
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("khSpT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0e41414e24bcf781$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lIePH = parcelRequire("lIePH");

var $4SflX = parcelRequire("4SflX");
parcelRequire("cuFEI");
var $iMoOg = parcelRequire("iMoOg");

var $iFYrC = parcelRequire("iFYrC");

var $5GBSS = parcelRequire("5GBSS");

var $irfuL = parcelRequire("irfuL");

var $8lLGC = parcelRequire("8lLGC");

var $4vPWW = parcelRequire("4vPWW");

var $iYRB0 = parcelRequire("iYRB0");
parcelRequire("df4Jn");
var $fsbKr = parcelRequire("fsbKr");

var $bDAY5 = parcelRequire("bDAY5");
parcelRequire("aE4WL");
var $cXr7b = parcelRequire("cXr7b");

var $5AKWJ = parcelRequire("5AKWJ");

var $l9J5E = parcelRequire("l9J5E");

var $abgpq = parcelRequire("abgpq");

var $9FyNo = parcelRequire("9FyNo");

var $4MsBj = parcelRequire("4MsBj");
parcelRequire("bKdiQ");
var $eh10R = parcelRequire("eh10R");

var $a4vO3 = parcelRequire("a4vO3");

var $gGKRb = parcelRequire("gGKRb");

var $5F8Fv = parcelRequire("5F8Fv");

var $4ZvZs = parcelRequire("4ZvZs");

var $68S28 = parcelRequire("68S28");

var $jK1pm = parcelRequire("jK1pm");

var $ligKL = parcelRequire("ligKL");

var $5BnlQ = parcelRequire("5BnlQ");

var $dLW5r = parcelRequire("dLW5r");
const $0e41414e24bcf781$var$PlanTimeline = ({ store: store, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const pageHeading = formatMessage((0, $5BnlQ.default).timeline);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "plan-timeline-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5F8Fv.PlanAppBase), {
        appKey: "spa-app.advanced-roadmaps-plan.timeline",
        store: store,
        withReduxStore: true,
        paddingRight: false,
        paddingLeft: false,
        planView: "timeline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l9J5E.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4SflX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZvZs.default), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLW5r.HeaderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ligKL.HeaderBar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLW5r.RoadmapContainer), null, (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4MsBj.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $68S28.PlanOnboarding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AKWJ.default), null))))));
};
// Rename this component to PlanTimeline when cleaning 'jet-plans-nav-refresh_f9025'
const $0e41414e24bcf781$var$PlanTimelineWithoutPageHeader = ({ store: store, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const pageHeading = formatMessage((0, $5BnlQ.default).timeline);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "plan-timeline-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5F8Fv.PlanAppBase), {
        appKey: "spa-app.advanced-roadmaps-plan.timeline",
        store: store,
        paddingRight: false,
        withReduxStore: true,
        planView: "timeline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l9J5E.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4SflX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZvZs.default), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0e41414e24bcf781$var$toolbarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eh10R.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0e41414e24bcf781$var$roadmapContainerStyles
    }, (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4MsBj.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $68S28.PlanOnboarding), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AKWJ.default), null))))));
};
var $0e41414e24bcf781$export$2e2bcd8739ae039 = (0, $a4vO3.provideComponents)({
    FieldSelect: $8lLGC.default,
    FieldPrioritySelect: $irfuL.default,
    FieldMultiSelectCell: $5GBSS.default,
    FieldDatePicker: $iFYrC.default,
    FieldUserAvatarCell: $4vPWW.default,
    CellSelectWithRollup: $gGKRb.CellSelectWithRollup,
    CellTextField: (0, $lIePH.default),
    AdvancedFieldsMenu: $iMoOg.default,
    FilterDependencyGraphFromRoadmap: $fsbKr.default,
    QuickFilter: $cXr7b.default,
    IssueSearchWarningClearFilter: $bDAY5.default,
    NowLine: $9FyNo.default,
    UserPicker: $iYRB0.default
})((0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jet-plans-nav-refresh_f9025'), $0e41414e24bcf781$var$PlanTimelineWithoutPageHeader, $0e41414e24bcf781$var$PlanTimeline));
const $0e41414e24bcf781$var$toolbarStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.200',
    paddingRight: 'space.300',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
});
const $0e41414e24bcf781$var$roadmapContainerStyles = (0, $1ZAYh.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderTopLeftRadius: "var(--ds-space-050, 4px)",
    position: 'relative',
    flex: 1,
    display: 'flex'
});

});
parcelRegister("lIePH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34701e3c7af4749$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AkTextField", () => (parcelRequire("cf2Y4")).default);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $cf2Y4 = parcelRequire("cf2Y4");

var $imY0u = parcelRequire("imY0u");
class $c34701e3c7af4749$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        if (this.inputEl && this.inputEl.type === 'number') {
            this.inputEl.addEventListener('input', this.onInputNative);
            this.inputEl.addEventListener('mousedown', this.onChildMouseDown);
            this.inputEl.setAttribute('step', this.props.step && this.props.step.toString() || 'any');
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) this.setState({
            value: nextProps.value,
            oldValue: nextProps.value
        });
    }
    componentWillUnmount() {
        if (this.inputEl && this.inputEl.type === 'number') {
            this.inputEl.removeEventListener('mousedown', this.onChildMouseDown);
            this.inputEl.removeEventListener('input', this.onInputNative);
        }
    }
    render() {
        const { isAlignRight: isAlignRight, isTransparentBackground: isTransparentBackground, isReadOnly: isReadOnly, onDone: onDone, errorMessage: errorMessage, ...props } = this.props;
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
            [$imY0u.isTransparentBackground]: isTransparentBackground,
            [$imY0u.isAlignRight]: isAlignRight,
            [$imY0u.error]: !this.state.valid,
            [$imY0u.isReadOnly]: isReadOnly
        });
        const { value: value } = this.state;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...props,
            isReadOnly: isReadOnly,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onFocus: this.onFocus,
            onKeyDown: this.onKeyDown,
            ref: (inputEl)=>{
                if (inputEl) this.inputEl = inputEl;
            },
            value: value === null || value === undefined ? '' : value
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            oldValue: this.props.value,
            value: this.props.value,
            valid: true
        };
        this.onChildMouseDown = ()=>{
            // workaround for JPOS-2334 Firefox: Using number spinner button doesn't show dorito
            // see more https://bugzilla.mozilla.org/show_bug.cgi?id=1012818
            this.inputEl.focus();
        };
        this.onBlur = (e)=>{
            const { oldValue: oldValue, value: value, valid: valid } = this.state;
            let newValue = value;
            if (valid) {
                if (this.props.type === 'number' && value !== undefined) newValue = `${Math.round(parseFloat(value) * 1000) / 1000}`;
                this.setState({
                    value: newValue,
                    oldValue: newValue,
                    valid: true
                });
            } else {
                this.setState({
                    value: oldValue,
                    valid: true
                });
                newValue = oldValue;
            }
            if (this.props.onDone) this.props.onDone(newValue);
            if (this.props.onBlur) this.props.onBlur(e);
        };
        this.onInputNative = (e)=>{
            const target = e.target;
            if (target instanceof HTMLInputElement) {
                const { value: value, validity: { valid: valid } } = target;
                this.setState({
                    value: value,
                    valid: valid
                });
            }
        };
        this.onKeyDown = (e)=>{
            const target = e.target;
            if (e.key === 'Escape') this.setState({
                value: this.props.value
            }, ()=>{
                if (target instanceof HTMLInputElement) target.blur();
            });
            if (e.key === 'Enter') {
                if (target instanceof HTMLInputElement) target.blur();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        };
        this.onFocus = (event)=>{
            if (this.props.isReadOnly) event.preventDefault();
            else if (this.props.onFocus) this.props.onFocus(event);
        };
        this.onChange = (e)=>{
            if (e.target instanceof HTMLInputElement) {
                this.setState({
                    value: e.target.value
                });
                if (this.props.onChange) this.props.onChange(e);
            }
        };
    }
}

});
parcelRegister("hjlb6", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ecaf8c9a10cf48c9$var$TextfieldComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
$ecaf8c9a10cf48c9$var$TextfieldComponent.displayName = 'Textfield';
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.memo)($ecaf8c9a10cf48c9$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("imY0u", function(module, exports) {

$parcel$export(module.exports, "error", () => $d5f8d4316c792b62$export$a3bc9b8ed74fc, (v) => $d5f8d4316c792b62$export$a3bc9b8ed74fc = v);
$parcel$export(module.exports, "isAlignRight", () => $d5f8d4316c792b62$export$314135682d277cb4, (v) => $d5f8d4316c792b62$export$314135682d277cb4 = v);
$parcel$export(module.exports, "isReadOnly", () => $d5f8d4316c792b62$export$2498094d90b6ac72, (v) => $d5f8d4316c792b62$export$2498094d90b6ac72 = v);
$parcel$export(module.exports, "isTransparentBackground", () => $d5f8d4316c792b62$export$2183c3f1b0e8f02a, (v) => $d5f8d4316c792b62$export$2183c3f1b0e8f02a = v);
var $d5f8d4316c792b62$export$a3bc9b8ed74fc;
var $d5f8d4316c792b62$export$314135682d277cb4;
var $d5f8d4316c792b62$export$2498094d90b6ac72;
var $d5f8d4316c792b62$export$2183c3f1b0e8f02a;
$d5f8d4316c792b62$export$a3bc9b8ed74fc = `Brmfbq_error`;
$d5f8d4316c792b62$export$314135682d277cb4 = `Brmfbq_isAlignRight`;
$d5f8d4316c792b62$export$2498094d90b6ac72 = `Brmfbq_isReadOnly`;
$d5f8d4316c792b62$export$2183c3f1b0e8f02a = `Brmfbq_isTransparentBackground`;

});


parcelRegister("4SflX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd3ecad65f1cec7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fmaO5 = parcelRequire("fmaO5");

var $4jBRy = parcelRequire("4jBRy");
var $dbd3ecad65f1cec7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fmaO5.default), {})((0, $4jBRy.default));

});
parcelRegister("fmaO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83e614e2be20fc5$export$2e2bcd8739ae039);

var $11mKX = parcelRequire("11mKX");
const $d83e614e2be20fc5$var$mapStateToProps = (state)=>({
        associatedIssueIds: (0, $11mKX.getAssociatedIssueIds)(state)
    });
var $d83e614e2be20fc5$export$2e2bcd8739ae039 = $d83e614e2be20fc5$var$mapStateToProps;

});
parcelRegister("11mKX", function(module, exports) {

$parcel$export(module.exports, "getAssociatedIssueIds", () => $015712b5e1b0d20d$export$6f62a10975052989);
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $iK4oF = parcelRequire("iK4oF");
const $015712b5e1b0d20d$export$6f62a10975052989 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues)
], (issues)=>issues.map((issue)=>issue.associatedIssueIds || []).flat());

});
parcelRegister("kwMvv", function(module, exports) {

$parcel$export(module.exports, "getAllSortedIssues", () => $3800638ecfe0acda$export$7c3a06b6c8e04cb6);
$parcel$export(module.exports, "getIsIssuesLoading", () => $3800638ecfe0acda$export$43a88fed19edd69);
$parcel$export(module.exports, "getIssuesByLevel", () => $3800638ecfe0acda$export$6c7f4547348bb8cc);
$parcel$export(module.exports, "getOriginalIssues", () => $3800638ecfe0acda$export$78e865af1b622bce);
$parcel$export(module.exports, "getAncestors", () => $3800638ecfe0acda$export$c6fd3ab3f44300d0);
$parcel$export(module.exports, "getDescendantIdsByParent", () => $3800638ecfe0acda$export$10cf9ac9d0b5c754);
$parcel$export(module.exports, "getIssueFilterMatcher", () => $3800638ecfe0acda$export$1f42b2c834376f59);
$parcel$export(module.exports, "getFilteredIssues", () => $3800638ecfe0acda$export$637f6f4447a6cb4);
$parcel$export(module.exports, "getIssueFilterMatcherWithFilterId", () => $3800638ecfe0acda$export$81a180583deb97be);
$parcel$export(module.exports, "getParentAndDescendant", () => $3800638ecfe0acda$export$eb2109d2e87ee1e2);
$parcel$export(module.exports, "getWholeHierarchyParentAndDescendant", () => $3800638ecfe0acda$export$22b9a03ec1eb8dd6);
$parcel$export(module.exports, "getFilteredIssuesWithHierarchy", () => $3800638ecfe0acda$export$82c01ac68f22904d);
$parcel$export(module.exports, "getFilteredIssuesWithHierarchyById", () => $3800638ecfe0acda$export$28e54faad0065b6f);
$parcel$export(module.exports, "getIssueChangesMetaData", () => $3800638ecfe0acda$export$fa48bdc11248955a);
$parcel$export(module.exports, "getIssueChangesData", () => $3800638ecfe0acda$export$c913ecfe262dc703);
$parcel$export(module.exports, "getChangedAttributes", () => $3800638ecfe0acda$export$3c13bed81ee9bbc8);
$parcel$export(module.exports, "getIssueChanges", () => $3800638ecfe0acda$export$a6de124506edd2c9);
$parcel$export(module.exports, "getIssueChangesWithChangedLinks", () => $3800638ecfe0acda$export$f951d26970afc90);
$parcel$export(module.exports, "getIssueAttributeChangeCounts", () => $3800638ecfe0acda$export$e46b31cf3437f90c);
$parcel$export(module.exports, "getCreatedIssueCount", () => $3800638ecfe0acda$export$43f0babde21e402);
$parcel$export(module.exports, "getIssueChangeCount", () => $3800638ecfe0acda$export$de1b72009d6b1dfc);
$parcel$export(module.exports, "getIssueChangesWithChangedLinksCount", () => $3800638ecfe0acda$export$eea625218b940c41);
$parcel$export(module.exports, "getInitialFilterValues", () => $3800638ecfe0acda$export$63f0253ea18e1b2b);
$parcel$export(module.exports, "getIssuesByVersionMap", () => $3800638ecfe0acda$export$615c37ad4901bd5c);
$parcel$export(module.exports, "getHistoryIssues", () => $3800638ecfe0acda$export$65ea2b70e1e8b23d);
$parcel$export(module.exports, "isLoadingHistory", () => $3800638ecfe0acda$export$bb6e9f1f80fa26a);
$parcel$export(module.exports, "isSavingIssue", () => $3800638ecfe0acda$export$570537f670c4986d);
$parcel$export(module.exports, "getSelected", () => $3800638ecfe0acda$export$f9f1f4119b3df74);
$parcel$export(module.exports, "getSelectedIssues", () => $3800638ecfe0acda$export$5e52d79ee962d3c1);
$parcel$export(module.exports, "getSelectedIssuesByProjectId", () => $3800638ecfe0acda$export$584afdbe1174e39e);
$parcel$export(module.exports, "getCPRsForSelectedIssues", () => $3800638ecfe0acda$export$adefbe0a9c7ccb6a);
$parcel$export(module.exports, "toApiIssue", () => $3800638ecfe0acda$export$d4820931b5475426);
$parcel$export(module.exports, "getAllIssues", () => (parcelRequire("cwP4d")).getAllIssues);
$parcel$export(module.exports, "getIssues", () => (parcelRequire("cwP4d")).getIssues);
$parcel$export(module.exports, "getIssueMapById", () => (parcelRequire("cwP4d")).getIssueMapById);
$parcel$export(module.exports, "createIssueMapByIdPure", () => (parcelRequire("cwP4d")).createIssueMapByIdPure);
$parcel$export(module.exports, "getScenarioRemovedIssueMapById", () => (parcelRequire("cwP4d")).getScenarioRemovedIssueMapById);
$parcel$export(module.exports, "getRollupMap", () => (parcelRequire("aK3ri")).getRollupMap);
$parcel$export(module.exports, "getChildrenByParent", () => (parcelRequire("aK3ri")).getChildrenByParent);
$parcel$export(module.exports, "getDescendants", () => (parcelRequire("aK3ri")).getDescendants);
$parcel$export(module.exports, "getChildrenIdsByParent", () => (parcelRequire("aK3ri")).getChildrenIdsByParent);
$parcel$export(module.exports, "getChildrenByParentPure", () => (parcelRequire("aK3ri")).getChildrenByParentPure);

var $illlw = parcelRequire("illlw");

var $hTVz0 = parcelRequire("hTVz0");

var $itLT6 = parcelRequire("itLT6");
var $1dZWS = parcelRequire("1dZWS");
var $9FeHi = parcelRequire("9FeHi");
var $dSK2s = parcelRequire("dSK2s");
var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $eirae = parcelRequire("eirae");
var $jPCDz = parcelRequire("jPCDz");
var $eN1iE = parcelRequire("eN1iE");
var $cQwal = parcelRequire("cQwal");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $kpKEz = parcelRequire("kpKEz");
var $afKQR = parcelRequire("afKQR");
var $3G9Az = parcelRequire("3G9Az");
var $kndO6 = parcelRequire("kndO6");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");

var $akhOi = parcelRequire("akhOi");

var $kKj1m = parcelRequire("kKj1m");

var $6WF4e = parcelRequire("6WF4e");

var $fbHoQ = parcelRequire("fbHoQ");

var $fZW8G = parcelRequire("fZW8G");

var $dEoWh = parcelRequire("dEoWh");

var $75KhQ = parcelRequire("75KhQ");

var $cwP4d = parcelRequire("cwP4d");

var $aK3ri = parcelRequire("aK3ri");

var $7s3LJ = parcelRequire("7s3LJ");

var $wcCGG = parcelRequire("wcCGG");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $3800638ecfe0acda$export$eb0a0f4026d4f504 = (issues, sort)=>sort(issues);
const $3800638ecfe0acda$export$7c3a06b6c8e04cb6 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues),
    (0, $7s3LJ.getSort)
], $3800638ecfe0acda$export$eb0a0f4026d4f504);
const $3800638ecfe0acda$export$43a88fed19edd69 = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isLoading;
const $3800638ecfe0acda$export$6c7f4547348bb8cc = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    (state, targetLevel)=>targetLevel
], (issues, targetLevel)=>issues.filter(({ level: level })=>level === targetLevel));
const $3800638ecfe0acda$export$78e865af1b622bce = (state)=>state.domain.originalIssues;
const $3800638ecfe0acda$export$c6fd3ab3f44300d0 = (issue, issueMap, maxAncestorLevel)=>{
    const ancestorsIds = [];
    const ancestors = [];
    let currentIssue = issue;
    while(currentIssue && currentIssue.level < maxAncestorLevel && currentIssue.parent){
        currentIssue = issueMap[currentIssue.parent];
        // It is entirely possible for an issue to have a parent, but that parent issue to NOT be in the plan
        if (!currentIssue) break;
        if (ancestorsIds.includes(currentIssue.id)) break;
        ancestorsIds.push(currentIssue.id);
        ancestors.push(currentIssue);
    }
    return ancestors;
};
const $3800638ecfe0acda$export$10cf9ac9d0b5c754 = (0, $iK4oF.createSelector)([
    (0, $aK3ri.getDescendantsByParent)
], (0, $7CnHa.mapGroupsToIds));
const $3800638ecfe0acda$export$3f223538464739b6 = (filters, optimizedMode, customFields)=>(issue, options)=>{
        /**
		 * When the feature flag is disabled, we exclude the "new" hierarchy filter since we do not
		 * want issues to be filtered by it.
		 */ if (!(0, $1ybV0.ff)('use-jira-hierarchy-levels-in-plans_knftc')) return (0, $fbHoQ.matchFilter)(filters, optimizedMode, customFields, issue, {
            ...options,
            exclude: options?.exclude?.concat((0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)) || [
                (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)
            ]
        });
        /**
		 * When the feature flag is enabled, we exclude the "old" hierarchy filter since we do not
		 * want issues to be filtered by it.
		 */ return (0, $fbHoQ.matchFilter)(filters, optimizedMode, customFields, issue, {
            ...options,
            exclude: options?.exclude?.concat((0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)) || [
                (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)
            ]
        });
    };
const $3800638ecfe0acda$export$1f42b2c834376f59 = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $akhOi.isOptimizedMode),
    (0, $kKj1m.getCustomFields)
], $3800638ecfe0acda$export$3f223538464739b6);
const $3800638ecfe0acda$export$19412d4e3ba084c2 = (issues, issueFilterMatcher)=>$fpul1.default(issueFilterMatcher)(issues);
const $3800638ecfe0acda$export$637f6f4447a6cb4 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    $3800638ecfe0acda$export$1f42b2c834376f59
], $3800638ecfe0acda$export$19412d4e3ba084c2);
const $3800638ecfe0acda$export$81a180583deb97be = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $akhOi.isOptimizedMode),
    (0, $kKj1m.getCustomFields)
], (filters, optimizedMode, customFields)=>(issue)=>(0, $fbHoQ.getUnmatchedFiltersList)(filters, optimizedMode, customFields, issue));
const $3800638ecfe0acda$export$5de7d1d2af779977 = (filteredIssues, { start: start, end: end }, issueMap, descendantsMap)=>{
    const resultMap = {};
    for (const filteredIssue of filteredIssues)resultMap[filteredIssue.id] = {
        ancestors: $3800638ecfe0acda$export$c6fd3ab3f44300d0(filteredIssue, issueMap, start),
        descendants: (0, $aK3ri.getDescendants)(filteredIssue, issueMap, descendantsMap, end)
    };
    return resultMap;
};
const $3800638ecfe0acda$export$eb2109d2e87ee1e2 = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$637f6f4447a6cb4,
    (0, $fbHoQ.getFilters),
    (0, $cwP4d.getIssueMapById),
    (0, $aK3ri.getChildrenIdsByParent)
], (filteredIssues, filters, issueMap, descendantsMap)=>$3800638ecfe0acda$export$5de7d1d2af779977(filteredIssues, {
        start: filters[0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc].value.start,
        end: filters[0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc].value.end
    }, issueMap, descendantsMap));
const $3800638ecfe0acda$export$22b9a03ec1eb8dd6 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues),
    (0, $fZW8G.getHierarchyRange),
    (0, $cwP4d.getIssueMapById),
    (0, $aK3ri.getChildrenIdsByParent)
], (issues, { max: start, min: end }, issueMap, descendantsMap)=>$3800638ecfe0acda$export$5de7d1d2af779977(issues, {
        start: start,
        end: end
    }, issueMap, descendantsMap));
const $3800638ecfe0acda$export$a679b46e98507a98 = (flatIssues, ancestorsAndDescendants, showFullHierarchy)=>(0, $6WF4e.applyOption)(flatIssues, ancestorsAndDescendants, showFullHierarchy);
const $3800638ecfe0acda$export$82c01ac68f22904d = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$637f6f4447a6cb4,
    $3800638ecfe0acda$export$eb2109d2e87ee1e2,
    (0, $6WF4e.getShowFullHierarchy)
], $3800638ecfe0acda$export$a679b46e98507a98);
const $3800638ecfe0acda$export$28e54faad0065b6f = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$82c01ac68f22904d
], (filteredIssuesWithHierarchy)=>$eN1iE.default($f7Op5.default('id'), filteredIssuesWithHierarchy));
const $3800638ecfe0acda$export$fa48bdc11248955a = (state)=>$kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData',
        'issues'
    ], state) || {};
const $3800638ecfe0acda$export$c913ecfe262dc703 = (state)=>{
    const issues = (0, $cwP4d.getIssueMapById)(state);
    const changes = $kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'issues'
    ], state) || [];
    return changes.map((change)=>{
        const issue = issues[change.id];
        if (!(0, $7CnHa.isDefined)(issue) || !(0, $7CnHa.isDefined)(change.values)) return change;
        const isSameParent = $dSK2s.default('parent', issue, change.values);
        return isSameParent ? change : $itLT6.default([
            'values',
            'parent'
        ], issue.parent, change);
    });
};
const $3800638ecfe0acda$export$2cdbb6213e588813 = (issue, attributeName)=>{
    if (!$jPCDz.default(attributeName)(issue.originals)) return issue;
    // originalItems and valueItems will both either be a string[] or a number[]
    // TS has a hard time determining that they would both be the same type and complains when you try and difference them
    // Cast to any to avoid this
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const originalItems = issue.originals[attributeName] || [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const valueItems = issue.values[attributeName] || [];
    const addedItems = $9FeHi.default(valueItems, originalItems);
    const removedItems = $9FeHi.default(originalItems, valueItems);
    const haveAddedItems = addedItems.length > 0;
    const haveRemovedItems = removedItems.length > 0;
    if (!haveAddedItems && !haveRemovedItems) return issue;
    if (haveAddedItems || haveRemovedItems) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        delete issue.values[attributeName];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
        delete issue.originals[attributeName];
    }
    const capitalize = $afKQR.default(/^./, $kndO6.default);
    const addedAttributeName = `added${capitalize(attributeName)}`;
    const removedAttributeName = `removed${capitalize(attributeName)}`;
    return {
        ...issue,
        originals: {
            ...issue.originals,
            ...haveAddedItems ? {
                [addedAttributeName]: []
            } : {},
            ...haveRemovedItems ? {
                [removedAttributeName]: []
            } : {}
        },
        values: {
            ...issue.values,
            ...haveAddedItems ? {
                [addedAttributeName]: addedItems
            } : {},
            ...haveRemovedItems ? {
                [removedAttributeName]: removedItems
            } : {}
        }
    };
};
const $3800638ecfe0acda$export$4998ea759a3625dd = (issue, customFields, scenarioType)=>{
    const multiSelectFields = (0, $kKj1m.getCustomFieldsByKey)((0, $5rYNM.CustomFieldTypes).MultiSelect, customFields);
    multiSelectFields.forEach(({ id: multiSelectField })=>{
        // for the newly created issue, the originals would be undefined,
        // but we still need to display the multi select custom field value, refer to https://hello.jira.atlassian.cloud/browse/JPO-27813
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.fix-multi-select-custom-field-not-display-in-review-change-dialo_rhcuv') && scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED && $jPCDz.default(multiSelectField.toString())(issue.values.customFields || {}) || issue.originals.customFields && $jPCDz.default(multiSelectField.toString())(issue.originals.customFields || {})) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const originalItems = issue.originals.customFields && issue.originals.customFields[multiSelectField] || [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const valueItems = issue.values.customFields && issue.values.customFields[multiSelectField] || []; // Multi select field values are always string arrays
            const addedItems = $9FeHi.default(valueItems, originalItems);
            const removedItems = $9FeHi.default(originalItems, valueItems);
            const haveAddedItems = addedItems.length > 0;
            const haveRemovedItems = removedItems.length > 0;
            if (haveAddedItems) {
                // eslint-disable-next-line no-param-reassign
                issue.values[`customFieldValueAdded-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: addedItems
                };
                // eslint-disable-next-line no-param-reassign
                issue.originals[`customFieldValueAdded-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: []
                };
            }
            if (haveRemovedItems) {
                // eslint-disable-next-line no-param-reassign
                issue.values[`customFieldValueRemoved-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: removedItems
                };
                // eslint-disable-next-line no-param-reassign
                issue.originals[`customFieldValueRemoved-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: []
                };
            }
            // the cases where subsequent scenario changes haved cancelled each other out.
            // still needs to be displayed so the user can clean up scenario data.
            if (!haveRemovedItems && !haveAddedItems) {
                // eslint-disable-next-line no-param-reassign
                issue.values[`customField-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: valueItems?.length > 0 ? valueItems : undefined
                };
                // eslint-disable-next-line no-param-reassign
                issue.originals[`customField-${multiSelectField}`] = {
                    id: multiSelectField,
                    typeKey: (0, $5rYNM.CustomFieldTypes).MultiSelect,
                    value: originalItems?.length > 0 ? originalItems : undefined
                };
            }
        }
    });
    const filterMultiSelectCustomFields = (customFieldsValues)=>Object.entries(customFieldsValues).filter(([fieldId])=>{
            const customField = (0, $kKj1m.getCustomFieldById)(Number(fieldId), customFields)[0];
            return !customField || customField && customField.type.key !== (0, $5rYNM.CustomFieldTypes).MultiSelect;
        });
    const getCustomFieldTypeKey = (fieldId)=>{
        const customField = (0, $kKj1m.getCustomFieldById)(Number(fieldId), customFields)[0];
        return customField && customField.type ? customField.type.key : undefined;
    };
    if (issue.values.customFields) {
        filterMultiSelectCustomFields(issue.values.customFields).forEach(([fieldId, value])=>{
            // eslint-disable-next-line no-param-reassign
            issue.values[`customField-${fieldId}`] = {
                id: fieldId,
                value: value,
                typeKey: getCustomFieldTypeKey(fieldId)
            };
        });
        // eslint-disable-next-line no-param-reassign
        delete issue.values.customFields;
    }
    if (issue.originals.customFields) {
        filterMultiSelectCustomFields(issue.originals.customFields).forEach(([fieldId, value])=>{
            // eslint-disable-next-line no-param-reassign
            issue.originals[`customField-${fieldId}`] = {
                id: fieldId,
                value: value,
                typeKey: getCustomFieldTypeKey(fieldId)
            };
        });
        // eslint-disable-next-line no-param-reassign
        delete issue.originals.customFields;
    }
    return issue;
};
const $3800638ecfe0acda$export$3c13bed81ee9bbc8 = ({ values: values, originals: originals }, scenarioType)=>{
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
        const { summary: summary, lexoRank: lexoRank, project: project, type: type, color: color, ...remainingValues } = values;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.keys(remainingValues);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(originals);
};
const $3800638ecfe0acda$export$7208ce03e8a0ca7d = (valueObject, plan)=>{
    const { planningUnit: planningUnit } = plan;
    const attributes = Object.keys(valueObject);
    // Remove completedSprints because they should not change.
    const { completedSprints: completedSprints, ...values } = valueObject;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const valuesToRemove = [];
    if (attributes.includes('storyPoints') && (planningUnit === (0, $5rYNM.PlanningUnits).hours || planningUnit === (0, $5rYNM.PlanningUnits).days)) valuesToRemove.push('storyPoints');
    if (attributes.includes('timeEstimate') && planningUnit === (0, $5rYNM.PlanningUnits).storyPoints) valuesToRemove.push('timeEstimate');
    /**
	 * Themes are not supported in 3.0 but however users can make theme
	 * changes in 2.0 and switch to 3.0 interface so we ignore those changes from showing up
	 * in the review changes dialog.
	 */ if (attributes.includes('theme')) valuesToRemove.push('theme');
    /**
	 * In Portfolio 2.0, distribution values are aggregated as story points and when the user
	 * tries to commit, only the story point value is shown as the change.
	 * Distribution is not supported in 3.0 but however users can make distribution
	 * changes in 2.0 and switch to 3.0 interface so we ignore those changes from showing up
	 * in the review changes dialog.
	 */ if (attributes.includes('distribution')) valuesToRemove.push('distribution');
    return $cQwal.default(valuesToRemove, values);
};
const $3800638ecfe0acda$export$8372f47f7c4a2a9 = (changedAttributes, scenarioType)=>{
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || changedAttributes.length !== 1) return;
    const attributeName = changedAttributes[0];
    return attributeName;
};
const $3800638ecfe0acda$export$6038614360f9e2c3 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $5rYNM.ENTITY).ISSUE];
const $3800638ecfe0acda$export$153214b5bd108ed3 = ({ domain: { updateJira: { changesWarnings: changesWarnings } } })=>changesWarnings[(0, $5rYNM.ENTITY).ISSUE];
const $3800638ecfe0acda$var$getIssueChangesWithLinks = (planInfo, issue, metaData, warnings = [], issueLinks = [], issueLinksMetaData, customFields)=>{
    const scenarioType = metaData.scenarioType;
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, no-param-reassign
    issue.values = $3800638ecfe0acda$export$7208ce03e8a0ca7d(issue.values, planInfo);
    else // eslint-disable-next-line no-param-reassign
    issue.originals = $3800638ecfe0acda$export$7208ce03e8a0ca7d(issue.originals, planInfo);
    for (const link of issueLinks){
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { itemKey: itemKey, scenarioType: scenarioType } = link;
        const linkMeta = issueLinksMetaData[itemKey];
        if (linkMeta.lastChangeTimestamp > metaData.lastChangeTimestamp) {
            // eslint-disable-next-line no-param-reassign
            metaData.lastChangeTimestamp = linkMeta.lastChangeTimestamp;
            // eslint-disable-next-line no-param-reassign
            metaData.lastChangeUser = linkMeta.lastChangeUser;
        }
        const attributeName = `issueLink-${itemKey}`;
        switch(scenarioType){
            case (0, $5rYNM.SCENARIO_TYPE).ADDED:
                // eslint-disable-next-line no-param-reassign
                issue.values[attributeName] = link;
                // eslint-disable-next-line no-param-reassign
                issue.originals[attributeName] = null;
                break;
            case (0, $5rYNM.SCENARIO_TYPE).DELETED:
                // eslint-disable-next-line no-param-reassign
                issue.values[attributeName] = null;
                // eslint-disable-next-line no-param-reassign
                issue.originals[attributeName] = link;
                break;
            default:
                throw new Error(`Unexpected issue link scenarioType: ${scenarioType}`);
        }
    }
    const issueWithComponentsChange = $3800638ecfe0acda$export$2cdbb6213e588813(issue, 'components');
    const issueWithLabelsChange = $3800638ecfe0acda$export$2cdbb6213e588813(issueWithComponentsChange, 'labels');
    const issueWithCustomFieldChanges = $3800638ecfe0acda$export$4998ea759a3625dd(issueWithLabelsChange, customFields, scenarioType);
    const changedAttributes = $3800638ecfe0acda$export$3c13bed81ee9bbc8(issueWithCustomFieldChanges, scenarioType);
    return {
        id: issueWithCustomFieldChanges.id,
        category: (0, $5rYNM.ENTITY).ISSUE,
        metaData: metaData,
        changeCount: changedAttributes.length,
        warnings: warnings,
        attributeName: $3800638ecfe0acda$export$8372f47f7c4a2a9(changedAttributes, scenarioType),
        details: issueWithCustomFieldChanges
    };
};
const $3800638ecfe0acda$export$577045878cf2f430 = (planInfo, issues = [], entityMetaData, warnings, issueLinks, issueLinksMetaData, changesWarnings, customFields)=>{
    const issueChangeDataByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), issues);
    // Issue changes generated by this function incorporate issue links changes
    // represented as issue values.
    // Injecting them brings some complications:
    // 1. Changes handling architecture doesn't support spreading of array values as to multiple changes rows (see JPOS-2583)
    // 2. metaData should be calculated based on both issues and issueLinks metaData
    // 3. Issue link changes should be injected into existing issue changes when they exists,
    // otherwise new fake issue changes should be produced.
    const changes = (0, $7CnHa.filterMap)((id)=>(0, $7CnHa.isDefined)(issueChangeDataByIdMap[id]), (id)=>{
        const issue = issueChangeDataByIdMap[id];
        const metaData = entityMetaData[id];
        return $3800638ecfe0acda$var$getIssueChangesWithLinks(planInfo, {
            ...issue
        }, {
            ...metaData
        }, [
            ...changesWarnings[id] || [],
            ...warnings[id] || []
        ], issueLinks[id], issueLinksMetaData, customFields);
    }, Object.keys(entityMetaData));
    const issueLinkOnlyChanges = (0, $7CnHa.filterMap)((id)=>!(0, $7CnHa.isDefined)(entityMetaData[id]) && (0, $7CnHa.isDefined)(issueChangeDataByIdMap[id]), (id)=>{
        const issue = issueChangeDataByIdMap[id];
        const metaData = {
            lastChangeTimestamp: 0,
            lastChangeUser: 'unassigned',
            scenarioType: (0, $5rYNM.SCENARIO_TYPE).UPDATED
        };
        return $3800638ecfe0acda$var$getIssueChangesWithLinks(planInfo, {
            ...issue
        }, metaData, [
            ...changesWarnings[id] || [],
            ...warnings[id] || []
        ], issueLinks[id], issueLinksMetaData, customFields);
    }, Object.keys(issueLinks));
    return changes.concat(issueLinkOnlyChanges).filter(({ metaData: { scenarioType: scenarioType }, details: { originals: originals } })=>scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED && Object.keys(originals).length > 0 || scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED);
};
const $3800638ecfe0acda$export$a6de124506edd2c9 = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getPlan),
    $3800638ecfe0acda$export$c913ecfe262dc703,
    $3800638ecfe0acda$export$fa48bdc11248955a,
    $3800638ecfe0acda$export$6038614360f9e2c3,
    (0, $dEoWh.getIssueLinkChangesData),
    (0, $dEoWh.getIssueLinkChangesMetaData),
    $3800638ecfe0acda$export$153214b5bd108ed3,
    (0, $kKj1m.getCustomFields)
], $3800638ecfe0acda$export$577045878cf2f430);
const $3800638ecfe0acda$export$ad6b984a9b918985 = (issueChanges)=>issueChanges.filter((change)=>{
        const changedAttributes = Object.keys(change.details.originals);
        return changedAttributes.some((attribute)=>attribute.match(/^issueLink-/));
    });
const $3800638ecfe0acda$export$f951d26970afc90 = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$a6de124506edd2c9
], $3800638ecfe0acda$export$ad6b984a9b918985);
const $3800638ecfe0acda$export$f853033d86d5092a = (issueChanges)=>{
    const customFieldChangeKey = /^customField-\d+$/;
    const simplifyAttributeList = (attributes)=>{
        const multiValueFields = [
            [
                'labels',
                [
                    'addedLabels',
                    'removedLabels'
                ]
            ],
            [
                'components',
                [
                    'addedComponents',
                    'removedComponents'
                ]
            ]
        ];
        let simplifiedAttributes = attributes.map((attribute)=>attribute.match(customFieldChangeKey) ? 'customField' : attribute);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        multiValueFields.forEach(([key, fields])=>{
            if (fields.some((field)=>simplifiedAttributes.includes(field))) {
                simplifiedAttributes = simplifiedAttributes.filter((attribute)=>!fields.includes(attribute));
                simplifiedAttributes.push(key);
            }
        });
        return simplifiedAttributes;
    };
    return issueChanges.filter((issue)=>issue.metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED).map((issue)=>$3800638ecfe0acda$export$3c13bed81ee9bbc8(issue.details, issue.metaData.scenarioType)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((attributeCounts, changedAttributes)=>{
        const simplifiedChangedAttributes = simplifyAttributeList(changedAttributes);
        simplifiedChangedAttributes.forEach((attribute)=>{
            // eslint-disable-next-line no-param-reassign
            attributeCounts[attribute] = (attributeCounts[attribute] || 0) + 1;
        });
        return attributeCounts;
    }, {});
};
const $3800638ecfe0acda$export$e46b31cf3437f90c = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$a6de124506edd2c9
], $3800638ecfe0acda$export$f853033d86d5092a);
const $3800638ecfe0acda$export$3953dcb78b9e2829 = (issueChanges)=>issueChanges.filter((issue)=>issue.metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED).length;
const $3800638ecfe0acda$export$43f0babde21e402 = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$a6de124506edd2c9
], $3800638ecfe0acda$export$3953dcb78b9e2829);
function $3800638ecfe0acda$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks) {
    const changedLinkIssues = new Set();
    // There could be scenario changes on both internal and external links.
    // Checking both incoming and outgoing links would pickup all changes.
    const linksData = [
        [
            incomingIssueLinks,
            originalIncomingIssueLinks
        ],
        [
            outgoingIssueLinks,
            originalOutgoingIssueLinks
        ]
    ];
    for (const [issueLinks, originalIssueLinks] of linksData){
        const issueLinkIds = new Set(Object.keys(issueLinks).concat(Object.keys(originalIssueLinks)));
        for (const id of issueLinkIds){
            const changedLinks = (0, (/*@__PURE__*/$parcel$interopDefault($hTVz0)))(issueLinks[id] || [], originalIssueLinks[id] || [], (link, originalLink)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(link, 'itemKey') === (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(originalLink, 'itemKey'));
            if (changedLinks.length > 0) changedLinkIssues.add(id);
        }
    }
    return changedLinkIssues;
}
const $3800638ecfe0acda$export$7a4cbbca987bfc8 = (planInfo, originalIssues, incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks)=>{
    const changedIssues = new Set(Object.keys(originalIssues));
    for (const id of [
        ...changedIssues
    ])// keep excluded issues
    if (Object.keys(originalIssues[id]).length >= 1) {
        const processedOriginalIssue = $3800638ecfe0acda$export$7208ce03e8a0ca7d(originalIssues[id], planInfo);
        if (id == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'getIssueChangeCountPure id is undefined');
        if (!id?.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX)) && Object.keys(processedOriginalIssue).length < 1) changedIssues.delete(id);
    }
    // Add IDs for issues with changed links
    const changedLinkIssues = $3800638ecfe0acda$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks);
    changedLinkIssues.forEach(changedIssues.add, changedIssues);
    return changedIssues.size;
};
const $3800638ecfe0acda$export$de1b72009d6b1dfc = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getPlan),
    $3800638ecfe0acda$export$78e865af1b622bce,
    (0, $dEoWh.getIncomingLinks),
    (0, $dEoWh.getIncomingLinkOriginals),
    (0, $dEoWh.getOutgoingLinks),
    (0, $dEoWh.getOutgoingLinkOriginals)
], $3800638ecfe0acda$export$7a4cbbca987bfc8);
const $3800638ecfe0acda$export$861bb780dd70ec3c = (incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks)=>$3800638ecfe0acda$var$getIdsOfIssuesWithChangedLinks(incomingIssueLinks, originalIncomingIssueLinks, outgoingIssueLinks, originalOutgoingIssueLinks).size;
const $3800638ecfe0acda$export$eea625218b940c41 = (0, $iK4oF.createSelector)([
    (0, $dEoWh.getIncomingLinks),
    (0, $dEoWh.getIncomingLinkOriginals),
    (0, $dEoWh.getOutgoingLinks),
    (0, $dEoWh.getOutgoingLinkOriginals)
], $3800638ecfe0acda$export$861bb780dd70ec3c);
const $3800638ecfe0acda$export$376ed4e7d3bbaa04 = (issues)=>{
    const issueCountByLevel = $1dZWS.default((issue)=>issue.level.toString(), issues);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const startLevel = Object.keys(issueCountByLevel).reduce((startLevel, level)=>{
        const currentLevel = parseFloat(level);
        if (currentLevel > startLevel && issueCountByLevel[level] > 1) return currentLevel;
        return startLevel;
    }, (0, $8YqJS.EPIC_LEVEL));
    return {
        start: startLevel,
        end: (0, $8YqJS.SUB_TASK_LEVEL)
    };
};
const $3800638ecfe0acda$export$63f0253ea18e1b2b = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues)
], $3800638ecfe0acda$export$376ed4e7d3bbaa04);
const $3800638ecfe0acda$export$e36f9fa7514e08e1 = (versions, issues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issuesByVersionMap = {};
    // This is suboptimal but necessary to preserve semantics of the old
    // algorithm, as consumers rely on the fact that for any valid version id
    // they will get at least an empty array but not null. Now imagine that
    // there is a version that is not assigned to any issue. Omitting this loop
    // will not create an entry with empty array for its id, unlike an old
    // selector reducing over versions.
    for (const { id: id } of versions)issuesByVersionMap[id] = [];
    for (const issue of issues)for (const versionId of issue.fixVersions || []){
        if (typeof issuesByVersionMap[versionId] === 'undefined') issuesByVersionMap[versionId] = [];
        issuesByVersionMap[versionId].push(issue);
    }
    return issuesByVersionMap;
};
const $3800638ecfe0acda$export$615c37ad4901bd5c = (0, $iK4oF.createSelector)([
    (0, $wcCGG.getVersions),
    (0, $cwP4d.getIssues)
], $3800638ecfe0acda$export$e36f9fa7514e08e1);
const $3800638ecfe0acda$export$65ea2b70e1e8b23d = (state)=>state.domain.historyIssues;
const $3800638ecfe0acda$export$bb6e9f1f80fa26a = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isLoadingHistory;
const $3800638ecfe0acda$export$570537f670c4986d = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.isSavingIssue;
const $3800638ecfe0acda$export$f9f1f4119b3df74 = (state)=>new Set(state.ui.Main.Tabs.Roadmap.Scope.Issues.selected);
const $3800638ecfe0acda$export$ddca736c9a2b0f6d = (issuesById, selectedIds)=>Array.from(selectedIds).map((id)=>issuesById[id])// Remove undefined issues
    .filter((0, $7CnHa.isDefined));
const $3800638ecfe0acda$export$5e52d79ee962d3c1 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssueMapById),
    $3800638ecfe0acda$export$f9f1f4119b3df74
], $3800638ecfe0acda$export$ddca736c9a2b0f6d);
const $3800638ecfe0acda$export$263f4881943c16ad = (selectedIssues)=>$eirae.default(({ project: project })=>$3G9Az.default(project), selectedIssues);
const $3800638ecfe0acda$export$584afdbe1174e39e = (0, $iK4oF.createSelector)([
    $3800638ecfe0acda$export$5e52d79ee962d3c1
], $3800638ecfe0acda$export$263f4881943c16ad);
const $3800638ecfe0acda$export$5cb8a36a11d27820 = (projectsByCPRsMap, selectedIssuesByProject)=>{
    const selectedProjectIds = Object.keys(selectedIssuesByProject);
    return $fpul1.default((cprId)=>selectedProjectIds.every((issueProjectId)=>projectsByCPRsMap[cprId].includes(Number(issueProjectId))), Object.keys(projectsByCPRsMap));
};
const $3800638ecfe0acda$export$adefbe0a9c7ccb6a = (0, $iK4oF.createSelector)([
    (0, $wcCGG.getProjectIdsByCrossProjectVersionsMap),
    $3800638ecfe0acda$export$584afdbe1174e39e
], $3800638ecfe0acda$export$5cb8a36a11d27820);
const $3800638ecfe0acda$export$d4820931b5475426 = (issue, originals, scenarioType = (0, $5rYNM.SCENARIO_TYPE).UPDATED)=>{
    const { id: id, issueKey: issueKey, assignments: assignments = [], annotations: annotations = [], issueSources: issueSources = [], level: level /** Level can never be scenario changed and it's not present in API issue. It is calculated from 'type' */ , inferred: inferred /** Inferred is not present in API issue as it's metadata which maps field name to inference source. */ , ...rest } = issue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let values = $kpKEz.default($5OdRK.default(undefined))(rest);
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        values = $kpKEz.default($5OdRK.default(null))(values);
        // Exclude baselineStart and baselineEnd in newly added issues as they are the inferred dates value, rather than dates set by user
        delete values.baselineStart;
        delete values.baselineEnd;
        // 'issueKey' is not defined in the newly created issue.
        return {
            id: id,
            assignments: assignments,
            annotations: annotations,
            issueSources: issueSources,
            values: values,
            originals: originals
        };
    }
    return {
        id: id,
        issueKey: issueKey,
        assignments: assignments,
        annotations: annotations,
        issueSources: issueSources,
        values: values,
        originals: originals
    };
};

});
parcelRegister("hTVz0", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9eFtX = parcelRequire("9eFtX");

var $a5Cec = parcelRequire("a5Cec");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */ var $d08439ab21e39200$var$xorWith = $9eFtX(function(arrays) {
    var comparator = $iTvqy(arrays);
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return $a5Cec($904yO(arrays, $cRpul), undefined, comparator);
});
module.exports = $d08439ab21e39200$var$xorWith;

});
parcelRegister("a5Cec", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $42tFs = parcelRequire("42tFs");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $7588064e955aa173$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $42tFs(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $fa0Ox(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $42tFs($hKE3p(result, 1), iteratee, comparator);
}
module.exports = $7588064e955aa173$var$baseXor;

});


parcelRegister("itLT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74014f011f9a289$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $kWDdm = parcelRequire("kWDdm");

var $dPJMs = parcelRequire("dPJMs");

var $5CL3x = parcelRequire("5CL3x");

var $aeXAa = parcelRequire("aeXAa");

var $kDrtX = parcelRequire("kDrtX");
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $d74014f011f9a289$var$assocPath = /*#__PURE__*/ (0, $4g10W.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $kDrtX.default)(obj) && (0, $kWDdm.default)(idx, obj) ? obj[idx] : (0, $5CL3x.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, $5CL3x.default)(idx) && (0, $dPJMs.default)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, $aeXAa.default)(idx, val, obj);
});
var $d74014f011f9a289$export$2e2bcd8739ae039 = $d74014f011f9a289$var$assocPath;

});
parcelRegister("4g10W", function(module, exports) {

$parcel$export(module.exports, "default", () => $3199717412d5c659$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $ggdJA = parcelRequire("ggdJA");

var $1lcvr = parcelRequire("1lcvr");
function $3199717412d5c659$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $1lcvr.default)(a) ? f3 : (0, $ggdJA.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $1lcvr.default)(a) && (0, $1lcvr.default)(b) ? f3 : (0, $1lcvr.default)(a) ? (0, $ggdJA.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $1lcvr.default)(b) ? (0, $ggdJA.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $eSWTK.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $1lcvr.default)(a) && (0, $1lcvr.default)(b) && (0, $1lcvr.default)(c) ? f3 : (0, $1lcvr.default)(a) && (0, $1lcvr.default)(b) ? (0, $ggdJA.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $1lcvr.default)(a) && (0, $1lcvr.default)(c) ? (0, $ggdJA.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $1lcvr.default)(b) && (0, $1lcvr.default)(c) ? (0, $ggdJA.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $1lcvr.default)(a) ? (0, $eSWTK.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $1lcvr.default)(b) ? (0, $eSWTK.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $1lcvr.default)(c) ? (0, $eSWTK.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});
parcelRegister("eSWTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad63cbc7fd519eef$export$2e2bcd8739ae039);

var $1lcvr = parcelRequire("1lcvr");
function $ad63cbc7fd519eef$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $1lcvr.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("1lcvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa1741392102609$export$2e2bcd8739ae039);
function $0fa1741392102609$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

});


parcelRegister("ggdJA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd68cb50d52ee6e4$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $1lcvr = parcelRequire("1lcvr");
function $bd68cb50d52ee6e4$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $1lcvr.default)(a) ? f2 : (0, $eSWTK.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $1lcvr.default)(a) && (0, $1lcvr.default)(b) ? f2 : (0, $1lcvr.default)(a) ? (0, $eSWTK.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $1lcvr.default)(b) ? (0, $eSWTK.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});


parcelRegister("kWDdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f7a49729e11bce$export$2e2bcd8739ae039);
function $f3f7a49729e11bce$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("dPJMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1238cdad7882fcf$export$2e2bcd8739ae039);
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $a1238cdad7882fcf$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

});

parcelRegister("5CL3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $418500b7dae643c4$export$2e2bcd8739ae039);
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $418500b7dae643c4$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("aeXAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $77496dfa81c1be4b$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $77496dfa81c1be4b$var$assoc = /*#__PURE__*/ (0, $4g10W.default)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
var $77496dfa81c1be4b$export$2e2bcd8739ae039 = $77496dfa81c1be4b$var$assoc;

});

parcelRegister("kDrtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05cc48e61ef6e51$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $f05cc48e61ef6e51$var$isNil = /*#__PURE__*/ (0, $eSWTK.default)(function isNil(x) {
    return x == null;
});
var $f05cc48e61ef6e51$export$2e2bcd8739ae039 = $f05cc48e61ef6e51$var$isNil;

});


parcelRegister("1dZWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e470f0df08f6bca$export$2e2bcd8739ae039);

var $bWZKK = parcelRequire("bWZKK");
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $0e470f0df08f6bca$var$countBy = /*#__PURE__*/ (0, $bWZKK.default)(function(acc, elem) {
    return acc + 1;
}, 0);
var $0e470f0df08f6bca$export$2e2bcd8739ae039 = $0e470f0df08f6bca$var$countBy;

});
parcelRegister("bWZKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b3503560abc3fea$export$2e2bcd8739ae039);

var $9aKLL = parcelRequire("9aKLL");

var $5NMGM = parcelRequire("5NMGM");

var $kWDdm = parcelRequire("kWDdm");

var $hC9UT = parcelRequire("hC9UT");

var $gUcwi = parcelRequire("gUcwi");
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $8b3503560abc3fea$var$reduceBy = /*#__PURE__*/ (0, $9aKLL.default)(4, [], /*#__PURE__*/ (0, $5NMGM.default)([], (0, $gUcwi.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $hC9UT.default)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, $kWDdm.default)(key, acc) ? acc[key] : valueAcc, elt);
        return acc;
    }, {}, list);
}));
var $8b3503560abc3fea$export$2e2bcd8739ae039 = $8b3503560abc3fea$var$reduceBy;

});
parcelRegister("9aKLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad953abfa3f0a57$export$2e2bcd8739ae039);

var $i3ArA = parcelRequire("i3ArA");

var $1lcvr = parcelRequire("1lcvr");
function $6ad953abfa3f0a57$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $1lcvr.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $1lcvr.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $i3ArA.default)(left, $6ad953abfa3f0a57$export$2e2bcd8739ae039(length, combined, fn));
    };
}

});
parcelRegister("i3ArA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d254c6d1de203f9c$export$2e2bcd8739ae039);
function $d254c6d1de203f9c$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}

});


parcelRegister("5NMGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $43974bfa44555a02$export$2e2bcd8739ae039);

var $dPJMs = parcelRequire("dPJMs");

var $8Wdbj = parcelRequire("8Wdbj");
function $43974bfa44555a02$export$2e2bcd8739ae039(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, $dPJMs.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, $8Wdbj.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("8Wdbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $681df713ae0661e1$export$2e2bcd8739ae039);
function $681df713ae0661e1$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}

});


parcelRegister("hC9UT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2dad7e6213e77b$export$2e2bcd8739ae039);

var $b3lcT = parcelRequire("b3lcT");

var $dM7Vm = parcelRequire("dM7Vm");

var $j1ZfC = parcelRequire("j1ZfC");
function $cd2dad7e6213e77b$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
function $cd2dad7e6213e77b$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function $cd2dad7e6213e77b$var$_methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]((0, $j1ZfC.default)(xf['@@transducer/step'], xf), acc));
}
var $cd2dad7e6213e77b$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function $cd2dad7e6213e77b$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === 'function') fn = (0, $dM7Vm.default)(fn);
    if ((0, $b3lcT.default)(list)) return $cd2dad7e6213e77b$var$_arrayReduce(fn, acc, list);
    if (typeof list['fantasy-land/reduce'] === 'function') return $cd2dad7e6213e77b$var$_methodReduce(fn, acc, list, 'fantasy-land/reduce');
    if (list[$cd2dad7e6213e77b$var$symIterator] != null) return $cd2dad7e6213e77b$var$_iterableReduce(fn, acc, list[$cd2dad7e6213e77b$var$symIterator]());
    if (typeof list.next === 'function') return $cd2dad7e6213e77b$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === 'function') return $cd2dad7e6213e77b$var$_methodReduce(fn, acc, list, 'reduce');
    throw new TypeError('reduce: list must be array or iterable');
}

});
parcelRegister("b3lcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c06cc4b49520c7$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $dPJMs = parcelRequire("dPJMs");

var $faRtN = parcelRequire("faRtN");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var $80c06cc4b49520c7$var$_isArrayLike = /*#__PURE__*/ (0, $eSWTK.default)(function isArrayLike(x) {
    if ((0, $dPJMs.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== 'object') return false;
    if ((0, $faRtN.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $80c06cc4b49520c7$export$2e2bcd8739ae039 = $80c06cc4b49520c7$var$_isArrayLike;

});
parcelRegister("faRtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c1462201bf40fb$export$2e2bcd8739ae039);
function $b0c1462201bf40fb$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

});


parcelRegister("dM7Vm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a075e79d35d5e143$export$2e2bcd8739ae039);
var $a075e79d35d5e143$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $a075e79d35d5e143$export$2e2bcd8739ae039(fn) {
    return new $a075e79d35d5e143$var$XWrap(fn);
}

});

parcelRegister("j1ZfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddad9f7859eb5317$export$2e2bcd8739ae039);

var $i3ArA = parcelRequire("i3ArA");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $ddad9f7859eb5317$var$bind = /*#__PURE__*/ (0, $ggdJA.default)(function bind(fn, thisObj) {
    return (0, $i3ArA.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $ddad9f7859eb5317$export$2e2bcd8739ae039 = $ddad9f7859eb5317$var$bind;

});


parcelRegister("gUcwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4eb9684b5fb0029$export$2e2bcd8739ae039);

var $9aKLL = parcelRequire("9aKLL");

var $kWDdm = parcelRequire("kWDdm");

var $8uquE = parcelRequire("8uquE");
var $c4eb9684b5fb0029$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XReduceBy.prototype['@@transducer/result'] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $kWDdm.default)(key, this.inputs)) {
            result = this.xf['@@transducer/step'](result, this.inputs[key]);
            if (result['@@transducer/reduced']) {
                result = result['@@transducer/value'];
                break;
            }
        }
        this.inputs = null;
        return this.xf['@@transducer/result'](result);
    };
    XReduceBy.prototype['@@transducer/step'] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $c4eb9684b5fb0029$var$_xreduceBy = /*#__PURE__*/ (0, $9aKLL.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $c4eb9684b5fb0029$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $c4eb9684b5fb0029$export$2e2bcd8739ae039 = $c4eb9684b5fb0029$var$_xreduceBy;

});
parcelRegister("8uquE", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e5ad20f2108c84$export$2e2bcd8739ae039);
var $62e5ad20f2108c84$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf['@@transducer/init']();
    },
    result: function(result) {
        return this.xf['@@transducer/result'](result);
    }
};

});




parcelRegister("9FeHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $709357f44245c192$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $0fFBQ = parcelRequire("0fFBQ");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $709357f44245c192$var$difference = /*#__PURE__*/ (0, $ggdJA.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $0fFBQ.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $709357f44245c192$export$2e2bcd8739ae039 = $709357f44245c192$var$difference;

});
parcelRegister("0fFBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $000c27f61c1ba11b$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");
var $000c27f61c1ba11b$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === 'function' ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$000c27f61c1ba11b$var$hasOrAdd(item, true, this);
    };
    //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $000c27f61c1ba11b$var$hasOrAdd(item, false, this);
    };
    //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $000c27f61c1ba11b$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case 'string':
        case 'number':
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items['-0']) return true;
                else {
                    if (shouldAdd) set._items['-0'] = true;
                    return false;
                }
            }
            // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case 'boolean':
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case 'function':
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $75bQw.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case 'undefined':
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case 'object':
            if (item === null) {
                if (!set._items['null']) {
                    if (shouldAdd) set._items['null'] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            }
            // scan through all previously applied items
            if (!(0, $75bQw.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
}
var // A simple Set type that honours R.equals semantics
$000c27f61c1ba11b$export$2e2bcd8739ae039 = $000c27f61c1ba11b$var$_Set;

});
parcelRegister("75bQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5282306d28fca878$export$2e2bcd8739ae039);

var $gbZFe = parcelRequire("gbZFe");
function $5282306d28fca878$export$2e2bcd8739ae039(a, list) {
    return (0, $gbZFe.default)(list, a, 0) >= 0;
}

});
parcelRegister("gbZFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9d819b79767682$export$2e2bcd8739ae039);

var $5OdRK = parcelRequire("5OdRK");
function $bc9d819b79767682$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === 'function') switch(typeof a){
        case 'number':
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === 'number' && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case 'string':
        case 'boolean':
        case 'function':
        case 'undefined':
            return list.indexOf(a, idx);
        case 'object':
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $5OdRK.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("5OdRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ac60b95b83a85c$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $dTttc = parcelRequire("dTttc");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $43ac60b95b83a85c$var$equals = /*#__PURE__*/ (0, $ggdJA.default)(function equals(a, b) {
    return (0, $dTttc.default)(a, b, [], []);
});
var $43ac60b95b83a85c$export$2e2bcd8739ae039 = $43ac60b95b83a85c$var$equals;

});
parcelRegister("dTttc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d74582e898d186$export$2e2bcd8739ae039);

var $6NHev = parcelRequire("6NHev");

var $92ytG = parcelRequire("92ytG");

var $3uOS2 = parcelRequire("3uOS2");

var $kWDdm = parcelRequire("kWDdm");

var $1eyk6 = parcelRequire("1eyk6");

var $erwaN = parcelRequire("erwaN");

var $cy5HJ = parcelRequire("cy5HJ");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $a1d74582e898d186$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $6NHev.default)(aIterator);
    var b = (0, $6NHev.default)(bIterator);
    function eq(_a, _b) {
        return $a1d74582e898d186$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $92ytG.default)(function(b, aItem) {
        return !(0, $92ytG.default)(eq, aItem, b);
    }, b, a);
}
function $a1d74582e898d186$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $1eyk6.default)(a, b)) return true;
    var typeA = (0, $cy5HJ.default)(a);
    if (typeA !== (0, $cy5HJ.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    if (typeof a.equals === 'function' || typeof b.equals === 'function') return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    switch(typeA){
        case 'Arguments':
        case 'Array':
        case 'Object':
            if (typeof a.constructor === 'function' && (0, $3uOS2.default)(a.constructor) === 'Promise') return a === b;
            break;
        case 'Boolean':
        case 'Number':
        case 'String':
            if (!(typeof a === typeof b && (0, $1eyk6.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case 'Date':
            if (!(0, $1eyk6.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case 'Error':
            return a.name === b.name && a.message === b.message;
        case 'RegExp':
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case 'Map':
            if (a.size !== b.size) return false;
            return $a1d74582e898d186$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Set':
            if (a.size !== b.size) return false;
            return $a1d74582e898d186$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $erwaN.default)(a);
    if (keysA.length !== (0, $erwaN.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $kWDdm.default)(key, b) && $a1d74582e898d186$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("6NHev", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f38dad359ca19f3$export$2e2bcd8739ae039);
function $4f38dad359ca19f3$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("92ytG", function(module, exports) {

$parcel$export(module.exports, "default", () => $694f0b8a18173d38$export$2e2bcd8739ae039);
function $694f0b8a18173d38$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("3uOS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $28bba24788e20364$export$2e2bcd8739ae039);
function $28bba24788e20364$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
}

});

parcelRegister("1eyk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e61b91d6f721ebe$export$2e2bcd8739ae039);
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $0e61b91d6f721ebe$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $0e61b91d6f721ebe$export$2e2bcd8739ae039 = typeof Object.is === 'function' ? Object.is : $0e61b91d6f721ebe$var$_objectIs;

});

parcelRegister("erwaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83c8b3ea493a2ec$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $kWDdm = parcelRequire("kWDdm");

var $20J5D = parcelRequire("20J5D");
// cover IE < 9 keys issues
var $a83c8b3ea493a2ec$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var $a83c8b3ea493a2ec$var$nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
// Safari bug
var $a83c8b3ea493a2ec$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var $a83c8b3ea493a2ec$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $a83c8b3ea493a2ec$var$keys = typeof Object.keys === 'function' && !$a83c8b3ea493a2ec$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $eSWTK.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $eSWTK.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $a83c8b3ea493a2ec$var$hasArgsEnumBug && (0, $20J5D.default)(obj);
    for(prop in obj)if ((0, $kWDdm.default)(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if ($a83c8b3ea493a2ec$var$hasEnumBug) {
        nIdx = $a83c8b3ea493a2ec$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $a83c8b3ea493a2ec$var$nonEnumerableProps[nIdx];
            if ((0, $kWDdm.default)(prop, obj) && !$a83c8b3ea493a2ec$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $a83c8b3ea493a2ec$export$2e2bcd8739ae039 = $a83c8b3ea493a2ec$var$keys;

});
parcelRegister("20J5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $176e8ec9851986c2$export$2e2bcd8739ae039);

var $kWDdm = parcelRequire("kWDdm");
var $176e8ec9851986c2$var$toString = Object.prototype.toString;
var $176e8ec9851986c2$var$_isArguments = /*#__PURE__*/ function() {
    return $176e8ec9851986c2$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return $176e8ec9851986c2$var$toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return (0, $kWDdm.default)('callee', x);
    };
}();
var $176e8ec9851986c2$export$2e2bcd8739ae039 = $176e8ec9851986c2$var$_isArguments;

});


parcelRegister("cy5HJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $922d15c3750ff92d$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $922d15c3750ff92d$var$type = /*#__PURE__*/ (0, $eSWTK.default)(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
var $922d15c3750ff92d$export$2e2bcd8739ae039 = $922d15c3750ff92d$var$type;

});







parcelRegister("dSK2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1b407ccf0e5c2f7$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $5OdRK = parcelRequire("5OdRK");
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $a1b407ccf0e5c2f7$var$eqProps = /*#__PURE__*/ (0, $4g10W.default)(function eqProps(prop, obj1, obj2) {
    return (0, $5OdRK.default)(obj1[prop], obj2[prop]);
});
var $a1b407ccf0e5c2f7$export$2e2bcd8739ae039 = $a1b407ccf0e5c2f7$var$eqProps;

});

parcelRegister("fpul1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b380b95875b74cb7$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $du3lC = parcelRequire("du3lC");

var $ktV10 = parcelRequire("ktV10");

var $hC9UT = parcelRequire("hC9UT");

var $4xbvw = parcelRequire("4xbvw");

var $erwaN = parcelRequire("erwaN");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $b380b95875b74cb7$var$filter = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'filter'
], (0, $4xbvw.default), function(pred, filterable) {
    return (0, $ktV10.default)(filterable) ? (0, $hC9UT.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $erwaN.default)(filterable)) : // else
    (0, $du3lC.default)(pred, filterable);
}));
var $b380b95875b74cb7$export$2e2bcd8739ae039 = $b380b95875b74cb7$var$filter;

});
parcelRegister("du3lC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d10ac7fe2ac1873$export$2e2bcd8739ae039);
function $9d10ac7fe2ac1873$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("ktV10", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee92be18301682f8$export$2e2bcd8739ae039);
function $ee92be18301682f8$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

});

parcelRegister("4xbvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d32ba6a79e261d$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $8uquE = parcelRequire("8uquE");
var $34d32ba6a79e261d$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XFilter.prototype['@@transducer/result'] = (0, $8uquE.default).result;
    XFilter.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XFilter;
}();
var $34d32ba6a79e261d$var$_xfilter = /*#__PURE__*/ (0, $ggdJA.default)(function _xfilter(f, xf) {
    return new $34d32ba6a79e261d$var$XFilter(f, xf);
});
var $34d32ba6a79e261d$export$2e2bcd8739ae039 = $34d32ba6a79e261d$var$_xfilter;

});


parcelRegister("eirae", function(module, exports) {

$parcel$export(module.exports, "default", () => $a687d15adcb71d3c$export$2e2bcd8739ae039);

var $6uMFi = parcelRequire("6uMFi");

var $ggdJA = parcelRequire("ggdJA");

var $bWZKK = parcelRequire("bWZKK");
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $a687d15adcb71d3c$var$groupBy = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $6uMFi.default)('groupBy', /*#__PURE__*/ (0, $bWZKK.default)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
var $a687d15adcb71d3c$export$2e2bcd8739ae039 = $a687d15adcb71d3c$var$groupBy;

});
parcelRegister("6uMFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bab4b5017a4d94c$export$2e2bcd8739ae039);

var $dPJMs = parcelRequire("dPJMs");
function $4bab4b5017a4d94c$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $dPJMs.default)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});


parcelRegister("jPCDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e700c04599ba9b53$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $eCA8M = parcelRequire("eCA8M");
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $e700c04599ba9b53$var$has = /*#__PURE__*/ (0, $ggdJA.default)(function has(prop, obj) {
    return (0, $eCA8M.default)([
        prop
    ], obj);
});
var $e700c04599ba9b53$export$2e2bcd8739ae039 = $e700c04599ba9b53$var$has;

});
parcelRegister("eCA8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa50a60ffaf2b1f8$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $kWDdm = parcelRequire("kWDdm");
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $aa50a60ffaf2b1f8$var$hasPath = /*#__PURE__*/ (0, $ggdJA.default)(function hasPath(_path, obj) {
    if (_path.length === 0) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if ((0, $kWDdm.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $aa50a60ffaf2b1f8$export$2e2bcd8739ae039 = $aa50a60ffaf2b1f8$var$hasPath;

});


parcelRegister("eN1iE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac46a66313f594d3$export$2e2bcd8739ae039);

var $bWZKK = parcelRequire("bWZKK");
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $ac46a66313f594d3$var$indexBy = /*#__PURE__*/ (0, $bWZKK.default)(function(acc, elem) {
    return elem;
}, null);
var $ac46a66313f594d3$export$2e2bcd8739ae039 = $ac46a66313f594d3$var$indexBy;

});

parcelRegister("cQwal", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a34ad4b08602a0$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $95a34ad4b08602a0$var$omit = /*#__PURE__*/ (0, $ggdJA.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $95a34ad4b08602a0$export$2e2bcd8739ae039 = $95a34ad4b08602a0$var$omit;

});

parcelRegister("kjklK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec955e0362a178ab$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */ var $ec955e0362a178ab$var$path = /*#__PURE__*/ (0, $ggdJA.default)(function path(paths, obj) {
    var val = obj;
    var idx = 0;
    while(idx < paths.length){
        if (val == null) return;
        val = val[paths[idx]];
        idx += 1;
    }
    return val;
});
var $ec955e0362a178ab$export$2e2bcd8739ae039 = $ec955e0362a178ab$var$path;

});

parcelRegister("f7Op5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02e9b8f5f440a55$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $kjklK = parcelRequire("kjklK");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $b02e9b8f5f440a55$var$prop = /*#__PURE__*/ (0, $ggdJA.default)(function prop(p, obj) {
    return (0, $kjklK.default)([
        p
    ], obj);
});
var $b02e9b8f5f440a55$export$2e2bcd8739ae039 = $b02e9b8f5f440a55$var$prop;

});

parcelRegister("kpKEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $edca54d3ce8c6eaf$export$2e2bcd8739ae039);

var $5QxVa = parcelRequire("5QxVa");

var $ggdJA = parcelRequire("ggdJA");

var $fpul1 = parcelRequire("fpul1");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $edca54d3ce8c6eaf$var$reject = /*#__PURE__*/ (0, $ggdJA.default)(function reject(pred, filterable) {
    return (0, $fpul1.default)((0, $5QxVa.default)(pred), filterable);
});
var $edca54d3ce8c6eaf$export$2e2bcd8739ae039 = $edca54d3ce8c6eaf$var$reject;

});
parcelRegister("5QxVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $441c1f18f874f244$export$2e2bcd8739ae039);
function $441c1f18f874f244$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});


parcelRegister("afKQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $776fa5d31a463792$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $776fa5d31a463792$var$replace = /*#__PURE__*/ (0, $4g10W.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $776fa5d31a463792$export$2e2bcd8739ae039 = $776fa5d31a463792$var$replace;

});

parcelRegister("3G9Az", function(module, exports) {

$parcel$export(module.exports, "default", () => $2adcbb7f68e2ee91$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $hFcvX = parcelRequire("hFcvX");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $2adcbb7f68e2ee91$var$toString = /*#__PURE__*/ (0, $eSWTK.default)(function toString(val) {
    return (0, $hFcvX.default)(val, []);
});
var $2adcbb7f68e2ee91$export$2e2bcd8739ae039 = $2adcbb7f68e2ee91$var$toString;

});
parcelRegister("hFcvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdbff91c5a6a5081$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");

var $3bCe9 = parcelRequire("3bCe9");

var $jnwgB = parcelRequire("jnwgB");

var $gi5VL = parcelRequire("gi5VL");

var $erwaN = parcelRequire("erwaN");

var $kpKEz = parcelRequire("kpKEz");
function $cdbff91c5a6a5081$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $75bQw.default)(y, xs) ? '<Circular>' : $cdbff91c5a6a5081$export$2e2bcd8739ae039(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $3bCe9.default)(function(k) {
            return (0, $jnwgB.default)(k) + ': ' + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case '[object Arguments]':
            return '(function() { return arguments; }(' + (0, $3bCe9.default)(recur, x).join(', ') + '))';
        case '[object Array]':
            return '[' + (0, $3bCe9.default)(recur, x).concat(mapPairs(x, (0, $kpKEz.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $erwaN.default)(x)))).join(', ') + ']';
        case '[object Boolean]':
            return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
        case '[object Date]':
            return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : (0, $jnwgB.default)((0, $gi5VL.default)(x))) + ')';
        case '[object Null]':
            return 'null';
        case '[object Number]':
            return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
        case '[object String]':
            return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : (0, $jnwgB.default)(x);
        case '[object Undefined]':
            return 'undefined';
        default:
            if (typeof x.toString === 'function') {
                var repr = x.toString();
                if (repr !== '[object Object]') return repr;
            }
            return '{' + mapPairs(x, (0, $erwaN.default)(x)).join(', ') + '}';
    }
}

});
parcelRegister("3bCe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $25200d513c7d0c23$export$2e2bcd8739ae039);
function $25200d513c7d0c23$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("jnwgB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b931cf8f848b60$export$2e2bcd8739ae039);
function $e1b931cf8f848b60$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("gi5VL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc2ed7a4157d7bd$export$2e2bcd8739ae039);
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $bdc2ed7a4157d7bd$var$pad = function pad(n) {
    return (n < 10 ? '0' : '') + n;
};
var $bdc2ed7a4157d7bd$var$_toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + '-' + $bdc2ed7a4157d7bd$var$pad(d.getUTCMonth() + 1) + '-' + $bdc2ed7a4157d7bd$var$pad(d.getUTCDate()) + 'T' + $bdc2ed7a4157d7bd$var$pad(d.getUTCHours()) + ':' + $bdc2ed7a4157d7bd$var$pad(d.getUTCMinutes()) + ':' + $bdc2ed7a4157d7bd$var$pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};
var $bdc2ed7a4157d7bd$export$2e2bcd8739ae039 = $bdc2ed7a4157d7bd$var$_toISOString;

});



parcelRegister("kndO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed50aa68a4a546b9$export$2e2bcd8739ae039);

var $juWBF = parcelRequire("juWBF");
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $ed50aa68a4a546b9$var$toUpper = /*#__PURE__*/ (0, $juWBF.default)(0, 'toUpperCase');
var $ed50aa68a4a546b9$export$2e2bcd8739ae039 = $ed50aa68a4a546b9$var$toUpper;

});
parcelRegister("juWBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31e47b03927340e$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $bcKbC = parcelRequire("bcKbC");

var $bwMm3 = parcelRequire("bwMm3");

var $3G9Az = parcelRequire("3G9Az");
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $e31e47b03927340e$var$invoker = /*#__PURE__*/ (0, $ggdJA.default)(function invoker(arity, method) {
    return (0, $bwMm3.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $bcKbC.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $3G9Az.default)(target) + ' does not have a method named "' + method + '"');
    });
});
var $e31e47b03927340e$export$2e2bcd8739ae039 = $e31e47b03927340e$var$invoker;

});
parcelRegister("bcKbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8284a45864cd3504$export$2e2bcd8739ae039);
function $8284a45864cd3504$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Function]';
}

});

parcelRegister("bwMm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $86483115f0bb4136$export$2e2bcd8739ae039);

var $i3ArA = parcelRequire("i3ArA");

var $eSWTK = parcelRequire("eSWTK");

var $ggdJA = parcelRequire("ggdJA");

var $9aKLL = parcelRequire("9aKLL");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $86483115f0bb4136$var$curryN = /*#__PURE__*/ (0, $ggdJA.default)(function curryN(length, fn) {
    if (length === 1) return (0, $eSWTK.default)(fn);
    return (0, $i3ArA.default)(length, (0, $9aKLL.default)(length, [], fn));
});
var $86483115f0bb4136$export$2e2bcd8739ae039 = $86483115f0bb4136$var$curryN;

});



parcelRegister("8YqJS", function(module, exports) {

$parcel$export(module.exports, "SUB_TASK_LEVEL", () => $c8b5d01a0262a13c$export$629eb88199636e31);
$parcel$export(module.exports, "STORY_LEVEL", () => $c8b5d01a0262a13c$export$5851ccd68c79bc39);
$parcel$export(module.exports, "EPIC_LEVEL", () => $c8b5d01a0262a13c$export$346285e0085a3842);
$parcel$export(module.exports, "INITIATIVE_LEVEL", () => $c8b5d01a0262a13c$export$3dc28f07aa7629a3);

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");
const $c8b5d01a0262a13c$var$adjustHierarchyLevel = (level)=>{
    if (!(0, $1ybV0.ff)('use-jira-hierarchy-levels-in-plans_knftc')) return level + 1;
    return level;
};
const $c8b5d01a0262a13c$export$629eb88199636e31 = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_SUBTASK));
const $c8b5d01a0262a13c$export$5851ccd68c79bc39 = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE));
const $c8b5d01a0262a13c$export$346285e0085a3842 = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC));
const $c8b5d01a0262a13c$export$3dc28f07aa7629a3 = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_INITIATIVE));
const $c8b5d01a0262a13c$export$6b568e78303247cb = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_STRATEGY));
const $c8b5d01a0262a13c$export$8d7949e6fbe9c22a = $c8b5d01a0262a13c$var$adjustHierarchyLevel((0, $3l6tm.ISSUE_HIERARCHY_LEVEL_GOAL));

});

parcelRegister("akhOi", function(module, exports) {

$parcel$export(module.exports, "getMode", () => $acab7c6230ca6e7d$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getAnalyticsEvent", () => $acab7c6230ca6e7d$export$32b073657518c6bb);
$parcel$export(module.exports, "isOptimizedMode", () => $acab7c6230ca6e7d$export$cd4751658902d6e8);
$parcel$export(module.exports, "isReadOnlyPure", () => $acab7c6230ca6e7d$export$37f5d101f9e0e691);
$parcel$export(module.exports, "isReadOnly", () => $acab7c6230ca6e7d$export$2498094d90b6ac72);
$parcel$export(module.exports, "isArchived", () => $acab7c6230ca6e7d$export$e254a38a69007d83);
$parcel$export(module.exports, "isReportMode", () => $acab7c6230ca6e7d$export$e8610bde98f41d48);
$parcel$export(module.exports, "isExportMode", () => $acab7c6230ca6e7d$export$b01a4f610a5e4f02);
$parcel$export(module.exports, "isExportPreview", () => $acab7c6230ca6e7d$export$ad6637fa30ef33ef);
$parcel$export(module.exports, "isEditMode", () => $acab7c6230ca6e7d$export$57957ca6633a6742);
$parcel$export(module.exports, "isConfluenceMacro", () => $acab7c6230ca6e7d$export$5e9f5d03e746bc0e);
$parcel$export(module.exports, "isEmbed", () => $acab7c6230ca6e7d$export$6a4806a2b2fc6ddd);
$parcel$export(module.exports, "getPlanUserRole", () => $acab7c6230ca6e7d$export$7f15cac1ccc346b0);
$parcel$export(module.exports, "getPlanModeForAnalytics", () => $acab7c6230ca6e7d$export$399cb6b07601f91);
$parcel$export(module.exports, "getIsPlanInfoReady", () => $acab7c6230ca6e7d$export$9f4fce2c8690a6c4);
$parcel$export(module.exports, "EDIT", () => $99f9ac26081f8045$export$250171a898bf7ef);
$parcel$export(module.exports, "EXPORT", () => $99f9ac26081f8045$export$f79b1fae3e63e441);
$parcel$export(module.exports, "REPORT", () => $99f9ac26081f8045$export$e3d31417f21c1ce7);
$parcel$export(module.exports, "OPTIMIZING", () => $99f9ac26081f8045$export$7536581a3f6533cb);
$parcel$export(module.exports, "OPTIMIZED", () => $99f9ac26081f8045$export$e91bb82ec00eb771);
$parcel$export(module.exports, "READONLY", () => $99f9ac26081f8045$export$b07c15b79440feb8);


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");
const $acab7c6230ca6e7d$export$1fc0f6205829e19c = (state)=>state.domain.app.mode;
const $acab7c6230ca6e7d$export$abc1d5d6f276a713 = (state)=>state.domain.plan.planStatus === 'ARCHIVED';
const $acab7c6230ca6e7d$export$534eb0b3e1a26ec7 = (state)=>state.domain.app.isExportPreview;
const $acab7c6230ca6e7d$export$fb4d124cbc4fe01f = (state)=>state.domain.app.hasReportedInitialLoadAnalytics;
const $acab7c6230ca6e7d$export$32b073657518c6bb = (state)=>state.domain.app.analyticsEvent;
const $acab7c6230ca6e7d$export$cd4751658902d6e8 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771));
const $acab7c6230ca6e7d$export$37f5d101f9e0e691 = (mode)=>mode === (0, $99f9ac26081f8045$export$b07c15b79440feb8) || mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) || mode === (0, $99f9ac26081f8045$export$f79b1fae3e63e441);
const $acab7c6230ca6e7d$export$2498094d90b6ac72 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], $acab7c6230ca6e7d$export$37f5d101f9e0e691);
const $acab7c6230ca6e7d$export$e254a38a69007d83 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$abc1d5d6f276a713
], (archived)=>archived);
const $acab7c6230ca6e7d$export$e8610bde98f41d48 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) || mode === (0, $99f9ac26081f8045$export$f79b1fae3e63e441));
const $acab7c6230ca6e7d$export$b01a4f610a5e4f02 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$f79b1fae3e63e441));
const $acab7c6230ca6e7d$export$ad6637fa30ef33ef = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c,
    $acab7c6230ca6e7d$export$534eb0b3e1a26ec7
], (mode, isPreview)=>mode === (0, $99f9ac26081f8045$export$f79b1fae3e63e441) && isPreview);
const $acab7c6230ca6e7d$export$57957ca6633a6742 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$250171a898bf7ef));
const $acab7c6230ca6e7d$export$5e9f5d03e746bc0e = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && (0, $lFLge.isConfluenceReportView)());
const $acab7c6230ca6e7d$export$6a4806a2b2fc6ddd = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && (0, $lFLge.isEmbedReportView)());
const $acab7c6230ca6e7d$export$7f15cac1ccc346b0 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>{
    switch(mode){
        case 0, $99f9ac26081f8045$export$e3d31417f21c1ce7:
        case 0, $99f9ac26081f8045$export$f79b1fae3e63e441:
            return (0, $lFLge.isConfluenceReportView)() ? (0, $5rYNM.PLAN_USER_ROLE).CONFLUENCE_CONSUMER : (0, $5rYNM.PLAN_USER_ROLE).REPORT_CONSUMER;
        case 0, $99f9ac26081f8045$export$b07c15b79440feb8:
            return (0, $5rYNM.PLAN_USER_ROLE).VIEWER;
        default:
            return (0, $5rYNM.PLAN_USER_ROLE).EDITOR;
    }
});
const $acab7c6230ca6e7d$export$47e5056eea334725 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$7f15cac1ccc346b0
], (planUserRole)=>planUserRole === (0, $5rYNM.PLAN_USER_ROLE).EDITOR);
const $acab7c6230ca6e7d$export$6c84b521e280798b = {
    REPORT: 'REPORT',
    EXPORT: 'EXPORT',
    READONLY: 'READ-ONLY',
    EDIT: 'EDIT'
};
const $acab7c6230ca6e7d$export$399cb6b07601f91 = (0, $iK4oF.createSelector)([
    $acab7c6230ca6e7d$export$1fc0f6205829e19c
], (mode)=>{
    switch(mode){
        case 0, $99f9ac26081f8045$export$e3d31417f21c1ce7:
            return $acab7c6230ca6e7d$export$6c84b521e280798b.REPORT;
        case 0, $99f9ac26081f8045$export$f79b1fae3e63e441:
            return $acab7c6230ca6e7d$export$6c84b521e280798b.EXPORT;
        case 0, $99f9ac26081f8045$export$b07c15b79440feb8:
            return $acab7c6230ca6e7d$export$6c84b521e280798b.READONLY;
        default:
            return $acab7c6230ca6e7d$export$6c84b521e280798b.EDIT;
    }
});
const $acab7c6230ca6e7d$export$9f4fce2c8690a6c4 = (state)=>state.domain.app.isPlanInfoReady;

});
const $99f9ac26081f8045$export$250171a898bf7ef = 'state.domain.app.EDIT';
const $99f9ac26081f8045$export$e3d31417f21c1ce7 = 'state.domain.app.REPORT';
const $99f9ac26081f8045$export$7536581a3f6533cb = 'state.domain.app.OPTIMIZING';
const $99f9ac26081f8045$export$e91bb82ec00eb771 = 'state.domain.app.OPTIMIZED';
const $99f9ac26081f8045$export$b07c15b79440feb8 = 'state.domain.app.READONLY';
const $99f9ac26081f8045$export$f79b1fae3e63e441 = 'state.domain.app.EXPORT';

parcelRegister("iK4oF", function(module, exports) {

$parcel$export(module.exports, "equals", () => $d5f40b520a178e89$export$e9bab7fafb253603);
$parcel$export(module.exports, "createSelector", () => $d5f40b520a178e89$export$595d22ed68ca2841);
$parcel$export(module.exports, "createStructuredSelector", () => $d5f40b520a178e89$export$75979cfcd91bf38f);

var $df4Sl = parcelRequire("df4Sl");
parcelRequire("21J3i");
var $gA7sD = parcelRequire("gA7sD");

var $5WdbR = parcelRequire("5WdbR");
// Use the reselect wrapper library for debugging if feature flag enabled
// More info: https://bitbucket.org/atlassianlabs/reselect-debug/src/master/
const $d5f40b520a178e89$var$libCreateSelectorCreator = (0, $gA7sD.default)() ? (0, $5WdbR.createSelectorCreator) : (0, $df4Sl.createSelectorCreator);
const $d5f40b520a178e89$var$libCreateStructuredSelector = (0, $gA7sD.default)() ? (0, $5WdbR.createStructuredSelector) : (0, $df4Sl.createStructuredSelector);
const $d5f40b520a178e89$var$EQUALS_DEPTH_LIMIT = 1;
const $d5f40b520a178e89$export$e9bab7fafb253603 = (a, b, maxDepth = $d5f40b520a178e89$var$EQUALS_DEPTH_LIMIT, depth = 0)=>{
    if (a === b) return true;
    if (depth > maxDepth) return false;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$d5f40b520a178e89$export$e9bab7fafb253603(a[i], b[i], maxDepth, depth + 1)) return false;
        }
        return true;
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        // NOTE Object.keys returns [] for any set thus we need to treat Set instances specially
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const c = new Set(b);
            for (const x of a){
                if (!c.has(x)) return false;
                c.delete(x);
            }
            if (c.size > 0) return false;
            return true;
        }
        const k1 = Object.keys(a);
        const k2 = Object.keys(b);
        if (k1.length !== k2.length) return false;
        // Micro-optimization relying on the assumption that if keys are out-of-order
        // then chances are that object was rebuilt and changed.
        // (It's okay for selector's `equals` to give false negatives)
        // k1.sort();
        // k2.sort();
        for(let i = 0; i < k1.length; i++){
            if (k1[i] !== k2[i]) return false;
            if (!$d5f40b520a178e89$export$e9bab7fafb253603(a[k1[i]], b[k2[i]], maxDepth, depth + 1)) return false;
        }
        return true;
    }
    return false;
};
const $d5f40b520a178e89$export$595d22ed68ca2841 = $d5f40b520a178e89$var$libCreateSelectorCreator((0, $df4Sl.defaultMemoize), $d5f40b520a178e89$export$e9bab7fafb253603);
const $d5f40b520a178e89$export$75979cfcd91bf38f = (selectors, selectorCreator = $d5f40b520a178e89$export$595d22ed68ca2841)=>$d5f40b520a178e89$var$libCreateStructuredSelector(selectors, selectorCreator);

});
parcelRegister("21J3i", function(module, exports) {

$parcel$export(module.exports, "isUsingReselectWrapper", () => (parcelRequire("gA7sD")).default);

var $gA7sD = parcelRequire("gA7sD");

});
parcelRegister("gA7sD", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b132f704cb9893$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
const $49b132f704cb9893$var$isUsingReselectWrapper = ()=>(0, $dtKCx.getBooleanFeatureFlag)('com.atlassian.rm.jpo.jpo3cloud.use-reselect-wrapper-library');
var $49b132f704cb9893$export$2e2bcd8739ae039 = $49b132f704cb9893$var$isUsingReselectWrapper;

});
parcelRegister("dtKCx", function(module, exports) {

$parcel$export(module.exports, "injectCallbackIntoGetBooleanFeatureFlag", () => $42058a3266f06a4b$export$fe8eedb8c1059343);
$parcel$export(module.exports, "getBooleanFeatureFlag", () => $42058a3266f06a4b$export$a4658325ccb88f03);

var $1ybV0 = parcelRequire("1ybV0");
const $42058a3266f06a4b$var$callbacks = [];
const $42058a3266f06a4b$export$fe8eedb8c1059343 = (callback)=>{
    $42058a3266f06a4b$var$callbacks.push(callback);
};
const $42058a3266f06a4b$export$d930a8564fce9bcd = (flag)=>{
    const urlParams = new URLSearchParams(window.location.search);
    const ffOverrides = urlParams.get('ffOverrides');
    if (ffOverrides === undefined || ffOverrides === null) return null;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const item = ffOverrides.split(',').find((item)=>item.startsWith(`${flag}:`));
    return item !== undefined && item.split(':')[1] || null;
};
const $42058a3266f06a4b$export$a4658325ccb88f03 = (flag, defaultValue = false, storybookDefault = true)=>{
    for (const cb of $42058a3266f06a4b$var$callbacks)cb(flag, defaultValue, storybookDefault);
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $42058a3266f06a4b$export$d930a8564fce9bcd(flag);
        if (overrideValue !== null) return overrideValue === 'true';
        return storybookDefault;
    }
    return (0, $1ybV0.ff)(flag, defaultValue);
};
const $42058a3266f06a4b$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues = [], storybookDefault)=>{
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $42058a3266f06a4b$export$d930a8564fce9bcd(featureFlagName);
        if (overrideValue !== null) return overrideValue;
        return typeof storybookDefault === 'string' ? storybookDefault : defaultValue;
    }
    return (0, $1ybV0.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};

});



parcelRegister("5WdbR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStructuredSelector = module.exports.createSelector = module.exports.createSelectorCreator = module.exports.windowKey = module.exports.defaultMemoize = void 0;

var $df4Sl = parcelRequire("df4Sl");

var $df4Sl = parcelRequire("df4Sl");
Object.defineProperty(module.exports, "defaultMemoize", {
    enumerable: true,
    get: function() {
        return $df4Sl.defaultMemoize;
    }
});
// Name of property to store data on the global window object
module.exports.windowKey = '__RESELECT_DEBUG__';
// The poor mans UUIDv4
function $452c99d8bd0ae4a3$var$getUniqueId() {
    const random = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    // Return number in hex
    return random.toString(16);
}
// Get selector info map, creating if it doesn't exist
function $452c99d8bd0ae4a3$var$getSelectorMap() {
    if (!window[module.exports.windowKey]) window[module.exports.windowKey] = {
        selectors: new Map()
    };
    return window[module.exports.windowKey].selectors;
}
// Get a unique name for this selector, given creation args
function $452c99d8bd0ae4a3$var$getSelectorName(id, args) {
    // Use name of combiner function if available
    const combiner = args[args.length - 1];
    if (combiner instanceof Function && combiner.name) return combiner.name;
    // Otherwise use anon with id
    return `anonymous ${id}`;
}
// Extract dependency functions from creation args 
function $452c99d8bd0ae4a3$var$extractDependencies(args) {
    const funcs = args.slice(0, -1);
    if (funcs.length > 0) {
        const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
        // TODO: Better typing
        return dependencies.map((f)=>{
            if (f.debugId !== undefined) {
                const info = $452c99d8bd0ae4a3$var$getSelectorMap().get(f.debugId);
                if (info) return {
                    type: "selector",
                    id: f.debugId,
                    name: info.name,
                    functionName: f.name
                };
                else throw new Error("Failed to lookup dependency name");
            }
            return {
                type: "function",
                name: f.name
            };
        });
    }
    return [];
}
// Store selector information in global state
function $452c99d8bd0ae4a3$var$storeSelectorInfo(id, name, dependencies) {
    const info = {
        id: id,
        name: name,
        recomputations: 0,
        savedUsage: 0,
        dependencies: dependencies,
        combinerArguments: []
    };
    $452c99d8bd0ae4a3$var$getSelectorMap().set(id, info);
}
module.exports.createSelectorCreator = (...args)=>{
    const selectorCreator = (0, $df4Sl.createSelectorCreator)(...args);
    return (...args)=>{
        const selectorId = $452c99d8bd0ae4a3$var$getUniqueId();
        const initialSelectorName = $452c99d8bd0ae4a3$var$getSelectorName(selectorId, args);
        const combiner = args[args.length - 1];
        const funcs = args.slice(0, -1);
        const wrappedCombiner = (...args)=>{
            const info = $452c99d8bd0ae4a3$var$getSelectorMap().get(selectorId);
            if (info) info.combinerArguments.push(args);
            return combiner(...args);
        };
        // @ts-expect-error The type system doesn't understand we have just wrapped the last argument
        const selector = selectorCreator(...funcs, wrappedCombiner);
        $452c99d8bd0ae4a3$var$storeSelectorInfo(selectorId, initialSelectorName, $452c99d8bd0ae4a3$var$extractDependencies(args));
        const wrappedSelector = (...args)=>{
            // Compute result, keeping track of recomputations
            const beforeRecomputations = selector.recomputations();
            const result = selector(...args);
            const afterRecomputations = selector.recomputations();
            // Update selector info with new data
            const info = $452c99d8bd0ae4a3$var$getSelectorMap().get(selectorId);
            if (info) {
                if (afterRecomputations > beforeRecomputations) info.recomputations = afterRecomputations;
                else info.savedUsage++;
            }
            return result;
        };
        // Add functions that were on the original selector
        wrappedSelector.recomputations = selector.recomputations;
        wrappedSelector.resetRecomputations = selector.resetRecomputations;
        wrappedSelector.resultFunc = selector.resultFunc;
        // Add the debug id so we can map dependencies
        wrappedSelector.debugId = selectorId;
        // Function to set a custom debug name
        wrappedSelector.setDebugName = (name)=>{
            // TODO: Currently using this function will result in a type error due to re-use of
            // reselect library types
            const info = $452c99d8bd0ae4a3$var$getSelectorMap().get(selectorId);
            if (info) info.name = name;
        };
        return wrappedSelector;
    };
// Use this "as" so we expose a function with the same horrifying overloaded types as the original
// Unfortunately we can't just export a function using Paramaters and ReturnType due to
// https://github.com/microsoft/TypeScript/issues/43731
};
module.exports.createSelector = (0, module.exports.createSelectorCreator)($df4Sl.defaultMemoize);
module.exports.createStructuredSelector = (...args)=>{
    // Extract creation function from args or use default from this library
    const creationFunction = args[1] === undefined ? module.exports.createSelector : args[1];
    // Wrap the create selector function so we can capture it's return value
    let innerSelector;
    const wrappedCreateSelector = (...args)=>{
        innerSelector = creationFunction(...args);
        return innerSelector;
    };
    const creationArgs = Array.from(args);
    creationArgs[1] = wrappedCreateSelector;
    // @ts-expect-error Cannot use Parameters due to overloaded function as above
    const structuredSelector = (0, $df4Sl.createStructuredSelector)(...creationArgs);
    // Add debug id and set name from the original selector if present. Possible for this to be
    // missing if using a creation function not from this library
    if (innerSelector.debugId && innerSelector.setDebugName) {
        structuredSelector.debugId = innerSelector.debugId;
        structuredSelector.setDebugName = innerSelector.setDebugName;
    } else console.warn("Not instrumenting structured selector created with custom function");
    return structuredSelector;
};

});


parcelRegister("5rYNM", function(module, exports) {

$parcel$export(module.exports, "DefaultDateFormat", () => $678968442832ddd5$export$14ae725d0cc7daa1);
$parcel$export(module.exports, "EXPORT_FILE_DATE_FORMAT", () => $678968442832ddd5$export$363270f5bff80927);
$parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", () => $678968442832ddd5$export$c8c7cce628cf5c4e);
$parcel$export(module.exports, "DIRECTIONS", () => $678968442832ddd5$export$4aabe0d20c9c03b3);
$parcel$export(module.exports, "PLANNING_UNITS", () => $678968442832ddd5$export$c56f9fa2106f4847);
$parcel$export(module.exports, "CROSS_PROJECT_RELEASE", () => $678968442832ddd5$export$7b04eb9e81ba1c56);
$parcel$export(module.exports, "NONE", () => $678968442832ddd5$export$c53d0f541b41b88e);
$parcel$export(module.exports, "PROJECT", () => $678968442832ddd5$export$fe791c4fa892e400);
$parcel$export(module.exports, "RELEASE", () => $678968442832ddd5$export$5c698591c0e586a2);
$parcel$export(module.exports, "ASCENDING", () => $678968442832ddd5$export$6e386ac144cffab5);
$parcel$export(module.exports, "DEFAULT", () => $678968442832ddd5$export$e6952b12ade67489);
$parcel$export(module.exports, "LINES", () => $678968442832ddd5$export$e0de529f548a9140);
$parcel$export(module.exports, "COUNT", () => $678968442832ddd5$export$d61684373eacdf61);
$parcel$export(module.exports, "ENTITY", () => $678968442832ddd5$export$fa20de1d199f87ac);
$parcel$export(module.exports, "SCENARIO_TYPE", () => $678968442832ddd5$export$6952e648aa2551c8);
$parcel$export(module.exports, "GROUPING", () => $678968442832ddd5$export$a9c30cbc241a4f57);
$parcel$export(module.exports, "STRING", () => $678968442832ddd5$export$a0e01ba2ebef17f2);
$parcel$export(module.exports, "ISSUE_FIELD_TYPES", () => $678968442832ddd5$export$a8827164bd516a88);
$parcel$export(module.exports, "SORT_DIRECTION", () => $678968442832ddd5$export$2e66878530bcbbc7);
$parcel$export(module.exports, "COMPLETED_SPRINTS_GROUP", () => $678968442832ddd5$export$cc61be5f9aa609ee);
$parcel$export(module.exports, "COMPLETED_RELEASES_GROUP", () => $678968442832ddd5$export$93d3dc39c0269fe3);
$parcel$export(module.exports, "RELEASE_STATUSES", () => $678968442832ddd5$export$7082e4b62554b72d);
$parcel$export(module.exports, "RELEASE_STATUSES_APPEARANCE_SPA", () => $678968442832ddd5$export$311d2f5af921faaa);
$parcel$export(module.exports, "CustomFieldTypes", () => $678968442832ddd5$export$331c42b4f42400fb);
$parcel$export(module.exports, "CustomFieldTypesToDataType", () => $678968442832ddd5$export$fea945adb3660cc7);
$parcel$export(module.exports, "CustomFields", () => $678968442832ddd5$export$a1d1fd7da6e94a65);
$parcel$export(module.exports, "PREVIEW_OPACITY", () => $678968442832ddd5$export$8ffcc37b9e9dd572);
$parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES_CONST", () => $678968442832ddd5$export$16f1a8408ee71016);
$parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES", () => $678968442832ddd5$export$2b1f4448b6b508db);
$parcel$export(module.exports, "ISSUE_STATUS_APPEARANCE", () => $678968442832ddd5$export$86fc137548f2fce5);
$parcel$export(module.exports, "SPRINT_STATES", () => $678968442832ddd5$export$73a0206a4dc59760);
$parcel$export(module.exports, "EXTERNAL_SPRINT", () => $678968442832ddd5$export$f1b6d0605ff9b7e6);
$parcel$export(module.exports, "DEFAULT_FIELD_WIDTH", () => $678968442832ddd5$export$e5d805200f62f81d);
$parcel$export(module.exports, "SCOPE_ROW_HEIGHT", () => $678968442832ddd5$export$6edf6d7514b31ffa);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_SCOPE_WIDTH", () => $678968442832ddd5$export$a705d305be7bd15d);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_FIELDS_WIDTH", () => $678968442832ddd5$export$9a8b9408dd2830b);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH", () => $678968442832ddd5$export$4cd768253686885b);
$parcel$export(module.exports, "NUM_ISSUES_IN_EXPORT_PREVIEW", () => $678968442832ddd5$export$36a3ce28e91ef989);
$parcel$export(module.exports, "AUTO_SCHEDULE_OVERWRITE", () => $678968442832ddd5$export$de3ef5bf994b7018);
$parcel$export(module.exports, "ISSUE_VALUES", () => $678968442832ddd5$export$f9c0c7ff9184db0);
$parcel$export(module.exports, "PlanningUnits", () => $678968442832ddd5$export$448fe702ac76034a);
$parcel$export(module.exports, "UNDEFINED_KEY", () => $678968442832ddd5$export$75989ea7860b85e9);
$parcel$export(module.exports, "STICKY_HEADER_CONTAINER_PREFIX", () => $678968442832ddd5$export$6bc4f75201f6f12e);
$parcel$export(module.exports, "CHECKBOX_STATES", () => $678968442832ddd5$export$e3c19de1b019757c);
$parcel$export(module.exports, "PLUGIN_PERMISSION", () => $678968442832ddd5$export$3bf3c26d6d69f3b1);
$parcel$export(module.exports, "SHARE_AS", () => $678968442832ddd5$export$40628b030ac72445);
$parcel$export(module.exports, "SCHEDULE_MODE", () => $678968442832ddd5$export$5b1b1523594baa6e);
$parcel$export(module.exports, "INSTANCE_USER_ROLE", () => $678968442832ddd5$export$b4d5766fd1973953);
$parcel$export(module.exports, "PLAN_USER_ROLE", () => $678968442832ddd5$export$183f45c476faaff2);
$parcel$export(module.exports, "ISSUE_LINK_DIRECTION", () => $678968442832ddd5$export$deea8c9ae0e3c1ca);
$parcel$export(module.exports, "ISSUE_SOURCE_TYPES", () => $678968442832ddd5$export$86e2f9653c14c34);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $678968442832ddd5$export$f048d91ccaf92408);
$parcel$export(module.exports, "PROFILE_KEYS", () => $678968442832ddd5$export$4eb5c0330ef8fab4);
$parcel$export(module.exports, "PACKAGE_NAME", () => $678968442832ddd5$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $678968442832ddd5$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $678968442832ddd5$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_BULK_CHANGE_ISSUES", () => $678968442832ddd5$export$bf7af18c7898a31);
$parcel$export(module.exports, "DEPENDENCY_SETTINGS", () => $678968442832ddd5$export$37e30ab04b9b1705);
$parcel$export(module.exports, "HORIZONTAL_SCROLL_OFFSET", () => $678968442832ddd5$export$e24665e8d921f93e);
$parcel$export(module.exports, "PROJECT_TYPE_KEY", () => $678968442832ddd5$export$22ed55708a9d1966);
$parcel$export(module.exports, "ZOOM_LEVELS", () => $678968442832ddd5$export$8b7222fa92892b49);
$parcel$export(module.exports, "TIMELINE_MODES", () => $678968442832ddd5$export$bbbec7054427e57b);
$parcel$export(module.exports, "CUSTOM_DATE_RANGES", () => $678968442832ddd5$export$b0f7807f8d64b44a);
$parcel$export(module.exports, "VALID_LEADING_TIME_FOR_DEPENDENCIES", () => $678968442832ddd5$export$46a3b4b81e5a44ac);
$parcel$export(module.exports, "NOTIFY_WATCHERS_KEY", () => $678968442832ddd5$export$954b02519e22ad3c);
$parcel$export(module.exports, "TIMELINE_SHARE_TYPE", () => $678968442832ddd5$export$cb60c924e8198091);
$parcel$export(module.exports, "DEPENDENCY_REPORT_SHARE_TYPE", () => $678968442832ddd5$export$16c8656f8d888a96);
$parcel$export(module.exports, "SECTION_KEYS", () => $678968442832ddd5$export$d37ffa307efd6838);
$parcel$export(module.exports, "SECTION_ITEM_KEYS", () => $678968442832ddd5$export$cb4feb832f4bb576);
$parcel$export(module.exports, "ORIGINAL_STATUS_TRANSITION", () => $678968442832ddd5$export$ce125fc0306b71a0);
$parcel$export(module.exports, "BREAKDOWN_SPRINT_CAPACITY_BY", () => $678968442832ddd5$export$c773c9bd947df9ae);
$parcel$export(module.exports, "IPH_IDS", () => $678968442832ddd5$export$253194752488840a);
$parcel$export(module.exports, "INCLUDE_COMPLETED_ISSUE_FOR_DAYS", () => $87a0abe4cc67502d$export$6afdd25b4da87159);

var $17L5s = parcelRequire("17L5s");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");


const $678968442832ddd5$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
const $678968442832ddd5$export$1d279fd478aab274 = 'dd/MMM/yy';
const $678968442832ddd5$export$10b28f765b682c36 = 'yyyy-MM-dd';
const $678968442832ddd5$export$ce46174a69ff80b3 = 'DD MMM YYYY h:mma';
const $678968442832ddd5$export$4255b3d650213d61 = 'D MMM';
const $678968442832ddd5$export$cc2582ada357cd5 = 'D MMM YYYY';
const $678968442832ddd5$export$363270f5bff80927 = 'DDMMYYYY';
const $678968442832ddd5$export$c8c7cce628cf5c4e = 'SCEN-';
const $678968442832ddd5$export$4aabe0d20c9c03b3 = {
    AFTER: 'after',
    BEFORE: 'before'
};
const $678968442832ddd5$export$c56f9fa2106f4847 = {
    STORY_POINTS: 'StoryPoints',
    DAYS: 'Days',
    HOURS: 'Hours'
};
const $678968442832ddd5$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $678968442832ddd5$export$6d7021166edc895c = 'REPORTER';
const $678968442832ddd5$export$af1e30ebbae9df3b = 'COMPONENT';
const $678968442832ddd5$export$3d393c30a30490eb = 'GOALS';
const $678968442832ddd5$export$a75a0417fc96ea63 = 'IDEAS';
const $678968442832ddd5$export$7b04eb9e81ba1c56 = 'CROSS_PROJECT_RELEASE';
const $678968442832ddd5$export$76a449e52fa0e1e8 = 'ISSUE';
const $678968442832ddd5$export$37aee82a3cb1e8f7 = 'LABEL';
const $678968442832ddd5$export$c53d0f541b41b88e = 'NONE';
const $678968442832ddd5$export$fe791c4fa892e400 = 'PROJECT';
const $678968442832ddd5$export$5c698591c0e586a2 = 'RELEASE';
const $678968442832ddd5$export$84ba8fa7099b85b = 'RESOURCE';
const $678968442832ddd5$export$bc8b984358922f81 = 'TEAM';
const $678968442832ddd5$export$c3d7e0f1e63de60e = 'RANK';
const $678968442832ddd5$export$6e386ac144cffab5 = 'ASCENDING';
const $678968442832ddd5$export$f634ff5a7f1c8f3 = 'DESCENDING';
const $678968442832ddd5$export$a316570a0dbfd2b0 = 'SPRINT';
const $678968442832ddd5$export$3e0a40c59fa4032 = 'PLANNED_CAPACITY';
const $678968442832ddd5$export$e6952b12ade67489 = 'default';
const $678968442832ddd5$export$e0de529f548a9140 = 'lines';
const $678968442832ddd5$export$d61684373eacdf61 = 'count';
const $678968442832ddd5$export$fa20de1d199f87ac = {
    ISSUE: $678968442832ddd5$export$76a449e52fa0e1e8,
    RELEASE: $678968442832ddd5$export$5c698591c0e586a2,
    CROSS_PROJECT_RELEASE: $678968442832ddd5$export$7b04eb9e81ba1c56,
    TEAM: $678968442832ddd5$export$bc8b984358922f81,
    RESOURCE: $678968442832ddd5$export$84ba8fa7099b85b,
    PLANNED_CAPACITY: $678968442832ddd5$export$3e0a40c59fa4032,
    SPRINT: $678968442832ddd5$export$a316570a0dbfd2b0,
    NONE: $678968442832ddd5$export$c53d0f541b41b88e
};
const $678968442832ddd5$export$6952e648aa2551c8 = {
    ADDED: 'ADDED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED',
    NONE: 'NONE',
    MULTIPLE: 'MULTIPLE',
    EXCLUDED: 'EXCLUDED',
    ADDEDEXISTING: 'ADDEDEXISTING',
    UNKNOWN: 'UNKNOWN'
};
const $678968442832ddd5$export$a9c30cbc241a4f57 = {
    NONE: $678968442832ddd5$export$c53d0f541b41b88e,
    ASSIGNEE: $678968442832ddd5$export$f8f7545d2bb78afb,
    COMPONENT: $678968442832ddd5$export$af1e30ebbae9df3b,
    GOALS: $678968442832ddd5$export$3d393c30a30490eb,
    IDEAS: $678968442832ddd5$export$a75a0417fc96ea63,
    LABEL: $678968442832ddd5$export$37aee82a3cb1e8f7,
    PROJECT: $678968442832ddd5$export$fe791c4fa892e400,
    RELEASE: $678968442832ddd5$export$5c698591c0e586a2,
    REPORTER: $678968442832ddd5$export$6d7021166edc895c,
    TEAM: $678968442832ddd5$export$bc8b984358922f81,
    SPRINT: $678968442832ddd5$export$a316570a0dbfd2b0
};
const $678968442832ddd5$export$a0e01ba2ebef17f2 = 'string';
const $678968442832ddd5$export$501a7fac1df67a49 = 'date';
const $678968442832ddd5$export$4e8bcd47a31d751c = 'number';
const $678968442832ddd5$export$a8827164bd516a88 = {
    DATE: $678968442832ddd5$export$501a7fac1df67a49,
    STRING: $678968442832ddd5$export$a0e01ba2ebef17f2,
    NUMBER: $678968442832ddd5$export$4e8bcd47a31d751c
};
const $678968442832ddd5$export$2e66878530bcbbc7 = {
    ASCENDING: $678968442832ddd5$export$6e386ac144cffab5,
    DESCENDING: $678968442832ddd5$export$f634ff5a7f1c8f3
};
const $678968442832ddd5$export$cc61be5f9aa609ee = 'COMPLETED_SPRINTS_GROUP';
const $678968442832ddd5$export$93d3dc39c0269fe3 = 'COMPLETED_RELEASES_GROUP';
const $678968442832ddd5$var$UNRELEASED = '0';
const $678968442832ddd5$var$RELEASED = '1';
const $678968442832ddd5$var$OFFTRACK = '2';
const $678968442832ddd5$var$ONTRACK = '3';
const $678968442832ddd5$export$7082e4b62554b72d = {
    UNRELEASED: $678968442832ddd5$var$UNRELEASED,
    RELEASED: $678968442832ddd5$var$RELEASED,
    OFFTRACK: $678968442832ddd5$var$OFFTRACK,
    ONTRACK: $678968442832ddd5$var$ONTRACK
};
const $678968442832ddd5$export$311d2f5af921faaa = {
    [$678968442832ddd5$var$UNRELEASED]: 'inprogress',
    [$678968442832ddd5$var$RELEASED]: 'success',
    [$678968442832ddd5$var$OFFTRACK]: 'removed',
    [$678968442832ddd5$var$ONTRACK]: 'inprogress'
};
const $678968442832ddd5$export$331c42b4f42400fb = {
    AssetObject: (0, $cofZt.default)() ? 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype' : 'not-supported',
    TextField: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    SingleSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MultiSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    DatePicker: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
    NumberField: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    MultiCheckboxes: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    RadioButtons: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    UserPicker: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    Url: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    Labels: 'com.atlassian.jira.plugin.system.customfieldtypes:labels'
};
const $678968442832ddd5$export$fea945adb3660cc7 = {
    [$678968442832ddd5$export$331c42b4f42400fb.DatePicker]: $678968442832ddd5$export$a8827164bd516a88.DATE,
    [$678968442832ddd5$export$331c42b4f42400fb.NumberField]: $678968442832ddd5$export$a8827164bd516a88.NUMBER,
    [$678968442832ddd5$export$331c42b4f42400fb.SingleSelect]: $678968442832ddd5$export$a8827164bd516a88.STRING
};
const $678968442832ddd5$export$a1d1fd7da6e94a65 = {
    WritableFields: [
        $678968442832ddd5$export$331c42b4f42400fb.DatePicker,
        $678968442832ddd5$export$331c42b4f42400fb.Labels,
        $678968442832ddd5$export$331c42b4f42400fb.MultiCheckboxes,
        $678968442832ddd5$export$331c42b4f42400fb.MultiSelect,
        $678968442832ddd5$export$331c42b4f42400fb.NumberField,
        $678968442832ddd5$export$331c42b4f42400fb.RadioButtons,
        $678968442832ddd5$export$331c42b4f42400fb.SingleSelect,
        $678968442832ddd5$export$331c42b4f42400fb.TextField,
        $678968442832ddd5$export$331c42b4f42400fb.UserPicker
    ],
    ReadOnlyFields: [
        $678968442832ddd5$export$331c42b4f42400fb.Url,
        ...(0, $cofZt.default)() ? [
            $678968442832ddd5$export$331c42b4f42400fb.AssetObject
        ] : []
    ],
    FilterableFields: [
        $678968442832ddd5$export$331c42b4f42400fb.SingleSelect,
        $678968442832ddd5$export$331c42b4f42400fb.Labels,
        $678968442832ddd5$export$331c42b4f42400fb.MultiCheckboxes,
        $678968442832ddd5$export$331c42b4f42400fb.MultiSelect,
        $678968442832ddd5$export$331c42b4f42400fb.RadioButtons,
        ...(0, $cofZt.default)() ? [
            $678968442832ddd5$export$331c42b4f42400fb.AssetObject
        ] : []
    ],
    GroupableSingleValueFields: [
        $678968442832ddd5$export$331c42b4f42400fb.SingleSelect,
        $678968442832ddd5$export$331c42b4f42400fb.UserPicker
    ],
    GroupableMultiValueFields: [
        $678968442832ddd5$export$331c42b4f42400fb.Labels,
        $678968442832ddd5$export$331c42b4f42400fb.MultiSelect,
        ...(0, $cofZt.default)() ? [
            $678968442832ddd5$export$331c42b4f42400fb.AssetObject
        ] : []
    ]
};
const $678968442832ddd5$export$8ffcc37b9e9dd572 = 0.5;
const $678968442832ddd5$export$16f1a8408ee71016 = {
    TODO: 2,
    INPROGRESS: 4,
    DONE: 3
};
const $678968442832ddd5$export$2b1f4448b6b508db = {
    TODO: 2,
    INPROGRESS: 4,
    DONE: 3
};
const $678968442832ddd5$export$86fc137548f2fce5 = {
    [$678968442832ddd5$export$2b1f4448b6b508db.TODO]: 'default',
    [$678968442832ddd5$export$2b1f4448b6b508db.INPROGRESS]: 'inprogress',
    [$678968442832ddd5$export$2b1f4448b6b508db.DONE]: 'success'
};
const $678968442832ddd5$export$73a0206a4dc59760 = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};
const $678968442832ddd5$export$f1b6d0605ff9b7e6 = 'EXTERNAL_SPRINT';
const $678968442832ddd5$export$8c8dab1ad613072e = 3000;
const $678968442832ddd5$export$e5d805200f62f81d = {
    SMALL: 58,
    MEDIUM: 98,
    LARGE: 138,
    EXTRALARGE: 196
};
const $678968442832ddd5$export$6edf6d7514b31ffa = 40;
const $678968442832ddd5$export$a705d305be7bd15d = 440;
const $678968442832ddd5$export$9a8b9408dd2830b = 600;
const $678968442832ddd5$export$4cd768253686885b = 900;
const $678968442832ddd5$export$36a3ce28e91ef989 = 20;
const $678968442832ddd5$export$f777897e7e87cb69 = 'ALL_VALUES';
const $678968442832ddd5$export$2933446418f07e42 = 'EMPTY_VALUES_ONLY';
const $678968442832ddd5$export$de3ef5bf994b7018 = {
    ALL_VALUES: $678968442832ddd5$export$f777897e7e87cb69,
    EMPTY_VALUES_ONLY: $678968442832ddd5$export$2933446418f07e42
};
const $678968442832ddd5$export$f9c0c7ff9184db0 = {
    SPRINT: $678968442832ddd5$export$a316570a0dbfd2b0,
    RELEASE: $678968442832ddd5$export$5c698591c0e586a2,
    TEAM: $678968442832ddd5$export$bc8b984358922f81
};
const $678968442832ddd5$export$448fe702ac76034a = {
    storyPoints: 'StoryPoints',
    days: 'Days',
    hours: 'Hours'
};
const $678968442832ddd5$export$75989ea7860b85e9 = 'UNDEFINED';
const $678968442832ddd5$export$6bc4f75201f6f12e = 'sticky-header-cell';
const $678968442832ddd5$export$e3c19de1b019757c = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
};
const $678968442832ddd5$export$3bf3c26d6d69f3b1 = {
    VIEWER: 'Viewer',
    FULL_EDITOR: 'FullEditor',
    NON_PUBLISHING_EDITOR: 'NonPublishingEditor'
};
const $678968442832ddd5$export$40628b030ac72445 = {
    LINK: 'Link',
    EMBED: 'Embed',
    CONFLUENCE: 'Confluence',
    CSV: 'Csv',
    PNG: 'Png',
    DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
};
const $678968442832ddd5$export$5b1b1523594baa6e = {
    kanban: 'Kanban',
    scrum: 'Scrum'
};
const $678968442832ddd5$export$b4d5766fd1973953 = {
    ADMIN: 'Admin',
    EDITOR: 'Editor',
    VIEWER: 'Viewer',
    RESTRICTED_USER: 'Restricted'
};
const $678968442832ddd5$export$183f45c476faaff2 = {
    EDITOR: 'Editor',
    VIEWER: 'Viewer',
    REPORT_CONSUMER: 'ReportConsumer',
    CONFLUENCE_CONSUMER: 'ConfluenceConsumer'
};
const $678968442832ddd5$export$deea8c9ae0e3c1ca = {
    OUTWARD: 'outward',
    INWARD: 'inward'
};
const $678968442832ddd5$export$86e2f9653c14c34 = {
    PROJECT: 'Project',
    BOARD: 'Board',
    FILTER: 'Filter'
};
const $678968442832ddd5$export$5b6c28c7dca07ad7 = 'portfolio-3';
const $678968442832ddd5$export$d39436cd641938a9 = 'portfolio-3.create-plan-wizard';
const $678968442832ddd5$export$f048d91ccaf92408 = {
    COMMIT_CHANGES_TIME_TO_SAVE: 'commit-changes.time-to-save',
    COMMIT_CHANGES_TIME_TO_PERSIST: 'commit-changes.time-to-persist',
    RENDER_APP: 'page-plan.render-app',
    EXPORT_PNG: {
        INITIAL_PREVIEW: 'page-plan.export-png.initial-preview',
        SUBSEQUENT_PREVIEW: 'page-plan.export-png.subsequent-preview',
        EXPORT: 'page-plan.export-png.export'
    }
};
const $678968442832ddd5$export$4eb5c0330ef8fab4 = {
    RENDER: {
        SCOPE_TABLE: 'renderScopeTable'
    },
    EXPORT_PNG: {
        INITIAL_LOAD: 'page-plan.export-png.profile.initial-load',
        REACT_RENDER: 'page-plan.export-png.profile.react-render',
        PREPARE_FOR_EXPORT: 'page-plan.export-png.profile.prepare-for-export',
        CANVAS_RENDER: 'page-plan.export-png.profile.canvas-render'
    }
};
const $678968442832ddd5$export$b8b9d90f9e5bd72b = 'jiraPortfolio3Portfolio';
const $678968442832ddd5$export$f27a837467ec20e5 = {
    APP: 'app',
    ROADMAP: 'roadmapTab',
    TEAMS: 'teamsTab',
    RELEASES: 'releasesTab',
    DEPENDENCIES: 'dependenciesTab',
    SETTINGS: 'settings',
    REDUX: 'redux',
    REDUX_SAGA: 'reduxSaga',
    PLAN_WIZARD: 'planWizard',
    UNHANDLED: 'unhandled',
    ENVIRONMENT: 'environment',
    GIC: 'GIC'
};
const $678968442832ddd5$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $678968442832ddd5$export$bf7af18c7898a31 = 100;
const $678968442832ddd5$export$37e30ab04b9b1705 = {
    DEFAULT: $678968442832ddd5$export$e6952b12ade67489,
    LINES: $678968442832ddd5$export$e0de529f548a9140,
    COUNT: $678968442832ddd5$export$d61684373eacdf61
};
const $678968442832ddd5$export$e24665e8d921f93e = 1e6;
const $678968442832ddd5$export$22ed55708a9d1966 = {
    SOFTWARE: 'software',
    WORK_MANAGEMENT: 'business',
    SERVICE_MANAGEMENT: 'service_desk'
};
const $678968442832ddd5$export$8b7222fa92892b49 = {
    WEEKS: 'weeks',
    MONTHS: 'months',
    QUARTERS: 'quarters',
    YEARS: 'years'
};
const $678968442832ddd5$export$bbbec7054427e57b = {
    ...$678968442832ddd5$export$8b7222fa92892b49,
    CUSTOM: 'custom'
};
const $678968442832ddd5$export$b0f7807f8d64b44a = {
    SMALL: 14,
    MEDIUM: 93,
    LARGE: 364
};
const $678968442832ddd5$export$46a3b4b81e5a44ac = (0, $17L5s.ONE_DAY);
const $678968442832ddd5$export$e433769a2e1c823 = 1 / 7 * 100;
const $678968442832ddd5$export$954b02519e22ad3c = 'jira.user.arj.notify.watchers';
const $678968442832ddd5$export$cb60c924e8198091 = 'timeline';
const $678968442832ddd5$export$16c8656f8d888a96 = 'dependency-report';
const $678968442832ddd5$export$d37ffa307efd6838 = {
    MAIN: 'main-sections',
    FIELD: 'fields-section',
    LIST_MAIN: 'list-main-sections',
    LIST_FIELD: 'list-fields-section'
};
const $678968442832ddd5$export$cb4feb832f4bb576 = {
    SCOPE: 'scope-column',
    FIELDS: 'fields-column',
    TIMELINE: 'timeline-column'
};
const $678968442832ddd5$export$ce125fc0306b71a0 = {
    id: '__original_status_transition_id__',
    name: '__original_status_transition_name__'
};
const $678968442832ddd5$export$c773c9bd947df9ae = {
    STATUS: 'status',
    ESTIMATE: 'estimate'
};
const $678968442832ddd5$export$253194752488840a = {
    AUTO_SCHEDULE: '72BaKCMhh1aBiQprnER3pL',
    SHARE_CONFLUENCE: '8xdMiPoU4Fr4KWxzGJdXL',
    WARNING_CENTER: '5NX3sX9eqNEXSGhi4cMQ4L',
    SAVED_VIEWS: '636NO7TUPjErcJvohzMo9f',
    MANAGE_SAVED_VIEWS: '59mAhBw1bktXGV50c5c3ax',
    DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
    SUMMARY: '2lAziig1qpzuPCelr0CWB3',
    TEAMS: '30yplH4RxkjUZwmNwOxT2k',
    TEAM_CAPACITY: '1iT8GgcEZ2tikuwlnTq8Ij',
    DEPENDENCIES_REPORT: '2N5Dc7LkkoTjytZVPp9PQV',
    ISSUE_SOURCE: '1HTUp4iLEAeRVWDAI6pCaB',
    EXCLUSION_RULES: '2okV00HG5KCXjcw9oxv2kv',
    PERMISSIONS: '2GnX12bqw32MnTSVnDooC'
};

});
parcelRegister("17L5s", function(module, exports) {

$parcel$export(module.exports, "ONE_HOUR", () => $4b3e008bf73964f2$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $4b3e008bf73964f2$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_WEEK", () => $4b3e008bf73964f2$export$8187f416f1cc43d8);
$parcel$export(module.exports, "isISOCompatible", () => $4b3e008bf73964f2$export$19585d8c4023da60);
$parcel$export(module.exports, "dateDiffFromUTC", () => $4b3e008bf73964f2$export$c0a5d57ff50684cd);
$parcel$export(module.exports, "endOfUtcDay", () => $4b3e008bf73964f2$export$28816be40db3c661);
$parcel$export(module.exports, "startOfUtcDay", () => $4b3e008bf73964f2$export$5232bbb29ed7bb90);
$parcel$export(module.exports, "startOfUtcWeek", () => $4b3e008bf73964f2$export$beda72ac2de463b);
$parcel$export(module.exports, "startOfUtcMonth", () => $4b3e008bf73964f2$export$6f42959055abfd71);
$parcel$export(module.exports, "buildStartOfUtcQuarter", () => $4b3e008bf73964f2$export$2fc2f60e244962d8);
$parcel$export(module.exports, "buildStartOfUtcYear", () => $4b3e008bf73964f2$export$d9d30b5ea3d906ae);
$parcel$export(module.exports, "distanceInWordsWithPolarity", () => $4b3e008bf73964f2$export$6c9763c5fdf1d9bf);
$parcel$export(module.exports, "distanceInWordsToNowWithPolarity", () => $4b3e008bf73964f2$export$2b43273db3dc8a06);
$parcel$export(module.exports, "endOfUtcWeek", () => $4b3e008bf73964f2$export$cd5772ae045b582a);
$parcel$export(module.exports, "endOfUtcMonth", () => $4b3e008bf73964f2$export$7eaba70871f25263);
$parcel$export(module.exports, "buildEndOfUtcQuarter", () => $4b3e008bf73964f2$export$15d62cfd22087517);
$parcel$export(module.exports, "buildEndOfUtcYear", () => $4b3e008bf73964f2$export$ea7270449a050df5);
$parcel$export(module.exports, "getWorkingMillionSecondsBetweenTwoDates", () => $4b3e008bf73964f2$export$11174f5b39020529);
$parcel$export(module.exports, "convertShortFormatDate", () => $4b3e008bf73964f2$export$51353e55e1015915);
$parcel$export(module.exports, "distanceInWordsByShortFormat", () => $4b3e008bf73964f2$export$6fd795612f323dcc);
$parcel$export(module.exports, "getRelativeDates", () => $4b3e008bf73964f2$export$f1b9e31b5813ebf9);
$parcel$export(module.exports, "getWeekStartDay", () => $4b3e008bf73964f2$export$99291c0265ff1d37);
$parcel$export(module.exports, "addMonths", () => (parcelRequire("5STnX")).default);
$parcel$export(module.exports, "distanceInWords", () => (parcelRequire("j4tJJ")).default);
$parcel$export(module.exports, "isDateEqual", () => (parcelRequire("gctne")).default);
$parcel$export(module.exports, "subDays", () => (parcelRequire("9FEvp")).default);
$parcel$export(module.exports, "parse", () => (parcelRequire("5YjhU")).default);
$parcel$export(module.exports, "DateUnits", () => (parcelRequire("eTbtL")).DateUnits);

var $illlw = parcelRequire("illlw");

var $3KReq = parcelRequire("3KReq");

var $6wqPF = parcelRequire("6wqPF");
var $5STnX = parcelRequire("5STnX");
var $OwBos = parcelRequire("OwBos");
var $kqUc2 = parcelRequire("kqUc2");
var $d2wNG = parcelRequire("d2wNG");
var $6WQhi = parcelRequire("6WQhi");
var $EN9B6 = parcelRequire("EN9B6");
var $j4tJJ = parcelRequire("j4tJJ");
var $bo7IP = parcelRequire("bo7IP");
var $gRrfF = parcelRequire("gRrfF");
var $lUve5 = parcelRequire("lUve5");
var $dlGXX = parcelRequire("dlGXX");
var $gctne = parcelRequire("gctne");
var $dulT0 = parcelRequire("dulT0");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $3jYzf = parcelRequire("3jYzf");
var $jqhqi = parcelRequire("jqhqi");
var $sDHpG = parcelRequire("sDHpG");
var $9FEvp = parcelRequire("9FEvp");
var $4IszY = parcelRequire("4IszY");
var $5Jma3 = parcelRequire("5Jma3");

var $5oPVJ = parcelRequire("5oPVJ");

var $8K9kM = parcelRequire("8K9kM");

var $eTbtL = parcelRequire("eTbtL");

var $l2Sj2 = parcelRequire("l2Sj2");
const $4b3e008bf73964f2$export$82541edf19e5e3b0 = 3600000;
const $4b3e008bf73964f2$export$a97a1358cbb650ab = 86400000;
const $4b3e008bf73964f2$export$8187f416f1cc43d8 = 7 * $4b3e008bf73964f2$export$a97a1358cbb650ab;
const $4b3e008bf73964f2$export$3ff59674890cae52 = $4b3e008bf73964f2$export$a97a1358cbb650ab - 1;
const $4b3e008bf73964f2$export$5dddd410b460512a = /^\d{4}-\d{2}-\d{2}\s?/; // YYYY/MM/DD, YYYY/MM/DD GMT+0000
const $4b3e008bf73964f2$export$f5b73408663c3e14 = /^\d{2}\/\w{3}\/\d{2}\s?/; // DD/MMM/YY, DD/MMM/YY GMT+0000
const $4b3e008bf73964f2$export$63484a545c40ee32 = /^\d{2}\/\w{3}\/\d{4}\s?/; // DD/MMM/YYYY, DD/MMM/YYYY GMT+0000
const $4b3e008bf73964f2$export$ce02ba817385328 = (str)=>new Date(`${str} UTC`).getTime();
const $4b3e008bf73964f2$export$f7a957134186c558 = (date)=>{
    if ($4b3e008bf73964f2$export$5dddd410b460512a.test(date)) {
        const trimmedDate = date.substring(0, 10);
        return new Date(trimmedDate);
    }
    if ($4b3e008bf73964f2$export$63484a545c40ee32.test(date)) {
        const trimmedDate = date.substring(0, 11);
        const parsedDate = (0, $5YjhU.default)(trimmedDate, 'dd/MMM/yyyy', new Date());
        const time = parsedDate.getTime();
        const timeOffset = parsedDate.getTimezoneOffset() * 60000;
        return new Date(time - timeOffset);
    }
    // convert DD/MMM/YY to ISO Date for datepicker
    if ($4b3e008bf73964f2$export$f5b73408663c3e14.test(date)) {
        const trimmedDate = date.substring(0, 9);
        const parsedDate = (0, $5YjhU.default)(trimmedDate, 'dd/MMM/yy', new Date());
        const time = parsedDate.getTime();
        const timeOffset = parsedDate.getTimezoneOffset() * 60000;
        return new Date(time - timeOffset);
    }
    throw new Error(`Non ISO date format provided to create UTC date: ${date}`);
};
const $4b3e008bf73964f2$export$19585d8c4023da60 = (date)=>$4b3e008bf73964f2$export$f5b73408663c3e14.test(date) || $4b3e008bf73964f2$export$5dddd410b460512a.test(date);
const $4b3e008bf73964f2$export$c0a5d57ff50684cd = ()=>{
    const now = new Date();
    const tzInHours = -now.getTimezoneOffset() / 60; // Timezone offset is in minutes, time in timezone +10:00 has -600 timezone offset
    const utcHours = (now.getHours() + now.getMinutes() / 60 - tzInHours + 24) % 24;
    if (utcHours + tzInHours > 24) return 1;
    if (utcHours + tzInHours < 0) return -1;
    return 0;
};
const $4b3e008bf73964f2$export$28816be40db3c661 = (date)=>new Date($5oPVJ.default(Number, date) ? date : $4b3e008bf73964f2$export$f7a957134186c558(date.toString())).setUTCHours(23, 59, 59, 999);
const $4b3e008bf73964f2$export$5232bbb29ed7bb90 = (date)=>new Date($5oPVJ.default(Number, date) ? date : $4b3e008bf73964f2$export$f7a957134186c558(date.toString())).setUTCHours(0, 0, 0, 0);
const $4b3e008bf73964f2$export$beda72ac2de463b = (value)=>{
    const startOfDay = $4b3e008bf73964f2$export$5232bbb29ed7bb90(new Date(value).getTime());
    const dayOfWeek = new Date(startOfDay).getUTCDay();
    const millisecondsToSubstract = $4b3e008bf73964f2$export$a97a1358cbb650ab * dayOfWeek;
    const date = new Date(startOfDay - millisecondsToSubstract);
    const year = date.getUTCFullYear();
    const month = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(`${date.getUTCMonth() + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const day = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(`${date.getUTCDate()}`, 2, '0');
    const startOfWeek = new Date(`${year}-${month}-${day}T00:00:00Z`);
    return startOfWeek;
};
const $4b3e008bf73964f2$export$6f42959055abfd71 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const month = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(`${date.getUTCMonth() + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const startOfMonth = new Date(`${year}-${month}-01T00:00:00Z`);
    return startOfMonth;
};
const $4b3e008bf73964f2$export$f8d6d59f9413fa73 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const UTCmonth = date.getUTCMonth();
    let month;
    if (UTCmonth >= 0 && UTCmonth <= 2) month = '01';
    else if (UTCmonth >= 3 && UTCmonth <= 5) month = '04';
    else if (UTCmonth >= 6 && UTCmonth <= 8) month = '07';
    else month = '10';
    const startOfQuarter = new Date(`${year}-${month}-01T00:00:00Z`);
    return startOfQuarter;
};
const $4b3e008bf73964f2$export$2fc2f60e244962d8 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // UTC month starts from 0
        const nextFYStartMonth = fyStartMonth + 12;
        let firstMonthOfThisQuarter = nextFYStartMonth;
        // stop when month >= firstMonthOfThisQuarter
        while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
        const willWrapToPreviousYear = firstMonthOfThisQuarter < 1;
        const dateString = `${willWrapToPreviousYear ? year - 1 : year}-${willWrapToPreviousYear ? 12 + firstMonthOfThisQuarter : `0${firstMonthOfThisQuarter}`.slice(-2)}-01T00:00:00Z`;
        return new Date(dateString);
    };
const $4b3e008bf73964f2$export$fea0669370045ef2 = (value)=>{
    const date = new Date(value);
    const startOfYear = new Date(`${date.getUTCFullYear()}-01-01T00:00:00Z`);
    return startOfYear;
};
const $4b3e008bf73964f2$export$d9d30b5ea3d906ae = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        const currentUtcMonth = date.getUTCMonth() + 1; // zero-based
        return new Date(`${currentUtcYear - (currentUtcMonth >= fyStartMonth ? 0 : 1)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`);
    };
/*
This hack is needed to make certain date-fns functions work in Jira.

In Jira `Date.prototype.setFullYear()` is overridden by an old JS library called JSCal2 (http://www.dynarch.com/jscal/).
The overridden setFullYear does not pass all the arguments through to the original method. This causes some date-fn functions to break.

To fix this problem, we re-override JSCal2's setFullYear() function to handle all parameters properly. This ensures
that any Jira code that uses that library should continue working.
*/ const $4b3e008bf73964f2$export$55d224f4c8cb5e91 = ()=>{
    if (Date.prototype.__msh_oldSetFullYear) // Need to disable linting and flow because we're overwriting a native method
    /* eslint-disable no-extend-native */ Date.prototype.setFullYear = function setFullYear(...args) {
        const d = new Date(this);
        d.__msh_oldSetFullYear && d.__msh_oldSetFullYear.call(d, ...args);
        if (d.getMonth() !== this.getMonth()) this.setDate(28);
        return this.__msh_oldSetFullYear ? this.__msh_oldSetFullYear.call(this, ...args) : Number.NaN;
    };
};
if (document.readyState === 'loading') // This happens in production. JSCal2 is loaded after Portfolio, so we need to execute our fix after DOMContentLoaded
document.addEventListener('DOMContentLoaded', $4b3e008bf73964f2$export$55d224f4c8cb5e91);
else // This happens in in development (i.e. `gulp watch`). JSCal2 is already loaded and DOMContentLoaded has already fired.
// So we immediately execute the fix.
$4b3e008bf73964f2$export$55d224f4c8cb5e91();
const $4b3e008bf73964f2$export$6c9763c5fdf1d9bf = (fromDate, toDate, locale)=>{
    const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
    const distanceStr = (0, $j4tJJ.default)(toDate, fromDate, {
        locale: locale !== undefined ? (0, $8K9kM.getLocale)(locale) : undefined
    });
    return distanceStr.split(' ').map((str)=>Number.isNaN(Number(str)) ? str : `${sign}${str}`).join(' ');
};
const $4b3e008bf73964f2$export$2b43273db3dc8a06 = (locale, date)=>$4b3e008bf73964f2$export$6c9763c5fdf1d9bf(Date.now(), date, locale);
const $4b3e008bf73964f2$export$cd5772ae045b582a = (value)=>{
    const startOfWeek = $4b3e008bf73964f2$export$beda72ac2de463b(value);
    const endOfWeek = startOfWeek.getTime() + 7 * $4b3e008bf73964f2$export$a97a1358cbb650ab - 1;
    return new Date(endOfWeek);
};
const $4b3e008bf73964f2$export$7eaba70871f25263 = (value)=>{
    const date = new Date(value);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth();
    month++;
    if (month > 11) {
        month = 0;
        year++;
    }
    const paddedMonth = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(`${month + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const firstDayOfNextYear = new Date(`${year}-${paddedMonth}-01T00:00:00.000Z`);
    const endOfYear = new Date(firstDayOfNextYear.getTime() - 1);
    return endOfYear;
};
const $4b3e008bf73964f2$export$893511aa1d64d04 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const UTCmonth = date.getUTCMonth();
    let month;
    let day = '31';
    if (UTCmonth >= 0 && UTCmonth <= 2) month = '03';
    else if (UTCmonth >= 3 && UTCmonth <= 5) {
        month = '06';
        day = '30';
    } else if (UTCmonth >= 6 && UTCmonth <= 8) {
        month = '09';
        day = '30';
    } else month = '12';
    const lastDayOfQuarter = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
    return lastDayOfQuarter;
};
const $4b3e008bf73964f2$export$15d62cfd22087517 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // UTC month starts from 0
        const nextFYStartMonth = fyStartMonth + 12;
        let firstMonthOfThisQuarter = nextFYStartMonth;
        while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
        const firstMonthOfNextQuarter = firstMonthOfThisQuarter + 3;
        const willWrapToNextYear = firstMonthOfNextQuarter > 12;
        if (willWrapToNextYear) return new Date(new Date(`${year + 1}-0${firstMonthOfNextQuarter % 12}-01T00:00:00Z`).getTime() - 1);
        return new Date(new Date(`${year}-${`0${firstMonthOfNextQuarter}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
    };
const $4b3e008bf73964f2$export$73a64972c33eed9e = (value)=>{
    const date = new Date(value);
    const currentUtcYear = date.getUTCFullYear();
    return new Date(`${currentUtcYear}-12-31T23:59:59.999Z`);
};
const $4b3e008bf73964f2$export$ea7270449a050df5 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        const currentUtcMonth = date.getUTCMonth() + 1; // zero-based
        return new Date(new Date(`${currentUtcYear + (currentUtcMonth >= fyStartMonth ? 1 : 0)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
    };
const $4b3e008bf73964f2$export$66ad6b2cba030df5 = (startTime, endTime)=>(0, $gctne.default)($4b3e008bf73964f2$export$beda72ac2de463b(startTime), $4b3e008bf73964f2$export$beda72ac2de463b(endTime));
const $4b3e008bf73964f2$export$dbbb7786eda0de5f = (value)=>{
    const startTimeOfUtcWeek = $4b3e008bf73964f2$export$beda72ac2de463b(value).getTime();
    return {
        start: startTimeOfUtcWeek + $4b3e008bf73964f2$export$a97a1358cbb650ab,
        end: startTimeOfUtcWeek + 6 * $4b3e008bf73964f2$export$a97a1358cbb650ab
    };
};
const $4b3e008bf73964f2$export$11174f5b39020529 = (startTime, endTime)=>{
    const { start: startWorkingTimeOfStartTime, end: endWorkingTimeOfStartTime } = $4b3e008bf73964f2$export$dbbb7786eda0de5f(startTime);
    // if the startTime and endTime is in the same week
    if ($4b3e008bf73964f2$export$66ad6b2cba030df5(startTime, endTime)) {
        if (endTime < startWorkingTimeOfStartTime || startTime > endWorkingTimeOfStartTime) return 0;
        return Math.min(endWorkingTimeOfStartTime, endTime) - Math.max(startWorkingTimeOfStartTime, startTime);
    }
    const { start: startWorkingTimeOfEndTime, end: endWorkingTimeOfEndTime } = $4b3e008bf73964f2$export$dbbb7786eda0de5f(endTime);
    const weeks = Math.floor((startWorkingTimeOfEndTime - endWorkingTimeOfStartTime) / $4b3e008bf73964f2$export$8187f416f1cc43d8);
    const workingMillionSecondsOfMiddleWeeks = weeks * (5 * $4b3e008bf73964f2$export$a97a1358cbb650ab);
    const workingMillionSecondsOfFirstWeek = startTime > endWorkingTimeOfStartTime ? 0 : endWorkingTimeOfStartTime - Math.max(startTime, startWorkingTimeOfStartTime);
    const workingMillionSecondsOfLastWeek = endTime < startWorkingTimeOfEndTime ? 0 : Math.min(endTime, endWorkingTimeOfEndTime) - startWorkingTimeOfEndTime;
    return workingMillionSecondsOfFirstWeek + workingMillionSecondsOfLastWeek + workingMillionSecondsOfMiddleWeeks;
};
/**
 * Unify the singular and plural english date unit to singular unit. like months -> month, days -> day, years -> year
 * @param unitStr
 * @returns
 */ const $4b3e008bf73964f2$var$getUnifiedEnglishDateUnit = (unitStr)=>{
    const regx = /((\w+)(?=s))|([^s]+)/g;
    const resultArr = unitStr.match(regx);
    if (Array.isArray(resultArr) && resultArr.length > 0) return resultArr[0];
    return unitStr;
};
const $4b3e008bf73964f2$export$51353e55e1015915 = (number, unit, localeStr)=>new Intl.NumberFormat(localeStr, {
        style: 'unit',
        unit: unit,
        unitDisplay: 'narrow'
    }).format(number);
const $4b3e008bf73964f2$export$6fd795612f323dcc = (fromDate, toDate, localeStr)=>{
    const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
    // step1: get the distanceStr which is only english without locale
    const distanceStr = (0, $j4tJJ.default)(toDate, fromDate);
    // step2: split to array, the last element of this array is the unit, it can be day/days, 'year/years','month/months'
    const distanceStrArray = distanceStr.split(' ');
    const locale = (0, $8K9kM.getLocale)(localeStr);
    if (distanceStrArray.length === 2) {
        // step3: unitfy the english unit day/days->day, 'year/years'->year,'month/months'->month
        const unit = $4b3e008bf73964f2$var$getUnifiedEnglishDateUnit(distanceStrArray[1]);
        const number = distanceStrArray[0];
        // step4: callconvertShortFormatDate(Number(number), unit, locale.code) to i18n the dates. English unit is for the  new Intl.NumberFormat method
        return `${sign}${$4b3e008bf73964f2$export$51353e55e1015915(Number(number), unit, locale.code)}`;
    }
    if (distanceStrArray.length === 3) {
        // get the localised suffix which can be above/almost/over, refer to https://date-fns.org/v2.30.0/docs/formatDistance
        const suffix = (0, $j4tJJ.default)(toDate, fromDate, {
            locale: locale
        }).split(' ')[0];
        const number = distanceStrArray[1];
        const unit = $4b3e008bf73964f2$var$getUnifiedEnglishDateUnit(distanceStrArray[2]);
        return `${suffix} ${sign}${$4b3e008bf73964f2$export$51353e55e1015915(Number(number), unit, locale.code)}`;
    }
    return distanceStr;
};
const $4b3e008bf73964f2$export$f1b9e31b5813ebf9 = ({ toNowUnitCount: toNowUnitCount = 0, fromNowUnitCount: fromNowUnitCount = 0, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit }, today)=>{
    const start = toNowUnit === (0, $eTbtL.DateUnits).WEEKS ? (0, $5Jma3.default)(today, toNowUnitCount) : (0, $4IszY.default)(today, toNowUnitCount);
    const end = fromNowUnit === (0, $eTbtL.DateUnits).WEEKS ? (0, $kqUc2.default)(today, fromNowUnitCount) : (0, $5STnX.default)(today, fromNowUnitCount);
    // relative time range should include current day
    // if relative time range is 0 before the current day amd 0 after the current day
    // then timeline should include at least 1 day
    if (toNowUnitCount === 0 && fromNowUnitCount === 0) return {
        start: $4b3e008bf73964f2$export$5232bbb29ed7bb90(start.getTime()),
        end: $4b3e008bf73964f2$export$28816be40db3c661(end.getTime())
    };
    // if relative time range is any range before the current day and any range after the current day
    // or only before the current day then add the current day
    if (toNowUnitCount && fromNowUnitCount || toNowUnitCount) return {
        start: $4b3e008bf73964f2$export$5232bbb29ed7bb90((0, $6wqPF.default)(start, 1).getTime()),
        end: $4b3e008bf73964f2$export$28816be40db3c661(end.getTime())
    };
    return {
        start: $4b3e008bf73964f2$export$5232bbb29ed7bb90(start.getTime()),
        end: $4b3e008bf73964f2$export$28816be40db3c661((0, $9FEvp.default)(end, 1).getTime())
    };
};
const $4b3e008bf73964f2$export$99291c0265ff1d37 = (locale)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))((0, $8K9kM.getLocale)(locale), 'options.weekStartsOn', (0, $eTbtL.DEFAULT_WEEK_START_DAY));

});
parcelRegister("3KReq", function(module, exports) {

var $e9ydl = parcelRequire("e9ydl");

var $eQiJU = parcelRequire("eQiJU");

var $hNahz = parcelRequire("hNahz");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */ function $2bbef5aa3752aacb$var$padStart(string, length, chars) {
    string = $1uqnh(string);
    length = $hNahz(length);
    var strLength = length ? $eQiJU(string) : 0;
    return length && strLength < length ? $e9ydl(length - strLength, chars) + string : string;
}
module.exports = $2bbef5aa3752aacb$var$padStart;

});
parcelRegister("e9ydl", function(module, exports) {

var $f6TjR = parcelRequire("f6TjR");

var $TLr3n = parcelRequire("TLr3n");

var $8SGvQ = parcelRequire("8SGvQ");

var $fFFC0 = parcelRequire("fFFC0");

var $eQiJU = parcelRequire("eQiJU");

var $aSldm = parcelRequire("aSldm");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a4dc722e2594635e$var$nativeCeil = Math.ceil;
/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */ function $a4dc722e2594635e$var$createPadding(length, chars) {
    chars = chars === undefined ? ' ' : $TLr3n(chars);
    var charsLength = chars.length;
    if (charsLength < 2) return charsLength ? $f6TjR(chars, length) : chars;
    var result = $f6TjR(chars, $a4dc722e2594635e$var$nativeCeil(length / $eQiJU(chars)));
    return $fFFC0(chars) ? $8SGvQ($aSldm(result), 0, length).join('') : result.slice(0, length);
}
module.exports = $a4dc722e2594635e$var$createPadding;

});
parcelRegister("f6TjR", function(module, exports) {
/** Used as references for various `Number` constants. */ var $b00253cd6c3460b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b00253cd6c3460b9$var$nativeFloor = Math.floor;
/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */ function $b00253cd6c3460b9$var$baseRepeat(string, n) {
    var result = '';
    if (!string || n < 1 || n > $b00253cd6c3460b9$var$MAX_SAFE_INTEGER) return result;
    // Leverage the exponentiation by squaring algorithm for a faster repeat.
    // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
    do {
        if (n % 2) result += string;
        n = $b00253cd6c3460b9$var$nativeFloor(n / 2);
        if (n) string += string;
    }while (n);
    return result;
}
module.exports = $b00253cd6c3460b9$var$baseRepeat;

});

parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});




parcelRegister("5oPVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ee779e3e7fec9cf$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $3ee779e3e7fec9cf$var$is = /*#__PURE__*/ (0, $ggdJA.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
var $3ee779e3e7fec9cf$export$2e2bcd8739ae039 = $3ee779e3e7fec9cf$var$is;

});

parcelRegister("eTbtL", function(module, exports) {

$parcel$export(module.exports, "longDateFormat", () => $fadd5b9df95b4958$export$7bc415832e79e22c);
$parcel$export(module.exports, "dateMonthFormat", () => $fadd5b9df95b4958$export$f9c3f52e4a5f8635);
$parcel$export(module.exports, "longDateTimeFormat", () => $fadd5b9df95b4958$export$f2f390060309965);
$parcel$export(module.exports, "shortDateFormat", () => $fadd5b9df95b4958$export$1a445e44d9863af);
$parcel$export(module.exports, "weekdayFormat", () => $fadd5b9df95b4958$export$faf60e60fca9bed1);
$parcel$export(module.exports, "weekdayFormatLong", () => $fadd5b9df95b4958$export$a28e4d9035dd351c);
$parcel$export(module.exports, "DateUnits", () => $fadd5b9df95b4958$export$c7e7da0fa6bb60a7);
$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $fadd5b9df95b4958$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DefaultDateFormat", () => $fadd5b9df95b4958$export$14ae725d0cc7daa1);
$parcel$export(module.exports, "IsoDateFormat", () => $fadd5b9df95b4958$export$7288711b5316ff78);
$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $fadd5b9df95b4958$export$845e1054649a85c2);
/**
 * UTC Long format of a date, eg "13 Jul 2023"
 */ const $fadd5b9df95b4958$export$7bc415832e79e22c = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$f9c3f52e4a5f8635 = {
    day: '2-digit',
    month: 'short',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$352fb2bc78f82ff2 = {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$1a445e44d9863af = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$faf60e60fca9bed1 = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$a28e4d9035dd351c = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $fadd5b9df95b4958$export$c7e7da0fa6bb60a7 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $fadd5b9df95b4958$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $fadd5b9df95b4958$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
const $fadd5b9df95b4958$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $fadd5b9df95b4958$export$845e1054649a85c2 = 0; // Sunday

});

parcelRegister("l2Sj2", function(module, exports) {

$parcel$export(module.exports, "getDayLabel", () => $771b2724562e6dfd$export$77c6667acb2335c);
$parcel$export(module.exports, "getMonthLabel", () => $771b2724562e6dfd$export$5492c4ce9d26d774);
$parcel$export(module.exports, "formatDateUTC", () => $771b2724562e6dfd$export$f6ec9a122d9a3697);
$parcel$export(module.exports, "formatTimestampWithIntl", () => $771b2724562e6dfd$export$a70c08d756ec4ebf);
$parcel$export(module.exports, "formatDateWithIntl", () => $771b2724562e6dfd$export$41d39199b76e5fba);
$parcel$export(module.exports, "useDateFormatter", () => $771b2724562e6dfd$export$85fd5fdf27bacc79);

var $eUqFw = parcelRequire("eUqFw");

var $7ueqz = parcelRequire("7ueqz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eTbtL = parcelRequire("eTbtL");
const $771b2724562e6dfd$export$32db56fbc0b29120 = (day)=>{
    switch(day){
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        default:
            return 'Saturday';
    }
};
const $771b2724562e6dfd$export$e5b0222dbac9656 = (month)=>{
    switch(month){
        case 0:
            return 'January';
        case 1:
            return 'February';
        case 2:
            return 'March';
        case 3:
            return 'April';
        case 4:
            return 'May';
        case 5:
            return 'June';
        case 6:
            return 'July';
        case 7:
            return 'August';
        case 8:
            return 'September';
        case 9:
            return 'October';
        case 10:
            return 'November';
        default:
            return 'December';
    }
};
const $771b2724562e6dfd$export$77c6667acb2335c = (day)=>$771b2724562e6dfd$export$32db56fbc0b29120(day).substr(0, 3);
const $771b2724562e6dfd$export$5492c4ce9d26d774 = (month)=>$771b2724562e6dfd$export$e5b0222dbac9656(month).substr(0, 3);
const $771b2724562e6dfd$export$b27aef2de915d062 = (format)=>{
    let stringFormat = format;
    let match;
    let parts = [];
    const DATE_FORMATS_SPLIT = /((?:[^YMDHhmsaAZzE']+)|(?:'(?:[^']|'')*')|(?:E+|Y+|M+|D+|H+|h+|m+|s+|a|A|Z|z))(.*)/;
    const slice = [].slice;
    const concatMethod = (array1, array2, index)=>array1.concat(slice.call(array2, index));
    while(stringFormat){
        match = DATE_FORMATS_SPLIT.exec(stringFormat);
        if (match) {
            parts = concatMethod(parts, match, 1);
            stringFormat = parts.pop();
        } else {
            parts.push(format);
            stringFormat = null;
        }
    }
    return parts;
};
const $771b2724562e6dfd$export$f6ec9a122d9a3697 = (time, format)=>{
    const date = new Date(time);
    if (!(0, $7ueqz.default)(date)) throw new Error('Date passed to formatDateUTC function is not valid');
    // get individual values
    const dayOfWeekIndex = date.getUTCDay();
    const month = date.getUTCMonth();
    const fullYear = date.getUTCFullYear().toString();
    const fullMonth = $771b2724562e6dfd$export$e5b0222dbac9656(month);
    const shortMonth = $771b2724562e6dfd$export$5492c4ce9d26d774(month);
    const digitMonth = month + 1;
    const hour = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const formatArray = $771b2724562e6dfd$export$b27aef2de915d062(format);
    // TODO: getFormatVal is hardcoded to date-fns v.1.x.x format should be reimplemented by owners team
    // pick individual parts of the date format
    const getFormatVal = (part)=>{
        let val;
        switch(part){
            case 'YYYY':
                // 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
                val = fullYear.padStart(4, '0');
                break;
            case 'YY':
                // 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01)
                val = fullYear.padStart(4, '0').substr(-2);
                break;
            case 'MMMM':
                // Month in year (January-December)
                val = fullMonth;
                break;
            case 'MMM':
                // Month in year (Jan-Dec)
                val = shortMonth;
                break;
            case 'MM':
                // Month in year (01-12)
                val = digitMonth.toString().padStart(2, '0');
                break;
            case 'M':
                // Month in year (1-12)
                val = digitMonth;
                break;
            case 'EEEE':
                // Day in Week,(Sunday-Saturday)
                val = $771b2724562e6dfd$export$32db56fbc0b29120(dayOfWeekIndex);
                break;
            case 'EEE':
                // Day in Week, (Sun-Sat)
                val = $771b2724562e6dfd$export$77c6667acb2335c(dayOfWeekIndex);
                break;
            case 'DD':
                // Day in month (01-31)
                val = date.getUTCDate().toString().padStart(2, '0');
                break;
            case 'D':
                // Day in month (1-31)
                val = date.getUTCDate();
                break;
            case 'hh':
                // Hour in AM/PM (01-12)
                val = 12;
                if (hour !== 0) {
                    const diff = hour - 12;
                    val = diff > 0 ? diff.toString().padStart(2, '0') : hour.toString().padStart(2, '0');
                }
                break;
            case 'h':
                // Hour in AM/PM, (1-12)
                val = 12;
                if (hour !== 0) val = hour > 12 ? hour - 12 : hour;
                break;
            case 'HH':
                // Hour in day (00-23)
                val = hour.toString().padStart(2, '0');
                break;
            case 'H':
                // Hour in day (0-23)
                val = hour;
                break;
            case 'mm':
                // Minute in hour (00-59)
                val = minutes.toString().padStart(2, '0');
                break;
            case 'm':
                // Minute in hour (0-59)
                val = minutes;
                break;
            case 'ss':
                // Seconds in minute (00-59)
                val = seconds.toString().padStart(2, '0');
                break;
            case 's':
                // Seconds in minute (0-59)
                val = seconds;
                break;
            case 'a':
                val = hour >= 12 ? 'pm' : 'am';
                break;
            case 'A':
                val = hour >= 12 ? 'PM' : 'AM';
                break;
            default:
                val = part;
        }
        val = typeof val !== 'undefined' ? val.toString() : part;
        return val;
    };
    let dateVal = '';
    formatArray.forEach((part)=>{
        dateVal += getFormatVal(part);
    });
    return dateVal;
};
const $771b2724562e6dfd$export$a70c08d756ec4ebf = (intl, timestamp, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $eTbtL.longDateFormat))=>intl.formatDate(timestamp, formatOptions);
const $771b2724562e6dfd$export$41d39199b76e5fba = (intl, iso, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $eTbtL.longDateFormat))=>{
    const date = new Date(iso);
    return intl.formatDate(date.getTime(), formatOptions);
};
const $771b2724562e6dfd$export$85fd5fdf27bacc79 = ()=>{
    const intl = (0, $5JgJ2.default)();
    const formatTimestamp = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (timestamp, formatOptions)=>$771b2724562e6dfd$export$a70c08d756ec4ebf(intl, timestamp, formatOptions), [
        intl
    ]);
    const formatDate = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (iso, formatOptions)=>{
        const date = new Date(iso);
        return $771b2724562e6dfd$export$a70c08d756ec4ebf(intl, date.getTime(), formatOptions);
    }, [
        intl
    ]);
    return {
        formatTimestamp: formatTimestamp,
        formatDate: formatDate
    };
};

});


parcelRegister("bJc6r", function(module, exports) {

$parcel$export(module.exports, "getCommitScenarioChangesBatchSize", () => (parcelRequire("dsqWN")).default);
$parcel$export(module.exports, "getTtiExcludedUsers", () => (parcelRequire("l9Wts")).default);
$parcel$export(module.exports, "isAssetCustomFieldForInternalEnabled", () => (parcelRequire("cofZt")).default);
$parcel$export(module.exports, "isArjGicPrefilledDataHandlingEnabled", () => (parcelRequire("hs46g")).default);
$parcel$export(module.exports, "isMigrateArjTeamsToPlatformTeamsEnabled", () => (parcelRequire("430Oj")).default);
$parcel$export(module.exports, "isPlatformTeamsSiteScopedM1Enabled", () => (parcelRequire("1eATi")).default);
$parcel$export(module.exports, "isPollinatorTenant", () => (parcelRequire("8bnQD")).default);
/**
 * All new feature flags should use this convention.
 *
 * Are we crazy?
 * There were 2 main issues with exporting feature flags directly from this file.
 * 1. We got a lot of merge conflicts, because devs all tend to add new flags to the bottom.
 * 2. It's hard to mock feature flags independently in tests (you have to mock all flags that are evaluated during your tests).
 * Read the proposal - https://hello.atlassian.net/wiki/spaces/AG/pages/792046806/Discussion+-+Front+End+Avoiding+the+developer+experience+pitfalls+of+feature+flags
 */ 
var $dsqWN = parcelRequire("dsqWN");

var $l9Wts = parcelRequire("l9Wts");

var $hs46g = parcelRequire("hs46g");

var $cofZt = parcelRequire("cofZt");

var $430Oj = parcelRequire("430Oj");

var $1eATi = parcelRequire("1eATi");

var $8bnQD = parcelRequire("8bnQD");

});
parcelRegister("dsqWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4b4fd34374dbfc9$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
const $b4b4fd34374dbfc9$var$getCommitScenarioChangesBatchSize = ()=>Number((0, $1ybV0.getFeatureFlagValue)('com.atlassian.rm.jpo.jpo3cloud.commit-scenario-changes-batch-size', 5));
var $b4b4fd34374dbfc9$export$2e2bcd8739ae039 = $b4b4fd34374dbfc9$var$getCommitScenarioChangesBatchSize;

});

parcelRegister("l9Wts", function(module, exports) {

$parcel$export(module.exports, "default", () => $318d7047a1e194d5$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");
/**
 * Get a list of account id's that should be excluded from time to interactive reporting
 */ const $318d7047a1e194d5$var$getTtiExcludedUsers = ()=>{
    // https://app.launchdarkly.com/jira/production/features/com.atlassian.rm.jpo.jpo3cloud.ttiExcludedUsers/targeting
    const flagValue = (0, $1ybV0.getFeatureFlagValue)('com.atlassian.rm.jpo.jpo3cloud.ttiExcludedUsers', '');
    return typeof flagValue === 'string' && flagValue ? flagValue.split(',') : [];
};
var $318d7047a1e194d5$export$2e2bcd8739ae039 = $318d7047a1e194d5$var$getTtiExcludedUsers;

});

parcelRegister("hs46g", function(module, exports) {

$parcel$export(module.exports, "default", () => $f10c77fc86105580$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
const $f10c77fc86105580$var$isArjGicPrefilledDataHandlingEnabled = ()=>(0, $dtKCx.getBooleanFeatureFlag)('arj.gic-pre-filled-data-handling_pkvuc', false);
var $f10c77fc86105580$export$2e2bcd8739ae039 = $f10c77fc86105580$var$isArjGicPrefilledDataHandlingEnabled;

});

parcelRegister("cofZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce197540dcaf3524$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
/**
 * this is a permanent feature flag and its feature only enabled for our internal hello customers
 * https://hello.atlassian.net/wiki/spaces/~388547371/pages/2866539946/ARJ+-+Asset+Field+-+Software+Requirement+Spec
 */ const $ce197540dcaf3524$var$isAssetCustomFieldForInternalEnabled = ()=>(0, $dtKCx.getBooleanFeatureFlag)('asset-custom-field-internal-support_an36a');
var $ce197540dcaf3524$export$2e2bcd8739ae039 = $ce197540dcaf3524$var$isAssetCustomFieldForInternalEnabled;

});

parcelRegister("430Oj", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7633ffe64ef5c3$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
const $aa7633ffe64ef5c3$export$e8b71221dec26433 = ()=>'com.atlassian.rm.jpo.jpo3cloud.migrateToAtlassianTeams';
const $aa7633ffe64ef5c3$export$f526d68ea51e9947 = ()=>'com.atlassian.rm.jpo.jpo3cloud.migrate-to-atlassian-teams-rollout';
/*
 * Checks if either flag is true
 * When second feature flag is to rollout to 100% prior to migration, the frontend will reliant only on useTwpTeams
 */ const $aa7633ffe64ef5c3$var$isMigrateArjTeamsToPlatformTeamsEnabled = ()=>(0, $dtKCx.getBooleanFeatureFlag)($aa7633ffe64ef5c3$export$e8b71221dec26433(), false, true) || (0, $dtKCx.getBooleanFeatureFlag)($aa7633ffe64ef5c3$export$f526d68ea51e9947(), false, true);
var $aa7633ffe64ef5c3$export$2e2bcd8739ae039 = $aa7633ffe64ef5c3$var$isMigrateArjTeamsToPlatformTeamsEnabled;

});

parcelRegister("1eATi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ede7439e319979$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
const $a8ede7439e319979$var$isPlatformTeamsSiteScopedM1Enabled = ()=>(0, $dtKCx.getBooleanFeatureFlag)('platform.teams.site-scoped.m1', false, true);
var $a8ede7439e319979$export$2e2bcd8739ae039 = $a8ede7439e319979$var$isPlatformTeamsSiteScopedM1Enabled;

});

parcelRegister("8bnQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3a35fae17b0a09$export$2e2bcd8739ae039);

var $dtKCx = parcelRequire("dtKCx");
const $ac3a35fae17b0a09$var$isPollinatorTenant = ()=>(0, $dtKCx.getBooleanFeatureFlag)('jsw.pollinator.tenants');
var $ac3a35fae17b0a09$export$2e2bcd8739ae039 = $ac3a35fae17b0a09$var$isPollinatorTenant;

});


const $87a0abe4cc67502d$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $87a0abe4cc67502d$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $87a0abe4cc67502d$export$f27a837467ec20e5 = 'planWizard';
const $87a0abe4cc67502d$export$6afdd25b4da87159 = 30;
const $87a0abe4cc67502d$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $87a0abe4cc67502d$export$a8e537ef0c1e2586 = 'Days';
const $87a0abe4cc67502d$export$2a59d0fbc784e5c1 = '1';
const $87a0abe4cc67502d$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $87a0abe4cc67502d$export$14ae725d0cc7daa1 = 'DD/MMM/YY';


parcelRegister("lFLge", function(module, exports) {

$parcel$export(module.exports, "ROOT_PATHS", () => $a64d485c2ea55670$export$7b854f4176fe4984);
$parcel$export(module.exports, "PLAN_PAGES", () => $a64d485c2ea55670$export$aa80e59bd6a86321);
$parcel$export(module.exports, "PLAN_PATHS", () => $a64d485c2ea55670$export$50ce986ba03069e4);
$parcel$export(module.exports, "PLAN_SETTINGS_PAGES", () => $a64d485c2ea55670$export$331e0cdfec693a91);
$parcel$export(module.exports, "PLAN_SETTINGS_PATHS", () => $a64d485c2ea55670$export$f8b09fb9bf12a66d);
$parcel$export(module.exports, "buildManageViewsPath", () => $a64d485c2ea55670$export$163eb352faa92361);
$parcel$export(module.exports, "buildRemoveIssuePath", () => $a64d485c2ea55670$export$92e12da00cfa0a30);
$parcel$export(module.exports, "redirect", () => $a64d485c2ea55670$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $a64d485c2ea55670$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "reload", () => $a64d485c2ea55670$export$32da5b5043dcd88c);
$parcel$export(module.exports, "redirectToPlan", () => $a64d485c2ea55670$export$91c50705ae840697);
$parcel$export(module.exports, "redirectToSettings", () => $a64d485c2ea55670$export$fac3bf18cd62bfe3);
$parcel$export(module.exports, "redirectToSettingsSubPage", () => $a64d485c2ea55670$export$30c1dc5285e5b7c5);
$parcel$export(module.exports, "redirectToPlanPage", () => $a64d485c2ea55670$export$8ccbd58c5a1933be);
$parcel$export(module.exports, "redirectToIssueSourceSetup", () => $a64d485c2ea55670$export$c1647ef31d453e4e);
$parcel$export(module.exports, "redirectToManageSharedTeams", () => $a64d485c2ea55670$export$494ba966e7162403);
$parcel$export(module.exports, "userAgent", () => $a64d485c2ea55670$export$3dcce53a3755dc8c);
$parcel$export(module.exports, "getLocation", () => $a64d485c2ea55670$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "parseQueryParams", () => $a64d485c2ea55670$export$67c4cee80a3410cd);
$parcel$export(module.exports, "getQueryParameters", () => $a64d485c2ea55670$export$2c02b58bdf58d1c3);
$parcel$export(module.exports, "getPathParams", () => $a64d485c2ea55670$export$da250964c4d72448);
$parcel$export(module.exports, "updateQueryString", () => $a64d485c2ea55670$export$a725689b9dc0457f);
$parcel$export(module.exports, "redirectToNewScenario", () => $a64d485c2ea55670$export$11f26f7d7225123e);
$parcel$export(module.exports, "isReportView", () => $a64d485c2ea55670$export$60b6d4de09d53c54);
$parcel$export(module.exports, "isEmbedReportView", () => $a64d485c2ea55670$export$cf369e206dbfd4ce);
$parcel$export(module.exports, "isConfluenceReportView", () => $a64d485c2ea55670$export$62a9a65b5c5c27e);
$parcel$export(module.exports, "isExportView", () => $a64d485c2ea55670$export$cf7a8de77e0c8209);
$parcel$export(module.exports, "isExportPreview", () => $a64d485c2ea55670$export$ad6637fa30ef33ef);
$parcel$export(module.exports, "getNonTimelineWidth", () => $a64d485c2ea55670$export$9bd1947787a14301);
$parcel$export(module.exports, "getExportTimelineDateRange", () => $a64d485c2ea55670$export$fc5fb6d4b5cb9b11);
$parcel$export(module.exports, "isPageUnloading", () => $a64d485c2ea55670$export$806b710b4d1b901c);
$parcel$export(module.exports, "getPlanUrl", () => $a64d485c2ea55670$export$c64539b90bced4a);

var $4vTMF = parcelRequire("4vTMF");

var $ldYmX = parcelRequire("ldYmX");

var $1ybV0 = parcelRequire("1ybV0");

var $64VaH = parcelRequire("64VaH");

var $5rYNM = parcelRequire("5rYNM");
const $a64d485c2ea55670$export$7b854f4176fe4984 = {
    PLAN: 'plan',
    SETTINGS: 'settings'
};
const $a64d485c2ea55670$export$aa80e59bd6a86321 = {
    ROADMAP: 'backlog',
    RELEASES: 'releases',
    TEAMS: 'teams',
    DEPENDENCIES_REPORT: 'dependencies'
};
const $a64d485c2ea55670$export$50ce986ba03069e4 = {
    ROADMAP: `${$a64d485c2ea55670$export$7b854f4176fe4984.PLAN}/${$a64d485c2ea55670$export$aa80e59bd6a86321.ROADMAP}`,
    RELEASES: `${$a64d485c2ea55670$export$7b854f4176fe4984.PLAN}/${$a64d485c2ea55670$export$aa80e59bd6a86321.RELEASES}`,
    TEAMS: `${$a64d485c2ea55670$export$7b854f4176fe4984.PLAN}/${$a64d485c2ea55670$export$aa80e59bd6a86321.TEAMS}`,
    DEPENDENCIES_REPORT: `${$a64d485c2ea55670$export$7b854f4176fe4984.PLAN}/${$a64d485c2ea55670$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`
};
const $a64d485c2ea55670$export$331e0cdfec693a91 = {
    CUSTOM_FIELDS: 'customFields',
    EXCLUSION_RULES: 'setExclusionRules',
    ISSUE_SOURCES: 'issueSources',
    PERMISSIONS: 'permissions',
    REMOVED_ISSUES: 'removedIssues',
    SAVED_VIEWS: 'savedViews',
    SCENARIOS: 'scenarios',
    AUTO_SCHEDULER: 'auto-scheduler',
    SCHEDULING: 'scheduling',
    SOURCES: 'sources',
    FIND_YOUR_ISSUE: 'findYourIssue'
};
const $a64d485c2ea55670$export$f8b09fb9bf12a66d = {
    CUSTOM_FIELDS: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.CUSTOM_FIELDS}`,
    EXCLUSION_RULES: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.EXCLUSION_RULES}`,
    ISSUE_SOURCES: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.ISSUE_SOURCES}`,
    PERMISSIONS: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.PERMISSIONS}`,
    REMOVED_ISSUES: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.REMOVED_ISSUES}`,
    SAVED_VIEWS: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.SAVED_VIEWS}`,
    SCENARIOS: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.SCENARIOS}`,
    AUTO_SCHEDULER: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.AUTO_SCHEDULER}`,
    SCHEDULING: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.SCHEDULING}`,
    SOURCES: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.SOURCES}`,
    FIND_YOUR_ISSUE: `/${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${$a64d485c2ea55670$export$331e0cdfec693a91.FIND_YOUR_ISSUE}`
};
const $a64d485c2ea55670$export$163eb352faa92361 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))($a64d485c2ea55670$export$331e0cdfec693a91.SAVED_VIEWS)}`;
const $a64d485c2ea55670$export$92e12da00cfa0a30 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))($a64d485c2ea55670$export$331e0cdfec693a91.REMOVED_ISSUES)}`;
const $a64d485c2ea55670$export$89e12c5b50f7529d = (url)=>{
    window.location.href = url;
};
const $a64d485c2ea55670$export$9e52b10d57ddf9e3 = (url)=>{
    window.open(url, '_blank')?.focus();
};
const $a64d485c2ea55670$export$32da5b5043dcd88c = ()=>{
    window.location.reload();
};
const $a64d485c2ea55670$export$91c50705ae840697 = (planId, scenarioId)=>{
    $a64d485c2ea55670$export$89e12c5b50f7529d((0, $64VaH.proxyContextSafeUrl)(`/jira/plans/${planId}/scenarios/${scenarioId}`));
};
const $a64d485c2ea55670$export$fac3bf18cd62bfe3 = ()=>{
    window.location.hash = `#${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}`;
};
const $a64d485c2ea55670$export$30c1dc5285e5b7c5 = (page)=>{
    window.location.hash = `#${$a64d485c2ea55670$export$7b854f4176fe4984.SETTINGS}/${page}`;
};
const $a64d485c2ea55670$export$8ccbd58c5a1933be = (tab)=>{
    window.location.hash = `#${$a64d485c2ea55670$export$7b854f4176fe4984.PLAN}${tab}`;
};
const $a64d485c2ea55670$export$c1647ef31d453e4e = (planId)=>{
    $a64d485c2ea55670$export$89e12c5b50f7529d((0, $64VaH.proxyContextSafeUrl)(`/secure/PortfolioPlanSetup.jspa?id=${planId}&3.0plan`));
};
const $a64d485c2ea55670$export$494ba966e7162403 = ()=>{
    $a64d485c2ea55670$export$89e12c5b50f7529d((0, $64VaH.proxyContextSafeUrl)(`/secure/TeamManagement.jspa?planUrl=${encodeURIComponent(window.location.href)}`));
};
const $a64d485c2ea55670$export$3dcce53a3755dc8c = window.navigator.userAgent;
const $a64d485c2ea55670$export$e7fd20fad3cf4b5f = ()=>window.location;
const $a64d485c2ea55670$export$67c4cee80a3410cd = (rawParams)=>{
    if (!rawParams) return {};
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        const result = {};
        rawParams.slice(1) // ignore '?'
        .split('&').map((queryParam)=>{
            const keyValue = queryParam.split('=');
            return {
                key: keyValue[0],
                value: keyValue[1]
            };
        }).forEach((keyValue)=>{
            result[keyValue.key] = keyValue.value;
        });
        return result;
    }
    return rawParams.slice(1) // ignore '?'
    .split('&').map((queryParam)=>{
        const keyValue = queryParam.split('=');
        return {
            key: keyValue[0],
            value: keyValue[1]
        };
    }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((query, keyValue)=>{
        // eslint-disable-next-line no-param-reassign
        query[keyValue.key] = keyValue.value;
        return query;
    }, {});
};
const $a64d485c2ea55670$export$2c02b58bdf58d1c3 = ()=>$a64d485c2ea55670$export$67c4cee80a3410cd(window.location.search);
const $a64d485c2ea55670$export$62c1abd9d82e0215 = (path)=>{
    const pathparams = [
        'id',
        'sid',
        'r'
    ];
    const paramToPathNameMap = {
        id: 'plans',
        sid: 'scenarios',
        r: 'reports'
    };
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        const params = {};
        pathparams.forEach((param)=>{
            const regex = new RegExp(`/${paramToPathNameMap[param]}/(\\w+)`, 'g');
            const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
            params[param] = matches[0];
        });
        return params;
    }
    return $ldYmX.default((params, param)=>{
        const regex = new RegExp(`/${paramToPathNameMap[param]}/(\\w+)`, 'g');
        const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
        // eslint-disable-next-line no-param-reassign
        params[param] = matches[0];
        return params;
    }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    {}, pathparams);
};
const $a64d485c2ea55670$export$da250964c4d72448 = ()=>$a64d485c2ea55670$export$62c1abd9d82e0215(window.location.pathname);
const $a64d485c2ea55670$export$a725689b9dc0457f = (locationSearch, newParams)=>{
    const currentParams = $a64d485c2ea55670$export$67c4cee80a3410cd(locationSearch);
    const updatedParams = {
        ...currentParams,
        ...newParams
    };
    const searchString = Object.keys(updatedParams).filter((key)=>updatedParams[key] !== undefined).map((key)=>`${key}=${updatedParams[key]}`).join('&');
    return `?${searchString}`;
};
const $a64d485c2ea55670$export$11f26f7d7225123e = (browserHistory, sid)=>{
    const regex = new RegExp('(/scenarios/)\\w+', 'g');
    const url = `${window.location.pathname.replace(regex, (_, $1)=>`${$1}${sid}`)}${window.location.search}${window.location.hash}`;
    browserHistory.push(url);
};
const $a64d485c2ea55670$export$60b6d4de09d53c54 = ()=>{
    return window && (window.location.pathname.includes('reports') || window.location.pathname.includes('PortfolioEmbeddedReportView') || window.location.pathname.includes('PlanEmbeddedReport') || window.location.pathname.includes('PortfolioRoadmapConfluence'));
};
const $a64d485c2ea55670$export$cf369e206dbfd4ce = ()=>window && (window.location.pathname.includes('PortfolioEmbeddedReportView') || window.location.pathname.includes('PlanEmbeddedReport'));
const $a64d485c2ea55670$export$62a9a65b5c5c27e = ()=>window && window.location.pathname.indexOf('PortfolioRoadmapConfluence') !== -1;
const $a64d485c2ea55670$export$cf7a8de77e0c8209 = ()=>Boolean(window?.location.pathname.indexOf('plans') !== -1 && window?.location.pathname.indexOf('scenarios') !== -1 && window?.location.pathname.indexOf('/export') !== -1) || Boolean(window?.location.href.indexOf('forceExportMode=1') !== -1);
const $a64d485c2ea55670$export$ad6637fa30ef33ef = ()=>Boolean(window?.location.href.indexOf('startInPreviewMode=1') !== -1);
const $a64d485c2ea55670$export$2399fb6b8ed70468 = ()=>{
    const params = $a64d485c2ea55670$export$2c02b58bdf58d1c3();
    const width = parseInt(params.scopeWidth || (0, $5rYNM.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH), 10);
    return Number.isNaN(width) ? (0, $5rYNM.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH) : width;
};
const $a64d485c2ea55670$export$661aa4dfe4b50072 = ()=>{
    const params = $a64d485c2ea55670$export$2c02b58bdf58d1c3();
    const width = parseInt(params.fieldsWidth || (0, $5rYNM.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH), 10);
    return Number.isNaN(width) ? (0, $5rYNM.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH) : width;
};
const $a64d485c2ea55670$export$9bd1947787a14301 = ()=>$a64d485c2ea55670$export$2399fb6b8ed70468() + $a64d485c2ea55670$export$661aa4dfe4b50072();
const $a64d485c2ea55670$export$fc5fb6d4b5cb9b11 = ()=>{
    const params = $a64d485c2ea55670$export$2c02b58bdf58d1c3();
    const fromDate = parseInt(params.fromDate || '', 10);
    const toDate = parseInt(params.toDate || '', 10);
    return {
        fromDate: Number.isNaN(fromDate) ? undefined : fromDate,
        toDate: Number.isNaN(toDate) ? undefined : toDate
    };
};
// Firefox has a bad habit of terminating network requests on the unloading page before stopping
// JS execution. As a result fetch throws an error which we don't know what to do with except as
// to show to the user as an error flag and try to log it.
// We workaround it by swallowing any fetch failures if the page started to unload,
// as well as not reporting unhandled exceptions via Flags.
let $a64d485c2ea55670$var$isPageUnloadingFlag = false;
if (window) window.addEventListener('beforeunload', ()=>{
    $a64d485c2ea55670$var$isPageUnloadingFlag = true;
});
const $a64d485c2ea55670$export$806b710b4d1b901c = ()=>$a64d485c2ea55670$var$isPageUnloadingFlag;
const $a64d485c2ea55670$export$c64539b90bced4a = ({ planId: planId, scenarioId: scenarioId, confluenceMacroType: confluenceMacroType })=>{
    const baseUrl = scenarioId != null ? `/jira/plans/${planId}/scenarios/${scenarioId}/` : `/jira/plans/${planId}/`;
    switch(confluenceMacroType){
        case 0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE:
            return `${baseUrl}${$a64d485c2ea55670$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`;
        default:
            return `${baseUrl}${$a64d485c2ea55670$export$aa80e59bd6a86321.ROADMAP}`;
    }
};

});
parcelRegister("ldYmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f739a3f975f13492$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $hC9UT = parcelRequire("hC9UT");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $f739a3f975f13492$var$reduce = /*#__PURE__*/ (0, $4g10W.default)((0, $hC9UT.default));
var $f739a3f975f13492$export$2e2bcd8739ae039 = $f739a3f975f13492$var$reduce;

});

parcelRegister("64VaH", function(module, exports) {

$parcel$export(module.exports, "proxyContextSafeUrl", () => $4eff7026519fa39d$export$ff2a151586ba6aa1);
/**
 * All API calls in the confluence macro need to be wrapped in a proxy if the Jira and Confluence have different base urls.
 * Note this should be used for api calls only, not for links.
 */ const $4eff7026519fa39d$export$ff2a151586ba6aa1 = (url)=>`${window.integrationApiUrl || window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;

});



parcelRegister("kKj1m", function(module, exports) {

$parcel$export(module.exports, "getCustomFields", () => $5d8fade62c443547$export$38306747bc0912a4);
$parcel$export(module.exports, "getCustomFieldsById", () => $5d8fade62c443547$export$dada3f92779aaf9a);
$parcel$export(module.exports, "getSupportedCustomFields", () => $5d8fade62c443547$export$9369dee44a26a06c);
$parcel$export(module.exports, "getFilterableCustomFields", () => $5d8fade62c443547$export$3b1b52240ef3572e);
$parcel$export(module.exports, "getCustomFieldsByKey", () => $5d8fade62c443547$export$d8a0fc111d5e2ab0);
$parcel$export(module.exports, "getCustomFieldById", () => $5d8fade62c443547$export$793123b5ff3f40ad);
$parcel$export(module.exports, "getSelectOptions", () => $5d8fade62c443547$export$fd440e53dd69ddad);
$parcel$export(module.exports, "getSelectOptionsById", () => $5d8fade62c443547$export$b3a0f99c6d5c0eb0);
$parcel$export(module.exports, "getUserPickerOptions", () => $5d8fade62c443547$export$a4fdd23a97f272c8);
$parcel$export(module.exports, "getUserPickerOptionsUserList", () => $5d8fade62c443547$export$9bfa891f0e97567);
$parcel$export(module.exports, "getUserPickerOptionsUserListById", () => $5d8fade62c443547$export$4fb91df5858ae1d4);
$parcel$export(module.exports, "getUserPickerUIState", () => $5d8fade62c443547$export$d488418c9141b6ed);
$parcel$export(module.exports, "getCustomLabelFieldIds", () => $5d8fade62c443547$export$d1d1f3bde590a033);

var $f7Op5 = parcelRequire("f7Op5");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");
const $5d8fade62c443547$export$38306747bc0912a4 = (state)=>state.domain.customFields;
const $5d8fade62c443547$export$dada3f92779aaf9a = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$38306747bc0912a4
], (customFields)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), customFields));
const $5d8fade62c443547$export$9369dee44a26a06c = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$38306747bc0912a4
], (customFields)=>customFields.filter((field)=>(0, $5rYNM.CustomFields).WritableFields.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        field.type.key) || (0, $5rYNM.CustomFields).ReadOnlyFields.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        field.type.key)));
const $5d8fade62c443547$export$3b1b52240ef3572e = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$38306747bc0912a4
], (customFields)=>customFields.filter((field)=>(0, $5rYNM.CustomFields).FilterableFields.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        field.type.key)));
const $5d8fade62c443547$export$d8a0fc111d5e2ab0 = (key, customFields)=>customFields.filter((customField)=>customField.type.key === key);
const $5d8fade62c443547$export$793123b5ff3f40ad = (id, customFields)=>customFields.filter((customField)=>customField.id === id);
const $5d8fade62c443547$export$fd440e53dd69ddad = (state)=>state.domain.selectOptions;
const $5d8fade62c443547$export$b3a0f99c6d5c0eb0 = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$fd440e53dd69ddad
], (selectOptions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), selectOptions));
const $5d8fade62c443547$export$a4fdd23a97f272c8 = (state)=>state.domain.userPickerOptions;
const $5d8fade62c443547$export$9bfa891f0e97567 = (state)=>state.domain.userPickerOptions.userList;
const $5d8fade62c443547$export$4fb91df5858ae1d4 = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$9bfa891f0e97567
], (userList)=>(0, $7CnHa.indexBy)($f7Op5.default('value'), userList));
const $5d8fade62c443547$export$d488418c9141b6ed = (state)=>state.ui.Main.Tabs.Roadmap.Fields.CustomFields.UserPicker;
const $5d8fade62c443547$export$d1d1f3bde590a033 = (0, $iK4oF.createSelector)([
    $5d8fade62c443547$export$38306747bc0912a4
], (customFields)=>customFields.filter((customField)=>(0, $ayXoc.isLabelCustomField)(customField.type.key)).map((customField)=>`${customField.id}`));

});
parcelRegister("7CnHa", function(module, exports) {

$parcel$export(module.exports, "chain", () => $3e6d7b22f0b7a314$export$e08e3b67e392101e);
$parcel$export(module.exports, "fromPairs", () => $3e6d7b22f0b7a314$export$8995636b7242f090);
$parcel$export(module.exports, "values", () => $3e6d7b22f0b7a314$export$68c286be0e7e55b7);
$parcel$export(module.exports, "groupBy", () => $3e6d7b22f0b7a314$export$3f063810d7bf01bd);
$parcel$export(module.exports, "indexBy", () => $3e6d7b22f0b7a314$export$e620e98009814b79);
$parcel$export(module.exports, "sortWith", () => $3e6d7b22f0b7a314$export$a9e7d1a6fdcfefde);
$parcel$export(module.exports, "ascend", () => $3e6d7b22f0b7a314$export$417c3e637c1bc965);
$parcel$export(module.exports, "descend", () => $3e6d7b22f0b7a314$export$748246bdd9c122ea);
$parcel$export(module.exports, "isDefined", () => $3e6d7b22f0b7a314$export$4e62c701997796c1);
$parcel$export(module.exports, "filterDefined", () => $3e6d7b22f0b7a314$export$68250b7674019b05);
$parcel$export(module.exports, "filterMap", () => $3e6d7b22f0b7a314$export$a04c6c6965dd4709);
$parcel$export(module.exports, "valuesLength", () => $3e6d7b22f0b7a314$export$745491ed4818e2e8);
$parcel$export(module.exports, "valuesKeysLength", () => $3e6d7b22f0b7a314$export$44e3e1a05911fec9);
$parcel$export(module.exports, "mapValues", () => $3e6d7b22f0b7a314$export$825e789796ab7275);
$parcel$export(module.exports, "pickBy", () => $3e6d7b22f0b7a314$export$b460b275d6c6aa0);
$parcel$export(module.exports, "pluck", () => $3e6d7b22f0b7a314$export$c44985b87d605eff);
$parcel$export(module.exports, "mapObject", () => $3e6d7b22f0b7a314$export$d6051a0f7a227332);
$parcel$export(module.exports, "move", () => $3e6d7b22f0b7a314$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "mapGroupsToIds", () => $3e6d7b22f0b7a314$export$28674149d4fdfa90);
// This module contains counterparts to Ramda functions missing/ill-typed in flow-typed
// It's okay if they are less generic (non-curried, work only over array etc.)

var $kaVjO = parcelRequire("kaVjO");
var $f7Op5 = parcelRequire("f7Op5");
function $3e6d7b22f0b7a314$export$e08e3b67e392101e(callback, array) {
    const result = [];
    for (const elements of array.map(callback))Array.prototype.push.apply(result, elements);
    return result;
}
function $3e6d7b22f0b7a314$export$8995636b7242f090(pairs) {
    const result = {};
    for (const [k, v] of pairs)result[k] = v;
    return result;
}
const $3e6d7b22f0b7a314$export$68c286be0e7e55b7 = (object)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values(object);
function $3e6d7b22f0b7a314$export$3f063810d7bf01bd(keyFn, array) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const element of array){
        const key = keyFn(element);
        if (!result[key]) result[key] = [];
        result[key].push(element);
    }
    return result;
}
function $3e6d7b22f0b7a314$export$e620e98009814b79(keyFn, array) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const result = {};
    for (const element of array){
        const key = keyFn(element);
        result[key] = element;
    }
    return result;
}
function $3e6d7b22f0b7a314$export$a9e7d1a6fdcfefde(comparators) {
    return (array)=>[
            ...array
        ].sort((a, b)=>{
            let comparison = 0;
            for (const comparator of comparators){
                comparison = comparator(a, b);
                if (comparison !== 0) return comparison;
            }
            return comparison;
        });
}
function $3e6d7b22f0b7a314$export$417c3e637c1bc965(keyFn) {
    return (a, b)=>{
        const keyA = keyFn(a);
        const keyB = keyFn(b);
        if (typeof keyA === 'number' && typeof keyB === 'number') {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        }
        if (typeof keyA === 'string' && typeof keyB === 'string') {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        }
        throw new Error('keyFn must return number or string consistently');
    };
}
function $3e6d7b22f0b7a314$export$748246bdd9c122ea(keyFn) {
    return (a, b)=>{
        const keyA = keyFn(a);
        const keyB = keyFn(b);
        if (typeof keyA === 'number' && typeof keyB === 'number') {
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        }
        if (typeof keyA === 'string' && typeof keyB === 'string') {
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        }
        throw new Error('keyFn must return number or string consistently');
    };
}
function $3e6d7b22f0b7a314$export$448332262467e042(array) {
    let counter = array.length;
    const result = [
        ...array
    ];
    while(counter > 0){
        const index = Math.floor(Math.random() * counter);
        counter -= 1;
        const temp = result[counter];
        result[counter] = result[index];
        result[index] = temp;
    }
    return result;
}
function $3e6d7b22f0b7a314$export$66c1ae025e96b4bc(array) {
    const reversed = [];
    for(let i = array.length - 1; i >= 0; i -= 1)reversed.push(array[i]);
    return reversed;
}
function $3e6d7b22f0b7a314$export$4e62c701997796c1(thing) {
    return thing !== undefined && thing !== null;
}
function $3e6d7b22f0b7a314$export$68250b7674019b05(array) {
    const filtered = [];
    for (const e of array)if ($3e6d7b22f0b7a314$export$4e62c701997796c1(e)) filtered.push(e);
    return filtered;
}
function $3e6d7b22f0b7a314$export$a04c6c6965dd4709(filter, map, array) {
    const result = [];
    for(let i = 0; i < array.length; i++){
        const element = array[i];
        if (filter(element)) result.push(map(element, i));
    }
    return result;
}
function $3e6d7b22f0b7a314$export$745491ed4818e2e8(object) {
    let result = 0;
    for (const array of Object.values(object))result += array.length;
    return result;
}
function $3e6d7b22f0b7a314$export$44e3e1a05911fec9(object) {
    let result = 0;
    for (const child of Object.values(object))result += Object.keys(child).length;
    return result;
}
function $3e6d7b22f0b7a314$export$825e789796ab7275(f, object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const k of Object.keys(object))// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    result[k] = object[k].map(f);
    return result;
}
function $3e6d7b22f0b7a314$export$b460b275d6c6aa0(// eslint-disable-next-line @typescript-eslint/no-explicit-any
f, obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (f(value, key)) {
            acc[key] = value;
            return acc;
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
}
function $3e6d7b22f0b7a314$export$c44985b87d605eff(prop, array) {
    return array.map((x)=>x[prop]);
}
function $3e6d7b22f0b7a314$export$d6051a0f7a227332(f, object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const k of Object.keys(object))result[k] = f(k, object[k]);
    return result;
}
function $3e6d7b22f0b7a314$export$d947e5f4f4c48d48(fromIndex, toIndex, array) {
    return $kaVjO.default(fromIndex, toIndex, array);
}
function $3e6d7b22f0b7a314$export$28674149d4fdfa90(object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $3e6d7b22f0b7a314$export$825e789796ab7275($f7Op5.default('id'), object);
}

});
parcelRegister("kaVjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb013410cf9bd048$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $eb013410cf9bd048$var$move = /*#__PURE__*/ (0, $4g10W.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $eb013410cf9bd048$export$2e2bcd8739ae039 = $eb013410cf9bd048$var$move;

});


parcelRegister("ayXoc", function(module, exports) {

$parcel$export(module.exports, "isRoadmapGroupedByCustomField", () => $d4dec0f7ccef74a6$export$ab9f09a1d4f7c122);
$parcel$export(module.exports, "getCustomFieldIdFromCustomFieldGrouping", () => $d4dec0f7ccef74a6$export$8f12e0ea293cf738);
$parcel$export(module.exports, "isMultiSelectCustomField", () => $d4dec0f7ccef74a6$export$44fc3b70a457386d);
$parcel$export(module.exports, "isLabelCustomField", () => $d4dec0f7ccef74a6$export$f9c878cce6945b43);

var $5rYNM = parcelRequire("5rYNM");
const $d4dec0f7ccef74a6$export$ab9f09a1d4f7c122 = (grouping)=>/^customfield_/.test(grouping);
const $d4dec0f7ccef74a6$export$8f12e0ea293cf738 = (grouping)=>grouping.substring(12);
const $d4dec0f7ccef74a6$export$44fc3b70a457386d = (fieldType)=>fieldType === (0, $5rYNM.CustomFieldTypes).MultiSelect;
const $d4dec0f7ccef74a6$export$f9c878cce6945b43 = (fieldType)=>fieldType === (0, $5rYNM.CustomFieldTypes).Labels;

});


parcelRegister("6WF4e", function(module, exports) {

$parcel$export(module.exports, "applyOption", () => $ff3dc2457e5c95d4$export$a8d7808c320ee36b);
$parcel$export(module.exports, "getShowFullHierarchy", () => $ff3dc2457e5c95d4$export$4d043fada9b9f718);

var $9H2AP = parcelRequire("9H2AP");
const $ff3dc2457e5c95d4$export$a8d7808c320ee36b = (filteredIssues = [], ancestorsAndDescendants, showFullHierarchy)=>{
    const result = [];
    const uniqIds = new Set();
    const addItem = (item)=>{
        if (!uniqIds.has(item.id)) {
            uniqIds.add(item.id);
            result.push(item);
        }
    };
    for (const issue of filteredIssues){
        const { ancestors: ancestors, descendants: descendants } = ancestorsAndDescendants[issue.id];
        ancestors.forEach((ancestor)=>addItem(ancestor));
        addItem(issue);
        if (showFullHierarchy) descendants.forEach((descendant)=>addItem(descendant));
    }
    return result;
};
const $ff3dc2457e5c95d4$export$4d043fada9b9f718 = (state)=>(0, $9H2AP.getFilterOptionsViewSettings)(state).includeDescendants;

});
parcelRegister("9H2AP", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $a6d668a1597c7e82$export$3ae70db4a97563c);
$parcel$export(module.exports, "getIsCalendarView", () => $a6d668a1597c7e82$export$7ac48ee147a124b8);
$parcel$export(module.exports, "getFiltersViewSettings", () => $a6d668a1597c7e82$export$de5b47246a90a380);
$parcel$export(module.exports, "getColorByViewSettings", () => $a6d668a1597c7e82$export$89c287e1b70fc517);
$parcel$export(module.exports, "getTimeScaleViewSettings", () => $a6d668a1597c7e82$export$bb9c5abbffcc2d9);
$parcel$export(module.exports, "getIssueExpansionsViewSettings", () => $a6d668a1597c7e82$export$667cd472c0cbffff);
$parcel$export(module.exports, "getFilterOptionsViewSettings", () => $a6d668a1597c7e82$export$7b90d9dd3b52e40d);
$parcel$export(module.exports, "getRollupViewSettings", () => $a6d668a1597c7e82$export$cb42a8226d9928a0);
$parcel$export(module.exports, "getHighlightedVersionsViewSettings", () => $a6d668a1597c7e82$export$24cd3e812c6fd651);
$parcel$export(module.exports, "getComponentGroupsViewSettings", () => $a6d668a1597c7e82$export$29948f4864a35d5);
$parcel$export(module.exports, "getLabelsGroupViewSettings", () => $a6d668a1597c7e82$export$3a3f88dcba27590);
$parcel$export(module.exports, "getCustomFieldValuesGroupsViewSettings", () => $a6d668a1597c7e82$export$c6774389fcc31261);
$parcel$export(module.exports, "getWarningViewSettings", () => $a6d668a1597c7e82$export$bff0f8c53c029824);
$parcel$export(module.exports, "getVisualisationViewSettings", () => $a6d668a1597c7e82$export$3815c5ababe87c29);
$parcel$export(module.exports, "getShowRolledUpDates", () => $a6d668a1597c7e82$export$9bb477be981b6a4e);
$parcel$export(module.exports, "getDependencySettings", () => $a6d668a1597c7e82$export$5b652ca76283f3ee);
$parcel$export(module.exports, "getShowRolledUpOthers", () => $a6d668a1597c7e82$export$37497680880cdb7c);
$parcel$export(module.exports, "getDependencySettingsDisplay", () => $a6d668a1597c7e82$export$52fff7345d751053);
$parcel$export(module.exports, "getComponentGroupsById", () => $a6d668a1597c7e82$export$16fb8d1a8cf90d64);
$parcel$export(module.exports, "getLabelGroupsById", () => $a6d668a1597c7e82$export$92cc93af4bfd2a4f);
$parcel$export(module.exports, "getViewMode", () => $a6d668a1597c7e82$export$956c1b0ab1ddf9f1);
$parcel$export(module.exports, "getFieldColumnsViewSettingsByViewMode", () => $a6d668a1597c7e82$export$685fbbb7108a90e1);
$parcel$export(module.exports, "ALL_OTHER_ISSUES", () => $bb09f71c7817719d$export$526fec6b76d5bc5);

var $f7Op5 = parcelRequire("f7Op5");

var $lcvrv = parcelRequire("lcvrv");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

const $a6d668a1597c7e82$export$3ae70db4a97563c = (state)=>state.domain.viewSettings;
const $a6d668a1597c7e82$export$7ac48ee147a124b8 = (state)=>state.domain.viewSettings.activeFilterViewV0 === 'calendar';
const $a6d668a1597c7e82$export$de5b47246a90a380 = (state)=>$a6d668a1597c7e82$export$7ac48ee147a124b8(state) ? state.domain.viewSettings.calendarFiltersV0 : state.domain.viewSettings.filtersV0;
const $a6d668a1597c7e82$export$89c287e1b70fc517 = (state)=>state.domain.viewSettings.colourByV2;
const $a6d668a1597c7e82$export$bb9c5abbffcc2d9 = (state)=>state.domain.viewSettings.timeScaleV1;
const $a6d668a1597c7e82$export$667cd472c0cbffff = (state)=>state.domain.viewSettings.issueExpansionsV0;
const $a6d668a1597c7e82$export$cda31cc46b3c6999 = (state)=>state.domain.viewSettings.fieldColumnsV0;
const $a6d668a1597c7e82$var$getListFieldColumnsViewSettings = (state)=>state.domain.viewSettings.listFieldColumnsV0;
const $a6d668a1597c7e82$export$7b90d9dd3b52e40d = (state)=>state.domain.viewSettings.filterOptionsV1;
const $a6d668a1597c7e82$export$cb42a8226d9928a0 = (state)=>state.domain.viewSettings.rollupSettingsV0;
const $a6d668a1597c7e82$export$24cd3e812c6fd651 = (state)=>state.domain.viewSettings.highlightedVersionsV0;
const $a6d668a1597c7e82$export$29948f4864a35d5 = (state)=>state.domain.viewSettings.componentGroupsV0;
const $a6d668a1597c7e82$export$3a3f88dcba27590 = (state)=>state.domain.viewSettings.labelGroupsV0;
const $a6d668a1597c7e82$export$c6774389fcc31261 = (state)=>state.domain.viewSettings.customFieldValuesGroupsV0;
const $a6d668a1597c7e82$export$bff0f8c53c029824 = (state)=>state.domain.viewSettings.warningSettingsV1;
const $a6d668a1597c7e82$export$545de9d49422239c = (state)=>state.domain.viewSettings.dateConstraintsV0;
const $a6d668a1597c7e82$export$3815c5ababe87c29 = (state)=>state.domain.viewSettings.visualisationsV0;
const $a6d668a1597c7e82$export$9bb477be981b6a4e = (state)=>$a6d668a1597c7e82$export$cb42a8226d9928a0(state).showingRolledUpDate;
const $a6d668a1597c7e82$export$5b652ca76283f3ee = (state)=>state.domain.viewSettings.dependencySettingsV0;
const $a6d668a1597c7e82$var$getViewModeViewSettingsDefault = {
    mode: (0, $lcvrv.VIEW_MODES).TIMELINE
};
const $a6d668a1597c7e82$export$56600ac9e6d65e1d = (state)=>state.domain.viewSettings.viewModeV0 || $a6d668a1597c7e82$var$getViewModeViewSettingsDefault;
const $a6d668a1597c7e82$export$37497680880cdb7c = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$cb42a8226d9928a0
], (rollupViewSettings)=>rollupViewSettings.showRolledUpOthers);
const $a6d668a1597c7e82$export$52fff7345d751053 = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$5b652ca76283f3ee
], (dependencySettings)=>dependencySettings.display);
const $a6d668a1597c7e82$export$16fb8d1a8cf90d64 = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$29948f4864a35d5
], (componentGroupsViewSettings)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), componentGroupsViewSettings));
const $a6d668a1597c7e82$export$92cc93af4bfd2a4f = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$3a3f88dcba27590
], (labelsGroupViewSettings)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), labelsGroupViewSettings));
const $a6d668a1597c7e82$export$956c1b0ab1ddf9f1 = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$56600ac9e6d65e1d
], ({ mode: mode })=>mode);
const $a6d668a1597c7e82$export$685fbbb7108a90e1 = (0, $iK4oF.createSelector)([
    $a6d668a1597c7e82$export$cda31cc46b3c6999,
    $a6d668a1597c7e82$var$getListFieldColumnsViewSettings,
    $a6d668a1597c7e82$export$956c1b0ab1ddf9f1
], (fieldColumns, listFieldColumns, viewMode)=>viewMode === (0, $lcvrv.VIEW_MODES).LIST ? listFieldColumns : fieldColumns);

});
parcelRegister("lcvrv", function(module, exports) {

$parcel$export(module.exports, "VIEW_MODES", () => $3e6f6f030d1e5561$export$f4c4d822ceaa9764);
const $3e6f6f030d1e5561$export$f4c4d822ceaa9764 = {
    TIMELINE: 'timeline',
    LIST: 'list'
};

});

const $bb09f71c7817719d$export$526fec6b76d5bc5 = 'all_other_issues';



parcelRegister("fbHoQ", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $a55e8108c902e8c9$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getFiltersAndHierarchyLevelsForAnalytics", () => $a55e8108c902e8c9$export$848df232fa46588e);
$parcel$export(module.exports, "getFilterCount", () => $a55e8108c902e8c9$export$93837b363b30db3a);
$parcel$export(module.exports, "getRawFilters", () => $a55e8108c902e8c9$export$bdb6d3f30d16cca7);
$parcel$export(module.exports, "filterById", () => $a55e8108c902e8c9$export$ff9a17ccab304c79);
$parcel$export(module.exports, "matchFilter", () => $a55e8108c902e8c9$export$c6f8482e724e56c5);
$parcel$export(module.exports, "getUnmatchedFiltersList", () => $a55e8108c902e8c9$export$a494cbe4bae883bb);
$parcel$export(module.exports, "PROJECT_FILTER_ID", () => $12ee831723ccf9c2$export$d0da0a0b0cd817d8);
$parcel$export(module.exports, "CROSS_PROJECT_RELEASE_FILTER_ID", () => $12ee831723ccf9c2$export$585fb3e81bcfccad);
$parcel$export(module.exports, "RELEASE_FILTER_ID", () => $12ee831723ccf9c2$export$53e2f8996e102881);
$parcel$export(module.exports, "TEAM_FILTER_ID", () => $12ee831723ccf9c2$export$8abe69ceb26771cd);
$parcel$export(module.exports, "ASSIGNEE_FILTER_ID", () => $12ee831723ccf9c2$export$43596ee088b165a);
$parcel$export(module.exports, "REPORTER_FILTER_ID", () => $12ee831723ccf9c2$export$20140793a0aa2b3c);
$parcel$export(module.exports, "DEPENDENCIES_FILTER_ID", () => $12ee831723ccf9c2$export$a849f806e27a57e8);
$parcel$export(module.exports, "LABEL_FILTER_ID", () => $12ee831723ccf9c2$export$7e257b719377371e);
$parcel$export(module.exports, "COMPONENT_FILTER_ID", () => $12ee831723ccf9c2$export$6022538efc28a609);
$parcel$export(module.exports, "SPRINT_FILTER_ID", () => $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb);
$parcel$export(module.exports, "ISSUE_TYPE_KEY_FILTER_ID", () => $12ee831723ccf9c2$export$a8ec3260a009d752);

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");
var $erwaN = parcelRequire("erwaN");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");

var $8YqJS = parcelRequire("8YqJS");

var $kKj1m = parcelRequire("kKj1m");

var $fiZs1 = parcelRequire("fiZs1");

var $dhHiZ = parcelRequire("dhHiZ");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $aYCQt = parcelRequire("aYCQt");

var $2c08V = parcelRequire("2c08V");

var $38iYP = parcelRequire("38iYP");

var $fiZs1 = parcelRequire("fiZs1");

var $imCER = parcelRequire("imCER");

var $bRpYp = parcelRequire("bRpYp");

var $kOHCR = parcelRequire("kOHCR");

var $6UAvZ = parcelRequire("6UAvZ");

var $eFzGj = parcelRequire("eFzGj");

var $2vV9U = parcelRequire("2vV9U");

var $gqs5m = parcelRequire("gqs5m");

var $Z7Mx2 = parcelRequire("Z7Mx2");

var $5Rz3d = parcelRequire("5Rz3d");

var $68BNT = parcelRequire("68BNT");

var $3nT5G = parcelRequire("3nT5G");

var $f436g = parcelRequire("f436g");

var $7hbkF = parcelRequire("7hbkF");

var $5mAJ1 = parcelRequire("5mAJ1");

var $77IHm = parcelRequire("77IHm");

var $3Fte6 = parcelRequire("3Fte6");

var $kahmZ = parcelRequire("kahmZ");
const $a55e8108c902e8c9$export$1933a9fe712fc1fd = (0, $iK4oF.createStructuredSelector)({
    [(0, $12ee831723ccf9c2$export$43596ee088b165a)]: (0, $aYCQt.getAssigneeFilter),
    [(0, $12ee831723ccf9c2$export$6022538efc28a609)]: (0, $2c08V.getComponentFilter),
    [(0, $12ee831723ccf9c2$export$585fb3e81bcfccad)]: (0, $38iYP.getCrossProjectReleaseFilter),
    [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: (0, $fiZs1.getCustomFieldFilter),
    [(0, $12ee831723ccf9c2$export$a849f806e27a57e8)]: (0, $bRpYp.getDependenciesFilter),
    [(0, $12ee831723ccf9c2$export$861e775e082be75a)]: (0, $kOHCR.getGoalFilter),
    [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: (0, $6UAvZ.getHierarchyFilter),
    [(0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)]: (0, $eFzGj.getHierarchyRangeFilter),
    [(0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d)]: (0, $2vV9U.getIssuePrioritiesFilter),
    [(0, $12ee831723ccf9c2$export$a8ec3260a009d752)]: (0, $gqs5m.getIssueTypeKeyFilter),
    [(0, $12ee831723ccf9c2$export$7e257b719377371e)]: (0, $5Rz3d.getLabelFilter),
    [(0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8)]: (0, $68BNT.getProjectFilter),
    [(0, $12ee831723ccf9c2$export$53e2f8996e102881)]: (0, $3nT5G.getReleaseFilter),
    [(0, $12ee831723ccf9c2$export$20140793a0aa2b3c)]: (0, $f436g.getReporterFilter),
    [(0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)]: (0, $7hbkF.getSprintFilter),
    [(0, $12ee831723ccf9c2$export$9b51ec1115932c53)]: (0, $5mAJ1.getStatusKeyFilter),
    [(0, $12ee831723ccf9c2$export$e32eeae4866f112c)]: (0, $77IHm.getSummaryFilter),
    [(0, $12ee831723ccf9c2$export$8abe69ceb26771cd)]: (0, $3Fte6.getTeamFilter),
    [(0, $12ee831723ccf9c2$export$d6f1616882408daa)]: (0, $kahmZ.getWarningFilter),
    [(0, $12ee831723ccf9c2$export$59af687b450af7eb)]: (0, $Z7Mx2.getIssueWarningFilter),
    [(0, $12ee831723ccf9c2$export$82db1960569473ff)]: (0, $imCER.getDateRangeFilter)
});
const $a55e8108c902e8c9$export$848df232fa46588e = (state)=>{
    const filters = $a55e8108c902e8c9$export$1933a9fe712fc1fd(state);
    const customFieldsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), (0, $kKj1m.getCustomFields)(state));
    // highest and lowest hierarchy levels
    const hierarchyLevels = {
        start: (0, $8YqJS.SUB_TASK_LEVEL),
        end: (0, $8YqJS.SUB_TASK_LEVEL)
    };
    const ignoredFilters = [
        (0, $12ee831723ccf9c2$export$a8ec3260a009d752),
        (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
        (0, $12ee831723ccf9c2$export$3b798637a628dacc),
        (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
        (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
        (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
        (0, $12ee831723ccf9c2$export$e32eeae4866f112c),
        (0, $12ee831723ccf9c2$export$d6f1616882408daa),
        (0, $12ee831723ccf9c2$export$82db1960569473ff)
    ];
    const selectedFilters = [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const [filterKey, filterValue] of Object.entries(filters)){
        if (filterKey === (0, $12ee831723ccf9c2$export$3b798637a628dacc)) /**
			 * A bit of context before starting to engineer the special case of custom fields
			 * When there are custom fields in the plan, the "filters" object includes the following key / value pair
			 * {
			 *   state.domain.view-settings.filters.CUSTOM_FIELD_FILTER_ID: {
			 *      id: "state.domain.view-settings.filters.CUSTOM_FIELD_FILTER_ID",
			 *      value: {
			 *          10201: ["10101"],
			 *          10202: [],
			 *          10203: ["10105", "10107"],
			 *      }
			 *  }
			 * in this example, the user:
			 * - selected one option in the custom field 10201 filter
			 * - did NOT select any options in the custom field 10202 filter (empty array)
			 * - selected two options in the custom field 10203 filter
			 *
			 * For each key / value pair of the filterValue object i.e.
			 * { 10201: ["10101"], 10202: [], 10203: ["10105", "10107"] }
			 * we get the custom field type key e.g. com.atlassian.jira.plugin.system.customfieldtypes:multiselect
			 *
			 *  Since there might be several custom fields with the same type (e.g. 2 MultiSelect custom fields), we either
			 * - increment the current count value if the selectedFilters object has already that custom field type
			 * - set the count value to "1" if the selectedFilters object does not yet have that custom field type
			 */ for (const [customFieldId, selectedOptionsIds] of Object.entries(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $kjklK.default([
            'value'
        ], filterValue))){
            const customFieldTypeKey = $kjklK.default([
                'type',
                'key'
            ], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            customFieldsById[customFieldId]);
            if ((0, $7CnHa.isDefined)(customFieldTypeKey) && selectedOptionsIds && selectedOptionsIds.length) selectedFilters.push(customFieldTypeKey);
        }
        else if (filterKey === (0, $12ee831723ccf9c2$export$a849f806e27a57e8) && $kjklK.default([
            'value',
            'type'
        ], filterValue) !== 'off') // when the user is filtering on dependencies, a value will be defined and its type will be different than "off"
        selectedFilters.push(filterKey);
        else if (filterKey === (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)) {
            // for the hierarchy, we are looking at the "start" and "end" values and assign it to their respective keys
            hierarchyLevels.start = $kjklK.default([
                'value',
                'start'
            ], filterValue) || (0, $8YqJS.SUB_TASK_LEVEL);
            hierarchyLevels.end = $kjklK.default([
                'value',
                'end'
            ], filterValue) || (0, $8YqJS.SUB_TASK_LEVEL);
        } else if ((filterKey === (0, $12ee831723ccf9c2$export$e32eeae4866f112c) || filterKey === (0, $12ee831723ccf9c2$export$d6f1616882408daa)) && $kjklK.default([
            'value'
        ], filterValue)) // for "Summary" and "Warnings" filters, they DO remain in the filters state even if the user does not filter
        // on them anymore, hence why we check whether the "value" is actually defined
        selectedFilters.push(filterKey);
        else if (filterValue.id === (0, $12ee831723ccf9c2$export$82db1960569473ff) && (filterValue.value?.startDate || filterValue.value?.endDate)) selectedFilters.push(filterKey);
        else if (!ignoredFilters.includes(filterKey)) {
            // for all other filters: checking if their key is included in the selectedFilters object (this check is there to
            // prevent unwanted keys - such as state.domain.filters.ISSUE_TYPES_FILTER_ID - to be added to the selectedFilters object)
            // this line looks overkill, but is necessary to keep Flow happy
            const selectedFilterValue = $kjklK.default([
                'value'
            ], filterValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (selectedFilterValue && selectedFilterValue.length) selectedFilters.push(filterKey);
        }
    }
    return {
        selectedFilters: selectedFilters,
        hierarchyLevels: hierarchyLevels
    };
};
const $a55e8108c902e8c9$export$537d4ab858fa5f4a = ({ value: value })=>$kDrtX.default(value) || $b3iuB.default(value) || value.type === 'off' || value === false;
const $a55e8108c902e8c9$export$573fe4d6049b5e1b = (customFieldCount, isAtlasConnectInstalledCheck, { [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: _, [(0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)]: __, [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: ___, ...remainingFilters })=>{
    const nonEmptyFilters = Object.entries(remainingFilters)// eslint-disable-next-line @typescript-eslint/no-shadow
    .filter(([_, filter])=>!$a55e8108c902e8c9$export$537d4ab858fa5f4a(filter))// eslint-disable-next-line @typescript-eslint/no-shadow
    .map(([filterId, _])=>filterId);
    // avoid double counting issue type and status filters
    let adjustment = 0;
    if (nonEmptyFilters.indexOf((0, $12ee831723ccf9c2$export$9b51ec1115932c53)) > -1 && nonEmptyFilters.indexOf((0, $12ee831723ccf9c2$export$e3608e8ffa9df136)) > -1) adjustment += 1;
    if (nonEmptyFilters.indexOf((0, $12ee831723ccf9c2$export$a8ec3260a009d752)) > -1 && nonEmptyFilters.indexOf((0, $12ee831723ccf9c2$export$ef1873c24394b0a7)) > -1) adjustment += 1;
    if (!isAtlasConnectInstalledCheck && nonEmptyFilters.includes((0, $12ee831723ccf9c2$export$861e775e082be75a))) adjustment += 1;
    return customFieldCount + nonEmptyFilters.length - adjustment;
};
const $a55e8108c902e8c9$export$93837b363b30db3a = (0, $iK4oF.createSelector)([
    (0, $fiZs1.getCustomFieldFilterCount),
    (0, $dhHiZ.isAtlasConnectInstalled),
    $a55e8108c902e8c9$export$1933a9fe712fc1fd
], $a55e8108c902e8c9$export$573fe4d6049b5e1b);
const $a55e8108c902e8c9$export$bdb6d3f30d16cca7 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state);
const $a55e8108c902e8c9$export$ff9a17ccab304c79 = {
    [(0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8)]: (0, $68BNT.applyFilter),
    [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: (0, $6UAvZ.applyFilter),
    [(0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)]: (0, $eFzGj.applyHierarchyRangeFilter),
    [(0, $12ee831723ccf9c2$export$53e2f8996e102881)]: (0, $3nT5G.applyFilter),
    [(0, $12ee831723ccf9c2$export$8abe69ceb26771cd)]: (0, $3Fte6.applyFilter),
    [(0, $12ee831723ccf9c2$export$43596ee088b165a)]: (0, $aYCQt.applyFilter),
    [(0, $12ee831723ccf9c2$export$20140793a0aa2b3c)]: (0, $f436g.applyFilter),
    [(0, $12ee831723ccf9c2$export$e32eeae4866f112c)]: (0, $77IHm.applyFilter),
    [(0, $12ee831723ccf9c2$export$a849f806e27a57e8)]: (0, $bRpYp.applyFilter),
    [(0, $12ee831723ccf9c2$export$7e257b719377371e)]: (0, $5Rz3d.applyFilter),
    [(0, $12ee831723ccf9c2$export$9b51ec1115932c53)]: (0, $5mAJ1.applyFilter),
    [(0, $12ee831723ccf9c2$export$6022538efc28a609)]: (0, $2c08V.applyFilter),
    [(0, $12ee831723ccf9c2$export$d6f1616882408daa)]: (0, $kahmZ.applyFilter),
    [(0, $12ee831723ccf9c2$export$59af687b450af7eb)]: (0, $Z7Mx2.applyFilter),
    [(0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)]: (0, $7hbkF.applyFilter),
    [(0, $12ee831723ccf9c2$export$a8ec3260a009d752)]: (0, $gqs5m.applyFilter),
    [(0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d)]: (0, $2vV9U.applyFilter),
    [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: (0, $fiZs1.applyFilter),
    [(0, $12ee831723ccf9c2$export$861e775e082be75a)]: (0, $kOHCR.applyFilter),
    [(0, $12ee831723ccf9c2$export$82db1960569473ff)]: (0, $imCER.applyFilter)
};
function $a55e8108c902e8c9$export$c6f8482e724e56c5(filters, optimizedMode, customFields, issue, options = {}) {
    const exclude = options.exclude || [];
    for (const filterId of $erwaN.default(filters)){
        const filterFn = $a55e8108c902e8c9$export$ff9a17ccab304c79[filterId];
        if (typeof filterFn === 'function' && !exclude.includes(filterId)) {
            if (filterId === (0, $12ee831723ccf9c2$export$3b798637a628dacc)) {
                if (!filterFn(issue, filters[filterId], customFields)) return false;
            } else if (!filterFn(issue, filters[filterId], optimizedMode)) return false;
        }
    }
    return true;
}
function $a55e8108c902e8c9$export$a494cbe4bae883bb(filters, optimizedMode, customFields, issue) {
    const customFieldsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), customFields);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const appliedCustomFilters = (filters)=>{
        const customFilters = [];
        for (const [key, value] of Object.entries(filters))// if the value is not an empty array, the plan is filtered on that custom field
        if (value && value.length) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        customFilters.push(customFieldsById[key]);
        return customFilters;
    };
    const unmatchedList = [];
    for (const filterId of $erwaN.default(filters)){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const filterFn = $a55e8108c902e8c9$export$ff9a17ccab304c79[filterId];
        if (typeof filterFn === 'function') {
            if (filterId === (0, $12ee831723ccf9c2$export$3b798637a628dacc)) {
                if (!filterFn(issue, filters[filterId], customFields)) unmatchedList.push({
                    id: filterId,
                    type: 'custom',
                    filters: appliedCustomFilters(filters[filterId].value)
                });
            } else if (!filterFn(issue, filters[filterId], optimizedMode)) unmatchedList.push({
                id: filterId,
                type: 'standard',
                filters: []
            });
        }
    }
    return unmatchedList;
}

});
parcelRegister("b3iuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $80be51ca7caf53e9$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $iYf9Q = parcelRequire("iYf9Q");

var $5OdRK = parcelRequire("5OdRK");
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var $80be51ca7caf53e9$var$isEmpty = /*#__PURE__*/ (0, $eSWTK.default)(function isEmpty(x) {
    return x != null && (0, $5OdRK.default)(x, (0, $iYf9Q.default)(x));
});
var $80be51ca7caf53e9$export$2e2bcd8739ae039 = $80be51ca7caf53e9$var$isEmpty;

});
parcelRegister("iYf9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf9969fafee86cb$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $20J5D = parcelRequire("20J5D");

var $dPJMs = parcelRequire("dPJMs");

var $ktV10 = parcelRequire("ktV10");

var $faRtN = parcelRequire("faRtN");
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var $dcf9969fafee86cb$var$empty = /*#__PURE__*/ (0, $eSWTK.default)(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : (0, $dPJMs.default)(x) ? [] : (0, $faRtN.default)(x) ? '' : (0, $ktV10.default)(x) ? {} : (0, $20J5D.default)(x) ? function() {
        return arguments;
    }() : void 0 // else
    ;
});
var $dcf9969fafee86cb$export$2e2bcd8739ae039 = $dcf9969fafee86cb$var$empty;

});


parcelRegister("fiZs1", function(module, exports) {

$parcel$export(module.exports, "NO_CUSTOM_FIELD_VALUE_ID", () => $e7f075cf11f7dd97$export$ee2197aa1f91e426);
$parcel$export(module.exports, "applyFilter", () => $e7f075cf11f7dd97$export$1b001418845b471c);
$parcel$export(module.exports, "getCustomFieldFilter", () => $e7f075cf11f7dd97$export$bdbfb790183fd77b);
$parcel$export(module.exports, "getCustomFieldFilterCount", () => $e7f075cf11f7dd97$export$673e7236e5e3896);
$parcel$export(module.exports, "getCustomFieldsWithFilteringAllowed", () => $e7f075cf11f7dd97$export$9eed4354878b09d1);

var $b3iuB = parcelRequire("b3iuB");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $kKj1m = parcelRequire("kKj1m");

var $V8UZp = parcelRequire("V8UZp");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $e7f075cf11f7dd97$export$ee2197aa1f91e426 = (0, $5rYNM.UNDEFINED_KEY);
const $e7f075cf11f7dd97$export$1b001418845b471c = (issue, customFieldFilter, customFields)=>{
    const matches = Object.keys(customFieldFilter.value).map((fieldId)=>{
        const customField = customFields.find(({ id: id })=>id === Number(fieldId));
        const filterValue = customFieldFilter.value[fieldId];
        const attribute = issue.customFields && issue.customFields[fieldId];
        if (!(0, $7CnHa.isDefined)(customField)) throw new Error('customField not found for the filter');
        switch(customField.type.key){
            case (0, $5rYNM.CustomFieldTypes).Labels:
            case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
            case (0, $5rYNM.CustomFieldTypes).AssetObject:
            case (0, $5rYNM.CustomFieldTypes).MultiSelect:
                {
                    if (!(0, $cofZt.default)()) {
                        if (customField.type.key === (0, $5rYNM.CustomFieldTypes).AssetObject) return true;
                    }
                    const emptyFilter = filterValue.length === 0;
                    if (emptyFilter) return true;
                    const matchable = attribute instanceof Array && !$b3iuB.default(attribute) ? attribute : [
                        $e7f075cf11f7dd97$export$ee2197aa1f91e426
                    ];
                    return (0, $V8UZp.matchFilter)(filterValue, matchable);
                }
            case (0, $5rYNM.CustomFieldTypes).RadioButtons:
            case (0, $5rYNM.CustomFieldTypes).SingleSelect:
                {
                    if (!Array.isArray(filterValue)) throw new Error(`value of filter for ${customField.title} is not an array`);
                    const emptyFilter = filterValue.length === 0;
                    if (emptyFilter) return true;
                    const matchable = attribute ? [
                        attribute
                    ] : [
                        $e7f075cf11f7dd97$export$ee2197aa1f91e426
                    ];
                    return (0, $V8UZp.matchFilter)(filterValue, matchable);
                }
            default:
                return true;
        }
    });
    return matches.reduce((a, b)=>a && b, true);
};
const $e7f075cf11f7dd97$var$getRawCustomFieldFilter = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$3b798637a628dacc] || {
        id: (0, $12ee831723ccf9c2$export$3b798637a628dacc),
        value: {}
    };
const $e7f075cf11f7dd97$export$bdbfb790183fd77b = (0, $iK4oF.createSelector)([
    $e7f075cf11f7dd97$var$getRawCustomFieldFilter,
    (0, $kKj1m.getCustomFields)
], (customFieldFilter, customFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = customFields.reduce((acc, customField)=>{
        const id = String(customField.id);
        const filterValue = customFieldFilter.value[id];
        switch(customField.type.key){
            case (0, $5rYNM.CustomFieldTypes).Labels:
            case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
            case (0, $5rYNM.CustomFieldTypes).AssetObject:
            case (0, $5rYNM.CustomFieldTypes).MultiSelect:
            case (0, $5rYNM.CustomFieldTypes).RadioButtons:
            case (0, $5rYNM.CustomFieldTypes).SingleSelect:
                if (!(0, $cofZt.default)()) {
                    if (customField.type.key === (0, $5rYNM.CustomFieldTypes).AssetObject) return acc;
                }
                if (!Array.isArray(filterValue)) return Object.assign(acc, {
                    [id]: []
                });
                return Object.assign(acc, {
                    [id]: filterValue
                });
            default:
                return acc;
        }
    }, {});
    return {
        ...customFieldFilter,
        value: value
    };
});
const $e7f075cf11f7dd97$var$getCustomFieldFilterCountPure = (customFieldFilter, customFields)=>{
    if (customFields.length === 0) return 0;
    return Object.keys(customFieldFilter.value).reduce((count, fieldId)=>{
        const customField = customFields.find(({ id: id })=>id === Number(fieldId));
        const filterValue = customFieldFilter.value[fieldId];
        if (!(0, $7CnHa.isDefined)(customField)) throw new Error('customField not found for the filter');
        switch(customField.type.key){
            case (0, $5rYNM.CustomFieldTypes).Labels:
            case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
            case (0, $5rYNM.CustomFieldTypes).AssetObject:
            case (0, $5rYNM.CustomFieldTypes).MultiSelect:
            case (0, $5rYNM.CustomFieldTypes).RadioButtons:
            case (0, $5rYNM.CustomFieldTypes).SingleSelect:
                if (!(0, $cofZt.default)()) {
                    if (customField.type.key === (0, $5rYNM.CustomFieldTypes).AssetObject) return count;
                }
                if (!Array.isArray(filterValue)) throw new Error(`value of filter for ${customField.title} is not an array`);
                return filterValue.length > 0 ? count + 1 : count;
            default:
                return count;
        }
    }, 0);
};
const $e7f075cf11f7dd97$export$673e7236e5e3896 = (0, $iK4oF.createSelector)([
    $e7f075cf11f7dd97$export$bdbfb790183fd77b,
    (0, $kKj1m.getCustomFields)
], (customFieldFilter, customFields)=>$e7f075cf11f7dd97$var$getCustomFieldFilterCountPure(customFieldFilter, customFields));
const $e7f075cf11f7dd97$export$9eed4354878b09d1 = (0, $iK4oF.createSelector)([
    (0, $kKj1m.getFilterableCustomFields)
], (customFields)=>customFields.filter((field)=>field.filteringAllowed));

});
parcelRegister("V8UZp", function(module, exports) {

$parcel$export(module.exports, "matchFilter", () => $2210b120323755c6$export$c6f8482e724e56c5);
$parcel$export(module.exports, "applyFilter", () => $2210b120323755c6$export$1b001418845b471c);

var $lqxEm = parcelRequire("lqxEm");
var $b3iuB = parcelRequire("b3iuB");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
function $2210b120323755c6$export$c6f8482e724e56c5(filterValue, attrValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return attrValue.some((v)=>filterValue.includes(v));
}
const $2210b120323755c6$export$1b001418845b471c = (issue, filterValue, attrName, optimizedMode)=>{
    if (!filterValue || filterValue.length === 0) return true;
    const attrValue = optimizedMode ? [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ...issue.assignments.map((el)=>el[attrName]).filter((el)=>el),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issue[attrName]
    ] : issue[attrName];
    if (attrValue instanceof Array) {
        const matchable = $b3iuB.default(attrValue) ? [
            (0, $5rYNM.UNDEFINED_KEY)
        ] : $lqxEm.default(attrValue);
        return $2210b120323755c6$export$c6f8482e724e56c5(filterValue, matchable);
    }
    const matchable = !(0, $7CnHa.isDefined)(attrValue) ? [
        (0, $5rYNM.UNDEFINED_KEY)
    ] : [
        attrValue
    ];
    return $2210b120323755c6$export$c6f8482e724e56c5(filterValue, matchable);
};

});
parcelRegister("lqxEm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f99620d909e70805$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $bNA4U = parcelRequire("bNA4U");
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $f99620d909e70805$var$flatten = /*#__PURE__*/ (0, $eSWTK.default)(/*#__PURE__*/ (0, $bNA4U.default)(true));
var $f99620d909e70805$export$2e2bcd8739ae039 = $f99620d909e70805$var$flatten;

});
parcelRegister("bNA4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $897041aeba25bb07$export$2e2bcd8739ae039);

var $b3lcT = parcelRequire("b3lcT");
function $897041aeba25bb07$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $b3lcT.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

});



const $12ee831723ccf9c2$export$9ca65f4dca18a9fc = 'state.domain.view-settings.filters.HIERARCHY_FILTER_ID';
const $12ee831723ccf9c2$export$c4a2a48e7b94aaa5 = 'state.domain.view-settings.filters.HIERARCHY_RANGE_FILTER_ID';
const $12ee831723ccf9c2$export$d0da0a0b0cd817d8 = 'state.domain.view-settings.filters.PROJECT_FILTER_ID';
const $12ee831723ccf9c2$export$585fb3e81bcfccad = 'state.domain.view-settings.filters.CROSS_PROJECT_RELEASE_FILTER_ID';
const $12ee831723ccf9c2$export$53e2f8996e102881 = 'state.domain.view-settings.filters.RELEASE_FILTER_ID';
const $12ee831723ccf9c2$export$8abe69ceb26771cd = 'state.domain.view-settings.filters.TEAM_FILTER_ID';
const $12ee831723ccf9c2$export$43596ee088b165a = 'state.domain.view-settings.filters.ASSIGNEE_FILTER_ID';
const $12ee831723ccf9c2$export$20140793a0aa2b3c = 'state.domain.view-settings.filters.REPORTER_FILTER_ID';
const $12ee831723ccf9c2$export$e32eeae4866f112c = 'state.domain.view-settings.filters.SUMMARY_FILTER_ID';
const $12ee831723ccf9c2$export$a849f806e27a57e8 = 'state.domain.view-settings.filters.DEPENDENCIES_FILTER_ID';
const $12ee831723ccf9c2$export$7e257b719377371e = 'state.domain.view-settings.filters.LABEL_FILTER_ID';
const $12ee831723ccf9c2$export$6022538efc28a609 = 'state.domain.view-settings.filters.COMPONENT_FILTER_ID';
const $12ee831723ccf9c2$export$e3608e8ffa9df136 = 'state.domain.view-settings.filters.STATUS_FILTER_ID';
const $12ee831723ccf9c2$export$9b51ec1115932c53 = 'state.domain.view-settings.filters.STATUS_KEY_FILTER_ID';
const $12ee831723ccf9c2$export$d6f1616882408daa = 'state.domain.view-settings.filters.WARNING_FILTER_ID';
const $12ee831723ccf9c2$export$59af687b450af7eb = 'state.domain.view-settings.filters.ISSUE_WARNING_FILTER_ID';
const $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb = 'state.domain.view-settings.filters.SPRINT_FILTER_ID';
const $12ee831723ccf9c2$export$861e775e082be75a = 'state.domain.view-settings.filters.GOAL_FILTER_ID';
const $12ee831723ccf9c2$export$ef1873c24394b0a7 = 'state.domain.view-settings.filters.ISSUE_TYPES_FILTER_ID';
const $12ee831723ccf9c2$export$a8ec3260a009d752 = 'state.domain.view-settings.filters.ISSUE_TYPE_KEY_FILTER_ID';
const $12ee831723ccf9c2$export$b6fe2739dbbe2e5d = 'state.domain.view-settings.filters.ISSUE_PRIORITIES_FILTER_ID';
const $12ee831723ccf9c2$export$3b798637a628dacc = 'state.domain.view-settings.filters.CUSTOM_FIELD_FILTER_ID';
const $12ee831723ccf9c2$export$82db1960569473ff = 'state.domain.view-settings.filters.DATE_RANGE_FILTER_ID';
const $12ee831723ccf9c2$export$f4ac8734c859ca93 = 'roadmap';
const $12ee831723ccf9c2$export$eb2de919d11696d = 'release';


parcelRegister("dhHiZ", function(module, exports) {

$parcel$export(module.exports, "getSystemInfo", () => $b0eb2c40f8c4df7b$export$d51248ece03722d6);
$parcel$export(module.exports, "getAgileInfo", () => $b0eb2c40f8c4df7b$export$2e685c300dc2bca1);
$parcel$export(module.exports, "getJiraHoursPerDay", () => $b0eb2c40f8c4df7b$export$6052ef45443f5a7c);
$parcel$export(module.exports, "getLoadingLimitsInfo", () => $b0eb2c40f8c4df7b$export$8b9416d87c4e395c);
$parcel$export(module.exports, "getDateFormat", () => $b0eb2c40f8c4df7b$export$fa96065c64444af6);
$parcel$export(module.exports, "getIssueLinkTypesInfo", () => $b0eb2c40f8c4df7b$export$d4e01b8a05970fd7);
$parcel$export(module.exports, "getDependencySettingsInfo", () => $b0eb2c40f8c4df7b$export$a452921f8f88500f);
$parcel$export(module.exports, "getFiscalMonth", () => $b0eb2c40f8c4df7b$export$b4f0c59b6883adbf);
$parcel$export(module.exports, "isNonPublishingEditor", () => $b0eb2c40f8c4df7b$export$f0c949045c6f435d);
$parcel$export(module.exports, "getInstanceUserRole", () => $b0eb2c40f8c4df7b$export$f07b48fa83dcf606);
$parcel$export(module.exports, "isAtlasConnectInstalled", () => $b0eb2c40f8c4df7b$export$fe67de28f66ce62b);
$parcel$export(module.exports, "getHasAtlasPermissions", () => $b0eb2c40f8c4df7b$export$eb44a0ec15e48ae);

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $b0eb2c40f8c4df7b$export$d51248ece03722d6 = (state)=>state.domain.system.systemInfo;
const $b0eb2c40f8c4df7b$export$2e685c300dc2bca1 = (state)=>state.domain.system.agileInfo;
const $b0eb2c40f8c4df7b$export$6052ef45443f5a7c = (state)=>state.domain.system.systemInfo.jiraHoursPerDay;
const $b0eb2c40f8c4df7b$export$8b9416d87c4e395c = (state)=>state.domain.system.loadingLimitsInfo;
const $b0eb2c40f8c4df7b$export$fa96065c64444af6 = (state)=>state.domain.system.systemInfo.lookAndFeel.dateFormat;
const $b0eb2c40f8c4df7b$export$d4e01b8a05970fd7 = (state)=>state.domain.system.issueLinkTypesInfo;
const $b0eb2c40f8c4df7b$export$a452921f8f88500f = (state)=>state.domain.system.dependencySettingsInfo;
const $b0eb2c40f8c4df7b$export$b4f0c59b6883adbf = (state)=>state.domain.system.systemInfo.fiscalMonth;
const $b0eb2c40f8c4df7b$export$6728be6ff2068a47 = (0, $iK4oF.createSelector)([
    $b0eb2c40f8c4df7b$export$d51248ece03722d6
], (systemInfo)=>systemInfo.permission);
const $b0eb2c40f8c4df7b$export$f0c949045c6f435d = (0, $iK4oF.createSelector)([
    $b0eb2c40f8c4df7b$export$d51248ece03722d6
], (systemInfo)=>systemInfo.permission === (0, $5rYNM.PLUGIN_PERMISSION).NON_PUBLISHING_EDITOR && !systemInfo.isAdmin);
const $b0eb2c40f8c4df7b$export$f07b48fa83dcf606 = (0, $iK4oF.createSelector)([
    $b0eb2c40f8c4df7b$export$d51248ece03722d6
], (systemInfo)=>{
    if (systemInfo.isAdmin) return (0, $5rYNM.INSTANCE_USER_ROLE).ADMIN;
    if (systemInfo.permission === (0, $5rYNM.PLUGIN_PERMISSION).FULL_EDITOR) return (0, $5rYNM.INSTANCE_USER_ROLE).EDITOR;
    if (systemInfo.permission === (0, $5rYNM.PLUGIN_PERMISSION).VIEWER) return (0, $5rYNM.INSTANCE_USER_ROLE).VIEWER;
    if (systemInfo.permission === (0, $5rYNM.PLUGIN_PERMISSION).NON_PUBLISHING_EDITOR) return (0, $5rYNM.INSTANCE_USER_ROLE).RESTRICTED_USER;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return '';
});
const $b0eb2c40f8c4df7b$export$fe67de28f66ce62b = (state)=>state.domain.system.isAtlasConnectInstalled;
const $b0eb2c40f8c4df7b$export$eb44a0ec15e48ae = (state)=>state.domain.system.hasAtlasPermissions;

});

parcelRegister("aYCQt", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $0cdf47c498a6721c$export$1b001418845b471c);
$parcel$export(module.exports, "getAssigneeForFilter", () => $0cdf47c498a6721c$export$be11142e7392d31);
$parcel$export(module.exports, "getAssigneeFilter", () => $0cdf47c498a6721c$export$9c158e12671c7642);
$parcel$export(module.exports, "ASSIGNEE_FILTER_ID", () => $12ee831723ccf9c2$export$43596ee088b165a);

var $lyOYo = parcelRequire("lyOYo");

var $6VhAf = parcelRequire("6VhAf");

var $V8UZp = parcelRequire("V8UZp");

var $f6g5r = parcelRequire("f6g5r");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $0cdf47c498a6721c$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'assignee', optimizedMode);
const $0cdf47c498a6721c$var$getTeamsAssignees = (0, $iK4oF.createSelector)([
    (0, $f6g5r.getTeamsPersons),
    (0, $6VhAf.getAssigneeList)
], (persons, assignees)=>{
    const jiraUserIds = persons.reduce((acc, person)=>{
        if (person.jiraUser) acc.add(person.jiraUser.accountId);
        return acc;
    }, new Set());
    return assignees.filter((assignee)=>jiraUserIds.has(assignee.jiraUser.accountId));
});
const $0cdf47c498a6721c$export$be11142e7392d31 = (0, $iK4oF.createSelector)([
    $0cdf47c498a6721c$var$getTeamsAssignees,
    (0, $6VhAf.getAssigneesOfIssues)
], (teamsAssignees, issuesAssignees)=>(0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...teamsAssignees,
        ...issuesAssignees
    ], ({ personId: personId })=>personId));
const $0cdf47c498a6721c$export$a9062f4ed8b94d99 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$43596ee088b165a] || {
        id: (0, $12ee831723ccf9c2$export$43596ee088b165a),
        value: []
    };
const $0cdf47c498a6721c$export$9c158e12671c7642 = (0, $iK4oF.createSelector)([
    $0cdf47c498a6721c$export$be11142e7392d31,
    $0cdf47c498a6721c$export$a9062f4ed8b94d99
], (assignees, { id: id, value: value = [] })=>{
    const assigneeSet = new Set(assignees.map(({ personId: personId })=>personId));
    return {
        id: id,
        value: value.filter((personId)=>assigneeSet.has(personId))
    };
});

});
parcelRegister("6VhAf", function(module, exports) {

$parcel$export(module.exports, "getAssigneeListFetchStatus", () => $a55b5b26b1a183e1$export$e3b989a9b8bf61ec);
$parcel$export(module.exports, "getIssueIdForFetchAssigneeListProgress", () => $a55b5b26b1a183e1$export$32e3a14387dac47b);
$parcel$export(module.exports, "getAssigneeList", () => $a55b5b26b1a183e1$export$e57275653c7a8d26);
$parcel$export(module.exports, "getAssigneesById", () => $a55b5b26b1a183e1$export$67f3f388d3197338);
$parcel$export(module.exports, "getAssigneesOfIssues", () => $a55b5b26b1a183e1$export$69b494dd078e2e04);

var $f7Op5 = parcelRequire("f7Op5");

var $cwP4d = parcelRequire("cwP4d");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $a55b5b26b1a183e1$export$e3b989a9b8bf61ec = (state)=>state.ui.Main.Tabs.Roadmap.Fields.Assignee.isFetchAssigneeListInProgress;
const $a55b5b26b1a183e1$export$32e3a14387dac47b = (state)=>state.ui.Main.Tabs.Roadmap.Fields.Assignee.issueIdForFetchAssigneeListProgress;
const $a55b5b26b1a183e1$export$e57275653c7a8d26 = (state)=>state.domain.assignees.assigneeList;
const $a55b5b26b1a183e1$export$67f3f388d3197338 = (0, $iK4oF.createSelector)([
    $a55b5b26b1a183e1$export$e57275653c7a8d26
], (assignees)=>(0, $7CnHa.indexBy)($f7Op5.default('personId'), assignees));
const $a55b5b26b1a183e1$export$d6727e3bcb79811f = (issues, assigneeList)=>{
    const assignees = new Set();
    issues.forEach((issue)=>{
        const userId = issue.assignee;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const assignee = assigneeList.find((assignee)=>assignee.jiraUser.accountId === userId);
        if (assignee) assignees.add(assignee);
    });
    return Array.from(assignees);
};
const $a55b5b26b1a183e1$export$69b494dd078e2e04 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    $a55b5b26b1a183e1$export$e57275653c7a8d26
], $a55b5b26b1a183e1$export$d6727e3bcb79811f);

});
parcelRegister("cwP4d", function(module, exports) {

$parcel$export(module.exports, "getAllIssues", () => $a47ef6b6de0c815a$export$7d1865fcc78ac59e);
$parcel$export(module.exports, "getIssuesWithRolledUpDates", () => $a47ef6b6de0c815a$export$34dfe67491b3b80a);
$parcel$export(module.exports, "getIssues", () => $a47ef6b6de0c815a$export$73a53226406d7fe);
$parcel$export(module.exports, "createIssueMapByIdPure", () => $a47ef6b6de0c815a$export$920c5c5c2a4b2e13);
$parcel$export(module.exports, "getIssueMapById", () => $a47ef6b6de0c815a$export$f997fcc0f824766c);
$parcel$export(module.exports, "getScenarioRemovedIssueMapById", () => $a47ef6b6de0c815a$export$5731605119919ca9);
// This module is not supposed to be used from View or Command,
// and exists solely for resolving circular dependencies in the Query
// as issue-related selectors form complex graph of dependencies
// with no clear ownership sometimes.

var $bbUhj = parcelRequire("bbUhj");

var $3fphB = parcelRequire("3fphB");

var $2wtN3 = parcelRequire("2wtN3");
var $eoUrK = parcelRequire("eoUrK");
var $b3iuB = parcelRequire("b3iuB");
var $kbCSE = parcelRequire("kbCSE");
var $gXysT = parcelRequire("gXysT");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");

var $akhOi = parcelRequire("akhOi");

var $kFf60 = parcelRequire("kFf60");
parcelRequire("75KhQ");
var $eOsHk = parcelRequire("eOsHk");
var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $kCccV = parcelRequire("kCccV");

var $853IT = parcelRequire("853IT");

var $a4NMN = parcelRequire("a4NMN");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");

var $aKueD = parcelRequire("aKueD");

var $9H2AP = parcelRequire("9H2AP");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $dJx9o = parcelRequire("dJx9o");
const $a47ef6b6de0c815a$export$7d1865fcc78ac59e = (state)=>state.domain.issues;
const $a47ef6b6de0c815a$export$78e865af1b622bce = (state)=>state.domain.originalIssues;
const $a47ef6b6de0c815a$export$8f046b32de3888d3 = (state)=>state.domain.scenarioRemovedIssues;
const $a47ef6b6de0c815a$var$doesNotBelongToRemovedVersion = (fixVersions, removedVersionsById)=>!(0, $7CnHa.isDefined)(fixVersions) || fixVersions.length === 0 || fixVersions.some((vid)=>!Object.prototype.hasOwnProperty.call(removedVersionsById, vid));
/** When both start and end dates of the issue are empty try to infer them from
 *  the dates of the latest sprint assigned to the issue.
 */ const $a47ef6b6de0c815a$var$inferSprintDates = (sprintsWithFutureDates, issueStatusesById)=>(issue)=>{
        if ((0, $7CnHa.isDefined)(issue.baselineStart) || (0, $7CnHa.isDefined)(issue.baselineEnd)) return issue;
        const sprints = (0, $853IT.getFutureSprintsForIssue)(issue, sprintsWithFutureDates);
        if ($b3iuB.default(sprints)) return issue;
        const { rawStartDate: rawStartDate, rawEndDate: rawEndDate } = (0, $a4NMN.getTargetDatesFromSprints)(issue, sprints, issueStatusesById);
        return {
            ...issue,
            baselineStart: rawStartDate,
            baselineEnd: rawEndDate,
            inferred: {
                baselineStart: (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT,
                baselineEnd: (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT
            }
        };
    };
const $a47ef6b6de0c815a$var$inferReleaseDates = (versions)=>(issue)=>{
        if ((0, $7CnHa.isDefined)(issue.baselineStart) || (0, $7CnHa.isDefined)(issue.baselineEnd)) return issue;
        const targetDates = (0, $aKueD.getTargetDatesFromReleases)(issue, versions);
        if (!(0, $7CnHa.isDefined)(targetDates)) return issue;
        const { startDate: startDate, endDate: endDate } = targetDates;
        if (!(0, $7CnHa.isDefined)(startDate) && !(0, $7CnHa.isDefined)(endDate)) return issue;
        return {
            ...issue,
            baselineStart: startDate,
            baselineEnd: endDate,
            inferred: {
                baselineStart: startDate ? (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE : (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE,
                baselineEnd: endDate ? (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE : (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE
            }
        };
    };
const $a47ef6b6de0c815a$var$appendOptimizedValues = (dateConfiguration, selectedIssuesForCalculation, solution)=>(issue)=>{
        const { assignments: assignments, id: id } = issue;
        if (selectedIssuesForCalculation.length === 0 || selectedIssuesForCalculation.includes(id)) {
            const undefinedIfInsane = (num)=>!(0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(num) ? undefined : num;
            const baselineStart = undefinedIfInsane(assignments.reduce((acc, { start: start })=>Math.min(acc, start || Infinity), Infinity));
            const baselineEnd = undefinedIfInsane(assignments.reduce((acc, { end: end })=>Math.max(acc, end || -Infinity), -Infinity));
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { team: team } = assignments.find(({ team: team })=>(0, $7CnHa.isDefined)(team)) || issue;
            const optimized = {
                baselineStart: (0, $7CnHa.isDefined)(baselineStart) ? baselineStart : issue.baselineStart,
                baselineEnd: (0, $7CnHa.isDefined)(baselineEnd) ? baselineEnd : issue.baselineEnd,
                team: team,
                fixVersions: (0, $dJx9o.getOptimizedFixVersion)(issue, solution),
                sprint: (0, $dJx9o.getOptimizedSprint)(issue, solution)
            };
            return {
                ...issue,
                optimized: {
                    ...optimized,
                    [dateConfiguration.baselineStartField.key]: optimized.baselineStart,
                    [dateConfiguration.baselineEndField.key]: optimized.baselineEnd
                }
            };
        }
        return {
            ...issue,
            optimized: {}
        };
    };
const $a47ef6b6de0c815a$var$getConfiguredDate = (dateField, issue)=>{
    if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issue[dateField.key];
    if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM && (0, $7CnHa.isDefined)(issue.customFields)) return issue.customFields[dateField.key];
    return null;
};
const $a47ef6b6de0c815a$var$seedRolledUpDates = $2wtN3.default({
    baselineStart: Infinity,
    baselineEnd: -Infinity
});
const $a47ef6b6de0c815a$export$34dfe67491b3b80a = (issues)=>{
    const rolledUpDatesById = {};
    const issuesSortedByLevelFromLowerToHigher = $9RbxZ.default($f7Op5.default('level'), issues);
    const rollUpDatesForAnIssue = ({ parent: parent, baselineStart: baselineStart, baselineEnd: baselineEnd })=>{
        const hasAtLeastOneDate = (0, $7CnHa.isDefined)(baselineStart) || (0, $7CnHa.isDefined)(baselineEnd);
        // Children without both dates are ignored during roll-up
        if ((0, $7CnHa.isDefined)(parent) && hasAtLeastOneDate) // defaultTo values are chosen such that a single missing child date will lead to "no date" roll-up.
        rolledUpDatesById[parent] = $eoUrK.default({
            baselineStart: $gXysT.default($2wtN3.default(-Infinity, baselineStart)),
            baselineEnd: $kbCSE.default($2wtN3.default(Infinity, baselineEnd))
        }, $a47ef6b6de0c815a$var$seedRolledUpDates(rolledUpDatesById[parent]));
    };
    return issuesSortedByLevelFromLowerToHigher.map((issue)=>{
        const rolledUpDates = rolledUpDatesById[issue.id];
        if (!rolledUpDates || (0, $7CnHa.isDefined)(issue.baselineStart) && (0, $7CnHa.isDefined)(issue.baselineEnd)) {
            rollUpDatesForAnIssue(issue);
            return issue;
        }
        const transformedIssue = {
            ...issue,
            inferred: issue.inferred || {}
        };
        for (const date of [
            'baselineStart',
            'baselineEnd'
        ])if (!(0, $7CnHa.isDefined)(issue[date])) {
            transformedIssue.inferred[date] = (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
            if (Number.isFinite(rolledUpDates[date])) transformedIssue[date] = rolledUpDates[date];
        }
        rollUpDatesForAnIssue(transformedIssue);
        return transformedIssue;
    });
};
const $a47ef6b6de0c815a$export$ef6f826be9f0f699 = (issues, projects, versionsById, removedVersionsById, allTeams, sprintsWithFutureDates, issueInferredDateSelection, dateConfiguration, issueStatusesById, shouldShowRollUpDates, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode, solution)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    const projectIds = new Set(projects.map((x)=>x.id));
    const allTeamIds = new Set(allTeams.map((x)=>x.id));
    const isNotRemoved = ({ project: project, fixVersions: fixVersions })=>$b3iuB.default(removedVersionsById) ? projectIds.has(project) : projectIds.has(project) && $a47ef6b6de0c815a$var$doesNotBelongToRemovedVersion(fixVersions, removedVersionsById);
    const removeNotExistingTeam = (issue)=>{
        if (issue.team && !allTeamIds.has(issue.team)) return {
            ...issue,
            team: undefined
        };
        return issue;
    };
    const configureBaselineDates = (issue)=>({
            ...issue,
            baselineStart: $a47ef6b6de0c815a$var$getConfiguredDate(baselineStartField, issue),
            baselineEnd: $a47ef6b6de0c815a$var$getConfiguredDate(baselineEndField, issue)
        });
    const transformations = [
        removeNotExistingTeam,
        configureBaselineDates
    ];
    if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT) transformations.push($a47ef6b6de0c815a$var$inferSprintDates(sprintsWithFutureDates, issueStatusesById));
    else if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE) transformations.push($a47ef6b6de0c815a$var$inferReleaseDates(versionsById));
    if (isOptimizedMode) {
        const selectedIssuesForCalculation = solution.calculationConfiguration && solution.calculationConfiguration.selectedIssueIds ? solution.calculationConfiguration.selectedIssueIds : [];
        transformations.push($a47ef6b6de0c815a$var$appendOptimizedValues(dateConfiguration, selectedIssuesForCalculation, solution));
    }
    const transformedIssues = (0, $7CnHa.filterMap)(isNotRemoved, (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))(transformations), issues);
    return shouldShowRollUpDates ? $a47ef6b6de0c815a$export$34dfe67491b3b80a(transformedIssues) : transformedIssues;
};
const $a47ef6b6de0c815a$export$73a53226406d7fe = (0, $iK4oF.createSelector)([
    $a47ef6b6de0c815a$export$7d1865fcc78ac59e,
    (0, $ehEr2.getProjects),
    (0, $wcCGG.getVersionsById),
    (0, $wcCGG.getRemovedVersionsById),
    (0, $MQRDu.getAllTeams),
    (0, $853IT.getSprintsWithFutureDates),
    (0, $75KhQ.getPlanIssueInferredDateSelection),
    (0, $75KhQ.getDateConfiguration),
    (0, $kFf60.getIssueStatusById),
    (0, $9H2AP.getShowRolledUpDates),
    (0, $akhOi.isOptimizedMode),
    (0, $kCccV.getSolution)
], $a47ef6b6de0c815a$export$ef6f826be9f0f699);
const $a47ef6b6de0c815a$export$920c5c5c2a4b2e13 = (issues)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), issues);
const $a47ef6b6de0c815a$export$f997fcc0f824766c = (0, $iK4oF.createSelector)([
    $a47ef6b6de0c815a$export$73a53226406d7fe
], $a47ef6b6de0c815a$export$920c5c5c2a4b2e13);
const $a47ef6b6de0c815a$export$5731605119919ca9 = (0, $iK4oF.createSelector)([
    $a47ef6b6de0c815a$export$8f046b32de3888d3
], $a47ef6b6de0c815a$export$920c5c5c2a4b2e13);

});
parcelRegister("bbUhj", function(module, exports) {

module.exports = (parcelRequire("3omiX"));

});
parcelRegister("3omiX", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $2784ea3ef613cf7e$var$func = $jFIrw('flow', (parcelRequire("c8Guq")));

$2784ea3ef613cf7e$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $2784ea3ef613cf7e$var$func;

});


parcelRegister("3fphB", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $25d6627b2429993c$var$nativeIsFinite = $c1MCs.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $25d6627b2429993c$var$isFinite(value) {
    return typeof value == 'number' && $25d6627b2429993c$var$nativeIsFinite(value);
}
module.exports = $25d6627b2429993c$var$isFinite;

});

parcelRegister("2wtN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d65ada66a94a420$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $1d65ada66a94a420$var$defaultTo = /*#__PURE__*/ (0, $ggdJA.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $1d65ada66a94a420$export$2e2bcd8739ae039 = $1d65ada66a94a420$var$defaultTo;

});

parcelRegister("eoUrK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7bf17b4874a101e$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $a7bf17b4874a101e$var$evolve = /*#__PURE__*/ (0, $ggdJA.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $a7bf17b4874a101e$export$2e2bcd8739ae039 = $a7bf17b4874a101e$var$evolve;

});

parcelRegister("kbCSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb22fe9434133c9d$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $eb22fe9434133c9d$var$max = /*#__PURE__*/ (0, $ggdJA.default)(function max(a, b) {
    return b > a ? b : a;
});
var $eb22fe9434133c9d$export$2e2bcd8739ae039 = $eb22fe9434133c9d$var$max;

});

parcelRegister("gXysT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58ce40af11a256a$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $c58ce40af11a256a$var$min = /*#__PURE__*/ (0, $ggdJA.default)(function min(a, b) {
    return b < a ? b : a;
});
var $c58ce40af11a256a$export$2e2bcd8739ae039 = $c58ce40af11a256a$var$min;

});

parcelRegister("9RbxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d205507d909cbd$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $72d205507d909cbd$var$sortBy = /*#__PURE__*/ (0, $ggdJA.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $72d205507d909cbd$export$2e2bcd8739ae039 = $72d205507d909cbd$var$sortBy;

});

parcelRegister("kFf60", function(module, exports) {

$parcel$export(module.exports, "getIssueStatuses", () => $0da997fbd77f3213$export$62f3835c38e7545f);
$parcel$export(module.exports, "getIssueStatusById", () => $0da997fbd77f3213$export$6da1c7e84cedf7);
$parcel$export(module.exports, "getIssueStatusByKey", () => $0da997fbd77f3213$export$17d3a761803fe8b8);
$parcel$export(module.exports, "getIssueStatusByIdForCompanyManagedProjects", () => $0da997fbd77f3213$export$422f19a1ad3809f8);

var $fcWBJ = parcelRequire("fcWBJ");

var $9BtCH = parcelRequire("9BtCH");

var $1urNG = parcelRequire("1urNG");

var $ehEr2 = parcelRequire("ehEr2");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $0da997fbd77f3213$export$62f3835c38e7545f = (state)=>state.domain.issueStatuses;
const $0da997fbd77f3213$var$getIssueStatusByIdMap = (statuses)=>(0, $7CnHa.indexBy)((status)=>status.id, statuses);
const $0da997fbd77f3213$export$6da1c7e84cedf7 = (0, $iK4oF.createSelector)([
    $0da997fbd77f3213$export$62f3835c38e7545f
], $0da997fbd77f3213$var$getIssueStatusByIdMap);
const $0da997fbd77f3213$export$17d3a761803fe8b8 = (0, $iK4oF.createSelector)([
    $0da997fbd77f3213$export$62f3835c38e7545f
], (statuses)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(statuses, ({ categoryId: categoryId, name: name })=>`${categoryId} ${name}`));
const $0da997fbd77f3213$var$getIssueStatusTypeIdsOfCompanyManagedProjects = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getCompanyManagedProjects)
], (projects)=>(0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(projects, (current, { issueStatusIds: issueStatusIds })=>(0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))(issueStatusIds, current), []));
const $0da997fbd77f3213$export$422f19a1ad3809f8 = (0, $iK4oF.createSelector)([
    $0da997fbd77f3213$export$62f3835c38e7545f,
    $0da997fbd77f3213$var$getIssueStatusTypeIdsOfCompanyManagedProjects
], (issueStatuses, issueStatusIdsOfCompanyManagedProjects)=>issueStatuses.filter((issueStatus)=>issueStatusIdsOfCompanyManagedProjects.includes(issueStatus.id)));

});
parcelRegister("9BtCH", function(module, exports) {

var $flmMe = parcelRequire("flmMe");

var $awetI = parcelRequire("awetI");

var $7qARj = parcelRequire("7qARj");

var $jhbYY = parcelRequire("jhbYY");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6fde8c506e131c3e$var$reduce(collection, iteratee, accumulator) {
    var func = $1c8hB(collection) ? $flmMe : $jhbYY, initAccum = arguments.length < 3;
    return func(collection, $7qARj(iteratee, 4), accumulator, initAccum, $awetI);
}
module.exports = $6fde8c506e131c3e$var$reduce;

});
parcelRegister("jhbYY", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $e088e655a3a9a31d$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $e088e655a3a9a31d$var$baseReduce;

});


parcelRegister("1urNG", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $115e28588d963fcd$var$union = $9eFtX(function(arrays) {
    return $42tFs($hKE3p(arrays, 1, $cRpul, true));
});
module.exports = $115e28588d963fcd$var$union;

});

parcelRegister("ehEr2", function(module, exports) {

$parcel$export(module.exports, "getProjects", () => $a0ec28b8069b9b4a$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProjectsById", () => $a0ec28b8069b9b4a$export$c1c858cbec61800c);
$parcel$export(module.exports, "getCompanyManagedProjects", () => $a0ec28b8069b9b4a$export$bb44f8d3716d4f81);
$parcel$export(module.exports, "getTeamManagedProjects", () => $a0ec28b8069b9b4a$export$16d1d0520626b714);
$parcel$export(module.exports, "getTeamManagedProjectsSortedByName", () => $a0ec28b8069b9b4a$export$f3912c620acff892);
$parcel$export(module.exports, "getIsSimplifiedProjectAvailable", () => $a0ec28b8069b9b4a$export$18a4e9a6f18c938b);
$parcel$export(module.exports, "getDefaultProjectId", () => $a0ec28b8069b9b4a$export$ac9e364a395b5304);
$parcel$export(module.exports, "getIssuePriorityIdsByProjectId", () => $a0ec28b8069b9b4a$export$327c22d922f3f070);
$parcel$export(module.exports, "getDefaultIssuePriorityByProjectId", () => $a0ec28b8069b9b4a$export$3b205f854fdaea78);
$parcel$export(module.exports, "getReleasesDisabledProject", () => $a0ec28b8069b9b4a$export$1f93e90bc93b7dd3);

var $607C7 = parcelRequire("607C7");
var $fpul1 = parcelRequire("fpul1");
var $i0RGP = parcelRequire("i0RGP");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");
var $l7xwn = parcelRequire("l7xwn");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $a0ec28b8069b9b4a$export$b00a271f69f3d728 = (state)=>state.domain.projects;
const $a0ec28b8069b9b4a$export$c1c858cbec61800c = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], (projects)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), projects));
const $a0ec28b8069b9b4a$export$bb44f8d3716d4f81 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $fpul1.default(({ isSimplified: isSimplified })=>!isSimplified));
const $a0ec28b8069b9b4a$export$16d1d0520626b714 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $fpul1.default(({ isSimplified: isSimplified })=>isSimplified));
const $a0ec28b8069b9b4a$export$f3912c620acff892 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$16d1d0520626b714
], $l7xwn.default((a, b)=>a.name.localeCompare(b.name)));
const $a0ec28b8069b9b4a$export$18a4e9a6f18c938b = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $607C7.default($f7Op5.default('isSimplified')));
const $a0ec28b8069b9b4a$var$getDefaultProjectIdPure = (projects)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const defaultProject = $i0RGP.default($h3f0m.default('isDefault', true))(projects) || {
        id: undefined
    };
    return defaultProject.id;
};
const $a0ec28b8069b9b4a$export$ac9e364a395b5304 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $a0ec28b8069b9b4a$var$getDefaultProjectIdPure);
const $a0ec28b8069b9b4a$export$1b195f62369b1585 = (projects)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    projects.reduce((acc, project)=>Object.assign(acc, {
            [project.id]: project.issuePriorityIds
        }), {});
const $a0ec28b8069b9b4a$export$327c22d922f3f070 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $a0ec28b8069b9b4a$export$1b195f62369b1585);
const $a0ec28b8069b9b4a$export$bcff2c2aa178e37a = (projects)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    projects.reduce((acc, project)=>Object.assign(acc, {
            [project.id]: project.defaultIssuePriorityId
        }), {});
const $a0ec28b8069b9b4a$export$3b205f854fdaea78 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $a0ec28b8069b9b4a$export$bcff2c2aa178e37a);
const $a0ec28b8069b9b4a$export$1f93e90bc93b7dd3 = (0, $iK4oF.createSelector)([
    $a0ec28b8069b9b4a$export$b00a271f69f3d728
], $fpul1.default(({ isReleasesEnabled: isReleasesEnabled })=>!isReleasesEnabled));

});
parcelRegister("607C7", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e8a61c268f21df$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $5q82T = parcelRequire("5q82T");
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $45e8a61c268f21df$var$any = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'any'
], (0, $5q82T.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $45e8a61c268f21df$export$2e2bcd8739ae039 = $45e8a61c268f21df$var$any;

});
parcelRegister("5q82T", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f259f25d89e37a4$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $3f259f25d89e37a4$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XAny.prototype['@@transducer/result'] = function(result) {
        if (!this.any) result = this.xf['@@transducer/step'](result, false);
        return this.xf['@@transducer/result'](result);
    };
    XAny.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $5zr36.default)(this.xf['@@transducer/step'](result, true));
        }
        return result;
    };
    return XAny;
}();
var $3f259f25d89e37a4$var$_xany = /*#__PURE__*/ (0, $ggdJA.default)(function _xany(f, xf) {
    return new $3f259f25d89e37a4$var$XAny(f, xf);
});
var $3f259f25d89e37a4$export$2e2bcd8739ae039 = $3f259f25d89e37a4$var$_xany;

});
parcelRegister("5zr36", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e534097fcb66e6$export$2e2bcd8739ae039);
function $40e534097fcb66e6$export$2e2bcd8739ae039(x) {
    return x && x['@@transducer/reduced'] ? x : {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

});



parcelRegister("i0RGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d1dfc025d2ff2d$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $ccP8L = parcelRequire("ccP8L");
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $d1d1dfc025d2ff2d$var$find = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'find'
], (0, $ccP8L.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $d1d1dfc025d2ff2d$export$2e2bcd8739ae039 = $d1d1dfc025d2ff2d$var$find;

});
parcelRegister("ccP8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e2e4672f456e15a$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $8e2e4672f456e15a$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XFind.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, void 0);
        return this.xf['@@transducer/result'](result);
    };
    XFind.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $5zr36.default)(this.xf['@@transducer/step'](result, input));
        }
        return result;
    };
    return XFind;
}();
var $8e2e4672f456e15a$var$_xfind = /*#__PURE__*/ (0, $ggdJA.default)(function _xfind(f, xf) {
    return new $8e2e4672f456e15a$var$XFind(f, xf);
});
var $8e2e4672f456e15a$export$2e2bcd8739ae039 = $8e2e4672f456e15a$var$_xfind;

});


parcelRegister("h3f0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69e5b1dfc76fd70$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $5OdRK = parcelRequire("5OdRK");
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $c69e5b1dfc76fd70$var$propEq = /*#__PURE__*/ (0, $4g10W.default)(function propEq(name, val, obj) {
    return (0, $5OdRK.default)(val, obj[name]);
});
var $c69e5b1dfc76fd70$export$2e2bcd8739ae039 = $c69e5b1dfc76fd70$var$propEq;

});

parcelRegister("l7xwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f60441063fcebe06$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $f60441063fcebe06$var$sort = /*#__PURE__*/ (0, $ggdJA.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $f60441063fcebe06$export$2e2bcd8739ae039 = $f60441063fcebe06$var$sort;

});



parcelRegister("75KhQ", function(module, exports) {

$parcel$export(module.exports, "getPlan", () => $abe644eb792d5106$export$235c374fac5f5d1b);
$parcel$export(module.exports, "getPlanType", () => $abe644eb792d5106$export$c5009b13f979c1b6);
$parcel$export(module.exports, "getIsSamplePlan", () => $abe644eb792d5106$export$e1349dde19453d1f);
$parcel$export(module.exports, "getIsCrossTeamPlanning", () => $abe644eb792d5106$export$b8d7dd0bfb4fa4fe);
$parcel$export(module.exports, "getPlanTitle", () => $abe644eb792d5106$export$3a977cd83f945733);
$parcel$export(module.exports, "getAutoSchedulerEnabled", () => $abe644eb792d5106$export$c396215c7d30980f);
$parcel$export(module.exports, "getIssueSources", () => $abe644eb792d5106$export$16bdc72ef65977db);
$parcel$export(module.exports, "getPlanningUnit", () => $abe644eb792d5106$export$7bd856f542fb6dc5);
$parcel$export(module.exports, "getSyncStartEnabled", () => $abe644eb792d5106$export$efb081429119caca);
$parcel$export(module.exports, "getIssueSourcesById", () => $abe644eb792d5106$export$8834a5bc0beb2ee5);
$parcel$export(module.exports, "findIssueSourceById", () => $abe644eb792d5106$export$722eb315d83d8783);
$parcel$export(module.exports, "getPlanScenarios", () => $abe644eb792d5106$export$dcfb6bc2956ec132);
$parcel$export(module.exports, "useTwpTeams", () => $abe644eb792d5106$export$25634b1616bed187);
$parcel$export(module.exports, "isMultiScenarioEnabled", () => $abe644eb792d5106$export$5c0e252a3e94185a);
$parcel$export(module.exports, "currentScenarioId", () => $abe644eb792d5106$export$518c73faa0b23138);
$parcel$export(module.exports, "getCurrentScenarioColor", () => $abe644eb792d5106$export$a352f0a83e7a1027);
$parcel$export(module.exports, "getAutoScheduleConfiguration", () => $abe644eb792d5106$export$9e519e3d0791b75);
$parcel$export(module.exports, "getCreatedTimestamp", () => $abe644eb792d5106$export$c25ddf5c19130650);
$parcel$export(module.exports, "getPlanIssueInferredDateSelection", () => $abe644eb792d5106$export$21b3bfe6331442bb);
$parcel$export(module.exports, "getBaselineStartField", () => $abe644eb792d5106$export$27162fa81fdb5f6f);
$parcel$export(module.exports, "getBaselineEndField", () => $abe644eb792d5106$export$c3047bd55ed2ff53);
$parcel$export(module.exports, "getDateConfiguration", () => $abe644eb792d5106$export$6eea2a2f8d211a5c);
$parcel$export(module.exports, "hasWarningInConfiguredDates", () => $abe644eb792d5106$export$f428dfac2965faf0);
$parcel$export(module.exports, "DATEFIELD_TYPES", () => (parcelRequire("eOsHk")).DATEFIELD_TYPES);

var $f7Op5 = parcelRequire("f7Op5");

var $g4Vkx = parcelRequire("g4Vkx");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $eOsHk = parcelRequire("eOsHk");
const $abe644eb792d5106$export$235c374fac5f5d1b = (state)=>state.domain.plan;
const $abe644eb792d5106$export$c5009b13f979c1b6 = (state)=>{
    switch(state.domain.plan.planType){
        case 'CROSS_TEAM':
        case 'CROSS_TEAM_PLANNING':
        case 'SAFE':
            return state.domain.plan.planType;
        default:
            return 'STANDARD';
    }
};
const $abe644eb792d5106$export$e1349dde19453d1f = (state)=>!!state.domain.plan.isSamplePlan;
const $abe644eb792d5106$export$b8d7dd0bfb4fa4fe = (state)=>state.domain.plan.planType === 'CROSS_TEAM_PLANNING';
const $abe644eb792d5106$export$3a977cd83f945733 = (state)=>state.domain.plan.title;
const $abe644eb792d5106$export$c396215c7d30980f = (state)=>!!state.domain.plan.autoSchedulerEnabled;
const $abe644eb792d5106$export$fb7a5df85a35a8d0 = (state)=>!!state.domain.plan.planStatus;
const $abe644eb792d5106$export$16bdc72ef65977db = (state)=>state.domain.plan.issueSources;
const $abe644eb792d5106$export$7bd856f542fb6dc5 = (state)=>state.domain.plan.planningUnit;
const $abe644eb792d5106$export$efb081429119caca = (state)=>state.domain.plan.syncStartEnabled;
const $abe644eb792d5106$export$a78de2f73ee50e7c = (state, issueSourceId)=>{
    const issueSources = $abe644eb792d5106$export$16bdc72ef65977db(state);
    return issueSources.find((issueSource)=>issueSource.id === issueSourceId);
};
const $abe644eb792d5106$export$2419cd984fa6ae80 = (issueSources)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), issueSources);
const $abe644eb792d5106$export$8834a5bc0beb2ee5 = (0, $iK4oF.createSelector)([
    $abe644eb792d5106$export$16bdc72ef65977db
], $abe644eb792d5106$export$2419cd984fa6ae80);
const $abe644eb792d5106$export$722eb315d83d8783 = (issueSources, issueSourceId)=>issueSources.find((issueSource)=>issueSource.id === issueSourceId);
const $abe644eb792d5106$export$dcfb6bc2956ec132 = (state)=>state.domain.plan.scenarios ?? [];
const $abe644eb792d5106$export$25634b1616bed187 = (state)=>state.domain.plan.useTwpTeams;
const $abe644eb792d5106$export$5c0e252a3e94185a = (state)=>state.domain.plan.multiScenarioEnabled;
const $abe644eb792d5106$export$518c73faa0b23138 = (state)=>state.domain.plan.currentScenarioId;
const $abe644eb792d5106$export$a352f0a83e7a1027 = (0, $iK4oF.createSelector)([
    $abe644eb792d5106$export$dcfb6bc2956ec132,
    $abe644eb792d5106$export$518c73faa0b23138,
    $abe644eb792d5106$export$5c0e252a3e94185a
], // eslint-disable-next-line @typescript-eslint/no-shadow
(scenarios, currentScenarioId, isMultiScenarioEnabled)=>{
    if (scenarios && isMultiScenarioEnabled) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const scenario = scenarios.find((scenario)=>scenario.id === currentScenarioId);
        // scenario colours are not moved to tokens
        return scenario ? scenario.color : (0, $g4Vkx.default).Y400;
    }
    return (0, $g4Vkx.default).Y400;
});
const $abe644eb792d5106$export$9e519e3d0791b75 = (state)=>state.domain.plan.autoScheduleConfiguration;
const $abe644eb792d5106$export$c25ddf5c19130650 = (state)=>state.domain.plan.createdTimestamp;
const $abe644eb792d5106$export$21b3bfe6331442bb = (state)=>state.domain.plan.issueInferredDateSelection;
const $abe644eb792d5106$export$27162fa81fdb5f6f = (state)=>state.domain.plan.baselineStartField;
const $abe644eb792d5106$export$c3047bd55ed2ff53 = (state)=>state.domain.plan.baselineEndField;
const $abe644eb792d5106$export$6eea2a2f8d211a5c = (0, $iK4oF.createSelector)([
    $abe644eb792d5106$export$27162fa81fdb5f6f,
    $abe644eb792d5106$export$c3047bd55ed2ff53
], (baselineStartField, baselineEndField)=>({
        baselineStartField: baselineStartField,
        baselineEndField: baselineEndField
    }));
const $abe644eb792d5106$export$f428dfac2965faf0 = (0, $iK4oF.createSelector)([
    $abe644eb792d5106$export$6eea2a2f8d211a5c
], (dateConfiguration)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    return (0, $7CnHa.isDefined)(baselineStartField.warning) || (0, $7CnHa.isDefined)(baselineEndField.warning);
});

});
parcelRegister("g4Vkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $47c0516f65ea71be$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");
// Transparent color equivalent to ADG's N20 (#F4F5F7)
const $47c0516f65ea71be$var$N20_TRANSPARENT = "var(--ds-background-neutral, rgba(35, 55, 95, 0.05))";
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47c0516f65ea71be$export$2e2bcd8739ae039 = {
    ...(0, $PdmhA),
    N20_TRANSPARENT: $47c0516f65ea71be$var$N20_TRANSPARENT
};

});

parcelRegister("eOsHk", function(module, exports) {

$parcel$export(module.exports, "ISSUE_INFERRED_DATE_SELECTION", () => $b4fecd87e797297f$export$d20a030b70ab1266);
$parcel$export(module.exports, "DUE_DATE", () => $b4fecd87e797297f$export$cf7e173386d30cdd);
$parcel$export(module.exports, "TARGET_START_FIELD", () => $b4fecd87e797297f$export$77f4fd573f5dd5b2);
$parcel$export(module.exports, "TARGET_END_FIELD", () => $b4fecd87e797297f$export$1906d795dad222a2);
$parcel$export(module.exports, "TARGET_START_END_API_MAP", () => $b4fecd87e797297f$export$a977ae1ec7868242);
$parcel$export(module.exports, "BUILT_IN_DATE_FIELDS", () => $b4fecd87e797297f$export$5b772dcefb474518);
$parcel$export(module.exports, "DATEFIELD_TYPES", () => $b4fecd87e797297f$export$f1b7783d68321e17);
$parcel$export(module.exports, "DATEFIELD_WARNINGS", () => $b4fecd87e797297f$export$4a3a3d3681d6aef2);
$parcel$export(module.exports, "DUE_DATE_FIELD", () => $b4fecd87e797297f$export$f4a47f55547a932c);
$parcel$export(module.exports, "TARGET_START_DATE_FIELD", () => $b4fecd87e797297f$export$d8edc8f6b75c5d36);
$parcel$export(module.exports, "TARGET_END_DATE_FIELD", () => $b4fecd87e797297f$export$8e3f7c464f9fbc67);
$parcel$export(module.exports, "DateFieldStatus", () => $b4fecd87e797297f$export$741035fa3d533c);
$parcel$export(module.exports, "RANK_TOP", () => $b4fecd87e797297f$export$44676822f5e6b099);
$parcel$export(module.exports, "RANK_LAST", () => $b4fecd87e797297f$export$6d8ebc2b2a45c68f);
$parcel$export(module.exports, "RANK_BEFORE", () => $b4fecd87e797297f$export$72384426ccc8b8e7);
$parcel$export(module.exports, "RANK_AFTER", () => $b4fecd87e797297f$export$7b4abdf7cd37b163);
$parcel$export(module.exports, "ASSIGNEE_FIELD", () => (parcelRequire("lO4Or")).ASSIGNEE_TYPE);
$parcel$export(module.exports, "REPORTER_FIELD", () => (parcelRequire("lO4Or")).REPORTER_TYPE);
$parcel$export(module.exports, "STATUS_FIELD", () => (parcelRequire("lO4Or")).STATUS_TYPE);
$parcel$export(module.exports, "TEAM_FIELD", () => (parcelRequire("lO4Or")).TEAM_TYPE);
$parcel$export(module.exports, "PRIORITY_FIELD", () => (parcelRequire("lO4Or")).PRIORITY_TYPE);
$parcel$export(module.exports, "ESTIMATE", () => (parcelRequire("lO4Or")).ESTIMATE_TYPE);

var $lO4Or = parcelRequire("lO4Or");
const $b4fecd87e797297f$export$d20a030b70ab1266 = {
    /** This ENUM is mainly used to represent options for date inference. This options are
	 *  provided by backend. Currently there only three options; 0 - None, 1 - Sprint, 2 - Release.
	 *  We are using this same ENUM to support rolling up of the dates as well. We are using
	 *  -1 to represent rolling up option, because in future we can introduce more options
	 *  for date inference and it could take value such as 2, 3, etc. Hence to avoid collision
	 *  with such options, we are using -1 for rolling up.
	 */ ROLL_UP: -1,
    NONE: 0,
    SPRINT: 1,
    RELEASE: 2
};
const $b4fecd87e797297f$export$cf7e173386d30cdd = (0, $lO4Or.DUE_DATE_PORTFOLIO_TYPE);
const $b4fecd87e797297f$export$77f4fd573f5dd5b2 = (0, $lO4Or.TARGET_START_TYPE);
const $b4fecd87e797297f$export$1906d795dad222a2 = (0, $lO4Or.TARGET_END_TYPE);
const $b4fecd87e797297f$export$a977ae1ec7868242 = Object.freeze({
    [$b4fecd87e797297f$export$77f4fd573f5dd5b2]: 'baselineStart',
    [$b4fecd87e797297f$export$1906d795dad222a2]: 'baselineEnd'
});
const $b4fecd87e797297f$export$5b772dcefb474518 = Object.freeze([
    $b4fecd87e797297f$export$cf7e173386d30cdd,
    $b4fecd87e797297f$export$77f4fd573f5dd5b2,
    $b4fecd87e797297f$export$1906d795dad222a2
]);
const $b4fecd87e797297f$export$f1b7783d68321e17 = Object.freeze({
    BUILT_IN: 'BuiltIn',
    CUSTOM: 'Custom'
});
const $b4fecd87e797297f$export$4a3a3d3681d6aef2 = Object.freeze({
    NOT_EXIST: 'NOT_EXIST',
    UNAVAILABLE: 'VALUE_NO_LONGER_AVAILABLE'
});
const $b4fecd87e797297f$export$f4a47f55547a932c = {
    id: $b4fecd87e797297f$export$cf7e173386d30cdd,
    key: $b4fecd87e797297f$export$cf7e173386d30cdd,
    type: $b4fecd87e797297f$export$f1b7783d68321e17.BUILT_IN
};
const $b4fecd87e797297f$export$d8edc8f6b75c5d36 = {
    id: $b4fecd87e797297f$export$77f4fd573f5dd5b2,
    key: $b4fecd87e797297f$export$77f4fd573f5dd5b2,
    type: $b4fecd87e797297f$export$f1b7783d68321e17.BUILT_IN
};
const $b4fecd87e797297f$export$8e3f7c464f9fbc67 = {
    id: $b4fecd87e797297f$export$1906d795dad222a2,
    key: $b4fecd87e797297f$export$1906d795dad222a2,
    type: $b4fecd87e797297f$export$f1b7783d68321e17.BUILT_IN
};
const $b4fecd87e797297f$export$741035fa3d533c = {
    OK: 'ok',
    NOT_EXIST: "doesn't exist",
    UNAVAILABLE: 'unavailable'
};
const $b4fecd87e797297f$export$44676822f5e6b099 = 'TOP';
const $b4fecd87e797297f$export$6d8ebc2b2a45c68f = 'LAST';
const $b4fecd87e797297f$export$72384426ccc8b8e7 = 'BEFORE';
const $b4fecd87e797297f$export$7b4abdf7cd37b163 = 'AFTER';

});


parcelRegister("kCccV", function(module, exports) {

$parcel$export(module.exports, "getIsSolutionLatest", () => $c9496f0758b3ae6c$export$a0ce90303719b0f1);
$parcel$export(module.exports, "getIsSolutionValid", () => $c9496f0758b3ae6c$export$99af26022344ca72);
$parcel$export(module.exports, "getSolution", () => $c9496f0758b3ae6c$export$aa83c3a07763586);
$parcel$export(module.exports, "getApplyingProgress", () => $c9496f0758b3ae6c$export$ce4821395b01b556);
const $c9496f0758b3ae6c$export$a0ce90303719b0f1 = (state)=>state.domain.solution.isLatest;
const $c9496f0758b3ae6c$export$99af26022344ca72 = (state)=>state.domain.solution.isValid;
const $c9496f0758b3ae6c$export$aa83c3a07763586 = (state)=>state.domain.solution;
const $c9496f0758b3ae6c$export$ce4821395b01b556 = (state)=>state.domain.solution.applyingProgress;
const $c9496f0758b3ae6c$export$dffc07d1b5a91631 = (state)=>state.domain.solution.calculationConfiguration;

});

parcelRegister("853IT", function(module, exports) {

$parcel$export(module.exports, "getSprints", () => $23820dfd28e859c3$export$1b132ed8629e9cb0);
$parcel$export(module.exports, "getExternalSprints", () => $23820dfd28e859c3$export$a116ea7be7faa950);
$parcel$export(module.exports, "getSprintsWithFutureDates", () => $23820dfd28e859c3$export$890993119fd2e3d2);
$parcel$export(module.exports, "getFutureSprintsForIssue", () => $23820dfd28e859c3$export$fe70fca007a8ca4e);

var $607C7 = parcelRequire("607C7");
var $f2C9X = parcelRequire("f2C9X");
var $1l9vO = parcelRequire("1l9vO");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $irp43 = parcelRequire("irp43");

var $75KhQ = parcelRequire("75KhQ");

var $2iYEz = parcelRequire("2iYEz");

var $MQRDu = parcelRequire("MQRDu");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $a4NMN = parcelRequire("a4NMN");
const $23820dfd28e859c3$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
const $23820dfd28e859c3$export$a116ea7be7faa950 = (state)=>state.domain.externalSprints;
const $23820dfd28e859c3$export$136e69b79f9b3bc6 = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams),
    (0, $75KhQ.getIssueSources),
    $23820dfd28e859c3$export$1b132ed8629e9cb0
], (0, $a4NMN.getSprintsForTeamPure));
const $23820dfd28e859c3$export$890993119fd2e3d2 = (0, $iK4oF.createSelector)([
    $23820dfd28e859c3$export$136e69b79f9b3bc6,
    (0, $MQRDu.getTeams),
    (0, $75KhQ.getIssueSources),
    $23820dfd28e859c3$export$1b132ed8629e9cb0,
    (0, $2iYEz.getDefaultIterationLength)
], (0, $a4NMN.getSprintsWithFutureDatesPure));
const $23820dfd28e859c3$export$fe70fca007a8ca4e = ({ team: team, sprint: sprint, completedSprints: completedSprints }, sprintsWithDates)=>{
    const requiredSprintsForIssue = [
        ...completedSprints || [],
        ...sprint ? [
            sprint
        ] : []
    ];
    if ((0, $7CnHa.isDefined)(team)) {
        const futureSprintsForTeam = sprintsWithDates.team[team];
        if ((0, $7CnHa.isDefined)(futureSprintsForTeam)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const sprintIds = futureSprintsForTeam.map((sprint)=>sprint.id);
            if (requiredSprintsForIssue.some((sprintId)=>sprintIds.includes(sprintId))) return futureSprintsForTeam;
        }
    }
    if ((0, $7CnHa.isDefined)(sprint)) {
        const futureSprintsBasedOnIssueSource = sprintsWithDates.sprint[sprint];
        if ((0, $7CnHa.isDefined)(futureSprintsBasedOnIssueSource)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const sprintIds = futureSprintsBasedOnIssueSource.map((sprint)=>sprint.id);
            if (requiredSprintsForIssue.some((sprintId)=>sprintIds.includes(sprintId))) return futureSprintsBasedOnIssueSource;
        }
    }
    if (completedSprints && completedSprints.length) {
        const hasSprints = (id)=>!!sprintsWithDates.sprint[id] && $607C7.default((el)=>$1l9vO.default($f7Op5.default('id', el))(requiredSprintsForIssue))(sprintsWithDates.sprint[id]);
        return $3IGDG.default($irp43.default(hasSprints), $f2C9X.default, (id)=>id ? sprintsWithDates.sprint[id] : [])(completedSprints);
    }
    return [];
};

});
parcelRegister("f2C9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d36e02a35069a4$export$2e2bcd8739ae039);

var $adz2t = parcelRequire("adz2t");
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $02d36e02a35069a4$var$head = /*#__PURE__*/ (0, $adz2t.default)(0);
var $02d36e02a35069a4$export$2e2bcd8739ae039 = $02d36e02a35069a4$var$head;

});
parcelRegister("adz2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $77064c4156adc6df$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $faRtN = parcelRequire("faRtN");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $77064c4156adc6df$var$nth = /*#__PURE__*/ (0, $ggdJA.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $faRtN.default)(list) ? list.charAt(idx) : list[idx];
});
var $77064c4156adc6df$export$2e2bcd8739ae039 = $77064c4156adc6df$var$nth;

});


parcelRegister("1l9vO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9f2184ad4d1892$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $0f9f2184ad4d1892$var$includes = /*#__PURE__*/ (0, $ggdJA.default)((0, $75bQw.default));
var $0f9f2184ad4d1892$export$2e2bcd8739ae039 = $0f9f2184ad4d1892$var$includes;

});

parcelRegister("3IGDG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b568e64fec8d7a2$export$2e2bcd8739ae039);

var $i3ArA = parcelRequire("i3ArA");

var $4k9H9 = parcelRequire("4k9H9");

var $ldYmX = parcelRequire("ldYmX");

var $22OV5 = parcelRequire("22OV5");
function $2b568e64fec8d7a2$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return (0, $i3ArA.default)(arguments[0].length, (0, $ldYmX.default)((0, $4k9H9.default), arguments[0], (0, $22OV5.default)(arguments)));
}

});
parcelRegister("4k9H9", function(module, exports) {

$parcel$export(module.exports, "default", () => $32608ce761dd910a$export$2e2bcd8739ae039);
function $32608ce761dd910a$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("22OV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d34443ac21e6a8$export$2e2bcd8739ae039);

var $6uMFi = parcelRequire("6uMFi");

var $eSWTK = parcelRequire("eSWTK");

var $aaoZV = parcelRequire("aaoZV");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $17d34443ac21e6a8$var$tail = /*#__PURE__*/ (0, $eSWTK.default)(/*#__PURE__*/ (0, $6uMFi.default)('tail', /*#__PURE__*/ (0, $aaoZV.default)(1, Infinity)));
var $17d34443ac21e6a8$export$2e2bcd8739ae039 = $17d34443ac21e6a8$var$tail;

});
parcelRegister("aaoZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $766e3a94bcfebbb8$export$2e2bcd8739ae039);

var $6uMFi = parcelRequire("6uMFi");

var $4g10W = parcelRequire("4g10W");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $766e3a94bcfebbb8$var$slice = /*#__PURE__*/ (0, $4g10W.default)(/*#__PURE__*/ (0, $6uMFi.default)('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $766e3a94bcfebbb8$export$2e2bcd8739ae039 = $766e3a94bcfebbb8$var$slice;

});



parcelRegister("irp43", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce30e4bd7675f7$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $kr47W = parcelRequire("kr47W");

var $aaoZV = parcelRequire("aaoZV");
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $d6ce30e4bd7675f7$var$takeWhile = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'takeWhile'
], (0, $kr47W.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $aaoZV.default)(0, idx, xs);
}));
var $d6ce30e4bd7675f7$export$2e2bcd8739ae039 = $d6ce30e4bd7675f7$var$takeWhile;

});
parcelRegister("kr47W", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0987cdbde6da1a$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $ee0987cdbde6da1a$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XTakeWhile.prototype['@@transducer/result'] = (0, $8uquE.default).result;
    XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : (0, $5zr36.default)(result);
    };
    return XTakeWhile;
}();
var $ee0987cdbde6da1a$var$_xtakeWhile = /*#__PURE__*/ (0, $ggdJA.default)(function _xtakeWhile(f, xf) {
    return new $ee0987cdbde6da1a$var$XTakeWhile(f, xf);
});
var $ee0987cdbde6da1a$export$2e2bcd8739ae039 = $ee0987cdbde6da1a$var$_xtakeWhile;

});


parcelRegister("2iYEz", function(module, exports) {

$parcel$export(module.exports, "getDefaultTeamVelocity", () => $f6f7f0f60ebd8e49$export$ed5c36f37a54350e);
$parcel$export(module.exports, "getDefaultIterationLength", () => $f6f7f0f60ebd8e49$export$f37877a682ee0aaf);
$parcel$export(module.exports, "getPlanDefaults", () => $f6f7f0f60ebd8e49$export$6495a62a7818a20e);
$parcel$export(module.exports, "getDefaultSyncStartEnabled", () => $f6f7f0f60ebd8e49$export$2aeef20d067b1e04);
const $f6f7f0f60ebd8e49$export$ed5c36f37a54350e = (state)=>state.domain.planDefaults.defaultTeamVelocity || 0;
const $f6f7f0f60ebd8e49$export$f37877a682ee0aaf = (state)=>state.domain.planDefaults.defaultIterationLength;
const $f6f7f0f60ebd8e49$export$6495a62a7818a20e = (state)=>state.domain.planDefaults;
const $f6f7f0f60ebd8e49$export$2aeef20d067b1e04 = (state)=>!!state.domain.planDefaults.defaultSyncStartEnabled;

});

parcelRegister("MQRDu", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $9dcabb2a7f3ba19f$export$5a622455e94bac3);
$parcel$export(module.exports, "getNonScenarioTeamsIds", () => $9dcabb2a7f3ba19f$export$e5fac1ec2e895554);
$parcel$export(module.exports, "getExistingTeams", () => $9dcabb2a7f3ba19f$export$40026669047b0e00);
$parcel$export(module.exports, "getScenarioRemovedShareTeams", () => $9dcabb2a7f3ba19f$export$4de42d9c1295d36c);
$parcel$export(module.exports, "getAdditionalTeams", () => $9dcabb2a7f3ba19f$export$8cb15b8f966ebbb9);
$parcel$export(module.exports, "getAllTeams", () => $9dcabb2a7f3ba19f$export$ff848de5b4c70793);
$parcel$export(module.exports, "getAllExistingTeams", () => $9dcabb2a7f3ba19f$export$a200a25405172a9f);
$parcel$export(module.exports, "getOriginalTeams", () => $9dcabb2a7f3ba19f$export$e0a864ffe5709a49);
$parcel$export(module.exports, "getTeamById", () => $9dcabb2a7f3ba19f$export$5dcc6aff8319c1fe);
$parcel$export(module.exports, "getAllTeamsById", () => $9dcabb2a7f3ba19f$export$ea9a67254fdb719d);
$parcel$export(module.exports, "getTeamsById", () => $9dcabb2a7f3ba19f$export$b54b70b5214dea1a);
$parcel$export(module.exports, "getAdditionalTeamsById", () => $9dcabb2a7f3ba19f$export$d368aeefd0fe1c0);
$parcel$export(module.exports, "findTeamById", () => $9dcabb2a7f3ba19f$export$93627fd7a1a1fc10);
$parcel$export(module.exports, "findResourceFromTeam", () => $9dcabb2a7f3ba19f$export$9d1939bc8063970f);
$parcel$export(module.exports, "findTeamAssociatedWithResource", () => $9dcabb2a7f3ba19f$export$9b2a78fec47a5cad);
$parcel$export(module.exports, "isTeamwithoutResources", () => $9dcabb2a7f3ba19f$export$2a1144896824746b);
$parcel$export(module.exports, "getCommitWarningsForTeams", () => $9dcabb2a7f3ba19f$export$3b9a598ad04ed144);
$parcel$export(module.exports, "getTeamChangesMetaData", () => $9dcabb2a7f3ba19f$export$29c139115e056a14);
$parcel$export(module.exports, "getWeeklyCapacityByTeam", () => $9dcabb2a7f3ba19f$export$c35afbe880471269);
$parcel$export(module.exports, "getAddedTWPInfo", () => $9dcabb2a7f3ba19f$export$954edddbabdfd076);
$parcel$export(module.exports, "getDialogMode", () => $9dcabb2a7f3ba19f$export$dfca671db15d2f8a);
$parcel$export(module.exports, "getEditedTeam", () => $9dcabb2a7f3ba19f$export$49c12233d021d66b);

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");
var $cQGVO = parcelRequire("cQGVO");

var $2iYEz = parcelRequire("2iYEz");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $9dcabb2a7f3ba19f$export$5a622455e94bac3 = (state)=>state.domain.teams;
const $9dcabb2a7f3ba19f$export$e5fac1ec2e895554 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3
], (teams)=>teams.map((team)=>team.id).filter((id)=>!id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))));
const $9dcabb2a7f3ba19f$export$40026669047b0e00 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3
], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED));
const $9dcabb2a7f3ba19f$export$4de42d9c1295d36c = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3
], (teams)=>teams.filter((team)=>team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED && team.shareable));
const $9dcabb2a7f3ba19f$export$8cb15b8f966ebbb9 = (state)=>state.domain.teamsAdditional;
const $9dcabb2a7f3ba19f$export$99158a173ae93ce8 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$8cb15b8f966ebbb9
], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED));
const $9dcabb2a7f3ba19f$export$ff848de5b4c70793 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3,
    $9dcabb2a7f3ba19f$export$8cb15b8f966ebbb9
], (teams, additionalTeams)=>teams.concat(additionalTeams));
const $9dcabb2a7f3ba19f$export$a200a25405172a9f = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$ff848de5b4c70793
], (teams)=>teams.filter((team)=>team.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED));
const $9dcabb2a7f3ba19f$export$e0a864ffe5709a49 = (state)=>state.domain.originalTeams;
const $9dcabb2a7f3ba19f$export$5dcc6aff8319c1fe = (state, teamId)=>{
    const teams = $9dcabb2a7f3ba19f$export$5a622455e94bac3(state);
    return teams.find((team)=>team.id === teamId);
};
const $9dcabb2a7f3ba19f$export$6cbb2fc52fbb30a6 = (teams)=>(0, $7CnHa.indexBy)((x)=>x.id, teams);
const $9dcabb2a7f3ba19f$export$ea9a67254fdb719d = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$ff848de5b4c70793
], $9dcabb2a7f3ba19f$export$6cbb2fc52fbb30a6);
const $9dcabb2a7f3ba19f$export$b54b70b5214dea1a = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3
], $9dcabb2a7f3ba19f$export$6cbb2fc52fbb30a6);
const $9dcabb2a7f3ba19f$export$d368aeefd0fe1c0 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$8cb15b8f966ebbb9
], $9dcabb2a7f3ba19f$export$6cbb2fc52fbb30a6);
const $9dcabb2a7f3ba19f$export$88f9e108414d3399 = (teams, defaultTeamVelocity)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    teams.reduce((velocityMap, team)=>{
        // eslint-disable-next-line no-param-reassign
        velocityMap[team.id] = team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
        return velocityMap;
    }, {});
const $9dcabb2a7f3ba19f$export$2a00e87e65278669 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$5a622455e94bac3,
    (0, $2iYEz.getDefaultTeamVelocity)
], $9dcabb2a7f3ba19f$export$88f9e108414d3399);
const $9dcabb2a7f3ba19f$export$93627fd7a1a1fc10 = (teams, teamId)=>teams.find((team)=>team.id === teamId);
const $9dcabb2a7f3ba19f$export$9d1939bc8063970f = (team, resourceKey)=>team.resources.find((resource)=>resource.itemKey === resourceKey);
const $9dcabb2a7f3ba19f$export$9b2a78fec47a5cad = (teams, resourceKey)=>teams.find((team)=>$9dcabb2a7f3ba19f$export$9d1939bc8063970f(team, resourceKey));
const $9dcabb2a7f3ba19f$export$2a1144896824746b = (team)=>$kDrtX.default(team.resources) || $b3iuB.default(team.resources) || team.resources.filter(({ scenarioType: scenarioType })=>scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED).length === 0;
const $9dcabb2a7f3ba19f$var$getSharedTeamsWithoutResourcePure = (teams)=>teams.filter((team)=>team.shareable && $9dcabb2a7f3ba19f$export$2a1144896824746b(team));
const $9dcabb2a7f3ba19f$export$56bc26991d0dd1ae = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$40026669047b0e00
], $9dcabb2a7f3ba19f$var$getSharedTeamsWithoutResourcePure);
const $9dcabb2a7f3ba19f$export$3b9a598ad04ed144 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $5rYNM.ENTITY).TEAM];
const $9dcabb2a7f3ba19f$export$29c139115e056a14 = ({ domain: { updateJira: updateJira } })=>{
    if (updateJira && updateJira.changes && updateJira.changes.data && updateJira.changes.data.metaData && updateJira.changes.data.metaData.teams) return updateJira.changes.data.metaData.teams;
};
const $9dcabb2a7f3ba19f$export$1e467c0c5872b46b = (state)=>state.ui.Top.TitleBar.UpdateJira.expandedChanges.TEAM;
const $9dcabb2a7f3ba19f$export$a6380030161f6417 = (state)=>state.ui.Top.TitleBar.UpdateJira.selectedChanges.TEAM;
const $9dcabb2a7f3ba19f$var$getWeeklyCapacity = (planDefaults)=>(team)=>{
        if (team.weeklyHours || team.weeklyHours === 0) return team.weeklyHours;
        return planDefaults.defaultTeamWeeklyHours || 0;
    };
const $9dcabb2a7f3ba19f$export$c35afbe880471269 = (0, $iK4oF.createSelector)([
    $9dcabb2a7f3ba19f$export$b54b70b5214dea1a,
    (0, $2iYEz.getPlanDefaults)
], (teamsById, planDefaults)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $cQGVO.default($9dcabb2a7f3ba19f$var$getWeeklyCapacity(planDefaults), teamsById));
const $9dcabb2a7f3ba19f$export$954edddbabdfd076 = (state)=>({
        teamTitle: state.ui.Main.Tabs.Teams.CreateTeam.addedTWPTeamTitle,
        teamId: state.ui.Main.Tabs.Teams.CreateTeam.addedTWPTeamId
    });
const $9dcabb2a7f3ba19f$export$dfca671db15d2f8a = (state)=>state.ui.Main.Tabs.Teams.TeamsList.dialogMode;
const $9dcabb2a7f3ba19f$export$49c12233d021d66b = (state)=>state.ui.Main.Tabs.Teams.TeamsList.editedTeam;

});
parcelRegister("cQGVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $95aba4a7282204ae$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $3bCe9 = parcelRequire("3bCe9");

var $hC9UT = parcelRequire("hC9UT");

var $2lZi9 = parcelRequire("2lZi9");

var $bwMm3 = parcelRequire("bwMm3");

var $erwaN = parcelRequire("erwaN");
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $95aba4a7282204ae$var$map = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'fantasy-land/map',
    'map'
], (0, $2lZi9.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return (0, $bwMm3.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return (0, $hC9UT.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $erwaN.default)(functor));
        default:
            return (0, $3bCe9.default)(fn, functor);
    }
}));
var $95aba4a7282204ae$export$2e2bcd8739ae039 = $95aba4a7282204ae$var$map;

});
parcelRegister("2lZi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b6d1637f970a34d$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $8uquE = parcelRequire("8uquE");
var $1b6d1637f970a34d$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XMap.prototype['@@transducer/result'] = (0, $8uquE.default).result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var $1b6d1637f970a34d$var$_xmap = /*#__PURE__*/ (0, $ggdJA.default)(function _xmap(f, xf) {
    return new $1b6d1637f970a34d$var$XMap(f, xf);
});
var $1b6d1637f970a34d$export$2e2bcd8739ae039 = $1b6d1637f970a34d$var$_xmap;

});



parcelRegister("a4NMN", function(module, exports) {

$parcel$export(module.exports, "getSprintsForTeamPure", () => $22a874737270ee06$export$9243dfc1617c55b8);
$parcel$export(module.exports, "getSprintsForIssueSourcesPure", () => $22a874737270ee06$export$75614dbaeb172566);
$parcel$export(module.exports, "getSprintsAndTeamsByIssueSourcesPure", () => $22a874737270ee06$export$83fd28707f2693a7);
$parcel$export(module.exports, "getSprintStatesCategoriesPure", () => $22a874737270ee06$export$84f58648e5fd0982);
$parcel$export(module.exports, "getSprintById", () => $22a874737270ee06$export$2408d631da3b8ccd);
$parcel$export(module.exports, "getSprintByIdMapPure", () => $22a874737270ee06$export$7218eb788b037547);
$parcel$export(module.exports, "getIssuesByKanbanIterationPure", () => $22a874737270ee06$export$6456c14aff191bdf);
$parcel$export(module.exports, "getIssuesBySprintPure", () => $22a874737270ee06$export$39b9f591cb5babf9);
$parcel$export(module.exports, "getIssuesBySprintOptimizedPure", () => $22a874737270ee06$export$352df393d87c6e45);
$parcel$export(module.exports, "getSprintStreamsForTeamsPure", () => $22a874737270ee06$export$366891b86c1a480d);
$parcel$export(module.exports, "getSprintsStreamsGetterPure", () => $22a874737270ee06$export$2c19bb597f3993ce);
$parcel$export(module.exports, "getSprintIdsWithDatesIsInconsistentPure", () => $22a874737270ee06$export$c501cbd65c882409);
$parcel$export(module.exports, "getSprintStreamsUnitsForTeamsPure", () => $22a874737270ee06$export$a2649b86fe314f7f);
$parcel$export(module.exports, "getSprintStreamsUnitsGetterPure", () => $22a874737270ee06$export$364b800ef2163c);
$parcel$export(module.exports, "getSprintsWithFutureDatesPure", () => $22a874737270ee06$export$eb0254c397e556b3);
$parcel$export(module.exports, "getTargetDatesFromSprints", () => $22a874737270ee06$export$6b6ffbeb66570a75);
$parcel$export(module.exports, "getFutureSprintGroups", () => $22a874737270ee06$export$d7616b811073c058);
$parcel$export(module.exports, "getSprintsCapacityOnTimelinePure", () => $22a874737270ee06$export$230a55ad90f8755);
$parcel$export(module.exports, "convertCapacityByPlanningUnit", () => $22a874737270ee06$export$570cdbd5979ccd);
$parcel$export(module.exports, "convertCapacityFromPlanningUnitToSeconds", () => $22a874737270ee06$export$acbcfbe3e761e0b4);
$parcel$export(module.exports, "getPlannedCapacityChangesPure", () => $22a874737270ee06$export$5389b2bbf0271c30);
$parcel$export(module.exports, "getSprintChangesPure", () => $22a874737270ee06$export$7ad618a806be26f0);
$parcel$export(module.exports, "formatSprintUTCTime", () => $22a874737270ee06$export$c0501b9f0bd00198);
$parcel$export(module.exports, "formatDateRange", () => $22a874737270ee06$export$2e9241a0bdf6c8b8);
$parcel$export(module.exports, "getLozengeContent", () => $22a874737270ee06$export$9f71a9790fe294f);
$parcel$export(module.exports, "getLozengeAppearance", () => $22a874737270ee06$export$4d9e331cafeacb9d);
$parcel$export(module.exports, "getSprintStateLozengeContent", () => $22a874737270ee06$export$fd6ceee9e9533c99);
$parcel$export(module.exports, "getSprintStateLabel", () => $22a874737270ee06$export$6f891d146561f05a);

var $6G5mG = parcelRequire("6G5mG");

var $aXGkF = parcelRequire("aXGkF");

var $3fphB = parcelRequire("3fphB");

var $ji0fW = parcelRequire("ji0fW");

var $itLT6 = parcelRequire("itLT6");
var $hC4q3 = parcelRequire("hC4q3");
var $hkOxK = parcelRequire("hkOxK");
var $1dZWS = parcelRequire("1dZWS");
var $dSK2s = parcelRequire("dSK2s");
var $fpul1 = parcelRequire("fpul1");
var $5ckL2 = parcelRequire("5ckL2");
var $eirae = parcelRequire("eirae");
var $f2C9X = parcelRequire("f2C9X");
var $l0L3x = parcelRequire("l0L3x");
var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");
var $dfCnd = parcelRequire("dfCnd");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $3by2Y = parcelRequire("3by2Y");
var $kjklK = parcelRequire("kjklK");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $l3byl = parcelRequire("l3byl");
var $l7xwn = parcelRequire("l7xwn");
var $9RbxZ = parcelRequire("9RbxZ");
var $dRo9r = parcelRequire("dRo9r");
var $1zKBj = parcelRequire("1zKBj");
var $eCpJ2 = parcelRequire("eCpJ2");
var $UCNmJ = parcelRequire("UCNmJ");

var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
var $8YqJS = parcelRequire("8YqJS");
var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("akhOi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");
const { TODO: $22a874737270ee06$var$TODO, INPROGRESS: $22a874737270ee06$var$INPROGRESS, DONE: $22a874737270ee06$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
const $22a874737270ee06$export$4ff47658dac00b1a = (0, $17L5s.ONE_WEEK);
const $22a874737270ee06$var$isInfiniteTimelineRange = (timelineRange)=>Math.abs(timelineRange.start) + Math.abs(timelineRange.end) === Infinity;
const $22a874737270ee06$export$14dc3d2554a83ab1 = (sprintsInOrder, sprints)=>{
    const sprintOrdering = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))(sprintsInOrder);
    return sprints.filter((sprint)=>(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(sprintOrdering, sprint.id)).sort((a, b)=>{
        const indexA = parseInt(sprintOrdering[a.id], 10);
        const indexB = parseInt(sprintOrdering[b.id], 10);
        return indexA - indexB;
    });
};
const $22a874737270ee06$export$98922a1700a2456 = ({ teams: teams })=>({ team: team, interval: interval })=>(0, $7CnHa.isDefined)(team) && (0, $7CnHa.isDefined)(interval) ? $kjklK.default([
            team,
            'intervals',
            interval
        ], teams) : null;
const $22a874737270ee06$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
const $22a874737270ee06$export$9243dfc1617c55b8 = (teams, issueSources, sprints)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const teamsToSprintMap = {};
    teams.forEach((team)=>{
        let sprintsForTeam;
        const issueSource = issueSources.find(// eslint-disable-next-line @typescript-eslint/no-shadow
        (issueSource)=>issueSource.id === team.issueSource);
        if ((0, $7CnHa.isDefined)(issueSource) && (0, $7CnHa.isDefined)(issueSource.sprintIds)) sprintsForTeam = $22a874737270ee06$export$14dc3d2554a83ab1(issueSource.sprintIds, sprints);
        teamsToSprintMap[team.id] = sprintsForTeam || [];
    });
    return teamsToSprintMap;
};
const $22a874737270ee06$export$75614dbaeb172566 = (issueSourcesById, sprintsById, disabledSprintsById)=>$cQGVO.default(({ sprintIds: sprintIds = [] })=>$l3byl.default(sprintIds.map((x)=>`${x}`).filter((x)=>disabledSprintsById[x] === undefined), sprintsById), issueSourcesById);
const $22a874737270ee06$export$83fd28707f2693a7 = (issueSourcesById, sprintsById, teams, disabledSprintsById)=>{
    const sprintsAndTeamsByIssueSources = {
        sprintsWithTeams: [],
        sprintsWithoutTeams: []
    };
    const uniqueSprintIds = new Set();
    for (const [issueSourceId, issueSource] of Object.entries(issueSourcesById)){
        const sprintIds = $f7Op5.default('sprintIds', issueSource);
        if (sprintIds && sprintIds.length) {
            // we get sprint deets for all sprints from the sprintsById object
            const sprints = sprintIds.map((x)=>`${x}`).filter((x)=>disabledSprintsById[x] === undefined).map((sprintId)=>sprintsById[sprintId]);
            // if there are teams for that very same issue source
            const teamTitles = (0, $7CnHa.filterMap)((team)=>team.issueSource === Number(issueSourceId), (team)=>team.title, teams);
            if (teamTitles && teamTitles.length) // then that issue source has sprints with associated teams
            sprintsAndTeamsByIssueSources.sprintsWithTeams.push({
                teams: teamTitles,
                sprints: sprints
            });
            else // we store those sprints on the side, but we need to be careful of not having duplicated sprints
            sprints.forEach((sprint)=>{
                // so we use the "uniqueSprintIds" set to keep track of unique sprint ids
                if (!uniqueSprintIds.has(sprint.id)) {
                    uniqueSprintIds.add(sprint.id);
                    // and only store the sprint if we have not encountered it before
                    sprintsAndTeamsByIssueSources.sprintsWithoutTeams.push(sprint);
                }
            });
        }
    }
    return sprintsAndTeamsByIssueSources;
};
const $22a874737270ee06$export$de039e868213edc8 = (sprintIds, uniqueFilteredSprints)=>{
    // if there are selected sprints in the sprint filter menu
    if (uniqueFilteredSprints.size > 0) {
        // if the length of the sprintIds array is not higher than the length of the array of selected sprints
        // and all sprintIds are included in the array of selected sprints in the sprint filter menu
        // note: checking array lengths first can avoid unnecessary loops if there are less sprints selected
        // in the filters than there are in the array of sprints we're searching in
        // the original version 'sprintIds.every((el) => uniqueFilteredSprints.has(el))' checking of every sprintId is selected, if the sprintIds length is n, the uniqueFilteredSprints length is m
        // it means the calculation cost is m*n
        // the improved '!sprintIds.some((el) => !uniqueFilteredSprints.has(el))', it checks if at least one of the sprintIds is not found in the uniqueFilteredSprints
        // so in the best case, the cost is 1, the worst calculation cost is m*n
        if (sprintIds.length > 0 && sprintIds.length <= uniqueFilteredSprints.size && !sprintIds.some((el)=>!uniqueFilteredSprints.has(el))) return (0, $5rYNM.CHECKBOX_STATES).CHECKED;
        if (sprintIds.some((el)=>uniqueFilteredSprints.has(el))) return (0, $5rYNM.CHECKBOX_STATES).INDETERMINATE;
    }
    return (0, $5rYNM.CHECKBOX_STATES).UNCHECKED;
};
const $22a874737270ee06$export$84f58648e5fd0982 = (sprintsIdsByState, externalSprintIds, uniqueFilteredSprints)=>{
    const sprintStateCategories = [];
    // let's start with non-external sprints
    Object.keys((0, $5rYNM.SPRINT_STATES)).forEach((sprintState)=>{
        // getting all sprints id's for the current sprint state
        const sprintIds = sprintsIdsByState[sprintState] || [];
        sprintStateCategories.push({
            checkboxState: $22a874737270ee06$export$de039e868213edc8(sprintIds, uniqueFilteredSprints),
            sprintIds: sprintIds,
            sprintState: sprintState
        });
    });
    // and finish with the external sprints (if there are any)
    if (externalSprintIds.length) sprintStateCategories.push({
        checkboxState: $22a874737270ee06$export$de039e868213edc8(externalSprintIds, uniqueFilteredSprints),
        sprintIds: externalSprintIds,
        sprintState: (0, $5rYNM.EXTERNAL_SPRINT)
    });
    return sprintStateCategories;
};
const $22a874737270ee06$export$2408d631da3b8ccd = (sprints, sprintId)=>sprints.find((sprint)=>sprint.id === sprintId);
const $22a874737270ee06$export$7218eb788b037547 = (sprints)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), sprints);
const $22a874737270ee06$export$c3dd5085da5f7cb7 = (start, end, timeline)=>{
    const unitLength = Math.min(timeline.end, end) - Math.max(timeline.start, start);
    const rangeLength = timeline.end - timeline.start;
    return 100 * unitLength / rangeLength;
};
const $22a874737270ee06$var$calcOffsetPercentage = (startOfUtcDate, timeline)=>{
    const offsetLength = Math.max(timeline.start, startOfUtcDate) - timeline.start;
    return 100 * offsetLength / (timeline.end - timeline.start);
};
const $22a874737270ee06$var$sprintStartsWithinTimeline = (timeline, sprint)=>timeline.end >= sprint.startDate && sprint.startDate >= timeline.start;
const $22a874737270ee06$var$sprintEndsWithinTimeline = (timeline, sprint)=>sprint.endDate >= timeline.start && timeline.end >= sprint.endDate;
const $22a874737270ee06$var$sprintAppearsOnTimeline = (timeline, sprint)=>$22a874737270ee06$var$sprintStartsWithinTimeline(timeline, sprint) || $22a874737270ee06$var$sprintEndsWithinTimeline(timeline, sprint);
// Note that the sprint titles are internationalised later, in the view
const $22a874737270ee06$var$createPastSprint = (startDate, endDate, schedulingMode)=>({
        id: 'PAST',
        title: 'Past Sprint',
        state: (0, $5rYNM.SPRINT_STATES).CLOSED,
        startDate: startDate,
        endDate: endDate,
        issueSources: [],
        schedulingMode: schedulingMode,
        rawStartDate: startDate,
        rawEndDate: endDate
    });
// Note that the sprint titles are internationalised later, in the view
const $22a874737270ee06$var$createFutureSprint = (startDate, endDate, schedulingMode)=>({
        id: 'FUTURE',
        title: 'Future Sprint',
        state: (0, $5rYNM.SPRINT_STATES).FUTURE,
        startDate: startDate,
        endDate: endDate,
        issueSources: [],
        schedulingMode: schedulingMode,
        rawStartDate: startDate,
        rawEndDate: endDate
    });
const $22a874737270ee06$export$16f1e219d71d96ad = (sprints)=>{
    if (sprints.length < 2) return [
        sprints
    ];
    const streams = [];
    let pool = sprints;
    let nextPool = [];
    while(pool.length > 0){
        let cursor = pool[0];
        const stream = [
            cursor
        ];
        for (const sprint of pool.slice(1))// if a sprint starts more than one day before the previous sprint ends, it will be rendered
        // in a second stream of sprints as we consider that it is a deliberate choice from the user
        if (cursor.rawEndDate && sprint.rawStartDate && (0, $17L5s.endOfUtcDay)(cursor.rawEndDate) - (0, $17L5s.startOfUtcDay)(sprint.rawStartDate) > (0, $17L5s.ONE_DAY)) nextPool.push(sprint);
        else {
            cursor = sprint;
            stream.push(cursor);
        }
        streams.push(stream);
        pool = nextPool;
        nextPool = [];
    }
    return streams;
};
const $22a874737270ee06$var$startDateAscend = (0, $7CnHa.ascend)((x)=>x.startDate);
const $22a874737270ee06$var$endDateAscend = (0, $7CnHa.ascend)((x)=>x.endDate);
const $22a874737270ee06$export$f698cc36cb31ff11 = (sprints)=>sprints.map((sprint)=>{
        const endDate = sprint.endDate && (0, $17L5s.startOfUtcDay)(sprint.completeDate || sprint.endDate) - 1;
        return {
            ...sprint,
            startDate: (0, $17L5s.startOfUtcDay)(sprint.startDate),
            endDate: endDate,
            rawStartDate: sprint.startDate,
            rawEndDate: sprint.completeDate || sprint.endDate
        };
    })// Initial order of sprints might be a bit unclear in case of overlapping and parallel sprints
    // thus it's better to sort and allow later code to rely on sprints being sorted by
    // start and end date.
    .sort((a, b)=>$22a874737270ee06$var$startDateAscend(a, b) || $22a874737270ee06$var$endDateAscend(a, b));
const $22a874737270ee06$export$770b406429d15ffa = (sprints, start, sprintLengthInMillis)=>{
    const startOfTomorrow = (0, $17L5s.startOfUtcDay)(Date.now()) + (0, $17L5s.ONE_DAY);
    // Future sprints gonna be in the future. © The Scheduler.
    let currentStart = Math.max((0, $17L5s.startOfUtcDay)(start + 1), startOfTomorrow);
    return sprints.map((sprint)=>{
        // If the sprint does not have a start date, just start asap after previous sprint
        let rawStartDate = sprint.startDate || currentStart;
        let startDate = sprint.startDate ? (0, $17L5s.startOfUtcDay)(sprint.startDate) : currentStart;
        // If the sprint does not have a start date but has an end date
        // (this is impossible by Jira's design but we want to handle gracefully just in case)
        if (!(0, $7CnHa.isDefined)(sprint.startDate) && (0, $7CnHa.isDefined)(sprint.endDate)) {
            rawStartDate = sprint.endDate - sprintLengthInMillis;
            startDate = (0, $17L5s.startOfUtcDay)(rawStartDate);
        }
        // Coz we want to end on the day before the start of next sprint... we need to - 1 day.
        const sprintLengthAdjusted = sprintLengthInMillis - (0, $17L5s.ONE_DAY);
        const rawEndDate = sprint.endDate || (0, $17L5s.endOfUtcDay)(startDate + sprintLengthAdjusted);
        const endDate = (0, $17L5s.endOfUtcDay)(sprint.endDate || startDate + sprintLengthAdjusted);
        currentStart = (0, $17L5s.startOfUtcDay)(endDate + (0, $17L5s.ONE_DAY));
        return {
            ...sprint,
            startDate: startDate,
            endDate: endDate,
            rawStartDate: rawStartDate,
            rawEndDate: rawEndDate
        };
    });
};
const $22a874737270ee06$export$800f6e20804f9ed1 = (start, end, sprintLengthInMillis, schedulingMode)=>{
    const sprints = [];
    // Don't generate anything if we have infinite range
    if ($22a874737270ee06$var$isInfiniteTimelineRange({
        start: start,
        end: end
    })) return sprints;
    let endDate = (0, $17L5s.startOfUtcDay)(end);
    while(endDate > start){
        const startDate = (0, $17L5s.startOfUtcDay)(endDate - sprintLengthInMillis);
        sprints.push($22a874737270ee06$var$createPastSprint(startDate, endDate - 1, schedulingMode));
        endDate = startDate;
    }
    return sprints.reverse();
};
const $22a874737270ee06$export$ce1cefb45c8832 = (start, end, sprintLengthInMillis, schedulingMode)=>{
    const sprints = [];
    // Don't generate anything if we have infinite range
    if ($22a874737270ee06$var$isInfiniteTimelineRange({
        start: start,
        end: end
    })) return sprints;
    let startDate = (0, $17L5s.startOfUtcDay)(start + 1000);
    while(startDate < end){
        const endDate = (0, $17L5s.startOfUtcDay)(startDate + sprintLengthInMillis);
        sprints.push($22a874737270ee06$var$createFutureSprint(startDate, endDate - 1, schedulingMode));
        startDate = endDate;
    }
    return sprints;
};
const $22a874737270ee06$export$ac96f955bd8392a1 = (sprints, timeline, omitGaps = false)=>{
    const units = [];
    let cursor = timeline.start;
    for (const { title: title, id: id, state: state, startDate: startDate, endDate: endDate, issueSources: issueSources, planned: planned, rawStartDate: rawStartDate, rawEndDate: rawEndDate, ...rest } of sprints){
        // We shouldn't get gaps more than 1 ms when less than a day due to alignment, and those
        // small gaps shouldn't be rendered as they will be too thin and still have a border.
        if (cursor + 1 < startDate && !omitGaps) units.push({
            id: 'GAP',
            widthPercentage: $22a874737270ee06$export$c3dd5085da5f7cb7(cursor, startDate, timeline),
            label: {
                display: 'none'
            },
            // offset is used in "app-simple-plans/view/main/tabs/roadmap/timeline/schedule/sprints/sprint/view.tsx"
            // in order to render the sprint box at the right place in the timeline given its position is absolute
            offset: $22a874737270ee06$var$calcOffsetPercentage((0, $17L5s.startOfUtcDay)(startDate), timeline),
            state: state,
            startDate: cursor,
            endDate: startDate,
            issueSources: issueSources,
            planned: planned,
            rawStartDate: cursor,
            rawEndDate: rawEndDate
        });
        units.push({
            id: id,
            widthPercentage: $22a874737270ee06$export$c3dd5085da5f7cb7(startDate, endDate, timeline),
            label: {
                display: title
            },
            // offset is used in "app-simple-plans/view/main/tabs/roadmap/timeline/schedule/sprints/sprint/view.tsx"
            // in order to render the sprint box at the right place in the timeline given its position is absolute
            offset: $22a874737270ee06$var$calcOffsetPercentage((0, $17L5s.startOfUtcDay)(startDate), timeline),
            state: state,
            startDate: startDate,
            endDate: endDate,
            issueSources: issueSources,
            planned: planned,
            rawStartDate: rawStartDate,
            rawEndDate: rawEndDate,
            ...rest
        });
        cursor = endDate;
    }
    if (cursor < timeline.end && !omitGaps) units.push({
        id: 'GAP',
        widthPercentage: $22a874737270ee06$export$c3dd5085da5f7cb7(cursor, timeline.end, timeline),
        label: {
            display: 'none'
        },
        // offset is used in "app-simple-plans/view/main/tabs/roadmap/timeline/schedule/sprints/sprint/view.tsx"
        // in order to render the sprint box at the right place in the timeline given its position is absolute
        offset: $22a874737270ee06$var$calcOffsetPercentage((0, $17L5s.startOfUtcDay)(timeline.end), timeline),
        state: (0, $5rYNM.SPRINT_STATES).FUTURE,
        startDate: cursor,
        endDate: timeline.end,
        issueSources: [],
        planned: false,
        rawStartDate: cursor,
        rawEndDate: timeline.end
    });
    return units;
};
const $22a874737270ee06$var$getIssueDates = (issue, mode)=>{
    const isOptimized = mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771);
    const { assignments: assignments, baselineStart: baselineStart, baselineEnd: baselineEnd } = issue;
    let start = baselineStart;
    let end = baselineEnd;
    if (isOptimized) {
        const optimizedStart = assignments.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
        (acc, { start: start })=>Math.min(acc, start || acc), Infinity);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(optimizedStart)) start = optimizedStart;
        const optimizedEnd = assignments.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
        (acc, { end: end })=>Math.max(acc, end || acc), -Infinity);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(optimizedStart)) end = optimizedEnd;
    }
    return {
        start: start,
        end: end
    };
};
const $22a874737270ee06$export$58007ae5dd91fcc6 = (team, sprintsForTeam, defaultIterationLength)=>{
    if (!(0, $7CnHa.isDefined)(team.issueSource)) return [];
    // This is default sprint length for the team.
    // It is required to fill up future and fake sprints with start and end dates.
    const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, $17L5s.ONE_WEEK);
    // If there is no default sprint length then we are not going to return streams
    // for this team even if all sprints within timeline range are real and non-future
    // (which means that default sprint length will not be used). Just to keep things simple.
    if (sprintLengthInMillis === 0) return [];
    // Splitting sprints into past/active and future ones to divide the former to non-overlapping streams of sprints.
    const [futureSprints, pastAndActiveSprints] = $3by2Y.default((x)=>x.state === (0, $5rYNM.SPRINT_STATES).FUTURE, sprintsForTeam[team.id]);
    const pastAndActiveSprintsSortedByDate = $22a874737270ee06$export$f698cc36cb31ff11(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    pastAndActiveSprints);
    // Those dates are required to know where to start fake past and real/fake future sprints.
    // If there are no real sprints with dates then sprints should start from tomorrow.
    // Sprints should not start from today because we cannot reasonably expect work to be started on the current day.
    const lastRealSprint = $dfCnd.default(pastAndActiveSprintsSortedByDate);
    const lastRealEndDate = lastRealSprint && lastRealSprint.endDate || 0;
    // Now it's time to divide overlapping and parallel sprints into non-overlapping streams.
    // It needs to be done only for those real sprints with dates which appear on timeline.
    // Note they are aligned, otherwise even linear sequence of sprints will lead to the
    // stream-per-sprint degenerate case because of one day overlap.
    // Add start and end dates to future sprints to show them on a timeline.
    // Assumptions: future sprints have default sprint length and follow each other without gaps and overlaps.
    const futureSprintsWithDates = $22a874737270ee06$export$770b406429d15ffa(futureSprints, lastRealEndDate, sprintLengthInMillis);
    return [
        ...pastAndActiveSprintsSortedByDate,
        ...futureSprintsWithDates
    ].sort((a, b)=>$22a874737270ee06$var$startDateAscend(a, b) || $22a874737270ee06$var$endDateAscend(a, b));
};
const $22a874737270ee06$export$79672c235d041dc0 = (mode, adjustment)=>(0, $7CnHa.sortWith)([
        (0, $7CnHa.ascend)((issue)=>$22a874737270ee06$var$getIssueDates(issue, mode).end || 0),
        (0, $7CnHa.ascend)(({ level: level })=>level),
        (0, $7CnHa.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
        (0, $7CnHa.ascend)(({ id: id })=>adjustment.indexOf(id))
    ]);
const $22a874737270ee06$export$1395453ccdeb45c4 = (numberOfMembersInTheTeam, capacityOfTeam)=>{
    const adjustedNumberOfMembersInTheTeam = numberOfMembersInTheTeam === 0 ? 1 : numberOfMembersInTheTeam;
    const roundCapacityPerMember = Math.floor(capacityOfTeam / adjustedNumberOfMembersInTheTeam);
    let remainingCapacity = capacityOfTeam % adjustedNumberOfMembersInTheTeam;
    return $1zKBj.default(()=>{
        let availableCapacity = roundCapacityPerMember;
        if (remainingCapacity > 0) {
            availableCapacity += 1;
            remainingCapacity -= 1;
        }
        return {
            availableCapacity: availableCapacity,
            usedCapacity: 0
        };
    }, adjustedNumberOfMembersInTheTeam);
};
const $22a874737270ee06$export$78919c276404a113 = ({ defaultTeamVelocity: defaultTeamVelocity, issuesBySprint: issuesBySprint, issueStatusById: issueStatusById, planningUnit: planningUnit, stream: stream, team: team, weeklyCapacityByTeam: weeklyCapacityByTeam, boardId: boardId, mode: mode, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities })=>{
    const estimateAttribute = planningUnit === (0, $5rYNM.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
    const sorter = $22a874737270ee06$export$79672c235d041dc0(mode, issueLexoRankAdjustments);
    const carryOver = new Map();
    const updatedStream = [];
    const numberOfMembersInTheTeam = team.resources.filter(({ scenarioType: scenarioType })=>scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED).length || 1; // if there are no members in the team, we assume the entire team as a single resource
    /**
   * Helper methods
   */ // eslint-disable-next-line @typescript-eslint/no-shadow
    const getCapacityOfTeam = (team, sprint)=>{
        const iterationId = team.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban ? String(sprint.startDate) : sprint.id;
        // Explicit planned capacity will always override
        const plannedCapacity = $kjklK.default([
            team.id,
            iterationId
        ], plannedCapacities);
        if (plannedCapacity) return plannedCapacity.capacity;
        if (planningUnit === (0, $5rYNM.PlanningUnits).storyPoints) return team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
        // WeeklyCapacity is in hours, but we should take weekends into account.
        // For example, if the sprintA.startDate is 29/7/2019(Monday) and the sprintA.endDate is 2/8/2019(Friday),
        // the length of this sprintA is 5 days, there are 5 working day.
        // However, the sprintB.startDate is 30/7/2019(Tuesday) and the sprintB.endDate is 3/8/2019(Saturday), the length of this sprintB is 5 days,
        // but there are 4 working day. So the sprintA and sprintB should have different availableCapacity
        return (0, $17L5s.ONE_HOUR) * weeklyCapacityByTeam[team.id] * (0, $17L5s.getWorkingMillionSecondsBetweenTwoDates)(sprint.startDate, sprint.endDate) / (5 * (0, $17L5s.ONE_DAY)) / 1000;
    };
    const getIssuesThatFallInTheSprint = (sprint)=>(issuesByTeam[team.id] || []).filter((issue)=>{
            // note: if the issue is assigned to a sprint
            // start = rawStartDate of the sprint
            // end = rawEndDate of the sprint
            const { start: start, end: end } = $22a874737270ee06$var$getIssueDates(issue, mode);
            // ignore if the issues are assigned with a sprint. Their capacity is distributed separately
            if (issue.sprint && team.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum) return false;
            if (!(0, $7CnHa.isDefined)(sprint.startDate) || !(0, $7CnHa.isDefined)(sprint.endDate) || !(0, $7CnHa.isDefined)(start) || !(0, $7CnHa.isDefined)(end)) return false;
            // if issue does not have a sprint, it might be because it was done in a previous sprint
            // so we check if the issue was done before the start of the sprint
            if (!issue.sprint && issue.completedSprints && !$b3iuB.default(issue.completedSprints) && issue.status && issueStatusById[issue.status] && issueStatusById[issue.status].categoryId === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            end < sprint.rawStartDate) return false;
            return start >= sprint.startDate && start <= sprint.endDate || end >= sprint.startDate && end <= sprint.endDate || start <= sprint.startDate && end >= sprint.endDate;
        });
    const getIssuesAssignedToTheSprint = (sprint)=>(issuesByTeam[team.id] || []).filter((issue)=>{
            const optimizedSprint = $kjklK.default([
                'optimized',
                'sprint'
            ], issue);
            return mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771) ? optimizedSprint === sprint.id : issue.sprint === sprint.id;
        });
    // finds the next assignable member bucket which is large enough to fit the issue completely but yet small enough
    const getNextAssignableMemberBucket = (memberBuckets, estimateOfIssue)=>{
        const sortedByCapacity = $9RbxZ.default($f7Op5.default('usedCapacity'), memberBuckets);
        const assignableMiniBucket = sortedByCapacity.find((bucket)=>{
            const remainingBucketCapacity = bucket.availableCapacity - bucket.usedCapacity;
            return remainingBucketCapacity >= estimateOfIssue;
        });
        // if we couldn't find a bucket which can fit the issues completely, return the first bucket with any capacity available
        if (!assignableMiniBucket) return sortedByCapacity.find((bucket)=>bucket.availableCapacity - bucket.usedCapacity > 0);
        return assignableMiniBucket;
    };
    const isTheLastSprintOfIssue = (issue, sprint)=>{
        const { end: end } = $22a874737270ee06$var$getIssueDates(issue, mode);
        return end && end >= sprint.startDate && end <= sprint.endDate;
    };
    const getAssignableCapacity = ({ issue: issue, nextAssignableMemberBucket: nextAssignableMemberBucket, estimateOfIssue: estimateOfIssue, assignRemainingEstimateToBucket: assignRemainingEstimateToBucket })=>{
        let usedSprintCapacity = 0;
        const remainingCapacityInBucket = nextAssignableMemberBucket ? Math.max(nextAssignableMemberBucket.availableCapacity - nextAssignableMemberBucket.usedCapacity, 0) : 0;
        // if this is assignRemainingEstimateToBucket is true, we assign the entire remaining estimate to that sprint.
        // this could potentially overbook the sprint but that's the best we can do.
        if (estimateOfIssue <= remainingCapacityInBucket || assignRemainingEstimateToBucket) {
            if (nextAssignableMemberBucket) // eslint-disable-next-line no-param-reassign
            nextAssignableMemberBucket.usedCapacity += estimateOfIssue;
            usedSprintCapacity = estimateOfIssue;
            carryOver.set(issue.id, 0);
        } else {
            if (nextAssignableMemberBucket) // eslint-disable-next-line no-param-reassign
            nextAssignableMemberBucket.usedCapacity += remainingCapacityInBucket;
            usedSprintCapacity = remainingCapacityInBucket;
            carryOver.set(issue.id, estimateOfIssue - remainingCapacityInBucket);
        }
        return usedSprintCapacity;
    };
    for (const sprint of stream){
        let statusBreakdown = {
            byCategoryId: {
                [String($22a874737270ee06$var$TODO)]: 0,
                [String($22a874737270ee06$var$INPROGRESS)]: 0,
                [String($22a874737270ee06$var$DONE)]: 0
            },
            total: 0
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const allContributingIssues = {};
        let issueWithoutSprintCount = 0;
        let usedCapacity = 0;
        const capacityOfTeam = getCapacityOfTeam(team, sprint);
        const memberBuckets = $22a874737270ee06$export$1395453ccdeb45c4(numberOfMembersInTheTeam, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        capacityOfTeam);
        if (sprint.state !== (0, $5rYNM.SPRINT_STATES).CLOSED) {
            const issuesInTheSprint = getIssuesThatFallInTheSprint(sprint);
            const issuesInTheSprintSorted = sorter(issuesInTheSprint);
            const issuesAssignedToTheSprint = getIssuesAssignedToTheSprint(sprint);
            // prioritize issuesAssignedToTheSprint before any other issues since they needs to be distributed first
            const issuesToBeDistributed = [
                ...issuesAssignedToTheSprint,
                ...issuesInTheSprintSorted
            ];
            issuesToBeDistributed.forEach((issue)=>{
                const estimate = issue[estimateAttribute];
                // count issues without sprint
                if (!issue.sprint) issueWithoutSprintCount += 1;
                if (!(0, $7CnHa.isDefined)(estimate)) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sprint.unestimatedIssuesCount += 1;
                // get the estimate of the issue. If the carryOver exists, get it instead of the actual estimate from the issue
                let estimateOfIssue = carryOver.has(issue.id) ? carryOver.get(issue.id) || 0 : estimate || 0;
                let nextAssignableMemberBucket = getNextAssignableMemberBucket(memberBuckets, estimateOfIssue);
                const lastSprintOfTheIssue = issuesAssignedToTheSprint.includes(issue) || // if an issue is assigned with a sprint, the work should be done in that sprint
                isTheLastSprintOfIssue(issue, sprint);
                const addCapacityToCategory = (capacity)=>{
                    const category = $kjklK.default([
                        issue.status || '',
                        'categoryId'
                    ], issueStatusById) || $22a874737270ee06$var$TODO;
                    if (!category) return statusBreakdown;
                    const currentVal = $kjklK.default([
                        'byCategoryId',
                        category
                    ], statusBreakdown);
                    return $itLT6.default([
                        'byCategoryId',
                        category
                    ], (currentVal || 0) + capacity, statusBreakdown);
                };
                // Only counts the capacity we took from this particular issue for this sprint.
                let contributingCapacity = 0;
                const assignCapacity = (capacity)=>{
                    usedCapacity += capacity;
                    contributingCapacity += capacity;
                    statusBreakdown = addCapacityToCategory(capacity);
                };
                if (issue.level > (0, $8YqJS.STORY_LEVEL)) while(estimateOfIssue > 0 && nextAssignableMemberBucket || estimateOfIssue > 0 && lastSprintOfTheIssue){
                    const capacity = getAssignableCapacity({
                        issue: issue,
                        nextAssignableMemberBucket: nextAssignableMemberBucket,
                        estimateOfIssue: estimateOfIssue,
                        assignRemainingEstimateToBucket: lastSprintOfTheIssue && !nextAssignableMemberBucket
                    });
                    assignCapacity(capacity);
                    estimateOfIssue = carryOver.has(issue.id) ? carryOver.get(issue.id) || 0 : estimate || 0;
                    nextAssignableMemberBucket = getNextAssignableMemberBucket(memberBuckets, estimateOfIssue);
                }
                else if (nextAssignableMemberBucket || lastSprintOfTheIssue) {
                    const capacity = getAssignableCapacity({
                        issue: issue,
                        nextAssignableMemberBucket: nextAssignableMemberBucket,
                        estimateOfIssue: estimateOfIssue,
                        assignRemainingEstimateToBucket: lastSprintOfTheIssue
                    });
                    assignCapacity(capacity);
                }
                // Snapshot for allContributingIssues
                allContributingIssues[issue.id] = {
                    ...issue,
                    contributingCapacity: contributingCapacity
                };
            });
            // Breakdown by issueCount when we are using time based planningUnit
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if ([
                (0, $5rYNM.PLANNING_UNITS).HOURS,
                (0, $5rYNM.PLANNING_UNITS).DAYS
            ].includes(planningUnit)) statusBreakdown.byCategoryId = $hkOxK.default($01zCq.default({
                [String($22a874737270ee06$var$TODO)]: 0,
                [String($22a874737270ee06$var$INPROGRESS)]: 0,
                [String($22a874737270ee06$var$DONE)]: 0
            }), $1dZWS.default((issue)=>String($kjklK.default([
                    issue.status || '',
                    'categoryId'
                ], issueStatusById) || $22a874737270ee06$var$TODO)))(issuesToBeDistributed);
        }
        // the unestimated issue count on considers issues with the sprint assigned to it
        const unestimatedIssuesCount = (issuesBySprint[sprint.id] || []).filter((issue)=>issue.team === team.id && !(0, $7CnHa.isDefined)(issue[estimateAttribute])).length;
        statusBreakdown.total = $dRo9r.default($UCNmJ.default(statusBreakdown.byCategoryId));
        updatedStream.push({
            ...sprint,
            availableCapacity: Number(capacityOfTeam?.toFixed(1)),
            doneEstimate: statusBreakdown.byCategoryId[String($22a874737270ee06$var$DONE)],
            schedulingMode: team.schedulingMode,
            unestimatedIssuesCount: unestimatedIssuesCount,
            issueWithoutSprintCount: issueWithoutSprintCount,
            usedCapacity: usedCapacity,
            statusBreakdown: statusBreakdown,
            allContributingIssues: allContributingIssues,
            boardId: boardId
        });
    }
    return updatedStream;
};
const $22a874737270ee06$var$getSprintStreamsForKanbanTeam = ({ issueStatusById: issueStatusById, issuesByKanbanIteration: issuesByKanbanIteration, mode: mode, team: team, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, planningUnit: planningUnit, defaultTeamVelocity: defaultTeamVelocity, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, boardId: boardId, plannedCapacities: plannedCapacities })=>{
    // Iteration length is fixed to one week.
    // We convert it into one week fake sprint.
    // However calculating capacity and its usage is a whole world of complicated stuff involving plan defaults, plan settings and team defaults and settings.
    const activeIterationStart = (0, $17L5s.startOfUtcWeek)(Date.now()).getTime();
    const activeIterationEnd = (0, $17L5s.startOfUtcDay)(activeIterationStart + $22a874737270ee06$export$4ff47658dac00b1a) - 1;
    const activeSprint = {
        id: 'ACTIVE',
        // note: the sprint title is internationalised later, in the view
        title: 'Active Sprint',
        state: (0, $5rYNM.SPRINT_STATES).ACTIVE,
        startDate: activeIterationStart,
        endDate: activeIterationEnd,
        issueSources: [],
        rawStartDate: activeIterationStart,
        rawEndDate: activeIterationEnd
    };
    const futureSprints = $22a874737270ee06$export$ce1cefb45c8832(activeIterationEnd, timelineRange.end, $22a874737270ee06$export$4ff47658dac00b1a, (0, $5rYNM.SCHEDULE_MODE).kanban);
    const allSprints = [
        activeSprint,
        ...futureSprints
    ];
    const allSprintsWithCapacity = $22a874737270ee06$export$78919c276404a113({
        defaultTeamVelocity: defaultTeamVelocity,
        issuesBySprint: issuesByKanbanIteration,
        issueStatusById: issueStatusById,
        planningUnit: planningUnit,
        stream: allSprints,
        team: team,
        weeklyCapacityByTeam: weeklyCapacityByTeam,
        boardId: boardId,
        mode: mode,
        issueLexoRankAdjustments: issueLexoRankAdjustments,
        issuesByTeam: issuesByTeam,
        plannedCapacities: plannedCapacities
    });
    const sprintsWithCapacity = allSprintsWithCapacity.filter((sprint)=>$22a874737270ee06$var$sprintAppearsOnTimeline(timelineRange, sprint));
    return [
        sprintsWithCapacity
    ];
};
const $22a874737270ee06$export$df033e038ec34c36 = ({ defaultIterationLength: defaultIterationLength, defaultTeamVelocity: defaultTeamVelocity, issueStatusById: issueStatusById, issuesByKanbanIteration: issuesByKanbanIteration, issuesBySprint: issuesBySprint, mode: mode, planningUnit: planningUnit, sprintsForTeam: sprintsForTeam, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, issueSources: issueSources, issueLexoRankAdjustments: issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities })=>(team)=>{
        const { value: boardId } = issueSources.find((source)=>source.id === team.issueSource) || {};
        // Kanban teams don't have sprints, but to show capacity we are going to generate
        // some fake ones representing iterations.
        if (team.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban) return $22a874737270ee06$var$getSprintStreamsForKanbanTeam({
            issueStatusById: issueStatusById,
            issuesByKanbanIteration: issuesByKanbanIteration,
            mode: mode,
            team: team,
            timelineRange: timelineRange,
            weeklyCapacityByTeam: weeklyCapacityByTeam,
            planningUnit: planningUnit,
            defaultTeamVelocity: defaultTeamVelocity,
            issuesByTeam: issuesByTeam,
            issueLexoRankAdjustments: issueLexoRankAdjustments,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            boardId: boardId,
            plannedCapacities: plannedCapacities
        });
        let sprintsInStream = [];
        sprintsInStream = $22a874737270ee06$export$58007ae5dd91fcc6(team, sprintsForTeam, defaultIterationLength);
        if (!sprintsInStream) return [];
        // Those dates are required to know where to start fake past and real/fake future sprints.
        // If there are no real sprints with dates then sprints should start from tomorrow.
        // Sprints should not start from today because we cannot reasonably expect work to be started on the current day.
        const tomorrow = (0, $17L5s.startOfUtcDay)(Date.now() + (0, $17L5s.ONE_DAY));
        // Add start and end dates to future sprints to show them on a timeline.
        // Assumptions: future sprints have default sprint length and follow each other without gaps and overlaps.
        const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, $17L5s.ONE_WEEK);
        // Now it's time to add fake past/future sprints to fill the gap up to timeline range.
        const firstRealSprint = $f2C9X.default(sprintsInStream);
        const fakePastSprints = $22a874737270ee06$export$800f6e20804f9ed1(timelineRange.start, firstRealSprint && firstRealSprint.startDate || tomorrow, sprintLengthInMillis, (0, $5rYNM.SCHEDULE_MODE).scrum);
        const lastRealSprint = $dfCnd.default(sprintsInStream);
        const fakeFutureSprints = $22a874737270ee06$export$ce1cefb45c8832(lastRealSprint && lastRealSprint.endDate || tomorrow, timelineRange.end, sprintLengthInMillis, (0, $5rYNM.SCHEDULE_MODE).scrum);
        // Top stream is the stream we attach fake past/future sprints to.
        const streams = $22a874737270ee06$export$16f1e219d71d96ad(sprintsInStream);
        const topStream = streams[0];
        topStream.splice(0, 0, ...fakePastSprints);
        Array.prototype.push.apply(topStream, fakeFutureSprints);
        // should filter the sprint in here, if filter the invisible sprint in the getAlignedSprints method, will get a wrong the firstRealStartDate and lastRealEndDate
        // should make sure there is at least a visible sprint in the stream, to fix https://bulldog.internal.atlassian.com/browse/JPOS-4010
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const streamsContainVisibleSprint = streams.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
        (streamsContainVisibleSprint, stream)=>{
            const visibleSprint = stream.filter((sprint)=>$22a874737270ee06$var$sprintAppearsOnTimeline(timelineRange, sprint));
            if (visibleSprint.length > 0) {
                // we don't want to provide comparison of sprint's iteration length (start and end dates)
                // for teams that have no any issue
                if (!issuesByTeam[team.id] && mode !== (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) return [];
                const allSprintsWithCapacity = $22a874737270ee06$export$78919c276404a113({
                    defaultTeamVelocity: defaultTeamVelocity,
                    issuesBySprint: issuesBySprint,
                    issueStatusById: issueStatusById,
                    planningUnit: planningUnit,
                    stream: stream,
                    team: team,
                    weeklyCapacityByTeam: weeklyCapacityByTeam,
                    boardId: boardId,
                    mode: mode,
                    issueLexoRankAdjustments: issueLexoRankAdjustments,
                    issuesByTeam: issuesByTeam,
                    plannedCapacities: plannedCapacities
                });
                const visibleSprintsWithCapacity = allSprintsWithCapacity.filter((sprint)=>$22a874737270ee06$var$sprintAppearsOnTimeline(timelineRange, sprint));
                streamsContainVisibleSprint.push(visibleSprintsWithCapacity);
            }
            return streamsContainVisibleSprint;
        }, []);
        return streamsContainVisibleSprint;
    };
const $22a874737270ee06$export$6456c14aff191bdf = (issues, mode)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issuesByKanbanIteration = {};
    for (const issue of issues){
        const { start: start, end: end } = $22a874737270ee06$var$getIssueDates(issue, mode);
        if ((0, $7CnHa.isDefined)(start) && (0, $7CnHa.isDefined)(end)) {
            let iterationStart = (0, $17L5s.startOfUtcWeek)(start).getTime();
            while(iterationStart < end){
                if (!issuesByKanbanIteration[iterationStart]) issuesByKanbanIteration[iterationStart] = [];
                issuesByKanbanIteration[iterationStart].push(issue);
                iterationStart = (0, $17L5s.startOfUtcDay)(iterationStart + $22a874737270ee06$export$4ff47658dac00b1a);
            }
        }
    }
    return issuesByKanbanIteration;
};
const $22a874737270ee06$export$39b9f591cb5babf9 = (issues)=>(0, $7CnHa.groupBy)((x)=>x.sprint || '', issues.filter((x)=>x.sprint));
const $22a874737270ee06$export$352df393d87c6e45 = (issues, solution)=>{
    const getAssignedSprint = $22a874737270ee06$export$98922a1700a2456(solution);
    const getIssueSprint = ({ level: level, sprint: sprint, assignments: assignments })=>{
        if (level > (0, $8YqJS.EPIC_LEVEL)) return sprint;
        const sprintAssignments = assignments.filter(getAssignedSprint);
        if (sprintAssignments.length === 1) {
            const assignedSprint = getAssignedSprint(sprintAssignments[0]);
            // https://bulldog.internal.atlassian.com/browse/JPOS-3354 fix this bugs, when optimization changes the sprint value  to a sprint which id is undefined
            return assignedSprint && assignedSprint.sprintId;
        }
        return sprint;
    };
    const getIssueTeam = ({ team: team, assignments: assignments })=>{
        const teamAssignment = assignments.find(getAssignedSprint) || assignments.find((x)=>x.team);
        return teamAssignment && teamAssignment.team || team;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, $7CnHa.groupBy)((x)=>x.sprint || '', (0, $7CnHa.filterMap)((issue)=>!!getIssueSprint(issue), (issue)=>({
            ...issue,
            sprint: getIssueSprint(issue),
            team: getIssueTeam(issue)
        }), issues));
};
const $22a874737270ee06$export$366891b86c1a480d = (sprintsAreShown, teams, context)=>sprintsAreShown ? $cQGVO.default($22a874737270ee06$export$df033e038ec34c36(context), (0, $7CnHa.indexBy)((x)=>x.id, teams)) : {};
const $22a874737270ee06$export$2c19bb597f3993ce = (sprintsAreShown, _, context)=>(timelineRange, team)=>{
        const contextWithUpdatedTimelineRange = {
            ...context,
            timelineRange: timelineRange
        };
        return sprintsAreShown ? $22a874737270ee06$export$df033e038ec34c36(contextWithUpdatedTimelineRange)(team) : [];
    };
const $22a874737270ee06$var$getAssignedStartAndEndDateForFutureSprint = (streamsUnitsForTeams)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const futureSprintsWithStartandEndDate = {};
    $5ckL2.default((streams, teamId)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const allFutureSprint = streams.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
        (allFutureSprint, stream, index)=>allFutureSprint.concat(stream.filter((sprint)=>sprint.state === (0, $5rYNM.SPRINT_STATES).FUTURE && sprint.id !== 'GAP' && sprint.id !== 'FUTURE').map((sprint)=>({
                    ...sprint,
                    streamIndex: index
                }))), []);
        allFutureSprint.forEach((sprint)=>{
            const { id: id, endDate: endDate, startDate: startDate, streamIndex: streamIndex } = sprint;
            if ($kDrtX.default(futureSprintsWithStartandEndDate[id])) futureSprintsWithStartandEndDate[id] = [];
            futureSprintsWithStartandEndDate[id].push({
                endDate: endDate,
                startDate: startDate,
                teamId: teamId,
                streamIndex: streamIndex
            });
        });
    }, streamsUnitsForTeams);
    return futureSprintsWithStartandEndDate;
};
const $22a874737270ee06$export$c501cbd65c882409 = (streamsUnitsForTeams)=>{
    const futureSprintsWithStartAndEndDate = $22a874737270ee06$var$getAssignedStartAndEndDateForFutureSprint(streamsUnitsForTeams);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sprintAreInconsistent = [];
    $5ckL2.default((dateArray, sprintId)=>{
        let isTimeRangeDifferentInTeams = false;
        for(let i = 0, len = dateArray.length; i < len - 1; i++)if (!($dSK2s.default('startDate', dateArray[i], dateArray[i + 1]) && $dSK2s.default('endDate', dateArray[i], dateArray[i + 1]))) {
            isTimeRangeDifferentInTeams = true;
            break;
        }
        if (isTimeRangeDifferentInTeams) sprintAreInconsistent.push(sprintId);
    }, futureSprintsWithStartAndEndDate);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        ...new Set(sprintAreInconsistent)
    ];
};
const $22a874737270ee06$export$a2649b86fe314f7f = (streamsForTeams, timelineRange)=>{
    const omitGaps = !Number.isFinite(timelineRange.start * timelineRange.end);
    return $cQGVO.default((streams)=>streams.map((sprints)=>$22a874737270ee06$export$ac96f955bd8392a1(sprints, timelineRange, omitGaps)), streamsForTeams);
};
const $22a874737270ee06$export$364b800ef2163c = (getSprintStreams, zoomLevel)=>(timelineRange, team)=>{
        const omitGaps = zoomLevel !== undefined;
        return getSprintStreams(timelineRange, team).map((sprints)=>$22a874737270ee06$export$ac96f955bd8392a1(sprints, timelineRange, omitGaps));
    };
const $22a874737270ee06$export$eb0254c397e556b3 = (sprintsByTeam, teams, issueSources, sprints, defaultIterationLength)=>{
    const result = {
        team: {},
        sprint: {}
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const addDates = (sprints, sprintLengthInMillis)=>{
        const [futureSprints, pastAndActiveSprints] = $3by2Y.default((x)=>x.state === (0, $5rYNM.SPRINT_STATES).FUTURE, sprints);
        const pastAndActiveSprintsSortedByDate = $22a874737270ee06$export$f698cc36cb31ff11(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        pastAndActiveSprints);
        const lastRealSprint = $dfCnd.default(pastAndActiveSprintsSortedByDate);
        const lastRealEndDate = lastRealSprint && lastRealSprint.endDate || 0;
        const futureSprintsWithDates = $22a874737270ee06$export$770b406429d15ffa(futureSprints, lastRealEndDate, sprintLengthInMillis);
        return [
            ...pastAndActiveSprintsSortedByDate,
            ...futureSprintsWithDates
        ];
    };
    for (const team of teams){
        const sprintsForTeam = sprintsByTeam[team.id] || [];
        const sprintLengthInMillis = (team.iterationLength || defaultIterationLength || 0) * (0, $17L5s.ONE_WEEK);
        const futureSprintsForTeam = addDates(sprintsForTeam, sprintLengthInMillis);
        if (futureSprintsForTeam.length > 0) result.team[team.id] = [
            ...futureSprintsForTeam
        ];
    }
    issueSources.filter((issueSource)=>issueSource.type === (0, $5rYNM.ISSUE_SOURCE_TYPES).BOARD).forEach((issueSource)=>{
        const sprintLengthInMillis = (defaultIterationLength || 0) * (0, $17L5s.ONE_WEEK);
        const sprintForIssueSource = $22a874737270ee06$export$14dc3d2554a83ab1(issueSource.sprintIds || [], sprints);
        const futureSprintsForIssueSource = addDates(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sprintForIssueSource, sprintLengthInMillis);
        if (futureSprintsForIssueSource.length > 0) // Future sprints are calculated per issue source but the map is indexed by sprintIds from those issue sources
        // because it makes lookup easier by sprint id when consuming
        (issueSource.sprintIds || []).forEach((sprintId)=>{
            if (!result.sprint[sprintId]) result.sprint[sprintId] = [
                ...futureSprintsForIssueSource
            ];
        });
    });
    return result;
};
const $22a874737270ee06$var$sortDateAsc = (firstDate, secondDate)=>firstDate - secondDate;
const $22a874737270ee06$var$sortDateDsc = (firstDate, secondDate)=>secondDate - firstDate;
const $22a874737270ee06$export$9c9d199864f2b0a1 = (sprints, prop)=>{
    const dates = sprints.map((sprint)=>sprint[prop] ?? undefined);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const datesWithoutNulls = dates.filter((date)=>date !== undefined);
    const sortFn = prop === 'startDate' || prop === 'rawStartDate' ? $22a874737270ee06$var$sortDateAsc : $22a874737270ee06$var$sortDateDsc;
    const sortedArray = $l7xwn.default(sortFn)(datesWithoutNulls);
    return sortedArray[0];
};
const $22a874737270ee06$export$6b6ffbeb66570a75 = (issue, sprints, issueStatusById)=>{
    const sprintsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), sprints);
    const mapSprints = $hkOxK.default($fpul1.default((0, $7CnHa.isDefined)), $cQGVO.default((id)=>sprintsById[id]));
    const statusCategory = issueStatusById && $kjklK.default([
        issue.status || '',
        'categoryId'
    ], issueStatusById);
    if (!issue.sprint && (statusCategory === $22a874737270ee06$var$TODO || statusCategory === $22a874737270ee06$var$INPROGRESS)) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const sprints = mapSprints(issue.completedSprints || []);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            startDate: $22a874737270ee06$export$9c9d199864f2b0a1(sprints, 'startDate'),
            endDate: $22a874737270ee06$export$9c9d199864f2b0a1(sprints, 'endDate'),
            rawStartDate: $22a874737270ee06$export$9c9d199864f2b0a1(sprints, 'rawStartDate'),
            rawEndDate: $22a874737270ee06$export$9c9d199864f2b0a1(sprints, 'rawEndDate')
        };
    }
    const allSprintsIds = [
        ...issue.completedSprints || [],
        ...issue.sprint ? [
            issue.sprint
        ] : []
    ];
    const mappedSprints = mapSprints(allSprintsIds);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        startDate: $22a874737270ee06$export$9c9d199864f2b0a1(mappedSprints, 'startDate'),
        endDate: $22a874737270ee06$export$9c9d199864f2b0a1(mappedSprints, 'endDate'),
        rawStartDate: $22a874737270ee06$export$9c9d199864f2b0a1(mappedSprints, 'rawStartDate'),
        rawEndDate: $22a874737270ee06$export$9c9d199864f2b0a1(mappedSprints, 'rawEndDate')
    };
};
const $22a874737270ee06$export$d7616b811073c058 = (teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel)=>{
    const otherSprints = [];
    const result = Object.entries(sprintsByIssueSources).reduce((previous, [issueSource, sprints])=>{
        const currentSprintBelongsToCurrentTeam = (teamOfIssue && sprintsByTeam[teamOfIssue] || []).some((sprint)=>sprint.id === sprintOfIssue);
        const isExternalTeam = teamOfIssue && additionalTeamsById && (0, $7CnHa.isDefined)(additionalTeamsById[teamOfIssue]);
        const issueSourceBelongsToATeam = teams.some((team)=>team.issueSource === Number(issueSource));
        if (!issueSourceBelongsToATeam) otherSprints.push(...sprints.filter((sprint)=>sprint.state !== (0, $5rYNM.SPRINT_STATES).CLOSED));
        const teamsOfIssueSource = teams.filter((team)=>{
            if (team.issueSource !== Number(issueSource)) return false;
            if (isExternalTeam) return true; // if an team is external, show all the sprints
            if (teamOfIssue && teamsById && teamsById[teamOfIssue] && !teamsById[teamOfIssue].issueSource) return true;
            if (sprintOfIssue && teamOfIssue) {
                if (currentSprintBelongsToCurrentTeam) return team.id === teamOfIssue;
                return true; // if team and sprint is selected but the sprint doesn't belong to the team, show all the  sprints
            }
            if (teamOfIssue) return team.id === teamOfIssue; // if team is selected, show only sprints of the team
            return true;
        });
        if (teamsOfIssueSource.length > 0) {
            const label = teamsOfIssueSource.map((team)=>team.title).join(', ');
            const futureSprints = sprints.filter((sprint)=>sprint.state !== (0, $5rYNM.SPRINT_STATES).CLOSED);
            previous.set(label, futureSprints);
        }
        return previous;
    }, new Map());
    if (otherSprints.length) return result.set(otherSprintsLabel, otherSprints);
    return result;
};
const $22a874737270ee06$export$230a55ad90f8755 = (teams, { defaultIterationLength: defaultIterationLength, defaultTeamVelocity: defaultTeamVelocity, issueStatusById: issueStatusById, issuesBySprint: issuesBySprint, mode: mode, planningUnit: planningUnit, sprintsForTeam: sprintsForTeam, timelineRange: timelineRange, weeklyCapacityByTeam: weeklyCapacityByTeam, issueSources: issueSources = [], issueLexoRankAdjustments: // Default to [] as we've seen "cannot read property 'find' of undefined" errors
issueLexoRankAdjustments, issuesByTeam: issuesByTeam, plannedCapacities: plannedCapacities })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const team of teams)if (team.schedulingMode !== (0, $5rYNM.SCHEDULE_MODE).kanban) {
        const alignedSprints = $22a874737270ee06$export$58007ae5dd91fcc6(team, sprintsForTeam, defaultIterationLength);
        if ((0, $7CnHa.isDefined)(alignedSprints)) {
            const { value: boardId } = issueSources.find((source)=>source.id === team.issueSource) || {};
            const sprintsWithCapacity = $22a874737270ee06$export$78919c276404a113({
                defaultTeamVelocity: defaultTeamVelocity,
                issuesBySprint: issuesBySprint,
                issueStatusById: issueStatusById,
                planningUnit: planningUnit,
                stream: alignedSprints,
                team: team,
                weeklyCapacityByTeam: weeklyCapacityByTeam,
                boardId: boardId,
                mode: mode,
                issueLexoRankAdjustments: issueLexoRankAdjustments,
                issuesByTeam: issuesByTeam,
                plannedCapacities: plannedCapacities
            });
            const sprintsWithCapacityById = (0, $7CnHa.indexBy)((x)=>x.id, sprintsWithCapacity);
            result[team.id] = $cQGVO.default((sprintWithCapacity)=>$22a874737270ee06$export$ac96f955bd8392a1([
                    sprintWithCapacity
                ], timelineRange), sprintsWithCapacityById);
        }
    }
    return result;
};
const $22a874737270ee06$export$570cdbd5979ccd = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
    const hourInSeconds = (0, $17L5s.ONE_HOUR) / 1000;
    const { days: days, hours: hours } = (0, $5rYNM.PlanningUnits);
    switch(planningUnit){
        case days:
            return (0, (/*@__PURE__*/$parcel$interopDefault($ji0fW)))(capacity / (hourInSeconds * workingHours), 2);
        case hours:
            return (0, (/*@__PURE__*/$parcel$interopDefault($ji0fW)))(capacity / hourInSeconds, 2);
        default:
            return (0, (/*@__PURE__*/$parcel$interopDefault($ji0fW)))(capacity, 2);
    }
};
const $22a874737270ee06$export$acbcfbe3e761e0b4 = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
    const hourInSeconds = (0, $17L5s.ONE_HOUR) / 1000;
    const { days: days, hours: hours } = (0, $5rYNM.PlanningUnits);
    switch(planningUnit){
        case days:
            return capacity * hourInSeconds * workingHours;
        case hours:
            return capacity * hourInSeconds;
        default:
            return capacity;
    }
};
const $22a874737270ee06$var$calculateDefaultSprintCapacity = (sprint, team, planningUnit, weeklyCapacity, defaultTeamVelocity)=>{
    let availableCapacity = 0;
    if (planningUnit === (0, $5rYNM.PlanningUnits).storyPoints) availableCapacity = team.velocity || team.velocity === 0 ? team.velocity : defaultTeamVelocity;
    else // WeeklyCapacity is in hours, but we should take weekends into account.
    // For example, if the sprintA.startDate is 29/7/2019(Monday) and the sprintA.endDate is 2/8/2019(Friday),
    // the length of this sprintA is 5 days, there are 5 working day.
    // However, the sprintB.startDate is 30/7/2019(Tuesday) and the sprintB.endDate is 3/8/2019(Saturday), the length of this sprintB is 5 days,
    // but there are 4 working day. So the sprintA and sprintB should have different availableCapacity
    availableCapacity = (0, $17L5s.ONE_HOUR) * weeklyCapacity * (0, $17L5s.getWorkingMillionSecondsBetweenTwoDates)(sprint.startDate, sprint.endDate) / (5 * (0, $17L5s.ONE_DAY)) / 1000;
    return availableCapacity;
};
const $22a874737270ee06$export$5389b2bbf0271c30 = (plannedCapacities, originalPlannedCapacities, { team: sprintsByTeam }, planningUnit, defaultTeamVelocity, weeklyCapacityByTeam, teamsById, metaData)=>{
    const twoLevelObjectValues = $3IGDG.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $UCNmJ.default, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $hC4q3.default($UCNmJ.default));
    const flattenedOriginals = twoLevelObjectValues(originalPlannedCapacities);
    const applyDefaultCapacity = (plannedCapacity)=>{
        if (Number.isInteger(plannedCapacity.capacity)) return plannedCapacity;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const weeklyCapacity = weeklyCapacityByTeam[plannedCapacity.teamId];
        let defaultCapacity;
        if (plannedCapacity.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const teamSprints = sprintsByTeam[plannedCapacity.teamId] || [];
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const sprint = teamSprints.find((sprint)=>sprint.id === plannedCapacity.iterationId);
            if (!sprint) return plannedCapacity;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const team = teamsById[plannedCapacity.teamId];
            defaultCapacity = $22a874737270ee06$var$calculateDefaultSprintCapacity(sprint, team, planningUnit, weeklyCapacity, defaultTeamVelocity);
        } else defaultCapacity = (0, $17L5s.ONE_HOUR) * weeklyCapacity / 1000;
        return {
            ...plannedCapacity,
            capacity: defaultCapacity
        };
    };
    const changes = flattenedOriginals.map(// @ts-expect-error TS2345 - Argument of type '(original: OriginalPlannedCapacity) => { iterationId: string; teamId: string; values: PlannedCapacity; originals: PlannedCapacity; metaData: ChangeMetadata | null; }' is not assignable to parameter of type '(value: PlannedCapacities, index: number, array: PlannedCapacities[]) => { iterationId: string; teamId: string; values: PlannedCapacity; originals: PlannedCapacity; metaData: ChangeMetadata | null; }'.
    (original)=>{
        /*
                 If a capacity has been deleted, there will be an original without a current value.
                 So we reconstruct the current value by using the original value with a capacity
                 of 0.
                 Also:
                 When a sprint velocity changes, the original value is set in the store before
                 the new value is. So it's possible for this query to run when the new value isn't
                 set yet. In this case, the reconstructed value will be used for a brief moment.
              */ const newValue = $kjklK.default([
            original.teamId,
            original.iterationId
        ], plannedCapacities) || {
            ...original,
            capacity: null
        };
        return {
            iterationId: original.iterationId,
            teamId: original.teamId,
            values: applyDefaultCapacity(newValue),
            originals: applyDefaultCapacity(original),
            metaData: metaData && original.itemKey ? metaData[original.itemKey] : null
        };
    });
    return changes;
};
const $22a874737270ee06$export$7ad618a806be26f0 = (plannedCapacityChanges, { sprint: sprintsWithDates })=>{
    const velocityChangesBySprint = $eirae.default($f7Op5.default('iterationId'), plannedCapacityChanges);
    const entries = $eCpJ2.default(velocityChangesBySprint);
    const changes = entries.map(([sprintId, capacityChanges])=>{
        const changeCount = capacityChanges.length;
        const attributeName = changeCount === 1 ? `teamVelocity-${capacityChanges[0].teamId}` : undefined;
        let sprintWithoutCapacities;
        if (capacityChanges[0].values.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sprintWithoutCapacities = sprintsWithDates[sprintId].find((sprint)=>sprint.id === sprintId);
        else {
            const iterationStart = +sprintId;
            const iterationEnd = (0, $17L5s.startOfUtcDay)(iterationStart + $22a874737270ee06$export$4ff47658dac00b1a) - 1000;
            sprintWithoutCapacities = $22a874737270ee06$var$createFutureSprint(iterationStart, iterationEnd, (0, $5rYNM.SCHEDULE_MODE).kanban);
            sprintWithoutCapacities.id = sprintId;
        }
        // NOTE: SprintWithVelocities extends TimelineSprint type, but it's indistinguishable to TS with an object spread
        const sprintWithNewVelocities = {
            ...sprintWithoutCapacities
        };
        capacityChanges.forEach((change)=>{
            sprintWithNewVelocities[`teamVelocity-${change.teamId}`] = change.values;
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const originals = {};
        capacityChanges.forEach((change)=>{
            originals[`teamVelocity-${change.teamId}`] = change.originals;
        });
        let metaData = {
            // Default, in case we can't find metadata for any of the capacity changes
            lastChangeTimestamp: 1579059707222,
            lastChangeUser: '',
            scenarioType: (0, $5rYNM.SCENARIO_TYPE).UPDATED
        };
        // Get the most recent capacity change metadata
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const metaDataObjects = capacityChanges.map((change)=>({
                ...change.metaData,
                // The capacity may have been added, updated or removed.
                // Since this metadata will now represent the sprint itself,
                // rather than the capacity, we should always consider it updated.
                scenarioType: (0, $5rYNM.SCENARIO_TYPE).UPDATED
            })).filter($l0L3x.default); // NOTE: TS doesn't know filter(R.identity) will remove all objects without metaData
        metaDataObjects.sort((a, b)=>b.lastChangeTimestamp - a.lastChangeTimestamp);
        if (metaDataObjects.length) metaData = metaDataObjects[0];
        return {
            attributeName: attributeName,
            changeCount: changeCount,
            id: sprintId,
            warnings: [],
            category: (0, $5rYNM.ENTITY).SPRINT,
            details: {
                values: sprintWithNewVelocities,
                originals: originals
            },
            metaData: metaData
        };
    });
    return changes;
};
const $22a874737270ee06$export$5841f9eb9773f25f = (startTime, endTime)=>{
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    return startDate.getUTCFullYear() === endDate.getUTCFullYear();
};
const $22a874737270ee06$export$c0501b9f0bd00198 = (intl, startDate, endDate)=>{
    const dateTimeFormatWithoutYearOptions = {
        day: '2-digit',
        month: 'short',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
        timeZoneName: 'short'
    };
    const dateTimeFormatWithYearOptions = {
        ...dateTimeFormatWithoutYearOptions,
        year: 'numeric'
    };
    const formatDateTimeString = $22a874737270ee06$export$5841f9eb9773f25f(startDate, endDate) ? dateTimeFormatWithoutYearOptions : dateTimeFormatWithYearOptions;
    return {
        startDate: (0, $l2Sj2.formatTimestampWithIntl)(intl, startDate, formatDateTimeString),
        endDate: (0, $l2Sj2.formatTimestampWithIntl)(intl, endDate, formatDateTimeString)
    };
};
const $22a874737270ee06$export$a18c89cbd24170ff = (startTime, endTime)=>{
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    return startDate.getUTCMonth() === endDate.getUTCMonth();
};
const $22a874737270ee06$export$2e9241a0bdf6c8b8 = (intl, startDate, endDate)=>{
    if ($22a874737270ee06$export$a18c89cbd24170ff(startDate, endDate)) {
        const startDateOfMonth = new Date(startDate).getUTCDate();
        return `${startDateOfMonth} \u2013 ${(0, $l2Sj2.formatTimestampWithIntl)(intl, endDate, (0, $eTbtL.dateMonthFormat))}`;
    }
    const formatDateString = $22a874737270ee06$export$5841f9eb9773f25f(startDate, endDate) ? (0, $eTbtL.dateMonthFormat) : (0, $eTbtL.longDateFormat);
    return `${(0, $l2Sj2.formatTimestampWithIntl)(intl, startDate, formatDateString)} \u2013 ${(0, $l2Sj2.formatTimestampWithIntl)(intl, endDate, formatDateString)} `;
};
const $22a874737270ee06$export$9f71a9790fe294f = (intl)=>({ sprint: sprint, isFutureProjectedSprint: isFutureProjectedSprint })=>{
        if (isFutureProjectedSprint) return intl.formatMessage((0, $ib5d3.default).futureProjectedSprint);
        switch(sprint.state){
            case (0, $5rYNM.SPRINT_STATES).CLOSED:
                return intl.formatMessage((0, $ib5d3.default).completedSprint);
            case (0, $5rYNM.SPRINT_STATES).ACTIVE:
                return intl.formatMessage((0, $ib5d3.default).activeSprint);
            case (0, $5rYNM.SPRINT_STATES).FUTURE:
                return intl.formatMessage((0, $ib5d3.default).futureSprint);
            default:
                return '';
        }
    };
const $22a874737270ee06$export$4d9e331cafeacb9d = (state)=>{
    switch(state){
        case (0, $5rYNM.SPRINT_STATES).CLOSED:
            return 'success';
        case (0, $5rYNM.SPRINT_STATES).ACTIVE:
            return 'inprogress';
        case (0, $5rYNM.SPRINT_STATES).FUTURE:
            return 'default';
        default:
            return 'default';
    }
};
const $22a874737270ee06$export$fd6ceee9e9533c99 = (intl)=>(state)=>{
        switch(state){
            case (0, $5rYNM.SPRINT_STATES).CLOSED:
                return intl.formatMessage((0, $ib5d3.default).completedSprintState);
            case (0, $5rYNM.SPRINT_STATES).ACTIVE:
                return intl.formatMessage((0, $ib5d3.default).activeSprintState);
            case (0, $5rYNM.SPRINT_STATES).FUTURE:
                return intl.formatMessage((0, $ib5d3.default).futureSprintState);
            case 0, $5rYNM.EXTERNAL_SPRINT:
                return intl.formatMessage((0, $ib5d3.default).externalSprintState);
            default:
                return '';
        }
    };
const $22a874737270ee06$export$6f891d146561f05a = (intl)=>(state)=>{
        switch(state){
            case (0, $5rYNM.SPRINT_STATES).CLOSED:
                return intl.formatMessage((0, $ib5d3.default).completedSprintsLabel);
            case (0, $5rYNM.SPRINT_STATES).ACTIVE:
                return intl.formatMessage((0, $ib5d3.default).activeSprintsLabel);
            case (0, $5rYNM.SPRINT_STATES).FUTURE:
                return intl.formatMessage((0, $ib5d3.default).futureSprintsLabel);
            case 0, $5rYNM.EXTERNAL_SPRINT:
                return intl.formatMessage((0, $ib5d3.default).externalSprintsLabel);
            default:
                return '';
        }
    };

});
parcelRegister("ji0fW", function(module, exports) {

var $kKsLa = parcelRequire("kKsLa");
/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $e0afe5a3934eab9b$var$round = $kKsLa('round');
module.exports = $e0afe5a3934eab9b$var$round;

});
parcelRegister("kKsLa", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");

var $hNahz = parcelRequire("hNahz");

var $7kP6w = parcelRequire("7kP6w");

var $1uqnh = parcelRequire("1uqnh");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $03e5e8ede243e943$var$nativeIsFinite = $c1MCs.isFinite, $03e5e8ede243e943$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $03e5e8ede243e943$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $7kP6w(number);
        precision = precision == null ? 0 : $03e5e8ede243e943$var$nativeMin($hNahz(precision), 292);
        if (precision && $03e5e8ede243e943$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($1uqnh(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($1uqnh(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $03e5e8ede243e943$var$createRound;

});


parcelRegister("hC4q3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2969d5f41035d0$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $bNA4U = parcelRequire("bNA4U");

var $iQS1H = parcelRequire("iQS1H");

var $cQGVO = parcelRequire("cQGVO");
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $cd2969d5f41035d0$var$chain = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'fantasy-land/chain',
    'chain'
], (0, $iQS1H.default), function chain(fn, monad) {
    if (typeof monad === 'function') return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $bNA4U.default)(false)((0, $cQGVO.default)(fn, monad));
}));
var $cd2969d5f41035d0$export$2e2bcd8739ae039 = $cd2969d5f41035d0$var$chain;

});
parcelRegister("iQS1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $db96fdd928c07bc0$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $2Pumm = parcelRequire("2Pumm");

var $cQGVO = parcelRequire("cQGVO");
var $db96fdd928c07bc0$var$_xchain = /*#__PURE__*/ (0, $ggdJA.default)(function _xchain(f, xf) {
    return (0, $cQGVO.default)(f, (0, $2Pumm.default)(xf));
});
var $db96fdd928c07bc0$export$2e2bcd8739ae039 = $db96fdd928c07bc0$var$_xchain;

});
parcelRegister("2Pumm", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f7e5029950c2ef$export$2e2bcd8739ae039);

var $k7y51 = parcelRequire("k7y51");

var $b3lcT = parcelRequire("b3lcT");

var $hC9UT = parcelRequire("hC9UT");

var $8uquE = parcelRequire("8uquE");
var $20f7e5029950c2ef$var$preservingReduced = function(xf) {
    return {
        '@@transducer/init': (0, $8uquE.default).init,
        '@@transducer/result': function(result) {
            return xf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            var ret = xf['@@transducer/step'](result, input);
            return ret['@@transducer/reduced'] ? (0, $k7y51.default)(ret) : ret;
        }
    };
};
var $20f7e5029950c2ef$var$_flatCat = function _xcat(xf) {
    var rxf = $20f7e5029950c2ef$var$preservingReduced(xf);
    return {
        '@@transducer/init': (0, $8uquE.default).init,
        '@@transducer/result': function(result) {
            return rxf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            return !(0, $b3lcT.default)(input) ? (0, $hC9UT.default)(rxf, result, [
                input
            ]) : (0, $hC9UT.default)(rxf, result, input);
        }
    };
};
var $20f7e5029950c2ef$export$2e2bcd8739ae039 = $20f7e5029950c2ef$var$_flatCat;

});
parcelRegister("k7y51", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5ee5a86e2e49dc$export$2e2bcd8739ae039);
function $ea5ee5a86e2e49dc$export$2e2bcd8739ae039(x) {
    return {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

});




parcelRegister("hkOxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9eb82c04a94bba6$export$2e2bcd8739ae039);

var $3IGDG = parcelRequire("3IGDG");

var $2uEDR = parcelRequire("2uEDR");
function $c9eb82c04a94bba6$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error('compose requires at least one argument');
    return (0, $3IGDG.default).apply(this, (0, $2uEDR.default)(arguments));
}

});
parcelRegister("2uEDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0de8bd503729e3$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $faRtN = parcelRequire("faRtN");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $1d0de8bd503729e3$var$reverse = /*#__PURE__*/ (0, $eSWTK.default)(function reverse(list) {
    return (0, $faRtN.default)(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
var $1d0de8bd503729e3$export$2e2bcd8739ae039 = $1d0de8bd503729e3$var$reverse;

});


parcelRegister("5ckL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c8e2ccd4b2ccf1e$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $erwaN = parcelRequire("erwaN");
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $3c8e2ccd4b2ccf1e$var$forEachObjIndexed = /*#__PURE__*/ (0, $ggdJA.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $erwaN.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $3c8e2ccd4b2ccf1e$export$2e2bcd8739ae039 = $3c8e2ccd4b2ccf1e$var$forEachObjIndexed;

});

parcelRegister("l0L3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4be1966edf7e077$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $1kIfb = parcelRequire("1kIfb");
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $f4be1966edf7e077$var$identity = /*#__PURE__*/ (0, $eSWTK.default)((0, $1kIfb.default));
var $f4be1966edf7e077$export$2e2bcd8739ae039 = $f4be1966edf7e077$var$identity;

});
parcelRegister("1kIfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f89fa99ec2653e5$export$2e2bcd8739ae039);
function $0f89fa99ec2653e5$export$2e2bcd8739ae039(x) {
    return x;
}

});


parcelRegister("dfCnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5a7141994058db$export$2e2bcd8739ae039);

var $adz2t = parcelRequire("adz2t");
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $9a5a7141994058db$var$last = /*#__PURE__*/ (0, $adz2t.default)(-1);
var $9a5a7141994058db$export$2e2bcd8739ae039 = $9a5a7141994058db$var$last;

});

parcelRegister("01zCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $004bb942477df3c5$export$2e2bcd8739ae039);

var $cOiwb = parcelRequire("cOiwb");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */ var $004bb942477df3c5$var$merge = /*#__PURE__*/ (0, $ggdJA.default)(function merge(l, r) {
    return (0, $cOiwb.default)({}, l, r);
});
var $004bb942477df3c5$export$2e2bcd8739ae039 = $004bb942477df3c5$var$merge;

});
parcelRegister("cOiwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $953884da05704938$export$2e2bcd8739ae039);

var $kWDdm = parcelRequire("kWDdm");
// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
function $953884da05704938$var$_objectAssign(target) {
    if (target == null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $kWDdm.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $953884da05704938$export$2e2bcd8739ae039 = typeof Object.assign === 'function' ? Object.assign : $953884da05704938$var$_objectAssign;

});


parcelRegister("3by2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $251ccf379c358936$export$2e2bcd8739ae039);

var $fpul1 = parcelRequire("fpul1");

var $fIpiC = parcelRequire("fIpiC");

var $kpKEz = parcelRequire("kpKEz");
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $251ccf379c358936$var$partition = /*#__PURE__*/ (0, $fIpiC.default)([
    (0, $fpul1.default),
    (0, $kpKEz.default)
]);
var $251ccf379c358936$export$2e2bcd8739ae039 = $251ccf379c358936$var$partition;

});
parcelRegister("fIpiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70e96fc6afb5209$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $3T9My = parcelRequire("3T9My");
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $b70e96fc6afb5209$var$juxt = /*#__PURE__*/ (0, $eSWTK.default)(function juxt(fns) {
    return (0, $3T9My.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $b70e96fc6afb5209$export$2e2bcd8739ae039 = $b70e96fc6afb5209$var$juxt;

});
parcelRegister("3T9My", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d4e18ad61febabd$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $3bCe9 = parcelRequire("3bCe9");

var $bwMm3 = parcelRequire("bwMm3");

var $kbCSE = parcelRequire("kbCSE");

var $lwVjM = parcelRequire("lwVjM");

var $ldYmX = parcelRequire("ldYmX");
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $2d4e18ad61febabd$var$converge = /*#__PURE__*/ (0, $ggdJA.default)(function converge(after, fns) {
    return (0, $bwMm3.default)((0, $ldYmX.default)((0, $kbCSE.default), 0, (0, $lwVjM.default)('length', fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $3bCe9.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $2d4e18ad61febabd$export$2e2bcd8739ae039 = $2d4e18ad61febabd$var$converge;

});
parcelRegister("lwVjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac90c531f16ccd1$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $cQGVO = parcelRequire("cQGVO");

var $f7Op5 = parcelRequire("f7Op5");
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $fac90c531f16ccd1$var$pluck = /*#__PURE__*/ (0, $ggdJA.default)(function pluck(p, list) {
    return (0, $cQGVO.default)((0, $f7Op5.default)(p), list);
});
var $fac90c531f16ccd1$export$2e2bcd8739ae039 = $fac90c531f16ccd1$var$pluck;

});




parcelRegister("l3byl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f532d6fa39e30682$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $f532d6fa39e30682$var$props = /*#__PURE__*/ (0, $ggdJA.default)(function props(ps, obj) {
    var len = ps.length;
    var out = [];
    var idx = 0;
    while(idx < len){
        out[idx] = obj[ps[idx]];
        idx += 1;
    }
    return out;
});
var $f532d6fa39e30682$export$2e2bcd8739ae039 = $f532d6fa39e30682$var$props;

});

parcelRegister("dRo9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a172f58b7a7238ec$export$2e2bcd8739ae039);

var $kVK4d = parcelRequire("kVK4d");

var $ldYmX = parcelRequire("ldYmX");
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $a172f58b7a7238ec$var$sum = /*#__PURE__*/ (0, $ldYmX.default)((0, $kVK4d.default), 0);
var $a172f58b7a7238ec$export$2e2bcd8739ae039 = $a172f58b7a7238ec$var$sum;

});
parcelRegister("kVK4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ccdd7be67b9545$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $f3ccdd7be67b9545$var$add = /*#__PURE__*/ (0, $ggdJA.default)(function add(a, b) {
    return Number(a) + Number(b);
});
var $f3ccdd7be67b9545$export$2e2bcd8739ae039 = $f3ccdd7be67b9545$var$add;

});


parcelRegister("1zKBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $125d35413c078594$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $125d35413c078594$var$times = /*#__PURE__*/ (0, $ggdJA.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError('n must be a non-negative number');
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $125d35413c078594$export$2e2bcd8739ae039 = $125d35413c078594$var$times;

});

parcelRegister("eCpJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa4891ce809edde7$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $kWDdm = parcelRequire("kWDdm");
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $aa4891ce809edde7$var$toPairs = /*#__PURE__*/ (0, $eSWTK.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $kWDdm.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $aa4891ce809edde7$export$2e2bcd8739ae039 = $aa4891ce809edde7$var$toPairs;

});

parcelRegister("UCNmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aa353000858f8f4$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $erwaN = parcelRequire("erwaN");
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $0aa353000858f8f4$var$values = /*#__PURE__*/ (0, $eSWTK.default)(function values(obj) {
    var props = (0, $erwaN.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $0aa353000858f8f4$export$2e2bcd8739ae039 = $0aa353000858f8f4$var$values;

});

parcelRegister("ib5d3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0d5c5dc40e9c5b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2d0d5c5dc40e9c5b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    add: {
        "id": "portfolio-3-portfolio.common.add",
        "defaultMessage": "Add"
    },
    after: {
        "id": "portfolio-3-portfolio.common.after",
        "defaultMessage": "after"
    },
    afterAllIssuesAreCompleted: {
        "id": "portfolio-3-portfolio.common.after-all-issues-are-completed",
        "defaultMessage": "After all issues are completed"
    },
    afterCapitalized: {
        "id": "portfolio-3-portfolio.common.after-capitalized",
        "defaultMessage": "After"
    },
    allOtherIssues: {
        "id": "portfolio-3-portfolio.common.all-other-issues",
        "defaultMessage": "All other issues"
    },
    apply: {
        "id": "portfolio-3-portfolio.common.apply",
        "defaultMessage": "Apply"
    },
    asEarlyAsPossible: {
        "id": "portfolio-3-portfolio.common.as-early-as-possible",
        "defaultMessage": "As early as possible"
    },
    assignee: {
        "id": "portfolio-3-portfolio.common.assignee",
        "defaultMessage": "Assignee"
    },
    reporter: {
        "id": "portfolio-3-portfolio.common.reporter",
        "defaultMessage": "Reporter"
    },
    before: {
        "id": "portfolio-3-portfolio.common.before",
        "defaultMessage": "before"
    },
    beforeCapitalized: {
        "id": "portfolio-3-portfolio.common.before-capitalized",
        "defaultMessage": "Before"
    },
    cancel: {
        "id": "portfolio-3-portfolio.common.cancel",
        "defaultMessage": "Cancel"
    },
    confirm: {
        "id": "portfolio-3-portfolio.common.confirm",
        "defaultMessage": "Confirm"
    },
    changeIndicatorTooltip: {
        "id": "portfolio-3-portfolio.common.change-indicator-tooltip",
        "defaultMessage": "To apply issue changes beyond your plan, review and save changes."
    },
    clearFilterText: {
        "id": "portfolio-3-portfolio.common.clear-filter-text",
        "defaultMessage": "Clear selected items"
    },
    close: {
        "id": "portfolio-3-portfolio.common.close",
        "defaultMessage": "Close"
    },
    component: {
        "id": "portfolio-3-portfolio.common.component",
        "defaultMessage": "Component"
    },
    chooseConfigurableDatesUnavailableHeading: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-heading",
        "defaultMessage": "Custom {count, plural,\n            one {date}\n            other {dates}\n          } no longer available"
    },
    chooseConfigurableDatesUnavailableContentStartDate: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-date",
        "defaultMessage": "<strong>{startDateTitle}</strong> is no longer available for scheduling issues. Use other custom start dates, or keep default start dates."
    },
    chooseConfigurableDatesUnavailableContentEndDate: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-end-date",
        "defaultMessage": "<strong>{endDateTitle}</strong> is no longer available for scheduling issues. Use other custom end dates, or keep default end dates."
    },
    chooseConfigurableDatesUnavailableContentStartAndEndDate: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-and-end-date",
        "defaultMessage": "<strong>{startDateTitle}</strong> and <strong>{endDateTitle}</strong> are no longer available for scheduling issues. Use other custom dates, or keep default dates."
    },
    chooseConfigurableDatesUnavailableContentStartDateTooltip: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-start-date-tooltip",
        "defaultMessage": "{startDateTitle} is no longer available for scheduling issues. Use other custom start dates, or keep default start dates."
    },
    chooseConfigurableDatesUnavailableContentEndDateTooltip: {
        "id": "portfolio-3-portfolio.common.choose-configurable-dates-unavailable-content-end-date-tooltip",
        "defaultMessage": "{endDateTitle} is no longer available for scheduling issues. Use other custom end dates, or keep default end dates."
    },
    chooseConfigurableDateNotExistContent: {
        "id": "portfolio-3-portfolio.common.choose-configurable-date-not-exist-content",
        "defaultMessage": "The previously used custom {count, plural,\n                one {date is}\n                other {dates are}\n              } no longer available for scheduling issues. Use other custom dates, or keep using default dates."
    },
    create: {
        "id": "portfolio-3-portfolio.common.create",
        "defaultMessage": "Create"
    },
    crossProjectRelease: {
        "id": "portfolio-3-portfolio.common.cross-project-release",
        "defaultMessage": "Cross-project release"
    },
    crossProjectReleases: {
        "id": "portfolio-3-portfolio.common.cross-project-releases",
        "defaultMessage": "Cross-project releases"
    },
    current: {
        "id": "portfolio-3-portfolio.common.current",
        "defaultMessage": "Current"
    },
    dates: {
        "id": "portfolio-3-portfolio.common.dates",
        "defaultMessage": "Dates"
    },
    dateRange: {
        "id": "portfolio-3-portfolio.common.date-range",
        "defaultMessage": "Date range"
    },
    days: {
        "id": "portfolio-3-portfolio.common.days",
        "defaultMessage": "Days"
    },
    delete: {
        "id": "portfolio-3-portfolio.common.delete",
        "defaultMessage": "Delete"
    },
    dueDate: {
        "id": "portfolio-3-portfolio.common.due-date",
        "defaultMessage": "Due date"
    },
    edit: {
        "id": "portfolio-3-portfolio.common.edit",
        "defaultMessage": "Edit"
    },
    epic: {
        "id": "portfolio-3-portfolio.common.epic",
        "defaultMessage": "Epic"
    },
    estimate: {
        "id": "portfolio-3-portfolio.common.estimate",
        "defaultMessage": "Estimate"
    },
    fixedDate: {
        "id": "portfolio-3-portfolio.common.fixed-date",
        "defaultMessage": "Fixed date"
    },
    goals: {
        "id": "portfolio-3-portfolio.common.goals",
        "defaultMessage": "Goals"
    },
    ideas: {
        "id": "portfolio-3-portfolio.common.ideas",
        "defaultMessage": "Ideas"
    },
    groupBy: {
        "id": "portfolio-3-portfolio.common.group-by",
        "defaultMessage": "Group by"
    },
    issueType: {
        "id": "portfolio-3-portfolio.common.issue-type",
        "defaultMessage": "Issue type"
    },
    issueLinkType: {
        "id": "portfolio-3-portfolio.common.issue-link-type",
        "defaultMessage": "Issue link type"
    },
    jira: {
        "id": "portfolio-3-portfolio.common.jira",
        "defaultMessage": "Jira"
    },
    label: {
        "id": "portfolio-3-portfolio.common.label",
        "defaultMessage": "Label"
    },
    learnMore: {
        "id": "portfolio-3-portfolio.common.learn-more",
        "defaultMessage": "Learn more"
    },
    loadingIssuesMessage: {
        "id": "portfolio-3-portfolio.common.loading-issues-message",
        "defaultMessage": "Loading issues..."
    },
    loading: {
        "id": "portfolio-3-portfolio.common.loading",
        "defaultMessage": "Loading"
    },
    name: {
        "id": "portfolio-3-portfolio.common.name",
        "defaultMessage": "Name"
    },
    new: {
        "id": "portfolio-3-portfolio.common.new",
        "defaultMessage": "New"
    },
    next: {
        "id": "portfolio-3-portfolio.common.next",
        "defaultMessage": "Next"
    },
    noMatchFoundText: {
        "id": "portfolio-3-portfolio.common.no-match-found-text",
        "defaultMessage": "No matches"
    },
    none: {
        "id": "portfolio-3-portfolio.common.none",
        "defaultMessage": "None"
    },
    notInPlan: {
        "id": "portfolio-3-portfolio.common.not-in-plan",
        "defaultMessage": "Not in plan"
    },
    plan: {
        "id": "portfolio-3-portfolio.common.plan",
        "defaultMessage": "Plan"
    },
    planNotFound: {
        "id": "portfolio-3-portfolio.common.plan-not-found",
        "defaultMessage": "We couldn\u2019t find that plan. It might have been deleted by its owner or the URL might be wrong."
    },
    priority: {
        "id": "portfolio-3-portfolio.common.priority",
        "defaultMessage": "Priority"
    },
    project: {
        "id": "portfolio-3-portfolio.common.project",
        "defaultMessage": "Project"
    },
    relativeToPreviousRelease: {
        "id": "portfolio-3-portfolio.common.relative-to-previous-release",
        "defaultMessage": "{factor} previous release date"
    },
    relativeToPreviousReleaseMethod: {
        "id": "portfolio-3-portfolio.common.relative-to-previous-release-method",
        "defaultMessage": "Relative to previous release date"
    },
    requiredField: {
        "id": "portfolio-3-portfolio.common.required-field",
        "defaultMessage": "A value must be provided"
    },
    release: {
        "id": "portfolio-3-portfolio.common.release",
        "defaultMessage": "Release"
    },
    releases: {
        "id": "portfolio-3-portfolio.common.releases",
        "defaultMessage": "Releases"
    },
    remove: {
        "id": "portfolio-3-portfolio.common.remove",
        "defaultMessage": "Remove"
    },
    save: {
        "id": "portfolio-3-portfolio.common.save",
        "defaultMessage": "Save"
    },
    done: {
        "id": "portfolio-3-portfolio.common.done",
        "defaultMessage": "Done"
    },
    sprint: {
        "id": "portfolio-3-portfolio.common.sprint",
        "defaultMessage": "Sprint"
    },
    sprints: {
        "id": "portfolio-3-portfolio.common.sprints",
        "defaultMessage": "Sprints"
    },
    status: {
        "id": "portfolio-3-portfolio.common.status",
        "defaultMessage": "Status"
    },
    statusBreakdown: {
        "id": "portfolio-3-portfolio.common.status-breakdown",
        "defaultMessage": "Progress (issue count)"
    },
    team: {
        "id": "portfolio-3-portfolio.common.team",
        "defaultMessage": "Team"
    },
    teams: {
        "id": "portfolio-3-portfolio.common.teams",
        "defaultMessage": "Teams"
    },
    unassigned: {
        "id": "portfolio-3-portfolio.common.unassigned",
        "defaultMessage": "Unassigned"
    },
    viewIn: {
        "id": "portfolio-3-portfolio.common.view-in",
        "defaultMessage": "View in"
    },
    weeks: {
        "id": "portfolio-3-portfolio.common.weeks",
        "defaultMessage": "Weeks"
    },
    whenPreviousReleaseEnds: {
        "id": "portfolio-3-portfolio.common.when-previous-release-ends",
        "defaultMessage": "When previous release ends"
    },
    targetStart: {
        "id": "portfolio-3-portfolio.common.target-start",
        "defaultMessage": "Target start"
    },
    targetEnd: {
        "id": "portfolio-3-portfolio.common.target-end",
        "defaultMessage": "Target end"
    },
    invalidDateStartBeforeEnd: {
        "id": "portfolio-3-portfolio.common.invalid-date-start-before-end",
        "defaultMessage": "The start date of the issue must be before its end date."
    },
    invalidDateEndAfterStart: {
        "id": "portfolio-3-portfolio.common.invalid-date-end-after-start",
        "defaultMessage": "The end date of the issue must be after its start date."
    },
    invalidDateTitle: {
        "id": "portfolio-3-portfolio.common.invalid-date-title",
        "defaultMessage": "That didn't work"
    },
    disabledSortByPriorityTooltip: {
        "id": "portfolio-3-portfolio.common.disabled-sort-by-priority-tooltip",
        "defaultMessage": "To sort issues by priority, the projects in the plan must be using the same priority scheme."
    },
    onTrackRelease: {
        "id": "portfolio-3-portfolio.common.on-track-release",
        "defaultMessage": "On-Track"
    },
    offTrackRelease: {
        "id": "portfolio-3-portfolio.common.off-track-release",
        "defaultMessage": "Off-Track"
    },
    releasedRelease: {
        "id": "portfolio-3-portfolio.common.released-release",
        "defaultMessage": "Released"
    },
    unReleasedRelease: {
        "id": "portfolio-3-portfolio.common.un-released-release",
        "defaultMessage": "Unreleased"
    },
    dependency: {
        "id": "portfolio-3-portfolio.common.dependency",
        "defaultMessage": "Dependency"
    },
    dependencyWarning: {
        "id": "portfolio-3-portfolio.common.dependency-warning",
        "defaultMessage": "Dependency warning"
    },
    unsavedChanges: {
        "id": "portfolio-3-portfolio.common.unsaved-changes",
        "defaultMessage": "Unsaved changes"
    },
    externalLozenge: {
        "id": "portfolio-3-portfolio.common.external-lozenge",
        "defaultMessage": "EXT"
    },
    datesOutsideRange: {
        "id": "portfolio-3-portfolio.common.dates-outside-range",
        "defaultMessage": "Dates outside current view range"
    },
    teamSettings: {
        "id": "portfolio-3-portfolio.common.team-settings",
        "defaultMessage": "Team settings"
    },
    scope: {
        "id": "portfolio-3-portfolio.common.scope",
        "defaultMessage": "Scope"
    },
    fields: {
        "id": "portfolio-3-portfolio.common.fields",
        "defaultMessage": "Fields"
    },
    timeline: {
        "id": "portfolio-3-portfolio.common.timeline",
        "defaultMessage": "Timeline"
    },
    issueSource: {
        "id": "portfolio-3-portfolio.common.issue-source",
        "defaultMessage": "Issue source"
    },
    customFields: {
        "id": "portfolio-3-portfolio.common.custom-fields",
        "defaultMessage": "Custom fields"
    },
    more: {
        "id": "portfolio-3-portfolio.common.more",
        "defaultMessage": "+ {count} more"
    },
    noAssociatedTeams: {
        "id": "portfolio-3-portfolio.common.no-associated-teams",
        "defaultMessage": "No associated teams"
    },
    otherSprints: {
        "id": "portfolio-3-portfolio.common.other-sprints",
        "defaultMessage": "Other sprints"
    },
    futureProjectedSprint: {
        "id": "portfolio-3-portfolio.common.future-projected-sprint",
        "defaultMessage": "Projected sprint"
    },
    futureSprint: {
        "id": "portfolio-3-portfolio.common.future-sprint",
        "defaultMessage": "Future sprint"
    },
    completedSprint: {
        "id": "portfolio-3-portfolio.common.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    activeSprint: {
        "id": "portfolio-3-portfolio.common.active-sprint",
        "defaultMessage": "Active sprint"
    },
    futureSprintState: {
        "id": "portfolio-3-portfolio.common.future-sprint-state",
        "defaultMessage": "Future"
    },
    completedSprintState: {
        "id": "portfolio-3-portfolio.common.completed-sprint-state",
        "defaultMessage": "Completed"
    },
    activeSprintState: {
        "id": "portfolio-3-portfolio.common.active-sprint-state",
        "defaultMessage": "Active"
    },
    externalSprintState: {
        "id": "portfolio-3-portfolio.common.external-sprint-state",
        "defaultMessage": "external"
    },
    completedSprintsLabel: {
        "id": "portfolio-3-portfolio.common.completed-sprints-label",
        "defaultMessage": "All completed sprints"
    },
    activeSprintsLabel: {
        "id": "portfolio-3-portfolio.common.active-sprints-label",
        "defaultMessage": "All active sprints"
    },
    futureSprintsLabel: {
        "id": "portfolio-3-portfolio.common.future-sprints-label",
        "defaultMessage": "All future sprints"
    },
    externalSprintsLabel: {
        "id": "portfolio-3-portfolio.common.external-sprints-label",
        "defaultMessage": "All external sprints"
    },
    noSprintLabel: {
        "id": "portfolio-3-portfolio.common.no-sprint-label",
        "defaultMessage": "No sprint assigned"
    }
});

});



parcelRegister("wcCGG", function(module, exports) {

$parcel$export(module.exports, "getVersions", () => $2a856b74b002eeef$export$cbd9528a83fbffa1);
$parcel$export(module.exports, "getVersionsById", () => $2a856b74b002eeef$export$6276b9eb21b360da);
$parcel$export(module.exports, "getRemovedVersions", () => $2a856b74b002eeef$export$c13a2a631377464a);
$parcel$export(module.exports, "getRemovedVersionsById", () => $2a856b74b002eeef$export$2c2ed1c3fa0848e9);
$parcel$export(module.exports, "getReleaseStatusesById", () => $2a856b74b002eeef$export$d7ec23def82b181e);
$parcel$export(module.exports, "getSortByHighestRank", () => $2a856b74b002eeef$export$3e8f3b624e136113);
$parcel$export(module.exports, "getSortByLowestRank", () => $2a856b74b002eeef$export$fde25415e63b943f);
$parcel$export(module.exports, "getVersionWithHighestRankInProject", () => $2a856b74b002eeef$export$701ca456028faee4);
$parcel$export(module.exports, "getOriginalVersions", () => $2a856b74b002eeef$export$6fb02f212999533e);
$parcel$export(module.exports, "getCommitWarningsForVersions", () => $2a856b74b002eeef$export$293e3ececda5ef14);
$parcel$export(module.exports, "getEnrichedVersions", () => $2a856b74b002eeef$export$768e48b2c317ec1);
$parcel$export(module.exports, "getSolutionVersionsById", () => $2a856b74b002eeef$export$7c50d111c2b02c6f);
$parcel$export(module.exports, "getVersionChangeCount", () => $2a856b74b002eeef$export$d97dab6022ceb421);
$parcel$export(module.exports, "getVersionChanges", () => $2a856b74b002eeef$export$17954408be2c7691);
$parcel$export(module.exports, "getReleasesTableRankingStatus", () => $2a856b74b002eeef$export$92d3fa6211fa94a4);
$parcel$export(module.exports, "getEnrichedVersionsById", () => $2a856b74b002eeef$export$264ae8bd37fe59e6);
$parcel$export(module.exports, "getProjectIdsByCrossProjectVersionsMap", () => $2a856b74b002eeef$export$2e0a86e15fc298ce);
$parcel$export(module.exports, "getCompletedVersionsById", () => $2a856b74b002eeef$export$df487cb7cbf7a3ba);
$parcel$export(module.exports, "getStartDateMethod", () => (parcelRequire("aKueD")).getStartDateMethod);
$parcel$export(module.exports, "getEndDateMethod", () => (parcelRequire("aKueD")).getEndDateMethod);
$parcel$export(module.exports, "DATE_METHODS", () => (parcelRequire("lNU8O")).DATE_METHODS);

var $8K6YM = parcelRequire("8K6YM");
var $fpul1 = parcelRequire("fpul1");
var $eirae = parcelRequire("eirae");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $ldYmX = parcelRequire("ldYmX");
var $659jj = parcelRequire("659jj");
var $8aqkF = parcelRequire("8aqkF");

var $czhUP = parcelRequire("czhUP");

var $ehEr2 = parcelRequire("ehEr2");

var $kCccV = parcelRequire("kCccV");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $aKueD = parcelRequire("aKueD");

var $lNU8O = parcelRequire("lNU8O");
const $2a856b74b002eeef$export$cbd9528a83fbffa1 = (state)=>state.domain.versions;
const $2a856b74b002eeef$export$6276b9eb21b360da = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1
], (versions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), versions));
const $2a856b74b002eeef$export$c13a2a631377464a = (state)=>state.domain.removedVersions;
const $2a856b74b002eeef$export$2c2ed1c3fa0848e9 = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$c13a2a631377464a
], (versions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), versions));
const $2a856b74b002eeef$export$e91aef70d413a5eb = (state)=>state.domain.releaseStatuses;
const $2a856b74b002eeef$export$d7ec23def82b181e = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$e91aef70d413a5eb
], (releaseStatuses)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), releaseStatuses));
const $2a856b74b002eeef$export$7ece973307d52dd2 = (lexoRankAdjustments)=>(versions)=>$659jj.default([
            (0, $7CnHa.descend)(({ lexoRank: lexoRank })=>lexoRank || ''),
            (0, $7CnHa.descend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
        ])(versions);
const $2a856b74b002eeef$export$3e8f3b624e136113 = (0, $iK4oF.createSelector)([
    (0, $czhUP.getVersionLexoRankAdjustments)
], $2a856b74b002eeef$export$7ece973307d52dd2);
const $2a856b74b002eeef$export$f035ce36fd097cb6 = (lexoRankAdjustments)=>(versions)=>$659jj.default([
            (0, $7CnHa.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
            (0, $7CnHa.ascend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
        ])(versions);
const $2a856b74b002eeef$export$fde25415e63b943f = (0, $iK4oF.createSelector)([
    (0, $czhUP.getVersionLexoRankAdjustments)
], $2a856b74b002eeef$export$f035ce36fd097cb6);
const $2a856b74b002eeef$export$4c4992f425d2e683 = (versions, sortVersionsByHighestRank)=>{
    if (versions.length === 0) return;
    if (versions.length === 1) return versions[0];
    const sortedVersions = sortVersionsByHighestRank(versions);
    return sortedVersions[0];
};
const $2a856b74b002eeef$export$e32aae4224e2cdad = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1,
    $2a856b74b002eeef$export$3e8f3b624e136113
], $2a856b74b002eeef$export$4c4992f425d2e683);
const $2a856b74b002eeef$export$701ca456028faee4 = (state, projectId)=>{
    const versions = $2a856b74b002eeef$export$cbd9528a83fbffa1(state);
    const versionsInProject = versions.filter((version)=>version.projects.includes(projectId));
    return $2a856b74b002eeef$export$4c4992f425d2e683(versionsInProject, $2a856b74b002eeef$export$3e8f3b624e136113(state));
};
const $2a856b74b002eeef$export$6fb02f212999533e = (state)=>state.domain.originalVersions;
const $2a856b74b002eeef$export$293e3ececda5ef14 = (state)=>state.domain.updateJira.warnings[(0, $5rYNM.ENTITY).RELEASE];
const $2a856b74b002eeef$export$f3cd71750a928238 = (versions, projects)=>{
    const projectsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), projects);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return versions.map(({ projects: projects, ...rest })=>({
            ...rest,
            projects: projects.map((id)=>projectsByIdMap[id])
        }));
};
const $2a856b74b002eeef$export$768e48b2c317ec1 = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1,
    (0, $ehEr2.getProjects)
], $2a856b74b002eeef$export$f3cd71750a928238);
const $2a856b74b002eeef$export$f4a2370bd2a02a4c = (solution)=>{
    if (!(0, $7CnHa.isDefined)(solution)) return [];
    const solutionProjects = (0, $7CnHa.values)(solution.projects);
    return solutionProjects.flatMap(({ versions: versions })=>versions);
};
const $2a856b74b002eeef$export$4f1c1f3ec6b290e5 = (0, $iK4oF.createSelector)([
    (0, $kCccV.getSolution)
], $2a856b74b002eeef$export$f4a2370bd2a02a4c);
const $2a856b74b002eeef$export$7c50d111c2b02c6f = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$4f1c1f3ec6b290e5
], (solutionVersions)=>(0, $7CnHa.indexBy)($f7Op5.default('key'), solutionVersions));
const $2a856b74b002eeef$export$d97dab6022ceb421 = ({ domain: { originalVersions: originalVersions } })=>Object.keys(originalVersions).length;
const $2a856b74b002eeef$export$9d001e5246befab = ({ domain: { updateJira: updateJira } })=>{
    if (updateJira && updateJira.changes && updateJira.changes.data) return updateJira.changes.data.metaData.versions;
    return {};
};
const $2a856b74b002eeef$export$b1e188784551697f = (versions, removedVersions, originalVersions, versionChangesMetadata, warnings, projectsById)=>{
    const enrichedVersions = [
        ...versions,
        ...removedVersions
    ].map(({ projects: projects, ...rest })=>({
            ...rest,
            projects: projects.map((id)=>projectsById[id])
        }));
    const versionsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), enrichedVersions);
    const changes = Object.keys(versionChangesMetadata).filter((versionId)=>(0, $7CnHa.isDefined)(versionsByIdMap[versionId])).filter((versionId)=>(0, $7CnHa.isDefined)(originalVersions[versionId])).map((versionId)=>{
        const version = versionsByIdMap[versionId];
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { id: id, projects: projects, ...values } = version;
        const originalValues = originalVersions[versionId];
        const metaData = versionChangesMetadata[versionId];
        const { scenarioType: scenarioType } = metaData;
        const changedAttributes = (0, $aKueD.getChangedAttributes)(values, originalValues, scenarioType);
        return {
            id: id,
            category: (0, $5rYNM.ENTITY).RELEASE,
            metaData: metaData,
            changeCount: changedAttributes.length,
            warnings: warnings[versionId] || [],
            attributeName: (0, $aKueD.getChangedAttributeName)(changedAttributes, scenarioType),
            details: {
                id: id,
                projects: projects,
                values: {
                    ...values
                },
                originals: {
                    ...originalValues
                }
            }
        };
    });
    // @ts-expect-error TS2322 - Type '(number | Readonly<{ id: number; key: string; name: string; avatarUrl: string; versions: string[]; components?: Component[] | undefined; issueTypeIds: number[]; isDefault?: boolean | undefined; ... 4 more ...; projectTypeKey: "software" | ... 1 more ... | "service_desk"; }>)[]' is not assignable to type 'number[] & Readonly<{ id: number; key: string; name: string; avatarUrl: string; versions: string[]; components?: Component[] | undefined; issueTypeIds: number[]; isDefault?: boolean | undefined; ... 4 more ...; projectTypeKey: "software" | ... 1 more ... | "service_desk"; }>[]'.
    return changes;
};
const $2a856b74b002eeef$export$17954408be2c7691 = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1,
    $2a856b74b002eeef$export$c13a2a631377464a,
    $2a856b74b002eeef$export$6fb02f212999533e,
    $2a856b74b002eeef$export$9d001e5246befab,
    $2a856b74b002eeef$export$293e3ececda5ef14,
    (0, $ehEr2.getProjectsById)
], $2a856b74b002eeef$export$b1e188784551697f);
const $2a856b74b002eeef$export$92d3fa6211fa94a4 = (state)=>state.ui.Main.Tabs.Releases.ProjectReleases.ReleasesTable.isRanking;
const $2a856b74b002eeef$export$264ae8bd37fe59e6 = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$768e48b2c317ec1
], (versions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), versions));
const $2a856b74b002eeef$export$c34bf9b5248be50b = (versions)=>$3IGDG.default($eirae.default((version)=>version.crossProjectVersion || 'omit'), $8K6YM.default('omit'), (versionsByCPV)=>Object.keys(versionsByCPV).reduce((projectIdsByCPR, cprId)=>{
            const versionsWithCPV = versionsByCPV[cprId];
            const projects = $ldYmX.default(// eslint-disable-next-line @typescript-eslint/no-shadow
            (projects, v)=>$8aqkF.default(projects, v.projects), [])(versionsWithCPV);
            return Object.assign(projectIdsByCPR, {
                [cprId]: projects
            });
        }, {}))(versions);
const $2a856b74b002eeef$export$2e0a86e15fc298ce = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1
], $2a856b74b002eeef$export$c34bf9b5248be50b);
const $2a856b74b002eeef$var$getCompletedVersionsPure = (versions)=>$fpul1.default((version)=>version.releaseStatusId === (0, $5rYNM.RELEASE_STATUSES).RELEASED, versions);
const $2a856b74b002eeef$var$getCompletedVersions = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$export$cbd9528a83fbffa1
], $2a856b74b002eeef$var$getCompletedVersionsPure);
const $2a856b74b002eeef$export$df487cb7cbf7a3ba = (0, $iK4oF.createSelector)([
    $2a856b74b002eeef$var$getCompletedVersions
], (completedVersion)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), completedVersion));

});
parcelRegister("8K6YM", function(module, exports) {

$parcel$export(module.exports, "default", () => $65d8088dee892965$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $65d8088dee892965$var$dissoc = /*#__PURE__*/ (0, $ggdJA.default)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
var $65d8088dee892965$export$2e2bcd8739ae039 = $65d8088dee892965$var$dissoc;

});

parcelRegister("659jj", function(module, exports) {

$parcel$export(module.exports, "default", () => $46da6e8e44d2485b$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $46da6e8e44d2485b$var$sortWith = /*#__PURE__*/ (0, $ggdJA.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $46da6e8e44d2485b$export$2e2bcd8739ae039 = $46da6e8e44d2485b$var$sortWith;

});

parcelRegister("8aqkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f23aeefe706dcc8$export$2e2bcd8739ae039);

var $kJFRt = parcelRequire("kJFRt");

var $ggdJA = parcelRequire("ggdJA");

var $hkOxK = parcelRequire("hkOxK");

var $1uCJR = parcelRequire("1uCJR");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $5f23aeefe706dcc8$var$union = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $hkOxK.default)((0, $1uCJR.default), (0, $kJFRt.default)));
var $5f23aeefe706dcc8$export$2e2bcd8739ae039 = $5f23aeefe706dcc8$var$union;

});
parcelRegister("kJFRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1887b6ae7f15250$export$2e2bcd8739ae039);
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $f1887b6ae7f15250$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("1uCJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1166a47d1eb84495$export$2e2bcd8739ae039);

var $l0L3x = parcelRequire("l0L3x");

var $egiDP = parcelRequire("egiDP");
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $1166a47d1eb84495$var$uniq = /*#__PURE__*/ (0, $egiDP.default)((0, $l0L3x.default));
var $1166a47d1eb84495$export$2e2bcd8739ae039 = $1166a47d1eb84495$var$uniq;

});
parcelRegister("egiDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6210516a263f730$export$2e2bcd8739ae039);

var $0fFBQ = parcelRequire("0fFBQ");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $a6210516a263f730$var$uniqBy = /*#__PURE__*/ (0, $ggdJA.default)(function uniqBy(fn, list) {
    var set = new (0, $0fFBQ.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
var $a6210516a263f730$export$2e2bcd8739ae039 = $a6210516a263f730$var$uniqBy;

});



parcelRegister("czhUP", function(module, exports) {

$parcel$export(module.exports, "getIssueLexoRankAdjustments", () => $67f304052a88b593$export$263b62c0d6fc0959);
$parcel$export(module.exports, "getVersionLexoRankAdjustments", () => $67f304052a88b593$export$edd7701f656ba11f);
const $67f304052a88b593$export$263b62c0d6fc0959 = (state)=>state.domain.lexorank.issueAdjustments;
const $67f304052a88b593$export$edd7701f656ba11f = (state)=>state.domain.lexorank.versionAdjustments;

});

parcelRegister("aKueD", function(module, exports) {

$parcel$export(module.exports, "getMillisecondsDateReference", () => $56cd60db0dba937b$export$b40a93d7ad7a9349);
$parcel$export(module.exports, "getStartDateMethod", () => $56cd60db0dba937b$export$37dd434ed790acdc);
$parcel$export(module.exports, "getEndDateMethod", () => $56cd60db0dba937b$export$bd9c4c37a91873f3);
$parcel$export(module.exports, "getChangedAttributes", () => $56cd60db0dba937b$export$3c13bed81ee9bbc8);
$parcel$export(module.exports, "getChangedAttributeName", () => $56cd60db0dba937b$export$8372f47f7c4a2a9);
$parcel$export(module.exports, "getTargetDatesFromReleases", () => $56cd60db0dba937b$export$ec4d0087f9018a86);

var $b3iuB = parcelRequire("b3iuB");
parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lNU8O = parcelRequire("lNU8O");
const $56cd60db0dba937b$var$getDateReferenceFromMilliseconds = (delta)=>{
    const days = delta / (0, $17L5s.ONE_DAY);
    const direction = delta > 0 ? (0, $5rYNM.DIRECTIONS).AFTER : (0, $5rYNM.DIRECTIONS).BEFORE;
    const canBeDisplayedAsWeeks = days % 7 === 0;
    return canBeDisplayedAsWeeks ? {
        quantity: Math.abs(days) / 7,
        unit: (0, $eTbtL.DateUnits).WEEKS,
        direction: direction
    } : {
        quantity: Math.abs(days),
        unit: (0, $eTbtL.DateUnits).DAYS,
        direction: direction
    };
};
const $56cd60db0dba937b$export$b40a93d7ad7a9349 = ({ quantity: quantity, unit: unit, direction: direction })=>{
    const milliseconds = unit === (0, $eTbtL.DateUnits).DAYS ? quantity * (0, $17L5s.ONE_DAY) : quantity * (0, $17L5s.ONE_WEEK);
    return direction === (0, $5rYNM.DIRECTIONS).AFTER ? milliseconds : -1 * milliseconds;
};
const $56cd60db0dba937b$export$37dd434ed790acdc = (start, delta)=>{
    if (!(0, $7CnHa.isDefined)(start) && !(0, $7CnHa.isDefined)(delta)) return {
        method: (0, $lNU8O.DATE_METHODS).AS_EARLY_AS_POSSIBLE
    };
    if ((0, $7CnHa.isDefined)(start)) return {
        method: (0, $lNU8O.DATE_METHODS).FIXED_DATE
    };
    let dateReference;
    if ((0, $7CnHa.isDefined)(delta)) dateReference = $56cd60db0dba937b$var$getDateReferenceFromMilliseconds(delta);
    return {
        method: (0, $lNU8O.DATE_METHODS).RELATIVE_TO_PREVIOUS_RELEASE,
        ...dateReference
    };
};
const $56cd60db0dba937b$export$bd9c4c37a91873f3 = (end)=>{
    if ((0, $7CnHa.isDefined)(end)) return {
        method: (0, $lNU8O.DATE_METHODS).FIXED_DATE
    };
    return {
        method: (0, $lNU8O.DATE_METHODS).AFTER_ALL_ISSUES_ARE_COMPLETED
    };
};
const $56cd60db0dba937b$export$3c13bed81ee9bbc8 = (values, originals, scenarioType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const originalKeys = Object.keys(originals);
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
        const { delta: delta, lexoRank: lexoRank, releaseStatusId: releaseStatusId, ...rest } = values;
        if (!(0, $7CnHa.isDefined)(values.description)) delete rest.description;
        if (!(0, $7CnHa.isDefined)(values.crossProjectVersion)) delete rest.crossProjectVersion;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.keys(rest);
    }
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED) return [];
    if (originalKeys.includes('delta')) return originalKeys.includes('start') ? originalKeys.filter((key)=>key !== 'delta') : originalKeys.map((key)=>key === 'delta' ? 'start' : key);
    return originalKeys;
};
const $56cd60db0dba937b$export$8372f47f7c4a2a9 = (changedAttributes, scenarioType)=>{
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || changedAttributes.length !== 1) return;
    const attributeName = changedAttributes[0];
    return attributeName;
};
const $56cd60db0dba937b$export$ec4d0087f9018a86 = (issue, releases)=>{
    if ($b3iuB.default(issue.fixVersions) || !(0, $7CnHa.isDefined)(issue.fixVersions)) return null;
    // JPO-22372 - Inherit start and end dates from multiple releases
    // if the issue has multiple releases, we're looking for the lowest start date and the lowest end date of all its releases
    if (issue.fixVersions.length > 1) {
        const { startDate: startDate, endDate: endDate } = issue.fixVersions.reduce((acc, fixVersion)=>{
            const fixVersionStartDate = releases[fixVersion]?.start;
            if (fixVersionStartDate) acc.startDate = Math.min(acc.startDate, fixVersionStartDate);
            else acc.startDate = -Infinity;
            const fixVersionEndDate = releases[fixVersion]?.end;
            if (fixVersionEndDate) acc.endDate = Math.min(acc.endDate, fixVersionEndDate);
            return acc;
        }, {
            startDate: Infinity,
            endDate: Infinity
        });
        return {
            startDate: Number.isFinite(startDate) ? startDate : null,
            endDate: Number.isFinite(endDate) ? endDate : null
        };
    }
    const fixVersion = issue.fixVersions[0];
    const startDate = releases[fixVersion]?.start;
    const endDate = releases[fixVersion]?.end;
    return {
        startDate: startDate,
        endDate: endDate
    };
};

});
parcelRegister("lNU8O", function(module, exports) {

$parcel$export(module.exports, "DATE_METHODS", () => $2affa32f12c4adf9$export$850c860d7b37834e);
const $2affa32f12c4adf9$export$850c860d7b37834e = {
    LEAVE_AS_IS: 'leaveAsIs',
    AS_EARLY_AS_POSSIBLE: 'asEarlyAsPossible',
    RELATIVE_TO_PREVIOUS_RELEASE: 'relativeToPreviousRelease',
    FIXED_DATE: 'fixedDate',
    AFTER_ALL_ISSUES_ARE_COMPLETED: 'afterAllIssuesAreCompleted'
};

});



parcelRegister("dJx9o", function(module, exports) {

$parcel$export(module.exports, "getGroupKey", () => $2d00b9f14fbc82b7$export$54ec6941e5eeb2d3);
$parcel$export(module.exports, "getIssuesHierarchy", () => $2d00b9f14fbc82b7$export$5a0621fb8f463d9);
$parcel$export(module.exports, "getOptimizedFixVersion", () => $2d00b9f14fbc82b7$export$6133bf612955a1ac);
$parcel$export(module.exports, "getOptimizedSprint", () => $2d00b9f14fbc82b7$export$e860cd1899972684);
$parcel$export(module.exports, "addIssueToGroup", () => $2d00b9f14fbc82b7$export$74ebd6ddbf709589);
$parcel$export(module.exports, "getTeamsBySprintGroups", () => $2d00b9f14fbc82b7$export$4e7e6196f09f0c44);
$parcel$export(module.exports, "getReleasesGroups", () => $2d00b9f14fbc82b7$export$49a0d7a2330233a9);

var $i0RGP = parcelRequire("i0RGP");
var $jPCDz = parcelRequire("jPCDz");
var $kDrtX = parcelRequire("kDrtX");
var $01zCq = parcelRequire("01zCq");
var $kjklK = parcelRequire("kjklK");
var $h3f0m = parcelRequire("h3f0m");

var $8YqJS = parcelRequire("8YqJS");

var $dYnI4 = parcelRequire("dYnI4");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $2d00b9f14fbc82b7$export$dcda7e10772ff7e8 = (0, $5rYNM.UNDEFINED_KEY);
const $2d00b9f14fbc82b7$export$54ec6941e5eeb2d3 = (groupCombination)=>(0, $7CnHa.filterMap)((grouping)=>(0, $7CnHa.isDefined)(grouping[1]), ([attr, group])=>`${attr}-${String(group)}`, // Sort the array of entries to maintain the specific order
    Object.entries(groupCombination).sort(([attr1], [attr2])=>attr1.localeCompare(attr2))).join('-') || $2d00b9f14fbc82b7$export$dcda7e10772ff7e8;
const $2d00b9f14fbc82b7$export$82269f08f5e108b8 = ({ depth: depth = 0, hierarchyIssueIds: hierarchyIssueIds = [], issues: issues, issuesByParent: issuesByParent, isExpanded: isExpanded, issuesInGroupMap: issuesInGroupMap, rootIndex: parentRootIndex, group: group = '', groupCombination: groupCombination, ignoreExpandingState: ignoreExpandingState = false, parentsExpanded: parentsExpanded = true })=>{
    const result = [];
    for(let index = 0; index < issues.length; index++){
        const issue = issues[index];
        const { id: id } = issue;
        let children = issuesByParent[id];
        const rootIndex = $kDrtX.default(parentRootIndex) ? index : parentRootIndex;
        const idSuffix = groupCombination ? `:${$2d00b9f14fbc82b7$export$54ec6941e5eeb2d3(groupCombination)}` : '';
        const expandId = `${id}${idSuffix}`;
        if (children) {
            // prevent infinite loop
            if ((0, $7CnHa.isDefined)(issuesInGroupMap)) children = children.filter((child)=>!!issuesInGroupMap[child.id] && !hierarchyIssueIds.includes(child.id));
            else children = children.filter((child)=>!hierarchyIssueIds.includes(child.id));
        }
        const isIssueExpanded = isExpanded && !!isExpanded[expandId];
        const processChildren = ignoreExpandingState || isIssueExpanded;
        // R.merge is faster than Babel's object spread polyfill
        // which becomes noticeable on large plans because this merge is a hot spot
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Grouping | undefined'.
        const scopeIssue = $01zCq.default(issue, {
            depth: depth,
            isExpanded: isIssueExpanded,
            isExpandable: !!children && children.length > 0,
            rootIndex: rootIndex,
            group: group,
            parentsExpanded: parentsExpanded
        });
        result.push(scopeIssue);
        hierarchyIssueIds.push(scopeIssue.id);
        if (processChildren && children) Array.prototype.push.apply(result, $2d00b9f14fbc82b7$export$82269f08f5e108b8({
            depth: depth + 1,
            issues: children,
            issuesByParent: issuesByParent,
            isExpanded: isExpanded,
            issuesInGroupMap: issuesInGroupMap,
            rootIndex: rootIndex,
            group: // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Grouping | undefined'.
            group,
            hierarchyIssueIds: hierarchyIssueIds,
            groupCombination: groupCombination,
            ignoreExpandingState: ignoreExpandingState,
            parentsExpanded: parentsExpanded && isIssueExpanded
        }));
    }
    return result;
};
const $2d00b9f14fbc82b7$export$5a0621fb8f463d9 = (0, $dYnI4.monitor).timeFunction($2d00b9f14fbc82b7$export$82269f08f5e108b8, 'query_scope_util_getIssuesHierarchy');
const $2d00b9f14fbc82b7$export$6133bf612955a1ac = (issue, solution)=>{
    const { assignments: assignments } = issue;
    if (issue.fixVersions && issue.fixVersions.length && !$kjklK.default([
        'calculationConfiguration',
        'ignoreReleases'
    ], solution)) return issue.fixVersions;
    if (assignments.length === 0) return issue.fixVersions;
    const { projects: projects } = solution;
    const projectVersions = projects[Number(issue.project)] && projects[Number(issue.project)].versions || [];
    const endedAtForVersion = (version)=>{
        const projectVersion = $i0RGP.default($h3f0m.default('key', version))(projectVersions);
        if (!(0, $7CnHa.isDefined)(projectVersion)) return undefined;
        if ((0, $7CnHa.isDefined)(projectVersion.fixedEnd)) return projectVersion.fixedEnd;
        return projectVersion.end;
    };
    const { laterVersions: laterVersions, latestVersion: latestVersion } = assignments.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
    ({ laterVersions: laterVersions, latestVersion: latestVersion }, { version: version })=>{
        if ((0, $7CnHa.isDefined)(version)) {
            if (version.endsWith('-later')) laterVersions.push(version);
            else {
                const endedAt = endedAtForVersion(version);
                if ((0, $7CnHa.isDefined)(endedAt) && endedAt > latestVersion.endedAt) return {
                    laterVersions: laterVersions,
                    latestVersion: {
                        version: version,
                        endedAt: endedAt
                    }
                };
                if (latestVersion.endedAt === 0) return {
                    laterVersions: laterVersions,
                    latestVersion: {
                        version: version,
                        endedAt: 0
                    }
                };
            }
        }
        return {
            laterVersions: laterVersions,
            latestVersion: latestVersion
        };
    }, {
        laterVersions: [],
        latestVersion: {
            version: undefined,
            endedAt: 0
        }
    });
    if (laterVersions.length === 0 && (0, $7CnHa.isDefined)(latestVersion.version)) return [
        latestVersion.version
    ];
};
const $2d00b9f14fbc82b7$export$e860cd1899972684 = (issue, solution)=>{
    const { teams: teams } = solution;
    const { assignments: assignments } = issue;
    if (assignments.length === 0 || issue.level >= (0, $8YqJS.EPIC_LEVEL) || // If there is one assignment with interval value present but the team value is not presented then we should use the original value.
    assignments.length === 1 && !(0, $7CnHa.isDefined)(assignments[0].team) && (0, $7CnHa.isDefined)(assignments[0].interval)) return issue.sprint;
    const { sprintId: sprintId } = assignments.reduce((earliestSprint, { interval: interval, team: team })=>{
        if ((0, $7CnHa.isDefined)(team) && (0, $7CnHa.isDefined)(interval)) {
            const sprint = $kjklK.default([
                team,
                'intervals',
                interval
            ], teams);
            if ((0, $7CnHa.isDefined)(sprint) && (!(0, $7CnHa.isDefined)(earliestSprint.start) || sprint.start < earliestSprint.start)) return sprint;
        }
        return earliestSprint;
    }, {
        start: undefined,
        sprintId: undefined
    });
    if (solution.calculationConfiguration && !solution.calculationConfiguration.ignoreSprints && !(0, $7CnHa.isDefined)(sprintId)) return issue.sprint;
    return sprintId;
};
const $2d00b9f14fbc82b7$export$74ebd6ddbf709589 = (issuesByGroup, issue, issueGroup)=>{
    const { issues: issues, parentGroup: parentGroup, ...group } = issueGroup;
    const groupKey = $2d00b9f14fbc82b7$export$54ec6941e5eeb2d3(group);
    const grouping = issuesByGroup[groupKey];
    if (grouping && grouping.issues) grouping.issues.add(issue);
    else {
        const newGroup = {
            ...group,
            issues: new Set([
                issue
            ]),
            ...(0, $7CnHa.isDefined)(parentGroup) ? {
                parentGroup: parentGroup
            } : {}
        };
        // eslint-disable-next-line no-param-reassign
        issuesByGroup[groupKey] = newGroup;
    }
};
const $2d00b9f14fbc82b7$export$4e7e6196f09f0c44 = (issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById)=>{
    const groups = [];
    const issueSprint = isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized) && issue.optimized.sprint || issue.sprint || null;
    const issueTeam = isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized) && issue.optimized.team || issue.team || null;
    if (issue.completedSprints && issue.completedSprints.length > 0) issue.completedSprints.forEach((completedSprintId)=>{
        if ($jPCDz.default(completedSprintId, sprintsByIdMap)) groups.push({
            sprint: completedSprintId,
            parentGroup: (0, $5rYNM.COMPLETED_SPRINTS_GROUP)
        });
    });
    if (issue.completedSprints && issue.completedSprints.includes(issueSprint)) ;
    else if (issueSprint && $jPCDz.default(issueSprint, sprintsByIdMap)) // sprint is in a plan
    groups.push({
        sprint: issueSprint
    });
    else if (!issue.completedSprints || !issue.completedSprints.length) // add it to unassigned group
    groups.push({
        sprint: null
    });
    groups.forEach((group)=>{
        const sprintWithTeam = group.sprint && issueTeam && sprintsForTeam && sprintsForTeam[issueTeam] && sprintsForTeam[issueTeam].find((sprint)=>sprint.id === group.sprint);
        const isKanbanTeam = issueTeam && teamsById && teamsById[issueTeam] && teamsById[issueTeam].schedulingMode === 'Kanban';
        if (sprintWithTeam && !isKanbanTeam) // eslint-disable-next-line no-param-reassign
        group.team = issueTeam;
    });
    return groups;
};
const $2d00b9f14fbc82b7$export$49a0d7a2330233a9 = (issue, isOptimizedMode, versionsById)=>{
    const groups = [];
    let issueFixVersions;
    if (isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized) && $jPCDz.default('fixVersions', issue.optimized)) issueFixVersions = issue.optimized.fixVersions;
    else issueFixVersions = issue.fixVersions;
    // No release assigned
    if (!issueFixVersions || issueFixVersions.length === 0) return [
        {
            release: null
        }
    ];
    issueFixVersions.forEach((fixVersion)=>{
        const version = versionsById[fixVersion];
        if (version && version.releaseStatusId === (0, $5rYNM.RELEASE_STATUSES).RELEASED) groups.push({
            release: fixVersion,
            parentGroup: (0, $5rYNM.COMPLETED_RELEASES_GROUP)
        });
        else if (version) groups.push({
            release: fixVersion
        });
    });
    // Assigned release are not in plan
    if (groups.length === 0) return [
        {
            release: null
        }
    ];
    return groups;
};

});
parcelRegister("dYnI4", function(module, exports) {

$parcel$export(module.exports, "SPA_APP_NAME", () => $0dd50ffde9ec4111$export$3121747bb6e73d1c);
$parcel$export(module.exports, "TTI_SLO", () => $0dd50ffde9ec4111$export$748427380a6493b0);
$parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", () => $0dd50ffde9ec4111$export$1b60784a15ad91a9);
$parcel$export(module.exports, "monitor", () => $0dd50ffde9ec4111$export$ec5b303098bc4b7f);

var $3tabS = parcelRequire("3tabS");
var $lEpcX = parcelRequire("lEpcX");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $fVaJL = parcelRequire("fVaJL");

var $dtKCx = parcelRequire("dtKCx");

var $j3szT = parcelRequire("j3szT");
const $0dd50ffde9ec4111$export$3121747bb6e73d1c = 'advanced-roadmaps';
const $0dd50ffde9ec4111$export$748427380a6493b0 = 4000;
const $0dd50ffde9ec4111$export$2a97570d48bcd64d = 1000;
const $0dd50ffde9ec4111$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
const $0dd50ffde9ec4111$var$INTERACTION_PREFIX = $0dd50ffde9ec4111$export$3121747bb6e73d1c;
const $0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
const $0dd50ffde9ec4111$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
const $0dd50ffde9ec4111$var$taskKeyToInteractionKey = (taskKey)=>`${$0dd50ffde9ec4111$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
const $0dd50ffde9ec4111$export$4726438eb4db5074 = '__initial_render__';
const $0dd50ffde9ec4111$var$MAX_ENTRIES_PER_MARK = 5;
class $0dd50ffde9ec4111$export$3de16b9a4e4a99f4 {
    constructor(options){
        this.featureFlags = [];
        this.profiles = new Map();
        this.timings = [];
        this.tasks = new Map();
        this.contextualAnalyticsData = {
            planId: '',
            scenarioId: ''
        };
        this.browserMetrics = (options || {}).browserMetrics || (0, $3tabS.browserMetrics);
        this.metrics = (options || {}).metrics || (0, $lEpcX.metrics);
        this.resetInitialRenderTask();
        (0, $dtKCx.injectCallbackIntoGetBooleanFeatureFlag)((flag)=>{
            this.registerBooleanFeatureFlag(flag);
        });
    }
    initializeContextualAnalyticsData(data) {
        this.contextualAnalyticsData = {
            ...data
        };
    }
    addContextualAnalyticsData(newData) {
        this.contextualAnalyticsData = {
            ...this.contextualAnalyticsData,
            ...newData
        };
    }
    /**
	 * Add initial render stats to the ongoing UFO initial load metric
	 *
	 */ finishInitialRender(options) {
        // Retrieve the task in which all the initial render stats are stored.
        const task = this.tasks.get($0dd50ffde9ec4111$export$4726438eb4db5074);
        if (!task) return;
        // Extract and record the early preload timings
        this.recordEarlyPreloadTimings();
        const bm3Marks = {};
        this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
            bm3Marks[`${key}:start`] = startTime;
            bm3Marks[`${key}:end`] = endTime;
        });
        const bm3CustomTimings = this.timings.map(({ key: key })=>({
                key: key,
                startMark: `${key}:start`,
                endMark: `${key}:end`
            }));
        (0, $j2Yjr.addBM3TimingsToUFO)(bm3Marks, bm3CustomTimings);
        // Record the product stop in the UFO
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
        // Add custom data to UFO
        const { scalingFactors: scalingFactors } = options;
        const customData = this.collectCustomData({
            scalingFactors: scalingFactors
        }, task.executionTimes, task.marks);
        (0, $1QVWH.addUFOCustomData)(customData);
        /**
		 * Record the custom TTI value in UFO. UFO will use this TTI value. If this is not provided it, will use TTAI.
		 * The key is only used to create [bm3_tti] mark. The TTI value is recorded using `stopTime`.
		 * As we are using UFO metric names, we don't need seperate keys here.
		 * platform/packages/react-ufo/ufo-create-payload/src/index.ts#74
		 */ (0, $fVaJL.addApdexToAll)({
            key: 'plans',
            stopTime: performance.now()
        });
        // Reset the initial render data.
        this.resetInitialRenderTask();
    }
    /**
	 * Start measuring the task and timed functions within.
	 *
	 * Task is a single report unit. Always pair `startTask` with `finishTask`, or the corresponding
	 * analytics event will not be sent. Tasks are re-entrant, starting the same task before it's
	 * finished has no effect, the monitor just continues to collect data. However, people looking
	 * at the data would most likely imply 1:1 start/finish correspondence, so please don't abuse
	 * re-entrance property.
	 *
	 * When timed function is executed within a task its timing is added to task's extra attributes,
	 * as well as provided scaleFactors and registered perf feature flags. Tasks support nesting,
	 * timed functions are reported for all running tasks.
	 *
	 * We track function timing in `executionTimes` instead of using `BrowserMetrics.setMark` as it
	 * gets ugly fast due to the need to keep track of start and end of multiple invocations encoded
	 * in mark keys.
	 *
	 * At the moment all the tasks are reported as `custom` metrics as it's a majority of our use-cases
	 * but we must add support for `interaction` metrics.
	 */ startTask(taskKey, options, customStartTime) {
        if (this.tasks.has(taskKey)) return;
        const interaction = this.metrics.custom({
            key: $0dd50ffde9ec4111$var$taskKeyToInteractionKey(taskKey),
            featureFlags: this.featureFlags,
            slo: {
                threshold: $0dd50ffde9ec4111$export$2a97570d48bcd64d
            }
        });
        customStartTime !== undefined ? interaction.start({
            startTime: customStartTime
        }) : interaction.start();
        const justOptions = options || {
            scalingFactors: {}
        };
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: interaction,
            options: justOptions,
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set(taskKey, task);
        this.setMark(`${taskKey}_start`);
    }
    /**
	 * Finish measuring the task, prepare and send corresponding analytics event.
	 */ finishTask(taskKey, options) {
        const task = this.tasks.get(taskKey);
        if (!task) return;
        const { sloSuccessThreshold: sloSuccessThreshold = $0dd50ffde9ec4111$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
        // NOTE BM3 doesn't support setting SLO after interaction instantiation.
        // We violate its contract and set private field directly from here.
        // We do it only for the sake of Monitor's API backward compatibility.
        // We must move SLO into startTask ASAP and remove this abomination.
        if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
        if (scalingFactors) // @ts-expect-error No overload matches this call.
        Object.assign(task.options.scalingFactors, scalingFactors);
        const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
        task.interaction.stop({
            customData: customData
        });
        this.tasks.delete(taskKey);
        this.setMark(`${taskKey}_end`);
    }
    /**
	 * Decorate a function as a task, synchronously (task is finished as soon as the function returns).
	 */ timeTask(task, taskKey, options) {
        return (...args)=>{
            this.startTask(taskKey, options);
            const result = task(...args);
            this.finishTask(taskKey);
            return result;
        };
    }
    /**
	 * Mark a synchronous function as a timed one.
	 *
	 * When the function is executed in the presence of running tasks, its timing is reported to all of them.
	 *
	 * TODO Have a register of timed functions to warn on name clashes.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeFunction(fn, fnKey) {
        return (...args)=>{
            this.startProfile(fnKey);
            const result = fn(...args);
            this.finishProfile(fnKey);
            return result;
        };
    }
    /**
	 * Start measuring execution time from the current point to the corresponding `finishProfile` call.
	 *
	 * When the profile is finished in the presence of running tasks, its timing is reported to all of them.
	 * *Do not* use it if the same profile could be potentially started concurrently,
	 * use `startProfileConcurrent` instead.
	 */ startProfile(profileKey) {
        if (this.profiles.has(profileKey)) return;
        this.profiles.set(profileKey, {
            start: performance.now()
        });
    }
    /**
	 * Finish profile and record its execution time to all running tasks.
	 *
	 * Use it only together with `startProfile`.
	 * To finish profile started by `startProfileConcurrent` use the returned function instead.
	 */ finishProfile(profileKey) {
        const profile = this.profiles.get(profileKey);
        if (!profile) return;
        this.recordProfile(profileKey, profile);
        this.profiles.delete(profileKey);
    }
    /**
	 * Start measuring execution time from the current point to the call of the returned function.
	 *
	 * When the profile is finish in the presence of running tasks, its timing is reported to all of them.
	 * This method is safe for the potentially concurrent multiple entries by the cost of the need
	 * to pass finish function down to the profile finish point.
	 * *Do not* use `finishProfile` method for the profile started by `startProfileConcurrent`.
	 */ startProfileConcurrent(profileKey) {
        const profile = {
            start: performance.now()
        };
        return ()=>this.recordProfile(profileKey, profile);
    }
    /**
	 * Register a boolean flag to be added as an extra attribute to emitted events.
	 */ registerBooleanFeatureFlag(flag) {
        this.featureFlags.push(flag);
    }
    /**
	 * Register a mark to be reported to all tasks running at that moment.
	 */ setMark(markKey) {
        if (!performance.mark) return;
        performance.mark(markKey);
        for (const { marks: marks } of this.tasks.values())marks.add(markKey);
    }
    // Private.
    /**
	 * Create a fake task to track initial render info
	 */ resetInitialRenderTask() {
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: {},
            options: {
                scalingFactors: {}
            },
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set($0dd50ffde9ec4111$export$4726438eb4db5074, task);
    }
    /**
	 * Record profile execution time to all running tasks.
	 */ recordProfile(profileKey, profile) {
        const profileEnd = performance.now();
        const measurement = {
            start: profile.start,
            end: profileEnd
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Record custom profile execution time to all running tasks
	 */ recordCustomProfile(profileKey, customProfile) {
        const measurement = {
            ...customProfile
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Records the timing for preload requests
	 */ recordEarlyPreloadTimings() {
        const resources = [
            '',
            'backlog',
            'info-metadata',
            'initial-checks-for-report',
            'plan-info-for-report'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information of the API before returning
				 * the response.
				 */ const start = Math.floor((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
            const end = Math.ceil((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
            return {
                key: resource ? `${$0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD}/${resource}` : $0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD,
                startTime: start,
                endTime: end
            };
        }));
    }
    recordProductTimings() {
        const resources = [
            'parse-json'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information for preprocessing product data
				 */ const start = Math.floor((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$var$PRODUCT_PREFIX}.${resource}:start`));
            const end = Math.ceil((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$var$PRODUCT_PREFIX}.${resource}:end`));
            return {
                key: `product/${resource}`,
                startTime: start,
                endTime: end
            };
        }));
    }
    /**
	 * Enrich task report with feature flags, scaling factors, and execution time stats.
	 *
	 * Reported stats: min, max, mean, standard deviation, number of runs.
	 *
	 * Note that dots in feature flag names (and any other attributes) will be replaced by underscores in Splunk.
	 * (TODO confirm if this is still true in BM3 case)
	 */ collectCustomData(options, executionTimes, marks) {
        const pageStart = this.pageStart();
        const report = {
            ...this.contextualAnalyticsData,
            scalingFactors: {},
            executionTimes: {},
            marks: {}
        };
        const scalingFactors = options.scalingFactors || {};
        for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
        for (const [fnKey, allTimes] of executionTimes){
            // Skip leftovers from the previous route.
            const times = allTimes.filter(({ start: start })=>start >= pageStart);
            const n = times.length;
            if (n > 0) {
                const start = times[0].start;
                let lastEnd = start;
                let min = Infinity;
                let max = -Infinity;
                let sum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const duration = end - start;
                    sum += duration;
                    min = Math.min(min, duration);
                    max = Math.max(max, duration);
                    lastEnd = Math.max(lastEnd, end);
                }
                const mean = sum / n;
                let devSum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const dev = end - start - mean;
                    devSum += dev * dev;
                }
                const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                report.executionTimes[fnKey] = {
                    start: start - pageStart,
                    end: lastEnd - pageStart,
                    min: min,
                    max: max,
                    mean: mean,
                    stddev: stddev,
                    count: n,
                    sum: sum
                };
            }
        }
        if (performance.getEntriesByName) for (const mark of marks){
            let i = 0;
            for (const m of performance.getEntriesByName(mark) || []){
                if (i > $0dd50ffde9ec4111$var$MAX_ENTRIES_PER_MARK) break;
                const start = m.startTime - pageStart;
                // Skip leftovers from the previous route.
                if (start >= 0) {
                    report.marks[`${mark}_${i}`] = start;
                    i++;
                }
            }
        }
        return report;
    }
    /** When the most recent page transition started.
	 *
	 * It will be 0 on initial load.
	 */ pageStart() {
        return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
    }
}
const $0dd50ffde9ec4111$export$ec5b303098bc4b7f = new $0dd50ffde9ec4111$export$3de16b9a4e4a99f4();

});
parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("j3szT", function(module, exports) {

$parcel$export(module.exports, "extractStartTime", () => $f7e9a101130fcdb5$export$97ed9769a496ce6e);
const $f7e9a101130fcdb5$export$97ed9769a496ce6e = (markName)=>(performance.getEntriesByName(markName, 'mark')[0] || {
        startTime: 0
    }).startTime;

});





parcelRegister("f6g5r", function(module, exports) {

$parcel$export(module.exports, "getPersons", () => $656684c0bbe8f25a$export$a65219a764b7ed0b);
$parcel$export(module.exports, "getPersonByItemKey", () => $656684c0bbe8f25a$export$2b4d70a437cfed20);
$parcel$export(module.exports, "getTeamsPersons", () => $656684c0bbe8f25a$export$d6f9c7178699f78f);
$parcel$export(module.exports, "getTeamsAssigneeAccountIds", () => $656684c0bbe8f25a$export$5df6d993def6aa15);

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
const $656684c0bbe8f25a$export$a65219a764b7ed0b = (state)=>state.domain.persons;
const $656684c0bbe8f25a$export$2b4d70a437cfed20 = (persons, itemKey)=>persons.find((person)=>person.itemKey === itemKey);
const $656684c0bbe8f25a$export$810f09e034097552 = (teams, persons)=>{
    const resources = teams.flatMap((team)=>team.resources);
    const personItemKeys = new Set(resources.map((resource)=>resource.personItemKey));
    return persons.filter((person)=>personItemKeys.has(person.itemKey));
};
const $656684c0bbe8f25a$export$d6f9c7178699f78f = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getExistingTeams),
    $656684c0bbe8f25a$export$a65219a764b7ed0b
], $656684c0bbe8f25a$export$810f09e034097552);
const $656684c0bbe8f25a$export$be4040e7528db5fb = (persons)=>persons.reduce((acc, person)=>{
        if (person.jiraUser) acc.push(person.jiraUser.accountId);
        return acc;
    }, []);
const $656684c0bbe8f25a$export$5df6d993def6aa15 = (0, $iK4oF.createSelector)([
    $656684c0bbe8f25a$export$d6f9c7178699f78f
], $656684c0bbe8f25a$export$be4040e7528db5fb);

});


parcelRegister("2c08V", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $4e152bf931ac74a6$export$1b001418845b471c);
$parcel$export(module.exports, "getComponentFilter", () => $4e152bf931ac74a6$export$bcd437988954b9c8);
$parcel$export(module.exports, "COMPONENT_FILTER_ID", () => $12ee831723ccf9c2$export$6022538efc28a609);

var $lvJU2 = parcelRequire("lvJU2");

var $V8UZp = parcelRequire("V8UZp");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $4e152bf931ac74a6$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'components', optimizedMode);
const $4e152bf931ac74a6$export$b546ae0f6e6b7b86 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$6022538efc28a609] || {
        id: (0, $12ee831723ccf9c2$export$6022538efc28a609),
        value: []
    };
const $4e152bf931ac74a6$export$bcd437988954b9c8 = (0, $iK4oF.createSelector)([
    (0, $lvJU2.getComponents),
    $4e152bf931ac74a6$export$b546ae0f6e6b7b86
], (components, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const componentIds = new Set(components.map(({ id: id })=>id));
    const existingComponents = value.filter((component)=>componentIds.has(component));
    return {
        id: (0, $12ee831723ccf9c2$export$6022538efc28a609),
        value: existingComponents
    };
});

});
parcelRegister("lvJU2", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $b763d6cac208a489$export$4e811121b221213b);
$parcel$export(module.exports, "getComponentsById", () => $b763d6cac208a489$export$1cb6b3a2bacfcd71);
$parcel$export(module.exports, "getComponentsByProjectId", () => $b763d6cac208a489$export$d273028e2d6ef56c);

var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $ehEr2 = parcelRequire("ehEr2");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $b763d6cac208a489$export$69acd92c48f788f7 = (projects)=>(0, $7CnHa.chain)(({ components: components })=>components || [], projects);
const $b763d6cac208a489$export$4e811121b221213b = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjects)
], $b763d6cac208a489$export$69acd92c48f788f7);
const $b763d6cac208a489$export$1cb6b3a2bacfcd71 = (0, $iK4oF.createSelector)([
    $b763d6cac208a489$export$4e811121b221213b
], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(components)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), components));
const $b763d6cac208a489$export$d273028e2d6ef56c = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjectsById)
], (projectsById)=>$cQGVO.default((project)=>project.components ?? [], projectsById));

});


parcelRegister("38iYP", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectReleaseFilter", () => $eed4bb860bceacb6$export$d3efc13c7bb14288);
$parcel$export(module.exports, "CROSS_PROJECT_RELEASE_FILTER_ID", () => $12ee831723ccf9c2$export$585fb3e81bcfccad);

var $2Ruxt = parcelRequire("2Ruxt");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $eed4bb860bceacb6$export$1fb508e90d4dba03 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$585fb3e81bcfccad] || {
        id: (0, $12ee831723ccf9c2$export$585fb3e81bcfccad),
        value: []
    };
const $eed4bb860bceacb6$export$d3efc13c7bb14288 = (0, $iK4oF.createSelector)([
    (0, $2Ruxt.getCrossProjectVersionsById),
    $eed4bb860bceacb6$export$1fb508e90d4dba03
], (crossProjectVersionsById, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    return {
        id: (0, $12ee831723ccf9c2$export$585fb3e81bcfccad),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value: value.reduce((result, cprId)=>{
            const crossProjectVersion = crossProjectVersionsById[cprId];
            if ((0, $7CnHa.isDefined)(crossProjectVersion)) result.push(cprId);
            return result;
        }, []),
        crossProjectVersionsById: crossProjectVersionsById
    };
});

});
parcelRegister("2Ruxt", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectVersions", () => $d6835cbe1f5dc181$export$96aefa9e5b339235);
$parcel$export(module.exports, "getCrossProjectVersionsById", () => $d6835cbe1f5dc181$export$34f7a353be0fbd5a);
$parcel$export(module.exports, "getRemovedCrossProjectVersions", () => $d6835cbe1f5dc181$export$541a8daa218b27a8);
$parcel$export(module.exports, "getRemovedCrossProjectVersionsById", () => $d6835cbe1f5dc181$export$8c7c88d6ff048be3);
$parcel$export(module.exports, "getOriginalCrossProjectVersions", () => $d6835cbe1f5dc181$export$15354078c9227d29);
$parcel$export(module.exports, "getCrossProjectVersionChangeCount", () => $d6835cbe1f5dc181$export$a8e5eb8dd701e4cf);
$parcel$export(module.exports, "getCrossProjectVersionChanges", () => $d6835cbe1f5dc181$export$82c61cf2cd5affb4);
$parcel$export(module.exports, "getEnrichedCrossProjectVersions", () => $d6835cbe1f5dc181$export$b0aa263c5f8aad6a);
$parcel$export(module.exports, "getEnrichedCrossProjectVersionsById", () => $d6835cbe1f5dc181$export$be19acca0e4271d3);
$parcel$export(module.exports, "getEnrichedCrossProjectVersionsSortedByName", () => $d6835cbe1f5dc181$export$af5dc8974c602aef);

var $01zCq = parcelRequire("01zCq");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");

var $wcCGG = parcelRequire("wcCGG");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $d6835cbe1f5dc181$export$96aefa9e5b339235 = (state)=>state.domain.crossProjectVersions;
const $d6835cbe1f5dc181$export$34f7a353be0fbd5a = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$96aefa9e5b339235
], (crossProjectVersions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), crossProjectVersions));
const $d6835cbe1f5dc181$export$541a8daa218b27a8 = (state)=>state.domain.removedCrossProjectVersions;
const $d6835cbe1f5dc181$export$8c7c88d6ff048be3 = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$541a8daa218b27a8
], (removedCrossProjectVersions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), removedCrossProjectVersions));
const $d6835cbe1f5dc181$export$15354078c9227d29 = (state)=>state.domain.originalCrossProjectVersions;
const $d6835cbe1f5dc181$export$a8e5eb8dd701e4cf = ({ domain: { originalCrossProjectVersions: originalCrossProjectVersions } })=>Object.keys(originalCrossProjectVersions).length;
const $d6835cbe1f5dc181$export$a4034dcb9c848c74 = (state)=>$kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData',
        'crossProjectVersions'
    ], state) || {};
const $d6835cbe1f5dc181$export$d4d0f421f97c57fe = (state)=>state.domain.updateJira.warnings[(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE];
const $d6835cbe1f5dc181$export$ee9e0efc68f3757b = (crossProjectVersions = [], removedCrossProjectVersions = [], originalCrossProjectVersions = {}, entityMetaData, warnings)=>{
    const crossProjectVersionsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), [
        ...crossProjectVersions,
        ...removedCrossProjectVersions
    ]);
    return (0, $7CnHa.filterMap)((id)=>(0, $7CnHa.isDefined)(crossProjectVersionsById[id]), (id)=>{
        const crossProjectVersion = crossProjectVersionsById[id];
        const metaData = entityMetaData[id];
        return {
            // at the moment only name could be changed in CPV
            // and we don't want to show it as a separate field if version was created
            attributeName: metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? null : 'name',
            category: (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE,
            changeCount: metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? 0 : 1,
            details: {
                values: crossProjectVersion,
                originals: $01zCq.default(originalCrossProjectVersions[id], {})
            },
            id: id,
            metaData: metaData,
            warnings: warnings[id] || []
        };
    }, Object.keys(entityMetaData));
};
const $d6835cbe1f5dc181$export$82c61cf2cd5affb4 = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$96aefa9e5b339235,
    $d6835cbe1f5dc181$export$541a8daa218b27a8,
    $d6835cbe1f5dc181$export$15354078c9227d29,
    $d6835cbe1f5dc181$export$a4034dcb9c848c74,
    $d6835cbe1f5dc181$export$d4d0f421f97c57fe
], $d6835cbe1f5dc181$export$ee9e0efc68f3757b);
const $d6835cbe1f5dc181$export$ad60801a43040a2 = (crossProjectVersions, versionsByIdMap)=>crossProjectVersions.map(({ versions: versions, ...rest })=>({
            ...rest,
            versions: versions.map((vid)=>versionsByIdMap[vid])
        }));
const $d6835cbe1f5dc181$export$b0aa263c5f8aad6a = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$96aefa9e5b339235,
    (0, $wcCGG.getVersionsById)
], $d6835cbe1f5dc181$export$ad60801a43040a2);
const $d6835cbe1f5dc181$export$be19acca0e4271d3 = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$b0aa263c5f8aad6a
], (versions)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), versions));
const $d6835cbe1f5dc181$export$34c32ae6954e6b88 = (enrichedCrossProjectVersions)=>$9RbxZ.default($f7Op5.default('name'), enrichedCrossProjectVersions);
const $d6835cbe1f5dc181$export$af5dc8974c602aef = (0, $iK4oF.createSelector)([
    $d6835cbe1f5dc181$export$b0aa263c5f8aad6a
], $d6835cbe1f5dc181$export$34c32ae6954e6b88);

});


parcelRegister("imCER", function(module, exports) {

$parcel$export(module.exports, "getDateRangeFilter", () => $ea92d7175275e2c0$export$4adc666d0ec1b95a);
$parcel$export(module.exports, "applyFilter", () => $ea92d7175275e2c0$export$1b001418845b471c);
$parcel$export(module.exports, "DATE_RANGE_FILTER_ID", () => $12ee831723ccf9c2$export$82db1960569473ff);

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $ea92d7175275e2c0$export$8ef11a90fa2d53e4 = (state)=>{
    const { value: value } = (0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$82db1960569473ff] || {};
    return {
        id: (0, $12ee831723ccf9c2$export$82db1960569473ff),
        value: value
    };
};
const $ea92d7175275e2c0$export$cb4ac493812837a8 = (dateRangeFilter)=>({
        ...dateRangeFilter,
        value: dateRangeFilter.value || {}
    });
const $ea92d7175275e2c0$export$4adc666d0ec1b95a = (0, $iK4oF.createSelector)([
    $ea92d7175275e2c0$export$8ef11a90fa2d53e4
], $ea92d7175275e2c0$export$cb4ac493812837a8);
const $ea92d7175275e2c0$export$1b001418845b471c = ({ baselineEnd: baselineEnd, baselineStart: baselineStart }, { value: { startDate: startDate, endDate: endDate } })=>(!(0, $7CnHa.isDefined)(startDate) || (0, $7CnHa.isDefined)(baselineStart) && baselineStart >= startDate || (0, $7CnHa.isDefined)(baselineEnd) && baselineEnd >= startDate) && (!(0, $7CnHa.isDefined)(endDate) || (0, $7CnHa.isDefined)(baselineEnd) && baselineEnd <= endDate || (0, $7CnHa.isDefined)(baselineStart) && baselineStart <= endDate);

});

parcelRegister("bRpYp", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $41454dc165967c82$export$1b001418845b471c);
$parcel$export(module.exports, "getDependenciesFilter", () => $41454dc165967c82$export$7e5efb93ed83c18f);
$parcel$export(module.exports, "DEPENDENCIES_FILTER_ID", () => $12ee831723ccf9c2$export$a849f806e27a57e8);

var $dYnI4 = parcelRequire("dYnI4");

var $dEoWh = parcelRequire("dEoWh");

var $lseqm = parcelRequire("lseqm");

var $kFf60 = parcelRequire("kFf60");

var $75KhQ = parcelRequire("75KhQ");

var $cwP4d = parcelRequire("cwP4d");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $41454dc165967c82$export$1b001418845b471c = (issue, filter)=>{
    const { value: value, issuesWithLinks: issuesWithLinks = new Set(), specificIssueLinks: specificIssueLinks = new Set(), offtrackIssueLinks: offtrackIssueLinks = new Set() } = filter;
    switch(value.type){
        case 'on':
            return issuesWithLinks.has(issue.id);
        case 'specificIssue':
            return !value.issueId || specificIssueLinks.has(issue.id) || value.issueId === issue.id;
        case 'offtrack':
            return offtrackIssueLinks.has(issue.id);
        default:
            return true;
    }
};
const $41454dc165967c82$export$c0e0bfc86fb01b8f = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8] || {
        value: {
            type: 'off'
        }
    };
const $41454dc165967c82$export$14dac874d99ad1a4 = (value, incomingLinks, outgoingLinks)=>{
    const specificIssueLinks = new Set();
    if (value.type === 'specificIssue' && value.issueId) {
        if (value.includeTransitive) {
            // Collect all the issues which are linked to the specific one via dependencies,
            // both immediate and transitive.
            // Handling cycles: skip met issues, but don't interrupt queue traversal.
            const queue = [
                value.issueId
            ];
            while(queue.length > 0){
                const id = queue.pop();
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                for (const link of incomingLinks[id] || []){
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    const id = link.sourceItemKey;
                    if (!specificIssueLinks.has(id)) {
                        specificIssueLinks.add(id);
                        queue.push(id);
                    }
                }
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                for (const link of outgoingLinks[id] || []){
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    const id = link.targetItemKey;
                    if (!specificIssueLinks.has(id)) {
                        specificIssueLinks.add(id);
                        queue.push(id);
                    }
                }
            }
        } else {
            for (const link of incomingLinks[value.issueId || ''] || [])specificIssueLinks.add(link.sourceItemKey);
            for (const link of outgoingLinks[value.issueId || ''] || [])specificIssueLinks.add(link.targetItemKey);
        }
    }
    return specificIssueLinks;
};
const $41454dc165967c82$export$f16b4b4ef2c78b0d = (issueMap, outgoingLinks, issueStatusById, syncStartEnabled)=>{
    const offtrackIssueLinks = new Set();
    for (const issueLinks of Object.values(outgoingLinks))for (const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } of issueLinks){
        const overlapping = (0, $lseqm.getIssueLinkIfOverlapping)(issueMap[sourceItemKey], issueMap[targetItemKey], issueStatusById, syncStartEnabled);
        if (overlapping) {
            offtrackIssueLinks.add(sourceItemKey);
            offtrackIssueLinks.add(targetItemKey);
        }
    }
    return offtrackIssueLinks;
};
const $41454dc165967c82$export$f325f5532978989e = (0, $dYnI4.monitor).timeFunction($41454dc165967c82$export$f16b4b4ef2c78b0d, 'query_filters_dependenciesFilter_index_getOfftrackIssueLinks');
const $41454dc165967c82$export$7e5efb93ed83c18f = (0, $iK4oF.createSelector)([
    $41454dc165967c82$export$c0e0bfc86fb01b8f,
    (0, $dEoWh.getAllIssuesWithLinks),
    (0, $dEoWh.getInternalIncomingLinks),
    (0, $dEoWh.getInternalOutgoingLinks),
    (0, $cwP4d.getIssueMapById),
    (0, $kFf60.getIssueStatusById),
    (0, $75KhQ.getSyncStartEnabled)
], (filterState, issuesWithLinks, incomingLinks, outgoingLinks, issueMap, issueStatusById, syncStartEnabled)=>{
    const { value: value = {
        type: 'off'
    } } = filterState || {};
    return {
        id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
        value: value,
        issuesWithLinks: issuesWithLinks,
        specificIssueLinks: $41454dc165967c82$export$14dac874d99ad1a4(value, incomingLinks, outgoingLinks),
        offtrackIssueLinks: $41454dc165967c82$export$f325f5532978989e(issueMap, outgoingLinks, issueStatusById, syncStartEnabled)
    };
});

});
parcelRegister("dEoWh", function(module, exports) {

$parcel$export(module.exports, "getIssueLinks", () => $752d5472e05b55de$export$58c9baa89092141d);
$parcel$export(module.exports, "getIssueLinkOriginals", () => $752d5472e05b55de$export$1afd614b829de1af);
$parcel$export(module.exports, "getOutgoingLinks", () => $752d5472e05b55de$export$c13f12ce68344b34);
$parcel$export(module.exports, "getOutgoingLinkOriginals", () => $752d5472e05b55de$export$c7e01775a6d5ac01);
$parcel$export(module.exports, "getInternalOutgoingLinks", () => $752d5472e05b55de$export$4512d9d5dd191b3b);
$parcel$export(module.exports, "getInternalOutgoingLinkOriginals", () => $752d5472e05b55de$export$12bed64401d7ce47);
$parcel$export(module.exports, "getExternalOutgoingLinks", () => $752d5472e05b55de$export$cdbd80b3d29e5c05);
$parcel$export(module.exports, "getIncomingLinks", () => $752d5472e05b55de$export$1ed684a0d7ab81ae);
$parcel$export(module.exports, "getIncomingLinkOriginals", () => $752d5472e05b55de$export$6ad957af4df4a3e9);
$parcel$export(module.exports, "getInternalIncomingLinks", () => $752d5472e05b55de$export$5567029344c01af9);
$parcel$export(module.exports, "getInternalIncomingLinkOriginals", () => $752d5472e05b55de$export$55f70301dcb7a9b5);
$parcel$export(module.exports, "getExternalIncomingLinks", () => $752d5472e05b55de$export$503854918648e210);
$parcel$export(module.exports, "getAllIssuesWithLinks", () => $752d5472e05b55de$export$6b72ce8376e8916a);
$parcel$export(module.exports, "getUniqueLinks", () => $752d5472e05b55de$export$4592e5de25d61d15);
$parcel$export(module.exports, "getDependencyIssueLinkTypes", () => $752d5472e05b55de$export$2bf90898c9560ad8);
$parcel$export(module.exports, "getDependencyIssueLinkTypesById", () => $752d5472e05b55de$export$8f21fbdff6c58479);
$parcel$export(module.exports, "getIssueCountByLinkType", () => $752d5472e05b55de$export$9d514c9fb87fc17a);
$parcel$export(module.exports, "getIssueLinkChangesDataPure", () => $752d5472e05b55de$export$b2866f3fe0e9bd20);
$parcel$export(module.exports, "getIssueLinkChangesData", () => $752d5472e05b55de$export$aefbf48531b950e);
$parcel$export(module.exports, "getIssueLinkChangesMetaData", () => $752d5472e05b55de$export$ec9cbadd3b83e825);

var $1dZWS = parcelRequire("1dZWS");
var $lqxEm = parcelRequire("lqxEm");
var $b3iuB = parcelRequire("b3iuB");
var $cQGVO = parcelRequire("cQGVO");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $kpKEz = parcelRequire("kpKEz");
var $UCNmJ = parcelRequire("UCNmJ");

var $cwP4d = parcelRequire("cwP4d");

var $dhHiZ = parcelRequire("dhHiZ");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $752d5472e05b55de$export$58c9baa89092141d = (state)=>state.domain.issueLinks.values;
const $752d5472e05b55de$export$1afd614b829de1af = (state)=>state.domain.issueLinks.originals;
const $752d5472e05b55de$export$10359de6952f0fb3 = (issueLinks, issuesById)=>$cQGVO.default((links)=>links.filter((x)=>issuesById[x.sourceItemKey] && issuesById[x.targetItemKey]), issueLinks);
const $752d5472e05b55de$export$ec401995dee39995 = (issueLinks, issuesById)=>$cQGVO.default((links)=>links.filter((x)=>!issuesById[x.sourceItemKey] || !issuesById[x.targetItemKey]), issueLinks);
const $752d5472e05b55de$export$6f5ee8e3e5b8730d = (issueLinks)=>(0, $7CnHa.mapObject)((issueId, links)=>$UCNmJ.default(links).filter((x)=>x.sourceItemKey === issueId), issueLinks);
const $752d5472e05b55de$export$c13f12ce68344b34 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$58c9baa89092141d
], $752d5472e05b55de$export$6f5ee8e3e5b8730d);
const $752d5472e05b55de$export$c7e01775a6d5ac01 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$1afd614b829de1af
], $752d5472e05b55de$export$6f5ee8e3e5b8730d);
const $752d5472e05b55de$export$4512d9d5dd191b3b = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$c13f12ce68344b34,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$10359de6952f0fb3);
const $752d5472e05b55de$export$12bed64401d7ce47 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$c7e01775a6d5ac01,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$10359de6952f0fb3);
const $752d5472e05b55de$export$cdbd80b3d29e5c05 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$c13f12ce68344b34,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$ec401995dee39995);
const $752d5472e05b55de$export$9011cf2b1d0ca0e0 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$c7e01775a6d5ac01,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$ec401995dee39995);
const $752d5472e05b55de$export$1adf7387341603d7 = (issueLinks)=>(0, $7CnHa.mapObject)((issueId, links)=>$UCNmJ.default(links).filter((x)=>x.targetItemKey === issueId), issueLinks);
const $752d5472e05b55de$export$1ed684a0d7ab81ae = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$58c9baa89092141d
], $752d5472e05b55de$export$1adf7387341603d7);
const $752d5472e05b55de$export$6ad957af4df4a3e9 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$1afd614b829de1af
], $752d5472e05b55de$export$1adf7387341603d7);
const $752d5472e05b55de$export$5567029344c01af9 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$1ed684a0d7ab81ae,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$10359de6952f0fb3);
const $752d5472e05b55de$export$55f70301dcb7a9b5 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$6ad957af4df4a3e9,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$10359de6952f0fb3);
const $752d5472e05b55de$export$503854918648e210 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$1ed684a0d7ab81ae,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$ec401995dee39995);
const $752d5472e05b55de$export$66da17e536ea1124 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$6ad957af4df4a3e9,
    (0, $cwP4d.getIssueMapById)
], $752d5472e05b55de$export$ec401995dee39995);
const $752d5472e05b55de$export$6b72ce8376e8916a = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$58c9baa89092141d
], (issueLinks)=>new Set(Object.keys($kpKEz.default($b3iuB.default, issueLinks))));
const $752d5472e05b55de$export$4592e5de25d61d15 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$58c9baa89092141d
], (issueLinks)=>{
    const cleanIssueLinks = $lqxEm.default($cQGVO.default($UCNmJ.default, $UCNmJ.default($kpKEz.default($b3iuB.default, issueLinks))));
    const seen = new Set();
    /* Unique items by property, this could potentially be moved to a util */ return cleanIssueLinks.filter((issueLink)=>{
        if (seen.has(issueLink.itemKey)) return false;
        seen.add(issueLink.itemKey);
        return true;
    });
});
const $752d5472e05b55de$export$73624b3e4f1f5f78 = ({ issueLinkTypes: issueLinkTypes }, { dependencyIssueLinkTypes: dependencyIssueLinkTypes })=>{
    const linkTypes = new Set(dependencyIssueLinkTypes.map(({ issueLinkTypeId: issueLinkTypeId })=>issueLinkTypeId));
    return issueLinkTypes.filter(({ id: id })=>linkTypes.has(id));
};
const $752d5472e05b55de$export$2bf90898c9560ad8 = (0, $iK4oF.createSelector)([
    (0, $dhHiZ.getIssueLinkTypesInfo),
    (0, $dhHiZ.getDependencySettingsInfo)
], $752d5472e05b55de$export$73624b3e4f1f5f78);
const $752d5472e05b55de$export$8f21fbdff6c58479 = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$2bf90898c9560ad8
], (dependencyIssueLinkTypes)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), dependencyIssueLinkTypes));
const $752d5472e05b55de$export$77b826244302fe5c = (issueLinks)=>$1dZWS.default((issue)=>issue.type)(issueLinks);
const $752d5472e05b55de$export$9d514c9fb87fc17a = (0, $iK4oF.createSelector)([
    $752d5472e05b55de$export$4592e5de25d61d15
], $752d5472e05b55de$export$77b826244302fe5c);
const $752d5472e05b55de$export$b2866f3fe0e9bd20 = (issueLinks = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const link of issueLinks){
        const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } = link;
        if (!result[sourceItemKey]) result[sourceItemKey] = [];
        if (!result[targetItemKey]) result[targetItemKey] = [];
        result[sourceItemKey].push({
            ...link,
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD
        });
        result[targetItemKey].push({
            ...link,
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD
        });
    }
    return result;
};
const $752d5472e05b55de$export$aefbf48531b950e = (0, $iK4oF.createSelector)([
    $kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'issueLinks'
    ])
], $752d5472e05b55de$export$b2866f3fe0e9bd20);
const $752d5472e05b55de$export$ec9cbadd3b83e825 = (state)=>$kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData',
        'issueLinks'
    ], state) || {};

});

parcelRegister("lseqm", function(module, exports) {

$parcel$export(module.exports, "getIssueLinkIfOverlapping", () => $3b3532b5d95a866b$export$bfc725baf7746c7e);
$parcel$export(module.exports, "getIssueLinkLeadTime", () => $3b3532b5d95a866b$export$a7e1a952eb4b8aaf);

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $3b3532b5d95a866b$var$isIssueDone = (issue, issueStatusById)=>{
    if ('statusCategoryId' in issue && typeof issue.statusCategoryId === 'number') return issue.statusCategoryId === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE;
    if ('status' in issue && typeof issue.status === 'string') // Note: issueStatusById[issue.status] should normally not be be absent, but a small number of customers
    // were hitting this case and a false default is better than the plan crashing
    return issueStatusById[issue.status]?.categoryId === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE;
    return false;
};
const $3b3532b5d95a866b$export$bfc725baf7746c7e = (sourceIssue, targetIssue, issueStatusById, syncStartEnabled)=>{
    if (!(0, $7CnHa.isDefined)(sourceIssue) || !(0, $7CnHa.isDefined)(targetIssue)) return false;
    // if either sourceIssue or targetIssue is DONE, there is no blocking dependency
    if ($3b3532b5d95a866b$var$isIssueDone(sourceIssue, issueStatusById) || $3b3532b5d95a866b$var$isIssueDone(targetIssue, issueStatusById)) return false;
    let sourceIssueSprint;
    const { baselineStart: sourceIssueStartTime, baselineEnd: sourceIssueEndTime } = sourceIssue;
    if ('sprint' in sourceIssue && sourceIssue.sprint !== 'undefined') sourceIssueSprint = sourceIssue.sprint;
    let targetIssueSprint;
    const { baselineStart: targetIssueStartTime, baselineEnd: targetIssueEndTime } = targetIssue;
    if ('sprint' in targetIssue && targetIssue.sprint !== 'undefined') targetIssueSprint = targetIssue.sprint;
    // if the issues are in the same sprint and Plan Settings > Dependencies > Concurrent is selected
    if ((0, $7CnHa.isDefined)(sourceIssueSprint) && (0, $7CnHa.isDefined)(targetIssueSprint) && sourceIssueSprint === targetIssueSprint && syncStartEnabled) {
        // there is a blocking dependency if the source issue starts after the target issue start time
        if ((0, $7CnHa.isDefined)(sourceIssueStartTime)) {
            if ((0, $7CnHa.isDefined)(targetIssueStartTime)) return sourceIssueStartTime > targetIssueStartTime;
            // if the target issue does not have a start time or finish time then there is no blocking dependency
            if (!(0, $7CnHa.isDefined)(targetIssueEndTime)) return false;
            // There is a blocking dependency if the source issue starts after the target issue finishes
            return sourceIssueStartTime > targetIssueEndTime;
        }
        return false;
    }
    // if:
    // - the issues are in the same sprint AND Plan Settings > Dependencies > Sequential is selected; OR
    // - the issues are NOT in the same sprint AND Plan Settings > Dependencies > Sequential is selected; OR
    // - the issues are NOT in the same sprint AND Plan Settings > Dependencies > Concurrent is selected
    // then any issue A blocked by an issue B should be scheduled after issue A
    if ((0, $7CnHa.isDefined)(targetIssueEndTime)) {
        // There is a blocking dependency if the source issue has no end date and the target issue has an end date
        if (!(0, $7CnHa.isDefined)(sourceIssueEndTime)) return true;
        // There is a blocking dependency if the target issue has no start date and the source issue has an end date
        if (!(0, $7CnHa.isDefined)(targetIssueStartTime)) return true;
        // there is a blocking dependency if:
        // - the source issue end time is higher than the target issue start time and the leading time (sourceIssueEndTime - targetIssueStartTime) is bigger than VALID_LEADING_TIME_FOR_DEPENDENCIES(always be positive);
        return sourceIssueEndTime - targetIssueStartTime > (0, $5rYNM.VALID_LEADING_TIME_FOR_DEPENDENCIES);
    }
    return false;
};
const $3b3532b5d95a866b$export$a7e1a952eb4b8aaf = (sourceIssue, targetIssue)=>{
    if ((0, $7CnHa.isDefined)(sourceIssue) && (0, $7CnHa.isDefined)(sourceIssue.baselineEnd) && (0, $7CnHa.isDefined)(targetIssue) && (0, $7CnHa.isDefined)(targetIssue.baselineStart)) return targetIssue.baselineStart - sourceIssue.baselineEnd;
    return null;
};

});


parcelRegister("kOHCR", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $6a1c39b8a1b0e92a$export$1b001418845b471c);
$parcel$export(module.exports, "getGoalFilter", () => $6a1c39b8a1b0e92a$export$6da7d7f535a37598);
$parcel$export(module.exports, "GOAL_FILTER_ID", () => $12ee831723ccf9c2$export$861e775e082be75a);

var $V8UZp = parcelRequire("V8UZp");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $e4IaE = parcelRequire("e4IaE");
const $6a1c39b8a1b0e92a$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'goals', optimizedMode);
const $6a1c39b8a1b0e92a$export$cb2e83517b340370 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$861e775e082be75a] || {
        id: (0, $12ee831723ccf9c2$export$861e775e082be75a),
        value: []
    };
const $6a1c39b8a1b0e92a$export$6da7d7f535a37598 = (0, $iK4oF.createSelector)([
    (0, $e4IaE.getIssueGoalARIs),
    $6a1c39b8a1b0e92a$export$cb2e83517b340370
], (issueGoalARIs, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const filteredGoals = value.filter((goalARI)=>issueGoalARIs.some((issueGoalARI)=>issueGoalARI === goalARI));
    return {
        id: (0, $12ee831723ccf9c2$export$861e775e082be75a),
        value: filteredGoals
    };
});

});
parcelRegister("e4IaE", function(module, exports) {

$parcel$export(module.exports, "getIssueGoalARIs", () => $e5737a8589eea582$export$ee7a2e4f209f098d);
const $e5737a8589eea582$export$ee7a2e4f209f098d = (state)=>state.domain.goalARIs;

});


parcelRegister("6UAvZ", function(module, exports) {

$parcel$export(module.exports, "getHierarchyFilterState", () => $d17a35f2275f04d5$export$30c35db60c3f32f5);
$parcel$export(module.exports, "getHierarchyFilter", () => $d17a35f2275f04d5$export$e1c94a7e3ef179d9);
$parcel$export(module.exports, "applyFilter", () => $d17a35f2275f04d5$export$1b001418845b471c);

var $8YqJS = parcelRequire("8YqJS");

var $fZW8G = parcelRequire("fZW8G");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $d17a35f2275f04d5$export$30c35db60c3f32f5 = (state)=>{
    const { value: value } = (0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc] || {};
    return {
        id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
        value: value
    };
};
const $d17a35f2275f04d5$export$dd998d0ed23710ab = (hierarchyFilter, hierarchyRange, isCalendarView)=>{
    const { min: min, max: max } = hierarchyRange;
    const currentValue = hierarchyFilter.value || {
        start: undefined,
        end: undefined
    };
    if (!(0, $7CnHa.isDefined)(currentValue.start)) currentValue.start = isCalendarView ? (0, $8YqJS.EPIC_LEVEL) : max;
    if (!(0, $7CnHa.isDefined)(currentValue.end)) currentValue.end = isCalendarView ? (0, $8YqJS.EPIC_LEVEL) : min;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const clamp = (val, min, max)=>Math.min(Math.max(val, min), max);
    const clampedStart = clamp(currentValue.start, min, max);
    const clampedEnd = isCalendarView ? clampedStart : clamp(currentValue.end, min, clampedStart);
    const newValue = {
        start: clampedStart,
        end: clampedEnd
    };
    return {
        ...hierarchyFilter,
        value: newValue
    };
};
const $d17a35f2275f04d5$export$e1c94a7e3ef179d9 = (0, $iK4oF.createSelector)([
    $d17a35f2275f04d5$export$30c35db60c3f32f5,
    (0, $fZW8G.getHierarchyRange),
    (0, $9H2AP.getIsCalendarView)
], $d17a35f2275f04d5$export$dd998d0ed23710ab);
const $d17a35f2275f04d5$export$1b001418845b471c = (issue, filter)=>{
    const { start: start, end: end } = filter.value;
    return start >= issue.level && issue.level >= end;
};

});
parcelRegister("fZW8G", function(module, exports) {

$parcel$export(module.exports, "getHierarchy", () => $1132ee5ebe77300c$export$9447fd3d4b10cb5f);
$parcel$export(module.exports, "getHierarchyLevels", () => $1132ee5ebe77300c$export$f6802dd3df2c9c9f);
$parcel$export(module.exports, "getHierarchyLevelsByLevel", () => $1132ee5ebe77300c$export$476530a7d255f7a6);
$parcel$export(module.exports, "getTypeToLevel", () => $1132ee5ebe77300c$export$c2a7df7fd3eb5955);
$parcel$export(module.exports, "getIssueTypeWithLevelById", () => $1132ee5ebe77300c$export$9c54f3dd2a3e8b6b);
$parcel$export(module.exports, "getIssueTypesByLevel", () => $1132ee5ebe77300c$export$34839371792557f6);
$parcel$export(module.exports, "getEnrichedHierarchyLevels", () => $1132ee5ebe77300c$export$f82081736949f180);
$parcel$export(module.exports, "getHierarchyRange", () => $1132ee5ebe77300c$export$ce581c08d4a52de0);
$parcel$export(module.exports, "getHierarchyTitles", () => $1132ee5ebe77300c$export$710b1fdedb2df3ad);

var $fcWBJ = parcelRequire("fcWBJ");

var $3aUuh = parcelRequire("3aUuh");

var $8YqJS = parcelRequire("8YqJS");

var $lihml = parcelRequire("lihml");

var $frMqv = parcelRequire("frMqv");

var $iK4oF = parcelRequire("iK4oF");
const $1132ee5ebe77300c$export$9447fd3d4b10cb5f = (state)=>state.domain.hierarchy.levels;
const $1132ee5ebe77300c$export$746d16b887d46fe3 = (hierarchy)=>{
    // making a copy to prevent mutation of the original hierarchy
    const hierarchyLevels = [
        ...hierarchy
    ];
    // sorting the hierarchy levels in descending order (top-down)
    return hierarchyLevels.sort((a, b)=>b.level - a.level);
};
const $1132ee5ebe77300c$export$f6802dd3df2c9c9f = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f
], $1132ee5ebe77300c$export$746d16b887d46fe3);
const $1132ee5ebe77300c$export$94fac7b50826b632 = (hierarchy)=>{
    const hierarchyLevels = [
        ...hierarchy
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(hierarchyLevels, 'level');
};
const $1132ee5ebe77300c$export$476530a7d255f7a6 = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f
], $1132ee5ebe77300c$export$94fac7b50826b632);
const $1132ee5ebe77300c$export$c2a7df7fd3eb5955 = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f,
    (0, $lihml.getIssueTypes)
], (0, $frMqv.getTypeToLevelPure));
const $1132ee5ebe77300c$export$5f725a76f1d1e1b2 = (issueTypes, hierarchyLevels)=>{
    const issueTypeIdToLevel = issueTypes.reduce((acc, { id: id, level: level })=>{
        acc[`${id}`] = level;
        return acc;
    }, {});
    // fallback to hierarchy data if issue type id does not exist, i.e. some CMP issue types
    // eslint-disable-next-line @typescript-eslint/no-shadow
    hierarchyLevels.forEach(({ level: level, issueTypes: issueTypes = [] })=>{
        issueTypes.forEach((issueTypeId)=>{
            if (issueTypeIdToLevel[issueTypeId] === undefined) // subtract 1 to convert ARJ hierarchy back to Jira hierarchy convention
            issueTypeIdToLevel[issueTypeId] = level - 1;
        });
    });
    return issueTypeIdToLevel;
};
const $1132ee5ebe77300c$export$2e66c1118674a4e7 = (0, $iK4oF.createSelector)([
    (0, $lihml.getIssueTypes),
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f
], $1132ee5ebe77300c$export$5f725a76f1d1e1b2);
const $1132ee5ebe77300c$export$c92a4ded8a03a436 = (issueTypes, issueTypeIdToLevel)=>issueTypes.reduce((acc, { id: id, name: name, iconUrl: iconUrl })=>{
        // should never be possible for issue type without id, but default to base-level 0 anyway
        const level = issueTypeIdToLevel[`${id}`] ?? 0;
        acc[id] = {
            id: id,
            name: name,
            iconUrl: iconUrl,
            level: level
        };
        return acc;
    }, {});
const $1132ee5ebe77300c$export$9c54f3dd2a3e8b6b = (0, $iK4oF.createSelector)([
    (0, $lihml.getIssueTypes),
    $1132ee5ebe77300c$export$2e66c1118674a4e7
], $1132ee5ebe77300c$export$c92a4ded8a03a436);
const $1132ee5ebe77300c$export$384a76490e77fdf = (issueTypes, issueTypeIdToLevel)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(issueTypes, (issueType)=>issueTypeIdToLevel[`${issueType.id}`]);
const $1132ee5ebe77300c$export$34839371792557f6 = (0, $iK4oF.createSelector)([
    (0, $lihml.getIssueTypes),
    $1132ee5ebe77300c$export$2e66c1118674a4e7
], $1132ee5ebe77300c$export$384a76490e77fdf);
const $1132ee5ebe77300c$export$f82081736949f180 = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f,
    (0, $lihml.getIssueTypes)
], (0, $frMqv.getEnrichedHierarchyLevelsPure));
const $1132ee5ebe77300c$export$e6655097f86f8d45 = (levels)=>{
    if (levels.length > 0) {
        const hierarchyRangeLevels = levels.map(({ level: level })=>level);
        return {
            max: Math.max(...hierarchyRangeLevels),
            min: Math.min(...hierarchyRangeLevels)
        };
    }
    return {
        max: (0, $8YqJS.SUB_TASK_LEVEL),
        min: (0, $8YqJS.SUB_TASK_LEVEL)
    };
};
const $1132ee5ebe77300c$export$ce581c08d4a52de0 = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f
], $1132ee5ebe77300c$export$e6655097f86f8d45);
const $1132ee5ebe77300c$export$47548a2aea415bb0 = (levels)=>levels.reduce((acc, { level: level, title: title })=>{
        // offset -1 from ARJ hierarchy to match Jira hierarchy convention
        acc[level - 1] = title;
        return acc;
    }, {});
const $1132ee5ebe77300c$export$710b1fdedb2df3ad = (0, $iK4oF.createSelector)([
    $1132ee5ebe77300c$export$9447fd3d4b10cb5f
], $1132ee5ebe77300c$export$47548a2aea415bb0);

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("lihml", function(module, exports) {

$parcel$export(module.exports, "getIssueTypes", () => $99bdc172372b0d44$export$4cf4b24b88599615);
$parcel$export(module.exports, "getIssueTypesById", () => $99bdc172372b0d44$export$4c667e9a92bbd1ef);
$parcel$export(module.exports, "getIssueTypesByName", () => $99bdc172372b0d44$export$e980f590d46b59b4);
$parcel$export(module.exports, "getIssueTypeIds", () => $99bdc172372b0d44$export$ad4e1aa4d2c7ef98);
$parcel$export(module.exports, "getIssueTypeIdsOfCompanyManagedProjects", () => $99bdc172372b0d44$export$c276bc4d7b5b95e1);
$parcel$export(module.exports, "getTeamManagedProjectByIssueTypeId", () => $99bdc172372b0d44$export$35747f0693c3c228);
$parcel$export(module.exports, "getIssueTypesByIdForCompanyManagedProjects", () => $99bdc172372b0d44$export$c21f9b5f8889e9a6);
$parcel$export(module.exports, "getIssueTypeIconByKey", () => $99bdc172372b0d44$export$8696f212ec31e9f7);
$parcel$export(module.exports, "getIssueTypeIconByName", () => $99bdc172372b0d44$export$f67c89b26645faf6);

var $fcWBJ = parcelRequire("fcWBJ");

var $cQGVO = parcelRequire("cQGVO");

var $ehEr2 = parcelRequire("ehEr2");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $99bdc172372b0d44$export$4cf4b24b88599615 = (state)=>state.domain.issueTypes;
const $99bdc172372b0d44$export$4c667e9a92bbd1ef = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615
], (issueTypes)=>(0, $7CnHa.indexBy)(({ id: id })=>id, issueTypes));
const $99bdc172372b0d44$export$e980f590d46b59b4 = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615
], (issueTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(issueTypes, ({ name: name })=>name));
const $99bdc172372b0d44$export$ad4e1aa4d2c7ef98 = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615
], (issueTypes)=>$cQGVO.default(({ id: id })=>id, issueTypes));
const $99bdc172372b0d44$export$2d61f545ccc89c9e = (projects)=>[
        ...new Set((0, $7CnHa.chain)((x)=>x.issueTypeIds, projects))
    ];
const $99bdc172372b0d44$export$c276bc4d7b5b95e1 = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getCompanyManagedProjects)
], $99bdc172372b0d44$export$2d61f545ccc89c9e);
const $99bdc172372b0d44$export$d31015b408eb24 = (projects)=>projects.reduce((acc, project)=>{
        project.issueTypeIds.forEach((issueTypeId)=>{
            acc[issueTypeId] = project;
        });
        return acc;
    }, {});
const $99bdc172372b0d44$export$35747f0693c3c228 = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getTeamManagedProjects)
], $99bdc172372b0d44$export$d31015b408eb24);
const $99bdc172372b0d44$export$c21f9b5f8889e9a6 = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615,
    $99bdc172372b0d44$export$c276bc4d7b5b95e1
], (issueTypes, issueTypeIdsOfCompanyManagedProjects)=>{
    const issueTypesForCompanyManagedProjects = issueTypes.filter((issueType)=>issueTypeIdsOfCompanyManagedProjects.includes(issueType.id));
    return (0, $7CnHa.indexBy)(({ id: id })=>id, issueTypesForCompanyManagedProjects);
});
const $99bdc172372b0d44$export$2dc055bad16afadb = (issueTypes)=>issueTypes.reduce((acc, { level: level, name: name, iconUrl: iconUrl })=>{
        const currentIconUrl = acc[`${level} ${name}`];
        if (currentIconUrl === undefined || currentIconUrl.localeCompare(iconUrl) === 1) acc[`${level} ${name}`] = iconUrl;
        return acc;
    }, {});
const $99bdc172372b0d44$export$8696f212ec31e9f7 = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615
], $99bdc172372b0d44$export$2dc055bad16afadb);
const $99bdc172372b0d44$export$a9ecc8e21e9a38b0 = (issueTypes)=>{
    const issueTypeLevelAndIconByName = issueTypes.reduce((acc, { level: level, name: name, iconUrl: iconUrl })=>{
        const currentLevelAndIconUrl = acc[name];
        if (currentLevelAndIconUrl === undefined || level >= currentLevelAndIconUrl.level && currentLevelAndIconUrl.iconUrl.localeCompare(iconUrl) === 1) acc[name] = {
            level: level,
            iconUrl: iconUrl
        };
        return acc;
    }, {});
    return Object.entries(issueTypeLevelAndIconByName).reduce((acc, [name, { iconUrl: iconUrl }])=>{
        acc[name] = iconUrl;
        return acc;
    }, {});
};
const $99bdc172372b0d44$export$f67c89b26645faf6 = (0, $iK4oF.createSelector)([
    $99bdc172372b0d44$export$4cf4b24b88599615
], $99bdc172372b0d44$export$a9ecc8e21e9a38b0);

});

parcelRegister("frMqv", function(module, exports) {

$parcel$export(module.exports, "getTypeToLevelPure", () => $5202c8685d19d42c$export$3c4e701e817f6c92);
$parcel$export(module.exports, "getEnrichedHierarchyLevelsPure", () => $5202c8685d19d42c$export$61f53636045c576c);

var $2wtN3 = parcelRequire("2wtN3");
var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $8YqJS = parcelRequire("8YqJS");

var $7CnHa = parcelRequire("7CnHa");
const $5202c8685d19d42c$export$3c4e701e817f6c92 = (levels = [], issueTypes)=>{
    const issueTypesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueTypes);
    const typeToLevelMap = (0, $7CnHa.fromPairs)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (0, $7CnHa.chain)(({ level: level, issueTypes: issueTypes = [] })=>issueTypes.map((type)=>[
                type,
                level
            ]), levels));
    return (type)=>$2wtN3.default(issueTypesById[type] && issueTypesById[type].subTask === true ? (0, $8YqJS.SUB_TASK_LEVEL) : (0, $8YqJS.STORY_LEVEL), typeToLevelMap[type]);
};
const $5202c8685d19d42c$export$61f53636045c576c = (levels = [], issueTypes)=>{
    const typeToLevel = $5202c8685d19d42c$export$3c4e701e817f6c92(levels, issueTypes);
    const enriched = $cQGVO.default(({ level: level, title: title })=>({
            level: level,
            title: title,
            issueTypes: []
        }), levels);
    for (const type of issueTypes){
        const level = typeToLevel(type.id);
        const enrichedLevelIndex = enriched.findIndex((enrichedLevel)=>enrichedLevel.level === level);
        enriched[enrichedLevelIndex].issueTypes.push(type);
    }
    return enriched;
};

});



parcelRegister("eFzGj", function(module, exports) {

$parcel$export(module.exports, "getHierarchyRangeFilter", () => $a74e39b825e0fdef$export$e9935447b3518591);
$parcel$export(module.exports, "applyHierarchyRangeFilter", () => $a74e39b825e0fdef$export$713199788b3f01f0);

var $3l6tm = parcelRequire("3l6tm");

var $fZW8G = parcelRequire("fZW8G");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $a74e39b825e0fdef$export$cbede2dc3b8b4300 = (state)=>{
    const { value: value } = (0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5] || {};
    return {
        id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
        value: value
    };
};
const $a74e39b825e0fdef$export$7f7144ee25fd419b = (hierarchyFilter, hierarchyRange, isCalendarView)=>{
    const { min: min, max: max } = hierarchyRange;
    const currentValue = hierarchyFilter.value || {
        start: undefined,
        end: undefined
    };
    if (!(0, $7CnHa.isDefined)(currentValue.start)) currentValue.start = isCalendarView ? (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC) : max;
    if (!(0, $7CnHa.isDefined)(currentValue.end)) currentValue.end = isCalendarView ? (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_EPIC) : min;
    const clamp = (val, minValue, maxValue)=>Math.min(Math.max(val, minValue), maxValue);
    const clampedStart = clamp(currentValue.start, min, max);
    const clampedEnd = isCalendarView ? clampedStart : clamp(currentValue.end, min, clampedStart);
    const newValue = {
        start: clampedStart,
        end: clampedEnd
    };
    return {
        ...hierarchyFilter,
        value: newValue
    };
};
const $a74e39b825e0fdef$export$e9935447b3518591 = (0, $iK4oF.createSelector)([
    $a74e39b825e0fdef$export$cbede2dc3b8b4300,
    (0, $fZW8G.getHierarchyRange),
    (0, $9H2AP.getIsCalendarView)
], $a74e39b825e0fdef$export$7f7144ee25fd419b);
const $a74e39b825e0fdef$export$713199788b3f01f0 = (issue, filter)=>{
    const { start: start, end: end } = filter.value;
    return start >= issue.level && issue.level >= end;
};

});

parcelRegister("2vV9U", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $721905eebb16c8e7$export$1b001418845b471c);
$parcel$export(module.exports, "getIssuePrioritiesFilter", () => $721905eebb16c8e7$export$1d973cb7e23b6d1d);
$parcel$export(module.exports, "ISSUE_PRIORITIES_FILTER_ID", () => $12ee831723ccf9c2$export$b6fe2739dbbe2e5d);

var $V8UZp = parcelRequire("V8UZp");

var $jp3RH = parcelRequire("jp3RH");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $721905eebb16c8e7$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'priority', optimizedMode);
const $721905eebb16c8e7$export$f6da05142cfdf21d = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d] || {
        id: (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
        value: []
    };
const $721905eebb16c8e7$export$1d973cb7e23b6d1d = (0, $iK4oF.createSelector)([
    (0, $jp3RH.getIssuePriorities),
    $721905eebb16c8e7$export$f6da05142cfdf21d
], (issuePriorities, filter)=>{
    const { value: value = [] } = filter;
    const filteredIssuePriorities = value.filter((issuePriorityId)=>Object.values(issuePriorities).some(({ id: id })=>id === issuePriorityId));
    return {
        id: (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
        value: filteredIssuePriorities
    };
});

});
parcelRegister("jp3RH", function(module, exports) {

$parcel$export(module.exports, "getIssuePriorities", () => $44a7587bdc3734a3$export$98d3203068a2d313);
$parcel$export(module.exports, "getIssuePrioritiesById", () => $44a7587bdc3734a3$export$44140bf6dfd56211);
$parcel$export(module.exports, "getIssuePrioritiesIdList", () => $44a7587bdc3734a3$export$30b64fafed1a8d33);

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $44a7587bdc3734a3$export$98d3203068a2d313 = (state)=>state.domain.issuePriorities;
const $44a7587bdc3734a3$export$44140bf6dfd56211 = (0, $iK4oF.createSelector)([
    $44a7587bdc3734a3$export$98d3203068a2d313
], (issuePriorities)=>(0, $7CnHa.indexBy)(({ id: id })=>id, Object.values(issuePriorities)));
const $44a7587bdc3734a3$export$30b64fafed1a8d33 = (0, $iK4oF.createSelector)([
    $44a7587bdc3734a3$export$98d3203068a2d313
], (issuePriorities)=>{
    const issuePrioritiesIdList = Object.values(issuePriorities).sort((a, b)=>a.sequence - b.sequence).map(({ id: id })=>id);
    return issuePrioritiesIdList.length ? issuePrioritiesIdList : null;
});

});


parcelRegister("gqs5m", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $d0f35d38afc09a2a$export$1b001418845b471c);
$parcel$export(module.exports, "getIssueTypeKeyFilterValue", () => $d0f35d38afc09a2a$export$68fbb55423a6c5a4);
$parcel$export(module.exports, "getIssueTypeKeyFilter", () => $d0f35d38afc09a2a$export$16acaef7acc9fa68);
$parcel$export(module.exports, "ISSUE_TYPE_KEY_FILTER_ID", () => $12ee831723ccf9c2$export$a8ec3260a009d752);

var $fZW8G = parcelRequire("fZW8G");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $V8UZp = parcelRequire("V8UZp");

var $9Y8IZ = parcelRequire("9Y8IZ");
const $d0f35d38afc09a2a$export$1b001418845b471c = (issue, { value: value }, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, value, 'type', optimizedMode);
const $d0f35d38afc09a2a$var$getNewIssueTypeFilterValues = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFiltersViewSettings)
], ({ [(0, $12ee831723ccf9c2$export$a8ec3260a009d752)]: filter })=>filter?.value ?? []);
const $d0f35d38afc09a2a$var$getOldIssueTypeFilterValues = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFiltersViewSettings)
], ({ [(0, $12ee831723ccf9c2$export$ef1873c24394b0a7)]: filter })=>filter?.value ?? []);
const $d0f35d38afc09a2a$export$68fbb55423a6c5a4 = (0, $iK4oF.createSelector)([
    $d0f35d38afc09a2a$var$getOldIssueTypeFilterValues,
    $d0f35d38afc09a2a$var$getNewIssueTypeFilterValues,
    (0, $fZW8G.getIssueTypeWithLevelById)
], (0, $9Y8IZ.getIssueTypeKeyValuesPure));
const $d0f35d38afc09a2a$export$16acaef7acc9fa68 = (0, $iK4oF.createSelector)([
    $d0f35d38afc09a2a$export$68fbb55423a6c5a4,
    (0, $fZW8G.getIssueTypesByLevel)
], (0, $9Y8IZ.getIssueTypeKeyFilterPure));

});
parcelRegister("9Y8IZ", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeKeyValuesPure", () => $dd01a4a97781b98d$export$977ae805a1ff1ddc);
$parcel$export(module.exports, "getIssueTypeKeyFilterPure", () => $dd01a4a97781b98d$export$b34f9f337ddcb9e9);

const $dd01a4a97781b98d$var$issueTypeIdsToIssueTypeKeys = (issueTypeIds, issueTypesById)=>{
    const issueTypeNamesByLevel = issueTypeIds.reduce((acc, id)=>{
        const issueType = issueTypesById[id];
        if (issueType !== undefined) {
            const names = acc[issueType.level];
            if (names !== undefined) names.add(issueType.name);
            else {
                const newNames = new Set();
                newNames.add(issueType.name);
                acc[issueType.level] = newNames;
            }
        }
        return acc;
    }, {});
    return Object.entries(issueTypeNamesByLevel).reduce((acc, [level, names])=>{
        names.forEach((name)=>acc.push({
                level: Number(level),
                name: name
            }));
        return acc;
    }, []);
};
const $dd01a4a97781b98d$var$issueTypeKeysToIssueTypeIds = (issueTypeKeys, issueTypesByHierarchy)=>issueTypeKeys.reduce((acc, { level: level, name: keyName })=>{
        const issueTypesMatchingLevelAndName = (issueTypesByHierarchy[level] ?? []).filter(({ name: name })=>name === keyName);
        return acc.concat(issueTypesMatchingLevelAndName.map(({ id: id })=>id));
    }, []);
const $dd01a4a97781b98d$export$977ae805a1ff1ddc = (oldIssueTypeFilterValue, newIssueTypeKeyFilterValue, issueTypesById)=>{
    if (newIssueTypeKeyFilterValue.length > 0) return newIssueTypeKeyFilterValue;
    // transform to issue type ids to keys (aggregated)
    return $dd01a4a97781b98d$var$issueTypeIdsToIssueTypeKeys(oldIssueTypeFilterValue, issueTypesById);
};
const $dd01a4a97781b98d$export$b34f9f337ddcb9e9 = (issueTypeKeyValue, issueTypesByHierarchy)=>({
        id: (0, $12ee831723ccf9c2$export$ef1873c24394b0a7),
        value: $dd01a4a97781b98d$var$issueTypeKeysToIssueTypeIds(issueTypeKeyValue, issueTypesByHierarchy)
    });

});


parcelRegister("Z7Mx2", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $563844f0f3369d79$export$1b001418845b471c);
$parcel$export(module.exports, "getIssueWarningFilter", () => $563844f0f3369d79$export$dc6e663d6e389fd9);

var $1ybV0 = parcelRequire("1ybV0");

var $V8UZp = parcelRequire("V8UZp");

var $9H2AP = parcelRequire("9H2AP");

var $YHQpz = parcelRequire("YHQpz");


var $iK4oF = parcelRequire("iK4oF");
const $563844f0f3369d79$export$1b001418845b471c = (issue, { value: value, issueIdsWithWarnings: issueIdsWithWarnings })=>{
    if (!(0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k')) return true;
    if (value.length === 0) return true;
    if (!issueIdsWithWarnings.length) return false;
    return (0, $V8UZp.applyFilter)(issue, issueIdsWithWarnings, 'id');
};
const $563844f0f3369d79$export$8911a9f6301ebc3d = (filterSate)=>filterSate[0, $12ee831723ccf9c2$export$59af687b450af7eb]?.value ?? [];
const $563844f0f3369d79$var$getIssueWarningFilterValue = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFiltersViewSettings)
], $563844f0f3369d79$export$8911a9f6301ebc3d);
const $563844f0f3369d79$export$3221b5007fc3ddc8 = (warningIssueHash, value)=>{
    const issueIdsWithWarnings = [];
    const filteredWarnings = new Set(value);
    for (const [issueId, warnings] of Object.entries(warningIssueHash))if (warnings.some((warning)=>filteredWarnings.has(warning.type))) issueIdsWithWarnings.push(issueId);
    return {
        id: (0, $12ee831723ccf9c2$export$59af687b450af7eb),
        value: (0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? value : [],
        issueIdsWithWarnings: issueIdsWithWarnings
    };
};
const $563844f0f3369d79$export$dc6e663d6e389fd9 = (0, $iK4oF.createSelector)([
    (0, $YHQpz.getAllWarningsIssueHash),
    $563844f0f3369d79$var$getIssueWarningFilterValue
], $563844f0f3369d79$export$3221b5007fc3ddc8);

});
parcelRegister("YHQpz", function(module, exports) {

$parcel$export(module.exports, "getWarnings", () => $23ff646058b7cc06$export$86d329c847012ae2);
$parcel$export(module.exports, "getAllWarningsIssueHash", () => $23ff646058b7cc06$export$b57778db38fddaef);
$parcel$export(module.exports, "getWarningsCount", () => $23ff646058b7cc06$export$20f02d6376cfe718);
$parcel$export(module.exports, "getAggregatedWarnings", () => $23ff646058b7cc06$export$eb155605f8c3215b);
$parcel$export(module.exports, "getIssueIdsWithWarnings", () => $23ff646058b7cc06$export$8b9894fc22f2f295);
$parcel$export(module.exports, "getDisabledWarnings", () => $23ff646058b7cc06$export$7f31179b1c3042fc);

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
const $23ff646058b7cc06$export$86d329c847012ae2 = (state)=>state.domain.warnings;
const $23ff646058b7cc06$export$b57778db38fddaef = (state)=>state.domain.warnings.allWarningsByIssue ?? {};
const $23ff646058b7cc06$export$9fa94caae031b9ff = (warnings)=>{
    const issueIds = Object.keys(warnings.byIssue);
    return issueIds.length ? [
        ...issueIds,
        ...warnings.transitiveIssueIds
    ] : [];
};
const $23ff646058b7cc06$export$20f02d6376cfe718 = (0, $iK4oF.createSelector)([
    $23ff646058b7cc06$export$86d329c847012ae2
], (warnings)=>Object.values(warnings.byIssue).reduce((acc, value)=>{
        // eslint-disable-next-line no-param-reassign
        acc += value.length;
        return acc;
    }, 0));
const $23ff646058b7cc06$export$b2df6730bf20ee08 = (warnings)=>{
    const byType = {};
    for (const [issueId, value] of Object.entries(warnings.byIssue)){
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const warnings = value;
        for (const warning of warnings){
            const type = warning.type;
            if (!byType[type]) byType[type] = [];
            byType[type].push(issueId);
        }
    }
    return byType;
};
const $23ff646058b7cc06$export$eb155605f8c3215b = (0, $iK4oF.createSelector)([
    $23ff646058b7cc06$export$86d329c847012ae2
], $23ff646058b7cc06$export$b2df6730bf20ee08);
const $23ff646058b7cc06$export$8b9894fc22f2f295 = (0, $iK4oF.createSelector)([
    $23ff646058b7cc06$export$86d329c847012ae2
], $23ff646058b7cc06$export$9fa94caae031b9ff);
const $23ff646058b7cc06$export$7f31179b1c3042fc = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getWarningViewSettings)
], (warningViewSettings)=>warningViewSettings.disabledWarnings);

});


parcelRegister("5Rz3d", function(module, exports) {

$parcel$export(module.exports, "NO_LABEL_ID", () => $670d66de91c1f20a$export$a8155a8d6b3722d6);
$parcel$export(module.exports, "applyFilter", () => $670d66de91c1f20a$export$1b001418845b471c);
$parcel$export(module.exports, "getLabelFilter", () => $670d66de91c1f20a$export$7947209750252631);
$parcel$export(module.exports, "LABEL_FILTER_ID", () => $12ee831723ccf9c2$export$7e257b719377371e);

var $V8UZp = parcelRequire("V8UZp");

var $94enn = parcelRequire("94enn");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $670d66de91c1f20a$export$a8155a8d6b3722d6 = (0, $5rYNM.UNDEFINED_KEY);
const $670d66de91c1f20a$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'labels', optimizedMode);
const $670d66de91c1f20a$export$367a351aa5ad067f = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$7e257b719377371e] || {
        id: (0, $12ee831723ccf9c2$export$7e257b719377371e),
        value: []
    };
const $670d66de91c1f20a$export$7947209750252631 = (0, $iK4oF.createSelector)([
    (0, $94enn.getIssueLabels),
    $670d66de91c1f20a$export$367a351aa5ad067f
], (issueLabels, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const existingLabels = value.filter((label)=>issueLabels.some((issueLabel)=>issueLabel === label) || label === $670d66de91c1f20a$export$a8155a8d6b3722d6);
    return {
        id: (0, $12ee831723ccf9c2$export$7e257b719377371e),
        value: existingLabels
    };
});

});
parcelRegister("94enn", function(module, exports) {

$parcel$export(module.exports, "getIssueLabels", () => $73f4d72629470564$export$424a50dfd4d5b981);
const $73f4d72629470564$export$424a50dfd4d5b981 = (state)=>state.domain.issueLabels;

});


parcelRegister("68BNT", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $6be9fc62a0bea564$export$1b001418845b471c);
$parcel$export(module.exports, "getProjectFilter", () => $6be9fc62a0bea564$export$4939fc722e810d76);
$parcel$export(module.exports, "getFilteredProjects", () => $6be9fc62a0bea564$export$dd7c4fe962efad41);
$parcel$export(module.exports, "PROJECT_FILTER_ID", () => $12ee831723ccf9c2$export$d0da0a0b0cd817d8);

var $V8UZp = parcelRequire("V8UZp");

var $ehEr2 = parcelRequire("ehEr2");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $6be9fc62a0bea564$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'project', optimizedMode);
const $6be9fc62a0bea564$export$5d95a6a4ccb5cadb = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8] || {
        id: (0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8),
        value: []
    };
const $6be9fc62a0bea564$export$4939fc722e810d76 = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjects),
    $6be9fc62a0bea564$export$5d95a6a4ccb5cadb
], (projects, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const filteredProjects = value.filter((projectId)=>projects.some(({ id: id })=>id === projectId));
    return {
        id: (0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8),
        value: filteredProjects
    };
});
const $6be9fc62a0bea564$export$48773ecb6624dbb4 = (projects, { value: value })=>projects.filter(({ id: id })=>value.length === 0 || value.includes(id));
const $6be9fc62a0bea564$export$dd7c4fe962efad41 = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjects),
    $6be9fc62a0bea564$export$4939fc722e810d76
], $6be9fc62a0bea564$export$48773ecb6624dbb4);

});

parcelRegister("3nT5G", function(module, exports) {

$parcel$export(module.exports, "NO_RELEASE_ID", () => $7209e54257ef4a27$export$94e199d2d0bac60a);
$parcel$export(module.exports, "applyFilter", () => $7209e54257ef4a27$export$1b001418845b471c);
$parcel$export(module.exports, "getReleaseFilterPure", () => $7209e54257ef4a27$export$1cc314758e6c1f41);
$parcel$export(module.exports, "getReleaseFilter", () => $7209e54257ef4a27$export$6c10eb7bc4b783e);
$parcel$export(module.exports, "RELEASE_FILTER_ID", () => $12ee831723ccf9c2$export$53e2f8996e102881);

var $V8UZp = parcelRequire("V8UZp");

var $38iYP = parcelRequire("38iYP");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $7209e54257ef4a27$export$94e199d2d0bac60a = (0, $5rYNM.UNDEFINED_KEY);
const $7209e54257ef4a27$export$852eff6db828121c = 'EMPTY_CPR_ID';
const $7209e54257ef4a27$export$1b001418845b471c = (issue, filter, optimizedMode)=>{
    const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = filter;
    const filterValue = (0, $7CnHa.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
        ...value,
        ...versionsFromCrossProjectReleaseFilterValue
    ] : value;
    return (0, $V8UZp.applyFilter)(issue, filterValue, 'fixVersions', optimizedMode);
};
const $7209e54257ef4a27$export$1cc314758e6c1f41 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$53e2f8996e102881] || {
        id: (0, $12ee831723ccf9c2$export$53e2f8996e102881),
        value: []
    };
const $7209e54257ef4a27$export$6c10eb7bc4b783e = (0, $iK4oF.createSelector)([
    (0, $wcCGG.getVersions),
    (0, $38iYP.getCrossProjectReleaseFilter),
    $7209e54257ef4a27$export$1cc314758e6c1f41
], (versions, crossProjectReleaseFilter, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const filteredVersions = value.filter((versionId)=>versions.some(({ id: id })=>id === versionId) || versionId === $7209e54257ef4a27$export$94e199d2d0bac60a);
    const { crossProjectVersionsById: crossProjectVersionsById = {}, value: crossProjectReleaseFilterValue = [] } = crossProjectReleaseFilter;
    const versionsFromCrossProjectReleaseFilterValue = crossProjectReleaseFilterValue.reduce((acc, cprId)=>{
        const crossProjectVersion = crossProjectVersionsById[cprId];
        if (crossProjectVersion) acc.push(...crossProjectVersion.versions);
        return acc;
    }, []);
    if (crossProjectReleaseFilterValue.length !== 0 && versionsFromCrossProjectReleaseFilterValue.length === 0) versionsFromCrossProjectReleaseFilterValue.push($7209e54257ef4a27$export$852eff6db828121c);
    return {
        id: (0, $12ee831723ccf9c2$export$53e2f8996e102881),
        value: filteredVersions,
        versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue
    };
});

});

parcelRegister("f436g", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $a715f2ae26137ef2$export$1b001418845b471c);
$parcel$export(module.exports, "getReporterForFilter", () => $a715f2ae26137ef2$export$c7d736d901652cb8);
$parcel$export(module.exports, "getReporterFilter", () => $a715f2ae26137ef2$export$88d268cefa9b9990);
$parcel$export(module.exports, "REPORTER_FILTER_ID", () => $12ee831723ccf9c2$export$20140793a0aa2b3c);

var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");
var $egiDP = parcelRequire("egiDP");

var $V8UZp = parcelRequire("V8UZp");

var $KA559 = parcelRequire("KA559");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");
const $a715f2ae26137ef2$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'reporter', optimizedMode);
const $a715f2ae26137ef2$export$c7d736d901652cb8 = (0, $iK4oF.createSelector)([
    (0, $KA559.getUniqueReportersOfIssues)
], (issuesReporters)=>$egiDP.default($f7Op5.default('personId'))([
        ...issuesReporters
    ]));
const $a715f2ae26137ef2$export$c2ef75efa427967 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$20140793a0aa2b3c] || {
        id: (0, $12ee831723ccf9c2$export$20140793a0aa2b3c),
        value: []
    };
const $a715f2ae26137ef2$export$88d268cefa9b9990 = (0, $iK4oF.createSelector)([
    $a715f2ae26137ef2$export$c7d736d901652cb8,
    $a715f2ae26137ef2$export$c2ef75efa427967
], (reporters, { id: id, value: value = [] })=>{
    const reporterSet = new Set($cQGVO.default($f7Op5.default('personId'), reporters));
    return {
        id: id,
        value: value.filter((personId)=>reporterSet.has(personId))
    };
});

});
parcelRegister("KA559", function(module, exports) {

$parcel$export(module.exports, "getIssueReporterMap", () => $8e340d6fb1cdb569$export$42587cd54d399808);
$parcel$export(module.exports, "getUniqueReportersOfIssues", () => $8e340d6fb1cdb569$export$13c1420a9d57662e);
$parcel$export(module.exports, "getReportersById", () => $8e340d6fb1cdb569$export$9771ac378c0c93c6);

var $f7Op5 = parcelRequire("f7Op5");

var $cwP4d = parcelRequire("cwP4d");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $8e340d6fb1cdb569$export$42587cd54d399808 = (state)=>state.domain.reporters.issueReporterMap;
const $8e340d6fb1cdb569$export$6cade5530a24c0d4 = (issues, reporterMapByIssueId)=>{
    const reporters = new Set();
    issues.forEach((issue)=>{
        const reporterPerson = reporterMapByIssueId[issue.id];
        if (reporterPerson) reporters.add(reporterPerson);
    });
    return Array.from(reporters);
};
const $8e340d6fb1cdb569$export$13c1420a9d57662e = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    $8e340d6fb1cdb569$export$42587cd54d399808
], $8e340d6fb1cdb569$export$6cade5530a24c0d4);
const $8e340d6fb1cdb569$export$9771ac378c0c93c6 = (0, $iK4oF.createSelector)([
    $8e340d6fb1cdb569$export$13c1420a9d57662e
], (reporter)=>(0, $7CnHa.indexBy)($f7Op5.default('personId'), reporter));

});


parcelRegister("7hbkF", function(module, exports) {

$parcel$export(module.exports, "NO_SPRINT_ID", () => $c09328dcd5d91c80$export$43e4bd26116c3832);
$parcel$export(module.exports, "applyFilter", () => $c09328dcd5d91c80$export$1b001418845b471c);
$parcel$export(module.exports, "getSprintFilter", () => $c09328dcd5d91c80$export$d63c00efb8ec5b93);
$parcel$export(module.exports, "SPRINT_FILTER_ID", () => $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb);

var $853IT = parcelRequire("853IT");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $c09328dcd5d91c80$export$43e4bd26116c3832 = (0, $5rYNM.UNDEFINED_KEY);
const $c09328dcd5d91c80$export$1b001418845b471c = (issue, { value: value })=>{
    if (value.length === 0) return true;
    const filterSprints = new Set(value);
    const issueSprints = [
        ...issue.completedSprints || [],
        issue.sprint
    ].filter((0, $7CnHa.isDefined));
    if (filterSprints.has($c09328dcd5d91c80$export$43e4bd26116c3832) && issueSprints.length === 0) return true;
    filterSprints.delete($c09328dcd5d91c80$export$43e4bd26116c3832);
    return issueSprints.some((id)=>filterSprints.has(id));
};
const $c09328dcd5d91c80$export$10eeae1e8c2ca5bc = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb] || {
        id: (0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb),
        value: []
    };
const $c09328dcd5d91c80$export$d63c00efb8ec5b93 = (0, $iK4oF.createSelector)([
    (0, $853IT.getSprints),
    (0, $853IT.getExternalSprints),
    $c09328dcd5d91c80$export$10eeae1e8c2ca5bc
], (sprints, externalSprints, { value: value = [] })=>{
    const sprintsInPlan = new Set([
        ...sprints,
        ...externalSprints
    ].map((x)=>x.id));
    const existingSprints = value.filter((sprintId)=>sprintsInPlan.has(sprintId) || sprintId === $c09328dcd5d91c80$export$43e4bd26116c3832);
    return {
        id: (0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb),
        value: existingSprints
    };
});

});

parcelRegister("5mAJ1", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $7fcdb62c35f60b2d$export$1b001418845b471c);
$parcel$export(module.exports, "getStatusKeyFilterValue", () => $7fcdb62c35f60b2d$export$e16c6fcb26f91d3e);
$parcel$export(module.exports, "getStatusKeyFilterOptionsByCategory", () => $7fcdb62c35f60b2d$export$a29aeec6e1389748);
$parcel$export(module.exports, "getAllStatusKeyOfCategoryChecked", () => $7fcdb62c35f60b2d$export$d25277796925c242);
$parcel$export(module.exports, "getStatusKeyFilter", () => $7fcdb62c35f60b2d$export$472e823661b0066e);
$parcel$export(module.exports, "STATUS_KEY_FILTER_ID", () => $12ee831723ccf9c2$export$9b51ec1115932c53);
$parcel$export(module.exports, "UNSAVED_STATUS", () => (parcelRequire("7YjYY")).UNSAVED_STATUS);

var $kFf60 = parcelRequire("kFf60");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $44SvN = parcelRequire("44SvN");

var $V8UZp = parcelRequire("V8UZp");

var $7YjYY = parcelRequire("7YjYY");
const $7fcdb62c35f60b2d$export$1b001418845b471c = (issue, { value: value }, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, value, 'status', optimizedMode);
const $7fcdb62c35f60b2d$var$getOldStatusFilterValue = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFiltersViewSettings)
], (filters)=>{
    const statusFilters = filters[0, $12ee831723ccf9c2$export$e3608e8ffa9df136];
    return statusFilters?.value ?? [];
});
const $7fcdb62c35f60b2d$var$getNewStatusKeyFilterValue = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFiltersViewSettings)
], (filters)=>{
    const statusKeyFilters = filters[0, $12ee831723ccf9c2$export$9b51ec1115932c53];
    return statusKeyFilters?.value ?? [];
});
const $7fcdb62c35f60b2d$export$e16c6fcb26f91d3e = (0, $iK4oF.createSelector)([
    (0, $kFf60.getIssueStatusById),
    $7fcdb62c35f60b2d$var$getOldStatusFilterValue,
    $7fcdb62c35f60b2d$var$getNewStatusKeyFilterValue
], (0, $7YjYY.getStatusKeyFilterValuePure));
const $7fcdb62c35f60b2d$export$a29aeec6e1389748 = (0, $iK4oF.createSelector)([
    (0, $kFf60.getIssueStatuses),
    (0, $44SvN.getCategoryNameById)
], (0, $7YjYY.getStatusKeyFilterOptionsByCategoryPure));
const $7fcdb62c35f60b2d$export$d25277796925c242 = (0, $iK4oF.createSelector)([
    $7fcdb62c35f60b2d$export$e16c6fcb26f91d3e,
    $7fcdb62c35f60b2d$export$a29aeec6e1389748,
    (0, $44SvN.getCategoryNameById)
], (0, $7YjYY.getIsAllStatusKeyOfCategorySelectedPure));
const $7fcdb62c35f60b2d$export$472e823661b0066e = (0, $iK4oF.createSelector)([
    (0, $kFf60.getIssueStatusById),
    (0, $kFf60.getIssueStatusByKey),
    $7fcdb62c35f60b2d$var$getOldStatusFilterValue,
    $7fcdb62c35f60b2d$var$getNewStatusKeyFilterValue
], (0, $7YjYY.getStatusKeyFilterPure));

});
parcelRegister("44SvN", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryById", () => $1608fafcb2a5cd6e$export$27be3f1f634c6db8);
$parcel$export(module.exports, "getCategoryNameById", () => $1608fafcb2a5cd6e$export$90d9bee9a9c242be);

var $df4Sl = parcelRequire("df4Sl");

var $f7Op5 = parcelRequire("f7Op5");

var $7CnHa = parcelRequire("7CnHa");
const $1608fafcb2a5cd6e$export$29350702a509e1b9 = (state)=>state.domain.issueStatusCategories;
const $1608fafcb2a5cd6e$export$27be3f1f634c6db8 = (state)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), state.domain.issueStatusCategories);
const $1608fafcb2a5cd6e$export$90d9bee9a9c242be = (0, $df4Sl.createSelector)([
    $1608fafcb2a5cd6e$export$29350702a509e1b9
], (statusCategories)=>new Map(statusCategories.map(({ id: id, name: name })=>[
            `${id}`,
            name
        ])));

});

parcelRegister("7YjYY", function(module, exports) {

$parcel$export(module.exports, "getStatusKeyFilterValuePure", () => $a8ed0c7d8dbae1bd$export$21d86fd023fcea16);
$parcel$export(module.exports, "UNSAVED_STATUS", () => $a8ed0c7d8dbae1bd$export$6ffc1063451c988d);
$parcel$export(module.exports, "getStatusKeyFilterOptionsByCategoryPure", () => $a8ed0c7d8dbae1bd$export$976ea5918c04a147);
$parcel$export(module.exports, "getIsAllStatusKeyOfCategorySelectedPure", () => $a8ed0c7d8dbae1bd$export$3c1dd3a395fc993a);
$parcel$export(module.exports, "getStatusKeyFilterPure", () => $a8ed0c7d8dbae1bd$export$5fc99df4db8f9996);

var $fcWBJ = parcelRequire("fcWBJ");

var $hTLlD = parcelRequire("hTLlD");

var $MdoH4 = parcelRequire("MdoH4");

var $biByU = parcelRequire("biByU");


var $5rYNM = parcelRequire("5rYNM");
const $a8ed0c7d8dbae1bd$var$statusIdToStatusKey = (issueStatusById, statusIds)=>{
    const statusKeys = statusIds.reduce((acc, statusId)=>{
        const status = issueStatusById[statusId];
        if (status !== undefined) acc.push({
            category: `${status.categoryId}`,
            name: status.name
        });
        return acc;
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($biByU)))(statusKeys, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
};
const $a8ed0c7d8dbae1bd$export$21d86fd023fcea16 = (issueStatusById, oldStatusFilterValue, newStatusKeyFilterValue)=>{
    if (newStatusKeyFilterValue.length > 0) return newStatusKeyFilterValue;
    return $a8ed0c7d8dbae1bd$var$statusIdToStatusKey(issueStatusById, oldStatusFilterValue);
};
const $a8ed0c7d8dbae1bd$export$6ffc1063451c988d = {
    id: (0, $5rYNM.UNDEFINED_KEY),
    categoryId: 2,
    name: 'UNSAVED'
};
const $a8ed0c7d8dbae1bd$export$976ea5918c04a147 = (statuses, categoryNameById)=>{
    const statusByCategory = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(statuses, ({ categoryId: categoryId })=>`${categoryId}`);
    const result = new Map();
    for (const categoryId of categoryNameById.keys()){
        const statusNames = (statusByCategory[categoryId] ?? []).map(({ name: name })=>name);
        // manually add UNSAVED_STATUS as part of "To do" category
        if (categoryId === `${$a8ed0c7d8dbae1bd$export$6ffc1063451c988d.categoryId}`) statusNames.push($a8ed0c7d8dbae1bd$export$6ffc1063451c988d.name);
        if (statusNames.length > 0) result.set(categoryId, (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(statusNames));
    }
    return result;
};
const $a8ed0c7d8dbae1bd$export$3c1dd3a395fc993a = (selectedStatusKeys, statusNamesByCategory, categoryNameById)=>{
    const result = {};
    for (const categoryId of categoryNameById.keys()){
        const allStatusNamesOfCategory = statusNamesByCategory.get(categoryId) ?? [];
        const selectedStatusNamesOfCategory = allStatusNamesOfCategory.filter((statusName)=>selectedStatusKeys.find(({ category: category, name: name })=>category === categoryId && name === statusName) !== undefined);
        if (allStatusNamesOfCategory.length === 0 || selectedStatusNamesOfCategory.length === 0) result[categoryId] = (0, $5rYNM.CHECKBOX_STATES).UNCHECKED;
        else if (allStatusNamesOfCategory.length === selectedStatusNamesOfCategory.length) result[categoryId] = (0, $5rYNM.CHECKBOX_STATES).CHECKED;
        else result[categoryId] = (0, $5rYNM.CHECKBOX_STATES).INDETERMINATE;
    }
    return result;
};
const $a8ed0c7d8dbae1bd$var$statusIdFromStatusKey = (issueStatusByKey, statusKeys)=>statusKeys.map(({ category: category, name: name })=>issueStatusByKey[`${category} ${name}`]?.map(({ id: id })=>id) ?? []).flat();
const $a8ed0c7d8dbae1bd$export$5fc99df4db8f9996 = (issueStatusById, issueStatusByKey, oldStatusFilterValue, newStatusKeyFilterValue)=>{
    if (newStatusKeyFilterValue.length > 0) {
        // need to add custom UNSAVED status manually as it won't exist in the issueStatusById mapping
        const containsUnsavedStatus = newStatusKeyFilterValue.some(({ category: category, name: name })=>category === `${$a8ed0c7d8dbae1bd$export$6ffc1063451c988d.categoryId}` && name === $a8ed0c7d8dbae1bd$export$6ffc1063451c988d.name);
        return {
            // the id is not important
            id: (0, $12ee831723ccf9c2$export$e3608e8ffa9df136),
            value: (containsUnsavedStatus ? [
                $a8ed0c7d8dbae1bd$export$6ffc1063451c988d.id
            ] : []).concat($a8ed0c7d8dbae1bd$var$statusIdFromStatusKey(issueStatusByKey, newStatusKeyFilterValue))
        };
    }
    const containsUnsavedStatus = oldStatusFilterValue.some((id)=>id === $a8ed0c7d8dbae1bd$export$6ffc1063451c988d.id);
    return {
        id: (0, $12ee831723ccf9c2$export$e3608e8ffa9df136),
        // transform to key and then back to id to include ALL statuses of that category
        // otherwise, only _partial_ statuses of a category will be filtered
        value: (containsUnsavedStatus ? [
            $a8ed0c7d8dbae1bd$export$6ffc1063451c988d.id
        ] : []).concat($a8ed0c7d8dbae1bd$var$statusIdFromStatusKey(issueStatusByKey, $a8ed0c7d8dbae1bd$var$statusIdToStatusKey(issueStatusById, oldStatusFilterValue)))
    };
};

});
parcelRegister("biByU", function(module, exports) {

var $42tFs = parcelRequire("42tFs");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $839e83316547a995$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $42tFs(array, undefined, comparator) : [];
}
module.exports = $839e83316547a995$var$uniqWith;

});



parcelRegister("77IHm", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $e659266e77242005$export$1b001418845b471c);
$parcel$export(module.exports, "getSummaryFilter", () => $e659266e77242005$export$3e1a3421edad933);
$parcel$export(module.exports, "SUMMARY_FILTER_ID", () => $12ee831723ccf9c2$export$e32eeae4866f112c);

var $ehEr2 = parcelRequire("ehEr2");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $e659266e77242005$export$1b001418845b471c = (issue, filter)=>{
    const { queries: queries, projectsById: projectsById = {} } = filter;
    const { summary: summary = '', issueKey: issueKey = '', project: project } = issue;
    if (queries.length === 0) return true;
    let title = `${issueKey} ${summary}`;
    if ((0, $7CnHa.isDefined)(project)) {
        const projectDetails = projectsById[project];
        if ((0, $7CnHa.isDefined)(projectDetails)) {
            const projectKey = projectDetails.key;
            title = `${projectKey}-${issueKey} ${summary}`;
        }
    }
    title = title.toLowerCase();
    return queries.some((term)=>title.includes(term));
};
const $e659266e77242005$export$1886090eaf2edb60 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$e32eeae4866f112c] || {
        id: (0, $12ee831723ccf9c2$export$e32eeae4866f112c),
        value: ''
    };
const $e659266e77242005$export$b7b2a481b84622e6 = (query)=>(query.match(/[^,;]+/g) || []).map((x)=>x.trim().toLowerCase()).filter((x)=>x.length > 0);
const $e659266e77242005$export$3e1a3421edad933 = (0, $iK4oF.createSelector)([
    $e659266e77242005$export$1886090eaf2edb60,
    (0, $ehEr2.getProjectsById)
], ({ value: value = '' }, projectsById)=>({
        id: (0, $12ee831723ccf9c2$export$e32eeae4866f112c),
        value: value,
        queries: $e659266e77242005$export$b7b2a481b84622e6(value),
        projectsById: projectsById
    }));

});

parcelRegister("3Fte6", function(module, exports) {

$parcel$export(module.exports, "NO_TEAM_ID", () => $5f6e2e6f4494cd90$export$53782b65600ab96d);
$parcel$export(module.exports, "applyFilter", () => $5f6e2e6f4494cd90$export$1b001418845b471c);
$parcel$export(module.exports, "getTeamsFilterPure", () => $5f6e2e6f4494cd90$export$b64e4243796e514a);
$parcel$export(module.exports, "getTeamFilter", () => $5f6e2e6f4494cd90$export$5f62ef45898119c1);
$parcel$export(module.exports, "TEAM_FILTER_ID", () => $12ee831723ccf9c2$export$8abe69ceb26771cd);

var $V8UZp = parcelRequire("V8UZp");

var $MQRDu = parcelRequire("MQRDu");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $5f6e2e6f4494cd90$export$53782b65600ab96d = (0, $5rYNM.UNDEFINED_KEY);
const $5f6e2e6f4494cd90$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'team', optimizedMode);
const $5f6e2e6f4494cd90$export$b64e4243796e514a = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$8abe69ceb26771cd] || {
        id: (0, $12ee831723ccf9c2$export$8abe69ceb26771cd),
        value: []
    };
const $5f6e2e6f4494cd90$export$5f62ef45898119c1 = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams),
    $5f6e2e6f4494cd90$export$b64e4243796e514a
], (teams, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const filteredTeams = value.filter((teamId)=>teams.some(({ id: id })=>id === teamId) || teamId === $5f6e2e6f4494cd90$export$53782b65600ab96d);
    return {
        id: (0, $12ee831723ccf9c2$export$8abe69ceb26771cd),
        value: filteredTeams
    };
});

});

parcelRegister("kahmZ", function(module, exports) {

$parcel$export(module.exports, "applyFilter", () => $e5384d9c3d2ded84$export$1b001418845b471c);
$parcel$export(module.exports, "getWarningFilter", () => $e5384d9c3d2ded84$export$3d6eb7784d00480e);
$parcel$export(module.exports, "WARNING_FILTER_ID", () => $12ee831723ccf9c2$export$d6f1616882408daa);

var $1ybV0 = parcelRequire("1ybV0");

var $V8UZp = parcelRequire("V8UZp");

var $9H2AP = parcelRequire("9H2AP");

var $YHQpz = parcelRequire("YHQpz");


var $iK4oF = parcelRequire("iK4oF");
const $e5384d9c3d2ded84$export$1b001418845b471c = (issue, { value: value, issueIdsWithWarnings: issueIdsWithWarnings })=>{
    if ((0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k')) return true;
    if (value && !issueIdsWithWarnings.length) return false;
    return !value || (0, $V8UZp.applyFilter)(issue, issueIdsWithWarnings, 'id');
};
const $e5384d9c3d2ded84$export$11af7bd59c0de6a5 = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$d6f1616882408daa] || {
        id: (0, $12ee831723ccf9c2$export$d6f1616882408daa),
        issueIdsWithWarnings: [],
        value: false
    };
const $e5384d9c3d2ded84$export$3d6eb7784d00480e = (0, $iK4oF.createSelector)([
    (0, $YHQpz.getIssueIdsWithWarnings),
    $e5384d9c3d2ded84$export$11af7bd59c0de6a5
], (issueIdsWithWarnings, pureFilter)=>{
    const { value: value } = pureFilter;
    return {
        id: (0, $12ee831723ccf9c2$export$d6f1616882408daa),
        value: (0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? false : value,
        issueIdsWithWarnings: issueIdsWithWarnings
    };
});

});


parcelRegister("aK3ri", function(module, exports) {

$parcel$export(module.exports, "getChildrenByParentPure", () => $53a69b23fbb2f139$export$cfcbda58efe6fed9);
$parcel$export(module.exports, "getChildrenByParent", () => $53a69b23fbb2f139$export$65544d51bd5cdae8);
$parcel$export(module.exports, "getChildrenIdsByParent", () => $53a69b23fbb2f139$export$da55948f2286493c);
$parcel$export(module.exports, "getDescendants", () => $53a69b23fbb2f139$export$d607bcb6675e3e03);
$parcel$export(module.exports, "getDescendantsByParent", () => $53a69b23fbb2f139$export$3a123be6fa1e1089);
$parcel$export(module.exports, "getRollupMap", () => $53a69b23fbb2f139$export$61e0876ed41cdcfd);

var $fpul1 = parcelRequire("fpul1");
var $eirae = parcelRequire("eirae");
var $jPCDz = parcelRequire("jPCDz");
var $kDrtX = parcelRequire("kDrtX");
var $cQGVO = parcelRequire("cQGVO");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");

var $8YqJS = parcelRequire("8YqJS");

var $75KhQ = parcelRequire("75KhQ");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $cwP4d = parcelRequire("cwP4d");
const $53a69b23fbb2f139$export$1b6ef61469955f33 = (sprints, descendant)=>{
    if (!(0, $7CnHa.isDefined)(descendant.sprint) && descendant.completedSprints && descendant.completedSprints.length === 0 || descendant.level === (0, $8YqJS.SUB_TASK_LEVEL)) return sprints;
    if (!(0, $7CnHa.isDefined)(descendant.sprint)) return [
        ...sprints || [],
        ...descendant.completedSprints || []
    ];
    return [
        ...sprints || [],
        descendant.sprint,
        ...descendant.completedSprints || []
    ];
};
const $53a69b23fbb2f139$export$ad7f62d8b8ed8f29 = (issues, descendantsMap, planningUnit, showRolledUpOthers)=>{
    const estimateAttribute = planningUnit === 'StoryPoints' ? 'storyPoints' : 'timeEstimate';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rollupMap = {};
    if (!showRolledUpOthers) return rollupMap;
    const getEstimate = (estimateSum, descendant)=>{
        if (estimateSum == null && $kDrtX.default(descendant[estimateAttribute])) return null;
        if ($kDrtX.default(descendant[estimateAttribute])) return estimateSum;
        return (estimateSum || 0) + (descendant[estimateAttribute] || 0);
    };
    const getReleases = (releases, descendant)=>{
        if (releases === null && $kDrtX.default(descendant.fixVersions)) return null;
        if ($kDrtX.default(descendant.fixVersions)) return releases;
        return [
            ...releases || [],
            ...descendant.fixVersions || []
        ];
    };
    // notice the shared team
    const getTeam = (team, descendant)=>{
        if (team === null && $kDrtX.default(descendant.team)) return null;
        if ($kDrtX.default(descendant.team) || descendant.level === (0, $8YqJS.SUB_TASK_LEVEL)) return team;
        return [
            ...team || [],
            descendant.team
        ];
    };
    for (const issue of issues)rollupMap[issue.id] = descendantsMap[issue.id] && descendantsMap[issue.id].reduce(({ estimate: estimate, release: release, team: team, sprint: sprint }, descendant)=>({
            release: [
                ...new Set(getReleases(release, descendant))
            ],
            estimate: getEstimate(estimate, descendant),
            team: [
                ...new Set(getTeam(team, descendant))
            ],
            sprint: [
                ...new Set($53a69b23fbb2f139$export$1b6ef61469955f33(sprint, descendant))
            ]
        }), {
        estimate: null,
        release: null,
        team: null,
        sprint: null
    });
    return rollupMap;
};
const $53a69b23fbb2f139$export$cfcbda58efe6fed9 = (issues)=>// @ts-expect-error Ramda types are not very good for working with objects
    $3IGDG.default($fpul1.default($jPCDz.default('parent')), $eirae.default($f7Op5.default('parent')))(issues);
const $53a69b23fbb2f139$export$65544d51bd5cdae8 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues)
], $53a69b23fbb2f139$export$cfcbda58efe6fed9);
const $53a69b23fbb2f139$export$da55948f2286493c = (0, $iK4oF.createSelector)([
    $53a69b23fbb2f139$export$65544d51bd5cdae8
], (0, $7CnHa.mapGroupsToIds));
const $53a69b23fbb2f139$export$d607bcb6675e3e03 = (issue, issueMap, descendantsMap, maxDescendantsLevel, descendants = [], descendantParents = new Set())=>{
    descendantParents.add(issue.id);
    for (const descendantId of descendantsMap[issue.id] || []){
        const issueObj = issueMap[descendantId];
        if (issueObj.level >= maxDescendantsLevel && !descendantParents.has(issueObj.id)) {
            descendants.push(issueObj);
            $53a69b23fbb2f139$export$d607bcb6675e3e03(issueObj, issueMap, descendantsMap, maxDescendantsLevel, descendants, descendantParents);
        }
    }
    return descendants;
};
const $53a69b23fbb2f139$export$3da908157953bd63 = (issuesById, childrenIdsByParent)=>$cQGVO.default((issue)=>$53a69b23fbb2f139$export$d607bcb6675e3e03(issue, issuesById, childrenIdsByParent, 0), issuesById);
const $53a69b23fbb2f139$export$3a123be6fa1e1089 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssueMapById),
    $53a69b23fbb2f139$export$da55948f2286493c
], $53a69b23fbb2f139$export$3da908157953bd63);
const $53a69b23fbb2f139$export$61e0876ed41cdcfd = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues),
    $53a69b23fbb2f139$export$3a123be6fa1e1089,
    (0, $75KhQ.getPlanningUnit),
    (0, $9H2AP.getShowRolledUpOthers)
], $53a69b23fbb2f139$export$ad7f62d8b8ed8f29);

});

parcelRegister("7s3LJ", function(module, exports) {

$parcel$export(module.exports, "getFieldKey", () => $50915e2d061d88bc$export$d6ccbf9dc458bdae);
$parcel$export(module.exports, "getSort", () => $50915e2d061d88bc$export$9cf0cb3e0918cf99);

var $bwMm3 = parcelRequire("bwMm3");
var $kDrtX = parcelRequire("kDrtX");
var $kjklK = parcelRequire("kjklK");
var $dOoQ4 = parcelRequire("dOoQ4");
var $2uEDR = parcelRequire("2uEDR");
var $701od = parcelRequire("701od");

var $6VhAf = parcelRequire("6VhAf");

var $kKj1m = parcelRequire("kKj1m");

var $jp3RH = parcelRequire("jp3RH");

var $kFf60 = parcelRequire("kFf60");

var $czhUP = parcelRequire("czhUP");

var $75KhQ = parcelRequire("75KhQ");

var $MQRDu = parcelRequire("MQRDu");

var $9H2AP = parcelRequire("9H2AP");

var $chgK5 = parcelRequire("chgK5");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $aK3ri = parcelRequire("aK3ri");
const $50915e2d061d88bc$export$d6ccbf9dc458bdae = (fieldId, planningUnit)=>{
    if (fieldId === (0, $chgK5.ISSUE_FIELDS).ESTIMATE) return planningUnit === (0, $5rYNM.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
    return fieldId;
};
const $50915e2d061d88bc$export$2c9b3f539cb25b05 = (isCustomField, field, issue)=>isCustomField ? $kjklK.default([
        'customFields',
        field
    ], issue) : issue[field];
const $50915e2d061d88bc$export$cb8ab7d6e878141 = (allTeamsById, direction)=>(comparatorFunction)=>[
            // we need this custom logic because issues without team should
            // be at the end if sort is ascending and first if sort is descending (JPOS-3338)
            ({ team: teamOfIssueA }, { team: teamOfIssueB })=>{
                if (teamOfIssueA && teamOfIssueB) return comparatorFunction((team)=>$dOoQ4.default('', [
                        team,
                        'title'
                    ], allTeamsById).toLowerCase())(teamOfIssueA, teamOfIssueB);
                if (!teamOfIssueA && !teamOfIssueB) return 0;
                if (direction === (0, $5rYNM.SORT_DIRECTION).ASCENDING) return teamOfIssueA ? -1 : 1;
                return teamOfIssueA ? 1 : -1;
            }
        ];
const $50915e2d061d88bc$export$f56cdb802f24d250 = (issuePrioritiesIdList)=>(comparatorFunction)=>[
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            comparatorFunction(({ priority: priority })=>issuePrioritiesIdList.indexOf(priority))
        ];
const $50915e2d061d88bc$export$57707817503254eb = (issueStatusById)=>(comparatorFunction)=>{
        const categoriesMap = {
            [(0, $5rYNM.ISSUE_STATUS_CATEGORIES).TODO]: 1,
            [(0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS]: 2,
            [(0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE]: 3
        };
        return [
            comparatorFunction(({ status: status })=>{
                if (!(0, $7CnHa.isDefined)(status)) return 0;
                const issueStatus = issueStatusById[status];
                if (!(0, $7CnHa.isDefined)(issueStatus)) return 0;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return categoriesMap[issueStatus.categoryId];
            }),
            comparatorFunction(({ status: status })=>{
                if (!(0, $7CnHa.isDefined)(status)) return '';
                return $dOoQ4.default('', [
                    status,
                    'name'
                ], issueStatusById).toLowerCase();
            })
        ];
    };
const $50915e2d061d88bc$export$4aa9d781e270fa16 = (assigneesById, direction)=>(comparatorFunction)=>[
            // we need this custom logic because issues that are unassigned should
            // be at the end if sort is ascending and first if sort is descending (JPOS-4280)
            ({ assignee: assigneeOfIssueA }, { assignee: assigneeOfIssueB })=>{
                if (assigneeOfIssueA !== 'unassigned' && assigneeOfIssueB !== 'unassigned') return comparatorFunction((assignee)=>$dOoQ4.default('', [
                        assignee,
                        'jiraUser',
                        'title'
                    ], assigneesById).toLowerCase())(assigneeOfIssueA, assigneeOfIssueB);
                if (assigneeOfIssueA === 'unassigned' && assigneeOfIssueB === 'unassigned') return 0;
                if (direction === (0, $5rYNM.SORT_DIRECTION).ASCENDING) return assigneeOfIssueA === 'unassigned' ? 1 : -1;
                return assigneeOfIssueA === 'unassigned' ? -1 : 1;
            }
        ];
const $50915e2d061d88bc$export$8e2c99fad461c86f = (state)=>(0, $9H2AP.getVisualisationViewSettings)(state).sorting;
const $50915e2d061d88bc$export$e52fa2f2cecb999c = $bwMm3.default(3, (fn, a, b)=>{
    // function does not guarantee strict order between null and undefined
    const aa = fn(a);
    const bb = fn(b);
    if ($kDrtX.default(aa) && $kDrtX.default(bb)) return 0;
    if ($kDrtX.default(aa)) return -1;
    if ($kDrtX.default(bb)) return 1;
    if (aa < bb) return -1;
    if (aa > bb) return 1;
    return 0;
});
const $50915e2d061d88bc$export$b2276edb91189a53 = $bwMm3.default(3, (fn, a, b)=>{
    // function does not guarantee strict order between null and undefined
    const aa = fn(a);
    const bb = fn(b);
    if ($kDrtX.default(aa) && $kDrtX.default(bb)) return 0;
    if ($kDrtX.default(aa)) return 1;
    if ($kDrtX.default(bb)) return -1;
    if (aa > bb) return -1;
    if (aa < bb) return 1;
    return 0;
});
const $50915e2d061d88bc$export$95525488fdeaaa55 = (lexoRankAdjustments, sorting, dateConfiguration, issueStatusById, showRolledUpOthers = false, planningUnit, rollupMap, issuePrioritiesIdList, allTeamsById, assigneesById, selectOptionsById)=>{
    const comparatorFunction = (0, $7CnHa.isDefined)(sorting.direction) && sorting.direction === (0, $5rYNM.SORT_DIRECTION).DESCENDING ? $50915e2d061d88bc$export$b2276edb91189a53 : $50915e2d061d88bc$export$e52fa2f2cecb999c;
    const defaultSortFunctions = [
        (0, $7CnHa.ascend)(({ lexoRank: lexoRank })=>lexoRank || ''),
        (0, $7CnHa.ascend)(({ id: id })=>lexoRankAdjustments.indexOf(id))
    ];
    const { baselineStartField: { key: configuredStartField }, baselineEndField: { key: configuredEndField } } = dateConfiguration;
    const sortByStringFunctionsMap = {
        [(0, $chgK5.ISSUE_FIELDS).PRIORITY_FIELD]: issuePrioritiesIdList ? $50915e2d061d88bc$export$f56cdb802f24d250($2uEDR.default(issuePrioritiesIdList)) : ()=>[],
        [(0, $chgK5.ISSUE_FIELDS).TEAM_FIELD]: $50915e2d061d88bc$export$cb8ab7d6e878141(allTeamsById, sorting.direction),
        [(0, $chgK5.ISSUE_FIELDS).STATUS_FIELD]: $50915e2d061d88bc$export$57707817503254eb(issueStatusById),
        [(0, $chgK5.ISSUE_FIELDS).ASSIGNEE_FIELD]: $50915e2d061d88bc$export$4aa9d781e270fa16(assigneesById, sorting.direction)
    };
    switch(sorting.type){
        /** When a new data type is supported for sorting,
		 *  add relevant system fields for which sort is supported and "customfield_{type}" to
		 *  portfolio-2/portfolio/portfolio-plugin/src/main/resources/analytics/whitelist.js
		 *
		 *  Example: If support for string is added, then
		 *  add "customfield_string" and all the issue fields, whose data type is string and
		 *  are added to sort by option in view settings to p4j.viewRoadmap.page (sortByField)
		 *  and p4j.sortField.button (field)
		 *  events in whitelist.js
		 */ case (0, $5rYNM.ISSUE_FIELD_TYPES).DATE:
            return (0, $7CnHa.sortWith)([
                comparatorFunction((issue)=>{
                    if (sorting.field === configuredStartField) return issue.baselineStart || 0;
                    if (sorting.field === configuredEndField) return issue.baselineEnd || 0;
                    const dateAttribute = $50915e2d061d88bc$export$2c9b3f539cb25b05(sorting.isCustomField, sorting.field, issue);
                    return dateAttribute || 0;
                }),
                ...defaultSortFunctions
            ]);
        case (0, $5rYNM.ISSUE_FIELD_TYPES).STRING:
            {
                const getSortBy = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                sortByStringFunctionsMap[sorting.field];
                if (!getSortBy) return (0, $7CnHa.sortWith)([
                    comparatorFunction((issue)=>{
                        const field = $50915e2d061d88bc$export$2c9b3f539cb25b05(sorting.isCustomField, sorting.field, issue);
                        if (sorting.isCustomField) {
                            const customFieldValue = field && selectOptionsById[field] && selectOptionsById[field].value;
                            return (0, $7CnHa.isDefined)(customFieldValue) ? $701od.default(customFieldValue) : customFieldValue;
                        }
                        return (0, $7CnHa.isDefined)(field) ? $701od.default(field) : field;
                    }),
                    ...defaultSortFunctions
                ]);
                return (0, $7CnHa.sortWith)([
                    ...getSortBy(comparatorFunction),
                    ...defaultSortFunctions
                ]);
            }
        case (0, $5rYNM.ISSUE_FIELD_TYPES).NUMBER:
            return (0, $7CnHa.sortWith)([
                comparatorFunction((issue)=>{
                    const rollupIssueValues = rollupMap[issue.id];
                    const attributeKey = sorting.isCustomField ? sorting.field : $50915e2d061d88bc$export$d6ccbf9dc458bdae(sorting.field, planningUnit);
                    const value = $50915e2d061d88bc$export$2c9b3f539cb25b05(sorting.isCustomField, attributeKey, issue);
                    const isValueDefined = (0, $7CnHa.isDefined)(value);
                    if (showRolledUpOthers) {
                        const isRollupValueDefined = (0, $7CnHa.isDefined)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        rollupIssueValues[sorting.field]);
                        if (!isRollupValueDefined) return value;
                        if (!isValueDefined) return rollupIssueValues[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        sorting.field];
                        return value + // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        rollupIssueValues[sorting.field];
                    }
                    return value;
                }),
                ...defaultSortFunctions
            ]);
        default:
            return (0, $7CnHa.sortWith)(defaultSortFunctions);
    }
};
const $50915e2d061d88bc$export$9cf0cb3e0918cf99 = (0, $iK4oF.createSelector)([
    (0, $czhUP.getIssueLexoRankAdjustments),
    $50915e2d061d88bc$export$8e2c99fad461c86f,
    (0, $75KhQ.getDateConfiguration),
    (0, $kFf60.getIssueStatusById),
    (0, $9H2AP.getShowRolledUpOthers),
    (0, $75KhQ.getPlanningUnit),
    (0, $aK3ri.getRollupMap),
    (0, $jp3RH.getIssuePrioritiesIdList),
    (0, $MQRDu.getAllTeamsById),
    (0, $6VhAf.getAssigneesById),
    (0, $kKj1m.getSelectOptionsById)
], $50915e2d061d88bc$export$95525488fdeaaa55);

});
parcelRegister("dOoQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e3365fb6054aec$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $2wtN3 = parcelRequire("2wtN3");

var $kjklK = parcelRequire("kjklK");
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $a0e3365fb6054aec$var$pathOr = /*#__PURE__*/ (0, $4g10W.default)(function pathOr(d, p, obj) {
    return (0, $2wtN3.default)(d, (0, $kjklK.default)(p, obj));
});
var $a0e3365fb6054aec$export$2e2bcd8739ae039 = $a0e3365fb6054aec$var$pathOr;

});

parcelRegister("701od", function(module, exports) {

$parcel$export(module.exports, "default", () => $51899c70f878d96c$export$2e2bcd8739ae039);

var $juWBF = parcelRequire("juWBF");
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $51899c70f878d96c$var$toLower = /*#__PURE__*/ (0, $juWBF.default)(0, 'toLowerCase');
var $51899c70f878d96c$export$2e2bcd8739ae039 = $51899c70f878d96c$var$toLower;

});

parcelRegister("chgK5", function(module, exports) {

$parcel$export(module.exports, "ISSUE_FIELDS", () => $524a328888d6c934$export$e2d863e73993291c);
$parcel$export(module.exports, "TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP", () => $524a328888d6c934$export$2cfb2d0810bc071e);
$parcel$export(module.exports, "ISSUE_FIELD_TO_TYPE_MAP", () => $524a328888d6c934$export$192a285e6a49f870);
$parcel$export(module.exports, "TARGET_START_FIELD", () => (parcelRequire("eOsHk")).TARGET_START_FIELD);
$parcel$export(module.exports, "TARGET_END_FIELD", () => (parcelRequire("eOsHk")).TARGET_END_FIELD);
$parcel$export(module.exports, "BUILT_IN_DATE_FIELDS", () => (parcelRequire("eOsHk")).BUILT_IN_DATE_FIELDS);
parcelRequire("eOsHk");
var $lO4Or = parcelRequire("lO4Or");
var $eOsHk = parcelRequire("eOsHk");

var $5rYNM = parcelRequire("5rYNM");
const $524a328888d6c934$export$c3d7e0f1e63de60e = 'lexoRank';
const $524a328888d6c934$export$e2d863e73993291c = {
    DUE_DATE: $eOsHk.DUE_DATE,
    RANK: $524a328888d6c934$export$c3d7e0f1e63de60e,
    TARGET_START_FIELD: $eOsHk.TARGET_START_FIELD,
    TARGET_END_FIELD: $eOsHk.TARGET_END_FIELD,
    TEAM_FIELD: $lO4Or.TEAM_TYPE,
    STATUS_FIELD: $lO4Or.STATUS_TYPE,
    ESTIMATE: $lO4Or.ESTIMATE_TYPE,
    PRIORITY_FIELD: $lO4Or.PRIORITY_TYPE,
    ASSIGNEE_FIELD: $lO4Or.ASSIGNEE_TYPE,
    REPORTER_FIELD: $lO4Or.REPORTER_TYPE
};
const $524a328888d6c934$export$2cfb2d0810bc071e = Object.freeze({
    [(0, $eOsHk.TARGET_START_FIELD)]: 'baselineStart',
    [(0, $eOsHk.TARGET_END_FIELD)]: 'baselineEnd'
});
const $524a328888d6c934$export$192a285e6a49f870 = {
    [(0, $eOsHk.DUE_DATE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).DATE,
    [$524a328888d6c934$export$c3d7e0f1e63de60e]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    [(0, $eOsHk.TARGET_START_FIELD)]: (0, $5rYNM.ISSUE_FIELD_TYPES).DATE,
    [(0, $eOsHk.TARGET_END_FIELD)]: (0, $5rYNM.ISSUE_FIELD_TYPES).DATE,
    [(0, $lO4Or.TEAM_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    [(0, $lO4Or.STATUS_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    [(0, $lO4Or.ESTIMATE_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).NUMBER,
    [(0, $lO4Or.PRIORITY_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    [(0, $lO4Or.REPORTER_TYPE)]: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING
};

});





parcelRegister("4jBRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e645351c5d600645$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l79aB = parcelRequire("l79aB");
const $e645351c5d600645$var$Wrapper = ({ associatedIssueIds: associatedIssueIds, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l79aB.AssociatedIssuesContainer), {
        associatedIssueIds: associatedIssueIds
    }, children);
var $e645351c5d600645$export$2e2bcd8739ae039 = $e645351c5d600645$var$Wrapper;

});
parcelRegister("l79aB", function(module, exports) {

$parcel$export(module.exports, "AssociatedIssuesContainer", () => $c42efdb4f69d04a0$export$6b5d5209e8b70003);
$parcel$export(module.exports, "useAssociatedIssues", () => $c42efdb4f69d04a0$export$170f0814c1650002);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4lF8N = parcelRequire("4lF8N");

var $dl9FG = parcelRequire("dl9FG");
const $c42efdb4f69d04a0$export$6b5d5209e8b70003 = (0, $heB5U.createContainer)();
const $c42efdb4f69d04a0$var$handlers = {
    onInit: ()=>(storeApi)=>{
            storeApi.dispatch((0, $4lF8N.actions).loadAssociatedIssue());
        },
    onContainerUpdate: ()=>()=>{
        // at this point associated issues are read-only, so we don't fetch anything here
        }
};
const $c42efdb4f69d04a0$var$Store = (0, $a61MH.createStore)({
    containedBy: $c42efdb4f69d04a0$export$6b5d5209e8b70003,
    initialState: {
        associatedIssues: undefined,
        isError: false,
        isLoading: false
    },
    actions: $4lF8N.actions,
    handlers: $c42efdb4f69d04a0$var$handlers
});
const $c42efdb4f69d04a0$export$170f0814c1650002 = (0, $ggKAj.createHook)($c42efdb4f69d04a0$var$Store, {
    selector: (0, $dl9FG.getAssociatedIssues)
});

});
parcelRegister("4lF8N", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c8e0a11402bd6ec6$export$e324594224ef24da);

var $guiFP = parcelRequire("guiFP");

var $37igo = parcelRequire("37igo");

var $dl9FG = parcelRequire("dl9FG");
const $c8e0a11402bd6ec6$var$loadAssociatedIssue = ()=>async ({ getState: getState, setState: setState }, { associatedIssueIds: associatedIssueIds })=>{
        if ((0, $dl9FG.getIsLoading)(getState()) || !associatedIssueIds || associatedIssueIds.length === 0) return;
        setState({
            isLoading: true
        });
        (0, $37igo.fetchAssociatedIssues)(associatedIssueIds).then((associatedIssues)=>{
            setState({
                associatedIssues: associatedIssues,
                isLoading: false
            });
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    packageName: 'jiraPortfolio3AssociatedIssues',
                    id: 'fetchAssociatedIssues',
                    teamName: 'jpd-juno'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: false
            });
        });
    };
const $c8e0a11402bd6ec6$export$e324594224ef24da = {
    loadAssociatedIssue: $c8e0a11402bd6ec6$var$loadAssociatedIssue
};

});
parcelRegister("37igo", function(module, exports) {

$parcel$export(module.exports, "fetchAssociatedIssues", () => $da9f3ddf223ad2ab$export$2fa93be020e5415c);

var $2OdyW = parcelRequire("2OdyW");
const $da9f3ddf223ad2ab$var$makeSearchBody = (ids)=>JSON.stringify({
        jql: `id in (${ids.join(',')})`,
        // fields,
        startAt: 0,
        maxResults: 100,
        validateQuery: 'strict'
    });
const $da9f3ddf223ad2ab$var$fetchBatch = (ids)=>(0, $2OdyW.default)('/rest/api/3/search', {
        method: 'POST',
        body: $da9f3ddf223ad2ab$var$makeSearchBody(ids)
    });
const $da9f3ddf223ad2ab$export$2fa93be020e5415c = (associatedIssueIds)=>associatedIssueIds.length === 0 ? Promise.resolve({}) : $da9f3ddf223ad2ab$var$fetchBatch(associatedIssueIds).then((result)=>{
        const associatedIssues = {};
        result.issues.forEach((issue)=>{
            associatedIssues[issue.id] = {
                id: issue.id,
                key: issue.key,
                summary: issue.fields.summary,
                iconUrl: issue.fields.issuetype.iconUrl
            };
        });
        return associatedIssues;
    });

});

parcelRegister("dl9FG", function(module, exports) {

$parcel$export(module.exports, "getAssociatedIssues", () => $12609d0cf7761a4f$export$b5b4d0e5ac99bf25);
$parcel$export(module.exports, "getIsLoading", () => $12609d0cf7761a4f$export$439d81b5ff19f64f);
const $12609d0cf7761a4f$export$b5b4d0e5ac99bf25 = (state)=>state.associatedIssues;
const $12609d0cf7761a4f$export$439d81b5ff19f64f = (state)=>state.isLoading;

});





parcelRegister("cuFEI", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("iMoOg")).default);
// eslint-disable-next-line jira/export/no-external-exports

var $iMoOg = parcelRequire("iMoOg");

});
parcelRegister("iMoOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $688791258c114933$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $3YYMM = parcelRequire("3YYMM");
const $688791258c114933$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    viewMode: (0, $9H2AP.getViewMode),
    isReadOnly: $akhOi.isReadOnly
});
var $688791258c114933$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($688791258c114933$var$mapStateToProps, {})((0, $3YYMM.default));

});
parcelRegister("3YYMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd46cf9344077db1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hkOxK = parcelRequire("hkOxK");
var $haaWO = parcelRequire("haaWO");
var $jNzVW = parcelRequire("jNzVW");
var $lwX94 = parcelRequire("lwX94");
var $3by2Y = parcelRequire("3by2Y");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $kndO6 = parcelRequire("kndO6");
var $kChDU = parcelRequire("kChDU");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3XRVl = parcelRequire("3XRVl");
var $ffiyv = parcelRequire("ffiyv");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $kYJcj = parcelRequire("kYJcj");
var $gwbfD = parcelRequire("gwbfD");

var $j4LwV = parcelRequire("j4LwV");

var $dw8TK = parcelRequire("dw8TK");

var $lf4fN = parcelRequire("lf4fN");

var $NeuAT = parcelRequire("NeuAT");

var $9NSUz = parcelRequire("9NSUz");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $gGKRb = parcelRequire("gGKRb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $8QdsV = parcelRequire("8QdsV");

var $51Seq = parcelRequire("51Seq");

var $5lbSo = parcelRequire("5lbSo");

var $8kuoL = parcelRequire("8kuoL");

var $6EZ9n = parcelRequire("6EZ9n");
const $dd46cf9344077db1$var$getColumnTitle = (column, intl)=>{
    /**
   * this type check is performed because:
   * - the title of a standard field is of type Message; whereas
   * - the title of a custom field is of type string
   *
   * If the column title is passed as a string in the formatMessage below, the plan would crash
   * because an `id` must be provided to format a message.
   */ if (typeof column.title === 'string') /**
           * There are 3 scenarios to take care of with the title of custom fields:
           * 1. the user could have entered a whitespace in front of the title e.g. " My custom label"
           * 2. the user could have forgotten to type the first letter as capital e.g. "my custom label"
           * 3. the user did both 1. and 2. e.g. " my custom label"
            * These scenarios impact the sorting of fields in the "Choose fields" picklist:
           * - fields with a whitespace in front of the title are displayed first
           * - fields with a non-capital letter are displayed last
           *
           * The solution is to trim the title, then capitalize the first letter
           */ return $hkOxK.default($haaWO.default(''), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $lwX94.default($jNzVW.default(0), $kndO6.default), $kChDU.default)(column.title);
    return intl.formatMessage(column.groupTitle || column.title);
};
const $dd46cf9344077db1$var$localizeColumns = (columns, intl)=>columns.map((column)=>{
        const { id: id, isVisible: isVisible, isCustomField: isCustomField, projectId: projectId } = column;
        const localizedTitle = $dd46cf9344077db1$var$getColumnTitle(column, intl);
        const localizedColumn = {
            id: id,
            isVisible: isVisible,
            localizedTitle: localizedTitle,
            isCustomField: isCustomField,
            projectId: projectId
        };
        return localizedColumn;
    });
const $dd46cf9344077db1$var$AdvancedFieldsMenu = ({ columns: columns, isDropMenuOpenByDefault: isDropMenuOpenByDefault, getMatchingConfiguredDate: getMatchingConfiguredDate, hideColumn: hideColumn, moveColumn: moveColumn, showColumn: showColumn, isDropMenuSelectOpenByDefault: isDropMenuSelectOpenByDefault = false, isReadOnly: isReadOnly, viewMode: viewMode, id: id, isShortcutEnabled: isShortcutEnabled = true, renderMenuTrigger: renderMenuTrigger, placement: placement = 'bottom-start' })=>{
    const intl = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [localizedColumns, setLocalizedColumns] = (0, $eUqFw.useState)($dd46cf9344077db1$var$localizeColumns(columns, intl));
    const [isAdvancedFieldsMenuOpen, setIsAdvancedFieldsMenuOpen] = (0, $eUqFw.useState)(isDropMenuOpenByDefault || false);
    (0, $eUqFw.useEffect)(()=>{
        setLocalizedColumns($dd46cf9344077db1$var$localizeColumns(columns, intl));
    }, [
        columns,
        intl
    ]);
    const toggleAdvancedFieldsMenu = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fieldsMenu', {
            viewMode: viewMode,
            trigger: id
        });
        setIsAdvancedFieldsMenuOpen(!isAdvancedFieldsMenuOpen);
    }, [
        createAnalyticsEvent,
        id,
        viewMode,
        isAdvancedFieldsMenuOpen
    ]);
    const openDropMenu = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fieldsMenu', {
            viewMode: viewMode,
            trigger: id
        });
        setIsAdvancedFieldsMenuOpen(true);
    }, [
        createAnalyticsEvent,
        id,
        viewMode
    ]);
    const updateRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        updateRef.current?.();
    }, [
        columns,
        updateRef
    ]);
    const planId = (0, $NeuAT.getPlanId)();
    const scenarioId = (0, $NeuAT.getScenarioId)();
    const getSearchFieldOptions = (options)=>{
        const listableColumns = (0, $6EZ9n.getListableColumns)(options);
        return $9RbxZ.default((option)=>(0, $7CnHa.isDefined)(option) && option[0].localizedTitle, listableColumns).map((group)=>{
            const localizedTitle = group && group[0] ? group[0].localizedTitle : '';
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const columns = $9RbxZ.default($f7Op5.default('id'), group);
            const compoundId = columns.map($f7Op5.default('id')).join(':');
            const configurableDate = getMatchingConfiguredDate(compoundId);
            return {
                value: group,
                label: localizedTitle,
                isCustomField: group.find((e)=>e.isCustomField),
                configurableDate: configurableDate
            };
        });
    };
    const renderCustomFieldLozenge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $8kuoL["afm-custom-field-lozenge"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.custom-lozenge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, intl.formatMessage((0, $51Seq.default).advancedFieldsMenuCustomFieldLozenge)));
    const renderOptionLabel = (option)=>{
        const { configurableDate: configurableDate, label: label, isCustomField: isCustomField, value: value = [] } = option;
        const tooltip = (0, $9NSUz.getConfiguredDateTooltip)(configurableDate);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $8kuoL["afm-field-option"],
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.option-${value[0] && value[0].id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $8kuoL["afm-field-option-title"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJcj.default), {
            icon: configurableDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.option-${value[0] && value[0].id}.configurable-date-lozenge`
            }, "D"),
            tooltip: tooltip && intl.formatMessage(tooltip, {
                title: label
            }),
            mode: "inline"
        }, label)), isCustomField && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $8kuoL["afm-field-option-custom-lozenge"]
        }, renderCustomFieldLozenge()));
    };
    const formatOptionLabel = (option)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $8kuoL["afm-select-option-label"]
        }, renderOptionLabel(option));
    const safeLocalizedColumns = localizedColumns.filter(// eslint-disable-next-line @typescript-eslint/no-shadow
    ({ id: id })=>id !== (0, $lf4fN.ADD_FIELDS_COLUMN_ID));
    const [selected, unselected] = $3by2Y.default($f7Op5.default('isVisible'), safeLocalizedColumns);
    /**
   * A different message is displayed in the drop menu of the "Choose fields..." drop list when
   * - there are no fields which match the search criteria, or
   * - there are no fields because all of them have been selected
   */ const noFieldsMessage = intl.formatMessage(unselected && unselected.length ? (0, $51Seq.default).advancedFieldsMenuNoFieldsMatchCriteria : (0, $51Seq.default).advancedFieldsMenuAllFieldsSelected);
    const onSelectChange = (value, _)=>{
        if (value != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-shadow
        value.value.forEach(({ id: id, isCustomField: isCustomField, projectId: projectId })=>{
            showColumn(id);
            if (isCustomField && projectId) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'select'
            }), 'addTmpCustomFieldToTimeline');
        });
    };
    const renderDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $8kuoL["afm-dropdown-container"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $8kuoL["afm-dropdown-menu-header"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.select"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGKRb.default), {
            autoFocus: true,
            isTransparentBackground: false,
            options: getSearchFieldOptions(unselected),
            menuPlacement: "auto",
            value: null,
            onChange: onSelectChange,
            formatOptionLabel: formatOptionLabel,
            placeholder: intl.formatMessage((0, $51Seq.default).advancedFieldsMenuSelectPlaceholder),
            noOptionsMessage: ()=>noFieldsMessage,
            menuIsOpen: isDropMenuSelectOpenByDefault,
            "aria-label": intl.formatMessage((0, $51Seq.default).advancedFieldsMenuSelectLabel)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lbSo.default), {
            selectedColumns: selected,
            moveColumn: moveColumn,
            hideColumn: hideColumn,
            getMatchingConfiguredDate: getMatchingConfiguredDate
        }), !isReadOnly && planId && scenarioId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $8kuoL["afm-dropdown-menu-divider"]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            onClick: ()=>push(`/jira/plans/${planId}/scenarios/${scenarioId}/settings/custom-fields`)
        }, intl.formatMessage((0, $51Seq.default).advancedFieldsMenuManageCustomFieldsLink))));
    const renderTriggerButton = (triggerProps)=>{
        if (renderMenuTrigger !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return renderMenuTrigger({
            ...triggerProps,
            onClick: toggleAdvancedFieldsMenu,
            isSelected: isAdvancedFieldsMenuOpen
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...triggerProps,
            onClick: toggleAdvancedFieldsMenu,
            appearance: "subtle",
            isSelected: isAdvancedFieldsMenuOpen,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.trigger-menu-button",
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.trigger-menu-icon",
                label: ""
            })
        }, intl.formatMessage((0, $ib5d3.default).fields));
    };
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: isShortcutEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4LwV.default), {
                letter: "A",
                message: (0, $51Seq.default).advancedFieldsMenuAddFieldTooltip
            }) : intl.formatMessage((0, $51Seq.default).advancedFieldsMenuAddFieldTooltip),
            position: "bottom"
        }, renderTriggerButton(triggerProps));
    const renderContent = ({ update: update })=>{
        updateRef.current = update;
        return renderDialogContent();
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8kuoL["afm-header-left"]
    }, isShortcutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyA",
        onKeyDown: openDropMenu
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: placement,
        fallbackPlacements: [
            'bottom',
            'bottom-end'
        ],
        autoFocus: false,
        isOpen: isAdvancedFieldsMenuOpen,
        onClose: ()=>setIsAdvancedFieldsMenuOpen(false),
        popupComponent: (0, $8QdsV.default),
        trigger: renderTrigger,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: true
    })));
};
var $dd46cf9344077db1$export$2e2bcd8739ae039 = $dd46cf9344077db1$var$AdvancedFieldsMenu;

});
parcelRegister("haaWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7ebdccd56053a2a$export$2e2bcd8739ae039);

var $juWBF = parcelRequire("juWBF");
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $c7ebdccd56053a2a$var$join = /*#__PURE__*/ (0, $juWBF.default)(1, 'join');
var $c7ebdccd56053a2a$export$2e2bcd8739ae039 = $c7ebdccd56053a2a$var$join;

});

parcelRegister("jNzVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69e7799d526c954$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $5mkdj = parcelRequire("5mkdj");

var $adz2t = parcelRequire("adz2t");

var $elb6l = parcelRequire("elb6l");
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $e69e7799d526c954$var$lensIndex = /*#__PURE__*/ (0, $eSWTK.default)(function lensIndex(n) {
    return (0, $5mkdj.default)((0, $adz2t.default)(n), (0, $elb6l.default)(n));
});
var $e69e7799d526c954$export$2e2bcd8739ae039 = $e69e7799d526c954$var$lensIndex;

});
parcelRegister("5mkdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e6eafdbf7d0e8b4$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $cQGVO = parcelRequire("cQGVO");
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $3e6eafdbf7d0e8b4$var$lens = /*#__PURE__*/ (0, $ggdJA.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $cQGVO.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $3e6eafdbf7d0e8b4$export$2e2bcd8739ae039 = $3e6eafdbf7d0e8b4$var$lens;

});

parcelRegister("elb6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70ba353a708c078$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $gUZib = parcelRequire("gUZib");

var $gIUzE = parcelRequire("gIUzE");
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $a70ba353a708c078$var$update = /*#__PURE__*/ (0, $4g10W.default)(function update(idx, x, list) {
    return (0, $gUZib.default)(idx, (0, $gIUzE.default)(x), list);
});
var $a70ba353a708c078$export$2e2bcd8739ae039 = $a70ba353a708c078$var$update;

});
parcelRegister("gUZib", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5116bae107c00fa$export$2e2bcd8739ae039);

var $kJFRt = parcelRequire("kJFRt");

var $4g10W = parcelRequire("4g10W");
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $c5116bae107c00fa$var$adjust = /*#__PURE__*/ (0, $4g10W.default)(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, $kJFRt.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $c5116bae107c00fa$export$2e2bcd8739ae039 = $c5116bae107c00fa$var$adjust;

});

parcelRegister("gIUzE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cca3d9136f803e$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $c2cca3d9136f803e$var$always = /*#__PURE__*/ (0, $eSWTK.default)(function always(val) {
    return function() {
        return val;
    };
});
var $c2cca3d9136f803e$export$2e2bcd8739ae039 = $c2cca3d9136f803e$var$always;

});



parcelRegister("lwX94", function(module, exports) {

$parcel$export(module.exports, "default", () => $faca772a4ca946fa$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var $faca772a4ca946fa$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $faca772a4ca946fa$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $faca772a4ca946fa$var$over = /*#__PURE__*/ (0, $4g10W.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $faca772a4ca946fa$var$Identity(f(y));
    })(x).value;
});
var $faca772a4ca946fa$export$2e2bcd8739ae039 = $faca772a4ca946fa$var$over;

});

parcelRegister("kChDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0250abfafdf4eac$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
var $f0250abfafdf4eac$var$ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $f0250abfafdf4eac$var$zeroWidth = '\u200b';
var $f0250abfafdf4eac$var$hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $f0250abfafdf4eac$var$trim = !$f0250abfafdf4eac$var$hasProtoTrim || /*#__PURE__*/ $f0250abfafdf4eac$var$ws.trim() || !/*#__PURE__*/ $f0250abfafdf4eac$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $eSWTK.default)(function trim(str) {
    var beginRx = new RegExp('^[' + $f0250abfafdf4eac$var$ws + '][' + $f0250abfafdf4eac$var$ws + ']*');
    var endRx = new RegExp('[' + $f0250abfafdf4eac$var$ws + '][' + $f0250abfafdf4eac$var$ws + ']*$');
    return str.replace(beginRx, '').replace(endRx, '');
}) : /*#__PURE__*/ (0, $eSWTK.default)(function trim(str) {
    return str.trim();
});
var $f0250abfafdf4eac$export$2e2bcd8739ae039 = $f0250abfafdf4eac$var$trim;

});

parcelRegister("3XRVl", function(module, exports) {

$parcel$export(module.exports, "DropMenuItem", () => $eec5751305d683f5$export$1d16dd19bd2e4d57);
$parcel$export(module.exports, "default", () => $eec5751305d683f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $1ybV0 = parcelRequire("1ybV0");

var $g8JvH = parcelRequire("g8JvH");
const $eec5751305d683f5$export$1d16dd19bd2e4d57 = (0, $g8JvH.AnalyticsEventToProps)('dropMenuItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
class $eec5751305d683f5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            defaultOpen: false,
            isLoading: false,
            isOpen: false,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onOpenChange: ()=>{},
            placement: 'bottom-start',
            testId: ''
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */ if (nextProps.isOpen !== this.props.isOpen) this.setState({
            isOpen: !!nextProps.isOpen
        });
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { children: children, isLoading: isLoading, placement: placement, testId: testId, trigger: trigger } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            isOpen: isOpen,
            isLoading: isLoading,
            onOpenChange: this.handleOpenChange,
            placement: placement,
            testId: testId,
            trigger: trigger,
            ...(0, $1ybV0.ff)('jsw.roadmaps.jca11y-565-plan-team-screen-inaccurate-reading-order_7q5lg') && {
                shouldRenderToParent: true
            }
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: this.props.defaultOpen || false
        };
        this.handleOpenChange = (attrs)=>{
            this.setState({
                isOpen: attrs.isOpen
            });
            /* istanbul ignore else */ if (this.props.onOpenChange) this.props.onOpenChange(attrs);
        };
    }
}

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
parcelRegister("6zOB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8bd316b08fe19e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $4ZL0y = parcelRequire("4ZL0y");

var $3Ucf8 = parcelRequire("3Ucf8");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $4a8bd316b08fe19e$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ...rest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }, baseProps.children);
}));
$4a8bd316b08fe19e$var$Button.displayName = 'Button';
var $4a8bd316b08fe19e$export$2e2bcd8739ae039 = $4a8bd316b08fe19e$var$Button;

});

/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});


parcelRegister("aAyrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c9ee29ca5a58ef$export$2e2bcd8739ae039);
$parcel$export(module.exports, "StandardButton", () => (parcelRequire("7u4fN")).default);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $bLFgh = parcelRequire("bLFgh");
var $bbaTG = parcelRequire("bbaTG");

var $Sibrq = parcelRequire("Sibrq");
const $49c9ee29ca5a58ef$var$Button = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { ariaLabel: ariaLabel, isLoading: isLoading, ...restProps } = props;
    if (isLoading !== undefined && isLoading !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        ref: ref,
        isLoading: isLoading,
        ...restProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        ...restProps,
        "aria-label": ariaLabel
    });
});
var $49c9ee29ca5a58ef$export$2e2bcd8739ae039 = $49c9ee29ca5a58ef$var$Button;

});

parcelRegister("kYJcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d7305e346d1d73$export$2e2bcd8739ae039);
/**
 * Icon and tooltip wrapper
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $gwbfD = parcelRequire("gwbfD");

var $6B26M = parcelRequire("6B26M");
const $27d7305e346d1d73$var$TitleWithIcon = ({ icon: icon, tooltip: tooltip = '', mode: mode, children: children })=>{
    const titleStyle = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        [$6B26M.title]: true,
        [$6B26M.__header]: mode === 'header'
    });
    const iconStyle = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        [$6B26M["title-icon"]]: true,
        [$6B26M.__collapsed]: mode === 'collapsed'
    });
    const element = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: titleStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $6B26M["truncate-text"]
    }, children), icon !== undefined && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: iconStyle,
        "data-testid": "portfolio-3-common.sections.title-icon"
    }, icon));
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip
    }, element) : element;
};
var $27d7305e346d1d73$export$2e2bcd8739ae039 = $27d7305e346d1d73$var$TitleWithIcon;

});
parcelRegister("gwbfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a1a19c5eb18f15$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");
function $a0a1a19c5eb18f15$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), props);
}

});

parcelRegister("6B26M", function(module, exports) {

$parcel$export(module.exports, "__collapsed", () => $4cd7d571010001f7$export$ee2c026c2cbf6421, (v) => $4cd7d571010001f7$export$ee2c026c2cbf6421 = v);
$parcel$export(module.exports, "__header", () => $4cd7d571010001f7$export$ff68220f8e4ae00, (v) => $4cd7d571010001f7$export$ff68220f8e4ae00 = v);
$parcel$export(module.exports, "collapsedSection", () => $4cd7d571010001f7$export$e075d8876bc6f9dd, (v) => $4cd7d571010001f7$export$e075d8876bc6f9dd = v);
$parcel$export(module.exports, "columnText", () => $4cd7d571010001f7$export$87335a0dd85d937a, (v) => $4cd7d571010001f7$export$87335a0dd85d937a = v);
$parcel$export(module.exports, "columnTextTitle", () => $4cd7d571010001f7$export$9f0f00525fe7c162, (v) => $4cd7d571010001f7$export$9f0f00525fe7c162 = v);
$parcel$export(module.exports, "columnTexts", () => $4cd7d571010001f7$export$94e99beec2cab04b, (v) => $4cd7d571010001f7$export$94e99beec2cab04b = v);
$parcel$export(module.exports, "drag-active", () => $4cd7d571010001f7$export$99d5fd10140fa6b7, (v) => $4cd7d571010001f7$export$99d5fd10140fa6b7 = v);
$parcel$export(module.exports, "handle", () => $4cd7d571010001f7$export$8f34ce051745d39e, (v) => $4cd7d571010001f7$export$8f34ce051745d39e = v);
$parcel$export(module.exports, "section", () => $4cd7d571010001f7$export$fe2e36411d703b3d, (v) => $4cd7d571010001f7$export$fe2e36411d703b3d = v);
$parcel$export(module.exports, "sections", () => $4cd7d571010001f7$export$5a1dbaa3e4449344, (v) => $4cd7d571010001f7$export$5a1dbaa3e4449344 = v);
$parcel$export(module.exports, "separator", () => $4cd7d571010001f7$export$3e523c77c1f23f8c, (v) => $4cd7d571010001f7$export$3e523c77c1f23f8c = v);
$parcel$export(module.exports, "title", () => $4cd7d571010001f7$export$fb184b623420d9be, (v) => $4cd7d571010001f7$export$fb184b623420d9be = v);
$parcel$export(module.exports, "title-icon", () => $4cd7d571010001f7$export$8465d27022f5235a, (v) => $4cd7d571010001f7$export$8465d27022f5235a = v);
$parcel$export(module.exports, "truncate-text", () => $4cd7d571010001f7$export$e6ca8839261504b0, (v) => $4cd7d571010001f7$export$e6ca8839261504b0 = v);
var $4cd7d571010001f7$export$ee2c026c2cbf6421;
var $4cd7d571010001f7$export$ff68220f8e4ae00;
var $4cd7d571010001f7$export$e075d8876bc6f9dd;
var $4cd7d571010001f7$export$87335a0dd85d937a;
var $4cd7d571010001f7$export$9f0f00525fe7c162;
var $4cd7d571010001f7$export$94e99beec2cab04b;
var $4cd7d571010001f7$export$99d5fd10140fa6b7;
var $4cd7d571010001f7$export$8f34ce051745d39e;
var $4cd7d571010001f7$export$fe2e36411d703b3d;
var $4cd7d571010001f7$export$5a1dbaa3e4449344;
var $4cd7d571010001f7$export$3e523c77c1f23f8c;
var $4cd7d571010001f7$export$6ea4444824e687db;
var $4cd7d571010001f7$export$fb184b623420d9be;
var $4cd7d571010001f7$export$8465d27022f5235a;
var $4cd7d571010001f7$export$e6ca8839261504b0;
$4cd7d571010001f7$export$ee2c026c2cbf6421 = `VqplxG___collapsed`;
$4cd7d571010001f7$export$ff68220f8e4ae00 = `VqplxG___header`;
$4cd7d571010001f7$export$e075d8876bc6f9dd = `VqplxG_collapsedSection`;
$4cd7d571010001f7$export$87335a0dd85d937a = `VqplxG_columnText`;
$4cd7d571010001f7$export$9f0f00525fe7c162 = `VqplxG_columnTextTitle`;
$4cd7d571010001f7$export$94e99beec2cab04b = `VqplxG_columnTexts`;
$4cd7d571010001f7$export$99d5fd10140fa6b7 = `VqplxG_drag-active`;
$4cd7d571010001f7$export$8f34ce051745d39e = `VqplxG_handle`;
$4cd7d571010001f7$export$fe2e36411d703b3d = `VqplxG_section`;
$4cd7d571010001f7$export$5a1dbaa3e4449344 = `VqplxG_sections`;
$4cd7d571010001f7$export$3e523c77c1f23f8c = `VqplxG_separator`;
$4cd7d571010001f7$export$6ea4444824e687db = `VqplxG_story-title`;
$4cd7d571010001f7$export$fb184b623420d9be = `VqplxG_title`;
$4cd7d571010001f7$export$8465d27022f5235a = `VqplxG_title-icon`;
$4cd7d571010001f7$export$e6ca8839261504b0 = `VqplxG_truncate-text`;

});


parcelRegister("j4LwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef249a5174f0efc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $lCpfo = parcelRequire("lCpfo");
const $ef249a5174f0efc4$var$KeyboardShortcutTooltip = ({ letter: letter, message: message })=>(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ef249a5174f0efc4$var$tooltipContainerStyles
    }, message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ef249a5174f0efc4$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), message)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ef249a5174f0efc4$var$shortcutContainerStyles
    }, letter)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lCpfo.tooltipContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lCpfo.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lCpfo.shortcutContainer
    }, letter));
const $ef249a5174f0efc4$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: '0',
    paddingRight: '0'
});
const $ef249a5174f0efc4$var$shortcutContainerStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.neutral',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'color.border.inverse',
    borderRadius: '2px',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    marginTop: 'space.025',
    marginBottom: 'space.025',
    marginRight: '0',
    marginLeft: '0'
});
const $ef249a5174f0efc4$var$textContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    marginRight: 'space.050'
});
var $ef249a5174f0efc4$export$2e2bcd8739ae039 = $ef249a5174f0efc4$var$KeyboardShortcutTooltip;

});
parcelRegister("lCpfo", function(module, exports) {

$parcel$export(module.exports, "shortcutContainer", () => $fbd0bb2da54dc016$export$6c378f4d39cba4ad, (v) => $fbd0bb2da54dc016$export$6c378f4d39cba4ad = v);
$parcel$export(module.exports, "textContainer", () => $fbd0bb2da54dc016$export$2cedfd664bb3bd01, (v) => $fbd0bb2da54dc016$export$2cedfd664bb3bd01 = v);
$parcel$export(module.exports, "tooltipContainer", () => $fbd0bb2da54dc016$export$3fcce5d0c5d151e1, (v) => $fbd0bb2da54dc016$export$3fcce5d0c5d151e1 = v);
var $fbd0bb2da54dc016$export$6c378f4d39cba4ad;
var $fbd0bb2da54dc016$export$2cedfd664bb3bd01;
var $fbd0bb2da54dc016$export$3fcce5d0c5d151e1;
$fbd0bb2da54dc016$export$6c378f4d39cba4ad = `iM7JoW_shortcutContainer`;
$fbd0bb2da54dc016$export$2cedfd664bb3bd01 = `iM7JoW_textContainer`;
$fbd0bb2da54dc016$export$3fcce5d0c5d151e1 = `iM7JoW_tooltipContainer`;

});


parcelRegister("dw8TK", function(module, exports) {

$parcel$export(module.exports, "UseShortcuts", () => $44fc0d4a8a7a90b7$export$65eedd797745cae9);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $7Q1yP = parcelRequire("7Q1yP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $gkgJN = parcelRequire("gkgJN");
const $44fc0d4a8a7a90b7$export$a1ca853c6e4bb6fb = (key, callback)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [actionSubject, action] = (0, $9a231222eda807fc$export$6a05d0dd2493170b).split(' ');
    const analyticsEvent = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const [{ isEnabled: isKeyboardShortcutsEnabled }] = (0, $7Q1yP.useKeyboardShortcutsToggle)();
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (!(0, $gkgJN.isRelevantKeyEvent)(e) || !isKeyboardShortcutsEnabled) return;
        if (e.code === key) {
            e.preventDefault();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), {
                key: e.code
            });
            callback(e);
        }
    }, [
        action,
        actionSubject,
        analyticsEvent,
        callback,
        isKeyboardShortcutsEnabled,
        key
    ]);
    const debouncedHandleKeyDown = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(handleKeyDown, 1000, {
        leading: true
    }));
    (0, $eUqFw.useEffect)(()=>{
        debouncedHandleKeyDown.current = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(handleKeyDown, 1000, {
            leading: true
        });
    }, [
        isKeyboardShortcutsEnabled,
        handleKeyDown
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handler = (e)=>debouncedHandleKeyDown.current(e);
        document.addEventListener('keydown', handler);
        return ()=>document.removeEventListener('keydown', handler);
    }, []);
};
const $44fc0d4a8a7a90b7$export$65eedd797745cae9 = ({ shortcutKey: shortcutKey, onKeyDown: onKeyDown })=>{
    $44fc0d4a8a7a90b7$export$a1ca853c6e4bb6fb(shortcutKey, onKeyDown);
    return null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

const $9a231222eda807fc$export$6a05d0dd2493170b = 'arjKeyboardShortcut pressed';

parcelRegister("gkgJN", function(module, exports) {

$parcel$export(module.exports, "isRelevantKeyEvent", () => $928e9065c32f55c5$export$f1fe560ca916816e);
const $928e9065c32f55c5$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
const $928e9065c32f55c5$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $928e9065c32f55c5$var$isEditable = (node)=>node.nodeName === 'INPUT' || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
const $928e9065c32f55c5$export$f1fe560ca916816e = (e)=>{
    const { key: key, target: target } = e;
    return target && target instanceof HTMLElement && typeof e.key === 'string' && (e.key === 'Escape' || !$928e9065c32f55c5$var$isEditable(target) && !$928e9065c32f55c5$var$ignoredKeys[key]) && !($928e9065c32f55c5$export$6159e43e50a41987() && e.metaKey || !$928e9065c32f55c5$export$6159e43e50a41987() && e.ctrlKey);
};

});


parcelRegister("lf4fN", function(module, exports) {

$parcel$export(module.exports, "ADD_FIELDS_COLUMN_ID", () => $c3bc04c86c5dbc89$export$302cf7e916671595);
$parcel$export(module.exports, "getColumnIds", () => $c3bc04c86c5dbc89$export$3d88032e6be0ee47);
$parcel$export(module.exports, "defaultWidthOfColumnTimeline", () => $c3bc04c86c5dbc89$export$2430e422fe504be0);
$parcel$export(module.exports, "defaultWidthOfColumnList", () => $c3bc04c86c5dbc89$export$6743df29cb997fb5);
$parcel$export(module.exports, "isColumnId", () => $c3bc04c86c5dbc89$export$e10c6e1e5f10eae8);

var $1ybV0 = parcelRequire("1ybV0");

var $5rYNM = parcelRequire("5rYNM");
const $c3bc04c86c5dbc89$export$302cf7e916671595 = 'addFields';
const $c3bc04c86c5dbc89$var$columnIds = [
    'targetStart',
    'targetEnd',
    'assignee',
    'team',
    'issueStatus',
    'release',
    'estimate',
    'breakdown',
    'progressByEstimation',
    'sprint',
    'incomingDependencies',
    'outgoingDependencies',
    'components',
    'labels',
    'dueDate',
    'parent',
    'priority',
    'reporter',
    'goal',
    $c3bc04c86c5dbc89$export$302cf7e916671595
];
const $c3bc04c86c5dbc89$var$columnIdsWithIdeas = [
    'targetStart',
    'targetEnd',
    'assignee',
    'team',
    'issueStatus',
    'release',
    'estimate',
    'breakdown',
    'progressByEstimation',
    'sprint',
    'incomingDependencies',
    'outgoingDependencies',
    'components',
    'labels',
    'dueDate',
    'parent',
    'priority',
    'reporter',
    'goal',
    'ideas',
    $c3bc04c86c5dbc89$export$302cf7e916671595
];
const $c3bc04c86c5dbc89$export$3d88032e6be0ee47 = ()=>(0, $1ybV0.ff)('polaris-arj-ideas') ? $c3bc04c86c5dbc89$var$columnIdsWithIdeas : $c3bc04c86c5dbc89$var$columnIds;
const $c3bc04c86c5dbc89$export$2430e422fe504be0 = {
    targetStart: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    targetEnd: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    assignee: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    team: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    issueStatus: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    release: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    estimate: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    breakdown: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    progressByEstimation: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    sprint: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    incomingDependencies: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    outgoingDependencies: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    components: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    ideas: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    labels: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    dueDate: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    parent: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    priority: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    reporter: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    addFields: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    [(0, $5rYNM.CustomFieldTypes).TextField]: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    [(0, $5rYNM.CustomFieldTypes).MultiSelect]: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    [(0, $5rYNM.CustomFieldTypes).AssetObject]: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    [(0, $5rYNM.CustomFieldTypes).SingleSelect]: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    DEFAULT: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM
};
const $c3bc04c86c5dbc89$export$6743df29cb997fb5 = {
    assignee: (0, $5rYNM.DEFAULT_FIELD_WIDTH).EXTRALARGE,
    targetStart: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    targetEnd: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    issueStatus: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    dueDate: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    [(0, $5rYNM.CustomFieldTypes).DatePicker]: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
    estimate: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    priority: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM,
    DEFAULT: (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE
};
function $c3bc04c86c5dbc89$export$e10c6e1e5f10eae8(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $c3bc04c86c5dbc89$export$3d88032e6be0ee47().includes(key);
}

});

parcelRegister("NeuAT", function(module, exports) {

$parcel$export(module.exports, "getPlanId", () => $4832fbf4f4e089b8$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "getScenarioId", () => $4832fbf4f4e089b8$export$8572797243a693b9);
$parcel$export(module.exports, "getReportHash", () => $4832fbf4f4e089b8$export$bba909e367ded43b);

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");
const $4832fbf4f4e089b8$export$2d09f4703b637141 = (param)=>{
    const paramMatch = window.location.search.match(`[?&]${param}=([^&]*)`);
    if (paramMatch) return paramMatch[1];
    return undefined;
};
const $4832fbf4f4e089b8$export$203ed8b65c3b2a28 = ()=>+(0, $lFLge.getPathParams)().id || undefined;
const $4832fbf4f4e089b8$export$8572797243a693b9 = ()=>+(0, $lFLge.getPathParams)().sid || undefined;
const $4832fbf4f4e089b8$export$b86807180a5e2759 = ()=>+$4832fbf4f4e089b8$export$2d09f4703b637141('vid') || undefined;
const $4832fbf4f4e089b8$export$bba909e367ded43b = ()=>{
    // Path parameter is passed when serving the report view in SPA
    if ((0, $7CnHa.isDefined)((0, $lFLge.getPathParams)().r)) return (0, $lFLge.getPathParams)().r;
    // URL parameter is passed when serving PortfolioEmbeddedReportView.jspa or PlanEmbeddedReportView.jspa
    return $4832fbf4f4e089b8$export$2d09f4703b637141('r');
};

});

parcelRegister("9NSUz", function(module, exports) {

$parcel$export(module.exports, "getEstimateColumnTitle", () => $0d6ad736ac0b0aeb$export$961e02836694eb96);
$parcel$export(module.exports, "getProgressByEstimateColumnTitle", () => $0d6ad736ac0b0aeb$export$8b71285ce3a3c6ed);
$parcel$export(module.exports, "getConfiguredDateTooltip", () => $0d6ad736ac0b0aeb$export$d1378ae5a88a63b9);
$parcel$export(module.exports, "getHeaderMessage", () => $0d6ad736ac0b0aeb$export$9872ef3877d2d3b2);
$parcel$export(module.exports, "default", () => $0d6ad736ac0b0aeb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $bOL8s = parcelRequire("bOL8s");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");
const $0d6ad736ac0b0aeb$var$planningUnits = {
    storyPoints: 'StoryPoints',
    days: 'Days',
    hours: 'Hours'
};
const $0d6ad736ac0b0aeb$var$messages = (0, $90IgZ.defineMessages)({
    targetStartColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.target-start-column-header",
        "defaultMessage": "Target start"
    },
    targetEndColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.target-end-column-header",
        "defaultMessage": "Target end"
    },
    unmappedColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.unmapped-column-header",
        "defaultMessage": "Unmapped"
    },
    teamColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.team-column-header",
        "defaultMessage": "Team"
    },
    issueStatusColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.issue-status-column-header",
        "defaultMessage": "Status"
    },
    storyPointsEstimateColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.story-points-estimate-column-header",
        "defaultMessage": "Story points"
    },
    hoursEstimateColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.hours-estimate-column-header",
        "defaultMessage": "Estimates (h)"
    },
    daysEstimateColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.days-estimate-column-header",
        "defaultMessage": "Estimates (d)"
    },
    breakdownColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.breakdown-column-header",
        "defaultMessage": "Progress (issue count)"
    },
    progressEstimateByPointsColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-points-column-header",
        "defaultMessage": "Progress (story points)"
    },
    progressEstimateByHoursColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-hours-column-header",
        "defaultMessage": "Progress (hours)"
    },
    progressEstimateByDaysColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.progress-estimate-by-days-column-header",
        "defaultMessage": "Progress (days)"
    },
    incomingDependenciesColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.incoming-dependencies-column-header",
        "defaultMessage": "Incoming dependencies"
    },
    outgoingDependenciesColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.outgoing-dependencies-column-header",
        "defaultMessage": "Outgoing dependencies"
    },
    dependenciesColumnsHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.dependencies-columns-header",
        "defaultMessage": "Dependencies"
    },
    componentsColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.components-column-header",
        "defaultMessage": "Components"
    },
    labelsColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.labels-column-header",
        "defaultMessage": "Labels"
    },
    parentColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.parent-column-header",
        "defaultMessage": "Parent"
    },
    priorityColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.priority-column-header",
        "defaultMessage": "Priority"
    },
    goalColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.goal-column-header",
        "defaultMessage": "Goal"
    },
    ideasColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.ideas-column-header",
        "defaultMessage": "Idea"
    },
    configuredDateStart: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.configured-date-start",
        "defaultMessage": "{title} is being used as the start date for the issues in this plan."
    },
    configuredDateEnd: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.configured-date-end",
        "defaultMessage": "{title} is being used as the end date for the issues in this plan."
    },
    addFieldsColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.add-fields-column-header",
        "defaultMessage": "Add fields"
    }
});
const $0d6ad736ac0b0aeb$export$961e02836694eb96 = (planningUnit)=>{
    switch(planningUnit){
        case $0d6ad736ac0b0aeb$var$planningUnits.storyPoints:
            return $0d6ad736ac0b0aeb$var$messages.storyPointsEstimateColumnHeader;
        case $0d6ad736ac0b0aeb$var$planningUnits.days:
            return $0d6ad736ac0b0aeb$var$messages.daysEstimateColumnHeader;
        case $0d6ad736ac0b0aeb$var$planningUnits.hours:
        default:
            return $0d6ad736ac0b0aeb$var$messages.hoursEstimateColumnHeader;
    }
};
const $0d6ad736ac0b0aeb$export$8b71285ce3a3c6ed = (planningUnit)=>{
    switch(planningUnit){
        case $0d6ad736ac0b0aeb$var$planningUnits.storyPoints:
            return $0d6ad736ac0b0aeb$var$messages.progressEstimateByPointsColumnHeader;
        case $0d6ad736ac0b0aeb$var$planningUnits.days:
            return $0d6ad736ac0b0aeb$var$messages.progressEstimateByDaysColumnHeader;
        case $0d6ad736ac0b0aeb$var$planningUnits.hours:
        default:
            return $0d6ad736ac0b0aeb$var$messages.progressEstimateByHoursColumnHeader;
    }
};
const $0d6ad736ac0b0aeb$export$d1378ae5a88a63b9 = (configurableDate)=>{
    switch(configurableDate){
        case (0, $bOL8s.ConfigurableDateTypes).start:
            return $0d6ad736ac0b0aeb$var$messages.configuredDateStart;
        case (0, $bOL8s.ConfigurableDateTypes).end:
            return $0d6ad736ac0b0aeb$var$messages.configuredDateEnd;
        default:
    }
};
const $0d6ad736ac0b0aeb$export$9872ef3877d2d3b2 = (sectionId, planningUnit)=>{
    switch(sectionId){
        case 'targetStart':
            return $0d6ad736ac0b0aeb$var$messages.targetStartColumnHeader;
        case 'targetEnd':
            return $0d6ad736ac0b0aeb$var$messages.targetEndColumnHeader;
        case 'dueDate':
            return (0, $ib5d3.default).dueDate;
        case 'assignee':
            return (0, $ib5d3.default).assignee;
        case 'sprint':
            return (0, $ib5d3.default).sprint;
        case 'unmapped':
            return $0d6ad736ac0b0aeb$var$messages.unmappedColumnHeader;
        case 'team':
            return $0d6ad736ac0b0aeb$var$messages.teamColumnHeader;
        case 'issueStatus':
            return $0d6ad736ac0b0aeb$var$messages.issueStatusColumnHeader;
        case 'release':
            return (0, $ib5d3.default).releases;
        case 'breakdown':
            return $0d6ad736ac0b0aeb$var$messages.breakdownColumnHeader;
        case 'incomingDependencies':
            return $0d6ad736ac0b0aeb$var$messages.incomingDependenciesColumnHeader;
        case 'outgoingDependencies':
            return $0d6ad736ac0b0aeb$var$messages.outgoingDependenciesColumnHeader;
        case 'dependencies':
            return $0d6ad736ac0b0aeb$var$messages.dependenciesColumnsHeader;
        case 'components':
            return $0d6ad736ac0b0aeb$var$messages.componentsColumnHeader;
        case 'labels':
            return $0d6ad736ac0b0aeb$var$messages.labelsColumnHeader;
        case 'parent':
            return $0d6ad736ac0b0aeb$var$messages.parentColumnHeader;
        case 'priority':
            return $0d6ad736ac0b0aeb$var$messages.priorityColumnHeader;
        case 'estimate':
            switch(planningUnit){
                case (0, $5rYNM.PLANNING_UNITS).HOURS:
                    return $0d6ad736ac0b0aeb$var$messages.hoursEstimateColumnHeader;
                case (0, $5rYNM.PLANNING_UNITS).STORY_POINTS:
                    return $0d6ad736ac0b0aeb$var$messages.storyPointsEstimateColumnHeader;
                case (0, $5rYNM.PLANNING_UNITS).DAYS:
                    return $0d6ad736ac0b0aeb$var$messages.daysEstimateColumnHeader;
                default:
                    return undefined;
            }
        case 'progressByEstimation':
            switch(planningUnit){
                case (0, $5rYNM.PLANNING_UNITS).HOURS:
                    return $0d6ad736ac0b0aeb$var$messages.progressEstimateByHoursColumnHeader;
                case (0, $5rYNM.PLANNING_UNITS).STORY_POINTS:
                    return $0d6ad736ac0b0aeb$var$messages.progressEstimateByPointsColumnHeader;
                case (0, $5rYNM.PLANNING_UNITS).DAYS:
                    return $0d6ad736ac0b0aeb$var$messages.progressEstimateByDaysColumnHeader;
                default:
                    return undefined;
            }
        default:
    }
};
var $0d6ad736ac0b0aeb$export$2e2bcd8739ae039 = $0d6ad736ac0b0aeb$var$messages;

});
parcelRegister("bOL8s", function(module, exports) {

$parcel$export(module.exports, "ConfigurableDateTypes", () => $49141df0db4ab5a1$export$e202020d6b90ab1e);
// eslint-disable-next-line jira/restricted/react-component-props
const $49141df0db4ab5a1$export$e202020d6b90ab1e = Object.freeze({
    start: 'CONFIGURABLE_DATE_START',
    end: 'CONFIGURABLE_DATE_END'
});
const $49141df0db4ab5a1$export$4d4da49430f168be = '@portfolio/common/sections';

});


parcelRegister("gGKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d1c940b21500cd3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SelectForColumnCell", () => $8d1c940b21500cd3$export$6385b193dd4b511d);
$parcel$export(module.exports, "CellSelectWithRollup", () => $8d1c940b21500cd3$export$716b30d2725b585e);
$parcel$export(module.exports, "selectUtils", () => (parcelRequire("akSC8")).selectUtils);
$parcel$export(module.exports, "AsyncSelect", () => (parcelRequire("2LimL")).AsyncSelect);
$parcel$export(module.exports, "MIN_SELECT_WIDTH", () => (parcelRequire("2LimL")).MIN_SELECT_WIDTH);

var $lNNXV = parcelRequire("lNNXV");

var $97R39 = parcelRequire("97R39");

var $7QdY9 = parcelRequire("7QdY9");

var $2LimL = parcelRequire("2LimL");

var $jOSAg = parcelRequire("jOSAg");

var $akSC8 = parcelRequire("akSC8");
var $8d1c940b21500cd3$export$2e2bcd8739ae039 = (0, $2LimL.default);
const $8d1c940b21500cd3$export$6385b193dd4b511d = (0, $lNNXV.connect)(null, (0, $97R39.default))((0, $2LimL.SelectForColumnCell));
const $8d1c940b21500cd3$export$716b30d2725b585e = (0, $lNNXV.connect)((0, $7QdY9.default), (0, $97R39.default))((0, $jOSAg.default));

});
parcelRegister("97R39", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2dc0723bb93195$export$2e2bcd8739ae039);
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b2dc0723bb93195$export$2e2bcd8739ae039 = (dispatch, ownProps)=>({
        lockInlineCreate: (isLocked)=>{
            dispatch((0, $dr4qD.setOpenLocked)({
                attribute: ownProps.attribute,
                isLocked: isLocked
            }));
        }
    });

});
parcelRegister("fk2gn", function(module, exports) {

$parcel$export(module.exports, "inlineCreateIssue", () => $04fc6423361c7704$export$6a4019ebc77bfcad);
$parcel$export(module.exports, "startInlineCreate", () => $04fc6423361c7704$export$3b53adae66ce2b28);
$parcel$export(module.exports, "default", () => $04fc6423361c7704$export$2e2bcd8739ae039);
$parcel$export(module.exports, "clearInlineCreate", () => (parcelRequire("dr4qD")).clearInlineCreate);
$parcel$export(module.exports, "setIssueTypeId", () => (parcelRequire("dr4qD")).setIssueTypeId);
$parcel$export(module.exports, "setProjectId", () => (parcelRequire("dr4qD")).setProjectId);
$parcel$export(module.exports, "updateInlineCreate", () => (parcelRequire("dr4qD")).updateInlineCreate);
$parcel$export(module.exports, "setSiblingId", () => (parcelRequire("dr4qD")).setSiblingId);
$parcel$export(module.exports, "setIssueTypeIdForHierarchy", () => (parcelRequire("dr4qD")).setIssueTypeIdForHierarchy);
$parcel$export(module.exports, "setGlobalCreateIssue", () => (parcelRequire("dr4qD")).setGlobalCreateIssue);
$parcel$export(module.exports, "setOpenLocked", () => (parcelRequire("dr4qD")).setOpenLocked);
parcelRequire("inLJ0");
var $71txE = parcelRequire("71txE");

var $01zCq = parcelRequire("01zCq");
var $kjklK = parcelRequire("kjklK");
var $3G9Az = parcelRequire("3G9Az");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $lPQPn = parcelRequire("lPQPn");

var $8YqJS = parcelRequire("8YqJS");

var $cbq3D = parcelRequire("cbq3D");

var $lvJU2 = parcelRequire("lvJU2");

var $cwMfk = parcelRequire("cwMfk");

var $ehEr2 = parcelRequire("ehEr2");
parcelRequire("40hi6");
var $dJx9o = parcelRequire("dJx9o");
var $40hi6 = parcelRequire("40hi6");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $c7fhc = parcelRequire("c7fhc");

var $dr4qD = parcelRequire("dr4qD");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

const $04fc6423361c7704$export$1102f55b777d8730 = (payload)=>({
        type: (0, $83cf706a87a62789$export$242fccfb90c57247),
        payload: payload
    });
const $04fc6423361c7704$export$bcd650ef032c77dd = 'command.inline-create.INLINE_CREATE_ISSUE';
const $04fc6423361c7704$export$e4b545016f01a38c = 'command.inline-create.START_INLINE_CREATE';
const $04fc6423361c7704$export$6a4019ebc77bfcad = (title)=>({
        type: $04fc6423361c7704$export$bcd650ef032c77dd,
        payload: {
            title: title
        }
    });
const $04fc6423361c7704$export$3b53adae66ce2b28 = (payload)=>({
        type: $04fc6423361c7704$export$e4b545016f01a38c,
        payload: payload
    });
function* $04fc6423361c7704$export$97cc3cee1b036b4c(group, groupCombination = {}, projectId) {
    if (group === (0, $40hi6.UNDEFINED_GROUP)) return {};
    const grouping = yield (0, $9e8i2.select)((0, $kyGCj.getVisualisationGrouping));
    switch(grouping){
        case (0, $5rYNM.GROUPING).ASSIGNEE:
        case (0, $5rYNM.GROUPING).TEAM:
        case (0, $5rYNM.GROUPING).SPRINT:
            return groupCombination;
        case (0, $5rYNM.GROUPING).COMPONENT:
            {
                const componentGroupsById = yield (0, $9e8i2.select)((0, $9H2AP.getComponentGroupsById));
                if (!(0, $7CnHa.isDefined)(groupCombination.components)) return {};
                /*
               we could include components from different projects in one component group, so when presetting
               the components value to a new issue, we should filter the components in the component group by the project id to
               prevent assigning other project's componentto the new issue
            */ const componentsByProjectId = yield (0, $9e8i2.select)((0, $lvJU2.getComponentsByProjectId));
                const componentIdsOfProject = (componentsByProjectId[projectId] || []).map((component)=>component.id);
                const componentsValues = ($kjklK.default(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                [
                    groupCombination.components,
                    'components'
                ], componentGroupsById) || []).filter((componentId)=>componentIdsOfProject.includes(componentId));
                return {
                    components: componentsValues
                };
            }
        case (0, $5rYNM.GROUPING).LABEL:
            {
                const labelGroupsById = yield (0, $9e8i2.select)((0, $9H2AP.getLabelGroupsById));
                if (!(0, $7CnHa.isDefined)(groupCombination.labels)) return {};
                return {
                    labels: $kjklK.default([
                        groupCombination.labels,
                        'labels'
                    ], labelGroupsById)
                };
            }
        case (0, $5rYNM.GROUPING).RELEASE:
            return {
                fixVersions: [
                    groupCombination.release
                ]
            };
        case (0, $ayXoc.isRoadmapGroupedByCustomField)(grouping) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        grouping || '':
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (!(0, $7CnHa.isDefined)(groupCombination[grouping])) return {};
                const groupAttribute = (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping);
                const groupByMultiValueCustomField = yield (0, $9e8i2.select)((0, $kyGCj.isGroupByMultiValueCustomField));
                const customFieldValuesGroupsById = yield (0, $9e8i2.select)((0, $kyGCj.getCustomFieldValuesGroupsById));
                if (groupByMultiValueCustomField) {
                    const groupValues = $kjklK.default([
                        groupCombination[grouping] ?? '',
                        grouping
                    ], customFieldValuesGroupsById);
                    return {
                        customFields: {
                            [groupAttribute]: groupValues?.map((value)=>typeof value === 'string' ? value : $3G9Az.default(value))
                        }
                    };
                }
                return {
                    customFields: {
                        [groupAttribute]: groupCombination[grouping]
                    }
                };
            }
        default:
            return {};
    }
}
function* $04fc6423361c7704$export$18efaeddd34b9c24({ payload: payload }) {
    try {
        const { hierarchyLevel: hierarchyLevel, parentId: parentId, group: group, groupCombination: groupCombination, grouping: grouping, projectId: projectId } = payload;
        const defaultProjectId = yield (0, $9e8i2.select)((0, $ehEr2.getDefaultProjectId));
        const { isGlobalCreateIssue: isGlobalCreateIssue } = yield (0, $9e8i2.select)((0, $cwMfk.getInlineCreateState));
        const valuesFromGrouping = yield (0, $9e8i2.call)($04fc6423361c7704$export$97cc3cee1b036b4c, group, groupCombination, projectId);
        if (!(0, $7CnHa.isDefined)(parentId)) {
            const groupKey = groupCombination ? `:${(0, $dJx9o.getGroupKey)(groupCombination)}` : '';
            // Expand the issuesWithoutParentHeader when creating a new issue
            yield (0, $9e8i2.put)((0, $c7fhc.setIsExpanded)({
                [`IssuesWithoutParentHeader${groupKey}`]: true
            }));
            // If the issue is created from the button in the scope header make sure the relevant hierarchy level is expanded
            yield (0, $9e8i2.put)((0, $c7fhc.setIsExpanded)({
                [`IssuesWithoutParent-${hierarchyLevel}${groupKey}`]: true
            }));
            // we want to prevent batching actions because virtual list should first update its dimensions
            // after expanding and only then to scroll
            yield (0, $9e8i2.call)((0, $71txE.delay), 0);
        }
        // if the parentId and siblingId are all null and it's not grouped by project, it is the global create issue,
        // so should use the defaultProject to init the create inline issue UI.
        if (isGlobalCreateIssue && grouping !== (0, $5rYNM.GROUPING).PROJECT) yield (0, $9e8i2.put)((0, $dr4qD.startInlineCreate)({
            ...payload,
            projectId: defaultProjectId,
            valuesFromGrouping: valuesFromGrouping
        }));
        else yield (0, $9e8i2.put)((0, $dr4qD.startInlineCreate)({
            ...payload,
            valuesFromGrouping: valuesFromGrouping
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $04fc6423361c7704$export$ce9cde4cd0f70f8d({ payload: payload }) {
    try {
        const { group: group, groupCombination: groupCombination = {}, hierarchyLevel: hierarchyLevel, issueTypeId: issueTypeId, projectId: projectId, parentId: parentId, values: values, siblingId: siblingId } = yield (0, $9e8i2.select)((0, $cwMfk.getInlineCreateState));
        const defaultIssuePriority = (yield (0, $9e8i2.select)((0, $ehEr2.getDefaultIssuePriorityByProjectId)))[projectId];
        const color = hierarchyLevel === (0, $8YqJS.EPIC_LEVEL) ? {
            color: (0, $lPQPn.toBackendColor)((0, $lPQPn.getRandomColor)())
        } : {};
        const issue = $01zCq.default(values, {
            priority: values.priority || defaultIssuePriority,
            level: hierarchyLevel,
            summary: payload.title,
            type: issueTypeId,
            project: projectId,
            ...color
        });
        yield (0, $9e8i2.put)((0, $dr4qD.startInlineCreate)({
            group: group,
            groupCombination: groupCombination,
            hierarchyLevel: hierarchyLevel,
            issueTypeId: issueTypeId,
            parentId: parentId,
            projectId: projectId,
            siblingId: siblingId,
            valuesFromGrouping: values,
            source: 'INLINE'
        }));
        if (parentId) {
            const expandedKey = group ? `${parentId}:${group}` : parentId;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issue.parent = parentId;
            yield (0, $9e8i2.put)((0, $c7fhc.setIsExpanded)({
                [expandedKey]: true
            }));
        }
        yield (0, $9e8i2.put)($04fc6423361c7704$export$1102f55b777d8730({
            issue: issue,
            sibling: siblingId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $04fc6423361c7704$export$57e2d6019587c893() {
    yield (0, $bG7pV.takeEvery)($04fc6423361c7704$export$bcd650ef032c77dd, $04fc6423361c7704$export$ce9cde4cd0f70f8d);
    yield (0, $bG7pV.takeEvery)($04fc6423361c7704$export$e4b545016f01a38c, $04fc6423361c7704$export$18efaeddd34b9c24);
}
function* $04fc6423361c7704$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($04fc6423361c7704$export$57e2d6019587c893);
}

});
parcelRegister("inLJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61f6526eec0a404$export$2e2bcd8739ae039);
$parcel$export(module.exports, "delay", () => (parcelRequire("71txE")).delay);

var $kqNCK = parcelRequire("kqNCK");

var $9urCB = parcelRequire("9urCB");

var $1fYhi = parcelRequire("1fYhi");

var $4RfEe = parcelRequire("4RfEe");

var $jYyHx = parcelRequire("jYyHx");

var $71txE = parcelRequire("71txE");

var $9e8i2 = parcelRequire("9e8i2");

var $6Zcms = parcelRequire("6Zcms");

var $hIh4o = parcelRequire("hIh4o");
var $d61f6526eec0a404$export$2e2bcd8739ae039 = (0, $kqNCK.default);

});
parcelRegister("kqNCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfcbaa64667c898$export$2e2bcd8739ae039);

var $71txE = parcelRequire("71txE");

var $1fYhi = parcelRequire("1fYhi");

var $9urCB = parcelRequire("9urCB");
function $edfcbaa64667c898$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $edfcbaa64667c898$export$2e2bcd8739ae039() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _ref$context = _ref.context, context = _ref$context === undefined ? {} : _ref$context, options = $edfcbaa64667c898$var$_objectWithoutProperties(_ref, [
        'context'
    ]);
    var sagaMonitor = options.sagaMonitor, logger = options.logger, onError = options.onError;
    if ((0, $71txE.is).func(options)) throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    if (logger && !(0, $71txE.is).func(logger)) throw new Error('`options.logger` passed to the Saga middleware is not a function!');
    if (onError && !(0, $71txE.is).func(onError)) throw new Error('`options.onError` passed to the Saga middleware is not a function!');
    if (options.emitter && !(0, $71txE.is).func(options.emitter)) throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        var sagaEmitter = (0, $1fYhi.emitter)();
        sagaEmitter.emit = (options.emitter || (0, $71txE.ident))(sagaEmitter.emit);
        sagaMiddleware.run = (0, $9urCB.runSaga).bind(null, {
            context: context,
            subscribe: sagaEmitter.subscribe,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor,
            logger: logger,
            onError: onError
        });
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                sagaEmitter.emit(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    };
    sagaMiddleware.setContext = function(props) {
        (0, $71txE.check)(props, (0, $71txE.is).object, (0, $71txE.createSetContextWarning)('sagaMiddleware', props));
        (0, $71txE.object).assign(context, props);
    };
    return sagaMiddleware;
}

});
parcelRegister("71txE", function(module, exports) {

$parcel$export(module.exports, "sym", () => $51cf8ac7ad0269b0$export$fe4bf738d66b6b12);
$parcel$export(module.exports, "TASK", () => $51cf8ac7ad0269b0$export$9355e489ad16f98e);
$parcel$export(module.exports, "MATCH", () => $51cf8ac7ad0269b0$export$5a1a83be8f503735);
$parcel$export(module.exports, "CANCEL", () => $51cf8ac7ad0269b0$export$2b10f4b30fb65583);
$parcel$export(module.exports, "SAGA_ACTION", () => $51cf8ac7ad0269b0$export$7d963e45ecdffba1);
$parcel$export(module.exports, "SELF_CANCELLATION", () => $51cf8ac7ad0269b0$export$3f4d38f8b89bfda7);
$parcel$export(module.exports, "kTrue", () => $51cf8ac7ad0269b0$export$efbbf28b4361f147);
$parcel$export(module.exports, "noop", () => $51cf8ac7ad0269b0$export$8793edee2d425525);
$parcel$export(module.exports, "ident", () => $51cf8ac7ad0269b0$export$7b66c250b210a314);
$parcel$export(module.exports, "check", () => $51cf8ac7ad0269b0$export$35dc45686fc2dbd7);
$parcel$export(module.exports, "log", () => $51cf8ac7ad0269b0$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "is", () => $51cf8ac7ad0269b0$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "object", () => $51cf8ac7ad0269b0$export$be5493f9613cbbe);
$parcel$export(module.exports, "remove", () => $51cf8ac7ad0269b0$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "array", () => $51cf8ac7ad0269b0$export$2f23118c22fb2630);
$parcel$export(module.exports, "deferred", () => $51cf8ac7ad0269b0$export$b37aab7cecdd910a);
$parcel$export(module.exports, "delay", () => $51cf8ac7ad0269b0$export$1391212d75b2ee65);
$parcel$export(module.exports, "uid", () => $51cf8ac7ad0269b0$export$e2a22331486dcca0);
$parcel$export(module.exports, "makeIterator", () => $51cf8ac7ad0269b0$export$81c40ebfe660d3ca);
$parcel$export(module.exports, "deprecate", () => $51cf8ac7ad0269b0$export$b680e6b2c82f8c2f);
$parcel$export(module.exports, "updateIncentive", () => $51cf8ac7ad0269b0$export$415a43e38195481b);
$parcel$export(module.exports, "internalErr", () => $51cf8ac7ad0269b0$export$7127e4a0685605ed);
$parcel$export(module.exports, "createSetContextWarning", () => $51cf8ac7ad0269b0$export$8f9f9318fd98b7c9);
$parcel$export(module.exports, "wrapSagaDispatch", () => $51cf8ac7ad0269b0$export$e34107956f29fe3b);
var $51cf8ac7ad0269b0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $51cf8ac7ad0269b0$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $51cf8ac7ad0269b0$export$fe4bf738d66b6b12 = function sym(id) {
    return '@@redux-saga/' + id;
};
var $51cf8ac7ad0269b0$export$9355e489ad16f98e = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('TASK');
var $51cf8ac7ad0269b0$export$6f5f529ff1aab24d = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('HELPER');
var $51cf8ac7ad0269b0$export$5a1a83be8f503735 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('MATCH');
var $51cf8ac7ad0269b0$export$2b10f4b30fb65583 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('CANCEL_PROMISE');
var $51cf8ac7ad0269b0$export$7d963e45ecdffba1 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('SAGA_ACTION');
var $51cf8ac7ad0269b0$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$fe4bf738d66b6b12('SELF_CANCELLATION');
var $51cf8ac7ad0269b0$export$bb6635af2cb49569 = function konst(v) {
    return function() {
        return v;
    };
};
var $51cf8ac7ad0269b0$export$efbbf28b4361f147 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$bb6635af2cb49569(true);
var $51cf8ac7ad0269b0$export$9842751ca2ee3424 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$bb6635af2cb49569(false);
var $51cf8ac7ad0269b0$export$8793edee2d425525 = function noop() {};
var $51cf8ac7ad0269b0$export$7b66c250b210a314 = function ident(v) {
    return v;
};
function $51cf8ac7ad0269b0$export$35dc45686fc2dbd7(value, predicate, error) {
    if (!predicate(value)) {
        $51cf8ac7ad0269b0$export$bef1f36f5486a6a3('error', 'uncaught at check', error);
        throw new Error(error);
    }
}
var $51cf8ac7ad0269b0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $51cf8ac7ad0269b0$export$b5a638e9b3fff9f3(object, property) {
    return $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.notUndef(object) && $51cf8ac7ad0269b0$var$hasOwnProperty.call(object, property);
}
var $51cf8ac7ad0269b0$export$226b3eccf92c9ed9 = {
    undef: function undef(v) {
        return v === null || v === undefined;
    },
    notUndef: function notUndef(v) {
        return v !== null && v !== undefined;
    },
    func: function func(f) {
        return typeof f === 'function';
    },
    number: function number(n) {
        return typeof n === 'number';
    },
    string: function string(s) {
        return typeof s === 'string';
    },
    array: Array.isArray,
    object: function object(obj) {
        return obj && !$51cf8ac7ad0269b0$export$226b3eccf92c9ed9.array(obj) && (typeof obj === 'undefined' ? 'undefined' : $51cf8ac7ad0269b0$var$_typeof(obj)) === 'object';
    },
    promise: function promise(p) {
        return p && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(p.then);
    },
    iterator: function iterator(it) {
        return it && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(it.next) && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(it.throw);
    },
    iterable: function iterable(it) {
        return it && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(Symbol) ? $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(it[Symbol.iterator]) : $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.array(it);
    },
    task: function task(t) {
        return t && t[$51cf8ac7ad0269b0$export$9355e489ad16f98e];
    },
    observable: function observable(ob) {
        return ob && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(ob.subscribe);
    },
    buffer: function buffer(buf) {
        return buf && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(buf.isEmpty) && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(buf.take) && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(buf.put);
    },
    pattern: function pattern(pat) {
        return pat && ($51cf8ac7ad0269b0$export$226b3eccf92c9ed9.string(pat) || (typeof pat === 'undefined' ? 'undefined' : $51cf8ac7ad0269b0$var$_typeof(pat)) === 'symbol' || $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(pat) || $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.array(pat));
    },
    channel: function channel(ch) {
        return ch && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(ch.take) && $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(ch.close);
    },
    helper: function helper(it) {
        return it && it[$51cf8ac7ad0269b0$export$6f5f529ff1aab24d];
    },
    stringableFunc: function stringableFunc(f) {
        return $51cf8ac7ad0269b0$export$226b3eccf92c9ed9.func(f) && $51cf8ac7ad0269b0$export$b5a638e9b3fff9f3(f, 'toString');
    }
};
var $51cf8ac7ad0269b0$export$be5493f9613cbbe = {
    assign: function assign(target, source) {
        for(var i in source)if ($51cf8ac7ad0269b0$export$b5a638e9b3fff9f3(source, i)) target[i] = source[i];
    }
};
function $51cf8ac7ad0269b0$export$cd7f480d6b8286c3(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
var $51cf8ac7ad0269b0$export$2f23118c22fb2630 = {
    from: function from(obj) {
        var arr = Array(obj.length);
        for(var i in obj)if ($51cf8ac7ad0269b0$export$b5a638e9b3fff9f3(obj, i)) arr[i] = obj[i];
        return arr;
    }
};
function $51cf8ac7ad0269b0$export$b37aab7cecdd910a() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var def = $51cf8ac7ad0269b0$var$_extends({}, props);
    var promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    def.promise = promise;
    return def;
}
function $51cf8ac7ad0269b0$export$2d997e4cfcc3111d(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($51cf8ac7ad0269b0$export$b37aab7cecdd910a());
    return arr;
}
function $51cf8ac7ad0269b0$export$1391212d75b2ee65(ms) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var timeoutId = void 0;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(function() {
            return resolve(val);
        }, ms);
    });
    promise[$51cf8ac7ad0269b0$export$2b10f4b30fb65583] = function() {
        return clearTimeout(timeoutId);
    };
    return promise;
}
function $51cf8ac7ad0269b0$export$d17c7504aef5c28d() {
    var _ref;
    var running = true;
    var _result = void 0, _error = void 0;
    return _ref = {}, _ref[$51cf8ac7ad0269b0$export$9355e489ad16f98e] = true, _ref.isRunning = function isRunning() {
        return running;
    }, _ref.result = function result() {
        return _result;
    }, _ref.error = function error() {
        return _error;
    }, _ref.setRunning = function setRunning(b) {
        return running = b;
    }, _ref.setResult = function setResult(r) {
        return _result = r;
    }, _ref.setError = function setError(e) {
        return _error = e;
    }, _ref;
}
function $51cf8ac7ad0269b0$export$7b18e57694835208() {
    var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return function() {
        return ++seed;
    };
}
var $51cf8ac7ad0269b0$export$e2a22331486dcca0 = /*#__PURE__*/ $51cf8ac7ad0269b0$export$7b18e57694835208();
var $51cf8ac7ad0269b0$var$kThrow = function kThrow(err) {
    throw err;
};
var $51cf8ac7ad0269b0$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $51cf8ac7ad0269b0$export$81c40ebfe660d3ca(next) {
    var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $51cf8ac7ad0269b0$var$kThrow;
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var isHelper = arguments[3];
    var iterator = {
        name: name,
        next: next,
        throw: thro,
        return: $51cf8ac7ad0269b0$var$kReturn
    };
    if (isHelper) iterator[$51cf8ac7ad0269b0$export$6f5f529ff1aab24d] = true;
    if (typeof Symbol !== 'undefined') iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $51cf8ac7ad0269b0$export$bef1f36f5486a6a3(level, message) {
    var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    /*eslint-disable no-console*/ if (typeof window === 'undefined') console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
    else console[level](message, error);
}
function $51cf8ac7ad0269b0$export$b680e6b2c82f8c2f(fn, deprecationWarning) {
    return function() {
        return fn.apply(undefined, arguments);
    };
}
var $51cf8ac7ad0269b0$export$415a43e38195481b = function updateIncentive(deprecated, preferred) {
    return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};
var $51cf8ac7ad0269b0$export$7127e4a0685605ed = function internalErr(err) {
    return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
var $51cf8ac7ad0269b0$export$8f9f9318fd98b7c9 = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};
var $51cf8ac7ad0269b0$export$e34107956f29fe3b = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, $51cf8ac7ad0269b0$export$7d963e45ecdffba1, {
            value: true
        }));
    };
};
var $51cf8ac7ad0269b0$export$f2053ff14a3b4370 = function cloneableGenerator(generatorFunc) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var history = [];
        var gen = generatorFunc.apply(undefined, args);
        return {
            next: function next(arg) {
                history.push(arg);
                return gen.next(arg);
            },
            clone: function clone() {
                var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
                history.forEach(function(arg) {
                    return clonedGen.next(arg);
                });
                return clonedGen;
            },
            return: function _return(value) {
                return gen.return(value);
            },
            throw: function _throw(exception) {
                return gen.throw(exception);
            }
        };
    };
};

});

parcelRegister("1fYhi", function(module, exports) {

$parcel$export(module.exports, "END", () => $0ea5f31fc5a2f90e$export$32239d68d9c6cb49);
$parcel$export(module.exports, "isEnd", () => $0ea5f31fc5a2f90e$export$42af6f45c6e0d09f);
$parcel$export(module.exports, "emitter", () => $0ea5f31fc5a2f90e$export$bad24218ebd77223);
$parcel$export(module.exports, "eventChannel", () => $0ea5f31fc5a2f90e$export$dfc3101b3180c292);
$parcel$export(module.exports, "stdChannel", () => $0ea5f31fc5a2f90e$export$e987d166a3a4f3ec);

var $71txE = parcelRequire("71txE");

var $4RfEe = parcelRequire("4RfEe");

var $bXjjV = parcelRequire("bXjjV");
var $0ea5f31fc5a2f90e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0ea5f31fc5a2f90e$var$CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var $0ea5f31fc5a2f90e$export$32239d68d9c6cb49 = {
    type: $0ea5f31fc5a2f90e$var$CHANNEL_END_TYPE
};
var $0ea5f31fc5a2f90e$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === $0ea5f31fc5a2f90e$var$CHANNEL_END_TYPE;
};
function $0ea5f31fc5a2f90e$export$bad24218ebd77223() {
    var subscribers = [];
    function subscribe(sub) {
        subscribers.push(sub);
        return function() {
            return (0, $71txE.remove)(subscribers, sub);
        };
    }
    function emit(item) {
        var arr = subscribers.slice();
        for(var i = 0, len = arr.length; i < len; i++)arr[i](item);
    }
    return {
        subscribe: subscribe,
        emit: emit
    };
}
var $0ea5f31fc5a2f90e$export$bf9cf0a07cf1d9ff = 'invalid buffer passed to channel factory function';
var $0ea5f31fc5a2f90e$export$8c86d8be17ae885 = 'Saga was provided with an undefined action';
function $0ea5f31fc5a2f90e$export$1f95fbd68d964d36() {
    var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $4RfEe.buffers).fixed();
    var closed = false;
    var takers = [];
    (0, $71txE.check)(buffer, (0, $71txE.is).buffer, $0ea5f31fc5a2f90e$export$bf9cf0a07cf1d9ff);
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $71txE.internalErr)('Cannot have a closed channel with pending takers');
        if (takers.length && !buffer.isEmpty()) throw (0, $71txE.internalErr)('Cannot have pending takers with non empty buffer');
    }
    function put(input) {
        checkForbiddenStates();
        (0, $71txE.check)(input, (0, $71txE.is).notUndef, $0ea5f31fc5a2f90e$export$8c86d8be17ae885);
        if (closed) return;
        if (!takers.length) return buffer.put(input);
        for(var i = 0; i < takers.length; i++){
            var cb = takers[i];
            if (!cb[0, $71txE.MATCH] || cb[0, $71txE.MATCH](input)) {
                takers.splice(i, 1);
                return cb(input);
            }
        }
    }
    function take(cb) {
        checkForbiddenStates();
        (0, $71txE.check)(cb, (0, $71txE.is).func, "channel.take's callback must be a function");
        if (closed && buffer.isEmpty()) cb($0ea5f31fc5a2f90e$export$32239d68d9c6cb49);
        else if (!buffer.isEmpty()) cb(buffer.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                return (0, $71txE.remove)(takers, cb);
            };
        }
    }
    function flush(cb) {
        checkForbiddenStates(); // TODO: check if some new state should be forbidden now
        (0, $71txE.check)(cb, (0, $71txE.is).func, "channel.flush' callback must be a function");
        if (closed && buffer.isEmpty()) {
            cb($0ea5f31fc5a2f90e$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer.flush());
    }
    function close() {
        checkForbiddenStates();
        if (!closed) {
            closed = true;
            if (takers.length) {
                var arr = takers;
                takers = [];
                for(var i = 0, len = arr.length; i < len; i++)arr[i]($0ea5f31fc5a2f90e$export$32239d68d9c6cb49);
            }
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close,
        get __takers__ () {
            return takers;
        },
        get __closed__ () {
            return closed;
        }
    };
}
function $0ea5f31fc5a2f90e$export$dfc3101b3180c292(subscribe) {
    var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $4RfEe.buffers).none();
    var matcher = arguments[2];
    /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/ if (arguments.length > 2) (0, $71txE.check)(matcher, (0, $71txE.is).func, 'Invalid match function passed to eventChannel');
    var chan = $0ea5f31fc5a2f90e$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (!chan.__closed__) {
            if (unsubscribe) unsubscribe();
            chan.close();
        }
    };
    var unsubscribe = subscribe(function(input) {
        if ($0ea5f31fc5a2f90e$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        if (matcher && !matcher(input)) return;
        chan.put(input);
    });
    if (chan.__closed__) unsubscribe();
    if (!(0, $71txE.is).func(unsubscribe)) throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $0ea5f31fc5a2f90e$export$e987d166a3a4f3ec(subscribe) {
    var chan = $0ea5f31fc5a2f90e$export$dfc3101b3180c292(function(cb) {
        return subscribe(function(input) {
            if (input[0, $71txE.SAGA_ACTION]) {
                cb(input);
                return;
            }
            (0, $bXjjV.asap)(function() {
                return cb(input);
            });
        });
    });
    return $0ea5f31fc5a2f90e$var$_extends({}, chan, {
        take: function take(cb, matcher) {
            if (arguments.length > 1) {
                (0, $71txE.check)(matcher, (0, $71txE.is).func, "channel.take's matcher argument must be a function");
                cb[0, $71txE.MATCH] = matcher;
            }
            chan.take(cb);
        }
    });
}

});
parcelRegister("4RfEe", function(module, exports) {

$parcel$export(module.exports, "buffers", () => $38983ffcdb005b72$export$e131ba331971b277);

var $71txE = parcelRequire("71txE");
var $38983ffcdb005b72$export$9293dc23fd60380b = "Channel's Buffer overflow!";
var $38983ffcdb005b72$var$ON_OVERFLOW_THROW = 1;
var $38983ffcdb005b72$var$ON_OVERFLOW_DROP = 2;
var $38983ffcdb005b72$var$ON_OVERFLOW_SLIDE = 3;
var $38983ffcdb005b72$var$ON_OVERFLOW_EXPAND = 4;
var $38983ffcdb005b72$var$zeroBuffer = {
    isEmpty: (0, $71txE.kTrue),
    put: (0, $71txE.noop),
    take: (0, $71txE.noop)
};
function $38983ffcdb005b72$var$ringBuffer() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var overflowAction = arguments[1];
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit = void 0;
                switch(overflowAction){
                    case $38983ffcdb005b72$var$ON_OVERFLOW_THROW:
                        throw new Error($38983ffcdb005b72$export$9293dc23fd60380b);
                    case $38983ffcdb005b72$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $38983ffcdb005b72$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $38983ffcdb005b72$export$e131ba331971b277 = {
    none: function none() {
        return $38983ffcdb005b72$var$zeroBuffer;
    },
    fixed: function fixed(limit) {
        return $38983ffcdb005b72$var$ringBuffer(limit, $38983ffcdb005b72$var$ON_OVERFLOW_THROW);
    },
    dropping: function dropping(limit) {
        return $38983ffcdb005b72$var$ringBuffer(limit, $38983ffcdb005b72$var$ON_OVERFLOW_DROP);
    },
    sliding: function sliding(limit) {
        return $38983ffcdb005b72$var$ringBuffer(limit, $38983ffcdb005b72$var$ON_OVERFLOW_SLIDE);
    },
    expanding: function expanding(initialSize) {
        return $38983ffcdb005b72$var$ringBuffer(initialSize, $38983ffcdb005b72$var$ON_OVERFLOW_EXPAND);
    }
};

});

parcelRegister("bXjjV", function(module, exports) {

$parcel$export(module.exports, "suspend", () => $8b4430ff40580405$export$a1428c8f7ba796e8);
$parcel$export(module.exports, "asap", () => $8b4430ff40580405$export$dc4d482300a341e1);
$parcel$export(module.exports, "flush", () => $8b4430ff40580405$export$4909b86c8034bf73);
var $8b4430ff40580405$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $8b4430ff40580405$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $8b4430ff40580405$var$exec(task) {
    try {
        $8b4430ff40580405$export$a1428c8f7ba796e8();
        task();
    } finally{
        $8b4430ff40580405$var$release();
    }
}
function $8b4430ff40580405$export$dc4d482300a341e1(task) {
    $8b4430ff40580405$var$queue.push(task);
    if (!$8b4430ff40580405$var$semaphore) {
        $8b4430ff40580405$export$a1428c8f7ba796e8();
        $8b4430ff40580405$export$4909b86c8034bf73();
    }
}
function $8b4430ff40580405$export$a1428c8f7ba796e8() {
    $8b4430ff40580405$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $8b4430ff40580405$var$release() {
    $8b4430ff40580405$var$semaphore--;
}
function $8b4430ff40580405$export$4909b86c8034bf73() {
    $8b4430ff40580405$var$release();
    var task = void 0;
    while(!$8b4430ff40580405$var$semaphore && (task = $8b4430ff40580405$var$queue.shift()) !== undefined)$8b4430ff40580405$var$exec(task);
}

});


parcelRegister("9urCB", function(module, exports) {

$parcel$export(module.exports, "runSaga", () => $6e8c57743805d014$export$3d8d44bf0c43bb61);

var $71txE = parcelRequire("71txE");

var $in7jJ = parcelRequire("in7jJ");
var $6e8c57743805d014$var$RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var $6e8c57743805d014$var$NON_GENERATOR_ERR = $6e8c57743805d014$var$RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
function $6e8c57743805d014$export$3d8d44bf0c43bb61(storeInterface, saga) {
    for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator = void 0;
    if ((0, $71txE.is).iterator(storeInterface)) {
        iterator = storeInterface;
        storeInterface = saga;
    } else {
        (0, $71txE.check)(saga, (0, $71txE.is).func, $6e8c57743805d014$var$NON_GENERATOR_ERR);
        iterator = saga.apply(undefined, args);
        (0, $71txE.check)(iterator, (0, $71txE.is).iterator, $6e8c57743805d014$var$NON_GENERATOR_ERR);
    }
    var _storeInterface = storeInterface, subscribe = _storeInterface.subscribe, dispatch = _storeInterface.dispatch, getState = _storeInterface.getState, context = _storeInterface.context, sagaMonitor = _storeInterface.sagaMonitor, logger = _storeInterface.logger, onError = _storeInterface.onError;
    var effectId = (0, $71txE.uid)();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $71txE.noop);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $71txE.noop);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $71txE.noop);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $71txE.noop);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $71txE.noop);
        sagaMonitor.effectTriggered({
            effectId: effectId,
            root: true,
            parentEffectId: 0,
            effect: {
                root: true,
                saga: saga,
                args: args
            }
        });
    }
    var task = (0, $in7jJ.default)(iterator, subscribe, (0, $71txE.wrapSagaDispatch)(dispatch), getState, context, {
        sagaMonitor: sagaMonitor,
        logger: logger,
        onError: onError
    }, effectId, saga.name);
    if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
    return task;
}

});
parcelRegister("in7jJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6000d0487a35599$export$2e2bcd8739ae039);

var $71txE = parcelRequire("71txE");

var $bXjjV = parcelRequire("bXjjV");

var $9e8i2 = parcelRequire("9e8i2");

var $1fYhi = parcelRequire("1fYhi");

var $4RfEe = parcelRequire("4RfEe");
var $d6000d0487a35599$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d6000d0487a35599$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $d6000d0487a35599$var$_defineEnumerableProperties(obj, descs) {
    for(var key in descs){
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ("value" in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
    }
    return obj;
}
var $d6000d0487a35599$export$e152ed93e7f2bba6 = 'proc first argument (Saga function result) must be an iterator';
var $d6000d0487a35599$export$ad61d2aef9f3734 = {
    toString: function toString() {
        return '@@redux-saga/CHANNEL_END';
    }
};
var $d6000d0487a35599$export$a47f788ef0b36709 = {
    toString: function toString() {
        return '@@redux-saga/TASK_CANCEL';
    }
};
var $d6000d0487a35599$var$matchers = {
    wildcard: function wildcard() {
        return 0, $71txE.kTrue;
    },
    default: function _default(pattern) {
        return (typeof pattern === 'undefined' ? 'undefined' : $d6000d0487a35599$var$_typeof(pattern)) === 'symbol' ? function(input) {
            return input.type === pattern;
        } : function(input) {
            return input.type === String(pattern);
        };
    },
    array: function array(patterns) {
        return function(input) {
            return patterns.some(function(p) {
                return $d6000d0487a35599$var$matcher(p)(input);
            });
        };
    },
    predicate: function predicate(_predicate) {
        return function(input) {
            return _predicate(input);
        };
    }
};
function $d6000d0487a35599$var$matcher(pattern) {
    // prettier-ignore
    return (pattern === '*' ? $d6000d0487a35599$var$matchers.wildcard : (0, $71txE.is).array(pattern) ? $d6000d0487a35599$var$matchers.array : (0, $71txE.is).stringableFunc(pattern) ? $d6000d0487a35599$var$matchers.default : (0, $71txE.is).func(pattern) ? $d6000d0487a35599$var$matchers.predicate : $d6000d0487a35599$var$matchers.default)(pattern);
}
/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/ function $d6000d0487a35599$var$forkQueue(name, mainTask, cb) {
    var tasks = [], result = void 0, completed = false;
    addTask(mainTask);
    function abort(err) {
        cancelAll();
        cb(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $71txE.remove)(tasks, task);
            task.cont = (0, $71txE.noop);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cb(result);
                }
            }
        };
    // task.cont.cancel = task.cancel
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $71txE.noop);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: function getTasks() {
            return tasks;
        },
        taskNames: function taskNames() {
            return tasks.map(function(t) {
                return t.name;
            });
        }
    };
}
function $d6000d0487a35599$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    if ((0, $71txE.is).iterator(fn)) return fn;
    // catch synchronous failures; see #152 and #441
    var result = void 0, error = void 0;
    try {
        result = fn.apply(context, args);
    } catch (err) {
        error = err;
    }
    // i.e. a generator function returns an iterator
    if ((0, $71txE.is).iterator(result)) return result;
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return error ? (0, $71txE.makeIterator)(function() {
        throw error;
    }) : (0, $71txE.makeIterator)(function() {
        var pc = void 0;
        var eff = {
            done: false,
            value: result
        };
        var ret = function ret(value) {
            return {
                done: true,
                value: value
            };
        };
        return function(arg) {
            if (!pc) {
                pc = true;
                return eff;
            } else return ret(arg);
        };
    }());
}
var $d6000d0487a35599$var$wrapHelper = function wrapHelper(helper) {
    return {
        fn: helper
    };
};
function $d6000d0487a35599$export$2e2bcd8739ae039(iterator) {
    var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return 0, $71txE.noop;
    };
    var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $71txE.noop);
    var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, $71txE.noop);
    var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
    var cont = arguments[8];
    (0, $71txE.check)(iterator, (0, $71txE.is).iterator, $d6000d0487a35599$export$e152ed93e7f2bba6);
    var effectsString = '[...effects]';
    var runParallelEffect = (0, $71txE.deprecate)(runAllEffect, (0, $71txE.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
    var sagaMonitor = options.sagaMonitor, logger = options.logger, onError = options.onError;
    var log = logger || (0, $71txE.log);
    var logError = function logError(err) {
        var message = err.sagaStack;
        if (!message && err.stack) message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
        log('error', 'uncaught at ' + name, message || err.message || err);
    };
    var stdChannel = (0, $1fYhi.stdChannel)(subscribe);
    var taskContext = Object.create(parentContext);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $71txE.noop);
    /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/ var task = newTask(parentEffectId, name, iterator, cont);
    var mainTask = {
        name: name,
        cancel: cancelMain,
        isRunning: true
    };
    var taskQueue = $d6000d0487a35599$var$forkQueue(name, mainTask, end);
    /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/ function cancelMain() {
        if (mainTask.isRunning && !mainTask.isCancelled) {
            mainTask.isCancelled = true;
            next($d6000d0487a35599$export$a47f788ef0b36709);
        }
    }
    /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/ function cancel() {
        /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/ if (iterator._isRunning && !iterator._isCancelled) {
            iterator._isCancelled = true;
            taskQueue.cancelAll();
            /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/ end($d6000d0487a35599$export$a47f788ef0b36709);
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ cont && (cont.cancel = cancel);
    // tracks the running status
    iterator._isRunning = true;
    // kicks up the generator
    next();
    // then return the task descriptor to the caller
    return task;
    /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/ function next(arg, isErr) {
        // Preventive measure. If we end up here, then there is really something wrong
        if (!mainTask.isRunning) throw new Error('Trying to resume an already finished generator');
        try {
            var result = void 0;
            if (isErr) result = iterator.throw(arg);
            else if (arg === $d6000d0487a35599$export$a47f788ef0b36709) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.isCancelled = true;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $71txE.is).func(iterator.return) ? iterator.return($d6000d0487a35599$export$a47f788ef0b36709) : {
                    done: true,
                    value: $d6000d0487a35599$export$a47f788ef0b36709
                };
            } else if (arg === $d6000d0487a35599$export$ad61d2aef9f3734) // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $71txE.is).func(iterator.return) ? iterator.return() : {
                done: true
            };
            else result = iterator.next(arg);
            if (!result.done) runEffect(result.value, parentEffectId, '', next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ mainTask.isMainRunning = false;
                mainTask.cont && mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.isCancelled) logError(error);
            mainTask.isMainRunning = false;
            mainTask.cont(error, true);
        }
    }
    function end(result, isErr) {
        iterator._isRunning = false;
        stdChannel.close();
        if (!isErr) {
            iterator._result = result;
            iterator._deferredEnd && iterator._deferredEnd.resolve(result);
        } else {
            if (result instanceof Error) Object.defineProperty(result, 'sagaStack', {
                value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
                configurable: true
            });
            if (!task.cont) {
                if (result instanceof Error && onError) onError(result);
                else logError(result);
            }
            iterator._error = result;
            iterator._isAborted = true;
            iterator._deferredEnd && iterator._deferredEnd.reject(result);
        }
        task.cont && task.cont(result, isErr);
        task.joiners.forEach(function(j) {
            return j.cb(result, isErr);
        });
        task.joiners = null;
    }
    function runEffect(effect, parentEffectId) {
        var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var cb = arguments[3];
        var effectId = (0, $71txE.uid)();
        sagaMonitor && sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled = void 0;
        // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $71txE.noop); // defensive measure
            if (sagaMonitor) isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
            cb(res, isErr);
        }
        // tracks down the current cancel
        currCb.cancel = (0, $71txE.noop);
        // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/ try {
                currCb.cancel();
            } catch (err) {
                logError(err);
            }
            currCb.cancel = (0, $71txE.noop); // defensive measure
            sagaMonitor && sagaMonitor.effectCancelled(effectId);
        };
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ var data = void 0;
        // prettier-ignore
        return(// Non declarative effect
        (0, $71txE.is).promise(effect) ? resolvePromise(effect, currCb) : (0, $71txE.is).helper(effect) ? runForkEffect($d6000d0487a35599$var$wrapHelper(effect), effectId, currCb) : (0, $71txE.is).iterator(effect) ? resolveIterator(effect, effectId, name, currCb) : (0, $71txE.is).array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = (0, $9e8i2.asEffect).take(effect)) ? runTakeEffect(data, currCb) : (data = (0, $9e8i2.asEffect).put(effect)) ? runPutEffect(data, currCb) : (data = (0, $9e8i2.asEffect).all(effect)) ? runAllEffect(data, effectId, currCb) : (data = (0, $9e8i2.asEffect).race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = (0, $9e8i2.asEffect).call(effect)) ? runCallEffect(data, effectId, currCb) : (data = (0, $9e8i2.asEffect).cps(effect)) ? runCPSEffect(data, currCb) : (data = (0, $9e8i2.asEffect).fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = (0, $9e8i2.asEffect).join(effect)) ? runJoinEffect(data, currCb) : (data = (0, $9e8i2.asEffect).cancel(effect)) ? runCancelEffect(data, currCb) : (data = (0, $9e8i2.asEffect).select(effect)) ? runSelectEffect(data, currCb) : (data = (0, $9e8i2.asEffect).actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = (0, $9e8i2.asEffect).flush(effect)) ? runFlushEffect(data, currCb) : (data = (0, $9e8i2.asEffect).cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = (0, $9e8i2.asEffect).getContext(effect)) ? runGetContextEffect(data, currCb) : (data = (0, $9e8i2.asEffect).setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */ currCb(effect));
    }
    function resolvePromise(promise, cb) {
        var cancelPromise = promise[0, $71txE.CANCEL];
        if ((0, $71txE.is).func(cancelPromise)) cb.cancel = cancelPromise;
        else if ((0, $71txE.is).func(promise.abort)) cb.cancel = function() {
            return promise.abort();
        };
        promise.then(cb, function(error) {
            return cb(error, true);
        });
    }
    function resolveIterator(iterator, effectId, name, cb) {
        $d6000d0487a35599$export$2e2bcd8739ae039(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
    }
    function runTakeEffect(_ref2, cb) {
        var channel = _ref2.channel, pattern = _ref2.pattern, maybe = _ref2.maybe;
        channel = channel || stdChannel;
        var takeCb = function takeCb(inp) {
            return inp instanceof Error ? cb(inp, true) : (0, $1fYhi.isEnd)(inp) && !maybe ? cb($d6000d0487a35599$export$ad61d2aef9f3734) : cb(inp);
        };
        try {
            channel.take(takeCb, $d6000d0487a35599$var$matcher(pattern));
        } catch (err) {
            return cb(err, true);
        }
        cb.cancel = takeCb.cancel;
    }
    function runPutEffect(_ref3, cb) {
        var channel = _ref3.channel, action = _ref3.action, resolve = _ref3.resolve;
        /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/ (0, $bXjjV.asap)(function() {
            var result = void 0;
            try {
                result = (channel ? channel.put : dispatch)(action);
            } catch (error) {
                // If we have a channel or `put.resolve` was used then bubble up the error.
                if (channel || resolve) return cb(error, true);
                logError(error);
            }
            if (resolve && (0, $71txE.is).promise(result)) resolvePromise(result, cb);
            else return cb(result);
        });
    // Put effects are non cancellables
    }
    function runCallEffect(_ref4, effectId, cb) {
        var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
        var result = void 0;
        // catch synchronous failures; see #152
        try {
            result = fn.apply(context, args);
        } catch (error) {
            return cb(error, true);
        }
        return (0, $71txE.is).promise(result) ? resolvePromise(result, cb) : (0, $71txE.is).iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
    }
    function runCPSEffect(_ref5, cb) {
        var context = _ref5.context, fn = _ref5.fn, args = _ref5.args;
        // CPS (ie node style functions) can define their own cancellation logic
        // by setting cancel field on the cb
        // catch synchronous failures; see #152
        try {
            var cpsCb = function cpsCb(err, res) {
                return (0, $71txE.is).undef(err) ? cb(res) : cb(err, true);
            };
            fn.apply(context, args.concat(cpsCb));
            if (cpsCb.cancel) cb.cancel = function() {
                return cpsCb.cancel();
            };
        } catch (error) {
            return cb(error, true);
        }
    }
    function runForkEffect(_ref6, effectId, cb) {
        var context = _ref6.context, fn = _ref6.fn, args = _ref6.args, detached = _ref6.detached;
        var taskIterator = $d6000d0487a35599$var$createTaskIterator({
            context: context,
            fn: fn,
            args: args
        });
        try {
            (0, $bXjjV.suspend)();
            var _task = $d6000d0487a35599$export$2e2bcd8739ae039(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : (0, $71txE.noop));
            if (detached) cb(_task);
            else {
                if (taskIterator._isRunning) {
                    taskQueue.addTask(_task);
                    cb(_task);
                } else if (taskIterator._error) taskQueue.abort(taskIterator._error);
                else cb(_task);
            }
        } finally{
            (0, $bXjjV.flush)();
        }
    // Fork effects are non cancellables
    }
    function runJoinEffect(t, cb) {
        if (t.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                return (0, $71txE.remove)(t.joiners, joiner);
            };
            t.joiners.push(joiner);
        } else t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
    function runCancelEffect(taskToCancel, cb) {
        if (taskToCancel === (0, $71txE.SELF_CANCELLATION)) taskToCancel = task;
        if (taskToCancel.isRunning()) taskToCancel.cancel();
        cb();
    // cancel effects are non cancellables
    }
    function runAllEffect(effects, effectId, cb) {
        var keys = Object.keys(effects);
        if (!keys.length) return cb((0, $71txE.is).array(effects) ? [] : {});
        var completedCount = 0;
        var completed = void 0;
        var results = {};
        var childCbs = {};
        function checkEffectEnd() {
            if (completedCount === keys.length) {
                completed = true;
                cb((0, $71txE.is).array(effects) ? (0, $71txE.array).from($d6000d0487a35599$var$_extends({}, results, {
                    length: keys.length
                })) : results);
            }
        }
        keys.forEach(function(key) {
            var chCbAtKey = function chCbAtKey(res, isErr) {
                if (completed) return;
                if (isErr || (0, $1fYhi.isEnd)(res) || res === $d6000d0487a35599$export$ad61d2aef9f3734 || res === $d6000d0487a35599$export$a47f788ef0b36709) {
                    cb.cancel();
                    cb(res, isErr);
                } else {
                    results[key] = res;
                    completedCount++;
                    checkEffectEnd();
                }
            };
            chCbAtKey.cancel = (0, $71txE.noop);
            childCbs[key] = chCbAtKey;
        });
        cb.cancel = function() {
            if (!completed) {
                completed = true;
                keys.forEach(function(key) {
                    return childCbs[key].cancel();
                });
            }
        };
        keys.forEach(function(key) {
            return runEffect(effects[key], effectId, key, childCbs[key]);
        });
    }
    function runRaceEffect(effects, effectId, cb) {
        var completed = void 0;
        var keys = Object.keys(effects);
        var childCbs = {};
        keys.forEach(function(key) {
            var chCbAtKey = function chCbAtKey(res, isErr) {
                if (completed) return;
                if (isErr) {
                    // Race Auto cancellation
                    cb.cancel();
                    cb(res, true);
                } else if (!(0, $1fYhi.isEnd)(res) && res !== $d6000d0487a35599$export$ad61d2aef9f3734 && res !== $d6000d0487a35599$export$a47f788ef0b36709) {
                    var _response;
                    cb.cancel();
                    completed = true;
                    var response = (_response = {}, _response[key] = res, _response);
                    cb((0, $71txE.is).array(effects) ? [].slice.call($d6000d0487a35599$var$_extends({}, response, {
                        length: keys.length
                    })) : response);
                }
            };
            chCbAtKey.cancel = (0, $71txE.noop);
            childCbs[key] = chCbAtKey;
        });
        cb.cancel = function() {
            // prevents unnecessary cancellation
            if (!completed) {
                completed = true;
                keys.forEach(function(key) {
                    return childCbs[key].cancel();
                });
            }
        };
        keys.forEach(function(key) {
            if (completed) return;
            runEffect(effects[key], effectId, key, childCbs[key]);
        });
    }
    function runSelectEffect(_ref7, cb) {
        var selector = _ref7.selector, args = _ref7.args;
        try {
            var state = selector.apply(undefined, [
                getState()
            ].concat(args));
            cb(state);
        } catch (error) {
            cb(error, true);
        }
    }
    function runChannelEffect(_ref8, cb) {
        var pattern = _ref8.pattern, buffer = _ref8.buffer;
        var match = $d6000d0487a35599$var$matcher(pattern);
        match.pattern = pattern;
        cb((0, $1fYhi.eventChannel)(subscribe, buffer || (0, $4RfEe.buffers).fixed(), match));
    }
    function runCancelledEffect(data, cb) {
        cb(!!mainTask.isCancelled);
    }
    function runFlushEffect(channel, cb) {
        channel.flush(cb);
    }
    function runGetContextEffect(prop, cb) {
        cb(taskContext[prop]);
    }
    function runSetContextEffect(props, cb) {
        (0, $71txE.object).assign(taskContext, props);
        cb();
    }
    function newTask(id, name, iterator, cont) {
        var _done, _ref9, _mutatorMap;
        iterator._deferredEnd = null;
        return _ref9 = {}, _ref9[0, $71txE.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function() {
            if (iterator._deferredEnd) return iterator._deferredEnd.promise;
            else {
                var def = (0, $71txE.deferred)();
                iterator._deferredEnd = def;
                if (!iterator._isRunning) iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
                return def.promise;
            }
        }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
            return iterator._isRunning;
        }, _ref9.isCancelled = function isCancelled() {
            return iterator._isCancelled;
        }, _ref9.isAborted = function isAborted() {
            return iterator._isAborted;
        }, _ref9.result = function result() {
            return iterator._result;
        }, _ref9.error = function error() {
            return iterator._error;
        }, _ref9.setContext = function setContext(props) {
            (0, $71txE.check)(props, (0, $71txE.is).object, (0, $71txE.createSetContextWarning)('task', props));
            (0, $71txE.object).assign(taskContext, props);
        }, $d6000d0487a35599$var$_defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
    }
}

});
parcelRegister("9e8i2", function(module, exports) {

$parcel$export(module.exports, "asEffect", () => $6b7bda11fac41b68$export$6338d86c17f4b021);
$parcel$export(module.exports, "take", () => $6b7bda11fac41b68$export$b7df5d561049483a);
$parcel$export(module.exports, "put", () => $6b7bda11fac41b68$export$327f7b26ebf455db);
$parcel$export(module.exports, "all", () => $6b7bda11fac41b68$export$84bf76cd7afc7469);
$parcel$export(module.exports, "call", () => $6b7bda11fac41b68$export$848feb93d8f32b9b);
$parcel$export(module.exports, "fork", () => $6b7bda11fac41b68$export$7a5058c6b79333e0);
$parcel$export(module.exports, "join", () => $6b7bda11fac41b68$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "cancel", () => $6b7bda11fac41b68$export$70b61ad426ddbe54);
$parcel$export(module.exports, "select", () => $6b7bda11fac41b68$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "actionChannel", () => $6b7bda11fac41b68$export$64c6ba3aace17f8f);

var $71txE = parcelRequire("71txE");
var $6b7bda11fac41b68$var$IO = /*#__PURE__*/ (0, $71txE.sym)('IO');
var $6b7bda11fac41b68$var$TAKE = 'TAKE';
var $6b7bda11fac41b68$var$PUT = 'PUT';
var $6b7bda11fac41b68$var$ALL = 'ALL';
var $6b7bda11fac41b68$var$RACE = 'RACE';
var $6b7bda11fac41b68$var$CALL = 'CALL';
var $6b7bda11fac41b68$var$CPS = 'CPS';
var $6b7bda11fac41b68$var$FORK = 'FORK';
var $6b7bda11fac41b68$var$JOIN = 'JOIN';
var $6b7bda11fac41b68$var$CANCEL = 'CANCEL';
var $6b7bda11fac41b68$var$SELECT = 'SELECT';
var $6b7bda11fac41b68$var$ACTION_CHANNEL = 'ACTION_CHANNEL';
var $6b7bda11fac41b68$var$CANCELLED = 'CANCELLED';
var $6b7bda11fac41b68$var$FLUSH = 'FLUSH';
var $6b7bda11fac41b68$var$GET_CONTEXT = 'GET_CONTEXT';
var $6b7bda11fac41b68$var$SET_CONTEXT = 'SET_CONTEXT';
var $6b7bda11fac41b68$var$TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
var $6b7bda11fac41b68$var$effect = function effect(type, payload) {
    var _ref;
    return _ref = {}, _ref[$6b7bda11fac41b68$var$IO] = true, _ref[type] = payload, _ref;
};
var $6b7bda11fac41b68$export$3f780019ff766da6 = function detach(eff) {
    (0, $71txE.check)($6b7bda11fac41b68$export$6338d86c17f4b021.fork(eff), (0, $71txE.is).object, 'detach(eff): argument must be a fork effect');
    eff[$6b7bda11fac41b68$var$FORK].detached = true;
    return eff;
};
function $6b7bda11fac41b68$export$b7df5d561049483a() {
    var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
    if (arguments.length) (0, $71txE.check)(arguments[0], (0, $71txE.is).notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
    if ((0, $71txE.is).pattern(patternOrChannel)) return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$TAKE, {
        pattern: patternOrChannel
    });
    if ((0, $71txE.is).channel(patternOrChannel)) return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$TAKE, {
        channel: patternOrChannel
    });
    throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}
$6b7bda11fac41b68$export$b7df5d561049483a.maybe = function() {
    var eff = $6b7bda11fac41b68$export$b7df5d561049483a.apply(undefined, arguments);
    eff[$6b7bda11fac41b68$var$TAKE].maybe = true;
    return eff;
};
var $6b7bda11fac41b68$export$a83b02dcc7b6ebeb = /*#__PURE__*/ (0, $71txE.deprecate)($6b7bda11fac41b68$export$b7df5d561049483a.maybe, /*#__PURE__*/ (0, $71txE.updateIncentive)('takem', 'take.maybe'));
function $6b7bda11fac41b68$export$327f7b26ebf455db(channel, action) {
    if (arguments.length > 1) {
        (0, $71txE.check)(channel, (0, $71txE.is).notUndef, 'put(channel, action): argument channel is undefined');
        (0, $71txE.check)(channel, (0, $71txE.is).channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
        (0, $71txE.check)(action, (0, $71txE.is).notUndef, 'put(channel, action): argument action is undefined');
    } else {
        (0, $71txE.check)(channel, (0, $71txE.is).notUndef, 'put(action): argument action is undefined');
        action = channel;
        channel = null;
    }
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$PUT, {
        channel: channel,
        action: action
    });
}
$6b7bda11fac41b68$export$327f7b26ebf455db.resolve = function() {
    var eff = $6b7bda11fac41b68$export$327f7b26ebf455db.apply(undefined, arguments);
    eff[$6b7bda11fac41b68$var$PUT].resolve = true;
    return eff;
};
$6b7bda11fac41b68$export$327f7b26ebf455db.sync = /*#__PURE__*/ (0, $71txE.deprecate)($6b7bda11fac41b68$export$327f7b26ebf455db.resolve, /*#__PURE__*/ (0, $71txE.updateIncentive)('put.sync', 'put.resolve'));
function $6b7bda11fac41b68$export$84bf76cd7afc7469(effects) {
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$ALL, effects);
}
function $6b7bda11fac41b68$export$236c05de452bec2(effects) {
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$RACE, effects);
}
function $6b7bda11fac41b68$var$getFnCallDesc(meth, fn, args) {
    (0, $71txE.check)(fn, (0, $71txE.is).notUndef, meth + ': argument fn is undefined');
    var context = null;
    if ((0, $71txE.is).array(fn)) {
        var _fn = fn;
        context = _fn[0];
        fn = _fn[1];
    } else if (fn.fn) {
        var _fn2 = fn;
        context = _fn2.context;
        fn = _fn2.fn;
    }
    if (context && (0, $71txE.is).string(fn) && (0, $71txE.is).func(context[fn])) fn = context[fn];
    (0, $71txE.check)(fn, (0, $71txE.is).func, meth + ': argument ' + fn + ' is not a function');
    return {
        context: context,
        fn: fn,
        args: args
    };
}
function $6b7bda11fac41b68$export$848feb93d8f32b9b(fn) {
    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$CALL, $6b7bda11fac41b68$var$getFnCallDesc('call', fn, args));
}
function $6b7bda11fac41b68$export$5635d7ef4b8fee1c(context, fn) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$CALL, $6b7bda11fac41b68$var$getFnCallDesc('apply', {
        context: context,
        fn: fn
    }, args));
}
function $6b7bda11fac41b68$export$488893254e5e098(fn) {
    for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$CPS, $6b7bda11fac41b68$var$getFnCallDesc('cps', fn, args));
}
function $6b7bda11fac41b68$export$7a5058c6b79333e0(fn) {
    for(var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$FORK, $6b7bda11fac41b68$var$getFnCallDesc('fork', fn, args));
}
function $6b7bda11fac41b68$export$1713f5ac2bf0caf5(fn) {
    for(var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $6b7bda11fac41b68$export$3f780019ff766da6($6b7bda11fac41b68$export$7a5058c6b79333e0.apply(undefined, [
        fn
    ].concat(args)));
}
function $6b7bda11fac41b68$export$f7e2c8231c57a8bd() {
    for(var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)tasks[_key5] = arguments[_key5];
    if (tasks.length > 1) return $6b7bda11fac41b68$export$84bf76cd7afc7469(tasks.map(function(t) {
        return $6b7bda11fac41b68$export$f7e2c8231c57a8bd(t);
    }));
    var task = tasks[0];
    (0, $71txE.check)(task, (0, $71txE.is).notUndef, 'join(task): argument task is undefined');
    (0, $71txE.check)(task, (0, $71txE.is).task, 'join(task): argument ' + task + ' is not a valid Task object ' + $6b7bda11fac41b68$var$TEST_HINT);
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$JOIN, task);
}
function $6b7bda11fac41b68$export$70b61ad426ddbe54() {
    for(var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++)tasks[_key6] = arguments[_key6];
    if (tasks.length > 1) return $6b7bda11fac41b68$export$84bf76cd7afc7469(tasks.map(function(t) {
        return $6b7bda11fac41b68$export$70b61ad426ddbe54(t);
    }));
    var task = tasks[0];
    if (tasks.length === 1) {
        (0, $71txE.check)(task, (0, $71txE.is).notUndef, 'cancel(task): argument task is undefined');
        (0, $71txE.check)(task, (0, $71txE.is).task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + $6b7bda11fac41b68$var$TEST_HINT);
    }
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$CANCEL, task || (0, $71txE.SELF_CANCELLATION));
}
function $6b7bda11fac41b68$export$2e6c959c16ff56b8(selector) {
    for(var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)args[_key7 - 1] = arguments[_key7];
    if (arguments.length === 0) selector = (0, $71txE.ident);
    else {
        (0, $71txE.check)(selector, (0, $71txE.is).notUndef, 'select(selector,[...]): argument selector is undefined');
        (0, $71txE.check)(selector, (0, $71txE.is).func, 'select(selector,[...]): argument ' + selector + ' is not a function');
    }
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$SELECT, {
        selector: selector,
        args: args
    });
}
function $6b7bda11fac41b68$export$64c6ba3aace17f8f(pattern, buffer) {
    (0, $71txE.check)(pattern, (0, $71txE.is).notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
    if (arguments.length > 1) {
        (0, $71txE.check)(buffer, (0, $71txE.is).notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
        (0, $71txE.check)(buffer, (0, $71txE.is).buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
    }
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$ACTION_CHANNEL, {
        pattern: pattern,
        buffer: buffer
    });
}
function $6b7bda11fac41b68$export$b108ea1063c657e3() {
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$CANCELLED, {});
}
function $6b7bda11fac41b68$export$4909b86c8034bf73(channel) {
    (0, $71txE.check)(channel, (0, $71txE.is).channel, 'flush(channel): argument ' + channel + ' is not valid channel');
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$FLUSH, channel);
}
function $6b7bda11fac41b68$export$31553aaa555c1514(prop) {
    (0, $71txE.check)(prop, (0, $71txE.is).string, 'getContext(prop): argument ' + prop + ' is not a string');
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$GET_CONTEXT, prop);
}
function $6b7bda11fac41b68$export$2f04de43fe27971a(props) {
    (0, $71txE.check)(props, (0, $71txE.is).object, (0, $71txE.createSetContextWarning)(null, props));
    return $6b7bda11fac41b68$var$effect($6b7bda11fac41b68$var$SET_CONTEXT, props);
}
var $6b7bda11fac41b68$var$createAsEffectType = function createAsEffectType(type) {
    return function(effect) {
        return effect && effect[$6b7bda11fac41b68$var$IO] && effect[type];
    };
};
var $6b7bda11fac41b68$export$6338d86c17f4b021 = {
    take: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$TAKE),
    put: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$PUT),
    all: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$ALL),
    race: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$RACE),
    call: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$CALL),
    cps: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$CPS),
    fork: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$FORK),
    join: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$JOIN),
    cancel: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$CANCEL),
    select: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$SELECT),
    actionChannel: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$ACTION_CHANNEL),
    cancelled: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$CANCELLED),
    flush: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$FLUSH),
    getContext: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$GET_CONTEXT),
    setContext: /*#__PURE__*/ $6b7bda11fac41b68$var$createAsEffectType($6b7bda11fac41b68$var$SET_CONTEXT)
};

});




parcelRegister("jYyHx", function(module, exports) {

$parcel$export(module.exports, "takeEveryHelper", () => (parcelRequire("2DsgJ")).default);
$parcel$export(module.exports, "takeLatestHelper", () => (parcelRequire("f9QDo")).default);
$parcel$export(module.exports, "throttleHelper", () => (parcelRequire("aNlx5")).default);

var $2DsgJ = parcelRequire("2DsgJ");

var $f9QDo = parcelRequire("f9QDo");

var $aNlx5 = parcelRequire("aNlx5");

var $71txE = parcelRequire("71txE");
var $e8ae89d73aaae251$var$deprecationWarning = function deprecationWarning(helperName) {
    return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};
var $e8ae89d73aaae251$export$4e24be1e1c9d5c69 = /*#__PURE__*/ (0, $71txE.deprecate)((0, $2DsgJ.default), /*#__PURE__*/ $e8ae89d73aaae251$var$deprecationWarning('takeEvery'));
var $e8ae89d73aaae251$export$ca010cea618a298a = /*#__PURE__*/ (0, $71txE.deprecate)((0, $f9QDo.default), /*#__PURE__*/ $e8ae89d73aaae251$var$deprecationWarning('takeLatest'));
var $e8ae89d73aaae251$export$de363e709c412c8a = /*#__PURE__*/ (0, $71txE.deprecate)((0, $aNlx5.default), /*#__PURE__*/ $e8ae89d73aaae251$var$deprecationWarning('throttle'));

});
parcelRegister("2DsgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb526ec29d64cd8$export$2e2bcd8739ae039);

var $5YL8H = parcelRequire("5YL8H");

var $9e8i2 = parcelRequire("9e8i2");

var $1fYhi = parcelRequire("1fYhi");
function $1eb526ec29d64cd8$export$2e2bcd8739ae039(patternOrChannel, worker) {
    for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $9e8i2.take)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $9e8i2.fork).apply(undefined, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action = void 0, setAction = function setAction(ac) {
        return action = ac;
    };
    return (0, $5YL8H.default)({
        q1: function q1() {
            return [
                'q2',
                yTake,
                setAction
            ];
        },
        q2: function q2() {
            return action === (0, $1fYhi.END) ? [
                (0, $5YL8H.qEnd)
            ] : [
                'q1',
                yFork(action)
            ];
        }
    }, 'q1', 'takeEvery(' + (0, $5YL8H.safeName)(patternOrChannel) + ', ' + worker.name + ')');
}

});
parcelRegister("5YL8H", function(module, exports) {

$parcel$export(module.exports, "qEnd", () => $45a71f40622f814a$export$41cf03a0ef8df852);
$parcel$export(module.exports, "safeName", () => $45a71f40622f814a$export$13bcac93470fc5a);
$parcel$export(module.exports, "default", () => $45a71f40622f814a$export$2e2bcd8739ae039);

var $71txE = parcelRequire("71txE");
var $45a71f40622f814a$var$done = {
    done: true,
    value: undefined
};
var $45a71f40622f814a$export$41cf03a0ef8df852 = {};
function $45a71f40622f814a$export$13bcac93470fc5a(patternOrChannel) {
    if ((0, $71txE.is).channel(patternOrChannel)) return 'channel';
    else if (Array.isArray(patternOrChannel)) return String(patternOrChannel.map(function(entry) {
        return String(entry);
    }));
    else return String(patternOrChannel);
}
function $45a71f40622f814a$export$2e2bcd8739ae039(fsm, q0) {
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
    var updateState = void 0, qNext = q0;
    function next(arg, error) {
        if (qNext === $45a71f40622f814a$export$41cf03a0ef8df852) return $45a71f40622f814a$var$done;
        if (error) {
            qNext = $45a71f40622f814a$export$41cf03a0ef8df852;
            throw error;
        } else {
            updateState && updateState(arg);
            var _fsm$qNext = fsm[qNext](), q = _fsm$qNext[0], output = _fsm$qNext[1], _updateState = _fsm$qNext[2];
            qNext = q;
            updateState = _updateState;
            return qNext === $45a71f40622f814a$export$41cf03a0ef8df852 ? $45a71f40622f814a$var$done : output;
        }
    }
    return (0, $71txE.makeIterator)(next, function(error) {
        return next(null, error);
    }, name, true);
}

});


parcelRegister("f9QDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0908664d79e4ada$export$2e2bcd8739ae039);

var $5YL8H = parcelRequire("5YL8H");

var $9e8i2 = parcelRequire("9e8i2");

var $1fYhi = parcelRequire("1fYhi");
function $b0908664d79e4ada$export$2e2bcd8739ae039(patternOrChannel, worker) {
    for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $9e8i2.take)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $9e8i2.fork).apply(undefined, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $9e8i2.cancel)(task)
        };
    };
    var task = void 0, action = void 0;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return (0, $5YL8H.default)({
        q1: function q1() {
            return [
                'q2',
                yTake,
                setAction
            ];
        },
        q2: function q2() {
            return action === (0, $1fYhi.END) ? [
                (0, $5YL8H.qEnd)
            ] : task ? [
                'q3',
                yCancel(task)
            ] : [
                'q1',
                yFork(action),
                setTask
            ];
        },
        q3: function q3() {
            return [
                'q1',
                yFork(action),
                setTask
            ];
        }
    }, 'q1', 'takeLatest(' + (0, $5YL8H.safeName)(patternOrChannel) + ', ' + worker.name + ')');
}

});

parcelRegister("aNlx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbf2ee8b242701b$export$2e2bcd8739ae039);

var $5YL8H = parcelRequire("5YL8H");

var $9e8i2 = parcelRequire("9e8i2");

var $1fYhi = parcelRequire("1fYhi");

var $4RfEe = parcelRequire("4RfEe");

var $71txE = parcelRequire("71txE");
function $7dbf2ee8b242701b$export$2e2bcd8739ae039(delayLength, pattern, worker) {
    for(var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action = void 0, channel = void 0;
    var yActionChannel = {
        done: false,
        value: (0, $9e8i2.actionChannel)(pattern, (0, $4RfEe.buffers).sliding(1))
    };
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $9e8i2.take)(channel)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $9e8i2.fork).apply(undefined, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $9e8i2.call)((0, $71txE.delay), delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel = ch;
    };
    return (0, $5YL8H.default)({
        q1: function q1() {
            return [
                'q2',
                yActionChannel,
                setChannel
            ];
        },
        q2: function q2() {
            return [
                'q3',
                yTake(),
                setAction
            ];
        },
        q3: function q3() {
            return action === (0, $1fYhi.END) ? [
                (0, $5YL8H.qEnd)
            ] : [
                'q4',
                yFork(action)
            ];
        },
        q4: function q4() {
            return [
                'q2',
                yDelay
            ];
        }
    }, 'q1', 'throttle(' + (0, $5YL8H.safeName)(pattern) + ', ' + worker.name + ')');
}

});


parcelRegister("6Zcms", function(module, exports) {

$parcel$export(module.exports, "take", () => (parcelRequire("9e8i2")).take);
$parcel$export(module.exports, "put", () => (parcelRequire("9e8i2")).put);
$parcel$export(module.exports, "all", () => (parcelRequire("9e8i2")).all);
$parcel$export(module.exports, "call", () => (parcelRequire("9e8i2")).call);
$parcel$export(module.exports, "fork", () => (parcelRequire("9e8i2")).fork);
$parcel$export(module.exports, "join", () => (parcelRequire("9e8i2")).join);
$parcel$export(module.exports, "select", () => (parcelRequire("9e8i2")).select);
$parcel$export(module.exports, "takeEvery", () => (parcelRequire("bG7pV")).takeEvery);
$parcel$export(module.exports, "takeLatest", () => (parcelRequire("bG7pV")).takeLatest);

var $9e8i2 = parcelRequire("9e8i2");

var $bG7pV = parcelRequire("bG7pV");

});
parcelRegister("bG7pV", function(module, exports) {

$parcel$export(module.exports, "takeEvery", () => $88095edc97287e24$export$4e24be1e1c9d5c69);
$parcel$export(module.exports, "takeLatest", () => $88095edc97287e24$export$ca010cea618a298a);

var $9e8i2 = parcelRequire("9e8i2");
parcelRequire("jYyHx");
var $2DsgJ = parcelRequire("2DsgJ");
var $f9QDo = parcelRequire("f9QDo");
var $aNlx5 = parcelRequire("aNlx5");
function $88095edc97287e24$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $9e8i2.fork).apply(undefined, [
        (0, $2DsgJ.default),
        patternOrChannel,
        worker
    ].concat(args));
}
function $88095edc97287e24$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $9e8i2.fork).apply(undefined, [
        (0, $f9QDo.default),
        patternOrChannel,
        worker
    ].concat(args));
}
function $88095edc97287e24$export$de363e709c412c8a(ms, pattern, worker) {
    for(var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++)args[_key3 - 3] = arguments[_key3];
    return (0, $9e8i2.fork).apply(undefined, [
        (0, $aNlx5.default),
        ms,
        pattern,
        worker
    ].concat(args));
}

});


parcelRegister("hIh4o", function(module, exports) {

var $71txE = parcelRequire("71txE");

var $9e8i2 = parcelRequire("9e8i2");

var $in7jJ = parcelRequire("in7jJ");

});


parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("cbq3D", function(module, exports) {

$parcel$export(module.exports, "genericError", () => $0415ca93fe28a1f0$export$28cd364e99d3d2cb);
$parcel$export(module.exports, "httpRequestError", () => $0415ca93fe28a1f0$export$90aa3e18a8fea0c3);
$parcel$export(module.exports, "default", () => $0415ca93fe28a1f0$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $guiFP = parcelRequire("guiFP");

var $dhHiZ = parcelRequire("dhHiZ");

var $l7qZG = parcelRequire("l7qZG");

var $ewayV = parcelRequire("ewayV");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");

var $lPV5U = parcelRequire("lPV5U");
const $0415ca93fe28a1f0$export$4b044058fcbf0e64 = 'command.errors.GENERIC_ERROR';
const $0415ca93fe28a1f0$export$28cd364e99d3d2cb = (payload)=>({
        type: $0415ca93fe28a1f0$export$4b044058fcbf0e64,
        payload: payload
    });
function* $0415ca93fe28a1f0$export$7bb03edbe2d071a1({ payload: { message: message, stackTrace: stackTrace, requestInfo: requestInfo, shouldReportError: shouldReportError = true, description: description } // eslint-disable-next-line @typescript-eslint/no-explicit-any
 }) {
    if ((0, $lPV5U.shouldIgnoreError)(message)) {
        // eslint-disable-next-line no-console
        console.warn('Not showing JPO error dialog for exception:', message);
        return;
    }
    const error = new Error(message);
    if (stackTrace) error.stack = stackTrace;
    const details = {
        requestInfo: requestInfo,
        clientInfo: {
            userAgent: $lFLge.userAgent,
            localTime: new Date().toString()
        },
        systemInfo: yield (0, $9e8i2.select)((0, $dhHiZ.getSystemInfo))
    };
    if (shouldReportError && !(0, $7CnHa.isDefined)(requestInfo)) {
        const id = (0, $ewayV.isEnvironmentError)(error) ? (0, $5rYNM.ERROR_REPORTING_PACKAGE).ENVIRONMENT : (0, $5rYNM.ERROR_REPORTING_PACKAGE).REDUX_SAGA;
        (0, $guiFP.default)({
            meta: {
                id: id,
                packageName: (0, $5rYNM.PACKAGE_NAME),
                teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    yield (0, $9e8i2.put)((0, $l7qZG.showError)(message, stackTrace, window?.location.hash, window?.location.pathname, details, description));
}
function $0415ca93fe28a1f0$export$90aa3e18a8fea0c3(response, error, requestObj) {
    return $0415ca93fe28a1f0$export$28cd364e99d3d2cb({
        ...error,
        requestInfo: {
            url: response.url,
            type: requestObj.method,
            status: response.status,
            body: response.body || {}
        }
    });
}
function* $0415ca93fe28a1f0$export$2e2bcd8739ae039() {
    yield (0, $bG7pV.takeEvery)($0415ca93fe28a1f0$export$4b044058fcbf0e64, $0415ca93fe28a1f0$export$7bb03edbe2d071a1);
}

});
parcelRegister("l7qZG", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR", () => $212bc02c0b2c0229$export$5973607600a0786d);
$parcel$export(module.exports, "HIDE_ERROR", () => $212bc02c0b2c0229$export$35787d4a70876f22);
$parcel$export(module.exports, "HIDE_ALL_ERRORS", () => $212bc02c0b2c0229$export$f926a085912a5839);
$parcel$export(module.exports, "SHOW_ERROR_LOG_DIALOG", () => $212bc02c0b2c0229$export$e0cd60c420c02c62);
$parcel$export(module.exports, "HIDE_ERROR_LOG_DIALOG", () => $212bc02c0b2c0229$export$57775ccf5f85090c);
$parcel$export(module.exports, "SET_IS_PROJECT_LIMIT_EXCEEDED", () => $212bc02c0b2c0229$export$bf07a2a294a1e09);
$parcel$export(module.exports, "showError", () => $212bc02c0b2c0229$export$3879b24e8245693d);
$parcel$export(module.exports, "hideError", () => $212bc02c0b2c0229$export$ef18f38624819fc7);
$parcel$export(module.exports, "hideAllErrors", () => $212bc02c0b2c0229$export$b14e3962385f56b8);
$parcel$export(module.exports, "showErrorLogDialog", () => $212bc02c0b2c0229$export$5bcf5adcc0c68988);
$parcel$export(module.exports, "hideErrorLogDialog", () => $212bc02c0b2c0229$export$1f3af5ffc591ab3d);
$parcel$export(module.exports, "setIsProjectLimitExceeded", () => $212bc02c0b2c0229$export$c952db40d64d2fb1);
const $212bc02c0b2c0229$export$5973607600a0786d = 'state.ui.errors.SHOW_ERROR';
const $212bc02c0b2c0229$export$35787d4a70876f22 = 'state.ui.errors.HIDE_ERROR';
const $212bc02c0b2c0229$export$f926a085912a5839 = 'state.ui.errors.HIDE_ALL_ERRORS';
const $212bc02c0b2c0229$export$e0cd60c420c02c62 = 'state.ui.errors.SHOW_ERROR_LOG_DIALOG';
const $212bc02c0b2c0229$export$57775ccf5f85090c = 'state.ui.errors.HIDE_ERROR_LOG_DIALOG';
const $212bc02c0b2c0229$export$bf07a2a294a1e09 = 'state.ui.errors.SET_IS_PROJECT_LIMIT_EXCEEDED';
const $212bc02c0b2c0229$export$3879b24e8245693d = (message, stackTrace, locationHash, locationPath, details, description)=>({
        type: $212bc02c0b2c0229$export$5973607600a0786d,
        payload: {
            title: '',
            message: message,
            stackTrace: stackTrace,
            locationHash: locationHash,
            locationPath: locationPath,
            details: details,
            description: description
        }
    });
const $212bc02c0b2c0229$export$ef18f38624819fc7 = ()=>({
        type: $212bc02c0b2c0229$export$35787d4a70876f22
    });
const $212bc02c0b2c0229$export$b14e3962385f56b8 = ()=>({
        type: $212bc02c0b2c0229$export$f926a085912a5839
    });
const $212bc02c0b2c0229$export$5bcf5adcc0c68988 = ()=>({
        type: $212bc02c0b2c0229$export$e0cd60c420c02c62
    });
const $212bc02c0b2c0229$export$1f3af5ffc591ab3d = ()=>({
        type: $212bc02c0b2c0229$export$57775ccf5f85090c
    });
const $212bc02c0b2c0229$export$c952db40d64d2fb1 = ()=>({
        type: $212bc02c0b2c0229$export$bf07a2a294a1e09
    });

});

parcelRegister("ewayV", function(module, exports) {

$parcel$export(module.exports, "isEnvironmentError", () => $5ba6102034eda8e0$export$c064455e4b53485b);
$parcel$export(module.exports, "RESPONSE_ERROR_CODE", () => $5ba6102034eda8e0$export$c1f417eafe9132b3);
const $5ba6102034eda8e0$var$environmentErrorMessagesRegexes = [
    'Failed to fetch$',
    'Failed to fetch page data for plan',
    "Cannot read property 'claim' of undefined$",
    'NetworkError when attempting to fetch resource.$',
    'cancelled$',
    '^Not enough storage is available to complete this operation.$',
    'The operation was aborted.$',
    "^undefined is not an object \\(evaluating 'window.WRM.data.claim'\\)$",
    'The request timed out.$',
    'The network connection was lost.$'
];
const $5ba6102034eda8e0$var$environmentErrorMessagesRegex = new RegExp($5ba6102034eda8e0$var$environmentErrorMessagesRegexes.join('|'));
const $5ba6102034eda8e0$export$c064455e4b53485b = (error)=>error.message.match($5ba6102034eda8e0$var$environmentErrorMessagesRegex);
const $5ba6102034eda8e0$export$c1f417eafe9132b3 = {
    REQUIRE_STATUS_TRANSITION_SCREEN: 'REQUIRE_STATUS_TRANSITION_SCREEN'
};

});

parcelRegister("lPV5U", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreError", () => $7271934bec836d5f$export$a42b2ab4291804cd);

var $607C7 = parcelRequire("607C7");

var $lFLge = parcelRequire("lFLge");
const $7271934bec836d5f$var$ignoredErrorRegexes = [
    // Ignore localStorage.setItem() errors
    // ==================================
    // If localStorage is full, Portfolio behaves okay, but some non-JPO code can throw exceptions (e.g. atlassian-analytics).
    // So we ignore any localStorage write exceptions.
    // Chrome
    /Uncaught QuotaExceededError: Failed to execute 'setItem' on 'Storage': Setting the value of '.*' exceeded the quota/,
    // Firefox
    /NS_ERROR_DOM_QUOTA_REACHED: Persistent storage maximum size reached/,
    // Safari
    /QuotaExceededError: DOM Exception 22: An attempt was made to add something to storage that exceeded the quota/,
    // IE 10, Edge
    /^QuotaExceededError$/,
    // If XHR response status is 401, we reload the page to be redirected to the login page.
    // Hence, no need to show the error.
    /^common\.fetch\.XHR_UNAUTHORIZED_ERROR/
];
const $7271934bec836d5f$export$a42b2ab4291804cd = (errorMessage)=>{
    if ((0, $lFLge.isPageUnloading)()) return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const matchesError = (regex)=>regex.test(errorMessage);
    return $607C7.default(matchesError, $7271934bec836d5f$var$ignoredErrorRegexes);
};

});


parcelRegister("cwMfk", function(module, exports) {

$parcel$export(module.exports, "getInlineCreateState", () => $0e99fe7c79dfe5c1$export$b165df9027afb05a);
$parcel$export(module.exports, "INLINE_CREATE_ID", () => (parcelRequire("lxd1S")).INLINE_CREATE_ID);

var $iK4oF = parcelRequire("iK4oF");

var $lxd1S = parcelRequire("lxd1S");
const $0e99fe7c79dfe5c1$export$b165df9027afb05a = (state)=>state.ui.Main.Tabs.Roadmap.Scope.InlineCreate;
const $0e99fe7c79dfe5c1$var$getInlineCreatePositionPure = (inlineState)=>({
        isOpen: inlineState.isOpen,
        parentId: inlineState.parentId,
        hierarchyLevel: inlineState.hierarchyLevel
    });
const $0e99fe7c79dfe5c1$export$552de75b329ed590 = (0, $iK4oF.createSelector)([
    $0e99fe7c79dfe5c1$export$b165df9027afb05a
], $0e99fe7c79dfe5c1$var$getInlineCreatePositionPure);

});
parcelRegister("lxd1S", function(module, exports) {

$parcel$export(module.exports, "INLINE_CREATE_ID", () => $5c6b2f4623c81057$export$2ec38414760ef1ba);
$parcel$export(module.exports, "default", () => $5c6b2f4623c81057$export$2e2bcd8739ae039);

var $8YqJS = parcelRequire("8YqJS");

var $8RAUa = parcelRequire("8RAUa");

var $kBus3 = parcelRequire("kBus3");
var $c8Rgw = parcelRequire("c8Rgw");

var $dr4qD = parcelRequire("dr4qD");
const $5c6b2f4623c81057$export$2ec38414760ef1ba = '__INLINE_CREATE_ID__';
const $5c6b2f4623c81057$var$defaultValues = {
    project: (0, $8RAUa.DEFAULT_PROJECT_ID),
    assignee: 'unassigned',
    assignments: []
};
const $5c6b2f4623c81057$export$d4c72bab9d6cc13a = {
    id: $5c6b2f4623c81057$export$2ec38414760ef1ba,
    hierarchyLevel: (0, $8YqJS.SUB_TASK_LEVEL),
    isOpen: false,
    openLockedMap: {},
    issueTypeId: 0,
    parentId: null,
    siblingId: null,
    projectId: 0,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    values: $5c6b2f4623c81057$var$defaultValues,
    IssueTypeIdForHierarchy: {},
    isGlobalCreateIssue: true
};
const $5c6b2f4623c81057$var$reducer = (state = $5c6b2f4623c81057$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $dr4qD.CLEAR_INLINE_CREATE:
            return {
                ...state,
                isOpen: false,
                startInlineCreateInEmptyGroup: false
            };
        case 0, $dr4qD.SET_GLOBAL_CREATE_ISSUE:
            return {
                ...state,
                isGlobalCreateIssue: action.payload.isGlobalCreateIssue
            };
        case 0, $dr4qD.SET_ISSUE_TYPE_ID:
            {
                const { payload: { issueTypeId: issueTypeId } } = action;
                return {
                    ...state,
                    issueTypeId: issueTypeId
                };
            }
        case 0, $dr4qD.SET_PROJECT_ID:
            {
                const { payload: { projectId: projectId } } = action;
                return {
                    ...state,
                    projectId: projectId,
                    values: {
                        ...state.values,
                        project: projectId
                    }
                };
            }
        case 0, $dr4qD.SET_SIBLING_ID:
            {
                const { payload: { siblingId: siblingId } } = action;
                return {
                    ...state,
                    siblingId: siblingId
                };
            }
        case 0, $dr4qD.START_INLINE_CREATE:
            {
                const { payload: { parentId: parentId, issueTypeId: issueTypeId, hierarchyLevel: hierarchyLevel, projectId: projectId, siblingId: siblingId, group: group, groupCombination: groupCombination, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup, valuesFromGrouping: valuesFromGrouping } } = action;
                return {
                    ...state,
                    group: group,
                    groupCombination: groupCombination,
                    isOpen: true,
                    parentId: parentId,
                    siblingId: siblingId,
                    issueTypeId: issueTypeId,
                    hierarchyLevel: hierarchyLevel,
                    projectId: projectId,
                    startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup,
                    values: {
                        ...$5c6b2f4623c81057$var$defaultValues,
                        project: projectId,
                        ...valuesFromGrouping
                    }
                };
            }
        case 0, $dr4qD.UPDATE_INLINE_CREATE:
            return {
                ...state,
                values: {
                    ...state.values,
                    ...action.payload
                }
            };
        case 0, $dr4qD.SET_OPEN_LOCKED:
            {
                const { attribute: attribute, isLocked: isLocked } = action.payload;
                return {
                    ...state,
                    openLockedMap: {
                        ...state.openLockedMap,
                        [attribute]: isLocked
                    }
                };
            }
        case 0, $dr4qD.SET_ISSUE_TYPE_ID_FOR_HIERARCHY:
            {
                const { hierarchyLevel: hierarchyLevel, issueTypeId: issueTypeId } = action.payload;
                return {
                    ...state,
                    IssueTypeIdForHierarchy: {
                        ...state.IssueTypeIdForHierarchy,
                        [hierarchyLevel]: issueTypeId
                    }
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var // this persisted reducer is being removed with view-switching
// eslint-disable-next-line jira/redux/redux-persist-whitelist
$5c6b2f4623c81057$export$2e2bcd8739ae039 = (0, $c8Rgw.persistReducer)({
    key: (0, $kBus3.getPlanPrefixedKey)('issues-type-for-hierarchy'),
    whitelist: [
        'IssueTypeIdForHierarchy'
    ]
}, $5c6b2f4623c81057$var$reducer);

});
parcelRegister("8RAUa", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PROJECT_ID", () => $8e373c7c08615cc1$export$2d57479448be0d61);
$parcel$export(module.exports, "DEFAULT_SCRATCH_ISSUE_TYPE", () => $8e373c7c08615cc1$export$5331cbeee80032d1);
$parcel$export(module.exports, "prepareIssues", () => $8e373c7c08615cc1$export$7ee48aec63e12327);
$parcel$export(module.exports, "prepareIssueGoals", () => $8e373c7c08615cc1$export$10fa05fcb84f4152);
$parcel$export(module.exports, "prepareIssueLabels", () => $8e373c7c08615cc1$export$8c647deb657d24f3);
$parcel$export(module.exports, "prepareCustomLabels", () => $8e373c7c08615cc1$export$e4e5ef06a110b4fe);
$parcel$export(module.exports, "prepareIssueLinks", () => $8e373c7c08615cc1$export$77be91e7c3f75d53);
$parcel$export(module.exports, "prepareOriginalIssues", () => $8e373c7c08615cc1$export$2369010677cffb11);
$parcel$export(module.exports, "prepareOriginalTeams", () => $8e373c7c08615cc1$export$9f9189c6bd7cd5f2);
$parcel$export(module.exports, "prepareOriginalResources", () => $8e373c7c08615cc1$export$7c7246f1cd0fb982);
$parcel$export(module.exports, "preparePlan", () => $8e373c7c08615cc1$export$ba899063f8c1fb3);
$parcel$export(module.exports, "prepareProjects", () => $8e373c7c08615cc1$export$bdd0152d88205d11);
$parcel$export(module.exports, "prepareReleaseStatuses", () => $8e373c7c08615cc1$export$5973c8d181359244);
$parcel$export(module.exports, "prepareSprints", () => $8e373c7c08615cc1$export$a493e3df6f49328a);
$parcel$export(module.exports, "prepareSolution", () => $8e373c7c08615cc1$export$a2595bd0c9ce474b);
$parcel$export(module.exports, "prepareTeam", () => $8e373c7c08615cc1$export$399f8f703c757cc2);
$parcel$export(module.exports, "prepareTeams", () => $8e373c7c08615cc1$export$cc413d722ead6efe);
$parcel$export(module.exports, "prepareVersions", () => $8e373c7c08615cc1$export$56367a2df59d4d2c);
$parcel$export(module.exports, "prepareOriginalVersions", () => $8e373c7c08615cc1$export$fd78157933f7abd6);
$parcel$export(module.exports, "prepareCrossProjectVersions", () => $8e373c7c08615cc1$export$aef37bed4a9e5dd5);
$parcel$export(module.exports, "prepareOriginalCrossProjectVersions", () => $8e373c7c08615cc1$export$8c1dc82bd60fadde);
$parcel$export(module.exports, "isFlagHidden", () => $8e373c7c08615cc1$export$2336e431db64bb71);
$parcel$export(module.exports, "prepareWRMPlannedCapacities", () => $8e373c7c08615cc1$export$3adcaa8cd98b8f6a);
$parcel$export(module.exports, "prepareWRMOriginalPlannedCapacities", () => $8e373c7c08615cc1$export$2656d9c43b9d53c6);
$parcel$export(module.exports, "updateRefs", () => $8e373c7c08615cc1$export$a193e7f93f99fcee);

var $2ZWVL = parcelRequire("2ZWVL");
var $hkOxK = parcelRequire("hkOxK");
var $e1ur4 = parcelRequire("e1ur4");
var $fpul1 = parcelRequire("fpul1");
var $eirae = parcelRequire("eirae");
var $jPCDz = parcelRequire("jPCDz");
var $b3iuB = parcelRequire("b3iuB");
var $erwaN = parcelRequire("erwaN");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $95vNo = parcelRequire("95vNo");
var $cQwal = parcelRequire("cQwal");
var $3by2Y = parcelRequire("3by2Y");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");
var $6aakY = parcelRequire("6aakY");
var $2uEDR = parcelRequire("2uEDR");
var $1uCJR = parcelRequire("1uCJR");
var $egiDP = parcelRequire("egiDP");
var $elb6l = parcelRequire("elb6l");
var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $3l6tm = parcelRequire("3l6tm");

var $9QGGE = parcelRequire("9QGGE");

var $17L5s = parcelRequire("17L5s");
var $8YqJS = parcelRequire("8YqJS");

var $dYnI4 = parcelRequire("dYnI4");

var $64VaH = parcelRequire("64VaH");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $frMqv = parcelRequire("frMqv");

var $g7NYg = parcelRequire("g7NYg");
const $8e373c7c08615cc1$export$2d57479448be0d61 = -1;
const $8e373c7c08615cc1$export$daec004a13bf7323 = {
    id: -2,
    name: 'Story',
    iconUrl: (0, $64VaH.proxyContextSafeUrl)((0, $9QGGE.puppies).puppy1),
    level: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE)
};
const $8e373c7c08615cc1$export$5331cbeee80032d1 = $8e373c7c08615cc1$export$daec004a13bf7323;
function $8e373c7c08615cc1$export$d12436df6b5b161e(dateConfiguration) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function normalizeDates(x) {
        const result = {
            ...x
        };
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        for (const [f, props] of [
            [
                (0, $17L5s.startOfUtcDay),
                [
                    'start',
                    baselineStartField.key
                ]
            ],
            [
                (0, $17L5s.endOfUtcDay),
                [
                    'end',
                    baselineEndField.key
                ]
            ]
        ])for (const prop of props){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if ((0, $7CnHa.isDefined)(x[prop])) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            result[prop] = f(x[prop]);
            else if ((0, $7CnHa.isDefined)(x.customFields) && (0, $7CnHa.isDefined)(x.customFields[prop])) result.customFields[prop] = f(x.customFields[prop]);
        }
        return result;
    };
}
function $8e373c7c08615cc1$var$normalizeParentTeamAndSprintForSubtasks(issuesById) {
    return (issue)=>{
        const parentIssue = issuesById[issue.parent || ''];
        if (!(0, $7CnHa.isDefined)(parentIssue)) return issue;
        if (issue.level >= parentIssue.level) return $cQwal.default([
            'parent'
        ], issue);
        if (issue.level === (0, $8YqJS.SUB_TASK_LEVEL) && (issue.team !== parentIssue.team || issue.sprint !== parentIssue.sprint)) {
            const changes = {
                team: parentIssue.team,
                sprint: parentIssue.sprint
            };
            return $01zCq.default(issue, changes);
        }
        return issue;
    };
}
const $8e373c7c08615cc1$export$7ee48aec63e12327 = (apiIssues = [], { levels: levels, issueTypes: issueTypes, dateConfiguration: dateConfiguration, releasesDisabledProject: releasesDisabledProject })=>{
    const typeToLevel = (0, $frMqv.getTypeToLevelPure)(levels, issueTypes);
    const normalizeDates = $8e373c7c08615cc1$export$d12436df6b5b161e(dateConfiguration);
    const issues = apiIssues.map(({ id: id, issueKey: issueKey, assignments: assignments, annotations: annotations, issueSources: issueSources, values: { assignee: assignee, associatedIssueIds: associatedIssueIds, reporter: reporter, baselineStart: baselineStart, baselineEnd: baselineEnd, color: color, customFields: customFields, description: description, dueDate: dueDate, earliestStart: earliestStart, excluded: excluded, fixVersions: fixVersions, goals: goals, labels: labels, lexoRank: lexoRank, originalStoryPoints: originalStoryPoints, originalTimeEstimate: originalTimeEstimate, parent: parent, priority: priority, project: project, sprint: sprint, completedSprints: completedSprints, status: status, storyPoints: storyPoints, summary: summary, team: team, timeEstimate: timeEstimate, timeSpent: timeSpent, type: type, components: components }, originals: { completedSprints: ogCompletedSprints } })=>normalizeDates({
            assignments: assignments.map(normalizeDates),
            annotations: annotations,
            assignee: assignee || 'unassigned',
            associatedIssueIds: associatedIssueIds || undefined,
            reporter: reporter,
            color: color,
            customFields: customFields,
            description: description,
            dueDate: dueDate,
            earliestStart: earliestStart,
            excluded: excluded,
            fixVersions: releasesDisabledProject.includes(project) ? [] : fixVersions,
            goals: goals,
            id: id,
            issueKey: issueKey,
            level: typeToLevel(type),
            labels: labels,
            lexoRank: lexoRank,
            issueSources: issueSources,
            originalStoryPoints: originalStoryPoints,
            originalTimeEstimate: originalTimeEstimate,
            parent: parent,
            priority: priority,
            project: project,
            sprint: sprint,
            completedSprints: [
                ...completedSprints || [],
                ...ogCompletedSprints || []
            ],
            status: status,
            storyPoints: storyPoints,
            summary: summary,
            // switch baselineStart/End out for TargetStart/End, as we store the configured start field in baselineStart/End later
            [$eOsHk.TARGET_START_FIELD]: baselineStart,
            [$eOsHk.TARGET_END_FIELD]: baselineEnd,
            team: team,
            timeEstimate: timeEstimate,
            timeSpent: timeSpent,
            components: components,
            type: (0, $7CnHa.isDefined)(type) || project ? type : $8e373c7c08615cc1$export$daec004a13bf7323.id
        }));
    const issuesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), issues);
    return issues.map($8e373c7c08615cc1$var$normalizeParentTeamAndSprintForSubtasks(issuesById));
};
const $8e373c7c08615cc1$export$10fa05fcb84f4152 = (issues, originalIssues)=>{
    const result = new Set();
    for (const { goals: goals } of issues)for (const goal of goals || [])result.add(goal);
    for (const { goals: goals } of (0, $7CnHa.values)(originalIssues))for (const goal of goals || [])result.add(goal);
    return Array.from(result).sort();
};
const $8e373c7c08615cc1$export$8c647deb657d24f3 = (issues, originalIssues)=>{
    const result = new Set();
    for (const { labels: labels } of issues)for (const label of labels || [])result.add(label);
    for (const { labels: labels } of (0, $7CnHa.values)(originalIssues))for (const label of labels || [])result.add(label);
    return Array.from(result).sort();
};
const $8e373c7c08615cc1$export$e4e5ef06a110b4fe = (issues, originalIssues, customFields)=>{
    const result = {};
    const labelFieldIds = customFields.filter((field)=>(0, $ayXoc.isLabelCustomField)(field?.type?.key)).map((field)=>field.id);
    if (labelFieldIds.length < 1) return result;
    const getCustomLabels = (issue)=>{
        labelFieldIds.forEach((fieldId)=>{
            const customFieldValue = issue?.customFields?.[fieldId];
            if (Array.isArray(customFieldValue) && (0, $7CnHa.isDefined)(fieldId)) {
                const customLabels = result[fieldId];
                if (Array.isArray(customLabels)) result[Number(fieldId)] = $1uCJR.default(customLabels.concat(customFieldValue));
                else result[Number(fieldId)] = customFieldValue;
            }
        });
    };
    issues.forEach(getCustomLabels);
    (0, $7CnHa.values)(originalIssues).forEach(getCustomLabels);
    return result;
};
const $8e373c7c08615cc1$export$5e8aad9fb5510614 = (currentCustomLabels, newCustomLabels)=>$95vNo.default($3IGDG.default($e1ur4.default, $1uCJR.default), currentCustomLabels, newCustomLabels);
const $8e373c7c08615cc1$export$eb3bc0a67206b042 = (issues, originalIssues)=>{
    const result = new Set();
    for (const { components: components } of issues)for (const component of components || [])result.add(component);
    for (const { components: components } of (0, $7CnHa.values)(originalIssues))for (const component of components || [])result.add(component);
    return Array.from(result).sort();
};
const $8e373c7c08615cc1$export$77be91e7c3f75d53 = (issues, dependencySettingsInfo)=>{
    const result = {
        values: {},
        originals: {}
    };
    const modes = [
        'values',
        'originals'
    ];
    const linkTypes = new Set((0, $7CnHa.pluck)('issueLinkTypeId', dependencySettingsInfo.dependencyIssueLinkTypes));
    const dependencyIssueLinkTypeById = (0, $7CnHa.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencySettingsInfo.dependencyIssueLinkTypes);
    for (const issue of issues){
        const { id: id } = issue;
        for (const mode of modes){
            let links = issue[mode].issueLinks;
            if (links) {
                links = links.map((link)=>{
                    if (dependencyIssueLinkTypeById[link.type] && !dependencyIssueLinkTypeById[link.type].isOutward) return {
                        ...link,
                        sourceItemKey: link.targetItemKey,
                        targetItemKey: link.sourceItemKey
                    };
                    return link;
                });
                result[mode][id] = (0, $7CnHa.indexBy)((x)=>x.itemKey, links.filter((x)=>linkTypes.has(x.type)));
            }
        }
    }
    return result;
};
const $8e373c7c08615cc1$export$2369010677cffb11 = (issues, dateConfiguration, scenarioRemovedIssues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const originalIssues = {};
    const normalizeDates = $8e373c7c08615cc1$export$d12436df6b5b161e(dateConfiguration);
    for (const { id: id, issueKey: issueKey, originals: rawOriginals } of [
        ...issues,
        ...scenarioRemovedIssues || []
    ]){
        const { issueLinks: issueLinks, statusTransition: statusTransition, ...originals } = rawOriginals;
        if (!$b3iuB.default(originals)) {
            const { baselineStart: baselineStart, baselineEnd: baselineEnd, ...otherOriginals } = originals;
            const originalValues = {
                ...otherOriginals
            };
            if ($jPCDz.default('baselineStart')(originals)) originalValues[$eOsHk.TARGET_START_FIELD] = baselineStart;
            if ($jPCDz.default('baselineEnd')(originals)) originalValues[$eOsHk.TARGET_END_FIELD] = baselineEnd;
            originalIssues[id] = normalizeDates(originalValues);
        } else if (!(0, $7CnHa.isDefined)(issueKey)) // issue not committed to Jira has no originals, but we still want it to present in originalIssues
        originalIssues[id] = {};
    }
    return originalIssues;
};
const $8e373c7c08615cc1$export$9f9189c6bd7cd5f2 = (teams)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const originalTeams = {};
    for (const { id: id, originals: originals, itemKey: itemKey, scenarioType: scenarioType } of teams){
        if (!$b3iuB.default(originals)) originalTeams[itemKey] = originals;
        else if (!itemKey) originalTeams[id] = {};
        else if (scenarioType) originalTeams[itemKey] = {};
    }
    return originalTeams;
};
const $8e373c7c08615cc1$export$7c7246f1cd0fb982 = (teams)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const originalResources = {};
    for (const { resources: resources } of teams)resources.filter((resource)=>resource.scenarioType).forEach((resource)=>{
        originalResources[resource.itemKey] = {};
    });
    return originalResources;
};
const $8e373c7c08615cc1$export$ba899063f8c1fb3 = ({ currentScenarioId: currentScenarioId, plan: { id: id, title: title, planningUnit: planningUnit, issueSources: issueSources, multiScenarioEnabled: multiScenarioEnabled, includeCompletedIssuesFor: includeCompletedIssuesFor, calculationConfiguration: calculationConfiguration, syncStartEnabled: syncStartEnabled, issueInferredDateSelection: issueInferredDateSelection, baselineStartField: baselineStartField, baselineEndField: baselineEndField, createdTimestamp: createdTimestamp, creatorAccountId: creatorAccountId }, scenarios: scenarios, teamManager: teamManager, useTwpTeams: useTwpTeams, zeroMemberTeamsCount: // delete this key when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
zeroMemberTeamsCount, isSamplePlan: // Default value for safety due to how the FF is managed
isSamplePlan = false, autoSchedulerEnabled: autoSchedulerEnabled = true, planStatus: planStatus = 'ACTIVE', planType: planType })=>({
        id: id,
        title: title,
        currentScenarioId: currentScenarioId,
        planningUnit: planningUnit,
        issueSources: issueSources,
        multiScenarioEnabled: multiScenarioEnabled,
        scenarios: scenarios,
        includeCompletedIssuesFor: includeCompletedIssuesFor,
        autoScheduleConfiguration: calculationConfiguration,
        teamManager: teamManager,
        syncStartEnabled: syncStartEnabled,
        issueInferredDateSelection: issueInferredDateSelection,
        baselineStartField: baselineStartField,
        baselineEndField: baselineEndField,
        createdTimestamp: createdTimestamp,
        useTwpTeams: useTwpTeams,
        zeroMemberTeamsCount: // delete this key when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
        zeroMemberTeamsCount,
        isSamplePlan: isSamplePlan,
        autoSchedulerEnabled: autoSchedulerEnabled,
        planStatus: planStatus,
        creatorAccountId: creatorAccountId,
        planType: planType
    });
const $8e373c7c08615cc1$var$getPrioritiesForProject = (issuePriorityInformation, projectId)=>{
    const { issuePrioritySchemes: issuePrioritySchemes, projectToPrioritySchemeAssociations: projectToPrioritySchemeAssociations } = issuePriorityInformation;
    const prioritySchemeId = projectToPrioritySchemeAssociations[projectId];
    return issuePrioritySchemes[prioritySchemeId];
};
const $8e373c7c08615cc1$export$53e809f11defc51 = ({ id: id, key: key, name: name, avatarUrl: avatarUrl, versions: versions, issueTypeIds: issueTypeIds, issueStatusIds: issueStatusIds, components: components, isSimplified: isSimplified, projectTypeKey: projectTypeKey, isReleasesEnabled: isReleasesEnabled }, defaultIssuePriorityScheme)=>{
    const { defaultIssuePriorityId: defaultIssuePriorityId, issuePriorityIds: issuePriorityIds = [], id: prioritySchemaId } = defaultIssuePriorityScheme;
    return {
        id: id,
        key: key,
        name: name,
        avatarUrl: avatarUrl,
        versions: versions.filter($2ZWVL.default($h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED))).map($f7Op5.default('itemKey')),
        components: components,
        issueStatusIds: issueStatusIds,
        issueTypeIds: issueTypeIds.map((x)=>parseInt(x, 10)),
        issuePriorityIds: issuePriorityIds,
        defaultIssuePriorityId: defaultIssuePriorityId,
        prioritySchemaId: prioritySchemaId,
        isSimplified: isSimplified,
        projectTypeKey: projectTypeKey,
        isReleasesEnabled: isReleasesEnabled ?? true
    };
};
const $8e373c7c08615cc1$export$bdd0152d88205d11 = (projects, issuePriorityInformation)=>projects.map((project)=>$8e373c7c08615cc1$export$53e809f11defc51(project, $8e373c7c08615cc1$var$getPrioritiesForProject(issuePriorityInformation, project.id)));
const $8e373c7c08615cc1$export$5973c8d181359244 = (releaseStatuses)=>[
        // the releaseStatuses array includes the following statuses:
        // [{ id: "0", name: "Unreleased" }, { id: "1", name: "Released" }]
        ...releaseStatuses,
        // to which we're adding these two ARJ "special" statuses
        // note that the "name" isn't actually used in the codebase, we keep it just for reference
        (0, $g7NYg.offTrack),
        (0, $g7NYg.onTrack)
    ];
const $8e373c7c08615cc1$export$b1987cbfdb1ff1f6 = (sprints, planInfo)=>{
    const sprintIssueSources = {};
    planInfo.plan.issueSources.forEach((issueSource)=>{
        if (issueSource.sprintIds && Array.isArray(issueSource.sprintIds)) issueSource.sprintIds.forEach((sprintId)=>{
            if (!sprintIssueSources[sprintId]) sprintIssueSources[sprintId] = new Set();
            sprintIssueSources[sprintId].add(issueSource.id);
        });
    });
    return $3IGDG.default($cQGVO.default((sprint)=>({
            ...sprint,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueSources: Array.from(sprintIssueSources[sprint.id] || []),
            // Make the sprint ID be a string instead of a number. This keeps it consistent with the Issue.sprint type.
            id: `${sprint.id}`
        })), // Reason for double-reverse - https://stash.atlassian.com/projects/JPOS/repos/portfolio-server/pull-requests/2153/overview?commentId=1711287
    $2uEDR.default, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $egiDP.default((s)=>s.id), $2uEDR.default)(sprints);
};
const $8e373c7c08615cc1$export$a493e3df6f49328a = (0, $dYnI4.monitor).timeFunction($8e373c7c08615cc1$export$b1987cbfdb1ff1f6, 'state_domain_util_prepareSprints');
const $8e373c7c08615cc1$var$groupPlannedCapacities = (plannedCapacities)=>$hkOxK.default($cQGVO.default((plannedCapacitiesInGroup)=>(0, $7CnHa.indexBy)($f7Op5.default('iterationId'), plannedCapacitiesInGroup)), $eirae.default($f7Op5.default('teamId')))(plannedCapacities);
const $8e373c7c08615cc1$export$8ee5116566102c9e = (arr)=>$8e373c7c08615cc1$var$groupPlannedCapacities(arr);
const $8e373c7c08615cc1$export$c6aff91679d072cd = (arr)=>$8e373c7c08615cc1$var$groupPlannedCapacities(arr);
const $8e373c7c08615cc1$export$a2595bd0c9ce474b = ({ id: id, solution: solution, calculationConfiguration: calculationConfiguration })=>{
    if (!solution) throw new Error('Expected calculationResult with solution');
    const { projects: projects, teams: teams } = solution;
    return {
        id: id,
        projects: projects,
        teams: teams,
        calculationConfiguration: calculationConfiguration
    };
};
const $8e373c7c08615cc1$export$399f8f703c757cc2 = ({ itemKey: itemKey, resources: resources, shareable: shareable, scenarioType: scenarioType, values: // eslint-disable-next-line @typescript-eslint/no-shadow
values, originals: originals, externalId: externalId })=>({
        id: itemKey,
        resources: resources,
        shareable: shareable,
        originals: originals,
        scenarioType: scenarioType,
        // Casted since there are fields on TeamValues that aren't on Team should be fixed up
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        ...values,
        avatarUrl: values.avatarUrl || '',
        externalId: externalId
    });
const $8e373c7c08615cc1$export$cc413d722ead6efe = (teams)=>teams.map($8e373c7c08615cc1$export$399f8f703c757cc2);
const $8e373c7c08615cc1$var$mergeApiVersionsOld = (allVersions, projectId, versions, isPreparingRemovedVersions)=>{
    let versionsToProcess;
    if (isPreparingRemovedVersions) versionsToProcess = versions.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED));
    else versionsToProcess = versions.filter($2ZWVL.default($h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED)));
    // eslint-disable-next-line @typescript-eslint/no-shadow
    for (const { itemKey: itemKey, values: values } of versionsToProcess){
        const mappedValues = {
            ...values
        };
        if ((0, $7CnHa.isDefined)(mappedValues.end)) mappedValues.end = (0, $17L5s.endOfUtcDay)(mappedValues.end);
        const prev = allVersions[itemKey] || {
            projects: []
        };
        // eslint-disable-next-line no-param-reassign
        allVersions[itemKey] = {
            ...prev,
            ...mappedValues,
            id: itemKey,
            projects: Array.from(new Set([
                ...prev.projects,
                projectId
            ]))
        };
    }
};
const $8e373c7c08615cc1$export$1fe0089a80242df0 = (allVersions, projectId, versions, isPreparingRemovedVersions)=>{
    const newAllVersions = allVersions;
    let versionsToProcess;
    if (isPreparingRemovedVersions) versionsToProcess = versions.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED));
    else versionsToProcess = versions.filter($2ZWVL.default($h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED)));
    // eslint-disable-next-line @typescript-eslint/no-shadow
    for (const { itemKey: itemKey, values: values } of versionsToProcess){
        const mappedValues = {
            ...values
        };
        if ((0, $7CnHa.isDefined)(mappedValues.end)) mappedValues.end = (0, $17L5s.endOfUtcDay)(mappedValues.end);
        const prev = allVersions[itemKey] || {
            projects: []
        };
        newAllVersions[itemKey] = {
            ...prev,
            ...mappedValues,
            id: itemKey,
            projects: Array.from(new Set([
                ...prev.projects,
                projectId
            ]))
        };
    }
    return newAllVersions;
};
const $8e373c7c08615cc1$export$56367a2df59d4d2c = (projects, crossProjectVersions, { isPreparingRemovedVersions: isPreparingRemovedVersions })=>{
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let allVersions = {};
        const crossProjectVersionsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('itemKey'), crossProjectVersions);
        for (const { id: id, versions: versions } of projects)allVersions = $8e373c7c08615cc1$export$1fe0089a80242df0(allVersions, id, versions, isPreparingRemovedVersions);
        for (const versionId of Object.keys(allVersions)){
            const crossProjectVersion = allVersions[versionId].crossProjectVersion;
            if ((0, $7CnHa.isDefined)(crossProjectVersion) && !(0, $7CnHa.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) allVersions[versionId].crossProjectVersion = null;
        }
        return $UCNmJ.default(allVersions);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allVersions = {};
    const crossProjectVersionsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('itemKey'), crossProjectVersions);
    for (const { id: id, versions: versions } of projects)$8e373c7c08615cc1$var$mergeApiVersionsOld(allVersions, id, versions, isPreparingRemovedVersions);
    for (const versionId of Object.keys(allVersions)){
        const crossProjectVersion = allVersions[versionId].crossProjectVersion;
        if ((0, $7CnHa.isDefined)(crossProjectVersion) && !(0, $7CnHa.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) allVersions[versionId].crossProjectVersion = null;
    }
    return $UCNmJ.default(allVersions);
};
const $8e373c7c08615cc1$export$fd78157933f7abd6 = (projects, crossProjectVersions)=>{
    const allVersions = [];
    const crossProjectVersionsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('itemKey'), crossProjectVersions);
    for (const { versions: versions } of projects)allVersions.push(...versions);
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const originalVersions = {};
        allVersions.forEach(({ itemKey: id, originals: originals, scenarioType: scenarioType })=>{
            if (scenarioType) {
                const originalValues = {
                    ...originals
                };
                const { crossProjectVersion: crossProjectVersion } = originals;
                /** A version can be assigned to a cross-project version in another plan. In that case it won't be
				 *  part of our crossProjectVersionsByIdMap. In that situation we want to set the originalValue.crossProjectVersion to null.
				 */ if ((0, $7CnHa.isDefined)(crossProjectVersion) && !(0, $7CnHa.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) originalValues.crossProjectVersion = null;
                originalVersions[id] = originalValues;
            }
            return originalVersions;
        });
        return originalVersions;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return allVersions.reduce((originalVersions, { itemKey: id, originals: originals, scenarioType: scenarioType })=>{
        if (scenarioType) {
            const originalValues = {
                ...originals
            };
            const crossProjectVersion = originals.crossProjectVersion;
            /** A version can be assigned to a cross-project version in another plan. In that case it won't be
				 *  part of our crossProjectVersionsByIdMap. In that situation we want to set the originalValue.crossProjectVersion to null.
				 */ if ((0, $7CnHa.isDefined)(crossProjectVersion) && !(0, $7CnHa.isDefined)(crossProjectVersionsByIdMap[crossProjectVersion])) originalValues.crossProjectVersion = null;
            // eslint-disable-next-line no-param-reassign
            originalVersions[id] = originalValues;
        }
        return originalVersions;
    }, {});
};
const $8e373c7c08615cc1$export$1999a22f899a37d4 = (crossProjectVersionId, versions)=>versions.filter(({ crossProjectVersion: crossProjectVersion })=>(0, $7CnHa.isDefined)(crossProjectVersion) && crossProjectVersion === crossProjectVersionId).map(({ id: id })=>id);
const $8e373c7c08615cc1$export$aef37bed4a9e5dd5 = (crossProjectVersions, versions, { isPreparingDeletedCrossProjectVersions: isPreparingDeletedCrossProjectVersions })=>{
    const [deletedCrossProjectVersions, existingCrossProjectVersions] = $3by2Y.default(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $h3f0m.default('scenarioType', (0, $5rYNM.SCENARIO_TYPE).DELETED), crossProjectVersions).map((crossProjectVersions)=>crossProjectVersions.map(({ itemKey: itemKey, values: { name: name } })=>({
                id: itemKey,
                name: name,
                versions: $8e373c7c08615cc1$export$1999a22f899a37d4(itemKey, versions)
            })));
    if (isPreparingDeletedCrossProjectVersions) return deletedCrossProjectVersions;
    return existingCrossProjectVersions;
};
const $8e373c7c08615cc1$export$8c1dc82bd60fadde = (crossProjectVersions)=>{
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const originalCrossProjectVersions = {};
        crossProjectVersions.forEach(({ itemKey: id, originals: originals, scenarioType: scenarioType })=>{
            if (scenarioType) originalCrossProjectVersions[id] = {
                ...originals
            };
            return originalCrossProjectVersions;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return crossProjectVersions.reduce((originalCrossProjectVersions, { itemKey: id, originals: originals, scenarioType: scenarioType })=>{
        if (scenarioType) // eslint-disable-next-line no-param-reassign
        originalCrossProjectVersions[id] = {
            ...originals
        };
        return originalCrossProjectVersions;
    }, {});
};
const $8e373c7c08615cc1$export$2336e431db64bb71 = (flagName, hiddenFlags)=>{
    const currentHiddenFlag = hiddenFlags[flagName];
    const currentTimeStamp = Date.now();
    return !!(currentHiddenFlag && currentTimeStamp < currentHiddenFlag.hiddenUntilTimestamp);
};
const $8e373c7c08615cc1$var$plannedCapacityIsDeleted = (plannedCapacity)=>plannedCapacity.scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED;
const $8e373c7c08615cc1$var$mapWRMPlannedCapacity = (plannedCapacity)=>{
    const { itemKey: itemKey, values: { teamKey: teamKey, iterationId: iterationId, schedulingMode: schedulingMode, planningUnit: planningUnit, capacity: capacity } } = plannedCapacity;
    return {
        itemKey: itemKey,
        teamId: teamKey,
        iterationId: String(iterationId),
        schedulingMode: schedulingMode,
        planningUnit: planningUnit,
        capacity: capacity
    };
};
const $8e373c7c08615cc1$var$mapWRMOriginalPlannedCapacity = (plannedCapacity)=>{
    const { itemKey: itemKey, values: { teamKey: teamKey, iterationId: iterationId, schedulingMode: schedulingMode, planningUnit: planningUnit, capacity: capacity }, originals: originals } = plannedCapacity;
    if ($8e373c7c08615cc1$var$plannedCapacityIsDeleted(plannedCapacity)) return {
        itemKey: itemKey,
        teamId: teamKey,
        iterationId: String(iterationId),
        schedulingMode: schedulingMode,
        planningUnit: planningUnit,
        capacity: capacity
    };
    return {
        itemKey: itemKey,
        teamId: teamKey,
        iterationId: String(iterationId),
        schedulingMode: schedulingMode,
        planningUnit: planningUnit,
        capacity: typeof originals.capacity === 'number' ? originals.capacity : null
    };
};
const $8e373c7c08615cc1$var$indexBySprintId = (capacityArray)=>(0, $7CnHa.indexBy)($f7Op5.default('iterationId'), capacityArray);
// Check that the capacity has values
// This is a workaround for this issue: https://bulldog.internal.atlassian.com/browse/JPOS-5179
// TODO: remove this check once that's fixed
const $8e373c7c08615cc1$var$validCapacity = (plannedCapacity)=>!!plannedCapacity.values.teamKey;
const $8e373c7c08615cc1$export$3adcaa8cd98b8f6a = (plannedCapacityList)=>$3IGDG.default($fpul1.default($8e373c7c08615cc1$var$validCapacity), $fpul1.default((plannedCapacity)=>!$8e373c7c08615cc1$var$plannedCapacityIsDeleted(plannedCapacity)), $cQGVO.default($8e373c7c08615cc1$var$mapWRMPlannedCapacity), $eirae.default((it)=>it.teamId), $cQGVO.default($8e373c7c08615cc1$var$indexBySprintId))(plannedCapacityList);
const $8e373c7c08615cc1$export$2656d9c43b9d53c6 = (plannedCapacityList)=>$3IGDG.default($fpul1.default($8e373c7c08615cc1$var$validCapacity), $fpul1.default((c)=>!!c.scenarioType), $cQGVO.default($8e373c7c08615cc1$var$mapWRMOriginalPlannedCapacity), $eirae.default((it)=>it.teamId), $cQGVO.default($8e373c7c08615cc1$var$indexBySprintId))(plannedCapacityList);
const $8e373c7c08615cc1$var$updateSingleRef = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
item, key, oldRef, newRef)=>{
    if (item[key] !== oldRef) return item;
    return {
        ...item,
        [key]: newRef
    };
};
const $8e373c7c08615cc1$var$updateMultiRef = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
item, key, oldRef, newRef)=>{
    const refs = item[key];
    const index = refs.indexOf(oldRef);
    if (index < 0) return item;
    return {
        ...item,
        [key]: newRef === null ? $6aakY.default(index, 1, refs) : $elb6l.default(index, newRef, refs)
    };
};
const $8e373c7c08615cc1$var$updateRef = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
item, key, oldRef, newRef)=>{
    if (oldRef === newRef) return item;
    if (Array.isArray(item[key])) return $8e373c7c08615cc1$var$updateMultiRef(item, key, oldRef, newRef);
    return $8e373c7c08615cc1$var$updateSingleRef(item, key, oldRef, newRef);
};
function $8e373c7c08615cc1$export$a193e7f93f99fcee(items, refs) {
    return $cQGVO.default((item)=>$erwaN.default(refs).reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
        (item, key)=>refs[key].reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
            (item, [oldRef, newRef])=>$8e373c7c08615cc1$var$updateRef(item, key, oldRef, newRef), item), item), items);
}

});
parcelRegister("2ZWVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $22eefdaa366ce6cb$export$2e2bcd8739ae039);

var $3A7ET = parcelRequire("3A7ET");

var $63hMP = parcelRequire("63hMP");
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $22eefdaa366ce6cb$var$complement = /*#__PURE__*/ (0, $3A7ET.default)((0, $63hMP.default));
var $22eefdaa366ce6cb$export$2e2bcd8739ae039 = $22eefdaa366ce6cb$var$complement;

});
parcelRegister("3A7ET", function(module, exports) {

$parcel$export(module.exports, "default", () => $29baacb6985237b1$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $iJKA7 = parcelRequire("iJKA7");
/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var $29baacb6985237b1$var$lift = /*#__PURE__*/ (0, $eSWTK.default)(function lift(fn) {
    return (0, $iJKA7.default)(fn.length, fn);
});
var $29baacb6985237b1$export$2e2bcd8739ae039 = $29baacb6985237b1$var$lift;

});
parcelRegister("iJKA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $da40901606f03762$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $hC9UT = parcelRequire("hC9UT");

var $4v6Gd = parcelRequire("4v6Gd");

var $bwMm3 = parcelRequire("bwMm3");

var $cQGVO = parcelRequire("cQGVO");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $da40901606f03762$var$liftN = /*#__PURE__*/ (0, $ggdJA.default)(function liftN(arity, fn) {
    var lifted = (0, $bwMm3.default)(arity, fn);
    return (0, $bwMm3.default)(arity, function() {
        return (0, $hC9UT.default)((0, $4v6Gd.default), (0, $cQGVO.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $da40901606f03762$export$2e2bcd8739ae039 = $da40901606f03762$var$liftN;

});
parcelRegister("4v6Gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $346f3d2c6f1b23de$export$2e2bcd8739ae039);

var $kJFRt = parcelRequire("kJFRt");

var $ggdJA = parcelRequire("ggdJA");

var $hC9UT = parcelRequire("hC9UT");

var $cQGVO = parcelRequire("cQGVO");
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $346f3d2c6f1b23de$var$ap = /*#__PURE__*/ (0, $ggdJA.default)(function ap(applyF, applyX) {
    return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $hC9UT.default)(function(acc, f) {
        return (0, $kJFRt.default)(acc, (0, $cQGVO.default)(f, applyX));
    }, [], applyF);
});
var $346f3d2c6f1b23de$export$2e2bcd8739ae039 = $346f3d2c6f1b23de$var$ap;

});



parcelRegister("63hMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4680d1ebb0319881$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $4680d1ebb0319881$var$not = /*#__PURE__*/ (0, $eSWTK.default)(function not(a) {
    return !a;
});
var $4680d1ebb0319881$export$2e2bcd8739ae039 = $4680d1ebb0319881$var$not;

});


parcelRegister("e1ur4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a358c494f1db3fb6$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $dPJMs = parcelRequire("dPJMs");

var $bcKbC = parcelRequire("bcKbC");

var $faRtN = parcelRequire("faRtN");

var $3G9Az = parcelRequire("3G9Az");
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $a358c494f1db3fb6$var$concat = /*#__PURE__*/ (0, $ggdJA.default)(function concat(a, b) {
    if ((0, $dPJMs.default)(a)) {
        if ((0, $dPJMs.default)(b)) return a.concat(b);
        throw new TypeError((0, $3G9Az.default)(b) + ' is not an array');
    }
    if ((0, $faRtN.default)(a)) {
        if ((0, $faRtN.default)(b)) return a + b;
        throw new TypeError((0, $3G9Az.default)(b) + ' is not a string');
    }
    if (a != null && (0, $bcKbC.default)(a['fantasy-land/concat'])) return a['fantasy-land/concat'](b);
    if (a != null && (0, $bcKbC.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, $3G9Az.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $a358c494f1db3fb6$export$2e2bcd8739ae039 = $a358c494f1db3fb6$var$concat;

});

parcelRegister("95vNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dd3ea8cd79d581$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $6Xuyi = parcelRequire("6Xuyi");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $69dd3ea8cd79d581$var$mergeDeepWith = /*#__PURE__*/ (0, $4g10W.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $6Xuyi.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $69dd3ea8cd79d581$export$2e2bcd8739ae039 = $69dd3ea8cd79d581$var$mergeDeepWith;

});
parcelRegister("6Xuyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $510ff3c5f93cd938$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $ktV10 = parcelRequire("ktV10");

var $8e6Ja = parcelRequire("8e6Ja");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $510ff3c5f93cd938$var$mergeDeepWithKey = /*#__PURE__*/ (0, $4g10W.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $8e6Ja.default)(function(k, lVal, rVal) {
        if ((0, $ktV10.default)(lVal) && (0, $ktV10.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $510ff3c5f93cd938$export$2e2bcd8739ae039 = $510ff3c5f93cd938$var$mergeDeepWithKey;

});
parcelRegister("8e6Ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd4d97c5b181df8$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $kWDdm = parcelRequire("kWDdm");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $5fd4d97c5b181df8$var$mergeWithKey = /*#__PURE__*/ (0, $4g10W.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $kWDdm.default)(k, l)) result[k] = (0, $kWDdm.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $kWDdm.default)(k, r) && !(0, $kWDdm.default)(k, result)) result[k] = r[k];
    return result;
});
var $5fd4d97c5b181df8$export$2e2bcd8739ae039 = $5fd4d97c5b181df8$var$mergeWithKey;

});



parcelRegister("6aakY", function(module, exports) {

$parcel$export(module.exports, "default", () => $47cbb2030f161437$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $47cbb2030f161437$var$remove = /*#__PURE__*/ (0, $4g10W.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $47cbb2030f161437$export$2e2bcd8739ae039 = $47cbb2030f161437$var$remove;

});

parcelRegister("9QGGE", function(module, exports) {

$parcel$export(module.exports, "kittens", () => $7baa837659600598$export$9efba97d8fa872be);
$parcel$export(module.exports, "puppies", () => $7baa837659600598$export$7f1ab90efc5648fa);
$parcel$export(module.exports, "issueTypes", () => $7baa837659600598$export$581c23707211238b);
$parcel$export(module.exports, "issuePriorities", () => $7baa837659600598$export$dea2e031cf462e5d);

var $kxxtu = parcelRequire("kxxtu");

var $1kspQ = parcelRequire("1kspQ");

var $dIWhR = parcelRequire("dIWhR");

var $TZtYk = parcelRequire("TZtYk");

var $fSLez = parcelRequire("fSLez");

var $h3zVZ = parcelRequire("h3zVZ");

var $axsPk = parcelRequire("axsPk");

var $d4rFV = parcelRequire("d4rFV");

var $j57NH = parcelRequire("j57NH");

var $eUy45 = parcelRequire("eUy45");

var $3CHVk = parcelRequire("3CHVk");

var $h24Bx = parcelRequire("h24Bx");

var $es4Fa = parcelRequire("es4Fa");

var $dzJX1 = parcelRequire("dzJX1");

var $g08zn = parcelRequire("g08zn");

var $895WI = parcelRequire("895WI");

var $hIcLK = parcelRequire("hIcLK");

var $cicK2 = parcelRequire("cicK2");

var $5Ywyt = parcelRequire("5Ywyt");

var $kQtC6 = parcelRequire("kQtC6");

var $cy5eP = parcelRequire("cy5eP");

var $kj0uO = parcelRequire("kj0uO");

var $jC7Yn = parcelRequire("jC7Yn");

var $i6a2x = parcelRequire("i6a2x");

var $9nHD2 = parcelRequire("9nHD2");

var $2NHEx = parcelRequire("2NHEx");

var $dRzgB = parcelRequire("dRzgB");

var $jjn8y = parcelRequire("jjn8y");

var $gGigs = parcelRequire("gGigs");

var $jNxvd = parcelRequire("jNxvd");

var $5U3JZ = parcelRequire("5U3JZ");

var $EAwMo = parcelRequire("EAwMo");

var $5B4ee = parcelRequire("5B4ee");
const $7baa837659600598$export$4313e66a20025fb5 = {
    text: 'Sample Text to be used for a file download content'
};
// WARNING
// some mocks are (unfortunately) dynamically generated using those mock illustrations
// Thus any change to this object is now BREAKING
// and will cause a LOT of test/VR failures
const $7baa837659600598$export$9efba97d8fa872be = {
    kitten1: (/*@__PURE__*/$parcel$interopDefault($hIcLK)),
    kitten2: (/*@__PURE__*/$parcel$interopDefault($cicK2)),
    kitten3: (/*@__PURE__*/$parcel$interopDefault($5Ywyt)),
    kitten4: (/*@__PURE__*/$parcel$interopDefault($kQtC6)),
    kitten5: (/*@__PURE__*/$parcel$interopDefault($cy5eP))
};
// WARNING
// some mocks are (unfortunately) dynamically generated using those mock illustrations
// Thus any change to this object is now BREAKING
// and will cause a LOT of test/VR failures
const $7baa837659600598$export$7f1ab90efc5648fa = {
    buckleyCaffeinating: (/*@__PURE__*/$parcel$interopDefault($kj0uO)),
    buckleyClassy: (/*@__PURE__*/$parcel$interopDefault($jC7Yn)),
    buckleyCoding: (/*@__PURE__*/$parcel$interopDefault($i6a2x)),
    buckleyListening: (/*@__PURE__*/$parcel$interopDefault($9nHD2)),
    puppy1: (/*@__PURE__*/$parcel$interopDefault($jNxvd)),
    puppy2: (/*@__PURE__*/$parcel$interopDefault($5U3JZ)),
    puppy3: (/*@__PURE__*/$parcel$interopDefault($EAwMo)),
    puppy4: (/*@__PURE__*/$parcel$interopDefault($5B4ee))
};
const $7baa837659600598$export$581c23707211238b = {
    epic: (/*@__PURE__*/$parcel$interopDefault($eUy45)),
    task: (/*@__PURE__*/$parcel$interopDefault($dzJX1)),
    story: (/*@__PURE__*/$parcel$interopDefault($h24Bx)),
    bug: (/*@__PURE__*/$parcel$interopDefault($j57NH)),
    subtask: (/*@__PURE__*/$parcel$interopDefault($es4Fa)),
    idea: (/*@__PURE__*/$parcel$interopDefault($3CHVk))
};
const $7baa837659600598$export$dea2e031cf462e5d = {
    lowest: (/*@__PURE__*/$parcel$interopDefault($fSLez)),
    low: (/*@__PURE__*/$parcel$interopDefault($TZtYk)),
    minor: (/*@__PURE__*/$parcel$interopDefault($d4rFV)),
    medium: (/*@__PURE__*/$parcel$interopDefault($axsPk)),
    high: (/*@__PURE__*/$parcel$interopDefault($dIWhR)),
    major: (/*@__PURE__*/$parcel$interopDefault($h3zVZ))
};
const $7baa837659600598$export$31d6f2c3562ba09e = {
    unassigned: (/*@__PURE__*/$parcel$interopDefault($1kspQ)),
    avatarLetterA: (/*@__PURE__*/$parcel$interopDefault($kxxtu))
};
const $7baa837659600598$export$df03f54e09e486fa = {
    cat: (0, (/*@__PURE__*/$parcel$interopDefault($g08zn))),
    cats: (0, (/*@__PURE__*/$parcel$interopDefault($895WI))),
    dog: (0, (/*@__PURE__*/$parcel$interopDefault($2NHEx))),
    pawColor: (0, (/*@__PURE__*/$parcel$interopDefault($jjn8y))),
    pawColorAlternate: (0, (/*@__PURE__*/$parcel$interopDefault($dRzgB))),
    paw: (0, (/*@__PURE__*/$parcel$interopDefault($gGigs)))
};
// These icons are useful for VR-tests, as there is no network-request involved.
const $7baa837659600598$export$80dbe9c6c40b7d25 = {
    atlas: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABcVBMVEUAAAAmhP8mg/8AWs8FV9IMY90kgvwjgPwggP8JXtgJWtQTbOYYcOseffcgfPceevUOZN8NY94LYNoQcOcZcu0ZdfEJW9YIXtkQYM8gd+8dd/EZd/EQaOcSaeISa+UNY94OZN0bcOoYcewWcOwYcOcIaN8QaOMRaeQQcN8VbOUUbeYeePQiffkmhP8jgf0ggP8Wb+kYcOsUaOMRauQmg/8nhP8ffPcYcO8ac+8Zdu8QaN8lhf8Wb+odefQddvIZdO8VbeclhP4lgv4JXtomg/8khf8MZN4NZN8Zc+0LYdolhP8mg/8Ra+QTaeQnhP8UbOMJX9kNYt0ogP8kg/8YcOoYcesmhP8IYNcIYNclhf8nhf8gfPgdePMWcOkHXdYkhP8lgP8qhf8mhP8FW9QHXNgmhf8dd/IIXtUQUM8mhP8IXdclgv4if/kSauQYcesLYdsjgPwPZuAXcOoMYtwOZN4GWtQJX9kif/oZdO4kgvz///8vzF5RAAAAaXRSTlMAf4Awn+7vnyBvkJB/n/5/f98wIN9vcN4QIN9vIKCfv4AwoJ8gIEDuEKCP34Dv7xDfQEDe76/eIJ+PIDDPj1C/n8/fb98/z0+g34+fv1+/QK+fIECfgK9AIG/ur7+A73AwMM/vb5/fgBAJDM76AAAAAWJLR0R6ONWFagAAAAd0SU1FB+YHDAUeI4TSvdEAAADPSURBVBjTY2CAAEYmBiTAzMKamcnGzgHjc2ZxcWfn8PDy8UP4AoJCwiKiYuISklLSIL5MrgyDrBwDg7wCg2KeMFBASZlBJV+VgUFNXYNBUwsooK3DpKunD2QYGDIYGQPpAhPTzEwzaXMGC0sGq0KgQKY1g42tnX2Rg6OTvnMxUMDFlcHNnYFBxSMzs6TUEyjg5c3g4wuyzs/FPyAQSAfpBoeEggTCmMLLIkCMyKjoGJCES2ycM8Sp8Sbl7AmJSRXJKTDPBKUmZVampWcwYAMAeCgij+XGLr4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDctMTJUMDU6MzA6MzUrMDA6MDAwjjdPAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA3LTEyVDA1OjMwOjM1KzAwOjAwQdOP8wAAAABJRU5ErkJggg==',
    purpleLightning: 'data:image/svg+xml;base64,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',
    robot: 'data:image/svg+xml;base64,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',
    breadSlices: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIzMnB4IiBoZWlnaHQ9IjMycHgiIHZpZXdCb3g9IjAgMCAzMiAzMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5ib2FyZF9hdmF0YXI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgICAgICA8ZyBpZD0iYm9hcmRfYXZhdGFyIj4gICAgICAgICAgICA8cmVjdCBpZD0iaXNzdWUtdHlwZV9pY29uIiBmaWxsPSIjMkU4N0ZCIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIyIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgeD0iNyIgeT0iOCIgd2lkdGg9IjQuOTA5MDkwOTEiIGhlaWdodD0iMTYiIHJ4PSIxIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5IiBmaWxsPSIjRkZGRkZGIiB4PSIxMy41NDU0NTQ1IiB5PSI4IiB3aWR0aD0iNC45MDkwOTA5MSIgaGVpZ2h0PSIxNiIgcng9IjEiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHktMiIgZmlsbD0iI0ZGRkZGRiIgeD0iMjAuMDkwOTA5MSIgeT0iOCIgd2lkdGg9IjQuOTA5MDkwOTEiIGhlaWdodD0iMTYiIHJ4PSIxIj48L3JlY3Q+ICAgICAgICA8L2c+ICAgIDwvZz48L3N2Zz4=',
    target: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAVFBMVEUAAAD/ZjP/YED/VTn/XS7/Tif/Wi3/WC7/VjH/WDD/VzD/VjD/VTH/Vy//VjD/Vy//Vi//VTH/VjD/VjD/VjH/VjD/VzD/VjD/Vi//VjD/VjD///9mBMtqAAAAGnRSTlMABQgJCw0RPT5AcHR+gYaHrK2ur7K14Obn6jjiiqUAAAABYktHRBsCYNSkAAAAZklEQVQoz7XSSQ6AIAxA0dYBcCxOINz/oCYqm0ITN/5lX0KYAMnFLEcIFIvN4MvgIQr9AlYrZZYcergbOFh42xjoBB2DJkH7FcSl9gQH3+74zKfSAavarP9eIodTelrxMyCFfBwIL2ppMdyhdcybAAAAAElFTkSuQmCC',
    upArrow: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTWVkaXVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDY0IDY0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNMzIsNTUuOTYzTDMyLDU1Ljk2M2MyLjIsMCw0LTEuOCw0LTRWMTIuMDM3YzAtMi4yLTEuOC00LTQtNGgwYy0yLjIsMC00LDEuOC00LDR2MzkuOTI2DQoJQzI4LDU0LjE2MywyOS44LDU1Ljk2MywzMiw1NS45NjN6Ii8+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNNDkuNTkzLDI5LjYzTDQ5LjU5MywyOS42M2MxLjU1Ni0xLjU1NiwxLjU1Ni00LjEwMSwwLTUuNjU3TDM0LjgyNCw5LjIwNGMtMS41NTYtMS41NTYtNC4xMDEtMS41NTYtNS42NTcsMA0KCWwwLDBjLTEuNTU2LDEuNTU2LTEuNTU2LDQuMTAxLDAsNS42NTdMNDMuOTM2LDI5LjYzQzQ1LjQ5MSwzMS4xODUsNDguMDM3LDMxLjE4NSw0OS41OTMsMjkuNjN6Ii8+DQo8cGF0aCBmaWxsPSIjRUE3RDI0IiBkPSJNMTQuMjQxLDI5LjYzTDE0LjI0MSwyOS42M2MtMS41NTYtMS41NTYtMS41NTYtNC4xMDEsMC01LjY1N0wyOS4wMSw5LjIwNGMxLjU1Ni0xLjU1Niw0LjEwMS0xLjU1Niw1LjY1NywwDQoJbDAsMGMxLjU1NiwxLjU1NiwxLjU1Niw0LjEwMSwwLDUuNjU3TDE5Ljg5NywyOS42M0MxOC4zNDIsMzEuMTg1LDE1Ljc5NiwzMS4xODUsMTQuMjQxLDI5LjYzeiIvPg0KPC9zdmc+DQo=',
    greyTarget: 'data:image/png;base64,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',
    hand: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAApCAYAAAC2qTBFAAAIB0lEQVRYR72YfYgbaR3Hv5NkJplN0k2ye6suW5vVHhwBzy25qvhypJ6iILJBDB7eH90qCCrarihI5WgqiCAcbTnkEMF2RRQatF0QQf+wW6T07o/YxZcUjr02dy45Ndtk9pLdZmaSjHyn88TZaTbJXlcfGHbn7ZlPfi/f3+95JOxtSJ7Hrb29vrenvR/r97aUz+ftA4CUTqelYrFIKCufz/Po7u2Toz89FC6Xy/kLhYIPwCyAnwJ4GsDrAH4AYAlABwAB992KA+Hy+bwvn8/7AcgAbieTyXfPz8/j+vXrWF1dpQk+A+CPAMz/BeAwy/mnp6eDlUrlEwCWL126hOPHj0PTNBw7doyAb8Tj8Sfr9Xorn8+b++3iQXC8R4upAD4JoHDt2jVkMhk7aFZWVmxAAJ8D8AcAhmVZbUmS9s29u8JZliVJkhQEEHHgfumGI1U8HqcVfw/giwC2XO4dPeoHPDkMLgQgCuDDAK4It4r5FhcXcf78+bcAPAGgAaAFoL0vZJSGIeBqOByObm1tMVNvnjp1CufOneu9QtgTJ07w/KMASgC2HTghL3QxvyFcLb43kusHws3MzIQ0TYsYhvGYYRhXM5nM43StGMzYI0eO8PTrAP4J4ClHWn4B4K4DZQOm02k4+uiWnYGQw9xqx1wwGEzoun42Fos9W6/Xe3DMWsYdgDcBvMvjhR8C+BWAHwP4mHPvtwC+k06nXysWi4QcqI8DLZdKpeRSqRQOhULxVqu1AOB5b1LMzs6iXC7jzJkzoNsJfOHCBcYiedbn5uZmstmszcZrmqa9AeB9MzMz5vr6ugDsCzpM5+RYLBbWNO0AgPcAuMYPnDx5smckxhxjzw1NWEJz3L17F8lk0is/LwD4EICPAPgLgC8AeM0JCbs08gU3nPifpYqDfwn0b7pWluVJ0zQvZzKZw+64o5VosX4yE4vFbDgxXGFg6yUPx5p/mp6e/nSlUmGm87ATygvHUkWobwL4HoAYgH9QRgBcAnA6Fot93h13y8vLoNv6uZsWc/8QftBtUZ6fPXsW+Xye/77XiV3DsWAPTsrlcr5CocCK8DwhFhYWMDc3h1u3bmFpifUdfwbwMoCv8RrvcdAadC0lRriP169evWrHIq3qHtTGQ4cO9a675Ihuvg3gvmM9y7YcC/zly5cDpVJpjDGQzWYPXrlCYz0YND0nBfAvAO/wivGOr+/xxAX39IEDB/4+NTW1tba2Rus9gGNbdOPGDRZ4Bv6bNDOzzz1ck9i/2i3Ge+TZbd6PR6PRv05MTDTL5bLegwMQAECrjQP4TTKZfModyGI2p1yBLr948eKjMPXedf3oZwD8DcBblmXpbCBEQhAu7CTApwD8ZDfrOJ3IQ4HOasHsdMsG/xfn3vuCTiSEoigpRVHuNZvNhmVZLS+cqqpqrN1uT5mmeZqtkFfT3JJAEPcgNK+JWO13zue92et4o6koygcEnNNA9CxHCWGpYgcyAWASwIuxWOxJTiYyc5AfvRYddi7mogwtLy+/qijKvGEY9wA0vXC+w4cPy9VqdWxzc3NcluWJbrd7sNPpvJRMJt9J6fBaygs6DGa3cHDK33UAXwEg4P6brc6HhPUYe6zmCadg/6hf9u4HnKur+X4wGPy5ruvsKti0Mlt3VAhWBrd7CUgXfwtA9s6dOz117+fet2M5Zv3S0hJbredCodAdVVXr9XqdPSEXTA81mwRk5nLdQM0j3EG2PplMJuwNZm9CuAN+GKxLQlgWz6uquhGJRDar1SorBJebD3fCFOSbN28q6+vr1D2mJAHZLn11kHuHwbjvs6yxSdU0jZ0I565GIpHa5ORk4+jRo2ahUOgP5wD3c++3AcyzMnjrJX8ls06SpJ6U8JyNqBBr930nCdjtMGRuq6paVVV1s1arcQ1Clz7UMrm9JDmNpu1eWZYTlmUl2u02O5VnRkmQ3WRHuNPn873Q7XZ/DWAjGo3WG43GVi6XM4TV+rrVmdTeF3G0T5Q1JgiP744KyI6Fh7tbcXSNDcSziqJsGIZRY8lKp9N6sVhkL9dbVwzrhJkcFGcCCguyinwDwGcHdSeuRfeOXo+xtrq6ekOW5UW/338vGAzW4/H4/YWFBcO7YzAMjqumQLFYJCD1jxksLPhSNpuddbdWwpUMeCZAuVze4LVkMjkphNyJt9/RA2NjYxvb29tc91LXmAQ7VmPD4Dh3T//C4XCk3W6P67pOgWb1eD+1yjvYaDobPYs+n++xbrd7mq7ls05b/iot760I3nlGgROxGUgkEmqtVmP9JdyLznaYmNM9FzPxZwBe8fv96HQ6HwTwJQBTzvr2digU+nKr1WJF2LYsy+y3xzIynLOBKI+Pj4/puh7rdDpx0zTH/X4/41FhAnU6HbqF7mFtNAKBQLvdbvMa23/GL/+nCzUATIRNp8jbFeHtWk5Yj/rH/RM7QZxNHjUQCMjtdlsKBAL8OHeamHW6aZqmoigwDINgBKQxCML6uTk9Pb1VqVREvD0SnIg/kcGEpA7aVlEUxSdJUlfXdVqOcPYqKhKJWM1m04YLhUJSq9XiNb3ZbN5PpVJ6qVTi83ZFeBTLCeuJBOGCW9Y0TSwned+KRqNWo9EgnNiOtd9LJBL+Wq3mi8fjVr1eF+tT8UP6avaoMbcj6Bl/KysrPmpZKpXybW9v++jStbU1nlulUsletedyOVsaqtWq1Gg0uNEtdpx4vWs92ATcdTNnr3C7VSX3PN5tL28lGmn7a1D52g3i/3r9P73PxFfgQuw7AAAAAElFTkSuQmCC',
    angel: 'data:image/png;base64,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',
    person: 'data:image/svg+xml;base64,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'
};

});
parcelRegister("kxxtu", function(module, exports) {
module.exports = new URL("avatar-letter-a.a574ddda.png", import.meta.url).toString();

});

parcelRegister("1kspQ", function(module, exports) {
module.exports = new URL("unassigned.4cbf42ba.svg", import.meta.url).toString();

});

parcelRegister("dIWhR", function(module, exports) {
module.exports = new URL("high.19a3b29d.svg", import.meta.url).toString();

});

parcelRegister("TZtYk", function(module, exports) {
module.exports = new URL("low.8e8e01f6.svg", import.meta.url).toString();

});

parcelRegister("fSLez", function(module, exports) {
module.exports = new URL("lowest.e96804a1.svg", import.meta.url).toString();

});

parcelRegister("h3zVZ", function(module, exports) {
module.exports = new URL("major.b6ad486f.svg", import.meta.url).toString();

});

parcelRegister("axsPk", function(module, exports) {
module.exports = new URL("medium.825ac8e1.svg", import.meta.url).toString();

});

parcelRegister("d4rFV", function(module, exports) {
module.exports = new URL("minor.45ace9ea.svg", import.meta.url).toString();

});

parcelRegister("j57NH", function(module, exports) {
module.exports = new URL("bug.ee818e22.svg", import.meta.url).toString();

});

parcelRegister("eUy45", function(module, exports) {
module.exports = new URL("epic.51b289d0.svg", import.meta.url).toString();

});

parcelRegister("3CHVk", function(module, exports) {
module.exports = new URL("idea.877bae0a.svg", import.meta.url).toString();

});

parcelRegister("h24Bx", function(module, exports) {
module.exports = new URL("story.c031d198.svg", import.meta.url).toString();

});

parcelRegister("es4Fa", function(module, exports) {
module.exports = new URL("subtask.db935aa5.svg", import.meta.url).toString();

});

parcelRegister("dzJX1", function(module, exports) {
module.exports = new URL("task.ce7fec8e.svg", import.meta.url).toString();

});

parcelRegister("g08zn", function(module, exports) {
module.exports = new URL("cat-animal-icon.2cb08d7b.svg", import.meta.url).toString();

});

parcelRegister("895WI", function(module, exports) {
module.exports = new URL("cats-icon.8c9e32fe.svg", import.meta.url).toString();

});

parcelRegister("hIcLK", function(module, exports) {
module.exports = new URL("kitten1.c7908a10.png", import.meta.url).toString();

});

parcelRegister("cicK2", function(module, exports) {
module.exports = new URL("kitten2.1f13a3cf.png", import.meta.url).toString();

});

parcelRegister("5Ywyt", function(module, exports) {
module.exports = new URL("kitten3.c0dd84a1.png", import.meta.url).toString();

});

parcelRegister("kQtC6", function(module, exports) {
module.exports = new URL("kitten4.7c25dd70.png", import.meta.url).toString();

});

parcelRegister("cy5eP", function(module, exports) {
module.exports = new URL("kitten5.1fe5eed6.png", import.meta.url).toString();

});

parcelRegister("kj0uO", function(module, exports) {
module.exports = new URL("buckley-caffeinating.824a444e.png", import.meta.url).toString();

});

parcelRegister("jC7Yn", function(module, exports) {
module.exports = new URL("buckley-classy.2e622e92.png", import.meta.url).toString();

});

parcelRegister("i6a2x", function(module, exports) {
module.exports = new URL("buckley-coding.e036b89b.png", import.meta.url).toString();

});

parcelRegister("9nHD2", function(module, exports) {
module.exports = new URL("buckley-listening.b145c945.png", import.meta.url).toString();

});

parcelRegister("2NHEx", function(module, exports) {
module.exports = new URL("dog-icon.1c9050b4.svg", import.meta.url).toString();

});

parcelRegister("dRzgB", function(module, exports) {
module.exports = new URL("paw-color-icon-2.47f7229a.svg", import.meta.url).toString();

});

parcelRegister("jjn8y", function(module, exports) {
module.exports = new URL("paw-color-icon.aa5e7c89.svg", import.meta.url).toString();

});

parcelRegister("gGigs", function(module, exports) {
module.exports = new URL("paw-icon.216b0259.svg", import.meta.url).toString();

});

parcelRegister("jNxvd", function(module, exports) {
module.exports = new URL("puppy1.a4a0ed88.png", import.meta.url).toString();

});

parcelRegister("5U3JZ", function(module, exports) {
module.exports = new URL("puppy2.8dc0b94c.png", import.meta.url).toString();

});

parcelRegister("EAwMo", function(module, exports) {
module.exports = new URL("puppy3.73455761.png", import.meta.url).toString();

});

parcelRegister("5B4ee", function(module, exports) {
module.exports = new URL("puppy4.1d6c1107.png", import.meta.url).toString();

});


parcelRegister("g7NYg", function(module, exports) {

$parcel$export(module.exports, "offTrack", () => $28b6e76decb44b45$export$cd48b0013ee54170);
$parcel$export(module.exports, "onTrack", () => $28b6e76decb44b45$export$8e8c195be1d237dd);

var $5rYNM = parcelRequire("5rYNM");
const $28b6e76decb44b45$export$cd48b0013ee54170 = {
    id: (0, $5rYNM.RELEASE_STATUSES).OFFTRACK,
    name: 'Off track'
};
const $28b6e76decb44b45$export$8e8c195be1d237dd = {
    id: (0, $5rYNM.RELEASE_STATUSES).ONTRACK,
    name: 'On track'
};

});


parcelRegister("kBus3", function(module, exports) {

$parcel$export(module.exports, "getPlanPrefixedKey", () => $c6025bba76fd5722$export$61368afd1d6e9efc);
$parcel$export(module.exports, "persistReducer", () => (parcelRequire("c8Rgw")).persistReducer);

var $NeuAT = parcelRequire("NeuAT");

var $c8Rgw = parcelRequire("c8Rgw");
const $c6025bba76fd5722$export$61368afd1d6e9efc = (key)=>{
    const planId = (0, $NeuAT.getPlanId)() || 'none';
    return `jpo-app-simple-plans-${planId}-${key}`;
};

});
parcelRegister("c8Rgw", function(module, exports) {

$parcel$export(module.exports, "persistReducer", () => $3874d40322eb783a$export$1e2465eba28351ae);
parcelRequire("97CJW");
var $eB2GF = parcelRequire("eB2GF");

var $bQZsb = parcelRequire("bQZsb");
const $3874d40322eb783a$export$1e2465eba28351ae = (persistConfig, reducer)=>{
    const fullPersistConfig = {
        storage: (0, $bQZsb.promiseStorage),
        ...persistConfig
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, $eB2GF.default)(fullPersistConfig, reducer);
};

});
parcelRegister("97CJW", function(module, exports) {

$parcel$export(module.exports, "persistReducer", () => (parcelRequire("eB2GF")).default);
$parcel$export(module.exports, "persistStore", () => (parcelRequire("5BTOa")).default);
$parcel$export(module.exports, "createTransform", () => (parcelRequire("hvHzx")).default);

var $eB2GF = parcelRequire("eB2GF");

var $25Szd = parcelRequire("25Szd");

var $5BTOa = parcelRequire("5BTOa");

var $ajgw5 = parcelRequire("ajgw5");

var $hvHzx = parcelRequire("hvHzx");

var $adW0t = parcelRequire("adW0t");

var $Uli5o = parcelRequire("Uli5o");

var $kltR9 = parcelRequire("kltR9");
parcelRequire("kWpB8");

});
parcelRegister("eB2GF", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa069afc095455a7$export$2e2bcd8739ae039);

var $kWpB8 = parcelRequire("kWpB8");

var $jRx4o = parcelRequire("jRx4o");

var $Uli5o = parcelRequire("Uli5o");

var $adW0t = parcelRequire("adW0t");

var $kltR9 = parcelRequire("kltR9");
var $aa069afc095455a7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $aa069afc095455a7$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $aa069afc095455a7$var$DEFAULT_TIMEOUT = 5000;
function $aa069afc095455a7$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $kWpB8.DEFAULT_VERSION);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $jRx4o.default) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $adW0t.default);
    var timeout = config.timeout !== undefined ? config.timeout : $aa069afc095455a7$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $aa069afc095455a7$var$_objectWithoutProperties(_ref, [
            '_persist'
        ]);
        var restState = rest;
        if (action.type === (0, $kWpB8.PERSIST)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                // only rehydrate if we are not already sealed
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
            }, timeout);
            // @NOTE PERSIST resumes if paused.
            _paused = false;
            // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $Uli5o.default)(config);
            // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) return state;
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $aa069afc095455a7$var$_extends({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $kWpB8.PURGE)) {
            _purge = true;
            action.result((0, $kltR9.default)(config));
            return $aa069afc095455a7$var$_extends({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $kWpB8.FLUSH)) {
            action.result(_persistoid && _persistoid.flush());
            return $aa069afc095455a7$var$_extends({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $kWpB8.PAUSE)) _paused = true;
        else if (action.type === (0, $kWpB8.REHYDRATE)) {
            // noop on restState if purging
            if (_purge) return $aa069afc095455a7$var$_extends({}, restState, {
                _persist: $aa069afc095455a7$var$_extends({}, _persist, {
                    rehydrated: true
                })
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload;
                // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $aa069afc095455a7$var$_extends({}, reconciledRest, {
                    _persist: $aa069afc095455a7$var$_extends({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        }
        // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action);
        // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        else {
            newState._persist = _persist;
            return conditionalUpdate(newState);
        }
    };
}

});
parcelRegister("kWpB8", function(module, exports) {

$parcel$export(module.exports, "KEY_PREFIX", () => $f3ed14a7842d929e$export$711117ad6ad27992);
$parcel$export(module.exports, "FLUSH", () => $f3ed14a7842d929e$export$2aaee4793dd13a52);
$parcel$export(module.exports, "REHYDRATE", () => $f3ed14a7842d929e$export$1647ef958242c4e2);
$parcel$export(module.exports, "PAUSE", () => $f3ed14a7842d929e$export$dd1033c27a16bbd3);
$parcel$export(module.exports, "PERSIST", () => $f3ed14a7842d929e$export$913fe0e161ed92a2);
$parcel$export(module.exports, "PURGE", () => $f3ed14a7842d929e$export$5514fc3b4067675f);
$parcel$export(module.exports, "REGISTER", () => $f3ed14a7842d929e$export$51e82cdd7353a0e1);
$parcel$export(module.exports, "DEFAULT_VERSION", () => $f3ed14a7842d929e$export$363ebe89e6e7aeef);
var $f3ed14a7842d929e$export$711117ad6ad27992 = 'persist:';
var $f3ed14a7842d929e$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $f3ed14a7842d929e$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $f3ed14a7842d929e$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $f3ed14a7842d929e$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $f3ed14a7842d929e$export$5514fc3b4067675f = 'persist/PURGE';
var $f3ed14a7842d929e$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $f3ed14a7842d929e$export$363ebe89e6e7aeef = -1;

});

parcelRegister("jRx4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75c9e90908cdef5$export$2e2bcd8739ae039);
var $e75c9e90908cdef5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e75c9e90908cdef5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e75c9e90908cdef5$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $e75c9e90908cdef5$var$_extends({}, reducedState);
    // only rehydrate if inboundState exists and is an object
    if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : $e75c9e90908cdef5$var$_typeof(inboundState)) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return;
        // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
} /*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/ 

});

parcelRegister("Uli5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a95bef80493c9f1$export$2e2bcd8739ae039);

var $kWpB8 = parcelRequire("kWpB8");
function $0a95bef80493c9f1$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $kWpB8.KEY_PREFIX)) + config.key;
    var storage = config.storage;
    var serialize = config.serialize === false ? function(x) {
        return x;
    } : $0a95bef80493c9f1$var$defaultSerialize;
    // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        });
        //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined) keysToProcess.push(key);
        });
        // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {}
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    };
    // return `persistoid`
    return {
        update: update,
        flush: flush
    };
}
// @NOTE in the future this may be exposed via config
function $0a95bef80493c9f1$var$defaultSerialize(data) {
    return JSON.stringify(data);
}

});

parcelRegister("adW0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $77181d350cf4cd8b$export$2e2bcd8739ae039);

var $kWpB8 = parcelRequire("kWpB8");
function $77181d350cf4cd8b$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $kWpB8.KEY_PREFIX)) + config.key;
    var storage = config.storage;
    var debug = config.debug;
    var deserialize = config.serialize === false ? function(x) {
        return x;
    } : $77181d350cf4cd8b$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $77181d350cf4cd8b$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}

});

parcelRegister("kltR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfcedabb8b7ccdb$export$2e2bcd8739ae039);

var $kWpB8 = parcelRequire("kWpB8");
function $ecfcedabb8b7ccdb$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : (0, $kWpB8.KEY_PREFIX)) + config.key;
    return storage.removeItem(storageKey, $ecfcedabb8b7ccdb$var$warnIfRemoveError);
}
function $ecfcedabb8b7ccdb$var$warnIfRemoveError(err) {}

});


parcelRegister("25Szd", function(module, exports) {

var $huRi7 = parcelRequire("huRi7");

var $eB2GF = parcelRequire("eB2GF");

var $jN8mv = parcelRequire("jN8mv");
function $1866604815b9cf3d$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $jN8mv.default) : config.stateReconciler;
    return (0, $eB2GF.default)(config, (0, $huRi7.combineReducers)(reducers));
}

});
parcelRegister("jN8mv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e689146fde7ae5c7$export$2e2bcd8739ae039);
var $e689146fde7ae5c7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $e689146fde7ae5c7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e689146fde7ae5c7$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $e689146fde7ae5c7$var$_extends({}, reducedState);
    // only rehydrate if inboundState exists and is an object
    if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : $e689146fde7ae5c7$var$_typeof(inboundState)) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return;
        // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($e689146fde7ae5c7$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $e689146fde7ae5c7$var$_extends({}, newState[key], inboundState[key]);
            return;
        }
        // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/ function $e689146fde7ae5c7$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : $e689146fde7ae5c7$var$_typeof(o)) === 'object';
}

});


parcelRegister("5BTOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $415bb2d01905222a$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");
parcelRequire("eB2GF");

var $kWpB8 = parcelRequire("kWpB8");
var $415bb2d01905222a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $415bb2d01905222a$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $415bb2d01905222a$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $415bb2d01905222a$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $415bb2d01905222a$var$initialState;
    var action = arguments[1];
    switch(action.type){
        case 0, $kWpB8.REGISTER:
            return $415bb2d01905222a$var$_extends({}, state, {
                registry: [].concat($415bb2d01905222a$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $kWpB8.REHYDRATE:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = [].concat($415bb2d01905222a$var$_toConsumableArray(state.registry));
            registry.splice(firstIndex, 1);
            return $415bb2d01905222a$var$_extends({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $415bb2d01905222a$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $huRi7.createStore)($415bb2d01905222a$var$persistorReducer, $415bb2d01905222a$var$initialState, options ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $kWpB8.REGISTER),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $kWpB8.REHYDRATE),
            payload: payload,
            err: err,
            key: key
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $415bb2d01905222a$var$_extends({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $kWpB8.PURGE),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $kWpB8.FLUSH),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $kWpB8.PAUSE)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $kWpB8.PERSIST),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    persistor.persist();
    return persistor;
}

});

parcelRegister("ajgw5", function(module, exports) {

var $kWpB8 = parcelRequire("kWpB8");
function $78187d950377f881$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $kWpB8.DEFAULT_VERSION);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

});

parcelRegister("hvHzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf7217105a3f9ce$export$2e2bcd8739ae039);
function $cbf7217105a3f9ce$export$2e2bcd8739ae039(// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound, // @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}

});


parcelRegister("bQZsb", function(module, exports) {

$parcel$export(module.exports, "promiseStorage", () => $bcfb09662bacc6db$export$192c9db47d7c59a4);
// This function is based on an example provided here: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
const $bcfb09662bacc6db$var$isStorageAvailable = (type)=>{
    let storage;
    try {
        storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return(// NOTE: Flow is complaining it can't resolve name for DOMException (the commented line is the suggested one from MDN)
        // e instanceof DOMException &&
        e && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0);
    }
};
const $bcfb09662bacc6db$var$localStorageAvailable = $bcfb09662bacc6db$var$isStorageAvailable('localStorage');
// Create a simple object as a fallback for a lack of support for localstorage. This will allow data
const $bcfb09662bacc6db$var$inMemoryStorage = {};
const $bcfb09662bacc6db$var$setItemInLocalStorage = (key, value)=>{
    if ($bcfb09662bacc6db$var$localStorageAvailable) window.localStorage.setItem(key, value);
    else $bcfb09662bacc6db$var$inMemoryStorage[key] = value;
};
const $bcfb09662bacc6db$var$getItemFromLocalStorage = (key)=>{
    if ($bcfb09662bacc6db$var$localStorageAvailable) return window.localStorage.getItem(key);
    return $bcfb09662bacc6db$var$inMemoryStorage[key];
};
const $bcfb09662bacc6db$var$removeItemFromLocalStorage = (key)=>{
    if ($bcfb09662bacc6db$var$localStorageAvailable) window.localStorage.removeItem(key);
    else delete $bcfb09662bacc6db$var$inMemoryStorage[key];
};
const $bcfb09662bacc6db$export$ddcffe0146c8f882 = {
    getItem: (key)=>$bcfb09662bacc6db$var$getItemFromLocalStorage(key),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    setItem: (key, value)=>$bcfb09662bacc6db$var$setItemInLocalStorage(key, value),
    removeItem: (key)=>$bcfb09662bacc6db$var$removeItemFromLocalStorage(key)
};
const $bcfb09662bacc6db$export$192c9db47d7c59a4 = {
    getItem: (key)=>Promise.resolve($bcfb09662bacc6db$var$getItemFromLocalStorage(key)),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    setItem: (key, value)=>Promise.resolve($bcfb09662bacc6db$var$setItemInLocalStorage(key, value)),
    removeItem: (key)=>Promise.resolve($bcfb09662bacc6db$var$removeItemFromLocalStorage(key))
};

});



parcelRegister("dr4qD", function(module, exports) {

$parcel$export(module.exports, "CLEAR_INLINE_CREATE", () => $cd7d0d4179dba33f$export$1a9a8a01b7182017);
$parcel$export(module.exports, "SET_ISSUE_TYPE_ID", () => $cd7d0d4179dba33f$export$b5b06234341e4e89);
$parcel$export(module.exports, "SET_PROJECT_ID", () => $cd7d0d4179dba33f$export$7a6c7dbea71065c6);
$parcel$export(module.exports, "SET_SIBLING_ID", () => $cd7d0d4179dba33f$export$98cade42b641eb6c);
$parcel$export(module.exports, "START_INLINE_CREATE", () => $cd7d0d4179dba33f$export$e4b545016f01a38c);
$parcel$export(module.exports, "UPDATE_INLINE_CREATE", () => $cd7d0d4179dba33f$export$32dcb826f20ea035);
$parcel$export(module.exports, "SET_ISSUE_TYPE_ID_FOR_HIERARCHY", () => $cd7d0d4179dba33f$export$70b83d224b93b6b8);
$parcel$export(module.exports, "SET_GLOBAL_CREATE_ISSUE", () => $cd7d0d4179dba33f$export$e335aa41e2ecdc00);
$parcel$export(module.exports, "SET_OPEN_LOCKED", () => $cd7d0d4179dba33f$export$b6f8461edbea9f82);
$parcel$export(module.exports, "clearInlineCreate", () => $cd7d0d4179dba33f$export$619728c77bf26024);
$parcel$export(module.exports, "startInlineCreate", () => $cd7d0d4179dba33f$export$3b53adae66ce2b28);
$parcel$export(module.exports, "setIssueTypeId", () => $cd7d0d4179dba33f$export$b3b6c9f64a9db332);
$parcel$export(module.exports, "setProjectId", () => $cd7d0d4179dba33f$export$b3b5d26bd744f328);
$parcel$export(module.exports, "setSiblingId", () => $cd7d0d4179dba33f$export$ef019bea9344af30);
$parcel$export(module.exports, "setIssueTypeIdForHierarchy", () => $cd7d0d4179dba33f$export$151bc49debc6e194);
$parcel$export(module.exports, "updateInlineCreate", () => $cd7d0d4179dba33f$export$c3b45d8c36e75acb);
$parcel$export(module.exports, "setGlobalCreateIssue", () => $cd7d0d4179dba33f$export$e8934634f77b30a3);
$parcel$export(module.exports, "setOpenLocked", () => $cd7d0d4179dba33f$export$c2b4d1403d5a92c9);
const $cd7d0d4179dba33f$export$1a9a8a01b7182017 = 'state.ui.main.tabs.roadmap.scope.inline-create.CLEAR_INLINE_CREATE';
const $cd7d0d4179dba33f$export$b5b06234341e4e89 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_ISSUE_TYPE_ID';
const $cd7d0d4179dba33f$export$7a6c7dbea71065c6 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_PROJECT_ID';
const $cd7d0d4179dba33f$export$98cade42b641eb6c = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_SIBLING_ID';
const $cd7d0d4179dba33f$export$e4b545016f01a38c = 'state.ui.main.tabs.roadmap.scope.inline-create.START_INLINE_CREATE';
const $cd7d0d4179dba33f$export$32dcb826f20ea035 = 'state.ui.main.tabs.roadmap.scope.inline-create.UPDATE_INLINE_CREATE';
const $cd7d0d4179dba33f$export$70b83d224b93b6b8 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_ISSUE_TYPE_ID_FOR_HIERARCHY';
const $cd7d0d4179dba33f$export$e335aa41e2ecdc00 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_GLOBAL_CREATE_ISSUE';
const $cd7d0d4179dba33f$export$b6f8461edbea9f82 = 'state.ui.main.tabs.roadmap.scope.inline-create.SET_OPEN_LOCKED';
const $cd7d0d4179dba33f$export$619728c77bf26024 = ()=>({
        type: $cd7d0d4179dba33f$export$1a9a8a01b7182017
    });
const $cd7d0d4179dba33f$export$3b53adae66ce2b28 = (payload)=>({
        type: $cd7d0d4179dba33f$export$e4b545016f01a38c,
        payload: payload
    });
const $cd7d0d4179dba33f$export$b3b6c9f64a9db332 = (issueTypeId)=>({
        type: $cd7d0d4179dba33f$export$b5b06234341e4e89,
        payload: {
            issueTypeId: issueTypeId
        }
    });
const $cd7d0d4179dba33f$export$b3b5d26bd744f328 = (projectId)=>({
        type: $cd7d0d4179dba33f$export$7a6c7dbea71065c6,
        payload: {
            projectId: projectId
        }
    });
const $cd7d0d4179dba33f$export$ef019bea9344af30 = (siblingId)=>({
        type: $cd7d0d4179dba33f$export$98cade42b641eb6c,
        payload: {
            siblingId: siblingId
        }
    });
const $cd7d0d4179dba33f$export$151bc49debc6e194 = (hierarchyLevel, issueTypeId)=>({
        type: $cd7d0d4179dba33f$export$70b83d224b93b6b8,
        payload: {
            hierarchyLevel: hierarchyLevel,
            issueTypeId: issueTypeId
        }
    });
const $cd7d0d4179dba33f$export$c3b45d8c36e75acb = (payload)=>({
        type: $cd7d0d4179dba33f$export$32dcb826f20ea035,
        payload: payload
    });
const $cd7d0d4179dba33f$export$e8934634f77b30a3 = (isGlobalCreateIssue)=>({
        type: $cd7d0d4179dba33f$export$e335aa41e2ecdc00,
        payload: {
            isGlobalCreateIssue: isGlobalCreateIssue
        }
    });
const $cd7d0d4179dba33f$export$c2b4d1403d5a92c9 = (payload)=>({
        type: $cd7d0d4179dba33f$export$b6f8461edbea9f82,
        payload: payload
    });

});



parcelRegister("40hi6", function(module, exports) {

$parcel$export(module.exports, "getIsExpanded", () => $89346a5a4d52c6c9$export$8c797d2c6f8c1a2b);
$parcel$export(module.exports, "getSortedIssues", () => $89346a5a4d52c6c9$export$a7e6813e541a5ff8);
$parcel$export(module.exports, "UNDEFINED_GROUP", () => $89346a5a4d52c6c9$export$dcda7e10772ff7e8);
$parcel$export(module.exports, "UNASSIGNED_GROUP", () => $89346a5a4d52c6c9$export$36304411fc607ee8);
$parcel$export(module.exports, "getAncestorsOfIssue", () => $89346a5a4d52c6c9$export$1465021a0c4b5a3e);
$parcel$export(module.exports, "getGroupAttribute", () => $89346a5a4d52c6c9$export$66c297e813a21e25);
$parcel$export(module.exports, "getIssuesByGroup", () => $89346a5a4d52c6c9$export$97e315c357c4faa0);
$parcel$export(module.exports, "buildScope", () => $89346a5a4d52c6c9$export$cc6f39777f861b93);
$parcel$export(module.exports, "groupSortComparator", () => $89346a5a4d52c6c9$export$56c13c77705fe953);
$parcel$export(module.exports, "getIssuesWithOriginalsAndOptimized", () => $89346a5a4d52c6c9$export$2dc22532bb2facbd);
$parcel$export(module.exports, "getAllIssuesWithOriginalAndOptimized", () => $89346a5a4d52c6c9$export$5e57a775e538d605);
$parcel$export(module.exports, "getAllIssuesWithOriginalAndOptimizedById", () => $89346a5a4d52c6c9$export$10ba2fa27c7f7e0c);
$parcel$export(module.exports, "getIssuesByTeam", () => $89346a5a4d52c6c9$export$e10d3122e31e969c);
$parcel$export(module.exports, "getScope", () => $89346a5a4d52c6c9$export$5d887aaef2abf9e2);
$parcel$export(module.exports, "countVisibleIssues", () => $89346a5a4d52c6c9$export$190897ce30bb27ad);
$parcel$export(module.exports, "getSearchQuery", () => $89346a5a4d52c6c9$export$1664b92369554829);
$parcel$export(module.exports, "getActiveSearchResultIndex", () => $89346a5a4d52c6c9$export$e467ab9db30aa64c);
$parcel$export(module.exports, "splitString", () => $89346a5a4d52c6c9$export$d05bbe0328e41cc6);
$parcel$export(module.exports, "equalsIgnoreCase", () => $89346a5a4d52c6c9$export$d9ffdbc590df6d8a);
$parcel$export(module.exports, "searchForIssues", () => $89346a5a4d52c6c9$export$df7b5ec530ae24ca);
$parcel$export(module.exports, "getActiveSearchIssue", () => $89346a5a4d52c6c9$export$6ab3c2d73db706ef);
$parcel$export(module.exports, "getGroupCombinationByIssueId", () => $89346a5a4d52c6c9$export$269e836147dd799c);
$parcel$export(module.exports, "getGroupKey", () => (parcelRequire("dJx9o")).getGroupKey);

var $hkOxK = parcelRequire("hkOxK");
var $e1ur4 = parcelRequire("e1ur4");
var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $i0RGP = parcelRequire("i0RGP");
var $lqxEm = parcelRequire("lqxEm");
var $eirae = parcelRequire("eirae");
var $l0L3x = parcelRequire("l0L3x");
var $eN1iE = parcelRequire("eN1iE");
var $dspDs = parcelRequire("dspDs");
var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");
var $hQdGw = parcelRequire("hQdGw");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $lEZXx = parcelRequire("lEZXx");
var $3by2Y = parcelRequire("3by2Y");
var $kjklK = parcelRequire("kjklK");
var $79tFY = parcelRequire("79tFY");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");
var $812KE = parcelRequire("812KE");
var $ldYmX = parcelRequire("ldYmX");
var $l7xwn = parcelRequire("l7xwn");
var $cGOmv = parcelRequire("cGOmv");
var $701od = parcelRequire("701od");
var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");

var $dYnI4 = parcelRequire("dYnI4");

var $akhOi = parcelRequire("akhOi");

var $6VhAf = parcelRequire("6VhAf");

var $kKj1m = parcelRequire("kKj1m");

var $fbHoQ = parcelRequire("fbHoQ");

var $cwMfk = parcelRequire("cwMfk");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $cwP4d = parcelRequire("cwP4d");

var $7s3LJ = parcelRequire("7s3LJ");

var $KA559 = parcelRequire("KA559");

var $853IT = parcelRequire("853IT");

var $a4NMN = parcelRequire("a4NMN");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $dJx9o = parcelRequire("dJx9o");
const $89346a5a4d52c6c9$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
const $89346a5a4d52c6c9$export$8c797d2c6f8c1a2b = (state)=>(0, $9H2AP.getIssueExpansionsViewSettings)(state).isExpanded;
const $89346a5a4d52c6c9$export$d7ad569e206d3043 = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$1b132ed8629e9cb0
], (0, $a4NMN.getSprintByIdMapPure));
const $89346a5a4d52c6c9$export$136e69b79f9b3bc6 = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams),
    (0, $75KhQ.getIssueSources),
    $89346a5a4d52c6c9$export$1b132ed8629e9cb0
], (0, $a4NMN.getSprintsForTeamPure));
const $89346a5a4d52c6c9$export$9ac265cc37a57f7 = (issues, sort)=>sort(issues);
const $89346a5a4d52c6c9$export$9bdb9e03b1a7d7af = (0, $dYnI4.monitor).timeFunction($89346a5a4d52c6c9$export$9ac265cc37a57f7, 'query_scope_index_getSortedIssuesPure');
const $89346a5a4d52c6c9$export$a7e6813e541a5ff8 = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getFilteredIssuesWithHierarchy),
    (0, $7s3LJ.getSort)
], $89346a5a4d52c6c9$export$9bdb9e03b1a7d7af);
const $89346a5a4d52c6c9$export$1762232de55aae51 = (issues, originalIssues)=>issues.map((issue)=>$01zCq.default(issue, {
            originals: originalIssues[issue.id]
        }));
const $89346a5a4d52c6c9$export$dd8fe8767b0c9948 = (issue, groupAttribute, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode)=>{
    const group = isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized) && issue.optimized[groupAttribute] || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    issue[groupAttribute] || issue.customFields && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $ayXoc.isRoadmapGroupedByCustomField)(groupAttribute) && issue.customFields[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(groupAttribute)] || null;
    return group;
};
const $89346a5a4d52c6c9$var$getCustomFieldValues = (issue, valueAttribute)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ((0, $ayXoc.isRoadmapGroupedByCustomField)(valueAttribute)) {
        const values = issue.customFields && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issue.customFields[(0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(valueAttribute)];
        return values?.map((value)=>Number.isNaN(parseInt(value, 10)) ? value : parseInt(value, 10));
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issue[valueAttribute];
};
const $89346a5a4d52c6c9$export$6d6bd5139b41ba0d = (issue, groups, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode, valueAttribute)=>{
    const values = isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized) && issue.optimized[valueAttribute] || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    issue[valueAttribute] || $89346a5a4d52c6c9$var$getCustomFieldValues(issue, valueAttribute);
    // If issue does not have values.
    if (!(0, $7CnHa.isDefined)(values)) return [
        (0, $bb09f71c7817719d$export$526fec6b76d5bc5)
    ];
    /** Set is used as a data structure. This is important because an issue can have multiple components/labels.
	 * And all components/labels can be part of one group. groupsWhereIssueValuesBelong can have
	 * same group multiple times if different components/labels belong to the same group. Hence set is used.
	 * It will add the group only once.
	 */ const groupsWhereIssueValuesBelong = new Set();
    values.forEach((value)=>groups.filter((group)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            group[valueAttribute].includes(value)).forEach((group)=>groupsWhereIssueValuesBelong.add(group)));
    // If issue has components/labels, but they are not part any component group.
    if (groupsWhereIssueValuesBelong.size === 0) return [
        (0, $bb09f71c7817719d$export$526fec6b76d5bc5)
    ];
    return [
        ...groupsWhereIssueValuesBelong
    ].map(({ id: id })=>id);
};
const $89346a5a4d52c6c9$export$dcda7e10772ff7e8 = (0, $5rYNM.UNDEFINED_KEY);
const $89346a5a4d52c6c9$export$36304411fc607ee8 = 'unassigned';
const $89346a5a4d52c6c9$export$1465021a0c4b5a3e = (issue, issuesById)=>{
    const ancestors = [];
    const ancestorsIds = [];
    let parent = issuesById[issue.parent || ''];
    while(parent){
        if (ancestorsIds.includes(parent.id)) break;
        ancestorsIds.push(parent.id);
        ancestors.push(parent);
        parent = issuesById[parent.parent || ''];
    }
    return ancestors;
};
const $89346a5a4d52c6c9$export$66c297e813a21e25 = (group)=>{
    if ((0, $ayXoc.isRoadmapGroupedByCustomField)(group)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return group;
    switch(group){
        case (0, $5rYNM.GROUPING).ASSIGNEE:
            return 'assignee';
        case (0, $5rYNM.GROUPING).REPORTER:
            return 'reporter';
        case (0, $5rYNM.GROUPING).COMPONENT:
            return 'components';
        case (0, $5rYNM.GROUPING).LABEL:
            return 'labels';
        case (0, $5rYNM.GROUPING).PROJECT:
            return 'project';
        case (0, $5rYNM.GROUPING).RELEASE:
            return 'release';
        case (0, $5rYNM.GROUPING).SPRINT:
            return 'sprint';
        case (0, $5rYNM.GROUPING).TEAM:
            return 'team';
        case (0, $5rYNM.GROUPING).GOALS:
            return 'goals';
        case (0, $5rYNM.GROUPING).IDEAS:
            return 'ideas';
        default:
            throw new Error(`Grouping by ${group} is not supported yet.`);
    }
};
const $89346a5a4d52c6c9$export$8f96112d7c990471 = (group, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode, issue, issuesByGroup, issuesById, isAncestorGroupMatchCustom)=>{
    (0, $dJx9o.addIssueToGroup)(issuesByGroup, issue, group);
    // Here we may add issues that we have already skipped (as it did not fit into a group), but we add them as they are the parent of the issue we have just added.
    // Thus we can't preserve the initial sorting of the issues.
    $89346a5a4d52c6c9$export$1465021a0c4b5a3e(issue, issuesById).forEach((ancestor)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const isAncestorGroupMatch = Object.keys(group).every((groupAttr)=>(0, $7CnHa.isDefined)(isAncestorGroupMatchCustom) ? isAncestorGroupMatchCustom(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            group[groupAttr], ancestor, isOptimizedMode) : group[groupAttr] === $89346a5a4d52c6c9$export$dd8fe8767b0c9948(ancestor, groupAttr, isOptimizedMode));
        if (!isAncestorGroupMatch) // NOTE: Intentionally adding ancestor to original issue group (we want the ancestor to appear for the group)
        (0, $dJx9o.addIssueToGroup)(issuesByGroup, ancestor, group);
    });
};
const $89346a5a4d52c6c9$export$95faac342fd66174 = (issues, issuesById, grouping = (0, $5rYNM.GROUPING).NONE, componentGroups, labelGroups, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, versionsById, customFieldValuesGroups = [], // eslint-disable-next-line @typescript-eslint/no-shadow
isGroupByMultiValueCustomField = false)=>{
    const issuesByGroup = {};
    const groupAttribute = grouping !== (0, $5rYNM.GROUPING).NONE ? $89346a5a4d52c6c9$export$66c297e813a21e25(grouping) : '';
    switch(grouping){
        case (0, $5rYNM.GROUPING).COMPONENT:
            issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$6d6bd5139b41ba0d(issue, componentGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471({
                        [`${groupAttribute}`]: group
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            break;
        case (0, $5rYNM.GROUPING).LABEL:
            issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$6d6bd5139b41ba0d(issue, labelGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471({
                        [`${groupAttribute}`]: group
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            break;
        case (0, $5rYNM.GROUPING).GOALS:
            issues.forEach((issue)=>{
                const goals = !issue.goals?.length ? [
                    $89346a5a4d52c6c9$export$dcda7e10772ff7e8
                ] : issue.goals;
                goals.forEach((goal)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471({
                        [`${groupAttribute}`]: goal
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            break;
        case (0, $5rYNM.GROUPING).RELEASE:
            issues.forEach((issue)=>{
                (0, $dJx9o.getReleasesGroups)(issue, isOptimizedMode, versionsById).forEach((group)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471(group, isOptimizedMode, issue, issuesByGroup, issuesById, // eslint-disable-next-line @typescript-eslint/no-shadow
                    (groupAttrValue, ancestor, isOptimizedMode)=>{
                        const fixVersions = $89346a5a4d52c6c9$export$dd8fe8767b0c9948(ancestor, 'fixVersions', isOptimizedMode) || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        [];
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        return fixVersions.includes(groupAttrValue);
                    });
                });
            });
            break;
        case (0, $5rYNM.GROUPING).SPRINT:
            issues.forEach((issue)=>{
                (0, $dJx9o.getTeamsBySprintGroups)(issue, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById).forEach((group)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471(group, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            break;
        case (0, $5rYNM.GROUPING).TEAM:
            issues.forEach((issue)=>{
                if (issue.level === (0, $8YqJS.SUB_TASK_LEVEL)) {
                    const parentId = issue.parent;
                    if ((0, $7CnHa.isDefined)(parentId)) {
                        const parentIssue = issuesById[parentId];
                        if (parentIssue) (0, $dJx9o.addIssueToGroup)(issuesByGroup, issue, {
                            [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(parentIssue, groupAttribute, isOptimizedMode)
                        });
                    } else // Fot sub-task's whose parent don't be included in the plan also needed to be listed
                    (0, $dJx9o.addIssueToGroup)(issuesByGroup, issue, {
                        [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                    });
                } else $89346a5a4d52c6c9$export$8f96112d7c990471({
                    [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                }, isOptimizedMode, issue, issuesByGroup, issuesById);
            });
            break;
        case (0, $ayXoc.isRoadmapGroupedByCustomField)(grouping) && grouping:
            if (isGroupByMultiValueCustomField) issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$6d6bd5139b41ba0d(issue, customFieldValuesGroups, isOptimizedMode, groupAttribute).forEach((group)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471({
                        [`${groupAttribute}`]: group
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            else issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$8f96112d7c990471({
                    [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                }, isOptimizedMode, issue, issuesByGroup, issuesById);
            });
            break;
        case (0, $5rYNM.GROUPING).IDEAS:
            if ((0, $1ybV0.ff)('polaris-arj-ideas')) issues.forEach((issue)=>{
                const ideaIds = !issue.associatedIssueIds?.length ? [
                    $89346a5a4d52c6c9$export$dcda7e10772ff7e8
                ] : issue.associatedIssueIds;
                ideaIds.forEach((ideaId)=>{
                    $89346a5a4d52c6c9$export$8f96112d7c990471({
                        [`${groupAttribute}`]: ideaId
                    }, isOptimizedMode, issue, issuesByGroup, issuesById);
                });
            });
            else issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$8f96112d7c990471({
                    [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                }, isOptimizedMode, issue, issuesByGroup, issuesById);
            });
            break;
        // grouping by "Assignee", "Project"
        default:
            issues.forEach((issue)=>{
                $89346a5a4d52c6c9$export$8f96112d7c990471({
                    [`${groupAttribute}`]: $89346a5a4d52c6c9$export$dd8fe8767b0c9948(issue, groupAttribute, isOptimizedMode)
                }, isOptimizedMode, issue, issuesByGroup, issuesById);
            });
            break;
    }
    return issuesByGroup;
};
const $89346a5a4d52c6c9$export$fbb72383d7fe83f = (issues, grouping = (0, $5rYNM.GROUPING).NONE, componentGroups, labelGroups, // eslint-disable-next-line @typescript-eslint/no-shadow
isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, versionsById, customFieldValuesGroups = [], // eslint-disable-next-line @typescript-eslint/no-shadow
isGroupByMultiValueCustomField = false)=>{
    const issuesById = (0, $7CnHa.indexBy)(({ id: id })=>id, issues);
    return $89346a5a4d52c6c9$export$95faac342fd66174(issues, issuesById, grouping, componentGroups, labelGroups, isOptimizedMode, sprintsByIdMap, sprintsForTeam, teamsById, versionsById, customFieldValuesGroups, isGroupByMultiValueCustomField);
};
const $89346a5a4d52c6c9$export$97e315c357c4faa0 = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getFilteredIssuesWithHierarchy),
    (0, $cwP4d.getIssueMapById),
    (0, $kyGCj.getVisualisationGrouping),
    (0, $9H2AP.getComponentGroupsViewSettings),
    (0, $9H2AP.getLabelsGroupViewSettings),
    (0, $akhOi.isOptimizedMode),
    $89346a5a4d52c6c9$export$d7ad569e206d3043,
    $89346a5a4d52c6c9$export$136e69b79f9b3bc6,
    (0, $MQRDu.getAllTeamsById),
    (0, $wcCGG.getVersionsById),
    (0, $kyGCj.getCustomFieldValuesGroups),
    (0, $kyGCj.isGroupByMultiValueCustomField)
], $89346a5a4d52c6c9$export$95faac342fd66174);
const $89346a5a4d52c6c9$export$2d0a064b4b76d506 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues),
    (0, $cwP4d.getIssueMapById),
    (0, $kyGCj.getVisualisationGrouping),
    (0, $9H2AP.getComponentGroupsViewSettings),
    (0, $9H2AP.getLabelsGroupViewSettings),
    (0, $akhOi.isOptimizedMode),
    $89346a5a4d52c6c9$export$d7ad569e206d3043,
    $89346a5a4d52c6c9$export$136e69b79f9b3bc6,
    (0, $MQRDu.getAllTeamsById),
    (0, $wcCGG.getVersionsById),
    (0, $kyGCj.getCustomFieldValuesGroups),
    (0, $kyGCj.isGroupByMultiValueCustomField)
], $89346a5a4d52c6c9$export$95faac342fd66174);
const $89346a5a4d52c6c9$export$cc6f39777f861b93 = (issues, issuesByParent, issuesById, isExpanded, start, end, group, groupCombination, issuesInGroup, ignoreExpandingState)=>{
    const rootIssues = issues.filter(({ level: level })=>level === start);
    let issuesInGroupMap;
    if (issuesInGroup) issuesInGroupMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), issuesInGroup);
    const startLevelIssues = {
        rootIssuesCount: rootIssues.length,
        issues: (0, $dJx9o.getIssuesHierarchy)({
            issues: rootIssues,
            issuesByParent: issuesByParent,
            isExpanded: isExpanded,
            group: group,
            groupCombination: groupCombination,
            issuesInGroupMap: issuesInGroupMap,
            ignoreExpandingState: ignoreExpandingState
        }),
        level: start
    };
    const issuesWithoutParent = issues.filter(({ level: level, parent: parent })=>level < start && !(parent && issuesById[parent]));
    const issuesWithoutParentByLevel = (0, $7CnHa.groupBy)(({ level: level })=>level, issuesWithoutParent);
    const issuesWithoutParentFlattenForest = [];
    const headerIdSuffix = groupCombination ? `:${(0, $dJx9o.getGroupKey)(groupCombination)}` : '';
    const headerId = `IssuesWithoutParentHeader${headerIdSuffix}`;
    for (const level of $812KE.default(end, start).reverse()){
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const rootIssues = issuesWithoutParentByLevel[level];
        const idSuffix = groupCombination ? `:${(0, $dJx9o.getGroupKey)(groupCombination)}` : '';
        const id = `IssuesWithoutParent-${level}${idSuffix}`;
        if (rootIssues) issuesWithoutParentFlattenForest.push({
            id: id,
            isExpanded: isExpanded[id],
            issues: (0, $dJx9o.getIssuesHierarchy)({
                issues: rootIssues,
                issuesByParent: issuesByParent,
                isExpanded: isExpanded,
                group: group,
                groupCombination: groupCombination,
                issuesInGroupMap: issuesInGroupMap,
                ignoreExpandingState: ignoreExpandingState
            }),
            level: level,
            rootIssuesCount: rootIssues.length
        });
        else issuesWithoutParentFlattenForest.push({
            id: id,
            isExpanded: isExpanded[id],
            issues: [],
            level: level,
            rootIssuesCount: 0
        });
    }
    return {
        startLevelIssues: startLevelIssues,
        issuesWithoutParent: issuesWithoutParentFlattenForest,
        issuesWithoutParentHeaderData: {
            id: headerId,
            isExpanded: isExpanded[headerId]
        }
    };
};
const $89346a5a4d52c6c9$export$a06a68c30cc52c94 = '';
const $89346a5a4d52c6c9$var$getExpandedGroups = (state)=>(0, $9H2AP.getVisualisationViewSettings)(state).expandedItems;
const $89346a5a4d52c6c9$export$c3687f28f0f07b51 = (grouping, groupName, expandedState)=>expandedState?.[grouping]?.[groupName];
const $89346a5a4d52c6c9$export$213ef3bd851839cf = (componentGroups = [], labelGroups = [], teamsById = {}, projects = [], assignees = [], reporters = [], sprintsByIdMap = {}, grouping = (0, $5rYNM.GROUPING).TEAM, groupId, versionsById)=>{
    // Project id is a number. We have to convert it to string for all other types.
    // in case GROUPING.PROJECT we are using parseInt method which converts it back to number
    const group = groupId && groupId.toString();
    if (!group || group === $89346a5a4d52c6c9$export$dcda7e10772ff7e8) return {
        name: $89346a5a4d52c6c9$export$a06a68c30cc52c94,
        grouping: grouping,
        group: $89346a5a4d52c6c9$export$dcda7e10772ff7e8
    };
    switch(grouping){
        case (0, $5rYNM.GROUPING).COMPONENT:
            {
                const componentGroup = componentGroups.find(({ id: id })=>id === group);
                const groupName = (0, $7CnHa.isDefined)(componentGroup) && componentGroup.name || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: groupName,
                    group: group,
                    grouping: grouping
                };
            }
        case (0, $5rYNM.GROUPING).LABEL:
            {
                const labelGroup = labelGroups.find(({ id: id })=>id === group);
                const groupName = (0, $7CnHa.isDefined)(labelGroup) && labelGroup.name || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: groupName,
                    group: group,
                    grouping: grouping
                };
            }
        case (0, $5rYNM.GROUPING).TEAM:
            {
                const team = teamsById[group];
                const teamName = (0, $7CnHa.isDefined)(team) && team.title || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: teamName,
                    group: group,
                    grouping: grouping,
                    url: team && team.avatarUrl
                };
            }
        case (0, $5rYNM.GROUPING).ASSIGNEE:
            {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const assignee = assignees.find((assignee)=>assignee.jiraUser.accountId === group);
                const assigneeName = (0, $7CnHa.isDefined)(assignee) && assignee.jiraUser.title || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: assigneeName,
                    group: group,
                    grouping: grouping,
                    url: assignee && assignee.jiraUser.avatarUrl
                };
            }
        case (0, $5rYNM.GROUPING).REPORTER:
            {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const reporter = reporters.find((reporter)=>reporter.jiraUser.accountId === group);
                const reporterName = (0, $7CnHa.isDefined)(reporter) && reporter.jiraUser.title || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: reporterName,
                    group: group,
                    grouping: grouping,
                    url: reporter && reporter.jiraUser.avatarUrl
                };
            }
        case (0, $5rYNM.GROUPING).PROJECT:
            {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const project = projects.find((project)=>project.id === parseInt(group, 10));
                const projectName = (0, $7CnHa.isDefined)(project) && project.name || $89346a5a4d52c6c9$export$a06a68c30cc52c94;
                return {
                    name: projectName,
                    group: group,
                    grouping: grouping,
                    url: project && project.avatarUrl
                };
            }
        case (0, $5rYNM.GROUPING).SPRINT:
            return {
                name: sprintsByIdMap[group].title || $89346a5a4d52c6c9$export$a06a68c30cc52c94,
                group: group,
                grouping: grouping
            };
        case (0, $5rYNM.GROUPING).RELEASE:
            {
                const release = versionsById[group];
                return {
                    name: release ? release.name : $89346a5a4d52c6c9$export$a06a68c30cc52c94,
                    group: group,
                    grouping: grouping
                };
            }
        case (0, $5rYNM.GROUPING).GOALS:
            return {
                name: group,
                group: group,
                grouping: grouping
            };
        case (0, $5rYNM.GROUPING).IDEAS:
            return {
                name: group,
                group: group,
                grouping: grouping
            };
        default:
            return {
                name: $89346a5a4d52c6c9$export$a06a68c30cc52c94,
                grouping: grouping,
                group: group
            };
    }
};
const $89346a5a4d52c6c9$export$56c13c77705fe953 = (group1, group2)=>{
    // This is a very primitive sort comparator but should be sufficient for our needs
    if (group1.groupName === '') return 1;
    if (group2.groupName === '') return -1;
    const g1 = group1.groupName.toLowerCase();
    const g2 = group2.groupName.toLowerCase();
    // put unassigned groups in the end of array
    if (g2 === $89346a5a4d52c6c9$export$36304411fc607ee8) return -1;
    if (g1 === $89346a5a4d52c6c9$export$36304411fc607ee8) return 1;
    if (g1 === g2) return 0;
    return g1 > g2 ? 1 : -1;
};
const $89346a5a4d52c6c9$export$c70054835d4cf76 = (sprintsWithFutureDates, groupCombination = {})=>{
    const { team: team, sprint: sprint } = groupCombination;
    const findSprint = (arr)=>arr && $i0RGP.default($h3f0m.default('id', sprint), arr);
    return team ? findSprint(sprintsWithFutureDates.team[team]) : (0, $7CnHa.isDefined)(sprint) && findSprint(sprintsWithFutureDates.sprint[sprint]);
};
const $89346a5a4d52c6c9$export$25033657b811db0f = (teamsByIdMap = {}, sprintsWithFutureDates = {
    team: {},
    sprint: {}
})=>({ groupCombination: groupCombination1 }, { groupCombination: groupCombination2 })=>{
        if (!groupCombination2) return -1;
        if (!groupCombination1) return 1;
        const sprint1 = $89346a5a4d52c6c9$export$c70054835d4cf76(sprintsWithFutureDates, groupCombination1);
        const sprint2 = $89346a5a4d52c6c9$export$c70054835d4cf76(sprintsWithFutureDates, groupCombination2);
        if (!sprint1) return 1;
        if (!sprint2) return -1;
        let g1;
        let g2;
        const team1 = groupCombination1.team && teamsByIdMap[groupCombination1.team];
        const team2 = groupCombination2.team && teamsByIdMap[groupCombination2.team];
        if (sprint1.startDate === sprint2.startDate) {
            // sort by team
            g1 = team1 && team1.title.toLowerCase();
            g2 = team2 && team2.title.toLowerCase();
            if (team1 && team2 && g1 === g2) {
                // sort by sprint title
                g1 = sprint1.title.toLowerCase();
                g2 = sprint2.title.toLowerCase();
            }
        } else {
            // sort by start date
            g1 = sprint1.startDate;
            g2 = sprint2.startDate;
        }
        // put unassigned groups in the end
        if ($kDrtX.default(g1)) return 1;
        if ($kDrtX.default(g2)) return -1;
        if (g1 === g2) return 0;
        return g1 > g2 ? 1 : -1;
    };
const $89346a5a4d52c6c9$export$39d3423359f09c19 = (versionsById)=>({ groupCombination: groupCombination1 }, { groupCombination: groupCombination2 })=>{
        if (!groupCombination2) return -1;
        if (!groupCombination1) return 1;
        const release1 = (0, $7CnHa.isDefined)(groupCombination1.release) && versionsById[groupCombination1.release];
        const release2 = (0, $7CnHa.isDefined)(groupCombination2.release) && versionsById[groupCombination2.release];
        if (!release1) return 1;
        if (!release2) return -1;
        // sort by start date
        const g1 = release1.end;
        const g2 = release2.end;
        // put unassigned groups in the end
        if ($kDrtX.default(g1)) return 1;
        if ($kDrtX.default(g2)) return -1;
        if (g1 === g2) return 0;
        return g1 > g2 ? 1 : -1;
    };
const $89346a5a4d52c6c9$export$2411a98ccc307764 = (groups, grouping, teamsById, versionsById = {}, sprintsWithFutureDates)=>{
    if (grouping === (0, $5rYNM.GROUPING).SPRINT) // Completed sprints should come first and be sorted separately
    return $3IGDG.default($3by2Y.default($79tFY.default([
        'parentGroup'
    ], (0, $5rYNM.COMPLETED_SPRINTS_GROUP))), $cQGVO.default($l7xwn.default($89346a5a4d52c6c9$export$25033657b811db0f(teamsById, sprintsWithFutureDates))), $ldYmX.default($e1ur4.default, []))(groups);
    if (grouping === (0, $5rYNM.GROUPING).RELEASE) // Completed releases should come first and be sorted separately
    return $3IGDG.default($3by2Y.default($79tFY.default([
        'parentGroup'
    ], (0, $5rYNM.COMPLETED_RELEASES_GROUP))), $cQGVO.default($l7xwn.default($89346a5a4d52c6c9$export$39d3423359f09c19(versionsById))), $ldYmX.default($e1ur4.default, []))(groups);
    return groups.sort($89346a5a4d52c6c9$export$56c13c77705fe953);
};
const $89346a5a4d52c6c9$export$9c28870bc535869b = (grouping, group, filters, issues)=>{
    if (!group) return true;
    switch(grouping){
        case (0, $5rYNM.GROUPING).ASSIGNEE:
            {
                const filteredAssignees = filters[0, $12ee831723ccf9c2$export$43596ee088b165a].value;
                return filteredAssignees.length === 0 || filteredAssignees.some((assignee)=>assignee === group);
            }
        case (0, $5rYNM.GROUPING).REPORTER:
            {
                const filteredReporters = filters[0, $12ee831723ccf9c2$export$20140793a0aa2b3c].value;
                return filteredReporters.length === 0 || filteredReporters.some((reporter)=>reporter === group);
            }
        case (0, $5rYNM.GROUPING).COMPONENT:
            {
                const filteredComponents = filters[0, $12ee831723ccf9c2$export$6022538efc28a609].value;
                if (filteredComponents.length === 0) return true;
                // the group should not be filtered out if there is at least one issue
                // that has at least one component matching one of the filtered components
                return issues.some((issue)=>issue.components && !$b3iuB.default(issue.components) && $dspDs.default(issue.components, filteredComponents).length > 0);
            }
        case (0, $5rYNM.GROUPING).LABEL:
            {
                const filteredLabels = filters[0, $12ee831723ccf9c2$export$7e257b719377371e].value;
                if (filteredLabels.length === 0) return true;
                // the group should not be filtered out if there is at least one issue
                // that has at least one label matching one of the filtered labels
                // if the "No label" value is one of the filtered labels
                if (filteredLabels.includes($89346a5a4d52c6c9$export$dcda7e10772ff7e8)) // then we check first if the issue labels is an empty array (to return earlier) before
                // looking for common labels in issue labels and filteredLabels
                return issues.some((issue)=>issue.labels && ($b3iuB.default(issue.labels) || $dspDs.default(issue.labels, filteredLabels).length > 0));
                // if the "No label" value is not one of the filtered labels
                // then we only look for common labels in issue labels and filteredLabels if issue labels are not empty
                return issues.some((issue)=>issue.labels && !$b3iuB.default(issue.labels) && $dspDs.default(issue.labels, filteredLabels).length > 0);
            }
        case (0, $5rYNM.GROUPING).PROJECT:
            {
                const filteredProjects = filters[0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8].value;
                return filteredProjects.length === 0 || filteredProjects.some((project)=>project.toString() === group.toString());
            }
        case (0, $5rYNM.GROUPING).RELEASE:
            {
                const { value: filteredReleases, versionsFromCrossProjectReleaseFilterValue: filteredCPReleases = [] } = filters[0, $12ee831723ccf9c2$export$53e2f8996e102881];
                return (filteredReleases.length === 0 || filteredReleases.some((project)=>project.toString() === group)) && (filteredCPReleases.length === 0 || filteredCPReleases.some((project)=>project.toString() === group));
            }
        case (0, $5rYNM.GROUPING).SPRINT:
            {
                const filteredSprints = filters[0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb].value;
                return filteredSprints.length === 0 || filteredSprints.some((sprint)=>sprint === group);
            }
        case (0, $5rYNM.GROUPING).TEAM:
            {
                const filteredTeams = filters[0, $12ee831723ccf9c2$export$8abe69ceb26771cd].value;
                return filteredTeams.length === 0 || filteredTeams.some((team)=>team === group);
            }
        default:
            return true;
    }
};
const $89346a5a4d52c6c9$export$896f0b9c47e9ce0b = (issues, isExpanded, filters, sort, inlineCreateState, { isAtlasConnectInstalled: // eslint-disable-next-line @typescript-eslint/no-shadow
isAtlasConnectInstalled, grouping: grouping = (0, $5rYNM.GROUPING).NONE }, issuesByGroupArg = {}, teamsById = {}, groupDetailsMap, expandedGroups, sprintsWithFutureDates, versionsById = {})=>{
    const { [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: { value: { start: start, end: end } } } = filters;
    const issuesById = (0, $7CnHa.indexBy)(({ id: id })=>id, issues);
    const issuesByParent = (0, $7CnHa.groupBy)(({ parent: parent })=>parent || 'Flow cannot get filter meaning', issues.filter(({ parent: parent })=>parent));
    let groups = [];
    let groupCount = 0;
    const getGroupDetailsFromMap = (id)=>{
        const unknownDetails = {
            name: $89346a5a4d52c6c9$export$a06a68c30cc52c94,
            grouping: grouping,
            group: $89346a5a4d52c6c9$export$dcda7e10772ff7e8
        };
        if (id) return groupDetailsMap?.[id] ?? unknownDetails;
        return unknownDetails;
    };
    if (grouping !== (0, $5rYNM.GROUPING).NONE && !(grouping === (0, $5rYNM.GROUPING).GOALS && !isAtlasConnectInstalled)) {
        const issuesByGroup = issuesByGroupArg;
        const groupAttribute = $89346a5a4d52c6c9$export$66c297e813a21e25(grouping);
        for (const [groupMapKey, group] of Object.entries(issuesByGroup))if ($89346a5a4d52c6c9$export$9c28870bc535869b(grouping, group[groupAttribute], filters, group.issues ? Array.from(group.issues) : [])) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { issues: issues, parentGroup: parentGroup, ...groupCombination } = group;
            const groupKey = groupMapKey;
            // Fix sorting after it was messed by getIssuesByGroup.
            const issuesInGroup = issues ? $89346a5a4d52c6c9$export$9bdb9e03b1a7d7af(Array.from(issues), sort) : [];
            groupCount++;
            const { name: name, url: url } = getGroupDetailsFromMap(groupKey);
            const groupExpanded = $89346a5a4d52c6c9$export$c3687f28f0f07b51(grouping, groupKey, expandedGroups);
            const scope = $89346a5a4d52c6c9$export$cc6f39777f861b93(issuesInGroup, issuesByParent, issuesById, isExpanded, start, end, groupKey, groupCombination, issuesInGroup, true);
            let isParentGroupExpanded;
            if (parentGroup) isParentGroupExpanded = $89346a5a4d52c6c9$export$c3687f28f0f07b51(grouping, parentGroup, expandedGroups);
            groups.push({
                groupName: name,
                grouping: grouping,
                groupUrl: url,
                scope: scope,
                isExpanded: groupExpanded,
                group: groupKey,
                groupCombination: groupCombination,
                ...(0, $7CnHa.isDefined)(parentGroup) ? {
                    parentGroup: parentGroup,
                    isParentGroupExpanded: isParentGroupExpanded
                } : {}
            });
        }
        // add new group to scope when user tries to global create in grouping view
        const { groupCombination: groupCombination, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup } = inlineCreateState;
        if (startInlineCreateInEmptyGroup && groupCombination) {
            const groupKey = (0, $dJx9o.getGroupKey)(groupCombination);
            const { name: name, url: url } = getGroupDetailsFromMap(groupCombination[groupAttribute]);
            const groupExpanded = $89346a5a4d52c6c9$export$c3687f28f0f07b51(grouping, groupKey, expandedGroups);
            const scope = $89346a5a4d52c6c9$export$cc6f39777f861b93([], issuesByParent, issuesById, isExpanded, start, end, groupKey, groupCombination, []);
            groups.push({
                groupName: name,
                grouping: grouping,
                groupUrl: url,
                scope: scope,
                isExpanded: groupExpanded,
                group: groupKey,
                groupCombination: groupCombination
            });
            groupCount++;
        }
        groups = $89346a5a4d52c6c9$export$2411a98ccc307764(groups, grouping, teamsById, versionsById, sprintsWithFutureDates);
        // Create a dummy scope in order to support table rendering, this is done to avoid the necessity of building
        // a full scope for all issues. The data is not required when rendering issues in groups
        const scope = {
            startLevelIssues: {
                level: start,
                issues: [],
                rootIssuesCount: 0
            },
            issuesWithoutParent: [],
            issuesWithoutParentHeaderData: {
                id: 'itemsWithoutParentsHeader',
                isExpanded: true
            }
        };
        return {
            groupCount: groupCount,
            groups: groups,
            ...scope
        };
    }
    const scope = $89346a5a4d52c6c9$export$cc6f39777f861b93(issues, issuesByParent, issuesById, isExpanded, start, end, undefined, undefined, undefined, true);
    // Top level scope added as a group as well for use by search
    groups.push({
        groupName: $89346a5a4d52c6c9$export$dcda7e10772ff7e8,
        grouping: (0, $5rYNM.GROUPING).NONE,
        group: $89346a5a4d52c6c9$export$dcda7e10772ff7e8,
        scope: scope
    });
    return {
        groupCount: groupCount,
        groups: groups,
        ...scope
    };
};
const $89346a5a4d52c6c9$export$611c3bba6a5df07a = (fullScope)=>{
    const visibleFilter = (scopeIssue)=>!!scopeIssue.parentsExpanded;
    const issuesWithoutParentMap = (scopeIssues)=>({
            ...scopeIssues,
            issues: scopeIssues.issues.filter(visibleFilter)
        });
    return {
        startLevelIssues: {
            ...fullScope.startLevelIssues,
            issues: fullScope.startLevelIssues.issues.filter(visibleFilter)
        },
        issuesWithoutParent: fullScope.issuesWithoutParent.map(issuesWithoutParentMap),
        issuesWithoutParentHeaderData: {
            ...fullScope.issuesWithoutParentHeaderData
        },
        extraIssues: fullScope.extraIssues ? fullScope.extraIssues.filter(visibleFilter) : undefined,
        groupCount: fullScope.groupCount,
        groups: fullScope.groups ? fullScope.groups// Filter out none grouping created by full scope
        .filter((group)=>group.grouping !== (0, $5rYNM.GROUPING).NONE).map((group)=>group.isExpanded ? {
                ...group,
                scope: {
                    startLevelIssues: {
                        ...group.scope.startLevelIssues,
                        issues: group.scope.startLevelIssues.issues.filter(visibleFilter)
                    },
                    issuesWithoutParent: group.scope.issuesWithoutParent.map(issuesWithoutParentMap),
                    issuesWithoutParentHeaderData: {
                        ...group.scope.issuesWithoutParentHeaderData
                    },
                    extraIssues: group.scope.extraIssues ? group.scope.extraIssues.filter(visibleFilter) : undefined
                }
            } : {
                ...group,
                scope: {
                    startLevelIssues: {
                        ...group.scope.startLevelIssues,
                        issues: [],
                        rootIssuesCount: 0
                    },
                    issuesWithoutParent: group.scope.issuesWithoutParent.map((scopeIssues)=>({
                            ...scopeIssues,
                            issues: [],
                            rootIssuesCount: 0
                        })),
                    issuesWithoutParentHeaderData: {
                        ...group.scope.issuesWithoutParentHeaderData
                    },
                    extraIssues: []
                }
            }) : undefined
    };
};
const $89346a5a4d52c6c9$export$2dc22532bb2facbd = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$a7e6813e541a5ff8,
    (0, $kwMvv.getOriginalIssues)
], $89346a5a4d52c6c9$export$1762232de55aae51);
const $89346a5a4d52c6c9$export$5e57a775e538d605 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    (0, $kwMvv.getOriginalIssues)
], $89346a5a4d52c6c9$export$1762232de55aae51);
const $89346a5a4d52c6c9$export$10ba2fa27c7f7e0c = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$5e57a775e538d605
], (allIssuesWithOriginalAndOptimized)=>$eN1iE.default($f7Op5.default('id'), allIssuesWithOriginalAndOptimized));
const $89346a5a4d52c6c9$var$getIssuesWithOriginalsAndOptimizedByGroup = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$2dc22532bb2facbd,
    (0, $kyGCj.getVisualisationGrouping),
    (0, $9H2AP.getComponentGroupsViewSettings),
    (0, $9H2AP.getLabelsGroupViewSettings),
    (0, $akhOi.isOptimizedMode),
    $89346a5a4d52c6c9$export$d7ad569e206d3043,
    $89346a5a4d52c6c9$export$136e69b79f9b3bc6,
    (0, $MQRDu.getAllTeamsById),
    (0, $wcCGG.getVersionsById),
    (0, $kyGCj.getCustomFieldValuesGroups),
    (0, $kyGCj.isGroupByMultiValueCustomField)
], $89346a5a4d52c6c9$export$fbb72383d7fe83f);
const $89346a5a4d52c6c9$export$e10d3122e31e969c = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$2dc22532bb2facbd,
    (0, $akhOi.isOptimizedMode)
], (issues, isOptimized)=>$eirae.default((issue)=>{
        const team = isOptimized ? $kjklK.default([
            'optimized',
            'team'
        ], issue) : issue.team;
        return team || '';
    }, issues));
const $89346a5a4d52c6c9$export$f37748fb501e94bc = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getLabelsGroupViewSettings),
    (0, $9H2AP.getComponentGroupsViewSettings)
], (labelGroups, componentGroups)=>({
        labelGroups: labelGroups,
        componentGroups: componentGroups
    }));
const $89346a5a4d52c6c9$export$90e66d86e8725e1d = (issuesByGroup, grouping, labelAndComponentGroups = {}, teamsById = {}, sprintsByIdMap = {}, versionsById = {}, groupByCustomFieldDetailsMap, projects, assignees, reporters)=>{
    if (Object.keys(groupByCustomFieldDetailsMap).length > 0) return groupByCustomFieldDetailsMap;
    const groupDetails = {};
    if (grouping !== (0, $5rYNM.GROUPING).NONE) for (const [groupKey, group] of Object.entries(issuesByGroup)){
        const groupAttribute = $89346a5a4d52c6c9$export$66c297e813a21e25(grouping);
        if (groupKey) {
            const details = $89346a5a4d52c6c9$export$213ef3bd851839cf(labelAndComponentGroups?.componentGroups ?? [], labelAndComponentGroups?.labelGroups ?? [], teamsById, projects ?? [], assignees ?? [], reporters ?? [], sprintsByIdMap, grouping, group[groupAttribute], versionsById);
            groupDetails[groupKey] = details;
        }
    }
    return groupDetails;
};
const $89346a5a4d52c6c9$var$getGroupDetailsMapForCustomField = (groupId, grouping, // eslint-disable-next-line @typescript-eslint/no-shadow
isGroupByMultiValueCustomField, customFieldValuesGroups, customFieldsById, userPickerOptionsById, selectOptionsById)=>{
    const group = groupId;
    if (!group || group === $89346a5a4d52c6c9$export$dcda7e10772ff7e8) return {
        name: $89346a5a4d52c6c9$export$a06a68c30cc52c94,
        grouping: grouping,
        group: $89346a5a4d52c6c9$export$dcda7e10772ff7e8
    };
    if (isGroupByMultiValueCustomField) {
        const customFieldValuesGroup = customFieldValuesGroups.find(({ id: id })=>id === group);
        return {
            name: customFieldValuesGroup?.name || $89346a5a4d52c6c9$export$a06a68c30cc52c94,
            group: group,
            grouping: grouping
        };
    }
    const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
    const customField = customFieldsById[fieldId];
    if (customField) {
        if (customField.type.key === (0, $5rYNM.CustomFieldTypes).UserPicker) {
            const option = userPickerOptionsById[group];
            return {
                name: option ? option.label : $89346a5a4d52c6c9$export$a06a68c30cc52c94,
                group: group,
                grouping: grouping,
                url: option ? option.icon : ''
            };
        }
        const option = selectOptionsById[group];
        return {
            name: option ? option.value : $89346a5a4d52c6c9$export$a06a68c30cc52c94,
            group: group,
            grouping: grouping
        };
    }
    return {
        name: $89346a5a4d52c6c9$export$a06a68c30cc52c94,
        grouping: grouping,
        group: group
    };
};
const $89346a5a4d52c6c9$var$getGroupDetailsMapForCustomFieldSelector = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$var$getIssuesWithOriginalsAndOptimizedByGroup,
    (0, $kyGCj.getVisualisationGrouping),
    (0, $kKj1m.getCustomFieldsById),
    (0, $kKj1m.getSelectOptionsById),
    (0, $kyGCj.getCustomFieldValuesGroups),
    (0, $kyGCj.isGroupByMultiValueCustomField),
    (0, $kKj1m.getUserPickerOptionsUserListById)
], (issuesByGroup, grouping, customFieldsById, selectOptionsById, customFieldValuesGroups, // eslint-disable-next-line @typescript-eslint/no-shadow
isGroupByMultiValueCustomField, userPickerOptionsById)=>{
    const groupDetails = {};
    if ((0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) for (const [groupKey, issuesGroup] of Object.entries(issuesByGroup)){
        const groupAttribute = $89346a5a4d52c6c9$export$66c297e813a21e25(grouping);
        if (groupKey) {
            const details = $89346a5a4d52c6c9$var$getGroupDetailsMapForCustomField(issuesGroup[groupAttribute], grouping, isGroupByMultiValueCustomField, customFieldValuesGroups, customFieldsById, userPickerOptionsById, selectOptionsById);
            groupDetails[groupKey] = details;
        }
    }
    return groupDetails;
});
const $89346a5a4d52c6c9$var$getGroupDetailsMap = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$var$getIssuesWithOriginalsAndOptimizedByGroup,
    (0, $kyGCj.getVisualisationGrouping),
    $89346a5a4d52c6c9$export$f37748fb501e94bc,
    (0, $MQRDu.getAllTeamsById),
    $89346a5a4d52c6c9$export$d7ad569e206d3043,
    (0, $wcCGG.getVersionsById),
    $89346a5a4d52c6c9$var$getGroupDetailsMapForCustomFieldSelector,
    (0, $ehEr2.getProjects),
    (0, $6VhAf.getAssigneeList),
    (0, $KA559.getUniqueReportersOfIssues)
], $89346a5a4d52c6c9$export$90e66d86e8725e1d);
// createSelector supports up to max 12 dependencies, so we're just combining some into an object
const $89346a5a4d52c6c9$var$getGroupingWithIsAtlasConnectInstalled = (0, $iK4oF.createSelector)([
    (0, $dhHiZ.isAtlasConnectInstalled),
    (0, $kyGCj.getVisualisationGrouping)
], // eslint-disable-next-line @typescript-eslint/no-shadow
(isAtlasConnectInstalled, grouping)=>({
        isAtlasConnectInstalled: isAtlasConnectInstalled,
        grouping: grouping
    }));
const $89346a5a4d52c6c9$export$1641f2070ecb49b2 = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$2dc22532bb2facbd,
    $89346a5a4d52c6c9$export$8c797d2c6f8c1a2b,
    (0, $fbHoQ.getFilters),
    (0, $7s3LJ.getSort),
    (0, $cwMfk.getInlineCreateState),
    $89346a5a4d52c6c9$var$getGroupingWithIsAtlasConnectInstalled,
    $89346a5a4d52c6c9$var$getIssuesWithOriginalsAndOptimizedByGroup,
    (0, $MQRDu.getAllTeamsById),
    $89346a5a4d52c6c9$var$getGroupDetailsMap,
    $89346a5a4d52c6c9$var$getExpandedGroups,
    (0, $853IT.getSprintsWithFutureDates),
    (0, $wcCGG.getVersionsById)
], $89346a5a4d52c6c9$export$896f0b9c47e9ce0b);
const $89346a5a4d52c6c9$export$5d887aaef2abf9e2 = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$1641f2070ecb49b2
], $89346a5a4d52c6c9$export$611c3bba6a5df07a);
const $89346a5a4d52c6c9$export$6a9094aa95a25d0d = (scope)=>{
    if (scope.groupCount !== undefined && scope.groupCount > 0) {
        const issueIds = new Set();
        (scope.groups ?? []).forEach((group)=>{
            if (group.parentGroup !== undefined) // parentGroup used for nested grouping of releases within the 'Completed Releases' section
            {
                if (group.isParentGroupExpanded && group.isExpanded) $89346a5a4d52c6c9$export$c3ff3eda8ed23c68(group.scope).forEach((id)=>{
                    issueIds.add(id);
                });
            } else if (group.isExpanded) $89346a5a4d52c6c9$export$c3ff3eda8ed23c68(group.scope).forEach((id)=>{
                issueIds.add(id);
            });
        });
        return issueIds.size;
    }
    // the 'ungrouped' group
    return $89346a5a4d52c6c9$export$c3ff3eda8ed23c68(scope).size;
};
const $89346a5a4d52c6c9$export$c3ff3eda8ed23c68 = (scope)=>{
    const issueIds = new Set();
    scope.startLevelIssues.issues.forEach((issue)=>{
        issueIds.add(issue.id);
    });
    if (scope.issuesWithoutParentHeaderData.isExpanded) (scope.issuesWithoutParent ?? []).forEach((section)=>{
        if (section.isExpanded) section.issues.forEach((issue)=>{
            issueIds.add(issue.id);
        });
    });
    return issueIds;
};
const $89346a5a4d52c6c9$export$190897ce30bb27ad = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$5d887aaef2abf9e2
], $89346a5a4d52c6c9$export$6a9094aa95a25d0d);
const $89346a5a4d52c6c9$export$1664b92369554829 = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.searchQuery;
const $89346a5a4d52c6c9$export$e467ab9db30aa64c = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.activeSearchResultIndex;
const $89346a5a4d52c6c9$export$642c6002a1fbcb9c = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Header.Search.isSearchBoxOpen;
const $89346a5a4d52c6c9$export$6f6fcc622ed0431a = (string)=>// eslint-disable-next-line no-useless-escape
    string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $89346a5a4d52c6c9$export$f02f6625a39c8cf2 = (searchQuery)=>new RegExp(`(${$89346a5a4d52c6c9$export$6f6fcc622ed0431a(searchQuery)})`, 'gi');
const $89346a5a4d52c6c9$export$d05bbe0328e41cc6 = (searchQuery, title)=>$hkOxK.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $fpul1.default($l0L3x.default), $cGOmv.default($89346a5a4d52c6c9$export$f02f6625a39c8cf2(searchQuery)))(title);
const $89346a5a4d52c6c9$export$d9ffdbc590df6d8a = (str1, str2)=>$5OdRK.default($701od.default(str1), $701od.default(str2));
const $89346a5a4d52c6c9$export$cf96ff633ce1ed2a = (projectsById, { issueKey: issueKey, project: project })=>{
    let issueLink = `${issueKey || ''}`;
    if ((0, $7CnHa.isDefined)(project) && (0, $7CnHa.isDefined)(projectsById[project])) issueLink = `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
    return issueLink;
};
const $89346a5a4d52c6c9$export$2bbb1aef9a2e8a75 = (issueLink, searchQuery, issue)=>$hQdGw.default(`${issueLink} ${issue.summary}`.match(new RegExp($89346a5a4d52c6c9$export$6f6fcc622ed0431a(searchQuery), 'gi')) || []);
const $89346a5a4d52c6c9$export$6134a38b10ca9c9d = (allIssuesByGroup, scope, filteredIssuesById, projects, grouping, isSearchBoxOpen, searchQuery, issueFilterMatcherWithFilterId)=>{
    const results = {
        hasNestedMatches: {},
        total: 0,
        resultsHiddenByFilter: [],
        searchMatches: []
    };
    // Because of dependencies in the selectors that we cannot get rid of, this selector is called on init.
    // We don't want to calculate such heavy selector every time but only when the user starts using issue search
    if (!isSearchBoxOpen || searchQuery.trim() === '') return results;
    // projects indexed by id are needed for the "buildIssueLink" function
    const projectsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), projects);
    // when the plan is grouped by a field, issues are displayed several times which can cause duplicates in the searchMatches
    const isChunkAlreadyInSearchMatches = (internalIndex, id, linkMatch, group)=>results.searchMatches.find((match)=>[
                match.internalIndex,
                match.id,
                match.linkMatch,
                match.group
            ].join('|') === [
                internalIndex,
                id,
                linkMatch,
                group
            ].join('|'));
    const searchForMatchingIssuesInGroup = (issue, group)=>{
        const { id: id, summary: summary, parent: parent } = issue;
        const issueLink = $89346a5a4d52c6c9$export$cf96ff633ce1ed2a(projectsById, issue);
        const total = $89346a5a4d52c6c9$export$2bbb1aef9a2e8a75(issueLink, searchQuery, issue);
        // if the issue matches the searchQuery and is not hidden by filters
        if (total && filteredIssuesById[id]) {
            if (parent) results.hasNestedMatches = $lEZXx.default(results.hasNestedMatches, {
                [`${group}`]: {
                    [parent]: true
                }
            });
            let internalIndex = 0;
            const linkChunks = $89346a5a4d52c6c9$export$d05bbe0328e41cc6(searchQuery, issueLink);
            for (const chunk of linkChunks){
                if ($89346a5a4d52c6c9$export$d9ffdbc590df6d8a(chunk, searchQuery) && !isChunkAlreadyInSearchMatches(internalIndex, id, true, group)) {
                    results.searchMatches.push({
                        internalIndex: internalIndex,
                        id: id,
                        linkMatch: true,
                        group: group
                    });
                    results.total += 1;
                }
                internalIndex++;
            }
            const summaryChunks = $89346a5a4d52c6c9$export$d05bbe0328e41cc6(searchQuery, summary);
            for (const chunk of summaryChunks){
                if ($89346a5a4d52c6c9$export$d9ffdbc590df6d8a(chunk, searchQuery) && !isChunkAlreadyInSearchMatches(internalIndex, id, false, group)) {
                    results.searchMatches.push({
                        internalIndex: internalIndex,
                        id: id,
                        linkMatch: false,
                        group: group
                    });
                    results.total += 1;
                }
                internalIndex++;
            }
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const browseIssuesInGroup = (scope, group)=>{
        const { startLevelIssues: startLevelIssues, issuesWithoutParent: issuesWithoutParent } = scope;
        // the issuesWithoutParent is an array of objects
        // each object includes the issues without parent on a specific level of the hierarchy (Initiative, Epic, Story)
        // e.g. if there are 30 Initiative issues without parent and 23 story issues without parent:
        // issuesWithoutParent: [
        // { id: "IssuesWithoutParent-3", isExpanded: false, issues: Array(30), level: INITIATIVE_LEVEL, rootIssuesCount: 30 }
        // { id: "IssuesWithoutParent-2", isExpanded: true, issues: Array(0), level: EPIC_LEVEL, rootIssuesCount: 0 }
        // { id: "IssuesWithoutParent-1", isExpanded: false, issues: Array(23), level: STORY_LEVEL, rootIssuesCount: 23 }
        // ]
        // we map through each level, get the issues and then flatten the whole array
        const flattenIssuesWithoutParent = $lqxEm.default($cQGVO.default($f7Op5.default('issues'), issuesWithoutParent));
        // note: when the plan is grouped by None, issues have an EMPTY group
        const issueGroup = grouping !== (0, $5rYNM.GROUPING).NONE ? group : '';
        // all these issues are already sorted accordingly in the getScopeWithExpandingStateIgnored selector
        // and come bundled with their children also sorted accordingly
        // e.g. Epic 1 has no children, Epic 2 has 1 Story child, Epic 3 has 2 Story children, Epic 4 has no children
        // [ {Epic 1}, {Epic 2 > Story 1}, {Epic 3}, {Epic 3 > Story 1}, {Epic 3 > Story 2}, {Epic 4}, {Epic 5},  ... ]
        // therefore we only need to map through the array of issues and find potential matches
        const allIssues = [
            ...startLevelIssues.issues,
            ...flattenIssuesWithoutParent
        ];
        allIssues.forEach((issue)=>{
            searchForMatchingIssuesInGroup(issue, issueGroup);
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    scope.groups.forEach(({ scope: scope, group: group })=>{
        browseIssuesInGroup(scope, group);
    });
    // looping through all issues to find the matching issues hidden by filters
    $UCNmJ.default(allIssuesByGroup).forEach((group)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [
            ...group.issues
        ].forEach((issue)=>{
            const issueLink = $89346a5a4d52c6c9$export$cf96ff633ce1ed2a(projectsById, issue);
            const total = $89346a5a4d52c6c9$export$2bbb1aef9a2e8a75(issueLink, searchQuery, issue);
            if (total && !filteredIssuesById[issue.id]) results.resultsHiddenByFilter.push({
                id: issue.id,
                unmatchedFilters: issueFilterMatcherWithFilterId(issue)
            });
        });
    });
    return results;
};
const $89346a5a4d52c6c9$export$df7b5ec530ae24ca = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$2d0a064b4b76d506,
    $89346a5a4d52c6c9$export$1641f2070ecb49b2,
    (0, $kwMvv.getFilteredIssuesWithHierarchyById),
    (0, $ehEr2.getProjects),
    (0, $kyGCj.getVisualisationGrouping),
    $89346a5a4d52c6c9$export$642c6002a1fbcb9c,
    $89346a5a4d52c6c9$export$1664b92369554829,
    (0, $kwMvv.getIssueFilterMatcherWithFilterId)
], $89346a5a4d52c6c9$export$6134a38b10ca9c9d);
const $89346a5a4d52c6c9$export$24686634b40470a0 = ({ searchMatches: searchMatches }, activeSearchResultIndex)=>(0, $7CnHa.isDefined)(searchMatches[activeSearchResultIndex]) ? searchMatches[activeSearchResultIndex] : undefined;
const $89346a5a4d52c6c9$export$6ab3c2d73db706ef = (0, $iK4oF.createSelector)([
    $89346a5a4d52c6c9$export$df7b5ec530ae24ca,
    $89346a5a4d52c6c9$export$e467ab9db30aa64c
], $89346a5a4d52c6c9$export$24686634b40470a0);
const $89346a5a4d52c6c9$export$67b67276ed3edc87 = (issuesByGroup)=>{
    const map = {};
    for (const { issues: issues = new Set(), parentGroup: parentGroup, ...groupCombination } of $UCNmJ.default(issuesByGroup))for (const issue of issues){
        if (!map[issue.id]) map[issue.id] = [];
        map[issue.id].push({
            groupCombination: groupCombination,
            parentGroup: parentGroup
        });
    }
    return map;
};
const $89346a5a4d52c6c9$export$269e836147dd799c = (0, $iK4oF.createSelector)($89346a5a4d52c6c9$export$97e315c357c4faa0, $89346a5a4d52c6c9$export$67b67276ed3edc87);

});
parcelRegister("dspDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc1c68d9046c198$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");

var $ggdJA = parcelRequire("ggdJA");

var $du3lC = parcelRequire("du3lC");

var $jDSc6 = parcelRequire("jDSc6");

var $1uCJR = parcelRequire("1uCJR");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $9cc1c68d9046c198$var$intersection = /*#__PURE__*/ (0, $ggdJA.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $1uCJR.default)((0, $du3lC.default)((0, $jDSc6.default)((0, $75bQw.default))(lookupList), filteredList));
});
var $9cc1c68d9046c198$export$2e2bcd8739ae039 = $9cc1c68d9046c198$var$intersection;

});
parcelRegister("jDSc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4cbb2acb40af068$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $bwMm3 = parcelRequire("bwMm3");
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $e4cbb2acb40af068$var$flip = /*#__PURE__*/ (0, $eSWTK.default)(function flip(fn) {
    return (0, $bwMm3.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $e4cbb2acb40af068$export$2e2bcd8739ae039 = $e4cbb2acb40af068$var$flip;

});


parcelRegister("hQdGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd1e8897d0b5b6b$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $gxE4U = parcelRequire("gxE4U");
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $cfd1e8897d0b5b6b$var$length = /*#__PURE__*/ (0, $eSWTK.default)(function length(list) {
    return list != null && (0, $gxE4U.default)(list.length) ? list.length : NaN;
});
var $cfd1e8897d0b5b6b$export$2e2bcd8739ae039 = $cfd1e8897d0b5b6b$var$length;

});
parcelRegister("gxE4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0aed11fc539f8a8$export$2e2bcd8739ae039);
function $c0aed11fc539f8a8$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
}

});


parcelRegister("lEZXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4d653af09f83c4$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $6Xuyi = parcelRequire("6Xuyi");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $fc4d653af09f83c4$var$mergeDeepLeft = /*#__PURE__*/ (0, $ggdJA.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, $6Xuyi.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $fc4d653af09f83c4$export$2e2bcd8739ae039 = $fc4d653af09f83c4$var$mergeDeepLeft;

});

parcelRegister("79tFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $535064afa04dfb5e$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $5OdRK = parcelRequire("5OdRK");

var $kjklK = parcelRequire("kjklK");
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $535064afa04dfb5e$var$pathEq = /*#__PURE__*/ (0, $4g10W.default)(function pathEq(_path, val, obj) {
    return (0, $5OdRK.default)((0, $kjklK.default)(_path, obj), val);
});
var $535064afa04dfb5e$export$2e2bcd8739ae039 = $535064afa04dfb5e$var$pathEq;

});

parcelRegister("812KE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d608d14aa554469$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $gxE4U = parcelRequire("gxE4U");
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $5d608d14aa554469$var$range = /*#__PURE__*/ (0, $ggdJA.default)(function range(from, to) {
    if (!((0, $gxE4U.default)(from) && (0, $gxE4U.default)(to))) throw new TypeError('Both arguments to range must be numbers');
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $5d608d14aa554469$export$2e2bcd8739ae039 = $5d608d14aa554469$var$range;

});

parcelRegister("cGOmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d079251c6aa617$export$2e2bcd8739ae039);

var $juWBF = parcelRequire("juWBF");
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $93d079251c6aa617$var$split = /*#__PURE__*/ (0, $juWBF.default)(1, 'split');
var $93d079251c6aa617$export$2e2bcd8739ae039 = $93d079251c6aa617$var$split;

});

parcelRegister("kyGCj", function(module, exports) {

$parcel$export(module.exports, "getStickyHeaderScrollTop", () => $ab44bb17eed8e72a$export$20068a88fa6c5af7);
$parcel$export(module.exports, "getVisualisationGrouping", () => $ab44bb17eed8e72a$export$6d374601688ff387);
$parcel$export(module.exports, "getVisualisationSorting", () => $ab44bb17eed8e72a$export$8e2c99fad461c86f);
$parcel$export(module.exports, "getShowSprints", () => $ab44bb17eed8e72a$export$6b80bdc7be3201ec);
$parcel$export(module.exports, "getSprintsAreShown", () => $ab44bb17eed8e72a$export$7c3fd961263a77cc);
$parcel$export(module.exports, "getColorByValue", () => $ab44bb17eed8e72a$export$f663f23222699c31);
$parcel$export(module.exports, "getColourMaps", () => $ab44bb17eed8e72a$export$dc402cc25706a1d9);
$parcel$export(module.exports, "getColourIssueTypes", () => $ab44bb17eed8e72a$export$5724381328eeee06);
$parcel$export(module.exports, "getColourLabels", () => $ab44bb17eed8e72a$export$9b80d63cbee94715);
$parcel$export(module.exports, "getColourComponents", () => $ab44bb17eed8e72a$export$2baa3bc0767a767b);
$parcel$export(module.exports, "getColourPriorities", () => $ab44bb17eed8e72a$export$93dce55de70fbd71);
$parcel$export(module.exports, "getColourSelects", () => $ab44bb17eed8e72a$export$138250857b33c4c9);
$parcel$export(module.exports, "getColourByIssueTypeColourMap", () => $ab44bb17eed8e72a$export$dc50c92d9f08f06d);
$parcel$export(module.exports, "getColourByLabelColourMap", () => $ab44bb17eed8e72a$export$1cbb1202b144d067);
$parcel$export(module.exports, "getColourByComponentColourMap", () => $ab44bb17eed8e72a$export$49637d2c4b6ad582);
$parcel$export(module.exports, "getColourByPriorityColourMap", () => $ab44bb17eed8e72a$export$679b944fd77daa3);
$parcel$export(module.exports, "getColourBySelectColourMap", () => $ab44bb17eed8e72a$export$d1a26b5685d69490);
$parcel$export(module.exports, "isColorByCustomFieldOption", () => $ab44bb17eed8e72a$export$f2e3afe6b51cb1fe);
$parcel$export(module.exports, "getSelectOptionsFromIssues", () => $ab44bb17eed8e72a$export$33345bc5757ddb24);
$parcel$export(module.exports, "getCustomFieldValuesGroups", () => $ab44bb17eed8e72a$export$bf794e171dc086eb);
$parcel$export(module.exports, "isGroupByMultiValueCustomField", () => $ab44bb17eed8e72a$export$de65305314931ab0);
$parcel$export(module.exports, "getCustomFieldValuesGroupsById", () => $ab44bb17eed8e72a$export$4cb7ee4ce12522c5);
$parcel$export(module.exports, "changeGroup", () => (parcelRequire("l1dWb")).changeGroup);
$parcel$export(module.exports, "defaultSorting", () => (parcelRequire("dvRTl")).defaultSorting);

var $jPCDz = parcelRequire("jPCDz");
var $kDrtX = parcelRequire("kDrtX");
var $f7Op5 = parcelRequire("f7Op5");

var $kKj1m = parcelRequire("kKj1m");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $9H2AP = parcelRequire("9H2AP");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $l1dWb = parcelRequire("l1dWb");

var $dvRTl = parcelRequire("dvRTl");
const $ab44bb17eed8e72a$export$20068a88fa6c5af7 = (state)=>state.ui.Main.Tabs.Roadmap.StickyHeader.scrollTop;
const $ab44bb17eed8e72a$export$6d374601688ff387 = (state)=>(0, $9H2AP.getVisualisationViewSettings)(state).grouping;
const $ab44bb17eed8e72a$export$8e2c99fad461c86f = (state)=>(0, $9H2AP.getVisualisationViewSettings)(state).sorting;
const $ab44bb17eed8e72a$export$6b80bdc7be3201ec = (state)=>(0, $9H2AP.getVisualisationViewSettings)(state).showSprints;
const $ab44bb17eed8e72a$export$7c3fd961263a77cc = (state)=>$ab44bb17eed8e72a$export$6b80bdc7be3201ec(state) && ($ab44bb17eed8e72a$export$6d374601688ff387(state) === (0, $5rYNM.GROUPING).TEAM || $ab44bb17eed8e72a$export$6d374601688ff387(state) === (0, $5rYNM.GROUPING).SPRINT);
const $ab44bb17eed8e72a$export$f663f23222699c31 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourByValue;
const $ab44bb17eed8e72a$export$dc402cc25706a1d9 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourMaps;
const $ab44bb17eed8e72a$export$cf14d565a2ef3c90 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).lastUsed;
const $ab44bb17eed8e72a$export$5724381328eeee06 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourIssueTypes;
const $ab44bb17eed8e72a$export$9b80d63cbee94715 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourLabels;
const $ab44bb17eed8e72a$export$2baa3bc0767a767b = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourComponents;
const $ab44bb17eed8e72a$export$93dce55de70fbd71 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourPriorities;
const $ab44bb17eed8e72a$export$138250857b33c4c9 = (state)=>(0, $9H2AP.getColorByViewSettings)(state).colourSelects;
const $ab44bb17eed8e72a$export$bb6b047bffa50ce5 = (colourIssueTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const { colour: colour, issueTypes: issueTypes } of colourIssueTypes){
        if (colour && issueTypes) for (const issueType of issueTypes)result[issueType] = colour;
    }
    return result;
};
const $ab44bb17eed8e72a$export$47c6097f7c97c7e7 = (colourLabels)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const { colour: colour, labels: labels } of colourLabels){
        if (colour) for (const label of labels)result[label] = colour;
    }
    return result;
};
const $ab44bb17eed8e72a$export$9cb076f9ce17918f = (colourComponents)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const { colour: colour, components: components } of colourComponents){
        if (colour) for (const component of components)result[component] = colour;
    }
    return result;
};
const $ab44bb17eed8e72a$export$9d7ac11983e3f8db = (colourPriorities = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const { colour: colour, priorities: priorities } of colourPriorities){
        if (colour && priorities) for (const priority of priorities)result[priority] = colour;
    }
    return result;
};
const $ab44bb17eed8e72a$export$dc50c92d9f08f06d = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$5724381328eeee06
], $ab44bb17eed8e72a$export$bb6b047bffa50ce5);
const $ab44bb17eed8e72a$export$1cbb1202b144d067 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$9b80d63cbee94715
], $ab44bb17eed8e72a$export$47c6097f7c97c7e7);
const $ab44bb17eed8e72a$export$49637d2c4b6ad582 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$2baa3bc0767a767b
], $ab44bb17eed8e72a$export$9cb076f9ce17918f);
const $ab44bb17eed8e72a$export$679b944fd77daa3 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$93dce55de70fbd71
], $ab44bb17eed8e72a$export$9d7ac11983e3f8db);
const $ab44bb17eed8e72a$export$2d7070b8c3d8a5fe = (colorByValue, colourOptions)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const { colour: colour, options: options } of colourOptions[colorByValue] || []){
        if (colour) for (const option of options)result[option] = colour;
    }
    return result;
};
const $ab44bb17eed8e72a$export$d1a26b5685d69490 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$f663f23222699c31,
    $ab44bb17eed8e72a$export$138250857b33c4c9
], $ab44bb17eed8e72a$export$2d7070b8c3d8a5fe);
const $ab44bb17eed8e72a$export$f2e3afe6b51cb1fe = (id)=>!$kDrtX.default(id) && ![
        (0, $33N5G.colourByOptions).COMPONENT,
        (0, $33N5G.colourByOptions).EPIC,
        (0, $33N5G.colourByOptions).ISSUE_TYPE,
        (0, $33N5G.colourByOptions).LABEL,
        (0, $33N5G.colourByOptions).NONE,
        (0, $33N5G.colourByOptions).PRIORITY,
        (0, $33N5G.colourByOptions).PROJECT,
        (0, $33N5G.colourByOptions).STATUS,
        (0, $33N5G.colourByOptions).TEAM
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    .includes(id);
const $ab44bb17eed8e72a$export$dec6094604a65c25 = (colorByValue, availableCustomFields, issues)=>{
    const field = (0, $kKj1m.getCustomFieldById)(Number(colorByValue), availableCustomFields)[0];
    if (!field) return [];
    // get all the issues which has the custom field used by color-by
    const issuesWithColorByCustomFields = issues.filter(({ customFields: customFields = {} })=>$jPCDz.default(colorByValue, customFields));
    // get the values of the custom field used by color-by
    const options = issuesWithColorByCustomFields // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((ids, { customFields: customFields = {} })=>{
        const fieldValue = customFields[field.id];
        Array.prototype.push.apply(ids, Array.isArray(fieldValue) ? fieldValue : [
            fieldValue
        ]);
        return ids;
    }, []).filter((id)=>!$kDrtX.default(id)).map((id)=>id && id.toString());
    return [
        ...new Set(options)
    ];
};
const $ab44bb17eed8e72a$export$33345bc5757ddb24 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$f663f23222699c31,
    (0, $kKj1m.getCustomFields),
    (0, $cwP4d.getIssues)
], $ab44bb17eed8e72a$export$dec6094604a65c25);
const $ab44bb17eed8e72a$var$getAllOtherIssuesGroup = (grouping)=>({
        id: (0, $2d8d6e97f58f6828$export$526fec6b76d5bc5),
        name: '',
        isExpanded: false,
        [grouping]: []
    });
const $ab44bb17eed8e72a$export$bf794e171dc086eb = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getCustomFieldValuesGroupsViewSettings),
    $ab44bb17eed8e72a$export$6d374601688ff387
], (customFieldValuesGroupsState, grouping)=>customFieldValuesGroupsState[grouping] || [
        $ab44bb17eed8e72a$var$getAllOtherIssuesGroup(grouping)
    ]);
const $ab44bb17eed8e72a$export$95a03f06c11e24b1 = (grouping, customFieldsById)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) return false;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldId = (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping);
    if (!customFieldsById[fieldId]) return false;
    return (0, $5rYNM.CustomFields).GroupableMultiValueFields.includes(customFieldsById[fieldId].type.key);
};
const $ab44bb17eed8e72a$export$de65305314931ab0 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$6d374601688ff387,
    (0, $kKj1m.getCustomFieldsById)
], $ab44bb17eed8e72a$export$95a03f06c11e24b1);
const $ab44bb17eed8e72a$export$4cb7ee4ce12522c5 = (0, $iK4oF.createSelector)([
    $ab44bb17eed8e72a$export$bf794e171dc086eb
], (customFieldValuesGroups)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), customFieldValuesGroups));

});
const $2d8d6e97f58f6828$export$526fec6b76d5bc5 = 'all_other_issues';

parcelRegister("33N5G", function(module, exports) {

$parcel$export(module.exports, "priorityColourMap", () => $c47965a0a2d1782d$export$9e46ca4a9d72a47a);
$parcel$export(module.exports, "statusColourMap", () => $c47965a0a2d1782d$export$b165e7a83b8d071e);
$parcel$export(module.exports, "colourPalette", () => $c47965a0a2d1782d$export$62574e55be2dec4c);
$parcel$export(module.exports, "colourPickerPalette", () => $c47965a0a2d1782d$export$64eb68126e172885);
$parcel$export(module.exports, "colourPickerPaletteLabels", () => $c47965a0a2d1782d$export$91b816e18e6c5df8);
$parcel$export(module.exports, "colourPaletteTextColoursMap", () => $c47965a0a2d1782d$export$417e78c88d312f43);
$parcel$export(module.exports, "DEFAULT_COLOR", () => $c47965a0a2d1782d$export$37394b0fa44b998c);
$parcel$export(module.exports, "OPTIMIZED_COLOR", () => $c47965a0a2d1782d$export$5f382c549e49b03c);
$parcel$export(module.exports, "colourByOptions", () => $c47965a0a2d1782d$export$48e6473fbcf263ed);
$parcel$export(module.exports, "statusBreakdownColourMap", () => $c47965a0a2d1782d$export$8d0430f655bb72d1);
$parcel$export(module.exports, "epicColorToARJColor", () => $c47965a0a2d1782d$export$6dd3d3f0ff9ad95d);

var $opsFH = parcelRequire("opsFH");

var $g4Vkx = parcelRequire("g4Vkx");

var $gB7xc = parcelRequire("gB7xc");
const $c47965a0a2d1782d$export$9e46ca4a9d72a47a = [
    (0, $g4Vkx.default).R400,
    (0, $g4Vkx.default).Y400,
    (0, $g4Vkx.default).B400
];
const $c47965a0a2d1782d$export$b165e7a83b8d071e = {
    '2': (0, $g4Vkx.default).N500,
    // todo
    '4': (0, $g4Vkx.default).B500,
    // in progress
    '3': (0, $g4Vkx.default).G500 // done
};
const $c47965a0a2d1782d$export$62574e55be2dec4c = [
    // Dark colours
    (0, $g4Vkx.default).P400,
    (0, $g4Vkx.default).B400,
    (0, $g4Vkx.default).T400,
    (0, $g4Vkx.default).G400,
    (0, $g4Vkx.default).Y400,
    // Light colours
    (0, $g4Vkx.default).R100,
    (0, $g4Vkx.default).P75,
    (0, $g4Vkx.default).B100,
    (0, $g4Vkx.default).T100,
    (0, $g4Vkx.default).G100,
    (0, $g4Vkx.default).Y100,
    // Dark red is at the end because it could be interpreted as a warning.
    // We don't want to remove it from palette, just make it less likely to be used.
    (0, $g4Vkx.default).R400
];
const $c47965a0a2d1782d$export$64eb68126e172885 = [
    // Dark colours
    (0, $g4Vkx.default).R400,
    (0, $g4Vkx.default).P400,
    (0, $g4Vkx.default).B400,
    (0, $g4Vkx.default).T400,
    (0, $g4Vkx.default).G400,
    (0, $g4Vkx.default).Y400,
    // Light colours
    (0, $g4Vkx.default).R100,
    (0, $g4Vkx.default).P75,
    (0, $g4Vkx.default).B100,
    (0, $g4Vkx.default).T100,
    (0, $g4Vkx.default).G100,
    (0, $g4Vkx.default).Y100
];
const $c47965a0a2d1782d$export$91b816e18e6c5df8 = {
    // Dark colours
    [(0, $g4Vkx.default).R400]: (0, $gB7xc.default).r400,
    [(0, $g4Vkx.default).P400]: (0, $gB7xc.default).p400,
    [(0, $g4Vkx.default).B400]: (0, $gB7xc.default).b400,
    [(0, $g4Vkx.default).T400]: (0, $gB7xc.default).t400,
    [(0, $g4Vkx.default).G400]: (0, $gB7xc.default).g400,
    [(0, $g4Vkx.default).Y400]: (0, $gB7xc.default).y400,
    // Light colours
    [(0, $g4Vkx.default).R100]: (0, $gB7xc.default).r100,
    [(0, $g4Vkx.default).P75]: (0, $gB7xc.default).p75,
    [(0, $g4Vkx.default).B100]: (0, $gB7xc.default).b100,
    [(0, $g4Vkx.default).T100]: (0, $gB7xc.default).t100,
    [(0, $g4Vkx.default).G100]: (0, $gB7xc.default).g100,
    [(0, $g4Vkx.default).Y100]: (0, $gB7xc.default).y100,
    // Grey colour
    [(0, $g4Vkx.default).N100]: (0, $gB7xc.default).n100
};
const $c47965a0a2d1782d$export$417e78c88d312f43 = {
    // Light font colour for dark colours
    [(0, $g4Vkx.default).R400]: (0, $g4Vkx.default).N0,
    [(0, $g4Vkx.default).P400]: (0, $g4Vkx.default).N0,
    [(0, $g4Vkx.default).B400]: (0, $g4Vkx.default).N0,
    [(0, $g4Vkx.default).T400]: (0, $g4Vkx.default).N0,
    [(0, $g4Vkx.default).G400]: (0, $g4Vkx.default).N0,
    // Dark font colour for light colours
    [(0, $g4Vkx.default).R100]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).P75]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).B100]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).T100]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).G100]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).Y100]: (0, $g4Vkx.default).N800,
    [(0, $g4Vkx.default).Y400]: (0, $g4Vkx.default).N800
};
const $c47965a0a2d1782d$export$37394b0fa44b998c = (0, $g4Vkx.default).N100;
const $c47965a0a2d1782d$export$5f382c549e49b03c = (0, $g4Vkx.default).P300;
const $c47965a0a2d1782d$export$48e6473fbcf263ed = {
    COMPONENT: 'component',
    EPIC: 'epic',
    ISSUE_TYPE: 'issueType',
    ISSUE_TYPE_KEY: 'issueTypeKey',
    LABEL: 'label',
    NONE: 'none',
    PRIORITY: 'priority',
    PROJECT: 'project',
    STATUS: 'status',
    TEAM: 'team'
};
const $c47965a0a2d1782d$export$8d0430f655bb72d1 = {
    TODO: `var(--ds-border, ${(0, $g4Vkx.default).N50})`,
    INPROGRESS: `var(--ds-border-information, ${(0, $g4Vkx.default).B400})`,
    DONE: `var(--ds-border-success, ${(0, $g4Vkx.default).G300})`
};
const $c47965a0a2d1782d$export$6dd3d3f0ff9ad95d = {
    // Dark colours
    [(0, $opsFH.Colors).DARK_ORANGE]: (0, $g4Vkx.default).R400,
    [(0, $opsFH.Colors).DARK_PURPLE]: (0, $g4Vkx.default).P400,
    [(0, $opsFH.Colors).DARK_BLUE]: (0, $g4Vkx.default).B400,
    [(0, $opsFH.Colors).DARK_TEAL]: (0, $g4Vkx.default).T400,
    [(0, $opsFH.Colors).DARK_GREEN]: (0, $g4Vkx.default).G400,
    [(0, $opsFH.Colors).DARK_YELLOW]: (0, $g4Vkx.default).Y400,
    // Light colours
    [(0, $opsFH.Colors).ORANGE]: (0, $g4Vkx.default).R100,
    [(0, $opsFH.Colors).PURPLE]: (0, $g4Vkx.default).P75,
    [(0, $opsFH.Colors).BLUE]: (0, $g4Vkx.default).B100,
    [(0, $opsFH.Colors).TEAL]: (0, $g4Vkx.default).T100,
    [(0, $opsFH.Colors).GREEN]: (0, $g4Vkx.default).G100,
    [(0, $opsFH.Colors).YELLOW]: (0, $g4Vkx.default).Y100,
    // Extra colours
    [(0, $opsFH.Colors).DARK_GREY]: (0, $g4Vkx.default).N400,
    [(0, $opsFH.Colors).GREY]: (0, $g4Vkx.default).N100
};

});
parcelRegister("gB7xc", function(module, exports) {

$parcel$export(module.exports, "default", () => $94236d0c5cc5fa6e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $94236d0c5cc5fa6e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Dark colours
    r400: {
        "id": "portfolio-3-portfolio.common.colours.r-400",
        "defaultMessage": "Red"
    },
    p400: {
        "id": "portfolio-3-portfolio.common.colours.p-400",
        "defaultMessage": "Purple"
    },
    b400: {
        "id": "portfolio-3-portfolio.common.colours.b-400",
        "defaultMessage": "Blue"
    },
    t400: {
        "id": "portfolio-3-portfolio.common.colours.t-400",
        "defaultMessage": "Teal"
    },
    g400: {
        "id": "portfolio-3-portfolio.common.colours.g-400",
        "defaultMessage": "Green"
    },
    y400: {
        "id": "portfolio-3-portfolio.common.colours.y-400",
        "defaultMessage": "Orange"
    },
    // Light colours
    r100: {
        "id": "portfolio-3-portfolio.common.colours.r-100",
        "defaultMessage": "Light red"
    },
    p75: {
        "id": "portfolio-3-portfolio.common.colours.p-75",
        "defaultMessage": "Light purple"
    },
    b100: {
        "id": "portfolio-3-portfolio.common.colours.b-100",
        "defaultMessage": "Light blue"
    },
    t100: {
        "id": "portfolio-3-portfolio.common.colours.t-100",
        "defaultMessage": "Light teal"
    },
    g100: {
        "id": "portfolio-3-portfolio.common.colours.g-100",
        "defaultMessage": "Light green"
    },
    y100: {
        "id": "portfolio-3-portfolio.common.colours.y-100",
        "defaultMessage": "Light yellow"
    },
    // Grey colour
    n100: {
        "id": "portfolio-3-portfolio.common.colours.n-100",
        "defaultMessage": "Gray"
    }
});

});


parcelRegister("l1dWb", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $e4a4f0287c9c124b$export$4a991c87e640ef77);
$parcel$export(module.exports, "CHANGE_GROUP", () => $e4a4f0287c9c124b$export$b4ef27f82439f936);
$parcel$export(module.exports, "CHANGE_SORT", () => $e4a4f0287c9c124b$export$d7e9ddd59e8f46a1);
$parcel$export(module.exports, "TOGGLE_EXPAND_GROUP", () => $e4a4f0287c9c124b$export$8078ee4dffbc67dd);
$parcel$export(module.exports, "TOGGLE_SHOW_SPRINTS", () => $e4a4f0287c9c124b$export$3d122ed49958660e);
$parcel$export(module.exports, "changeGroup", () => $e4a4f0287c9c124b$export$4574bce4737c2ea6);
$parcel$export(module.exports, "changeSort", () => $e4a4f0287c9c124b$export$302198af71c74ff0);
$parcel$export(module.exports, "toggleExpandGroup", () => $e4a4f0287c9c124b$export$e39ccd5e591a7b90);
$parcel$export(module.exports, "toggleShowSprints", () => $e4a4f0287c9c124b$export$78af749f6ae1eb58);
const $e4a4f0287c9c124b$export$4a991c87e640ef77 = 'state.domain.view-settings.visualisations.RESET';
const $e4a4f0287c9c124b$export$b4ef27f82439f936 = 'state.domain.view-settings.visualisations.CHANGE_GROUP';
const $e4a4f0287c9c124b$export$d7e9ddd59e8f46a1 = 'state.domain.view-settings.visualisations.CHANGE_SORT';
const $e4a4f0287c9c124b$export$8078ee4dffbc67dd = 'state.domain.view-settings.visualisations.TOGGLE_EXPAND_GROUP';
const $e4a4f0287c9c124b$export$3d122ed49958660e = 'state.domain.view-settings.visualisations.TOGGLE_SHOW_SPRINTS';
const $e4a4f0287c9c124b$export$aad8462122ac592b = (payload)=>({
        type: $e4a4f0287c9c124b$export$4a991c87e640ef77,
        payload: payload
    });
const $e4a4f0287c9c124b$export$4574bce4737c2ea6 = (payload)=>({
        type: $e4a4f0287c9c124b$export$b4ef27f82439f936,
        payload: payload
    });
const $e4a4f0287c9c124b$export$302198af71c74ff0 = (payload)=>({
        type: $e4a4f0287c9c124b$export$d7e9ddd59e8f46a1,
        payload: payload
    });
const $e4a4f0287c9c124b$export$e39ccd5e591a7b90 = (payload)=>({
        type: $e4a4f0287c9c124b$export$8078ee4dffbc67dd,
        payload: payload
    });
const $e4a4f0287c9c124b$export$78af749f6ae1eb58 = (payload)=>({
        type: $e4a4f0287c9c124b$export$3d122ed49958660e,
        payload: payload
    });

});

parcelRegister("dvRTl", function(module, exports) {

$parcel$export(module.exports, "defaultSorting", () => $55a1c139c9f195ad$export$6655f0b167885296);

var $chgK5 = parcelRequire("chgK5");

var $5rYNM = parcelRequire("5rYNM");
const $55a1c139c9f195ad$export$6655f0b167885296 = {
    field: (0, $chgK5.ISSUE_FIELDS).RANK,
    type: (0, $5rYNM.ISSUE_FIELD_TYPES).STRING,
    direction: (0, $5rYNM.SORT_DIRECTION).ASCENDING
};

});



parcelRegister("c7fhc", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $ada6d80d87726e3c$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE_EXPANDED_ISSUE_LINKS", () => $ada6d80d87726e3c$export$d99167e1e5a860b7);
$parcel$export(module.exports, "SET_IS_EXPANDED", () => $ada6d80d87726e3c$export$9b92e965bf6ba41);
$parcel$export(module.exports, "setIsExpanded", () => $ada6d80d87726e3c$export$231b1c9d9115ec74);
$parcel$export(module.exports, "updateExpandedIssueLinks", () => $ada6d80d87726e3c$export$3fe1202ea331fec2);
const $ada6d80d87726e3c$export$4a991c87e640ef77 = 'state.domain.view-settings.issue-expansions.RESET';
const $ada6d80d87726e3c$export$d99167e1e5a860b7 = 'state.domain.view-settings.issue-expansions.UPDATE_EXPANDED_ISSUE_LINKS';
const $ada6d80d87726e3c$export$9b92e965bf6ba41 = 'state.domain.view-settings.issue-expansions.SET_IS_EXPANDED';
const $ada6d80d87726e3c$export$231b1c9d9115ec74 = (payload)=>({
        type: $ada6d80d87726e3c$export$9b92e965bf6ba41,
        payload: payload
    });
const $ada6d80d87726e3c$export$3fe1202ea331fec2 = (payload)=>({
        type: $ada6d80d87726e3c$export$d99167e1e5a860b7,
        payload: payload
    });
const $ada6d80d87726e3c$export$aad8462122ac592b = (payload)=>({
        type: $ada6d80d87726e3c$export$4a991c87e640ef77,
        payload: payload
    });

});

const $83cf706a87a62789$export$242fccfb90c57247 = 'command.issue.ADD_ISSUE';
const $83cf706a87a62789$export$d46fd8e9a2a59b28 = 'command.issue.UPDATE_ISSUE';
const $83cf706a87a62789$export$254f30e4f720be90 = 'command.issue.UPDATE_MULTIPLE_ISSUES';
const $83cf706a87a62789$export$9bbbeac0bf5bf14 = 'command.issue.RANK_ISSUE';
const $83cf706a87a62789$export$269d7b2720ef5d5e = 'command.issue.MOVE_ISSUE';
const $83cf706a87a62789$export$ce69e6c9d4cdf606 = 'command.issue.UPDATE_ORIGINAL_ISSUE';
const $83cf706a87a62789$export$7dc711c48e3c938f = 'command.issue.FETCH_HISTORICAL_DONE_ISSUES';
const $83cf706a87a62789$export$563a5374cb06df7d = 'command.issue.HANDLE_COMMIT_RESPONSE';
const $83cf706a87a62789$export$35cae9f1acacb606 = 'command.issue.REMOVE_SELECTED_ISSUES';
const $83cf706a87a62789$export$b6c322dbc4f2f8ac = 'command.issue.BULK_ISSUES_UPDATE';
const $83cf706a87a62789$export$4c343341eb9052e8 = 'command.issue.BULK_ISSUES_CPR_UPDATE';
const $83cf706a87a62789$export$85b6c4937eed754f = 'command.issue.BULK_RANK_ISSUES';
const $83cf706a87a62789$export$20130dbd048fc414 = 'command.issue.EXPAND_ALL_ANALYTICS_ACTION';
const $83cf706a87a62789$export$39babeb2e7944629 = 'command.issue.COLLAPSE_ALL_ANALYTICS_ACTION';
const $83cf706a87a62789$export$15027aa3e935638c = 'command.issue.FAIL_COMMIT_REQUEST';
const $83cf706a87a62789$export$868e118e8d9234f = 'command.issue.REFRESH_SUBTASK';
const $83cf706a87a62789$export$d8ee766aa26c1e82 = 'DESCRIPTION_FETCH_ERROR';



parcelRegister("7QdY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f872ed572aaba53$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f872ed572aaba53$export$2e2bcd8739ae039 = (state)=>({
        showRolledUpEstimate: (0, $9H2AP.getShowRolledUpOthers)(state)
    });

});

parcelRegister("2LimL", function(module, exports) {

$parcel$export(module.exports, "MIN_SELECT_WIDTH", () => $3084f9d59f80b590$export$c5e8dc4078d1dc65);
$parcel$export(module.exports, "SelectForColumnCell", () => $3084f9d59f80b590$export$6385b193dd4b511d);
$parcel$export(module.exports, "default", () => $3084f9d59f80b590$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncSelect", () => $3084f9d59f80b590$export$aca05dd54e009a80);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
var $5JgJ2 = parcelRequire("5JgJ2");

var $fm9CZ = parcelRequire("fm9CZ");
var $fmBR7 = parcelRequire("fmBR7");
var $akSC8 = parcelRequire("akSC8");
parcelRequire("cwMfk");
var $lxd1S = parcelRequire("lxd1S");

var $1ni3W = parcelRequire("1ni3W");

var $1UYJl = parcelRequire("1UYJl");
const $3084f9d59f80b590$export$c5e8dc4078d1dc65 = 300;
function $3084f9d59f80b590$export$ef9b1a59e592288f({ noOptionsMessage: noOptionsMessage, ...props }) {
    const intl = (0, $5JgJ2.default)();
    const selectProps = {
        ...props,
        noOptionsMessage: noOptionsMessage || (()=>intl.formatMessage({
                ...(0, $1UYJl.default).noMatchesText
            }))
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $akSC8.Select), selectProps);
}
function $3084f9d59f80b590$var$AsyncSelectWrapper(props) {
    const { intl: intl, noOptionsMessage: noOptionsMessage = ()=>intl.formatMessage({
            ...(0, $1UYJl.default).noMatchesText
        }), ...restProps } = props;
    const selectProps = {
        ...restProps,
        noOptionsMessage: noOptionsMessage
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), selectProps);
}
class $3084f9d59f80b590$export$6385b193dd4b511d extends (0, $eUqFw.Component) {
    componentWillUnmount() {
        if (this.props.issueId === (0, $lxd1S.INLINE_CREATE_ID)) this.props.lockInlineCreate(false);
    }
    render() {
        const { issueId: issueId, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, attribute: attribute, lockInlineCreate: lockInlineCreate, styles: styles, placeholder: placeholder, ...selectProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: this.setHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3084f9d59f80b590$export$ef9b1a59e592288f, {
            menuPlacement: "auto",
            menuPortalTarget: (0, $1ni3W.getBody)(),
            minSelectWidth: $3084f9d59f80b590$export$c5e8dc4078d1dc65,
            onMenuClose: this.onMenuClose,
            onMenuOpen: this.onMenuOpen,
            scrollLock: true,
            placeholder: this.state.placeholder,
            styles: {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                placeholder: (styles)=>({
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        ...styles
                    }),
                ...styles
            },
            ...selectProps
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            // note: showPlaceholder is only used for VR test purposes in order to take a snapshot of the picklist placeholder
            isHovered: this.props.showPlaceholder || false,
            placeholder: ''
        };
        // eslint-disable-next-line react/sort-comp
        this.setHovered = (isHovered)=>this.setState({
                isHovered: isHovered
            });
        this.onMenuOpen = ()=>{
            if (this.props.issueId === (0, $lxd1S.INLINE_CREATE_ID)) this.props.lockInlineCreate(true);
            this.setState({
                placeholder: this.props.placeholder ?? ''
            });
            if (this.props.onMenuOpen) this.props.onMenuOpen();
        };
        this.onMenuClose = ()=>{
            if (this.props.issueId === (0, $lxd1S.INLINE_CREATE_ID)) this.props.lockInlineCreate(false);
            this.setState({
                placeholder: ''
            });
            if (this.props.onMenuClose) this.props.onMenuClose();
        };
    }
}
var $3084f9d59f80b590$export$2e2bcd8739ae039 = $3084f9d59f80b590$export$ef9b1a59e592288f;
const $3084f9d59f80b590$export$aca05dd54e009a80 = (0, $2qhQi.default)($3084f9d59f80b590$var$AsyncSelectWrapper);

});
parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = (0, $5FjBr.default)((0, $hgTYM.default));

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});
parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("fmBR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff42c7cd5c55498e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
class $ff42c7cd5c55498e$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.node = this.getDomNode();
        this.node.addEventListener('mouseenter', this.onMouseEnter);
        this.node.addEventListener('mouseleave', this.onMouseLeave);
    }
    componentWillUnmount() {
        if (this.node) {
            this.node.removeEventListener('mouseenter', this.onMouseEnter);
            this.node.removeEventListener('mouseleave', this.onMouseLeave);
        }
    }
    getDomNode() {
        // findDOMNode is discouraged but is sometimes the best way to implement behavior-based
        // higher order components. See https://github.com/yannickcr/eslint-plugin-react/issues/678#issuecomment-238090846
        // In this case we can't just use a ref from the child, because the child may not be an HTML element, and thus the
        // ref won't point to a DOM node.
        // eslint-disable-next-line react/no-find-dom-node
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this);
        if (!(node instanceof Element)) throw new Error('Only plain DOM elements could be observed');
        return node;
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.node = null;
        this.onMouseEnter = ()=>{
            this.props.onHoverChanged(true);
        };
        this.onMouseLeave = ()=>{
            this.props.onHoverChanged(false);
        };
    }
}

});

parcelRegister("akSC8", function(module, exports) {

$parcel$export(module.exports, "selectUtils", () => $27ec640c17dce629$export$9fd93ba4d7fb167b);
$parcel$export(module.exports, "selectOptionWithAvatar", () => $27ec640c17dce629$export$645b47931df64cd);
$parcel$export(module.exports, "selectIssueOption", () => $27ec640c17dce629$export$a9d867c834fa6cc9);
$parcel$export(module.exports, "injectMouseOverStyles", () => $27ec640c17dce629$export$cba7cac47550e20c);
$parcel$export(module.exports, "Select", () => $27ec640c17dce629$export$ef9b1a59e592288f);
$parcel$export(module.exports, "AkSelect", () => (parcelRequire("5wCDk")).default);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $fm9CZ = parcelRequire("fm9CZ");
var $bVKeg = parcelRequire("bVKeg");
var $jvznW = parcelRequire("jvznW");
var $jQxSL = parcelRequire("jQxSL");
var $28t3A = parcelRequire("28t3A");
var $cEc3i = parcelRequire("cEc3i");
var $5wCDk = parcelRequire("5wCDk");
var $l44HT = parcelRequire("l44HT");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $g4Vkx = parcelRequire("g4Vkx");

var $7Mdad = parcelRequire("7Mdad");

var $g7yd7 = parcelRequire("g7yd7");

var $bpQNu = parcelRequire("bpQNu");
const $27ec640c17dce629$export$9fd93ba4d7fb167b = {
    createFilter: (0, $cEc3i.c)
};
const $27ec640c17dce629$export$645b47931df64cd = ({ icon: icon, label: label })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bpQNu["select-option"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bpQNu.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: icon,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bpQNu.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $bpQNu.truncated
    }, label)));
const $27ec640c17dce629$export$a9d867c834fa6cc9 = ({ icon: icon, label: label })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bpQNu["select-option"]
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bpQNu["issue-icon"],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundSize: 'contain',
            backgroundImage: `url(${icon})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$bpQNu["issue-summary"]} ${$bpQNu.truncated}`
    }, label));
const $27ec640c17dce629$export$cba7cac47550e20c = (styles, shouldInjectMouseOverStyles, isFocused, isTransparentBackground)=>{
    const mouseOver = {
        backgroundColor: (0, $g4Vkx.default).N20_TRANSPARENT,
        borderColor: (0, $g4Vkx.default).N20_TRANSPARENT
    };
    const resultStyles = {
        ...styles,
        ':hover': shouldInjectMouseOverStyles ? {
            ...styles[':hover'],
            ...mouseOver
        } : styles[':hover']
    };
    if (isTransparentBackground) return {
        ...resultStyles,
        backgroundColor: isFocused ? styles.backgroundColor : 'transparent',
        borderColor: isFocused ? styles.borderColor : 'transparent'
    };
    return resultStyles;
};
class $27ec640c17dce629$export$ef9b1a59e592288f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isTransparentBackground: true,
            menuIsOpen: false,
            placeholder: '',
            scrollLock: false,
            isCreatable: false
        };
    }
    static{
        // eslint-disable-next-line react/sort-comp
        this.createFilter = (0, $cEc3i.c);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.menuIsOpen !== this.props.menuIsOpen) this.setState({
            menuIsOpen: nextProps.menuIsOpen
        });
    }
    render() {
        const { components: // eslint-disable-next-line @typescript-eslint/no-shadow
        components = {}, isDisabled: isDisabled, isSearchable: isSearchable, isTransparentBackground: isTransparentBackground, minSelectWidth: minSelectWidth, placeholder: placeholder, scrollLock: scrollLock, styles: // eslint-disable-next-line @typescript-eslint/no-shadow
        styles, isCreatable: isCreatable } = this.props;
        const { menuIsOpen: menuIsOpen } = this.state;
        const customStyles = {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            container: (styles)=>({
                    ...styles,
                    width: '100%',
                    height: '100%',
                    // need this padding otherwise the select overlaps with the border on the timeline fields
                    paddingRight: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? undefined : '1px'
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            control: (styles, state)=>{
                const { isFocused: isFocused } = state;
                const resultStyles = $27ec640c17dce629$export$cba7cac47550e20c(styles, !isFocused, isFocused, !!isTransparentBackground);
                if (isTransparentBackground) return {
                    ...resultStyles,
                    padding: 0,
                    flexWrap: 'nowrap'
                };
                return resultStyles;
            },
            // eslint-disable-next-line @typescript-eslint/no-shadow
            groupHeading: (styles, state)=>({
                    ...styles,
                    fontWeight: 'bold',
                    fontSize: '11px',
                    color: `var(--ds-text-subtlest, ${(0, $g4Vkx.default).N200})`,
                    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
                    display: state.data.label ? 'block' : 'none'
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            menu: (styles)=>{
                // when min-width for select is defined we need to avoid hiding dropdown behind right border of the screen
                if (minSelectWidth) {
                    const { left: left = 0 } = this.ref && this.ref.getBoundingClientRect() || {};
                    return {
                        ...styles,
                        minWidth: minSelectWidth,
                        right: left + minSelectWidth > window.innerWidth ? 0 : 'auto'
                    };
                }
                return styles;
            },
            // eslint-disable-next-line @typescript-eslint/no-shadow
            menuPortal: (styles)=>({
                    ...styles,
                    zIndex: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? (0, $lcnyw.layers).dialog() : 10
                })
        };
        const SelectComponent = isCreatable ? (0, $28t3A.default) : (0, $5wCDk.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: (node)=>{
                if (node) this.ref = node;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Mdad.default), {
            enabled: scrollLock && menuIsOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            ...this.props,
            // Input props file (node_modules/@types/react-select/src/components/Input.d.ts) was automatically generated and does not contain selectProps, which do exist. Once the component is updated from react-select, the error will be fixed
            // @ts-expect-error - TS2322 - Type '({ className, cx, getStyles, innerRef, isHidden, isDisabled, selectProps, ...props }: InputProps) => JSX.Element' is not assignable to type 'ComponentType<InputProps> | undefined'.
            components: {
                Input: $g7yd7.default,
                ...components
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            styles: {
                ...customStyles,
                ...styles
            },
            menuIsOpen: menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            isSearchable: isSearchable,
            placeholder: !isDisabled && placeholder
        }));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.state = {
            menuIsOpen: this.props.menuIsOpen
        };
        this.handleWindowMouseDown = (e)=>{
            if (!this.state.menuIsOpen) return;
            if (!this.ref) return;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const node = e.target;
            if (this.ref.contains(node) || !node.parentNode) return;
            this.onMenuClose();
        };
        this.onMenuOpen = ()=>{
            window.addEventListener('mousedown', this.handleWindowMouseDown);
            const { onMenuOpen: onMenuOpen } = this.props;
            const { menuIsOpen: menuIsOpen } = this.state;
            if (menuIsOpen) return;
            this.setState({
                menuIsOpen: true
            });
            /* istanbul ignore else */ if (onMenuOpen) onMenuOpen();
        };
        this.onMenuClose = ()=>{
            window.removeEventListener('mousedown', this.handleWindowMouseDown);
            const { onMenuClose: onMenuClose } = this.props;
            this.setState({
                menuIsOpen: false
            });
            /* istanbul ignore else */ if (onMenuClose) onMenuClose();
        };
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        };
        this.onFocus = (e)=>{
            const { onFocus: onFocus } = this.props;
            if (onFocus) onFocus(e);
        };
    }
}

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $hSJ9G = parcelRequire("hSJ9G");

var $PdmhA = parcelRequire("PdmhA");
function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $PdmhA.B400})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B75})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N20A})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B75})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $PdmhA.B75})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B300})`;
    else if (isFocused) return `var(--ds-surface, ${0, $PdmhA.N0})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-background-neutral, ${0, $PdmhA.N0})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $PdmhA.B400})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $PdmhA.N0})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B400})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N100})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B400})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B400})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $PdmhA.N100})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-border-input, ${0, $PdmhA.N100})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "zlggru",
    styles: "align-items:center;display:flex ;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-width:var(--ds-border-width, 1px);stroke-linejoin:round;}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "6gb5tk",
    styles: "text-overflow:ellipsis;overflow-x:hidden;flex-grow:1;white-space:nowrap"
};
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            })
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});


parcelRegister("jvznW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632e850af918cb2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $bVKeg = parcelRequire("bVKeg");
const $a632e850af918cb2$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $bVKeg.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $a632e850af918cb2$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($a632e850af918cb2$var$CheckboxSelectInternal);
var $a632e850af918cb2$export$2e2bcd8739ae039 = $a632e850af918cb2$var$CheckboxSelect;

});
parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = undefined;
const $eb73e877c5661200$var$packageVersion = undefined;
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});



parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
var $2ab404645f53318b$export$2e2bcd8739ae039 = (0, $5FjBr.default)((0, $lOwgQ.default));

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});
parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $7ldaw = parcelRequire("7ldaw");

var $bKJfr = parcelRequire("bKJfr");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.openMenu('first') : this.selectRef.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $5wCDk.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, {
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    onMenuClose: ()=>{
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        props.onMenuClose?.();
                    },
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "1sujbl1",
    styles: "margin-inline-end:var(--ds-space-025, 2px);text-align:center;width:32px"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});



parcelRegister("7Mdad", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69fe9649ddc2665$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $1b8g7 = parcelRequire("1b8g7");

var $a7B0o = parcelRequire("a7B0o");
const $c69fe9649ddc2665$var$ScrollLock = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition'), (0, $1b8g7.default), (0, $a7B0o.default));
var $c69fe9649ddc2665$export$2e2bcd8739ae039 = $c69fe9649ddc2665$var$ScrollLock;

});
parcelRegister("1b8g7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d0a219d09e0429$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

/**
 * Lock/unlock scroll to support `position: fixed` hack.
 * This hack is used to prevent popup clipping in components like DatePicker or SingleSelect
 * when they have ancestors with `overflow: hidden` and `position: absolute`.
 * `position: fixed` allows to ignore such container boundaries (not always though), but pins popup
 * to the same position during scroll which breaks UX.
 * By locking scroll when popup is visible we partially mitigate this problem.
 */ const $f8d0a219d09e0429$var$getLockableScrollAreas = ()=>document.querySelectorAll('[data-scroll="lockable"]');
const $f8d0a219d09e0429$var$lockCounts = {
    horizontal: 0,
    vertical: 0
};
function $f8d0a219d09e0429$export$db7b55565b101966(axis = (0, $0458f03c16ac5ddf$export$61b49a5ae59d663)) {
    switch(axis){
        case 0, $0458f03c16ac5ddf$export$f318c07624159aa0:
            return $f8d0a219d09e0429$var$lockCounts.horizontal > 0;
        case 0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea:
            return $f8d0a219d09e0429$var$lockCounts.vertical > 0;
        default:
            return $f8d0a219d09e0429$var$lockCounts.horizontal > 0 || $f8d0a219d09e0429$var$lockCounts.vertical > 0;
    }
}
function $f8d0a219d09e0429$export$5cfba70f0315a03f(axis) {
    const nodes = $f8d0a219d09e0429$var$getLockableScrollAreas();
    const lockHorizontal = axis === (0, $0458f03c16ac5ddf$export$f318c07624159aa0) || axis === (0, $0458f03c16ac5ddf$export$61b49a5ae59d663);
    const lockVertical = axis === (0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea) || axis === (0, $0458f03c16ac5ddf$export$61b49a5ae59d663);
    if (lockHorizontal) $f8d0a219d09e0429$var$lockCounts.horizontal++;
    if (lockVertical) $f8d0a219d09e0429$var$lockCounts.vertical++;
    Array.from(nodes).forEach((node)=>{
        // eslint-disable-next-line no-param-reassign
        if ($f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$f318c07624159aa0))) node.style.overflowX = 'hidden';
        // eslint-disable-next-line no-param-reassign
        if ($f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea))) node.style.overflowY = 'hidden';
    });
}
function $f8d0a219d09e0429$export$bf957eb8a462d4f3(axis) {
    const nodes = $f8d0a219d09e0429$var$getLockableScrollAreas();
    const unlockHorizontal = axis === (0, $0458f03c16ac5ddf$export$f318c07624159aa0) || axis === (0, $0458f03c16ac5ddf$export$61b49a5ae59d663);
    const unlockVertical = axis === (0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea) || axis === (0, $0458f03c16ac5ddf$export$61b49a5ae59d663);
    if ($f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$f318c07624159aa0)) && unlockHorizontal) $f8d0a219d09e0429$var$lockCounts.horizontal--;
    if ($f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea)) && unlockVertical) $f8d0a219d09e0429$var$lockCounts.vertical--;
    Array.from(nodes).forEach((node)=>{
        // eslint-disable-next-line no-param-reassign
        if (!$f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$f318c07624159aa0))) node.style.overflowX = 'auto';
        // eslint-disable-next-line no-param-reassign
        if (!$f8d0a219d09e0429$export$db7b55565b101966((0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea))) node.style.overflowY = 'auto';
    });
}
const $f8d0a219d09e0429$var$useScrollLock = (axis, enabled)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (enabled) {
            $f8d0a219d09e0429$export$5cfba70f0315a03f(axis);
            return ()=>$f8d0a219d09e0429$export$bf957eb8a462d4f3(axis);
        }
    }, [
        axis,
        enabled
    ]);
};
const $f8d0a219d09e0429$var$ScrollLock = ({ children: children = null, axis: axis = (0, $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea), enabled: enabled = true })=>{
    $f8d0a219d09e0429$var$useScrollLock(axis, enabled);
    return children;
};
var $f8d0a219d09e0429$export$2e2bcd8739ae039 = $f8d0a219d09e0429$var$ScrollLock;

});
const $0458f03c16ac5ddf$export$f318c07624159aa0 = 'horizontal';
const $0458f03c16ac5ddf$export$9f2fe7df0ae9fdea = 'vertical';
const $0458f03c16ac5ddf$export$61b49a5ae59d663 = 'all';


parcelRegister("a7B0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60d4629c0223f02$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Lock/unlock scroll to support `position: fixed` hack.
 * This hack is used to prevent popup clipping in components like DatePicker or SingleSelect
 * when they have ancestors with `overflow: hidden` and `position: absolute`.
 * `position: fixed` allows to ignore such container boundaries (not always though), but pins popup
 * to the same position during scroll which breaks UX.
 * By locking scroll when popup is visible we partially mitigate this problem.
 */ const $e60d4629c0223f02$var$getLockableScrollAreas = ()=>document.querySelectorAll('[data-scroll="lockable"]');
let $e60d4629c0223f02$var$lockCount = 0;
function $e60d4629c0223f02$export$5cfba70f0315a03f() {
    const nodes = $e60d4629c0223f02$var$getLockableScrollAreas();
    $e60d4629c0223f02$var$lockCount++;
    Array.from(nodes).forEach((node)=>{
        // eslint-disable-next-line no-param-reassign
        node.style.overflowY = 'hidden';
    });
}
function $e60d4629c0223f02$export$bf957eb8a462d4f3() {
    const nodes = $e60d4629c0223f02$var$getLockableScrollAreas();
    if ($e60d4629c0223f02$var$lockCount > 0) $e60d4629c0223f02$var$lockCount--;
    if ($e60d4629c0223f02$var$lockCount === 0) Array.from(nodes).forEach((node)=>{
        // eslint-disable-next-line no-param-reassign
        node.style.overflowY = 'auto';
    });
}
function $e60d4629c0223f02$export$db7b55565b101966() {
    return $e60d4629c0223f02$var$lockCount > 0;
}
const $e60d4629c0223f02$var$useScrollLock = (enabled)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (enabled) {
            $e60d4629c0223f02$export$5cfba70f0315a03f();
            return $e60d4629c0223f02$export$bf957eb8a462d4f3;
        }
    }, [
        enabled
    ]);
};
const $e60d4629c0223f02$var$ScrollLock = ({ children: children = null, enabled: enabled = true })=>{
    $e60d4629c0223f02$var$useScrollLock(enabled);
    return children;
};
var $e60d4629c0223f02$export$2e2bcd8739ae039 = $e60d4629c0223f02$var$ScrollLock;

});


parcelRegister("g7yd7", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ceed1beda45f11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
const $31ceed1beda45f11$var$inputStyle = (isHidden)=>({
        background: 0,
        border: 0,
        fontSize: 'inherit',
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: 'inherit',
        boxSizing: 'content-box',
        width: '100%'
    });
const $31ceed1beda45f11$var$Input = ({ className: className, cx: cx, getStyles: getStyles, innerRef: innerRef, isHidden: isHidden, isDisabled: isDisabled, selectProps: /** This property gets passed to our Input component by atlaskit when it doesn't understand the
	 *  the property. We don't need this property for Input, it is only used the select component
	 *  So we are removing it.
	 */ selectProps, ...props })=>{
    /* Not all the props forward from select are valid HTML attributes.
	 * When forwarded to the DOM, these cause warnings in the console.
	 */ const { isMulti: isMulti, isRtl: isRtl, hasValue: hasValue, setValue: setValue, getValue: getValue, clearValue: clearValue, selectOption: selectOption, ...validHTMLProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...getStyles('input', props),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gridTemplateColumns: 'unset'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        // if the menu is open so should autofocus,if the menu is closed but there are some value need to autofocus too
        autoFocus: !$b3iuB.default(selectProps.value) && selectProps.menuIsOpen,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: cx(null, {
            input: true
        }, className),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $31ceed1beda45f11$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...validHTMLProps,
        "aria-describedby": selectProps['aria-describedby']
    }));
};
var $31ceed1beda45f11$export$2e2bcd8739ae039 = $31ceed1beda45f11$var$Input;

});

parcelRegister("bpQNu", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $84fafbec24d28611$export$345c5736c8054f22, (v) => $84fafbec24d28611$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "issue-icon", () => $84fafbec24d28611$export$39bed5d6a23c78de, (v) => $84fafbec24d28611$export$39bed5d6a23c78de = v);
$parcel$export(module.exports, "issue-summary", () => $84fafbec24d28611$export$ace0486c2e1c4abe, (v) => $84fafbec24d28611$export$ace0486c2e1c4abe = v);
$parcel$export(module.exports, "label", () => $84fafbec24d28611$export$1237798dc640739a, (v) => $84fafbec24d28611$export$1237798dc640739a = v);
$parcel$export(module.exports, "select-option", () => $84fafbec24d28611$export$25439fa9d099d50b, (v) => $84fafbec24d28611$export$25439fa9d099d50b = v);
$parcel$export(module.exports, "truncated", () => $84fafbec24d28611$export$23ef198012fb7186, (v) => $84fafbec24d28611$export$23ef198012fb7186 = v);
var $84fafbec24d28611$export$345c5736c8054f22;
var $84fafbec24d28611$export$39bed5d6a23c78de;
var $84fafbec24d28611$export$ace0486c2e1c4abe;
var $84fafbec24d28611$export$1237798dc640739a;
var $84fafbec24d28611$export$25439fa9d099d50b;
var $84fafbec24d28611$export$23ef198012fb7186;
$84fafbec24d28611$export$345c5736c8054f22 = `BubBCW_avatar`;
$84fafbec24d28611$export$39bed5d6a23c78de = `BubBCW_issue-icon`;
$84fafbec24d28611$export$ace0486c2e1c4abe = `BubBCW_issue-summary`;
$84fafbec24d28611$export$1237798dc640739a = `BubBCW_label`;
$84fafbec24d28611$export$25439fa9d099d50b = `BubBCW_select-option`;
$84fafbec24d28611$export$23ef198012fb7186 = `BubBCW_truncated`;

});


parcelRegister("1ni3W", function(module, exports) {

$parcel$export(module.exports, "getBody", () => $b0f61f0458ffcc58$export$135b49d4bc2964c6);
$parcel$export(module.exports, "removeNode", () => $b0f61f0458ffcc58$export$1d0aa160432dfea5);
$parcel$export(module.exports, "getViewportSize", () => $b0f61f0458ffcc58$export$125915cfb610b3c2);
const $b0f61f0458ffcc58$export$135b49d4bc2964c6 = ()=>{
    const body = document.body;
    if (!body) throw new Error('document body is not found');
    return body;
};
const $b0f61f0458ffcc58$export$1d0aa160432dfea5 = (node)=>{
    if (node.parentNode) node.parentNode.removeChild(node);
};
const $b0f61f0458ffcc58$export$125915cfb610b3c2 = ()=>{
    let width = 0;
    let height = 0;
    if (window.innerWidth !== undefined && window.innerHeight !== undefined) {
        width = Math.max(width, window.innerWidth);
        height = Math.max(height, window.innerHeight);
    }
    if (document.documentElement) {
        const { clientWidth: clientWidth, clientHeight: clientHeight } = document.documentElement;
        width = Math.max(width, clientWidth);
        height = Math.max(height, clientHeight);
    }
    return {
        width: width,
        height: height
    };
};

});

parcelRegister("1UYJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $aec915d831a70183$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aec915d831a70183$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatchesText: {
        "id": "portfolio-3-portfolio.common.select.no-matches-text",
        "defaultMessage": "No matches"
    },
    rolledUpValueLabel: {
        "id": "portfolio-3-portfolio.common.select.rolled-up-value-label",
        "defaultMessage": "Rolled-up values"
    },
    releaseActualValueLabel: {
        "id": "portfolio-3-portfolio.common.select.release-actual-value-label",
        "defaultMessage": "Release of this issue"
    },
    sprintActualValueLabel: {
        "id": "portfolio-3-portfolio.common.select.sprint-actual-value-label",
        "defaultMessage": "Sprint of this issue"
    },
    teamActualValueLabel: {
        "id": "portfolio-3-portfolio.common.select.team-actual-value-label",
        "defaultMessage": "Team of this issue"
    }
});

});


parcelRegister("jOSAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e17d24904a46dac2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jQxSL = parcelRequire("jQxSL");
var $gwbfD = parcelRequire("gwbfD");

var $a4vO3 = parcelRequire("a4vO3");

var $8V0HQ = parcelRequire("8V0HQ");

var $fztAU = parcelRequire("fztAU");

var $1UYJl = parcelRequire("1UYJl");
const $e17d24904a46dac2$var$SelectWithRollup = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})((props)=>{
    const { rolledUpValues: rolledUpValues, showRolledUpEstimate: showRolledUpEstimate, FieldSelect: FieldSelect, attribute: attribute, value: value, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose } = props;
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const getToolTipContent = ()=>{
        let actualValue;
        if (Array.isArray(value)) actualValue = value.map((option)=>option.label).join(', ');
        else actualValue = value ? String(value.label || '') : '';
        if (!(showRolledUpEstimate && rolledUpValues && rolledUpValues.length > 0 && !menuIsOpen)) {
            if (`${actualValue}`.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, actualValue);
            return null;
        }
        const rolledUpValuesStr = rolledUpValues ? rolledUpValues.join(', ') : '';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const label = `${attribute}ActualValueLabel`;
        const actualValueTooltipLabel = intl.formatMessage((0, $1UYJl.default)[label]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, `${actualValue}`.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, ' ', actualValueTooltipLabel, ": ", actualValue, ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $1UYJl.default).rolledUpValueLabel), ": ", rolledUpValuesStr));
    };
    const handleMenuOpen = (0, $eUqFw.useCallback)(()=>{
        setMenuIsOpen(true);
        if (onMenuOpen) onMenuOpen();
    }, [
        onMenuOpen
    ]);
    const handleMenuClose = (0, $eUqFw.useCallback)(()=>{
        setMenuIsOpen(false);
        if (onMenuClose) onMenuClose();
    }, [
        onMenuClose
    ]);
    const selectProps = (()=>{
        const { onMenuOpen: // eslint-disable-next-line @typescript-eslint/no-shadow
        onMenuOpen, onMenuClose: // eslint-disable-next-line @typescript-eslint/no-shadow
        onMenuClose, rolledUpValues: // eslint-disable-next-line @typescript-eslint/no-shadow
        rolledUpValues, showRolledUpEstimate: // eslint-disable-next-line @typescript-eslint/no-shadow
        showRolledUpEstimate, FieldSelect: // eslint-disable-next-line @typescript-eslint/no-shadow
        FieldSelect, // eslint-disable-next-line @typescript-eslint/no-shadow
        ...selectProps } = props;
        return selectProps;
    })();
    const ValueContainer = (0, $eUqFw.useCallback)(({ children: children, ...innerProps })=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const value = innerProps.selectProps.value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; isCreatable?: boolean | undefined; "aria-label"?: string | undefined; autoFocus?: boolean | undefined; blurInputOnSelect?: boolean | undefined; closeMenuOnSelect?: boolean | undefined; ... 36 more ...; onCreateOption?: ((inputValue: string) => void) | undefined; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 6 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, innerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8V0HQ.default), {
            menuIsOpen: innerProps.selectProps.menuIsOpen,
            isDisabled: innerProps.selectProps.isDisabled,
            showRollup: showRolledUpEstimate && rolledUpValues && rolledUpValues.length > 0,
            isMultiSelect: innerProps.selectProps.isMulti,
            rolledUpValues: rolledUpValues,
            withValue: Array.isArray(value) ? !$b3iuB.default(value) : !!value
        }, children)));
    }, [
        rolledUpValues,
        showRolledUpEstimate
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$fztAU.selectRollupContainer} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: getToolTipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, {
        onMenuOpen: handleMenuOpen,
        onMenuClose: handleMenuClose,
        ...selectProps,
        styles: {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            multiValueLabel: (styles)=>({
                    ...styles,
                    minWidth: 'auto',
                    maxWidth: '240px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    height: '18px',
                    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                    fontSize: '14px',
                    lineHeight: '14px',
                    paddingLeft: "var(--ds-space-050, 4px)",
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            valueContainer: (styles)=>({
                    ...styles,
                    flexWrap: 'nowrap'
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            singleValue: (styles)=>({
                    ...styles,
                    ...menuIsOpen ? {} : {
                        top: 0,
                        transform: 'none',
                        position: 'relative'
                    }
                }),
            input: ()=>({
                    flex: selectProps.isMulti && menuIsOpen ? '1 1 auto' : '1 1 0'
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            multiValueRemove: (styles, state)=>({
                    ...styles,
                    display: state.selectProps.menuIsOpen ? 'flex' : 'none'
                }),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            clearIndicator: (styles, state)=>({
                    ...styles,
                    display: state.selectProps.menuIsOpen ? 'flex' : 'none'
                }),
            container: (styles, { selectProps: { menuIsOpen: menuIsOpen, isMulti: isMulti } })=>({
                    ...styles,
                    ...menuIsOpen && isMulti ? {
                        zIndex: 1
                    } : {}
                }),
            control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen, isMulti: isMulti } })=>menuIsOpen && isMulti ? {
                    ...styles,
                    zIndex: 99999
                } : {
                    ...styles,
                    background: 'none',
                    borderColor: 'transparent',
                    // eslint-disable-next-line no-useless-computed-key
                    [':hover']: {
                        ...styles[':hover'],
                        background: 'none',
                        ...hasValue ? {
                            borderColor: 'transparent'
                        } : {}
                    }
                }
        },
        components: {
            ...selectProps.components,
            ValueContainer: ValueContainer
        }
    }))));
});
var $e17d24904a46dac2$export$2e2bcd8739ae039 = $e17d24904a46dac2$var$SelectWithRollup;

});
parcelRegister("a4vO3", function(module, exports) {

$parcel$export(module.exports, "slots", () => $e8b79d8e4d37977a$export$bbd679b9fab4c947);
$parcel$export(module.exports, "provideComponents", () => $e8b79d8e4d37977a$export$bf97b3f3c826d1af);
$parcel$export(module.exports, "withSlots", () => $e8b79d8e4d37977a$export$bb4665f044311879);

var $eUqFw = parcelRequire("eUqFw");
const $e8b79d8e4d37977a$export$bbd679b9fab4c947 = {};
const $e8b79d8e4d37977a$export$f0b2358e80e9bcad = [
    'FieldComponents',
    'FieldDatePicker',
    'CellSelectWithRollup',
    'CellTextField',
    'FieldMultiSelectCell',
    'FieldSelect',
    'FieldPrioritySelect',
    'AdvancedFieldsMenu',
    'FilterDependencyGraphFromRoadmap',
    'QuickFilter',
    'IssueSearchWarningClearFilter',
    'NowLine',
    'UserPicker',
    'FieldUserAvatarCell'
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
const $e8b79d8e4d37977a$var$contexts = {};
$e8b79d8e4d37977a$export$f0b2358e80e9bcad.forEach((slotName)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const context = /*#__PURE__*/ (0, $eUqFw.createContext)(()=>null);
    $e8b79d8e4d37977a$var$contexts[slotName] = context;
    $e8b79d8e4d37977a$export$bbd679b9fab4c947[slotName] = slotName;
});
function $e8b79d8e4d37977a$export$bf97b3f3c826d1af(// eslint-disable-next-line @typescript-eslint/no-shadow
slots) {
    return (WrappedComponent)=>function ComponentSlotsContentsProvider(props) {
            // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
            let acc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            for (const slotName of Object.keys(slots)){
                if (!$e8b79d8e4d37977a$export$f0b2358e80e9bcad.includes(slotName)) throw new TypeError(`slot with name ${slotName} not supported`);
                const { Provider: Provider } = $e8b79d8e4d37977a$var$contexts[slotName];
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                acc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Provider, {
                    value: slots[slotName]
                }, acc);
            }
            return acc;
        };
}
function $e8b79d8e4d37977a$export$bb4665f044311879(slotsByProps) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function HoC(props) {
            const render = Object.entries(slotsByProps).reduce((acc, [propName, slotName])=>{
                if (typeof slotName !== 'string') throw new TypeError('slotName must be string');
                if (!$e8b79d8e4d37977a$export$f0b2358e80e9bcad.includes(slotName)) throw new TypeError(`slot with name ${slotName} not supported`);
                const { Consumer: Consumer } = $e8b79d8e4d37977a$var$contexts[slotName];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (injecting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Consumer, null, (Slot)=>acc({
                            ...injecting,
                            [propName]: Slot
                        }));
            }, (injecting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...props,
                    ...injecting
                }));
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            return render();
        }
        const compName = WrappedComponent.displayName || WrappedComponent.name || '';
        HoC.displayName = `WithSlots(${compName})`;
        HoC.WrappedComponent = WrappedComponent;
        HoC.slotsByProps = slotsByProps;
        return HoC;
    };
}
function $e8b79d8e4d37977a$export$9203a8e84125433c() {}

});

parcelRegister("8V0HQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a9bba58866e9f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");
parcelRequire("2Bjja");
var $b1b5T = parcelRequire("b1b5T");

var $fztAU = parcelRequire("fztAU");
function $c5a9bba58866e9f7$var$RollupContainer({ showRollup: showRollup, children: children, rolledUpValues: rolledUpValues = [], isDisabled: isDisabled = false, withValue: withValue, readonly: readonly = false, menuIsOpen: menuIsOpen = false, isMultiSelect: isMultiSelect = false }) {
    const styleNameForRollup = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        [$fztAU.rollup]: true,
        [$fztAU.disabledRollup]: isDisabled,
        [$fztAU.onlyRollup]: !withValue && !readonly,
        [$fztAU.onlyRollupReadOnly]: !withValue && readonly
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$fztAU.rollupWrapper} ${isDisabled ? $fztAU.disabledRollupWrapper : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: styleNameForRollup,
        style: {
            display: !showRollup || menuIsOpen ? 'none' : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1b5T.default), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fztAU.rollupValue
    }, rolledUpValues && rolledUpValues.join(', '))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            flexWrap: isMultiSelect && menuIsOpen ? 'wrap' : 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($fztAU.childrenWrapper, {
            [$fztAU.placeholder]: !withValue && showRollup,
            [$fztAU.childrenWrapperWithRollupValue]: rolledUpValues.length > 0 && !menuIsOpen
        })
    }, children)));
}
var $c5a9bba58866e9f7$export$2e2bcd8739ae039 = $c5a9bba58866e9f7$var$RollupContainer;

});
parcelRegister("2Bjja", function(module, exports) {

$parcel$export(module.exports, "SprintIcon", () => (parcelRequire("4JE8j")).default);
$parcel$export(module.exports, "SavedViewIcon", () => (parcelRequire("ffzME")).default);
$parcel$export(module.exports, "RollupIcon", () => (parcelRequire("b1b5T")).default);

var $4JE8j = parcelRequire("4JE8j");

var $ffzME = parcelRequire("ffzME");

var $b1b5T = parcelRequire("b1b5T");

});
parcelRegister("4JE8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bffd7d6c38cd449$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $gFx0N = parcelRequire("gFx0N");
function $6bffd7d6c38cd449$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($gFx0N))),
        ...props
    });
}

});
parcelRegister("gFx0N", function(module, exports) {
module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg width=\"24px\" height=\"24px\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <defs>\n        <path d=\"M0 0h24v24H0V0zm13 14v7h10v-6l-5-5-5 4z\" id=\"a\"></path>\n    </defs>\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0 1)\">\n            <mask id=\"b\" fill=\"#fff\">\n                <use xlink:href=\"#a\"></use>\n            </mask>\n            <g mask=\"url(#b)\" stroke=\"#42526E\" stroke-width=\"2\">\n                <circle cx=\"8.5\" cy=\"8.5\" r=\"7.5\" transform=\"translate(5 1)\"></circle>\n            </g>\n        </g>\n        <path fill=\"#42526E\" d=\"M13 17h7v2h-7z\"></path>\n        <path d=\"M17.293 15.707a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L19.586 18l-2.293-2.293z\" fill=\"#42526E\" fill-rule=\"nonzero\"></path>\n        <path d=\"M5.253 17a10.561 10.561 0 0 0 2.081 2H3a1 1 0 0 1 0-2h2.253z\" fill=\"#42526E\"></path>\n    </g>\n</svg>";

});


parcelRegister("ffzME", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5b40ac7e9f7348$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $2f5b40ac7e9f7348$var$Glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "13",
        height: "3",
        x: "5",
        y: "5",
        fill: "currentColor",
        rx: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "10",
        height: "3",
        x: "10",
        y: "10.5",
        fill: "currentColor",
        rx: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "9",
        height: "3",
        x: "5",
        y: "16",
        fill: "currentColor",
        rx: "1.5"
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f5b40ac7e9f7348$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $2f5b40ac7e9f7348$var$Glyph,
        label: ""
    });

});

parcelRegister("b1b5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9f5172e001b24aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $e9f5172e001b24aa$var$Glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "currentColor",
        d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9f5172e001b24aa$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $e9f5172e001b24aa$var$Glyph,
        ...props
    });

});


parcelRegister("fztAU", function(module, exports) {

$parcel$export(module.exports, "childrenWrapper", () => $b56114b016d471ec$export$976523451128e394, (v) => $b56114b016d471ec$export$976523451128e394 = v);
$parcel$export(module.exports, "childrenWrapperWithRollupValue", () => $b56114b016d471ec$export$6448e42458359282, (v) => $b56114b016d471ec$export$6448e42458359282 = v);
$parcel$export(module.exports, "disabledRollup", () => $b56114b016d471ec$export$8fc2859090092516, (v) => $b56114b016d471ec$export$8fc2859090092516 = v);
$parcel$export(module.exports, "disabledRollupWrapper", () => $b56114b016d471ec$export$5b235e02afd947a8, (v) => $b56114b016d471ec$export$5b235e02afd947a8 = v);
$parcel$export(module.exports, "onlyRollup", () => $b56114b016d471ec$export$7f37be09c0fafa00, (v) => $b56114b016d471ec$export$7f37be09c0fafa00 = v);
$parcel$export(module.exports, "onlyRollupReadOnly", () => $b56114b016d471ec$export$d6c3a1a50fade065, (v) => $b56114b016d471ec$export$d6c3a1a50fade065 = v);
$parcel$export(module.exports, "placeholder", () => $b56114b016d471ec$export$c7187bbd1a7a9244, (v) => $b56114b016d471ec$export$c7187bbd1a7a9244 = v);
$parcel$export(module.exports, "rollup", () => $b56114b016d471ec$export$97e11c0b0230f130, (v) => $b56114b016d471ec$export$97e11c0b0230f130 = v);
$parcel$export(module.exports, "rollupValue", () => $b56114b016d471ec$export$409b770e9b28d1a3, (v) => $b56114b016d471ec$export$409b770e9b28d1a3 = v);
$parcel$export(module.exports, "rollupWrapper", () => $b56114b016d471ec$export$5fb402ec83a32662, (v) => $b56114b016d471ec$export$5fb402ec83a32662 = v);
$parcel$export(module.exports, "selectRollupContainer", () => $b56114b016d471ec$export$c4493537ac0c5f1c, (v) => $b56114b016d471ec$export$c4493537ac0c5f1c = v);
var $b56114b016d471ec$export$976523451128e394;
var $b56114b016d471ec$export$6448e42458359282;
var $b56114b016d471ec$export$8fc2859090092516;
var $b56114b016d471ec$export$5b235e02afd947a8;
var $b56114b016d471ec$export$7f37be09c0fafa00;
var $b56114b016d471ec$export$d6c3a1a50fade065;
var $b56114b016d471ec$export$2c2896b483654bfa;
var $b56114b016d471ec$export$c7187bbd1a7a9244;
var $b56114b016d471ec$export$97e11c0b0230f130;
var $b56114b016d471ec$export$409b770e9b28d1a3;
var $b56114b016d471ec$export$5fb402ec83a32662;
var $b56114b016d471ec$export$c4493537ac0c5f1c;
$b56114b016d471ec$export$976523451128e394 = `pnFITa_childrenWrapper`;
$b56114b016d471ec$export$6448e42458359282 = `pnFITa_childrenWrapperWithRollupValue`;
$b56114b016d471ec$export$8fc2859090092516 = `pnFITa_disabledRollup`;
$b56114b016d471ec$export$5b235e02afd947a8 = `pnFITa_disabledRollupWrapper`;
$b56114b016d471ec$export$7f37be09c0fafa00 = `pnFITa_onlyRollup`;
$b56114b016d471ec$export$d6c3a1a50fade065 = `pnFITa_onlyRollupReadOnly`;
$b56114b016d471ec$export$2c2896b483654bfa = `pnFITa_openedRollup`;
$b56114b016d471ec$export$c7187bbd1a7a9244 = `pnFITa_placeholder`;
$b56114b016d471ec$export$97e11c0b0230f130 = `pnFITa_rollup`;
$b56114b016d471ec$export$409b770e9b28d1a3 = `pnFITa_rollupValue`;
$b56114b016d471ec$export$5fb402ec83a32662 = `pnFITa_rollupWrapper`;
$b56114b016d471ec$export$c4493537ac0c5f1c = `pnFITa_selectRollupContainer`;

});




parcelRegister("8QdsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d657cc3b845377c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $78woL = parcelRequire("78woL");
const $4d657cc3b845377c$var$CustomPopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        className: $78woL["afm-custom-popup-container"]
    }, children), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-role": "afm-dropdown-menu-drag-handle",
        key: "afm-dropdown-menu-drag-handle"
    })));
var $4d657cc3b845377c$export$2e2bcd8739ae039 = $4d657cc3b845377c$var$CustomPopupContainer;

});
parcelRegister("78woL", function(module, exports) {

$parcel$export(module.exports, "afm-custom-popup-container", () => $532269632612eec6$export$c624532f0d686e13, (v) => $532269632612eec6$export$c624532f0d686e13 = v);
var $532269632612eec6$export$c624532f0d686e13;
$532269632612eec6$export$c624532f0d686e13 = `v2i7oq_afm-custom-popup-container`;

});


parcelRegister("51Seq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8e6cad207ce99d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9f8e6cad207ce99d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    advancedFieldsMenuSelectPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-select-placeholder",
        "defaultMessage": "Choose fields..."
    },
    advancedFieldsMenuNoFieldsMatchCriteria: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-no-fields-match-criteria",
        "defaultMessage": "No fields match the search criteria"
    },
    advancedFieldsMenuAllFieldsSelected: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-all-fields-selected",
        "defaultMessage": "All fields have been selected"
    },
    advancedFieldsMenuCustomFieldLozenge: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-custom-field-lozenge",
        "defaultMessage": "CUSTOM"
    },
    advancedFieldsMenuManageCustomFieldsLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-manage-custom-fields-link",
        "defaultMessage": "Manage custom fields"
    },
    advancedFieldsMenuAddFieldTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-add-field-tooltip",
        "defaultMessage": "Add fields"
    },
    advancedFieldsMenuSelectLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.advanced-fields-menu-select-label",
        "defaultMessage": "Select fields"
    }
});

});

parcelRegister("5lbSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9783fff8ce7fbc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");

var $8Itt3 = parcelRequire("8Itt3");

var $dULIU = parcelRequire("dULIU");

var $je5kZ = parcelRequire("je5kZ");

var $lkPEe = parcelRequire("lkPEe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $kYJcj = parcelRequire("kYJcj");
var $gwbfD = parcelRequire("gwbfD");

var $9NSUz = parcelRequire("9NSUz");

var $6EZ9n = parcelRequire("6EZ9n");

var $7cNjm = parcelRequire("7cNjm");

var $aLAUL = parcelRequire("aLAUL");
// @ts-expect-error - TS2345 - Argument of type '({ children }: Props) => React.ReactNode' is not assignable to parameter of type 'WrappedComponent<Props>'.
const $d9783fff8ce7fbc7$var$SortableItem = (0, $8Itt3.SortableElement)(({ children: children })=>children);
// @ts-expect-error - TS2345 - Argument of type '({ children }: { children: any; }) => any' is not assignable to parameter of type 'WrappedComponent<unknown>'.
const $d9783fff8ce7fbc7$var$SortableContainerWrapper = (0, $8Itt3.SortableContainer)(({ children: children })=>children);
const $d9783fff8ce7fbc7$var$AdvancedFieldsMenu = ({ selectedColumns: selectedColumns, getMatchingConfiguredDate: getMatchingConfiguredDate, hideColumn: hideColumn, moveColumn: moveColumn })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [sortingAnnouncement, setSortingAnnouncement] = (0, $eUqFw.useState)('');
    const [sortableInfo, setSortableInfo] = (0, $eUqFw.useState)(null);
    const [initialPosition, setInitialPosition] = (0, $eUqFw.useState)(null);
    const renderCustomFieldLozenge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $aLAUL["afm-custom-field-lozenge"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.custom-lozenge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $7cNjm.default).advancedFieldsMenuCustomFieldLozenge)));
    const renderSelectedFields = (columns)=>(0, $6EZ9n.getListableColumns)(columns).map((group, index)=>{
            const localizedTitle = group[0].localizedTitle;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const columns = $9RbxZ.default($f7Op5.default('id'), group);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const isCustomField = columns.every(({ isCustomField: isCustomField })=>isCustomField);
            const compoundId = columns.map($f7Op5.default('id')).join(':');
            const configurableDate = getMatchingConfiguredDate(compoundId);
            const tooltip = (0, $9NSUz.getConfiguredDateTooltip)(configurableDate);
            return(// @ts-expect-error - TS2322 - Type '{ children: Element; id: string; index: number; key: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Props & SortableElementProps, any, any>> & Readonly<...> & Readonly<...>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9783fff8ce7fbc7$var$SortableItem, {
                id: compoundId,
                index: index,
                key: compoundId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                tabIndex: 0,
                "data-title": localizedTitle,
                id: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}`,
                role: "button",
                "aria-labelledby": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId} portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-a11y-text`,
                "aria-label": localizedTitle,
                key: `item-${localizedTitle}`,
                "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $aLAUL["afm-selected-field-item"],
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $aLAUL["afm-selected-field-item-section"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $7cNjm.default).advancedFieldsMenuSelectedFieldDragTooltip)
            }, (triggerProps)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    ...triggerProps,
                    className: $aLAUL["afm-selected-field-item-drag-icon"]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
                    label: formatMessage((0, $7cNjm.default).advancedFieldsMenuSelectedFieldDragTooltip)
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $aLAUL["afm-selected-field-item-title"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJcj.default), {
                icon: configurableDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}.configurable-date-lozenge`
                }, "D"),
                tooltip: tooltip && formatMessage(tooltip, {
                    title: localizedTitle
                }),
                mode: "inline"
            }, localizedTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $aLAUL["afm-selected-field-item-section"]
            }, isCustomField && renderCustomFieldLozenge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $aLAUL["afm-selected-field-item-remove-icon"],
                "data-drag": "false",
                "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.remove-button",
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-${compoundId}-remove-button`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $7cNjm.default).advancedFieldsMenuSelectedFieldRemoveTooltip)
            }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    spacing: "none",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                        label: ""
                    }),
                    onClick: ()=>{
                        columns.forEach(({ id: id })=>{
                            hideColumn(id);
                        });
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $aLAUL["afm-selected-field-item-remove-icon-button"],
                    "aria-label": formatMessage((0, $7cNjm.default).advancedFieldsMenuSelectedFieldRemoveAriaLabel, {
                        fieldName: localizedTitle
                    }),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.selected-field-remove-button"
                })))))));
        });
    const handleSortStart = (0, $eUqFw.useCallback)((sortStart, event)=>{
        const { node: node, isKeySorting: isKeySorting, index: index } = sortStart;
        const fieldName = node.getAttribute('data-title');
        setSortableInfo(sortStart);
        isKeySorting && setSortingAnnouncement(formatMessage((0, $7cNjm.default).advancedFieldMenuGrabbedFieldAnnouncement, {
            fieldName: fieldName
        }));
        setInitialPosition(index + 1);
        // this workaround prevents text to be selected in the background when dragging fields - see
        // https://github.com/clauderic/react-sortable-hoc/issues/253#issuecomment-350223723
        event.preventDefault();
    }, [
        formatMessage
    ]);
    const handleSortEnd = (sortEnd)=>{
        const { oldIndex: oldIndex, newIndex: newIndex, isKeySorting: isKeySorting, nodes: nodes } = sortEnd;
        const columns = (0, $6EZ9n.getListableColumns)(selectedColumns);
        const columnToMove = columns[oldIndex][0].id;
        const moveToTheIndexOf = columns[newIndex][0].id;
        moveColumn(columnToMove, moveToTheIndexOf);
        // @ts-expect-error Property 'node' does not exist on type 'HTMLElement'.ts(2339)
        const fieldName = nodes[oldIndex].node.getAttribute('data-title');
        const position = newIndex + 1;
        if (isKeySorting && oldIndex !== newIndex) setSortingAnnouncement(formatMessage((0, $7cNjm.default).advancedFieldMenuDroppedFieldAnnouncement, {
            fieldName: fieldName,
            position: position
        }));
        setInitialPosition(null);
        setSortableInfo(null);
    };
    const handleSortMove = (e)=>{
        // @ts-expect-error Property 'ignoreTransition' does not exist on type 'SortEvent'.
        if (sortableInfo && initialPosition && !e.ignoreTransition) {
            const { node: node, helper: helper } = sortableInfo;
            const fieldName = node.getAttribute('data-title');
            const { top: top } = node.getBoundingClientRect();
            const { height: height } = helper.getBoundingClientRect();
            // @ts-expect-error Property 'pageY' does not exist on type 'SortEvent'.
            const currentPosition = Math.ceil(initialPosition + (e.pageY - top) / height);
            setSortingAnnouncement(formatMessage((0, $7cNjm.default).advancedFieldMenuMovedFieldAnnouncement, {
                fieldName: fieldName,
                initialPosition: initialPosition,
                currentPosition: currentPosition
            }));
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldCancelStart = (e)=>// cancel sorting onClick on remove icon to allow click event propagation and the removal of the field
        Boolean(e.target.closest('div[data-drag="false"]'));
    const renderDialogContent = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $aLAUL["afm-dropdown-menu-body"],
            "data-role": "afm-dropdown-menu-body"
        }, selectedColumns.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
            id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.visually-hidden"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
            id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-field-a11y-text"
        }, formatMessage((0, $7cNjm.default).advancedFieldMenuFocusedFieldAnnouncement)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "status",
            "aria-live": "polite",
            "aria-atomic": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: sortingAnnouncement
        }, sortingAnnouncement))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d9783fff8ce7fbc7$var$SortableContainerWrapper, {
            helperClass: $aLAUL["afm-sortable-helper"],
            onSortStart: handleSortStart,
            onSortEnd: handleSortEnd,
            shouldCancelStart: shouldCancelStart,
            lockToContainerEdges: true,
            onSortMove: handleSortMove,
            lockAxis: "y",
            helperContainer: document.querySelector("div[data-role='afm-dropdown-menu-drag-handle']") || undefined,
            // @ts-expect-error - TS2322 - Type '() => Element | null' is not assignable to type 'ContainerGetter'.
            getContainer: ()=>/**
       * The container is explicity given so the menu list would auto-scroll when the user
       * drags an item beyond the current visible items
       */ document.querySelector("div[data-role='afm-dropdown-menu-body']")
        }, renderSelectedFields(selectedColumns))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $aLAUL["afm-no-selected-fields"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.no-selected-field"
        }, formatMessage((0, $7cNjm.default).advancedFieldsMenuNoSelectedFields)));
    return renderDialogContent();
};
var $d9783fff8ce7fbc7$export$2e2bcd8739ae039 = $d9783fff8ce7fbc7$var$AdvancedFieldsMenu;

});
parcelRegister("8Itt3", function(module, exports) {

$parcel$export(module.exports, "SortableContainer", () => $65894a732c14c34f$export$a4b10e5599330dd0);
$parcel$export(module.exports, "SortableElement", () => $65894a732c14c34f$export$58d1e4fb0d207bf7);

var $kU09D = parcelRequire("kU09D");

var $aKcqM = parcelRequire("aKcqM");

var $1o7fk = parcelRequire("1o7fk");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $4mIeV = parcelRequire("4mIeV");

var $i3rTN = parcelRequire("i3rTN");

var $eT4IF = parcelRequire("eT4IF");

var $aCdHv = parcelRequire("aCdHv");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $h8TzT = parcelRequire("h8TzT");

var $fVK4C = parcelRequire("fVK4C");

var $1Qivz = parcelRequire("1Qivz");
var $65894a732c14c34f$var$Manager = function() {
    function Manager() {
        (0, $lDSrn.default)(this, Manager);
        (0, $5zQU9.default)(this, "refs", {});
    }
    (0, $lIEGP.default)(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($65894a732c14c34f$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
function $65894a732c14c34f$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}
function $65894a732c14c34f$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $65894a732c14c34f$var$omit(obj, keysToOmit) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $65894a732c14c34f$var$events = {
    end: [
        'touchend',
        'touchcancel',
        'mouseup'
    ],
    move: [
        'touchmove',
        'mousemove'
    ],
    start: [
        'touchstart',
        'mousedown'
    ]
};
var $65894a732c14c34f$var$vendorPrefix = function() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return '';
    var styles = window.getComputedStyle(document.documentElement, '') || [
        '-moz-hidden-iframe'
    ];
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
        '',
        'o'
    ])[1];
    switch(pre){
        case 'ms':
            return 'ms';
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
    }
}();
function $65894a732c14c34f$var$setInlineStyles(node, styles) {
    Object.keys(styles).forEach(function(key) {
        node.style[key] = styles[key];
    });
}
function $65894a732c14c34f$var$setTranslate3d(node, translate) {
    node.style["".concat($65894a732c14c34f$var$vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function $65894a732c14c34f$var$setTransitionDuration(node, duration) {
    node.style["".concat($65894a732c14c34f$var$vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function $65894a732c14c34f$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
    return null;
}
function $65894a732c14c34f$var$limit(min, max, value1) {
    return Math.max(min, Math.min(value1, max));
}
function $65894a732c14c34f$var$getPixelValue(stringValue) {
    if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
    return 0;
}
function $65894a732c14c34f$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        bottom: $65894a732c14c34f$var$getPixelValue(style.marginBottom),
        left: $65894a732c14c34f$var$getPixelValue(style.marginLeft),
        right: $65894a732c14c34f$var$getPixelValue(style.marginRight),
        top: $65894a732c14c34f$var$getPixelValue(style.marginTop)
    };
}
function $65894a732c14c34f$var$provideDisplayName(prefix, Component$$1) {
    var componentName = Component$$1.displayName || Component$$1.name;
    return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function $65894a732c14c34f$var$getScrollAdjustedBoundingClientRect(node, scrollDelta) {
    var boundingClientRect = node.getBoundingClientRect();
    return {
        top: boundingClientRect.top + scrollDelta.top,
        left: boundingClientRect.left + scrollDelta.left
    };
}
function $65894a732c14c34f$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $65894a732c14c34f$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $65894a732c14c34f$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        left: 0,
        top: 0
    };
    if (!node) return undefined;
    var nodeOffset = {
        left: offset.left + node.offsetLeft,
        top: offset.top + node.offsetTop
    };
    if (node.parentNode === parent) return nodeOffset;
    return $65894a732c14c34f$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function $65894a732c14c34f$var$getTargetIndex(newIndex, prevIndex, oldIndex) {
    if (newIndex < oldIndex && newIndex > prevIndex) return newIndex - 1;
    else if (newIndex > oldIndex && newIndex < prevIndex) return newIndex + 1;
    else return newIndex;
}
function $65894a732c14c34f$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = 'px';
    if (typeof lockOffset === 'string') {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = parseFloat(lockOffset);
        offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
    if (unit === '%') {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}
function $65894a732c14c34f$var$getLockPixelOffsets(_ref2) {
    var height = _ref2.height, width = _ref2.width, lockOffset = _ref2.lockOffset;
    var offsets = Array.isArray(lockOffset) ? lockOffset : [
        lockOffset,
        lockOffset
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
    var _offsets = (0, $aKcqM.default)(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
    return [
        $65894a732c14c34f$var$getLockPixelOffset({
            height: height,
            lockOffset: minLockOffset,
            width: width
        }),
        $65894a732c14c34f$var$getLockPixelOffset({
            height: height,
            lockOffset: maxLockOffset,
            width: width
        })
    ];
}
function $65894a732c14c34f$var$isScrollable(el) {
    var computedStyle = window.getComputedStyle(el);
    var overflowRegex = /(auto|scroll)/;
    var properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.find(function(property) {
        return overflowRegex.test(computedStyle[property]);
    });
}
function $65894a732c14c34f$var$getScrollingParent(el) {
    if (!(el instanceof HTMLElement)) return null;
    else if ($65894a732c14c34f$var$isScrollable(el)) return el;
    else return $65894a732c14c34f$var$getScrollingParent(el.parentNode);
}
function $65894a732c14c34f$var$getContainerGridGap(element) {
    var style = window.getComputedStyle(element);
    if (style.display === 'grid') return {
        x: $65894a732c14c34f$var$getPixelValue(style.gridColumnGap),
        y: $65894a732c14c34f$var$getPixelValue(style.gridRowGap)
    };
    return {
        x: 0,
        y: 0
    };
}
var $65894a732c14c34f$var$KEYCODE = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
var $65894a732c14c34f$var$NodeType = {
    Anchor: 'A',
    Button: 'BUTTON',
    Canvas: 'CANVAS',
    Input: 'INPUT',
    Option: 'OPTION',
    Textarea: 'TEXTAREA',
    Select: 'SELECT'
};
function $65894a732c14c34f$var$cloneNode(node) {
    var selector = 'input, textarea, select, canvas, [contenteditable]';
    var fields = node.querySelectorAll(selector);
    var clonedNode = node.cloneNode(true);
    var clonedFields = (0, $fVK4C.default)(clonedNode.querySelectorAll(selector));
    clonedFields.forEach(function(field, i) {
        if (field.type !== 'file') field.value = fields[i].value;
        if (field.type === 'radio' && field.name) field.name = "__sortableClone__".concat(field.name);
        if (field.tagName === $65894a732c14c34f$var$NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
            var destCtx = field.getContext('2d');
            destCtx.drawImage(fields[i], 0, 0);
        }
    });
    return clonedNode;
}
function $65894a732c14c34f$export$680929e2aec3ce89(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $eT4IF.default)(WithSortableHandle, _React$Component);
        function WithSortableHandle() {
            var _getPrototypeOf2;
            var _this;
            (0, $lDSrn.default)(this, WithSortableHandle);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $4mIeV.default)(this, (_getPrototypeOf2 = (0, $i3rTN.default)(WithSortableHandle)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "wrappedInstance", (0, $eUqFw.createRef)());
            return _this;
        }
        (0, $lIEGP.default)(WithSortableHandle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var node = (0, $lEfVV.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $eUqFw.createElement)(WrappedComponent, (0, $kU09D.default)({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return WithSortableHandle;
    }((0, $eUqFw.Component)), (0, $5zQU9.default)(_class, "displayName", $65894a732c14c34f$var$provideDisplayName('sortableHandle', WrappedComponent)), _temp;
}
function $65894a732c14c34f$var$isSortableHandle(node) {
    return node.sortableHandle != null;
}
var $65894a732c14c34f$var$AutoScroller = function() {
    function AutoScroller(container, onScrollCallback) {
        (0, $lDSrn.default)(this, AutoScroller);
        this.container = container;
        this.onScrollCallback = onScrollCallback;
    }
    (0, $lIEGP.default)(AutoScroller, [
        {
            key: "clear",
            value: function clear() {
                if (this.interval == null) return;
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        {
            key: "update",
            value: function update(_ref) {
                var _this = this;
                var translate = _ref.translate, minTranslate = _ref.minTranslate, maxTranslate = _ref.maxTranslate, width = _ref.width, height = _ref.height;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                var _this$container = this.container, scrollTop = _this$container.scrollTop, scrollLeft = _this$container.scrollLeft, scrollHeight = _this$container.scrollHeight, scrollWidth = _this$container.scrollWidth, clientHeight = _this$container.clientHeight, clientWidth = _this$container.clientWidth;
                var isTop = scrollTop === 0;
                var isBottom = scrollHeight - scrollTop - clientHeight === 0;
                var isLeft = scrollLeft === 0;
                var isRight = scrollWidth - scrollLeft - clientWidth === 0;
                if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
                    direction.y = 1;
                    speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
                } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
                    direction.x = 1;
                    speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
                } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
                    direction.y = -1;
                    speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
                } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
                    direction.x = -1;
                    speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
                }
                if (this.interval) {
                    this.clear();
                    this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) this.interval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: speed.x * direction.x,
                        top: speed.y * direction.y
                    };
                    _this.container.scrollTop += offset.top;
                    _this.container.scrollLeft += offset.left;
                    _this.onScrollCallback(offset);
                }, 5);
            }
        }
    ]);
    return AutoScroller;
}();
function $65894a732c14c34f$var$defaultGetHelperDimensions(_ref) {
    var node = _ref.node;
    return {
        height: node.offsetHeight,
        width: node.offsetWidth
    };
}
function $65894a732c14c34f$var$defaultShouldCancelStart(event) {
    var interactiveElements = [
        $65894a732c14c34f$var$NodeType.Input,
        $65894a732c14c34f$var$NodeType.Textarea,
        $65894a732c14c34f$var$NodeType.Select,
        $65894a732c14c34f$var$NodeType.Option,
        $65894a732c14c34f$var$NodeType.Button
    ];
    if (interactiveElements.indexOf(event.target.tagName) !== -1) return true;
    if ($65894a732c14c34f$var$closest(event.target, function(el) {
        return el.contentEditable === 'true';
    })) return true;
    return false;
}
var $65894a732c14c34f$var$propTypes = {
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'x',
        'y',
        'xy'
    ]),
    contentWindow: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).any,
    disableAutoscroll: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    distance: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    getContainer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    getHelperDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    helperClass: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    helperContainer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        typeof HTMLElement === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).any : (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf(HTMLElement)
    ]),
    hideSortableGhost: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    keyboardSortingTransitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    lockAxis: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    lockOffset: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
        ]))
    ]),
    lockToContainerEdges: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    onSortEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onSortMove: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onSortOver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    pressDelay: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    pressThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    keyCodes: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        lift: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number),
        drop: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number),
        cancel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number),
        up: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number),
        down: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number)
    }),
    shouldCancelStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    updateBeforeSortStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    useDragHandle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    useWindowAsScrollContainer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
};
var $65894a732c14c34f$var$defaultKeyCodes = {
    lift: [
        $65894a732c14c34f$var$KEYCODE.SPACE
    ],
    drop: [
        $65894a732c14c34f$var$KEYCODE.SPACE
    ],
    cancel: [
        $65894a732c14c34f$var$KEYCODE.ESC
    ],
    up: [
        $65894a732c14c34f$var$KEYCODE.UP,
        $65894a732c14c34f$var$KEYCODE.LEFT
    ],
    down: [
        $65894a732c14c34f$var$KEYCODE.DOWN,
        $65894a732c14c34f$var$KEYCODE.RIGHT
    ]
};
var $65894a732c14c34f$var$defaultProps = {
    axis: 'y',
    disableAutoscroll: false,
    distance: 0,
    getHelperDimensions: $65894a732c14c34f$var$defaultGetHelperDimensions,
    hideSortableGhost: true,
    lockOffset: '50%',
    lockToContainerEdges: false,
    pressDelay: 0,
    pressThreshold: 5,
    keyCodes: $65894a732c14c34f$var$defaultKeyCodes,
    shouldCancelStart: $65894a732c14c34f$var$defaultShouldCancelStart,
    transitionDuration: 300,
    useWindowAsScrollContainer: false
};
var $65894a732c14c34f$var$omittedProps = Object.keys($65894a732c14c34f$var$propTypes);
function $65894a732c14c34f$var$validateProps(props) {
    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}
function $65894a732c14c34f$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $65894a732c14c34f$var$SortableContext = (0, $eUqFw.createContext)({
    manager: {}
});
function $65894a732c14c34f$export$a4b10e5599330dd0(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $eT4IF.default)(WithSortableContainer, _React$Component);
        function WithSortableContainer(props) {
            var _this;
            (0, $lDSrn.default)(this, WithSortableContainer);
            _this = (0, $4mIeV.default)(this, (0, $i3rTN.default)(WithSortableContainer).call(this, props));
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "state", {});
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleStart", function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return;
                _this.touched = true;
                _this.position = $65894a732c14c34f$var$getPosition(event);
                var node = $65894a732c14c34f$var$closest(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection, disabled = _node$sortableInfo.disabled;
                    if (disabled) return;
                    if (useDragHandle && !$65894a732c14c34f$var$closest(event.target, $65894a732c14c34f$var$isSortableHandle)) return;
                    _this.manager.active = {
                        collection: collection,
                        index: index
                    };
                    if (!$65894a732c14c34f$var$isTouchEvent(event) && event.target.tagName === $65894a732c14c34f$var$NodeType.Anchor) event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "nodeIsChild", function(node) {
                return node.sortableInfo.manager === _this.manager;
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleMove", function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
                    var position = $65894a732c14c34f$var$getPosition(event);
                    var delta = {
                        x: _this.position.x - position.x,
                        y: _this.position.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    _this.delta = delta;
                    if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleEnd", function() {
                _this.touched = false;
                _this.cancel();
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "cancel", function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handlePress", function(event) {
                try {
                    var active = _this.manager.getActive();
                    var _temp6 = function() {
                        if (active) {
                            var _temp7 = function _temp7() {
                                var index = _node.sortableInfo.index;
                                var margin = $65894a732c14c34f$var$getElementMargin(_node);
                                var gridGap = $65894a732c14c34f$var$getContainerGridGap(_this.container);
                                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();
                                var dimensions = _getHelperDimensions({
                                    index: index,
                                    node: _node,
                                    collection: _collection
                                });
                                _this.node = _node;
                                _this.margin = margin;
                                _this.gridGap = gridGap;
                                _this.width = dimensions.width;
                                _this.height = dimensions.height;
                                _this.marginOffset = {
                                    x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                                    y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                                };
                                _this.boundingClientRect = _node.getBoundingClientRect();
                                _this.containerBoundingRect = containerBoundingRect;
                                _this.index = index;
                                _this.newIndex = index;
                                _this.axis = {
                                    x: _axis.indexOf('x') >= 0,
                                    y: _axis.indexOf('y') >= 0
                                };
                                _this.offsetEdge = $65894a732c14c34f$var$getEdgeOffset(_node, _this.container);
                                if (_isKeySorting) _this.initialOffset = $65894a732c14c34f$var$getPosition((0, $1o7fk.default)({}, event, {
                                    pageX: _this.boundingClientRect.left,
                                    pageY: _this.boundingClientRect.top
                                }));
                                else _this.initialOffset = $65894a732c14c34f$var$getPosition(event);
                                _this.initialScroll = {
                                    left: _this.scrollContainer.scrollLeft,
                                    top: _this.scrollContainer.scrollTop
                                };
                                _this.initialWindowScroll = {
                                    left: window.pageXOffset,
                                    top: window.pageYOffset
                                };
                                _this.helper = _this.helperContainer.appendChild($65894a732c14c34f$var$cloneNode(_node));
                                $65894a732c14c34f$var$setInlineStyles(_this.helper, {
                                    boxSizing: 'border-box',
                                    height: "".concat(_this.height, "px"),
                                    left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                                    pointerEvents: 'none',
                                    position: 'fixed',
                                    top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                                    width: "".concat(_this.width, "px")
                                });
                                if (_isKeySorting) _this.helper.focus();
                                if (_hideSortableGhost) {
                                    _this.sortableGhost = _node;
                                    $65894a732c14c34f$var$setInlineStyles(_node, {
                                        opacity: 0,
                                        visibility: 'hidden'
                                    });
                                }
                                _this.minTranslate = {};
                                _this.maxTranslate = {};
                                if (_isKeySorting) {
                                    var _ref = _useWindowAsScrollContainer ? {
                                        top: 0,
                                        left: 0,
                                        width: _this.contentWindow.innerWidth,
                                        height: _this.contentWindow.innerHeight
                                    } : _this.containerBoundingRect, containerTop = _ref.top, containerLeft = _ref.left, containerWidth = _ref.width, containerHeight = _ref.height;
                                    var containerBottom = containerTop + containerHeight;
                                    var containerRight = containerLeft + containerWidth;
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                                        _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                                        _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                                    }
                                } else {
                                    if (_this.axis.x) {
                                        _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                                        _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                                    }
                                    if (_this.axis.y) {
                                        _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                                        _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                                    }
                                }
                                if (_helperClass) _helperClass.split(' ').forEach(function(className) {
                                    return _this.helper.classList.add(className);
                                });
                                _this.listenerNode = event.touches ? event.target : _this.contentWindow;
                                if (_isKeySorting) {
                                    _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);
                                    _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                                } else {
                                    $65894a732c14c34f$var$events.move.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                                    });
                                    $65894a732c14c34f$var$events.end.forEach(function(eventName) {
                                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                                    });
                                }
                                _this.setState({
                                    sorting: true,
                                    sortingIndex: index
                                });
                                if (_onSortStart) _onSortStart({
                                    node: _node,
                                    index: index,
                                    collection: _collection,
                                    isKeySorting: _isKeySorting,
                                    nodes: _this.manager.getOrderedRefs(),
                                    helper: _this.helper
                                }, event);
                                if (_isKeySorting) _this.keyMove(0);
                            };
                            var _this$props3 = _this.props, _axis = _this$props3.axis, _getHelperDimensions = _this$props3.getHelperDimensions, _helperClass = _this$props3.helperClass, _hideSortableGhost = _this$props3.hideSortableGhost, updateBeforeSortStart = _this$props3.updateBeforeSortStart, _onSortStart = _this$props3.onSortStart, _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                            var _node = active.node, _collection = active.collection;
                            var _isKeySorting = _this.manager.isKeySorting;
                            var _temp8 = function() {
                                if (typeof updateBeforeSortStart === 'function') {
                                    _this._awaitingUpdateBeforeSortStart = true;
                                    var _temp9 = $65894a732c14c34f$var$_finallyRethrows(function() {
                                        var index = _node.sortableInfo.index;
                                        return Promise.resolve(updateBeforeSortStart({
                                            collection: _collection,
                                            index: index,
                                            node: _node,
                                            isKeySorting: _isKeySorting
                                        }, event)).then(function() {});
                                    }, function(_wasThrown, _result) {
                                        _this._awaitingUpdateBeforeSortStart = false;
                                        if (_wasThrown) throw _result;
                                        return _result;
                                    });
                                    if (_temp9 && _temp9.then) return _temp9.then(function() {});
                                }
                            }();
                            return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
                        }
                    }();
                    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleSortMove", function(event) {
                var onSortMove = _this.props.onSortMove;
                if (typeof event.preventDefault === 'function' && event.cancelable) event.preventDefault();
                _this.updateHelperPosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleSortEnd", function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var _this$manager = _this.manager, collection = _this$manager.active.collection, isKeySorting = _this$manager.isKeySorting;
                var nodes = _this.manager.getOrderedRefs();
                if (_this.listenerNode) {
                    if (isKeySorting) {
                        _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);
                        _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
                    } else {
                        $65894a732c14c34f$var$events.move.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                        });
                        $65894a732c14c34f$var$events.end.forEach(function(eventName) {
                            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                        });
                    }
                }
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) $65894a732c14c34f$var$setInlineStyles(_this.sortableGhost, {
                    opacity: '',
                    visibility: ''
                });
                for(var i = 0, len = nodes.length; i < len; i++){
                    var _node2 = nodes[i];
                    var el = _node2.node;
                    _node2.edgeOffset = null;
                    _node2.boundingClientRect = null;
                    $65894a732c14c34f$var$setTranslate3d(el, null);
                    $65894a732c14c34f$var$setTransitionDuration(el, null);
                    _node2.translate = null;
                }
                _this.autoScroller.clear();
                _this.manager.active = null;
                _this.manager.isKeySorting = false;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === 'function') onSortEnd({
                    collection: collection,
                    newIndex: _this.newIndex,
                    oldIndex: _this.index,
                    isKeySorting: isKeySorting,
                    nodes: nodes
                }, event);
                _this.touched = false;
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "autoscroll", function() {
                var disableAutoscroll = _this.props.disableAutoscroll;
                var isKeySorting = _this.manager.isKeySorting;
                if (disableAutoscroll) {
                    _this.autoScroller.clear();
                    return;
                }
                if (isKeySorting) {
                    var translate = (0, $1o7fk.default)({}, _this.translate);
                    var scrollX = 0;
                    var scrollY = 0;
                    if (_this.axis.x) {
                        translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
                        scrollX = _this.translate.x - translate.x;
                    }
                    if (_this.axis.y) {
                        translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
                        scrollY = _this.translate.y - translate.y;
                    }
                    _this.translate = translate;
                    $65894a732c14c34f$var$setTranslate3d(_this.helper, _this.translate);
                    _this.scrollContainer.scrollLeft += scrollX;
                    _this.scrollContainer.scrollTop += scrollY;
                    return;
                }
                _this.autoScroller.update({
                    height: _this.height,
                    maxTranslate: _this.maxTranslate,
                    minTranslate: _this.minTranslate,
                    translate: _this.translate,
                    width: _this.width
                });
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "onAutoScroll", function(offset) {
                _this.translate.x += offset.left;
                _this.translate.y += offset.top;
                _this.animateNodes();
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleKeyDown", function(event) {
                var keyCode = event.keyCode;
                var _this$props5 = _this.props, shouldCancelStart = _this$props5.shouldCancelStart, _this$props5$keyCodes = _this$props5.keyCodes, customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;
                var keyCodes = (0, $1o7fk.default)({}, $65894a732c14c34f$var$defaultKeyCodes, customKeyCodes);
                if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) return;
                event.stopPropagation();
                event.preventDefault();
                if (keyCodes.lift.includes(keyCode) && !_this.manager.active) _this.keyLift(event);
                else if (keyCodes.drop.includes(keyCode) && _this.manager.active) _this.keyDrop(event);
                else if (keyCodes.cancel.includes(keyCode)) {
                    _this.newIndex = _this.manager.active.index;
                    _this.keyDrop(event);
                } else if (keyCodes.up.includes(keyCode)) _this.keyMove(-1);
                else if (keyCodes.down.includes(keyCode)) _this.keyMove(1);
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "keyLift", function(event) {
                var target = event.target;
                var node = $65894a732c14c34f$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                var _node$sortableInfo2 = node.sortableInfo, index = _node$sortableInfo2.index, collection = _node$sortableInfo2.collection;
                _this.initialFocusedNode = target;
                _this.manager.isKeySorting = true;
                _this.manager.active = {
                    index: index,
                    collection: collection
                };
                _this.handlePress(event);
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "keyMove", function(shift) {
                var nodes = _this.manager.getOrderedRefs();
                var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
                var newIndex = _this.newIndex + shift;
                var prevIndex = _this.newIndex;
                if (newIndex < 0 || newIndex > lastIndex) return;
                _this.prevIndex = prevIndex;
                _this.newIndex = newIndex;
                var targetIndex = $65894a732c14c34f$var$getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
                var target = nodes.find(function(_ref2) {
                    var node = _ref2.node;
                    return node.sortableInfo.index === targetIndex;
                });
                var targetNode = target.node;
                var scrollDelta = _this.containerScrollDelta;
                var targetBoundingClientRect = target.boundingClientRect || $65894a732c14c34f$var$getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
                var targetTranslate = target.translate || {
                    x: 0,
                    y: 0
                };
                var targetPosition = {
                    top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
                    left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
                };
                var shouldAdjustForSize = prevIndex < newIndex;
                var sizeAdjustment = {
                    x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
                    y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
                };
                _this.handleSortMove({
                    pageX: targetPosition.left + sizeAdjustment.x,
                    pageY: targetPosition.top + sizeAdjustment.y,
                    ignoreTransition: shift === 0
                });
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "keyDrop", function(event) {
                _this.handleSortEnd(event);
                if (_this.initialFocusedNode) _this.initialFocusedNode.focus();
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "handleKeyEnd", function(event) {
                if (_this.manager.active) _this.keyDrop(event);
            });
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "isValidSortingTarget", function(event) {
                var useDragHandle = _this.props.useDragHandle;
                var target = event.target;
                var node = $65894a732c14c34f$var$closest(target, function(el) {
                    return el.sortableInfo != null;
                });
                return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? $65894a732c14c34f$var$isSortableHandle(target) : target.sortableInfo);
            });
            var manager = new $65894a732c14c34f$var$Manager();
            $65894a732c14c34f$var$validateProps(props);
            _this.manager = manager;
            _this.wrappedInstance = (0, $eUqFw.createRef)();
            _this.sortableContextValue = {
                manager: manager
            };
            _this.events = {
                end: _this.handleEnd,
                move: _this.handleMove,
                start: _this.handleStart
            };
            return _this;
        }
        (0, $lIEGP.default)(WithSortableContainer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : $65894a732c14c34f$var$getScrollingParent(_this2.container) || _this2.container;
                        _this2.autoScroller = new $65894a732c14c34f$var$AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
                        Object.keys(_this2.events).forEach(function(key) {
                            return $65894a732c14c34f$var$events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        });
                        _this2.container.addEventListener('keydown', _this2.handleKeyDown);
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.helper && this.helper.parentNode) this.helper.parentNode.removeChild(this.helper);
                    if (!this.container) return;
                    Object.keys(this.events).forEach(function(key) {
                        return $65894a732c14c34f$var$events[key].forEach(function(eventName) {
                            return _this3.container.removeEventListener(eventName, _this3.events[key]);
                        });
                    });
                    this.container.removeEventListener('keydown', this.handleKeyDown);
                }
            },
            {
                key: "updateHelperPosition",
                value: function updateHelperPosition(event) {
                    var _this$props6 = this.props, lockAxis = _this$props6.lockAxis, lockOffset = _this$props6.lockOffset, lockToContainerEdges = _this$props6.lockToContainerEdges, transitionDuration = _this$props6.transitionDuration, _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration, keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
                    var isKeySorting = this.manager.isKeySorting;
                    var ignoreTransition = event.ignoreTransition;
                    var offset = $65894a732c14c34f$var$getPosition(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = $65894a732c14c34f$var$getLockPixelOffsets({
                            height: this.height,
                            lockOffset: lockOffset,
                            width: this.width
                        }), _getLockPixelOffsets2 = (0, $aKcqM.default)(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = $65894a732c14c34f$var$limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = $65894a732c14c34f$var$limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === 'x') translate.y = 0;
                    else if (lockAxis === 'y') translate.x = 0;
                    if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) $65894a732c14c34f$var$setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
                    $65894a732c14c34f$var$setTranslate3d(this.helper, translate);
                }
            },
            {
                key: "animateNodes",
                value: function animateNodes() {
                    var _this$props7 = this.props, transitionDuration = _this$props7.transitionDuration, hideSortableGhost = _this$props7.hideSortableGhost, onSortOver = _this$props7.onSortOver;
                    var containerScrollDelta = this.containerScrollDelta, windowScrollDelta = this.windowScrollDelta;
                    var nodes = this.manager.getOrderedRefs();
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var isKeySorting = this.manager.isKeySorting;
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var _node3 = nodes[i].node;
                        var index = _node3.sortableInfo.index;
                        var width = _node3.offsetWidth;
                        var height = _node3.offsetHeight;
                        var offset = {
                            height: this.height > height ? height / 2 : this.height / 2,
                            width: this.width > width ? width / 2 : this.width / 2
                        };
                        var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
                        var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        if (!edgeOffset) {
                            edgeOffset = $65894a732c14c34f$var$getEdgeOffset(_node3, this.container);
                            nodes[i].edgeOffset = edgeOffset;
                            if (isKeySorting) nodes[i].boundingClientRect = $65894a732c14c34f$var$getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
                        }
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        if (nextNode && !nextNode.edgeOffset) {
                            nextNode.edgeOffset = $65894a732c14c34f$var$getEdgeOffset(nextNode.node, this.container);
                            if (isKeySorting) nextNode.boundingClientRect = $65894a732c14c34f$var$getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
                        }
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                this.sortableGhost = _node3;
                                $65894a732c14c34f$var$setInlineStyles(_node3, {
                                    opacity: 0,
                                    visibility: 'hidden'
                                });
                            }
                            continue;
                        }
                        if (transitionDuration) $65894a732c14c34f$var$setTransitionDuration(_node3, transitionDuration);
                        if (this.axis.x) {
                            if (this.axis.y) {
                                if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        if (nextNode) {
                                            translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        if (prevNode) {
                                            translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                            translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                        }
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        $65894a732c14c34f$var$setTranslate3d(_node3, translate);
                        nodes[i].translate = translate;
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (isKeySorting) this.newIndex = prevIndex;
                    var oldIndex = isKeySorting ? this.prevIndex : prevIndex;
                    if (onSortOver && this.newIndex !== oldIndex) onSortOver({
                        collection: this.manager.active.collection,
                        index: this.index,
                        newIndex: this.newIndex,
                        oldIndex: oldIndex,
                        isKeySorting: isKeySorting,
                        nodes: nodes,
                        helper: this.helper
                    });
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "getContainer",
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== 'function') return (0, $lEfVV.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $eUqFw.createElement)($65894a732c14c34f$var$SortableContext.Provider, {
                        value: this.sortableContextValue
                    }, (0, $eUqFw.createElement)(WrappedComponent, (0, $kU09D.default)({
                        ref: ref
                    }, $65894a732c14c34f$var$omit(this.props, $65894a732c14c34f$var$omittedProps))));
                }
            },
            {
                key: "helperContainer",
                get: function get() {
                    var helperContainer = this.props.helperContainer;
                    if (typeof helperContainer === 'function') return helperContainer();
                    return this.props.helperContainer || this.document.body;
                }
            },
            {
                key: "containerScrollDelta",
                get: function get() {
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    if (useWindowAsScrollContainer) return {
                        left: 0,
                        top: 0
                    };
                    return {
                        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
                        top: this.scrollContainer.scrollTop - this.initialScroll.top
                    };
                }
            },
            {
                key: "windowScrollDelta",
                get: function get() {
                    return {
                        left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
                        top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
                    };
                }
            }
        ]);
        return WithSortableContainer;
    }((0, $eUqFw.Component)), (0, $5zQU9.default)(_class, "displayName", $65894a732c14c34f$var$provideDisplayName('sortableList', WrappedComponent)), (0, $5zQU9.default)(_class, "defaultProps", $65894a732c14c34f$var$defaultProps), (0, $5zQU9.default)(_class, "propTypes", $65894a732c14c34f$var$propTypes), _temp;
}
var $65894a732c14c34f$var$propTypes$1 = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
};
var $65894a732c14c34f$var$omittedProps$1 = Object.keys($65894a732c14c34f$var$propTypes$1);
function $65894a732c14c34f$export$58d1e4fb0d207bf7(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_React$Component) {
        (0, $eT4IF.default)(WithSortableElement, _React$Component);
        function WithSortableElement() {
            var _getPrototypeOf2;
            var _this;
            (0, $lDSrn.default)(this, WithSortableElement);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, $4mIeV.default)(this, (_getPrototypeOf2 = (0, $i3rTN.default)(WithSortableElement)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, $5zQU9.default)((0, $aCdHv.default)((0, $aCdHv.default)(_this)), "wrappedInstance", (0, $eUqFw.createRef)());
            return _this;
        }
        (0, $lIEGP.default)(WithSortableElement, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.register();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.node) {
                        if (prevProps.index !== this.props.index) this.node.sortableInfo.index = this.props.index;
                        if (prevProps.disabled !== this.props.disabled) this.node.sortableInfo.disabled = this.props.disabled;
                    }
                    if (prevProps.collection !== this.props.collection) {
                        this.unregister(prevProps.collection);
                        this.register();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unregister();
                }
            },
            {
                key: "register",
                value: function register() {
                    var _this$props = this.props, collection = _this$props.collection, disabled = _this$props.disabled, index = _this$props.index;
                    var node = (0, $lEfVV.findDOMNode)(this);
                    node.sortableInfo = {
                        collection: collection,
                        disabled: disabled,
                        index: index,
                        manager: this.context.manager
                    };
                    this.node = node;
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: "unregister",
                value: function unregister() {
                    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                    return this.wrappedInstance.current;
                }
            },
            {
                key: "render",
                value: function render() {
                    var ref = config.withRef ? this.wrappedInstance : null;
                    return (0, $eUqFw.createElement)(WrappedComponent, (0, $kU09D.default)({
                        ref: ref
                    }, $65894a732c14c34f$var$omit(this.props, $65894a732c14c34f$var$omittedProps$1)));
                }
            }
        ]);
        return WithSortableElement;
    }((0, $eUqFw.Component)), (0, $5zQU9.default)(_class, "displayName", $65894a732c14c34f$var$provideDisplayName('sortableElement', WrappedComponent)), (0, $5zQU9.default)(_class, "contextType", $65894a732c14c34f$var$SortableContext), (0, $5zQU9.default)(_class, "propTypes", $65894a732c14c34f$var$propTypes$1), (0, $5zQU9.default)(_class, "defaultProps", {
        collection: 0
    }), _temp;
}

});
parcelRegister("1o7fk", function(module, exports) {

$parcel$export(module.exports, "default", () => $102da74a6124e11e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $102da74a6124e11e$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
    }
    return target;
}

});


parcelRegister("dULIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a215862d5b66b800$var$_react = $a215862d5b66b800$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a215862d5b66b800$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a215862d5b66b800$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $a215862d5b66b800$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props));
$a215862d5b66b800$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $a215862d5b66b800$var$_default = $a215862d5b66b800$var$DragHandlerIcon;
module.exports.default = $a215862d5b66b800$var$_default;

});

parcelRegister("6EZ9n", function(module, exports) {

$parcel$export(module.exports, "getListableColumns", () => $94a1d29499aeb7b6$export$b130bbab35fbab57);

var $UCNmJ = parcelRequire("UCNmJ");

var $7CnHa = parcelRequire("7CnHa");
const $94a1d29499aeb7b6$var$INCOMING_DEPENDENCY = 'incomingDependencies';
const $94a1d29499aeb7b6$var$OUTGOING_DEPENDENCY = 'outgoingDependencies';
const $94a1d29499aeb7b6$export$b130bbab35fbab57 = (columns)=>$UCNmJ.default((0, $7CnHa.groupBy)((column)=>[
            $94a1d29499aeb7b6$var$INCOMING_DEPENDENCY,
            $94a1d29499aeb7b6$var$OUTGOING_DEPENDENCY
        ].includes(column.id) ? 'dependency' : `${column.localizedTitle}-${column.id}`, columns));

});

parcelRegister("7cNjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c521455c6653a03$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9c521455c6653a03$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    advancedFieldsMenuNoSelectedFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-no-selected-fields",
        "defaultMessage": "No fields have been selected."
    },
    advancedFieldsMenuCustomFieldLozenge: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-custom-field-lozenge",
        "defaultMessage": "CUSTOM"
    },
    advancedFieldsMenuSelectedFieldDragTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-drag-tooltip",
        "defaultMessage": "Rearrange field order"
    },
    advancedFieldsMenuSelectedFieldRemoveTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-remove-tooltip",
        "defaultMessage": "Remove field"
    },
    advancedFieldsMenuSelectedFieldRemoveAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-fields-menu-selected-field-remove-aria-label",
        "defaultMessage": "Remove {fieldName} field"
    },
    advancedFieldMenuFocusedFieldAnnouncement: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-focused-field-announcement",
        "defaultMessage": "Draggable item. Ensure your screen reader is not in browse mode and then press the space bar to lift."
    },
    advancedFieldMenuGrabbedFieldAnnouncement: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-grabbed-field-announcement",
        "defaultMessage": "You have lifted {fieldName} field. Use the arrow keys to move, space bar to drop, and escape to cancel."
    },
    advancedFieldMenuDroppedFieldAnnouncement: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-dropped-field-announcement",
        "defaultMessage": "You have moved {fieldName} field to Position {position}."
    },
    advancedFieldMenuMovedFieldAnnouncement: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu.selected-fields.advanced-field-menu-moved-field-announcement",
        "defaultMessage": "You have moved an item from the Position {initialPosition} to Position {currentPosition}. Use the arrow keys to move, space bar to drop, and escape to cancel.\""
    }
});

});

parcelRegister("aLAUL", function(module, exports) {

$parcel$export(module.exports, "afm-custom-field-lozenge", () => $7d6aeda34e255be6$export$51a969aafb1f991c, (v) => $7d6aeda34e255be6$export$51a969aafb1f991c = v);
$parcel$export(module.exports, "afm-dropdown-menu-body", () => $7d6aeda34e255be6$export$43df9b5ce18a8b4, (v) => $7d6aeda34e255be6$export$43df9b5ce18a8b4 = v);
$parcel$export(module.exports, "afm-no-selected-fields", () => $7d6aeda34e255be6$export$8abc7ba865f0cc7f, (v) => $7d6aeda34e255be6$export$8abc7ba865f0cc7f = v);
$parcel$export(module.exports, "afm-selected-field-item", () => $7d6aeda34e255be6$export$fcb0fc7018fc0e10, (v) => $7d6aeda34e255be6$export$fcb0fc7018fc0e10 = v);
$parcel$export(module.exports, "afm-selected-field-item-drag-icon", () => $7d6aeda34e255be6$export$f7ad72c054fabedb, (v) => $7d6aeda34e255be6$export$f7ad72c054fabedb = v);
$parcel$export(module.exports, "afm-selected-field-item-remove-icon", () => $7d6aeda34e255be6$export$94fc5f115eb0699b, (v) => $7d6aeda34e255be6$export$94fc5f115eb0699b = v);
$parcel$export(module.exports, "afm-selected-field-item-remove-icon-button", () => $7d6aeda34e255be6$export$5349758fd85eb4be, (v) => $7d6aeda34e255be6$export$5349758fd85eb4be = v);
$parcel$export(module.exports, "afm-selected-field-item-section", () => $7d6aeda34e255be6$export$d6f135831cf0ddc1, (v) => $7d6aeda34e255be6$export$d6f135831cf0ddc1 = v);
$parcel$export(module.exports, "afm-selected-field-item-title", () => $7d6aeda34e255be6$export$b81eed1372b5b4de, (v) => $7d6aeda34e255be6$export$b81eed1372b5b4de = v);
$parcel$export(module.exports, "afm-sortable-helper", () => $7d6aeda34e255be6$export$d838166ee9717897, (v) => $7d6aeda34e255be6$export$d838166ee9717897 = v);
var $7d6aeda34e255be6$export$51a969aafb1f991c;
var $7d6aeda34e255be6$export$43df9b5ce18a8b4;
var $7d6aeda34e255be6$export$8abc7ba865f0cc7f;
var $7d6aeda34e255be6$export$fcb0fc7018fc0e10;
var $7d6aeda34e255be6$export$d099f59ae3e2e288;
var $7d6aeda34e255be6$export$f7ad72c054fabedb;
var $7d6aeda34e255be6$export$94fc5f115eb0699b;
var $7d6aeda34e255be6$export$5349758fd85eb4be;
var $7d6aeda34e255be6$export$d6f135831cf0ddc1;
var $7d6aeda34e255be6$export$b81eed1372b5b4de;
var $7d6aeda34e255be6$export$d838166ee9717897;
$7d6aeda34e255be6$export$51a969aafb1f991c = `GgeTjW_afm-custom-field-lozenge`;
$7d6aeda34e255be6$export$43df9b5ce18a8b4 = `GgeTjW_afm-dropdown-menu-body`;
$7d6aeda34e255be6$export$8abc7ba865f0cc7f = `GgeTjW_afm-no-selected-fields`;
$7d6aeda34e255be6$export$fcb0fc7018fc0e10 = `GgeTjW_afm-selected-field-item`;
$7d6aeda34e255be6$export$d099f59ae3e2e288 = `GgeTjW_afm-selected-field-item-custom-lozenge`;
$7d6aeda34e255be6$export$f7ad72c054fabedb = `GgeTjW_afm-selected-field-item-drag-icon`;
$7d6aeda34e255be6$export$94fc5f115eb0699b = `GgeTjW_afm-selected-field-item-remove-icon`;
$7d6aeda34e255be6$export$5349758fd85eb4be = `GgeTjW_afm-selected-field-item-remove-icon-button`;
$7d6aeda34e255be6$export$d6f135831cf0ddc1 = `GgeTjW_afm-selected-field-item-section`;
$7d6aeda34e255be6$export$b81eed1372b5b4de = `GgeTjW_afm-selected-field-item-title`;
$7d6aeda34e255be6$export$d838166ee9717897 = `GgeTjW_afm-sortable-helper`;

});


parcelRegister("8kuoL", function(module, exports) {

$parcel$export(module.exports, "afm-custom-field-lozenge", () => $6107c57af80c88f4$export$51a969aafb1f991c, (v) => $6107c57af80c88f4$export$51a969aafb1f991c = v);
$parcel$export(module.exports, "afm-dropdown-container", () => $6107c57af80c88f4$export$95815578c4856fea, (v) => $6107c57af80c88f4$export$95815578c4856fea = v);
$parcel$export(module.exports, "afm-dropdown-menu-divider", () => $6107c57af80c88f4$export$8c2501616d9e2d73, (v) => $6107c57af80c88f4$export$8c2501616d9e2d73 = v);
$parcel$export(module.exports, "afm-dropdown-menu-header", () => $6107c57af80c88f4$export$39c716ad17a14d42, (v) => $6107c57af80c88f4$export$39c716ad17a14d42 = v);
$parcel$export(module.exports, "afm-field-option", () => $6107c57af80c88f4$export$c4dc84db340240de, (v) => $6107c57af80c88f4$export$c4dc84db340240de = v);
$parcel$export(module.exports, "afm-field-option-custom-lozenge", () => $6107c57af80c88f4$export$dfe7b0b9ad68beaf, (v) => $6107c57af80c88f4$export$dfe7b0b9ad68beaf = v);
$parcel$export(module.exports, "afm-field-option-title", () => $6107c57af80c88f4$export$513e2dab2e941930, (v) => $6107c57af80c88f4$export$513e2dab2e941930 = v);
$parcel$export(module.exports, "afm-header-left", () => $6107c57af80c88f4$export$6c74d3971ac3113, (v) => $6107c57af80c88f4$export$6c74d3971ac3113 = v);
$parcel$export(module.exports, "afm-select-option-label", () => $6107c57af80c88f4$export$a0bf72b5860d98, (v) => $6107c57af80c88f4$export$a0bf72b5860d98 = v);
var $6107c57af80c88f4$export$21220cda0bbe516b;
var $6107c57af80c88f4$export$51a969aafb1f991c;
var $6107c57af80c88f4$export$95815578c4856fea;
var $6107c57af80c88f4$export$560c6189393c16e;
var $6107c57af80c88f4$export$43df9b5ce18a8b4;
var $6107c57af80c88f4$export$8c2501616d9e2d73;
var $6107c57af80c88f4$export$e6b766ff3c71a859;
var $6107c57af80c88f4$export$ce1082ff2dcc4f0d;
var $6107c57af80c88f4$export$39c716ad17a14d42;
var $6107c57af80c88f4$export$590974056234d93e;
var $6107c57af80c88f4$export$c4dc84db340240de;
var $6107c57af80c88f4$export$dfe7b0b9ad68beaf;
var $6107c57af80c88f4$export$513e2dab2e941930;
var $6107c57af80c88f4$export$6c74d3971ac3113;
var $6107c57af80c88f4$export$a0bf72b5860d98;
var $6107c57af80c88f4$export$fcb0fc7018fc0e10;
var $6107c57af80c88f4$export$d099f59ae3e2e288;
var $6107c57af80c88f4$export$f7ad72c054fabedb;
var $6107c57af80c88f4$export$94fc5f115eb0699b;
var $6107c57af80c88f4$export$b81eed1372b5b4de;
var $6107c57af80c88f4$export$d838166ee9717897;
var $6107c57af80c88f4$export$9f40be408ef90a09;
var $6107c57af80c88f4$export$fa60ad54036b1f7a;
var $6107c57af80c88f4$export$ed632e85719c4e08;
$6107c57af80c88f4$export$21220cda0bbe516b = `_2rlvoW_afm-custom-field-label`;
$6107c57af80c88f4$export$51a969aafb1f991c = `_2rlvoW_afm-custom-field-lozenge`;
$6107c57af80c88f4$export$95815578c4856fea = `_2rlvoW_afm-dropdown-container`;
$6107c57af80c88f4$export$560c6189393c16e = `_2rlvoW_afm-dropdown-container-old`;
$6107c57af80c88f4$export$43df9b5ce18a8b4 = `_2rlvoW_afm-dropdown-menu-body`;
$6107c57af80c88f4$export$8c2501616d9e2d73 = `_2rlvoW_afm-dropdown-menu-divider`;
$6107c57af80c88f4$export$e6b766ff3c71a859 = `_2rlvoW_afm-dropdown-menu-footer`;
$6107c57af80c88f4$export$ce1082ff2dcc4f0d = `_2rlvoW_afm-dropdown-menu-footer-old`;
$6107c57af80c88f4$export$39c716ad17a14d42 = `_2rlvoW_afm-dropdown-menu-header`;
$6107c57af80c88f4$export$590974056234d93e = `_2rlvoW_afm-dropdown-menu-header-old`;
$6107c57af80c88f4$export$c4dc84db340240de = `_2rlvoW_afm-field-option`;
$6107c57af80c88f4$export$dfe7b0b9ad68beaf = `_2rlvoW_afm-field-option-custom-lozenge`;
$6107c57af80c88f4$export$513e2dab2e941930 = `_2rlvoW_afm-field-option-title`;
$6107c57af80c88f4$export$6c74d3971ac3113 = `_2rlvoW_afm-header-left`;
$6107c57af80c88f4$export$a0bf72b5860d98 = `_2rlvoW_afm-select-option-label`;
$6107c57af80c88f4$export$fcb0fc7018fc0e10 = `_2rlvoW_afm-selected-field-item`;
$6107c57af80c88f4$export$d099f59ae3e2e288 = `_2rlvoW_afm-selected-field-item-custom-lozenge`;
$6107c57af80c88f4$export$f7ad72c054fabedb = `_2rlvoW_afm-selected-field-item-drag-icon`;
$6107c57af80c88f4$export$94fc5f115eb0699b = `_2rlvoW_afm-selected-field-item-remove-icon`;
$6107c57af80c88f4$export$b81eed1372b5b4de = `_2rlvoW_afm-selected-field-item-title`;
$6107c57af80c88f4$export$d838166ee9717897 = `_2rlvoW_afm-sortable-helper`;
$6107c57af80c88f4$export$9f40be408ef90a09 = `_2rlvoW_afm-trigger-button`;
$6107c57af80c88f4$export$fa60ad54036b1f7a = `_2rlvoW_afm-trigger-button-icon`;
$6107c57af80c88f4$export$ed632e85719c4e08 = `_2rlvoW_afm-trigger-button-text`;

});




parcelRegister("iFYrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f7fe5fad178fa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4l6af = parcelRequire("4l6af");
function $37f7fe5fad178fa7$export$2e2bcd8739ae039({ ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4l6af.default), props);
}

});
parcelRegister("4l6af", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fd2945ad9d8725f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jXg8H = parcelRequire("jXg8H");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $akSC8 = parcelRequire("akSC8");

var $4xHig = parcelRequire("4xHig");

var $l2Sj2 = parcelRequire("l2Sj2");
class $2fd2945ad9d8725f$export$2452ee3d2335d0d0 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isTransparentBackground: true,
            isDisabled: false,
            isActiveOnFirstRender: false,
            showClearIndicator: false
        };
    }
    componentDidMount() {
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') && this.datePickerRef) window.addEventListener('click', this.onWindowClick);
    }
    componentWillUnmount() {
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) window.removeEventListener('click', this.onWindowClick);
    }
    render() {
        const { isTransparentBackground: isTransparentBackground, onToggle: onToggle, onChange: onChange, isDisabled: isDisabled, isActiveOnFirstRender: isActiveOnFirstRender, showClearIndicator: showClearIndicator, styles: styles, placeholder: placeholder, weekStartDay: weekStartDay, locale: locale, intl: intl, ...props } = this.props;
        const selectProps = {
            ref: this.selectRef,
            // This helps to avoid expensive built-in AutosizeInput on the first render as we anyway
            // re-render after Select is mounted and its components get available for extension.
            isSearchable: isActiveOnFirstRender,
            styles: {
                ...styles,
                // eslint-disable-next-line @typescript-eslint/no-shadow
                menuPortal: (styles)=>({
                        ...styles,
                        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? {
                            zIndex: (0, $lcnyw.layers).modal(),
                            marginTop: `calc(${"var(--ds-space-negative-100, -8px)"} - ${"var(--ds-space-400, 32px)"})`
                        } : {}
                    }),
                // eslint-disable-next-line @typescript-eslint/no-shadow
                control: (styles, state)=>(0, $akSC8.injectMouseOverStyles)(styles, true, state.isFocused, !!isTransparentBackground)
            },
            ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? {
                menuPortalTarget: document.body
            } : {}
        };
        const appearance = isTransparentBackground ? 'subtle' : 'default';
        // Empty string evaluates as false inside AtlasKit, and makes the datepicker show 2/18/1983 as the placeholder string.
        // In order to avoid this, we turn any empty strings into ' '.
        const placeholderString = isDisabled || placeholder === '' ? ' ' : placeholder;
        return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Temporary incompatible selectProps type ('as any' workaround) until @atlaskit/select is upgraded
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
            ...props,
            hideIcon: props.hideIcon || !showClearIndicator,
            isDisabled: isDisabled,
            onFocus: ()=>{
                onToggle && onToggle(true);
            },
            onBlur: ()=>{
                onToggle && onToggle(false);
            },
            appearance: appearance,
            onChange: onChange,
            selectProps: selectProps,
            ref: this.datePickerRef,
            placeholder: placeholderString,
            weekStartDay: weekStartDay ?? 0,
            locale: locale,
            formatDisplayLabel: intl ? (date)=>(0, $l2Sj2.formatDateWithIntl)(intl, date) : undefined
        }));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/sort-comp
        this.selectRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // AtlasKit DatePicker fails to blur when the user clicks on another dropdown.
        // We need a reference to the AtlasKit DatePicker component to force `onSelectBlur`
        // when the user clicks outside of the datepicker.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.datePickerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.onWindowClick = (e)=>{
            const datePicker = this.datePickerRef.current;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const node = e.target;
            if (datePicker && datePicker.state.isOpen && !datePicker.containerRef.contains(node) && document.body && document.body.contains(node)) datePicker.onSelectBlur(e);
        };
    }
}
function $2fd2945ad9d8725f$export$2e2bcd8739ae039(props) {
    const intl = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const weekStartDay = (0, $8K9kM.getLocale)(locale)?.options?.weekStartsOn || 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fd2945ad9d8725f$export$2452ee3d2335d0d0, {
        ...props,
        weekStartDay: weekStartDay,
        intl: intl,
        locale: locale
    });
}

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $XHGTv = parcelRequire("XHGTv");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $jP55W = parcelRequire("jP55W");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = undefined;
const $a38f1e4301a686fa$var$packageVersion = undefined;
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    hideIcon: false,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))),
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ selectProps: {},
    spacing: 'default',
    locale: 'en-US'
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.calendarRef = null;
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getSafeState = ()=>{
            return {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value',
                    'isOpen'
                ]),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props.selectProps, [
                    'inputValue'
                ])
            };
        };
        this.isDateDisabled = (date)=>{
            return this.props.disabled.indexOf(date) > -1;
        };
        this.onCalendarChange = ({ iso: iso })=>{
            const [year, month, date] = iso.split('-');
            let newIso = iso;
            const parsedDate = parseInt(date, 10);
            const parsedMonth = parseInt(month, 10);
            const parsedYear = parseInt(year, 10);
            const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1) // This needs to be -1, because the Date constructor expects an index of the given month
            ).getDate();
            if (lastDayInMonth < parsedDate) newIso = `${year}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
            else newIso = `${year}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
            this.setState({
                calendarValue: newIso
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getSafeState().isOpen) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false
                });
                this.props.onBlur(event);
            }
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.getSafeState().clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon, value: value } = this.getSafeState();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = this.parseDate(inputValue);
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { value: value, calendarValue: calendarValue } = this.getSafeState();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = (0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') ? 1 : 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!this.isDateDisabled(calendarValue)) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.refCalendar = (ref)=>{
            this.calendarRef = ref;
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const { onInputChange: onInputChange } = this.props.selectProps;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        /**
   * There are two props that can change how the date is parsed.
   * The priority of props used is:
   *   1. `parseInputValue`
   *   2. `locale`
   */ this.parseDate = (date)=>{
            const { parseInputValue: parseInputValue, dateFormat: dateFormat } = this.props;
            if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
            const { l10n: l10n } = this.getSafeState();
            return l10n.parseDate(date);
        };
        /**
   * There are multiple props that can change how the date is formatted.
   * The priority of props used is:
   *   1. `formatDisplayLabel`
   *   2. `dateFormat`
   *   3. `locale`
   */ this.formatDate = (value)=>{
            const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat } = this.props;
            const { l10n: l10n } = this.getSafeState();
            if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
            const date = (0, $3xcI8.default)(value);
            return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
        };
        this.getPlaceholder = ()=>{
            const { placeholder: placeholder } = this.props;
            if (placeholder) return placeholder;
            const { l10n: l10n } = this.getSafeState();
            return l10n.formatDate((0, $7i5dr.placeholderDatetime));
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance, autoFocus: autoFocus, disabled: disabled, hideIcon: hideIcon, icon: icon, id: id, innerProps: innerProps, isDisabled: isDisabled, disabledDateFilter: disabledDateFilter, maxDate: maxDate, minDate: minDate, isInvalid: isInvalid, label: label, name: name, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, locale: locale, testId: testId, weekStartDay: weekStartDay } = this.props;
        const { value: value, calendarValue: calendarValue, isOpen: isOpen, selectInputValue: selectInputValue } = this.getSafeState();
        let actualSelectInputValue;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs')) actualSelectInputValue = selectInputValue || (value ? this.formatDate(value) : undefined);
        else actualSelectInputValue = selectInputValue;
        const menuIsOpen = isOpen && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarRef: this.refCalendar,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel
        };
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            "aria-label": label || undefined,
            appearance: this.props.appearance,
            enableAnimation: false,
            menuIsOpen: menuIsOpen,
            closeMenuOnSelect: true,
            autoFocus: autoFocus,
            inputId: id,
            isDisabled: isDisabled,
            onBlur: this.onSelectBlur,
            onFocus: this.onSelectFocus,
            inputValue: actualSelectInputValue,
            onInputChange: this.handleSelectInputChange,
            components: selectComponents,
            onChange: this.onSelectChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        // ICON_PADDING = 2
                        paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                    })
            }),
            placeholder: this.getPlaceholder(),
            value: value && {
                label: this.formatDate(value),
                value: value
            },
            ...selectProps,
            ...calendarProps,
            isClearable: true,
            spacing: spacing,
            isInvalid: isInvalid,
            testId: testId
        })));
    }
}
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
function $c845995965375b9a$var$getValidDate(iso) {
    const date = (0, $3xcI8.default)(iso);
    return (0, $7ueqz.default)(date) ? {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    } : {};
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            ...$c845995965375b9a$var$getValidDate(selectProps.calendarValue),
            ...$c845995965375b9a$var$getValidDate(selectProps.calendarView),
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            calendarRef: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $boty7 = parcelRequire("boty7");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");

var $fUeB0 = parcelRequire("fUeB0");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: undefined,
    packageVersion: undefined
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, calendarRef: calendarRef, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    (0, $boty7.default)(calendarRef, {
        navigate: navigate
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $fUeB0.default)('month-year-header');
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fUeB0 = parcelRequire("fUeB0");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $fUeB0.default)('month-year-announce');
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;
module.exports.default = $a2a4a1e4b9148f86$var$_default;

});

parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

parcelRegister("fUeB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40d1eadda8cdb8f$export$2e2bcd8739ae039);

var $jFtVs = parcelRequire("jFtVs");
function $b40d1eadda8cdb8f$export$2e2bcd8739ae039(prefix) {
    const seed = (0, $jFtVs.useUIDSeed)();
    return `${prefix}-${seed(prefix)}`;
}

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $PdmhA = parcelRequire("PdmhA");
const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $PdmhA.B400})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.N500})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N0})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N600})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("boty7", function(module, exports) {

$parcel$export(module.exports, "default", () => $986db25f452819ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $986db25f452819ee$export$2e2bcd8739ae039(calendarRef, { navigate: navigate }) {
    (0, $eUqFw.useImperativeHandle)(calendarRef, ()=>({
            navigate: navigate
        }), [
        navigate
    ]);
}

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8MHxr = parcelRequire("8MHxr");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)(),
            ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') && {
                pointerEvents: 'none'
            }
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...props,
            innerProps: {
                lang: lang
            }
        }, children);
    };

});


parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});



parcelRegister("5GBSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $758a5bd56a3d2c7b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eaAI = parcelRequire("2eaAI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$758a5bd56a3d2c7b$export$2e2bcd8739ae039 = ({ isReadOnly: isReadOnly, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eaAI.default), {
        ...props,
        isDisabled: isReadOnly,
        isReadOnly: isReadOnly
    });

});
parcelRegister("2eaAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ca5ed3950e7f4e$export$2e2bcd8739ae039);

var $ImH5E = parcelRequire("ImH5E");
var $37ca5ed3950e7f4e$export$2e2bcd8739ae039 = (0, $ImH5E.default);

});
parcelRegister("ImH5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc7b61091584eb1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $a576Y = parcelRequire("a576Y");

var $hjlb6 = parcelRequire("hjlb6");

var $fmBR7 = parcelRequire("fmBR7");
var $jQxSL = parcelRequire("jQxSL");
var $9jNAz = parcelRequire("9jNAz");
var $gwbfD = parcelRequire("gwbfD");

var $8CXDT = parcelRequire("8CXDT");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $cjjm8 = parcelRequire("cjjm8");

var $5omWp = parcelRequire("5omWp");
class $0bc7b61091584eb1$export$4ae427e87d8482e2 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isCreatable: false,
            HoverObserver: $fmBR7.default
        };
    }
    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            selectedOptions: props.getValues(props.issue, props.attribute)
        };
    }
    componentDidMount() {
        if (this.props.menuIsOpen) this.getOptions('');
    }
    getOptions(query) {
        this.setState({
            isLoading: true
        });
        this.props.fetchOptions(query).then((options)=>{
            this.setState({
                options: options,
                isLoading: false
            });
        });
    }
    render() {
        const { attribute: attribute, issue: issue, messages: messages, FieldSelect: FieldSelect, isReadOnly: isReadOnly, isDisabled: isDisabled, isCreatable: isCreatable, customNoOptionsMessage: customNoOptionsMessage, formatCreateLabel: formatCreateLabel, validateInputForCreation: validateInputForCreation, HoverObserver: // eslint-disable-next-line @typescript-eslint/no-shadow
        HoverObserver, menuIsOpen: menuIsOpen } = this.props;
        const values = this.state.selectedOptions;
        const noOptionsMessage = ({ inputValue: inputValue })=>{
            if (customNoOptionsMessage) {
                const message = customNoOptionsMessage(inputValue);
                if (message) return message;
            }
            if (inputValue === '' && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(values)) return messages.noLabels;
            if (inputValue === '' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(values)) return messages.noLabelsLeft;
            return messages.noMatch;
        };
        const getFieldSelect = ()=>isDisabled || isReadOnly ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $cjjm8.labelsContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $cjjm8.itemsWrapper
            }, values && values.length > 0 && this.renderMultipleLabels(values, (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($cjjm8.item, {
                [$cjjm8.disabled]: isDisabled && !isReadOnly
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, {
                isMulti: true,
                isCreatable: isCreatable,
                formatCreateLabel: formatCreateLabel,
                isLoading: this.state.isLoading,
                value: values,
                onChange: this.handleChange,
                onMenuOpen: ()=>this.getOptions(''),
                onInputChange: this.handleInputChange,
                options: this.state.options,
                closeMenuOnSelect: false,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                styles: (0, $5omWp.selectStyles),
                minSelectWidth: (0, $2LimL.MIN_SELECT_WIDTH),
                isTransparentBackground: false,
                placeholder: messages.placeholder,
                noOptionsMessage: noOptionsMessage,
                issueId: issue.id,
                attribute: attribute,
                components: {
                    Control: this.getControlComponent
                },
                isDisabled: isReadOnly || isDisabled,
                onCreateOption: this.handleCreateOption,
                isValidNewOption: validateInputForCreation,
                menuIsOpen: menuIsOpen
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: attribute,
            issue: issue,
            isScrolling: false,
            showOptimizations: false
        }, (0, $7CnHa.isDefined)(HoverObserver) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HoverObserver, {
            onHoverChanged: this.setHovered
        }, getFieldSelect()) : getFieldSelect());
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.state = {
            isLoading: false,
            options: [],
            isHovered: false,
            selectedOptions: []
        };
        this.throttledGetOptions = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(this.getOptions, 250);
        this.handleInputChange = (value, { action: action })=>{
            if (action === 'input-change' || action === 'input-blur') this.throttledGetOptions(value);
            // input the query and select the option, then need to render the rest options which need to set the query is empty string
            if (action === 'set-value') this.throttledGetOptions('');
        };
        this.setHovered = (isHovered)=>this.setState({
                isHovered: isHovered
            });
        this.handleChange = (options)=>{
            this.setState({
                selectedOptions: Array.isArray(options) ? options : []
            });
            this.props.onChange(this.props.issue, options || []);
        };
        // this will be called with the input value when a new option is created, and onChange will not be called. Use this when you need more control over what happens when new options are created.
        this.handleCreateOption = (inputValue)=>{
            this.props.onCreateOption && this.props.onCreateOption(inputValue);
            const newOption = this.props.convertCreatedLabelToOption && this.props.convertCreatedLabelToOption(inputValue) || {};
            const newSelectedOptions = [
                ...this.state.selectedOptions,
                newOption
            ];
            this.setState({
                selectedOptions: newSelectedOptions
            });
            // manually call onChange event
            this.props.onChange(this.props.issue, newSelectedOptions);
        };
        this.renderMultipleLabels = (selectedValues, itemClasses)=>{
            const title = selectedValues.map((value)=>value.label).join(', ');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: title
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $cjjm8.tagContainer
            }, selectedValues.map(({ label: label, value: value })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    key: value,
                    className: itemClasses
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                    text: label
                })))));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.getControlComponent = (props)=>{
            const { isReadOnly: isReadOnly, isDisabled: isDisabled } = this.props;
            const { isHovered: isHovered } = this.state;
            const { selectProps: { menuIsOpen: menuIsOpen, value: value, onMenuOpen: onMenuOpen } } = props;
            const isDefaultControl = menuIsOpen || isHovered && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value) && !isDisabled && !isReadOnly;
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($cjjm8.componentsContainer, {
                [$cjjm8.componentsContainerDisabled]: isDisabled,
                [$cjjm8.hiddenContainer]: isDefaultControl
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, {
                ...props,
                isFocused: menuIsOpen
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isDefaultControl && props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: className,
                role: "button",
                tabIndex: 0,
                onClick: onMenuOpen
            }, value && value.length > 0 && this.renderMultipleLabels(value, (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($cjjm8.item, {
                [$cjjm8.disabled]: isDisabled && !isReadOnly
            })))));
        };
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof MultiSelectCell' is not assignable to parameter of type 'ComponentType<any>'.
$0bc7b61091584eb1$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})($0bc7b61091584eb1$export$4ae427e87d8482e2);

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTag);

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            $98c5a9f7a5ded4f8$var$baseStyles,
            (isRemovable || isLink) && $98c5a9f7a5ded4f8$var$focusRingStyles,
            isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            isInteractive && $98c5a9f7a5ded4f8$var$interactiveStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $70eddb948b5989f5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $70eddb948b5989f5$var$beforeElementStyles
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $154b7edc63fec879$var$baseStyles,
            $154b7edc63fec879$var$linkStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $154b7edc63fec879$var$baseStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("8CXDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1045661615d0ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jPCDz = parcelRequire("jPCDz");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $eNhh9 = parcelRequire("eNhh9");

var $57dZR = parcelRequire("57dZR");

var $4UWBa = parcelRequire("4UWBa");

var $1Ml8N = parcelRequire("1Ml8N");
const $6f1045661615d0ae$export$836a69893daa1f7c = (current, optimized, delta)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Ml8N.default), {
        current: current,
        optimized: optimized,
        delta: delta
    });
class $6f1045661615d0ae$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ChangeIndicator: $4UWBa.default
        };
    }
    render() {
        const { showFlyout: showFlyout } = this.state;
        const { issue: issue, attribute: attribute, valueMapper: valueMapper, showOptimizations: showOptimizations, delta: delta, isCellDirty: isCellDirty, ChangeIndicator: // eslint-disable-next-line @typescript-eslint/no-shadow
        ChangeIndicator, locale: locale, children: children } = this.props;
        let isDirty = false;
        if (isCellDirty) isDirty = isCellDirty();
        else isDirty = issue.originals && $jPCDz.default(attribute, issue.originals);
        const shouldShowChangeIndicator = isDirty && !showOptimizations;
        let shouldShowFlyout = false;
        let flyout = null;
        if (showOptimizations) {
            let optimizedValue = (0, $57dZR.getOptimizedValue)(issue, attribute);
            let currentValue = (0, $57dZR.getCurrentValue)(issue, attribute);
            const hasOptimizedValue = (0, $57dZR.hasValueChanged)(currentValue, optimizedValue);
            const deltaValue = typeof delta === 'function' ? delta(currentValue, optimizedValue, locale) : '';
            if (valueMapper) {
                optimizedValue = valueMapper(issue, optimizedValue);
                currentValue = valueMapper(issue, currentValue);
            }
            flyout = $6f1045661615d0ae$export$836a69893daa1f7c(currentValue, optimizedValue, deltaValue);
            shouldShowFlyout = hasOptimizedValue && showFlyout;
        }
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    ref: ref,
                    onMouseEnter: this.showFlyout,
                    onMouseLeave: this.hideFlyout,
                    "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.div"
                }, children, shouldShowChangeIndicator && ChangeIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeIndicator, null)),
            isOpen: shouldShowFlyout,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $6f1045661615d0ae$var$flyoutWrapperStyles
                }, flyout)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onMouseEnter: this.showFlyout,
            onMouseLeave: this.hideFlyout,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.div"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            content: flyout,
            isOpen: shouldShowFlyout
        }, this.props.children, shouldShowChangeIndicator && ChangeIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeIndicator, null)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            showFlyout: false
        };
        this.showFlyout = ()=>{
            this.setState({
                showFlyout: true
            });
        };
        this.hideFlyout = ()=>{
            this.setState({
                showFlyout: false
            });
        };
    }
}
const $6f1045661615d0ae$var$flyoutWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200'
});

});
parcelRegister("eNhh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $670e683807978bcd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $29yDk = parcelRequire("29yDk");
const $670e683807978bcd$var$INLINE_DIALOG_PADDING = 32;
const $670e683807978bcd$var$THRESHOLD = 50;
const $670e683807978bcd$var$TIMEOUT = 500;
function $670e683807978bcd$var$WithCloseOnScroll({ isOpen: isOpen, children: children }) {
    const containerElement = document.body;
    const distanceXRef = (0, $eUqFw.useRef)(0);
    const distanceYRef = (0, $eUqFw.useRef)(0);
    const timeoutIdRef = (0, $eUqFw.useRef)();
    const shouldClose = ()=>Math.abs(distanceXRef.current) >= $670e683807978bcd$var$THRESHOLD || Math.abs(distanceYRef.current) >= $670e683807978bcd$var$THRESHOLD;
    const resetThresholdChecking = (0, $eUqFw.useCallback)(()=>{
        distanceYRef.current = 0;
        distanceXRef.current = 0;
        timeoutIdRef.current = undefined;
    }, []);
    const closeDialog = (0, $eUqFw.useCallback)(()=>containerElement?.click(), [
        containerElement
    ]);
    // Function will check if the scroll delta (both horizontal and vertical) is
    // larger than the threshold and close the dialog.
    // If the scroll delta is less than the threshold, we sum all scroll deltas in 500ms.
    // If the sum is larger than the threshold, we close the dialog.
    // Reasoning: want to prevent the dialog from closing immediately if the user accidentally scrolls a few pixels.
    const handleWheel = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        distanceXRef.current += e.deltaX;
        distanceYRef.current += e.deltaY;
        if (shouldClose()) {
            closeDialog();
            resetThresholdChecking();
        }
        if (!timeoutIdRef.current) timeoutIdRef.current = setTimeout(()=>{
            if (shouldClose()) closeDialog();
            resetThresholdChecking();
        }, $670e683807978bcd$var$TIMEOUT);
    }, [
        closeDialog,
        resetThresholdChecking
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen) window.addEventListener('wheel', handleWheel, {
            passive: true
        });
        else window.removeEventListener('wheel', handleWheel);
        return ()=>window.removeEventListener('wheel', handleWheel);
    }, [
        isOpen,
        handleWheel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
}
class $670e683807978bcd$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        this.updateContainerStyles();
    }
    componentDidUpdate() {
        this.updateContainerStyles();
    }
    render() {
        return this.props.closeOnScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($670e683807978bcd$var$WithCloseOnScroll, {
            isOpen: this.props.isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), this.props)) : // @ts-expect-error - TS2741 - Property 'content' is missing in type '{ children?: ReactNode; }' but required in type 'Pick<Pick<PropsWithChildren<InlineDialogProps>, "children" | "content" | "testId" | "strategy" | "isOpen" | "placement" | "onContentBlur" | "onContentClick" | "onContentFocus" | "onClose"> & RefAttributes<...> & WithContextProps, "children" | ... 10 more ... | "onClose">'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), this.props);
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.updateContainerStyles = ()=>{
            const { maxWidth: maxWidth, minWidth: minWidth, isOpen: isOpen, noPaddings: noPaddings, noHorizontalScroll: noHorizontalScroll, zIndex: zIndex, overflow: overflow } = this.props;
            if (!isOpen) return;
            // eslint-disable-next-line react/no-find-dom-node
            const node = (0, $lEfVV.findDOMNode)(this);
            // this should find dialog content container,
            // keep it updated as you upgrade @atlaskit/inline-dialog
            const container = node && node.nextElementSibling;
            if (!(container instanceof HTMLElement)) return;
            container.setAttribute('role', 'inlineDialogContent');
            if (noPaddings) container.style.padding = '0';
            if (maxWidth) {
                const width = noPaddings ? maxWidth : maxWidth + $670e683807978bcd$var$INLINE_DIALOG_PADDING;
                container.style.maxWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (minWidth) {
                const width = noPaddings ? minWidth : minWidth + $670e683807978bcd$var$INLINE_DIALOG_PADDING;
                container.style.minWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (overflow) container.style.overflow = overflow;
            if (noHorizontalScroll) container.style.maxWidth = 'initial';
            container.style.maxHeight = 'initial';
            //  custom zIndex can be used only when we have 2 or more inline dialogs and has to define their priorities
            // initially it has been added because of https://bulldog.internal.atlassian.com/browse/JPOS-4104
            container.style.zIndex = zIndex;
        };
    }
}

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = undefined;
const $99fb58582e83d080$var$packageVersion = undefined;
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
const $99fb58582e83d080$var$InlineDialogWithLayering = ({ isOpen: isOpen, onContentBlur: onContentBlur, onContentClick: onContentClick, onContentFocus: onContentFocus, onClose: onClose, placement: placement, strategy: strategy, testId: testId, content: content, children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p') ? !isOpen : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$export$513033cc22e3bc20, {
        isOpen: isOpen,
        onContentBlur: onContentBlur,
        onContentClick: onContentClick,
        onContentFocus: onContentFocus,
        onClose: onClose,
        placement: placement,
        strategy: strategy,
        testId: testId,
        content: content
    }, children));
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p')) {
            if (!isLayerDisabled()) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        } else {
            // handles the case where inline dialog opens portalled elements such as modal
            if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
            // call onClose if the click originated from outside the dialog
            if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        }
    }, [
        isLayerDisabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.inline-message-layering_wfp1p') && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $99fb58582e83d080$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$var$InlineDialogWithLayering));

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});



parcelRegister("57dZR", function(module, exports) {

$parcel$export(module.exports, "getHighlightRowId", () => $dd3a8014c196edc0$export$a23875ea10851868);
$parcel$export(module.exports, "getRowHighlighter", () => $dd3a8014c196edc0$export$3d44be5a96fa58c3);
$parcel$export(module.exports, "getCurrentValue", () => $dd3a8014c196edc0$export$f277181e65de46c7);
$parcel$export(module.exports, "getOptimizedValue", () => $dd3a8014c196edc0$export$f2a3a2f8a1013b3);
$parcel$export(module.exports, "hasValueChanged", () => $dd3a8014c196edc0$export$95598ecadc03a242);
$parcel$export(module.exports, "getInlineCreateIssueTypeId", () => $dd3a8014c196edc0$export$be1dd65e66c75e08);
$parcel$export(module.exports, "toggleRowHighlighter", () => $dd3a8014c196edc0$export$55759e443003e7b2);
$parcel$export(module.exports, "shouldSetOnboardingWidth", () => $dd3a8014c196edc0$export$bba978883a886a);
$parcel$export(module.exports, "getSectionsData", () => $dd3a8014c196edc0$export$a822c88ebfae7388);
$parcel$export(module.exports, "getExperienceName", () => $dd3a8014c196edc0$export$4ce0bedef4e84bb7);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $kxKIR = parcelRequire("kxKIR");

var $5iWql = parcelRequire("5iWql");

var $7d70y = parcelRequire("7d70y");
var $5OdRK = parcelRequire("5OdRK");
var $jPCDz = parcelRequire("jPCDz");
var $kDrtX = parcelRequire("kDrtX");

var $g4Vkx = parcelRequire("g4Vkx");
var $lcvrv = parcelRequire("lcvrv");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $cJ2vZ = parcelRequire("cJ2vZ");
const $dd3a8014c196edc0$var$MIN_VIEWPORT_WIDTH = 1024;
const $dd3a8014c196edc0$var$ONBOARDING_MESSAGE_WIDTH = 320;
const $dd3a8014c196edc0$export$a23875ea10851868 = (group, issueId = '')=>(0, (/*@__PURE__*/$parcel$interopDefault($kxKIR)))((0, $7CnHa.isDefined)(group) ? `${group}_${issueId}` : issueId);
const $dd3a8014c196edc0$export$3d44be5a96fa58c3 = (group, issueId, isWarningRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $cJ2vZ.rowHighlighter,
        "data-highlight-row": $dd3a8014c196edc0$export$a23875ea10851868(group, issueId),
        style: {
            backgroundColor: isWarningRow ? `var(--ds-background-warning, ${(0, $g4Vkx.default).Y200})` : `var(--ds-text, ${(0, $g4Vkx.default).N800})`
        }
    });
const $dd3a8014c196edc0$export$f277181e65de46c7 = (issue, attribute)=>issue.inferred && $jPCDz.default(attribute, issue.inferred) ? undefined : issue[attribute];
const $dd3a8014c196edc0$export$f2a3a2f8a1013b3 = (issue, attribute)=>issue.optimized && $jPCDz.default(attribute, issue.optimized) ? issue.optimized[attribute] : $dd3a8014c196edc0$export$f277181e65de46c7(issue, attribute);
const $dd3a8014c196edc0$export$95598ecadc03a242 = (currentValue, optimizedValue)=>{
    if ($kDrtX.default(currentValue) && $kDrtX.default(optimizedValue)) return false;
    return !$5OdRK.default(currentValue, optimizedValue);
};
const $dd3a8014c196edc0$export$be1dd65e66c75e08 = (level, inlineCreateProject, props)=>{
    const { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy, typeToLevel: typeToLevel } = props;
    // Give preference to IssueTypeIdForHierarchy as it stores the most recent user's choice.
    if (IssueTypeIdForHierarchy && (0, $7CnHa.isDefined)(IssueTypeIdForHierarchy[level]) && $7d70y.default(IssueTypeIdForHierarchy[level], inlineCreateProject.issueTypeIds) && typeToLevel(IssueTypeIdForHierarchy[level]) === level) return IssueTypeIdForHierarchy[level];
    // Then try given issueTypeId if it fits.
    if ($7d70y.default(issueTypeId, inlineCreateProject.issueTypeIds) && typeToLevel(issueTypeId) === level) return issueTypeId;
    // And finally try to find anything suitable among project issue types.
    const inlineCreateIssueTypeId = inlineCreateProject.issueTypeIds.find((id)=>typeToLevel(id) === level);
    if (!(0, $7CnHa.isDefined)(inlineCreateIssueTypeId)) throw new Error(`inlineCreateProject doesn't have issue type corresponding to the ${level}`);
    return inlineCreateIssueTypeId;
};
const $dd3a8014c196edc0$export$55759e443003e7b2 = (id, isOn)=>{
    const opacity = isOn ? '0.08' : '0';
    const query = `[data-highlight-row="${id}"]`;
    // Unable to use @ts-expect-error it conflicts with typecheck with project references according to which ts-expect error is not needed and existing typecheck requires it, hence ignoring it till TS project references are enabled
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - error TS2488: Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const element of document.querySelectorAll(query))// Unable to use @ts-expect-error it conflicts with typecheck with project references according to which ts-expect error is not needed and existing typecheck requires it, hence ignoring it till TS project references are enabled
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TS2339 - Property 'style' does not exist on type 'Element'.
    element.style.opacity = opacity;
};
const $dd3a8014c196edc0$export$bba978883a886a = (section, containerWidth)=>{
    if (containerWidth < $dd3a8014c196edc0$var$MIN_VIEWPORT_WIDTH) return false;
    if (section.id === 'scope-column' && section.width + $dd3a8014c196edc0$var$ONBOARDING_MESSAGE_WIDTH >= containerWidth) return true;
    if (section.id === 'fields-column' && (section.width <= section.minWidth || section.width + 2 * $dd3a8014c196edc0$var$ONBOARDING_MESSAGE_WIDTH > containerWidth)) return true;
    return section.id === 'timeline-column' && section.width <= section.minWidth;
};
const $dd3a8014c196edc0$export$a822c88ebfae7388 = (0, $5iWql.default)(({ formatMessage: formatMessage }, viewMode)=>{
    const sections = [
        {
            initialWidth: 300,
            minWidth: 300,
            isFixed: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE,
            id: (0, $5rYNM.SECTION_ITEM_KEYS).SCOPE,
            title: formatMessage((0, $ib5d3.default).scope),
            collapsible: false,
            onboardingWidth: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? 30 : 50
        },
        {
            initialWidth: 3 * (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE,
            minWidth: 32,
            isFixed: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE,
            id: (0, $5rYNM.SECTION_ITEM_KEYS).FIELDS,
            title: formatMessage((0, $ib5d3.default).fields),
            collapsible: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE,
            onboardingWidth: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? 35 : 50
        }
    ];
    if (viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE) sections.push({
        initialWidth: 100,
        minWidth: 32,
        isFixed: false,
        id: (0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE,
        title: formatMessage((0, $ib5d3.default).timeline),
        collapsible: true,
        onboardingWidth: 35
    });
    return sections;
});
const $dd3a8014c196edc0$export$4ce0bedef4e84bb7 = (isReportMode, isConfluenceMacro, isEmbedReportView)=>{
    if (isEmbedReportView) return 'viewPortfolio3Embed';
    if (isConfluenceMacro) return 'viewPortfolio3ConfluenceEmbed';
    if (isReportMode) return 'viewPortfolio3Report';
    return 'viewPortfolio3Roadmap';
};

});
parcelRegister("kxKIR", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $ef4b21d93f469fa3$var$func = $jFIrw('escape', (parcelRequire("kLTaL")), (parcelRequire("jKGa6")));

$ef4b21d93f469fa3$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $ef4b21d93f469fa3$var$func;

});
parcelRegister("kLTaL", function(module, exports) {

var $j61lW = parcelRequire("j61lW");

var $1uqnh = parcelRequire("1uqnh");
/** Used to match HTML entities and HTML characters. */ var $f1f2fe915f63c33a$var$reUnescapedHtml = /[&<>"']/g, $f1f2fe915f63c33a$var$reHasUnescapedHtml = RegExp($f1f2fe915f63c33a$var$reUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */ function $f1f2fe915f63c33a$var$escape(string) {
    string = $1uqnh(string);
    return string && $f1f2fe915f63c33a$var$reHasUnescapedHtml.test(string) ? string.replace($f1f2fe915f63c33a$var$reUnescapedHtml, $j61lW) : string;
}
module.exports = $f1f2fe915f63c33a$var$escape;

});
parcelRegister("j61lW", function(module, exports) {

var $aJZyN = parcelRequire("aJZyN");
/** Used to map characters to HTML entities. */ var $de6fa08a33c172be$var$htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */ var $de6fa08a33c172be$var$escapeHtmlChar = $aJZyN($de6fa08a33c172be$var$htmlEscapes);
module.exports = $de6fa08a33c172be$var$escapeHtmlChar;

});



parcelRegister("7d70y", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ff2ef0c47e7e60$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */ var $53ff2ef0c47e7e60$var$contains = /*#__PURE__*/ (0, $ggdJA.default)((0, $75bQw.default));
var $53ff2ef0c47e7e60$export$2e2bcd8739ae039 = $53ff2ef0c47e7e60$var$contains;

});

parcelRegister("cJ2vZ", function(module, exports) {

$parcel$export(module.exports, "columnsTexts", () => $943ba36858cb53b2$export$a9d8bcc9cf44210e, (v) => $943ba36858cb53b2$export$a9d8bcc9cf44210e = v);
$parcel$export(module.exports, "container", () => $943ba36858cb53b2$export$34e0f9847d4c02dd, (v) => $943ba36858cb53b2$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "content-header", () => $943ba36858cb53b2$export$9d1727038373c126, (v) => $943ba36858cb53b2$export$9d1727038373c126 = v);
$parcel$export(module.exports, "content-row", () => $943ba36858cb53b2$export$1b84428217457dc3, (v) => $943ba36858cb53b2$export$1b84428217457dc3 = v);
$parcel$export(module.exports, "content-scroller", () => $943ba36858cb53b2$export$1a1ae98421834be9, (v) => $943ba36858cb53b2$export$1a1ae98421834be9 = v);
$parcel$export(module.exports, "content-scroller-export", () => $943ba36858cb53b2$export$cb31a111370bb06c, (v) => $943ba36858cb53b2$export$cb31a111370bb06c = v);
$parcel$export(module.exports, "contentArea", () => $943ba36858cb53b2$export$26bdc8f90c1f72f6, (v) => $943ba36858cb53b2$export$26bdc8f90c1f72f6 = v);
$parcel$export(module.exports, "fields-column", () => $943ba36858cb53b2$export$37fa2e596216ead5, (v) => $943ba36858cb53b2$export$37fa2e596216ead5 = v);
$parcel$export(module.exports, "fullScreen", () => $943ba36858cb53b2$export$708e76f13b8a286c, (v) => $943ba36858cb53b2$export$708e76f13b8a286c = v);
$parcel$export(module.exports, "highlight", () => $943ba36858cb53b2$export$e4043f67d36cbb26, (v) => $943ba36858cb53b2$export$e4043f67d36cbb26 = v);
$parcel$export(module.exports, "horizontalScrollbar", () => $943ba36858cb53b2$export$eaff3a7f2873082e, (v) => $943ba36858cb53b2$export$eaff3a7f2873082e = v);
$parcel$export(module.exports, "mainSections", () => $943ba36858cb53b2$export$45b4f5aeebd36310, (v) => $943ba36858cb53b2$export$45b4f5aeebd36310 = v);
$parcel$export(module.exports, "mainSectionsWrap", () => $943ba36858cb53b2$export$1d8563297886613e, (v) => $943ba36858cb53b2$export$1d8563297886613e = v);
$parcel$export(module.exports, "optimized", () => $943ba36858cb53b2$export$9b9b1652bca12cee, (v) => $943ba36858cb53b2$export$9b9b1652bca12cee = v);
$parcel$export(module.exports, "pointer-cursor", () => $943ba36858cb53b2$export$276c65bb3f69c2dd, (v) => $943ba36858cb53b2$export$276c65bb3f69c2dd = v);
$parcel$export(module.exports, "rowHighlighter", () => $943ba36858cb53b2$export$a2c8b4da76b89a3f, (v) => $943ba36858cb53b2$export$a2c8b4da76b89a3f = v);
$parcel$export(module.exports, "scope-column", () => $943ba36858cb53b2$export$fd3660ce8c0cae8c, (v) => $943ba36858cb53b2$export$fd3660ce8c0cae8c = v);
$parcel$export(module.exports, "scope-container", () => $943ba36858cb53b2$export$8679d1488887bbf9, (v) => $943ba36858cb53b2$export$8679d1488887bbf9 = v);
$parcel$export(module.exports, "space", () => $943ba36858cb53b2$export$a941ed4b947d12f8, (v) => $943ba36858cb53b2$export$a941ed4b947d12f8 = v);
$parcel$export(module.exports, "sticky-headers", () => $943ba36858cb53b2$export$841b8acc5177368a, (v) => $943ba36858cb53b2$export$841b8acc5177368a = v);
$parcel$export(module.exports, "timeline-column", () => $943ba36858cb53b2$export$b50d7ef348eef170, (v) => $943ba36858cb53b2$export$b50d7ef348eef170 = v);
$parcel$export(module.exports, "timeline-column-header", () => $943ba36858cb53b2$export$b490673c2354b6f5, (v) => $943ba36858cb53b2$export$b490673c2354b6f5 = v);
var $943ba36858cb53b2$export$a9d8bcc9cf44210e;
var $943ba36858cb53b2$export$34e0f9847d4c02dd;
var $943ba36858cb53b2$export$9d1727038373c126;
var $943ba36858cb53b2$export$1b84428217457dc3;
var $943ba36858cb53b2$export$1a1ae98421834be9;
var $943ba36858cb53b2$export$cb31a111370bb06c;
var $943ba36858cb53b2$export$26bdc8f90c1f72f6;
var $943ba36858cb53b2$export$37fa2e596216ead5;
var $943ba36858cb53b2$export$708e76f13b8a286c;
var $943ba36858cb53b2$export$e4043f67d36cbb26;
var $943ba36858cb53b2$export$eaff3a7f2873082e;
var $943ba36858cb53b2$export$45b4f5aeebd36310;
var $943ba36858cb53b2$export$1d8563297886613e;
var $943ba36858cb53b2$export$9b9b1652bca12cee;
var $943ba36858cb53b2$export$276c65bb3f69c2dd;
var $943ba36858cb53b2$export$a2c8b4da76b89a3f;
var $943ba36858cb53b2$export$fd3660ce8c0cae8c;
var $943ba36858cb53b2$export$8679d1488887bbf9;
var $943ba36858cb53b2$export$a941ed4b947d12f8;
var $943ba36858cb53b2$export$841b8acc5177368a;
var $943ba36858cb53b2$export$b50d7ef348eef170;
var $943ba36858cb53b2$export$b490673c2354b6f5;
$943ba36858cb53b2$export$a9d8bcc9cf44210e = `Afe8Za_columnsTexts`;
$943ba36858cb53b2$export$34e0f9847d4c02dd = `Afe8Za_container`;
$943ba36858cb53b2$export$9d1727038373c126 = `Afe8Za_content-header`;
$943ba36858cb53b2$export$1b84428217457dc3 = `Afe8Za_content-row`;
$943ba36858cb53b2$export$1a1ae98421834be9 = `Afe8Za_content-scroller`;
$943ba36858cb53b2$export$cb31a111370bb06c = `Afe8Za_content-scroller-export`;
$943ba36858cb53b2$export$26bdc8f90c1f72f6 = `Afe8Za_contentArea`;
$943ba36858cb53b2$export$37fa2e596216ead5 = `Afe8Za_fields-column`;
$943ba36858cb53b2$export$708e76f13b8a286c = `Afe8Za_fullScreen`;
$943ba36858cb53b2$export$e4043f67d36cbb26 = `Afe8Za_highlight`;
$943ba36858cb53b2$export$eaff3a7f2873082e = `Afe8Za_horizontalScrollbar`;
$943ba36858cb53b2$export$45b4f5aeebd36310 = `Afe8Za_mainSections`;
$943ba36858cb53b2$export$1d8563297886613e = `Afe8Za_mainSectionsWrap`;
$943ba36858cb53b2$export$9b9b1652bca12cee = `Afe8Za_optimized`;
$943ba36858cb53b2$export$276c65bb3f69c2dd = `Afe8Za_pointer-cursor`;
$943ba36858cb53b2$export$a2c8b4da76b89a3f = `Afe8Za_rowHighlighter`;
$943ba36858cb53b2$export$fd3660ce8c0cae8c = `Afe8Za_scope-column`;
$943ba36858cb53b2$export$8679d1488887bbf9 = `Afe8Za_scope-container`;
$943ba36858cb53b2$export$a941ed4b947d12f8 = `Afe8Za_space`;
$943ba36858cb53b2$export$841b8acc5177368a = `Afe8Za_sticky-headers`;
$943ba36858cb53b2$export$b50d7ef348eef170 = `Afe8Za_timeline-column`;
$943ba36858cb53b2$export$b490673c2354b6f5 = `Afe8Za_timeline-column-header`;

});


parcelRegister("4UWBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b87c7ce88a9184d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jZfNw = parcelRequire("jZfNw");

var $435fl = parcelRequire("435fl");
var $6b87c7ce88a9184d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jZfNw.default), {})((0, $435fl.default));

});
parcelRegister("jZfNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $31682943fc2a22c1$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");
const $31682943fc2a22c1$var$mapStateToProps = (state)=>({
        currentScenarioColor: (0, $75KhQ.getCurrentScenarioColor)(state)
    });
var $31682943fc2a22c1$export$2e2bcd8739ae039 = $31682943fc2a22c1$var$mapStateToProps;

});

parcelRegister("435fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d354f9a8b5b980$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $gwbfD = parcelRequire("gwbfD");

var $ib5d3 = parcelRequire("ib5d3");

var $ai1R5 = parcelRequire("ai1R5");
function $b8d354f9a8b5b980$export$eb0ebb5fe48d40a7({ currentScenarioColor: currentScenarioColor = `var(--ds-text-warning, ${(0, $g4Vkx.default).Y400})`, appearance: appearance = 'triangle', borderRadius: borderRadius }) {
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $ib5d3.default).changeIndicatorTooltip),
        position: "mouse"
    }, appearance === 'triangle' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.common.change-indicator",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ai1R5.triangle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        width: "10" // Seems to be a minimum width/height else the svg doesn't render properly in chrome
        ,
        height: "10",
        style: {
            borderTopRightRadius: borderRadius
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        points: "0,0  100,0  100,100",
        style: {
            fill: currentScenarioColor
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.common.change-indicator",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ai1R5[appearance],
        style: {
            backgroundColor: currentScenarioColor,
            borderTopLeftRadius: borderRadius,
            borderBottomLeftRadius: borderRadius
        }
    }));
}
var $b8d354f9a8b5b980$export$2e2bcd8739ae039 = $b8d354f9a8b5b980$export$eb0ebb5fe48d40a7;

});
parcelRegister("ai1R5", function(module, exports) {

$parcel$export(module.exports, "bar", () => $77dd06397ebb8016$export$d927737047eb3867, (v) => $77dd06397ebb8016$export$d927737047eb3867 = v);
$parcel$export(module.exports, "triangle", () => $77dd06397ebb8016$export$9eed783d03e0135c, (v) => $77dd06397ebb8016$export$9eed783d03e0135c = v);
var $77dd06397ebb8016$export$d927737047eb3867;
var $77dd06397ebb8016$export$9eed783d03e0135c;
$77dd06397ebb8016$export$d927737047eb3867 = `_6DYw6W_bar`;
$77dd06397ebb8016$export$9eed783d03e0135c = `_6DYw6W_triangle`;

});



parcelRegister("1Ml8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $e176dc1ff225e790$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $g4Vkx = parcelRequire("g4Vkx");

var $ib5d3 = parcelRequire("ib5d3");

var $l3kze = parcelRequire("l3kze");

var $g9AI6 = parcelRequire("g9AI6");
function $e176dc1ff225e790$var$FieldFlyout(props) {
    const { optimized: optimized, intl: intl, current: current, delta: delta } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $g9AI6.flyout,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.changes-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g9AI6.column
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g9AI6.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).current)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: current ? $g9AI6.value : $g9AI6["no-value"]
    }, current || intl.formatMessage({
        ...(0, $l3kze.default).noValue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g9AI6.column
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "",
        primaryColor: `var(--ds-background-neutral-bold, ${(0, $g4Vkx.default).N200})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g9AI6.column
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g9AI6.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $l3kze.default).whenAccepted)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: optimized ? $g9AI6.value : $g9AI6["no-value"]
    }, optimized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, optimized, " ", delta) : intl.formatMessage({
        ...(0, $l3kze.default).noValue
    }))));
}
$e176dc1ff225e790$var$FieldFlyout.defaultProps = {
    delta: ''
};
var $e176dc1ff225e790$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e176dc1ff225e790$var$FieldFlyout);

});
parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.793 5.793a.999.999 0 000 1.414L15.586 11H6a1 1 0 000 2h9.586l-3.793 3.793a.999.999 0 000 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 00.293-.679v-.057a.996.996 0 00-.293-.678l-5.499-5.5a1 1 0 00-1.415 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = $9601eacac1d33448$var$ArrowRightIcon;
module.exports.default = $9601eacac1d33448$var$_default;

});

parcelRegister("l3kze", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c4810129ba2c00c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9c4810129ba2c00c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whenAccepted: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.when-accepted",
        "defaultMessage": "When accepted"
    },
    noValue: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.cell.flyout.no-value",
        "defaultMessage": "None"
    }
});

});

parcelRegister("g9AI6", function(module, exports) {

$parcel$export(module.exports, "column", () => $bc29f68580df1c46$export$4e0c71f277ca26b3, (v) => $bc29f68580df1c46$export$4e0c71f277ca26b3 = v);
$parcel$export(module.exports, "flyout", () => $bc29f68580df1c46$export$ec4922be16378791, (v) => $bc29f68580df1c46$export$ec4922be16378791 = v);
$parcel$export(module.exports, "heading", () => $bc29f68580df1c46$export$46e4a324ac90507f, (v) => $bc29f68580df1c46$export$46e4a324ac90507f = v);
$parcel$export(module.exports, "no-value", () => $bc29f68580df1c46$export$5b267f5c7fc66f30, (v) => $bc29f68580df1c46$export$5b267f5c7fc66f30 = v);
$parcel$export(module.exports, "value", () => $bc29f68580df1c46$export$2ab9a8f9f1186f14, (v) => $bc29f68580df1c46$export$2ab9a8f9f1186f14 = v);
var $bc29f68580df1c46$export$4e0c71f277ca26b3;
var $bc29f68580df1c46$export$ec4922be16378791;
var $bc29f68580df1c46$export$46e4a324ac90507f;
var $bc29f68580df1c46$export$5b267f5c7fc66f30;
var $bc29f68580df1c46$export$2ab9a8f9f1186f14;
$bc29f68580df1c46$export$4e0c71f277ca26b3 = `oXsrEG_column`;
$bc29f68580df1c46$export$ec4922be16378791 = `oXsrEG_flyout`;
$bc29f68580df1c46$export$46e4a324ac90507f = `oXsrEG_heading`;
$bc29f68580df1c46$export$5b267f5c7fc66f30 = `oXsrEG_no-value`;
$bc29f68580df1c46$export$2ab9a8f9f1186f14 = `oXsrEG_value`;

});



parcelRegister("cjjm8", function(module, exports) {

$parcel$export(module.exports, "componentsContainer", () => $8f664615222f6dd7$export$77d38a6d62c7a7c9, (v) => $8f664615222f6dd7$export$77d38a6d62c7a7c9 = v);
$parcel$export(module.exports, "componentsContainerDisabled", () => $8f664615222f6dd7$export$f8fe21d67e4e5ecf, (v) => $8f664615222f6dd7$export$f8fe21d67e4e5ecf = v);
$parcel$export(module.exports, "disabled", () => $8f664615222f6dd7$export$683472f6198a076e, (v) => $8f664615222f6dd7$export$683472f6198a076e = v);
$parcel$export(module.exports, "hiddenContainer", () => $8f664615222f6dd7$export$182c1d64f1533c1d, (v) => $8f664615222f6dd7$export$182c1d64f1533c1d = v);
$parcel$export(module.exports, "item", () => $8f664615222f6dd7$export$7061c75fc5af8b7e, (v) => $8f664615222f6dd7$export$7061c75fc5af8b7e = v);
$parcel$export(module.exports, "itemsWrapper", () => $8f664615222f6dd7$export$c11ed2585ba4746a, (v) => $8f664615222f6dd7$export$c11ed2585ba4746a = v);
$parcel$export(module.exports, "labelsContainer", () => $8f664615222f6dd7$export$dc574f36aa67ced6, (v) => $8f664615222f6dd7$export$dc574f36aa67ced6 = v);
$parcel$export(module.exports, "tagContainer", () => $8f664615222f6dd7$export$89a4c13858b336ea, (v) => $8f664615222f6dd7$export$89a4c13858b336ea = v);
var $8f664615222f6dd7$export$77d38a6d62c7a7c9;
var $8f664615222f6dd7$export$f8fe21d67e4e5ecf;
var $8f664615222f6dd7$export$683472f6198a076e;
var $8f664615222f6dd7$export$182c1d64f1533c1d;
var $8f664615222f6dd7$export$7061c75fc5af8b7e;
var $8f664615222f6dd7$export$c11ed2585ba4746a;
var $8f664615222f6dd7$export$dc574f36aa67ced6;
var $8f664615222f6dd7$export$89a4c13858b336ea;
$8f664615222f6dd7$export$77d38a6d62c7a7c9 = `or0DHa_componentsContainer`;
$8f664615222f6dd7$export$f8fe21d67e4e5ecf = `or0DHa_componentsContainerDisabled`;
$8f664615222f6dd7$export$683472f6198a076e = `or0DHa_disabled`;
$8f664615222f6dd7$export$182c1d64f1533c1d = `or0DHa_hiddenContainer`;
$8f664615222f6dd7$export$7061c75fc5af8b7e = `or0DHa_item`;
$8f664615222f6dd7$export$c11ed2585ba4746a = `or0DHa_itemsWrapper`;
$8f664615222f6dd7$export$dc574f36aa67ced6 = `or0DHa_labelsContainer`;
$8f664615222f6dd7$export$89a4c13858b336ea = `or0DHa_tagContainer`;

});

parcelRegister("5omWp", function(module, exports) {

$parcel$export(module.exports, "selectStyles", () => $b9c790ea0bee39de$export$70a9ea0b017c448a);
const $b9c790ea0bee39de$export$70a9ea0b017c448a = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    container: (styles, { selectProps: { menuIsOpen: menuIsOpen } })=>({
            ...styles,
            ...menuIsOpen ? {
                zIndex: 1
            } : {}
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen } })=>menuIsOpen ? {
            ...styles,
            zIndex: 99999
        } : {
            ...styles,
            background: 'none',
            borderColor: 'transparent',
            // eslint-disable-next-line no-useless-computed-key
            [':hover']: {
                ...styles[':hover'],
                background: 'none',
                ...hasValue ? {
                    borderColor: 'transparent'
                } : {}
            }
        },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dropdownIndicator (styles) {
        return {
            ...styles,
            alignSelf: 'flex-start'
        };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer (styles) {
        return {
            ...styles,
            maxHeight: 150,
            overflow: 'auto',
            flex: '1'
        };
    }
};

});




parcelRegister("irfuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5155bb82382f96f$export$2e2bcd8739ae039);

var $gGKRb = parcelRequire("gGKRb");
var $d5155bb82382f96f$export$2e2bcd8739ae039 = (0, $gGKRb.SelectForColumnCell);

});

parcelRegister("8lLGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2168419490b439$export$2e2bcd8739ae039);

var $gGKRb = parcelRequire("gGKRb");
var $ec2168419490b439$export$2e2bcd8739ae039 = (0, $gGKRb.SelectForColumnCell);

});

parcelRegister("4vPWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d9bba6f6ecde1f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $gwbfD = parcelRequire("gwbfD");

var $7CnHa = parcelRequire("7CnHa");
const $b1d9bba6f6ecde1f$export$6170d04d90efda45 = ({ title: title, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        delay: 1000,
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d9bba6f6ecde1f$var$ReadViewContainer, null, (0, $7CnHa.isDefined)(avatarUrl) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d9bba6f6ecde1f$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        borderColor: "transparent",
        src: avatarUrl,
        size: "xsmall"
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d9bba6f6ecde1f$var$NameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, title))));
var $b1d9bba6f6ecde1f$export$2e2bcd8739ae039 = $b1d9bba6f6ecde1f$export$6170d04d90efda45;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1d9bba6f6ecde1f$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $b1d9bba6f6ecde1f$var$NameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _vwz4gktf _s7n4nkob _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $b1d9bba6f6ecde1f$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf _18s812x7 _1yt41b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iYRB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f113e8caedf4ee21$export$2e2bcd8739ae039);

var $gkXIa = parcelRequire("gkXIa");
var $f113e8caedf4ee21$export$2e2bcd8739ae039 = (0, $gkXIa.default);

});
parcelRegister("gkXIa", function(module, exports) {

$parcel$export(module.exports, "UserSelectItem", () => $c92a7b13077832a5$export$7f3c0720363a56f3);
$parcel$export(module.exports, "formatOptionLabel", () => $c92a7b13077832a5$export$322216d90ffb8d0e);
$parcel$export(module.exports, "default", () => $c92a7b13077832a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $9OdO2 = parcelRequire("9OdO2");

var $eo8NR = parcelRequire("eo8NR");

var $fXlPv = parcelRequire("fXlPv");

var $hkOxK = parcelRequire("hkOxK");
var $eUK1h = parcelRequire("eUK1h");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $haaWO = parcelRequire("haaWO");
var $cQGVO = parcelRequire("cQGVO");
var $l3byl = parcelRequire("l3byl");
var $aylCn = parcelRequire("aylCn");
var $701od = parcelRequire("701od");

var $iJlfe = parcelRequire("iJlfe");

var $akSC8 = parcelRequire("akSC8");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $4mvyb = parcelRequire("4mvyb");

var $5GJ80 = parcelRequire("5GJ80");
const $c92a7b13077832a5$export$7f3c0720363a56f3 = ({ icon: icon, email: email, label: label })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4mvyb.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4mvyb.optionAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: icon,
        borderColor: "transparent"
    })), email && label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4mvyb.optionEmail
    }, email)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4mvyb.optionUnassigned
    }, label));
const $c92a7b13077832a5$export$322216d90ffb8d0e = (opt, { context: context })=>context === 'value' ? (0, $akSC8.selectOptionWithAvatar)(opt) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c92a7b13077832a5$export$7f3c0720363a56f3, opt);
// eslint-disable-next-line jira/react/no-class-components
class $c92a7b13077832a5$var$UserPicker extends (0, $eUqFw.Component) {
    getDisplayedUsers(userOptions, query) {
        const { maxOptionsPerGroup: maxOptionsPerGroup } = this.props;
        if (maxOptionsPerGroup) {
            const getFullText = $hkOxK.default($701od.default, $haaWO.default(' '), // @ts-expect-error R.Props seems very difficult to make TS happy
            $l3byl.default([
                'label',
                'email'
            ]));
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const matchQuery = $eUK1h.default((query, option)=>$1l9vO.default($701od.default(query))(getFullText(option)));
            const transformOptions = $hkOxK.default($aylCn.default(maxOptionsPerGroup), (array)=>query ? $fpul1.default(matchQuery(query), array) : array);
            return (0, $5GJ80.isGroupedOptions)(userOptions) ? $cQGVO.default(({ options: options, ...rest })=>({
                    options: transformOptions(options),
                    ...rest
                }))(userOptions) : transformOptions(userOptions);
        }
        return userOptions;
    }
    render() {
        const { FieldSelect: FieldSelect, user: user, userList: userList, selectProps: selectProps, issueId: issueId, attribute: attribute, placeholder: placeholder } = this.props;
        const currentUserValue = user?.value || '';
        const selectedUser = (0, $5GJ80.isGroupedOptions)(userList) ? (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))((0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))((0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))(userList, 'options')), (0, (/*@__PURE__*/$parcel$interopDefault($fXlPv)))('value', currentUserValue)) : (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(userList, (0, (/*@__PURE__*/$parcel$interopDefault($fXlPv)))('value', currentUserValue));
        const onQuerySearch = (query, { action: action })=>{
            if (action === 'input-change') {
                const { onFetchUserList: onFetchUserList } = this.props;
                onFetchUserList(query);
                this.setState(()=>({
                        query: query
                    }));
            }
        };
        const props = {
            formatOptionLabel: $c92a7b13077832a5$export$322216d90ffb8d0e,
            options: this.getDisplayedUsers(userList, this.state.query),
            onChange: this.onUserChange,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            onInputChange: onQuerySearch,
            value: (0, $7CnHa.isDefined)(selectedUser) ? selectedUser : null,
            issueId: issueId,
            attribute: attribute,
            filterOption: $5GJ80.filterOption,
            placeholder: placeholder,
            ...selectProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            query: ''
        };
        this.onUserChange = (selection)=>{
            const { onUserChange: onUserChange } = this.props;
            if (selection && typeof selection.value === 'string') onUserChange(selection.value);
            else onUserChange(null);
        };
        this.onMenuOpen = ()=>{
            const { onFetchUserList: onFetchUserList, updateUserOption: updateUserOption, user: user } = this.props;
            onFetchUserList('');
            if ((0, $7CnHa.isDefined)(updateUserOption)) updateUserOption(user && user.value);
        };
        this.onMenuClose = ()=>{
            this.setState(()=>({
                    query: ''
                }));
        };
    }
}
var $c92a7b13077832a5$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})($c92a7b13077832a5$var$UserPicker);

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});


parcelRegister("fXlPv", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $8okHL = parcelRequire("8okHL");
/** Used to compose bitmasks for cloning. */ var $b9dd4c9dc2b30956$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */ function $b9dd4c9dc2b30956$var$matchesProperty(path, srcValue) {
    return $8okHL(path, $ee7Ev(srcValue, $b9dd4c9dc2b30956$var$CLONE_DEEP_FLAG));
}
module.exports = $b9dd4c9dc2b30956$var$matchesProperty;

});

parcelRegister("eUK1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb9fe2ed21ade0e$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $bwMm3 = parcelRequire("bwMm3");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $adb9fe2ed21ade0e$var$curry = /*#__PURE__*/ (0, $eSWTK.default)(function curry(fn) {
    return (0, $bwMm3.default)(fn.length, fn);
});
var $adb9fe2ed21ade0e$export$2e2bcd8739ae039 = $adb9fe2ed21ade0e$var$curry;

});

parcelRegister("aylCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aedd939d024dbb3$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $fNuNs = parcelRequire("fNuNs");

var $aaoZV = parcelRequire("aaoZV");
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $7aedd939d024dbb3$var$take = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'take'
], (0, $fNuNs.default), function take(n, xs) {
    return (0, $aaoZV.default)(0, n < 0 ? Infinity : n, xs);
}));
var $7aedd939d024dbb3$export$2e2bcd8739ae039 = $7aedd939d024dbb3$var$take;

});
parcelRegister("fNuNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b80352357e6ee318$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $b80352357e6ee318$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XTake.prototype['@@transducer/result'] = (0, $8uquE.default).result;
    XTake.prototype['@@transducer/step'] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $5zr36.default)(ret) : ret;
    };
    return XTake;
}();
var $b80352357e6ee318$var$_xtake = /*#__PURE__*/ (0, $ggdJA.default)(function _xtake(n, xf) {
    return new $b80352357e6ee318$var$XTake(n, xf);
});
var $b80352357e6ee318$export$2e2bcd8739ae039 = $b80352357e6ee318$var$_xtake;

});


parcelRegister("4mvyb", function(module, exports) {

$parcel$export(module.exports, "option", () => $32d1b0bc6ab6ae81$export$a75d1723e6bda2ec, (v) => $32d1b0bc6ab6ae81$export$a75d1723e6bda2ec = v);
$parcel$export(module.exports, "optionAvatar", () => $32d1b0bc6ab6ae81$export$74d139e8e4ac3515, (v) => $32d1b0bc6ab6ae81$export$74d139e8e4ac3515 = v);
$parcel$export(module.exports, "optionEmail", () => $32d1b0bc6ab6ae81$export$a1cdb2bb0f192cfd, (v) => $32d1b0bc6ab6ae81$export$a1cdb2bb0f192cfd = v);
$parcel$export(module.exports, "optionUnassigned", () => $32d1b0bc6ab6ae81$export$4b31fbead0475bc4, (v) => $32d1b0bc6ab6ae81$export$4b31fbead0475bc4 = v);
var $32d1b0bc6ab6ae81$export$a75d1723e6bda2ec;
var $32d1b0bc6ab6ae81$export$74d139e8e4ac3515;
var $32d1b0bc6ab6ae81$export$a1cdb2bb0f192cfd;
var $32d1b0bc6ab6ae81$export$4b31fbead0475bc4;
$32d1b0bc6ab6ae81$export$a75d1723e6bda2ec = `NKUPUW_option`;
$32d1b0bc6ab6ae81$export$74d139e8e4ac3515 = `NKUPUW_optionAvatar`;
$32d1b0bc6ab6ae81$export$a1cdb2bb0f192cfd = `NKUPUW_optionEmail`;
$32d1b0bc6ab6ae81$export$4b31fbead0475bc4 = `NKUPUW_optionUnassigned`;

});

parcelRegister("5GJ80", function(module, exports) {

$parcel$export(module.exports, "isGroupedOptions", () => $d4463e6e6fda5cce$export$16eb355a03e2df95);
$parcel$export(module.exports, "filterOption", () => $d4463e6e6fda5cce$export$9ec48f819895657b);

var $hkOxK = parcelRequire("hkOxK");
var $eUK1h = parcelRequire("eUK1h");
var $1l9vO = parcelRequire("1l9vO");
var $haaWO = parcelRequire("haaWO");
var $f7Op5 = parcelRequire("f7Op5");
var $l3byl = parcelRequire("l3byl");
var $701od = parcelRequire("701od");
var $kChDU = parcelRequire("kChDU");
const $d4463e6e6fda5cce$export$16eb355a03e2df95 = (options = [])=>options.some((el)=>'options' in el);
const $d4463e6e6fda5cce$export$9ec48f819895657b = (candidate, input)=>{
    if (input) {
        const getFullText = $hkOxK.default($701od.default, $haaWO.default(' '), // @ts-expect-error - TS2769 - No overload matches this call.
        $l3byl.default([
            'label',
            'value',
            'email'
        ]), $f7Op5.default('data'));
        const matchQuery = $eUK1h.default((query, option)=>$1l9vO.default($kChDU.default($701od.default(query)))(getFullText(option)));
        return matchQuery(input, candidate);
    }
    return true;
};

});



parcelRegister("df4Jn", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fsbKr")).default);
// eslint-disable-next-line jira/export/no-external-exports

var $fsbKr = parcelRequire("fsbKr");

});
parcelRegister("fsbKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd13cbcad6fb493$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $326MO = parcelRequire("326MO");

var $gSuLH = parcelRequire("gSuLH");
var $4dd13cbcad6fb493$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $326MO.default))((0, $gSuLH.default));

});
parcelRegister("326MO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b6008f14ced7b2f$export$2e2bcd8739ae039);

var $2DO1r = parcelRequire("2DO1r");
// eslint-disable-next-line jira/react-use-short-dispatch
const $0b6008f14ced7b2f$var$mapDispatchToProps = (dispatch)=>({
        filterDependencyGraphByIssue: (issueId)=>dispatch((0, $2DO1r.setIssueFilter)(issueId))
    });
var $0b6008f14ced7b2f$export$2e2bcd8739ae039 = $0b6008f14ced7b2f$var$mapDispatchToProps;

});
parcelRegister("2DO1r", function(module, exports) {

$parcel$export(module.exports, "SET_ROLLUP_FILTER", () => $7ea42253a3b76232$export$a6c2d7a80cfb3455);
$parcel$export(module.exports, "SET_ISSUE_IN_FOCUS", () => $7ea42253a3b76232$export$b87ffec8d0dafc38);
$parcel$export(module.exports, "SET_GROUP_BY", () => $7ea42253a3b76232$export$8f090af48253b08d);
$parcel$export(module.exports, "SET_ISSUE_FILTER", () => $7ea42253a3b76232$export$713aca294e2edbeb);
$parcel$export(module.exports, "SET_PROJECT_FILTER", () => $7ea42253a3b76232$export$a1c04670e5db534f);
$parcel$export(module.exports, "SET_ISSUE_LINK_TYPE_FILTER", () => $7ea42253a3b76232$export$ad9d21923e98779d);
$parcel$export(module.exports, "SET_SPRINT_FILTER", () => $7ea42253a3b76232$export$f721bf1c7400b42f);
$parcel$export(module.exports, "RESET_FILTERS", () => $7ea42253a3b76232$export$ff065b13677c68b8);
$parcel$export(module.exports, "INITIATE_FILTERS", () => $7ea42253a3b76232$export$ba398c435aa70db);
$parcel$export(module.exports, "setRollUp", () => $7ea42253a3b76232$export$455c2e9a45ca6d44);
$parcel$export(module.exports, "setIssueInFocus", () => $7ea42253a3b76232$export$a04195565eafede1);
$parcel$export(module.exports, "setGroupBy", () => $7ea42253a3b76232$export$3b589469d04138c6);
$parcel$export(module.exports, "setIssueFilter", () => $7ea42253a3b76232$export$2031bedc653a753d);
$parcel$export(module.exports, "setProjectFilter", () => $7ea42253a3b76232$export$f059b4545b91cdfa);
$parcel$export(module.exports, "setIssueLinkTypeFilter", () => $7ea42253a3b76232$export$b46d89818ecd6846);
$parcel$export(module.exports, "setSprintFilter", () => $7ea42253a3b76232$export$e1616f34263e93a4);
$parcel$export(module.exports, "resetFilters", () => $7ea42253a3b76232$export$8da0d8f55c4b51d0);
$parcel$export(module.exports, "initiateFilters", () => $7ea42253a3b76232$export$e9cb6e729c902aaa);
const $7ea42253a3b76232$export$a6c2d7a80cfb3455 = 'state.ui.main.tabs.dependencies.filters.SET_ROLLUP_FILTER';
const $7ea42253a3b76232$export$b87ffec8d0dafc38 = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_IN_FOCUS';
const $7ea42253a3b76232$export$8f090af48253b08d = 'state.ui.main.tabs.dependencies.filters.SET_GROUP_BY';
const $7ea42253a3b76232$export$713aca294e2edbeb = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_FILTER';
const $7ea42253a3b76232$export$a1c04670e5db534f = 'state.ui.main.tabs.dependencies.filters.SET_PROJECT_FILTER';
const $7ea42253a3b76232$export$ad9d21923e98779d = 'state.ui.main.tabs.dependencies.filters.SET_ISSUE_LINK_TYPE_FILTER';
const $7ea42253a3b76232$export$f721bf1c7400b42f = 'state.ui.main.tabs.dependencies.filters.SET_SPRINT_FILTER';
const $7ea42253a3b76232$export$ff065b13677c68b8 = 'state.ui.main.tabs.dependencies.filters.RESET_FILTERS';
const $7ea42253a3b76232$export$ba398c435aa70db = 'state.ui.main.tabs.dependencies.filters.INITIATE_FILTERS';
const $7ea42253a3b76232$export$455c2e9a45ca6d44 = (rollupBy, rollupHierarchyLevel)=>({
        type: $7ea42253a3b76232$export$a6c2d7a80cfb3455,
        payload: {
            rollupBy: rollupBy,
            rollupHierarchyLevel: rollupHierarchyLevel
        }
    });
const $7ea42253a3b76232$export$a04195565eafede1 = (issueId)=>({
        type: $7ea42253a3b76232$export$b87ffec8d0dafc38,
        payload: issueId
    });
const $7ea42253a3b76232$export$3b589469d04138c6 = (groupBy)=>({
        type: $7ea42253a3b76232$export$8f090af48253b08d,
        payload: groupBy
    });
const $7ea42253a3b76232$export$2031bedc653a753d = (issueFilter)=>({
        type: $7ea42253a3b76232$export$713aca294e2edbeb,
        payload: issueFilter
    });
const $7ea42253a3b76232$export$f059b4545b91cdfa = (projectFilter)=>({
        type: $7ea42253a3b76232$export$a1c04670e5db534f,
        payload: projectFilter
    });
const $7ea42253a3b76232$export$b46d89818ecd6846 = (issueLinkTypeFilter)=>({
        type: $7ea42253a3b76232$export$ad9d21923e98779d,
        payload: issueLinkTypeFilter
    });
const $7ea42253a3b76232$export$e1616f34263e93a4 = (sprintFilter)=>({
        type: $7ea42253a3b76232$export$f721bf1c7400b42f,
        payload: sprintFilter
    });
const $7ea42253a3b76232$export$8da0d8f55c4b51d0 = ()=>({
        type: $7ea42253a3b76232$export$ff065b13677c68b8
    });
const $7ea42253a3b76232$export$e9cb6e729c902aaa = (payload)=>({
        type: $7ea42253a3b76232$export$ba398c435aa70db,
        payload: payload
    });

});


parcelRegister("gSuLH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f036fa3755efc42e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aAyrO = parcelRequire("aAyrO");

var $NeuAT = parcelRequire("NeuAT");

var $7CnHa = parcelRequire("7CnHa");

var $kJlBc = parcelRequire("kJlBc");

var $2ccn2 = parcelRequire("2ccn2");
function $f036fa3755efc42e$export$2e2bcd8739ae039({ children: children, ariaLabel: ariaLabel, issueId: issueId, filterDependencyGraphByIssue: filterDependencyGraphByIssue }) {
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const planId = (0, $NeuAT.getPlanId)();
    const scenarioId = (0, $NeuAT.getScenarioId)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        // issueId should always be defined (even if it is scenario issue), but better be safe than sorry
        if ((0, $7CnHa.isDefined)(issueId)) {
            // redirecting the user to the dependencies tab
            if (planId && scenarioId) push(`/jira/plans/${planId}/scenarios/${scenarioId}/dependencies`);
            // setting the issue id in the Filter by issue field of the dependencies tab
            filterDependencyGraphByIssue(issueId);
        }
    }, [
        push,
        planId,
        scenarioId,
        filterDependencyGraphByIssue,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2ccn2.footerActionsSeparator
    }, "\xb7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleClick,
        ariaLabel: ariaLabel,
        testId: `portfolio-3-portfolio.common.filter-dependency-graph-from-roadmap.issue-${issueId}`
    }, children));
}

});
parcelRegister("2ccn2", function(module, exports) {

$parcel$export(module.exports, "footerActionsSeparator", () => $19964c4b99190721$export$7a30fd13ff41b95b, (v) => $19964c4b99190721$export$7a30fd13ff41b95b = v);
var $19964c4b99190721$export$7a30fd13ff41b95b;
$19964c4b99190721$export$7a30fd13ff41b95b = `icFyjG_footerActionsSeparator`;

});




parcelRegister("bDAY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb4fee602f86fec$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9YwjH = parcelRequire("9YwjH");

var $983IG = parcelRequire("983IG");
var $1fb4fee602f86fec$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $9YwjH.default))((0, $983IG.default));

});
parcelRegister("9YwjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d542b1958a57f2$export$2e2bcd8739ae039);

var $eaaIH = parcelRequire("eaaIH");

var $8B14N = parcelRequire("8B14N");
const $36d542b1958a57f2$var$mapDispatchToProps = (dispatch)=>({
        clearCustomFieldFilter: (customFields)=>{
            customFields.forEach((customField)=>dispatch((0, $8B14N.clear)({
                    customField: customField
                })));
        },
        clearFilter: (filterId)=>{
            dispatch((0, $eaaIH.clear)(filterId));
        }
    });
var $36d542b1958a57f2$export$2e2bcd8739ae039 = $36d542b1958a57f2$var$mapDispatchToProps;

});
parcelRegister("eaaIH", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $6ad01a751f7d4772$export$4a991c87e640ef77);
$parcel$export(module.exports, "CHANGE", () => $6ad01a751f7d4772$export$4bef51da9b53f613);
$parcel$export(module.exports, "CLEAR", () => $6ad01a751f7d4772$export$6c4d37c7f376a1de);
$parcel$export(module.exports, "CLEAR_ALL", () => $6ad01a751f7d4772$export$a4b3b534f9c4179f);
$parcel$export(module.exports, "change", () => $6ad01a751f7d4772$export$d8a7b8f475ec0161);
$parcel$export(module.exports, "clear", () => $6ad01a751f7d4772$export$42ffd38884aecdac);
$parcel$export(module.exports, "clearAll", () => $6ad01a751f7d4772$export$1042faa6df30c26);
const $6ad01a751f7d4772$export$4a991c87e640ef77 = 'state.domain.view-settings.filters.RESET';
const $6ad01a751f7d4772$export$4bef51da9b53f613 = 'state.domain.view-settings.filters.CHANGE';
const $6ad01a751f7d4772$export$6c4d37c7f376a1de = 'state.domain.view-settings.filters.CLEAR';
const $6ad01a751f7d4772$export$a4b3b534f9c4179f = 'state.domain.view-settings.filters.CLEAR_ALL';
const $6ad01a751f7d4772$export$aad8462122ac592b = (payload)=>({
        type: $6ad01a751f7d4772$export$4a991c87e640ef77,
        payload: payload
    });
const $6ad01a751f7d4772$export$d8a7b8f475ec0161 = (payload, bypassAnalytics = false)=>({
        type: $6ad01a751f7d4772$export$4bef51da9b53f613,
        payload: payload,
        bypassAnalytics: bypassAnalytics
    });
const $6ad01a751f7d4772$export$42ffd38884aecdac = (payload)=>({
        type: $6ad01a751f7d4772$export$6c4d37c7f376a1de,
        payload: payload
    });
const $6ad01a751f7d4772$export$1042faa6df30c26 = ()=>({
        type: $6ad01a751f7d4772$export$a4b3b534f9c4179f
    });

});

parcelRegister("8B14N", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $6eb80dc7fac05a65$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $6eb80dc7fac05a65$export$e271b26eefe41db8);
$parcel$export(module.exports, "CLEAR", () => $6eb80dc7fac05a65$export$6c4d37c7f376a1de);
$parcel$export(module.exports, "CLEAR_ALL", () => $6eb80dc7fac05a65$export$a4b3b534f9c4179f);
$parcel$export(module.exports, "reset", () => $6eb80dc7fac05a65$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $6eb80dc7fac05a65$export$722fbec263ad908a);
$parcel$export(module.exports, "clear", () => $6eb80dc7fac05a65$export$42ffd38884aecdac);
$parcel$export(module.exports, "clearAll", () => $6eb80dc7fac05a65$export$1042faa6df30c26);
const $6eb80dc7fac05a65$export$4a991c87e640ef77 = 'state.domain.view-settings.filters.custom-field-filter.RESET';
const $6eb80dc7fac05a65$export$e271b26eefe41db8 = 'state.domain.view-settings.filters.custom-field-filter.UPDATE';
const $6eb80dc7fac05a65$export$6c4d37c7f376a1de = 'state.domain.view-settings.filters.custom-field-filter.CLEAR';
const $6eb80dc7fac05a65$export$a4b3b534f9c4179f = 'state.domain.view-settings.filters.custom-field-filter.CLEAR_ALL';
const $6eb80dc7fac05a65$export$aad8462122ac592b = (payload)=>({
        type: $6eb80dc7fac05a65$export$4a991c87e640ef77,
        payload: payload
    });
const $6eb80dc7fac05a65$export$722fbec263ad908a = (payload)=>({
        type: $6eb80dc7fac05a65$export$e271b26eefe41db8,
        payload: payload
    });
const $6eb80dc7fac05a65$export$42ffd38884aecdac = (payload)=>({
        type: $6eb80dc7fac05a65$export$6c4d37c7f376a1de,
        payload: payload
    });
const $6eb80dc7fac05a65$export$1042faa6df30c26 = (payload)=>({
        type: $6eb80dc7fac05a65$export$a4b3b534f9c4179f,
        payload: payload
    });

});


parcelRegister("983IG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6098dfbaf911d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");

var $f7lXO = parcelRequire("f7lXO");

var $1ORJy = parcelRequire("1ORJy");
function $ae6098dfbaf911d3$var$ClearFilterForIssueSearchWarning({ intl: intl, filters: filters, clearFilter: clearFilter, clearCustomFieldFilter: clearCustomFieldFilter }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1ORJy.clearButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        onClick: ()=>{
            filters.forEach((item)=>{
                if (item.type === 'custom') clearCustomFieldFilter(item.filters);
                else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                clearFilter(item.id);
            });
        }
    }, intl.formatMessage((0, $f7lXO.default).clearFilterLink, {
        filterCount: filters && filters.reduce((acc, item)=>acc + (item.type === 'custom' ? item.filters.length : 1), 0)
    }))));
}
var $ae6098dfbaf911d3$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ae6098dfbaf911d3$var$ClearFilterForIssueSearchWarning);

});
parcelRegister("f7lXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1248e28ac33fb13d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1248e28ac33fb13d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clearFilterLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.component-slot-content.issue-search-warning-clear-filter.clear-filter-link",
        "defaultMessage": "Clear {filterCount, plural, one {this filter} other {these filters}}"
    }
});

});

parcelRegister("1ORJy", function(module, exports) {

$parcel$export(module.exports, "clearButton", () => $1534245fb4aa09e9$export$52aab205873de00, (v) => $1534245fb4aa09e9$export$52aab205873de00 = v);
var $1534245fb4aa09e9$export$52aab205873de00;
$1534245fb4aa09e9$export$52aab205873de00 = `wxrwna_clearButton`;

});



parcelRegister("aE4WL", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("cXr7b")).default);
// eslint-disable-next-line jira/export/no-external-exports

var $cXr7b = parcelRequire("cXr7b");

});
parcelRegister("cXr7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5d10b17c5cefa3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jnABw = parcelRequire("jnABw");

var $9hss5 = parcelRequire("9hss5");

var $9X5DW = parcelRequire("9X5DW");
var $ad5d10b17c5cefa3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9hss5.default), (0, $jnABw.default))((0, $9X5DW.default));

});
parcelRegister("jnABw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c872f93aa949c96d$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
const $c872f93aa949c96d$var$mapDispatchToProps = (dispatch)=>({
        quickFilter: (id, value)=>{
            dispatch((0, $296Gg.clearAll)());
            dispatch((0, $296Gg.change)({
                id: id,
                value: value
            }));
        },
        clearFilter: ()=>dispatch((0, $296Gg.clearAll)())
    });
var $c872f93aa949c96d$export$2e2bcd8739ae039 = $c872f93aa949c96d$var$mapDispatchToProps;

});
parcelRegister("296Gg", function(module, exports) {

$parcel$export(module.exports, "change", () => $d3d0924b135b1256$export$d8a7b8f475ec0161);
$parcel$export(module.exports, "clear", () => $d3d0924b135b1256$export$42ffd38884aecdac);
$parcel$export(module.exports, "clearAll", () => $d3d0924b135b1256$export$1042faa6df30c26);
$parcel$export(module.exports, "setInitialFilterValues", () => $d3d0924b135b1256$export$f464458558a6e458);
$parcel$export(module.exports, "default", () => $d3d0924b135b1256$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kKj1m = parcelRequire("kKj1m");

var $6UAvZ = parcelRequire("6UAvZ");

var $kwMvv = parcelRequire("kwMvv");

var $fr1nu = parcelRequire("fr1nu");

var $eaaIH = parcelRequire("eaaIH");

var $8B14N = parcelRequire("8B14N");

parcelRequire("6owOg");
var $5Cso7 = parcelRequire("5Cso7");

var $7CnHa = parcelRequire("7CnHa");

var $2BQwE = parcelRequire("2BQwE");

var $duQ8C = parcelRequire("duQ8C");
const $d3d0924b135b1256$export$80504656bcc6d2d9 = 'command.filters.SET_INITIAL_FILTER_VALUES';
const $d3d0924b135b1256$export$3b0c369061fa00ff = 'command.filters.CHANGE_FILTER_VALUE';
const $d3d0924b135b1256$export$80f6e3f69ac5bef4 = 'command.filters.CLEAR_FILTER';
const $d3d0924b135b1256$export$12b8b0c2680dfdd3 = 'command.filters.CLEAR_ALL_FILTERS';
const $d3d0924b135b1256$export$d8a7b8f475ec0161 = (payload)=>({
        type: $d3d0924b135b1256$export$3b0c369061fa00ff,
        payload: payload
    });
const $d3d0924b135b1256$export$42ffd38884aecdac = (payload)=>({
        type: $d3d0924b135b1256$export$80f6e3f69ac5bef4,
        payload: payload
    });
const $d3d0924b135b1256$export$1042faa6df30c26 = ()=>({
        type: $d3d0924b135b1256$export$12b8b0c2680dfdd3
    });
const $d3d0924b135b1256$export$f464458558a6e458 = ()=>({
        type: $d3d0924b135b1256$export$80504656bcc6d2d9
    });
function* $d3d0924b135b1256$export$14836535de8c6504() {
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        ids: [],
        isSelected: false,
        toggleAll: true
    }));
    const hierarchyFilter = yield (0, $9e8i2.select)((0, $6UAvZ.getHierarchyFilterState));
    if (!(0, $7CnHa.isDefined)(hierarchyFilter) || !(0, $7CnHa.isDefined)(hierarchyFilter.value)) {
        const value = yield (0, $9e8i2.select)((0, $kwMvv.getInitialFilterValues));
        yield (0, $9e8i2.put)((0, $eaaIH.change)({
            id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
            value: value
        }, true));
        yield (0, $9e8i2.put)((0, $eaaIH.change)({
            id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
            value: {
                start: value.start - 1,
                end: value.end - 1
            }
        }, true));
    }
}
function* $d3d0924b135b1256$export$b2959731240e2fac({ payload: payload }) {
    (0, $duQ8C.default)((0, $2BQwE.KEYS).CHANGE_FILTER_VALUE);
    yield (0, $9e8i2.put)((0, $eaaIH.change)(payload));
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        ids: [],
        isSelected: false,
        toggleAll: true
    }));
}
function* $d3d0924b135b1256$export$e2c2d6ba49cf760f({ payload: payload }) {
    (0, $duQ8C.default)((0, $2BQwE.KEYS).CHANGE_FILTER_VALUE);
    yield (0, $9e8i2.put)((0, $eaaIH.clear)(payload));
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        ids: [],
        isSelected: false,
        toggleAll: true
    }));
}
function* $d3d0924b135b1256$export$576439df9878db3a() {
    yield (0, $9e8i2.put)((0, $eaaIH.clearAll)());
    yield (0, $9e8i2.put)((0, $8B14N.clearAll)({
        customFields: yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields))
    }));
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        ids: [],
        isSelected: false,
        toggleAll: true
    }));
}
function* $d3d0924b135b1256$export$abdcbce35d8f856d() {
    yield (0, $9e8i2.all)([
        (0, $9e8i2.take)($d3d0924b135b1256$export$80504656bcc6d2d9),
        (0, $9e8i2.take)((0, $fr1nu.RESET_BACKLOG))
    ]);
    yield* $d3d0924b135b1256$export$14836535de8c6504();
}
function* $d3d0924b135b1256$export$2dcb0e711f5da649() {
    yield (0, $bG7pV.takeEvery)($d3d0924b135b1256$export$3b0c369061fa00ff, $d3d0924b135b1256$export$b2959731240e2fac);
}
function* $d3d0924b135b1256$export$8095d7c9e65e4027() {
    yield (0, $bG7pV.takeEvery)($d3d0924b135b1256$export$80f6e3f69ac5bef4, $d3d0924b135b1256$export$e2c2d6ba49cf760f);
}
function* $d3d0924b135b1256$export$9859c65de122217b() {
    yield (0, $bG7pV.takeEvery)($d3d0924b135b1256$export$12b8b0c2680dfdd3, $d3d0924b135b1256$export$576439df9878db3a);
}
function* $d3d0924b135b1256$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($d3d0924b135b1256$export$abdcbce35d8f856d);
    yield (0, $9e8i2.fork)($d3d0924b135b1256$export$2dcb0e711f5da649);
    yield (0, $9e8i2.fork)($d3d0924b135b1256$export$8095d7c9e65e4027);
    yield (0, $9e8i2.fork)($d3d0924b135b1256$export$9859c65de122217b);
}

});
parcelRegister("fr1nu", function(module, exports) {

$parcel$export(module.exports, "SET_PLAN_INFO", () => $5a62f030c7c21bca$export$c75f54816444e80b);
$parcel$export(module.exports, "RESET_BACKLOG", () => $5a62f030c7c21bca$export$c396d703a224b390);
$parcel$export(module.exports, "AFTER_RESET_BACKLOG", () => $5a62f030c7c21bca$export$a18f376ec94e9a69);
$parcel$export(module.exports, "UPDATE_ISSUE_REFERENCES", () => $5a62f030c7c21bca$export$506f8b03e3eeeb49);
$parcel$export(module.exports, "setPlanInfo", () => $5a62f030c7c21bca$export$47293510bb7e9633);
$parcel$export(module.exports, "resetBacklog", () => $5a62f030c7c21bca$export$3089734ef4d8a726);
$parcel$export(module.exports, "afterResetBacklog", () => $5a62f030c7c21bca$export$c889522a21dc6b24);
$parcel$export(module.exports, "updateIssueReferences", () => $5a62f030c7c21bca$export$3dc49f90a30d81dc);
const $5a62f030c7c21bca$export$c75f54816444e80b = 'state.domain.SET_PLAN_INFO';
const $5a62f030c7c21bca$export$c396d703a224b390 = 'state.domain.RESET_BACKLOG';
const $5a62f030c7c21bca$export$a18f376ec94e9a69 = 'state.domain.AFTER_RESET_BACKLOG';
const $5a62f030c7c21bca$export$506f8b03e3eeeb49 = 'state.domain.UPDATE_ISSUE_REFERENCES';
const $5a62f030c7c21bca$export$47293510bb7e9633 = (payload)=>({
        type: $5a62f030c7c21bca$export$c75f54816444e80b,
        payload: payload
    });
const $5a62f030c7c21bca$export$3089734ef4d8a726 = (payload)=>({
        type: $5a62f030c7c21bca$export$c396d703a224b390,
        payload: payload
    });
const $5a62f030c7c21bca$export$c889522a21dc6b24 = ()=>({
        type: $5a62f030c7c21bca$export$a18f376ec94e9a69
    });
const $5a62f030c7c21bca$export$3dc49f90a30d81dc = (payload)=>({
        type: $5a62f030c7c21bca$export$506f8b03e3eeeb49,
        payload: payload
    });

});

parcelRegister("6owOg", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $d99bbfc7c7489409$export$4a991c87e640ef77);
$parcel$export(module.exports, "SET_IS_LOADING_HISTORY", () => $d99bbfc7c7489409$export$2386799b95de6beb);
$parcel$export(module.exports, "SET_IS_LOADING", () => $d99bbfc7c7489409$export$a561b54b6c85b410);
$parcel$export(module.exports, "SET_IS_SAVING", () => $d99bbfc7c7489409$export$dde78b9273c318ca);
$parcel$export(module.exports, "setIsLoadingHistory", () => $d99bbfc7c7489409$export$a570139500d60df8);
$parcel$export(module.exports, "setIsLoading", () => $d99bbfc7c7489409$export$9eaa806651dd33f0);
$parcel$export(module.exports, "setIsSaving", () => $d99bbfc7c7489409$export$ad10cacbaf4608fe);
$parcel$export(module.exports, "toggleSelectedIssues", () => (parcelRequire("5Cso7")).toggleSelectedIssues);

var $5Cso7 = parcelRequire("5Cso7");
const $d99bbfc7c7489409$export$4a991c87e640ef77 = 'state.ui.main.tabs.roadmap.scope.issues.RESET';
const $d99bbfc7c7489409$export$2386799b95de6beb = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_LOADING_HISTORY';
const $d99bbfc7c7489409$export$a561b54b6c85b410 = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_LOADING';
const $d99bbfc7c7489409$export$ef4196109a02d078 = 'state.ui.main.table.roadmap.scope.issues.SET_IS_FULL_ISSUE_SET_LOADING';
const $d99bbfc7c7489409$export$dde78b9273c318ca = 'state.ui.main.tabs.roadmap.scope.issues.SET_IS_SAVING';
const $d99bbfc7c7489409$export$aad8462122ac592b = (payload)=>({
        type: $d99bbfc7c7489409$export$4a991c87e640ef77,
        payload: payload
    });
const $d99bbfc7c7489409$export$a570139500d60df8 = (payload)=>({
        type: $d99bbfc7c7489409$export$2386799b95de6beb,
        payload: payload
    });
const $d99bbfc7c7489409$export$9eaa806651dd33f0 = (payload)=>({
        type: $d99bbfc7c7489409$export$a561b54b6c85b410,
        payload: payload
    });
const $d99bbfc7c7489409$export$ad10cacbaf4608fe = (payload)=>({
        type: $d99bbfc7c7489409$export$dde78b9273c318ca,
        payload: payload
    });

});
parcelRegister("5Cso7", function(module, exports) {

$parcel$export(module.exports, "TargetTypes", () => $527b1c9dfc7454de$export$61728fee2ed143fe);
$parcel$export(module.exports, "TOGGLE_SELECTED_ISSUES", () => $527b1c9dfc7454de$export$8c9ac2746bcaefa7);
$parcel$export(module.exports, "toggleSelectedIssues", () => $527b1c9dfc7454de$export$d2807327ad419922);

const $527b1c9dfc7454de$export$61728fee2ed143fe = {
    single: (0, $cee285a471a5e0ee$export$9bf4e7d6b603dbce),
    all: (0, $cee285a471a5e0ee$export$9dddd83352737cc1),
    singleAndDescendants: (0, $cee285a471a5e0ee$export$28c9c1d4094b974f),
    descendants: (0, $cee285a471a5e0ee$export$eb5df195279ddc82)
};
const $527b1c9dfc7454de$export$8c9ac2746bcaefa7 = 'state.ui.main.tabs.roadmap.scope.issues.selectable-issue.TOGGLE_SELECTED_ISSUES';
const $527b1c9dfc7454de$export$d2807327ad419922 = (payload)=>({
        type: $527b1c9dfc7454de$export$8c9ac2746bcaefa7,
        payload: payload
    });

});
const $cee285a471a5e0ee$export$9bf4e7d6b603dbce = 'SINGLE';
const $cee285a471a5e0ee$export$9dddd83352737cc1 = 'ALL';
const $cee285a471a5e0ee$export$28c9c1d4094b974f = 'SINGLE_AND_DESCENDANTS'; // Select this and all descendant issues
const $cee285a471a5e0ee$export$eb5df195279ddc82 = 'DESCENDANTS'; // Select only descendant issues



parcelRegister("2BQwE", function(module, exports) {

$parcel$export(module.exports, "KEYS", () => $8f06a7cfe257ecb7$export$f9ba527e25c2bc92);
// Keys for use with UFO interaction metrics. These need to be unique across JFE
const $8f06a7cfe257ecb7$export$f9ba527e25c2bc92 = {
    // timeline tab
    EXPAND_ALL_ISSUES: 'arj-timeline-expand-all-issues',
    COLLAPSE_ALL_ISSUES: 'arj-timeline-collapse-all-issues',
    EXPAND_ISSUE: 'arj-timeline-expand-issue',
    COLLAPSE_ISSUE: 'arj-timeline-collapse-issue',
    EXPAND_ISSUE_WITHOUT_PARENT: 'arj-timeline-expand-issue-without-parent',
    CREATE_ISSUE: 'arj-timeline-create-issue',
    COLLAPSE_ISSUE_WITHOUT_PARENT: 'arj-timeline-collapse-issue-without-parent',
    CHANGE_COLOR_BY_SETTING: 'arj-timeline-change-color-by-setting',
    CHANGE_GROUP_BY_SETTING: 'arj-timeline-change-group-by-setting',
    CHANGE_FILTER_VALUE: 'arj-timeline-change-filter-value',
    SORT_BY_FIELD: 'arj-timeline-sort-by-field',
    OPEN_REVIEW_CHANGES: 'arj-timeline-open-review-changes',
    SAVE_REVIEW_CHANGES: 'arj-timeline-save-review-changes',
    SWITCH_VIEW: 'arj-timeline-switch-view',
    // teams tab
    CREATE_TEAM: 'arj-teams-create-team',
    UPDATE_TEAM: 'arj-teams-update-team',
    // releases tab
    CREATE_RELEASE: 'arj-releases-create-release',
    UPDATE_RELEASE: 'arj-releases-update-release'
};

});



parcelRegister("9hss5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d259456cf26ad4f$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");

var $iK4oF = parcelRequire("iK4oF");
var $1d259456cf26ad4f$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    filterValueFor: (state)=>(id)=>(0, $fbHoQ.getFilters)(state)[id].value
});

});

parcelRegister("9X5DW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4749b46507976de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5OdRK = parcelRequire("5OdRK");

var $aAyrO = parcelRequire("aAyrO");
function $c4749b46507976de$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, children: children, clearable: clearable, clearFilter: clearFilter, clearText: clearText, filterValueFor: filterValueFor, onFilterApply: onFilterApply = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), quickFilter: quickFilter, value: filter }) {
    const currentValue = filterValueFor(filter.id);
    const hasSameValue = $5OdRK.default(currentValue, filter.value);
    if (hasSameValue && clearable === true) {
        const handleClick = ()=>clearFilter();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: handleClick
        }, clearText);
    }
    const handleClick = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    _, analyticsEvent)=>{
        quickFilter(filter.id, filter.value);
        onFilterApply(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleClick,
        ariaLabel: ariaLabel
    }, children);
}

});



parcelRegister("5AKWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3564e34c280430c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bfZ6T = parcelRequire("bfZ6T");

var $blOY1 = parcelRequire("blOY1");

var $434A1 = parcelRequire("434A1");
var $a3564e34c280430c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $blOY1.default), (0, $bfZ6T.default))((0, $434A1.default));

});
parcelRegister("bfZ6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $eede8b0a7d9f9d1e$export$2e2bcd8739ae039);
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");

var $9ozqH = parcelRequire("9ozqH");
const $eede8b0a7d9f9d1e$var$mapDispatchToProps = {
    onDismissFlag: (0, $9ozqH.dismissFlag),
    onChangeSort: (0, $l1dWb.changeSort)
};
var $eede8b0a7d9f9d1e$export$2e2bcd8739ae039 = $eede8b0a7d9f9d1e$var$mapDispatchToProps;

});
parcelRegister("6auew", function(module, exports) {

$parcel$export(module.exports, "changeGroup", () => (parcelRequire("l1dWb")).changeGroup);
$parcel$export(module.exports, "changeSort", () => (parcelRequire("l1dWb")).changeSort);
$parcel$export(module.exports, "toggleExpandGroup", () => (parcelRequire("l1dWb")).toggleExpandGroup);
$parcel$export(module.exports, "toggleShowSprints", () => (parcelRequire("l1dWb")).toggleShowSprints);

var $l1dWb = parcelRequire("l1dWb");

});

parcelRegister("9ozqH", function(module, exports) {

$parcel$export(module.exports, "ADD_FLAG", () => $a7b33bcc1f45f658$export$8db129480af5aa95);
$parcel$export(module.exports, "PUSH_FLAG", () => $a7b33bcc1f45f658$export$23178c8e8290d2c3);
$parcel$export(module.exports, "REMOVE_FLAG", () => $a7b33bcc1f45f658$export$f49894fce0f25653);
$parcel$export(module.exports, "DISMISS_FLAG", () => $a7b33bcc1f45f658$export$1eb56620df104bf);
$parcel$export(module.exports, "addFlag", () => $a7b33bcc1f45f658$export$820a1da46c7a4303);
$parcel$export(module.exports, "pushFlag", () => $a7b33bcc1f45f658$export$5619f969d0372640);
$parcel$export(module.exports, "removeFlag", () => $a7b33bcc1f45f658$export$f2c4075a13a8b485);
$parcel$export(module.exports, "dismissFlag", () => $a7b33bcc1f45f658$export$900a08a292ad23cd);
const $a7b33bcc1f45f658$export$8db129480af5aa95 = 'state.domain.flags.ADD_FLAG';
const $a7b33bcc1f45f658$export$23178c8e8290d2c3 = 'state.domain.flags.PUSH_FLAG';
const $a7b33bcc1f45f658$export$f49894fce0f25653 = 'state.domain.flags.REMOVE_FLAG';
const $a7b33bcc1f45f658$export$1eb56620df104bf = 'state.domain.flags.DISMISS_FLAG';
const $a7b33bcc1f45f658$export$820a1da46c7a4303 = (payload)=>({
        type: $a7b33bcc1f45f658$export$8db129480af5aa95,
        payload: payload
    });
const $a7b33bcc1f45f658$export$5619f969d0372640 = (payload)=>({
        type: $a7b33bcc1f45f658$export$23178c8e8290d2c3,
        payload: payload
    });
const $a7b33bcc1f45f658$export$f2c4075a13a8b485 = (payload)=>({
        type: $a7b33bcc1f45f658$export$f49894fce0f25653,
        payload: payload
    });
const $a7b33bcc1f45f658$export$900a08a292ad23cd = (payload)=>({
        type: $a7b33bcc1f45f658$export$1eb56620df104bf,
        payload: payload
    });

});


parcelRegister("blOY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9354c43580d988$export$2e2bcd8739ae039);

var $1nPPv = parcelRequire("1nPPv");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $8f9354c43580d988$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    flags: (0, $1nPPv.getFlags),
    sorting: (0, $kyGCj.getVisualisationSorting)
});

});
parcelRegister("1nPPv", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $a28c102cdd8c5dd5$export$d5815430bcc75df0);
$parcel$export(module.exports, "ISSUE_LIMIT_WARNING", () => $42b69a8aa6898c13$export$42d68c08a5ace658);
$parcel$export(module.exports, "ISSUE_SEARCH_WARNING", () => $42b69a8aa6898c13$export$225669431bad5551);
$parcel$export(module.exports, "NO_JSW_ACCESS_FOR_USER", () => $42b69a8aa6898c13$export$a23067a331938f15);
$parcel$export(module.exports, "PROJECT_LIMIT_WARNING", () => $42b69a8aa6898c13$export$a1a68e80ebef1446);
$parcel$export(module.exports, "SORTED_PREVENT_ISSUE_RANKING_WARNING", () => $42b69a8aa6898c13$export$5d75f74c1d4d448d);
$parcel$export(module.exports, "REPARENT_CMP_TO_TMP_WARNING", () => $42b69a8aa6898c13$export$ac1a967dceae5708);
$parcel$export(module.exports, "REPARENT_TMP_TO_EXTERNAL_WARNING", () => $42b69a8aa6898c13$export$8a72c64e90d56fab);

const $a28c102cdd8c5dd5$export$d5815430bcc75df0 = (state)=>state.domain.flags;

});
const $42b69a8aa6898c13$export$42d68c08a5ace658 = 'state.domain.flags.ISSUE_LIMIT_WARNING';
const $42b69a8aa6898c13$export$a1a68e80ebef1446 = 'state.domain.flags.PROJECT_LIMIT_WARNING';
const $42b69a8aa6898c13$export$8a72c64e90d56fab = 'state.domain.flags.REPARENT_TMP_TO_EXTERNAL_WARNING';
const $42b69a8aa6898c13$export$ac1a967dceae5708 = 'state.domain.flags.REPARENT_CMP_TO_TMP_WARNING';
const $42b69a8aa6898c13$export$225669431bad5551 = 'state.domain.flags.ISSUE_SEARCH_WARNING';
const $42b69a8aa6898c13$export$5d75f74c1d4d448d = 'state.domain.flags.SORTED_PREVENT_ISSUE_RANKING_WARNING';
const $42b69a8aa6898c13$export$1c67cc6ab03450a2 = 'project-limit-exceeded';
const $42b69a8aa6898c13$export$a23067a331938f15 = 'no-jira-software-access-for-user';



parcelRegister("434A1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1bddf1038a3111e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQ0RL = parcelRequire("kQ0RL");
parcelRequire("1nPPv");
parcelRequire("kyGCj");
var $dvRTl = parcelRequire("dvRTl");

var $3upRO = parcelRequire("3upRO");
parcelRequire("98P8D");
var $3NvHV = parcelRequire("3NvHV");
parcelRequire("iAqj8");
var $76kcd = parcelRequire("76kcd");
parcelRequire("1fQoh");
var $fdlA6 = parcelRequire("fdlA6");
parcelRequire("g5yPc");
var $b6MYq = parcelRequire("b6MYq");
parcelRequire("b9flG");
var $c8xCG = parcelRequire("c8xCG");
parcelRequire("c1gJK");
var $5tijJ = parcelRequire("5tijJ");
parcelRequire("jCtKt");
var $1oUK6 = parcelRequire("1oUK6");
const $d1bddf1038a3111e$var$applyFlags = (flags, sortByRank, redirectToSpaPlanPage)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    flags.reduce((accum, { key: key, context: context = {} })=>{
        switch(key){
            case 0, $42b69a8aa6898c13$export$a23067a331938f15:
                return accum.concat((0, $b6MYq.getJSWNoAccessErrorFlag));
            case 0, $42b69a8aa6898c13$export$225669431bad5551:
                return accum.concat((0, $fdlA6.getIssueSearchWarningFlag));
            case 0, $42b69a8aa6898c13$export$8a72c64e90d56fab:
                return accum.concat(()=>(0, $1oUK6.getReparentTMPWarningFlag)({
                        context: context
                    }));
            case 0, $42b69a8aa6898c13$export$ac1a967dceae5708:
                return accum.concat(()=>(0, $5tijJ.getReparentCMPWarningFlag)({
                        context: context
                    }));
            case 0, $42b69a8aa6898c13$export$42d68c08a5ace658:
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return accum.concat((Description)=>(0, $3NvHV.getIssueLimitWarningFlag)(Description, redirectToSpaPlanPage));
            case 0, $42b69a8aa6898c13$export$a1a68e80ebef1446:
                return accum.concat((0, $c8xCG.getProjectLimitWarningFlag));
            case 0, $42b69a8aa6898c13$export$5d75f74c1d4d448d:
                return accum.concat(()=>(0, $76kcd.getIssueRankWarningFlag)({
                        sortByRank: sortByRank
                    }));
            default:
                return accum;
        }
    }, []);
const $d1bddf1038a3111e$var$FlagGroup = ({ flags: flags, onDismissFlag: onDismissFlag, onChangeSort: onChangeSort, sorting: sorting })=>{
    const [shownFlags, setShownFlags] = (0, $eUqFw.useState)([]);
    const redirectToSpaPlanPage = (0, $3upRO.useRedirectToSpaPlanPage)();
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const sortByRank = ({ sorting: sorting })=>{
            onChangeSort({
                sorting: sorting
            });
            onDismissFlag({
                key: (0, $42b69a8aa6898c13$export$5d75f74c1d4d448d)
            });
        };
        const filteredFlags = $d1bddf1038a3111e$var$applyFlags(flags, sortByRank, redirectToSpaPlanPage);
        setShownFlags(filteredFlags);
    }, // We dont want to rerun on new redirectToSpaPlanPage assignment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        flags,
        onDismissFlag,
        onChangeSort
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (sorting.field === (0, $dvRTl.defaultSorting).field && flags.some(({ key: key })=>key === (0, $42b69a8aa6898c13$export$5d75f74c1d4d448d))) onDismissFlag({
            key: (0, $42b69a8aa6898c13$export$5d75f74c1d4d448d)
        });
    }, [
        sorting,
        flags,
        onDismissFlag
    ]);
    const onDismissed = (flagKey)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onDismissFlag({
            key: flagKey.toString()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
        onDismissed: onDismissed
    }, shownFlags.map((getFlag)=>getFlag()));
};
var $d1bddf1038a3111e$export$2e2bcd8739ae039 = $d1bddf1038a3111e$var$FlagGroup;

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});


parcelRegister("3upRO", function(module, exports) {

$parcel$export(module.exports, "useRedirectToSpaPlanPage", () => $ec6d79eb44042d50$export$ca60ba613d31bd2a);
$parcel$export(module.exports, "default", () => $ec6d79eb44042d50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $kJlBc = parcelRequire("kJlBc");
const $ec6d79eb44042d50$export$ca60ba613d31bd2a = ()=>{
    const [{ match: match, location: location }, { replace: replace }] = (0, $kJlBc.useRouter)();
    return (page, plan)=>{
        if (!match.params?.planId || !match.params?.scenarioId) return;
        const newUrl = (0, $1ybV0.ff)('jet-plans-nav-refresh_f9025') && plan ? `/jira/plans/${plan.planId}/scenarios/${plan.scenarioId}${page}` : `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${page}`;
        if (newUrl === location.pathname) // short-circuit if the redirect url is the same
        return;
        replace(newUrl);
    };
};
const $ec6d79eb44042d50$var$withRedirectToSpaPlanPage = (WrappedComponent)=>(props)=>{
        const redirectToSpaPlanPage = $ec6d79eb44042d50$export$ca60ba613d31bd2a();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            redirectToSpaPlanPage: redirectToSpaPlanPage
        });
    };
var $ec6d79eb44042d50$export$2e2bcd8739ae039 = $ec6d79eb44042d50$var$withRedirectToSpaPlanPage;

});

parcelRegister("98P8D", function(module, exports) {

$parcel$export(module.exports, "getIssueLimitWarningFlag", () => (parcelRequire("3NvHV")).getIssueLimitWarningFlag);

var $3NvHV = parcelRequire("3NvHV");

});
parcelRegister("3NvHV", function(module, exports) {

$parcel$export(module.exports, "getIssueLimitWarningFlag", () => $1d170ede52095303$export$cd775572da7c8bd3);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $6Lp7l = parcelRequire("6Lp7l");

var $kJu69 = parcelRequire("kJu69");
const $1d170ede52095303$export$cd775572da7c8bd3 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Description = (0, $6Lp7l.default), redirectToSpaPlanPage)=>{
    const handleUpdateIssueSourcesButtonClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            actionSubject: 'issueLimitWarningModal',
            action: 'updateLinkClicked'
        }));
        redirectToSpaPlanPage('/settings/issue-sources');
    };
    const handleSetExclusionRulesButtonClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            actionSubject: 'issueLimitWarningModal',
            action: 'setExclusionRulesLinkClicked'
        }));
        redirectToSpaPlanPage('/settings/exclusion-rules');
    };
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kJu69.default).updateEditIssueSources),
            onClick: handleUpdateIssueSourcesButtonClick
        },
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kJu69.default).setExclusionRules),
            onClick: handleSetExclusionRulesButtonClick
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "issue-limit-warning",
        id: "issue-limit-warning",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "issueLimitWarning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (0, $jMP2a.fireScreenAnalytics)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kJu69.default).title), ' '),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Description, null),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        }),
        actions: actions
    });
};

});
parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("6Lp7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc314c0124c6f1c7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fK6ve = parcelRequire("fK6ve");

var $ajKdU = parcelRequire("ajKdU");
var $cc314c0124c6f1c7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fK6ve.default), {})((0, $ajKdU.default));

});
parcelRegister("fK6ve", function(module, exports) {

$parcel$export(module.exports, "default", () => $400b5c3664b0eb37$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
var $400b5c3664b0eb37$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    loadingLimitsInfo: (0, $dhHiZ.getLoadingLimitsInfo)
});

});

parcelRegister("ajKdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bfd5f0645b97f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7sN00 = parcelRequire("7sN00");
const $e1bfd5f0645b97f6$var$Description = ({ loadingLimitsInfo: loadingLimitsInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $7sN00.default).descriptionWithLimit,
        values: {
            issueLimit: loadingLimitsInfo.absoluteIssueLimit
        }
    });
var $e1bfd5f0645b97f6$export$2e2bcd8739ae039 = $e1bfd5f0645b97f6$var$Description;

});
parcelRegister("7sN00", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef5d91d18148dc4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $1ef5d91d18148dc4$var$messages = (0, $90IgZ.defineMessages)({
    descriptionWithLimit: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.description.description-with-limit",
        "defaultMessage": "The maximum issue count for a plan is {issueLimit} {issueLimit, plural, one {issue} other {issues}}. Try choosing an issue source with fewer issues, or edit your exclusion rules to reduce issue count."
    }
});
var $1ef5d91d18148dc4$export$2e2bcd8739ae039 = $1ef5d91d18148dc4$var$messages;

});



parcelRegister("kJu69", function(module, exports) {

$parcel$export(module.exports, "default", () => $5deb7e055ae3e923$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5deb7e055ae3e923$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.title",
        "defaultMessage": "Issue limit exceeded"
    },
    updateEditIssueSources: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.update-edit-issue-sources",
        "defaultMessage": "Edit issue sources"
    },
    setExclusionRules: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-limit-warning-flag.set-exclusion-rules",
        "defaultMessage": "Set exclusion rules"
    }
});
var $5deb7e055ae3e923$export$2e2bcd8739ae039 = $5deb7e055ae3e923$var$messages;

});



parcelRegister("iAqj8", function(module, exports) {

$parcel$export(module.exports, "getIssueRankWarningFlag", () => (parcelRequire("76kcd")).getIssueRankWarningFlag);

var $76kcd = parcelRequire("76kcd");

});
parcelRegister("76kcd", function(module, exports) {

$parcel$export(module.exports, "getIssueRankWarningFlag", () => $91ec56d68d738032$export$d77a5d6b75a012da);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");
parcelRequire("kyGCj");
var $dvRTl = parcelRequire("dvRTl");

var $8doCW = parcelRequire("8doCW");
const $91ec56d68d738032$export$d77a5d6b75a012da = ({ sortByRank: sortByRank })=>{
    const handleSortByRankButtonClick = (_)=>{
        sortByRank({
            sorting: (0, $dvRTl.defaultSorting)
        });
    };
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8doCW.default).sortByRank),
            onClick: handleSortByRankButtonClick
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "issue-rank-warning-flag",
        id: "issue-rank-warning-flag",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8doCW.default).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8doCW.default).sortedPreventIssueRankingDescription,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
            }
        })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        }),
        actions: actions
    });
};

});
parcelRegister("8doCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b9358b41c3c594$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e8b9358b41c3c594$var$messages = (0, $90IgZ.defineMessages)({
    sortByRank: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.sort-by-rank",
        "defaultMessage": "Sort by Rank"
    },
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.title",
        "defaultMessage": "Issue couldn\u2019t be moved"
    },
    sortedPreventIssueRankingDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-rank-warning-flag.sorted-prevent-issue-ranking-description",
        "defaultMessage": "Sort issues by <strong>Rank</strong> to enable drag and drop."
    }
});
var $e8b9358b41c3c594$export$2e2bcd8739ae039 = $e8b9358b41c3c594$var$messages;

});



parcelRegister("1fQoh", function(module, exports) {

$parcel$export(module.exports, "getIssueSearchWarningFlag", () => (parcelRequire("fdlA6")).getIssueSearchWarningFlag);

var $fdlA6 = parcelRequire("fdlA6");

});
parcelRegister("fdlA6", function(module, exports) {

$parcel$export(module.exports, "getIssueSearchWarningFlag", () => $722c74484dea5077$export$3fa9c14edc12458);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $6R5bd = parcelRequire("6R5bd");

var $j5UQS = parcelRequire("j5UQS");
const $722c74484dea5077$export$3fa9c14edc12458 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Description = (0, $6R5bd.default))=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "issue-search-warning",
        id: "issue-search-warning",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $j5UQS.default).hiddenByFilterTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Description, null)
    });

});
parcelRegister("6R5bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $17200f3c97ed2007$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ihopQ = parcelRequire("ihopQ");

var $hefYE = parcelRequire("hefYE");

var $hKGNJ = parcelRequire("hKGNJ");
var $17200f3c97ed2007$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hefYE.default), (0, $ihopQ.default))((0, $hKGNJ.default));

});
parcelRegister("ihopQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afbda2f553a3ffd$export$2e2bcd8739ae039);

var $eaaIH = parcelRequire("eaaIH");

var $8B14N = parcelRequire("8B14N");
const $9afbda2f553a3ffd$var$mapDispatchToProps = (dispatch)=>({
        clearCustomFieldFilter: (customFields)=>{
            customFields.forEach((customField)=>dispatch((0, $8B14N.clear)({
                    customField: customField
                })));
        },
        clearFilter: (filterId)=>{
            dispatch((0, $eaaIH.clear)(filterId));
        }
    });
var $9afbda2f553a3ffd$export$2e2bcd8739ae039 = $9afbda2f553a3ffd$var$mapDispatchToProps;

});

parcelRegister("hefYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64fb2e3e8fed8d35$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $cwP4d = parcelRequire("cwP4d");

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var $64fb2e3e8fed8d35$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issuesById: (0, $cwP4d.getIssueMapById),
    issueSearchResults: (0, $40hi6.searchForIssues),
    issueTypesById: (0, $lihml.getIssueTypesById),
    projectsById: (0, $ehEr2.getProjectsById)
});

});

parcelRegister("hKGNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96cbc1e0c112a08$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6g33d = parcelRequire("6g33d");

var $a4vO3 = parcelRequire("a4vO3");

var $9kjM2 = parcelRequire("9kjM2");

var $65UHd = parcelRequire("65UHd");

var $hxXfw = parcelRequire("hxXfw");
function $e96cbc1e0c112a08$var$Description({ issueSearchResults: { resultsHiddenByFilter: resultsHiddenByFilter }, issuesById: issuesById, projectsById: projectsById, issueTypesById: issueTypesById, intl: intl, IssueSearchWarningClearFilter: IssueSearchWarningClearFilter }) {
    // if there are up to 2 matching issues hidden by filters, a list of these issues is displayed with:
    // * the issue link
    // * the issue description
    // * the filters hiding the issue
    // * a Clear this (these) filter(s) link
    const showHiddenIssuesList = resultsHiddenByFilter && resultsHiddenByFilter.length > 0 && resultsHiddenByFilter.length <= 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.issue-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $hxXfw.messageText
    }, intl.formatMessage((0, $65UHd.default).hiddenByFilterBody, {
        filterCount: resultsHiddenByFilter.length
    }), !showHiddenIssuesList && intl.formatMessage((0, $65UHd.default).hiddenByClearFilterBody)), showHiddenIssuesList && resultsHiddenByFilter.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9kjM2.default), {
            issue: issuesById[item.id],
            projectKey: projectsById[issuesById[item.id].project.toString()].key,
            issueType: issueTypesById[issuesById[item.id].type.toString()]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $hxXfw.filterDetails
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $hxXfw.filters
        }, intl.formatMessage((0, $65UHd.default).hiddenByFilterLabel), item.unmatchedFilters.map((unmatchedFilter)=>{
            if (unmatchedFilter.type === 'custom') return unmatchedFilter.filters.map((e)=>e.title).join(', ');
            return intl.formatMessage((0, $6g33d.default)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            unmatchedFilter.id]);
        }).join(', ')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueSearchWarningClearFilter, {
            filters: item.unmatchedFilters
        })))));
}
var $e96cbc1e0c112a08$export$2e2bcd8739ae039 = (0, $2qhQi.default)((0, $a4vO3.withSlots)({
    IssueSearchWarningClearFilter: (0, $a4vO3.slots).IssueSearchWarningClearFilter
})($e96cbc1e0c112a08$var$Description));

});
parcelRegister("6g33d", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd650f9073fc7ab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bd650f9073fc7ab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.header",
        "defaultMessage": "Filters"
    },
    clearAllFiltersLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.clear-all-filters-label",
        "defaultMessage": "Clear all filters"
    },
    selected: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.selected",
        "defaultMessage": "selected"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ 'state.domain.view-settings.filters.HIERARCHY_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter-id",
        "defaultMessage": "Hierarchy"
    },
    'state.domain.view-settings.filters.PROJECT_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter-id",
        "defaultMessage": "Projects"
    },
    'state.domain.view-settings.filters.ISSUE_TYPE_KEY_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-type-key-filter-id",
        "defaultMessage": "Issue types"
    },
    'state.domain.view-settings.filters.ISSUE_PRIORITIES_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter-id",
        "defaultMessage": "Priorities"
    },
    'state.domain.view-settings.filters.RELEASE_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter-id",
        "defaultMessage": "Releases"
    },
    'state.domain.view-settings.filters.SUMMARY_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter-id",
        "defaultMessage": "Issue details"
    },
    'state.domain.view-settings.filters.TEAM_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter-id",
        "defaultMessage": "Teams"
    },
    'state.domain.view-settings.filters.ASSIGNEE_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter-id",
        "defaultMessage": "Assignees"
    },
    'state.domain.view-settings.filters.REPORTER_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter-id",
        "defaultMessage": "Reporters"
    },
    'state.domain.view-settings.filters.DEPENDENCIES_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter-id",
        "defaultMessage": "Dependencies"
    },
    'state.domain.view-settings.filters.LABEL_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter-id",
        "defaultMessage": "Labels"
    },
    'state.domain.view-settings.filters.STATUS_KEY_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter-id",
        "defaultMessage": "Statuses"
    },
    'state.domain.view-settings.filters.COMPONENT_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter-id",
        "defaultMessage": "Components"
    },
    'state.domain.view-settings.filters.WARNING_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.warning-filter-id",
        "defaultMessage": "Warnings"
    },
    'state.domain.view-settings.filters.ISSUE_WARNING_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter-id",
        "defaultMessage": "Warnings"
    },
    'state.domain.view-settings.filters.SPRINT_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter-id",
        "defaultMessage": "Sprints"
    },
    'state.domain.view-settings.filters.GOAL_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter-id",
        "defaultMessage": "Goals"
    },
    'state.domain.view-settings.filters.DATE_RANGE_FILTER_ID': {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter-id",
        "defaultMessage": "Date range"
    }
});

});

parcelRegister("9kjM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff1916af0b2984c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hl4M2 = parcelRequire("hl4M2");

var $gwbfD = parcelRequire("gwbfD");

var $kiVij = parcelRequire("kiVij");
function $ff1916af0b2984c1$export$2e2bcd8739ae039(props) {
    const { issue: issue, issueType: issueType, projectKey: projectKey } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: issue.summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $kiVij.issueTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $kiVij.issueIcon,
        style: {
            backgroundImage: issueType && `url(${issueType.iconUrl})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $kiVij.issueSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        issueKey: issue.issueKey,
        projectKey: projectKey,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $kiVij.issueLink
    }), issue.summary)));
}

});
parcelRegister("hl4M2", function(module, exports) {

$parcel$export(module.exports, "default", () => $36768afb78c9644f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $1ybV0 = parcelRequire("1ybV0");

var $5O99T = parcelRequire("5O99T");

var $1OdzL = parcelRequire("1OdzL");
function $36768afb78c9644f$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, issueKey: issueKey, className: className, issueId: issueId } = props;
    const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1ybV0.ff)('jsw.roadmaps.jca11y-505-review-table-switch-to-treegrid-component_s0cfc') ? (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(className, $1OdzL.issueLink) : className,
        href: (0, $5O99T.proxyContextSafeUrl)(`/browse/${fullIssueKey}`),
        target: "_blank",
        rel: "noopener noreferrer",
        id: issueId && `issue-link-${issueId}`
    }, props.children || fullIssueKey);
}

});
parcelRegister("5O99T", function(module, exports) {

$parcel$export(module.exports, "proxyContextSafeUrl", () => $17c3089434a77906$export$ff2a151586ba6aa1);
/**
 * All API calls in the confluence macro need to be wrapped in a proxy if the Jira and Confluence have different base urls.
 * Note this should be used for api calls only, not for links.
 */ const $17c3089434a77906$export$ff2a151586ba6aa1 = (url)=>`${window.integrationApiUrl || window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;

});

parcelRegister("1OdzL", function(module, exports) {

$parcel$export(module.exports, "issueLink", () => $1514fdd297337fbd$export$b71709449311b2f9, (v) => $1514fdd297337fbd$export$b71709449311b2f9 = v);
var $1514fdd297337fbd$export$b71709449311b2f9;
$1514fdd297337fbd$export$b71709449311b2f9 = `aKK0wq_issueLink`;

});


parcelRegister("kiVij", function(module, exports) {

$parcel$export(module.exports, "issueIcon", () => $ec81ee9240b784a6$export$415983cbc1f2b3fe, (v) => $ec81ee9240b784a6$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $ec81ee9240b784a6$export$b71709449311b2f9, (v) => $ec81ee9240b784a6$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueSummary", () => $ec81ee9240b784a6$export$7c7bc027bbbea103, (v) => $ec81ee9240b784a6$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $ec81ee9240b784a6$export$12781bd67c11efd8, (v) => $ec81ee9240b784a6$export$12781bd67c11efd8 = v);
var $ec81ee9240b784a6$export$415983cbc1f2b3fe;
var $ec81ee9240b784a6$export$b71709449311b2f9;
var $ec81ee9240b784a6$export$7c7bc027bbbea103;
var $ec81ee9240b784a6$export$12781bd67c11efd8;
$ec81ee9240b784a6$export$415983cbc1f2b3fe = `R8WuXW_issueIcon`;
$ec81ee9240b784a6$export$b71709449311b2f9 = `R8WuXW_issueLink`;
$ec81ee9240b784a6$export$7c7bc027bbbea103 = `R8WuXW_issueSummary`;
$ec81ee9240b784a6$export$12781bd67c11efd8 = `R8WuXW_issueTitle`;

});


parcelRegister("65UHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae2bc444432f0f9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1ae2bc444432f0f9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hiddenByFilterBody: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-filter-body",
        "defaultMessage": "{filterCount} matching {filterCount, plural, one {issue is} other {issues are}} not displaying due to the filters being used in the plan."
    },
    hiddenByClearFilterBody: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-clear-filter-body",
        "defaultMessage": " Clear all filters, then try again."
    },
    hiddenByFilterLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.description.hidden-by-filter-label",
        "defaultMessage": "Hidden by: "
    }
});

});

parcelRegister("hxXfw", function(module, exports) {

$parcel$export(module.exports, "filterDetails", () => $cc637a6f6069f851$export$f6b2c2cc1afb66a, (v) => $cc637a6f6069f851$export$f6b2c2cc1afb66a = v);
$parcel$export(module.exports, "filters", () => $cc637a6f6069f851$export$82462a21aead86ed, (v) => $cc637a6f6069f851$export$82462a21aead86ed = v);
$parcel$export(module.exports, "messageText", () => $cc637a6f6069f851$export$c43aefe7b0ad01ce, (v) => $cc637a6f6069f851$export$c43aefe7b0ad01ce = v);
var $cc637a6f6069f851$export$f6b2c2cc1afb66a;
var $cc637a6f6069f851$export$82462a21aead86ed;
var $cc637a6f6069f851$export$c43aefe7b0ad01ce;
$cc637a6f6069f851$export$f6b2c2cc1afb66a = `NbYNVa_filterDetails`;
$cc637a6f6069f851$export$82462a21aead86ed = `NbYNVa_filters`;
$cc637a6f6069f851$export$c43aefe7b0ad01ce = `NbYNVa_messageText`;

});



parcelRegister("j5UQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0837fb24c6cccd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a0837fb24c6cccd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hiddenByFilterTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.hidden-by-filter-title",
        "defaultMessage": "Matching results currently not visible"
    }
});

});



parcelRegister("g5yPc", function(module, exports) {

$parcel$export(module.exports, "getJSWNoAccessErrorFlag", () => (parcelRequire("b6MYq")).getJSWNoAccessErrorFlag);

var $b6MYq = parcelRequire("b6MYq");

});
parcelRegister("b6MYq", function(module, exports) {

$parcel$export(module.exports, "getJSWNoAccessErrorFlag", () => $9e9df00b1d56d963$export$f180b5dec38323d9);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $g3Zrw = parcelRequire("g3Zrw");
const $9e9df00b1d56d963$export$f180b5dec38323d9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "jsw-no-access-error",
        id: "jsw-no-access-error",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "nswNoAccessError"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (0, $jMP2a.fireScreenAnalytics)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $g3Zrw.default).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $g3Zrw.default).descriptionSpork),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $g4Vkx.default).R300})`
        })
    });

});
parcelRegister("g3Zrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $354ac78666bc31cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $354ac78666bc31cf$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.jsw-no-access-error-flag.title",
        "defaultMessage": "This plan isn't available"
    },
    descriptionSpork: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.jsw-no-access-error-flag.description-spork",
        "defaultMessage": "Your Jira permissions have changed, and you can no longer view this plan. Contact an administrator to restore access."
    }
});
var $354ac78666bc31cf$export$2e2bcd8739ae039 = $354ac78666bc31cf$var$messages;

});



parcelRegister("b9flG", function(module, exports) {

$parcel$export(module.exports, "getProjectLimitWarningFlag", () => (parcelRequire("c8xCG")).getProjectLimitWarningFlag);

var $c8xCG = parcelRequire("c8xCG");

});
parcelRegister("c8xCG", function(module, exports) {

$parcel$export(module.exports, "getProjectLimitWarningFlag", () => $26a5239c1ddcdcab$export$1fe8482a6799df4d);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $lFLge = parcelRequire("lFLge");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $eeQYa = parcelRequire("eeQYa");
const $26a5239c1ddcdcab$export$1fe8482a6799df4d = ()=>{
    const handleUpdateIssueSourcesButtonClick = (_, analyticsEvent)=>{
        const { id: planId } = (0, $lFLge.getPathParams)();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            actionSubject: 'projectLimitWarningModal',
            action: 'updateLinkClicked'
        }));
        (0, $lFLge.redirectToIssueSourceSetup)(planId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "project-limit-warning",
        id: "project-limit-warning",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "projectLimitWarning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (0, $jMP2a.fireScreenAnalytics)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eeQYa.default).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eeQYa.default).description),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "ProjectLimitException",
            primaryColor: `var(--ds-icon-danger, ${(0, $g4Vkx.default).R400})`
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eeQYa.default).updateEditIssueSources),
                onClick: handleUpdateIssueSourcesButtonClick
            }
        ]
    });
};

});
parcelRegister("eeQYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc277cc43dea76d2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $dc277cc43dea76d2$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.title",
        "defaultMessage": "Your plan includes too many projects"
    },
    description: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.description",
        "defaultMessage": "The number of projects in your plan exceeds the limit set by your administrator. Select fewer issue sources to continue."
    },
    updateEditIssueSources: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.project-limit-warning-flag.update-edit-issue-sources",
        "defaultMessage": "Configure issue sources"
    }
});
var $dc277cc43dea76d2$export$2e2bcd8739ae039 = $dc277cc43dea76d2$var$messages;

});



parcelRegister("c1gJK", function(module, exports) {

$parcel$export(module.exports, "getReparentCMPWarningFlag", () => (parcelRequire("5tijJ")).getReparentCMPWarningFlag);

var $5tijJ = parcelRequire("5tijJ");

});
parcelRegister("5tijJ", function(module, exports) {

$parcel$export(module.exports, "getReparentCMPWarningFlag", () => $8a1cd9126ff28bbf$export$f7c3261e72e1f2af);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $e4C3w = parcelRequire("e4C3w");
const $8a1cd9126ff28bbf$export$f7c3261e72e1f2af = ({ context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "reparent-cmp-warning",
        id: "reparent-cmp-warning",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "getReparentCMPWarningFlag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (0, $jMP2a.fireScreenAnalytics)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e4C3w.default).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $e4C3w.default).description,
            values: context
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        })
    });

});
parcelRegister("e4C3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $822cb41ff48d9d49$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $822cb41ff48d9d49$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-cmp-to-tmp-warning-flag.title",
        "defaultMessage": "Issue can't be moved"
    },
    description: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-cmp-to-tmp-warning-flag.description",
        "defaultMessage": "{issueKey} is part of a company-managed project, and can't be added to {destinationProjectName}."
    }
});
var $822cb41ff48d9d49$export$2e2bcd8739ae039 = $822cb41ff48d9d49$var$messages;

});



parcelRegister("jCtKt", function(module, exports) {

$parcel$export(module.exports, "getReparentTMPWarningFlag", () => (parcelRequire("1oUK6")).getReparentTMPWarningFlag);

var $1oUK6 = parcelRequire("1oUK6");

});
parcelRegister("1oUK6", function(module, exports) {

$parcel$export(module.exports, "getReparentTMPWarningFlag", () => $948b27cd99900095$export$be86b81c21258a33);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $gT2uq = parcelRequire("gT2uq");
const $948b27cd99900095$export$be86b81c21258a33 = ({ context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        key: "reparent-tmp-warning",
        id: "reparent-tmp-warning",
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "getReparentTMPWarningFlag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (0, $jMP2a.fireScreenAnalytics)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gT2uq.default).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $gT2uq.default).description,
            values: context
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        })
    });

});
parcelRegister("gT2uq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ffa0762d553bd4f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $3ffa0762d553bd4f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-tmp-to-external-warning-flag.title",
        "defaultMessage": "Issue can't be moved"
    },
    description: {
        "id": "portfolio-3-portfolio.app-simple-plans.flag-group.reparent-tmp-to-external-warning-flag.description",
        "defaultMessage": "{issueKey} is part of a team-managed project, and can't be moved outside of {projectName}."
    }
});
var $3ffa0762d553bd4f$export$2e2bcd8739ae039 = $3ffa0762d553bd4f$var$messages;

});





parcelRegister("l9J5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3685edc0e64d8bd$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9BKaX = parcelRequire("9BKaX");

var $jHReD = parcelRequire("jHReD");
var $a3685edc0e64d8bd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9BKaX.default), {})((0, $jHReD.default));

});
parcelRegister("9BKaX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a92b48c7baf71e1$export$2e2bcd8739ae039);

var $e4IaE = parcelRequire("e4IaE");

var $dhHiZ = parcelRequire("dhHiZ");
const $7a92b48c7baf71e1$var$mapStateToProps = (state)=>({
        isAtlasConnectInstalled: (0, $dhHiZ.isAtlasConnectInstalled)(state),
        issueGoalARIs: (0, $e4IaE.getIssueGoalARIs)(state)
    });
var $7a92b48c7baf71e1$export$2e2bcd8739ae039 = $7a92b48c7baf71e1$var$mapStateToProps;

});

parcelRegister("jHReD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33e1c56a5c2e1c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lGIBI = parcelRequire("lGIBI");
var $jtsiw = parcelRequire("jtsiw");

var $dWLk9 = parcelRequire("dWLk9");
const $f33e1c56a5c2e1c0$var$GoalsWrapper = ({ issueGoalARIs: issueGoalARIs, children: children, isAtlasConnectInstalled: isAtlasConnectInstalled })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGIBI.GoalsContainer), {
        goalARIs: issueGoalARIs,
        cloudId: cloudId,
        isAtlasConnectInstalled: isAtlasConnectInstalled
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtsiw.default), null));
};
var $f33e1c56a5c2e1c0$export$2e2bcd8739ae039 = $f33e1c56a5c2e1c0$var$GoalsWrapper;

});
parcelRegister("lGIBI", function(module, exports) {

$parcel$export(module.exports, "GoalsContainer", () => $69cb47452941356d$export$ac8a3116a309aa32);
$parcel$export(module.exports, "useLazyGoalByName", () => $69cb47452941356d$export$61cb9465fcab91e4);
$parcel$export(module.exports, "useLazyGoals", () => $69cb47452941356d$export$1d54eb65f5b2abc8);
$parcel$export(module.exports, "useLazyGoalsByARI", () => $69cb47452941356d$export$6e3a4b5b6e8a5982);
$parcel$export(module.exports, "useAllLazyGoals", () => $69cb47452941356d$export$a841e73da87b4519);
$parcel$export(module.exports, "useDefinedGoals", () => $69cb47452941356d$export$94a3d833fc882e5f);
$parcel$export(module.exports, "useLazyGoalSearchesInProgress", () => $69cb47452941356d$export$8610d022c4d2f6d7);

var $3G3gn = parcelRequire("3G3gn");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1h2WE = parcelRequire("1h2WE");

var $83miO = parcelRequire("83miO");
const $69cb47452941356d$export$ac8a3116a309aa32 = (0, $heB5U.createContainer)();
const $69cb47452941356d$var$Store = (0, $a61MH.createStore)({
    containedBy: $69cb47452941356d$export$ac8a3116a309aa32,
    initialState: {
        lazyGoalsByARI: {},
        isError: false,
        searchesInProgress: 0
    },
    actions: $1h2WE.actions,
    handlers: $83miO.handlers
});
const $69cb47452941356d$var$sortLazyGoals = (goals)=>(0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(goals, (goal)=>goal.goal?.name);
const $69cb47452941356d$var$getGoalByName = (state, searchString)=>$69cb47452941356d$var$sortLazyGoals(Object.values(state.lazyGoalsByARI).filter((lazyGoal)=>lazyGoal.goal?.name.toLowerCase().includes(searchString)));
const $69cb47452941356d$var$getGoalByIssueGoals = (state, goalIds)=>$69cb47452941356d$var$sortLazyGoals(goalIds.map((goalId)=>state.lazyGoalsByARI[goalId]));
const $69cb47452941356d$var$getAllLazyGoals = (state)=>$69cb47452941356d$var$sortLazyGoals(Object.values(state.lazyGoalsByARI));
const $69cb47452941356d$export$61cb9465fcab91e4 = (0, $ggKAj.createHook)($69cb47452941356d$var$Store, {
    selector: $69cb47452941356d$var$getGoalByName
});
const $69cb47452941356d$export$1d54eb65f5b2abc8 = (0, $ggKAj.createHook)($69cb47452941356d$var$Store);
const $69cb47452941356d$export$6e3a4b5b6e8a5982 = (0, $ggKAj.createHook)($69cb47452941356d$var$Store, {
    selector: $69cb47452941356d$var$getGoalByIssueGoals
});
const $69cb47452941356d$export$a841e73da87b4519 = (0, $ggKAj.createHook)($69cb47452941356d$var$Store, {
    selector: $69cb47452941356d$var$getAllLazyGoals
});
const $69cb47452941356d$var$getDefinedGoals = (state)=>{
    const definedGoalsByARI = Object.entries(state.lazyGoalsByARI).reduce((acc, [goalARI, lazyGoal])=>{
        if (lazyGoal.goal !== undefined && !lazyGoal.isLoading) {
            const { goal: goal } = lazyGoal;
            acc[goalARI] = goal;
        }
        return acc;
    }, {});
    return definedGoalsByARI;
};
const $69cb47452941356d$export$94a3d833fc882e5f = (0, $ggKAj.createHook)($69cb47452941356d$var$Store, {
    selector: $69cb47452941356d$var$getDefinedGoals
});
const $69cb47452941356d$var$getLazyGoalSearchesInProgress = (state)=>state.searchesInProgress;
const $69cb47452941356d$export$8610d022c4d2f6d7 = (0, $ggKAj.createHook)($69cb47452941356d$var$Store, {
    selector: $69cb47452941356d$var$getLazyGoalSearchesInProgress
});

});
parcelRegister("1h2WE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9a888bb3f83383ea$export$e324594224ef24da);

var $9FOsZ = parcelRequire("9FOsZ");

var $dc8wv = parcelRequire("dc8wv");
const $9a888bb3f83383ea$export$e324594224ef24da = {
    fetchGoalsByFuzzyName: (searchString)=>async ({ getState: getState, setState: setState }, { cloudId: cloudId })=>{
            const { lazyGoalsByARI: prevLazyGoalsByARI } = getState();
            setState({
                searchesInProgress: getState().searchesInProgress + 1
            });
            (0, $9FOsZ.fetchGoalsByFuzzyName)(searchString, cloudId).then((goalNodes)=>{
                const goals = goalNodes.map((0, $dc8wv.transformToGoal));
                const lazyGoalsByARI = goals.reduce((acc, goal)=>{
                    acc[goal.id] = {
                        isLoading: false,
                        goal: goal
                    };
                    return acc;
                }, prevLazyGoalsByARI);
                setState({
                    lazyGoalsByARI: lazyGoalsByARI
                });
            }).catch(()=>{
            // error already logged previously
            }).finally(()=>{
                const { searchesInProgress: searchesInProgress } = getState();
                setState({
                    searchesInProgress: searchesInProgress - 1
                });
            });
        },
    resetError: ()=>({ setState: setState })=>{
            setState({
                isError: false
            });
        }
};

});
parcelRegister("9FOsZ", function(module, exports) {

$parcel$export(module.exports, "fetchGoalsByARI", () => $1c1d375610437296$export$99c828a9ced380c2);
$parcel$export(module.exports, "fetchGoalsByFuzzyName", () => $1c1d375610437296$export$763eca1519d12fb6);

var $iWLL0 = parcelRequire("iWLL0");

var $hompL = parcelRequire("hompL");

var $7byHA = parcelRequire("7byHA");

var $amu7D = parcelRequire("amu7D");

var $15ZJO = parcelRequire("15ZJO");

var $lyeOl = parcelRequire("lyeOl");

var $7Tmp6 = parcelRequire("7Tmp6");

var $5udmX = parcelRequire("5udmX");

var $lyAQI = parcelRequire("lyAQI");
const $1c1d375610437296$var$analyticKey = 'jira.frontend.fe.jpo.fetch-goals';
const $1c1d375610437296$var$performanceMarkPrefix = 'jpo-fetch-goals';
const $1c1d375610437296$var$operationName = (0, $7Tmp6.default).params.name;
const $1c1d375610437296$var$goalsQueryByAriOperationName = (0, $lyeOl.default).params.name;
const $1c1d375610437296$var$sloThreshold = 1000;
const $1c1d375610437296$var$maxPage = 10;
const $1c1d375610437296$var$lastPerformanceMarkIndexes = [
    0
];
const $1c1d375610437296$var$extractNodesFromQuery = (data)=>(data.townsquare.goalTql?.edges ?? []).filter((edge)=>Boolean(edge)).map(({ node: node })=>node);
const $1c1d375610437296$var$extractNodes = (data)=>(data.townsquare.goalsByAri ?? []).filter((goal)=>Boolean(goal));
const $1c1d375610437296$var$getErrorsAndStopCapture = (errorCollector, graphQLOperationName)=>{
    const relevantErrors = (0, $lyAQI.getGraphQLErrorsForOperation)(errorCollector, graphQLOperationName ?? $1c1d375610437296$var$operationName);
    const isError = relevantErrors.length > 0;
    const isPermissionError = isError && relevantErrors.some((relevantError)=>relevantError?.extensions?.statusCode === 403);
    return {
        isError: isError,
        isPermissionError: isPermissionError,
        cause: relevantErrors[0]?.message ?? '',
        statusCode: relevantErrors[0]?.extensions?.statusCode
    };
};
const $1c1d375610437296$var$getNextPageCursor = (data, pageCount)=>{
    if (data.townsquare.goalTql?.pageInfo.hasNextPage && pageCount < $1c1d375610437296$var$maxPage) return data.townsquare.goalTql?.pageInfo.endCursor ?? '';
    return '';
};
// eslint-disable-next-line @typescript-eslint/no-shadow
const $1c1d375610437296$var$getTraceIdAndStopCapture = (operationName)=>{
    const traceIds = (0, $5udmX.getTraceIds)(operationName);
    const traceId = traceIds.length > 0 ? traceIds[traceIds.length - 1] : '';
    (0, $5udmX.stopCapturingTraceIds)(operationName);
    return traceId;
};
const $1c1d375610437296$var$measureAndClearPerformance = (pageCount, markIndex)=>{
    const performanceMark = `${$1c1d375610437296$var$performanceMarkPrefix}-${pageCount}`;
    const { duration: duration } = performance.measure(`${performanceMark}-measure`, performanceMark);
    // Only the last performance measure needs to clear the mark
    // Trying to clear the same mark again will cause an error
    if (markIndex === $1c1d375610437296$var$lastPerformanceMarkIndexes[pageCount - 1]) performance.clearMarks(performanceMark);
    // In practice, it isn't necessary to reset the performance mark index because it won't exceed max number
    return duration;
};
const $1c1d375610437296$var$cleanUpPerformanceAndLog = (statusCode, cause, pageCount, group, markIndex, traceId)=>{
    (0, $lyAQI.sendOperationalEvent)({
        analyticKey: $1c1d375610437296$var$analyticKey,
        statusCode: statusCode,
        cause: cause,
        duration: $1c1d375610437296$var$measureAndClearPerformance(pageCount, markIndex),
        sloThreshold: $1c1d375610437296$var$sloThreshold,
        pages: pageCount,
        group: group,
        traceId: traceId
    });
};
const $1c1d375610437296$var$cleanUpAndLog = (// eslint-disable-next-line @typescript-eslint/no-shadow
operationName, statusCode, cause, pageCount, group, markIndex)=>{
    $1c1d375610437296$var$cleanUpPerformanceAndLog(statusCode, cause, pageCount, group, markIndex, $1c1d375610437296$var$getTraceIdAndStopCapture(operationName));
};
const $1c1d375610437296$var$fetchGoalPagesByARI = (goalARIs, chunkSize, maxChunks)=>{
    const createFetchGoalsPromise = (goalARIChunk, pageCount)=>new Promise((resolve, reject)=>{
            const performanceMark = `${$1c1d375610437296$var$performanceMarkPrefix}-${pageCount}`;
            performance.mark(performanceMark);
            $1c1d375610437296$var$lastPerformanceMarkIndexes[pageCount - 1] += 1;
            const currentMarkIndex = $1c1d375610437296$var$lastPerformanceMarkIndexes[pageCount - 1];
            // will automatically clean up error collector after a while if not cleaned up explicitly
            const errorCollector = (0, $15ZJO.startCaptureGraphQlErrors)();
            (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $lyeOl.default), {
                goalARIs: goalARIChunk
            }).toPromise().then((data)=>{
                const { isError: isError, isPermissionError: isPermissionError, cause: cause, statusCode: statusCode } = $1c1d375610437296$var$getErrorsAndStopCapture(errorCollector, $1c1d375610437296$var$goalsQueryByAriOperationName);
                const traceIds = (0, $5udmX.getTraceIds)($1c1d375610437296$var$goalsQueryByAriOperationName);
                const traceId = traceIds.length > 0 ? traceIds[traceIds.length - 1] : undefined;
                if (!isError && data?.townsquare.goalsByAri) {
                    $1c1d375610437296$var$cleanUpPerformanceAndLog(200, '', pageCount, 'nogroup', currentMarkIndex, traceId);
                    const goalNodes = $1c1d375610437296$var$extractNodes(data);
                    resolve(goalNodes);
                } else if (isPermissionError) {
                    $1c1d375610437296$var$cleanUpPerformanceAndLog(403, '', pageCount, 'nogroup', currentMarkIndex, traceId);
                    reject(new (0, $7byHA.ValidationError)('Permission', [], 403));
                } else {
                    $1c1d375610437296$var$cleanUpPerformanceAndLog(statusCode, cause, 1, 'nogroup', currentMarkIndex, traceId);
                    reject(new (0, $7byHA.ValidationError)(cause ?? 'Error fetching goals', [], statusCode));
                }
            }).catch((error)=>{
                const { statusCode: statusCode, cause: cause } = (0, $lyAQI.getErrorDetails)(error);
                const traceId = (0, $5udmX.getTraceIds)($1c1d375610437296$var$goalsQueryByAriOperationName)[pageCount - 1];
                $1c1d375610437296$var$cleanUpPerformanceAndLog(statusCode, cause, pageCount, 'nogroup', currentMarkIndex, traceId);
                reject(error);
            });
        });
    const goalARIChunks = [];
    const maxSize = chunkSize * maxChunks;
    for(let i = 0; i < goalARIs.length && i < maxSize; i += chunkSize)goalARIChunks.push(goalARIs.slice(i, i + chunkSize));
    while($1c1d375610437296$var$lastPerformanceMarkIndexes.length < goalARIChunks.length)$1c1d375610437296$var$lastPerformanceMarkIndexes.push(0);
    (0, $5udmX.startCapturingTraceIds)($1c1d375610437296$var$goalsQueryByAriOperationName);
    return Promise.allSettled(goalARIChunks.map((chunk, i)=>createFetchGoalsPromise(chunk, i + 1))).finally(()=>(0, $5udmX.stopCapturingTraceIds)($1c1d375610437296$var$goalsQueryByAriOperationName));
};
const $1c1d375610437296$var$fetchGoalPagesByQuery = (query, cloudId, pageCursor = null, pageCount = 1, group = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4())=>{
    performance.mark(`${$1c1d375610437296$var$performanceMarkPrefix}-${pageCount}`);
    $1c1d375610437296$var$lastPerformanceMarkIndexes[pageCount - 1] += 1;
    const currentMarkIndex = $1c1d375610437296$var$lastPerformanceMarkIndexes[pageCount - 1];
    // safe to call startCapturingTraceIds multiple times
    (0, $5udmX.startCapturingTraceIds)($1c1d375610437296$var$operationName);
    // will automatically clean up error collector after a while if not cleaned up explicitly
    const errorCollector = (0, $15ZJO.startCaptureGraphQlErrors)();
    return new Promise((resolve, reject)=>{
        (0, $iWLL0.fetchQuery)((0, $amu7D.default), (0, $7Tmp6.default), {
            query: query,
            cloudId: cloudId,
            pageCursor: pageCursor
        }).toPromise().then((data)=>{
            const { isError: isError, isPermissionError: isPermissionError, cause: cause, statusCode: statusCode } = $1c1d375610437296$var$getErrorsAndStopCapture(errorCollector);
            if (!isError && data?.townsquare.goalTql) {
                $1c1d375610437296$var$cleanUpAndLog($1c1d375610437296$var$operationName, 200, '', pageCount, group, currentMarkIndex);
                const goalNodes = $1c1d375610437296$var$extractNodesFromQuery(data);
                const nextPageCursor = $1c1d375610437296$var$getNextPageCursor(data, pageCount);
                if (nextPageCursor) {
                    $1c1d375610437296$var$lastPerformanceMarkIndexes.push(0);
                    return $1c1d375610437296$var$fetchGoalPagesByQuery(query, cloudId, nextPageCursor, pageCount + 1, group).then((nextPageNodes)=>{
                        resolve(goalNodes.concat(nextPageNodes));
                    }).catch((error)=>{
                        // no need to handle the error right now, just bubble it up
                        reject(error);
                    });
                }
                resolve(goalNodes);
            } else if (isPermissionError) {
                $1c1d375610437296$var$cleanUpAndLog($1c1d375610437296$var$operationName, 403, '', pageCount, group, currentMarkIndex);
                reject(new (0, $7byHA.ValidationError)('Permission', [], 403));
            } else {
                $1c1d375610437296$var$cleanUpAndLog($1c1d375610437296$var$operationName, statusCode, cause, pageCount, group, currentMarkIndex);
                reject(new (0, $7byHA.ValidationError)(cause ?? 'Error fetching goals', [], statusCode));
            }
        }).catch((error)=>{
            const { statusCode: statusCode, cause: cause } = (0, $lyAQI.getErrorDetails)(error);
            $1c1d375610437296$var$cleanUpAndLog($1c1d375610437296$var$operationName, statusCode, cause, pageCount, group, currentMarkIndex);
            reject(error);
        });
    });
};
const $1c1d375610437296$export$99c828a9ced380c2 = (sourceARIs, chunkSize = 200, maxChunks = 10)=>$1c1d375610437296$var$fetchGoalPagesByARI(sourceARIs, chunkSize, maxChunks);
const $1c1d375610437296$export$763eca1519d12fb6 = (searchString, cloudId)=>{
    const query = `name like "${searchString}"`; // will be case-insensitive
    // only need to fetch a few goals for fuzzy name search so unnecessary to fetch additional pages
    return $1c1d375610437296$var$fetchGoalPagesByQuery(query, cloudId);
};

});
parcelRegister("lyeOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c439a1dba2fd5341$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4ae2c40c73a5cdbfdba20bfaf1d2db5>>
 * @relayHash e6e5fd76b4cc952ae1885a889b26de69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fafda54e23b12f97e9723b1e9f743e50e3243bdb69d33b3ecf88d8ff6275db2
const $c439a1dba2fd5341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "goalARIs"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "aris",
            "variableName": "goalARIs"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "score"
    }, v8 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "atlasGoalsByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goalsByAri",
                                "plural": true,
                                "selections": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": v4 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "townsquare.goalsByAri.url"
                                    },
                                    v5 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "TownsquareGoalState",
                                            "kind": "LinkedField",
                                            "name": "state",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "townsquare.goalsByAri.state.label"
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v8 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "townsquare.goalsByAri.state.value"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "townsquare.goalsByAri.state"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "townsquare"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "atlasGoalsByAriQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goalsByAri",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalState",
                                    "kind": "LinkedField",
                                    "name": "state",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4fafda54e23b12f97e9723b1e9f743e50e3243bdb69d33b3ecf88d8ff6275db2",
            "metadata": {},
            "name": "atlasGoalsByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c439a1dba2fd5341$var$node.hash = "5e9d34750d68538ced3164f9d1265228";
var $c439a1dba2fd5341$export$2e2bcd8739ae039 = $c439a1dba2fd5341$var$node;

});

parcelRegister("7Tmp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $285c8e6372214e73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e7be2124d7e828464ba4eb91d7f5a62>>
 * @relayHash 5728c562e353c2c75aa6262fd60ad456
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5aebb6a60ad0ae312e10f0d443a3d8c9c915aad3015c028c6c3abfd0f2cf00da
const $285c8e6372214e73$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageCursor"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "pageCursor"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "q",
            "variableName": "query"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "label"
    }, v9 = {
        "kind": "ScalarField",
        "name": "score"
    }, v10 = {
        "kind": "ScalarField",
        "name": "value"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "atlasGoalsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "TownsquareQueryApi",
                        "kind": "LinkedField",
                        "name": "townsquare",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3 /*: any*/ ,
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "goalTql",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "TownsquareGoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "TownsquareGoal",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4 /*: any*/ ,
                                                            v5 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v6 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "townsquare.goalTql.edges.node.url"
                                                            },
                                                            v7 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "TownsquareGoalState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v8 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "townsquare.goalTql.edges.node.state.label"
                                                                        },
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v10 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "townsquare.goalTql.edges.node.state.value"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "townsquare.goalTql.edges.node.state"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "townsquare.goalTql.edges.node"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "townsquare.goalTql.edges"
                                    },
                                    v11 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "townsquare"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "atlasGoalsQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goalTql",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "state",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5aebb6a60ad0ae312e10f0d443a3d8c9c915aad3015c028c6c3abfd0f2cf00da",
            "metadata": {},
            "name": "atlasGoalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$285c8e6372214e73$var$node.hash = "c3ba9fce92754742082d3128d96b3608";
var $285c8e6372214e73$export$2e2bcd8739ae039 = $285c8e6372214e73$var$node;

});

parcelRegister("lyAQI", function(module, exports) {

$parcel$export(module.exports, "getGraphQLErrorsForOperation", () => $b4e10db61363b05f$export$1ae618599d319ba5);
$parcel$export(module.exports, "getErrorDetails", () => $b4e10db61363b05f$export$33e83b6fee5d732d);
$parcel$export(module.exports, "sendOperationalEvent", () => $b4e10db61363b05f$export$e5f89b51c6d4e36b);

var $7byHA = parcelRequire("7byHA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $15ZJO = parcelRequire("15ZJO");
const $b4e10db61363b05f$export$1ae618599d319ba5 = (errorCollector, operationName)=>{
    const errorsWithMeta = (0, $15ZJO.stopCaptureGraphQlErrors)(errorCollector);
    if (Array.isArray(errorsWithMeta)) return errorsWithMeta.filter((errorWithMeta)=>errorWithMeta.meta.operationName === operationName).flatMap((errorWithMeta)=>errorWithMeta.errors);
    return [];
};
const $b4e10db61363b05f$export$33e83b6fee5d732d = (error)=>{
    if (error instanceof (0, $7byHA.ValidationError) || error instanceof (0, $7byHA.default)) return {
        cause: error.message ?? 'An unknown error has occurred.',
        statusCode: error.statusCode,
        traceId: error.traceId
    };
    if (error instanceof DOMException && error.name === 'AbortError') // When abort() is called, the fetch() promise rejects with an Error of type DOMException, with name AbortError.
    // See https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort for more details
    return {
        cause: 'Query was aborted.',
        statusCode: 0
    };
    if (error instanceof SyntaxError) // SyntaxError will usually be thrown when the json format is invalid.
    // Currently, no details are provided (traceId status code or content types).
    return {
        cause: 'Query response payload was invalid and could not be parsed.',
        statusCode: 500
    };
    return {
        cause: 'An unknown error has occurred.',
        statusCode: undefined
    };
};
const $b4e10db61363b05f$export$e5f89b51c6d4e36b = ({ analyticKey: analyticKey, traceId: traceId, statusCode: statusCode, cause: cause, duration: duration, sloThreshold: sloThreshold, pages: pages, group: group })=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        const statusCodeString = `${statusCode}`;
        if (statusCode === 0 || statusCode === 429) // special status codes
        statusCodeFamily = statusCodeString;
        else if (statusCodeString.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeString[0]}xx`;
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'relay operation',
            attributes: {
                key: analyticKey,
                traceId: traceId,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily,
                cause: cause,
                duration: duration,
                slo: duration <= sloThreshold,
                sloThreshold: sloThreshold,
                frontendVersion: window.BUILD_KEY,
                pages: pages,
                group: group
            },
            source: 'relayOperation'
        });
    });
};

});


parcelRegister("dc8wv", function(module, exports) {

$parcel$export(module.exports, "transformToGoal", () => $7a984e4c30a97d0d$export$2bad26f5d4979c25);
const $7a984e4c30a97d0d$export$2bad26f5d4979c25 = ({ id: id, key: key, name: name, state: state, url: url })=>({
        id: id,
        key: key,
        name: name,
        url: url,
        state: {
            ...state,
            score: state.score ?? undefined
        }
    });

});


parcelRegister("83miO", function(module, exports) {

$parcel$export(module.exports, "handlers", () => $ab30ad4a6ffcc031$export$455ce229eb3d2472);

var $9FOsZ = parcelRequire("9FOsZ");

var $dc8wv = parcelRequire("dc8wv");
const $ab30ad4a6ffcc031$var$asInitialLazyGoal = (goalARIs)=>goalARIs.reduce((acc, goalARI)=>{
        acc[goalARI] = {
            isLoading: true,
            goal: undefined
        };
        return acc;
    }, {});
const $ab30ad4a6ffcc031$var$fetchAndSetLazyGoalsByARI = (newGoalARIs, setState, prevLazyGoalsByARIs = {})=>{
    (0, $9FOsZ.fetchGoalsByARI)(newGoalARIs).then((goalPromises)=>{
        let isError = false;
        const goalNodes = [];
        goalPromises.forEach((promiseResult)=>{
            if (promiseResult.status === 'fulfilled') goalNodes.push(...promiseResult.value);
            else if (promiseResult.reason instanceof Error) {
                if (promiseResult.reason.message !== 'Permission') isError = true;
            }
        });
        const goals = goalNodes.map((0, $dc8wv.transformToGoal));
        const lazyGoalsByARI = goals.reduce((acc, goal)=>{
            acc[goal.id] = {
                isLoading: false,
                goal: goal
            };
            return acc;
        }, prevLazyGoalsByARIs);
        // reset loading state of unknown goals, e.g. goals that were deleted
        newGoalARIs.reduce((acc, goalARI)=>{
            if (!(goalARI in acc)) acc[goalARI] = {
                isLoading: false,
                goal: undefined
            };
            return acc;
        }, lazyGoalsByARI);
        setState({
            lazyGoalsByARI: lazyGoalsByARI,
            ...isError ? {
                isError: isError
            } : {}
        });
    });
};
const $ab30ad4a6ffcc031$export$455ce229eb3d2472 = {
    onInit: ()=>({ setState: setState }, { goalARIs: goalARIs, isAtlasConnectInstalled: isAtlasConnectInstalled })=>{
            if (isAtlasConnectInstalled && goalARIs.length > 0) {
                // set initial loading state
                setState({
                    lazyGoalsByARI: $ab30ad4a6ffcc031$var$asInitialLazyGoal(goalARIs)
                });
                $ab30ad4a6ffcc031$var$fetchAndSetLazyGoalsByARI(goalARIs, setState);
            }
        },
    onContainerUpdate: ()=>({ getState: getState, setState: setState }, { goalARIs: goalARIs, isAtlasConnectInstalled: isAtlasConnectInstalled })=>{
            if (isAtlasConnectInstalled && goalARIs.length > 0) {
                const { lazyGoalsByARI: prevLazyGoalsByARIs } = getState();
                const difference = goalARIs.reduce((acc, goalARI)=>{
                    if (prevLazyGoalsByARIs[goalARI] === undefined) acc.push(goalARI);
                    return acc;
                }, []);
                if (difference.length > 0) {
                    // set initial loading state
                    setState({
                        lazyGoalsByARI: {
                            ...prevLazyGoalsByARIs,
                            ...$ab30ad4a6ffcc031$var$asInitialLazyGoal(difference)
                        }
                    });
                    $ab30ad4a6ffcc031$var$fetchAndSetLazyGoalsByARI(difference, setState, prevLazyGoalsByARIs);
                }
            }
        }
};

});


parcelRegister("jtsiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe61bef6bdd1809$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $cCFSU = parcelRequire("cCFSU");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lGIBI = parcelRequire("lGIBI");

var $dtdPH = parcelRequire("dtdPH");
const $9fe61bef6bdd1809$var$GoalsErrorFlag = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ isError: isError }, { resetError: resetError }] = (0, $lGIBI.useLazyGoals)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const flagId = 'jpo-goals-error-flag';
    const onDismissed = (0, $eUqFw.useCallback)(()=>{
        resetError();
        dismissFlag(flagId);
    }, [
        resetError,
        dismissFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isError && showFlag({
            id: flagId,
            render: (flagCustomRendererProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                    ...flagCustomRendererProps,
                    id: flagId,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                        label: formatMessage((0, $dtdPH.default).errorFlagIconLabel),
                        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
                    }),
                    title: formatMessage((0, $dtdPH.default).errorFlagTitle),
                    description: formatMessage((0, $dtdPH.default).errorFlagDescription),
                    onDismissed: onDismissed
                })
        });
    }, [
        isError,
        showFlag,
        formatMessage,
        onDismissed
    ]);
    return null;
};
var $9fe61bef6bdd1809$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($9fe61bef6bdd1809$var$GoalsErrorFlag);

});
parcelRegister("dtdPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d837e84cad6e822$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $6d837e84cad6e822$var$messages = (0, $90IgZ.defineMessages)({
    errorFlagTitle: {
        "id": "portfolio-3-atlas-goals.ui.error-flag.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "portfolio-3-atlas-goals.ui.error-flag.error-flag-description",
        "defaultMessage": "There was an error when loading in Atlas goals. Please try refreshing the page."
    },
    errorFlagIconLabel: {
        "id": "portfolio-3-atlas-goals.ui.error-flag.error-flag-icon-label",
        "defaultMessage": "Error"
    }
});
var $6d837e84cad6e822$export$2e2bcd8739ae039 = $6d837e84cad6e822$var$messages;

});




parcelRegister("abgpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f21ed09102d4910$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bUi2Q = parcelRequire("bUi2Q");
var $kpmC0 = parcelRequire("kpmC0");

var $lGIBI = parcelRequire("lGIBI");

var $7SyBh = parcelRequire("7SyBh");

var $7Jv2m = parcelRequire("7Jv2m");

var $lNNXV = parcelRequire("lNNXV");

var $ab6rA = parcelRequire("ab6rA");

var $nQeGY = parcelRequire("nQeGY");

var $2Alm8 = parcelRequire("2Alm8");

var $6DiV9 = parcelRequire("6DiV9");
const $2f21ed09102d4910$var$ConnectedRoadmap = (0, $lNNXV.connect)((0, $2Alm8.default), (0, $nQeGY.default))((0, $6DiV9.default));
const $2f21ed09102d4910$var$RoadmapWrapper = (props)=>{
    /** The vertical scrollbar width. */ const SCROLLBAR_WIDTH = 18;
    const { software: edition } = (0, $ab6rA.useAppEditions)();
    const currentRightSidebarState = (0, $bUi2Q.useActiveRightSidebarState)();
    const { isCollapsed: isLeftSideBarCollapsed, width: width } = (0, $kpmC0.useLeftSidebarState)();
    const currentRightSidebarWidth = currentRightSidebarState && !currentRightSidebarState.isCollapsed ? currentRightSidebarState.width : 0;
    const [{ spotlight: onboardingSpotlight }] = (0, $7Jv2m.useCurrentSpotlight)();
    const [cttOnboardingSpotlight] = (0, $7SyBh.useCttSpotlight)();
    const spotlightSelection = onboardingSpotlight === (0, $7Jv2m.Spotlights).Inactive ? cttOnboardingSpotlight : onboardingSpotlight;
    const leftSidebarWidth = !isLeftSideBarCollapsed ? width : SCROLLBAR_WIDTH;
    const intl = (0, $5JgJ2.default)();
    const [{ lazyGoalsByARI: lazyGoalsByARI }] = (0, $lGIBI.useLazyGoals)();
    const isGoalsLoading = Object.values(lazyGoalsByARI).some((goal)=>goal.isLoading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f21ed09102d4910$var$ConnectedRoadmap, {
        ...props,
        edition: edition,
        intl: intl,
        isGoalsLoading: isGoalsLoading,
        leftSidebarWidth: leftSidebarWidth,
        rightSidebarWidth: currentRightSidebarWidth,
        spotlight: spotlightSelection
    });
};
var $2f21ed09102d4910$export$2e2bcd8739ae039 = $2f21ed09102d4910$var$RoadmapWrapper;

});
parcelRegister("7SyBh", function(module, exports) {

$parcel$export(module.exports, "useCttOnboardingTour", () => $e41c6db7e98cba40$export$b78e1ee36b9243d8);
$parcel$export(module.exports, "useCttSpotlight", () => $e41c6db7e98cba40$export$aa62f0dd18431aa7);
$parcel$export(module.exports, "CttOnboardingProvider", () => $e41c6db7e98cba40$export$1de71d05d686e991);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $cpI3a = parcelRequire("cpI3a");

var $fA5YX = parcelRequire("fA5YX");

var $iRHpq = parcelRequire("iRHpq");
const $e41c6db7e98cba40$var$initialState = {
    _rehydrated: false
};
const $e41c6db7e98cba40$var$store = (0, $a61MH.createStore)({
    initialState: $e41c6db7e98cba40$var$initialState,
    actions: $cpI3a.actions,
    name: 'portfolio-3/ctt-onboarding'
});
const $e41c6db7e98cba40$export$783184fef467e477 = (0, $ggKAj.createHook)($e41c6db7e98cba40$var$store, {
    selector: (state)=>state._rehydrated
});
const $e41c6db7e98cba40$export$b78e1ee36b9243d8 = (0, $ggKAj.createHook)($e41c6db7e98cba40$var$store, {
    selector: (0, $fA5YX.selectCttOnboardingTour)
});
const $e41c6db7e98cba40$export$aa62f0dd18431aa7 = (0, $ggKAj.createHook)($e41c6db7e98cba40$var$store, {
    selector: (0, $fA5YX.selectCttSpotlight)
});
const $e41c6db7e98cba40$export$1de71d05d686e991 = (0, $heB5U.createContainer)($e41c6db7e98cba40$var$store, {
    onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (getState()._rehydratePromise === undefined) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const promise = dispatch((0, $iRHpq.rehydrate));
                setState({
                    _rehydratePromise: promise
                });
                await promise;
            }
        }
});

});
parcelRegister("cpI3a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0ed6bf843a6a0c18$export$e324594224ef24da);

var $jDE3A = parcelRequire("jDE3A");

var $iRHpq = parcelRequire("iRHpq");
const $0ed6bf843a6a0c18$var$cttOnboardingActions = {
    initCttOnboarding: (planId)=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            const { cttOnboarding: cttOnboarding } = getState();
            if (planId === null) return;
            if (!cttOnboarding) {
                setState({
                    cttOnboarding: {
                        stage: (0, $jDE3A.CttOnboardingStage).CREATE_INITATIVE,
                        planId: planId
                    }
                });
                return;
            }
            if (cttOnboarding.planId !== planId && cttOnboarding.stage !== (0, $jDE3A.CttOnboardingStage).CLOSED && cttOnboarding.stage !== (0, $jDE3A.CttOnboardingStage).FINISH_FLAG) setState({
                cttOnboarding: {
                    stage: (0, $jDE3A.CttOnboardingStage).CREATE_INITATIVE,
                    planId: planId
                }
            });
        },
    setCttTakingTour: ()=>({ setState: setState, getState: getState })=>{
            const { cttOnboarding: currentCttOnboarding } = getState();
            if (!currentCttOnboarding) return;
            setState({
                cttOnboarding: {
                    ...currentCttOnboarding
                },
                isTakingOnboardingTour: true
            });
        },
    resetCttTakingTour: ()=>({ setState: setState })=>{
            setState({
                isTakingOnboardingTour: false
            });
        },
    nextCttStage: (skipTo)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const assertUnreachable = (_)=>{
                throw new Error("Didn't expect to get here");
            };
            const { cttOnboarding: cttOnboarding } = getState();
            if (!cttOnboarding) return;
            const { planId: planId, stage: stage } = cttOnboarding;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const updateStage = (updateStage, persist = true, ui = true)=>{
                dispatch((0, $iRHpq.update)({
                    ui: ui,
                    persist: persist
                })({
                    cttOnboarding: {
                        stage: updateStage,
                        planId: planId
                    }
                }));
            };
            if (skipTo) {
                Object.values((0, $jDE3A.CttOnboardingStage)).includes(skipTo) && updateStage(skipTo, true);
                return;
            }
            try {
                switch(stage){
                    case (0, $jDE3A.CttOnboardingStage).CREATE_INITATIVE:
                        updateStage((0, $jDE3A.CttOnboardingStage).INPUT_TITLE, false);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).INPUT_TITLE:
                        updateStage((0, $jDE3A.CttOnboardingStage).NAVIGATE_ISSUE_SOURCES, false);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).NAVIGATE_ISSUE_SOURCES:
                        updateStage((0, $jDE3A.CttOnboardingStage).SHOW_ISSUE_SOURCES, true);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).SHOW_ISSUE_SOURCES:
                        updateStage((0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN, false);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN:
                        updateStage((0, $jDE3A.CttOnboardingStage).EPIC_REPARENT, true);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).EPIC_REPARENT:
                        updateStage((0, $jDE3A.CttOnboardingStage).INPUT_EPIC_REPARENT, false);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).INPUT_EPIC_REPARENT:
                        updateStage((0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES, true);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES:
                        updateStage((0, $jDE3A.CttOnboardingStage).FINISH_FLAG, true);
                        updateStage((0, $jDE3A.CttOnboardingStage).CLOSED, true, false);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).FINISH_FLAG:
                        updateStage((0, $jDE3A.CttOnboardingStage).CLOSED, true);
                        break;
                    case (0, $jDE3A.CttOnboardingStage).CLOSED:
                        break;
                    default:
                        assertUnreachable(stage);
                }
            } catch (e) {
                setState({
                    cttOnboarding: {
                        ...cttOnboarding,
                        stage: (0, $jDE3A.CttOnboardingStage).CLOSED
                    }
                });
            }
        },
    closeCttOnboarding: ({ silent: silent } = {
        silent: true
    })=>({ getState: getState, dispatch: dispatch })=>{
            const planId = getState().cttOnboarding?.planId || -1;
            dispatch((0, $iRHpq.update)({
                ui: !silent,
                persist: true
            })({
                cttOnboarding: {
                    stage: (0, $jDE3A.CttOnboardingStage).CLOSED,
                    planId: planId
                },
                isTakingOnboardingTour: false
            }));
        },
    setSpotlight: (spotlight)=>({ getState: getState, dispatch: dispatch })=>{
            const { cttOnboarding: currentCttOnboarding } = getState();
            if (!currentCttOnboarding) return;
            dispatch((0, $iRHpq.update)({
                ui: true,
                persist: false
            })({
                spotlight: spotlight
            }));
        },
    resetSpotlight: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { cttOnboarding: currentCttOnboarding } = getState();
            if (!currentCttOnboarding) return;
            dispatch((0, $iRHpq.update)({
                ui: true,
                persist: false
            })({
                spotlight: undefined
            }));
        }
};
const $0ed6bf843a6a0c18$export$e324594224ef24da = {
    ...$0ed6bf843a6a0c18$var$cttOnboardingActions
};

});
parcelRegister("jDE3A", function(module, exports) {

$parcel$export(module.exports, "CttOnboardingStage", () => $580bc7e305382f96$export$883197f7727aad4b);
$parcel$export(module.exports, "CttOnboardingVariant", () => $580bc7e305382f96$export$394887c171dcc249);
const $580bc7e305382f96$export$883197f7727aad4b = {
    CREATE_INITATIVE: 'CREATE_INITATIVE',
    INPUT_TITLE: 'INPUT_TITLE',
    NAVIGATE_ISSUE_SOURCES: 'NAVIGATE_ISSUE_SOURCES',
    SHOW_ISSUE_SOURCES: 'SHOW_ISSUE_SOURCES',
    NAVIGATE_PLAN: 'NAVIGATE_PLAN',
    EPIC_REPARENT: 'EPIC_REPARENT',
    INPUT_EPIC_REPARENT: 'INPUT_EPIC_REPARENT',
    REVIEW_CHANGES: 'REVIEW_CHANGES',
    FINISH_FLAG: 'FINISH_FLAG',
    CLOSED: 'CLOSED'
};
const $580bc7e305382f96$export$394887c171dcc249 = {
    TMP_EPIC: 'TMP_EPIC',
    NO_EPIC: 'NO_EPIC',
    EPIC: 'EPIC',
    NO_INITIATIVE: 'NO_INITIATIVE'
};

});

parcelRegister("iRHpq", function(module, exports) {

$parcel$export(module.exports, "rehydrate", () => $3ca7b000d776c63d$export$27af23fc693b4501);
$parcel$export(module.exports, "update", () => $3ca7b000d776c63d$export$722fbec263ad908a);

var $2eIIH = parcelRequire("2eIIH");

var $fVqUX = parcelRequire("fVqUX");

var $lRmyA = parcelRequire("lRmyA");

var $jDE3A = parcelRequire("jDE3A");
const $3ca7b000d776c63d$var$PERSIST_KEY = 'jira.user.arj.ctt-onboarding';
const $3ca7b000d776c63d$var$getCttOnboardingUserProperties = async (accountId)=>{
    const fetchResponse = await fetch(`/rest/api/3/user/properties/${$3ca7b000d776c63d$var$PERSIST_KEY}?accountId=${accountId}`, (0, $fVqUX.default));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not migrated their data
    if (status === 404) return undefined;
    throw new Error(`Fetching ${$3ca7b000d776c63d$var$PERSIST_KEY} user property failed. Status code: ${fetchResponse.status}`);
};
const $3ca7b000d776c63d$export$27af23fc693b4501 = async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
    if (getState()._rehydrated) return;
    // Mark as any since it's assumed to be opaque, we ensure type safety in the code below.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let raw = {};
    const response = await $3ca7b000d776c63d$var$getCttOnboardingUserProperties(accountId);
    if (response) raw = response;
    else raw = {};
    const cttOnboarding = (()=>{
        const stage = raw.cttOnboarding?.stage;
        if (stage && Object.values((0, $jDE3A.CttOnboardingStage)).includes(stage)) return {
            stage: stage,
            planId: raw.cttOnboarding?.planId
        };
        return undefined;
    })();
    setState({
        _rehydrated: true,
        cttOnboarding: cttOnboarding
    });
};
const $3ca7b000d776c63d$export$9a6132153fba2e0 = (update)=>async ({ getState: getState }, { accountId: accountId })=>{
        const serialize = (0, (/*@__PURE__*/$parcel$interopDefault($2eIIH)))([
            'cttOnboarding'
        ]);
        await (0, $lRmyA.performPutRequest)(`/rest/api/3/user/properties/${$3ca7b000d776c63d$var$PERSIST_KEY}?accountId=${accountId}`, {
            body: JSON.stringify(serialize({
                ...getState(),
                ...update
            }))
        });
    };
const $3ca7b000d776c63d$export$722fbec263ad908a = (options = {
    ui: true,
    persist: true
})=>(partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
            if (!_rehydrated) await _rehydratePromise;
            if (options.ui) setState(partial);
            if (options.persist) dispatch($3ca7b000d776c63d$export$9a6132153fba2e0({
                ...getState(),
                ...partial
            }));
        };

});
parcelRegister("2eIIH", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $1a0f940879a67d42$var$func = $jFIrw('pick', (parcelRequire("8dloj")));

$1a0f940879a67d42$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $1a0f940879a67d42$var$func;

});



parcelRegister("fA5YX", function(module, exports) {

$parcel$export(module.exports, "selectCttOnboardingTour", () => $35bbb93fa80e9762$export$7aab0ca2606d6c15);
$parcel$export(module.exports, "selectCttSpotlight", () => $35bbb93fa80e9762$export$27269b971d238c07);

var $jDE3A = parcelRequire("jDE3A");
const $35bbb93fa80e9762$var$assertUnreachable = (_)=>{
    throw new Error("Didn't expect to get here");
};
const $35bbb93fa80e9762$export$7aab0ca2606d6c15 = ({ cttOnboarding: cttOnboarding, isTakingOnboardingTour: isTakingOnboardingTour })=>{
    const getVisibility = ()=>{
        if (!cttOnboarding) return false;
        try {
            switch(cttOnboarding.stage){
                case (0, $jDE3A.CttOnboardingStage).CREATE_INITATIVE:
                case (0, $jDE3A.CttOnboardingStage).NAVIGATE_ISSUE_SOURCES:
                case (0, $jDE3A.CttOnboardingStage).SHOW_ISSUE_SOURCES:
                case (0, $jDE3A.CttOnboardingStage).FINISH_FLAG:
                case (0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN:
                case (0, $jDE3A.CttOnboardingStage).EPIC_REPARENT:
                case (0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES:
                    return true;
                case (0, $jDE3A.CttOnboardingStage).INPUT_TITLE:
                case (0, $jDE3A.CttOnboardingStage).INPUT_EPIC_REPARENT:
                case (0, $jDE3A.CttOnboardingStage).CLOSED:
                    return false;
                default:
                    $35bbb93fa80e9762$var$assertUnreachable(cttOnboarding.stage);
                    return false;
            }
        } catch (e) {
            return false;
        }
    };
    return {
        stage: cttOnboarding?.stage,
        planId: cttOnboarding?.planId,
        visible: getVisibility(),
        isTakingOnboardingTour: isTakingOnboardingTour ?? false
    };
};
const $35bbb93fa80e9762$export$27269b971d238c07 = ({ spotlight: spotlight })=>spotlight;

});


parcelRegister("7Jv2m", function(module, exports) {

$parcel$export(module.exports, "Spotlights", () => $010f580bd4fb69cb$export$c7b90ff96148d0e3);
$parcel$export(module.exports, "useCurrentSpotlight", () => $010f580bd4fb69cb$export$26b0bb53036d8513);
$parcel$export(module.exports, "SpotlightStepsUpdater", () => $010f580bd4fb69cb$export$ac825ef8b2141343);
$parcel$export(module.exports, "OnboardingHeaderModeUpdater", () => $010f580bd4fb69cb$export$e9f9953833722cbb);

var $eUqFw = parcelRequire("eUqFw");

var $1OuJn = parcelRequire("1OuJn");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $lcvrv = parcelRequire("lcvrv");
const $010f580bd4fb69cb$export$c7b90ff96148d0e3 = {
    Inactive: 'INACTIVE',
    HeartOfPlan: 'portfolio-3/onboarding/heart-of-plan',
    Scope: 'portfolio-3/onboarding/scope',
    Fields: 'portfolio-3/onboarding/fields',
    Timeline: 'portfolio-3/onboarding/timeline',
    ListMode: 'portfolio-3/onboarding/list-mode',
    Views: 'portfolio-3/onboarding/views',
    ShowAndTell: 'portfolio-3/onboarding/show-and-tell',
    SaveYourChanges: 'portfolio-3/onboarding/save-your-changes',
    FindYourLook: 'portfolio-3/onboarding/find-your-look'
};
const $010f580bd4fb69cb$var$TimelineModeSpotlightSteps = Object.values($010f580bd4fb69cb$export$c7b90ff96148d0e3).filter((k)=>k !== $010f580bd4fb69cb$export$c7b90ff96148d0e3.HeartOfPlan); // Take the order of the enums as it is
const $010f580bd4fb69cb$var$ListModeSpotlightSteps = [
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Inactive,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Scope,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Fields,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.ListMode,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Views,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.ShowAndTell,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.SaveYourChanges,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.FindYourLook
];
const $010f580bd4fb69cb$var$SpotlightSteps = [
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Inactive,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.Views,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.HeartOfPlan,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.ShowAndTell,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.ListMode,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.FindYourLook,
    $010f580bd4fb69cb$export$c7b90ff96148d0e3.SaveYourChanges
];
const $010f580bd4fb69cb$var$store = (0, $a61MH.createStore)({
    // Remove "steps" when cleanup 'sploverview-onboarding-tour'
    initialState: {
        current: 0,
        steps: $010f580bd4fb69cb$var$TimelineModeSpotlightSteps
    },
    actions: {
        reset: ()=>({ setState: setState })=>setState({
                    current: 0
                }),
        start: ()=>({ setState: setState })=>{
                setState({
                    current: 1
                });
            },
        next: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    current: getState().current + 1
                });
            },
        setSteps: (viewMode)=>({ setState: setState, getState: getState })=>{
                if (!(0, $1ybV0.ff)('sploverview-onboarding-tour')) {
                    const { steps: steps } = getState();
                    const newSteps = viewMode === (0, $lcvrv.VIEW_MODES).LIST ? $010f580bd4fb69cb$var$ListModeSpotlightSteps : $010f580bd4fb69cb$var$TimelineModeSpotlightSteps;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1OuJn)))(steps, newSteps)) setState({
                        steps: newSteps
                    });
                }
            }
    },
    name: 'portfolio-3/onboarding/spotlights'
});
const $010f580bd4fb69cb$export$26b0bb53036d8513 = ()=>(0, $ggKAj.createHook)($010f580bd4fb69cb$var$store, {
        selector: ({ current: current, steps: steps })=>{
            const spotlightSteps = (0, $1ybV0.ff)('sploverview-onboarding-tour') ? $010f580bd4fb69cb$var$SpotlightSteps : steps;
            const totalStepCount = spotlightSteps.length - 1; // NOTE: All spotlights enums start with an invisible INACTIVE step (step 0)
            return {
                spotlight: spotlightSteps[current],
                currentStepCount: current,
                totalStepCount: totalStepCount
            };
        }
    })();
const $010f580bd4fb69cb$export$d52beefead77af4c = (0, $ggKAj.createHook)($010f580bd4fb69cb$var$store, {
    selector: null
});
const $010f580bd4fb69cb$export$ac825ef8b2141343 = ({ viewMode: viewMode })=>{
    const [, { setSteps: setSteps }] = $010f580bd4fb69cb$export$d52beefead77af4c();
    (0, $eUqFw.useEffect)(()=>{
        setSteps(viewMode);
    }, [
        viewMode,
        setSteps
    ]);
    return null;
};
const $010f580bd4fb69cb$export$e9f9953833722cbb = ({ headerMode: headerMode, setHeaderMode: setHeaderMode })=>{
    const [{ spotlight: spotlight }] = $010f580bd4fb69cb$export$26b0bb53036d8513();
    (0, $eUqFw.useEffect)(()=>{
        if (headerMode !== 'visible' && spotlight === $010f580bd4fb69cb$export$c7b90ff96148d0e3.HeartOfPlan) setHeaderMode('visible');
    }, [
        spotlight,
        headerMode,
        setHeaderMode
    ]);
    return null;
};

});
parcelRegister("1OuJn", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $15224c7ccc9df08d$var$func = $jFIrw('isEqual', (parcelRequire("hTLlD")));

$15224c7ccc9df08d$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $15224c7ccc9df08d$var$func;

});


parcelRegister("nQeGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $74de79dc18a8908f$export$2e2bcd8739ae039);

var $jwhcr = parcelRequire("jwhcr");
parcelRequire("9zeAN");
var $gG3rI = parcelRequire("gG3rI");

var $1eyFr = parcelRequire("1eyFr");

var $dbuYA = parcelRequire("dbuYA");

var $1G4B0 = parcelRequire("1G4B0");
const $74de79dc18a8908f$var$mapDispatchToProps = (dispatch)=>({
        onRoadmapView: (analyticsEvent)=>{
            dispatch((0, $jwhcr.sendViewRoadmapScreenAnalyticsEvent)(analyticsEvent));
        },
        onDragStart: ()=>{
            dispatch((0, $dbuYA.suspend)());
        },
        onDragEnd: ()=>{
            dispatch((0, $dbuYA.resume)());
        },
        setStickyHeaderScroll: (scrollTop)=>{
            dispatch((0, $gG3rI.setScrollingScrollTop)({
                scrollTop: scrollTop
            }));
        },
        reportTimeToInteractive: (payload)=>dispatch((0, $1eyFr.reportTimeToInteractive)(payload)),
        updateTopLevelColumnWidths: (payload)=>dispatch((0, $1G4B0.updateColumnWidths)(payload))
    });
var $74de79dc18a8908f$export$2e2bcd8739ae039 = $74de79dc18a8908f$var$mapDispatchToProps;

});
parcelRegister("jwhcr", function(module, exports) {

$parcel$export(module.exports, "sendViewRoadmapScreenAnalyticsEvent", () => $f1ffe67151c8cb31$export$226fbff13f644206);
$parcel$export(module.exports, "default", () => $f1ffe67151c8cb31$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");


var $9zeAN = parcelRequire("9zeAN");
const $f1ffe67151c8cb31$export$d07ff7a48940cdf1 = 'command.analytics.SEND_VIEW_ROADMAP_SCREEN';
const $f1ffe67151c8cb31$export$226fbff13f644206 = (payload)=>({
        type: $f1ffe67151c8cb31$export$d07ff7a48940cdf1,
        payload: payload
    });
function* $f1ffe67151c8cb31$export$e3c3228736aa99e3() {
    // The viewRoadmap analytics event needs plan Id and scenario Id to be available in the store.
    // Here we are waiting for plan load to complete before sending the analytics event so all the
    // required data is available in the store.
    const [{ payload: payload }] = yield (0, $9e8i2.all)([
        (0, $9e8i2.take)($f1ffe67151c8cb31$export$d07ff7a48940cdf1),
        (0, $9e8i2.take)((0, $74b2f27518e05c28$export$a60cf13a28cbf30f))
    ]);
    yield (0, $9e8i2.put)((0, $9zeAN.viewRoadmap)(payload));
}
function* $f1ffe67151c8cb31$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($f1ffe67151c8cb31$export$e3c3228736aa99e3);
}

});
const $74b2f27518e05c28$export$bf72183eb20c4d57 = 'command.INITIAL_LOAD';
const $74b2f27518e05c28$export$a60cf13a28cbf30f = 'command.AFTER_INITIAL_LOAD';

parcelRegister("9zeAN", function(module, exports) {

$parcel$export(module.exports, "VIEW_ROADMAP", () => $cf57de55d6e27f82$export$d26ca220cb0a4bd7);
$parcel$export(module.exports, "viewRoadmap", () => $cf57de55d6e27f82$export$115724b6e7221e4d);
$parcel$export(module.exports, "setStickyHeaderScroll", () => (parcelRequire("gG3rI")).setScrollingScrollTop);

var $gG3rI = parcelRequire("gG3rI");
const $cf57de55d6e27f82$export$d26ca220cb0a4bd7 = 'command.roadmap.VIEW_ROADMAP';
const $cf57de55d6e27f82$export$115724b6e7221e4d = (analyticsEvent)=>({
        type: $cf57de55d6e27f82$export$d26ca220cb0a4bd7,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});
parcelRegister("gG3rI", function(module, exports) {

$parcel$export(module.exports, "SET_STICKY_HEADER_SCROLL", () => $0f42e12bb9d7a714$export$de6494ad10940845);
$parcel$export(module.exports, "setScrollingScrollTop", () => $0f42e12bb9d7a714$export$f1596fbaf8604e30);
const $0f42e12bb9d7a714$export$de6494ad10940845 = 'state.ui.main.tabs.roadmap.sticky-header.SET_STICKY_HEADER_SCROLL';
const $0f42e12bb9d7a714$export$f1596fbaf8604e30 = (payload)=>({
        type: $0f42e12bb9d7a714$export$de6494ad10940845,
        payload: payload
    });

});



parcelRegister("1eyFr", function(module, exports) {

$parcel$export(module.exports, "reportTimeToInteractive", () => $c1147178ce79f202$export$7f6790acfc0478b9);
$parcel$export(module.exports, "default", () => $c1147178ce79f202$export$2e2bcd8739ae039);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $dYnI4 = parcelRequire("dYnI4");

var $kwMvv = parcelRequire("kwMvv");

var $40hi6 = parcelRequire("40hi6");
parcelRequire("bJc6r");
var $l9Wts = parcelRequire("l9Wts");

var $l3GKV = parcelRequire("l3GKV");

const $c1147178ce79f202$var$numberOfIssueLinks = (values)=>{
    let count = 0;
    for (const issueId of Object.keys(values))count += Object.keys(values[issueId] ?? {}).length;
    // issue links (within a plan) are counted twice, one per issue they touch.
    // external issue links (that point to issues outside of a plan) will be only worth 0.5 here
    // but this makes sense as they only render as a single badge, vs the usual 2 (or line)
    return Math.floor(count / 2);
};
const $c1147178ce79f202$export$7f6790acfc0478b9 = (payload)=>({
        type: (0, $83e4d52849812b92$export$d1ca64071165c7e5),
        payload: payload
    });
function* $c1147178ce79f202$var$doReportTimeToInteractive({ payload: { isNewSidebarEnabled: isNewSidebarEnabled, isTransposed: isTransposed = false } }) {
    const { domain: { assignees: assignees, crossProjectVersions: crossProjectVersions, customFields: customFields, issues: issues, issueLinks: issueLinks, persons: persons, projects: projects, sprints: sprints, teams: teams, versions: versions, views: views } } = yield (0, $9e8i2.select)((0, $l0L3x.default));
    const visibleIssueCount = yield (0, $9e8i2.select)((0, $40hi6.countVisibleIssues));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const filteredIssueCount = (yield (0, $9e8i2.select)((0, $kwMvv.getFilteredIssuesWithHierarchy))).length;
    const currentAccountId = (0, $l3GKV.getCurrentUserAccountId)();
    // Report TTI if we couldn't get the account id or if the account id is non in exclusion list
    if (!currentAccountId || !(0, $l9Wts.default)().includes(currentAccountId)) {
        (0, $dYnI4.monitor).addContextualAnalyticsData({
            isNewSidebarEnabled: isNewSidebarEnabled,
            isTransposed: isTransposed
        });
        (0, $dYnI4.monitor).finishInitialRender({
            scalingFactors: {
                assignees: assignees.assigneeList.length,
                crossProjectReleases: crossProjectVersions.length,
                customFields: customFields.length,
                issues: issues.length,
                issuesPostFiltering: filteredIssueCount,
                visibleIssues: visibleIssueCount,
                issueLinks: $c1147178ce79f202$var$numberOfIssueLinks(issueLinks.values),
                persons: persons.length,
                projects: projects.length,
                releases: versions.length,
                sprints: sprints.length,
                teams: teams.length,
                views: views.length
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $c1147178ce79f202$var$watchReportTimeToInteractive() {
    yield (0, $bG7pV.takeEvery)((0, $83e4d52849812b92$export$d1ca64071165c7e5), $c1147178ce79f202$var$doReportTimeToInteractive);
}
function* $c1147178ce79f202$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($c1147178ce79f202$var$watchReportTimeToInteractive);
}

});
parcelRegister("l3GKV", function(module, exports) {

$parcel$export(module.exports, "getCurrentUserAccountId", () => $813d2028905c574c$export$4635f55bc9feebdb);

var $6rW04 = parcelRequire("6rW04");
const $813d2028905c574c$export$4635f55bc9feebdb = ()=>(0, $6rW04.default)('ajs-atlassian-account-id');

});

const $83e4d52849812b92$export$d1ca64071165c7e5 = 'command.time-to-interactive.REPORT_TIME_TO_INTERACTIVE';


parcelRegister("dbuYA", function(module, exports) {

$parcel$export(module.exports, "suspend", () => $fb9d6cca33ecbdc9$export$a1428c8f7ba796e8);
$parcel$export(module.exports, "resume", () => $fb9d6cca33ecbdc9$export$fbb4d68fe60c1629);
$parcel$export(module.exports, "default", () => $fb9d6cca33ecbdc9$export$2e2bcd8739ae039);
const $fb9d6cca33ecbdc9$export$ee1b0a20fd84ab63 = 'state.enhancers.suspender.SUSPEND';
const $fb9d6cca33ecbdc9$export$97fb89e237502f12 = 'state.enhancers.suspender.RESUME';
const $fb9d6cca33ecbdc9$export$a1428c8f7ba796e8 = ()=>({
        type: $fb9d6cca33ecbdc9$export$ee1b0a20fd84ab63
    });
const $fb9d6cca33ecbdc9$export$fbb4d68fe60c1629 = ()=>({
        type: $fb9d6cca33ecbdc9$export$97fb89e237502f12
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fb9d6cca33ecbdc9$export$2e2bcd8739ae039 = ()=>{
    let lockCounter = 0;
    let currentListeners = [];
    let nextListeners = currentListeners;
    const ensureCanMutateNextListeners = ()=>{
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subscribe = (listener)=>{
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const entry = nextListeners.find((entry)=>listener === entry[0]);
        if (entry) return entry[1];
        const unsubscribe = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const index = nextListeners.findIndex((entry)=>listener === entry[0]);
            if (index < 0) return;
            ensureCanMutateNextListeners();
            nextListeners.splice(index, 1);
        };
        ensureCanMutateNextListeners();
        nextListeners.push([
            listener,
            unsubscribe
        ]);
        return unsubscribe;
    };
    const notifyListeners = ()=>{
        if (lockCounter > 0) return;
        currentListeners = nextListeners;
        for(let i = 0; i < currentListeners.length; i++)currentListeners[i][0]();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (next)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (...args)=>{
            const store = next(...args);
            const subscribeImmediate = store.subscribe;
            const dispatch = (...dispatchArgs)=>{
                const [action] = dispatchArgs;
                switch(action.type){
                    case $fb9d6cca33ecbdc9$export$97fb89e237502f12:
                        if (lockCounter <= 0) throw new Error(`Unbalanced ${$fb9d6cca33ecbdc9$export$97fb89e237502f12}`);
                        lockCounter--;
                        notifyListeners();
                        return action;
                    case $fb9d6cca33ecbdc9$export$ee1b0a20fd84ab63:
                        lockCounter++;
                        return action;
                    default:
                        {
                            const result = store.dispatch(...dispatchArgs);
                            notifyListeners();
                            return result;
                        }
                }
            };
            return {
                ...store,
                dispatch: dispatch,
                subscribe: subscribe,
                subscribeImmediate: subscribeImmediate
            };
        };
};

});

parcelRegister("1G4B0", function(module, exports) {

$parcel$export(module.exports, "updateColumnWidths", () => $ac29be6345032dee$export$6688b13ec132acdf);

const $ac29be6345032dee$export$6688b13ec132acdf = (payload)=>({
        type: (0, $891dfdd01b02bc5d$export$47640bb49c9df5f2),
        payload: payload
    });

});
const $891dfdd01b02bc5d$export$47640bb49c9df5f2 = 'state.ui.column-widths.UPDATE_COLUMN_WIDTHS';



parcelRegister("2Alm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc4a8bdf8dc088ab$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $akhOi = parcelRequire("akhOi");

var $fZW8G = parcelRequire("fZW8G");

var $e4IaE = parcelRequire("e4IaE");

var $52FI4 = parcelRequire("52FI4");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $1MWal = parcelRequire("1MWal");

var $75KhQ = parcelRequire("75KhQ");

var $4GVCJ = parcelRequire("4GVCJ");

var $evo53 = parcelRequire("evo53");

var $a0bo1 = parcelRequire("a0bo1");

var $aMoMC = parcelRequire("aMoMC");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");
var $bc4a8bdf8dc088ab$export$2e2bcd8739ae039 = (0, $df4Sl.createStructuredSelector)({
    activeCard: (0, $1MWal.getActiveCard),
    activeView: (0, $dBKyg.getActiveView),
    exportModeTimelineWidth: (0, $4GVCJ.getTimelineExportWidth),
    hasWarningInConfiguredDates: $75KhQ.hasWarningInConfiguredDates,
    isConfluenceMacro: $akhOi.isConfluenceMacro,
    isEmbed: $akhOi.isEmbed,
    isExportMode: $akhOi.isExportMode,
    isLoading: (0, $kwMvv.getIsIssuesLoading),
    isOptimizedMode: $akhOi.isOptimizedMode,
    isReportMode: $akhOi.isReportMode,
    issueBeingEdited: (0, $52FI4.getIssueBeingEdited),
    issues: (0, $cwP4d.getIssues),
    scopeHeight: (0, $a0bo1.getScopeHeight),
    stickyHeader: (0, $evo53.getCurrentStickyHeaderGeometry),
    useTwpTeams: (state)=>!!(0, $75KhQ.getPlan)(state).useTwpTeams,
    viewNamespace: (0, $dBKyg.getNamespaceFromActiveView),
    zoomLevel: (0, $aMoMC.getZoomLevel),
    viewMode: (0, $9H2AP.getViewMode),
    issueGoalARIs: (0, $e4IaE.getIssueGoalARIs),
    shouldDisplayTmpCrossProjectChangeboarding: (0, $1MWal.getShouldDisplayTmpCrossProjectChangeboarding),
    hierarchyTitles: (0, $fZW8G.getHierarchyTitles)
});

});
parcelRegister("52FI4", function(module, exports) {

$parcel$export(module.exports, "getIssueBeingEdited", () => $634cc863fcf53f54$export$34428deb778432d3);
$parcel$export(module.exports, "getIsLoadingIssueDescription", () => $634cc863fcf53f54$export$f22b627877ebce48);
const $634cc863fcf53f54$export$34428deb778432d3 = (state)=>state.domain.issueModal.issueBeingEdited;
const $634cc863fcf53f54$export$f22b627877ebce48 = (state)=>state.domain.issueModal.isLoadingIssueDescription;

});

parcelRegister("1MWal", function(module, exports) {

$parcel$export(module.exports, "getActiveCard", () => $607059bb232f433d$export$c090658018e2f5dc);
$parcel$export(module.exports, "isIntroOpen", () => $607059bb232f433d$export$ef17a58d2d00d956);
$parcel$export(module.exports, "getShouldDisplayTmpCrossProjectChangeboarding", () => $607059bb232f433d$export$5b71c6dc28ab6f74);

var $3l6tm = parcelRequire("3l6tm");

var $8YqJS = parcelRequire("8YqJS");

var $iK4oF = parcelRequire("iK4oF");

var $fZW8G = parcelRequire("fZW8G");

var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");
const $607059bb232f433d$export$c090658018e2f5dc = (state)=>state.ui.Onboarding.activeCard;
const $607059bb232f433d$export$ef17a58d2d00d956 = (state)=>state.ui.Onboarding.isIntroOpen;
const $607059bb232f433d$var$getLevelOneIssues = (state)=>(0, $kwMvv.getIssuesByLevel)(state, (0, $8YqJS.EPIC_LEVEL));
const $607059bb232f433d$export$32a8ae48b75926eb = (issueTypesByLevel, levelOneIssues, projects)=>{
    const issueTypesAboveEpic = issueTypesByLevel[(0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE) + 2] ?? [];
    if (issueTypesAboveEpic.length === 0) return false;
    const projectIds = new Set(projects.map((project)=>project.id));
    return levelOneIssues.some((issue)=>projectIds.has(issue.project) && issue.parent === undefined);
};
const $607059bb232f433d$export$5b71c6dc28ab6f74 = (0, $iK4oF.createSelector)((0, $fZW8G.getIssueTypesByLevel), $607059bb232f433d$var$getLevelOneIssues, (0, $ehEr2.getTeamManagedProjects), $607059bb232f433d$export$32a8ae48b75926eb);

});

parcelRegister("4GVCJ", function(module, exports) {

$parcel$export(module.exports, "getScopeWidth", () => $9dde368778557660$export$2399fb6b8ed70468);
$parcel$export(module.exports, "getFieldsWidth", () => $9dde368778557660$export$661aa4dfe4b50072);
$parcel$export(module.exports, "getTimelineExportWidth", () => $9dde368778557660$export$306be9ad4bb930e1);

var $iK4oF = parcelRequire("iK4oF");
const $9dde368778557660$export$a84244a60e1e50a0 = (state)=>state.ui.SectionWidths;
const $9dde368778557660$export$2399fb6b8ed70468 = (0, $iK4oF.createSelector)([
    $9dde368778557660$export$a84244a60e1e50a0
], (sectionWidths)=>sectionWidths.scope);
const $9dde368778557660$export$661aa4dfe4b50072 = (0, $iK4oF.createSelector)([
    $9dde368778557660$export$a84244a60e1e50a0
], (sectionWidths)=>sectionWidths.fields);
const $9dde368778557660$export$87113eddf3515c00 = (0, $iK4oF.createSelector)([
    $9dde368778557660$export$a84244a60e1e50a0
], (sectionWidths)=>sectionWidths.timeline);
const $9dde368778557660$export$306be9ad4bb930e1 = (0, $iK4oF.createSelector)([
    $9dde368778557660$export$a84244a60e1e50a0
], (sectionWidths)=>sectionWidths.timelineExport);

});

parcelRegister("evo53", function(module, exports) {

$parcel$export(module.exports, "getCurrentStickyHeaderGeometry", () => $5ba1537869172481$export$661aa8d94f7f9f38);

var $a0bo1 = parcelRequire("a0bo1");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $5ba1537869172481$export$373bbdfa48957fa = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getTableItems)
], (scope)=>scope.reduce((acc, { tag: tag, height: height = 1 }, index)=>{
        const pixelHeight = height * (0, $5rYNM.SCOPE_ROW_HEIGHT);
        if (tag === (0, $a0bo1.TABLE_GROUP)) acc.headers.push({
            index: index,
            height: pixelHeight,
            offset: acc.offset
        });
        acc.offset += pixelHeight;
        return acc;
    }, {
        headers: [],
        offset: 0
    }).headers);
const $5ba1537869172481$export$661aa8d94f7f9f38 = (0, $iK4oF.createSelector)([
    $5ba1537869172481$export$373bbdfa48957fa,
    (0, $kyGCj.getStickyHeaderScrollTop)
], (headers, scrollTop)=>{
    if (headers.length === 0 || scrollTop === 0) return null;
    for(let i = 1; i < headers.length; i++){
        const currentHeader = headers[i - 1];
        const nextHeader = headers[i];
        if (nextHeader.offset > scrollTop) return nextHeader.offset > scrollTop + currentHeader.height ? currentHeader : null;
    }
    return headers[headers.length - 1];
});

});
parcelRegister("a0bo1", function(module, exports) {

$parcel$export(module.exports, "TABLE_ISSUE", () => $7993b6a83713bd60$export$e028b8352a47c6);
$parcel$export(module.exports, "TABLE_INLINE_CREATE", () => $7993b6a83713bd60$export$749c40244e980b6f);
$parcel$export(module.exports, "TABLE_HEADER", () => $7993b6a83713bd60$export$17dfac22e88883a6);
$parcel$export(module.exports, "TABLE_GROUP", () => $7993b6a83713bd60$export$19b0175d8da45496);
$parcel$export(module.exports, "TABLE_GROUP_HEADER", () => $7993b6a83713bd60$export$1ebe3ab8a09d6fc3);
$parcel$export(module.exports, "TABLE_BLANK_ROW", () => $7993b6a83713bd60$export$f82be50a92182882);
$parcel$export(module.exports, "getTableItems", () => $7993b6a83713bd60$export$4877c3833eef3740);
$parcel$export(module.exports, "getScopeHeight", () => $7993b6a83713bd60$export$b0b02bd9d3cbd02e);
$parcel$export(module.exports, "getScrollToIndex", () => $7993b6a83713bd60$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "getDisableDnD", () => $7993b6a83713bd60$export$d39f95f18e5e5a62);

var $5OdRK = parcelRequire("5OdRK");
var $4G7jA = parcelRequire("4G7jA");
var $h3f0m = parcelRequire("h3f0m");

var $1ybV0 = parcelRequire("1ybV0");

var $akhOi = parcelRequire("akhOi");

var $cwMfk = parcelRequire("cwMfk");

var $40hi6 = parcelRequire("40hi6");
var $dJx9o = parcelRequire("dJx9o");

var $c1XMU = parcelRequire("c1XMU");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $7993b6a83713bd60$export$e028b8352a47c6 = 'app-simple-plans.query.table.ISSUE_TAG';
const $7993b6a83713bd60$export$749c40244e980b6f = 'app-simple-plans.query.table.INLINE_CREATE_TAG';
const $7993b6a83713bd60$export$17dfac22e88883a6 = 'app-simple-plans.query.table.HEADER_TAG';
const $7993b6a83713bd60$export$19b0175d8da45496 = 'app-simple-plans.query.table.GROUP_TAG';
const $7993b6a83713bd60$export$1ebe3ab8a09d6fc3 = 'app-simple-plans.query.table.GROUP_HEADER_TAG';
const $7993b6a83713bd60$export$f82be50a92182882 = 'app-simple-plans.query.table.BLANK_ROW_TAG';
const $7993b6a83713bd60$var$inlineCreateToDummyIssue = (inlineCreate)=>({
        depth: 0,
        id: inlineCreate.id,
        lexoRank: '',
        level: inlineCreate.hierarchyLevel,
        rootIndex: 0,
        summary: '',
        project: inlineCreate.projectId,
        type: inlineCreate.issueTypeId,
        ...inlineCreate.values
    });
const $7993b6a83713bd60$export$f777fb48da152e7a = (inlineCreateState, result, groupCombination = {})=>{
    const { isOpen: isOpen, parentId: parentId, siblingId: siblingId } = inlineCreateState;
    let inlineCreateDummyIssue;
    return (issue)=>{
        if (!(isOpen && (parentId || siblingId))) return;
        const isSibling = (0, $7CnHa.isDefined)(siblingId);
        const isAnchor = issue && (isSibling ? issue.id === siblingId : issue.id === parentId);
        if (issue && isAnchor && !(inlineCreateState.group && issue.group !== inlineCreateState.group) && (!inlineCreateState.groupCombination || $5OdRK.default(groupCombination, inlineCreateState.groupCombination))) {
            // @ts-expect-error - Type '{ tag: "app-simple-plans.query.table.INLINE_CREATE_TAG"; value: { level: number; depth: number; rootIndex: number; color?: string | null | undefined; status?: string | undefined; description?: string | ... 1 more ... | undefined; ... 35 more ...; type: number; }; }' is not assignable to type 'TableItem | null'.
            inlineCreateDummyIssue = {
                tag: $7993b6a83713bd60$export$749c40244e980b6f,
                value: {
                    ...$7993b6a83713bd60$var$inlineCreateToDummyIssue(inlineCreateState),
                    level: issue.id === parentId ? issue.level - 1 : issue.level,
                    depth: issue.id === parentId ? issue.depth + 1 : issue.depth,
                    rootIndex: issue.rootIndex
                }
            };
            return;
        }
        if (inlineCreateDummyIssue && siblingId && // @ts-expect-error - Object is possibly 'undefined'.
        !(issue && issue.level < inlineCreateDummyIssue.value.level)) {
            result.push({
                ...inlineCreateDummyIssue,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
            inlineCreateDummyIssue = null;
        }
        if (inlineCreateDummyIssue && parentId && // @ts-expect-error - Object is possibly 'undefined'.
        !(issue && issue.level <= inlineCreateDummyIssue.value.level)) {
            result.push({
                ...inlineCreateDummyIssue,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
            inlineCreateDummyIssue = null;
        }
    };
};
const $7993b6a83713bd60$export$9873ac8fb1dd1178 = (result, { startLevelIssues: startLevelIssues, issuesWithoutParent: issuesWithoutParent, issuesWithoutParentHeaderData: { id: id, isExpanded: isHeaderExpanded } }, inlineCreateState, groupName, grouping = (0, $5rYNM.GROUPING).NONE, groupUrl, isExpanded, group, sprintStreamsForTeams, groupCombination = {}, parentGroup, isParentGroupExpanded, childGroupsByParentMap)=>{
    if ((0, $7CnHa.isDefined)(group) && (0, $7CnHa.isDefined)(groupName)) {
        let height = 1;
        if (grouping === (0, $5rYNM.GROUPING).TEAM && sprintStreamsForTeams && group) {
            const streams = (0, $7CnHa.isDefined)(groupCombination.team) && sprintStreamsForTeams[groupCombination.team];
            if (streams && streams.length > 0) height = streams.length;
        }
        let topOffset = (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT) * height;
        if (parentGroup) {
            if (!result.find((item)=>item.group === parentGroup)) {
                result.push({
                    tag: $7993b6a83713bd60$export$19b0175d8da45496,
                    value: '',
                    grouping: grouping,
                    url: groupUrl,
                    isExpanded: !!isParentGroupExpanded,
                    group: parentGroup,
                    parentGroup: undefined,
                    height: height,
                    topOffset: topOffset,
                    groupCombination: {
                        [(0, $40hi6.getGroupAttribute)(grouping)]: parentGroup
                    },
                    childGroups: childGroupsByParentMap && childGroupsByParentMap[parentGroup]
                });
                topOffset += (0, $5rYNM.SCOPE_ROW_HEIGHT);
            }
            if (!isParentGroupExpanded) return;
        }
        result.push({
            tag: $7993b6a83713bd60$export$19b0175d8da45496,
            value: groupName,
            grouping: grouping,
            url: groupUrl,
            isExpanded: isExpanded || false,
            group: group,
            height: height,
            topOffset: topOffset,
            groupCombination: groupCombination,
            parentGroup: parentGroup
        });
    }
    const { parentId: parentId, siblingId: siblingId, hierarchyLevel: hierarchyLevel, isOpen: isOpen } = inlineCreateState;
    const issuesWithoutParentCount = issuesWithoutParent.map(({ rootIssuesCount: rootIssuesCount = 0 })=>rootIssuesCount).reduce((a, x)=>a + x, 0);
    if (startLevelIssues.issues.length + issuesWithoutParentCount === 0) {
        if (isOpen && (!(0, $7CnHa.isDefined)(group) || group === inlineCreateState.group)) {
            result.push({
                tag: $7993b6a83713bd60$export$749c40244e980b6f,
                value: $7993b6a83713bd60$var$inlineCreateToDummyIssue(inlineCreateState),
                group: group,
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
            result.push({
                tag: $7993b6a83713bd60$export$f82be50a92182882,
                value: undefined,
                group: group,
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
        }
        return;
    }
    const tryToInsertInlineCreate = $7993b6a83713bd60$export$f777fb48da152e7a(inlineCreateState, result, groupCombination);
    for (const issue of startLevelIssues.issues){
        tryToInsertInlineCreate(issue);
        result.push({
            tag: $7993b6a83713bd60$export$e028b8352a47c6,
            value: issue,
            group: group,
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
        });
    }
    const isTheSameGroup = !inlineCreateState.groupCombination || (0, $dJx9o.getGroupKey)(inlineCreateState.groupCombination) === group;
    if (isOpen && !(parentId || siblingId) && startLevelIssues.level === hierarchyLevel && isTheSameGroup) // Insert at the bottom of the level when creating from the header
    result.push({
        tag: $7993b6a83713bd60$export$749c40244e980b6f,
        value: $7993b6a83713bd60$var$inlineCreateToDummyIssue(inlineCreateState),
        group: group,
        groupCombination: groupCombination,
        parentGroup: parentGroup,
        topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
    });
    tryToInsertInlineCreate();
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.ease-of-use.remove-no-parent-header')) issuesWithoutParent.forEach(({ id: groupId, isExpanded: isGroupExpanded, level: level, issues: issues, rootIssuesCount: rootIssuesCount })=>{
        if (issues.length === 0) return;
        result.push({
            tag: $7993b6a83713bd60$export$1ebe3ab8a09d6fc3,
            group: group,
            value: {
                id: groupId,
                isExpanded: isGroupExpanded,
                level: level,
                rootIssuesCount: rootIssuesCount
            },
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
        });
        if (isGroupExpanded) {
            issues.forEach((issue)=>{
                tryToInsertInlineCreate(issue);
                result.push({
                    tag: $7993b6a83713bd60$export$e028b8352a47c6,
                    value: issue,
                    group: group,
                    groupCombination: groupCombination,
                    parentGroup: parentGroup,
                    topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
                });
            });
            tryToInsertInlineCreate();
        }
        if (isOpen && !(parentId || siblingId) && level === hierarchyLevel && isTheSameGroup) // Insert at the bottom of the level when creating from the header
        result.push({
            tag: $7993b6a83713bd60$export$749c40244e980b6f,
            group: group,
            value: $7993b6a83713bd60$var$inlineCreateToDummyIssue(inlineCreateState),
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
        });
    });
    else if (issuesWithoutParent.length > 0) {
        result.push({
            tag: $7993b6a83713bd60$export$17dfac22e88883a6,
            group: group,
            value: {
                id: id,
                isExpanded: isHeaderExpanded,
                issueCount: issuesWithoutParentCount
            },
            groupCombination: groupCombination,
            parentGroup: parentGroup,
            topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
        });
        if (isHeaderExpanded) // eslint-disable-next-line @typescript-eslint/no-shadow
        for (const { id: id, isExpanded: isExpanded, level: level, issues: issues, rootIssuesCount: rootIssuesCount } of issuesWithoutParent){
            result.push({
                tag: $7993b6a83713bd60$export$1ebe3ab8a09d6fc3,
                group: group,
                value: {
                    id: id,
                    isExpanded: isExpanded,
                    level: level,
                    rootIssuesCount: rootIssuesCount
                },
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
            if (isExpanded) {
                for (const issue of issues){
                    tryToInsertInlineCreate(issue);
                    result.push({
                        tag: $7993b6a83713bd60$export$e028b8352a47c6,
                        value: issue,
                        group: group,
                        groupCombination: groupCombination,
                        parentGroup: parentGroup,
                        topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
                    });
                }
                tryToInsertInlineCreate();
            }
            if (isOpen && !(parentId || siblingId) && level === hierarchyLevel && isTheSameGroup) // Insert at the bottom of the level when creating from the header
            result.push({
                tag: $7993b6a83713bd60$export$749c40244e980b6f,
                group: group,
                value: $7993b6a83713bd60$var$inlineCreateToDummyIssue(inlineCreateState),
                groupCombination: groupCombination,
                parentGroup: parentGroup,
                topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
            });
        }
    }
    result.push({
        tag: $7993b6a83713bd60$export$f82be50a92182882,
        value: undefined,
        group: group,
        groupCombination: groupCombination,
        parentGroup: parentGroup,
        topOffset: (result.length ? result[result.length - 1]?.topOffset || 0 : 0) + (0, $5rYNM.SCOPE_ROW_HEIGHT)
    });
};
const $7993b6a83713bd60$export$b5f7ab67ce89b674 = (scope, inlineCreateState, sprintStreamsForTeams, exportPreview)=>{
    const result = [];
    const { groupCount: groupCount = 0, groups: groups = [] } = scope;
    const childGroupsByParentMap = (0, $7CnHa.groupBy)((group)=>group.parentGroup || 'no_parent_groups', groups);
    if (groupCount === 0) $7993b6a83713bd60$export$9873ac8fb1dd1178(result, scope, inlineCreateState);
    else if (groupCount > 0) groups.forEach((groupedScope)=>{
        const { scope: // eslint-disable-next-line @typescript-eslint/no-shadow
        scope, groupName: groupName, grouping: grouping, groupUrl: groupUrl, isExpanded: isExpanded, group: group, groupCombination: groupCombination, parentGroup: parentGroup, isParentGroupExpanded: isParentGroupExpanded } = groupedScope;
        return $7993b6a83713bd60$export$9873ac8fb1dd1178(result, scope, inlineCreateState, groupName, grouping, groupUrl, isExpanded, group, sprintStreamsForTeams, groupCombination, parentGroup, isParentGroupExpanded, childGroupsByParentMap);
    });
    // In export preview we only return the first 20 issues and their headers
    if (exportPreview) {
        let issuesCounted = 0;
        let indexToSliceAt = (0, $5rYNM.NUM_ISSUES_IN_EXPORT_PREVIEW);
        for(let i = 0; i < result.length; i++)if (result[i].tag === $7993b6a83713bd60$export$e028b8352a47c6) {
            issuesCounted++;
            if (issuesCounted === (0, $5rYNM.NUM_ISSUES_IN_EXPORT_PREVIEW)) {
                indexToSliceAt = i;
                break;
            }
        }
        return result.slice(0, indexToSliceAt + 1);
    }
    return result;
};
const $7993b6a83713bd60$export$4877c3833eef3740 = (0, $iK4oF.createSelector)([
    (0, $40hi6.getScope),
    (0, $cwMfk.getInlineCreateState),
    (0, $c1XMU.getSprintStreamsForTeams),
    (0, $akhOi.isExportPreview)
], $7993b6a83713bd60$export$b5f7ab67ce89b674);
const $7993b6a83713bd60$export$b0b02bd9d3cbd02e = (0, $iK4oF.createSelector)([
    $7993b6a83713bd60$export$4877c3833eef3740
], (tableItems)=>tableItems.reduce((scopeHeight, { height: height = 1 })=>scopeHeight + height * (0, $5rYNM.SCOPE_ROW_HEIGHT), 0));
const $7993b6a83713bd60$export$1605e4b97a9dcce2 = (items, { isOpen: isOpen }, activeSearchIssue)=>{
    if (isOpen) return $4G7jA.default($h3f0m.default('tag', $7993b6a83713bd60$export$749c40244e980b6f))(items);
    if (activeSearchIssue) {
        const index = $4G7jA.default(({ value: value, group: group = '' })=>{
            if ($h3f0m.default('tag', $7993b6a83713bd60$export$e028b8352a47c6) && typeof value === 'object') return value.id === activeSearchIssue.id && group === activeSearchIssue.group;
            return false;
        })(items);
        return index > -1 ? index : undefined;
    }
};
const $7993b6a83713bd60$export$56068eb4c4e3a63c = (0, $iK4oF.createSelector)([
    $7993b6a83713bd60$export$4877c3833eef3740,
    (0, $cwMfk.getInlineCreateState),
    (0, $40hi6.getActiveSearchIssue)
], $7993b6a83713bd60$export$1605e4b97a9dcce2);
const $7993b6a83713bd60$export$d39f95f18e5e5a62 = (0, $iK4oF.createSelector)([
    (0, $cwMfk.getInlineCreateState)
], ({ isOpen: isOpen })=>isOpen);

});
parcelRegister("4G7jA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3680c24657efbaf2$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $6DiNv = parcelRequire("6DiNv");
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $3680c24657efbaf2$var$findIndex = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([], (0, $6DiNv.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $3680c24657efbaf2$export$2e2bcd8739ae039 = $3680c24657efbaf2$var$findIndex;

});
parcelRegister("6DiNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d44f761280dcbc2$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $4d44f761280dcbc2$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XFindIndex.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, -1);
        return this.xf['@@transducer/result'](result);
    };
    XFindIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $5zr36.default)(this.xf['@@transducer/step'](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $4d44f761280dcbc2$var$_xfindIndex = /*#__PURE__*/ (0, $ggdJA.default)(function _xfindIndex(f, xf) {
    return new $4d44f761280dcbc2$var$XFindIndex(f, xf);
});
var $4d44f761280dcbc2$export$2e2bcd8739ae039 = $4d44f761280dcbc2$var$_xfindIndex;

});


parcelRegister("c1XMU", function(module, exports) {

$parcel$export(module.exports, "getSprints", () => $6dbef4272356712d$export$1b132ed8629e9cb0);
$parcel$export(module.exports, "getExternalSprints", () => $6dbef4272356712d$export$a116ea7be7faa950);
$parcel$export(module.exports, "getOriginalPlannedCapacities", () => $6dbef4272356712d$export$14005bd74601c99d);
$parcel$export(module.exports, "getCapacityForTeamAndIteration", () => $6dbef4272356712d$export$de8654fbc16cb65c);
$parcel$export(module.exports, "getOriginalCapacityForTeamAndIteration", () => $6dbef4272356712d$export$d2861cf68b3b2255);
$parcel$export(module.exports, "getAllSprints", () => $6dbef4272356712d$export$60a2c24a37c53cfb);
$parcel$export(module.exports, "getAllSprintsById", () => $6dbef4272356712d$export$9c229a6c0d778e9d);
$parcel$export(module.exports, "getSprintsForTeam", () => $6dbef4272356712d$export$136e69b79f9b3bc6);
$parcel$export(module.exports, "getSprintByIdMap", () => $6dbef4272356712d$export$d7ad569e206d3043);
$parcel$export(module.exports, "getAllSprintsByIdMap", () => $6dbef4272356712d$export$664e5a6e15bdf42d);
$parcel$export(module.exports, "getAllSprintsIncludingDisabledByIdMap", () => $6dbef4272356712d$export$bea5ded2bfc86d51);
$parcel$export(module.exports, "getExternalSprintsById", () => $6dbef4272356712d$export$254f1dd35d84707c);
$parcel$export(module.exports, "getExternalSprintsIds", () => $6dbef4272356712d$export$da62f646ce4fc45b);
$parcel$export(module.exports, "getSprintsIdsByState", () => $6dbef4272356712d$export$8b47d16a8f839acb);
$parcel$export(module.exports, "getUniqueFilterSprints", () => $6dbef4272356712d$export$5e2f833fb9b859c6);
$parcel$export(module.exports, "getSprintsForIssueSources", () => $6dbef4272356712d$export$28ef6e3452a3bed3);
$parcel$export(module.exports, "getSprintsAndTeamsByIssueSources", () => $6dbef4272356712d$export$a3925a094e8f739c);
$parcel$export(module.exports, "getSprintStatesCategories", () => $6dbef4272356712d$export$14fe519a54423fb3);
$parcel$export(module.exports, "getIssuesBySprint", () => $6dbef4272356712d$export$77c13d5fe7506b9c);
$parcel$export(module.exports, "getSprintStreamsForTeams", () => $6dbef4272356712d$export$9e42c5283bf29884);
$parcel$export(module.exports, "getSprintStreamsUnitsForTeams", () => $6dbef4272356712d$export$89652c3da48f620d);
$parcel$export(module.exports, "getSprintStreamsUnitsGetter", () => $6dbef4272356712d$export$bfc3ff48117f3949);
$parcel$export(module.exports, "getSprintsWithFutureDates", () => $6dbef4272356712d$export$890993119fd2e3d2);
$parcel$export(module.exports, "getSprintIdsWithDatesIsInconsistent", () => $6dbef4272356712d$export$17db666a912c2fcd);
$parcel$export(module.exports, "getSprintsCapacityOnTimeline", () => $6dbef4272356712d$export$17eff8862a1d335b);
$parcel$export(module.exports, "getPlannedCapacityChanges", () => $6dbef4272356712d$export$846232223ccbf4ee);
$parcel$export(module.exports, "getSprintChanges", () => $6dbef4272356712d$export$137af5bfd2a1d324);
$parcel$export(module.exports, "getSprintChangeCount", () => $6dbef4272356712d$export$77d969bb56813bf0);
$parcel$export(module.exports, "getSprintById", () => (parcelRequire("a4NMN")).getSprintById);
$parcel$export(module.exports, "getTargetDatesFromSprints", () => (parcelRequire("a4NMN")).getTargetDatesFromSprints);
$parcel$export(module.exports, "convertCapacityByPlanningUnit", () => (parcelRequire("a4NMN")).convertCapacityByPlanningUnit);
$parcel$export(module.exports, "formatSprintUTCTime", () => (parcelRequire("a4NMN")).formatSprintUTCTime);
$parcel$export(module.exports, "formatDateRange", () => (parcelRequire("a4NMN")).formatDateRange);
$parcel$export(module.exports, "getLozengeContent", () => (parcelRequire("a4NMN")).getLozengeContent);
$parcel$export(module.exports, "getLozengeAppearance", () => (parcelRequire("a4NMN")).getLozengeAppearance);
$parcel$export(module.exports, "getSprintStatesCategoriesPure", () => (parcelRequire("a4NMN")).getSprintStatesCategoriesPure);

var $cQGVO = parcelRequire("cQGVO");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $bWZKK = parcelRequire("bWZKK");

var $akhOi = parcelRequire("akhOi");

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("7hbkF");

var $kFf60 = parcelRequire("kFf60");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $czhUP = parcelRequire("czhUP");

var $75KhQ = parcelRequire("75KhQ");

var $2iYEz = parcelRequire("2iYEz");

var $40hi6 = parcelRequire("40hi6");

var $kCccV = parcelRequire("kCccV");

var $MQRDu = parcelRequire("MQRDu");

var $aMoMC = parcelRequire("aMoMC");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $a4NMN = parcelRequire("a4NMN");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6dbef4272356712d$var$extractFromProps = (key)=>(_, props)=>props && props[key];
const $6dbef4272356712d$export$1b132ed8629e9cb0 = (state)=>state.domain.sprints;
const $6dbef4272356712d$export$a116ea7be7faa950 = (state)=>state.domain.externalSprints;
const $6dbef4272356712d$export$7672b228993575c9 = (state)=>state.domain.disabledSprints;
const $6dbef4272356712d$export$dfef5308140d2a3b = (state)=>state.domain.plannedCapacities;
const $6dbef4272356712d$export$14005bd74601c99d = (state)=>state.domain.originalPlannedCapacities;
const $6dbef4272356712d$export$157720fb6cc88d59 = (state)=>$kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData',
        'plannedcapacity'
    ], state);
const $6dbef4272356712d$export$de8654fbc16cb65c = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$dfef5308140d2a3b,
    $6dbef4272356712d$var$extractFromProps('teamId'),
    $6dbef4272356712d$var$extractFromProps('iterationId')
], (plannedCapacities, teamId, iterationId)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $kjklK.default([
        teamId,
        iterationId
    ], plannedCapacities));
const $6dbef4272356712d$export$d2861cf68b3b2255 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$14005bd74601c99d,
    $6dbef4272356712d$var$extractFromProps('teamId'),
    $6dbef4272356712d$var$extractFromProps('iterationId')
], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(plannedCapacities, teamId, iterationId)=>$kjklK.default([
        teamId,
        iterationId
    ], plannedCapacities));
const $6dbef4272356712d$export$60a2c24a37c53cfb = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$1b132ed8629e9cb0,
    $6dbef4272356712d$export$a116ea7be7faa950
], (sprints, externalSprints)=>[
        ...sprints,
        ...externalSprints
    ]);
const $6dbef4272356712d$export$9c229a6c0d778e9d = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$60a2c24a37c53cfb
], (sprints)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), sprints));
const $6dbef4272356712d$export$ebc671a197c89121 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$1b132ed8629e9cb0,
    $6dbef4272356712d$export$a116ea7be7faa950,
    $6dbef4272356712d$export$7672b228993575c9
], (sprints, externalSprints, disabledSprints)=>[
        ...sprints,
        ...externalSprints,
        ...disabledSprints
    ]);
const $6dbef4272356712d$export$136e69b79f9b3bc6 = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams),
    (0, $75KhQ.getIssueSources),
    $6dbef4272356712d$export$1b132ed8629e9cb0
], (0, $a4NMN.getSprintsForTeamPure));
const $6dbef4272356712d$export$d7ad569e206d3043 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$1b132ed8629e9cb0
], (0, $a4NMN.getSprintByIdMapPure));
const $6dbef4272356712d$export$664e5a6e15bdf42d = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$60a2c24a37c53cfb
], (0, $a4NMN.getSprintByIdMapPure));
const $6dbef4272356712d$export$bea5ded2bfc86d51 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$ebc671a197c89121
], (0, $a4NMN.getSprintByIdMapPure));
const $6dbef4272356712d$export$254f1dd35d84707c = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$a116ea7be7faa950
], (externalSprints)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), externalSprints));
const $6dbef4272356712d$export$8eae0da3bf0aa5d4 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$7672b228993575c9
], (disabledSprints)=>(0, $7CnHa.indexBy)($f7Op5.default('id'), disabledSprints));
const $6dbef4272356712d$export$da62f646ce4fc45b = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$a116ea7be7faa950
], (externalSprints)=>$cQGVO.default($f7Op5.default('id'), externalSprints));
const $6dbef4272356712d$export$8b47d16a8f839acb = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$1b132ed8629e9cb0
], (sprints)=>$bWZKK.default((acc, sprint)=>acc.concat(sprint.id), [], ({ state: state })=>state, sprints));
const $6dbef4272356712d$export$5e2f833fb9b859c6 = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], (filters)=>{
    const { [(0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)]: { value: value } } = filters;
    return new Set(value);
});
const $6dbef4272356712d$export$28ef6e3452a3bed3 = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getIssueSourcesById),
    $6dbef4272356712d$export$d7ad569e206d3043,
    $6dbef4272356712d$export$8eae0da3bf0aa5d4
], (0, $a4NMN.getSprintsForIssueSourcesPure));
const $6dbef4272356712d$export$a3925a094e8f739c = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getIssueSourcesById),
    $6dbef4272356712d$export$d7ad569e206d3043,
    (0, $MQRDu.getAllExistingTeams),
    $6dbef4272356712d$export$8eae0da3bf0aa5d4
], (0, $a4NMN.getSprintsAndTeamsByIssueSourcesPure));
const $6dbef4272356712d$export$14fe519a54423fb3 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$8b47d16a8f839acb,
    $6dbef4272356712d$export$da62f646ce4fc45b,
    $6dbef4272356712d$export$5e2f833fb9b859c6
], (0, $a4NMN.getSprintStatesCategoriesPure));
const $6dbef4272356712d$export$61afca10f5ef5a98 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    (0, $akhOi.getMode)
], (0, $a4NMN.getIssuesByKanbanIterationPure));
const $6dbef4272356712d$export$77c13d5fe7506b9c = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssues),
    (0, $akhOi.getMode),
    (0, $kCccV.getSolution)
], (issues, mode, solution)=>mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771) ? (0, $a4NMN.getIssuesBySprintOptimizedPure)(issues, solution) : (0, $a4NMN.getIssuesBySprintPure)(issues));
const $6dbef4272356712d$export$ab360203c3db252b = (0, $iK4oF.createStructuredSelector)({
    defaultIterationLength: (0, $2iYEz.getDefaultIterationLength),
    defaultTeamVelocity: (0, $2iYEz.getDefaultTeamVelocity),
    issueStatusById: (0, $kFf60.getIssueStatusById),
    issuesByKanbanIteration: $6dbef4272356712d$export$61afca10f5ef5a98,
    issuesBySprint: $6dbef4272356712d$export$77c13d5fe7506b9c,
    mode: (0, $akhOi.getMode),
    planningUnit: (0, $75KhQ.getPlanningUnit),
    sprintsForTeam: $6dbef4272356712d$export$136e69b79f9b3bc6,
    timelineRange: (0, $aMoMC.getScrollableTimelineRange),
    weeklyCapacityByTeam: (0, $MQRDu.getWeeklyCapacityByTeam),
    issueSources: (0, $75KhQ.getIssueSources),
    issues: (0, $cwP4d.getIssues),
    issueTypeById: (0, $lihml.getIssueTypesById),
    issueLexoRankAdjustments: (0, $czhUP.getIssueLexoRankAdjustments),
    issuesByTeam: (0, $40hi6.getIssuesByTeam),
    plannedCapacities: $6dbef4272356712d$export$dfef5308140d2a3b,
    zoomLevel: (0, $aMoMC.getZoomLevel)
});
const $6dbef4272356712d$export$9e42c5283bf29884 = (0, $iK4oF.createSelector)([
    (0, $kyGCj.getSprintsAreShown),
    (0, $MQRDu.getExistingTeams),
    $6dbef4272356712d$export$ab360203c3db252b
], (0, $a4NMN.getSprintStreamsForTeamsPure));
const $6dbef4272356712d$export$89652c3da48f620d = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$9e42c5283bf29884,
    (0, $aMoMC.getScrollableTimelineRange)
], (0, $a4NMN.getSprintStreamsUnitsForTeamsPure));
const $6dbef4272356712d$export$ecc04e4ef8bc8d33 = (0, $iK4oF.createSelector)([
    (0, $kyGCj.getSprintsAreShown),
    (0, $MQRDu.getExistingTeams),
    $6dbef4272356712d$export$ab360203c3db252b
], (0, $a4NMN.getSprintsStreamsGetterPure));
const $6dbef4272356712d$export$bfc3ff48117f3949 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$ecc04e4ef8bc8d33,
    (0, $aMoMC.getZoomLevel)
], (0, $a4NMN.getSprintStreamsUnitsGetterPure));
const $6dbef4272356712d$export$890993119fd2e3d2 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$136e69b79f9b3bc6,
    (0, $MQRDu.getTeams),
    (0, $75KhQ.getIssueSources),
    $6dbef4272356712d$export$1b132ed8629e9cb0,
    (0, $2iYEz.getDefaultIterationLength)
], (0, $a4NMN.getSprintsWithFutureDatesPure));
const $6dbef4272356712d$export$17db666a912c2fcd = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$89652c3da48f620d
], (0, $a4NMN.getSprintIdsWithDatesIsInconsistentPure));
const $6dbef4272356712d$export$17eff8862a1d335b = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getExistingTeams),
    $6dbef4272356712d$export$ab360203c3db252b
], (0, $a4NMN.getSprintsCapacityOnTimelinePure));
const $6dbef4272356712d$export$846232223ccbf4ee = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$dfef5308140d2a3b,
    $6dbef4272356712d$export$14005bd74601c99d,
    $6dbef4272356712d$export$890993119fd2e3d2,
    (0, $75KhQ.getPlanningUnit),
    (0, $2iYEz.getDefaultTeamVelocity),
    (0, $MQRDu.getWeeklyCapacityByTeam),
    (0, $MQRDu.getTeamsById),
    $6dbef4272356712d$export$157720fb6cc88d59
], (0, $a4NMN.getPlannedCapacityChangesPure));
const $6dbef4272356712d$export$137af5bfd2a1d324 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$846232223ccbf4ee,
    $6dbef4272356712d$export$890993119fd2e3d2
], (0, $a4NMN.getSprintChangesPure));
const $6dbef4272356712d$export$77d969bb56813bf0 = (0, $iK4oF.createSelector)([
    $6dbef4272356712d$export$137af5bfd2a1d324
], (changes)=>changes.length);

});
parcelRegister("aMoMC", function(module, exports) {

$parcel$export(module.exports, "getZoomLevel", () => $57b2199131d211e4$export$deb0f277a5f91a79);
$parcel$export(module.exports, "getOnlyEnabledIssueId", () => $57b2199131d211e4$export$b2e09724b4c97912);
$parcel$export(module.exports, "getTimelineContainerWidth", () => $57b2199131d211e4$export$b1656acc76a5947a);
$parcel$export(module.exports, "getTodayDate", () => $57b2199131d211e4$export$1118e4272ea1e258);
$parcel$export(module.exports, "get3mthTimeScale", () => $57b2199131d211e4$export$191c1aeefec6bc61);
$parcel$export(module.exports, "getTimelineRange", () => $57b2199131d211e4$export$6ab0dc7299631a53);
$parcel$export(module.exports, "getScrollableTimelineRange", () => $57b2199131d211e4$export$8b224e5b226711ba);
$parcel$export(module.exports, "getQuarterLabel", () => $57b2199131d211e4$export$5fd62420000921f7);
$parcel$export(module.exports, "getDayUnits", () => $57b2199131d211e4$export$bc6ab2cf11089d43);
$parcel$export(module.exports, "getMonthUnits", () => $57b2199131d211e4$export$3611c2007b9f6598);
$parcel$export(module.exports, "getQuarterUnits", () => $57b2199131d211e4$export$f2b0db57c6dfcb37);
$parcel$export(module.exports, "getYearUnits", () => $57b2199131d211e4$export$a3c3cfbcf0c80ed4);
$parcel$export(module.exports, "getTimelineUnits", () => $57b2199131d211e4$export$4762a276da75583a);

var $3KReq = parcelRequire("3KReq");

var $5oPVJ = parcelRequire("5oPVJ");
parcelRequire("17L5s");
var $5STnX = parcelRequire("5STnX");
var $17L5s = parcelRequire("17L5s");
var $5YjhU = parcelRequire("5YjhU");
var $eTbtL = parcelRequire("eTbtL");
var $EN9B6 = parcelRequire("EN9B6");
var $l2Sj2 = parcelRequire("l2Sj2");

var $kUlCF = parcelRequire("kUlCF");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $jqeWm = parcelRequire("jqeWm");
const $57b2199131d211e4$export$deb0f277a5f91a79 = (state)=>{
    const { mode: mode } = (0, $9H2AP.getTimeScaleViewSettings)(state);
    return (0, $kUlCF.getZoomLevel)(mode);
};
const $57b2199131d211e4$export$b2e09724b4c97912 = (state)=>state.ui.Main.Tabs.Roadmap.Timeline.Schedule.onlyEnabledIssueId;
const $57b2199131d211e4$export$b1656acc76a5947a = (state, viewportWidth)=>{
    if (viewportWidth == null) return viewportWidth;
    const { mode: mode } = (0, $9H2AP.getTimeScaleViewSettings)(state);
    switch(mode){
        case (0, $5rYNM.ZOOM_LEVELS).WEEKS:
        case (0, $5rYNM.ZOOM_LEVELS).MONTHS:
        case (0, $5rYNM.ZOOM_LEVELS).QUARTERS:
        case (0, $5rYNM.ZOOM_LEVELS).YEARS:
            return (0, $kUlCF.getContainerWidth)(mode);
        default:
            return viewportWidth;
    }
};
const $57b2199131d211e4$export$1118e4272ea1e258 = ()=>{
    const todayDate = new Date();
    return todayDate;
};
const $57b2199131d211e4$export$710a62793fa7376f = (date)=>date.toISOString().substr(0, 10);
const $57b2199131d211e4$export$191c1aeefec6bc61 = (today)=>{
    const in3Months = (0, $5STnX.default)(today, 3);
    const start = (0, $17L5s.startOfUtcDay)($57b2199131d211e4$export$710a62793fa7376f(today));
    const end = (0, $17L5s.endOfUtcDay)($57b2199131d211e4$export$710a62793fa7376f(in3Months));
    return {
        start: start,
        end: end
    };
};
const $57b2199131d211e4$var$getCustomFixedDates = ({ fromDate: fromDate, toDate: toDate })=>{
    const getFormattedDate = (date)=>{
        if (!$5oPVJ.default(Number, date)) // if date is already a number, we keep it as is as the startOfUtcDay also accepts timestamp
        return (0, $EN9B6.default)(typeof date === 'string' ? (0, $5YjhU.default)(date, 'yyyy/MM/dd', new Date()) : date, 'yyyy-MM-dd');
        return date;
    };
    return {
        start: (0, $17L5s.startOfUtcDay)(getFormattedDate(fromDate ?? '')),
        end: (0, $17L5s.endOfUtcDay)(getFormattedDate(toDate ?? ''))
    };
};
const $57b2199131d211e4$export$1f976157d092b952 = (timeScale, today)=>{
    const { mode: mode } = timeScale;
    let start;
    let end;
    switch(mode){
        case (0, $5rYNM.ZOOM_LEVELS).WEEKS:
        case (0, $5rYNM.ZOOM_LEVELS).MONTHS:
        case (0, $5rYNM.ZOOM_LEVELS).QUARTERS:
        case (0, $5rYNM.ZOOM_LEVELS).YEARS:
            start = (0, $17L5s.startOfUtcDay)($57b2199131d211e4$export$710a62793fa7376f(today));
            end = start + (0, $kUlCF.getContainerDuration)(mode);
            return {
                start: start,
                end: end
            };
        case (0, $5rYNM.TIMELINE_MODES).CUSTOM:
            {
                const { customDateRange: customDateRange } = timeScale;
                if (customDateRange) {
                    // In theory, it should only be possible to set a custom date range with some
                    // actual dates, but we are defensively coding to ensure that we don't try to
                    // calculate a custom date range using empty strings
                    const { fromDate: fromDate = '', toDate: toDate = '', toNowUnitCount: toNowUnitCount, fromNowUnitCount: fromNowUnitCount, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit, typeOfCustomDateRange: typeOfCustomDateRange = (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED } = customDateRange;
                    if (typeOfCustomDateRange === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED && fromDate !== '' && toDate !== '') {
                        const timescale = $57b2199131d211e4$var$getCustomFixedDates(customDateRange);
                        start = timescale.start;
                        end = timescale.end;
                    } else if (typeOfCustomDateRange === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).RELATIVE && (0, $7CnHa.isDefined)(toNowUnitCount) && (0, $7CnHa.isDefined)(fromNowUnitCount) && toNowUnit && fromNowUnit) {
                        const timescale = (0, $17L5s.getRelativeDates)(customDateRange, today);
                        start = timescale.start;
                        end = timescale.end;
                    } else {
                        const timescale = $57b2199131d211e4$export$191c1aeefec6bc61(today);
                        start = timescale.start;
                        end = timescale.end;
                    }
                // customDateRange should always be defined when the user selected a range, but just in case it's undefined we set the timeline to 3 months
                } else {
                    const timescale = $57b2199131d211e4$export$191c1aeefec6bc61(today);
                    start = timescale.start;
                    end = timescale.end;
                }
                break;
            }
        // default is set to "months" in "app-simple-plans/state/domain/view-settings/time-scale/reducer.js"
        default:
            start = (0, $17L5s.startOfUtcDay)($57b2199131d211e4$export$710a62793fa7376f(today));
            end = start + (0, $kUlCF.getContainerDuration)((0, $5rYNM.ZOOM_LEVELS).MONTHS);
            return {
                start: start,
                end: end
            };
    }
    if (!(0, $7CnHa.isDefined)(start) || !(0, $7CnHa.isDefined)(end)) throw new Error('Both start and end must be calculated');
    return {
        start: start,
        end: end
    };
};
const $57b2199131d211e4$export$6ab0dc7299631a53 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getTimeScaleViewSettings),
    $57b2199131d211e4$export$1118e4272ea1e258
], $57b2199131d211e4$export$1f976157d092b952);
const $57b2199131d211e4$export$d5e1b6167e68d71a = (zoomLevel, containerTimelineRange)=>{
    if (zoomLevel === undefined) return containerTimelineRange;
    return {
        start: -Infinity,
        end: Infinity
    };
};
const $57b2199131d211e4$export$8b224e5b226711ba = (0, $iK4oF.createSelector)([
    $57b2199131d211e4$export$deb0f277a5f91a79,
    $57b2199131d211e4$export$6ab0dc7299631a53
], $57b2199131d211e4$export$d5e1b6167e68d71a);
const $57b2199131d211e4$export$322ac48b0e5b3019 = (month)=>Math.floor(month / 3);
const $57b2199131d211e4$export$5fd62420000921f7 = (month, fiscalMonth = 1)=>`${(0, $jqeWm.calculateQuarter)(month + 1, fiscalMonth)}`;
const $57b2199131d211e4$export$ba186f0a8a0dd8dd = (value)=>{
    const date = new Date(value);
    const day = (0, $l2Sj2.getDayLabel)(date.getUTCDay());
    const month = (0, $l2Sj2.getMonthLabel)(date.getUTCMonth());
    const dayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(`${date.getUTCDate()}`, 2, '0');
    return `${day} ${dayOfMonth}/${month}`;
};
const $57b2199131d211e4$export$bc6ab2cf11089d43 = (startTime, totalDays)=>{
    const days = [];
    let start = startTime;
    for(let day = 0; day < Math.round(totalDays); day++){
        days.push({
            startTime: start,
            widthPercentage: 100 / totalDays
        });
        start += (0, $17L5s.ONE_DAY);
    }
    return days;
};
const $57b2199131d211e4$export$b5aaf8277821bbfa = (startTime, totalDays)=>{
    const daysInUnits = [];
    const widthPercentage = 100 / totalDays;
    let days = [];
    let date = new Date(startTime);
    let currStartTime = startTime;
    let startMonth = date.getUTCMonth();
    for(let day = 0; day < Math.round(totalDays); day++){
        date = new Date(currStartTime);
        if (date.getUTCMonth() !== startMonth) {
            daysInUnits.push(days);
            days = [];
            startMonth = date.getUTCMonth();
        }
        days.push({
            startTime: currStartTime,
            widthPercentage: widthPercentage
        });
        currStartTime += (0, $17L5s.ONE_DAY);
    }
    daysInUnits.push(days);
    return daysInUnits;
};
const $57b2199131d211e4$export$d383a29b14c36a14 = (value)=>{
    const date = new Date(value);
    const month = (0, $l2Sj2.getMonthLabel)(date.getUTCMonth());
    const dayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($3KReq)))(date.getUTCDate().toString(), 2, '0');
    return `${dayOfMonth}/${month}`;
};
const $57b2199131d211e4$export$7a054ec37aaa58a2 = (value)=>(0, $l2Sj2.getMonthLabel)(new Date(value).getUTCMonth());
const $57b2199131d211e4$export$a15b3dee161ca4e2 = (value)=>{
    const date = new Date(value);
    const month = (0, $l2Sj2.getMonthLabel)(date.getUTCMonth());
    const quarter = $57b2199131d211e4$export$5fd62420000921f7(date.getUTCMonth());
    const year = date.getUTCFullYear().toString().substr(2);
    return `${month} Q${quarter}/${year}`;
};
const $57b2199131d211e4$export$e04713337367b621 = (value)=>new Date(value).getUTCFullYear().toString();
const $57b2199131d211e4$export$94a11c5658544737 = (startTime, endTime, startOfUnit, endOfUnit)=>{
    const units = [];
    const timelineLength = endTime - startTime;
    const calcWidthPercentage = (start, end, rangeLength)=>{
        const unitLength = end - start;
        return unitLength / rangeLength * 100;
    };
    let lastTime = startTime;
    let leftOffset = 0;
    while(endTime > lastTime){
        const unitStartDate = startOfUnit(lastTime);
        const unitEndDate = endOfUnit(lastTime);
        const unitStartTime = unitStartDate.getTime();
        const unitEndTime = unitEndDate.getTime();
        let widthPercentage = 0;
        let unitTime;
        if (startTime > unitStartTime) {
            // Handle partial (should only be for first displayed unit)
            widthPercentage = calcWidthPercentage(startTime, unitEndTime, timelineLength);
            unitTime = startTime;
        } else if (endTime < unitEndTime) {
            // Handle partial (should only be for last displayed unit)
            widthPercentage = calcWidthPercentage(unitStartTime, endTime, timelineLength);
            unitTime = unitStartTime;
        } else {
            // Handle full unit
            widthPercentage = calcWidthPercentage(unitStartTime, unitEndTime, timelineLength);
            unitTime = unitStartTime;
        }
        units.push({
            startTime: unitTime,
            widthPercentage: widthPercentage,
            leftOffset: leftOffset
        });
        // Since we know that the current unit end time is a single millisecond before the start time of the
        // next unit we can simply add 1 (millisecond) to figure out the time for the start of the next unit
        lastTime = unitEndTime + 1;
        // increment leftOffset of the next unit by the current width
        leftOffset += widthPercentage;
    }
    return units;
};
const $57b2199131d211e4$export$167945d407df178d = (startDate, endDate)=>$57b2199131d211e4$export$94a11c5658544737(startDate, endDate, (0, $17L5s.startOfUtcWeek), (0, $17L5s.endOfUtcWeek));
const $57b2199131d211e4$export$3611c2007b9f6598 = (startDate, endDate)=>$57b2199131d211e4$export$94a11c5658544737(startDate, endDate, (0, $17L5s.startOfUtcMonth), (0, $17L5s.endOfUtcMonth));
const $57b2199131d211e4$export$f2b0db57c6dfcb37 = (startDate, endDate, fiscalMonth = 1)=>$57b2199131d211e4$export$94a11c5658544737(startDate, endDate, (0, $17L5s.buildStartOfUtcQuarter)(fiscalMonth), (0, $17L5s.buildEndOfUtcQuarter)(fiscalMonth));
const $57b2199131d211e4$export$a3c3cfbcf0c80ed4 = (startDate, endDate, fiscalMonth = 1)=>$57b2199131d211e4$export$94a11c5658544737(startDate, endDate, (0, $17L5s.buildStartOfUtcYear)(fiscalMonth), (0, $17L5s.buildEndOfUtcYear)(fiscalMonth));
const $57b2199131d211e4$export$10239d34ccbe7258 = (timelineRange)=>{
    const { start: start, end: end } = timelineRange;
    const daysInRange = (end - start) / (0, $17L5s.ONE_DAY);
    if (daysInRange <= 14) return $57b2199131d211e4$export$bc6ab2cf11089d43(start, daysInRange);
    if (daysInRange <= 93) return $57b2199131d211e4$export$167945d407df178d(start, end);
    if (daysInRange <= 364) return $57b2199131d211e4$export$3611c2007b9f6598(start, end);
    if (daysInRange <= 1825) return $57b2199131d211e4$export$f2b0db57c6dfcb37(start, end);
    return $57b2199131d211e4$export$a3c3cfbcf0c80ed4(start, end);
};
const $57b2199131d211e4$export$4762a276da75583a = (0, $iK4oF.createSelector)([
    $57b2199131d211e4$export$6ab0dc7299631a53
], $57b2199131d211e4$export$10239d34ccbe7258);

});
parcelRegister("kUlCF", function(module, exports) {

$parcel$export(module.exports, "getContainerWidth", () => $9f034544244a6e66$export$4bc9150518443cd1);
$parcel$export(module.exports, "getContainerDuration", () => $9f034544244a6e66$export$fe35704a86ff59e5);
$parcel$export(module.exports, "getZoomLevel", () => $9f034544244a6e66$export$deb0f277a5f91a79);

var $8tMGO = parcelRequire("8tMGO");
function $9f034544244a6e66$export$4bc9150518443cd1(zoomLevel) {
    switch(zoomLevel){
        case (0, $8tMGO.ZOOM_LEVELS).WEEKS:
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * (0, $8tMGO.ESTIMATED_MIN_COLUMN_WIDTH_WEEKS);
        case (0, $8tMGO.ZOOM_LEVELS).MONTHS:
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * (0, $8tMGO.ESTIMATED_MIN_COLUMN_WIDTH_MONTHS);
        case (0, $8tMGO.ZOOM_LEVELS).QUARTERS:
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * (0, $8tMGO.ESTIMATED_MIN_COLUMN_WIDTH_QUARTERS);
        case (0, $8tMGO.ZOOM_LEVELS).YEARS:
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * (0, $8tMGO.ESTIMATED_MIN_COLUMN_WIDTH_YEARS);
        default:
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * (0, $8tMGO.ESTIMATED_MIN_COLUMN_WIDTH_MONTHS);
    }
}
function $9f034544244a6e66$export$fe35704a86ff59e5(zoomLevel) {
    const msPerDay = 86400000;
    /* Needs to be the end of the last day. */ const adjustment = -1;
    switch(zoomLevel){
        case 'weeks':
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * 7 * msPerDay + adjustment;
        case 'months':
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * 30 * msPerDay + adjustment; /* approx 1 month. */ 
        case 'quarters':
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * 91 * msPerDay + adjustment; /* approx 3 months. */ 
        case 'years':
            return (0, $8tMGO.NUM_OF_SCALABLE_COLUMNS) * 365 * msPerDay + adjustment; /* approx 1 year. */ 
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return zoomLevel; /* This magic will save the missing cases. */ 
    }
}
function $9f034544244a6e66$export$deb0f277a5f91a79(timeScaleSelection) {
    switch(timeScaleSelection){
        case 'weeks':
        case 'months':
        case 'quarters':
        case 'years':
            return timeScaleSelection;
        default:
            return undefined;
    }
}

});
parcelRegister("8tMGO", function(module, exports) {

$parcel$export(module.exports, "NUM_OF_SCALABLE_COLUMNS", () => $6d7dcc420cc8ab18$export$4ebc98cbc6faf8fa);
$parcel$export(module.exports, "ESTIMATED_MAX_COLUMN_WIDTH", () => $6d7dcc420cc8ab18$export$d409274947a693d3);
$parcel$export(module.exports, "KEY_ARROW_LEFT", () => $6d7dcc420cc8ab18$export$842fd6cf65a6b80c);
$parcel$export(module.exports, "KEY_ARROW_RIGHT", () => $6d7dcc420cc8ab18$export$695331c89a36efd6);
$parcel$export(module.exports, "SCROLL_BUTTON_STEP", () => $6d7dcc420cc8ab18$export$328d7e29ebafe4ff);
$parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_WEEKS", () => $6d7dcc420cc8ab18$export$c236885cdc8a70c9);
$parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_MONTHS", () => $6d7dcc420cc8ab18$export$812af5a2153a5f6);
$parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_QUARTERS", () => $6d7dcc420cc8ab18$export$e1a0270a2def2eca);
$parcel$export(module.exports, "ESTIMATED_MIN_COLUMN_WIDTH_YEARS", () => $6d7dcc420cc8ab18$export$faa0cb0b47c6fd7a);
$parcel$export(module.exports, "ZOOM_LEVELS", () => $6d7dcc420cc8ab18$export$8b7222fa92892b49);
$parcel$export(module.exports, "ANALYTICS_SCROLL_TIMELINE", () => $6d7dcc420cc8ab18$export$1840ec5bca458d3e);
$parcel$export(module.exports, "ANALYITICS_TIMELINE_HORIZONTAL_SCROLLED", () => $6d7dcc420cc8ab18$export$f99ad8548d6a625e);
$parcel$export(module.exports, "SPA_APP_NAME", () => $6d7dcc420cc8ab18$export$3121747bb6e73d1c);
const $6d7dcc420cc8ab18$export$4ebc98cbc6faf8fa = 4.5;
const $6d7dcc420cc8ab18$export$554f7958a7f8ff1c = 120;
const $6d7dcc420cc8ab18$export$d409274947a693d3 = 250;
const $6d7dcc420cc8ab18$export$842fd6cf65a6b80c = 37;
const $6d7dcc420cc8ab18$export$695331c89a36efd6 = 39;
const $6d7dcc420cc8ab18$export$328d7e29ebafe4ff = 0.25;
const $6d7dcc420cc8ab18$export$c236885cdc8a70c9 = 252; // 7 days * 36px per day
const $6d7dcc420cc8ab18$export$812af5a2153a5f6 = 240; // 30 days * 8px per day
const $6d7dcc420cc8ab18$export$e1a0270a2def2eca = 252;
const $6d7dcc420cc8ab18$export$faa0cb0b47c6fd7a = 252;
const $6d7dcc420cc8ab18$export$8b7222fa92892b49 = {
    WEEKS: 'weeks',
    MONTHS: 'months',
    QUARTERS: 'quarters',
    YEARS: 'years'
};
const $6d7dcc420cc8ab18$export$1840ec5bca458d3e = 'timeline scrolled';
const $6d7dcc420cc8ab18$export$f99ad8548d6a625e = 'timelineHorizontalScrollPerformance measured';
const $6d7dcc420cc8ab18$export$3121747bb6e73d1c = 'advanced-roadmaps';

});


parcelRegister("jqeWm", function(module, exports) {

$parcel$export(module.exports, "calculateQuarter", () => $2f27b9bee5c29fe9$export$a1ca9a6cfffeccdd);
/**
 * Calculates the quarter (1-4) that a month falls within.
 * Can provide optional fyStart month, which defaults to 1 (January).
 * @param month calendar month (1-12)
 * @param fyStartMonth the month that FY starts (1-12)
 * @returns the quarter that the month falls within
 */ const $2f27b9bee5c29fe9$export$a1ca9a6cfffeccdd = (month, fyStartMonth = 1)=>{
    // to avoid negative values, we'll add 12 months first
    const sameMonth = month + 12;
    const monthsSinceFYStart = sameMonth - fyStartMonth;
    const monthsInAQuarter = 3;
    // because we floored here, we'll need to +1 at the end
    const fullQuartersSinceFYStart = Math.floor(monthsSinceFYStart / monthsInAQuarter);
    // only 4 quarters, e.g. Q5 wraps back to Q1
    const quarter = fullQuartersSinceFYStart % 4 + 1;
    return quarter;
};

});





parcelRegister("dBKyg", function(module, exports) {

$parcel$export(module.exports, "getViews", () => $a0f7a6be1ef87bef$export$1146ecde69e3aab7);
$parcel$export(module.exports, "getErrors", () => $a0f7a6be1ef87bef$export$501239432719417d);
$parcel$export(module.exports, "getSaveViewAsDialogStatus", () => $a0f7a6be1ef87bef$export$3d79349e74ca1dd4);
$parcel$export(module.exports, "getActiveView", () => $a0f7a6be1ef87bef$export$eeafe3a59ebae959);
$parcel$export(module.exports, "getActiveViewId", () => $a0f7a6be1ef87bef$export$1d07d3ed6ca0f6c4);
$parcel$export(module.exports, "getNamespaceForView", () => $a0f7a6be1ef87bef$export$7ca3723ed727a96b);
$parcel$export(module.exports, "getPrunedActiveView", () => $a0f7a6be1ef87bef$export$25a2142beadf5fa6);
$parcel$export(module.exports, "getNamespaceFromActiveView", () => $a0f7a6be1ef87bef$export$f58e4c494e4d972d);
$parcel$export(module.exports, "getDefaultView", () => $a0f7a6be1ef87bef$export$29c7e3796b1cc2e7);
$parcel$export(module.exports, "getViewById", () => $a0f7a6be1ef87bef$export$b292b237cbc170ca);
$parcel$export(module.exports, "getPresetPreferences", () => (parcelRequire("8DPqY")).default);

var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");

var $ehEr2 = parcelRequire("ehEr2");

var $cwP4d = parcelRequire("cwP4d");

var $aK3ri = parcelRequire("aK3ri");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $13pyJ = parcelRequire("13pyJ");

var $8DPqY = parcelRequire("8DPqY");
const $a0f7a6be1ef87bef$export$1146ecde69e3aab7 = (state)=>state.domain.views || [];
const $a0f7a6be1ef87bef$export$501239432719417d = (state)=>state.ui.Top.ViewBar.errors;
const $a0f7a6be1ef87bef$export$3d79349e74ca1dd4 = (state)=>state.ui.Top.ViewBar.saveViewAsDialogStatus;
const $a0f7a6be1ef87bef$export$eeafe3a59ebae959 = (0, $iK4oF.createSelector)([
    $a0f7a6be1ef87bef$export$1146ecde69e3aab7
], (views)=>views.find($f7Op5.default('active')) || views[0]);
const $a0f7a6be1ef87bef$export$1d07d3ed6ca0f6c4 = (0, $iK4oF.createSelector)([
    $a0f7a6be1ef87bef$export$eeafe3a59ebae959
], (view)=>view?.id || 0);
const $a0f7a6be1ef87bef$export$7ca3723ed727a96b = (id)=>`view-${id}`;
const $a0f7a6be1ef87bef$export$e1e3861e7c1dfb81 = (activeView, issuesById, issues, projectsById, versionsById, teamsById, sprintsById, labelGroupsById, componentGroupsById, descendantsByParent)=>{
    const { preferences: preferences } = activeView;
    const expandedState = preferences.issueExpansionsV0.isExpanded;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let prunedExpandedState = Object.entries(expandedState).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const issueId = key.split(':')[0];
        if (Number(issueId) || (0, $13pyJ.isScenarioIssue)(issueId)) {
            // if expanded state is stored for issues which are no longer in the plan OR for issues without children, then remove them
            if (!issuesById[issueId] || (descendantsByParent[issueId] || []).length === 0) return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
    // remove expansion state for group by components stored in issue expansion slice
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prunedExpandedState = Object.entries(prunedExpandedState).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        if (key.includes(':components-')) {
            const componentGroupName = key.split('-')[1];
            if (!componentGroupsById[componentGroupName]) return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
    preferences.issueExpansionsV0.isExpanded = prunedExpandedState;
    const groupingExpandedItems = preferences.visualisationsV0.expandedItems;
    if (!groupingExpandedItems) return activeView;
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).ASSIGNEE]) {
        const uniqueAssignees = new Set();
        issues.forEach((issue)=>{
            uniqueAssignees.add(issue.assignee);
        });
        const prunedAssigneeGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).ASSIGNEE]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === 'assignee-unassigned' || uniqueAssignees.has(key.split('-')[1])) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).ASSIGNEE] = prunedAssigneeGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).PROJECT]) {
        const prunedProjectGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).PROJECT]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (projectsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).PROJECT] = prunedProjectGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).RELEASE]) {
        const prunedReleaseGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).RELEASE]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === 'UNDEFINED' || versionsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).RELEASE] = prunedReleaseGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).TEAM]) {
        const prunedTeamGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).TEAM]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === 'UNDEFINED' || teamsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).TEAM] = prunedTeamGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).SPRINT]) {
        const prunedSprintGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).SPRINT]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === 'UNDEFINED' || sprintsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).SPRINT] = prunedSprintGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).LABEL]) {
        const prunedLabelGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).LABEL]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === `labels-${0, $bb09f71c7817719d$export$526fec6b76d5bc5}` || labelGroupsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).LABEL] = prunedLabelGrouping;
    }
    if (groupingExpandedItems[(0, $5rYNM.GROUPING).COMPONENT]) {
        const prunedComponentGrouping = Object.entries(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupingExpandedItems[(0, $5rYNM.GROUPING).COMPONENT]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, [key, value])=>{
            if (key === `components-${0, $bb09f71c7817719d$export$526fec6b76d5bc5}` || componentGroupsById[key.split('-')[1]]) acc[key] = value;
            return acc;
        }, {});
        groupingExpandedItems[(0, $5rYNM.GROUPING).COMPONENT] = prunedComponentGrouping;
    }
    return activeView;
};
const $a0f7a6be1ef87bef$export$25a2142beadf5fa6 = (0, $iK4oF.createSelector)([
    $a0f7a6be1ef87bef$export$eeafe3a59ebae959,
    (0, $cwP4d.getIssueMapById),
    (0, $cwP4d.getAllIssues),
    (0, $ehEr2.getProjectsById),
    (0, $wcCGG.getVersionsById),
    (0, $MQRDu.getTeamsById),
    (0, $c1XMU.getSprintByIdMap),
    (0, $9H2AP.getLabelGroupsById),
    (0, $9H2AP.getComponentGroupsById),
    (0, $aK3ri.getDescendantsByParent)
], $a0f7a6be1ef87bef$export$e1e3861e7c1dfb81);
const $a0f7a6be1ef87bef$export$f58e4c494e4d972d = (0, $iK4oF.createSelector)([
    $a0f7a6be1ef87bef$export$1146ecde69e3aab7
], (views)=>{
    const activeView = views.find($f7Op5.default('active'));
    return activeView && $a0f7a6be1ef87bef$export$7ca3723ed727a96b(activeView.id) || 'default-view';
});
const $a0f7a6be1ef87bef$export$29c7e3796b1cc2e7 = (0, $iK4oF.createSelector)([
    $a0f7a6be1ef87bef$export$1146ecde69e3aab7
], (views)=>views.find($f7Op5.default('isDefault')));
const $a0f7a6be1ef87bef$export$b292b237cbc170ca = (state, viewId)=>{
    const views = $a0f7a6be1ef87bef$export$1146ecde69e3aab7(state);
    return views.find($h3f0m.default('id', viewId));
};

});
parcelRegister("13pyJ", function(module, exports) {

$parcel$export(module.exports, "isScenarioIssue", () => $e080919badc22ce3$export$44ef32448ae567e6);

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $e080919badc22ce3$export$44ef32448ae567e6 = (issueId = '')=>(0, $7CnHa.isDefined)(issueId) && issueId.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX));

});

parcelRegister("8DPqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce649c2f3e422aa3$export$2e2bcd8739ae039);

var $1LPU4 = parcelRequire("1LPU4");
var $l0L3x = parcelRequire("l0L3x");
var $cQGVO = parcelRequire("cQGVO");
var $bIjSf = parcelRequire("bIjSf");
var $f7Op5 = parcelRequire("f7Op5");

var $79xbN = parcelRequire("79xbN");

var $8YqJS = parcelRequire("8YqJS");
var $lcvrv = parcelRequire("lcvrv");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $aMoMC = parcelRequire("aMoMC");

var $kyGCj = parcelRequire("kyGCj");


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $kInjb = parcelRequire("kInjb");
const $ce649c2f3e422aa3$var$DEFAULT_DEPENDENCY_VIEW_SETTINGS = 'lines';
const $ce649c2f3e422aa3$var$makePreset = (params)=>{
    const { groupBy: groupBy, expandedItems: expandedItems, colourBy: colourBy, colourMaps: colourMaps, visibleFields: visibleFields, visibleListFields: visibleListFields, timelineViewport: timelineViewport, filters: filters, calendarFilters: calendarFilters, mode: mode, rollupSettings: rollupSettings, viewMode: viewMode } = params;
    const { start: fromDate, end: toDate } = (0, $aMoMC.get3mthTimeScale)(new Date());
    return {
        dependencySettingsV0: {
            display: $ce649c2f3e422aa3$var$DEFAULT_DEPENDENCY_VIEW_SETTINGS
        },
        visualisationsV0: {
            sorting: {
                field: 'lexoRank',
                type: (0, $5rYNM.STRING),
                direction: (0, $5rYNM.ASCENDING)
            },
            grouping: groupBy,
            expandedItems: $bIjSf.default({
                ASSIGNEE: {},
                COMPONENT: {},
                LABEL: {},
                NONE: {},
                PROJECT: {},
                RELEASE: {},
                SPRINT: {},
                TEAM: {}
            }, expandedItems),
            showSprints: true
        },
        colourByV2: {
            colourByValue: colourBy,
            colourMaps: $bIjSf.default({
                none: {},
                project: {},
                status: {},
                team: {}
            }, colourMaps),
            colourComponents: [],
            colourIssueTypes: [],
            colourIssueTypeKeys: [],
            colourLabels: [],
            colourPriorities: [],
            colourSelects: {},
            lastUsed: 4
        },
        filtersV0: {
            [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: {
                id: (0, $12ee831723ccf9c2$export$3b798637a628dacc),
                value: {}
            },
            ...filters
        },
        calendarFiltersV0: calendarFilters,
        activeFilterViewV0: 'timeline',
        timeScaleV1: {
            selection: timelineViewport,
            customDateRange: {
                fromDate: fromDate,
                toDate: toDate
            },
            mode: mode
        },
        issueExpansionsV0: {
            isExpanded: {
                IssuesWithoutParentHeader: true
            }
        },
        fieldColumnsV0: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            columns: visibleFields.map((field)=>({
                    id: field,
                    isVisible: true
                }))
        },
        listFieldColumnsV0: {
            columns: visibleListFields.map((field)=>({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    id: field,
                    isVisible: true
                }))
        },
        filterOptionsV1: {
            includeAncestors: true,
            includeDescendants: true
        },
        componentGroupsV0: [
            {
                id: 'all_other_issues',
                name: '',
                isExpanded: false,
                components: []
            }
        ],
        labelGroupsV0: [
            {
                id: 'all_other_issues',
                name: '',
                isExpanded: false,
                labels: []
            }
        ],
        customFieldValuesGroupsV0: {},
        highlightedVersionsV0: {
            versions: []
        },
        rollupSettingsV0: {
            showingRolledUpDate: true,
            showRolledUpOthers: true,
            ...rollupSettings
        },
        warningSettingsV1: {
            showWarning: false,
            disabledWarnings: []
        },
        dateConstraintsV0: {
            showDateConstraints: false
        },
        viewModeV0: {
            mode: viewMode
        }
    };
};
// This function is used to find out the maximum and minimum levels of issues in a plan
// It returns an object including "start" and "end" values used to preset the hierarchy filter as follows:
// "Hierarchy" <start> "To" <end>
// e.g. if start = 2 and end = 1 then Hierarchy: "Epic" to "Story"
// e.g. if start = 1 and end = 0 then Hierarchy: "Story" to "Sub-task"
// If there are no issues in the plan, the maximum and minimum levels of the hierarchy range are used
const $ce649c2f3e422aa3$var$getMinMaxIssuesLevels = (state)=>{
    const { issues: issues, hierarchy: hierarchy } = state.domain;
    // finding out the maximum and minimum level of issues in the plan (if any)
    if (issues.length) {
        const issuesLevels = $cQGVO.default($f7Op5.default('level'))(issues);
        return {
            start: $1LPU4.default(Math.max, issuesLevels),
            end: $1LPU4.default(Math.min, issuesLevels)
        };
    }
    // finding out the maximum and minimum levels in the hierarchy range
    // {level: SUB_TASK_LEVEL, title: "Sub-task"}, {level: STORY_LEVEL, title: "Story"}, {level: EPIC_LEVEL, title: "Epic"} and so on
    const hierarchyLevels = $cQGVO.default($f7Op5.default('level'))(hierarchy.levels);
    return {
        start: $1LPU4.default(Math.max, hierarchyLevels),
        end: $1LPU4.default(Math.min, hierarchyLevels)
    };
};
const $ce649c2f3e422aa3$var$getFutureSprints = (sprints)=>sprints.filter(({ state: state })=>state === (0, $5rYNM.SPRINT_STATES).FUTURE).map(({ id: id })=>id);
const $ce649c2f3e422aa3$var$getProjectExpansions = (projects)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    projects.reduce((acc, { id: id })=>Object.assign(acc, {
            [`project-${id}`]: true
        }), {});
const $ce649c2f3e422aa3$var$getPresetsPure = (state, colourMaps, projects, sprints, planType)=>{
    const dateConfiguration = (0, $75KhQ.getDateConfiguration)(state);
    const isCrossTeam = planType === 'CROSS_TEAM';
    const isCrossTeamPlanning = planType === 'CROSS_TEAM_PLANNING';
    const isSamplePlan = (0, $75KhQ.getIsSamplePlan)(state);
    const shouldServeExperiment = (0, $79xbN.expValEquals)('ploverview_landing_on_list_mode_by_default', 'cohort', 'variation');
    const teamExpansions = (()=>{
        const teams = (0, $MQRDu.getTeams)(state);
        return teams.map(({ id: id })=>id).reduce((acc, id)=>{
            acc[`team-${id}`] = true;
            return acc;
        }, {});
    })();
    const calendarFilters = {
        [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
            id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
            value: $ce649c2f3e422aa3$var$getMinMaxIssuesLevels(state)
        }
    };
    // JPOS-4428 - adding a new default preset view named "Basic"
    const basic = $ce649c2f3e422aa3$var$makePreset({
        groupBy: (0, $5rYNM.GROUPING).NONE,
        expandedItems: {},
        colourBy: 'status',
        colourMaps: colourMaps,
        visibleFields: [
            'issueStatus'
        ],
        visibleListFields: [
            ...shouldServeExperiment ? [
                'priority'
            ] : [],
            dateConfiguration.baselineStartField.key,
            dateConfiguration.baselineEndField.key,
            'issueStatus',
            'progressByEstimation',
            'assignee'
        ],
        timelineViewport: '3mth',
        mode: (0, $5rYNM.TIMELINE_MODES).MONTHS,
        viewMode: shouldServeExperiment ? (0, $lcvrv.VIEW_MODES).LIST : (0, $lcvrv.VIEW_MODES).TIMELINE,
        filters: {
            [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: isCrossTeam ? {
                    start: (0, $8YqJS.INITIATIVE_LEVEL),
                    end: (0, $8YqJS.SUB_TASK_LEVEL)
                } : $ce649c2f3e422aa3$var$getMinMaxIssuesLevels(state)
            }
        },
        calendarFilters: calendarFilters,
        ...isCrossTeam && {
            rollupSettings: {
                showingRolledUpDate: true,
                showRolledUpOthers: true
            }
        }
    });
    const getSprintCapacityManagementFilters = ()=>{
        if (isSamplePlan) return {
            filters: {
                [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                    id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                    value: {
                        start: (0, $8YqJS.EPIC_LEVEL),
                        end: (0, $8YqJS.SUB_TASK_LEVEL)
                    }
                }
            },
            calendarFilters: calendarFilters,
            rollupSettings: {
                showingRolledUpDate: true,
                showRolledUpOthers: false
            }
        };
        if (isCrossTeamPlanning) return {
            filters: {
                [(0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)]: {
                    id: (0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb),
                    value: $ce649c2f3e422aa3$var$getFutureSprints(sprints)
                },
                [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                    id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                    value: {
                        start: (0, $8YqJS.EPIC_LEVEL),
                        end: (0, $8YqJS.EPIC_LEVEL)
                    }
                }
            },
            calendarFilters: calendarFilters
        };
        return {
            filters: {
                [(0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)]: {
                    id: (0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb),
                    value: $ce649c2f3e422aa3$var$getFutureSprints(sprints)
                },
                [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                    id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                    value: {
                        start: (0, $8YqJS.STORY_LEVEL),
                        end: (0, $8YqJS.STORY_LEVEL)
                    }
                }
            },
            calendarFilters: calendarFilters
        };
    };
    const sprintCapacityManagement = $ce649c2f3e422aa3$var$makePreset({
        groupBy: (0, $5rYNM.GROUPING).TEAM,
        expandedItems: {
            TEAM: {
                UNDEFINED: true,
                ...teamExpansions
            }
        },
        colourBy: 'status',
        colourMaps: colourMaps,
        visibleFields: [
            'assignee'
        ],
        visibleListFields: [
            'priority',
            'sprint',
            'estimate',
            'team',
            'release',
            'assignee'
        ],
        timelineViewport: '3mth',
        mode: (0, $5rYNM.TIMELINE_MODES).MONTHS,
        viewMode: isCrossTeamPlanning || shouldServeExperiment ? (0, $lcvrv.VIEW_MODES).LIST : (0, $lcvrv.VIEW_MODES).TIMELINE,
        ...getSprintCapacityManagementFilters()
    });
    const topLevelPlanning = $ce649c2f3e422aa3$var$makePreset({
        groupBy: (0, $5rYNM.GROUPING).PROJECT,
        expandedItems: {
            PROJECT: $ce649c2f3e422aa3$var$getProjectExpansions(projects)
        },
        colourBy: 'team',
        colourMaps: colourMaps,
        visibleFields: [
            'team'
        ],
        visibleListFields: [
            'breakdown',
            ...shouldServeExperiment ? [
                'priority'
            ] : [],
            dateConfiguration.baselineStartField.key,
            dateConfiguration.baselineEndField.key,
            'team',
            'release',
            'components'
        ],
        timelineViewport: '1yr',
        mode: (0, $5rYNM.TIMELINE_MODES).QUARTERS,
        viewMode: shouldServeExperiment ? (0, $lcvrv.VIEW_MODES).LIST : (0, $lcvrv.VIEW_MODES).TIMELINE,
        filters: {
            [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: {
                    start: (0, $8YqJS.STORY_LEVEL) + 8,
                    end: (0, $8YqJS.STORY_LEVEL)
                }
            }
        },
        calendarFilters: calendarFilters
    });
    const dependencyManagement = $ce649c2f3e422aa3$var$makePreset({
        groupBy: (0, $5rYNM.GROUPING).NONE,
        expandedItems: {},
        colourBy: 'status',
        colourMaps: colourMaps,
        visibleFields: [
            'team'
        ],
        visibleListFields: [
            'incomingDependencies',
            'outgoingDependencies',
            'priority',
            dateConfiguration.baselineStartField.key,
            dateConfiguration.baselineEndField.key,
            'team'
        ],
        timelineViewport: '1yr',
        mode: (0, $5rYNM.TIMELINE_MODES).QUARTERS,
        viewMode: shouldServeExperiment ? (0, $lcvrv.VIEW_MODES).LIST : (0, $lcvrv.VIEW_MODES).TIMELINE,
        filters: {
            [(0, $12ee831723ccf9c2$export$a849f806e27a57e8)]: {
                id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                value: {
                    type: 'on'
                }
            },
            [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: {
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: {
                    start: (0, $8YqJS.EPIC_LEVEL),
                    end: (0, $8YqJS.SUB_TASK_LEVEL)
                }
            }
        },
        calendarFilters: calendarFilters
    });
    const presetNames = (0, $kInjb.getPresetViewNames)();
    return {
        [presetNames.BASIC]: basic,
        [presetNames.SPRINT_CAPACITY_MANAGEMENT]: sprintCapacityManagement,
        [presetNames.TOP_LEVEL_PLANNING]: topLevelPlanning,
        [presetNames.DEPENDENCY_MANAGEMENT]: dependencyManagement
    };
};
const $ce649c2f3e422aa3$var$getPresets = (0, $iK4oF.createSelector)([
    $l0L3x.default,
    (0, $kyGCj.getColourMaps),
    (0, $ehEr2.getProjects),
    (0, $c1XMU.getSprints),
    (0, $75KhQ.getPlanType)
], $ce649c2f3e422aa3$var$getPresetsPure);
var $ce649c2f3e422aa3$export$2e2bcd8739ae039 = $ce649c2f3e422aa3$var$getPresets;

});
parcelRegister("1LPU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a2712eeb5270cb$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $14a2712eeb5270cb$var$apply = /*#__PURE__*/ (0, $ggdJA.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $14a2712eeb5270cb$export$2e2bcd8739ae039 = $14a2712eeb5270cb$var$apply;

});

parcelRegister("bIjSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $887338541ee657f4$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $6Xuyi = parcelRequire("6Xuyi");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $887338541ee657f4$var$mergeDeepRight = /*#__PURE__*/ (0, $ggdJA.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $6Xuyi.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $887338541ee657f4$export$2e2bcd8739ae039 = $887338541ee657f4$var$mergeDeepRight;

});

parcelRegister("kInjb", function(module, exports) {

$parcel$export(module.exports, "getPresetViewNames", () => $3508569cb7335aaa$export$4c84de639d306578);
$parcel$export(module.exports, "getMigratedPresetViewName", () => $3508569cb7335aaa$export$310b844714cc8795);

var $1ybV0 = parcelRequire("1ybV0");

var $6DE5z = parcelRequire("6DE5z");
const $3508569cb7335aaa$export$ce22daa42f564de0 = (currentVersions, finalVersion)=>currentVersions.reduce((migrationMap, currentVersion)=>{
        Object.assign(migrationMap, Object.fromEntries(Object.keys(finalVersion).filter((key)=>currentVersion[key]).map((key)=>[
                currentVersion[key],
                finalVersion[key]
            ])));
        return migrationMap;
    }, {});
const $3508569cb7335aaa$var$migrationMap = $3508569cb7335aaa$export$ce22daa42f564de0([
    (0, $6DE5z.PRESET_VIEWS_NAMES_V1),
    (0, $6DE5z.PRESET_VIEWS_NAMES_V2)
], (0, $6DE5z.PRESET_VIEWS_NAMES_V3));
const $3508569cb7335aaa$export$4c84de639d306578 = ()=>(0, $1ybV0.ff)('com.atlassian.jpo.rm.update-preset-names') ? (0, $6DE5z.PRESET_VIEWS_NAMES_V3) : (0, $6DE5z.PRESET_VIEWS_NAMES_V2);
const $3508569cb7335aaa$export$310b844714cc8795 = (view)=>{
    const isUserDefinedOrModifiedPresetView = view.updatedAt;
    if (isUserDefinedOrModifiedPresetView) return view.name;
    return $3508569cb7335aaa$var$migrationMap[view.name] || view.name;
};

});
parcelRegister("6DE5z", function(module, exports) {

$parcel$export(module.exports, "PRESET_VIEWS_NAMES_V1", () => $64bb019506243e18$export$67bf3fbafd21640c);
$parcel$export(module.exports, "PRESET_VIEWS_NAMES_V2", () => $64bb019506243e18$export$684b31ff3ba50072);
$parcel$export(module.exports, "PRESET_VIEWS_NAMES_V3", () => $64bb019506243e18$export$62577b1c23812511);
const $64bb019506243e18$export$67bf3fbafd21640c = {
    BASIC: 'Basic',
    SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity management',
    TOP_LEVEL_PLANNING: 'Top-level planning',
    DEPENDENCY_MANAGEMENT: 'Dependency management'
};
const $64bb019506243e18$export$684b31ff3ba50072 = {
    BASIC: 'Basic view',
    SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity management view',
    TOP_LEVEL_PLANNING: 'Top-level planning view',
    DEPENDENCY_MANAGEMENT: 'Dependency management view'
};
const $64bb019506243e18$export$62577b1c23812511 = {
    BASIC: 'Basic view',
    SPRINT_CAPACITY_MANAGEMENT: 'Sprint capacity view',
    TOP_LEVEL_PLANNING: 'Top-level view',
    DEPENDENCY_MANAGEMENT: 'Dependencies'
};

});





parcelRegister("6DiV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce9f055b9f1e61e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $5OdRK = parcelRequire("5OdRK");
var $eN1iE = parcelRequire("eN1iE");
var $f7Op5 = parcelRequire("f7Op5");

var $6Pq2D = parcelRequire("6Pq2D");

var $6ZVGV = parcelRequire("6ZVGV");

var $9EHc8 = parcelRequire("9EHc8");

var $aR8n6 = parcelRequire("aR8n6");

var $1ybV0 = parcelRequire("1ybV0");

var $eb6jM = parcelRequire("eb6jM");

var $9pngN = parcelRequire("9pngN");

var $kQ0RL = parcelRequire("kQ0RL");
var $lMaVG = parcelRequire("lMaVG");
var $lcvrv = parcelRequire("lcvrv");

var $cTxSR = parcelRequire("cTxSR");
var $3g62d = parcelRequire("3g62d");

var $dw8TK = parcelRequire("dw8TK");

var $hIE3U = parcelRequire("hIE3U");

var $7Jv2m = parcelRequire("7Jv2m");

var $h7T2Y = parcelRequire("h7T2Y");

var $cm4fw = parcelRequire("cm4fw");
parcelRequire("bJc6r");
var $8bnQD = parcelRequire("8bnQD");

var $Texvm = parcelRequire("Texvm");

var $aFXbw = parcelRequire("aFXbw");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");

var $8WuJm = parcelRequire("8WuJm");
var $2qZHF = parcelRequire("2qZHF");

var $eIp1n = parcelRequire("eIp1n");

var $jK1pm = parcelRequire("jK1pm");

var $1QVWH = parcelRequire("1QVWH");

var $a4FqW = parcelRequire("a4FqW");

var $5MFfw = parcelRequire("5MFfw");

var $RzRoa = parcelRequire("RzRoa");

var $ctt5V = parcelRequire("ctt5V");

var $jpHLB = parcelRequire("jpHLB");

var $4Zu2i = parcelRequire("4Zu2i");
parcelRequire("enlJQ");
var $33T6K = parcelRequire("33T6K");
var $l3ocQ = parcelRequire("l3ocQ");
var $5zxdR = parcelRequire("5zxdR");

var $b1lid = parcelRequire("b1lid");
parcelRequire("2Qk6Z");
var $8s4Mr = parcelRequire("8s4Mr");

var $6j6dF = parcelRequire("6j6dF");

var $f6cUI = parcelRequire("f6cUI");

var $7DHvS = parcelRequire("7DHvS");

var $aAoN3 = parcelRequire("aAoN3");

var $9JwZx = parcelRequire("9JwZx");

var $cJ2vZ = parcelRequire("cJ2vZ");

var $1jLma = parcelRequire("1jLma");

var $k1Cxd = parcelRequire("k1Cxd");

var $9g9PT = parcelRequire("9g9PT");

var $ddt7b = parcelRequire("ddt7b");

var $eaNnd = parcelRequire("eaNnd");

var $57dZR = parcelRequire("57dZR");
const $bce9f055b9f1e61e$var$MIN_APP_WIDTH = 1000; // cssVariables['jpo-common-min-app-width'];
const $bce9f055b9f1e61e$var$LEFT_MARGIN_DEFAULT = 40;
const $bce9f055b9f1e61e$var$LEFT_MARGIN_REPORT = 24;
const $bce9f055b9f1e61e$var$WrapFieldsContent = ({ isSpotlightActive: isSpotlightActive, width: width, children: children })=>{
    if (isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $cJ2vZ.highlight,
        style: {
            width: width
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $bce9f055b9f1e61e$var$ContentScroller = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    const [mounted, setMounted] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        // We only want to mount the child component (issues) after the scroll container has been mounted because
        // the child component requires a reference to the scroll container. useLayoutEffect delays when we
        // actually mount the child component.
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...otherProps,
        ref: ref
    }, mounted && children);
});
// eslint-disable-next-line jira/react/no-class-components
class $bce9f055b9f1e61e$var$Roadmap extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ZoomLevelSync: $5zxdR.default,
            TimeScale: $1jLma.default,
            PanningControl: $8s4Mr.default,
            Scope: $7DHvS.default,
            ScopeHeader: $f6cUI.default,
            Fields: $jpHLB.default,
            FieldsHeader: $4Zu2i.default,
            Timeline: $k1Cxd.default,
            TimelineHeader: $9g9PT.default,
            AllIssuesSelect: $6j6dF.default,
            IssueModal: $aFXbw.default,
            ViewExperienceFailureTracker: $Texvm.default
        };
    }
    getContainerRef() {
        return this.props.containerRef || this.containerRef;
    }
    // eslint-disable-next-line react/sort-comp
    constructor(props){
        super(props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/sort-comp
        this.containerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.sectionsRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.scrollTopRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.sectionsContainerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.navigationApp = null;
        this.navigationAppObserver = null;
        this.state = {
            containerWidth: 0,
            timelineSpotlightTopPosition: 68,
            timelineFullScreen: false,
            dividerVisible: true
        };
        this.scrollElement = null;
        this.activeRow = null;
        this.scopeColumnWidth = 0;
        this.fieldsColumnWidth = 0;
        this.timelineColumnWidth = 0;
        // Fields viewport width
        this.fieldsViewportWidth = 0;
        /**
	 * Manage row highlighting.
	 * Basic idea is to find the closest row highlighter element and switch on all row highlighters
	 * with the same id (and switch off previously active ones). Highlighter id is issueId at the
	 * moment, take it into account when extending functionality to non-issue rows so there will be
	 * no id overlap or instability.
	 */ this.onMouseOver = (e)=>{
            let parent = e.target;
            // Using while + parentNode as Element.closest() is not supported by IE11.
            while(parent instanceof Node){
                if (parent instanceof HTMLElement) {
                    const { issue: issue, group: group } = parent.dataset;
                    const highlightRowId = (0, $57dZR.getHighlightRowId)(group, issue);
                    if (issue && highlightRowId !== this.activeRow) {
                        if ((0, $7CnHa.isDefined)(this.activeRow)) (0, $57dZR.toggleRowHighlighter)(this.activeRow, false);
                        this.activeRow = highlightRowId;
                        (0, $57dZR.toggleRowHighlighter)(this.activeRow, true);
                        return;
                    }
                }
                parent = parent.parentNode;
            }
        };
        this.onMouseOut = ()=>{
            if ((0, $7CnHa.isDefined)(this.activeRow)) (0, $57dZR.toggleRowHighlighter)(this.activeRow, false);
            this.activeRow = null;
        };
        this.handleScroll = ()=>{
            if (this.scrollElement) {
                const scrollTop = this.scrollElement.scrollTop;
                this.setState({
                    dividerVisible: scrollTop > 0
                });
                if (!(0, $7CnHa.isDefined)(this.props.setStickyHeaderScroll)) return;
                if (this.scrollTopRef.current === scrollTop) return;
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scrollTopRef.current = scrollTop;
                this.props.setStickyHeaderScroll(scrollTop);
            }
        };
        this.handleSectionsRender = (sectionsData)=>{
            const sectionsById = $eN1iE.default($f7Op5.default('id'), sectionsData);
            const scopeWidth = sectionsById[(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE].width || this.scopeColumnWidth;
            const fieldsWidth = sectionsById[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS].width || this.fieldsColumnWidth;
            const timelineWidth = sectionsById[(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]?.width || this.timelineColumnWidth;
            const fieldsViewportWidth = Math.max(this.state.containerWidth - scopeWidth, 0);
            if (fieldsViewportWidth !== this.fieldsViewportWidth) this.fieldsViewportWidth = fieldsViewportWidth;
            if (scopeWidth !== this.scopeColumnWidth || fieldsWidth !== this.fieldsColumnWidth || timelineWidth !== this.timelineColumnWidth) {
                this.scopeColumnWidth = scopeWidth;
                this.fieldsColumnWidth = fieldsWidth;
                this.timelineColumnWidth = timelineWidth;
                /**
			 * This update the section-widths in the redux state which will be consumed elsewhere i.e. PngExport
			 * Ideally it should not be called in "render" lifecycle but this is where we could access the section widths
			 */ this.props.updateTopLevelColumnWidths({
                    scope: this.scopeColumnWidth,
                    fields: this.fieldsColumnWidth,
                    timeline: this.timelineColumnWidth
                });
            }
        };
        this.toggleFullscreen = (goFullScreen)=>{
            this.setState({
                timelineFullScreen: !goFullScreen
            }, ()=>{
                this.measureAndUpdateWidth();
            });
        };
        this.expandFieldsShortcut = ()=>{
            this.sectionsRef.current && this.sectionsRef.current.onCollapsedSectionClick(1);
        };
        this.getTimelineWidth = (sectionWidth)=>{
            const { isExportMode: isExportMode, exportModeTimelineWidth: exportModeTimelineWidth } = this.props;
            return isExportMode ? exportModeTimelineWidth : sectionWidth;
        };
        this.measureAndUpdateWidth = ()=>{
            const ref = this.getContainerRef().current;
            if (!ref) return;
            // Viewport width
            const { width: viewportWidth } = (0, $1ni3W.getViewportSize)();
            let containerWidth = viewportWidth;
            const rightSideBarWidth = this.getRightSidebarWidth();
            containerWidth -= rightSideBarWidth;
            if (!this.state.timelineFullScreen && !this.props.isExportMode && !this.props.isConfluenceMacro && !this.props.isEmbed && this.props.leftSidebarWidth) containerWidth -= this.props.isReportMode ? $bce9f055b9f1e61e$var$LEFT_MARGIN_REPORT : this.props.leftSidebarWidth + $bce9f055b9f1e61e$var$LEFT_MARGIN_DEFAULT;
            containerWidth = Math.max(containerWidth, $bce9f055b9f1e61e$var$MIN_APP_WIDTH);
            if (this.state.containerWidth !== containerWidth) this.setState({
                containerWidth: containerWidth
            });
        };
        this.getRightSidebarWidth = ()=>(0, $7CnHa.isDefined)(this.props.rightSidebarWidth) && !this.state.timelineFullScreen ? this.props.rightSidebarWidth : 0;
        this.measureAndUpdateWidthThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(this.measureAndUpdateWidth, 50);
        this.fieldsColumnTextsRenderer = ({ section: section })=>{
            const { viewMode: viewMode } = this.props;
            const id = viewMode === (0, $lcvrv.VIEW_MODES).LIST ? (0, $5rYNM.SECTION_KEYS).LIST_FIELD : (0, $5rYNM.SECTION_KEYS).FIELD;
            const style = {
                width: section.width,
                overflow: 'hidden'
            };
            // if the section is not collapsed and is the fields column
            if (section.width > section.minWidth && section.id === (0, $5rYNM.SECTION_ITEM_KEYS).FIELDS) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: style
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).ColumnTexts, {
                id: id,
                isExportMode: this.props.isExportMode,
                namespace: this.props.viewNamespace
            })));
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: style
            });
        };
        this.isSpotlightAtScope = ()=>this.props.activeCard === 'scope' || this.props.spotlight === (0, $7Jv2m.Spotlights).Scope || this.props.spotlight === (0, $hIE3U.CttSpotlights).Scope;
        this.isSpotlightAtFields = ()=>this.props.activeCard === 'fields' || this.props.spotlight === (0, $7Jv2m.Spotlights).Fields;
        this.isSpotlightAtTimeline = ()=>this.props.activeCard === 'timeline' || this.props.spotlight === (0, $7Jv2m.Spotlights).Timeline;
        this.getSectionWidth = (section)=>{
            if (section.id === (0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE) return this.getTimelineWidth(section.width);
            if (section.id === (0, $5rYNM.SECTION_ITEM_KEYS).FIELDS && this.props.viewMode === (0, $lcvrv.VIEW_MODES).LIST) return this.fieldsViewportWidth;
            return section.width;
        };
        this.sectionRenderer = ({ section: section, onSectionClick: onSectionClick, index: index, isDragging: isDragging, hoveredSectionIndex: hoveredSectionIndex, setHovered: setHovered })=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { Fields: Fields, Scope: Scope, Timeline: Timeline, leftSidebarWidth: leftSidebarWidth, viewMode: viewMode, isExportMode: isExportMode } = this.props;
            const width = this.getSectionWidth(section);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
                id: section.id,
                key: `section-${section.id}`,
                index: index,
                width: width,
                minWidth: section.minWidth,
                onClick: onSectionClick,
                collapsible: section.collapsible,
                hoveredSectionIndex: hoveredSectionIndex,
                setHovered: setHovered
            }, {
                [(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]} ${this.isSpotlightAtScope() ? $cJ2vZ.highlight : ''}`
                }, this.isSpotlightAtScope() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RzRoa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $cJ2vZ['scope-container']
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Scope, {
                    width: section.width,
                    scrollElement: this.scrollElement,
                    isDragging: isDragging
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $cJ2vZ.space
                })),
                [(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]: viewMode === (0, $lcvrv.VIEW_MODES).LIST && !isExportMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bce9f055b9f1e61e$var$WrapFieldsContent, {
                    width: width,
                    isSpotlightActive: this.isSpotlightAtFields()
                }, this.isSpotlightAtFields() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RzRoa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g62d.HorizontalSyncedScrollView), {
                    primary: true,
                    name: "fields",
                    width: section.width,
                    minWidth: width
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]}`,
                    style: {
                        minWidth: width
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fields, {
                    width: section.width,
                    minWidth: width,
                    scrollElement: this.scrollElement,
                    isDragging: isDragging
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]} ${this.isSpotlightAtFields() ? $cJ2vZ.highlight : ''}`,
                    style: {
                        minWidth: width
                    }
                }, this.isSpotlightAtFields() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RzRoa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fields, {
                    width: section.width,
                    scrollElement: this.scrollElement,
                    isDragging: isDragging
                })),
                [(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]} ${this.isSpotlightAtTimeline() ? $cJ2vZ.highlight : ''}`
                }, this.isSpotlightAtTimeline() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RzRoa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Timeline, {
                    scrollElement: this.scrollElement,
                    width: width,
                    isDragging: isDragging,
                    leftSidebarWidth: leftSidebarWidth
                }))
            }[section.id]);
        };
        this.horizontalScrollBarRenderer = ({ section: section })=>{
            const { isExportMode: isExportMode, viewMode: viewMode } = this.props;
            if (section.id === (0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE && !isExportMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    width: section.width,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    position: 'relative'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33T6K.default), null));
            if (viewMode === (0, $lcvrv.VIEW_MODES).LIST && section.id === (0, $5rYNM.SECTION_ITEM_KEYS).FIELDS && !isExportMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    width: this.fieldsViewportWidth,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    position: 'relative'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTxSR.HorizontalSyncedScrollbar), {
                name: "fields"
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    width: section.width
                }
            });
        };
        this.collapse = (index)=>()=>{
                this.sectionsRef.current && this.sectionsRef.current.collapseSection(index);
            };
        this.stickyHeaderRenderer = ({ section: section, onSectionClick: onSectionClick, index: index, isDragging: isDragging, hoveredSectionIndex: hoveredSectionIndex, setHovered: setHovered })=>{
            const { viewMode: viewMode, isExportMode: isExportMode } = this.props;
            const width = this.getSectionWidth(section);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
                id: section.id,
                key: `section-${section.id}`,
                index: index,
                width: width,
                minWidth: section.minWidth,
                onClick: onSectionClick,
                collapsible: section.collapsible,
                hoveredSectionIndex: hoveredSectionIndex,
                setHovered: setHovered
            }, {
                [(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]} ${this.isSpotlightAtScope() ? $cJ2vZ.highlight : ''}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAoN3.default), {
                    containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-scope`,
                    isDragging: isDragging,
                    width: section.width
                })),
                [(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]} ${this.isSpotlightAtTimeline() ? $cJ2vZ.highlight : ''}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAoN3.default), {
                    containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-timeline`,
                    isDragging: isDragging,
                    width: width
                })),
                [(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]: viewMode === (0, $lcvrv.VIEW_MODES).LIST && !isExportMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bce9f055b9f1e61e$var$WrapFieldsContent, {
                    width: width,
                    isSpotlightActive: this.isSpotlightAtFields()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g62d.HorizontalSyncedScrollView), {
                    name: "fields",
                    width: section.width,
                    minWidth: width
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]}`,
                    style: {
                        minWidth: width
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JwZx.default), {
                    width: section.width,
                    isDragging: isDragging,
                    minWidth: width
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]} ${this.isSpotlightAtFields() ? $cJ2vZ.highlight : ''}`,
                    style: {
                        minWidth: width
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JwZx.default), {
                    width: section.width,
                    isDragging: isDragging,
                    minWidth: undefined
                }))
            }[section.id]);
        };
        this.sectionHeadersRenderer = ({ section: section, onSectionClick: onSectionClick, index: index, isDragging: isDragging, hoveredSectionIndex: hoveredSectionIndex, setHovered: setHovered })=>{
            const { FieldsHeader: // eslint-disable-next-line @typescript-eslint/no-shadow
            FieldsHeader, ScopeHeader: // eslint-disable-next-line @typescript-eslint/no-shadow
            ScopeHeader, TimelineHeader: // eslint-disable-next-line @typescript-eslint/no-shadow
            TimelineHeader, AllIssuesSelect: // eslint-disable-next-line @typescript-eslint/no-shadow
            AllIssuesSelect, activeCard: activeCard, viewMode: viewMode, isExportMode: isExportMode } = this.props;
            const { containerWidth: containerWidth } = this.state;
            const width = this.getSectionWidth(section);
            // While onboarding, if the sections are collapsed or too large, we expand or shrink them
            if ((activeCard === 'update-jira' || this.isSpotlightAtFields()) && (0, $57dZR.shouldSetOnboardingWidth)(section, containerWidth)) this.sectionsRef.current && this.sectionsRef.current.setOnboardingWidth();
            const spotlightAnchorEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "aria-label": "Spotlight Anchor",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    position: 'absolute',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    top: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    bottom: 0,
                    zIndex: -1,
                    width: width
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
                id: section.id,
                key: `section-${section.id}`,
                index: index,
                width: width,
                minWidth: section.minWidth,
                title: section.title,
                onClick: onSectionClick,
                collapsible: section.collapsible,
                hoveredSectionIndex: hoveredSectionIndex,
                setHovered: setHovered
            }, {
                [(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).SCOPE]} ${this.isSpotlightAtScope() ? $cJ2vZ.highlight : ''}`
                }, this.isSpotlightAtScope() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
                    name: (0, $hIE3U.CttSpotlights).Scope
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
                    name: (0, $7Jv2m.Spotlights).Scope
                }, spotlightAnchorEl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AllIssuesSelect, {
                    isDragging: isDragging
                }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ScopeHeader, props))),
                [(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]: viewMode === (0, $lcvrv.VIEW_MODES).LIST && !isExportMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bce9f055b9f1e61e$var$WrapFieldsContent, {
                    width: width,
                    isSpotlightActive: this.isSpotlightAtFields()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
                    name: (0, $7Jv2m.Spotlights).Fields
                }, spotlightAnchorEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3g62d.HorizontalSyncedScrollView), {
                    name: "fields",
                    width: section.width,
                    minWidth: width
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]} ${$cJ2vZ['pointer-cursor']}`,
                    style: {
                        minWidth: width
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldsHeader, {
                    isDragging: isDragging,
                    onCollapseAllFields: this.collapse(index),
                    width: section.width,
                    minWidth: width
                })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).FIELDS]} ${$cJ2vZ['pointer-cursor']} ${this.isSpotlightAtFields() ? $cJ2vZ.highlight : ''}`,
                    style: {
                        minWidth: width
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
                    name: (0, $7Jv2m.Spotlights).Fields
                }, spotlightAnchorEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldsHeader, {
                    isDragging: isDragging,
                    onCollapseAllFields: this.collapse(index),
                    width: section.width
                })),
                [(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.isSpotlightAtTimeline() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
                    name: (0, $7Jv2m.Spotlights).Timeline
                }, spotlightAnchorEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$cJ2vZ[(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE]} ${$cJ2vZ['timeline-column-header']} ${this.isSpotlightAtTimeline() ? $cJ2vZ.highlight : ''}`,
                    "aria-hidden": true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimelineHeader, {
                    width: width
                })))
            }[section.id]);
        };
        this.sendViewRoadmapScreenAnalyticsEvent = (analyticsEvent)=>{
            this.props.onRoadmapView(analyticsEvent);
        };
        if (props.isExportMode) this.state.containerWidth = (0, $lFLge.getNonTimelineWidth)() + props.exportModeTimelineWidth;
    }
    componentDidMount() {
        const ref = this.getContainerRef();
        if (ref.current) {
            const containerEl = ref.current;
            const containerTop = containerEl.getBoundingClientRect().top;
            if (containerTop !== this.state.timelineSpotlightTopPosition) this.setState({
                timelineSpotlightTopPosition: containerTop + 68
            });
        }
        if (this.scrollElement) this.setState({
            dividerVisible: this.scrollElement.scrollTop > 0
        });
        this.navigationApp = document.getElementById('navigation-app');
        if (this.navigationApp) {
            this.navigationAppObserver = new MutationObserver(this.measureAndUpdateWidthThrottled);
            const config = {
                attributes: true,
                subtree: true
            };
            this.navigationAppObserver.observe(this.navigationApp, config);
        }
        if (!this.props.isExportMode) {
            this.measureAndUpdateWidth();
            window.addEventListener('resize', this.measureAndUpdateWidthThrottled);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !($5OdRK.default(nextProps, this.props) && $5OdRK.default(nextState, this.state));
    }
    componentDidUpdate(prevProps) {
        if (this.props.rightSidebarWidth !== prevProps.rightSidebarWidth || this.props.leftSidebarWidth !== prevProps.leftSidebarWidth) this.measureAndUpdateWidthThrottled();
        if (this.props.appWidth !== prevProps.appWidth && this.props.isExportMode && this.props.appWidth !== this.state.containerWidth) this.setState({
            containerWidth: this.props.appWidth
        });
        // These event handlers are added to highlight the rows on mouse over.
        const sectionsContainer = this.sectionsContainerRef.current;
        if (sectionsContainer instanceof HTMLElement) {
            sectionsContainer.addEventListener('mouseover', this.onMouseOver);
            sectionsContainer.addEventListener('mouseout', this.onMouseOut);
        }
        const { isExportMode: isExportMode, isLoading: isLoading, onLoadComplete: onLoadComplete, reportTimeToInteractive: reportTimeToInteractive, isGoalsLoading: isGoalsLoading } = this.props;
        if (!isLoading && !isGoalsLoading && onLoadComplete) onLoadComplete();
        if (!isExportMode && !isLoading) reportTimeToInteractive({
            isNewSidebarEnabled: true
        });
    }
    componentWillUnmount() {
        if (this.navigationAppObserver) this.navigationAppObserver.disconnect();
        if (!this.props.isExportMode) window.removeEventListener('resize', this.measureAndUpdateWidthThrottled);
        // The event handlers to highlight the rows on mouse over are removed on unmount.
        const sectionsContainer = this.sectionsContainerRef.current;
        if (sectionsContainer instanceof HTMLElement) {
            sectionsContainer.removeEventListener('mouseover', this.onMouseOver);
            sectionsContainer.removeEventListener('mouseout', this.onMouseOut);
        }
    }
    render() {
        const { ZoomLevelSync: // eslint-disable-next-line @typescript-eslint/no-shadow
        ZoomLevelSync, TimeScale: // eslint-disable-next-line @typescript-eslint/no-shadow
        TimeScale, PanningControl: // eslint-disable-next-line @typescript-eslint/no-shadow
        PanningControl, IssueModal: // eslint-disable-next-line @typescript-eslint/no-shadow
        IssueModal, ViewExperienceFailureTracker: // eslint-disable-next-line @typescript-eslint/no-shadow
        ViewExperienceFailureTracker, scopeHeight: scopeHeight, isOptimizedMode: isOptimizedMode, activeCard: activeCard, stickyHeader: stickyHeader, hasWarningInConfiguredDates: hasWarningInConfiguredDates, viewNamespace: viewNamespace, isExportMode: isExportMode, zoomLevel: zoomLevel, spotlight: spotlight, intl: intl, edition: edition, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed, isReportMode: isReportMode, shouldDisplayTmpCrossProjectChangeboarding: shouldDisplayTmpCrossProjectChangeboarding, hierarchyTitles: hierarchyTitles, viewMode: viewMode, isLoading: isLoading } = this.props;
        const mainSectionsData = (0, $57dZR.getSectionsData)(intl, viewMode);
        const { containerWidth: containerWidth, timelineFullScreen: timelineFullScreen } = this.state;
        const id = viewMode === (0, $lcvrv.VIEW_MODES).LIST ? (0, $5rYNM.SECTION_KEYS).LIST_MAIN : (0, $5rYNM.SECTION_KEYS).MAIN;
        const toolbarItems = [
            {
                id: 'pan-left-right',
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PanningControl, {
                    direction: "left"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PanningControl, {
                    direction: "right"
                })),
                isVisible: Boolean(zoomLevel && viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE)
            },
            {
                id: 'today-button',
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddt7b.default), null),
                isVisible: Boolean(zoomLevel && viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE)
            },
            {
                id: 'timeline-mode-switcher',
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimeScale, null),
                isVisible: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE
            },
            {
                id: 'legend',
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1lid.default), null),
                isVisible: true
            },
            {
                id: 'fullscreen-button',
                element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eb6jM.default), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fullscreen",
                    onToggle: this.toggleFullscreen,
                    analyticsAttributes: {
                        screenWidth: window.innerWidth,
                        screenHeight: window.innerHeight
                    },
                    withContainerStyles: false
                })
            }
        ];
        let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.getContainerRef(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$cJ2vZ.container} ${this.props.spotlight === (0, $7Jv2m.Spotlights).HeartOfPlan ? $cJ2vZ.highlight : ''}`
        }, this.props.spotlight === (0, $7Jv2m.Spotlights).HeartOfPlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
            name: (0, $7Jv2m.Spotlights).HeartOfPlan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "aria-label": "Spotlight Anchor",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                bottom: 0,
                zIndex: -1,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%'
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MFfw.DependenciesFlyoutOverlay), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
            shortcutKey: "KeyA",
            onKeyDown: this.expandFieldsShortcut
        }), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eaNnd.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Provider, {
            ref: this.providerRef
        }, !isExportMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "view-advanced-roadmaps-timeline-overlay"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "portfolio-3-plans-timeline-overlay"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZVGV.default), {
            items: toolbarItems,
            isCollapsible: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
            disabled: !timelineFullScreen || (0, $7CnHa.isDefined)(this.props.issueBeingEdited),
            noFocusGuards: true,
            autoFocus: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $cJ2vZ.mainSectionsWrap,
            // @ts-expect-error - TS2322 - Type '(node: HTMLElement) => boolean | undefined' is not assignable to type '(activeElement: HTMLElement) => boolean'.
            whiteList: (node)=>node.id === 'shifter-dialog' || document.querySelector('.atlaskit-portal-container')?.contains(node)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Container, {
            id: id,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.roadmap",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$cJ2vZ.mainSections} ${timelineFullScreen ? $cJ2vZ.fullScreen : ''}`,
            namespace: viewNamespace,
            width: containerWidth
        }, viewMode !== (0, $lcvrv.VIEW_MODES).LIST && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ.columnsTexts
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).ColumnTexts, {
            id: id,
            isExportMode: isExportMode,
            namespace: viewNamespace
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ['content-header']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            id: id,
            namespace: viewNamespace,
            // @ts-expect-error - TS2322 - Type '{ id: "main-sections"; namespace: string; sectionRenderer: ({ section, onSectionClick, index, isDragging, hoveredSectionIndex, setHovered, }: SectionRendererArgs) => Element; sectionsData: never[]; onDragStart: () => void; onDragEnd: () => void; width: number; activeCard: string; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            sectionRenderer: this.sectionHeadersRenderer,
            sectionsData: mainSectionsData,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.props.onDragEnd,
            width: containerWidth,
            activeCard: activeCard,
            spotlight: spotlight,
            // Call handleSectionsRender when the FIRST Sections renders,
            // it sets the columns widths that required by Sections.Item
            onRender: this.handleSectionsRender
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ['content-row']
        }, stickyHeader?.height ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ['sticky-headers'],
            style: {
                minHeight: 40
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            id: id,
            namespace: viewNamespace,
            // @ts-expect-error - TS2322 - Type '{ id: "main-sections"; namespace: string; minHeight: number; sectionRenderer: ({ section, onSectionClick, index, isDragging, hoveredSectionIndex, setHovered, }: SectionRendererArgs) => Element; sectionsData: never[]; onDragStart: () => void; onDragEnd: () => void; width: number; activeCard: string; height: number; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            minHeight: 40,
            sectionRenderer: this.stickyHeaderRenderer,
            sectionsData: mainSectionsData,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.props.onDragEnd,
            width: containerWidth,
            activeCard: activeCard,
            spotlight: spotlight,
            height: stickyHeader?.height || 0
        })) : null, viewMode !== (0, $lcvrv.VIEW_MODES).LIST && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ.columnsTexts
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            id: id,
            namespace: viewNamespace,
            // @ts-expect-error - TS2322 - Type '{ id: "main-sections"; namespace: string; sectionsData: never[]; sectionRenderer: ({ section }: SectionRendererArgs) => Element; width: number; onRender: (sectionsData: SectionsData) => void; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            sectionsData: mainSectionsData,
            sectionRenderer: this.fieldsColumnTextsRenderer,
            width: containerWidth,
            spotlight: spotlight
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bce9f055b9f1e61e$var$ContentScroller, {
            id: "portfolio-roadmap-table-content-scroller",
            "data-scroll": "lockable",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: isExportMode ? $cJ2vZ['content-scroller-export'] : $cJ2vZ['content-scroller'],
            onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(this.handleScroll, 16),
            ref: (node)=>{
                this.scrollElement = node;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.sectionsContainerRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$cJ2vZ.contentArea} ${isOptimizedMode ? $cJ2vZ.optimized : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                height: scopeHeight
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            // @ts-expect-error - TS2322 - Type '{ innerRef: RefObject<any>; minHeight: string; id: "main-sections"; namespace: string; sectionRenderer: ({ section, onSectionClick, index, isDragging, hoveredSectionIndex, setHovered, }: SectionRendererArgs) => Element; ... 5 more ...; activeCard: string; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            innerRef: this.sectionsRef,
            minHeight: "100%",
            id: id,
            namespace: viewNamespace,
            sectionRenderer: this.sectionRenderer,
            sectionsData: mainSectionsData,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.props.onDragEnd,
            width: containerWidth,
            height: scopeHeight,
            activeCard: activeCard,
            spotlight: spotlight
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l3ocQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cJ2vZ.horizontalScrollbar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            id: id,
            namespace: viewNamespace,
            // @ts-expect-error - TS2322 - Type '{ id: "main-sections"; namespace: string; sectionsData: never[]; sectionRenderer: ({ section }: SectionRendererArgs) => Element; width: number; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            sectionsData: mainSectionsData,
            sectionRenderer: this.horizontalScrollBarRenderer,
            width: containerWidth
        })))), hasWarningInConfiguredDates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4FqW.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueModal, null));
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MFfw.DependenciesFlyoutProvider), null, content);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ZoomLevelSync, null), (0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr') && shouldDisplayTmpCrossProjectChangeboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cm4fw.default), {
            hierarchyTitles: hierarchyTitles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Jv2m.SpotlightStepsUpdater), {
            viewMode: viewMode
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "view-advanced-roadmaps-timeline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
            experience: (0, $57dZR.getExperienceName)(isReportMode, isConfluenceMacro, isEmbed),
            analyticsSource: "portfolio3",
            application: (0, $eIp1n.JIRA_PORTFOLIO),
            edition: edition,
            additionalAttributes: {
                synthetic: (0, $8bnQD.default)()
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceFailureTracker, {
            location: "portfolio-3.simple-plans.roadmap.state-or-global-error",
            locationType: "path",
            locationPrefix: "roadmap"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: (0, $5rYNM.ERROR_REPORTING_PACKAGE).ROADMAP
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: this.sendViewRoadmapScreenAnalyticsEvent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).ROADMAP,
            packageName: (0, $5rYNM.PACKAGE_NAME),
            teamName: (0, $5rYNM.ERROR_REPORTING_TEAM),
            sendToPrivacyUnsafeSplunk: true
        }, content))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: {
                viewMode: viewMode
            }
        })), (0, $1ybV0.ff)('spork-in-product-survey') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctt5V.default), null));
    }
}
var $bce9f055b9f1e61e$export$2e2bcd8739ae039 = $bce9f055b9f1e61e$var$Roadmap;

});
parcelRegister("6ZVGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $757469c09e5a7167$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $9xXn5 = parcelRequire("9xXn5");

var $6EfnZ = parcelRequire("6EfnZ");

var $6WuW8 = parcelRequire("6WuW8");
const $757469c09e5a7167$var$renderItem = (key, component, showDivider)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
        key: key
    }, showDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$Divider, null), component);
const $757469c09e5a7167$var$Toolbar = ({ items: items, isCollapsible: isCollapsible = true })=>{
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(true);
    const toggleIsExpanded = (0, $eUqFw.useCallback)(()=>{
        if (isCollapsible) setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        isCollapsible,
        setIsExpanded
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isExpanded && !isCollapsible) setIsExpanded(true);
    }, [
        isExpanded,
        isCollapsible,
        setIsExpanded
    ]);
    const renderContent = ()=>items.filter(({ isVisible: isVisible = true })=>isVisible).map(({ id: id, element: element }, index)=>$757469c09e5a7167$var$renderItem(id, element, isCollapsible || index !== 0));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$TimelineToolbarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6WuW8.default), {
        isExpanded: isExpanded,
        collapsedWidth: "32px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($757469c09e5a7167$var$TimelineToolbarContainer, null, isCollapsible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "aais-timeline-toolbar.ui.container.expand-button",
        appearance: "subtle",
        onClick: toggleIsExpanded,
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6EfnZ))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9xXn5))), {
            label: ""
        })
    }), renderContent())));
};
var $757469c09e5a7167$export$2e2bcd8739ae039 = $757469c09e5a7167$var$Toolbar;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $757469c09e5a7167$var$Divider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkb5v6 _4t3i1tcg _1bsbt94y",
            __cmplp.className
        ])
    });
});
const $757469c09e5a7167$var$TimelineToolbarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkhp5a _1yt41b66 _1e0c1txw _19ith6cr _2rko1l7b _16qscbcv _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $757469c09e5a7167$var$TimelineToolbarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _1puhidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9xXn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f35400da13b72d7$var$_react = $6f35400da13b72d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6f35400da13b72d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6f35400da13b72d7$var$ChevronLeftCircleIcon = (props)=>/*#__PURE__*/ $6f35400da13b72d7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M13.706 9.698a.988.988 0 000-1.407 1.01 1.01 0 00-1.419 0l-2.965 2.94a1.09 1.09 0 000 1.548l2.955 2.93a1.01 1.01 0 001.42 0 .988.988 0 000-1.407l-2.318-2.297 2.327-2.307z" fill="inherit"/></g></svg>`
    }, props));
$6f35400da13b72d7$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
var $6f35400da13b72d7$var$_default = $6f35400da13b72d7$var$ChevronLeftCircleIcon;
module.exports.default = $6f35400da13b72d7$var$_default;

});

parcelRegister("6EfnZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d7269d0f6dcc3b2$var$_react = $4d7269d0f6dcc3b2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $4d7269d0f6dcc3b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $4d7269d0f6dcc3b2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="inherit"/></g></svg>`
    }, props));
$4d7269d0f6dcc3b2$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $4d7269d0f6dcc3b2$var$_default = $4d7269d0f6dcc3b2$var$ChevronRightCircleIcon;
module.exports.default = $4d7269d0f6dcc3b2$var$_default;

});

parcelRegister("6WuW8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2691faf6e55dd81a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $5LHuc = parcelRequire("5LHuc");
var $8YJjX = parcelRequire("8YJjX");
const $2691faf6e55dd81a$var$WidthExpander = ({ isExpanded: isExpanded, collapsedWidth: collapsedWidth, children: children })=>{
    const [width, setWidth] = (0, $eUqFw.useState)(isExpanded ? 'auto' : collapsedWidth);
    const prefersReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const duration = prefersReducedMotion ? 0 : (0, $5LHuc.mediumDurationMs);
    const isFirstRender = (0, $eUqFw.useRef)(true);
    const state = (0, $eUqFw.useRef)(isExpanded ? 'expanded' : 'collapsed');
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (ref.current === null) return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        }
        if (prefersReducedMotion) {
            setWidth(isExpanded ? 'auto' : collapsedWidth);
            return 0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu));
        }
        const expandedWidth = `${ref.current.offsetWidth}px`;
        if (state.current === 'transitioning') setWidth(isExpanded ? expandedWidth : collapsedWidth);
        else setWidth(expandedWidth);
        const immediate = setTimeout(()=>{
            if (!isExpanded) setWidth(collapsedWidth);
            state.current = 'transitioning';
        }, 1);
        const afterDuration = setTimeout(()=>{
            if (isExpanded) setWidth('auto');
            state.current = isExpanded ? 'expanded' : 'collapsed';
        }, (0, $5LHuc.mediumDurationMs));
        return ()=>{
            clearTimeout(immediate);
            clearTimeout(afterDuration);
        };
    }, [
        isExpanded,
        collapsedWidth,
        duration,
        prefersReducedMotion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2691faf6e55dd81a$var$OuterWrapper, {
        width: width,
        duration: duration,
        "data-testid": "aais-timeline-toolbar.ui.container.width-expander"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2691faf6e55dd81a$var$InnerWrapper, {
        ref: ref
    }, children));
};
var $2691faf6e55dd81a$export$2e2bcd8739ae039 = $2691faf6e55dd81a$var$WidthExpander;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2691faf6e55dd81a$var$OuterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { duration: duration, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width),
            "--_7nn7wk": (0, $9t7rW.default)(`width ${__cmplp.duration}ms ${(0, $d58b680a02f4d6a4$export$c07234257a03d5e9)}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu",
            __cmplp.className
        ])
    });
});
const $2691faf6e55dd81a$var$InnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';



parcelRegister("eb6jM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e63f1a697a100911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5kZSr = parcelRequire("5kZSr");

var $eQbJ4 = parcelRequire("eQbJ4");
const $e63f1a697a100911$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $eUqFw.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kZSr.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton
    });
};
$e63f1a697a100911$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $e63f1a697a100911$export$2e2bcd8739ae039 = $e63f1a697a100911$var$FullscreenButton;

});
parcelRegister("5kZSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b04dcc2d32cc90b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $22LS1 = parcelRequire("22LS1");

var $drWMe = parcelRequire("drWMe");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eDgaT = parcelRequire("eDgaT");

var $ffL85 = parcelRequire("ffL85");
const $1b04dcc2d32cc90b$var$removeFullScreenStyle = (customRefs)=>{
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $1b04dcc2d32cc90b$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreen, renderAsResponsiveButton: renderAsResponsiveButton = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const customRefElements = (0, $eUqFw.useRef)(null);
    const globalStyle = document.createElement('style');
    const handleKeysInFullScreen = (0, $eUqFw.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (navigationShortcuts.includes(e.key)) {
            onToggle(true, globalStyle);
            const customRefs = customRefElements.current;
            $1b04dcc2d32cc90b$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $eUqFw.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        globalStyle.id = 'fullscreen-global-style';
        globalStyle.appendChild(hiddenStylesNode);
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        const analyticsAttributes = {
            ...extraAnalyticsAttributes,
            expandToFullscreen: !isFullscreen
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
        onToggle(isFullscreen, globalStyle);
        if (isFullscreen) $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
        else createFullScreenStyle();
    };
    (0, $eUqFw.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
        return ()=>$1b04dcc2d32cc90b$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const colorFf = (0, $1ybV0.ff)('ftfns-19-header-update-share-button-icon-colour-token_g40ho') ? "var(--ds-icon, #44546F)" : undefined;
    const renderButtonWithTooltip = ()=>{
        if (renderAsResponsiveButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $ffL85.default).exitFullScreen) : formatMessage((0, $ffL85.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($drWMe))) : (0, (/*@__PURE__*/$parcel$interopDefault($22LS1))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage(isFullscreen ? (0, $ffL85.default).exitFullScreen : (0, $ffL85.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($drWMe))), {
                primaryColor: colorFf,
                label: formatMessage((0, $ffL85.default).exitFullScreen)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
                primaryColor: colorFf,
                label: formatMessage((0, $ffL85.default).enterFullScreen)
            })
        }));
    };
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b04dcc2d32cc90b$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip()) : renderButtonWithTooltip();
};
var $1b04dcc2d32cc90b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1b04dcc2d32cc90b$var$FullscreenButton;
const $1b04dcc2d32cc90b$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.587 6.003H15A1 1 0 0115 4h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0V7.411l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305zM7.413 17.997H9A1 1 0 019 20H5.1l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 014 18.946a1.12 1.12 0 010-.048v-3.896a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;
module.exports.default = $17d0e6b497755428$var$_default;

});

parcelRegister("drWMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cab63de7a2a3a02$var$_react = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9cab63de7a2a3a02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $9cab63de7a2a3a02$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.413 8.997H18A1 1 0 0118 11h-3.9l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 0113 9.946a1.12 1.12 0 010-.048V6.002a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305zm-8.826 6.006H6A1 1 0 016 13h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0v-1.587l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9cab63de7a2a3a02$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $9cab63de7a2a3a02$var$_default = $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon;
module.exports.default = $9cab63de7a2a3a02$var$_default;

});

parcelRegister("eDgaT", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $ad0d3127c7a37420$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $ad0d3127c7a37420$export$50fd17babcd996ef);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
var $fI650 = parcelRequire("fI650");
var $8GeQ6 = parcelRequire("8GeQ6");

var $9Amv1 = parcelRequire("9Amv1");

var $5ARvW = parcelRequire("5ARvW");

var $8cU5f = parcelRequire("8cU5f");

const $ad0d3127c7a37420$var$ResponsiveButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint, appearance: appearance, testId: testId, isLink: isLink, ...restProps } = props;
    const CollapsedButtonComponent = isLink ? (0, $8GeQ6.default) : (0, $j9fWg.default);
    const ExpandedButtonComponent = isLink ? (0, $fI650.default) : (0, $6zOB7.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CollapsedButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        /* @ts-expect-error TS2551: Property 'href' does not exist on type ResponsiveButtonProps */ ...isLink && {
            href: restProps.href
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandedButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        /* @ts-expect-error TS2551: Property 'href' does not exist on type ResponsiveButtonProps */ ...isLink && {
            href: restProps.href
        }
    }, label)));
});
const $ad0d3127c7a37420$export$47e82d861696e68c = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0d3127c7a37420$var$ResponsiveButtonWrapper, {
        ref: ref,
        ...props
    }));
const $ad0d3127c7a37420$export$50fd17babcd996ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad0d3127c7a37420$var$ResponsiveButtonWrapper, {
        isLink: true,
        ref: ref,
        ...props
    }));

});
parcelRegister("8GeQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b9b21212202cc40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $4kMup = parcelRequire("4kMup");

var $8cU5f = parcelRequire("8cU5f");

var $cxipd = parcelRequire("cxipd");
const $3b9b21212202cc40$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, UNSAFE_size: UNSAFE_size, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $cxipd.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId,
        UNSAFE_size: UNSAFE_size
    });
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
            ...rest,
            "aria-labelledby": baseProps['aria-labelledby'],
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                rest.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                rest.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                rest.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                rest.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                rest.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                rest.onBlur?.(e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                baseProps?.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            ref: (ref)=>{
                baseProps.ref(ref);
                triggerProps?.ref?.(ref);
            },
            // Base props only
            xcss: baseProps.xcss,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            /**
						 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
						 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
						 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined
        }, baseProps.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...rest,
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $3b9b21212202cc40$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($3b9b21212202cc40$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/link-icon-button/usage)
 */ const $3b9b21212202cc40$var$LinkIconButton = /*#__PURE__*/ (0, $eUqFw.memo)($3b9b21212202cc40$var$WithRef);
var $3b9b21212202cc40$export$2e2bcd8739ae039 = $3b9b21212202cc40$var$LinkIconButton;

});

parcelRegister("5ARvW", function(module, exports) {

$parcel$export(module.exports, "Show", () => $c749d80f6b8dab23$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
function $c749d80f6b8dab23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c749d80f6b8dab23$var$showAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$showBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $c749d80f6b8dab23$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c749d80f6b8dab23$var$defaultHiddenStyles,
            above && $c749d80f6b8dab23$var$showAboveQueries[above],
            below && $c749d80f6b8dab23$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("9SiaN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $gnQiH = parcelRequire("gnQiH");

var $4Ywu9 = parcelRequire("4Ywu9");
const $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("gnQiH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $8ce21554f3c8bfb7$export$2d293d9871c38e91);
const $8ce21554f3c8bfb7$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $8ce21554f3c8bfb7$export$2d293d9871c38e91 = Object.keys($8ce21554f3c8bfb7$export$e5ee4fe8b989fd09);
const $8ce21554f3c8bfb7$export$b7ed752a57b4177b = $8ce21554f3c8bfb7$export$2d293d9871c38e91[0];

});



const $d189205948d5eb28$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("ffL85", function(module, exports) {

$parcel$export(module.exports, "default", () => $20d24ea35e7158d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $20d24ea35e7158d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});



parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lMaVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $89bf1367d6f77870$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $5OdRK = parcelRequire("5OdRK");
var $kDrtX = parcelRequire("kDrtX");
var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $lNNXV = parcelRequire("lNNXV");
var $1TrR5 = parcelRequire("1TrR5");

var $n8xNY = parcelRequire("n8xNY");

var $gwgHy = parcelRequire("gwgHy");

var $bj39n = parcelRequire("bj39n");

var $66xCB = parcelRequire("66xCB");

var $6B5Ru = parcelRequire("6B5Ru");

var $ezuVy = parcelRequire("ezuVy");

var $gcqc6 = parcelRequire("gcqc6");

var $hwshf = parcelRequire("hwshf");

var $6B26M = parcelRequire("6B26M");

var $hOFtB = parcelRequire("hOFtB");
// eslint-disable-next-line jira/react/no-class-components
class $89bf1367d6f77870$var$Sections extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { width: width } = this.props;
        if (width > 0) this.onResize({
            width: width
        });
    }
    shouldComponentUpdate(nextProps) {
        const isParentInSync = !this.parent && !nextProps.linkToParent || this.parent && this.parent.id === nextProps.linkToParent;
        const propsEqual = $5OdRK.default(this.props, nextProps);
        if (this.props.id !== nextProps.id) this.didPerformResizeAtLeastOnce = false;
        return !!(isParentInSync && !propsEqual);
    }
    componentDidUpdate(prevProps) {
        const { id: id, totalWidth: totalWidth, sectionsData: sectionsData, width: width, isFitParent: isFitParent = true } = this.props;
        const toIds = $cQGVO.default($f7Op5.default('id'));
        if (!$5OdRK.default(toIds(sectionsData), toIds(prevProps.sectionsData))) this.props.onLengthChange({
            id: id,
            width: totalWidth,
            sectionsData: sectionsData,
            parent: this.parent,
            isFitParent: isFitParent
        });
        // shouldComponentUpdate prevents the component update until the parent IDs are in sync.
        // But by the time parent IDs comes to sync, there might not be a change in width or id anymore
        // so the resize might not be called at all. The 'didPerformResizeAtLeastOnce' flag here ensures
        // at-least we call resize once for sections component after the parent IDs are in sync.
        if (width !== prevProps.width || id !== prevProps.id || !this.didPerformResizeAtLeastOnce) {
            this.onResize({
                width: width
            });
            this.didPerformResizeAtLeastOnce = true;
        }
    }
    render() {
        const { linkToParent: linkToParent = false, sectionsData: sectionsData, onRender: onRender } = this.props;
        if (onRender) onRender(sectionsData);
        return linkToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66xCB.default).Consumer, null, (parent)=>this.content(parent)) : this.content();
    }
    constructor(...args){
        super(...args);
        // The section component should at-least resize once to generate it's initial state in the redux store.
        // This flag is to keep track of the mandatory resize call.
        this.didPerformResizeAtLeastOnce = false;
        this.onDrag = ({ index: index, from: from, to: to })=>{
            const { sectionsData: sectionsData, id: id, totalWidth: totalWidth, isFitParent: isFitParent = true } = this.props;
            const delta = to.x - from.x;
            if (delta === 0) return;
            this.props.onDrag({
                id: id,
                index: index,
                delta: delta,
                sectionsData: sectionsData,
                totalWidth: totalWidth,
                parent: this.parent,
                isFitParent: isFitParent
            });
        };
        this.onDragStart = (index)=>{
            const { id: id, sectionsData: sectionsData, savePreDragWidths: savePreDragWidths, onDragStart: onDragStart, onDragStartOwn: onDragStartOwn } = this.props;
            onDragStartOwn(id);
            savePreDragWidths(sectionsData[index].id);
            if (onDragStart) onDragStart();
        };
        this.onDragEnd = ()=>{
            const { id: id, onDragEnd: onDragEnd, onDragEndOwn: onDragEndOwn } = this.props;
            onDragEndOwn(id);
            if (onDragEnd) onDragEnd();
        };
        this.onCollapsedSectionClick = (index)=>{
            const { sectionsData: sectionsData, id: id, totalWidth: totalWidth, isFitParent: isFitParent = true } = this.props;
            this.props.onDrag({
                id: id,
                index: index,
                sectionsData: sectionsData,
                totalWidth: totalWidth,
                parent: this.parent,
                isFitParent: isFitParent
            });
        };
        this.onResize = ({ width: width })=>{
            const { sectionsData: sectionsData, id: id, isFitParent: isFitParent = true, minWidth: minWidth } = this.props;
            this.props.onResize({
                id: id,
                width: width,
                sectionsData: sectionsData,
                parent: this.parent,
                isFitParent: isFitParent,
                minWidth: minWidth
            });
        };
        // this has been used in the src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/roadmap/view.tsx
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.setOnboardingWidth = ()=>{
            const { id: id, sectionsData: sectionsData, width: width } = this.props;
            this.props.setOnboardingWidth(id, sectionsData, width);
        };
        // this has been used in the src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/roadmap/view.tsx
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.collapseSection = (index)=>{
            const { sectionsData: sectionsData, id: id, totalWidth: totalWidth, isFitParent: isFitParent = true } = this.props;
            const section = sectionsData[index];
            const delta = section.minWidth - section.width;
            this.props.savePreDragWidths(sectionsData[index].id);
            this.props.onDrag({
                id: id,
                index: index,
                sectionsData: sectionsData,
                delta: delta,
                totalWidth: totalWidth,
                parent: this.parent,
                isFitParent: isFitParent
            });
        };
        this.content = (parent)=>{
            this.parent = parent;
            const { id: id, sectionsData: sectionsData, sectionRenderer: sectionRenderer, height: height, minHeight: minHeight, setActiveSeparator: setActiveSeparator, activeSeparatorIndex: activeSeparatorIndex, totalWidth: totalWidth, isDragging: isDragging, hoveredSectionIndex: hoveredSectionIndex, setHovered: setHovered } = this.props;
            const children = [];
            const columnTexts = [];
            for(let i = 0; i < sectionsData.length; i++){
                const sectionEl = sectionRenderer({
                    section: sectionsData[i],
                    onSectionClick: this.onCollapsedSectionClick,
                    index: i,
                    isDragging: isDragging,
                    hoveredSectionIndex: hoveredSectionIndex,
                    setHovered: setHovered
                });
                const { title: title, icon: icon, tooltip: tooltip, width: width = 0, minWidth: minWidth, collapsible: collapsible } = sectionEl.props;
                const visible = collapsible && !!width && width <= minWidth;
                columnTexts.push({
                    title: title,
                    icon: icon,
                    tooltip: tooltip,
                    width: width,
                    visible: visible
                });
                children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66xCB.default).Provider, {
                    key: sectionsData[i].id,
                    value: {
                        id: id,
                        index: i,
                        sectionsData: sectionsData,
                        totalWidth: totalWidth,
                        parent: parent
                    }
                }, sectionEl));
                if (i !== sectionsData.length - 1) children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hwshf.default), {
                    testId: `separator-${sectionsData[i].id}`,
                    key: `separator-${sectionsData[i].id}`,
                    onDrag: this.onDrag,
                    onDragStart: this.onDragStart,
                    onDragEnd: this.onDragEnd,
                    index: i,
                    setActiveSeparator: setActiveSeparator,
                    isActive: activeSeparatorIndex === i,
                    isDragging: isDragging
                }));
            }
            const shouldUpdateColumnTexts = columnTexts.every((it)=>it.title);
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6B26M.sections,
                style: {
                    height: height,
                    minHeight: minHeight
                }
            }, children, shouldUpdateColumnTexts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwgHy.Updater), {
                id: id,
                columnTexts: columnTexts
            })));
        };
    }
}
const $89bf1367d6f77870$var$mapStateToProps = (state, ownProps)=>{
    const sectionState = state.sections[ownProps.id] || {};
    const { widths: widths = {}, totalWidth: totalWidth, activeSeparatorIndex: activeSeparatorIndex, hoveredSectionIndex: hoveredSectionIndex } = sectionState;
    const sectionsData = ownProps.sectionsData.map((section)=>{
        const width = $kDrtX.default(widths[section.id]) ? section.initialWidth : widths[section.id];
        return {
            ...section,
            width: width
        };
    });
    return {
        activeSeparatorIndex: activeSeparatorIndex,
        sectionsData: sectionsData,
        totalWidth: totalWidth,
        isDragging: state.isDragging,
        hoveredSectionIndex: hoveredSectionIndex
    };
};
const $89bf1367d6f77870$var$sectionStateObj = {};
const $89bf1367d6f77870$var$widthObj = {};
const $89bf1367d6f77870$var$mapStateToPropsFactory = ()=>{
    const getSectionsDataSelectorInstance = (0, $5iWql.default)((sectionsData, widths)=>sectionsData.map((section)=>{
            const width = $kDrtX.default(widths[section.id]) ? section.initialWidth : widths[section.id];
            return {
                ...section,
                width: width
            };
        }));
    return (state, ownProps)=>{
        const sectionState = state.sections[ownProps.id] || $89bf1367d6f77870$var$sectionStateObj;
        const { widths: widths = $89bf1367d6f77870$var$widthObj, totalWidth: totalWidth, activeSeparatorIndex: activeSeparatorIndex, hoveredSectionIndex: hoveredSectionIndex } = sectionState;
        const sectionsData = getSectionsDataSelectorInstance(ownProps.sectionsData, widths);
        return {
            activeSeparatorIndex: activeSeparatorIndex,
            sectionsData: sectionsData,
            totalWidth: totalWidth,
            isDragging: state.isDragging,
            hoveredSectionIndex: hoveredSectionIndex
        };
    };
};
const $89bf1367d6f77870$var$mapDispatchToProps = (dispatch, ownProps)=>({
        setActiveSeparator: (index)=>{
            dispatch({
                type: (0, $n8xNY.SET_ACTIVE_SEPARATOR),
                id: ownProps.id,
                index: index
            });
        },
        setHovered: (index)=>{
            dispatch({
                type: (0, $n8xNY.SET_IS_HOVERED),
                id: ownProps.id,
                index: index
            });
        },
        onResize: (payload)=>{
            dispatch({
                type: (0, $n8xNY.ON_RESIZE),
                payload: payload
            });
        },
        onDrag: (payload)=>{
            dispatch({
                type: (0, $n8xNY.ON_DRAG),
                payload: payload
            });
        },
        onDragStartOwn: (payload)=>{
            dispatch({
                type: (0, $n8xNY.ON_DRAG_START),
                payload: payload
            });
        },
        onDragEndOwn: (payload)=>{
            dispatch({
                type: (0, $n8xNY.ON_DRAG_END),
                payload: payload
            });
        },
        onLengthChange: (payload)=>{
            dispatch({
                type: (0, $n8xNY.ON_LENGTH_CHANGE),
                payload: payload
            });
        },
        savePreDragWidths: (sectionId)=>{
            dispatch({
                type: (0, $n8xNY.SAVE_PREDRAG_WIDTHS),
                id: ownProps.id,
                sectionId: sectionId
            });
        },
        setOnboardingWidth: (id, sectionsData, width)=>{
            dispatch({
                type: (0, $n8xNY.SET_ONBOARDING_WIDTH),
                id: id,
                sectionsData: sectionsData,
                width: width
            });
        }
    });
const $89bf1367d6f77870$var$connect = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToPropsFn, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToPropsFn, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $lNNXV.connect)(mapStateToPropsFn, mapDispatchToPropsFn, mergeProps, {
        ...options,
        context: (0, $66xCB.SectionContext),
        storeKey: $hOFtB.storeKey
    });
const $89bf1367d6f77870$var$Connected = $89bf1367d6f77870$var$connect((0, $1TrR5.functionWithFFRedux)($89bf1367d6f77870$var$mapStateToPropsFactory, // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 2 or more, but got 0.
$89bf1367d6f77870$var$mapStateToProps), $89bf1367d6f77870$var$mapDispatchToProps, null, {
    storeKey: $hOFtB.storeKey
})(({ innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89bf1367d6f77870$var$Sections, {
        ref: innerRef,
        ...props
    }));
const $89bf1367d6f77870$var$NameSpaced = (0, $ezuVy.default)($89bf1367d6f77870$var$Connected);
/**
 * SectionsSubscriber
 *
 * The purpose of this is to expose the internal redux
 * For example, we need to react to collapsible, one way is to add a onCollapse callback to sections
 * However that is less flexible and not as scalable. Exposing the store will just give us a bit more power to adapt
 * to change. We already have a Provider so might as well have a Subscriber
 *
 * Keeping this subscriber generic, you can create specific selecting subscribers in your actual app to pluck the data you need
 * */ const $89bf1367d6f77870$var$SubscriberHoc = ({ sectionsData: sectionsData, children: children })=>children ? children({
        sectionsData: sectionsData
    }) : null;
const $89bf1367d6f77870$export$60959659b2c22881 = $89bf1367d6f77870$var$connect((state, { children: children })=>{
    const sectionsData = state.sections || null;
    return {
        sectionsData: sectionsData,
        children: children
    };
}, null, null, {
    storeKey: $hOFtB.storeKey
})($89bf1367d6f77870$var$SubscriberHoc);
Object.assign($89bf1367d6f77870$var$NameSpaced, {
    Provider: $gcqc6.default,
    Subscriber: $89bf1367d6f77870$export$60959659b2c22881,
    Container: $bj39n.default,
    ColumnTexts: $gwgHy.default,
    Item: $6B5Ru.default
});
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$89bf1367d6f77870$export$2e2bcd8739ae039 = $89bf1367d6f77870$var$NameSpaced;

});
parcelRegister("n8xNY", function(module, exports) {

$parcel$export(module.exports, "ON_DRAG", () => $7a7a122a7a269f25$export$7849df7ba8e5ea3f);
$parcel$export(module.exports, "ON_DRAG_START", () => $7a7a122a7a269f25$export$c7c6e63d41a902ee);
$parcel$export(module.exports, "ON_DRAG_END", () => $7a7a122a7a269f25$export$2448521d2e69cf7a);
$parcel$export(module.exports, "ON_LENGTH_CHANGE", () => $7a7a122a7a269f25$export$45df1b4a50bcfeb6);
$parcel$export(module.exports, "ON_RESIZE", () => $7a7a122a7a269f25$export$271c20d9912fa5c0);
$parcel$export(module.exports, "SAVE_PREDRAG_WIDTHS", () => $7a7a122a7a269f25$export$878068af2d78ca2);
$parcel$export(module.exports, "SET_ACTIVE_SEPARATOR", () => $7a7a122a7a269f25$export$f36b50f14b42660);
$parcel$export(module.exports, "SET_IS_HOVERED", () => $7a7a122a7a269f25$export$dcf184c2cc5af73e);
$parcel$export(module.exports, "SET_ONBOARDING_WIDTH", () => $7a7a122a7a269f25$export$6979e33bafed5ff7);
const $7a7a122a7a269f25$export$7849df7ba8e5ea3f = 'ON_DRAG';
const $7a7a122a7a269f25$export$c7c6e63d41a902ee = 'ON_DRAG_START';
const $7a7a122a7a269f25$export$2448521d2e69cf7a = 'ON_DRAG_END';
const $7a7a122a7a269f25$export$45df1b4a50bcfeb6 = 'ON_LENGTH_CHANGE';
const $7a7a122a7a269f25$export$271c20d9912fa5c0 = 'ON_RESIZE';
const $7a7a122a7a269f25$export$878068af2d78ca2 = 'SAVE_PREDRAG_WIDTHS';
const $7a7a122a7a269f25$export$f36b50f14b42660 = 'SET_ACTIVE_SEPARATOR';
const $7a7a122a7a269f25$export$dcf184c2cc5af73e = 'SET_IS_HOVERED';
const $7a7a122a7a269f25$export$6979e33bafed5ff7 = 'SET_ONBOARDING_WIDTH';
const $7a7a122a7a269f25$export$45b39e67d4ce4921 = (payload)=>({
        type: $7a7a122a7a269f25$export$271c20d9912fa5c0,
        payload: payload
    });
const $7a7a122a7a269f25$export$11a07b18d6f8f6d2 = (payload)=>({
        type: $7a7a122a7a269f25$export$7849df7ba8e5ea3f,
        payload: payload
    });
const $7a7a122a7a269f25$export$8585243912055e14 = (id, sectionsData, width)=>({
        type: $7a7a122a7a269f25$export$6979e33bafed5ff7,
        sectionsData: sectionsData,
        id: id,
        width: width
    });
const $7a7a122a7a269f25$export$97e60746ac0856c6 = (id, sectionId)=>({
        type: $7a7a122a7a269f25$export$878068af2d78ca2,
        id: id,
        sectionId: sectionId
    });
const $7a7a122a7a269f25$export$e8e14da8a466b0a0 = (payload)=>({
        type: $7a7a122a7a269f25$export$45df1b4a50bcfeb6,
        payload: payload
    });

});

parcelRegister("gwgHy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $15bca4560a9110c8$export$2881499e37b75b9a);
$parcel$export(module.exports, "Updater", () => $15bca4560a9110c8$export$3386beb5bc3bfa);
$parcel$export(module.exports, "default", () => $15bca4560a9110c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");

var $g4Vkx = parcelRequire("g4Vkx");

var $bj39n = parcelRequire("bj39n");

var $ezuVy = parcelRequire("ezuVy");

var $6B26M = parcelRequire("6B26M");

var $kYJcj = parcelRequire("kYJcj");
const $15bca4560a9110c8$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    value: {},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    update: ()=>{}
});
function $15bca4560a9110c8$export$2881499e37b75b9a(props) {
    const [value, setValue] = (0, $eUqFw.useState)({});
    const update = (id, columnTexts)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        setValue((value)=>({
                ...value,
                [id]: columnTexts
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($15bca4560a9110c8$var$Context.Provider, {
        ...props,
        value: {
            value: value,
            update: update
        }
    });
}
function $15bca4560a9110c8$export$3386beb5bc3bfa({ id: id, columnTexts: columnTexts }) {
    const { value: value, update: update } = (0, $eUqFw.useContext)($15bca4560a9110c8$var$Context);
    (0, $eUqFw.useEffect)(()=>{
        const currColumnTexts = value[id];
        if (!$5OdRK.default(columnTexts, currColumnTexts)) update(id, columnTexts);
    }, [
        columnTexts,
        id,
        update,
        value
    ]);
    return null;
}
function $15bca4560a9110c8$var$ColumnText({ icon: icon, isExportMode: isExportMode, title: title = '', tooltip: tooltip, visible: visible, width: // as far as I could test, width is always defined but Flow thinks otherwise, so I set it to 24px by default
width = 24 }) {
    /**
   * When a field is collapsed in the Fields section of the roadmap, we rotate the name in order to render it vertically.
   * However, this is not supported well by html2canvas which crops the text after a few pixels, so in export mode, we use a svg to render the field name.
   */ if (isExportMode) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $6B26M.columnText,
        style: {
            width: width
        }
    }, visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: `var(--ds-blanket, ${(0, $g4Vkx.default).N200})`,
        fontFamily: "sans-serif",
        fontSize: "10px",
        fontWeight: "bold",
        /**
           * Collapsed columns are either:
           * - 32px wide (when all fields are collapsed and "FIELDS" is the only column)
           * - 24px wide (for a collapsed field)
           * therefore we use the width to move the text horizontally and center it into its column
           */ transform: `translate(${((width || 24) - 8) / 2}, 22) rotate(90)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textTransform: 'uppercase'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", null, title, " "), icon !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", null, "[D]") : null))));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $6B26M.columnText,
        style: {
            width: width
        }
    }, visible && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $6B26M.columnTextTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJcj.default), {
        icon: icon,
        tooltip: tooltip,
        mode: "collapsed"
    }, title))));
}
function $15bca4560a9110c8$var$ColumnTexts({ id: id, isExportMode: isExportMode = false, ...otherProps }) {
    const columnTexts = (0, $eUqFw.useContext)($15bca4560a9110c8$var$Context).value[id];
    if (!columnTexts) return null;
    return(// @ts-expect-error - TS2322 - Type '{ children: Element[]; id: string; styleName: string; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<SectionContainerProps, "width" | "dispatch"> & Props, any, any>> & Readonly<...> & Readonly<...>'.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bj39n.Container), {
        ...otherProps,
        id: id,
        className: $6B26M.columnTexts
    }, columnTexts.map((columnText, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($15bca4560a9110c8$var$ColumnText, {
            key: idx,
            isExportMode: isExportMode,
            ...columnText
        }))));
}
var $15bca4560a9110c8$export$2e2bcd8739ae039 = (0, $ezuVy.default)($15bca4560a9110c8$var$ColumnTexts);

});
parcelRegister("bj39n", function(module, exports) {

$parcel$export(module.exports, "Container", () => $55ae0ca425a88202$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $55ae0ca425a88202$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $66xCB = parcelRequire("66xCB");

var $ezuVy = parcelRequire("ezuVy");

var $hOFtB = parcelRequire("hOFtB");
function $55ae0ca425a88202$var$SectionsContainer({ id: id, width: width, style: style, dispatch: dispatch, linkToParent: linkToParent, ...otherProps }) {
    const finalStyle = {
        ...style,
        width: width
    };
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...otherProps,
        style: finalStyle
    });
}
const $55ae0ca425a88202$var$mapStateToProps = (state, { id: id, width: width })=>{
    const sectionState = state.sections[id] || {};
    const { widths: widths = {} } = sectionState;
    const sectionsWidth = Object.keys(widths).reduce((acc, key)=>acc + widths[key], 0);
    return {
        width: width ?? sectionsWidth
    };
};
const $55ae0ca425a88202$var$connect = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToPropsFn, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $lNNXV.connect)(mapStateToPropsFn, mapDispatchToProps, mergeProps, {
        ...options,
        context: (0, $66xCB.SectionContext),
        storeKey: $hOFtB.storeKey
    });
const $55ae0ca425a88202$export$42a852a2b6b56249 = $55ae0ca425a88202$var$connect($55ae0ca425a88202$var$mapStateToProps, null, null, {
    storeKey: $hOFtB.storeKey
})($55ae0ca425a88202$var$SectionsContainer);
var // The default export enhances the Container component with namespaced IDs. This export is used within the Portfolio application.
$55ae0ca425a88202$export$2e2bcd8739ae039 = (0, $ezuVy.default)($55ae0ca425a88202$export$42a852a2b6b56249);

});
parcelRegister("66xCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e033a2e615431c5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SectionContext", () => $8e033a2e615431c5$export$d40e14dec8b060a8);

var $eUqFw = parcelRequire("eUqFw");
const $8e033a2e615431c5$var$defaultSectionsContext = {
    id: '',
    index: 0,
    sectionsData: [],
    totalWidth: 0,
    parent: null
};
var $8e033a2e615431c5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)($8e033a2e615431c5$var$defaultSectionsContext);
const $8e033a2e615431c5$export$d40e14dec8b060a8 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("ezuVy", function(module, exports) {

$parcel$export(module.exports, "getSectionNamespace", () => $da0e469922d80c80$export$92bf67045c5ea0ed);
$parcel$export(module.exports, "default", () => $da0e469922d80c80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $da0e469922d80c80$export$92bf67045c5ea0ed(namespace, id) {
    return `${namespace}-${id}`;
}
function $da0e469922d80c80$export$2e2bcd8739ae039(Component) {
    return ({ namespace: namespace, id: id, linkToParent: linkToParent, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            id: $da0e469922d80c80$export$92bf67045c5ea0ed(namespace, id),
            linkToParent: linkToParent !== null && linkToParent !== undefined && `${namespace}-${linkToParent}`
        });
}

});

parcelRegister("hOFtB", function(module, exports) {

$parcel$export(module.exports, "storeKey", () => $07a3d4df45f99582$export$67bdc3ac2df6c0d1);
$parcel$export(module.exports, "getSectionsWidth", () => $07a3d4df45f99582$export$907b64f9062237ff);
$parcel$export(module.exports, "scaleLeftSections", () => $07a3d4df45f99582$export$26a1814b1ecd6bb8);
$parcel$export(module.exports, "scaleRightSections", () => $07a3d4df45f99582$export$781d70658d6d3ad8);
$parcel$export(module.exports, "getExpansionDelta", () => $07a3d4df45f99582$export$a0ddbc34b1c2e365);
$parcel$export(module.exports, "getAvailableDelta", () => $07a3d4df45f99582$export$686428d4ab44795d);
$parcel$export(module.exports, "getDeltaFromRightFlexiSection", () => $07a3d4df45f99582$export$f0de9b1cb3790f9e);

var $kgbOw = parcelRequire("kgbOw");
const $07a3d4df45f99582$export$67bdc3ac2df6c0d1 = '@portfolio/common/sections2';
const $07a3d4df45f99582$export$907b64f9062237ff = (sections)=>sections.reduce((width, section)=>width + section.width, 0);
const $07a3d4df45f99582$export$99446ef969a14435 = (section)=>!section.isFixed && section.width && section.width > section.minWidth;
const $07a3d4df45f99582$export$26a1814b1ecd6bb8 = (delta, sections)=>{
    if (sections.length === 0) return sections;
    let remainingDelta = delta;
    // Reverse sections to change size of the rightmost ones first.
    const result = $kgbOw.default(sections).reverse();
    // Treat the rightmost section on the left from separator as the dragged one and ignore its
    // isFixed flag.
    for (const section of result)if (section.width + remainingDelta < section.minWidth) {
        // Section can accomodate only part of the remaining delta.
        // Because this condition could happen only when sections are shrinking,
        // and delta is negative, it is "reduced" by adding positive width difference.
        remainingDelta += section.width - section.minWidth;
        section.width = section.minWidth;
    } else {
        // Section can absord the rest of the remainingDelta.
        section.width += remainingDelta;
        break;
    }
    return result.reverse();
};
const $07a3d4df45f99582$export$781d70658d6d3ad8 = (delta, sections, keepTotalWidth)=>{
    let remainingDelta = delta;
    const result = $kgbOw.default(sections);
    // First pass: try to change width of resizable sections only.
    for (const section of result)if ($07a3d4df45f99582$export$99446ef969a14435(section)) {
        if (section.width - remainingDelta < section.minWidth) {
            // Section can accomodate only part of the remaining delta.
            remainingDelta -= section.width - section.minWidth;
            section.width = section.minWidth;
        } else {
            // Section can absorb the rest of the delta.
            section.width -= remainingDelta;
            remainingDelta = 0;
            break;
        }
    }
    // Second pass: try to keep total width by any price except going below minWidth.
    if (keepTotalWidth && remainingDelta !== 0) {
        for (const section of result)if (section.width - remainingDelta < section.minWidth) {
            // Section can accomodate only part of the remaining delta.
            remainingDelta -= section.width - section.minWidth;
            section.width = section.minWidth;
        } else {
            // Section can absord the rest of the delta.
            section.width -= remainingDelta;
            remainingDelta = 0;
            break;
        }
    }
    // It may happen that remainingDelta is still not 0 by this point.
    // We don't have a good solution for this case yet.
    return result;
};
const $07a3d4df45f99582$export$a0ddbc34b1c2e365 = ({ id: id, width: width, initialWidth: initialWidth }, sections)=>{
    if (sections.preDragWidths && sections.preDragWidths[id]) return sections.preDragWidths[id] - width;
    return initialWidth - width;
};
const $07a3d4df45f99582$export$686428d4ab44795d = ({ index: index, parent: parent, sectionsData: sectionsData }, direction, isFitParent)=>{
    if (!isFitParent) // No restriction on available delta
    return Infinity;
    // Treat the rightmost section on the left from separator as the dragged one and ignore its isFixed flag.
    const draggedSection = sectionsData[index];
    const sections = direction < 0 ? sectionsData.slice(0, index + 1) : sectionsData.slice(index + 1);
    const availableDelta = sections.reduce((delta, section)=>delta + (!section.isFixed || section === draggedSection ? section.width - section.minWidth : 0), 0);
    const parentAvailableDelta = parent ? $07a3d4df45f99582$export$686428d4ab44795d(parent, direction, isFitParent) : 0;
    return direction * availableDelta + parentAvailableDelta;
};
const $07a3d4df45f99582$export$f0de9b1cb3790f9e = (sections)=>{
    const section = sections.slice().reverse().find(({ isFixed: isFixed })=>!isFixed);
    return section ? section.width - section.minWidth : 0;
};

});
parcelRegister("kgbOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebfe7741ca508008$export$2e2bcd8739ae039);

var $4jaPx = parcelRequire("4jaPx");

var $eSWTK = parcelRequire("eSWTK");
/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $ebfe7741ca508008$var$clone = /*#__PURE__*/ (0, $eSWTK.default)(function clone(value) {
    return value != null && typeof value.clone === 'function' ? value.clone() : (0, $4jaPx.default)(value, [], [], true);
});
var $ebfe7741ca508008$export$2e2bcd8739ae039 = $ebfe7741ca508008$var$clone;

});
parcelRegister("4jaPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3231566f8a64b239$export$2e2bcd8739ae039);

var $4oABC = parcelRequire("4oABC");

var $cy5HJ = parcelRequire("cy5HJ");
function $3231566f8a64b239$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? $3231566f8a64b239$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $cy5HJ.default)(value)){
        case 'Object':
            return copy({});
        case 'Array':
            return copy([]);
        case 'Date':
            return new Date(value.valueOf());
        case 'RegExp':
            return (0, $4oABC.default)(value);
        default:
            return value;
    }
}

});
parcelRegister("4oABC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3335cc7ae4f8940c$export$2e2bcd8739ae039);
function $3335cc7ae4f8940c$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

});






parcelRegister("6B5Ru", function(module, exports) {

$parcel$export(module.exports, "default", () => $94ee9ffaa91463ed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $fmBR7 = parcelRequire("fmBR7");

var $6B26M = parcelRequire("6B26M");
// eslint-disable-next-line jira/react/no-class-components
class $94ee9ffaa91463ed$var$SectionsItem extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            collapsible: true
        };
    }
    render() {
        const { width: width = 0, minWidth: minWidth, children: children, title: title = '', collapsible: collapsible, hoveredSectionIndex: hoveredSectionIndex, index: index, backgroundColor: backgroundColor = '', id: id } = this.props;
        let innerView = children;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        let onClick = ()=>{};
        let styleName = $6B26M.section;
        let styles = {
            backgroundColor: backgroundColor
        };
        if (width > 0) {
            styles = {
                ...styles,
                width: width
            };
            if (collapsible && width <= minWidth) {
                styleName += ` ${$6B26M.collapsedSection}`;
                onClick = this.onSectionClick;
                if (hoveredSectionIndex === index) styles = {
                    ...styles,
                    backgroundColor: `var(--ds-border, ${(0, $PdmhA).N30})`
                };
                const dataName = title ? `collapsed-section-${title}` : 'collapsed-section';
                innerView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
                    onHoverChanged: this.onSetHovered
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-name": dataName,
                    style: styles
                }));
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleName,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: styles,
            onClick: onClick,
            role: "none",
            id: `portfolio-3-common.sections.item.${id}`,
            "data-testid": `portfolio-3-common.sections.item.${id}`
        }, innerView);
    }
    constructor(...args){
        super(...args);
        this.onSectionClick = ()=>{
            const { onClick: onClick, index: index, setHovered: setHovered } = this.props;
            onClick(index);
            setHovered(null);
        };
        this.onSetHovered = (isHovered)=>{
            const { setHovered: setHovered, index: index } = this.props;
            isHovered ? setHovered(index) : setHovered(null);
        };
    }
}
var $94ee9ffaa91463ed$export$2e2bcd8739ae039 = $94ee9ffaa91463ed$var$SectionsItem;

});

parcelRegister("gcqc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e45e680f082ef68$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");
parcelRequire("97CJW");
var $eB2GF = parcelRequire("eB2GF");
var $5BTOa = parcelRequire("5BTOa");

var $iAoTX = parcelRequire("iAoTX");

var $5MJFl = parcelRequire("5MJFl");

var $js9X4 = parcelRequire("js9X4");

var $lNNXV = parcelRequire("lNNXV");

var $gwgHy = parcelRequire("gwgHy");

var $66xCB = parcelRequire("66xCB");

var $027zY = parcelRequire("027zY");

var $hOFtB = parcelRequire("hOFtB");
const $8e45e680f082ef68$var$sectionsWhitelist = (0, $js9X4.createWhitelist)([
    'sections'
], {
    '*': {
        totalWidth: true,
        widths: true,
        minWidths: true,
        activeSeparatorIndex: false,
        hoveredSectionIndex: false,
        preDragWidths: true
    }
});
const $8e45e680f082ef68$var$persistedReducer = (0, $eB2GF.default)({
    key: (0, $hOFtB.storeKey),
    storage: $5MJFl.default,
    whitelist: [
        'sections'
    ],
    transforms: [
        $8e45e680f082ef68$var$sectionsWhitelist
    ]
}, (0, $027zY.default));
const $8e45e680f082ef68$var$store = (0, $huRi7.createStore)($8e45e680f082ef68$var$persistedReducer);
const $8e45e680f082ef68$var$persistor = (0, $5BTOa.default)($8e45e680f082ef68$var$store);
const $8e45e680f082ef68$export$2881499e37b75b9a = (0, $lNNXV.createProvider)((0, $66xCB.SectionContext), (0, $hOFtB.storeKey));
class $8e45e680f082ef68$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwgHy.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8e45e680f082ef68$export$2881499e37b75b9a, {
            store: this.state.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
            loading: null,
            persistor: $8e45e680f082ef68$var$persistor
        }, this.props.children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            store: $8e45e680f082ef68$var$store
        };
    }
}

});
parcelRegister("iAoTX", function(module, exports) {

$parcel$export(module.exports, "PersistGate", () => $d87ee7b53a2acc42$export$311ca220e7478cda);

var $eUqFw = parcelRequire("eUqFw");
var $d87ee7b53a2acc42$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d87ee7b53a2acc42$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d87ee7b53a2acc42$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d87ee7b53a2acc42$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d87ee7b53a2acc42$export$311ca220e7478cda = function(_PureComponent) {
    $d87ee7b53a2acc42$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _ref;
        var _temp, _this, _ret;
        $d87ee7b53a2acc42$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d87ee7b53a2acc42$var$_possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            bootstrapped: false
        }, _this.handlePersistorState = function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).then(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                }).catch(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        }, _temp), $d87ee7b53a2acc42$var$_possibleConstructorReturn(_this, _ret);
    }
    $d87ee7b53a2acc42$var$_createClass(PersistGate, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: 'render',
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $eUqFw.PureComponent));
$d87ee7b53a2acc42$export$311ca220e7478cda.defaultProps = {
    loading: null
};

});

parcelRegister("5MJFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4364dbbfb8775ed7$export$2e2bcd8739ae039, (v) => $4364dbbfb8775ed7$export$2e2bcd8739ae039 = v);
var $4364dbbfb8775ed7$export$1e511d4a378977f5;
var $4364dbbfb8775ed7$export$2e2bcd8739ae039;
'use strict';
$4364dbbfb8775ed7$export$1e511d4a378977f5 = true;

var $6Et3H = parcelRequire("6Et3H");
var $4364dbbfb8775ed7$var$_createWebStorage2 = $4364dbbfb8775ed7$var$_interopRequireDefault($6Et3H);
function $4364dbbfb8775ed7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$4364dbbfb8775ed7$export$2e2bcd8739ae039 = (0, $4364dbbfb8775ed7$var$_createWebStorage2.default)('local');

});
parcelRegister("6Et3H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $4d7d04f68e12e39e$export$1e511d4a378977f5, (v) => $4d7d04f68e12e39e$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $4d7d04f68e12e39e$export$2e2bcd8739ae039, (v) => $4d7d04f68e12e39e$export$2e2bcd8739ae039 = v);
var $4d7d04f68e12e39e$export$1e511d4a378977f5;
var $4d7d04f68e12e39e$export$2e2bcd8739ae039;
'use strict';
$4d7d04f68e12e39e$export$1e511d4a378977f5 = true;
$4d7d04f68e12e39e$export$2e2bcd8739ae039 = $4d7d04f68e12e39e$var$createWebStorage;

var $eGXkx = parcelRequire("eGXkx");
var $4d7d04f68e12e39e$var$_getStorage2 = $4d7d04f68e12e39e$var$_interopRequireDefault($eGXkx);
function $4d7d04f68e12e39e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d7d04f68e12e39e$var$createWebStorage(type) {
    var storage = (0, $4d7d04f68e12e39e$var$_getStorage2.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("eGXkx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ab2302aecd85f775$export$1e511d4a378977f5, (v) => $ab2302aecd85f775$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ab2302aecd85f775$export$2e2bcd8739ae039, (v) => $ab2302aecd85f775$export$2e2bcd8739ae039 = v);
var $ab2302aecd85f775$export$1e511d4a378977f5;
var $ab2302aecd85f775$export$2e2bcd8739ae039;
'use strict';
$ab2302aecd85f775$export$1e511d4a378977f5 = true;
var $ab2302aecd85f775$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
$ab2302aecd85f775$export$2e2bcd8739ae039 = $ab2302aecd85f775$var$getStorage;
function $ab2302aecd85f775$var$noop() {}
var $ab2302aecd85f775$var$noopStorage = {
    getItem: $ab2302aecd85f775$var$noop,
    setItem: $ab2302aecd85f775$var$noop,
    removeItem: $ab2302aecd85f775$var$noop
};
function $ab2302aecd85f775$var$hasStorage(storageType) {
    if ((typeof self === 'undefined' ? 'undefined' : $ab2302aecd85f775$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = 'redux-persist ' + storageType + ' test';
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $ab2302aecd85f775$var$getStorage(type) {
    var storageType = type + 'Storage';
    if ($ab2302aecd85f775$var$hasStorage(storageType)) return self[storageType];
    else return $ab2302aecd85f775$var$noopStorage;
}

});



parcelRegister("js9X4", function(module, exports) {

$parcel$export(module.exports, "createWhitelist", () => $a81a0b8d2e7409e4$export$95bbff0cef869f61);
parcelRequire("97CJW");
var $hvHzx = parcelRequire("hvHzx");

var $jtsd5 = parcelRequire("jtsd5");
const $a81a0b8d2e7409e4$export$6f0586d0efa5b600 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
stateSlice, whitelist, // eslint-disable-next-line @typescript-eslint/no-explicit-any
outputSlice)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(stateSlice)) throw new Error('buildStateRecursiveFromWhitelist called on stateSlice that is not an object');
    for (const [key, value] of Object.entries(stateSlice)){
        const filterRule = Object.prototype.hasOwnProperty.call(whitelist, key) ? whitelist[key] : whitelist['*'];
        if (typeof filterRule === 'function') {
            if (filterRule(value)) // eslint-disable-next-line no-param-reassign
            outputSlice[key] = value;
        } else if (filterRule === true) // eslint-disable-next-line no-param-reassign
        outputSlice[key] = value;
        else if (filterRule !== false && (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(filterRule) && (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(value)) {
            // eslint-disable-next-line no-param-reassign
            outputSlice[key] = {};
            $a81a0b8d2e7409e4$export$6f0586d0efa5b600(value, filterRule, outputSlice[key]);
        }
    // false or no entry for this key - do nothing
    }
};
const $a81a0b8d2e7409e4$export$95bbff0cef869f61 = (topLevelKeys, whitelistMap)=>(0, $hvHzx.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (inboundState)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToKeep = {};
        $a81a0b8d2e7409e4$export$6f0586d0efa5b600(inboundState, whitelistMap, stateToKeep);
        return stateToKeep;
    }, (outboundState)=>outboundState, {
        whitelist: topLevelKeys
    });

});

parcelRegister("027zY", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c47846e518c739$export$2e2bcd8739ae039);

var $itLT6 = parcelRequire("itLT6");
var $kDrtX = parcelRequire("kDrtX");
var $ldYmX = parcelRequire("ldYmX");

var $n8xNY = parcelRequire("n8xNY");

var $hOFtB = parcelRequire("hOFtB");
const $90c47846e518c739$export$d4c72bab9d6cc13a = {
    sections: {},
    isDragging: false
};
const $90c47846e518c739$export$b7bc2eb1a535912b = (sectionsData)=>sectionsData.reduce((sectionsState, section)=>{
        // eslint-disable-next-line no-param-reassign
        sectionsState.widths[section.id] = section.width;
        // eslint-disable-next-line no-param-reassign
        sectionsState.minWidths[section.id] = section.minWidth;
        return sectionsState;
    }, {
        widths: {},
        minWidths: {}
    });
const $90c47846e518c739$var$reducer = (state = $90c47846e518c739$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $n8xNY.SET_ACTIVE_SEPARATOR:
            {
                const { id: id, index: index } = action;
                return $itLT6.default([
                    'sections',
                    id,
                    'activeSeparatorIndex'
                ], index, state);
            }
        case 0, $n8xNY.SET_IS_HOVERED:
            {
                const { id: id, index: index } = action;
                return $itLT6.default([
                    'sections',
                    id,
                    'hoveredSectionIndex'
                ], index, state);
            }
        case 0, $n8xNY.SET_ONBOARDING_WIDTH:
            {
                const { id: mainSectionId, sectionsData: sectionsData, width: width } = action;
                const newWidths = $ldYmX.default(// eslint-disable-next-line @typescript-eslint/no-shadow
                (newWidths, { id: id, onboardingWidth: onboardingWidth })=>{
                    // eslint-disable-next-line no-param-reassign
                    newWidths[id] = onboardingWidth ? width * onboardingWidth / 100 : state.sections[mainSectionId].widths[id];
                    return newWidths;
                }, {}, sectionsData);
                return $itLT6.default([
                    'sections',
                    mainSectionId,
                    'widths'
                ], newWidths, state);
            }
        case 0, $n8xNY.SAVE_PREDRAG_WIDTHS:
            {
                const { id: id } = action;
                const sections = state.sections[id];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const preDragWidths = {};
                for (const sectionKey of Object.keys(sections.widths))preDragWidths[sectionKey] = sections.minWidths[sectionKey] !== sections.widths[sectionKey] ? sections.widths[sectionKey] : sections.preDragWidths && sections.preDragWidths[sectionKey];
                return $itLT6.default([
                    'sections',
                    id,
                    'preDragWidths'
                ], preDragWidths, state);
            }
        case 0, $n8xNY.ON_DRAG_START:
            return {
                ...state,
                isDragging: true
            };
        case 0, $n8xNY.ON_DRAG_END:
            return {
                ...state,
                isDragging: false
            };
        case 0, $n8xNY.ON_DRAG:
            {
                const { id: id, index: index, delta: delta, sectionsData: sectionsData, parent: parent, totalWidth: totalWidth, isFitParent: isFitParent } = action.payload;
                const sections = state.sections[id];
                // "No delta" means that it's not an actual dragging but section expansion, and delta should be calculated.
                const sizeDelta = $kDrtX.default(delta) ? (0, $hOFtB.getExpansionDelta)(sectionsData[index], sections) : delta || 0;
                const direction = Math.sign(sizeDelta);
                const availableDelta = (0, $hOFtB.getAvailableDelta)({
                    id: id,
                    index: index,
                    parent: parent,
                    sectionsData: sectionsData,
                    totalWidth: totalWidth
                }, direction, isFitParent);
                // If there is no space for expansion, let's try to take some from the previous section
                // by emulating its dragging in opposite direction.
                if (availableDelta === 0 && index > 0 && sectionsData[index].width <= sectionsData[index].minWidth) {
                    const payload = {
                        ...action.payload,
                        index: index - 1,
                        // "minus abs" ensures that delta stays negative when cascading deeper than just previous section.
                        delta: -Math.abs(sizeDelta)
                    };
                    return $90c47846e518c739$var$reducer(state, {
                        type: (0, $n8xNY.ON_DRAG),
                        payload: payload
                    });
                }
                // Restrict delta magnitude by available space but keep the direction.
                const deltaToApply = direction * Math.min(Math.abs(sizeDelta), Math.abs(availableDelta));
                // Just a micro-optimization.
                if (deltaToApply === 0) return state;
                const previousSectionsWidth = (0, $hOFtB.getSectionsWidth)(sectionsData);
                const sectionsOnTheLeft = sectionsData.slice(0, index + 1);
                const sectionsOnTheRight = sectionsData.slice(index + 1);
                const newSectionsData = [
                    ...(0, $hOFtB.scaleLeftSections)(deltaToApply, sectionsOnTheLeft),
                    // If there is no parent then ask scaleRightSections to keep total width unchanged
                    // if possible. Which means to try to compensate change on the left side even if
                    // there are no flex sections on the right.
                    ...(0, $hOFtB.scaleRightSections)(deltaToApply, sectionsOnTheRight, !parent)
                ];
                const nextSectionsWidth = (0, $hOFtB.getSectionsWidth)(newSectionsData);
                const totalWidthDelta = nextSectionsWidth - previousSectionsWidth;
                const isDragOpposite = !isFitParent && (direction < 0 && totalWidthDelta > 0 || direction > 0 && totalWidthDelta < 0);
                // Don't update widths from dragging opposite direction
                if (isDragOpposite) return state;
                let newState = state;
                // Total width of sections has been changed which means we "borrowed" some available
                // delta from the parent. Now it's time to ask the parent to drag itself a bit.
                if (totalWidthDelta !== 0 && parent) {
                    const payload = {
                        ...parent,
                        delta: totalWidthDelta,
                        isFitParent: isFitParent
                    };
                    newState = $90c47846e518c739$var$reducer(state, {
                        type: (0, $n8xNY.ON_DRAG),
                        payload: payload
                    });
                }
                const newSectionsState = $90c47846e518c739$export$b7bc2eb1a535912b(newSectionsData);
                return $itLT6.default([
                    'sections',
                    id
                ], {
                    ...sections,
                    ...newSectionsState
                }, newState);
            }
        case 0, $n8xNY.ON_RESIZE:
            {
                const { id: id, width: sectionWidth, sectionsData: sectionsData, minWidth: minWidth, isFitParent: isFitParent, parent: parent } = action.payload;
                const sections = state.sections[id];
                if (sectionsData.length === 0) return state;
                const sectionsWidth = (0, $hOFtB.getSectionsWidth)(sectionsData);
                let width = !isFitParent ? Math.max(minWidth ?? sectionsWidth, sectionsWidth) : sectionWidth;
                let delta;
                let newSectionsState = {};
                if (isFitParent || minWidth === undefined || /**
				 * Avoid changing the columns width if the sectionsWidth is greater than the minWidth to respect the persisted widths,
				 * allow changing the columns width when the sectionsWidth is smaller than minWidth to fill up the remaining space.
				 */ sectionsWidth <= minWidth) // @ts-expect-error - TS7053 - width can be undefined
                delta = width - sectionsWidth;
                else if (!isFitParent && minWidth && width && /**
				 * Only applicable when the new width is greater than the viewport.
				 */ width > minWidth) {
                    /**
				 * Apply special treatment to the last non-fixed column:
				 * Scale the other columns and take delta from the last non-fixed column if it's width is greater than minWidth.
				 *
				 */ const deltaFromFlexiCol = (0, $hOFtB.getDeltaFromRightFlexiSection)(sectionsData);
                    delta = -Math.min(width - minWidth, deltaFromFlexiCol);
                    width += delta;
                } else if (width === sections?.totalWidth) /**
				 * Short-circuit if the width hasn't changed
				 */ return state;
                if (delta !== undefined) {
                    // Resize entire Sections component by resizing the rightmost section.
                    const index = sectionsData.length - 1;
                    const sectionsOnTheLeft = sectionsData.slice(0, index + 1);
                    const sectionsOnTheRight = sectionsData.slice(index + 1);
                    const newSectionsData = [
                        ...(0, $hOFtB.scaleLeftSections)(delta, sectionsOnTheLeft),
                        ...(0, $hOFtB.scaleRightSections)(delta, sectionsOnTheRight, false)
                    ];
                    newSectionsState = $90c47846e518c739$export$b7bc2eb1a535912b(newSectionsData);
                }
                let newState = state;
                /**
			 * if the section has isFitParent=false, it doesn't bound by its parent's width,
			 * therefore, we have to update the parent's width when the section resized.
			 */ if (parent && sectionWidth && width && sectionWidth !== width && !isFitParent) {
                    // Get the difference between the width from sectionsData AND the width from state
                    const diffWidth = width - sectionWidth;
                    const { totalWidth: totalWidth, sectionsData: parentSectionsData, ...restParent } = parent;
                    const parentIndex = parentSectionsData.length - 1;
                    const parentSectionsOnTheLeft = parentSectionsData.slice(0, parentIndex + 1);
                    const parentSectionsOnTheRight = parentSectionsData.slice(parentIndex + 1);
                    const newSectionsData = [
                        ...(0, $hOFtB.scaleLeftSections)(diffWidth, parentSectionsOnTheLeft),
                        ...(0, $hOFtB.scaleRightSections)(diffWidth, parentSectionsOnTheRight, true)
                    ];
                    const payload = {
                        ...restParent,
                        isFitParent: false,
                        width: totalWidth,
                        sectionsData: newSectionsData
                    };
                    newState = $90c47846e518c739$var$reducer(state, {
                        type: (0, $n8xNY.ON_RESIZE),
                        payload: payload
                    });
                }
                return $itLT6.default([
                    'sections',
                    id
                ], {
                    ...sections,
                    totalWidth: width,
                    ...newSectionsState
                }, newState);
            }
        case 0, $n8xNY.ON_LENGTH_CHANGE:
            {
                const { id: id, width: width, sectionsData: sectionsData, parent: parent, isFitParent: isFitParent } = action.payload;
                const sections = state.sections[id];
                /**
			 * If there is no parent OR if the section is not fitting the parent,
			 * then it's not "borrowing" any width from parent.
			 *
			 * In that case adding or removing section is the same as if sections were without/with
			 * added/removed section with their current individual widths and then were resized to
			 * the former total width.
			 */ if (!parent || !isFitParent) {
                    const payload = action.payload;
                    return $90c47846e518c739$var$reducer(state, {
                        type: (0, $n8xNY.ON_RESIZE),
                        payload: payload
                    });
                }
                // Otherwise we can use space available in the parent to minimize impact of
                // adding/removal section on other sections widths.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const delta = (0, $hOFtB.getSectionsWidth)(sectionsData) - width;
                const direction = Math.sign(delta);
                const availableDelta = (0, $hOFtB.getAvailableDelta)(parent, direction, isFitParent);
                // Restrict delta magnitude by available space but keep the direction.
                const deltaToApply = direction * Math.min(Math.abs(delta), Math.abs(availableDelta));
                // Now let's ask the parent to drag itself a bit to accomodate adding/removing section.
                const payload = {
                    ...parent,
                    delta: deltaToApply,
                    isFitParent: isFitParent
                };
                const newState = $90c47846e518c739$var$reducer(state, {
                    type: (0, $n8xNY.ON_DRAG),
                    payload: payload
                });
                // Next step is to scale sections to compensate delta not absorbed by the parent.
                const availableWidth = sectionsData.reduce((acc, section)=>acc + section.width - section.minWidth, 0);
                if (availableWidth <= 0) return newState;
                // Proportionally distribute remaining delta over all sections disregarding their isFixed status.
                const excessiveDelta = delta - deltaToApply;
                const k = excessiveDelta / availableWidth;
                const newSectionsData = sectionsData.map((section)=>({
                        ...section,
                        width: Math.max(section.minWidth, section.width - k * (section.width - section.minWidth))
                    }));
                const newSectionsState = $90c47846e518c739$export$b7bc2eb1a535912b(newSectionsData);
                return $itLT6.default([
                    'sections',
                    id
                ], {
                    ...sections,
                    totalWidth: width,
                    ...newSectionsState
                }, newState);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $90c47846e518c739$export$2e2bcd8739ae039 = $90c47846e518c739$var$reducer;

});


parcelRegister("hwshf", function(module, exports) {

$parcel$export(module.exports, "default", () => $313e0bcaa188d5d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $18uE0 = parcelRequire("18uE0");

var $6B26M = parcelRequire("6B26M");
// eslint-disable-next-line jira/react/no-class-components
class $313e0bcaa188d5d7$var$Separator extends (0, $eUqFw.Component) {
    render() {
        const separatorClassName = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($6B26M.handle, {
            [$6B26M["drag-active"]]: this.props.isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18uE0.default), {
            dragHandler: {
                onDragStart: this.onDragStart,
                onDrag: this.onDrag,
                onDragEnd: this.onDragEnd
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $6B26M.separator,
            "data-testid": this.props.testId || '',
            role: "none",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: separatorClassName
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMouseHover: false
        };
        this.onDragStart = ()=>this.props.onDragStart(this.props.index);
        this.onDrag = (from, to)=>this.props.onDrag({
                index: this.props.index,
                from: from,
                to: to
            });
        this.onDragEnd = ()=>{
            const { isActive: isActive, onDragEnd: onDragEnd, setActiveSeparator: setActiveSeparator } = this.props;
            onDragEnd();
            if (isActive && !this.state.isMouseHover) setActiveSeparator(null);
        };
        this.onMouseEnter = ()=>{
            this.setState({
                isMouseHover: true
            });
            const { index: index, isActive: isActive, isDragging: isDragging, setActiveSeparator: setActiveSeparator } = this.props;
            if (!isActive && !isDragging) setActiveSeparator(index);
        };
        this.onMouseLeave = ()=>{
            this.setState({
                isMouseHover: false
            });
            // Deferring isDragging check as mouse leave could happen before isDragging was propagated
            // back to this component if user moves cursor too fast.
            setTimeout(()=>{
                const { isDragging: isDragging, setActiveSeparator: setActiveSeparator } = this.props;
                if (!isDragging) setActiveSeparator(null);
            }, 50);
        };
    }
}
var $313e0bcaa188d5d7$export$2e2bcd8739ae039 = $313e0bcaa188d5d7$var$Separator;

});
parcelRegister("18uE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac3c7a4d742ea683$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
const $ac3c7a4d742ea683$export$25e31b3f7c2a34fa = 3;
class $ac3c7a4d742ea683$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            dragHandler: {}
        };
    }
    componentDidMount() {
        this.node = this.getDomNode();
        this.mounted = true;
        // @ts-expect-error - TS2769 - No overload matches this call.
        this.node.addEventListener('mousedown', this.onChildMouseDown);
    }
    componentWillUnmount() {
        // remove listeners in case this component is unmounted during a drag operation
        window.removeEventListener('mousemove', this.onWindowMouseMove);
        window.removeEventListener('mouseup', this.onWindowMouseUp);
        if (this.node) // @ts-expect-error - TS2769 - No overload matches this call.
        this.node.removeEventListener('mousedown', this.onChildMouseDown);
        this.mounted = false;
    }
    // Must only be called after the component has been mounted
    getDomNode() {
        // findDOMNode is discouraged but is sometimes the best way to implement behavior-based
        // higher order components. See https://github.com/yannickcr/eslint-plugin-react/issues/678#issuecomment-238090846
        // In this case we can't just use a ref from the child, because the child may not be an HTML element, and thus the
        // ref won't point to a DOM node.
        // eslint-disable-next-line react/no-find-dom-node
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this);
        if (!(node instanceof Element)) throw new Error('Only plain DOM elements could be observed');
        return node;
    }
    render() {
        const { dragging: dragging } = this.state;
        const { children: children } = this.props;
        const childProps = dragging ? {
            dragging: dragging
        } : {};
        // @ts-expect-error - TS2769 - No overload matches this call.
        return /*#__PURE__*/ (0, $eUqFw.cloneElement)((0, $eUqFw.Children).only(children), {
            ...childProps
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            dragging: false
        };
        // eslint-disable-next-line react/sort-comp
        this.mounted = false;
        this.node = null;
        this.onChildMouseDown = (e)=>{
            if (Object.keys(this.props.dragHandler).length === 0) // No drag handler. Return early
            return;
            e.preventDefault();
            e.stopPropagation();
            window.addEventListener('mousemove', this.onWindowMouseMove);
            window.addEventListener('mouseup', this.onWindowMouseUp);
            const dragStart = this.getMousePosition(e);
            this.setState({
                dragging: false,
                dragStart: dragStart,
                previousDragPosition: dragStart
            });
            this.onMouseDown(e);
        };
        this.onWindowMouseMove = (e)=>{
            e.preventDefault();
            const mouse = this.getMousePosition(e);
            const { dragging: dragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
            if (!dragStart || !previousDragPosition) throw Error('dragStart and previousDragPosition should be set');
            if (!dragging) {
                if (Math.abs(mouse.x - dragStart.x) > $ac3c7a4d742ea683$export$25e31b3f7c2a34fa || Math.abs(mouse.y - dragStart.y) > $ac3c7a4d742ea683$export$25e31b3f7c2a34fa) {
                    this.setState({
                        dragging: true
                    });
                    this.onDragStart(dragStart);
                }
            }
            if (dragging) {
                const from = previousDragPosition;
                const to = mouse;
                this.setState({
                    previousDragPosition: mouse
                });
                this.onDrag(from, to, dragStart);
            }
        };
        this.onWindowMouseUp = (e)=>{
            const { dragging: dragging, dragStart: dragStart } = this.state;
            if (!dragStart) // Make flow happy
            throw Error('Illegal state: dragStart must be set here');
            if (dragging) {
                const mouse = this.getMousePosition(e);
                const start = dragStart;
                const end = mouse;
                if (this.mounted) this.setState({
                    dragging: false
                });
                this.onDragEnd(start, end);
            } else this.onClick(e);
            window.removeEventListener('mousemove', this.onWindowMouseMove);
            window.removeEventListener('mouseup', this.onWindowMouseUp);
        };
        this.onMouseDown = (e)=>{
            if (this.props.dragHandler.onMouseDown) this.props.dragHandler.onMouseDown(e);
        };
        this.onDragStart = (from)=>{
            if (this.props.dragHandler.onDragStart) this.props.dragHandler.onDragStart(from);
        };
        this.onDrag = (from, to, start)=>{
            if (this.props.dragHandler.onDrag) this.props.dragHandler.onDrag(from, to, start);
        };
        this.onDragEnd = (from, to)=>{
            if (this.props.dragHandler.onDragEnd) this.props.dragHandler.onDragEnd(from, to);
        };
        this.onClick = (e)=>{
            if (this.props.dragHandler.onClick) this.props.dragHandler.onClick(e);
        };
        this.getMousePosition = (e)=>({
                x: e.pageX,
                y: e.pageY
            });
    }
}

});



parcelRegister("cTxSR", function(module, exports) {

$parcel$export(module.exports, "HorizontalSyncedScrollbar", () => $25350f6007cc9414$export$22e5092b0af9baf7);

var $eUqFw = parcelRequire("eUqFw");

var $hq3Md = parcelRequire("hq3Md");

var $7NeCw = parcelRequire("7NeCw");

var $l36Pm = parcelRequire("l36Pm");
// empty image gif
const $25350f6007cc9414$var$getEmptyImage = ()=>{
    const emptyImage = document.createElement('img');
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    return emptyImage;
};
const $25350f6007cc9414$export$80b3c1e22c09058 = ({ trackX: trackX, trackWidth: trackWidth, thumbWidth: thumbWidth, mouseX: mouseX, scrollWidth: scrollWidth })=>{
    const factor = scrollWidth / trackWidth;
    const relativePosition = mouseX - trackX;
    return Math.round(relativePosition * factor - thumbWidth * factor / 2);
};
const $25350f6007cc9414$export$22e5092b0af9baf7 = ({ name: name })=>{
    const [{ offset: offset, viewportWidth: viewportWidth, scrollWidth: scrollWidth }, { setOffset: setOffset }] = (0, $7NeCw.usePayload)(name);
    const scale = scrollWidth ? viewportWidth / scrollWidth : 1;
    const offsetRef = (0, $eUqFw.useRef)(offset);
    offsetRef.current = offset;
    const startingOffsetRef = (0, $eUqFw.useRef)(offset);
    const startingClientXRef = (0, $eUqFw.useRef)(0);
    const thumbWidth = viewportWidth * scale;
    const emptyImage = (0, $eUqFw.useMemo)(()=>$25350f6007cc9414$var$getEmptyImage(), []);
    const handleDrag = (0, $eUqFw.useCallback)((e)=>{
        const { clientX: clientX } = e;
        if (clientX === 0) return;
        requestAnimationFrame(()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const offset = Math.round(startingOffsetRef.current + (clientX - startingClientXRef.current) / scale);
            setOffset(name, offset);
        });
    }, [
        scale,
        name,
        setOffset
    ]);
    const handleDragStart = (0, $eUqFw.useCallback)((e)=>{
        e.nativeEvent.dataTransfer?.setDragImage(emptyImage, 0, 0);
        startingClientXRef.current = e.clientX;
        startingOffsetRef.current = offsetRef.current;
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
        document.body.addEventListener('dragover', handleDrag);
        e.stopPropagation();
    }, [
        handleDrag,
        emptyImage
    ]);
    const handleDragEnd = (0, $eUqFw.useCallback)(()=>{
        document.body.removeEventListener('dragover', handleDrag);
    }, [
        handleDrag
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const offset = $25350f6007cc9414$export$80b3c1e22c09058({
            trackX: left,
            trackWidth: width,
            thumbWidth: thumbWidth,
            mouseX: event.clientX,
            scrollWidth: scrollWidth
        });
        setOffset(name, offset);
    }, [
        thumbWidth,
        name,
        setOffset,
        scrollWidth
    ]);
    (0, $l36Pm.useScrollAnalytics)(offset);
    if (scale === 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq3Md.Track), {
        onClick: handleClick,
        role: "scrollbar",
        "data-testid": "portfolio-3-horizontal-scrolling-synced.ui.scrollbar.scroll-track"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq3Md.Thumb), {
        draggable: true,
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        width: thumbWidth,
        left: offset * scale,
        "data-testid": "portfolio-3-horizontal-scrolling-synced.ui.scrollbar.scroll-thumb"
    }));
};

});
parcelRegister("hq3Md", function(module, exports) {

$parcel$export(module.exports, "Track", () => $66b9572f7c4baf63$export$13921ac0cc260818);
$parcel$export(module.exports, "Thumb", () => $66b9572f7c4baf63$export$6521433ed15a34db);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $66b9572f7c4baf63$var$SCROLLBAR_HEIGHT = 10;
const $66b9572f7c4baf63$export$13921ac0cc260818 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i19bv _bfhkqzid _2rko19bv _1ltvidpf _1xi2idpf _94n5idpf _o7ks5r0a _irr31fy5",
            __cmplp.className
        ])
    });
});
const $66b9572f7c4baf63$export$6521433ed15a34db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_159zbtr": (0, $9t7rW.default)(`translateX(${__cmplp.left}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _t9ec1vqn _kqswstnw _4t3i19bv _2rko19bv _bfhk70z6",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7NeCw", function(module, exports) {

$parcel$export(module.exports, "usePayload", () => $46e1a025ecbe6d73$export$5038fd1db96a9342);
$parcel$export(module.exports, "useActions", () => $46e1a025ecbe6d73$export$bc923229a7fa61e7);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $SQYj7 = parcelRequire("SQYj7");

var $7wlLQ = parcelRequire("7wlLQ");
const $46e1a025ecbe6d73$var$initialState = {};
const $46e1a025ecbe6d73$var$store = (0, $a61MH.createStore)({
    name: 'horizontal-scrolling-synced',
    actions: {
        resetPayload: $SQYj7.resetPayload,
        setPayload: $SQYj7.setPayload,
        addScrollElement: $SQYj7.addScrollElement,
        removeScrollElement: $SQYj7.removeScrollElement,
        setOffset: $SQYj7.setOffset,
        setOffsetFallback: $SQYj7.setOffsetFallback
    },
    initialState: $46e1a025ecbe6d73$var$initialState
});
const $46e1a025ecbe6d73$export$5038fd1db96a9342 = (0, $ggKAj.createHook)($46e1a025ecbe6d73$var$store, {
    selector: (state, name)=>state[name] ?? (0, $7wlLQ.DEFAULT_PAYLOAD)
});
const $46e1a025ecbe6d73$export$99e5207fa7e69f17 = (0, $ggKAj.createHook)($46e1a025ecbe6d73$var$store, {
    selector: (state, name)=>state[name]?.offset ?? 0
});
const $46e1a025ecbe6d73$export$bc923229a7fa61e7 = (0, $ggKAj.createActionsHook)($46e1a025ecbe6d73$var$store);

});
parcelRegister("SQYj7", function(module, exports) {

$parcel$export(module.exports, "resetPayload", () => $ad0bc107b5876f3a$export$6b8b2d717622293e);
$parcel$export(module.exports, "setPayload", () => $ad0bc107b5876f3a$export$9431b11349b6e344);
$parcel$export(module.exports, "addScrollElement", () => $ad0bc107b5876f3a$export$af4208d39f87b8f4);
$parcel$export(module.exports, "removeScrollElement", () => $ad0bc107b5876f3a$export$67e42f622dd06e54);
$parcel$export(module.exports, "setOffset", () => $ad0bc107b5876f3a$export$ed400fd6c8dc94e3);
$parcel$export(module.exports, "setOffsetFallback", () => $ad0bc107b5876f3a$export$c09c24453a9bf96e);

var $7wlLQ = parcelRequire("7wlLQ");
const $ad0bc107b5876f3a$export$6b8b2d717622293e = (name)=>({ setState: setState })=>setState({
            [name]: (0, $7wlLQ.DEFAULT_PAYLOAD)
        });
const $ad0bc107b5876f3a$export$9431b11349b6e344 = (name, update)=>({ getState: getState, setState: setState })=>setState({
            [name]: typeof update === 'function' ? update(getState()[name] ?? (0, $7wlLQ.DEFAULT_PAYLOAD)) : update
        });
const $ad0bc107b5876f3a$export$af4208d39f87b8f4 = (name, element)=>({ dispatch: dispatch })=>{
        dispatch($ad0bc107b5876f3a$export$9431b11349b6e344(name, ({ scrollElements: scrollElements, ...data })=>{
            // eslint-disable-next-line no-param-reassign
            element.scrollLeft = data.offset;
            return {
                ...data,
                scrollElements: [
                    ...scrollElements,
                    element
                ]
            };
        }));
    };
const $ad0bc107b5876f3a$export$67e42f622dd06e54 = (name, element)=>({ dispatch: dispatch })=>{
        dispatch($ad0bc107b5876f3a$export$9431b11349b6e344(name, ({ scrollElements: scrollElements, ...data })=>({
                ...data,
                scrollElements: scrollElements.filter((ele)=>ele !== element)
            })));
    };
const $ad0bc107b5876f3a$export$ed400fd6c8dc94e3 = (name, update)=>({ dispatch: dispatch })=>{
        dispatch($ad0bc107b5876f3a$export$9431b11349b6e344(name, ({ offset: offset, viewportWidth: viewportWidth, scrollWidth: scrollWidth, scrollElements: scrollElements })=>{
            const updatedOffset = typeof update === 'function' ? update(offset) : update;
            const saneOffset = Math.max(Math.min(updatedOffset, scrollWidth - viewportWidth), 0);
            scrollElements.forEach((node)=>{
                // eslint-disable-next-line no-param-reassign
                node.scrollLeft = saneOffset;
            });
            return {
                offset: saneOffset,
                scrollWidth: scrollWidth,
                viewportWidth: viewportWidth,
                scrollElements: scrollElements
            };
        }));
    };
const $ad0bc107b5876f3a$export$c09c24453a9bf96e = (name, updatedOffset)=>({ getState: getState, dispatch: dispatch })=>{
        dispatch($ad0bc107b5876f3a$export$9431b11349b6e344(name, ({ offset: offset, viewportWidth: viewportWidth, scrollWidth: scrollWidth, scrollElements: scrollElements })=>{
            if (updatedOffset === offset) return getState()[name];
            scrollElements.forEach((node)=>{
                // eslint-disable-next-line no-param-reassign
                node.scrollLeft = updatedOffset;
            });
            return {
                offset: updatedOffset,
                scrollWidth: scrollWidth,
                viewportWidth: viewportWidth,
                scrollElements: scrollElements
            };
        }));
    };

});
parcelRegister("7wlLQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PAYLOAD", () => $6d44e8d9fe749d94$export$fc05a57b0ef48bb5);
const $6d44e8d9fe749d94$export$fc05a57b0ef48bb5 = {
    offset: 0,
    viewportWidth: 0,
    scrollWidth: 0,
    scrollElements: []
};

});



parcelRegister("l36Pm", function(module, exports) {

$parcel$export(module.exports, "useScrollAnalytics", () => $bf7831c366b5ce0d$export$d9c9701e4dfc700);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $dYnI4 = parcelRequire("dYnI4");

var $f3YKO = parcelRequire("f3YKO");
const $bf7831c366b5ce0d$export$be097c2d334688c0 = (0, $f3YKO.default)((0, $dYnI4.SPA_APP_NAME));
const $bf7831c366b5ce0d$export$d9c9701e4dfc700 = (offset)=>{
    const lastReportedOffset = (0, $eUqFw.useRef)(offset);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This check helps defends against firing for implicit scroll events (e.g. page load)
        if (lastReportedOffset.current !== offset) {
            $bf7831c366b5ce0d$export$be097c2d334688c0.trackWithTimeout('syncedScrollbar measured', createAnalyticsEvent);
            lastReportedOffset.current = offset;
        }
    }, [
        createAnalyticsEvent,
        offset
    ]);
};

});
parcelRegister("f3YKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6be3e0a068b32dc$export$2e2bcd8739ae039);

var $511uv = parcelRequire("511uv");

var $fPUXl = parcelRequire("fPUXl");

var $oVkDS = parcelRequire("oVkDS");

var $7tZw9 = parcelRequire("7tZw9");

var $jMP2a = parcelRequire("jMP2a");

const $c6be3e0a068b32dc$export$fd37aa2563e8b3e8 = (analyticsEvent, offset = 0, additionalAttributes)=>(observationData)=>{
        if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
            const eventStartTimes = observationData.events.map((event)=>event.timestamp);
            const startTime = Math.min(observationData.startTimestamp, ...eventStartTimes);
            const measureTimespan = performance.now() - startTime - offset;
            const endTimeStamp = startTime + measureTimespan;
            // Remove events that are triggered after the last scroll event because the user could have triggered another unrelated long task
            const events = observationData.events.filter((event)=>event.timestamp <= endTimeStamp);
            const analyticsData = {
                ...(0, $fPUXl.generateLongTaskAnalyticsSummary)(`${observationData.type}`, events),
                measureTimespan: measureTimespan,
                events: events,
                ...additionalAttributes
            };
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, observationData.type, analyticsData);
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6be3e0a068b32dc$export$2e2bcd8739ae039 = (appId)=>{
    let scrollTrackingTimeout = false;
    const start = (type)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $511uv.getLongTasksMetrics)(type).start(appId);
    };
    const stop = (type, reporter = (0, $oVkDS.genericReporter))=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $511uv.getLongTasksMetrics)(type).stop((param)=>{
            reporter(param);
        });
    };
    return {
        start: start,
        stop: stop,
        trackWithTimeout: (type, createAnalyticsEvent, wait = (0, $cb9d9ce25f6ad9ee$export$3e6e59880a7a1435), additionalAttributes)=>{
            if (!scrollTrackingTimeout) start(type);
            else clearTimeout(scrollTrackingTimeout);
            scrollTrackingTimeout = setTimeout(()=>{
                const [actionSubject, action] = type.split(' ');
                const analyticsEvent = createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                });
                const scrollReporter = $c6be3e0a068b32dc$export$fd37aa2563e8b3e8(analyticsEvent, wait, additionalAttributes);
                stop(type, scrollReporter);
                scrollTrackingTimeout = false;
            }, wait);
        },
        clearTimeout: ()=>{
            if (scrollTrackingTimeout) clearTimeout(scrollTrackingTimeout);
        }
    };
};

});
parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $8uNQc = parcelRequire("8uNQc");
var $6iz4v = parcelRequire("6iz4v");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $8uNQc.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $8uNQc.default).now && isStarted) {
                const stopTimestamp = (0, $8uNQc.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});



parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});

parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});


parcelRegister("oVkDS", function(module, exports) {

$parcel$export(module.exports, "genericReporter", () => $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2);

var $7tZw9 = parcelRequire("7tZw9");

var $fPUXl = parcelRequire("fPUXl");
const $11a01d8fc8c2c9e1$export$bf7963bc28dd02c2 = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $7tZw9.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $fPUXl.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $fPUXl.generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags
        };
        triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
    }
};

});

// the timeout delay to stop the scroll event tracking
const $cb9d9ce25f6ad9ee$export$3e6e59880a7a1435 = 300;




parcelRegister("3g62d", function(module, exports) {

$parcel$export(module.exports, "HorizontalSyncedScrollView", () => $f3951486889cf740$export$dd0b2b54ac3a5f90);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JB4J = parcelRequire("5JB4J");

var $7NeCw = parcelRequire("7NeCw");

var $2uX6A = parcelRequire("2uX6A");
const $f3951486889cf740$var$paddingToHideAutoHideScrollbar = 50;
const $f3951486889cf740$export$2bac67accba49b51 = ({ name: name, containerRef: containerRef, viewportRef: viewportRef })=>{
    const { setPayload: setPayload, resetPayload: resetPayload } = (0, $7NeCw.useActions)();
    (0, $5JB4J.useResizeObserver)(containerRef, (0, $eUqFw.useCallback)((el)=>{
        const { width: scrollWidth } = el.getBoundingClientRect();
        setPayload(name, (data)=>({
                ...data,
                scrollWidth: scrollWidth
            }));
    }, [
        name,
        setPayload
    ]));
    (0, $5JB4J.useResizeObserver)(viewportRef, (0, $eUqFw.useCallback)((el)=>{
        const { width: viewportWidth } = el.getBoundingClientRect();
        setPayload(name, (data)=>({
                ...data,
                viewportWidth: viewportWidth
            }));
    }, [
        name,
        setPayload
    ]));
    (0, $eUqFw.useEffect)(()=>()=>{
            resetPayload(name);
        }, [
        resetPayload,
        name
    ]);
    return null;
};
const $f3951486889cf740$export$dd0b2b54ac3a5f90 = ({ name: name, primary: primary, width: width, minWidth: minWidth, children: children })=>{
    const viewportRef = (0, $eUqFw.useRef)(null);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const containerRef = (0, $eUqFw.useRef)(null);
    const { setOffset: setOffset, setOffsetFallback: setOffsetFallback, removeScrollElement: removeScrollElement, addScrollElement: addScrollElement } = (0, $7NeCw.useActions)();
    const nativeScrollBarHeight = (0, $2uX6A.getNativeScrollbarSizeMemoed)();
    const handleScroll = (0, $eUqFw.useCallback)(()=>{
        if (scrollableRef.current) {
            const deltaX = scrollableRef.current.scrollLeft;
            setOffsetFallback(name, deltaX);
        }
    }, [
        setOffsetFallback,
        name
    ]);
    const handleWheel = (0, $eUqFw.useCallback)((e)=>{
        const { deltaX: deltaX, deltaY: deltaY } = (0, $5JB4J.getDelta)(e);
        if (Math.abs(deltaX) >= Math.abs(deltaY)) {
            setOffset(name, (offset)=>offset + deltaX);
            e.preventDefault();
        }
    }, [
        name,
        setOffset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!scrollableRef.current) return;
        const scrollableEl = scrollableRef.current;
        scrollableEl.addEventListener('wheel', handleWheel, false);
        scrollableEl.addEventListener('scroll', handleScroll, false);
        addScrollElement(name, scrollableEl);
        return ()=>{
            scrollableEl.removeEventListener('wheel', handleWheel, false);
            scrollableEl.removeEventListener('scroll', handleScroll, false);
            removeScrollElement(name, scrollableEl);
        };
    }, [
        scrollableRef,
        handleWheel,
        handleScroll,
        addScrollElement,
        removeScrollElement,
        name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3951486889cf740$var$Viewport, {
        ref: viewportRef,
        width: width,
        minWidth: minWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3951486889cf740$var$Scrollable, {
        ref: scrollableRef,
        bottom: -((nativeScrollBarHeight ?? 0) + $f3951486889cf740$var$paddingToHideAutoHideScrollbar)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f3951486889cf740$var$containerStyles,
        ref: containerRef
    }, children))), primary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3951486889cf740$export$2bac67accba49b51, {
        name: name,
        containerRef: containerRef,
        viewportRef: viewportRef
    }));
};
const $f3951486889cf740$var$Scrollable = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ bottom: bottom, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": "portfolio-3-horizontal-scrolling-synced.ui.scroll-view.scrollable",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            bottom: `${bottom}px`
        },
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _n3td12am _1reo15zi _12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw"
        ])
    }, children));
const $f3951486889cf740$var$scrollableStyles = null;
const $f3951486889cf740$var$Viewport = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, minWidth: minWidth, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width ? `${width}px` : 'auto',
            minWidth: minWidth ? `${minWidth}px` : '0px'
        },
        ref: ref,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _18m915vq _4t3i1osq"
        ])
    }, children));
const $f3951486889cf740$var$viewportStyles = null;
const $f3951486889cf740$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});

});
parcelRegister("5JB4J", function(module, exports) {

$parcel$export(module.exports, "getDelta", () => $2f1ef6cfd9aef394$export$693f861392be013b);
$parcel$export(module.exports, "useNativeScrollbarHeight", () => $2f1ef6cfd9aef394$export$14225e9ed50450f8);
$parcel$export(module.exports, "useResizeObserver", () => $2f1ef6cfd9aef394$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
const $2f1ef6cfd9aef394$export$693f861392be013b = ({ deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey })=>{
    // On windows, holding shift then using wheel doesn't result in deltaX change.
    if (shiftKey && deltaY !== 0) return {
        deltaX: deltaY,
        deltaY: deltaX
    };
    return {
        deltaX: deltaX,
        deltaY: deltaY
    };
};
const $2f1ef6cfd9aef394$export$14225e9ed50450f8 = ()=>{
    const [result, setResult] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const outerEl = document.createElement('div');
        const innerEl = document.createElement('div');
        Object.assign(outerEl.style, {
            overflowX: 'scroll',
            width: '50px'
        });
        Object.assign(innerEl.style, {
            width: '100px'
        });
        outerEl.appendChild(innerEl);
        document.body?.appendChild(outerEl);
        setResult(outerEl.offsetHeight - outerEl.clientHeight);
        document.body?.removeChild(outerEl);
    }, []);
    return result;
};
function $2f1ef6cfd9aef394$export$683480f191c0e3ea(elRef, callback) {
    (0, $eUqFw.useLayoutEffect)(()=>{
        const el = elRef.current;
        if (!el) return;
        callback(el);
        const observer = new ResizeObserver(()=>callback(el));
        observer.observe(el);
        return ()=>{
            observer.unobserve(el);
            observer.disconnect();
        };
    }, [
        callback,
        elRef
    ]);
}

});

parcelRegister("2uX6A", function(module, exports) {

$parcel$export(module.exports, "getNativeScrollbarSizeMemoed", () => $4ed35b9d8d13787d$export$2399d538e930487f);

var $jqvCZ = parcelRequire("jqvCZ");
const $4ed35b9d8d13787d$export$2399d538e930487f = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(()=>{
    const outerEl = document.createElement('div');
    const innerEl = document.createElement('div');
    Object.assign(outerEl.style, {
        overflowX: 'scroll',
        width: '50px'
    });
    Object.assign(innerEl.style, {
        width: '100px'
    });
    outerEl.appendChild(innerEl);
    document.body?.appendChild(outerEl);
    const nativeScrollBarSize = outerEl.offsetHeight - outerEl.clientHeight;
    document.body?.removeChild(outerEl);
    return nativeScrollBarSize;
});

});


parcelRegister("hIE3U", function(module, exports) {

$parcel$export(module.exports, "CttSpotlights", () => $bba9cb2006b9c9bb$export$d87db548b153c65d);
const $bba9cb2006b9c9bb$export$d87db548b153c65d = {
    Inactive: 'INACTIVE',
    CreateIssue: 'portfolio-3/ctt-onboarding/create-issue',
    TitleInput: 'portfolio-3/ctt-onboarding/title-input',
    Settings: 'portfolio-3/ctt-onboarding/settings',
    IssueSources: 'portfolio-3/ctt-onboarding/issue-source',
    BackToPlan: 'portfolio-3/ctt-onboarding/back-to-plan',
    EpicSection: 'portfolio-3/ctt-onboarding/epic-section',
    Scope: 'portfolio-3/ctt-onboarding/scope',
    ReviewChanges: 'portfolio-3/ctt-onboarding/review-changes'
};

});

parcelRegister("h7T2Y", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $8a79ba92a6955587$export$e29577842f211e22);
$parcel$export(module.exports, "EpicLevelSpotlightTarget", () => $8a79ba92a6955587$export$27903a60ba199e9f);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $8YqJS = parcelRequire("8YqJS");

var $hIE3U = parcelRequire("hIE3U");
const $8a79ba92a6955587$export$e29577842f211e22 = ({ children: children, delayOn: delayOn, name: name })=>{
    const [withSpotlight, setWithSpotlight] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (delayOn === undefined) return;
        setWithSpotlight(false);
        setTimeout(()=>setWithSpotlight(true), 1000);
    }, [
        delayOn
    ]);
    return withSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: name
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $8a79ba92a6955587$export$27903a60ba199e9f = (children, isGroupByNone, level)=>level === (0, $8YqJS.EPIC_LEVEL) && isGroupByNone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8a79ba92a6955587$export$e29577842f211e22, {
        delayOn: true,
        name: (0, $hIE3U.CttSpotlights).EpicSection,
        key: (0, $hIE3U.CttSpotlights).EpicSection
    }, children) : children;

});

parcelRegister("cm4fw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcae0843a8a0345a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kx4As = parcelRequire("kx4As");

var $PdmhA = parcelRequire("PdmhA");

var $5ge6s = parcelRequire("5ge6s");

var $0cdA8 = parcelRequire("0cdA8");

var $cCFSU = parcelRequire("cCFSU");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5LCRg = parcelRequire("5LCRg");
const $dcae0843a8a0345a$var$FLAG_ID = 'tmp_cross_project_parenting_changeboarding';
const $dcae0843a8a0345a$var$EP_MESSAGE_ID = 'JPO-25758-tmp-cross-project-parenting';
const $dcae0843a8a0345a$export$48ea269755562084 = ({ hierarchyTitles: hierarchyTitles })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        showFlag({
            id: $dcae0843a8a0345a$var$FLAG_ID,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                    id: $dcae0843a8a0345a$var$FLAG_ID,
                    title: formatMessage((0, $5LCRg.default).title, {
                        epics: hierarchyTitles[1],
                        initiatives: hierarchyTitles[2]
                    }),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kx4As))), {
                        label: formatMessage((0, $5LCRg.default).iconLabel),
                        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N500})`
                    }),
                    onDismissed: ()=>dismissFlag($dcae0843a8a0345a$var$FLAG_ID)
                })
        });
    }, [
        showFlag,
        dismissFlag,
        formatMessage,
        hierarchyTitles
    ]);
    return null;
};
const $dcae0843a8a0345a$var$TmpCrossProjectChangeBoarding = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "tmpCrossProjectChangeBoarding",
        packageName: "jiraPortfolio3Onboarding",
        teamName: "chronos",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: $dcae0843a8a0345a$var$EP_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dcae0843a8a0345a$export$48ea269755562084, props)));
var $dcae0843a8a0345a$export$2e2bcd8739ae039 = $dcae0843a8a0345a$var$TmpCrossProjectChangeBoarding;

});
parcelRegister("kx4As", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef2a729f4f0796a9$var$_react = $ef2a729f4f0796a9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ef2a729f4f0796a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ef2a729f4f0796a9$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $ef2a729f4f0796a9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.998 4A5.997 5.997 0 006 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611 0 .499.45.907 1 .907h4c.55 0 1-.408 1-.907 0-.499.32-1.224.71-1.611 0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0011.998 4zm2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V19z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ef2a729f4f0796a9$var$LightbulbFilledIcon.displayName = 'LightbulbFilledIcon';
var $ef2a729f4f0796a9$var$_default = $ef2a729f4f0796a9$var$LightbulbFilledIcon;
module.exports.default = $ef2a729f4f0796a9$var$_default;

});

parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hRleJ = parcelRequire("hRleJ");

var $hpAuL = parcelRequire("hpAuL");
var $8Voen = parcelRequire("8Voen");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
const $67d1cec28351d2e7$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
const $67d1cec28351d2e7$var$getEnvironmentType = (env)=>{
    if (env === 'prod') return (0, $hRleJ.envType).PROD;
    if (env === 'staging') return (0, $hRleJ.envType).STAGING;
    return (0, $hRleJ.envType).DEV;
};
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $8Voen.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = ''){
        const coordinationOptions = {
            envType: $67d1cec28351d2e7$var$getEnvironmentType($67d1cec28351d2e7$var$environment),
            enableChoreographer: (0, $1ybV0.ff)('post-office_enable_jira_choreographer')
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) await super.stop(messageId);
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId);
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId);
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAuL.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});

parcelRegister("5LCRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8703ff3ac3c050$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $0f8703ff3ac3c050$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.tmp-cross-project-parenting.title",
        "defaultMessage": "You can now assign a company managed {initiatives} as a parent to a team managed {epics}."
    },
    iconLabel: {
        "id": "portfolio-3-onboarding.tmp-cross-project-parenting.icon-label",
        "defaultMessage": "New Feature"
    }
});
var $0f8703ff3ac3c050$export$2e2bcd8739ae039 = $0f8703ff3ac3c050$var$messages;

});


parcelRegister("Texvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $66313eba32ba3fac$export$2e2bcd8739ae039);

var $2240V = parcelRequire("2240V");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $8XBh3 = parcelRequire("8XBh3");
const $66313eba32ba3fac$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    errors: (0, $2240V.getErrors)
});
var $66313eba32ba3fac$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($66313eba32ba3fac$var$mapStateToProps, {})((0, $8XBh3.default));

});
parcelRegister("2240V", function(module, exports) {

$parcel$export(module.exports, "getErrors", () => $d1646bca6720bb62$export$501239432719417d);
$parcel$export(module.exports, "getErrorLogDialogState", () => $d1646bca6720bb62$export$197d5b7cd31faba3);
$parcel$export(module.exports, "getIsProjectLimitExceeded", () => $d1646bca6720bb62$export$6b889b3c17f5cdcd);

var $h9JIe = parcelRequire("h9JIe");
const $d1646bca6720bb62$export$501239432719417d = (state)=>state.ui.Errors.errors;
const $d1646bca6720bb62$export$197d5b7cd31faba3 = (state)=>state.ui.Errors.isErrorLogDialogOpen;
const $d1646bca6720bb62$export$6b889b3c17f5cdcd = (state)=>state.ui.Errors.isProjectLimitExceeded;

});
parcelRegister("h9JIe", function(module, exports) {
const $4ae053aaa683e198$var$errors = [
    {
        id: 1,
        title: 'Error',
        message: 'Not able to fetch data',
        locationHash: '#plan/backlog',
        locationPath: undefined
    },
    {
        id: 2,
        title: 'Error',
        message: 'Not able to call ReST endpoint',
        locationHash: '#plan/teams',
        locationPath: undefined
    }
];
var $4ae053aaa683e198$export$2e2bcd8739ae039 = $4ae053aaa683e198$var$errors;

});


parcelRegister("8XBh3", function(module, exports) {

$parcel$export(module.exports, "default", () => $198e6920d77e0fbb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $7fcGh = parcelRequire("7fcGh");

var $ewayV = parcelRequire("ewayV");
var /** Report experience failure in the presence of errors
 * with the errorType depending on the kind of the error.
 *
 * Some errors are more likely to be attributed to the environment rather than
 * malfunction of our application.  We'd like to monitor experience failures
 * caused by these errors anyway and action on their spike but we also would
 * like to exclude them from our reliability SLO calculation, hence assigning
 * them dedicated errorType.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$198e6920d77e0fbb$export$2e2bcd8739ae039 = ({ errors: errors, location: location, locationType: locationType, locationPrefix: locationPrefix })=>{
    const basePath = (0, $7fcGh.default)();
    const relevantErrors = errors.filter((error)=>{
        if (locationPrefix === undefined) return true;
        switch(locationType){
            case 'hash':
                return error.locationHash?.startsWith(locationPrefix);
            case 'path':
                return error.locationPath?.startsWith(`${basePath}/${locationPrefix}`);
            default:
                return true;
        }
    });
    if (relevantErrors.length === 0) return null;
    // If at least one error is not caused by the environment
    // then we consider it a regular failure impacting reliability SLO.
    const failureEventAttributes = relevantErrors.every((0, $ewayV.isEnvironmentError)) ? // but in order to keep metric cardinality low we overload meaning of this type.
    {
        errorType: 'networkError'
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: failureEventAttributes
    });
};

});
parcelRegister("7fcGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0089cdf65e56a11$export$2e2bcd8739ae039);

var $kJlBc = parcelRequire("kJlBc");
const $f0089cdf65e56a11$var$useBasePath = ()=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const { planId: planId, scenarioId: scenarioId } = match.params;
    if (!planId) return '/jira/plans';
    if (!scenarioId) return (0, $kJlBc.generatePath)('/jira/plans/:planId', {
        planId: planId
    });
    return (0, $kJlBc.generatePath)('/jira/plans/:planId/scenarios/:scenarioId', {
        planId: planId,
        scenarioId: scenarioId
    });
};
var $f0089cdf65e56a11$export$2e2bcd8739ae039 = $f0089cdf65e56a11$var$useBasePath;

});



parcelRegister("aFXbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f152c3423e38f86$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bt6qG = parcelRequire("bt6qG");

var $1O638 = parcelRequire("1O638");

var $aMdJ0 = parcelRequire("aMdJ0");
var $6f152c3423e38f86$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1O638.default), (0, $bt6qG.default))((0, $aMdJ0.default));

});
parcelRegister("bt6qG", function(module, exports) {

$parcel$export(module.exports, "default", () => $99503bf08b8ed8c3$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");

var $77LR7 = parcelRequire("77LR7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$99503bf08b8ed8c3$export$2e2bcd8739ae039 = (dispatch)=>({
        setIssueBeingEdited: (issueId)=>{
            dispatch((0, $77LR7.setIssueBeingEdited)(issueId));
        },
        setDescription: (issueId, description)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issueId,
                description: description
            }));
        },
        onChange: (payload)=>{
            dispatch((0, $1Szmp.updateIssueRaw)(payload));
        }
    });

});
parcelRegister("1Szmp", function(module, exports) {

$parcel$export(module.exports, "expandAllAnalytics", () => $dc5803bacbec72da$export$479ca0fe8309c04b);
$parcel$export(module.exports, "collapseAllAnalytics", () => $dc5803bacbec72da$export$5ec4bceeee978c7);
$parcel$export(module.exports, "addIssue", () => $dc5803bacbec72da$export$1102f55b777d8730);
$parcel$export(module.exports, "updateIssueRaw", () => $dc5803bacbec72da$export$ea59680060060435);
$parcel$export(module.exports, "updateMultipleIssues", () => $dc5803bacbec72da$export$1b4a9385b5a56903);
$parcel$export(module.exports, "rankIssue", () => $dc5803bacbec72da$export$dbff149eb80fd116);
$parcel$export(module.exports, "bulkRankIssue", () => $dc5803bacbec72da$export$b4a658098853486e);
$parcel$export(module.exports, "moveIssue", () => $dc5803bacbec72da$export$ad9ee5173d066064);
$parcel$export(module.exports, "fetchHistoricalDoneIssues", () => $dc5803bacbec72da$export$3530e2931cb20bc6);
$parcel$export(module.exports, "removeSelectedIssues", () => $dc5803bacbec72da$export$790e3b588d2f43de);
$parcel$export(module.exports, "bulkIssuesUpdate", () => $dc5803bacbec72da$export$e9c4b1a0f7662f95);
$parcel$export(module.exports, "bulkIssuesCRPUpdate", () => $dc5803bacbec72da$export$5c464cc99540bf04);
$parcel$export(module.exports, "updateIssueOrInlineCreate", () => $dc5803bacbec72da$export$f4f7259d29fa9aad);
$parcel$export(module.exports, "doResetIssueRequest", () => $dc5803bacbec72da$export$e856c719fba649e);
$parcel$export(module.exports, "handleIssueCommitResponse", () => $dc5803bacbec72da$export$b52851cef8ec2dd1);
$parcel$export(module.exports, "revertChange", () => $dc5803bacbec72da$export$be623675b8f208ee);
$parcel$export(module.exports, "getHiddenIssues", () => $dc5803bacbec72da$export$ea11170f6eef9668);
$parcel$export(module.exports, "getHistoricalDoneIssues", () => $dc5803bacbec72da$export$22cefaeb4a8d245f);
$parcel$export(module.exports, "default", () => $dc5803bacbec72da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setIsExpanded", () => (parcelRequire("c7fhc")).setIsExpanded);
$parcel$export(module.exports, "ADD_ISSUE", () => $83cf706a87a62789$export$242fccfb90c57247);
$parcel$export(module.exports, "BULK_ISSUES_UPDATE", () => $83cf706a87a62789$export$b6c322dbc4f2f8ac);
$parcel$export(module.exports, "COLLAPSE_ALL_ANALYTICS_ACTION", () => $83cf706a87a62789$export$39babeb2e7944629);
$parcel$export(module.exports, "EXPAND_ALL_ANALYTICS_ACTION", () => $83cf706a87a62789$export$20130dbd048fc414);
$parcel$export(module.exports, "RANK_ISSUE", () => $83cf706a87a62789$export$9bbbeac0bf5bf14);
$parcel$export(module.exports, "UPDATE_ISSUE", () => $83cf706a87a62789$export$d46fd8e9a2a59b28);

var $aeXAa = parcelRequire("aeXAa");
var $itLT6 = parcelRequire("itLT6");
var $hkOxK = parcelRequire("hkOxK");
var $9FeHi = parcelRequire("9FeHi");
var $8K6YM = parcelRequire("8K6YM");
var $jPCDz = parcelRequire("jPCDz");
var $l0L3x = parcelRequire("l0L3x");
var $dspDs = parcelRequire("dspDs");
var $dfCnd = parcelRequire("dfCnd");
var $cQwal = parcelRequire("cQwal");
var $3by2Y = parcelRequire("3by2Y");
var $3IGDG = parcelRequire("3IGDG");
var $659jj = parcelRequire("659jj");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");

var $kP3Wn = parcelRequire("kP3Wn");

var $kXdPE = parcelRequire("kXdPE");

var $jyOCP = parcelRequire("jyOCP");

var $j5GRN = parcelRequire("j5GRN");

var $cbq3D = parcelRequire("cbq3D");

var $iTjRl = parcelRequire("iTjRl");
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");

var $051m9 = parcelRequire("051m9");

var $dC8ep = parcelRequire("dC8ep");
parcelRequire("bJc6r");
var $hs46g = parcelRequire("hs46g");

var $akhOi = parcelRequire("akhOi");

var $2Ruxt = parcelRequire("2Ruxt");

var $kKj1m = parcelRequire("kKj1m");

var $5fUv6 = parcelRequire("5fUv6");

var $6UAvZ = parcelRequire("6UAvZ");
parcelRequire("cwMfk");
var $lxd1S = parcelRequire("lxd1S");

var $94enn = parcelRequire("94enn");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");
parcelRequire("75KhQ");
var $eOsHk = parcelRequire("eOsHk");
var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $dhHiZ = parcelRequire("dhHiZ");

var $fr1nu = parcelRequire("fr1nu");

var $bfLCp = parcelRequire("bfLCp");

var $1umd3 = parcelRequire("1umd3");

var $lhX0J = parcelRequire("lhX0J");

var $77LR7 = parcelRequire("77LR7");

var $kt7Vd = parcelRequire("kt7Vd");

var $kIUsy = parcelRequire("kIUsy");

var $lwKA5 = parcelRequire("lwKA5");

var $9ZuLc = parcelRequire("9ZuLc");

var $xlOmi = parcelRequire("xlOmi");

var $2oZqS = parcelRequire("2oZqS");

var $9LVH6 = parcelRequire("9LVH6");

var $7WQG5 = parcelRequire("7WQG5");

var $264LW = parcelRequire("264LW");

var $eBGH3 = parcelRequire("eBGH3");

var $c7fhc = parcelRequire("c7fhc");

var $6owOg = parcelRequire("6owOg");
var $5Cso7 = parcelRequire("5Cso7");


var $ewayV = parcelRequire("ewayV");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $13pyJ = parcelRequire("13pyJ");

var $jMP2a = parcelRequire("jMP2a");

var $gUMnJ = parcelRequire("gUMnJ");


var $57pw5 = parcelRequire("57pw5");
const $dc5803bacbec72da$export$57c7dfb729a4eb26 = 'command.issue.UPDATE_INLINE_CREATE_ISSUE';
function $dc5803bacbec72da$var$isHandleCommitResponseMethod(res) {
    return typeof res === 'function';
}
const $dc5803bacbec72da$var$handleCommitResponse = (payload)=>({
        type: $83cf706a87a62789$export$563a5374cb06df7d,
        payload: payload
    });
const $dc5803bacbec72da$export$479ca0fe8309c04b = (payload)=>({
        type: $83cf706a87a62789$export$20130dbd048fc414,
        payload: payload
    });
const $dc5803bacbec72da$export$5ec4bceeee978c7 = (payload)=>({
        type: $83cf706a87a62789$export$39babeb2e7944629,
        payload: payload
    });
const $dc5803bacbec72da$export$1102f55b777d8730 = (payload)=>({
        type: $83cf706a87a62789$export$242fccfb90c57247,
        payload: payload
    });
const $dc5803bacbec72da$export$ea59680060060435 = (payload)=>({
        type: $83cf706a87a62789$export$d46fd8e9a2a59b28,
        payload: payload
    });
const $dc5803bacbec72da$export$1b4a9385b5a56903 = (payload)=>({
        type: $83cf706a87a62789$export$254f30e4f720be90,
        payload: payload
    });
const $dc5803bacbec72da$export$dbff149eb80fd116 = (payload)=>({
        type: $83cf706a87a62789$export$9bbbeac0bf5bf14,
        payload: payload
    });
const $dc5803bacbec72da$export$b4a658098853486e = (payload)=>({
        type: $83cf706a87a62789$export$85b6c4937eed754f,
        payload: payload
    });
const $dc5803bacbec72da$export$ad9ee5173d066064 = (payload)=>({
        type: $83cf706a87a62789$export$269d7b2720ef5d5e,
        payload: payload
    });
const $dc5803bacbec72da$export$49eb640c284e8826 = (payload)=>({
        type: $83cf706a87a62789$export$ce69e6c9d4cdf606,
        payload: payload
    });
const $dc5803bacbec72da$export$3530e2931cb20bc6 = ()=>({
        type: $83cf706a87a62789$export$7dc711c48e3c938f
    });
const $dc5803bacbec72da$export$790e3b588d2f43de = ()=>({
        type: $83cf706a87a62789$export$35cae9f1acacb606
    });
const $dc5803bacbec72da$export$e9c4b1a0f7662f95 = (payload)=>({
        type: $83cf706a87a62789$export$b6c322dbc4f2f8ac,
        payload: payload
    });
const $dc5803bacbec72da$export$5c464cc99540bf04 = (cprId)=>({
        type: $83cf706a87a62789$export$4c343341eb9052e8,
        cprId: cprId
    });
const $dc5803bacbec72da$export$f4f7259d29fa9aad = (payload)=>({
        type: $dc5803bacbec72da$export$57c7dfb729a4eb26,
        payload: payload
    });
const $dc5803bacbec72da$export$2418b445b82e0c8f = (payload)=>({
        type: $83cf706a87a62789$export$868e118e8d9234f,
        payload: payload
    });
function* $dc5803bacbec72da$export$4884fd84d9484e78(// eslint-disable-next-line @typescript-eslint/no-explicit-any
block, promise) {
    if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $9e8i2.call)(block);
    try {
        const result = yield (0, $9e8i2.call)(block);
        promise.resolve(result); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        promise.reject(err);
    }
}
function* $dc5803bacbec72da$var$doUpdateIssueOrInlineCreate({ payload: payload }) {
    if (payload.id === (0, $lxd1S.INLINE_CREATE_ID)) {
        const { id: id, lexoRank: lexoRank, level: level, summary: summary, type: type, ...slimPayload } = payload;
        return yield (0, $9e8i2.put)((0, $dr4qD.updateInlineCreate)({
            ...slimPayload
        }));
    }
    return yield (0, $9e8i2.put)($dc5803bacbec72da$export$ea59680060060435(payload));
}
function* $dc5803bacbec72da$export$a6f3b2da528d4c39({ payload: payload }) {
    const issueMap = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
    const issue = issueMap[payload.issueId];
    if (!issue) return;
    if (issue.level === (0, $8YqJS.SUB_TASK_LEVEL)) {
        // payload issue is a subtask, which happens when a subtask is moved from one story to another
        // we need to look up the team value from its parent issue
        const parent = issue.parent;
        if ((0, $7CnHa.isDefined)(parent) && (0, $7CnHa.isDefined)(issueMap[parent])) {
            const parentIssue = issueMap[parent];
            const updatedValues = {
                id: issue.id
            };
            let changed = false;
            if (issue.team !== parentIssue.team) {
                updatedValues.team = parentIssue.team;
                changed = true;
            }
            if (issue.sprint !== parentIssue.sprint) {
                updatedValues.sprint = parentIssue.sprint;
                changed = true;
            }
            if (changed) yield (0, $9e8i2.put)((0, $kt7Vd.update)(updatedValues));
        }
    } else {
        // payload issue is a story, which happens when the team of a story is updated
        // we need to refresh all its subtasks
        const { team: team, sprint: sprint } = issue;
        const { fields: fields } = payload;
        for (const issueId of Object.keys(issueMap)){
            const curIssue = issueMap[issueId];
            if (curIssue.parent === issue.id && curIssue.level === (0, $8YqJS.SUB_TASK_LEVEL)) {
                const updatedValues = {
                    id: curIssue.id
                };
                if ((0, $7CnHa.isDefined)(fields) && fields.team && curIssue.team !== team) updatedValues.team = team;
                if ((0, $7CnHa.isDefined)(fields) && fields.sprint && curIssue.sprint !== sprint) updatedValues.sprint = sprint;
                if ((0, $7CnHa.isDefined)(updatedValues.team) || (0, $7CnHa.isDefined)(updatedValues.sprint)) yield (0, $9e8i2.put)((0, $kt7Vd.update)(updatedValues));
            }
        }
    }
}
const $dc5803bacbec72da$export$60287b88963120b6 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
payload, dateConfiguration)=>// eslint-disable-next-line @typescript-eslint/no-shadow
    [
        'baselineStart',
        'baselineEnd'
    ].reduce((payload, field)=>{
        if (!$jPCDz.default(field, payload)) return payload;
        const { key: key, type: type } = dateConfiguration[`${field}Field`];
        const path = type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM ? [
            'customFields',
            key
        ] : [
            key
        ];
        const value = payload[field];
        // Remove changes of baseline dates and associate them to changes of configured dates
        return $hkOxK.default($8K6YM.default(field), $itLT6.default(path, value))(payload);
    }, payload);
function* $dc5803bacbec72da$export$d4ec0482ae4b1f56(payload) {
    const dateConfiguration = yield (0, $9e8i2.select)((0, $75KhQ.getDateConfiguration));
    return $dc5803bacbec72da$export$60287b88963120b6(payload, dateConfiguration);
}
function* $dc5803bacbec72da$export$3de94ba9de434e56({ payload: { issue: newIssue, sibling: sibling, skipRanking: skipRanking = false } }) {
    try {
        const issue = yield (0, $9e8i2.call)($dc5803bacbec72da$export$d4ec0482ae4b1f56, newIssue);
        const url = (0, $gUMnJ.urls).add;
        const body = (0, $gUMnJ.addIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), issue);
        yield (0, $9e8i2.put)((0, $6owOg.setIsSaving)(true));
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        else {
            const result = yield (0, $9e8i2.call)(response.json.bind(response));
            const { itemKey: id } = result;
            const apiIssue = {
                ...issue,
                id: id
            };
            yield* (0, $kXdPE.default)(function*() {
                yield (0, $9e8i2.put)((0, $dr4qD.setSiblingId)(id));
                yield (0, $9e8i2.put)((0, $kt7Vd.add)(apiIssue));
                yield (0, $9e8i2.put)($dc5803bacbec72da$export$49eb640c284e8826({
                    id: id
                }));
                const issues = yield (0, $9e8i2.select)((0, $40hi6.getSortedIssues));
                if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') || !skipRanking) // For issue create externally triggered from the program board, there will be a separate rank request to make sure both apps could do the required optimistic updates
                yield (0, $9e8i2.put)($dc5803bacbec72da$export$dbff149eb80fd116((0, $57pw5.getAddedIssueRankPayload)(apiIssue, issues, sibling)));
                yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
                if (issue.level === (0, $8YqJS.SUB_TASK_LEVEL)) yield (0, $9e8i2.put)($dc5803bacbec72da$export$2418b445b82e0c8f({
                    issueId: id
                }));
            });
            if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && result) return result;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)((0, $6owOg.setIsSaving)(false));
    }
}
function* $dc5803bacbec72da$export$4c5f4cf5d27c16aa(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$4884fd84d9484e78, function*() {
        return yield (0, $9e8i2.call)($dc5803bacbec72da$export$3de94ba9de434e56, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $dc5803bacbec72da$export$44a4abb35fa185ab({ payload: payload, issue: issue, originalProperties: originalProperties }) {
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = yield (0, $9e8i2.select)((0, $75KhQ.getDateConfiguration));
    const labelCustomFieldIds = yield (0, $9e8i2.select)((0, $kKj1m.getCustomLabelFieldIds));
    let issueBaselineEnd = null;
    if (baselineEndField.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    issueBaselineEnd = issue[baselineEndField.key];
    else if ((0, $7CnHa.isDefined)(issue.customFields)) issueBaselineEnd = issue.customFields[baselineEndField.key];
    yield* (0, $kXdPE.default)(function*() {
        yield (0, $9e8i2.put)($dc5803bacbec72da$export$49eb640c284e8826(issue.issueKey ? originalProperties : {
            id: issue.id
        }));
        const updatedProperties = Object.keys(payload);
        if ((0, $7CnHa.isDefined)(payload.customFields)) updatedProperties.push(...Object.keys(payload.customFields));
        if (updatedProperties.includes(baselineStartField.key) && !(0, $7CnHa.isDefined)(issueBaselineEnd) || updatedProperties.includes(baselineEndField.key) || updatedProperties.includes('fixVersions') || updatedProperties.includes('sprint')) {
            const issueVersions = issue.fixVersions || [];
            const payloadVersions = payload.fixVersions || [];
            for (const version of new Set([
                ...issueVersions,
                ...payloadVersions
            ]))yield (0, $9e8i2.put)((0, $051m9.calculateReleaseStatus)(version));
        }
        const customLabelFieldIds = $dspDs.default(updatedProperties, labelCustomFieldIds);
        if (customLabelFieldIds.length > 0) for (const customLabelFieldId of customLabelFieldIds){
            const originalCustomLabels = issue.customFields && issue.customFields[customLabelFieldId] || [];
            const newCustomLabels = payload.customFields && payload.customFields[customLabelFieldId] || [];
            const newAddedLabels = $9FeHi.default(newCustomLabels, originalCustomLabels);
            yield (0, $9e8i2.put)((0, $bfLCp.add)({
                customFieldId: Number(customLabelFieldId),
                labels: newAddedLabels
            }));
        }
        if (updatedProperties.includes('labels')) {
            const issueLabelsInStore = new Set((yield (0, $9e8i2.select)((0, $94enn.getIssueLabels))));
            const originalIssueLabels = issue.labels || [];
            let newIssueLabels = payload.labels || [];
            // If we are bulk updating labels, the payload is different.
            // This is needed so that ARJ has the new labels that may have been created in bulk edit labels without refreshing
            if (payload.labels?.fieldAction) newIssueLabels = payload.labels?.value || [];
            const addedLabels = $9FeHi.default(newIssueLabels, originalIssueLabels);
            for (const addedLabel of addedLabels)if (!issueLabelsInStore.has(addedLabel)) yield (0, $9e8i2.put)($lhX0J.add(addedLabel));
        }
    });
}
function* $dc5803bacbec72da$export$acda8c54b266b88a(body) {
    try {
        const url = (0, $gUMnJ.urls).update;
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dc5803bacbec72da$export$e856c719fba649e(body) {
    try {
        const url = (0, $gUMnJ.urls).update;
        const resetStatusResponse = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!resetStatusResponse.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(resetStatusResponse, (yield (0, $9e8i2.call)(resetStatusResponse.text.bind(resetStatusResponse)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: resetStatusResponse.status,
                body: body
            }
        }));
        else {
            const data = yield (0, $9e8i2.call)(resetStatusResponse.json.bind(resetStatusResponse));
            const { change: { sequence: sequence }, failed: failed } = data;
            if (failed > 0) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: 'Failed to reset issue scenario changes'
            }));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        }
        yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
        return resetStatusResponse;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dc5803bacbec72da$export$edf4c125212bfd66({ payload: { promise: promise, ...payload } }) {
    const issue = (yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById)))[payload.id];
    let updatedValues = payload;
    if ($jPCDz.default('baselineStart', payload) || $jPCDz.default('baselineEnd', payload)) updatedValues = yield (0, $9e8i2.call)($dc5803bacbec72da$export$d4ec0482ae4b1f56, payload);
    const originalProperties = (0, $57pw5.getOriginalProperties)(issue, updatedValues);
    if (!originalProperties) return;
    // for updating status, need to pass the statusTransition to the BE, but for the FE, we don't
    // need add the statusTransition field to the issue model which will mess up the changes of the issue, so
    // we need to get rid of the statusTransition in here
    if ($jPCDz.default('statusTransition', payload)) {
        const updatedValuesWithoutStatusTransition = $cQwal.default([
            'statusTransition'
        ], updatedValues);
        yield (0, $9e8i2.put)((0, $kt7Vd.update)(updatedValuesWithoutStatusTransition));
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$44a4abb35fa185ab, {
            payload: updatedValuesWithoutStatusTransition,
            issue: issue,
            originalProperties: originalProperties
        });
    } else {
        if (updatedValues.goals) {
            const newGoals = updatedValues.goals.map((value)=>value.id);
            const newUpdatedValues = {
                ...updatedValues
            };
            newUpdatedValues.goals = newGoals;
            yield (0, $9e8i2.put)((0, $kt7Vd.update)(newUpdatedValues));
        } else yield (0, $9e8i2.put)((0, $kt7Vd.update)(updatedValues));
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$44a4abb35fa185ab, {
            payload: updatedValues,
            issue: issue,
            originalProperties: originalProperties
        });
    }
    const parentUpdatedForSubtask = issue.level === (0, $8YqJS.SUB_TASK_LEVEL) && ($jPCDz.default('parent', updatedValues) || $jPCDz.default('parent', originalProperties));
    const teamUpdatedForStandardIssue = issue.level === (0, $8YqJS.STORY_LEVEL) && ($jPCDz.default('team', updatedValues) || $jPCDz.default('team', originalProperties));
    const sprintUpdatedForStandardIssue = issue.level === (0, $8YqJS.STORY_LEVEL) && ($jPCDz.default('sprint', updatedValues) || $jPCDz.default('sprint', originalProperties));
    if (teamUpdatedForStandardIssue || sprintUpdatedForStandardIssue || parentUpdatedForSubtask) yield (0, $9e8i2.put)($dc5803bacbec72da$export$2418b445b82e0c8f({
        issueId: issue.id,
        fields: {
            team: teamUpdatedForStandardIssue || parentUpdatedForSubtask,
            sprint: sprintUpdatedForStandardIssue || parentUpdatedForSubtask
        }
    }));
    const body = (0, $gUMnJ.updateIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), updatedValues);
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$acda8c54b266b88a, body);
}
function* $dc5803bacbec72da$export$5c6a7a448f6c7ede(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$4884fd84d9484e78, function*() {
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$edf4c125212bfd66, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $dc5803bacbec72da$export$a659eeffaf0169f6({ payload: payload }) {
    for (const issueId of Object.keys(payload))yield (0, $9e8i2.call)($dc5803bacbec72da$export$edf4c125212bfd66, {
        type: $83cf706a87a62789$export$d46fd8e9a2a59b28,
        payload: {
            ...payload[issueId],
            id: issueId
        }
    });
}
function* $dc5803bacbec72da$export$960787e2a2dfab5e({ payload: { issueIds: issueIds, ...payload } }) {
    const itemKeys = [];
    let updatedValues = payload;
    if ($jPCDz.default('baselineStart', payload) || $jPCDz.default('baselineEnd', payload)) updatedValues = yield (0, $9e8i2.call)($dc5803bacbec72da$export$d4ec0482ae4b1f56, payload);
    if ($jPCDz.default('estimate', payload)) {
        const { planningUnit: planningUnit } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const workingHours = yield (0, $9e8i2.select)((0, $dhHiZ.getJiraHoursPerDay));
        const propName = planningUnit === (0, $5rYNM.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
        const estimate = payload.clearEstimates ? null : (0, $5fUv6.convertEstimate)(planningUnit, payload.estimate, workingHours);
        updatedValues = $3IGDG.default($8K6YM.default('estimate'), $aeXAa.default(propName, estimate))(updatedValues);
    }
    yield* (0, $kXdPE.default)(function*() {
        const issueMapById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
        const selectedIssues = issueIds && issueIds.length ? issueIds.map((issueId)=>issueMapById[issueId]).filter(Boolean) : yield (0, $9e8i2.select)((0, $kwMvv.getSelectedIssues));
        for (const issue of selectedIssues){
            const originalProperties = (0, $57pw5.getOriginalProperties)(issue, {
                ...updatedValues,
                id: issue.id
            });
            if (originalProperties) {
                itemKeys.push(issue.id);
                yield (0, $9e8i2.call)($dc5803bacbec72da$export$44a4abb35fa185ab, {
                    payload: updatedValues,
                    issue: issue,
                    originalProperties: originalProperties
                });
            }
        }
        if (itemKeys.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const bulkUpdatePayload = selectedIssues.reduce((acc, issue)=>Object.assign(acc, {
                    [issue.id]: {
                        ...updatedValues
                    }
                }), {});
            if ($jPCDz.default('labels', updatedValues)) yield (0, $9e8i2.put)((0, $kt7Vd.bulkLabelUpdate)(bulkUpdatePayload));
            else yield (0, $9e8i2.put)((0, $kt7Vd.bulkUpdate)(bulkUpdatePayload));
            if ($jPCDz.default('parent', updatedValues)) yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
                isSelected: false,
                toggleAll: true,
                ids: []
            }));
            const teamUpdated = $jPCDz.default('team', updatedValues);
            const sprintUpdated = $jPCDz.default('sprint', updatedValues);
            if (teamUpdated || sprintUpdated) yield (0, $9e8i2.all)(itemKeys.map((itemKey)=>(0, $9e8i2.put)($dc5803bacbec72da$export$2418b445b82e0c8f({
                    issueId: itemKey,
                    fields: {
                        team: teamUpdated,
                        sprint: sprintUpdated
                    }
                }))));
        }
    });
    if (itemKeys.length) {
        const body = (0, $gUMnJ.updateIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), updatedValues, itemKeys);
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$acda8c54b266b88a, body);
    }
}
function* $dc5803bacbec72da$export$cfff686a68dd7df4(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$4884fd84d9484e78, function*() {
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$960787e2a2dfab5e, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $dc5803bacbec72da$export$5bf0bb972a681b23({ cprId: cprId }) {
    const projectsById = yield (0, $9e8i2.select)((0, $ehEr2.getProjectsById));
    const selectedIssuesByProject = yield (0, $9e8i2.select)((0, $kwMvv.getSelectedIssuesByProjectId));
    const crossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getCrossProjectVersionsById));
    const versionsInCPR = crossProjectVersionsById[cprId].versions;
    const releaseToSelectedIssuesMap = Object.keys(selectedIssuesByProject).reduce((data, projectId)=>{
        const releaseInCPR = projectsById[projectId].versions.find((projectVersion)=>versionsInCPR.includes(projectVersion));
        return data.set(releaseInCPR, selectedIssuesByProject[projectId]);
    }, new Map());
    for (const [versionId, selectedIssues] of releaseToSelectedIssuesMap){
        const itemKeys = [];
        const updatedValue = {
            fixVersions: [
                versionId
            ]
        };
        yield* (0, $kXdPE.default)(function*() {
            for (const issue of selectedIssues){
                const originalProperties = (0, $57pw5.getOriginalProperties)(issue, {
                    ...updatedValue,
                    id: issue.id
                });
                if (originalProperties) {
                    itemKeys.push(issue.id);
                    yield (0, $9e8i2.call)($dc5803bacbec72da$export$44a4abb35fa185ab, {
                        payload: updatedValue,
                        issue: issue,
                        originalProperties: originalProperties
                    });
                }
            }
            if (itemKeys.length) {
                const bulkUpdatePayload = selectedIssues.reduce((acc, issue)=>Object.assign(acc, {
                        [issue.id]: updatedValue
                    }), {});
                yield (0, $9e8i2.put)((0, $kt7Vd.bulkUpdate)(bulkUpdatePayload));
            }
        });
        if (itemKeys.length) {
            const body = (0, $gUMnJ.updateIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), updatedValue, itemKeys);
            yield (0, $9e8i2.call)($dc5803bacbec72da$export$acda8c54b266b88a, body);
        }
    }
}
function* $dc5803bacbec72da$export$6ebbd47a62a9e98e(body) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = yield* $iTjRl.jsonOrError({
        url: (0, $gUMnJ.urls).rank,
        body: body,
        method: 'POST'
    });
    if (!response.ok) return;
    const { change: { sequence: sequence }, failed: failed } = response.data;
    if (failed > 0) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: 'Failed to rank some issues'
        }));
        return;
    }
    yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
}
function* $dc5803bacbec72da$export$c66886d54bda95a1({ payload: payload }) {
    yield* (0, $kXdPE.default)(function*() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { id: id, lexoRank: lexoRank } = (yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById)))[payload.itemKeys[0]];
        yield (0, $9e8i2.put)($dc5803bacbec72da$export$49eb640c284e8826({
            id: id,
            lexoRank: lexoRank
        }));
        yield (0, $9e8i2.put)((0, $kt7Vd.rank)(payload));
        yield (0, $9e8i2.put)((0, $kIUsy.adjustLexoRank)(payload));
    });
    const body = (0, $gUMnJ.rankIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$6ebbd47a62a9e98e, body);
}
function* $dc5803bacbec72da$export$bb03c5769232d24c(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$4884fd84d9484e78, function*() {
        yield (0, $9e8i2.call)($dc5803bacbec72da$export$c66886d54bda95a1, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $dc5803bacbec72da$export$6c983680b0561560({ payload: payload }) {
    const issues = yield (0, $9e8i2.select)((0, $kwMvv.getAllSortedIssues));
    const issueIndexById = issues.reduce((acc, { id: id }, index)=>{
        acc[id] = index;
        return acc;
    }, {});
    const selectedIssues = $659jj.default([
        (a, b)=>issueIndexById[a.id] - issueIndexById[b.id]
    ], (yield (0, $9e8i2.select)((0, $kwMvv.getSelectedIssues))));
    const bulkPayload = (0, $57pw5.getBulkRankPayload)(payload, selectedIssues.map(({ id: id })=>id), issues);
    if (!bulkPayload) return;
    yield* (0, $kXdPE.default)(function*() {
        for (const { id: id, lexoRank: lexoRank } of selectedIssues)yield (0, $9e8i2.put)($dc5803bacbec72da$export$49eb640c284e8826({
            id: id,
            lexoRank: lexoRank
        }));
        yield (0, $9e8i2.put)((0, $kt7Vd.bulkRank)(bulkPayload));
        yield (0, $9e8i2.put)((0, $kIUsy.bulkAdjustLexoRank)(bulkPayload));
    });
    const body = (0, $gUMnJ.rankIssueBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), bulkPayload);
    yield (0, $9e8i2.call)($dc5803bacbec72da$export$6ebbd47a62a9e98e, body);
}
const $dc5803bacbec72da$export$9623ca1d58f4559a = (issues, descendantsMap, isExpanded, payload, hierarchy)=>{
    const { anchor: anchor, dragAndDrop: dragAndDrop, group: group, id: id, parentId: parentId, relation: relation } = payload;
    const movedIssue = issues.find((issue)=>issue.id === id);
    if (!movedIssue) throw new Error('Issue is not found. Have you dropped it into the Trash?');
    const actions = [];
    const parentIssue = issues.find((issue)=>issue.id === parentId);
    if (parentIssue) {
        const issueMap = (0, $cwP4d.createIssueMapByIdPure)(issues);
        const parentAncestors = (0, $kwMvv.getAncestors)(parentIssue, issueMap, Infinity);
        for (const descendantIssueId of descendantsMap[id] || [])// check if descendant issues are in ancestor issues
        if (parentAncestors.find((ancestorIssue)=>descendantIssueId === ancestorIssue.id) || descendantIssueId === parentId) {
            // prevent infinite loop
            actions.push($dc5803bacbec72da$export$ea59680060060435({
                id: descendantIssueId,
                parent: undefined
            }));
            actions.push((0, $1umd3.updateParent)({
                id: descendantIssueId,
                parent: undefined,
                isDragAndDrop: dragAndDrop
            }));
            break;
        }
    }
    if (!anchor) {
        // issue was moved to the empty group
        if (movedIssue.parent) {
            actions.push($dc5803bacbec72da$export$ea59680060060435({
                id: id,
                parent: undefined
            }));
            actions.push((0, $1umd3.updateParent)({
                id: id,
                parent: undefined,
                isDragAndDrop: dragAndDrop
            }));
        }
        return actions;
    }
    if (parentId !== movedIssue.parent && hierarchy.value.start !== movedIssue.level) {
        actions.push($dc5803bacbec72da$export$ea59680060060435({
            id: id,
            parent: parentId
        }));
        actions.push((0, $1umd3.updateParent)({
            id: id,
            parent: parentId,
            isDragAndDrop: dragAndDrop
        }));
    }
    if (parentId) {
        const parentIdKey = group ? `${parentId}:${group}` : parentId;
        if (!isExpanded[parentIdKey]) {
            actions.push((0, $c7fhc.setIsExpanded)({
                [`${parentIdKey}`]: true
            }));
            // if the new parent is collapsed we want to move issue to the bottom of its children list
            const children = issues.filter(({ parent: parent })=>parent === parentId);
            const lastChild = $dfCnd.default(children);
            if (lastChild) {
                actions.push($dc5803bacbec72da$export$dbff149eb80fd116({
                    itemKeys: [
                        id
                    ],
                    anchor: lastChild.id,
                    relation: 'AFTER'
                }));
                return actions;
            }
        }
    }
    if (dragAndDrop) actions.push($dc5803bacbec72da$export$dbff149eb80fd116({
        itemKeys: [
            id
        ],
        anchor: anchor,
        relation: relation,
        dragAndDrop: dragAndDrop
    }));
    else actions.push($dc5803bacbec72da$export$dbff149eb80fd116({
        itemKeys: [
            id
        ],
        anchor: anchor,
        relation: relation
    }));
    return actions;
};
function* $dc5803bacbec72da$export$26dc99c947cf00be({ payload: payload }) {
    const issues = yield (0, $9e8i2.select)((0, $40hi6.getSortedIssues));
    const descendantsMap = yield (0, $9e8i2.select)((0, $kwMvv.getDescendantIdsByParent));
    const isExpanded = yield (0, $9e8i2.select)((0, $40hi6.getIsExpanded));
    const hierarhy = yield (0, $9e8i2.select)((0, $6UAvZ.getHierarchyFilter));
    const actions = yield (0, $9e8i2.call)($dc5803bacbec72da$export$9623ca1d58f4559a, issues, descendantsMap, isExpanded, payload, hierarhy);
    yield (0, $9e8i2.all)(actions.map((action)=>(0, $9e8i2.put)(action)));
}
function* $dc5803bacbec72da$export$fc3e038178ab21fa({ payload: payload }) {
    let updatedValues = payload;
    if ($jPCDz.default('baselineStart', payload) || $jPCDz.default('baselineEnd', payload)) updatedValues = yield (0, $9e8i2.call)($dc5803bacbec72da$export$d4ec0482ae4b1f56, payload);
    yield (0, $9e8i2.put)((0, $lwKA5.update)(updatedValues));
    yield (0, $9e8i2.put)((0, $xlOmi.increment)([
        'issues'
    ]));
}
function* $dc5803bacbec72da$var$doCommitRequest(issueId, notifyWatchers, generatedItemId) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.commitBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, issueId, generatedItemId, notifyWatchers);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = yield* $iTjRl.json({
        url: (0, $gUMnJ.urls).commitChanges,
        profile: (0, $gUMnJ.urls).commitChanges,
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence }, error: error, entity: entity = {}, id: id } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        if ($dc5803bacbec72da$var$isHandleCommitResponseMethod($dc5803bacbec72da$var$handleCommitResponse)) {
            const finalAction = $dc5803bacbec72da$var$handleCommitResponse({
                change: {
                    sequence: sequence
                },
                error: error,
                entity: entity,
                id: id
            });
            yield (0, $9e8i2.put)(finalAction);
            return finalAction;
        }
    }
    return {
        type: $83cf706a87a62789$export$15027aa3e935638c,
        payload: response
    };
}
// show status change screen
function* $dc5803bacbec72da$var$doShowChangeStatusScreen(issueId, issueKeyInJira, transitionId) {
    if ((0, $7CnHa.isDefined)(issueKeyInJira) && (0, $7CnHa.isDefined)(transitionId)) {
        yield (0, $9e8i2.put)((0, $2oZqS.load)({
            issueKeyInJira: issueKeyInJira,
            transitionId: transitionId,
            issueId: issueId
        }));
        // listen to the result of the status transition dialog, success/cancel/fail to update status
        const changeStatusResult = yield (0, $9e8i2.take)([
            (0, $2oZqS.SUCCESS),
            (0, $2oZqS.CANCEL),
            (0, $2oZqS.FAIL)
        ]);
        if (changeStatusResult.type === (0, $2oZqS.SUCCESS)) {
            // Transition screen dialog directly communicate with Jira, so when user submit it,
            // the status has changed in Jira, then we should reset the status scenario changed in the ARJ
            const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
            const body = {
                itemKeys: [
                    issueId
                ],
                planId: planId,
                scenarioId: scenarioId,
                description: {
                    status: {
                        reset: true
                    },
                    statusTransition: {
                        reset: true
                    }
                }
            };
            yield (0, $9e8i2.call)($dc5803bacbec72da$export$e856c719fba649e, body);
        } else if (changeStatusResult.type === (0, $2oZqS.CANCEL)) yield (0, $9e8i2.put)((0, $9LVH6.interrupt)());
        else if (changeStatusResult.type === (0, $2oZqS.FAIL)) {
            yield (0, $9e8i2.put)((0, $9LVH6.interrupt)());
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: 'Jira failed to transition the status'
            }));
        }
        return changeStatusResult;
    }
}
function* $dc5803bacbec72da$var$doUpdateIssueKey(issueId, generatedItemId) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const id = generatedItemId ? parseInt(generatedItemId, 10) : null;
    if (id == null || Number.isNaN(id)) // We just return 400 here to save a call
    // The api types allow it but cleary this is invalid and the response will break anyway
    return {
        type: $83cf706a87a62789$export$15027aa3e935638c,
        payload: {
            ok: false,
            status: 400,
            error: 'MANUAL_CREATE_ID_INVALID'
        }
    };
    const response = yield* $iTjRl.json({
        url: (0, $gUMnJ.urls).updateIssueKey,
        method: (0, $kP3Wn.POST),
        body: {
            planId: planId,
            scenarioId: currentScenarioId,
            itemKey: issueId,
            generatedItemId: generatedItemId
        }
    });
    if (response.ok && response.data.success) {
        const { change: change } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(change.sequence));
        if ($dc5803bacbec72da$var$isHandleCommitResponseMethod($dc5803bacbec72da$var$handleCommitResponse)) {
            const finalAction = $dc5803bacbec72da$var$handleCommitResponse({
                change: change,
                entity: {},
                id: id
            });
            yield (0, $9e8i2.put)(finalAction);
            return finalAction;
        }
    }
    return {
        type: $83cf706a87a62789$export$15027aa3e935638c,
        payload: response
    };
}
function* $dc5803bacbec72da$var$doManualCreate(issueId, loadError, notifyWatchers) {
    yield (0, $9e8i2.put)((0, $264LW.load)({
        issueId: issueId,
        error: loadError
    }));
    const manualCreateResult = yield (0, $9e8i2.take)([
        (0, $264LW.SUBMIT),
        (0, $264LW.CANCEL),
        (0, $264LW.FAIL)
    ]);
    const analyticsEvent = yield (0, $9e8i2.select)((0, $akhOi.getAnalyticsEvent));
    if (manualCreateResult.type === (0, $264LW.SUBMIT)) {
        const { generatedItemId: generatedItemId } = manualCreateResult.payload;
        // isArjGicPrefilledDataHandlingEnabled clean up , this should become a constant
        let commitRetryResponse;
        if (!!generatedItemId && generatedItemId !== issueId) yield (0, $9e8i2.put)($fr1nu.updateIssueReferences({
            oldId: issueId,
            newId: generatedItemId
        }));
        if ((0, $hs46g.default)()) commitRetryResponse = yield (0, $9e8i2.call)($dc5803bacbec72da$var$doUpdateIssueKey, issueId, generatedItemId);
        else commitRetryResponse = yield (0, $9e8i2.call)($dc5803bacbec72da$var$doCommitRequest, issueId, notifyWatchers, generatedItemId);
        if (commitRetryResponse.type === $83cf706a87a62789$export$563a5374cb06df7d) {
            const { error: error, entity: entity } = commitRetryResponse.payload;
            const internalEntity = entity && entity.entity;
            const warnings = yield (0, $9e8i2.call)((0, $j5GRN.inspectForCommitWarnings), internalEntity, error);
            if (warnings.length) {
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateFailedWithWarnings', {
                    error: loadError?.error
                });
                yield (0, $9e8i2.put)((0, $eBGH3.add)({
                    category: (0, $5rYNM.ENTITY).ISSUE,
                    itemId: issueId,
                    warnings: warnings
                }));
            } else (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateSuccess', {
                error: loadError?.error
            });
        } else if (commitRetryResponse.type === $83cf706a87a62789$export$15027aa3e935638c) yield (0, $9e8i2.put)((0, $eBGH3.add)({
            category: (0, $5rYNM.ENTITY).ISSUE,
            itemId: issueId,
            warnings: [
                (0, $j5GRN.defaultWarning)
            ]
        }));
    } else if (manualCreateResult.type === (0, $264LW.CANCEL)) {
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateCancelled', {
            error: loadError?.error
        });
        yield (0, $9e8i2.put)((0, $9LVH6.interrupt)());
    } else if (manualCreateResult.type === (0, $264LW.FAIL)) {
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateFailed', {
            error: loadError?.error
        });
        yield (0, $9e8i2.put)((0, $9LVH6.interrupt)());
        const message = yield (0, $9e8i2.call)(!$dc5803bacbec72da$var$isHandleCommitResponseMethod($dc5803bacbec72da$var$handleCommitResponse) && $dc5803bacbec72da$var$handleCommitResponse.text.bind($dc5803bacbec72da$var$handleCommitResponse));
        const finalAction = (0, $cbq3D.genericError)({
            message: message
        });
        yield (0, $9e8i2.put)(finalAction);
        return finalAction;
    }
    return manualCreateResult;
}
function* $dc5803bacbec72da$export$b52851cef8ec2dd1(entityResponse, notifyWatchers) {
    const issueId = entityResponse.itemKey;
    const internalEntity = entityResponse.entity?.entity;
    const error = entityResponse.error;
    const warnings = yield (0, $9e8i2.call)((0, $j5GRN.inspectForCommitWarnings), internalEntity, error);
    // when user change the status, we need to check if we need to display the transition screen
    const isTransitionStatusDialog = error?.error === (0, $ewayV.RESPONSE_ERROR_CODE).REQUIRE_STATUS_TRANSITION_SCREEN;
    if (isTransitionStatusDialog) {
        const transitionScreenId = error?.errorMessages && error?.errorMessages[0];
        const projectsById = yield (0, $9e8i2.select)((0, $ehEr2.getProjectsById));
        const issueById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
        const issue = issueById[issueId];
        const projectKeyOfIssue = issue.project && projectsById[issue.project] && projectsById[issue.project].key;
        // combine `${projectKey}-${issueKey}` which will be used in commitIssueChange.
        const issueKeyInJira = issue.issueKey && projectKeyOfIssue ? `${projectKeyOfIssue}-${issue.issueKey}` : undefined;
        const changeStatusResult = yield (0, $9e8i2.call)($dc5803bacbec72da$var$doShowChangeStatusScreen, issueId, issueKeyInJira, transitionScreenId);
        if (changeStatusResult.type === (0, $2oZqS.SUCCESS)) return true;
        if (changeStatusResult.type === (0, $2oZqS.CANCEL)) yield (0, $9e8i2.put)((0, $eBGH3.add)({
            category: (0, $5rYNM.ENTITY).ISSUE,
            itemId: issueId,
            warnings: warnings
        }));
        return false;
    }
    const analyticsEvent = yield (0, $9e8i2.select)((0, $akhOi.getAnalyticsEvent));
    const isManualCreateRequired = (0, $13pyJ.isScenarioIssue)(issueId) && (()=>{
        switch(String(error?.error)){
            case 'REQUIRED_FIELDS_MISSING':
            case 'WORKFLOW_VALIDATION_FAILURE':
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'advancedRoadmaps issueCommitManualCreateRequired', {
                    error: error?.error
                });
                return true;
            default:
                return false;
        }
    })();
    // this means the issue could not be created since there are required fields that have not been set,
    // we let the user enter them in a pop up dialogue
    if (isManualCreateRequired) {
        const manualCreateResult = yield (0, $9e8i2.call)($dc5803bacbec72da$var$doManualCreate, issueId, error, notifyWatchers);
        if (manualCreateResult.type === (0, $264LW.SUBMIT)) return true;
        if (manualCreateResult.type === (0, $264LW.CANCEL)) yield (0, $9e8i2.put)((0, $eBGH3.add)({
            category: (0, $5rYNM.ENTITY).ISSUE,
            itemId: issueId,
            warnings: warnings
        }));
    } else if (warnings.length) yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).ISSUE,
        itemId: issueId,
        warnings: warnings
    }));
    return false;
}
function* $dc5803bacbec72da$export$be623675b8f208ee(id) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, id);
    const response = yield* $iTjRl.json({
        url: (0, $gUMnJ.urls).revertIssues,
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
    }
    return response;
}
function* $dc5803bacbec72da$export$ea11170f6eef9668(ids) {
    const jiraIds = ids.map((id)=>Number.parseInt(id, 10)).filter((id)=>!Number.isNaN(id));
    if (jiraIds.length === 0) return;
    const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $gUMnJ.hiddenIssuesBody)({
        id: id,
        currentScenarioId: currentScenarioId
    }, jiraIds);
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $gUMnJ.urls).getHiddenIssues, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { issues: issues } = yield (0, $9e8i2.call)(response.json.bind(response));
        if (issues.length > 0) {
            yield (0, $9e8i2.put)((0, $7WQG5.reset)(issues));
            yield (0, $9e8i2.put)({
                type: (0, $98b7323ecc71747d$export$9d631ffde1befd43)
            });
        }
    }
}
function* $dc5803bacbec72da$export$22cefaeb4a8d245f() {
    const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    // Cancel if there is no plan Id, or scenario Id, this can happen when the chain of sagas are still running but the app has already navigated away from the page
    if (id == null || !currentScenarioId) return;
    const url = `${(0, $gUMnJ.urls).getDoneHistory}?planId=${id}&scenarioId=${currentScenarioId}&includeCompletedSince=0`;
    yield (0, $9e8i2.put)((0, $6owOg.setIsLoadingHistory)(true));
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
        method: (0, $kP3Wn.GET),
        profile: (0, $gUMnJ.urls).getDoneHistory
    });
    yield (0, $9e8i2.put)((0, $6owOg.setIsLoadingHistory)(false));
    if (response.ok) {
        const historyIssues = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $1umd3.reset)(historyIssues.issues));
    }
}
function* $dc5803bacbec72da$export$870e45ab8f3f6bbc() {
    try {
        const { id: id, currentScenarioId: currentScenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        if (!id) throw new Error('Plan id is not available');
        if (!currentScenarioId) throw new Error('Scenario id is not available');
        const selectedIssuesIds = yield (0, $9e8i2.select)((0, $kwMvv.getSelected));
        const issues = yield (0, $9e8i2.select)((0, $cwP4d.getIssues));
        const [selectedIssues, remainingIssues] = $3by2Y.default(// eslint-disable-next-line @typescript-eslint/no-shadow
        ({ id: id })=>selectedIssuesIds.has(id), issues);
        yield (0, $9e8i2.put)((0, $kt7Vd.reset)(remainingIssues));
        yield (0, $9e8i2.put)($9ZuLc.bulkAdd(selectedIssues.map((issue)=>({
                ...issue,
                excluded: true
            }))));
        const body = {
            itemKeys: Array.from(selectedIssuesIds),
            planId: id,
            scenarioId: currentScenarioId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $gUMnJ.urls).removeIssues, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            const scenarioIssues = [];
            for (const issueId of selectedIssuesIds)if ((0, $13pyJ.isScenarioIssue)(issueId)) scenarioIssues.push(issueId);
            else yield (0, $9e8i2.put)((0, $lwKA5.update)({
                id: issueId,
                excluded: false
            }));
            if (scenarioIssues.length) yield (0, $9e8i2.put)((0, $lwKA5.remove)(scenarioIssues));
            yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
                isSelected: false,
                toggleAll: true,
                ids: []
            }));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
        } else {
            yield (0, $9e8i2.put)((0, $kt7Vd.reset)(issues));
            yield (0, $9e8i2.put)($9ZuLc.bulkRemove(selectedIssuesIds));
            const message = yield (0, $9e8i2.call)(response.text.bind(response));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: message
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dc5803bacbec72da$export$2171d5eda5f9818d({ payload: payload }) {
    if (payload === null) return;
    // we show a spinner on the issue description field while we wait for the backend response
    yield (0, $9e8i2.put)((0, $77LR7.setLoadingIssueDescription)(true));
    const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $gUMnJ.getDescription)({
        id: id,
        currentScenarioId: currentScenarioId
    }, payload);
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $gUMnJ.urls).getDescription, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        /**
		 * The possible values of issue.description returned by the backend are:
		 * - undefined == if the issue does not have any description
		 * - 'ERROR' == if the request failed
		 * - any other string == the issue has a description which we assume is a valid ADF
		 */ const description = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $kt7Vd.update)({
            id: payload,
            description: description.value
        }));
    } else {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: (0, $gUMnJ.urls).getDescription,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $kt7Vd.update)({
            id: payload,
            description: (0, $83cf706a87a62789$export$d8ee766aa26c1e82)
        }));
    }
    // once the issue description is fetched from the backend, we stop showing the spinner on the description field
    yield (0, $9e8i2.put)((0, $77LR7.setLoadingIssueDescription)(false));
}
function* $dc5803bacbec72da$export$f838fcb0d258d6e4() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$242fccfb90c57247, $dc5803bacbec72da$export$4c5f4cf5d27c16aa);
    else yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$242fccfb90c57247, $dc5803bacbec72da$export$3de94ba9de434e56);
}
function* $dc5803bacbec72da$export$eeca124c095ce47c() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$d46fd8e9a2a59b28, $dc5803bacbec72da$export$5c6a7a448f6c7ede);
    else yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$d46fd8e9a2a59b28, $dc5803bacbec72da$export$edf4c125212bfd66);
}
function* $dc5803bacbec72da$export$3a5a00ff802b1115() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$254f30e4f720be90, $dc5803bacbec72da$export$a659eeffaf0169f6);
}
function* $dc5803bacbec72da$export$b653f0d048b72ee5() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$b6c322dbc4f2f8ac, $dc5803bacbec72da$export$cfff686a68dd7df4);
    else yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$b6c322dbc4f2f8ac, $dc5803bacbec72da$export$960787e2a2dfab5e);
}
function* $dc5803bacbec72da$export$f76f5031f6f8e0fc() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$4c343341eb9052e8, $dc5803bacbec72da$export$5bf0bb972a681b23);
}
function* $dc5803bacbec72da$export$b7a92e3dbab82894() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$85b6c4937eed754f, $dc5803bacbec72da$export$6c983680b0561560);
}
function* $dc5803bacbec72da$export$526b8f427354c53d() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$9bbbeac0bf5bf14, $dc5803bacbec72da$export$bb03c5769232d24c);
    else yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$9bbbeac0bf5bf14, $dc5803bacbec72da$export$c66886d54bda95a1);
}
function* $dc5803bacbec72da$export$657a600589fa02a1() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$269d7b2720ef5d5e, $dc5803bacbec72da$export$26dc99c947cf00be);
}
function* $dc5803bacbec72da$export$f52b10cb9b101e2a() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$ce69e6c9d4cdf606, $dc5803bacbec72da$export$fc3e038178ab21fa);
}
function* $dc5803bacbec72da$export$7361a3ed146cf32c() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$7dc711c48e3c938f, $dc5803bacbec72da$export$22cefaeb4a8d245f);
}
function* $dc5803bacbec72da$export$d67d766377d9d9ce() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$35cae9f1acacb606, $dc5803bacbec72da$export$870e45ab8f3f6bbc);
}
function* $dc5803bacbec72da$export$918f78945edad0e6() {
    yield (0, $bG7pV.takeEvery)($dc5803bacbec72da$export$57c7dfb729a4eb26, $dc5803bacbec72da$var$doUpdateIssueOrInlineCreate);
}
function* $dc5803bacbec72da$export$f6cefbf53e22d109() {
    yield (0, $bG7pV.takeEvery)($83cf706a87a62789$export$868e118e8d9234f, $dc5803bacbec72da$export$a6f3b2da528d4c39);
}
function* $dc5803bacbec72da$export$ee53207dcda05720() {
    yield (0, $bG7pV.takeEvery)((0, $77LR7.SET_ISSUE_BEING_EDITED), $dc5803bacbec72da$export$2171d5eda5f9818d);
}
function* $dc5803bacbec72da$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$f838fcb0d258d6e4);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$eeca124c095ce47c);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$3a5a00ff802b1115);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$b653f0d048b72ee5);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$f76f5031f6f8e0fc);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$b7a92e3dbab82894);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$526b8f427354c53d);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$657a600589fa02a1);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$f52b10cb9b101e2a);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$7361a3ed146cf32c);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$d67d766377d9d9ce);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$918f78945edad0e6);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$f6cefbf53e22d109);
    yield (0, $9e8i2.fork)($dc5803bacbec72da$export$ee53207dcda05720);
}

});
parcelRegister("kP3Wn", function(module, exports) {

$parcel$export(module.exports, "GET", () => $84550961ac061908$export$1bb358554aac31c1);
$parcel$export(module.exports, "POST", () => $84550961ac061908$export$484f3009c2ee32ad);
$parcel$export(module.exports, "DELETE", () => $84550961ac061908$export$4bd2facc4a3e6aa1);
$parcel$export(module.exports, "parseError", () => $84550961ac061908$export$e80a9284539c1797);
const $84550961ac061908$export$1bb358554aac31c1 = 'GET';
const $84550961ac061908$export$484f3009c2ee32ad = 'POST';
const $84550961ac061908$export$4bd2facc4a3e6aa1 = 'DELETE';
const $84550961ac061908$export$e80a9284539c1797 = (response, message)=>{
    const contentType = response.headers.get('Content-Type');
    if (typeof contentType === 'string' && contentType.indexOf('application/json') === 0) try {
        const errorObj = JSON.parse(message).exception;
        const stackTrace = errorObj.stackTrace.reduce((accumulator, trace)=>`${accumulator}${trace.className}.${trace.methodName}:${trace.line}\n`, '');
        return {
            message: `Type: ${errorObj.type}`,
            stackTrace: stackTrace
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return {
            message: message,
            stackTrace: ''
        };
    }
    return {
        message: message,
        stackTrace: ''
    };
};

});

parcelRegister("kXdPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $282b71df896b5d86$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $dbuYA = parcelRequire("dbuYA");
function* $282b71df896b5d86$export$2e2bcd8739ae039(callback) {
    yield (0, $9e8i2.put)((0, $dbuYA.suspend)());
    try {
        yield (0, $9e8i2.call)(callback);
    } finally{
        yield (0, $9e8i2.put)((0, $dbuYA.resume)());
    }
}

});

parcelRegister("jyOCP", function(module, exports) {

$parcel$export(module.exports, "commitBody", () => $eae8bd7ad63c7f03$export$7c9a53d60320f7fe);
$parcel$export(module.exports, "revertBody", () => $eae8bd7ad63c7f03$export$7d51b8ce955d016b);

var $GanEp = parcelRequire("GanEp");

var $hkDg7 = parcelRequire("hkDg7");
const $eae8bd7ad63c7f03$export$7c9a53d60320f7fe = ({ id: planId, currentScenarioId: scenarioId }, sequence, itemKey, generatedItemId, notifyWatchers)=>{
    if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
    const payload = {
        planId: planId,
        scenarioId: scenarioId,
        sequence: $GanEp.default((0, $hkDg7.sequenceKeys).map((key)=>[
                key,
                {
                    current: sequence[key]?.current || 0
                }
            ])),
        itemKey: itemKey,
        generatedItemId: generatedItemId,
        notifyWatchers: notifyWatchers
    };
    return payload;
};
const $eae8bd7ad63c7f03$export$7d51b8ce955d016b = ({ id: planId, currentScenarioId: scenarioId }, sequence, itemKey)=>{
    if (!planId || !scenarioId) throw new Error('Need both plan and scenario to revert changes');
    const payload = {
        itemKeys: [
            itemKey
        ],
        planId: planId,
        scenarioId: scenarioId,
        sequence: $GanEp.default((0, $hkDg7.sequenceKeys).map((key)=>[
                key,
                {
                    current: sequence[key]?.current || 0
                }
            ]))
    };
    return payload;
};

});
parcelRegister("GanEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $07ebf9b3e878a437$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $07ebf9b3e878a437$var$fromPairs = /*#__PURE__*/ (0, $eSWTK.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $07ebf9b3e878a437$export$2e2bcd8739ae039 = $07ebf9b3e878a437$var$fromPairs;

});

parcelRegister("hkDg7", function(module, exports) {

$parcel$export(module.exports, "urls", () => $42f5b58daef01666$export$bcae9ba627f604b6);
$parcel$export(module.exports, "sequenceKeys", () => $42f5b58daef01666$export$7c53c6aeef0196af);
$parcel$export(module.exports, "getChangesMetadataBody", () => $42f5b58daef01666$export$1879f65d67ccff8d);

var $GanEp = parcelRequire("GanEp");
const $42f5b58daef01666$export$bcae9ba627f604b6 = {
    getScenarioChangesMetadata: '/rest/jpo/1.0/scenario/metadata',
    updateLastCommittedTimestamp: (planId)=>`/rest/jpo/1.0/plans/${planId}/lastcommit`
};
const $42f5b58daef01666$export$7c53c6aeef0196af = [
    'issues',
    'versions',
    'teams',
    'persons',
    'resources',
    'xprojectversions',
    'themes',
    'skills',
    'stages',
    'abilities',
    'issuelinks',
    'plannedcapacity'
];
const $42f5b58daef01666$export$1879f65d67ccff8d = ({ id: planId, currentScenarioId: scenarioId }, sequence)=>{
    if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
    const payload = {
        planId: planId,
        scenarioId: scenarioId,
        sequence: $GanEp.default($42f5b58daef01666$export$7c53c6aeef0196af.map((key)=>[
                key,
                {
                    current: sequence[key]?.current || 0
                }
            ]))
    };
    return payload;
};

});


parcelRegister("j5GRN", function(module, exports) {

$parcel$export(module.exports, "defaultWarning", () => $9f8a8321096434df$export$deb6050352aafd0b);
$parcel$export(module.exports, "inspectForCommitWarnings", () => $9f8a8321096434df$export$1eed481c758d15b7);

var $eUqFw = parcelRequire("eUqFw");

var $erwaN = parcelRequire("erwaN");
var $cQGVO = parcelRequire("cQGVO");
var $8aqkF = parcelRequire("8aqkF");
var $eXGQy = parcelRequire("eXGQy");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $8uD7Y = parcelRequire("8uD7Y");

var $kKj1m = parcelRequire("kKj1m");

var $hjY2n = parcelRequire("hjY2n");

var $Dp4jf = parcelRequire("Dp4jf");
function $9f8a8321096434df$export$ac27981c37e52390(entity) {
    const uncommitedKeysWithoutCustomFieldContainer = $eXGQy.default([
        'customFields'
    ], $erwaN.default(entity.originals));
    const uncommittedCustomFieldKeys = $cQGVO.default((customFieldId)=>`cf-${customFieldId}`, $erwaN.default(entity.originals.customFields));
    return $8aqkF.default(uncommitedKeysWithoutCustomFieldContainer, uncommittedCustomFieldKeys);
}
function $9f8a8321096434df$export$74d0da8cf5388cfa(warningKeys, customFields) {
    return warningKeys.map((key)=>{
        if (key.startsWith('cf-')) {
            const customFieldId = key.slice(3);
            const fieldDef = customFields.find((field)=>field.id.toString() === customFieldId);
            if (fieldDef) return {
                header: (0, $Dp4jf.default).customFieldNotSupportedHeader,
                message: (0, $Dp4jf.default).customFieldNotSupportedContent,
                messageValues: {
                    key: fieldDef.title
                }
            };
        }
        switch(key){
            case 'storyPoints':
                return {
                    header: (0, $Dp4jf.default).storyPointsWarningHeader,
                    message: (0, $Dp4jf.default).storyPointsWarningContent,
                    messageValues: {}
                };
            case 'assignee':
                return {
                    header: (0, $Dp4jf.default).assigneeWarningHeader,
                    message: (0, $Dp4jf.default).assigneeWarningContent,
                    messageValues: {}
                };
            case 'lexoRank':
                return {
                    header: (0, $Dp4jf.default).lexoRankWarningHeader,
                    message: (0, $Dp4jf.default).lexoRankWarningContent,
                    messageValues: {}
                };
            case 'team':
                return {
                    header: (0, $Dp4jf.default).teamWarningHeader,
                    message: (0, $Dp4jf.default).teamWarningContent,
                    messageValues: {}
                };
            case 'fixVersions':
                return {
                    header: (0, $Dp4jf.default).releaseWarningHeader,
                    message: (0, $Dp4jf.default).releaseWarningContent,
                    messageValues: {}
                };
            case 'originalStoryPoints':
                return {
                    header: (0, $Dp4jf.default).originalStoryPointsHeader,
                    messageValues: {}
                };
            case 'originalTimeEstimate':
                return {
                    header: (0, $Dp4jf.default).originalTimeEstimateHeader,
                    messageValues: {}
                };
            case 'timeEstimate':
                return {
                    header: (0, $Dp4jf.default).timeEstimateHeader,
                    messageValues: {}
                };
            default:
                return {
                    header: (0, $Dp4jf.default).defaultPartialCommitWarningHeader,
                    messageValues: {
                        key: key
                    }
                };
        }
    });
}
const $9f8a8321096434df$export$deb6050352aafd0b = {
    header: (0, $Dp4jf.default).defaultWarningHeader,
    message: (0, $Dp4jf.default).defaultWarningContent,
    messageValues: {}
};
function $9f8a8321096434df$export$fa8c0c6fcfd0b677({ error: error, errorMessages: errorMessages }) {
    switch(error){
        case 'ENVIRONMENT_ENTITY_NOT_FOUND':
            return {
                header: (0, $Dp4jf.default).notFoundWarningHeader,
                message: (0, $Dp4jf.default).notFoundWarningContent,
                messageValues: {}
            };
        case 'UNCOMMITTED_PARENT':
            return {
                header: (0, $Dp4jf.default).uncommittedParentHeader,
                message: (0, $Dp4jf.default).uncommittedParentContent,
                messageValues: {}
            };
        case 'SUBTASK_PARENT_NOT_DEFINED':
            return {
                header: (0, $Dp4jf.default).subTaskParentNotDefinedHeader,
                message: (0, $Dp4jf.default).subTaskParentNotDefinedContent,
                messageValues: {}
            };
        case 'SUBTASK_IN_WRONG_PROJECT':
            return {
                header: (0, $Dp4jf.default).subTaskInWrongProjectHeader,
                message: (0, $Dp4jf.default).subTaskInWrongProjectContent,
                messageValues: {}
            };
        case 'REQUIRED_FIELDS_MISSING':
            return {
                header: (0, $Dp4jf.default).requiredFieldsMissingHeader,
                message: (0, $Dp4jf.default).requiredFieldsMissingContent,
                messageValues: {}
            };
        case 'REQUIRE_STATUS_TRANSITION_SCREEN':
            return {
                header: (0, $Dp4jf.default).requiredTransitionScreenMissingHeader,
                message: (0, $Dp4jf.default).requiredTransitionScreenMissingContent,
                messageValues: {}
            };
        case 'ISSUE_API_EXCEPTION':
            if (errorMessages.length > 0) return {
                header: (0, $Dp4jf.default).unknownErrorHeader,
                message: (0, $Dp4jf.default).apiExceptionContent,
                messageValues: {
                    messages: errorMessages.join(' ')
                }
            };
            return {
                header: (0, $Dp4jf.default).unknownErrorHeader,
                message: (0, $Dp4jf.default).unknownErrorHeader,
                messageValues: {}
            };
        case 'RANK_FAILURE_SCHEDULE_ISSUES_PERMISSION_MISSING':
            return {
                header: (0, $Dp4jf.default).permissionMissingHeader,
                message: (0, $Dp4jf.default).permissionMissingContent,
                messageValues: {
                    learnMoreAboutPermissions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $hjY2n.default).learnMoreAboutPermissions,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $Dp4jf.default).learnMoreAboutPermissions)),
                    permissionName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $Dp4jf.default).scheduleIssuesPermission))
                }
            };
        default:
            return $9f8a8321096434df$export$deb6050352aafd0b;
    }
}
function* $9f8a8321096434df$export$1eed481c758d15b7(entity, error // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    const customFields = yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields));
    let unCommittedPropertyWarnings = [];
    if (entity) unCommittedPropertyWarnings = $9f8a8321096434df$export$74d0da8cf5388cfa($9f8a8321096434df$export$ac27981c37e52390(entity), customFields);
    let errorWarning = [];
    if (error) errorWarning = [
        $9f8a8321096434df$export$fa8c0c6fcfd0b677(error)
    ];
    return [
        ...unCommittedPropertyWarnings,
        ...errorWarning
    ];
}

});
parcelRegister("eXGQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae47cfd7655365fa$export$2e2bcd8739ae039);

var $75bQw = parcelRequire("75bQw");

var $ggdJA = parcelRequire("ggdJA");

var $jDSc6 = parcelRequire("jDSc6");

var $kpKEz = parcelRequire("kpKEz");
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $ae47cfd7655365fa$var$without = /*#__PURE__*/ (0, $ggdJA.default)(function(xs, list) {
    return (0, $kpKEz.default)((0, $jDSc6.default)((0, $75bQw.default))(xs), list);
});
var $ae47cfd7655365fa$export$2e2bcd8739ae039 = $ae47cfd7655365fa$var$without;

});

parcelRegister("hjY2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc214b88981bb03e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $dc214b88981bb03e$export$2e2bcd8739ae039 = {
    home: 'https://support.atlassian.com/jira-software-cloud/resources/',
    followOurProgress: 'https://jira.atlassian.com/browse/JSWCLOUD-20012',
    gettingStarted: 'https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/',
    customFields: 'https://support.atlassian.com/jira-software-cloud/docs/enable-custom-fields-used-in-advanced-roadmaps-in-jira/',
    schedulingIssues: 'https://support.atlassian.com/jira-software-cloud/docs/estimate-and-schedule-issues-in-advanced-roadmaps/',
    schedulingWork: 'https://support.atlassian.com/jira-software-cloud/docs/estimate-and-schedule-issues-in-advanced-roadmaps/',
    embedRoadmapInConfluenceMacro: 'https://support.atlassian.com/jira-software-cloud/docs/embed-your-advanced-roadmap-plan-in-a-confluence-page/',
    viewSwitching: 'https://support.atlassian.com/jira-software-cloud/docs/preconfigured-views-in-advanced-roadmaps/',
    supportLink: 'https://support.atlassian.com/contact/#/',
    exportPng: 'https://support.atlassian.com/jira-software-cloud/docs/create-a-static-image-of-your-plan/',
    committingChangesToJira: 'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/',
    manageTeamInJira: 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-team/',
    learnMoreAboutPermissions: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/#Permissionsoverview-board-usagesprint-related-actionsBoardusage',
    teamsInOpenSites: 'https://support.atlassian.com/jira-software-cloud/docs/limitations-of-teams-in-advanced-roadmaps-open-sites/',
    dependencyReport: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/',
    warningsDialog: 'https://support.atlassian.com/jira-software-cloud/docs/view-the-warnings-center-in-advanced-roadmaps/'
};

});

parcelRegister("Dp4jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $266225c65d30c86e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $266225c65d30c86e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    storyPointsWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.story-points-warning-header",
        "defaultMessage": "Unable to commit the item's story points."
    },
    storyPointsWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.story-points-warning-content",
        "defaultMessage": "Please check that story points are enabled for this issue type."
    },
    assigneeWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.assignee-warning-header",
        "defaultMessage": "Unable to commit the item's assignee."
    },
    assigneeWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.assignee-warning-content",
        "defaultMessage": "Please check that you have permission to assign issues in this project."
    },
    lexoRankWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.lexo-rank-warning-header",
        "defaultMessage": "Unable to commit the item's LexoRank."
    },
    lexoRankWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.lexo-rank-warning-content",
        "defaultMessage": "Please check that you have permission to rank issues in this project."
    },
    uncommittedParentHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.uncommitted-parent-header",
        "defaultMessage": "Cannot save child issue"
    },
    uncommittedParentContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.uncommitted-parent-content",
        "defaultMessage": "Save the parent issue first, then try again."
    },
    subTaskParentNotDefinedHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-parent-not-defined-header",
        "defaultMessage": "Uncommitted parent"
    },
    subTaskParentNotDefinedContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-parent-not-defined-content",
        "defaultMessage": "Issue cannot be created as a sub-task of an uncommitted parent. Please commit the parent issue and retry."
    },
    subTaskInWrongProjectHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-in-wrong-project-header",
        "defaultMessage": "Sub-task in wrong project"
    },
    subTaskInWrongProjectContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.sub-task-in-wrong-project-content",
        "defaultMessage": "An issue and its sub-task must both belong to the same project."
    },
    defaultWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-warning-header",
        "defaultMessage": "Could not be committed for unknown reasons."
    },
    defaultWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-warning-content",
        "defaultMessage": "Item could not be committed for unknown reasons. Please contact your administrator."
    },
    defaultPartialCommitWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.default-partial-commit-warning-header",
        "defaultMessage": "Unable to commit the item's {key}"
    },
    scheduleIssuesPermission: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.schedule-issues-permission",
        "defaultMessage": "Schedule Issues"
    },
    permissionMissingHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.permission-missing-header",
        "defaultMessage": "Missing permissions"
    },
    permissionMissingContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.permission-missing-content",
        "defaultMessage": "Your changes could not be saved because you don\u2019t have the {permissionName} permission. An admin needs to grant you this permission. {learnMoreAboutPermissions}"
    },
    learnMoreAboutPermissions: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.learn-more-about-permissions",
        "defaultMessage": "Learn more about these permissions."
    },
    teamWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.team-warning-header",
        "defaultMessage": "Unable to commit the item's team"
    },
    teamWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.team-warning-content",
        "defaultMessage": "Please ensure that the team has been committed."
    },
    originalStoryPointsHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.original-story-points-header",
        "defaultMessage": "Unable to commit the item's original story points"
    },
    originalTimeEstimateHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.original-time-estimate-header",
        "defaultMessage": "Unable to commit the item's original time estimate"
    },
    timeEstimateHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.time-estimate-header",
        "defaultMessage": "Unable to commit the item's time estimate"
    },
    releaseWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.release-warning-header",
        "defaultMessage": "Unable to commit the item's release"
    },
    releaseWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.release-warning-content",
        "defaultMessage": "Please ensure that the release has been committed."
    },
    notFoundWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.not-found-warning-header",
        "defaultMessage": "Issue could not be found"
    },
    notFoundWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.not-found-warning-content",
        "defaultMessage": "Please refresh to update your plan"
    },
    requiredFieldsMissingHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-fields-missing-header",
        "defaultMessage": "The issue cannot be updated as required fields are missing"
    },
    requiredFieldsMissingContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-fields-missing-content",
        "defaultMessage": "Please define a value or mark the field as optional to resolve the problem"
    },
    requiredTransitionScreenMissingHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-transition-screen-missing-header",
        "defaultMessage": "The issue cannot be updated as required transition screen are missing"
    },
    requiredTransitionScreenMissingContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.required-transition-screen-missing-content",
        "defaultMessage": "Please fill the transition screen fields or remove the transition screen when update the issue status to resolve the problem"
    },
    unknownErrorHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.unknown-error-header",
        "defaultMessage": "Issue could not be committed for unknown reasons"
    },
    unknownErrorContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.unknown-error-content",
        "defaultMessage": "Please contact your administrator"
    },
    apiExceptionContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.api-exception-content",
        "defaultMessage": "Please contact your administrator. {messages}"
    },
    customFieldNotSupportedHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.custom-field-not-supported-header",
        "defaultMessage": "Cannot commit {key} for this issue"
    },
    customFieldNotSupportedContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.commit.custom-field-not-supported-content",
        "defaultMessage": "The custom field {key} is not supported. Discard this change, or ask your Jira admin to make sure the issue type and project of the issue are supported."
    }
});

});


parcelRegister("iTjRl", function(module, exports) {

$parcel$export(module.exports, "json", () => $7c02eb8e10c57910$export$7b419323e6ed4f31);
$parcel$export(module.exports, "jsonOrError", () => $7c02eb8e10c57910$export$7ae2377f3464eaf5);
$parcel$export(module.exports, "withErrorTolerated", () => $7c02eb8e10c57910$export$d987e8f826d94836);
/**
 * This module provides various utilities for handling HTTP requests in commands.
 */ parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $9cGgz = parcelRequire("9cGgz");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $5rVFi = parcelRequire("5rVFi");
function* $7c02eb8e10c57910$export$7b419323e6ed4f31(request) {
    const { url: url, method: method, body: body, ...options } = request;
    try {
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: method,
            body: body,
            ...options
        });
        if (response.ok) return {
            ok: true,
            data: yield (0, $9e8i2.call)(response.json.bind(response))
        };
        const message = yield (0, $9e8i2.call)(response.text.bind(response));
        return {
            ok: false,
            status: response.status,
            error: (0, $9cGgz.tryParseJson)(message) || message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return {
            ok: false,
            status: -1,
            error: e.message
        };
    }
}
function* $7c02eb8e10c57910$export$7ae2377f3464eaf5(request) {
    const { url: url, method: method, body: body, profile: profile } = request;
    try {
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: method,
            body: body,
            profile: profile
        });
        if (response.ok) return {
            ok: true,
            data: yield (0, $9e8i2.call)(response.json.bind(response))
        };
        const parsedError = (0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response))));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...parsedError,
            requestInfo: {
                url: url,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
        return {
            ok: false,
            status: response.status,
            error: parsedError
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
        return {
            ok: false,
            status: -1,
            error: e.message
        };
    }
}
function* $7c02eb8e10c57910$export$d987e8f826d94836(// eslint-disable-next-line @typescript-eslint/no-explicit-any
block) {
    try {
        return yield (0, $9e8i2.call)(block);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (err instanceof (0, $5rVFi.AgressiveFetchError)) {
            const { request: request, response: response } = err;
            const requestInfo = {
                url: request.url,
                type: request.method,
                status: response.status,
                body: request.body ?? undefined
            };
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const errPayload = (err)=>({
                    message: err.message,
                    stackTrace: err.stack
                });
            const { message: message, stackTrace: stackTrace } = response.bodyUsed ? errPayload(err) : (0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response))));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: message,
                stackTrace: stackTrace,
                requestInfo: requestInfo
            }));
        } else throw err;
    }
}

});
parcelRegister("9cGgz", function(module, exports) {

$parcel$export(module.exports, "tryParseJson", () => $93d6ce0df74a4914$export$798eca59d671408d);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $93d6ce0df74a4914$export$798eca59d671408d = (str)=>{
    if (str) try {
        return JSON.parse(str);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Swallow exception
    }
    return undefined;
};

});

parcelRegister("5rVFi", function(module, exports) {

$parcel$export(module.exports, "AgressiveFetchError", () => $eb5229e147d27eb9$export$a09f0e985c649de4);
$parcel$export(module.exports, "aggressiveFetch", () => $eb5229e147d27eb9$export$624e87556f86a679);
$parcel$export(module.exports, "default", () => $eb5229e147d27eb9$export$2e2bcd8739ae039);

var $eoUrK = parcelRequire("eoUrK");
var $cy5HJ = parcelRequire("cy5HJ");

var $dYnI4 = parcelRequire("dYnI4");

var $64VaH = parcelRequire("64VaH");

var $lFLge = parcelRequire("lFLge");
const $eb5229e147d27eb9$export$8467c5933bf19410 = 'common.fetch.XHR_UNAUTHORIZED_ERROR';
const $eb5229e147d27eb9$export$b8ec1360093ba0e8 = 'response not ok';
const $eb5229e147d27eb9$var$headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $eb5229e147d27eb9$var$defaultOptions = {
    credentials: 'same-origin',
    headers: $eb5229e147d27eb9$var$headers
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eb5229e147d27eb9$var$castBody = (body)=>{
    const type = $cy5HJ.default(body);
    switch(type){
        case 'String':
            return body;
        case 'Object':
            return JSON.stringify(body);
        case 'Number':
            return `${body}`;
        default:
            throw new Error(`Unsupported body type: ${type}`);
    }
};
const $eb5229e147d27eb9$var$enhanceOptions = $eoUrK.default({
    body: $eb5229e147d27eb9$var$castBody
});
const $eb5229e147d27eb9$var$checkAuthorized = (response)=>{
    if (!response?.ok && response.status === 401) {
        (0, $lFLge.reload)();
        throw new Error(`${$eb5229e147d27eb9$export$8467c5933bf19410}:${response.url}`);
    }
    return response;
};
function $eb5229e147d27eb9$var$fetch(url, { isUrlVerbatim: isUrlVerbatim, profile: profile, ...options }) {
    const request = window.fetch(isUrlVerbatim ? url : (0, $64VaH.proxyContextSafeUrl)(url), $eb5229e147d27eb9$var$enhanceOptions({
        ...$eb5229e147d27eb9$var$defaultOptions,
        ...options
    })).then($eb5229e147d27eb9$var$checkAuthorized);
    if (profile) {
        const finishProfile = (0, $dYnI4.monitor).startProfileConcurrent(profile);
        return request.then((response)=>{
            finishProfile();
            return response;
        });
    }
    return request;
}
class $eb5229e147d27eb9$export$a09f0e985c649de4 extends Error {
    constructor(message, { request: request, response: response }){
        super(message);
        this.request = request;
        this.response = response;
    }
}
async function $eb5229e147d27eb9$export$624e87556f86a679(url, { profile: profile, ...options }, errMessage = 'aggressiveFetch failed') {
    const request = new Request(url, $eb5229e147d27eb9$var$enhanceOptions({
        ...$eb5229e147d27eb9$var$defaultOptions,
        ...options
    }));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let finishProfile = ()=>{};
    if (profile) finishProfile = (0, $dYnI4.monitor).startProfileConcurrent(profile);
    const response = await $eb5229e147d27eb9$var$fetch(url, options);
    finishProfile();
    $eb5229e147d27eb9$var$checkAuthorized(response);
    if (!response?.ok) throw new $eb5229e147d27eb9$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${$eb5229e147d27eb9$export$b8ec1360093ba0e8}`, {
        request: request,
        response: response
    });
    if (options.json && response.status !== 204) try {
        return await response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        throw new $eb5229e147d27eb9$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${err.message}`, {
            request: request,
            response: response
        });
    }
}
var $eb5229e147d27eb9$export$2e2bcd8739ae039 = $eb5229e147d27eb9$var$fetch;

});


parcelRegister("051m9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ADD_RELEASE", () => $9710589aeb38434b$export$2bdfac268df97e49);
$parcel$export(module.exports, "UPDATE_RELEASE", () => $9710589aeb38434b$export$3f90e3abee6e8d70);
$parcel$export(module.exports, "RANK_RELEASE", () => $9710589aeb38434b$export$c2ca61e48c051fa6);
$parcel$export(module.exports, "DELETE_RELEASE", () => $9710589aeb38434b$export$440c54a43c85f449);
$parcel$export(module.exports, "CALCULATE_RELEASE_STATUS", () => $9710589aeb38434b$export$bcf0ce7e9670a9d);
$parcel$export(module.exports, "CALCULATE_STATUS_OF_ALL_RELEASES", () => $9710589aeb38434b$export$114415b2450800d);
$parcel$export(module.exports, "ADD_RELEASE_TO_CROSS_PROJECT_RELEASE", () => $9710589aeb38434b$export$f6d34bff03547a78);
$parcel$export(module.exports, "VIEW_RELEASE_IN_ROADMAP", () => $9710589aeb38434b$export$a54e64fcc2f0026f);
$parcel$export(module.exports, "GET_RELEASES_FOR_IDS", () => $9710589aeb38434b$export$494c2f9413c26e0c);
$parcel$export(module.exports, "addRelease", () => $9710589aeb38434b$export$d7ff8290d1a14fa1);
$parcel$export(module.exports, "updateRelease", () => $9710589aeb38434b$export$a5f005f0031c650d);
$parcel$export(module.exports, "rankRelease", () => $9710589aeb38434b$export$e7abf7191f04bdf9);
$parcel$export(module.exports, "deleteRelease", () => $9710589aeb38434b$export$41b4061737a08cd);
$parcel$export(module.exports, "calculateReleaseStatus", () => $9710589aeb38434b$export$7e4d7a0e6f2ecd97);
$parcel$export(module.exports, "calculateStatusOfAllReleases", () => $9710589aeb38434b$export$814759937e7677ff);
$parcel$export(module.exports, "addReleaseToCrossProjectRelease", () => $9710589aeb38434b$export$bace67d72a0ad73a);
$parcel$export(module.exports, "viewReleaseInRoadmap", () => $9710589aeb38434b$export$4ddde390df08566c);
$parcel$export(module.exports, "getReleasesForIds", () => $9710589aeb38434b$export$63e6b3e46226b547);
$parcel$export(module.exports, "addVersionInStore", () => $9710589aeb38434b$export$5efaacd55cc1612e);
$parcel$export(module.exports, "removeVersionFromStore", () => $9710589aeb38434b$export$bf48c144c9502436);
$parcel$export(module.exports, "addRemovedVersionToMainVersionsList", () => $9710589aeb38434b$export$d375fd666a67b57e);
$parcel$export(module.exports, "updateDetailsOfNewlyAddedVersion", () => $9710589aeb38434b$export$50b15d1407aac14c);
$parcel$export(module.exports, "handleVersionWarnings", () => $9710589aeb38434b$export$ea5c9603aa3d16d4);
$parcel$export(module.exports, "handleVersionCommitResponse", () => $9710589aeb38434b$export$f552fa4bc1966f1e);
$parcel$export(module.exports, "revertChange", () => $9710589aeb38434b$export$be623675b8f208ee);
$parcel$export(module.exports, "updateReferences", () => $9710589aeb38434b$export$387fc7d982d5d3ef);
$parcel$export(module.exports, "revertReferences", () => $9710589aeb38434b$export$21aa7f798a65a8c0);
$parcel$export(module.exports, "updateStateAfterAddingVersion", () => $9710589aeb38434b$export$476de812fbbb6302);
$parcel$export(module.exports, "doAddVersion", () => $9710589aeb38434b$export$89ca6b91461e4dc);
$parcel$export(module.exports, "updateVersion", () => $9710589aeb38434b$export$5652a4ac6807e581);
$parcel$export(module.exports, "updateStateAfterUpdatingVersion", () => $9710589aeb38434b$export$307c978903f505ad);
$parcel$export(module.exports, "doUpdateVersion", () => $9710589aeb38434b$export$740de856a6989843);
$parcel$export(module.exports, "doRankVersion", () => $9710589aeb38434b$export$c3dc37c85d86f10c);
$parcel$export(module.exports, "unassignVersionInIssues", () => $9710589aeb38434b$export$25de5bd053709c0f);
$parcel$export(module.exports, "updateStateAfterDeletingVersion", () => $9710589aeb38434b$export$d88648d01aa45c1d);
$parcel$export(module.exports, "updateStateAfterRemovingVersion", () => $9710589aeb38434b$export$3d30cf8b88f7bb6f);
$parcel$export(module.exports, "doDeleteVersion", () => $9710589aeb38434b$export$c7f0d1a6ee665364);
$parcel$export(module.exports, "setStatusOfVersion", () => $9710589aeb38434b$export$19970962bad2152d);
$parcel$export(module.exports, "doCalculateVersionStatus", () => $9710589aeb38434b$export$4dbc8e12162b81db);
$parcel$export(module.exports, "doCalculateStatusOfAllVersions", () => $9710589aeb38434b$export$7e65e5343d7c672b);
$parcel$export(module.exports, "doAddReleaseToCrossProjectRelease", () => $9710589aeb38434b$export$31d54314ae5480f6);
$parcel$export(module.exports, "doViewReleaseInRoadmap", () => $9710589aeb38434b$export$6305f6649b21cb82);
$parcel$export(module.exports, "doGetReleasesForIds", () => $9710589aeb38434b$export$cb0413722f11fcf5);
$parcel$export(module.exports, "watchAddVersion", () => $9710589aeb38434b$export$7636f00a67e1b930);
$parcel$export(module.exports, "watchUpdateVersion", () => $9710589aeb38434b$export$919e3b6069d2417d);
$parcel$export(module.exports, "watchRankVersion", () => $9710589aeb38434b$export$2075f1cbc6860e11);
$parcel$export(module.exports, "watchDeleteVersion", () => $9710589aeb38434b$export$877c3b6cd35254fd);
$parcel$export(module.exports, "watchCalculateVersionStatus", () => $9710589aeb38434b$export$d72bc7e55e3e1f7a);
$parcel$export(module.exports, "watchCalculateStatusOfAllVersions", () => $9710589aeb38434b$export$db3062cd2a511ac7);
$parcel$export(module.exports, "watchAddReleaseToCrossProjectRelease", () => $9710589aeb38434b$export$3e74af38e36afe10);
$parcel$export(module.exports, "watchViewReleaseInRoadmap", () => $9710589aeb38434b$export$20993805280f607e);
$parcel$export(module.exports, "watchGetReleasesForIds", () => $9710589aeb38434b$export$d211e2e29b5233fc);
$parcel$export(module.exports, "default", () => $9710589aeb38434b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setMode", () => (parcelRequire("boi4O")).setMode);
$parcel$export(module.exports, "openDialog", () => (parcelRequire("boi4O")).openDialog);
$parcel$export(module.exports, "closeDialog", () => (parcelRequire("boi4O")).closeDialog);
$parcel$export(module.exports, "CREATE_RELEASE", () => $2ca1157acc350995$export$afecb711a599950a);
$parcel$export(module.exports, "EDIT_RELEASE", () => $2ca1157acc350995$export$b9385259cf8397cd);
$parcel$export(module.exports, "setDeleteDialogMode", () => (parcelRequire("8NHMp")).setMode);
$parcel$export(module.exports, "openDeleteDialog", () => (parcelRequire("8NHMp")).openDialog);
$parcel$export(module.exports, "closeDeleteDialog", () => (parcelRequire("8NHMp")).closeDialog);
$parcel$export(module.exports, "DELETE_DIALOG_ACTIONS", () => (parcelRequire("ivdvr")).DELETE_DIALOG_ACTIONS);
$parcel$export(module.exports, "openAddToCprDialog", () => (parcelRequire("9aQvf")).openDialog);
$parcel$export(module.exports, "closeAddToCprDialog", () => (parcelRequire("9aQvf")).closeDialog);

var $8K6YM = parcelRequire("8K6YM");
var $l0L3x = parcelRequire("l0L3x");
var $01zCq = parcelRequire("01zCq");
var $7WzTP = parcelRequire("7WzTP");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $kXdPE = parcelRequire("kXdPE");

var $jyOCP = parcelRequire("jyOCP");

var $cbq3D = parcelRequire("cbq3D");

var $296Gg = parcelRequire("296Gg");

var $iTjRl = parcelRequire("iTjRl");
parcelRequire("fbHoQ");
parcelRequire("38iYP");

var $3nT5G = parcelRequire("3nT5G");

var $kwMvv = parcelRequire("kwMvv");

var $g8SOd = parcelRequire("g8SOd");

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $wcCGG = parcelRequire("wcCGG");

var $DywVp = parcelRequire("DywVp");

var $kt7Vd = parcelRequire("kt7Vd");

var $kIUsy = parcelRequire("kIUsy");

var $gExeY = parcelRequire("gExeY");

var $lwKA5 = parcelRequire("lwKA5");

var $1LA8L = parcelRequire("1LA8L");

var $boQGP = parcelRequire("boQGP");

var $cYoMq = parcelRequire("cYoMq");

var $9ZuLc = parcelRequire("9ZuLc");

var $xlOmi = parcelRequire("xlOmi");

var $eBGH3 = parcelRequire("eBGH3");

var $12x9g = parcelRequire("12x9g");

var $9aQvf = parcelRequire("9aQvf");

var $8NHMp = parcelRequire("8NHMp");

var $boi4O = parcelRequire("boi4O");

var $MrW4M = parcelRequire("MrW4M");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hFSyR = parcelRequire("hFSyR");

var $U7xww = parcelRequire("U7xww");


var $ivdvr = parcelRequire("ivdvr");
// TODO This is a horrendous hack to temporarily workaround mutual dependency between command/versions and command/cross-project-versions via injection at common parent. Proper solution pending.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $9710589aeb38434b$var$crossProjectVersionsCommands = {};
const $9710589aeb38434b$export$2bdfac268df97e49 = 'command.versions.ADD_RELEASE';
const $9710589aeb38434b$export$3f90e3abee6e8d70 = 'command.versions.UPDATE_RELEASE';
const $9710589aeb38434b$export$c2ca61e48c051fa6 = 'command.versions.RANK_RELEASE';
const $9710589aeb38434b$export$440c54a43c85f449 = 'command.versions.DELETE_RELEASE';
const $9710589aeb38434b$export$bcf0ce7e9670a9d = 'command.versions.CALCULATE_RELEASE_STATUS';
const $9710589aeb38434b$export$114415b2450800d = 'command.versions.CALCULATE_STATUS_OF_ALL_RELEASES';
const $9710589aeb38434b$export$f6d34bff03547a78 = 'command.versions.ADD_RELEASE_TO_CROSS_PROJECT_RELEASE';
const $9710589aeb38434b$export$a54e64fcc2f0026f = 'command.versions.VIEW_RELEASE_IN_ROADMAP';
const $9710589aeb38434b$export$494c2f9413c26e0c = 'command.versions.GET_RELEASES_FOR_IDS';
const $9710589aeb38434b$export$d7ff8290d1a14fa1 = (version)=>({
        type: $9710589aeb38434b$export$2bdfac268df97e49,
        payload: version
    });
const $9710589aeb38434b$export$a5f005f0031c650d = (payload)=>({
        type: $9710589aeb38434b$export$3f90e3abee6e8d70,
        payload: payload
    });
const $9710589aeb38434b$export$e7abf7191f04bdf9 = (id, anchor, relation)=>({
        type: $9710589aeb38434b$export$c2ca61e48c051fa6,
        payload: {
            id: id,
            anchor: anchor,
            relation: relation
        }
    });
const $9710589aeb38434b$export$41b4061737a08cd = (versionId)=>({
        type: $9710589aeb38434b$export$440c54a43c85f449,
        versionId: versionId
    });
const $9710589aeb38434b$export$7e4d7a0e6f2ecd97 = (versionId)=>({
        type: $9710589aeb38434b$export$bcf0ce7e9670a9d,
        versionId: versionId
    });
const $9710589aeb38434b$export$814759937e7677ff = ()=>({
        type: $9710589aeb38434b$export$114415b2450800d
    });
const $9710589aeb38434b$export$bace67d72a0ad73a = (versionId, crossProjectVersionId)=>({
        type: $9710589aeb38434b$export$f6d34bff03547a78,
        payload: {
            versionId: versionId,
            crossProjectVersionId: crossProjectVersionId
        }
    });
const $9710589aeb38434b$export$4ddde390df08566c = (filterValue)=>({
        type: $9710589aeb38434b$export$a54e64fcc2f0026f,
        payload: filterValue
    });
const $9710589aeb38434b$export$63e6b3e46226b547 = (payload)=>({
        type: $9710589aeb38434b$export$494c2f9413c26e0c,
        payload: payload
    });
function* $9710589aeb38434b$export$5efaacd55cc1612e(version) {
    const { id: id, projects: projects, crossProjectVersion: crossProjectVersion } = version;
    // Add a new release to state.domain.versions.
    yield (0, $9e8i2.put)($12x9g.add(version));
    // Add a new release to each project that it belongs to.
    for (const projectId of projects)yield (0, $9e8i2.put)((0, $boQGP.addVersionInProject)({
        projectId: projectId,
        versionId: id
    }));
    // Add a new release to each crossProjectVersion that it belongs to.
    if ((0, $7CnHa.isDefined)(crossProjectVersion)) yield (0, $9e8i2.call)($9710589aeb38434b$var$crossProjectVersionsCommands.addVersionInCrossProjectVersion, id, crossProjectVersion);
}
function* $9710589aeb38434b$export$bf48c144c9502436(versionId) {
    const versionbyIdMap = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
    const version = versionbyIdMap[versionId];
    const { id: id, projects: projects, crossProjectVersion: crossProjectVersion } = version;
    // Remove a release from each project
    for (const projectId of projects)yield (0, $9e8i2.put)((0, $boQGP.removeVersionFromProject)({
        projectId: projectId,
        versionId: id
    }));
    // Remove a release from crossProjectVersion
    if ((0, $7CnHa.isDefined)(crossProjectVersion)) yield (0, $9e8i2.call)($9710589aeb38434b$var$crossProjectVersionsCommands.removeVersionFromCrossProjectVersion, id, crossProjectVersion);
    // Remove a release from state.domain.versions
    yield (0, $9e8i2.put)($12x9g.remove(id));
}
function* $9710589aeb38434b$export$d375fd666a67b57e(removedVersion) {
    const { id: id } = removedVersion;
    yield* (0, $kXdPE.default)(function*() {
        // Remove version from removed versions' list
        yield (0, $9e8i2.put)($cYoMq.remove(id));
        // Add it back to versions list
        yield (0, $9e8i2.call)($9710589aeb38434b$export$5efaacd55cc1612e, removedVersion);
    });
}
function* $9710589aeb38434b$export$50b15d1407aac14c(scenarioId, versionId) {
    const versionbyIdMap = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
    const version = versionbyIdMap[scenarioId];
    const releaseFilter = yield (0, $9e8i2.select)((0, $3nT5G.getReleaseFilterPure));
    yield* (0, $kXdPE.default)(function*() {
        yield (0, $9e8i2.put)((0, $boQGP.removeVersionFromProject)({
            projectId: version.projects[0],
            versionId: scenarioId
        }));
        yield (0, $9e8i2.put)((0, $boQGP.addVersionInProject)({
            projectId: version.projects[0],
            versionId: versionId
        }));
        yield (0, $9e8i2.put)($12x9g.bulkUpdate({
            [scenarioId]: {
                id: versionId
            }
        }));
        if (releaseFilter.value && releaseFilter.value.includes(scenarioId)) {
            const rest = releaseFilter.value.filter(// eslint-disable-next-line @typescript-eslint/no-shadow
            (versionId)=>versionId !== scenarioId);
            yield (0, $9e8i2.put)((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$53e2f8996e102881),
                value: [
                    ...rest,
                    versionId
                ]
            }));
        }
        yield (0, $9e8i2.put)($DywVp.updateReferences({
            versions: [
                [
                    scenarioId,
                    versionId
                ]
            ]
        }));
        yield (0, $9e8i2.put)($gExeY.updateReferences({
            versions: [
                [
                    scenarioId,
                    versionId
                ]
            ]
        }));
        yield (0, $9e8i2.put)((0, $kIUsy.updateVersionLexorankAdjustments)({
            [scenarioId]: versionId
        }));
    });
}
function* $9710589aeb38434b$export$ea5c9603aa3d16d4(entityResponse) {
    const versionId = entityResponse.generatedId;
    const id = entityResponse.itemKey;
    if ((0, $7CnHa.isDefined)(versionId)) yield (0, $9e8i2.call)($9710589aeb38434b$export$50b15d1407aac14c, id, versionId);
    const warnings = yield (0, $9e8i2.call)((0, $U7xww.inspectForCommitWarnings), entityResponse.error, id);
    if (warnings.length) yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).RELEASE,
        itemId: id,
        warnings: warnings
    }));
}
function* $9710589aeb38434b$export$f552fa4bc1966f1e(entityResponse) {
    yield (0, $9e8i2.call)($9710589aeb38434b$export$ea5c9603aa3d16d4, entityResponse);
    const id = entityResponse.itemKey;
    const warnings = yield (0, $9e8i2.select)((0, $wcCGG.getCommitWarningsForVersions));
    const removedVersionsById = yield (0, $9e8i2.select)((0, $wcCGG.getRemovedVersionsById));
    const removedVersion = removedVersionsById[id];
    if (!(0, $7CnHa.isDefined)(warnings[id])) {
        const originals = yield (0, $9e8i2.select)((0, $wcCGG.getOriginalVersions));
        yield (0, $9e8i2.put)((0, $1LA8L.reset)($8K6YM.default(id, originals)));
        if ((0, $7CnHa.isDefined)(removedVersion)) yield (0, $9e8i2.put)($cYoMq.remove(id));
    }
}
function* $9710589aeb38434b$export$be623675b8f208ee(id) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, id);
    const response = yield* $iTjRl.json({
        url: (0, $hFSyR.urls).revertChanges,
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
    }
    return response;
}
function* $9710589aeb38434b$export$387fc7d982d5d3ef(payload) {
    yield (0, $9e8i2.put)($12x9g.updateReferences(payload));
    yield (0, $9e8i2.put)($1LA8L.updateReferences(payload));
}
function* $9710589aeb38434b$export$21aa7f798a65a8c0(payload) {
    const versions = yield (0, $9e8i2.select)((0, $wcCGG.getVersions));
    let originalVersions = $01zCq.default({}, (yield (0, $9e8i2.select)((0, $wcCGG.getOriginalVersions))));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const versionPatches = {};
    for (const version of versions){
        const { id: id } = version;
        const originalVersion = originalVersions[id];
        for (const key of Object.keys(payload)){
            for (const ref of payload[key])if (version[key] === ref) {
                versionPatches[id] = $01zCq.default(versionPatches[id], {
                    [key]: originalVersion[key] || null
                });
                delete originalVersion[key];
                if (Object.keys(originalVersion).length === 0) originalVersions = $8K6YM.default(id, originalVersions);
            }
        }
    }
    yield (0, $9e8i2.put)($12x9g.bulkUpdate(versionPatches));
    yield (0, $9e8i2.put)($1LA8L.reset(originalVersions));
}
function* $9710589aeb38434b$export$476de812fbbb6302({ projectId: projectId, version: version }, newVersionId, sequence) {
    yield* (0, $kXdPE.default)(function*() {
        // Add a new release to client-side model
        const highestRankedVersion = yield (0, $9e8i2.select)((0, $wcCGG.getVersionWithHighestRankInProject), projectId);
        yield (0, $9e8i2.call)($9710589aeb38434b$export$5efaacd55cc1612e, {
            ...version,
            id: newVersionId,
            crossProjectVersion: null,
            releaseStatusId: '0',
            lexoRank: (0, $7CnHa.isDefined)(highestRankedVersion) ? highestRankedVersion.lexoRank : '',
            projects: [
                projectId
            ]
        });
        // Rank a newly added release such that it has the highest rank
        if ((0, $7CnHa.isDefined)(highestRankedVersion)) {
            const rankPayload = {
                id: newVersionId,
                anchor: highestRankedVersion.id,
                relation: 'AFTER'
            };
            yield (0, $9e8i2.put)($12x9g.rank(rankPayload));
            yield (0, $9e8i2.put)((0, $kIUsy.adjustVersionLexoRank)(rankPayload));
        }
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        /** Update the original versions model so that it shows newly added release in
		 *  the update-jira dialog.
		 */ yield (0, $9e8i2.put)($1LA8L.update({
            id: newVersionId,
            values: {}
        }));
        // Close the create release dialog
        yield (0, $9e8i2.put)((0, $boi4O.closeDialog)());
    });
}
function* $9710589aeb38434b$export$89ca6b91461e4dc({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $boi4O.initiateRequest)());
    try {
        const url = (0, $hFSyR.urls).add;
        const body = (0, $hFSyR.addVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body,
            profile: url
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        else {
            const { itemKey: itemKey, change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($9710589aeb38434b$export$476de812fbbb6302, payload, itemKey, sequence);
        }
        yield (0, $9e8i2.put)((0, $boi4O.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $boi4O.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $9710589aeb38434b$export$5652a4ac6807e581({ versionId: versionId, patch: patch }) {
    const versionsById = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
    const version = versionsById[versionId];
    const updatedAttributes = Object.keys(patch);
    const originalValues = $7WzTP.default(updatedAttributes, {
        ...version
    });
    // Update a release in client-side model
    yield (0, $9e8i2.put)($12x9g.bulkUpdate({
        [versionId]: patch
    }));
    // Calculate the new release status
    if (updatedAttributes.includes('start') || updatedAttributes.includes('end')) yield (0, $9e8i2.put)($9710589aeb38434b$export$7e4d7a0e6f2ecd97(versionId));
    // Update cross-project version
    if (updatedAttributes.includes('crossProjectVersion')) {
        if ((0, $7CnHa.isDefined)(version.crossProjectVersion)) // Remove a release from crossProjectVersion
        yield (0, $9e8i2.call)($9710589aeb38434b$var$crossProjectVersionsCommands.removeVersionFromCrossProjectVersion, versionId, version.crossProjectVersion);
        if ((0, $7CnHa.isDefined)(patch.crossProjectVersion)) // Add a new release to each crossProjectVersion that it belongs to.
        yield (0, $9e8i2.call)($9710589aeb38434b$var$crossProjectVersionsCommands.addVersionInCrossProjectVersion, versionId, patch.crossProjectVersion);
    }
    /** Update the original versions model so that it shows newly added release in
	 *  the update-jira dialog.
	 */ yield (0, $9e8i2.put)($1LA8L.update({
        id: versionId,
        values: originalValues
    }));
}
function* $9710589aeb38434b$export$307c978903f505ad(payload, sequence) {
    yield* (0, $kXdPE.default)(function*() {
        // Update the version
        yield (0, $9e8i2.call)($9710589aeb38434b$export$5652a4ac6807e581, payload);
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        // Close the update release dialog
        yield (0, $9e8i2.put)((0, $boi4O.closeDialog)());
        yield (0, $9e8i2.put)((0, $9aQvf.closeDialog)());
    });
}
function* $9710589aeb38434b$export$740de856a6989843({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $boi4O.initiateRequest)());
    try {
        const url = (0, $hFSyR.urls).update;
        const body = (0, $hFSyR.updateVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body,
            profile: url
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        else {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($9710589aeb38434b$export$307c978903f505ad, payload, sequence);
        }
        yield (0, $9e8i2.put)((0, $boi4O.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $boi4O.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $9710589aeb38434b$export$c3dc37c85d86f10c({ payload: payload }) {
    const isRanking = yield (0, $9e8i2.select)((0, $wcCGG.getReleasesTableRankingStatus));
    try {
        const url = (0, $hFSyR.urls).rank;
        const body = (0, $hFSyR.rankVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            /** When a release is ranked in the releases table and the call fails, the dynamic-table that we are using
			 * remembers the new poisiton and do not put the release back to it's original position. In order to achieve that
			 * we have to re-render dynamic table. This state is updated to re-render the releases dynamic table. This
			 * happens in all failure scenario. */ yield (0, $9e8i2.put)((0, $MrW4M.isReleasesRanking)(!isRanking));
            return;
        }
        const { change: { sequence: sequence }, failed: failed } = yield (0, $9e8i2.call)(response.json.bind(response));
        if (failed > 0) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: 'Failed to rank release'
            }));
            yield (0, $9e8i2.put)((0, $MrW4M.isReleasesRanking)(!isRanking));
            return;
        }
        yield* (0, $kXdPE.default)(function*() {
            const versions = yield (0, $9e8i2.select)((0, $wcCGG.getVersions));
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-shadow
            const { id: id, lexoRank: lexoRank } = versions.find(({ id: id })=>id === payload.id);
            if (!id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $9e8i2.put)($1LA8L.update({
                id: id,
                values: {
                    lexoRank: lexoRank
                }
            }));
            yield (0, $9e8i2.put)($12x9g.rank(payload));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            yield (0, $9e8i2.put)((0, $kIUsy.adjustVersionLexoRank)(payload));
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
        yield (0, $9e8i2.put)((0, $MrW4M.isReleasesRanking)(!isRanking));
    }
}
function* $9710589aeb38434b$export$25de5bd053709c0f(versionId) {
    const issuesByVersion = yield (0, $9e8i2.select)((0, $kwMvv.getIssuesByVersionMap));
    const issuesInCurrentVersion = issuesByVersion[versionId];
    const originalIssues = yield (0, $9e8i2.select)((0, $kwMvv.getOriginalIssues));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bulkUpdatePayload = {};
    for (const { id: id } of issuesInCurrentVersion){
        bulkUpdatePayload[id] = {
            fixVersions: originalIssues[id].fixVersions
        };
        yield (0, $9e8i2.put)($lwKA5.revertFields({
            id: id,
            fields: [
                'fixVersions'
            ]
        }));
    }
    yield (0, $9e8i2.put)($kt7Vd.bulkUpdate(bulkUpdatePayload));
}
function* $9710589aeb38434b$export$d88648d01aa45c1d(versionId, sequence) {
    yield* (0, $kXdPE.default)(function*() {
        // Reset version assginments to Issue.
        yield (0, $9e8i2.call)($9710589aeb38434b$export$25de5bd053709c0f, versionId);
        // Remove version from store
        yield (0, $9e8i2.call)($9710589aeb38434b$export$bf48c144c9502436, versionId);
        // Remove version from original versions as we don't commit such changes
        const originals = yield (0, $9e8i2.select)((0, $wcCGG.getOriginalVersions));
        yield (0, $9e8i2.put)($1LA8L.reset($8K6YM.default(versionId, originals)));
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        // Close the delete release dialog
        yield (0, $9e8i2.put)((0, $8NHMp.closeDialog)());
    });
}
function* $9710589aeb38434b$export$3d30cf8b88f7bb6f(versionId, sequence) {
    const versionsById = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
    const version = versionsById[versionId];
    const issuesByVersionid = yield (0, $9e8i2.select)((0, $kwMvv.getIssuesByVersionMap));
    yield* (0, $kXdPE.default)(function*() {
        // Remove version from store
        yield (0, $9e8i2.call)($9710589aeb38434b$export$bf48c144c9502436, versionId);
        // Add version to removed version
        yield (0, $9e8i2.put)($cYoMq.add(version));
        // Add issues to scenario removed issues that are assigned to removed version
        /**
		 * We have intentionally not removed these issues from the "issues" branch of the state
		 * because we are removed issues that are assinged to scenario removed issues in the
		 * "getIsssues" selector.
		 */ yield (0, $9e8i2.put)($9ZuLc.bulkAdd(issuesByVersionid[versionId]));
        /** Update the original versions model so that it shows removed release in
		 *  the update-jira dialog.
		 */ yield (0, $9e8i2.put)($1LA8L.update({
            id: versionId,
            values: {}
        }));
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        // Close the delete release dialog
        yield (0, $9e8i2.put)((0, $8NHMp.closeDialog)());
    });
}
function* $9710589aeb38434b$export$c7f0d1a6ee665364({ versionId: versionId }) {
    yield (0, $9e8i2.put)((0, $8NHMp.initiateRequest)());
    try {
        const url = (0, $hFSyR.urls).delete;
        const body = (0, $hFSyR.deleteVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), versionId);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        else {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            if (versionId.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $9e8i2.call)($9710589aeb38434b$export$d88648d01aa45c1d, versionId, sequence);
            else yield (0, $9e8i2.call)($9710589aeb38434b$export$3d30cf8b88f7bb6f, versionId, sequence);
        }
        yield (0, $9e8i2.put)((0, $8NHMp.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $8NHMp.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $9710589aeb38434b$export$19970962bad2152d(versionId, issueDate, releaseDate) {
    /** If target start/end date of the issue is after release date then set the
	 * release status as OFFTRACK, else set as ONTRACK.
	 */ const releaseStatusId = (0, $7CnHa.isDefined)(issueDate) && (0, $7CnHa.isDefined)(releaseDate) && issueDate > releaseDate ? (0, $5rYNM.RELEASE_STATUSES).OFFTRACK : (0, $5rYNM.RELEASE_STATUSES).ONTRACK;
    yield (0, $9e8i2.put)($12x9g.bulkUpdate({
        [versionId]: {
            releaseStatusId: releaseStatusId
        }
    }));
}
function* $9710589aeb38434b$export$4dbc8e12162b81db({ versionId: versionId }, issuesByVersionCache) {
    const versionbyIdMap = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
    const issuesByVersion = issuesByVersionCache || (yield (0, $9e8i2.select)((0, $kwMvv.getIssuesByVersionMap)));
    const version = versionbyIdMap[versionId];
    if (!version) return;
    const releaseDate = version.end;
    // This additional check is used when we directly call this saga.
    if (version.releaseStatusId === (0, $5rYNM.RELEASE_STATUSES).RELEASED) return;
    // Calculate the release status based the target end date of the issues.
    const issueEndingLastBasedOnBaselineEnd = yield (0, $9e8i2.call)((0, $g8SOd.getIssueEndingLastBasedOnBaselineEnd), issuesByVersion[versionId]);
    if ((0, $7CnHa.isDefined)(issueEndingLastBasedOnBaselineEnd)) {
        const { baselineEnd: baselineEnd } = issueEndingLastBasedOnBaselineEnd;
        yield (0, $9e8i2.call)($9710589aeb38434b$export$19970962bad2152d, versionId, baselineEnd, releaseDate);
        return;
    }
    /** If target end date is not set for all the issues then calculate the release status
	 * based on the target start date of the issues.
	 */ const issueStartingLastBasedOnBaselineStart = yield (0, $9e8i2.call)((0, $g8SOd.getIssueStartingLastBasedOnBaselineStart), issuesByVersion[versionId]);
    if ((0, $7CnHa.isDefined)(issueStartingLastBasedOnBaselineStart)) {
        const { baselineStart: baselineStart } = issueStartingLastBasedOnBaselineStart;
        yield (0, $9e8i2.call)($9710589aeb38434b$export$19970962bad2152d, versionId, baselineStart, releaseDate);
        return;
    }
    /** If target start and targetEnd dates are not set for all the issues then calculate the release status
	 * based on the sprint date end  of the issues.
	 */ const sprints = yield (0, $9e8i2.select)((0, $c1XMU.getSprintsWithFutureDates));
    const issueEndingLastBasedOnSprintEndDate = yield (0, $9e8i2.call)((0, $g8SOd.getIssueEndingLastBasedOnSprintEndDate), issuesByVersion[versionId], sprints);
    if ((0, $7CnHa.isDefined)(issueEndingLastBasedOnSprintEndDate)) {
        const { baselineEnd: baselineEnd } = issueEndingLastBasedOnSprintEndDate;
        yield (0, $9e8i2.call)($9710589aeb38434b$export$19970962bad2152d, versionId, baselineEnd, releaseDate);
        return;
    }
    /** If none of the issues are set target start and target end date then we can't calculate
	 * the release status. Hence set the release status as ONTRACK.
	 */ yield (0, $9e8i2.put)($12x9g.bulkUpdate({
        [versionId]: {
            releaseStatusId: (0, $5rYNM.RELEASE_STATUSES).ONTRACK
        }
    }));
}
function* $9710589aeb38434b$export$7e65e5343d7c672b() {
    const versions = yield (0, $9e8i2.select)((0, $wcCGG.getVersions));
    const issuesByVersion = yield (0, $9e8i2.select)((0, $kwMvv.getIssuesByVersionMap));
    const unreleasedVersionsWithReleaseDateAndIssues = [];
    const onTrackPayload = {
        releaseStatusId: (0, $5rYNM.RELEASE_STATUSES).ONTRACK
    };
    const onTrackVersions = {};
    for (const { id: id, releaseStatusId: releaseStatusId, end: end } of versions)if (releaseStatusId !== (0, $5rYNM.RELEASE_STATUSES).RELEASED) {
        if (!(0, $7CnHa.isDefined)(end) || // without a release date
        issuesByVersion[id].length === 0 // or without issues assigned to it
        ) onTrackVersions[id] = onTrackPayload;
        else unreleasedVersionsWithReleaseDateAndIssues.push(id);
    }
    yield* (0, $kXdPE.default)(function*() {
        // Set the release status as ONTRACK for all the unreleased releases without
        // release date and with none of the issues tagged to them.
        yield (0, $9e8i2.put)($12x9g.bulkUpdate(onTrackVersions));
        // Now calculate the release status of the unreleased releases with release
        // date and having issues tagged to them.
        for (const versionId of unreleasedVersionsWithReleaseDateAndIssues)yield (0, $9e8i2.call)($9710589aeb38434b$export$4dbc8e12162b81db, $9710589aeb38434b$export$7e4d7a0e6f2ecd97(versionId), issuesByVersion);
    });
}
function* $9710589aeb38434b$export$31d54314ae5480f6({ payload: { versionId: versionId, crossProjectVersionId: crossProjectVersionId } }) {
    yield (0, $9e8i2.put)($9710589aeb38434b$export$a5f005f0031c650d({
        versionId: versionId,
        patch: {
            crossProjectVersion: crossProjectVersionId
        }
    }));
}
function* $9710589aeb38434b$export$6305f6649b21cb82({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $296Gg.change)({
        id: (0, $12ee831723ccf9c2$export$53e2f8996e102881),
        value: payload
    }));
    yield (0, $9e8i2.put)((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$585fb3e81bcfccad)));
}
function* $9710589aeb38434b$export$cb0413722f11fcf5({ payload: payload }) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = yield* $iTjRl.json({
        url: (0, $hFSyR.urls).get,
        method: 'POST',
        body: {
            planId: planId,
            scenarioId: scenarioId,
            ids: payload
        }
    });
    if (response.ok) yield* (0, $kXdPE.default)(function*() {
        for (const version of response.data.filter(// eslint-disable-next-line @typescript-eslint/no-shadow
        (version)=>version.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED)){
            yield (0, $9e8i2.put)($12x9g.add({
                projects: [
                    version.projectId
                ],
                id: version.itemKey,
                ...version.values
            }));
            yield (0, $9e8i2.put)($9710589aeb38434b$export$7e4d7a0e6f2ecd97(version.values.id));
        }
    });
}
function* $9710589aeb38434b$export$7636f00a67e1b930() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$2bdfac268df97e49, $9710589aeb38434b$export$89ca6b91461e4dc);
}
function* $9710589aeb38434b$export$919e3b6069d2417d() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$3f90e3abee6e8d70, $9710589aeb38434b$export$740de856a6989843);
}
function* $9710589aeb38434b$export$2075f1cbc6860e11() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$c2ca61e48c051fa6, $9710589aeb38434b$export$c3dc37c85d86f10c);
}
function* $9710589aeb38434b$export$877c3b6cd35254fd() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$440c54a43c85f449, $9710589aeb38434b$export$c7f0d1a6ee665364);
}
function* $9710589aeb38434b$export$d72bc7e55e3e1f7a() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$bcf0ce7e9670a9d, $9710589aeb38434b$export$4dbc8e12162b81db);
}
function* $9710589aeb38434b$export$db3062cd2a511ac7() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$114415b2450800d, $9710589aeb38434b$export$7e65e5343d7c672b);
}
function* $9710589aeb38434b$export$3e74af38e36afe10() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$f6d34bff03547a78, $9710589aeb38434b$export$31d54314ae5480f6);
}
function* $9710589aeb38434b$export$20993805280f607e() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$a54e64fcc2f0026f, $9710589aeb38434b$export$6305f6649b21cb82);
}
function* $9710589aeb38434b$export$d211e2e29b5233fc() {
    yield (0, $bG7pV.takeEvery)($9710589aeb38434b$export$494c2f9413c26e0c, $9710589aeb38434b$export$cb0413722f11fcf5);
}
function $9710589aeb38434b$export$2e2bcd8739ae039(crossProjectVersionsCommandsModule) {
    $9710589aeb38434b$var$crossProjectVersionsCommands = crossProjectVersionsCommandsModule;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function*() {
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$7636f00a67e1b930);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$919e3b6069d2417d);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$2075f1cbc6860e11);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$877c3b6cd35254fd);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$d72bc7e55e3e1f7a);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$db3062cd2a511ac7);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$3e74af38e36afe10);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$20993805280f607e);
        yield (0, $9e8i2.fork)($9710589aeb38434b$export$d211e2e29b5233fc);
    };
}

});
parcelRegister("7WzTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c89cc128bdca723$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $5c89cc128bdca723$var$pick = /*#__PURE__*/ (0, $ggdJA.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $5c89cc128bdca723$export$2e2bcd8739ae039 = $5c89cc128bdca723$var$pick;

});

parcelRegister("g8SOd", function(module, exports) {

$parcel$export(module.exports, "getIssueStartingLastBasedOnBaselineStart", () => $900863b4776c51df$export$82110a2ddafda11a);
$parcel$export(module.exports, "getIssueEndingLastBasedOnBaselineEnd", () => $900863b4776c51df$export$963e0f9e82d0022d);
$parcel$export(module.exports, "getIssueEndingLastBasedOnSprintEndDate", () => $900863b4776c51df$export$23baf3eb744c9623);
$parcel$export(module.exports, "getIssueOption", () => $900863b4776c51df$export$fa4500d3cd97bc66);
$parcel$export(module.exports, "mergeOptimizedValueToIssue", () => $900863b4776c51df$export$3e9f1ccec23df0b9);

var $iTvqy = parcelRequire("iTvqy");

var $23M0s = parcelRequire("23M0s");

var $3G3gn = parcelRequire("3G3gn");
parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");

var $7CnHa = parcelRequire("7CnHa");
const $900863b4776c51df$var$getLatestIssueBasedOn = (field)=>(issues)=>{
        const sorted = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issues.filter((issue)=>!!issue[field]), (0, (/*@__PURE__*/$parcel$interopDefault($23M0s)))(field));
        return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sorted);
    };
const $900863b4776c51df$export$82110a2ddafda11a = $900863b4776c51df$var$getLatestIssueBasedOn('baselineStart');
const $900863b4776c51df$export$963e0f9e82d0022d = $900863b4776c51df$var$getLatestIssueBasedOn('baselineEnd');
const $900863b4776c51df$export$23baf3eb744c9623 = (issues, sprintsWithDates)=>{
    const issuesWithTargetEndDate = issues.reduce((results, issue)=>{
        const { rawEndDate: rawEndDate } = (0, $a4NMN.getTargetDatesFromSprints)(issue, (0, $7CnHa.isDefined)(issue.team) ? sprintsWithDates[issue.team] || [] : []);
        if (rawEndDate) results.push({
            ...issue,
            baselineEnd: rawEndDate
        });
        return results;
    }, []);
    if (issuesWithTargetEndDate.length === 0) return;
    return $900863b4776c51df$export$963e0f9e82d0022d(issuesWithTargetEndDate);
};
const $900863b4776c51df$export$fa4500d3cd97bc66 = (issue, issueTypesById, projectsById)=>{
    const issueProject = issue.project && projectsById[issue.project];
    const issueProjectAndKey = issueProject ? `${issueProject.key}${issue.issueKey ? `-${issue.issueKey} ` : ' '}` : '';
    return {
        value: issue.id,
        label: `${issueProjectAndKey}${issue.summary}`,
        icon: issueTypesById && issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl
    };
};
const $900863b4776c51df$export$3e9f1ccec23df0b9 = (issue, isOptimizationMode)=>{
    if (isOptimizationMode) return {
        ...issue,
        ...issue.optimized
    };
    return issue;
};

});

parcelRegister("DywVp", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $18fce6649944b341$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $18fce6649944b341$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $18fce6649944b341$export$29d55e1f664a246b);
$parcel$export(module.exports, "BULK_UPDATE", () => $18fce6649944b341$export$193f41a37c2df875);
$parcel$export(module.exports, "ADD_VERSION_IN_CROSS_PROJECT_VERSION", () => $18fce6649944b341$export$5bb382b7a9364fa0);
$parcel$export(module.exports, "REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION", () => $18fce6649944b341$export$cfd29272fccd14f8);
$parcel$export(module.exports, "UPDATE_REFERENCES", () => $18fce6649944b341$export$a6376ffb02379d2a);
$parcel$export(module.exports, "reset", () => $18fce6649944b341$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $18fce6649944b341$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $18fce6649944b341$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "bulkUpdate", () => $18fce6649944b341$export$fc4d5d648b7f7ca2);
$parcel$export(module.exports, "updateReferences", () => $18fce6649944b341$export$387fc7d982d5d3ef);
$parcel$export(module.exports, "addVersionInCrossProjectVersion", () => $18fce6649944b341$export$8e127e72248d08);
$parcel$export(module.exports, "removeVersionFromCrossProjectVersion", () => $18fce6649944b341$export$ac89d6cd5251dbf4);
const $18fce6649944b341$export$4a991c87e640ef77 = 'state.domain.cross-project-versions.RESET';
const $18fce6649944b341$export$bb6389024b71c2ae = 'state.domain.cross-project-versions.ADD';
const $18fce6649944b341$export$29d55e1f664a246b = 'state.domain.cross-project-versions.REMOVE';
const $18fce6649944b341$export$193f41a37c2df875 = 'state.domain.cross-project-versions.BULK_UPDATE';
const $18fce6649944b341$export$5bb382b7a9364fa0 = 'state.domain.cross-project-versions.ADD_VERSION_IN_CROSS_PROJECT_VERSION';
const $18fce6649944b341$export$cfd29272fccd14f8 = 'state.domain.cross-project-versions.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION';
const $18fce6649944b341$export$a6376ffb02379d2a = 'state.domain.cross-project-versions.UPDATE_REFERENCES';
const $18fce6649944b341$export$aad8462122ac592b = (payload)=>({
        type: $18fce6649944b341$export$4a991c87e640ef77,
        payload: payload
    });
const $18fce6649944b341$export$e16d8520af44a096 = (payload)=>({
        type: $18fce6649944b341$export$bb6389024b71c2ae,
        payload: payload
    });
const $18fce6649944b341$export$cd7f480d6b8286c3 = (payload)=>({
        type: $18fce6649944b341$export$29d55e1f664a246b,
        payload: payload
    });
const $18fce6649944b341$export$fc4d5d648b7f7ca2 = (payload)=>({
        type: $18fce6649944b341$export$193f41a37c2df875,
        payload: payload
    });
const $18fce6649944b341$export$387fc7d982d5d3ef = (payload)=>({
        type: $18fce6649944b341$export$a6376ffb02379d2a,
        payload: payload
    });
const $18fce6649944b341$export$8e127e72248d08 = (payload)=>({
        type: $18fce6649944b341$export$5bb382b7a9364fa0,
        payload: payload
    });
const $18fce6649944b341$export$ac89d6cd5251dbf4 = (payload)=>({
        type: $18fce6649944b341$export$cfd29272fccd14f8,
        payload: payload
    });

});

parcelRegister("kt7Vd", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $9b251f04e23eb258$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $9b251f04e23eb258$export$e271b26eefe41db8);
$parcel$export(module.exports, "ADD", () => $9b251f04e23eb258$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RANK", () => $9b251f04e23eb258$export$c3d7e0f1e63de60e);
$parcel$export(module.exports, "BULK_RANK", () => $9b251f04e23eb258$export$2f0e7af5a9c14709);
$parcel$export(module.exports, "BULK_UPDATE", () => $9b251f04e23eb258$export$193f41a37c2df875);
$parcel$export(module.exports, "BULK_LABEL_UPDATE", () => $9b251f04e23eb258$export$9cfd4599eabb1543);
$parcel$export(module.exports, "REMOVE_WITHOUT_ISSUE_KEY", () => $9b251f04e23eb258$export$dce92373a83d92e6);
$parcel$export(module.exports, "reset", () => $9b251f04e23eb258$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $9b251f04e23eb258$export$722fbec263ad908a);
$parcel$export(module.exports, "bulkUpdate", () => $9b251f04e23eb258$export$fc4d5d648b7f7ca2);
$parcel$export(module.exports, "bulkLabelUpdate", () => $9b251f04e23eb258$export$8fb259f4ed407e98);
$parcel$export(module.exports, "add", () => $9b251f04e23eb258$export$e16d8520af44a096);
$parcel$export(module.exports, "rank", () => $9b251f04e23eb258$export$fbc8bcd33b574fbc);
$parcel$export(module.exports, "bulkRank", () => $9b251f04e23eb258$export$18077ecf970eb146);
$parcel$export(module.exports, "removeWithoutIssueKey", () => $9b251f04e23eb258$export$84880db81a8577e8);
const $9b251f04e23eb258$export$4a991c87e640ef77 = 'state.domain.issues.RESET';
const $9b251f04e23eb258$export$e271b26eefe41db8 = 'state.domain.issues.UPDATE';
const $9b251f04e23eb258$export$bb6389024b71c2ae = 'state.domain.issues.ADD';
const $9b251f04e23eb258$export$c3d7e0f1e63de60e = 'state.domain.issues.RANK';
const $9b251f04e23eb258$export$2f0e7af5a9c14709 = 'state.domain.issues.BULK_RANK';
const $9b251f04e23eb258$export$193f41a37c2df875 = 'state.domain.issues.BULK_UPDATE';
const $9b251f04e23eb258$export$9cfd4599eabb1543 = 'state.domain.issues.BULK_LABEL_UPDATE';
const $9b251f04e23eb258$export$dce92373a83d92e6 = 'state.domain.issues.REMOVE_WITHOUT_ISSUE_KEY';
const $9b251f04e23eb258$export$aad8462122ac592b = (payload)=>({
        type: $9b251f04e23eb258$export$4a991c87e640ef77,
        payload: payload
    });
const $9b251f04e23eb258$export$722fbec263ad908a = (payload)=>({
        type: $9b251f04e23eb258$export$e271b26eefe41db8,
        payload: payload
    });
const $9b251f04e23eb258$export$fc4d5d648b7f7ca2 = (payload)=>({
        type: $9b251f04e23eb258$export$193f41a37c2df875,
        payload: payload
    });
const $9b251f04e23eb258$export$8fb259f4ed407e98 = (payload)=>({
        type: $9b251f04e23eb258$export$9cfd4599eabb1543,
        payload: payload
    });
const $9b251f04e23eb258$export$e16d8520af44a096 = (payload)=>({
        type: $9b251f04e23eb258$export$bb6389024b71c2ae,
        payload: payload
    });
const $9b251f04e23eb258$export$fbc8bcd33b574fbc = (payload)=>({
        type: $9b251f04e23eb258$export$c3d7e0f1e63de60e,
        payload: payload
    });
const $9b251f04e23eb258$export$18077ecf970eb146 = (payload)=>({
        type: $9b251f04e23eb258$export$2f0e7af5a9c14709,
        payload: payload
    });
const $9b251f04e23eb258$export$84880db81a8577e8 = ()=>({
        type: $9b251f04e23eb258$export$dce92373a83d92e6
    });

});

parcelRegister("kIUsy", function(module, exports) {

$parcel$export(module.exports, "RESET_ADJUSTMENTS", () => $4187e0f4311ac37f$export$250cb1b4630283c8);
$parcel$export(module.exports, "ADJUST_ISSUE_LEXORANK", () => $4187e0f4311ac37f$export$a725da43c169be3f);
$parcel$export(module.exports, "BULK_ADJUST_ISSUE_LEXORANK", () => $4187e0f4311ac37f$export$e19ad2bc26becca6);
$parcel$export(module.exports, "ADJUST_VERSION_LEXORANK", () => $4187e0f4311ac37f$export$a37e1778d5918680);
$parcel$export(module.exports, "UPDATE_VERSION_LEXORANK_ADJUSTMENTS", () => $4187e0f4311ac37f$export$e5a62d196ff7bcf6);
$parcel$export(module.exports, "resetAdjustments", () => $4187e0f4311ac37f$export$18e2a815bee627c8);
$parcel$export(module.exports, "adjustLexoRank", () => $4187e0f4311ac37f$export$542c0016967556bc);
$parcel$export(module.exports, "bulkAdjustLexoRank", () => $4187e0f4311ac37f$export$2390e9f7e5ba0983);
$parcel$export(module.exports, "adjustVersionLexoRank", () => $4187e0f4311ac37f$export$d39cbec08adbce15);
$parcel$export(module.exports, "updateVersionLexorankAdjustments", () => $4187e0f4311ac37f$export$49fab6a55c666253);
const $4187e0f4311ac37f$export$250cb1b4630283c8 = 'state.domain.lexorank.RESET_ADJUSTMENTS';
const $4187e0f4311ac37f$export$a725da43c169be3f = 'state.domain.lexorank.ADJUST_ISSUE_LEXORANK';
const $4187e0f4311ac37f$export$e19ad2bc26becca6 = 'state.domain.lexorank.BULK_ADJUST_ISSUE_LEXORANK';
const $4187e0f4311ac37f$export$a37e1778d5918680 = 'state.domain.lexorank.ADJUST_VERSION_LEXORANK';
const $4187e0f4311ac37f$export$e5a62d196ff7bcf6 = 'state.domain.lexorank.UPDATE_VERSION_LEXORANK_ADJUSTMENTS';
const $4187e0f4311ac37f$export$18e2a815bee627c8 = (payload)=>({
        type: $4187e0f4311ac37f$export$250cb1b4630283c8,
        payload: payload
    });
const $4187e0f4311ac37f$export$542c0016967556bc = (payload)=>({
        type: $4187e0f4311ac37f$export$a725da43c169be3f,
        payload: payload
    });
const $4187e0f4311ac37f$export$2390e9f7e5ba0983 = (payload)=>({
        type: $4187e0f4311ac37f$export$e19ad2bc26becca6,
        payload: payload
    });
const $4187e0f4311ac37f$export$d39cbec08adbce15 = (payload)=>({
        type: $4187e0f4311ac37f$export$a37e1778d5918680,
        payload: payload
    });
const $4187e0f4311ac37f$export$49fab6a55c666253 = (payload)=>({
        type: $4187e0f4311ac37f$export$e5a62d196ff7bcf6,
        payload: payload
    });

});

parcelRegister("gExeY", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $123edafc363ea977$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $123edafc363ea977$export$e271b26eefe41db8);
$parcel$export(module.exports, "UPDATE_REFERENCES", () => $123edafc363ea977$export$a6376ffb02379d2a);
$parcel$export(module.exports, "reset", () => $123edafc363ea977$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $123edafc363ea977$export$722fbec263ad908a);
$parcel$export(module.exports, "updateReferences", () => $123edafc363ea977$export$387fc7d982d5d3ef);
const $123edafc363ea977$export$4a991c87e640ef77 = 'state.domain.original-cross-project-versions.RESET';
const $123edafc363ea977$export$e271b26eefe41db8 = 'state.domain.original-cross-project-versions.UPDATE';
const $123edafc363ea977$export$a6376ffb02379d2a = 'state.domain.original-cross-project-versions.UPDATE_REFERENCES';
const $123edafc363ea977$export$aad8462122ac592b = (payload)=>({
        type: $123edafc363ea977$export$4a991c87e640ef77,
        payload: payload
    });
const $123edafc363ea977$export$722fbec263ad908a = (payload)=>({
        type: $123edafc363ea977$export$e271b26eefe41db8,
        payload: payload
    });
const $123edafc363ea977$export$387fc7d982d5d3ef = (payload)=>({
        type: $123edafc363ea977$export$a6376ffb02379d2a,
        payload: payload
    });

});

parcelRegister("lwKA5", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $95e9cf5eec80dc66$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $95e9cf5eec80dc66$export$e271b26eefe41db8);
$parcel$export(module.exports, "REVERT_FIELDS", () => $95e9cf5eec80dc66$export$f28bd85bcbd8a2dc);
$parcel$export(module.exports, "REMOVE", () => $95e9cf5eec80dc66$export$29d55e1f664a246b);
$parcel$export(module.exports, "reset", () => $95e9cf5eec80dc66$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $95e9cf5eec80dc66$export$722fbec263ad908a);
$parcel$export(module.exports, "revertFields", () => $95e9cf5eec80dc66$export$466264e35a72d8ef);
$parcel$export(module.exports, "remove", () => $95e9cf5eec80dc66$export$cd7f480d6b8286c3);
const $95e9cf5eec80dc66$export$4a991c87e640ef77 = 'state.domain.original-issues.RESET';
const $95e9cf5eec80dc66$export$e271b26eefe41db8 = 'state.domain.original-issues.UPDATE';
const $95e9cf5eec80dc66$export$f28bd85bcbd8a2dc = 'state.domain.original-issues.REVERT_FIELDS';
const $95e9cf5eec80dc66$export$29d55e1f664a246b = 'state.domain.original-issues.REMOVE';
const $95e9cf5eec80dc66$export$aad8462122ac592b = (payload)=>({
        type: $95e9cf5eec80dc66$export$4a991c87e640ef77,
        payload: payload
    });
const $95e9cf5eec80dc66$export$722fbec263ad908a = (payload)=>({
        type: $95e9cf5eec80dc66$export$e271b26eefe41db8,
        payload: payload
    });
const $95e9cf5eec80dc66$export$466264e35a72d8ef = (payload)=>({
        type: $95e9cf5eec80dc66$export$f28bd85bcbd8a2dc,
        payload: payload
    });
const $95e9cf5eec80dc66$export$cd7f480d6b8286c3 = (payload)=>({
        type: $95e9cf5eec80dc66$export$29d55e1f664a246b,
        payload: payload
    });

});

parcelRegister("1LA8L", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $32c91b2e6b9b3805$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $32c91b2e6b9b3805$export$e271b26eefe41db8);
$parcel$export(module.exports, "UPDATE_REFERENCES", () => $32c91b2e6b9b3805$export$a6376ffb02379d2a);
$parcel$export(module.exports, "reset", () => $32c91b2e6b9b3805$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $32c91b2e6b9b3805$export$722fbec263ad908a);
$parcel$export(module.exports, "updateReferences", () => $32c91b2e6b9b3805$export$387fc7d982d5d3ef);
const $32c91b2e6b9b3805$export$4a991c87e640ef77 = 'state.domain.original-versions.RESET';
const $32c91b2e6b9b3805$export$e271b26eefe41db8 = 'state.domain.original-versions.UPDATE';
const $32c91b2e6b9b3805$export$a6376ffb02379d2a = 'state.domain.original-versions.UPDATE_REFERENCES';
const $32c91b2e6b9b3805$export$aad8462122ac592b = (payload)=>({
        type: $32c91b2e6b9b3805$export$4a991c87e640ef77,
        payload: payload
    });
const $32c91b2e6b9b3805$export$722fbec263ad908a = (payload)=>({
        type: $32c91b2e6b9b3805$export$e271b26eefe41db8,
        payload: payload
    });
const $32c91b2e6b9b3805$export$387fc7d982d5d3ef = (payload)=>({
        type: $32c91b2e6b9b3805$export$a6376ffb02379d2a,
        payload: payload
    });

});

parcelRegister("boQGP", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $3ed37431e2697918$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $3ed37431e2697918$export$bb6389024b71c2ae);
$parcel$export(module.exports, "ADD_VERSION_IN_PROJECT", () => $3ed37431e2697918$export$b90941c21e0a8c3a);
$parcel$export(module.exports, "REMOVE_VERSION_FROM_PROJECT", () => $3ed37431e2697918$export$30c6ea30d9ec4bc);
$parcel$export(module.exports, "SET_DEFAULT_PROJECT", () => $3ed37431e2697918$export$f0f2b3316de0f660);
$parcel$export(module.exports, "reset", () => $3ed37431e2697918$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $3ed37431e2697918$export$e16d8520af44a096);
$parcel$export(module.exports, "addVersionInProject", () => $3ed37431e2697918$export$197e16f09b72093e);
$parcel$export(module.exports, "removeVersionFromProject", () => $3ed37431e2697918$export$50ab934eee6c251);
$parcel$export(module.exports, "setDefaultProject", () => $3ed37431e2697918$export$5fb893a5ca0ba0fa);
const $3ed37431e2697918$export$4a991c87e640ef77 = 'state.domain.projects.RESET';
const $3ed37431e2697918$export$bb6389024b71c2ae = 'state.domain.projects.ADD';
const $3ed37431e2697918$export$b90941c21e0a8c3a = 'state.domain.projects.ADD_VERSION_IN_PROJECT';
const $3ed37431e2697918$export$30c6ea30d9ec4bc = 'state.domain.projects.REMOVE_VERSION_FROM_PROJECT';
const $3ed37431e2697918$export$f0f2b3316de0f660 = 'state.domain.projects.SET_DEFAULT_PROJECT';
const $3ed37431e2697918$export$aad8462122ac592b = (payload)=>({
        type: $3ed37431e2697918$export$4a991c87e640ef77,
        payload: payload
    });
const $3ed37431e2697918$export$e16d8520af44a096 = (payload)=>({
        type: $3ed37431e2697918$export$bb6389024b71c2ae,
        payload: payload
    });
const $3ed37431e2697918$export$197e16f09b72093e = (payload)=>({
        type: $3ed37431e2697918$export$b90941c21e0a8c3a,
        payload: payload
    });
const $3ed37431e2697918$export$50ab934eee6c251 = (payload)=>({
        type: $3ed37431e2697918$export$30c6ea30d9ec4bc,
        payload: payload
    });
const $3ed37431e2697918$export$5fb893a5ca0ba0fa = (payload)=>({
        type: $3ed37431e2697918$export$f0f2b3316de0f660,
        payload: payload
    });

});

parcelRegister("cYoMq", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $7354a05dabbfbfec$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $7354a05dabbfbfec$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $7354a05dabbfbfec$export$29d55e1f664a246b);
$parcel$export(module.exports, "reset", () => $7354a05dabbfbfec$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $7354a05dabbfbfec$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $7354a05dabbfbfec$export$cd7f480d6b8286c3);
const $7354a05dabbfbfec$export$4a991c87e640ef77 = 'state.domain.removed-versions.RESET';
const $7354a05dabbfbfec$export$bb6389024b71c2ae = 'state.domain.removed-versions.ADD';
const $7354a05dabbfbfec$export$29d55e1f664a246b = 'state.domain.removed-versions.REMOVE';
const $7354a05dabbfbfec$export$aad8462122ac592b = (payload)=>({
        type: $7354a05dabbfbfec$export$4a991c87e640ef77,
        payload: payload
    });
const $7354a05dabbfbfec$export$e16d8520af44a096 = (payload)=>({
        type: $7354a05dabbfbfec$export$bb6389024b71c2ae,
        payload: payload
    });
const $7354a05dabbfbfec$export$cd7f480d6b8286c3 = (versionId)=>({
        type: $7354a05dabbfbfec$export$29d55e1f664a246b,
        versionId: versionId
    });

});

parcelRegister("9ZuLc", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $a29c3f8b27992280$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $a29c3f8b27992280$export$bb6389024b71c2ae);
$parcel$export(module.exports, "BULK_ADD", () => $a29c3f8b27992280$export$6295ee0df406f89c);
$parcel$export(module.exports, "REMOVE", () => $a29c3f8b27992280$export$29d55e1f664a246b);
$parcel$export(module.exports, "BULK_REMOVE", () => $a29c3f8b27992280$export$2b953021360583c3);
$parcel$export(module.exports, "reset", () => $a29c3f8b27992280$export$aad8462122ac592b);
$parcel$export(module.exports, "bulkAdd", () => $a29c3f8b27992280$export$95c4934f4651c863);
$parcel$export(module.exports, "bulkRemove", () => $a29c3f8b27992280$export$18acb55cd937cabd);
const $a29c3f8b27992280$export$4a991c87e640ef77 = 'state.domain.scenario-removed-issues.RESET';
const $a29c3f8b27992280$export$bb6389024b71c2ae = 'state.domain.scenario-removed-issues.ADD';
const $a29c3f8b27992280$export$6295ee0df406f89c = 'state.domain.scenario-removed-issues.BULK_ADD';
const $a29c3f8b27992280$export$29d55e1f664a246b = 'state.domain.scenario-removed-issues.REMOVE';
const $a29c3f8b27992280$export$2b953021360583c3 = 'state.domain.scenario-removed-issues.BULK_REMOVE';
const $a29c3f8b27992280$export$aad8462122ac592b = (payload)=>({
        type: $a29c3f8b27992280$export$4a991c87e640ef77,
        payload: payload
    });
const $a29c3f8b27992280$export$e16d8520af44a096 = (payload)=>({
        type: $a29c3f8b27992280$export$bb6389024b71c2ae,
        payload: payload
    });
const $a29c3f8b27992280$export$95c4934f4651c863 = (payload)=>({
        type: $a29c3f8b27992280$export$6295ee0df406f89c,
        payload: payload
    });
const $a29c3f8b27992280$export$cd7f480d6b8286c3 = (payload)=>({
        type: $a29c3f8b27992280$export$29d55e1f664a246b,
        payload: payload
    });
const $a29c3f8b27992280$export$18acb55cd937cabd = (payload)=>({
        type: $a29c3f8b27992280$export$2b953021360583c3,
        payload: payload
    });

});

parcelRegister("xlOmi", function(module, exports) {

$parcel$export(module.exports, "INCREMENT", () => $392c10f5e7f66f45$export$5ef1d926c74c32f2);
$parcel$export(module.exports, "RESET", () => $392c10f5e7f66f45$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $392c10f5e7f66f45$export$e271b26eefe41db8);
$parcel$export(module.exports, "increment", () => $392c10f5e7f66f45$export$a2647aa13413c947);
$parcel$export(module.exports, "reset", () => $392c10f5e7f66f45$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $392c10f5e7f66f45$export$722fbec263ad908a);
const $392c10f5e7f66f45$export$5ef1d926c74c32f2 = 'state.domain.sequence.INCREMENT';
const $392c10f5e7f66f45$export$4a991c87e640ef77 = 'state.domain.sequence.RESET';
const $392c10f5e7f66f45$export$e271b26eefe41db8 = 'state.domain.sequence.UPDATE';
const $392c10f5e7f66f45$export$a2647aa13413c947 = (payload)=>({
        type: $392c10f5e7f66f45$export$5ef1d926c74c32f2,
        payload: payload
    });
const $392c10f5e7f66f45$export$aad8462122ac592b = (payload)=>({
        type: $392c10f5e7f66f45$export$4a991c87e640ef77,
        payload: payload
    });
const $392c10f5e7f66f45$export$722fbec263ad908a = (payload)=>({
        type: $392c10f5e7f66f45$export$e271b26eefe41db8,
        payload: payload
    });

});

parcelRegister("eBGH3", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $c0d9d64c3f5547b3$export$bb6389024b71c2ae);
$parcel$export(module.exports, "add", () => $c0d9d64c3f5547b3$export$e16d8520af44a096);
const $c0d9d64c3f5547b3$export$bb6389024b71c2ae = 'state.domain.update-jira.warnings.ADD';
const $c0d9d64c3f5547b3$export$e16d8520af44a096 = (payload)=>({
        type: $c0d9d64c3f5547b3$export$bb6389024b71c2ae,
        payload: payload
    });

});

parcelRegister("12x9g", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $33e1fa5fcdc14b44$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $33e1fa5fcdc14b44$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $33e1fa5fcdc14b44$export$29d55e1f664a246b);
$parcel$export(module.exports, "RANK", () => $33e1fa5fcdc14b44$export$c3d7e0f1e63de60e);
$parcel$export(module.exports, "BULK_UPDATE", () => $33e1fa5fcdc14b44$export$193f41a37c2df875);
$parcel$export(module.exports, "UPDATE_REFERENCES", () => $33e1fa5fcdc14b44$export$a6376ffb02379d2a);
$parcel$export(module.exports, "reset", () => $33e1fa5fcdc14b44$export$aad8462122ac592b);
$parcel$export(module.exports, "rank", () => $33e1fa5fcdc14b44$export$fbc8bcd33b574fbc);
$parcel$export(module.exports, "add", () => $33e1fa5fcdc14b44$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $33e1fa5fcdc14b44$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "bulkUpdate", () => $33e1fa5fcdc14b44$export$fc4d5d648b7f7ca2);
$parcel$export(module.exports, "updateReferences", () => $33e1fa5fcdc14b44$export$387fc7d982d5d3ef);
const $33e1fa5fcdc14b44$export$4a991c87e640ef77 = 'state.domain.versions.RESET';
const $33e1fa5fcdc14b44$export$bb6389024b71c2ae = 'state.domain.versions.ADD';
const $33e1fa5fcdc14b44$export$29d55e1f664a246b = 'state.domain.versions.REMOVE';
const $33e1fa5fcdc14b44$export$c3d7e0f1e63de60e = 'state.domain.versions.RANK';
const $33e1fa5fcdc14b44$export$193f41a37c2df875 = 'state.domain.versions.BULK_UPDATE';
const $33e1fa5fcdc14b44$export$a6376ffb02379d2a = 'state.domain.versions.UPDATE_REFERENCES';
const $33e1fa5fcdc14b44$export$aad8462122ac592b = (payload)=>({
        type: $33e1fa5fcdc14b44$export$4a991c87e640ef77,
        payload: payload
    });
const $33e1fa5fcdc14b44$export$fbc8bcd33b574fbc = (payload)=>({
        type: $33e1fa5fcdc14b44$export$c3d7e0f1e63de60e,
        payload: payload
    });
const $33e1fa5fcdc14b44$export$e16d8520af44a096 = (payload)=>({
        type: $33e1fa5fcdc14b44$export$bb6389024b71c2ae,
        payload: payload
    });
const $33e1fa5fcdc14b44$export$cd7f480d6b8286c3 = (payload)=>({
        type: $33e1fa5fcdc14b44$export$29d55e1f664a246b,
        payload: payload
    });
const $33e1fa5fcdc14b44$export$fc4d5d648b7f7ca2 = (payload)=>({
        type: $33e1fa5fcdc14b44$export$193f41a37c2df875,
        payload: payload
    });
const $33e1fa5fcdc14b44$export$387fc7d982d5d3ef = (payload)=>({
        type: $33e1fa5fcdc14b44$export$a6376ffb02379d2a,
        payload: payload
    });

});

parcelRegister("9aQvf", function(module, exports) {

$parcel$export(module.exports, "OPEN_DIALOG", () => $1646cc7aea93c79b$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $1646cc7aea93c79b$export$194b247a9d6170da);
$parcel$export(module.exports, "openDialog", () => $1646cc7aea93c79b$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $1646cc7aea93c79b$export$34bf1befb2fab61a);
const $1646cc7aea93c79b$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.add-to-cpr-dialog.OPEN_DIALOG';
const $1646cc7aea93c79b$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.add-to-cpr-dialog.CLOSE_DIALOG';
const $1646cc7aea93c79b$export$45f11db5513b93db = (versionId)=>({
        type: $1646cc7aea93c79b$export$fb283a8049ce78e7,
        versionId: versionId
    });
const $1646cc7aea93c79b$export$34bf1befb2fab61a = ()=>({
        type: $1646cc7aea93c79b$export$194b247a9d6170da
    });

});

parcelRegister("8NHMp", function(module, exports) {

$parcel$export(module.exports, "SET_MODE", () => $cb32bed31b011179$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "OPEN_DIALOG", () => $cb32bed31b011179$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $cb32bed31b011179$export$194b247a9d6170da);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $cb32bed31b011179$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $cb32bed31b011179$export$31889003e5372a7f);
$parcel$export(module.exports, "setMode", () => $cb32bed31b011179$export$d4f039427a1beff1);
$parcel$export(module.exports, "openDialog", () => $cb32bed31b011179$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $cb32bed31b011179$export$34bf1befb2fab61a);
$parcel$export(module.exports, "initiateRequest", () => $cb32bed31b011179$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $cb32bed31b011179$export$b38f09eddeeb56fb);
const $cb32bed31b011179$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.SET_MODE';
const $cb32bed31b011179$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.OPEN_DIALOG';
const $cb32bed31b011179$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.CLOSE_DIALOG';
const $cb32bed31b011179$export$4580e708995fb75f = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.INITIATE_REQUEST';
const $cb32bed31b011179$export$31889003e5372a7f = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.RESET_REQUEST';
const $cb32bed31b011179$export$d4f039427a1beff1 = (payload)=>({
        type: $cb32bed31b011179$export$27a86d4a6fd7f204,
        payload: payload
    });
const $cb32bed31b011179$export$45f11db5513b93db = (versionId)=>({
        type: $cb32bed31b011179$export$fb283a8049ce78e7,
        versionId: versionId
    });
const $cb32bed31b011179$export$34bf1befb2fab61a = ()=>({
        type: $cb32bed31b011179$export$194b247a9d6170da
    });
const $cb32bed31b011179$export$82f68a404cfea29 = ()=>({
        type: $cb32bed31b011179$export$4580e708995fb75f
    });
const $cb32bed31b011179$export$b38f09eddeeb56fb = ()=>({
        type: $cb32bed31b011179$export$31889003e5372a7f
    });

});

parcelRegister("boi4O", function(module, exports) {

$parcel$export(module.exports, "SET_MODE", () => $3f9cfcea262df158$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "OPEN_DIALOG", () => $3f9cfcea262df158$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $3f9cfcea262df158$export$194b247a9d6170da);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $3f9cfcea262df158$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $3f9cfcea262df158$export$31889003e5372a7f);
$parcel$export(module.exports, "setMode", () => $3f9cfcea262df158$export$d4f039427a1beff1);
$parcel$export(module.exports, "openDialog", () => $3f9cfcea262df158$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $3f9cfcea262df158$export$34bf1befb2fab61a);
$parcel$export(module.exports, "initiateRequest", () => $3f9cfcea262df158$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $3f9cfcea262df158$export$b38f09eddeeb56fb);
const $3f9cfcea262df158$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.project-releases.release-dialog.SET_MODE';
const $3f9cfcea262df158$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.project-releases.release-dialog.OPEN_DIALOG';
const $3f9cfcea262df158$export$194b247a9d6170da = 'state.ui.main.tabs.releases.project-releases.release-dialog.CLOSE_DIALOG';
const $3f9cfcea262df158$export$4580e708995fb75f = 'state.ui.main.tabs.releases.project-releases.release-dialog.INITIATE_REQUEST';
const $3f9cfcea262df158$export$31889003e5372a7f = 'state.ui.main.tabs.releases.project-releases.release-dialog.RESET_REQUEST';
const $3f9cfcea262df158$export$d4f039427a1beff1 = (payload)=>({
        type: $3f9cfcea262df158$export$27a86d4a6fd7f204,
        payload: payload
    });
const $3f9cfcea262df158$export$45f11db5513b93db = (projectId, versionId)=>({
        type: $3f9cfcea262df158$export$fb283a8049ce78e7,
        payload: {
            projectId: projectId,
            versionId: versionId
        }
    });
const $3f9cfcea262df158$export$34bf1befb2fab61a = ()=>({
        type: $3f9cfcea262df158$export$194b247a9d6170da
    });
const $3f9cfcea262df158$export$82f68a404cfea29 = ()=>({
        type: $3f9cfcea262df158$export$4580e708995fb75f
    });
const $3f9cfcea262df158$export$b38f09eddeeb56fb = ()=>({
        type: $3f9cfcea262df158$export$31889003e5372a7f
    });

});

parcelRegister("MrW4M", function(module, exports) {

$parcel$export(module.exports, "SET_RANKING_STATE", () => $fd4e988600b6214c$export$1850e3f5cf6a5e30);
$parcel$export(module.exports, "isReleasesRanking", () => $fd4e988600b6214c$export$45321decb2561e51);
const $fd4e988600b6214c$export$1850e3f5cf6a5e30 = 'state.ui.main.tabs.releases.project-releases.releases-table.SET_RANKING_STATE';
const $fd4e988600b6214c$export$45321decb2561e51 = (payload)=>({
        type: $fd4e988600b6214c$export$1850e3f5cf6a5e30,
        payload: payload
    });

});

parcelRegister("hFSyR", function(module, exports) {

$parcel$export(module.exports, "urls", () => $7b9a0313be00c56e$export$bcae9ba627f604b6);
$parcel$export(module.exports, "addVersionBody", () => $7b9a0313be00c56e$export$a19bf42e0b3d7082);
$parcel$export(module.exports, "updateVersionBody", () => $7b9a0313be00c56e$export$80a1d0573753ab10);
$parcel$export(module.exports, "rankVersionBody", () => $7b9a0313be00c56e$export$b303dc519d35242f);
$parcel$export(module.exports, "deleteVersionBody", () => $7b9a0313be00c56e$export$4c6bb7db8f86d168);

var $cQGVO = parcelRequire("cQGVO");
var $ldYmX = parcelRequire("ldYmX");

var $7CnHa = parcelRequire("7CnHa");
const $7b9a0313be00c56e$export$bcae9ba627f604b6 = {
    add: '/rest/jpo/1.0/versions/add',
    get: '/rest/jpo/1.0/versions/get',
    update: '/rest/jpo/1.0/versions/update',
    rank: '/rest/jpo/1.0/versions/rank',
    delete: '/rest/jpo/1.0/versions/delete',
    revertChanges: '/rest/jpo/1.0/versions/revert'
};
const $7b9a0313be00c56e$export$a19bf42e0b3d7082 = (plan, { projectId: projectId, version: version })=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    const versionAttributes = [
        'name',
        'description',
        'start',
        'delta',
        'end'
    ];
    const versionValues = $ldYmX.default((acc, attr)=>{
        acc[attr] = (0, $7CnHa.isDefined)(version[attr]) ? {
            value: version[attr]
        } : {};
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {}, versionAttributes);
    return {
        planId: planId,
        scenarioId: scenarioId,
        projectId: projectId,
        description: {
            ...versionValues,
            crossProjectVersion: {}
        }
    };
};
const $7b9a0313be00c56e$var$asObject = (value)=>(0, $7CnHa.isDefined)(value) ? {
        value: value
    } : {};
const $7b9a0313be00c56e$export$80a1d0573753ab10 = (plan, { versionId: versionId, patch: patch })=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    const copyOfPatch = {
        ...patch
    };
    const versionValues = $cQGVO.default($7b9a0313be00c56e$var$asObject, copyOfPatch);
    return {
        planId: planId,
        scenarioId: scenarioId,
        itemKeys: [
            versionId
        ],
        description: {
            ...versionValues
        }
    };
};
const $7b9a0313be00c56e$export$b303dc519d35242f = (plan, payload)=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    const { id: id, anchor: anchor, relation: relation } = payload;
    return {
        operations: [
            {
                anchor: anchor,
                itemKeys: [
                    id
                ],
                operationType: relation
            }
        ],
        planId: planId,
        scenarioId: scenarioId
    };
};
const $7b9a0313be00c56e$export$4c6bb7db8f86d168 = ({ id: planId, currentScenarioId: scenarioId }, versionId)=>({
        itemKeys: [
            versionId
        ],
        planId: planId,
        scenarioId: scenarioId
    });

});

parcelRegister("U7xww", function(module, exports) {

$parcel$export(module.exports, "inspectForCommitWarnings", () => $433049d725d81fa2$export$1eed481c758d15b7);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $2Ruxt = parcelRequire("2Ruxt");

var $wcCGG = parcelRequire("wcCGG");

var $cN1Lq = parcelRequire("cN1Lq");
const $433049d725d81fa2$export$deb6050352aafd0b = {
    header: (0, $cN1Lq.default).defaultWarningHeader,
    message: (0, $cN1Lq.default).defaultWarningContent,
    messageValues: {}
};
function $433049d725d81fa2$export$bb28f4058acfe78c({ error: error, errorMessages: errorMessages }, crossProjectVersionTitle, versionTitle) {
    switch(error){
        case 'ENVIRONMENT_ENTITY_NOT_FOUND':
            return {
                header: (0, $cN1Lq.default).releaseNotFoundHeader,
                message: (0, $cN1Lq.default).releaseNotFoundContent,
                messageValues: {
                    versionTitle: versionTitle
                }
            };
        case 'ENVIRONMENT_RELATED_ENTITY_NOT_FOUND':
            return {
                header: (0, $cN1Lq.default).projectNotFoundHeader,
                message: (0, $cN1Lq.default).projectNotFoundContent,
                messageValues: {}
            };
        case 'UNCOMMITTED_FOREIGN_KEY':
            return {
                header: (0, $cN1Lq.default).crossProjectReleaseNotCommittedHeader,
                message: (0, $cN1Lq.default).crossProjectReleaseNotCommittedContent,
                messageValues: {
                    crossProjectVersionTitle: crossProjectVersionTitle
                }
            };
        case 'VERSION_API_EXCEPTION':
            if (errorMessages.length > 0) return {
                header: (0, $cN1Lq.default).apiExceptionHeader,
                message: (0, $cN1Lq.default).apiExceptionContent,
                messageValues: {
                    messages: errorMessages.join(' ')
                }
            };
            return {
                header: (0, $cN1Lq.default).defaultWarningHeader,
                message: (0, $cN1Lq.default).defaultWarningContent,
                messageValues: {}
            };
        default:
            return $433049d725d81fa2$export$deb6050352aafd0b;
    }
}
function* $433049d725d81fa2$export$1eed481c758d15b7(error, versionId) {
    if (error) {
        const versions = yield (0, $9e8i2.select)((0, $wcCGG.getVersions));
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const version = versions.find((version)=>version.id === versionId);
        let crossProjectVersionTitle;
        let versionTitle;
        if (version) {
            versionTitle = version.name;
            const crossProjectVersionId = version.crossProjectVersion;
            const crossProjectVersions = yield (0, $9e8i2.select)((0, $2Ruxt.getCrossProjectVersions));
            const crossProjectVersion = crossProjectVersions.find(// eslint-disable-next-line @typescript-eslint/no-shadow
            (crossProjectVersion)=>crossProjectVersion.id === crossProjectVersionId);
            if (crossProjectVersion) crossProjectVersionTitle = crossProjectVersion.name;
        }
        return [
            $433049d725d81fa2$export$bb28f4058acfe78c(error, crossProjectVersionTitle, versionTitle)
        ];
    }
    return [];
}

});
parcelRegister("cN1Lq", function(module, exports) {

$parcel$export(module.exports, "default", () => $230a6b43f37b7717$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $230a6b43f37b7717$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releaseNotFoundHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.release-not-found-header",
        "defaultMessage": "Release {versionTitle} no longer exists in this plan"
    },
    releaseNotFoundContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.release-not-found-content",
        "defaultMessage": "Refresh your plan to reflect this change"
    },
    projectNotFoundHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.project-not-found-header",
        "defaultMessage": "Project no longer exists in this plan"
    },
    projectNotFoundContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.project-not-found-content",
        "defaultMessage": "Refresh to update your plan"
    },
    crossProjectReleaseNotCommittedHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.cross-project-release-not-committed-header",
        "defaultMessage": "Changes not saved"
    },
    crossProjectReleaseNotCommittedContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.cross-project-release-not-committed-content",
        "defaultMessage": "This release is linked to {crossProjectVersionTitle}, which is a cross-project release. You need to save {crossProjectVersionTitle} in Jira first, then save this release."
    },
    defaultWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.default-warning-header",
        "defaultMessage": "Version could not be committed for unknown reasons."
    },
    defaultWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.default-warning-content",
        "defaultMessage": "Please contact your administrator."
    },
    apiExceptionContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.api-exception-content",
        "defaultMessage": "{messages}"
    },
    apiExceptionHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.versions.api-exception-header",
        "defaultMessage": "Version could not be committed"
    }
});

});


const $2ca1157acc350995$export$afecb711a599950a = 'state.ui.main.tabs.releases.project-releases.release-dialog.CREATE_RELEASE';
const $2ca1157acc350995$export$b9385259cf8397cd = 'state.ui.main.tabs.releases.project-releases.release-dialog.EDIT_RELEASE';

parcelRegister("ivdvr", function(module, exports) {

$parcel$export(module.exports, "DELETE_RELEASE", () => $74dc8bedca88f2f1$export$440c54a43c85f449);
$parcel$export(module.exports, "DELETE_DIALOG_ACTIONS", () => $74dc8bedca88f2f1$export$1ec19a32727d8911);
const $74dc8bedca88f2f1$export$440c54a43c85f449 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.DELETE_RELEASE';
const $74dc8bedca88f2f1$export$653071db1143c98 = 'state.ui.main.tabs.releases.project-releases.delete-release-dialog.REMOVE_RELEASE';
const $74dc8bedca88f2f1$export$1ec19a32727d8911 = {
    DELETE_RELEASE: $74dc8bedca88f2f1$export$440c54a43c85f449,
    REMOVE_RELEASE: $74dc8bedca88f2f1$export$653071db1143c98
};

});


parcelRegister("dC8ep", function(module, exports) {

$parcel$export(module.exports, "calculateWarnings", () => $ec38e7fc627c302e$export$3bec30015a8c58aa);
$parcel$export(module.exports, "misconfiguredChildrenWarning", () => $ec38e7fc627c302e$export$4c7b48c5d99eb207);
$parcel$export(module.exports, "default", () => $ec38e7fc627c302e$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $cbq3D = parcelRequire("cbq3D");

var $akhOi = parcelRequire("akhOi");

var $kKj1m = parcelRequire("kKj1m");

var $kFf60 = parcelRequire("kFf60");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $kCccV = parcelRequire("kCccV");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $YHQpz = parcelRequire("YHQpz");

var $gNoQI = parcelRequire("gNoQI");

var $k94CF = parcelRequire("k94CF");

var $e0l3L = parcelRequire("e0l3L");

var $9RBvc = parcelRequire("9RBvc");

var $bmXiI = parcelRequire("bmXiI");

var $lOjjB = parcelRequire("lOjjB");

var $hFkwG = parcelRequire("hFkwG");

var $ltE2N = parcelRequire("ltE2N");
const $ec38e7fc627c302e$var$CALCULATE_WARNINGS = 'command.warnings.CALCULATE_WARNINGS';
const $ec38e7fc627c302e$export$3bec30015a8c58aa = ()=>({
        type: $ec38e7fc627c302e$var$CALCULATE_WARNINGS
    });
const $ec38e7fc627c302e$export$4c7b48c5d99eb207 = ()=>({
        type: (0, $lOjjB.MISCONFIGURED_CHILDREN),
        header: (0, $ltE2N.headerMessages).misconfiguredChildren,
        message: (0, $ltE2N.bodyMessages).misconfiguredChildren,
        messageValues: {}
    });
function* $ec38e7fc627c302e$export$4447429ff9b7cd07() {
    const isSolutionValid = yield (0, $9e8i2.select)((0, $kCccV.getIsSolutionValid));
    const mode = yield (0, $9e8i2.select)((0, $akhOi.getMode));
    const issues = yield (0, $9e8i2.select)((0, $cwP4d.getIssues));
    const projects = yield (0, $9e8i2.select)((0, $ehEr2.getProjects));
    const sprints = yield (0, $9e8i2.select)((0, $c1XMU.getSprints));
    const issueStatuses = yield (0, $9e8i2.select)((0, $kFf60.getIssueStatuses));
    const customFields = yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields));
    const sprintsWithFutureDates = yield (0, $9e8i2.select)((0, $c1XMU.getSprintsWithFutureDates));
    const plan = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const disabledWarnings = yield (0, $9e8i2.select)((0, $YHQpz.getDisabledWarnings));
    const teamsById = yield (0, $9e8i2.select)((0, $MQRDu.getAllTeamsById));
    try {
        const warnings = yield (0, $9e8i2.call)((0, $hFkwG.calculateAllWarnings), {
            isSolutionValid: isSolutionValid,
            mode: mode,
            issues: issues,
            projects: projects,
            sprints: sprints,
            issueStatuses: issueStatuses,
            customFields: customFields,
            sprintsWithFutureDates: sprintsWithFutureDates,
            plan: plan,
            disabledWarnings: disabledWarnings,
            teamsById: teamsById
        });
        yield (0, $9e8i2.put)((0, $bmXiI.setWarnings)(warnings));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $ec38e7fc627c302e$export$f48673270179dc3a() {
    yield (0, $bG7pV.takeLatest)([
        $ec38e7fc627c302e$var$CALCULATE_WARNINGS,
        (0, $gNoQI.SET_MODE),
        (0, $gNoQI.SET_MODE),
        (0, $k94CF.SET_VALIDITY),
        (0, $e0l3L.SET_SHOW_ROLLED_UP_DATE),
        (0, $9RBvc.TOGGLE_WARNING_TYPE)
    ], $ec38e7fc627c302e$export$4447429ff9b7cd07);
}
function* $ec38e7fc627c302e$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($ec38e7fc627c302e$export$f48673270179dc3a);
}

});
parcelRegister("gNoQI", function(module, exports) {

$parcel$export(module.exports, "SET_MODE", () => $59b8dbad46da4737$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "SET_ANALYTICS_EVENT", () => $59b8dbad46da4737$export$2499970725b3d311);
$parcel$export(module.exports, "REPORT_INITIAL_LOAD_ANALYTICS", () => $59b8dbad46da4737$export$ec1035696f159a68);
$parcel$export(module.exports, "SET_IS_EXPORT_PREVIEW", () => $59b8dbad46da4737$export$bee450b8c5830be2);
$parcel$export(module.exports, "SET_BROWSER_HISTORY", () => $59b8dbad46da4737$export$1d7cc3d04182cd55);
$parcel$export(module.exports, "setMode", () => $59b8dbad46da4737$export$d4f039427a1beff1);
$parcel$export(module.exports, "setAnalyticsEvent", () => $59b8dbad46da4737$export$e09b03f3b8c97b73);
$parcel$export(module.exports, "setIsExportPreview", () => $59b8dbad46da4737$export$313833c4b42ad868);
$parcel$export(module.exports, "setBrowserHistory", () => $59b8dbad46da4737$export$ed028cee82239b37);
const $59b8dbad46da4737$export$27a86d4a6fd7f204 = 'state.domain.app.SET_MODE';
const $59b8dbad46da4737$export$2499970725b3d311 = 'state.domain.app.SET_ANALYTICS_EVENT';
const $59b8dbad46da4737$export$ec1035696f159a68 = 'state.domain.app.REPORT_INITIAL_LOAD_ANALYTICS';
const $59b8dbad46da4737$export$bee450b8c5830be2 = 'state.domain.app.SET_IS_EXPORT_PREVIEW';
const $59b8dbad46da4737$export$1d7cc3d04182cd55 = 'state.domain.app.SET_BROWSER_HISTORY';
const $59b8dbad46da4737$export$d4f039427a1beff1 = (payload)=>({
        type: $59b8dbad46da4737$export$27a86d4a6fd7f204,
        payload: payload
    });
const $59b8dbad46da4737$export$e09b03f3b8c97b73 = (payload)=>({
        type: $59b8dbad46da4737$export$2499970725b3d311,
        payload: payload
    });
const $59b8dbad46da4737$export$6a8af29705a96449 = ()=>({
        type: $59b8dbad46da4737$export$ec1035696f159a68
    });
const $59b8dbad46da4737$export$313833c4b42ad868 = (payload)=>({
        type: $59b8dbad46da4737$export$bee450b8c5830be2,
        payload: payload
    });
const $59b8dbad46da4737$export$ed028cee82239b37 = (payload)=>({
        type: $59b8dbad46da4737$export$1d7cc3d04182cd55,
        payload: payload
    });

});

parcelRegister("k94CF", function(module, exports) {

$parcel$export(module.exports, "SET_LATEST", () => $e935397599e5b095$export$e102ab8a610053c9);
$parcel$export(module.exports, "SET_VALIDITY", () => $e935397599e5b095$export$6e6a82795d265bb3);
$parcel$export(module.exports, "RESET", () => $e935397599e5b095$export$4a991c87e640ef77);
$parcel$export(module.exports, "SET_PROGRESS", () => $e935397599e5b095$export$b1d6de4448cfb1e3);
$parcel$export(module.exports, "setLatest", () => $e935397599e5b095$export$94f0dfbac15ff20c);
$parcel$export(module.exports, "setValidity", () => $e935397599e5b095$export$aa2e5f48fa69b31d);
$parcel$export(module.exports, "reset", () => $e935397599e5b095$export$aad8462122ac592b);
$parcel$export(module.exports, "setProgress", () => $e935397599e5b095$export$e352b740a6841494);
const $e935397599e5b095$export$e102ab8a610053c9 = 'state.domain.solution.SET_LATEST';
const $e935397599e5b095$export$6e6a82795d265bb3 = 'state.domain.solution.SET_VALIDITY';
const $e935397599e5b095$export$4a991c87e640ef77 = 'state.domain.solution.RESET';
const $e935397599e5b095$export$b1d6de4448cfb1e3 = 'state.domain.solution.SET_PROGRESS';
const $e935397599e5b095$export$94f0dfbac15ff20c = (payload)=>({
        type: $e935397599e5b095$export$e102ab8a610053c9,
        payload: payload
    });
const $e935397599e5b095$export$aa2e5f48fa69b31d = (payload)=>({
        type: $e935397599e5b095$export$6e6a82795d265bb3,
        payload: payload
    });
const $e935397599e5b095$export$aad8462122ac592b = (payload)=>({
        type: $e935397599e5b095$export$4a991c87e640ef77,
        payload: payload
    });
const $e935397599e5b095$export$e352b740a6841494 = (payload)=>({
        type: $e935397599e5b095$export$b1d6de4448cfb1e3,
        payload: payload
    });

});

parcelRegister("e0l3L", function(module, exports) {

$parcel$export(module.exports, "SET_SHOW_ROLLED_UP_DATE", () => $88830f850ee87fd7$export$9f7a30c1cb755660);
$parcel$export(module.exports, "SET_SHOW_ROLLED_UP_OTHERS", () => $88830f850ee87fd7$export$948b90af2ac6573c);
$parcel$export(module.exports, "setShowRolledUpDates", () => $88830f850ee87fd7$export$df5b4cee0c3ae1b6);
$parcel$export(module.exports, "setShowRolledUpOthers", () => $88830f850ee87fd7$export$41d403e9b16845fe);
const $88830f850ee87fd7$export$9f7a30c1cb755660 = 'state.domain.view-settings.rollup-settings.SET_SHOW_ROLLED_UP_DATE';
const $88830f850ee87fd7$export$948b90af2ac6573c = 'state.domain.view-settings.rollup-settings.SET_SHOW_ROLLED_UP_OTHERS';
const $88830f850ee87fd7$export$df5b4cee0c3ae1b6 = (payload)=>({
        type: $88830f850ee87fd7$export$9f7a30c1cb755660,
        payload: payload
    });
const $88830f850ee87fd7$export$41d403e9b16845fe = (payload)=>({
        type: $88830f850ee87fd7$export$948b90af2ac6573c,
        payload: payload
    });

});

parcelRegister("9RBvc", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_SHOW_WARNING", () => $e1dfff94c1bab56d$export$d4ff2af774aef1c0);
$parcel$export(module.exports, "RESET_SHOW_WARNING", () => $e1dfff94c1bab56d$export$f8a9c3527c1ac902);
$parcel$export(module.exports, "TOGGLE_WARNING_TYPE", () => $e1dfff94c1bab56d$export$9907ee878c9466c3);
$parcel$export(module.exports, "RESET_ENABLED_WARNING_TYPE", () => $e1dfff94c1bab56d$export$a82954c4e1a6aa6);
$parcel$export(module.exports, "toggleShowWarning", () => $e1dfff94c1bab56d$export$7c9e001e736a253d);
$parcel$export(module.exports, "toggleWarningByType", () => $e1dfff94c1bab56d$export$1712432632037ce1);
$parcel$export(module.exports, "resetEnabledWarningType", () => $e1dfff94c1bab56d$export$940207be1e4e61ac);
const $e1dfff94c1bab56d$export$d4ff2af774aef1c0 = 'state.domain.view-settings.warning-settings.TOGGLE_SHOW_WARNING';
const $e1dfff94c1bab56d$export$f8a9c3527c1ac902 = 'state.domain.view-settings.warning-settings.RESET_SHOW_WARNING';
const $e1dfff94c1bab56d$export$9907ee878c9466c3 = 'state.domain.view-settings.warning-settings.TOGGLE_WARNING_TYPE';
const $e1dfff94c1bab56d$export$a82954c4e1a6aa6 = 'state.domain.view-settings.warning-settings.RESET_ENABLED_WARNING_TYPE';
const $e1dfff94c1bab56d$export$7c9e001e736a253d = ()=>({
        type: $e1dfff94c1bab56d$export$d4ff2af774aef1c0
    });
const $e1dfff94c1bab56d$export$5403b06d3931daf7 = (payload)=>({
        type: $e1dfff94c1bab56d$export$f8a9c3527c1ac902,
        payload: payload
    });
const $e1dfff94c1bab56d$export$1712432632037ce1 = (payload)=>({
        type: $e1dfff94c1bab56d$export$9907ee878c9466c3,
        payload: payload
    });
const $e1dfff94c1bab56d$export$940207be1e4e61ac = (payload)=>({
        type: $e1dfff94c1bab56d$export$a82954c4e1a6aa6,
        payload: payload
    });

});

parcelRegister("bmXiI", function(module, exports) {

$parcel$export(module.exports, "SET_WARNINGS", () => $400c2edf13b3dbff$export$8078dd99bef6fdf);
$parcel$export(module.exports, "setWarnings", () => $400c2edf13b3dbff$export$eb05c66a610b38c0);
const $400c2edf13b3dbff$export$8078dd99bef6fdf = 'state.domain.warnings.SET_WARNINGS';
const $400c2edf13b3dbff$export$eb05c66a610b38c0 = (payload)=>({
        type: $400c2edf13b3dbff$export$8078dd99bef6fdf,
        payload: payload
    });

});

parcelRegister("lOjjB", function(module, exports) {

$parcel$export(module.exports, "MISCONFIGURED_CHILDREN", () => $f1cc080f10ff47d2$export$54fe5a9205a0315e);
$parcel$export(module.exports, "ENDS_AFTER_PARENT", () => $f1cc080f10ff47d2$export$4336de3d90bb2c49);
$parcel$export(module.exports, "STARTS_BEFORE_PARENT", () => $f1cc080f10ff47d2$export$d4a7eb40b2206472);
$parcel$export(module.exports, "TARGET_DATE_BEYOND_DUE_DATE", () => $f1cc080f10ff47d2$export$c65dfcaa2eb60c77);
$parcel$export(module.exports, "NOT_CLOSED_BEYOND_TARGET_END_DATE", () => $f1cc080f10ff47d2$export$ee50b99467509c89);
$parcel$export(module.exports, "IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE", () => $f1cc080f10ff47d2$export$3b60c958072be00d);
$parcel$export(module.exports, "TARGET_DATES_ARE_OUTSIDE_OF_SPRINT", () => $f1cc080f10ff47d2$export$9969a2bca1107f62);
$parcel$export(module.exports, "ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT", () => $f1cc080f10ff47d2$export$5418cafbad534a1d);
$parcel$export(module.exports, "UNKNOWN", () => $f1cc080f10ff47d2$export$78244dbb77cfa6b6);
$parcel$export(module.exports, "NOT_FULLY_SCHEDULED", () => $f1cc080f10ff47d2$export$180c8c4e5ca7fc64);
$parcel$export(module.exports, "HORIZON_REACHED", () => $f1cc080f10ff47d2$export$506c0966b2777a1b);
$parcel$export(module.exports, "RELEASE_CONFLICT", () => $f1cc080f10ff47d2$export$baece8055553e2d7);
$parcel$export(module.exports, "ASSIGNEE_IGNORED", () => $f1cc080f10ff47d2$export$eed6c64af2fd3b6c);
$parcel$export(module.exports, "EXTERNAL_TEAM", () => $f1cc080f10ff47d2$export$4b43e7fa9e1cb022);
$parcel$export(module.exports, "SUBTASK_VIOLATION", () => $f1cc080f10ff47d2$export$c895d8cb2e188887);
$parcel$export(module.exports, "SUBTASK_ASSIGNMENT_VIOLATION", () => $f1cc080f10ff47d2$export$d29de877c56fd5f3);
$parcel$export(module.exports, "SPRINT_EXCEEDED", () => $f1cc080f10ff47d2$export$82276ba4a3d599be);
$parcel$export(module.exports, "INVALID_SPRINT", () => $f1cc080f10ff47d2$export$2903a36058b72b4b);
$parcel$export(module.exports, "RELEASE_SHIFTED", () => $f1cc080f10ff47d2$export$88cbcab8a50f4112);
$parcel$export(module.exports, "EARLIEST_START_IGNORED", () => $f1cc080f10ff47d2$export$6d3cb9de6cef8b94);
$parcel$export(module.exports, "OVERBOOKED", () => $f1cc080f10ff47d2$export$e92bcd88cf28a567);
$parcel$export(module.exports, "AVAILABILITY_VIOLATION", () => $f1cc080f10ff47d2$export$fdd4c22a8207c89b);
$parcel$export(module.exports, "VIOLATION_IN_DEPENDENCY", () => $f1cc080f10ff47d2$export$bbb5754bfb57083e);
$parcel$export(module.exports, "RESOURCE_LIMIT_VIOLATION", () => $f1cc080f10ff47d2$export$8116f921873c497f);
$parcel$export(module.exports, "DEPENDENCIES_IGNORED_SPRINT", () => $f1cc080f10ff47d2$export$eca19cdcca121312);
$parcel$export(module.exports, "DEPENDENCIES_IGNORED_RELEASE", () => $f1cc080f10ff47d2$export$9cadba489b70f1e1);
$parcel$export(module.exports, "CYCLIC_DEPENDENCY", () => $f1cc080f10ff47d2$export$4c94664807496c52);
$parcel$export(module.exports, "SUBTASK_CYCLIC_DEPENDENCY_IGNORED", () => $f1cc080f10ff47d2$export$dba3e57b5804782c);
$parcel$export(module.exports, "SUBTASK_NO_SKILLED_RESOURCE", () => $f1cc080f10ff47d2$export$7373594db109755f);
$parcel$export(module.exports, "MISSING_SKILLS", () => $f1cc080f10ff47d2$export$4e4875e1b4f24a3c);
$parcel$export(module.exports, "TOO_SMALL_ESTIMATES", () => $f1cc080f10ff47d2$export$fee6d7a90f3c128d);
$parcel$export(module.exports, "COMPLETED_PARENT", () => $f1cc080f10ff47d2$export$220707e5274a4e55);
$parcel$export(module.exports, "CALCULATION_COMPLEXITY", () => $f1cc080f10ff47d2$export$a47259b29ac2584a);
$parcel$export(module.exports, "WARNING_TYPE_NUMBER_MAP", () => $f1cc080f10ff47d2$export$6e3885125caa57e8);
$parcel$export(module.exports, "WARNING_CENTER_AVAILABLE_TYPES", () => $f1cc080f10ff47d2$export$6a7c7b701dd98e87);
const $f1cc080f10ff47d2$export$54fe5a9205a0315e = 'state.warnings.MISCONFIGURED_CHILDREN';
const $f1cc080f10ff47d2$export$4336de3d90bb2c49 = 'state.warnings.ENDS_AFTER_PARENT';
const $f1cc080f10ff47d2$export$d4a7eb40b2206472 = 'state.warnings.STARTS_BEFORE_PARENT';
const $f1cc080f10ff47d2$export$dfdca0491979cec5 = 'state.warnings.IGNORES_DEPENDENCY';
const $f1cc080f10ff47d2$export$fe60411ab692631e = 'state.warnings.DEPENDENCIES_SHARE_SPRINT';
const $f1cc080f10ff47d2$export$c65dfcaa2eb60c77 = 'state.warnings.TARGET_DATE_BEYOND_DUE_DATE';
const $f1cc080f10ff47d2$export$ee50b99467509c89 = 'state.warnings.NOT_CLOSED_BEYOND_TARGET_END_DATE';
const $f1cc080f10ff47d2$export$3b60c958072be00d = 'state.warnings.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE';
const $f1cc080f10ff47d2$export$9969a2bca1107f62 = 'state.warnings.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT';
const $f1cc080f10ff47d2$export$5418cafbad534a1d = 'state.warnings.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT';
const $f1cc080f10ff47d2$export$78244dbb77cfa6b6 = 'state.warnings.UNKNOWN';
const $f1cc080f10ff47d2$export$180c8c4e5ca7fc64 = 'state.warnings.NOT_FULLY_SCHEDULED';
const $f1cc080f10ff47d2$export$506c0966b2777a1b = 'state.warnings.HORIZON_REACHED';
const $f1cc080f10ff47d2$export$baece8055553e2d7 = 'state.warnings.RELEASE_CONFLICT';
const $f1cc080f10ff47d2$export$eed6c64af2fd3b6c = 'state.warnings.ASSIGNEE_IGNORED';
const $f1cc080f10ff47d2$export$4b43e7fa9e1cb022 = 'state.warnings.EXTERNAL_TEAM';
const $f1cc080f10ff47d2$export$c895d8cb2e188887 = 'state.warnings.SUBTASK_VIOLATION';
const $f1cc080f10ff47d2$export$d29de877c56fd5f3 = 'state.warnings.SUBTASK_ASSIGNMENT_VIOLATION';
const $f1cc080f10ff47d2$export$82276ba4a3d599be = 'state.warnings.SPRINT_EXCEEDED';
const $f1cc080f10ff47d2$export$2903a36058b72b4b = 'state.warnings.INVALID_SPRINT';
const $f1cc080f10ff47d2$export$88cbcab8a50f4112 = 'state.warnings.RELEASE_SHIFTED';
const $f1cc080f10ff47d2$export$6d3cb9de6cef8b94 = 'state.warnings.EARLIEST_START_IGNORED';
const $f1cc080f10ff47d2$export$e92bcd88cf28a567 = 'state.warnings.OVERBOOKED';
const $f1cc080f10ff47d2$export$fdd4c22a8207c89b = 'state.warnings.AVAILABILITY_VIOLATION';
const $f1cc080f10ff47d2$export$bbb5754bfb57083e = 'state.warnings.VIOLATION_IN_DEPENDENCY';
const $f1cc080f10ff47d2$export$8116f921873c497f = 'state.warnings.RESOURCE_LIMIT_VIOLATION';
const $f1cc080f10ff47d2$export$eca19cdcca121312 = 'state.warnings.DEPENDENCIES_IGNORED_SPRINT';
const $f1cc080f10ff47d2$export$9cadba489b70f1e1 = 'state.warnings.DEPENDENCIES_IGNORED_RELEASE';
const $f1cc080f10ff47d2$export$4c94664807496c52 = 'state.warnings.CYCLIC_DEPENDENCY';
const $f1cc080f10ff47d2$export$dba3e57b5804782c = 'state.warnings.SUBTASK_CYCLIC_DEPENDENCY_IGNORED';
const $f1cc080f10ff47d2$export$7373594db109755f = 'state.warnings.SUBTASK_NO_SKILLED_RESOURCE';
const $f1cc080f10ff47d2$export$4e4875e1b4f24a3c = 'state.warnings.MISSING_SKILLS';
const $f1cc080f10ff47d2$export$fee6d7a90f3c128d = 'state.warnings.TOO_SMALL_ESTIMATES';
const $f1cc080f10ff47d2$export$220707e5274a4e55 = 'state.warnings.COMPLETED_PARENT';
const $f1cc080f10ff47d2$export$a47259b29ac2584a = 'state.warnings.CALCULATION_COMPLEXITY';
const $f1cc080f10ff47d2$export$6e3885125caa57e8 = {
    [$f1cc080f10ff47d2$export$c65dfcaa2eb60c77]: 1,
    [$f1cc080f10ff47d2$export$9969a2bca1107f62]: 2,
    [$f1cc080f10ff47d2$export$ee50b99467509c89]: 3,
    [$f1cc080f10ff47d2$export$4336de3d90bb2c49]: 5,
    [$f1cc080f10ff47d2$export$d4a7eb40b2206472]: 6,
    [$f1cc080f10ff47d2$export$5418cafbad534a1d]: 7
};
const $f1cc080f10ff47d2$export$6a7c7b701dd98e87 = [
    $f1cc080f10ff47d2$export$54fe5a9205a0315e,
    $f1cc080f10ff47d2$export$4336de3d90bb2c49,
    $f1cc080f10ff47d2$export$d4a7eb40b2206472,
    $f1cc080f10ff47d2$export$dfdca0491979cec5,
    $f1cc080f10ff47d2$export$fe60411ab692631e,
    $f1cc080f10ff47d2$export$c65dfcaa2eb60c77,
    $f1cc080f10ff47d2$export$ee50b99467509c89,
    $f1cc080f10ff47d2$export$3b60c958072be00d,
    $f1cc080f10ff47d2$export$9969a2bca1107f62,
    $f1cc080f10ff47d2$export$5418cafbad534a1d
];

});

parcelRegister("hFkwG", function(module, exports) {

$parcel$export(module.exports, "WarningTypesOld", () => $40a36e4c30022deb$export$6468cc0fd40b679);
$parcel$export(module.exports, "WarningTypes", () => $40a36e4c30022deb$export$b3c1ed7ac13a6caf);
$parcel$export(module.exports, "WarningTypeIds", () => $40a36e4c30022deb$export$3d3e5150e65ef8c9);
$parcel$export(module.exports, "calculateAllWarnings", () => $40a36e4c30022deb$export$75bc8fa5816784a7);

var $fpul1 = parcelRequire("fpul1");
var $erwaN = parcelRequire("erwaN");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $eCpJ2 = parcelRequire("eCpJ2");

var $bKxX9 = parcelRequire("bKxX9");

var $17L5s = parcelRequire("17L5s");
parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");

var $853IT = parcelRequire("853IT");

parcelRequire("6OvfP");
var $eOsHk = parcelRequire("eOsHk");

var $lOjjB = parcelRequire("lOjjB");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ltE2N = parcelRequire("ltE2N");
const $40a36e4c30022deb$export$6468cc0fd40b679 = {
    [(0, $lOjjB.TARGET_DATE_BEYOND_DUE_DATE)]: {
        header: (0, $ltE2N.headerMessages).dateBeyondDueDate,
        description: (0, $ltE2N.detailedSummaryMessages).targetDateBeyondDueDate
    },
    [(0, $lOjjB.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT)]: {
        header: (0, $ltE2N.headerMessages).dateOutsideOfSprint,
        description: (0, $ltE2N.detailedSummaryMessages).targetDateOutsideOfSprint
    },
    [(0, $lOjjB.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE)]: {
        header: (0, $ltE2N.headerMessages).notClosedBeyondInferredTargetEndDate,
        description: (0, $ltE2N.detailedSummaryMessages).inProgressBeyondInferredTargetEndDate
    },
    [(0, $lOjjB.NOT_CLOSED_BEYOND_TARGET_END_DATE)]: {
        header: (0, $ltE2N.headerMessages).notClosedBeyondEndDate,
        description: (0, $ltE2N.detailedSummaryMessages).notClosedBeyondTargetEndDate
    },
    [(0, $lOjjB.ENDS_AFTER_PARENT)]: {
        header: (0, $ltE2N.headerMessages).endsAfterParent,
        description: (0, $ltE2N.detailedSummaryMessages).endsAfterParent
    },
    [(0, $lOjjB.STARTS_BEFORE_PARENT)]: {
        header: (0, $ltE2N.headerMessages).startsBeforeParent,
        description: (0, $ltE2N.detailedSummaryMessages).startsBeforeParent
    },
    [(0, $lOjjB.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT)]: {
        header: (0, $ltE2N.headerMessages).issueAssignedKanbanTeamAndSprint,
        description: (0, $ltE2N.detailedSummaryMessages).issueAssignedKanbanTeamAndSprint
    }
};
const $40a36e4c30022deb$export$b3c1ed7ac13a6caf = {
    [(0, $lOjjB.TARGET_DATE_BEYOND_DUE_DATE)]: {
        header: (0, $ltE2N.headerMessages).dateAfterDueDate,
        description: (0, $ltE2N.detailedSummaryMessages).targetDateBeyondDueDate
    },
    [(0, $lOjjB.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT)]: {
        header: (0, $ltE2N.headerMessages).issueScheduledOutsideOfSprint,
        description: (0, $ltE2N.detailedSummaryMessages).targetDateOutsideOfSprint
    },
    [(0, $lOjjB.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE)]: {
        header: (0, $ltE2N.headerMessages).openIssuePastInferredEndDate,
        description: (0, $ltE2N.detailedSummaryMessages).inProgressBeyondInferredTargetEndDate
    },
    [(0, $lOjjB.NOT_CLOSED_BEYOND_TARGET_END_DATE)]: {
        header: (0, $ltE2N.headerMessages).openIssuePastAssignedEndDate,
        description: (0, $ltE2N.detailedSummaryMessages).notClosedBeyondTargetEndDate
    },
    [(0, $lOjjB.ENDS_AFTER_PARENT)]: {
        header: (0, $ltE2N.headerMessages).childIssueEndsAfterParent,
        description: (0, $ltE2N.detailedSummaryMessages).endsAfterParent
    },
    [(0, $lOjjB.STARTS_BEFORE_PARENT)]: {
        header: (0, $ltE2N.headerMessages).childIssueStartsBeforeParent,
        description: (0, $ltE2N.detailedSummaryMessages).startsBeforeParent
    },
    [(0, $lOjjB.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT)]: {
        header: (0, $ltE2N.headerMessages).kanbanIssueAssignedToSprint,
        description: (0, $ltE2N.detailedSummaryMessages).issueAssignedKanbanTeamAndSprint
    }
};
const $40a36e4c30022deb$export$3d3e5150e65ef8c9 = Object.keys($40a36e4c30022deb$export$b3c1ed7ac13a6caf);
// TODO(JPOS-1940/tim) change to AtlasKit-provided heuristics before switching live.
// Or factor with distanceInWordsToNow from @atlassian/jira-portfolio-3-common?
const $40a36e4c30022deb$var$periodBetween = (a, b)=>{
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    const millis = hi - lo;
    const days = Math.ceil(millis / (0, $17L5s.ONE_DAY));
    if (days < 7) return {
        key: (0, $ltE2N.shortDateMessages).days,
        days: days
    };
    const weeks = Math.floor(days / 7);
    if (weeks < 4) return {
        key: (0, $ltE2N.shortDateMessages).weeks,
        weeks: weeks
    };
    const months = Math.ceil(days / 365 * 12);
    if (months < 12) return {
        key: (0, $ltE2N.shortDateMessages).months,
        months: months
    };
    const years = Math.ceil(months / 12);
    return {
        key: (0, $ltE2N.shortDateMessages).years,
        years: years
    };
};
const $40a36e4c30022deb$export$3162886456acb148 = (issuesById, warningsByIssue)=>{
    // Add parent warnings closure so that warnings are surfaced on otherwise correct collapsed parents
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transitiveIssueIds = {};
    for (const [issueId, existingWarnings] of $eCpJ2.default(warningsByIssue))if (existingWarnings && existingWarnings.length !== 0) {
        const issue = issuesById[issueId];
        const parent = issue && issue.parent && issuesById[issue.parent];
        if (parent) transitiveIssueIds[parent.id] = true;
    }
    // Roll up for parents of parents of warned issues.
    for (const id of $erwaN.default(transitiveIssueIds)){
        let issue = issuesById[id];
        while(issue){
            transitiveIssueIds[issue.id] = true;
            issue = issuesById[issue.parent || ''];
        }
    }
    // Don't include transitive ids if they have their own warnings.
    for (const id of $erwaN.default(transitiveIssueIds)){
        const warnings = warningsByIssue[id];
        if (warnings && warnings.length !== 0) delete transitiveIssueIds[id];
    }
    return $erwaN.default(transitiveIssueIds);
};
const $40a36e4c30022deb$var$processWarnings = (issuesById, warningsByIssue, allWarningsByIssue)=>({
        byIssue: warningsByIssue,
        transitiveIssueIds: $40a36e4c30022deb$export$3162886456acb148(issuesById, warningsByIssue),
        allWarningsByIssue: allWarningsByIssue
    });
// cleanup with plans-warning-filter-rework_7pi1k
const $40a36e4c30022deb$var$processWarningsOld = (issuesById, warningsByIssue)=>({
        byIssue: warningsByIssue,
        transitiveIssueIds: $40a36e4c30022deb$export$3162886456acb148(issuesById, warningsByIssue)
    });
const $40a36e4c30022deb$var$staticWarning = (type, header, message)=>({
        type: type,
        header: header,
        message: message,
        messageValues: {}
    });
const $40a36e4c30022deb$var$STATIC_SCHEDULE_WARNINGS = {
    'not-fully-scheduled': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.NOT_FULLY_SCHEDULED), (0, $ltE2N.headerMessages).notFullyScheduled, (0, $ltE2N.bodyMessages).notFullyScheduled),
    'horizon-reached': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.HORIZON_REACHED), (0, $ltE2N.headerMessages).horizonReached, (0, $ltE2N.bodyMessages).horizonReached),
    'release-shifted': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.RELEASE_SHIFTED), (0, $ltE2N.headerMessages).releaseShifted, (0, $ltE2N.bodyMessages).releaseShifted),
    'release-conflict': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.RELEASE_CONFLICT), (0, $ltE2N.headerMessages).releaseConflict, (0, $ltE2N.bodyMessages).releaseConflict),
    'assignee-ignored': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.ASSIGNEE_IGNORED), (0, $ltE2N.headerMessages).assigneeIgnored, (0, $ltE2N.bodyMessages).assigneeIgnored),
    'external-team': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.EXTERNAL_TEAM), (0, $ltE2N.headerMessages).externalTeam, (0, $ltE2N.bodyMessages).externalTeam),
    'subtask-violation': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.SUBTASK_VIOLATION), (0, $ltE2N.headerMessages).subtaskViolation, (0, $ltE2N.bodyMessages).subtaskViolation),
    'subtask-assignment-violation': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.SUBTASK_ASSIGNMENT_VIOLATION), (0, $ltE2N.headerMessages).subtaskAssignmentViolation, (0, $ltE2N.bodyMessages).subtaskAssignmentViolation),
    'sprint-exceeded': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.SPRINT_EXCEEDED), (0, $ltE2N.headerMessages).sprintExceeded, (0, $ltE2N.bodyMessages).sprintExceeded),
    'invalid-sprint': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.INVALID_SPRINT), (0, $ltE2N.headerMessages).invalidSprint, (0, $ltE2N.bodyMessages).invalidSprint),
    'earliest-start-ignored': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.EARLIEST_START_IGNORED), (0, $ltE2N.headerMessages).earliestStartIgnored, (0, $ltE2N.bodyMessages).earliestStartIgnored),
    overbooked: $40a36e4c30022deb$var$staticWarning((0, $lOjjB.OVERBOOKED), (0, $ltE2N.headerMessages).overbooked, (0, $ltE2N.bodyMessages).overbooked),
    'availability-violation': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.AVAILABILITY_VIOLATION), (0, $ltE2N.headerMessages).availabilityViolation, (0, $ltE2N.bodyMessages).availabilityViolation),
    'violation-in-dependency': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.VIOLATION_IN_DEPENDENCY), (0, $ltE2N.headerMessages).violationInDependency, (0, $ltE2N.bodyMessages).violationInDependency),
    'resource-limit-violation': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.RESOURCE_LIMIT_VIOLATION), (0, $ltE2N.headerMessages).resourceLimitViolation, (0, $ltE2N.bodyMessages).resourceLimitViolation),
    'dependencies-ignored-sprint': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.DEPENDENCIES_IGNORED_SPRINT), (0, $ltE2N.headerMessages).dependenciesIgnoredSprint, (0, $ltE2N.bodyMessages).dependenciesIgnoredSprint),
    'dependencies-ignored-release': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.DEPENDENCIES_IGNORED_RELEASE), (0, $ltE2N.headerMessages).dependenciesIgnoredRelease, (0, $ltE2N.bodyMessages).dependenciesIgnoredRelease),
    'cyclic-dependency': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.CYCLIC_DEPENDENCY), (0, $ltE2N.headerMessages).cyclicDependency, (0, $ltE2N.bodyMessages).cyclicDependency),
    'subtask-cyclic-dependency-ignored': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.SUBTASK_CYCLIC_DEPENDENCY_IGNORED), (0, $ltE2N.headerMessages).subtaskCyclicDependencyIgnored, (0, $ltE2N.bodyMessages).subtaskCyclicDependencyIgnored),
    'subtask-no-skilled-resource': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.SUBTASK_NO_SKILLED_RESOURCE), (0, $ltE2N.headerMessages).subtaskNoSkilledResource, (0, $ltE2N.bodyMessages).subtaskNoSkilledResource),
    'missing-skills': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.MISSING_SKILLS), (0, $ltE2N.headerMessages).missingSkills, (0, $ltE2N.bodyMessages).missingSkills),
    'too-small-estimates': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.TOO_SMALL_ESTIMATES), (0, $ltE2N.headerMessages).tooSmallEstimates, (0, $ltE2N.bodyMessages).tooSmallEstimates),
    'completed-parent': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.COMPLETED_PARENT), (0, $ltE2N.headerMessages).completedParent, (0, $ltE2N.bodyMessages).completedParent),
    'calculation-complexity': $40a36e4c30022deb$var$staticWarning((0, $lOjjB.CALCULATION_COMPLEXITY), (0, $ltE2N.headerMessages).calculationComplexity, (0, $ltE2N.bodyMessages).calculationComplexity)
};
const $40a36e4c30022deb$var$mapAnnotationToWarning = ({ type: type })=>{
    const warning = $40a36e4c30022deb$var$STATIC_SCHEDULE_WARNINGS[type];
    if (warning) return warning;
    return {
        type: (0, $lOjjB.UNKNOWN),
        header: (0, $ltE2N.headerMessages).unknown,
        message: (0, $ltE2N.bodyMessages).unknown,
        messageValues: {}
    };
};
const $40a36e4c30022deb$var$extractSchedulerWarnings = (warningsByIssue, allWarningsByIssue, issues)=>{
    for (const { id: id, annotations: annotations } of issues){
        if (annotations && annotations.length) for (const annotation of annotations || []){
            const warning = $40a36e4c30022deb$var$mapAnnotationToWarning(annotation);
            $40a36e4c30022deb$var$addWarningToHash(warningsByIssue, id, warning);
            $40a36e4c30022deb$var$addWarningToHash(allWarningsByIssue, id, warning);
        }
    }
};
const $40a36e4c30022deb$var$extractSchedulerWarningsOld = (warningsByIssue, issues)=>{
    for (const { id: id, annotations: annotations } of issues)if (annotations && annotations.length) {
        if (!warningsByIssue[id]) {
            const mutableReference = warningsByIssue; // Boo, lint!
            mutableReference[id] = [];
        }
        for (const annotation of annotations || [])warningsByIssue[id].push($40a36e4c30022deb$var$mapAnnotationToWarning(annotation));
    }
};
const $40a36e4c30022deb$var$addWarningToHash = (warningIssueHash, issueId, warning)=>{
    if (!warningIssueHash[issueId]) // eslint-disable-next-line no-param-reassign
    warningIssueHash[issueId] = [];
    warningIssueHash[issueId].push(warning);
};
const $40a36e4c30022deb$export$75bc8fa5816784a7 = (args)=>(0, $bKxX9.ff)('plans-warning-filter-rework_7pi1k') ? $40a36e4c30022deb$export$3f60265b9381f0e(args) : $40a36e4c30022deb$export$e0a2539a25aa2f10(args);
const $40a36e4c30022deb$export$3f60265b9381f0e = ({ isSolutionValid: isSolutionValid, mode: mode, issues: issues, projects: projects, sprints: sprints, issueStatuses: issueStatuses, sprintsWithFutureDates: sprintsWithFutureDates, plan: plan, disabledWarnings: disabledWarnings, teamsById: teamsById })=>{
    const warningsByIssue = {};
    const allWarningsByIssue = {};
    const idProp = $f7Op5.default('id');
    const projectsById = (0, $7CnHa.indexBy)(idProp, projects);
    const sprintsById = (0, $7CnHa.indexBy)(idProp, sprints);
    const issueStatusesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueStatuses);
    const isCompletedIssueStatuses = $fpul1.default((status)=>status.categoryId === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE, issueStatusesById);
    const isNotDone = (issue)=>!isCompletedIssueStatuses[issue.status || ''];
    const addWarning = (issueId, type, header, message, messageValues, autoResolvePayload)=>{
        const warning = {
            type: type,
            header: header,
            message: message,
            messageValues: messageValues,
            autoResolvePayload: autoResolvePayload
        };
        $40a36e4c30022deb$var$addWarningToHash(allWarningsByIssue, issueId, warning);
        if (!disabledWarnings.includes(type)) $40a36e4c30022deb$var$addWarningToHash(warningsByIssue, issueId, warning);
    };
    const now = Date.now();
    const undone = $fpul1.default(isNotDone, issues);
    const issuesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), undone);
    if (mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) {
        if (isSolutionValid) $40a36e4c30022deb$var$extractSchedulerWarnings(warningsByIssue, allWarningsByIssue, issues);
        return $40a36e4c30022deb$var$processWarnings(issuesById, warningsByIssue, allWarningsByIssue);
    }
    const key = (issue)=>{
        const project = projectsById[issue.project];
        const issueKey = issue.issueKey;
        if (project && project.key && issueKey) return `${project.key}-${issueKey}`;
        return issue.summary;
    };
    for (const issue of undone){
        const id = issue.id;
        const parent = issue.parent && issuesById[issue.parent];
        const issueStatusCategory = $kjklK.default([
            issue.status || '',
            'categoryId'
        ], issueStatusesById);
        const sprint = issue.sprint ? sprintsById[issue.sprint] : null;
        if (sprint) // Issue has sprint and is assigned to Kanban team
        {
            if (issue.team && teamsById[issue.team]) {
                const team = teamsById[issue.team];
                if (team.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban) addWarning(id, (0, $lOjjB.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).kanbanIssueAssignedToSprint : (0, $ltE2N.headerMessages).issueAssignedKanbanTeamAndSprint, (0, $ltE2N.bodyMessages).issueAssignedKanbanTeamAndSprint, {});
            }
        }
        if ((0, $7CnHa.isDefined)(issue.dueDate)) {
            const endOfDayDueDate = (0, $17L5s.endOfUtcDay)(issue.dueDate);
            const isConfiguredAsDueDate = [
                plan.baselineStartField,
                plan.baselineEndField
            ].some((field)=>field.key === 'dueDate' && field.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN);
            // when built in dueDate is used as either start or end plan date, this check makes no sense and can be skipped
            if (!isConfiguredAsDueDate) {
                if ((0, $7CnHa.isDefined)(issue.baselineEnd) && issue.baselineEnd > endOfDayDueDate || (0, $7CnHa.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayDueDate) addWarning(id, (0, $lOjjB.TARGET_DATE_BEYOND_DUE_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).dateAfterDueDate : (0, $ltE2N.headerMessages).dateBeyondDueDate, (0, $ltE2N.bodyMessages).dateBeyondDueDate, {});
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const sprints = (0, $853IT.getFutureSprintsForIssue)(issue, sprintsWithFutureDates);
        if (issue.sprint && sprints.length > 0 && ((0, $7CnHa.isDefined)(issue.baselineStart) || (0, $7CnHa.isDefined)(issue.baselineEnd))) {
            const sprintDates = (0, $a4NMN.getTargetDatesFromSprints)(issue, sprints);
            if ((0, $7CnHa.isDefined)(issue.baselineStart) && sprintDates.rawEndDate && issue.baselineStart > sprintDates.rawEndDate || (0, $7CnHa.isDefined)(issue.baselineEnd) && sprintDates.rawStartDate && issue.baselineEnd < sprintDates.rawStartDate) addWarning(id, (0, $lOjjB.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).issueScheduledOutsideOfSprint : (0, $ltE2N.headerMessages).dateOutsideOfSprint, (0, $ltE2N.bodyMessages).dateOutsideOfSprint, {});
        }
        const end = issue.baselineEnd;
        if ((0, $7CnHa.isDefined)(end)) {
            const isInferred = issue.inferred && issue.inferred.baselineEnd;
            if (isInferred && now > end && issueStatusCategory === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS) addWarning(id, (0, $lOjjB.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).openIssuePastInferredEndDate : (0, $ltE2N.headerMessages).notClosedBeyondInferredTargetEndDate, (0, $ltE2N.bodyMessages).inProgressBeyondInferredEndDate, {
                issue: key(issue)
            });
            if (!isInferred && now > end && (!issue.status || isNotDone(issue))) addWarning(id, (0, $lOjjB.NOT_CLOSED_BEYOND_TARGET_END_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).openIssuePastAssignedEndDate : (0, $ltE2N.headerMessages).notClosedBeyondEndDate, (0, $ltE2N.bodyMessages).notClosedBeyondEndDate, {});
        }
        if (parent) {
            const parentStart = parent.baselineStart;
            const parentEnd = parent.baselineEnd;
            const issueStart = issue.baselineStart;
            const issueEnd = issue.baselineEnd;
            // PA.end < A.end
            if ((0, $7CnHa.isDefined)(parentEnd) && (0, $7CnHa.isDefined)(issueEnd) && parentEnd < issueEnd) addWarning(id, (0, $lOjjB.ENDS_AFTER_PARENT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).endsAfterParent : (0, $ltE2N.headerMessages).childIssueEndsAfterParent, (0, $ltE2N.bodyMessages).endsAfterParent, {
                issue: key(issue),
                parent: key(parent),
                amount: $40a36e4c30022deb$var$periodBetween(parentEnd, issueEnd)
            }, {
                issueId: parent.id,
                end: issueEnd
            });
            // PA.start > A.start
            if (parentStart && issueStart && parentStart > issueStart) addWarning(id, (0, $lOjjB.STARTS_BEFORE_PARENT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).childIssueStartsBeforeParent : (0, $ltE2N.headerMessages).startsBeforeParent, (0, $ltE2N.bodyMessages).startsBeforeParent, {
                issue: key(issue),
                parent: key(parent),
                amount: $40a36e4c30022deb$var$periodBetween(issueStart, parentStart)
            }, {
                issueId: parent.id,
                start: issueStart
            });
        }
    }
    return $40a36e4c30022deb$var$processWarnings(issuesById, warningsByIssue, allWarningsByIssue);
};
const $40a36e4c30022deb$export$e0a2539a25aa2f10 = ({ isSolutionValid: isSolutionValid, mode: mode, issues: issues, projects: projects, sprints: sprints, issueStatuses: issueStatuses, sprintsWithFutureDates: sprintsWithFutureDates, plan: plan, disabledWarnings: disabledWarnings, teamsById: teamsById })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const warningsByIssue = {};
    const idProp = $f7Op5.default('id');
    const projectsById = (0, $7CnHa.indexBy)(idProp, projects);
    const sprintsById = (0, $7CnHa.indexBy)(idProp, sprints);
    const issueStatusesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueStatuses);
    const isCompletedIssueStatuses = $fpul1.default((status)=>status.categoryId === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE, issueStatusesById);
    const isNotDone = (issue)=>!isCompletedIssueStatuses[issue.status || ''];
    const addWarning = (issueId, type, header, message, messageValues, autoResolvePayload)=>{
        if (disabledWarnings.includes(type)) return;
        if (!warningsByIssue[issueId]) warningsByIssue[issueId] = [];
        warningsByIssue[issueId].push({
            type: type,
            header: header,
            message: message,
            messageValues: messageValues,
            autoResolvePayload: autoResolvePayload
        });
    };
    const now = Date.now();
    const undone = $fpul1.default(isNotDone, issues);
    const issuesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), undone);
    if (mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) {
        if (isSolutionValid) $40a36e4c30022deb$var$extractSchedulerWarningsOld(warningsByIssue, issues);
        return $40a36e4c30022deb$var$processWarningsOld(issuesById, warningsByIssue);
    }
    const key = (issue)=>{
        const project = projectsById[issue.project];
        const issueKey = issue.issueKey;
        if (project && project.key && issueKey) return `${project.key}-${issueKey}`;
        return issue.summary;
    };
    for (const issue of undone){
        const id = issue.id;
        const parent = issue.parent && issuesById[issue.parent];
        const issueStatusCategory = $kjklK.default([
            issue.status || '',
            'categoryId'
        ], issueStatusesById);
        const sprint = issue.sprint ? sprintsById[issue.sprint] : null;
        if (sprint) // Issue has sprint and is assigned to Kanban team
        {
            if (issue.team && teamsById[issue.team]) {
                const team = teamsById[issue.team];
                if (team.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban) addWarning(id, (0, $lOjjB.ISSUE_ASSIGNED_KANBAN_TEAM_AND_SPRINT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).kanbanIssueAssignedToSprint : (0, $ltE2N.headerMessages).issueAssignedKanbanTeamAndSprint, (0, $ltE2N.bodyMessages).issueAssignedKanbanTeamAndSprint, {});
            }
        }
        if ((0, $7CnHa.isDefined)(issue.dueDate)) {
            const endOfDayDueDate = (0, $17L5s.endOfUtcDay)(issue.dueDate);
            const isConfiguredAsDueDate = [
                plan.baselineStartField,
                plan.baselineEndField
            ].some((field)=>field.key === 'dueDate' && field.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN);
            // when built in dueDate is used as either start or end plan date, this check makes no sense and can be skipped
            if (!isConfiguredAsDueDate) {
                if ((0, $7CnHa.isDefined)(issue.baselineEnd) && issue.baselineEnd > endOfDayDueDate || (0, $7CnHa.isDefined)(issue.baselineStart) && issue.baselineStart > endOfDayDueDate) addWarning(id, (0, $lOjjB.TARGET_DATE_BEYOND_DUE_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).dateAfterDueDate : (0, $ltE2N.headerMessages).dateBeyondDueDate, (0, $ltE2N.bodyMessages).dateBeyondDueDate, {});
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const sprints = (0, $853IT.getFutureSprintsForIssue)(issue, sprintsWithFutureDates);
        if (issue.sprint && sprints.length > 0 && ((0, $7CnHa.isDefined)(issue.baselineStart) || (0, $7CnHa.isDefined)(issue.baselineEnd))) {
            const sprintDates = (0, $a4NMN.getTargetDatesFromSprints)(issue, sprints);
            if ((0, $7CnHa.isDefined)(issue.baselineStart) && sprintDates.rawEndDate && issue.baselineStart > sprintDates.rawEndDate || (0, $7CnHa.isDefined)(issue.baselineEnd) && sprintDates.rawStartDate && issue.baselineEnd < sprintDates.rawStartDate) addWarning(id, (0, $lOjjB.TARGET_DATES_ARE_OUTSIDE_OF_SPRINT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).issueScheduledOutsideOfSprint : (0, $ltE2N.headerMessages).dateOutsideOfSprint, (0, $ltE2N.bodyMessages).dateOutsideOfSprint, {});
        }
        const end = issue.baselineEnd;
        if ((0, $7CnHa.isDefined)(end)) {
            const isInferred = issue.inferred && issue.inferred.baselineEnd;
            if (isInferred && now > end && issueStatusCategory === (0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS) addWarning(id, (0, $lOjjB.IN_PROGRESS_BEYOND_INFERRED_TARGET_END_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).openIssuePastInferredEndDate : (0, $ltE2N.headerMessages).notClosedBeyondInferredTargetEndDate, (0, $ltE2N.bodyMessages).inProgressBeyondInferredEndDate, {
                issue: key(issue)
            });
            if (!isInferred && now > end && (!issue.status || isNotDone(issue))) addWarning(id, (0, $lOjjB.NOT_CLOSED_BEYOND_TARGET_END_DATE), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).openIssuePastAssignedEndDate : (0, $ltE2N.headerMessages).notClosedBeyondEndDate, (0, $ltE2N.bodyMessages).notClosedBeyondEndDate, {});
        }
        if (parent) {
            const parentStart = parent.baselineStart;
            const parentEnd = parent.baselineEnd;
            const issueStart = issue.baselineStart;
            const issueEnd = issue.baselineEnd;
            // PA.end < A.end
            if ((0, $7CnHa.isDefined)(parentEnd) && (0, $7CnHa.isDefined)(issueEnd) && parentEnd < issueEnd) addWarning(id, (0, $lOjjB.ENDS_AFTER_PARENT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).endsAfterParent : (0, $ltE2N.headerMessages).childIssueEndsAfterParent, (0, $ltE2N.bodyMessages).endsAfterParent, {
                issue: key(issue),
                parent: key(parent),
                amount: $40a36e4c30022deb$var$periodBetween(parentEnd, issueEnd)
            }, {
                issueId: parent.id,
                end: issueEnd
            });
            // PA.start > A.start
            if (parentStart && issueStart && parentStart > issueStart) addWarning(id, (0, $lOjjB.STARTS_BEFORE_PARENT), (0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? (0, $ltE2N.headerMessages).childIssueStartsBeforeParent : (0, $ltE2N.headerMessages).startsBeforeParent, (0, $ltE2N.bodyMessages).startsBeforeParent, {
                issue: key(issue),
                parent: key(parent),
                amount: $40a36e4c30022deb$var$periodBetween(issueStart, parentStart)
            }, {
                issueId: parent.id,
                start: issueStart
            });
        }
    }
    return $40a36e4c30022deb$var$processWarningsOld(issuesById, warningsByIssue);
};

});
parcelRegister("6OvfP", function(module, exports) {

$parcel$export(module.exports, "toPlanWizardIssueSources", () => $cf7a7bf0bd66b94e$export$d7c054d9b80c30a8);
$parcel$export(module.exports, "DATEFIELD_TYPES", () => (parcelRequire("eOsHk")).DATEFIELD_TYPES);
$parcel$export(module.exports, "DATEFIELD_WARNINGS", () => (parcelRequire("eOsHk")).DATEFIELD_WARNINGS);
$parcel$export(module.exports, "TARGET_START_END_API_MAP", () => (parcelRequire("eOsHk")).TARGET_START_END_API_MAP);

var $eOsHk = parcelRequire("eOsHk");
const $cf7a7bf0bd66b94e$export$e00da033f6a840cd = {
    baselineStartField: (0, $eOsHk.TARGET_START_DATE_FIELD),
    baselineEndField: (0, $eOsHk.TARGET_END_DATE_FIELD)
};
function $cf7a7bf0bd66b94e$export$d7c054d9b80c30a8(issueSources) {
    return issueSources;
}

});

parcelRegister("ltE2N", function(module, exports) {

$parcel$export(module.exports, "shortDateMessages", () => $9c7103dc610e0378$export$22643896e174d0a1);
$parcel$export(module.exports, "headerMessages", () => $9c7103dc610e0378$export$266853a8c4c67815);
$parcel$export(module.exports, "detailedSummaryMessages", () => $9c7103dc610e0378$export$d28e0cd4ecb13f93);
$parcel$export(module.exports, "bodyMessages", () => $9c7103dc610e0378$export$daf59e8556d24858);

var $90IgZ = parcelRequire("90IgZ");
const $9c7103dc610e0378$export$22643896e174d0a1 = (0, $90IgZ.defineMessages)({
    days: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.days",
        "defaultMessage": "{days}d"
    },
    weeks: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.weeks",
        "defaultMessage": "{weeks}w"
    },
    months: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.months",
        "defaultMessage": "{months}m"
    },
    years: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.years",
        "defaultMessage": "{years}y"
    },
    notClosedBeyondTargetEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.not-closed-beyond-target-end-date",
        "defaultMessage": "This issue is still unresolved after the target end date. Check if the status needs updating, or if more time is needed for the issue."
    }
});
const $9c7103dc610e0378$export$266853a8c4c67815 = (0, $90IgZ.defineMessages)({
    // Warning Center warnings
    misconfiguredChildren: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.misconfigured-children",
        "defaultMessage": "Children have warnings"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    endsAfterParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.ends-after-parent",
        "defaultMessage": "Ends after parent"
    },
    childIssueEndsAfterParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.child-issue-ends-after-parent",
        "defaultMessage": "Child issue ends after its parent issue"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    startsBeforeParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.starts-before-parent",
        "defaultMessage": "Starts before parent"
    },
    childIssueStartsBeforeParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.child-issue-starts-before-parent",
        "defaultMessage": "Child issue starts before its parent issue"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    dateBeyondDueDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.date-beyond-due-date",
        "defaultMessage": "Issue start date or end date set beyond the due date"
    },
    dateAfterDueDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.date-after-due-date",
        "defaultMessage": "Issue starts or ends after its due date"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    notClosedBeyondInferredTargetEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.not-closed-beyond-inferred-target-end-date",
        "defaultMessage": "Unresolved issue after inferred end date"
    },
    openIssuePastInferredEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.open-issue-past-inferred-end-date",
        "defaultMessage": "Open issue has passed its inferred end date"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    notClosedBeyondEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.not-closed-beyond-end-date",
        "defaultMessage": "Unresolved issue after end date"
    },
    openIssuePastAssignedEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.open-issue-past-assigned-end-date",
        "defaultMessage": "Open issue has passed its assigned end date"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    dateOutsideOfSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.date-outside-of-sprint",
        "defaultMessage": "Issue dates outside of assigned sprint"
    },
    issueScheduledOutsideOfSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.issue-scheduled-outside-of-sprint",
        "defaultMessage": "Issue scheduled outside of its assigned sprint"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    issueAssignedKanbanTeamAndSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.issue-assigned-kanban-team-and-sprint",
        "defaultMessage": "Issue assigned to a Sprint and a Kanban team"
    },
    kanbanIssueAssignedToSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.kanban-issue-assigned-to-sprint",
        "defaultMessage": "Kanban issue assigned to a sprint"
    },
    // Scheduler warnings
    unknown: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.unknown",
        "defaultMessage": "There was an error during scheduling"
    },
    notFullyScheduled: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.not-fully-scheduled",
        "defaultMessage": "This issue is partially scheduled because the assigned people have limited availability"
    },
    horizonReached: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.horizon-reached",
        "defaultMessage": "Your schedule can't be calculated properly because it exceeds the planning horizon"
    },
    releaseConflict: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.release-conflict",
        "defaultMessage": "This issue can't be scheduled because this issue and its sub-tasks are assigned to different releases"
    },
    assigneeIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.assignee-ignored",
        "defaultMessage": "This issue's assignee is ignored because they aren't part of the plan"
    },
    externalTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.external-team",
        "defaultMessage": "This issue can't be scheduled properly because the assigned team isn't present in your plan"
    },
    subtaskViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-violation",
        "defaultMessage": "Problem in sub-task"
    },
    subtaskAssignmentViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-assignment-violation",
        "defaultMessage": "This issue can't be scheduled because this issue and its sub-tasks are assigned to different teams"
    },
    sprintExceeded: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.sprint-exceeded",
        "defaultMessage": "More than one sprint is needed to finish this issue"
    },
    invalidSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.invalid-sprint",
        "defaultMessage": "Item ignored"
    },
    releaseShifted: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.release-shifted",
        "defaultMessage": "Release start date shifted."
    },
    earliestStartIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.earliest-start-ignored",
        "defaultMessage": "This issue's earliest start date is ignored because of its sprint assignment"
    },
    overbooked: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.overbooked",
        "defaultMessage": "The people working on this issue are overbooked for this sprint"
    },
    availabilityViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.availability-violation",
        "defaultMessage": "This issue can't be scheduled because no one is available"
    },
    resourceLimitViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.resource-limit-violation",
        "defaultMessage": "Resource limit violation"
    },
    violationInDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.violation-in-dependency",
        "defaultMessage": "Violation in dependency."
    },
    dependenciesIgnoredRelease: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.dependencies-ignored-release",
        "defaultMessage": "Dependencies ignored"
    },
    dependenciesIgnoredSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.dependencies-ignored-sprint",
        "defaultMessage": "Dependencies ignored"
    },
    cyclicDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.cyclic-dependency",
        "defaultMessage": "This issue can't be scheduled due to a cyclic dependency"
    },
    subtaskCyclicDependencyIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-cyclic-dependency-ignored",
        "defaultMessage": "We can't process dependencies between sub-tasks within a single issue. Remove these dependencies on this issue and then auto-schedule your plan."
    },
    subtaskNoSkilledResource: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.subtask-no-skilled-resource",
        "defaultMessage": "This sub-task can't be scheduled because no available single team member has the required skill set"
    },
    missingSkills: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.missing-skills",
        "defaultMessage": "This issue can't be scheduled because the available team members don't have the required skill set"
    },
    tooSmallEstimates: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.too-small-estimates",
        "defaultMessage": "This issue can't be scheduled because this issue's estimate is too small"
    },
    completedParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.completed-parent",
        "defaultMessage": "Parent item marked as done"
    },
    calculationComplexity: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.header.calculation-complexity",
        "defaultMessage": "This issue can't be scheduled because the calculation is too complex"
    }
});
const $9c7103dc610e0378$export$d28e0cd4ecb13f93 = (0, $90IgZ.defineMessages)({
    targetDateBeyondDueDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.target-date-beyond-due-date",
        "defaultMessage": "One or both of the target dates for this issue are set after the due date. Either update the due date, or set the target dates to on or before the due date."
    },
    targetDateOutsideOfSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.target-date-outside-of-sprint",
        "defaultMessage": "The target dates of the issue fall outside of the assigned sprint"
    },
    notClosedBeyondTargetEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.not-closed-beyond-target-end-date",
        "defaultMessage": "This issue is still unresolved after the target end date. Check if the status needs updating, or if more time is needed for the issue."
    },
    inProgressBeyondInferredTargetEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.in-progress-beyond-inferred-target-end-date",
        "defaultMessage": "This issue is still unresolved after its end date. Consider moving the status back to To do, or adding the issue to a current or future sprint, or rescheduling the issue to a later end date."
    },
    endsAfterParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.ends-after-parent",
        "defaultMessage": "A child issue ends after its parent issue"
    },
    startsBeforeParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.starts-before-parent",
        "defaultMessage": "A child issue starts before its parent issue"
    },
    issueAssignedKanbanTeamAndSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.issue-assigned-kanban-team-and-sprint",
        "defaultMessage": "Sprints should only be associated with Scrum teams."
    }
});
const $9c7103dc610e0378$export$daf59e8556d24858 = (0, $90IgZ.defineMessages)({
    // Warning Center warnings
    misconfiguredChildren: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.misconfigured-children",
        "defaultMessage": "This issue is OK, but it has children with warnings"
    },
    endsAfterParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.ends-after-parent",
        "defaultMessage": "{issue} ends {amount} after its parent {parent}"
    },
    startsBeforeParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.starts-before-parent",
        "defaultMessage": "{issue} starts {amount} before its parent {parent}"
    },
    dateBeyondDueDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.date-beyond-due-date",
        "defaultMessage": "One or both of the start and end dates for this issue are set after the due date. Either update the due date, or set the dates to on or before the due date."
    },
    notClosedBeyondEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.not-closed-beyond-end-date",
        "defaultMessage": "This issue is still unresolved after its end date. Check if the status needs updating, or if more time is needed for the issue."
    },
    inProgressBeyondInferredEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.in-progress-beyond-inferred-end-date",
        "defaultMessage": "This issue is still unresolved after its end date. Consider moving the status back to To do, adding the issue to a current or future sprint, or rescheduling the issue to a later end date."
    },
    dateOutsideOfSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.date-outside-of-sprint",
        "defaultMessage": "The start or end date of the issue fall outside of the assigned sprint"
    },
    issueAssignedKanbanTeamAndSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.issue-assigned-kanban-team-and-sprint",
        "defaultMessage": "Sprints should only be associated with Scrum teams. The capacity of this issue will still be allocated to the Kanban iterations using the assigned dates, but please verify the Sprint assignment."
    },
    // Scheduler warnings
    unknown: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.unknown",
        "defaultMessage": "There was an error during scheduling"
    },
    notFullyScheduled: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.not-fully-scheduled",
        "defaultMessage": "Check that someone in your team is available to work on this issue at this particular time and then recalculate your plan."
    },
    horizonReached: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.horizon-reached",
        "defaultMessage": "Every plan has a maximum 5 year planning horizon. Decrease the scope of work, add extra people, or increase your team's capacity to reduce the length of your schedule. Then, recalculate your plan."
    },
    releaseConflict: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.release-conflict",
        "defaultMessage": "A story-level issue and its sub-tasks must be assigned to the same release. Check the release assignments are consistent and then recalculate your plan."
    },
    assigneeIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.assignee-ignored",
        "defaultMessage": "This issue is scheduled for a person other than its assignee, as the assignee is not part of any of the teams in your plan. Check that they are part of a team and that their team can be assigned to this issue. Then, recalculate your plan."
    },
    externalTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.external-team",
        "defaultMessage": "Change the assigned team to one that's in your plan, or add the assigned team to your plan. Then, recalculate your plan."
    },
    subtaskViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-violation",
        "defaultMessage": "This item could not be scheduled due to a problem with one of its sub-tasks. To schedule this item, alleviate any existing errors on its sub-tasks."
    },
    subtaskAssignmentViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-assignment-violation",
        "defaultMessage": "A story-level issue and its sub-tasks must be scheduled to the same team. Check the team assignments are consistent and then recalculate your plan."
    },
    sprintExceeded: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.sprint-exceeded",
        "defaultMessage": "Break your story down further so that estimate is reduced, or decrease the scope of the sprint, until this issue fits into the sprint. Then, recalculate your plan."
    },
    invalidSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.invalid-sprint",
        "defaultMessage": "The item is assigned to an invalid sprint."
    },
    releaseShifted: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.release-shifted",
        "defaultMessage": "Because of the sprint assignment of this work item the corresponding release start date is shifted."
    },
    earliestStartIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.earliest-start-ignored",
        "defaultMessage": "The start date of this issue's manually assigned sprint takes precedence over this issue's earliest start date. To maintain the earliest start date, set the issue's sprint to 'Calculate'. Or, to remove this message, remove the start date from this issue. Then, recalculate your plan."
    },
    overbooked: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.overbooked",
        "defaultMessage": "This issue is manually assigned to a sprint in which the people available to work on it are overbooked. Decrease the scope for those particular people. Or, if there are no people in your team, decrease the scope of the sprint. Then, recalculate your plan."
    },
    availabilityViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.availability-violation",
        "defaultMessage": "Check in the team view that someone in your team is available to work on this issue at this time and then recalculate your plan."
    },
    resourceLimitViolation: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.resource-limit-violation",
        "defaultMessage": "Resource limit violation"
    },
    violationInDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.violation-in-dependency",
        "defaultMessage": "A required work item could not be scheduled."
    },
    dependenciesIgnoredRelease: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.dependencies-ignored-release",
        "defaultMessage": "This work item is assigned to a release which happens earlier than releases that this work item's dependencies are assigned to."
    },
    dependenciesIgnoredSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.dependencies-ignored-sprint",
        "defaultMessage": "This work item is assigned to a fixed sprint which happens earlier than sprints that this work item's dependencies are scheduled in."
    },
    cyclicDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.cyclic-dependency",
        "defaultMessage": "This issue depends on an issue that directly (or indirectly) depends back on this issue. Remove that dependency and recalculate your plan."
    },
    /* eslint-disable jira/i18n/id-named-by-package */ subtaskCyclicDependencyIgnored: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.body.subtask-cyclic-dependency-ignored",
        "defaultMessage": "We can't process dependencies between sub-tasks within a single issue. Remove these dependencies on this issue and then auto-schedule your plan."
    } /* eslint-enable jira/i18n/id-named-by-package */ ,
    subtaskNoSkilledResource: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.subtask-no-skilled-resource",
        "defaultMessage": "Sub-tasks must to assigned to a single person and can't be assigned across teams or people. Check a single team member has the required skill set and make sure they are available. Or, remove the skill requirements on this issue by refining its estimates. Then, recalculate your plan."
    },
    missingSkills: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.missing-skills",
        "defaultMessage": "Story-level issues can't be assigned across teams. Check that (a subset of) team members collectively have the required skill set, and that they are available. Then, recalculate your plan."
    },
    tooSmallEstimates: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.too-small-estimates",
        "defaultMessage": "Check all estimates on this issue are at least 0.01. This means the total estimate, as well as the estimate for any stage or skill. Then, recalculate your plan."
    },
    completedParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.completed-parent",
        "defaultMessage": "This work item could not be scheduled because one of its parents has been marked as done. To schedule it, change the parent of this work item or change the status of the parent. Otherwise, to remove this message, mark this item as done as well."
    },
    calculationComplexity: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.warnings.calculation-complexity",
        "defaultMessage": "Remove the issue from its assigned sprint, change the required skills, or make the assigned team smaller. Then, recalculate your plan."
    }
});

});



parcelRegister("5fUv6", function(module, exports) {

$parcel$export(module.exports, "convertSecondsToHours", () => $c7df2e2060a1423c$export$9446e10eb5cfa53);
$parcel$export(module.exports, "convertSecondsToDays", () => $c7df2e2060a1423c$export$c6ce755da034e875);
$parcel$export(module.exports, "isEstimated", () => $c7df2e2060a1423c$export$28d842baedf9b186);
$parcel$export(module.exports, "getEstimateRollupValue", () => $c7df2e2060a1423c$export$dacf8be5aae1988);
$parcel$export(module.exports, "getEstimateValue", () => $c7df2e2060a1423c$export$16b3694ec6544c81);
$parcel$export(module.exports, "getTimeSpentValue", () => $c7df2e2060a1423c$export$cd24e7ac392945a5);
$parcel$export(module.exports, "convertEstimate", () => $c7df2e2060a1423c$export$bf9e57c9a45f6fd9);

var $b3iuB = parcelRequire("b3iuB");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $c7df2e2060a1423c$export$9446e10eb5cfa53 = (seconds)=>seconds / 3600;
const $c7df2e2060a1423c$export$c6ce755da034e875 = (seconds, hoursPerDay)=>$c7df2e2060a1423c$export$9446e10eb5cfa53(seconds) / hoursPerDay;
const $c7df2e2060a1423c$export$28d842baedf9b186 = (planningUnit, issue)=>{
    switch(planningUnit){
        case (0, $5rYNM.PlanningUnits).storyPoints:
            return (0, $7CnHa.isDefined)(issue.storyPoints) && !$b3iuB.default(issue.storyPoints);
        case (0, $5rYNM.PlanningUnits).days:
        case (0, $5rYNM.PlanningUnits).hours:
            return (0, $7CnHa.isDefined)(issue.timeEstimate) && !$b3iuB.default(issue.timeEstimate);
        default:
            throw new Error(`Unexpected planningUnit: ${planningUnit}`);
    }
};
const $c7df2e2060a1423c$export$dacf8be5aae1988 = (estimate, planningUnit, workingHours)=>{
    if (estimate === null) return '';
    switch(planningUnit){
        case (0, $5rYNM.PlanningUnits).days:
            return Math.round($c7df2e2060a1423c$export$c6ce755da034e875(estimate, workingHours) * 100) / 100;
        case (0, $5rYNM.PlanningUnits).hours:
            return Math.round($c7df2e2060a1423c$export$9446e10eb5cfa53(estimate) * 100) / 100;
        default:
            return Math.round(estimate * 10) / 10;
    }
};
const $c7df2e2060a1423c$export$16b3694ec6544c81 = (planningUnit, issue, hoursPerDay)=>{
    switch(planningUnit){
        case (0, $5rYNM.PlanningUnits).storyPoints:
            return issue.storyPoints ? issue.storyPoints : 0;
        case (0, $5rYNM.PlanningUnits).days:
            return issue.timeEstimate ? $c7df2e2060a1423c$export$c6ce755da034e875(issue.timeEstimate, hoursPerDay) : 0;
        case (0, $5rYNM.PlanningUnits).hours:
            return issue.timeEstimate ? $c7df2e2060a1423c$export$9446e10eb5cfa53(issue.timeEstimate) : 0;
        default:
            throw new Error(`Unexpected planningUnit: ${planningUnit}`);
    }
};
const $c7df2e2060a1423c$export$cd24e7ac392945a5 = (planningUnit, issue, hoursPerDay)=>{
    switch(planningUnit){
        case (0, $5rYNM.PlanningUnits).storyPoints:
            return 0;
        case (0, $5rYNM.PlanningUnits).days:
            return issue.timeSpent ? $c7df2e2060a1423c$export$c6ce755da034e875(issue.timeSpent, hoursPerDay) : 0;
        case (0, $5rYNM.PlanningUnits).hours:
            return issue.timeSpent ? $c7df2e2060a1423c$export$9446e10eb5cfa53(issue.timeSpent) : 0;
        default:
            throw new Error(`Unexpected planningUnit: ${planningUnit}`);
    }
};
const $c7df2e2060a1423c$var$convertHoursToSeconds = (hours)=>hours * 3600;
const $c7df2e2060a1423c$var$convertDaysToSeconds = (days, workingHours)=>days * workingHours * 3600;
const $c7df2e2060a1423c$var$round = (number)=>Math.round(number * 1000) / 1000;
const $c7df2e2060a1423c$var$floorSecondsToNearestMinute = (seconds)=>Math.floor(seconds / 60) * 60;
const $c7df2e2060a1423c$export$bf9e57c9a45f6fd9 = (planningUnit, value, workingHours)=>{
    switch(planningUnit){
        case (0, $5rYNM.PlanningUnits).storyPoints:
            return $c7df2e2060a1423c$var$round(value);
        case (0, $5rYNM.PlanningUnits).days:
            return $c7df2e2060a1423c$var$floorSecondsToNearestMinute($c7df2e2060a1423c$var$convertDaysToSeconds(value, workingHours));
        case (0, $5rYNM.PlanningUnits).hours:
            return $c7df2e2060a1423c$var$floorSecondsToNearestMinute($c7df2e2060a1423c$var$convertHoursToSeconds(value));
        default:
            throw new Error(`Unexpected value: ${value}`);
    }
};

});

parcelRegister("bfLCp", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $a9c35876ed28e368$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $a9c35876ed28e368$export$4a991c87e640ef77);
$parcel$export(module.exports, "RESET_ALL", () => $a9c35876ed28e368$export$626f5c04a48a9c44);
$parcel$export(module.exports, "add", () => $a9c35876ed28e368$export$e16d8520af44a096);
$parcel$export(module.exports, "reset", () => $a9c35876ed28e368$export$aad8462122ac592b);
$parcel$export(module.exports, "resetAll", () => $a9c35876ed28e368$export$ffe8c06b7e356699);
const $a9c35876ed28e368$export$bb6389024b71c2ae = 'state.domain.custom-labels.ADD';
const $a9c35876ed28e368$export$4a991c87e640ef77 = 'state.domain.custom-labels.RESET';
const $a9c35876ed28e368$export$626f5c04a48a9c44 = 'state.domain.custom-labels.RESET_ALL';
const $a9c35876ed28e368$export$e16d8520af44a096 = (payload)=>({
        type: $a9c35876ed28e368$export$bb6389024b71c2ae,
        payload: payload
    });
const $a9c35876ed28e368$export$aad8462122ac592b = (payload)=>({
        type: $a9c35876ed28e368$export$4a991c87e640ef77,
        payload: payload
    });
const $a9c35876ed28e368$export$ffe8c06b7e356699 = (payload)=>({
        type: $a9c35876ed28e368$export$626f5c04a48a9c44,
        payload: payload
    });

});

parcelRegister("1umd3", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $89984ddfc71741d3$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE_PARENT", () => $89984ddfc71741d3$export$44bc1fe1c2a61c81);
$parcel$export(module.exports, "reset", () => $89984ddfc71741d3$export$aad8462122ac592b);
$parcel$export(module.exports, "updateParent", () => $89984ddfc71741d3$export$28a8f5cfab98131e);
const $89984ddfc71741d3$export$4a991c87e640ef77 = 'state.domain.history-issues.RESET';
const $89984ddfc71741d3$export$44bc1fe1c2a61c81 = 'state.domain.history-issues.UPDATE_PARENT';
const $89984ddfc71741d3$export$aad8462122ac592b = (payload)=>({
        type: $89984ddfc71741d3$export$4a991c87e640ef77,
        payload: payload
    });
const $89984ddfc71741d3$export$28a8f5cfab98131e = (payload)=>({
        type: $89984ddfc71741d3$export$44bc1fe1c2a61c81,
        payload: payload
    });

});

parcelRegister("lhX0J", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $e465f1592cfc0efc$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $e465f1592cfc0efc$export$4a991c87e640ef77);
$parcel$export(module.exports, "REMOVE", () => $e465f1592cfc0efc$export$29d55e1f664a246b);
$parcel$export(module.exports, "add", () => $e465f1592cfc0efc$export$e16d8520af44a096);
$parcel$export(module.exports, "reset", () => $e465f1592cfc0efc$export$aad8462122ac592b);
const $e465f1592cfc0efc$export$bb6389024b71c2ae = 'state.domain.issue-labels.ADD';
const $e465f1592cfc0efc$export$4a991c87e640ef77 = 'state.domain.issue-labels.RESET';
const $e465f1592cfc0efc$export$29d55e1f664a246b = 'state.domain.issue-labels.REMOVE';
const $e465f1592cfc0efc$export$e16d8520af44a096 = (payload)=>({
        type: $e465f1592cfc0efc$export$bb6389024b71c2ae,
        payload: payload
    });
const $e465f1592cfc0efc$export$aad8462122ac592b = (payload)=>({
        type: $e465f1592cfc0efc$export$4a991c87e640ef77,
        payload: payload
    });
const $e465f1592cfc0efc$export$cd7f480d6b8286c3 = (payload)=>({
        type: $e465f1592cfc0efc$export$29d55e1f664a246b,
        payload: payload
    });

});

parcelRegister("77LR7", function(module, exports) {

$parcel$export(module.exports, "SET_LOADING_ISSUE_DESCRIPTION", () => $5dec046ee3f875a9$export$f8f331eabae6331a);
$parcel$export(module.exports, "SET_ISSUE_BEING_EDITED", () => $5dec046ee3f875a9$export$1477427ecc20a98f);
$parcel$export(module.exports, "setLoadingIssueDescription", () => $5dec046ee3f875a9$export$c7b33c71f329a906);
$parcel$export(module.exports, "setIssueBeingEdited", () => $5dec046ee3f875a9$export$8ab1575ab4b619b6);
const $5dec046ee3f875a9$export$f8f331eabae6331a = 'state.domain.issueModal.SET_LOADING_ISSUE_DESCRIPTION';
const $5dec046ee3f875a9$export$1477427ecc20a98f = 'state.domain.issueModal.SET_ISSUE_BEING_EDITED';
const $5dec046ee3f875a9$export$c7b33c71f329a906 = (payload)=>({
        type: $5dec046ee3f875a9$export$f8f331eabae6331a,
        payload: payload
    });
const $5dec046ee3f875a9$export$8ab1575ab4b619b6 = (payload)=>({
        type: $5dec046ee3f875a9$export$1477427ecc20a98f,
        payload: payload
    });

});

parcelRegister("2oZqS", function(module, exports) {

$parcel$export(module.exports, "LOAD", () => $b192655066a32005$export$50c885a21bfec48c);
$parcel$export(module.exports, "CANCEL", () => $b192655066a32005$export$2b10f4b30fb65583);
$parcel$export(module.exports, "SUCCESS", () => $b192655066a32005$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAIL", () => $b192655066a32005$export$1c2edf198d818245);
$parcel$export(module.exports, "load", () => $b192655066a32005$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "cancel", () => $b192655066a32005$export$70b61ad426ddbe54);
$parcel$export(module.exports, "success", () => $b192655066a32005$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "fail", () => $b192655066a32005$export$2b62a06a9fee979c);
const $b192655066a32005$export$50c885a21bfec48c = 'state.domain.update-jira.change-status.LOAD';
const $b192655066a32005$export$2b10f4b30fb65583 = 'state.domain.update-jira.change-status.CANCEL';
const $b192655066a32005$export$638cc6e36b2a737a = 'state.domain.update-jira.change-status.SUCCESS';
const $b192655066a32005$export$1c2edf198d818245 = 'state.domain.update-jira.change-status.FAIL';
const $b192655066a32005$export$11e63f7b0f3d9900 = (payload)=>({
        type: $b192655066a32005$export$50c885a21bfec48c,
        payload: payload
    });
const $b192655066a32005$export$70b61ad426ddbe54 = ()=>({
        type: $b192655066a32005$export$2b10f4b30fb65583
    });
const $b192655066a32005$export$fe7c49d056ea1d88 = ()=>({
        type: $b192655066a32005$export$638cc6e36b2a737a
    });
const $b192655066a32005$export$2b62a06a9fee979c = ()=>({
        type: $b192655066a32005$export$1c2edf198d818245
    });

});

parcelRegister("9LVH6", function(module, exports) {

$parcel$export(module.exports, "START", () => $0e9aa941af7ff6c7$export$21c466265830bc3a);
$parcel$export(module.exports, "INCREMENT_NUMBER_OF_COMMITTED_CHANGES", () => $0e9aa941af7ff6c7$export$9c44dbd8f77715ca);
$parcel$export(module.exports, "INTERRUPT", () => $0e9aa941af7ff6c7$export$a9f3c3bb2f676e06);
$parcel$export(module.exports, "STOP", () => $0e9aa941af7ff6c7$export$82b9a23e44460c20);
$parcel$export(module.exports, "start", () => $0e9aa941af7ff6c7$export$b3571188c770cc5a);
$parcel$export(module.exports, "incrementNumberOfCommittedChanges", () => $0e9aa941af7ff6c7$export$687ff1f375e4b25);
$parcel$export(module.exports, "interrupt", () => $0e9aa941af7ff6c7$export$7b7d62677a00f822);
$parcel$export(module.exports, "stop", () => $0e9aa941af7ff6c7$export$fa6813432f753b0d);
const $0e9aa941af7ff6c7$export$21c466265830bc3a = 'state.domain.update-jira.commit.START';
const $0e9aa941af7ff6c7$export$9c44dbd8f77715ca = 'state.domain.update-jira.commit.INCREMENT_NUMBER_OF_COMMITTED_CHANGES';
const $0e9aa941af7ff6c7$export$a9f3c3bb2f676e06 = 'state.domain.update-jira.commit.INTERRUPT';
const $0e9aa941af7ff6c7$export$82b9a23e44460c20 = 'state.domain.update-jira.commit.STOP';
const $0e9aa941af7ff6c7$export$b3571188c770cc5a = (totalChanges)=>({
        type: $0e9aa941af7ff6c7$export$21c466265830bc3a,
        payload: totalChanges
    });
const $0e9aa941af7ff6c7$export$687ff1f375e4b25 = ()=>({
        type: $0e9aa941af7ff6c7$export$9c44dbd8f77715ca
    });
const $0e9aa941af7ff6c7$export$7b7d62677a00f822 = ()=>({
        type: $0e9aa941af7ff6c7$export$a9f3c3bb2f676e06
    });
const $0e9aa941af7ff6c7$export$fa6813432f753b0d = ()=>({
        type: $0e9aa941af7ff6c7$export$82b9a23e44460c20
    });

});

parcelRegister("7WQG5", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $6a66dc2dc183b809$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $6a66dc2dc183b809$export$aad8462122ac592b);
const $6a66dc2dc183b809$export$4a991c87e640ef77 = 'state.domain.update-jira.hidden-issues.RESET';
const $6a66dc2dc183b809$export$aad8462122ac592b = (payload)=>({
        type: $6a66dc2dc183b809$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("264LW", function(module, exports) {

$parcel$export(module.exports, "LOAD", () => $6cce52d2abb270af$export$50c885a21bfec48c);
$parcel$export(module.exports, "CANCEL", () => $6cce52d2abb270af$export$2b10f4b30fb65583);
$parcel$export(module.exports, "SUBMIT", () => $6cce52d2abb270af$export$324ecb06850cfa68);
$parcel$export(module.exports, "FAIL", () => $6cce52d2abb270af$export$1c2edf198d818245);
$parcel$export(module.exports, "load", () => $6cce52d2abb270af$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "cancel", () => $6cce52d2abb270af$export$70b61ad426ddbe54);
$parcel$export(module.exports, "submit", () => $6cce52d2abb270af$export$853c27de4ce0f746);
$parcel$export(module.exports, "fail", () => $6cce52d2abb270af$export$2b62a06a9fee979c);
const $6cce52d2abb270af$export$50c885a21bfec48c = 'state.domain.update-jira.required-fields.LOAD';
const $6cce52d2abb270af$export$2b10f4b30fb65583 = 'state.domain.update-jira.required-fields.CANCEL';
const $6cce52d2abb270af$export$324ecb06850cfa68 = 'state.domain.update-jira.required-fields.SUBMIT';
const $6cce52d2abb270af$export$1c2edf198d818245 = 'state.domain.update-jira.required-fields.FAIL';
const $6cce52d2abb270af$export$11e63f7b0f3d9900 = (payload)=>({
        type: $6cce52d2abb270af$export$50c885a21bfec48c,
        payload: payload
    });
const $6cce52d2abb270af$export$70b61ad426ddbe54 = ()=>({
        type: $6cce52d2abb270af$export$2b10f4b30fb65583
    });
const $6cce52d2abb270af$export$853c27de4ce0f746 = (payload)=>({
        type: $6cce52d2abb270af$export$324ecb06850cfa68,
        payload: payload
    });
const $6cce52d2abb270af$export$2b62a06a9fee979c = ()=>({
        type: $6cce52d2abb270af$export$1c2edf198d818245
    });

});

const $98b7323ecc71747d$export$9d631ffde1befd43 = 'state.ui.top.title-bar.hidden-issues.OPEN_HIDDEN_ISSUES_DIALOG';
const $98b7323ecc71747d$export$b1f17581bba10917 = 'state.ui.top.title-bar.hidden-issues.CLOSE_HIDDEN_ISSUES_DIALOG';

parcelRegister("gUMnJ", function(module, exports) {

$parcel$export(module.exports, "urls", () => $df980f88d13b153b$export$bcae9ba627f604b6);
$parcel$export(module.exports, "addIssueBody", () => $df980f88d13b153b$export$6c760d32dba4459f);
$parcel$export(module.exports, "updateIssueBody", () => $df980f88d13b153b$export$adb5b7fd3b19978e);
$parcel$export(module.exports, "rankIssueBody", () => $df980f88d13b153b$export$ed4998e39ac15e6e);
$parcel$export(module.exports, "hiddenIssuesBody", () => $df980f88d13b153b$export$632c3b767f7138e9);
$parcel$export(module.exports, "getDescription", () => $df980f88d13b153b$export$67580b1c13935958);
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");
var $eOsHk = parcelRequire("eOsHk");
const $df980f88d13b153b$export$bcae9ba627f604b6 = {
    add: '/rest/jpo/1.0/scenarios/addIssue',
    update: '/rest/jpo/1.0/scenarios/updateIssues',
    removeIssues: '/rest/jpo/1.0/scenarios/removeIssues',
    // Deprecated. Use removeIssues.
    deleteIssues: '/rest/jpo/1.0/scenarios/deleteIssues',
    rank: '/rest/jpo/1.0/issues/rank',
    commitChanges: '/rest/jpo/1.0/issues/commit',
    updateIssueKey: '/rest/jpo/1.0/scenarios/updateIssueKey',
    revertIssues: '/rest/jpo/1.0/scenarios/revertIssues',
    getHiddenIssues: '/rest/jpo/1.0/backlog/hiddenIssues',
    getDoneHistory: '/rest/jpo/1.0/backlog/history',
    getDescription: '/rest/jpo/1.0/issue/description/get'
};
const $df980f88d13b153b$export$b397e3f558f897d1 = ({ id: id, level: level, ...issue })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const patch = {};
    for (const key of Object.keys(issue)){
        if (key === 'assignee' && issue.assignee === 'unassigned') patch.assignee = {
            value: null
        };
        else if (key === 'fixVersions' && Array.isArray(issue[key])) patch.versionIds = {
            value: issue[key]
        };
        else if (key === 'customFields') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        patch.customFields = Object.keys(issue.customFields).reduce((previous, field)=>{
            // eslint-disable-next-line no-param-reassign
            previous[field] = {
                value: issue.customFields[field] === null ? undefined : issue.customFields[field]
            };
            return previous;
        }, {});
        else if (key === (0, $eOsHk.TARGET_START_FIELD) || key === (0, $eOsHk.TARGET_END_FIELD)) {
            const apiKey = (0, $chgK5.TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP)[key] || key;
            patch[apiKey] = {
                value: issue[key]
            };
        } else if (key === 'labels') {
            if (issue[key].fieldAction != null) patch[key] = issue[key];
            else patch[key] = {
                value: issue[key]
            };
        } else patch[key] = {
            value: issue[key]
        };
    }
    return patch;
};
const $df980f88d13b153b$export$6c760d32dba4459f = (plan, payload)=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    return {
        planId: planId,
        scenarioId: scenarioId,
        description: $df980f88d13b153b$export$b397e3f558f897d1(payload)
    };
};
const $df980f88d13b153b$export$adb5b7fd3b19978e = (plan, payload, itemKeys)=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    return {
        itemKeys: itemKeys || [
            payload.id
        ],
        planId: planId,
        scenarioId: scenarioId,
        description: $df980f88d13b153b$export$b397e3f558f897d1(payload)
    };
};
const $df980f88d13b153b$export$ed4998e39ac15e6e = (plan, payload)=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    const { itemKeys: itemKeys, anchor: anchor, relation: relation } = payload;
    return {
        operations: [
            {
                anchor: anchor,
                itemKeys: itemKeys,
                operationType: relation
            }
        ],
        planId: planId,
        scenarioId: scenarioId
    };
};
const $df980f88d13b153b$export$632c3b767f7138e9 = ({ id: planId, currentScenarioId: scenarioId }, issueIds)=>{
    if (!planId || !scenarioId) throw new Error('Need both plan and scenario to get hidden issues');
    const payload = {
        planId: planId,
        scenarioId: scenarioId,
        issueIds: issueIds
    };
    return payload;
};
const $df980f88d13b153b$export$67580b1c13935958 = (plan, itemKey)=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    return {
        planId: planId,
        scenarioId: scenarioId,
        itemKey: itemKey,
        renderRaw: true
    };
};

});
parcelRegister("1Uotp", function(module, exports) {

$parcel$export(module.exports, "BUILT_IN_DATE_FIELDS", () => (parcelRequire("eOsHk")).BUILT_IN_DATE_FIELDS);
$parcel$export(module.exports, "ISSUE_FIELDS", () => (parcelRequire("chgK5")).ISSUE_FIELDS);
$parcel$export(module.exports, "ISSUE_FIELD_TO_TYPE_MAP", () => (parcelRequire("chgK5")).ISSUE_FIELD_TO_TYPE_MAP);
$parcel$export(module.exports, "TARGET_START_FIELD", () => (parcelRequire("eOsHk")).TARGET_START_FIELD);
$parcel$export(module.exports, "TARGET_END_FIELD", () => (parcelRequire("eOsHk")).TARGET_END_FIELD);
$parcel$export(module.exports, "TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP", () => (parcelRequire("chgK5")).TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP);
parcelRequire("chgK5");
var $eOsHk = parcelRequire("eOsHk");
var $chgK5 = parcelRequire("chgK5");

});


parcelRegister("57pw5", function(module, exports) {

$parcel$export(module.exports, "getOriginalProperties", () => $8d0bd763e2df15c3$export$c8b74b755988db44);
$parcel$export(module.exports, "getAddedIssueRankPayload", () => $8d0bd763e2df15c3$export$10c4913e94f7c57b);
$parcel$export(module.exports, "getBulkRankPayload", () => $8d0bd763e2df15c3$export$40698dc95abaae0b);

var $5OdRK = parcelRequire("5OdRK");
var $aAR0h = parcelRequire("aAR0h");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $kjklK = parcelRequire("kjklK");
var $7WzTP = parcelRequire("7WzTP");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");
const $8d0bd763e2df15c3$var$pickFieldsFromIssue = (fields, issue)=>$7WzTP.default(fields, issue);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8d0bd763e2df15c3$var$withNullDefaultValue = (partialIssue)=>$cQGVO.default((value)=>(0, $7CnHa.isDefined)(value) ? value : null, partialIssue);
const $8d0bd763e2df15c3$export$c8b74b755988db44 = (issue, payload)=>{
    const originalCustomFields = Object.keys(payload.customFields || {}).reduce((result, key)=>Object.assign(result, {
            [key]: $kjklK.default([
                'customFields',
                key
            ], issue) || null
        }), {});
    const originalProperties = Object.keys(originalCustomFields).length === 0 ? $8d0bd763e2df15c3$var$withNullDefaultValue($8d0bd763e2df15c3$var$pickFieldsFromIssue(Object.keys(payload), issue)) : $01zCq.default($8d0bd763e2df15c3$var$withNullDefaultValue($8d0bd763e2df15c3$var$pickFieldsFromIssue(Object.keys(payload), issue)), {
        customFields: originalCustomFields
    });
    if (!$5OdRK.default(payload, originalProperties)) return originalProperties;
};
const $8d0bd763e2df15c3$export$10c4913e94f7c57b = ({ id: id, level: level, parent: parent }, issues, sibling)=>{
    const siblings = issues.filter(parent ? (issue)=>issue.parent === parent && issue.id !== id : (issue)=>issue.level === level && issue.id !== id);
    if (!parent && siblings.length === 0) return {
        itemKeys: [
            id
        ],
        relation: (0, $eOsHk.RANK_LAST)
    };
    if (sibling) return {
        anchor: sibling,
        itemKeys: [
            id
        ],
        relation: (0, $eOsHk.RANK_AFTER)
    };
    return {
        anchor: siblings.length > 0 ? siblings[siblings.length - 1].id : parent,
        itemKeys: [
            id
        ],
        relation: (0, $eOsHk.RANK_AFTER)
    };
};
const $8d0bd763e2df15c3$export$40698dc95abaae0b = ({ anchor: anchor, operationType: operationType }, itemKeys, allIssues)=>{
    const itemKeysSet = new Set(itemKeys);
    // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'Relation' and '"TOP"' have no overlap.
    if (operationType === (0, $eOsHk.RANK_TOP)) {
        // For RANK_TOP we need to rank BEFORE the issue with the lowest lexorank, otherwise it's a no-op.
        const topIssue = allIssues.find(({ id: id })=>!itemKeysSet.has(id));
        if (!topIssue) return null;
        return {
            anchor: topIssue.id,
            itemKeys: itemKeys,
            relation: (0, $eOsHk.RANK_BEFORE)
        };
    }
    if (operationType === (0, $eOsHk.RANK_LAST)) {
        // For RANK_LAST we need to rank AFTER the issue with the highest lexorank, otherwise it's a no-op.
        // Note that RANK_LAST meaning is overloaded for the bulk case. Usually RANK_LAST is used
        // to get initial rank for the scenario issue without parent and siblings as there is no
        // suitable anchor to rank against.
        const bottomIssue = $aAR0h.default(({ id: id })=>!itemKeysSet.has(id), allIssues);
        if (!bottomIssue) return null;
        return {
            anchor: bottomIssue.id,
            itemKeys: itemKeys,
            relation: operationType
        };
    }
    return {
        anchor: anchor,
        itemKeys: itemKeys,
        relation: operationType
    };
};

});
parcelRegister("aAR0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b666196f0d93cd1$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $jPXcn = parcelRequire("jPXcn");
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $7b666196f0d93cd1$var$findLast = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([], (0, $jPXcn.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $7b666196f0d93cd1$export$2e2bcd8739ae039 = $7b666196f0d93cd1$var$findLast;

});
parcelRegister("jPXcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e710b3576f6d020b$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $8uquE = parcelRequire("8uquE");
var $e710b3576f6d020b$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XFindLast.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
    };
    XFindLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $e710b3576f6d020b$var$_xfindLast = /*#__PURE__*/ (0, $ggdJA.default)(function _xfindLast(f, xf) {
    return new $e710b3576f6d020b$var$XFindLast(f, xf);
});
var $e710b3576f6d020b$export$2e2bcd8739ae039 = $e710b3576f6d020b$var$_xfindLast;

});





parcelRegister("1O638", function(module, exports) {

$parcel$export(module.exports, "default", () => $af39ee4ac700a64a$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $52FI4 = parcelRequire("52FI4");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var $af39ee4ac700a64a$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    isLoadingIssueDescription: (0, $52FI4.getIsLoadingIssueDescription),
    isOptimizedMode: $akhOi.isOptimizedMode,
    isReadOnly: $akhOi.isReadOnly,
    issueBeingEdited: (0, $52FI4.getIssueBeingEdited),
    issuesById: (0, $40hi6.getAllIssuesWithOriginalAndOptimizedById),
    projectsById: (0, $ehEr2.getProjectsById)
});

});

parcelRegister("aMdJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e4b32039316e76$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-lazy

var $eUqFw = parcelRequire("eUqFw");

var $jPCDz = parcelRequire("jPCDz");

var $jWuk1 = parcelRequire("jWuk1");

var $5YsMl = parcelRequire("5YsMl");

var $f8Yej = parcelRequire("f8Yej");

var $2qhQi = parcelRequire("2qhQi");

var $gGtKh = parcelRequire("gGtKh");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $eNhh9 = parcelRequire("eNhh9");
var $6GmrT = parcelRequire("6GmrT");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $eYlCJ = parcelRequire("eYlCJ");
var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");

var $7CnHa = parcelRequire("7CnHa");

var $4UWBa = parcelRequire("4UWBa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $2tFe2 = parcelRequire("2tFe2");

var $h5Clq = parcelRequire("h5Clq");

var $8vhw8 = parcelRequire("8vhw8");

const $69e4b32039316e76$var$LazyDescriptionEditor = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("hcWZo")));
function $69e4b32039316e76$var$IssueModal({ BreadcrumbsComponent: BreadcrumbsComponent = (0, $2tFe2.default), DescriptionEditorComponent: DescriptionEditorComponent = $69e4b32039316e76$var$LazyDescriptionEditor, issueBeingEdited: issueBeingEdited, issuesById: issuesById, setIssueBeingEdited: setIssueBeingEdited, setDescription: setDescription, projectsById: projectsById, intl: intl, onChange: onChange, isOptimizedMode: isOptimizedMode, isReadOnly: isReadOnly, isLoadingIssueDescription: isLoadingIssueDescription }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isEditingSummary, setIsEditingSummary] = (0, $eUqFw.useState)(false);
    const [isEditingDescription, setIsEditingDescription] = (0, $eUqFw.useState)(false);
    const innerFieldModalIssue = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = intl;
    const issue = typeof issueBeingEdited === 'string' ? issuesById[issueBeingEdited] : null;
    const isScenarioIssue = Boolean(issue && (!(0, $7CnHa.isDefined)(issue.issueKey) || issue.id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))));
    const issueDescription = isLoadingIssueDescription ? undefined : issue?.description;
    const isSummaryDirty = issue?.originals && $jPCDz.default('summary', issue.originals);
    const isDescriptionDirty = issue?.originals && $jPCDz.default('description', issue.originals);
    const validateIssueSummary = (summary)=>{
        // if the issue summary is not valid, we return a warning message which disables the "confirm" button of <InlineEdit />
        if (summary.trim().length === 0) return formatMessage((0, $h5Clq.default).blankSummaryInputErrorMessage);
        if (summary.length > 255) return formatMessage((0, $h5Clq.default).invalidSummaryInput);
        // if the issue summary is valid, we return undefined which enables the "confirm" button of <InlineEdit />
        return undefined;
    };
    const fireAnalytics = (0, $eUqFw.useCallback)((eventName)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), eventName, 'arjIssueModalIssueSummary', {
            isScenarioIssue: isScenarioIssue
        });
    }, [
        createAnalyticsEvent,
        isScenarioIssue
    ]);
    const handleSummaryEdit = ()=>{
        setIsEditingSummary(true);
        fireAnalytics((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_ISSUE_SUMMARY);
    };
    const handleSummaryChange = (0, $eUqFw.useCallback)((editedSummary)=>{
        if (!issue) return;
        if (!issue.id) throw new Error('Issue must have id!');
        onChange({
            id: issue.id,
            summary: editedSummary && editedSummary.trim() || issue.summary
        });
        setIsEditingSummary(false);
        // This callback is fired even when the user clicks away without editing
        // so we add this check to fire the appropriate event
        if (editedSummary !== issue.summary) fireAnalytics((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_ISSUE_SUMMARY);
        else fireAnalytics((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CANCELLED_ISSUE_SUMMARY);
    }, [
        fireAnalytics,
        issue,
        onChange
    ]);
    const handleSummaryCancel = ()=>{
        setIsEditingSummary(false);
        fireAnalytics((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CANCELLED_ISSUE_SUMMARY);
    };
    const handleClose = ()=>{
        setIsEditingSummary(false);
        setIsEditingDescription(false);
        setIssueBeingEdited(null);
    };
    const getIssueSummaryReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary-read-view",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $8vhw8.summaryReadView
        }, issue?.summary, " ", !isOptimizedMode && isSummaryDirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), null));
    if (!(0, $7CnHa.isDefined)(issueBeingEdited) || !(0, $7CnHa.isDefined)(issue)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        width: "large",
        autoFocus: false,
        onClose: handleClose,
        shouldCloseOnOverlayClick: isReadOnly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8vhw8.modalHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8vhw8.breadcrumbs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadcrumbsComponent, {
        issue: issue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: isEditingSummary || isEditingDescription ? $8vhw8.hiddenButton : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: formatMessage((0, $ib5d3.default).close),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage((0, $ib5d3.default).close)
        }),
        onClick: handleClose,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.modal-close-button"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$8vhw8.summary} ${!isReadOnly && isEditingSummary ? $8vhw8.summaryBeingEdited : ''}`
    }, isReadOnly ? getIssueSummaryReadView() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GmrT.default), {
        defaultValue: issue.summary,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                content: errorMessage,
                isOpen: fieldProps.isInvalid,
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.edit-summary"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
                onEscape: ()=>{
                // empty function
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...fieldProps,
                autoFocus: true,
                elemAfterInput: fieldProps && fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                    label: "",
                    primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
                }),
                maxLength: 256,
                placeholder: formatMessage((0, $h5Clq.default).summaryPlaceholder),
                ref: innerFieldModalIssue
            })))),
        onCancel: handleSummaryCancel,
        onConfirm: handleSummaryChange,
        onEdit: handleSummaryEdit,
        readView: getIssueSummaryReadView,
        validate: validateIssueSummary
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $8vhw8.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h5", {
        className: $8vhw8.descriptionLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $8vhw8.descriptionLabelInner
    }, formatMessage((0, $h5Clq.default).descriptionLabel), !isOptimizedMode && !!isDescriptionDirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "arj-description-editor",
        fallback: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $8vhw8.descriptionSpinner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DescriptionEditorComponent, {
        editMode: isEditingDescription,
        setEditMode: setIsEditingDescription,
        onSave: (description)=>setDescription(issueBeingEdited, description),
        issueId: issueBeingEdited,
        projectKey: projectsById[issue.project].key,
        issueKey: isScenarioIssue ? null : (0, $6vrw7.toIssueKey)(`${projectsById[issue.project].key}-${issue.issueKey || 0}`),
        editorContent: issueDescription,
        isReadOnly: isReadOnly,
        isLoadingIssueDescription: isLoadingIssueDescription,
        isScenarioIssue: isScenarioIssue,
        noContentMessage: formatMessage(isReadOnly ? (0, $h5Clq.default).noDescriptionReadOnlyMode : (0, $h5Clq.default).noDescription),
        descriptionFailedMessage: formatMessage((0, $h5Clq.default).descriptionParsingError)
    })))));
}
var $69e4b32039316e76$export$2e2bcd8739ae039 = (0, $2qhQi.default)($69e4b32039316e76$var$IssueModal);

});
parcelRegister("f8Yej", function(module, exports) {

$parcel$export(module.exports, "default", () => $874373505540c4d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");
class $874373505540c4d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args);
        this.setRef = (ref)=>{
            this.ref = ref;
        };
        this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("6GmrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fc22791565b0897$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2yRWX = parcelRequire("2yRWX");
class $6fc22791565b0897$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yRWX.default), this.props);
    }
}

});
parcelRegister("2yRWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0664d820ae0097f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $4LhB6 = parcelRequire("4LhB6");

var $lzLxZ = parcelRequire("lzLxZ");

var $4ZL0y = parcelRequire("4ZL0y");

var $lkPEe = parcelRequire("lkPEe");

var $5wwB6 = parcelRequire("5wwB6");

var $kNcDT = parcelRequire("kNcDT");

var $8hUcM = parcelRequire("8hUcM");
function $0664d820ae0097f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0664d820ae0097f9$var$fieldStyles = {
    name: "nziz0a",
    styles: "max-width:100%;position:relative"
};
const $0664d820ae0097f9$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: undefined,
    packageVersion: undefined
};
const $0664d820ae0097f9$var$noop = ()=>{};
const $0664d820ae0097f9$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel = $0664d820ae0097f9$var$noop, onEdit: providedOnEdit = $0664d820ae0097f9$var$noop, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eUqFw.useState)(startWithEditViewOpen);
    const timerRef = (0, $eUqFw.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $kNcDT.default)(isEditing, isEditingState);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eUqFw.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$0664d820ae0097f9$var$analyticsAttributes
    });
    const onCancelClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ const onEditViewWrapperBlur = (0, $eUqFw.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ const onEditViewWrapperFocus = (0, $eUqFw.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8hUcM.default), {
            editButtonLabel: editButtonLabel,
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lzLxZ.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $byn9U.jsx)("form", {
            /**
     * It is not normally acceptable to add key handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * to add support for keyboard functionality instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there is no negative
     * impacts to assistive technologies.
     */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') onCancel();
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $0664d820ae0097f9$var$fieldStyles,
                onBlur: ()=>{
                    onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wwB6.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /** Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /** This is to allow Ctrl + Enter to submit without action buttons */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, "Submit")))) : /** Field is used here only for the label and spacing */ /*#__PURE__*/ (0, $byn9U.jsx)((0, $4LhB6.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $0664d820ae0097f9$var$InlineEdit = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($0664d820ae0097f9$var$InnerInlineEdit, props);
};
var $0664d820ae0097f9$export$2e2bcd8739ae039 = $0664d820ae0097f9$var$InlineEdit;

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("5wwB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d378d9c54c5a6cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");

var $PdmhA = parcelRequire("PdmhA");

var $8tdcZ = parcelRequire("8tdcZ");
function $6d378d9c54c5a6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d378d9c54c5a6cc$var$buttonsContainerStyles = {
    name: "w3jtt6",
    styles: "display:flex;margin-block-start:var(--ds-space-075, 6px);position:absolute;inset-block-start:100%;inset-inline-end:0;flex-shrink:0"
};
const $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $8tdcZ.fontSize),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    // These buttons are floating, so they need an override to overlay interaction states
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N20A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N30A)})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:active': {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: `var(--ds-text, ${(0, $PdmhA.B400)})`
    }
});
const $6d378d9c54c5a6cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonsContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        type: "submit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))),
        UNSAFE_size: "small",
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d378d9c54c5a6cc$var$buttonWrapperBaseStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        UNSAFE_size: "small",
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $6d378d9c54c5a6cc$export$2e2bcd8739ae039 = $6d378d9c54c5a6cc$var$Buttons;

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z" fill="currentColor"/></svg>`
    }, props));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = $6d3cc6c41555bcf7$var$CheckIcon;
module.exports.default = $6d3cc6c41555bcf7$var$_default;

});

parcelRegister("8tdcZ", function(module, exports) {

$parcel$export(module.exports, "fontSize", () => $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "borderRadius", () => $0b3df1ecc0dc12b2$export$7a57f79000377ca2);

var $lcnyw = parcelRequire("lcnyw");
const $0b3df1ecc0dc12b2$export$85e3c3ca0c6fb93 = 14;
const $0b3df1ecc0dc12b2$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();

});


parcelRegister("kNcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc2637f9691157f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $acc2637f9691157f$var$usePrevious = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $acc2637f9691157f$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eUqFw.useRef)(null);
    const editViewRef = (0, $eUqFw.useRef)();
    const preventFocusOnEditButtonRef = (0, $eUqFw.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $acc2637f9691157f$var$usePrevious(shouldBeEditing);
    (0, $eUqFw.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $acc2637f9691157f$export$2e2bcd8739ae039 = $acc2637f9691157f$var$useButtonFocusHook;

});

parcelRegister("8hUcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e4844bc5b892d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $8tdcZ = parcelRequire("8tdcZ");
function $f1e4844bc5b892d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1e4844bc5b892d8$var$readViewContainerStyles = {
    name: "1xe63ku",
    styles: "line-height:1"
};
const $f1e4844bc5b892d8$var$editButtonStyles = (0, $1ZAYh.xcss)({
    display: 'block',
    margin: 'space.0',
    padding: 'space.0',
    appearance: 'none',
    background: 'transparent',
    border: 0,
    lineHeight: 1,
    outline: 0,
    ':focus-visible': {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ':focus + div': {
        borderColor: 'color.border.focused',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid'
    }
});
const $f1e4844bc5b892d8$var$readViewWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    border: '2px solid transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $8tdcZ.borderRadius),
    transition: 'background 0.2s',
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N30)})`
    }
});
const $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $f1e4844bc5b892d8$var$DRAG_THRESHOLD = 5;
const $f1e4844bc5b892d8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eUqFw.useRef)(0);
    const startY = (0, $eUqFw.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $f1e4844bc5b892d8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f1e4844bc5b892d8$var$readViewContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $f1e4844bc5b892d8$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f1e4844bc5b892d8$var$readViewWrapperStyles,
            readViewFitContainerWidth && $f1e4844bc5b892d8$var$readViewFitContainerWidthStyles
        ],
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $f1e4844bc5b892d8$export$2e2bcd8739ae039 = $f1e4844bc5b892d8$var$ReadView;

});



parcelRegister("2RVAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f36c83b31da2664$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f36c83b31da2664$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), props));

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});




parcelRegister("eYlCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf9add15f149187$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $84CBi = parcelRequire("84CBi");
function $fbf9add15f149187$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), props));
}

});

parcelRegister("cuuJa", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_ANALYTICS_EVENT_NAMES", () => $2e848d3540d9e0c5$export$284d34b1b34fb96d);
const $2e848d3540d9e0c5$export$284d34b1b34fb96d = {
    // Event Type - UI
    ISSUE_SEARCH_ICON_CLICK: 'jiraPortfolio3IssueSearch searchIconClick',
    ISSUE_SEARCH_STARTED_SEARCH_RESULT_NAVIGATION: 'jiraPortfolio3IssueSearch startedSearchResultsNavigation',
    REPARENT_ISSUES: 'issues reparented',
    REVERT_SCENARIO: 'scenarioChanges reverted',
    SELECT_TIMELINE_RANGE: 'timelineOption selectTimelineRange',
    SHARE_REPORT: 'report shared',
    UPDATE_ISSUE: 'issue updated',
    UPDATE_ISSUES: 'issues updated',
    UPDATE_FILTER: 'filters updated',
    CLEAR_FILTERS: 'filters cleared',
    UPDATED_DEPENDENCIES_FILTER: 'dependenciesFilter updated',
    UPDATED_ISSUE_PRIORITIES_FILTER: 'issuePrioritiesFilter updated',
    UPDATED_DEPENDENCY_STYLE: 'dependencyStyle updated',
    SET_ACTIVE_VIEW: 'activeView changed',
    SAVE_VIEW: 'view saved',
    ADD_VIEW: 'view added',
    RESET_VIEWS: 'view reset',
    HIDE_COLUMN: 'column hidden',
    SHOW_COLUMN: 'column shown',
    MARK_AS_DEFAULT_VIEW: 'view defaulted',
    CLICKED_DEPENDENCY_TAB: 'dependencyTab clicked',
    VIEWED_DEPENDENCY_TAB: 'dependencyTab viewed',
    CLICKED_DEPENDENCY_CARD: 'dependencyCard clicked',
    CLICKED_DEPENDENCY_LINE: 'dependencyLink clicked',
    UPDATED_DEPENDENCY_ROLLUP_DROPDOWN: 'dependencyRollupDropDown updated',
    UPDATED_DEPENDENCY_GROUP_DROPDOWN: 'dependencyGroupDropDown updated',
    UPDATED_DEPENDENCY_ISSUE_FILTER: 'dependencyIssueFilter updated',
    UPDATED_DEPENDENCY_PROJECT_FILTER: 'dependencyProjectFilter updated',
    UPDATED_DEPENDENCY_ISSUE_LINK_TYPE_FILTER: 'dependencyIssueLinkTypeFilter updated',
    UPDATED_DEPENDENCY_SPRINT_FILTER: 'dependencySprintFilter updated',
    CLICKED_EXPORT_TO_CSV: 'exportToCsv clicked',
    OPENED_WARNING_CENTER: 'warningCenter opened',
    FILTERED_WARNING_TYPE: 'warningAffectsLink clicked',
    LOCATED_WARNING_ISSUE_ITEM: 'warningIssueItem clicked',
    TOGGLED_WARNING_FILTER: 'warningsFilterSwitch clicked',
    TOGGLED_WARNING_TYPE: 'warningTypeToggle clicked',
    OPENED_DEPENDENCY_FLYOUT_FROM_DROPDOWN: 'dependencyFlyOut openedFromDropdown',
    OPENED_DEPENDENCY_FLYOUT_FROM_BADGE: 'dependencyFlyOut openedFromBadge',
    EXPANDED_ALL_ISSUES: 'expandAllIssues clicked',
    COLLAPSED_ALL_ISSUES: 'collapseAllIssues clicked',
    ADDED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink added',
    DELETED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink deleted',
    SWAPPED_ISSUE_DEPENDENCY_LINK: 'issueDependencyLink swapped',
    CREATED_ISSUE_FROM_HEADER: 'createIssueFromHeader clicked',
    CREATED_ISSUE_INLINE: 'createIssueInline clicked',
    OPENED_ISSUE_SUMMARY: 'issueSummary opened',
    UPDATED_ISSUE_SUMMARY: 'issueSummary updated',
    CANCELLED_ISSUE_SUMMARY: 'issueSummary cancelled',
    CLICKED_ISSUE_SUMMARY_BUTTON: 'issueSummaryButton clicked',
    CLICKED_SELECT_ISSUES: 'selectIssues clicked',
    CLICKED_CANCEL_OPTIMIZATION: 'cancelOptimization clicked',
    CLICKED_ACCEPT_OPTIMIZATION: 'acceptOptimization clicked',
    CLICKED_FULL_SCREEN_TIMELINE_BUTTON: 'fullScreenTimelineBtn clicked',
    BULK_ACTIONS_CLICKED: 'bulkActions clicked',
    BULK_ACTIONS_OPTION_SELECTED: 'bulkActions optionSelected',
    BULK_ACTIONS_ACTION_SUCCEEDED: 'bulkActions actionSucceeded',
    OPENED_SPRINT_FLYOUT: 'sprintFlyout opened',
    OPENED_RELEASES_FLYOUT: 'releasesFlyout opened',
    VIEWED_SPRINT_IN_JIRA: 'sprintInJira viewed',
    VIEWED_SPRINT_REPORT_IN_JIRA: 'sprintReportInJira viewed',
    APPLIED_SPRINT_FILER_FROM_FLYOUT: 'sprintFilterFromSprintFlyout applied',
    SPRINT_CAPACITY_EDITED: 'sprintCapacity edited',
    SPRINT_VELOCITY_CHART_VIEWED: 'velocityChartInJira viewed',
    SHARED_TEAM_ADDED: 'sharedTeam added',
    TEAM_IS_SHARED: 'team shared',
    ATLAS_TEAM_CREATED: 'atlasTeam created',
    ATLAS_TEAM_ADDED: 'atlasTeam added',
    PRIVATE_TEAM_CREATED: 'privateTeam created',
    EXPAND_TOOL_BAR: 'expandToolBar clicked',
    COLLAPSE_TOOL_BAR: 'collapseToolBar clicked',
    START_EDIT_DESCRIPTION: 'descriptionEditor activated',
    CANCEL_EDIT_DESCRIPTION: 'descriptionEditor deactivated',
    SAVE_DESCRIPTION: 'descriptionEditor saved',
    ALIGN_RELEASE_DATES_IN_CPR: 'alignDatesOfReleasesInCrossProjectRelease clicked',
    VIEW_RELEASE_IN_ROADMAP: 'viewReleaseInRoadmap clicked',
    ADD_RELEASE_TO_CPR: 'addReleaseToCrossProjectRelease clicked',
    CONFIGURABLE_DATE_CHANGED: 'configurableDate changed',
    CUSTOM_CONFIGURABLE_DATE_USED: 'customConfigurableDate used',
    NO_CUSTOM_CONFIGURABLE_DATES_USED: 'noCustomConfigurableDates used',
    FILTERED_RELEASES_TAB: 'releasesTab filtered',
    INFERRED_DATE_SELECTION_CHANGED: 'inferredDateSelection changed',
    HEADER_HELP_LINK_CLICKED: 'headerHelpLink clicked',
    SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED: 'saveSelectedChangesInJira clicked',
    DISCARD_SELECTED_CHANGES_CLICKED: 'discardSelectedChanges clicked',
    REVIEW_CHANGES_MODAL_CANCEL_CLICKED: 'cancel clicked',
    INLINE_DIALOG_VIEWED: 'inlineDialog viewed',
    REVIEW_CHANGES_MODAL_QUICK_SELECT_CLICKED: 'reviewChangesQuickSelect clicked',
    REVIEW_CHANGES_MODAL_USER_FILTER_CHANGED: 'reviewChangesUserFilter changed',
    EXPAND_SCOPE_GROUP: 'expandScopeGroup clicked',
    COLLAPSE_SCOPE_GROUP: 'collapseScopeGroup clicked',
    EXPAND_SCOPE_ITEM: 'expandScopeItem clicked',
    COLLAPSE_SCOPE_ITEM: 'collapseScopeItem clicked',
    CLOSE_UNSAVED_CHANGES_SPOTLIGHT: 'closeUnsavedChangesSpotlight clicked',
    /**
	 * With actionSubjectId
	 */ COLOR_BY_CLICKED: 'dropdownItem clicked colorBy',
    SORT_BY_CLICKED: 'dropdownItem clicked sortBy',
    GROUP_BY_CLICKED: 'dropdownItem clicked groupBy',
    SHOW_CAPACITY_ON_TIMELINE_CHANGED: 'checkbox changed showCapacityOnTimeline',
    DEPENDENCY_TYPE_CLICKED: 'dropdownItem changed dependencyStyle',
    ROLL_UP_DATES_CHANGED: 'checkbox changed rollUpDates',
    ROLL_UP_OTHERS_CHANGED: 'checkbox changed rollUpOthers',
    EXPORT_PNG_CHANGE_TIMELINE_WIDTH: 'button clicked exportPngTimelineWidth',
    EXPORT_PNG_MODAL_CLOSED: 'modal closed exportPng',
    EXPORT_CSV_MODAL_CLOSED: 'modal closed exportCsv',
    // Event Type - Track
    CALCULATE_PLAN: 'plan calculated',
    DELETE_PLAN: 'plan deleted',
    STAR_PLAN: 'plan starred',
    UNSTAR_PLAN: 'plan unstarred',
    CREATE_CROSS_PROJECT_RELEASE: 'crossProjectRelease created',
    REPARENT_ISSUE: 'issue reparented',
    UPDATE_JIRA: 'changes updatedInJira',
    ADD_ISSUE: 'issue added',
    RANK_ISSUE: 'issue ranked',
    PLAN_EXPORTED: 'plan exported',
    ADD_LABEL: 'label added',
    // Event Type - Operational
    RESET_BACKLOG: 'backlog reset',
    COMMIT_MODAL_LOADED_CHANGES: 'commitModal loadedChanges',
    COMMIT_MODAL_SCROLLED: 'commitModal scrolled',
    TIMELINE_VERTICAL_SCROLLED: 'timelineVerticalScrollPerformance measured'
};

});

parcelRegister("2tFe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00b1a80a30d4822$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kSHA0 = parcelRequire("kSHA0");

var $fuYCa = parcelRequire("fuYCa");
var $a00b1a80a30d4822$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $kSHA0.default), {})((0, $fuYCa.default));

});
parcelRegister("kSHA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff77396b136ccc0$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");
function $5ff77396b136ccc0$var$mapStateToProps(state) {
    return {
        issuesById: (0, $cwP4d.getIssueMapById)(state),
        issueTypes: (0, $lihml.getIssueTypes)(state),
        projectsById: (0, $ehEr2.getProjectsById)(state)
    };
}
var $5ff77396b136ccc0$export$2e2bcd8739ae039 = $5ff77396b136ccc0$var$mapStateToProps;

});

parcelRegister("fuYCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4351b8a0edc2e7e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $gwbfD = parcelRequire("gwbfD");

var $40hi6 = parcelRequire("40hi6");

var $8RAUa = parcelRequire("8RAUa");

var $64VaH = parcelRequire("64VaH");

var $7CnHa = parcelRequire("7CnHa");

var $acozJ = parcelRequire("acozJ");
const $e4351b8a0edc2e7e$var$NoUrlCrumb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ className: className, children: children }, ref)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        className: className,
        style: {
            cursor: 'default'
        }
    }, children));
function $e4351b8a0edc2e7e$var$IssueBreadcrumbs({ issue: issue, issuesById: issuesById, projectsById: projectsById, issueTypes: issueTypes }) {
    const issueType = issueTypes.find((type)=>type.id === issue.type) || (0, $8RAUa.DEFAULT_SCRATCH_ISSUE_TYPE);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getBreadcrumbProps = (issue)=>{
        const projectKey = projectsById[issue.project].key;
        const issueKey = (0, $7CnHa.isDefined)(issue.issueKey) ? `${projectKey}-${issue.issueKey}` : projectKey;
        const hasUrl = issueKey !== projectKey;
        const url = (0, $64VaH.proxyContextSafeUrl)(`/browse/${issueKey}`);
        const props = {
            href: hasUrl ? url : '',
            target: '_blank',
            text: issueKey
        };
        if (!hasUrl) props.component = $e4351b8a0edc2e7e$var$NoUrlCrumb;
        return props;
    };
    const ancestorsOfIssue = (0, $40hi6.getAncestorsOfIssue)(issue, issuesById);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), {
        maxItems: 5
    }, ancestorsOfIssue.length > 0 && // eslint-disable-next-line @typescript-eslint/no-shadow
    ancestorsOfIssue.reverse().map((issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `crumb-${projectsById[issue.project].key}-${issue?.issueKey || issue.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $acozJ.breadCrumbItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: issue?.summary || null,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), getBreadcrumbProps(issue))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        ...getBreadcrumbProps(issue),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $acozJ["issue-icon"],
            style: {
                backgroundImage: `url(${issueType.iconUrl})`
            }
        })
    }));
}
var $e4351b8a0edc2e7e$export$2e2bcd8739ae039 = $e4351b8a0edc2e7e$var$IssueBreadcrumbs;

});
parcelRegister("acozJ", function(module, exports) {

$parcel$export(module.exports, "breadCrumbItem", () => $76ce1688c7e3f0fd$export$9478590597717b26, (v) => $76ce1688c7e3f0fd$export$9478590597717b26 = v);
$parcel$export(module.exports, "issue-icon", () => $76ce1688c7e3f0fd$export$39bed5d6a23c78de, (v) => $76ce1688c7e3f0fd$export$39bed5d6a23c78de = v);
var $76ce1688c7e3f0fd$export$9478590597717b26;
var $76ce1688c7e3f0fd$export$39bed5d6a23c78de;
$76ce1688c7e3f0fd$export$9478590597717b26 = `dAFjAq_breadCrumbItem`;
$76ce1688c7e3f0fd$export$39bed5d6a23c78de = `dAFjAq_issue-icon`;

});



parcelRegister("h5Clq", function(module, exports) {

$parcel$export(module.exports, "default", () => $650d3e942631f9e5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $650d3e942631f9e5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blankSummaryInputErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.blank-summary-input-error-message",
        "defaultMessage": "You must specify a summary of the issue."
    },
    invalidSummaryInput: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.invalid-summary-input",
        "defaultMessage": "Summary must be less than 256 characters."
    },
    summaryPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.summary-placeholder",
        "defaultMessage": "Issue summary ..."
    },
    descriptionLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description-label",
        "defaultMessage": "Description"
    },
    noDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.no-description",
        "defaultMessage": "Add a description..."
    },
    noDescriptionReadOnlyMode: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.no-description-read-only-mode",
        "defaultMessage": "No description"
    },
    descriptionParsingError: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-modal.description-parsing-error",
        "defaultMessage": "There was an error loading the description for this issue."
    }
});

});

parcelRegister("8vhw8", function(module, exports) {

$parcel$export(module.exports, "breadcrumbs", () => $630ece8eee22a19c$export$515d2155aaad79e4, (v) => $630ece8eee22a19c$export$515d2155aaad79e4 = v);
$parcel$export(module.exports, "description", () => $630ece8eee22a19c$export$6d59db4903f20f7d, (v) => $630ece8eee22a19c$export$6d59db4903f20f7d = v);
$parcel$export(module.exports, "descriptionLabel", () => $630ece8eee22a19c$export$7de3eff20b335ee9, (v) => $630ece8eee22a19c$export$7de3eff20b335ee9 = v);
$parcel$export(module.exports, "descriptionLabelInner", () => $630ece8eee22a19c$export$4ec4cd5bccf215f2, (v) => $630ece8eee22a19c$export$4ec4cd5bccf215f2 = v);
$parcel$export(module.exports, "descriptionSpinner", () => $630ece8eee22a19c$export$8fe2c617c69b145c, (v) => $630ece8eee22a19c$export$8fe2c617c69b145c = v);
$parcel$export(module.exports, "hiddenButton", () => $630ece8eee22a19c$export$3f4a1c21e2e27d37, (v) => $630ece8eee22a19c$export$3f4a1c21e2e27d37 = v);
$parcel$export(module.exports, "modalHeader", () => $630ece8eee22a19c$export$3099d0daead893d3, (v) => $630ece8eee22a19c$export$3099d0daead893d3 = v);
$parcel$export(module.exports, "summary", () => $630ece8eee22a19c$export$9a2dbef7a17e2e58, (v) => $630ece8eee22a19c$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "summaryBeingEdited", () => $630ece8eee22a19c$export$1b38869ff17953e6, (v) => $630ece8eee22a19c$export$1b38869ff17953e6 = v);
$parcel$export(module.exports, "summaryReadView", () => $630ece8eee22a19c$export$10ac4ca9f19e16f5, (v) => $630ece8eee22a19c$export$10ac4ca9f19e16f5 = v);
var $630ece8eee22a19c$export$515d2155aaad79e4;
var $630ece8eee22a19c$export$6d59db4903f20f7d;
var $630ece8eee22a19c$export$7de3eff20b335ee9;
var $630ece8eee22a19c$export$4ec4cd5bccf215f2;
var $630ece8eee22a19c$export$8fe2c617c69b145c;
var $630ece8eee22a19c$export$3f4a1c21e2e27d37;
var $630ece8eee22a19c$export$3099d0daead893d3;
var $630ece8eee22a19c$export$9a2dbef7a17e2e58;
var $630ece8eee22a19c$export$1b38869ff17953e6;
var $630ece8eee22a19c$export$10ac4ca9f19e16f5;
$630ece8eee22a19c$export$515d2155aaad79e4 = `-8IA7a_breadcrumbs`;
$630ece8eee22a19c$export$6d59db4903f20f7d = `-8IA7a_description`;
$630ece8eee22a19c$export$7de3eff20b335ee9 = `-8IA7a_descriptionLabel`;
$630ece8eee22a19c$export$4ec4cd5bccf215f2 = `-8IA7a_descriptionLabelInner`;
$630ece8eee22a19c$export$8fe2c617c69b145c = `-8IA7a_descriptionSpinner`;
$630ece8eee22a19c$export$3f4a1c21e2e27d37 = `-8IA7a_hiddenButton`;
$630ece8eee22a19c$export$3099d0daead893d3 = `-8IA7a_modalHeader`;
$630ece8eee22a19c$export$9a2dbef7a17e2e58 = `-8IA7a_summary`;
$630ece8eee22a19c$export$1b38869ff17953e6 = `-8IA7a_summaryBeingEdited`;
$630ece8eee22a19c$export$10ac4ca9f19e16f5 = `-8IA7a_summaryReadView`;

});

parcelRegister("hcWZo", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("5BVCQ")),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('faYsE')
        ]);
        const value = parcelRequire('3fz0F');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("5BVCQ")),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("faYsE")
    ]).then(()=>parcelRequire('3fz0F'));
}

});



parcelRegister("a4FqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef88e7b87780e0aa$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6j2Es = parcelRequire("6j2Es");

var $3z6Ad = parcelRequire("3z6Ad");
var $ef88e7b87780e0aa$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6j2Es.mapStateToProps), (0, $6j2Es.mapDispatchToProps), (0, $6j2Es.mergeProps))((0, $3z6Ad.default));

});
parcelRegister("6j2Es", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $0d137849f0db5fa2$export$c31df4bd766f9c35);
$parcel$export(module.exports, "mapDispatchToProps", () => $0d137849f0db5fa2$export$9e6a17cf56877796);
$parcel$export(module.exports, "mergeProps", () => $0d137849f0db5fa2$export$9d1611c77c2fe928);

var $5iWql = parcelRequire("5iWql");

var $cQGVO = parcelRequire("cQGVO");
var $cQwal = parcelRequire("cQwal");
var $kjklK = parcelRequire("kjklK");
var $186Kt = parcelRequire("186Kt");

var $hLlYV = parcelRequire("hLlYV");

var $75KhQ = parcelRequire("75KhQ");
parcelRequire("6OvfP");
var $eOsHk = parcelRequire("eOsHk");

var $iK4oF = parcelRequire("iK4oF");

var $1TrR5 = parcelRequire("1TrR5");
const $0d137849f0db5fa2$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    dateConfiguration: (0, $75KhQ.getDateConfiguration)
});
const $0d137849f0db5fa2$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $0d137849f0db5fa2$var$dateFieldNeedsUpdate = (dateField)=>{
    const warning = $kjklK.default([
        'warning',
        'code'
    ], dateField);
    if (!warning) return false;
    return Object.values((0, $eOsHk.DATEFIELD_WARNINGS)).includes(warning);
};
const $0d137849f0db5fa2$var$mergePropsOld = (stateProps, dispatchProps)=>{
    const { dispatch: dispatch } = dispatchProps;
    const { dateConfiguration: dateConfiguration } = stateProps;
    const handleKeepUsingTargetDates = ()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        const payload = $cQGVO.default($cQwal.default([
            'warning'
        ]), $186Kt.default($0d137849f0db5fa2$var$dateFieldNeedsUpdate, dateConfiguration));
        dispatch((0, $hLlYV.updatePlan)(payload));
    };
    return {
        handleKeepUsingTargetDates: handleKeepUsingTargetDates,
        ...stateProps
    };
};
const $0d137849f0db5fa2$var$handleKeepUsingTargetDatesFactory = (0, $5iWql.default)((dateConfiguration, dispatch)=>()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        const payload = $cQGVO.default($cQwal.default([
            'warning'
        ]), $186Kt.default($0d137849f0db5fa2$var$dateFieldNeedsUpdate, dateConfiguration));
        dispatch((0, $hLlYV.updatePlan)(payload));
    });
const $0d137849f0db5fa2$var$mergePropsNew = (stateProps, dispatchProps)=>{
    const { dispatch: dispatch } = dispatchProps;
    const { dateConfiguration: dateConfiguration } = stateProps;
    return {
        handleKeepUsingTargetDates: $0d137849f0db5fa2$var$handleKeepUsingTargetDatesFactory(dateConfiguration, dispatch),
        ...stateProps
    };
};
const $0d137849f0db5fa2$export$9d1611c77c2fe928 = (0, $1TrR5.functionWithFFRedux)($0d137849f0db5fa2$var$mergePropsNew, $0d137849f0db5fa2$var$mergePropsOld);

});
parcelRegister("186Kt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2bc5e7e6e670e1$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $0d2bc5e7e6e670e1$var$pickBy = /*#__PURE__*/ (0, $ggdJA.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $0d2bc5e7e6e670e1$export$2e2bcd8739ae039 = $0d2bc5e7e6e670e1$var$pickBy;

});

parcelRegister("hLlYV", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PLAN", () => $9bf0f447148406b7$export$20cc563653555d6e);
$parcel$export(module.exports, "updateIncludeCompletedIssuesForDays", () => $9bf0f447148406b7$export$14b5ae4431410e37);
$parcel$export(module.exports, "deletePlan", () => $9bf0f447148406b7$export$947e41df5a20fab3);
$parcel$export(module.exports, "updatePlan", () => $9bf0f447148406b7$export$6246b08e191feb20);
$parcel$export(module.exports, "getPlanInfo", () => $9bf0f447148406b7$export$bf5dcfa60204106b);
$parcel$export(module.exports, "default", () => $9bf0f447148406b7$export$2e2bcd8739ae039);

var $l0L3x = parcelRequire("l0L3x");
var $01zCq = parcelRequire("01zCq");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $1jM5j = parcelRequire("1jM5j");

var $cbq3D = parcelRequire("cbq3D");

var $dr8sv = parcelRequire("dr8sv");

var $48HOG = parcelRequire("48HOG");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $indSC = parcelRequire("indSC");

var $lFLge = parcelRequire("lFLge");

var $gOwfg = parcelRequire("gOwfg");
const $9bf0f447148406b7$var$DELETE_PLAN = 'command.plan.DELETE_PLAN';
const $9bf0f447148406b7$export$20cc563653555d6e = 'command.plan.UPDATE_PLAN';
const $9bf0f447148406b7$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS = 'command.plan.UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS';
const $9bf0f447148406b7$export$14b5ae4431410e37 = (payload)=>({
        type: $9bf0f447148406b7$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS,
        payload: payload
    });
const $9bf0f447148406b7$export$947e41df5a20fab3 = ()=>({
        type: $9bf0f447148406b7$var$DELETE_PLAN,
        payload: {}
    });
const $9bf0f447148406b7$export$6246b08e191feb20 = (payload, onComplete)=>({
        type: $9bf0f447148406b7$export$20cc563653555d6e,
        payload: payload,
        onComplete: onComplete
    });
function* $9bf0f447148406b7$export$d96ee885e1ac10be({ payload: payload, onComplete: onComplete }) {
    const { domain: { plan: { id: id, autoScheduleConfiguration: autoScheduleConfiguration } } } = yield (0, $9e8i2.select)($l0L3x.default);
    if (!id) throw new Error('No plan to update');
    let updatePayload = payload;
    if ((0, $7CnHa.isDefined)(updatePayload.autoScheduleConfiguration)) updatePayload = $01zCq.default(updatePayload, {
        autoScheduleConfiguration: $01zCq.default(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        autoScheduleConfiguration, updatePayload.autoScheduleConfiguration)
    });
    yield (0, $9e8i2.put)((0, $dr8sv.update)(updatePayload));
    try {
        const url = (0, $gOwfg.urls).update(id);
        const body = (0, $gOwfg.transformUpdatePayload)(updatePayload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        if (onComplete) onComplete();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $9bf0f447148406b7$export$90daf630220ca848({ payload: payload }) {
    try {
        const { domain: { plan: { id: id } } } = yield (0, $9e8i2.select)($l0L3x.default);
        if (id == null) return;
        // Need to upload autoSchedulerEnabled seperately, different api...
        const body = {
            planId: id,
            enabled: payload.autoSchedulerEnabled
        };
        const res = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $gOwfg.urls).toggleAutoSchedule(), {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!res.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(res, (yield (0, $9e8i2.call)(res.text.bind(res)))),
            requestInfo: {
                url: (0, $gOwfg.urls).toggleAutoSchedule(),
                type: (0, $kP3Wn.POST),
                status: res.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: err.message,
            stackTrace: err.stack
        }));
    }
}
function* $9bf0f447148406b7$export$c09da2867831af5() {
    const { domain: { app: { browserHistory: browserHistory }, plan: { id: id } } } = yield (0, $9e8i2.select)($l0L3x.default);
    if (!id) throw new Error('No plan to delete');
    try {
        yield (0, $9e8i2.put)({
            type: (0, $48HOG.DISABLE_DELETE)
        });
        const url = (0, $gOwfg.urls).delete(id);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.DELETE)
        });
        if (response.ok) {
            if ((0, $7CnHa.isDefined)(browserHistory)) yield (0, $9e8i2.call)(browserHistory.push, (0, $indSC.default).managePortfolio);
            else yield (0, $9e8i2.call)((0, $lFLge.redirect), (0, $indSC.default).jiraHome);
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.DELETE),
                status: response.status,
                body: {}
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)({
            type: (0, $48HOG.ENABLE_DELETE)
        });
    }
}
function* $9bf0f447148406b7$var$doUpdateIncludeCompletedIssuesForDays({ payload: { days: days } }) {
    yield (0, $9e8i2.call)($9bf0f447148406b7$export$d96ee885e1ac10be, {
        payload: {
            includeCompletedIssuesFor: days
        }
    });
    yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
}
function* $9bf0f447148406b7$export$bf5dcfa60204106b() {
    const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    // Cancel if there is no plan Id, or scenario Id, this can happen when the chain of sagas are still running but the app has already navigated away from the page
    if (id == null || !currentScenarioId) return;
    try {
        const url = (0, $gOwfg.urls).get(id, currentScenarioId);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.GET)
        });
        if (response.ok) return yield (0, $9e8i2.call)(response.json.bind(response));
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: {}
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $9bf0f447148406b7$export$3097d32aa598c8e2() {
    yield (0, $bG7pV.takeEvery)($9bf0f447148406b7$var$DELETE_PLAN, $9bf0f447148406b7$export$c09da2867831af5);
}
function* $9bf0f447148406b7$export$3cf225935bd15c51() {
    yield (0, $bG7pV.takeEvery)($9bf0f447148406b7$export$20cc563653555d6e, $9bf0f447148406b7$export$d96ee885e1ac10be);
}
function* $9bf0f447148406b7$export$99bfa39e154b395e() {
    yield (0, $bG7pV.takeEvery)((0, $dr8sv.UPDATE_AUTO_SCHEDULER_ENABLED), $9bf0f447148406b7$export$90daf630220ca848);
}
function* $9bf0f447148406b7$export$e09672252ff2cf70() {
    yield (0, $bG7pV.takeEvery)($9bf0f447148406b7$var$UPDATE_INCLUDED_COMPLETED_ISSUES_FOR_DAYS, $9bf0f447148406b7$var$doUpdateIncludeCompletedIssuesForDays);
}
function* $9bf0f447148406b7$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($9bf0f447148406b7$export$3097d32aa598c8e2);
    yield (0, $9e8i2.fork)($9bf0f447148406b7$export$3cf225935bd15c51);
    yield (0, $9e8i2.fork)($9bf0f447148406b7$export$e09672252ff2cf70);
    yield (0, $9e8i2.fork)($9bf0f447148406b7$export$99bfa39e154b395e);
}

});
parcelRegister("1jM5j", function(module, exports) {

$parcel$export(module.exports, "getBacklog", () => $0710336b5e704a08$export$78352065150b1467);
$parcel$export(module.exports, "fetchBacklog", () => $0710336b5e704a08$export$ea50bb28c5c1891c);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $AKDZl = parcelRequire("AKDZl");

var $1ybV0 = parcelRequire("1ybV0");

var $dYnI4 = parcelRequire("dYnI4");

var $j3szT = parcelRequire("j3szT");

var $kP3Wn = parcelRequire("kP3Wn");

var $kXdPE = parcelRequire("kXdPE");

var $cbq3D = parcelRequire("cbq3D");

var $051m9 = parcelRequire("051m9");

var $dC8ep = parcelRequire("dC8ep");

var $fr1nu = parcelRequire("fr1nu");


var $aF7eA = parcelRequire("aF7eA");

var $8RAUa = parcelRequire("8RAUa");

var $5rVFi = parcelRequire("5rVFi");

var $jpccz = parcelRequire("jpccz");
const $0710336b5e704a08$var$defaultHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $0710336b5e704a08$var$arjBacklogClient = new (0, $AKDZl.AdvancedRoadmapsBacklogApi)();
function* $0710336b5e704a08$export$78352065150b1467(isInitialLoad = false) {
    try {
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId, includeCompletedIssuesFor: includeCompletedIssuesFor } } } = yield (0, $9e8i2.select)($l0L3x.default);
        const url = (0, $jpccz.urls).backlog;
        let response;
        let body;
        const preloadedRequest = window.jpoPreloadedRequests && window.jpoPreloadedRequests.backlog;
        if (isInitialLoad && preloadedRequest) {
            body = preloadedRequest.request.body;
            response = yield preloadedRequest.request;
            delete window.jpoPreloadedRequests.backlog;
        } else {
            body = yield (0, $9e8i2.call)((0, $jpccz.backlogBody), {
                id: id,
                currentScenarioId: currentScenarioId,
                includeCompletedIssuesFor: includeCompletedIssuesFor
            });
            response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
                method: (0, $kP3Wn.POST),
                body: body,
                profile: url
            });
        }
        if (response.ok) yield* (0, $kXdPE.default)(function*() {
            const backlog = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.put)((0, $fr1nu.resetBacklog)(backlog));
            const teams = backlog.teams?.map((0, $8RAUa.prepareTeam)) ?? [];
            yield (0, $9e8i2.put)((0, $aF7eA.setAdditionalTeams)(teams));
            yield (0, $9e8i2.put)((0, $fr1nu.afterResetBacklog)());
            yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
            yield (0, $9e8i2.put)((0, $051m9.calculateStatusOfAllReleases)());
        });
        else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $0710336b5e704a08$var$fetchBacklogUrl(url, planId, scenarioId, isInitialLoad, marks, headers = $0710336b5e704a08$var$defaultHeaders) {
    const earlyPreloadBacklogPromise = window.__ARJ_BACKLOG_PROMISE__;
    delete window.__ARJ_BACKLOG_PROMISE__;
    if (isInitialLoad && earlyPreloadBacklogPromise) {
        const response = yield earlyPreloadBacklogPromise;
        /**
		 * Recording the performance information of the API before returning
		 * the response.
		 */ const start = Math.floor((0, $j3szT.extractStartTime)(marks.startMark));
        const end = Math.ceil((0, $j3szT.extractStartTime)(marks.endMark));
        (0, $dYnI4.monitor).recordCustomProfile(url, {
            start: start,
            end: end
        });
        return response;
    }
    const body = yield (0, $9e8i2.call)((0, $jpccz.backlogBody), {
        id: planId,
        currentScenarioId: scenarioId
    });
    return yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
        method: (0, $kP3Wn.POST),
        body: body,
        profile: url,
        headers: headers
    });
}
function* $0710336b5e704a08$var$fetchBacklogUrlOpenApi(planId, scenarioId, isInitialLoad, marks) {
    const earlyPreloadBacklogPromise = window.__ARJ_BACKLOG_PROMISE__;
    delete window.__ARJ_BACKLOG_PROMISE__;
    if (isInitialLoad && earlyPreloadBacklogPromise) {
        const response = yield earlyPreloadBacklogPromise;
        /**
		 * Recording the performance information of the API before returning
		 * the response.
		 */ const start = Math.floor((0, $j3szT.extractStartTime)(marks.startMark));
        const end = Math.ceil((0, $j3szT.extractStartTime)(marks.endMark));
        (0, $dYnI4.monitor).recordCustomProfile('/rest/jpo/2.0/backlog', {
            start: start,
            end: end
        });
        return response;
    }
    const requestBody = yield (0, $9e8i2.call)((0, $jpccz.backlogBody), {
        id: planId,
        currentScenarioId: scenarioId
    });
    return yield (0, $9e8i2.call)($0710336b5e704a08$var$arjBacklogClient.getRaw.bind($0710336b5e704a08$var$arjBacklogClient), {
        backlogRequest: requestBody
    });
}
function* $0710336b5e704a08$export$ea50bb28c5c1891c(isInitialLoad = false, planId, scenarioId, mode) {
    if ((0, $1ybV0.ff)('use-openapi-generated-server-stub-and-the-client_p7a4d')) {
        if (mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7)) return yield* $0710336b5e704a08$var$fetchBacklogUrl((0, $jpccz.urls).backlog20, planId, scenarioId, isInitialLoad, {
            startMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:start`,
            endMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:end`
        });
        return yield* $0710336b5e704a08$var$fetchBacklogUrlOpenApi(planId, scenarioId, isInitialLoad, {
            startMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:start`,
            endMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:end`
        });
    }
    return yield* $0710336b5e704a08$var$fetchBacklogUrl((0, $jpccz.urls).backlog, planId, scenarioId, isInitialLoad, {
        startMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:start`,
        endMark: `${(0, $dYnI4.ARJ_EARLY_PRELOAD_PREFIX)}.backlog:end`
    });
}

});
parcelRegister("AKDZl", function(module, exports) {

$parcel$export(module.exports, "AdvancedRoadmapsBacklogApi", () => $06e78b6dd6b6b294$export$af6a1bcb815b1cf4);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");

var $dAeTg = parcelRequire("dAeTg");
var $azk0n = parcelRequire("azk0n");
var $hsPmG = parcelRequire("hsPmG");
var $06e78b6dd6b6b294$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $06e78b6dd6b6b294$export$af6a1bcb815b1cf4 extends $3Soqo.BaseAPI {
    /**
     * Get the backlog data
     */ getRaw(requestParameters, initOverrides) {
        return $06e78b6dd6b6b294$var$__awaiter(this, void 0, void 0, function*() {
            if (requestParameters.backlogRequest === null || requestParameters.backlogRequest === undefined) throw new $3Soqo.RequiredError('backlogRequest', 'Required parameter requestParameters.backlogRequest was null or undefined when calling get.');
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/2.0/backlog`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, $dAeTg.BacklogRequestToJSON)(requestParameters.backlogRequest)
            }, initOverrides);
            return new $3Soqo.JSONApiResponse(response, (jsonValue)=>(0, $azk0n.BacklogResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the backlog data
     */ get(requestParameters, initOverrides) {
        return $06e78b6dd6b6b294$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.getRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the partitioned backlog data
     */ getPartitionedRaw(requestParameters, initOverrides) {
        return $06e78b6dd6b6b294$var$__awaiter(this, void 0, void 0, function*() {
            if (requestParameters.backlogRequest === null || requestParameters.backlogRequest === undefined) throw new $3Soqo.RequiredError('backlogRequest', 'Required parameter requestParameters.backlogRequest was null or undefined when calling getPartitioned.');
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/2.0/backlog/partitioned`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, $dAeTg.BacklogRequestToJSON)(requestParameters.backlogRequest)
            }, initOverrides);
            return new $3Soqo.JSONApiResponse(response, (jsonValue)=>(0, $hsPmG.PartitionedBacklogResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get the partitioned backlog data
     */ getPartitioned(requestParameters, initOverrides) {
        return $06e78b6dd6b6b294$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.getPartitionedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}

});
parcelRegister("3Soqo", function(module, exports) {

$parcel$export(module.exports, "BaseAPI", () => $2d295c7afc3eca86$export$70edad7ad5bb3f5d);
$parcel$export(module.exports, "RequiredError", () => $2d295c7afc3eca86$export$a27bea7cdb975d70);
$parcel$export(module.exports, "exists", () => $2d295c7afc3eca86$export$f7e9f41ea797a17);
$parcel$export(module.exports, "JSONApiResponse", () => $2d295c7afc3eca86$export$9a41a2c2c33dd8d4);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var $2d295c7afc3eca86$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2d295c7afc3eca86$export$2812a1fb15aca49c = "/rest/jpo".replace(/\/+$/, "");
class $2d295c7afc3eca86$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $2d295c7afc3eca86$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $2d295c7afc3eca86$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : ()=>$2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
                return accessToken;
            });
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $2d295c7afc3eca86$export$ac4f8128ea29c5 = new $2d295c7afc3eca86$export$fa89be98fe0936f2();
class $2d295c7afc3eca86$export$70edad7ad5bb3f5d {
    constructor(configuration = $2d295c7afc3eca86$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = (url, init)=>$2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
                let fetchParams = {
                    url: url,
                    init: init
                };
                for (const middleware of this.middleware)if (middleware.pre) fetchParams = (yield middleware.pre(Object.assign({
                    fetch: this.fetchApi
                }, fetchParams))) || fetchParams;
                let response = undefined;
                try {
                    response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
                } catch (e) {
                    for (const middleware of this.middleware)if (middleware.onError) response = (yield middleware.onError({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        error: e,
                        response: response ? response.clone() : undefined
                    })) || response;
                    if (response === undefined) {
                        if (e instanceof Error) throw new $2d295c7afc3eca86$export$26e841bcf1aeb894(e, 'The request failed and the interceptors did not return an alternative response');
                        else throw e;
                    }
                }
                for (const middleware of this.middleware)if (middleware.post) response = (yield middleware.post({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    response: response.clone()
                })) || response;
                return response;
            });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $2d295c7afc3eca86$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    request(context, initOverrides) {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            const { url: url, init: init } = yield this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response && response.status >= 200 && response.status < 300) return response;
            throw new $2d295c7afc3eca86$export$286baf652d0b1206(response, 'Response returned an error code');
        });
    }
    createFetchParams(context, initOverrides) {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            let url = this.configuration.basePath + context.path;
            if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
            const headers = Object.assign({}, this.configuration.headers, context.headers);
            Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
            const initOverrideFn = typeof initOverrides === "function" ? initOverrides : ()=>$2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
                    return initOverrides;
                });
            const initParams = {
                method: context.method,
                headers: headers,
                body: context.body,
                credentials: this.configuration.credentials
            };
            const overriddenInit = Object.assign(Object.assign({}, initParams), (yield initOverrideFn({
                init: initParams,
                context: context
            })));
            let body;
            if ($2d295c7afc3eca86$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $2d295c7afc3eca86$var$isBlob(overriddenInit.body)) body = overriddenInit.body;
            else if (this.isJsonMime(headers['Content-Type'])) body = JSON.stringify(overriddenInit.body);
            else body = overriddenInit.body;
            const init = Object.assign(Object.assign({}, overriddenInit), {
                body: body
            });
            return {
                url: url,
                init: init
            };
        });
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
$2d295c7afc3eca86$export$70edad7ad5bb3f5d.jsonRegex = new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i');
function $2d295c7afc3eca86$var$isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
function $2d295c7afc3eca86$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $2d295c7afc3eca86$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $2d295c7afc3eca86$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $2d295c7afc3eca86$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $2d295c7afc3eca86$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
function $2d295c7afc3eca86$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $2d295c7afc3eca86$export$ac4103b836844853(params, prefix = '') {
    return Object.keys(params).map((key)=>$2d295c7afc3eca86$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join('&');
}
function $2d295c7afc3eca86$var$querystringSingleKey(key, value, keyPrefix = '') {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $2d295c7afc3eca86$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $2d295c7afc3eca86$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $2d295c7afc3eca86$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>Object.assign(Object.assign({}, acc), {
            [key]: fn(data[key])
        }), {});
}
function $2d295c7afc3eca86$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class $2d295c7afc3eca86$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            return this.transformer((yield this.raw.json()));
        });
    }
}
class $2d295c7afc3eca86$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            return undefined;
        });
    }
}
class $2d295c7afc3eca86$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.raw.blob();
        });
    }
}
class $2d295c7afc3eca86$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    value() {
        return $2d295c7afc3eca86$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.raw.text();
        });
    }
}

});

parcelRegister("dAeTg", function(module, exports) {

$parcel$export(module.exports, "BacklogRequestToJSON", () => $9e3a30100c34460d$export$e8b1c101a4162151);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");

var $7MHmE = parcelRequire("7MHmE");

var $91ZkE = parcelRequire("91ZkE");
function $9e3a30100c34460d$export$4be084cb2cb2bfcc(value) {
    let isInstance = true;
    return isInstance;
}
function $9e3a30100c34460d$export$a2ff44cde78f0ee2(json) {
    return $9e3a30100c34460d$export$14e2004a27753081(json, false);
}
function $9e3a30100c34460d$export$14e2004a27753081(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'filter': !(0, $3Soqo.exists)(json, 'filter') ? undefined : (0, $7MHmE.IssueFilterFromJSON)(json['filter']),
        'planId': !(0, $3Soqo.exists)(json, 'planId') ? undefined : json['planId'],
        'scenarioId': !(0, $3Soqo.exists)(json, 'scenarioId') ? undefined : json['scenarioId'],
        'supportingDataOptions': !(0, $3Soqo.exists)(json, 'supportingDataOptions') ? undefined : (0, $91ZkE.SupportingDataOptionsFromJSON)(json['supportingDataOptions']),
        'refreshCache': !(0, $3Soqo.exists)(json, 'refreshCache') ? undefined : json['refreshCache']
    };
}
function $9e3a30100c34460d$export$e8b1c101a4162151(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'filter': (0, $7MHmE.IssueFilterToJSON)(value.filter),
        'planId': value.planId,
        'scenarioId': value.scenarioId,
        'supportingDataOptions': (0, $91ZkE.SupportingDataOptionsToJSON)(value.supportingDataOptions),
        'refreshCache': value.refreshCache
    };
}

});
parcelRegister("7MHmE", function(module, exports) {

$parcel$export(module.exports, "IssueFilterFromJSON", () => $5aaea75800d66be5$export$1bdbaa89c9fd493f);
$parcel$export(module.exports, "IssueFilterToJSON", () => $5aaea75800d66be5$export$a275ae20f91002d7);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");
function $5aaea75800d66be5$export$5cf6fe96fdcc81a7(value) {
    let isInstance = true;
    return isInstance;
}
function $5aaea75800d66be5$export$1bdbaa89c9fd493f(json) {
    return $5aaea75800d66be5$export$f824312aabe8f46f(json, false);
}
function $5aaea75800d66be5$export$f824312aabe8f46f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'includeCompleted': !(0, $3Soqo.exists)(json, 'includeCompleted') ? undefined : json['includeCompleted'],
        'includeExcluded': !(0, $3Soqo.exists)(json, 'includeExcluded') ? undefined : json['includeExcluded'],
        'scenarioOnly': !(0, $3Soqo.exists)(json, 'scenarioOnly') ? undefined : json['scenarioOnly'],
        'excludeCalculation': !(0, $3Soqo.exists)(json, 'excludeCalculation') ? undefined : json['excludeCalculation'],
        'performParentCompletion': !(0, $3Soqo.exists)(json, 'performParentCompletion') ? undefined : json['performParentCompletion'],
        'includeCompletedActiveSprints': !(0, $3Soqo.exists)(json, 'includeCompletedActiveSprints') ? undefined : json['includeCompletedActiveSprints'],
        'includeSupportingData': !(0, $3Soqo.exists)(json, 'includeSupportingData') ? undefined : json['includeSupportingData'],
        'includeIssueLinks': !(0, $3Soqo.exists)(json, 'includeIssueLinks') ? undefined : json['includeIssueLinks'],
        'includeCompletedSince': !(0, $3Soqo.exists)(json, 'includeCompletedSince') ? undefined : json['includeCompletedSince'],
        'issueSources': !(0, $3Soqo.exists)(json, 'issueSources') ? undefined : json['issueSources'],
        'excludedIssueTypeIds': !(0, $3Soqo.exists)(json, 'excludedIssueTypeIds') ? undefined : json['excludedIssueTypeIds'],
        'excludedIssueTypeNames': !(0, $3Soqo.exists)(json, 'excludedIssueTypeNames') ? undefined : json['excludedIssueTypeNames'],
        'excludedStatusIds': !(0, $3Soqo.exists)(json, 'excludedStatusIds') ? undefined : json['excludedStatusIds'],
        'excludedStatusCategoryIds': !(0, $3Soqo.exists)(json, 'excludedStatusCategoryIds') ? undefined : json['excludedStatusCategoryIds'],
        'itemKeys': !(0, $3Soqo.exists)(json, 'itemKeys') ? undefined : json['itemKeys'],
        'limit': !(0, $3Soqo.exists)(json, 'limit') ? undefined : json['limit'],
        'projects': !(0, $3Soqo.exists)(json, 'projects') ? undefined : json['projects']
    };
}
function $5aaea75800d66be5$export$a275ae20f91002d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'includeCompleted': value.includeCompleted,
        'includeExcluded': value.includeExcluded,
        'scenarioOnly': value.scenarioOnly,
        'excludeCalculation': value.excludeCalculation,
        'performParentCompletion': value.performParentCompletion,
        'includeCompletedActiveSprints': value.includeCompletedActiveSprints,
        'includeSupportingData': value.includeSupportingData,
        'includeIssueLinks': value.includeIssueLinks,
        'includeCompletedSince': value.includeCompletedSince,
        'issueSources': value.issueSources,
        'excludedIssueTypeIds': value.excludedIssueTypeIds,
        'excludedIssueTypeNames': value.excludedIssueTypeNames,
        'excludedStatusIds': value.excludedStatusIds,
        'excludedStatusCategoryIds': value.excludedStatusCategoryIds,
        'itemKeys': value.itemKeys === undefined ? undefined : Array.from(value.itemKeys),
        'limit': value.limit,
        'projects': value.projects
    };
}

});

parcelRegister("91ZkE", function(module, exports) {

$parcel$export(module.exports, "SupportingDataOptionsFromJSON", () => $6933c85586333a10$export$6f7265532bc04dc);
$parcel$export(module.exports, "SupportingDataOptionsToJSON", () => $6933c85586333a10$export$f947ba8e4600db47);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");
function $6933c85586333a10$export$51be35f9b2f2538a(value) {
    let isInstance = true;
    return isInstance;
}
function $6933c85586333a10$export$6f7265532bc04dc(json) {
    return $6933c85586333a10$export$7f45e9618821d15d(json, false);
}
function $6933c85586333a10$export$7f45e9618821d15d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'assignees': !(0, $3Soqo.exists)(json, 'assignees') ? undefined : json['assignees'],
        'reporters': !(0, $3Soqo.exists)(json, 'reporters') ? undefined : json['reporters'],
        'externalTeams': !(0, $3Soqo.exists)(json, 'externalTeams') ? undefined : json['externalTeams'],
        'sprints': !(0, $3Soqo.exists)(json, 'sprints') ? undefined : json['sprints'],
        'rollups': !(0, $3Soqo.exists)(json, 'rollups') ? undefined : json['rollups']
    };
}
function $6933c85586333a10$export$f947ba8e4600db47(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'assignees': value.assignees,
        'reporters': value.reporters,
        'externalTeams': value.externalTeams,
        'sprints': value.sprints,
        'rollups': value.rollups
    };
}

});


parcelRegister("azk0n", function(module, exports) {

$parcel$export(module.exports, "BacklogResponseFromJSON", () => $7b1cb0d8b63f8681$export$27a7e707b7142c2c);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");
function $7b1cb0d8b63f8681$export$6bd91bb91ecd1d1(value) {
    let isInstance = true;
    return isInstance;
}
function $7b1cb0d8b63f8681$export$27a7e707b7142c2c(json) {
    return $7b1cb0d8b63f8681$export$ca9e8ecf3149eb25(json, false);
}
function $7b1cb0d8b63f8681$export$ca9e8ecf3149eb25(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'issues': !(0, $3Soqo.exists)(json, 'issues') ? undefined : json['issues'],
        'loadTimestampMs': !(0, $3Soqo.exists)(json, 'loadTimestampMs') ? undefined : json['loadTimestampMs'],
        'timeTakenMs': !(0, $3Soqo.exists)(json, 'timeTakenMs') ? undefined : json['timeTakenMs'],
        'assigneeProfiles': !(0, $3Soqo.exists)(json, 'assigneeProfiles') ? undefined : json['assigneeProfiles'],
        'calculationResult': !(0, $3Soqo.exists)(json, 'calculationResult') ? undefined : json['calculationResult'],
        'more': !(0, $3Soqo.exists)(json, 'more') ? undefined : json['more'],
        'reporterProfiles': !(0, $3Soqo.exists)(json, 'reporterProfiles') ? undefined : json['reporterProfiles'],
        'scenarioRemovedIssues': !(0, $3Soqo.exists)(json, 'scenarioRemovedIssues') ? undefined : json['scenarioRemovedIssues'],
        'sprints': !(0, $3Soqo.exists)(json, 'sprints') ? undefined : json['sprints'],
        'teams': !(0, $3Soqo.exists)(json, 'teams') ? undefined : json['teams'],
        'parametersHash': !(0, $3Soqo.exists)(json, 'parametersHash') ? undefined : json['parametersHash']
    };
}
function $7b1cb0d8b63f8681$export$eef36577ac770bbe(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'issues': value.issues,
        'loadTimestampMs': value.loadTimestampMs,
        'timeTakenMs': value.timeTakenMs,
        'assigneeProfiles': value.assigneeProfiles,
        'calculationResult': value.calculationResult,
        'more': value.more,
        'reporterProfiles': value.reporterProfiles,
        'scenarioRemovedIssues': value.scenarioRemovedIssues,
        'sprints': value.sprints,
        'teams': value.teams,
        'parametersHash': value.parametersHash
    };
}

});

parcelRegister("hsPmG", function(module, exports) {

$parcel$export(module.exports, "PartitionedBacklogResponseFromJSON", () => $cb6ce533cfe6385d$export$7f4343672215b302);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");

var $kaP5H = parcelRequire("kaP5H");
function $cb6ce533cfe6385d$export$64b49414a5618762(value) {
    let isInstance = true;
    return isInstance;
}
function $cb6ce533cfe6385d$export$7f4343672215b302(json) {
    return $cb6ce533cfe6385d$export$33006cccdb5a9c3(json, false);
}
function $cb6ce533cfe6385d$export$33006cccdb5a9c3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'issues': !(0, $3Soqo.exists)(json, 'issues') ? undefined : (0, $kaP5H.PartitionedIssuesFromJSON)(json['issues']),
        'assigneeProfiles': !(0, $3Soqo.exists)(json, 'assigneeProfiles') ? undefined : json['assigneeProfiles'],
        'calculationResult': !(0, $3Soqo.exists)(json, 'calculationResult') ? undefined : json['calculationResult'],
        'more': !(0, $3Soqo.exists)(json, 'more') ? undefined : json['more'],
        'reporterProfiles': !(0, $3Soqo.exists)(json, 'reporterProfiles') ? undefined : json['reporterProfiles'],
        'sprints': !(0, $3Soqo.exists)(json, 'sprints') ? undefined : json['sprints'],
        'teams': !(0, $3Soqo.exists)(json, 'teams') ? undefined : json['teams']
    };
}
function $cb6ce533cfe6385d$export$7ec4649283020759(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'issues': (0, $kaP5H.PartitionedIssuesToJSON)(value.issues),
        'assigneeProfiles': value.assigneeProfiles,
        'calculationResult': value.calculationResult,
        'more': value.more,
        'reporterProfiles': value.reporterProfiles,
        'sprints': value.sprints,
        'teams': value.teams
    };
}

});
parcelRegister("kaP5H", function(module, exports) {

$parcel$export(module.exports, "PartitionedIssuesFromJSON", () => $03ca439a8c024453$export$fa1f3f1ea72a5a9);
$parcel$export(module.exports, "PartitionedIssuesToJSON", () => $03ca439a8c024453$export$9f8e3769d5d69103);
/* tslint:disable */ /* eslint-disable */ /**
 * Portfolio Internal REST API
 * Internal REST API for Portfolio
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
var $3Soqo = parcelRequire("3Soqo");
function $03ca439a8c024453$export$77c7c745e280dbcb(value) {
    let isInstance = true;
    return isInstance;
}
function $03ca439a8c024453$export$fa1f3f1ea72a5a9(json) {
    return $03ca439a8c024453$export$e4884d8ccf117162(json, false);
}
function $03ca439a8c024453$export$e4884d8ccf117162(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'initial': !(0, $3Soqo.exists)(json, 'initial') ? undefined : json['initial'],
        'delayed': !(0, $3Soqo.exists)(json, 'delayed') ? undefined : json['delayed']
    };
}
function $03ca439a8c024453$export$9f8e3769d5d69103(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'initial': value.initial,
        'delayed': value.delayed
    };
}

});



parcelRegister("aF7eA", function(module, exports) {

$parcel$export(module.exports, "SET", () => $7dacbaee740d0565$export$5e8f180ef0142226);
$parcel$export(module.exports, "setAdditionalTeams", () => $7dacbaee740d0565$export$eb6986b461047d6c);
const $7dacbaee740d0565$export$5e8f180ef0142226 = 'state.domain.teams-additional.SET';
const $7dacbaee740d0565$export$eb6986b461047d6c = (payload)=>({
        type: $7dacbaee740d0565$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("jpccz", function(module, exports) {

$parcel$export(module.exports, "urls", () => $cbf8eb01a07c93bd$export$bcae9ba627f604b6);
$parcel$export(module.exports, "backlogBody", () => $cbf8eb01a07c93bd$export$a77ab082423ea66d);
parcelRequire("17L5s");
var $9FEvp = parcelRequire("9FEvp");

var $7CnHa = parcelRequire("7CnHa");
parcelRequire("5rYNM");
const $cbf8eb01a07c93bd$export$bcae9ba627f604b6 = {
    backlog: '/rest/jpo/1.0/backlog',
    backlog20: '/rest/jpo/2.0/backlog'
};
const $cbf8eb01a07c93bd$export$a77ab082423ea66d = ({ id: planId, currentScenarioId: scenarioId, includeCompletedIssuesFor: includeCompletedIssuesFor })=>({
        planId: planId,
        scenarioId: scenarioId,
        filter: {
            includeCompleted: includeCompletedIssuesFor !== 0,
            includeCompletedSince: (0, $9FEvp.default)(Date.now(), (0, $7CnHa.isDefined)(includeCompletedIssuesFor) ? includeCompletedIssuesFor : (0, $87a0abe4cc67502d$export$6afdd25b4da87159)).getTime(),
            includeIssueLinks: true
        },
        supportingDataOptions: {
            assignees: true,
            reporters: true,
            externalTeams: true,
            sprints: true
        }
    });

});


parcelRegister("dr8sv", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $3f54024916157f63$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $3f54024916157f63$export$e271b26eefe41db8);
$parcel$export(module.exports, "ADD_PLAN_SCENARIO", () => $3f54024916157f63$export$7366bdbb08ff990d);
$parcel$export(module.exports, "ENABLE_PLAN_SCENARIOS", () => $3f54024916157f63$export$194b93e0925d4c62);
$parcel$export(module.exports, "REMOVE_PLAN_SCENARIO", () => $3f54024916157f63$export$eca14a501ab8708e);
$parcel$export(module.exports, "DISABLE_PLAN_SCENARIOS", () => $3f54024916157f63$export$4d024fa49048ae59);
$parcel$export(module.exports, "UPDATE_PLAN_SCENARIO", () => $3f54024916157f63$export$60e8b04bc54d4cc2);
$parcel$export(module.exports, "UPDATE_AUTO_SCHEDULER_ENABLED", () => $3f54024916157f63$export$19bb50c9d1b6706f);
$parcel$export(module.exports, "reset", () => $3f54024916157f63$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $3f54024916157f63$export$722fbec263ad908a);
$parcel$export(module.exports, "updateAutoSchedulerEnabled", () => $3f54024916157f63$export$6b069c9e8291cced);
$parcel$export(module.exports, "addPlanScenario", () => $3f54024916157f63$export$ef567162fe046f26);
$parcel$export(module.exports, "enablePlanScenarios", () => $3f54024916157f63$export$1d8cd5385dd8eed2);
$parcel$export(module.exports, "removePlanScenario", () => $3f54024916157f63$export$2101863918c1e241);
$parcel$export(module.exports, "disablePlanScenarios", () => $3f54024916157f63$export$fc07c1be35f7a22d);
$parcel$export(module.exports, "updatePlanScenario", () => $3f54024916157f63$export$b611a5f0b8f8b9de);
const $3f54024916157f63$export$4a991c87e640ef77 = 'state.domain.plan.RESET';
const $3f54024916157f63$export$e271b26eefe41db8 = 'state.domain.plan.UPDATE';
const $3f54024916157f63$export$7366bdbb08ff990d = 'state.domain.plan.ADD_PLAN_SCENARIO';
const $3f54024916157f63$export$194b93e0925d4c62 = 'state.domain.plan.ENABLE_PLAN_SCENARIOS';
const $3f54024916157f63$export$eca14a501ab8708e = 'state.domain.plan.REMOVE_PLAN_SCENARIO';
const $3f54024916157f63$export$4d024fa49048ae59 = 'state.domain.plan.DISABLE_PLAN_SCENARIOS';
const $3f54024916157f63$export$60e8b04bc54d4cc2 = 'state.domain.plan.UPDATE_PLAN_SCENARIO';
const $3f54024916157f63$export$19bb50c9d1b6706f = 'state.domain.plan.UPDATE_AUTO_SCHEDULER_ENABLED';
const $3f54024916157f63$export$aad8462122ac592b = (payload)=>({
        type: $3f54024916157f63$export$4a991c87e640ef77,
        payload: payload
    });
const $3f54024916157f63$export$722fbec263ad908a = (payload)=>({
        type: $3f54024916157f63$export$e271b26eefe41db8,
        payload: payload
    });
const $3f54024916157f63$export$6b069c9e8291cced = (payload)=>({
        type: $3f54024916157f63$export$19bb50c9d1b6706f,
        payload: payload
    });
const $3f54024916157f63$export$ef567162fe046f26 = (payload)=>({
        type: $3f54024916157f63$export$7366bdbb08ff990d,
        payload: payload
    });
const $3f54024916157f63$export$1d8cd5385dd8eed2 = (payload)=>({
        type: $3f54024916157f63$export$194b93e0925d4c62,
        payload: payload
    });
const $3f54024916157f63$export$2101863918c1e241 = (payload)=>({
        type: $3f54024916157f63$export$eca14a501ab8708e,
        payload: payload
    });
const $3f54024916157f63$export$fc07c1be35f7a22d = (scenarioToKeepId)=>({
        type: $3f54024916157f63$export$4d024fa49048ae59,
        scenarioToKeepId: scenarioToKeepId
    });
const $3f54024916157f63$export$b611a5f0b8f8b9de = (payload)=>({
        type: $3f54024916157f63$export$60e8b04bc54d4cc2,
        payload: payload
    });

});

parcelRegister("48HOG", function(module, exports) {

$parcel$export(module.exports, "SET_DELETE_DIALOG_VISIBILITY", () => $86533a2fe506929e$export$7ba9245b25391992);
$parcel$export(module.exports, "ENABLE_DELETE", () => $86533a2fe506929e$export$ff1973e9dc85021b);
$parcel$export(module.exports, "DISABLE_DELETE", () => $86533a2fe506929e$export$2ea4734ebbcd83c4);
$parcel$export(module.exports, "REDIRECT_TO_SETTINGS", () => $86533a2fe506929e$export$1244ece369641a83);
$parcel$export(module.exports, "redirectToSettings", () => $86533a2fe506929e$export$fac3bf18cd62bfe3);
$parcel$export(module.exports, "setDeleteDialogVisibility", () => $86533a2fe506929e$export$ad6a13eccaf22bdb);
const $86533a2fe506929e$export$7ba9245b25391992 = 'state.ui.top.title-bar.plan-settings.TOGGLE_DELETE_DIALOG_VISIBILITY';
const $86533a2fe506929e$export$ff1973e9dc85021b = 'state.ui.top.title-bar.plan-settings.ENABLE_DELETE';
const $86533a2fe506929e$export$2ea4734ebbcd83c4 = 'state.ui.top.title-bar.plan-settings.DISABLE_DELETE';
const $86533a2fe506929e$export$1244ece369641a83 = 'state.ui.top.title-bar.plan-settings.REDIRECT_TO_SETTINGS';
const $86533a2fe506929e$export$fac3bf18cd62bfe3 = (redirectFrom)=>({
        type: $86533a2fe506929e$export$1244ece369641a83,
        payload: redirectFrom
    });
const $86533a2fe506929e$export$ad6a13eccaf22bdb = (visibility)=>({
        type: $86533a2fe506929e$export$7ba9245b25391992,
        payload: visibility
    });

});

parcelRegister("indSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7b79c3575e93bc$export$2e2bcd8739ae039);

var $64VaH = parcelRequire("64VaH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9a7b79c3575e93bc$export$2e2bcd8739ae039 = {
    managePortfolio: (0, $64VaH.proxyContextSafeUrl)('/jira/plans'),
    administration: (0, $64VaH.proxyContextSafeUrl)('/secure/PortfolioPermissions.jspa'),
    jiraHome: (0, $64VaH.proxyContextSafeUrl)('/jira/dashboards/last-visited'),
    manageCustomFields: (0, $64VaH.proxyContextSafeUrl)('/secure/admin/ViewCustomFields.jspa')
};

});

parcelRegister("gOwfg", function(module, exports) {

$parcel$export(module.exports, "urls", () => $1d32ed70b29dccba$export$bcae9ba627f604b6);
$parcel$export(module.exports, "transformUpdatePayload", () => $1d32ed70b29dccba$export$faf8dd22c72e24c0);
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");
const $1d32ed70b29dccba$export$bcae9ba627f604b6 = {
    update: (id)=>`/rest/jpo/1.0/plans/${id}/update`,
    delete: (id)=>`/rest/jpo/1.0/plans/${id}`,
    get: (planId, scenarioId)=>`/rest/jpo/1.0/planinfo/${planId}/scenario/${scenarioId}`,
    toggleAutoSchedule: ()=>'/rest/jpo/1.0/plans/autoSchedulerEnabled'
};
const $1d32ed70b29dccba$export$faf8dd22c72e24c0 = (update)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const key of Object.keys(update)){
        const value = update[key];
        if (key === 'autoScheduleConfiguration') result.calculationConfiguration = {
            value: value
        };
        else if ([
            'baselineStartField',
            'baselineEndField'
        ].includes(key)) {
            if (typeof value === 'object' && typeof value.id === 'string') {
                const convertedId = (0, $chgK5.TARGET_DATE_FIELD_TO_API_DATE_FIELD_MAP)[value.id] || value.id;
                result[`${key}Id`] = {
                    value: convertedId
                };
            }
        } else result[key] = {
            value: value
        };
    }
    // This is updated in separate api (toggleAutoSchedule) it will 400 if we accidentally include it here
    // but this is part of PlanInfo so is easy to accidentally include it in the payload
    delete result.autoSchedulerEnabled;
    return result;
};

});



parcelRegister("3z6Ad", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b48cb871ea868c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");
var $79tFY = parcelRequire("79tFY");
var $186Kt = parcelRequire("186Kt");

var $5YsMl = parcelRequire("5YsMl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");

var $3upRO = parcelRequire("3upRO");

var $eOsHk = parcelRequire("eOsHk");

var $ib5d3 = parcelRequire("ib5d3");

var $7PfBx = parcelRequire("7PfBx");
function $b0b48cb871ea868c$var$ConfiguredDatesUnavailableFlag({ dateConfiguration: dateConfiguration, handleKeepUsingTargetDates: handleKeepUsingTargetDates }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const dateFieldsWithWarning = $186Kt.default((field)=>!!field.warning, dateConfiguration);
    const numFieldsDontExist = Object.keys($186Kt.default($79tFY.default([
        'warning',
        'code'
    ], (0, $eOsHk.DATEFIELD_WARNINGS).NOT_EXIST), dateConfiguration)).length;
    const startDateTitle = $kjklK.default([
        'baselineStartField',
        'warning',
        'apiDateField',
        'title'
    ], dateFieldsWithWarning);
    const endDateTitle = $kjklK.default([
        'baselineEndField',
        'warning',
        'apiDateField',
        'title'
    ], dateFieldsWithWarning);
    const redirectToSpaPlanPage = (0, $3upRO.useRedirectToSpaPlanPage)();
    let description;
    if (numFieldsDontExist) description = formatMessage((0, $ib5d3.default).chooseConfigurableDateNotExistContent, {
        count: numFieldsDontExist
    });
    else if (startDateTitle) description = endDateTitle ? formatMessage((0, $ib5d3.default).chooseConfigurableDatesUnavailableContentStartAndEndDate, {
        startDateTitle: startDateTitle,
        endDateTitle: endDateTitle,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    }) : formatMessage((0, $ib5d3.default).chooseConfigurableDatesUnavailableContentStartDate, {
        startDateTitle: startDateTitle,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    });
    else if (endDateTitle) description = formatMessage((0, $ib5d3.default).chooseConfigurableDatesUnavailableContentEndDate, {
        endDateTitle: endDateTitle,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    });
    const actions = [
        {
            content: formatMessage((0, $7PfBx.default).useOtherDates),
            onClick: ()=>{
                redirectToSpaPlanPage('/settings/scheduling');
            }
        },
        {
            content: formatMessage((0, $7PfBx.default).keepUsingTargetDates),
            onClick: handleKeepUsingTargetDates
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        actions: actions,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        }),
        id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.configured-dates-flag.flag",
        description: description,
        title: formatMessage((0, $ib5d3.default).chooseConfigurableDatesUnavailableHeading, {
            count: Object.keys(dateFieldsWithWarning).length
        })
    });
}
var $b0b48cb871ea868c$export$2e2bcd8739ae039 = $b0b48cb871ea868c$var$ConfiguredDatesUnavailableFlag;

});
parcelRegister("7PfBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a4876bb715e85d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a4876bb715e85d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    useOtherDates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.configured-dates-flag.use-other-dates",
        "defaultMessage": "Use other dates"
    },
    keepUsingTargetDates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.configured-dates-flag.keep-using-target-dates",
        "defaultMessage": "Keep using default dates"
    }
});

});



parcelRegister("5MFfw", function(module, exports) {

$parcel$export(module.exports, "DependenciesFlyoutProvider", () => $8ff608e31e00f456$export$769da5814e8289ab);
$parcel$export(module.exports, "useDependenciesFlyout", () => $8ff608e31e00f456$export$e17d1515ee11256);
$parcel$export(module.exports, "DependenciesFlyoutOverlay", () => $8ff608e31e00f456$export$53da0ea820617f48);

var $eUqFw = parcelRequire("eUqFw");

var $eNhh9 = parcelRequire("eNhh9");

var $6ai6B = parcelRequire("6ai6B");

var $gTmjQ = parcelRequire("gTmjQ");

var $do5YK = parcelRequire("do5YK");
const $8ff608e31e00f456$var$FLYOUT_MAX_WIDTH = 800;
const $8ff608e31e00f456$var$context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    payload: null,
    triggerRect: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    open: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    close: ()=>{}
});
const $8ff608e31e00f456$export$769da5814e8289ab = ({ children: children })=>{
    const [flyoutProps, setFlyoutProps] = (0, $eUqFw.useState)(null);
    const [triggerRect, setTriggerRect] = (0, $eUqFw.useState)(null);
    const open = (payload, triggerEl)=>{
        setFlyoutProps(payload);
        setTriggerRect(triggerEl.getBoundingClientRect());
    };
    const close = ()=>setFlyoutProps(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8ff608e31e00f456$var$context.Provider, {
        value: {
            payload: flyoutProps,
            triggerRect: triggerRect,
            open: open,
            close: close
        }
    }, children);
};
const $8ff608e31e00f456$export$e17d1515ee11256 = ()=>(0, $eUqFw.useContext)($8ff608e31e00f456$var$context);
function $8ff608e31e00f456$var$useDialogLock() {
    const flagsRef = (0, $eUqFw.useRef)(new Set());
    /** Resets the lock by removing all of the flags. */ const reset = ()=>{
        flagsRef.current = new Set();
    };
    /** Check if the lock is activated by checking if there is any flag available. */ const isActivated = ()=>flagsRef.current.size > 0;
    /** Toggle a flag inside the lock  */ const toggle = (lock)=>(on)=>{
            if (on) flagsRef.current.add(lock);
            else flagsRef.current.delete(lock);
        };
    return {
        reset: reset,
        isActivated: isActivated,
        toggle: toggle
    };
}
const $8ff608e31e00f456$export$53da0ea820617f48 = ()=>{
    const ref = (0, $eUqFw.useRef)(null);
    const dialogLock = $8ff608e31e00f456$var$useDialogLock();
    const [anchorRect, setAnchorRect] = (0, $eUqFw.useState)(null);
    const { payload: payload, close: close, triggerRect: triggerRect } = $8ff608e31e00f456$export$e17d1515ee11256();
    (0, $eUqFw.useEffect)(()=>{
        const containerEl = ref.current;
        if (containerEl == null) return;
        if (triggerRect == null) return;
        const containerRect = containerEl.getBoundingClientRect();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const anchorRect = {
            top: triggerRect.top - containerRect.top,
            left: triggerRect.left - containerRect.left,
            width: triggerRect.width,
            height: triggerRect.height
        };
        setAnchorRect(anchorRect);
    }, [
        payload,
        triggerRect
    ]);
    (0, $eUqFw.useEffect)(()=>{
        dialogLock.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        payload
    ]);
    function handleRequestClose() {
        if (dialogLock.isActivated()) return;
        close();
    }
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        className: $do5YK.overlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ai6B.DependenciesDialogContext).Provider, {
        value: {
            isDialogLocked: true,
            toggleDialogLocked: dialogLock.toggle
        }
    }, payload != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTmjQ.default), payload),
        isOpen: "true",
        // go/jfe-eslint
        // eslint-disable-next-line react/jsx-no-bind
        onClose: handleRequestClose,
        maxWidth: $8ff608e31e00f456$var$FLYOUT_MAX_WIDTH,
        placement: "bottom-end",
        closeOnScroll: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $do5YK.anchor,
        style: {
            ...anchorRect
        }
    })))));
};

});
parcelRegister("6ai6B", function(module, exports) {

$parcel$export(module.exports, "DependenciesDialogContext", () => $40e77ad89547e78e$export$9e8fff114122fda5);

var $eUqFw = parcelRequire("eUqFw");
const $40e77ad89547e78e$export$9e8fff114122fda5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isDialogLocked: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleDialogLocked: ()=>()=>{}
});

});

parcelRegister("gTmjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce94ac758fc404a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7Z5Bz = parcelRequire("7Z5Bz");

var $hxUuj = parcelRequire("hxUuj");
var $8ce94ac758fc404a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $7Z5Bz.default), {})((0, $hxUuj.default));

});
parcelRegister("7Z5Bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba03fca63d0ff4f0$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $fbHoQ = parcelRequire("fbHoQ");

var $dEoWh = parcelRequire("dEoWh");

var $5rYNM = parcelRequire("5rYNM");

var $1TrR5 = parcelRequire("1TrR5");
const $ba03fca63d0ff4f0$var$mapStateToPropsOld = (state, props)=>{
    const issueId = props.issue.id;
    const externalIncomingLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || [];
    const externalOutgoingLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || [];
    const internalIncomingLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || [];
    const internalIncomingLinksOriginal = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || [];
    const internalOutgoingLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || [];
    const internalOutgoingLinksOriginal = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || [];
    const filterValue = (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value;
    const [externalIssueLinks, internalIssueLinks, originalIssueLinks] = props.direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD ? [
        externalIncomingLinks,
        internalIncomingLinks,
        internalIncomingLinksOriginal
    ] : [
        externalOutgoingLinks,
        internalOutgoingLinks,
        internalOutgoingLinksOriginal
    ];
    return {
        internalIssueLinks: internalIssueLinks,
        externalIssueLinks: externalIssueLinks,
        originalIssueLinks: originalIssueLinks,
        filterValue: filterValue
    };
};
const $ba03fca63d0ff4f0$var$externalIncomingLinksList = [];
const $ba03fca63d0ff4f0$var$externalOutgoingLinksList = [];
const $ba03fca63d0ff4f0$var$internalIncomingLinksList = [];
const $ba03fca63d0ff4f0$var$internalIncomingLinksOriginalList = [];
const $ba03fca63d0ff4f0$var$internalOutgoingLinksList = [];
const $ba03fca63d0ff4f0$var$internalOutgoingLinksOriginalList = [];
const $ba03fca63d0ff4f0$var$mapStateToPropsFactory = ()=>{
    const linksFactory = (0, $5iWql.default)((direction, externalIncomingLinks, internalIncomingLinks, internalIncomingLinksOriginal, externalOutgoingLinks, internalOutgoingLinks, internalOutgoingLinksOriginal)=>direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD ? [
            externalIncomingLinks,
            internalIncomingLinks,
            internalIncomingLinksOriginal
        ] : [
            externalOutgoingLinks,
            internalOutgoingLinks,
            internalOutgoingLinksOriginal
        ]);
    return (state, props)=>{
        const issueId = props.issue.id;
        const externalIncomingLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || $ba03fca63d0ff4f0$var$externalIncomingLinksList;
        const externalOutgoingLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || $ba03fca63d0ff4f0$var$externalOutgoingLinksList;
        const internalIncomingLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || $ba03fca63d0ff4f0$var$internalIncomingLinksList;
        const internalIncomingLinksOriginal = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || $ba03fca63d0ff4f0$var$internalIncomingLinksOriginalList;
        const internalOutgoingLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || $ba03fca63d0ff4f0$var$internalOutgoingLinksList;
        const internalOutgoingLinksOriginal = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || $ba03fca63d0ff4f0$var$internalOutgoingLinksOriginalList;
        const filterValue = (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value;
        const [externalIssueLinks, internalIssueLinks, originalIssueLinks] = linksFactory(props.direction, externalIncomingLinks, internalIncomingLinks, internalIncomingLinksOriginal, externalOutgoingLinks, internalOutgoingLinks, internalOutgoingLinksOriginal);
        return {
            internalIssueLinks: internalIssueLinks,
            externalIssueLinks: externalIssueLinks,
            originalIssueLinks: originalIssueLinks,
            filterValue: filterValue
        };
    };
};
const $ba03fca63d0ff4f0$export$c31df4bd766f9c35 = (0, $1TrR5.functionWithFFRedux)($ba03fca63d0ff4f0$var$mapStateToPropsFactory, $ba03fca63d0ff4f0$var$mapStateToPropsOld);
var $ba03fca63d0ff4f0$export$2e2bcd8739ae039 = $ba03fca63d0ff4f0$export$c31df4bd766f9c35;

});

parcelRegister("hxUuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23dea0df3fc8677$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6PWGn = parcelRequire("6PWGn");
function $b23dea0df3fc8677$export$2e2bcd8739ae039({ direction: direction, issue: issue, filterValue: filterValue, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, originalIssueLinks: originalIssueLinks }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PWGn.default), {
        direction: direction,
        issue: issue,
        externalIssueLinks: externalIssueLinks,
        internalIssueLinks: internalIssueLinks,
        internalOriginalIssueLinks: originalIssueLinks || [],
        context: "badge",
        filterValue: filterValue
    });
}

});
parcelRegister("6PWGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $47072a8ecd71aa9d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $a7bxb = parcelRequire("a7bxb");

var $bHNJD = parcelRequire("bHNJD");

var $fSR6b = parcelRequire("fSR6b");
var $47072a8ecd71aa9d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bHNJD.default), (0, $a7bxb.default))((0, $fSR6b.default));

});
parcelRegister("a7bxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $972bf8b96f3ea5e5$export$2e2bcd8739ae039);

var $99FB5 = parcelRequire("99FB5");

var $cTDpS = parcelRequire("cTDpS");

var $8fleG = parcelRequire("8fleG");
const $972bf8b96f3ea5e5$var$mapDispatchToProps = (dispatch)=>({
        addDependency: (payload)=>{
            dispatch((0, $cTDpS.addIssueLink)(payload));
        },
        removeDependency: (payload)=>{
            dispatch((0, $cTDpS.deleteIssueLink)(payload));
        },
        loadExternalIssues: (ids)=>{
            dispatch((0, $99FB5.loadExternalIssues)(ids));
        },
        changeDependencySettingsDisplay: (payload)=>{
            dispatch((0, $8fleG.changeDisplay)(payload));
        }
    });
var $972bf8b96f3ea5e5$export$2e2bcd8739ae039 = $972bf8b96f3ea5e5$var$mapDispatchToProps;

});
parcelRegister("99FB5", function(module, exports) {

$parcel$export(module.exports, "loadExternalIssues", () => $d90675655036602c$export$3efe18aba92c530);
$parcel$export(module.exports, "default", () => $d90675655036602c$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $7zlu6 = parcelRequire("7zlu6");

var $4hIOe = parcelRequire("4hIOe");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $eoL5m = parcelRequire("eoL5m");
const $d90675655036602c$export$effe480081a88736 = 'command.external-issues.LOAD_EXTERNAL_ISSUES';
const $d90675655036602c$export$3efe18aba92c530 = (payload)=>({
        type: $d90675655036602c$export$effe480081a88736,
        payload: payload
    });
function* $d90675655036602c$export$badea75b931890f4({ payload: payload }) {
    const requestedExternalIssues = yield (0, $9e8i2.select)((0, $7zlu6.getExternalIssues));
    // Do not request issues which were requested before.
    const issueIds = payload.filter((id)=>!requestedExternalIssues[id]);
    // If response would miss some issues or if request would fail we should put nulls into state to
    // indicate failure. The easiest way is to have id => null map for all issues now and just merge
    // response into it later.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = issueIds.reduce((acc, id)=>{
        acc[id] = null;
        return acc;
    }, {});
    const url = (0, $eoL5m.urls).get;
    const body = {
        issueIds: issueIds
    };
    try {
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const { issues: issues } = yield (0, $9e8i2.call)(response.json.bind(response));
            Object.assign(result, (0, $7CnHa.indexBy)((x)=>x.id, issues));
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)($4hIOe.add(result));
    }
}
function* $d90675655036602c$export$2c4536cb2d0e7e41() {
    yield (0, $bG7pV.takeEvery)($d90675655036602c$export$effe480081a88736, $d90675655036602c$export$badea75b931890f4);
}
function* $d90675655036602c$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($d90675655036602c$export$2c4536cb2d0e7e41);
}

});
parcelRegister("7zlu6", function(module, exports) {

$parcel$export(module.exports, "getExternalIssues", () => $b50aca0e40dc0d95$export$c284fae2050e87b6);
const $b50aca0e40dc0d95$export$c284fae2050e87b6 = (state)=>state.domain.externalIssues;

});

parcelRegister("4hIOe", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $5c9f2a5da7c2ff42$export$bb6389024b71c2ae);
$parcel$export(module.exports, "add", () => $5c9f2a5da7c2ff42$export$e16d8520af44a096);
const $5c9f2a5da7c2ff42$export$bb6389024b71c2ae = 'state.domain.external-issues.ADD';
const $5c9f2a5da7c2ff42$export$e16d8520af44a096 = (payload)=>({
        type: $5c9f2a5da7c2ff42$export$bb6389024b71c2ae,
        payload: payload
    });

});

parcelRegister("eoL5m", function(module, exports) {

$parcel$export(module.exports, "urls", () => $cd81cc2dfd468d48$export$bcae9ba627f604b6);
const $cd81cc2dfd468d48$export$bcae9ba627f604b6 = {
    get: '/rest/jpo/1.0/issue/get'
};

});


parcelRegister("cTDpS", function(module, exports) {

$parcel$export(module.exports, "addIssueLink", () => $1418dd87123b02f6$export$113196d38d8f6448);
$parcel$export(module.exports, "deleteIssueLink", () => $1418dd87123b02f6$export$b38a2b924f85419d);
$parcel$export(module.exports, "handleIssueLinkCommitResponse", () => $1418dd87123b02f6$export$d69a8e11bd4b544f);
$parcel$export(module.exports, "revertChange", () => $1418dd87123b02f6$export$be623675b8f208ee);
$parcel$export(module.exports, "default", () => $1418dd87123b02f6$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $kP3Wn = parcelRequire("kP3Wn");

var $jyOCP = parcelRequire("jyOCP");

var $j5GRN = parcelRequire("j5GRN");

var $cbq3D = parcelRequire("cbq3D");

var $iTjRl = parcelRequire("iTjRl");

var $dEoWh = parcelRequire("dEoWh");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $eDYLe = parcelRequire("eDYLe");

var $872dx = parcelRequire("872dx");

var $xlOmi = parcelRequire("xlOmi");

var $eBGH3 = parcelRequire("eBGH3");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hLGUx = parcelRequire("hLGUx");
const $1418dd87123b02f6$export$9ece66d5710b5222 = 'command.issue-links.ADD_ISSUE_LINK';
const $1418dd87123b02f6$export$e447be9b24d8f55e = 'command.issue-links.DELETE_ISSUE_LINK';
const $1418dd87123b02f6$export$113196d38d8f6448 = (payload)=>({
        type: $1418dd87123b02f6$export$9ece66d5710b5222,
        payload: payload
    });
const $1418dd87123b02f6$export$b38a2b924f85419d = (payload)=>({
        type: $1418dd87123b02f6$export$e447be9b24d8f55e,
        payload: payload
    });
function* $1418dd87123b02f6$export$4884fd84d9484e78(// eslint-disable-next-line @typescript-eslint/no-explicit-any
block, promise, checkResult = false) {
    if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $9e8i2.call)(block);
    try {
        const result = yield (0, $9e8i2.call)(block);
        if (checkResult && result === undefined) promise.reject(new Error('No result returned from the block'));
        else promise.resolve(result);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        promise.reject(err);
    }
}
function* $1418dd87123b02f6$export$a357c0495856cd1c({ payload: payload }) {
    // random alpha-numeric key for optimistic issue link
    const pendingKey = Math.random().toString(36).slice(2);
    try {
        const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type } = payload;
        const { currentScenarioId: scenarioId, id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const { dependencyIssueLinkTypes: dependencyIssueLinkTypes } = yield (0, $9e8i2.select)((0, $dhHiZ.getDependencySettingsInfo));
        const outgoingLinks = yield (0, $9e8i2.select)((0, $dEoWh.getOutgoingLinks));
        const dependencyIssueLinkTypeById = (0, $7CnHa.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencyIssueLinkTypes);
        const dependencyIssueLinkType = dependencyIssueLinkTypeById[type];
        if (dependencyIssueLinkType == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'doAddIssueLink dependencyIssueLinkTypeById[type] is undefined');
        const isOutward = dependencyIssueLinkType?.isOutward;
        const url = (0, $hLGUx.urls).add;
        // Check if source and target are the same
        if (sourceItemKey === targetItemKey) return;
        // We check if this dependency already exists
        const outgoingLinksForItem = outgoingLinks[sourceItemKey] || [];
        const existingLinkArray = outgoingLinksForItem.filter((link)=>link.targetItemKey === targetItemKey && link.type === type);
        if (existingLinkArray.length > 0) return;
        // If a dependency link type is swapped through the dependency settings page, the entry points of the application swap them target and source
        // so portfolio would handle is properly. Look into domain => system reducer
        // This is the exit point so we swap is back
        const body = {
            description: {
                type: {
                    value: type
                }
            },
            sourceItemKey: isOutward ? sourceItemKey : targetItemKey,
            targetItemKey: isOutward ? targetItemKey : sourceItemKey,
            scenarioId: scenarioId,
            planId: planId
        };
        yield (0, $9e8i2.put)($872dx.add({
            ...payload,
            itemKey: pendingKey
        }));
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const result = yield (0, $9e8i2.call)(response.json.bind(response));
            const { itemKey: itemKey, change: { sequence: sequence } } = result;
            yield (0, $9e8i2.put)($872dx.add({
                ...payload,
                itemKey: itemKey,
                pendingKey: pendingKey
            }));
            yield (0, $9e8i2.put)($xlOmi.update(sequence));
            if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && result) return result;
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // remove the pending issue link from state
        yield (0, $9e8i2.put)($872dx.remove({
            ...payload,
            itemKey: pendingKey
        }));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1418dd87123b02f6$export$97863425886e3651(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($1418dd87123b02f6$export$4884fd84d9484e78, function*() {
        return yield (0, $9e8i2.call)($1418dd87123b02f6$export$a357c0495856cd1c, {
            type: type,
            payload: payload
        });
    }, promise, true);
}
function* $1418dd87123b02f6$export$75cbe85ffa49cddc({ payload: payload }) {
    try {
        yield (0, $9e8i2.put)($872dx.remove(payload));
        const { itemKey: itemKey } = payload;
        const { currentScenarioId: scenarioId, id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const url = (0, $hLGUx.urls).delete;
        const body = {
            itemKeys: [
                itemKey
            ],
            scenarioId: scenarioId,
            planId: planId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: 'POST',
            body: body
        });
        if (response.ok) {
            const result = yield (0, $9e8i2.call)(response.json.bind(response));
            const { change: { sequence: sequence } } = result;
            yield (0, $9e8i2.put)($xlOmi.update(sequence));
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: 'POST',
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1418dd87123b02f6$export$4aae455a2679cf2d(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($1418dd87123b02f6$export$4884fd84d9484e78, function*() {
        return yield (0, $9e8i2.call)($1418dd87123b02f6$export$75cbe85ffa49cddc, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $1418dd87123b02f6$export$d69a8e11bd4b544f(entityResponse, issueId) {
    if (entityResponse.success) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const issueId = entityResponse.itemKey;
        const internalEntity = entityResponse.entity?.entity;
        const error = entityResponse.error;
        const warnings = yield (0, $9e8i2.call)((0, $j5GRN.inspectForCommitWarnings), internalEntity, error);
        if (warnings.length) // Issue links are represented as issue value in the Review changes dialog.
        // It has two important consequences:
        // 1. Committing link is triggered by the issue which was selected first.
        // 2. Warning produced by issue link commit should be shown as issue warnings.
        // To make things simpler id of the issue which triggered link commit
        // is passed here and warnings are attached to this issue.
        yield (0, $9e8i2.put)($eBGH3.add({
            category: (0, $5rYNM.ENTITY).ISSUE,
            itemId: issueId,
            warnings: warnings
        }));
    } else yield (0, $9e8i2.put)($eBGH3.add({
        category: (0, $5rYNM.ENTITY).ISSUE,
        itemId: issueId,
        warnings: [
            (0, $j5GRN.defaultWarning)
        ]
    }));
}
function* $1418dd87123b02f6$export$be623675b8f208ee(id) {
    const { id: planId, currentScenarioId: currentScenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const sequence = yield (0, $9e8i2.select)((0, $eDYLe.getSequence));
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, id);
    const response = yield* $iTjRl.json({
        url: (0, $hLGUx.urls).revertChanges,
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)($xlOmi.update(sequence));
    }
    return response;
}
function* $1418dd87123b02f6$export$dc8aa13c514faabe() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($1418dd87123b02f6$export$9ece66d5710b5222, $1418dd87123b02f6$export$97863425886e3651);
    else yield (0, $bG7pV.takeEvery)($1418dd87123b02f6$export$9ece66d5710b5222, $1418dd87123b02f6$export$a357c0495856cd1c);
}
function* $1418dd87123b02f6$export$dfe2669f36cf1dde() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($1418dd87123b02f6$export$e447be9b24d8f55e, $1418dd87123b02f6$export$4aae455a2679cf2d);
    else yield (0, $bG7pV.takeEvery)($1418dd87123b02f6$export$e447be9b24d8f55e, $1418dd87123b02f6$export$75cbe85ffa49cddc);
}
function* $1418dd87123b02f6$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($1418dd87123b02f6$export$dc8aa13c514faabe);
    yield (0, $9e8i2.fork)($1418dd87123b02f6$export$dfe2669f36cf1dde);
}

});
parcelRegister("eDYLe", function(module, exports) {

$parcel$export(module.exports, "getReviewChanges", () => $baa65b2e1745e246$export$3570f914f5a12111);
$parcel$export(module.exports, "getReviewChangesCount", () => $baa65b2e1745e246$export$26f51a34975a7739);
$parcel$export(module.exports, "getSelectedChanges", () => $baa65b2e1745e246$export$48659d68af0bee07);
$parcel$export(module.exports, "getScenarioRemovedIssueChanges", () => $baa65b2e1745e246$export$e24098b7db7b9ce5);
$parcel$export(module.exports, "getSortedByHierarchySelectedIssues", () => $baa65b2e1745e246$export$f47dbfe6ab1c063d);
$parcel$export(module.exports, "getExpandedChanges", () => $baa65b2e1745e246$export$bacc19472f5797fe);
$parcel$export(module.exports, "getSelectedChangesCount", () => $baa65b2e1745e246$export$422cac0bd217f0d9);
$parcel$export(module.exports, "getIsLoading", () => $baa65b2e1745e246$export$439d81b5ff19f64f);
$parcel$export(module.exports, "getIsOutOfSync", () => $baa65b2e1745e246$export$17adf6d814ca318e);
$parcel$export(module.exports, "getIsLoaded", () => $baa65b2e1745e246$export$c2ab4f36d4c3d60a);
$parcel$export(module.exports, "getIsSaving", () => $baa65b2e1745e246$export$88b3f624eba99c6);
$parcel$export(module.exports, "getIsSavingInterrupted", () => $baa65b2e1745e246$export$7fc970d8e872228e);
$parcel$export(module.exports, "getCommitProgressStats", () => $baa65b2e1745e246$export$237d8ccf3c54fe3c);
$parcel$export(module.exports, "getIsReverting", () => $baa65b2e1745e246$export$4bf6de41c813fc9b);
$parcel$export(module.exports, "getIsRevertingInterrupted", () => $baa65b2e1745e246$export$bcfae069f16c50d7);
$parcel$export(module.exports, "getRevertProgressStats", () => $baa65b2e1745e246$export$95a400011a937d4b);
$parcel$export(module.exports, "getHiddenIssues", () => $baa65b2e1745e246$export$ea11170f6eef9668);
$parcel$export(module.exports, "getIsCommitWarningFlagClosed", () => $baa65b2e1745e246$export$12589ad7af99a8bb);
$parcel$export(module.exports, "getCommitWarnings", () => $baa65b2e1745e246$export$83cd988b46c0ef8e);
$parcel$export(module.exports, "getChangesWarnings", () => $baa65b2e1745e246$export$df2560b98034da0f);
$parcel$export(module.exports, "getCommittedChangesCount", () => $baa65b2e1745e246$export$626c6d4f2ef28500);
$parcel$export(module.exports, "getAllChangesMetaData", () => $baa65b2e1745e246$export$2e200220fb9ff908);
$parcel$export(module.exports, "getSortBy", () => $baa65b2e1745e246$export$c7052c2989e7b681);
$parcel$export(module.exports, "getSortDirection", () => $baa65b2e1745e246$export$509e2b9937961873);
$parcel$export(module.exports, "getSequence", () => $baa65b2e1745e246$export$5c1e203ca018159a);
$parcel$export(module.exports, "getFilteredReviewChanges", () => $baa65b2e1745e246$export$246aa7c7321c7a9e);
$parcel$export(module.exports, "getNotificationPreference", () => $baa65b2e1745e246$export$3c3771868e06ade1);
$parcel$export(module.exports, "getCountForStatusCategory", () => $baa65b2e1745e246$export$d8dd3fdfde69fc2c);
$parcel$export(module.exports, "getCountForGoals", () => $baa65b2e1745e246$export$cb42fcdf163e8c7b);

var $cQGVO = parcelRequire("cQGVO");
var $kjklK = parcelRequire("kjklK");
var $3IGDG = parcelRequire("3IGDG");
var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $6VhAf = parcelRequire("6VhAf");

var $2Ruxt = parcelRequire("2Ruxt");

var $kFf60 = parcelRequire("kFf60");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $kogU9 = parcelRequire("kogU9");

var $wcCGG = parcelRequire("wcCGG");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $1bVXL = parcelRequire("1bVXL");
const $baa65b2e1745e246$export$19cde3a2e3bf276a = 'out-of-sync';
function $baa65b2e1745e246$export$c1a95b573a616529(metaData, assigneeMapById = {}, dateFormat) {
    const personId = metaData.lastChangeUser;
    const person = assigneeMapById[personId];
    return {
        date: metaData.lastChangeTimestamp,
        personId: personId,
        dateFormat: dateFormat,
        ...person ? {
            title: person.jiraUser.title,
            avatarUrl: person.jiraUser.avatarUrl
        } : {}
    };
}
const $baa65b2e1745e246$export$f0d3973db2d9f1b5 = (scenarioType, changeCount)=>{
    if (scenarioType === 'ADDED') return 'ADDED';
    if (scenarioType === 'UPDATED') {
        if (changeCount === 0) // This would be unexpected, but let's account for it!
        return 'NONE';
        if (changeCount === 1) return 'UPDATED';
        return 'MULTIPLE';
    }
    if (scenarioType === 'DELETED') return 'DELETED';
    // Couldn't figure out the change!
    return 'UNKNOWN';
};
const $baa65b2e1745e246$export$606c6b01925e3a74 = (issueChanges, versionChanges, crossProjectVersionChanges, teamAndResourceChanges, sprintChanges, dateFormat, assigneeMapById)=>[
        ...issueChanges,
        ...versionChanges,
        ...crossProjectVersionChanges,
        ...teamAndResourceChanges,
        ...sprintChanges
    ].map(// NOTE due to Flow limitations in handling sum types we need to do unsafe cast here
    // therefore please pay extra attention to keep this code correct
    ({ metaData: metaData, metaData: { scenarioType: scenarioType }, ...rest })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            type: $baa65b2e1745e246$export$f0d3973db2d9f1b5(scenarioType, rest.changeCount),
            lastModified: $baa65b2e1745e246$export$c1a95b573a616529(metaData, assigneeMapById, dateFormat),
            ...rest
        }));
const $baa65b2e1745e246$export$3570f914f5a12111 = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getIssueChanges),
    (0, $wcCGG.getVersionChanges),
    (0, $2Ruxt.getCrossProjectVersionChanges),
    (0, $kogU9.getTeamAndResourceChanges),
    (0, $c1XMU.getSprintChanges),
    (0, $dhHiZ.getDateFormat),
    (0, $6VhAf.getAssigneesById)
], $baa65b2e1745e246$export$606c6b01925e3a74);
const $baa65b2e1745e246$export$26f51a34975a7739 = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getIssueChangeCount),
    (0, $wcCGG.getVersionChangeCount),
    (0, $2Ruxt.getCrossProjectVersionChangeCount),
    (0, $kogU9.getTeamOrResourceChangeCount),
    (0, $c1XMU.getSprintChangeCount)
], (issueChangeCount, versionChangeCount, crossProjectVersionChangeCount, resourceChangeCount, plannedCapacityChangeCount)=>issueChangeCount + versionChangeCount + crossProjectVersionChangeCount + resourceChangeCount + plannedCapacityChangeCount);
const $baa65b2e1745e246$export$48659d68af0bee07 = (state)=>state.ui.Top.TitleBar.UpdateJira.selectedChanges;
const $baa65b2e1745e246$export$7b4bd5631415c286 = (issues, { ISSUE: selectedIssues })=>{
    const removedIssuesIds = [];
    const sortedIds = selectedIssues // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
    .reduce((selectedIssues, selectedIssueId)=>{
        const existingIssue = issues.find((issue)=>selectedIssueId === issue.id);
        if (!existingIssue) {
            // We don't sort issues that do not exist, but we want to keep their ids, so we can commit these changes.
            removedIssuesIds.push(selectedIssueId);
            return selectedIssues;
        }
        return selectedIssues.concat(existingIssue);
    }, []).sort((issueA, issueB)=>issueB && issueA ? issueB.level - issueA.level : 0).map((issue)=>issue ? issue.id : '');
    return sortedIds.concat(removedIssuesIds);
};
const $baa65b2e1745e246$export$ede43e961e608007 = (issues)=>issues.reduce((result, issue)=>{
        const isExcluded = issue.values.excluded;
        const issueKey = issue.issueKey;
        if (!isExcluded || !(0, $7CnHa.isDefined)(issueKey) || !(0, $7CnHa.isDefined)(issue.values.project)) return result;
        return result.concat({
            ...issue,
            issueSources: issue.issueSources || [],
            issueKey: issueKey
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $baa65b2e1745e246$export$e24098b7db7b9ce5 = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getIssueChangesData)
], $baa65b2e1745e246$export$ede43e961e608007);
const $baa65b2e1745e246$export$f47dbfe6ab1c063d = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getAllIssues),
    $baa65b2e1745e246$export$48659d68af0bee07
], $baa65b2e1745e246$export$7b4bd5631415c286);
const $baa65b2e1745e246$export$bacc19472f5797fe = (state)=>state.ui.Top.TitleBar.UpdateJira.expandedChanges;
const $baa65b2e1745e246$export$422cac0bd217f0d9 = (0, $iK4oF.createSelector)([
    $baa65b2e1745e246$export$48659d68af0bee07
], (0, $7CnHa.valuesLength));
const $baa65b2e1745e246$export$439d81b5ff19f64f = ({ domain: { updateJira: { changes: { status: status } } } })=>status === (0, $2d1ffdf76d206286$export$16250ffd632e517a) || status === (0, $2d1ffdf76d206286$export$26d55645375ca9a);
const $baa65b2e1745e246$export$17adf6d814ca318e = ({ domain: { updateJira: { changes: { status: status, error: error } } } })=>status === (0, $2d1ffdf76d206286$export$103bedf43ba882db) && error && error.message.error === $baa65b2e1745e246$export$19cde3a2e3bf276a;
const $baa65b2e1745e246$export$c2ab4f36d4c3d60a = ({ domain: { updateJira: { changes: { status: status } } } })=>status === (0, $2d1ffdf76d206286$export$638cc6e36b2a737a) || status === (0, $2d1ffdf76d206286$export$103bedf43ba882db);
const $baa65b2e1745e246$export$88b3f624eba99c6 = (state)=>state.domain.updateJira.commit.inProgress;
const $baa65b2e1745e246$export$7fc970d8e872228e = (state)=>state.domain.updateJira.commit.isInterrupted;
const $baa65b2e1745e246$export$237d8ccf3c54fe3c = (state)=>state.domain.updateJira.commit.progressStats;
const $baa65b2e1745e246$export$4bf6de41c813fc9b = (state)=>state.domain.updateJira.revert.inProgress;
const $baa65b2e1745e246$export$bcfae069f16c50d7 = (state)=>state.domain.updateJira.revert.isInterrupted;
const $baa65b2e1745e246$export$95a400011a937d4b = (state)=>state.domain.updateJira.revert.progressStats;
const $baa65b2e1745e246$export$ea11170f6eef9668 = ({ domain: { updateJira: { hiddenIssues: hiddenIssues } } })=>hiddenIssues;
const $baa65b2e1745e246$export$12589ad7af99a8bb = ({ ui: { Top: { TitleBar: { UpdateJira: { isCommitWarningFlagClosed: isCommitWarningFlagClosed } } } } })=>isCommitWarningFlagClosed;
const $baa65b2e1745e246$export$83cd988b46c0ef8e = ({ domain: { updateJira: { warnings: warnings } } })=>warnings;
const $baa65b2e1745e246$export$df2560b98034da0f = ({ domain: { updateJira: { changesWarnings: changesWarnings } } })=>changesWarnings;
const $baa65b2e1745e246$export$626c6d4f2ef28500 = (state)=>state.domain.updateJira.commit.changesCommitted;
const $baa65b2e1745e246$export$8c863a326abf9497 = ({ domain: { updateJira: { changes: { data: data = {
    metaData: {
        issues: {},
        resources: {},
        teams: {},
        versions: {},
        crossProjectVersions: {},
        plannedcapacity: {},
        issueLinks: {}
    },
    issues: [],
    issueLinks: []
} } } } })=>data.metaData.issues;
const $baa65b2e1745e246$export$2e200220fb9ff908 = (state)=>{
    const metaDataByType = $kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData'
    ], state) || {};
    const changes = [];
    const nestedChanges = $3IGDG.default($UCNmJ.default, $cQGVO.default($UCNmJ.default))(metaDataByType);
    return changes.concat(...nestedChanges);
};
const $baa65b2e1745e246$export$c7052c2989e7b681 = (state)=>state.ui.Top.TitleBar.UpdateJira.sortBy;
const $baa65b2e1745e246$export$509e2b9937961873 = (state)=>state.ui.Top.TitleBar.UpdateJira.sortDirection;
const $baa65b2e1745e246$export$5c1e203ca018159a = (state)=>state.domain.sequence;
const $baa65b2e1745e246$export$69250c46436353be = (changes, filter)=>filter.value.length ? changes.filter((change)=>filter.value.some((el)=>change.lastModified && el === change.lastModified.personId)) : changes;
const $baa65b2e1745e246$export$246aa7c7321c7a9e = (0, $iK4oF.createSelector)([
    $baa65b2e1745e246$export$3570f914f5a12111,
    (0, $1bVXL.getUserFilter)
], $baa65b2e1745e246$export$69250c46436353be);
const $baa65b2e1745e246$export$3c3771868e06ade1 = (state)=>state.ui.Top.TitleBar.UpdateJira.shouldNotifyWatchers;
const $baa65b2e1745e246$var$getCountForStatusCategoryPure = (issueChanges, selectedChanges, statusById)=>{
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        const filteredIssues = issueChanges.filter((issue)=>{
            const selectedIssueIds = selectedChanges.ISSUE || [];
            return issue.metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED && (0, $7CnHa.isDefined)(issue?.details?.originals?.status) && selectedIssueIds.includes(`${issue.id}`);
        });
        const result = {
            TODO: 0,
            INPROGRESS: 0,
            DONE: 0,
            UNDEFINED: 0
        };
        filteredIssues.forEach((issue)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const currentStatus = issue?.details?.values?.status;
            const currentStatusCategoryId = statusById[currentStatus]?.categoryId;
            switch(Number(currentStatusCategoryId)){
                case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).TODO:
                    result.TODO++;
                    break;
                case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS:
                    result.INPROGRESS++;
                    break;
                case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE:
                    result.DONE++;
                    break;
                default:
                    result.UNDEFINED++;
            }
            return result;
        });
        return result;
    }
    // Default use when ff "portfolio-3-no-param-reassign-fix_topgz" is false
    return issueChanges.filter((issue)=>{
        const selectedIssueIds = selectedChanges.ISSUE || [];
        return issue.metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED && (0, $7CnHa.isDefined)($kjklK.default([
            'details',
            'originals',
            'status'
        ], issue)) && selectedIssueIds.includes(`${issue.id}`);
    }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((statusCountGroup, issue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const currentStatus = $kjklK.default([
            'details',
            'values',
            'status'
        ], issue);
        const currentStatusCategoryId = statusById[currentStatus]?.categoryId;
        switch(Number(currentStatusCategoryId)){
            case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).TODO:
                // eslint-disable-next-line no-param-reassign
                statusCountGroup.TODO++;
                break;
            case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS:
                // eslint-disable-next-line no-param-reassign
                statusCountGroup.INPROGRESS++;
                break;
            case (0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE:
                // eslint-disable-next-line no-param-reassign
                statusCountGroup.DONE++;
                break;
            default:
                // eslint-disable-next-line no-param-reassign
                statusCountGroup.UNDEFINED++;
        }
        return statusCountGroup;
    }, {
        TODO: 0,
        INPROGRESS: 0,
        DONE: 0,
        UNDEFINED: 0
    });
};
const $baa65b2e1745e246$export$d8dd3fdfde69fc2c = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getIssueChanges),
    $baa65b2e1745e246$export$48659d68af0bee07,
    (0, $kFf60.getIssueStatusById)
], $baa65b2e1745e246$var$getCountForStatusCategoryPure);
const $baa65b2e1745e246$var$getCountGoalsPure = (issueChanges, selectedChanges)=>issueChanges.filter((issue)=>{
        const selectedIssueIds = selectedChanges.ISSUE || [];
        return issue.metaData.scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED && selectedIssueIds.includes(`${issue.id}`);
    }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((goalsCount, issue)=>{
        const currentGoals = issue.details.values.goals || [];
        const previousGoals = issue.details.originals.goals || [];
        const numGoalsRemoved = previousGoals.filter((goal)=>!currentGoals.includes(goal)).length;
        const numGoalsAdded = currentGoals.filter((goal)=>!previousGoals.includes(goal)).length;
        return {
            numGoalsRemoved: goalsCount.numGoalsRemoved + numGoalsRemoved,
            numGoalsAdded: goalsCount.numGoalsAdded + numGoalsAdded
        };
    }, {
        numGoalsRemoved: 0,
        numGoalsAdded: 0
    });
const $baa65b2e1745e246$export$cb42fcdf163e8c7b = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getIssueChanges),
    $baa65b2e1745e246$export$48659d68af0bee07
], $baa65b2e1745e246$var$getCountGoalsPure);

});
parcelRegister("kogU9", function(module, exports) {

$parcel$export(module.exports, "getTeamOrResourceChangeCount", () => $6aa3c16b212068f6$export$d5389f30d33b6fce);
$parcel$export(module.exports, "getDetailChange", () => $6aa3c16b212068f6$export$c00ac67fdd84eb31);
$parcel$export(module.exports, "expandChangesForTeam", () => $6aa3c16b212068f6$export$d1dd496f4579c767);
$parcel$export(module.exports, "getTeamAndResourceChanges", () => $6aa3c16b212068f6$export$2ae81b83b6cee86a);

var $kDrtX = parcelRequire("kDrtX");
var $cQGVO = parcelRequire("cQGVO");
var $cQwal = parcelRequire("cQwal");
var $kpKEz = parcelRequire("kpKEz");
var $l7xwn = parcelRequire("l7xwn");

var $f6g5r = parcelRequire("f6g5r");

var $75KhQ = parcelRequire("75KhQ");

var $9ydqM = parcelRequire("9ydqM");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $MQRDu = parcelRequire("MQRDu");
const $6aa3c16b212068f6$export$d802c22d109d9806 = (values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $cQGVO.default((value)=>value === null ? undefined : value, values);
const $6aa3c16b212068f6$export$b8ff943ec5a93e1e = (id, issueMetadata)=>{
    if (issueMetadata && issueMetadata[id]) return issueMetadata[id].scenarioType;
};
const $6aa3c16b212068f6$export$d5389f30d33b6fce = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams),
    (0, $MQRDu.getOriginalTeams),
    (0, $9ydqM.getOriginalResources)
], (teams, originalTeams, originalResources)=>teams.reduce((total, team)=>{
        const hasResourceChange = team.resources.filter((resource)=>originalResources[resource.itemKey]).length > 0;
        const hasTeamChange = originalTeams[team.id];
        if (hasResourceChange || hasTeamChange) return total + 1;
        return total;
    }, 0));
const $6aa3c16b212068f6$export$c00ac67fdd84eb31 = (change)=>{
    const teamDetails = change.details;
    const teamChange = change.category === (0, $5rYNM.ENTITY).RESOURCE ? teamDetails.changes.find((c)=>c.attributeName === change.attributeName && c.resourceId === change.id) : teamDetails.changes.find((c)=>c.attributeName === change.attributeName);
    return teamChange;
};
const $6aa3c16b212068f6$export$505442f9000110e3 = (team)=>{
    const values = $cQGVO.default((value)=>value === null ? undefined : value, $cQwal.default([
        'resources',
        'originals',
        'avatarUrl',
        'id',
        'shareable',
        'scenarioType',
        'externalId'
    ], team));
    return values;
};
const $6aa3c16b212068f6$export$1d75af08c1b97078 = (teamValues)=>$kpKEz.default($kDrtX.default, teamValues);
const $6aa3c16b212068f6$export$9e7d3164d16d5531 = (attributeName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributeValue, issueSources)=>{
    if (attributeName === 'issueSource') {
        const issueSource = (0, $75KhQ.findIssueSourceById)(issueSources, attributeValue);
        if (!issueSource) return attributeValue;
        return issueSource.title;
    }
    return attributeValue;
};
const $6aa3c16b212068f6$var$getOriginals = (originalValues, scenarioType, valueChanges)=>{
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING) return $cQGVO.default(()=>undefined, $6aa3c16b212068f6$export$1d75af08c1b97078(valueChanges));
    return $6aa3c16b212068f6$export$d802c22d109d9806(originalValues);
};
const $6aa3c16b212068f6$var$getScenarioTypeForTeam = (teamId, team, teamsMeta)=>{
    let scenarioType = $6aa3c16b212068f6$export$b8ff943ec5a93e1e(teamId, teamsMeta) || (0, $5rYNM.SCENARIO_TYPE).NONE;
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED) scenarioType = team.shareable ? (0, $5rYNM.SCENARIO_TYPE).EXCLUDED : scenarioType;
    else if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED && Object.keys(team.originals).length === 0 && team.shareable) return (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING;
    return scenarioType;
};
const $6aa3c16b212068f6$export$ca43e2138742c6b0 = (teamsMeta, teams, originalTeams, issueSources, warnings)=>{
    const teamChangeKeys = Object.keys(teamsMeta);
    const changeDetails = {};
    teamChangeKeys.forEach((teamId)=>{
        const team = (0, $MQRDu.findTeamById)(teams, teamId);
        if (!team) return;
        const scenarioType = $6aa3c16b212068f6$var$getScenarioTypeForTeam(teamId, team, teamsMeta);
        const originalTeamValues = originalTeams[teamId];
        if (!scenarioType || !originalTeamValues) return;
        const valueChanges = $6aa3c16b212068f6$export$505442f9000110e3(team);
        const originals = $6aa3c16b212068f6$export$505442f9000110e3($6aa3c16b212068f6$var$getOriginals(originalTeamValues, scenarioType, valueChanges));
        const change = {
            id: team.id,
            changeCount: 0,
            category: (0, $5rYNM.ENTITY).TEAM,
            type: scenarioType,
            attributeName: '',
            metaData: teamsMeta[team.id],
            warnings: warnings[teamId] || [],
            details: {
                changes: [],
                title: {
                    name: team.title,
                    avatarUrl: team.avatarUrl
                }
            }
        };
        // if deleted,  no need to show any other changes
        if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED || scenarioType === (0, $5rYNM.SCENARIO_TYPE).EXCLUDED) {
            changeDetails[teamId] = change;
            return changeDetails;
        }
        for (const [originalKey, originalValue] of Object.entries(originals))// Only show changes that are defined in the original or the value changes
        if ((0, $7CnHa.isDefined)(originalValue) || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7CnHa.isDefined)(valueChanges[originalKey])) change.details.changes.push({
            category: (0, $5rYNM.ENTITY).TEAM,
            attributeName: originalKey,
            originalValue: $6aa3c16b212068f6$export$9e7d3164d16d5531(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            originalKey, originalValue, issueSources),
            currentValue: $6aa3c16b212068f6$export$9e7d3164d16d5531(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            originalKey, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            valueChanges[originalKey], issueSources),
            metaData: teamsMeta[team.id]
        });
        changeDetails[teamId] = change;
    });
    return changeDetails;
};
const $6aa3c16b212068f6$var$isCreated = (change)=>change.type === (0, $5rYNM.SCENARIO_TYPE).ADDED;
const $6aa3c16b212068f6$var$isAdded = (change)=>change.type === (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING;
const $6aa3c16b212068f6$var$isDeleted = (change)=>change.type === (0, $5rYNM.SCENARIO_TYPE).DELETED;
const $6aa3c16b212068f6$var$getLatestMetaData = (change)=>{
    if (change.details.changes.length === 0) return change.metaData;
    const sortedChanges = $l7xwn.default((first, second)=>(second.metaData.lastChangeTimestamp || 0) - (first.metaData.lastChangeTimestamp || 0), change.details.changes);
    return sortedChanges[0].metaData;
};
function $6aa3c16b212068f6$export$f177941d20463906(teamChangeByTeamId, resourceChangesByTeamId) {
    const mergedTeamAndResourceChanges = teamChangeByTeamId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(resourceChangesByTeamId).forEach(([teamId, resourceChanges])=>{
        if (teamChangeByTeamId[teamId] && $6aa3c16b212068f6$var$isDeleted(teamChangeByTeamId[teamId])) // if a team is deleted, no need to show resource changes
        return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const changesForResource = resourceChangesByTeamId[teamId].reduce((allChanges, current)=>{
            allChanges.push(...current.details.changes);
            return allChanges;
        }, []);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const warningsForResource = resourceChangesByTeamId[teamId].reduce((allWarnings, current)=>{
            allWarnings.push(...current.warnings);
            return allWarnings;
        }, []);
        if (!mergedTeamAndResourceChanges[teamId]) {
            mergedTeamAndResourceChanges[teamId] = resourceChanges[0];
            mergedTeamAndResourceChanges[teamId].details.changes = changesForResource;
            mergedTeamAndResourceChanges[teamId].warnings = warningsForResource;
        } else {
            mergedTeamAndResourceChanges[teamId].details.changes.push(...changesForResource);
            mergedTeamAndResourceChanges[teamId].warnings.push(...warningsForResource);
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(mergedTeamAndResourceChanges).forEach(([, change])=>{
        const changeCount = change.details.changes.length;
        // eslint-disable-next-line no-param-reassign
        change.type = changeCount > 1 && !$6aa3c16b212068f6$var$isCreated(change) && !$6aa3c16b212068f6$var$isAdded(change) ? (0, $5rYNM.SCENARIO_TYPE).MULTIPLE : change.type;
        // eslint-disable-next-line no-param-reassign
        change.attributeName = !$6aa3c16b212068f6$var$isAdded(change) && change.details.changes[0] && change.details.changes[0].attributeName;
        // eslint-disable-next-line no-param-reassign
        change.changeCount = changeCount;
        // when the team and resources have different last updated meta data, we use the latest one
        // eslint-disable-next-line no-param-reassign
        change.metaData = $6aa3c16b212068f6$var$getLatestMetaData(change);
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.values(mergedTeamAndResourceChanges).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (previous, current)=>{
        previous.push(current);
        return previous;
    }, []);
}
function $6aa3c16b212068f6$export$d1dd496f4579c767(change) {
    const { category: category, lastModified: lastModified, ...rest } = change;
    return change.details.changes.map((childChange)=>({
            ...rest,
            id: childChange.category === (0, $5rYNM.ENTITY).RESOURCE ? childChange.resourceId || '' : change.id,
            type: (0, $5rYNM.SCENARIO_TYPE).NONE,
            category: childChange.category,
            attributeName: childChange.attributeName
        }));
}
const $6aa3c16b212068f6$export$2ae81b83b6cee86a = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeamChangesMetaData),
    (0, $9ydqM.getResourcesChangesMetaData),
    (0, $MQRDu.getTeams),
    (0, $MQRDu.getOriginalTeams),
    (0, $MQRDu.getCommitWarningsForTeams),
    (0, $9ydqM.getCommitWarningsForResources),
    (0, $f6g5r.getPersons),
    (0, $75KhQ.getIssueSources)
], (teamChangesMeta, resourceChangesMeta, teams, originalTeams, commitWarnings, resourceCommitWarnings, persons, issueSources)=>{
    const teamChanges = teamChangesMeta ? $6aa3c16b212068f6$export$ca43e2138742c6b0(teamChangesMeta, teams, originalTeams, issueSources, commitWarnings) : {};
    const resourceChanges = resourceChangesMeta ? (0, $9ydqM.getAllChangesForResource)(teams, resourceChangesMeta, persons, resourceCommitWarnings) : {};
    return $6aa3c16b212068f6$export$f177941d20463906(teamChanges, resourceChanges);
});

});
parcelRegister("9ydqM", function(module, exports) {

$parcel$export(module.exports, "getCommitWarningsForResources", () => $daa10cf37ccbaf11$export$1cdb006c2dfd7712);
$parcel$export(module.exports, "getOriginalResources", () => $daa10cf37ccbaf11$export$d894052e3f6edc60);
$parcel$export(module.exports, "getResourcesChangesMetaData", () => $daa10cf37ccbaf11$export$9235e6646f134b0e);
$parcel$export(module.exports, "getAllResources", () => $daa10cf37ccbaf11$export$5f76b3c51e55718);
$parcel$export(module.exports, "getAllChangesForResource", () => $daa10cf37ccbaf11$export$5f311af7e8e2bcf4);

var $e1ur4 = parcelRequire("e1ur4");
var $kjklK = parcelRequire("kjklK");
var $ldYmX = parcelRequire("ldYmX");

var $f6g5r = parcelRequire("f6g5r");

var $MQRDu = parcelRequire("MQRDu");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $daa10cf37ccbaf11$export$1cdb006c2dfd7712 = ({ domain: { updateJira: { warnings: warnings } } })=>warnings[(0, $5rYNM.ENTITY).RESOURCE];
const $daa10cf37ccbaf11$export$d894052e3f6edc60 = (state)=>state.domain.originalResources;
const $daa10cf37ccbaf11$export$9235e6646f134b0e = (state)=>$kjklK.default([
        'domain',
        'updateJira',
        'changes',
        'data',
        'metaData',
        'resources'
    ], state) || {};
const $daa10cf37ccbaf11$var$getValuesForNewResource = (values)=>(0, $7CnHa.pickBy)((0, $7CnHa.isDefined), values);
const $daa10cf37ccbaf11$export$a0d4d2a74c7df9f = (teams)=>$ldYmX.default((resources, team)=>$e1ur4.default(team.resources, resources), [], teams);
const $daa10cf37ccbaf11$export$5f76b3c51e55718 = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getTeams)
], $daa10cf37ccbaf11$export$a0d4d2a74c7df9f);
function $daa10cf37ccbaf11$export$68ecbd10fca209f9(values) {
    if (values.exceptions) // eslint-disable-next-line no-param-reassign
    values.exceptions = true;
    return values;
}
const $daa10cf37ccbaf11$export$e8245c687a3091c3 = (resource, resourcesChangeMeta, team, persons, warnings)=>{
    let originals = resource.originals;
    let values = resource.values;
    const resourceId = resource.itemKey;
    const scenarioType = resource.scenarioType;
    const resourceMeta = resourcesChangeMeta[resourceId];
    const person = (0, $f6g5r.getPersonByItemKey)(persons, resource.personItemKey);
    const personTitle = person && person.values.title || '';
    const change = {
        id: resourceId,
        changeCount: 0,
        category: (0, $5rYNM.ENTITY).RESOURCE,
        type: (0, $5rYNM.SCENARIO_TYPE).UPDATED,
        metaData: resourceMeta,
        warnings: warnings[resourceId] || [],
        details: {
            changes: [],
            title: {
                name: team.title,
                avatarUrl: team.avatarUrl
            }
        }
    };
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED) {
        const attributeName = scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? 'addedMember' : 'removedMember';
        const attributeValue = scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? personTitle : undefined; // new value
        const attributeOriginal = scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? undefined : personTitle; // old value
        values = {
            [attributeName]: attributeValue,
            ...values
        };
        originals = {
            [attributeName]: attributeOriginal,
            ...originals
        };
    }
    values = $daa10cf37ccbaf11$export$68ecbd10fca209f9(values);
    let changedAttributes = [];
    if (scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
        originals = {};
        values = $daa10cf37ccbaf11$var$getValuesForNewResource(values);
        changedAttributes = Object.keys(values);
    } else {
        originals = $daa10cf37ccbaf11$export$68ecbd10fca209f9(originals);
        changedAttributes = Object.keys(originals);
    }
    change.details.changes = changedAttributes.map((attributeName)=>({
            category: (0, $5rYNM.ENTITY).RESOURCE,
            attributeName: attributeName,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            originalValue: originals[attributeName],
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            currentValue: values[attributeName],
            resourceId: resourceId,
            personTitle: personTitle,
            metaData: resourceMeta
        }));
    return change;
};
const $daa10cf37ccbaf11$export$5f311af7e8e2bcf4 = (teams, resourceChangeMeta, persons, warnings)=>{
    const changes = {};
    Object.entries(resourceChangeMeta).forEach(([resourceKey])=>{
        const team = (0, $MQRDu.findTeamAssociatedWithResource)(teams, resourceKey);
        if (!team) return;
        const resource = (0, $MQRDu.findResourceFromTeam)(team, resourceKey);
        if (!resource) return false;
        const resourceChange = $daa10cf37ccbaf11$export$e8245c687a3091c3(resource, resourceChangeMeta, team, persons, warnings);
        const resourceChangesForTeam = changes[team.id];
        if (resourceChangesForTeam) resourceChangesForTeam.push(resourceChange);
        else changes[team.id] = [
            resourceChange
        ];
    });
    return changes;
};

});


const $2d1ffdf76d206286$export$16250ffd632e517a = 'common.api.request.status.UNSENT';
const $2d1ffdf76d206286$export$26d55645375ca9a = 'common.api.request.status.LOADING';
const $2d1ffdf76d206286$export$638cc6e36b2a737a = 'common.api.request.status.SUCCESS';
const $2d1ffdf76d206286$export$103bedf43ba882db = 'common.api.request.status.ERROR';

parcelRegister("1bVXL", function(module, exports) {

$parcel$export(module.exports, "getUserFilter", () => $81f2fa2505659c1a$export$5c99253b524db68f);

var $j3zeB = parcelRequire("j3zeB");
const $81f2fa2505659c1a$export$5c99253b524db68f = (state)=>state.ui.Top.TitleBar.UpdateJira.filters[0, $j3zeB.USER_FILTER_ID];

});
parcelRegister("j3zeB", function(module, exports) {

$parcel$export(module.exports, "USER_FILTER_ID", () => $9460694f501ba880$export$f3f93134ef6dbcd6);
$parcel$export(module.exports, "QuickSelectOption", () => $9460694f501ba880$export$72fea0ffa8da318d);
const $9460694f501ba880$export$f3f93134ef6dbcd6 = 'USER_FILTER_ID';
const $9460694f501ba880$export$72fea0ffa8da318d = {
    MINE: 'MINE',
    TODAY: 'TODAY',
    TIMELINE: 'TIMELINE',
    NONE: 'NONE'
};

});



parcelRegister("872dx", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $42e5ef5d8e445cd7$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $42e5ef5d8e445cd7$export$29d55e1f664a246b);
$parcel$export(module.exports, "RESET", () => $42e5ef5d8e445cd7$export$4a991c87e640ef77);
$parcel$export(module.exports, "add", () => $42e5ef5d8e445cd7$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $42e5ef5d8e445cd7$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "reset", () => $42e5ef5d8e445cd7$export$aad8462122ac592b);
const $42e5ef5d8e445cd7$export$bb6389024b71c2ae = 'state.domain.issue-links.ADD';
const $42e5ef5d8e445cd7$export$29d55e1f664a246b = 'state.domain.issue-links.REMOVE';
const $42e5ef5d8e445cd7$export$4a991c87e640ef77 = 'state.domain.issue-links.RESET';
const $42e5ef5d8e445cd7$export$e16d8520af44a096 = (payload)=>({
        type: $42e5ef5d8e445cd7$export$bb6389024b71c2ae,
        payload: payload
    });
const $42e5ef5d8e445cd7$export$cd7f480d6b8286c3 = (payload)=>({
        type: $42e5ef5d8e445cd7$export$29d55e1f664a246b,
        payload: payload
    });
const $42e5ef5d8e445cd7$export$aad8462122ac592b = (payload)=>({
        type: $42e5ef5d8e445cd7$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("hLGUx", function(module, exports) {

$parcel$export(module.exports, "urls", () => $c02cc8ed87d545a5$export$bcae9ba627f604b6);
const $c02cc8ed87d545a5$export$bcae9ba627f604b6 = {
    add: '/rest/jpo/1.0/issuelink/add',
    delete: '/rest/jpo/1.0/issuelink/delete',
    revertChanges: '/rest/jpo/1.0/issuelink/revert'
};

});


parcelRegister("8fleG", function(module, exports) {

$parcel$export(module.exports, "CHANGE_DISPLAY", () => $65ce4418090e467c$export$b08c2aa538b0eed6);
$parcel$export(module.exports, "changeDisplay", () => $65ce4418090e467c$export$d6a8b85d53ecacd8);
const $65ce4418090e467c$export$b08c2aa538b0eed6 = 'state.domain.view-settings.dependency-settings.DISPLAY';
const $65ce4418090e467c$export$d6a8b85d53ecacd8 = (payload)=>({
        type: $65ce4418090e467c$export$b08c2aa538b0eed6,
        payload: payload
    });

});


parcelRegister("bHNJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd8b0d07db819fe$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $5iWql = parcelRequire("5iWql");

var $jPCDz = parcelRequire("jPCDz");

var $3l6tm = parcelRequire("3l6tm");

var $akhOi = parcelRequire("akhOi");

var $6VhAf = parcelRequire("6VhAf");

var $7zlu6 = parcelRequire("7zlu6");

var $dEoWh = parcelRequire("dEoWh");

var $lseqm = parcelRequire("lseqm");

var $kFf60 = parcelRequire("kFf60");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $g8SOd = parcelRequire("g8SOd");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $1TrR5 = parcelRequire("1TrR5");
const $cfd8b0d07db819fe$var$preprocess = (0, $iK4oF.createStructuredSelector)({
    assigneesById: (0, $6VhAf.getAssigneesById),
    externalIssues: (0, $7zlu6.getExternalIssues),
    issues: (0, $cwP4d.getIssues),
    issueLinkTypes: (0, $dEoWh.getDependencyIssueLinkTypes),
    issueCountByLinkType: (0, $dEoWh.getIssueCountByLinkType),
    issueStatusById: (0, $kFf60.getIssueStatusById),
    issueTypes: (0, $lihml.getIssueTypes),
    mode: (0, $akhOi.getMode),
    projectsById: (0, $ehEr2.getProjectsById),
    isOptimizedMode: $akhOi.isOptimizedMode,
    issuesWithOptimizedById: (0, $40hi6.getAllIssuesWithOriginalAndOptimizedById),
    syncStartEnabled: (0, $75KhQ.getSyncStartEnabled),
    dependencyViewSettings: (0, $9H2AP.getDependencySettings)
});
const $cfd8b0d07db819fe$var$mapStateToPropsOld = (state, { direction: direction, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalOriginalIssueLinks: internalOriginalIssueLinks, issue: issue })=>{
    const { assigneesById: assigneesById, externalIssues: externalIssues, issues: issues, issueLinkTypes: issueLinkTypes, issueStatusById: issueStatusById, issueTypes: issueTypes, mode: mode, projectsById: projectsById, isOptimizedMode: // eslint-disable-next-line @typescript-eslint/no-shadow
    isOptimizedMode, issuesWithOptimizedById: issuesWithOptimizedById, syncStartEnabled: syncStartEnabled, issueCountByLinkType: issueCountByLinkType, dependencyViewSettings: dependencyViewSettings } = $cfd8b0d07db819fe$var$preprocess(state);
    const { id: originalIssueId } = issue;
    const otherIssueKey = direction === 'outward' ? 'targetItemKey' : 'sourceItemKey';
    const missingExternalIssues = externalIssueLinks.map((link)=>link[otherIssueKey]).filter((issueId)=>!$jPCDz.default(issueId, externalIssues));
    const externalRows = missingExternalIssues.length > 0 ? [] : (0, $7CnHa.filterMap)((link)=>!!externalIssues[link[otherIssueKey]], (link)=>{
        let isOverlapping = false;
        const { itemKey: itemKey, type: typeId } = link;
        const type = issueLinkTypes.find(({ id: id })=>id === typeId);
        if (!type) throw new Error('Unknown issue link type!');
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const issue = externalIssues[link[otherIssueKey]];
        if (!issue) throw new Error('Unplanned issue!');
        let leadTime;
        if (direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD) {
            const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], isOptimizedMode);
            const targetIssue = externalIssues[issue.id];
            leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
            isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        } else {
            const sourceIssue = externalIssues[issue.id];
            const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], isOptimizedMode);
            leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
            isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        }
        return {
            assignee: {
                personId: issue.userId,
                jiraUser: {
                    avatarUrl: issue.userAvatarUrl,
                    title: issue.userTitle,
                    accountId: issue.userId,
                    email: ''
                }
            },
            isOverlapping: isOverlapping,
            isChanged: false,
            issue: issue,
            issueType: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                id: issue.typeId,
                iconUrl: issue.typeIconUrl,
                name: '',
                level: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE)
            },
            itemKey: itemKey,
            leadTime: leadTime,
            projectKey: issue.projectKey,
            status: {
                id: issue.statusId,
                categoryId: issue.statusCategoryId,
                name: issue.statusName
            },
            syncStartEnabled: syncStartEnabled,
            type: type
        };
    }, externalIssueLinks);
    const internalRows = internalIssueLinks.map(({ itemKey: itemKey, type: typeId, sourceItemKey: sourceItemKey, targetItemKey: targetItemKey })=>{
        const type = issueLinkTypes.find(({ id: id })=>id === typeId);
        if (!type) throw new Error('Unknown issue link type!');
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const issue = issuesWithOptimizedById[direction === 'outward' ? targetItemKey : sourceItemKey];
        if (!issue) throw new Error('Unplanned issue!');
        const issueType = issueTypes.find(({ id: id })=>id === issue.type);
        if (!issueType) throw new Error('Unknown issue type!');
        const project = projectsById[issue.project];
        if (!project) throw new Error('Unknown project!');
        let leadTime;
        let isOverlapping = false;
        if (direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD) {
            const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], isOptimizedMode);
            const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
            isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
        } else {
            const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
            const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], isOptimizedMode);
            isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
            leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
        }
        return {
            assignee: assigneesById[issue.assignee],
            isChanged: !internalOriginalIssueLinks.some((link)=>link.itemKey === itemKey),
            issue: issue,
            issueType: issueType,
            itemKey: itemKey,
            leadTime: leadTime,
            projectKey: project.key,
            status: issueStatusById[issue.status || ''],
            syncStartEnabled: syncStartEnabled,
            type: type,
            isOverlapping: isOverlapping
        };
    });
    return {
        dependencyViewSettings: dependencyViewSettings,
        externalRows: externalRows,
        internalRows: internalRows,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        issues: issues,
        issueLinkTypes: issueLinkTypes,
        issueCountByLinkType: issueCountByLinkType,
        issueTypes: issueTypes,
        missingExternalIssues: missingExternalIssues,
        projectsById: projectsById
    };
};
const $cfd8b0d07db819fe$var$preprocessMemoized = ()=>(0, $df4Sl.createSelector)($cfd8b0d07db819fe$var$preprocess, (res)=>res);
const $cfd8b0d07db819fe$var$mapStateToPropsFactory = ()=>{
    const preprocessInstance = $cfd8b0d07db819fe$var$preprocessMemoized();
    const missingExternalIssuesFactory = (0, $5iWql.default)((externalIssueLinks, otherIssueKey, externalIssues)=>externalIssueLinks.map((link)=>link[otherIssueKey]).filter((issueId)=>!$jPCDz.default(issueId, externalIssues)));
    const externalRowsFactory = (0, $5iWql.default)((missingExternalIssues, externalIssues, otherIssueKey, externalIssueLinks, issueLinkTypes, direction, issuesWithOptimizedById, originalIssueId, statePropsIsOptimizedMode, issueStatusById, syncStartEnabled)=>missingExternalIssues.length > 0 ? [] : (0, $7CnHa.filterMap)((link)=>!!externalIssues[link[otherIssueKey]], (link)=>{
            let isOverlapping = false;
            const { itemKey: itemKey, type: typeId } = link;
            const type = issueLinkTypes.find(({ id: id })=>id === typeId);
            if (!type) throw new Error('Unknown issue link type!');
            const issue = externalIssues[link[otherIssueKey]];
            if (!issue) throw new Error('Unplanned issue!');
            let leadTime;
            if (direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD) {
                const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                const targetIssue = externalIssues[issue.id];
                leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
            } else {
                const sourceIssue = externalIssues[issue.id];
                const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
            }
            return {
                assignee: {
                    personId: issue.userId,
                    jiraUser: {
                        avatarUrl: issue.userAvatarUrl,
                        title: issue.userTitle,
                        accountId: issue.userId,
                        email: ''
                    }
                },
                isOverlapping: isOverlapping,
                isChanged: false,
                issue: issue,
                issueType: {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    id: issue.typeId,
                    iconUrl: issue.typeIconUrl,
                    name: '',
                    level: (0, $3l6tm.ISSUE_HIERARCHY_LEVEL_BASE)
                },
                itemKey: itemKey,
                leadTime: leadTime,
                projectKey: issue.projectKey,
                status: {
                    id: issue.statusId,
                    categoryId: issue.statusCategoryId,
                    name: issue.statusName
                },
                syncStartEnabled: syncStartEnabled,
                type: type
            };
        }, externalIssueLinks));
    const internalRowsFactory = (0, $5iWql.default)((internalIssueLinks, issueLinkTypes, issuesWithOptimizedById, direction, issueTypes, projectsById, originalIssueId, statePropsIsOptimizedMode, issueStatusById, syncStartEnabled, assigneesById, internalOriginalIssueLinks)=>internalIssueLinks.map(({ itemKey: itemKey, type: typeId, sourceItemKey: sourceItemKey, targetItemKey: targetItemKey })=>{
            const type = issueLinkTypes.find(({ id: id })=>id === typeId);
            if (!type) throw new Error('Unknown issue link type!');
            const issue = issuesWithOptimizedById[direction === 'outward' ? targetItemKey : sourceItemKey];
            if (!issue) throw new Error('Unplanned issue!');
            const issueType = issueTypes.find(({ id: id })=>id === issue.type);
            if (!issueType) throw new Error('Unknown issue type!');
            const project = projectsById[issue.project];
            if (!project) throw new Error('Unknown project!');
            let leadTime;
            let isOverlapping = false;
            if (direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD) {
                const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], statePropsIsOptimizedMode);
                leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
                isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
            } else {
                const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], statePropsIsOptimizedMode);
                const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[originalIssueId], statePropsIsOptimizedMode);
                isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
                leadTime = (0, $lseqm.getIssueLinkLeadTime)(sourceIssue, targetIssue);
            }
            return {
                assignee: assigneesById[issue.assignee],
                isChanged: !internalOriginalIssueLinks.some((link)=>link.itemKey === itemKey),
                issue: issue,
                issueType: issueType,
                itemKey: itemKey,
                leadTime: leadTime,
                projectKey: project.key,
                status: issueStatusById[issue.status || ''],
                syncStartEnabled: syncStartEnabled,
                type: type,
                isOverlapping: isOverlapping
            };
        }));
    return (state, { direction: direction, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalOriginalIssueLinks: internalOriginalIssueLinks, issue: issue })=>{
        const { assigneesById: assigneesById, externalIssues: externalIssues, issues: issues, issueLinkTypes: issueLinkTypes, issueStatusById: issueStatusById, issueTypes: issueTypes, mode: mode, projectsById: projectsById, isOptimizedMode: // eslint-disable-next-line @typescript-eslint/no-shadow
        isOptimizedMode, issuesWithOptimizedById: issuesWithOptimizedById, syncStartEnabled: syncStartEnabled, issueCountByLinkType: issueCountByLinkType, dependencyViewSettings: dependencyViewSettings } = preprocessInstance(state);
        const { id: originalIssueId } = issue;
        const otherIssueKey = direction === 'outward' ? 'targetItemKey' : 'sourceItemKey';
        const missingExternalIssues = missingExternalIssuesFactory(externalIssueLinks, otherIssueKey, externalIssues);
        const externalRows = externalRowsFactory(missingExternalIssues, externalIssues, otherIssueKey, externalIssueLinks, issueLinkTypes, direction, issuesWithOptimizedById, originalIssueId, isOptimizedMode, issueStatusById, syncStartEnabled);
        const internalRows = internalRowsFactory(internalIssueLinks, issueLinkTypes, issuesWithOptimizedById, direction, issueTypes, projectsById, originalIssueId, isOptimizedMode, issueStatusById, syncStartEnabled, assigneesById, internalOriginalIssueLinks);
        return {
            dependencyViewSettings: dependencyViewSettings,
            externalRows: externalRows,
            internalRows: internalRows,
            isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
            issues: issues,
            issueLinkTypes: issueLinkTypes,
            issueCountByLinkType: issueCountByLinkType,
            issueTypes: issueTypes,
            missingExternalIssues: missingExternalIssues,
            projectsById: projectsById
        };
    };
};
// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
const $cfd8b0d07db819fe$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($cfd8b0d07db819fe$var$mapStateToPropsFactory, $cfd8b0d07db819fe$var$mapStateToPropsOld);
var $cfd8b0d07db819fe$export$2e2bcd8739ae039 = $cfd8b0d07db819fe$var$mapStateToProps;

});

parcelRegister("fSR6b", function(module, exports) {

$parcel$export(module.exports, "default", () => $4232370885721679$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldYmX = parcelRequire("ldYmX");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $4ki2H = parcelRequire("4ki2H");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");
var $eYlCJ = parcelRequire("eYlCJ");

var $cuuJa = parcelRequire("cuuJa");


var $a4vO3 = parcelRequire("a4vO3");

var $4UWBa = parcelRequire("4UWBa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $ku3Ew = parcelRequire("ku3Ew");

var $5TLgG = parcelRequire("5TLgG");

var $4MgLQ = parcelRequire("4MgLQ");

var $jiwIZ = parcelRequire("jiwIZ");

var $eukez = parcelRequire("eukez");

var $jqssy = parcelRequire("jqssy");

var $4CIha = parcelRequire("4CIha");

var $akJHc = parcelRequire("akJHc");

var $8AwJn = parcelRequire("8AwJn");
// eslint-disable-next-line jira/react/no-class-components
class $4232370885721679$var$DependenciesFlyout extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { loadExternalIssues: loadExternalIssues, missingExternalIssues: missingExternalIssues } = this.props;
        if (missingExternalIssues.length > 0) loadExternalIssues(missingExternalIssues);
    }
    render() {
        const { addDependency: addDependency, context: context, direction: direction, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalRows: internalRows, isReadOnly: isReadOnly, issue: issue, issueLinkTypes: issueLinkTypes, issueCountByLinkType: issueCountByLinkType, issueTypes: issueTypes, issues: issues, missingExternalIssues: missingExternalIssues, projectsById: projectsById, updatePopup: updatePopup } = this.props;
        const addDependencyProps = {
            addDependency: addDependency,
            context: context,
            issueCountByLinkType: issueCountByLinkType,
            direction: direction,
            isInitiallyAddingNewDependency: this.getRowsCount() === 0 && missingExternalIssues.length === 0,
            issue: issue,
            issueLinkTypes: issueLinkTypes,
            internalIssueLinks: internalIssueLinks,
            issueTypes: issueTypes,
            issues: issues,
            projectsById: projectsById,
            ...(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? {
                updatePopup: updatePopup
            } : {}
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: this.fireViewDependencyFlyOutAnalyticsEvent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
            className: $8AwJn.table
        }, this.getRowsCount() > 0 || missingExternalIssues.length > 0 ? this.renderHeader() : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, internalRows.map((row)=>this.renderRow(row)), !(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ku3Ew.default), addDependencyProps) : null, externalIssueLinks.length > 0 ? this.renderExternalDependencies() : null)), (0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ku3Ew.default), addDependencyProps) : null, !addDependencyProps.isInitiallyAddingNewDependency && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $8AwJn.footerActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, this.quickFilter(), !isReadOnly && this.renderFilterDependencyGraphFromRoadmapLink()), this.toggleDependencyViewButton()));
    }
    constructor(...args){
        super(...args);
        this.fireViewDependencyFlyOutAnalyticsEvent = (analyticsEvent)=>{
            const { context: context, externalRows: externalRows, internalRows: internalRows } = this.props;
            const conflictCount = $ldYmX.default((acc, row)=>row.leadTime && row.leadTime < 0 ? acc + 1 : acc, 0, internalRows.concat(externalRows));
            let analyticsKey = '';
            if (context === 'dropdown') analyticsKey = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_DEPENDENCY_FLYOUT_FROM_DROPDOWN;
            else if (context === 'badge') analyticsKey = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_DEPENDENCY_FLYOUT_FROM_BADGE;
            if (analyticsKey) {
                const [actionSubject, eventAction] = analyticsKey.split(' ');
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                    action: eventAction,
                    actionSubject: actionSubject
                }), analyticsKey, {
                    conflictCount: conflictCount
                });
            }
        };
        this.onRemoveDependency = ({ itemKey: itemKey, issue: { id: id }, type: type })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e)=>{
                // prevent InlineDialog from closing
                // it's required because at the moment InlineDialog processes event
                // current button is removed from DOM because row was removed
                // as dependency was removed by the removeDependency call
                // and InlineDialog thinks that it was click outside
                e.preventDefault();
                const { removeDependency: removeDependency, issue: issue, direction: direction } = this.props;
                removeDependency({
                    itemKey: itemKey,
                    sourceItemKey: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD ? issue.id : id,
                    targetItemKey: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD ? id : issue.id,
                    type: type.id
                });
            };
        this.renderRow = (row, isReadOnly = this.props.isReadOnly)=>{
            const { direction: direction } = this.props;
            const { isChanged: isChanged, issue: issue, type: type, projectKey: projectKey } = row;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                key: `${type.id}:${issue.id}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $8AwJn["change-indicator"]
            }, isChanged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), {
                appearance: "bar"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $8AwJn.typeCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4CIha.default), {
                row: row,
                direction: direction
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4MgLQ.default), {
                row: row
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jqssy.default), {
                row: row
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $8AwJn.assigneeCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TLgG.default), {
                row: row
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiwIZ.default), {
                row: row
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, !isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eukez.default), {
                issueKey: issue.issueKey,
                projectKey: projectKey,
                onClick: this.onRemoveDependency(row),
                ...(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? {
                    updatePopup: this.props.updatePopup
                } : {}
            }) : null));
        };
        this.renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $akJHc.default).typeHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $akJHc.default).issueHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $akJHc.default).statusHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).assignee)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $akJHc.default).leadTimeHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", null)));
        this.renderExternalDependencies = ()=>{
            const { externalRows: externalRows, missingExternalIssues: missingExternalIssues } = this.props;
            const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 6,
                className: $8AwJn.externalDependenciesHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $akJHc.default).externalDependenciesHeader)));
            let content = null;
            if (missingExternalIssues.length > 0) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 6
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
                size: "small",
                delay: 0
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                style: {
                    paddingLeft: "var(--ds-space-150, 12px)"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).loadingIssuesMessage))));
            else content = externalRows.map((row)=>this.renderRow(row, true));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, content);
        };
        this.getRowsCount = ()=>this.props.externalRows.length + this.props.internalRows.length;
        this.quickFilter = ()=>{
            const { issue: issue, projectsById: projectsById, QuickFilter: QuickFilter } = this.props;
            const issueKey = issue.issueKey ? `${projectsById[issue.project].key}-${issue.issueKey}` : 'ScenarioIssue';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QuickFilter, {
                value: {
                    id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                    value: {
                        type: 'specificIssue',
                        issueId: issue.id,
                        includeTransitive: false
                    }
                },
                clearable: true,
                clearText: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $8AwJn["remove-filter"]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
                    label: ""
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $akJHc.default).removeQuickFilterText,
                    values: {
                        issueKey: issueKey
                    }
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akJHc.default).addQuickFilterText,
                values: {
                    issueKey: issueKey
                }
            }));
        };
        this.handleToggleDependencyView = (_, analyticsEvent)=>{
            const { changeDependencySettingsDisplay: changeDependencySettingsDisplay, dependencyViewSettings: dependencyViewSettings } = this.props;
            const { display: display } = dependencyViewSettings;
            const nextSetting = display === (0, $5rYNM.LINES) ? (0, $5rYNM.DEFAULT) : (0, $5rYNM.LINES);
            changeDependencySettingsDisplay({
                display: nextSetting
            });
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_DEPENDENCY_STYLE.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), {
                dependencyStyle: nextSetting
            });
        };
        this.toggleDependencyViewButton = ()=>{
            const { dependencyViewSettings: dependencyViewSettings } = this.props;
            const { display: display } = dependencyViewSettings;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                spacing: "none",
                onClick: this.handleToggleDependencyView
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akJHc.default).toggleDependencyViewButton,
                values: {
                    value: display
                }
            }));
        };
        this.renderFilterDependencyGraphFromRoadmapLink = ()=>{
            const { issue: issue, projectsById: projectsById, FilterDependencyGraphFromRoadmap: FilterDependencyGraphFromRoadmap } = this.props;
            const issueKey = issue.issueKey ? `${projectsById[issue.project].key}-${issue.issueKey}` : 'ScenarioIssue';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterDependencyGraphFromRoadmap, {
                issueId: issue.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $akJHc.default).visualizeDependencies,
                values: {
                    issueKey: issueKey
                }
            }));
        };
    }
}
var $4232370885721679$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    source: 'dependenciesFlyoutDialog'
})((0, $2jDha.default)()((0, $a4vO3.withSlots)({
    FilterDependencyGraphFromRoadmap: (0, $a4vO3.slots).FilterDependencyGraphFromRoadmap,
    QuickFilter: (0, $a4vO3.slots).QuickFilter
})($4232370885721679$var$DependenciesFlyout)));

});
parcelRegister("ku3Ew", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ff17dea995f03c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");

var $cuuJa = parcelRequire("cuuJa");

var $5rYNM = parcelRequire("5rYNM");

var $jMP2a = parcelRequire("jMP2a");

var $k8M5E = parcelRequire("k8M5E");

var $3JksF = parcelRequire("3JksF");

var $32jwX = parcelRequire("32jwX");
class $a0ff17dea995f03c$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { addDependencyIssue: addDependencyIssue, addDependencyType: addDependencyType, isAddingNewDependency: isAddingNewDependency } = this.state;
        if (!isAddingNewDependency) return this.renderAddDependencyButton();
        const { direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, internalIssueLinks: internalIssueLinks, issueTypes: issueTypes, issues: issues, projectsById: projectsById, isInitiallyAddingNewDependency: isInitiallyAddingNewDependency } = this.props;
        const dependencySelectorProps = {
            addDependencyIssue: addDependencyIssue,
            addDependencyType: addDependencyType,
            direction: direction,
            issue: issue,
            issueLinkTypes: issueLinkTypes,
            internalIssueLinks: internalIssueLinks,
            issueTypes: issueTypes,
            issues: issues,
            onAddDependencyCancel: this.onAddDependencyCancel,
            onAddDependencyConfirm: this.onAddDependencyConfirm,
            onChangeDependencyIssue: this.onChangeDependencyIssue,
            onChangeDependencyType: this.onChangeDependencyType,
            projectsById: projectsById,
            ...(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? {
                isInitiallyAddingNewDependency: isInitiallyAddingNewDependency
            } : {}
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8M5E.default), dependencySelectorProps);
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAddingNewDependency: this.props.isInitiallyAddingNewDependency,
            addDependencyIssue: null,
            addDependencyType: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onAddDependency = (e)=>{
            // prevent InlineDialog from closing
            // it's required because at the moment InlineDialog processes event
            // current button is removed from DOM because view is flipped
            // and InlineDialog thinks that it was click outside
            e.preventDefault();
            this.setState({
                isAddingNewDependency: true
            });
            if ((0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && this.props.updatePopup) this.props.updatePopup();
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onAddDependencyConfirm = (e, analyticsEvent)=>{
            // prevent InlineDialog from closing
            // it's required because at the moment InlineDialog processes event
            // current button is removed from DOM because view is flipped
            // and InlineDialog thinks that it was click outside
            e.preventDefault();
            const { addDependency: addDependency, direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, context: context, issueCountByLinkType: issueCountByLinkType } = this.props;
            const { addDependencyType: addDependencyType, addDependencyIssue: addDependencyIssue } = this.state;
            if (!addDependencyIssue) throw new Error('Target issue is not selected!');
            // note: this is a workaround to fix a gnarkly TS issue
            const newIssue = addDependencyIssue;
            const type = (addDependencyType || issueLinkTypes[0]).id;
            if (direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD) addDependency({
                sourceItemKey: issue.id,
                targetItemKey: newIssue.id,
                type: type
            });
            else addDependency({
                sourceItemKey: newIssue.id,
                targetItemKey: issue.id,
                type: type
            });
            this.setState({
                isAddingNewDependency: false
            });
            if ((0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && this.props.updatePopup) this.props.updatePopup();
            // triggering analytics when a user adds a new dependency relationship to an issue in the plan
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADDED_ISSUE_DEPENDENCY_LINK.split(' ');
            const analyticsPayload = {
                source: context,
                type: type,
                typeCount: issueCountByLinkType[type] || 0
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), analyticsPayload);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onAddDependencyCancel = (e)=>{
            // prevent InlineDialog from closing
            // it's required because at the moment InlineDialog processes event
            // current button is removed from DOM because view is flipped
            // and InlineDialog thinks that it was click outside
            e.preventDefault();
            this.setState({
                isAddingNewDependency: false
            });
            if ((0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && this.props.updatePopup) this.props.updatePopup();
        };
        this.onChangeDependencyType = (option)=>{
            if (option?.type === undefined) throw new Error('Make sure that dependency selector items have type injected');
            this.setState({
                addDependencyType: option.type
            });
        };
        this.onChangeDependencyIssue = (option)=>{
            this.setState({
                addDependencyIssue: option
            });
            if ((0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && this.props.updatePopup) this.props.updatePopup();
        };
        this.renderAddDependencyButton = ()=>(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                onClick: this.onAddDependency,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3JksF.default).addDependencyLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.add-dependency-page-rows"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 5,
                className: $32jwX.noButtonPadding
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                onClick: this.onAddDependency,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3JksF.default).addDependencyLabel))));
    }
}

});
parcelRegister("k8M5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaab57f83f08bed5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f2C9X = parcelRequire("f2C9X");

var $9nt1B = parcelRequire("9nt1B");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");

var $6ai6B = parcelRequire("6ai6B");

var $5rYNM = parcelRequire("5rYNM");

var $kRIMQ = parcelRequire("kRIMQ");

var $3Rbzs = parcelRequire("3Rbzs");

var $2F7ka = parcelRequire("2F7ka");

var $dcHV8 = parcelRequire("dcHV8");
// eslint-disable-next-line jira/react/no-class-components
class $aaab57f83f08bed5$var$DependencySelector extends (0, $eUqFw.Component) {
    render() {
        const { addDependencyType: addDependencyType, direction: direction, issue: issue, issueLinkTypes: issueLinkTypes, issueTypes: issueTypes, issues: issues, onChangeDependencyIssue: onChangeDependencyIssue, onChangeDependencyType: onChangeDependencyType, projectsById: projectsById, isInitiallyAddingNewDependency: isInitiallyAddingNewDependency } = this.props;
        const typeSelectorProps = {
            addDependencyType: addDependencyType,
            direction: direction,
            issueLinkTypes: issueLinkTypes,
            onChangeDependencyType: onChangeDependencyType
        };
        const issueSelectorProps = {
            issue: issue,
            issueTypes: issueTypes,
            issues: issues,
            onChangeDependencyIssue: onChangeDependencyIssue,
            projectsById: projectsById
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ai6B.DependenciesDialogContext).Consumer, null, ({ toggleDialogLocked: toggleDialogLocked })=>(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                xcss: $aaab57f83f08bed5$var$inlineStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: [
                    $aaab57f83f08bed5$var$addDependencyTypeStyles,
                    !isInitiallyAddingNewDependency && $aaab57f83f08bed5$var$addDependencyTypeLeftStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcHV8.default), {
                ...typeSelectorProps,
                toggleDialogLocked: toggleDialogLocked('TypeSelector'),
                ariaLabel: this.props.intl.formatMessage((0, $3Rbzs.default).dependencyTypeSelectorLabel)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $aaab57f83f08bed5$var$addDependencyIssueStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRIMQ.default), {
                ...issueSelectorProps,
                toggleDialogLocked: toggleDialogLocked('IssueSelector')
            })), this.renderConfirmButton(), this.renderCancelButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $2F7ka.addDependencyType
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcHV8.default), {
                ...typeSelectorProps,
                toggleDialogLocked: toggleDialogLocked('TypeSelector'),
                ariaLabel: this.props.intl.formatMessage((0, $3Rbzs.default).dependencyTypeSelectorLabel)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 5
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $2F7ka.addDependencyIssue
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRIMQ.default), {
                ...issueSelectorProps,
                toggleDialogLocked: toggleDialogLocked('IssueSelector')
            }), this.renderConfirmButton(), this.renderCancelButton()))));
    }
    constructor(...args){
        super(...args);
        this.renderConfirmButton = ()=>{
            const { addDependencyIssue: addDependencyIssue, addDependencyType: addDependencyType, direction: direction, internalIssueLinks: internalIssueLinks, issueLinkTypes: issueLinkTypes, intl: { formatMessage: formatMessage }, onAddDependencyConfirm: onAddDependencyConfirm } = this.props;
            const type = addDependencyType || $f2C9X.default(issueLinkTypes);
            const typeId = type && type.id;
            const otherIssueKey = direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD ? 'targetItemKey' : 'sourceItemKey';
            // do not allow to confirm when issue is not selected or the same type-issue pair already exists
            const isDisabled = !typeId || !addDependencyIssue || !!internalIssueLinks.find(// eslint-disable-next-line @typescript-eslint/no-shadow
            ({ type: type, [otherIssueKey]: otherIssueId })=>type === typeId && otherIssueId === addDependencyIssue.id);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                ariaLabel: formatMessage((0, $3Rbzs.default).dependencyConfirmButtonAriaLabel),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $2F7ka.addDependencyButton,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
                    label: "",
                    size: "small"
                }),
                isDisabled: isDisabled,
                onClick: onAddDependencyConfirm,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-confirm-btn"
            });
        };
        this.renderCancelButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                ariaLabel: this.props.intl.formatMessage((0, $3Rbzs.default).dependencyCancelButtonAriaLabel),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $2F7ka.addDependencyButton,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    label: "",
                    size: "small"
                }),
                onClick: this.props.onAddDependencyCancel,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.button"
            });
    }
}
const $aaab57f83f08bed5$var$inlineStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $aaab57f83f08bed5$var$addDependencyIssueStyles = (0, $1ZAYh.xcss)({
    minWidth: '300px',
    flexWrap: 'nowrap',
    flex: '1'
});
const $aaab57f83f08bed5$var$addDependencyTypeStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.100',
    minWidth: '164px'
});
const $aaab57f83f08bed5$var$addDependencyTypeLeftStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});
var $aaab57f83f08bed5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($aaab57f83f08bed5$var$DependencySelector);

});
parcelRegister("kRIMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb637737c1e52eb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $akSC8 = parcelRequire("akSC8");

var $1ni3W = parcelRequire("1ni3W");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $hWsdP = parcelRequire("hWsdP");

var $T4pxu = parcelRequire("T4pxu");
// eslint-disable-next-line jira/react/no-class-components
class $8bb637737c1e52eb$var$IssueSelector extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.renderDependencyIssue = (issue)=>{
            const { issueTypes: issueTypes } = this.props;
            const issueType = issueTypes.find(({ id: id })=>id === issue.type);
            return (0, $akSC8.selectIssueOption)({
                icon: issueType && issueType.iconUrl,
                label: this.getDependencyIssueValue(issue)
            });
        };
        this.getDependencyIssueValue = ({ issueKey: issueKey, project: projectId, summary: summary })=>{
            const { projectsById: projectsById } = this.props;
            const project = projectsById[projectId || NaN];
            const key = issueKey ? `${project.key}-${issueKey}` : project.key;
            return `${key} ${summary}`;
        };
        this.loadOptions = (query)=>{
            const { issue: { id: id } } = this.props;
            const q = query.toLowerCase();
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const options = this.props.issues.reduce((options, issue)=>{
                if (options.length < 50 && this.getDependencyIssueValue(issue).toLowerCase().includes(q) && issue.id !== id) options.push({
                    ...issue,
                    label: this.getDependencyIssueValue(issue)
                });
                return options;
            }, []);
            return Promise.resolve(options);
        };
        this.onMenuOpen = ()=>{
            this.props.toggleDialogLocked(true);
        };
        this.onMenuClose = ()=>{
            this.props.toggleDialogLocked(false);
        };
        this.menuContainer = document.createElement('div');
        this.menuContainer.style.pointerEvents = 'none';
        // menu container is stretched to the viewport size and clips menu
        // if it extends outside viewport to prevent breaking page layout and jumps
        this.menuContainer.classList.add($T4pxu.menuContainer);
        (0, $1ni3W.getBody)().appendChild(this.menuContainer);
    }
    componentWillUnmount() {
        (0, $1ni3W.removeNode)(this.menuContainer);
    }
    render() {
        const { onChangeDependencyIssue: onChangeDependencyIssue, intl: intl } = this.props;
        return (0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $8bb637737c1e52eb$var$addDependencyIssueSelectorStyles,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.dependency-flyout-issue-selector"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LimL.AsyncSelect), {
            autoFocus: true,
            defaultOptions: true,
            // @ts-expect-error - TS2322 - Type '(issue: Issue) => JSX.Element' is not assignable to type '(arg1: OptionType, arg2: FormatOptionLabelMeta) => ReactElement<any, string | JSXElementConstructor<any>>'.
            formatOptionLabel: this.renderDependencyIssue,
            getOptionValue: this.getDependencyIssueValue,
            isClearable: true,
            isTransparentBackground: false,
            loadOptions: this.loadOptions,
            menuPlacement: "auto",
            menuPortalTarget: this.menuContainer,
            // @ts-expect-error - TS2322 - Type '(arg1?: Readonly<{ assignee: string; assignments: Assignment[]; annotations?: Annotation[] | undefined; baselineStart?: number | null | undefined; baselineEnd?: number | null | undefined; ... 30 more ...; inferred?: InferredFields | undefined; }> | null | undefined) => void' is not assignable to type '(arg1: ValueType, arg2: ActionMeta) => void'.
            onChange: onChangeDependencyIssue,
            placeholder: intl.formatMessage((0, $hWsdP.default).issueSelectorPlaceholder),
            styles: {
                menuPortal: (menuPortalStyles)=>({
                        ...menuPortalStyles,
                        zIndex: 1000,
                        pointerEvents: 'initial'
                    })
            },
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            "aria-label": intl.formatMessage((0, $hWsdP.default).issueSelectorLabel)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $T4pxu.addDependencyIssueSelector,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.dependency-flyout-issue-selector"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LimL.AsyncSelect), {
            autoFocus: true,
            defaultOptions: true,
            // @ts-expect-error - TS2322 - Type '(issue: Issue) => JSX.Element' is not assignable to type '(arg1: OptionType, arg2: FormatOptionLabelMeta) => ReactElement<any, string | JSXElementConstructor<any>>'.
            formatOptionLabel: this.renderDependencyIssue,
            getOptionValue: this.getDependencyIssueValue,
            isClearable: true,
            isTransparentBackground: false,
            loadOptions: this.loadOptions,
            menuPlacement: "auto",
            menuPortalTarget: this.menuContainer,
            // @ts-expect-error - TS2322 - Type '(arg1?: Readonly<{ assignee: string; assignments: Assignment[]; annotations?: Annotation[] | undefined; baselineStart?: number | null | undefined; baselineEnd?: number | null | undefined; ... 30 more ...; inferred?: InferredFields | undefined; }> | null | undefined) => void' is not assignable to type '(arg1: ValueType, arg2: ActionMeta) => void'.
            onChange: onChangeDependencyIssue,
            // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hWsdP.default).issueSelectorPlaceholder),
            styles: {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                menuPortal: (styles)=>({
                        ...styles,
                        zIndex: 1000,
                        pointerEvents: 'initial'
                    })
            },
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "portfolio-3-portfolio-app-simple-plans-main-tabs-roadmap-fields-columns-cells-dependencies-flyout-add-dependency-dependency-selector-issue-selector",
            "aria-label": intl.formatMessage((0, $hWsdP.default).issueSelectorLabel)
        }));
    }
}
const $8bb637737c1e52eb$var$addDependencyIssueSelectorStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
var $8bb637737c1e52eb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($8bb637737c1e52eb$var$IssueSelector);

});
parcelRegister("hWsdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9ecfe575da6d681$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e9ecfe575da6d681$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueSelectorPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.issue-selector-placeholder",
        "defaultMessage": "Choose an issue..."
    },
    issueSelectorLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.issue-selector.issue-selector-label",
        "defaultMessage": "Select an issue"
    }
});

});

parcelRegister("T4pxu", function(module, exports) {

$parcel$export(module.exports, "addDependencyIssueSelector", () => $0a588f15f1121c02$export$d0c9710459ab31d6, (v) => $0a588f15f1121c02$export$d0c9710459ab31d6 = v);
$parcel$export(module.exports, "menuContainer", () => $0a588f15f1121c02$export$8ef325e9124f92b2, (v) => $0a588f15f1121c02$export$8ef325e9124f92b2 = v);
var $0a588f15f1121c02$export$d0c9710459ab31d6;
var $0a588f15f1121c02$export$8ef325e9124f92b2;
$0a588f15f1121c02$export$d0c9710459ab31d6 = `s9hvAq_addDependencyIssueSelector`;
$0a588f15f1121c02$export$8ef325e9124f92b2 = `s9hvAq_menuContainer`;

});


parcelRegister("3Rbzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac15767130c7023$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fac15767130c7023$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dependencyConfirmButtonAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-confirm-button-aria-label",
        "defaultMessage": "Confirm"
    },
    dependencyCancelButtonAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-cancel-button-aria-label",
        "defaultMessage": "Clear"
    },
    dependencyTypeSelectorLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.dependency-selector.dependency-type-selector-label",
        "defaultMessage": "Issue type"
    }
});

});

parcelRegister("2F7ka", function(module, exports) {

$parcel$export(module.exports, "addDependencyButton", () => $1f0517935b8e9f0b$export$a67007520ef868ed, (v) => $1f0517935b8e9f0b$export$a67007520ef868ed = v);
$parcel$export(module.exports, "addDependencyIssue", () => $1f0517935b8e9f0b$export$14c861700ae81b70, (v) => $1f0517935b8e9f0b$export$14c861700ae81b70 = v);
$parcel$export(module.exports, "addDependencyType", () => $1f0517935b8e9f0b$export$8aa27b4fe6bcbcf7, (v) => $1f0517935b8e9f0b$export$8aa27b4fe6bcbcf7 = v);
var $1f0517935b8e9f0b$export$a67007520ef868ed;
var $1f0517935b8e9f0b$export$14c861700ae81b70;
var $1f0517935b8e9f0b$export$8aa27b4fe6bcbcf7;
$1f0517935b8e9f0b$export$a67007520ef868ed = `_3zxRDW_addDependencyButton`;
$1f0517935b8e9f0b$export$14c861700ae81b70 = `_3zxRDW_addDependencyIssue`;
$1f0517935b8e9f0b$export$8aa27b4fe6bcbcf7 = `_3zxRDW_addDependencyType`;

});

parcelRegister("dcHV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5622645e2ae74454$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f2C9X = parcelRequire("f2C9X");

var $1ni3W = parcelRequire("1ni3W");

var $gGKRb = parcelRequire("gGKRb");

var $7C0Jk = parcelRequire("7C0Jk");

var $jZxfJ = parcelRequire("jZxfJ");
class $5622645e2ae74454$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onMenuOpen = ()=>{
            this.props.toggleDialogLocked(true);
        };
        this.onMenuClose = ()=>{
            this.props.toggleDialogLocked(false);
        };
        this.menuContainer = document.createElement('div');
        this.menuContainer.style.pointerEvents = 'none';
        // menu container is stretched to the viewport size and clips menu
        // if it extends outside viewport to prevent breaking page layout and jumps
        this.menuContainer.classList.add($jZxfJ.menuContainer);
        (0, $1ni3W.getBody)().appendChild(this.menuContainer);
    }
    componentWillUnmount() {
        (0, $1ni3W.removeNode)(this.menuContainer);
    }
    render() {
        const { addDependencyType: addDependencyType, issueLinkTypes: issueLinkTypes, direction: direction, onChangeDependencyType: onChangeDependencyType, ariaLabel: ariaLabel } = this.props;
        const options = issueLinkTypes.map((type)=>({
                label: (0, $7C0Jk.titleCase)(type[direction]),
                value: `${type.id}`,
                type: type
            }));
        const value = addDependencyType ? options.find(({ type: type })=>type.id === addDependencyType.id) : $f2C9X.default(options);
        const select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGKRb.default), {
            value: value,
            menuPlacement: "auto",
            menuPortalTarget: this.menuContainer,
            isDisabled: !value,
            isClearable: false,
            isSearchable: false,
            isTransparentBackground: false,
            options: options,
            onChange: onChangeDependencyType,
            styles: {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                menuPortal: (styles)=>({
                        ...styles,
                        zIndex: 1000,
                        pointerEvents: 'initial'
                    })
            },
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            "aria-label": ariaLabel
        }));
        return select;
    }
}

});
parcelRegister("7C0Jk", function(module, exports) {

$parcel$export(module.exports, "titleCase", () => $46a3a3ce466f7473$export$348afa8c9ff47183);
const $46a3a3ce466f7473$export$348afa8c9ff47183 = (s)=>s[0].toUpperCase() + s.slice(1);

});

parcelRegister("jZxfJ", function(module, exports) {

$parcel$export(module.exports, "menuContainer", () => $e8dd821ff9c1e3fe$export$8ef325e9124f92b2, (v) => $e8dd821ff9c1e3fe$export$8ef325e9124f92b2 = v);
var $e8dd821ff9c1e3fe$export$8ef325e9124f92b2;
$e8dd821ff9c1e3fe$export$8ef325e9124f92b2 = `wBHyJG_menuContainer`;

});



parcelRegister("3JksF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb655bcfddaedca$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5bb655bcfddaedca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addDependencyLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-dependency.add-dependency-label",
        "defaultMessage": "+ Add dependency"
    }
});

});

parcelRegister("32jwX", function(module, exports) {

$parcel$export(module.exports, "noButtonPadding", () => $2360b5647f20ff7b$export$a4d97e03f045b43b, (v) => $2360b5647f20ff7b$export$a4d97e03f045b43b = v);
var $2360b5647f20ff7b$export$a4d97e03f045b43b;
$2360b5647f20ff7b$export$a4d97e03f045b43b = `_9Kn8pq_noButtonPadding`;

});


parcelRegister("5TLgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab877cf6b8d16f87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $2qhQi = parcelRequire("2qhQi");

var $ib5d3 = parcelRequire("ib5d3");

var $ej7oV = parcelRequire("ej7oV");
function $ab877cf6b8d16f87$var$AssigneeCell(props) {
    const { intl: intl, row: { assignee: assignee } } = props;
    if (!assignee) return null;
    const { jiraUser: { avatarUrl: avatarUrl, title: title, accountId: accountId } } = assignee;
    const name = title || accountId || intl.formatMessage((0, $ib5d3.default).unassigned);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $ej7oV.assignee
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: avatarUrl ?? undefined,
        name: name
    }))));
}
var $ab877cf6b8d16f87$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ab877cf6b8d16f87$var$AssigneeCell);

});
parcelRegister("ej7oV", function(module, exports) {

$parcel$export(module.exports, "assignee", () => $a6a894bd0b5061c5$export$65bc3e250c89c0e4, (v) => $a6a894bd0b5061c5$export$65bc3e250c89c0e4 = v);
var $a6a894bd0b5061c5$export$65bc3e250c89c0e4;
$a6a894bd0b5061c5$export$65bc3e250c89c0e4 = `F04w9G_assignee`;

});


parcelRegister("4MgLQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4f5301373d24b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hl4M2 = parcelRequire("hl4M2");

var $akWeR = parcelRequire("akWeR");
function $7f4f5301373d24b3$export$2e2bcd8739ae039({ row: { issue: issue, issueType: issueType, projectKey: projectKey } }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $akWeR.issueTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $akWeR.issueIcon,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundSize: 'contain',
            backgroundImage: issueType && `url(${issueType.iconUrl})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $akWeR.issueSummary,
        title: issue.summary,
        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.issue-${issue.id}.summary`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issueKey: issue.issueKey,
        projectKey: projectKey,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $akWeR.issueLink
    }), issue.summary)));
}

});
parcelRegister("akWeR", function(module, exports) {

$parcel$export(module.exports, "issueIcon", () => $7868f2a480290762$export$415983cbc1f2b3fe, (v) => $7868f2a480290762$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $7868f2a480290762$export$b71709449311b2f9, (v) => $7868f2a480290762$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueSummary", () => $7868f2a480290762$export$7c7bc027bbbea103, (v) => $7868f2a480290762$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $7868f2a480290762$export$12781bd67c11efd8, (v) => $7868f2a480290762$export$12781bd67c11efd8 = v);
var $7868f2a480290762$export$415983cbc1f2b3fe;
var $7868f2a480290762$export$b71709449311b2f9;
var $7868f2a480290762$export$7c7bc027bbbea103;
var $7868f2a480290762$export$12781bd67c11efd8;
$7868f2a480290762$export$415983cbc1f2b3fe = `_8vVz8q_issueIcon`;
$7868f2a480290762$export$b71709449311b2f9 = `_8vVz8q_issueLink`;
$7868f2a480290762$export$7c7bc027bbbea103 = `_8vVz8q_issueSummary`;
$7868f2a480290762$export$12781bd67c11efd8 = `_8vVz8q_issueTitle`;

});


parcelRegister("jiwIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a0960867b45421$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $17L5s = parcelRequire("17L5s");

var $7CnHa = parcelRequire("7CnHa");

var $4xHig = parcelRequire("4xHig");

var $9FTTF = parcelRequire("9FTTF");

var $lUPZ4 = parcelRequire("lUPZ4");
function $27a0960867b45421$export$2e2bcd8739ae039({ row: { issue: issue, leadTime: leadTime, isOverlapping: isOverlapping, syncStartEnabled: syncStartEnabled } }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    let leadTimeMessage = '';
    if ((0, $7CnHa.isDefined)(leadTime)) {
        // if "end date" of issue A is May 4, 2021 and "start date" of issue B is May 5, 2021, then leadTime = 1
        if (leadTime === 1) // we display a leadTimeMessage "less than a day"
        // note: we don't use distanceInWordsToNowWithPolarity as it would return 'less than a minute'
        leadTimeMessage = formatMessage((0, $9FTTF.default).lessThanOneDayLeadTime);
        else if (// if "end date" of issue A is May 4, 2021 and "start date" of issue B is May 4, 2021, then leadTime = -86399999
        Math.abs(leadTime) < (0, $17L5s.ONE_DAY) || leadTime < 0 && !isOverlapping && syncStartEnabled) // we display a leadTimeMessage of "0 days"
        leadTimeMessage = formatMessage((0, $9FTTF.default).zeroLeadTime);
        else leadTimeMessage = (0, $17L5s.distanceInWordsToNowWithPolarity)(locale, Date.now() + leadTime);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7CnHa.isDefined)(leadTime) && leadTime < 0 && !(!isOverlapping && syncStartEnabled) ? $lUPZ4.warning : '',
        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.issue-${issue.id}.lead-time`
    }, leadTimeMessage);
}

});
parcelRegister("9FTTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f0967c1504390d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $16f0967c1504390d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    lessThanOneDayLeadTime: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.lead-time.less-than-one-day-lead-time",
        "defaultMessage": "+ < 1 day"
    },
    zeroLeadTime: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.lead-time.zero-lead-time",
        "defaultMessage": "0 days"
    }
});

});

parcelRegister("lUPZ4", function(module, exports) {

$parcel$export(module.exports, "warning", () => $ff4726dd7cbf0bf0$export$491112666e282270, (v) => $ff4726dd7cbf0bf0$export$491112666e282270 = v);
var $ff4726dd7cbf0bf0$export$491112666e282270;
$ff4726dd7cbf0bf0$export$491112666e282270 = `Gn7wnW_warning`;

});


parcelRegister("eukez", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e94881179b15f80$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fEMj1 = parcelRequire("fEMj1");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");

var $33N5G = parcelRequire("33N5G");

var $jMP2a = parcelRequire("jMP2a");

var $iRWKu = parcelRequire("iRWKu");

var $7Euzz = parcelRequire("7Euzz");
function $5e94881179b15f80$var$RemoveCell(props) {
    const { intl: intl, issueKey: issueKey, projectKey: projectKey } = props;
    const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClick = (event, analyticsEvent)=>{
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DELETED_ISSUE_DEPENDENCY_LINK.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: action,
            actionSubject: actionSubject
        }));
        if ((0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') && props.updatePopup) props.updatePopup();
        props.onClick(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $iRWKu.default).removeDependency)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $7Euzz.trashcan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: onClick,
        ariaLabel: `${intl.formatMessage((0, $iRWKu.default).removeDependency)}: ${fullIssueKey}`,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.remove"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
        label: "",
        size: "small",
        primaryColor: (0, $33N5G.DEFAULT_COLOR)
    }))));
}
var $5e94881179b15f80$export$2e2bcd8739ae039 = (0, $2qhQi.default)($5e94881179b15f80$var$RemoveCell);

});
parcelRegister("fEMj1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6600ff3072270d9$var$_react = $b6600ff3072270d9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b6600ff3072270d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b6600ff3072270d9$var$TrashIcon = (props)=>/*#__PURE__*/ $b6600ff3072270d9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5 5a1 1 0 00-1 1v1h16V6a1 1 0 00-1-1H5zm11.15 15H7.845a1 1 0 01-.986-.835L5 8h14l-1.864 11.166a.999.999 0 01-.986.834M9 4.5a.5.5 0 01.491-.5h5.018a.5.5 0 01.491.5V5H9v-.5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b6600ff3072270d9$var$TrashIcon.displayName = 'TrashIcon';
var $b6600ff3072270d9$var$_default = $b6600ff3072270d9$var$TrashIcon;
module.exports.default = $b6600ff3072270d9$var$_default;

});

parcelRegister("iRWKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b40155bc358780$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $29b40155bc358780$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.cells.remove.remove-dependency",
        "defaultMessage": "Remove dependency"
    }
});

});

parcelRegister("7Euzz", function(module, exports) {

$parcel$export(module.exports, "trashcan", () => $5923fbef1566b296$export$4818a3431a1cd86, (v) => $5923fbef1566b296$export$4818a3431a1cd86 = v);
var $5923fbef1566b296$export$4818a3431a1cd86;
$5923fbef1566b296$export$4818a3431a1cd86 = `l-GlJq_trashcan`;

});


parcelRegister("jqssy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7d2b066ec67c47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $5rYNM = parcelRequire("5rYNM");
function $6a7d2b066ec67c47$export$2e2bcd8739ae039({ row: { status: status } }) {
    if (!status) return null;
    const { name: name, categoryId: categoryId } = status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: (0, $5rYNM.ISSUE_STATUS_APPEARANCE)[categoryId]
    }, name);
}

});

parcelRegister("4CIha", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ce386b04e42ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7C0Jk = parcelRequire("7C0Jk");
function $4f1ce386b04e42ac$export$2e2bcd8739ae039({ direction: direction, row: { type: type } }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $7C0Jk.titleCase)(type[direction]));
}

});

parcelRegister("akJHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0230c12e4889d0d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e0230c12e4889d0d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    typeHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.type-header",
        "defaultMessage": "Type"
    },
    issueHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.issue-header",
        "defaultMessage": "Issue"
    },
    statusHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.status-header",
        "defaultMessage": "Status"
    },
    leadTimeHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.lead-time-header",
        "defaultMessage": "Lead time"
    },
    externalDependenciesHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.external-dependencies-header",
        "defaultMessage": "Not in this plan"
    },
    addQuickFilterText: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.add-quick-filter-text",
        "defaultMessage": "Filter by dependencies of {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
    },
    removeQuickFilterText: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.remove-quick-filter-text",
        "defaultMessage": "Clear filter for {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
    },
    toggleDependencyViewButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.toggle-dependency-view-button",
        "defaultMessage": "View dependencies as {value, select, lines {badges} other {lines}}"
    },
    visualizeDependencies: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies.flyout.visualize-dependencies",
        "defaultMessage": "Show dependencies for {issueKey, select, ScenarioIssue {this issue} other {{issueKey}}}"
    }
});

});

parcelRegister("8AwJn", function(module, exports) {

$parcel$export(module.exports, "assigneeCell", () => $640b133339d7c348$export$c777f4b5fa291396, (v) => $640b133339d7c348$export$c777f4b5fa291396 = v);
$parcel$export(module.exports, "change-indicator", () => $640b133339d7c348$export$157c8f7811c1bda7, (v) => $640b133339d7c348$export$157c8f7811c1bda7 = v);
$parcel$export(module.exports, "externalDependenciesHeader", () => $640b133339d7c348$export$68638848871a3dea, (v) => $640b133339d7c348$export$68638848871a3dea = v);
$parcel$export(module.exports, "footerActions", () => $640b133339d7c348$export$dc59c743128f690f, (v) => $640b133339d7c348$export$dc59c743128f690f = v);
$parcel$export(module.exports, "remove-filter", () => $640b133339d7c348$export$86450144a1f5cc56, (v) => $640b133339d7c348$export$86450144a1f5cc56 = v);
$parcel$export(module.exports, "table", () => $640b133339d7c348$export$9852986a3ec5f6a0, (v) => $640b133339d7c348$export$9852986a3ec5f6a0 = v);
$parcel$export(module.exports, "typeCell", () => $640b133339d7c348$export$99e92e4c1acf2763, (v) => $640b133339d7c348$export$99e92e4c1acf2763 = v);
var $640b133339d7c348$export$c777f4b5fa291396;
var $640b133339d7c348$export$157c8f7811c1bda7;
var $640b133339d7c348$export$68638848871a3dea;
var $640b133339d7c348$export$dc59c743128f690f;
var $640b133339d7c348$export$86450144a1f5cc56;
var $640b133339d7c348$export$9852986a3ec5f6a0;
var $640b133339d7c348$export$99e92e4c1acf2763;
$640b133339d7c348$export$c777f4b5fa291396 = `BMlqFq_assigneeCell`;
$640b133339d7c348$export$157c8f7811c1bda7 = `BMlqFq_change-indicator`;
$640b133339d7c348$export$68638848871a3dea = `BMlqFq_externalDependenciesHeader`;
$640b133339d7c348$export$dc59c743128f690f = `BMlqFq_footerActions`;
$640b133339d7c348$export$86450144a1f5cc56 = `BMlqFq_remove-filter`;
$640b133339d7c348$export$9852986a3ec5f6a0 = `BMlqFq_table`;
$640b133339d7c348$export$99e92e4c1acf2763 = `BMlqFq_typeCell`;

});





parcelRegister("do5YK", function(module, exports) {

$parcel$export(module.exports, "anchor", () => $9bf2277f17c13aff$export$2e2992790a6f69a8, (v) => $9bf2277f17c13aff$export$2e2992790a6f69a8 = v);
$parcel$export(module.exports, "overlay", () => $9bf2277f17c13aff$export$29dd17c7f3c81c36, (v) => $9bf2277f17c13aff$export$29dd17c7f3c81c36 = v);
var $9bf2277f17c13aff$export$2e2992790a6f69a8;
var $9bf2277f17c13aff$export$29dd17c7f3c81c36;
$9bf2277f17c13aff$export$2e2992790a6f69a8 = `VBLPGq_anchor`;
$9bf2277f17c13aff$export$29dd17c7f3c81c36 = `VBLPGq_overlay`;

});


parcelRegister("RzRoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b6ef2bc204db92$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gyAFK = parcelRequire("gyAFK");
const $69b6ef2bc204db92$var$Divider = ({ isExportMode: isExportMode = false })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "aria-hidden": true,
        className: isExportMode ? $gyAFK.dividerExportMode : $gyAFK.divider
    });
var $69b6ef2bc204db92$export$2e2bcd8739ae039 = $69b6ef2bc204db92$var$Divider;

});
parcelRegister("gyAFK", function(module, exports) {

$parcel$export(module.exports, "divider", () => $c0dc44ac01be8148$export$e8c9778bf415dd08, (v) => $c0dc44ac01be8148$export$e8c9778bf415dd08 = v);
$parcel$export(module.exports, "dividerExportMode", () => $c0dc44ac01be8148$export$b545a421e7459e9f, (v) => $c0dc44ac01be8148$export$b545a421e7459e9f = v);
var $c0dc44ac01be8148$export$e8c9778bf415dd08;
var $c0dc44ac01be8148$export$b545a421e7459e9f;
$c0dc44ac01be8148$export$e8c9778bf415dd08 = `cLNbza_divider`;
$c0dc44ac01be8148$export$b545a421e7459e9f = `cLNbza_dividerExportMode`;

});


parcelRegister("ctt5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $d561f2336c5128d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $d87RU = parcelRequire("d87RU");
const $d561f2336c5128d9$var$runtimeProps = {};
const $d561f2336c5128d9$var$entryPointParams = {};
const $d561f2336c5128d9$var$RatingFeedbackCollectorAsync = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $d87RU.RatingFeedbackCollector), $d561f2336c5128d9$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "ploverview-survey-feedback",
        packageName: "jiraPortfolio3Portfolio",
        entryPointReferenceSubject: entryPointReferenceSubject,
        teamName: "Chronos",
        runtimeProps: $d561f2336c5128d9$var$runtimeProps
    });
};
var $d561f2336c5128d9$export$2e2bcd8739ae039 = $d561f2336c5128d9$var$RatingFeedbackCollectorAsync;

});
parcelRegister("d87RU", function(module, exports) {

$parcel$export(module.exports, "RatingFeedbackCollector", () => $523b06b188138aaa$export$cae3092db956c7d1);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $523b06b188138aaa$export$cae3092db956c7d1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("4I9MT")).then((module)=>module.FeedbackCollectorWithEP), {
        moduleId: "42c5335b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4I9MT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('xTcEI');
        const value = parcelRequire('8t2rl');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("xTcEI").then(()=>parcelRequire('8t2rl'));
}

});



parcelRegister("jpHLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6465d0f722bcdd7d$export$2e2bcd8739ae039);

var $dbuYA = parcelRequire("dbuYA");
parcelRequire("2ZiOh");
var $eJkeb = parcelRequire("eJkeb");

var $lNNXV = parcelRequire("lNNXV");

var $fnooh = parcelRequire("fnooh");

var $7rDvn = parcelRequire("7rDvn");
const $6465d0f722bcdd7d$var$mapDispatchToProps = (dispatch)=>({
        onDragStart: ()=>{
            dispatch((0, $dbuYA.suspend)());
        },
        onDragEnd: ()=>{
            dispatch((0, $dbuYA.resume)());
        }
    });
const $6465d0f722bcdd7d$var$Fields = (0, $lNNXV.connect)((0, $fnooh.default), $6465d0f722bcdd7d$var$mapDispatchToProps)((0, $7rDvn.default));
// @ts-expect-error - connect does not have a component interface for `why-did-you-render`
$6465d0f722bcdd7d$var$Fields.whyDidYouRender = true;
$6465d0f722bcdd7d$var$Fields.displayName = 'Fields';
var $6465d0f722bcdd7d$export$2e2bcd8739ae039 = (0, $eJkeb.default)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<any> & { WrappedComponent: Component<Props>; }' is not assignable to parameter of type 'AbstractComponent<Diff<Props, InjectedProps> & InjectedProps, any>'.
$6465d0f722bcdd7d$var$Fields, 'portfolio-3.simple-plans.roadmap.fields-column');

});
parcelRegister("2ZiOh", function(module, exports) {

$parcel$export(module.exports, "withViewExperienceTracker", () => (parcelRequire("eJkeb")).default);

var $eJkeb = parcelRequire("eJkeb");

});
parcelRegister("eJkeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a0820f534cd132$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8yne0 = parcelRequire("8yne0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $51a0820f534cd132$var$withViewExperienceTracker = (WrappedComponent, location)=>{
    function WithViewExperienceTracker(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: location
        }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                onExperienceSuccess: onExperienceSuccess
            }));
    }
    return WithViewExperienceTracker;
};
var $51a0820f534cd132$export$2e2bcd8739ae039 = $51a0820f534cd132$var$withViewExperienceTracker;

});


parcelRegister("fnooh", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $b8268cecaadbfe56$export$978e30a0fb8610d8);
$parcel$export(module.exports, "default", () => $b8268cecaadbfe56$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $3OXzs = parcelRequire("3OXzs");

var $cQGVO = parcelRequire("cQGVO");
var $eXGQy = parcelRequire("eXGQy");

var $lcvrv = parcelRequire("lcvrv");

var $akhOi = parcelRequire("akhOi");

var $kKj1m = parcelRequire("kKj1m");
parcelRequire("e0gs4");
var $lf4fN = parcelRequire("lf4fN");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $a0bo1 = parcelRequire("a0bo1");

var $9H2AP = parcelRequire("9H2AP");

var $lf4fN = parcelRequire("lf4fN");

var $57dZR = parcelRequire("57dZR");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $63Xjz = parcelRequire("63Xjz");

var $bqvI1 = parcelRequire("bqvI1");

var $gRh9B = parcelRequire("gRh9B");

var $ekyJn = parcelRequire("ekyJn");

var $72KE6 = parcelRequire("72KE6");
const $b8268cecaadbfe56$export$cdc3020bd8d7e8aa = (customFields, dateConfiguration, viewMode)=>{
    const isCollapsible = viewMode !== (0, $lcvrv.VIEW_MODES).LIST;
    return customFields.map((field)=>{
        let cell = (0, $bqvI1.default);
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        const fieldId = `${field.id}`;
        const keyPath = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, [
            'type',
            'key'
        ]);
        if (fieldId === baselineStartField.key) // @ts-expect-error - TS2322 - Type 'typeof (Anonymous class)' is not assignable to type 'ComponentClass<Omit<Props & RefAttributes<any>, string | number | symbol> & Partial<Props>> & { WrappedComponent: Component<...>; }'.
        cell = (0, $gRh9B.createDateCell)((0, $gRh9B.default), (0, $ekyJn.DateTypes).Start);
        if (fieldId === baselineEndField.key) // @ts-expect-error - TS2322 - Type 'typeof (Anonymous class)' is not assignable to type 'ComponentClass<Omit<Props & RefAttributes<any>, string | number | symbol> & Partial<Props>> & { WrappedComponent: Component<...>; }'.
        cell = (0, $gRh9B.createDateCell)((0, $gRh9B.default), (0, $ekyJn.DateTypes).End);
        const defaultWidth = (0, $72KE6.getDefaultWidth)(keyPath, viewMode);
        const minWidth = (0, $72KE6.getMinWidth)(keyPath, isCollapsible, viewMode);
        const column = {
            id: fieldId,
            isVisible: false,
            title: field.title,
            attribute: fieldId,
            cell: cell,
            isCustomField: true,
            isLoading: false,
            isReadOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))((0, $5rYNM.CustomFields).ReadOnlyFields, (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, [
                'type',
                'key'
            ])),
            isSortable: false,
            defaultWidth: defaultWidth,
            isCollapsible: isCollapsible,
            minWidth: minWidth,
            projectId: field.projectId
        };
        const customProperties = (0, $7CnHa.isDefined)(keyPath) ? (0, $63Xjz.customFieldColumnProperties)(keyPath) : {};
        // Typescript complains here that id is optional because column/customProperties are partial, but we know that id is defined.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            ...column,
            ...customProperties
        };
    });
};
function $b8268cecaadbfe56$var$getCustomColumn(id, customFields) {
    return customFields.find((customColumn)=>customColumn.id.toString() === id.toString());
}
const $b8268cecaadbfe56$export$ac0c9b0a002d1a9 = (attribute)=>(item)=>{
        if (item.tag !== (0, $a0bo1.TABLE_ISSUE)) return false;
        const { value: issue } = item;
        return (0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, attribute), (0, $57dZR.getOptimizedValue)(issue, attribute));
    };
const $b8268cecaadbfe56$var$filterGoalColumnIfNotAvailable = (columns, isAtlasConnectInstalled)=>columns.filter((column)=>column.id !== 'goal' || isAtlasConnectInstalled);
const $b8268cecaadbfe56$export$46848d2dbf73aee = ({ columns: columnStates }, dateConfiguration, planningUnit, customFields, isLoadingHistoryIssues, items, showOptimizations, viewMode, isAtlasConnectInstalled)=>{
    const customFieldColumns = $b8268cecaadbfe56$export$cdc3020bd8d7e8aa(customFields, dateConfiguration, viewMode);
    // Custom field columns could be added and then removed from a plan, so we filter the available columns
    const availableColumnStatesCheck = ()=>columnStates.filter((column)=>(0, $lf4fN.isColumnId)(column.id) || $b8268cecaadbfe56$var$getCustomColumn(column.id, customFieldColumns));
    const availableColumnStates = availableColumnStatesCheck();
    const columnPropertiesContext = {
        dateConfiguration: dateConfiguration,
        planningUnit: planningUnit
    };
    const columnsInStore = availableColumnStates.map((columnState)=>{
        const customColumn = $b8268cecaadbfe56$var$getCustomColumn(columnState.id, customFieldColumns);
        const defaultColumn = (0, $63Xjz.default)(columnState.id, columnPropertiesContext, viewMode);
        const column = customColumn || defaultColumn;
        const defaultWidth = (0, $7CnHa.isDefined)(customColumn) ? customColumn.defaultWidth : (0, $72KE6.getDefaultWidth)(columnState.id, viewMode);
        const hasOptimizedValues = showOptimizations && column && !!items.find($b8268cecaadbfe56$export$ac0c9b0a002d1a9(column.attribute));
        return {
            ...column,
            ...columnState,
            isLoading: isLoadingHistoryIssues && (columnState.id === 'breakdown' || columnState.id === 'progressByEstimation'),
            defaultWidth: defaultWidth,
            hasOptimizedValues: hasOptimizedValues
        };
    });
    const columnIdsWithCustomFields = [
        ...(0, $lf4fN.getColumnIds)(),
        ...customFields.map((customField)=>customField.id.toString())
    ];
    const storedColumnIds = availableColumnStates.map((column)=>column.id.toString());
    const notStoredColumnIds = $eXGQy.default(storedColumnIds, columnIdsWithCustomFields);
    const createHiddenColumn = (id)=>{
        let properties;
        if ((0, $lf4fN.isColumnId)(id)) properties = {
            ...(0, $63Xjz.default)(id, columnPropertiesContext, viewMode),
            defaultWidth: (0, $72KE6.getDefaultWidth)(id, viewMode)
        };
        else properties = $b8268cecaadbfe56$var$getCustomColumn(id, customFieldColumns);
        return {
            id: id,
            isVisible: false,
            isLoading: isLoadingHistoryIssues && id === 'breakdown',
            ...properties
        };
    };
    const columnsNotInStore = $cQGVO.default(createHiddenColumn, notStoredColumnIds);
    if (viewMode === (0, $lcvrv.VIEW_MODES).LIST) {
        const addFieldsColumn = {
            id: (0, $lf4fN.ADD_FIELDS_COLUMN_ID),
            isVisible: true,
            defaultWidth: (0, $72KE6.getDefaultWidth)((0, $lf4fN.ADD_FIELDS_COLUMN_ID), viewMode),
            ...(0, $63Xjz.default)((0, $lf4fN.ADD_FIELDS_COLUMN_ID), columnPropertiesContext, viewMode)
        };
        return $b8268cecaadbfe56$var$filterGoalColumnIfNotAvailable(// @ts-expect-error - TS2322 - Type '{ id: any; isVisible: boolean; isLoading: boolean; }[]' is not assignable to type 'IssueColumn[]'.
        [
            ...columnsInStore,
            ...columnsNotInStore,
            addFieldsColumn
        ], isAtlasConnectInstalled);
    }
    return $b8268cecaadbfe56$var$filterGoalColumnIfNotAvailable(// @ts-expect-error - TS2322 - Type '{ id: any; isVisible: boolean; isLoading: boolean; }[]' is not assignable to type 'IssueColumn[]'.
    [
        ...columnsInStore,
        ...columnsNotInStore
    ], isAtlasConnectInstalled);
};
const $b8268cecaadbfe56$export$978e30a0fb8610d8 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getFieldColumnsViewSettingsByViewMode),
    (0, $75KhQ.getDateConfiguration),
    (0, $75KhQ.getPlanningUnit),
    (0, $kKj1m.getSupportedCustomFields),
    (0, $kwMvv.isLoadingHistory),
    (0, $a0bo1.getTableItems),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state)=>(0, $akhOi.getMode)(state) === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
    (0, $9H2AP.getViewMode),
    (0, $dhHiZ.isAtlasConnectInstalled)
], $b8268cecaadbfe56$export$46848d2dbf73aee);
const $b8268cecaadbfe56$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    showWarning: (state)=>(0, $9H2AP.getWarningViewSettings)(state).showWarning,
    items: (0, $a0bo1.getTableItems),
    columns: $b8268cecaadbfe56$export$978e30a0fb8610d8,
    isReadOnly: (state)=>(0, $akhOi.getMode)(state) !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
    showOptimizations: (state)=>(0, $akhOi.getMode)(state) === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)
});
var $b8268cecaadbfe56$export$2e2bcd8739ae039 = $b8268cecaadbfe56$var$querySelector;

});
parcelRegister("3OXzs", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hNahz = parcelRequire("hNahz");

var $hvbu2 = parcelRequire("hvbu2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c84401faa0612b2$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $2c84401faa0612b2$var$includes(collection, value, fromIndex, guard) {
    collection = $jxg5X(collection) ? collection : $hvbu2(collection);
    fromIndex = fromIndex && !guard ? $hNahz(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $2c84401faa0612b2$var$nativeMax(length + fromIndex, 0);
    return $4ZYEI(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $jkhuN(collection, value, fromIndex) > -1;
}
module.exports = $2c84401faa0612b2$var$includes;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("e0gs4", function(module, exports) {

$parcel$export(module.exports, "getColumnIds", () => (parcelRequire("lf4fN")).getColumnIds);

var $lf4fN = parcelRequire("lf4fN");

var $aGViN = parcelRequire("aGViN");

});
parcelRegister("aGViN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a3fb672c5f6725$export$2e2bcd8739ae039);

var $7CnHa = parcelRequire("7CnHa");

var $lNYdY = parcelRequire("lNYdY");

var $lf4fN = parcelRequire("lf4fN");
const $93a3fb672c5f6725$export$d4c72bab9d6cc13a = {
    columns: [
        {
            id: 'targetStart',
            isVisible: true
        },
        {
            id: 'targetEnd',
            isVisible: true
        },
        {
            id: 'issueStatus',
            isVisible: true
        }
    ]
};
const $93a3fb672c5f6725$export$40791e2b75f99dde = (columns, id, isVisible)=>{
    const safeColumns = columns.filter((col)=>col.id !== (0, $lf4fN.ADD_FIELDS_COLUMN_ID));
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ...safeColumns.filter((col)=>col.id !== id),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            id: id,
            isVisible: isVisible
        }
    ];
};
const $93a3fb672c5f6725$export$d1fbe0eb3fc9219 = (columns, columnToMove, moveToTheIndexOf)=>{
    const indexOfColumnToMove = columns.findIndex((col)=>col.id === columnToMove);
    let indexOfMoveTo = columns.findIndex((col)=>col.id === moveToTheIndexOf);
    /**
	 * the columns array contains incomingDependencies and outgoingDependencies columns
	 * but when moving columns, when incomingDependencies is moved, the outgoingDependencies column
	 * should move along with it.
	 *
	 * Take a look at the tests to understand these cases more
	 */ if (columnToMove === 'incomingDependencies') {
        const incomingDependencyMoveResults = (0, $7CnHa.move)(indexOfColumnToMove, indexOfMoveTo, columns);
        const outgoingDependencyIndex = incomingDependencyMoveResults.findIndex((col)=>col.id === 'outgoingDependencies');
        const indexOfMoveToForOutgoingDependency = incomingDependencyMoveResults.findIndex((col)=>col.id === 'incomingDependencies');
        // adjust index based on whether the column is moving up or down
        const delta = outgoingDependencyIndex > indexOfMoveToForOutgoingDependency ? 1 : 0;
        const result = (0, $7CnHa.move)(outgoingDependencyIndex, indexOfMoveToForOutgoingDependency + delta, incomingDependencyMoveResults);
        return result;
    }
    // When a column is moving to the index of incomingDependencies, it should not move in-between incomingDependencies and outgoingDependencies
    if (moveToTheIndexOf === 'incomingDependencies') {
        const delta = indexOfMoveTo > indexOfColumnToMove ? 1 : 0;
        indexOfMoveTo += delta;
    }
    return (0, $7CnHa.move)(indexOfColumnToMove, indexOfMoveTo, columns);
};
const $93a3fb672c5f6725$var$reducer = (state = $93a3fb672c5f6725$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $lNYdY.RESET:
            return {
                ...action.payload
            };
        case 0, $lNYdY.SHOW_COLUMN:
            return {
                ...state,
                columns: $93a3fb672c5f6725$export$40791e2b75f99dde(state.columns, action.id, true)
            };
        case 0, $lNYdY.HIDE_COLUMN:
            return {
                ...state,
                columns: $93a3fb672c5f6725$export$40791e2b75f99dde(state.columns, action.id, false)
            };
        case 0, $lNYdY.MOVE_COLUMN:
            return {
                ...state,
                columns: [
                    ...$93a3fb672c5f6725$export$d1fbe0eb3fc9219(state.columns, action.payload.columnToMove, action.payload.moveToTheIndexOf)
                ]
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $93a3fb672c5f6725$export$2e2bcd8739ae039 = $93a3fb672c5f6725$var$reducer;

});
parcelRegister("lNYdY", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $0d6160a8cc1b0eaf$export$4a991c87e640ef77);
$parcel$export(module.exports, "SHOW_COLUMN", () => $0d6160a8cc1b0eaf$export$4a38807763b7121b);
$parcel$export(module.exports, "HIDE_COLUMN", () => $0d6160a8cc1b0eaf$export$8aa1aac0877ab14a);
$parcel$export(module.exports, "MOVE_COLUMN", () => $0d6160a8cc1b0eaf$export$222f4d20cfc4481f);
$parcel$export(module.exports, "move", () => $0d6160a8cc1b0eaf$export$d947e5f4f4c48d48);
const $0d6160a8cc1b0eaf$export$4a991c87e640ef77 = 'state.domain.view-settings.field-columns.RESET';
const $0d6160a8cc1b0eaf$export$4a38807763b7121b = 'state.domain.view-settings.field-columns.SHOW_COLUMN';
const $0d6160a8cc1b0eaf$export$8aa1aac0877ab14a = 'state.domain.view-settings.field-columns.HIDE_COLUMN';
const $0d6160a8cc1b0eaf$export$222f4d20cfc4481f = 'state.domain.view-settings.field-columns.MOVE_COLUMN';
const $0d6160a8cc1b0eaf$export$aad8462122ac592b = (payload)=>({
        type: $0d6160a8cc1b0eaf$export$4a991c87e640ef77,
        payload: payload
    });
const $0d6160a8cc1b0eaf$export$d947e5f4f4c48d48 = (payload)=>({
        type: $0d6160a8cc1b0eaf$export$222f4d20cfc4481f,
        payload: payload
    });

});



parcelRegister("63Xjz", function(module, exports) {

$parcel$export(module.exports, "customFieldColumnProperties", () => $5df04d92e3d822e8$export$82164cfe90d2a476);
$parcel$export(module.exports, "default", () => $5df04d92e3d822e8$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $lcvrv = parcelRequire("lcvrv");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $e2w6g = parcelRequire("e2w6g");

var $qIzJb = parcelRequire("qIzJb");

var $jFi8o = parcelRequire("jFi8o");

var $gRh9B = parcelRequire("gRh9B");

var $ekyJn = parcelRequire("ekyJn");

var $lFvbU = parcelRequire("lFvbU");

var $4x1VQ = parcelRequire("4x1VQ");

var $SLVaF = parcelRequire("SLVaF");

var $3lvGT = parcelRequire("3lvGT");

var $kEdAy = parcelRequire("kEdAy");

var $a96yg = parcelRequire("a96yg");

var $1NWBc = parcelRequire("1NWBc");

var $j5xV4 = parcelRequire("j5xV4");

var $5yMne = parcelRequire("5yMne");

var $eTocq = parcelRequire("eTocq");

var $iZmwI = parcelRequire("iZmwI");


var $g7qnq = parcelRequire("g7qnq");

var $c3o8C = parcelRequire("c3o8C");

var $9NSUz = parcelRequire("9NSUz");

var $72KE6 = parcelRequire("72KE6");
const $5df04d92e3d822e8$var$EmptyCell = ()=>null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5df04d92e3d822e8$var$getDateCell = (context, issueAttribute)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = context.dateConfiguration;
    if (baselineStartField.key === issueAttribute) // @ts-expect-error Argument of type 'ConnectedComponentClass<{ (props: any): Element; displayName: string; WrappedComponent: ComponentType<any>; slotsByProps: Partial<Record<string, SlotName>>; }, Omit<...>>' is not assignable to parameter of type 'ComponentType<Props>'.ts(2345)
    return (0, $gRh9B.createDateCell)((0, $gRh9B.default), (0, $ekyJn.DateTypes).Start);
    if (baselineEndField.key === issueAttribute) // @ts-expect-error Argument of type 'ConnectedComponentClass<{ (props: any): Element; displayName: string; WrappedComponent: ComponentType<any>; slotsByProps: Partial<Record<string, SlotName>>; }, Omit<...>>' is not assignable to parameter of type 'ComponentType<Props>'.ts(2345)
    return (0, $gRh9B.createDateCell)((0, $gRh9B.default), (0, $ekyJn.DateTypes).End);
    // @ts-expect-error Argument of type 'ConnectedComponentClass<{ (props: any): Element; displayName: string; WrappedComponent: ComponentType<any>; slotsByProps: Partial<Record<string, SlotName>>; }, Omit<...>>' is not assignable to parameter of type 'ComponentType<Props>'.ts(2345)
    return (0, $gRh9B.createDateCell)((0, $gRh9B.default), (0, $ekyJn.DateTypes).Other);
};
const $5df04d92e3d822e8$var$columnProperties = (columnId, context, viewMode)=>{
    const isCollapsible = viewMode !== (0, $lcvrv.VIEW_MODES).LIST;
    const minWidth = (0, $72KE6.getMinWidth)(columnId, isCollapsible, viewMode);
    switch(columnId){
        case 'assignee':
            return {
                title: (0, $ib5d3.default).assignee,
                attribute: 'assignee',
                cell: (0, $e2w6g.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'reporter':
            return {
                title: (0, $ib5d3.default).reporter,
                attribute: 'reporter',
                cell: (0, $eTocq.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'breakdown':
            return {
                title: (0, $9NSUz.default).breakdownColumnHeader,
                attribute: 'breakdown',
                cell: (0, $qIzJb.createBreakdownCell)((0, $qIzJb.default), (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'progressByEstimation':
            return {
                title: (0, $9NSUz.getProgressByEstimateColumnTitle)(context.planningUnit),
                attribute: 'progressByEstimate',
                cell: (0, $qIzJb.createBreakdownCell)((0, $qIzJb.default), (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).ESTIMATE),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'estimate':
            return {
                title: (0, $9NSUz.getEstimateColumnTitle)(context.planningUnit),
                attribute: 'estimate',
                cell: (0, $4x1VQ.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'issueStatus':
            return {
                title: (0, $9NSUz.default).issueStatusColumnHeader,
                attribute: 'status',
                cell: (0, $kEdAy.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'release':
            return {
                title: (0, $ib5d3.default).releases,
                attribute: 'fixVersions',
                cell: (0, $5yMne.default),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'sprint':
            return {
                title: (0, $ib5d3.default).sprint,
                attribute: (0, $b44ee846994766e8$export$b549cc58e415d416),
                cell: (0, $iZmwI.default),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'targetStart':
            return {
                title: (0, $9NSUz.default).targetStartColumnHeader,
                attribute: 'targetStart',
                cell: $5df04d92e3d822e8$var$getDateCell(context, 'targetStart'),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'targetEnd':
            return {
                title: (0, $9NSUz.default).targetEndColumnHeader,
                attribute: 'targetEnd',
                cell: $5df04d92e3d822e8$var$getDateCell(context, 'targetEnd'),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'dueDate':
            return {
                title: (0, $ib5d3.default).dueDate,
                attribute: 'dueDate',
                cell: $5df04d92e3d822e8$var$getDateCell(context, 'dueDate'),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'team':
            return {
                title: (0, $9NSUz.default).teamColumnHeader,
                attribute: 'team',
                cell: (0, $g7qnq.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'incomingDependencies':
            return {
                title: (0, $9NSUz.default).incomingDependenciesColumnHeader,
                attribute: 'incomingDependencies',
                groupTitle: (0, $9NSUz.default).dependenciesColumnsHeader,
                cell: (0, $lFvbU.IncomingDependenciesCell),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'outgoingDependencies':
            return {
                title: (0, $9NSUz.default).outgoingDependenciesColumnHeader,
                attribute: 'outgoingDependencies',
                groupTitle: (0, $9NSUz.default).dependenciesColumnsHeader,
                cell: (0, $lFvbU.OutgoingDependenciesCell),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'components':
            return {
                title: (0, $9NSUz.default).componentsColumnHeader,
                attribute: 'components',
                cell: (0, $jFi8o.default),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'labels':
            return {
                title: (0, $9NSUz.default).labelsColumnHeader,
                attribute: 'labels',
                groupTitle: (0, $9NSUz.default).labelsColumnHeader,
                cell: (0, $a96yg.default),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'parent':
            return {
                title: (0, $9NSUz.default).parentColumnHeader,
                attribute: 'parent',
                groupTitle: (0, $9NSUz.default).parentColumnHeader,
                cell: (0, $1NWBc.default),
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'priority':
            return {
                title: (0, $9NSUz.default).priorityColumnHeader,
                attribute: 'priority',
                groupTitle: (0, $9NSUz.default).priorityColumnHeader,
                cell: (0, $j5xV4.default),
                isSortable: true,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            };
        case 'goal':
            return {
                title: (0, $9NSUz.default).goalColumnHeader,
                attribute: 'goal',
                groupTitle: (0, $9NSUz.default).goalColumnHeader,
                cell: (0, $SLVaF.default),
                isSortable: false,
                isCollapsible: isCollapsible,
                minWidth: minWidth,
                HeaderContent: (0, $c3o8C.default)
            };
        case 'ideas':
            return (0, $1ybV0.ff)('polaris-arj-ideas') ? {
                title: (0, $9NSUz.default).ideasColumnHeader,
                attribute: 'ideas',
                groupTitle: (0, $9NSUz.default).ideasColumnHeader,
                cell: (0, $3lvGT.default),
                isSortable: false,
                isCollapsible: isCollapsible,
                minWidth: minWidth
            } : null;
        case 'addFields':
            return {
                title: (0, $9NSUz.default).addFieldsColumnHeader,
                attribute: 'addFields',
                groupTitle: (0, $9NSUz.default).addFieldsColumnHeader,
                cell: $5df04d92e3d822e8$var$EmptyCell,
                isCollapsible: false,
                minWidth: minWidth
            };
        default:
            return null;
    }
};
const $5df04d92e3d822e8$export$82164cfe90d2a476 = (fieldType)=>{
    switch(fieldType){
        case (0, $5rYNM.CustomFieldTypes).DatePicker:
        case (0, $5rYNM.CustomFieldTypes).NumberField:
        case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            return {
                isSortable: true
            };
        default:
            return {};
    }
};
var $5df04d92e3d822e8$export$2e2bcd8739ae039 = $5df04d92e3d822e8$var$columnProperties;

});
parcelRegister("e2w6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4140a50f9dcb1d81$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gt4Od = parcelRequire("gt4Od");

var $5zTgu = parcelRequire("5zTgu");

var $7LUTG = parcelRequire("7LUTG");
var $4140a50f9dcb1d81$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5zTgu.default), (0, $gt4Od.default))((0, $7LUTG.default));

});
parcelRegister("gt4Od", function(module, exports) {

$parcel$export(module.exports, "default", () => $86621b64ca198520$export$2e2bcd8739ae039);

var $63O1Q = parcelRequire("63O1Q");

var $1Szmp = parcelRequire("1Szmp");

var $g4z4L = parcelRequire("g4z4L");
const $86621b64ca198520$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, assignee)=>{
            if (assignee) dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                assignee: assignee.jiraUser.accountId
            }));
            dispatch(// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Person | null | undefined; }' is not assignable to parameter of type 'IssueAssigneeMap'.
            (0, $g4z4L.updateIssueAssigneeMap)({
                [issue.id]: assignee
            }));
        },
        fetchAssigneeList: (payload)=>{
            dispatch((0, $63O1Q.fetchAssigneeList)(payload));
        }
    });
var $86621b64ca198520$export$2e2bcd8739ae039 = $86621b64ca198520$var$dispatchMethods;

});
parcelRegister("63O1Q", function(module, exports) {

$parcel$export(module.exports, "fetchAssigneeList", () => $dd6cca97cf01765f$export$697cc0c8abe021c9);
$parcel$export(module.exports, "fetchAssigneeListForKeys", () => $dd6cca97cf01765f$export$a149c3b6531d9418);
$parcel$export(module.exports, "fetchTeamsAssignees", () => $dd6cca97cf01765f$export$56f56a69078c2d60);
$parcel$export(module.exports, "getUsers", () => $dd6cca97cf01765f$export$925a4945a6cd0f3e);
$parcel$export(module.exports, "populateAssignees", () => $dd6cca97cf01765f$export$dd4a891b55a6409);
$parcel$export(module.exports, "populateAssigneesFromProfiles", () => $dd6cca97cf01765f$export$e3585c4bb68b1b7);
$parcel$export(module.exports, "default", () => $dd6cca97cf01765f$export$2e2bcd8739ae039);
parcelRequire("inLJ0");
var $71txE = parcelRequire("71txE");

var $9FeHi = parcelRequire("9FeHi");
var $l0L3x = parcelRequire("l0L3x");
var $hQdGw = parcelRequire("hQdGw");
var $UCNmJ = parcelRequire("UCNmJ");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $6VhAf = parcelRequire("6VhAf");

var $f6g5r = parcelRequire("f6g5r");

var $g4z4L = parcelRequire("g4z4L");

var $bv1hL = parcelRequire("bv1hL");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $j31OP = parcelRequire("j31OP");
const $dd6cca97cf01765f$export$746abeb2a401028e = 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_QUERY';
const $dd6cca97cf01765f$export$7f3e3acfa85504f9 = 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_KEYS';
const $dd6cca97cf01765f$export$39efea07a70e4e7e = 'command.assignees.FETCH_TEAMS_ASSIGNEE_LIST';
const $dd6cca97cf01765f$var$unassignedUser = {
    title: 'Unassigned',
    accountId: 'unassigned',
    email: '',
    avatarUrl: ''
};
const $dd6cca97cf01765f$export$697cc0c8abe021c9 = (payload)=>({
        type: $dd6cca97cf01765f$export$746abeb2a401028e,
        payload: payload
    });
const $dd6cca97cf01765f$export$a149c3b6531d9418 = (payload)=>({
        type: $dd6cca97cf01765f$export$7f3e3acfa85504f9,
        payload: payload
    });
const $dd6cca97cf01765f$export$56f56a69078c2d60 = ()=>({
        type: $dd6cca97cf01765f$export$39efea07a70e4e7e
    });
function* $dd6cca97cf01765f$export$925a4945a6cd0f3e({ keys: keys } = {
    keys: []
}) {
    try {
        let users = [];
        const url = (0, $j31OP.urls).users;
        const body = (0, $j31OP.usersRequestBody)({
            keys: keys.filter((0, $7CnHa.isDefined))
        });
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body,
            profile: url
        });
        if (response.ok) {
            const results = yield (0, $9e8i2.call)(response.json.bind(response));
            users = [
                ...results.users
            ];
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        return users;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
    return [];
}
function* $dd6cca97cf01765f$export$a65219a764b7ed0b(config = {
    query: ''
}) {
    try {
        let results = [];
        const url = (0, $j31OP.urls).assignees;
        const body = (0, $j31OP.personsRequestBody)(config);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const persons = yield (0, $9e8i2.call)(response.json.bind(response));
            results = [
                ...persons.results
            ];
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        return results;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
    return [];
}
function* $dd6cca97cf01765f$export$dd4a891b55a6409({ payload: payload } = {
    payload: {},
    type: 'command.assignees.FETCH_ASSIGNEE_LIST_FOR_KEYS'
}) {
    try {
        const keys = payload && payload.keys;
        const { domain: { issues: issues, originalIssues: originalIssues } } = yield (0, $9e8i2.select)($l0L3x.default);
        // should fetch assignees of all the issues, originalIssues and teams
        const originalIssueAssigneeIds = ($UCNmJ.default(originalIssues) || []).map((issue)=>issue.assignee) || [];
        const issueAssigneeIds = issues.map((issue)=>issue.assignee) || [];
        const fetchAllAssignees = payload && payload.fetchAllAssignees;
        const requestedKeys = keys || [];
        let requiredKeys;
        if (requestedKeys.length === 0 || fetchAllAssignees) {
            // if assignee keys are not specified we fetch all assignees
            const teamsAssigneeKeys = yield (0, $9e8i2.select)((0, $f6g5r.getTeamsAssigneeAccountIds));
            requiredKeys = [
                ...requestedKeys,
                ...issueAssigneeIds,
                ...originalIssueAssigneeIds,
                ...teamsAssigneeKeys
            ];
        } else requiredKeys = requestedKeys;
        const assigneeList = yield (0, $9e8i2.select)((0, $6VhAf.getAssigneeList));
        const availableUserKeys = assigneeList.map((assignee)=>assignee.personId);
        const userIds = $9FeHi.default(requiredKeys, availableUserKeys).filter((0, $7CnHa.isDefined));
        if ($hQdGw.default(userIds) === 0) return;
        const users = yield (0, $9e8i2.call)($dd6cca97cf01765f$export$925a4945a6cd0f3e, {
            keys: userIds
        });
        users.unshift($dd6cca97cf01765f$var$unassignedUser);
        const transformedUsersList = users.map((user)=>({
                personId: user.accountId,
                jiraUser: user
            }));
        yield (0, $9e8i2.put)((0, $g4z4L.updateAssigneeList)({
            people: [
                ...transformedUsersList
            ]
        }));
        const issueAssigneeMap = issues.reduce((acc, issue)=>{
            const assignee = users.find(({ accountId: accountId })=>accountId === issue.assignee);
            if (assignee) acc[issue.id] = {
                personId: assignee.accountId,
                jiraUser: assignee
            };
            return acc;
        }, {});
        yield (0, $9e8i2.put)((0, $g4z4L.updateIssueAssigneeMap)(issueAssigneeMap));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dd6cca97cf01765f$export$e3585c4bb68b1b7(assigneeProfiles) {
    try {
        const { domain: { issues: issues } } = yield (0, $9e8i2.select)($l0L3x.default);
        // if assignee keys are not specified we fetch all assignees
        const teamAssignees = yield (0, $9e8i2.select)((0, $f6g5r.getTeamsPersons));
        // List of account id's for the list order
        const allPersonsOrder = [
            $dd6cca97cf01765f$var$unassignedUser.accountId
        ];
        // Map of account id to person
        const allPersonsMap = {
            [$dd6cca97cf01765f$var$unassignedUser.accountId]: {
                personId: $dd6cca97cf01765f$var$unassignedUser.accountId,
                jiraUser: $dd6cca97cf01765f$var$unassignedUser
            }
        };
        for (const assigneePerson of Object.values(assigneeProfiles)){
            allPersonsOrder.push(assigneePerson.accountId);
            allPersonsMap[assigneePerson.accountId] = {
                personId: assigneePerson.accountId,
                jiraUser: assigneePerson
            };
        }
        for (const apiPerson of teamAssignees)// Using full expansion in the if statement to make typescripts inference happy
        if (apiPerson?.jiraUser?.accountId && !allPersonsMap[apiPerson?.jiraUser?.accountId]) {
            const accountId = apiPerson.jiraUser.accountId;
            allPersonsOrder.push(accountId);
            allPersonsMap[accountId] = {
                personId: accountId,
                jiraUser: {
                    accountId: accountId,
                    title: apiPerson.jiraUser.title,
                    avatarUrl: apiPerson.jiraUser.avatarUrl,
                    email: apiPerson.jiraUser?.email
                }
            };
        }
        yield (0, $9e8i2.put)((0, $g4z4L.updateAssigneeList)({
            people: allPersonsOrder.map((accountId)=>allPersonsMap[accountId])
        }));
        const issueAssigneeMap = {};
        issues.forEach((issue)=>{
            const assigneePerson = allPersonsMap[issue.assignee];
            if (assigneePerson) issueAssigneeMap[issue.id] = assigneePerson;
        });
        yield (0, $9e8i2.put)((0, $g4z4L.updateIssueAssigneeMap)(issueAssigneeMap));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dd6cca97cf01765f$export$144ae522d73a11b8({ payload: { query: query, issueId: issueId } }) {
    try {
        yield (0, $9e8i2.put)((0, $bv1hL.startUpdatingAssigneeList)(issueId || ''));
        const assigneeList = yield (0, $9e8i2.call)($dd6cca97cf01765f$export$a65219a764b7ed0b, {
            query: query
        });
        assigneeList.unshift({
            personId: $dd6cca97cf01765f$var$unassignedUser.accountId,
            jiraUser: {
                ...$dd6cca97cf01765f$var$unassignedUser
            }
        });
        yield (0, $9e8i2.put)((0, $g4z4L.updateAssigneeList)({
            people: assigneeList.filter((assignee)=>assignee.jiraUser).map(({ jiraUser: jiraUser })=>({
                    personId: jiraUser.accountId,
                    jiraUser: jiraUser
                }))
        }));
        yield (0, $9e8i2.put)((0, $bv1hL.stopUpdatingAssigneeList)(issueId || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $dd6cca97cf01765f$export$919b7611971b07c1(action) {
    yield (0, $9e8i2.call)((0, $71txE.delay), 500);
    yield (0, $9e8i2.call)($dd6cca97cf01765f$export$144ae522d73a11b8, action);
}
function* $dd6cca97cf01765f$export$eab844ac5f2070c4() {
    const keys = yield (0, $9e8i2.select)((0, $f6g5r.getTeamsAssigneeAccountIds));
    yield (0, $9e8i2.put)($dd6cca97cf01765f$export$a149c3b6531d9418({
        keys: keys
    }));
}
function* $dd6cca97cf01765f$export$7dc46a99f6328d90() {
    yield (0, $bG7pV.takeLatest)($dd6cca97cf01765f$export$746abeb2a401028e, $dd6cca97cf01765f$export$919b7611971b07c1);
}
function* $dd6cca97cf01765f$export$a794a84c83401681() {
    yield (0, $bG7pV.takeEvery)($dd6cca97cf01765f$export$7f3e3acfa85504f9, $dd6cca97cf01765f$export$dd4a891b55a6409);
}
function* $dd6cca97cf01765f$export$739f5e1b36c4ea3a() {
    yield (0, $bG7pV.takeLatest)($dd6cca97cf01765f$export$39efea07a70e4e7e, $dd6cca97cf01765f$export$eab844ac5f2070c4);
}
function* $dd6cca97cf01765f$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($dd6cca97cf01765f$export$7dc46a99f6328d90);
    yield (0, $9e8i2.fork)($dd6cca97cf01765f$export$a794a84c83401681);
    yield (0, $9e8i2.fork)($dd6cca97cf01765f$export$739f5e1b36c4ea3a);
}

});
parcelRegister("g4z4L", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ISSUE_ASSIGNEE_MAP", () => $d552fb9a0c939e03$export$6861ed0171e1a77e);
$parcel$export(module.exports, "UPDATE_ASSIGNEES_LIST", () => $d552fb9a0c939e03$export$ebcfa10ee460b7cf);
$parcel$export(module.exports, "updateIssueAssigneeMap", () => $d552fb9a0c939e03$export$cb751895c7b66bf2);
$parcel$export(module.exports, "updateAssigneeList", () => $d552fb9a0c939e03$export$fd2cc1da8acc3773);
const $d552fb9a0c939e03$export$6861ed0171e1a77e = 'state.domain.assignees.UPDATE_ISSUE_ASSIGNEE_MAP';
const $d552fb9a0c939e03$export$ebcfa10ee460b7cf = 'state.domain.assignees.UPDATE_ASSIGNEES_LIST';
const $d552fb9a0c939e03$export$cb751895c7b66bf2 = (payload)=>({
        type: $d552fb9a0c939e03$export$6861ed0171e1a77e,
        payload: payload
    });
const $d552fb9a0c939e03$export$fd2cc1da8acc3773 = (payload)=>({
        type: $d552fb9a0c939e03$export$ebcfa10ee460b7cf,
        payload: payload
    });

});

parcelRegister("bv1hL", function(module, exports) {

$parcel$export(module.exports, "FETCH_ASSIGNEES_START", () => $1262629ca69850e9$export$5142077b54dce3ef);
$parcel$export(module.exports, "FETCH_ASSIGNEES_STOP", () => $1262629ca69850e9$export$9c6e6fe248892a25);
$parcel$export(module.exports, "startUpdatingAssigneeList", () => $1262629ca69850e9$export$c74a51765e09775f);
$parcel$export(module.exports, "stopUpdatingAssigneeList", () => $1262629ca69850e9$export$c796270210de179d);
const $1262629ca69850e9$export$5142077b54dce3ef = 'state.ui.main.tabs.roadmap.fields.assignee.FETCH_ASSIGNEES_START';
const $1262629ca69850e9$export$9c6e6fe248892a25 = 'state.ui.main.tabs.roadmap.fields.assignee.FETCH_ASSIGNEES_STOP';
const $1262629ca69850e9$export$c74a51765e09775f = (issueId)=>({
        type: $1262629ca69850e9$export$5142077b54dce3ef,
        payload: {
            issueId: issueId || ''
        }
    });
const $1262629ca69850e9$export$c796270210de179d = (issueId)=>({
        type: $1262629ca69850e9$export$9c6e6fe248892a25,
        payload: {
            issueId: issueId || ''
        }
    });

});

parcelRegister("j31OP", function(module, exports) {

$parcel$export(module.exports, "urls", () => $458c5f8a538775a4$export$bcae9ba627f604b6);
$parcel$export(module.exports, "LIMIT_OF_USERS", () => $458c5f8a538775a4$export$aa33dcd85c6bc170);
$parcel$export(module.exports, "personsRequestBody", () => $458c5f8a538775a4$export$9759b32997d3bfe3);
$parcel$export(module.exports, "usersRequestBody", () => $458c5f8a538775a4$export$a0d5e607159aec63);
const $458c5f8a538775a4$export$bcae9ba627f604b6 = {
    assignees: '/rest/teams/1.0/persons/find',
    users: '/rest/jpo/1.0/users/get'
};
const $458c5f8a538775a4$export$aa33dcd85c6bc170 = 50;
const $458c5f8a538775a4$export$9759b32997d3bfe3 = ({ query: query = '', excludedIds: excludedIds = [], maxResults: maxResults = $458c5f8a538775a4$export$aa33dcd85c6bc170 })=>({
        query: query,
        excludedIds: excludedIds,
        maxResults: maxResults
    });
const $458c5f8a538775a4$export$a0d5e607159aec63 = ({ keys: keys = [] })=>({
        keys: Array.from(new Set(keys))
    });

});



parcelRegister("5zTgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c4919596e96484$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");

var $iK4oF = parcelRequire("iK4oF");
const $64c4919596e96484$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    assigneeList: (0, $6VhAf.getAssigneeList),
    assigneeListFetchStatus: (0, $6VhAf.getAssigneeListFetchStatus),
    currentAssignees: (0, $6VhAf.getAssigneesOfIssues),
    issueIdForFetchAssigneeListProgress: (0, $6VhAf.getIssueIdForFetchAssigneeListProgress)
});
var $64c4919596e96484$export$2e2bcd8739ae039 = $64c4919596e96484$export$c31df4bd766f9c35;

});

parcelRegister("7LUTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2aeb295d3696ee7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jQxSL = parcelRequire("jQxSL");
var $gbNhI = parcelRequire("gbNhI");
var $gwbfD = parcelRequire("gwbfD");

var $j31OP = parcelRequire("j31OP");

var $ewMwZ = parcelRequire("ewMwZ");

var $8CXDT = parcelRequire("8CXDT");

var $57dZR = parcelRequire("57dZR");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $h4rmN = parcelRequire("h4rmN");

var $kna0L = parcelRequire("kna0L");
const $c2aeb295d3696ee7$export$8b412adb79c82bc8 = ({ assigneeList: assigneeList, onChange: onChange, issue: issue })=>(userId)=>{
        if ((0, $7CnHa.isDefined)(userId)) {
            const assignee = (0, $kna0L.findAssigneeItem)(assigneeList, userId);
            onChange(issue, assignee);
        } else {
            // This path covers the case where the user clears the select value. If nothing is assigned then
            // we need to force the value back to the 'Unassigned' state. This works in tandem with using the
            // value rather than defaultValue for the prop passed to Select
            const assignee = (0, $kna0L.findAssigneeItem)(assigneeList, 'unassigned');
            onChange(issue, assignee);
        }
    };
const $c2aeb295d3696ee7$export$361f73eba39649ac = ({ fetchAssigneeList: fetchAssigneeList, onChange: onChange, currentAssignees: currentAssignees, isScrolling: isScrolling = false, assigneeList: assigneeList, issue: issue, showOptimizations: showOptimizations = false, issue: { assignee: assignee, summary: summary }, isReadOnly: isReadOnly = false, assigneeListFetchStatus: assigneeListFetchStatus, issueIdForFetchAssigneeListProgress: issueIdForFetchAssigneeListProgress, UserPicker: UserPicker })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isScrolling || assigneeList.length === 0) {
        const { optimized: optimized } = issue;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const assignee = showOptimizations === true && optimized && optimized.assignee ? optimized.assignee : issue.assignee;
        const items = (0, $ewMwZ.transformPersons)(assigneeList);
        const selectedItem = items.find((item)=>item.value === assignee);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
            content: selectedItem && selectedItem.label,
            isReadOnly: showOptimizations
        });
    }
    const mapUserIdToTitle = (_, value)=>(0, $kna0L.getUserTitle)(assigneeList, value);
    const attribute = 'assignee';
    let value = assignee;
    if (showOptimizations) value = (0, $57dZR.getOptimizedValue)(issue, attribute);
    const userList = (0, $kna0L.getGroupedAssignees)({
        assigneeList: assigneeList,
        currentAssignees: currentAssignees
    }).map((option)=>{
        if (option.label && typeof option.label === 'object') return {
            ...option,
            label: formatMessage(option.label)
        };
        return option;
    });
    const user = userList.flatMap(({ options: options })=>options)// eslint-disable-next-line @typescript-eslint/no-shadow
    .find((user)=>user.value === value);
    /* Handlers */ const handleUserChange = $c2aeb295d3696ee7$export$8b412adb79c82bc8({
        assigneeList: assigneeList,
        onChange: onChange,
        issue: issue
    });
    const onFetchUserList = (query)=>{
        fetchAssigneeList({
            query: query || '',
            issueId: issue.id
        });
    };
    const getTooltipContent = ()=>{
        if (!user) return '';
        return user.value === 'unassigned' ? formatMessage((0, $h4rmN.default).unassignedTooltipMessage) : user.email;
    };
    const getControlComponent = (props)=>{
        const { children: children, selectProps: { menuIsOpen: menuIsOpen } } = props;
        const tooltipContent = menuIsOpen ? '' : getTooltipContent();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, props, children));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        attribute: attribute,
        issue: issue,
        valueMapper: mapUserIdToTitle,
        isScrolling: isScrolling,
        showOptimizations: showOptimizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserPicker, {
        placeholder: "",
        userList: userList,
        maxOptionsPerGroup: (0, $j31OP.LIMIT_OF_USERS),
        onUserChange: handleUserChange,
        onFetchUserList: onFetchUserList,
        user: user,
        selectProps: {
            'aria-label': formatMessage({
                ...(0, $h4rmN.default).assigneeCellLabel
            }, {
                issue: summary
            }),
            isClearable: value !== 'unassigned',
            isDisabled: isReadOnly,
            minSelectWidth: (0, $2LimL.MIN_SELECT_WIDTH),
            isLoading: (0, $7CnHa.isDefined)(issueIdForFetchAssigneeListProgress) && issue.id === issueIdForFetchAssigneeListProgress && assigneeListFetchStatus,
            components: {
                Control: getControlComponent
            }
        },
        issueId: issue.id,
        attribute: attribute
    }));
};
var $c2aeb295d3696ee7$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    UserPicker: (0, $a4vO3.slots).UserPicker
})($c2aeb295d3696ee7$export$361f73eba39649ac);

});
parcelRegister("gbNhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ca41a9eab3ad64$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $haaWO = parcelRequire("haaWO");

var $aesPS = parcelRequire("aesPS");
const $d4ca41a9eab3ad64$export$234c310f1a4fffd6 = (content)=>{
    if (!content) return undefined;
    if (typeof content === 'string') return content;
    if (Array.isArray(content)) return $haaWO.default(', ', content);
    return content;
};
function $d4ca41a9eab3ad64$export$2e2bcd8739ae039(props) {
    const { isReadOnly: isReadOnly, content: content } = props;
    const classNames = isReadOnly ? $aesPS.readOnly : '';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$aesPS.wireframe} ${classNames}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, $d4ca41a9eab3ad64$export$234c310f1a4fffd6(content))));
}
$d4ca41a9eab3ad64$export$2e2bcd8739ae039.defaultProps = {
    isReadOnly: false
};

});
parcelRegister("aesPS", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $77319459bff51fae$export$b2cbc93d4da94977, (v) => $77319459bff51fae$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "wireframe", () => $77319459bff51fae$export$a8fec3cf51c7da20, (v) => $77319459bff51fae$export$a8fec3cf51c7da20 = v);
var $77319459bff51fae$export$b2cbc93d4da94977;
var $77319459bff51fae$export$a8fec3cf51c7da20;
$77319459bff51fae$export$b2cbc93d4da94977 = `TWK4FW_readOnly`;
$77319459bff51fae$export$a8fec3cf51c7da20 = `TWK4FW_wireframe`;

});


parcelRegister("ewMwZ", function(module, exports) {

$parcel$export(module.exports, "transformPersons", () => $a32b82dabc00bfde$export$ca1d576fde6dcfcc);
$parcel$export(module.exports, "sort", () => $a32b82dabc00bfde$export$97db5808d8f88186);
$parcel$export(module.exports, "filter", () => $a32b82dabc00bfde$export$3dea766d36a8935f);

var $eUK1h = parcelRequire("eUK1h");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $haaWO = parcelRequire("haaWO");
var $63hMP = parcelRequire("63hMP");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $7CnHa = parcelRequire("7CnHa");
const $a32b82dabc00bfde$export$ca1d576fde6dcfcc = (persons)=>(0, $7CnHa.filterMap)((person)=>(0, $7CnHa.isDefined)(person.jiraUser), (person)=>({
            value: person.jiraUser.accountId,
            label: person.jiraUser.title,
            icon: person.jiraUser.avatarUrl,
            email: person.jiraUser.email
        }), persons);
const $a32b82dabc00bfde$var$sortByPersonTitle = $9RbxZ.default((el)=>$701od.default(el.jiraUser.title));
const $a32b82dabc00bfde$var$sortByAssigned = $9RbxZ.default($3IGDG.default($h3f0m.default('personId', 'unassigned'), $63hMP.default));
const $a32b82dabc00bfde$export$97db5808d8f88186 = $3IGDG.default($a32b82dabc00bfde$var$sortByPersonTitle, $a32b82dabc00bfde$var$sortByAssigned);
/*
<
    Person,
    JiraUser,
    [JiraUser['email'], JiraUser['title']],
    string,
    string
>
*/ const $a32b82dabc00bfde$var$getFullText = $3IGDG.default($f7Op5.default('jiraUser'), (user)=>[
        user?.email ?? '',
        user.title
    ], $haaWO.default(' '), $701od.default);
const $a32b82dabc00bfde$var$matchQuery = $eUK1h.default((query, person)=>$1l9vO.default($701od.default(query))($a32b82dabc00bfde$var$getFullText(person)));
const $a32b82dabc00bfde$export$3dea766d36a8935f = $eUK1h.default((query, people)=>$fpul1.default($a32b82dabc00bfde$var$matchQuery(query))(people));

});

parcelRegister("h4rmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c32b74bb86b2d02$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c32b74bb86b2d02$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeCellLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.assignee-cell-label",
        "defaultMessage": "Choose an assignee for issue {issue}"
    },
    currentlyAssignedGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.currently-assigned-group-title",
        "defaultMessage": "Currently assigned"
    },
    allAssigneesGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.all-assignees-group-title",
        "defaultMessage": "All users"
    },
    unassignedTooltipMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.assignee.unassigned-tooltip-message",
        "defaultMessage": "This issue is not assigned to anyone"
    }
});

});

parcelRegister("kna0L", function(module, exports) {

$parcel$export(module.exports, "findAssigneeItem", () => $71f8e7aa5218cf28$export$f96ccaaed6a64e74);
$parcel$export(module.exports, "getUserTitle", () => $71f8e7aa5218cf28$export$5f7a1baecd59f846);
$parcel$export(module.exports, "getGroupedAssignees", () => $71f8e7aa5218cf28$export$23efc4e6e86f4ba4);

var $8L1yQ = parcelRequire("8L1yQ");
var $fpul1 = parcelRequire("fpul1");
var $i0RGP = parcelRequire("i0RGP");
var $63hMP = parcelRequire("63hMP");
var $3IGDG = parcelRequire("3IGDG");
var $h3f0m = parcelRequire("h3f0m");

var $ewMwZ = parcelRequire("ewMwZ");

var $h4rmN = parcelRequire("h4rmN");
const $71f8e7aa5218cf28$export$f96ccaaed6a64e74 = (list, name)=>list.find((assignee)=>assignee.jiraUser.accountId === name);
const $71f8e7aa5218cf28$export$5f7a1baecd59f846 = (persons, userId)=>{
    const targetPerson = persons.find((person)=>person.jiraUser.accountId === userId);
    if (targetPerson) return targetPerson.jiraUser.title;
    return userId;
};
const $71f8e7aa5218cf28$export$23efc4e6e86f4ba4 = ({ assigneeList: assigneeList, currentAssignees: currentAssignees })=>{
    const unassigned = $3IGDG.default($h3f0m.default('personId', 'unassigned'), $63hMP.default);
    const allAssigneeOptions = $3IGDG.default($8L1yQ.default((p1, p2)=>p1.personId === p2.personId, assigneeList), $fpul1.default(unassigned), (0, $ewMwZ.sort), (0, $ewMwZ.transformPersons))(currentAssignees);
    const currentlyAssignedOptions = $3IGDG.default(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $fpul1.default(unassigned), (0, $ewMwZ.sort), (0, $ewMwZ.transformPersons))(currentAssignees);
    const unassignedUser = $i0RGP.default($h3f0m.default('personId', 'unassigned'), assigneeList);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        {
            options: unassignedUser && (0, $ewMwZ.transformPersons)([
                unassignedUser
            ]) || []
        },
        {
            label: (0, $h4rmN.default).currentlyAssignedGroupTitle,
            options: currentlyAssignedOptions
        },
        {
            label: (0, $h4rmN.default).allAssigneesGroupTitle,
            options: allAssigneeOptions
        }
    ];
};

});
parcelRegister("8L1yQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6603ec7d515abd32$export$2e2bcd8739ae039);

var $92ytG = parcelRequire("92ytG");

var $4g10W = parcelRequire("4g10W");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $6603ec7d515abd32$var$differenceWith = /*#__PURE__*/ (0, $4g10W.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $92ytG.default)(pred, first[idx], second) && !(0, $92ytG.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $6603ec7d515abd32$export$2e2bcd8739ae039 = $6603ec7d515abd32$var$differenceWith;

});




parcelRegister("qIzJb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df3360bc16c0195$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createBreakdownCell", () => $5df3360bc16c0195$export$6630e0b49cfb1c29);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $iN8yE = parcelRequire("iN8yE");

var $dhc4A = parcelRequire("dhc4A");
var $5df3360bc16c0195$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iN8yE.default), {})((0, $dhc4A.default));
const $5df3360bc16c0195$export$6630e0b49cfb1c29 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
EstimateCellComponent, breakdownBy)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
    class extends (0, $eUqFw.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EstimateCellComponent, {
                breakdownBy: breakdownBy,
                ...this.props
            });
        }
    };

});
parcelRegister("iN8yE", function(module, exports) {

$parcel$export(module.exports, "getBreakdown", () => $c49a1d195bbfde0d$export$44e052266c6cb01d);
$parcel$export(module.exports, "getBreakdownByEstimate", () => $c49a1d195bbfde0d$export$abf82cc9ff41d874);
$parcel$export(module.exports, "default", () => $c49a1d195bbfde0d$export$2e2bcd8739ae039);

var $kjklK = parcelRequire("kjklK");

var $YxFn4 = parcelRequire("YxFn4");

var $kFf60 = parcelRequire("kFf60");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");
var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $dhHiZ = parcelRequire("dhHiZ");

var $bnY7I = parcelRequire("bnY7I");

var $5rYNM = parcelRequire("5rYNM");
const { TODO: $c49a1d195bbfde0d$var$TODO, INPROGRESS: $c49a1d195bbfde0d$var$INPROGRESS, DONE: $c49a1d195bbfde0d$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
const $c49a1d195bbfde0d$export$f329467b33724fe7 = (parentIssueId, historyIssues, issueMap)=>historyIssues.filter((historyIssue)=>historyIssue.parent === parentIssueId)// we ignore issues that are in the plan
    .filter((historyIssue)=>!issueMap[historyIssue.id]).map((issue)=>issue.id);
const $c49a1d195bbfde0d$export$994fbe3fc8e99f59 = (issues, issueStatuses)=>issues.filter((issue)=>{
        const categoryId = $kjklK.default([
            issue.status || '',
            'categoryId'
        ], issueStatuses);
        return categoryId === $c49a1d195bbfde0d$var$DONE;
    }).map((issue)=>issue.id);
const $c49a1d195bbfde0d$export$62787c9f03e7328c = (issues, issueStatuses, parentIssueId, historyIssues, issueMap)=>{
    const issuesIdsInDoneStatus = issues.length > 0 ? $c49a1d195bbfde0d$export$994fbe3fc8e99f59(issues, issueStatuses) : [];
    const issueIdsInDoneFromHistory = $c49a1d195bbfde0d$export$f329467b33724fe7(parentIssueId, historyIssues, issueMap);
    const uniqueIssueIdsInDoneStatus = new Set([
        ...issuesIdsInDoneStatus,
        ...issueIdsInDoneFromHistory
    ]);
    return uniqueIssueIdsInDoneStatus.size;
};
const $c49a1d195bbfde0d$export$44e052266c6cb01d = (issue, issueIdToChildIssuesMap, issueStatuses, issueMap, historyIssues)=>{
    let todoCount = 0;
    let inProgressCount = 0;
    let doneCount = 0;
    const { id: id } = issue;
    const childIds = issueIdToChildIssuesMap[id];
    // We need to defensively code against there being no childIds array defined in the case where
    // a new issue is being created (because this will not exist in the map)...
    let childIssues = [];
    if (childIds) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        childIssues = childIds.map((id)=>issueMap[id]);
        const breakdown = (0, $bnY7I.getIssuesStatusBreakdown)(childIssues, issueStatuses);
        todoCount += breakdown.byCategoryId[String($c49a1d195bbfde0d$var$TODO)];
        inProgressCount += breakdown.byCategoryId[String($c49a1d195bbfde0d$var$INPROGRESS)];
    }
    // we ignore the done count returned by the status breakdown method
    // and re-calculate the done count including the history issues as well
    doneCount = $c49a1d195bbfde0d$export$62787c9f03e7328c(childIssues, issueStatuses, id, historyIssues, issueMap);
    return {
        byCategoryId: {
            [String($c49a1d195bbfde0d$var$TODO)]: todoCount,
            [String($c49a1d195bbfde0d$var$INPROGRESS)]: inProgressCount,
            [String($c49a1d195bbfde0d$var$DONE)]: doneCount
        },
        total: todoCount + inProgressCount + doneCount
    };
};
const $c49a1d195bbfde0d$export$abf82cc9ff41d874 = (issue, issueIdToDescendantsIdsMap, issueStatuses, issueMap, planningUnit, workingHours, estimateFromHistoryIssues)=>{
    const { id: id } = issue;
    const descendantIds = issueIdToDescendantsIdsMap[id] || [];
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const childIssues = descendantIds.map((id)=>issueMap[id]);
    const estimateBreakdown = (0, $bnY7I.getEstimateBreakdown)(issue, childIssues, issueStatuses, planningUnit, workingHours);
    let doneEstimate = 0;
    let noOfDoneIssues = 0;
    let noOfUnestimatedInDone = 0;
    const estimateFromDoneIssues = estimateFromHistoryIssues[id];
    if (estimateFromDoneIssues) {
        doneEstimate = estimateFromDoneIssues.estimate;
        noOfDoneIssues = estimateFromDoneIssues.numberOfIssues;
        noOfUnestimatedInDone = estimateFromDoneIssues.unEstimatedCount;
    }
    return {
        ...estimateBreakdown,
        unestimated: estimateBreakdown.unestimated + noOfUnestimatedInDone,
        byCategoryId: {
            ...estimateBreakdown.byCategoryId,
            [String($c49a1d195bbfde0d$var$DONE)]: estimateBreakdown.byCategoryId[String($c49a1d195bbfde0d$var$DONE)] + doneEstimate
        },
        total: estimateBreakdown.total + doneEstimate,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        issueCount: estimateBreakdown.issueCount + noOfDoneIssues
    };
};
const $c49a1d195bbfde0d$export$c31df4bd766f9c35 = (state)=>({
        issueIdToChildIdsMap: (0, $aK3ri.getChildrenIdsByParent)(state),
        issueIdToDescendantsIdMap: (0, $kwMvv.getDescendantIdsByParent)(state),
        estimateFromHistoryIssues: (0, $YxFn4.getEstimateFromHistoryIssues)(state),
        issueStatuses: (0, $kFf60.getIssueStatusById)(state),
        issueMapById: (0, $cwP4d.getIssueMapById)(state),
        historyIssues: (0, $kwMvv.getHistoryIssues)(state),
        isLoading: (0, $kwMvv.isLoadingHistory)(state),
        planningUnit: (0, $75KhQ.getPlanningUnit)(state),
        workingHours: (0, $dhHiZ.getJiraHoursPerDay)(state),
        projects: (0, $ehEr2.getProjects)(state),
        issueTypes: (0, $lihml.getIssueTypes)(state)
    });
var $c49a1d195bbfde0d$export$2e2bcd8739ae039 = $c49a1d195bbfde0d$export$c31df4bd766f9c35;

});
parcelRegister("YxFn4", function(module, exports) {

$parcel$export(module.exports, "getEstimateFromHistoryIssues", () => $fd0b0e86e23deec1$export$2532420da5bed387);

var $5fUv6 = parcelRequire("5fUv6");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
const $fd0b0e86e23deec1$export$c6fd3ab3f44300d0 = (issue, issueMap)=>{
    const ancestorsIds = [];
    const ancestors = [];
    let currentIssue = issue;
    while(currentIssue && currentIssue.parent){
        currentIssue = issueMap[currentIssue.parent];
        // It is entirely possible for an issue to have a parent, but that parent issue to NOT be in the plan
        if (!currentIssue) break;
        if (ancestorsIds.includes(currentIssue.id)) break;
        ancestorsIds.push(currentIssue.id);
        ancestors.push(currentIssue);
    }
    return ancestors;
};
const $fd0b0e86e23deec1$export$284f74dfe4a146bf = (issuesById, historyIssues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueIdToChildIdsMap = {};
    historyIssues// if the history issue is available in the plan, filter it
    .filter((historyIssue)=>!issuesById[historyIssue.id]).forEach((historyIssue)=>{
        const { parent: parent } = historyIssue;
        if (parent && !issueIdToChildIdsMap[parent]) issueIdToChildIdsMap[parent] = [];
        if (parent) {
            issueIdToChildIdsMap[parent].push(historyIssue);
            const ancestors = $fd0b0e86e23deec1$export$c6fd3ab3f44300d0(issuesById[parent], issuesById);
            ancestors.forEach((ancestor)=>{
                if (!issueIdToChildIdsMap[ancestor.id]) issueIdToChildIdsMap[ancestor.id] = [];
                issueIdToChildIdsMap[ancestor.id].push(historyIssue);
            });
        }
    });
    return issueIdToChildIdsMap;
};
const $fd0b0e86e23deec1$export$76f84947e56e5ca6 = (targetArray, parentId, historyIssuesWithParent)=>{
    const childHistoryIssues = historyIssuesWithParent[parentId] || [];
    childHistoryIssues.forEach((historyIssue)=>{
        targetArray.push(historyIssue);
        $fd0b0e86e23deec1$export$76f84947e56e5ca6(targetArray, historyIssue.id, historyIssuesWithParent);
    });
};
const $fd0b0e86e23deec1$export$7014b2b54bb2cfe6 = (issuesById, historyIssues, planningUnit, workingHours)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const estimateByHistoryIssueParentId = {};
    const historyIssuesWithParent = $fd0b0e86e23deec1$export$284f74dfe4a146bf(issuesById, historyIssues);
    Object.keys(historyIssuesWithParent).forEach((parentId)=>{
        const descendants = [];
        // recursively get all the descendants for the top level historic issues
        $fd0b0e86e23deec1$export$76f84947e56e5ca6(descendants, parentId, historyIssuesWithParent);
        estimateByHistoryIssueParentId[parentId] = descendants.reduce((acc, item)=>{
            if (!(0, $5fUv6.isEstimated)(planningUnit, item)) acc.unEstimatedCount += 1;
            else {
                acc.estimate = (0, $5fUv6.getEstimateValue)(planningUnit, item, workingHours) + acc.estimate;
                acc.numberOfIssues += 1;
            }
            return acc;
        }, {
            estimate: 0,
            numberOfIssues: 0,
            unEstimatedCount: 0
        });
    });
    return estimateByHistoryIssueParentId;
};
const $fd0b0e86e23deec1$export$2532420da5bed387 = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssueMapById),
    (0, $kwMvv.getHistoryIssues),
    (0, $75KhQ.getPlanningUnit),
    (0, $dhHiZ.getJiraHoursPerDay)
], $fd0b0e86e23deec1$export$7014b2b54bb2cfe6);

});

parcelRegister("bnY7I", function(module, exports) {

$parcel$export(module.exports, "getIssuesStatusBreakdown", () => $bf48407e00821f91$export$dae9c33c40f899e8);
$parcel$export(module.exports, "getEstimateBreakdown", () => $bf48407e00821f91$export$a1f397ecb6d56961);
$parcel$export(module.exports, "isIssueSubTaskType", () => $bf48407e00821f91$export$58e9558e964135a4);
$parcel$export(module.exports, "getPossibleParentIssues", () => $bf48407e00821f91$export$ab64a2584557c8a1);

var $hkOxK = parcelRequire("hkOxK");
var $fpul1 = parcelRequire("fpul1");
var $eirae = parcelRequire("eirae");
var $7Eejo = parcelRequire("7Eejo");
var $01zCq = parcelRequire("01zCq");
var $kjklK = parcelRequire("kjklK");
var $7WzTP = parcelRequire("7WzTP");
var $dRo9r = parcelRequire("dRo9r");
var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");

var $5fUv6 = parcelRequire("5fUv6");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $bf48407e00821f91$export$dae9c33c40f899e8 = (issues, issueStatuses, option)=>{
    const { TODO: TODO, INPROGRESS: INPROGRESS, DONE: DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES_CONST);
    const categoryKeys = [
        TODO,
        INPROGRESS,
        DONE
    ].map(String);
    const getCategoryId = ({ status: status })=>{
        const categoryId = $kjklK.default([
            status || '',
            'categoryId'
        ], issueStatuses);
        if (!(0, $7CnHa.isDefined)(categoryId)) throw new Error(`Unexpected issue status: ${status || ''}`);
        return String(categoryId);
    };
    /**
	 * Groups the array of Issue[] by their categoryId
	 * Input: Issue[],
	 * Output:  {
	 *  [TODO]: Issue[], [INPROGRESS]: Issue[], [DONE]: Issue[]
	 * }
	 */ const groupedByCategoryId = $hkOxK.default($01zCq.default({
        [TODO]: [],
        [INPROGRESS]: [],
        [DONE]: []
    }), $7WzTP.default(categoryKeys), $eirae.default(getCategoryId), $fpul1.default(({ status: status })=>(0, $7CnHa.isDefined)(status)))(issues);
    /**
	 * Counts the number for each category, the calculation is different depending on planningUnit
	 * Output: { [TODO]: number, [INPROGRESS]: number, [DONE]: number }
	 */ const byCategoryId = !option ? $7Eejo.default((issues)=>issues.length, groupedByCategoryId) : $7Eejo.default(// eslint-disable-next-line @typescript-eslint/no-shadow
    (issues)=>issues.reduce((total, issue)=>{
            const { storyPoints: storyPoints } = issue;
            const { planningUnit: planningUnit, workingHours: workingHours } = option;
            switch(planningUnit){
                case (0, $5rYNM.PlanningUnits).days:
                case (0, $5rYNM.PlanningUnits).hours:
                    return total + // TODO: Current behaviour is to ignore timeSpent, but it doesn't really make sense
                    // getTimeSpentValue(planningUnit, issue, workingHours) +
                    (0, $5fUv6.getEstimateValue)(planningUnit, issue, workingHours);
                case (0, $5rYNM.PlanningUnits).storyPoints:
                    return total + (storyPoints ?? 0);
                default:
                    return total + 1;
            }
        }, 0), groupedByCategoryId);
    /**
	 * Adds all the values in the object.
	 * Input: { [any]: number }, Output: number
	 */ const total = $hkOxK.default($dRo9r.default, $UCNmJ.default)(byCategoryId);
    return {
        byCategoryId: byCategoryId,
        total: total
    };
};
const $bf48407e00821f91$export$a1f397ecb6d56961 = (issue, childIssues, issueStatuses, planningUnit, workingHours)=>{
    const { TODO: TODO, INPROGRESS: INPROGRESS, DONE: DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES_CONST);
    const breakdown = {
        byCategoryId: {
            [TODO]: 0,
            [INPROGRESS]: 0,
            [DONE]: 0
        },
        total: 0,
        unestimated: 0,
        issueCount: 0
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const updateBreakdown = (issue)=>{
        if ((0, $5fUv6.isEstimated)(planningUnit, issue)) {
            // If the issue is scenario issue, there won't be an issue status associated so consider them as TODO.
            const categoryId = $kjklK.default([
                issue.status || '',
                'categoryId'
            ], issueStatuses) || TODO;
            const remainingEstimate = (0, $5fUv6.getEstimateValue)(planningUnit, issue, workingHours);
            const timeSpent = (0, $5fUv6.getTimeSpentValue)(planningUnit, issue, workingHours);
            if (categoryId === DONE) // Done should include both the time spent and the remaining time for the issue.
            breakdown.byCategoryId[categoryId] = (breakdown.byCategoryId[categoryId] || 0) + remainingEstimate + timeSpent;
            else {
                // Inprogress and todo should include the remaining estimate only.
                // Time spent for these statuses will be attributed to 'done'.
                breakdown.byCategoryId[categoryId] = (breakdown.byCategoryId[categoryId] || 0) + remainingEstimate;
                breakdown.byCategoryId[DONE] = (breakdown.byCategoryId[DONE] || 0) + timeSpent;
            }
            breakdown.total += remainingEstimate + timeSpent;
            breakdown.issueCount += 1;
        } else breakdown.unestimated += 1;
    };
    childIssues.forEach(updateBreakdown);
    updateBreakdown(issue);
    return breakdown;
};
const $bf48407e00821f91$export$58e9558e964135a4 = ({ issue: issue, issueTypesById: issueTypesById })=>{
    const { type: type } = issue;
    const issueType = issueTypesById[type];
    return issueType && !!issueType.subTask;
};
const $bf48407e00821f91$export$ab64a2584557c8a1 = ({ issue: issue, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById })=>{
    const { level: issueLevel, project: issueProjectId } = issue;
    const isIssueSubtask = $bf48407e00821f91$export$58e9558e964135a4({
        issue: issue,
        issueTypesById: issueTypesById
    });
    const { isSimplified: isIssueSimplified } = projectsById[issueProjectId] ?? {
        isSimplified: false
    };
    const isIssueLevelOne = issueLevel === (0, $8YqJS.EPIC_LEVEL);
    return issues.filter((currentIssue)=>{
        if (isIssueSimplified) {
            if ((0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr')) return(// TMP only allows reparent within project scope except for level one to level two (Epic to Initiative)
            currentIssue.level === issueLevel + 1 && (currentIssue.project === issueProjectId || isIssueLevelOne));
            return(// TMP only allows reparent within project scope
            currentIssue.level === issueLevel + 1 && currentIssue.project === issueProjectId);
        }
        const { isSimplified: isCurrentIssueSimplified } = projectsById[currentIssue.project] ?? {
            isSimplified: false
        };
        if (isCurrentIssueSimplified) // Jira doesn't allow cross project-type reparenting
        return false;
        return isIssueSubtask ? /**
				 * [This case applies to CMP only]
				 * Allow reparenting subtask to issue of any non subtask-level
				 */ currentIssue.level !== issueLevel : currentIssue.level === issueLevel + 1;
    });
};

});
parcelRegister("7Eejo", function(module, exports) {

$parcel$export(module.exports, "default", () => $59175edea22cfb60$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $hC9UT = parcelRequire("hC9UT");

var $erwaN = parcelRequire("erwaN");
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $59175edea22cfb60$var$mapObjIndexed = /*#__PURE__*/ (0, $ggdJA.default)(function mapObjIndexed(fn, obj) {
    return (0, $hC9UT.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $erwaN.default)(obj));
});
var $59175edea22cfb60$export$2e2bcd8739ae039 = $59175edea22cfb60$var$mapObjIndexed;

});



parcelRegister("dhc4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a26d3399d681ba6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f7Op5 = parcelRequire("f7Op5");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ThfTr = parcelRequire("ThfTr");

var $iN8yE = parcelRequire("iN8yE");

var $jf0L8 = parcelRequire("jf0L8");
const $0a26d3399d681ba6$export$a7f376d1bbbf50c8 = ({ breakdownBy: breakdownBy, estimateFromHistoryIssues: estimateFromHistoryIssues, historyIssues: historyIssues, isLoading: isLoading, isScrolling: isScrolling, issue: issue, issueIdToChildIdsMap: issueIdToChildIdsMap, issueIdToDescendantsIdMap: issueIdToDescendantsIdMap, issueMapById: issueMapById, issueStatuses: issueStatuses, issueTypes: issueTypes, planningUnit: planningUnit, projects: projects, workingHours: workingHours })=>{
    if (isLoading) return null;
    const { issueKey: issueKey, id: id, summary: summary, project: project, type: type } = issue;
    const projectsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), projects);
    const issueTypesByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueTypes);
    const projectKey = project ? projectsByIdMap[project]?.key || '' : '';
    const issueType = issueTypesByIdMap[type];
    const issueTitleData = {
        issueKey: issueKey,
        summary: summary,
        id: id,
        issueType: issueType,
        projectKey: projectKey
    };
    const breakdownProps = {
        onlyRenderStatusBar: isScrolling,
        planningUnit: breakdownBy === (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS ? 'issueCount' : planningUnit,
        breakdownBy: breakdownBy
    };
    const statusBreakdownProps = breakdownBy === (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).ESTIMATE ? {
        ...breakdownProps,
        ...(0, $iN8yE.getBreakdownByEstimate)(issue, issueIdToDescendantsIdMap, issueStatuses, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues),
        issueTitleData: issueTitleData
    } : {
        ...breakdownProps,
        ...(0, $iN8yE.getBreakdown)(issue, issueIdToChildIdsMap, issueStatuses, issueMapById, historyIssues)
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jf0L8["breakdown-container"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ThfTr.default), statusBreakdownProps)));
};
var $0a26d3399d681ba6$export$2e2bcd8739ae039 = $0a26d3399d681ba6$export$a7f376d1bbbf50c8;

});
parcelRegister("ThfTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c4aaac1cf7d9b4$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $jHYj3 = parcelRequire("jHYj3");

var $kpu2b = parcelRequire("kpu2b");
var $46c4aaac1cf7d9b4$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition'), (0, $jHYj3.default), (0, $kpu2b.default));

});
parcelRegister("jHYj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d24cf4fc95d9e51$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbfD = parcelRequire("gwbfD");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("8cfkP");
var $8CBm8 = parcelRequire("8CBm8");
var $Yvkhc = parcelRequire("Yvkhc");

var $eiHbQ = parcelRequire("eiHbQ");

var $2tvn9 = parcelRequire("2tvn9");
const { TODO: $3d24cf4fc95d9e51$var$TODO, INPROGRESS: $3d24cf4fc95d9e51$var$INPROGRESS, DONE: $3d24cf4fc95d9e51$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
const $3d24cf4fc95d9e51$var$StatusBreakdown = (props)=>{
    const { onlyRenderStatusBar: onlyRenderStatusBar = false, breakdownBy: breakdownBy = (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS, total: total, label: label, showToolTip: showToolTip, planningUnit: planningUnit, byCategoryId: byCategoryId } = props;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const getBreakdown = (0, $eUqFw.useCallback)(()=>({
            todo: byCategoryId[String($3d24cf4fc95d9e51$var$TODO)],
            inprogress: byCategoryId[String($3d24cf4fc95d9e51$var$INPROGRESS)],
            done: byCategoryId[String($3d24cf4fc95d9e51$var$DONE)]
        }), [
        byCategoryId
    ]);
    const renderStatusBar = (0, $eUqFw.useCallback)(()=>{
        const { todo: todo, inprogress: inprogress, done: done } = getBreakdown();
        const remaining = todo + inprogress;
        const todoWidth = todo / total * 100;
        const inProgressWidth = inprogress / total * 100;
        const doneWidth = total === 0 ? 0 : done / total * 100;
        const remainingWidth = total === 0 ? 100 : remaining / total * 100;
        const overBooked = done > total;
        const todoBar = // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${todoWidth}%`,
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).TODO
            }
        });
        const inprogressBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${inProgressWidth}%`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).INPROGRESS
            }
        });
        const doneBar = // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${doneWidth}%`,
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).DONE
            }
        });
        let bar = breakdownBy === 'status' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.bar,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
        }, doneWidth > 0 && doneBar, inProgressWidth > 0 && inprogressBar, todoWidth > 0 && todoBar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.bar,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
        }, doneWidth > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: overBooked ? `${$2tvn9.completed} ${$2tvn9.overbooked}` : $2tvn9.completed,
            style: {
                width: `${doneWidth}%`
            }
        }), remainingWidth > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2tvn9.remaining,
            style: {
                width: `${remainingWidth}%`
            }
        }));
        if (showToolTip === true && breakdownBy === 'estimate') bar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $eiHbQ.default).breakdownByEstimateToolTip, {
                done: done,
                donePercent: total ? Math.round(done * 100 / total) : '0',
                total: total,
                planningUnit: planningUnit
            }),
            position: "mouse"
        }, bar);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2tvn9.breakdown
        }, label, bar));
    }, [
        breakdownBy,
        formatMessage,
        getBreakdown,
        label,
        planningUnit,
        showToolTip,
        total
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.container,
            onClick: onToggle,
            tabIndex: 0,
            role: "button",
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onKeyDown: ()=>{},
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.trigger",
            ...triggerProps
        }, renderStatusBar()), [
        onToggle,
        renderStatusBar
    ]);
    const renderContent = ()=>breakdownBy === (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Yvkhc.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CBm8.default), props);
    if (total === 0 && breakdownBy === (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    if (onlyRenderStatusBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2tvn9.container
    }, renderStatusBar());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        placement: "bottom-start"
    });
};
var $3d24cf4fc95d9e51$export$2e2bcd8739ae039 = $3d24cf4fc95d9e51$var$StatusBreakdown;

});
parcelRegister("8cfkP", function(module, exports) {

$parcel$export(module.exports, "StatusFlyout", () => (parcelRequire("Yvkhc")).default);
$parcel$export(module.exports, "EstimateFlyout", () => (parcelRequire("8CBm8")).default);

var $8CBm8 = parcelRequire("8CBm8");

var $Yvkhc = parcelRequire("Yvkhc");

});
parcelRegister("8CBm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $afd53776f422ce0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");

var $hl4M2 = parcelRequire("hl4M2");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $3c22F = parcelRequire("3c22F");

var $hpAm0 = parcelRequire("hpAm0");

var $lLhwB = parcelRequire("lLhwB");

var $fJsYU = parcelRequire("fJsYU");
const { TODO: $afd53776f422ce0f$var$TODO, INPROGRESS: $afd53776f422ce0f$var$INPROGRESS, DONE: $afd53776f422ce0f$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
const $afd53776f422ce0f$var$EstimateFlyout = (props)=>{
    const { planningUnit: planningUnit, byCategoryId: byCategoryId, unestimated: unestimated = 0, issueCount: issueCount = 0, issueTitleData: issueTitleData } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getBreakdown = ()=>({
            completed: byCategoryId[String($afd53776f422ce0f$var$DONE)],
            remaining: byCategoryId[String($afd53776f422ce0f$var$TODO)] + byCategoryId[String($afd53776f422ce0f$var$INPROGRESS)]
        });
    const getLabel = (count)=>{
        const countToTwoDigit = (0, $fJsYU.roundToTwoDigit)(count);
        let label = formatMessage((0, $3c22F.default).issueCountLabel, {
            numberOfIssues: countToTwoDigit
        });
        if (planningUnit === (0, $5rYNM.PlanningUnits).storyPoints) label = formatMessage((0, $3c22F.default).storyPointsCountLabel, {
            storyPoints: countToTwoDigit
        });
        else if (planningUnit === (0, $5rYNM.PlanningUnits).days) label = formatMessage((0, $3c22F.default).daysCountLabel, {
            days: countToTwoDigit
        });
        else if (planningUnit === (0, $5rYNM.PlanningUnits).hours) label = formatMessage((0, $3c22F.default).hoursCountLabel, {
            hours: countToTwoDigit
        });
        return label;
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getIssueTitle = (issueTitleData)=>{
        const { projectKey: projectKey, issueType: issueType, issueKey: issueKey, id: id, summary: summary } = issueTitleData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $lLhwB.issueTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $lLhwB.issueIcon,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundSize: 'contain',
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
            projectKey: projectKey,
            issueKey: issueKey,
            className: $lLhwB.issueLink
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: summary,
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $lLhwB.issueSummary
        }, summary))));
    };
    const { completed: completed, remaining: remaining } = getBreakdown();
    const total = completed + remaining;
    const hasUnestimatedIssues = unestimated > 0;
    const hasChildIssues = unestimated + issueCount > 1;
    const percent = total > 0 ? (0, $fJsYU.roundToTwoDigit)(completed / total * 100) : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? $lLhwB.flyout : $lLhwB.flyoutOld,
        "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.estimate-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, (0, $7CnHa.isDefined)(issueTitleData) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2,
        className: $lLhwB.issueTitleCell
    }, getIssueTitle(issueTitleData))), !hasChildIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, hasUnestimatedIssues ? formatMessage((0, $3c22F.default).individualIssueUnestimatedLabel) : formatMessage((0, $3c22F.default).individualIssueBreakdownLabel, {
        percent: percent,
        remaining: (0, $fJsYU.roundToTwoDigit)(remaining),
        total: getLabel(total)
    }))), hasChildIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).completed))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAm0.default), {
        count: completed,
        total: total,
        label: getLabel(completed)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).remaining))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAm0.default), {
        count: remaining,
        total: total,
        label: getLabel(remaining)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).total)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lLhwB.countLabel
    }, getLabel(total), hasUnestimatedIssues ? '*' : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("hr", {
        className: $lLhwB.separator
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).estimatedIssuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lLhwB.countLabel
    }, issueCount))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).unestimatedIssuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lLhwB.countLabel
    }, unestimated))), hasUnestimatedIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2,
        className: $lLhwB.accuracyWarning
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).notAccurateProgress)))))));
};
var $afd53776f422ce0f$export$2e2bcd8739ae039 = $afd53776f422ce0f$var$EstimateFlyout;

});
parcelRegister("7Iub8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c6794d8c1241a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gwbfD = parcelRequire("gwbfD");

var $1E0y3 = parcelRequire("1E0y3");
function $95c6794d8c1241a6$export$2e2bcd8739ae039({ children: children, content: content, id: id, position: position = 'bottom' }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1E0y3.ellipsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: content,
        position: position,
        tag: "span",
        key: id
    }, children)));
}

});
parcelRegister("1E0y3", function(module, exports) {

$parcel$export(module.exports, "ellipsed", () => $1329f3b98ab92c58$export$6ce21b76224237ee, (v) => $1329f3b98ab92c58$export$6ce21b76224237ee = v);
var $1329f3b98ab92c58$export$6ce21b76224237ee;
$1329f3b98ab92c58$export$6ce21b76224237ee = `jh2iBq_ellipsed`;

});


parcelRegister("3c22F", function(module, exports) {

$parcel$export(module.exports, "default", () => $042de4db063aac02$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $042de4db063aac02$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    todo: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.todo",
        "defaultMessage": "To do"
    },
    inprogress: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.inprogress",
        "defaultMessage": "In progress"
    },
    done: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.done",
        "defaultMessage": "Done"
    },
    completed: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.completed",
        "defaultMessage": "Completed"
    },
    remaining: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.remaining",
        "defaultMessage": "Remaining"
    },
    total: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.total",
        "defaultMessage": "Total"
    },
    estimatedIssuesLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.estimated-issues-label",
        "defaultMessage": "Estimated issues"
    },
    unestimatedIssuesLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.unestimated-issues-label",
        "defaultMessage": "Unestimated issues"
    },
    issueCountLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.issue-count-label",
        "defaultMessage": "{numberOfIssues, plural, one {{numberOfIssues} issue} other {{numberOfIssues} issues}}"
    },
    storyPointsCountLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.story-points-count-label",
        "defaultMessage": "{storyPoints, plural, one {{storyPoints} point} other {{storyPoints} points}}"
    },
    hoursCountLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.hours-count-label",
        "defaultMessage": "{hours, plural, one {{hours} hour} other {{hours} hours}}"
    },
    daysCountLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.days-count-label",
        "defaultMessage": "{days, plural, one {{days} day} other {{days} days}}"
    },
    totalIssuesLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.total-issues-label",
        "defaultMessage": "Total issues"
    },
    notAccurateProgress: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.not-accurate-progress",
        "defaultMessage": "*Progress may not be accurate due to unestimated issues"
    },
    individualIssueBreakdownLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.individual-issue-breakdown-label",
        "defaultMessage": "{percent}% | {remaining} out of {total} remaining"
    },
    individualIssueUnestimatedLabel: {
        "id": "portfolio-3-portfolio.common.status-breakdown.components.individual-issue-unestimated-label",
        "defaultMessage": "Unestimated"
    }
});

});

parcelRegister("hpAm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6c1b613ca25292$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLhwB = parcelRequire("lLhwB");
function $6e6c1b613ca25292$export$2e2bcd8739ae039({ count: count, total: total, label: label }) {
    const percentage = total && Math.round(count / total * 100);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lLhwB.totalValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lLhwB.countLabel
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lLhwB.percentage
    }, "(", percentage, "%)")));
}

});
parcelRegister("lLhwB", function(module, exports) {

$parcel$export(module.exports, "accuracyWarning", () => $fd7b94d5bbfbc530$export$ca0c5138b6a08a79, (v) => $fd7b94d5bbfbc530$export$ca0c5138b6a08a79 = v);
$parcel$export(module.exports, "countLabel", () => $fd7b94d5bbfbc530$export$19665c9017513a41, (v) => $fd7b94d5bbfbc530$export$19665c9017513a41 = v);
$parcel$export(module.exports, "flyout", () => $fd7b94d5bbfbc530$export$ec4922be16378791, (v) => $fd7b94d5bbfbc530$export$ec4922be16378791 = v);
$parcel$export(module.exports, "flyoutOld", () => $fd7b94d5bbfbc530$export$30b9d66acf28aaf7, (v) => $fd7b94d5bbfbc530$export$30b9d66acf28aaf7 = v);
$parcel$export(module.exports, "issueIcon", () => $fd7b94d5bbfbc530$export$415983cbc1f2b3fe, (v) => $fd7b94d5bbfbc530$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $fd7b94d5bbfbc530$export$b71709449311b2f9, (v) => $fd7b94d5bbfbc530$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueSummary", () => $fd7b94d5bbfbc530$export$7c7bc027bbbea103, (v) => $fd7b94d5bbfbc530$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $fd7b94d5bbfbc530$export$12781bd67c11efd8, (v) => $fd7b94d5bbfbc530$export$12781bd67c11efd8 = v);
$parcel$export(module.exports, "issueTitleCell", () => $fd7b94d5bbfbc530$export$b338cf20d238f012, (v) => $fd7b94d5bbfbc530$export$b338cf20d238f012 = v);
$parcel$export(module.exports, "percentage", () => $fd7b94d5bbfbc530$export$a3560dfa62c7efe0, (v) => $fd7b94d5bbfbc530$export$a3560dfa62c7efe0 = v);
$parcel$export(module.exports, "separator", () => $fd7b94d5bbfbc530$export$3e523c77c1f23f8c, (v) => $fd7b94d5bbfbc530$export$3e523c77c1f23f8c = v);
$parcel$export(module.exports, "totalValue", () => $fd7b94d5bbfbc530$export$c6e8091564698d96, (v) => $fd7b94d5bbfbc530$export$c6e8091564698d96 = v);
var $fd7b94d5bbfbc530$export$ca0c5138b6a08a79;
var $fd7b94d5bbfbc530$export$85b9a36db797e02b;
var $fd7b94d5bbfbc530$export$19665c9017513a41;
var $fd7b94d5bbfbc530$export$ec4922be16378791;
var $fd7b94d5bbfbc530$export$30b9d66acf28aaf7;
var $fd7b94d5bbfbc530$export$415983cbc1f2b3fe;
var $fd7b94d5bbfbc530$export$b71709449311b2f9;
var $fd7b94d5bbfbc530$export$7c7bc027bbbea103;
var $fd7b94d5bbfbc530$export$12781bd67c11efd8;
var $fd7b94d5bbfbc530$export$b338cf20d238f012;
var $fd7b94d5bbfbc530$export$a3560dfa62c7efe0;
var $fd7b94d5bbfbc530$export$3e523c77c1f23f8c;
var $fd7b94d5bbfbc530$export$c6e8091564698d96;
$fd7b94d5bbfbc530$export$ca0c5138b6a08a79 = `qE68GG_accuracyWarning`;
$fd7b94d5bbfbc530$export$85b9a36db797e02b = `qE68GG_count`;
$fd7b94d5bbfbc530$export$19665c9017513a41 = `qE68GG_countLabel`;
$fd7b94d5bbfbc530$export$ec4922be16378791 = `qE68GG_flyout`;
$fd7b94d5bbfbc530$export$30b9d66acf28aaf7 = `qE68GG_flyoutOld`;
$fd7b94d5bbfbc530$export$415983cbc1f2b3fe = `qE68GG_issueIcon`;
$fd7b94d5bbfbc530$export$b71709449311b2f9 = `qE68GG_issueLink`;
$fd7b94d5bbfbc530$export$7c7bc027bbbea103 = `qE68GG_issueSummary`;
$fd7b94d5bbfbc530$export$12781bd67c11efd8 = `qE68GG_issueTitle`;
$fd7b94d5bbfbc530$export$b338cf20d238f012 = `qE68GG_issueTitleCell`;
$fd7b94d5bbfbc530$export$a3560dfa62c7efe0 = `qE68GG_percentage`;
$fd7b94d5bbfbc530$export$3e523c77c1f23f8c = `qE68GG_separator`;
$fd7b94d5bbfbc530$export$c6e8091564698d96 = `qE68GG_totalValue`;

});


parcelRegister("fJsYU", function(module, exports) {

$parcel$export(module.exports, "roundToTwoDigit", () => $b9b4852a04f6e097$export$86ca448670eadcc3);
const $b9b4852a04f6e097$export$86ca448670eadcc3 = (number)=>Math.round(number * 100) / 100;

});


parcelRegister("Yvkhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $73b2a741c400ea82$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $3c22F = parcelRequire("3c22F");

var $hpAm0 = parcelRequire("hpAm0");

var $lLhwB = parcelRequire("lLhwB");

var $fJsYU = parcelRequire("fJsYU");
const { TODO: $73b2a741c400ea82$var$TODO, INPROGRESS: $73b2a741c400ea82$var$INPROGRESS, DONE: $73b2a741c400ea82$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
const $73b2a741c400ea82$var$StatusFlyout = (props)=>{
    const { issueCount: issueCount, planningUnit: planningUnit, byCategoryId: byCategoryId } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getBreakdown = ()=>({
            todo: byCategoryId[String($73b2a741c400ea82$var$TODO)],
            inprogress: byCategoryId[String($73b2a741c400ea82$var$INPROGRESS)],
            done: byCategoryId[String($73b2a741c400ea82$var$DONE)]
        });
    const getLabel = (count)=>{
        let label = formatMessage((0, $3c22F.default).issueCountLabel, {
            numberOfIssues: count
        });
        const countToTwoDigit = (0, $fJsYU.roundToTwoDigit)(count);
        if (planningUnit === (0, $5rYNM.PLANNING_UNITS).STORY_POINTS) label = formatMessage((0, $3c22F.default).storyPointsCountLabel, {
            storyPoints: countToTwoDigit
        });
        else if (planningUnit === (0, $5rYNM.PLANNING_UNITS).DAYS) label = formatMessage((0, $3c22F.default).daysCountLabel, {
            days: countToTwoDigit
        });
        else if (planningUnit === (0, $5rYNM.PLANNING_UNITS).HOURS) label = formatMessage((0, $3c22F.default).hoursCountLabel, {
            hours: countToTwoDigit
        });
        return label;
    };
    const { todo: todo, inprogress: inprogress, done: done } = getBreakdown();
    const total = todo + inprogress + done;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? $lLhwB.flyout : $lLhwB.flyoutOld,
        "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.status-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).done))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.done",
        "data-count": done
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAm0.default), {
        count: done,
        total: total,
        label: getLabel(done)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "inprogress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).inprogress))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.inprogress",
        "data-count": inprogress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAm0.default), {
        count: inprogress,
        total: total,
        label: getLabel(inprogress)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).todo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        "data-testid": "portfolio-3-portfolio.common.status-breakdown.components.todo",
        "data-count": todo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAm0.default), {
        count: todo,
        total: total,
        label: getLabel(todo)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).total)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lLhwB.countLabel
    }, getLabel(total)))), (0, $7CnHa.isDefined)(issueCount) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3c22F.default).totalIssuesLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lLhwB.countLabel
    }, issueCount))))));
};
var $73b2a741c400ea82$export$2e2bcd8739ae039 = $73b2a741c400ea82$var$StatusFlyout;

});


parcelRegister("eiHbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $64dae6a3dddc054c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $64dae6a3dddc054c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    breakdownByEstimateToolTip: {
        "id": "portfolio-3-portfolio.common.status-breakdown.breakdown-by-estimate-tool-tip",
        "defaultMessage": "{done} ({donePercent}%) of {total} {planningUnit, select, Hours {hours} StoryPoints {points} Days {days} other {points}}"
    }
});

});

parcelRegister("2tvn9", function(module, exports) {

$parcel$export(module.exports, "bar", () => $1cd6a018e18b2f95$export$d927737047eb3867, (v) => $1cd6a018e18b2f95$export$d927737047eb3867 = v);
$parcel$export(module.exports, "breakdown", () => $1cd6a018e18b2f95$export$34efeb50ac145768, (v) => $1cd6a018e18b2f95$export$34efeb50ac145768 = v);
$parcel$export(module.exports, "completed", () => $1cd6a018e18b2f95$export$ec6bc36c360d4313, (v) => $1cd6a018e18b2f95$export$ec6bc36c360d4313 = v);
$parcel$export(module.exports, "container", () => $1cd6a018e18b2f95$export$34e0f9847d4c02dd, (v) => $1cd6a018e18b2f95$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "overbooked", () => $1cd6a018e18b2f95$export$312c3ba826526246, (v) => $1cd6a018e18b2f95$export$312c3ba826526246 = v);
$parcel$export(module.exports, "remaining", () => $1cd6a018e18b2f95$export$b3be9c438214c6f4, (v) => $1cd6a018e18b2f95$export$b3be9c438214c6f4 = v);
var $1cd6a018e18b2f95$export$d927737047eb3867;
var $1cd6a018e18b2f95$export$34efeb50ac145768;
var $1cd6a018e18b2f95$export$ec6bc36c360d4313;
var $1cd6a018e18b2f95$export$34e0f9847d4c02dd;
var $1cd6a018e18b2f95$export$312c3ba826526246;
var $1cd6a018e18b2f95$export$b3be9c438214c6f4;
$1cd6a018e18b2f95$export$d927737047eb3867 = `uwXdGW_bar`;
$1cd6a018e18b2f95$export$34efeb50ac145768 = `uwXdGW_breakdown`;
$1cd6a018e18b2f95$export$ec6bc36c360d4313 = `uwXdGW_completed`;
$1cd6a018e18b2f95$export$34e0f9847d4c02dd = `uwXdGW_container`;
$1cd6a018e18b2f95$export$312c3ba826526246 = `uwXdGW_overbooked`;
$1cd6a018e18b2f95$export$b3be9c438214c6f4 = `uwXdGW_remaining`;

});


parcelRegister("kpu2b", function(module, exports) {

$parcel$export(module.exports, "default", () => $24232386181f17c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $eNhh9 = parcelRequire("eNhh9");
var $gwbfD = parcelRequire("gwbfD");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("8cfkP");
var $8CBm8 = parcelRequire("8CBm8");
var $Yvkhc = parcelRequire("Yvkhc");

var $eiHbQ = parcelRequire("eiHbQ");

var $2tvn9 = parcelRequire("2tvn9");
const { TODO: $24232386181f17c7$var$TODO, INPROGRESS: $24232386181f17c7$var$INPROGRESS, DONE: $24232386181f17c7$var$DONE } = (0, $5rYNM.ISSUE_STATUS_CATEGORIES);
// eslint-disable-next-line jira/react/no-class-components
class $24232386181f17c7$var$StatusBreakdown extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onlyRenderStatusBar: false,
            breakdownBy: (0, $5rYNM.BREAKDOWN_SPRINT_CAPACITY_BY).STATUS
        };
    }
    getBreakdown() {
        const { byCategoryId: byCategoryId } = this.props;
        return {
            todo: byCategoryId[String($24232386181f17c7$var$TODO)],
            inprogress: byCategoryId[String($24232386181f17c7$var$INPROGRESS)],
            done: byCategoryId[String($24232386181f17c7$var$DONE)]
        };
    }
    renderStatusBar() {
        const { total: total, breakdownBy: breakdownBy, label: label, showToolTip: showToolTip, planningUnit: planningUnit, intl: intl } = this.props;
        const { todo: todo, inprogress: inprogress, done: done } = this.getBreakdown();
        const remaining = todo + inprogress;
        const todoWidth = todo / total * 100;
        const inProgressWidth = inprogress / total * 100;
        const doneWidth = total === 0 ? 0 : done / total * 100;
        const remainingWidth = total === 0 ? 100 : remaining / total * 100;
        const overBooked = done > total;
        const todoBar = // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${todoWidth}%`,
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).TODO
            }
        });
        const inprogressBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${inProgressWidth}%`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).INPROGRESS
            }
        });
        const doneBar = // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: `${doneWidth}%`,
                backgroundColor: (0, $33N5G.statusBreakdownColourMap).DONE
            }
        });
        let bar = breakdownBy === 'status' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.bar,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
        }, doneWidth > 0 && doneBar, inProgressWidth > 0 && inprogressBar, todoWidth > 0 && todoBar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.bar,
            "data-testid": "portfolio-3-portfolio.common.status-breakdown.status-breakdown-bar"
        }, doneWidth > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: overBooked ? `${$2tvn9.completed} ${$2tvn9.overbooked}` : $2tvn9.completed,
            style: {
                width: `${doneWidth}%`
            }
        }), remainingWidth > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2tvn9.remaining,
            style: {
                width: `${remainingWidth}%`
            }
        }));
        if (showToolTip === true && breakdownBy === 'estimate') bar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: intl.formatMessage((0, $eiHbQ.default).breakdownByEstimateToolTip, {
                done: done,
                donePercent: total ? Math.round(done * 100 / total) : '0',
                total: total,
                planningUnit: planningUnit
            }),
            position: "mouse"
        }, bar);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2tvn9.breakdown
        }, label, bar));
    }
    render() {
        const { showFlyout: showFlyout } = this.state;
        const { intl: intl, ...flyoutProps } = this.props;
        const { total: total, onlyRenderStatusBar: onlyRenderStatusBar, issueCount: issueCount, breakdownBy: breakdownBy } = this.props;
        if (total === 0 && breakdownBy === 'status') return null;
        if (onlyRenderStatusBar === true) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2tvn9.container
        }, this.renderStatusBar());
        const flyout = breakdownBy === 'status' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Yvkhc.default), flyoutProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CBm8.default), flyoutProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $2tvn9.container,
            onMouseEnter: ()=>this.showFlyout(),
            onMouseLeave: ()=>this.hideFlyout()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            content: flyout,
            isOpen: showFlyout,
            issueCount: issueCount
        }, this.renderStatusBar()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            showFlyout: false
        };
        this.showFlyout = ()=>this.setState({
                showFlyout: true
            });
        this.hideFlyout = ()=>this.setState({
                showFlyout: false
            });
    }
}
var $24232386181f17c7$export$2e2bcd8739ae039 = (0, $2qhQi.default)($24232386181f17c7$var$StatusBreakdown);

});


parcelRegister("jf0L8", function(module, exports) {

$parcel$export(module.exports, "breakdown-container", () => $e02001d185a96341$export$c192079175952776, (v) => $e02001d185a96341$export$c192079175952776 = v);
var $e02001d185a96341$export$c192079175952776;
$e02001d185a96341$export$c192079175952776 = `_8rLZ3q_breakdown-container`;

});



parcelRegister("jFi8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8bc94d6e6c3cbc0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $flzGZ = parcelRequire("flzGZ");

var $dhNuw = parcelRequire("dhNuw");

var $7eiVJ = parcelRequire("7eiVJ");
var $d8bc94d6e6c3cbc0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $dhNuw.default), (0, $flzGZ.default))((0, $7eiVJ.default));

});
parcelRegister("flzGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f40b8deef69095$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $90f40b8deef69095$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, components)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                components: components.length === 0 ? null : components
            }));
        }
    });
var $90f40b8deef69095$export$2e2bcd8739ae039 = $90f40b8deef69095$var$dispatchMethods;

});

parcelRegister("dhNuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a7b5877f69fc5f$export$2e2bcd8739ae039);

var $lvJU2 = parcelRequire("lvJU2");

var $iK4oF = parcelRequire("iK4oF");
const $84a7b5877f69fc5f$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    componentsByProjectId: (0, $lvJU2.getComponentsByProjectId)
});
var $84a7b5877f69fc5f$export$2e2bcd8739ae039 = $84a7b5877f69fc5f$var$querySelector;

});

parcelRegister("7eiVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c80d8af9b6d9e30$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7CACT = parcelRequire("7CACT");
function $6c80d8af9b6d9e30$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CACT.default), props);
}

});
parcelRegister("7CACT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9890e3ccad2bbf07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2eaAI = parcelRequire("2eaAI");

var $8LmKR = parcelRequire("8LmKR");
const $9890e3ccad2bbf07$var$getComponentOption = (component)=>({
        label: component.name,
        value: component.id.toString()
    });
const $9890e3ccad2bbf07$export$8d800dbad5a57be1 = ({ issue: issue, componentsByProjectId: componentsByProjectId })=>{
    if (!issue.project) return [];
    return componentsByProjectId[issue.project.toString()] || [];
};
const $9890e3ccad2bbf07$export$77d77034d25f4a4c = ({ issue: issue, componentsByProjectId: componentsByProjectId })=>$9890e3ccad2bbf07$export$8d800dbad5a57be1({
        issue: issue,
        componentsByProjectId: componentsByProjectId
    }).filter((component)=>(issue.components || []).includes(component.id));
const $9890e3ccad2bbf07$export$cdb8a2fe02a819d9 = ({ attribute: attribute, issue: issue, isDisabled: isDisabled, isReadOnly: isReadOnly, componentsByProjectId: componentsByProjectId, onChange: onChange })=>{
    const intl = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getIssueComponents = ()=>$9890e3ccad2bbf07$export$8d800dbad5a57be1({
            issue: issue,
            componentsByProjectId: componentsByProjectId
        }).filter((component)=>(issue.components || []).includes(component.id));
    const fetchOptions = (query)=>Promise.resolve($9890e3ccad2bbf07$export$8d800dbad5a57be1({
            issue: issue,
            componentsByProjectId: componentsByProjectId
        }).map($9890e3ccad2bbf07$var$getComponentOption).filter((option)=>option.label.toLowerCase().includes(query.toLowerCase())));
    const handleComponentsChange = (issue, options)=>{
        if (!options) return;
        onChange(issue, options.map((item)=>Number(item.value)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eaAI.default), {
        attribute: attribute,
        messages: {
            placeholder: intl.formatMessage((0, $8LmKR.default).componentsLabel),
            noLabels: intl.formatMessage((0, $8LmKR.default).noComponents),
            noLabelsLeft: intl.formatMessage((0, $8LmKR.default).noComponentsLeft),
            noMatch: intl.formatMessage((0, $8LmKR.default).noMatch)
        },
        getValues: ()=>getIssueComponents().map($9890e3ccad2bbf07$var$getComponentOption),
        fetchOptions: fetchOptions,
        isReadOnly: isReadOnly,
        isDisabled: isDisabled,
        issue: issue,
        onChange: handleComponentsChange
    });
};
var $9890e3ccad2bbf07$export$2e2bcd8739ae039 = $9890e3ccad2bbf07$export$cdb8a2fe02a819d9;

});
parcelRegister("8LmKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f9e748b77c8cf0b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4f9e748b77c8cf0b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentsLabel: {
        "id": "portfolio-3-portfolio.common.cells.components.components-label",
        "defaultMessage": "Choose a component"
    },
    noComponents: {
        "id": "portfolio-3-portfolio.common.cells.components.no-components",
        "defaultMessage": "There are no components in this project"
    },
    noComponentsLeft: {
        "id": "portfolio-3-portfolio.common.cells.components.no-components-left",
        "defaultMessage": "No available components left"
    },
    noMatch: {
        "id": "portfolio-3-portfolio.common.cells.components.no-match",
        "defaultMessage": "No results match your search"
    }
});

});




parcelRegister("gRh9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4dc2a845233a33$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createDateCell", () => $6d4dc2a845233a33$export$33f3410f8828e1b1);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $6090A = parcelRequire("6090A");

var $ges37 = parcelRequire("ges37");

var $gnATW = parcelRequire("gnATW");
var $6d4dc2a845233a33$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ges37.default), (0, $6090A.default))((0, $gnATW.default));
const $6d4dc2a845233a33$export$33f3410f8828e1b1 = (DateCellComponent, type)=>// eslint-disable-next-line jira/react/no-class-components
    class extends (0, $eUqFw.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateCellComponent, {
                ...this.props,
                type: type
            });
        }
    };

});
parcelRegister("6090A", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9fc942ec669558f$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $b9fc942ec669558f$var$dispatchMethods = (dispatch)=>({
        onChange: ({ issue: issue, field: field, date: date })=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                [field]: date
            }));
        }
    });
var $b9fc942ec669558f$export$2e2bcd8739ae039 = $b9fc942ec669558f$var$dispatchMethods;

});

parcelRegister("ges37", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce676402472a0900$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
const $ce676402472a0900$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    dateConfiguration: (0, $75KhQ.getDateConfiguration),
    isExportMode: $akhOi.isExportMode
});
var $ce676402472a0900$export$2e2bcd8739ae039 = $ce676402472a0900$var$querySelector;

});

parcelRegister("gnATW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8506cba63dbd3a3d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $jPCDz = parcelRequire("jPCDz");
var $eCA8M = parcelRequire("eCA8M");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eBkd9 = parcelRequire("eBkd9");
var $eTbtL = parcelRequire("eTbtL");
var $kQ0RL = parcelRequire("kQ0RL");
var $l2Sj2 = parcelRequire("l2Sj2");
var $fmBR7 = parcelRequire("fmBR7");
var $ffiyv = parcelRequire("ffiyv");
var $7Mdad = parcelRequire("7Mdad");
var $gwbfD = parcelRequire("gwbfD");

var $3evMM = parcelRequire("3evMM");

var $8CXDT = parcelRequire("8CXDT");

var $57dZR = parcelRequire("57dZR");

var $eOsHk = parcelRequire("eOsHk");

var $a4vO3 = parcelRequire("a4vO3");
parcelRequire("2Bjja");
var $b1b5T = parcelRequire("b1b5T");

var $7CnHa = parcelRequire("7CnHa");

var $4xHig = parcelRequire("4xHig");

var $RMUGD = parcelRequire("RMUGD");

var $dJmyv = parcelRequire("dJmyv");

var $ekyJn = parcelRequire("ekyJn");

var $kNJ9D = parcelRequire("kNJ9D");
const $8506cba63dbd3a3d$var$DateCell = ({ dateConfiguration: dateConfiguration, attribute: attributeProp, type: type, issue: { summary: summary }, isReadOnly: isReadOnly, isScrolling: isScrolling, issue: issue, showOptimizations: showOptimizations = false, onChange: onChange, DatePicker: DatePicker, isExportMode: isExportMode })=>{
    const intl = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const { formatDate: formatDateIntl, formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const [isActive, setIsActive] = (0, $eUqFw.useState)(false);
    const [flags, setFlags] = (0, $eUqFw.useState)([]);
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const [isValid, setIsValid] = (0, $eUqFw.useState)(true);
    const mapDateToFormattedValue = (_, value)=>{
        if (!value) return '';
        return (0, $l2Sj2.formatDateUTC)(value, (0, $eTbtL.DefaultDateFormat));
    };
    const attribute = (0, $kNJ9D.issueField)[type] ?? attributeProp;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const date = issue[attribute];
    const label = (0, $kNJ9D.labels)[type];
    let value = showOptimizations ? (0, $57dZR.getOptimizedValue)(issue, attribute) : date;
    if ((0, $7CnHa.isDefined)(value)) // for browser comparability(e.g Safari) we have to pass value to datepicker only ISO date format
    value = (0, $l2Sj2.formatDateUTC)(value, (0, $eTbtL.IsoDateFormat));
    else value = '';
    /*
   * Ex-class methods
   */ const isCellDirty = ()=>{
        const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
        const startDatePath = baselineStartField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM ? [
            'customFields',
            baselineStartField.key
        ] : [
            baselineStartField.key
        ];
        const endDatePath = baselineEndField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM ? [
            'customFields',
            baselineEndField.key
        ] : [
            baselineEndField.key
        ];
        if (type === (0, $ekyJn.DateTypes).Start) return !!issue.originals && $eCA8M.default(startDatePath, issue.originals);
        if (type === (0, $ekyJn.DateTypes).End) return !!issue.originals && $eCA8M.default(endDatePath, issue.originals);
        if (type === (0, $ekyJn.DateTypes).Other) return !!issue.originals && $jPCDz.default(attribute, issue.originals);
        return false;
    };
    const handleChange = (changedDate)=>{
        (0, $kNJ9D.handleChange)(changedDate, {
            onChange: onChange,
            issue: issue,
            type: type,
            attribute: attribute,
            flags: flags,
            setFlags: setFlags,
            intl: intl,
            setIsValid: setIsValid
        });
    };
    const getAlignedDate = (isDatePickerActive, dateType, baseLineStart, baseLineEnd, rawDate)=>{
        // if the calendar Date Picker is triggered
        if (isDatePickerActive) {
            // if the calendar is End type and Start Date is set but Due Date is not defined
            // then we set start date as initial end date
            // else if the calendar is Start type and Due Date is set but Start Date is not defined,
            // we set due date as initial start date
            if (dateType === (0, $ekyJn.DateTypes).End && (0, $7CnHa.isDefined)(baseLineStart) && !(0, $7CnHa.isDefined)(baseLineEnd)) return (0, $l2Sj2.formatDateUTC)(baseLineStart, (0, $eTbtL.IsoDateFormat));
            if (dateType === (0, $ekyJn.DateTypes).Start && (0, $7CnHa.isDefined)(baseLineEnd) && !(0, $7CnHa.isDefined)(baseLineStart)) return (0, $l2Sj2.formatDateUTC)(baseLineEnd, (0, $eTbtL.IsoDateFormat));
        }
        return rawDate;
    };
    const renderDatePicker = ({ intl: // eslint-disable-next-line @typescript-eslint/no-shadow
    intl, isReadOnly: // eslint-disable-next-line @typescript-eslint/no-shadow
    isReadOnly, label: // eslint-disable-next-line @typescript-eslint/no-shadow
    label, summary: // eslint-disable-next-line @typescript-eslint/no-shadow
    summary, value: // eslint-disable-next-line @typescript-eslint/no-shadow
    value, type: // eslint-disable-next-line @typescript-eslint/no-shadow
    type })=>{
        const adjustedDate = getAlignedDate(isActive, type, issue.baselineStart, issue.baselineEnd, value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "aria-label": intl.formatMessage(label, {
                issue: summary
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
                [$dJmyv['cell-valid']]: isValid,
                [$dJmyv['cell-invalid']]: !isValid,
                [$dJmyv.isReadOnly]: isReadOnly
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Mdad.default), {
            enabled: isActive
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: setIsHovered
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DatePicker, {
            autoFocus: isActive && (type === (0, $ekyJn.DateTypes).Start || type === (0, $ekyJn.DateTypes).End),
            isDisabled: isReadOnly,
            isTransparentBackground: true,
            onChange: handleChange,
            onToggle: setIsActive,
            placeholder: intl.formatMessage((0, $RMUGD.default).placeholder),
            showClearIndicator: true,
            styles: {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                placeholder: (styles)=>({
                        display: !isHovered && 'none',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        width: 'calc(100% - 9px)',
                        ...styles
                    })
            },
            value: adjustedDate
        })));
    };
    // Used to format rollup dates
    const formattedDate = (()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let date = 0;
        if (type === (0, $ekyJn.DateTypes).Start) {
            if (!(0, $7CnHa.isDefined)(issue.baselineStart)) return '';
            date = issue.baselineStart;
        } else if (type === (0, $ekyJn.DateTypes).End) {
            if (!(0, $7CnHa.isDefined)(issue.baselineEnd)) return '';
            date = issue.baselineEnd;
        }
        return formatTimestamp(date);
    })();
    const renderInferredDate = (tooltip, icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onClick: ()=>setIsActive(true),
            onKeyDown: ()=>setIsActive(true),
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dJmyv.projectedDate
        }, isExportMode ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dJmyv.exportPNGLozenge
        }, icon) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dJmyv.rollUpIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: tooltip
        }, icon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dJmyv.projectedDateText
        }, formattedDate)));
    const getContent = ({ intl: // eslint-disable-next-line @typescript-eslint/no-shadow
    intl, isReadOnly: // eslint-disable-next-line @typescript-eslint/no-shadow
    isReadOnly, label: // eslint-disable-next-line @typescript-eslint/no-shadow
    label, showOptimizations: // eslint-disable-next-line @typescript-eslint/no-shadow
    showOptimizations, summary: // eslint-disable-next-line @typescript-eslint/no-shadow
    summary, value: // eslint-disable-next-line @typescript-eslint/no-shadow
    value, type: // eslint-disable-next-line @typescript-eslint/no-shadow
    type })=>{
        const methodOfDateInferrence = (0, $kNJ9D.getTheMethodOfDateInferrence)(issue, type);
        const tooltipForInferredDateUsingSprint = intl.formatMessage((0, $RMUGD.default).projectedDatesUsingSprintTooltip);
        const iconForInferredDateUsingSprint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "S");
        const tooltipForInferredDateUsingRelease = intl.formatMessage((0, $RMUGD.default).projectedDatesUsingReleasesTooltip);
        const iconForInferredDateUsingRelease = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "R");
        const tooltipForInferredDateUsingRollUp = intl.formatMessage((0, $3evMM.default).rolledUpEstimateToolip, {
            value: formattedDate || intl.formatMessage((0, $RMUGD.default).noDate)
        });
        const iconForInferredDateUsingRollUp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1b5T.default), {
            label: ""
        });
        if (!showOptimizations && (!isActive || isReadOnly)) {
            if (methodOfDateInferrence === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT) return renderInferredDate(tooltipForInferredDateUsingSprint, iconForInferredDateUsingSprint);
            if (methodOfDateInferrence === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE) return renderInferredDate(tooltipForInferredDateUsingRelease, iconForInferredDateUsingRelease);
            if (methodOfDateInferrence === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP) return renderInferredDate(tooltipForInferredDateUsingRollUp, iconForInferredDateUsingRollUp);
        }
        return renderDatePicker({
            intl: intl,
            isReadOnly: isReadOnly,
            label: label,
            summary: summary,
            value: value,
            type: type
        });
    };
    const getWireFrame = ({ intl: // eslint-disable-next-line @typescript-eslint/no-shadow
    intl, isReadOnly: // eslint-disable-next-line @typescript-eslint/no-shadow
    isReadOnly, label: // eslint-disable-next-line @typescript-eslint/no-shadow
    label, showOptimizations: // eslint-disable-next-line @typescript-eslint/no-shadow
    showOptimizations, summary: // eslint-disable-next-line @typescript-eslint/no-shadow
    summary, value: // eslint-disable-next-line @typescript-eslint/no-shadow
    value })=>{
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($dJmyv.wireframe, $dJmyv[isValid ? 'cell-valid' : 'cell-invalid'], $dJmyv[showOptimizations ? 'readOnly' : '']);
        function getFormattedValue() {
            return formatDateIntl(value);
        }
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "aria-label": intl.formatMessage(label, {
                issue: summary
            }),
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: value ? '' : $dJmyv.placeholder,
            value: value ? getFormattedValue() : '',
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onChange: ()=>{},
            readOnly: isReadOnly,
            disabled: isReadOnly
        })));
    };
    const dismissFlag = ()=>{
        setFlags(flags.slice(1));
    };
    const warningFlags = ()=>flags.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
            onDismissed: dismissFlag
        }, flags.map(({ created: created, ...flag }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBkd9.default), {
                ...flag,
                key: index
            }))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        attribute: attribute,
        isCellDirty: isCellDirty,
        issue: issue,
        valueMapper: mapDateToFormattedValue,
        delta: (0, $kNJ9D.getDateDiff),
        isScrolling: isScrolling,
        showOptimizations: showOptimizations,
        locale: locale
    }, !isScrolling ? getContent({
        intl: intl,
        isReadOnly: isReadOnly,
        label: label,
        showOptimizations: showOptimizations,
        summary: summary,
        value: value,
        type: type
    }) : getWireFrame({
        intl: intl,
        isReadOnly: isReadOnly,
        label: label,
        showOptimizations: showOptimizations,
        summary: summary,
        value: value
    }), warningFlags());
};
var $8506cba63dbd3a3d$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    DatePicker: (0, $a4vO3.slots).FieldDatePicker
})($8506cba63dbd3a3d$var$DateCell);

});
parcelRegister("eBkd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2abc675c3cd85b60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $2abc675c3cd85b60$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        isAutoDismiss: true,
        ...props,
        flagType: "info"
    }));
var $2abc675c3cd85b60$export$2e2bcd8739ae039 = $2abc675c3cd85b60$var$AkAutoDismissFlag;

});

parcelRegister("3evMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d69f2cf04cb57d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5d69f2cf04cb57d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    rolledUpEstimateToolip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.rolled-up-estimate-toolip",
        "defaultMessage": "Rolled-up value: {value}"
    }
});

});

parcelRegister("RMUGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $52da65c38617eef3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $52da65c38617eef3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.placeholder",
        "defaultMessage": "Choose a date"
    },
    startDateLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.start-date-label",
        "defaultMessage": "Choose target start date for issue {issue}"
    },
    endDateLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.end-date-label",
        "defaultMessage": "Choose target end date for issue {issue}"
    },
    dateLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.date-label",
        "defaultMessage": "Choose date field for issue {issue}"
    },
    projectedDatesUsingSprintTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.projected-dates-using-sprint-tooltip",
        "defaultMessage": "This issue has no dates, so it's using the dates of its assigned sprint."
    },
    projectedDatesUsingReleasesTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.projected-dates-using-releases-tooltip",
        "defaultMessage": "This issue has no dates, so it's using the dates of its assigned releases."
    },
    noDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.date.no-date",
        "defaultMessage": "No date"
    }
});

});

parcelRegister("dJmyv", function(module, exports) {

$parcel$export(module.exports, "cell-invalid", () => $9ff0f9678be1360b$export$387981ce241ed7d9, (v) => $9ff0f9678be1360b$export$387981ce241ed7d9 = v);
$parcel$export(module.exports, "cell-valid", () => $9ff0f9678be1360b$export$5d11244acbce5c4a, (v) => $9ff0f9678be1360b$export$5d11244acbce5c4a = v);
$parcel$export(module.exports, "exportPNGLozenge", () => $9ff0f9678be1360b$export$1ec0dee322814bb4, (v) => $9ff0f9678be1360b$export$1ec0dee322814bb4 = v);
$parcel$export(module.exports, "isReadOnly", () => $9ff0f9678be1360b$export$2498094d90b6ac72, (v) => $9ff0f9678be1360b$export$2498094d90b6ac72 = v);
$parcel$export(module.exports, "placeholder", () => $9ff0f9678be1360b$export$c7187bbd1a7a9244, (v) => $9ff0f9678be1360b$export$c7187bbd1a7a9244 = v);
$parcel$export(module.exports, "projectedDate", () => $9ff0f9678be1360b$export$4b0386405699aa0a, (v) => $9ff0f9678be1360b$export$4b0386405699aa0a = v);
$parcel$export(module.exports, "projectedDateText", () => $9ff0f9678be1360b$export$664bf476323cd04d, (v) => $9ff0f9678be1360b$export$664bf476323cd04d = v);
$parcel$export(module.exports, "readOnly", () => $9ff0f9678be1360b$export$b2cbc93d4da94977, (v) => $9ff0f9678be1360b$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "rollUpIcon", () => $9ff0f9678be1360b$export$894901fa58357dbf, (v) => $9ff0f9678be1360b$export$894901fa58357dbf = v);
$parcel$export(module.exports, "wireframe", () => $9ff0f9678be1360b$export$a8fec3cf51c7da20, (v) => $9ff0f9678be1360b$export$a8fec3cf51c7da20 = v);
var $9ff0f9678be1360b$export$387981ce241ed7d9;
var $9ff0f9678be1360b$export$5d11244acbce5c4a;
var $9ff0f9678be1360b$export$1ec0dee322814bb4;
var $9ff0f9678be1360b$export$2498094d90b6ac72;
var $9ff0f9678be1360b$export$c7187bbd1a7a9244;
var $9ff0f9678be1360b$export$4b0386405699aa0a;
var $9ff0f9678be1360b$export$664bf476323cd04d;
var $9ff0f9678be1360b$export$b2cbc93d4da94977;
var $9ff0f9678be1360b$export$894901fa58357dbf;
var $9ff0f9678be1360b$export$a8fec3cf51c7da20;
$9ff0f9678be1360b$export$387981ce241ed7d9 = `Tw2-xG_cell-invalid`;
$9ff0f9678be1360b$export$5d11244acbce5c4a = `Tw2-xG_cell-valid`;
$9ff0f9678be1360b$export$1ec0dee322814bb4 = `Tw2-xG_exportPNGLozenge`;
$9ff0f9678be1360b$export$2498094d90b6ac72 = `Tw2-xG_isReadOnly`;
$9ff0f9678be1360b$export$c7187bbd1a7a9244 = `Tw2-xG_placeholder`;
$9ff0f9678be1360b$export$4b0386405699aa0a = `Tw2-xG_projectedDate`;
$9ff0f9678be1360b$export$664bf476323cd04d = `Tw2-xG_projectedDateText`;
$9ff0f9678be1360b$export$b2cbc93d4da94977 = `Tw2-xG_readOnly`;
$9ff0f9678be1360b$export$894901fa58357dbf = `Tw2-xG_rollUpIcon`;
$9ff0f9678be1360b$export$a8fec3cf51c7da20 = `Tw2-xG_wireframe`;

});

parcelRegister("ekyJn", function(module, exports) {

$parcel$export(module.exports, "DateTypes", () => $e904b16f0ab0ab7c$export$7690b1846650bc08);
const $e904b16f0ab0ab7c$export$7690b1846650bc08 = {
    Start: 'START',
    End: 'END',
    Other: 'OTHER'
};

});

parcelRegister("kNJ9D", function(module, exports) {

$parcel$export(module.exports, "issueField", () => $b6b9f028d3652f91$export$453c7585f6587ecc);
$parcel$export(module.exports, "labels", () => $b6b9f028d3652f91$export$a238cb463698c900);
$parcel$export(module.exports, "getDateDiff", () => $b6b9f028d3652f91$export$9cd30990ce195ccd);
$parcel$export(module.exports, "getTheMethodOfDateInferrence", () => $b6b9f028d3652f91$export$e6f648b65089ac1e);
$parcel$export(module.exports, "handleChange", () => $b6b9f028d3652f91$export$1ba2cb844e41b315);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");

var $5YsMl = parcelRequire("5YsMl");

var $g4Vkx = parcelRequire("g4Vkx");
var $17L5s = parcelRequire("17L5s");
var $gctne = parcelRequire("gctne");
var $l2Sj2 = parcelRequire("l2Sj2");
var $7ueqz = parcelRequire("7ueqz");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $RMUGD = parcelRequire("RMUGD");

var $ekyJn = parcelRequire("ekyJn");
const $b6b9f028d3652f91$export$453c7585f6587ecc = {
    [(0, $ekyJn.DateTypes).Start]: 'baselineStart',
    [(0, $ekyJn.DateTypes).End]: 'baselineEnd',
    [(0, $ekyJn.DateTypes).Other]: undefined
};
const $b6b9f028d3652f91$export$a238cb463698c900 = {
    [(0, $ekyJn.DateTypes).Start]: (0, $RMUGD.default).startDateLabel,
    [(0, $ekyJn.DateTypes).End]: (0, $RMUGD.default).endDateLabel,
    [(0, $ekyJn.DateTypes).Other]: (0, $RMUGD.default).dateLabel
};
const $b6b9f028d3652f91$export$9cd30990ce195ccd = (stringDate1, stringDate2, locale)=>{
    if (stringDate1 == null || stringDate2 == null) return '';
    const date1 = new Date(stringDate1);
    const date2 = new Date(stringDate2);
    if (!(0, $7ueqz.default)(date1) || !(0, $7ueqz.default)(date2) || (0, $gctne.default)(date1, date2)) return '';
    return `(${(0, $17L5s.distanceInWordsWithPolarity)(date1.getTime(), date2.getTime(), locale)})`;
};
const $b6b9f028d3652f91$export$64a5b7a68f1d5081 = (issue, type, date)=>{
    const targetStart = issue[$b6b9f028d3652f91$export$453c7585f6587ecc[(0, $ekyJn.DateTypes).Start]];
    const targetEnd = issue[$b6b9f028d3652f91$export$453c7585f6587ecc[(0, $ekyJn.DateTypes).End]];
    if (Number.isNaN(date)) return false;
    if (type === (0, $ekyJn.DateTypes).Start && targetEnd != null && date > targetEnd) return false;
    if (type === (0, $ekyJn.DateTypes).End && targetStart != null && targetStart > date) return false;
    return true;
};
const $b6b9f028d3652f91$export$92521769c5df59ad = (issue, type)=>{
    let date = 0;
    if (type === (0, $ekyJn.DateTypes).Start) {
        if (!(0, $7CnHa.isDefined)(issue.baselineStart)) return '';
        date = issue.baselineStart;
    } else if (type === (0, $ekyJn.DateTypes).End) {
        if (!(0, $7CnHa.isDefined)(issue.baselineEnd)) return '';
        date = issue.baselineEnd;
    }
    return (0, $l2Sj2.formatDateUTC)(date, (0, $5rYNM.DefaultDateFormat));
};
const $b6b9f028d3652f91$export$e6f648b65089ac1e = (issue, type)=>{
    if (type !== (0, $ekyJn.DateTypes).Other) {
        const attribute = $b6b9f028d3652f91$export$453c7585f6587ecc[type] || '';
        const inferredFrom = $kjklK.default([
            'inferred',
            attribute
        ], issue);
        return inferredFrom || (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE;
    }
    return (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE;
};
const $b6b9f028d3652f91$var$getFlagData = (index, intl, type)=>{
    const timeOffset = 0;
    const warningIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`,
        size: "medium"
    });
    const description = type === (0, $ekyJn.DateTypes).Start ? (0, $ib5d3.default).invalidDateStartBeforeEnd : (0, $ib5d3.default).invalidDateEndAfterStart;
    return {
        created: Date.now() - timeOffset * 1000,
        title: intl.formatMessage((0, $ib5d3.default).invalidDateTitle),
        description: intl.formatMessage(description),
        icon: warningIcon,
        id: index,
        key: index
    };
};
const $b6b9f028d3652f91$var$addFlag = (flags, setFlags, intl, type)=>{
    // Implementation as per Atlaskit example source code for Datepicker
    const nextFlags = flags.slice();
    nextFlags.unshift($b6b9f028d3652f91$var$getFlagData(flags.length + 1, intl, type));
    setFlags(nextFlags);
};
const $b6b9f028d3652f91$export$1ba2cb844e41b315 = (changedDate, { onChange: onChange, issue: issue, type: type, attribute: attribute, flags: flags, setFlags: setFlags, intl: intl, setIsValid: setIsValid })=>{
    if (changedDate === '' || !(0, $17L5s.isISOCompatible)(changedDate)) onChange({
        issue: issue,
        field: $b6b9f028d3652f91$export$453c7585f6587ecc[type] ?? attribute,
        date: undefined
    });
    else {
        // The date value we receive from the date-picker will always be an ISO value in the form 'YYYY-MM-DD',
        // but we want to convert this to the start and end of date as appropriate to store in the scenario in milliseconds...
        const date = type === (0, $ekyJn.DateTypes).Start ? (0, $17L5s.startOfUtcDay)(changedDate) : (0, $17L5s.endOfUtcDay)(changedDate);
        const validity = $b6b9f028d3652f91$export$64a5b7a68f1d5081(issue, type, date);
        setIsValid(validity);
        if (!validity) $b6b9f028d3652f91$var$addFlag(flags, setFlags, intl, type);
        else onChange({
            issue: issue,
            field: $b6b9f028d3652f91$export$453c7585f6587ecc[type] ?? attribute,
            date: date
        });
    }
};

});



parcelRegister("lFvbU", function(module, exports) {

$parcel$export(module.exports, "IncomingDependenciesCell", () => $8b168b768d51a71a$export$a3b08300c887bd44);
$parcel$export(module.exports, "OutgoingDependenciesCell", () => $8b168b768d51a71a$export$14dbbf44c8220856);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $1WxRB = parcelRequire("1WxRB");

var $6ai6B = parcelRequire("6ai6B");

var $6PWGn = parcelRequire("6PWGn");

var $kJgLh = parcelRequire("kJgLh");

var $6c33V = parcelRequire("6c33V");

var $4BgLS = parcelRequire("4BgLS");
class $8b168b768d51a71a$export$2e2bcd8739ae039 extends (0, $kJgLh.default) {
    render() {
        const { issue: issue, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, internalOriginalIssueLinks: internalOriginalIssueLinks } = this.props;
        const { direction: direction, ...dependenciesProps } = this.props;
        const isDialogLocked = Object.values(this.state.dialogLockingInstances).some((value)=>!!value);
        const renderDialogContent = (update)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ai6B.DependenciesDialogContext).Provider, {
                value: {
                    isDialogLocked: isDialogLocked,
                    toggleDialogLocked: this.toggleDialogLocked
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PWGn.default), {
                direction: direction,
                issue: issue,
                externalIssueLinks: externalIssueLinks,
                internalIssueLinks: internalIssueLinks,
                internalOriginalIssueLinks: internalOriginalIssueLinks,
                context: "dropdown",
                updatePopup: update
            }));
        const dialogContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ai6B.DependenciesDialogContext).Provider, {
            value: {
                isDialogLocked: isDialogLocked,
                toggleDialogLocked: this.toggleDialogLocked
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PWGn.default), {
            direction: direction,
            issue: issue,
            externalIssueLinks: externalIssueLinks,
            internalIssueLinks: internalIssueLinks,
            internalOriginalIssueLinks: internalOriginalIssueLinks,
            context: "dropdown"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WxRB.default), {
            ...dependenciesProps,
            ...(0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? {
                renderDialogContent: renderDialogContent
            } : {
                dialogContent: dialogContentOld
            },
            isDialogLocked: isDialogLocked
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            dialogLockingInstances: {}
        };
        this.toggleDialogLocked = (instanceName)=>(isLocked)=>{
                this.setState(({ dialogLockingInstances: dialogLockingInstances })=>({
                        dialogLockingInstances: {
                            ...dialogLockingInstances,
                            [instanceName]: isLocked
                        }
                    }));
            };
    }
}
const $8b168b768d51a71a$export$a3b08300c887bd44 = (0, $6c33V.default)($8b168b768d51a71a$export$2e2bcd8739ae039);
const $8b168b768d51a71a$export$14dbbf44c8220856 = (0, $4BgLS.default)($8b168b768d51a71a$export$2e2bcd8739ae039);

});
parcelRegister("1WxRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd71fa9439497aa$export$2e2bcd8739ae039);

var $kOuUE = parcelRequire("kOuUE");
var $cbd71fa9439497aa$export$2e2bcd8739ae039 = (0, $kOuUE.default);

});
parcelRegister("kOuUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f39c442ac1432ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");
var $fmBR7 = parcelRequire("fmBR7");
var $7Mdad = parcelRequire("7Mdad");

var $4UWBa = parcelRequire("4UWBa");

var $dhQQN = parcelRequire("dhQQN");
const $f39c442ac1432ab3$var$DependenciesCell = (props)=>{
    const { dialogContent: dialogContent, renderDialogContent: renderDialogContent, isChanged: isChanged, isOptimizedMode: isOptimizedMode, messages: messages, isDialogLocked: isDialogLocked, externalIssueLinks: externalIssueLinks, internalIssueLinks: internalIssueLinks, isReadOnly: isReadOnly } = props;
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const onHoverChanged = (0, $eUqFw.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
    }, []);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        if (isDialogLocked) return;
        setIsOpen(false);
    }, [
        isDialogLocked
    ]);
    const getIssueLinksCount = (0, $eUqFw.useCallback)(()=>externalIssueLinks.length + internalIssueLinks.length, [
        externalIssueLinks.length,
        internalIssueLinks.length
    ]);
    const renderIssueCount = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $dhQQN.issuesCount,
            onClick: onToggle,
            tabIndex: 0,
            role: "button",
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onKeyDown: ()=>{},
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dhQQN.issuesLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...messages.issues,
            values: {
                count: getIssueLinksCount()
            }
        })), (isHovered || isOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "",
            size: "large"
        })), [
        getIssueLinksCount,
        isHovered,
        isOpen,
        messages.issues,
        onToggle
    ]);
    const renderAddDependency = (0, $eUqFw.useCallback)((triggerProps)=>!isReadOnly && (isHovered || isOpen) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "link",
            onClick: onToggle,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), messages.addDependency)) : null, [
        isHovered,
        isOpen,
        isReadOnly,
        messages.addDependency,
        onToggle
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)(({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: onHoverChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref,
            className: $dhQQN.container
        }, getIssueLinksCount() > 0 ? renderIssueCount(triggerProps) : renderAddDependency(triggerProps), isChanged && !isOptimizedMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), null) : null)), [
        getIssueLinksCount,
        isChanged,
        isOptimizedMode,
        onHoverChanged,
        renderAddDependency,
        renderIssueCount
    ]);
    const renderContent = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $f39c442ac1432ab3$var$dialogStyles
        }, renderDialogContent && renderDialogContent(update), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Mdad.default), null)), [
        renderDialogContent
    ]);
    const renderContentOld = (0, $eUqFw.useCallback)(()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dhQQN.dialog
        }, dialogContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Mdad.default), null)), [
        dialogContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: (0, $1ybV0.ff)('list-view-add-dependency-styling-fix_9ibdi') ? renderContent : renderContentOld,
        placement: "bottom-start",
        shouldUseCaptureOnOutsideClick: true
    });
};
const $f39c442ac1432ab3$var$dialogStyles = (0, $1ZAYh.xcss)({
    maxWidth: '800px',
    maxHeight: '400px',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    boxSizing: 'border-box'
});
var $f39c442ac1432ab3$export$2e2bcd8739ae039 = $f39c442ac1432ab3$var$DependenciesCell;

});
parcelRegister("dhQQN", function(module, exports) {

$parcel$export(module.exports, "container", () => $9ac5dbe6faef4bef$export$34e0f9847d4c02dd, (v) => $9ac5dbe6faef4bef$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "dialog", () => $9ac5dbe6faef4bef$export$518824cf31321346, (v) => $9ac5dbe6faef4bef$export$518824cf31321346 = v);
$parcel$export(module.exports, "issuesCount", () => $9ac5dbe6faef4bef$export$9e11ad065927463a, (v) => $9ac5dbe6faef4bef$export$9e11ad065927463a = v);
$parcel$export(module.exports, "issuesLabel", () => $9ac5dbe6faef4bef$export$491cc3e43ef9a10c, (v) => $9ac5dbe6faef4bef$export$491cc3e43ef9a10c = v);
var $9ac5dbe6faef4bef$export$34e0f9847d4c02dd;
var $9ac5dbe6faef4bef$export$518824cf31321346;
var $9ac5dbe6faef4bef$export$9e11ad065927463a;
var $9ac5dbe6faef4bef$export$491cc3e43ef9a10c;
$9ac5dbe6faef4bef$export$34e0f9847d4c02dd = `_5Hr3oa_container`;
$9ac5dbe6faef4bef$export$518824cf31321346 = `_5Hr3oa_dialog`;
$9ac5dbe6faef4bef$export$9e11ad065927463a = `_5Hr3oa_issuesCount`;
$9ac5dbe6faef4bef$export$491cc3e43ef9a10c = `_5Hr3oa_issuesLabel`;

});



parcelRegister("kJgLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa8ce2d76cffac38$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iK4oF = parcelRequire("iK4oF");
const $aa8ce2d76cffac38$var$EQUALS_DEPTH_LIMIT = 256;
class $aa8ce2d76cffac38$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps, nextState) {
        return !(0, $iK4oF.equals)(this.props, nextProps, $aa8ce2d76cffac38$var$EQUALS_DEPTH_LIMIT) || !(0, $iK4oF.equals)(this.state, nextState, $aa8ce2d76cffac38$var$EQUALS_DEPTH_LIMIT);
    }
}

});

parcelRegister("6c33V", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d409c465e059e6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bH1Fn = parcelRequire("bH1Fn");
function $94d409c465e059e6$export$2e2bcd8739ae039(WrappedComponent) {
    return (0, $lNNXV.connect)((0, $bH1Fn.default), {})(WrappedComponent);
}

});
parcelRegister("bH1Fn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a940b9b857402f8d$export$2e2bcd8739ae039);

var $9EioJ = parcelRequire("9EioJ");

var $akhOi = parcelRequire("akhOi");

var $fbHoQ = parcelRequire("fbHoQ");

var $dEoWh = parcelRequire("dEoWh");

var $5rYNM = parcelRequire("5rYNM");

var $1TrR5 = parcelRequire("1TrR5");

var $huqk4 = parcelRequire("huqk4");
const $a940b9b857402f8d$var$mapStateToPropsOld = (state, { issue: issue })=>{
    const issueId = issue?.id || '';
    const externalIssueLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || [];
    const internalIssueLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || [];
    const internalOriginalIssueLinks = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || [];
    const issueLinks = (0, $dEoWh.getIncomingLinks)(state)[issueId] || [];
    const originalIssueLinks = (0, $dEoWh.getIncomingLinkOriginals)(state)[issueId] || [];
    const isChanged = $9EioJ.default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
    const mode = (0, $akhOi.getMode)(state);
    return {
        externalIssueLinks: externalIssueLinks,
        isChanged: isChanged,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isOptimizedMode: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        internalIssueLinks: internalIssueLinks,
        internalOriginalIssueLinks: internalOriginalIssueLinks,
        filterValue: (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value,
        messages: $huqk4.default,
        direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD
    };
};
const $a940b9b857402f8d$var$externalIssueLinksList = [];
const $a940b9b857402f8d$var$internalIssueLinksList = [];
const $a940b9b857402f8d$var$internalOriginalIssueLinksList = [];
const $a940b9b857402f8d$var$issueLinksList = [];
const $a940b9b857402f8d$var$originalIssueLinksList = [];
const $a940b9b857402f8d$var$mapStateToPropsNew = (state, { issue: issue })=>{
    const issueId = issue?.id || '';
    const externalIssueLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || $a940b9b857402f8d$var$externalIssueLinksList;
    const internalIssueLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || $a940b9b857402f8d$var$internalIssueLinksList;
    const internalOriginalIssueLinks = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || $a940b9b857402f8d$var$internalOriginalIssueLinksList;
    const issueLinks = (0, $dEoWh.getIncomingLinks)(state)[issueId] || $a940b9b857402f8d$var$issueLinksList;
    const originalIssueLinks = (0, $dEoWh.getIncomingLinkOriginals)(state)[issueId] || $a940b9b857402f8d$var$originalIssueLinksList;
    const isChanged = $9EioJ.default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
    const mode = (0, $akhOi.getMode)(state);
    return {
        externalIssueLinks: externalIssueLinks,
        isChanged: isChanged,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isOptimizedMode: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        internalIssueLinks: internalIssueLinks,
        internalOriginalIssueLinks: internalOriginalIssueLinks,
        filterValue: (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value,
        messages: $huqk4.default,
        direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD
    };
};
const $a940b9b857402f8d$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($a940b9b857402f8d$var$mapStateToPropsNew, $a940b9b857402f8d$var$mapStateToPropsOld);
var $a940b9b857402f8d$export$2e2bcd8739ae039 = $a940b9b857402f8d$var$mapStateToProps;

});
parcelRegister("9EioJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $70661eec1b1913af$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $e1ur4 = parcelRequire("e1ur4");

var $9FeHi = parcelRequire("9FeHi");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $70661eec1b1913af$var$symmetricDifference = /*#__PURE__*/ (0, $ggdJA.default)(function symmetricDifference(list1, list2) {
    return (0, $e1ur4.default)((0, $9FeHi.default)(list1, list2), (0, $9FeHi.default)(list2, list1));
});
var $70661eec1b1913af$export$2e2bcd8739ae039 = $70661eec1b1913af$var$symmetricDifference;

});

parcelRegister("huqk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1674ecbeb7c1d9cc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1674ecbeb7c1d9cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.incoming-dependencies.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    addDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.incoming-dependencies.add-dependency",
        "defaultMessage": "+ Add dependency"
    }
});

});



parcelRegister("4BgLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c669fb5bf64f00a9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $k8XiW = parcelRequire("k8XiW");
function $c669fb5bf64f00a9$export$2e2bcd8739ae039(WrappedComponent) {
    return (0, $lNNXV.connect)((0, $k8XiW.default), {})(WrappedComponent);
}

});
parcelRegister("k8XiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab02584c57c5b43$export$2e2bcd8739ae039);

var $9EioJ = parcelRequire("9EioJ");

var $akhOi = parcelRequire("akhOi");

var $fbHoQ = parcelRequire("fbHoQ");

var $dEoWh = parcelRequire("dEoWh");

var $5rYNM = parcelRequire("5rYNM");

var $1TrR5 = parcelRequire("1TrR5");

var $58uCf = parcelRequire("58uCf");
const $dab02584c57c5b43$var$mapStateToPropsOld = (state, { issue: issue })=>{
    const issueId = issue?.id || '';
    const externalIssueLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || [];
    const internalIssueLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || [];
    const internalOriginalIssueLinks = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || [];
    const issueLinks = (0, $dEoWh.getOutgoingLinks)(state)[issueId] || [];
    const originalIssueLinks = (0, $dEoWh.getOutgoingLinkOriginals)(state)[issueId] || [];
    const isChanged = $9EioJ.default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
    const mode = (0, $akhOi.getMode)(state);
    return {
        externalIssueLinks: externalIssueLinks,
        isChanged: isChanged,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isOptimizedMode: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        internalIssueLinks: internalIssueLinks,
        internalOriginalIssueLinks: internalOriginalIssueLinks,
        filterValue: (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value,
        messages: $58uCf.default,
        direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD
    };
};
const $dab02584c57c5b43$var$externalIssueLinksList = [];
const $dab02584c57c5b43$var$internalIssueLinksList = [];
const $dab02584c57c5b43$var$internalOriginalIssueLinksList = [];
const $dab02584c57c5b43$var$issueLinksList = [];
const $dab02584c57c5b43$var$originalIssueLinksList = [];
const $dab02584c57c5b43$var$mapStateToPropsNew = (state, { issue: issue })=>{
    const issueId = issue?.id || '';
    const externalIssueLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || $dab02584c57c5b43$var$externalIssueLinksList;
    const internalIssueLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || $dab02584c57c5b43$var$internalIssueLinksList;
    const internalOriginalIssueLinks = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || $dab02584c57c5b43$var$internalOriginalIssueLinksList;
    const issueLinks = (0, $dEoWh.getOutgoingLinks)(state)[issueId] || $dab02584c57c5b43$var$issueLinksList;
    const originalIssueLinks = (0, $dEoWh.getOutgoingLinkOriginals)(state)[issueId] || $dab02584c57c5b43$var$originalIssueLinksList;
    const isChanged = $9EioJ.default(issueLinks.map(({ itemKey: itemKey })=>itemKey), originalIssueLinks.map(({ itemKey: itemKey })=>itemKey)).length > 0;
    const mode = (0, $akhOi.getMode)(state);
    return {
        externalIssueLinks: externalIssueLinks,
        isChanged: isChanged,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isOptimizedMode: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        internalIssueLinks: internalIssueLinks,
        internalOriginalIssueLinks: internalOriginalIssueLinks,
        filterValue: (0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value,
        messages: $58uCf.default,
        direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD
    };
};
const $dab02584c57c5b43$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($dab02584c57c5b43$var$mapStateToPropsNew, $dab02584c57c5b43$var$mapStateToPropsOld);
var $dab02584c57c5b43$export$2e2bcd8739ae039 = $dab02584c57c5b43$var$mapStateToProps;

});
parcelRegister("58uCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca84c69ea55705e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eca84c69ea55705e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.outgoing-dependencies.issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    addDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.dependencies-cells.outgoing-dependencies.add-dependency",
        "defaultMessage": "+ Add dependency"
    }
});

});




parcelRegister("4x1VQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e95843ccfb38b5$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $h6Har = parcelRequire("h6Har");

var $8502k = parcelRequire("8502k");

var $HqJ6c = parcelRequire("HqJ6c");
var $88e95843ccfb38b5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $8502k.default), (0, $h6Har.default))((0, $HqJ6c.default));

});
parcelRegister("h6Har", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfbb5a510a7d30df$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");

var $5fUv6 = parcelRequire("5fUv6");

var $5rYNM = parcelRequire("5rYNM");
const $bfbb5a510a7d30df$var$dispatchMethods = (dispatch)=>({
        updateEstimate: (estimate, planningUnit, issueId, workingHours)=>{
            const propName = planningUnit === (0, $5rYNM.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issueId,
                [propName]: estimate && (0, $5fUv6.convertEstimate)(planningUnit, estimate, workingHours)
            }));
        }
    });
var $bfbb5a510a7d30df$export$2e2bcd8739ae039 = $bfbb5a510a7d30df$var$dispatchMethods;

});

parcelRegister("8502k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a618e506f5a5c6$export$2e2bcd8739ae039);
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");
const $d0a618e506f5a5c6$var$querySelector = (state, props)=>({
        plan: (0, $75KhQ.getPlan)(state),
        estimateRollUpForIssue: (0, $7CnHa.isDefined)((0, $aK3ri.getRollupMap)(state)[props.issue.id]) ? (0, $aK3ri.getRollupMap)(state)[props.issue.id].estimate : null,
        showEstimateRollup: (0, $9H2AP.getShowRolledUpOthers)(state),
        workingHours: (0, $dhHiZ.getJiraHoursPerDay)(state)
    });
var $d0a618e506f5a5c6$export$2e2bcd8739ae039 = $d0a618e506f5a5c6$var$querySelector;

});

parcelRegister("HqJ6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $45663ebd8fac907f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kDrtX = parcelRequire("kDrtX");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbfD = parcelRequire("gwbfD");

var $5fUv6 = parcelRequire("5fUv6");

var $3evMM = parcelRequire("3evMM");

var $8CXDT = parcelRequire("8CXDT");

var $a4vO3 = parcelRequire("a4vO3");
parcelRequire("2Bjja");
var $b1b5T = parcelRequire("b1b5T");

var $5rYNM = parcelRequire("5rYNM");

var $4HlSD = parcelRequire("4HlSD");

var $fUkUw = parcelRequire("fUkUw");
const $45663ebd8fac907f$var$round = (number)=>Math.round(number * 1000) / 1000;
const $45663ebd8fac907f$export$943451e6e6e964be = ({ updateEstimate: updateEstimate, planningUnit: planningUnit, issue: issue, workingHours: workingHours })=>(value)=>{
        let numberValue = null;
        if (typeof value === 'number') numberValue = value;
        else if (typeof value === 'string') numberValue = parseFloat(value);
        updateEstimate(Number.isNaN(numberValue) || !Number.isFinite(numberValue) ? null : numberValue, planningUnit, issue.id, workingHours);
    };
const $45663ebd8fac907f$export$4a24036355e3202b = ({ estimateRollUpForIssue: estimateRollUpForIssue, plan: { planningUnit: planningUnit }, workingHours: workingHours, issue: issue, isScrolling: isScrolling, showOptimizations: showOptimizations, isReadOnly: isReadOnly = false, updateEstimate: updateEstimate, showEstimateRollup: showEstimateRollup, TextField: TextField })=>{
    const inputElement = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [inEditMode, setInEditMode] = (0, $eUqFw.useState)(false);
    const handleClickOutside = (event)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const current = inputElement.current;
        if (current && !current.contains(event.target)) current.blur();
    };
    (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('click', handleClickOutside);
        return ()=>window.removeEventListener('click', handleClickOutside);
    }, []);
    const estimateText = (()=>{
        if (!(0, $5fUv6.isEstimated)(planningUnit, issue)) return '';
        const estimateValue = (0, $5fUv6.getEstimateValue)(planningUnit, issue, workingHours);
        return $45663ebd8fac907f$var$round(estimateValue).toString();
    })();
    const getPlanningUnit = ()=>planningUnit === (0, $5rYNM.PlanningUnits).storyPoints ? 'storyPoints' : 'timeEstimate';
    const update = $45663ebd8fac907f$export$943451e6e6e964be({
        updateEstimate: updateEstimate,
        planningUnit: planningUnit,
        issue: issue,
        workingHours: workingHours
    });
    const shouldShowRollup = ()=>{
        if (!estimateRollUpForIssue && planningUnit === (0, $5rYNM.PlanningUnits).storyPoints) return false;
        return showEstimateRollup && !inEditMode && !$kDrtX.default(estimateRollUpForIssue);
    };
    const handleClickOnRollup = ()=>{
        setInEditMode(true);
        if (inputElement.current) inputElement.current.focus();
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getCellContent = (estimateText, issueSummary)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $fUkUw.container
        }, shouldShowRollup() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $fUkUw.rollUp,
            key: "rollup",
            onClick: handleClickOnRollup,
            onKeyDown: handleClickOnRollup,
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1b5T.default), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $fUkUw.rollupValue
        }, (0, $5fUv6.getEstimateRollupValue)(estimateRollUpForIssue, planningUnit, workingHours))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$fUkUw.estimate} ${isReadOnly ? $fUkUw.readOnly : ''}`,
            ref: inputElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TextField, {
            appearance: "subtle",
            isAlignRight: true,
            isReadOnly: isReadOnly,
            isTransparentBackground: true,
            min: 0,
            onBlur: ()=>{
                setInEditMode(false);
            },
            onDone: update,
            onFocus: ()=>{
                setInEditMode(true);
            },
            step: "any",
            type: "number",
            value: estimateText,
            "aria-label": formatMessage((0, $4HlSD.default).estimateCellLabel, {
                issue: issueSummary
            })
        })));
    const attribute = getPlanningUnit();
    const issueEstimateTooltipText = estimateText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $4HlSD.default).issueEstimateTooltip), estimateText) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        attribute: attribute,
        issue: issue,
        isScrolling: isScrolling,
        showOptimizations: !!showOptimizations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: shouldShowRollup() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueEstimateTooltipText, formatMessage((0, $3evMM.default).rolledUpEstimateToolip, {
            value: (0, $5fUv6.getEstimateRollupValue)(estimateRollUpForIssue, planningUnit, workingHours)
        })) : null
    }, getCellContent(estimateText, issue.summary)));
};
var $45663ebd8fac907f$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    TextField: (0, $a4vO3.slots).CellTextField
})($45663ebd8fac907f$export$4a24036355e3202b);

});
parcelRegister("4HlSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ae8a0b829d4ef6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $75ae8a0b829d4ef6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueEstimateTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.estimate.issue-estimate-tooltip",
        "defaultMessage": "Estimate of this issue: "
    },
    estimateCellLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.estimate.estimate-cell-label",
        "defaultMessage": "Enter an estimate for issue {issue}"
    }
});

});

parcelRegister("fUkUw", function(module, exports) {

$parcel$export(module.exports, "container", () => $b94c4e6565c98f2b$export$34e0f9847d4c02dd, (v) => $b94c4e6565c98f2b$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "estimate", () => $b94c4e6565c98f2b$export$9f3a0795ca2cc944, (v) => $b94c4e6565c98f2b$export$9f3a0795ca2cc944 = v);
$parcel$export(module.exports, "readOnly", () => $b94c4e6565c98f2b$export$b2cbc93d4da94977, (v) => $b94c4e6565c98f2b$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "rollUp", () => $b94c4e6565c98f2b$export$e495e138161077ba, (v) => $b94c4e6565c98f2b$export$e495e138161077ba = v);
$parcel$export(module.exports, "rollupValue", () => $b94c4e6565c98f2b$export$409b770e9b28d1a3, (v) => $b94c4e6565c98f2b$export$409b770e9b28d1a3 = v);
var $b94c4e6565c98f2b$export$34e0f9847d4c02dd;
var $b94c4e6565c98f2b$export$9f3a0795ca2cc944;
var $b94c4e6565c98f2b$export$b2cbc93d4da94977;
var $b94c4e6565c98f2b$export$e495e138161077ba;
var $b94c4e6565c98f2b$export$409b770e9b28d1a3;
$b94c4e6565c98f2b$export$34e0f9847d4c02dd = `w3jkUG_container`;
$b94c4e6565c98f2b$export$9f3a0795ca2cc944 = `w3jkUG_estimate`;
$b94c4e6565c98f2b$export$b2cbc93d4da94977 = `w3jkUG_readOnly`;
$b94c4e6565c98f2b$export$e495e138161077ba = `w3jkUG_rollUp`;
$b94c4e6565c98f2b$export$409b770e9b28d1a3 = `w3jkUG_rollupValue`;

});



parcelRegister("SLVaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8deecb25f63ed87c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $hQmpr = parcelRequire("hQmpr");

var $ehOMN = parcelRequire("ehOMN");
const $8deecb25f63ed87c$var$GoalCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQmpr.AllAtlasGoals), props);
var $8deecb25f63ed87c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $ehOMN.default))($8deecb25f63ed87c$var$GoalCell);

});
parcelRegister("hQmpr", function(module, exports) {

$parcel$export(module.exports, "AllAtlasGoals", () => $cf9d4b294ef17dfb$export$f0602cb4d11ab613);

var $lNNXV = parcelRequire("lNNXV");

var $2bAux = parcelRequire("2bAux");

var $9fKdd = parcelRequire("9fKdd");
const $cf9d4b294ef17dfb$export$f0602cb4d11ab613 = (0, $lNNXV.connect)((0, $2bAux.default), {})((0, $9fKdd.default));

});
parcelRegister("2bAux", function(module, exports) {

$parcel$export(module.exports, "default", () => $0995b4e8fb132a5d$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
const $0995b4e8fb132a5d$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    isExportMode: $akhOi.isExportMode,
    hasAtlasPermissions: (0, $dhHiZ.getHasAtlasPermissions)
});
var $0995b4e8fb132a5d$export$2e2bcd8739ae039 = $0995b4e8fb132a5d$var$querySelector;

});

parcelRegister("9fKdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $98e2e7d231e55e9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iVIEg = parcelRequire("iVIEg");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $b5IAe = parcelRequire("b5IAe");

var $1ybV0 = parcelRequire("1ybV0");

var $lGIBI = parcelRequire("lGIBI");

var $gbNhI = parcelRequire("gbNhI");
var $8YqJS = parcelRequire("8YqJS");

var $dlZBr = parcelRequire("dlZBr");

var $5rYNM = parcelRequire("5rYNM");

var $85Qc1 = parcelRequire("85Qc1");
const $98e2e7d231e55e9d$var$calculateFlexShrink = (lazyGoals)=>{
    const goalNameLengths = lazyGoals.map((lazyGoal)=>lazyGoal.goal === undefined ? 0 : lazyGoal.goal.name.length);
    const shrinkCoefficient = 0.2; // A smaller number will make the goal components shrink closer to a similar rate.
    return goalNameLengths.map((length)=>Math.pow(length, shrinkCoefficient));
};
const $98e2e7d231e55e9d$var$AllAtlasGoals = /*#__PURE__*/ (0, $eUqFw.memo)(({ hasAtlasPermissions: hasAtlasPermissions, isScrolling: isScrolling = false, issue: issue, onChange: onChangeApiUpdate, isExportMode: isExportMode, ...props })=>{
    const goals = issue.goals ?? [];
    const [lazyGoals] = (0, $lGIBI.useLazyGoalsByARI)(goals);
    if (lazyGoals.some(({ isLoading: isLoading })=>isLoading)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dlZBr.CellSkeleton), {
        width: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM
    });
    const filteredLazyGoals = lazyGoals.filter((lazyGoal)=>lazyGoal.goal !== undefined);
    const canEditGoals = hasAtlasPermissions && ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') ? true : issue.level > (0, $8YqJS.STORY_LEVEL));
    if (isScrolling) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), null);
    const flexShrinkValues = $98e2e7d231e55e9d$var$calculateFlexShrink(lazyGoals);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const onChange = (issue, goals)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filteredLazyGoals, goals)) onChangeApiUpdate(issue, goals);
    };
    const currentGoals = issue.goals;
    const originalGoals = issue.originals?.goals;
    const hasBeenChanged = originalGoals && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(currentGoals, originalGoals)) || currentGoals && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))((0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(originalGoals, currentGoals));
    if (canEditGoals) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85Qc1.default), {
        ...props,
        isCellDirty: ()=>hasBeenChanged,
        issue: issue,
        onChange: onChange,
        flexShrinkValues: flexShrinkValues,
        lazyGoals: filteredLazyGoals,
        isExportMode: isExportMode
    }));
    return null;
});
var $98e2e7d231e55e9d$export$2e2bcd8739ae039 = $98e2e7d231e55e9d$var$AllAtlasGoals;

});
parcelRegister("dlZBr", function(module, exports) {

$parcel$export(module.exports, "CellSkeleton", () => $1e2c904259b126e1$export$17bd75bd7c43e72);

var $eUqFw = parcelRequire("eUqFw");

var $gIPv8 = parcelRequire("gIPv8");

var $7QAbJ = parcelRequire("7QAbJ");
const $1e2c904259b126e1$export$17bd75bd7c43e72 = ({ width: width, height: height = (0, $7QAbJ.RECT_ROW_HEIGHT) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIPv8.default), {
        width: `${width}px`,
        height: `${height}px`,
        ...(0, $7QAbJ.DEFAULT_CONTENT_LOADER_PROPS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        ...(0, $7QAbJ.RECT_BORDER_RADIUS),
        width: width,
        height: height
    }));

});
parcelRegister("gIPv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c8b47a4f82f1da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $c2c8b47a4f82f1da$var$__assign = function() {
    $c2c8b47a4f82f1da$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2c8b47a4f82f1da$var$__assign.apply(this, arguments);
};
function $c2c8b47a4f82f1da$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $c2c8b47a4f82f1da$var$uid = function() {
    return Math.random().toString(36).substring(2);
};
var $c2c8b47a4f82f1da$var$Svg = function(_a) {
    var rtl = _a.rtl, speed = _a.speed, interval = _a.interval, style = _a.style, width = _a.width, height = _a.height, baseUrl = _a.baseUrl, gradientRatio = _a.gradientRatio, animate = _a.animate, ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, uniquekey = _a.uniquekey, primaryColor = _a.primaryColor, primaryOpacity = _a.primaryOpacity, secondaryColor = _a.secondaryColor, secondaryOpacity = _a.secondaryOpacity, preserveAspectRatio = _a.preserveAspectRatio, props = $c2c8b47a4f82f1da$var$__rest(_a, [
        "rtl",
        "speed",
        "interval",
        "style",
        "width",
        "height",
        "baseUrl",
        "gradientRatio",
        "animate",
        "ariaLabel",
        "children",
        "className",
        "uniquekey",
        "primaryColor",
        "primaryOpacity",
        "secondaryColor",
        "secondaryOpacity",
        "preserveAspectRatio"
    ]);
    var idClip = uniquekey ? uniquekey + "-idClip" : $c2c8b47a4f82f1da$var$uid();
    var idGradient = uniquekey ? uniquekey + "-idGradient" : $c2c8b47a4f82f1da$var$uid();
    var rtlStyle = rtl ? {
        transform: 'scaleX(-1)'
    } : {};
    var keyTimes = "0; " + interval + "; 1";
    var dur = speed + "s";
    return (0, $eUqFw.createElement)("svg", $c2c8b47a4f82f1da$var$__assign({
        role: "img",
        style: $c2c8b47a4f82f1da$var$__assign($c2c8b47a4f82f1da$var$__assign({}, style), rtlStyle),
        className: className,
        "aria-label": ariaLabel ? ariaLabel : null,
        viewBox: "0 0 " + width + " " + height,
        preserveAspectRatio: preserveAspectRatio
    }, props), ariaLabel ? (0, $eUqFw.createElement)("title", null, ariaLabel) : null, (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "0",
        width: width,
        height: height,
        clipPath: "url(" + baseUrl + "#" + idClip + ")",
        style: {
            fill: "url(" + baseUrl + "#" + idGradient + ")"
        }
    }), (0, $eUqFw.createElement)("defs", null, (0, $eUqFw.createElement)("clipPath", {
        id: idClip
    }, children), (0, $eUqFw.createElement)("linearGradient", {
        id: idGradient
    }, (0, $eUqFw.createElement)("stop", {
        offset: "0%",
        stopColor: primaryColor,
        stopOpacity: primaryOpacity
    }, animate && (0, $eUqFw.createElement)("animate", {
        attributeName: "offset",
        values: -gradientRatio + "; " + -gradientRatio + "; 1",
        keyTimes: keyTimes,
        dur: dur,
        repeatCount: "indefinite"
    })), (0, $eUqFw.createElement)("stop", {
        offset: "50%",
        stopColor: secondaryColor,
        stopOpacity: secondaryOpacity
    }, animate && (0, $eUqFw.createElement)("animate", {
        attributeName: "offset",
        values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 + gradientRatio / 2),
        keyTimes: keyTimes,
        dur: dur,
        repeatCount: "indefinite"
    })), (0, $eUqFw.createElement)("stop", {
        offset: "100%",
        stopColor: primaryColor,
        stopOpacity: primaryOpacity
    }, animate && (0, $eUqFw.createElement)("animate", {
        attributeName: "offset",
        values: "0; 0; " + (1 + gradientRatio),
        keyTimes: keyTimes,
        dur: dur,
        repeatCount: "indefinite"
    })))));
};
var $c2c8b47a4f82f1da$var$defaultProps = {
    animate: true,
    ariaLabel: 'Loading interface...',
    baseUrl: '',
    gradientRatio: 2,
    height: 130,
    interval: 0.25,
    preserveAspectRatio: 'none',
    primaryColor: '#f0f0f0',
    primaryOpacity: 1,
    rtl: false,
    secondaryColor: '#e0e0e0',
    secondaryOpacity: 1,
    speed: 2,
    style: {},
    width: 400
};
var $c2c8b47a4f82f1da$var$InitialComponent = function(props) {
    return (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "0",
        rx: "5",
        ry: "5",
        width: props.width,
        height: props.height
    });
};
var $c2c8b47a4f82f1da$var$ContentLoader = function(props) {
    var mergedProps = $c2c8b47a4f82f1da$var$__assign($c2c8b47a4f82f1da$var$__assign({}, $c2c8b47a4f82f1da$var$defaultProps), props);
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$Svg, $c2c8b47a4f82f1da$var$__assign({}, mergedProps), props.children || (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$InitialComponent, $c2c8b47a4f82f1da$var$__assign({}, mergedProps)));
};
var $c2c8b47a4f82f1da$export$a4f57375e50e81d5 = function(props) {
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$ContentLoader, $c2c8b47a4f82f1da$var$__assign({}, props), (0, $eUqFw.createElement)("rect", {
        x: "70",
        y: "15",
        rx: "4",
        ry: "4",
        width: "117",
        height: "6.4"
    }), (0, $eUqFw.createElement)("rect", {
        x: "70",
        y: "35",
        rx: "3",
        ry: "3",
        width: "85",
        height: "6.4"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "80",
        rx: "3",
        ry: "3",
        width: "350",
        height: "6.4"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "100",
        rx: "3",
        ry: "3",
        width: "380",
        height: "6.4"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "120",
        rx: "3",
        ry: "3",
        width: "201",
        height: "6.4"
    }), (0, $eUqFw.createElement)("circle", {
        cx: "30",
        cy: "30",
        r: "30"
    }));
};
var $c2c8b47a4f82f1da$export$6afe72be63c708bc = function(props) {
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$ContentLoader, $c2c8b47a4f82f1da$var$__assign({}, props, {
        height: 480
    }), (0, $eUqFw.createElement)("circle", {
        cx: "30",
        cy: "30",
        r: "30"
    }), (0, $eUqFw.createElement)("rect", {
        x: "75",
        y: "13",
        rx: "4",
        ry: "4",
        width: "100",
        height: "13"
    }), (0, $eUqFw.createElement)("rect", {
        x: "75",
        y: "37",
        rx: "4",
        ry: "4",
        width: "50",
        height: "8"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "70",
        rx: "5",
        ry: "5",
        width: "400",
        height: "400"
    }));
};
var $c2c8b47a4f82f1da$export$52f0f02147b12c03 = function(props) {
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$ContentLoader, $c2c8b47a4f82f1da$var$__assign({}, props), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "0",
        rx: "3",
        ry: "3",
        width: "70",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "80",
        y: "0",
        rx: "3",
        ry: "3",
        width: "100",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "190",
        y: "0",
        rx: "3",
        ry: "3",
        width: "10",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "15",
        y: "20",
        rx: "3",
        ry: "3",
        width: "130",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "155",
        y: "20",
        rx: "3",
        ry: "3",
        width: "130",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "15",
        y: "40",
        rx: "3",
        ry: "3",
        width: "90",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "115",
        y: "40",
        rx: "3",
        ry: "3",
        width: "60",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "185",
        y: "40",
        rx: "3",
        ry: "3",
        width: "60",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "60",
        rx: "3",
        ry: "3",
        width: "30",
        height: "10"
    }));
};
var $c2c8b47a4f82f1da$export$54c2e3dc7acea9f5 = function(props) {
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$ContentLoader, $c2c8b47a4f82f1da$var$__assign({}, props), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "0",
        rx: "3",
        ry: "3",
        width: "250",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "20",
        y: "20",
        rx: "3",
        ry: "3",
        width: "220",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "20",
        y: "40",
        rx: "3",
        ry: "3",
        width: "170",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "0",
        y: "60",
        rx: "3",
        ry: "3",
        width: "250",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "20",
        y: "80",
        rx: "3",
        ry: "3",
        width: "200",
        height: "10"
    }), (0, $eUqFw.createElement)("rect", {
        x: "20",
        y: "100",
        rx: "3",
        ry: "3",
        width: "80",
        height: "10"
    }));
};
var $c2c8b47a4f82f1da$export$546f606c73d35982 = function(props) {
    return (0, $eUqFw.createElement)($c2c8b47a4f82f1da$var$ContentLoader, $c2c8b47a4f82f1da$var$__assign({}, props), (0, $eUqFw.createElement)("circle", {
        cx: "10",
        cy: "20",
        r: "8"
    }), (0, $eUqFw.createElement)("rect", {
        x: "25",
        y: "15",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
    }), (0, $eUqFw.createElement)("circle", {
        cx: "10",
        cy: "50",
        r: "8"
    }), (0, $eUqFw.createElement)("rect", {
        x: "25",
        y: "45",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
    }), (0, $eUqFw.createElement)("circle", {
        cx: "10",
        cy: "80",
        r: "8"
    }), (0, $eUqFw.createElement)("rect", {
        x: "25",
        y: "75",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
    }), (0, $eUqFw.createElement)("circle", {
        cx: "10",
        cy: "110",
        r: "8"
    }), (0, $eUqFw.createElement)("rect", {
        x: "25",
        y: "105",
        rx: "5",
        ry: "5",
        width: "220",
        height: "10"
    }));
};
var $c2c8b47a4f82f1da$export$2e2bcd8739ae039 = $c2c8b47a4f82f1da$var$ContentLoader;

});

parcelRegister("7QAbJ", function(module, exports) {

$parcel$export(module.exports, "RECT_BORDER_RADIUS", () => $f880beada11c5680$export$6e8110f49ab45b16);
$parcel$export(module.exports, "RECT_ROW_HEIGHT", () => $f880beada11c5680$export$edd1e89b478b8de3);
$parcel$export(module.exports, "DEFAULT_CONTENT_LOADER_PROPS", () => $f880beada11c5680$export$a04fe6b687553e9b);

var $PdmhA = parcelRequire("PdmhA");
const $f880beada11c5680$var$BORDER_RADIUS = 2;
const $f880beada11c5680$export$6e8110f49ab45b16 = {
    rx: `${$f880beada11c5680$var$BORDER_RADIUS}`,
    ry: `${$f880beada11c5680$var$BORDER_RADIUS}`
};
const $f880beada11c5680$export$edd1e89b478b8de3 = 28;
const $f880beada11c5680$var$CONTENT_LOADER_COLORS = {
    primaryColor: `var(--ds-background-neutral, ${(0, $PdmhA).N30})`,
    secondaryColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA).N20})`
};
const $f880beada11c5680$var$CONTENT_LOADER_ANIMATION_SPEED = 1;
const $f880beada11c5680$export$a04fe6b687553e9b = {
    ...$f880beada11c5680$var$CONTENT_LOADER_COLORS,
    speed: $f880beada11c5680$var$CONTENT_LOADER_ANIMATION_SPEED
};

});


parcelRegister("85Qc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $393032152a5d66d5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $3hSi4 = parcelRequire("3hSi4");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lGIBI = parcelRequire("lGIBI");

var $jQxSL = parcelRequire("jQxSL");

var $8CXDT = parcelRequire("8CXDT");

var $a4vO3 = parcelRequire("a4vO3");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $apDsW = parcelRequire("apDsW");

var $8QizU = parcelRequire("8QizU");

var $8QizU = parcelRequire("8QizU");

var $gpryJ = parcelRequire("gpryJ");

var $sY26D = parcelRequire("sY26D");
const $393032152a5d66d5$var$MultiValueRemove = (props)=>{
    const innerProps = {
        ...props.innerProps,
        'aria-label': `Remove ${props.data.goal?.name ?? 'goal'}`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MultiValueRemove, {
        ...props,
        innerProps: innerProps
    });
};
function $393032152a5d66d5$export$a46eb59c704d783({ lazyGoals: lazyGoals, onChange: onChange, issue: issue, flexShrinkValues: flexShrinkValues, isDisabled: isDisabled, FieldSelect: FieldSelect, isReadOnly: isReadOnly, isCellDirty: isCellDirty, isExportMode: isExportMode }) {
    const [searchesInProgress] = (0, $lGIBI.useLazyGoalSearchesInProgress)();
    const [goals] = (0, $lGIBI.useLazyGoalsByARI)(issue.goals ? issue.goals : []);
    const [query, setQuery] = (0, $eUqFw.useState)('');
    const [selectedOptions, setSelectedOptions] = (0, $eUqFw.useState)(goals);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [searchLazyGoalsByARI, { fetchGoalsByFuzzyName: fetchGoalsByFuzzyName }] = (0, $lGIBI.useLazyGoalByName)(query);
    const [allLazyGoals] = (0, $lGIBI.useAllLazyGoals)();
    (0, $eUqFw.useEffect)(()=>{
        setSelectedOptions(lazyGoals);
    }, [
        lazyGoals
    ]);
    const getOptions = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    async (query)=>{
        const trimmedQuery = query.trim().toLowerCase();
        setQuery(trimmedQuery);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(trimmedQuery)) await fetchGoalsByFuzzyName(trimmedQuery);
    }, [
        fetchGoalsByFuzzyName
    ]);
    const debounceGetOptions = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(getOptions, 250), [
        getOptions
    ]);
    const handleInputChange = (value, { action: action })=>{
        if (action === 'input-change') debounceGetOptions(value);
    };
    const handleMenuClose = ()=>{
        onChange(issue, selectedOptions);
    };
    const onItemChanged = (options)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const selectedOptions = Array.isArray(options) ? options : [];
        setSelectedOptions(selectedOptions);
        setQuery('');
    };
    const renderMultipleGoals = (0, $eUqFw.useCallback)(({ onMenuOpen: onMenuOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selectedOptions.map((lazyGoal, index)=>{
            if (lazyGoal.goal === undefined) return null;
            const { goal: goal } = lazyGoal;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QizU.GoalHoverCard), {
                goal: goal,
                flexShrink: flexShrinkValues[index],
                key: goal.key,
                onClick: onMenuOpen,
                isExportMode: isExportMode
            });
        })), [
        flexShrinkValues,
        isExportMode,
        selectedOptions
    ]);
    const ControlComponent = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>{
        const { selectProps: { menuIsOpen: menuIsOpen, value: value, onMenuOpen: onMenuOpen } } = props;
        const isDefaultControl = menuIsOpen || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value) && !isDisabled;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, {
            ...props,
            isFocused: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isDefaultControl && props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "button",
            tabIndex: 0,
            onClick: onMenuOpen,
            onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            className: (0, $7JEyt.default)([
                "_1e0c1txw _2lx2vrvc _1yt4h8dc _80omtlke _1bsb1osq _vchhusvi _6ndb11dc",
                isDisabled && "_80om73ad _nt751r31 _49pcglyw _1hvw1o36 _1q5t1r31 _1ohyglyw _1r9x1o36",
                menuIsOpen && "_1e0cglyw"
            ])
        }, renderMultipleGoals({
            onMenuOpen: onMenuOpen
        }))));
    }, [
        isDisabled,
        renderMultipleGoals
    ]);
    const filterOptions = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3hSi4)))(allLazyGoals, selectedOptions, (goal)=>goal.goal?.id);
    const getFieldSelect = ()=>isDisabled || isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_11ow1osq _1u6fh8dc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_1tke1ylp _1bsb1osq _1e0c1txw _4cvr1h6o"
            ])
        }, lazyGoals.length > 0 && renderMultipleGoals({
            onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, {
            isMulti: true,
            isLoading: searchesInProgress > 0 && query.length > 0,
            value: selectedOptions,
            options: searchLazyGoalsByARI,
            formatOptionLabel: (option)=>{
                if (option.goal) {
                    const { goal: { key: key, name: name, state: { value: value, label: label } = {
                        value: (0, $apDsW.GoalStateValues).CANCELLED,
                        label: 'Cancelled'
                    } } } = option;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        key: key,
                        xcss: $393032152a5d66d5$var$outerWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center",
                        alignInline: "start",
                        xcss: $393032152a5d66d5$var$goalSelectStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QizU.BasicGoal), {
                        name: name,
                        value: value,
                        label: label,
                        isExportMode: isExportMode
                    }))));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
            },
            onMenuClose: handleMenuClose,
            onChange: onItemChanged,
            closeMenuOnSelect: false,
            styles: (0, $sY26D.selectStyles),
            onInputChange: handleInputChange,
            minSelectWidth: (0, $2LimL.MIN_SELECT_WIDTH),
            placeholder: formatMessage((0, $gpryJ.default).chooseGoal),
            noOptionsMessage: ()=>formatMessage((0, $gpryJ.default).noMatch),
            issueId: issue.id,
            components: (0, $1ybV0.ff)('arj-goals-aria-label-broken_mozdx') ? {
                Control: ControlComponent,
                MultiValueRemove: $393032152a5d66d5$var$MultiValueRemove,
                LoadingIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                        size: "small"
                    })
            } : {
                Control: ControlComponent,
                LoadingIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                        size: "small"
                    })
            },
            getOptionLabel: (goal)=>goal.goal?.name,
            getOptionValue: (goal)=>goal.goal?.key,
            filterOption: filterOptions
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        attribute: "goal",
        issue: issue,
        isScrolling: false,
        isCellDirty: isCellDirty
    }, getFieldSelect());
}
const $393032152a5d66d5$var$goalSelectStyles = (0, $1ZAYh.xcss)({
    height: '30px',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $393032152a5d66d5$var$outerWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    minWidth: '38px'
});
const $393032152a5d66d5$var$itemsWrapperStyles = null;
const $393032152a5d66d5$var$labelsContainerStyles = null;
const $393032152a5d66d5$var$componentContainerStyles = null;
const $393032152a5d66d5$var$componentsContainerDisabledStyles = null;
const $393032152a5d66d5$var$hiddenContainerStyles = null;
var $393032152a5d66d5$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})($393032152a5d66d5$export$a46eb59c704d783);

});
parcelRegister("3hSi4", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $264d129342447f48$var$differenceBy = $9eFtX(function(array, values) {
    var iteratee = $iTvqy(values);
    if ($cRpul(iteratee)) iteratee = undefined;
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true), $7qARj(iteratee, 2)) : [];
});
module.exports = $264d129342447f48$var$differenceBy;

});

parcelRegister("apDsW", function(module, exports) {

$parcel$export(module.exports, "GoalStateValues", () => $79c60efd79b96bed$export$a05d2a8ae30caf55);
const $79c60efd79b96bed$export$c936349447a77fe0 = 'archived';
const $79c60efd79b96bed$export$2163138c803bb209 = 'at_risk';
const $79c60efd79b96bed$export$6b4658081fcf1aed = 'cancelled';
const $79c60efd79b96bed$export$71efb3495f6084f2 = 'done';
const $79c60efd79b96bed$export$fbc51d7b148a92b2 = 'off_track';
const $79c60efd79b96bed$export$2e8f909ef398bdf4 = 'on_track';
const $79c60efd79b96bed$export$3ad39751a33c16b8 = 'paused';
const $79c60efd79b96bed$export$aebb42912407fb2d = 'pending';
// eslint-disable-next-line @atlassian/relay/no-future-added-value
const $79c60efd79b96bed$var$FUTURE_ADDED_VALUE = '%future added value';
const $79c60efd79b96bed$export$a05d2a8ae30caf55 = {
    ARCHIVED: $79c60efd79b96bed$export$c936349447a77fe0,
    AT_RISK: $79c60efd79b96bed$export$2163138c803bb209,
    CANCELLED: $79c60efd79b96bed$export$6b4658081fcf1aed,
    DONE: $79c60efd79b96bed$export$71efb3495f6084f2,
    OFF_TRACK: $79c60efd79b96bed$export$fbc51d7b148a92b2,
    ON_TRACK: $79c60efd79b96bed$export$2e8f909ef398bdf4,
    PAUSED: $79c60efd79b96bed$export$3ad39751a33c16b8,
    PENDING: $79c60efd79b96bed$export$aebb42912407fb2d
};

});

parcelRegister("8QizU", function(module, exports) {

$parcel$export(module.exports, "Goal", () => $d7b7177fb7748b2f$export$462e530a9b3886e4);
$parcel$export(module.exports, "BasicGoal", () => $d7b7177fb7748b2f$export$2fc34cb0ccc82804);
$parcel$export(module.exports, "GoalHoverCard", () => $d7b7177fb7748b2f$export$ef57e3709451ec90);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $hqABm = parcelRequire("hqABm");

var $l2663 = parcelRequire("l2663");

var $apDsW = parcelRequire("apDsW");

var $4Deo8 = parcelRequire("4Deo8");

var $4dREb = parcelRequire("4dREb");

var $As52d = parcelRequire("As52d");
const $d7b7177fb7748b2f$export$462e530a9b3886e4 = ({ name: name, state: { value: value, label: label, score: score } = {
    value: (0, $apDsW.GoalStateValues).CANCELLED,
    label: 'Cancelled'
}, isExportMode: isExportMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        xcss: $d7b7177fb7748b2f$var$goalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7b7177fb7748b2f$export$2fc34cb0ccc82804, {
        name: name,
        value: value,
        isExportMode: isExportMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $As52d.GoalTracker), {
        value: value,
        label: label,
        score: score
    }));
const $d7b7177fb7748b2f$export$2fc34cb0ccc82804 = ({ name: name, value: value, label: label, isExportMode: isExportMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dREb.GoalIcon), {
        state: value,
        ariaLabel: label ? (0, $4Deo8.extractStatusLabelWithoutScore)(label) : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: !isExportMode ? $d7b7177fb7748b2f$var$goalNameStyles : $d7b7177fb7748b2f$var$exportGoalNameStyles
    }, name));
const $d7b7177fb7748b2f$export$ef57e3709451ec90 = ({ goal: goal, flexShrink: flexShrink, onClick: onClick, isExportMode: isExportMode })=>{
    const { key: key, name: name, state: state, url: url } = goal;
    return(// eslint-disable-next-line jira/react/no-style-attribute
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        key: key,
        xcss: $d7b7177fb7748b2f$var$outerWrapperStyles,
        style: {
            flexShrink: flexShrink
        }
    }, url !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.StandaloneHoverCard), {
        url: url ?? '',
        actionOptions: {
            hide: false,
            exclude: [
                (0, $hqABm.CardAction).ChangeStatusAction
            ]
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d7b7177fb7748b2f$var$innerWrapperStyles,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7b7177fb7748b2f$export$462e530a9b3886e4, {
        name: name,
        state: state,
        isExportMode: isExportMode
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d7b7177fb7748b2f$var$innerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7b7177fb7748b2f$export$462e530a9b3886e4, {
        name: name,
        state: state,
        isExportMode: isExportMode
    }))));
};
const $d7b7177fb7748b2f$var$outerWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    minWidth: '38px'
});
const $d7b7177fb7748b2f$var$innerWrapperStyles = (0, $1ZAYh.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface',
    height: '32px',
    marginLeft: 'space.025',
    marginRight: 'space.025'
});
const $d7b7177fb7748b2f$var$goalStyles = (0, $1ZAYh.xcss)({
    height: '30px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    padding: 'space.050'
});
const $d7b7177fb7748b2f$var$goalNameStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $d7b7177fb7748b2f$var$exportGoalNameStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    textOverflow: 'clip',
    overflow: 'hidden'
});

});
parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("l2663", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $5be32bc41d45e714$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $5be32bc41d45e714$export$f1f63acbe6ed8fb0);
/** @jsx jsx */ 
var $2jDha = parcelRequire("2jDha");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $jtkmg = parcelRequire("jtkmg");

var $iNbFo = parcelRequire("iNbFo");

var $kDtPD = parcelRequire("kDtPD");

var $caOA9 = parcelRequire("caOA9");

var $asu8X = parcelRequire("asu8X");
const $5be32bc41d45e714$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $asu8X.di)((0, $kDtPD.HoverCardComponent));
    const { url: url, id: id, children: children } = props;
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const onError = (0, $eUqFw.useCallback)((error, info)=>{
        analytics.ui.renderFailedEvent({
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            id: id,
            error: error,
            errorInfo: info
        });
    }, [
        analytics.ui,
        id
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jb3WS.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iNbFo.SmartLinkModalProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDtPD.HoverCardComponent), props, children)));
};
const $5be32bc41d45e714$var$HoverCardWithoutAnalyticsContext = (0, $2jDha.default)()($5be32bc41d45e714$var$HoverCardWithErrorBoundary);
const $5be32bc41d45e714$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($5be32bc41d45e714$var$HoverCardWithoutAnalyticsContext, props);
};
const $5be32bc41d45e714$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($5be32bc41d45e714$export$57a077cc9fbe653e, props);

});
parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("jtkmg", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalytics", () => $4156fbcb4ce186b5$export$57c7fece972c9472);

var $eUqFw = parcelRequire("eUqFw");

var $cGAGh = parcelRequire("cGAGh");

var $bTNMs = parcelRequire("bTNMs");
var $x8tkc = parcelRequire("x8tkc");

var $2cI4y = parcelRequire("2cI4y");

var $269iK = parcelRequire("269iK");

var $gqldc = parcelRequire("gqldc");

var $bTNMs = parcelRequire("bTNMs");

var $h71BW = parcelRequire("h71BW");
const $4156fbcb4ce186b5$var$applyCommonAttributes = (event, commonAttributes)=>{
    if (event && event.attributes) {
        for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
    }
    return event;
};
const $4156fbcb4ce186b5$export$57c7fece972c9472 = (url, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Overriding the analytics dispatch method is deprecated. Please omit this argument.
	 */ _dispatchAnalytics, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this via the id prop on the `<Card />` component.
	 */ id, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this attribute via analytics context.
	 */ defaultLocation)=>{
    const { dispatchAnalytics: dispatchAnalytics } = (0, $h71BW.useDispatchAnalytics)(_dispatchAnalytics);
    const defaultId = id || 'NULL';
    // We don't want to trigger a re-render by using useSmartCardState
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const state = store ? (0, $cGAGh.getUrl)(store, url) : undefined;
    const details = state ? state.details : undefined;
    const extractedDefinitionId = (0, $269iK.getDefinitionId)(details);
    const extractedExtensionKey = (0, $269iK.getExtensionKey)(details);
    const extractedResourceType = (0, $269iK.getResourceType)(details);
    const extractedSubproduct = (0, $269iK.getSubproduct)(details);
    const extractedProduct = (0, $269iK.getProduct)(details);
    const extractedStatusDetails = (0, $269iK.getStatusDetails)(details);
    const commonAttributes = (0, $eUqFw.useMemo)(()=>({
            id: defaultId,
            definitionId: extractedDefinitionId,
            extensionKey: extractedExtensionKey,
            resourceType: extractedResourceType,
            destinationObjectType: extractedResourceType,
            destinationSubproduct: extractedSubproduct,
            destinationProduct: extractedProduct,
            location: defaultLocation,
            statusDetails: extractedStatusDetails
        }), [
        defaultId,
        extractedDefinitionId,
        extractedExtensionKey,
        extractedResourceType,
        extractedSubproduct,
        extractedProduct,
        defaultLocation,
        extractedStatusDetails
    ]);
    /** Contains all ui analytics events */ const ui = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with no current authenticated account. (i.e. Connect to Preview).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with a forbidden authenticated account. (i.e. Try another account).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthAlternateAccountEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user
			 * click a button.
			 * @param data A partial analytics event payload
			 */ buttonClickedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param isModifierKeyPressed Whether a modifier key was pressed when clicking the Smart Link.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiCardClickedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    isModifierKeyPressed: isModifierKeyPressed,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    actionSubjectId: actionSubjectId
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user dwells their cursor on a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @param dwellTime Total seconds that the user has dwelled on this iframe
			 * @param dwellPercentVisible Percentage element was visible at end of dwell
			 * @returns
			 */ iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeDwelledEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    dwellTime: dwellTime,
                    dwellPercentVisible: dwellPercentVisible
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks or tabs into a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeFocusedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link action.
			 * Note: This also starts the UFO smart-link-action-invocation experience.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of the action that was clicked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param invokeType @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
			 * @returns
			 */ actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiActionClickedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user clicks on a hover preview's "navigate to link" button.
			 * https://product-fabric.atlassian.net/wiki/spaces/EM/pages/3206743323/Analytics+Metrics+-+Hover+Previews
			 * @param previewDisplay What format the preview is in.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 */ hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardOpenLinkClickedEvent)({
                    id: defaultId,
                    previewDisplay: previewDisplay,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user closed the authentication window without authenticating after opening it.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiClosedAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user close a modal.
			 * @param data A partial analytics event payload
			 */ modalClosedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'closed',
                    actionSubject: 'modal',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a Smart Link was rendered successfully.
			 * Note: this fires even if the Smart Link request errored out.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param canBeDatasource An indicator that shows that a smart link can be converted to a datasource
			 */ renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.succeedUfoExperience)('smart-link-rendered', experienceId, {
                    extensionKey: extensionKey,
                    display: display
                });
                // UFO will disregard this if authentication experience has not yet been started
                (0, $2cI4y.succeedUfoExperience)('smart-link-authenticated', experienceId, {
                    display: display
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderSuccessEvent)({
                    display: display,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    canBeDatasource: canBeDatasource
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                // Start and fail the smart-link-rendered experience. If it has already
                // been started nothing happens.
                (0, $2cI4y.startUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-authenticated', experienceId);
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents a hover preview being opened.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardViewedEvent)({
                    id: id,
                    previewDisplay: previewDisplay,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * This fires an event that represents a hover preview being dismissed.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param hoverTime The duration that the user hovered over a Smart Link before the preview was dismissed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardDismissedEvent)({
                    previewDisplay: previewDisplay,
                    id: id,
                    hoverTime: hoverTime,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * Fires an event that signifies that a "Learn More" link was clicked on an unauthenticated card
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location The location where a link is displayed (jiraWebLinks, confluencePages etc)
			 */ learnMoreClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiLearnMoreLinkClickedEvent)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge
			 */ smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge's dropdown item
			 */ smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge open preview button
			 */ smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
            smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiServerActionClicked)(props), commonAttributes))
        }), [
        dispatchAnalytics,
        commonAttributes,
        defaultId,
        extractedExtensionKey
    ]);
    /** Contains all operational analytics events */ const operational = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents an action being successfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 */ invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeSucceededEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an action being unsuccessfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param reason The reason the invocation failed.
			 */ invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeFailedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account successfully being connected via a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 */ connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectSucceededEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account unsuccessfully being connected.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param reason The reason why the Smart Link connect account failed.
			 */ connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: reason
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectFailedEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event which represents a Smart Link request succeeding or failing based on the status.
			 * @param id The unique ID for this Smart Link.
			 * @param status The status of the Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param resourceType The type of resource that was invoked. This is provider specific (e.g. File, PullRequest).
			 * @param error An error representing why the Smart Link request failed.
			 */ instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                const event = (0, $x8tkc.instrumentEvent)({
                    ...commonAttributes,
                    id: id,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    error: error
                });
                if (event) dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes(event, commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.chunkloadFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            }
        }), [
        defaultId,
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all track analytics events */ const track = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents a user connecting their account to view a Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountConnected)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event which represents a user starting the Smart Link connect account process.
			 * @param location a location where the Smart Link auth action was initiated.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @returns
			 */ appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountAuthStarted)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    location: location
                }), commonAttributes)),
            /**
			 * Removed in EDM-5153: This is an even from an experiment.
			 * @deprecated
			 */ linkUpdated: ()=>{},
            /**
			 * This fires a tracking event before an action invoke api call is made
			 */ smartLinkQuickActionStarted: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionStarted)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call is successful
			 */ smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionSuccess)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call has failed
			 */ smartLinkQuickActionFailed: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionFailed)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * Fires a track event when we call loadMetadata() to get information for a hover card
			 */ hoverCardResolutionStarted: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackHoverCardResolutionStarted)({
                    display: 'hoverCardPreview',
                    ...commonAttributes
                }), commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all screen analytics events */ const screen = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents the connect account page being opened.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.screenAuthPopupEvent)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user view a modal.
			 * @param data A partial analytics event payload
			 */ modalViewedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'viewed',
                    actionSubject: data.name,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'screen',
                    name: data.name
                }, commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ui: ui,
            operational: operational,
            track: track,
            screen: screen
        }), [
        ui,
        operational,
        track,
        screen
    ]);
};

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: undefined,
    packageVersion: undefined
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("x8tkc", function(module, exports) {

$parcel$export(module.exports, "instrumentEvent", () => $823c14fa33decb2a$export$860cf9c079ed505);

var $hEsGF = parcelRequire("hEsGF");

var $bTNMs = parcelRequire("bTNMs");
const $823c14fa33decb2a$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
    const measure = (0, $hEsGF.getMeasure)(id, status) || {
        duration: undefined
    };
    if (status === 'resolved') {
        const event = (0, $bTNMs.resolvedEvent)({
            id: id,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    } else if (error?.type !== 'ResolveUnsupportedError') {
        const event = (0, $bTNMs.unresolvedEvent)({
            id: id,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            error: error
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    }
};

});

parcelRegister("2cI4y", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $6dc76d5a97c623dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $6dc76d5a97c623dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $6dc76d5a97c623dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $6dc76d5a97c623dd$export$4084c0df4a03a6af);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $6dc76d5a97c623dd$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
};
const $6dc76d5a97c623dd$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2kFUE.ConcurrentExperience)('smart-link-rendered', $6dc76d5a97c623dd$var$renderExperience),
    'smart-link-authenticated': new (0, $2kFUE.ConcurrentExperience)('smart-link-authenticated', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2kFUE.ConcurrentExperience)('smart-link-action-invocation', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2kFUE.ConcurrentExperience)('smart-link-ai-summary', $6dc76d5a97c623dd$var$aiExperience)
};
const $6dc76d5a97c623dd$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $6dc76d5a97c623dd$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});





parcelRegister("269iK", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $7ebbf14b484e98b7$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $7ebbf14b484e98b7$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $7ebbf14b484e98b7$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $7ebbf14b484e98b7$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getProduct", () => $7ebbf14b484e98b7$export$e2005c9600188ac7);
$parcel$export(module.exports, "getSubproduct", () => $7ebbf14b484e98b7$export$f8fdefc70357968e);
$parcel$export(module.exports, "getServices", () => $7ebbf14b484e98b7$export$a009e3a1163d46fb);
$parcel$export(module.exports, "getStatusDetails", () => $7ebbf14b484e98b7$export$a752a116d184ffbd);
$parcel$export(module.exports, "isFinalState", () => $7ebbf14b484e98b7$export$d590d08942abc17a);
$parcel$export(module.exports, "getCanBeDatasource", () => $7ebbf14b484e98b7$export$ba6d13ab7b87c55c);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $7ebbf14b484e98b7$export$3f9446bb21b945a0);

var $5gJEv = parcelRequire("5gJEv");
const $7ebbf14b484e98b7$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $5gJEv.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $7ebbf14b484e98b7$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $7ebbf14b484e98b7$export$218d96312e385949 = (details)=>details?.meta?.key;
const $7ebbf14b484e98b7$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $7ebbf14b484e98b7$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $7ebbf14b484e98b7$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $7ebbf14b484e98b7$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $7ebbf14b484e98b7$export$ac5d414b1ebfab5a = (details)=>details && $7ebbf14b484e98b7$export$cd41ae544cfc2a65(details) && $7ebbf14b484e98b7$export$795910f5f15a9633(details);
const $7ebbf14b484e98b7$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $7ebbf14b484e98b7$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $7ebbf14b484e98b7$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $7ebbf14b484e98b7$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $7ebbf14b484e98b7$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $7ebbf14b484e98b7$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $7ebbf14b484e98b7$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $7ebbf14b484e98b7$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("5gJEv", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $dbcf37ca341757a3$export$c81497d3681f24f4);
const $dbcf37ca341757a3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("h71BW", function(module, exports) {

$parcel$export(module.exports, "useDispatchAnalytics", () => $abd09e159ea44bb9$export$5f37699fba0ba807);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $abd09e159ea44bb9$export$5f37699fba0ba807 = (handler)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return {
        dispatchAnalytics: (0, $eUqFw.useMemo)(()=>{
            if (handler) return handler;
            return (payload)=>{
                createAnalyticsEvent(payload).fire((0, $bTNMs.ANALYTICS_CHANNEL));
            };
        }, [
            handler,
            createAnalyticsEvent
        ])
    };
};

});


parcelRegister("iNbFo", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $6a9669e2457be519$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $6a9669e2457be519$export$1fd7f5f21a6d6cb8);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");
const $6a9669e2457be519$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $6a9669e2457be519$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($6a9669e2457be519$var$FALLBACK_API);
const $6a9669e2457be519$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                    fallback: null
                }, modal)),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eUqFw.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eUqFw.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a9669e2457be519$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $6a9669e2457be519$export$1fd7f5f21a6d6cb8 = ()=>(0, $eUqFw.useContext)($6a9669e2457be519$export$f4c0a0f23ba57f8c);

});

parcelRegister("kDtPD", function(module, exports) {

$parcel$export(module.exports, "HoverCardComponent", () => $33866a187794779b$export$e2173dafa6a751bb);
/** @jsx jsx */ 
var $3MV1G = parcelRequire("3MV1G");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $g1UEC = parcelRequire("g1UEC");

var $4XjK2 = parcelRequire("4XjK2");

var $b81Yi = parcelRequire("b81Yi");

var $3miv3 = parcelRequire("3miv3");

var $hxNq6 = parcelRequire("hxNq6");

var $lVbJo = parcelRequire("lVbJo");

var $caOA9 = parcelRequire("caOA9");

var $eGeQQ = parcelRequire("eGeQQ");

var $fck9X = parcelRequire("fck9X");

var $ibKIt = parcelRequire("ibKIt");

var $jtkmg = parcelRequire("jtkmg");
const $33866a187794779b$var$HOVER_CARD_SOURCE = 'smartLinkPreviewHoverCard';
const $33866a187794779b$var$FADE_IN_DELAY = 500;
const $33866a187794779b$var$FADE_OUT_DELAY = 300;
const $33866a187794779b$var$RESOLVE_DELAY = 100;
const $33866a187794779b$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', analyticsHandler: analyticsHandler, canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, hidePreviewButton: hidePreviewButton = false, showServerActions: showServerActions, actionOptions: actionOptionsProp, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $lVbJo.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const fadeOutTimeoutId = (0, $eUqFw.useRef)();
    const fadeInTimeoutId = (0, $eUqFw.useRef)();
    const resolveTimeOutId = (0, $eUqFw.useRef)();
    const mousePos = (0, $eUqFw.useRef)();
    const popupOffset = (0, $eUqFw.useRef)();
    const parentSpan = (0, $eUqFw.useRef)(null);
    const renderers = (0, $4XjK2.useSmartLinkRenderers)();
    const linkState = (0, $b81Yi.useSmartCardState)(url);
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const { loadMetadata: loadMetadata } = (0, $ibKIt.useSmartCardActions)(id, url, analytics);
    const actionOptions = (0, $fck9X.combineActionOptions)(actionOptionsProp, showServerActions);
    const setMousePosition = (0, $eUqFw.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $lVbJo.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $lVbJo.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eUqFw.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $33866a187794779b$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eUqFw.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $33866a187794779b$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eUqFw.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, $33866a187794779b$var$FADE_IN_DELAY);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay
    ]);
    const linkActions = (0, $g1UEC.useSmartLinkActions)({
        url: url,
        appearance: (0, $caOA9.CardDisplay).HoverCardPreview,
        analyticsHandler: analyticsHandler,
        origin: $33866a187794779b$var$HOVER_CARD_SOURCE,
        actionOptions: actionOptions
    });
    const filteredActions = (0, $eUqFw.useMemo)(()=>{
        return hidePreviewButton ? linkActions.filter((action)=>action.id !== 'preview-content') : linkActions;
    }, [
        hidePreviewButton,
        linkActions
    ]);
    const onActionClick = (0, $eUqFw.useCallback)((actionId)=>{
        if (actionId === 'preview-content' || actionId === (0, $caOA9.ActionName).PreviewAction || actionId === (0, $caOA9.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eUqFw.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eUqFw.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardActions: filteredActions,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eGeQQ.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            id: id,
            source: $33866a187794779b$var$HOVER_CARD_SOURCE
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3miv3.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        filteredActions,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": "hover-card-trigger-wrapper"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        popupComponent: (0, $hxNq6.default)
    });
};

});
parcelRegister("g1UEC", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkActions", () => $aca33340d457697a$export$a95296ded9241771);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $9Eiuw = parcelRequire("9Eiuw");

var $ibKIt = parcelRequire("ibKIt");

var $jtkmg = parcelRequire("jtkmg");

var $b81Yi = parcelRequire("b81Yi");

var $269iK = parcelRequire("269iK");
function $aca33340d457697a$export$a95296ded9241771({ url: url, appearance: appearance, analyticsHandler: analyticsHandler, platform: platform = 'web', origin: origin, actionOptions: actionOptions }) {
    const id = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), []);
    const linkState = (0, $b81Yi.useSmartCardState)(url);
    const linkAnalytics = (0, $jtkmg.useSmartLinkAnalytics)(url, analyticsHandler, id);
    const linkActions = (0, $ibKIt.useSmartCardActions)(id, url, linkAnalytics);
    if (linkState.details && !actionOptions?.hide) {
        const cardProperties = (0, $9Eiuw.extractBlockProps)(linkState.details.data, linkState.details.meta, {
            handleInvoke: (opts)=>linkActions.invoke(opts, appearance),
            analytics: linkAnalytics,
            origin: origin,
            extensionKey: (0, $269iK.getExtensionKey)(linkState.details),
            source: appearance,
            actionOptions: actionOptions
        }, undefined, platform);
        if (cardProperties.actions && cardProperties.actions.length > 0) {
            const cardActions = cardProperties.actions.map((action)=>({
                    id: action.id,
                    text: action.text,
                    invoke: action.promise
                }));
            return cardActions;
        }
    }
    return [];
}

});
parcelRegister("9Eiuw", function(module, exports) {

$parcel$export(module.exports, "extractBlockProps", () => $3d076f209fb5402b$export$183e15864834a0bd);

var $4zMKr = parcelRequire("4zMKr");
var $24j8L = parcelRequire("24j8L");

var $i9zl6 = parcelRequire("i9zl6");

var $s2tJO = parcelRequire("s2tJO");

var $bILit = parcelRequire("bILit");
var $lrB7A = parcelRequire("lrB7A");
var $2W9Up = parcelRequire("2W9Up");
var $cc539 = parcelRequire("cc539");

var $lbKTa = parcelRequire("lbKTa");
var $lnW6z = parcelRequire("lnW6z");
var $cx2mN = parcelRequire("cx2mN");
var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $eahqC = parcelRequire("eahqC");

var $buT9h = parcelRequire("buT9h");

var $e3WTQ = parcelRequire("e3WTQ");

var $cNILZ = parcelRequire("cNILZ");

var $5fK3A = parcelRequire("5fK3A");
const $3d076f209fb5402b$var$extractBlockIcon = (jsonLd)=>{
    const icon = (0, $s2tJO.extractIcon)(jsonLd);
    if (typeof icon === 'string') return {
        url: icon
    };
    else return {
        icon: icon
    };
};
const $3d076f209fb5402b$var$extractBlockDetails = (jsonLd)=>[
        (0, $lrB7A.extractCommentCount)(jsonLd),
        (0, $2W9Up.extractProgrammingLanguage)(jsonLd),
        (0, $cc539.extractSubscriberCount)(jsonLd),
        (0, $bILit.extractAttachmentCount)(jsonLd)
    ].filter((detail)=>!!detail);
const $3d076f209fb5402b$export$874f983fcd62a981 = (props, jsonLd, opts, platform, meta)=>{
    if (opts) {
        const { handleInvoke: handleInvoke, actionOptions: actionOptions } = opts;
        const actions = (0, $e3WTQ.extractClientActions)(jsonLd, handleInvoke, actionOptions);
        const previewAction = (0, $cNILZ.extractPreviewAction)({
            ...opts,
            viewProps: props,
            jsonLd: jsonLd,
            platform: platform,
            meta: meta
        });
        // The previewAction should always be the last action
        if (previewAction) actions.push(previewAction);
        return actions;
    }
    return [];
};
const $3d076f209fb5402b$export$37f7a7348279b273 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') return (0, $cx2mN.extractMembers)(jsonLd);
    else if (jsonLd['@type'] === 'atlassian:Task') {
        const assignedMembers = (0, $dlXJJ.extractPersonAssignedTo)(jsonLd);
        if (assignedMembers) return [
            assignedMembers
        ];
    } else if (jsonLd['@type'] === 'atlassian:SourceCodePullRequest') return (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
    else {
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        let updatedByMembers;
        if (updatedBy) updatedByMembers = [
            updatedBy
        ];
        const createdByMembers = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        return updatedByMembers || createdByMembers;
    }
};
const $3d076f209fb5402b$export$183e15864834a0bd = (jsonLd, meta, opts, renderers, platform)=>{
    const props = {
        link: (0, $lnW6z.extractLink)(jsonLd),
        title: (0, $a4gSw.extractTitle)(jsonLd),
        titleTextColor: (0, $24j8L.extractTitleTextColor)(jsonLd),
        lozenge: (0, $i9zl6.extractLozenge)(jsonLd),
        icon: $3d076f209fb5402b$var$extractBlockIcon(jsonLd),
        context: (0, $ebCNT.extractProvider)(jsonLd),
        details: $3d076f209fb5402b$var$extractBlockDetails(jsonLd),
        byline: (0, $4zMKr.extractSummary)(jsonLd) || (0, $eahqC.extractByline)(jsonLd),
        thumbnail: (0, $lbKTa.extractImage)(jsonLd),
        users: $3d076f209fb5402b$export$37f7a7348279b273(jsonLd),
        titlePrefix: (0, $buT9h.extractTitlePrefix)(jsonLd, renderers, 'block'),
        isTrusted: (0, $5fK3A.extractIsTrusted)(meta)
    };
    return {
        ...props,
        actions: $3d076f209fb5402b$export$874f983fcd62a981(props, jsonLd, opts, platform, meta)
    };
};

});
parcelRegister("4zMKr", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $03eb7123b442c89e$export$db5a8500f6b6286e);
const $03eb7123b442c89e$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("24j8L", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $3edef14ae51bdf5a$export$a2afc198e9dada1);

var $2aTcn = parcelRequire("2aTcn");

var $PdmhA = parcelRequire("PdmhA");
const $3edef14ae51bdf5a$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $PdmhA.R500})`;
            default:
                return undefined;
        }
    }
};

});
parcelRegister("2aTcn", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $52be4013925bc58c$export$e0deaeb4a2dfe2b4);
const $52be4013925bc58c$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});


parcelRegister("i9zl6", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $f0d2b04ab2e51680$export$e5da155556a77bca);

var $9tMLz = parcelRequire("9tMLz");

var $h8zKt = parcelRequire("h8zKt");

var $dSEZR = parcelRequire("dSEZR");

var $4yj9H = parcelRequire("4yj9H");

var $jy3WR = parcelRequire("jy3WR");
const $f0d2b04ab2e51680$var$DOC_TYPES = [
    'schema:BlogPosting',
    'schema:TextDigitalDocument',
    'schema:DigitalDocument',
    'schema:PresentationDigitalDocument',
    'schema:SpreadsheetDigitalDocument'
];
const $f0d2b04ab2e51680$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4yj9H.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:SourceCodePullRequest')) return (0, $9tMLz.extractState)(jsonLd);
        else if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $h8zKt.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $dSEZR.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $f0d2b04ab2e51680$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        } else if (type.some((types)=>$f0d2b04ab2e51680$var$DOC_TYPES.includes(types))) {
            const jsonLdDocument = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdDocument);
            return lozengeFromState;
        } else if (type.includes('atlassian:Goal')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:Project')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
    }
};
const $f0d2b04ab2e51680$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $jy3WR.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("9tMLz", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $c909e4d157540c3d$export$5e4074cbce6574c7);

var $BOwLU = parcelRequire("BOwLU");
// Maps accent color short names to their corresponding background and text colors
const $c909e4d157540c3d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $c909e4d157540c3d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $BOwLU.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $BOwLU.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $c909e4d157540c3d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("BOwLU", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $9ca9d217c185ead7$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $9ca9d217c185ead7$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $9ca9d217c185ead7$export$772610da74ddbc07);
const $9ca9d217c185ead7$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $9ca9d217c185ead7$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $9ca9d217c185ead7$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $9ca9d217c185ead7$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $9ca9d217c185ead7$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("h8zKt", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $c3a22850fb93f457$export$962a8da34cf78a4f);

var $BOwLU = parcelRequire("BOwLU");
const $c3a22850fb93f457$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($c3a22850fb93f457$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $c3a22850fb93f457$var$extractTagItem(tag);
    }
};
const $c3a22850fb93f457$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $BOwLU.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("dSEZR", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $845f51ab32eef1a6$export$7698df1946deda72);
const $845f51ab32eef1a6$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});

parcelRegister("4yj9H", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b06a91293523bc6e$export$2e9ae379995d99e3);
const $b06a91293523bc6e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});

parcelRegister("jy3WR", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $345dc23d744dc954$export$ed3fd59180514d27);

var $amPw7 = parcelRequire("amPw7");
const $345dc23d744dc954$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $amPw7.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});
parcelRegister("amPw7", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $8352024242ae3429$export$67f3d92c824fd850);

var $9W7HP = parcelRequire("9W7HP");
const $8352024242ae3429$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});
parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});




parcelRegister("s2tJO", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $c16b40392cebfc0c$export$64bdf1f5e49e8626);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $iwsIy = parcelRequire("iwsIy");

var $fU2qj = parcelRequire("fU2qj");

var $6VQ7Z = parcelRequire("6VQ7Z");

var $gQa4O = parcelRequire("gQa4O");

var $egbU6 = parcelRequire("egbU6");

var $hiUvC = parcelRequire("hiUvC");

var $9A6mL = parcelRequire("9A6mL");

var $2aTcn = parcelRequire("2aTcn");

var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");
var $amPw7 = parcelRequire("amPw7");

var $36X1C = parcelRequire("36X1C");

var $av1Br = parcelRequire("av1Br");

var $1dx5E = parcelRequire("1dx5E");

var $jy3WR = parcelRequire("jy3WR");

var $4afqa = parcelRequire("4afqa");
const $c16b40392cebfc0c$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type')=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $a4gSw.extractTitle)(jsonLd),
        provider: (0, $ebCNT.extractProvider)(jsonLd),
        fileFormat: (0, $36X1C.extractFileFormat)(jsonLd),
        taskType: (0, $jy3WR.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $amPw7.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0];
        return $c16b40392cebfc0c$var$extractIconByType(highestPriorityType, opts);
    } else return $c16b40392cebfc0c$var$extractIconByType(type, opts);
};
function $c16b40392cebfc0c$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU2qj))), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                label: opts.title || 'project',
                size: "small",
                testId: "project-icon"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6VQ7Z))), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gQa4O))), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($egbU6))), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1dx5E.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $c16b40392cebfc0c$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $c16b40392cebfc0c$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $9A6mL.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $c16b40392cebfc0c$var$extractIconByType = (type, opts)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour')) switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $av1Br.extractIconFromDocument)(type, opts);
        default:
            return $c16b40392cebfc0c$var$standardisedExtractIcon(type, opts);
    }
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $av1Br.extractIconFromDocument)(type, opts);
        case 'atlassian:Goal':
            return opts.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Project':
            return opts.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                label: opts.title || 'project',
                size: "small",
                testId: "project-icon"
            });
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU2qj))), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6VQ7Z))), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gQa4O))), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($egbU6))), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Task':
            return (0, $1dx5E.extractIconFromTask)(opts);
        default:
            return opts.provider && opts.provider.icon;
    }
};

});
parcelRegister("fU2qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93df738dedd3ac6$var$_react = $b93df738dedd3ac6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b93df738dedd3ac6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b93df738dedd3ac6$var$Commit16Icon = (props)=>/*#__PURE__*/ $b93df738dedd3ac6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 9a1 1 0 100-2 1 1 0 000 2zm-.986 1.834a3.001 3.001 0 010-5.668A1.007 1.007 0 017 5V3a1 1 0 112 0v2c0 .057-.005.112-.014.166a3.001 3.001 0 010 5.668c.01.054.014.11.014.166v2a1 1 0 01-2 0v-2c0-.057.005-.112.014-.166z"/></svg>`
    }, props, {
        size: "small"
    }));
$b93df738dedd3ac6$var$Commit16Icon.displayName = 'Commit16Icon';
var $b93df738dedd3ac6$var$_default = $b93df738dedd3ac6$var$Commit16Icon;
module.exports.default = $b93df738dedd3ac6$var$_default;

});

parcelRegister("6VQ7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50c080749674b039$var$_react = $50c080749674b039$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50c080749674b039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50c080749674b039$var$PullRequest16Icon = (props)=>/*#__PURE__*/ $50c080749674b039$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M6.417 6H9a1 1 0 011 1v1a1 1 0 002 0V7a3 3 0 00-3-3H6.415l.294-.295a1 1 0 10-1.413-1.414l-2.003 2a1 1 0 00.001 1.415l2.002 2.001a.999.999 0 001.414-.002.999.999 0 00-.001-1.413L6.417 6zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9 14a2 2 0 100-4 2 2 0 000 4z"/></svg>`
    }, props, {
        size: "small"
    }));
$50c080749674b039$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $50c080749674b039$var$_default = $50c080749674b039$var$PullRequest16Icon;
module.exports.default = $50c080749674b039$var$_default;

});

parcelRegister("gQa4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c42951abc82b6c35$var$_react = $c42951abc82b6c35$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c42951abc82b6c35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c42951abc82b6c35$var$Branch16Icon = (props)=>/*#__PURE__*/ $c42951abc82b6c35$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 018.002 11l-.004 2A3.995 3.995 0 0012 9.007v-.274a2 2 0 10-2 0zm-4-3a2 2 0 10-2 0v4.536a2 2 0 102 0V5.732zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$c42951abc82b6c35$var$Branch16Icon.displayName = 'Branch16Icon';
var $c42951abc82b6c35$var$_default = $c42951abc82b6c35$var$Branch16Icon;
module.exports.default = $c42951abc82b6c35$var$_default;

});

parcelRegister("egbU6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a61bcb2b0c01b80b$var$_react = $a61bcb2b0c01b80b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a61bcb2b0c01b80b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a61bcb2b0c01b80b$var$Code16Icon = (props)=>/*#__PURE__*/ $a61bcb2b0c01b80b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L4.46 8.006l1.873-1.871A1 1 0 104.92 4.72zm4.792 0a.999.999 0 000 1.415l1.874 1.87-1.873 1.87a1 1 0 101.414 1.416l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.995.995 0 00-.708.293z"/></svg>`
    }, props, {
        size: "small"
    }));
$a61bcb2b0c01b80b$var$Code16Icon.displayName = 'Code16Icon';
var $a61bcb2b0c01b80b$var$_default = $a61bcb2b0c01b80b$var$Code16Icon;
module.exports.default = $a61bcb2b0c01b80b$var$_default;

});

parcelRegister("hiUvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98ff3a06ace07f2$var$_react = $c98ff3a06ace07f2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c98ff3a06ace07f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c98ff3a06ace07f2$var$Task16Icon = (props)=>/*#__PURE__*/ $c98ff3a06ace07f2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$c98ff3a06ace07f2$var$Task16Icon.displayName = 'Task16Icon';
var $c98ff3a06ace07f2$var$_default = $c98ff3a06ace07f2$var$Task16Icon;
module.exports.default = $c98ff3a06ace07f2$var$_default;

});

parcelRegister("9A6mL", function(module, exports) {

$parcel$export(module.exports, "isCardWithData", () => $4e9a30041ebff1a9$export$f287576685db4026);
$parcel$export(module.exports, "isSpecialEvent", () => $4e9a30041ebff1a9$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $4e9a30041ebff1a9$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4e9a30041ebff1a9$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4e9a30041ebff1a9$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4e9a30041ebff1a9$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4e9a30041ebff1a9$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4e9a30041ebff1a9$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4e9a30041ebff1a9$export$a238cfe4a10e6279);
$parcel$export(module.exports, "combineFrameStyle", () => $4e9a30041ebff1a9$export$666eb6846f461ee6);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4e9a30041ebff1a9$export$4470f298c61a79da);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $XHGTv = parcelRequire("XHGTv");

var $iednx = parcelRequire("iednx");
const $4e9a30041ebff1a9$export$f287576685db4026 = (props)=>!!props.data;
const $4e9a30041ebff1a9$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4e9a30041ebff1a9$export$e6c5ffa684aac4d7() || $4e9a30041ebff1a9$export$d8de0cd37d316fdf(evt) || $4e9a30041ebff1a9$export$5b1771037ab7c451(evt));
const $4e9a30041ebff1a9$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4e9a30041ebff1a9$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
const $4e9a30041ebff1a9$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4e9a30041ebff1a9$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4e9a30041ebff1a9$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $4e9a30041ebff1a9$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("aWo98"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("5hO6q"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("5hO6q"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("3kV6m"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("68kEB"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("pNNfx"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("pNNfx"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("dlbJ3"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("fqpGs"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("fqpGs"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("hgXDP"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("8JPzk"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("8JPzk"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("8JPzk"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("8JPzk"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("8JPzk"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("cVIlt"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("kOBr9"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("kOBr9"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("kOBr9"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("kOBr9"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("kOBr9"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("4BViP"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("1SSFi"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("5KraK"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("3Odf5"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("gwQvz"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("5Gpyh"))
    ]
};
const $4e9a30041ebff1a9$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4e9a30041ebff1a9$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4e9a30041ebff1a9$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4e9a30041ebff1a9$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4e9a30041ebff1a9$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4e9a30041ebff1a9$export$e772c8ff12451969(interval);
            return $4e9a30041ebff1a9$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4e9a30041ebff1a9$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4e9a30041ebff1a9$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4e9a30041ebff1a9$export$666eb6846f461ee6 = (frameStyle, isFrameVisible)=>{
    if (frameStyle !== undefined) return frameStyle;
    if (isFrameVisible) return 'show';
};
const $4e9a30041ebff1a9$export$4470f298c61a79da = (previewUrl, themeState)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.fix-embed-preview-url-query-params')) try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $iednx.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
    const themeStateQueryString = encodeURIComponent((0, $iednx.themeObjectToString)(themeState));
    return `${previewUrl}${previewUrl.includes('?') ? '&' : '?'}themeState=${themeStateQueryString}`;
};

});
parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});

parcelRegister("aWo98", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f6s74');
        const value = parcelRequire('koIAu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f6s74").then(()=>parcelRequire('koIAu'));
}

});

parcelRegister("5hO6q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gnAw0');
        const value = parcelRequire('IXu7C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gnAw0").then(()=>parcelRequire('IXu7C'));
}

});

parcelRegister("3kV6m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jD9x7');
        const value = parcelRequire('gZQhT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jD9x7").then(()=>parcelRequire('gZQhT'));
}

});

parcelRegister("68kEB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cXU5K');
        const value = parcelRequire('8o5C6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cXU5K").then(()=>parcelRequire('8o5C6'));
}

});

parcelRegister("pNNfx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3jhqX');
        const value = parcelRequire('iByLo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3jhqX").then(()=>parcelRequire('iByLo'));
}

});

parcelRegister("dlbJ3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7yNJI');
        const value = parcelRequire('2pi7o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7yNJI").then(()=>parcelRequire('2pi7o'));
}

});

parcelRegister("fqpGs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ifX94');
        const value = parcelRequire('3Xmfm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ifX94").then(()=>parcelRequire('3Xmfm'));
}

});

parcelRegister("hgXDP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3fs5M');
        const value = parcelRequire('7ISrx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3fs5M").then(()=>parcelRequire('7ISrx'));
}

});

parcelRegister("8JPzk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cCULL');
        const value = parcelRequire('cOsqE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cCULL").then(()=>parcelRequire('cOsqE'));
}

});

parcelRegister("cVIlt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('81ele');
        const value = parcelRequire('heDum');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("81ele").then(()=>parcelRequire('heDum'));
}

});

parcelRegister("kOBr9", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9CNV1');
        const value = parcelRequire('ax6gr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9CNV1").then(()=>parcelRequire('ax6gr'));
}

});

parcelRegister("4BViP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dwqKI');
        const value = parcelRequire('8DjS6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dwqKI").then(()=>parcelRequire('8DjS6'));
}

});

parcelRegister("1SSFi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('c9j7H');
        const value = parcelRequire('avXTG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("c9j7H").then(()=>parcelRequire('avXTG'));
}

});

parcelRegister("5KraK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('MsAMf');
        const value = parcelRequire('kRSyE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("MsAMf").then(()=>parcelRequire('kRSyE'));
}

});

parcelRegister("3Odf5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kj99S');
        const value = parcelRequire('cu0Sf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kj99S").then(()=>parcelRequire('cu0Sf'));
}

});

parcelRegister("gwQvz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1bzA4');
        const value = parcelRequire('dCALS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1bzA4").then(()=>parcelRequire('dCALS'));
}

});

parcelRegister("5Gpyh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hqUNL');
        const value = parcelRequire('bXsFc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hqUNL").then(()=>parcelRequire('bXsFc'));
}

});


parcelRegister("ebCNT", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $949786e11a712549$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $949786e11a712549$export$6fb636a2ac885215);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $77CtJ = parcelRequire("77CtJ");


var $amPw7 = parcelRequire("amPw7");
var $9W7HP = parcelRequire("9W7HP");
const $949786e11a712549$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $949786e11a712549$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $949786e11a712549$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $949786e11a712549$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $91701787b8fb623d$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-deprecated-apis */ size: "xsmall"
        });
        else if (id === (0, $91701787b8fb623d$export$f654d825189934a7)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ size: "xsmall"
        });
    }
    if (icon) return (0, $amPw7.extractUrlFromIconJsonLd)(icon);
};
const $949786e11a712549$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});
parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

const $91701787b8fb623d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $91701787b8fb623d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $91701787b8fb623d$export$84a73a0383f58180 = 'JiraTask';
const $91701787b8fb623d$export$c6c83963a9378a67 = 'JiraSubTask';
const $91701787b8fb623d$export$58af3c426c111a6d = 'JiraStory';
const $91701787b8fb623d$export$ac9898a63417219e = 'JiraBug';
const $91701787b8fb623d$export$54db5e3fb12e39cd = 'JiraEpic';
const $91701787b8fb623d$export$2f54a5a217202c85 = 'JiraIncident';
const $91701787b8fb623d$export$d097371052bfc411 = 'JiraServiceRequest';
const $91701787b8fb623d$export$efd9452ad16c6676 = 'JiraChange';
const $91701787b8fb623d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $91701787b8fb623d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';


parcelRegister("a4gSw", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $a665721ac2392089$export$b05803156e5015b6);

var $XHGTv = parcelRequire("XHGTv");

var $ieJEX = parcelRequire("ieJEX");

var $4yj9H = parcelRequire("4yj9H");
const $a665721ac2392089$export$b05803156e5015b6 = (jsonLd)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $ieJEX.extractContext)(jsonLd);
    const type = (0, $4yj9H.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.extractor.improve-bitbucket-file-links') && type.includes('schema:DigitalDocument')) return contextName + name;
    }
    return name;
};

});
parcelRegister("ieJEX", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $24c906d1ff23560a$export$efdbd45f3e77a161);

var $4yj9H = parcelRequire("4yj9H");

var $amPw7 = parcelRequire("amPw7");
const $24c906d1ff23560a$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $amPw7.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $4yj9H.extractType)(context)
            };
        }
    }
};

});


parcelRegister("36X1C", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $5af5b408333e6bb6$export$f2d65f02f6888b60);
const $5af5b408333e6bb6$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("av1Br", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $1ec5d72f762200d9$export$25c24c7f577936d3);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $42mVw = parcelRequire("42mVw");

var $hC3Rz = parcelRequire("hC3Rz");

var $iIEQk = parcelRequire("iIEQk");

var $kaVAc = parcelRequire("kaVAc");

var $33pqc = parcelRequire("33pqc");

var $nzdI3 = parcelRequire("nzdI3");

var $9A6mL = parcelRequire("9A6mL");

var $4afqa = parcelRequire("4afqa");
const $1ec5d72f762200d9$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $1ec5d72f762200d9$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $1ec5d72f762200d9$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour')) return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
    // If we encounter a native provider, we privilege the
    // icon generated by its type. Otherwise, we privilege the
    // provider icon, followed by the type & mime type icons.
    if (opts.priority === 'provider') return iconFromProvider || iconFromFileFormat || iconFromType;
    return iconFromFileFormat || iconFromType || opts.icon || iconFromProvider;
};
const $1ec5d72f762200d9$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $9A6mL.getIconForFileType)(opts.fileFormat);
};
const $1ec5d72f762200d9$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: opts.title || 'blog',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hC3Rz))), {
                label: opts.title || 'file',
                testId: "file-icon"
            });
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'document',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iIEQk))), {
                label: opts.title || 'presentation',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaVAc))), {
                label: opts.title || 'spreadsheet',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($nzdI3))), {
                label: opts.title || 'template',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'undefinedLink',
                testId: "document-icon"
            });
    }
};

});
parcelRegister("42mVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f09221b0a539484$var$_react = $2f09221b0a539484$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2f09221b0a539484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f09221b0a539484$var$Blog16Icon = (props)=>/*#__PURE__*/ $2f09221b0a539484$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zm7 0a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$2f09221b0a539484$var$Blog16Icon.displayName = 'Blog16Icon';
var $2f09221b0a539484$var$_default = $2f09221b0a539484$var$Blog16Icon;
module.exports.default = $2f09221b0a539484$var$_default;

});

parcelRegister("hC3Rz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cd28fb6529d0fdb1$var$_react = $cd28fb6529d0fdb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cd28fb6529d0fdb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cd28fb6529d0fdb1$var$Generic16Icon = (props)=>/*#__PURE__*/ $cd28fb6529d0fdb1$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.333.333 0 00-.093-.231l-2.164-2.25A1.333 1.333 0 008.782 3H8zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cd28fb6529d0fdb1$var$Generic16Icon.displayName = 'Generic16Icon';
var $cd28fb6529d0fdb1$var$_default = $cd28fb6529d0fdb1$var$Generic16Icon;
module.exports.default = $cd28fb6529d0fdb1$var$_default;

});

parcelRegister("iIEQk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $da0c049bdbf3c329$var$_react = $da0c049bdbf3c329$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $da0c049bdbf3c329$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $da0c049bdbf3c329$var$Presentation16Icon = (props)=>/*#__PURE__*/ $da0c049bdbf3c329$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm10 3a1 1 0 00-1 1v8a1 1 0 002 0V4a1 1 0 00-1-1zM8 6a1 1 0 00-1 1v5a1 1 0 002 0V7a1 1 0 00-1-1zM4 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'small'
    }));
$da0c049bdbf3c329$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $da0c049bdbf3c329$var$_default = $da0c049bdbf3c329$var$Presentation16Icon;
module.exports.default = $da0c049bdbf3c329$var$_default;

});

parcelRegister("kaVAc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $eb01688efa6942b0$var$_react = $eb01688efa6942b0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $eb01688efa6942b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eb01688efa6942b0$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $eb01688efa6942b0$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 000 2h1a1 1 0 000-2H4zm5-8a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 000 2h3a1 1 0 000-2H9z"/></svg>`
    }, props, {
        size: 'small'
    }));
$eb01688efa6942b0$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $eb01688efa6942b0$var$_default = $eb01688efa6942b0$var$Spreadsheet16Icon;
module.exports.default = $eb01688efa6942b0$var$_default;

});

parcelRegister("nzdI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $046d781480b548f9$var$_react = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $046d781480b548f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $046d781480b548f9$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $046d781480b548f9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M18.99 8.99l.01 1.015V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768v.521zM12.02 5L12 8.192a.99.99 0 00.994.991h4L12.02 5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$046d781480b548f9$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $046d781480b548f9$var$_default = $046d781480b548f9$var$DocumentFilledIcon;
module.exports.default = $046d781480b548f9$var$_default;

});

parcelRegister("4afqa", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $4cb04ba6bb191e3c$export$65e47eb22a387a86);
function $4cb04ba6bb191e3c$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});


parcelRegister("1dx5E", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4ac251c9d7089865$export$321256ed044e3100);

var $eUqFw = parcelRequire("eUqFw");

var $hiUvC = parcelRequire("hiUvC");

var $aJNc8 = parcelRequire("aJNc8");

var $3Fcny = parcelRequire("3Fcny");

var $3YEb9 = parcelRequire("3YEb9");

var $gFrvj = parcelRequire("gFrvj");

var $bJZ7m = parcelRequire("bJZ7m");

var $2NYtj = parcelRequire("2NYtj");

var $fsJVW = parcelRequire("fsJVW");

var $5cywL = parcelRequire("5cywL");

var $4DxpJ = parcelRequire("4DxpJ");
const $4ac251c9d7089865$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $4DxpJ.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $4DxpJ.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $4DxpJ.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aJNc8))), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $4DxpJ.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fcny))), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $4DxpJ.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YEb9))), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $4DxpJ.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFrvj))), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $4DxpJ.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJZ7m))), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $4DxpJ.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NYtj))), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $4DxpJ.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsJVW))), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $4DxpJ.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cywL))), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $4DxpJ.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("aJNc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $020474b73d22e170$var$_react = $020474b73d22e170$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $020474b73d22e170$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $020474b73d22e170$var$Subtask16Icon = (props)=>/*#__PURE__*/ $020474b73d22e170$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M9 7V4a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h3v3a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H9zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM9 9h2v2H9V9zM5 5h2v2H5V5z"/></svg>`
    }, props, {
        size: "small"
    }));
$020474b73d22e170$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $020474b73d22e170$var$_default = $020474b73d22e170$var$Subtask16Icon;
module.exports.default = $020474b73d22e170$var$_default;

});

parcelRegister("3Fcny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2aaecda278f48b77$var$_react = $2aaecda278f48b77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2aaecda278f48b77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2aaecda278f48b77$var$Story16Icon = (props)=>/*#__PURE__*/ $2aaecda278f48b77$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$2aaecda278f48b77$var$Story16Icon.displayName = 'Story16Icon';
var $2aaecda278f48b77$var$_default = $2aaecda278f48b77$var$Story16Icon;
module.exports.default = $2aaecda278f48b77$var$_default;

});

parcelRegister("3YEb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e5624669878641f$var$_react = $2e5624669878641f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e5624669878641f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e5624669878641f$var$Bug16Icon = (props)=>/*#__PURE__*/ $2e5624669878641f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$2e5624669878641f$var$Bug16Icon.displayName = 'Bug16Icon';
var $2e5624669878641f$var$_default = $2e5624669878641f$var$Bug16Icon;
module.exports.default = $2e5624669878641f$var$_default;

});

parcelRegister("gFrvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c225cf658d24b86a$var$_react = $c225cf658d24b86a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c225cf658d24b86a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c225cf658d24b86a$var$Epic16Icon = (props)=>/*#__PURE__*/ $c225cf658d24b86a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9.912 7.767A.486.486 0 0012 7.5a.5.5 0 00-.5-.5H9V3.5a.495.495 0 00-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.487.487 0 004 8.5a.5.5 0 00.5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 00.5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033-.002-.003z"/></svg>`
    }, props, {
        size: "small"
    }));
$c225cf658d24b86a$var$Epic16Icon.displayName = 'Epic16Icon';
var $c225cf658d24b86a$var$_default = $c225cf658d24b86a$var$Epic16Icon;
module.exports.default = $c225cf658d24b86a$var$_default;

});

parcelRegister("bJZ7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c34e63e2df12b5$var$_react = $88c34e63e2df12b5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88c34e63e2df12b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c34e63e2df12b5$var$Incident16Icon = (props)=>/*#__PURE__*/ $88c34e63e2df12b5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499l-.714 2zM4 11a1 1 0 00-1 1v1h10v-1a1 1 0 00-1-1H4zm1.856-4h4.288L8.942 3.632a1 1 0 00-1.884 0L5.856 7zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$88c34e63e2df12b5$var$Incident16Icon.displayName = 'Incident16Icon';
var $88c34e63e2df12b5$var$_default = $88c34e63e2df12b5$var$Incident16Icon;
module.exports.default = $88c34e63e2df12b5$var$_default;

});

parcelRegister("2NYtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20af10cdef604edb$var$_react = $20af10cdef604edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20af10cdef604edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20af10cdef604edb$var$Issue16Icon = (props)=>/*#__PURE__*/ $20af10cdef604edb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm1 4a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H3zm1 2v4h8V6H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$20af10cdef604edb$var$Issue16Icon.displayName = 'Issue16Icon';
var $20af10cdef604edb$var$_default = $20af10cdef604edb$var$Issue16Icon;
module.exports.default = $20af10cdef604edb$var$_default;

});

parcelRegister("fsJVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b41d19f8b49fa534$var$_react = $b41d19f8b49fa534$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b41d19f8b49fa534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b41d19f8b49fa534$var$Changes16Icon = (props)=>/*#__PURE__*/ $b41d19f8b49fa534$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 104.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L5.456 9h5.134l-.877.876a1 1 0 101.414 1.415l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.999.999 0 00-.707 1.707l.866.865zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$b41d19f8b49fa534$var$Changes16Icon.displayName = 'Changes16Icon';
var $b41d19f8b49fa534$var$_default = $b41d19f8b49fa534$var$Changes16Icon;
module.exports.default = $b41d19f8b49fa534$var$_default;

});

parcelRegister("5cywL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c98db310910faad$var$_react = $3c98db310910faad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3c98db310910faad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3c98db310910faad$var$Problem16Icon = (props)=>/*#__PURE__*/ $3c98db310910faad$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M5.968 11.446l5.478-5.478a4 4 0 01-5.478 5.478zm-.796-.618zm-.618-.796a4 4 0 015.478-5.478l-5.478 5.478zm6.274-4.86zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 14A6 6 0 108 2a6 6 0 000 12z"/></svg>`
    }, props, {
        size: "small"
    }));
$3c98db310910faad$var$Problem16Icon.displayName = 'Problem16Icon';
var $3c98db310910faad$var$_default = $3c98db310910faad$var$Problem16Icon;
module.exports.default = $3c98db310910faad$var$_default;

});

parcelRegister("4DxpJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $0689ce76a4c51982$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $0689ce76a4c51982$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $0689ce76a4c51982$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $0689ce76a4c51982$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $0689ce76a4c51982$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $0689ce76a4c51982$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $0689ce76a4c51982$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $0689ce76a4c51982$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $0689ce76a4c51982$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $0689ce76a4c51982$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $0689ce76a4c51982$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $0689ce76a4c51982$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $0689ce76a4c51982$export$fe44ce30fd8d131b);
const $0689ce76a4c51982$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0689ce76a4c51982$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0689ce76a4c51982$export$84a73a0383f58180 = 'JiraTask';
const $0689ce76a4c51982$export$c6c83963a9378a67 = 'JiraSubTask';
const $0689ce76a4c51982$export$58af3c426c111a6d = 'JiraStory';
const $0689ce76a4c51982$export$ac9898a63417219e = 'JiraBug';
const $0689ce76a4c51982$export$54db5e3fb12e39cd = 'JiraEpic';
const $0689ce76a4c51982$export$2f54a5a217202c85 = 'JiraIncident';
const $0689ce76a4c51982$export$d097371052bfc411 = 'JiraServiceRequest';
const $0689ce76a4c51982$export$efd9452ad16c6676 = 'JiraChange';
const $0689ce76a4c51982$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0689ce76a4c51982$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $0689ce76a4c51982$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});



parcelRegister("bILit", function(module, exports) {

$parcel$export(module.exports, "extractAttachmentCount", () => $abe20e355f69e333$export$65362ff78a97fd8);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $jUThT = parcelRequire("jUThT");
const $abe20e355f69e333$export$65362ff78a97fd8 = (jsonLd)=>{
    const attachmentCount = jsonLd['atlassian:attachmentCount'];
    if (attachmentCount) return {
        text: attachmentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUThT))), {
            size: "small",
            label: "attachments",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});
parcelRegister("jUThT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7fe223acf10e6f6$var$_react = $e7fe223acf10e6f6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e7fe223acf10e6f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e7fe223acf10e6f6$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e7fe223acf10e6f6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 01.002-5.412l7.147-6.985a2.316 2.316 0 013.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 01-.914-.008.62.62 0 010-.902l6.229-6.087a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.23 6.087a2.502 2.502 0 000 3.607 2.643 2.643 0 003.683.009l6.703-6.55a4.074 4.074 0 00-.003-5.859 4.306 4.306 0 00-6.002.003l-7.148 6.985a5.655 5.655 0 00-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.941.941 0 000-1.353.995.995 0 00-1.384 0l-6.686 6.534z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e7fe223acf10e6f6$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e7fe223acf10e6f6$var$_default = $e7fe223acf10e6f6$var$AttachmentIcon;
module.exports.default = $e7fe223acf10e6f6$var$_default;

});


parcelRegister("lrB7A", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $5e138b4d3be6aa9d$export$b68822b76d5d51d5);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $d3vNK = parcelRequire("d3vNK");
const $5e138b4d3be6aa9d$export$b68822b76d5d51d5 = (jsonLd)=>{
    const commentCount = jsonLd['schema:commentCount'];
    if (commentCount) return {
        text: commentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            label: "comment-count",
            key: "comments-count-icon",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});
parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});


parcelRegister("2W9Up", function(module, exports) {

$parcel$export(module.exports, "extractProgrammingLanguage", () => $ca70aff3d91540cb$export$43e54589935a1ff);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $2Q5Ee = parcelRequire("2Q5Ee");
const $ca70aff3d91540cb$export$43e54589935a1ff = (jsonLd)=>{
    const programmingLanguage = jsonLd['schema:programmingLanguage'];
    if (programmingLanguage) return {
        text: programmingLanguage,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q5Ee))), {
            size: "small",
            label: "code",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});
parcelRegister("2Q5Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2114d1ad49e5b359$var$_react = $2114d1ad49e5b359$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2114d1ad49e5b359$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2114d1ad49e5b359$var$CodeIcon = (props)=>/*#__PURE__*/ $2114d1ad49e5b359$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.155 4.055a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.891.65l4.83-14.045a1 1 0 00-.62-1.271m-6.138 8.21l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436m12.219 1.568l-3.32-3.22a.999.999 0 10-1.393 1.437l2.58 2.5-2.799 2.715a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$2114d1ad49e5b359$var$CodeIcon.displayName = 'CodeIcon';
var $2114d1ad49e5b359$var$_default = $2114d1ad49e5b359$var$CodeIcon;
module.exports.default = $2114d1ad49e5b359$var$_default;

});


parcelRegister("cc539", function(module, exports) {

$parcel$export(module.exports, "extractSubscriberCount", () => $0355ea046d0d5228$export$8bd03a7beb5badf1);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $4nce6 = parcelRequire("4nce6");
const $0355ea046d0d5228$export$8bd03a7beb5badf1 = (jsonLd)=>{
    const subscriberCount = jsonLd['atlassian:subscriberCount'];
    if (subscriberCount) return {
        text: subscriberCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: "small",
            label: "subscribers",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA.N600)})`
        })
    };
};

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});


parcelRegister("lbKTa", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $205a59ce4cd20de1$export$4c753a1297cb9805);

var $9W7HP = parcelRequire("9W7HP");
const $205a59ce4cd20de1$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});

parcelRegister("lnW6z", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $798276e7999c5211$export$63f54cf4c5883620);

var $9W7HP = parcelRequire("9W7HP");
const $798276e7999c5211$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $9W7HP.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("cx2mN", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $f6777de4e93b831a$export$6281d080d62a0719);

var $3gIUj = parcelRequire("3gIUj");
const $f6777de4e93b831a$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $3gIUj.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $3gIUj.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});
parcelRegister("3gIUj", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $2b1bbf71ecf49172$export$c471ae5fddcf1392);

var $amPw7 = parcelRequire("amPw7");
const $2b1bbf71ecf49172$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $amPw7.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("dlXJJ", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $eecb0f85fd3e820f$export$38a0979ebf273662);

var $3gIUj = parcelRequire("3gIUj");
const $eecb0f85fd3e820f$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $3gIUj.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("c8AiI", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $62e4f86ca3f5f110$export$a66235cba0c9d11a);

var $3gIUj = parcelRequire("3gIUj");
const $62e4f86ca3f5f110$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("gd1O9", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0);

var $3gIUj = parcelRequire("3gIUj");
const $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
};

});

parcelRegister("eahqC", function(module, exports) {

$parcel$export(module.exports, "extractByline", () => $d692e81450b50c93$export$1bc5d7728bb194e9);

var $eUqFw = parcelRequire("eUqFw");

var $8M1qS = parcelRequire("8M1qS");

var $9KU0P = parcelRequire("9KU0P");

var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
const $d692e81450b50c93$export$1bc5d7728bb194e9 = (jsonLd)=>{
    const updatedAt = (0, $dGfXu.extractDateUpdated)(jsonLd);
    const createdAt = (0, $h1sO6.extractDateCreated)(jsonLd);
    if (updatedAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(updatedAt).getTime());
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Updated ", updatedBy && `by ${updatedBy.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    } else if (createdAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(createdAt).getTime());
        const createdBy = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        const createdByPerson = $d692e81450b50c93$var$extractFirstPerson(createdBy);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Created ", createdByPerson && `by ${createdByPerson.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    }
};
const $d692e81450b50c93$var$extractFirstPerson = (persons)=>{
    if (persons && persons.length > 0) return persons.shift();
};

});
parcelRegister("h1sO6", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $b0559218890d0714$export$e1226a5e0bbbf862);
const $b0559218890d0714$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("dGfXu", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $172490fac0121aa1$export$7fc2f5e6f9d22ae7);
const $172490fac0121aa1$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});


parcelRegister("buT9h", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $4d38aa6ad60122f5$export$58d9bc37318dfb32);
const $4d38aa6ad60122f5$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4d38aa6ad60122f5$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $4d38aa6ad60122f5$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});

parcelRegister("e3WTQ", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $20656457f4b723f0$export$8f031784a3a03b23);
$parcel$export(module.exports, "extractClientActions", () => $20656457f4b723f0$export$75be35b463ab3fda);

var $hMDH6 = parcelRequire("hMDH6");

var $dAGi3 = parcelRequire("dAGi3");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $20656457f4b723f0$var$isClientAction = (action)=>[
        'ViewAction',
        'DownloadAction'
    ].indexOf(action['@type']) > -1;
const $20656457f4b723f0$var$getClientAction = (jsonLd, action)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $hMDH6.ViewAction)({
                url: jsonLd.url
            });
        case 'DownloadAction':
            return (0, $dAGi3.DownloadAction)({
                url: jsonLd['atlassian:downloadUrl']
            });
    }
};
const $20656457f4b723f0$var$isActionEnabled = (action, actionOptions)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions);
        case 'DownloadAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions);
    }
    return true;
};
const $20656457f4b723f0$var$getClientActionProps = (jsonLd, action, handler)=>{
    const clientAction = $20656457f4b723f0$var$getClientAction(jsonLd, action);
    const clientActionInvokeOpts = {
        type: 'client',
        key: action.identifier,
        action: {
            type: action['@type'],
            promise: clientAction.promise
        }
    };
    // Send client actions through common invocation flow; for analytics
    // and, in future, in order to propagate state changes.
    return {
        ...clientAction,
        promise: ()=>handler(clientActionInvokeOpts)
    };
};
const $20656457f4b723f0$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
function $20656457f4b723f0$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
    const actions = $20656457f4b723f0$export$8f031784a3a03b23(jsonLd);
    const clientActions = actions.filter((action)=>$20656457f4b723f0$var$isClientAction(action) && $20656457f4b723f0$var$isActionEnabled(action, actionOptions));
    const clientActionImpls = clientActions.map((action)=>$20656457f4b723f0$var$getClientActionProps(jsonLd, action, handler));
    return clientActionImpls;
}

});
parcelRegister("hMDH6", function(module, exports) {

$parcel$export(module.exports, "ViewAction", () => $724f4a3330fcc48e$export$a96f88e1928d92fa);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $724f4a3330fcc48e$export$a96f88e1928d92fa = ({ url: url })=>({
        id: 'view-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).view),
        promise: ()=>(0, $9A6mL.openUrl)(url)
    });

});
parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent Links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});


parcelRegister("dAGi3", function(module, exports) {

$parcel$export(module.exports, "DownloadAction", () => $15ad76cb67b3a953$export$7a2b423858a679ca);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $15ad76cb67b3a953$export$7a2b423858a679ca = ({ url: url })=>({
        id: 'download-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).download),
        promise: ()=>(0, $9A6mL.downloadUrl)(url)
    });

});

parcelRegister("44Wm8", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $da2b2293f1c35c89$export$2487b058456cca75);
const $da2b2293f1c35c89$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("cNILZ", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $be0d8fa1ca130eb2$export$eba2f3246148e526);

var $hqABm = parcelRequire("hqABm");

var $lIFl3 = parcelRequire("lIFl3");

var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");

var $lFzxK = parcelRequire("lFzxK");

var $caOA9 = parcelRequire("caOA9");

var $dB5lQ = parcelRequire("dB5lQ");

var $44Wm8 = parcelRequire("44Wm8");
const $be0d8fa1ca130eb2$var$getMetadataFromJsonLd = (jsonLd, platform)=>{
    const download = (0, $lIFl3.extractDownloadUrl)(jsonLd);
    const provider = (0, $ebCNT.extractProvider)(jsonLd);
    const preview = (0, $fQDHB.extractPreview)(jsonLd, platform);
    return {
        download: download,
        providerName: provider && provider.text,
        src: preview && preview.src
    };
};
const $be0d8fa1ca130eb2$var$getMetadataFromResolvedProps = (props)=>({
        /* It's fine for content to be undefined, but src is still needed for the link out, even if it's not the source for the iframing */ link: props.link,
        title: props.title,
        details: props.details,
        icon: props.icon,
        url: props.link,
        byline: props.byline,
        isTrusted: props.isTrusted
    });
const $be0d8fa1ca130eb2$var$getInvokeOpts = (key, action, source)=>({
        type: 'client',
        key: key,
        // NB: the preview action is invoked from a block card -
        // the actions on the preview state are invoked from the
        // preview card. Hence, we have a `source` for distinguishing
        // between the two.
        source: source || (0, $caOA9.CardDisplay).EmbedPreview,
        action: {
            type: action,
            promise: ()=>Promise.resolve()
        }
    });
const $be0d8fa1ca130eb2$export$eba2f3246148e526 = ({ extensionKey: extensionKey = 'empty-object-provider', viewProps: viewProps, jsonLd: jsonLd, handleInvoke: handleInvoke, testId: testId, platform: platform, origin: origin, source: source = 'block', analytics: analytics, meta: meta, actionOptions: actionOptions })=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    // Extract metadata from view props & raw JSON-LD.
    const metadataFromJsonLd = $be0d8fa1ca130eb2$var$getMetadataFromJsonLd(jsonLd, platform);
    const metadataFromViewProps = $be0d8fa1ca130eb2$var$getMetadataFromResolvedProps(viewProps);
    const metadata = {
        ...metadataFromJsonLd,
        ...metadataFromViewProps
    };
    // Extract preview action only if we have an iframe src.
    if (metadataFromJsonLd.src) {
        // Build action using instrumentation hooks.
        const key = extensionKey;
        const previewAction = (0, $lFzxK.default)({
            ...metadata,
            analytics: analytics,
            extensionKey: extensionKey,
            origin: origin,
            testId: testId,
            isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
        });
        // Setup props to go through proper Redux 'invocation' flow
        // for analytics, further state management if required in future.
        const previewActionProps = $be0d8fa1ca130eb2$var$getInvokeOpts(key, 'PreviewAction', source);
        // - Promise invoked by the action invocation handler; open preview.
        previewActionProps.action.promise = previewAction.promise;
        // - Promise invoked on click of `Preview` on block card; trigger above promise.
        previewAction.promise = ()=>handleInvoke(previewActionProps);
        return previewAction;
    }
};

});
parcelRegister("lIFl3", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $833f00c4d88e64d9$export$9682e3ac9d184e95);
const $833f00c4d88e64d9$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("lFzxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $890039ba319f55f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $1csi6 = parcelRequire("1csi6");
var $890039ba319f55f6$export$2e2bcd8739ae039 = ({ details: details, ...rest })=>({
        id: 'preview-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        promise: ()=>(0, $1csi6.openEmbedModal)({
                providerName: 'Preview',
                showModal: true,
                onClose: ()=>{},
                ...rest
            })
    });

});
parcelRegister("1csi6", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $06a3274b0148278d$export$7859f96cd8cff034);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
const $06a3274b0148278d$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $06a3274b0148278d$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($06a3274b0148278d$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("gWtzv"));
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Modal.default, {
        ...props,
        iframeName: $06a3274b0148278d$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("gWtzv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('ivIPh')
        ]);
        const value = parcelRequire('2vsut');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("ivIPh")
    ]).then(()=>parcelRequire('2vsut'));
}

});



parcelRegister("caOA9", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $0e147ae1cf3527e1$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $0e147ae1cf3527e1$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $0e147ae1cf3527e1$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $0e147ae1cf3527e1$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $0e147ae1cf3527e1$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $0e147ae1cf3527e1$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $0e147ae1cf3527e1$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $0e147ae1cf3527e1$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $0e147ae1cf3527e1$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $0e147ae1cf3527e1$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $0e147ae1cf3527e1$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $0e147ae1cf3527e1$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $0e147ae1cf3527e1$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $0e147ae1cf3527e1$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $0e147ae1cf3527e1$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $0e147ae1cf3527e1$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $0e147ae1cf3527e1$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $0e147ae1cf3527e1$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804);
const $0e147ae1cf3527e1$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $0e147ae1cf3527e1$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $0e147ae1cf3527e1$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $0e147ae1cf3527e1$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $0e147ae1cf3527e1$export$8910bf86027fe6be;
(function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
})($0e147ae1cf3527e1$export$8910bf86027fe6be || ($0e147ae1cf3527e1$export$8910bf86027fe6be = {}));
var $0e147ae1cf3527e1$export$60831686b0574c86;
(function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
})($0e147ae1cf3527e1$export$60831686b0574c86 || ($0e147ae1cf3527e1$export$60831686b0574c86 = {}));
var $0e147ae1cf3527e1$export$d58e6377644d1dcf;
(function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
})($0e147ae1cf3527e1$export$d58e6377644d1dcf || ($0e147ae1cf3527e1$export$d58e6377644d1dcf = {}));
var $0e147ae1cf3527e1$export$51f13ced115cbdae;
(function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
})($0e147ae1cf3527e1$export$51f13ced115cbdae || ($0e147ae1cf3527e1$export$51f13ced115cbdae = {}));
var $0e147ae1cf3527e1$export$61cff06be26816f;
(function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
})($0e147ae1cf3527e1$export$61cff06be26816f || ($0e147ae1cf3527e1$export$61cff06be26816f = {}));
var $0e147ae1cf3527e1$export$aed0f1e801ad691f;
(function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
})($0e147ae1cf3527e1$export$aed0f1e801ad691f || ($0e147ae1cf3527e1$export$aed0f1e801ad691f = {}));
var $0e147ae1cf3527e1$export$9aafec380d7005da;
(function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
})($0e147ae1cf3527e1$export$9aafec380d7005da || ($0e147ae1cf3527e1$export$9aafec380d7005da = {}));
var $0e147ae1cf3527e1$export$19c60054ee783de6;
(function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
})($0e147ae1cf3527e1$export$19c60054ee783de6 || ($0e147ae1cf3527e1$export$19c60054ee783de6 = {}));
var $0e147ae1cf3527e1$export$d65b168331104a46;
(function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
})($0e147ae1cf3527e1$export$d65b168331104a46 || ($0e147ae1cf3527e1$export$d65b168331104a46 = {}));
var $0e147ae1cf3527e1$export$9c95d6e1614bad84;
(function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-8954 Internal documentation for deprecation (no external access)}
	 */ ActionName["ViewAction"] = "ViewAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
})($0e147ae1cf3527e1$export$9c95d6e1614bad84 || ($0e147ae1cf3527e1$export$9c95d6e1614bad84 = {}));
var $0e147ae1cf3527e1$export$4871a84b35cf8eb9;
(function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
})($0e147ae1cf3527e1$export$4871a84b35cf8eb9 || ($0e147ae1cf3527e1$export$4871a84b35cf8eb9 = {}));
var $0e147ae1cf3527e1$export$13ff1290a9e22e77;
(function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
})($0e147ae1cf3527e1$export$13ff1290a9e22e77 || ($0e147ae1cf3527e1$export$13ff1290a9e22e77 = {}));
var $0e147ae1cf3527e1$export$483c11740a902fcd;
(function(MediaType) {
    MediaType["Image"] = "image";
})($0e147ae1cf3527e1$export$483c11740a902fcd || ($0e147ae1cf3527e1$export$483c11740a902fcd = {}));
var $0e147ae1cf3527e1$export$f9f4737e25ab90fa;
(function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
})($0e147ae1cf3527e1$export$f9f4737e25ab90fa || ($0e147ae1cf3527e1$export$f9f4737e25ab90fa = {}));
var $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804;
(function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
})($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 || ($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 = {}));

});

parcelRegister("dB5lQ", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $b34c0ba6cc99590f$export$38d755f52cdf4acb);

var $4DxpJ = parcelRequire("4DxpJ");
const $b34c0ba6cc99590f$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $4DxpJ.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});


parcelRegister("5fK3A", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $f12ece06a3bad4f3$export$4f3ffbb500daac5a);
const $f12ece06a3bad4f3$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});


parcelRegister("ibKIt", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $b8e0945b17791722$export$f7c340395f31e832);

var $eUqFw = parcelRequire("eUqFw");

var $6Y4Ff = parcelRequire("6Y4Ff");

var $gqldc = parcelRequire("gqldc");

var $6EHO5 = parcelRequire("6EHO5");

var $269iK = parcelRequire("269iK");

var $caOA9 = parcelRequire("caOA9");

var $af6S8 = parcelRequire("af6S8");

var $3SJS1 = parcelRequire("3SJS1");
const $b8e0945b17791722$export$f7c340395f31e832 = (id, url, analytics)=>{
    const resolveUrl = (0, $af6S8.default)();
    const invokeClientAction = (0, $3SJS1.default)({
        analytics: analytics
    });
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eUqFw.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $caOA9.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eUqFw.useCallback)((metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eUqFw.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $269iK.getDefinitionId)(details);
        if (definitionId) (0, $269iK.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eUqFw.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eUqFw.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $269iK.getDefinitionId)(details);
        const extensionKey = (0, $269iK.getExtensionKey)(details);
        const services = (0, $269iK.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') analytics.ui.authEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (status === 'forbidden') analytics.ui.authAlternateAccountEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (services.length > 0) {
            analytics.screen.authPopupEvent({
                definitionId: definitionId,
                extensionKey: extensionKey
            });
            (0, $6Y4Ff.auth)(services[0].url).then(()=>{
                analytics.track.appAccountConnected({
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                analytics.operational.connectSucceededEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            }, (err)=>{
                analytics.operational.connectFailedEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    reason: err.type
                });
                if (err.type === 'auth_window_closed') analytics.ui.closedAuthEvent({
                    display: appearance,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        analytics.ui,
        analytics.screen,
        analytics.track,
        analytics.operational,
        id,
        reload
    ]);
    const invoke = (0, $eUqFw.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("6Y4Ff", function(module, exports) {

$parcel$export(module.exports, "auth", () => $f8e4a233562063a8$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("dCD3m")).AuthError);

var $dCD3m = parcelRequire("dCD3m");

var $aMNE6 = parcelRequire("aMNE6");
function $f8e4a233562063a8$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $aMNE6.isOfTypeAuthError)(errorType)) reject(new (0, $dCD3m.AuthError)(data.message, errorType));
                    else reject(new (0, $dCD3m.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $dCD3m.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("dCD3m", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0d7f9acb0a73d09c$export$145273558d58e0ac);
class $0d7f9acb0a73d09c$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message);
        this.message = message;
        this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("aMNE6", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $7b1b7575975439b3$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $7b1b7575975439b3$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("af6S8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997c27397645ece$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2cI4y = parcelRequire("2cI4y");

var $caOA9 = parcelRequire("caOA9");

var $gqldc = parcelRequire("gqldc");

var $fQBSX = parcelRequire("fQBSX");
const $2997c27397645ece$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $fQBSX.default)();
    return (0, $eUqFw.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $2cI4y.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $2997c27397645ece$export$2e2bcd8739ae039 = $2997c27397645ece$var$useResolve;

});
parcelRegister("fQBSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1d36093d90197e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6EHO5 = parcelRequire("6EHO5");
var $f9yXU = parcelRequire("f9yXU");
var $4hPjC = parcelRequire("4hPjC");

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");


var $lEfVV = parcelRequire("lEfVV");

var $gqldc = parcelRequire("gqldc");
const $ae1d36093d90197e$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eUqFw.useCallback)((url, metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eUqFw.useCallback)((url, error, response, isMetadataRequest)=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If there's no previous data in the store for this URL, then bail
            // out and let the editor handle fallbacks (returns to a blue link).
            if (!hasData && status !== 'resolved') {
                dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
                url: url
            }, details));
        // Handle AuthErrors (user did not have access to resource) -
        // Missing AAID in ASAP claims, or missing UserContext, or 403 from downstream
        } else if (error.kind === 'auth') dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: url
        }, (0, $7pH5u.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4hPjC.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fallback', hostname, (0, $30e664360e28092c$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fatal', hostname, (0, $30e664360e28092c$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('error', hostname, (0, $30e664360e28092c$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $lEfVV.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $ae1d36093d90197e$export$2e2bcd8739ae039 = $ae1d36093d90197e$var$useResponse;

});
parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("7pH5u", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $c6847fc9d6f0df43$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $c6847fc9d6f0df43$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $c6847fc9d6f0df43$export$e32193033a594efb);
const $c6847fc9d6f0df43$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $c6847fc9d6f0df43$export$2796a804c6e44f63 = ()=>$c6847fc9d6f0df43$var$emptyData;
const $c6847fc9d6f0df43$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });
const $c6847fc9d6f0df43$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });

});

const $30e664360e28092c$export$297c39c8b9bfca0 = 'resolving';
const $30e664360e28092c$export$b64a888338c24e0e = 'errored';
const $30e664360e28092c$export$677b6edfa0002c70 = 'fallback';
const $30e664360e28092c$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $30e664360e28092c$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $30e664360e28092c$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("3SJS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a127f233fa1a4ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $2cI4y = parcelRequire("2cI4y");
const $5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $5a127f233fa1a4ad$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $eUqFw.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $hEsGF.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $2cI4y.startUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            analytics?.ui.actionClickedEvent({
                actionType: actionType,
                display: display
            });
            // Invoke action
            const result = await actionFn();
            $hEsGF.mark(markName, 'resolved');
            (0, $2cI4y.succeedUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            analytics?.operational.invokeSucceededEvent({
                actionType: actionType,
                display: display
            });
            return result;
        } catch (err) {
            $hEsGF.mark(markName, 'errored');
            (0, $2cI4y.failUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            analytics?.operational.invokeFailedEvent({
                actionType: actionType,
                display: display,
                reason: reason
            });
        }
    }, [
        analytics?.operational,
        analytics?.ui
    ]);
var $5a127f233fa1a4ad$export$2e2bcd8739ae039 = $5a127f233fa1a4ad$var$useInvokeClientAction;

});


parcelRegister("b81Yi", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $e9516c66fbd4716f$export$b0444d00ba7313c6);

var $awFmn = parcelRequire("awFmn");

var $gqldc = parcelRequire("gqldc");
const $e9516c66fbd4716f$var$PENDING_STATE = {
    status: 'pending'
};
function $e9516c66fbd4716f$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const cardState = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $e9516c66fbd4716f$var$PENDING_STATE;
}

});


parcelRegister("4XjK2", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $eea7a418db70e1c9$export$c3514c024fefef57);

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");
const $eea7a418db70e1c9$export$c3514c024fefef57 = ()=>{
    const context = (0, $gqldc.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eUqFw.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("3miv3", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $14e6c0cc2f6d2356$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $14e6c0cc2f6d2356$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $XHGTv = parcelRequire("XHGTv");

var $byn9U = parcelRequire("byn9U");

var $bFzGY = parcelRequire("bFzGY");

var $dmCPj = parcelRequire("dmCPj");

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");

var $caOA9 = parcelRequire("caOA9");

var $jtkmg = parcelRequire("jtkmg");

var $269iK = parcelRequire("269iK");

var $9A6mL = parcelRequire("9A6mL");

var $lVbJo = parcelRequire("lVbJo");

var $crquY = parcelRequire("crquY");

var $85lvj = parcelRequire("85lvj");

var $2v0K6 = parcelRequire("2v0K6");

var $iWhYa = parcelRequire("iWhYa");

var $jVUJM = parcelRequire("jVUJM");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $lyAeo = parcelRequire("lyAeo");

var $b81Yi = parcelRequire("b81Yi");

var $Ur3CB = parcelRequire("Ur3CB");

var $NJTzu = parcelRequire("NJTzu");

var $hZwiw = parcelRequire("hZwiw");
const $14e6c0cc2f6d2356$export$34883cbaea18402d = 'smart-links-hover-preview';
const $14e6c0cc2f6d2356$export$aa00abb0c6c1741e = (url)=>({
        name: (0, $caOA9.ActionName).CustomAction,
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "copy url",
            size: "medium"
        }),
        iconPosition: 'before',
        onClick: async ()=>await navigator.clipboard.writeText(url),
        tooltipMessage: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).copy_url_to_clipboard),
        testId: 'hover-card-copy-button'
    });
const $14e6c0cc2f6d2356$var$HoverCardContent = ({ id: id = '', analytics: _analytics, cardActions: cardActions = [], cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const defaultAnalytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const analytics = _analytics ?? defaultAnalytics;
    const extensionKey = (0, $eUqFw.useMemo)(()=>(0, $269iK.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $b81Yi.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $hZwiw.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $269iK.getServices)(linkState.details);
    const statusRef = (0, $eUqFw.useRef)(linkStatus);
    const analyticsRef = (0, $eUqFw.useRef)(analytics);
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Must access current analytics object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (analyticsRef.current !== analytics) analyticsRef.current = analytics;
        if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
    }, [
        analytics,
        linkStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        analyticsRef.current.ui.hoverCardViewedEvent({
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            status: statusRef.current
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            analyticsRef.current.ui.hoverCardDismissedEvent({
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                status: statusRef.current
            });
        };
    }, []);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $9A6mL.isSpecialEvent)(event);
        analytics.ui.cardClickedEvent({
            id: id,
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            status: cardState.status,
            isModifierKeyPressed: isModifierKeyPressed,
            actionSubjectId: 'titleGoToLink'
        });
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        cardState.status,
        analytics.ui,
        id
    ]);
    const titleActions = (0, $eUqFw.useMemo)(()=>[
            $14e6c0cc2f6d2356$export$aa00abb0c6c1741e(url)
        ], [
        url
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $crquY.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        actions: (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? undefined : titleActions,
        maxLines: titleMaxLines,
        overrideCss: (0, $lVbJo.titleBlockCss),
        size: (0, $caOA9.SmartLinkSize).Large,
        position: (0, $caOA9.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const flexibleCardProps = {
        appearance: (0, $caOA9.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        ui: (0, $lVbJo.flexibleUiOptions),
        url: url,
        children: null,
        analytics: analytics
    };
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $85lvj.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2v0K6.default), {
            analytics: analytics,
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $Ur3CB.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') {
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jVUJM.default), {
                analytics: analytics,
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps,
                url: url
            });
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iWhYa.default), {
                id: id,
                url: url,
                extensionKey: extensionKey,
                analytics: analytics,
                cardActions: cardActions,
                cardState: cardState,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
        }
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $NJTzu.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url
    }, cardView) : null;
};
var $14e6c0cc2f6d2356$export$2e2bcd8739ae039 = $14e6c0cc2f6d2356$var$HoverCardContent;

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8v11zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 018 19.008V7.992z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13H5zm2 0h8V5H7v11z"/></g></svg>`
    }, props));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = $9bab72963b78cefe$var$CopyIcon;
module.exports.default = $9bab72963b78cefe$var$_default;

});

parcelRegister("lVbJo", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $856efd6cf881538e$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $856efd6cf881538e$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $856efd6cf881538e$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $856efd6cf881538e$export$e7cae8c75d768024);
$parcel$export(module.exports, "separatorCss", () => $856efd6cf881538e$export$a967860c7ee2c3e1);
$parcel$export(module.exports, "HoverCardContainer", () => $856efd6cf881538e$export$f57be4bd7a4d32ec);
$parcel$export(module.exports, "titleBlockCss", () => $856efd6cf881538e$export$ec02d9e26e1aed66);
$parcel$export(module.exports, "getTransitionStyles", () => $856efd6cf881538e$export$cfbcd9a4c0ed32ac);
$parcel$export(module.exports, "popupContainerStyles", () => $856efd6cf881538e$export$40ef6bd85f8ebb71);
$parcel$export(module.exports, "getPreviewBlockStyles", () => $856efd6cf881538e$export$190eda52f0eac4c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $caOA9 = parcelRequire("caOA9");

var $lcnyw = parcelRequire("lcnyw");

var $XHGTv = parcelRequire("XHGTv");
function $856efd6cf881538e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $856efd6cf881538e$export$8245b0eaabf3440c = (0, $lcnyw.layers).modal();
const $856efd6cf881538e$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    size: (0, $caOA9.SmartLinkSize).Medium,
    hideHoverCardPreviewButton: false,
    zIndex: $856efd6cf881538e$export$8245b0eaabf3440c + 1
};
const $856efd6cf881538e$export$a0a37c997fbcd678 = 24;
const $856efd6cf881538e$export$337e78d5d001376e = 25;
const $856efd6cf881538e$export$e7cae8c75d768024 = 10;
const $856efd6cf881538e$var$blockGap = '0.5rem';
const $856efd6cf881538e$var$elementGap = '0.5rem';
const $856efd6cf881538e$export$a967860c7ee2c3e1 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-separator] + [data-separator]:before': {
        marginRight: $856efd6cf881538e$var$elementGap
    }
});
const $856efd6cf881538e$export$f57be4bd7a4d32ec = /*#__PURE__*/ (0, $byn9U.css)("background:none;border-width:0;box-sizing:border-box;width:", (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') ? $856efd6cf881538e$export$337e78d5d001376e : $856efd6cf881538e$export$a0a37c997fbcd678, "rem;.", (0, $02e88e077d3b3f54$export$4b2b7d155f69aed4), "{display:none;}");
const $856efd6cf881538e$export$ec02d9e26e1aed66 = /*#__PURE__*/ (0, $byn9U.css)("gap:", $856efd6cf881538e$var$blockGap, ";", $856efd6cf881538e$export$a967860c7ee2c3e1, "[data-smart-element-group]{gap:0.06rem;display:flex;>[data-smart-element-group]{>span{margin-right:", $856efd6cf881538e$var$elementGap, ";}}}[data-smart-element='Title']{font-weight:600;}");
const $856efd6cf881538e$export$cfbcd9a4c0ed32ac = (snippetHeight)=>/*#__PURE__*/ (0, $byn9U.css)({
        transition: 'height 300ms ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${snippetHeight}px`
    });
const $856efd6cf881538e$export$40ef6bd85f8ebb71 = {
    name: "kq493r",
    styles: "border-radius:var(--ds-border-radius-200, 8px);background-color:var(--ds-surface-overlay, white);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))"
};
const $856efd6cf881538e$export$190eda52f0eac4c = (previewHeight)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)(previewHeight ? `height: ${previewHeight}px;` : '', {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        marginBottom: $856efd6cf881538e$var$blockGap
    });

});
const $02e88e077d3b3f54$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("crquY", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $9575c987ee374080$export$8548546c0aa631e6);

var $caOA9 = parcelRequire("caOA9");

var $4yj9H = parcelRequire("4yj9H");

var $fmv4j = parcelRequire("fmv4j");

var $XHGTv = parcelRequire("XHGTv");
const $9575c987ee374080$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $4yj9H.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $caOA9.ElementName).AuthorGroup,
            (0, $caOA9.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn,
                    (0, $caOA9.ElementName).SubscriberCount,
                    (0, $caOA9.ElementName).State
                ],
                subtitle: [
                    (0, $caOA9.ElementName).SourceBranch,
                    (0, $caOA9.ElementName).TargetBranch
                ]
            };
            if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.extractor.improve-bitbucket-file-links') && types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $caOA9.ElementName).LatestCommit,
                    (0, $caOA9.ElementName).CollaboratorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $fmv4j.extractOwnedBy)(data) ? (0, $caOA9.ElementName).OwnedByGroup : (0, $caOA9.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $caOA9.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount,
                    (0, $caOA9.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $caOA9.ElementName).AssignedToGroup,
                        (0, $caOA9.ElementName).State,
                        (0, $caOA9.ElementName).StoryPoints,
                        (0, $caOA9.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).CollaboratorGroup,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ],
                secondary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount,
                    (0, $caOA9.ElementName).AttachmentCount,
                    (0, $caOA9.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $caOA9.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).SentOn
                ],
                tertiary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $9575c987ee374080$var$AvatarGroupsWithNamePrefix = [
    (0, $caOA9.ElementName).AssignedToGroup,
    (0, $caOA9.ElementName).OwnedByGroup,
    (0, $caOA9.ElementName).AuthorGroup
];
const $9575c987ee374080$var$toElementItem = (name)=>{
    const showNamePrefix = $9575c987ee374080$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $9575c987ee374080$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $caOA9.ElementName)).map($9575c987ee374080$var$toElementItem);
};
const $9575c987ee374080$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $9575c987ee374080$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? [].concat(metadata.primary, metadata.tertiary) : metadata.primary;
    // `tertiary` should be removed completely during cleanup:
    // https://product-fabric.atlassian.net/browse/EDM-9556
    const tertiary = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? undefined : metadata.tertiary;
    return {
        subtitle: $9575c987ee374080$var$toElementItems(metadata.subtitle),
        primary: $9575c987ee374080$var$toElementItems(primary),
        secondary: $9575c987ee374080$var$toElementItems(metadata.secondary),
        tertiary: $9575c987ee374080$var$toElementItems(tertiary)
    };
};

});
parcelRegister("fmv4j", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $469a01a9f706d88b$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractDueOn", () => $469a01a9f706d88b$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $469a01a9f706d88b$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $469a01a9f706d88b$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $469a01a9f706d88b$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $469a01a9f706d88b$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $469a01a9f706d88b$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $469a01a9f706d88b$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $469a01a9f706d88b$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $469a01a9f706d88b$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $469a01a9f706d88b$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $469a01a9f706d88b$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $469a01a9f706d88b$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $469a01a9f706d88b$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $469a01a9f706d88b$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $469a01a9f706d88b$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $469a01a9f706d88b$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $469a01a9f706d88b$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $469a01a9f706d88b$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $469a01a9f706d88b$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $469a01a9f706d88b$export$bdcea84d1550eb9d);

var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $gd1O9 = parcelRequire("gd1O9");
const $469a01a9f706d88b$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $469a01a9f706d88b$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $469a01a9f706d88b$export$b68822b76d5d51d5 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:commentCount');
const $469a01a9f706d88b$export$ac56bd7a37249b48 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'endTime');
const $469a01a9f706d88b$export$e57334ce4738e29d = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:viewCount');
const $469a01a9f706d88b$export$44130aa92252501 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:reactCount');
const $469a01a9f706d88b$export$c8bef3d5e550a3a = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:voteCount');
const $469a01a9f706d88b$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $dMa80.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$5546969a505305 = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $469a01a9f706d88b$export$69b10d653f96288b = (data)=>{
    const persons = (0, $c8AiI.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $gd1O9.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$43e54589935a1ff = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:programmingLanguage');
const $469a01a9f706d88b$export$949ac6a8325b3fdb = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeSource']);
const $469a01a9f706d88b$export$8bd03a7beb5badf1 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:subscriberCount');
const $469a01a9f706d88b$export$65362ff78a97fd8 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:attachmentCount');
const $469a01a9f706d88b$export$29b0ac5d2f9890cf = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeDestination']);
const $469a01a9f706d88b$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $469a01a9f706d88b$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $469a01a9f706d88b$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $469a01a9f706d88b$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $469a01a9f706d88b$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $469a01a9f706d88b$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $469a01a9f706d88b$export$cc4028b2878d0675 = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $469a01a9f706d88b$export$b592ddecae70b61d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'dateSent');
};
const $469a01a9f706d88b$export$bdcea84d1550eb9d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("dMa80", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $ce0e432e194a4e67$export$19ee667f3f7a6ec3);

var $3gIUj = parcelRequire("3gIUj");
const $ce0e432e194a4e67$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("85lvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $192f1cc4566d6a7d$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $8SIiI = parcelRequire("8SIiI");

var $lVbJo = parcelRequire("lVbJo");

var $fCD0G = parcelRequire("fCD0G");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $c2pJy = parcelRequire("c2pJy");
const $192f1cc4566d6a7d$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $lVbJo.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $fCD0G.loadingViewContainer),
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $fCD0G.skeletonContainer)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...titleBlockProps,
        overrideCss: (0, $fCD0G.titleBlockStyles),
        testId: `${testId}-title-block`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $c2pJy.default), {
        render: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), null),
        size: size
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $fCD0G.getTitleStyles)(lineHeightRem),
        "data-testid": `${testId}-title`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        height: lineHeightRem
    })), actionGroup), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem * 3
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem
    }))));
};
var $192f1cc4566d6a7d$export$2e2bcd8739ae039 = $192f1cc4566d6a7d$var$HoverCardLoadingView;

});
parcelRegister("8SIiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9060a2498f61f4f2$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $9060a2498f61f4f2$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $byn9U.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $9060a2498f61f4f2$export$2e2bcd8739ae039 = $9060a2498f61f4f2$var$LoadingSkeleton;

});

parcelRegister("fCD0G", function(module, exports) {

$parcel$export(module.exports, "loadingViewContainer", () => $de7116d5503ac50c$export$a470e5777446b28);
$parcel$export(module.exports, "skeletonContainer", () => $de7116d5503ac50c$export$e39e8873928166f5);
$parcel$export(module.exports, "getTitleStyles", () => $de7116d5503ac50c$export$83146cf7d1bec659);
$parcel$export(module.exports, "titleBlockStyles", () => $de7116d5503ac50c$export$38125fa6916f5dab);

var $byn9U = parcelRequire("byn9U");
function $de7116d5503ac50c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de7116d5503ac50c$export$a470e5777446b28 = {
    name: "vl4r61",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-200, 1rem)"
};
const $de7116d5503ac50c$export$e39e8873928166f5 = {
    name: "m407pt",
    styles: "display:flex;flex-direction:column;gap:0.625rem;align-items:center"
};
const $de7116d5503ac50c$export$83146cf7d1bec659 = (height)=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        flex: '1 0 auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            width: '100%'
        }
    });
};
const $de7116d5503ac50c$export$38125fa6916f5dab = {
    name: "168etio",
    styles: "width:100%;gap:var(--ds-space-100, 0.5rem)"
};

});

parcelRegister("fNWSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b51d5450dd65dfd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $8cU5f = parcelRequire("8cU5f");

var $6OfWd = parcelRequire("6OfWd");

var $caOA9 = parcelRequire("caOA9");

var $7u4fN = parcelRequire("7u4fN");

var $jG1wZ = parcelRequire("jG1wZ");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $avp6V = parcelRequire("avp6V");

var $d2BrZ = parcelRequire("d2BrZ");

var $asu8X = parcelRequire("asu8X");
function $7b51d5450dd65dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b51d5450dd65dfd$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $7b51d5450dd65dfd$var$renderActionItems = (items = [], size = (0, $caOA9.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $avp6V.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7b51d5450dd65dfd$var$ActionGroup = ({ items: items = [], size: size = (0, $caOA9.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $asu8X.di)((0, $6OfWd.default));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const renderableActionItems = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $4z862.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: "more"
            });
            const formatMessage = /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).more_actions);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b51d5450dd65dfd$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, actionButtons, moreActionDropdown)) : null;
};
var $7b51d5450dd65dfd$export$2e2bcd8739ae039 = $7b51d5450dd65dfd$var$ActionGroup;

});
parcelRegister("4z862", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $c5cf90fd8bf8cba5$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $c5cf90fd8bf8cba5$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $c5cf90fd8bf8cba5$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $c5cf90fd8bf8cba5$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidth", () => $c5cf90fd8bf8cba5$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $c5cf90fd8bf8cba5$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $c5cf90fd8bf8cba5$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $c5cf90fd8bf8cba5$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $c5cf90fd8bf8cba5$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $c5cf90fd8bf8cba5$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $c5cf90fd8bf8cba5$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $c5cf90fd8bf8cba5$export$619e376a425cb759);
$parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", () => $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $1csi6 = parcelRequire("1csi6");

var $bYKiA = parcelRequire("bYKiA");
const $c5cf90fd8bf8cba5$export$9d642f65a919fb93 = {
    [(0, $caOA9.SmartLinkSize).Small]: 'none',
    [(0, $caOA9.SmartLinkSize).Medium]: 'compact',
    [(0, $caOA9.SmartLinkSize).Large]: 'compact',
    [(0, $caOA9.SmartLinkSize).XLarge]: 'default'
};
const $c5cf90fd8bf8cba5$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptor,
            values: values
        });
    }
};
const $c5cf90fd8bf8cba5$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $c5cf90fd8bf8cba5$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $c5cf90fd8bf8cba5$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $c5cf90fd8bf8cba5$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $c5cf90fd8bf8cba5$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $c5cf90fd8bf8cba5$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '1.25rem',
                fontWeight: 400,
                letterSpacing: '-0.008em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.875rem',
                fontWeight: 400,
                letterSpacing: '-0.003em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 400,
                letterSpacing: '0em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
    }
};
const $c5cf90fd8bf8cba5$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return 1.75;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $c5cf90fd8bf8cba5$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $c5cf90fd8bf8cba5$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $c5cf90fd8bf8cba5$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $c5cf90fd8bf8cba5$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $byn9U.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $c5cf90fd8bf8cba5$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
const $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
    const icon = {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
            ...linkIcon,
            size: (0, $caOA9.SmartLinkSize).Large
        }),
        isFlexibleUi: true
    };
    return (0, $1csi6.openEmbedModal)({
        ...props,
        icon: icon,
        // Flex should not send origin as block card. It should be able to support
        // its internal parent components like hover card, block card and
        // itself as a standalone. To be investigated and fix in EDM-7520.
        origin: 'smartLinkCard'
    });
};

});
parcelRegister("c2pJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d34755e025af7a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $hUwRB = parcelRequire("hUwRB");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $h0YJD = parcelRequire("h0YJD");

var $2pE6J = parcelRequire("2pE6J");

var $4z862 = parcelRequire("4z862");
function $13d34755e025af7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $13d34755e025af7a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $13d34755e025af7a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $13d34755e025af7a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $caOA9.SmartLinkPosition).Center:
            return $13d34755e025af7a$var$_ref2;
        case (0, $caOA9.SmartLinkPosition).Top:
        default:
            return $13d34755e025af7a$var$_ref;
    }
};
const $13d34755e025af7a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)($13d34755e025af7a$var$getPositionStyles(position), (0, $4z862.getIconSizeStyles)(width));
const $13d34755e025af7a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $4z862.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $13d34755e025af7a$var$renderAtlaskitIcon = (icon, label, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        label: label,
        testId: `${testId}-icon`
    });
};
const $13d34755e025af7a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        label: label,
        testId: `${testId}-default`
    });
const $13d34755e025af7a$var$renderImageIcon = (defaultIcon, url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $13d34755e025af7a$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $caOA9.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $eUqFw.useMemo)(()=>{
        const defaultIcon = $13d34755e025af7a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $13d34755e025af7a$var$renderImageIcon(defaultIcon, url, testId) || $13d34755e025af7a$var$renderAtlaskitIcon(icon, label, testId) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url
    ]);
    const width = (0, $4z862.getIconWidth)(size);
    const styles = $13d34755e025af7a$var$getIconStyles(position, width);
    const renderStyles = render ? $13d34755e025af7a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
        css: [
            styles,
            renderStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, element);
};
var $13d34755e025af7a$export$2e2bcd8739ae039 = $13d34755e025af7a$var$Icon;

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = $d0a128a0d80d703a$var$LinkIcon;
module.exports.default = $d0a128a0d80d703a$var$_default;

});

parcelRegister("h0YJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7df94b43718706$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $PdmhA = parcelRequire("PdmhA");

var $5KT10 = parcelRequire("5KT10");
var $77CtJ = parcelRequire("77CtJ");

var $33pqc = parcelRequire("33pqc");

var $42mVw = parcelRequire("42mVw");

var $caOA9 = parcelRequire("caOA9");





























































// prettier-ignore
const $bc7df94b43718706$var$importIconMapper = {
    [(0, $caOA9.IconType).Archive]: ()=>(parcelRequire("1SSFi")),
    [(0, $caOA9.IconType).Audio]: ()=>(parcelRequire("kOBr9")),
    [(0, $caOA9.IconType).Code]: ()=>(parcelRequire("3Odf5")),
    [(0, $caOA9.IconType).Executable]: ()=>(parcelRequire("5KraK")),
    [(0, $caOA9.IconType).File]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $caOA9.IconType).Folder]: ()=>(parcelRequire("5Gpyh")),
    [(0, $caOA9.IconType).Generic]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $caOA9.IconType).GIF]: ()=>(parcelRequire("cVIlt")),
    [(0, $caOA9.IconType).GoogleDocs]: ()=>(parcelRequire("aWo98")),
    [(0, $caOA9.IconType).GoogleForms]: ()=>(parcelRequire("hgXDP")),
    [(0, $caOA9.IconType).GoogleSheets]: ()=>(parcelRequire("68kEB")),
    [(0, $caOA9.IconType).GoogleSlides]: ()=>(parcelRequire("dlbJ3")),
    [(0, $caOA9.IconType).Image]: ()=>(parcelRequire("8JPzk")),
    [(0, $caOA9.IconType).MSExcel]: ()=>(parcelRequire("pNNfx")),
    [(0, $caOA9.IconType).MSPowerpoint]: ()=>(parcelRequire("fqpGs")),
    [(0, $caOA9.IconType).MSWord]: ()=>(parcelRequire("5hO6q")),
    [(0, $caOA9.IconType).PDF]: ()=>(parcelRequire("3kV6m")),
    [(0, $caOA9.IconType).Presentation]: ()=>Promise.resolve((parcelRequire("iIEQk"))),
    [(0, $caOA9.IconType).Sketch]: ()=>(parcelRequire("gwQvz")),
    [(0, $caOA9.IconType).Spreadsheet]: ()=>Promise.resolve((parcelRequire("kaVAc"))),
    [(0, $caOA9.IconType).Template]: ()=>Promise.resolve((parcelRequire("nzdI3"))),
    [(0, $caOA9.IconType).Video]: ()=>(parcelRequire("4BViP")),
    // Bitbucket icons
    [(0, $caOA9.IconType).Branch]: ()=>Promise.resolve((parcelRequire("gQa4O"))),
    [(0, $caOA9.IconType).Commit]: ()=>Promise.resolve((parcelRequire("fU2qj"))),
    [(0, $caOA9.IconType).Project]: ()=>Promise.resolve((parcelRequire("iwsIy"))),
    [(0, $caOA9.IconType).PullRequest]: ()=>Promise.resolve((parcelRequire("6VQ7Z"))),
    [(0, $caOA9.IconType).Repo]: ()=>Promise.resolve((parcelRequire("egbU6"))),
    // Jira icons
    [(0, $caOA9.IconType).Bug]: ()=>Promise.resolve((parcelRequire("3YEb9"))),
    [(0, $caOA9.IconType).Change]: ()=>Promise.resolve((parcelRequire("fsJVW"))),
    [(0, $caOA9.IconType).Epic]: ()=>Promise.resolve((parcelRequire("gFrvj"))),
    [(0, $caOA9.IconType).Incident]: ()=>Promise.resolve((parcelRequire("bJZ7m"))),
    [(0, $caOA9.IconType).Problem]: ()=>Promise.resolve((parcelRequire("5cywL"))),
    [(0, $caOA9.IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("2NYtj"))),
    [(0, $caOA9.IconType).Story]: ()=>Promise.resolve((parcelRequire("3Fcny"))),
    [(0, $caOA9.IconType).SubTask]: ()=>Promise.resolve((parcelRequire("aJNc8"))),
    [(0, $caOA9.IconType).Task]: ()=>Promise.resolve((parcelRequire("hiUvC"))),
    // Provider icons
    [(0, $caOA9.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("5KT10"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $caOA9.IconType).Jira]: ()=>Promise.resolve((parcelRequire("77CtJ"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $caOA9.IconType).Default]: ()=>Promise.resolve((parcelRequire("hUwRB"))),
    [(0, $caOA9.IconType).Error]: ()=>Promise.resolve((parcelRequire("96IgR"))),
    [(0, $caOA9.IconType).Forbidden]: ()=>(parcelRequire("6lUer")),
    // Badge
    [(0, $caOA9.IconType).Attachment]: ()=>Promise.resolve((parcelRequire("jUThT"))),
    [(0, $caOA9.IconType).CheckItem]: ()=>Promise.resolve((parcelRequire("eRawo"))),
    [(0, $caOA9.IconType).Comment]: ()=>Promise.resolve((parcelRequire("d3vNK"))),
    [(0, $caOA9.IconType).View]: ()=>(parcelRequire("hmLFo")),
    [(0, $caOA9.IconType).React]: ()=>(parcelRequire("j55mI")),
    [(0, $caOA9.IconType).Vote]: ()=>Promise.resolve((parcelRequire("hL0Qd"))),
    [(0, $caOA9.IconType).PriorityBlocker]: ()=>(parcelRequire("dwS3h")),
    [(0, $caOA9.IconType).PriorityCritical]: ()=>(parcelRequire("31xay")),
    [(0, $caOA9.IconType).PriorityHigh]: ()=>(parcelRequire("i9Yk2")),
    [(0, $caOA9.IconType).PriorityHighest]: ()=>(parcelRequire("3Ew0R")),
    [(0, $caOA9.IconType).PriorityLow]: ()=>(parcelRequire("5GRoj")),
    [(0, $caOA9.IconType).PriorityLowest]: ()=>(parcelRequire("K0fRz")),
    [(0, $caOA9.IconType).PriorityMajor]: ()=>(parcelRequire("2lHWV")),
    [(0, $caOA9.IconType).PriorityMedium]: ()=>(parcelRequire("1QjLQ")),
    [(0, $caOA9.IconType).PriorityMinor]: ()=>(parcelRequire("4B1vJ")),
    [(0, $caOA9.IconType).PriorityTrivial]: ()=>(parcelRequire("lMNPH")),
    [(0, $caOA9.IconType).PriorityUndefined]: ()=>(parcelRequire("aH6Tz")),
    [(0, $caOA9.IconType).ProgrammingLanguage]: ()=>Promise.resolve((parcelRequire("2Q5Ee"))),
    [(0, $caOA9.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("4nce6"))),
    [(0, $caOA9.IconType).SubTasksProgress]: ()=>(parcelRequire("km3FZ"))
};
const $bc7df94b43718706$var$getIconImportFn = (icon)=>$bc7df94b43718706$var$importIconMapper[icon];
const $bc7df94b43718706$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $bc7df94b43718706$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $caOA9.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: label || 'document',
                testId: testId
            });
        case (0, $caOA9.IconType).Blog:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: label || 'blog',
                testId: testId
            });
    }
    const importFn = $bc7df94b43718706$var$getIconImportFn(icon);
    if (!importFn) return null;
    const ImportedIcon = $bc7df94b43718706$var$importIcon(importFn);
    switch(icon){
        case (0, $caOA9.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Error:
        case (0, $caOA9.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId
            });
    }
};
var $bc7df94b43718706$export$2e2bcd8739ae039 = $bc7df94b43718706$var$AtlaskitIcon;

});
parcelRegister("6lUer", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l5Ls8');
        const value = parcelRequire('f4A0J');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l5Ls8").then(()=>parcelRequire('f4A0J'));
}

});

parcelRegister("hmLFo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('NpdOV');
        const value = parcelRequire('jHMvH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("NpdOV").then(()=>parcelRequire('jHMvH'));
}

});

parcelRegister("j55mI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('YPDkL');
        const value = parcelRequire('fvQWm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("YPDkL").then(()=>parcelRequire('fvQWm'));
}

});

parcelRegister("dwS3h", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kvwg1');
        const value = parcelRequire('8nY6X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kvwg1").then(()=>parcelRequire('8nY6X'));
}

});

parcelRegister("31xay", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('yTwnW');
        const value = parcelRequire('eIr2t');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("yTwnW").then(()=>parcelRequire('eIr2t'));
}

});

parcelRegister("i9Yk2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9yvg0');
        const value = parcelRequire('hRYdU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9yvg0").then(()=>parcelRequire('hRYdU'));
}

});

parcelRegister("3Ew0R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ebVzT');
        const value = parcelRequire('gSFPI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ebVzT").then(()=>parcelRequire('gSFPI'));
}

});

parcelRegister("5GRoj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aRCDF');
        const value = parcelRequire('h0cb1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aRCDF").then(()=>parcelRequire('h0cb1'));
}

});

parcelRegister("K0fRz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9VtCD');
        const value = parcelRequire('k3ak7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9VtCD").then(()=>parcelRequire('k3ak7'));
}

});

parcelRegister("2lHWV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2bZsf');
        const value = parcelRequire('7JgHV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2bZsf").then(()=>parcelRequire('7JgHV'));
}

});

parcelRegister("1QjLQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fNIof');
        const value = parcelRequire('fQ2EI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fNIof").then(()=>parcelRequire('fQ2EI'));
}

});

parcelRegister("4B1vJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hK23s');
        const value = parcelRequire('1psqr');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hK23s").then(()=>parcelRequire('1psqr'));
}

});

parcelRegister("lMNPH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('k2MLG');
        const value = parcelRequire('cLW4D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("k2MLG").then(()=>parcelRequire('cLW4D'));
}

});

parcelRegister("aH6Tz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l1hYo');
        const value = parcelRequire('eQuyQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l1hYo").then(()=>parcelRequire('eQuyQ'));
}

});

parcelRegister("km3FZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kr06K');
        const value = parcelRequire('eyI8O');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kr06K").then(()=>parcelRequire('eyI8O'));
}

});


parcelRegister("2pE6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d21a9774b5a2f1e$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cRPaW = parcelRequire("cRPaW");

var $8SIiI = parcelRequire("8SIiI");
const $6d21a9774b5a2f1e$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loading: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
            testId: `${testId}-loading`
        }),
        loaded: /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $6d21a9774b5a2f1e$export$2e2bcd8739ae039 = $6d21a9774b5a2f1e$var$ImageIcon;

});
parcelRegister("cRPaW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95e221a7f9807f92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $95e221a7f9807f92$var$React = $95e221a7f9807f92$var$_interopRequireWildcard($eUqFw);
function $95e221a7f9807f92$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $95e221a7f9807f92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95e221a7f9807f92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95e221a7f9807f92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $95e221a7f9807f92$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $95e221a7f9807f92$var$loaded() {
    return {
        isLoaded: true
    };
}
function $95e221a7f9807f92$var$errored() {
    return {
        isErrored: true
    };
}
function $95e221a7f9807f92$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $95e221a7f9807f92$var$ImageRenderer = function(_React$Component) {
    $95e221a7f9807f92$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $95e221a7f9807f92$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95e221a7f9807f92$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $95e221a7f9807f92$var$_possibleConstructorReturn(_this, _ret);
    }
    $95e221a7f9807f92$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(this.props, nextProps)) this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($95e221a7f9807f92$var$React.Component);
module.exports.default = $95e221a7f9807f92$var$ImageRenderer;

});




parcelRegister("4AAjx", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $43db55e8f7afe139$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $43db55e8f7afe139$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$9296fed6018ca95b);
$parcel$export(module.exports, "useFlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$80b8dfec38d1d85c);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $43db55e8f7afe139$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $43db55e8f7afe139$export$e6b5ad18b56e8f51);

var $eUqFw = parcelRequire("eUqFw");
const $43db55e8f7afe139$export$ca70b164b615de47 = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$61d7957a243df7aa = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$ca70b164b615de47);
const $43db55e8f7afe139$export$9296fed6018ca95b = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$80b8dfec38d1d85c = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$9296fed6018ca95b);
const $43db55e8f7afe139$export$f7433dbd6c50e26a = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$e6b5ad18b56e8f51 = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$f7433dbd6c50e26a);

});

parcelRegister("avp6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $02b4f62361713a29$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $eJljw = parcelRequire("eJljw");
const $02b4f62361713a29$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $eJljw ? $eJljw[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $02b4f62361713a29$export$2e2bcd8739ae039 = $02b4f62361713a29$var$ActionGroupItem;

});
parcelRegister("eJljw", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("lLAmK")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("6fkrT")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("gui89")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("daPVN")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("iY7WF")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("dDX5p")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("8TjUj")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("e5u7V")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("9QQRq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9razy")).default);

var $lLAmK = parcelRequire("lLAmK");

var $6fkrT = parcelRequire("6fkrT");

var $gui89 = parcelRequire("gui89");

var $daPVN = parcelRequire("daPVN");

var $iY7WF = parcelRequire("iY7WF");

var $dDX5p = parcelRequire("dDX5p");

var $8TjUj = parcelRequire("8TjUj");

var $e5u7V = parcelRequire("e5u7V");

var $9QQRq = parcelRequire("9QQRq");

var $9razy = parcelRequire("9razy");

});
parcelRegister("lLAmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ab2f99cd527f23$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $27JBd = parcelRequire("27JBd");

var $48lKs = parcelRequire("48lKs");

var $eh8Nz = parcelRequire("eh8Nz");

var $32zsR = parcelRequire("32zsR");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $b5ab2f99cd527f23$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $32zsR.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27JBd.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eh8Nz.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $48lKs.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)(Wrapper, null, button) : button;
};
var $b5ab2f99cd527f23$export$2e2bcd8739ae039 = $b5ab2f99cd527f23$var$Action;

});
parcelRegister("27JBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $885b23cdbf468f5a$export$2e2bcd8739ae039);

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $cVfTe = parcelRequire("cVfTe");
const $885b23cdbf468f5a$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $885b23cdbf468f5a$export$2e2bcd8739ae039 = $885b23cdbf468f5a$var$ActionStackItem;

});
parcelRegister("cVfTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f587baae0a0b39b$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $4z862 = parcelRequire("4z862");

var $32zsR = parcelRequire("32zsR");
const $6f587baae0a0b39b$var$buttonStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $6f587baae0a0b39b$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    // Replace with font token once it becomes stable (currently alpha)
    // font: 'font.body.small',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
});
const $6f587baae0a0b39b$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $4z862.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32zsR.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $6f587baae0a0b39b$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f587baae0a0b39b$var$contentStyles
    }, content)));
};
var $6f587baae0a0b39b$export$2e2bcd8739ae039 = $6f587baae0a0b39b$var$ActionButton;

});
parcelRegister("32zsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdb5dc66621388c$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
const $5cdb5dc66621388c$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $5cdb5dc66621388c$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $5cdb5dc66621388c$var$stackItemIconSizeStyles = (0, $4z862.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5cdb5dc66621388c$var$stackItemIconStyles = /*#__PURE__*/ (0, $byn9U.css)($5cdb5dc66621388c$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $5cdb5dc66621388c$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5cdb5dc66621388c$var$getIconStyles(isDisabled),
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            asStackItemIcon ? $5cdb5dc66621388c$var$stackItemIconStyles : (0, $4z862.getIconSizeStyles)($5cdb5dc66621388c$var$getIconWidth(size))
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $5cdb5dc66621388c$export$2e2bcd8739ae039 = $5cdb5dc66621388c$var$ActionIcon;

});



parcelRegister("48lKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93679c6d64657cb$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7opLA = parcelRequire("7opLA");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
function $e93679c6d64657cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e93679c6d64657cb$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $e93679c6d64657cb$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).Large:
            return iconOnly ? $e93679c6d64657cb$var$_ref : '';
        case (0, $caOA9.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        lineHeight: '1rem'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $e93679c6d64657cb$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eUqFw.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e93679c6d64657cb$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7opLA.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $4z862.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $e93679c6d64657cb$export$2e2bcd8739ae039 = $e93679c6d64657cb$var$ActionButton;

});

parcelRegister("eh8Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b98a59bc5a7d99$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $9A6mL = parcelRequire("9A6mL");
const $b2b98a59bc5a7d99$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $9A6mL.handleOnClick)(onClick),
        testId: testId
    }, content);
var $b2b98a59bc5a7d99$export$2e2bcd8739ae039 = $b2b98a59bc5a7d99$var$ActionDropdownItem;

});


parcelRegister("6fkrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2513bc2d127363c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $jWuk1 = parcelRequire("jWuk1");
const $a2513bc2d127363c$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        ...props
    });
var $a2513bc2d127363c$export$2e2bcd8739ae039 = $a2513bc2d127363c$var$DeleteAction;

});

parcelRegister("gui89", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1b155aa63a7698$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $bZ1Zi = parcelRequire("bZ1Zi");
const $6a1b155aa63a7698$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        ...props
    });
var $6a1b155aa63a7698$export$2e2bcd8739ae039 = $6a1b155aa63a7698$var$EditAction;

});
parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8b96eef1afb7c03f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zm5.921-2.62l-2.12-2.12L16.306 6h.002l2.121 2.121-8.489 8.49zm9.903-9.903l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = $8b96eef1afb7c03f$var$EditIcon;
module.exports.default = $8b96eef1afb7c03f$var$_default;

});


parcelRegister("daPVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5689d24bc37939$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9A6mL = parcelRequire("9A6mL");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $i9nBX = parcelRequire("i9nBX");
const $3f5689d24bc37939$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).DownloadAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data?.downloadUrl) {
            invoke({
                actionType: (0, $caOA9.ActionName).DownloadAction,
                actionFn: async ()=>(0, $9A6mL.downloadUrl)(data?.downloadUrl),
                // These values have already been set in analytics context.
                // We only pass these here for ufo experience.
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }
    }, [
        analytics,
        data?.downloadUrl,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $4abrz.messages).download_file : (0, $4abrz.messages).download;
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).download_description : (0, $4abrz.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $3f5689d24bc37939$export$2e2bcd8739ae039 = $3f5689d24bc37939$var$DownloadAction;

});
parcelRegister("i9nBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d36b61f12f7a705f$var$_react = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d36b61f12f7a705f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d36b61f12f7a705f$var$DownloadIcon = (props)=>/*#__PURE__*/ $d36b61f12f7a705f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M10.687 17.292a.983.983 0 00-1.397 0 1 1 0 000 1.407l1.964 1.98a1.082 1.082 0 001.538 0l1.919-1.933a1 1 0 000-1.408.983.983 0 00-1.398 0l-1.29 1.3-1.336-1.346z" fill-rule="nonzero"/><path d="M13.001 19.993L13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007z" fill-rule="nonzero"/><path d="M7.938 5.48a4.8 4.8 0 00-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 014.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48z"/></g></svg>`
    }, props));
$d36b61f12f7a705f$var$DownloadIcon.displayName = 'DownloadIcon';
var $d36b61f12f7a705f$var$_default = $d36b61f12f7a705f$var$DownloadIcon;
module.exports.default = $d36b61f12f7a705f$var$_default;

});


parcelRegister("iY7WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4000632475db60c8$export$2e2bcd8739ae039);

var $iisnK = parcelRequire("iisnK");

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bPnXx = parcelRequire("bPnXx");

var $b19ph = parcelRequire("b19ph");

var $4z862 = parcelRequire("4z862");

var $5c3rh = parcelRequire("5c3rh");


const $4000632475db60c8$var$importIconMapper = {
    goal: ()=>(parcelRequire("3qTk6")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("gt1na")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $4000632475db60c8$var$getIcon = (stackIconType)=>{
    const importFn = $4000632475db60c8$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $4z862.importIcon)(importFn);
};
const $4000632475db60c8$var$getIconFF = (iconFFEnabled, defaultIcon)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) {
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.action-icon-redesign')) return iconFFEnabled;
    }
    return defaultIcon;
};
const $4000632475db60c8$var$FollowAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $4abrz.messages).follow : (0, $4abrz.messages).unfollow;
    const projectMessage = value ? (0, $4abrz.messages).follow_project : (0, $4abrz.messages).unfollow_project;
    const goalMessage = value ? (0, $4abrz.messages).follow_goal : (0, $4abrz.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $4abrz.messages).follow_project_description : (0, $4abrz.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $4abrz.messages).follow_goal_description : (0, $4abrz.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const icon = value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        label: "Follow"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b19ph.default), {
        label: "Unfollow"
    });
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $4000632475db60c8$var$getIcon(stackIconType);
    const stackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const followIcon = isStackItem ? stackIcon : $4000632475db60c8$var$getIconFF(stackIcon, icon);
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $5c3rh.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPnXx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $4000632475db60c8$export$2e2bcd8739ae039 = $4000632475db60c8$var$FollowAction;

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d51fec82b4cf5254$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="18" y="5" width="2" height="6" rx="1"/><rect x="16" y="7" width="6" height="2" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = $d51fec82b4cf5254$var$InviteTeamIcon;
module.exports.default = $d51fec82b4cf5254$var$_default;

});

parcelRegister("bPnXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee58e6cedb3bfa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fZ5ue = parcelRequire("fZ5ue");

var $8McbT = parcelRequire("8McbT");

var $af6S8 = parcelRequire("af6S8");

var $201mO = parcelRequire("201mO");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");
const $fee58e6cedb3bfa7$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    const reload = (0, $af6S8.default)();
    const handleClick = (0, $eUqFw.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                analytics?.ui.smartLinkServerActionClickedEvent({
                    smartLinkActionType: smartLinkActionType
                });
                analytics?.track.smartLinkQuickActionStarted({
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $201mO.default)(action);
                await invoke(request);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                analytics?.track.smartLinkQuickActionFailed({
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8McbT.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        analytics?.track,
        analytics?.ui,
        invoke,
        onClick,
        onErrorCallback,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $fee58e6cedb3bfa7$export$2e2bcd8739ae039 = $fee58e6cedb3bfa7$var$ServerAction;

});
parcelRegister("fZ5ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $526f1cd6fde31da2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $526f1cd6fde31da2$var$useInvoke = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $526f1cd6fde31da2$export$2e2bcd8739ae039 = $526f1cd6fde31da2$var$useInvoke;

});
parcelRegister("imCrQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $e90617a456d47f08$export$303ede4eed148855);

var $eUqFw = parcelRequire("eUqFw");

var $5LW2w = parcelRequire("5LW2w");

var $cCvxR = parcelRequire("cCvxR");

var $euvAQ = parcelRequire("euvAQ");
const $e90617a456d47f08$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $euvAQ.useResolverUrl)(cardClient);
    const invoke = (0, $eUqFw.useCallback)(async (data)=>{
        try {
            return await (0, $5LW2w.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $cCvxR.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    const relatedUrls = (0, $eUqFw.useCallback)(async (url)=>{
        return await (0, $5LW2w.request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
            'Cache-Control': 'private'
        }, [
            200
        ]);
    }, [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            invoke: invoke,
            relatedUrls: relatedUrls
        }), [
        invoke,
        relatedUrls
    ]);
};

});
parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("euvAQ", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $56f10bb2820b4284$export$d08617a365fbe694);

var $eUqFw = parcelRequire("eUqFw");

var $dUrSu = parcelRequire("dUrSu");
const $56f10bb2820b4284$export$d08617a365fbe694 = (cardClient)=>(0, $eUqFw.useMemo)(()=>(0, $dUrSu.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});




parcelRegister("8McbT", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $1c7a2500ec767744$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $1c7a2500ec767744$export$1694272377fa07d8);

var $bTNMs = parcelRequire("bTNMs");
const $1c7a2500ec767744$export$65b3f792dff0bd60 = (err)=>{
    if (!$1c7a2500ec767744$export$1694272377fa07d8(err)) return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $bTNMs.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    }
};
const $1c7a2500ec767744$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("201mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51aec3ddbd0b82b$export$2e2bcd8739ae039);
const $b51aec3ddbd0b82b$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $b51aec3ddbd0b82b$export$2e2bcd8739ae039 = $b51aec3ddbd0b82b$var$createInvokeRequest;

});


parcelRegister("b19ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a361d745bbd5e91$export$2e2bcd8739ae039);

var $2ziLQ = parcelRequire("2ziLQ");

var $eUqFw = parcelRequire("eUqFw");
const $4a361d745bbd5e91$var$UnfollowGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 4.66667H11.3333C10.9652 4.66667 10.6667 4.96514 10.6667 5.33333C10.6667 5.70152 10.9652 6 11.3333 6H14C14.3682 6 14.6667 5.70152 14.6667 5.33333C14.6667 4.96514 14.3682 4.66667 14 4.66667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.33334 9.33333C3.33334 8.59667 3.93468 8 4.67268 8H9.99401C10.734 8 11.3333 8.596 11.3333 9.33733V12.2973C11.3333 14.5673 3.33334 14.5673 3.33334 12.2973V9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.33334 7.33333C8.8061 7.33333 10 6.13943 10 4.66667C10 3.19391 8.8061 2 7.33334 2C5.86058 2 4.66668 3.19391 4.66668 4.66667C4.66668 6.13943 5.86058 7.33333 7.33334 7.33333Z",
        fill: "currentColor"
    }));
const $4a361d745bbd5e91$var$UnfollowIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $4a361d745bbd5e91$var$UnfollowGlyph,
        ...props
    });
var $4a361d745bbd5e91$export$2e2bcd8739ae039 = $4a361d745bbd5e91$var$UnfollowIcon;

});

parcelRegister("5c3rh", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $caf136fdee970c8a$export$49248678d3914625);

var $4abrz = parcelRequire("4abrz");
const $caf136fdee970c8a$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $4abrz.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $4abrz.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $4abrz.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $4abrz.messages).unfollow_goal_error;
    return (0, $4abrz.messages).generic_error_message;
};

});

parcelRegister("3qTk6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kGvxd');
        const value = parcelRequire('hSFb0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kGvxd").then(()=>parcelRequire('hSFb0'));
}

});

parcelRegister("gt1na", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2WhTq');
        const value = parcelRequire('9dFQg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2WhTq").then(()=>parcelRequire('9dFQg'));
}

});


parcelRegister("dDX5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e249092d4fa8c714$export$2e2bcd8739ae039);

var $cYnD3 = parcelRequire("cYnD3");

var $22LS1 = parcelRequire("22LS1");

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $4z862 = parcelRequire("4z862");

var $lLAmK = parcelRequire("lLAmK");
const $e249092d4fa8c714$var$getIconFF = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) {
        if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.action-icon-redesign')) return 0, (/*@__PURE__*/$parcel$interopDefault($22LS1));
    }
    return 0, (/*@__PURE__*/$parcel$interopDefault($cYnD3));
};
const $e249092d4fa8c714$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).PreviewAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data) invoke({
            actionType: (0, $caOA9.ActionName).PreviewAction,
            actionFn: async ()=>(0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                    download: data?.downloadUrl,
                    extensionKey: analytics?.extensionKey,
                    analytics: analytics,
                    ...data
                }),
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const Icon = isStackItem ? (0, (/*@__PURE__*/$parcel$interopDefault($22LS1))) : $e249092d4fa8c714$var$getIconFF();
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).preview_description : (0, $4abrz.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e249092d4fa8c714$export$2e2bcd8739ae039 = $e249092d4fa8c714$var$PreviewAction;

});
parcelRegister("cYnD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $971d6ad91943ad82$var$_react = $971d6ad91943ad82$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $971d6ad91943ad82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $971d6ad91943ad82$var$VidFullScreenOnIcon = (props)=>/*#__PURE__*/ $971d6ad91943ad82$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 18h3a1 1 0 010 2H6a2 2 0 01-2-2v-3a1 1 0 012 0v3zm12 2h-3a1 1 0 010-2h3v-3a1 1 0 012 0v3a2 2 0 01-2 2zM6 4h3a1 1 0 110 2H6v3a1 1 0 11-2 0V6a2 2 0 012-2zm12 2h-3a1 1 0 010-2h3a2 2 0 012 2v3a1 1 0 01-2 0V6z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$971d6ad91943ad82$var$VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var $971d6ad91943ad82$var$_default = $971d6ad91943ad82$var$VidFullScreenOnIcon;
module.exports.default = $971d6ad91943ad82$var$_default;

});


parcelRegister("8TjUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2597fe5d03e9fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $hUwRB = parcelRequire("hUwRB");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $3SJS1 = parcelRequire("3SJS1");
const $8c2597fe5d03e9fc$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_url_to_clipboard);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data && data.url) invoke({
            actionType: (0, $caOA9.ActionName).CopyLinkAction,
            actionFn: async ()=>{
                await navigator.clipboard.writeText(data.url ?? '');
                setTooltipMessage((0, $4abrz.messages).copied_url_to_clipboard);
            },
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            label: "copy url",
            size: "medium"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $8c2597fe5d03e9fc$export$2e2bcd8739ae039 = $8c2597fe5d03e9fc$var$CopyLinkAction;

});

parcelRegister("e5u7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $911fbb2dd20043a1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $47wdF = parcelRequire("47wdF");
const $911fbb2dd20043a1$var$AISummaryAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47wdF.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $911fbb2dd20043a1$export$2e2bcd8739ae039 = $911fbb2dd20043a1$var$AISummaryAction;

});
parcelRegister("47wdF", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b6dae4aa0e47e00e$export$8eed96bc6d982595);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $04PAQ = parcelRequire("04PAQ");

var $b8pNE = parcelRequire("b8pNE");

var $5UoQc = parcelRequire("5UoQc");
const $b6dae4aa0e47e00e$export$8eed96bc6d982595 = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $04PAQ.default)(url);
    (0, $eUqFw.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8pNE.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UoQc.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("04PAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $060f4b6c56808cdc$export$2e2bcd8739ae039);

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");

var $2cI4y = parcelRequire("2cI4y");

var $b81Yi = parcelRequire("b81Yi");

var $jOo8k = parcelRequire("jOo8k");

var $8ru2D = parcelRequire("8ru2D");
const $060f4b6c56808cdc$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $060f4b6c56808cdc$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $8ru2D.useAISummaryConfig)();
    const cardState = (0, $b81Yi.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $1qrFi.extractAri)(data);
    const dataUrl = data && (0, $lnW6z.extractLink)(data) || '';
    const onStart = (0, $eUqFw.useCallback)((id)=>{
        (0, $2cI4y.startUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eUqFw.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $2cI4y.succeedUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eUqFw.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $2cI4y.failUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $jOo8k.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $060f4b6c56808cdc$export$2e2bcd8739ae039 = $060f4b6c56808cdc$var$useAISummaryAction;

});
parcelRegister("1qrFi", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $719f58b8f5cece0a$export$be18a6294fd426ec);
const $719f58b8f5cece0a$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("45sl7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $20285615fd58f92d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::3fdfbbdbdb062babb9a2ab4e53454d79>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $dHNAr = parcelRequire("dHNAr");
const $20285615fd58f92d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $dHNAr.default)(...params));
        event.fire((0, $1695fa5341c6d031$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $1695fa5341c6d031$export$3f072f06b90c3985 = 'media';

parcelRegister("dHNAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9d05577ac8ffe9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d08fdca953a1eb1130683499e509165>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $dd9d05577ac8ffe9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $dd9d05577ac8ffe9$export$2e2bcd8739ae039 = $dd9d05577ac8ffe9$var$createEventPayload;

});


parcelRegister("jOo8k", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $8e7665aa4bc9eed3$export$becd8f2eba1bbd96);

var $eUqFw = parcelRequire("eUqFw");

var $iThCc = parcelRequire("iThCc");

var $96eVN = parcelRequire("96eVN");
const $8e7665aa4bc9eed3$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eUqFw.useState)((0, $iThCc.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    (0, $eUqFw.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $iThCc.AISummariesStore).get(url)) (0, $iThCc.AISummariesStore).set(url, new (0, $96eVN.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $iThCc.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey
    ]);
    const summariseUrl = ()=>{
        return (0, $iThCc.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("iThCc", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $a00dd5447fec502f$export$6979339b6d41707e);

var $6roQF = parcelRequire("6roQF");
const $a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE = 100;
const $a00dd5447fec502f$export$6979339b6d41707e = new (0, $6roQF.LRUMap)($a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE);

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("96eVN", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $4ceaf946d9c480f1$export$73e4b807d5bd74b6);

var $hompL = parcelRequire("hompL");

var $906lw = parcelRequire("906lw");

var $7h3kH = parcelRequire("7h3kH");

var $03QE9 = parcelRequire("03QE9");

var $dUrSu = parcelRequire("dUrSu");
class $4ceaf946d9c480f1$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dUrSu.getBaseUrl)(envKey);
                return (0, $7h3kH.addPath)(baseUrl, path);
            }
            return (0, $7h3kH.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown'
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $03QE9.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $7h3kH.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new Error(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof Error && this.isExpectedError(err.message) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    isExpectedError(value) {
        return typeof value === 'string' && (0, $906lw.errorMessages).some((a)=>a === value);
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("906lw", function(module, exports) {

$parcel$export(module.exports, "errorMessages", () => $5cf044834cb63238$export$d8bd0967cb58683);
const $5cf044834cb63238$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});

parcelRegister("7h3kH", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $b6cc5b1d42af4557$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $b6cc5b1d42af4557$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $b6cc5b1d42af4557$export$ff2962de2b2c930f);
const $b6cc5b1d42af4557$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $b6cc5b1d42af4557$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $b6cc5b1d42af4557$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $b6cc5b1d42af4557$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $b6cc5b1d42af4557$export$ff2962de2b2c930f = (product)=>{
    if ($b6cc5b1d42af4557$var$isJiraProduct(product)) return $b6cc5b1d42af4557$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("03QE9", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $8a24a33dc932f4e5$export$e45226161c660403);

var $7h3kH = parcelRequire("7h3kH");
async function* $8a24a33dc932f4e5$export$e45226161c660403(response) {
    const reader = (0, $7h3kH.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});



parcelRegister("8ru2D", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $4403e58f54b47af1$export$4480af2c00aa7ebe);

var $gqldc = parcelRequire("gqldc");

var $eUqFw = parcelRequire("eUqFw");
const $4403e58f54b47af1$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("b8pNE", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $42b519d5e1f81e55$export$cfa1d3eed9a61059);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");
function $42b519d5e1f81e55$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eUqFw.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $4abrz.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_summary_action_description),
        ...props
    });
}

});

parcelRegister("5UoQc", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $0bc861f7676c4d20$export$75a19de44af58722);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $fN7pY = parcelRequire("fN7pY");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");

var $exKwM = parcelRequire("exKwM");
function $0bc861f7676c4d20$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onCompleted = (0, $eUqFw.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $exKwM.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eUqFw.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action_description),
        ...props
    });
}

});
parcelRegister("fN7pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c379c2d8e36be306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $c379c2d8e36be306$var$AiIcon = (props)=>{
    const iconColor = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? "var(--ds-icon, #44546F)" : `var(--ds-icon-accent-blue, ${0, $PdmhA.B200})`;
    const textColor = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') ? "var(--ds-icon, #44546F)" : `var(--ds-text-accent-blue, ${0, $PdmhA.B400})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconColor,
        color: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textColor,
        color: textColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconColor,
        color: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textColor,
        color: textColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textColor,
        color: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconColor,
        color: iconColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textColor,
        color: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconColor,
        color: iconColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "url(#ai_icon_lg0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#ai_icon_lg1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#ai_icon_lg2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "url(#ai_icon_lg3)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconColor
    })));
};
var $c379c2d8e36be306$export$2e2bcd8739ae039 = $c379c2d8e36be306$var$AiIcon;

});

parcelRegister("exKwM", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $7d236111ed75f623$export$82f46aa4e6535a45);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hZwiw = parcelRequire("hZwiw");

var $bJ9S9 = parcelRequire("bJ9S9");

var $fv3b5 = parcelRequire("fv3b5");
const $7d236111ed75f623$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $hZwiw.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJ9S9.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fv3b5.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("hZwiw", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $13fbd6746cda9c21$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $13fbd6746cda9c21$export$cd2e891d7f87074d);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $13fbd6746cda9c21$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') && isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $13fbd6746cda9c21$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $4abrz.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $caOA9.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $4abrz.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $4abrz.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $4abrz.messages).ai_summary_error_generic,
                url: (0, $caOA9.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("bJ9S9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f231676b33723539$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $f231676b33723539$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $f231676b33723539$export$2e2bcd8739ae039 = $f231676b33723539$var$AIEventErrorViewed;

});

parcelRegister("fv3b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed25baefb28285c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");
const $0ed25baefb28285c$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $caOA9.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $0ed25baefb28285c$export$2e2bcd8739ae039 = $0ed25baefb28285c$var$AILearnMoreAnchor;

});





parcelRegister("9QQRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1aac8212e0f674$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jgpX5 = parcelRequire("jgpX5");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $1tnZc = parcelRequire("1tnZc");

const $8f1aac8212e0f674$var$AutomationModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aZlf0")));
const $8f1aac8212e0f674$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $caOA9.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eUqFw.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1tnZc.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f1aac8212e0f674$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $4abrz.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgpX5.default), {
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $8f1aac8212e0f674$export$2e2bcd8739ae039 = $8f1aac8212e0f674$var$AutomationAction;

});
parcelRegister("jgpX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd431ca61fafd84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbd431ca61fafd84$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $bbd431ca61fafd84$export$2e2bcd8739ae039 = $bbd431ca61fafd84$var$AutomationManualTriggersGlyph;

});

parcelRegister("1tnZc", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $15c366388beaffc3$export$93e707b363eaf5c8);

var $4abrz = parcelRequire("4abrz");
const $15c366388beaffc3$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $4abrz.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $4abrz.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aZlf0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('hKMCy')
        ]);
        const value = parcelRequire('lRKyt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("hKMCy")
    ]).then(()=>parcelRequire('lRKyt'));
}

});


parcelRegister("9razy", function(module, exports) {

$parcel$export(module.exports, "default", () => $10dd6358c7ba1901$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lLAmK = parcelRequire("lLAmK");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bP3BY = parcelRequire("bP3BY");

var $eUqFw = parcelRequire("eUqFw");

var $iNbFo = parcelRequire("iNbFo");

const $10dd6358c7ba1901$var$RelatedLinksModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("e3q82")));
const $10dd6358c7ba1901$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $byn9U.jsx)($10dd6358c7ba1901$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        actionData?.ari,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).related_links_view_related_urls),
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $bP3BY.default), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $10dd6358c7ba1901$export$2e2bcd8739ae039 = $10dd6358c7ba1901$var$ViewRelatedLinksAction;

});
parcelRegister("bP3BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $091bd7b6fd540225$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jfQfF = parcelRequire("jfQfF");
function $091bd7b6fd540225$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $091bd7b6fd540225$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $091bd7b6fd540225$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $091bd7b6fd540225$var$rotateSvg
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        label: "View recent links..."
    }));
var $091bd7b6fd540225$export$2e2bcd8739ae039 = $091bd7b6fd540225$var$RelatedLinksActionIcon;

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"/><path d="M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z" fill-rule="nonzero"/></g></svg>`
    }, props));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = $e047f322faad4563$var$ChildIssuesIcon;
module.exports.default = $e047f322faad4563$var$_default;

});


parcelRegister("e3q82", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('e8loy');
        const value = parcelRequire('ixfFh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("e8loy").then(()=>parcelRequire('ixfFh'));
}

});




parcelRegister("d2BrZ", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ab32f415250f7e3$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ab32f415250f7e3$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ab32f415250f7e3$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ab32f415250f7e3$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ab32f415250f7e3$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ab32f415250f7e3$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ab32f415250f7e3$export$9678d3ca18bd7526);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $bampN = parcelRequire("bampN");

var $6oJXW = parcelRequire("6oJXW");

var $fNWSr = parcelRequire("fNWSr");

var $7GItJ = parcelRequire("7GItJ");
function $8ab32f415250f7e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ab32f415250f7e3$export$f942619ce67b1a41 = {
    [(0, $caOA9.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Location]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Preview]: [
        'block'
    ],
    [(0, $caOA9.ElementName).Priority]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Provider]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Snippet]: [
        'block'
    ],
    [(0, $caOA9.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).State]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Title]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ab32f415250f7e3$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ab32f415250f7e3$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ab32f415250f7e3$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $caOA9.SmartLinkDirection).Vertical:
            return $8ab32f415250f7e3$var$_ref3;
        case (0, $caOA9.SmartLinkDirection).Horizontal:
        default:
            return $8ab32f415250f7e3$var$_ref2;
    }
};
const $8ab32f415250f7e3$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $caOA9.SmartLinkSize).Large:
            return 1;
        case (0, $caOA9.SmartLinkSize).Medium:
            return 0.5;
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ab32f415250f7e3$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ab32f415250f7e3$export$ff20be09ae01c52e(size)}rem`,
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ab32f415250f7e3$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ab32f415250f7e3$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ab32f415250f7e3$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $fNWSr.default);
const $8ab32f415250f7e3$var$isElementDisplayValid = (name, display)=>{
    return $8ab32f415250f7e3$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ab32f415250f7e3$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ab32f415250f7e3$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && ((0, $6oJXW.isFlexibleUiElement)(node) || node.type === (0, $7GItJ.default));
var $8ab32f415250f7e3$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ab32f415250f7e3$export$393b0054595c3748 = (size)=>{
    if (size === (0, $caOA9.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ab32f415250f7e3$var$_ref;
};
const $8ab32f415250f7e3$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $caOA9.ActionName).DeleteAction:
            case (0, $caOA9.ActionName).EditAction:
            case (0, $caOA9.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $caOA9.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ab32f415250f7e3$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if ($8ab32f415250f7e3$var$isElementOrElementGroup(child) || $8ab32f415250f7e3$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ab32f415250f7e3$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $bampN[name];
        const typedProps = props;
        if (Element && $8ab32f415250f7e3$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$8ab32f415250f7e3$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("bampN", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $706e9ad9ba761081$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $706e9ad9ba761081$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $706e9ad9ba761081$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $706e9ad9ba761081$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $706e9ad9ba761081$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $706e9ad9ba761081$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $706e9ad9ba761081$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $706e9ad9ba761081$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $706e9ad9ba761081$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $706e9ad9ba761081$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $706e9ad9ba761081$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $706e9ad9ba761081$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $706e9ad9ba761081$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $706e9ad9ba761081$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $706e9ad9ba761081$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $706e9ad9ba761081$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $706e9ad9ba761081$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $706e9ad9ba761081$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $706e9ad9ba761081$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $706e9ad9ba761081$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $706e9ad9ba761081$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $706e9ad9ba761081$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $706e9ad9ba761081$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $706e9ad9ba761081$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $706e9ad9ba761081$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $706e9ad9ba761081$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $706e9ad9ba761081$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $706e9ad9ba761081$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $706e9ad9ba761081$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $706e9ad9ba761081$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $706e9ad9ba761081$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $706e9ad9ba761081$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("2mW0Z")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("jtGWU")).default);

var $577Fl = parcelRequire("577Fl");

var $caOA9 = parcelRequire("caOA9");

var $2mW0Z = parcelRequire("2mW0Z");

var $jtGWU = parcelRequire("jtGWU");
const $706e9ad9ba761081$export$d3af56c23f9e459b = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedTo);
const $706e9ad9ba761081$export$fbd18f11bf3a3444 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedToGroup);
const $706e9ad9ba761081$export$3bc3c9693a40aa = (0, $577Fl.createElement)((0, $caOA9.ElementName).AttachmentCount);
const $706e9ad9ba761081$export$2ae2af4435dd6144 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AuthorGroup);
const $706e9ad9ba761081$export$5742b38fd5cfe410 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ChecklistProgress);
const $706e9ad9ba761081$export$a1e647014985ddb9 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CollaboratorGroup);
const $706e9ad9ba761081$export$f4c1466e6fdd07b = (0, $577Fl.createElement)((0, $caOA9.ElementName).CommentCount);
const $706e9ad9ba761081$export$53ced9403d373871 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedOn);
const $706e9ad9ba761081$export$db468caedefbb630 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedBy);
const $706e9ad9ba761081$export$fea59459cfa1625b = (0, $577Fl.createElement)((0, $caOA9.ElementName).DueOn);
const $706e9ad9ba761081$export$2aa8c58ab6c8ae64 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LatestCommit);
const $706e9ad9ba761081$export$69387b41dfc808f7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LinkIcon);
const $706e9ad9ba761081$export$18a2be9195644f38 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Location);
const $706e9ad9ba761081$export$ebbbdcc68d717b7b = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedBy);
const $706e9ad9ba761081$export$a6db3f4240728b58 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedOn);
const $706e9ad9ba761081$export$fa04b1f8d953704f = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedBy);
const $706e9ad9ba761081$export$90e81c873cca1e90 = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedByGroup);
const $706e9ad9ba761081$export$300334f671c43555 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Priority);
const $706e9ad9ba761081$export$7904b5485bf997ea = (0, $577Fl.createElement)((0, $caOA9.ElementName).ProgrammingLanguage);
const $706e9ad9ba761081$export$2881499e37b75b9a = (0, $577Fl.createElement)((0, $caOA9.ElementName).Provider);
const $706e9ad9ba761081$export$f69df2decd5f729e = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReactCount);
const $706e9ad9ba761081$export$77dedcd16f070a20 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReadTime);
const $706e9ad9ba761081$export$897b145a1ed39fe5 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SentOn);
const $706e9ad9ba761081$export$387c3264a8f67d61 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SourceBranch);
const $706e9ad9ba761081$export$7254cc27399e90bd = (0, $577Fl.createElement)((0, $caOA9.ElementName).State);
const $706e9ad9ba761081$export$cfafe90bba8a54db = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubscriberCount);
const $706e9ad9ba761081$export$d441f34e4c8dd9e7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubTasksProgress);
const $706e9ad9ba761081$export$634eef04d1a9a575 = (0, $577Fl.createElement)((0, $caOA9.ElementName).StoryPoints);
const $706e9ad9ba761081$export$b5e4199e062b8f44 = (0, $577Fl.createElement)((0, $caOA9.ElementName).TargetBranch);
const $706e9ad9ba761081$export$f99233281efd08a0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Title);
const $706e9ad9ba761081$export$ae2d8be089b6cfe0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ViewCount);
const $706e9ad9ba761081$export$b080bef6ed7fa75a = (0, $577Fl.createElement)((0, $caOA9.ElementName).VoteCount);

});
parcelRegister("577Fl", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $d123e4d2e9f5aa27$export$c8a8987d4410bf2d);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $kIJ39 = parcelRequire("kIJ39");

var $4AAjx = parcelRequire("4AAjx");

var $ecYnC = parcelRequire("ecYnC");

var $1aEBl = parcelRequire("1aEBl");

var $2aeJ6 = parcelRequire("2aeJ6");

var $gsehw = parcelRequire("gsehw");

var $4abrz = parcelRequire("4abrz");

var $iAt1y = parcelRequire("iAt1y");

var $8UE2N = parcelRequire("8UE2N");
const $d123e4d2e9f5aa27$var$elementMappings = {
    [(0, $caOA9.ElementName).AttachmentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Attachment
        }
    },
    [(0, $caOA9.ElementName).AuthorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).ChecklistProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).CheckItem
        }
    },
    [(0, $caOA9.ElementName).CollaboratorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CommentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Comment
        }
    },
    [(0, $caOA9.ElementName).ViewCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).View
        }
    },
    [(0, $caOA9.ElementName).ReactCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).React
        }
    },
    [(0, $caOA9.ElementName).VoteCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Vote
        }
    },
    [(0, $caOA9.ElementName).CreatedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).OwnedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedTo]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedToGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).OwnedByGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CreatedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).DueOn]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).LatestCommit]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Commit
        }
    },
    [(0, $caOA9.ElementName).LinkIcon]: {
        component: (0, $c2pJy.default)
    },
    [(0, $caOA9.ElementName).ModifiedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).ModifiedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).Preview]: {
        component: (0, $2aeJ6.default)
    },
    [(0, $caOA9.ElementName).Priority]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ProgrammingLanguage]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).ProgrammingLanguage
        }
    },
    [(0, $caOA9.ElementName).Provider]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ReadTime]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).SentOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).SourceBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).State]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).SubscriberCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Subscriber
        }
    },
    [(0, $caOA9.ElementName).SubTasksProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).SubTasksProgress
        }
    },
    [(0, $caOA9.ElementName).StoryPoints]: {
        component: (0, $8UE2N.default)
    },
    [(0, $caOA9.ElementName).TargetBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).Title]: {
        component: (0, $39rqs.default)
    },
    [(0, $caOA9.ElementName).Location]: {
        component: (0, $39rqs.default),
        props: {
            theme: (0, $caOA9.SmartLinkInternalTheme).Grey
        }
    }
};
const $d123e4d2e9f5aa27$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $d123e4d2e9f5aa27$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
        case (0, $caOA9.ElementName).AuthorGroup:
        case (0, $caOA9.ElementName).CollaboratorGroup:
        case (0, $caOA9.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $caOA9.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $d123e4d2e9f5aa27$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $caOA9.ElementName).AttachmentCount:
        case (0, $caOA9.ElementName).ChecklistProgress:
        case (0, $caOA9.ElementName).CommentCount:
        case (0, $caOA9.ElementName).ViewCount:
        case (0, $caOA9.ElementName).ReactCount:
        case (0, $caOA9.ElementName).VoteCount:
        case (0, $caOA9.ElementName).ProgrammingLanguage:
        case (0, $caOA9.ElementName).SubscriberCount:
        case (0, $caOA9.ElementName).LatestCommit:
        case (0, $caOA9.ElementName).SubTasksProgress:
            return $d123e4d2e9f5aa27$var$toBadgeProps(data);
        case (0, $caOA9.ElementName).StoryPoints:
            return $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps(data);
        case (0, $caOA9.ElementName).CreatedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).created_by, context.createdBy);
        case (0, $caOA9.ElementName).AssignedTo:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).assigned_to, context.assignedTo);
        case (0, $caOA9.ElementName).OwnedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).owned_by, context.ownedBy);
        case (0, $caOA9.ElementName).CreatedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('created', context.createdOn);
        case (0, $caOA9.ElementName).DueOn:
            return $d123e4d2e9f5aa27$var$toDateLozengeProps(context.dueOn);
        case (0, $caOA9.ElementName).ModifiedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).modified_by, context.modifiedBy);
        case (0, $caOA9.ElementName).ModifiedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $caOA9.ElementName).SentOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('sent', context.sentOn);
        case (0, $caOA9.ElementName).ReadTime:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).read_time, data);
        case (0, $caOA9.ElementName).SourceBranch:
        case (0, $caOA9.ElementName).TargetBranch:
            return $d123e4d2e9f5aa27$var$toTextProps(data);
        case (0, $caOA9.ElementName).Title:
            return $d123e4d2e9f5aa27$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $d123e4d2e9f5aa27$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $d123e4d2e9f5aa27$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $d123e4d2e9f5aa27$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $d123e4d2e9f5aa27$var$elementMappings[name] || {};
    const contextKey = $d123e4d2e9f5aa27$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
        const data = $d123e4d2e9f5aa27$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("39rqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $105659f25305e8c7$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $8sbpW = parcelRequire("8sbpW");
function $105659f25305e8c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $105659f25305e8c7$var$DEFAULT_MAX_LINES = 2;
const $105659f25305e8c7$var$MAXIMUM_MAX_LINES = 2;
const $105659f25305e8c7$var$MINIMUM_MAX_LINES = 1;
const $105659f25305e8c7$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $105659f25305e8c7$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref3 = {
    name: "rllj93",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font-size:12px;}"
};
const $105659f25305e8c7$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $caOA9.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $105659f25305e8c7$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $caOA9.SmartLinkTheme).Black:
            return $105659f25305e8c7$var$_ref2;
        case (0, $caOA9.SmartLinkTheme).Link:
        default:
            return $105659f25305e8c7$var$_ref;
    }
};
const $105659f25305e8c7$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, (0, $4z862.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $105659f25305e8c7$var$getThemeStyles(theme));
};
const $105659f25305e8c7$var$getMaxLines = (maxLines)=>{
    if (maxLines > $105659f25305e8c7$var$MAXIMUM_MAX_LINES) return $105659f25305e8c7$var$DEFAULT_MAX_LINES;
    if (maxLines < $105659f25305e8c7$var$MINIMUM_MAX_LINES) return $105659f25305e8c7$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $105659f25305e8c7$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $105659f25305e8c7$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $105659f25305e8c7$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $caOA9.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const hasSpace = (0, $eUqFw.useMemo)(()=>text ? (0, $4z862.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $105659f25305e8c7$var$getAnchorStyles(size, theme, $105659f25305e8c7$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $105659f25305e8c7$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $105659f25305e8c7$var$withTooltip(anchor, text, testId));
};
var $105659f25305e8c7$export$2e2bcd8739ae039 = $105659f25305e8c7$var$Link;

});
parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});




parcelRegister("kIJ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab46ec5e33c2c988$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cCDvW = parcelRequire("cCDvW");

var $4AAjx = parcelRequire("4AAjx");
function $ab46ec5e33c2c988$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab46ec5e33c2c988$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab46ec5e33c2c988$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $cCDvW.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab46ec5e33c2c988$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab46ec5e33c2c988$export$2e2bcd8739ae039 = $ab46ec5e33c2c988$var$Lozenge;

});
parcelRegister("cCDvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af307a3451da5a$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $gNhy0 = parcelRequire("gNhy0");

var $k18Wh = parcelRequire("k18Wh");

var $aiL3q = parcelRequire("aiL3q");

var $fZ5ue = parcelRequire("fZ5ue");

var $2n1yu = parcelRequire("2n1yu");

var $5PFec = parcelRequire("5PFec");

var $af6S8 = parcelRequire("af6S8");

var $gBDMJ = parcelRequire("gBDMJ");

var $8McbT = parcelRequire("8McbT");

var $4AAjx = parcelRequire("4AAjx");

var $bTNMs = parcelRequire("bTNMs");

var $5Oy6H = parcelRequire("5Oy6H");

var $4jHIN = parcelRequire("4jHIN");
const $c8af307a3451da5a$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $c8af307a3451da5a$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eUqFw.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [items, setItems] = (0, $eUqFw.useState)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)();
    const reload = (0, $af6S8.default)();
    //TODO EDM-6583 Replace usage of useFlexibleUiAnalyticsContext with linking platform analytics context from find team.
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    (0, $eUqFw.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
    const handleOpenChange = (0, $eUqFw.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            analytics?.ui.smartLinkLozengeActionClickedEvent();
            analytics?.track.smartLinkQuickActionStarted({
                smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $2n1yu.default));
                const validItems = typeof text === 'string' ? $c8af307a3451da5a$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        analytics,
        invoke,
        isLoaded,
        text
    ]);
    const trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gNhy0.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)(async (id, text, appearance)=>{
        try {
            analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $5PFec.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8McbT.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).updateFailed);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        analytics,
        invoke,
        linkId,
        reload,
        url
    ]);
    const dropdownItemGroup = (0, $eUqFw.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k18Wh.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            previewData: previewData
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jHIN.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        previewData,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $c8af307a3451da5a$export$2e2bcd8739ae039 = (0, $aiL3q.default)($c8af307a3451da5a$var$LozengeAction);

});
parcelRegister("gNhy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7635f6bba3760eba$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $86Ndv = parcelRequire("86Ndv");

var $bPzws = parcelRequire("bPzws");
const $7635f6bba3760eba$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $bPzws.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "options",
            size: "medium"
        }))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $bPzws.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $7635f6bba3760eba$export$2e2bcd8739ae039 = $7635f6bba3760eba$var$LozengeActionTrigger;

});
parcelRegister("bPzws", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $fc5d2e39c54f8883$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $fc5d2e39c54f8883$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $fc5d2e39c54f8883$export$2c40d814aeff5db);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $fc5d2e39c54f8883$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $byn9U.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $fc5d2e39c54f8883$export$5717c7336384f3a6 = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "span[role='img']": {
        margin: `${"var(--ds-space-negative-050, -4px)"} ${"var(--ds-space-negative-100, -8px)"} ${"var(--ds-space-negative-050, -4px)"} -1px`
    }
});
const $fc5d2e39c54f8883$export$2c40d814aeff5db = /*#__PURE__*/ (0, $byn9U.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});


parcelRegister("k18Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $723d9a69e05743b3$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $PdmhA = parcelRequire("PdmhA");

var $96IgR = parcelRequire("96IgR");

var $c3mz7 = parcelRequire("c3mz7");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $af6S8 = parcelRequire("af6S8");
const $723d9a69e05743b3$var$MAX_LINE_NUMBER = 8;
const $723d9a69e05743b3$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $723d9a69e05743b3$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
    const reload = (0, $af6S8.default)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const isPreviewAvailable = previewData && previewData.src !== undefined;
    const handlePreviewClose = (0, $eUqFw.useCallback)(()=>{
        if (url) reload(url, true);
    }, [
        reload,
        url
    ]);
    const handlePreviewOpen = (0, $eUqFw.useCallback)(()=>{
        if (isPreviewAvailable) {
            analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
            return (0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                ...previewData,
                analytics: analytics,
                onClose: handlePreviewClose
            });
        }
    }, [
        analytics,
        handlePreviewClose,
        isPreviewAvailable,
        previewData
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.contentStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            testId: `${testId}-icon`,
            size: "medium",
            primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`,
            secondaryColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
            label: 'error'
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $c3mz7.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $4z862.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.linkStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c3mz7.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        testId: `${testId}-error`
    }, content))));
};
var $723d9a69e05743b3$export$2e2bcd8739ae039 = $723d9a69e05743b3$var$LozengeActionError;

});
parcelRegister("c3mz7", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $88f4678df04deb4b$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $88f4678df04deb4b$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $88f4678df04deb4b$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $88f4678df04deb4b$export$6a54c24d15b0f6ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4z862 = parcelRequire("4z862");
function $88f4678df04deb4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88f4678df04deb4b$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $88f4678df04deb4b$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $88f4678df04deb4b$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: `var(--ds-text, ${(0, $PdmhA.N800)})`
    }
});
const $88f4678df04deb4b$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $88f4678df04deb4b$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));

});


parcelRegister("aiL3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac18b970e0fdc7f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $ffiyv = parcelRequire("ffiyv");
const $ac18b970e0fdc7f3$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    };
var $ac18b970e0fdc7f3$export$2e2bcd8739ae039 = $ac18b970e0fdc7f3$var$withErrorBoundary;

});

parcelRegister("2n1yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8986176ef21b1b25$export$2e2bcd8739ae039);
const $8986176ef21b1b25$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $8986176ef21b1b25$export$2e2bcd8739ae039 = $8986176ef21b1b25$var$extractLozengeActionItems;

});

parcelRegister("5PFec", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf0e102a3fe2298$export$2e2bcd8739ae039);
const $1bf0e102a3fe2298$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $1bf0e102a3fe2298$export$2e2bcd8739ae039 = $1bf0e102a3fe2298$var$createStatusUpdateRequest;

});

parcelRegister("gBDMJ", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $7b8be149f9c2eaef$export$4f2e371a667ad688);

var $4abrz = parcelRequire("4abrz");
const $7b8be149f9c2eaef$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $4abrz.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $4abrz.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $4abrz.messages)['status_change_update_error']
    }
};

});

parcelRegister("5Oy6H", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$618660b8f2aa87e2);
const $2f5a2618d92e65d0$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $2f5a2618d92e65d0$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("4jHIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a1291c7d9bca32$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5etYV = parcelRequire("5etYV");

var $bPzws = parcelRequire("bPzws");

var $fEubG = parcelRequire("fEubG");
const $85a1291c7d9bca32$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $bPzws.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5etYV.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $85a1291c7d9bca32$export$2e2bcd8739ae039 = $85a1291c7d9bca32$var$LozengeActionItemsGroup;

});
parcelRegister("5etYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fefc6a85569ce88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");
const $4fefc6a85569ce88$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance
    }, text)));
};
var $4fefc6a85569ce88$export$2e2bcd8739ae039 = $4fefc6a85569ce88$var$LozengeActionItem;

});




parcelRegister("ecYnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fe7a328e3dd330$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $2pE6J = parcelRequire("2pE6J");

var $h0YJD = parcelRequire("h0YJD");
function $e3fe7a328e3dd330$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3fe7a328e3dd330$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $e3fe7a328e3dd330$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $4z862.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $e3fe7a328e3dd330$var$labelStyles = {
    name: "8loelm",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $e3fe7a328e3dd330$var$messageMapper = {
    [(0, $caOA9.IconType).PriorityBlocker]: (0, $4abrz.messages).priority_blocker,
    [(0, $caOA9.IconType).PriorityCritical]: (0, $4abrz.messages).priority_critical,
    [(0, $caOA9.IconType).PriorityHigh]: (0, $4abrz.messages).priority_high,
    [(0, $caOA9.IconType).PriorityHighest]: (0, $4abrz.messages).priority_highest,
    [(0, $caOA9.IconType).PriorityLow]: (0, $4abrz.messages).priority_low,
    [(0, $caOA9.IconType).PriorityLowest]: (0, $4abrz.messages).priority_lowest,
    [(0, $caOA9.IconType).PriorityMajor]: (0, $4abrz.messages).priority_major,
    [(0, $caOA9.IconType).PriorityMedium]: (0, $4abrz.messages).priority_medium,
    [(0, $caOA9.IconType).PriorityMinor]: (0, $4abrz.messages).priority_minor,
    [(0, $caOA9.IconType).PriorityTrivial]: (0, $4abrz.messages).priority_trivial,
    [(0, $caOA9.IconType).PriorityUndefined]: (0, $4abrz.messages).priority_undefined
};
const $e3fe7a328e3dd330$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e3fe7a328e3dd330$var$messageMapper[icon];
        if (descriptor) return (0, $4z862.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e3fe7a328e3dd330$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e3fe7a328e3dd330$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e3fe7a328e3dd330$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $e3fe7a328e3dd330$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e3fe7a328e3dd330$var$renderAtlaskitIcon(icon, testId) || $e3fe7a328e3dd330$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e3fe7a328e3dd330$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $e3fe7a328e3dd330$export$2e2bcd8739ae039 = $e3fe7a328e3dd330$var$Badge;

});

parcelRegister("1aEBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a383934139702b93$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4z862 = parcelRequire("4z862");
function $a383934139702b93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a383934139702b93$var$MAX_COUNT = 4;
var $a383934139702b93$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $a383934139702b93$var$getStyles = (size)=>{
    const styles = $a383934139702b93$var$_ref;
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $byn9U.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $a383934139702b93$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).assigned_to, personName);
        case (0, $caOA9.ElementName).OwnedByGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).owned_by, personName);
        case (0, $caOA9.ElementName).AuthorGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $a383934139702b93$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $a383934139702b93$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $5JgJ2.default)();
    const data = (0, $eUqFw.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $caOA9.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a383934139702b93$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a383934139702b93$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $a383934139702b93$export$2e2bcd8739ae039 = $a383934139702b93$var$AvatarGroup;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("2aeJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ea9141ebba5fdb$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2pE6J = parcelRequire("2pE6J");
function $f1ea9141ebba5fdb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $f1ea9141ebba5fdb$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $f1ea9141ebba5fdb$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $f1ea9141ebba5fdb$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $f1ea9141ebba5fdb$export$2e2bcd8739ae039 = $f1ea9141ebba5fdb$var$Media;

});

parcelRegister("gsehw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd937a6ee8e1ad3$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");
const $5dd937a6ee8e1ad3$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $5dd937a6ee8e1ad3$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $5dd937a6ee8e1ad3$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $4z862.getFormattedMessage)(message) || content);
};
var $5dd937a6ee8e1ad3$export$2e2bcd8739ae039 = $5dd937a6ee8e1ad3$var$Text;

});

parcelRegister("iAt1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $588a9b7e2c02aa74$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $9KU0P = parcelRequire("9KU0P");

var $4abrz = parcelRequire("4abrz");
const $588a9b7e2c02aa74$var$styles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4z862.getTruncateStyles)(1));
const $588a9b7e2c02aa74$var$typeToDescriptorMap = {
    created: {
        relative: (0, $4abrz.messages).created_on_relative,
        absolute: (0, $4abrz.messages).created_on_absolute
    },
    modified: {
        relative: (0, $4abrz.messages).modified_on_relative,
        absolute: (0, $4abrz.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $4abrz.messages).sent_on_relative,
        absolute: (0, $4abrz.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $588a9b7e2c02aa74$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $5JgJ2.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $588a9b7e2c02aa74$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...$588a9b7e2c02aa74$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $588a9b7e2c02aa74$export$2e2bcd8739ae039 = $588a9b7e2c02aa74$var$DateTime;

});

parcelRegister("8UE2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d82cf77148d10f$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $byn9U = parcelRequire("byn9U");
function $82d82cf77148d10f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $82d82cf77148d10f$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $82d82cf77148d10f$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $82d82cf77148d10f$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9nkwJ.default), null, value));
};
var $82d82cf77148d10f$export$2e2bcd8739ae039 = $82d82cf77148d10f$var$AtlaskitBadge;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0
});
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});




parcelRegister("2mW0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc684baf7d7b3ad$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $2aeJ6 = parcelRequire("2aeJ6");
const $1dc684baf7d7b3ad$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $caOA9.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2aeJ6.default), {
        ...rest,
        ...data
    });
};
var $1dc684baf7d7b3ad$export$2e2bcd8739ae039 = $1dc684baf7d7b3ad$var$Preview;

});

parcelRegister("jtGWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9944feb1da4750$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $gsehw = parcelRequire("gsehw");
const $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $7f9944feb1da4750$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $7f9944feb1da4750$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gsehw.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $7f9944feb1da4750$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $7f9944feb1da4750$export$2e2bcd8739ae039 = $7f9944feb1da4750$var$SnippetElement;

});


parcelRegister("6oJXW", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $7acfde2c70552128$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $7acfde2c70552128$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $7acfde2c70552128$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $7acfde2c70552128$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $7acfde2c70552128$export$c0547b4405cae584);

var $eUqFw = parcelRequire("eUqFw");

var $kMn00 = parcelRequire("kMn00");
var $4bEHq = parcelRequire("4bEHq");
var $d9NWW = parcelRequire("d9NWW");
var $kcn2F = parcelRequire("kcn2F");

var $bampN = parcelRequire("bampN");
const $7acfde2c70552128$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some((child)=>$7acfde2c70552128$export$df0092b19156b140(child))) return true;
    return false;
};
const $7acfde2c70552128$export$b56fc89cf6e7d1e9 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($kMn00).some((type)=>type === node.type);
const $7acfde2c70552128$export$d7fc505bb0bd5756 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($bampN).some((type)=>type === node.type);
const $7acfde2c70552128$export$df0092b19156b140 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $4bEHq.default);
const $7acfde2c70552128$export$c0547b4405cae584 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $d9NWW.default);
const $7acfde2c70552128$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $kcn2F.default);

});
parcelRegister("kMn00", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("kcn2F")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("cIk4w")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("d9NWW")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("bTLTu")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("4bEHq")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("4sQhG")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("fbX7D")).default);
$parcel$export(module.exports, "RelatedUrlsBlock", () => (parcelRequire("8jYmN")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("h2NbM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("jgolE")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("5I51G")).default);

var $kcn2F = parcelRequire("kcn2F");

var $cIk4w = parcelRequire("cIk4w");

var $d9NWW = parcelRequire("d9NWW");

var $bTLTu = parcelRequire("bTLTu");

var $4bEHq = parcelRequire("4bEHq");

var $4sQhG = parcelRequire("4sQhG");

var $fbX7D = parcelRequire("fbX7D");

var $8jYmN = parcelRequire("8jYmN");

var $h2NbM = parcelRequire("h2NbM");

var $jgolE = parcelRequire("jgolE");

var $5I51G = parcelRequire("5I51G");

});
parcelRegister("kcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $e186a177ed6dee21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fbX7D = parcelRequire("fbX7D");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $e186a177ed6dee21$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbX7D.default), {
        ...props,
        testId: testId
    });
};
var $e186a177ed6dee21$export$2e2bcd8739ae039 = $e186a177ed6dee21$var$FooterBlock;

});
parcelRegister("fbX7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6de85b494ec94f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $bampN = parcelRequire("bampN");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $d2BrZ = parcelRequire("d2BrZ");
const $5c6de85b494ec94f$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $caOA9.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const hasActions = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        testId: "smart-element-group-actions",
        align: (0, $caOA9.SmartLinkAlignment).Right,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        overrideCss: (0, $d2BrZ.getActionGroupStyles)(size),
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $5c6de85b494ec94f$export$2e2bcd8739ae039 = $5c6de85b494ec94f$var$FooterBlockResolvedView;

});
parcelRegister("4sQhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2059b5fdc19a0897$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
const $2059b5fdc19a0897$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)((0, $d2BrZ.getBaseStyles)(direction, size), " ", (0, $d2BrZ.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $d2BrZ.getGapSize)(size), "rem;}[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2059b5fdc19a0897$var$Block = ({ children: children, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $eUqFw.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $2059b5fdc19a0897$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $d2BrZ.renderChildren)(children, size));
};
var $2059b5fdc19a0897$export$2e2bcd8739ae039 = $2059b5fdc19a0897$var$Block;

});

parcelRegister("7GItJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef467f6c35c7534c$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4z862 = parcelRequire("4z862");
function $ef467f6c35c7534c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ef467f6c35c7534c$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $ef467f6c35c7534c$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $ef467f6c35c7534c$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $caOA9.SmartLinkAlignment).Right:
            return $ef467f6c35c7534c$var$_ref2;
        case (0, $caOA9.SmartLinkAlignment).Left:
        default:
            return $ef467f6c35c7534c$var$_ref;
    }
};
const $ef467f6c35c7534c$var$getGapStyles = (size, align)=>{
    const gap = (0, $d2BrZ.getGapSize)(size);
    if (align === (0, $caOA9.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $ef467f6c35c7534c$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:block;vertical-align:middle;", (0, $4z862.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ef467f6c35c7534c$var$getGapStyles(size, align), ";");
};
const $ef467f6c35c7534c$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $d2BrZ.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ef467f6c35c7534c$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $caOA9.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $caOA9.SmartLinkDirection).Horizontal ? $ef467f6c35c7534c$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $caOA9.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ef467f6c35c7534c$var$ElementGroup = ({ align: align = (0, $caOA9.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $caOA9.SmartLinkWidth).FitToContent, position: position = (0, $caOA9.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ef467f6c35c7534c$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $d2BrZ.renderChildren)(children, size));
var $ef467f6c35c7534c$export$2e2bcd8739ae039 = $ef467f6c35c7534c$var$ElementGroup;

});



parcelRegister("cIk4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fdb61e49b433fdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $4z862 = parcelRequire("4z862");
const $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES = 1;
const $6fdb61e49b433fdb$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $6fdb61e49b433fdb$var$getMaxLines = (maxLines)=>{
    if (maxLines > $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES;
    if (maxLines < $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $6fdb61e49b433fdb$var$MetadataBlock = ({ maxLines: maxLines = $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $d2BrZ.renderElementItems)(primary);
    const secondaryElements = (0, $d2BrZ.renderElementItems)(secondary);
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $6fdb61e49b433fdb$var$getElementGroupStyles(size, $6fdb61e49b433fdb$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $6fdb61e49b433fdb$export$2e2bcd8739ae039 = $6fdb61e49b433fdb$var$MetadataBlock;

});

parcelRegister("d9NWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f26c88235b3036$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $l5CPU = parcelRequire("l5CPU");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $f0f26c88235b3036$var$PreviewBlock = ({ status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5CPU.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $f0f26c88235b3036$export$2e2bcd8739ae039 = $f0f26c88235b3036$var$PreviewBlock;

});
parcelRegister("l5CPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $895a212ba51d5e0c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $2mW0Z = parcelRequire("2mW0Z");
function $895a212ba51d5e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $895a212ba51d5e0c$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $895a212ba51d5e0c$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $caOA9.MediaPlacement).Left || placement === (0, $caOA9.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $byn9U.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $caOA9.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $caOA9.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $895a212ba51d5e0c$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $895a212ba51d5e0c$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $eUqFw.useState)(overrideCss);
    const updateStyles = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $byn9U.css)($895a212ba51d5e0c$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $eUqFw.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eUqFw.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2mW0Z.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $895a212ba51d5e0c$export$2e2bcd8739ae039 = $895a212ba51d5e0c$var$PreviewBlockResolvedView;

});


parcelRegister("bTLTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c244300e3064a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $jtGWU = parcelRequire("jtGWU");

var $4z862 = parcelRequire("4z862");
const $2c244300e3064a1f$var$DEFAULT_MAX_LINES = 3;
const $2c244300e3064a1f$var$MAXIMUM_MAX_LINES = 6;
const $2c244300e3064a1f$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlock} SnippetBlock
 * @see Block
 */ const $2c244300e3064a1f$var$SnippetBlock = ({ maxLines: maxLines = $2c244300e3064a1f$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $4z862.getMaxLines)(maxLines, $2c244300e3064a1f$var$DEFAULT_MAX_LINES, $2c244300e3064a1f$var$MAXIMUM_MAX_LINES, $2c244300e3064a1f$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtGWU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $2c244300e3064a1f$export$2e2bcd8739ae039 = $2c244300e3064a1f$var$SnippetBlock;

});

parcelRegister("4bEHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d96c71ded8e60f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");

var $caOA9 = parcelRequire("caOA9");

var $dKmeE = parcelRequire("dKmeE");

var $fTNaM = parcelRequire("fTNaM");

var $G9qxY = parcelRequire("G9qxY");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");
function $1d96c71ded8e60f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d96c71ded8e60f3$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $1d96c71ded8e60f3$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $1d96c71ded8e60f3$var$_ref;
};
const $1d96c71ded8e60f3$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return 0, $G9qxY.default;
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return 0, $dKmeE.default;
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return 0, $fTNaM.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $1d96c71ded8e60f3$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $caOA9.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $1d96c71ded8e60f3$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $byn9U.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $1d96c71ded8e60f3$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $1d96c71ded8e60f3$export$2e2bcd8739ae039 = $1d96c71ded8e60f3$var$TitleBlock;

});
parcelRegister("dKmeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd04caefc73a85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
function $3bd04caefc73a85e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $3bd04caefc73a85e$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $3bd04caefc73a85e$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $d2BrZ.renderElementItems)(metadata);
    const subtitleElements = (0, $d2BrZ.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        width: (0, $caOA9.SmartLinkWidth).Flexible,
        overrideCss: $3bd04caefc73a85e$var$_ref
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $caOA9.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $3bd04caefc73a85e$export$2e2bcd8739ae039 = $3bd04caefc73a85e$var$TitleBlockResolvedView;

});

parcelRegister("fTNaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35c62bcc8002acc$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $7GItJ = parcelRequire("7GItJ");
function $d35c62bcc8002acc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d35c62bcc8002acc$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $d35c62bcc8002acc$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $d35c62bcc8002acc$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(1, (0, $4z862.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    });
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $d35c62bcc8002acc$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: hasAction ? 'has-action' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d35c62bcc8002acc$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        "data-testid": `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $d35c62bcc8002acc$export$2e2bcd8739ae039 = $d35c62bcc8002acc$var$TitleBlockErroredView;

});

parcelRegister("G9qxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e75535fc810aa$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $8SIiI = parcelRequire("8SIiI");

var $4z862 = parcelRequire("4z862");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $1c6e75535fc810aa$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $4z862.getIconWidth)(size);
    const iconStyles = (0, $4z862.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $1c6e75535fc810aa$export$2e2bcd8739ae039 = $1c6e75535fc810aa$var$TitleBlockResolvingView;

});


parcelRegister("8jYmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2bdb59e926ed8a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $bFzGY = parcelRequire("bFzGY");

var $jOVzD = parcelRequire("jOVzD");

var $buene = parcelRequire("buene");

var $44yzk = parcelRequire("44yzk");

var $aguBP = parcelRequire("aguBP");

var $iWItW = parcelRequire("iWItW");
function $ef2bdb59e926ed8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Represents a block to display related resources of a url
 */ var $ef2bdb59e926ed8a$var$_ref = {
    name: "1ftjnda",
    styles: "min-height:1.55rem"
};
const $ef2bdb59e926ed8a$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $asu8X.di)((0, $jOVzD.default));
    const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $eUqFw.useState)(true);
    const [err, setErr] = (0, $eUqFw.useState)();
    const [relatedUrls, setRelatedUrls] = (0, $eUqFw.useState)();
    const getRelatedUrls = (0, $jOVzD.default)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchRelatedUrls = async ()=>{
            try {
                const relUrls = await getRelatedUrls(url);
                setRelatedUrls(relUrls);
                /**
         * Fire TrackRelatedLinksLoadedEvent
         */ (0, $iWItW.fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                    relatedLinksCount: relUrls.resolvedResults?.length ?? 0
                });
            } catch (error) {
                setErr(error);
            }
            setLoadingRelatedUrls(false);
        };
        fetchRelatedUrls();
    }, [
        createAnalyticsEvent,
        getRelatedUrls,
        url
    ]);
    if (loadingRelatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aguBP.RelatedUrlsBlockResolvingView), {
        testId: `${testId}-resolving-view`,
        ...blockProps
    });
    if (relatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44yzk.RelatedUrlsResolvedView), {
        renderers: renderers,
        overrideCss: $ef2bdb59e926ed8a$var$_ref,
        testId: `${testId}-resolved-view`,
        relatedUrlsResponse: relatedUrls,
        ...blockProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buene.RelatedUrlsBlockErroredView), {
        err: err,
        testId: `${testId}-errored-view`,
        ...blockProps
    });
};
var $ef2bdb59e926ed8a$export$2e2bcd8739ae039 = $ef2bdb59e926ed8a$var$RelatedUrlsBlock;

});
parcelRegister("jOVzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17b3a7a9d9f04e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $d17b3a7a9d9f04e2$var$useRelatedUrls = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (url)=>{
        return await clientExt.relatedUrls(url);
    }, [
        clientExt
    ]);
};
var $d17b3a7a9d9f04e2$export$2e2bcd8739ae039 = $d17b3a7a9d9f04e2$var$useRelatedUrls;

});

parcelRegister("buene", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockErroredView", () => $c113a405c1268075$export$35d9a5df27ecfbf0);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $gsehw = parcelRequire("gsehw");

var $4sQhG = parcelRequire("4sQhG");
const $c113a405c1268075$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        message: {
            descriptor: (0, $4abrz.messages).generic_error_message
        }
    }));

});

parcelRegister("44yzk", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsResolvedView", () => $a007e2cede3efc31$export$743935ead2c9d445);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $6pyKj = parcelRequire("6pyKj");
const $a007e2cede3efc31$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, resolvedResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pyKj.default), {
        testId: `${testId}-list`,
        renderers: renderers,
        initializeOpened: initializeOpened,
        title: (0, $4abrz.messages).last_mentioned_in,
        resolvedResults: resolvedResults
    }));
};

});
parcelRegister("6pyKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ccec9f065474826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4abrz = parcelRequire("4abrz");

var $4z862 = parcelRequire("4z862");

var $gsehw = parcelRequire("gsehw");

var $gDdZc = parcelRequire("gDdZc");
function $2ccec9f065474826$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ccec9f065474826$var$_ref = {
    name: "rbkjwc",
    styles: "font-weight:var(--ds-font-weight-medium, 500)"
};
const $2ccec9f065474826$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initializeOpened);
    const chevronClickHandler = (0, $eUqFw.useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const ChevronComponent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv)));
    const intl = (0, $5JgJ2.default)();
    return resolvedResults.length > 0 ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        testId: testId,
        xcss: (0, $1ZAYh.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: chevronClickHandler,
        testId: `${testId}-expand-title`,
        backgroundColor: "color.background.neutral.subtle",
        "aria-expanded": !!isOpen,
        padding: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        overrideCss: $2ccec9f065474826$var$_ref,
        message: {
            descriptor: title
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronComponent, {
        label: (0, $4z862.getFormattedMessageAsString)(intl, title),
        size: 'medium'
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDdZc.default), {
        resolvedResults: resolvedResults,
        testId: testId,
        renderers: renderers
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        testId: testId,
        message: {
            descriptor: (0, $4abrz.messages).related_work_items_not_found
        }
    });
};
var $2ccec9f065474826$export$2e2bcd8739ae039 = $2ccec9f065474826$var$RelatedUrlList;

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = $40822fe6f5908262$var$ChevronUpIcon;
module.exports.default = $40822fe6f5908262$var$_default;

});

parcelRegister("gDdZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a454004ca0f579a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $elJTs = parcelRequire("elJTs");

var $f6EQU = parcelRequire("f6EQU");
const $a454004ca0f579a9$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This event will fire each time the component is loaded
        (0, $f6EQU.fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
            relatedLinksCount: resolvedResults.length
        });
    }, [
        resolvedResults.length,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        testId: `${testId}-items-wrapper`,
        as: "ul",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            paddingLeft: 'space.0',
            marginTop: 'space.0'
        })
    }, resolvedResults.map((resolvedResults, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6EQU.RelatedUrlItemAnalyticsContext), {
            details: resolvedResults,
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elJTs.default), {
            testId: `${testId}-item`,
            results: resolvedResults,
            renderers: renderers
        }))));
};
const $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            component: 'relatedLinksSection'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a454004ca0f579a9$var$ResolvedResultsStack, props));
};
var $a454004ca0f579a9$export$2e2bcd8739ae039 = $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics;

});
parcelRegister("elJTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7174b4dbac0a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $bFzGY = parcelRequire("bFzGY");

var $caOA9 = parcelRequire("caOA9");

var $fsHAt = parcelRequire("fsHAt");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $lyAeo = parcelRequire("lyAeo");
const $6c7174b4dbac0a44$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flexibleDataContext = (0, $eUqFw.useMemo)(()=>(0, $fsHAt.default)({
            response: results,
            renderers: renderers
        }), [
        renderers,
        results
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
        ...flexibleDataContext?.linkIcon,
        testId: `${testId}-icon`,
        size: (0, $caOA9.SmartLinkSize).Small
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39rqs.default), {
        testId: `${testId}-link`,
        text: flexibleDataContext?.title,
        url: flexibleDataContext?.url,
        size: (0, $caOA9.SmartLinkSize).Small,
        maxLines: 1,
        onClick: onClick
    }));
};
var $6c7174b4dbac0a44$export$2e2bcd8739ae039 = $6c7174b4dbac0a44$var$RelatedUrlItem;

});
parcelRegister("fsHAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a709dad76fe90a85$export$2e2bcd8739ae039);

var $4zMKr = parcelRequire("4zMKr");

var $8hH6p = parcelRequire("8hH6p");

var $903Mk = parcelRequire("903Mk");

var $fmv4j = parcelRequire("fmv4j");

var $7DLuu = parcelRequire("7DLuu");

var $1qrFi = parcelRequire("1qrFi");
var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $lnW6z = parcelRequire("lnW6z");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $a4gSw = parcelRequire("a4gSw");

var $77p4K = parcelRequire("77p4K");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");

var $2umDH = parcelRequire("2umDH");

var $asvOI = parcelRequire("asvOI");

var $eywmF = parcelRequire("eywmF");
const $a709dad76fe90a85$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $lnW6z.extractLink)(data);
    return {
        // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
        actions: (0, $8hH6p.default)(response, props.url, actionOptions, id, aiSummaryConfig),
        assignedToGroup: (0, $fmv4j.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $fmv4j.extractAttachmentCount)(data),
        authorGroup: (0, $c8AiI.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $dMa80.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $7DLuu.extractPersonsUpdatedBy)(data),
        commentCount: (0, $fmv4j.extractCommentCount)(data),
        viewCount: (0, $fmv4j.extractViewCount)(data),
        reactCount: (0, $fmv4j.extractReactCount)(data),
        voteCount: (0, $fmv4j.extractVoteCount)(data),
        checklistProgress: (0, $fmv4j.extractChecklistProgress)(data),
        createdBy: (0, $fmv4j.extractCreatedBy)(data),
        ownedBy: (0, $fmv4j.extractOwnedBy)(data),
        assignedTo: (0, $fmv4j.extractAssignedTo)(data),
        createdOn: (0, $h1sO6.extractDateCreated)(data),
        dueOn: (0, $fmv4j.extractDueOn)(data),
        viewAction: (0, $eywmF.extractViewAction)(data, actionOptions),
        latestCommit: (0, $asvOI.extractLatestCommit)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response, renderers),
        location: (0, $fmv4j.extractLocation)(data),
        modifiedBy: (0, $fmv4j.extractModifiedBy)(data),
        modifiedOn: (0, $dGfXu.extractDateUpdated)(data),
        preview: (0, $ket3S.default)(data),
        priority: (0, $77p4K.default)(data),
        provider: (0, $9BBAF.default)(data),
        programmingLanguage: (0, $fmv4j.extractProgrammingLanguage)(data),
        readTime: (0, $fmv4j.extractReadTime)(data),
        sentOn: (0, $fmv4j.extractSentOn)(data),
        snippet: (0, $4zMKr.extractSummary)(data) || undefined,
        sourceBranch: (0, $fmv4j.extractSourceBranch)(data),
        state: (0, $2umDH.default)(response, actionOptions, id),
        subscriberCount: (0, $fmv4j.extractSubscriberCount)(data),
        subTasksProgress: (0, $fmv4j.extractSubTasksProgress)(data),
        storyPoints: (0, $fmv4j.extractStoryPoints)(data),
        targetBranch: (0, $fmv4j.extractTargetBranch)(data),
        title: (0, $a4gSw.extractTitle)(data) || url,
        url: url,
        ari: (0, $1qrFi.extractAri)(data)
    };
};
var $a709dad76fe90a85$export$2e2bcd8739ae039 = $a709dad76fe90a85$var$extractFlexibleUiContext;

});
parcelRegister("8hH6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $53addcfa7a39f29f$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");

var $ehbIu = parcelRequire("ehbIu");

var $RO4Pi = parcelRequire("RO4Pi");

var $amwpE = parcelRequire("amwpE");

var $6qhhh = parcelRequire("6qhhh");

var $zhR2s = parcelRequire("zhR2s");

var $1GqIw = parcelRequire("1GqIw");

var $gK2mf = parcelRequire("gK2mf");
const $53addcfa7a39f29f$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
    const data = response.data;
    const action = {
        [(0, $caOA9.ActionName).CopyLinkAction]: (0, $zhR2s.extractCopyLinkAction)(data, actionOptions),
        [(0, $caOA9.ActionName).DownloadAction]: (0, $ehbIu.extractDownloadAction)(data, actionOptions),
        [(0, $caOA9.ActionName).FollowAction]: (0, $6qhhh.default)(response, actionOptions, id),
        [(0, $caOA9.ActionName).PreviewAction]: (0, $RO4Pi.extractPreviewAction)(response, actionOptions),
        [(0, $caOA9.ActionName).AutomationAction]: (0, $1GqIw.extractAutomationAction)(response),
        [(0, $caOA9.InternalActionName).AISummaryAction]: (0, $amwpE.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-view-related-urls-action') ? {
            [(0, $caOA9.InternalActionName).ViewRelatedLinksAction]: (0, $gK2mf.extractViewRelatedLinksAction)(response)
        } : {}
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
var $53addcfa7a39f29f$export$2e2bcd8739ae039 = $53addcfa7a39f29f$var$extractActions;

});
parcelRegister("ehbIu", function(module, exports) {

$parcel$export(module.exports, "extractDownloadAction", () => $66eea790b8ba0e58$export$e2076b2e4a490ac5);

var $44Wm8 = parcelRequire("44Wm8");

var $hqABm = parcelRequire("hqABm");

var $e3WTQ = parcelRequire("e3WTQ");

var $lIFl3 = parcelRequire("lIFl3");
const $66eea790b8ba0e58$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions)) return;
    const downloadActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data)
    };
    return;
};

});

parcelRegister("RO4Pi", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $834bef11f28eb280$export$eba2f3246148e526);

var $lIFl3 = parcelRequire("lIFl3");

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $903Mk = parcelRequire("903Mk");

var $dB5lQ = parcelRequire("dB5lQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $834bef11f28eb280$export$eba2f3246148e526 = (response, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $fQDHB.extractPreview)(data, 'web')?.src;
    if (src) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data),
        providerName: (0, $ebCNT.extractProvider)(data)?.text,
        src: src,
        title: (0, $a4gSw.extractTitle)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response),
        url: (0, $lnW6z.extractLink)(data),
        isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
    };
};

});
parcelRegister("903Mk", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $3d22e311bd34cc2d$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $3d22e311bd34cc2d$export$bdd29be9b0395931);

var $gaEk5 = parcelRequire("gaEk5");

var $9BBAF = parcelRequire("9BBAF");

var $caOA9 = parcelRequire("caOA9");

var $eYh51 = parcelRequire("eYh51");
const $3d22e311bd34cc2d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $eYh51.default)(data, renderers);
    return {
        ...(0, $gaEk5.default)(data),
        render: render
    };
};
const $3d22e311bd34cc2d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $9BBAF.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $caOA9.IconType).Forbidden
            };
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                icon: (0, $caOA9.IconType).Error
            };
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $caOA9.IconType).Default
            };
    }
};

});
parcelRegister("gaEk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $022ee8dc75d3db15$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $4DxpJ = parcelRequire("4DxpJ");

var $60G1O = parcelRequire("60G1O");

var $iTTUV = parcelRequire("iTTUV");

var $WIkzi = parcelRequire("WIkzi");

var $9BBAF = parcelRequire("9BBAF");

var $d5yin = parcelRequire("d5yin");

var $jy3WR = parcelRequire("jy3WR");

var $a4gSw = parcelRequire("a4gSw");

var $2aTcn = parcelRequire("2aTcn");

var $caOA9 = parcelRequire("caOA9");

var $4afqa = parcelRequire("4afqa");
const $022ee8dc75d3db15$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $jy3WR.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $022ee8dc75d3db15$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0] : type;
};
const $022ee8dc75d3db15$var$isConfluenceProvider = (provider)=>provider === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID);
const $022ee8dc75d3db15$var$isJiraProvider = (provider)=>provider === (0, $4DxpJ.JIRA_GENERATOR_ID);
const $022ee8dc75d3db15$var$isNativeProvider = (provider)=>$022ee8dc75d3db15$var$isConfluenceProvider(provider) || $022ee8dc75d3db15$var$isJiraProvider(provider);
function $022ee8dc75d3db15$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $iTTUV.default)(fileFormat);
    const documentTypeIcon = $022ee8dc75d3db15$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $60G1O.default)(type, label);
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $022ee8dc75d3db15$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $caOA9.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $caOA9.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $caOA9.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $caOA9.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $caOA9.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $caOA9.IconType).Task,
                label: taskLabel
            };
            if ($022ee8dc75d3db15$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $022ee8dc75d3db15$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $WIkzi.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $022ee8dc75d3db15$var$extractJsonldDataIcon = (data)=>{
    const generator = data.generator;
    const label = (0, $a4gSw.extractTitle)(data);
    const type = $022ee8dc75d3db15$var$extractType(data);
    const urlIcon = (0, $d5yin.default)(data.icon, label);
    const provider = generator?.['@id'];
    const providerIcon = (0, $9BBAF.default)(data);
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour')) return $022ee8dc75d3db15$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            // If we encounter a native provider, we privilege the
            // icon generated by its mime type and document type.
            // Otherwise, we privilege the provider icon,
            // followed by mime type and document type icon.
            const documentData = data;
            const fileFormat = documentData?.['schema:fileFormat'];
            const fileFormatIcon = (0, $iTTUV.default)(fileFormat);
            const documentTypeIcon = (0, $60G1O.default)(type, label);
            return $022ee8dc75d3db15$var$isNativeProvider(provider) ? fileFormatIcon || documentTypeIcon || urlIcon || providerIcon : providerIcon || fileFormatIcon || documentTypeIcon;
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            if ($022ee8dc75d3db15$var$isJiraProvider(provider)) {
                const { taskType: taskType, taskIcon: taskIcon } = $022ee8dc75d3db15$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || urlIcon || providerIcon || {
                    icon: (0, $caOA9.IconType).Task,
                    label: taskLabel
                } : (0, $WIkzi.default)(taskType, taskLabel);
            }
            return {
                icon: (0, $caOA9.IconType).Task,
                label: taskLabel
            };
        case 'atlassian:Goal':
            return urlIcon || {
                icon: (0, $caOA9.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return urlIcon || {
                icon: (0, $caOA9.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $caOA9.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $caOA9.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $caOA9.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $caOA9.IconType).Repo,
                label: label || 'Repository'
            };
        default:
            return providerIcon;
    }
};
var $022ee8dc75d3db15$export$2e2bcd8739ae039 = $022ee8dc75d3db15$var$extractJsonldDataIcon;

});
parcelRegister("60G1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaccd265493698eb$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $aaccd265493698eb$var$extractDocumentTypeIcon = (documentType, label)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $caOA9.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            return {
                icon: (0, $caOA9.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $caOA9.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $aaccd265493698eb$export$2e2bcd8739ae039 = $aaccd265493698eb$var$extractDocumentTypeIcon;

});

parcelRegister("iTTUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa68e49b5e1b13b$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $cfa68e49b5e1b13b$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $caOA9.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $caOA9.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $caOA9.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $caOA9.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $caOA9.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $caOA9.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $caOA9.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $caOA9.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $caOA9.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $caOA9.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $caOA9.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $caOA9.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $caOA9.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $caOA9.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $caOA9.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $caOA9.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $caOA9.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $cfa68e49b5e1b13b$export$2e2bcd8739ae039 = $cfa68e49b5e1b13b$var$extractFileFormatIcon;

});

parcelRegister("WIkzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a469cd27ea0426c$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $0a469cd27ea0426c$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $caOA9.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $caOA9.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $caOA9.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $caOA9.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $caOA9.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $caOA9.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $caOA9.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $caOA9.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label
            };
    }
};
var $0a469cd27ea0426c$export$2e2bcd8739ae039 = $0a469cd27ea0426c$var$extractJiraTaskIcon;

});

parcelRegister("9BBAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a453423411755a2f$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $caOA9 = parcelRequire("caOA9");

var $d5yin = parcelRequire("d5yin");

var $a4gSw = parcelRequire("a4gSw");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $a453423411755a2f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $a4gSw.extractTitle)(data);
    if (provider === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $4DxpJ.JIRA_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $d5yin.default)(icon, label);
};
var $a453423411755a2f$export$2e2bcd8739ae039 = $a453423411755a2f$var$extractProviderIcon;

});
parcelRegister("d5yin", function(module, exports) {

$parcel$export(module.exports, "default", () => $a073a66919740263$export$2e2bcd8739ae039);

var $amPw7 = parcelRequire("amPw7");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $a073a66919740263$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $amPw7.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $a073a66919740263$export$2e2bcd8739ae039 = $a073a66919740263$var$extractUrlIcon;

});



parcelRegister("eYh51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4581489debbadb7f$export$2e2bcd8739ae039);
const $4581489debbadb7f$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4581489debbadb7f$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $4581489debbadb7f$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $4581489debbadb7f$export$2e2bcd8739ae039 = $4581489debbadb7f$var$extractIconRenderer;

});



parcelRegister("amwpE", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $38c5d89c8c4c78d5$export$e7f7a50a8b8932df);

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");

var $hZwiw = parcelRequire("hZwiw");
const $38c5d89c8c4c78d5$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).AISummaryAction, actionOptions) || !(0, $hZwiw.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});

parcelRegister("6qhhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a426c8146558b6e$export$2e2bcd8739ae039);

var $lnW6z = parcelRequire("lnW6z");
var $4yj9H = parcelRequire("4yj9H");

var $cCvxR = parcelRequire("cCvxR");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $6a426c8146558b6e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    const type = (0, $4yj9H.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $cCvxR.SmartLinkActionType).FollowEntityAction || actionName === (0, $cCvxR.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $lnW6z.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cCvxR.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6a426c8146558b6e$export$2e2bcd8739ae039 = $6a426c8146558b6e$var$extractFollowAction;

});
parcelRegister("5cnU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba438025015c1fd$export$2e2bcd8739ae039);
const $5ba438025015c1fd$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $5ba438025015c1fd$export$2e2bcd8739ae039 = $5ba438025015c1fd$var$extractServerAction;

});


parcelRegister("zhR2s", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkAction", () => $f482c27c7008fd92$export$5b7ae1fa8fdb83ba);

var $lnW6z = parcelRequire("lnW6z");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $f482c27c7008fd92$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $lnW6z.extractLink)(data);
    if (!url) return;
    return {
        url: url
    };
};

});

parcelRegister("1GqIw", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $6447dee659182c27$export$f913cc6abf3ec084);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");
const $6447dee659182c27$export$f913cc6abf3ec084 = (response)=>{
    if (!(0, $XHGTv.getBooleanFF)('platform.linking-platfom.smart-card.confluence.page.automation-action_xcdoi') || !response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $caOA9.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("gK2mf", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $d3a00a758146d92c$export$debae7424a0231b9);

var $1qrFi = parcelRequire("1qrFi");
const $d3a00a758146d92c$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $1qrFi.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("7DLuu", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $144ad24fb0523f2d$export$216e4f6aa7c169b8);

var $cx2mN = parcelRequire("cx2mN");
var $3gIUj = parcelRequire("3gIUj");
const $144ad24fb0523f2d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $cx2mN.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});

parcelRegister("77p4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e993678abbe0145f$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");

var $amPw7 = parcelRequire("amPw7");
const $e993678abbe0145f$var$priorityMapper = {
    blocker: (0, $caOA9.IconType).PriorityBlocker,
    critical: (0, $caOA9.IconType).PriorityCritical,
    high: (0, $caOA9.IconType).PriorityHigh,
    highest: (0, $caOA9.IconType).PriorityHighest,
    low: (0, $caOA9.IconType).PriorityLow,
    lowest: (0, $caOA9.IconType).PriorityLowest,
    major: (0, $caOA9.IconType).PriorityMajor,
    medium: (0, $caOA9.IconType).PriorityMedium,
    minor: (0, $caOA9.IconType).PriorityMinor,
    trivial: (0, $caOA9.IconType).PriorityTrivial,
    undefined: (0, $caOA9.IconType).PriorityUndefined
};
const $e993678abbe0145f$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $e993678abbe0145f$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $amPw7.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $e993678abbe0145f$export$2e2bcd8739ae039 = $e993678abbe0145f$var$extractPriority;

});

parcelRegister("ket3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd5351f90659454$export$2e2bcd8739ae039);

var $lbKTa = parcelRequire("lbKTa");

var $caOA9 = parcelRequire("caOA9");
const $0bd5351f90659454$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $lbKTa.extractImage)(data);
    return url ? {
        type: (0, $caOA9.MediaType).Image,
        url: url
    } : undefined;
};
var $0bd5351f90659454$export$2e2bcd8739ae039 = $0bd5351f90659454$var$extractPreview;

});

parcelRegister("2umDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ca2df7ccfe49f1$export$2e2bcd8739ae039);

var $i9zl6 = parcelRequire("i9zl6");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $lnW6z = parcelRequire("lnW6z");

var $RO4Pi = parcelRequire("RO4Pi");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $c8ca2df7ccfe49f1$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $c8ca2df7ccfe49f1$var$extractAction = (response, id)=>{
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $lnW6z.extractLink)(data);
    const previewData = response ? (0, $RO4Pi.extractPreviewAction)(response) : null;
    const details = {
        id: id,
        url: url,
        previewData: previewData
    };
    const update = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $c8ca2df7ccfe49f1$var$extractState = (response, actionOptions, id)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $i9zl6.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $c8ca2df7ccfe49f1$var$extractAction(response, id);
    return {
        ...lozenge,
        action: action
    };
};
var $c8ca2df7ccfe49f1$export$2e2bcd8739ae039 = $c8ca2df7ccfe49f1$var$extractState;

});

parcelRegister("asvOI", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $1458752047a9ffeb$export$f222392162cff0d8);
const $1458752047a9ffeb$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});

parcelRegister("eywmF", function(module, exports) {

$parcel$export(module.exports, "extractViewAction", () => $151b53176fbfdd54$export$96c7e3a7e9c64e85);

var $lnW6z = parcelRequire("lnW6z");

var $e3WTQ = parcelRequire("e3WTQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $151b53176fbfdd54$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions)) return;
    const viewActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (viewActionExists) return {
        viewUrl: (0, $lnW6z.extractLink)(data)
    };
    return undefined;
};

});



parcelRegister("f6EQU", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksViewedEvent", () => $08d93b061d67c6f8$export$b33ea4a8393685d8);
$parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", () => $08d93b061d67c6f8$export$e88153cb3e6fc3fc);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $bTNMs = parcelRequire("bTNMs");
const $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'viewed',
        actionSubject: 'relatedLinks',
        eventType: 'ui',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $08d93b061d67c6f8$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $08d93b061d67c6f8$export$e88153cb3e6fc3fc = (props)=>{
    const { children: children, details: details } = props;
    /**
	 * We don't really need the `url` to get the attributes here so set
	 * it to an empty string to just make typescript happy
	 */ const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: ''
    }, details);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes,
            component: 'relatedLink'
        }
    }, children);
};

});
parcelRegister("jfVIr", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $ea95fbff36d57274$export$7243431f5325a7b);

var $4hPjC = parcelRequire("4hPjC");

var $kFGtp = parcelRequire("kFGtp");
const $ea95fbff36d57274$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $4hPjC.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kFGtp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("kFGtp", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5);
const $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});






parcelRegister("aguBP", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockResolvingView", () => $507d5607706e35a7$export$50a43430722f62f8);

var $eUqFw = parcelRequire("eUqFw");

var $8SIiI = parcelRequire("8SIiI");

var $4sQhG = parcelRequire("4sQhG");
const $507d5607706e35a7$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SIiI.default), {
        height: 1.55,
        width: 22
    }));

});

parcelRegister("iWItW", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksLoadedEvent", () => $cf9e32bcbac3d864$export$d2852f8792c380fa);

var $bTNMs = parcelRequire("bTNMs");
const $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'loaded',
        actionSubject: 'relatedLinks',
        eventType: 'track',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $cf9e32bcbac3d864$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };

});


parcelRegister("h2NbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe889a6e310b451$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ayl0W = parcelRequire("ayl0W");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5fe889a6e310b451$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayl0W.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5fe889a6e310b451$export$2e2bcd8739ae039 = $5fe889a6e310b451$var$AISummaryBlock;

});
parcelRegister("ayl0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e07ab863de3221$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $caOA9 = parcelRequire("caOA9");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $3FvFV = parcelRequire("3FvFV");

var $i0l8Y = parcelRequire("i0l8Y");

var $d2BrZ = parcelRequire("d2BrZ");

var $4abrz = parcelRequire("4abrz");

var $04PAQ = parcelRequire("04PAQ");

var $fN7pY = parcelRequire("fN7pY");

var $4zu6H = parcelRequire("4zu6H");

var $45sl7 = parcelRequire("45sl7");

var $8xb3a = parcelRequire("8xb3a");

var $bJ9S9 = parcelRequire("bJ9S9");

var $asu8X = parcelRequire("asu8X");

var $byn9U = parcelRequire("byn9U");

var $jx2TA = parcelRequire("jx2TA");

var $XHGTv = parcelRequire("XHGTv");
const $04e07ab863de3221$export$d5337beb171cc161 = ({ showErrorIndicator: showErrorIndicator, error: error, showTransition: showTransition, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        isFadeIn: true,
        show: showErrorIndicator,
        showTransition: showTransition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJ9S9.default), {
        reason: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0l8Y.default), {
        error: error,
        state: "error",
        testId: testId
    }));
const $04e07ab863de3221$export$abb9b28ccbdde43a = ({ showStatusIndicator: showStatusIndicator, metadata: metadata, status: status, testId: testId })=>{
    const metadataElements = (0, $d2BrZ.renderElementItems)(metadata);
    return showStatusIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0l8Y.default), {
        state: status,
        testId: `${testId}-state-indicator`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        width: (0, $caOA9.SmartLinkWidth).FitToContent,
        testId: `${testId}-metadata-group`
    }, metadataElements);
};
const $04e07ab863de3221$var$AISummaryBlockResolvedView = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default), $04e07ab863de3221$export$d5337beb171cc161, $04e07ab863de3221$export$abb9b28ccbdde43a, (0, $4zu6H.default));
    const { actions: actions = [], onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, metadata: metadata, placeholder: placeholder, url: url } = props;
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const { summariseUrl: summariseUrl, state: { content: content, status: status, error: error } } = (0, $04PAQ.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eUqFw.useRef)(status === 'done');
    const isErroredOnMountRef = (0, $eUqFw.useRef)(status === 'error');
    const minHeight = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    (0, $eUqFw.useEffect)(()=>{
        // if the error was apparent on mount and the status is changed to loading we can
        // clear the initial error on mount state
        if (isErroredOnMountRef.current && status === 'loading') isErroredOnMountRef.current = false;
    }, [
        status
    ]);
    const combinedActions = (0, $eUqFw.useMemo)(()=>{
        if (status === 'ready' || status === 'error') {
            const aiAction = {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarize),
                name: (0, $caOA9.ActionName).CustomAction,
                onClick: ()=>{
                    fireEvent('ui.button.clicked.aiSummary', {});
                    fireEvent('track.aiInteraction.initiated', {
                        aiFeatureName: 'Smart Links Summary',
                        proactiveAIGenerated: 0,
                        userGeneratedAI: 1
                    });
                    summariseUrl();
                },
                testId: `${testId}-ai-summary-action`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
                    label: "AIIcon"
                }),
                /**
         * Enabling feature discovery pulse
         * Cleanup: https://product-fabric.atlassian.net/browse/EDM-9693
         */ wrapper: (0, $jx2TA.default)
            };
            return [
                aiAction,
                ...actions
            ];
        }
        return actions;
    }, [
        actions,
        status,
        testId,
        summariseUrl,
        fireEvent
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    if (!showAISummary && (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $byn9U.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss)
    }, status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xb3a.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zu6H.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content,
        showIcon: !(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && isSummarisedOnMountRef.current
    })), !(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-action-redesign') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        alignInline: "end",
        grow: "fill",
        spread: "space-between",
        testId: `${testId}-footer-metadata`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04e07ab863de3221$export$abb9b28ccbdde43a, {
        metadata: metadata,
        showStatusIndicator: !isSummarisedOnMountRef.current && (status === 'loading' || status === 'done'),
        status: status,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: combinedActions,
        appearance: "default",
        size: size
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04e07ab863de3221$export$d5337beb171cc161, {
        showErrorIndicator: !isErroredOnMountRef.current && status === 'error',
        showTransition: !isErroredOnMountRef.current,
        error: error,
        testId: `${testId}-error-indicator`
    })));
};
var $04e07ab863de3221$export$2e2bcd8739ae039 = $04e07ab863de3221$var$AISummaryBlockResolvedView;

});
parcelRegister("3FvFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $470ec6acac7c72bd$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");

var $eUqFw = parcelRequire("eUqFw");
const $470ec6acac7c72bd$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eUqFw.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $470ec6acac7c72bd$export$2e2bcd8739ae039 = $470ec6acac7c72bd$export$6118ed0013927eb2;

});

parcelRegister("i0l8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e4c55f87bf8f06$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $2sCCv = parcelRequire("2sCCv");

var $6G9JA = parcelRequire("6G9JA");

var $eECxt = parcelRequire("eECxt");
const $03e4c55f87bf8f06$var$AIStateIndicator = ({ state: state, appearance: appearance = 'default', testId: testId = 'ai-state-indicator', error: error })=>{
    switch(state){
        case 'error':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eECxt.default), {
                appearance: appearance,
                testId: testId,
                error: error
            });
        case 'loading':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2sCCv.default), {
                appearance: appearance,
                testId: testId
            });
        case 'done':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6G9JA.default), {
                appearance: appearance,
                testId: testId
            });
        default:
            return null;
    }
};
var $03e4c55f87bf8f06$export$2e2bcd8739ae039 = $03e4c55f87bf8f06$var$AIStateIndicator;

});
parcelRegister("2sCCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b12e7e8273b69c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");

var $4abrz = parcelRequire("4abrz");

var $djQ0b = parcelRequire("djQ0b");

var $2y0V4 = parcelRequire("2y0V4");
const $7b12e7e8273b69c8$var$AIStateLoading = ({ appearance: appearance, testId: testId })=>{
    switch(appearance){
        case 'icon-only':
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2y0V4.default), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQ0b.default), {
                    label: "AI",
                    size: "small",
                    testId: `${testId}-loading-icon`
                }),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    testId: `${testId}-loading-message`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarizing)),
                testId: `${testId}-loading`
            });
    }
};
var $7b12e7e8273b69c8$export$2e2bcd8739ae039 = $7b12e7e8273b69c8$var$AIStateLoading;

});
parcelRegister("djQ0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f972514403719e8$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");

var $jLlux = parcelRequire("jLlux");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $1f972514403719e8$var$bounce = (0, $byn9U.keyframes)({
    from: {
        transform: 'translateY(0)'
    },
    '16.67%': {
        transform: 'translateY(-2px)'
    },
    '33.33%': {
        transform: 'translateY(0px)'
    }
});
const $1f972514403719e8$var$BASE_DELAY = 400;
const $1f972514403719e8$var$QUEUE_DELAY = 200;
const $1f972514403719e8$var$animationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$1f972514403719e8$var$bounce} 1.2s linear infinite normal`
});
const $1f972514403719e8$var$firstDelayStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationDelay: `${$1f972514403719e8$var$BASE_DELAY + $1f972514403719e8$var$QUEUE_DELAY}ms`
});
const $1f972514403719e8$var$secondDelayStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationDelay: `${$1f972514403719e8$var$BASE_DELAY + $1f972514403719e8$var$QUEUE_DELAY * 2}ms`
});
const $1f972514403719e8$var$thirdDelayStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationDelay: `${$1f972514403719e8$var$BASE_DELAY + $1f972514403719e8$var$QUEUE_DELAY * 3}ms`
});
/**
 * this icon is theme agnostic, no need for tokens
 */ const $1f972514403719e8$var$AIIconLoading = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), props, /*#__PURE__*/ (0, $byn9U.jsx)("circle", {
        css: [
            $1f972514403719e8$var$animationStyles,
            $1f972514403719e8$var$firstDelayStyles
        ],
        cx: "6",
        cy: "12",
        r: "1.5",
        fill: (0, $jLlux.aiThemeTokens).blue700
    }), /*#__PURE__*/ (0, $byn9U.jsx)("circle", {
        css: [
            $1f972514403719e8$var$animationStyles,
            $1f972514403719e8$var$secondDelayStyles
        ],
        cx: "12",
        cy: "12",
        r: "1.5",
        fill: (0, $jLlux.aiThemeTokens).blue600
    }), /*#__PURE__*/ (0, $byn9U.jsx)("circle", {
        css: [
            $1f972514403719e8$var$animationStyles,
            $1f972514403719e8$var$thirdDelayStyles
        ],
        cx: "17.5",
        cy: "12",
        r: "1.5",
        fill: (0, $jLlux.aiThemeTokens).blue500
    }));
var $1f972514403719e8$export$2e2bcd8739ae039 = $1f972514403719e8$var$AIIconLoading;

});
parcelRegister("jLlux", function(module, exports) {

$parcel$export(module.exports, "INNER_BORDER_RADIUS", () => $def64263c2f98430$export$e9d9825cf6898271);
$parcel$export(module.exports, "OUTER_BORDER_RADIUS", () => $def64263c2f98430$export$2a2ad00ed1dae540);
$parcel$export(module.exports, "aiThemeTokens", () => $def64263c2f98430$export$3088ed82e2905d1e);
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $def64263c2f98430$export$23b7b83c7063ccfe);
const $def64263c2f98430$export$e9d9825cf6898271 = 8;
const $def64263c2f98430$export$2a2ad00ed1dae540 = 10;
const $def64263c2f98430$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $def64263c2f98430$export$23b7b83c7063ccfe = {
    dark: {
        blue: $def64263c2f98430$export$3088ed82e2905d1e.blue800,
        teal: $def64263c2f98430$export$3088ed82e2905d1e.teal500,
        yellow: $def64263c2f98430$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $def64263c2f98430$export$3088ed82e2905d1e.blue600,
        teal: $def64263c2f98430$export$3088ed82e2905d1e.teal300,
        yellow: $def64263c2f98430$export$3088ed82e2905d1e.yellow200
    }
};

});


parcelRegister("2y0V4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed47be1c7f90b117$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");
const $ed47be1c7f90b117$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px'
});
const $ed47be1c7f90b117$var$AIIndicatorContainer = ({ icon: icon, content: content, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "start",
        alignInline: "start",
        space: "space.050",
        xcss: $ed47be1c7f90b117$var$contentStyles,
        testId: testId
    }, icon, content);
};
var $ed47be1c7f90b117$export$2e2bcd8739ae039 = $ed47be1c7f90b117$var$AIIndicatorContainer;

});


parcelRegister("6G9JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e03ea2bb30f9247c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $aUqTb = parcelRequire("aUqTb");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $XHGTv = parcelRequire("XHGTv");

var $4abrz = parcelRequire("4abrz");

var $fN7pY = parcelRequire("fN7pY");

var $PKMiL = parcelRequire("PKMiL");

var $2y0V4 = parcelRequire("2y0V4");

var $fv3b5 = parcelRequire("fv3b5");
function $e03ea2bb30f9247c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e03ea2bb30f9247c$var$tooltipMsgStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px'
});
const $e03ea2bb30f9247c$var$iconTooltipLinkStyles = {
    name: "cq2x9g",
    styles: "color:var(--ds-text-subtlest, #626F86);&:link, :visited{color:var(--ds-text-subtlest, #626F86);}&:hover{color:var(--ds-text-subtle, #44546F);}&:active{color:var(--ds-text, #172B4D);}text-decoration:underline"
};
const $e03ea2bb30f9247c$var$iconTooltipTitleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px'
});
const $e03ea2bb30f9247c$var$iconTooltipDescStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '14px'
});
const $e03ea2bb30f9247c$var$iconTooltipTriggerStyles = (0, $1ZAYh.xcss)({
    verticalAlign: 'bottom'
});
const $e03ea2bb30f9247c$var$AIStateDone = ({ appearance: appearance, testId: testId })=>{
    const icon = /*#__PURE__*/ (0, $byn9U.jsx)((0, $fN7pY.default), {
        label: "AI",
        size: "small",
        testId: `${testId}-done-icon`
    });
    const title = (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries-release-stable') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: `${testId}-done-message`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: `${testId}-done-message`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized_abbreviation)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: "new",
        testId: `${testId}-beta`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).beta))));
    switch(appearance){
        case 'icon-only':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $PKMiL.default), {
                content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
                    alignBlock: "center",
                    space: "space.100"
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fN7pY.default), {
                    label: "AI",
                    size: "medium",
                    testId: `${testId}-done-tooltip-icon`
                }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    space: "space.050",
                    xcss: $e03ea2bb30f9247c$var$iconTooltipTitleStyles
                }, title), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
                    xcss: $e03ea2bb30f9247c$var$iconTooltipDescStyles
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages).ai_summarized_info,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $fv3b5.default), {
                                css: $e03ea2bb30f9247c$var$iconTooltipLinkStyles
                            }, chunks)
                    }
                })))),
                trigger: icon,
                xcss: $e03ea2bb30f9247c$var$iconTooltipTriggerStyles
            });
        default:
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2y0V4.default), {
                icon: icon,
                content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    space: "space.050"
                }, title, /*#__PURE__*/ (0, $byn9U.jsx)((0, $PKMiL.default), {
                    content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
                        xcss: $e03ea2bb30f9247c$var$tooltipMsgStyles,
                        testId: `${testId}-done-tooltip`
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
                        ...(0, $4abrz.messages).ai_summarized_info,
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $fv3b5.default), null, chunks)
                        }
                    })),
                    trigger: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                        label: "Info",
                        size: "small",
                        testId: `${testId}-done-info`
                    })
                })),
                testId: `${testId}-done`
            });
    }
};
var $e03ea2bb30f9247c$export$2e2bcd8739ae039 = $e03ea2bb30f9247c$var$AIStateDone;

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 19a7 7 0 110-14 7 7 0 010 14zm0-1.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = $7f13fdf9f823d771$var$EditorPanelIcon;
module.exports.default = $7f13fdf9f823d771$var$_default;

});

parcelRegister("PKMiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47dbd521d2abf80$export$2e2bcd8739ae039);

var $joBf7 = parcelRequire("joBf7");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $a47dbd521d2abf80$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a47dbd521d2abf80$var$AIIndicatorTooltipPrimitive = /*#__PURE__*/ (0, $joBf7.default)((0, $g3tFP.default), {
    target: "e14r56fq0"
})({
    name: "1cuxa6t",
    styles: "border-radius:var(--ds-border-radius, 3px);background-color:var(--ds-surface-raised, white);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31));box-sizing:content-box;padding:var(--ds-space-200, 16px);max-width:350px"
});
const $a47dbd521d2abf80$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex'
});
const $a47dbd521d2abf80$var$AIIndicatorTooltip = ({ content: content, trigger: trigger, xcss: overrideXcss })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        component: $a47dbd521d2abf80$var$AIIndicatorTooltipPrimitive,
        content: content,
        tag: "span"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $a47dbd521d2abf80$var$triggerStyles,
                overrideXcss
            ],
            ...tooltipProps
        }, trigger));
};
var $a47dbd521d2abf80$export$2e2bcd8739ae039 = $a47dbd521d2abf80$var$AIIndicatorTooltip;

});


parcelRegister("eECxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d3898695296314$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hZwiw = parcelRequire("hZwiw");

var $fv3b5 = parcelRequire("fv3b5");

var $2y0V4 = parcelRequire("2y0V4");
const $b6d3898695296314$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '14px'
});
const $b6d3898695296314$var$FormattedErrorMessage = ({ message: message, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...message,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fv3b5.default), {
                    href: url
                }, chunks)
        }
    });
const $b6d3898695296314$var$AIStateError = ({ appearance: appearance, testId: testId, error: error })=>{
    const { message: message, url: url } = (0, $hZwiw.getAISummaryErrorMessage)(error);
    switch(appearance){
        case 'icon-only':
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2y0V4.default), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    primaryColor: "var(--ds-icon-danger, #C9372C)",
                    label: "AI",
                    size: "small",
                    testId: `${testId}-error-icon`
                }),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    testId: `${testId}-error-message`,
                    xcss: $b6d3898695296314$var$contentStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b6d3898695296314$var$FormattedErrorMessage, {
                    message: message,
                    url: url
                })),
                testId: `${testId}-error`
            });
    }
};
var $b6d3898695296314$export$2e2bcd8739ae039 = $b6d3898695296314$var$AIStateError;

});


parcelRegister("4zu6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae60e2ff2b3e6cc$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $27B3S = parcelRequire("27B3S");

var $byn9U = parcelRequire("byn9U");

var $i0l8Y = parcelRequire("i0l8Y");

var $fRvRW = parcelRequire("fRvRW");
function $aae60e2ff2b3e6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aae60e2ff2b3e6cc$var$AITooltipIcon = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $i0l8Y.default), {
        appearance: "icon-only",
        state: "done",
        testId: "ai-tooltip"
    });
const $aae60e2ff2b3e6cc$var$AISummaryCSSStyles = {
    name: "178flxl",
    styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $aae60e2ff2b3e6cc$var$AISummary = ({ content: content = '', showIcon: showIcon = false, iconComponent: iconComponent, overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27B3S.default), {
        "data-testid": testId,
        css: [
            $aae60e2ff2b3e6cc$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: showIcon ? `${content}&nbsp;<Icon />` : content,
        options: {
            forceWrapper: true,
            overrides: {
                Icon: iconComponent ?? $aae60e2ff2b3e6cc$var$AITooltipIcon,
                ul: (0, $fRvRW.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $aae60e2ff2b3e6cc$export$2e2bcd8739ae039 = $aae60e2ff2b3e6cc$var$AISummary;

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("fRvRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $215caff20423c5d7$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $215caff20423c5d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $215caff20423c5d7$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $215caff20423c5d7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $215caff20423c5d7$var$listStyles,
        ...props
    }, children);
var $215caff20423c5d7$export$2e2bcd8739ae039 = $215caff20423c5d7$var$UList;

});


parcelRegister("8xb3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0ebde4df0a9cbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $bc0ebde4df0a9cbc$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $bc0ebde4df0a9cbc$export$2e2bcd8739ae039 = $bc0ebde4df0a9cbc$var$AIEventSummaryViewed;

});

parcelRegister("jx2TA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe83bf1a3af6385$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6BD9J = parcelRequire("6BD9J");

var $4VUiP = parcelRequire("4VUiP");
const $3fe83bf1a3af6385$var$LOCAL_STORAGE_CLIENT_KEY = '@atlaskit/smart-card';
const $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_KEY = 'action-discovery-ai-summarise';
const $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_VALUE = 'discovered';
const $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS = 15552000000; // 180 days
const $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME = 2000;
/**
 * This is a hacky solution to help with the feature discovery.
 * This implementation must be removed once the experiment is completed.
 * Cleanup on https://product-fabric.atlassian.net/browse/EDM-9649
 */ const $3fe83bf1a3af6385$var$FeatureDiscovery = ({ children: children, testId: testId })=>{
    const renderedTime = (0, $eUqFw.useRef)();
    const storageClient = (0, $eUqFw.useMemo)(()=>new (0, $6BD9J.default)($3fe83bf1a3af6385$var$LOCAL_STORAGE_CLIENT_KEY), []);
    const discovered = (0, $eUqFw.useMemo)(()=>storageClient.getItem($3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_KEY) === $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_VALUE, [
        storageClient
    ]);
    (0, $eUqFw.useEffect)(()=>{
        renderedTime.current = Date.now();
        return ()=>{
            if (!discovered && renderedTime.current) {
                const duration = Date.now() - renderedTime.current;
                if (duration > $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME) storageClient.setItemWithExpiry($3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_KEY, $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_VALUE, $3fe83bf1a3af6385$var$LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS);
            }
        };
    }, [
        storageClient,
        discovered
    ]);
    const component = (0, $eUqFw.useMemo)(()=>{
        if (!discovered) return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $4VUiP.getPulseStyles)(),
            "data-testid": `${testId}-discovery`
        }, children));
    }, [
        children,
        discovered,
        testId
    ]);
    return component ?? children;
};
var $3fe83bf1a3af6385$export$2e2bcd8739ae039 = $3fe83bf1a3af6385$var$FeatureDiscovery;

});
parcelRegister("4VUiP", function(module, exports) {

$parcel$export(module.exports, "getPulseStyles", () => $7448e59b0b87da28$export$4c553574c9c58dea);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $7448e59b0b87da28$export$4c553574c9c58dea = ()=>{
    const color = "var(--ds-border-discovery, #8270DB)";
    const pulseKeyframes = (0, $byn9U.keyframes)({
        to: {
            boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        display: 'inline-flex',
        borderRadius: '3px',
        boxShadow: `0 0 0 0 ${color}`,
        animation: `${pulseKeyframes} 2s cubic-bezier(0.5, 0, 0, 1) 0.25s both 2`
    });
};

});




parcelRegister("jgolE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f51aa4942c7ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AgCU = parcelRequire("4AgCU");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $64f51aa4942c7ea2$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AgCU.default), {
        ...props,
        testId: testId
    });
};
var $64f51aa4942c7ea2$export$2e2bcd8739ae039 = $64f51aa4942c7ea2$var$AIFooterBlock;

});
parcelRegister("4AgCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ddf1676e35a244$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $7IEJa = parcelRequire("7IEJa");

var $4AAjx = parcelRequire("4AAjx");
const $f4ddf1676e35a244$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IEJa.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $f4ddf1676e35a244$export$2e2bcd8739ae039 = $f4ddf1676e35a244$var$AIFooterBlockResolvedView;

});
parcelRegister("7IEJa", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $de37226e2d74f64d$export$175228cc2c92b3b6);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $asu8X = parcelRequire("asu8X");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fN7pY = parcelRequire("fN7pY");

var $f9UoZ = parcelRequire("f9UoZ");

var $4abrz = parcelRequire("4abrz");

var $04PAQ = parcelRequire("04PAQ");
const $de37226e2d74f64d$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UoZ.InfoIcon), {
            label: "Information",
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
        label: "AI",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("f9UoZ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $73dd1366f48d3276$export$2957fc44b3d2481);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $73dd1366f48d3276$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
const $73dd1366f48d3276$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $73dd1366f48d3276$var$CustomGlyph
    });

});




parcelRegister("5I51G", function(module, exports) {

$parcel$export(module.exports, "default", () => $af32a75a0d93a295$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $eJljw = parcelRequire("eJljw");

var $4z862 = parcelRequire("4z862");

var $kbWJ8 = parcelRequire("kbWJ8");

var $asu8X = parcelRequire("asu8X");
function $af32a75a0d93a295$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af32a75a0d93a295$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $af32a75a0d93a295$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $af32a75a0d93a295$var$sort = (a, b)=>{
    let idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $af32a75a0d93a295$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $asu8X.di)((0, $kbWJ8.ActionFooter));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const onLoadingChange = (0, $eUqFw.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $4z862.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $caOA9.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eUqFw.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eUqFw.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($af32a75a0d93a295$var$sort);
        return arr.map((name)=>{
            const Action = name in $eJljw ? $eJljw[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                xcss: (0, $1ZAYh.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $af32a75a0d93a295$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbWJ8.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $af32a75a0d93a295$export$2e2bcd8739ae039 = $af32a75a0d93a295$var$ActionBlock;

});
parcelRegister("kbWJ8", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $9ecf2b3307383602$export$2d2b754ac238f9aa);

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $3FvFV = parcelRequire("3FvFV");
const $9ecf2b3307383602$var$containerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $9ecf2b3307383602$var$errorStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9ecf2b3307383602$var$titleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px'
});
const $9ecf2b3307383602$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: "Error",
                size: "small",
                testId: "action-error-icon"
            });
        default:
            return null;
    }
};
const $9ecf2b3307383602$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: `${testId}-footer`,
        xcss: [
            $9ecf2b3307383602$var$containerStyles,
            message.appearance === 'error' && $9ecf2b3307383602$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.050"
    }, message.icon || $9ecf2b3307383602$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ecf2b3307383602$var$titleStyles
    }, message.title))));
};

});







parcelRegister("2v0K6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e456a96ecd62ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $kKYlt = parcelRequire("kKYlt");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $ebCNT = parcelRequire("ebCNT");

var $03mTY = parcelRequire("03mTY");

var $eDeuK = parcelRequire("eDeuK");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $ibKIt = parcelRequire("ibKIt");

var $269iK = parcelRequire("269iK");
const $51e456a96ecd62ea$var$HoverCardUnauthorisedView = ({ analytics: analytics, extensionKey: extensionKey, id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const data = cardState.details?.data;
    const providerName = (0, $ebCNT.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $269iK.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $ibKIt.useSmartCardActions)(id, url, analytics);
    const handleAuthorize = (0, $eUqFw.useCallback)(()=>{
        if (authorize) {
            analytics.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            authorize((0, $caOA9.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        extensionKey,
        analytics.track
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                name: (0, $caOA9.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDeuK.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported,
        analytics: analytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.connectButtonStyles),
        testId: `${testId}-button`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $51e456a96ecd62ea$export$2e2bcd8739ae039 = $51e456a96ecd62ea$var$HoverCardUnauthorisedView;

});
parcelRegister("kKYlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $097b0e074c8851f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $fzEHL = parcelRequire("fzEHL");

var $4AAjx = parcelRequire("4AAjx");

var $fM0Kr = parcelRequire("fM0Kr");

var $8ru2D = parcelRequire("8ru2D");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $097b0e074c8851f3$var$FlexibleCard = ({ analytics: analytics, appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, renderers: renderers, showAuthTooltip: showAuthTooltip, showHoverPreview: showHoverPreview, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $8ru2D.useAISummaryConfig)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eUqFw.useMemo)(()=>(0, $fM0Kr.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            response: details,
            id: id,
            renderers: renderers,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        details,
        id,
        renderers,
        actionOptions,
        status,
        url
    ]);
    const retry = (0, $fM0Kr.getRetryOptions)(url, status, details, onAuthorize);
    const { title: title } = context || {};
    const analyticsContext = (0, $eUqFw.useMemo)(()=>analytics ? {
            ...analytics,
            display: appearance,
            extensionKey: details?.meta?.key
        } : undefined, [
        analytics,
        appearance,
        details?.meta?.key
    ]);
    (0, $eUqFw.useEffect)(()=>{
        switch(status){
            case (0, $caOA9.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $caOA9.SmartLinkStatus).Errored:
            case (0, $caOA9.SmartLinkStatus).Fallback:
            case (0, $caOA9.SmartLinkStatus).Forbidden:
            case (0, $caOA9.SmartLinkStatus).NotFound:
            case (0, $caOA9.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiAnalyticsContext).Provider, {
        value: analyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiOptionContext).Provider, {
        value: ui
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fzEHL.default), {
        testId: testId,
        ...ui,
        onClick: onClick,
        retry: retry,
        showHoverPreview: showHoverPreview,
        actionOptions: actionOptions,
        showAuthTooltip: showAuthTooltip,
        status: status
    }, children))));
};
var $097b0e074c8851f3$export$2e2bcd8739ae039 = $097b0e074c8851f3$var$FlexibleCard;

});
parcelRegister("fzEHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c35613b0ba2456e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $6oJXW = parcelRequire("6oJXW");

var $4AAjx = parcelRequire("4AAjx");

var $hpCTJ = parcelRequire("hpCTJ");

var $7YoZZ = parcelRequire("7YoZZ");

var $lcwz5 = parcelRequire("lcwz5");

var $PdmhA = parcelRequire("PdmhA");

var $asu8X = parcelRequire("asu8X");
function $1c35613b0ba2456e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c35613b0ba2456e$var$elevationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    border: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40)})`}`,
    borderRadius: "var(--ds-border-radius-200, 8px)",
    margin: "var(--ds-space-025, 2px)"
});
const $1c35613b0ba2456e$var$getGap = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $1c35613b0ba2456e$var$getPadding = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $1c35613b0ba2456e$var$clickableContainerStyles = {
    name: "1ubcigm",
    styles: "a, button, .has-action{position:relative;z-index:1;}"
};
const $1c35613b0ba2456e$var$getContainerPaddingStyles = (size, hidePadding, childrenOptions)=>{
    const padding = hidePadding ? '0rem' : $1c35613b0ba2456e$var$getPadding(size);
    const gap = $1c35613b0ba2456e$var$getGap(size);
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = childrenOptions;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-padding': padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-gap-left': previewOnLeft ? gap : padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-gap-right': previewOnRight ? gap : padding,
        '--preview-block-width': '30%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    previewOnLeft ? `padding-left: calc(var(--preview-block-width) + ${gap});` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    previewOnRight ? `padding-right: calc(var(--preview-block-width) + ${gap});` : '');
};
const $1c35613b0ba2456e$var$getChildrenOptions = (children, context)=>{
    let options = {};
    if ((0, $lcwz5.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
            if ((0, $6oJXW.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $caOA9.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $caOA9.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $1c35613b0ba2456e$export$8947b11ec08f5f9d = (size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions)=>{
    const paddingCss = $1c35613b0ba2456e$var$getContainerPaddingStyles(size, hidePadding, childrenOptions);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:flex;gap:", $1c35613b0ba2456e$var$getGap(size), " 0;flex-direction:column;min-width:0;overflow-x:hidden;position:relative;", hideBackground ? '' : `background-color: ${"var(--ds-surface-raised, #FFFFFF)"};`, " ", paddingCss, " ", hideElevation ? '' : $1c35613b0ba2456e$var$elevationStyles, " ", clickableContainer ? $1c35613b0ba2456e$var$clickableContainerStyles : '', " &:hover~.actions-button-group{opacity:1;}a:focus,.has-action:focus{outline-offset:-2px;}");
};
const $1c35613b0ba2456e$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        // TODO: EDM-6468: Use useFlexibleUiOptionContext for rendering options inside block/element instead
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) && (0, $6oJXW.isFlexibleUiBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $6oJXW.isFlexibleUiTitleBlock)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                onClick: // @ts-expect-error
                onClick,
                retry: retry,
                size: size,
                status: status,
                theme: containerTheme
            });
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                size: size,
                status: status
            });
        }
    });
const $1c35613b0ba2456e$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).find((child)=>(0, $6oJXW.isFlexibleUiTitleBlock)(child));
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(block)) return block.props;
};
const $1c35613b0ba2456e$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $1c35613b0ba2456e$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hpCTJ.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $1c35613b0ba2456e$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hideHoverCardPreviewButton: hideHoverCardPreviewButton = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showAuthTooltip: showAuthTooltip = false, showHoverPreview: showHoverPreview = false, actionOptions: actionOptions, size: size = (0, $caOA9.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $caOA9.SmartLinkTheme).Link })=>{
    (0, $asu8X.di)((0, $7YoZZ.default));
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const childrenOptions = $1c35613b0ba2456e$var$getChildrenOptions(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showAuthTooltip && status === 'unauthorized' && retry !== undefined;
    const container = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $1c35613b0ba2456e$export$8947b11ec08f5f9d(size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions),
        "data-smart-link-container": true,
        "data-testid": testId
    }, clickableContainer ? $1c35613b0ba2456e$var$getLayeredLink(testId, context, children, onClick) : null, $1c35613b0ba2456e$var$renderChildren(children, size, theme, status, retry, onClick));
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7YoZZ.default), {
        hideHoverCardPreviewButton: hideHoverCardPreviewButton,
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url
    }, container);
    return container;
};
var $1c35613b0ba2456e$export$2e2bcd8739ae039 = $1c35613b0ba2456e$var$Container;

});
parcelRegister("hpCTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7847f320889d9cf9$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");
function $7847f320889d9cf9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7847f320889d9cf9$var$styles = {
    name: "1mlo8gi",
    styles: "top:0;right:0;bottom:0;left:0;overflow:hidden;text-indent:100%;white-space:nowrap;a&.layered-link{position:absolute;z-index:0;}&:hover ~ *{.actions-button-group{opacity:1;}}"
};
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $7847f320889d9cf9$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "layered-link",
        css: $7847f320889d9cf9$var$styles,
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1
    }, text);
};
var $7847f320889d9cf9$export$2e2bcd8739ae039 = $7847f320889d9cf9$var$LayeredLink;

});

parcelRegister("7YoZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d52849f89264e22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2663 = parcelRequire("l2663");

var $caOA9 = parcelRequire("caOA9");
const $3d52849f89264e22$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $3d52849f89264e22$var$HoverCardControl = ({ children: children, hideHoverCardPreviewButton: hideHoverCardPreviewButton, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $3d52849f89264e22$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY })=>{
    const [canOpen, setCanOpen] = (0, $eUqFw.useState)(true);
    const mouseStopTimer = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eUqFw.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $caOA9.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        hidePreviewButton: hideHoverCardPreviewButton,
        actionOptions: actionOptions,
        url: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`
    }, children));
};
var $3d52849f89264e22$export$2e2bcd8739ae039 = $3d52849f89264e22$var$HoverCardControl;

});

parcelRegister("lcwz5", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $499e41af2307ecea$export$783c1bf8fee63f80);
const $499e41af2307ecea$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});


parcelRegister("fM0Kr", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $046cdf71ac9af491$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $046cdf71ac9af491$export$f3d3482baaff4bf6);

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");

var $8tvRs = parcelRequire("8tvRs");

var $4abrz = parcelRequire("4abrz");

var $fsHAt = parcelRequire("fsHAt");

var $903Mk = parcelRequire("903Mk");

var $9A6mL = parcelRequire("9A6mL");

var $ebCNT = parcelRequire("ebCNT");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");
const $046cdf71ac9af491$export$e68aec76e359e401 = (params)=>{
    const { response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return {
                title: url,
                url: url
            };
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return (0, $fsHAt.default)(params);
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            const preview = (0, $ket3S.default)(response?.data);
            const linkIcon = (0, $903Mk.extractErrorIcon)(response, status);
            const provider = (0, $9BBAF.default)(response?.data);
            return {
                linkIcon: linkIcon,
                title: url,
                url: url,
                provider: provider,
                preview: preview
            };
    }
};
const $046cdf71ac9af491$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return 'join_to_view';
        case 'REQUEST_ACCESS':
            return 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $046cdf71ac9af491$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const data = response && response.data || (0, $7pH5u.getEmptyJsonLd)();
    const provider = (0, $ebCNT.extractProvider)(data);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
            const access = (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $046cdf71ac9af491$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $4abrz.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $9A6mL.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $4abrz.messages).connect_link_account_card_name,
                onClick: (0, $9A6mL.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $4abrz.messages).cannot_find_link
            };
    }
};

});
parcelRegister("8tvRs", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $3c50b4df075e1149$export$846c1540a86749e6);

var $4abrz = parcelRequire("4abrz");

var $lGrBa = parcelRequire("lGrBa");

var $8Wyjt = parcelRequire("8Wyjt");

var $bTNMs = parcelRequire("bTNMs");
const $3c50b4df075e1149$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $8Wyjt.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $4abrz.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $4abrz.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $lGrBa.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $4abrz.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $4abrz.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("lGrBa", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $3d1a270b54bff24e$export$59f8830fb5467e35);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");
const $3d1a270b54bff24e$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $4abrz.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("8Wyjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a55e9b430ce63e07$export$2e2bcd8739ae039);
const $a55e9b430ce63e07$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $a55e9b430ce63e07$export$2e2bcd8739ae039 = $a55e9b430ce63e07$var$extractHostname;

});




parcelRegister("03mTY", function(module, exports) {

$parcel$export(module.exports, "connectButtonStyles", () => $02f66405c7d8fa7c$export$e63cb455d3692ef0);
$parcel$export(module.exports, "titleBlockStyles", () => $02f66405c7d8fa7c$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $02f66405c7d8fa7c$export$a8a26925e3db0ef6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $02f66405c7d8fa7c$var$blockGap = '0.5rem';
const $02f66405c7d8fa7c$var$iconGap = '0.5rem';
const $02f66405c7d8fa7c$var$titleFontWeight = '500';
const $02f66405c7d8fa7c$export$e63cb455d3692ef0 = /*#__PURE__*/ (0, $byn9U.css)({
    justifyContent: 'flex-end',
    marginTop: $02f66405c7d8fa7c$var$blockGap
});
const $02f66405c7d8fa7c$export$38125fa6916f5dab = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${$02f66405c7d8fa7c$var$blockGap} ${$02f66405c7d8fa7c$var$iconGap}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        fontWeight: $02f66405c7d8fa7c$var$titleFontWeight
    }
});
const $02f66405c7d8fa7c$export$a8a26925e3db0ef6 = /*#__PURE__*/ (0, $byn9U.css)({
    marginTop: $02f66405c7d8fa7c$var$blockGap,
    fontSize: '0.75rem'
});

});

parcelRegister("eDeuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d0b603118aba1b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $caOA9 = parcelRequire("caOA9");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $14d0b603118aba1b$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content', analytics: analytics })=>{
    const handleLearnMoreClick = (0, $eUqFw.useCallback)(()=>{
        analytics?.ui.learnMoreClickedEvent();
    }, [
        analytics?.ui
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $4abrz.messages).learn_more_about_connecting_account : (0, $4abrz.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).connect_unauthorised_account_description,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).connect_unauthorised_account_description_no_provider), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: isProductIntegrationSupported ? (0, $caOA9.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $caOA9.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        "data-testid": `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), learnMoreMessage)));
};
var $14d0b603118aba1b$export$2e2bcd8739ae039 = $14d0b603118aba1b$var$UnauthorisedViewContent;

});


parcelRegister("iWhYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $03155fabde6a047b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $h2NbM = parcelRequire("h2NbM");
var $4sQhG = parcelRequire("4sQhG");
var $kcn2F = parcelRequire("kcn2F");
var $cIk4w = parcelRequire("cIk4w");
var $8jYmN = parcelRequire("8jYmN");
var $bTLTu = parcelRequire("bTLTu");
var $4bEHq = parcelRequire("4bEHq");

var $9OsQy = parcelRequire("9OsQy");

var $kKYlt = parcelRequire("kKYlt");

var $crquY = parcelRequire("crquY");

var $fjZxK = parcelRequire("fjZxK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $XHGTv = parcelRequire("XHGTv");

var $269iK = parcelRequire("269iK");

var $04PAQ = parcelRequire("04PAQ");

var $asu8X = parcelRequire("asu8X");
const $03155fabde6a047b$export$c2949e393fa25b77 = (cardActions, onActionClick)=>{
    const followAction = {
        hideIcon: true,
        name: (0, $caOA9.ActionName).FollowAction
    };
    const actions = cardActions.map((action)=>{
        if (action.id === 'preview-content') return {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
            name: (0, $caOA9.ActionName).CustomAction,
            onClick: ()=>{
                if (onActionClick) onActionClick(action.id);
                return action.invoke();
            },
            testId: action.id,
            appearance: 'primary'
        };
        return {
            content: action.text,
            name: (0, $caOA9.ActionName).CustomAction,
            onClick: ()=>{
                if (onActionClick) onActionClick(action.id);
                return action.invoke();
            },
            testId: action.id
        };
    });
    return [
        followAction,
        ...actions
    ];
};
//This component encapsulates useAISummarySmartLink hook under the AI Summary FF 'platform.linking-platform.smart-card.hover-card-ai-summaries'
const $03155fabde6a047b$var$ConnectedAIBlock = ({ bottomPrimary: bottomPrimary, imagePreview: imagePreview, url: url })=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { state: { status: status, content: content } } = (0, $04PAQ.default)(url);
    const showData = status === 'ready' || status === 'error' || // Description & bottom metadata should only disappear when we start getting summary content
    !content && status === 'loading';
    return showData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !imagePreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        testId: 'connected-AI',
        status: (0, $caOA9.SmartLinkStatus).Resolved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: bottomPrimary,
        size: (0, $caOA9.SmartLinkSize).Large,
        overrideCss: (0, $9OsQy.metadataBlockCss),
        maxLines: 1,
        status: (0, $caOA9.SmartLinkStatus).Resolved
    })) : null;
};
const $03155fabde6a047b$var$HoverCardResolvedView = ({ flexibleCardProps: flexibleCardProps, titleBlockProps: titleBlockProps, analytics: analytics, cardState: cardState, cardActions: cardActions = [], isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, extensionKey: extensionKey, url: url })=>{
    const canBeDatasource = (0, $269iK.getCanBeDatasource)(cardState.details);
    (0, $eUqFw.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        analytics.ui.renderSuccessEvent({
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            status: cardState.status,
            canBeDatasource: canBeDatasource
        });
    }, [
        analytics.ui,
        cardState.status,
        canBeDatasource
    ]);
    const footerActions = (0, $eUqFw.useMemo)(()=>$03155fabde6a047b$export$c2949e393fa25b77(cardActions, onActionClick), [
        cardActions,
        onActionClick
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary, tertiary: tertiary } = (0, $eUqFw.useMemo)(()=>{
        return (0, $crquY.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const snippetBlockRef = (0, $eUqFw.useRef)(null);
    const onSnippetRender = (0, $eUqFw.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    // We want to maintain the height of the HoverCard while summarizing and pass this height to the AISummaryBlock.
    // This approach will prevent any abrupt changes in the height of the HoverCard.
    const connectedAIBlockHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const connectedAIBlockRef = (0, $eUqFw.useRef)(null);
    const onConnectedAIBlockRender = (0, $eUqFw.useCallback)(()=>{
        connectedAIBlockHeight.current = connectedAIBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $fjZxK.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
        ...titleBlockProps,
        metadataPosition: (0, $caOA9.SmartLinkPosition).Top
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: primary,
        secondary: secondary,
        overrideCss: (0, $9OsQy.metadataBlockCss),
        maxLines: 1,
        size: (0, $caOA9.SmartLinkSize).Medium
    }), isAISummaryEnabled && // All custom elements should be contained within a CustomBlock.
    // Flex Container components check whether the direct child is a flex blocks. It removes anything that isn't
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        onRender: onConnectedAIBlockRender,
        blockRef: connectedAIBlockRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03155fabde6a047b$var$ConnectedAIBlock, {
        imagePreview: !!imagePreview,
        bottomPrimary: tertiary,
        url: url
    })), !isAISummaryEnabled && !imagePreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        status: (0, $caOA9.SmartLinkStatus).Resolved
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        testId: 'hidden-snippet',
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        overrideCss: (0, $9OsQy.hiddenSnippetStyles)
    }), !isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: tertiary,
        size: (0, $caOA9.SmartLinkSize).Large,
        overrideCss: (0, $9OsQy.metadataBlockCss),
        maxLines: 1,
        status: (0, $caOA9.SmartLinkStatus).Resolved
    }), (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-hover-card-related-urls') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jYmN.default), {
        url: url,
        size: (0, $caOA9.SmartLinkSize).Small
    }), isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2NbM.default), {
        metadata: [
            {
                name: (0, $caOA9.ElementName).Provider
            }
        ],
        actions: footerActions,
        aiSummaryMinHeight: connectedAIBlockHeight.current
    }), !isAISummaryEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcn2F.default), {
        actions: footerActions,
        size: (0, $caOA9.SmartLinkSize).Large,
        overrideCss: (0, $9OsQy.footerBlockCss)
    }));
};
var $03155fabde6a047b$export$2e2bcd8739ae039 = $03155fabde6a047b$var$HoverCardResolvedView;

});
parcelRegister("9OsQy", function(module, exports) {

$parcel$export(module.exports, "metadataBlockCss", () => $0281bb6549b2b889$export$6d2a8e6ec8eaf792);
$parcel$export(module.exports, "footerBlockCss", () => $0281bb6549b2b889$export$1ede44d22c218cc4);
$parcel$export(module.exports, "hiddenSnippetStyles", () => $0281bb6549b2b889$export$a0cfecf316f11fd2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lVbJo = parcelRequire("lVbJo");
function $0281bb6549b2b889$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0281bb6549b2b889$var$elementGap = '0.5rem';
const $0281bb6549b2b889$export$6d2a8e6ec8eaf792 = /*#__PURE__*/ (0, $byn9U.css)("gap:0px;[data-smart-element-group]:nth-of-type(1){flex-grow:7;", (0, $lVbJo.separatorCss), ">span{margin-right:", $0281bb6549b2b889$var$elementGap, ";}}[data-smart-element-group]:nth-of-type(2){flex-grow:3;>span{margin-left:", $0281bb6549b2b889$var$elementGap, ";}}[data-smart-element-group]{line-height:1rem;}");
const $0281bb6549b2b889$export$1ede44d22c218cc4 = {
    name: "eqx0xi",
    styles: "height:1.5rem"
};
const $0281bb6549b2b889$export$a0cfecf316f11fd2 = {
    name: "546l7a",
    styles: "visibility:hidden;position:absolute"
};

});

parcelRegister("fjZxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf1f99a9e4f883d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ket3S = parcelRequire("ket3S");

var $d9NWW = parcelRequire("d9NWW");

var $lVbJo = parcelRequire("lVbJo");
const $ebf1f99a9e4f883d$var$ImagePreview = ({ data: data, fallbackElementHeight: fallbackElementHeight })=>{
    const transitionStarted = (0, $eUqFw.useRef)(false);
    const previewBlockRef = (0, $eUqFw.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eUqFw.useState)(true);
    const [previewCss, setPreviewCss] = (0, $eUqFw.useState)();
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eUqFw.useCallback)(()=>{
        previewBlockRef.current && setPreviewCss((0, $lVbJo.getPreviewBlockStyles)(previewBlockRef.current?.getBoundingClientRect().height));
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eUqFw.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setPreviewCss((0, $lVbJo.getTransitionStyles)(fallbackElementHeight));
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eUqFw.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && data && (0, $ket3S.default)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        overrideCss: previewCss,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender
    }) : null;
};
var $ebf1f99a9e4f883d$export$2e2bcd8739ae039 = $ebf1f99a9e4f883d$var$ImagePreview;

});


parcelRegister("jVUJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d329f21429fe8f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $269iK = parcelRequire("269iK");

var $kKYlt = parcelRequire("kKYlt");

var $5I51G = parcelRequire("5I51G");
var $jgolE = parcelRequire("jgolE");
var $h2NbM = parcelRequire("h2NbM");
var $cIk4w = parcelRequire("cIk4w");
var $bTLTu = parcelRequire("bTLTu");
var $4bEHq = parcelRequire("4bEHq");

var $crquY = parcelRequire("crquY");

var $fjZxK = parcelRequire("fjZxK");

var $9OsQy = parcelRequire("9OsQy");
const $6d329f21429fe8f2$var$HoverCardResolvedView = ({ analytics: analytics, cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps })=>{
    const canBeDatasource = (0, $269iK.getCanBeDatasource)(cardState.details);
    (0, $eUqFw.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        analytics.ui.renderSuccessEvent({
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            status: cardState.status,
            canBeDatasource: canBeDatasource
        });
    }, [
        analytics.ui,
        cardState.status,
        canBeDatasource
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eUqFw.useMemo)(()=>{
        return (0, $crquY.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const snippetBlockRef = (0, $eUqFw.useRef)(null);
    const onSnippetRender = (0, $eUqFw.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $fjZxK.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        status: (0, $caOA9.SmartLinkStatus).Resolved
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
        ...titleBlockProps,
        metadataPosition: (0, $caOA9.SmartLinkPosition).Top
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: primary,
        secondary: secondary,
        overrideCss: (0, $9OsQy.metadataBlockCss),
        maxLines: 1,
        size: (0, $caOA9.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2NbM.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet,
        status: (0, $caOA9.SmartLinkStatus).Resolved
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        overrideCss: (0, $9OsQy.hiddenSnippetStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I51G.default), {
        onClick: onActionClick,
        spaceInline: "space.100"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgolE.default), null));
};
var $6d329f21429fe8f2$export$2e2bcd8739ae039 = $6d329f21429fe8f2$var$HoverCardResolvedView;

});

parcelRegister("Ur3CB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd311226ef0fbfa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $kKYlt = parcelRequire("kKYlt");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");
var $d9NWW = parcelRequire("d9NWW");

var $7u4fN = parcelRequire("7u4fN");

var $ebCNT = parcelRequire("ebCNT");

var $6PC9Z = parcelRequire("6PC9Z");

var $lVbJo = parcelRequire("lVbJo");

var $8tvRs = parcelRequire("8tvRs");

var $8Wyjt = parcelRequire("8Wyjt");

var $bFzGY = parcelRequire("bFzGY");
const $bd311226ef0fbfa9$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = cardState.details?.data;
    const meta = cardState.details?.meta;
    const product = (0, $ebCNT.extractProvider)(data)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, (0, $8Wyjt.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $8tvRs.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), {
        ignoreContainerPadding: true,
        overrideCss: (0, $lVbJo.getPreviewBlockStyles)(),
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.connectButtonStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $bd311226ef0fbfa9$export$2e2bcd8739ae039 = $bd311226ef0fbfa9$var$HoverCardForbiddenView;

});
parcelRegister("6PC9Z", function(module, exports) {

$parcel$export(module.exports, "titleBlockStyles", () => $e29da529ecbe3399$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $e29da529ecbe3399$export$a8a26925e3db0ef6);
$parcel$export(module.exports, "connectButtonStyles", () => $e29da529ecbe3399$export$e63cb455d3692ef0);

var $byn9U = parcelRequire("byn9U");
function $e29da529ecbe3399$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e29da529ecbe3399$var$titleFontWeight = '600';
const $e29da529ecbe3399$export$38125fa6916f5dab = /*#__PURE__*/ (0, $byn9U.css)({
    justifyContent: 'center',
    fontWeight: $e29da529ecbe3399$var$titleFontWeight,
    marginTop: "var(--ds-space-100, 8px)"
});
const $e29da529ecbe3399$export$a8a26925e3db0ef6 = {
    name: "9ceufl",
    styles: "display:inline;justify-content:center;margin-top:var(--ds-space-0, 0px);font-size:0.75rem;text-align:center"
};
const $e29da529ecbe3399$export$e63cb455d3692ef0 = {
    name: "198gd5p",
    styles: "justify-content:center;margin-top:var(--ds-space-100, 8px)"
};

});


parcelRegister("NJTzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39b0b8c882ae6a0$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $lVbJo = parcelRequire("lVbJo");

var $i2yZR = parcelRequire("i2yZR");

var $3miv3 = parcelRequire("3miv3");

var $04PAQ = parcelRequire("04PAQ");

var $asu8X = parcelRequire("asu8X");
const $c39b0b8c882ae6a0$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $asu8X.di)((0, $04PAQ.default), (0, $i2yZR.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    const [showPrism, setShowPrism] = (0, $eUqFw.useState)(status === 'loading');
    (0, $eUqFw.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $3miv3.hoverCardClassName),
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            (0, $lVbJo.HoverCardContainer),
            !isAIEnabled ? (0, $lVbJo.popupContainerStyles) : undefined
        ],
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i2yZR.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $c39b0b8c882ae6a0$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    if ((0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries')) return /*#__PURE__*/ (0, $byn9U.jsx)($c39b0b8c882ae6a0$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $3miv3.hoverCardClassName),
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lVbJo.HoverCardContainer),
        "data-testid": testId,
        ...props
    }, children);
};
var $c39b0b8c882ae6a0$export$2e2bcd8739ae039 = $c39b0b8c882ae6a0$var$ContentContainer;

});
parcelRegister("i2yZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7014d33f6e1aba$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4q38b = parcelRequire("4q38b");

var $jLlux = parcelRequire("jLlux");

var $fMafu = parcelRequire("fMafu");

var $lVbJo = parcelRequire("lVbJo");
function $bb7014d33f6e1aba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bb7014d33f6e1aba$var$contentStyles = {
    name: "1u4p2uv",
    styles: "transition:box-shadow 0.5s ease"
};
const $bb7014d33f6e1aba$var$contentStylesPrismVisible = {
    name: "egtvy2",
    styles: "box-shadow:0px 8px 12px rgba(9, 30, 66, 0),0px 0px 1px rgba(9, 30, 66, 0)"
};
const $bb7014d33f6e1aba$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fMafu.default), {
        additionalCss: {
            animatedSvgContainer: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.5s ease'
            })
        },
        palette: (0, $jLlux.AI_BORDER_PALETTE)[colorMode] ?? (0, $jLlux.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lVbJo.popupContainerStyles),
            $bb7014d33f6e1aba$var$contentStyles,
            isVisible ? $bb7014d33f6e1aba$var$contentStylesPrismVisible : undefined
        ]
    }, children));
};
var $bb7014d33f6e1aba$export$2e2bcd8739ae039 = $bb7014d33f6e1aba$var$AIPrism;

});
parcelRegister("fMafu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c91d8a83a09599$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $fDt02 = parcelRequire("fDt02");

var $jLlux = parcelRequire("jLlux");
function $b7c91d8a83a09599$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7c91d8a83a09599$var$borderContainerStyles = {
    name: "hjc7l6",
    styles: "display:flex;position:relative;padding:var(--ds-space-025, 2px);width:fit-content"
};
const $b7c91d8a83a09599$export$a16b2e78d6201b80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $jLlux.INNER_BORDER_RADIUS),
    flexGrow: 1,
    zIndex: 1 // needs to be more than the svg container at least
});
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $b7c91d8a83a09599$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, additionalCss: additionalCss })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $b7c91d8a83a09599$var$borderContainerStyles,
            additionalCss?.container
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fDt02.default), {
        palette: palette,
        isMoving: isMoving,
        additionalCss: additionalCss?.animatedSvgContainer
    }), isGlowing && /*#__PURE__*/ (0, $byn9U.jsx)((0, $fDt02.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        additionalCss: additionalCss?.animatedSvgContainer
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b7c91d8a83a09599$export$a16b2e78d6201b80
    }, children, " "));
var $b7c91d8a83a09599$export$2e2bcd8739ae039 = $b7c91d8a83a09599$var$AIGlowingBorder;

});
parcelRegister("fDt02", function(module, exports) {

$parcel$export(module.exports, "default", () => $507303c4e5cfbc53$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $jLlux = parcelRequire("jLlux");
function $507303c4e5cfbc53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
let $507303c4e5cfbc53$var$namespaceUUID = 0;
const $507303c4e5cfbc53$var$svgStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $jLlux.OUTER_BORDER_RADIUS)
});
const $507303c4e5cfbc53$var$blurredStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    top: "var(--ds-space-050, 4px)",
    left: "var(--ds-space-050, 4px)",
    filter: `blur(${"var(--ds-space-100, 8px)"})`,
    // for safari... : https://stackoverflow.com/a/71353198
    backfaceVisibility: 'hidden',
    transform: 'translate3d(0, 0, 0)'
});
const $507303c4e5cfbc53$var$notBlurredStyles = {
    name: "1nir64p",
    styles: "left:0;top:0;width:100%;height:100%"
};
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $507303c4e5cfbc53$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, additionalCss: additionalCss })=>{
    const svgRef = (0, $eUqFw.useRef)(null);
    const namespaceId = (0, $eUqFw.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $507303c4e5cfbc53$var$namespaceUUID;
        $507303c4e5cfbc53$var$namespaceUUID += 1;
    }
    (0, $eUqFw.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $507303c4e5cfbc53$var$svgStyles,
            isGlowing ? $507303c4e5cfbc53$var$blurredStyles : $507303c4e5cfbc53$var$notBlurredStyles,
            additionalCss
        ],
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("defs", null, /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $507303c4e5cfbc53$export$2e2bcd8739ae039 = $507303c4e5cfbc53$var$AnimatedSvgContainer;

});





parcelRegister("hxNq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5de1a9710440709$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $lVbJo = parcelRequire("lVbJo");

var $byn9U = parcelRequire("byn9U");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $f5de1a9710440709$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.hover-card-ai-summaries') ? undefined : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $lVbJo.popupContainerStyles),
        ...props,
        ref: ref
    }, children));
var $f5de1a9710440709$export$2e2bcd8739ae039 = $f5de1a9710440709$var$CustomPopupContainer;

});

parcelRegister("eGeQQ", function(module, exports) {

$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5fc5bdbc0f185cb2$export$eaff10f7ec59c455);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $b81Yi = parcelRequire("b81Yi");

var $6aS3b = parcelRequire("6aS3b");
const $5fc5bdbc0f185cb2$export$eaff10f7ec59c455 = (props)=>{
    const { children: children, url: url, display: display } = props;
    const { details: details, status: status } = (0, $b81Yi.useSmartCardState)(url);
    const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: url
    }, details, status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aS3b.LinkAnalyticsContext), {
        ...props,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes
        }
    }, children));
};

});
parcelRegister("6aS3b", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $225f130421a19d23$export$9458cdec663b9ff1);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $225f130421a19d23$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});


parcelRegister("fck9X", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $b6c4b6f4a8e17ca1$export$2ae4cf79c720146a);

var $hqABm = parcelRequire("hqABm");
const $b6c4b6f4a8e17ca1$export$2ae4cf79c720146a = (actionOptions, showServerActions, showActions, platform)=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile' || showServerActions === false && showActions === false) return {
        hide: true
    };
    if (showServerActions && showActions) return {
        hide: false
    };
    let exclude = [];
    if (showServerActions === false) exclude = [
        ...exclude,
        (0, $hqABm.CardAction).FollowAction,
        (0, $hqABm.CardAction).ChangeStatusAction
    ];
    if (showActions === false) exclude = [
        ...exclude,
        (0, $hqABm.CardAction).DownloadAction,
        (0, $hqABm.CardAction).PreviewAction,
        (0, $hqABm.CardAction).ViewAction
    ];
    return {
        hide: false,
        exclude: exclude
    };
};

});



parcelRegister("4Deo8", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $02d4cc5f6bd3d325$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $02d4cc5f6bd3d325$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $02d4cc5f6bd3d325$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $02d4cc5f6bd3d325$export$88bbcb3741dee92d);

var $PdmhA = parcelRequire("PdmhA");
const $02d4cc5f6bd3d325$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-background-accent-red-subtlest, ${(0, $PdmhA).R50})`;
        case 'at_risk':
            return `var(--ds-background-accent-yellow-subtlest, ${(0, $PdmhA).Y50})`;
        case 'on_track':
            return `var(--ds-background-accent-green-subtlest, ${(0, $PdmhA).G50})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-background-accent-gray-subtlest, ${(0, $PdmhA).N20})`;
    }
};
const $02d4cc5f6bd3d325$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`;
        case 'at_risk':
            return `var(--ds-text-accent-orange, ${(0, $PdmhA).Y500})`;
        case 'on_track':
            return `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`;
    }
};
const $02d4cc5f6bd3d325$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $PdmhA).R500})`;
    if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y500})`;
    return `var(--ds-background-success-bold, ${(0, $PdmhA).G500})`;
};
const $02d4cc5f6bd3d325$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("4dREb", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $05f58ca73b129f56$export$134cbcd70c6693b8);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4Deo8 = parcelRequire("4Deo8");

var $gKpeZ = parcelRequire("gKpeZ");
const $05f58ca73b129f56$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $05f58ca73b129f56$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $05f58ca73b129f56$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4Deo8.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $05f58ca73b129f56$var$GoalGlyph,
        label: formatMessage((0, $gKpeZ.default).goalIconLabel),
        primaryColor: (0, $4Deo8.mapStateToColor)(state)
    }));
};
const $05f58ca73b129f56$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("gKpeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea671f73d186d15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ea671f73d186d15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("As52d", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $303e43f665e710f6$export$c0fdf469f92e8578);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fKlXo = parcelRequire("fKlXo");

var $hT69m = parcelRequire("hT69m");
const $303e43f665e710f6$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hT69m.Tracker), {
        backgroundColor: (0, $4Deo8.mapStateToBgColor)(value),
        color: (0, $4Deo8.mapStateToColor)(value)
    }, (0, $4Deo8.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fKlXo.Score), {
        score: score
    }));

});
parcelRegister("fKlXo", function(module, exports) {

$parcel$export(module.exports, "Score", () => $8652e2ebcc366b7f$export$6735cf84ecd2736);

var $eUqFw = parcelRequire("eUqFw");

var $4Deo8 = parcelRequire("4Deo8");

var $fdegN = parcelRequire("fdegN");
const $8652e2ebcc366b7f$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdegN.ScoreContainer), {
        backgroundColor: (0, $4Deo8.mapScoreToBgColor)(score)
    }, score);

});
parcelRegister("fdegN", function(module, exports) {

$parcel$export(module.exports, "ScoreContainer", () => $0423525836f3c2c9$export$32466e20de52fc97);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $0423525836f3c2c9$export$32466e20de52fc97 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hT69m", function(module, exports) {

$parcel$export(module.exports, "Tracker", () => $ef0bcdff719080e2$export$254d9747e34ddc90);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $ef0bcdff719080e2$export$254d9747e34ddc90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk3qkl _2rko1l7b _1yt41b66 _k48p1fw0 _1wyb1skh _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
            __cmplp.className
        ])
    });
});

});



parcelRegister("gpryJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf260ae1dcdb88a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ccf260ae1dcdb88a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    chooseGoal: {
        "id": "portfolio-3-portfolio.common.goal.goal-cell-select.choose-goal",
        "defaultMessage": "Choose a Goal"
    },
    noGoals: {
        "id": "portfolio-3-portfolio.common.goal.goal-cell-select.no-goals",
        "defaultMessage": "There are no goals in this plan"
    },
    noMatch: {
        "id": "portfolio-3-portfolio.common.goal.goal-cell-select.no-match",
        "defaultMessage": "No results match your search"
    }
});

});

parcelRegister("sY26D", function(module, exports) {

$parcel$export(module.exports, "selectStyles", () => $3ac3bfc45825e771$export$70a9ea0b017c448a);
const $3ac3bfc45825e771$export$70a9ea0b017c448a = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    container: (styles, { selectProps: { menuIsOpen: menuIsOpen } })=>({
            ...styles,
            ...menuIsOpen ? {
                zIndex: 1
            } : {}
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (styles, { hasValue: hasValue, selectProps: { menuIsOpen: menuIsOpen } })=>menuIsOpen ? {
            ...styles
        } : {
            ...styles,
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            // eslint-disable-next-line no-useless-computed-key
            [':hover']: {
                ...styles[':hover'],
                background: 'none',
                ...hasValue ? {
                    borderColor: 'transparent'
                } : {}
            }
        },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (styles)=>({
            ...styles,
            maxHeight: 150,
            overflow: 'auto',
            flex: '1'
        }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    multiValue: (styles)=>({
            ...styles,
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            borderColor: "var(--ds-border, #091e4221)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        })
};

});




parcelRegister("ehOMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $05eb1e08f9bef101$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $05eb1e08f9bef101$var$mapDispatchToProps = (dispatch)=>({
        onChange: (issue, goals)=>{
            const newGoals = goals.map((goal)=>({
                    id: goal.goal?.id,
                    key: goal.goal?.key
                }));
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                goals: newGoals
            }));
        }
    });
var $05eb1e08f9bef101$export$2e2bcd8739ae039 = $05eb1e08f9bef101$var$mapDispatchToProps;

});


parcelRegister("3lvGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $20969728dc6238d1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $g25G8 = parcelRequire("g25G8");

var $5UKKH = parcelRequire("5UKKH");
var $20969728dc6238d1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $g25G8.default), {})((0, $5UKKH.default));

});
parcelRegister("g25G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $063b31e29818e3b9$export$2e2bcd8739ae039);

var $11mKX = parcelRequire("11mKX");

var $iK4oF = parcelRequire("iK4oF");
const $063b31e29818e3b9$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    associatedIssueIds: (0, $11mKX.getAssociatedIssueIds)
});
var $063b31e29818e3b9$export$2e2bcd8739ae039 = $063b31e29818e3b9$var$querySelector;

});

parcelRegister("5UKKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $da736d750b56f345$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $l79aB = parcelRequire("l79aB");
const $da736d750b56f345$var$calculateFlexShrink = (names)=>{
    const nameLengths = names.map((name)=>name === undefined ? 0 : name.length);
    const shrinkCoefficient = 0.2; // A smaller number will make the components shrink closer to a similar rate.
    return nameLengths.map((length)=>Math.pow(length, shrinkCoefficient));
};
const $da736d750b56f345$var$IssueCardContent = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da736d750b56f345$var$ideaContentCardTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da736d750b56f345$var$ideaContentCardAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: data.iconUrl,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "a",
        href: `/browse/${data.key}`,
        target: "_blank"
    }, data.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "div",
        size: "xsmall"
    }, data.summary));
const $da736d750b56f345$var$Issue = ({ data: data, flexShrink: flexShrink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da736d750b56f345$var$container,
        style: {
            flexShrink: flexShrink
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da736d750b56f345$var$IssueCardContent, {
                data: data
            }),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        component: $da736d750b56f345$var$TooltipLikeInlineDialog
    }, (tooltipProps)=>// eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ...tooltipProps,
            xcss: $da736d750b56f345$var$contentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $da736d750b56f345$var$avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: data.iconUrl,
            size: "xsmall"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $da736d750b56f345$var$summary
        }, data.summary))));
const $da736d750b56f345$var$IdeasCell = ({ associatedIssues: associatedIssues })=>{
    const names = associatedIssues.map((el)=>el.summary);
    const values = $da736d750b56f345$var$calculateFlexShrink(names);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da736d750b56f345$var$ideasCellWrapper
    }, associatedIssues.map((associatedIssue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da736d750b56f345$var$Issue, {
            key: associatedIssue.key,
            data: associatedIssue,
            flexShrink: values[index]
        })));
};
const $da736d750b56f345$var$View = (props)=>{
    const [associatedIssues] = (0, $l79aB.useAssociatedIssues)();
    if (!associatedIssues || !props.issue.associatedIssueIds) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da736d750b56f345$var$IdeasCell, {
        associatedIssues: props.issue.associatedIssueIds?.map((issueId)=>associatedIssues[issueId]).filter((issue)=>!!issue)
    });
};
var $da736d750b56f345$export$2e2bcd8739ae039 = $da736d750b56f345$var$View;
const $da736d750b56f345$var$container = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.100',
    minWidth: 'size.300',
    height: '100%',
    flexBasis: 'content'
});
const $da736d750b56f345$var$avatar = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    flexShrink: 0
});
const $da736d750b56f345$var$summary = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $da736d750b56f345$var$ideasCellWrapper = (0, $1ZAYh.xcss)({
    display: 'flex'
});
const $da736d750b56f345$var$contentWrapper = (0, $1ZAYh.xcss)({
    display: 'flex',
    width: '100%'
});
const $da736d750b56f345$var$ideaContentCardTitle = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBottom: 'space.150'
});
const $da736d750b56f345$var$ideaContentCardAvatar = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const $da736d750b56f345$var$TooltipLikeInlineDialog = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhku67f _2rkoglpi _16qsjdvv _vchh18uv _1yt41bs6 _1bsb52fy",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kEdAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b005b8fe0b76e115$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hfmRl = parcelRequire("hfmRl");

var $8z7LW = parcelRequire("8z7LW");

var $9fk67 = parcelRequire("9fk67");
var $b005b8fe0b76e115$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $8z7LW.default), (0, $hfmRl.default))((0, $9fk67.default));

});
parcelRegister("hfmRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2279069e476beebc$export$2e2bcd8739ae039);

var $4zflJ = parcelRequire("4zflJ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2279069e476beebc$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, transition)=>{
            dispatch((0, $4zflJ.updateIssueStatus)({
                issue: issue,
                transition: transition
            }));
        }
    });
var $2279069e476beebc$export$2e2bcd8739ae039 = $2279069e476beebc$var$dispatchMethods;

});
parcelRegister("4zflJ", function(module, exports) {

$parcel$export(module.exports, "updateIssueStatus", () => $7d48c2cef15c52d3$export$a76d559af9096b60);
$parcel$export(module.exports, "default", () => $7d48c2cef15c52d3$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $1Szmp = parcelRequire("1Szmp");

var $75KhQ = parcelRequire("75KhQ");

var $kt7Vd = parcelRequire("kt7Vd");

var $lwKA5 = parcelRequire("lwKA5");

var $5rYNM = parcelRequire("5rYNM");
const $7d48c2cef15c52d3$var$UPDATE_ISSUE_STATUS = 'command.issue-status.UPDATE_ISSUE_STATUS';
const $7d48c2cef15c52d3$export$a76d559af9096b60 = (payload)=>({
        type: $7d48c2cef15c52d3$var$UPDATE_ISSUE_STATUS,
        payload: payload
    });
function* $7d48c2cef15c52d3$var$resetIssueStatus(issueId, originalIssueStatusId) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const body = {
        itemKeys: [
            issueId
        ],
        planId: planId,
        scenarioId: scenarioId,
        description: {
            status: {
                reset: true
            }
        }
    };
    const resetStatusResponse = yield (0, $9e8i2.call)((0, $1Szmp.doResetIssueRequest), body);
    if (resetStatusResponse?.ok) {
        yield (0, $9e8i2.put)((0, $kt7Vd.update)({
            id: issueId,
            status: originalIssueStatusId
        }));
        yield (0, $9e8i2.put)($lwKA5.revertFields({
            id: issueId,
            fields: [
                'status'
            ]
        }));
    }
}
function* $7d48c2cef15c52d3$export$35b7403928519ea({ payload: { issue: issue, transition: transition } }) {
    const originalIssueStatusId = issue?.originals?.status;
    const newStatus = transition.to;
    // if the use select back the original status, we should reset the scenario change
    if (transition.id === (0, $5rYNM.ORIGINAL_STATUS_TRANSITION).id) yield (0, $9e8i2.call)($7d48c2cef15c52d3$var$resetIssueStatus, issue.id, originalIssueStatusId);
    else yield (0, $9e8i2.put)((0, $1Szmp.updateIssueOrInlineCreate)({
        id: issue.id,
        status: newStatus.id,
        statusTransition: transition.id
    }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $7d48c2cef15c52d3$var$watchUpdateIssueStatus() {
    yield (0, $bG7pV.takeEvery)($7d48c2cef15c52d3$var$UPDATE_ISSUE_STATUS, $7d48c2cef15c52d3$export$35b7403928519ea);
}
function* $7d48c2cef15c52d3$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($7d48c2cef15c52d3$var$watchUpdateIssueStatus);
}

});


parcelRegister("8z7LW", function(module, exports) {

$parcel$export(module.exports, "default", () => $38c1426b626e280d$export$2e2bcd8739ae039);

var $kFf60 = parcelRequire("kFf60");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
const $38c1426b626e280d$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    issueStatuses: (0, $kFf60.getIssueStatusById),
    projectsById: (0, $ehEr2.getProjectsById)
});
var $38c1426b626e280d$export$2e2bcd8739ae039 = $38c1426b626e280d$var$querySelector;

});

parcelRegister("9fk67", function(module, exports) {

$parcel$export(module.exports, "default", () => $775dc2722c277dde$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d16Lt = parcelRequire("d16Lt");

var $8CXDT = parcelRequire("8CXDT");

var $7CnHa = parcelRequire("7CnHa");

var $13pyJ = parcelRequire("13pyJ");

var $6vrw7 = parcelRequire("6vrw7");

var $aCXxk = parcelRequire("aCXxk");

var $5obPP = parcelRequire("5obPP");
const $775dc2722c277dde$export$58e0df5bb69dbb83 = ({ issue: issue, issueStatuses: issueStatuses, projectsById: projectsById, onChange: onChange, isScrolling: isScrolling, showOptimizations: showOptimizations, isReadOnly: isReadOnly })=>{
    const handleChange = (transition)=>{
        onChange(issue, transition);
    };
    if ((0, $7CnHa.isDefined)(issue.status) && (0, $7CnHa.isDefined)(issueStatuses[issue.status])) {
        const status = issueStatuses[issue.status];
        // Defend against rare occurrences of corrupt data
        // Cannot destructure property 'id' of 't[e.status]' as it is undefined
        if (!status) return null;
        const issueProject = issue.project && projectsById[issue.project];
        if (!issueProject) return null;
        const issueProjectAndKey = `${issueProject.key}-${issue.issueKey}`;
        const { id: id, name: name, categoryId: categoryId } = status;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: "status",
            issue: issue,
            isScrolling: isScrolling,
            showOptimizations: !!showOptimizations
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5obPP.issueStatus
        }, (0, $13pyJ.isScenarioIssue)(issue.id) || isScrolling || isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
            value: {
                id: id,
                name: name,
                statusCategory: {
                    id: categoryId
                }
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCXxk.default), {
            issue: issue,
            issueKey: (0, $6vrw7.toIssueKey)(issueProjectAndKey),
            value: {
                id: id,
                name: name,
                statusCategory: {
                    id: categoryId
                }
            },
            onChange: handleChange,
            projectId: issueProject.id,
            issueStatuses: issueStatuses
        })));
    }
    return null;
};
var $775dc2722c277dde$export$2e2bcd8739ae039 = $775dc2722c277dde$export$58e0df5bb69dbb83;

});
parcelRegister("d16Lt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $ff16a2437ea95212$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $ff16a2437ea95212$export$9f5070a985b0679b);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $ff16a2437ea95212$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $ff16a2437ea95212$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("2GJ4g", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $0211a3ed28924b4c$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $0211a3ed28924b4c$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $0211a3ed28924b4c$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $bbaTG = parcelRequire("bbaTG");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $bR5MV = parcelRequire("bR5MV");

var $iccsh = parcelRequire("iccsh");

var $a8LdG = parcelRequire("a8LdG");
const $0211a3ed28924b4c$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $0211a3ed28924b4c$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $0211a3ed28924b4c$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    })));
const $0211a3ed28924b4c$export$f72db4ad1e9b3e6d = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, name)));
const $0211a3ed28924b4c$export$69ea4907eefa8e7b = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $PdmhA).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $PdmhA).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.status-lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$export$f72db4ad1e9b3e6d, {
        ...other,
        isEditable: isEditable
    }));
};
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozenge = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        pointerEvents: 'none'
    })}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StatusContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bR5MV", function(module, exports) {

$parcel$export(module.exports, "STATUS_THEME_DEFAULT", () => $0bd810462bafa4a2$export$61137dce61763ec3);
$parcel$export(module.exports, "STATUS_THEME_SUCCESS", () => $0bd810462bafa4a2$export$132676d06d92ad48);
$parcel$export(module.exports, "STATUS_THEME_IN_PROGRESS", () => $0bd810462bafa4a2$export$5c1f3b72419aa125);
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $0bd810462bafa4a2$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $0bd810462bafa4a2$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $0bd810462bafa4a2$export$32f78bffcd82ff28);
$parcel$export(module.exports, "bgHoverColor", () => $0bd810462bafa4a2$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $0bd810462bafa4a2$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $0bd810462bafa4a2$export$b70f10fc4a6ba453);

var $PdmhA = parcelRequire("PdmhA");
const $0bd810462bafa4a2$export$61137dce61763ec3 = 'default';
const $0bd810462bafa4a2$export$132676d06d92ad48 = 'success';
const $0bd810462bafa4a2$export$5c1f3b72419aa125 = 'inprogress';
const $0bd810462bafa4a2$export$d9e35f42afe1e488 = {
    '1': $0bd810462bafa4a2$export$61137dce61763ec3,
    '2': $0bd810462bafa4a2$export$61137dce61763ec3,
    '3': $0bd810462bafa4a2$export$132676d06d92ad48,
    '4': $0bd810462bafa4a2$export$5c1f3b72419aa125
};
const $0bd810462bafa4a2$export$7dcbec377a25efc6 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $PdmhA.B50)})`
};
const $0bd810462bafa4a2$export$32f78bffcd82ff28 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N500)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.G500)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.B500)})`
};
const $0bd810462bafa4a2$export$69fdf3ba928b4c77 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N70)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $PdmhA.G400)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $PdmhA.B400)})`
};
const $0bd810462bafa4a2$export$99ec0cf2cf1b2082 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N800)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.N0)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.N0)})`
};
const $0bd810462bafa4a2$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    text: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
};

});

parcelRegister("iccsh", function(module, exports) {

$parcel$export(module.exports, "isStatusInGicEnabled", () => $96fedf0b1762860e$export$30cd538422d6ae26);
$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $96fedf0b1762860e$export$9605b1d5fe0c238b);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $96fedf0b1762860e$export$60184d6d974595a9);

var $1ybV0 = parcelRequire("1ybV0");
const $96fedf0b1762860e$export$30cd538422d6ae26 = ()=>(0, $1ybV0.ff)('issue.details.gic.add_status_field', false);
const $96fedf0b1762860e$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $96fedf0b1762860e$export$9605b1d5fe0c238b = ()=>(0, $1ybV0.ff)($96fedf0b1762860e$export$455240e4be839479, false);
const $96fedf0b1762860e$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false); // </bento>

});

parcelRegister("a8LdG", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $c24adb58350b577e$export$a31cbe1bf5463979);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $c24adb58350b577e$var$containerStylesNew = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    // Hardcoded font size and line height to match @atlaskit/lozenge. This may change in the future due to ADS design decisions
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $c24adb58350b577e$var$containerStylesOld = {
    borderRadius: $c9TLT.borderRadius,
    boxSizing: 'border-box',
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    maxWidth: '100%',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    textTransform: 'uppercase',
    verticalAlign: 'baseline'
};
const $c24adb58350b577e$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $c24adb58350b577e$export$a31cbe1bf5463979 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? $c24adb58350b577e$var$containerStylesNew : $c24adb58350b577e$var$containerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $c24adb58350b577e$var$contentStyles
    }, children));
$c24adb58350b577e$export$a31cbe1bf5463979.displayName = 'Lozenge';

});



parcelRegister("aCXxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c8569080d74b859$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8ohYF = parcelRequire("8ohYF");

var $8gPNO = parcelRequire("8gPNO");
var $7c8569080d74b859$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $8ohYF.default))((0, $8gPNO.default));

});
parcelRegister("8ohYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc4e3579b94a06a$export$2e2bcd8739ae039);

var $cbq3D = parcelRequire("cbq3D");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdc4e3579b94a06a$export$2e2bcd8739ae039 = (dispatch)=>({
        genericError: (payload)=>{
            dispatch((0, $cbq3D.genericError)(payload));
        }
    });

});

parcelRegister("8gPNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dcb5ce6a18ccfd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3BadD = parcelRequire("3BadD");
var $hKhSq = parcelRequire("hKhSq");
var $g6Vr7 = parcelRequire("g6Vr7");
var $8N9iM = parcelRequire("8N9iM");

var $8T7GM = parcelRequire("8T7GM");

var $SEaoU = parcelRequire("SEaoU");

var $gd0Sp = parcelRequire("gd0Sp");

var $cYxL5 = parcelRequire("cYxL5");
const $65dcb5ce6a18ccfd$export$28769ce7cf4b59f9 = ({ issue: issue, onChange: onChange, issueKey: issueKey, value: value, projectId: projectId, transitions: transitions, loading: loading, fetchTransitions: fetchTransitions, isMenuDefaultOpen: isMenuDefaultOpen })=>{
    const [isWorkflowModalOpen, setIsWorkflowModalOpen] = (0, $eUqFw.useState)(false);
    const [isWorkflowModalMounted, setIsWorkflowModalMounted] = (0, $eUqFw.useState)(false);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const handleChange = (0, $eUqFw.useCallback)((transition)=>{
        onChange(transition);
    }, [
        onChange
    ]);
    const onOpenModal = (0, $eUqFw.useCallback)(()=>{
        setIsWorkflowModalOpen(true);
    }, []);
    const onCloseModal = (0, $eUqFw.useCallback)(()=>{
        setIsWorkflowModalOpen(false);
    }, []);
    const onModalMounted = (0, $eUqFw.useCallback)(()=>{
        setIsWorkflowModalMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6Vr7.default), {
        ContainerContextSubscriber: (0, $SEaoU.ContainerContextSubscriber),
        baseUrl: tenantContext.baseUrl,
        issueKey: issueKey
    }, (workflowServiceApi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BadD.default), {
            appearance: "lozenge",
            ...isMenuDefaultOpen === true ? {
                defaultOpen: true
            } : {},
            value: value,
            transitions: transitions,
            onChange: handleChange,
            isLoading: loading,
            popperProps: {
                strategy: 'absolute'
            },
            onOpen: ()=>{
                fetchTransitions();
                const hasFetchedWorkflowService = workflowServiceApi.data && workflowServiceApi.data.hasPermission !== undefined;
                if (hasFetchedWorkflowService !== true) workflowServiceApi.fetch();
            },
            footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKhSq.default), {
                baseUrl: tenantContext.baseUrl,
                issueKey: issueKey,
                workflowServiceApi: workflowServiceApi,
                onOpenModal: onOpenModal,
                isModalMounted: isWorkflowModalMounted
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N9iM.default), {
            onModalMounted: onModalMounted,
            issueKey: issueKey,
            issueTypeId: `${issue.type}`,
            baseUrl: tenantContext.baseUrl,
            locale: tenantContext.locale,
            cloudId: tenantContext.cloudId,
            projectId: `${projectId}`,
            isOpen: isWorkflowModalOpen,
            onClose: onCloseModal,
            scope: workflowServiceApi.data?.isSimplified === true ? (0, $8T7GM.SCOPE_PROJECT) : (0, $8T7GM.SCOPE_GLOBAL)
        })));
};
var $65dcb5ce6a18ccfd$export$2e2bcd8739ae039 = (0, $cYxL5.transitionsProvider)($65dcb5ce6a18ccfd$export$28769ce7cf4b59f9);

});
parcelRegister("3BadD", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $d882b3ccfb1ea465$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $d882b3ccfb1ea465$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $jG2Eu = parcelRequire("jG2Eu");

var $5wCDk = parcelRequire("5wCDk");
var $l44HT = parcelRequire("l44HT");

var $kNcnV = parcelRequire("kNcnV");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $2GJ4g = parcelRequire("2GJ4g");

var $50D0V = parcelRequire("50D0V");

var $iccsh = parcelRequire("iccsh");

var $99Syk = parcelRequire("99Syk");

var $f3qzK = parcelRequire("f3qzK");

var $5x3wA = parcelRequire("5x3wA");

var $fr49r = parcelRequire("fr49r");

var $dSoqn = parcelRequire("dSoqn");
const $d882b3ccfb1ea465$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $d882b3ccfb1ea465$export$d5aa018254c8c065 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $l44HT.default));
const $d882b3ccfb1ea465$export$f35c79a5a21cbec1 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $5wCDk.default));
const $d882b3ccfb1ea465$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, defaultOpen: // for testing
defaultOpen = false, shouldFitContainer: shouldFitContainer = true })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const childWrapperRef = (0, $eUqFw.useRef)(null);
    const wasChanged = (0, $eUqFw.useRef)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const previousIsSaving = (0, $hzcvF.usePrevious)(isSaving);
    const previousTransitions = (0, $hzcvF.usePrevious)(transitions);
    const previousIsOpen = (0, $hzcvF.usePrevious)(isOpen);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $50D0V.getFilteredOrderedTransitions)(transitions, value.id);
    const isGlobalOnly = (0, $50D0V.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    const formatTransitionOptionLabel = (0, $eUqFw.useCallback)((option, transitionProps)=>(0, $iccsh.isStatusInGicEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "issue-field-status.ui.status-view.transition"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSoqn.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSoqn.Transition), {
            transition: option.transition,
            hasLabel: !isGlobalOnly,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing
        }), [
        showLabel,
        isGlobalOnly
    ]);
    // specifically for screen readers
    const getTransitionOptionLabel = (option)=>option.transition.isGlobal ? formatMessage((0, $f3qzK.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
    const isOptionDisabled = (option)=>(0, $iccsh.isStatusInGicEnabled)() ? option.transition.isDisabled : false;
    const mergedPopperProps = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))($d882b3ccfb1ea465$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    // componentWillUpdate
    (0, $eUqFw.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isOpen,
        isSaving,
        previousIsOpen,
        previousIsSaving,
        previousTransitions,
        transitions
    ]);
    const handleChangeStatus = (0, $eUqFw.useCallback)((transition, analyticsEvent)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        onChange?.(transition, analyticsEvent);
    }, [
        onChange
    ]);
    const handleChange = (0, $eUqFw.useCallback)((option, action, analyticsEvent)=>{
        handleChangeStatus(option.transition, analyticsEvent);
    }, [
        handleChangeStatus
    ]);
    const handleOpen = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
    }, [
        onOpen
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
    }, [
        onClose
    ]);
    const renderLozenge = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (saving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), {
            border: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            targetRef: targetRef,
            status: value,
            error: error
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            error: err,
            hasHoverState: true,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef
        });
    }, [
        error,
        formatMessage,
        isOpen,
        value
    ]);
    const renderButton = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
        const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fr49r.StatusButton), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef,
            statusButtonRef: statusButtonRef,
            shouldFitContainer: shouldFitContainer
        });
        return saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), null, statusButton) : statusButton;
    }, [
        formatMessage,
        isOpen,
        shouldFitContainer,
        statusButtonRef,
        value
    ]);
    const renderCommandPalette = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99Syk.CommandPaletteStatusView), {
            transitions: filteredAndOrderedTransitions,
            currentStatus: value,
            onSuccess: onSuccess,
            wasFetchSuccessful: wasFetchSuccessful,
            renderTransition: formatTransitionOptionLabel,
            onFetch: onFetch,
            isLoading: isLoading
        }), [
        filteredAndOrderedTransitions,
        value,
        onSuccess,
        wasFetchSuccessful,
        formatTransitionOptionLabel,
        onFetch,
        isLoading
    ]);
    const renderWithFocusWrapper = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: childWrapperRef
        }, children), []);
    const renderTarget = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (value) {
            if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                isEditable: editable,
                isSaving: saving,
                error: err,
                targetRef: targetRef
            }));
            if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderWithFocusWrapper(renderButton({
                isEditable: editable,
                isSaving: saving,
                targetRef: targetRef
            })), registerInCommandPalette && renderCommandPalette());
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
    }, [
        appearance,
        registerInCommandPalette,
        renderButton,
        renderCommandPalette,
        renderLozenge,
        renderWithFocusWrapper,
        value
    ]);
    /* This prevents the dropdown from being accessible while saving/not editable,
   * because for the underlying PopupSelect, the `isDisabled` prop only prevents
   * the actual dropdown items from being selectable - the dropdown itself still
   * pops up/down.
   */ if (isSaving || !isEditable) return renderTarget({
        isSaving: isSaving,
        isEditable: isEditable,
        error: error
    });
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        return formatMessage(wasFetchSuccessful ? (0, $f3qzK.default).noPermission : (0, $f3qzK.default).cannotLoadTransitions);
    };
    const statusPopup = isDefaultSelect && selectedTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$f35c79a5a21cbec1, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: isOptionDisabled,
        onChange: handleChange,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        value: (0, $50D0V.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$d5aa018254c8c065, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        target: ({ ref: ref })=>renderTarget({
                isEditable: isEditable,
                isSaving: isSaving,
                error: error,
                targetRef: ref
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer,
        defaultIsOpen: defaultOpen
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, statusPopup);
};
var $d882b3ccfb1ea465$export$2e2bcd8739ae039 = $d882b3ccfb1ea465$export$a11134e1462e763;

});
parcelRegister("kNcnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $615c2b2f32d9571c$export$2e2bcd8739ae039);

var $5oqGi = parcelRequire("5oqGi");
var $615c2b2f32d9571c$export$2e2bcd8739ae039 = (0, $5oqGi.default);

});
parcelRegister("5oqGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d7187de9305cdc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $33d7187de9305cdc$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null)));
}
$33d7187de9305cdc$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33d7187de9305cdc$var$BlanketContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$BackgroundContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
            __cmplp.border ? "_19it1qih" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$ComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("50D0V", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $eb8c09ff04a7e642$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $eb8c09ff04a7e642$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $eb8c09ff04a7e642$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $eb8c09ff04a7e642$export$e2dafe47b17b2cfc);

var $5iWql = parcelRequire("5iWql");

var $8Qd0L = parcelRequire("8Qd0L");

var $iccsh = parcelRequire("iccsh");
const $eb8c09ff04a7e642$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf = (0, $5iWql.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isGlobalSelfTransition(transition, currentStatusId) && !((0, $iccsh.isStatusInGicEnabled)() && $eb8c09ff04a7e642$var$isInitialSelfTransition(transition, currentStatusId))));
const $eb8c09ff04a7e642$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $eb8c09ff04a7e642$export$707115549202b9e4 = (transitions, currentStatusId)=>$eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $eb8c09ff04a7e642$export$38146914a8d06579 = (0, $5iWql.default)((transitions, currentStatusId)=>{
    if (transitions === null) return null;
    return transitions.filter((transition)=>$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId));
});
const $eb8c09ff04a7e642$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $eb8c09ff04a7e642$var$memoizedTranformOptions = (0, $5iWql.default)($eb8c09ff04a7e642$var$formatOptions);
const $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04 = (options)=>$eb8c09ff04a7e642$var$memoizedTranformOptions(options);
const $eb8c09ff04a7e642$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $8Qd0L.StatusCategoryIds)[category] || (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("99Syk", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $0668685bfe518e32$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $eRawo = parcelRequire("eRawo");

var $ffiyv = parcelRequire("ffiyv");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $gCtL7 = parcelRequire("gCtL7");

var $9zALC = parcelRequire("9zALC");
var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $bT6OI = parcelRequire("bT6OI");

var $fmmnJ = parcelRequire("fmmnJ");
var $dK5FP = parcelRequire("dK5FP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $3Tszs = parcelRequire("3Tszs");

var $jMP2a = parcelRequire("jMP2a");


var $igSdB = parcelRequire("igSdB");

var $aaWu9 = parcelRequire("aaWu9");

var $hiXJ2 = parcelRequire("hiXJ2");
const $0668685bfe518e32$export$3b70c533639eedc2 = ({ childrenProps: childrenProps, statusViewProps: statusViewProps })=>{
    const { setLoading: setLoading, setChildResult: setChildResult } = childrenProps;
    const { wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, isLoading: isLoading, renderTransition: renderTransition, onSuccess: onSuccess } = statusViewProps;
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $3Tszs.useIssueAri)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { saveStatusField: saveStatusField } = (0, $aaWu9.useSaveStatusField)(issueKey, issueId);
    const loadTransitions = (0, $eUqFw.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        }))
                },
                keywords: (0, $hiXJ2.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const commands = [
            {
                id: `${(0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$CurrentStatusContainer, null, formatMessage((0, $igSdB.messages).currentStatus)))
                },
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
                }
            },
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        createAnalyticsEvent,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        formatMessage,
        onSuccess,
        renderTransition,
        saveStatusField,
        transitions,
        wasFetchSuccessful
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setLoading(isLoading);
    }, [
        isLoading,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setChildResult(loadTransitions());
    }, [
        loadTransitions,
        setChildResult
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Body, childrenProps);
};
const $0668685bfe518e32$export$d907a4132fe8618c = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const subscribeCommands = (0, $dK5FP.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteExpandedCommand)();
    const { onFetch: onFetch } = props;
    const renderChildren = (0, $eUqFw.useCallback)((childrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$export$3b70c533639eedc2, {
            childrenProps: childrenProps,
            statusViewProps: props
        }), [
        props
    ]);
    const renderHeader = (0, $eUqFw.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT6OI.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const statusCommand = {
            id: (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774),
            name: (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $igSdB.messages).editStatus) : formatMessage((0, $igSdB.messages).changeStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $igSdB.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eRawo))), {
                        label: formatMessage((0, $igSdB.messages).changeStatus)
                    })
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $igSdB.messages).fallbackNoResults)
                    }
                },
                components: {
                    Body: renderChildren,
                    ...(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') && {
                        Header: renderHeader
                    }
                }
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        renderChildren,
        renderHeader,
        subscribeCommands
    ]);
    const expandedCommandId = expandedCommand?.id;
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774) && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        expandedCommandId,
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$TransitionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$SelectedStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$CurrentStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eRawo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad0e2d491eada4f5$var$_react = $ad0e2d491eada4f5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ad0e2d491eada4f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ad0e2d491eada4f5$var$TaskIcon = (props)=>/*#__PURE__*/ $ad0e2d491eada4f5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 01-.993.993H3.993A.994.994 0 013 20.007V3.993zM5 5v14h14V5H5z"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill-rule="nonzero"/></g></svg>`
    }, props));
$ad0e2d491eada4f5$var$TaskIcon.displayName = 'TaskIcon';
var $ad0e2d491eada4f5$var$_default = $ad0e2d491eada4f5$var$TaskIcon;
module.exports.default = $ad0e2d491eada4f5$var$_default;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});

parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: (0, $eUqFw.Fragment),
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            group: result.group,
            key: index
        }, (0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainer, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainerOld, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), (0, $bKxX9.ff)('compal-issue-actions') ? renderAfterCommands?.({}) : !loadingList && renderAfterCommands && renderAfterCommands({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1oud _k48p1nn1 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $a61MH.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $ggKAj.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        ...(0, $1ybV0.ff)('compal.search-algorithm-analytics') ? {
            relevancyModel: 'v2-string-similarity'
        } : {}
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $bj4JM.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $1ybV0 = parcelRequire("1ybV0");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...(0, $1ybV0.ff)('fix-register-searchable-command-with-registryid') && $faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands),
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9lcOH = parcelRequire("9lcOH");

var $duQ8C = parcelRequire("duQ8C");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $duQ8C.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $9lcOH.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $duQ8C.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
                if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            }
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $duQ8C.default)('command-palette-executed');
                currentCommandAction.perform();
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $9lcOH.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analytics?.attributes
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});



parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        role: "listbox",
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        ref: ref,
        "aria-label": (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel) : undefined,
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5t8Df", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $cfdd8a3faf592ae6$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $cfdd8a3faf592ae6$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $cfdd8a3faf592ae6$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlaskit+theme -- Avoid using jira specific components to make this component easier to export to atlaskit later - https://hello.atlassian.net/browse/DEE-1558

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfdd8a3faf592ae6$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _1wyb1crf _vwz41crf _syaz1aqp",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect485st _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _k48pni7l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _ect485st _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4otz2 _1bsb1ris _1wybdlk8 _vwz4dlk8 _bfhk1yrq",
            __cmplp.className
        ])
    });
});

});

const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "separator"
        }))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $PdmhA).N400})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, containerRef: containerRef, shouldShowTooltip: shouldShowTooltip })=>{
    let shouldShowTruncatedTooltip = false;
    if (!(0, $1ybV0.ff)('compal-update-active-tooltip')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: (0, $1ybV0.ff)('compal-update-active-tooltip') ? !!shouldShowTooltip : shouldShowTruncatedTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
};
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld = ({ children: children, isActive: isActive })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
        ref: containerRef
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        containerRef: containerRef
    }, children));
};
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$export$4495aca3d261add0 = (0, $bAQOb.componentWithFF)('compal-update-active-tooltip', $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew, $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld);
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("46gH8", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $1d28d9547f2aa59c$export$cd9931655a8cfb04);

var $9zALC = parcelRequire("9zALC");

var $36mrL = parcelRequire("36mrL");

var $2NY3y = parcelRequire("2NY3y");
const $1d28d9547f2aa59c$export$cd9931655a8cfb04 = (issueKey)=>`${0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});
parcelRegister("36mrL", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $58e6fffac6029e83$export$5164bb42fa883371);
const $58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $58e6fffac6029e83$export$5164bb42fa883371 = (key)=>$58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("2NY3y", function(module, exports) {

$parcel$export(module.exports, "noSortNoFilterOverride", () => $94f67465bbdaf727$export$78d30e5b661ceee3);
const $94f67465bbdaf727$export$78d30e5b661ceee3 = (_search, selectedCommands)=>selectedCommands;

});


parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("bT6OI", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $f484a350daa785aa$export$c6444eb1c6f44b2d);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $LddR2 = parcelRequire("LddR2");

var $70Z2O = parcelRequire("70Z2O");
const $f484a350daa785aa$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70Z2O.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("70Z2O", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $f2e2061572377f16$export$a342a0ad2c552031);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $h2IaY = parcelRequire("h2IaY");

var $b5tfU = parcelRequire("b5tfU");

var $8xsZc = parcelRequire("8xsZc");

var $fWeG1 = parcelRequire("fWeG1");
const $f2e2061572377f16$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    const [{ value: summary }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const [{ value: issueType }] = (0, $8xsZc.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5tfU.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2IaY.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $f2e2061572377f16$var$issueTagContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '0'
});
const $f2e2061572377f16$var$issueTagStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    fontSize: '14px',
    color: 'color.text.subtle',
    lineHeight: 1
});

});
parcelRegister("h2IaY", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $dae903da6e3f2851$export$b2323503daaefa);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $dae903da6e3f2851$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $dae903da6e3f2851$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $dae903da6e3f2851$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $lXgc2.TooltipComponent),
        position: "bottom-end",
        delay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("b5tfU", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $1622fc3f30429d58$export$b1b562672a76ad84);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4SlOI = parcelRequire("4SlOI");
const $1622fc3f30429d58$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4SlOI.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("4SlOI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9a3b0db79e5e3d34$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9a3b0db79e5e3d34$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    }
});

});


parcelRegister("8xsZc", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $d6d526ec7a011453$export$3da96c4009e089ca);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d6d526ec7a011453$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: (0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? analyticsFieldTypeAlias ?? fieldType : fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(async (fieldValue, event)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            // eslint-disable-next-line jira/wrm/no-load-bridge
            await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $8Bhia = parcelRequire("8Bhia");

var $lDYuK = parcelRequire("lDYuK");

var $idwtd = parcelRequire("idwtd");

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04)) : (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_MODAL));
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $935e771f19f8ea28$export$98c0ebc22792f04) : (0, $idwtd.DETAIL_VIEW_MODAL)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040)) : (0, $lDYuK.setBoardDetailViewMode)((0, $idwtd.DETAIL_VIEW_SIDEBAR));
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $935e771f19f8ea28$export$705305d6da432040) : (0, $idwtd.DETAIL_VIEW_SIDEBAR)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $8Bhia.isBentoViewModeRefactor)() ? (0, $fhgeS.getViewModeFromLocalStorage)() : (0, $lDYuK.getBoardDetailViewMode)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("8Bhia", function(module, exports) {

$parcel$export(module.exports, "isAllPerfFeatureFlagsEnabled", () => $706d7ea06981f598$export$a9f38f9f0d6f10af);
$parcel$export(module.exports, "isChildIssuePanelConfigurationEnabled", () => $706d7ea06981f598$export$b5be9eaa7fce369);
$parcel$export(module.exports, "isIssueViewCommentRender", () => $706d7ea06981f598$export$9e18785497c1673b);
$parcel$export(module.exports, "isIssueViewCommentFetch", () => $706d7ea06981f598$export$35c0c8db33387f4d);
$parcel$export(module.exports, "isEcosystemLeftPanel", () => $706d7ea06981f598$export$6e4f76cd76a804da);
$parcel$export(module.exports, "isQuickActionExperimentFF", () => $706d7ea06981f598$export$7f7b600c4eafe68f);
$parcel$export(module.exports, "isDataClassificationEnabled", () => $706d7ea06981f598$export$c8aa8a13c42858dd);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerLinkedIssueEnabled", () => $706d7ea06981f598$export$3041d162b6562717);
$parcel$export(module.exports, "isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled", () => $706d7ea06981f598$export$7af43b56ceb4b148);
$parcel$export(module.exports, "isIssueViewActivityFeedUIFixesEnabled", () => $706d7ea06981f598$export$11c3bd37c4149e8a);
$parcel$export(module.exports, "isRelayCascadingSelectFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$91d9e9331bcb489f);
$parcel$export(module.exports, "isIssueViewMigratedStreamEnabled", () => $706d7ea06981f598$export$4bef98bf98ff2cb);
$parcel$export(module.exports, "isGiraAGGConsistencyCheckEnabled", () => $706d7ea06981f598$export$3c97eb4b6ff2fec1);
$parcel$export(module.exports, "isJiraIssueViewEditorAIEnabled", () => $706d7ea06981f598$export$183bff9fcee964a2);
$parcel$export(module.exports, "isIssueViewAdminGlobalOptInAiEnabled", () => $706d7ea06981f598$export$a42a9ff4a537eac1);
$parcel$export(module.exports, "isJiraIntelligentIssueBreakdownEnabled", () => $706d7ea06981f598$export$bb7bcfe9ba7992e5);
$parcel$export(module.exports, "isJiraSmartSummaryPlatformEnabled", () => $706d7ea06981f598$export$be02cc41570f884f);
$parcel$export(module.exports, "isJiraAIWorkBreakdownOnboardingEnabled", () => $706d7ea06981f598$export$25f1a380ac523ab1);
$parcel$export(module.exports, "isIssueTypeSelectHierarchyFixEnabled", () => $706d7ea06981f598$export$b9ecdb2af6d8a25);
$parcel$export(module.exports, "isShardAndRegionToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$a1b2fc5741a7de01);
$parcel$export(module.exports, "isFeatureFlagsToSLOAnalyticsEnabled", () => $706d7ea06981f598$export$b1c6c927b1de3746);
$parcel$export(module.exports, "isJiraAiWorkBreakdownDisclaimerUpdateEnabled", () => $706d7ea06981f598$export$3694fdeb5d384181);
$parcel$export(module.exports, "isA11yForIssueKeyStrikethroughEnabled", () => $706d7ea06981f598$export$4166161ebaa7c45b);
$parcel$export(module.exports, "isIssueViewRemoveConnectOperationsFromCriticalFetchEnabled", () => $706d7ea06981f598$export$c3e066f7be7868e8);
$parcel$export(module.exports, "isMediaInlineEnabled", () => $706d7ea06981f598$export$a3e5d5dfe1ed90ed);
$parcel$export(module.exports, "isTeamsCustomFieldTypeEnabled", () => $706d7ea06981f598$export$d7d142f5ac020394);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $706d7ea06981f598$export$cdd5c612352d7bf0);
$parcel$export(module.exports, "getInviteFromAssignModalCohort", () => $706d7ea06981f598$export$5b9220081498abd7);
$parcel$export(module.exports, "isInviteFromAssignModalFeEnabled", () => $706d7ea06981f598$export$89f18660d3a3bb78);
$parcel$export(module.exports, "isFedRampCheckEnabled", () => $706d7ea06981f598$export$dd98acc8d28f3c1e);
$parcel$export(module.exports, "isStoryPointAnalyticsEnabled", () => $706d7ea06981f598$export$f0ece2538dd9e423);
$parcel$export(module.exports, "isTrelloCardIntegrationPatch", () => $706d7ea06981f598$export$ca7c31f03d6e8f02);
$parcel$export(module.exports, "isNewEditorAiFeedbackCollectorEnabled", () => $706d7ea06981f598$export$2ed16947150cc8c);
$parcel$export(module.exports, "isIssueCommentsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$dcc4742bc52ec465);
$parcel$export(module.exports, "isIssueWorklogsHardLimitsFlagEnabled", () => $706d7ea06981f598$export$fa2b2d3091ee4acb);
$parcel$export(module.exports, "isIssueConfluenceLinksHardLimitsFlagEnabled", () => $706d7ea06981f598$export$8138f2ec6e2b730c);
$parcel$export(module.exports, "isNotifyAdminModalHardLimitsEnabled", () => $706d7ea06981f598$export$b014ef5adbdaef11);
$parcel$export(module.exports, "isSmartSummariesNewDisclaimerEnabled", () => $706d7ea06981f598$export$d6f2a732166d94ed);
$parcel$export(module.exports, "isNavigationBlockAIWorkBreakdownEnabled", () => $706d7ea06981f598$export$750399b1f64b9999);
$parcel$export(module.exports, "issueDetailsHardLimitsMilestone1Enabled", () => $706d7ea06981f598$export$d0ed2d8440fb5bbc);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueRemoteLinkEnabled", () => $706d7ea06981f598$export$41470180bace44ba);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueAttachmentsEnabled", () => $706d7ea06981f598$export$9a5cf06e051f6deb);
$parcel$export(module.exports, "issueDetailsHardLimitsIssueWeblinksEnabled", () => $706d7ea06981f598$export$e3bcb7ed6340e909);
$parcel$export(module.exports, "isChangeboardingForParentEnabled", () => $706d7ea06981f598$export$a0e01c32249a7097);
$parcel$export(module.exports, "isOptimisticWeblinksFixEnabled", () => $706d7ea06981f598$export$dbaa92a1f690c8fe);
$parcel$export(module.exports, "getPerformanceTrackingConfiguration", () => $706d7ea06981f598$export$78dd97cfaffb6fb1);
$parcel$export(module.exports, "getValidTransactionsTrackingConfiguration", () => $706d7ea06981f598$export$a801da94b6dd586b);
$parcel$export(module.exports, "isEditorUFOEnabled", () => $706d7ea06981f598$export$fd99e03c299972d3);
$parcel$export(module.exports, "getTTRSeverityTrackingConfiguration", () => $706d7ea06981f598$export$6fb6e5d98b15585b);
$parcel$export(module.exports, "getUnsupportedContentLevelsTrackingConfiguration", () => $706d7ea06981f598$export$eccecfefbd48225b);
$parcel$export(module.exports, "isSpecBasedValidatorEnabled", () => $706d7ea06981f598$export$ef24e9eecc594777);
$parcel$export(module.exports, "isModernGlobalIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$67305b99ef59566c);
$parcel$export(module.exports, "isCreateLinkedIssueTriggerPointEnabled", () => $706d7ea06981f598$export$fa44fb942e45b85d);
$parcel$export(module.exports, "isModernGlobalSubtaskIssueCreateTriggerEnabled", () => $706d7ea06981f598$export$9ba0da55e7f403e1);
$parcel$export(module.exports, "isModernGICEnabledForSubtask", () => $706d7ea06981f598$export$dbaf42ba39b66293);
$parcel$export(module.exports, "isProformaHarmonisationFFEnabled", () => $706d7ea06981f598$export$5dc774c58824d858);
$parcel$export(module.exports, "isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled", () => $706d7ea06981f598$export$73957227bab0d3f7);
$parcel$export(module.exports, "isDisableEpicLinkAndParentLinkFieldsEnabled", () => $706d7ea06981f598$export$dd5401dbc8bdbdfb);
$parcel$export(module.exports, "isRequestIsDoneWhenRequestingParentCandidatesEnabled", () => $706d7ea06981f598$export$c197f8974183a4f0);
$parcel$export(module.exports, "isRemoveParentLinkFromIssueViewEnabled", () => $706d7ea06981f598$export$6e06c78fd874f07f);
$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $706d7ea06981f598$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isIncrementPlanningM1Enabled", () => $706d7ea06981f598$export$33e603f2e83329f5);
$parcel$export(module.exports, "isSwitcherooRealtimeExposuresTestFlagEnabled", () => $706d7ea06981f598$export$a73c9c09ec24e5e9);
$parcel$export(module.exports, "isPlaceHolderTemplateE2EEnabled", () => $706d7ea06981f598$export$4df93ecfbfdca877);
$parcel$export(module.exports, "isCompalIssueActionsEnabled", () => $706d7ea06981f598$export$641196cc6a6481ea);
$parcel$export(module.exports, "isCompalIssueActionsFollowUpImprovementsEnabled", () => $706d7ea06981f598$export$7c0bd221ecbf9b57);
$parcel$export(module.exports, "isCompalIssueActionsVeryHighPriorityEnabled", () => $706d7ea06981f598$export$d5d401f0a31e62ea);
$parcel$export(module.exports, "isSelectableFieldEditViewIntegrationEnabled", () => $706d7ea06981f598$export$e253ac70cea0d36b);
$parcel$export(module.exports, "isHistoryActivityFeedAttachmentUpdatesEnabled", () => $706d7ea06981f598$export$ca654183a67f7c1d);
$parcel$export(module.exports, "isRemoveIssueAttachmentPanelViewedEventEnabled", () => $706d7ea06981f598$export$ecfec49bad872d16);
$parcel$export(module.exports, "isFetchingRequiredFieldOnRenderEnabled", () => $706d7ea06981f598$export$fe59b559919ee088);
$parcel$export(module.exports, "isJiraSmartSummaryOnboardingEnabled", () => $706d7ea06981f598$export$5194de77e8750c41);
$parcel$export(module.exports, "isJiraSmartSummaryAIMateEndpointEnabled", () => $706d7ea06981f598$export$3cfaae79d46ba7ee);
$parcel$export(module.exports, "isDefinitionCheckConfluenceAccessEnabled", () => $706d7ea06981f598$export$edfcfe610bd14d1);
$parcel$export(module.exports, "IsAIWorkBreakdownNewUiEnabled", () => $706d7ea06981f598$export$34d90e61db572fb4);
$parcel$export(module.exports, "isStatusInGicEnabled", () => $706d7ea06981f598$export$30cd538422d6ae26);
$parcel$export(module.exports, "isJsmSmartRequestSummaryEnabled", () => $706d7ea06981f598$export$7e4aef4ae0b914e2);
$parcel$export(module.exports, "isAltTextOnImagesEnabled", () => $706d7ea06981f598$export$9591540fa082da5a);
$parcel$export(module.exports, "useM4LayoutDataInBentoConsistencyCheckValue", () => $706d7ea06981f598$export$df603fd34aea93ca);
$parcel$export(module.exports, "ISSUE_DETAILS_SORTING_PINNED_FIELDS", () => $706d7ea06981f598$export$e6ec1a9a62cbf071);
$parcel$export(module.exports, "isSortingPinnedFieldsEnabled", () => $706d7ea06981f598$export$cce5c39a2a1dacf1);
$parcel$export(module.exports, "getEnableFlexibleBlockCardInIssueEditor", () => $706d7ea06981f598$export$408491224a0c915b);
$parcel$export(module.exports, "isTeamFieldInSubtasksEnabled", () => $706d7ea06981f598$export$150e448c819201a7);
$parcel$export(module.exports, "isOfferingCatalogueFeaturesEnabled", () => $706d7ea06981f598$export$369fa0ed6b2504fb);
$parcel$export(module.exports, "isRendererTtiTrackingEnabled", () => $706d7ea06981f598$export$b236d4b6aec7c4c3);
$parcel$export(module.exports, "isPriorityFieldTooltipEnabled", () => $706d7ea06981f598$export$a792a3f88a852f06);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $706d7ea06981f598$export$575e1bf822db15b5);
$parcel$export(module.exports, "isCannedResponseFFEnabled", () => $706d7ea06981f598$export$9f71233b08c04922);
$parcel$export(module.exports, "isSignatureCrFFEnabled", () => $706d7ea06981f598$export$8521761ebcf26351);
$parcel$export(module.exports, "isRespondersFieldAvailableInAllProjectsEnabled", () => $706d7ea06981f598$export$6f0be57bd65ee8bc);
$parcel$export(module.exports, "isEcClientEnabled", () => $706d7ea06981f598$export$e3bafd4acea73c60);
$parcel$export(module.exports, "isOverrideCreationDateEnabled", () => $706d7ea06981f598$export$dda3a2d16a2e0a31);
$parcel$export(module.exports, "isDeleteissueViewMetricsEnabled", () => $706d7ea06981f598$export$fad47591ae56c23f);
$parcel$export(module.exports, "is4xxRequestsIgnoreEnabled", () => $706d7ea06981f598$export$6d1f8ae8cf9bbc71);
$parcel$export(module.exports, "isMiddleClickFixEnabled", () => $706d7ea06981f598$export$7dbe34739b0d70b8);
$parcel$export(module.exports, "isLogForMissingProjectTypeEnabled", () => $706d7ea06981f598$export$3fa1b10a7b484874);
$parcel$export(module.exports, "isGiraAGGIsArchivedEnabled", () => $706d7ea06981f598$export$6604067817758030);
$parcel$export(module.exports, "isArchivedIssuesPageLinkEnabled", () => $706d7ea06981f598$export$c108c03095e0e655);
$parcel$export(module.exports, "isBM3EmitOnRafTopExperiencesEnabled", () => $706d7ea06981f598$export$ee410f0ba32dc900);
$parcel$export(module.exports, "isCustomMessageForLinkingWithoutPermissionsEnabled", () => $706d7ea06981f598$export$3068bf83bd6f9396);
$parcel$export(module.exports, "isSearchByEmailInMultiselectUserPickerEnabled", () => $706d7ea06981f598$export$da019fa3d31e5c7e);
$parcel$export(module.exports, "isRelayReleaseVersionFieldIssueViewIntegrationEnabled", () => $706d7ea06981f598$export$48d407f97269c8fa);
$parcel$export(module.exports, "isAsyncFieldOptionsTechDebtEnabled", () => $706d7ea06981f598$export$8a90e3b075447800);
$parcel$export(module.exports, "isJsmFixIncompatibleRequestTypeInconsistenciesEnabled", () => $706d7ea06981f598$export$733566d04cfe61b1);
$parcel$export(module.exports, "PlaceHolderTemplateFlags", () => $706d7ea06981f598$export$bf10032e4a734a65);
$parcel$export(module.exports, "getPlaceHolderTemplateVariant", () => $706d7ea06981f598$export$fb512d5beec30a90);
$parcel$export(module.exports, "isConfluencePageDummyLinkExperiment", () => $706d7ea06981f598$export$6e7dfb06c9e45ae7);
$parcel$export(module.exports, "isConfluencePageDummyLinkEnabled", () => $706d7ea06981f598$export$ef28379ba310de6e);
$parcel$export(module.exports, "isStopLoadingFieldConfigTwiceEnabled", () => $706d7ea06981f598$export$98dcb5ffd7beaf00);
$parcel$export(module.exports, "isNonCriticalGiraQueryExperienceTrackingEnabled", () => $706d7ea06981f598$export$8ea052ed520b62bc);
$parcel$export(module.exports, "isSHA256EnabledForMediaConfig", () => $706d7ea06981f598$export$a88e7ad1ce082e7d);
$parcel$export(module.exports, "isFilterIssueChangedEvents", () => $706d7ea06981f598$export$d616286874a25f83);
$parcel$export(module.exports, "isJiraForgeExtensionChangesForAegisEnabled", () => $706d7ea06981f598$export$496e94e3da873a49);
$parcel$export(module.exports, "isDisableUnneededForgeMetricsEnabled", () => $706d7ea06981f598$export$cd0e0ab900757d23);
$parcel$export(module.exports, "isAnotherExtensionContextForForgeBackgroundScriptsEnabled", () => $706d7ea06981f598$export$ea998c148f057985);
$parcel$export(module.exports, "isForgeExtensionMetricsFixEnabled", () => $706d7ea06981f598$export$3b4e3c7791b3909);
$parcel$export(module.exports, "isCompassComponentsEnabled", () => $706d7ea06981f598$export$33008660eb5353ef);
$parcel$export(module.exports, "isConferenceCallFieldHidden", () => $706d7ea06981f598$export$176e4d6701700463);
$parcel$export(module.exports, "isIssueLinkLimitEnabled", () => $706d7ea06981f598$export$c567845e4f18ee11);
$parcel$export(module.exports, "isCreateConfluencePagesEnabled", () => $706d7ea06981f598$export$2b839c758c080224);
$parcel$export(module.exports, "isOptimiseEditorOnchangeCallsEnabled", () => $706d7ea06981f598$export$7411486b04537f62);
$parcel$export(module.exports, "isMentionsAnalyticsEnabled", () => $706d7ea06981f598$export$281da19089438270);
$parcel$export(module.exports, "isNewLinkPickerEnabled", () => $706d7ea06981f598$export$ae2025957f2940e4);
$parcel$export(module.exports, "isTraceIdForRelayErrorsEnabled", () => $706d7ea06981f598$export$d83d25e87b40c475);
$parcel$export(module.exports, "getJiraIssuesDatasourceEnabled", () => $706d7ea06981f598$export$1c607d9b866655e1);
$parcel$export(module.exports, "shouldUseNewEditorCardProvider", () => $706d7ea06981f598$export$8c74256e92f57afb);
$parcel$export(module.exports, "isMentionsIndicatorEnabled", () => $706d7ea06981f598$export$5cb6179ec1a74a5a);
$parcel$export(module.exports, "isDevOpsAppRecommenderEnabled", () => $706d7ea06981f598$export$882e8ff421f7744c);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemBackgroundScriptsFromTTIEnabled", () => $706d7ea06981f598$export$c3737cff1b9064df);
$parcel$export(module.exports, "isIssueDescriptionReadingAidEnabled", () => $706d7ea06981f598$export$f16a46bb33ebb09c);
$parcel$export(module.exports, "isIssueDescriptionAcronymsHighlightEnabled", () => $706d7ea06981f598$export$7071b16bdeedd7e0);
$parcel$export(module.exports, "isIssueViewUnlinkGlancesFieldFromUi", () => $706d7ea06981f598$export$709da340f602ae6e);
$parcel$export(module.exports, "isIssueViewRemoveGlancesFieldFromQuery", () => $706d7ea06981f598$export$8db987307934d214);
$parcel$export(module.exports, "isIssueViewImplementDeadGlancesFieldQuery", () => $706d7ea06981f598$export$694fa8b8c523f4cc);
$parcel$export(module.exports, "isAggMigrationAttachmentsEnabled", () => $706d7ea06981f598$export$5a53bba8e442c4f9);
$parcel$export(module.exports, "isIssueViewWhiteboardsStandaloneEnabled", () => $706d7ea06981f598$export$6f64fb042a8db7d9);
$parcel$export(module.exports, "isDynamicEditButtonLabelEnabled", () => $706d7ea06981f598$export$27d85e4af83ec7f9);
$parcel$export(module.exports, "isNinColumnResizingEnabled", () => $706d7ea06981f598$export$1f76c12fbdafb975);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewCrossJoinEnabled", () => $706d7ea06981f598$export$667dd70f296d7a79);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueLinkedPageCrossJoinEnabled", () => $706d7ea06981f598$export$8d9e5c2fc560d7fb);
$parcel$export(module.exports, "isEmbeddedConfluenceIssueViewDeferSpaceSelectionEnabled", () => $706d7ea06981f598$export$712b6916406c5e2a);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $706d7ea06981f598$export$60184d6d974595a9);
$parcel$export(module.exports, "isIssueViewRemoveEcosystemActivityPanelsFromTTIEnabled", () => $706d7ea06981f598$export$b7098c14b9be61bc);
$parcel$export(module.exports, "isGoalsFieldEnabledInIssueView", () => $706d7ea06981f598$export$602a082cd6009b66);
$parcel$export(module.exports, "isTokensAndStyledComponentsMigrationEnabled", () => $706d7ea06981f598$export$590b056868f89976);
$parcel$export(module.exports, "isIssueArchivalFeatureEnabled", () => $706d7ea06981f598$export$f67982569b9aab31);
$parcel$export(module.exports, "isIssueDateFieldSavedOnChange", () => $706d7ea06981f598$export$694f7148d449e12);
$parcel$export(module.exports, "isSentimentFieldEnabled", () => $706d7ea06981f598$export$cd66b30e1a3ad3b0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $706d7ea06981f598$export$e92cc7310d059d3e);
$parcel$export(module.exports, "isIssueViewClassificationLevelEditabilityEnabled", () => $706d7ea06981f598$export$ab71258032925094);
$parcel$export(module.exports, "isDeleteLinkedIssueSLOEnabled", () => $706d7ea06981f598$export$2923d3b89bbda235);
$parcel$export(module.exports, "isFixForJracloud82128Enabled", () => $706d7ea06981f598$export$ff32b5a0029469f1);
$parcel$export(module.exports, "isCompalParentStatusCategoryIdEnabled", () => $706d7ea06981f598$export$8d6eb687c2a90c8c);
$parcel$export(module.exports, "isJSMRestrictInternalCommentVisibilityEnabled", () => $706d7ea06981f598$export$5dbdd9e44df66fdb);
$parcel$export(module.exports, "isIssueViewFitAndFinishM2Enabled", () => $706d7ea06981f598$export$61a4e4e1a79114de);
$parcel$export(module.exports, "aggUseIsEditableInViewFlag", () => $706d7ea06981f598$export$9e983b29015333eb);
$parcel$export(module.exports, "isLinkedPagesBugFixEnabled", () => $706d7ea06981f598$export$35cba8f6a1edcd6a);
$parcel$export(module.exports, "isUIMCascadingSelectFieldEnablead", () => $706d7ea06981f598$export$418f24ad76008d74);
$parcel$export(module.exports, "sprintFieldLongTextFixFlag", () => $706d7ea06981f598$export$24744533e9559f1e);
$parcel$export(module.exports, "selectableFieldEditViewReplaceSelectWithFooter", () => $706d7ea06981f598$export$614b1f6ee38ef8fe);
$parcel$export(module.exports, "isAIUpsellPremiumTrailEnabled", () => $706d7ea06981f598$export$63beab816c3f18b1);
$parcel$export(module.exports, "isEmbeddedConfluenceCreateContentCrossFlowEnabled", () => $706d7ea06981f598$export$8fa51a766c2ece72);
$parcel$export(module.exports, "isRendererDefaultSmartLinksValueEnabled", () => $706d7ea06981f598$export$36797146406f89b2);
$parcel$export(module.exports, "isHoverCardAISummariesEnabled", () => $706d7ea06981f598$export$68300000ff0840c3);
$parcel$export(module.exports, "isAffectsVersionsFieldSupportForIVEnabled", () => $706d7ea06981f598$export$71ed36e51616c829);
$parcel$export(module.exports, "isIssueViewNudgeExperimentEnabled", () => $706d7ea06981f598$export$d9ce3c80c1cc862d);
$parcel$export(module.exports, "isApprovalsGlancePanelToCollapsibleContextGroupEnabled", () => $706d7ea06981f598$export$9e54bab54faf7459);
$parcel$export(module.exports, "isConfluenceIntegrationsAdminControlsEnabled", () => $706d7ea06981f598$export$268b11901e56613a);
$parcel$export(module.exports, "isCascadingSelectSupportForUIMEnabled", () => $706d7ea06981f598$export$4399c72174f6c25d);
$parcel$export(module.exports, "isWhiteboardStandaloneEnabled", () => $706d7ea06981f598$export$18b62f1e8801aa0f);
$parcel$export(module.exports, "isFitAndFinishFullPageMilestone2", () => $706d7ea06981f598$export$56ceecd3414268e0);
$parcel$export(module.exports, "isCrossJoinContentPreviewEnabled", () => $706d7ea06981f598$export$ce9fb45735ec88ee);
$parcel$export(module.exports, "isHandleIssueCommentsEmptyEnabled", () => $706d7ea06981f598$export$bbd89fe4e4d7eff9);
$parcel$export(module.exports, "isHideLinkedIssueKeyForNonAuthorisesEnabled", () => $706d7ea06981f598$export$31792eb3d1db9c94);
$parcel$export(module.exports, "removeAllMentionsOfNewIssueView", () => $706d7ea06981f598$export$4eddc5d109dcba69);
$parcel$export(module.exports, "isReactReduxV8Upgrade", () => $706d7ea06981f598$export$fc502a08f3da8431);
$parcel$export(module.exports, "isAvoidProjectRedirectFromIssueViewEnabled", () => $706d7ea06981f598$export$27b1ada3a4e1a808);
$parcel$export(module.exports, "isCMDBAttributeIdRemoved", () => $706d7ea06981f598$export$98975042f993a7b1);
$parcel$export(module.exports, "isExtraPaddingOnIssueActionButtonsEnabled", () => $706d7ea06981f598$export$7248d3c792741fe6);
$parcel$export(module.exports, "isBentoViewModeRefactor", () => $706d7ea06981f598$export$6f11e578fe0086aa);
$parcel$export(module.exports, "is3pIssueWatchNudgeEnabled", () => $706d7ea06981f598$export$6ff28b2229a27899);
$parcel$export(module.exports, "isLinkedMentionedRestrictedPageOnClickEnabled", () => $706d7ea06981f598$export$aff6e532ec3ced01);
$parcel$export(module.exports, "isAddCommentScreenAnalyticsEnabled", () => $706d7ea06981f598$export$d365d0b31e3df46e);
$parcel$export(module.exports, "isJPDPanelEnabled", () => $706d7ea06981f598$export$c3c0abcc7a24c315);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $caTc0 = parcelRequire("caTc0");
const $706d7ea06981f598$export$a9f38f9f0d6f10af = ()=>(0, $1ybV0.ff)('ken-100-add-all-featureflags-to-issue-view-performance-events_kmez7');
const $706d7ea06981f598$export$b5be9eaa7fce369 = ()=>(0, $1ybV0.ff)('configurable-child-issues-panel_3ht06', false);
const $706d7ea06981f598$export$9e18785497c1673b = ()=>(0, $1ybV0.ff)('issue-comment-render_tt9jk');
const $706d7ea06981f598$export$35c0c8db33387f4d = ()=>(0, $1ybV0.ff)('issue-comment-fetch_9eeal');
const $706d7ea06981f598$export$6e4f76cd76a804da = ()=>(0, $1ybV0.ff)('ecosystem_content_panel_lhs_6eptr');
const $706d7ea06981f598$export$7f7b600c4eafe68f = ()=>(0, $1ybV0.ff)('issue_view_quick_actions_revamp_l8mbx');
const $706d7ea06981f598$export$c8aa8a13c42858dd = ()=>(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw', false);
const $706d7ea06981f598$export$3041d162b6562717 = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$7af43b56ceb4b148 = ()=>(0, $1ybV0.ff)('issue.details.issue-fetch-epic-prefetched-agg-query-logging', false);
const $706d7ea06981f598$export$11c3bd37c4149e8a = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-ui-fixes', false);
const $706d7ea06981f598$export$91d9e9331bcb489f = ()=>(0, $1ybV0.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration');
const $706d7ea06981f598$export$4bef98bf98ff2cb = ()=>(0, $1ybV0.ff)('issue.details.migration-migrated-stream', false);
const $706d7ea06981f598$export$3c97eb4b6ff2fec1 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]) === 'CHECK';
const $706d7ea06981f598$export$183bff9fcee964a2 = ()=>(0, $1ybV0.ff)('issue.details.jira-issue-view-editor-ai_sozy', false);
const $706d7ea06981f598$export$a42a9ff4a537eac1 = ()=>(0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai', false);
const $706d7ea06981f598$export$bb7bcfe9ba7992e5 = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl', false);
const $706d7ea06981f598$export$be02cc41570f884f = ()=>(0, $1ybV0.ff)('issue.details.jira-smart-summary-platform_0jta9', false);
const $706d7ea06981f598$export$25f1a380ac523ab1 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-onboarding', false);
const $706d7ea06981f598$export$b9ecdb2af6d8a25 = ()=>(0, $1ybV0.ff)('issue.details.issue-type-select-hierarchy-fix', false);
const $706d7ea06981f598$export$a1b2fc5741a7de01 = ()=>(0, $1ybV0.ff)('issue.details.shard-and-region-to-slo-analytics', false);
const $706d7ea06981f598$export$b1c6c927b1de3746 = ()=>(0, $1ybV0.ff)('issue.details.feature-flags-to-slo-analytics', false);
const $706d7ea06981f598$export$3694fdeb5d384181 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-disclaimer-update', false);
const $706d7ea06981f598$export$4166161ebaa7c45b = ()=>(0, $1ybV0.ff)('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);
const $706d7ea06981f598$export$c3e066f7be7868e8 = ()=>(0, $1ybV0.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');
const $706d7ea06981f598$export$a3e5d5dfe1ed90ed = ()=>(0, $1ybV0.ff)('issue.details.media-inline', false);
const $706d7ea06981f598$export$d7d142f5ac020394 = ()=>(0, $1ybV0.ff)('jira.teams.enable-new-custom-field-types', false);
const $706d7ea06981f598$export$cdd5c612352d7bf0 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.VARIATION)
    ]) === (0, $1Iui1.VARIATION);
const $706d7ea06981f598$export$5b9220081498abd7 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('invite.from.assign.modal', 'not-enrolled', [
        'control',
        'not-enrolled',
        'variation'
    ]);
const $706d7ea06981f598$export$89f18660d3a3bb78 = ()=>(0, $1ybV0.ff)('invite.from.assign.modal.fe.event', false);
const $706d7ea06981f598$export$dd98acc8d28f3c1e = ()=>(0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation', false);
const $706d7ea06981f598$export$f0ece2538dd9e423 = ()=>(0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6');
const $706d7ea06981f598$export$ca7c31f03d6e8f02 = ()=>(0, $1ybV0.ff)('trello.card.integration.patch', false);
const $706d7ea06981f598$export$2ed16947150cc8c = ()=>(0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk');
const $706d7ea06981f598$export$dcc4742bc52ec465 = ()=>(0, $1ybV0.ff)('comment-limit-exceed-warning-flag_3rx53', false);
const $706d7ea06981f598$export$fa2b2d3091ee4acb = ()=>(0, $1ybV0.ff)('worklog-limit-exceed-warning-flag_hh86h', false);
const $706d7ea06981f598$export$8138f2ec6e2b730c = ()=>(0, $1ybV0.ff)('confluence-link-limit-exceed-warning-flag_1ycku', false);
const $706d7ea06981f598$export$b014ef5adbdaef11 = ()=>(0, $1ybV0.ff)('hard-limits-modal-admin_wo9xn', false);
const $706d7ea06981f598$export$d6f2a732166d94ed = ()=>(0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u', false);
const $706d7ea06981f598$export$750399b1f64b9999 = ()=>(0, $1ybV0.ff)('navigation-blocker-for-ai-work-breakdown_tb7cx', false);
const $706d7ea06981f598$export$d0ed2d8440fb5bbc = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.milestone-1');
const $706d7ea06981f598$export$41470180bace44ba = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-remote-link');
const $706d7ea06981f598$export$9a5cf06e051f6deb = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-attachments-limit');
const $706d7ea06981f598$export$e3bcb7ed6340e909 = ()=>(0, $1ybV0.ff)('issue.details.hard-limits.issue-weblinks-limit');
const $706d7ea06981f598$export$a0e01c32249a7097 = ()=>(0, $1ybV0.ff)('parent-field-changeboarding_4ljdy', false);
const $706d7ea06981f598$export$dbaa92a1f690c8fe = ()=>(0, $1ybV0.ff)('issue.details.display-flag-on-optimistic-weblinks-error');
const $706d7ea06981f598$export$78dd97cfaffb6fb1 = ()=>(0, $1ybV0.getFeatureFlagValue)('issue.details.editor.performance-tracking', {});
const $706d7ea06981f598$export$a801da94b6dd586b = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (0, $1ybV0.getFeatureFlagValue)('issue.details.editor.valid-transactions-tracking', {});
    // workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
    const enabled = typeof value === 'object' && Object.keys(value).length;
    return enabled ? value : undefined;
};
const $706d7ea06981f598$export$fd99e03c299972d3 = ()=>(0, $1ybV0.ff)('issue.details.editor.ufo', false);
const $706d7ea06981f598$export$6fb6e5d98b15585b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.ttr-severity-tracking', {});
const $706d7ea06981f598$export$eccecfefbd48225b = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $1ybV0.getFeatureFlagValue)('issue.details.renderer.unsupported-content-levels-tracking', {});
const $706d7ea06981f598$export$ef24e9eecc594777 = ()=>(0, $1ybV0.ff)('issue.details.renderer.spec-based-validator');
const $706d7ea06981f598$export$67305b99ef59566c = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger', false);
const $706d7ea06981f598$export$fa44fb942e45b85d = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $706d7ea06981f598$export$9ba0da55e7f403e1 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-subtask-issue-create-trigger', false);
const $706d7ea06981f598$export$dbaf42ba39b66293 = ()=>$706d7ea06981f598$export$67305b99ef59566c() && $706d7ea06981f598$export$9ba0da55e7f403e1();
const $706d7ea06981f598$export$5dc774c58824d858 = ()=>(0, $1ybV0.ff)('proforma-harmonisation-main_ca6ff', false);
const $706d7ea06981f598$export$73957227bab0d3f7 = ()=>(0, $1ybV0.ff)('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);
const $706d7ea06981f598$export$dd5401dbc8bdbdfb = ()=>(0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);
const $706d7ea06981f598$export$c197f8974183a4f0 = ()=>(0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
const $706d7ea06981f598$export$6e06c78fd874f07f = ()=>(0, $1ybV0.ff)('remove-parent-link-from-issue-view_4t7dy', false);
const $706d7ea06981f598$export$9c7fa56ed1fa2e15 = ()=>(0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4', false);
const $706d7ea06981f598$export$33e603f2e83329f5 = ()=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', false);
const $706d7ea06981f598$export$a73c9c09ec24e5e9 = ()=>(0, $1ybV0.ff)('switcheroo-realtime-exposures-test-flag_648u4', false);
const $706d7ea06981f598$export$4df93ecfbfdca877 = ()=>(0, $1ybV0.ff)('jira.issue-view.placeholder-template-e2e-iteration', false);
const $706d7ea06981f598$export$641196cc6a6481ea = ()=>(0, $1ybV0.ff)('compal-issue-actions', false);
const $706d7ea06981f598$export$7c0bd221ecbf9b57 = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu', false);
const $706d7ea06981f598$export$d5d401f0a31e62ea = ()=>()=>(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r', false);
const $706d7ea06981f598$export$e253ac70cea0d36b = ()=>(0, $1ybV0.ff)('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);
const $706d7ea06981f598$export$ca654183a67f7c1d = ()=>(0, $1ybV0.ff)('jira-issue-view-activity-feed-syntax-value-updates', false);
const $706d7ea06981f598$export$ecfec49bad872d16 = ()=>(0, $1ybV0.ff)('remove-issueattachmentpanel-viewed-event_w282l');
const $706d7ea06981f598$export$fe59b559919ee088 = ()=>(0, $1ybV0.ff)('issue-view-fetch-the-required-field-on-rendering_lgknh', false);
const $706d7ea06981f598$export$5194de77e8750c41 = ()=>(0, $1ybV0.ff)('jira-issue-view-smart-summary-onboarding_jmzm7', false);
const $706d7ea06981f598$export$3cfaae79d46ba7ee = ()=>(0, $1ybV0.ff)('issue.details-smart-summary-with-ai-mate_qqug7.', false);
const $706d7ea06981f598$export$edfcfe610bd14d1 = ()=>(0, $1ybV0.ff)('issue-view-disable-definition-feature-if-the-user-doesnt-have-confluence-access_inh6g', false);
const $706d7ea06981f598$export$34d90e61db572fb4 = ()=>(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn', false);
const $706d7ea06981f598$export$30cd538422d6ae26 = ()=>(0, $1ybV0.ff)('issue.details.gic.add_status_field', false);
const $706d7ea06981f598$export$7e4aef4ae0b914e2 = ()=>(0, $1ybV0.ff)('enable-jsm-smart-request-summary_kva1r', false);
const $706d7ea06981f598$export$9591540fa082da5a = ()=>(0, $1ybV0.ff)('editor.renderer-alt-text-on-images', false);
const $706d7ea06981f598$export$df603fd34aea93ca = ()=>(0, $1ybV0.getFeatureFlagValue)('project.config.pce.use-m4-issue-layout-data-in-bento.with-consistency-check', 'OLD');
const $706d7ea06981f598$export$e6ec1a9a62cbf071 = 'issue.details.sorting-pinned-fields';
const $706d7ea06981f598$export$cce5c39a2a1dacf1 = ()=>(0, $1ybV0.ff)('issue.details.sorting-pinned-fields', false);
const $706d7ea06981f598$export$408491224a0c915b = ()=>(0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card');
const $706d7ea06981f598$export$150e448c819201a7 = ()=>(0, $1ybV0.ff)('jira.frontend.ptc.team-field-in-subtasks', false);
const $706d7ea06981f598$export$369fa0ed6b2504fb = ()=>(0, $1ybV0.ff)('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
const $706d7ea06981f598$export$b236d4b6aec7c4c3 = ()=>(0, $1ybV0.ff)('issue.details.renderer.tti-tracking', false);
const $706d7ea06981f598$export$a792a3f88a852f06 = ()=>(0, $1ybV0.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
const $706d7ea06981f598$export$575e1bf822db15b5 = ()=>(0, $1ybV0.ff)('jsm-timelines-phase-2_70gja', false);
const $706d7ea06981f598$export$9f71233b08c04922 = ()=>(0, $1ybV0.ff)('jsm-canned-response', false);
const $706d7ea06981f598$export$8521761ebcf26351 = ()=>(0, $1ybV0.ff)('jsm-agent-signature-cr-enabled', false);
const $706d7ea06981f598$export$6f0be57bd65ee8bc = ()=>(0, $1ybV0.ff)('responders-field-in-all-projects-issues-ui', false);
const $706d7ea06981f598$export$e3bafd4acea73c60 = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '');
    return experiences.length > 0;
};
const $706d7ea06981f598$export$dda3a2d16a2e0a31 = ()=>(0, $1ybV0.ff)('override-date-for-attachment-timestamp-in-film-strip_ymajc');
const $706d7ea06981f598$export$fad47591ae56c23f = ()=>(0, $1ybV0.ff)('metric-for-issue-delete-inside-issue-view_baxre');
const $706d7ea06981f598$export$6d1f8ae8cf9bbc71 = ()=>(0, $1ybV0.ff)('ken-429-restrict-4xx-error_vi8v7', false);
const $706d7ea06981f598$export$7dbe34739b0d70b8 = ()=>(0, $1ybV0.ff)('ken-524-fix-middle-click-issue-for-linked-issues_x1hgl', false);
const $706d7ea06981f598$export$3fa1b10a7b484874 = ()=>(0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv', false);
const $706d7ea06981f598$export$6604067817758030 = ()=>{
    const featureFlagValue = (0, $1ybV0.getMultivariateFeatureFlag)('issue.details.gira-agg-migration-isarchived', 'OLD', [
        'OLD',
        'NEW',
        'CHECK',
        'CHECK_RETURN_NEW'
    ]);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $706d7ea06981f598$export$c108c03095e0e655 = ()=>(0, $1ybV0.ff)('enable-archived-issues-page-link', false);
const $706d7ea06981f598$export$ee410f0ba32dc900 = ()=>(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences', false);
const $706d7ea06981f598$export$3068bf83bd6f9396 = ()=>(0, $1ybV0.ff)('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);
const $706d7ea06981f598$export$da019fa3d31e5c7e = ()=>(0, $1ybV0.ff)('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);
const $706d7ea06981f598$export$48d407f97269c8fa = ()=>(0, $1ybV0.ff)('issue.details.relay-release-version-field-issue-view-integration', false);
const $706d7ea06981f598$export$8a90e3b075447800 = ()=>(0, $1ybV0.ff)('issue.details.async-field-options-tech-debt', false);
const $706d7ea06981f598$export$733566d04cfe61b1 = ()=>(0, $1ybV0.ff)('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
const $706d7ea06981f598$export$bf10032e4a734a65 = {
    CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow'
};
const $706d7ea06981f598$export$fb512d5beec30a90 = (experiment)=>experiment ? (0, $1ybV0.getMultivariateFeatureFlag)(experiment, (0, $1Iui1.NOT_ENROLLED), [
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7),
        (0, $3401608855dcf8dc$export$c52ae1847ec8c2c),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.NOT_ENROLLED)
    ]) : (0, $1Iui1.NOT_ENROLLED);
const $706d7ea06981f598$export$6e7dfb06c9e45ae7 = ()=>[
        (0, $1Iui1.CONTROL),
        (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7)
    ].includes($706d7ea06981f598$export$fb512d5beec30a90($706d7ea06981f598$export$bf10032e4a734a65.CROSS_FLOW));
const $706d7ea06981f598$export$ef28379ba310de6e = (experiment)=>$706d7ea06981f598$export$fb512d5beec30a90(experiment) === (0, $3401608855dcf8dc$export$fb6fa89d43ed06f7);
const $706d7ea06981f598$export$98dcb5ffd7beaf00 = ()=>(0, $1ybV0.ff)('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
const $706d7ea06981f598$export$8ea052ed520b62bc = ()=>(0, $1ybV0.ff)('issue.details.non-critical-gira-query-experience-tracking', false);
const $706d7ea06981f598$export$a88e7ad1ce082e7d = ()=>(0, $1ybV0.ff)('issue.details.update-media-config-to-sha256', false);
const $706d7ea06981f598$export$d616286874a25f83 = ()=>(0, $1ybV0.ff)('filter-issue-changed-connect-app-events-to-non-dialogs');
const $706d7ea06981f598$export$496e94e3da873a49 = ()=>(0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
const $706d7ea06981f598$export$cd0e0ab900757d23 = ()=>(0, $1ybV0.ff)('remove-invalid-forge-metrics_n3ddj');
const $706d7ea06981f598$export$ea998c148f057985 = ()=>(0, $1ybV0.ff)('change-the-way-we-get-project-context-for-forge-background-scripts_smqab');
const $706d7ea06981f598$export$3b4e3c7791b3909 = ()=>(0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx');
const $706d7ea06981f598$export$33008660eb5353ef = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u', false);
const $706d7ea06981f598$export$176e4d6701700463 = ()=>(0, $1ybV0.ff)('hide-icc-for-all-users_avyh5', false);
const $706d7ea06981f598$export$c567845e4f18ee11 = ()=>(0, $1ybV0.ff)('issue.details.issue-link-limit-exceed-warning-flag');
const $706d7ea06981f598$export$2b839c758c080224 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
const $706d7ea06981f598$export$7411486b04537f62 = ()=>(0, $1ybV0.ff)('issue-details-optimise-editor-onchange-calls_bb4fq', false);
const $706d7ea06981f598$export$281da19089438270 = ()=>(0, $1ybV0.ff)('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji');
const $706d7ea06981f598$export$ae2025957f2940e4 = ()=>(0, $1ybV0.ff)('platform.linking-platform.link-picker_tgrho', false);
const $706d7ea06981f598$export$d83d25e87b40c475 = ()=>(0, $1ybV0.ff)('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
const $706d7ea06981f598$export$1c607d9b866655e1 = ()=>(0, $1ybV0.ff)('platform.linking-platform.datasource-jira_issues', false);
const $706d7ea06981f598$export$8c74256e92f57afb = ()=>(0, $1ybV0.ff)('platform.linking-platform.use-new-editor-card-provider', false);
const $706d7ea06981f598$export$5cb6179ec1a74a5a = ()=>(0, $caTc0.isInMentionsIndicatorExperimentCohort)();
const $706d7ea06981f598$export$882e8ff421f7744c = ()=>(0, $1ybV0.ff)('devops_app_recommendation_on_link_paste', false) && (0, $79xbN.expValEquals)('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
const $706d7ea06981f598$export$c3737cff1b9064df = ()=>(0, $1ybV0.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
const $706d7ea06981f598$export$f16a46bb33ebb09c = ()=>(0, $1ybV0.ff)('feature.reading-aid-in-issue-description', false);
const $706d7ea06981f598$export$7071b16bdeedd7e0 = ()=>(0, $1ybV0.ff)('jira-reading-aid-acronyms-highlight_3hr5i');
const $706d7ea06981f598$export$709da340f602ae6e = ()=>(0, $1ybV0.ff)('issue-view-unlink-glancefield-from-ui_8a5yg');
const $706d7ea06981f598$export$8db987307934d214 = ()=>(0, $1ybV0.ff)('issue-view-remove-glancesfield-from-query_fyj0g');
const $706d7ea06981f598$export$694fa8b8c523f4cc = ()=>(0, $1ybV0.ff)('implement-dead-glancesfield-query_f71sc');
const $706d7ea06981f598$export$5a53bba8e442c4f9 = ()=>(0, $1ybV0.ff)('issue.details.gira-agg-migration-attachments_ecebe', false);
const $706d7ea06981f598$export$6f64fb042a8db7d9 = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$27d85e4af83ec7f9 = ()=>(0, $1ybV0.ff)('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f', false);
const $706d7ea06981f598$export$1f76c12fbdafb975 = ()=>(0, $1ybV0.ff)('nin-resizable-columns_8z4eo');
const $706d7ea06981f598$export$667dd70f296d7a79 = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_create_cross-join', false);
const $706d7ea06981f598$export$8d9e5c2fc560d7fb = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$712b6916406c5e2a = ()=>(0, $1ybV0.ff)('platform_embed-conf_jira-issue_co-use', false);
const $706d7ea06981f598$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false);
const $706d7ea06981f598$export$b7098c14b9be61bc = ()=>(0, $1ybV0.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj');
const $706d7ea06981f598$export$602a082cd6009b66 = ()=>(0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view', false);
const $706d7ea06981f598$export$590b056868f89976 = ()=>(0, $1ybV0.ff)('im-tokens-and-styled-components-migration_qpsld', false);
const $706d7ea06981f598$export$f67982569b9aab31 = ()=>(0, $1ybV0.ff)('issue-unarchival_wdpb9', false);
const $706d7ea06981f598$export$694f7148d449e12 = ()=>(0, $1ybV0.ff)('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur');
const $706d7ea06981f598$export$cd66b30e1a3ad3b0 = ()=>(0, $1ybV0.ff)('jsm-sentiment-analysis_1dage', false);
const $706d7ea06981f598$export$e92cc7310d059d3e = ()=>(0, $1ybV0.ff)('dlp-gordian-enabled', false);
const $706d7ea06981f598$export$ab71258032925094 = ()=>(0, $1ybV0.ff)('issue-view-classification-level-editability_88zal', false);
const $706d7ea06981f598$export$2923d3b89bbda235 = ()=>(0, $1ybV0.ff)('analytics_event_for_deletion_of_linked_issue_1ufi8', false);
const $706d7ea06981f598$export$ff32b5a0029469f1 = ()=>(0, $1ybV0.ff)('fix-for-jracloud-82128_379yp', false);
const $706d7ea06981f598$export$8d6eb687c2a90c8c = ()=>(0, $1ybV0.ff)('compal-issue-actions-parent-statuscategoryid_s2esc', false);
const $706d7ea06981f598$export$5dbdd9e44df66fdb = ()=>(0, $1ybV0.ff)('jsm-restrict-internal-comment-visibility', false);
const $706d7ea06981f598$export$61a4e4e1a79114de = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$9e983b29015333eb = ()=>(0, $1ybV0.ff)('jiv-17158-agg-use-iseditableinview_8nogh', false);
const $706d7ea06981f598$export$35cba8f6a1edcd6a = ()=>(0, $1ybV0.ff)('linked-pages-embedded-bug-fix', false);
const $706d7ea06981f598$export$418f24ad76008d74 = ()=>(0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda', false);
const $706d7ea06981f598$export$24744533e9559f1e = ()=>(0, $1ybV0.ff)('sprint-field-long-text-bug_fo95j', false);
const $706d7ea06981f598$export$614b1f6ee38ef8fe = ()=>(0, $1ybV0.ff)('selectable-field-edit-view-replace-select-with-footer_301u0', false);
const $706d7ea06981f598$export$63beab816c3f18b1 = ()=>(0, $1ybV0.ff)('jsw-premium-edition-eval-admin-ai-upsell_djht5', false);
const $706d7ea06981f598$export$8fa51a766c2ece72 = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
const $706d7ea06981f598$export$36797146406f89b2 = ()=>(0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value', false);
const $706d7ea06981f598$export$68300000ff0840c3 = ()=>(0, $1ybV0.ff)('platform.linking-platform.smart-card.hover-card-ai-summaries', false);
const $706d7ea06981f598$export$71ed36e51616c829 = ()=>(0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj', false);
const $706d7ea06981f598$export$d9ce3c80c1cc862d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$9e54bab54faf7459 = ()=>(0, $1ybV0.ff)('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
const $706d7ea06981f598$export$268b11901e56613a = ()=>(0, $1ybV0.ff)('confluence-admin-product-controls', false);
const $706d7ea06981f598$export$4399c72174f6c25d = ()=>(0, $1ybV0.ff)('jsw.xflow.issue-view-nudge-experiment', false);
const $706d7ea06981f598$export$18b62f1e8801aa0f = ()=>(0, $1ybV0.ff)('jira-issue-view-whiteboards-standalone', false);
const $706d7ea06981f598$export$56ceecd3414268e0 = ()=>(0, $1ybV0.ff)('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
const $706d7ea06981f598$export$ce9fb45735ec88ee = ()=>(0, $1ybV0.ff)('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
const $706d7ea06981f598$export$bbd89fe4e4d7eff9 = ()=>(0, $1ybV0.ff)('catch-issue-comments-empty-response-errors_o2gkc', false);
const $706d7ea06981f598$export$31792eb3d1db9c94 = ()=>(0, $1ybV0.ff)('hide-issue-key-when-linked-issue-has-no-access_8nb8t');
const $706d7ea06981f598$export$4eddc5d109dcba69 = ()=>(0, $1ybV0.ff)('remove-all-mentions-of-new-issue-view_unq0c', false);
const $706d7ea06981f598$export$fc502a08f3da8431 = ()=>(0, $1ybV0.ff)('jff.magma.react-redux-upgrade_53sr4', false);
const $706d7ea06981f598$export$27b1ada3a4e1a808 = ()=>(0, $1ybV0.ff)('jsw.perf.navigation.avoid-redirect-from-issue-view_iv5hd', false);
const $706d7ea06981f598$export$98975042f993a7b1 = ()=>(0, $1ybV0.ff)('assets-rearch-deprecate-attribute-value-id_ykukg', false);
const $706d7ea06981f598$export$7248d3c792741fe6 = ()=>(0, $1ybV0.ff)('fix-narrow-button-spacing-on-issue-actions_icmq8', false);
const $706d7ea06981f598$export$6f11e578fe0086aa = ()=>(0, $1ybV0.ff)('refactor-bento-view-mode-logic', false);
const $706d7ea06981f598$export$6ff28b2229a27899 = ()=>(0, $1ybV0.ff)('third_party_app_nudge_on_issues_watch', false) && (0, $79xbN.expValEquals)('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
const $706d7ea06981f598$export$aff6e532ec3ced01 = ()=>(0, $1ybV0.ff)('linked_mentioned_pages_handle_restricted_page_on_click', false);
const $706d7ea06981f598$export$d365d0b31e3df46e = ()=>(0, $1ybV0.ff)('jira.onboarding.kuro-5895', false);
const $706d7ea06981f598$export$c3c0abcc7a24c315 = ()=>(0, $1ybV0.ff)('polaris.jpd-panel-in-issue-view', false); // </alaktionova>

});
const $3401608855dcf8dc$export$fb6fa89d43ed06f7 = 'variant-contextual';
const $3401608855dcf8dc$export$c52ae1847ec8c2c = 'variant-contextual-not-enrolled';

parcelRegister("caTc0", function(module, exports) {

$parcel$export(module.exports, "isInMentionsIndicatorExperimentCohort", () => $09e2035ec940dd58$export$4d1c47e616b7a5fb);

var $79xbN = parcelRequire("79xbN");
function $09e2035ec940dd58$export$4d1c47e616b7a5fb() {
    return (0, $79xbN.expValEquals)('mentions_in_board_and_backlog_ver_2', 'cohort', 'test');
}

});


parcelRegister("lDYuK", function(module, exports) {

$parcel$export(module.exports, "setBoardDetailViewMode", () => $1ed8663d5b2b533f$export$5aec23d4b2954b61);
$parcel$export(module.exports, "getBoardDetailViewMode", () => $1ed8663d5b2b533f$export$30296c2892a21468);
$parcel$export(module.exports, "getSwimlaneModeSetting", () => $1ed8663d5b2b533f$export$1708c8217a67f3f9);

var $aZaPn = parcelRequire("aZaPn");

var $idwtd = parcelRequire("idwtd");
const $1ed8663d5b2b533f$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('software');
const $1ed8663d5b2b533f$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $1ed8663d5b2b533f$export$5aec23d4b2954b61 = (detailViewMode)=>$1ed8663d5b2b533f$var$localStorage.set((0, $idwtd.BOARD_DETAIL_VIEW_MODE), detailViewMode);
const $1ed8663d5b2b533f$export$30296c2892a21468 = ()=>$1ed8663d5b2b533f$var$localStorage.get((0, $idwtd.BOARD_DETAIL_VIEW_MODE)) || (0, $idwtd.DETAIL_VIEW_DEFAULT);
const $1ed8663d5b2b533f$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $1ed8663d5b2b533f$var$localStorage.get(`${$1ed8663d5b2b533f$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};

});
parcelRegister("idwtd", function(module, exports) {

$parcel$export(module.exports, "DETAIL_VIEW_SIDEBAR", () => $9ab19831f05a709e$export$dfb67e34e4333816);
$parcel$export(module.exports, "DETAIL_VIEW_MODAL", () => $9ab19831f05a709e$export$1d6094128a3bfe4a);
$parcel$export(module.exports, "DETAIL_VIEW_DEFAULT", () => $9ab19831f05a709e$export$ad4637adae7d3e97);
$parcel$export(module.exports, "BOARD_DETAIL_VIEW_MODE", () => $9ab19831f05a709e$export$201bf1eb7c447afa);
$parcel$export(module.exports, "swimlaneModeToStrategies", () => $9ab19831f05a709e$export$6b0228c67b1e82cf);
const $9ab19831f05a709e$export$dfb67e34e4333816 = 'SIDEBAR';
const $9ab19831f05a709e$export$1d6094128a3bfe4a = 'MODAL';
const $9ab19831f05a709e$export$ad4637adae7d3e97 = 'DEFAULT';
const $9ab19831f05a709e$export$201bf1eb7c447afa = 'board-detail-view-mode';
const $9ab19831f05a709e$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};

});


parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $aZaPn = parcelRequire("aZaPn");

var $lDYuK = parcelRequire("lDYuK");

var $idwtd = parcelRequire("idwtd");

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>{
    const viewModeValue = (0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY));
    if (viewModeValue) return viewModeValue;
    const boardViewModeValue = (0, $lDYuK.getBoardDetailViewMode)();
    // if there is no viewModeValue but there is a boardViewModeValue then set that value in localStorage
    // and remove the old board local storage value
    if (boardViewModeValue) {
        const boardLocalStorage = (0, $aZaPn.createLocalStorageProvider)('software');
        (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), boardViewModeValue);
        boardLocalStorage.remove((0, $idwtd.BOARD_DETAIL_VIEW_MODE));
        return boardViewModeValue;
    }
    return 0, $935e771f19f8ea28$export$2d037fdba4f67558;
// note: during 'refactor-bento-view-mode-logic' ff cleanup (https://jbusiness.atlassian.net/browse/CAL-12), remove the above logic including getBoardDetailViewMode and uncomment
// return localStorage.get(VIEW_MODE_STORAGE_KEY) || VIEW_MODE_DEFAULT;
};

});




parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $a61MH.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $ggKAj.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $heB5U.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/graphql/1/', {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $a61MH.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $a61MH.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $ggKAj.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});



parcelRegister("fWeG1", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6c5f7158a1132680$export$a01f0885983ceff0);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $6c5f7158a1132680$export$a01f0885983ceff0 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});



parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("dK5FP", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $882c857bed4a7f74$export$c13b008422be19c7);

var $7Xm2s = parcelRequire("7Xm2s");
const $882c857bed4a7f74$export$c13b008422be19c7 = (0, $7Xm2s.useSubscribeCommandsWithRegistry);

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});


parcelRegister("3Tszs", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $81b7cb64c6be6c5d$export$f56776f1b409b56d);

var $hJ992 = parcelRequire("hJ992");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $81b7cb64c6be6c5d$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueId = (0, $hJ992.useIssueId)();
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

const $c7e109b9d85e3c97$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("igSdB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aaccf3a6ecd0d922$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $aaccf3a6ecd0d922$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    changeStatus: {
        "id": "issue-field-status.status-view.command-palette.change-status",
        "defaultMessage": "Change status"
    },
    // TODO delete on compal-issue-actions-follow-up-improvements_y49xu cleanup
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    currentStatus: {
        "id": "issue-field-status.status-view.command-palette.current-status",
        "defaultMessage": "Current status"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("aaWu9", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $4cf7bb6b63008adb$export$c6a3d42f97df89c9);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kmr29 = parcelRequire("kmr29");

var $1a3la = parcelRequire("1a3la");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $ebWv6 = parcelRequire("ebWv6");
const $4cf7bb6b63008adb$export$c6a3d42f97df89c9 = (issueKey, issueId)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $gCtL7.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $eUqFw.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $ebc098a76317be78$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $jMP2a.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        showFlag({
            type: 'success',
            title: formatMessage((0, $ebWv6.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $eUqFw.useCallback)((error)=>{
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'deliveroo'
            }
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $ebWv6.messages).errorFlagTitle),
            description: formatMessage((0, $ebWv6.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const saveStatusField = (0, $eUqFw.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>onSaveSuccessfully(transition, callback);
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                await (0, $lRmyA.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        openIssueTransitionModal
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);

var $eUqFw = parcelRequire("eUqFw");

var $6XOSh = parcelRequire("6XOSh");

var $b3pJg = parcelRequire("b3pJg");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        isEnabled,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...actions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $a61MH.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $heB5U.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $ggKAj.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $ggKAj.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';


parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $lEpcX = parcelRequire("lEpcX");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $lEpcX.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");
var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $duQ8C = parcelRequire("duQ8C");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    if ((0, $1ybV0.ff)('modernised-its-end-to-end-ufo-experience_m5e7f')) (0, $3gb01.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('issue-transition.transition-modal-subsequent');
    else (0, $duQ8C.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $dda1b5d926efd158$export$2f3b26e8acf79182);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $dda1b5d926efd158$export$2f3b26e8acf79182 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $lEpcX = parcelRequire("lEpcX");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal'
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $lEpcX.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});



parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $dfBCt.isFedRamp)()) return true;
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});




const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';

parcelRegister("ebWv6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f7580a2b91879afa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f7580a2b91879afa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We couldn\u2019t update the status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("hiXJ2", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $374b7ef282a2f0ed$export$258538e0d3d46460);
const $374b7ef282a2f0ed$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("f3qzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1612899557cfea6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1612899557cfea6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    }
});

});

parcelRegister("5x3wA", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $b8a1cf0cb2a35870$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $b8a1cf0cb2a35870$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8a1cf0cb2a35870$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8a1cf0cb2a35870$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4u2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fr49r", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $c8103b4d0a327bcd$export$517b7ecb2da8e76d);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $8cU5f = parcelRequire("8cU5f");

var $fAI2G = parcelRequire("fAI2G");

var $3xvgo = parcelRequire("3xvgo");
const $c8103b4d0a327bcd$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return 0, $3xvgo.ToDoButton;
        case 3:
            return 0, $3xvgo.DoneButton;
        case 4:
            return 0, $3xvgo.InProgressButton;
        default:
            return 0, $3xvgo.DefaultButton;
    }
};
const $c8103b4d0a327bcd$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
    const Button = $c8103b4d0a327bcd$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: targetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAI2G.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer
    }, status.name))));
};

});
parcelRegister("fAI2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e72f26e10429da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");
// TODO consolidate status id's
const $e9e72f26e10429da$var$DONE_ID = 3; // eslint-disable-next-line jira/react/no-class-components
class $e9e72f26e10429da$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $e9e72f26e10429da$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9e72f26e10429da$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldShow: false
        };
    }
}
const $e9e72f26e10429da$var$PulseAnimation = /*#__PURE__*/ (0, $kwce8.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $e9e72f26e10429da$var$PulseContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $9t7rW.default)($e9e72f26e10429da$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bsb1osq _2rko1l7b _16qs13jn",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3xvgo", function(module, exports) {

$parcel$export(module.exports, "DefaultButton", () => $9c0535c8db535606$export$b7c3a2f69225ecf);
$parcel$export(module.exports, "ToDoButton", () => $9c0535c8db535606$export$97f73b7c6e2328e5);
$parcel$export(module.exports, "InProgressButton", () => $9c0535c8db535606$export$8c94aeefd701630d);
$parcel$export(module.exports, "DoneButton", () => $9c0535c8db535606$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $9c0535c8db535606$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$8c94aeefd701630d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$e6559310cd173125 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g147y _11a4147y _dntb1gfe _cp4g1gfe _5xmdihng _11sm1gfe",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dSoqn", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $ae69ed3744ea99b9$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $iccsh = parcelRequire("iccsh");

var $5jCbl = parcelRequire("5jCbl");

var $dRdDe = parcelRequire("dRdDe");
const $ae69ed3744ea99b9$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing })=>{
    if ((0, $iccsh.isStatusInGicEnabled)() && transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$DisabledTransition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        label: "",
        primaryColor: `var(--ds-text-disabled, ${(0, $PdmhA).N200})`
    }))));
    return hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jCbl.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae69ed3744ea99b9$var$DisabledTransition = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3io7ao _1reoewfl _18m9ewfl _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$export$7ed12d2a5241e393 = {
    IconWrapper: $ae69ed3744ea99b9$var$IconWrapper
};

});
parcelRegister("5jCbl", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $31534da1e06e6efb$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cSu9v = parcelRequire("cSu9v");

var $4ksts = parcelRequire("4ksts");

var $2GJ4g = parcelRequire("2GJ4g");

var $Pk7Yy = parcelRequire("Pk7Yy");
const $31534da1e06e6efb$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $Pk7Yy.default).globalTransition);
    }
    return transition.name;
};
const $31534da1e06e6efb$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$147422f7450ccfac, null, $31534da1e06e6efb$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$da4545fe0ca096cf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31534da1e06e6efb$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$147422f7450ccfac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$var$VerticalCenter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("Pk7Yy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca438c42f301b049$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca438c42f301b049$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("dRdDe", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $3bc4861a1c7d5985$export$4cf2c7e5a408120e);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $3bc4861a1c7d5985$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});



parcelRegister("hKhSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9584ba9a040ef1b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aIecO = parcelRequire("aIecO");

var $gD4xA = parcelRequire("gD4xA");

var $1M8IB = parcelRequire("1M8IB");
class $e9584ba9a040ef1b$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { baseUrl: baseUrl, issueKey: issueKey, isModalMounted: isModalMounted, onOpenModal: onOpenModal, workflowServiceApi: workflowServiceApi } = this.props;
        const { isWorkflowServiceRefetching: isWorkflowServiceRefetching } = this.state;
        const { data: data, loading: loading, error: error, fetch: fetch } = workflowServiceApi;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIecO.default), {
            onRetry: (e)=>{
                this.onWorkflowServiceRefetch(e, fetch);
            }
        });
        if (!data) return null;
        const { isSimplified: isSimplified, projectId: projectId, issueTypeId: issueTypeId, hasPermission: hasPermission } = data;
        if (isSimplified === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1M8IB.default), {
            projectId: projectId,
            issueTypeId: issueTypeId,
            isModalMounted: isModalMounted,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching,
            onOpenModal: onOpenModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gD4xA.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isWorkflowServiceRefetching: false
        };
        this.onWorkflowServiceRefetch = async (e, retry)=>{
            e.stopPropagation();
            this.setState({
                isWorkflowServiceRefetching: true
            });
            await retry();
            this.setState({
                isWorkflowServiceRefetching: false
            });
        };
    }
}

});
parcelRegister("aIecO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef6cff4c32f2b822$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $cHMSy = parcelRequire("cHMSy");
const $ef6cff4c32f2b822$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onRetryClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'retryViewWorkflowButton'); // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        onRetry(e);
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "viewWorkflowError",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6cff4c32f2b822$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ef6cff4c32f2b822$var$errorMessageWrapperStyles
    }, formatMessage((0, $cHMSy.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6cff4c32f2b822$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "link",
        spacing: "none",
        onClick: onRetryClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.view-workflow.error.button"
    }, formatMessage((0, $cHMSy.default).tryAgain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
var $ef6cff4c32f2b822$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ef6cff4c32f2b822$export$edf27be85e5f6da0;
const $ef6cff4c32f2b822$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _x3do1on0 _1e0c1txw _4cvr1h6o _1yt4s8vo _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6cff4c32f2b822$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $ef6cff4c32f2b822$var$errorMessageWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("cHMSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6de2ac9633e5bb5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c6de2ac9633e5bb5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-field-status.common.view-workflow.error.error-message",
        "defaultMessage": "Couldn\u2019t find the workflow."
    },
    tryAgain: {
        "id": "issue-field-status.common.view-workflow.error.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("gD4xA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cbda2e6b4ce6eb$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps, jira/wrm/no-load-bridge */ 
var $eUqFw = parcelRequire("eUqFw");

var $2BvS3 = parcelRequire("2BvS3");

var $14fFu = parcelRequire("14fFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $16kIm = parcelRequire("16kIm");

var $bf489 = parcelRequire("bf489");

var $aIecO = parcelRequire("aIecO");

var $1VyIW = parcelRequire("1VyIW");

var $6d2As = parcelRequire("6d2As");

var $8o90a = parcelRequire("8o90a");
const $c2cbda2e6b4ce6eb$export$b5e9eef0cad95164 = ({ isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, issueKey: issueKey, hasPermission: hasPermission, baseUrl: baseUrl, ClassicViewWorkflowService: ClassicViewWorkflowService = (0, $6d2As.ClassicViewWorkflowServiceWithAnalytics) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isModalMounted, setIsModalMounted] = (0, $eUqFw.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $eUqFw.useState)(false);
    const [isRefetching, setIsRefetching] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const isModalMounting = isLoadingModal && !isModalMounted;
    const isDisabled = !hasPermission || isModalMounting;
    // we do not use || isClassicServiceLoading for isLoading because we do not want to show spinner while ClassicViewWorkflowService data loads
    const isLoading = isModalMounting || isServiceRefetching || isRefetching;
    let modalApi;
    (0, $eUqFw.useEffect)(()=>{
        const modalModuleName = 'workflow-designer/view-classic-project-workflow';
        // @ts-expect-error - TS2322 - Type 'Promise<unknown>' is not assignable to type 'Promise<ClassicProjectWorkflowModalApi>'.
        modalApi = (0, $2BvS3.loadBridge)({
            // checking if module was loaded on page load
            name: modalModuleName,
            tentatives: 0,
            shouldLogError: false
        }).catch(()=>{
            (0, $16kIm.asyncWrmRequire)([
                // eslint-disable-next-line jira/wrm/no-wr-prefix
                'wr!com.atlassian.jira.plugins.jira-workflow-designer:view-issue-page-workflow-designer'
            ]); // wrmRequire() does not fire catch() event
            return (0, $2BvS3.loadBridge)({
                name: modalModuleName
            });
        });
    }, []);
    const onClick = (0, $eUqFw.useCallback)((analyticsEvent, pShowFlag, workflowName, currentStepId)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
            isSimplifiedProject: false
        });
        if (!modalApi || !workflowName || !currentStepId) return;
        // modal code is being loaded only once, therefore there is no need to reset this to false
        setIsLoadingModal(true);
        setIsRefetching(false);
        modalApi.then((api)=>{
            api.showDialog(workflowName, currentStepId);
            // since there is no way to close Ak dropdown programmatically, this is the only option
            // to avoid dropdown wrong position on View workflow modal opening in Bento modal (BENTO-4660)
            window.dispatchEvent((0, $14fFu.default)('resize'));
            // @ts-expect-error - TS2345 - Argument of type '{ isModalMounted: boolean; }' is not assignable to parameter of type 'SetStateAction<boolean>'.
            setIsModalMounted({
                isModalMounted: true
            });
        }).catch(()=>{
            pShowFlag && pShowFlag((0, $8o90a.default).loadModalError());
            setIsLoadingModal(false);
        });
    }, // @ts-expect-error - TS2454 - Variable 'modalApi' is used before being assigned.
    [
        modalApi,
        setIsModalMounted,
        setIsRefetching,
        setIsLoadingModal
    ]);
    const onRetry = (0, $eUqFw.useCallback)((event, retry)=>{
        event.stopPropagation();
        setIsRefetching(true);
        return retry().then(()=>setIsRefetching(false));
    }, [
        setIsRefetching
    ]);
    const onMount = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: false
        });
    }, [
        hasPermission
    ]);
    const getTooltipMessage = (0, $eUqFw.useCallback)((isClassicServiceLoading)=>{
        if (isServiceRefetching || isClassicServiceLoading) return formatMessage((0, $1VyIW.default).loading);
        if (!hasPermission) return formatMessage((0, $1VyIW.default).noPermission);
        return '';
    }, [
        formatMessage,
        hasPermission,
        isServiceRefetching
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClassicViewWorkflowService, {
        issueKey: issueKey,
        baseUrl: baseUrl,
        shouldLoadOnMount: hasPermission
    }, ({ data: data, error: error, loading: isClassicServiceLoading, retry: retry })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aIecO.default), {
            onRetry: (event)=>{
                onRetry(event, retry);
            }
        });
        const workflowName = data ? data.workflowName : null;
        const currentStepId = data ? data.currentStepId : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bf489.default), {
            onMount: onMount,
            tooltipContent: getTooltipMessage(isServiceLoading || isClassicServiceLoading),
            isDisabled: isDisabled || isClassicServiceLoading,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading || isClassicServiceLoading,
            onClick: (_, analyticsEvent)=>onClick(analyticsEvent, showFlag, workflowName, currentStepId)
        });
    });
};
var $c2cbda2e6b4ce6eb$export$2e2bcd8739ae039 = $c2cbda2e6b4ce6eb$export$b5e9eef0cad95164;

});
parcelRegister("14fFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9be0b0302f41db4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c9be0b0302f41db4$export$2e2bcd8739ae039 = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
    const event = document.createEvent(eventConstructor);
    event.initEvent(eventType, bubbles, cancelable);
    return event;
};

});

parcelRegister("bf489", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b2bb06be8d06d0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $4ksts = parcelRequire("4ksts");

var $2qZHF = parcelRequire("2qZHF");

var $58qPQ = parcelRequire("58qPQ");
const $69b2bb06be8d06d0$var$WithTooltip = ({ content: content, children: children })=>{
    if (content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        tag: "span",
        content: content
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $69b2bb06be8d06d0$var$ViewWorkflowButton = ({ isDisabled: isDisabled, isLoading: isLoading, isInitialLoading: isInitialLoading, onClick: onClick, onMount: onMount, tooltipContent: tooltipContent })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const isDisabledColor = isDisabled === true && !isInitialLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$var$WithTooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69b2bb06be8d06d0$export$d53c836cccbb0d90, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        testId: "issue-field-status.common.ui.view-workflow.button.view-workflow",
        shouldFitContainer: true,
        appearance: "subtle",
        spacing: "none",
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center',
                    textAlign: 'left',
                    color: isDisabledColor ? `var(--ds-text-disabled, ${(0, $PdmhA).N70})` : `var(--ds-text, ${(0, $PdmhA).N900})`,
                    padding: `0 ${"var(--ds-space-150, 12px)"}`
                }
            };
        },
        interactionName: "auto-generated.issue-field-status.common.ui.view-workflow.button.view-workflow.button"
    }, intl.formatMessage((0, $58qPQ.default).viewWorkflow)))));
};
var $69b2bb06be8d06d0$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $69b2bb06be8d06d0$var$ViewWorkflowButton;
const $69b2bb06be8d06d0$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ickbl _x3do1on0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69b2bb06be8d06d0$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("58qPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $431207a6e4666834$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $431207a6e4666834$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewWorkflow: {
        "id": "issue-field-status.common.view-workflow.button.view-workflow",
        "defaultMessage": "View workflow"
    }
});

});


parcelRegister("1VyIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb93519bdc9b310d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb93519bdc9b310d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermission: {
        "id": "issue-field-status.common.view-workflow.no-permission",
        "defaultMessage": "You don't have permission to view this workflow."
    },
    loading: {
        "id": "issue-field-status.common.view-workflow.loading",
        "defaultMessage": "Looks like your connection is slow. We\u2019re still finding this workflow."
    }
});

});

parcelRegister("6d2As", function(module, exports) {

$parcel$export(module.exports, "ClassicViewWorkflowServiceWithAnalytics", () => $49ff3b2d374c70f7$export$1a80ddaaeea6341b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $gUUjF = parcelRequire("gUUjF");

var $jMP2a = parcelRequire("jMP2a");

var $jdSRD = parcelRequire("jdSRD");
// eslint-disable-next-line jira/react/no-class-components
class $49ff3b2d374c70f7$var$ClassicViewWorkflowService extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldLoadOnMount: true
        };
    }
    componentDidMount() {
        if (this.props.shouldLoadOnMount === true) this.load();
    }
    onLoading() {
        this.setState({
            data: undefined,
            error: undefined,
            loading: true
        });
    }
    onLoadSucceeded(data) {
        this.setState({
            data: data,
            error: undefined,
            loading: false
        });
    }
    onLoadFailed(error) {
        this.setState({
            data: undefined,
            error: error,
            loading: false
        });
    }
    fireAnalytics() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'requested'
        });
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'classicViewWorkflowData requested');
    }
    render() {
        return this.props.children({
            ...this.state,
            retry: this.load
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            data: undefined,
            error: undefined,
            loading: false
        };
        this.load = async ()=>{
            this.onLoading();
            const { baseUrl: baseUrl, issueKey: issueKey } = this.props;
            try {
                this.fireAnalytics();
                const data = await (0, $jdSRD.getViewWorkflowData)(baseUrl, issueKey);
                this.onLoadSucceeded(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.status.classic-view-workflow-service.fetch', 'Failed to fetch classic view workflow data.', {
                    errorReason: error.message && error.message === 'TransformError' ? 'transform' : 'fetch'
                });
                this.onLoadFailed(error);
            }
        };
    }
}
const $49ff3b2d374c70f7$export$1a80ddaaeea6341b = (0, $2jDha.default)()(// @ts-expect-error - TS2345 - Argument of type 'typeof ClassicViewWorkflowService' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof ClassicViewWorkflowService) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof ClassicViewWorkflowService)'.
$49ff3b2d374c70f7$var$ClassicViewWorkflowService);

});
parcelRegister("jdSRD", function(module, exports) {

$parcel$export(module.exports, "getViewWorkflowData", () => $d8d339a09b1f2f34$export$fa1a6ac9833b0597);

var $lRmyA = parcelRequire("lRmyA");
const $d8d339a09b1f2f34$var$query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;
const $d8d339a09b1f2f34$export$3361e9be8093ddcc = (response)=>{
    if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) return {
        workflowName: response.data.viewIssue.workflow.name,
        currentStepId: response.data.viewIssue.workflow.step.id
    };
    throw new Error('TransformError');
};
const $d8d339a09b1f2f34$export$fa1a6ac9833b0597 = (baseUrl, issueKey)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/gira/1/`, {
        body: JSON.stringify({
            query: $d8d339a09b1f2f34$var$query,
            variables: {
                issueKey: issueKey
            }
        })
    }).then($d8d339a09b1f2f34$export$3361e9be8093ddcc);

});


parcelRegister("8o90a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de04be88b22ac00$export$2e2bcd8739ae039);

var $8gQgm = parcelRequire("8gQgm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3de04be88b22ac00$export$2e2bcd8739ae039 = {
    loadModalError: $8gQgm.default
};

});
parcelRegister("8gQgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b0125e728899f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5f0b0125e728899f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.title",
        "defaultMessage": "We couldn't load the workflow"
    },
    description: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.description",
        "defaultMessage": "Check your connection, then try reloading the page."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f0b0125e728899f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $5f0b0125e728899f$var$messages.title,
        description: $5f0b0125e728899f$var$messages.description
    });

});



parcelRegister("1M8IB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24a04c39da424a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $bf489 = parcelRequire("bf489");

var $1VyIW = parcelRequire("1VyIW");
// eslint-disable-next-line jira/react/no-class-components
class $d24a04c39da424a7$var$ViewWorkflowSimplified extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            hasPermission: false
        };
    }
    getTooltipMessage() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, intl: intl } = this.props;
        if (isServiceLoading || isServiceRefetching) return intl.formatMessage((0, $1VyIW.default).loading);
        if (hasPermission !== true) return intl.formatMessage((0, $1VyIW.default).noPermission);
        return '';
    }
    render() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, isModalMounted: isModalMounted } = this.props;
        const { isLoadingModal: isLoadingModal } = this.state;
        const isModalMounting = isLoadingModal && !isModalMounted;
        const isDisabled = hasPermission !== true || isModalMounting;
        const isLoading = isServiceRefetching || isModalMounting;
        const tooltipContent = this.getTooltipMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bf489.default), {
            onMount: this.onMount,
            tooltipContent: tooltipContent,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading,
            onClick: this.onClick
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isLoadingModal: false
        };
        this.onMount = (analyticsEvent)=>{
            const { hasPermission: hasPermission } = this.props;
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
                hasViewWorkflowPermission: hasPermission,
                isSimplifiedProject: true
            });
        };
        this.onClick = (event, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
                isSimplifiedProject: true
            });
            this.setState({
                // modal code is being loaded only once, therefore there is no need to reset this to false
                isLoadingModal: true
            });
            const { issueTypeId: issueTypeId = (0, $6vrw7.toIssueTypeId)(''), projectId: projectId = (0, $6vrw7.toProjectId)(''), onOpenModal: onOpenModal } = this.props;
            onOpenModal(issueTypeId, projectId);
        };
    }
}
var $d24a04c39da424a7$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($d24a04c39da424a7$var$ViewWorkflowSimplified);

});


parcelRegister("g6Vr7", function(module, exports) {

$parcel$export(module.exports, "default", () => $70e7490019e1bafe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jBy23 = parcelRequire("jBy23");

var $6vrw7 = parcelRequire("6vrw7");

var $iccsh = parcelRequire("iccsh");

var $gZQrx = parcelRequire("gZQrx");

var $thcE1 = parcelRequire("thcE1");
const $70e7490019e1bafe$export$eaa7a2e07a1c5fcf = (containerContextData, issueProjectKey)=>{
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!containerContextData || !containerContextData.project) return undefined;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const contextProject = containerContextData.project;
    const hasIssueProjectDataInContext = contextProject.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $6vrw7.toProjectId)(contextProject.id.toString()),
        projectType: contextProject.type,
        isSimplified: contextProject.isSimplified
    };
};
const $70e7490019e1bafe$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
/**
 * Gets projectData from ContainerContextSubscriber or from service
 */ const $70e7490019e1bafe$var$ViewWorkflowContextService = (props)=>{
    const { ViewWorkflowService: ViewWorkflowService, ContainerContextSubscriber: ContainerContextSubscriber, baseUrl: baseUrl, issueKey: issueKey, children: children } = props;
    if ((0, $iccsh.isWorkflowDataServiceHookEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    return children((0, $gZQrx.useProjectViewWorkflowService)(baseUrl, issueKey));
    // ff use-view-workflow-service-hook_8y6bk cleanup: remove return below and unwrap ff conditional above
    const issueProjectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : null;
    if (!issueKey || !issueProjectKey) return children({
        ...$70e7490019e1bafe$export$d1183e28fea9e49c
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerContextSubscriber, null, ({ data: containerContextData })=>{
        const contextData = $70e7490019e1bafe$export$eaa7a2e07a1c5fcf(containerContextData, issueProjectKey);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewWorkflowService, {
            baseUrl: baseUrl,
            issueKey: issueKey,
            projectKey: contextData ? undefined : issueProjectKey,
            isSimplified: contextData && contextData.isSimplified
        }, ({ data: serviceData, ...serviceProps })=>{
            const data = contextData || serviceData ? {
                ...contextData,
                ...serviceData
            } : undefined;
            return children({
                data: data,
                ...serviceProps
            });
        });
    });
};
$70e7490019e1bafe$var$ViewWorkflowContextService.defaultProps = {
    ViewWorkflowService: (0, $thcE1.ViewWorkflowService)
};
var $70e7490019e1bafe$export$2e2bcd8739ae039 = $70e7490019e1bafe$var$ViewWorkflowContextService;

});
parcelRegister("gZQrx", function(module, exports) {

$parcel$export(module.exports, "useProjectViewWorkflowService", () => $9ce703895fb9b49d$export$aa23574b54bd5f5e);

var $7ZZxN = parcelRequire("7ZZxN");

var $jBy23 = parcelRequire("jBy23");

var $cPEpP = parcelRequire("cPEpP");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $bXrMR = parcelRequire("bXrMR");
const $9ce703895fb9b49d$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
const $9ce703895fb9b49d$var$getIssueProjectDataFromContext = (useProjectData, issueProjectKey)=>{
    if (!useProjectData || !useProjectData.data) return undefined;
    const hasIssueProjectDataInContext = useProjectData.data.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $6vrw7.toProjectId)(useProjectData.data.id.toString()),
        projectType: (0, $7ZZxN.toProjectType)(useProjectData.data.type),
        isSimplified: useProjectData.data.isSimplified
    };
};
const $9ce703895fb9b49d$export$aa23574b54bd5f5e = (baseUrl, issueKey)=>{
    const issueProjectKey = issueKey ? (0, $jBy23.extractProjectKey)(issueKey) : null;
    const useProjectData = (0, $cPEpP.useProject)();
    const projectContextData = $9ce703895fb9b49d$var$getIssueProjectDataFromContext(useProjectData, issueProjectKey);
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueContextData = (0, $bXrMR.useViewWorkflowData)({
        baseUrl: baseUrl,
        projectKey: projectContextData ? undefined : issueProjectKey || undefined,
        issueKey: issueKey,
        isSimplified: projectContextData && projectContextData.isSimplified,
        cloudId: cloudId
    });
    if (!issueKey || !issueProjectKey) return {
        ...$9ce703895fb9b49d$export$d1183e28fea9e49c
    };
    const combinedData = projectContextData || issueContextData.data ? {
        ...projectContextData,
        ...issueContextData.data
    } : undefined;
    return {
        ...issueContextData,
        data: combinedData
    };
};

});
parcelRegister("bXrMR", function(module, exports) {

$parcel$export(module.exports, "useViewWorkflowData", () => $34326079970e858d$export$d60b63dd0a193e30);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");


var $dhlfE = parcelRequire("dhlfE");
const $34326079970e858d$export$7a2d7e5adacde085 = ()=>'/rest/gira/latest/?operation=nextGenViewWorkflowQuery';
const $34326079970e858d$var$optionsGraphQlQuery = (issueKey, cloudId, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $e7647232d7445c32$export$136fc24ec1bfcefd}", "${0, $e7647232d7445c32$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
        jira {
            issueByKey(key: "${issueKey}", cloudId: "${cloudId}") {
                fieldsById(ids: ["issuetype"]) {
                    edges {
                        node {
                            ... on JiraIssueTypeField {
                                fieldId
                                issueType {
                                issueTypeId
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $34326079970e858d$export$7fe04353ef301d96 = (baseUrl, issueKey, cloudId, projectKey, isSimplified)=>(0, $2OdyW.default)($34326079970e858d$export$7a2d7e5adacde085(), {
        method: 'POST',
        body: JSON.stringify({
            query: $34326079970e858d$var$optionsGraphQlQuery(issueKey, cloudId, projectKey)
        })
    }).then((data)=>(0, $dhlfE.transform)(data, isSimplified));
const $34326079970e858d$export$d60b63dd0a193e30 = ({ baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified, cloudId: cloudId })=>{
    const [dataState, setDataState] = (0, $eUqFw.useState)(undefined);
    const [errorState, setErrorState] = (0, $eUqFw.useState)(undefined);
    const [loadingState, setLoadingState] = (0, $eUqFw.useState)(false);
    const fetch = async ()=>{
        request();
        try {
            const dataRes = await $34326079970e858d$export$7fe04353ef301d96(baseUrl, issueKey, cloudId, projectKey, isSimplified);
            success(dataRes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e7647232d7445c32$export$4bf6353caa97e8e7), ex);
            failure(ex);
        }
    };
    const request = ()=>{
        setDataState(undefined);
        setErrorState(undefined);
        setLoadingState(true);
    };
    const success = (data)=>{
        setDataState(data);
        setErrorState(undefined);
        setLoadingState(false);
    };
    const failure = (error)=>{
        setDataState(undefined);
        setErrorState(error);
        setLoadingState(false);
    };
    return {
        data: dataState,
        error: errorState,
        loading: loadingState,
        fetch: fetch
    };
};

});
const $e7647232d7445c32$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $e7647232d7445c32$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $e7647232d7445c32$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $e7647232d7445c32$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $e7647232d7445c32$export$624e7abc8d9cada5 = 'ADMINISTER';

parcelRegister("dhlfE", function(module, exports) {

$parcel$export(module.exports, "transform", () => $323479dc3a12c1eb$export$51186ad6e864892a);

var $7ZZxN = parcelRequire("7ZZxN");

var $6vrw7 = parcelRequire("6vrw7");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $323479dc3a12c1eb$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission || key === (0, $e7647232d7445c32$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $323479dc3a12c1eb$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission;
const $323479dc3a12c1eb$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.jira) return undefined;
    const { permissions: permissions, project: project, jira: jira } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $323479dc3a12c1eb$var$simplifiedPermissionPredicate : $323479dc3a12c1eb$var$classicPermissionPredicate;
    const issueTypeField = jira.issueByKey?.fieldsById?.edges?.find((edge)=>edge.node?.fieldId === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $6vrw7.toIssueTypeId)(issueTypeField?.node?.issueType?.issueTypeId ? issueTypeField.node.issueType.issueTypeId : '')
    };
    if (project) {
        result.projectId = (0, $6vrw7.toProjectId)(String(project.projectId));
        result.projectType = (0, $7ZZxN.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});



parcelRegister("thcE1", function(module, exports) {

$parcel$export(module.exports, "ViewWorkflowService", () => $14939fe4dd5d0b81$export$4318ed1e08552945);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");


var $aSR7x = parcelRequire("aSR7x");
const $14939fe4dd5d0b81$export$7a2d7e5adacde085 = (baseUrl)=>`${baseUrl}/rest/gira/latest/`;
const $14939fe4dd5d0b81$var$optionsGraphQlQuery = (issueKey, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $e7647232d7445c32$export$136fc24ec1bfcefd}", "${0, $e7647232d7445c32$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        viewIssue(issueKey: "${issueKey}") {
            fields {
                ... on IssueTypeField {
                    fieldKey
                    id
                }
            }
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
    }
`;
const $14939fe4dd5d0b81$export$7fe04353ef301d96 = (baseUrl, issueKey, projectKey, isSimplified)=>(0, $2OdyW.default)($14939fe4dd5d0b81$export$7a2d7e5adacde085(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            query: $14939fe4dd5d0b81$var$optionsGraphQlQuery(issueKey, projectKey)
        })
    }).then((data)=>(0, $aSR7x.transform)(data, isSimplified));
// ff use-view-workflow-service-hook_8y6bk cleanup: remove ViewWorkflowService and everything in this directory, it is replaced by useViewWorkflowData
// eslint-disable-next-line jira/react/no-class-components
class $14939fe4dd5d0b81$export$4318ed1e08552945 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.fetch = async ()=>{
            const { baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified } = this.props;
            this.request();
            try {
                const data = await $14939fe4dd5d0b81$export$7fe04353ef301d96(baseUrl, issueKey, projectKey, isSimplified);
                this.success(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (ex) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $e7647232d7445c32$export$4bf6353caa97e8e7), ex);
                this.failure(ex);
            }
        };
        this.request = ()=>{
            this.setState({
                error: undefined,
                loading: true,
                data: undefined
            });
        };
        this.success = (data)=>{
            this.setState({
                loading: false,
                data: data
            });
        };
        this.failure = (error)=>{
            this.setState({
                error: error,
                loading: false
            });
        };
        this.state = {
            data: undefined,
            loading: false,
            error: undefined
        };
    }
    render() {
        return this.props.children({
            ...this.state,
            fetch: this.fetch
        });
    }
}

});
parcelRegister("aSR7x", function(module, exports) {

$parcel$export(module.exports, "transform", () => $5e7d127f35e12e5c$export$51186ad6e864892a);

var $7ZZxN = parcelRequire("7ZZxN");

var $6vrw7 = parcelRequire("6vrw7");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $5e7d127f35e12e5c$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission || key === (0, $e7647232d7445c32$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $5e7d127f35e12e5c$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $e7647232d7445c32$export$136fc24ec1bfcefd) && havePermission;
const $5e7d127f35e12e5c$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.viewIssue) return undefined;
    const { permissions: permissions, project: project, viewIssue: viewIssue } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $5e7d127f35e12e5c$var$simplifiedPermissionPredicate : $5e7d127f35e12e5c$var$classicPermissionPredicate;
    const issueTypeField = viewIssue.fields.find((field)=>field.fieldKey === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $6vrw7.toIssueTypeId)(issueTypeField ? issueTypeField.id : '')
    };
    if (project) {
        result.projectId = (0, $6vrw7.toProjectId)(String(project.projectId));
        result.projectType = (0, $7ZZxN.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});



parcelRegister("8N9iM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c08b1e01d93233b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gzBuH = parcelRequire("gzBuH");

var $481Nl = parcelRequire("481Nl");

const $3c08b1e01d93233b$export$de1fcbea0facb135 = (0, $7rh0R.lazy)(()=>(parcelRequire("7U4R2")), {
    moduleId: "./src/packages/issue/workflow-readonly-modal/src/index.tsx"
});
class $3c08b1e01d93233b$export$3d7b4a64bc1f330f extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        return {
            shouldMountWorkflow: state.shouldMountWorkflow || props.isOpen
        };
    }
    render() {
        const { issueKey: issueKey, issueTypeId: issueTypeId, baseUrl: baseUrl, locale: locale, cloudId: cloudId, projectId: projectId, isOpen: isOpen, onModalMounted: onModalMounted, onClose: onClose, scope: scope } = this.props;
        const { shouldMountWorkflow: shouldMountWorkflow } = this.state;
        return shouldMountWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $481Nl.WorkflowReadonlyModalBoundary), {
            packageName: "issue"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzBuH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
            until: isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3c08b1e01d93233b$export$de1fcbea0facb135, {
            onMounted: onModalMounted,
            issueKey: issueKey,
            issueTypeId: issueTypeId,
            baseUrl: baseUrl,
            locale: locale,
            isOpen: isOpen,
            cloudId: cloudId,
            projectId: projectId,
            onClose: onClose,
            scope: scope
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldMountWorkflow: false
        };
    }
}
var $3c08b1e01d93233b$export$2e2bcd8739ae039 = $3c08b1e01d93233b$export$3d7b4a64bc1f330f;

});
parcelRegister("gzBuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303a1693ea37869$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aTx5K = parcelRequire("aTx5K");
function $6303a1693ea37869$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const ignoredRLLProfilerContext = (0, $eUqFw.useMemo)(()=>({
            ...parentProfilerContext,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackMounted () {},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackUnmounted () {}
        }), [
        parentProfilerContext
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTx5K.default), {
        ignore: ignore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: ignoredRLLProfilerContext
    }, kids));
}

});
parcelRegister("aTx5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ad7ab78a19ec4c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
function $99ad7ab78a19ec4c$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const ignoredInteractionContext = (0, $eUqFw.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsCXU.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
}

});


parcelRegister("481Nl", function(module, exports) {

$parcel$export(module.exports, "WorkflowReadonlyModalBoundary", () => $0a356db52042008d$export$62f00f305552896d);

var $eUqFw = parcelRequire("eUqFw");

var $cyVXS = parcelRequire("cyVXS");

var $dtQl8 = parcelRequire("dtQl8");
const $0a356db52042008d$export$62f00f305552896d = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "workflow-readonly-modal",
        metricKey: (0, $dtQl8.LOAD_START_MARK_KEY),
        packageName: packageName
    }, children);

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("dtQl8", function(module, exports) {

$parcel$export(module.exports, "LOAD_START_MARK_KEY", () => $0fbc548613b24cfd$export$37312a67c3e314c6);
$parcel$export(module.exports, "LOAD_END_MARK_KEY", () => $0fbc548613b24cfd$export$45d73db12b3f4402);
$parcel$export(module.exports, "DIAGRAM_RENDERING_START_MARK_KEY", () => $0fbc548613b24cfd$export$b251f321d9285754);
$parcel$export(module.exports, "READY_MARK_KEY", () => $0fbc548613b24cfd$export$9ec2b1585f998431);
$parcel$export(module.exports, "ERROR_LOGGER_PATTERN", () => $0fbc548613b24cfd$export$63291eb9eb8d2af2);
$parcel$export(module.exports, "APP_NAME", () => $0fbc548613b24cfd$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "transitionType", () => $0fbc548613b24cfd$export$331d6399b2e33350);
$parcel$export(module.exports, "WORKFLOW_EXPERIENCE_IDENTIFIER", () => $0fbc548613b24cfd$export$4c39956c777a6352);
$parcel$export(module.exports, "EXPERIENCE_OPENED_START_EVENT", () => $0fbc548613b24cfd$export$ded295b2866c666f);
$parcel$export(module.exports, "EXPERIENCE_OPENED_SUCCESS_EVENT", () => $0fbc548613b24cfd$export$375ec45005c7d160);
const $0fbc548613b24cfd$export$37312a67c3e314c6 = 'WORKFLOW_READONLY_MODAL_LOAD_START_MARK_KEY';
const $0fbc548613b24cfd$export$45d73db12b3f4402 = 'WORKFLOW_READONLY_MODAL_LOAD_END_MARK_KEY';
const $0fbc548613b24cfd$export$b251f321d9285754 = 'DIAGRAM_RENDERING_START_MARK_KEY';
const $0fbc548613b24cfd$export$9ec2b1585f998431 = 'WORKFLOW_READONLY_MODAL_READY_MARK_KEY';
const $0fbc548613b24cfd$export$63291eb9eb8d2af2 = '#workflow-readonly-modal#';
const $0fbc548613b24cfd$export$5b6c28c7dca07ad7 = 'jira.fe.spa.transition.workflow-readonly-modal';
const $0fbc548613b24cfd$export$e117396b0784c7cc = 'START';
const $0fbc548613b24cfd$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $0fbc548613b24cfd$export$54227ee7dff570d1 = {
    CHANGE_ASSIGNEE: 'system:change-assignee',
    UPDATE_FIELD: 'system:update-field'
};
const $0fbc548613b24cfd$export$4c39956c777a6352 = 'workflowBentoModal';
const $0fbc548613b24cfd$export$ded295b2866c666f = 'openedStart';
const $0fbc548613b24cfd$export$375ec45005c7d160 = 'openedSuccess';

});


parcelRegister("7U4R2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('enE0J')
        ]);
        const value = parcelRequire('9uk9j');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("enE0J")
    ]).then(()=>parcelRequire('9uk9j'));
}

});


parcelRegister("8T7GM", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $70b075ae0428a910$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $70b075ae0428a910$export$331d6399b2e33350);
$parcel$export(module.exports, "transitionIcon", () => $70b075ae0428a910$export$bb55b5bf71d8edff);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $70b075ae0428a910$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $70b075ae0428a910$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $70b075ae0428a910$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $70b075ae0428a910$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $70b075ae0428a910$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $70b075ae0428a910$export$927c560a42a52ce0);
$parcel$export(module.exports, "CmpApprovalConditionTypeKeys", () => $70b075ae0428a910$export$8d54d4f03e079633);

var $8Qd0L = parcelRequire("8Qd0L");
const $70b075ae0428a910$export$e117396b0784c7cc = 'START';
const $70b075ae0428a910$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $70b075ae0428a910$export$bb55b5bf71d8edff = {
    BOLT: 'bolt',
    ERROR: 'error',
    CHECK: 'check',
    CHECK_INACTIVE: 'check_inactive',
    CROSS: 'cross',
    CROSS_INACTIVE: 'cross_inactive'
};
const $70b075ae0428a910$export$9bb188cec3fcc43d = 'GLOBAL';
const $70b075ae0428a910$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $70b075ae0428a910$export$d3dc8e33b7258fc5 = 'ALL';
const $70b075ae0428a910$export$8fc40e3c53b7f30e = {
    [(0, $8Qd0L.TODO)]: 1,
    [(0, $8Qd0L.IN_PROGRESS)]: 2,
    [(0, $8Qd0L.DONE)]: 3,
    [(0, $8Qd0L.UNDEFINED)]: 4
};
const $70b075ae0428a910$export$804f62993e553350 = 'ANY';
const $70b075ae0428a910$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};
const $70b075ae0428a910$export$8d54d4f03e079633 = {
    NUMBER: 'number',
    NUMBER_PER_PRINCIPAL: 'numberPerPrincipal',
    PERCENT: 'percent'
};

});

parcelRegister("cYxL5", function(module, exports) {

$parcel$export(module.exports, "transitionsProvider", () => $5d3806e50713da86$export$2f81aa12f4ac86b3);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5rVFi = parcelRequire("5rVFi");

var $2RKg4 = parcelRequire("2RKg4");

var $fKMw0 = parcelRequire("fKMw0");
const $5d3806e50713da86$export$2f81aa12f4ac86b3 = (ComposedComponent)=>function(props) {
        const { genericError: genericError, issueKey: issueKey, issueStatuses: issueStatuses, issue: issue } = props;
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const [loading, setLoading] = (0, $eUqFw.useState)(false);
        const [transitions, setTransitions] = (0, $eUqFw.useState)(null);
        const fetchTransitions = (0, $eUqFw.useCallback)(()=>{
            if (loading) return;
            setLoading(true);
            setTransitions(null);
            (0, $5rVFi.default)(`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`, {
                method: 'GET'
            }).then((response)=>{
                setLoading(false);
                if (response.ok) return response.json();
                throw new Error(`Response not ok. Statuscode: ${response.status}`);
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((result)=>{
                const transitionsFromServer = (0, $fKMw0.getFilteredOrderedTransitions)(result.transitions || [], issue.status);
                setTransitions((0, $fKMw0.addOriginalTransitions)(issue, (0, $fKMw0.removeTransitionsToCurrentAndOriginalStatus)(issue, transitionsFromServer, issueStatuses), issueStatuses, formatMessage((0, $2RKg4.default).originalTransitionStatusName)));
            }).catch((err)=>{
                setLoading(false);
                genericError({
                    message: err.message,
                    stackTrace: err.stack
                });
                setTransitions(null);
            });
        }, [
            issueKey,
            issue,
            issueStatuses,
            loading,
            genericError,
            formatMessage
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComposedComponent, {
            ...props,
            transitions: transitions,
            loading: loading,
            fetchTransitions: fetchTransitions
        });
    };

});
parcelRegister("2RKg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5674643ec83d4fd1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5674643ec83d4fd1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cannotLoadTransitions: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.change-status",
        "defaultMessage": "Change status"
    },
    originalTransitionStatusName: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.issue-status.issue-status-field.original-transition-status-name",
        "defaultMessage": "Transition to"
    }
});

});

parcelRegister("fKMw0", function(module, exports) {

$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $2e98a7bdac2b3671$export$707115549202b9e4);
$parcel$export(module.exports, "removeTransitionsToCurrentAndOriginalStatus", () => $2e98a7bdac2b3671$export$91fa646e6c6bbddf);
$parcel$export(module.exports, "addOriginalTransitions", () => $2e98a7bdac2b3671$export$bfbef01cd993b505);

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $2e98a7bdac2b3671$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $2e98a7bdac2b3671$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $2e98a7bdac2b3671$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $2e98a7bdac2b3671$var$filterLoopedTransitionsToSelf = (transitions, currentStatusId)=>transitions.filter((transition)=>!$2e98a7bdac2b3671$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$2e98a7bdac2b3671$var$isGlobalSelfTransition(transition, currentStatusId) && !$2e98a7bdac2b3671$var$isInitialSelfTransition(transition, currentStatusId));
const $2e98a7bdac2b3671$export$707115549202b9e4 = (transitions = [], currentStatusId)=>{
    if (currentStatusId) // filter out the transition without target status or the statusCategory of target status is null and
    // filter out looped invalid transitions
    return $2e98a7bdac2b3671$var$filterLoopedTransitionsToSelf(transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory) || [], currentStatusId);
    return transitions || [];
};
const $2e98a7bdac2b3671$export$91fa646e6c6bbddf = (issue, serverTransitions, issueStatusesById)=>{
    const isCurrentIssueStatusExisted = (0, $7CnHa.isDefined)(issue.status) && (0, $7CnHa.isDefined)(issueStatusesById[issue.status]);
    const isOriginalIssueStatusExisted = (0, $7CnHa.isDefined)(issue?.originals?.status) && (0, $7CnHa.isDefined)(issueStatusesById[issue?.originals?.status]);
    if (isOriginalIssueStatusExisted || isCurrentIssueStatusExisted) return serverTransitions.filter((transition)=>transition.to.id !== issue.status && transition.to.id !== issue?.originals?.status);
    return serverTransitions;
};
const $2e98a7bdac2b3671$export$bfbef01cd993b505 = (issue, serverTransitions, issueStatusesById, originalTransitionName)=>{
    const originalIssueStatusId = issue?.originals?.status;
    if ((0, $7CnHa.isDefined)(originalIssueStatusId) && (0, $7CnHa.isDefined)(issueStatusesById[originalIssueStatusId])) {
        const originalTransition = {
            id: (0, $5rYNM.ORIGINAL_STATUS_TRANSITION).id,
            isConditional: false,
            isGlobal: true,
            isInitial: false,
            hasScreen: false,
            name: originalTransitionName,
            to: {
                id: originalIssueStatusId,
                name: issueStatusesById[originalIssueStatusId].name,
                statusCategory: {
                    id: issueStatusesById[originalIssueStatusId].categoryId
                }
            }
        };
        return serverTransitions.concat(originalTransition);
    }
    return serverTransitions;
};

});




parcelRegister("5obPP", function(module, exports) {

$parcel$export(module.exports, "issueStatus", () => $3ec85fcd90a6c8d3$export$428254b960a31b64, (v) => $3ec85fcd90a6c8d3$export$428254b960a31b64 = v);
var $3ec85fcd90a6c8d3$export$428254b960a31b64;
$3ec85fcd90a6c8d3$export$428254b960a31b64 = `LOCrTW_issueStatus`;

});



parcelRegister("a96yg", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb5c8582478697$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8bPAV = parcelRequire("8bPAV");

var $GYtYK = parcelRequire("GYtYK");

var $20aLq = parcelRequire("20aLq");
var $efbb5c8582478697$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $GYtYK.default), (0, $8bPAV.default))((0, $20aLq.default));

});
parcelRegister("8bPAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc6f16f2a7fc86e5$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $fc6f16f2a7fc86e5$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, labels)=>{
            const labelsValue = labels.map((label)=>label.value);
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                labels: labelsValue
            }));
        }
    });
var $fc6f16f2a7fc86e5$export$2e2bcd8739ae039 = $fc6f16f2a7fc86e5$var$dispatchMethods;

});

parcelRegister("GYtYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2601df55f4816281$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
const $2601df55f4816281$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    plan: (0, $75KhQ.getPlan)
});
var $2601df55f4816281$export$2e2bcd8739ae039 = $2601df55f4816281$var$querySelector;

});

parcelRegister("20aLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $777bfe4535c0fa64$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a4vO3 = parcelRequire("a4vO3");

var $2C6OW = parcelRequire("2C6OW");

var $8HrnD = parcelRequire("8HrnD");
const $777bfe4535c0fa64$export$a36612af82a12ac0 = (props)=>{
    const getValues = (issue, attribute)=>{
        // @ts-expect-error - attribute is any string
        if (!issue[attribute] || !Array.isArray(issue[attribute])) return [];
        // @ts-expect-error - TS7006 - Parameter 'label' implicitly has an 'any' type.
        return issue[attribute].map((label)=>({
                label: label,
                value: label
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2C6OW.default), {
        ...props,
        getValues: getValues
    });
};
var $777bfe4535c0fa64$export$2e2bcd8739ae039 = (0, $8HrnD.default)((0, $a4vO3.withSlots)({
    MultiSelectCell: (0, $a4vO3.slots).FieldMultiSelectCell
})($777bfe4535c0fa64$export$a36612af82a12ac0));

});
parcelRegister("2C6OW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fa0f446d335227b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuuJa = parcelRequire("cuuJa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2jLDV = parcelRequire("2jLDV");
const $1fa0f446d335227b$var$LabelsComponent = ({ attribute: attribute, fetchOptions: fetchOptions, isReadOnly: isReadOnly, issue: issue, onChange: onChange, MultiSelectCell: MultiSelectCell, getValues: getValues, menuIsOpen: menuIsOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customNoOptionsMessage = (inputValue)=>{
        if (inputValue.includes(' ')) return formatMessage((0, $2jLDV.default).invalidInputWithSpace);
        if (inputValue.trim().length > 255) return formatMessage((0, $2jLDV.default).invalidInputWithMaxLength);
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiSelectCell, {
        menuIsOpen: menuIsOpen,
        attribute: attribute,
        messages: {
            placeholder: formatMessage((0, $2jLDV.default).chooseLabel),
            noLabels: formatMessage((0, $2jLDV.default).noLabels),
            noLabelsLeft: formatMessage((0, $2jLDV.default).noLabelsLeft),
            noMatch: formatMessage((0, $2jLDV.default).noMatch)
        },
        getValues: getValues,
        fetchOptions: fetchOptions,
        isReadOnly: isReadOnly,
        issue: issue,
        onChange: onChange,
        isCreatable: true,
        customNoOptionsMessage: customNoOptionsMessage,
        onCreateOption: ()=>{
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL);
        },
        formatCreateLabel: (label)=>`${label} (${formatMessage((0, $2jLDV.default).newLabel)})`,
        convertCreatedLabelToOption: (inputValue)=>({
                label: inputValue,
                value: inputValue
            }),
        validateInputForCreation: (inputValue)=>{
            if (inputValue.includes(' ') || inputValue.trim().length > 255 || inputValue.trim().length === 0) return false;
            return true;
        }
    });
};
var $1fa0f446d335227b$export$2e2bcd8739ae039 = $1fa0f446d335227b$var$LabelsComponent;

});
parcelRegister("2jLDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d77a653a21934356$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d77a653a21934356$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    chooseLabel: {
        "id": "portfolio-3-portfolio.common.label.choose-label",
        "defaultMessage": "Choose a label"
    },
    noLabels: {
        "id": "portfolio-3-portfolio.common.label.no-labels",
        "defaultMessage": "There are no labels in this project"
    },
    noLabelsLeft: {
        "id": "portfolio-3-portfolio.common.label.no-labels-left",
        "defaultMessage": "No available labels left"
    },
    noMatch: {
        "id": "portfolio-3-portfolio.common.label.no-match",
        "defaultMessage": "No results match your search"
    },
    invalidInputWithSpace: {
        "id": "portfolio-3-portfolio.common.label.invalid-input-with-space",
        "defaultMessage": "Invalid input, labels can't contain spaces"
    },
    invalidInputWithMaxLength: {
        "id": "portfolio-3-portfolio.common.label.invalid-input-with-max-length",
        "defaultMessage": "Invalid input, labels can't have more than 255 characters"
    },
    newLabel: {
        "id": "portfolio-3-portfolio.common.label.new-label",
        "defaultMessage": "New label"
    }
});

});


parcelRegister("8HrnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ecfdc440d476b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5rVFi = parcelRequire("5rVFi");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$30ecfdc440d476b5$export$2e2bcd8739ae039 = (ComposedComponent)=>// eslint-disable-next-line jira/react/no-class-components
    class extends (0, $eUqFw.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComposedComponent, {
                ...this.props,
                fetchOptions: this.getLabelOptions
            });
        }
        constructor(...args){
            super(...args);
            this.getLabelOptions = (query)=>(0, $5rVFi.default)('/rest/jpo/1.0/scenarios/labels', {
                    method: 'POST',
                    body: {
                        limit: 50,
                        planId: this.props.plan.id,
                        scenarioId: this.props.plan.currentScenarioId,
                        query: query || null
                    }
                }).then((response)=>response.json()).then((data)=>// data.items is an array of labels e.g. ["label1", "label2", ..., "label6"]
                    // if data.items is undefined, we return an empty array, which will then
                    // display a message "No available labels left" or "No labels in this project"
                    // when the user clicks on the "Labels" cell in the fields section
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    data?.items?.map((item)=>({
                            value: item,
                            label: item
                        })) || []);
        }
    };

});



parcelRegister("1NWBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7905d2ff69c11b2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $as75D = parcelRequire("as75D");

var $e320O = parcelRequire("e320O");

var $hS0up = parcelRequire("hS0up");
var $c7905d2ff69c11b2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $e320O.default), (0, $as75D.default))((0, $hS0up.default));

});
parcelRegister("as75D", function(module, exports) {

$parcel$export(module.exports, "default", () => $10be059b9d33cb99$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $10be059b9d33cb99$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, parentId)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                parent: parentId
            }));
        }
    });
var $10be059b9d33cb99$export$2e2bcd8739ae039 = $10be059b9d33cb99$var$dispatchMethods;

});

parcelRegister("e320O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3664b28587a81167$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $3664b28587a81167$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issues: (0, $cwP4d.getIssues),
    issueTypesById: (0, $lihml.getIssueTypesById),
    projectsById: (0, $ehEr2.getProjectsById)
});

});

parcelRegister("hS0up", function(module, exports) {

$parcel$export(module.exports, "default", () => $956619d8472bbfcb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $akSC8 = parcelRequire("akSC8");
var $gbNhI = parcelRequire("gbNhI");
var $gwbfD = parcelRequire("gwbfD");

var $g8SOd = parcelRequire("g8SOd");

var $bnY7I = parcelRequire("bnY7I");

var $8CXDT = parcelRequire("8CXDT");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $bDi5u = parcelRequire("bDi5u");
const $956619d8472bbfcb$export$409850a8a9c79192 = ({ onChange: onChange, issue: issue })=>(selection)=>{
        // @ts-expect-error - TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        if (selection && typeof selection.value === 'string') // @ts-expect-error - TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        onChange(issue, selection.value);
        else onChange(issue, null);
    };
const $956619d8472bbfcb$export$d5a4cc78f8c5a2cd = ({ issue: issue, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById, onChange: onChange, isScrolling: isScrolling = false, isReadOnly: isReadOnly = false, FieldSelect: FieldSelect })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleSelection = $956619d8472bbfcb$export$409850a8a9c79192({
        onChange: onChange,
        issue: issue
    });
    const getParentSelectOptions = ()=>// eslint-disable-next-line @typescript-eslint/no-shadow
        (0, $bnY7I.getPossibleParentIssues)({
            issue: issue,
            issues: issues,
            issueTypesById: issueTypesById,
            projectsById: projectsById
        }).map((issue)=>(0, $g8SOd.getIssueOption)(issue, issueTypesById, projectsById));
    const select = ()=>{
        const { parent: parent, summary: summary } = issue;
        const items = getParentSelectOptions();
        const valueItem = items.find((option)=>option.value === parent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: "parent",
            issue: issue,
            isScrolling: isScrolling
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: valueItem ? valueItem.label : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, {
            "aria-label": formatMessage({
                ...(0, $bDi5u.default).parentCellLabel
            }, {
                issue: summary
            }),
            attribute: "parent",
            formatOptionLabel: (0, $akSC8.selectIssueOption),
            isClearable: (0, $7CnHa.isDefined)(parent) && !(0, $bnY7I.isIssueSubTaskType)({
                issue: issue,
                issueTypesById: issueTypesById
            }),
            isDisabled: isReadOnly,
            issueId: issue.id,
            onChange: handleSelection,
            options: items,
            placeholder: formatMessage((0, $bDi5u.default).placeholder),
            value: valueItem || null
        })));
    };
    const wireframe = ()=>{
        const parent = issue.parent;
        const items = getParentSelectOptions();
        const selectedItem = items.find((item)=>item.value === parent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
            content: selectedItem && (0, $akSC8.selectIssueOption)(selectedItem)
        });
    };
    let cell = null;
    cell = isScrolling ? wireframe() : select();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, cell);
};
var $956619d8472bbfcb$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})($956619d8472bbfcb$export$d5a4cc78f8c5a2cd);

});
parcelRegister("bDi5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f53df8566440c72$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9f53df8566440c72$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.parent.placeholder",
        "defaultMessage": "Choose a parent"
    },
    parentCellLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.parent.parent-cell-label",
        "defaultMessage": "Choose a parent for issue {issue}"
    }
});

});



parcelRegister("j5xV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcdb29a36dd0b1d0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $d5Q6K = parcelRequire("d5Q6K");

var $eaue2 = parcelRequire("eaue2");

var $fDQJI = parcelRequire("fDQJI");
var $bcdb29a36dd0b1d0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $eaue2.default), (0, $d5Q6K.default))((0, $fDQJI.default));

});
parcelRegister("d5Q6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e98b5dccec0f86$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $e4e98b5dccec0f86$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, priorityId)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                priority: priorityId
            }));
        }
    });
var $e4e98b5dccec0f86$export$2e2bcd8739ae039 = $e4e98b5dccec0f86$var$dispatchMethods;

});

parcelRegister("eaue2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6ed74e97372c513$export$2e2bcd8739ae039);

var $jp3RH = parcelRequire("jp3RH");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $f6ed74e97372c513$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    prioritiesByIdMap: (0, $jp3RH.getIssuePriorities),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'ownProps' implicitly has an 'any' type.
    priorityIdsForProject: (state, ownProps)=>(0, $ehEr2.getIssuePriorityIdsByProjectId)(state)[ownProps.issue.project] || [],
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'ownProps' implicitly has an 'any' type.
    defaultIssuePriority: (state, ownProps)=>(0, $ehEr2.getDefaultIssuePriorityByProjectId)(state)[ownProps.issue.project]
});

});

parcelRegister("fDQJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c5aff371b2e607$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $cQGVO = parcelRequire("cQGVO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gbNhI = parcelRequire("gbNhI");
var $gwbfD = parcelRequire("gwbfD");

var $8CXDT = parcelRequire("8CXDT");

var $64VaH = parcelRequire("64VaH");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");
parcelRequire("gGKRb");
var $akSC8 = parcelRequire("akSC8");

var $gOB9n = parcelRequire("gOB9n");

var $jpSjO = parcelRequire("jpSjO");
const $d8c5aff371b2e607$var$notInPlan = {
    id: '',
    iconUrl: '',
    name: '',
    sequence: 0
};
const $d8c5aff371b2e607$var$formatOptionLabel = (intl)=>// eslint-disable-next-line @typescript-eslint/no-shadow
    ({ icon: icon, label: label, notInPlan: notInPlan })=>{
        if (notInPlan) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: intl.formatMessage((0, $gOB9n.default).tooltipText)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$jpSjO["not-in-plan"]} ${$jpSjO.truncated}`
        }, label));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $jpSjO["select-option"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $jpSjO["icon-wrapper"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $jpSjO.icon,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                backgroundSize: 'contain',
                backgroundImage: `url(${icon})`
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $jpSjO.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $jpSjO.truncated
        }, label))));
    };
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d8c5aff371b2e607$var$initialSelectFilter = (0, $akSC8.selectUtils).createFilter(null);
const $d8c5aff371b2e607$export$b526cf238a0a0ab3 = ({ isScrolling: isScrolling = false, issue: issue, priorityIdsForProject: priorityIdsForProject, defaultIssuePriority: defaultIssuePriority, prioritiesByIdMap: prioritiesByIdMap, onChange: onChange, isReadOnly: isReadOnly = false, FieldPrioritySelect: FieldPrioritySelect })=>{
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const getSelectedIssuePriority = ()=>{
        const { priority: priority, project: project } = issue;
        if (!priority) {
            if (!project) return $d8c5aff371b2e607$var$notInPlan;
            if (!defaultIssuePriority) return null;
            if (!(0, $7CnHa.isDefined)(prioritiesByIdMap) || $b3iuB.default(prioritiesByIdMap)) return null;
            return prioritiesByIdMap[defaultIssuePriority];
        }
        if (!(0, $7CnHa.isDefined)(priorityIdsForProject)) return null;
        if (!priorityIdsForProject.includes(priority)) return null;
        if (!(0, $7CnHa.isDefined)(prioritiesByIdMap) || $b3iuB.default(prioritiesByIdMap)) return null;
        return prioritiesByIdMap[priority];
    };
    const handleSelectChange = (selectedOption)=>{
        if (!(0, $7CnHa.isDefined)(selectedOption)) return onChange(issue, null);
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        if (typeof selectedOption.value === 'string') // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        return onChange(issue, selectedOption.value);
    };
    // go/jfe-eslint
    const priorityToOption = (issuePriority)=>{
        const { name: name, iconUrl: iconUrl, id: id } = issuePriority;
        return {
            value: id,
            label: name,
            icon: (0, $64VaH.proxyContextSafeUrl)(iconUrl)
        };
    };
    const filterOption = (option, query)=>{
        if (!$d8c5aff371b2e607$var$initialSelectFilter(option, query)) return false;
        const selectedIssuePriority = getSelectedIssuePriority();
        if (selectedIssuePriority === $d8c5aff371b2e607$var$notInPlan) return false;
        if ((0, $7CnHa.isDefined)(selectedIssuePriority) && option.value === selectedIssuePriority.id) return false;
        return true;
    };
    const getSelectedOption = ()=>{
        const selectedIssuePriority = getSelectedIssuePriority();
        if (!(0, $7CnHa.isDefined)(selectedIssuePriority)) return null;
        if (selectedIssuePriority === $d8c5aff371b2e607$var$notInPlan) return {
            label: formatMessage((0, $gOB9n.default).notInPlan),
            notInPlan: true
        };
        return priorityToOption(selectedIssuePriority);
    };
    const select = ()=>{
        const { summary: summary } = issue;
        const priorities = priorityIdsForProject.map((id)=>prioritiesByIdMap[id]);
        const items = $cQGVO.default(priorityToOption, priorities);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: "priority",
            issue: issue,
            isScrolling: isScrolling
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldPrioritySelect, {
            "aria-label": formatMessage((0, $gOB9n.default).priorityCellLabel, {
                issue: summary
            }),
            attribute: "priority",
            filterOption: filterOption,
            formatOptionLabel: $d8c5aff371b2e607$var$formatOptionLabel(intl),
            isDisabled: isReadOnly,
            issueId: issue.id,
            onChange: handleSelectChange,
            options: items,
            placeholder: formatMessage((0, $gOB9n.default).placeholder),
            value: getSelectedOption()
        }));
    };
    const wireframe = ()=>{
        const selectedOption = getSelectedOption();
        const content = selectedOption ? selectedOption.label : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
            content: content
        });
    };
    const cell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isScrolling ? wireframe() : select());
    return cell;
};
var $d8c5aff371b2e607$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldPrioritySelect: (0, $a4vO3.slots).FieldPrioritySelect
})($d8c5aff371b2e607$export$b526cf238a0a0ab3);

});
parcelRegister("gOB9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf61fd4b00f34dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3cf61fd4b00f34dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    priorityCellLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.priority-cell-label",
        "defaultMessage": "Choose a priority for issue {issue}"
    },
    notInPlan: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.not-in-plan",
        "defaultMessage": "Not in plan"
    },
    tooltipText: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.tooltip-text",
        "defaultMessage": "This priority is no longer available"
    },
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.priority.placeholder",
        "defaultMessage": "Choose a priority"
    }
});

});

parcelRegister("jpSjO", function(module, exports) {

$parcel$export(module.exports, "icon", () => $e22a7ca0deb2061e$export$1ca1ec8b29a4ce27, (v) => $e22a7ca0deb2061e$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "icon-wrapper", () => $e22a7ca0deb2061e$export$d5b71a90834fa638, (v) => $e22a7ca0deb2061e$export$d5b71a90834fa638 = v);
$parcel$export(module.exports, "label", () => $e22a7ca0deb2061e$export$1237798dc640739a, (v) => $e22a7ca0deb2061e$export$1237798dc640739a = v);
$parcel$export(module.exports, "not-in-plan", () => $e22a7ca0deb2061e$export$5687e044f2e8382a, (v) => $e22a7ca0deb2061e$export$5687e044f2e8382a = v);
$parcel$export(module.exports, "select-option", () => $e22a7ca0deb2061e$export$25439fa9d099d50b, (v) => $e22a7ca0deb2061e$export$25439fa9d099d50b = v);
$parcel$export(module.exports, "truncated", () => $e22a7ca0deb2061e$export$23ef198012fb7186, (v) => $e22a7ca0deb2061e$export$23ef198012fb7186 = v);
var $e22a7ca0deb2061e$export$1ca1ec8b29a4ce27;
var $e22a7ca0deb2061e$export$d5b71a90834fa638;
var $e22a7ca0deb2061e$export$1237798dc640739a;
var $e22a7ca0deb2061e$export$5687e044f2e8382a;
var $e22a7ca0deb2061e$export$25439fa9d099d50b;
var $e22a7ca0deb2061e$export$23ef198012fb7186;
$e22a7ca0deb2061e$export$1ca1ec8b29a4ce27 = `JN-0Kq_icon`;
$e22a7ca0deb2061e$export$d5b71a90834fa638 = `JN-0Kq_icon-wrapper`;
$e22a7ca0deb2061e$export$1237798dc640739a = `JN-0Kq_label`;
$e22a7ca0deb2061e$export$5687e044f2e8382a = `JN-0Kq_not-in-plan`;
$e22a7ca0deb2061e$export$25439fa9d099d50b = `JN-0Kq_select-option`;
$e22a7ca0deb2061e$export$23ef198012fb7186 = `JN-0Kq_truncated`;

});



parcelRegister("5yMne", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cdf0d8bea7d264e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $k45ll = parcelRequire("k45ll");

var $aO6yk = parcelRequire("aO6yk");

var $b4XcV = parcelRequire("b4XcV");
var $0cdf0d8bea7d264e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $aO6yk.default), (0, $k45ll.default))((0, $b4XcV.default));

});
parcelRegister("k45ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc1508645866d05$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $0fc1508645866d05$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, fixVersions)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                fixVersions: fixVersions
            }));
        }
    });
var $0fc1508645866d05$export$2e2bcd8739ae039 = $0fc1508645866d05$var$dispatchMethods;

});

parcelRegister("aO6yk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b341a775a3ed991b$export$2e2bcd8739ae039);

var $kDrtX = parcelRequire("kDrtX");
var $ldYmX = parcelRequire("ldYmX");

var $2Ruxt = parcelRequire("2Ruxt");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");

var $ehEr2 = parcelRequire("ehEr2");

var $wcCGG = parcelRequire("wcCGG");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
function $b341a775a3ed991b$export$7e57356575dea18e(versions) {
    return $ldYmX.default((acc, version)=>{
        for (const projectId of version.projects)if ($kDrtX.default(acc[projectId])) acc[projectId] = [
            version
        ];
        else acc[projectId].push(version);
        return acc;
    }, {}, versions);
}
const $b341a775a3ed991b$var$getReleaseRollUpValueForIssue = (state, props)=>(0, $7CnHa.isDefined)((0, $aK3ri.getRollupMap)(state)[props.issue.id]) ? (0, $aK3ri.getRollupMap)(state)[props.issue.id].release : null;
const $b341a775a3ed991b$var$collectVersionsByProjectId = (0, $iK4oF.createSelector)([
    (0, $wcCGG.getVersions)
], $b341a775a3ed991b$export$7e57356575dea18e);
const $b341a775a3ed991b$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    crossProjectVersionsById: (0, $2Ruxt.getCrossProjectVersionsById),
    versionsById: (0, $wcCGG.getVersionsById),
    projectsById: (0, $ehEr2.getProjectsById),
    releaseRollUpForIssue: $b341a775a3ed991b$var$getReleaseRollUpValueForIssue,
    versionsByProjectId: $b341a775a3ed991b$var$collectVersionsByProjectId,
    sortVersionsByHighestRank: (0, $wcCGG.getSortByHighestRank),
    sortVersionsByLowestRank: (0, $wcCGG.getSortByLowestRank)
});
var $b341a775a3ed991b$export$2e2bcd8739ae039 = $b341a775a3ed991b$var$mapStateToProps;

});

parcelRegister("b4XcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ebceb9b35b6e9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hkOxK = parcelRequire("hkOxK");
var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");
var $jPCDz = parcelRequire("jPCDz");
var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");
var $haaWO = parcelRequire("haaWO");
var $cQGVO = parcelRequire("cQGVO");
var $l7xwn = parcelRequire("l7xwn");
var $9ehHx = parcelRequire("9ehHx");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bVKeg = parcelRequire("bVKeg");
var $gbNhI = parcelRequire("gbNhI");
var $gwbfD = parcelRequire("gwbfD");

var $8CXDT = parcelRequire("8CXDT");

var $57dZR = parcelRequire("57dZR");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7aiur = parcelRequire("7aiur");

var $ctVjw = parcelRequire("ctVjw");

var $luXj2 = parcelRequire("luXj2");
const $d8ebceb9b35b6e9d$export$6e53d26b0341455b = (issue, version)=>$7d70y.default(issue.project, version.projects);
const $d8ebceb9b35b6e9d$export$8dcfdc6f758d6599 = ({ versionsById: versionsById, formatMessage: formatMessage })=>(id)=>{
        const version = versionsById[id];
        if ($kDrtX.default(version)) return formatMessage((0, $ctVjw.default).unknownVersion, {
            id: id
        });
        return version.name;
    };
const $d8ebceb9b35b6e9d$export$998fbd4086f40b5a = ({ versionsById: versionsById, formatMessage: formatMessage })=>(_, fixVersions)=>// fixVersions could be null or undefined depending on whether it's a scenario change or not
        $hkOxK.default($haaWO.default(', '), $cQGVO.default($d8ebceb9b35b6e9d$export$8dcfdc6f758d6599({
            versionsById: versionsById,
            formatMessage: formatMessage
        })))(fixVersions || []);
const $d8ebceb9b35b6e9d$export$4edff4fd0399ce6e = ({ onChange: onChange, issue: issue })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (selection)=>{
        const selectionArray = Array.isArray(selection) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        selection.filter(({ value: value })=>typeof value === 'string') : [];
        onChange(issue, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        selectionArray.map(({ value: value })=>value));
    };
const $d8ebceb9b35b6e9d$export$8d15756cdedd050b = ({ issue: issue, isScrolling: isScrolling, crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById, showOptimizations: showOptimizations, versionsByProjectId: versionsByProjectId, sortVersionsByLowestRank: sortVersionsByLowestRank, sortVersionsByHighestRank: sortVersionsByHighestRank, onChange: onChange, isReadOnly: isReadOnly = false, releaseRollUpForIssue: releaseRollUpForIssue, CellSelectWithRollup: CellSelectWithRollup, propsFromStorybook: propsFromStorybook, projectsById: projectsById })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const versionsMapToOptions = (version)=>(0, $7aiur.createVersionOption)(version, crossProjectVersionsById);
    const optimizedValueMapper = $d8ebceb9b35b6e9d$export$998fbd4086f40b5a({
        versionsById: versionsById,
        formatMessage: formatMessage
    });
    const getRelevantReleases = ()=>$fpul1.default((version)=>$d8ebceb9b35b6e9d$export$6e53d26b0341455b(issue, version), $9ehHx.default(versionsById));
    const getAssignedReleases = ()=>{
        let fixVersions = Array.isArray(issue.fixVersions) ? [
            ...issue.fixVersions
        ] : undefined;
        if (showOptimizations) fixVersions = (0, $57dZR.getOptimizedValue)(issue, 'fixVersions');
        if (!fixVersions) return [];
        const knownVersions = $fpul1.default((versionId)=>$jPCDz.default(versionId, versionsById), fixVersions);
        return $cQGVO.default((versionId)=>versionsById[versionId], knownVersions);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getUnreleasedOptionsGroup = (projectIds)=>{
        const unreleasedOptionGroups = $cQGVO.default((projectId)=>{
            const versions = $fpul1.default((version)=>version.releaseStatusId !== (0, $5rYNM.RELEASE_STATUSES).RELEASED, sortVersionsByLowestRank(versionsByProjectId[projectId]));
            return {
                label: formatMessage((0, $ctVjw.default).unreleased),
                options: $cQGVO.default(versionsMapToOptions, versions)
            };
        }, projectIds);
        return unreleasedOptionGroups;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getReleasedOptionsGroup = (projectIds)=>{
        const releasedOptionGroups = $cQGVO.default((projectId)=>{
            const versions = $fpul1.default((version)=>version.releaseStatusId === (0, $5rYNM.RELEASE_STATUSES).RELEASED, sortVersionsByHighestRank(versionsByProjectId[projectId]));
            return {
                label: formatMessage((0, $ctVjw.default).released),
                options: $cQGVO.default(versionsMapToOptions, versions)
            };
        }, projectIds);
        return releasedOptionGroups;
    };
    const getOptions = ()=>{
        const versions = getRelevantReleases();
        const projectIds = Array.from(versions.reduce((acc, version)=>{
            version.projects.forEach(acc.add, acc);
            return acc;
        }, new Set()));
        return getUnreleasedOptionsGroup(projectIds).concat(getReleasedOptionsGroup(projectIds));
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filterOptions = (option, query)=>{
        const { label: versionName, data: data } = option;
        const { crossProjectVersionName: crossProjectVersionName = '' } = data;
        return versionName.toLowerCase().includes(query.toLowerCase()) || crossProjectVersionName.toLowerCase().includes(query.toLowerCase());
    };
    const getSelections = ()=>$cQGVO.default(versionsMapToOptions, getAssignedReleases());
    const handleOnChange = $d8ebceb9b35b6e9d$export$4edff4fd0399ce6e({
        onChange: onChange,
        issue: issue
    });
    const wireframe = ()=>{
        const selections = getSelections();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
            content: !$b3iuB.default(selections) ? selections.map((s)=>s.label) || '' : '',
            isReadOnly: showOptimizations
        });
    };
    const select = ()=>{
        const options = getOptions();
        const selections = getSelections();
        const rollupLabels = $l7xwn.default((a, b)=>a.localeCompare(b), (releaseRollUpForIssue || []).map((releaseId)=>(0, $7CnHa.isDefined)(versionsById[releaseId]) ? versionsById[releaseId].name : ''));
        if (projectsById[issue.project]?.isReleasesEnabled === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $ctVjw.default).notAvailableTooltip, {
                projectName: projectsById[issue.project].name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $luXj2.disabledContainer
        }, formatMessage((0, $ctVjw.default).disabledReleaseField)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: "fixVersions",
            isScrolling: isScrolling,
            issue: issue,
            showOptimizations: showOptimizations,
            valueMapper: optimizedValueMapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $luXj2.release
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellSelectWithRollup, {
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.release-cell",
            "aria-label": formatMessage((0, $ctVjw.default).releaseSelectorLabel, {
                issue: issue.summary
            }),
            attribute: "release",
            filterOption: filterOptions,
            formatOptionLabel: (0, $7aiur.formatReleaseOptionLabel),
            isClearable: true,
            isDisabled: isReadOnly,
            issueId: issue.id,
            hideSelectedOptions: false,
            closeMenuOnSelect: false,
            isMulti: true,
            components: {
                Option: (0, $bVKeg.CheckboxOption)
            },
            onChange: (option)=>handleOnChange(option),
            options: options,
            placeholder: formatMessage((0, $ctVjw.default).placeholder),
            rolledUpValues: rollupLabels,
            value: selections,
            ...propsFromStorybook
        })));
    };
    return isScrolling ? wireframe() : select();
};
var $d8ebceb9b35b6e9d$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    CellSelectWithRollup: (0, $a4vO3.slots).CellSelectWithRollup
})($d8ebceb9b35b6e9d$export$8d15756cdedd050b);

});
parcelRegister("9ehHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b8326fabc0c9732$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $6b8326fabc0c9732$var$valuesIn = /*#__PURE__*/ (0, $eSWTK.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $6b8326fabc0c9732$export$2e2bcd8739ae039 = $6b8326fabc0c9732$var$valuesIn;

});

parcelRegister("7aiur", function(module, exports) {

$parcel$export(module.exports, "createVersionOption", () => $85bd29ef16f703e4$export$94603e60741921d6);
$parcel$export(module.exports, "formatReleaseOptionLabel", () => $85bd29ef16f703e4$export$6a85bd1a027302d9);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $7CnHa = parcelRequire("7CnHa");

var $dMD7q = parcelRequire("dMD7q");
const $85bd29ef16f703e4$export$94603e60741921d6 = ({ id: id, name: name, crossProjectVersion: crossProjectVersion }, crossProjectVersionsById)=>{
    if ((0, $7CnHa.isDefined)(crossProjectVersion) && crossProjectVersionsById[crossProjectVersion]) return {
        value: id,
        label: name,
        crossProjectVersionName: crossProjectVersionsById[crossProjectVersion].name
    };
    return {
        value: id,
        label: name
    };
};
const $85bd29ef16f703e4$export$6a85bd1a027302d9 = (option, meta)=>{
    const { label: versionName, crossProjectVersionName: crossProjectVersionName } = option;
    const { context: context } = meta;
    if (context === 'menu') return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dMD7q.crossProjectReleaseOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dMD7q.crossProjectReleaseName,
        title: versionName
    }, versionName), (0, $7CnHa.isDefined)(crossProjectVersionName) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dMD7q.crossProjectReleaseLozenge,
        title: crossProjectVersionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, crossProjectVersionName))));
    return versionName;
};

});
parcelRegister("dMD7q", function(module, exports) {

$parcel$export(module.exports, "crossProjectReleaseLozenge", () => $a08e1a3cb844cd5d$export$be8ecdd1dde7847a, (v) => $a08e1a3cb844cd5d$export$be8ecdd1dde7847a = v);
$parcel$export(module.exports, "crossProjectReleaseName", () => $a08e1a3cb844cd5d$export$ad543e317dba39b7, (v) => $a08e1a3cb844cd5d$export$ad543e317dba39b7 = v);
$parcel$export(module.exports, "crossProjectReleaseOption", () => $a08e1a3cb844cd5d$export$dd5faf32de3b1cad, (v) => $a08e1a3cb844cd5d$export$dd5faf32de3b1cad = v);
var $a08e1a3cb844cd5d$export$be8ecdd1dde7847a;
var $a08e1a3cb844cd5d$export$ad543e317dba39b7;
var $a08e1a3cb844cd5d$export$dd5faf32de3b1cad;
var $a08e1a3cb844cd5d$export$69379c888580b1e2;
$a08e1a3cb844cd5d$export$be8ecdd1dde7847a = `hC7mga_crossProjectReleaseLozenge`;
$a08e1a3cb844cd5d$export$ad543e317dba39b7 = `hC7mga_crossProjectReleaseName`;
$a08e1a3cb844cd5d$export$dd5faf32de3b1cad = `hC7mga_crossProjectReleaseOption`;
$a08e1a3cb844cd5d$export$69379c888580b1e2 = `hC7mga_moreReleases`;

});


parcelRegister("ctVjw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc17c0bbe14c5d2c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dc17c0bbe14c5d2c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.placeholder",
        "defaultMessage": "Choose a release"
    },
    releaseSelectorLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.release-selector-label",
        "defaultMessage": "Choose a release for issue {issue}"
    },
    unknownVersion: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.unknown-version",
        "defaultMessage": "Unknown version {id}"
    },
    released: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.unreleased",
        "defaultMessage": "Unreleased"
    },
    notAvailable: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.not-available",
        "defaultMessage": "Not enabled"
    },
    notAvailableTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.not-available-tooltip",
        "defaultMessage": "To enable releases for <strong>{projectName}</strong>, go to Project settings > Features"
    },
    disabledReleaseField: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.release.disabled-release-field",
        "defaultMessage": "N/A"
    }
});

});

parcelRegister("luXj2", function(module, exports) {

$parcel$export(module.exports, "disabledContainer", () => $fa6a6743f4ed8cb4$export$9405ab27dc5f5d53, (v) => $fa6a6743f4ed8cb4$export$9405ab27dc5f5d53 = v);
$parcel$export(module.exports, "release", () => $fa6a6743f4ed8cb4$export$23d3fad09dc44362, (v) => $fa6a6743f4ed8cb4$export$23d3fad09dc44362 = v);
var $fa6a6743f4ed8cb4$export$34e0f9847d4c02dd;
var $fa6a6743f4ed8cb4$export$be8ecdd1dde7847a;
var $fa6a6743f4ed8cb4$export$ad543e317dba39b7;
var $fa6a6743f4ed8cb4$export$dd5faf32de3b1cad;
var $fa6a6743f4ed8cb4$export$9405ab27dc5f5d53;
var $fa6a6743f4ed8cb4$export$c0d9370d587dcb77;
var $fa6a6743f4ed8cb4$export$23d3fad09dc44362;
var $fa6a6743f4ed8cb4$export$3f3ea63501e8c591;
$fa6a6743f4ed8cb4$export$34e0f9847d4c02dd = `CDefyW_container`;
$fa6a6743f4ed8cb4$export$be8ecdd1dde7847a = `CDefyW_crossProjectReleaseLozenge`;
$fa6a6743f4ed8cb4$export$ad543e317dba39b7 = `CDefyW_crossProjectReleaseName`;
$fa6a6743f4ed8cb4$export$dd5faf32de3b1cad = `CDefyW_crossProjectReleaseOption`;
$fa6a6743f4ed8cb4$export$9405ab27dc5f5d53 = `CDefyW_disabledContainer`;
$fa6a6743f4ed8cb4$export$c0d9370d587dcb77 = `CDefyW_infoIcon`;
$fa6a6743f4ed8cb4$export$23d3fad09dc44362 = `CDefyW_release`;
$fa6a6743f4ed8cb4$export$3f3ea63501e8c591 = `CDefyW_releaseDisabled`;

});



parcelRegister("eTocq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8d5e9f97397b73$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4PUvn = parcelRequire("4PUvn");

var $jDsHD = parcelRequire("jDsHD");
var $1c8d5e9f97397b73$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4PUvn.default), {})((0, $jDsHD.default));

});
parcelRegister("4PUvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b94a76416cfc3dc6$export$2e2bcd8739ae039);

var $KA559 = parcelRequire("KA559");
const $b94a76416cfc3dc6$var$querySelector = (state)=>({
        issueReporterMap: (0, $KA559.getIssueReporterMap)(state)
    });
var $b94a76416cfc3dc6$export$2e2bcd8739ae039 = $b94a76416cfc3dc6$var$querySelector;

});

parcelRegister("jDsHD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9f01bee9bd4856$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");
const $4d9f01bee9bd4856$export$d0966422cba54096 = ({ issue: issue, issueReporterMap: issueReporterMap, FieldUserAvatarCell: FieldUserAvatarCell })=>{
    if ((0, $7CnHa.isDefined)(issue.reporter) && (0, $7CnHa.isDefined)(issueReporterMap[issue.id])) {
        const reporter = issueReporterMap[issue.id];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldUserAvatarCell, {
            title: reporter.jiraUser.title,
            avatarUrl: reporter.jiraUser.avatarUrl
        });
    }
    return null;
};
var $4d9f01bee9bd4856$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldUserAvatarCell: (0, $a4vO3.slots).FieldUserAvatarCell
})($4d9f01bee9bd4856$export$d0966422cba54096);

});


parcelRegister("iZmwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e3f3088a5d8831$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gX7sq = parcelRequire("gX7sq");

var $7yjnp = parcelRequire("7yjnp");

var $ahbG9 = parcelRequire("ahbG9");
var // @ts-expect-error - Argument of type '({ isScrolling, isReadOnly, issue, issue: { team: teamId, level, id: issueId }, showOptimizations, sprints, sprintsByTeam, teamsById, additionalTeamsById, issueStatuses, teams, sprintsByIssueSources, externalSprintsById, allSprints, rollupValues, SprintSelectComponent, onChange, }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<Matching<Partial<Props> & {}, Props>>'.
$49e3f3088a5d8831$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $7yjnp.default), (0, $gX7sq.default))((0, $ahbG9.default));

});
parcelRegister("gX7sq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ddda2a15a08a3c3$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $1ddda2a15a08a3c3$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, sprint)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                sprint: sprint
            }));
        }
    });
var $1ddda2a15a08a3c3$export$2e2bcd8739ae039 = $1ddda2a15a08a3c3$var$dispatchMethods;

});

parcelRegister("7yjnp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d18e6458e21dbb9$export$2e2bcd8739ae039);

var $kFf60 = parcelRequire("kFf60");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");
const $9d18e6458e21dbb9$var$mapStateToProps = (state)=>({
        sprints: (0, $c1XMU.getSprints)(state),
        sprintsByTeam: (0, $c1XMU.getSprintsForTeam)(state),
        teamsById: (0, $MQRDu.getTeamsById)(state),
        issueStatuses: (0, $kFf60.getIssueStatusById)(state),
        teams: (0, $MQRDu.getTeams)(state),
        sprintsByIssueSources: (0, $c1XMU.getSprintsForIssueSources)(state),
        additionalTeamsById: (0, $MQRDu.getAdditionalTeamsById)(state),
        externalSprintsById: (0, $c1XMU.getExternalSprintsById)(state),
        allSprints: (0, $c1XMU.getAllSprints)(state),
        rollupValues: (0, $aK3ri.getRollupMap)(state)
    });
var $9d18e6458e21dbb9$export$2e2bcd8739ae039 = $9d18e6458e21dbb9$var$mapStateToProps;

});

parcelRegister("ahbG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27cca93e2c4d35e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8YqJS = parcelRequire("8YqJS");

var $7CnHa = parcelRequire("7CnHa");

var $BbXIN = parcelRequire("BbXIN");

var $grTnd = parcelRequire("grTnd");

var $3FhcH = parcelRequire("3FhcH");
const $f27cca93e2c4d35e$export$639018492a4c835c = (isIssueASubtask, intl)=>{
    if (isIssueASubtask) return {
        header: intl.formatMessage((0, $BbXIN.default).issueIsSubtaskHeader),
        content: intl.formatMessage((0, $BbXIN.default).issueIsSubtaskContent)
    };
};
const $f27cca93e2c4d35e$export$a092d4418bd765b8 = ({ isScrolling: isScrolling, isReadOnly: isReadOnly = false, issue: issue, issue: { team: teamId, level: level, id: issueId }, showOptimizations: showOptimizations, sprints: sprints, sprintsByTeam: sprintsByTeam, teamsById: teamsById, additionalTeamsById: additionalTeamsById, issueStatuses: issueStatuses, teams: teams, sprintsByIssueSources: sprintsByIssueSources, externalSprintsById: externalSprintsById, allSprints: allSprints, rollupValues: rollupValues, SprintSelectComponent: SprintSelectComponent = (0, $grTnd.default), onChange: onChange })=>{
    const intl = (0, $5JgJ2.default)();
    const { formatMessage: formatMessage } = intl;
    const sprintRollUpForIssue = (0, $7CnHa.isDefined)(rollupValues[issueId]) ? rollupValues[issueId].sprint : null;
    const handleSelection = (selection)=>{
        // @ts-expect-error - TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        if (selection && typeof selection.value === 'string') // @ts-expect-error - TS2551 - Property 'value' does not exist on type 'OptionType | OptionsType'. Did you mean 'values'?
        onChange(issue, selection.value);
        else onChange(issue, undefined);
    };
    const isIssueASubtask = level === (0, $8YqJS.SUB_TASK_LEVEL);
    const team = teamId ? teamsById[teamId] || null : null;
    let sprintsForTeam = sprints;
    if ((0, $7CnHa.isDefined)(team)) sprintsForTeam = sprintsByTeam[team.id] || [];
    const isSelectReadOnly = isIssueASubtask || isReadOnly;
    const sprintSelectProps = {
        sprintRollUpForIssue: sprintRollUpForIssue,
        handleSelection: handleSelection,
        isScrolling: isScrolling,
        isReadOnly: isSelectReadOnly,
        issue: issue,
        showOptimizations: showOptimizations,
        sprints: sprints,
        issueStatuses: issueStatuses,
        sprintsByTeam: sprintsByTeam,
        teams: teams,
        sprintsByIssueSources: sprintsByIssueSources,
        additionalTeamsById: additionalTeamsById,
        teamsById: teamsById,
        allSprints: allSprints,
        externalSprintsById: externalSprintsById,
        externalSprintLabel: formatMessage((0, $BbXIN.default).externalSprint),
        message: !showOptimizations ? $f27cca93e2c4d35e$export$639018492a4c835c(isIssueASubtask, intl) : undefined
    };
    return isScrolling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FhcH.default), {
        issue: issue,
        showOptimizations: showOptimizations,
        sprints: sprintsForTeam
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SprintSelectComponent, sprintSelectProps);
};
var $f27cca93e2c4d35e$export$2e2bcd8739ae039 = $f27cca93e2c4d35e$export$a092d4418bd765b8;

});
parcelRegister("BbXIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $517235a665bda71d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $517235a665bda71d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.placeholder",
        "defaultMessage": "Choose a sprint"
    },
    sprintSelectorLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.sprint-selector-label",
        "defaultMessage": "Select sprint for issue {issue}"
    },
    issueIsSubtaskHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.issue-is-subtask-header",
        "defaultMessage": "Cannot change the sprint of sub-tasks."
    },
    issueIsSubtaskContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.issue-is-subtask-content",
        "defaultMessage": "A sub-task is assigned to the same sprint as its parent story. To change this sprint, change the sprint of the parent story instead."
    },
    noTeamHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-team-header",
        "defaultMessage": "No team has been selected."
    },
    noTeamContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-team-content",
        "defaultMessage": "Choose a Scrum team first, and make sure the board for that team has sprints in it."
    },
    externalTeamHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-team-header",
        "defaultMessage": "Team not in plan."
    },
    externalTeamContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-team-content",
        "defaultMessage": "Add the team to the plan first, then try setting the sprint again."
    },
    teamIsNotAScrumTeamHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.team-is-not-a-scrum-team-header",
        "defaultMessage": "The associated team is not a Scrum team."
    },
    teamIsNotAScrumTeamContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.team-is-not-a-scrum-team-content",
        "defaultMessage": "Since Scrum teams work in sprints, choose a Scrum team first."
    },
    noIssueSourceDefinedHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-issue-source-defined-header",
        "defaultMessage": "There are no Scrum boards for the associated team."
    },
    noIssueSourceDefinedContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-issue-source-defined-content",
        "defaultMessage": "Make sure this team is associated with a Scrum board, to use the sprints of that board."
    },
    noSprintsInTeamHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-sprints-in-team-header",
        "defaultMessage": "There are no sprints in the associated board."
    },
    noSprintsInTeamContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.no-sprints-in-team-content",
        "defaultMessage": "Create a sprint for this board in Jira first."
    },
    numCompletedSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.num-completed-sprints",
        "defaultMessage": "{numCompletedSprints} completed"
    },
    completedSprintsHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.completed-sprints-header",
        "defaultMessage": "This issue was in"
    },
    completedSprintsLozenge: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.completed-sprints-lozenge",
        "defaultMessage": "Completed"
    },
    futureSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.future-sprints",
        "defaultMessage": "Future"
    },
    futureAndCompletedSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.future-and-completed-sprints",
        "defaultMessage": "{sprint} <span>+ {numCompletedSprints} completed</span>"
    },
    notInPlanAndCompletedSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.not-in-plan-and-completed-sprints",
        "defaultMessage": "<span>{sprint}</span> <span>+ {numCompletedSprints} completed</span>"
    },
    otherSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.other-sprints",
        "defaultMessage": "Other sprints"
    },
    externalSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint",
        "defaultMessage": "External sprint"
    },
    externalSprintTooltipTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint-tooltip-title",
        "defaultMessage": "Sprint currently not in this plan"
    },
    externalSprintTooltipContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-sprint-tooltip-content",
        "defaultMessage": "While this sprint isn't in this plan, it's appearing because it's assigned to issues in the plan."
    },
    externalCompletedSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.sprint.external-completed-sprint",
        "defaultMessage": "completed (external)"
    }
});

});

parcelRegister("grTnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cce2921a9240e23$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $2uEDR = parcelRequire("2uEDR");
var $l7xwn = parcelRequire("l7xwn");
var $9RbxZ = parcelRequire("9RbxZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbfD = parcelRequire("gwbfD");

var $a4NMN = parcelRequire("a4NMN");

var $BbXIN = parcelRequire("BbXIN");

var $jmuk1 = parcelRequire("jmuk1");

var $8CXDT = parcelRequire("8CXDT");

var $57dZR = parcelRequire("57dZR");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $7uUgU = parcelRequire("7uUgU");

var $9pXbZ = parcelRequire("9pXbZ");

const $1cce2921a9240e23$var$sprintOfIssueIsCompleted = (issue)=>(0, $7CnHa.isDefined)(issue.sprint) && Array.isArray(issue.completedSprints) && $7d70y.default(issue.sprint, issue.completedSprints);
const $1cce2921a9240e23$var$getOptionLabel = ({ issue: issue, issueStatuses: issueStatuses, sprints: sprints, showOptimizations: showOptimizations })=>{
    const issueIsDone = Boolean(issueStatuses && issue.status && issueStatuses[issue.status] && issueStatuses[issue.status].categoryId === 3);
    const issueIsCompleted = issueIsDone && $1cce2921a9240e23$var$sprintOfIssueIsCompleted(issue);
    const completedSprintIds = issue.completedSprints || [];
    const completedSprints = $3IGDG.default($fpul1.default((sprint)=>$1l9vO.default(sprint.id, completedSprintIds)), $9RbxZ.default($f7Op5.default('completeDate')), $2uEDR.default)(sprints);
    const sprintIsOptimized = !!showOptimizations && (0, $57dZR.hasValueChanged)(issue.sprint, (0, $57dZR.getOptimizedValue)(issue, (0, $b44ee846994766e8$export$b549cc58e415d416)));
    return (opt, { context: context })=>{
        const sprintNotSet = !(0, $7CnHa.isDefined)(issue.sprint);
        if (context === 'menu') {
            const sprintIsCompleted = opt.isDisabled;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uUgU.MenuLabel), {
                sprintIsExternal: opt.isExternal,
                sprintIsCompleted: sprintIsCompleted
            }, opt.label);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uUgU.DisplayLabel), {
            issueIsCompleted: issueIsCompleted,
            issueCompletedSprints: completedSprints,
            sprintIsOptimized: sprintIsOptimized,
            sprintIsExternal: opt.isExternal,
            sprintNotSet: sprintNotSet
        }, opt.label);
    };
};
const $1cce2921a9240e23$export$b381aa2d0aaee6b6 = (props)=>{
    const { handleSelection: handleSelection, isScrolling: isScrolling, isReadOnly: isReadOnly, issue: issue, issue: { sprint: sprintOfIssue, team: teamOfIssue }, showOptimizations: showOptimizations, sprints: sprints, message: message, issueStatuses: issueStatuses, sprintsByTeam: sprintsByTeam, teams: teams, sprintsByIssueSources: sprintsByIssueSources, additionalTeamsById: additionalTeamsById, teamsById: teamsById, allSprints: allSprints, externalSprintsById: externalSprintsById, externalSprintLabel: externalSprintLabel, sprintRollUpForIssue: sprintRollUpForIssue, SelectForColumnCell: SelectForColumnCell } = props;
    const completedSprints = issue.completedSprints || [];
    const completedSprintsForIssue = allSprints.filter((sprint)=>sprint.state === (0, $5rYNM.SPRINT_STATES).CLOSED && $7d70y.default(sprint.id, completedSprints));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const otherSprintsLabel = formatMessage((0, $BbXIN.default).otherSprints);
    const futureSprintsGroupByTeam = (0, $a4NMN.getFutureSprintGroups)(teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel);
    const completedSprintOptions = completedSprintsForIssue.map((sprint)=>({
            value: sprint.id,
            label: sprint.title,
            isDisabled: true,
            isExternal: (0, $7CnHa.isDefined)(externalSprintsById[sprint.id])
        }));
    const groupedOptions = [
        {
            label: formatMessage((0, $BbXIN.default).completedSprintsHeader),
            options: completedSprintOptions
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-shadow
    futureSprintsGroupByTeam.forEach((sprints, label)=>{
        groupedOptions.push({
            label: label,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            options: sprints.map((s)=>({
                    value: s.id,
                    label: s.title
                }))
        });
    });
    const mapIdToTitle = (_, value)=>externalSprintsById[value] && externalSprintsById[value].title || (0, $jmuk1.getSprintName)(value, sprints);
    let value = showOptimizations ? (0, $57dZR.getOptimizedValue)(issue, (0, $b44ee846994766e8$export$b549cc58e415d416)) : sprintOfIssue;
    let isClearable = true;
    if (!(0, $7CnHa.isDefined)(value) && completedSprints.length > 0) {
        value = completedSprints[0];
        isClearable = false;
    }
    if ($1cce2921a9240e23$var$sprintOfIssueIsCompleted(issue)) isClearable = false;
    const currentSprint = sprints.find((sprint)=>sprint.id === value);
    let sprintValue;
    if (currentSprint) sprintValue = {
        label: currentSprint.title,
        value: currentSprint.id
    };
    if (!(0, $7CnHa.isDefined)(sprintValue) && (0, $7CnHa.isDefined)(value)) {
        const externalSprintOption = externalSprintsById[value];
        if (externalSprintOption) {
            sprintValue = {
                value: externalSprintOption.id,
                label: externalSprintOption.title,
                isExternal: true
            };
            if (externalSprintOption.state !== (0, $5rYNM.SPRINT_STATES).CLOSED) groupedOptions.push({
                label: externalSprintLabel,
                options: [
                    {
                        value: externalSprintOption.id,
                        label: externalSprintOption.title,
                        isExternal: true
                    }
                ]
            });
        }
    }
    let selectValue = null; // by default the select box value is null, so nothing is selected
    if ((0, $7CnHa.isDefined)(sprintValue)) // if a sprint value is available, then we set it as the select box value
    selectValue = sprintValue;
    else if (!(0, $7CnHa.isDefined)(sprintValue) && completedSprints.length > 0) // if sprint value is not available but if we have completed sprints, then we have to show completed sprints placeholder text so let's set a placeholder value
    selectValue = {
        value: null,
        label: null
    };
    const formatOptionLabel = $1cce2921a9240e23$var$getOptionLabel({
        issue: issue,
        issueStatuses: issueStatuses,
        sprints: allSprints,
        showOptimizations: showOptimizations
    });
    const withRollup = ()=>{
        const rolledUpValues = $l7xwn.default((a, b)=>a.localeCompare(b), (sprintRollUpForIssue || []).map((sprintId)=>{
            const externalSprint = externalSprintsById[sprintId];
            if (externalSprint) return externalSprint.title;
            return (0, $jmuk1.getSprintName)(sprintId, sprints) || // It's false positive, "missing" props are in the type.
            formatMessage((0, $BbXIN.default).externalCompletedSprint);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectForColumnCell, {
            "aria-label": formatMessage({
                ...(0, $BbXIN.default).sprintSelectorLabel
            }, {
                issue: issue.summary
            }),
            attribute: "sprint",
            formatOptionLabel: formatOptionLabel,
            isClearable: isClearable,
            isDisabled: isReadOnly,
            issueId: issue.id,
            minSelectWidth: (0, $2LimL.MIN_SELECT_WIDTH),
            onChange: handleSelection,
            options: groupedOptions,
            placeholder: formatMessage((0, $BbXIN.default).placeholder),
            rolledUpValues: rolledUpValues,
            value: selectValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        attribute: (0, $b44ee846994766e8$export$b549cc58e415d416),
        issue: issue,
        valueMapper: mapIdToTitle,
        isScrolling: isScrolling,
        showOptimizations: showOptimizations
    }, (0, $7CnHa.isDefined)(message) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9pXbZ.tooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, message.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, message.content))
    }, withRollup()) : withRollup());
};
var $1cce2921a9240e23$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    SelectForColumnCell: (0, $a4vO3.slots).CellSelectWithRollup
})($1cce2921a9240e23$export$b381aa2d0aaee6b6);

});
parcelRegister("jmuk1", function(module, exports) {

$parcel$export(module.exports, "getSprintName", () => $158eaeb49e7437d4$export$3df6198cde5435f9);

var $7CnHa = parcelRequire("7CnHa");
const $158eaeb49e7437d4$export$3df6198cde5435f9 = (sprintId, sprints)=>{
    const sprint = sprints.find(({ id: id })=>id === sprintId);
    return (0, $7CnHa.isDefined)(sprint) ? sprint.title : '';
};

});

parcelRegister("7uUgU", function(module, exports) {

$parcel$export(module.exports, "DisplayLabel", () => $cfca800184de5062$export$d6cff160a9173fab);
$parcel$export(module.exports, "MenuLabel", () => $cfca800184de5062$export$dd37bec0e8a99143);

var $eUqFw = parcelRequire("eUqFw");

var $f2C9X = parcelRequire("f2C9X");
var $b3iuB = parcelRequire("b3iuB");
var $aaoZV = parcelRequire("aaoZV");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $ffiyv = parcelRequire("ffiyv");
var $gwbfD = parcelRequire("gwbfD");

var $BbXIN = parcelRequire("BbXIN");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $iWLE9 = parcelRequire("iWLE9");
const $cfca800184de5062$var$getTestId = (sprintName)=>typeof sprintName === 'string' ? `sprint-select-option-${sprintName.replace(/\s/g, '-')}` : undefined;
const $cfca800184de5062$var$ExternalSprint = (0, $2qhQi.default)(({ children: children, intl: intl, isCompleted: isCompleted })=>{
    const tooltipContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $iWLE9.tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, intl.formatMessage((0, $BbXIN.default).externalSprintTooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage((0, $BbXIN.default).externalSprintTooltipContent)));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $iWLE9.externalSprint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $iWLE9.externalSprintText
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $iWLE9.externalSprintLozenge,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onFocus: ()=>{},
        onMouseOver: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).externalLozenge))), isCompleted === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $BbXIN.default).completedSprintsLozenge)))));
});
function $cfca800184de5062$var$UncompletedSprint({ children: children, sprintIsExternal: sprintIsExternal }) {
    return sprintIsExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$ExternalSprint, null, children) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $iWLE9.sprintTitle
    }, children);
}
function $cfca800184de5062$var$CompletedSprints({ peak: peak = false, prefix: prefix, sprints: sprints, sprintIsExternal: sprintIsExternal }) {
    if ($b3iuB.default(sprints)) return null;
    if ((0, $7CnHa.isDefined)(prefix)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: `${$iWLE9.completedSprintsChunk} ${$iWLE9.sprintTitlePrefix}`
    }, prefix), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprintIsExternal: sprintIsExternal,
        sprints: sprints
    }));
    if (peak) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprintIsExternal: sprintIsExternal,
        sprints: $aaoZV.default(0, 1)(sprints)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprintIsExternal: sprintIsExternal,
        sprints: $aaoZV.default(1, Infinity)(sprints),
        prefix: "+"
    }));
    if (sprints.length === 1) {
        const sprint = $f2C9X.default(sprints);
        if (!(0, $7CnHa.isDefined)(sprint)) return null;
        return sprintIsExternal === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$ExternalSprint, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: `${$iWLE9.completedSprintsChunk} ${$iWLE9.sprintTitle}`
        }, sprint.title)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: `${$iWLE9.completedSprintsChunk} ${$iWLE9.sprintTitle}`
        }, sprint.title);
    }
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: `${$iWLE9.completedSprintsChunk} ${$iWLE9.sprintTitle}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $BbXIN.default).numCompletedSprints,
        values: {
            numCompletedSprints: sprints.length
        }
    })));
}
const $cfca800184de5062$export$d6cff160a9173fab = function DisplayLabel({ issueIsCompleted: issueIsCompleted, issueCompletedSprints: issueCompletedSprints, sprintIsExternal: sprintIsExternal, sprintNotSet: sprintNotSet, sprintIsOptimized: sprintIsOptimized, children: children }) {
    if (issueIsCompleted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprintIsExternal: sprintIsExternal,
        peak: true,
        sprints: issueCompletedSprints
    });
    if (sprintNotSet && !sprintIsOptimized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprintIsExternal: sprintIsExternal,
        peak: true,
        sprints: issueCompletedSprints
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $iWLE9.completedAndUncompletedSprints
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$UncompletedSprint, {
        sprintIsExternal: sprintIsExternal
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$CompletedSprints, {
        sprints: issueCompletedSprints,
        prefix: "+"
    })));
};
const $cfca800184de5062$export$dd37bec0e8a99143 = function DisplayLabel({ sprintIsExternal: sprintIsExternal, sprintIsCompleted: sprintIsCompleted, children: children }) {
    if (sprintIsExternal) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $iWLE9.menuLabelDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfca800184de5062$var$ExternalSprint, {
        isCompleted: sprintIsCompleted
    }, children)));
    if (sprintIsCompleted) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $iWLE9.menuLabelDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $BbXIN.default).completedSprintsLozenge))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": $cfca800184de5062$var$getTestId(children)
    }, children);
};

});
parcelRegister("iWLE9", function(module, exports) {

$parcel$export(module.exports, "completedAndUncompletedSprints", () => $dcb29a6250bef106$export$2f132e32b175f6e6, (v) => $dcb29a6250bef106$export$2f132e32b175f6e6 = v);
$parcel$export(module.exports, "completedSprintsChunk", () => $dcb29a6250bef106$export$e509d521b99dedde, (v) => $dcb29a6250bef106$export$e509d521b99dedde = v);
$parcel$export(module.exports, "externalSprint", () => $dcb29a6250bef106$export$82eb6504f7db5235, (v) => $dcb29a6250bef106$export$82eb6504f7db5235 = v);
$parcel$export(module.exports, "externalSprintLozenge", () => $dcb29a6250bef106$export$657f3f84e37b3aed, (v) => $dcb29a6250bef106$export$657f3f84e37b3aed = v);
$parcel$export(module.exports, "externalSprintText", () => $dcb29a6250bef106$export$536a5153d9b87a6b, (v) => $dcb29a6250bef106$export$536a5153d9b87a6b = v);
$parcel$export(module.exports, "menuLabelDisabled", () => $dcb29a6250bef106$export$28dc72f63d69649d, (v) => $dcb29a6250bef106$export$28dc72f63d69649d = v);
$parcel$export(module.exports, "sprintTitle", () => $dcb29a6250bef106$export$d36673c13d5182d, (v) => $dcb29a6250bef106$export$d36673c13d5182d = v);
$parcel$export(module.exports, "sprintTitlePrefix", () => $dcb29a6250bef106$export$c96e006c7c6ab3bd, (v) => $dcb29a6250bef106$export$c96e006c7c6ab3bd = v);
$parcel$export(module.exports, "tooltip", () => $dcb29a6250bef106$export$4e6f96734dfe12f4, (v) => $dcb29a6250bef106$export$4e6f96734dfe12f4 = v);
var $dcb29a6250bef106$export$2f132e32b175f6e6;
var $dcb29a6250bef106$export$e509d521b99dedde;
var $dcb29a6250bef106$export$82eb6504f7db5235;
var $dcb29a6250bef106$export$657f3f84e37b3aed;
var $dcb29a6250bef106$export$536a5153d9b87a6b;
var $dcb29a6250bef106$export$28dc72f63d69649d;
var $dcb29a6250bef106$export$d36673c13d5182d;
var $dcb29a6250bef106$export$c96e006c7c6ab3bd;
var $dcb29a6250bef106$export$4e6f96734dfe12f4;
$dcb29a6250bef106$export$2f132e32b175f6e6 = `wtLFHW_completedAndUncompletedSprints`;
$dcb29a6250bef106$export$e509d521b99dedde = `wtLFHW_completedSprintsChunk`;
$dcb29a6250bef106$export$82eb6504f7db5235 = `wtLFHW_externalSprint`;
$dcb29a6250bef106$export$657f3f84e37b3aed = `wtLFHW_externalSprintLozenge`;
$dcb29a6250bef106$export$536a5153d9b87a6b = `wtLFHW_externalSprintText`;
$dcb29a6250bef106$export$28dc72f63d69649d = `wtLFHW_menuLabelDisabled`;
$dcb29a6250bef106$export$d36673c13d5182d = `wtLFHW_sprintTitle`;
$dcb29a6250bef106$export$c96e006c7c6ab3bd = `wtLFHW_sprintTitlePrefix`;
$dcb29a6250bef106$export$4e6f96734dfe12f4 = `wtLFHW_tooltip`;

});


parcelRegister("9pXbZ", function(module, exports) {

$parcel$export(module.exports, "tooltip", () => $6db45d38c20c62c4$export$4e6f96734dfe12f4, (v) => $6db45d38c20c62c4$export$4e6f96734dfe12f4 = v);
var $6db45d38c20c62c4$export$4e6f96734dfe12f4;
$6db45d38c20c62c4$export$4e6f96734dfe12f4 = `qWxvNa_tooltip`;

});

const $b44ee846994766e8$export$b549cc58e415d416 = 'sprint';


parcelRegister("3FhcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a21f745df4b0ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gbNhI = parcelRequire("gbNhI");

var $jmuk1 = parcelRequire("jmuk1");
const $08a21f745df4b0ea$var$SprintWireframe = (props)=>{
    const { issue: { optimized: optimized, sprint: sprint }, showOptimizations: showOptimizations, sprints: sprints } = props;
    const sprintId = showOptimizations === true && optimized && optimized.sprint ? optimized.sprint : sprint;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
        content: (0, $jmuk1.getSprintName)(sprintId, sprints)
    });
};
var $08a21f745df4b0ea$export$2e2bcd8739ae039 = $08a21f745df4b0ea$var$SprintWireframe;

});



parcelRegister("g7qnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b38845524a1d21$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ixyEl = parcelRequire("ixyEl");

var $2k5NA = parcelRequire("2k5NA");

var $eXmzI = parcelRequire("eXmzI");
var $92b38845524a1d21$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2k5NA.default), (0, $ixyEl.default))((0, $eXmzI.default));

});
parcelRegister("ixyEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe711d3ce1d44df2$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe711d3ce1d44df2$export$2e2bcd8739ae039 = (dispatch)=>({
        onChange: (issue, team)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                team: team
            }));
        }
    });

});

parcelRegister("2k5NA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7485ba927a17a5$export$2e2bcd8739ae039);
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $7CnHa = parcelRequire("7CnHa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f7485ba927a17a5$export$2e2bcd8739ae039 = (state, props)=>({
        teams: (0, $MQRDu.getExistingTeams)(state),
        allTeams: (0, $MQRDu.getAllExistingTeams)(state),
        scenarioRemovedShareTeams: (0, $MQRDu.getScenarioRemovedShareTeams)(state),
        additionalTeamsById: (0, $MQRDu.getAdditionalTeamsById)(state),
        sprintsForTeam: (0, $c1XMU.getSprintsForTeam)(state),
        teamRollUpForIssue: (0, $7CnHa.isDefined)((0, $aK3ri.getRollupMap)(state)[props.issue.id]) ? (0, $aK3ri.getRollupMap)(state)[props.issue.id].team : null,
        useTwpTeams: !!(0, $75KhQ.getPlan)(state).useTwpTeams
    });

});

parcelRegister("eXmzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7de5eeb396a57cb0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kDrtX = parcelRequire("kDrtX");
var $f7Op5 = parcelRequire("f7Op5");
var $l7xwn = parcelRequire("l7xwn");

var $iJlfe = parcelRequire("iJlfe");

var $4nce6 = parcelRequire("4nce6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $ffiyv = parcelRequire("ffiyv");
var $jQxSL = parcelRequire("jQxSL");
var $akSC8 = parcelRequire("akSC8");
var $gbNhI = parcelRequire("gbNhI");
var $8YqJS = parcelRequire("8YqJS");
var $gwbfD = parcelRequire("gwbfD");

var $cc2RB = parcelRequire("cc2RB");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $8CXDT = parcelRequire("8CXDT");

var $57dZR = parcelRequire("57dZR");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $a6gTE = parcelRequire("a6gTE");

var $9tPF9 = parcelRequire("9tPF9");
const $7de5eeb396a57cb0$var$getTeamName = (teamId, teams)=>{
    if (!(0, $7CnHa.isDefined)(teamId) || !(0, $7CnHa.isDefined)(teams)) return '';
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const team = teams.find((team)=>team.id === teamId);
    if (team !== undefined && team !== null) return team.title;
    return '';
};
const $7de5eeb396a57cb0$var$getNoTeamAvatar = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9tPF9.defaultTeamAvatarOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: "",
        primaryColor: `var(--ds-icon, ${(0, $g4Vkx.default).N800})`,
        size: "small"
    }));
const $7de5eeb396a57cb0$var$getTeamAvatar = (teamId, teams)=>{
    if (!(0, $7CnHa.isDefined)(teamId) || !(0, $7CnHa.isDefined)(teams)) return $7de5eeb396a57cb0$var$getNoTeamAvatar();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const team = teams.find((team)=>team.id === teamId);
    if (team !== undefined && team !== null && team.avatarUrl) return team.avatarUrl;
    return $7de5eeb396a57cb0$var$getNoTeamAvatar();
};
const $7de5eeb396a57cb0$var$isPlanOnlyTeam = (teamId, teams)=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const team = teams.find((team)=>team.id === teamId);
    if (team !== undefined && team !== null) return !team.shareable;
    return true;
};
const $7de5eeb396a57cb0$export$409850a8a9c79192 = ({ onChange: onChange, issue: issue })=>(selection)=>{
        if (selection && typeof selection.value === 'string') {
            const newTeamId = selection.value;
            onChange(issue, newTeamId);
        } else onChange(issue, undefined);
    };
const $7de5eeb396a57cb0$export$2ea8e60ef5e5f6ad = ({ showOptimizations: showOptimizations = false, issue: issue, onChange: onChange, CellSelectWithRollup: CellSelectWithRollup, isScrolling: isScrolling, teams: teams, allTeams: allTeams, scenarioRemovedShareTeams: scenarioRemovedShareTeams, teamRollUpForIssue: teamRollUpForIssue, isReadOnly: isReadOnly = false, additionalTeamsById: additionalTeamsById, useTwpTeams: useTwpTeams = false })=>{
    const attribute = 'team';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleSelection = $7de5eeb396a57cb0$export$409850a8a9c79192({
        onChange: onChange,
        issue: issue
    });
    const isAdditionalTeam = (teamId)=>!$kDrtX.default((additionalTeamsById || {})[teamId]) || scenarioRemovedShareTeams.filter((team)=>team.id === teamId).length > 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSingleValue = ({ children: children, ...rest })=>// @ts-expect-error - TS2604 - JSX element type 'selectComponents.SingleValue' does not have any construct or call signatures.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, rest, children);
    const getTeamOptionLabelWithLozenge = (label, icon, teamType)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: !icon ? $9tPF9.optionNoAvatarWrapper : $9tPF9.optionWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: !icon ? '' : $9tPF9.externalValueWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9tPF9.teamAvatarItem
        }, !icon ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9tPF9.defaultTeamAvatarValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            label: "",
            primaryColor: `var(--ds-icon, ${(0, $g4Vkx.default).N800})`,
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "small",
            src: icon
        }), label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $9tPF9.externalLozenge,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onFocus: ()=>{},
            onMouseOver: (e)=>e.stopPropagation()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9tPF9.tooltip
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalTeamTooltipTitle : (0, $cc2RB.default).planOnlyTeamTooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalTeamTooltipContent : (0, $cc2RB.default).planOnlyTeamTooltipContent)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalLozengeShort : (0, $cc2RB.default).planOnlyLozenge)))));
    // delete this function including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    const getTeamLozengeOld = (label, teamType)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9tPF9.optionWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9tPF9.externalValueWrapper
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $9tPF9.externalLozenge,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onFocus: ()=>{},
            onMouseOver: (e)=>e.stopPropagation()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9tPF9.tooltip
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalTeamTooltipTitle : (0, $cc2RB.default).planOnlyTeamTooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalTeamTooltipContent : (0, $cc2RB.default).planOnlyTeamTooltipContent)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage(teamType === 'external' ? (0, $cc2RB.default).externalLozengeShort : (0, $cc2RB.default).planOnlyLozenge)))));
    const formatOptionLabel = (opt, { context: context })=>{
        if ((0, $430Oj.default)() && useTwpTeams) {
            if (context === 'value') {
                if (opt.isExternalTeam) return getTeamOptionLabelWithLozenge(opt.label, opt.icon, 'external');
                if (opt.isPlanOnlyTeam) return getTeamOptionLabelWithLozenge(opt.label, opt.icon, 'planOnly');
                if (!opt.icon) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $9tPF9.teamAvatarItem
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $9tPF9.defaultTeamAvatarValue
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                    label: "",
                    primaryColor: `var(--ds-icon, ${(0, $g4Vkx.default).N800})`,
                    size: "small"
                })), opt.label));
                return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $9tPF9.teamAvatarItem
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                    size: "small",
                    src: opt.icon
                }), opt.label));
            }
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9tPF9.selectOption
            }, !opt.icon ? $7de5eeb396a57cb0$var$getNoTeamAvatar() : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9tPF9.avatar
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: opt.icon
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9tPF9.label
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $9tPF9.truncated
            }, opt.label))));
        }
        // delete this code block when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
        // From here ...
        if (context === 'value') {
            if (opt.isExternalTeam) return getTeamLozengeOld(opt.label, 'external');
            if (opt.isPlanOnlyTeam) return getTeamLozengeOld(opt.label, 'planOnly');
            return opt.label;
        }
        return (0, $akSC8.selectOptionWithAvatar)(opt);
    // To here ...
    };
    const select = ()=>{
        const { level: level, summary: summary, team: team } = issue;
        const options = teams.map(({ id: id, title: title, avatarUrl: avatarUrl })=>({
                value: id,
                label: title,
                icon: avatarUrl,
                isPlanOnlyTeam: $7de5eeb396a57cb0$var$isPlanOnlyTeam(id, allTeams)
            }));
        let id = team;
        if (showOptimizations === true) id = (0, $57dZR.getOptimizedValue)(issue, attribute);
        let value = options.find((option)=>option.value === id);
        if (!value && id !== null && id !== undefined) value = {
            // delete this condition including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
            ...(0, $430Oj.default)() && useTwpTeams && {
                icon: $7de5eeb396a57cb0$var$getTeamAvatar(id, allTeams.concat(scenarioRemovedShareTeams))
            },
            label: $7de5eeb396a57cb0$var$getTeamName(id, allTeams.concat(scenarioRemovedShareTeams)),
            value: id,
            isExternalTeam: isAdditionalTeam(id || '')
        };
        const isIssueASubtask = level === (0, $8YqJS.SUB_TASK_LEVEL);
        const isSelectReadOnly = isIssueASubtask || isReadOnly;
        const allTeamsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), allTeams.concat(scenarioRemovedShareTeams));
        const rolledUpValues = $l7xwn.default((a, b)=>a.localeCompare(b), (teamRollUpForIssue || []).map((t)=>allTeamsById[t].title));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CellSelectWithRollup, {
            "aria-label": formatMessage({
                ...(0, $a6gTE.default).teamSelectorLabel
            }, {
                issue: summary
            }),
            attribute: attribute,
            components: {
                SingleValue: getSingleValue
            },
            // eslint-disable-next-line @typescript-eslint/no-shadow
            formatOptionLabel: (opt, value)=>formatOptionLabel(opt, value),
            isClearable: true,
            isDisabled: isSelectReadOnly,
            issueId: issue.id,
            onChange: (selection)=>handleSelection(selection),
            options: options,
            placeholder: formatMessage((0, $a6gTE.default).placeholder),
            rolledUpValues: rolledUpValues,
            value: value === undefined ? null : value
        });
    };
    const selectWithTooltip = ()=>{
        const tooltipContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9tPF9.tooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, formatMessage((0, $a6gTE.default).issueIsSubtaskHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $a6gTE.default).issueIsSubtaskContent)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: tooltipContent
        }, select());
    };
    const component = ()=>{
        const { level: level } = issue;
        const mapTeamIdToTitle = (_, value)=>$7de5eeb396a57cb0$var$getTeamName(value, allTeams.concat(scenarioRemovedShareTeams));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
            attribute: attribute,
            issue: issue,
            valueMapper: mapTeamIdToTitle,
            isScrolling: isScrolling,
            showOptimizations: showOptimizations
        }, level === (0, $8YqJS.SUB_TASK_LEVEL) ? selectWithTooltip() : select());
    };
    const wireframe = ()=>{
        const { optimized: optimized } = issue;
        const team = showOptimizations === true && optimized && optimized.team ? optimized.team : issue.team;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
            content: $7de5eeb396a57cb0$var$getTeamName(team, allTeams.concat(scenarioRemovedShareTeams)),
            isReadOnly: showOptimizations
        });
    };
    return isScrolling ? wireframe() : component();
};
var $7de5eeb396a57cb0$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    CellSelectWithRollup: (0, $a4vO3.slots).CellSelectWithRollup
})($7de5eeb396a57cb0$export$2ea8e60ef5e5f6ad);

});
parcelRegister("cc2RB", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb8c719eb2d2f22$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $abb8c719eb2d2f22$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalLozengeShort: {
        "id": "portfolio-3-plan-increment-common.external-lozenge-short",
        "defaultMessage": "EXT"
    },
    externalLozenge: {
        "id": "portfolio-3-plan-increment-common.external-lozenge",
        "defaultMessage": "EXTERNAL"
    },
    externalTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-title",
        "defaultMessage": "Team currently not in this plan"
    },
    externalTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-content",
        "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
    },
    planOnlyLozenge: {
        "id": "portfolio-3-plan-increment-common.plan-only-lozenge",
        "defaultMessage": "PLAN-ONLY"
    },
    planOnlyTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-title",
        "defaultMessage": "Plan-only team"
    },
    planOnlyTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content",
        "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
    },
    kanbanLozenge: {
        "id": "portfolio-3-plan-increment-common.kanban-lozenge",
        "defaultMessage": "KANBAN"
    }
});

});

parcelRegister("a6gTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c0db18d5aa6159$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $12c0db18d5aa6159$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.placeholder",
        "defaultMessage": "Choose a team"
    },
    teamSelectorLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.team-selector-label",
        "defaultMessage": "Choose team for issue {issue}"
    },
    issueIsSubtaskHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.issue-is-subtask-header",
        "defaultMessage": "Cannot change the team of sub-tasks"
    },
    issueIsSubtaskContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.issue-is-subtask-content",
        "defaultMessage": "A sub-task is assigned to the same team as its parent story. To change this team, reassign the parent story instead."
    },
    externalTeamTooltipTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.external-team-tooltip-title",
        "defaultMessage": "Team currently not in this plan"
    },
    externalTeamTooltipContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.team.external-team-tooltip-content",
        "defaultMessage": "While this team isn't in this plan, it's appearing because it's assigned to issues in the plan."
    }
});

});

parcelRegister("9tPF9", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $6e6ee5a0816b749b$export$345c5736c8054f22, (v) => $6e6ee5a0816b749b$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "defaultTeamAvatarOption", () => $6e6ee5a0816b749b$export$18910258f760a2fd, (v) => $6e6ee5a0816b749b$export$18910258f760a2fd = v);
$parcel$export(module.exports, "defaultTeamAvatarValue", () => $6e6ee5a0816b749b$export$ca1b754e4b55ac4c, (v) => $6e6ee5a0816b749b$export$ca1b754e4b55ac4c = v);
$parcel$export(module.exports, "externalLozenge", () => $6e6ee5a0816b749b$export$b23bb0784f4cf7e6, (v) => $6e6ee5a0816b749b$export$b23bb0784f4cf7e6 = v);
$parcel$export(module.exports, "externalValueWrapper", () => $6e6ee5a0816b749b$export$5c84e7cc2d29d1d1, (v) => $6e6ee5a0816b749b$export$5c84e7cc2d29d1d1 = v);
$parcel$export(module.exports, "label", () => $6e6ee5a0816b749b$export$1237798dc640739a, (v) => $6e6ee5a0816b749b$export$1237798dc640739a = v);
$parcel$export(module.exports, "optionNoAvatarWrapper", () => $6e6ee5a0816b749b$export$f0d4e5c24c029a5d, (v) => $6e6ee5a0816b749b$export$f0d4e5c24c029a5d = v);
$parcel$export(module.exports, "optionWrapper", () => $6e6ee5a0816b749b$export$9651f3c45da8432f, (v) => $6e6ee5a0816b749b$export$9651f3c45da8432f = v);
$parcel$export(module.exports, "selectOption", () => $6e6ee5a0816b749b$export$f6a817e077493ad8, (v) => $6e6ee5a0816b749b$export$f6a817e077493ad8 = v);
$parcel$export(module.exports, "teamAvatarItem", () => $6e6ee5a0816b749b$export$a15af679b64a13e5, (v) => $6e6ee5a0816b749b$export$a15af679b64a13e5 = v);
$parcel$export(module.exports, "tooltip", () => $6e6ee5a0816b749b$export$4e6f96734dfe12f4, (v) => $6e6ee5a0816b749b$export$4e6f96734dfe12f4 = v);
$parcel$export(module.exports, "truncated", () => $6e6ee5a0816b749b$export$23ef198012fb7186, (v) => $6e6ee5a0816b749b$export$23ef198012fb7186 = v);
var $6e6ee5a0816b749b$export$345c5736c8054f22;
var $6e6ee5a0816b749b$export$18910258f760a2fd;
var $6e6ee5a0816b749b$export$ca1b754e4b55ac4c;
var $6e6ee5a0816b749b$export$5f60c64a1fd5f53e;
var $6e6ee5a0816b749b$export$b23bb0784f4cf7e6;
var $6e6ee5a0816b749b$export$5c84e7cc2d29d1d1;
var $6e6ee5a0816b749b$export$1237798dc640739a;
var $6e6ee5a0816b749b$export$f0d4e5c24c029a5d;
var $6e6ee5a0816b749b$export$9651f3c45da8432f;
var $6e6ee5a0816b749b$export$f6a817e077493ad8;
var $6e6ee5a0816b749b$export$a15af679b64a13e5;
var $6e6ee5a0816b749b$export$d21dcf0dd9430234;
var $6e6ee5a0816b749b$export$9f98a8d796affec6;
var $6e6ee5a0816b749b$export$4e6f96734dfe12f4;
var $6e6ee5a0816b749b$export$23ef198012fb7186;
$6e6ee5a0816b749b$export$345c5736c8054f22 = `sMSUOa_avatar`;
$6e6ee5a0816b749b$export$18910258f760a2fd = `sMSUOa_defaultTeamAvatarOption`;
$6e6ee5a0816b749b$export$ca1b754e4b55ac4c = `sMSUOa_defaultTeamAvatarValue`;
$6e6ee5a0816b749b$export$5f60c64a1fd5f53e = `sMSUOa_dropdownArrow`;
$6e6ee5a0816b749b$export$b23bb0784f4cf7e6 = `sMSUOa_externalLozenge`;
$6e6ee5a0816b749b$export$5c84e7cc2d29d1d1 = `sMSUOa_externalValueWrapper`;
$6e6ee5a0816b749b$export$1237798dc640739a = `sMSUOa_label`;
$6e6ee5a0816b749b$export$f0d4e5c24c029a5d = `sMSUOa_optionNoAvatarWrapper`;
$6e6ee5a0816b749b$export$9651f3c45da8432f = `sMSUOa_optionWrapper`;
$6e6ee5a0816b749b$export$f6a817e077493ad8 = `sMSUOa_selectOption`;
$6e6ee5a0816b749b$export$a15af679b64a13e5 = `sMSUOa_teamAvatarItem`;
$6e6ee5a0816b749b$export$d21dcf0dd9430234 = `sMSUOa_teamDropdown`;
$6e6ee5a0816b749b$export$9f98a8d796affec6 = `sMSUOa_teamName`;
$6e6ee5a0816b749b$export$4e6f96734dfe12f4 = `sMSUOa_tooltip`;
$6e6ee5a0816b749b$export$23ef198012fb7186 = `sMSUOa_truncated`;

});



parcelRegister("c3o8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a411ab5235526f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5maKH = parcelRequire("5maKH");

var $eiFag = parcelRequire("eiFag");
var $f9a411ab5235526f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5maKH.default), {})((0, $eiFag.default));

});
parcelRegister("5maKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $17168e580008c3ce$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");
const $17168e580008c3ce$var$mapStateToProps = (state)=>({
        hasAtlasPermissions: (0, $dhHiZ.getHasAtlasPermissions)(state)
    });
var $17168e580008c3ce$export$2e2bcd8739ae039 = $17168e580008c3ce$var$mapStateToProps;

});

parcelRegister("eiFag", function(module, exports) {

$parcel$export(module.exports, "default", () => $56be0e433c462e8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jOdsB = parcelRequire("jOdsB");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");
var $d9epm = parcelRequire("d9epm");

var $f9uCX = parcelRequire("f9uCX");
const $56be0e433c462e8d$var$GoalHeaderPermissionCheck = ({ hasAtlasPermissions: hasAtlasPermissions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const atlasURL = `${(0, $d9epm.useTeamCentralBaseUrl)()}?cloudId=${(0, $dWLk9.useCloudId)()}`;
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    const onClickLink = (0, $eUqFw.useCallback)((_event, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'jpo-request-atlas');
        push(atlasURL);
    }, [
        push,
        atlasURL
    ]);
    if (!hasAtlasPermissions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $56be0e433c462e8d$var$boxStyles,
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOdsB.default), {
        appearance: "info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onClickLink
    }, formatMessage((0, $f9uCX.default).permissionCheckLink))));
    return null;
};
const $56be0e433c462e8d$var$boxStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});
var $56be0e433c462e8d$export$2e2bcd8739ae039 = $56be0e433c462e8d$var$GoalHeaderPermissionCheck;

});
parcelRegister("jOdsB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ceaa73c399a515a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $kDL8j = parcelRequire("kDL8j");
function $2ceaa73c399a515a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceaa73c399a515a$var$rootStyles = {
    name: "ssyr0c",
    styles: "display:inline-block;max-width:100%;&:focus{outline:1px solid;}&:hover{[data-ds--inline-message--icon]{color:var(--icon-accent-color);}[data-ds--inline-message--button]{text-decoration:underline;}}"
};
const $2ceaa73c399a515a$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B300})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G200})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P200})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y200})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R300})`;
    }
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $2ceaa73c399a515a$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', type: type = 'connectivity', appearance: appearance, children: children, testId: testId, iconLabel: iconLabel })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    if (!appearance) appearance = type;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $2ceaa73c399a515a$var$rootStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            '--icon-accent-color': $2ceaa73c399a515a$var$iconColor(appearance)
        },
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $29yDk.default), {
        onClose: onCloseDialog,
        content: children,
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--inline-dialog`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        "data-ds--inline-message--button": true,
        appearance: "subtle-link",
        onClick: toggleDialog,
        spacing: "none",
        testId: testId && `${testId}--button`,
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDL8j.default), {
        isOpen: isOpen,
        appearance: appearance,
        label: iconLabel
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.100"
    }, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        testId: testId && `${testId}--title`
    }, title), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "color.text.subtlest",
        maxLines: 1,
        testId: testId && `${testId}--text`
    }, secondaryText))))));
};
var $2ceaa73c399a515a$export$2e2bcd8739ae039 = $2ceaa73c399a515a$var$InlineMessage;

});
parcelRegister("kDL8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39338dc4e2b071$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $kAPh5 = parcelRequire("kAPh5");
function $2b39338dc4e2b071$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b39338dc4e2b071$var$iconColor = (appearance)=>{
    switch(appearance){
        case 'connectivity':
            return `var(--ds-icon-brand, ${0, $PdmhA.B400})`;
        case 'confirmation':
            return `var(--ds-icon-success, ${0, $PdmhA.G300})`;
        case 'info':
            return `var(--ds-icon-discovery, ${0, $PdmhA.P300})`;
        case 'warning':
            return `var(--ds-icon-warning, ${0, $PdmhA.Y300})`;
        case 'error':
            return `var(--ds-icon-danger, ${0, $PdmhA.R400})`;
    }
};
const $2b39338dc4e2b071$var$iconWrapperStyles = {
    name: "kw6wgo",
    styles: "display:flex;align-items:center;flex:0 0 auto;color:var(--icon-color)"
};
const $2b39338dc4e2b071$var$iconColorStyles = {
    name: "1iy94md",
    styles: "color:var(--icon-accent-color)"
};
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2b39338dc4e2b071$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $kAPh5.typesMapping);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-ds--inline-message--icon": true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--icon-color': $2b39338dc4e2b071$var$iconColor(appearance)
        },
        css: [
            $2b39338dc4e2b071$var$iconWrapperStyles,
            isOpen && $2b39338dc4e2b071$var$iconColorStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        size: "medium"
    }));
};
var $2b39338dc4e2b071$export$2e2bcd8739ae039 = $2b39338dc4e2b071$var$SelectedIcon;

});
parcelRegister("kAPh5", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $6da7ad19346443c2$export$4d111645c0b39d5d);

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");
const $6da7ad19346443c2$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("d9epm", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralUrl", () => $27fe3a2e52ea675c$export$12bf0987a96bab08);
$parcel$export(module.exports, "useTeamCentralBaseUrl", () => $27fe3a2e52ea675c$export$b49e0105c58cb761);

var $3e9vj = parcelRequire("3e9vj");
const $27fe3a2e52ea675c$export$12bf0987a96bab08 = ()=>'/gateway/api/watermelon/graphql';
const $27fe3a2e52ea675c$export$b49e0105c58cb761 = ()=>{
    const env = (0, $3e9vj.useEnvironment)();
    if (env === 'staging' || env === 'dev' || env === 'local') return 'https://team.stg.atlassian.com';
    return 'https://team.atlassian.com';
};

});
parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


parcelRegister("f9uCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc03c25bf5f0f5c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6bc03c25bf5f0f5c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    permissionCheckLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.goals.permission-check-link",
        "defaultMessage": "Request or confirm Atlas access."
    }
});

});



parcelRegister("72KE6", function(module, exports) {

$parcel$export(module.exports, "getMatchingConfiguredDate", () => $1fe117bbf237ce88$export$66903243edd3e113);
$parcel$export(module.exports, "getDefaultWidth", () => $1fe117bbf237ce88$export$ad27d04e3788b5e6);
$parcel$export(module.exports, "getMinWidth", () => $1fe117bbf237ce88$export$f556054ce4358701);

var $bOL8s = parcelRequire("bOL8s");
var $lcvrv = parcelRequire("lcvrv");

var $lf4fN = parcelRequire("lf4fN");

var $5rYNM = parcelRequire("5rYNM");
const $1fe117bbf237ce88$export$66903243edd3e113 = ({ baselineStartField: baselineStartField, baselineEndField: baselineEndField })=>(id)=>{
        if (!id) return;
        if (baselineStartField && baselineStartField.key === id) return (0, $bOL8s.ConfigurableDateTypes).start;
        if (baselineEndField && baselineEndField.key === id) return (0, $bOL8s.ConfigurableDateTypes).end;
    };
const $1fe117bbf237ce88$export$ad27d04e3788b5e6 = (id, viewMode)=>{
    const defaultWidthOfColumn = viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? (0, $lf4fN.defaultWidthOfColumnTimeline) : (0, $lf4fN.defaultWidthOfColumnList);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const columnId = id ?? 'DEFAULT';
    const columnWidth = defaultWidthOfColumn[columnId];
    return columnWidth ?? defaultWidthOfColumn.DEFAULT;
};
const $1fe117bbf237ce88$export$f556054ce4358701 = (id, isCollapsible, viewMode)=>{
    if (isCollapsible) return 24;
    if (viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE) return (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM;
    return $1fe117bbf237ce88$export$ad27d04e3788b5e6(id, viewMode);
};

});


parcelRegister("bqvI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9764bb8e4f1f85fe$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $b2GxP = parcelRequire("b2GxP");

var $hX1Ds = parcelRequire("hX1Ds");
var $9764bb8e4f1f85fe$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $b2GxP.default), {})((0, $hX1Ds.default));

});
parcelRegister("b2GxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7fc14cec4b4cede$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
const $a7fc14cec4b4cede$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    customFieldValue: (state, props)=>(0, $kKj1m.getSupportedCustomFields)(state).find((field)=>field.id.toString() === props.attribute)
});
var $a7fc14cec4b4cede$export$2e2bcd8739ae039 = $a7fc14cec4b4cede$var$querySelector;

});

parcelRegister("hX1Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $011bfa3b4ffc905b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jPCDz = parcelRequire("jPCDz");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $8CXDT = parcelRequire("8CXDT");

var $5rYNM = parcelRequire("5rYNM");

var $eHBph = parcelRequire("eHBph");

var $e9fTF = parcelRequire("e9fTF");

var $h30ns = parcelRequire("h30ns");

var $8F6lo = parcelRequire("8F6lo");

var $8IzVc = parcelRequire("8IzVc");

var $io3RO = parcelRequire("io3RO");

var $fdB97 = parcelRequire("fdB97");

var $8CRQO = parcelRequire("8CRQO");

var $dmOK7 = parcelRequire("dmOK7");
const $011bfa3b4ffc905b$export$9639a5943929d469 = (props)=>{
    const { attribute: attribute, customFieldValue: customFieldValue, isReadOnly: isReadOnly, isScrolling: isScrolling, issue: issue, showOptimizations: showOptimizations = false, TextRenderer: TextRenderer = (0, $io3RO.default) } = props;
    if (!customFieldValue) return null;
    if ((0, $dmOK7.shouldCustomFieldBeDisabledForScopedIssue)(customFieldValue, issue.type, issue.project)) // this is just a placeholder component as design is not finalised yet
    // currently return back a disabled TextField with N/A as placeholder message
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9fTF.default), {
        customField: customFieldValue,
        ...props
    });
    const customFieldType = customFieldValue.type.key;
    const content = (()=>{
        switch(customFieldType){
            case (0, $5rYNM.CustomFieldTypes).TextField:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TextRenderer, {
                    attribute: attribute,
                    issue: issue,
                    isReadOnly: isReadOnly
                });
            case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            case (0, $5rYNM.CustomFieldTypes).RadioButtons:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IzVc.default), props);
            case (0, $5rYNM.CustomFieldTypes).Labels:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h30ns.LabelRenderer), {
                    ...props,
                    useValueAsLabel: true
                });
            case (0, $5rYNM.CustomFieldTypes).MultiSelect:
            case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h30ns.default), props);
            case (0, $5rYNM.CustomFieldTypes).NumberField:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8F6lo.default), {
                    attribute: attribute,
                    issue: issue,
                    isReadOnly: isReadOnly
                });
            case (0, $5rYNM.CustomFieldTypes).DatePicker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eHBph.default), props);
            case (0, $5rYNM.CustomFieldTypes).UserPicker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CRQO.default), {
                    attribute: attribute,
                    isReadOnly: isReadOnly,
                    issue: issue,
                    isScrolling: isScrolling
                });
            case (0, $5rYNM.CustomFieldTypes).Url:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdB97.default), props);
            case (0, $5rYNM.CustomFieldTypes).AssetObject:
                // This is a permanent feature flag and its feature only enabled for our internal hello customers
                if ((0, $cofZt.default)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h30ns.default), props);
                return null;
            default:
                return null;
        }
    })();
    const isCellDirty = ()=>{
        const fieldId = attribute;
        if (issue.originals && issue.originals.customFields) return issue.originals.customFields && $jPCDz.default(fieldId, issue.originals.customFields);
        return false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CXDT.default), {
        attribute: "customFields",
        issue: issue,
        isScrolling: false,
        showOptimizations: showOptimizations,
        isCellDirty: isCellDirty
    }, content);
};
var $011bfa3b4ffc905b$export$2e2bcd8739ae039 = $011bfa3b4ffc905b$export$9639a5943929d469;

});
parcelRegister("eHBph", function(module, exports) {

$parcel$export(module.exports, "default", () => $d597d471baa101c8$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $juSsM = parcelRequire("juSsM");

var $ZRwxq = parcelRequire("ZRwxq");
var $d597d471baa101c8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $juSsM.default))((0, $ZRwxq.default));

});
parcelRegister("juSsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c13e907c598426a$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $0c13e907c598426a$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, customFieldId, customFieldValue)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: customFieldValue
                }
            }));
        }
    });
var $0c13e907c598426a$export$2e2bcd8739ae039 = $0c13e907c598426a$var$dispatchMethods;

});

parcelRegister("ZRwxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $235d17478cf84df9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $l2Sj2 = parcelRequire("l2Sj2");
var $fmBR7 = parcelRequire("fmBR7");
var $17L5s = parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");

var $a4vO3 = parcelRequire("a4vO3");

var $9QPff = parcelRequire("9QPff");

var $hbMr2 = parcelRequire("hbMr2");
const $235d17478cf84df9$export$4edff4fd0399ce6e = ({ attribute: attribute, onChange: onChange, issue: issue })=>(date)=>{
        if (date === '') return onChange(issue, attribute, undefined);
        if (!(0, $17L5s.isISOCompatible)(date)) return;
        const dateUTC = new Date(date).getTime();
        onChange(issue, attribute, dateUTC || undefined);
    };
const $235d17478cf84df9$export$5109c6dd95d8fb00 = ({ attribute: attribute, isReadOnly: isReadOnly, issue: issue, DatePicker: DatePicker, onChange: onChange })=>{
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const value = issue.customFields && issue.customFields[attribute];
    // for browser comparability (e.g Safari) we have to pass value to datepicker only ISO date format
    const dateValue = value ? (0, $l2Sj2.formatDateUTC)(parseFloat(value), (0, $eTbtL.IsoDateFormat)) : '';
    const handleOnChange = $235d17478cf84df9$export$4edff4fd0399ce6e({
        attribute: attribute,
        issue: issue,
        onChange: onChange
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: isReadOnly ? $hbMr2.isReadOnly : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
        onHoverChanged: setIsHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DatePicker, {
        isDisabled: isReadOnly,
        onChange: handleOnChange,
        placeholder: formatMessage((0, $9QPff.default).placeholder),
        styles: {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            placeholder: (styles)=>({
                    display: !isHovered && 'none',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    width: 'calc(100% - 9px)',
                    ...styles
                })
        },
        showClearIndicator: true,
        value: dateValue
    }))));
};
var $235d17478cf84df9$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    DatePicker: (0, $a4vO3.slots).FieldDatePicker
})($235d17478cf84df9$export$5109c6dd95d8fb00);

});
parcelRegister("9QPff", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e8984d5e5c2c46$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $25e8984d5e5c2c46$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.date-picker.placeholder",
        "defaultMessage": "Choose a date"
    }
});

});

parcelRegister("hbMr2", function(module, exports) {

$parcel$export(module.exports, "isReadOnly", () => $c83908f88f2dd798$export$2498094d90b6ac72, (v) => $c83908f88f2dd798$export$2498094d90b6ac72 = v);
var $c83908f88f2dd798$export$2498094d90b6ac72;
$c83908f88f2dd798$export$2498094d90b6ac72 = `_8h9bCa_isReadOnly`;

});



parcelRegister("e9fTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $44114565a4218063$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $aa9Jz = parcelRequire("aa9Jz");

var $jmNyS = parcelRequire("jmNyS");
var $44114565a4218063$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $aa9Jz.default), {})((0, $jmNyS.default));

});
parcelRegister("aa9Jz", function(module, exports) {

$parcel$export(module.exports, "default", () => $192fcf16d0397770$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $7CnHa = parcelRequire("7CnHa");
const $192fcf16d0397770$export$6919d4cc2fba73b0 = (customField, issueTypesMapById)=>customField.issueTypeIds ? customField.issueTypeIds.map((id)=>issueTypesMapById[id]?.name).filter((name)=>(0, $7CnHa.isDefined)(name)).join(', ').replace(/,([^,]*)$/, ' &$1') : '';
const $192fcf16d0397770$export$2cd058184eb75757 = (customField, projectMapById)=>{
    if (customField.projectId && projectMapById[customField.projectId]) return projectMapById[customField.projectId].name;
    return '';
};
const $192fcf16d0397770$var$mapStateToProps = (state, { customField: customField })=>({
        projectName: $192fcf16d0397770$export$2cd058184eb75757(customField, (0, $ehEr2.getProjectsById)(state)),
        issueTypeNames: $192fcf16d0397770$export$6919d4cc2fba73b0(customField, (0, $lihml.getIssueTypesById)(state))
    });
var $192fcf16d0397770$export$2e2bcd8739ae039 = $192fcf16d0397770$var$mapStateToProps;

});

parcelRegister("jmNyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fc52cf05db530c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbfD = parcelRequire("gwbfD");

var $7nZE6 = parcelRequire("7nZE6");

var $a1aWl = parcelRequire("a1aWl");
const $22fc52cf05db530c$export$efad39e5eb7ff7a3 = ({ customField: { title: title }, projectName: projectName, issueTypeNames: issueTypeNames })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $7nZE6.default).disabledScopedFieldTooltip, {
            customFieldName: title,
            projectName: projectName,
            issueTypeNames: issueTypeNames
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $a1aWl.container
    }, formatMessage((0, $7nZE6.default).disabledScopedFieldNa)));
};
var $22fc52cf05db530c$export$2e2bcd8739ae039 = $22fc52cf05db530c$export$efad39e5eb7ff7a3;

});
parcelRegister("7nZE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ffd5b7281fc75d9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ffd5b7281fc75d9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    disabledScopedFieldTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.disabled-custom-field.disabled-scoped-field-tooltip",
        "defaultMessage": "You can only apply the {customFieldName} custom field from project {projectName} to issue types: {issueTypeNames} in that project."
    },
    disabledScopedFieldNa: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.disabled-custom-field.disabled-scoped-field-na",
        "defaultMessage": "N/A"
    }
});

});

parcelRegister("a1aWl", function(module, exports) {

$parcel$export(module.exports, "container", () => $74b27bdd125eb546$export$34e0f9847d4c02dd, (v) => $74b27bdd125eb546$export$34e0f9847d4c02dd = v);
var $74b27bdd125eb546$export$34e0f9847d4c02dd;
$74b27bdd125eb546$export$34e0f9847d4c02dd = `OMlRpG_container`;

});



parcelRegister("h30ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $170b6c949e47f7ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LabelRenderer", () => $170b6c949e47f7ac$export$a36612af82a12ac0);

var $lNNXV = parcelRequire("lNNXV");

var $cVd8A = parcelRequire("cVd8A");

var $gCM04 = parcelRequire("gCM04");

var $2I4Ya = parcelRequire("2I4Ya");
var $170b6c949e47f7ac$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gCM04.default), (0, $cVd8A.default))((0, $2I4Ya.MultiSelect));
const $170b6c949e47f7ac$export$a36612af82a12ac0 = (0, $lNNXV.connect)((0, $gCM04.default), (0, $cVd8A.default))((0, $2I4Ya.Label));

});
parcelRegister("cVd8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9336c1e9b1a04ba$export$2e2bcd8739ae039);

var $cbq3D = parcelRequire("cbq3D");

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9336c1e9b1a04ba$export$2e2bcd8739ae039 = (dispatch)=>({
        onChange: (issue, customFieldId, options)=>{
            const values = (()=>{
                if (Array.isArray(options)) return options.map((option)=>option.value);
                return [];
            })();
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: values
                }
            }));
        },
        genericError: (payload)=>{
            dispatch((0, $cbq3D.genericError)(payload));
        }
    });

});

parcelRegister("gCM04", function(module, exports) {

$parcel$export(module.exports, "default", () => $f00577b5eb14c5c8$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
const $f00577b5eb14c5c8$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    selectOptions: (0, $kKj1m.getSelectOptions),
    plan: (0, $75KhQ.getPlan)
});
var $f00577b5eb14c5c8$export$2e2bcd8739ae039 = $f00577b5eb14c5c8$var$querySelector;

});

parcelRegister("2I4Ya", function(module, exports) {

$parcel$export(module.exports, "MultiSelect", () => $1358374d9a5ff6fa$export$1e7dfd31545b5809);
$parcel$export(module.exports, "Label", () => $1358374d9a5ff6fa$export$b04be29aa201d4f5);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $2C6OW = parcelRequire("2C6OW");

var $bHbrR = parcelRequire("bHbrR");

var $jTFz5 = parcelRequire("jTFz5");
const $1358374d9a5ff6fa$export$70d2bb9b72984635 = ({ issue: issue, messages: messages, attribute: attribute, isReadOnly: isReadOnly, onChange: onChange, fetchOptions: fetchOptions, useValueAsLabel: useValueAsLabel, selectOptions: selectOptions, MultiSelectCell: MultiSelectCell, menuIsOpen: menuIsOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getDisplayValue = (id)=>{
        if (useValueAsLabel === true) return id;
        const displayValue = selectOptions.find((field)=>field.id.toString() === (id && id.toString()));
        return displayValue?.value || '';
    };
    const getValues = ()=>{
        const values = issue.customFields && issue.customFields[attribute] || [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return values.map((value)=>({
                label: getDisplayValue(value),
                value: value
            }));
    };
    const formattedMessages = (0, $eUqFw.useMemo)(()=>{
        const result = {};
        for (const [key, v] of Object.entries(messages)){
            const formattedMessage = formatMessage(v);
            result[key] = formattedMessage;
        }
        return result;
    }, [
        messages,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiSelectCell, {
        menuIsOpen: menuIsOpen,
        attribute: attribute,
        issue: issue,
        isReadOnly: isReadOnly,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        messages: formattedMessages,
        getValues: getValues,
        fetchOptions: (query)=>(0, $7CnHa.isDefined)(fetchOptions) && fetchOptions(attribute, issue.project, issue.type.toString(), query),
        isDisabled: false,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        onChange: (issue, options)=>onChange(issue, attribute, options)
    });
};
const $1358374d9a5ff6fa$export$1e7dfd31545b5809 = (0, $bHbrR.OptionsProvider)((0, $a4vO3.withSlots)({
    MultiSelectCell: (0, $a4vO3.slots).FieldMultiSelectCell
})($1358374d9a5ff6fa$export$70d2bb9b72984635));
const $1358374d9a5ff6fa$export$a36612af82a12ac0 = (props)=>{
    const { attribute: attribute, issue: issue, fetchOptions: fetchOptions, onChange: onChange } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getValues = (issue, attribute)=>{
        const values = issue.customFields && issue.customFields[attribute] || [];
        return values.map((value)=>({
                label: value,
                value: value
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2C6OW.default), {
        ...props,
        getValues: getValues,
        fetchOptions: (query)=>{
            if (fetchOptions !== undefined) return fetchOptions(attribute, issue.project, issue.type.toString(), query);
        },
        // eslint-disable-next-line @typescript-eslint/no-shadow
        onChange: (issue, labels)=>onChange(issue, attribute, labels)
    });
};
const $1358374d9a5ff6fa$var$LabelComponent = (0, $jTFz5.default)((0, $a4vO3.withSlots)({
    MultiSelectCell: (0, $a4vO3.slots).FieldMultiSelectCell
})($1358374d9a5ff6fa$export$a36612af82a12ac0));
const $1358374d9a5ff6fa$export$b04be29aa201d4f5 = $1358374d9a5ff6fa$var$LabelComponent;

});
parcelRegister("bHbrR", function(module, exports) {

$parcel$export(module.exports, "OptionsProvider", () => $f21814400d1f2106$export$1238f6fc6d9e005a);

var $eUqFw = parcelRequire("eUqFw");

var $9foZI = parcelRequire("9foZI");

var $5rVFi = parcelRequire("5rVFi");

var $cUtBl = parcelRequire("cUtBl");
const $f21814400d1f2106$export$abbf91d37f1b4230 = {
    placeholder: (0, $cUtBl.default).componentsLabel,
    noLabels: (0, $cUtBl.default).noLabels,
    noLabelsLeft: (0, $cUtBl.default).noLabelsLeft,
    noMatch: (0, $cUtBl.default).noMatch
};
const $f21814400d1f2106$export$1238f6fc6d9e005a = (ComposedComponent)=>function(props) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const fetchOptions = (0, $eUqFw.useCallback)((customFieldId, projectId, issueTypeId)=>(0, $5rVFi.default)((0, $9foZI.urls).getCustomFieldSettableOptions, {
                method: 'POST',
                body: {
                    customFieldId: customFieldId,
                    projectId: projectId,
                    issueTypeId: issueTypeId
                }
            }).then((response)=>response.json()).then((data)=>data.map(({ id: id, value: value })=>({
                        value: String(id),
                        label: value
                    }))), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComposedComponent, {
            ...props,
            fetchOptions: fetchOptions,
            messages: $f21814400d1f2106$export$abbf91d37f1b4230
        });
    };

});
parcelRegister("9foZI", function(module, exports) {

$parcel$export(module.exports, "urls", () => $b926cfe0c6b66461$export$bcae9ba627f604b6);
$parcel$export(module.exports, "getAddCustomFieldsBody", () => $b926cfe0c6b66461$export$8a6e7a2ddfd84e7f);
$parcel$export(module.exports, "getUpdateCustomFieldsBody", () => $b926cfe0c6b66461$export$4eb083e76e90dd2);
$parcel$export(module.exports, "getLabelForFieldBody", () => $b926cfe0c6b66461$export$53875b0a840a0df2);
$parcel$export(module.exports, "getRemoveCustomFieldBody", () => $b926cfe0c6b66461$export$ac79055f4767d6df);
$parcel$export(module.exports, "getCustomFieldVisibleOptionsBody", () => $b926cfe0c6b66461$export$56d9dae1feb647fe);
$parcel$export(module.exports, "getUserPickerCustomFieldOptionsBody", () => $b926cfe0c6b66461$export$6f822a48b243bbd);
const $b926cfe0c6b66461$export$bcae9ba627f604b6 = {
    addCustomFields: '/rest/jpo/1.0/customfield/add',
    removeCustomField: '/rest/jpo/1.0/customfield/delete',
    getCustomFieldSettableOptions: '/rest/jpo/1.0/customfield/getSettableOptions',
    getCustomFieldVisibleOptions: '/rest/jpo/1.0/customfield/getVisibleOptions',
    getUserPickerCustomFieldOptions: '/rest/teams/1.0/persons/find',
    getDateFields: Object.assign((planId)=>`/rest/jpo/1.0/plans/${planId}/datefields`, {
        // To use as a key for profiling.
        endpoint: '/rest/jpo/1.0/plans/:id/datefields'
    }),
    updateCustomField: '/rest/jpo/1.0/customfield/update',
    labels: '/rest/jpo/1.0/labels'
};
const $b926cfe0c6b66461$export$8a6e7a2ddfd84e7f = (planId, planCustomFields)=>({
        planId: planId,
        planCustomFields: planCustomFields
    });
const $b926cfe0c6b66461$export$4eb083e76e90dd2 = $b926cfe0c6b66461$export$8a6e7a2ddfd84e7f;
const $b926cfe0c6b66461$export$53875b0a840a0df2 = (planId, customFieldId, scenarioId)=>({
        planId: planId,
        customFieldId: `${customFieldId}`,
        ...scenarioId && {
            scenarioId: scenarioId
        }
    });
const $b926cfe0c6b66461$export$ac79055f4767d6df = (planId, scenarioId, customFieldId)=>({
        planId: planId,
        scenarioId: scenarioId,
        customFieldIds: [
            customFieldId
        ]
    });
const $b926cfe0c6b66461$export$56d9dae1feb647fe = (customFieldIds, projectIds)=>({
        customFieldIds: customFieldIds,
        projectIds: projectIds
    });
const $b926cfe0c6b66461$export$6f822a48b243bbd = ({ query: query = '', excludedIds: excludedIds = [], maxResults: maxResults = 50 })=>({
        query: query,
        excludedIds: excludedIds,
        maxResults: maxResults
    });

});

parcelRegister("cUtBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ae2a8dd08382d6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $54ae2a8dd08382d6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.components-label",
        "defaultMessage": "Choose an\xA0option"
    },
    noLabels: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-labels",
        "defaultMessage": "There are no options for this custom field"
    },
    noLabelsLeft: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-labels-left",
        "defaultMessage": "No available options left"
    },
    noMatch: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.multi-select.no-match",
        "defaultMessage": "No results match your search"
    }
});

});


parcelRegister("jTFz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec652005b37b46e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $2jLDV = parcelRequire("2jLDV");
const $6ec652005b37b46e$var$messageDescriptors = {
    placeholder: (0, $2jLDV.default).chooseLabel,
    noLabels: (0, $2jLDV.default).noLabels,
    noLabelsLeft: (0, $2jLDV.default).noLabelsLeft,
    noMatch: (0, $2jLDV.default).noMatch
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ec652005b37b46e$export$2e2bcd8739ae039 = (ComposedComponent)=>function(props) {
        const fetchOptions = (0, $eUqFw.useCallback)((customFieldId, _, _2, query = '')=>{
            const { plan: plan, genericError: genericError } = props;
            if (!(0, $7CnHa.isDefined)(plan.id)) {
                genericError({
                    message: 'Plan id is not available in the options provider label'
                });
                return Promise.reject('Plan id is not available');
            }
            if (!(0, $7CnHa.isDefined)(plan.currentScenarioId)) {
                genericError({
                    message: 'Scenario id is not available in the options provider label'
                });
                return Promise.reject('Scenario id is not available');
            }
            const body = {
                planId: plan.id,
                customFieldId: customFieldId,
                query: query,
                scenarioId: plan.currentScenarioId
            };
            return (0, $5rVFi.default)('/rest/jpo/1.0/labels', {
                method: 'POST',
                body: body
            }).then((response)=>{
                if (response.ok) return response.json();
                throw new Error(`Response not ok. Statuscode: ${response.status}`);
            }).then((data)=>data.items.map((value)=>({
                        label: value,
                        value: value
                    }))).catch((err)=>{
                genericError({
                    message: err.message,
                    stackTrace: err.stack
                });
            });
        }, [
            props
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComposedComponent, {
            ...props,
            fetchOptions: fetchOptions,
            messages: $6ec652005b37b46e$var$messageDescriptors
        });
    };

});



parcelRegister("8F6lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e4d751107c17bbb$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4mo33 = parcelRequire("4mo33");

var $04Kxf = parcelRequire("04Kxf");
var $5e4d751107c17bbb$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $4mo33.default))((0, $04Kxf.default));

});
parcelRegister("4mo33", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc52e76d8616902$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");

var $7CnHa = parcelRequire("7CnHa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc52e76d8616902$export$2e2bcd8739ae039 = (dispatch)=>({
        onChange: (issue, customFieldId, value)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: (0, $7CnHa.isDefined)(value) ? value : undefined
                }
            }));
        }
    });

});

parcelRegister("04Kxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $678092c8e2f99f2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $1u8Bk = parcelRequire("1u8Bk");
const $678092c8e2f99f2a$export$a303e10ced124537 = ({ isReadOnly: isReadOnly, attribute: attribute, onChange: onChange, issue: issue })=>(value)=>{
        if (isReadOnly) return;
        const numberValue = Number(value);
        onChange(issue, attribute, Number.isNaN(numberValue) || !Number.isFinite(numberValue) ? null : numberValue);
    };
const $678092c8e2f99f2a$export$db41933ce0e4f8c3 = ({ attribute: attribute, issue: issue, onChange: onChange, isReadOnly: isReadOnly, TextField: TextField })=>{
    const [textValue, setTextValue] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (attribute && issue && textValue == null) {
            const customerFieldValue = issue.customFields && issue.customFields[attribute];
            setTextValue({
                textValue: (0, $7CnHa.isDefined)(customerFieldValue) ? customerFieldValue : ''
            });
        } else setTextValue(null);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        attribute,
        issue
    ]);
    const saveValue = $678092c8e2f99f2a$export$a303e10ced124537({
        isReadOnly: isReadOnly,
        attribute: attribute,
        issue: issue,
        onChange: onChange
    });
    const getValue = ()=>{
        const customerFieldValue = issue.customFields && issue.customFields[attribute];
        return (0, $7CnHa.isDefined)(customerFieldValue) ? customerFieldValue : '';
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$1u8Bk.textFieldWrapper} ${isReadOnly ? $1u8Bk.readOnly : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TextField, {
        isAlignRight: true,
        isReadOnly: isReadOnly,
        isTransparentBackground: true,
        onDone: saveValue,
        type: "number",
        value: getValue()
    })));
};
var $678092c8e2f99f2a$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    TextField: (0, $a4vO3.slots).CellTextField
})($678092c8e2f99f2a$export$db41933ce0e4f8c3);

});
parcelRegister("1u8Bk", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $114f43cdb917f503$export$b2cbc93d4da94977, (v) => $114f43cdb917f503$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "textFieldWrapper", () => $114f43cdb917f503$export$7910eaff0a3df2fc, (v) => $114f43cdb917f503$export$7910eaff0a3df2fc = v);
var $114f43cdb917f503$export$b2cbc93d4da94977;
var $114f43cdb917f503$export$7910eaff0a3df2fc;
$114f43cdb917f503$export$b2cbc93d4da94977 = `lBMG-a_readOnly`;
$114f43cdb917f503$export$7910eaff0a3df2fc = `lBMG-a_textFieldWrapper`;

});



parcelRegister("8IzVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d0a4f767b3bada$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jDISv = parcelRequire("jDISv");

var $49Hss = parcelRequire("49Hss");

var $4zqs8 = parcelRequire("4zqs8");
var $98d0a4f767b3bada$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $49Hss.default), (0, $jDISv.default))((0, $4zqs8.default));

});
parcelRegister("jDISv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f95c0820c7e1801b$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $f95c0820c7e1801b$var$dispatchMethods = (dispatch)=>({
        onChange: (issue, customFieldId, option)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: option ? option.value : undefined
                }
            }));
        }
    });
var $f95c0820c7e1801b$export$2e2bcd8739ae039 = $f95c0820c7e1801b$var$dispatchMethods;

});

parcelRegister("49Hss", function(module, exports) {

$parcel$export(module.exports, "default", () => $334593640f5aec00$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");
const $334593640f5aec00$var$mapStateToProps = (state, { issue: issue, attribute: attribute })=>{
    const customFieldId = Number(attribute);
    const attrValue = issue.customFields && issue.customFields[attribute] && Number(issue.customFields[attribute]);
    const selectedOption = (0, $kKj1m.getSelectOptions)(state).find((option)=>option.fieldId === customFieldId && Number(option.id) === attrValue);
    return {
        selectedOption: selectedOption
    };
};
var $334593640f5aec00$export$2e2bcd8739ae039 = $334593640f5aec00$var$mapStateToProps;

});

parcelRegister("4zqs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a3013e57503525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4vO3 = parcelRequire("a4vO3");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $dKmVn = parcelRequire("dKmVn");

var $9XyJ9 = parcelRequire("9XyJ9");

var $gQnsI = parcelRequire("gQnsI");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $56a3013e57503525$var$toOption = (data)=>({
        value: String(data.id),
        label: data.value
    });
const $56a3013e57503525$export$2cc36d93c89f0c53 = ({ FieldSelect: FieldSelect, isReadOnly: isReadOnly, selectedOption: selectedOption, issue: issue, attribute: attribute, onChange: onChange, fetchOptions: fetchOptions })=>{
    const [options, setOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const value = selectedOption && $56a3013e57503525$var$toOption(selectedOption);
    const handleFetchOptions = ()=>{
        setIsLoading(true);
        fetchOptions(attribute, issue.project, issue.type.toString()).then((data)=>data.map($56a3013e57503525$var$toOption))// eslint-disable-next-line @typescript-eslint/no-shadow
        .then((options)=>{
            setOptions(options);
            setIsLoading(false);
        });
    };
    const handleSelectionChange = (option)=>{
        onChange(issue, attribute, option);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: isReadOnly ? $gQnsI.readOnly : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldSelect, {
        isLoading: isLoading,
        isClearable: (0, $7CnHa.isDefined)(value),
        isDisabled: isReadOnly,
        isSearchable: false,
        isTransparentBackground: true,
        menuPlacement: "auto",
        menuPortalTarget: (0, $1ni3W.getBody)(),
        minSelectWidth: (0, $2LimL.MIN_SELECT_WIDTH),
        onChange: handleSelectionChange,
        onMenuOpen: handleFetchOptions,
        options: options,
        placeholder: formatMessage((0, $dKmVn.default).placeholder),
        scrollLock: true,
        value: value,
        issueId: issue.id,
        attribute: attribute
    })));
};
const $56a3013e57503525$export$5a85d25d3071ae48 = (0, $9XyJ9.default)($56a3013e57503525$export$2cc36d93c89f0c53);
var $56a3013e57503525$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    FieldSelect: (0, $a4vO3.slots).FieldSelect
})($56a3013e57503525$export$5a85d25d3071ae48);

});
parcelRegister("dKmVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a1f8cfa1cbfefc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c1a1f8cfa1cbfefc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.single-select.placeholder",
        "defaultMessage": "Choose an option"
    }
});

});

parcelRegister("9XyJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c159cab1ffa08f59$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9foZI = parcelRequire("9foZI");

var $5rVFi = parcelRequire("5rVFi");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c159cab1ffa08f59$export$2e2bcd8739ae039 = (ComposedComponent)=>// eslint-disable-next-line jira/react/no-class-components
    class extends (0, $eUqFw.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComposedComponent, {
                ...this.props,
                fetchOptions: this.fetchOptions
            });
        }
        constructor(...args){
            super(...args);
            this.fetchOptions = (customFieldId, projectId, issueTypeId)=>(0, $5rVFi.default)((0, $9foZI.urls).getCustomFieldSettableOptions, {
                    method: 'POST',
                    body: {
                        customFieldId: customFieldId,
                        projectId: projectId,
                        issueTypeId: issueTypeId
                    }
                }).then((response)=>response.json());
        }
    };

});

parcelRegister("gQnsI", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $c433b3c0dae40b0f$export$b2cbc93d4da94977, (v) => $c433b3c0dae40b0f$export$b2cbc93d4da94977 = v);
var $c433b3c0dae40b0f$export$b2cbc93d4da94977;
$c433b3c0dae40b0f$export$b2cbc93d4da94977 = `Z1ySdG_readOnly`;

});



parcelRegister("io3RO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5baf4f3bc6b5690f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bPIWn = parcelRequire("bPIWn");

var $dS1Ys = parcelRequire("dS1Ys");
var $5baf4f3bc6b5690f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $bPIWn.default))((0, $dS1Ys.default));

});
parcelRegister("bPIWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $534c36411a34e8e2$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$534c36411a34e8e2$export$2e2bcd8739ae039 = (dispatch)=>({
        onChange: (issue, customFieldId, customFieldValue)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: customFieldValue
                }
            }));
        }
    });

});

parcelRegister("dS1Ys", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fbbe155199f7fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a4vO3 = parcelRequire("a4vO3");

var $kormK = parcelRequire("kormK");
const $01fbbe155199f7fd$export$cc29b30a97a1a24b = ({ attribute: attribute, isReadOnly: isReadOnly, issue: issue, TextField: TextField, onChange: onChange })=>{
    const handleBlur = (event)=>{
        if (isReadOnly) return;
        if (event.target instanceof HTMLInputElement) onChange(issue, attribute, event.target.value);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$kormK.textFieldWrapper} ${isReadOnly ? $kormK.readOnly : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TextField, {
        isReadOnly: isReadOnly,
        isTransparentBackground: true,
        maxLength: 255,
        onBlur: handleBlur,
        type: "text",
        value: issue.customFields && issue.customFields[attribute]
    })));
};
var $01fbbe155199f7fd$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    TextField: (0, $a4vO3.slots).CellTextField
})($01fbbe155199f7fd$export$cc29b30a97a1a24b);

});
parcelRegister("kormK", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $ed8b46d950d8353b$export$b2cbc93d4da94977, (v) => $ed8b46d950d8353b$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "textFieldWrapper", () => $ed8b46d950d8353b$export$7910eaff0a3df2fc, (v) => $ed8b46d950d8353b$export$7910eaff0a3df2fc = v);
var $ed8b46d950d8353b$export$b2cbc93d4da94977;
var $ed8b46d950d8353b$export$7910eaff0a3df2fc;
$ed8b46d950d8353b$export$b2cbc93d4da94977 = `GgqE6a_readOnly`;
$ed8b46d950d8353b$export$7910eaff0a3df2fc = `GgqE6a_textFieldWrapper`;

});



parcelRegister("fdB97", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c8dcd2c568b655$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gwbfD = parcelRequire("gwbfD");

var $gVHbL = parcelRequire("gVHbL");
const $c2c8dcd2c568b655$export$a540001a865aece7 = ({ issue: issue, attribute: attribute })=>{
    const value = issue.customFields && issue.customFields[attribute];
    if (!value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, value)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gVHbL.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, value)));
};
var $c2c8dcd2c568b655$export$2e2bcd8739ae039 = $c2c8dcd2c568b655$export$a540001a865aece7;

});
parcelRegister("gVHbL", function(module, exports) {

$parcel$export(module.exports, "container", () => $c5337899fe2863ef$export$34e0f9847d4c02dd, (v) => $c5337899fe2863ef$export$34e0f9847d4c02dd = v);
var $c5337899fe2863ef$export$34e0f9847d4c02dd;
$c5337899fe2863ef$export$34e0f9847d4c02dd = `WjFy1q_container`;

});


parcelRegister("8CRQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $aedf93bd0ce84abf$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5STbA = parcelRequire("5STbA");

var $etIrL = parcelRequire("etIrL");

var $goZ4z = parcelRequire("goZ4z");
var $aedf93bd0ce84abf$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $etIrL.default), (0, $5STbA.default))((0, $goZ4z.default));

});
parcelRegister("5STbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f32c1b80576fd64$export$2e2bcd8739ae039);

var $kKZNQ = parcelRequire("kKZNQ");

var $1Szmp = parcelRequire("1Szmp");

var $7CnHa = parcelRequire("7CnHa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f32c1b80576fd64$export$2e2bcd8739ae039 = (dispatch)=>({
        fetchUserList: (query, issueId)=>{
            dispatch((0, $kKZNQ.fetchUserPickerOptions)(query || '', issueId || ''));
        },
        onChange: (issue, customFieldId, userId)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)({
                id: issue.id,
                customFields: {
                    [customFieldId]: (0, $7CnHa.isDefined)(userId) ? userId : undefined
                }
            }));
        }
    });

});
parcelRegister("kKZNQ", function(module, exports) {

$parcel$export(module.exports, "addCustomFields", () => $63c577c3bbd6b08e$export$d0e2ef714a0db3b4);
$parcel$export(module.exports, "removeCustomField", () => $63c577c3bbd6b08e$export$4519a1d548472c6f);
$parcel$export(module.exports, "populateUserPickerOptions", () => $63c577c3bbd6b08e$export$7004d9a21bcdbd07);
$parcel$export(module.exports, "fetchUserPickerOptions", () => $63c577c3bbd6b08e$export$7e0de8c99d98518f);
$parcel$export(module.exports, "toggleCustomFieldFilterability", () => $63c577c3bbd6b08e$export$795f830258bd4ea7);
$parcel$export(module.exports, "doPopulateUserPickerOptions", () => $63c577c3bbd6b08e$export$4c65256e5a964137);
$parcel$export(module.exports, "default", () => $63c577c3bbd6b08e$export$2e2bcd8739ae039);
parcelRequire("inLJ0");
var $71txE = parcelRequire("71txE");

var $aeXAa = parcelRequire("aeXAa");
var $lqxEm = parcelRequire("lqxEm");
var $l0L3x = parcelRequire("l0L3x");
var $erwaN = parcelRequire("erwaN");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $7WzTP = parcelRequire("7WzTP");
var $f7Op5 = parcelRequire("f7Op5");
var $UCNmJ = parcelRequire("UCNmJ");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $1jM5j = parcelRequire("1jM5j");

var $cbq3D = parcelRequire("cbq3D");

var $iTjRl = parcelRequire("iTjRl");
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $ewMwZ = parcelRequire("ewMwZ");

var $kKj1m = parcelRequire("kKj1m");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");
parcelRequire("kyGCj");
var $dvRTl = parcelRequire("dvRTl");
var $kyGCj = parcelRequire("kyGCj");

var $2LFLH = parcelRequire("2LFLH");

var $bfLCp = parcelRequire("bfLCp");

var $1oWqc = parcelRequire("1oWqc");

var $7uxoA = parcelRequire("7uxoA");

var $9ffcO = parcelRequire("9ffcO");

var $8B14N = parcelRequire("8B14N");

var $gCsFH = parcelRequire("gCsFH");

var $5rVFi = parcelRequire("5rVFi");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $63O1Q = parcelRequire("63O1Q");

var $9foZI = parcelRequire("9foZI");
const $63c577c3bbd6b08e$export$22550c63d1d2e6de = 'command.custom-fields.ADD_CUSTOM_FIELDS';
const $63c577c3bbd6b08e$export$aebce24c838569e9 = 'command.custom-fields.REMOVE_CUSTOM_FIELD';
const $63c577c3bbd6b08e$export$837a9b121c89f72c = 'command.custom-fields.FETCH_SELECT_OPTIONS';
const $63c577c3bbd6b08e$export$26ce9bf8b551812b = 'command.custom-fields.FETCH_USER_PICKER_OPTIONS';
const $63c577c3bbd6b08e$export$2c810c4aa49c0a3b = 'command.custom-fields.FETCH_USER_PICKER_OPTIONS_BY_IDS';
const $63c577c3bbd6b08e$export$97d3a70653e68b71 = 'command.custom-fields.POPULATE_USER_PICKER_OPTIONS';
const $63c577c3bbd6b08e$export$692688de415f3085 = 'command.custom-fields.TOGGLE_CUSTOM_FIELD_FILTERABILITY';
const $63c577c3bbd6b08e$export$d0e2ef714a0db3b4 = (fields, options = {
    skipBackendRequest: false
})=>({
        type: $63c577c3bbd6b08e$export$22550c63d1d2e6de,
        options: options,
        payload: {
            fields: fields
        }
    });
const $63c577c3bbd6b08e$export$4519a1d548472c6f = (id)=>({
        type: $63c577c3bbd6b08e$export$aebce24c838569e9,
        payload: {
            id: id
        }
    });
const $63c577c3bbd6b08e$export$8187784a31a97290 = ()=>({
        type: $63c577c3bbd6b08e$export$837a9b121c89f72c
    });
const $63c577c3bbd6b08e$export$7004d9a21bcdbd07 = ()=>({
        type: $63c577c3bbd6b08e$export$97d3a70653e68b71
    });
const $63c577c3bbd6b08e$export$7e0de8c99d98518f = (query, issueId)=>({
        type: $63c577c3bbd6b08e$export$26ce9bf8b551812b,
        payload: {
            query: query,
            issueId: issueId
        }
    });
const $63c577c3bbd6b08e$export$795f830258bd4ea7 = (payload)=>({
        type: $63c577c3bbd6b08e$export$692688de415f3085,
        payload: payload
    });
function $63c577c3bbd6b08e$var$getCustomFieldValuesFromIssues(fields, issues) {
    return issues.filter(({ customFields: customFields = {} })=>$erwaN.default($7WzTP.default(fields.map((field)=>field.id.toString()), customFields)).length > 0).flatMap(({ customFields: customFields = {} })=>$UCNmJ.default($7WzTP.default(fields.map((field)=>field.id.toString()), customFields)));
}
const $63c577c3bbd6b08e$var$getValuesOfCustomField = (type, customFields, originalIssues, issues)=>{
    const customFieldsWithType = (0, $kKj1m.getCustomFieldsByKey)(type, customFields);
    const originalIssueOptionIds = $63c577c3bbd6b08e$var$getCustomFieldValuesFromIssues(customFieldsWithType, $UCNmJ.default(originalIssues));
    const optionIds = $63c577c3bbd6b08e$var$getCustomFieldValuesFromIssues(customFieldsWithType, issues);
    return $lqxEm.default([
        ...originalIssueOptionIds,
        ...optionIds
    ]);
};
function* $63c577c3bbd6b08e$export$ef6c57c5ffb83c06({ payload: { ids: ids } }) {
    const users = yield (0, $9e8i2.call)((0, $63O1Q.getUsers), {
        keys: ids || []
    });
    yield (0, $9e8i2.put)((0, $7uxoA.reset)((users || []).map((user)=>({
            value: user.accountId,
            label: user.title,
            icon: user.avatarUrl,
            email: user.email
        }))));
}
function* $63c577c3bbd6b08e$export$4c65256e5a964137() {
    // need fetch the user picker value of issues and originalIssues
    const customFields = yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields));
    const originalIssues = yield (0, $9e8i2.select)((0, $kwMvv.getOriginalIssues));
    const issues = yield (0, $9e8i2.select)((0, $cwP4d.getIssues));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const userPickerOptions = $63c577c3bbd6b08e$var$getValuesOfCustomField((0, $5rYNM.CustomFieldTypes).UserPicker, customFields, originalIssues, issues); // User picker options are always string
    if (userPickerOptions.length === 0) return;
    const users = yield (0, $9e8i2.call)((0, $63O1Q.getUsers), {
        keys: userPickerOptions || []
    });
    yield (0, $9e8i2.put)((0, $7uxoA.reset)((users || []).map((user)=>({
            value: user.accountId,
            label: user.title,
            icon: user.avatarUrl,
            email: user.email
        }))));
}
function* $63c577c3bbd6b08e$export$3cd7dad83cedca62({ payload: { fields: fields }, options: { skipBackendRequest: skipBackendRequest } }) {
    try {
        const state = yield (0, $9e8i2.select)($l0L3x.default);
        const { domain: { plan: { id: planId } } } = state;
        if (!planId) return;
        const withFilteringAllowed = fields.map((field)=>({
                ...field,
                filteringAllowed: (0, $5rYNM.CustomFields).FilterableFields.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                field.type?.key)
            }));
        const wrapCustomFields = (field)=>({
                customFieldId: field.id,
                filteringAllowed: field.filteringAllowed
            });
        const body = (0, $9foZI.getAddCustomFieldsBody)(planId, withFilteringAllowed.map((field)=>wrapCustomFields(field || {})));
        if (!skipBackendRequest) {
            const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $9foZI.urls).addCustomFields, {
                method: (0, $kP3Wn.POST),
                body: body
            });
            if (!response.ok) return yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $9foZI.urls).removeCustomField,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
        }
        if (typeof withFilteringAllowed !== 'undefined') yield (0, $9e8i2.put)((0, $2LFLH.add)(withFilteringAllowed));
        yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
        yield (0, $9e8i2.put)($63c577c3bbd6b08e$export$8187784a31a97290());
        yield (0, $9e8i2.put)($63c577c3bbd6b08e$export$7004d9a21bcdbd07());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)((0, $8B14N.reset)({
            customFields: yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields))
        }));
    }
}
function* $63c577c3bbd6b08e$export$2f12d93ffddc65e0({ payload: { id: id } }) {
    try {
        const state = yield (0, $9e8i2.select)($l0L3x.default);
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = state;
        if (!planId || !currentScenarioId) return;
        const body = (0, $9foZI.getRemoveCustomFieldBody)(planId, currentScenarioId, id);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $9foZI.urls).removeCustomField, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            yield (0, $9e8i2.put)((0, $2LFLH.remove)(id));
            const colorByValue = yield (0, $9e8i2.select)((0, $kyGCj.getColorByValue));
            const sorting = yield (0, $9e8i2.select)((0, $kyGCj.getVisualisationSorting));
            if (colorByValue === id.toString()) yield (0, $9e8i2.put)((0, $9ffcO.setColourByValue)({
                id: (0, $33N5G.colourByOptions).NONE
            }));
            if (sorting.field === id.toString()) yield (0, $9e8i2.put)((0, $l1dWb.changeSort)({
                sorting: (0, $dvRTl.defaultSorting)
            }));
            const grouping = yield (0, $9e8i2.select)((0, $kyGCj.getVisualisationGrouping));
            if ((0, $ayXoc.isRoadmapGroupedByCustomField)(grouping) && (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping) === id.toString()) yield (0, $9e8i2.put)((0, $l1dWb.changeGroup)({
                grouping: (0, $5rYNM.GROUPING).NONE
            }));
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: (0, $9foZI.urls).removeCustomField,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $8B14N.reset)({
            customFields: yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields))
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $63c577c3bbd6b08e$export$3fd454a1f9fecf74({ payload: { fieldId: fieldId, filteringAllowed: filteringAllowed } }) {
    try {
        const state = yield (0, $9e8i2.select)($l0L3x.default);
        const customField = (yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields))).find((field)=>field.id === fieldId);
        const { domain: { plan: { id: planId } } } = state;
        if (planId) {
            const body = (0, $9foZI.getUpdateCustomFieldsBody)(planId, [
                {
                    customFieldId: fieldId,
                    filteringAllowed: filteringAllowed
                }
            ]);
            const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $9foZI.urls).updateCustomField, {
                method: (0, $kP3Wn.POST),
                body: body
            });
            if (response.ok) {
                yield (0, $9e8i2.put)((0, $2LFLH.update)($01zCq.default(customField, {
                    filteringAllowed: filteringAllowed
                })));
                yield (0, $9e8i2.put)((0, $8B14N.reset)({
                    customFields: yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields))
                }));
            } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $9foZI.urls).removeCustomField,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $63c577c3bbd6b08e$export$bfa91ca8fa407ad() {
    try {
        const state = yield (0, $9e8i2.select)($l0L3x.default);
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, projects: projects } } = state;
        const projectIds = projects.map((project)=>project.id);
        if (!planId || !currentScenarioId) return;
        // note: "CustomFieldTypes.Labels" is not in the list of allowed types because
        // label options are fetched from a different endpoint - see doFetchLabelForField()
        const allowedTypes = new Set([
            ...(0, $cofZt.default)() ? [
                (0, $5rYNM.CustomFieldTypes).AssetObject
            ] : [],
            (0, $5rYNM.CustomFieldTypes).SingleSelect,
            (0, $5rYNM.CustomFieldTypes).MultiSelect,
            (0, $5rYNM.CustomFieldTypes).MultiCheckboxes,
            (0, $5rYNM.CustomFieldTypes).RadioButtons
        ]);
        const allowedCustomFields = (yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields)))/* eslint-enable @typescript-eslint/consistent-type-assertions */ .filter((field)=>allowedTypes.has(field.type.key));
        // if there are no allowed custom fields in the plan, the "urls.getCustomFieldVisibleOptions" endpoint (see below) returns response.data = []
        // therefore we can reset select options to this empty array earlier in order to avoid calling the endpoint
        if (allowedCustomFields.length === 0) {
            yield (0, $9e8i2.put)((0, $1oWqc.reset)([]));
            return;
        }
        const url = (0, $9foZI.urls).getCustomFieldVisibleOptions;
        const response = yield* (0, $iTjRl.jsonOrError)({
            url: url,
            method: (0, $kP3Wn.POST),
            body: (0, $9foZI.getCustomFieldVisibleOptionsBody)($cQGVO.default($f7Op5.default('id'))(allowedCustomFields), projectIds),
            profile: url
        });
        if (response.ok) {
            const selectOptions = response.data.map(({ customFieldId: fieldId, options: options })=>options.map((option)=>$aeXAa.default('fieldId', fieldId, option))).reduce((a, b)=>a.concat(b), []);
            yield (0, $9e8i2.put)((0, $1oWqc.reset)(selectOptions));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $63c577c3bbd6b08e$export$a71c9ae971ca1414({ planId: planId, customFieldId: customFieldId, scenarioId: scenarioId }) {
    const body = (0, $9foZI.getLabelForFieldBody)(planId, customFieldId, scenarioId);
    const url = (0, $9foZI.urls).labels;
    const { items: items } = yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: (0, $kP3Wn.POST),
        body: body,
        json: true,
        profile: url
    }, 'Failed to fetch doFetchLabelForField');
    yield (0, $9e8i2.put)((0, $bfLCp.reset)({
        customFieldId: customFieldId,
        labels: items
    }));
}
function* $63c577c3bbd6b08e$export$595181c7146606e7(action = {
    type: $63c577c3bbd6b08e$export$26ce9bf8b551812b,
    payload: {
        query: '',
        issueId: ''
    }
}) {
    const issueId = action && action.payload && action.payload.issueId;
    const query = action ? action.payload && action.payload.query : '';
    const url = (0, $9foZI.urls).getUserPickerCustomFieldOptions;
    const method = 'POST';
    const body = (0, $9foZI.getUserPickerCustomFieldOptionsBody)({
        query: query
    });
    yield (0, $9e8i2.put)((0, $gCsFH.fetchUserStart)(issueId));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = yield* (0, $iTjRl.jsonOrError)({
        url: url,
        method: method,
        body: body
    });
    if (response.ok) yield (0, $9e8i2.put)((0, $7uxoA.reset)((0, $ewMwZ.transformPersons)(response.data && response.data.results || [])));
    yield (0, $9e8i2.put)((0, $gCsFH.fetchUserStop)(issueId));
}
function* $63c577c3bbd6b08e$export$90e3800be4ee03a0(action) {
    yield (0, $9e8i2.call)((0, $71txE.delay), 500);
    yield (0, $9e8i2.call)($63c577c3bbd6b08e$export$595181c7146606e7, action);
}
function* $63c577c3bbd6b08e$export$94874ce07393af5e() {
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$26ce9bf8b551812b, $63c577c3bbd6b08e$export$90e3800be4ee03a0);
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$2c810c4aa49c0a3b, $63c577c3bbd6b08e$export$ef6c57c5ffb83c06);
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$97d3a70653e68b71, $63c577c3bbd6b08e$export$4c65256e5a964137);
}
function* $63c577c3bbd6b08e$export$3559fa8b9a088433() {
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$22550c63d1d2e6de, $63c577c3bbd6b08e$export$3cd7dad83cedca62);
}
function* $63c577c3bbd6b08e$export$3edd59f42a0ea08d() {
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$aebce24c838569e9, $63c577c3bbd6b08e$export$2f12d93ffddc65e0);
}
function* $63c577c3bbd6b08e$export$50b4fa5c99cd5c86() {
    yield (0, $bG7pV.takeEvery)($63c577c3bbd6b08e$export$692688de415f3085, $63c577c3bbd6b08e$export$3fd454a1f9fecf74);
}
function* $63c577c3bbd6b08e$export$f80141107633cc64() {
    yield (0, $bG7pV.takeLatest)($63c577c3bbd6b08e$export$837a9b121c89f72c, $63c577c3bbd6b08e$export$bfa91ca8fa407ad);
}
function* $63c577c3bbd6b08e$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($63c577c3bbd6b08e$export$3559fa8b9a088433);
    yield (0, $9e8i2.fork)($63c577c3bbd6b08e$export$3edd59f42a0ea08d);
    yield (0, $9e8i2.fork)($63c577c3bbd6b08e$export$f80141107633cc64);
    yield (0, $9e8i2.fork)($63c577c3bbd6b08e$export$94874ce07393af5e);
    yield (0, $9e8i2.fork)($63c577c3bbd6b08e$export$50b4fa5c99cd5c86);
}

});
parcelRegister("2LFLH", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $116e1be000241240$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $116e1be000241240$export$bb6389024b71c2ae);
$parcel$export(module.exports, "UPDATE", () => $116e1be000241240$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $116e1be000241240$export$29d55e1f664a246b);
$parcel$export(module.exports, "reset", () => $116e1be000241240$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $116e1be000241240$export$e16d8520af44a096);
$parcel$export(module.exports, "update", () => $116e1be000241240$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $116e1be000241240$export$cd7f480d6b8286c3);
const $116e1be000241240$export$4a991c87e640ef77 = 'state.domain.custom-fields.RESET';
const $116e1be000241240$export$bb6389024b71c2ae = 'state.domain.custom-fields.ADD';
const $116e1be000241240$export$e271b26eefe41db8 = 'state.domain.custom-fields.UPDATE';
const $116e1be000241240$export$29d55e1f664a246b = 'state.domain.custom-fields.REMOVE';
const $116e1be000241240$export$aad8462122ac592b = (payload)=>({
        type: $116e1be000241240$export$4a991c87e640ef77,
        payload: payload
    });
const $116e1be000241240$export$e16d8520af44a096 = (payload)=>({
        type: $116e1be000241240$export$bb6389024b71c2ae,
        payload: payload
    });
const $116e1be000241240$export$722fbec263ad908a = (payload)=>({
        type: $116e1be000241240$export$e271b26eefe41db8,
        payload: payload
    });
const $116e1be000241240$export$cd7f480d6b8286c3 = (payload)=>({
        type: $116e1be000241240$export$29d55e1f664a246b,
        payload: payload
    });

});

parcelRegister("1oWqc", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $1b43096335d74c6e$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $1b43096335d74c6e$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $1b43096335d74c6e$export$aad8462122ac592b);
const $1b43096335d74c6e$export$bb6389024b71c2ae = 'state.domain.select-options.ADD';
const $1b43096335d74c6e$export$4a991c87e640ef77 = 'state.domain.select-options.RESET';
const $1b43096335d74c6e$export$e16d8520af44a096 = (payload)=>({
        type: $1b43096335d74c6e$export$bb6389024b71c2ae,
        payload: payload
    });
const $1b43096335d74c6e$export$aad8462122ac592b = (payload)=>({
        type: $1b43096335d74c6e$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("7uxoA", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $1078b383ce3097ea$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $1078b383ce3097ea$export$aad8462122ac592b);
const $1078b383ce3097ea$export$4a991c87e640ef77 = 'state.domain.user-picker-options.RESET';
const $1078b383ce3097ea$export$aad8462122ac592b = (payload)=>({
        type: $1078b383ce3097ea$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("9ffcO", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $c621b672bef7ecd0$export$4a991c87e640ef77);
$parcel$export(module.exports, "SET_COLOUR_BY_VALUE", () => $c621b672bef7ecd0$export$3e66ee5150a809d5);
$parcel$export(module.exports, "SET_COLOUR_MAP", () => $c621b672bef7ecd0$export$1ed2e8cc5af52ec2);
$parcel$export(module.exports, "UPDATE_TEAM_ID", () => $c621b672bef7ecd0$export$3375e6b8e0671d88);
$parcel$export(module.exports, "REMOVE_TEAM_ID", () => $c621b672bef7ecd0$export$96d619ae50e035a8);
$parcel$export(module.exports, "SET_COLOUR_FOR_NEW_TEAM", () => $c621b672bef7ecd0$export$9c3daa8c244ed3c);
$parcel$export(module.exports, "ADD_ISSUE_TYPE_COLOUR", () => $c621b672bef7ecd0$export$99be6a41dc9f4ab2);
$parcel$export(module.exports, "UPDATE_ISSUE_TYPE_COLOUR", () => $c621b672bef7ecd0$export$a7aed6f0b1f757ad);
$parcel$export(module.exports, "REMOVE_ISSUE_TYPE_COLOUR", () => $c621b672bef7ecd0$export$278fc823cb39dabd);
$parcel$export(module.exports, "ADD_LABEL_COLOUR", () => $c621b672bef7ecd0$export$3b20979dcb1bf726);
$parcel$export(module.exports, "UPDATE_LABEL_COLOUR", () => $c621b672bef7ecd0$export$30151323c3555d8e);
$parcel$export(module.exports, "REMOVE_LABEL_COLOUR", () => $c621b672bef7ecd0$export$8a40cd78cd667ee0);
$parcel$export(module.exports, "ADD_COMPONENT_COLOUR", () => $c621b672bef7ecd0$export$6dab2bbd46f0738);
$parcel$export(module.exports, "UPDATE_COMPONENT_COLOUR", () => $c621b672bef7ecd0$export$1604157578c815f3);
$parcel$export(module.exports, "REMOVE_COMPONENT_COLOUR", () => $c621b672bef7ecd0$export$6276b3bbeed8dd7e);
$parcel$export(module.exports, "ADD_PRIORITY_COLOUR", () => $c621b672bef7ecd0$export$b3764a4f4a360f31);
$parcel$export(module.exports, "SET_PRIORITY_COLOUR_MAP", () => $c621b672bef7ecd0$export$6f995e7ddc07011d);
$parcel$export(module.exports, "UPDATE_PRIORITY_COLOUR", () => $c621b672bef7ecd0$export$93b0e1785ade5311);
$parcel$export(module.exports, "REMOVE_PRIORITY_COLOUR", () => $c621b672bef7ecd0$export$e735a906397ccf0f);
$parcel$export(module.exports, "ADD_SELECT_COLOUR", () => $c621b672bef7ecd0$export$229431d3c9de9119);
$parcel$export(module.exports, "UPDATE_SELECT_COLOUR", () => $c621b672bef7ecd0$export$cc2ebe1808de3eaf);
$parcel$export(module.exports, "REMOVE_SELECT_COLOUR", () => $c621b672bef7ecd0$export$a72e3d03e03081fd);
$parcel$export(module.exports, "CLEAR_ALL_ISSUE_TYPE_COLOURS", () => $c621b672bef7ecd0$export$528cae8834a7aaba);
$parcel$export(module.exports, "CLEAR_ALL_LABEL_COLOURS", () => $c621b672bef7ecd0$export$f3d6db75bc058932);
$parcel$export(module.exports, "CLEAR_ALL_PRIORITY_COLOURS", () => $c621b672bef7ecd0$export$92fd8171426ca27);
$parcel$export(module.exports, "CLEAR_ALL_SELECT_COLOURS", () => $c621b672bef7ecd0$export$a9f87cf8b48c9f17);
$parcel$export(module.exports, "CLEAR_ALL_COMPONENT_COLOURS", () => $c621b672bef7ecd0$export$4f3c0a419cae6844);
$parcel$export(module.exports, "setColourMap", () => $c621b672bef7ecd0$export$c48a172e21f06e14);
$parcel$export(module.exports, "setColourByValue", () => $c621b672bef7ecd0$export$d5f986a0fd9fff3d);
$parcel$export(module.exports, "updateTeamId", () => $c621b672bef7ecd0$export$3d88424f2784ccca);
$parcel$export(module.exports, "removeTeamId", () => $c621b672bef7ecd0$export$d80371939c87a6d7);
$parcel$export(module.exports, "setColourForNewTeam", () => $c621b672bef7ecd0$export$e5818852970cd077);
$parcel$export(module.exports, "addIssueTypeColour", () => $c621b672bef7ecd0$export$cf61b392749df3f);
$parcel$export(module.exports, "updateIssueTypeColour", () => $c621b672bef7ecd0$export$b74745aa4e3de6b6);
$parcel$export(module.exports, "removeIssueTypeColour", () => $c621b672bef7ecd0$export$45c2d6f3c09898c7);
$parcel$export(module.exports, "clearAllIssueTypeColours", () => $c621b672bef7ecd0$export$54e5405609708451);
$parcel$export(module.exports, "addLabelColour", () => $c621b672bef7ecd0$export$5f6974865002dbeb);
$parcel$export(module.exports, "updateLabelColour", () => $c621b672bef7ecd0$export$d4bc34b40af5964a);
$parcel$export(module.exports, "removeLabelColour", () => $c621b672bef7ecd0$export$577b6462cf2c190b);
$parcel$export(module.exports, "clearAllLabelColours", () => $c621b672bef7ecd0$export$6c6fbec7b1246d3b);
$parcel$export(module.exports, "addPriorityColour", () => $c621b672bef7ecd0$export$c06d80c47bf126b);
$parcel$export(module.exports, "setPriorityColourMap", () => $c621b672bef7ecd0$export$38c255cf3dd1a29a);
$parcel$export(module.exports, "updatePriorityColour", () => $c621b672bef7ecd0$export$1460535d1143f247);
$parcel$export(module.exports, "removePriorityColour", () => $c621b672bef7ecd0$export$e1d85b8f002c3a84);
$parcel$export(module.exports, "clearAllPriorityColours", () => $c621b672bef7ecd0$export$47367661758240c6);
$parcel$export(module.exports, "addSelectColour", () => $c621b672bef7ecd0$export$670e2ed2e9b2440f);
$parcel$export(module.exports, "updateSelectColour", () => $c621b672bef7ecd0$export$ef87fce70c438ed2);
$parcel$export(module.exports, "removeSelectColour", () => $c621b672bef7ecd0$export$2d31749d1b7ade6);
$parcel$export(module.exports, "clearAllSelectColours", () => $c621b672bef7ecd0$export$76831fdfcb69dda);
$parcel$export(module.exports, "addComponentColour", () => $c621b672bef7ecd0$export$3b1279f9abc2a577);
$parcel$export(module.exports, "updateComponentColour", () => $c621b672bef7ecd0$export$4f3671368b35342e);
$parcel$export(module.exports, "removeComponentColour", () => $c621b672bef7ecd0$export$fb2d993c8537820a);
$parcel$export(module.exports, "clearAllComponentColours", () => $c621b672bef7ecd0$export$d36c83e78ef4db76);
const $c621b672bef7ecd0$export$4a991c87e640ef77 = 'state.domain.view-settings.colour-by.RESET';
const $c621b672bef7ecd0$export$3e66ee5150a809d5 = 'state.domain.view-settings.colour-by.SET_COLOUR_BY_VALUE';
const $c621b672bef7ecd0$export$1ed2e8cc5af52ec2 = 'state.domain.view-settings.colour-by.SET_COLOUR_MAP';
const $c621b672bef7ecd0$export$3375e6b8e0671d88 = 'state.domain.view-settings.colour-by.UPDATE_TEAM_ID';
const $c621b672bef7ecd0$export$96d619ae50e035a8 = 'state.domain.view-settings.colour-by.REMOVE_TEAM_ID';
const $c621b672bef7ecd0$export$9c3daa8c244ed3c = 'state.domain.view-settings.colour-by.SET_COLOUR_FOR_NEW_TEAM';
const $c621b672bef7ecd0$export$99be6a41dc9f4ab2 = 'state.domain.view-settings.colour-by.ADD_ISSUE_TYPE_COLOUR';
const $c621b672bef7ecd0$export$a7aed6f0b1f757ad = 'state.domain.view-settings.colour-by.UPDATE_ISSUE_TYPE_COLOUR';
const $c621b672bef7ecd0$export$278fc823cb39dabd = 'state.domain.view-settings.colour-by.REMOVE_ISSUE_TYPE_COLOUR';
const $c621b672bef7ecd0$export$3b20979dcb1bf726 = 'state.domain.view-settings.colour-by.ADD_LABEL_COLOUR';
const $c621b672bef7ecd0$export$30151323c3555d8e = 'state.domain.view-settings.colour-by.UPDATE_LABEL_COLOUR';
const $c621b672bef7ecd0$export$8a40cd78cd667ee0 = 'state.domain.view-settings.colour-by.REMOVE_LABEL_COLOUR';
const $c621b672bef7ecd0$export$6dab2bbd46f0738 = 'state.domain.view-settings.colour-by.ADD_COMPONENT_COLOUR';
const $c621b672bef7ecd0$export$1604157578c815f3 = 'state.domain.view-settings.colour-by.UPDATE_COMPONENT_COLOUR';
const $c621b672bef7ecd0$export$6276b3bbeed8dd7e = 'state.domain.view-settings.colour-by.REMOVE_COMPONENT_COLOUR';
const $c621b672bef7ecd0$export$b3764a4f4a360f31 = 'state.domain.view-settings.colour-by.ADD_PRIORITY_COLOUR';
const $c621b672bef7ecd0$export$6f995e7ddc07011d = 'state.domain.view-settings.colour-by.SET_PRIORITY_COLOUR_MAP';
const $c621b672bef7ecd0$export$93b0e1785ade5311 = 'state.domain.view-settings.colour-by.UPDATE_PRIORITY_COLOUR';
const $c621b672bef7ecd0$export$e735a906397ccf0f = 'state.domain.view-settings.colour-by.REMOVE_PRIORITY_COLOUR';
const $c621b672bef7ecd0$export$229431d3c9de9119 = 'state.domain.view-settings.colour-by.ADD_SELECT_COLOUR';
const $c621b672bef7ecd0$export$cc2ebe1808de3eaf = 'state.domain.view-settings.colour-by.UPDATE_SELECT_COLOUR';
const $c621b672bef7ecd0$export$a72e3d03e03081fd = 'state.domain.view-settings.colour-by.REMOVE_SELECT_COLOUR';
const $c621b672bef7ecd0$export$528cae8834a7aaba = 'state.domain.view-settings.colour-by.CLEAR_ALL_ISSUE_TYPE_COLOURS';
const $c621b672bef7ecd0$export$f3d6db75bc058932 = 'state.domain.view-settings.colour-by.CLEAR_ALL_LABEL_COLOURS';
const $c621b672bef7ecd0$export$92fd8171426ca27 = 'state.domain.view-settings.colour-by.CLEAR_ALL_PRIORITY_COLOURS';
const $c621b672bef7ecd0$export$a9f87cf8b48c9f17 = 'state.domain.view-settings.colour-by.CLEAR_ALL_SELECT_COLOURS';
const $c621b672bef7ecd0$export$4f3c0a419cae6844 = 'state.domain.view-settings.colour-by.CLEAR_ALL_COMPONENT_COLOURS';
const $c621b672bef7ecd0$export$aad8462122ac592b = (payload)=>({
        type: $c621b672bef7ecd0$export$4a991c87e640ef77,
        payload: payload
    });
const $c621b672bef7ecd0$export$c48a172e21f06e14 = (payload)=>({
        type: $c621b672bef7ecd0$export$1ed2e8cc5af52ec2,
        payload: payload
    });
const $c621b672bef7ecd0$export$d5f986a0fd9fff3d = (payload)=>({
        type: $c621b672bef7ecd0$export$3e66ee5150a809d5,
        payload: payload
    });
const $c621b672bef7ecd0$export$3d88424f2784ccca = (payload)=>({
        type: $c621b672bef7ecd0$export$3375e6b8e0671d88,
        payload: payload
    });
const $c621b672bef7ecd0$export$d80371939c87a6d7 = (payload)=>({
        type: $c621b672bef7ecd0$export$96d619ae50e035a8,
        payload: payload
    });
const $c621b672bef7ecd0$export$e5818852970cd077 = (payload)=>({
        type: $c621b672bef7ecd0$export$9c3daa8c244ed3c,
        payload: payload
    });
const $c621b672bef7ecd0$export$cf61b392749df3f = ()=>({
        type: $c621b672bef7ecd0$export$99be6a41dc9f4ab2
    });
const $c621b672bef7ecd0$export$b74745aa4e3de6b6 = (payload)=>({
        type: $c621b672bef7ecd0$export$a7aed6f0b1f757ad,
        payload: payload
    });
const $c621b672bef7ecd0$export$45c2d6f3c09898c7 = (payload)=>({
        type: $c621b672bef7ecd0$export$278fc823cb39dabd,
        payload: payload
    });
const $c621b672bef7ecd0$export$54e5405609708451 = ()=>({
        type: $c621b672bef7ecd0$export$528cae8834a7aaba
    });
const $c621b672bef7ecd0$export$5f6974865002dbeb = ()=>({
        type: $c621b672bef7ecd0$export$3b20979dcb1bf726
    });
const $c621b672bef7ecd0$export$d4bc34b40af5964a = (payload)=>({
        type: $c621b672bef7ecd0$export$30151323c3555d8e,
        payload: payload
    });
const $c621b672bef7ecd0$export$577b6462cf2c190b = (payload)=>({
        type: $c621b672bef7ecd0$export$8a40cd78cd667ee0,
        payload: payload
    });
const $c621b672bef7ecd0$export$6c6fbec7b1246d3b = ()=>({
        type: $c621b672bef7ecd0$export$f3d6db75bc058932
    });
const $c621b672bef7ecd0$export$c06d80c47bf126b = ()=>({
        type: $c621b672bef7ecd0$export$b3764a4f4a360f31
    });
const $c621b672bef7ecd0$export$38c255cf3dd1a29a = (payload)=>({
        type: $c621b672bef7ecd0$export$6f995e7ddc07011d,
        payload: payload
    });
const $c621b672bef7ecd0$export$1460535d1143f247 = (payload)=>({
        type: $c621b672bef7ecd0$export$93b0e1785ade5311,
        payload: payload
    });
const $c621b672bef7ecd0$export$e1d85b8f002c3a84 = (payload)=>({
        type: $c621b672bef7ecd0$export$e735a906397ccf0f,
        payload: payload
    });
const $c621b672bef7ecd0$export$47367661758240c6 = ()=>({
        type: $c621b672bef7ecd0$export$92fd8171426ca27
    });
const $c621b672bef7ecd0$export$670e2ed2e9b2440f = ()=>({
        type: $c621b672bef7ecd0$export$229431d3c9de9119
    });
const $c621b672bef7ecd0$export$ef87fce70c438ed2 = (payload)=>({
        type: $c621b672bef7ecd0$export$cc2ebe1808de3eaf,
        payload: payload
    });
const $c621b672bef7ecd0$export$2d31749d1b7ade6 = (payload)=>({
        type: $c621b672bef7ecd0$export$a72e3d03e03081fd,
        payload: payload
    });
const $c621b672bef7ecd0$export$76831fdfcb69dda = ()=>({
        type: $c621b672bef7ecd0$export$a9f87cf8b48c9f17
    });
const $c621b672bef7ecd0$export$3b1279f9abc2a577 = ()=>({
        type: $c621b672bef7ecd0$export$6dab2bbd46f0738
    });
const $c621b672bef7ecd0$export$4f3671368b35342e = (payload)=>({
        type: $c621b672bef7ecd0$export$1604157578c815f3,
        payload: payload
    });
const $c621b672bef7ecd0$export$fb2d993c8537820a = (payload)=>({
        type: $c621b672bef7ecd0$export$6276b3bbeed8dd7e,
        payload: payload
    });
const $c621b672bef7ecd0$export$d36c83e78ef4db76 = ()=>({
        type: $c621b672bef7ecd0$export$4f3c0a419cae6844
    });

});

parcelRegister("gCsFH", function(module, exports) {

$parcel$export(module.exports, "FETCH_USER_START", () => $2d84ceca8f2bac53$export$447013e0880a2fa);
$parcel$export(module.exports, "FETCH_USER_STOP", () => $2d84ceca8f2bac53$export$9a15cd003e3d43b);
$parcel$export(module.exports, "fetchUserStart", () => $2d84ceca8f2bac53$export$82dc48650f95fc3d);
$parcel$export(module.exports, "fetchUserStop", () => $2d84ceca8f2bac53$export$c75227b929d0c88c);
const $2d84ceca8f2bac53$export$447013e0880a2fa = 'state.ui.main.tabs.roadmap.fields.custom-fields.user-picker.FETCH_USER_START';
const $2d84ceca8f2bac53$export$9a15cd003e3d43b = 'state.ui.main.tabs.roadmap.fields.custom-fields.user-picker.FETCH_USER_STOP';
const $2d84ceca8f2bac53$export$82dc48650f95fc3d = (issueId)=>({
        type: $2d84ceca8f2bac53$export$447013e0880a2fa,
        payload: {
            issueId: issueId
        }
    });
const $2d84ceca8f2bac53$export$c75227b929d0c88c = (issueId)=>({
        type: $2d84ceca8f2bac53$export$9a15cd003e3d43b,
        payload: {
            issueId: issueId
        }
    });

});



parcelRegister("etIrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $520f3a1b29ba6610$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
var $520f3a1b29ba6610$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    userList: (0, $kKj1m.getUserPickerOptionsUserList),
    userListById: (0, $kKj1m.getUserPickerOptionsUserListById),
    userPickerUIState: (0, $kKj1m.getUserPickerUIState)
});

});

parcelRegister("goZ4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bfbdfa460f0af8c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");

var $iJlfe = parcelRequire("iJlfe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gbNhI = parcelRequire("gbNhI");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $etO0g = parcelRequire("etO0g");

var $g6ugj = parcelRequire("g6ugj");
const $8bfbdfa460f0af8c$export$8b412adb79c82bc8 = ({ issue: issue, attribute: attribute, onChange: onChange })=>(userId)=>{
        onChange(issue, attribute, userId);
    };
const $8bfbdfa460f0af8c$export$6341682f20d2dbb4 = ({ attribute: attribute, issue: issue, userListById: userListById })=>{
    const userPickerValue = $kjklK.default([
        'customFields',
        attribute
    ], issue);
    // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
    if (userPickerValue && userListById[userPickerValue]) // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
    return userListById[userPickerValue];
    return null;
};
const $8bfbdfa460f0af8c$export$1a4c3eec4d27c15d = ({ attribute: attribute, issue: issue, userListById: userListById, isScrolling: isScrolling, isReadOnly: isReadOnly = false, userList: userList = [], UserPicker: UserPicker, userPickerUIState: userPickerUIState, onChange: onChange, fetchUserList: fetchUserList })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const selectedUser = $8bfbdfa460f0af8c$export$6341682f20d2dbb4({
        attribute: attribute,
        issue: issue,
        userListById: userListById
    });
    const handleUserChange = $8bfbdfa460f0af8c$export$8b412adb79c82bc8({
        issue: issue,
        attribute: attribute,
        onChange: onChange
    });
    const onFetchUserList = (query = '')=>{
        fetchUserList(query, issue.id);
    };
    if (isScrolling) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbNhI.default), {
        content: selectedUser ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $g6ugj.wireframeWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: selectedUser.icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $g6ugj.wireframeTitle
        }, selectedUser.label)) : '',
        isReadOnly: isReadOnly
    });
    const { issueId: issueId, isFetchUserListInProgress: isFetchUserListInProgress } = userPickerUIState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserPicker, {
        attribute: attribute,
        issueId: issue.id,
        onFetchUserList: onFetchUserList,
        onUserChange: handleUserChange,
        placeholder: formatMessage((0, $etO0g.default).placeholder),
        selectProps: {
            isClearable: true,
            isDisabled: isReadOnly,
            isLoading: (0, $7CnHa.isDefined)(issueId) && issue.id === issueId && isFetchUserListInProgress
        },
        user: selectedUser,
        userList: userList
    });
};
const $8bfbdfa460f0af8c$export$98f196004df7adbd = (0, $a4vO3.withSlots)({
    UserPicker: (0, $a4vO3.slots).UserPicker
})($8bfbdfa460f0af8c$export$1a4c3eec4d27c15d);
var $8bfbdfa460f0af8c$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    UserPicker: (0, $a4vO3.slots).UserPicker
})($8bfbdfa460f0af8c$export$1a4c3eec4d27c15d);

});
parcelRegister("etO0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e396b8cea564d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81e396b8cea564d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.cells.custom-field.renderers.user-picker.placeholder",
        "defaultMessage": "Choose a user"
    }
});

});

parcelRegister("g6ugj", function(module, exports) {

$parcel$export(module.exports, "wireframeTitle", () => $bb94ae520ba7a705$export$5b70723b6181a633, (v) => $bb94ae520ba7a705$export$5b70723b6181a633 = v);
$parcel$export(module.exports, "wireframeWrapper", () => $bb94ae520ba7a705$export$fc8552436656bc6, (v) => $bb94ae520ba7a705$export$fc8552436656bc6 = v);
var $bb94ae520ba7a705$export$5b70723b6181a633;
var $bb94ae520ba7a705$export$fc8552436656bc6;
$bb94ae520ba7a705$export$5b70723b6181a633 = `HckXpG_wireframeTitle`;
$bb94ae520ba7a705$export$fc8552436656bc6 = `HckXpG_wireframeWrapper`;

});



parcelRegister("dmOK7", function(module, exports) {

$parcel$export(module.exports, "shouldCustomFieldBeDisabledForScopedIssue", () => $65b1ead7773f4680$export$45e0204534f8a44e);
const $65b1ead7773f4680$export$92eaadfffff71863 = (customField)=>customField.projectId !== undefined;
const $65b1ead7773f4680$export$45e0204534f8a44e = (customField, issueTypeId, issueProjectId)=>{
    // if the custom field has projectId attached that means the custom field is bound to
    // a specific project, so it's a scoped custom field (TMP)
    if ($65b1ead7773f4680$export$92eaadfffff71863(customField)) {
        // check both project id and issue types are matched
        // if they are not matched, so the issue does not belong to the project and we should disable it
        if (customField.projectId !== issueProjectId || !(customField.issueTypeIds && customField.issueTypeIds.includes(issueTypeId))) return true;
    }
    return false;
};

});




parcelRegister("7rDvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f57750880d643e8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9eMVJ = parcelRequire("9eMVJ");

var $VAiiJ = parcelRequire("VAiiJ");
class $9f57750880d643e8$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ColumnsComponent: $9eMVJ.default,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onExperienceSuccess: ()=>{}
        };
    }
    componentDidMount() {
        this.props.onExperienceSuccess && this.props.onExperienceSuccess();
    }
    render() {
        const { columns: columns, height: height, isReadOnly: isReadOnly = false, items: items, ColumnsComponent: // eslint-disable-next-line @typescript-eslint/no-shadow
        ColumnsComponent, showOptimizations: showOptimizations = false, scrollElement: scrollElement, width: width, minWidth: minWidth, showWarning: showWarning } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $VAiiJ.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnsComponent, {
            columns: columns,
            height: height,
            items: items,
            isReadOnly: isReadOnly,
            showOptimizations: showOptimizations,
            scrollElement: scrollElement,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.props.onDragEnd,
            width: width,
            minWidth: minWidth,
            showWarning: showWarning
        })));
    }
}

});
parcelRegister("9eMVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $46615f5a6d395841$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2ZXgk = parcelRequire("2ZXgk");

var $3qSb0 = parcelRequire("3qSb0");
var $46615f5a6d395841$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2ZXgk.default), {})((0, $3qSb0.default));

});
parcelRegister("2ZXgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $44aa8330cf4fe67b$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $72KE6 = parcelRequire("72KE6");

var $iK4oF = parcelRequire("iK4oF");
const $44aa8330cf4fe67b$var$query = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getDateConfiguration),
    (0, $akhOi.getIsPlanInfoReady),
    (0, $dBKyg.getNamespaceFromActiveView),
    (0, $75KhQ.getPlanningUnit),
    (0, $9H2AP.getViewMode),
    (0, $akhOi.isExportMode),
    (0, $akhOi.isConfluenceMacro)
], (dateConfiguration, isPlanInfoReady, viewNamespace, planningUnit, viewMode, // eslint-disable-next-line @typescript-eslint/no-shadow
isExportMode, // eslint-disable-next-line @typescript-eslint/no-shadow
isConfluenceMacro)=>({
        getMatchingConfiguredDate: (0, $72KE6.getMatchingConfiguredDate)(dateConfiguration),
        areCustomFieldsReady: isPlanInfoReady,
        viewNamespace: viewNamespace,
        planningUnit: planningUnit,
        viewMode: viewMode,
        isExportMode: isExportMode,
        isConfluenceMacro: isConfluenceMacro
    }));
var $44aa8330cf4fe67b$export$2e2bcd8739ae039 = $44aa8330cf4fe67b$var$query;

});

parcelRegister("3qSb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9c411970e173e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Hojg = parcelRequire("1Hojg");
var $aml13 = parcelRequire("aml13");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $ffiyv = parcelRequire("ffiyv");
var $lMaVG = parcelRequire("lMaVG");
var $lcvrv = parcelRequire("lcvrv");

var $lf4fN = parcelRequire("lf4fN");

var $9NSUz = parcelRequire("9NSUz");

var $5rYNM = parcelRequire("5rYNM");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cJIet = parcelRequire("cJIet");

var $3HDq7 = parcelRequire("3HDq7");

var $lnZlB = parcelRequire("lnZlB");

var $bUuwD = parcelRequire("bUuwD");
const $db9c411970e173e3$var$getColumnTitle = (column)=>{
    if (typeof column.title === 'string') return column.title;
    // @ts-expect-error Type 'MessageFormatElement[]' is not assignable to type 'string'.
    return column.title.defaultMessage || '';
};
const $db9c411970e173e3$export$f02cc02ad0e0bba3 = ({ columns: columns, height: height, width: width, getMatchingConfiguredDate: getMatchingConfiguredDate, areCustomFieldsReady: areCustomFieldsReady, viewNamespace: viewNamespace, onDragStart: onDragStart, onDragEnd: onDragEnd, items: items, isReadOnly: isReadOnly, showOptimizations: showOptimizations = false, scrollElement: scrollElement, showWarning: showWarning, planningUnit: planningUnit, viewMode: viewMode, minWidth: minWidth, isExportMode: isExportMode, isConfluenceMacro: isConfluenceMacro })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isViewModeList = viewMode === (0, $lcvrv.VIEW_MODES).LIST;
    const onHandleDragEnd = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragged',
            actionSubject: 'column'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'fields', {
            viewMode: viewMode
        });
        onDragEnd();
    };
    const renderColumn = (column, section, isDragging)=>{
        const { id: id, cell: cell, attribute: attribute } = column;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cJIet.default), {
            key: id,
            id: id,
            attribute: attribute,
            cell: cell,
            items: items,
            isReadOnly: isReadOnly || column.isReadOnly || false,
            showOptimizations: showOptimizations,
            scrollElement: scrollElement,
            width: section.width,
            isDragging: isDragging,
            showWarning: showWarning
        })));
    };
    const getColumnTextTitle = (section)=>{
        const titleLabel = section.id && (0, $9NSUz.getHeaderMessage)(section.id, planningUnit);
        if (titleLabel) return formatMessage(titleLabel);
        return section.title;
    };
    const dateIcon = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "D"), []);
    const sectionRenderer = (issueColumns)=>// False-positive :/
        // eslint-disable-next-line react/no-unstable-nested-components
        ({ section: section, onSectionClick: onSectionClick, index: index, isDragging: isDragging, hoveredSectionIndex: hoveredSectionIndex, setHovered: setHovered })=>{
            const icon = dateIcon;
            const tooltip = icon && (0, $9NSUz.getConfiguredDateTooltip)(section.configurableDate);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
                backgroundColor: issueColumns[index].hasOptimizedValues ? undefined : `var(--ds-background-neutral-subtle, ${(0, $g4Vkx.default).N0})`,
                hoveredSectionIndex: hoveredSectionIndex,
                icon: section.configurableDate && icon,
                id: section.id,
                index: index,
                key: `section-${section.id}`,
                minWidth: section.minWidth,
                onClick: onSectionClick,
                setHovered: setHovered,
                title: getColumnTextTitle(section),
                tooltip: tooltip && formatMessage(tooltip, {
                    title: section.title
                }),
                width: section.width,
                collapsible: section.collapsible
            }, renderColumn(issueColumns[index], section, isDragging));
        };
    const visibleColumns = columns.filter((column)=>column.isVisible);
    if ((0, $bUuwD.showEmptyView)({
        areCustomFieldsReady: areCustomFieldsReady,
        isViewModeList: isViewModeList,
        isExportMode: isExportMode,
        isConfluenceMacro: isConfluenceMacro,
        totalVisibleColumns: visibleColumns.filter(({ id: id })=>id !== (0, $lf4fN.ADD_FIELDS_COLUMN_ID)).length
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3HDq7.default), {
        columns: columns,
        getMatchingConfiguredDate: getMatchingConfiguredDate,
        width: minWidth ?? width
    });
    if (!areCustomFieldsReady || visibleColumns.length === 0) return null;
    const sectionsData = visibleColumns.map((column, index, arr)=>{
        const data = {
            initialWidth: column.defaultWidth,
            minWidth: column.minWidth ?? 24,
            // Last column is flexible to absorb the remaining delta
            isFixed: !(viewMode === (0, $lcvrv.VIEW_MODES).LIST && index === arr.length - 1),
            id: column.id,
            title: $db9c411970e173e3$var$getColumnTitle(column),
            collapsible: column.isCollapsible
        };
        const configurableDate = getMatchingConfiguredDate(column.id);
        if (configurableDate) {
            data.configurableDate = configurableDate;
            data.initialWidth = (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE;
        }
        return data;
    });
    const linkToParent = isViewModeList ? (0, $5rYNM.SECTION_KEYS).LIST_MAIN : (0, $5rYNM.SECTION_KEYS).MAIN;
    const id = isViewModeList ? (0, $5rYNM.SECTION_KEYS).LIST_FIELD : (0, $5rYNM.SECTION_KEYS).FIELD;
    const columnContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lnZlB.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
        namespace: viewNamespace,
        /**
     * CAVEAT of 'linkToParent' with 'isFitParent'
     *
     * There are three "Fields" sections (sticky-header, header, and columns),
     * only ONE section should be linked to the parent IF the sections have `isFitParent=false`.
     *
     * `isFitParent=false` where the section does not bound by parent's size, the parent's width get updated after the section resized,
     * this will resulted with multiple cascading updates on the parent section IF multiple sections linked to the same parent.
     *
     * */ linkToParent: linkToParent,
        // @ts-expect-error - TS2322 - Type '{ namespace: string; linkToParent: "main-sections"; minHeight: string; height: string | number; id: "fields-section"; sectionRenderer: ({ section, onSectionClick, index, isDragging, hoveredSectionIndex, setHovered, }: SectionRendererArgs) => Element; sectionsData: { ...; }[]; onDragStart: () => void; onDragEnd: () =...' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
        minHeight: "100%",
        height: height || '100%',
        id: id,
        sectionRenderer: sectionRenderer(visibleColumns),
        sectionsData: sectionsData,
        onDragStart: onDragStart,
        onDragEnd: onHandleDragEnd,
        width: width,
        minWidth: minWidth,
        isFitParent: !isViewModeList
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        client: new (0, $1Hojg.default)()
    }, columnContent);
};
var $db9c411970e173e3$export$2e2bcd8739ae039 = $db9c411970e173e3$export$f02cc02ad0e0bba3;

});
parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $5pr8w = parcelRequire("5pr8w");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5pr8w)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("inzmU", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $2fFJv.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("5pr8w", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3f0456472e399d24$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3f0456472e399d24$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3f0456472e399d24$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3f0456472e399d24$var$getValidCacheKeyFn(options);
        this._cacheMap = $3f0456472e399d24$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3f0456472e399d24$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3f0456472e399d24$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3f0456472e399d24$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3f0456472e399d24$var$resolvedPromise) $3f0456472e399d24$var$resolvedPromise = Promise.resolve();
    $3f0456472e399d24$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3f0456472e399d24$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3f0456472e399d24$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3f0456472e399d24$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3f0456472e399d24$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3f0456472e399d24$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3f0456472e399d24$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3f0456472e399d24$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3f0456472e399d24$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3f0456472e399d24$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3f0456472e399d24$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3f0456472e399d24$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3f0456472e399d24$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3f0456472e399d24$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3f0456472e399d24$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3f0456472e399d24$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3f0456472e399d24$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3f0456472e399d24$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3f0456472e399d24$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3f0456472e399d24$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});


parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});


parcelRegister("cJIet", function(module, exports) {

$parcel$export(module.exports, "default", () => $03f609a8a5a6d95b$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $kwMvv = parcelRequire("kwMvv");

var $YHQpz = parcelRequire("YHQpz");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $1g6mJ = parcelRequire("1g6mJ");
const $03f609a8a5a6d95b$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    warnings: (0, $YHQpz.getWarnings),
    mode: (0, $akhOi.getMode),
    isLoading: (0, $kwMvv.getIsIssuesLoading)
});
const $03f609a8a5a6d95b$var$Column = (0, $lNNXV.connect)($03f609a8a5a6d95b$var$mapStateToProps, {})((0, $1g6mJ.default));
// @ts-expect-error: Property 'whyDidYouRender' does not exist on connected component
$03f609a8a5a6d95b$var$Column.whyDidYouRender = true;
$03f609a8a5a6d95b$var$Column.displayName = 'Column';
var $03f609a8a5a6d95b$export$2e2bcd8739ae039 = $03f609a8a5a6d95b$var$Column;

});
parcelRegister("1g6mJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8056a0ad7addb994$export$2e2bcd8739ae039);
/* eslint-disable max-classes-per-file */ 
var $eUqFw = parcelRequire("eUqFw");

var $jPCDz = parcelRequire("jPCDz");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $g4Vkx = parcelRequire("g4Vkx");
var $1WecH = parcelRequire("1WecH");

var $9Ar1p = parcelRequire("9Ar1p");
var $hoaeP = parcelRequire("hoaeP");

var $a0bo1 = parcelRequire("a0bo1");

var $3dOx1 = parcelRequire("3dOx1");

var $57dZR = parcelRequire("57dZR");

var $kJgLh = parcelRequire("kJgLh");

var $5rYNM = parcelRequire("5rYNM");

var $hPeQq = parcelRequire("hPeQq");

var $ib5d3 = parcelRequire("ib5d3");

var $aRcOC = parcelRequire("aRcOC");

var $bEvmS = parcelRequire("bEvmS");
const $8056a0ad7addb994$var$cellStyle = (rootIndex, isOptimized)=>{
    const isEven = rootIndex % 2 === 0;
    if (isEven) {
        if (isOptimized) return `${$bEvmS.cell} ${$bEvmS["cell-optimized"]}`;
        return $bEvmS.cell;
    }
    if (isOptimized) return `${$bEvmS.cell} ${$bEvmS["cell-even-optimized"]}`;
    return `${$bEvmS.cell} ${$bEvmS["cell-even"]}`;
};
// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
class $8056a0ad7addb994$var$CellWrapper extends (0, $kJgLh.default) {
    static{
        this.displayName = 'CellWrapper';
    }
    static{
        this.whyDidYouRender = true;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    shouldComponentUpdate(nextProps, nextState) {
        return !nextProps.isScrolling && super.shouldComponentUpdate(nextProps, nextState);
    }
    render() {
        const { cell: Cell, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRcOC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Cell, props));
    }
}
class $8056a0ad7addb994$export$816b5d811295e6bc extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            StickyHeader: $3dOx1.default
        };
    }
    // eslint-disable-next-line react/sort-comp
    shouldComponentUpdate(nextProps) {
        if (nextProps.isDragging && this.props.width !== nextProps.width && this.containerRef.current) (0, $hPeQq.manuallyUpdateReactVirtualizedListWidth)(this.containerRef.current, nextProps.width);
        return !nextProps.isDragging;
    }
    componentDidMount() {
        this.forceHandleScroll();
    }
    componentDidUpdate(prevProps) {
        if (this.props.scrollElement !== prevProps.scrollElement) this.forceHandleScroll();
        const listRef = this.listRef.current;
        if (listRef && prevProps.items !== this.props.items) {
            const length = Math.min(prevProps.items.length, this.props.items.length);
            for(let i = 0; i < length; i++)if (prevProps.items[i].height !== this.props.items[i].height) {
                listRef.recomputeRowHeights();
                break;
            }
        }
    }
    forceHandleScroll() {
        // JPOS-2155 Fields are not rendered until next scrolling event
        // After collapse/expand column item position is wrong because starting index for second part of table starts from 0
        // this workaround is for recalculating items position in a column after colapse/expand field.
        const ref = this.ref.current;
        if (ref) {
            ref.__handleWindowScrollEvent();
            ref.__resetIsScrolling();
        /* eslint-enable */ }
    }
    render() {
        const { intl: intl, attribute: attribute, items: items, mode: mode, scrollElement: scrollElement, warnings: warnings, width: width, isLoading: isLoading, id: id, StickyHeader: // eslint-disable-next-line @typescript-eslint/no-shadow
        StickyHeader } = this.props;
        // NOTE rows={items} + warnings={warnings} are passed to List to trigger re-render when items content was changed
        // but length remained the same
        const content = scrollElement ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.containerRef,
            className: $bEvmS.column,
            "data-testid": `column-${attribute}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoaeP.WindowScroller), {
            scrollElement: scrollElement,
            ref: this.ref
        }, ({ height: height = 0, isScrolling: isScrolling, onChildScroll: onChildScroll, scrollTop: scrollTop })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    position: 'relative'
                }
            }, StickyHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StickyHeader, {
                sectionId: "field",
                containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-field-${id}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ar1p.List), {
                ref: this.listRef,
                autoHeight: true,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $bEvmS.list,
                height: height,
                isScrolling: isScrolling,
                mode: mode,
                onScroll: onChildScroll,
                rowCount: items.length,
                rowHeight: ({ index: index })=>{
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    const height = items[index].height || 1;
                    return height * (0, $5rYNM.SCOPE_ROW_HEIGHT);
                },
                rowRenderer: this.rowRenderer,
                rows: items,
                scrollTop: scrollTop,
                tabIndex: null,
                width: width,
                warnings: warnings,
                overscanRowCount: 20
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $bEvmS.space
        })) : null;
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WecH.default), {
            ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage),
            numOfRows: 13,
            spaceInBetween: 12
        }) : content;
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/sort-comp
        this.ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.containerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.listRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.getCell = (issue, isScrolling)=>{
            // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
            const warnings = this.props.warnings.byIssue[issue.id || ''] || [];
            // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
            const hasWarnings = warnings.length > 0;
            const { cell: cell, isReadOnly: isReadOnly = false, attribute: attribute, showOptimizations: showOptimizations = false, width: width, showWarning: // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
            showWarning } = this.props;
            const { id: id, optimized: optimized } = issue;
            const isOptimized = showOptimizations && optimized && $jPCDz.default(attribute, optimized) ? (0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, attribute), (0, $57dZR.getOptimizedValue)(issue, attribute)) : false;
            const styleName = $8056a0ad7addb994$var$cellStyle(issue.rootIndex, isOptimized);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: styleName,
                key: id,
                "data-issue": id,
                "data-group": issue.group,
                "data-name": `cell-${id}`,
                "data-attribute": attribute
            }, (0, $1ybV0.ff)('arj-remove-row-warning-highlighting_jqjs5') || (0, $57dZR.getRowHighlighter)(issue.group, id, hasWarnings && showWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8056a0ad7addb994$var$CellWrapper, {
                cell: cell,
                issue: issue,
                isReadOnly: isReadOnly,
                isScrolling: isScrolling,
                showOptimizations: showOptimizations,
                width: width,
                attribute: attribute
            }));
        };
        this.rowRenderer = ({ key: key, index: index, style: style, isScrolling: isScrolling })=>{
            const { items: items } = this.props;
            const item = items[index];
            const { tag: tag } = item;
            switch(item.tag){
                case 0, $a0bo1.TABLE_ISSUE:
                    {
                        const issue = item.value;
                        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            key: `${item.tag}-${item.group || ''}-${issue.id}`,
                            style: style
                        }, this.getCell(issue, isScrolling)));
                    }
                case 0, $a0bo1.TABLE_INLINE_CREATE:
                    {
                        const issue = item.value;
                        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            key: `${item.tag}-${item.group || ''}-${issue.id}`,
                            style: style
                        }, this.getCell(issue, isScrolling)));
                    }
                case 0, $a0bo1.TABLE_HEADER:
                    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: 40,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $g4Vkx.default).N0})`
                        }
                    })));
                case 0, $a0bo1.TABLE_GROUP_HEADER:
                    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: 40,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $g4Vkx.default).N0})`
                        }
                    })));
                case 0, $a0bo1.TABLE_BLANK_ROW:
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style,
                        className: $bEvmS.blankRow
                    });
                case 0, $a0bo1.TABLE_GROUP:
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style,
                        className: $bEvmS.groupRow
                    });
                default:
                    throw new Error(`Unexpected TABLE item variant: ${tag}`);
            }
        };
    }
}
var $8056a0ad7addb994$export$2e2bcd8739ae039 = (0, $2qhQi.default)($8056a0ad7addb994$export$816b5d811295e6bc);

});
parcelRegister("1WecH", function(module, exports) {

$parcel$export(module.exports, "default", () => $68dd131ede77873a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $812KE = parcelRequire("812KE");

var $gIPv8 = parcelRequire("gIPv8");

var $1ybV0 = parcelRequire("1ybV0");

var $84CBi = parcelRequire("84CBi");

var $1FoRq = parcelRequire("1FoRq");

var $7QAbJ = parcelRequire("7QAbJ");

var $exjqP = parcelRequire("exjqP");
class $68dd131ede77873a$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            rowHeight: (0, $7QAbJ.RECT_ROW_HEIGHT),
            sidePadding: 8,
            spaceInBetween: 8,
            topPadding: 8,
            animate: true
        };
    }
    render() {
        const { numOfRows: numOfRows, ariaLabel: ariaLabel, rowHeight: rowHeight, animate: animate } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
            name: "list-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1FoRq.AutoSizer), null, ({ width: width, height: height })=>{
            const rowCount = numOfRows || Math.floor(height / rowHeight) - 1;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $exjqP.skeleton,
                style: {
                    width: width,
                    height: height
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIPv8.default), {
                ariaLabel: ariaLabel,
                width: width,
                height: height,
                ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? {
                    animate: animate
                } : {},
                ...(0, $7QAbJ.DEFAULT_CONTENT_LOADER_PROPS)
            }, $812KE.default(0, rowCount).map((index)=>this.getSkeletonFragments(index, width)))));
        }));
    }
    constructor(...args){
        super(...args);
        this.getSkeletonFragments = (index, width)=>{
            const { rowHeight: rowHeight, sidePadding: sidePadding, spaceInBetween: spaceInBetween, topPadding: topPadding } = this.props;
            const rectWidth = width - sidePadding * 2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding,
                y: index * (rowHeight + spaceInBetween) + topPadding,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: rectWidth < 0 ? 0 : rectWidth,
                height: rowHeight
            }));
        };
    }
}

});
parcelRegister("1FoRq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2DPbm = parcelRequire("2DPbm");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $136ce7930e2abfc3$var$_interopRequireDefault($2DPbm).default;
    }
});
Object.defineProperty(module.exports, 'AutoSizer', {
    enumerable: true,
    get: function get() {
        return $136ce7930e2abfc3$var$_interopRequireDefault($2DPbm).default;
    }
});
function $136ce7930e2abfc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2DPbm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $1ec6ed07ef4e0151$var$_extends3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $1ec6ed07ef4e0151$var$_getPrototypeOf2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $1ec6ed07ef4e0151$var$_classCallCheck3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $1ec6ed07ef4e0151$var$_createClass3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $1ec6ed07ef4e0151$var$_possibleConstructorReturn3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $1ec6ed07ef4e0151$var$_inherits3 = $1ec6ed07ef4e0151$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $1ec6ed07ef4e0151$var$React = $1ec6ed07ef4e0151$var$_interopRequireWildcard($eUqFw);

var $jq35C = parcelRequire("jq35C");
var $1ec6ed07ef4e0151$var$_detectElementResize2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($jq35C);

var $1Qivz = parcelRequire("1Qivz");
var $1ec6ed07ef4e0151$var$_propTypes2 = $1ec6ed07ef4e0151$var$_interopRequireDefault($1Qivz);
function $1ec6ed07ef4e0151$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1ec6ed07ef4e0151$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1ec6ed07ef4e0151$var$AutoSizer = function(_React$PureComponent) {
    (0, $1ec6ed07ef4e0151$var$_inherits3.default)(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $1ec6ed07ef4e0151$var$_classCallCheck3.default)(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $1ec6ed07ef4e0151$var$_possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, $1ec6ed07ef4e0151$var$_getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var _style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), (0, $1ec6ed07ef4e0151$var$_possibleConstructorReturn3.default)(_this, _ret);
    } // uses any instead of Window because Flow doesn't have window type
    (0, $1ec6ed07ef4e0151$var$_createClass3.default)(AutoSizer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $1ec6ed07ef4e0151$var$_detectElementResize2.default)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return $1ec6ed07ef4e0151$var$React.createElement('div', {
                    className: className,
                    ref: this._setRef,
                    style: (0, $1ec6ed07ef4e0151$var$_extends3.default)({}, outerStyle, style)
                }, children(childParams));
            }
        }
    ]);
    return AutoSizer;
}($1ec6ed07ef4e0151$var$React.PureComponent);
$1ec6ed07ef4e0151$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
$1ec6ed07ef4e0151$var$AutoSizer.propTypes = null;
module.exports.default = $1ec6ed07ef4e0151$var$AutoSizer;

});
parcelRegister("2gFMx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1a6d7c6c067b8cc3$export$1e511d4a378977f5, (v) => $1a6d7c6c067b8cc3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039, (v) => $1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = v);
var $1a6d7c6c067b8cc3$export$1e511d4a378977f5;
var $1a6d7c6c067b8cc3$export$2e2bcd8739ae039;
"use strict";
$1a6d7c6c067b8cc3$export$1e511d4a378977f5 = true;

var $b43x1 = parcelRequire("b43x1");
var $1a6d7c6c067b8cc3$var$_assign2 = $1a6d7c6c067b8cc3$var$_interopRequireDefault($b43x1);
function $1a6d7c6c067b8cc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1a6d7c6c067b8cc3$export$2e2bcd8739ae039 = $1a6d7c6c067b8cc3$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("b43x1", function(module, exports) {

module.exports = {
    "default": (parcelRequire("dyfRa")),
    __esModule: true
};

});
parcelRegister("dyfRa", function(module, exports) {
parcelRequire("kX90m");

module.exports = (parcelRequire("aMwpa")).Object.assign;

});
parcelRegister("kX90m", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S + $e03XD.F, 'Object', {
    assign: (parcelRequire("3ksdV"))
});

});
parcelRegister("e03XD", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $bgjSK = parcelRequire("bgjSK");

var $9dqdv = parcelRequire("9dqdv");

var $6Yw7l = parcelRequire("6Yw7l");
var $a314234ee4b1b532$var$PROTOTYPE = 'prototype';
var $a314234ee4b1b532$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a314234ee4b1b532$var$$export.F;
    var IS_GLOBAL = type & $a314234ee4b1b532$var$$export.G;
    var IS_STATIC = type & $a314234ee4b1b532$var$$export.S;
    var IS_PROTO = type & $a314234ee4b1b532$var$$export.P;
    var IS_BIND = type & $a314234ee4b1b532$var$$export.B;
    var IS_WRAP = type & $a314234ee4b1b532$var$$export.W;
    var exports = IS_GLOBAL ? $aMwpa : $aMwpa[name] || ($aMwpa[name] = {});
    var expProto = exports[$a314234ee4b1b532$var$PROTOTYPE];
    var target = IS_GLOBAL ? $Tiymd : IS_STATIC ? $Tiymd[name] : ($Tiymd[name] || {})[$a314234ee4b1b532$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $6Yw7l(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $bgjSK(out, $Tiymd) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$a314234ee4b1b532$var$PROTOTYPE] = C[$a314234ee4b1b532$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $bgjSK(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $a314234ee4b1b532$var$$export.R && expProto && !expProto[key]) $9dqdv(expProto, key, out);
        }
    }
};
// type bitmap
$a314234ee4b1b532$var$$export.F = 1; // forced
$a314234ee4b1b532$var$$export.G = 2; // global
$a314234ee4b1b532$var$$export.S = 4; // static
$a314234ee4b1b532$var$$export.P = 8; // proto
$a314234ee4b1b532$var$$export.B = 16; // bind
$a314234ee4b1b532$var$$export.W = 32; // wrap
$a314234ee4b1b532$var$$export.U = 64; // safe
$a314234ee4b1b532$var$$export.R = 128; // real proto method for `library`
module.exports = $a314234ee4b1b532$var$$export;

});
parcelRegister("Tiymd", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $0a6387701af29dff$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $0a6387701af29dff$var$global; // eslint-disable-line no-undef

});

parcelRegister("aMwpa", function(module, exports) {
var $020692ad8d3771b6$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $020692ad8d3771b6$var$core; // eslint-disable-line no-undef

});

parcelRegister("bgjSK", function(module, exports) {
// optional / simple context binding

var $4PBcz = parcelRequire("4PBcz");
module.exports = function(fn, that, length) {
    $4PBcz(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("4PBcz", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9dqdv", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $aZwDw = parcelRequire("aZwDw");

module.exports = (parcelRequire("6thbX")) ? function(object, key, value) {
    return $hIB01.f(object, key, $aZwDw(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("hIB01", function(module, exports) {

$parcel$export(module.exports, "f", () => $ce633f0d6980c4c2$export$2d1720544b23b823, (v) => $ce633f0d6980c4c2$export$2d1720544b23b823 = v);
var $ce633f0d6980c4c2$export$2d1720544b23b823;

var $jdpF7 = parcelRequire("jdpF7");

var $8MNgS = parcelRequire("8MNgS");

var $5s3nY = parcelRequire("5s3nY");
var $ce633f0d6980c4c2$var$dP = Object.defineProperty;

$ce633f0d6980c4c2$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $jdpF7(O);
    P = $5s3nY(P, true);
    $jdpF7(Attributes);
    if ($8MNgS) try {
        return $ce633f0d6980c4c2$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("jdpF7", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");
module.exports = function(it) {
    if (!$1zFdr(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("1zFdr", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("8MNgS", function(module, exports) {



module.exports = !(parcelRequire("6thbX")) && !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty((parcelRequire("4Py1Y"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("6thbX", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("iNaFM"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iNaFM", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("4Py1Y", function(module, exports) {

var $1zFdr = parcelRequire("1zFdr");

var $Tiymd = parcelRequire("Tiymd");
var $384652aa420d7c34$require$document = $Tiymd.document;
// typeof document.createElement is 'object' in old IE
var $384652aa420d7c34$var$is = $1zFdr($384652aa420d7c34$require$document) && $1zFdr($384652aa420d7c34$require$document.createElement);
module.exports = function(it) {
    return $384652aa420d7c34$var$is ? $384652aa420d7c34$require$document.createElement(it) : {};
};

});


parcelRegister("5s3nY", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $1zFdr = parcelRequire("1zFdr");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$1zFdr(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$1zFdr(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("aZwDw", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("6Yw7l", function(module, exports) {
var $5141428ca4d1c535$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5141428ca4d1c535$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("3ksdV", function(module, exports) {
'use strict';

var $6thbX = parcelRequire("6thbX");

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");

var $7kYU6 = parcelRequire("7kYU6");

var $2RBhn = parcelRequire("2RBhn");
var $26c921fb558de49c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$26c921fb558de49c$var$$assign || (parcelRequire("iNaFM"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $26c921fb558de49c$var$$assign({}, A)[S] != 7 || Object.keys($26c921fb558de49c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7kYU6(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $gz5yj.f;
    var isEnum = $lEu8b.f;
    while(aLen > index){
        var S = $2RBhn(arguments[index++]);
        var keys = getSymbols ? $3Qq35(S).concat(getSymbols(S)) : $3Qq35(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6thbX || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $26c921fb558de49c$var$$assign;

});
parcelRegister("3Qq35", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $6QCVe = parcelRequire("6QCVe");

var $c5IyZ = parcelRequire("c5IyZ");
module.exports = Object.keys || function keys(O) {
    return $6QCVe(O, $c5IyZ);
};

});
parcelRegister("6QCVe", function(module, exports) {

var $6Yw7l = parcelRequire("6Yw7l");

var $uZdCX = parcelRequire("uZdCX");

var $4fc5ca8c2d339bcd$var$arrayIndexOf = (parcelRequire("3oulG"))(false);

var $4fc5ca8c2d339bcd$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $uZdCX(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $4fc5ca8c2d339bcd$var$IE_PROTO) $6Yw7l(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6Yw7l(O, key = names[i++])) ~$4fc5ca8c2d339bcd$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("uZdCX", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $2RBhn = parcelRequire("2RBhn");

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return $2RBhn($9NV8H(it));
};

});
parcelRegister("2RBhn", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $7A4P0 = parcelRequire("7A4P0");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $7A4P0(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("7A4P0", function(module, exports) {
var $584fa2a9599a1920$var$toString = {}.toString;
module.exports = function(it) {
    return $584fa2a9599a1920$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("9NV8H", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("3oulG", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $uZdCX = parcelRequire("uZdCX");

var $fTg1r = parcelRequire("fTg1r");

var $eF7Pk = parcelRequire("eF7Pk");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $uZdCX($this);
        var length = $fTg1r(O.length);
        var index = $eF7Pk(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fTg1r", function(module, exports) {
// 7.1.15 ToLength

var $3xWSq = parcelRequire("3xWSq");
var $b9186bc652284f3b$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b9186bc652284f3b$var$min($3xWSq(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("3xWSq", function(module, exports) {
// 7.1.4 ToInteger
var $29521fe616939884$var$ceil = Math.ceil;
var $29521fe616939884$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $29521fe616939884$var$floor : $29521fe616939884$var$ceil)(it);
};

});


parcelRegister("eF7Pk", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");
var $aacaf747231c5347$var$max = Math.max;
var $aacaf747231c5347$var$min = Math.min;
module.exports = function(index, length) {
    index = $3xWSq(index);
    return index < 0 ? $aacaf747231c5347$var$max(index + length, 0) : $aacaf747231c5347$var$min(index, length);
};

});


parcelRegister("2xdmx", function(module, exports) {

var $1d89075ef1733bd9$var$shared = (parcelRequire("kCZia"))('keys');

var $b1OOh = parcelRequire("b1OOh");
module.exports = function(key) {
    return $1d89075ef1733bd9$var$shared[key] || ($1d89075ef1733bd9$var$shared[key] = $b1OOh(key));
};

});
parcelRegister("kCZia", function(module, exports) {

var $aMwpa = parcelRequire("aMwpa");

var $Tiymd = parcelRequire("Tiymd");
var $f046e68e3b8c4e69$var$SHARED = '__core-js_shared__';
var $f046e68e3b8c4e69$var$store = $Tiymd[$f046e68e3b8c4e69$var$SHARED] || ($Tiymd[$f046e68e3b8c4e69$var$SHARED] = {});

(module.exports = function(key, value) {
    return $f046e68e3b8c4e69$var$store[key] || ($f046e68e3b8c4e69$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $aMwpa.version,
    mode: (parcelRequire("2isa8")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("2isa8", function(module, exports) {
module.exports = true;

});


parcelRegister("b1OOh", function(module, exports) {
var $8077337b366c5b6b$var$id = 0;
var $8077337b366c5b6b$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8077337b366c5b6b$var$id + $8077337b366c5b6b$var$px).toString(36));
};

});



parcelRegister("c5IyZ", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("gz5yj", function(module, exports) {

$parcel$export(module.exports, "f", () => $c0f438d0690feeb2$export$2d1720544b23b823, (v) => $c0f438d0690feeb2$export$2d1720544b23b823 = v);
var $c0f438d0690feeb2$export$2d1720544b23b823;
$c0f438d0690feeb2$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("lEu8b", function(module, exports) {

$parcel$export(module.exports, "f", () => $fc34b4c94ea102c2$export$2d1720544b23b823, (v) => $fc34b4c94ea102c2$export$2d1720544b23b823 = v);
var $fc34b4c94ea102c2$export$2d1720544b23b823;
$fc34b4c94ea102c2$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("7kYU6", function(module, exports) {
// 7.1.13 ToObject(argument)

var $9NV8H = parcelRequire("9NV8H");
module.exports = function(it) {
    return Object($9NV8H(it));
};

});






parcelRegister("cLNRv", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5NbMn")),
    __esModule: true
};

});
parcelRegister("5NbMn", function(module, exports) {
parcelRequire("hGEQI");

module.exports = (parcelRequire("aMwpa")).Object.getPrototypeOf;

});
parcelRegister("hGEQI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7kYU6 = parcelRequire("7kYU6");

var $3prgy = parcelRequire("3prgy");

(parcelRequire("2EilE"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $3prgy($7kYU6(it));
    };
});

});
parcelRegister("3prgy", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $6Yw7l = parcelRequire("6Yw7l");

var $7kYU6 = parcelRequire("7kYU6");

var $27b8db5922169ed5$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $27b8db5922169ed5$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7kYU6(O);
    if ($6Yw7l(O, $27b8db5922169ed5$var$IE_PROTO)) return O[$27b8db5922169ed5$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $27b8db5922169ed5$var$ObjectProto : null;
};

});

parcelRegister("2EilE", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $e03XD = parcelRequire("e03XD");

var $aMwpa = parcelRequire("aMwpa");

var $iNaFM = parcelRequire("iNaFM");
module.exports = function(KEY, exec) {
    var fn = ($aMwpa.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $e03XD($e03XD.S + $e03XD.F * $iNaFM(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("jO9Ex", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e6ba2caaec6e7c87$export$1e511d4a378977f5, (v) => $e6ba2caaec6e7c87$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e6ba2caaec6e7c87$export$2e2bcd8739ae039, (v) => $e6ba2caaec6e7c87$export$2e2bcd8739ae039 = v);
var $e6ba2caaec6e7c87$export$1e511d4a378977f5;
var $e6ba2caaec6e7c87$export$2e2bcd8739ae039;
"use strict";
$e6ba2caaec6e7c87$export$1e511d4a378977f5 = true;
$e6ba2caaec6e7c87$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("i2meQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d219a9fc8d9b72f7$export$1e511d4a378977f5, (v) => $d219a9fc8d9b72f7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d219a9fc8d9b72f7$export$2e2bcd8739ae039, (v) => $d219a9fc8d9b72f7$export$2e2bcd8739ae039 = v);
var $d219a9fc8d9b72f7$export$1e511d4a378977f5;
var $d219a9fc8d9b72f7$export$2e2bcd8739ae039;
"use strict";
$d219a9fc8d9b72f7$export$1e511d4a378977f5 = true;

var $7uigX = parcelRequire("7uigX");
var $d219a9fc8d9b72f7$var$_defineProperty2 = $d219a9fc8d9b72f7$var$_interopRequireDefault($7uigX);
function $d219a9fc8d9b72f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d219a9fc8d9b72f7$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $d219a9fc8d9b72f7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("7uigX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8QmVP")),
    __esModule: true
};

});
parcelRegister("8QmVP", function(module, exports) {
parcelRequire("29H1v");

var $aMwpa = parcelRequire("aMwpa");
var $6704f7d038ceceea$require$$Object = $aMwpa.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6704f7d038ceceea$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("29H1v", function(module, exports) {

var $e03XD = parcelRequire("e03XD");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$e03XD($e03XD.S + $e03XD.F * !(parcelRequire("6thbX")), 'Object', {
    defineProperty: (parcelRequire("hIB01")).f
});

});




parcelRegister("aMQVq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7da770f13281a945$export$1e511d4a378977f5, (v) => $7da770f13281a945$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7da770f13281a945$export$2e2bcd8739ae039, (v) => $7da770f13281a945$export$2e2bcd8739ae039 = v);
var $7da770f13281a945$export$1e511d4a378977f5;
var $7da770f13281a945$export$2e2bcd8739ae039;
"use strict";
$7da770f13281a945$export$1e511d4a378977f5 = true;

var $iKXrS = parcelRequire("iKXrS");
var $7da770f13281a945$var$_typeof3 = $7da770f13281a945$var$_interopRequireDefault($iKXrS);
function $7da770f13281a945$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7da770f13281a945$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $7da770f13281a945$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("iKXrS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $da7aa32252e16ce7$export$1e511d4a378977f5, (v) => $da7aa32252e16ce7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $da7aa32252e16ce7$export$2e2bcd8739ae039, (v) => $da7aa32252e16ce7$export$2e2bcd8739ae039 = v);
var $da7aa32252e16ce7$export$1e511d4a378977f5;
var $da7aa32252e16ce7$export$2e2bcd8739ae039;
"use strict";
$da7aa32252e16ce7$export$1e511d4a378977f5 = true;

var $9XWro = parcelRequire("9XWro");
var $da7aa32252e16ce7$var$_iterator2 = $da7aa32252e16ce7$var$_interopRequireDefault($9XWro);

var $2580X = parcelRequire("2580X");
var $da7aa32252e16ce7$var$_symbol2 = $da7aa32252e16ce7$var$_interopRequireDefault($2580X);
var $da7aa32252e16ce7$var$_typeof = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && typeof $da7aa32252e16ce7$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $da7aa32252e16ce7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$da7aa32252e16ce7$export$2e2bcd8739ae039 = typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && $da7aa32252e16ce7$var$_typeof($da7aa32252e16ce7$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $da7aa32252e16ce7$var$_symbol2.default === "function" && obj.constructor === $da7aa32252e16ce7$var$_symbol2.default && obj !== $da7aa32252e16ce7$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $da7aa32252e16ce7$var$_typeof(obj);
};

});
parcelRegister("9XWro", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2HsZd")),
    __esModule: true
};

});
parcelRegister("2HsZd", function(module, exports) {
parcelRequire("hk0a3");
parcelRequire("5rlu9");

module.exports = (parcelRequire("lBMLV")).f('iterator');

});
parcelRegister("hk0a3", function(module, exports) {
'use strict';

var $c9c46de7c8e907ca$var$$at = (parcelRequire("8KGAK"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("hvCN6"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $c9c46de7c8e907ca$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("8KGAK", function(module, exports) {

var $3xWSq = parcelRequire("3xWSq");

var $9NV8H = parcelRequire("9NV8H");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($9NV8H(that));
        var i = $3xWSq(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("hvCN6", function(module, exports) {
'use strict';

var $2isa8 = parcelRequire("2isa8");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $dyqaq = parcelRequire("dyqaq");

var $a5wrg = parcelRequire("a5wrg");

var $3prgy = parcelRequire("3prgy");

var $cbf36bfa64a1f0ac$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $cbf36bfa64a1f0ac$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $cbf36bfa64a1f0ac$var$FF_ITERATOR = '@@iterator';
var $cbf36bfa64a1f0ac$var$KEYS = 'keys';
var $cbf36bfa64a1f0ac$var$VALUES = 'values';
var $cbf36bfa64a1f0ac$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $dyqaq(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$cbf36bfa64a1f0ac$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $cbf36bfa64a1f0ac$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $cbf36bfa64a1f0ac$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $cbf36bfa64a1f0ac$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$cbf36bfa64a1f0ac$var$ITERATOR] || proto[$cbf36bfa64a1f0ac$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $3prgy($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $a5wrg(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$2isa8 && typeof IteratorPrototype[$cbf36bfa64a1f0ac$var$ITERATOR] != 'function') $9dqdv(IteratorPrototype, $cbf36bfa64a1f0ac$var$ITERATOR, $cbf36bfa64a1f0ac$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $cbf36bfa64a1f0ac$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$2isa8 || FORCED) && ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG || !proto[$cbf36bfa64a1f0ac$var$ITERATOR])) $9dqdv(proto, $cbf36bfa64a1f0ac$var$ITERATOR, $default);
    // Plug for library
    $4CSvb[NAME] = $default;
    $4CSvb[TAG] = $cbf36bfa64a1f0ac$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($cbf36bfa64a1f0ac$var$VALUES),
            keys: IS_SET ? $default : getMethod($cbf36bfa64a1f0ac$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $5DcrY(proto, key, methods[key]);
        } else $e03XD($e03XD.P + $e03XD.F * ($cbf36bfa64a1f0ac$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("5DcrY", function(module, exports) {

module.exports = (parcelRequire("9dqdv"));

});

parcelRegister("4CSvb", function(module, exports) {
module.exports = {};

});

parcelRegister("dyqaq", function(module, exports) {
'use strict';

var $3FikI = parcelRequire("3FikI");

var $aZwDw = parcelRequire("aZwDw");

var $a5wrg = parcelRequire("a5wrg");
var $9de2bf9b22f167c8$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9dqdv"))($9de2bf9b22f167c8$var$IteratorPrototype, (parcelRequire("3DTJ3"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $3FikI($9de2bf9b22f167c8$var$IteratorPrototype, {
        next: $aZwDw(1, next)
    });
    $a5wrg(Constructor, NAME + ' Iterator');
};

});
parcelRegister("3FikI", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $jdpF7 = parcelRequire("jdpF7");

var $kbx7w = parcelRequire("kbx7w");

var $c5IyZ = parcelRequire("c5IyZ");

var $2ab36c008f37c78f$var$IE_PROTO = (parcelRequire("2xdmx"))('IE_PROTO');
var $2ab36c008f37c78f$var$Empty = function() {};
var $2ab36c008f37c78f$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $2ab36c008f37c78f$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("4Py1Y"))('iframe');
    var i = $c5IyZ.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("eCthJ")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $2ab36c008f37c78f$var$createDict = iframeDocument.F;
    while(i--)delete $2ab36c008f37c78f$var$createDict[$2ab36c008f37c78f$var$PROTOTYPE][$c5IyZ[i]];
    return $2ab36c008f37c78f$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = $jdpF7(O);
        result = new $2ab36c008f37c78f$var$Empty();
        $2ab36c008f37c78f$var$Empty[$2ab36c008f37c78f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$2ab36c008f37c78f$var$IE_PROTO] = O;
    } else result = $2ab36c008f37c78f$var$createDict();
    return Properties === undefined ? result : $kbx7w(result, Properties);
};

});
parcelRegister("kbx7w", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");

var $jdpF7 = parcelRequire("jdpF7");

var $3Qq35 = parcelRequire("3Qq35");

module.exports = (parcelRequire("6thbX")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $jdpF7(O);
    var keys = $3Qq35(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$hIB01.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("eCthJ", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");
var $aa4b54b56aabc8f8$require$document = $Tiymd.document;
module.exports = $aa4b54b56aabc8f8$require$document && $aa4b54b56aabc8f8$require$document.documentElement;

});


parcelRegister("a5wrg", function(module, exports) {

var $hIB01 = parcelRequire("hIB01");
var $758388ae4ea0e5d2$require$def = $hIB01.f;

var $6Yw7l = parcelRequire("6Yw7l");

var $758388ae4ea0e5d2$var$TAG = (parcelRequire("3DTJ3"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$6Yw7l(it = stat ? it : it.prototype, $758388ae4ea0e5d2$var$TAG)) $758388ae4ea0e5d2$require$def(it, $758388ae4ea0e5d2$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("3DTJ3", function(module, exports) {

var $2a703d8d80c0db95$var$store = (parcelRequire("kCZia"))('wks');

var $b1OOh = parcelRequire("b1OOh");

var $Tiymd = parcelRequire("Tiymd");
var $2a703d8d80c0db95$require$Symbol = $Tiymd.Symbol;
var $2a703d8d80c0db95$var$USE_SYMBOL = typeof $2a703d8d80c0db95$require$Symbol == 'function';
var $2a703d8d80c0db95$var$$exports = module.exports = function(name) {
    return $2a703d8d80c0db95$var$store[name] || ($2a703d8d80c0db95$var$store[name] = $2a703d8d80c0db95$var$USE_SYMBOL && $2a703d8d80c0db95$require$Symbol[name] || ($2a703d8d80c0db95$var$USE_SYMBOL ? $2a703d8d80c0db95$require$Symbol : $b1OOh)('Symbol.' + name));
};
$2a703d8d80c0db95$var$$exports.store = $2a703d8d80c0db95$var$store;

});





parcelRegister("5rlu9", function(module, exports) {
parcelRequire("apb0F");

var $Tiymd = parcelRequire("Tiymd");

var $9dqdv = parcelRequire("9dqdv");

var $4CSvb = parcelRequire("4CSvb");

var $3f6023eca5f868be$var$TO_STRING_TAG = (parcelRequire("3DTJ3"))('toStringTag');
var $3f6023eca5f868be$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $3f6023eca5f868be$var$i = 0; $3f6023eca5f868be$var$i < $3f6023eca5f868be$var$DOMIterables.length; $3f6023eca5f868be$var$i++){
    var $3f6023eca5f868be$var$NAME = $3f6023eca5f868be$var$DOMIterables[$3f6023eca5f868be$var$i];
    var $3f6023eca5f868be$var$Collection = $Tiymd[$3f6023eca5f868be$var$NAME];
    var $3f6023eca5f868be$var$proto = $3f6023eca5f868be$var$Collection && $3f6023eca5f868be$var$Collection.prototype;
    if ($3f6023eca5f868be$var$proto && !$3f6023eca5f868be$var$proto[$3f6023eca5f868be$var$TO_STRING_TAG]) $9dqdv($3f6023eca5f868be$var$proto, $3f6023eca5f868be$var$TO_STRING_TAG, $3f6023eca5f868be$var$NAME);
    $4CSvb[$3f6023eca5f868be$var$NAME] = $4CSvb.Array;
}

});
parcelRegister("apb0F", function(module, exports) {
'use strict';

var $fxxRc = parcelRequire("fxxRc");

var $jL8LP = parcelRequire("jL8LP");

var $4CSvb = parcelRequire("4CSvb");

var $uZdCX = parcelRequire("uZdCX");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("hvCN6"))(Array, 'Array', function(iterated, kind) {
    this._t = $uZdCX(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $jL8LP(1);
    }
    if (kind == 'keys') return $jL8LP(0, index);
    if (kind == 'values') return $jL8LP(0, O[index]);
    return $jL8LP(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$4CSvb.Arguments = $4CSvb.Array;
$fxxRc('keys');
$fxxRc('values');
$fxxRc('entries');

});
parcelRegister("fxxRc", function(module, exports) {
module.exports = function() {};

});

parcelRegister("jL8LP", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("lBMLV", function(module, exports) {

$parcel$export(module.exports, "f", () => $fbb2e2c9b90a0797$export$2d1720544b23b823, (v) => $fbb2e2c9b90a0797$export$2d1720544b23b823 = v);
var $fbb2e2c9b90a0797$export$2d1720544b23b823;

$fbb2e2c9b90a0797$export$2d1720544b23b823 = (parcelRequire("3DTJ3"));

});



parcelRegister("2580X", function(module, exports) {

module.exports = {
    "default": (parcelRequire("9nPi6")),
    __esModule: true
};

});
parcelRegister("9nPi6", function(module, exports) {
parcelRequire("4TBu4");
parcelRequire("aVDCP");
parcelRequire("cJaq8");
parcelRequire("hkNGV");

module.exports = (parcelRequire("aMwpa")).Symbol;

});
parcelRegister("4TBu4", function(module, exports) {
'use strict';

var $Tiymd = parcelRequire("Tiymd");

var $6Yw7l = parcelRequire("6Yw7l");

var $6thbX = parcelRequire("6thbX");

var $e03XD = parcelRequire("e03XD");

var $5DcrY = parcelRequire("5DcrY");

var $bmXMY = parcelRequire("bmXMY");
var $39096007c19b2cf3$require$META = $bmXMY.KEY;

var $iNaFM = parcelRequire("iNaFM");

var $kCZia = parcelRequire("kCZia");

var $a5wrg = parcelRequire("a5wrg");

var $b1OOh = parcelRequire("b1OOh");

var $3DTJ3 = parcelRequire("3DTJ3");

var $lBMLV = parcelRequire("lBMLV");

var $5JZxk = parcelRequire("5JZxk");

var $7oGik = parcelRequire("7oGik");

var $2txWS = parcelRequire("2txWS");

var $jdpF7 = parcelRequire("jdpF7");

var $1zFdr = parcelRequire("1zFdr");

var $7kYU6 = parcelRequire("7kYU6");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $aZwDw = parcelRequire("aZwDw");

var $3FikI = parcelRequire("3FikI");

var $hbWGp = parcelRequire("hbWGp");

var $42GOE = parcelRequire("42GOE");

var $gz5yj = parcelRequire("gz5yj");

var $hIB01 = parcelRequire("hIB01");

var $3Qq35 = parcelRequire("3Qq35");
var $39096007c19b2cf3$var$gOPD = $42GOE.f;
var $39096007c19b2cf3$var$dP = $hIB01.f;
var $39096007c19b2cf3$var$gOPN = $hbWGp.f;
var $39096007c19b2cf3$var$$Symbol = $Tiymd.Symbol;
var $39096007c19b2cf3$var$$JSON = $Tiymd.JSON;
var $39096007c19b2cf3$var$_stringify = $39096007c19b2cf3$var$$JSON && $39096007c19b2cf3$var$$JSON.stringify;
var $39096007c19b2cf3$var$PROTOTYPE = 'prototype';
var $39096007c19b2cf3$var$HIDDEN = $3DTJ3('_hidden');
var $39096007c19b2cf3$var$TO_PRIMITIVE = $3DTJ3('toPrimitive');
var $39096007c19b2cf3$var$isEnum = {}.propertyIsEnumerable;
var $39096007c19b2cf3$var$SymbolRegistry = $kCZia('symbol-registry');
var $39096007c19b2cf3$var$AllSymbols = $kCZia('symbols');
var $39096007c19b2cf3$var$OPSymbols = $kCZia('op-symbols');
var $39096007c19b2cf3$var$ObjectProto = Object[$39096007c19b2cf3$var$PROTOTYPE];
var $39096007c19b2cf3$var$USE_NATIVE = typeof $39096007c19b2cf3$var$$Symbol == 'function' && !!$gz5yj.f;
var $39096007c19b2cf3$var$QObject = $Tiymd.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $39096007c19b2cf3$var$setter = !$39096007c19b2cf3$var$QObject || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE] || !$39096007c19b2cf3$var$QObject[$39096007c19b2cf3$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $39096007c19b2cf3$var$setSymbolDesc = $6thbX && $iNaFM(function() {
    return $3FikI($39096007c19b2cf3$var$dP({}, 'a', {
        get: function() {
            return $39096007c19b2cf3$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $39096007c19b2cf3$var$gOPD($39096007c19b2cf3$var$ObjectProto, key);
    if (protoDesc) delete $39096007c19b2cf3$var$ObjectProto[key];
    $39096007c19b2cf3$var$dP(it, key, D);
    if (protoDesc && it !== $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$dP($39096007c19b2cf3$var$ObjectProto, key, protoDesc);
} : $39096007c19b2cf3$var$dP;
var $39096007c19b2cf3$var$wrap = function(tag) {
    var sym = $39096007c19b2cf3$var$AllSymbols[tag] = $3FikI($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $39096007c19b2cf3$var$isSymbol = $39096007c19b2cf3$var$USE_NATIVE && typeof $39096007c19b2cf3$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $39096007c19b2cf3$var$$Symbol;
};
var $39096007c19b2cf3$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $39096007c19b2cf3$var$ObjectProto) $39096007c19b2cf3$var$$defineProperty($39096007c19b2cf3$var$OPSymbols, key, D);
    $jdpF7(it);
    key = $5s3nY(key, true);
    $jdpF7(D);
    if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$6Yw7l(it, $39096007c19b2cf3$var$HIDDEN)) $39096007c19b2cf3$var$dP(it, $39096007c19b2cf3$var$HIDDEN, $aZwDw(1, {}));
            it[$39096007c19b2cf3$var$HIDDEN][key] = true;
        } else {
            if ($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key]) it[$39096007c19b2cf3$var$HIDDEN][key] = false;
            D = $3FikI(D, {
                enumerable: $aZwDw(0, false)
            });
        }
        return $39096007c19b2cf3$var$setSymbolDesc(it, key, D);
    }
    return $39096007c19b2cf3$var$dP(it, key, D);
};
var $39096007c19b2cf3$var$$defineProperties = function defineProperties(it, P) {
    $jdpF7(it);
    var keys = $7oGik(P = $uZdCX(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$39096007c19b2cf3$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $39096007c19b2cf3$var$$create = function create(it, P) {
    return P === undefined ? $3FikI(it) : $39096007c19b2cf3$var$$defineProperties($3FikI(it), P);
};
var $39096007c19b2cf3$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $39096007c19b2cf3$var$isEnum.call(this, key = $5s3nY(key, true));
    if (this === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return false;
    return E || !$6Yw7l(this, key) || !$6Yw7l($39096007c19b2cf3$var$AllSymbols, key) || $6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && this[$39096007c19b2cf3$var$HIDDEN][key] ? E : true;
};
var $39096007c19b2cf3$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $uZdCX(it);
    key = $5s3nY(key, true);
    if (it === $39096007c19b2cf3$var$ObjectProto && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !$6Yw7l($39096007c19b2cf3$var$OPSymbols, key)) return;
    var D = $39096007c19b2cf3$var$gOPD(it, key);
    if (D && $6Yw7l($39096007c19b2cf3$var$AllSymbols, key) && !($6Yw7l(it, $39096007c19b2cf3$var$HIDDEN) && it[$39096007c19b2cf3$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $39096007c19b2cf3$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $39096007c19b2cf3$var$gOPN($uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && key != $39096007c19b2cf3$var$HIDDEN && key != $39096007c19b2cf3$require$META) result.push(key);
    return result;
};
var $39096007c19b2cf3$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $39096007c19b2cf3$var$ObjectProto;
    var names = $39096007c19b2cf3$var$gOPN(IS_OP ? $39096007c19b2cf3$var$OPSymbols : $uZdCX(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($6Yw7l($39096007c19b2cf3$var$AllSymbols, key = names[i++]) && (IS_OP ? $6Yw7l($39096007c19b2cf3$var$ObjectProto, key) : true)) result.push($39096007c19b2cf3$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$39096007c19b2cf3$var$USE_NATIVE) {
    $39096007c19b2cf3$var$$Symbol = function Symbol() {
        if (this instanceof $39096007c19b2cf3$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $b1OOh(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $39096007c19b2cf3$var$ObjectProto) $set.call($39096007c19b2cf3$var$OPSymbols, value);
            if ($6Yw7l(this, $39096007c19b2cf3$var$HIDDEN) && $6Yw7l(this[$39096007c19b2cf3$var$HIDDEN], tag)) this[$39096007c19b2cf3$var$HIDDEN][tag] = false;
            $39096007c19b2cf3$var$setSymbolDesc(this, tag, $aZwDw(1, value));
        };
        if ($6thbX && $39096007c19b2cf3$var$setter) $39096007c19b2cf3$var$setSymbolDesc($39096007c19b2cf3$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $39096007c19b2cf3$var$wrap(tag);
    };
    $5DcrY($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $42GOE.f = $39096007c19b2cf3$var$$getOwnPropertyDescriptor;
    $hIB01.f = $39096007c19b2cf3$var$$defineProperty;
    (parcelRequire("52EsI")).f = $hbWGp.f = $39096007c19b2cf3$var$$getOwnPropertyNames;
    (parcelRequire("lEu8b")).f = $39096007c19b2cf3$var$$propertyIsEnumerable;
    $gz5yj.f = $39096007c19b2cf3$var$$getOwnPropertySymbols;
    if ($6thbX && !(parcelRequire("2isa8"))) $5DcrY($39096007c19b2cf3$var$ObjectProto, 'propertyIsEnumerable', $39096007c19b2cf3$var$$propertyIsEnumerable, true);
    $lBMLV.f = function(name) {
        return $39096007c19b2cf3$var$wrap($3DTJ3(name));
    };
}
$e03XD($e03XD.G + $e03XD.W + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, {
    Symbol: $39096007c19b2cf3$var$$Symbol
});
for(var $39096007c19b2cf3$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $39096007c19b2cf3$var$j = 0; $39096007c19b2cf3$var$es6Symbols.length > $39096007c19b2cf3$var$j;)$3DTJ3($39096007c19b2cf3$var$es6Symbols[$39096007c19b2cf3$var$j++]);
for(var $39096007c19b2cf3$var$wellKnownSymbols = $3Qq35($3DTJ3.store), $39096007c19b2cf3$var$k = 0; $39096007c19b2cf3$var$wellKnownSymbols.length > $39096007c19b2cf3$var$k;)$5JZxk($39096007c19b2cf3$var$wellKnownSymbols[$39096007c19b2cf3$var$k++]);
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $6Yw7l($39096007c19b2cf3$var$SymbolRegistry, key += '') ? $39096007c19b2cf3$var$SymbolRegistry[key] : $39096007c19b2cf3$var$SymbolRegistry[key] = $39096007c19b2cf3$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$39096007c19b2cf3$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $39096007c19b2cf3$var$SymbolRegistry)if ($39096007c19b2cf3$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $39096007c19b2cf3$var$setter = true;
    },
    useSimple: function() {
        $39096007c19b2cf3$var$setter = false;
    }
});
$e03XD($e03XD.S + $e03XD.F * !$39096007c19b2cf3$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $39096007c19b2cf3$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $39096007c19b2cf3$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $39096007c19b2cf3$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $39096007c19b2cf3$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $39096007c19b2cf3$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $39096007c19b2cf3$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES = $iNaFM(function() {
    $gz5yj.f(1);
});
$e03XD($e03XD.S + $e03XD.F * $39096007c19b2cf3$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $gz5yj.f($7kYU6(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$39096007c19b2cf3$var$$JSON && $e03XD($e03XD.S + $e03XD.F * (!$39096007c19b2cf3$var$USE_NATIVE || $iNaFM(function() {
    var S = $39096007c19b2cf3$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $39096007c19b2cf3$var$_stringify([
        S
    ]) != '[null]' || $39096007c19b2cf3$var$_stringify({
        a: S
    }) != '{}' || $39096007c19b2cf3$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$1zFdr(replacer) && it === undefined || $39096007c19b2cf3$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$2txWS(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$39096007c19b2cf3$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $39096007c19b2cf3$var$_stringify.apply($39096007c19b2cf3$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE][$39096007c19b2cf3$var$TO_PRIMITIVE] || (parcelRequire("9dqdv"))($39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE], $39096007c19b2cf3$var$TO_PRIMITIVE, $39096007c19b2cf3$var$$Symbol[$39096007c19b2cf3$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$a5wrg($39096007c19b2cf3$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$a5wrg(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$a5wrg($Tiymd.JSON, 'JSON', true);

});
parcelRegister("bmXMY", function(module, exports) {

var $8470209bd5646a6f$var$META = (parcelRequire("b1OOh"))('meta');

var $1zFdr = parcelRequire("1zFdr");

var $6Yw7l = parcelRequire("6Yw7l");

var $hIB01 = parcelRequire("hIB01");
var $8470209bd5646a6f$require$setDesc = $hIB01.f;
var $8470209bd5646a6f$var$id = 0;
var $8470209bd5646a6f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8470209bd5646a6f$var$FREEZE = !(parcelRequire("iNaFM"))(function() {
    return $8470209bd5646a6f$var$isExtensible(Object.preventExtensions({}));
});
var $8470209bd5646a6f$var$setMeta = function(it) {
    $8470209bd5646a6f$require$setDesc(it, $8470209bd5646a6f$var$META, {
        value: {
            i: 'O' + ++$8470209bd5646a6f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8470209bd5646a6f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$1zFdr(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return object ID
    }
    return it[$8470209bd5646a6f$var$META].i;
};
var $8470209bd5646a6f$var$getWeak = function(it, create) {
    if (!$6Yw7l(it, $8470209bd5646a6f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8470209bd5646a6f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8470209bd5646a6f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8470209bd5646a6f$var$META].w;
};
// add metadata on freeze-family methods calling
var $8470209bd5646a6f$var$onFreeze = function(it) {
    if ($8470209bd5646a6f$var$FREEZE && $8470209bd5646a6f$var$meta.NEED && $8470209bd5646a6f$var$isExtensible(it) && !$6Yw7l(it, $8470209bd5646a6f$var$META)) $8470209bd5646a6f$var$setMeta(it);
    return it;
};
var $8470209bd5646a6f$var$meta = module.exports = {
    KEY: $8470209bd5646a6f$var$META,
    NEED: false,
    fastKey: $8470209bd5646a6f$var$fastKey,
    getWeak: $8470209bd5646a6f$var$getWeak,
    onFreeze: $8470209bd5646a6f$var$onFreeze
};

});

parcelRegister("5JZxk", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $2isa8 = parcelRequire("2isa8");

var $lBMLV = parcelRequire("lBMLV");

var $hIB01 = parcelRequire("hIB01");
var $42e0e392b78d557f$require$defineProperty = $hIB01.f;
module.exports = function(name) {
    var $Symbol = $aMwpa.Symbol || ($aMwpa.Symbol = $2isa8 ? {} : $Tiymd.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $42e0e392b78d557f$require$defineProperty($Symbol, name, {
        value: $lBMLV.f(name)
    });
};

});

parcelRegister("7oGik", function(module, exports) {
// all enumerable object keys, includes symbols

var $3Qq35 = parcelRequire("3Qq35");

var $gz5yj = parcelRequire("gz5yj");

var $lEu8b = parcelRequire("lEu8b");
module.exports = function(it) {
    var result = $3Qq35(it);
    var getSymbols = $gz5yj.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $lEu8b.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("2txWS", function(module, exports) {
// 7.2.2 IsArray(argument)

var $7A4P0 = parcelRequire("7A4P0");
module.exports = Array.isArray || function isArray(arg) {
    return $7A4P0(arg) == 'Array';
};

});

parcelRegister("hbWGp", function(module, exports) {

$parcel$export(module.exports, "f", () => $c840fbf7ee23ffb8$export$2d1720544b23b823, (v) => $c840fbf7ee23ffb8$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $c840fbf7ee23ffb8$export$2d1720544b23b823;

var $uZdCX = parcelRequire("uZdCX");

var $52EsI = parcelRequire("52EsI");
var $c840fbf7ee23ffb8$require$gOPN = $52EsI.f;
var $c840fbf7ee23ffb8$var$toString = {}.toString;
var $c840fbf7ee23ffb8$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $c840fbf7ee23ffb8$var$getWindowNames = function(it) {
    try {
        return $c840fbf7ee23ffb8$require$gOPN(it);
    } catch (e) {
        return $c840fbf7ee23ffb8$var$windowNames.slice();
    }
};
$c840fbf7ee23ffb8$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $c840fbf7ee23ffb8$var$windowNames && $c840fbf7ee23ffb8$var$toString.call(it) == '[object Window]' ? $c840fbf7ee23ffb8$var$getWindowNames(it) : $c840fbf7ee23ffb8$require$gOPN($uZdCX(it));
};

});
parcelRegister("52EsI", function(module, exports) {

$parcel$export(module.exports, "f", () => $3abc8693f4d46e8c$export$2d1720544b23b823, (v) => $3abc8693f4d46e8c$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $3abc8693f4d46e8c$export$2d1720544b23b823;

var $6QCVe = parcelRequire("6QCVe");

var $3abc8693f4d46e8c$var$hiddenKeys = (parcelRequire("c5IyZ")).concat('length', 'prototype');
$3abc8693f4d46e8c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $6QCVe(O, $3abc8693f4d46e8c$var$hiddenKeys);
};

});


parcelRegister("42GOE", function(module, exports) {

$parcel$export(module.exports, "f", () => $2f188fb35aa5638e$export$2d1720544b23b823, (v) => $2f188fb35aa5638e$export$2d1720544b23b823 = v);
var $2f188fb35aa5638e$export$2d1720544b23b823;

var $lEu8b = parcelRequire("lEu8b");

var $aZwDw = parcelRequire("aZwDw");

var $uZdCX = parcelRequire("uZdCX");

var $5s3nY = parcelRequire("5s3nY");

var $6Yw7l = parcelRequire("6Yw7l");

var $8MNgS = parcelRequire("8MNgS");
var $2f188fb35aa5638e$var$gOPD = Object.getOwnPropertyDescriptor;

$2f188fb35aa5638e$export$2d1720544b23b823 = (parcelRequire("6thbX")) ? $2f188fb35aa5638e$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $uZdCX(O);
    P = $5s3nY(P, true);
    if ($8MNgS) try {
        return $2f188fb35aa5638e$var$gOPD(O, P);
    } catch (e) {}
    if ($6Yw7l(O, P)) return $aZwDw(!$lEu8b.f.call(O, P), O[P]);
};

});


parcelRegister("aVDCP", function(module, exports) {

});

parcelRegister("cJaq8", function(module, exports) {

(parcelRequire("5JZxk"))('asyncIterator');

});

parcelRegister("hkNGV", function(module, exports) {

(parcelRequire("5JZxk"))('observable');

});





parcelRegister("5taqD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3fb7c0111f5c0ef4$export$1e511d4a378977f5, (v) => $3fb7c0111f5c0ef4$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039, (v) => $3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = v);
var $3fb7c0111f5c0ef4$export$1e511d4a378977f5;
var $3fb7c0111f5c0ef4$export$2e2bcd8739ae039;
"use strict";
$3fb7c0111f5c0ef4$export$1e511d4a378977f5 = true;

var $ephCu = parcelRequire("ephCu");
var $3fb7c0111f5c0ef4$var$_setPrototypeOf2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($ephCu);

var $9nmSg = parcelRequire("9nmSg");
var $3fb7c0111f5c0ef4$var$_create2 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($9nmSg);

var $iKXrS = parcelRequire("iKXrS");
var $3fb7c0111f5c0ef4$var$_typeof3 = $3fb7c0111f5c0ef4$var$_interopRequireDefault($iKXrS);
function $3fb7c0111f5c0ef4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$3fb7c0111f5c0ef4$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $3fb7c0111f5c0ef4$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $3fb7c0111f5c0ef4$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default ? (0, $3fb7c0111f5c0ef4$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("ephCu", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jbw8H")),
    __esModule: true
};

});
parcelRegister("jbw8H", function(module, exports) {
parcelRequire("8YZNe");

module.exports = (parcelRequire("aMwpa")).Object.setPrototypeOf;

});
parcelRegister("8YZNe", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $e03XD = parcelRequire("e03XD");

$e03XD($e03XD.S, 'Object', {
    setPrototypeOf: (parcelRequire("cAIQR")).set
});

});
parcelRegister("cAIQR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $1zFdr = parcelRequire("1zFdr");

var $jdpF7 = parcelRequire("jdpF7");
var $92aba36f6b06a026$var$check = function(O, proto) {
    $jdpF7(O);
    if (!$1zFdr(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bgjSK"))(Function.call, (parcelRequire("42GOE")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $92aba36f6b06a026$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $92aba36f6b06a026$var$check
};

});




parcelRegister("9nmSg", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bFuWU")),
    __esModule: true
};

});
parcelRegister("bFuWU", function(module, exports) {
parcelRequire("1zGUv");

var $aMwpa = parcelRequire("aMwpa");
var $87eb87e70ca19670$require$$Object = $aMwpa.Object;
module.exports = function create(P, D) {
    return $87eb87e70ca19670$require$$Object.create(P, D);
};

});
parcelRegister("1zGUv", function(module, exports) {

var $e03XD = parcelRequire("e03XD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$e03XD($e03XD.S, 'Object', {
    create: (parcelRequire("3FikI"))
});

});




parcelRegister("jq35C", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e232d790bb1068b6$var$createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $e232d790bb1068b6$var$createDetectElementResize(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                // Store reference to original instantiated scrollListener so it can be unbound later
                element.__scrollListener__ = scrollListener;
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                if (element.__scrollListener__) element.removeEventListener('scroll', element.__scrollListener__, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}

});



parcelRegister("exjqP", function(module, exports) {

$parcel$export(module.exports, "skeleton", () => $a953387fb9afd3de$export$2a0674ff2eb10214, (v) => $a953387fb9afd3de$export$2a0674ff2eb10214 = v);
var $a953387fb9afd3de$export$2a0674ff2eb10214;
$a953387fb9afd3de$export$2a0674ff2eb10214 = `wVb0Qa_skeleton`;

});


parcelRegister("9Ar1p", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;

var $erA1x = parcelRequire("erA1x");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $6fac6fcbd0494802$var$_interopRequireDefault($erA1x).default;
    }
});
Object.defineProperty(module.exports, 'List', {
    enumerable: true,
    get: function get() {
        return $6fac6fcbd0494802$var$_interopRequireDefault($erA1x).default;
    }
});

var $dxEUb = parcelRequire("dxEUb");
function $6fac6fcbd0494802$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_RowRendererParams = $dxEUb.bpfrpt_proptype_RowRendererParams;

});
parcelRegister("erA1x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $a83f87e024b189b5$var$_extends3 = $a83f87e024b189b5$var$_interopRequireDefault($2gFMx);

var $4Oajx = parcelRequire("4Oajx");
var $a83f87e024b189b5$var$_getOwnPropertyDescriptor2 = $a83f87e024b189b5$var$_interopRequireDefault($4Oajx);

var $cLNRv = parcelRequire("cLNRv");
var $a83f87e024b189b5$var$_getPrototypeOf2 = $a83f87e024b189b5$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $a83f87e024b189b5$var$_classCallCheck3 = $a83f87e024b189b5$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $a83f87e024b189b5$var$_createClass3 = $a83f87e024b189b5$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $a83f87e024b189b5$var$_possibleConstructorReturn3 = $a83f87e024b189b5$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $a83f87e024b189b5$var$_inherits3 = $a83f87e024b189b5$var$_interopRequireDefault($5taqD);

var $ef5CW = parcelRequire("ef5CW");
var $a83f87e024b189b5$var$_Grid2 = $a83f87e024b189b5$var$_interopRequireDefault($ef5CW);

var $eUqFw = parcelRequire("eUqFw");
var $a83f87e024b189b5$var$React = $a83f87e024b189b5$var$_interopRequireWildcard($eUqFw);

var $96Bek = parcelRequire("96Bek");
var $a83f87e024b189b5$var$_clsx2 = $a83f87e024b189b5$var$_interopRequireDefault($96Bek);
parcelRequire("dxEUb");

var $1Qivz = parcelRequire("1Qivz");
var $a83f87e024b189b5$var$_propTypes2 = $a83f87e024b189b5$var$_interopRequireDefault($1Qivz);
function $a83f87e024b189b5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a83f87e024b189b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $a83f87e024b189b5$var$List = function(_React$PureComponent) {
    (0, $a83f87e024b189b5$var$_inherits3.default)(List, _React$PureComponent);
    function List() {
        var _ref;
        var _temp, _this, _ret;
        (0, $a83f87e024b189b5$var$_classCallCheck3.default)(this, List);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $a83f87e024b189b5$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $a83f87e024b189b5$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
            var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var _Object$getOwnPropert = (0, $a83f87e024b189b5$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
            if (writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        }, _this._setRef = function(ref) {
            _this.Grid = ref;
        }, _this._onScroll = function(_ref3) {
            var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, _this._onSectionRendered = function(_ref4) {
            var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        }, _temp), (0, $a83f87e024b189b5$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $a83f87e024b189b5$var$_createClass3.default)(List, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref5) {
                var alignment = _ref5.alignment, index = _ref5.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return _scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref6) {
                var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                var classNames = (0, $a83f87e024b189b5$var$_clsx2.default)('ReactVirtualized__List', className);
                return $a83f87e024b189b5$var$React.createElement($a83f87e024b189b5$var$_Grid2.default, (0, $a83f87e024b189b5$var$_extends3.default)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($a83f87e024b189b5$var$React.PureComponent);
$a83f87e024b189b5$var$List.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $ef5CW.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
$a83f87e024b189b5$var$List.propTypes = null;
module.exports.default = $a83f87e024b189b5$var$List;

});
parcelRegister("4Oajx", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jYMHo")),
    __esModule: true
};

});
parcelRegister("jYMHo", function(module, exports) {
parcelRequire("irNNq");

var $aMwpa = parcelRequire("aMwpa");
var $e8b9657e862f46c1$require$$Object = $aMwpa.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $e8b9657e862f46c1$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("irNNq", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $uZdCX = parcelRequire("uZdCX");

var $42GOE = parcelRequire("42GOE");
var $d6e1601a79b4c957$require$$getOwnPropertyDescriptor = $42GOE.f;

(parcelRequire("2EilE"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $d6e1601a79b4c957$require$$getOwnPropertyDescriptor($uZdCX(it), key);
    };
});

});



parcelRegister("ef5CW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;

var $aJhAp = parcelRequire("aJhAp");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($aJhAp).default;
    }
});
Object.defineProperty(module.exports, 'Grid', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($aJhAp).default;
    }
});

var $ilwr8 = parcelRequire("ilwr8");
Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($ilwr8).default;
    }
});

var $lnAVU = parcelRequire("lnAVU");
Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($lnAVU).default;
    }
});

var $9NKvi = parcelRequire("9NKvi");
Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $a5e6d4d489078780$var$_interopRequireDefault($9NKvi).default;
    }
});

var $fZGp7 = parcelRequire("fZGp7");
function $a5e6d4d489078780$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_NoContentRenderer = $fZGp7.bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Alignment = $fZGp7.bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_CellPosition = $fZGp7.bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellSize = $fZGp7.bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $fZGp7.bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_RenderedSection = $fZGp7.bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_CellRendererParams = $fZGp7.bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_Scroll = $fZGp7.bpfrpt_proptype_Scroll;

});
parcelRegister("aJhAp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var $b43x1 = parcelRequire("b43x1");
var $7cfbbfa2eb960813$var$_assign2 = $7cfbbfa2eb960813$var$_interopRequireDefault($b43x1);

var $2gFMx = parcelRequire("2gFMx");
var $7cfbbfa2eb960813$var$_extends3 = $7cfbbfa2eb960813$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $7cfbbfa2eb960813$var$_getPrototypeOf2 = $7cfbbfa2eb960813$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $7cfbbfa2eb960813$var$_classCallCheck3 = $7cfbbfa2eb960813$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $7cfbbfa2eb960813$var$_createClass3 = $7cfbbfa2eb960813$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $7cfbbfa2eb960813$var$_possibleConstructorReturn3 = $7cfbbfa2eb960813$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $7cfbbfa2eb960813$var$_inherits3 = $7cfbbfa2eb960813$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $7cfbbfa2eb960813$var$React = $7cfbbfa2eb960813$var$_interopRequireWildcard($eUqFw);

var $96Bek = parcelRequire("96Bek");
var $7cfbbfa2eb960813$var$_clsx2 = $7cfbbfa2eb960813$var$_interopRequireDefault($96Bek);

var $k8xXW = parcelRequire("k8xXW");
var $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $7cfbbfa2eb960813$var$_interopRequireDefault($k8xXW);

var $31nq4 = parcelRequire("31nq4");
var $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2 = $7cfbbfa2eb960813$var$_interopRequireDefault($31nq4);

var $4utlP = parcelRequire("4utlP");
var $7cfbbfa2eb960813$var$_createCallbackMemoizer2 = $7cfbbfa2eb960813$var$_interopRequireDefault($4utlP);

var $9NKvi = parcelRequire("9NKvi");
var $7cfbbfa2eb960813$var$_defaultOverscanIndicesGetter2 = $7cfbbfa2eb960813$var$_interopRequireDefault($9NKvi);

var $5tGzo = parcelRequire("5tGzo");
var $7cfbbfa2eb960813$var$_updateScrollIndexHelper2 = $7cfbbfa2eb960813$var$_interopRequireDefault($5tGzo);

var $lnAVU = parcelRequire("lnAVU");
var $7cfbbfa2eb960813$var$_defaultCellRangeRenderer2 = $7cfbbfa2eb960813$var$_interopRequireDefault($lnAVU);

var $481BX = parcelRequire("481BX");
var $7cfbbfa2eb960813$var$_scrollbarSize2 = $7cfbbfa2eb960813$var$_interopRequireDefault($481BX);

var $8ZYKi = parcelRequire("8ZYKi");

var $cgVPq = parcelRequire("cgVPq");
parcelRequire("fZGp7");

var $1Qivz = parcelRequire("1Qivz");
var $7cfbbfa2eb960813$var$_propTypes2 = $7cfbbfa2eb960813$var$_interopRequireDefault($1Qivz);
function $7cfbbfa2eb960813$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $7cfbbfa2eb960813$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $7cfbbfa2eb960813$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $7cfbbfa2eb960813$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $7cfbbfa2eb960813$var$Grid = function(_React$PureComponent) {
    (0, $7cfbbfa2eb960813$var$_inherits3.default)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        (0, $7cfbbfa2eb960813$var$_classCallCheck3.default)(this, Grid);
        var _this = (0, $7cfbbfa2eb960813$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $7cfbbfa2eb960813$var$_getPrototypeOf2.default)(Grid)).call(this, props));
        _this._onGridRenderedMemoizer = (0, $7cfbbfa2eb960813$var$_createCallbackMemoizer2.default)();
        _this._onScrollMemoizer = (0, $7cfbbfa2eb960813$var$_createCallbackMemoizer2.default)(false);
        _this._deferredInvalidateColumnIndex = null;
        _this._deferredInvalidateRowIndex = null;
        _this._recomputeScrollLeftFlag = false;
        _this._recomputeScrollTopFlag = false;
        _this._horizontalScrollBarSize = 0;
        _this._verticalScrollBarSize = 0;
        _this._scrollbarPresenceChanged = false;
        _this._renderedColumnStartIndex = 0;
        _this._renderedColumnStopIndex = 0;
        _this._renderedRowStartIndex = 0;
        _this._renderedRowStopIndex = 0;
        _this._styleCache = {};
        _this._cellCache = {};
        _this._debounceScrollEndedCallback = function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        };
        _this._invokeOnGridRenderedHelper = function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        };
        _this._setScrollingContainerRef = function(ref) {
            _this._scrollingContainer = ref;
        };
        _this._onScroll = function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        };
        var columnSizeAndPositionManager = new $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $7cfbbfa2eb960813$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $9NKvi.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $9NKvi.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $7cfbbfa2eb960813$var$_createClass3.default)(Grid, [
        {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = (0, $7cfbbfa2eb960813$var$_extends3.default)({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: _scrollDirectionHorizontal,
                        scrollDirectionVertical: _scrollDirectionVertical,
                        scrollPositionChangeReason: $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: 'measureAllCells',
            value: function measureAllCells() {
                var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $9NKvi.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $9NKvi.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $7cfbbfa2eb960813$var$_extends3.default)({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $7cfbbfa2eb960813$var$_extends3.default)({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = (0, $7cfbbfa2eb960813$var$_extends3.default)({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $7cfbbfa2eb960813$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $7cfbbfa2eb960813$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $cgVPq.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $7cfbbfa2eb960813$var$React.createElement('div', (0, $7cfbbfa2eb960813$var$_extends3.default)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: (0, $7cfbbfa2eb960813$var$_clsx2.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: (0, $7cfbbfa2eb960813$var$_extends3.default)({}, gridStyle, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $7cfbbfa2eb960813$var$React.createElement('div', {
                    className: 'ReactVirtualized__Grid__innerScrollContainer',
                    role: containerRole,
                    style: (0, $7cfbbfa2eb960813$var$_extends3.default)({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $cgVPq.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $cgVPq.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: '_handleInvalidatedGridSize',
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: '_isScrolling',
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    _onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: 'scrollToPosition',
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = rowIndex + '-' + columnIndex;
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $7cfbbfa2eb960813$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $7cfbbfa2eb960813$var$_assign2.default)(newState, {
                    isScrolling: false
                });
                var maybeStateA = void 0;
                var maybeStateB = void 0;
                (0, $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $7cfbbfa2eb960813$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return (0, $7cfbbfa2eb960813$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
            }
        },
        {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: '_getScrollToPositionStateUpdate',
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $7cfbbfa2eb960813$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $9NKvi.SCROLL_DIRECTION_FORWARD : $9NKvi.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return null;
            }
        },
        {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return null;
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return null;
            }
        }
    ]);
    return Grid;
}($7cfbbfa2eb960813$var$React.PureComponent);
$7cfbbfa2eb960813$var$Grid.defaultProps = {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $7cfbbfa2eb960813$var$_defaultCellRangeRenderer2.default,
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $7cfbbfa2eb960813$var$_scrollbarSize2.default,
    noContentRenderer: $7cfbbfa2eb960813$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $7cfbbfa2eb960813$var$_defaultOverscanIndicesGetter2.default,
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $7cfbbfa2eb960813$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
};
$7cfbbfa2eb960813$var$Grid.propTypes = null;
(0, $8ZYKi.polyfill)($7cfbbfa2eb960813$var$Grid);
module.exports.default = $7cfbbfa2eb960813$var$Grid;

});
parcelRegister("96Bek", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $6a118db2bfbd3b63$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $6a118db2bfbd3b63$export$2e2bcd8739ae039);
function $6a118db2bfbd3b63$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $6a118db2bfbd3b63$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $6a118db2bfbd3b63$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $6a118db2bfbd3b63$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6a118db2bfbd3b63$export$2e2bcd8739ae039 = $6a118db2bfbd3b63$export$4f5d2d50c9deca37;

});

parcelRegister("k8xXW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea8ee6ec6e63e350$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
function $ea8ee6ec6e63e350$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
} /**
 * Helper method that determines when to recalculate row or column metadata.
 */ 

});

parcelRegister("31nq4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gVLwd = parcelRequire("gVLwd");
var $2333a1bb6a614a22$var$_objectWithoutProperties3 = $2333a1bb6a614a22$var$_interopRequireDefault($gVLwd);

var $jO9Ex = parcelRequire("jO9Ex");
var $2333a1bb6a614a22$var$_classCallCheck3 = $2333a1bb6a614a22$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $2333a1bb6a614a22$var$_createClass3 = $2333a1bb6a614a22$var$_interopRequireDefault($i2meQ);

var $3ejTS = parcelRequire("3ejTS");
var $2333a1bb6a614a22$var$_CellSizeAndPositionManager2 = $2333a1bb6a614a22$var$_interopRequireDefault($3ejTS);

var $2ylln = parcelRequire("2ylln");
parcelRequire("fZGp7");
function $2333a1bb6a614a22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ var $2333a1bb6a614a22$var$ScalingCellSizeAndPositionManager = function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $2ylln.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $2333a1bb6a614a22$var$_objectWithoutProperties3.default)(_ref, [
            'maxScrollSize'
        ]);
        (0, $2333a1bb6a614a22$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $2333a1bb6a614a22$var$_CellSizeAndPositionManager2.default(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $2333a1bb6a614a22$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: 'configure',
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: '_getOffsetPercentage',
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: '_offsetToSafeOffset',
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: '_safeOffsetToOffset',
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();
module.exports.default = $2333a1bb6a614a22$var$ScalingCellSizeAndPositionManager;

});
parcelRegister("gVLwd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c536d4703bbbb0c3$export$1e511d4a378977f5, (v) => $c536d4703bbbb0c3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c536d4703bbbb0c3$export$2e2bcd8739ae039, (v) => $c536d4703bbbb0c3$export$2e2bcd8739ae039 = v);
var $c536d4703bbbb0c3$export$1e511d4a378977f5;
var $c536d4703bbbb0c3$export$2e2bcd8739ae039;
"use strict";
$c536d4703bbbb0c3$export$1e511d4a378977f5 = true;
$c536d4703bbbb0c3$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("3ejTS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jO9Ex = parcelRequire("jO9Ex");
var $25a21db070ec1535$var$_classCallCheck3 = $25a21db070ec1535$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $25a21db070ec1535$var$_createClass3 = $25a21db070ec1535$var$_interopRequireDefault($i2meQ);
parcelRequire("fZGp7");
function $25a21db070ec1535$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $25a21db070ec1535$var$CellSizeAndPositionManager = function() {
    // Used in deferred mode to track which cells have been queued for measurement.
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $25a21db070ec1535$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
        this._cellSizeAndPositionData = {};
        this._lastMeasuredIndex = -1;
        this._lastBatchedIndex = -1;
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    (0, $25a21db070ec1535$var$_createClass3.default)(CellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: 'configure',
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var _size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                        else if (_size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: _size
                            };
                            _offset += _size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset = void 0;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: '_binarySearch',
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (_currentOffset === offset) return middle;
                    else if (_currentOffset < offset) low = middle + 1;
                    else if (_currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: '_exponentialSearch',
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: '_findNearestCell',
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();
module.exports.default = $25a21db070ec1535$var$CellSizeAndPositionManager;

});
parcelRegister("fZGp7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;

var $eUqFw = parcelRequire("eUqFw");
var $ba4d72155e399ed9$var$React = $ba4d72155e399ed9$var$_interopRequireWildcard($eUqFw);

var $31nq4 = parcelRequire("31nq4");
var $ba4d72155e399ed9$var$_ScalingCellSizeAndPositionManager2 = $ba4d72155e399ed9$var$_interopRequireDefault($31nq4);

var $1Qivz = parcelRequire("1Qivz");
var $ba4d72155e399ed9$var$_propTypes2 = $ba4d72155e399ed9$var$_interopRequireDefault($1Qivz);
function $ba4d72155e399ed9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba4d72155e399ed9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellPosition = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRendererParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellCache = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_StyleCache = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRendererParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellSizeGetter = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_CellSize = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_NoContentRenderer = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_Scroll = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_RenderedSection = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndices = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetter = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_Alignment = null;
var $ba4d72155e399ed9$var$bpfrpt_proptype_VisibleCellRange = null;
module.exports.bpfrpt_proptype_CellPosition = $ba4d72155e399ed9$var$bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellRendererParams = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_CellRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRenderer;
module.exports.bpfrpt_proptype_CellCache = $ba4d72155e399ed9$var$bpfrpt_proptype_CellCache;
module.exports.bpfrpt_proptype_StyleCache = $ba4d72155e399ed9$var$bpfrpt_proptype_StyleCache;
module.exports.bpfrpt_proptype_CellRangeRendererParams = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRendererParams;
module.exports.bpfrpt_proptype_CellRangeRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_CellRangeRenderer;
module.exports.bpfrpt_proptype_CellSizeGetter = $ba4d72155e399ed9$var$bpfrpt_proptype_CellSizeGetter;
module.exports.bpfrpt_proptype_CellSize = $ba4d72155e399ed9$var$bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_NoContentRenderer = $ba4d72155e399ed9$var$bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Scroll = $ba4d72155e399ed9$var$bpfrpt_proptype_Scroll;
module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $ba4d72155e399ed9$var$bpfrpt_proptype_ScrollbarPresenceChange;
module.exports.bpfrpt_proptype_RenderedSection = $ba4d72155e399ed9$var$bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetterParams;
module.exports.bpfrpt_proptype_OverscanIndices = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndices;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $ba4d72155e399ed9$var$bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_Alignment = $ba4d72155e399ed9$var$bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_VisibleCellRange = $ba4d72155e399ed9$var$bpfrpt_proptype_VisibleCellRange;

});


parcelRegister("2ylln", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1dbf502ca906ddfc$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $1dbf502ca906ddfc$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $1dbf502ca906ddfc$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $1dbf502ca906ddfc$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $1dbf502ca906ddfc$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
    if ($1dbf502ca906ddfc$var$isBrowser()) {
        if ($1dbf502ca906ddfc$var$isChrome()) return $1dbf502ca906ddfc$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $1dbf502ca906ddfc$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("4utlP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $azEBZ = parcelRequire("azEBZ");
var $3450bb4705ca52c7$var$_keys2 = $3450bb4705ca52c7$var$_interopRequireDefault($azEBZ);
module.exports.default = $3450bb4705ca52c7$var$createCallbackMemoizer;
function $3450bb4705ca52c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $3450bb4705ca52c7$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = (0, $3450bb4705ca52c7$var$_keys2.default)(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== (0, $3450bb4705ca52c7$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});
parcelRegister("azEBZ", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gJgtb")),
    __esModule: true
};

});
parcelRegister("gJgtb", function(module, exports) {
parcelRequire("9g03F");

module.exports = (parcelRequire("aMwpa")).Object.keys;

});
parcelRegister("9g03F", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $7kYU6 = parcelRequire("7kYU6");

var $3Qq35 = parcelRequire("3Qq35");

(parcelRequire("2EilE"))('keys', function() {
    return function keys(it) {
        return $3Qq35($7kYU6(it));
    };
});

});




parcelRegister("9NKvi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $722cc35a1fb8e99b$var$defaultOverscanIndicesGetter;
parcelRequire("fZGp7");
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $722cc35a1fb8e99b$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $722cc35a1fb8e99b$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $722cc35a1fb8e99b$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("5tGzo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fd0aea55027c20b$var$updateScrollIndexHelper;

var $31nq4 = parcelRequire("31nq4");
var $3fd0aea55027c20b$var$_ScalingCellSizeAndPositionManager2 = $3fd0aea55027c20b$var$_interopRequireDefault($31nq4);
parcelRequire("fZGp7");
function $3fd0aea55027c20b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ function $3fd0aea55027c20b$var$updateScrollIndexHelper(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("lnAVU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f908651aa22b7255$var$defaultCellRangeRenderer;
parcelRequire("fZGp7");
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $f908651aa22b7255$var$defaultCellRangeRenderer(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = rowIndex + '-' + columnIndex;
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $f908651aa22b7255$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("481BX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $301928ba4065172c$export$2e2bcd8739ae039);

var $kxHHB = parcelRequire("kxHHB");
var $301928ba4065172c$var$size;
function $301928ba4065172c$export$2e2bcd8739ae039(recalc) {
    if (!$301928ba4065172c$var$size && $301928ba4065172c$var$size !== 0 || recalc) {
        if (0, $kxHHB.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $301928ba4065172c$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $301928ba4065172c$var$size;
}

});
parcelRegister("kxHHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef48ca18c424d99b$export$2e2bcd8739ae039);
var $ef48ca18c424d99b$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("8ZYKi", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $68d32415568f42e4$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $68d32415568f42e4$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $68d32415568f42e4$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $68d32415568f42e4$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$68d32415568f42e4$var$componentWillMount.__suppressDeprecationWarning = true;
$68d32415568f42e4$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$68d32415568f42e4$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $68d32415568f42e4$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $68d32415568f42e4$var$componentWillMount;
        prototype.componentWillReceiveProps = $68d32415568f42e4$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $68d32415568f42e4$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("cgVPq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;

var $59fzC = parcelRequire("59fzC");
var $8ef3d62d18a49114$var$_promise2 = $8ef3d62d18a49114$var$_interopRequireDefault($59fzC);

var $wEmhH = parcelRequire("wEmhH");

var $1Qivz = parcelRequire("1Qivz");
var $8ef3d62d18a49114$var$_propTypes2 = $8ef3d62d18a49114$var$_interopRequireDefault($1Qivz);
function $8ef3d62d18a49114$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ef3d62d18a49114$var$bpfrpt_proptype_AnimationTimeoutId = null;
var $8ef3d62d18a49114$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
    return (0, $wEmhH.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $8ef3d62d18a49114$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
    var start = void 0;
    // wait for end of processing current event handler, because event handler may be long
    $8ef3d62d18a49114$var$_promise2.default.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $wEmhH.raf)(timeout);
    };
    var frame = {
        id: (0, $wEmhH.raf)(timeout)
    };
    return frame;
};
module.exports.bpfrpt_proptype_AnimationTimeoutId = $8ef3d62d18a49114$var$bpfrpt_proptype_AnimationTimeoutId;

});
parcelRegister("59fzC", function(module, exports) {

module.exports = {
    "default": (parcelRequire("aC3OD")),
    __esModule: true
};

});
parcelRegister("aC3OD", function(module, exports) {
parcelRequire("aVDCP");
parcelRequire("hk0a3");
parcelRequire("5rlu9");
parcelRequire("eaoPF");
parcelRequire("5qq17");
parcelRequire("2H49b");

module.exports = (parcelRequire("aMwpa")).Promise;

});
parcelRegister("eaoPF", function(module, exports) {
'use strict';

var $2isa8 = parcelRequire("2isa8");

var $Tiymd = parcelRequire("Tiymd");

var $bgjSK = parcelRequire("bgjSK");

var $p6HmC = parcelRequire("p6HmC");

var $e03XD = parcelRequire("e03XD");

var $1zFdr = parcelRequire("1zFdr");

var $4PBcz = parcelRequire("4PBcz");

var $9wuLV = parcelRequire("9wuLV");

var $k9ASi = parcelRequire("k9ASi");

var $dBQKu = parcelRequire("dBQKu");

var $6IlKu = parcelRequire("6IlKu");
var $a505430ed94fbef2$require$task = $6IlKu.set;

var $a505430ed94fbef2$var$microtask = (parcelRequire("4mgac"))();

var $kfXxa = parcelRequire("kfXxa");

var $hZD4L = parcelRequire("hZD4L");

var $gYbfH = parcelRequire("gYbfH");

var $6YzyD = parcelRequire("6YzyD");
var $a505430ed94fbef2$var$PROMISE = 'Promise';
var $a505430ed94fbef2$var$TypeError = $Tiymd.TypeError;
var $a505430ed94fbef2$var$process = $Tiymd.process;
var $a505430ed94fbef2$var$versions = $a505430ed94fbef2$var$process && $a505430ed94fbef2$var$process.versions;
var $a505430ed94fbef2$var$v8 = $a505430ed94fbef2$var$versions && $a505430ed94fbef2$var$versions.v8 || '';
var $a505430ed94fbef2$var$$Promise = $Tiymd[$a505430ed94fbef2$var$PROMISE];
var $a505430ed94fbef2$var$isNode = $p6HmC($a505430ed94fbef2$var$process) == 'process';
var $a505430ed94fbef2$var$empty = function() {};
var $a505430ed94fbef2$var$Internal, $a505430ed94fbef2$var$newGenericPromiseCapability, $a505430ed94fbef2$var$OwnPromiseCapability, $a505430ed94fbef2$var$Wrapper;
var $a505430ed94fbef2$var$newPromiseCapability = $a505430ed94fbef2$var$newGenericPromiseCapability = $kfXxa.f;

var $a505430ed94fbef2$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $a505430ed94fbef2$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("3DTJ3"))('species')] = function(exec) {
            exec($a505430ed94fbef2$var$empty, $a505430ed94fbef2$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($a505430ed94fbef2$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($a505430ed94fbef2$var$empty) instanceof FakePromise && $a505430ed94fbef2$var$v8.indexOf('6.6') !== 0 && $gYbfH.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $a505430ed94fbef2$var$isThenable = function(it) {
    var then;
    return $1zFdr(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $a505430ed94fbef2$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $a505430ed94fbef2$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $a505430ed94fbef2$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($a505430ed94fbef2$var$TypeError('Promise-chain cycle'));
                    else if (then = $a505430ed94fbef2$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $a505430ed94fbef2$var$onUnhandled(promise);
    });
};
var $a505430ed94fbef2$var$onUnhandled = function(promise) {
    $a505430ed94fbef2$require$task.call($Tiymd, function() {
        var value = promise._v;
        var unhandled = $a505430ed94fbef2$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $hZD4L(function() {
                if ($a505430ed94fbef2$var$isNode) $a505430ed94fbef2$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $Tiymd.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $Tiymd.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $a505430ed94fbef2$var$isNode || $a505430ed94fbef2$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $a505430ed94fbef2$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $a505430ed94fbef2$var$onHandleUnhandled = function(promise) {
    $a505430ed94fbef2$require$task.call($Tiymd, function() {
        var handler;
        if ($a505430ed94fbef2$var$isNode) $a505430ed94fbef2$var$process.emit('rejectionHandled', promise);
        else if (handler = $Tiymd.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $a505430ed94fbef2$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $a505430ed94fbef2$var$notify(promise, true);
};
var $a505430ed94fbef2$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $a505430ed94fbef2$var$TypeError("Promise can't be resolved itself");
        if (then = $a505430ed94fbef2$var$isThenable(value)) $a505430ed94fbef2$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $bgjSK($a505430ed94fbef2$var$$resolve, wrapper, 1), $bgjSK($a505430ed94fbef2$var$$reject, wrapper, 1));
            } catch (e) {
                $a505430ed94fbef2$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $a505430ed94fbef2$var$notify(promise, false);
        }
    } catch (e) {
        $a505430ed94fbef2$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$a505430ed94fbef2$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $a505430ed94fbef2$var$$Promise = function Promise(executor) {
        $9wuLV(this, $a505430ed94fbef2$var$$Promise, $a505430ed94fbef2$var$PROMISE, '_h');
        $4PBcz(executor);
        $a505430ed94fbef2$var$Internal.call(this);
        try {
            executor($bgjSK($a505430ed94fbef2$var$$resolve, this, 1), $bgjSK($a505430ed94fbef2$var$$reject, this, 1));
        } catch (err) {
            $a505430ed94fbef2$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $a505430ed94fbef2$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $a505430ed94fbef2$var$Internal.prototype = (parcelRequire("g7Cvi"))($a505430ed94fbef2$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $a505430ed94fbef2$var$newPromiseCapability($dBQKu(this, $a505430ed94fbef2$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $a505430ed94fbef2$var$isNode ? $a505430ed94fbef2$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $a505430ed94fbef2$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $a505430ed94fbef2$var$OwnPromiseCapability = function() {
        var promise = new $a505430ed94fbef2$var$Internal();
        this.promise = promise;
        this.resolve = $bgjSK($a505430ed94fbef2$var$$resolve, promise, 1);
        this.reject = $bgjSK($a505430ed94fbef2$var$$reject, promise, 1);
    };
    $kfXxa.f = $a505430ed94fbef2$var$newPromiseCapability = function(C) {
        return C === $a505430ed94fbef2$var$$Promise || C === $a505430ed94fbef2$var$Wrapper ? new $a505430ed94fbef2$var$OwnPromiseCapability(C) : $a505430ed94fbef2$var$newGenericPromiseCapability(C);
    };
}
$e03XD($e03XD.G + $e03XD.W + $e03XD.F * !$a505430ed94fbef2$var$USE_NATIVE, {
    Promise: $a505430ed94fbef2$var$$Promise
});

(parcelRequire("a5wrg"))($a505430ed94fbef2$var$$Promise, $a505430ed94fbef2$var$PROMISE);

(parcelRequire("9Gqkk"))($a505430ed94fbef2$var$PROMISE);

$a505430ed94fbef2$var$Wrapper = (parcelRequire("aMwpa"))[$a505430ed94fbef2$var$PROMISE];
// statics
$e03XD($e03XD.S + $e03XD.F * !$a505430ed94fbef2$var$USE_NATIVE, $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $a505430ed94fbef2$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$e03XD($e03XD.S + $e03XD.F * ($2isa8 || !$a505430ed94fbef2$var$USE_NATIVE), $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $6YzyD($2isa8 && this === $a505430ed94fbef2$var$Wrapper ? $a505430ed94fbef2$var$$Promise : this, x);
    }
});

$e03XD($e03XD.S + $e03XD.F * !($a505430ed94fbef2$var$USE_NATIVE && (parcelRequire("eg8rn"))(function(iter) {
    $a505430ed94fbef2$var$$Promise.all(iter)['catch']($a505430ed94fbef2$var$empty);
})), $a505430ed94fbef2$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $a505430ed94fbef2$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $hZD4L(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $k9ASi(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $a505430ed94fbef2$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $hZD4L(function() {
            $k9ASi(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("p6HmC", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $7A4P0 = parcelRequire("7A4P0");

var $04b788149bc8f783$var$TAG = (parcelRequire("3DTJ3"))('toStringTag');
// ES3 wrong here
var $04b788149bc8f783$var$ARG = $7A4P0(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $04b788149bc8f783$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $04b788149bc8f783$var$tryGet(O = Object(it), $04b788149bc8f783$var$TAG)) == 'string' ? T : $04b788149bc8f783$var$ARG ? $7A4P0(O) : (B = $7A4P0(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("9wuLV", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("k9ASi", function(module, exports) {

var $bgjSK = parcelRequire("bgjSK");

var $hQZUu = parcelRequire("hQZUu");

var $eMNpK = parcelRequire("eMNpK");

var $jdpF7 = parcelRequire("jdpF7");

var $fTg1r = parcelRequire("fTg1r");

var $jdRm8 = parcelRequire("jdRm8");
var $eac1407e38dfb5a4$var$BREAK = {};
var $eac1407e38dfb5a4$var$RETURN = {};
var $eac1407e38dfb5a4$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $jdRm8(iterable);
    var f = $bgjSK(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($eMNpK(iterFn)) for(length = $fTg1r(iterable.length); length > index; index++){
        result = entries ? f($jdpF7(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $eac1407e38dfb5a4$var$BREAK || result === $eac1407e38dfb5a4$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $hQZUu(iterator, f, step.value, entries);
        if (result === $eac1407e38dfb5a4$var$BREAK || result === $eac1407e38dfb5a4$var$RETURN) return result;
    }
};
$eac1407e38dfb5a4$var$exports.BREAK = $eac1407e38dfb5a4$var$BREAK;
$eac1407e38dfb5a4$var$exports.RETURN = $eac1407e38dfb5a4$var$RETURN;

});
parcelRegister("hQZUu", function(module, exports) {
// call something on iterator step with safe closing on error

var $jdpF7 = parcelRequire("jdpF7");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($jdpF7(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $jdpF7(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("eMNpK", function(module, exports) {
// check on default Array iterator

var $4CSvb = parcelRequire("4CSvb");

var $ac3be1073f35fcf4$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $ac3be1073f35fcf4$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($4CSvb.Array === it || $ac3be1073f35fcf4$var$ArrayProto[$ac3be1073f35fcf4$var$ITERATOR] === it);
};

});

parcelRegister("jdRm8", function(module, exports) {

var $p6HmC = parcelRequire("p6HmC");

var $dfe89e98dd5255eb$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');

var $4CSvb = parcelRequire("4CSvb");

module.exports = (parcelRequire("aMwpa")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$dfe89e98dd5255eb$var$ITERATOR] || it['@@iterator'] || $4CSvb[$p6HmC(it)];
};

});


parcelRegister("dBQKu", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $jdpF7 = parcelRequire("jdpF7");

var $4PBcz = parcelRequire("4PBcz");

var $9e87a5e4ebcc018d$var$SPECIES = (parcelRequire("3DTJ3"))('species');
module.exports = function(O, D) {
    var C = $jdpF7(O).constructor;
    var S;
    return C === undefined || (S = $jdpF7(C)[$9e87a5e4ebcc018d$var$SPECIES]) == undefined ? D : $4PBcz(S);
};

});

parcelRegister("6IlKu", function(module, exports) {

var $bgjSK = parcelRequire("bgjSK");

var $2WlP0 = parcelRequire("2WlP0");

var $eCthJ = parcelRequire("eCthJ");

var $4Py1Y = parcelRequire("4Py1Y");

var $Tiymd = parcelRequire("Tiymd");
var $4e37b90466960a47$var$process = $Tiymd.process;
var $4e37b90466960a47$var$setTask = $Tiymd.setImmediate;
var $4e37b90466960a47$var$clearTask = $Tiymd.clearImmediate;
var $4e37b90466960a47$var$MessageChannel = $Tiymd.MessageChannel;
var $4e37b90466960a47$var$Dispatch = $Tiymd.Dispatch;
var $4e37b90466960a47$var$counter = 0;
var $4e37b90466960a47$var$queue = {};
var $4e37b90466960a47$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $4e37b90466960a47$var$defer, $4e37b90466960a47$var$channel, $4e37b90466960a47$var$port;
var $4e37b90466960a47$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($4e37b90466960a47$var$queue.hasOwnProperty(id)) {
        var fn = $4e37b90466960a47$var$queue[id];
        delete $4e37b90466960a47$var$queue[id];
        fn();
    }
};
var $4e37b90466960a47$var$listener = function(event) {
    $4e37b90466960a47$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$4e37b90466960a47$var$setTask || !$4e37b90466960a47$var$clearTask) {
    $4e37b90466960a47$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $4e37b90466960a47$var$queue[++$4e37b90466960a47$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $2WlP0(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $4e37b90466960a47$var$defer($4e37b90466960a47$var$counter);
        return $4e37b90466960a47$var$counter;
    };
    $4e37b90466960a47$var$clearTask = function clearImmediate(id) {
        delete $4e37b90466960a47$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("7A4P0"))($4e37b90466960a47$var$process) == 'process') $4e37b90466960a47$var$defer = function(id) {
        $4e37b90466960a47$var$process.nextTick($bgjSK($4e37b90466960a47$var$run, id, 1));
    };
    else if ($4e37b90466960a47$var$Dispatch && $4e37b90466960a47$var$Dispatch.now) $4e37b90466960a47$var$defer = function(id) {
        $4e37b90466960a47$var$Dispatch.now($bgjSK($4e37b90466960a47$var$run, id, 1));
    };
    else if ($4e37b90466960a47$var$MessageChannel) {
        $4e37b90466960a47$var$channel = new $4e37b90466960a47$var$MessageChannel();
        $4e37b90466960a47$var$port = $4e37b90466960a47$var$channel.port2;
        $4e37b90466960a47$var$channel.port1.onmessage = $4e37b90466960a47$var$listener;
        $4e37b90466960a47$var$defer = $bgjSK($4e37b90466960a47$var$port.postMessage, $4e37b90466960a47$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($Tiymd.addEventListener && typeof postMessage == 'function' && !$Tiymd.importScripts) {
        $4e37b90466960a47$var$defer = function(id) {
            $Tiymd.postMessage(id + '', '*');
        };
        $Tiymd.addEventListener('message', $4e37b90466960a47$var$listener, false);
    // IE8-
    } else if ($4e37b90466960a47$var$ONREADYSTATECHANGE in $4Py1Y('script')) $4e37b90466960a47$var$defer = function(id) {
        $eCthJ.appendChild($4Py1Y('script'))[$4e37b90466960a47$var$ONREADYSTATECHANGE] = function() {
            $eCthJ.removeChild(this);
            $4e37b90466960a47$var$run.call(id);
        };
    };
    else $4e37b90466960a47$var$defer = function(id) {
        setTimeout($bgjSK($4e37b90466960a47$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $4e37b90466960a47$var$setTask,
    clear: $4e37b90466960a47$var$clearTask
};

});
parcelRegister("2WlP0", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("4mgac", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");

var $6IlKu = parcelRequire("6IlKu");
var $32c5c141c1b31345$require$macrotask = $6IlKu.set;
var $32c5c141c1b31345$var$Observer = $Tiymd.MutationObserver || $Tiymd.WebKitMutationObserver;
var $32c5c141c1b31345$var$process = $Tiymd.process;
var $32c5c141c1b31345$var$Promise = $Tiymd.Promise;

var $32c5c141c1b31345$var$isNode = (parcelRequire("7A4P0"))($32c5c141c1b31345$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($32c5c141c1b31345$var$isNode && (parent = $32c5c141c1b31345$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($32c5c141c1b31345$var$isNode) notify = function() {
        $32c5c141c1b31345$var$process.nextTick(flush);
    };
    else if ($32c5c141c1b31345$var$Observer && !($Tiymd.navigator && $Tiymd.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $32c5c141c1b31345$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($32c5c141c1b31345$var$Promise && $32c5c141c1b31345$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $32c5c141c1b31345$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $32c5c141c1b31345$require$macrotask.call($Tiymd, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("kfXxa", function(module, exports) {

$parcel$export(module.exports, "f", () => $ebf3638c734c9ca8$export$2d1720544b23b823, (v) => $ebf3638c734c9ca8$export$2d1720544b23b823 = v);
var $ebf3638c734c9ca8$export$2d1720544b23b823;
'use strict';

var $4PBcz = parcelRequire("4PBcz");
function $ebf3638c734c9ca8$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4PBcz(resolve);
    this.reject = $4PBcz(reject);
}
$ebf3638c734c9ca8$export$2d1720544b23b823 = function(C) {
    return new $ebf3638c734c9ca8$var$PromiseCapability(C);
};

});

parcelRegister("hZD4L", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("gYbfH", function(module, exports) {

var $Tiymd = parcelRequire("Tiymd");
var $c5aafa5f0b21004e$var$navigator = $Tiymd.navigator;
module.exports = $c5aafa5f0b21004e$var$navigator && $c5aafa5f0b21004e$var$navigator.userAgent || '';

});

parcelRegister("6YzyD", function(module, exports) {

var $jdpF7 = parcelRequire("jdpF7");

var $1zFdr = parcelRequire("1zFdr");

var $kfXxa = parcelRequire("kfXxa");
module.exports = function(C, x) {
    $jdpF7(C);
    if ($1zFdr(x) && x.constructor === C) return x;
    var promiseCapability = $kfXxa.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});

parcelRegister("g7Cvi", function(module, exports) {

var $9dqdv = parcelRequire("9dqdv");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $9dqdv(target, key, src[key]);
    return target;
};

});

parcelRegister("9Gqkk", function(module, exports) {
'use strict';

var $Tiymd = parcelRequire("Tiymd");

var $aMwpa = parcelRequire("aMwpa");

var $hIB01 = parcelRequire("hIB01");

var $6thbX = parcelRequire("6thbX");

var $70cc754bb21625af$var$SPECIES = (parcelRequire("3DTJ3"))('species');
module.exports = function(KEY) {
    var C = typeof $aMwpa[KEY] == 'function' ? $aMwpa[KEY] : $Tiymd[KEY];
    if ($6thbX && C && !C[$70cc754bb21625af$var$SPECIES]) $hIB01.f(C, $70cc754bb21625af$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("eg8rn", function(module, exports) {

var $a6191b73d50b3749$var$ITERATOR = (parcelRequire("3DTJ3"))('iterator');
var $a6191b73d50b3749$var$SAFE_CLOSING = false;
try {
    var $a6191b73d50b3749$var$riter = [
        7
    ][$a6191b73d50b3749$var$ITERATOR]();
    $a6191b73d50b3749$var$riter['return'] = function() {
        $a6191b73d50b3749$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($a6191b73d50b3749$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$a6191b73d50b3749$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$a6191b73d50b3749$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$a6191b73d50b3749$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});


parcelRegister("5qq17", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
'use strict';

var $e03XD = parcelRequire("e03XD");

var $aMwpa = parcelRequire("aMwpa");

var $Tiymd = parcelRequire("Tiymd");

var $dBQKu = parcelRequire("dBQKu");

var $6YzyD = parcelRequire("6YzyD");
$e03XD($e03XD.P + $e03XD.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $dBQKu(this, $aMwpa.Promise || $Tiymd.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $6YzyD(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $6YzyD(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("2H49b", function(module, exports) {
'use strict';

var $e03XD = parcelRequire("e03XD");

var $kfXxa = parcelRequire("kfXxa");

var $hZD4L = parcelRequire("hZD4L");
$e03XD($e03XD.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $kfXxa.f(this);
        var result = $hZD4L(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});



parcelRegister("wEmhH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Properly handle server-side rendering.
var $06224b9dd24e6627$var$win = void 0;
if (typeof window !== 'undefined') $06224b9dd24e6627$var$win = window;
else if (typeof self !== 'undefined') $06224b9dd24e6627$var$win = self;
else $06224b9dd24e6627$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $06224b9dd24e6627$var$request = $06224b9dd24e6627$var$win.requestAnimationFrame || $06224b9dd24e6627$var$win.webkitRequestAnimationFrame || $06224b9dd24e6627$var$win.mozRequestAnimationFrame || $06224b9dd24e6627$var$win.oRequestAnimationFrame || $06224b9dd24e6627$var$win.msRequestAnimationFrame || function(callback) {
    return $06224b9dd24e6627$var$win.setTimeout(callback, 1000 / 60);
};
var $06224b9dd24e6627$var$cancel = $06224b9dd24e6627$var$win.cancelAnimationFrame || $06224b9dd24e6627$var$win.webkitCancelAnimationFrame || $06224b9dd24e6627$var$win.mozCancelAnimationFrame || $06224b9dd24e6627$var$win.oCancelAnimationFrame || $06224b9dd24e6627$var$win.msCancelAnimationFrame || function(id) {
    $06224b9dd24e6627$var$win.clearTimeout(id);
};
var $06224b9dd24e6627$var$raf = module.exports.raf = $06224b9dd24e6627$var$request;
var $06224b9dd24e6627$var$caf = module.exports.caf = $06224b9dd24e6627$var$cancel;

});



parcelRegister("ilwr8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $d5b3596485ff732e$var$defaultOverscanIndicesGetter;
parcelRequire("fZGp7");
var $d5b3596485ff732e$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $d5b3596485ff732e$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $d5b3596485ff732e$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $d5b3596485ff732e$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $d5b3596485ff732e$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $d5b3596485ff732e$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});


parcelRegister("dxEUb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;

var $eUqFw = parcelRequire("eUqFw");
var $9dbe16596f191744$var$React = $9dbe16596f191744$var$_interopRequireWildcard($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $9dbe16596f191744$var$_propTypes2 = $9dbe16596f191744$var$_interopRequireDefault($1Qivz);
function $9dbe16596f191744$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9dbe16596f191744$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $9dbe16596f191744$var$bpfrpt_proptype_RowRendererParams = null;
var $9dbe16596f191744$var$bpfrpt_proptype_RowRenderer = null;
var $9dbe16596f191744$var$bpfrpt_proptype_RenderedRows = null;
var $9dbe16596f191744$var$bpfrpt_proptype_Scroll = null;
module.exports.bpfrpt_proptype_RowRendererParams = $9dbe16596f191744$var$bpfrpt_proptype_RowRendererParams;
module.exports.bpfrpt_proptype_RowRenderer = $9dbe16596f191744$var$bpfrpt_proptype_RowRenderer;
module.exports.bpfrpt_proptype_RenderedRows = $9dbe16596f191744$var$bpfrpt_proptype_RenderedRows;
module.exports.bpfrpt_proptype_Scroll = $9dbe16596f191744$var$bpfrpt_proptype_Scroll;

});



parcelRegister("hoaeP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IS_SCROLLING_TIMEOUT = module.exports.WindowScroller = undefined;

var $jA80F = parcelRequire("jA80F");
var $ca8c9eabfbb6eb3c$var$_WindowScroller2 = $ca8c9eabfbb6eb3c$var$_interopRequireDefault($jA80F);
function $ca8c9eabfbb6eb3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $ca8c9eabfbb6eb3c$var$_WindowScroller2.default;
module.exports.WindowScroller = $ca8c9eabfbb6eb3c$var$_WindowScroller2.default;
module.exports.IS_SCROLLING_TIMEOUT = $jA80F.IS_SCROLLING_TIMEOUT;

});
parcelRegister("jA80F", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IS_SCROLLING_TIMEOUT = undefined;

var $2gFMx = parcelRequire("2gFMx");
var $e41797b3ff4cacd9$var$_extends3 = $e41797b3ff4cacd9$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $e41797b3ff4cacd9$var$_getPrototypeOf2 = $e41797b3ff4cacd9$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $e41797b3ff4cacd9$var$_classCallCheck3 = $e41797b3ff4cacd9$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $e41797b3ff4cacd9$var$_createClass3 = $e41797b3ff4cacd9$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $e41797b3ff4cacd9$var$_possibleConstructorReturn3 = $e41797b3ff4cacd9$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $e41797b3ff4cacd9$var$_inherits3 = $e41797b3ff4cacd9$var$_interopRequireDefault($5taqD);

var $eUqFw = parcelRequire("eUqFw");
var $e41797b3ff4cacd9$var$React = $e41797b3ff4cacd9$var$_interopRequireWildcard($eUqFw);

var $lEfVV = parcelRequire("lEfVV");
var $e41797b3ff4cacd9$var$ReactDOM = $e41797b3ff4cacd9$var$_interopRequireWildcard($lEfVV);

var $lb9cd = parcelRequire("lb9cd");

var $gm6HE = parcelRequire("gm6HE");

var $jq35C = parcelRequire("jq35C");
var $e41797b3ff4cacd9$var$_detectElementResize2 = $e41797b3ff4cacd9$var$_interopRequireDefault($jq35C);

var $1Qivz = parcelRequire("1Qivz");
var $e41797b3ff4cacd9$var$_propTypes2 = $e41797b3ff4cacd9$var$_interopRequireDefault($1Qivz);
function $e41797b3ff4cacd9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e41797b3ff4cacd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $e41797b3ff4cacd9$var$IS_SCROLLING_TIMEOUT = module.exports.IS_SCROLLING_TIMEOUT = 150;
var $e41797b3ff4cacd9$var$getWindow = function getWindow() {
    return typeof window !== 'undefined' ? window : undefined;
};
var $e41797b3ff4cacd9$var$WindowScroller = function(_React$PureComponent) {
    (0, $e41797b3ff4cacd9$var$_inherits3.default)(WindowScroller, _React$PureComponent);
    function WindowScroller() {
        var _ref;
        var _temp, _this, _ret;
        (0, $e41797b3ff4cacd9$var$_classCallCheck3.default)(this, WindowScroller);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $e41797b3ff4cacd9$var$_possibleConstructorReturn3.default)(this, (_ref = WindowScroller.__proto__ || (0, $e41797b3ff4cacd9$var$_getPrototypeOf2.default)(WindowScroller)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._window = $e41797b3ff4cacd9$var$getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = (0, $e41797b3ff4cacd9$var$_extends3.default)({}, (0, $gm6HE.getDimensions)(_this.props.scrollElement, _this.props), {
            isScrolling: false,
            scrollLeft: 0,
            scrollTop: 0
        }), _this._registerChild = function(element) {
            if (element && !(element instanceof Element)) console.warn('WindowScroller registerChild expects to be passed Element or null');
            _this._child = element;
            _this.updatePosition();
        }, _this._onChildScroll = function(_ref2) {
            var scrollTop = _ref2.scrollTop;
            if (_this.state.scrollTop === scrollTop) return;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                if (typeof scrollElement.scrollTo === 'function') scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
                else scrollElement.scrollTop = scrollTop + _this._positionFromTop;
            }
        }, _this._registerResizeListener = function(element) {
            if (element === window) window.addEventListener('resize', _this._onResize, false);
            else _this._detectElementResize.addResizeListener(element, _this._onResize);
        }, _this._unregisterResizeListener = function(element) {
            if (element === window) window.removeEventListener('resize', _this._onResize, false);
            else if (element) _this._detectElementResize.removeResizeListener(element, _this._onResize);
        }, _this._onResize = function() {
            _this.updatePosition();
        }, _this.__handleWindowScrollEvent = function() {
            if (!_this._isMounted) return;
            var onScroll = _this.props.onScroll;
            var scrollElement = _this.props.scrollElement;
            if (scrollElement) {
                var scrollOffset = (0, $gm6HE.getScrollOffset)(scrollElement);
                var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
                var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
                _this.setState({
                    isScrolling: true,
                    scrollLeft: _scrollLeft,
                    scrollTop: _scrollTop
                });
                onScroll({
                    scrollLeft: _scrollLeft,
                    scrollTop: _scrollTop
                });
            }
        }, _this.__resetIsScrolling = function() {
            _this.setState({
                isScrolling: false
            });
        }, _temp), (0, $e41797b3ff4cacd9$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $e41797b3ff4cacd9$var$_createClass3.default)(WindowScroller, [
        {
            key: 'updatePosition',
            value: function updatePosition() {
                var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
                var onResize = this.props.onResize;
                var _state = this.state, height = _state.height, width = _state.width;
                var thisNode = this._child || $e41797b3ff4cacd9$var$ReactDOM.findDOMNode(this);
                if (thisNode instanceof Element && scrollElement) {
                    var offset = (0, $gm6HE.getPositionOffset)(thisNode, scrollElement);
                    this._positionFromTop = offset.top;
                    this._positionFromLeft = offset.left;
                }
                var dimensions = (0, $gm6HE.getDimensions)(scrollElement, this.props);
                if (height !== dimensions.height || width !== dimensions.width) {
                    this.setState({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                    onResize({
                        height: dimensions.height,
                        width: dimensions.width
                    });
                }
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var scrollElement = this.props.scrollElement;
                this._detectElementResize = (0, $e41797b3ff4cacd9$var$_detectElementResize2.default)();
                this.updatePosition(scrollElement);
                if (scrollElement) {
                    (0, $lb9cd.registerScrollListener)(this, scrollElement);
                    this._registerResizeListener(scrollElement);
                }
                this._isMounted = true;
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var scrollElement = this.props.scrollElement;
                var prevScrollElement = prevProps.scrollElement;
                if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
                    this.updatePosition(scrollElement);
                    (0, $lb9cd.unregisterScrollListener)(this, prevScrollElement);
                    (0, $lb9cd.registerScrollListener)(this, scrollElement);
                    this._unregisterResizeListener(prevScrollElement);
                    this._registerResizeListener(scrollElement);
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var scrollElement = this.props.scrollElement;
                if (scrollElement) {
                    (0, $lb9cd.unregisterScrollListener)(this, scrollElement);
                    this._unregisterResizeListener(scrollElement);
                }
                this._isMounted = false;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                var _state2 = this.state, isScrolling = _state2.isScrolling, scrollTop = _state2.scrollTop, scrollLeft = _state2.scrollLeft, height = _state2.height, width = _state2.width;
                return children({
                    onChildScroll: this._onChildScroll,
                    registerChild: this._registerChild,
                    height: height,
                    isScrolling: isScrolling,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    width: width
                });
            }
        }
    ]);
    return WindowScroller;
}($e41797b3ff4cacd9$var$React.PureComponent);
$e41797b3ff4cacd9$var$WindowScroller.defaultProps = {
    onResize: function onResize() {},
    onScroll: function onScroll() {},
    scrollingResetTimeInterval: $e41797b3ff4cacd9$var$IS_SCROLLING_TIMEOUT,
    scrollElement: $e41797b3ff4cacd9$var$getWindow(),
    serverHeight: 0,
    serverWidth: 0
};
$e41797b3ff4cacd9$var$WindowScroller.propTypes = null;
module.exports.default = $e41797b3ff4cacd9$var$WindowScroller;

});
parcelRegister("lb9cd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.registerScrollListener = $f6b1c235c9772b16$var$registerScrollListener;
module.exports.unregisterScrollListener = $f6b1c235c9772b16$var$unregisterScrollListener;

var $cgVPq = parcelRequire("cgVPq");
var $f6b1c235c9772b16$var$mountedInstances = [];
var $f6b1c235c9772b16$var$originalBodyPointerEvents = null;
var $f6b1c235c9772b16$var$disablePointerEventsTimeoutId = null;
function $f6b1c235c9772b16$var$enablePointerEventsIfDisabled() {
    if ($f6b1c235c9772b16$var$disablePointerEventsTimeoutId) {
        $f6b1c235c9772b16$var$disablePointerEventsTimeoutId = null;
        if (document.body && $f6b1c235c9772b16$var$originalBodyPointerEvents != null) document.body.style.pointerEvents = $f6b1c235c9772b16$var$originalBodyPointerEvents;
        $f6b1c235c9772b16$var$originalBodyPointerEvents = null;
    }
}
function $f6b1c235c9772b16$var$enablePointerEventsAfterDelayCallback() {
    $f6b1c235c9772b16$var$enablePointerEventsIfDisabled();
    $f6b1c235c9772b16$var$mountedInstances.forEach(function(instance) {
        return instance.component.__resetIsScrolling();
    });
}
function $f6b1c235c9772b16$var$enablePointerEventsAfterDelay() {
    if ($f6b1c235c9772b16$var$disablePointerEventsTimeoutId) (0, $cgVPq.cancelAnimationTimeout)($f6b1c235c9772b16$var$disablePointerEventsTimeoutId);
    var maximumTimeout = 0;
    $f6b1c235c9772b16$var$mountedInstances.forEach(function(instance) {
        maximumTimeout = Math.max(maximumTimeout, instance.component.props.scrollingResetTimeInterval);
    });
    $f6b1c235c9772b16$var$disablePointerEventsTimeoutId = (0, $cgVPq.requestAnimationTimeout)($f6b1c235c9772b16$var$enablePointerEventsAfterDelayCallback, maximumTimeout);
}
function $f6b1c235c9772b16$var$onScrollWindow(event) {
    if (event.currentTarget === window && $f6b1c235c9772b16$var$originalBodyPointerEvents == null && document.body) {
        $f6b1c235c9772b16$var$originalBodyPointerEvents = document.body.style.pointerEvents;
        document.body.style.pointerEvents = 'none';
    }
    $f6b1c235c9772b16$var$enablePointerEventsAfterDelay();
    $f6b1c235c9772b16$var$mountedInstances.forEach(function(instance) {
        if (instance.element === event.currentTarget) instance.component.__handleWindowScrollEvent();
    });
}
function $f6b1c235c9772b16$var$registerScrollListener(component, element) {
    if (!$f6b1c235c9772b16$var$mountedInstances.some(function(instance) {
        return instance.element === element;
    })) element.addEventListener('scroll', $f6b1c235c9772b16$var$onScrollWindow);
    $f6b1c235c9772b16$var$mountedInstances.push({
        component: component,
        element: element
    });
}
function $f6b1c235c9772b16$var$unregisterScrollListener(component, element) {
    $f6b1c235c9772b16$var$mountedInstances = $f6b1c235c9772b16$var$mountedInstances.filter(function(instance) {
        return instance.component !== component;
    });
    if (!$f6b1c235c9772b16$var$mountedInstances.length || !$f6b1c235c9772b16$var$mountedInstances.some(function(instance) {
        return instance.element === element;
    })) {
        element.removeEventListener('scroll', $f6b1c235c9772b16$var$onScrollWindow);
        if ($f6b1c235c9772b16$var$disablePointerEventsTimeoutId) {
            (0, $cgVPq.cancelAnimationTimeout)($f6b1c235c9772b16$var$disablePointerEventsTimeoutId);
            $f6b1c235c9772b16$var$enablePointerEventsIfDisabled();
        }
    }
}

});

parcelRegister("gm6HE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensions = $be83e6864a683223$var$getDimensions;
module.exports.getPositionOffset = $be83e6864a683223$var$getPositionOffset;
module.exports.getScrollOffset = $be83e6864a683223$var$getScrollOffset;
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */ var $be83e6864a683223$var$isWindow = function isWindow(element) {
    return element === window;
};
// TODO Move this into WindowScroller and import from there
var $be83e6864a683223$var$getBoundingBox = function getBoundingBox(element) {
    return element.getBoundingClientRect();
};
function $be83e6864a683223$var$getDimensions(scrollElement, props) {
    if (!scrollElement) return {
        height: props.serverHeight,
        width: props.serverWidth
    };
    else if ($be83e6864a683223$var$isWindow(scrollElement)) {
        var _window = window, innerHeight = _window.innerHeight, innerWidth = _window.innerWidth;
        return {
            height: typeof innerHeight === 'number' ? innerHeight : 0,
            width: typeof innerWidth === 'number' ? innerWidth : 0
        };
    } else return $be83e6864a683223$var$getBoundingBox(scrollElement);
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */ function $be83e6864a683223$var$getPositionOffset(element, container) {
    if ($be83e6864a683223$var$isWindow(container) && document.documentElement) {
        var containerElement = document.documentElement;
        var elementRect = $be83e6864a683223$var$getBoundingBox(element);
        var containerRect = $be83e6864a683223$var$getBoundingBox(containerElement);
        return {
            top: elementRect.top - containerRect.top,
            left: elementRect.left - containerRect.left
        };
    } else {
        var scrollOffset = $be83e6864a683223$var$getScrollOffset(container);
        var _elementRect = $be83e6864a683223$var$getBoundingBox(element);
        var _containerRect = $be83e6864a683223$var$getBoundingBox(container);
        return {
            top: _elementRect.top + scrollOffset.top - _containerRect.top,
            left: _elementRect.left + scrollOffset.left - _containerRect.left
        };
    }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */ function $be83e6864a683223$var$getScrollOffset(element) {
    if ($be83e6864a683223$var$isWindow(element) && document.documentElement) return {
        top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
        left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
    else return {
        top: element.scrollTop,
        left: element.scrollLeft
    };
}

});



parcelRegister("3dOx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a55947613a667c8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "context", () => (parcelRequire("cxEeq")).context);

var $lNNXV = parcelRequire("lNNXV");

var $uGxVh = parcelRequire("uGxVh");

var $cxEeq = parcelRequire("cxEeq");
var $0a55947613a667c8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $uGxVh.default), {})((0, $cxEeq.default));

});
parcelRegister("uGxVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ced3774be33869b$export$2e2bcd8739ae039);

var $evo53 = parcelRequire("evo53");

var $iK4oF = parcelRequire("iK4oF");
const $1ced3774be33869b$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    stickyHeader: (0, $evo53.getCurrentStickyHeaderGeometry)
});
var $1ced3774be33869b$export$2e2bcd8739ae039 = $1ced3774be33869b$var$mapStateToProps;

});

parcelRegister("cxEeq", function(module, exports) {

$parcel$export(module.exports, "context", () => $a793f5751c382251$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $a793f5751c382251$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $hjlb6 = parcelRequire("hjlb6");

var $feYIf = parcelRequire("feYIf");
const $a793f5751c382251$export$a078c61943f9dbbe = /*#__PURE__*/ (0, $eUqFw.createContext)({
    sticky: false
});
function $a793f5751c382251$export$2e2bcd8739ae039({ sectionId: sectionId = '', containerId: containerId, stickyHeader: stickyHeader, children: children }) {
    if (!stickyHeader) return null;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($feYIf.columnHeaderWrapper, {
        [$feYIf[`${sectionId}ColumnHeaderWrapper`]]: sectionId.length > 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $feYIf.stickHeaderLayout,
        style: {
            // @ts-expect-error - TS2322 - Type '{ heigth: number; width: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
            heigth: stickyHeader.height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a793f5751c382251$export$a078c61943f9dbbe.Provider, {
        value: {
            sticky: true
        }
    }, children))), document.getElementById(containerId) || document.createElement('div'));
}

});
parcelRegister("feYIf", function(module, exports) {

$parcel$export(module.exports, "columnHeaderSection", () => $b187421711100a46$export$f80cc4deee2042b3, (v) => $b187421711100a46$export$f80cc4deee2042b3 = v);
$parcel$export(module.exports, "columnHeaderWrapper", () => $b187421711100a46$export$9a2e0d37cd9f78a8, (v) => $b187421711100a46$export$9a2e0d37cd9f78a8 = v);
$parcel$export(module.exports, "fieldColumnHeaderWrapper", () => $b187421711100a46$export$967a2568e65827b1, (v) => $b187421711100a46$export$967a2568e65827b1 = v);
$parcel$export(module.exports, "portalContainer", () => $b187421711100a46$export$ad0ac4a84a807d3d, (v) => $b187421711100a46$export$ad0ac4a84a807d3d = v);
$parcel$export(module.exports, "scopeColumnHeaderWrapper", () => $b187421711100a46$export$b34ff16ecaf83ff0, (v) => $b187421711100a46$export$b34ff16ecaf83ff0 = v);
$parcel$export(module.exports, "stickHeaderLayout", () => $b187421711100a46$export$e1c875bb407fe8a3, (v) => $b187421711100a46$export$e1c875bb407fe8a3 = v);
var $b187421711100a46$export$f80cc4deee2042b3;
var $b187421711100a46$export$9a2e0d37cd9f78a8;
var $b187421711100a46$export$967a2568e65827b1;
var $b187421711100a46$export$ad0ac4a84a807d3d;
var $b187421711100a46$export$b34ff16ecaf83ff0;
var $b187421711100a46$export$e1c875bb407fe8a3;
$b187421711100a46$export$f80cc4deee2042b3 = `-_Hfnq_columnHeaderSection`;
$b187421711100a46$export$9a2e0d37cd9f78a8 = `-_Hfnq_columnHeaderWrapper`;
$b187421711100a46$export$967a2568e65827b1 = `-_Hfnq_fieldColumnHeaderWrapper`;
$b187421711100a46$export$ad0ac4a84a807d3d = `-_Hfnq_portalContainer`;
$b187421711100a46$export$b34ff16ecaf83ff0 = `-_Hfnq_scopeColumnHeaderWrapper`;
$b187421711100a46$export$e1c875bb407fe8a3 = `-_Hfnq_stickHeaderLayout`;

});



parcelRegister("hPeQq", function(module, exports) {

$parcel$export(module.exports, "manuallyUpdateReactVirtualizedListWidth", () => $696af149cc5cc309$export$ca740aa2d445e064);
$parcel$export(module.exports, "manuallyUpdateStickyHeaderWidth", () => $696af149cc5cc309$export$b056a85fe6795540);
// Be blessed those who reduce but not increase the size of this file.
/*
This function is used to eliminate unnecessary re-render when the user resizes Roadmap sections.

react-virtualized List doesn't have an option to say "please change your width but don't call
rowRenderer as I know that my rows don't depend on width directly". Thus in such situation, we don't
update List at all and just set its width manually directly in the DOM.

It's very brittle; please keep an eye on it while updating react-virtualized version.

Calling it from shouldComponentUpdate is against the law; please don't repeat at home as you might
be charged and sent to jail by React Evangelism Forces.
*/ const $696af149cc5cc309$export$ca740aa2d445e064 = (container, newWidth)=>{
    const width = `${newWidth}px`;
    const grid = container.querySelector('.ReactVirtualized__Grid');
    if (grid) {
        grid.style.width = width;
        const scroll = grid.querySelector('.ReactVirtualized__Grid__innerScrollContainer');
        if (scroll) scroll.style.maxWidth = width;
    }
};
const $696af149cc5cc309$export$b056a85fe6795540 = (elementId, newWidth)=>{
    const width = `${newWidth}px`;
    const stickyHeader = document.getElementById(elementId);
    if (stickyHeader) stickyHeader.style.width = width;
};

});

parcelRegister("aRcOC", function(module, exports) {

$parcel$export(module.exports, "default", () => $73d6d7705b2ea986$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2qhQi = parcelRequire("2qhQi");

var $5rYNM = parcelRequire("5rYNM");

var $cX2kh = parcelRequire("cX2kh");

var $4GFV1 = parcelRequire("4GFV1");
// This cannot be converted to functional component https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
class $73d6d7705b2ea986$var$CellErrorBoundary extends (0, $eUqFw.Component) {
    // eslint-disable-next-line react/sort-comp
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch({ message: message, stack: stackTrace }) {
        const error = new Error(message);
        if (stackTrace) error.stack = stackTrace;
        (0, $guiFP.default)({
            meta: {
                id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).ROADMAP,
                packageName: (0, $5rYNM.PACKAGE_NAME),
                teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    render() {
        if (this.state.hasError) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4GFV1.container
        }, this.props.intl.formatMessage((0, $cX2kh.default).anErrorOccurred)));
        return this.props.children;
    }
}
var $73d6d7705b2ea986$export$2e2bcd8739ae039 = (0, $2qhQi.default)($73d6d7705b2ea986$var$CellErrorBoundary);

});
parcelRegister("cX2kh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e69f54efc2c0e63$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5e69f54efc2c0e63$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    anErrorOccurred: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.column.error-boundary.an-error-occurred",
        "defaultMessage": "An error occurred"
    }
});

});

parcelRegister("4GFV1", function(module, exports) {

$parcel$export(module.exports, "container", () => $369b99de7b72d5d8$export$34e0f9847d4c02dd, (v) => $369b99de7b72d5d8$export$34e0f9847d4c02dd = v);
var $369b99de7b72d5d8$export$34e0f9847d4c02dd;
$369b99de7b72d5d8$export$34e0f9847d4c02dd = `ntVzWG_container`;

});


parcelRegister("bEvmS", function(module, exports) {

$parcel$export(module.exports, "blankRow", () => $87bbc3250d40fbc3$export$34126cd4b89016d9, (v) => $87bbc3250d40fbc3$export$34126cd4b89016d9 = v);
$parcel$export(module.exports, "cell", () => $87bbc3250d40fbc3$export$e2e1361cdc35271d, (v) => $87bbc3250d40fbc3$export$e2e1361cdc35271d = v);
$parcel$export(module.exports, "cell-even", () => $87bbc3250d40fbc3$export$1fed92586bcdfbf6, (v) => $87bbc3250d40fbc3$export$1fed92586bcdfbf6 = v);
$parcel$export(module.exports, "cell-even-optimized", () => $87bbc3250d40fbc3$export$1ab5768571e70105, (v) => $87bbc3250d40fbc3$export$1ab5768571e70105 = v);
$parcel$export(module.exports, "cell-optimized", () => $87bbc3250d40fbc3$export$d68c4b539403ac3a, (v) => $87bbc3250d40fbc3$export$d68c4b539403ac3a = v);
$parcel$export(module.exports, "column", () => $87bbc3250d40fbc3$export$4e0c71f277ca26b3, (v) => $87bbc3250d40fbc3$export$4e0c71f277ca26b3 = v);
$parcel$export(module.exports, "groupRow", () => $87bbc3250d40fbc3$export$26ba1761329d3a7b, (v) => $87bbc3250d40fbc3$export$26ba1761329d3a7b = v);
$parcel$export(module.exports, "list", () => $87bbc3250d40fbc3$export$8837f4fc672e936d, (v) => $87bbc3250d40fbc3$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "space", () => $87bbc3250d40fbc3$export$a941ed4b947d12f8, (v) => $87bbc3250d40fbc3$export$a941ed4b947d12f8 = v);
var $87bbc3250d40fbc3$export$34126cd4b89016d9;
var $87bbc3250d40fbc3$export$e2e1361cdc35271d;
var $87bbc3250d40fbc3$export$1fed92586bcdfbf6;
var $87bbc3250d40fbc3$export$1ab5768571e70105;
var $87bbc3250d40fbc3$export$d68c4b539403ac3a;
var $87bbc3250d40fbc3$export$4e0c71f277ca26b3;
var $87bbc3250d40fbc3$export$26ba1761329d3a7b;
var $87bbc3250d40fbc3$export$1291f1cc9f6ecb4c;
var $87bbc3250d40fbc3$export$12f1f50e7ede5be2;
var $87bbc3250d40fbc3$export$8837f4fc672e936d;
var $87bbc3250d40fbc3$export$a941ed4b947d12f8;
$87bbc3250d40fbc3$export$34126cd4b89016d9 = `_936CFa_blankRow`;
$87bbc3250d40fbc3$export$e2e1361cdc35271d = `_936CFa_cell`;
$87bbc3250d40fbc3$export$1fed92586bcdfbf6 = `_936CFa_cell-even`;
$87bbc3250d40fbc3$export$1ab5768571e70105 = `_936CFa_cell-even-optimized`;
$87bbc3250d40fbc3$export$d68c4b539403ac3a = `_936CFa_cell-optimized`;
$87bbc3250d40fbc3$export$4e0c71f277ca26b3 = `_936CFa_column`;
$87bbc3250d40fbc3$export$26ba1761329d3a7b = `_936CFa_groupRow`;
$87bbc3250d40fbc3$export$1291f1cc9f6ecb4c = `_936CFa_issues-group-section`;
$87bbc3250d40fbc3$export$12f1f50e7ede5be2 = `_936CFa_issues-without-parent-section`;
$87bbc3250d40fbc3$export$8837f4fc672e936d = `_936CFa_list`;
$87bbc3250d40fbc3$export$a941ed4b947d12f8 = `_936CFa_space`;

});



parcelRegister("3HDq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61351c55e95014e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jZVAE = parcelRequire("jZVAE");

var $jizAY = parcelRequire("jizAY");
var $d61351c55e95014e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $jZVAE.default))((0, $jizAY.default));

});
parcelRegister("jZVAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a794202178163ad1$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");

var $lNYdY = parcelRequire("lNYdY");
const $a794202178163ad1$var$dispatchMethods = (dispatch)=>({
        hideColumn: (id)=>{
            dispatch({
                type: (0, $lNYdY.HIDE_COLUMN),
                id: id
            });
        },
        showColumn: (id)=>{
            dispatch({
                type: (0, $lNYdY.SHOW_COLUMN),
                id: id
            });
            if (id === 'breakdown' || id === 'progressByEstimation') dispatch((0, $1Szmp.fetchHistoricalDoneIssues)());
        },
        moveColumn: (columnToMove, moveToTheIndexOf)=>{
            dispatch((0, $lNYdY.move)({
                columnToMove: columnToMove,
                moveToTheIndexOf: moveToTheIndexOf
            }));
        }
    });
var $a794202178163ad1$export$2e2bcd8739ae039 = $a794202178163ad1$var$dispatchMethods;

});

parcelRegister("jizAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8084e239130f5417$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $a4vO3 = parcelRequire("a4vO3");

var $kn41y = parcelRequire("kn41y");


var $71XYp = parcelRequire("71XYp");

var $4uRgn = parcelRequire("4uRgn");
const $8084e239130f5417$var$calculateOpacity = (width)=>{
    if (width >= (0, $b7d7765ad44e6c81$export$7bf66c9f4ca32280)) return 1;
    if (width <= (0, $b7d7765ad44e6c81$export$289ebd139efb3d0f)) return 0;
    return (width - (0, $b7d7765ad44e6c81$export$289ebd139efb3d0f)) / ((0, $b7d7765ad44e6c81$export$7bf66c9f4ca32280) - (0, $b7d7765ad44e6c81$export$289ebd139efb3d0f));
};
/* An empty view for the fields column.
 * In an attempt to optimise for various screen sizes, column configurations, and user interactions:
 * 1. The hero image shrinks at a certain threshold
 * 2. The hero image fades away at a second, smaller threshold (this was less jarring than binary visibility)
 */ const $8084e239130f5417$var$EmptyFields = ({ width: width, columns: columns, showColumn: showColumn, moveColumn: moveColumn, hideColumn: hideColumn, getMatchingConfiguredDate: getMatchingConfiguredDate, AdvancedFieldsMenu: AdvancedFieldsMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderMenuTrigger = (menuTriggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...menuTriggerProps,
            appearance: "primary",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.trigger-menu-button"
        }, formatMessage((0, $71XYp.default).addFields));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4uRgn.container,
        style: {
            width: width,
            opacity: $8084e239130f5417$var$calculateOpacity(width)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4uRgn.imageGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        className: $4uRgn.image,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kn41y))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($4uRgn.header, $4uRgn.text)
    }, formatMessage((0, $71XYp.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: $4uRgn.text
    }, formatMessage((0, $71XYp.default).callToAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4uRgn.dropdown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdvancedFieldsMenu, {
        id: "empty-view",
        columns: columns,
        hideColumn: hideColumn,
        showColumn: showColumn,
        moveColumn: moveColumn,
        getMatchingConfiguredDate: getMatchingConfiguredDate,
        isShortcutEnabled: false,
        renderMenuTrigger: renderMenuTrigger,
        placement: "right-end"
    }))));
};
var $8084e239130f5417$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    AdvancedFieldsMenu: (0, $a4vO3.slots).AdvancedFieldsMenu
})($8084e239130f5417$var$EmptyFields);

});
parcelRegister("kn41y", function(module, exports) {
module.exports = new URL("hero.8b784ab9.svg", import.meta.url).toString();

});

const $b7d7765ad44e6c81$export$7bf66c9f4ca32280 = 280;
const $b7d7765ad44e6c81$export$289ebd139efb3d0f = 210;

parcelRegister("71XYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d445debc290d5f8b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $d445debc290d5f8b$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.header",
        "defaultMessage": "Add a column to the view"
    },
    callToAction: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.call-to-action",
        "defaultMessage": "Add columns (or fields) to this view and start planning in more details"
    },
    addFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.columns.empty.add-fields",
        "defaultMessage": "Add fields"
    }
});
var $d445debc290d5f8b$export$2e2bcd8739ae039 = $d445debc290d5f8b$var$messages;

});

parcelRegister("4uRgn", function(module, exports) {

$parcel$export(module.exports, "container", () => $346347b4271396f2$export$34e0f9847d4c02dd, (v) => $346347b4271396f2$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "dropdown", () => $346347b4271396f2$export$81207e5cc4186890, (v) => $346347b4271396f2$export$81207e5cc4186890 = v);
$parcel$export(module.exports, "header", () => $346347b4271396f2$export$38e42c68cf43b5d4, (v) => $346347b4271396f2$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "image", () => $346347b4271396f2$export$5c452ff88e35e47d, (v) => $346347b4271396f2$export$5c452ff88e35e47d = v);
$parcel$export(module.exports, "imageGroup", () => $346347b4271396f2$export$915392582aa62df4, (v) => $346347b4271396f2$export$915392582aa62df4 = v);
$parcel$export(module.exports, "text", () => $346347b4271396f2$export$6f093cfa640b7166, (v) => $346347b4271396f2$export$6f093cfa640b7166 = v);
var $346347b4271396f2$export$34e0f9847d4c02dd;
var $346347b4271396f2$export$81207e5cc4186890;
var $346347b4271396f2$export$38e42c68cf43b5d4;
var $346347b4271396f2$export$5c452ff88e35e47d;
var $346347b4271396f2$export$915392582aa62df4;
var $346347b4271396f2$export$6f093cfa640b7166;
$346347b4271396f2$export$34e0f9847d4c02dd = `hgfPNG_container`;
$346347b4271396f2$export$81207e5cc4186890 = `hgfPNG_dropdown`;
$346347b4271396f2$export$38e42c68cf43b5d4 = `hgfPNG_header`;
$346347b4271396f2$export$5c452ff88e35e47d = `hgfPNG_image`;
$346347b4271396f2$export$915392582aa62df4 = `hgfPNG_imageGroup`;
$346347b4271396f2$export$6f093cfa640b7166 = `hgfPNG_text`;

});



parcelRegister("lnZlB", function(module, exports) {

$parcel$export(module.exports, "container", () => $f91b5546f48b9d88$export$34e0f9847d4c02dd, (v) => $f91b5546f48b9d88$export$34e0f9847d4c02dd = v);
var $f91b5546f48b9d88$export$34e0f9847d4c02dd;
var $f91b5546f48b9d88$export$1770ab2bedff69f8;
$f91b5546f48b9d88$export$34e0f9847d4c02dd = `u1KXxq_container`;
$f91b5546f48b9d88$export$1770ab2bedff69f8 = `u1KXxq_no-component-mapped`;

});

parcelRegister("bUuwD", function(module, exports) {

$parcel$export(module.exports, "showEmptyView", () => $07e4b71d3f8125d1$export$83cc251aa31e2fc6);
const $07e4b71d3f8125d1$export$83cc251aa31e2fc6 = ({ areCustomFieldsReady: areCustomFieldsReady, isViewModeList: isViewModeList, isExportMode: isExportMode, isConfluenceMacro: isConfluenceMacro, totalVisibleColumns: totalVisibleColumns })=>{
    const isValidEnvironment = isViewModeList && !isConfluenceMacro && !isExportMode;
    return isValidEnvironment && areCustomFieldsReady && totalVisibleColumns === 0;
};

});



parcelRegister("VAiiJ", function(module, exports) {

$parcel$export(module.exports, "container", () => $0ad17a40f01863a2$export$34e0f9847d4c02dd, (v) => $0ad17a40f01863a2$export$34e0f9847d4c02dd = v);
var $0ad17a40f01863a2$export$34e0f9847d4c02dd;
$0ad17a40f01863a2$export$34e0f9847d4c02dd = `Cnoqaq_container`;

});



parcelRegister("4Zu2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dcead2628fdd5eb$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ggf2e = parcelRequire("ggf2e");

var $IaIhY = parcelRequire("IaIhY");

var $b21FY = parcelRequire("b21FY");
var $2dcead2628fdd5eb$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $IaIhY.default), (0, $ggf2e.default))((0, $b21FY.default));

});
parcelRegister("ggf2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1404927e7408c10b$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");

var $lNYdY = parcelRequire("lNYdY");

var $dbuYA = parcelRequire("dbuYA");
const $1404927e7408c10b$var$dispatchMethods = (dispatch)=>({
        changeSort: (sortBy)=>{
            dispatch((0, $l1dWb.changeSort)({
                sorting: sortBy
            }));
        },
        hideColumn: (id)=>{
            dispatch({
                type: (0, $lNYdY.HIDE_COLUMN),
                id: id
            });
        },
        showColumn: (id)=>{
            dispatch({
                type: (0, $lNYdY.SHOW_COLUMN),
                id: id
            });
            if (id === 'breakdown' || id === 'progressByEstimation') dispatch((0, $1Szmp.fetchHistoricalDoneIssues)());
        },
        onDragStart: ()=>{
            dispatch((0, $dbuYA.suspend)());
        },
        onDragEnd: ()=>{
            dispatch((0, $dbuYA.resume)());
        },
        moveColumn: (columnToMove, moveToTheIndexOf)=>{
            dispatch((0, $lNYdY.move)({
                columnToMove: columnToMove,
                moveToTheIndexOf: moveToTheIndexOf
            }));
        }
    });
var $1404927e7408c10b$export$2e2bcd8739ae039 = $1404927e7408c10b$var$dispatchMethods;

});

parcelRegister("IaIhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e12f4dbf58dc913$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $kKj1m = parcelRequire("kKj1m");

var $jp3RH = parcelRequire("jp3RH");

var $75KhQ = parcelRequire("75KhQ");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $kyGCj = parcelRequire("kyGCj");

var $72KE6 = parcelRequire("72KE6");

var $iK4oF = parcelRequire("iK4oF");

var $fnooh = parcelRequire("fnooh");
const $0e12f4dbf58dc913$var$queryPure = (columns, sorting, customFields, dateConfiguration, planningUnit, issuePrioritiesIdList, isPlanInfoReady, viewNamespace, exportMode, viewMode, // eslint-disable-next-line @typescript-eslint/no-shadow
isConfluenceMacro)=>({
        columns: columns,
        sorting: sorting,
        customFields: customFields,
        getMatchingConfiguredDate: (0, $72KE6.getMatchingConfiguredDate)(dateConfiguration),
        planningUnit: planningUnit,
        issuePrioritiesIdList: issuePrioritiesIdList,
        areCustomFieldsReady: isPlanInfoReady,
        viewNamespace: viewNamespace,
        isExportMode: exportMode,
        viewMode: viewMode,
        isConfluenceMacro: isConfluenceMacro
    });
const $0e12f4dbf58dc913$export$2fa187e846a241c4 = (0, $iK4oF.createSelector)([
    (0, $fnooh.getColumns),
    (0, $kyGCj.getVisualisationSorting),
    (0, $kKj1m.getCustomFields),
    (0, $75KhQ.getDateConfiguration),
    (0, $75KhQ.getPlanningUnit),
    (0, $jp3RH.getIssuePrioritiesIdList),
    (0, $akhOi.getIsPlanInfoReady),
    (0, $dBKyg.getNamespaceFromActiveView),
    (0, $akhOi.isExportMode),
    (0, $9H2AP.getViewMode),
    (0, $akhOi.isConfluenceMacro)
], $0e12f4dbf58dc913$var$queryPure);
var $0e12f4dbf58dc913$export$2e2bcd8739ae039 = $0e12f4dbf58dc913$export$2fa187e846a241c4;

});

parcelRegister("b21FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f766c1b9d41d1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $ffiyv = parcelRequire("ffiyv");
var $lMaVG = parcelRequire("lMaVG");
var $eYlCJ = parcelRequire("eYlCJ");
var $kYJcj = parcelRequire("kYJcj");
var $lcvrv = parcelRequire("lcvrv");
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");
parcelRequire("kyGCj");
var $dvRTl = parcelRequire("dvRTl");

var $lf4fN = parcelRequire("lf4fN");

var $9NSUz = parcelRequire("9NSUz");

var $a4vO3 = parcelRequire("a4vO3");

var $5rYNM = parcelRequire("5rYNM");

var $brSAH = parcelRequire("brSAH");

var $ncpdK = parcelRequire("ncpdK");

var $bRGNO = parcelRequire("bRGNO");

var $aq1B9 = parcelRequire("aq1B9");

var $gqKtb = parcelRequire("gqKtb");

var $e2uqN = parcelRequire("e2uqN");

var $a5PyD = parcelRequire("a5PyD");
const $a6f766c1b9d41d1f$var$Header = (props)=>{
    const { intl: intl, changeSort: changeSort, getMatchingConfiguredDate: getMatchingConfiguredDate, columns: columns, customFields: customFields, sorting: sorting, planningUnit: planningUnit, issuePrioritiesIdList: issuePrioritiesIdList, AdvancedFieldsMenu: AdvancedFieldsMenu, hideColumn: hideColumn, showColumn: showColumn, moveColumn: moveColumn, width: width, onCollapseAllFields: onCollapseAllFields, onDragStart: onDragStart, onDragEnd: onDragEnd, areCustomFieldsReady: areCustomFieldsReady, viewNamespace: viewNamespace, isExportMode: isExportMode, viewMode: viewMode, isConfluenceMacro: isConfluenceMacro, minWidth: minWidth } = props;
    const sectionsRef = (0, $eUqFw.useRef)();
    const headerContainer = (0, $eUqFw.useRef)(null);
    const visibleColumns = (0, $eUqFw.useMemo)(()=>columns.filter((column)=>column.isVisible), [
        columns
    ]);
    const collapse = (index)=>()=>{
            if (sectionsRef.current) sectionsRef.current.collapseSection(index);
        };
    const onKeyDownToggle = (index)=>(event)=>{
            // Space bar is ' '
            if (event.key === 'Enter' || event.key === ' ') collapse(index);
        };
    const getColumnTitle = (column)=>{
        if (typeof column.title === 'string') return column.title;
        return intl.formatMessage(column.title);
    };
    const renderEmptyFields = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$a5PyD['column-header']} ${$a5PyD['no-fields-header']}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $a5PyD['no-fields-text']
        }, intl.formatMessage((0, $aq1B9.default).noFields)));
    const renderMenuTrigger = (menuTriggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ncpdK.default), {
            numberOfVisibleFields: visibleColumns.length,
            ...menuTriggerProps
        });
    const renderAddFieldsColumnHeader = ()=>!isExportMode && !isConfluenceMacro ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdvancedFieldsMenu, {
            id: "add-fields-header",
            columns: columns,
            hideColumn: hideColumn,
            showColumn: showColumn,
            moveColumn: moveColumn,
            getMatchingConfiguredDate: getMatchingConfiguredDate,
            isShortcutEnabled: false,
            renderMenuTrigger: renderMenuTrigger
        }), visibleColumns.length === 1 && renderEmptyFields()) : undefined;
    const sectionRenderer = ({ section: section, onSectionClick: onSectionClick, index: index, setHovered: setHovered })=>{
        const { width: // eslint-disable-next-line @typescript-eslint/no-shadow
        width, id: id, minWidth: // eslint-disable-next-line @typescript-eslint/no-shadow
        minWidth, title: title, isLoading: isLoading, collapsible: collapsible = true, HeaderContent: HeaderContent = null } = section;
        const configurableDate = getMatchingConfiguredDate(id);
        const tooltip = (0, $9NSUz.getConfiguredDateTooltip)(configurableDate);
        const currentColumn = columns.reduce((result, column)=>{
            if (column.id === id) return column;
            return result;
        }, columns[0]);
        const titleTooltip = tooltip ? intl.formatMessage(tooltip, {
            title: title
        }) : title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
            id: id,
            key: `section-${id}`,
            index: index,
            width: width,
            minWidth: minWidth,
            onClick: onSectionClick,
            setHovered: setHovered,
            collapsible: collapsible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$a5PyD['column-header']} ${$a5PyD[collapsible ? 'no-focus-collapsible' : 'no-focus']}`,
            key: id,
            onClick: collapsible ? collapse(index) : undefined,
            onKeyDown: collapsible ? onKeyDownToggle(index) : undefined,
            role: "button",
            tabIndex: 0,
            "data-name": `field-header-${id}`,
            "data-test-class": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header"
        }, isLoading && // `hideFromExport` is a global style
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: `${$a5PyD['header-spinner']} hideFromExport`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
            size: "small",
            delay: 0
        })), id === (0, $lf4fN.ADD_FIELDS_COLUMN_ID) ? renderAddFieldsColumnHeader() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $a5PyD[collapsible ? 'field-title-wrapper-collapsible' : 'field-title-wrapper']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $a5PyD['field-title']
        }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJcj.default), {
            icon: configurableDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "D"),
            tooltip: titleTooltip,
            mode: "header"
        }, title)), HeaderContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderContent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e2uqN.default), {
            isDisabled: currentColumn.attribute === 'priority' && !issuePrioritiesIdList,
            column: currentColumn,
            sorting: sorting,
            changeSort: changeSort,
            customFields: customFields,
            customClass: $a5PyD.sortTriggerButton,
            planningUnit: planningUnit
        })));
    };
    let columnsData;
    let noColumns;
    if (!areCustomFieldsReady || visibleColumns.length === 0) noColumns = renderEmptyFields();
    else columnsData = visibleColumns.map((column, index, arr)=>{
        const data = {
            initialWidth: column.defaultWidth,
            minWidth: column.minWidth ?? 24,
            // Last column is flexible to absorb the remaining delta
            isFixed: !(viewMode === (0, $lcvrv.VIEW_MODES).LIST && index === arr.length - 1),
            id: column.id,
            isLoading: column.isLoading,
            title: getColumnTitle(column),
            collapsible: column.isCollapsible,
            HeaderContent: column.HeaderContent
        };
        const configurableDate = getMatchingConfiguredDate(column.id);
        if (configurableDate) {
            data.configurableDate = configurableDate;
            data.initialWidth = (0, $5rYNM.DEFAULT_FIELD_WIDTH).LARGE;
        }
        return data;
    });
    const isViewModeList = viewMode === (0, $lcvrv.VIEW_MODES).LIST;
    const id = isViewModeList ? (0, $5rYNM.SECTION_KEYS).LIST_FIELD : (0, $5rYNM.SECTION_KEYS).FIELD;
    const topSectionStyles = isViewModeList ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {
        position: 'sticky',
        left: '0px',
        flex: '0 0 auto'
    } : undefined;
    const topRightSectionStyles = isViewModeList ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {
        position: 'sticky',
        right: "var(--ds-space-200, 16px)"
    } : undefined;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $a5PyD.header,
        ref: headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
        className: $a5PyD['top-section']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
        style: topSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdvancedFieldsMenu, {
        id: "fields-top-section",
        columns: columns,
        hideColumn: hideColumn,
        showColumn: showColumn,
        moveColumn: moveColumn,
        getMatchingConfiguredDate: getMatchingConfiguredDate
    })), sorting.field !== (0, $chgK5.ISSUE_FIELDS).RANK && !isExportMode && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), {
        style: topRightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqKtb.default), {
        onClick: ()=>changeSort((0, $dvRTl.defaultSorting))
    })), !isExportMode && viewMode !== (0, $lcvrv.VIEW_MODES).LIST && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), {
        className: $a5PyD.options
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bRGNO.default), {
        onClick: onCollapseAllFields
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $a5PyD['column-header-section']
    }, noColumns || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
        namespace: viewNamespace,
        // @ts-expect-error - TS2322 - Type '{ namespace: string; innerRef: RefObject<unknown>; id: "fields-section"; sectionRenderer: ({ section, onSectionClick, index, setHovered }: SectionRendererArgs) => Element; sectionsData: { ...; }[] | undefined; linkToParent: "main-sections"; onDragStart: () => void; onDragEnd: () => void; width: number; }' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
        innerRef: sectionsRef,
        id: id,
        sectionRenderer: sectionRenderer,
        sectionsData: columnsData,
        /**
         * CAVEAT of 'linkToParent' with 'isFitParent'
         *
         * There are three "Fields" sections (sticky-header, header, and columns),
         * only ONE section should be linked to the parent IF the sections have `isFitParent=false`.
         *
         * `isFitParent=false` where the section does not bound by parent's size, the parent's width get updated after the section resized,
         * this will resulted with multiple cascading updates on the parent section IF multiple sections linked to the same parent.
         *
         * */ linkToParent: !isViewModeList ? (0, $5rYNM.SECTION_KEYS).MAIN : undefined,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        width: width,
        minWidth: minWidth,
        isFitParent: !isViewModeList
    }))));
};
var $a6f766c1b9d41d1f$export$2e2bcd8739ae039 = (0, $2qhQi.default)((0, $a4vO3.withSlots)({
    AdvancedFieldsMenu: (0, $a4vO3.slots).AdvancedFieldsMenu
})($a6f766c1b9d41d1f$var$Header));

});
parcelRegister("brSAH", function(module, exports) {

$parcel$export(module.exports, "Left", () => $2b6371d720f64844$export$37c4d04eafdc5515);
$parcel$export(module.exports, "Right", () => $2b6371d720f64844$export$19db0165690c701a);
$parcel$export(module.exports, "Row", () => $2b6371d720f64844$export$b59bdbef9ce70de2);

var $eUqFw = parcelRequire("eUqFw");

var $4QXgG = parcelRequire("4QXgG");
const $2b6371d720f64844$var$Types = {
    left: 'left',
    right: 'right',
    row: 'row'
};
const $2b6371d720f64844$var$displayNameByType = {
    [$2b6371d720f64844$var$Types.left]: 'Left',
    [$2b6371d720f64844$var$Types.right]: 'Right',
    [$2b6371d720f64844$var$Types.row]: 'Row'
};
const $2b6371d720f64844$var$container = (type)=>{
    const Component = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ...props,
            className: `${$4QXgG[type]} ${props.className || ''}`
        });
    return Object.assign(Component, {
        displayName: $2b6371d720f64844$var$displayNameByType[type]
    });
};
const $2b6371d720f64844$export$37c4d04eafdc5515 = $2b6371d720f64844$var$container($2b6371d720f64844$var$Types.left);
const $2b6371d720f64844$export$19db0165690c701a = $2b6371d720f64844$var$container($2b6371d720f64844$var$Types.right);
const $2b6371d720f64844$export$b59bdbef9ce70de2 = $2b6371d720f64844$var$container($2b6371d720f64844$var$Types.row);

});
parcelRegister("4QXgG", function(module, exports) {

$parcel$export(module.exports, "left", () => $3889fe263ccf500e$export$eabcd2c8791e7bf4, (v) => $3889fe263ccf500e$export$eabcd2c8791e7bf4 = v);
$parcel$export(module.exports, "right", () => $3889fe263ccf500e$export$79ffe56a765070d2, (v) => $3889fe263ccf500e$export$79ffe56a765070d2 = v);
$parcel$export(module.exports, "row", () => $3889fe263ccf500e$export$120ff0929b202a6d, (v) => $3889fe263ccf500e$export$120ff0929b202a6d = v);
var $3889fe263ccf500e$export$eabcd2c8791e7bf4;
var $3889fe263ccf500e$export$79ffe56a765070d2;
var $3889fe263ccf500e$export$120ff0929b202a6d;
$3889fe263ccf500e$export$eabcd2c8791e7bf4 = `MhvOeG_left`;
$3889fe263ccf500e$export$79ffe56a765070d2 = `MhvOeG_right`;
$3889fe263ccf500e$export$120ff0929b202a6d = `MhvOeG_row`;

});


parcelRegister("ncpdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d7b28ac93c2b6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k7cZh = parcelRequire("k7cZh");

var $bkIGg = parcelRequire("bkIGg");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");
parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $ib5d3 = parcelRequire("ib5d3");

var $ckBOT = parcelRequire("ckBOT");
/* This element sits at the end of an overflow container where content can be dynamically added before it.
 * As a result, it can be pushed outside the viewport. Since the focus does not move, the browser will not
 * scroll to its new position automatically, so we have to initiate the scrolling ourselves.
 */ const $42d7b28ac93c2b6a$var$AdvancedFieldsTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ numberOfVisibleFields: numberOfVisibleFields, isSelected: isSelected, ...menuTriggerProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const previousNumberOfVisibleFields = (0, $hzcvF.usePreviousWithInitial)(numberOfVisibleFields);
    (0, $eUqFw.useEffect)(()=>{
        const couldExceedViewport = numberOfVisibleFields > previousNumberOfVisibleFields;
        if (wrapperRef.current && isSelected && couldExceedViewport) (0, $k7cZh.default)(wrapperRef.current, (0, $ckBOT.SCROLL_OPTIONS));
    }, [
        numberOfVisibleFields,
        previousNumberOfVisibleFields,
        isSelected
    ]);
    /* Setting a fixed width for the scrollIntoView anchor provides:
   * - A small gap so that the button isn't aligned at the edge of the screen
   * - A consistent jump point, regardless of how wide the header cell is (see SCROLL_OPTIONS)
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: numberOfVisibleFields > 1 ? '56px' : undefined
        },
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ref: ref,
        ...menuTriggerProps,
        isSelected: isSelected,
        appearance: "default",
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-trigger",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: formatMessage((0, $ib5d3.default).fields)
        })
    }));
});
var $42d7b28ac93c2b6a$export$2e2bcd8739ae039 = $42d7b28ac93c2b6a$var$AdvancedFieldsTrigger;

});
parcelRegister("ckBOT", function(module, exports) {

$parcel$export(module.exports, "SCROLL_OPTIONS", () => $6aefa8b4376c4f4d$export$a47da6bbcf4c3c28);
const $6aefa8b4376c4f4d$export$a47da6bbcf4c3c28 = {
    // Only scroll element into view when outside the viewport
    scrollMode: 'if-needed',
    // Vertically align element to bottom the scrollable ancestor (stops from breaking the hidden scrollbars)
    block: 'end',
    // Horizontally align element to right of the scrollable ancestor
    inline: 'end'
};

});


parcelRegister("bRGNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a3a6f2ba378131a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9drmE = parcelRequire("9drmE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $jMP2a = parcelRequire("jMP2a");

var $iuVgW = parcelRequire("iuVgW");
const $2a3a6f2ba378131a$var$CollapseButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onHandleClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'collapseFields');
        onClick();
    };
    const collapseFieldsFormatted = formatMessage((0, $iuVgW.default).advancedFieldsMenuCollapseFields);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onHandleClick,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button",
        ariaLabel: formatMessage((0, $iuVgW.default).advancedFieldsMenuCollapseFieldsLabel),
        "aria-expanded": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: collapseFieldsFormatted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9drmE))), {
        label: ""
    })));
};
var $2a3a6f2ba378131a$export$2e2bcd8739ae039 = $2a3a6f2ba378131a$var$CollapseButton;

});
parcelRegister("9drmE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b5a8df78b2a6e40$var$_react = $6b5a8df78b2a6e40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6b5a8df78b2a6e40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6b5a8df78b2a6e40$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $6b5a8df78b2a6e40$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.062 11L6.5 9.914A1 1 0 017.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 116.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0117.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 01-1.414 1.414l-2.616-2.616z" fill="currentColor"/></svg>`
    }, props));
$6b5a8df78b2a6e40$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $6b5a8df78b2a6e40$var$_default = $6b5a8df78b2a6e40$var$EditorCollapseIcon;
module.exports.default = $6b5a8df78b2a6e40$var$_default;

});

parcelRegister("iuVgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc0c5c7f22f0a5a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5bc0c5c7f22f0a5a$var$messages = (0, $90IgZ.defineMessages)({
    advancedFieldsMenuCollapseFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button.advanced-fields-menu-collapse-fields",
        "defaultMessage": "Collapse fields"
    },
    advancedFieldsMenuCollapseFieldsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.collapse-button.advanced-fields-menu-collapse-fields-label",
        "defaultMessage": "Fields"
    }
});
var $5bc0c5c7f22f0a5a$export$2e2bcd8739ae039 = $5bc0c5c7f22f0a5a$var$messages;

});


parcelRegister("aq1B9", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e1a0fb9295441f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $06e1a0fb9295441f$var$messages = (0, $90IgZ.defineMessages)({
    nofields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.nofields",
        "defaultMessage": "No fields"
    },
    resetSortingOrder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.reset-sorting-order",
        "defaultMessage": "Reset sorting order"
    },
    advancedFieldsMenuCollapseFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.advanced-fields-menu-collapse-fields",
        "defaultMessage": "Collapse fields"
    },
    noFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.no-fields",
        "defaultMessage": "Use the Fields button to add columns to this view."
    }
});
var $06e1a0fb9295441f$export$2e2bcd8739ae039 = $06e1a0fb9295441f$var$messages;

});

parcelRegister("gqKtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6a1160cf9a10d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8SZxd = parcelRequire("8SZxd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $jMP2a = parcelRequire("jMP2a");

var $a22Ef = parcelRequire("a22Ef");
const $7b6a1160cf9a10d3$var$ResetSortingOrder = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onHandleClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'resetSortingOrder');
        onClick();
    };
    const resetSortingOrderFormatted = formatMessage((0, $a22Ef.default).resetSortingOrder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onHandleClick,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.reset-sorting-order",
        ariaLabel: resetSortingOrderFormatted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: resetSortingOrderFormatted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8SZxd))), {
        label: ""
    })));
};
var $7b6a1160cf9a10d3$export$2e2bcd8739ae039 = $7b6a1160cf9a10d3$var$ResetSortingOrder;

});
parcelRegister("8SZxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6783196829040bcb$var$_react = $6783196829040bcb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6783196829040bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6783196829040bcb$var$RetryIcon = (props)=>/*#__PURE__*/ $6783196829040bcb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 10h2.954a1 1 0 010 2H5.099A1.1 1.1 0 014 10.9V7a1 1 0 112 0v3z" fill-rule="nonzero"/><path d="M7.39 10.09H5.3a8 8 0 11.818 6H7.84v-1.02a6 6 0 10-.45-4.98z" fill-rule="nonzero"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
    }, props));
$6783196829040bcb$var$RetryIcon.displayName = 'RetryIcon';
var $6783196829040bcb$var$_default = $6783196829040bcb$var$RetryIcon;
module.exports.default = $6783196829040bcb$var$_default;

});

parcelRegister("a22Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $8baf41ca8f17e4cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $8baf41ca8f17e4cb$var$messages = (0, $90IgZ.defineMessages)({
    resetSortingOrder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.reset-sorting-order.reset-sorting-order",
        "defaultMessage": "Reset sorting order"
    }
});
var $8baf41ca8f17e4cb$export$2e2bcd8739ae039 = $8baf41ca8f17e4cb$var$messages;

});


parcelRegister("e2uqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae23378a79eef83$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $9SdpV = parcelRequire("9SdpV");

var $hL0Qd = parcelRequire("hL0Qd");

var $2qhQi = parcelRequire("2qhQi");

var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");

var $7s3LJ = parcelRequire("7s3LJ");
parcelRequire("kyGCj");
var $dvRTl = parcelRequire("dvRTl");

var $62d8R = parcelRequire("62d8R");

var $5rYNM = parcelRequire("5rYNM");

var $2BQwE = parcelRequire("2BQwE");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $duQ8C = parcelRequire("duQ8C");

var $1nXab = parcelRequire("1nXab");

var $kEmqw = parcelRequire("kEmqw");
// eslint-disable-next-line jira/react/no-class-components
class $aae23378a79eef83$var$SortButton extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, column: { attribute: attribute, isSortable: isSortable }, sorting: sorting, customClass: customClass, isDisabled: isDisabled } = this.props;
        if (isSortable !== true) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: (analyticsEvent)=>{
                this.analyticsEvent = analyticsEvent;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "aria-label": intl.formatMessage((0, $1nXab.default).sortButton),
            tabIndex: 0,
            role: "button",
            onKeyDown: (e)=>this.onKeyDown(e),
            onClick: (e)=>this.onClick(e),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(customClass, $kEmqw.sortTrigger, {
                [$kEmqw.active]: sorting.field === attribute,
                [$kEmqw.isDisabled]: isDisabled
            })
        }, this.getArrows()));
    }
    constructor(...args){
        super(...args);
        this.getSortBy = ()=>{
            const { column: { attribute: attribute }, sorting: sorting, customFields: customFields } = this.props;
            const { field: field, direction: direction } = sorting;
            let nextDirection = attribute === 'priority' ? (0, $5rYNM.SORT_DIRECTION).DESCENDING : (0, $5rYNM.SORT_DIRECTION).ASCENDING;
            if (attribute === field) {
                if (field === 'priority' && direction === (0, $5rYNM.SORT_DIRECTION).ASCENDING) return 0, $dvRTl.defaultSorting;
                if (field === 'priority' && direction === (0, $5rYNM.SORT_DIRECTION).DESCENDING) return (0, $62d8R.getSortConfiguration)(attribute, customFields, (0, $5rYNM.SORT_DIRECTION).ASCENDING);
                if (direction === (0, $5rYNM.SORT_DIRECTION).DESCENDING) return 0, $dvRTl.defaultSorting;
                if (direction === (0, $5rYNM.SORT_DIRECTION).ASCENDING) nextDirection = (0, $5rYNM.SORT_DIRECTION).DESCENDING;
            }
            return (0, $62d8R.getSortConfiguration)(attribute, customFields, nextDirection);
        };
        this.fireAnalytics = ()=>{
            if (!this.analyticsEvent) return;
            const { planningUnit: planningUnit } = this.props;
            const sortConfiguration = this.getSortBy();
            const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SORT_BY_CLICKED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(this.analyticsEvent.update({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                sortByField: sortConfiguration.isCustomField === true ? `customfield_${sortConfiguration.type}` : (0, $7s3LJ.getFieldKey)(sortConfiguration.field, planningUnit)
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onClick = (e)=>{
            const { isDisabled: isDisabled = false, changeSort: changeSort } = this.props;
            e.stopPropagation();
            if (isDisabled) return;
            (0, $duQ8C.default)((0, $2BQwE.KEYS).SORT_BY_FIELD);
            this.fireAnalytics();
            changeSort(this.getSortBy());
        };
        this.onKeyDown = (event)=>{
            const { isDisabled: isDisabled = false, changeSort: changeSort } = this.props;
            event.stopPropagation();
            if (isDisabled) return;
            if (event.key === 'Enter' || event.key === ' ') {
                (0, $duQ8C.default)((0, $2BQwE.KEYS).SORT_BY_FIELD);
                this.fireAnalytics();
                changeSort(this.getSortBy());
            }
        };
        this.getArrows = ()=>{
            const { sorting: sorting, column: { attribute: attribute }, intl: intl, isDisabled: isDisabled = false } = this.props;
            if (attribute === 'priority') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: isDisabled ? intl.formatMessage((0, $ib5d3.default).disabledSortByPriorityTooltip) : null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: isDisabled ? $kEmqw.paddingOld : ''
            }, sorting.field === attribute && sorting.direction === (0, $5rYNM.SORT_DIRECTION).ASCENDING ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.arrow-up-icon-ascending",
                label: "",
                size: "small",
                primaryColor: "currentColor"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.arrow-down-icon-descending",
                label: "",
                size: "small",
                primaryColor: "currentColor"
            })));
            return sorting.field === attribute && sorting.direction === (0, $5rYNM.SORT_DIRECTION).DESCENDING ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9SdpV))), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.arrow-down-icon-descending",
                label: "",
                size: "small",
                primaryColor: "currentColor"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hL0Qd))), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.arrow-up-icon-ascending",
                label: "",
                size: "small",
                primaryColor: "currentColor"
            });
        };
    }
}
var $aae23378a79eef83$export$2e2bcd8739ae039 = (0, $2qhQi.default)($aae23378a79eef83$var$SortButton);

});
parcelRegister("9SdpV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $730390946cb60768$var$_react = $730390946cb60768$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $730390946cb60768$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $730390946cb60768$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $730390946cb60768$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11 6v9.586l-3.793-3.793a.999.999 0 00-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A.993.993 0 0012 19a.993.993 0 00.707-.293l5.5-5.499a1 1 0 10-1.414-1.415L13 15.586V6a1 1 0 00-2 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$730390946cb60768$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $730390946cb60768$var$_default = $730390946cb60768$var$ArrowDownIcon;
module.exports.default = $730390946cb60768$var$_default;

});

parcelRegister("hL0Qd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ced77a83dab807a4$var$_react = $ced77a83dab807a4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ced77a83dab807a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ced77a83dab807a4$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $ced77a83dab807a4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.293 5.293l-5.5 5.499a1.002 1.002 0 000 1.415.999.999 0 001.414 0L11 8.414V18a1 1 0 002 0V8.414l3.793 3.793a1 1 0 101.414-1.415l-5.5-5.499A.993.993 0 0012 5a.993.993 0 00-.707.293z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ced77a83dab807a4$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $ced77a83dab807a4$var$_default = $ced77a83dab807a4$var$ArrowUpIcon;
module.exports.default = $ced77a83dab807a4$var$_default;

});

parcelRegister("62d8R", function(module, exports) {

$parcel$export(module.exports, "getSortConfiguration", () => $5ef8d2452a34c2ce$export$518fef3a003052f);
$parcel$export(module.exports, "getOptionValueLabels", () => $5ef8d2452a34c2ce$export$e1872e169bf7937e);
$parcel$export(module.exports, "getStandardFieldsOptions", () => $5ef8d2452a34c2ce$export$f28a1cca332467ab);
$parcel$export(module.exports, "getCustomFieldsOptions", () => $5ef8d2452a34c2ce$export$9cabfb437de15b20);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");

var $ffiyv = parcelRequire("ffiyv");

var $kKj1m = parcelRequire("kKj1m");
parcelRequire("1Uotp");
var $eOsHk = parcelRequire("eOsHk");
var $chgK5 = parcelRequire("chgK5");

var $63Xjz = parcelRequire("63Xjz");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $bWzWB = parcelRequire("bWzWB");

var $joFQ2 = parcelRequire("joFQ2");
const $5ef8d2452a34c2ce$export$2c756f10502e9fb9 = (fieldId)=>!(0, $eOsHk.BUILT_IN_DATE_FIELDS).includes(fieldId);
const $5ef8d2452a34c2ce$export$518fef3a003052f = (fieldId, customFields, // ascending is the default sort direction when choosing a sort type
direction = (0, $5rYNM.SORT_DIRECTION).ASCENDING)=>{
    // Technically the type of fieldId is string here but we want to test if it is included in the BUILT_IN_DATE_FIELDS which is a specific set of strings.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ($5ef8d2452a34c2ce$export$2c756f10502e9fb9(fieldId)) {
        const customField = (0, $kKj1m.getCustomFieldById)(Number(fieldId), customFields);
        if (customField.length === 1) return {
            field: fieldId,
            type: (0, $5rYNM.CustomFieldTypesToDataType)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            customField[0].type.key],
            direction: direction,
            isCustomField: true
        };
    }
    return {
        field: fieldId,
        type: (0, $chgK5.ISSUE_FIELD_TO_TYPE_MAP)[fieldId],
        direction: direction
    };
};
const $5ef8d2452a34c2ce$export$8ec6c1f91252b206 = (attribute, title, dateConfiguration)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    if (attribute === baselineStartField.key || attribute === baselineEndField.key) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $joFQ2.configuredDateLozenge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "D")));
    return title;
};
const $5ef8d2452a34c2ce$var$isCustomFieldSortable = (field)=>!!(0, $63Xjz.customFieldColumnProperties)($kjklK.default([
        'type',
        'key'
    ], field)).isSortable;
const $5ef8d2452a34c2ce$export$e1872e169bf7937e = (intl, customFields, planningUnit)=>({
        ...customFields.reduce((prev, curr)=>Object.assign(prev, {
                [curr.id]: curr.title
            }), {}),
        [(0, $chgK5.ISSUE_FIELDS).RANK]: intl.formatMessage((0, $bWzWB.default).rank),
        [(0, $chgK5.ISSUE_FIELDS).ASSIGNEE_FIELD]: intl.formatMessage((0, $ib5d3.default).assignee),
        [(0, $chgK5.ISSUE_FIELDS).REPORTER_FIELD]: intl.formatMessage((0, $ib5d3.default).reporter),
        [(0, $chgK5.ISSUE_FIELDS).DUE_DATE]: intl.formatMessage((0, $ib5d3.default).dueDate),
        [(0, $chgK5.ISSUE_FIELDS).PRIORITY_FIELD]: intl.formatMessage((0, $ib5d3.default).priority),
        [(0, $chgK5.ISSUE_FIELDS).STATUS_FIELD]: intl.formatMessage((0, $ib5d3.default).status),
        [(0, $chgK5.ISSUE_FIELDS).ESTIMATE]: intl.formatMessage((0, $bWzWB.default)[planningUnit]),
        [(0, $chgK5.ISSUE_FIELDS).TARGET_START_FIELD]: intl.formatMessage((0, $ib5d3.default).targetStart),
        [(0, $chgK5.ISSUE_FIELDS).TARGET_END_FIELD]: intl.formatMessage((0, $ib5d3.default).targetEnd),
        [(0, $chgK5.ISSUE_FIELDS).TEAM_FIELD]: intl.formatMessage((0, $ib5d3.default).team)
    });
const $5ef8d2452a34c2ce$export$f28a1cca332467ab = (dateConfiguration, labels, issuePrioritiesIdList)=>{
    const makeOption = (key, defaultDirection, isDisabled, tooltipContent)=>({
            content: $5ef8d2452a34c2ce$export$8ec6c1f91252b206(key, labels[key], dateConfiguration),
            id: key,
            isDisabled: isDisabled ?? false,
            label: labels[key],
            tooltipContent: tooltipContent ?? null,
            value: key,
            ...defaultDirection ? {
                defaultDirection: defaultDirection
            } : {}
        });
    const systemFieldsOptions = [
        makeOption((0, $chgK5.ISSUE_FIELDS).RANK),
        makeOption((0, $chgK5.ISSUE_FIELDS).ASSIGNEE_FIELD),
        makeOption((0, $chgK5.ISSUE_FIELDS).REPORTER_FIELD),
        makeOption((0, $chgK5.ISSUE_FIELDS).DUE_DATE),
        makeOption((0, $chgK5.ISSUE_FIELDS).PRIORITY_FIELD, (0, $5rYNM.SORT_DIRECTION).DESCENDING, !issuePrioritiesIdList, (0, $ib5d3.default).disabledSortByPriorityTooltip),
        makeOption((0, $chgK5.ISSUE_FIELDS).STATUS_FIELD),
        makeOption((0, $chgK5.ISSUE_FIELDS).ESTIMATE),
        makeOption((0, $chgK5.ISSUE_FIELDS).TARGET_START_FIELD),
        makeOption((0, $chgK5.ISSUE_FIELDS).TARGET_END_FIELD),
        makeOption((0, $chgK5.ISSUE_FIELDS).TEAM_FIELD)
    ];
    return systemFieldsOptions;
};
const $5ef8d2452a34c2ce$export$9cabfb437de15b20 = (customFields, dateConfiguration)=>{
    const customFieldsOptions = (0, $7CnHa.filterMap)($5ef8d2452a34c2ce$var$isCustomFieldSortable, ({ id: id, title: title })=>({
            id: String(id),
            content: $5ef8d2452a34c2ce$export$8ec6c1f91252b206(String(id), title, dateConfiguration),
            label: title,
            value: String(id)
        }), customFields);
    return customFieldsOptions;
};

});
parcelRegister("bWzWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $837cc2e1accf01f9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $837cc2e1accf01f9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortByLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.sort-by-label",
        "defaultMessage": "Sort by"
    },
    Hours: {
        "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-hours",
        "defaultMessage": "Estimate (h)"
    },
    Days: {
        "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-days",
        "defaultMessage": "Estimate (d)"
    },
    StoryPoints: {
        "id": "simple-plans.view.main.tabs.roadmap.sort-by.option.estimate-story-points",
        "defaultMessage": "Story points"
    },
    rank: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.rank",
        "defaultMessage": "Rank (default)"
    },
    ascending: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.ascending",
        "defaultMessage": "Ascending"
    },
    descending: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.descending",
        "defaultMessage": "Descending"
    }
});

});

parcelRegister("joFQ2", function(module, exports) {

$parcel$export(module.exports, "configuredDateLozenge", () => $e1f0b6688a9b209e$export$8f64b4dd67ed1dca, (v) => $e1f0b6688a9b209e$export$8f64b4dd67ed1dca = v);
$parcel$export(module.exports, "radioOptions", () => $e1f0b6688a9b209e$export$778efc6049c081e9, (v) => $e1f0b6688a9b209e$export$778efc6049c081e9 = v);
$parcel$export(module.exports, "row", () => $e1f0b6688a9b209e$export$120ff0929b202a6d, (v) => $e1f0b6688a9b209e$export$120ff0929b202a6d = v);
var $e1f0b6688a9b209e$export$8f64b4dd67ed1dca;
var $e1f0b6688a9b209e$export$778efc6049c081e9;
var $e1f0b6688a9b209e$export$120ff0929b202a6d;
$e1f0b6688a9b209e$export$8f64b4dd67ed1dca = `_1OEXCW_configuredDateLozenge`;
$e1f0b6688a9b209e$export$778efc6049c081e9 = `_1OEXCW_radioOptions`;
$e1f0b6688a9b209e$export$120ff0929b202a6d = `_1OEXCW_row`;

});


parcelRegister("1nXab", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a619eaa563834f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1a619eaa563834f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sortButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.fields.header.sort-button.sort-button",
        "defaultMessage": "Sort the issues by this column"
    }
});

});

parcelRegister("kEmqw", function(module, exports) {

$parcel$export(module.exports, "active", () => $f088f08ff9f7c321$export$89da14300d534261, (v) => $f088f08ff9f7c321$export$89da14300d534261 = v);
$parcel$export(module.exports, "isDisabled", () => $f088f08ff9f7c321$export$30e0dc115df457ed, (v) => $f088f08ff9f7c321$export$30e0dc115df457ed = v);
$parcel$export(module.exports, "paddingOld", () => $f088f08ff9f7c321$export$afc9c8486c5be97f, (v) => $f088f08ff9f7c321$export$afc9c8486c5be97f = v);
$parcel$export(module.exports, "sortTrigger", () => $f088f08ff9f7c321$export$ef529da8c648bcc7, (v) => $f088f08ff9f7c321$export$ef529da8c648bcc7 = v);
var $f088f08ff9f7c321$export$89da14300d534261;
var $f088f08ff9f7c321$export$30e0dc115df457ed;
var $f088f08ff9f7c321$export$afc9c8486c5be97f;
var $f088f08ff9f7c321$export$ef529da8c648bcc7;
$f088f08ff9f7c321$export$89da14300d534261 = `ZrGMTq_active`;
$f088f08ff9f7c321$export$30e0dc115df457ed = `ZrGMTq_isDisabled`;
$f088f08ff9f7c321$export$afc9c8486c5be97f = `ZrGMTq_paddingOld`;
$f088f08ff9f7c321$export$ef529da8c648bcc7 = `ZrGMTq_sortTrigger`;

});


parcelRegister("a5PyD", function(module, exports) {

$parcel$export(module.exports, "column-header", () => $75925d448590d26a$export$7177d480608b4128, (v) => $75925d448590d26a$export$7177d480608b4128 = v);
$parcel$export(module.exports, "column-header-section", () => $75925d448590d26a$export$ea59de8ceee50c62, (v) => $75925d448590d26a$export$ea59de8ceee50c62 = v);
$parcel$export(module.exports, "field-icon", () => $75925d448590d26a$export$72245aedad1c2dbb, (v) => $75925d448590d26a$export$72245aedad1c2dbb = v);
$parcel$export(module.exports, "field-icon__left", () => $75925d448590d26a$export$71b3a780a437564c, (v) => $75925d448590d26a$export$71b3a780a437564c = v);
$parcel$export(module.exports, "field-title", () => $75925d448590d26a$export$f2428550d8c0b97b, (v) => $75925d448590d26a$export$f2428550d8c0b97b = v);
$parcel$export(module.exports, "field-title-wrapper", () => $75925d448590d26a$export$72e507d84bf0f188, (v) => $75925d448590d26a$export$72e507d84bf0f188 = v);
$parcel$export(module.exports, "field-title-wrapper-collapsible", () => $75925d448590d26a$export$5312bd69e9cc2bf0, (v) => $75925d448590d26a$export$5312bd69e9cc2bf0 = v);
$parcel$export(module.exports, "header", () => $75925d448590d26a$export$38e42c68cf43b5d4, (v) => $75925d448590d26a$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "header-spinner", () => $75925d448590d26a$export$b06ee3291fc78504, (v) => $75925d448590d26a$export$b06ee3291fc78504 = v);
$parcel$export(module.exports, "no-fields-header", () => $75925d448590d26a$export$33882bbad5966adf, (v) => $75925d448590d26a$export$33882bbad5966adf = v);
$parcel$export(module.exports, "no-fields-text", () => $75925d448590d26a$export$a1def9c7e7278bb2, (v) => $75925d448590d26a$export$a1def9c7e7278bb2 = v);
$parcel$export(module.exports, "no-focus", () => $75925d448590d26a$export$e9c6726c80f38942, (v) => $75925d448590d26a$export$e9c6726c80f38942 = v);
$parcel$export(module.exports, "no-focus-collapsible", () => $75925d448590d26a$export$e2afb79796ef6089, (v) => $75925d448590d26a$export$e2afb79796ef6089 = v);
$parcel$export(module.exports, "options", () => $75925d448590d26a$export$41c562ebe57d11e2, (v) => $75925d448590d26a$export$41c562ebe57d11e2 = v);
$parcel$export(module.exports, "sortTriggerButton", () => $75925d448590d26a$export$7dcdcaaa8ed613dd, (v) => $75925d448590d26a$export$7dcdcaaa8ed613dd = v);
$parcel$export(module.exports, "top-section", () => $75925d448590d26a$export$264fe72e5bd79b45, (v) => $75925d448590d26a$export$264fe72e5bd79b45 = v);
var $75925d448590d26a$export$7177d480608b4128;
var $75925d448590d26a$export$ea59de8ceee50c62;
var $75925d448590d26a$export$72245aedad1c2dbb;
var $75925d448590d26a$export$71b3a780a437564c;
var $75925d448590d26a$export$f2428550d8c0b97b;
var $75925d448590d26a$export$72e507d84bf0f188;
var $75925d448590d26a$export$5312bd69e9cc2bf0;
var $75925d448590d26a$export$38e42c68cf43b5d4;
var $75925d448590d26a$export$b06ee3291fc78504;
var $75925d448590d26a$export$33882bbad5966adf;
var $75925d448590d26a$export$a1def9c7e7278bb2;
var $75925d448590d26a$export$e9c6726c80f38942;
var $75925d448590d26a$export$e2afb79796ef6089;
var $75925d448590d26a$export$41c562ebe57d11e2;
var $75925d448590d26a$export$7dcdcaaa8ed613dd;
var $75925d448590d26a$export$264fe72e5bd79b45;
$75925d448590d26a$export$7177d480608b4128 = `REtQ6a_column-header`;
$75925d448590d26a$export$ea59de8ceee50c62 = `REtQ6a_column-header-section`;
$75925d448590d26a$export$72245aedad1c2dbb = `REtQ6a_field-icon`;
$75925d448590d26a$export$71b3a780a437564c = `REtQ6a_field-icon__left`;
$75925d448590d26a$export$f2428550d8c0b97b = `REtQ6a_field-title`;
$75925d448590d26a$export$72e507d84bf0f188 = `REtQ6a_field-title-wrapper`;
$75925d448590d26a$export$5312bd69e9cc2bf0 = `REtQ6a_field-title-wrapper-collapsible`;
$75925d448590d26a$export$38e42c68cf43b5d4 = `REtQ6a_header`;
$75925d448590d26a$export$b06ee3291fc78504 = `REtQ6a_header-spinner`;
$75925d448590d26a$export$33882bbad5966adf = `REtQ6a_no-fields-header`;
$75925d448590d26a$export$a1def9c7e7278bb2 = `REtQ6a_no-fields-text`;
$75925d448590d26a$export$e9c6726c80f38942 = `REtQ6a_no-focus`;
$75925d448590d26a$export$e2afb79796ef6089 = `REtQ6a_no-focus-collapsible`;
$75925d448590d26a$export$41c562ebe57d11e2 = `REtQ6a_options`;
$75925d448590d26a$export$7dcdcaaa8ed613dd = `REtQ6a_sortTriggerButton`;
$75925d448590d26a$export$264fe72e5bd79b45 = `REtQ6a_top-section`;

});



parcelRegister("enlJQ", function(module, exports) {

$parcel$export(module.exports, "ZoomLevelSync", () => (parcelRequire("5zxdR")).default);
$parcel$export(module.exports, "wrapHorizontalScrollView", () => (parcelRequire("jjPWu")).default);
$parcel$export(module.exports, "HorizontalScrollBar", () => (parcelRequire("33T6K")).default);
$parcel$export(module.exports, "HorizontalScrollBarOverlay", () => (parcelRequire("l3ocQ")).default);

var $5zxdR = parcelRequire("5zxdR");

var $jjPWu = parcelRequire("jjPWu");

var $33T6K = parcelRequire("33T6K");
var $l3ocQ = parcelRequire("l3ocQ");

});
parcelRegister("5zxdR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8692684fa25d5f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jNJc8 = parcelRequire("jNJc8");

var $8vXrP = parcelRequire("8vXrP");
var $7f8692684fa25d5f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jNJc8.default), {})((0, $8vXrP.default));

});
parcelRegister("jNJc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f3ac5fa7bfc19f$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $81f3ac5fa7bfc19f$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    timeScale: (0, $9H2AP.getTimeScaleViewSettings)
});

});

parcelRegister("8vXrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ceebc2d4e4508e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");

var $kUlCF = parcelRequire("kUlCF");
function $02ceebc2d4e4508e$export$2e2bcd8739ae039({ timeScale: timeScale }) {
    const timeScaleselection = timeScale.mode;
    const zoomLevel = (0, $kUlCF.getZoomLevel)(timeScaleselection);
    const [{ container: container, viewport: viewport }, { changeZoomLevel: changeZoomLevel, setViewportOffset: setViewportOffset }] = (0, $jODJR.useHorizontalScrolling)();
    // We want to avoid re-render on change of offset
    const nextOffsetRef = (0, $eUqFw.useRef)(0);
    const nextContainerDuration = zoomLevel !== undefined ? (0, $kUlCF.getContainerDuration)(zoomLevel) : 0;
    const nextMsPerPx = nextContainerDuration / container.width;
    const nextViewportDuration = viewport.width * nextMsPerPx;
    nextOffsetRef.current = nextViewportDuration * -0.15;
    // We want to avoid re-render on resize of container after container width has been set
    const containerHasWidth = container.width > 0;
    (0, $eUqFw.useEffect)(()=>{
        changeZoomLevel(zoomLevel);
        setViewportOffset(nextOffsetRef.current, 'zoomLevelChange');
    }, [
        zoomLevel,
        changeZoomLevel,
        setViewportOffset,
        containerHasWidth
    ]);
    return null;
}

});
parcelRegister("jODJR", function(module, exports) {

$parcel$export(module.exports, "useHorizontalScrolling", () => $8e62ddc7dd4fca51$export$97744631e5b676f5);
$parcel$export(module.exports, "createHorizontalScrollingHook", () => $8e62ddc7dd4fca51$export$c64aea07291af4d8);
$parcel$export(module.exports, "useZoomLevel", () => $8e62ddc7dd4fca51$export$83457f1b00e4d97b);
$parcel$export(module.exports, "useToday", () => $8e62ddc7dd4fca51$export$6d84255ad587f3b5);
$parcel$export(module.exports, "useSmooth", () => $8e62ddc7dd4fca51$export$665d75b0980ae645);
$parcel$export(module.exports, "useContainer", () => $8e62ddc7dd4fca51$export$b537cf6ebaf7ff54);
$parcel$export(module.exports, "useTimelineRuler", () => $8e62ddc7dd4fca51$export$cb80d2fae0ecdd66);
$parcel$export(module.exports, "useRenderingWindow", () => $8e62ddc7dd4fca51$export$2acc4f37cfc616a1);
$parcel$export(module.exports, "useHorizontalPercentageOffset", () => $8e62ddc7dd4fca51$export$e1fd0a2978f600ad);
$parcel$export(module.exports, "subscribeHorizontalScrolling", () => $8e62ddc7dd4fca51$export$63c91c16e36ba6b9);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");
var $gasA1 = parcelRequire("gasA1");

var $17L5s = parcelRequire("17L5s");

var $8tMGO = parcelRequire("8tMGO");

var $kUlCF = parcelRequire("kUlCF");
const $8e62ddc7dd4fca51$var$initialState = {
    zoomLevel: undefined,
    viewport: {
        offset: 0,
        width: 0,
        position: {
            left: 0,
            top: 0
        }
    },
    container: {
        duration: 0,
        width: 0
    },
    smooth: false,
    isScrollingWithScrollBar: false,
    today: (0, $17L5s.startOfUtcDay)(Date.now()),
    lastScrollTrigger: null,
    scrollEventHandlers: []
};
const $8e62ddc7dd4fca51$var$actions = {
    nudge: (deltaX)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { viewport: viewport, container: container } = state;
            const deltaT = deltaX * container.duration / container.width;
            const offset = viewport.offset + deltaT;
            setState({
                ...state,
                lastScrollTrigger: 'mousewheel',
                viewport: {
                    ...viewport,
                    offset: offset
                }
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    setViewportOffset: (offset, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const nextOffset = typeof offset === 'function' ? offset(state.viewport.offset) : offset;
            setState({
                ...state,
                lastScrollTrigger: source,
                viewport: {
                    ...state.viewport,
                    offset: nextOffset
                }
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
            dispatch($8e62ddc7dd4fca51$var$actions.triggerScrollEventHandlers(nextOffset, state.smooth, source));
        },
    resize: (payload)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            setState({
                ...state,
                viewport: {
                    ...state.viewport,
                    ...payload.viewport
                },
                container: payload.container
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    changeZoomLevel: (zoomLevel)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const newScrollTrigger = 'zoomLevelChange';
            let newState = {
                ...state,
                lastScrollTrigger: newScrollTrigger,
                zoomLevel: zoomLevel
            };
            if (zoomLevel) newState = {
                ...newState,
                container: {
                    duration: (0, $kUlCF.getContainerDuration)(zoomLevel),
                    width: (0, $kUlCF.getContainerWidth)(zoomLevel)
                }
            };
            setState(newState);
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    scrollTo: (offsetInPx, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { viewport: viewport, container: container } = state;
            const offsetT = offsetInPx * container.duration / container.width;
            setState({
                ...state,
                lastScrollTrigger: source,
                viewport: {
                    ...viewport,
                    offset: offsetT
                }
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    // this action is used by panning controls "<" and ">" to shift the timeline to the left / right
    shiftTimeline: (direction, source)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const { viewport: viewport, container: container } = state;
            const msToPx = (ms)=>ms * container.width / (container.duration || 1);
            const offsetInPx = msToPx(viewport.offset) + viewport.width * (0, $8tMGO.SCROLL_BUTTON_STEP) * (direction === 'left' ? -1 : 1);
            const offset = offsetInPx * container.duration / container.width;
            setState({
                ...state,
                lastScrollTrigger: source,
                viewport: {
                    ...viewport,
                    offset: offset
                }
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
            dispatch($8e62ddc7dd4fca51$var$actions.triggerScrollEventHandlers(offset, state.smooth, source));
        },
    scrollToView: ({ timestamp: timestamp }, source)=>({ getState: getState, dispatch: dispatch })=>{
            const { viewport: viewport, container: container, today: today } = getState();
            const msPerPx = container.duration / container.width;
            const viewportDuration = viewport.width * msPerPx;
            const margin = 24;
            const leftEdge = today + viewport.offset;
            const rightEdge = today + viewport.offset + viewportDuration;
            if (timestamp < leftEdge) {
                const nextViewportOffset = timestamp - today - margin * msPerPx; /** have some margin to the left */ 
                dispatch($8e62ddc7dd4fca51$var$actions.setViewportOffset(nextViewportOffset, source));
            }
            if (timestamp > rightEdge) {
                const nextViewportOffset = timestamp - today - viewportDuration + margin * msPerPx; /** have some margin to the right */ 
                dispatch($8e62ddc7dd4fca51$var$actions.setViewportOffset(nextViewportOffset, source));
            }
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    setSmooth: (newSmoothState)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            setState({
                ...state,
                smooth: newSmoothState
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    setScrollingWithScrollBar: (newScrollingState)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const state = getState();
            setState({
                ...state,
                isScrollingWithScrollBar: newScrollingState
            });
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    backToToday: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { container: container } = getState();
            const msPerPx = container.duration / container.width;
            const margin = (0, $8tMGO.ESTIMATED_MAX_COLUMN_WIDTH);
            const nextViewportOffset = -margin * msPerPx; /** have some margin to the left */ 
            dispatch($8e62ddc7dd4fca51$var$actions.setViewportOffset(nextViewportOffset, 'todayButton'));
            dispatch($8e62ddc7dd4fca51$var$actions.syncToday());
        },
    // When you open a plan on day 1, then go to the same plan on day 2 without refreshing the page, and
    // scroll the plan horizontally, the timeline header will appear shifted by a month because startOfUtcDay(Date.now())
    // is different from the startOfUtcDay(Date.now()) stored in the horizontal scrolling state (= yesterday)
    // therefore this function resets horizontal scrolling's `today` to... today
    // see https://jdog.jira-dev.com/browse/JPO-20671 for future reference
    syncToday: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const startOfToday = (0, $17L5s.startOfUtcDay)(Date.now());
            if (state.today !== startOfToday) setState({
                ...state,
                today: startOfToday
            });
        },
    triggerScrollEventHandlers: (offset, smooth, source)=>({ getState: getState })=>{
            const { container: container, scrollEventHandlers: scrollEventHandlers } = getState();
            const offsetInPx = offset * container.width / container.duration;
            scrollEventHandlers.forEach((callback)=>callback({
                    offsetInPx: offsetInPx,
                    smooth: smooth,
                    source: source
                }));
        },
    addScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
            setState({
                scrollEventHandlers: getState().scrollEventHandlers.concat(callback)
            });
        },
    removeScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
            setState({
                scrollEventHandlers: getState().scrollEventHandlers.filter((eventHandler)=>eventHandler !== callback)
            });
        }
};
const $8e62ddc7dd4fca51$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: $8e62ddc7dd4fca51$var$initialState,
    actions: $8e62ddc7dd4fca51$var$actions,
    name: 'portfolio-3/horizontal-scrolling'
});
const $8e62ddc7dd4fca51$export$97744631e5b676f5 = (0, $ggKAj.createHook)($8e62ddc7dd4fca51$export$390f32400eaf98c9);
const $8e62ddc7dd4fca51$export$c64aea07291af4d8 = (selector)=>(0, $ggKAj.createHook)($8e62ddc7dd4fca51$export$390f32400eaf98c9, {
        selector: selector
    });
const $8e62ddc7dd4fca51$export$83457f1b00e4d97b = $8e62ddc7dd4fca51$export$c64aea07291af4d8((state)=>state.zoomLevel);
const $8e62ddc7dd4fca51$export$6d84255ad587f3b5 = $8e62ddc7dd4fca51$export$c64aea07291af4d8((state)=>state.today);
const $8e62ddc7dd4fca51$export$665d75b0980ae645 = $8e62ddc7dd4fca51$export$c64aea07291af4d8((state)=>state.smooth);
const $8e62ddc7dd4fca51$export$b537cf6ebaf7ff54 = $8e62ddc7dd4fca51$export$c64aea07291af4d8((0, $bj4JM.createSelector)(({ container: container })=>container.duration, ({ container: container })=>container.width, (duration, width)=>({
        duration: duration,
        width: width
    })));
const $8e62ddc7dd4fca51$export$cb80d2fae0ecdd66 = $8e62ddc7dd4fca51$export$c64aea07291af4d8((0, $bj4JM.createSelector)(({ container: container })=>container.duration, ({ container: container })=>container.width, (duration, width)=>({
        pxToMs: (px)=>px * duration / (width || 1),
        msToPx: (ms)=>ms * width / (duration || 1)
    })));
const $8e62ddc7dd4fca51$var$DEFAULT_OVERSCAN = 1;
const $8e62ddc7dd4fca51$var$getViewportDuration = ({ container: container, viewport: viewport })=>container.duration / container.width * viewport.width;
const $8e62ddc7dd4fca51$var$getRenderingOverscan = (0, $bj4JM.createSelector)($8e62ddc7dd4fca51$var$getViewportDuration, (viewportDuration)=>$8e62ddc7dd4fca51$var$DEFAULT_OVERSCAN * viewportDuration);
const $8e62ddc7dd4fca51$var$getRenderingFrom = (0, $bj4JM.createSelector)($8e62ddc7dd4fca51$var$getRenderingOverscan, ({ viewport: viewport })=>viewport.offset, (overscan, viewportOffset)=>{
    const step = overscan / 2;
    return Math.floor(viewportOffset / step) * step - step;
});
const $8e62ddc7dd4fca51$var$getRenderingTo = (0, $bj4JM.createSelector)($8e62ddc7dd4fca51$var$getRenderingOverscan, $8e62ddc7dd4fca51$var$getViewportDuration, $8e62ddc7dd4fca51$var$getRenderingFrom, (overscan, viewportDuration, renderingFrom)=>renderingFrom + overscan + viewportDuration + overscan);
const $8e62ddc7dd4fca51$export$2acc4f37cfc616a1 = $8e62ddc7dd4fca51$export$c64aea07291af4d8((0, $bj4JM.createSelector)($8e62ddc7dd4fca51$var$getRenderingFrom, $8e62ddc7dd4fca51$var$getRenderingTo, ({ today: today })=>today, (from, to, today)=>{
    const start = today + from;
    const end = today + to;
    return {
        today: today,
        from: from,
        timelineRange: {
            start: start,
            end: end
        },
        to: to
    };
}));
const $8e62ddc7dd4fca51$export$e1fd0a2978f600ad = (0, $ggKAj.createHook)($8e62ddc7dd4fca51$export$390f32400eaf98c9, {
    selector: (0, $bj4JM.createSelector)((state)=>state.container.duration, (state)=>state.today, (duration, today)=>({
            getPercentageOffset: (offset)=>100 * offset / duration,
            getPercentageOffsetFromToday: (offset)=>100 * (offset - today) / duration
        }))
});
const $8e62ddc7dd4fca51$export$63c91c16e36ba6b9 = (callback)=>{
    const { storeState: storeState } = (0, $gasA1.defaultRegistry).getStore($8e62ddc7dd4fca51$export$390f32400eaf98c9);
    return storeState.subscribe(()=>{
        callback(storeState.getState());
    });
};

});



parcelRegister("jjPWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb95ea5affdf50f2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3oQRH = parcelRequire("3oQRH");
function $cb95ea5affdf50f2$export$2e2bcd8739ae039(wrapped) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oQRH.default), null, wrapped);
}

});
parcelRegister("3oQRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff4025581ee7f01$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JB4J = parcelRequire("5JB4J");

var $kUlCF = parcelRequire("kUlCF");

var $jODJR = parcelRequire("jODJR");

var $eddr9 = parcelRequire("eddr9");

var $H71MQ = parcelRequire("H71MQ");
const $bff4025581ee7f01$var$paddingToHideAutoHideScrollbar = 50;
const $bff4025581ee7f01$var$paddingSize = 1e6;
/**
 * Makes the container elements that resizing
 * @returns a DOM ref to the container el
 */ function $bff4025581ee7f01$var$useContainerRef() {
    const elRef = (0, $eUqFw.useRef)(null);
    const [{ width: width }] = (0, $jODJR.useContainer)();
    (0, $eUqFw.useEffect)(()=>{
        const el = elRef.current;
        if (el) el.style.width = `${width}px`;
    }, [
        width
    ]);
    return elRef;
}
function $bff4025581ee7f01$export$a22565511017b133({ children: children }) {
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const containerRef = $bff4025581ee7f01$var$useContainerRef();
    const nativeScrollBarHeight = (0, $5JB4J.useNativeScrollbarHeight)();
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [smooth] = (0, $jODJR.useSmooth)();
    const [, { resize: resize }] = (0, $jODJR.useContainer)();
    (0, $eddr9.useKeyHandler)(scrollableRef.current);
    const viewportRef = (0, $eddr9.useResizeObserver)((0, $eUqFw.useCallback)((el)=>{
        if (!zoomLevel) return;
        const { width: viewportWidth, left: left, top: top } = el.getBoundingClientRect();
        resize({
            viewport: {
                width: viewportWidth,
                position: {
                    left: left,
                    top: top
                }
            },
            container: {
                width: (0, $kUlCF.getContainerWidth)(zoomLevel),
                duration: (0, $kUlCF.getContainerDuration)(zoomLevel)
            }
        });
    }, [
        resize,
        zoomLevel
    ]));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: viewportRef,
        xcss: $bff4025581ee7f01$var$viewportStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        tabIndex: 0,
        ref: scrollableRef,
        xcss: $bff4025581ee7f01$var$scrollableStyles,
        style: {
            bottom: `${-((nativeScrollBarHeight ?? 0) + $bff4025581ee7f01$var$paddingToHideAutoHideScrollbar)}px`,
            scrollBehavior: smooth ? 'smooth' : 'auto',
            paddingBottom: `${$bff4025581ee7f01$var$paddingToHideAutoHideScrollbar}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bff4025581ee7f01$var$containerStyles,
        ref: containerRef,
        testId: "portfolio-3-horizontal-scrolling.ui.scroll-view.container"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bff4025581ee7f01$var$farRightStyles
    }, " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $H71MQ.default), {
        scrollableRef: scrollableRef,
        paddingSize: $bff4025581ee7f01$var$paddingSize
    }));
}
function $bff4025581ee7f01$export$2e2bcd8739ae039(props) {
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    (0, $jODJR.useContainer)();
    if (zoomLevel === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bff4025581ee7f01$export$a22565511017b133, props);
}
const $bff4025581ee7f01$var$viewportStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.0',
    left: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    overflowY: 'hidden'
});
const $bff4025581ee7f01$var$scrollableStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.0',
    left: 'space.0',
    right: 'space.0',
    overflowX: 'scroll',
    overflowY: 'hidden',
    outline: 'none'
});
const $bff4025581ee7f01$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    transform: `translateX(${$bff4025581ee7f01$var$paddingSize}px)`
});
const $bff4025581ee7f01$var$farRightStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.0',
    left: `${2e6}px`,
    pointerEvents: 'none',
    opacity: 0
});

});
parcelRegister("eddr9", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $748b152f7b9469d1$export$683480f191c0e3ea);
$parcel$export(module.exports, "useKeyHandler", () => $748b152f7b9469d1$export$67f126879bce8c6);

var $eUqFw = parcelRequire("eUqFw");

var $8tMGO = parcelRequire("8tMGO");

var $jODJR = parcelRequire("jODJR");
function $748b152f7b9469d1$export$683480f191c0e3ea(callback) {
    const observer = (0, $eUqFw.useRef)(undefined);
    const ref = (0, $eUqFw.useCallback)((el)=>{
        if (observer.current) {
            observer.current.disconnect();
            observer.current = undefined;
        }
        if (el) {
            callback(el);
            if (typeof ResizeObserver !== 'undefined') {
                observer.current = new ResizeObserver(()=>callback(el));
                observer.current.observe(el);
            }
        }
    }, [
        callback
    ]);
    return ref;
}
const $748b152f7b9469d1$var$useViewportWidth = (0, $jODJR.createHorizontalScrollingHook)(({ viewport: viewport })=>viewport.width);
function $748b152f7b9469d1$export$67f126879bce8c6(target) {
    const [viewportWidth] = $748b152f7b9469d1$var$useViewportWidth();
    const [smooth, { setViewportOffset: setViewportOffset, setSmooth: setSmooth }] = (0, $jODJR.useSmooth)();
    const [{ pxToMs: pxToMs }] = (0, $jODJR.useTimelineRuler)();
    const triggeredRef = (0, $eUqFw.useRef)(false);
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { keyCode: keyCode } = e;
        if (keyCode !== (0, $8tMGO.KEY_ARROW_LEFT) && keyCode !== (0, $8tMGO.KEY_ARROW_RIGHT)) return;
        const directionMultiplier = keyCode === (0, $8tMGO.KEY_ARROW_LEFT) ? -1 : 1;
        const distance = viewportWidth * (0, $8tMGO.SCROLL_BUTTON_STEP) * directionMultiplier;
        setSmooth(true);
        setViewportOffset((offset)=>offset + pxToMs(distance), 'keyboardArrows');
        triggeredRef.current = true;
        e.preventDefault();
    }, [
        viewportWidth,
        setSmooth,
        setViewportOffset,
        pxToMs
    ]);
    // disable "smooth" scroll after
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (smooth && triggeredRef.current) {
            setSmooth(false);
            triggeredRef.current = false;
        }
    }, [
        setSmooth,
        smooth
    ]);
    // Adding keydown event handling
    (0, $eUqFw.useEffect)(()=>{
        if (!target) return;
        target.addEventListener('keydown', handleKeyDown, false);
        return ()=>target.removeEventListener('keydown', handleKeyDown, false);
    }, [
        handleKeyDown,
        target
    ]);
}

});

parcelRegister("H71MQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $76016fdb59611014$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JB4J = parcelRequire("5JB4J");

var $jODJR = parcelRequire("jODJR");
function $76016fdb59611014$var$useScrollingContainerVSync(scrollableEl, paddingSize) {
    const [{ viewport: viewport }, { nudge: nudge }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    (0, $eUqFw.useEffect)(()=>{
        const offsetInPx = msToPx(viewport.offset) || 0;
        if (scrollableEl) // eslint-disable-next-line no-param-reassign
        scrollableEl.scrollLeft = paddingSize + offsetInPx;
    }, [
        scrollableEl,
        viewport,
        msToPx,
        paddingSize
    ]);
    const handleWheel = (0, $eUqFw.useCallback)((e)=>{
        const { deltaX: deltaX, deltaY: deltaY } = (0, $5JB4J.getDelta)(e);
        if (Math.abs(deltaX) >= Math.abs(deltaY)) {
            nudge(deltaX);
            e.preventDefault();
        }
    }, [
        nudge
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!scrollableEl) return;
        scrollableEl.addEventListener('wheel', handleWheel, false);
        return ()=>scrollableEl.removeEventListener('wheel', handleWheel, false);
    }, [
        scrollableEl,
        handleWheel
    ]);
}
function $76016fdb59611014$export$2e2bcd8739ae039({ scrollableRef: { current: scrollableEl }, paddingSize: paddingSize }) {
    $76016fdb59611014$var$useScrollingContainerVSync(scrollableEl, paddingSize);
    return null;
}

});



parcelRegister("33T6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2899944486a4ab69$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hq3Md = parcelRequire("hq3Md");

var $8tMGO = parcelRequire("8tMGO");

var $jODJR = parcelRequire("jODJR");
/** Returns the content bound, which can be combined with the viewport bound to calculate the scrollbar UIs. */ function $2899944486a4ab69$var$useContentBound(useDefaultBound) {
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [minimumViewportOffset, setMinimumViewportOffset] = (0, $eUqFw.useState)(1e10);
    const [maximumViewportOffset, setMaximumViewportOffset] = (0, $eUqFw.useState)(-10000000000);
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    const today = new Date(date.getTime());
    date.setFullYear(new Date().getFullYear() - 1);
    const oneYearAgo = new Date(date.getTime());
    date.setFullYear(new Date().getFullYear() + 2);
    const twoYearsLater = new Date(date.getTime());
    // today
    date.setFullYear(new Date().getFullYear());
    const [{ msToPx: msToPx, pxToMs: pxToMs }] = (0, $jODJR.useTimelineRuler)();
    /** The minimum content bound, which is from 1 year ago to 2 years later. */ const minimumBound = {
        offset: oneYearAgo.getTime() - today.getTime(),
        width: msToPx(twoYearsLater.getTime() - oneYearAgo.getTime())
    };
    /** Values used to calculate the viewport offset from */ const offsetFromValues = [
        viewport.offset,
        minimumBound.offset
    ];
    /** Values used to calculate the viewport offset to */ const offsetToValues = [
        viewport.offset + pxToMs(viewport.width),
        minimumBound.offset + pxToMs(minimumBound.width)
    ];
    // If we don't use the default bound, then we add the minimum and maximum values for offset
    if (!useDefaultBound) {
        offsetFromValues.push(minimumViewportOffset);
        offsetToValues.push(maximumViewportOffset);
    }
    const offsetFrom = Math.min(...offsetFromValues);
    const offsetTo = Math.max(...offsetToValues);
    const duration = offsetTo - offsetFrom;
    // We update the values for maximum and minimum offset every time they change
    (0, $eUqFw.useEffect)(()=>{
        setMinimumViewportOffset(offsetFrom);
        setMaximumViewportOffset(offsetTo);
    }, [
        offsetFrom,
        offsetTo
    ]);
    return {
        offset: offsetFrom,
        width: msToPx(duration)
    };
}
/**
 * Hook to enable drag handling for the drag handler element sent via parameter.
 * @param {HTMLElement} dragHandlerEl
 * @returns {boolean} wether we are dragging at this moment or not
 */ function $2899944486a4ab69$var$useDragHandling(trackBarEl, dragHandlerEl) {
    const [{ smooth: smooth, viewport: viewport }, { setViewportOffset: setViewportOffset, setScrollingWithScrollBar: setScrollingWithScrollBar, setSmooth: setSmooth }] = (0, $jODJR.useHorizontalScrolling)();
    const [isDragging, setIsDragging] = (0, $eUqFw.useState)(false);
    const [{ pxToMs: pxToMs }] = (0, $jODJR.useTimelineRuler)();
    const triggeredStepRef = (0, $eUqFw.useRef)(false);
    /** The offsetX of the mouse, used for calculating how far the drag would have gone. */ const mouseDownOffsetRef = (0, $eUqFw.useRef)();
    const originalViewportOffsetRef = (0, $eUqFw.useRef)(0);
    const dragHandlerWidthRef = (0, $eUqFw.useRef)(0);
    const handleMouseDownInThumb = (0, $eUqFw.useCallback)((e)=>{
        if (dragHandlerEl === null) return;
        if (e.target !== dragHandlerEl) return;
        setIsDragging(true);
        setScrollingWithScrollBar(true);
        e.preventDefault(); // prevent the default behavior (such as text selection)
        e.stopPropagation(); // prevent propagating it to the track
        dragHandlerWidthRef.current = dragHandlerEl.getBoundingClientRect().width;
        mouseDownOffsetRef.current = e.clientX;
        originalViewportOffsetRef.current = viewport.offset;
    }, [
        dragHandlerEl,
        viewport.offset,
        setScrollingWithScrollBar
    ]);
    const handleMouseDownInTrack = (0, $eUqFw.useCallback)((e)=>{
        if (trackBarEl === null || dragHandlerEl === null) return;
        if (e.target !== trackBarEl) return;
        const { left: thumbX } = dragHandlerEl.getBoundingClientRect();
        const directionMultiplier = e.clientX < thumbX ? -1 : 1;
        const distance = viewport.width * (0, $8tMGO.SCROLL_BUTTON_STEP) * directionMultiplier;
        setSmooth(true);
        setViewportOffset((offset)=>offset + pxToMs(distance), 'scrollbar');
        triggeredStepRef.current = true;
        e.preventDefault();
    }, [
        dragHandlerEl,
        pxToMs,
        setSmooth,
        setViewportOffset,
        trackBarEl,
        viewport.width
    ]);
    const handleMouseDown = (0, $eUqFw.useCallback)((e)=>{
        if (dragHandlerEl === null) return;
        if (e.target === dragHandlerEl) return handleMouseDownInThumb(e);
        if (e.target === trackBarEl) return handleMouseDownInTrack(e);
    }, [
        dragHandlerEl,
        handleMouseDownInThumb,
        handleMouseDownInTrack,
        trackBarEl
    ]);
    const handleMouseMove = (0, $eUqFw.useCallback)((e)=>{
        // Skip if there was no preceed mousedown
        if (mouseDownOffsetRef.current == null) return;
        if (originalViewportOffsetRef.current == null) return;
        const currentMouseOffset = e.clientX;
        const mouseDeltaX = currentMouseOffset - mouseDownOffsetRef.current;
        const distanceInPx = mouseDeltaX / dragHandlerWidthRef.current * viewport.width;
        const nextViewportOffset = originalViewportOffsetRef.current + pxToMs(distanceInPx);
        setViewportOffset(nextViewportOffset, 'scrollbar');
        window.dispatchEvent(new WheelEvent('wheel', {
            deltaX: mouseDeltaX
        }));
    }, [
        setViewportOffset,
        viewport.width,
        pxToMs
    ]);
    const handleMouseUp = (0, $eUqFw.useCallback)(()=>{
        mouseDownOffsetRef.current = undefined;
        setIsDragging(false);
        setScrollingWithScrollBar(false);
    }, [
        setScrollingWithScrollBar
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('mousedown', handleMouseDown);
        return ()=>document.removeEventListener('mousedown', handleMouseDown);
    }, [
        handleMouseDown
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('mouseup', handleMouseUp);
        return ()=>document.removeEventListener('mouseup', handleMouseUp);
    }, [
        handleMouseUp
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('mousemove', handleMouseMove);
        return ()=>document.removeEventListener('mousemove', handleMouseMove);
    }, [
        handleMouseMove
    ]);
    // disable "smooth" scroll after
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (smooth && triggeredStepRef.current) {
            setSmooth(false);
            triggeredStepRef.current = false;
        }
    }, [
        setSmooth,
        smooth
    ]);
    return isDragging;
}
const $2899944486a4ab69$var$useDragHandlerStyle = (isDragging)=>{
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const contentBound = $2899944486a4ab69$var$useContentBound(!isDragging);
    const scale = viewport.width / contentBound.width;
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    if (viewport.width === 0 /** uninitialized */ ) return {
        width: 0,
        left: 0
    };
    return {
        width: viewport.width * scale - 7,
        left: msToPx(viewport.offset - contentBound.offset) * scale
    };
};
function $2899944486a4ab69$export$f2f142948c143045() {
    const trackRef = (0, $eUqFw.useRef)(null);
    const thumbRef = (0, $eUqFw.useRef)(null);
    const isDragging = $2899944486a4ab69$var$useDragHandling(trackRef.current, thumbRef.current);
    const dragHandlerStyle = $2899944486a4ab69$var$useDragHandlerStyle(isDragging);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq3Md.Track), {
        ref: trackRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq3Md.Thumb), {
        ref: thumbRef,
        ...dragHandlerStyle
    }));
}
function $2899944486a4ab69$export$2e2bcd8739ae039() {
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    if (zoomLevel === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2899944486a4ab69$export$f2f142948c143045, null);
}

});

parcelRegister("l3ocQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6435c7caae1a1618$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jODJR = parcelRequire("jODJR");
/**
 * This components will act as an overlay above the schedule when the user is scrolling using the scrollbar.
 * This will avoid interactions with the plan when scrolling
 */ const $6435c7caae1a1618$var$HorizontalScrollbarOverlay = ()=>{
    const [{ isScrollingWithScrollBar: isScrollingWithScrollBar }] = (0, $jODJR.useHorizontalScrolling)();
    if (!isScrollingWithScrollBar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-horizontal-scrolling.ui.scroll-bar-overlay.scrollbar-overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6435c7caae1a1618$var$scrollbarOverlayStyles,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            zIndex: 'var(--jpo-z-index-horizontal-scrolling-overlay)'
        }
    }));
};
var $6435c7caae1a1618$export$2e2bcd8739ae039 = $6435c7caae1a1618$var$HorizontalScrollbarOverlay;
const $6435c7caae1a1618$var$scrollbarOverlayStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    left: 'space.0',
    right: 'space.0',
    top: 'space.0',
    bottom: 'space.100'
});

});


parcelRegister("b1lid", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fa0de411461c5e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9Nuei = parcelRequire("9Nuei");

var $jVrXg = parcelRequire("jVrXg");
var $e1fa0de411461c5e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9Nuei.default), {})((0, $jVrXg.default));

});
parcelRegister("9Nuei", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf9f098b9967043$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $9H2AP = parcelRequire("9H2AP");
const $edf9f098b9967043$var$mapStateToProps = (state)=>({
        currentScenarioColor: (0, $75KhQ.getCurrentScenarioColor)(state),
        viewMode: (0, $9H2AP.getViewMode)(state),
        isConfluenceMacro: (0, $akhOi.isConfluenceMacro)(state),
        isEmbed: (0, $akhOi.isEmbed)(state)
    });
var $edf9f098b9967043$export$2e2bcd8739ae039 = $edf9f098b9967043$var$mapStateToProps;

});

parcelRegister("jVrXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b375a03538e632f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gk7tF = parcelRequire("gk7tF");

var $PdmhA = parcelRequire("PdmhA");

var $ghtpV = parcelRequire("ghtpV");
var $7r30L = parcelRequire("7r30L");
var $8aRz2 = parcelRequire("8aRz2");
var $3xO0T = parcelRequire("3xO0T");
var $85rRm = parcelRequire("85rRm");
var $23bph = parcelRequire("23bph");
var $5ACdq = parcelRequire("5ACdq");
var $l50sF = parcelRequire("l50sF");
var $1guBK = parcelRequire("1guBK");
var $52uZH = parcelRequire("52uZH");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lcvrv = parcelRequire("lcvrv");

var $4THGU = parcelRequire("4THGU");

var $gyTbe = parcelRequire("gyTbe");

var $kOT6e = parcelRequire("kOT6e");
const $b375a03538e632f3$var$Legend = ({ currentScenarioColor: currentScenarioColor, viewMode: viewMode, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sprintsMessage = formatMessage((0, $kOT6e.default).sprints);
    const rollupMessage = formatMessage((0, $kOT6e.default).rollup);
    const sprintDatesMessage = formatMessage((0, $kOT6e.default).sprintDates);
    const releaseDatesMessage = formatMessage((0, $kOT6e.default).releaseDates);
    const dateFieldsMessage = formatMessage((0, $kOT6e.default).dateFields);
    const unsavedChangeMessage = formatMessage((0, $kOT6e.default).unsavedChange);
    const noEndDateMessage = formatMessage((0, $kOT6e.default).noEndDate);
    const noStartDateMessage = formatMessage((0, $kOT6e.default).noStartDate);
    const rollupBarMessage = formatMessage((0, $kOT6e.default).rollupBar);
    const releasedMessage = formatMessage((0, $kOT6e.default).released);
    const onTrackMessage = formatMessage((0, $kOT6e.default).onTrack);
    const offTrackMessage = formatMessage((0, $kOT6e.default).offTrack);
    const dependencyMessage = formatMessage((0, $kOT6e.default).dependency);
    const dependencyWarningMessage = formatMessage((0, $kOT6e.default).dependencyWarning);
    const numberOfDependenciesMessage = formatMessage((0, $kOT6e.default).numberOfDependencies);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8aRz2.default), {
        showLabel: isConfluenceMacro || isEmbed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $kOT6e.default).general)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            size: "medium",
            label: sprintsMessage,
            primaryColor: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`
        }),
        label: sprintsMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $52uZH.default), {
            label: rollupMessage
        }),
        label: rollupMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7r30L.SprintDateIcon), null),
        label: sprintDatesMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7r30L.ReleaseDateIcon), null),
        label: releaseDatesMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7r30L.DateFieldIcon), null),
        label: dateFieldsMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ghtpV.default), {
            label: unsavedChangeMessage,
            color: currentScenarioColor
        }),
        label: unsavedChangeMessage
    })), (isConfluenceMacro || isEmbed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gyTbe.default), null), viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isConfluenceMacro || isEmbed) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4THGU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $kOT6e.default).issueBars)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23bph.default), {
            type: "noEndDate"
        }),
        label: noEndDateMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23bph.default), {
            type: "noStartDate"
        }),
        label: noStartDateMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $23bph.default), {
            type: "rollupDates"
        }),
        label: rollupBarMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $kOT6e.default).releases)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "released"
        }),
        label: releasedMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "unreleased"
        }),
        label: onTrackMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1guBK.default), {
            type: "overdue-arj"
        }),
        label: offTrackMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $kOT6e.default).dependencies)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xO0T.default), {
            label: dependencyMessage
        }),
        label: dependencyMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xO0T.default), {
            label: dependencyMessage,
            withWarning: true
        }),
        label: dependencyWarningMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85rRm.default), null),
        label: numberOfDependenciesMessage
    }))));
};
var $b375a03538e632f3$export$2e2bcd8739ae039 = $b375a03538e632f3$var$Legend;

});
parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M17.717 17.137l-1.436-1.438a1.003 1.003 0 011.418-1.418l3.007 3.01a1.002 1.002 0 010 1.417l-3.007 3.01a1.003 1.003 0 01-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 014 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a7.982 7.982 0 01-.789 3.451l-1.438-1.44a6.11 6.11 0 00.345-2.01A6.121 6.121 0 0012 4.884a6.121 6.121 0 00-6.118 6.125 6.119 6.119 0 005.647 6.102l6.188.025zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005.003.013z" fill="currentColor"/></svg>`
    }, props));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = $be245075b7e5aee7$var$SprintIcon;
module.exports.default = $be245075b7e5aee7$var$_default;

});

parcelRegister("ghtpV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5add72e772f9be$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");
const $5f5add72e772f9be$var$getIconContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        points: "10,6  18,6  18,14",
        fill: "currentColor"
    }));
const $5f5add72e772f9be$var$ChangeIndicatorIcon = ({ label: label, color: color = `var(--ds-icon-warning, ${0, $PdmhA.Y400})` })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $5f5add72e772f9be$var$getIconContents,
        size: "medium",
        label: label,
        primaryColor: color
    });
var $5f5add72e772f9be$export$2e2bcd8739ae039 = $5f5add72e772f9be$var$ChangeIndicatorIcon;

});

parcelRegister("7r30L", function(module, exports) {

$parcel$export(module.exports, "DateFieldIcon", () => $62499c88da81931f$export$541e3c9f51736498);
$parcel$export(module.exports, "SprintDateIcon", () => $62499c88da81931f$export$bf7e718e80af79ab);
$parcel$export(module.exports, "ReleaseDateIcon", () => $62499c88da81931f$export$c99073909d241ba9);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $62499c88da81931f$var$LetterIcon = ({ letter: letter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $62499c88da81931f$var$TextStyles,
        as: "span"
    }, letter));
const $62499c88da81931f$export$541e3c9f51736498 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62499c88da81931f$var$LetterIcon, {
        letter: "D"
    });
const $62499c88da81931f$export$bf7e718e80af79ab = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62499c88da81931f$var$LetterIcon, {
        letter: "S"
    });
const $62499c88da81931f$export$c99073909d241ba9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62499c88da81931f$var$LetterIcon, {
        letter: "R"
    });
var $62499c88da81931f$export$2e2bcd8739ae039 = $62499c88da81931f$var$LetterIcon;
const $62499c88da81931f$var$TextStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    lineHeight: "var(--ds-space-200, 16px)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});

});

parcelRegister("8aRz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc67f28979db749$export$2e2bcd8739ae039);

var $ghtpV = parcelRequire("ghtpV");
var $dbh2k = parcelRequire("dbh2k");
var $7r30L = parcelRequire("7r30L");
var $3xO0T = parcelRequire("3xO0T");
var $85rRm = parcelRequire("85rRm");
var $23bph = parcelRequire("23bph");
var $9lR7f = parcelRequire("9lR7f");
var $eZlhy = parcelRequire("eZlhy");
var $5ACdq = parcelRequire("5ACdq");
var $l50sF = parcelRequire("l50sF");
var $1guBK = parcelRequire("1guBK");
var $52uZH = parcelRequire("52uZH");

var $0bc67f28979db749$export$2e2bcd8739ae039 = (0, $eZlhy.default);

});
parcelRegister("dbh2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4972251f681e2e7b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $4972251f681e2e7b$var$ColourByIcon = ({ backgroundColor: backgroundColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4972251f681e2e7b$var$Icon, {
        backgroundColor: backgroundColor
    });
var $4972251f681e2e7b$export$2e2bcd8739ae039 = $4972251f681e2e7b$var$ColourByIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4972251f681e2e7b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _2rkogqwt _bfhk3qkl",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3xO0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $41146912321bd6d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3fJGp = parcelRequire("3fJGp");

var $PdmhA = parcelRequire("PdmhA");
const $41146912321bd6d8$var$DependenciesIcon = ({ label: label, withWarning: withWarning = false })=>withWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41146912321bd6d8$var$Container, {
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
        size: "medium",
        key: "dependencies",
        label: label,
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
        size: "medium",
        key: "dependencies",
        label: label
    });
var $41146912321bd6d8$export$2e2bcd8739ae039 = $41146912321bd6d8$var$DependenciesIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41146912321bd6d8$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _bfhk3qkl _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $25e63580bbd9aab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.654 8.764a.858.858 0 01-1.213-1.213l1.214-1.214a3.717 3.717 0 015.257 0 3.714 3.714 0 01.001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 01-5.263.005.858.858 0 011.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a1.998 1.998 0 00-.001-2.831 2 2 0 00-2.83 0l-1.215 1.213zm-.808 6.472a.858.858 0 011.213 1.213l-1.214 1.214a3.717 3.717 0 01-5.257 0 3.714 3.714 0 01-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 015.263-.005.858.858 0 01-1.214 1.214 2.005 2.005 0 00-2.836.005l-.804.803L7.8 13.618a1.998 1.998 0 00.001 2.831 2 2 0 002.83 0l1.215-1.213z" fill="currentColor"/></svg>`
    }, props));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = $25e63580bbd9aab7$var$EditorLinkIcon;
module.exports.default = $25e63580bbd9aab7$var$_default;

});


parcelRegister("85rRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cfe44b4fded6206$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1cfe44b4fded6206$var$DependenciesIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1cfe44b4fded6206$var$Container, null, "1");
var $1cfe44b4fded6206$export$2e2bcd8739ae039 = $1cfe44b4fded6206$var$DependenciesIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cfe44b4fded6206$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _bfhkl0rj _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("23bph", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1175ce96efe0f52$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $c1175ce96efe0f52$var$getIssueBarContents = (type)=>{
    const color = `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA.N300)})`;
    switch(type){
        case 'noStartDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
                id: "noStartDate",
                gradientUnits: "userSpaceOnUse"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                stopColor: color,
                stopOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: ".75",
                stopColor: color
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#noStartDate)"
            }));
        case 'noEndDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
                id: "noEndDate",
                gradientUnits: "userSpaceOnUse"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: "0.25",
                stopColor: color
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
                offset: "1",
                stopColor: color,
                stopOpacity: "0"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#noEndDate)"
            }));
        case 'rollupDates':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("pattern", {
                id: "rollupDates",
                patternUnits: "userSpaceOnUse",
                width: "12",
                height: "12",
                x: "6",
                y: "0",
                patternTransform: "rotate(27.5)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
                x1: "3",
                y1: "0",
                x2: "3",
                y2: "12",
                opacity: "0.5",
                stroke: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA.N60)})`,
                strokeWidth: "6"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: color
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: "url(#rollupDates)"
            }));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "53",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "53",
                height: "16",
                rx: "3",
                fill: color
            }));
    }
};
const $c1175ce96efe0f52$var$IssueBarIcon = ({ type: type })=>$c1175ce96efe0f52$var$getIssueBarContents(type);
var $c1175ce96efe0f52$export$2e2bcd8739ae039 = $c1175ce96efe0f52$var$IssueBarIcon;

});

parcelRegister("9lR7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ab2ef84631a5546$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $9ab2ef84631a5546$var$IssueTypeIcon = ({ backgroundUrl: backgroundUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9ab2ef84631a5546$var$Icon, {
        backgroundUrl: backgroundUrl
    });
var $9ab2ef84631a5546$export$2e2bcd8739ae039 = $9ab2ef84631a5546$var$IssueTypeIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ab2ef84631a5546$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundUrl: backgroundUrl, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_i1vpsg": (0, $9t7rW.default)(`url('${__cmplp.backgroundUrl}') no-repeat center / cover`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbpxbi _4t3ipxbi _11q7na74",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eZlhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d74b7a197f5296e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $bAQOb = parcelRequire("bAQOb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jOtqo = parcelRequire("jOtqo");

var $cVePX = parcelRequire("cVePX");
const $7d74b7a197f5296e$var$Legend = ({ showLabel: showLabel = false, children: children, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultIsOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const toggleLegend = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'legend closed');
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        setIsOpen
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOtqo.default), {
            isSelected: isOpen,
            onClick: toggleLegend,
            showLabel: showLabel
        })), [
        isOpen,
        showLabel,
        toggleLegend
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVePX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d74b7a197f5296e$var$LegendRoot, null, children)), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        placement: "top-end",
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: true
    });
};
const $7d74b7a197f5296e$var$LegendLegacy = ({ showLabel: showLabel = false, children: children })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const toggleLegend = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `legend ${isOpen ? 'closed' : 'opened'}`);
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'legend closed');
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        setIsOpen
    ]);
    const renderTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOtqo.default), {
            isSelected: isOpen,
            onClick: toggleLegend,
            showLabel: showLabel
        })), [
        isOpen,
        showLabel,
        toggleLegend
    ]);
    const renderContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVePX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d74b7a197f5296e$var$LegendRoot, null, children)), [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        placement: "top-end",
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        shouldUseCaptureOnOutsideClick: true
    });
};
var $7d74b7a197f5296e$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('timeline-legend-token-update_7pgll', $7d74b7a197f5296e$var$Legend, $7d74b7a197f5296e$var$LegendLegacy);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d74b7a197f5296e$var$LegendRoot = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1yt417la _zulpv47k _1ul91178",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOtqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3abbb6d4cbb3880$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $2bv8J = parcelRequire("2bv8J");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bipHM = parcelRequire("bipHM");
const $e3abbb6d4cbb3880$var$LegendButton = ({ onClick: onClick, showLabel: showLabel, ...rest })=>{
    const { isSelected: isSelected } = rest;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClickCallback = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'legendButton');
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $bipHM.default).legend),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: formatMessage((0, $bipHM.default).legend),
            secondaryColor: `var(--ds-surface, ${isSelected ? (0, $PdmhA.N700) : (0, $PdmhA.N0)})`,
            size: "medium"
        }),
        appearance: "subtle",
        onClick: onClickCallback,
        ...rest
    }, showLabel && formatMessage((0, $bipHM.default).legend)));
};
var $e3abbb6d4cbb3880$export$2e2bcd8739ae039 = $e3abbb6d4cbb3880$var$LegendButton;

});
parcelRegister("bipHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fcd8fcd346f1be$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$f3fcd8fcd346f1be$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    legend: {
        "id": "aais-timeline-legend.legend.legend-button.legend",
        "defaultMessage": "Legend"
    }
});

});


parcelRegister("cVePX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7444b73b294f6062$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $7444b73b294f6062$var$DEFAULT_OFFSET = 24;
const $7444b73b294f6062$var$ShrinkToFit = ({ children: children })=>{
    const [bottomOffset, setBottomOffset] = (0, $eUqFw.useState)($7444b73b294f6062$var$DEFAULT_OFFSET);
    const rootRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        /**
     * Wait until animation frame before taking measurement, because popup does not position correctly straight
     * away for *some reason*.
     */ const animationFrame = requestAnimationFrame(()=>{
            if (!rootRef.current) return;
            const rect = rootRef.current.getBoundingClientRect();
            const distanceFromBottom = window.innerHeight - rect.bottom;
            setBottomOffset(distanceFromBottom);
        });
        return ()=>cancelAnimationFrame(animationFrame);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7444b73b294f6062$var$Container, {
        ref: rootRef,
        bottomOffset: bottomOffset,
        topOffset: $7444b73b294f6062$var$DEFAULT_OFFSET
    }, children);
};
var $7444b73b294f6062$export$2e2bcd8739ae039 = $7444b73b294f6062$var$ShrinkToFit;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7444b73b294f6062$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { bottomOffset: bottomOffset, topOffset: topOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1o4tium": (0, $9t7rW.default)(`calc(100vh - ${__cmplp.bottomOffset}px - ${__cmplp.topOffset}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l1oqz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5ACdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab9e08b61d1f0ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1ab9e08b61d1f0ce$var$LegendItem = ({ symbol: symbol, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab9e08b61d1f0ce$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab9e08b61d1f0ce$var$Symbol, null, symbol), label);
var $1ab9e08b61d1f0ce$export$2e2bcd8739ae039 = $1ab9e08b61d1f0ce$var$LegendItem;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ab9e08b61d1f0ce$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1n3s _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $1ab9e08b61d1f0ce$var$Symbol = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1ul91tcg _4t3igktf _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l50sF", function(module, exports) {

$parcel$export(module.exports, "default", () => $43557a5716ebe6b1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $43557a5716ebe6b1$var$LegendSection = ({ title: title, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($43557a5716ebe6b1$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_syaz1gjq _11c816g6 _vwz4v47k"
        ])
    }, title), children);
var $43557a5716ebe6b1$export$2e2bcd8739ae039 = $43557a5716ebe6b1$var$LegendSection;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $43557a5716ebe6b1$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $43557a5716ebe6b1$var$TitleStyles = null;

});

parcelRegister("1guBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8373cd8a94a3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");
const $1c8373cd8a94a3f9$var$getIconColor = (type)=>{
    switch(type){
        case 'released':
            return `var(--ds-icon-success, ${0, $PdmhA.G400})`;
        case 'unreleased':
            return `var(--ds-icon-information, ${0, $PdmhA.B400})`;
        case 'overdue':
        case 'overdue-arj':
        default:
            return `var(--ds-icon-danger, ${0, $PdmhA.R400})`;
    }
};
const $1c8373cd8a94a3f9$var$getIconContents = (type)=>{
    switch(type){
        case 'released':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M11.707 6.707a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
                fill: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
            }));
        case 'overdue':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M7 4a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V4Zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
            }));
        case 'overdue-arj':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "16",
                height: "16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "4",
                y: "7",
                width: "8",
                height: "2",
                rx: "1",
                fill: `var(--ds-text-inverse, ${(0, $PdmhA.N0)})`
            }));
        case 'unreleased':
        default:
            return undefined;
    }
};
const $1c8373cd8a94a3f9$var$ReleaseStatusIcon = ({ type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c8373cd8a94a3f9$var$Container, {
        backgroundColor: $1c8373cd8a94a3f9$var$getIconColor(type)
    }, $1c8373cd8a94a3f9$var$getIconContents(type));
var $1c8373cd8a94a3f9$export$2e2bcd8739ae039 = $1c8373cd8a94a3f9$var$ReleaseStatusIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c8373cd8a94a3f9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz15cr _bfhk3qkl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1osq _vchhusvi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("52uZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e16b5a99cfd9d70$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");
const $2e16b5a99cfd9d70$var$getIconContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m14.586 9-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 11H10a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0v-7a3 3 0 0 1 3-3h4.586Z",
        fill: "currentColor"
    }));
const $2e16b5a99cfd9d70$var$RollupIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $2e16b5a99cfd9d70$var$getIconContents,
        size: "medium",
        label: label,
        primaryColor: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`
    });
var $2e16b5a99cfd9d70$export$2e2bcd8739ae039 = $2e16b5a99cfd9d70$var$RollupIcon;

});


parcelRegister("4THGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b790d720e3a177a4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bsasz = parcelRequire("bsasz");

var $ihz4z = parcelRequire("ihz4z");
var $b790d720e3a177a4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bsasz.default), {})((0, $ihz4z.default));

});
parcelRegister("bsasz", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5ec25e17c2df23$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");

var $hoFKU = parcelRequire("hoFKU");
var $db5ec25e17c2df23$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    colorByValue: (0, $kyGCj.getColorByValue),
    colorByList: (0, $hoFKU.getColorByList),
    customFields: (0, $kKj1m.getCustomFields)
});

});
parcelRegister("hoFKU", function(module, exports) {

$parcel$export(module.exports, "getColorByList", () => $b0e14304b99c2410$export$6e40936c7fd316af);
$parcel$export(module.exports, "getColorByLegends", () => $b0e14304b99c2410$export$5420a01b46b86846);

var $b3iuB = parcelRequire("b3iuB");

var $lvJU2 = parcelRequire("lvJU2");

var $kKj1m = parcelRequire("kKj1m");

var $jp3RH = parcelRequire("jp3RH");

var $44SvN = parcelRequire("44SvN");

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $MQRDu = parcelRequire("MQRDu");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");
const $b0e14304b99c2410$export$7536fdb929ce63f0 = (allTeamsById, colourByValue, colourComponents, colourIssueTypes, colourLabels, colourMaps, colourPriorities, colourSelects, componentsById, customFieldsById, issuePriorities, issueTypesById, projectsById, selectOptionsById, statusCategoryById, teamManagedProjectByIssueTypeId)=>{
    if (colourByValue === (0, $33N5G.colourByOptions).COMPONENT) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return colourComponents.reduce((acc, colourComponent)=>{
        if (colourComponent && (0, $7CnHa.isDefined)(colourComponent.colour) && !$b3iuB.default(colourComponent.colour) && colourComponent.components && !$b3iuB.default(colourComponent.components)) {
            if (!acc[colourComponent.colour]) acc[colourComponent.colour] = [];
            colourComponent.components.forEach((componentId)=>{
                if (componentsById[Number(componentId)]) acc[colourComponent.colour || ''].push(componentsById[Number(componentId)].name);
            });
        }
        return acc;
    }, {});
    if (colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return colourIssueTypes.reduce((acc, colourIssueType)=>{
        if (colourIssueType && (0, $7CnHa.isDefined)(colourIssueType.colour) && !$b3iuB.default(colourIssueType.colour) && colourIssueType.issueTypes && !$b3iuB.default(colourIssueType.issueTypes)) {
            if (!acc[colourIssueType.colour]) acc[colourIssueType.colour] = [];
            colourIssueType.issueTypes.forEach((issueTypeId)=>{
                if (issueTypesById[issueTypeId]?.name) {
                    let issueTypeName = issueTypesById[issueTypeId].name;
                    if (teamManagedProjectByIssueTypeId[String(issueTypeId)]?.key) issueTypeName += ` (${teamManagedProjectByIssueTypeId[String(issueTypeId)].key})`;
                    if ((0, $7CnHa.isDefined)(colourIssueType.colour) && !$b3iuB.default(colourIssueType.colour)) acc[colourIssueType.colour].push(issueTypeName);
                }
            });
        }
        return acc;
    }, {});
    if (colourByValue === (0, $33N5G.colourByOptions).LABEL) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return colourLabels.reduce((acc, colourLabel)=>{
        if (colourLabel && (0, $7CnHa.isDefined)(colourLabel.colour) && !$b3iuB.default(colourLabel.colour) && colourLabel.labels && !$b3iuB.default(colourLabel.labels)) {
            if (!acc[colourLabel.colour]) acc[colourLabel.colour] = [];
            colourLabel.labels.forEach((label)=>{
                acc[colourLabel.colour || ''].push(label);
            });
        }
        return acc;
    }, {});
    if (colourByValue === (0, $33N5G.colourByOptions).PRIORITY) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return colourPriorities.reduce((acc, colourPriority)=>{
        if (colourPriority && (0, $7CnHa.isDefined)(colourPriority.colour) && !$b3iuB.default(colourPriority.colour) && colourPriority.priorities && !$b3iuB.default(colourPriority.priorities)) {
            if (!acc[colourPriority.colour]) acc[colourPriority.colour] = [];
            colourPriority.priorities.forEach((priorityId)=>{
                if (issuePriorities[priorityId]) acc[colourPriority.colour || ''].push(issuePriorities[priorityId].name);
            });
        }
        return acc;
    }, {});
    if (colourByValue === (0, $33N5G.colourByOptions).PROJECT) {
        const projectColorMap = colourMaps.project;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries(projectColorMap).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [projectId, colour])=>{
            if (projectsById[projectId]) {
                const projectColour = String(colour);
                if (!acc[projectColour]) acc[projectColour] = [];
                acc[projectColour].push(projectsById[projectId].name);
            }
            return acc;
        }, {});
    }
    if (colourByValue === (0, $33N5G.colourByOptions).STATUS) {
        const statusColorMap = colourMaps.status;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries(statusColorMap).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [id, colour])=>{
            const statusId = Number(id);
            if (statusCategoryById[statusId]) {
                const statusColour = String(colour);
                if (!acc[statusColour]) acc[statusColour] = [];
                acc[statusColour].push(statusCategoryById[statusId].name);
            }
            return acc;
        }, {});
    }
    if (colourByValue === (0, $33N5G.colourByOptions).TEAM) {
        const teamColorMap = colourMaps.team;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries(teamColorMap).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [teamId, colour])=>{
            // if the team exists
            if (allTeamsById[teamId]) {
                const teamColour = String(colour);
                // adding a colour if the teamColour does not exist
                if (!acc[teamColour]) acc[teamColour] = [];
                // pushing the team title in that color
                acc[teamColour].push(allTeamsById[teamId].title);
            }
            return acc;
        }, {});
    }
    if ((0, $kyGCj.isColorByCustomFieldOption)(colourByValue)) // on initial load, customFieldsById will be an empty object - customFieldsById = {}
    {
        if (!$b3iuB.default(customFieldsById)) {
            // checking that colourByValue is the id of a custom field to prevent any plan crash
            const customFieldType = customFieldsById[colourByValue] && customFieldsById[colourByValue].type && customFieldsById[colourByValue].type.key;
            if ((0, $7CnHa.isDefined)(customFieldType) && (0, $7CnHa.isDefined)(colourSelects[colourByValue])) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return colourSelects[colourByValue].reduce((acc, { colour: colour, options: options })=>{
                if (!(0, $7CnHa.isDefined)(colour)) return acc;
                // if there are options
                if (!$b3iuB.default(options)) {
                    // adding a colour if the colour does not exist
                    if (!acc[colour]) acc[colour] = [];
                    // in case of a custom Label field, "options" is an array of labels e.g. ["label 1", "label 3", "label 2"]
                    if (customFieldType === (0, $5rYNM.CustomFieldTypes).Labels) // getting the name of each option
                    options.forEach((optionLabel)=>{
                        acc[colour].push(optionLabel);
                    });
                    else // for other custom fields (SingleSelect, MultiCheckboxes, MultiSelect, RadioButtons)
                    // "options" is an array of id's e.g. ["10011", "10013"]
                    // so we need to find the name of each option based on its id
                    options.forEach((optionId)=>{
                        if (selectOptionsById[optionId]) acc[colour].push(selectOptionsById[optionId].value);
                    });
                }
                return acc;
            }, {});
        }
    }
    return {};
};
const $b0e14304b99c2410$export$6e40936c7fd316af = (0, $iK4oF.createSelector)([
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $MQRDu.getAllTeamsById),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColorByValue),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourComponents),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourIssueTypes),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourLabels),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourMaps),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourPriorities),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kyGCj.getColourSelects),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $lvJU2.getComponentsById),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kKj1m.getCustomFieldsById),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $jp3RH.getIssuePriorities),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $lihml.getIssueTypesById),
    (0, $ehEr2.getProjectsById),
    (0, $kKj1m.getSelectOptionsById),
    (0, $44SvN.getStatusCategoryById),
    (0, $lihml.getTeamManagedProjectByIssueTypeId)
], $b0e14304b99c2410$export$7536fdb929ce63f0);
const $b0e14304b99c2410$export$289386843eb404e7 = (colorByValue, colorByList)=>{
    if (colorByValue === (0, $33N5G.colourByOptions).NONE || !colorByValue) return [];
    // if no colors were selected (colorByList = {})
    if ($b3iuB.default(colorByList)) return [];
    const colorByLegends = [];
    Object.keys(colorByList).forEach((colorKey)=>{
        colorByLegends.push({
            color: colorKey,
            label: colorByList[colorKey].join(', ')
        });
    });
    return colorByLegends;
};
const $b0e14304b99c2410$export$5420a01b46b86846 = (0, $iK4oF.createSelector)([
    (0, $kyGCj.getColorByValue),
    $b0e14304b99c2410$export$6e40936c7fd316af
], $b0e14304b99c2410$export$289386843eb404e7);

});


parcelRegister("ihz4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e03536afc44bc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dbh2k = parcelRequire("dbh2k");
var $5ACdq = parcelRequire("5ACdq");
var $l50sF = parcelRequire("l50sF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kyGCj = parcelRequire("kyGCj");

var $6oalL = parcelRequire("6oalL");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $1WAFD = parcelRequire("1WAFD");
const $87e03536afc44bc3$var$ColourByLegend = ({ colorByList: colorByList, colorByValue: colorByValue, customFields: customFields })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const colorByValueTitle = (0, $eUqFw.useMemo)(()=>{
        if (colorByValue === (0, $33N5G.colourByOptions).NONE || !colorByValue) return;
        if (Object.keys(colorByList).length === 0) return;
        const optionMessages = {
            ...(0, $6oalL.default),
            allOtherIssues: (0, $ib5d3.default).allOtherIssues,
            issueType: (0, $ib5d3.default).issueType,
            label: (0, $ib5d3.default).label
        };
        if (!(0, $kyGCj.isColorByCustomFieldOption)(colorByValue)) return formatMessage(optionMessages[colorByValue]);
        const customField = customFields.find((field)=>field.id === Number(colorByValue));
        if (customField) return customField.title;
    }, [
        colorByList,
        colorByValue,
        customFields,
        formatMessage
    ]);
    if (!colorByValueTitle) return null;
    const showAllOtherIssuesColorLabel = colorByValue === (0, $33N5G.colourByOptions).COMPONENT || colorByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE || colorByValue === (0, $33N5G.colourByOptions).LABEL || colorByValue === (0, $33N5G.colourByOptions).PRIORITY || (0, $kyGCj.isColorByCustomFieldOption)(colorByValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $1WAFD.default).colorBy, {
            colorByValueTitle: colorByValueTitle
        })
    }, showAllOtherIssuesColorLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
        key: 0,
        symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbh2k.default), {
            backgroundColor: (0, $33N5G.DEFAULT_COLOR)
        }),
        label: formatMessage((0, $ib5d3.default).allOtherIssues)
    }), Object.entries(colorByList).map(([color, labels], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
            key: index,
            symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dbh2k.default), {
                backgroundColor: color
            }),
            label: labels.join(', ')
        })));
};
var $87e03536afc44bc3$export$2e2bcd8739ae039 = $87e03536afc44bc3$var$ColourByLegend;

});
parcelRegister("6oalL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd4b27701744966$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dfd4b27701744966$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorBy: {
        "id": "portfolio-3-portfolio.common.color-by-legend.color-by",
        "defaultMessage": "Color by"
    },
    team: {
        "id": "portfolio-3-portfolio.common.color-by-legend.team",
        "defaultMessage": "Team"
    },
    priority: {
        "id": "portfolio-3-portfolio.common.color-by-legend.priority",
        "defaultMessage": "Priority"
    },
    project: {
        "id": "portfolio-3-portfolio.common.color-by-legend.project",
        "defaultMessage": "Project"
    },
    component: {
        "id": "portfolio-3-portfolio.common.color-by-legend.component",
        "defaultMessage": "Component"
    },
    status: {
        "id": "portfolio-3-portfolio.common.color-by-legend.status",
        "defaultMessage": "Status"
    },
    // this message is there only to make Flow happy, but is actually not rendered in the frontend
    none: {
        "id": "portfolio-3-portfolio.common.color-by-legend.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("1WAFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7550dbae4f9fc895$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7550dbae4f9fc895$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorBy: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.color-by-legend.color-by",
        "defaultMessage": "Color by ({colorByValueTitle})"
    }
});

});



parcelRegister("gyTbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1af798ceb61d908$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ku5oQ = parcelRequire("ku5oQ");

var $z2J8l = parcelRequire("z2J8l");
var $a1af798ceb61d908$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ku5oQ.mapStateToProps), {})((0, $z2J8l.default));

});
parcelRegister("ku5oQ", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $350b1daa9f0075cf$export$c31df4bd766f9c35);

var $fZW8G = parcelRequire("fZW8G");

var $kwMvv = parcelRequire("kwMvv");

var $iK4oF = parcelRequire("iK4oF");
const $350b1daa9f0075cf$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    enrichedHierarchyLevels: (0, $fZW8G.getEnrichedHierarchyLevels),
    filteredIssues: (0, $kwMvv.getFilteredIssues)
});

});

parcelRegister("z2J8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $30347456da65d5c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9lR7f = parcelRequire("9lR7f");
var $5ACdq = parcelRequire("5ACdq");
var $l50sF = parcelRequire("l50sF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aWqrw = parcelRequire("aWqrw");
const $30347456da65d5c1$var$IssueTypesLegend = ({ enrichedHierarchyLevels: enrichedHierarchyLevels, filteredIssues: filteredIssues })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueTypes = (0, $eUqFw.useMemo)(()=>{
        const visibleIssueTypes = new Set(filteredIssues.map((issue)=>issue.type));
        return [
            ...enrichedHierarchyLevels
        ].sort((a, b)=>a.level - b.level).flatMap((level)=>level.issueTypes).filter((issueType)=>visibleIssueTypes.has(issueType.id));
    }, [
        enrichedHierarchyLevels,
        filteredIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l50sF.default), {
        title: formatMessage((0, $aWqrw.default).issueTypes)
    }, issueTypes.map(({ name: name, iconUrl: iconUrl }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ACdq.default), {
            key: index,
            symbol: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lR7f.default), {
                backgroundUrl: iconUrl
            }),
            label: name
        })));
};
var $30347456da65d5c1$export$2e2bcd8739ae039 = $30347456da65d5c1$var$IssueTypesLegend;

});
parcelRegister("aWqrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6514c2db8bd3210f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$6514c2db8bd3210f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypes: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.issue-types-legend.issue-types",
        "defaultMessage": "Issue types"
    }
});

});



parcelRegister("kOT6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $06900a1f9cc40e97$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$06900a1f9cc40e97$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Section Titles
    general: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.general",
        "defaultMessage": "General"
    },
    issueBars: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.issue-bars",
        "defaultMessage": "Issue bars"
    },
    releases: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.releases",
        "defaultMessage": "Releases"
    },
    dependencies: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependencies",
        "defaultMessage": "Dependencies"
    },
    // General
    sprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.sprints",
        "defaultMessage": "Sprints"
    },
    rollup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.rollup",
        "defaultMessage": "Inferred value (roll-up)"
    },
    sprintDates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.sprint-dates",
        "defaultMessage": "Sprint dates"
    },
    releaseDates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.release-dates",
        "defaultMessage": "Release dates"
    },
    dateFields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.date-fields",
        "defaultMessage": "Date fields"
    },
    unsavedChange: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.unsaved-change",
        "defaultMessage": "Unsaved change"
    },
    // Issue bars
    noEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.no-end-date",
        "defaultMessage": "No end date"
    },
    noStartDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.no-start-date",
        "defaultMessage": "No start date"
    },
    rollupBar: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.rollup-bar",
        "defaultMessage": "Inferred dates (roll-up)"
    },
    // Releases
    released: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.released",
        "defaultMessage": "Released"
    },
    onTrack: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.on-track",
        "defaultMessage": "On-track"
    },
    offTrack: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.off-track",
        "defaultMessage": "Off-track"
    },
    // Dependencies
    dependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependency",
        "defaultMessage": "Dependency"
    },
    dependencyWarning: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.dependency-warning",
        "defaultMessage": "Dependency warning"
    },
    numberOfDependencies: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.legend.number-of-dependencies",
        "defaultMessage": "Number of dependencies"
    }
});

});



parcelRegister("2Qk6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("8s4Mr")).default);

var $8s4Mr = parcelRequire("8s4Mr");

});
parcelRegister("8s4Mr", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a3932118c431dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $jODJR = parcelRequire("jODJR");

var $4FKGA = parcelRequire("4FKGA");
function $40a3932118c431dc$export$2e2bcd8739ae039({ direction: direction }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [smooth, { shiftTimeline: shiftTimeline, setSmooth: setSmooth }] = (0, $jODJR.useSmooth)();
    const triggeredRef = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (smooth && triggeredRef.current) {
            setSmooth(false);
            triggeredRef.current = false;
        }
    }, [
        setSmooth,
        smooth
    ]);
    let label = formatMessage((0, $4FKGA.default).shiftTimelineLeft);
    let icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
        label: label
    });
    if (direction === 'right') {
        label = formatMessage((0, $4FKGA.default).shiftTimelineRight);
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        iconBefore: icon,
        onClick: ()=>{
            setSmooth(true);
            shiftTimeline(direction, 'scrollButton');
            triggeredRef.current = true;
        },
        testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.ui.${direction}`
    }));
}

});
parcelRegister("4FKGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f0c33f7af3463c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b9f0c33f7af3463c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shiftTimelineLeft: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-left",
        "defaultMessage": "Shift timeline left"
    },
    shiftTimelineRight: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.panning-control.shift-timeline-right",
        "defaultMessage": "Shift timeline right"
    }
});

});



parcelRegister("6j6dF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e88ddf86b32f5a8$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hCb8j = parcelRequire("hCb8j");

var $4qoo1 = parcelRequire("4qoo1");

var $3zGLY = parcelRequire("3zGLY");
var $9e88ddf86b32f5a8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4qoo1.default), (0, $hCb8j.default))((0, $3zGLY.default));

});
parcelRegister("hCb8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f759ce8ded7d0c$export$2e2bcd8739ae039);
parcelRequire("5VQ0R");
var $5Cso7 = parcelRequire("5Cso7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f7f759ce8ded7d0c$export$2e2bcd8739ae039 = {
    toggleSelectedIssues: $5Cso7.toggleSelectedIssues
};

});
parcelRegister("5VQ0R", function(module, exports) {

$parcel$export(module.exports, "toggleSelectedIssues", () => (parcelRequire("5Cso7")).toggleSelectedIssues);
$parcel$export(module.exports, "TargetTypes", () => (parcelRequire("5Cso7")).TargetTypes);
// eslint-disable-next-line jira/export/no-external-exports
parcelRequire("6owOg");
var $5Cso7 = parcelRequire("5Cso7");

var $5Cso7 = parcelRequire("5Cso7");

});


parcelRegister("4qoo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d256bedc4958fa$export$2e2bcd8739ae039);

var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $iK4oF = parcelRequire("iK4oF");
var $51d256bedc4958fa$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssuesIds: (0, $kwMvv.getSelected),
    issueMapById: (0, $cwP4d.getIssueMapById),
    issuesInFilterById: (state)=>new Set($cQGVO.default($f7Op5.default('id'), (0, $kwMvv.getFilteredIssuesWithHierarchy)(state)))
});

});

parcelRegister("3zGLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f14758dacf5ac0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("5VQ0R");
var $5Cso7 = parcelRequire("5Cso7");

var $jMP2a = parcelRequire("jMP2a");
const $4f14758dacf5ac0c$export$3afcfcc1f8ba5f0e = 'roadmap.scope.all-issues-select.NONE_SELECTED';
const $4f14758dacf5ac0c$export$8a6f405a3e588fc = 'roadmap.scope.all-issues-select.ALL_SELECTED';
const $4f14758dacf5ac0c$export$1743d6cf71d3e2a = 'roadmap.scope.all-issues-select.SOME_SELECTED';
class $4f14758dacf5ac0c$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps) {
        return !nextProps.isDragging;
    }
    render() {
        const { selectedIssuesIds: selectedIssuesIds } = this.props;
        const checkboxState = this.getCheckboxState();
        const isSelected = checkboxState !== $4f14758dacf5ac0c$export$3afcfcc1f8ba5f0e;
        const isIndeterminate = checkboxState === $4f14758dacf5ac0c$export$1743d6cf71d3e2a;
        const nextState = checkboxState !== $4f14758dacf5ac0c$export$8a6f405a3e588fc ? $4f14758dacf5ac0c$export$8a6f405a3e588fc : $4f14758dacf5ac0c$export$3afcfcc1f8ba5f0e;
        return this.props.children({
            totalSelected: selectedIssuesIds.size,
            isIndeterminate: isIndeterminate,
            isSelected: isSelected,
            toggleAllSelected: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? this.toggleAllSelected : (_, analyticsEvent)=>{
                this.toggleAllSelectedOld(nextState === $4f14758dacf5ac0c$export$8a6f405a3e588fc);
                if (nextState === $4f14758dacf5ac0c$export$8a6f405a3e588fc) this.triggerAllSelectedAnalytics(analyticsEvent);
            }
        });
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.toggleAllSelectedOld = (isSelected)=>{
            const { toggleSelectedIssues: toggleSelectedIssues, issuesInFilterById: issuesInFilterById, selectedIssuesIds: selectedIssuesIds } = this.props;
            return toggleSelectedIssues({
                ids: isSelected ? Array.from(issuesInFilterById) : Array.from(selectedIssuesIds),
                isSelected: isSelected,
                toggleAll: true,
                targetType: (0, $5Cso7.TargetTypes).all
            });
        };
        this.toggleAllSelected = (_, analyticsEvent)=>{
            const checkboxState = this.getCheckboxState();
            const nextState = checkboxState !== $4f14758dacf5ac0c$export$8a6f405a3e588fc ? $4f14758dacf5ac0c$export$8a6f405a3e588fc : $4f14758dacf5ac0c$export$3afcfcc1f8ba5f0e;
            const { toggleSelectedIssues: toggleSelectedIssues, issuesInFilterById: issuesInFilterById, selectedIssuesIds: selectedIssuesIds } = this.props;
            const isSelected = nextState === $4f14758dacf5ac0c$export$8a6f405a3e588fc;
            toggleSelectedIssues({
                ids: isSelected ? Array.from(issuesInFilterById) : Array.from(selectedIssuesIds),
                isSelected: isSelected,
                toggleAll: true,
                targetType: (0, $5Cso7.TargetTypes).all
            });
            if (nextState === $4f14758dacf5ac0c$export$8a6f405a3e588fc) this.triggerAllSelectedAnalytics(analyticsEvent);
        };
        this.triggerAllSelectedAnalytics = (analyticsEvent)=>{
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
                selectOption: (0, $5Cso7.TargetTypes).all
            });
        };
        this.getCheckboxState = ()=>{
            const { selectedIssuesIds: selectedIssuesIds, issuesInFilterById: issuesInFilterById } = this.props;
            let selectedIssuesInFilter = 0;
            for (const id of selectedIssuesIds)if (issuesInFilterById.has(id)) selectedIssuesInFilter += 1;
            if (selectedIssuesInFilter === 0) return $4f14758dacf5ac0c$export$3afcfcc1f8ba5f0e;
            if (selectedIssuesInFilter >= issuesInFilterById.size) return $4f14758dacf5ac0c$export$8a6f405a3e588fc;
            return $4f14758dacf5ac0c$export$1743d6cf71d3e2a;
        };
    }
}

});


parcelRegister("f6cUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $46084366f16ae611$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ky8ZS = parcelRequire("ky8ZS");

var $k9nnW = parcelRequire("k9nnW");
var $46084366f16ae611$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ky8ZS.default), {})((0, $k9nnW.default));

});
parcelRegister("ky8ZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26de55a5e308b82$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $6UAvZ = parcelRequire("6UAvZ");

var $fZW8G = parcelRequire("fZW8G");

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var $c26de55a5e308b82$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getHierarchyLevels),
    (0, $6UAvZ.getHierarchyFilter),
    (0, $40hi6.getScope),
    (0, $akhOi.isExportMode),
    (0, $akhOi.getMode)
], (hierarchy, { value: { start: start, end: end } }, { startLevelIssues: { rootIssuesCount: rootIssuesCount } }, exportMode, mode)=>({
        hierarchy: hierarchy,
        start: start,
        end: end,
        rankDigits: rootIssuesCount.toString().length,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isExportMode: exportMode
    }));

});

parcelRegister("k9nnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e8c4742f2d83be8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $8YqJS = parcelRequire("8YqJS");

var $brSAH = parcelRequire("brSAH");

var $cxS9r = parcelRequire("cxS9r");

var $5QmtE = parcelRequire("5QmtE");

var $gJFoe = parcelRequire("gJFoe");

var $8J8wW = parcelRequire("8J8wW");

var $cDjM2 = parcelRequire("cDjM2");
// eslint-disable-next-line jira/react/no-class-components
class $1e8c4742f2d83be8$var$Header extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            BulkActions: $5QmtE.default,
            CollapseMenu: $gJFoe.default,
            AddIssueMenu: $cxS9r.default
        };
    }
    getCurrentHierarchyLevels() {
        const { hierarchy: hierarchy, start: start, end: end } = this.props;
        const endExcludingSubtask = Math.max((0, $8YqJS.STORY_LEVEL), end); // Don't create a subtask without a parent.
        return hierarchy.reduce((acc, { level: level, title: title })=>{
            if (level >= (0, $8YqJS.STORY_LEVEL)) acc.push({
                id: level,
                title: title,
                value: level,
                visible: level <= start && level >= endExcludingSubtask
            });
            return acc;
        }, []);
    }
    render() {
        const { isReadOnly: isReadOnly = false, isExportMode: isExportMode, totalSelected: totalSelected, isIndeterminate: isIndeterminate, isSelected: isSelected, toggleAllSelected: toggleAllSelected, BulkActions: // eslint-disable-next-line @typescript-eslint/no-shadow
        BulkActions, CollapseMenu: // eslint-disable-next-line @typescript-eslint/no-shadow
        CollapseMenu, AddIssueMenu: // eslint-disable-next-line @typescript-eslint/no-shadow
        AddIssueMenu, intl: { formatMessage: formatMessage } } = this.props;
        const currentHierarchyLevels = this.getCurrentHierarchyLevels();
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($cDjM2.spaHeader, {
            [$cDjM2.selected]: isSelected
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.scope-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
            className: $cDjM2["scope-row"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
            className: $cDjM2.left
        }, !isExportMode && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cDjM2.issueHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CollapseMenu, null))), !isReadOnly && !isSelected && currentHierarchyLevels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddIssueMenu, {
            currentHierarchyLevels: currentHierarchyLevels
        })))), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cDjM2.bulkActions
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BulkActions, null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $cDjM2.spaBottomHeader,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.scope-header"
        }, !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            isChecked: isSelected,
            isIndeterminate: isIndeterminate,
            onChange: toggleAllSelected,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.checkbox",
            "aria-label": formatMessage((0, $8J8wW.default).selectAllIssuesCheckboxAriaLabel)
        }), isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                margin: 0
            },
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.issues-selected-count"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8J8wW.default).selectedIssues,
            values: {
                totalSelected: totalSelected
            }
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cDjM2.rankHeader,
            "data-name": "rank-header"
        }, "#"))));
    }
}
var $1e8c4742f2d83be8$export$2e2bcd8739ae039 = (0, $2qhQi.default)($1e8c4742f2d83be8$var$Header);

});
parcelRegister("6ETZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $349143ab589f7178$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $iGfqw = parcelRequire("iGfqw");
var $349143ab589f7178$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        defaultChecked: defaultChecked,
        ref: ref,
        ...rest
    });
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("iGfqw", function(module, exports) {

$parcel$export(module.exports, "CheckboxSkeleton", () => $dde4347b9f84d193$export$8afb3d040818a5bf);

var $eUqFw = parcelRequire("eUqFw");

var $9SKMl = parcelRequire("9SKMl");
class $dde4347b9f84d193$export$8afb3d040818a5bf extends (0, $eUqFw.Component) {
    render() {
        const { inputRef: inputRef, testId: testId, labelledby: labelledby } = this.props;
        /* Use an SVG here to more accurately recreate the checkbox, for example:
		 * border styles do not have the same layout implications as stroke styles, which
		 * could lead to visual issues when swapping between the skeleton and the 'real' checkbox.
		 */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $9SKMl["checkbox-skeleton"],
            ref: inputRef,
            tabIndex: 0,
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            role: "checkbox",
            "aria-checked": "false",
            "data-testid": testId,
            "aria-labelledby": labelledby
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
            x: "1",
            y: "1",
            width: "12",
            height: "12",
            rx: "2"
        }));
    }
}

});
parcelRegister("9SKMl", function(module, exports) {

$parcel$export(module.exports, "checkbox-skeleton", () => $731d717cac11d907$export$3b7f6e665d7acaf2, (v) => $731d717cac11d907$export$3b7f6e665d7acaf2 = v);
var $731d717cac11d907$export$3b7f6e665d7acaf2;
$731d717cac11d907$export$3b7f6e665d7acaf2 = `T8QuXW_checkbox-skeleton`;

});



parcelRegister("cxS9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af01ec7da7e464c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lbau5 = parcelRequire("lbau5");

var $bYhb5 = parcelRequire("bYhb5");

var $cLtkv = parcelRequire("cLtkv");
var $0af01ec7da7e464c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bYhb5.default), (0, $lbau5.default))((0, $cLtkv.default));

});
parcelRegister("lbau5", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a7f3b81d2481e9$export$2e2bcd8739ae039);
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");
var $fk2gn = parcelRequire("fk2gn");
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");

var $boQGP = parcelRequire("boQGP");
const $16a7f3b81d2481e9$var$mapDispatchToProps = (dispatch)=>({
        startInlineCreate: (payload)=>{
            dispatch((0, $fk2gn.startInlineCreate)(payload));
        },
        setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
            dispatch((0, $dr4qD.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
        },
        setGlobalCreateIssue: ()=>{
            dispatch((0, $dr4qD.setGlobalCreateIssue)(true));
        },
        setDefaultProject: (projectId)=>dispatch((0, $boQGP.setDefaultProject)({
                projectId: projectId
            })),
        toggleExpandGroup: (payload)=>dispatch((0, $l1dWb.toggleExpandGroup)(payload))
    });
var $16a7f3b81d2481e9$export$2e2bcd8739ae039 = $16a7f3b81d2481e9$var$mapDispatchToProps;

});

parcelRegister("bYhb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c6b7a8e4283f04$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $fZW8G = parcelRequire("fZW8G");

var $cwMfk = parcelRequire("cwMfk");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $57c6b7a8e4283f04$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getTypeToLevel),
    (0, $ehEr2.getProjects),
    (0, $cwMfk.getInlineCreateState),
    (0, $ehEr2.getDefaultProjectId),
    (0, $fZW8G.getEnrichedHierarchyLevels),
    (0, $40hi6.getScope),
    (0, $kyGCj.getVisualisationGrouping),
    (0, $kKj1m.getCustomFieldsById)
], (typeToLevel, projects, { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy }, defaultProjectId, enrichedHierarchyLevels, { groups: groups }, visualisationGrouping, customFieldsById)=>({
        typeToLevel: typeToLevel,
        projects: projects,
        issueTypeId: issueTypeId,
        IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
        defaultProjectId: defaultProjectId,
        enrichedHierarchyLevels: enrichedHierarchyLevels,
        groups: groups,
        visualisationGrouping: visualisationGrouping,
        customFieldsById: customFieldsById
    }));

});

parcelRegister("cLtkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d53101ae0bcbbd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $i0RGP = parcelRequire("i0RGP");
var $dspDs = parcelRequire("dspDs");
var $h3f0m = parcelRequire("h3f0m");

var $bkIGg = parcelRequire("bkIGg");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $fEubG = parcelRequire("fEubG");
var $eNhh9 = parcelRequire("eNhh9");
var $ltfxy = parcelRequire("ltfxy");
var $gwbfD = parcelRequire("gwbfD");

var $6A3mj = parcelRequire("6A3mj");

var $hIE3U = parcelRequire("hIE3U");

var $cuuJa = parcelRequire("cuuJa");

var $57dZR = parcelRequire("57dZR");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $9RUk7 = parcelRequire("9RUk7");

var $jMP2a = parcelRequire("jMP2a");

var $1eMpI = parcelRequire("1eMpI");

var $g9UDC = parcelRequire("g9UDC");

var $3XuAF = parcelRequire("3XuAF");

var $bw2Zn = parcelRequire("bw2Zn");

var $gQw8M = parcelRequire("gQw8M");
class $9d53101ae0bcbbd9$export$9231831ea16dc281 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDefaultOpen: false,
            NestedMenu: $3XuAF.default,
            MenuItem: $1eMpI.default
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { isMenuOpen: isMenuOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            content: this.renderMenu(),
            isOpen: isMenuOpen,
            placement: "bottom-start",
            onClose: ()=>this.toggleMenu(),
            noPaddings: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: !this.allowGlobalAddIssueForGroups() ? formatMessage((0, $g9UDC.default).addIssueDisabledTooltip) : ''
        }, (0, $gQw8M.isCrossTeamPlanningTemplateExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
            name: (0, $hIE3U.CttSpotlights).CreateIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
            name: (0, $6A3mj.CtpSpotlights).CreateIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                label: ""
            }),
            isSelected: isMenuOpen,
            appearance: "link",
            onClick: ()=>this.toggleMenu(),
            isDisabled: !this.allowGlobalAddIssueForGroups(),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $g9UDC.default).createIssue)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
            name: (0, $hIE3U.CttSpotlights).CreateIssue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                label: ""
            }),
            isSelected: isMenuOpen,
            appearance: "link",
            onClick: ()=>this.toggleMenu(),
            isDisabled: !this.allowGlobalAddIssueForGroups(),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $g9UDC.default).createIssue)))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMenuOpen: this.props.isDefaultOpen
        };
        this.isPlanGroupedBySingleValueCustomField = ()=>{
            const { customFieldsById: customFieldsById, visualisationGrouping: visualisationGrouping = (0, $5rYNM.GROUPING).NONE } = this.props;
            if ((0, $ayXoc.isRoadmapGroupedByCustomField)(visualisationGrouping)) {
                const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(visualisationGrouping), 10);
                const customField = customFieldsById[fieldId];
                if (customField) return (0, $5rYNM.CustomFields).GroupableSingleValueFields.includes(customField.type.key);
                return false;
            }
            return false;
        };
        this.allowGlobalAddIssueForGroups = ()=>this.props.visualisationGrouping !== undefined && (0, $bw2Zn.ISSUE_CREATE_SUPPORTED_GROUPS).includes(this.props.visualisationGrouping) || this.isPlanGroupedBySingleValueCustomField();
        this.getProjectsForCurrentIssueTypeLevel = (level)=>{
            const { projects: projects, enrichedHierarchyLevels: enrichedHierarchyLevels } = this.props;
            const enrichedLevel = $i0RGP.default($h3f0m.default('level', level), enrichedHierarchyLevels);
            const orderedIssueTypes = enrichedLevel ? enrichedLevel.issueTypes : [];
            const currentLevelIssueTypes = orderedIssueTypes.map(({ id: id })=>id);
            return projects.filter((project)=>$dspDs.default(project.issueTypeIds, currentLevelIssueTypes).length > 0);
        };
        this.triggerInlineCreateIssueAnalytics = (analyticsEvent, issueTypeId, visualisationGrouping)=>{
            const { customFieldsById: customFieldsById } = this.props;
            const analyticsKey = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_FROM_HEADER;
            const [actionSubject, eventAction] = analyticsKey.split(' ');
            const grouping = (0, $9RUk7.getGroupForAnalyticEvent)(visualisationGrouping || '', Object.values(customFieldsById));
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), analyticsKey, {
                issueType: issueTypeId,
                grouping: grouping
            });
        };
        this.handleCreateClick = (hierarchyLevel, project, clickedGroup, analyticsEvent)=>{
            const { issueTypeId: currentIssueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy, startInlineCreate: startInlineCreate, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, setGlobalCreateIssue: setGlobalCreateIssue, setDefaultProject: setDefaultProject, toggleExpandGroup: toggleExpandGroup, typeToLevel: typeToLevel, visualisationGrouping: visualisationGrouping } = this.props;
            const issueTypeId = (0, $57dZR.getInlineCreateIssueTypeId)(hierarchyLevel.value, project, {
                issueTypeId: currentIssueTypeId,
                IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
                typeToLevel: typeToLevel
            });
            setIssueTypeIdForHierarchy(hierarchyLevel.value, issueTypeId);
            setGlobalCreateIssue();
            /**
     * If there is only one project in the plan, that project is marked as default project during the initial load.
     * If there are multiple projects in the plan, we present the user with a select box to select the default project while
     * creating an issue using the inline create.
     *
     * But there could be a situation where even though there are multiple projects in the plan but if the user creates an issue
     * in a hierarchy level which is only supported by one project, then we don't present the user with the select box
     * to select the default project so we set the default project manually below.
     */ const projectsForCurrentIssueTypeLevel = this.getProjectsForCurrentIssueTypeLevel(hierarchyLevel.value);
            if (clickedGroup) {
                const { groupCombination: groupCombination, grouping: grouping, group: group, startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup, parentGroup: parentGroup } = clickedGroup;
                const projectId = grouping === (0, $5rYNM.PROJECT) && groupCombination && Number(groupCombination.project) || project.id;
                if (projectsForCurrentIssueTypeLevel.length === 1) setDefaultProject(projectId);
                if (grouping === (0, $5rYNM.RELEASE) && parentGroup === (0, $5rYNM.COMPLETED_RELEASES_GROUP)) toggleExpandGroup({
                    expand: true,
                    groupName: (0, $5rYNM.COMPLETED_RELEASES_GROUP),
                    grouping: grouping
                });
                toggleExpandGroup({
                    expand: true,
                    groupName: group,
                    grouping: grouping
                });
                // triggering analytics
                this.triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId, visualisationGrouping);
                startInlineCreate({
                    parentId: null,
                    siblingId: null,
                    hierarchyLevel: hierarchyLevel.value,
                    issueTypeId: issueTypeId,
                    projectId: projectId,
                    source: 'HEADER',
                    groupCombination: groupCombination,
                    grouping: grouping,
                    group: group,
                    startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup
                });
            } else {
                if (projectsForCurrentIssueTypeLevel.length === 1) setDefaultProject(project.id);
                // triggering analytics
                this.triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId, visualisationGrouping);
                startInlineCreate({
                    parentId: null,
                    siblingId: null,
                    hierarchyLevel: hierarchyLevel.value,
                    issueTypeId: issueTypeId,
                    projectId: project.id,
                    source: 'HEADER'
                });
            }
        };
        this.handleHierarchyItemClick = (item, isDisabled, projectsForLevel, group, analyticsEvent)=>{
            if (!isDisabled) {
                let project = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(projectsForLevel, [
                    'id',
                    this.props.defaultProjectId
                ]) || projectsForLevel[0];
                if ((0, $1ybV0.ff)('jpo-fix-create-tmp-epic-7e1672bc')) {
                    if (group && group.grouping === (0, $5rYNM.PROJECT)) project = projectsForLevel.find((p)=>p.id === group.groupCombination?.project);
                }
                if (!(0, $7CnHa.isDefined)(project)) throw new Error('No project available for this level of hierarchy. It should be disabled in this menu.');
                else {
                    this.handleCreateClick(item, project, group, analyticsEvent);
                    this.toggleMenu(false);
                }
            }
        };
        this.renderMenu = ()=>{
            const { intl: intl, projects: projects, typeToLevel: typeToLevel, currentHierarchyLevels: currentHierarchyLevels, visualisationGrouping: visualisationGrouping, groups: groups, MenuItem: // eslint-disable-next-line @typescript-eslint/no-shadow
            MenuItem, NestedMenu: // eslint-disable-next-line @typescript-eslint/no-shadow
            NestedMenu } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.issue-types"
            }, currentHierarchyLevels.map((item)=>{
                const projectsForLevel = projects.filter((project)=>project.issueTypeIds.some((id)=>typeToLevel(id) === item.value));
                const isDisabled = projectsForLevel.length === 0 || !item.visible;
                let tooltipContent = projectsForLevel.length > 0 ? (0, $g9UDC.default).createIssueHiddenEntryTooltip : (0, $g9UDC.default).createIssueTypeDisabledTooltip;
                if (projectsForLevel.length === 0 && !projects.some((project)=>project.isSimplified === false)) tooltipContent = (0, $g9UDC.default).createIssueTypeDisabledTmpTooltip;
                return visualisationGrouping === (0, $5rYNM.GROUPING).NONE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
                    key: item.id,
                    menuItem: item,
                    isDisabled: isDisabled,
                    tooltip: intl.formatMessage(tooltipContent, {
                        hierarchy: item.title
                    }),
                    onMenuItemClick: (analyticsEvent)=>{
                        this.handleHierarchyItemClick(item, isDisabled, projectsForLevel, undefined, analyticsEvent);
                    }
                }, item.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NestedMenu, {
                    key: item.id,
                    hierarchyItem: item,
                    onGroupClick: (group, analyticsEvent)=>{
                        this.handleHierarchyItemClick(item, isDisabled, projectsForLevel, group, analyticsEvent);
                    },
                    isDisabled: isDisabled,
                    groups: groups,
                    projectsForLevel: projectsForLevel,
                    triggerTooltip: intl.formatMessage(tooltipContent, {
                        hierarchy: item.title
                    })
                });
            }));
        };
        this.toggleMenu = (isOpen)=>{
            if ((0, $7CnHa.isDefined)(isOpen)) this.setState(()=>({
                    isMenuOpen: isOpen
                }));
            else this.setState((prevState)=>({
                    isMenuOpen: !prevState.isMenuOpen
                }));
        };
    }
}
var $9d53101ae0bcbbd9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($9d53101ae0bcbbd9$export$9231831ea16dc281);

});
parcelRegister("6A3mj", function(module, exports) {

$parcel$export(module.exports, "CtpSpotlights", () => $11c4a63f0480e7df$export$79ec23ebaf903d75);
const $11c4a63f0480e7df$export$79ec23ebaf903d75 = {
    Inactive: 'INACTIVE',
    Timeline: 'portfolio-3/ctp-onboarding/timeline',
    CreateIssue: 'portfolio-3/ctp-onboarding/create-issue',
    Teams: 'portfolio-3/ctp-onboarding/teams',
    Boards: 'portfolio-3/ctp-onboarding/boards'
};

});

parcelRegister("9RUk7", function(module, exports) {

$parcel$export(module.exports, "standardFieldsGroupings", () => $fd4260c07856b1f4$export$d25b72cbdc75beae);
$parcel$export(module.exports, "getGroupingCustomFields", () => $fd4260c07856b1f4$export$b0132bc93caced5f);
$parcel$export(module.exports, "getGroupByStandardFieldLabel", () => $fd4260c07856b1f4$export$a9f5afa48954b6e0);
$parcel$export(module.exports, "getGroupByCustomFieldLabel", () => $fd4260c07856b1f4$export$89a8e6a87e875167);
$parcel$export(module.exports, "getGroupForAnalyticEvent", () => $fd4260c07856b1f4$export$5cfef184a69f5b2e);

var $1ybV0 = parcelRequire("1ybV0");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $ayXoc = parcelRequire("ayXoc");
const $fd4260c07856b1f4$var$isGroupableField = (customFieldKey)=>(0, $5rYNM.CustomFields).GroupableSingleValueFields.includes(customFieldKey) || (0, $5rYNM.CustomFields).GroupableMultiValueFields.includes(customFieldKey);
const $fd4260c07856b1f4$export$d25b72cbdc75beae = (isAtlasConnectInstalled)=>({
        [(0, $5rYNM.GROUPING).NONE]: (0, $ib5d3.default).none,
        [(0, $5rYNM.GROUPING).ASSIGNEE]: (0, $ib5d3.default).assignee,
        [(0, $5rYNM.GROUPING).REPORTER]: (0, $ib5d3.default).reporter,
        [(0, $5rYNM.GROUPING).COMPONENT]: (0, $ib5d3.default).component,
        ...isAtlasConnectInstalled && {
            [(0, $5rYNM.GROUPING).GOALS]: (0, $ib5d3.default).goals
        },
        ...(0, $1ybV0.ff)('polaris-arj-ideas') && {
            [(0, $5rYNM.GROUPING).IDEAS]: (0, $ib5d3.default).ideas
        },
        [(0, $5rYNM.GROUPING).LABEL]: (0, $ib5d3.default).label,
        [(0, $5rYNM.GROUPING).PROJECT]: (0, $ib5d3.default).project,
        [(0, $5rYNM.GROUPING).RELEASE]: (0, $ib5d3.default).releases,
        [(0, $5rYNM.GROUPING).SPRINT]: (0, $ib5d3.default).sprint,
        [(0, $5rYNM.GROUPING).TEAM]: (0, $ib5d3.default).team
    });
const $fd4260c07856b1f4$export$b0132bc93caced5f = (customFields)=>customFields.reduce((acc, customField)=>{
        if ($fd4260c07856b1f4$var$isGroupableField(customField.type.key)) acc[`customfield_${customField.id}`] = {
            title: customField.title,
            type: customField.type.key
        };
        return acc;
    }, {});
const $fd4260c07856b1f4$export$a9f5afa48954b6e0 = (grouping)=>$fd4260c07856b1f4$export$d25b72cbdc75beae(true)[grouping];
const $fd4260c07856b1f4$export$89a8e6a87e875167 = (grouping, customFields)=>$fd4260c07856b1f4$export$b0132bc93caced5f(customFields)[grouping]?.title;
const $fd4260c07856b1f4$export$5cfef184a69f5b2e = (grouping, customFields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ((0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) return $fd4260c07856b1f4$export$b0132bc93caced5f(customFields)[grouping]?.type;
    return grouping;
};

});

parcelRegister("1eMpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $040a3c278186e0f2$export$2e2bcd8739ae039);

var $hbCqm = parcelRequire("hbCqm");
var $040a3c278186e0f2$export$2e2bcd8739ae039 = (0, $hbCqm.default);

});
parcelRegister("hbCqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce25ba4cc72c322c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3XRVl = parcelRequire("3XRVl");
var $gwbfD = parcelRequire("gwbfD");

var $lwo9f = parcelRequire("lwo9f");
const $ce25ba4cc72c322c$var$MenuItem = ({ menuItem: menuItem, isDisabled: isDisabled, isSelected: isSelected, tooltip: tooltip, onMenuItemClick: onMenuItemClick, children: children })=>{
    const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        id: menuItem.id,
        onClick: (_, analyticsEvent)=>{
            onMenuItemClick(analyticsEvent);
        },
        key: menuItem.id,
        isDisabled: isDisabled,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lwo9f["menu-item"]} ${isSelected === true ? $lwo9f.selected : ''}`
    }, children);
    return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip || '',
        position: "right"
    }, innerContent) : innerContent;
};
var $ce25ba4cc72c322c$export$2e2bcd8739ae039 = $ce25ba4cc72c322c$var$MenuItem;

});
parcelRegister("lwo9f", function(module, exports) {

$parcel$export(module.exports, "menu-item", () => $faaf516fe62f5cfa$export$9aa3f5850e4e7780, (v) => $faaf516fe62f5cfa$export$9aa3f5850e4e7780 = v);
$parcel$export(module.exports, "selected", () => $faaf516fe62f5cfa$export$d90250155de6d7e7, (v) => $faaf516fe62f5cfa$export$d90250155de6d7e7 = v);
var $faaf516fe62f5cfa$export$9aa3f5850e4e7780;
var $faaf516fe62f5cfa$export$d90250155de6d7e7;
$faaf516fe62f5cfa$export$9aa3f5850e4e7780 = `lZPKBG_menu-item`;
$faaf516fe62f5cfa$export$d90250155de6d7e7 = `lZPKBG_selected`;

});



parcelRegister("g9UDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $148f8ae7acf75f7e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $148f8ae7acf75f7e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createIssue: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue",
        "defaultMessage": "Create issue"
    },
    addIssueDisabledTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.add-issue-disabled-tooltip",
        "defaultMessage": "You can create issues for issue groupings where only single values can be set."
    },
    createIssueTypeDisabledTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-type-disabled-tooltip",
        "defaultMessage": "This hierarchy level isn\u2019t available for the projects used in this plan. Project admins can add issue types at this hierarchy level in the project settings."
    },
    createIssueTypeDisabledTmpTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-type-disabled-tmp-tooltip",
        "defaultMessage": "Add a company-managed project to your plan to use hierarchy levels above epic."
    },
    createIssueHiddenEntryTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.create-issue-hidden-entry-tooltip",
        "defaultMessage": "This level is currently hidden. To create {hierarchy} issues, include this level in the hierarchy range."
    }
});

});

parcelRegister("3XuAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $668a225718c2f5aa$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $NQqTN = parcelRequire("NQqTN");

var $8qFnB = parcelRequire("8qFnB");
var $668a225718c2f5aa$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $NQqTN.default), {})((0, $8qFnB.default));

});
parcelRegister("NQqTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $879acb24e1de9e8e$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $879acb24e1de9e8e$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    customFieldsById: (0, $kKj1m.getCustomFieldsById),
    grouping: (0, $kyGCj.getVisualisationGrouping)
});

});

parcelRegister("8qFnB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb14eab41842417$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eNhh9 = parcelRequire("eNhh9");

var $1eMpI = parcelRequire("1eMpI");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $c1lOU = parcelRequire("c1lOU");

var $b8SyM = parcelRequire("b8SyM");

var $kmjiF = parcelRequire("kmjiF");

var $dAG98 = parcelRequire("dAG98");

var $kQWnm = parcelRequire("kQWnm");

var $7E7Ug = parcelRequire("7E7Ug");

var $kfUwo = parcelRequire("kfUwo");
// eslint-disable-next-line jira/react/no-class-components
class $ffb14eab41842417$var$NestedMenu extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isDefaultOpen: false,
            AssigneeOptions: $c1lOU.default,
            CustomFieldOptions: $b8SyM.default,
            CustomUserPickerOptions: $kmjiF.default,
            MenuItem: $1eMpI.default,
            ProjectOptions: $dAG98.default,
            TeamOptions: $kfUwo.default
        };
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { hierarchyItem: hierarchyItem, isDisabled: isDisabled, triggerTooltip: triggerTooltip, MenuItem: MenuItem } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            key: `${hierarchyItem.id}-nested-dialog`,
            content: this.renderMenuContent(),
            isOpen: this.state.isMenuOpen,
            placement: "right-start",
            onClose: ()=>this.toggleMenu(),
            noPaddings: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
            menuItem: hierarchyItem,
            key: hierarchyItem.id,
            isDisabled: isDisabled,
            tooltip: triggerTooltip,
            isSelected: this.state.isMenuOpen,
            onMenuItemClick: ()=>this.toggleMenu()
        }, hierarchyItem.title));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMenuOpen: this.props.isDefaultOpen
        };
        this.renderMenuContent = ()=>{
            const { AssigneeOptions: // eslint-disable-next-line @typescript-eslint/no-shadow
            AssigneeOptions, CustomFieldOptions: // eslint-disable-next-line @typescript-eslint/no-shadow
            CustomFieldOptions, CustomUserPickerOptions: // eslint-disable-next-line @typescript-eslint/no-shadow
            CustomUserPickerOptions, grouping: grouping, groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, ProjectOptions: // eslint-disable-next-line @typescript-eslint/no-shadow
            ProjectOptions, projectsForLevel: projectsForLevel, TeamOptions: // eslint-disable-next-line @typescript-eslint/no-shadow
            TeamOptions } = this.props;
            switch(grouping){
                case (0, $5rYNM.GROUPING).TEAM:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TeamOptions, {
                        groups: groups,
                        hierarchyItem: hierarchyItem,
                        onGroupClick: onGroupClick
                    });
                case (0, $5rYNM.GROUPING).PROJECT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectOptions, {
                        groups: groups,
                        hierarchyItem: hierarchyItem,
                        onGroupClick: onGroupClick,
                        projectsForLevel: projectsForLevel
                    });
                case (0, $5rYNM.GROUPING).SPRINT:
                    return(// @ts-expect-error - TS2739 - Type '{ groups: Group<ScopeIssue>[]; hierarchyItem: HierarchyItem; onGroupClick: (group: GroupOption) => void; }' is missing the following properties from type 'Readonly<Omit<OwnProps & StateProps, "groups" | "sprints" | "externalSprintsById" | "hierarchyItem" | "onGroupClick" | "sprintsByIdMap" | "SprintDialogContent"> & OwnProps & StateProps>': sprints, externalSprintsById, sprintsByIdMap
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7E7Ug.default), {
                        groups: groups,
                        hierarchyItem: hierarchyItem,
                        onGroupClick: onGroupClick
                    }));
                case (0, $5rYNM.GROUPING).RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQWnm.default), {
                        groups: groups,
                        hierarchyItem: hierarchyItem,
                        onGroupClick: onGroupClick
                    });
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                case (0, $ayXoc.isRoadmapGroupedByCustomField)(grouping) && grouping || '':
                    {
                        const fieldId = parseInt(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
                        if ((0, $7CnHa.isDefined)(this.props.customFieldsById) && (0, $7CnHa.isDefined)(this.props.customFieldsById[fieldId]) && this.props.customFieldsById[fieldId].type.key === (0, $5rYNM.CustomFieldTypes).UserPicker) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomUserPickerOptions, {
                            grouping: grouping,
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFieldOptions, {
                            grouping: grouping,
                            groups: groups,
                            hierarchyItem: hierarchyItem,
                            onGroupClick: onGroupClick
                        });
                    }
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AssigneeOptions, {
                        groups: groups,
                        hierarchyItem: hierarchyItem,
                        onGroupClick: onGroupClick
                    });
            }
        };
        this.toggleMenu = ()=>{
            this.setState((prevState)=>({
                    isMenuOpen: !prevState.isMenuOpen
                }));
        };
    }
}
var $ffb14eab41842417$export$2e2bcd8739ae039 = $ffb14eab41842417$var$NestedMenu;

});
parcelRegister("c1lOU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a34be42221d3284$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgO85 = parcelRequire("lgO85");

var $2aFFm = parcelRequire("2aFFm");

var $ciM4C = parcelRequire("ciM4C");
var $7a34be42221d3284$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2aFFm.default), (0, $lgO85.default))((0, $ciM4C.default));

});
parcelRegister("lgO85", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc32a559c4e136bb$export$2e2bcd8739ae039);

var $63O1Q = parcelRequire("63O1Q");
const $dc32a559c4e136bb$var$mapDispatchToProps = {
    fetchAssigneeList: $63O1Q.fetchAssigneeList
};
var $dc32a559c4e136bb$export$2e2bcd8739ae039 = $dc32a559c4e136bb$var$mapDispatchToProps;

});

parcelRegister("2aFFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f157fbe096f9b40$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");

var $iK4oF = parcelRequire("iK4oF");
var $4f157fbe096f9b40$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    assigneeListFetchStatus: (0, $6VhAf.getAssigneeListFetchStatus),
    assignees: (0, $6VhAf.getAssigneeList)
});

});

parcelRegister("ciM4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $78424f5565b51b4e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $40hi6 = parcelRequire("40hi6");

var $9Wv4l = parcelRequire("9Wv4l");
parcelRequire("e0Kr7");
var $hzcvF = parcelRequire("hzcvF");

var $5rYNM = parcelRequire("5rYNM");

var $gkXIa = parcelRequire("gkXIa");

var $42wbk = parcelRequire("42wbk");
const $78424f5565b51b4e$export$a21d144588fbaf9d = (assignee, groups)=>{
    const getGroupName = (person)=>{
        const jiraUser = person.jiraUser;
        if (jiraUser.title.toLowerCase() === (0, $40hi6.UNASSIGNED_GROUP)) return 0, $40hi6.UNASSIGNED_GROUP;
        return [
            jiraUser.title,
            jiraUser.email
        ].join(' ');
    };
    const startInlineCreateInEmptyGroup = !groups.some(({ groupCombination: groupCombination })=>groupCombination && groupCombination.assignee === assignee.personId);
    const { title: title, email: email, avatarUrl: avatarUrl } = assignee.jiraUser;
    return {
        group: `assignee-${assignee.personId}`,
        groupCombination: {
            assignee: assignee.personId
        },
        groupName: getGroupName(assignee),
        formattedTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkXIa.UserSelectItem), {
            email: email,
            label: title,
            icon: avatarUrl
        }),
        grouping: (0, $5rYNM.GROUPING).ASSIGNEE,
        startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup
    };
};
const $78424f5565b51b4e$export$c2479859c77a8b12 = (assignees, groups)=>assignees.map((person)=>$78424f5565b51b4e$export$a21d144588fbaf9d(person, groups)).sort((0, $40hi6.groupSortComparator));
const $78424f5565b51b4e$var$AssigneeOptions = ({ groups: groups, assignees: assignees, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, assigneeListFetchStatus: assigneeListFetchStatus, fetchAssigneeList: fetchAssigneeList, defaultLoadingState: defaultLoadingState = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // defaultLoadingState uses for story purposes
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(defaultLoadingState);
    (0, $eUqFw.useEffect)(()=>{
        fetchAssigneeList({
            query: ''
        });
    }, [
        fetchAssigneeList
    ]);
    const previousAssigneeListFetchStatus = (0, $hzcvF.usePrevious)(assigneeListFetchStatus);
    (0, $eUqFw.useEffect)(()=>{
        if (previousAssigneeListFetchStatus === true && assigneeListFetchStatus === false) setIsLoading(false);
    }, [
        assigneeListFetchStatus,
        previousAssigneeListFetchStatus
    ]);
    const queryChange = (query)=>{
        setIsLoading(true);
        fetchAssigneeList({
            query: query
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Wv4l.default), {
        groupOptions: $78424f5565b51b4e$export$c2479859c77a8b12(assignees, groups),
        hierarchyItem: hierarchyItem,
        searchPlaceholder: formatMessage((0, $42wbk.default).assigneeSearchPlaceholder),
        onGroupClick: onGroupClick,
        onQueryChange: queryChange,
        isLoading: isLoading
    });
};
var $78424f5565b51b4e$export$2e2bcd8739ae039 = $78424f5565b51b4e$var$AssigneeOptions;

});
parcelRegister("9Wv4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b24c0a87ab0069e8$export$2e2bcd8739ae039);

var $1n2uO = parcelRequire("1n2uO");
var $b24c0a87ab0069e8$export$2e2bcd8739ae039 = (0, $1n2uO.default);

});
parcelRegister("1n2uO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b990e3b20567ff4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $4zIro = parcelRequire("4zIro");
var $fEubG = parcelRequire("fEubG");
var $eYlCJ = parcelRequire("eYlCJ");

var $40hi6 = parcelRequire("40hi6");

var $1eMpI = parcelRequire("1eMpI");

var $7CnHa = parcelRequire("7CnHa");

var $eG0CY = parcelRequire("eG0CY");

var $3a1nD = parcelRequire("3a1nD");

var $7wwPY = parcelRequire("7wwPY");
class $b990e3b20567ff4d$export$b6d9565de1e068cf extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            MenuItem: $1eMpI.default,
            SearchField: $eG0CY.default
        };
    }
    render() {
        const { intl: intl, groupOptions: groupOptions, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, searchPlaceholder: searchPlaceholder, isLoading: isLoading } = this.props;
        const groupsToDisplay = groupOptions.filter(this.filterGroupsWithSearchQuery);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
            placeholder: searchPlaceholder,
            searchQuery: this.state.searchQuery,
            onQueryChange: this.searchOptions
        }), isLoading === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7wwPY.spinner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
            size: "medium"
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7wwPY["inline-dialog-child"]
        }, groupsToDisplay.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            title: intl.formatMessage((0, $3a1nD.default).where)
        }, groupsToDisplay.map((group, i)=>{
            const { groupName: groupName, groupUrl: groupUrl, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey, groupTooltip: groupTooltip } = group;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eMpI.default), {
                menuItem: hierarchyItem,
                key: `${hierarchyItem.id}-${groupKey}-${i}`,
                isDisabled: isDisabled,
                onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent),
                tooltip: isDisabled === true ? groupTooltip : ''
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $7wwPY.option,
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
            }, (0, $7CnHa.isDefined)(groupUrl) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $7wwPY.avatar
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "xsmall",
                src: groupUrl
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $7wwPY.label
            }, formattedTitle || groupName)));
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7wwPY["no-matches"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $3a1nD.default).noMatchFoundText))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            searchQuery: ''
        };
        this.filterGroupsWithSearchQuery = (group)=>{
            const groupName = group.groupName.length ? group.groupName : (0, $40hi6.UNASSIGNED_GROUP);
            return groupName.toLowerCase().includes(this.state.searchQuery.toLowerCase());
        };
        this.searchOptions = (searchQuery)=>{
            const { onQueryChange: onQueryChange } = this.props;
            this.setState(()=>({
                    searchQuery: searchQuery
                }));
            if (onQueryChange) onQueryChange(searchQuery);
        };
    }
}
var $b990e3b20567ff4d$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b990e3b20567ff4d$export$b6d9565de1e068cf);

});
parcelRegister("4zIro", function(module, exports) {

$parcel$export(module.exports, "DialogMenuContainer", () => $835558aa37eb60c0$export$be9c07659ee2411d);
$parcel$export(module.exports, "DialogMenuItem", () => $835558aa37eb60c0$export$e0dd179023805e1);
$parcel$export(module.exports, "DialogMenuGroup", () => $835558aa37eb60c0$export$9e580fe6153e8759);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $1mup9 = parcelRequire("1mup9");
function $835558aa37eb60c0$export$be9c07659ee2411d({ children: children, style: style, className: className }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($1mup9.container, className)
    }, children));
}
function $835558aa37eb60c0$export$e0dd179023805e1({ children: children, style: style, className: className }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: style || {},
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($1mup9.item, className)
    }, children));
}
function $835558aa37eb60c0$export$9e580fe6153e8759({ children: children, heading: heading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, heading && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1mup9["group-heading"],
        style: style || {}
    }, heading), children);
}

});
parcelRegister("1mup9", function(module, exports) {

$parcel$export(module.exports, "container", () => $0fdf6e3b8d1d8092$export$34e0f9847d4c02dd, (v) => $0fdf6e3b8d1d8092$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "group-heading", () => $0fdf6e3b8d1d8092$export$5c3275e478379e7c, (v) => $0fdf6e3b8d1d8092$export$5c3275e478379e7c = v);
$parcel$export(module.exports, "item", () => $0fdf6e3b8d1d8092$export$7061c75fc5af8b7e, (v) => $0fdf6e3b8d1d8092$export$7061c75fc5af8b7e = v);
var $0fdf6e3b8d1d8092$export$34e0f9847d4c02dd;
var $0fdf6e3b8d1d8092$export$5c3275e478379e7c;
var $0fdf6e3b8d1d8092$export$7061c75fc5af8b7e;
$0fdf6e3b8d1d8092$export$34e0f9847d4c02dd = `qqZ2EW_container`;
$0fdf6e3b8d1d8092$export$5c3275e478379e7c = `qqZ2EW_group-heading`;
$0fdf6e3b8d1d8092$export$7061c75fc5af8b7e = `qqZ2EW_item`;

});


parcelRegister("eG0CY", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0171e37f4630b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $5k4ch = parcelRequire("5k4ch");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $g4Vkx = parcelRequire("g4Vkx");
var $4zIro = parcelRequire("4zIro");
var $5CV7v = parcelRequire("5CV7v");

var $bDjSY = parcelRequire("bDjSY");

var $dCbnr = parcelRequire("dCbnr");
// eslint-disable-next-line jira/react/no-class-components
class $eb0171e37f4630b3$var$SearchField extends (0, $eUqFw.Component) {
    render() {
        const { placeholder: placeholder, searchQuery: searchQuery, autoFocus: autoFocus = true, ariaLabel: ariaLabel, intl: intl } = this.props;
        const hasInput = searchQuery.length > 0;
        const styleName = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
            [$dCbnr.hasInput]: hasInput
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
            style: {
                position: 'relative'
            },
            className: styleName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            autoFocus: autoFocus,
            onChange: this.onChange,
            placeholder: placeholder,
            value: searchQuery,
            "aria-label": ariaLabel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dCbnr.clearSearchField,
            style: {
                display: hasInput ? 'block' : 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
            onClick: this.onClear,
            tabIndex: -1,
            ariaLabel: intl.formatMessage((0, $bDjSY.default).clearButtonLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
            label: "",
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N40})`
        })))));
    }
    constructor(...args){
        super(...args);
        this.onChange = (e)=>{
            this.props.onQueryChange(e.target.value);
        };
        this.onClear = ()=>{
            this.props.onQueryChange('');
        };
    }
}
var $eb0171e37f4630b3$export$2e2bcd8739ae039 = (0, $2qhQi.default)($eb0171e37f4630b3$var$SearchField);

});
parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3e02137160dfc264$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M13.477 9.113l-4.36 4.386a1 1 0 101.418 1.41l4.36-4.386a1 1 0 00-1.418-1.41z" fill="inherit"/><path d="M9.084 10.501l4.358 4.377a1 1 0 101.418-1.411L10.5 9.09a1 1 0 00-1.417 1.411z" fill="inherit"/></g></svg>`
    }, props));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = $3e02137160dfc264$var$CrossCircleIcon;
module.exports.default = $3e02137160dfc264$var$_default;

});

parcelRegister("5CV7v", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $6d8f5f00d86a42c2$export$c25acd513dcc8062);

var $eUqFw = parcelRequire("eUqFw");

var $hfKAP = parcelRequire("hfKAP");
const $6d8f5f00d86a42c2$export$f173127635a15d2 = {
    small: 16,
    medium: 24,
    large: 32,
    xlarge: 48
};
const $6d8f5f00d86a42c2$export$c25acd513dcc8062 = ({ children: children, onClick: onClick, ariaLabel: ariaLabel, style: style, tabIndex: tabIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $hfKAP.button,
        "aria-label": ariaLabel,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        tabIndex: tabIndex
    }, children);
$6d8f5f00d86a42c2$export$c25acd513dcc8062.displayName = 'IconButton';

});
parcelRegister("hfKAP", function(module, exports) {

$parcel$export(module.exports, "button", () => $c8f7fac57e6c532b$export$2ba01fb71ed41cb6, (v) => $c8f7fac57e6c532b$export$2ba01fb71ed41cb6 = v);
var $c8f7fac57e6c532b$export$2ba01fb71ed41cb6;
$c8f7fac57e6c532b$export$2ba01fb71ed41cb6 = `WWOkVG_button`;

});


parcelRegister("bDjSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbb665e51db50fb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4fbb665e51db50fb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clearButtonLabel: {
        "id": "portfolio-3-portfolio.common.search-field.clear-button-label",
        "defaultMessage": "clear"
    }
});

});

parcelRegister("dCbnr", function(module, exports) {

$parcel$export(module.exports, "clearSearchField", () => $9e97a63e518dba2d$export$b80a961de74058b, (v) => $9e97a63e518dba2d$export$b80a961de74058b = v);
$parcel$export(module.exports, "hasInput", () => $9e97a63e518dba2d$export$303c88434854a784, (v) => $9e97a63e518dba2d$export$303c88434854a784 = v);
var $9e97a63e518dba2d$export$b80a961de74058b;
var $9e97a63e518dba2d$export$303c88434854a784;
$9e97a63e518dba2d$export$b80a961de74058b = `_1P5dNa_clearSearchField`;
$9e97a63e518dba2d$export$303c88434854a784 = `_1P5dNa_hasInput`;

});


parcelRegister("3a1nD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b57e55f68091b47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7b57e55f68091b47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    where: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.where",
        "defaultMessage": "Where"
    },
    noMatchFoundText: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.no-match-found-text",
        "defaultMessage": "No matches"
    }
});

});

parcelRegister("7wwPY", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $57a4fe57972e9439$export$345c5736c8054f22, (v) => $57a4fe57972e9439$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "inline-dialog-child", () => $57a4fe57972e9439$export$870e10843577b165, (v) => $57a4fe57972e9439$export$870e10843577b165 = v);
$parcel$export(module.exports, "label", () => $57a4fe57972e9439$export$1237798dc640739a, (v) => $57a4fe57972e9439$export$1237798dc640739a = v);
$parcel$export(module.exports, "no-matches", () => $57a4fe57972e9439$export$9c6a6c8c8d3c5bfb, (v) => $57a4fe57972e9439$export$9c6a6c8c8d3c5bfb = v);
$parcel$export(module.exports, "option", () => $57a4fe57972e9439$export$a75d1723e6bda2ec, (v) => $57a4fe57972e9439$export$a75d1723e6bda2ec = v);
$parcel$export(module.exports, "spinner", () => $57a4fe57972e9439$export$641374ffb95bc399, (v) => $57a4fe57972e9439$export$641374ffb95bc399 = v);
var $57a4fe57972e9439$export$345c5736c8054f22;
var $57a4fe57972e9439$export$870e10843577b165;
var $57a4fe57972e9439$export$1237798dc640739a;
var $57a4fe57972e9439$export$9c6a6c8c8d3c5bfb;
var $57a4fe57972e9439$export$a75d1723e6bda2ec;
var $57a4fe57972e9439$export$641374ffb95bc399;
$57a4fe57972e9439$export$345c5736c8054f22 = `SOS43G_avatar`;
$57a4fe57972e9439$export$870e10843577b165 = `SOS43G_inline-dialog-child`;
$57a4fe57972e9439$export$1237798dc640739a = `SOS43G_label`;
$57a4fe57972e9439$export$9c6a6c8c8d3c5bfb = `SOS43G_no-matches`;
$57a4fe57972e9439$export$a75d1723e6bda2ec = `SOS43G_option`;
$57a4fe57972e9439$export$641374ffb95bc399 = `SOS43G_spinner`;

});



parcelRegister("e0Kr7", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => (parcelRequire("hzcvF")).usePrevious);
// eslint-disable-next-line jira/export/no-external-exports

var $hzcvF = parcelRequire("hzcvF");

});

parcelRegister("42wbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $664cadc86d970773$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $664cadc86d970773$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assigneeSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.assignee-options.assignee-search-placeholder",
        "defaultMessage": "Find assignees..."
    }
});

});



parcelRegister("b8SyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db25f215795b8ad$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bMr9a = parcelRequire("bMr9a");

var $4gezC = parcelRequire("4gezC");
var $5db25f215795b8ad$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bMr9a.default), {})((0, $4gezC.default));

});
parcelRegister("bMr9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a4c939e296b309$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
var $b0a4c939e296b309$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectOptions: (0, $kKj1m.getSelectOptions)
});

});

parcelRegister("4gezC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0bc2fe700a7f26b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $40hi6 = parcelRequire("40hi6");

var $9Wv4l = parcelRequire("9Wv4l");

var $ayXoc = parcelRequire("ayXoc");

var $ib5d3 = parcelRequire("ib5d3");

var $YtqbQ = parcelRequire("YtqbQ");

var $bQDbE = parcelRequire("bQDbE");
function $f0bc2fe700a7f26b$export$2e2bcd8739ae039({ grouping: grouping, groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, selectOptions: selectOptions }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const customFieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
    const groupOptions = (0, $bQDbE.getGroupOptionsFromCustomField)(grouping, groups, selectOptions, customFieldId);
    const unassigned = {
        group: (0, $40hi6.UNDEFINED_GROUP),
        groupCombination: {
            [grouping]: null
        },
        grouping: grouping,
        groupName: formatMessage((0, $ib5d3.default).unassigned),
        isExpanded: true,
        startInlineCreateInEmptyGroup: !groups.some((group)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            group.groupCombination?.[grouping] === null)
    };
    const groupOptionsWithUnassigned = [
        ...groupOptions,
        unassigned
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Wv4l.default), {
        groupOptions: groupOptionsWithUnassigned,
        hierarchyItem: hierarchyItem,
        onGroupClick: onGroupClick,
        searchPlaceholder: formatMessage((0, $YtqbQ.default).customFieldSearchPlaceholder)
    });
}

});
parcelRegister("YtqbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b8fe2e507ec5df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $47b8fe2e507ec5df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    customFieldSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.custom-field-options.custom-field-search-placeholder",
        "defaultMessage": "Find options..."
    }
});

});

parcelRegister("bQDbE", function(module, exports) {

$parcel$export(module.exports, "getGroupOptionsFromCustomField", () => $d1241ccfecaf9596$export$80f35aa6e83126f4);

var $40hi6 = parcelRequire("40hi6");
const $d1241ccfecaf9596$var$createGroupOptionFromCustomField = (grouping, groups, selectOption)=>({
        group: `${grouping}-${selectOption.id}`,
        groupCombination: {
            [grouping]: selectOption.id
        },
        grouping: grouping,
        groupName: selectOption.value,
        startInlineCreateInEmptyGroup: !groups.some((group)=>group.groupCombination && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            group.groupCombination[grouping] === selectOption.id)
    });
const $d1241ccfecaf9596$export$80f35aa6e83126f4 = (grouping, groups, selectOptions, customFieldId)=>{
    const filteredOptions = selectOptions.filter((selectOption)=>selectOption.fieldId === customFieldId).map((option)=>({
            ...option,
            id: String(option.id)
        }));
    const groupOptions = filteredOptions.map((option)=>$d1241ccfecaf9596$var$createGroupOptionFromCustomField(grouping, groups, option));
    return [
        ...groupOptions.values()
    ].sort((0, $40hi6.groupSortComparator));
};

});



parcelRegister("kmjiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec97b8a4ff70cc8c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $rT1BL = parcelRequire("rT1BL");

var $5YfYP = parcelRequire("5YfYP");

var $hi3TP = parcelRequire("hi3TP");
var $ec97b8a4ff70cc8c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5YfYP.default), (0, $rT1BL.default))((0, $hi3TP.default));

});
parcelRegister("rT1BL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6736ec4a1e0044$export$2e2bcd8739ae039);

var $kKZNQ = parcelRequire("kKZNQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fe6736ec4a1e0044$var$mapDispatchToProps = (dispatch)=>({
        fetchUserList: (query)=>{
            dispatch((0, $kKZNQ.fetchUserPickerOptions)(query || '', ''));
        }
    });
var $fe6736ec4a1e0044$export$2e2bcd8739ae039 = $fe6736ec4a1e0044$var$mapDispatchToProps;

});

parcelRegister("5YfYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $357bef1b4c22717e$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
var $357bef1b4c22717e$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    userList: (0, $kKj1m.getUserPickerOptionsUserList),
    userPickerUIState: (0, $kKj1m.getUserPickerUIState)
});

});

parcelRegister("hi3TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $568da73e6ceee6ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9Wv4l = parcelRequire("9Wv4l");
parcelRequire("e0Kr7");
var $hzcvF = parcelRequire("hzcvF");

var $hGKeq = parcelRequire("hGKeq");

var $gp9ro = parcelRequire("gp9ro");
function $568da73e6ceee6ea$export$2e2bcd8739ae039({ fetchUserList: fetchUserList, groups: groups, grouping: grouping, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, userList: userList, userPickerUIState: userPickerUIState }) {
    const { issueId: issueId, isFetchUserListInProgress: isFetchUserListInProgress } = userPickerUIState;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(isFetchUserListInProgress);
    (0, $eUqFw.useEffect)(()=>{
        fetchUserList('', issueId);
    }, [
        fetchUserList,
        issueId
    ]);
    const previousFetchUserListInProgress = (0, $hzcvF.usePrevious)(isFetchUserListInProgress);
    (0, $eUqFw.useEffect)(()=>{
        if (previousFetchUserListInProgress === true && isFetchUserListInProgress === false) setIsLoading(false);
    }, [
        isFetchUserListInProgress,
        previousFetchUserListInProgress
    ]);
    const queryChange = (query)=>{
        setIsLoading(true);
        fetchUserList(query, issueId);
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Wv4l.default), {
        groupOptions: (0, $gp9ro.getGroupOptionsFromUsers)(grouping, groups, userList),
        hierarchyItem: hierarchyItem,
        isLoading: isLoading,
        onGroupClick: onGroupClick,
        onQueryChange: queryChange,
        searchPlaceholder: formatMessage((0, $hGKeq.default).userSearchPlaceholder)
    });
}

});
parcelRegister("hGKeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5c6601822e35c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cc5c6601822e35c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    userSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.custom-user-picker-options.user-search-placeholder",
        "defaultMessage": "Find users..."
    }
});

});

parcelRegister("gp9ro", function(module, exports) {

$parcel$export(module.exports, "getGroupOptionsFromUsers", () => $8ca8d1ed2e883f39$export$42081cca51fee3c);

var $eUqFw = parcelRequire("eUqFw");

var $701od = parcelRequire("701od");

var $40hi6 = parcelRequire("40hi6");

var $gkXIa = parcelRequire("gkXIa");
const $8ca8d1ed2e883f39$var$createGroupOptionFromUser = (grouping, groups, user)=>{
    const { email: email, icon: icon, label: label, value: value } = user;
    const isUnassigned = $701od.default(label) === (0, $40hi6.UNASSIGNED_GROUP);
    return {
        formattedTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkXIa.UserSelectItem), {
            email: email,
            label: label,
            icon: icon
        }),
        group: `${grouping}-${value}`,
        groupCombination: {
            [grouping]: value
        },
        grouping: grouping,
        groupName: isUnassigned ? (0, $40hi6.UNASSIGNED_GROUP) : [
            label,
            email
        ].join(' '),
        startInlineCreateInEmptyGroup: !groups.some((group)=>group.groupCombination && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            group.groupCombination[grouping] === value)
    };
};
const $8ca8d1ed2e883f39$export$42081cca51fee3c = (grouping, groups, userList)=>userList.map((user)=>$8ca8d1ed2e883f39$var$createGroupOptionFromUser(grouping, groups, user)).sort((0, $40hi6.groupSortComparator));
const $8ca8d1ed2e883f39$export$e2882820f72b6fb0 = ({ jiraUser: { email: email, title: title, avatarUrl: avatarUrl, accountId: accountId } })=>({
        email: email,
        value: accountId,
        label: title,
        icon: avatarUrl
    });

});



parcelRegister("dAG98", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d58078f953a8f7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gy7yO = parcelRequire("gy7yO");

var $1b1Uv = parcelRequire("1b1Uv");
var $96d58078f953a8f7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gy7yO.default), {})((0, $1b1Uv.default));

});
parcelRegister("gy7yO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f0bf561f965c80$export$2e2bcd8739ae039);

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $b1f0bf561f965c80$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    projects: (0, $ehEr2.getProjects)
});

});

parcelRegister("1b1Uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c68eebcb8aee6e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $40hi6 = parcelRequire("40hi6");

var $9Wv4l = parcelRequire("9Wv4l");

var $5rYNM = parcelRequire("5rYNM");

var $gDsN6 = parcelRequire("gDsN6");
class $2c68eebcb8aee6e7$export$10d585c345dfa553 extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Wv4l.default), {
            groupOptions: this.getGroupOptionsFromProjects(),
            hierarchyItem: hierarchyItem,
            searchPlaceholder: intl.formatMessage((0, $gDsN6.default).projectSearchPlaceholder),
            onGroupClick: onGroupClick
        });
    }
    constructor(...args){
        super(...args);
        this.isProjectDisabled = (projecId)=>this.props.projectsForLevel.every(({ id: id })=>id !== projecId);
        this.createGroupOptionFromProjects = (project)=>{
            const { groups: groups, intl: intl } = this.props;
            const startInlineCreateInEmptyGroup = !groups.some(({ groupCombination: groupCombination })=>groupCombination && groupCombination.project === project.id);
            return {
                group: `project-${project.id}`,
                groupCombination: {
                    project: project.id
                },
                groupName: project.name,
                groupUrl: project.avatarUrl || '',
                grouping: (0, $5rYNM.GROUPING).PROJECT,
                startInlineCreateInEmptyGroup: startInlineCreateInEmptyGroup,
                isDisabled: this.isProjectDisabled(project.id),
                groupTooltip: project.isSimplified ? intl.formatMessage((0, $gDsN6.default).projectTooltipTmp) : intl.formatMessage((0, $gDsN6.default).projectTooltip)
            };
        };
        this.getGroupOptionsFromProjects = ()=>{
            const { projects: projects } = this.props;
            return projects.map(this.createGroupOptionFromProjects).sort((0, $40hi6.groupSortComparator));
        };
    }
}
var $2c68eebcb8aee6e7$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2c68eebcb8aee6e7$export$10d585c345dfa553);

});
parcelRegister("gDsN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aab6b3e3606c3ed$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1aab6b3e3606c3ed$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-tooltip",
        "defaultMessage": "This issue type doesn\u2019t exist in this project. Ask your project admin to create this issue type for the project."
    },
    projectTooltipTmp: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-tooltip-tmp",
        "defaultMessage": "This hierarchy level can\u2019t be created in a team-managed project."
    },
    projectSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.project-options.project-search-placeholder",
        "defaultMessage": "Find projects..."
    }
});

});



parcelRegister("kQWnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77762272b92766f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jQPAH = parcelRequire("jQPAH");

var $i5OGd = parcelRequire("i5OGd");
var $a77762272b92766f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jQPAH.default), {})((0, $i5OGd.default));

});
parcelRegister("jQPAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2a4f373ef6221c$export$2e2bcd8739ae039);

var $wcCGG = parcelRequire("wcCGG");

var $iK4oF = parcelRequire("iK4oF");
var $9c2a4f373ef6221c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    enrichedVersions: (0, $wcCGG.getEnrichedVersions),
    enrichedVersionsById: (0, $wcCGG.getEnrichedVersionsById),
    completeVersionsById: (0, $wcCGG.getCompletedVersionsById)
});

});

parcelRegister("i5OGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea367eb1440baef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $40hi6 = parcelRequire("40hi6");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $bwizI = parcelRequire("bwizI");

var $9U8MO = parcelRequire("9U8MO");
function $fea367eb1440baef$export$2e2bcd8739ae039({ groups: groups, hierarchyItem: hierarchyItem, onGroupClick: onGroupClick, enrichedVersions: enrichedVersions, enrichedVersionsById: enrichedVersionsById, completeVersionsById: completeVersionsById, ReleaseDialogContent: ReleaseDialogContent = (0, $bwizI.default) }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const groupOptionsFromReleasesByProject = (0, $9U8MO.getGroupOptionsFromReleasesByProject)({
        groups: groups,
        enrichedVersions: enrichedVersions,
        enrichedVersionsById: enrichedVersionsById,
        completeVersionsById: completeVersionsById
    });
    const unassigned = {
        groupName: formatMessage((0, $ib5d3.default).unassigned),
        grouping: (0, $5rYNM.GROUPING).RELEASE,
        isExpanded: true,
        group: (0, $40hi6.UNDEFINED_GROUP),
        groupCombination: {
            release: null
        },
        startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $40hi6.UNDEFINED_GROUP))
    };
    const groupOptionsWithUnassigned = [
        ...groupOptionsFromReleasesByProject,
        [
            null,
            [
                unassigned
            ]
        ]
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseDialogContent, {
        groupOptions: groupOptionsWithUnassigned,
        hierarchyItem: hierarchyItem,
        onGroupClick: onGroupClick
    });
}

});
parcelRegister("bwizI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2500d20efe1e44$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4HiUm = parcelRequire("4HiUm");

var $5j6J6 = parcelRequire("5j6J6");
var $aa2500d20efe1e44$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4HiUm.default), {})((0, $5j6J6.default));

});
parcelRegister("4HiUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1db68b95bea458c$export$2e2bcd8739ae039);

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $d1db68b95bea458c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    projectsById: (0, $ehEr2.getProjectsById)
});

});

parcelRegister("5j6J6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b023fc5eafcfa71b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4zIro = parcelRequire("4zIro");
var $fEubG = parcelRequire("fEubG");

var $40hi6 = parcelRequire("40hi6");

var $1eMpI = parcelRequire("1eMpI");

var $ib5d3 = parcelRequire("ib5d3");

var $eG0CY = parcelRequire("eG0CY");

var $epFEP = parcelRequire("epFEP");

var $PZVUP = parcelRequire("PZVUP");

var $hq4YV = parcelRequire("hq4YV");
function $b023fc5eafcfa71b$export$2e2bcd8739ae039({ groupOptions: groupOptions, onGroupClick: onGroupClick, onQueryChange: onQueryChange, hierarchyItem: hierarchyItem, projectsById: projectsById }) {
    const [searchQuery, setSearchQuery] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterGroupsWithSearchQuery = (group)=>{
        const groupName = group.groupName.length ? group.groupName : (0, $40hi6.UNASSIGNED_GROUP);
        return groupName.toLowerCase().includes(searchQuery.toLowerCase());
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const searchOptions = (searchQuery)=>{
        setSearchQuery(searchQuery);
        if (onQueryChange) onQueryChange(searchQuery);
    };
    // Sort by project id, with null at the top so unassigned is always first
    const groupOptionsEntries = groupOptions.sort((0, $hq4YV.projectToGroupMapComparator));
    const renderGroupOptions = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        const groupOptions = groupOptionsEntries.map(([projectId, groups])=>{
            const groupsToDisplay = groups.filter(filterGroupsWithSearchQuery).sort((0, $40hi6.groupSortComparator));
            if (groupsToDisplay.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
                key: projectId,
                title: projectId !== null ? projectsById[projectId.toString()].name : formatMessage((0, $ib5d3.default).unassigned)
            }, groupsToDisplay.map((group, i)=>{
                const { groupName: groupName, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey } = group;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eMpI.default), {
                    menuItem: hierarchyItem,
                    key: `${hierarchyItem.id}-${groupKey}-${i}`,
                    isDisabled: isDisabled,
                    onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
                }, formattedTitle || groupName));
            }));
            return null;
        });
        if (groupOptions.every((el)=>el === null)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $PZVUP["no-matches"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).noMatchFoundText)));
        return groupOptions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
        placeholder: formatMessage((0, $epFEP.default).releaseSearchPlaceholder),
        searchQuery: searchQuery,
        onQueryChange: searchOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $PZVUP["inline-dialog-child"]
    }, renderGroupOptions()));
}

});
parcelRegister("epFEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $220d4bbbb0e2e120$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $220d4bbbb0e2e120$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releaseSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.release-options.release-dialog-content.release-search-placeholder",
        "defaultMessage": "Find releases..."
    }
});

});

parcelRegister("PZVUP", function(module, exports) {

$parcel$export(module.exports, "inline-dialog-child", () => $09c4ce29b448712b$export$870e10843577b165, (v) => $09c4ce29b448712b$export$870e10843577b165 = v);
$parcel$export(module.exports, "no-matches", () => $09c4ce29b448712b$export$9c6a6c8c8d3c5bfb, (v) => $09c4ce29b448712b$export$9c6a6c8c8d3c5bfb = v);
var $09c4ce29b448712b$export$870e10843577b165;
var $09c4ce29b448712b$export$9c6a6c8c8d3c5bfb;
$09c4ce29b448712b$export$870e10843577b165 = `pqcCAG_inline-dialog-child`;
$09c4ce29b448712b$export$9c6a6c8c8d3c5bfb = `pqcCAG_no-matches`;

});

parcelRegister("hq4YV", function(module, exports) {

$parcel$export(module.exports, "projectToGroupMapComparator", () => $23b61f08e88c39b5$export$82790021fe06eb0b);
const $23b61f08e88c39b5$export$82790021fe06eb0b = (a, b)=>{
    // Separated cases to handle null case for flow
    // null case should be rendered at the top
    if (a[0] === null) return -1;
    if (b[0] === null) return 1;
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
};

});



parcelRegister("9U8MO", function(module, exports) {

$parcel$export(module.exports, "getGroupOptionsFromReleasesByProject", () => $f1a442fd9fbea757$export$1bc27696314dd171);

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $f1a442fd9fbea757$export$1bc27696314dd171 = ({ groups: groups, enrichedVersionsById: enrichedVersionsById, enrichedVersions: enrichedVersions, completeVersionsById: completeVersionsById })=>{
    const createGroupOptionFromRelease = (release)=>({
            group: `release-${release.id}`,
            groupCombination: {
                release: release.id
            },
            groupName: release.name,
            grouping: (0, $5rYNM.GROUPING).RELEASE,
            startInlineCreateInEmptyGroup: true,
            parentGroup: (0, $7CnHa.isDefined)(completeVersionsById[release.id]) ? (0, $5rYNM.COMPLETED_RELEASES_GROUP) : undefined
        });
    const projectToGroupOptionsMap = new Map();
    // We use a set to keep track of which releases we have already handled, because
    // we are handling a map of projectId to Option, neither of which are easy to filter through
    const processedReleaseIds = new Set();
    for (const group of groups){
        const { scope: scope, ...groupOption } = group;
        if ((0, $7CnHa.isDefined)(groupOption.groupCombination) && (0, $7CnHa.isDefined)(groupOption.groupCombination.release)) {
            const enrichedVersion = enrichedVersionsById[groupOption.groupCombination.release];
            processedReleaseIds.add(groupOption.groupCombination.release);
            if (enrichedVersion !== undefined) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const projectId = enrichedVersion.projects[0].id;
                const [, releasesArray] = projectToGroupOptionsMap.get(projectId) ?? [
                    undefined,
                    []
                ];
                projectToGroupOptionsMap.set(projectId, [
                    projectId,
                    [
                        ...releasesArray,
                        groupOption
                    ]
                ]);
            }
        }
    }
    // Create option for releases that aren't currently assigned to any issues
    // Which therefore currently do not have a group.
    for (const release of enrichedVersions)if (!processedReleaseIds.has(release.id)) {
        const option = createGroupOptionFromRelease(release);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const projectId = release.projects[0].id;
        const [, releasesArray] = projectToGroupOptionsMap.get(projectId) ?? [
            undefined,
            []
        ];
        projectToGroupOptionsMap.set(projectId, [
            projectId,
            [
                ...releasesArray,
                option
            ]
        ]);
    }
    return [
        ...projectToGroupOptionsMap.values()
    ];
};

});



parcelRegister("7E7Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $046b933247a56a7d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2ETzu = parcelRequire("2ETzu");

var $caKGS = parcelRequire("caKGS");
var $046b933247a56a7d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2ETzu.default), {})((0, $caKGS.default));

});
parcelRegister("2ETzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ee6fcd8967c033a$export$2e2bcd8739ae039);

var $c1XMU = parcelRequire("c1XMU");

var $iK4oF = parcelRequire("iK4oF");
var $2ee6fcd8967c033a$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    sprints: (0, $c1XMU.getAllSprints),
    sprintsByIdMap: (0, $c1XMU.getAllSprintsByIdMap),
    externalSprintsById: (0, $c1XMU.getExternalSprintsById)
});

});

parcelRegister("caKGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bbc7369681e5a21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $40hi6 = parcelRequire("40hi6");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $3dZ6f = parcelRequire("3dZ6f");

var $4Pc0U = parcelRequire("4Pc0U");
function $6bbc7369681e5a21$export$2e2bcd8739ae039({ onGroupClick: onGroupClick, hierarchyItem: hierarchyItem, groups: groups, sprints: sprints, sprintsByIdMap: sprintsByIdMap, externalSprintsById: externalSprintsById, SprintDialogContent: SprintDialogContent = (0, $3dZ6f.default) }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const unassigned = {
        groupName: formatMessage((0, $ib5d3.default).unassigned),
        grouping: (0, $5rYNM.GROUPING).SPRINT,
        isExpanded: true,
        group: (0, $40hi6.UNDEFINED_GROUP),
        groupCombination: {
            sprint: null
        },
        startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $40hi6.UNDEFINED_GROUP))
    };
    const groupOptions = (0, $4Pc0U.getGroupOptionsFromSprints)({
        groups: groups,
        sprints: sprints,
        sprintsByIdMap: sprintsByIdMap,
        externalSprintsById: externalSprintsById
    });
    const groupOptionsWithUnassigned = [
        ...groupOptions,
        [
            null,
            [
                unassigned
            ]
        ]
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SprintDialogContent, {
        groupOptions: groupOptionsWithUnassigned,
        hierarchyItem: hierarchyItem,
        onGroupClick: onGroupClick
    });
}

});
parcelRegister("3dZ6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c4e439512db7dc$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cm9sB = parcelRequire("cm9sB");

var $4PYXp = parcelRequire("4PYXp");
var $e9c4e439512db7dc$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $cm9sB.default), {})((0, $4PYXp.default));

});
parcelRegister("cm9sB", function(module, exports) {

$parcel$export(module.exports, "default", () => $801fbe576811276e$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $801fbe576811276e$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issueSourcesById: (0, $75KhQ.getIssueSourcesById)
});

});

parcelRegister("4PYXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fe486f5ad2037e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4zIro = parcelRequire("4zIro");
var $fEubG = parcelRequire("fEubG");

var $40hi6 = parcelRequire("40hi6");

var $1eMpI = parcelRequire("1eMpI");

var $ib5d3 = parcelRequire("ib5d3");

var $eG0CY = parcelRequire("eG0CY");

var $leCWn = parcelRequire("leCWn");

var $gwxWo = parcelRequire("gwxWo");

var $k5IfQ = parcelRequire("k5IfQ");
function $e0fe486f5ad2037e$export$2e2bcd8739ae039({ issueSourcesById: issueSourcesById, groupOptions: groupOptions, onGroupClick: onGroupClick, onQueryChange: onQueryChange, hierarchyItem: hierarchyItem, MenuItem: MenuItem = (0, $1eMpI.default) }) {
    const [searchQuery, setSearchQuery] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterGroupsWithSearchQuery = (group)=>{
        const groupName = group.groupName.length ? group.groupName : (0, $40hi6.UNASSIGNED_GROUP);
        return groupName.toLowerCase().includes(searchQuery.toLowerCase());
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const searchOptions = (searchQuery)=>{
        setSearchQuery(searchQuery);
        if (onQueryChange) onQueryChange(searchQuery);
    };
    // Sort by issue source name, with null at the top so unassigned is always first
    const groupOptionsEntries = groupOptions.sort((0, $k5IfQ.projectToGroupMapComparator));
    const renderGroupOptions = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const groupOptions = groupOptionsEntries.map(([issueSourceId, groups])=>{
            const groupsToDisplay = groups.filter(filterGroupsWithSearchQuery).sort((0, $40hi6.groupSortComparator));
            if (groupsToDisplay.length > 0) {
                let title = '';
                if (issueSourceId !== null && issueSourceId !== undefined) title = issueSourcesById[issueSourceId].title;
                else if (issueSourceId === null) title = formatMessage((0, $ib5d3.default).unassigned);
                else if (issueSourceId === undefined) title = formatMessage((0, $leCWn.default).externalSource);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
                    key: issueSourceId,
                    title: title
                }, groupsToDisplay.map((group, i)=>{
                    const { groupName: groupName, isDisabled: isDisabled, formattedTitle: formattedTitle, group: groupKey } = group;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuItem, {
                        menuItem: hierarchyItem,
                        key: `${hierarchyItem.id}-${groupKey}-${i}`,
                        isDisabled: isDisabled,
                        onMenuItemClick: (analyticsEvent)=>onGroupClick(group, analyticsEvent),
                        tooltip: isDisabled === true ? formatMessage((0, $leCWn.default).sprintTooltip) : ''
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.dialog-content.${groupKey}`
                    }, formattedTitle || groupName));
                }));
            }
            return null;
        });
        if (groupOptions.every((el)=>el === null)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gwxWo["no-matches"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).noMatchFoundText)));
        return groupOptions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
        placeholder: formatMessage((0, $leCWn.default).sprintSearchPlaceholder),
        searchQuery: searchQuery,
        onQueryChange: searchOptions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gwxWo["inline-dialog-child"]
    }, renderGroupOptions()));
}

});
parcelRegister("leCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d74524c7c3734e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a6d74524c7c3734e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalSource: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.external-source",
        "defaultMessage": "External"
    },
    sprintSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.sprint-search-placeholder",
        "defaultMessage": "Find sprints..."
    },
    sprintTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.sprint-options.sprint-dialog-content.sprint-tooltip",
        "defaultMessage": "You can't create issues for external and completed sprints."
    }
});

});

parcelRegister("gwxWo", function(module, exports) {

$parcel$export(module.exports, "inline-dialog-child", () => $c079f66c55354422$export$870e10843577b165, (v) => $c079f66c55354422$export$870e10843577b165 = v);
$parcel$export(module.exports, "no-matches", () => $c079f66c55354422$export$9c6a6c8c8d3c5bfb, (v) => $c079f66c55354422$export$9c6a6c8c8d3c5bfb = v);
var $c079f66c55354422$export$870e10843577b165;
var $c079f66c55354422$export$9c6a6c8c8d3c5bfb;
$c079f66c55354422$export$870e10843577b165 = `cuQn0G_inline-dialog-child`;
$c079f66c55354422$export$9c6a6c8c8d3c5bfb = `cuQn0G_no-matches`;

});

parcelRegister("k5IfQ", function(module, exports) {

$parcel$export(module.exports, "projectToGroupMapComparator", () => $25d5f507a3f3cd2b$export$82790021fe06eb0b);
const $25d5f507a3f3cd2b$export$82790021fe06eb0b = (a, b)=>{
    // Separated cases to handle null and undefined case for flow
    // null case should be rendered at the top, undefined at the bottom.
    if (a[0] === null || b[0] === undefined) return -1;
    if (b[0] === null || a[0] === undefined) return 1;
    if (a[0] < b[0]) return -1;
    if (a[0] > b[0]) return 1;
    return 0;
};

});



parcelRegister("4Pc0U", function(module, exports) {

$parcel$export(module.exports, "getGroupOptionsFromSprints", () => $08f76695ac5b1af3$export$89bc41e026c5e43a);

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $08f76695ac5b1af3$export$89bc41e026c5e43a = ({ groups: groups, sprints: sprints, sprintsByIdMap: sprintsByIdMap, externalSprintsById: externalSprintsById })=>{
    const isSprintExternal = (sprintId)=>(0, $7CnHa.isDefined)(externalSprintsById[sprintId]);
    const createGroupOptionFromSprint = (sprint)=>({
            group: `sprint-${sprint.id}`,
            groupCombination: {
                sprint: sprint.id
            },
            groupName: sprint.title,
            grouping: (0, $5rYNM.GROUPING).SPRINT,
            startInlineCreateInEmptyGroup: true,
            isDisabled: isSprintExternal(sprint.id)
        });
    const sourceIdToGroupOptionsMap = new Map();
    // We use a set to keep track of which releases we have already handled, because
    // we are handling a map of issueSourceId to Option, neither of which are easy to filter through
    const processedSprintIds = new Set();
    for (const group of groups){
        const { scope: scope, ...groupOption } = group;
        if ((0, $7CnHa.isDefined)(groupOption.groupCombination) && (0, $7CnHa.isDefined)(groupOption.groupCombination.sprint) && !processedSprintIds.has(groupOption.groupCombination.sprint) && sprintsByIdMap[groupOption.groupCombination.sprint].state !== (0, $5rYNM.SPRINT_STATES).CLOSED // Don't render completed sprints in the options as you can't modify closed sprints
        ) {
            const sprintId = groupOption.groupCombination.sprint;
            processedSprintIds.add(groupOption.groupCombination.sprint);
            const sprint = sprintsByIdMap[sprintId];
            if (sprint === undefined) throw Error('Illegal state - sprint was not found in map of ids to sprints');
            // External sprint does not have an issue source
            // We assign all external sprints an undefined issue source, so they can be
            // rendered at the bottom of the list as a list of external sprints
            const issueSourceId = sprint.issueSources[0] !== undefined ? sprint.issueSources[0] : undefined;
            const [, sprintOptions] = sourceIdToGroupOptionsMap.get(issueSourceId) ?? [
                undefined,
                []
            ];
            const sprintOption = {
                ...groupOption,
                isDisabled: !!((0, $7CnHa.isDefined)(groupOption.groupCombination) && (0, $7CnHa.isDefined)(groupOption.groupCombination.sprint) && isSprintExternal(groupOption.groupCombination.sprint))
            };
            sourceIdToGroupOptionsMap.set(issueSourceId, [
                issueSourceId,
                [
                    ...sprintOptions,
                    sprintOption
                ]
            ]);
        }
    }
    // Create option for sprints that aren't currently assigned to any issues
    // Which therefore currently do not have a group.
    for (const sprint of sprints)if (!processedSprintIds.has(sprint.id) && sprint.state !== (0, $5rYNM.SPRINT_STATES).CLOSED) {
        const option = createGroupOptionFromSprint(sprint);
        const issueSourceId = sprint.issueSources !== undefined ? sprint.issueSources[0] : undefined;
        const [, sprintOptions] = sourceIdToGroupOptionsMap.get(issueSourceId) ?? [
            undefined,
            []
        ];
        const sprintOption = {
            ...option,
            isDisabled: !!isSprintExternal(sprint.id)
        };
        sourceIdToGroupOptionsMap.set(issueSourceId, [
            issueSourceId,
            [
                ...sprintOptions,
                sprintOption
            ]
        ]);
    }
    return [
        ...sourceIdToGroupOptionsMap.values()
    ];
};

});



parcelRegister("kfUwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $682a8094bc9c26ec$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3MPYV = parcelRequire("3MPYV");

var $8kGLe = parcelRequire("8kGLe");
var $682a8094bc9c26ec$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3MPYV.default), {})((0, $8kGLe.default));

});
parcelRegister("3MPYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a24de359b225be$export$2e2bcd8739ae039);

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
var $28a24de359b225be$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    additionalTeamsById: (0, $MQRDu.getAdditionalTeamsById),
    teams: (0, $MQRDu.getTeams)
});

});

parcelRegister("8kGLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a51e13e4ad0cdc5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $40hi6 = parcelRequire("40hi6");

var $9Wv4l = parcelRequire("9Wv4l");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $koYm3 = parcelRequire("koYm3");
class $5a51e13e4ad0cdc5$export$fb0ff90f6708321 extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onGroupClick: onGroupClick, hierarchyItem: hierarchyItem } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Wv4l.default), {
            groupOptions: this.getGroupOptionsFromTeams(),
            hierarchyItem: hierarchyItem,
            searchPlaceholder: intl.formatMessage((0, $koYm3.default).teamSearchPlaceholder),
            onGroupClick: onGroupClick
        });
    }
    constructor(...args){
        super(...args);
        this.isTeamDisabled = (teamId)=>(0, $7CnHa.isDefined)(this.props.additionalTeamsById[teamId]);
        this.createGroupOptionFromTeam = (tooltipMessage, team)=>({
                group: `team-${team.id}`,
                groupCombination: {
                    team: team.id
                },
                groupName: team.title,
                groupUrl: team.avatarUrl || '',
                grouping: (0, $5rYNM.GROUPING).TEAM,
                startInlineCreateInEmptyGroup: true,
                groupTooltip: tooltipMessage,
                isDisabled: this.isTeamDisabled(team.id)
            });
        this.getGroupOptionsFromTeams = ()=>{
            const { groups: groups, teams: teams, intl: intl } = this.props;
            const tooltipMessage = intl.formatMessage((0, $koYm3.default).teamTooltip);
            const unassigned = {
                groupName: intl.formatMessage((0, $ib5d3.default).unassigned),
                grouping: 'TEAM',
                isExpanded: true,
                group: (0, $40hi6.UNDEFINED_GROUP),
                groupCombination: {
                    team: null
                },
                startInlineCreateInEmptyGroup: !groups.some(({ group: group })=>group === (0, $40hi6.UNDEFINED_GROUP)),
                groupUrl: '',
                groupTooltip: tooltipMessage
            };
            const groupOptions = new Map();
            for (const group of groups){
                const { scope: scope, ...groupOption } = group;
                if (groupOption.groupCombination) groupOptions.set(groupOption.groupCombination.team, {
                    ...groupOption,
                    groupTooltip: tooltipMessage,
                    isDisabled: !!(groupOption.groupCombination && groupOption.groupCombination.team && this.isTeamDisabled(groupOption.groupCombination.team))
                });
            }
            for (const team of teams)if (!groupOptions.has(team.id)) {
                const option = this.createGroupOptionFromTeam(tooltipMessage, team);
                groupOptions.set(team.id, option);
            }
            groupOptions.set(null, unassigned);
            return [
                ...groupOptions.values()
            ].sort((0, $40hi6.groupSortComparator));
        };
    }
}
var $5a51e13e4ad0cdc5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($5a51e13e4ad0cdc5$export$fb0ff90f6708321);

});
parcelRegister("koYm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b1345b75c6ca73$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $30b1345b75c6ca73$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    teamTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.team-options.team-tooltip",
        "defaultMessage": "You can't create issues for external teams."
    },
    teamSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.add-issue.nested-menu.team-options.team-search-placeholder",
        "defaultMessage": "Find teams..."
    }
});

});





parcelRegister("bw2Zn", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_SUPPORTED_GROUPS", () => $fa60fe1516d530bc$export$68650f863e35e955);

var $5rYNM = parcelRequire("5rYNM");
const $fa60fe1516d530bc$export$68650f863e35e955 = [
    (0, $5rYNM.GROUPING).NONE,
    (0, $5rYNM.GROUPING).ASSIGNEE,
    (0, $5rYNM.GROUPING).REPORTER,
    (0, $5rYNM.GROUPING).PROJECT,
    (0, $5rYNM.GROUPING).RELEASE,
    (0, $5rYNM.GROUPING).SPRINT,
    (0, $5rYNM.GROUPING).TEAM
];

});

parcelRegister("gQw8M", function(module, exports) {

$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $eea42f92b0177647$export$5d06510124eb14f8);

var $79xbN = parcelRequire("79xbN");
const $eea42f92b0177647$export$5d06510124eb14f8 = ()=>(0, $79xbN.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');

});



parcelRegister("5QmtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d976d4791b64a9de$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hLWUD = parcelRequire("hLWUD");

var $kZGXc = parcelRequire("kZGXc");
var $d976d4791b64a9de$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hLWUD.default), {})((0, $kZGXc.default));

});
parcelRegister("hLWUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5035ee0795255054$export$2e2bcd8739ae039);

var $fZW8G = parcelRequire("fZW8G");

var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $5035ee0795255054$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    cpVersionsForSelectedIssues: (0, $kwMvv.getCPRsForSelectedIssues),
    hierarchyRange: (0, $fZW8G.getHierarchyRange),
    projectsById: (0, $ehEr2.getProjectsById),
    selectedIssues: (0, $kwMvv.getSelectedIssues)
});

});

parcelRegister("kZGXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ccb479e34f03cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eo8NR = parcelRequire("eo8NR");

var $86Ndv = parcelRequire("86Ndv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3XRVl = parcelRequire("3XRVl");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");

var $64VaH = parcelRequire("64VaH");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $jMP2a = parcelRequire("jMP2a");

var $2n0cC = parcelRequire("2n0cC");

var $bqeKi = parcelRequire("bqeKi");

var $axaal = parcelRequire("axaal");

var $lClE6 = parcelRequire("lClE6");

var $cYCst = parcelRequire("cYCst");
const $c2ccb479e34f03cb$var$DROPMENU_ITEMS = [
    'setAssignee',
    'dates',
    'setEstimate',
    'setLabel',
    'setParent',
    'setRank',
    'setReleases',
    'setSprint',
    'setTeam'
] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
.map((key)=>(0, $cYCst.DROPMENU_MAP)[key]);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $c2ccb479e34f03cb$var$MORE_DROPMENU_ITEMS = [
    'bulkChange',
    'removeFromPlanTitle'
].map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(key)=>(0, $cYCst.DROPMENU_MAP)[key]);
const $c2ccb479e34f03cb$export$9cf433a293bbef79 = /*#__PURE__*/ (0, $eUqFw.memo)(({ selectedIssues: selectedIssues, projectsById: projectsById, ...props })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $eUqFw.useState)(false);
    const [isDialogOpen, setIsDialogOpen] = (0, $eUqFw.useState)(false);
    const [optionSelected, setOptionSelected] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const toggleModalDialog = (0, $eUqFw.useCallback)((isDialogOpen)=>{
        setIsDialogOpen(isDialogOpen);
    }, []);
    const buildUrl = (0, $eUqFw.useCallback)(()=>{
        const issueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))(selectedIssues, ({ project: projectId, issueKey: issueKey })=>{
            const project = projectsById[projectId];
            if (!issueKey) return undefined;
            return `${project.key}-${issueKey}`;
        });
        const encodedIds = encodeURIComponent(issueKeys.filter((key)=>key).toString());
        return (0, $64VaH.proxyContextSafeUrl)(`/secure/GHBulkChange.jspa?issueKeys=${encodedIds}`);
    }, [
        projectsById,
        selectedIssues
    ]);
    const sendIDtoJira = (0, $eUqFw.useCallback)(()=>{
        (0, $lFLge.openInNewTab)(buildUrl());
        // eslint-disable-next-line @typescript-eslint/no-shadow
        setIsMenuOpen((isMenuOpen)=>!isMenuOpen);
    }, [
        buildUrl
    ]);
    const selectOption = (0, $eUqFw.useCallback)((dropOption, analyticsEvent)=>{
        if (analyticsEvent) {
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_OPTION_SELECTED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_OPTION_SELECTED, {
                selectedOption: dropOption.analyticsId
            });
        }
        if (dropOption.type === (0, $lClE6.BULK_CHANGE)) {
            sendIDtoJira();
            return;
        }
        setIsMenuOpen(false);
        setIsDialogOpen(true);
        setOptionSelected(dropOption);
    }, [
        sendIDtoJira
    ]);
    const renderOneItem = (0, $eUqFw.useCallback)((getDropOption)=>{
        const option = getDropOption({
            selectedIssues: selectedIssues,
            projectsById: projectsById,
            ...props
        });
        const { label: label, disabled: disabled, analyticsId: analyticsId, disabledTooltip: disabledTooltip } = option;
        const title = formatMessage(label);
        const tooltip = (0, $7CnHa.isDefined)(disabled) && disabled && disabledTooltip ? formatMessage(disabledTooltip) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: tooltip,
            key: title,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.drop-menu-item.${analyticsId}`,
            onClick: (_, analyticsEvent)=>selectOption(option, analyticsEvent),
            isDisabled: disabled
        }, title));
    }, [
        formatMessage,
        projectsById,
        selectedIssues,
        selectOption,
        props
    ]);
    const toggleMenu = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        if (analyticsEvent) {
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_CLICKED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_CLICKED, {
                selectedIssues: selectedIssues.length,
                isMenuOpen: !isMenuOpen
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-shadow
        setIsMenuOpen((isMenuOpen)=>!isMenuOpen);
    }, [
        selectedIssues,
        isMenuOpen
    ]);
    const fireBulkActionSuccessAnalytics = (0, $eUqFw.useCallback)((analyticsEvent, selectedOption)=>{
        if (analyticsEvent) {
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED, {
                selectedOption: selectedOption,
                selectedIssues: selectedIssues.length
            });
        }
    }, [
        selectedIssues.length
    ]);
    const renderDialog = (0, $eUqFw.useCallback)(()=>{
        const Dialog = optionSelected && optionSelected.dialog;
        if (!isDialogOpen || !optionSelected || !Dialog) return null;
        switch(optionSelected.type){
            case 0, $lClE6.SET_DATES:
            case 0, $lClE6.REMOVE_FROM_PLAN:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dialog, {
                    toggleModalDialog: ()=>toggleModalDialog(!isDialogOpen),
                    bulkActionSuccess: (analyticsEvent)=>fireBulkActionSuccessAnalytics(analyticsEvent, optionSelected.analyticsId)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dialog, {
                    toggleModalDialog: ()=>toggleModalDialog(!isDialogOpen),
                    UpdateAttributeForm: (0, $bqeKi.default),
                    bulkActionSuccess: (analyticsEvent)=>fireBulkActionSuccessAnalytics(analyticsEvent, optionSelected.analyticsId)
                });
        }
    }, [
        fireBulkActionSuccessAnalytics,
        isDialogOpen,
        optionSelected,
        toggleModalDialog
    ]);
    const onOpenChange = ({ isOpen: isOpen })=>{
        if (!isOpen) setIsMenuOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        isOpen: isMenuOpen,
        onOpenChange: onOpenChange,
        placement: "bottom-end",
        // eslint-disable-next-line @typescript-eslint/no-shadow
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                onClick: toggleMenu,
                ref: triggerRef,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions"
            }, formatMessage((0, $axaal.default).bulkActions))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2n0cC.default), {
        dropMenuItems: $c2ccb479e34f03cb$var$DROPMENU_ITEMS.map(renderOneItem),
        moreDropMenuItems: $c2ccb479e34f03cb$var$MORE_DROPMENU_ITEMS.map(renderOneItem)
    })), renderDialog());
});
var $c2ccb479e34f03cb$export$2e2bcd8739ae039 = $c2ccb479e34f03cb$export$9cf433a293bbef79;

});
parcelRegister("2n0cC", function(module, exports) {

$parcel$export(module.exports, "default", () => $500dccae7b3816d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fEubG = parcelRequire("fEubG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gNxyD = parcelRequire("gNxyD");
const $500dccae7b3816d6$var$BulkActionsMenu = /*#__PURE__*/ (0, $eUqFw.memo)(({ dropMenuItems: dropMenuItems, moreDropMenuItems: moreDropMenuItems })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.menu-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $gNxyD.default).setFieldGroupTitle)
    }, dropMenuItems), moreDropMenuItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $gNxyD.default).moreActionsGroupTitle)
    }, moreDropMenuItems));
});
var $500dccae7b3816d6$export$2e2bcd8739ae039 = $500dccae7b3816d6$var$BulkActionsMenu;

});
parcelRegister("gNxyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8d4a7c0475152f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4a8d4a7c0475152f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setFieldGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.set-field-group-title",
        "defaultMessage": "Update"
    },
    moreActionsGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions-menu.more-actions-group-title",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("bqeKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3321cabb0da35104$export$2e2bcd8739ae039);

var $ciOai = parcelRequire("ciOai");
var $3321cabb0da35104$export$2e2bcd8739ae039 = (0, $ciOai.default);

});
parcelRegister("ciOai", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce45f062f8e4c8b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $iJlfe = parcelRequire("iJlfe");

var $cSu9v = parcelRequire("cSu9v");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $akSC8 = parcelRequire("akSC8");
var $aAyrO = parcelRequire("aAyrO");
var $4LhB6 = parcelRequire("4LhB6");
var $7jPhn = parcelRequire("7jPhn");
var $gwbfD = parcelRequire("gwbfD");

var $i5n86 = parcelRequire("i5n86");

var $lClE6 = parcelRequire("lClE6");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $7aiur = parcelRequire("7aiur");

var $8fpon = parcelRequire("8fpon");

var $brPOj = parcelRequire("brPOj");
class $ce45f062f8e4c8b2$export$3f0525cbd1b0a680 extends (0, $eUqFw.Component) {
    render() {
        const { onCancel: onCancel, currentValue: currentValue, currentIssueTypeIcon: currentIssueTypeIcon, avatarIcon: avatarIcon, shouldFitContainerWidth: shouldFitContainerWidth } = this.props;
        const currentContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj["value-placeholder"]
        }, currentIssueTypeIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $brPOj["issue-type-icon"],
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundSize: 'contain',
                backgroundImage: `url(${currentIssueTypeIcon})`
            }
        }) : null, avatarIcon && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $brPOj.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: avatarIcon
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj["current-value-title"]
        }, currentValue));
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { fieldValue: fieldValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$brPOj["form-group"]} ${shouldFitContainerWidth ? $brPOj["should-fit-full-width"] : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj["current-value"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj["value-label"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).current)), currentValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: currentValue
        }, currentContent) : currentContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $brPOj["new-value"]
        }, this.getFormField())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
            className: $brPOj["form-footer"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "subtle",
            onClick: onCancel
        }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "primary",
            isDisabled: $b3iuB.default(fieldValue),
            onClick: (_, analyticsEvent)=>{
                this.submitForm(analyticsEvent);
            }
        }, formatMessage((0, $ib5d3.default).apply))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            fieldValue: {}
        };
        this.submitForm = (analyticsEvent)=>{
            const { onSubmit: onSubmit } = this.props;
            const { fieldValue: fieldValue } = this.state;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const normalizedData = Object.keys(fieldValue).reduce((acc, curr)=>{
                if (curr === 'fixVersions') // convert fixVersions value received from select to array.
                return Object.assign(acc, {
                    [curr]: fieldValue[curr] && fieldValue[curr] !== (0, $5rYNM.NONE) ? [
                        fieldValue[curr]
                    ] : []
                });
                return Object.assign(acc, {
                    [curr]: fieldValue[curr] === (0, $5rYNM.NONE) ? null : fieldValue[curr]
                });
            }, {});
            onSubmit(normalizedData, analyticsEvent);
        };
        this.handleOnChange = (fieldId, fieldValue)=>{
            this.setState({
                fieldValue: {
                    [fieldId]: fieldValue
                }
            });
        };
        this.getFormField = ()=>{
            const { intl: { formatMessage: formatMessage }, options: options = [], updatedAttributeType: updatedAttributeType, warningMessage: warningMessage } = this.props;
            const noneOption = {
                label: formatMessage((0, $ib5d3.default).none),
                value: (0, $5rYNM.NONE)
            };
            switch(updatedAttributeType){
                case 0, $lClE6.SET_ASSIGNEE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5n86.default), {
                        autofocus: true,
                        defaultValue: undefined,
                        id: "assignee",
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "assignee",
                        onChange: (id, value)=>{
                            this.handleOnChange(id, value);
                        },
                        placeholder: formatMessage((0, $8fpon.default).chooseAssigneePlaceholder)
                    });
                case 0, $lClE6.MOVE_ISSUES:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                        isRequired: true,
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "parent",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.move-issues-field"
                    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            defaultValue: undefined,
                            formatOptionLabel: (0, $akSC8.selectIssueOption),
                            "aria-label": formatMessage((0, $8fpon.default).chooseParentPlaceholder),
                            classNamePrefix: "move_issues_field",
                            onChange: (option)=>{
                                this.handleOnChange('parent', option?.value);
                            },
                            options: options,
                            placeholder: formatMessage((0, $8fpon.default).chooseParentPlaceholder),
                            styles: {
                                menu: (base)=>({
                                        ...base,
                                        minWidth: '300px',
                                        maxWidth: '560px',
                                        width: 'auto'
                                    }),
                                option: (base)=>({
                                        ...base,
                                        width: 'auto'
                                    }),
                                // eslint-disable-next-line @typescript-eslint/no-shadow
                                singleValue: (styles)=>({
                                        ...styles,
                                        width: '100%'
                                    })
                            }
                        }), warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, warningMessage)));
                case 0, $lClE6.SET_RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                        isRequired: true,
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "fixVersions",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-release-field"
                    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            autoFocus: true,
                            defaultValue: undefined,
                            formatOptionLabel: (0, $7aiur.formatReleaseOptionLabel),
                            classNamePrefix: "set_release_field",
                            "aria-label": formatMessage((0, $8fpon.default).chooseReleasePlaceholder),
                            onChange: (option)=>{
                                this.handleOnChange('fixVersions', option?.value);
                            },
                            options: [
                                {
                                    options: [
                                        noneOption
                                    ]
                                },
                                ...options
                            ],
                            placeholder: formatMessage((0, $8fpon.default).chooseReleasePlaceholder)
                        }));
                case 0, $lClE6.SET_CP_RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                        isRequired: true,
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "crossProjectVersion",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-cp-release-field"
                    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            autoFocus: true,
                            defaultValue: undefined,
                            "aria-label": formatMessage((0, $8fpon.default).chooseCrossProjectReleasePlaceholder),
                            classNamePrefix: "cp_release_field",
                            onChange: (option)=>{
                                this.handleOnChange('crossProjectVersion', option?.value);
                            },
                            options: [
                                noneOption,
                                ...options
                            ],
                            placeholder: formatMessage((0, $8fpon.default).chooseCrossProjectReleasePlaceholder)
                        }));
                case 0, $lClE6.SET_SPRINT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                        isRequired: true,
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "sprint",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-sprint-field"
                    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            autoFocus: true,
                            defaultValue: undefined,
                            "aria-label": formatMessage((0, $8fpon.default).chooseSprintPlaceholder),
                            classNamePrefix: "set_sprint_field",
                            onChange: (option)=>{
                                this.handleOnChange('sprint', option?.value);
                            },
                            options: options,
                            placeholder: formatMessage((0, $8fpon.default).chooseSprintPlaceholder)
                        }));
                case 0, $lClE6.SET_TEAM:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                        isRequired: true,
                        label: formatMessage((0, $ib5d3.default).new),
                        name: "team",
                        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.common.update-attribute-form.set-team-field"
                    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            autoFocus: true,
                            defaultValue: undefined,
                            "aria-label": formatMessage((0, $8fpon.default).chooseTeamPlaceholder),
                            classNamePrefix: "set_team_field",
                            onChange: (option)=>{
                                this.handleOnChange('team', option?.value);
                            },
                            options: [
                                noneOption,
                                ...options
                            ],
                            placeholder: formatMessage((0, $8fpon.default).chooseTeamPlaceholder)
                        }));
                default:
                    return undefined;
            }
        };
    }
}
var $ce45f062f8e4c8b2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ce45f062f8e4c8b2$export$3f0525cbd1b0a680);

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = $fbef6921e18df378$var$EditorSuccessIcon;
module.exports.default = $fbef6921e18df378$var$_default;

});


parcelRegister("i5n86", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46b863d1e13d9ec$export$2e2bcd8739ae039);

var $63O1Q = parcelRequire("63O1Q");

var $lNNXV = parcelRequire("lNNXV");

var $ddkmm = parcelRequire("ddkmm");

var $foQE2 = parcelRequire("foQE2");
const $d46b863d1e13d9ec$var$mapDispatchToProps = {
    fetchAssigneeList: $63O1Q.fetchAssigneeList
};
var $d46b863d1e13d9ec$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ddkmm.default), $d46b863d1e13d9ec$var$mapDispatchToProps)((0, $foQE2.default));

});
parcelRegister("ddkmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9c98056d87b0362$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");

var $iK4oF = parcelRequire("iK4oF");
var $b9c98056d87b0362$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    assigneeListFetchStatus: (0, $6VhAf.getAssigneeListFetchStatus),
    assignees: (0, $6VhAf.getAssigneeList)
});

});

parcelRegister("foQE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab2792dac6ffebd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $ewMwZ = parcelRequire("ewMwZ");

var $7CnHa = parcelRequire("7CnHa");

var $gGKRb = parcelRequire("gGKRb");

var $gkXIa = parcelRequire("gkXIa");
// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
class $0ab2792dac6ffebd$var$AssigneeSelectField extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { fetchAssigneeList: fetchAssigneeList } = this.props;
        fetchAssigneeList({
            query: ''
        });
    }
    render() {
        const { assigneeListFetchStatus: assigneeListFetchStatus, assignees: assignees, autofocus: autofocus, defaultValue: defaultValue, id: id, label: label, name: name, placeholder: placeholder, required: required, value: value } = this.props;
        const options = (0, $ewMwZ.transformPersons)((0, $ewMwZ.sort)(assignees));
        const selectedValue = options.find(({ value: optValue })=>optValue === value);
        const defaultSelectedValue = options.find(({ value: optValue })=>optValue === defaultValue);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            isRequired: required,
            key: `${id}-field`,
            label: label,
            name: name
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGKRb.default), {
                ...fieldProps,
                autoFocus: autofocus,
                defaultValue: defaultSelectedValue,
                // @ts-expect-error TS2322 trouble casting from the general OptionType to the UserOption,
                // we need to update OptionType to be the atlaskit type first I think
                formatOptionLabel: (0, $gkXIa.formatOptionLabel),
                isLoading: assigneeListFetchStatus,
                isTransparentBackground: false,
                key: id,
                menuPlacement: "auto",
                onChange: this.onUserChange,
                onInputChange: this.onInputChange,
                options: options,
                placeholder: placeholder,
                value: selectedValue
            }));
    }
    constructor(...args){
        super(...args);
        this.onUserChange = (value)=>{
            const { onChange: onChange, id: id } = this.props;
            // @ts-expect-error - TS2551 - Property 'value' does not exist on type 'OptionsType'
            const update = (0, $7CnHa.isDefined)(value) && value.value || value;
            onChange(id, update);
        };
        this.onInputChange = (currentFilter, { action: action })=>{
            if (action === 'input-change') {
                const { fetchAssigneeList: fetchAssigneeList } = this.props;
                fetchAssigneeList({
                    query: currentFilter
                });
            }
        };
    }
}
var $0ab2792dac6ffebd$export$2e2bcd8739ae039 = $0ab2792dac6ffebd$var$AssigneeSelectField;

});


parcelRegister("lClE6", function(module, exports) {

$parcel$export(module.exports, "MODAL_DIALOG_WIDTH", () => $f0809728db942d87$export$ba66d00f212e494);
$parcel$export(module.exports, "SET_ASSIGNEE", () => $f0809728db942d87$export$6814b7b3aea6ee01);
$parcel$export(module.exports, "SET_ESTIMATE", () => $f0809728db942d87$export$c2ccd34996aa2a3);
$parcel$export(module.exports, "SET_LABEL", () => $f0809728db942d87$export$8b170d320d746e17);
$parcel$export(module.exports, "REMOVE_FROM_PLAN", () => $f0809728db942d87$export$2a334e9fa63b0d35);
$parcel$export(module.exports, "SET_RELEASE", () => $f0809728db942d87$export$807382b6c265578e);
$parcel$export(module.exports, "SET_CP_RELEASE", () => $f0809728db942d87$export$572de3870cb71834);
$parcel$export(module.exports, "SET_TEAM", () => $f0809728db942d87$export$e470dd4ae2dbd706);
$parcel$export(module.exports, "SET_DATES", () => $f0809728db942d87$export$de056ff7f72d62f8);
$parcel$export(module.exports, "SET_RANK", () => $f0809728db942d87$export$6f51da72f6b60191);
$parcel$export(module.exports, "SET_SPRINT", () => $f0809728db942d87$export$26f77f93871b8908);
$parcel$export(module.exports, "MOVE_ISSUES", () => $f0809728db942d87$export$5a7b1cdb33fc8269);
$parcel$export(module.exports, "BULK_CHANGE", () => $f0809728db942d87$export$66cb530046350ea5);
const $f0809728db942d87$export$ba66d00f212e494 = 640;
const $f0809728db942d87$export$6814b7b3aea6ee01 = 'roadmap.scope.header.bulk-actions.SET_ASSIGNEE';
const $f0809728db942d87$export$c2ccd34996aa2a3 = 'roadmap.scope.header.bulk-actions.SET_ESTIMATE';
const $f0809728db942d87$export$8b170d320d746e17 = 'roadmap.scope.header.bulk-actions.SET_LABEL';
const $f0809728db942d87$export$2a334e9fa63b0d35 = 'roadmap.scope.header.bulk-actions.REMOVE_FROM_PLAN';
const $f0809728db942d87$export$807382b6c265578e = 'roadmap.scope.header.bulk-actions.SET_RELEASE';
const $f0809728db942d87$export$572de3870cb71834 = 'roadmap.scope.header.bulk-actions.SET_CP_RELEASE';
const $f0809728db942d87$export$e470dd4ae2dbd706 = 'roadmap.scope.header.bulk-actions.SET_TEAM';
const $f0809728db942d87$export$de056ff7f72d62f8 = 'roadmap.scope.header.bulk-actions.SET_DATES';
const $f0809728db942d87$export$6f51da72f6b60191 = 'roadmap.scope.header.bulk-actions.SET_RANK';
const $f0809728db942d87$export$26f77f93871b8908 = 'roadmap.scope.header.bulk-actions.SET_SPRINT';
const $f0809728db942d87$export$5a7b1cdb33fc8269 = 'roadmap.scope.header.bulk-actions.MOVE_ISSUES';
const $f0809728db942d87$export$66cb530046350ea5 = 'roadmap.scope.header.bulk-actions.BULK_CHANGE';

});

parcelRegister("8fpon", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef114a734e139bb$export$2e2bcd8739ae039);
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$bef114a734e139bb$export$2e2bcd8739ae039 = {
    chooseAssigneePlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-assignee-placeholder',
        defaultMessage: 'Choose an assignee',
        description: 'Placeholder for assignee picklist'
    },
    chooseParentPlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-parent-placeholder',
        defaultMessage: 'Choose a parent',
        description: 'Placeholder for parent picklist'
    },
    chooseReleasePlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-release-placeholder',
        defaultMessage: 'Choose a release',
        description: 'Placeholder for release picklist'
    },
    chooseCrossProjectReleasePlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-cross-project-release-placeholder',
        defaultMessage: 'Choose a cross-project release',
        description: 'Placeholder for cross-project release picklist'
    },
    chooseSprintPlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-sprint-placeholder',
        defaultMessage: 'Choose a sprint',
        description: 'Placeholder for sprint picklist'
    },
    chooseTeamPlaceholder: {
        id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.update-attribute-form.choose-team-placeholder',
        defaultMessage: 'Choose a team',
        description: 'Placeholder for team picklist'
    }
};

});

parcelRegister("brPOj", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $855a67d04ea04208$export$345c5736c8054f22, (v) => $855a67d04ea04208$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "current-value", () => $855a67d04ea04208$export$bd70860eb87e972b, (v) => $855a67d04ea04208$export$bd70860eb87e972b = v);
$parcel$export(module.exports, "current-value-title", () => $855a67d04ea04208$export$2c19fd1221dd0b06, (v) => $855a67d04ea04208$export$2c19fd1221dd0b06 = v);
$parcel$export(module.exports, "form-footer", () => $855a67d04ea04208$export$536347ba10a26096, (v) => $855a67d04ea04208$export$536347ba10a26096 = v);
$parcel$export(module.exports, "form-group", () => $855a67d04ea04208$export$55a1f87a143fb302, (v) => $855a67d04ea04208$export$55a1f87a143fb302 = v);
$parcel$export(module.exports, "icon", () => $855a67d04ea04208$export$1ca1ec8b29a4ce27, (v) => $855a67d04ea04208$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "issue-type-icon", () => $855a67d04ea04208$export$175e354db6e532ed, (v) => $855a67d04ea04208$export$175e354db6e532ed = v);
$parcel$export(module.exports, "new-value", () => $855a67d04ea04208$export$18786265e3bc6811, (v) => $855a67d04ea04208$export$18786265e3bc6811 = v);
$parcel$export(module.exports, "should-fit-full-width", () => $855a67d04ea04208$export$1ba12f97147feb87, (v) => $855a67d04ea04208$export$1ba12f97147feb87 = v);
$parcel$export(module.exports, "value-label", () => $855a67d04ea04208$export$f2febdad47edd01a, (v) => $855a67d04ea04208$export$f2febdad47edd01a = v);
$parcel$export(module.exports, "value-placeholder", () => $855a67d04ea04208$export$16d768213d218756, (v) => $855a67d04ea04208$export$16d768213d218756 = v);
var $855a67d04ea04208$export$345c5736c8054f22;
var $855a67d04ea04208$export$bd70860eb87e972b;
var $855a67d04ea04208$export$2c19fd1221dd0b06;
var $855a67d04ea04208$export$536347ba10a26096;
var $855a67d04ea04208$export$55a1f87a143fb302;
var $855a67d04ea04208$export$1ca1ec8b29a4ce27;
var $855a67d04ea04208$export$175e354db6e532ed;
var $855a67d04ea04208$export$18786265e3bc6811;
var $855a67d04ea04208$export$1ba12f97147feb87;
var $855a67d04ea04208$export$f2febdad47edd01a;
var $855a67d04ea04208$export$16d768213d218756;
$855a67d04ea04208$export$345c5736c8054f22 = `OU0D_a_avatar`;
$855a67d04ea04208$export$bd70860eb87e972b = `OU0D_a_current-value`;
$855a67d04ea04208$export$2c19fd1221dd0b06 = `OU0D_a_current-value-title`;
$855a67d04ea04208$export$536347ba10a26096 = `OU0D_a_form-footer`;
$855a67d04ea04208$export$55a1f87a143fb302 = `OU0D_a_form-group`;
$855a67d04ea04208$export$1ca1ec8b29a4ce27 = `OU0D_a_icon`;
$855a67d04ea04208$export$175e354db6e532ed = `OU0D_a_issue-type-icon`;
$855a67d04ea04208$export$18786265e3bc6811 = `OU0D_a_new-value`;
$855a67d04ea04208$export$1ba12f97147feb87 = `OU0D_a_should-fit-full-width`;
$855a67d04ea04208$export$f2febdad47edd01a = `OU0D_a_value-label`;
$855a67d04ea04208$export$16d768213d218756 = `OU0D_a_value-placeholder`;

});



parcelRegister("axaal", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af4136bbd133263$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1af4136bbd133263$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    bulkActions: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-actions",
        "defaultMessage": "Bulk actions"
    },
    bulkChange: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-change",
        "defaultMessage": "Bulk change in Jira"
    },
    bulkChangeInJiraTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.bulk-change-in-jira-tooltip",
        "defaultMessage": "All selected issues must already be saved in Jira"
    },
    issueLimitExceededTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issue-limit-exceeded-tooltip",
        "defaultMessage": "Maximum 100 issues"
    },
    setFieldGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-field-group-title",
        "defaultMessage": "Update"
    },
    setParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-parent",
        "defaultMessage": "Parent"
    },
    setRank: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-rank",
        "defaultMessage": "Rank"
    },
    setTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-team",
        "defaultMessage": "Team"
    },
    setSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-sprint",
        "defaultMessage": "Sprint"
    },
    labels: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.labels",
        "defaultMessage": "Labels"
    },
    moreActionsGroupTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.more-actions-group-title",
        "defaultMessage": "More actions"
    },
    removeFromPlanTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.remove-from-plan-title",
        "defaultMessage": "Remove from plan"
    },
    releaseMenuItemTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.release-menu-item-tooltip",
        "defaultMessage": "To set the release, the selected issues must belong to the same project, or there must be a cross-project release that has releases from all associated projects."
    },
    releaseDisabledMenuItemTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.release-disabled-menu-item-tooltip",
        "defaultMessage": "To set the release, the selected issues must belong to project that has releases enabled."
    },
    issuesSameLevelTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issues-same-level-tooltip",
        "defaultMessage": "To move multiple issues to another parent issue, the issues must be of the same hierarchy level"
    },
    issuesTopLevelTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.issues-top-level-tooltip",
        "defaultMessage": "One of the selected issues is already of the topmost hierarchy level, so it's not possible to move this any higher"
    },
    teamMenuItemTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.team-menu-item-tooltip",
        "defaultMessage": "A sub-task is assigned to the same team as its parent story. To change this team, reassign the parent story instead."
    },
    sprintMenuItemTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.sprint-menu-item-tooltip",
        "defaultMessage": "A sub-task is assigned to the same sprint as its parent story. To change its sprint, change the sprint of the parent story instead"
    }
});

});

parcelRegister("cYCst", function(module, exports) {

$parcel$export(module.exports, "DROPMENU_MAP", () => $76e7f4b07fb5ff70$export$c00c4ecb0f3e16f2);

var $b3iuB = parcelRequire("b3iuB");

var $8YqJS = parcelRequire("8YqJS");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $ej82X = parcelRequire("ej82X");

var $dKihG = parcelRequire("dKihG");

var $8rpuJ = parcelRequire("8rpuJ");

var $iYPFR = parcelRequire("iYPFR");

var $3pWsd = parcelRequire("3pWsd");

var $8a8aF = parcelRequire("8a8aF");

var $2sBeB = parcelRequire("2sBeB");

var $lPjIl = parcelRequire("lPjIl");

var $4ugWW = parcelRequire("4ugWW");

var $e72nm = parcelRequire("e72nm");

var $kI81z = parcelRequire("kI81z");

var $axaal = parcelRequire("axaal");

var $lClE6 = parcelRequire("lClE6");
const $76e7f4b07fb5ff70$export$71f5d920f9b29ebb = (selectedIssues)=>{
    if (selectedIssues && selectedIssues.length) return !selectedIssues.some((issue)=>issue.level !== selectedIssues[0].level);
    return false;
};
const $76e7f4b07fb5ff70$export$559c788e8799af86 = (selectedIssues, hierarchyRange)=>{
    if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>issue.level === hierarchyRange.max);
    return false;
};
const $76e7f4b07fb5ff70$export$f9c983cc2430c4f3 = (selectedIssues)=>{
    if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>issue.level === (0, $8YqJS.SUB_TASK_LEVEL));
    return false;
};
const $76e7f4b07fb5ff70$export$53f3d8e656ab0334 = (selectedIssues)=>{
    if (selectedIssues && selectedIssues.length) return selectedIssues.some(({ id: id })=>id.includes((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX)));
    return false;
};
const $76e7f4b07fb5ff70$export$e8b24162d7fa01b5 = (selectedIssues)=>{
    if (selectedIssues && selectedIssues.length) return selectedIssues.length > (0, $5rYNM.MAX_BULK_CHANGE_ISSUES);
    return false;
};
const $76e7f4b07fb5ff70$export$8ac58c2734f0faf8 = (selectedIssues)=>{
    if (selectedIssues && selectedIssues.length) return !selectedIssues.some((issue)=>issue.project !== selectedIssues[0].project);
    return false;
};
const $76e7f4b07fb5ff70$export$d285b37749fb1894 = (selectedIssues, projectsById)=>{
    if (selectedIssues && selectedIssues.length) return selectedIssues.some((issue)=>projectsById[issue.project]?.isReleasesEnabled !== true);
    return false;
};
const $76e7f4b07fb5ff70$export$c00c4ecb0f3e16f2 = {
    setAssignee: ()=>({
            type: (0, $lClE6.SET_ASSIGNEE),
            label: (0, $ib5d3.default).assignee,
            dialog: (0, $dKihG.default),
            analyticsId: 'Assignee'
        }),
    dates: ()=>({
            type: (0, $lClE6.SET_DATES),
            label: (0, $ib5d3.default).dates,
            dialog: (0, $iYPFR.default),
            analyticsId: 'Dates'
        }),
    setEstimate: ()=>({
            type: (0, $lClE6.SET_ESTIMATE),
            label: (0, $ib5d3.default).estimate,
            dialog: (0, $3pWsd.default),
            analyticsId: 'Estimate'
        }),
    setLabel: ()=>({
            type: (0, $lClE6.SET_LABEL),
            label: (0, $axaal.default).labels,
            dialog: (0, $8a8aF.default),
            analyticsId: 'Labels'
        }),
    setParent: ({ selectedIssues: selectedIssues, hierarchyRange: hierarchyRange })=>{
        const isSameLevel = $76e7f4b07fb5ff70$export$71f5d920f9b29ebb(selectedIssues);
        const isTopLevel = $76e7f4b07fb5ff70$export$559c788e8799af86(selectedIssues, hierarchyRange);
        const disabled = !isSameLevel && isTopLevel;
        const disabledTooltip = isSameLevel ? (0, $axaal.default).issuesTopLevelTooltip : (0, $axaal.default).issuesSameLevelTooltip;
        return {
            type: (0, $lClE6.MOVE_ISSUES),
            label: (0, $axaal.default).setParent,
            disabled: disabled,
            disabledTooltip: disabledTooltip,
            dialog: (0, $2sBeB.default),
            analyticsId: 'Parent'
        };
    },
    setRank: ()=>({
            type: (0, $lClE6.SET_RANK),
            label: (0, $axaal.default).setRank,
            dialog: (0, $lPjIl.default),
            analyticsId: 'Rank'
        }),
    setReleases: ({ selectedIssues: selectedIssues, cpVersionsForSelectedIssues: cpVersionsForSelectedIssues, projectsById: projectsById })=>{
        const isSameProject = $76e7f4b07fb5ff70$export$8ac58c2734f0faf8(selectedIssues);
        const hasReleasesDisabled = $76e7f4b07fb5ff70$export$d285b37749fb1894(selectedIssues, projectsById);
        const hasCPRs = !$b3iuB.default(cpVersionsForSelectedIssues);
        const disabled = hasReleasesDisabled || !hasCPRs && !isSameProject;
        const action = hasCPRs && !isSameProject ? (0, $lClE6.SET_CP_RELEASE) : (0, $lClE6.SET_RELEASE);
        const dialog = hasCPRs && !isSameProject ? (0, $8rpuJ.default) : (0, $kI81z.default);
        return {
            type: action,
            label: (0, $ib5d3.default).releases,
            disabled: disabled,
            disabledTooltip: hasReleasesDisabled ? (0, $axaal.default).releaseDisabledMenuItemTooltip : (0, $axaal.default).releaseMenuItemTooltip,
            dialog: dialog,
            analyticsId: 'Release'
        };
    },
    setSprint: ({ selectedIssues: selectedIssues })=>{
        const disabled = $76e7f4b07fb5ff70$export$f9c983cc2430c4f3(selectedIssues);
        return {
            type: (0, $lClE6.SET_SPRINT),
            label: (0, $axaal.default).setSprint,
            disabled: disabled,
            disabledTooltip: (0, $axaal.default).sprintMenuItemTooltip,
            dialog: (0, $4ugWW.default),
            analyticsId: 'Sprint'
        };
    },
    setTeam: ({ selectedIssues: selectedIssues })=>{
        const disabled = $76e7f4b07fb5ff70$export$f9c983cc2430c4f3(selectedIssues);
        return {
            type: (0, $lClE6.SET_TEAM),
            label: (0, $axaal.default).setTeam,
            disabled: disabled,
            disabledTooltip: (0, $axaal.default).teamMenuItemTooltip,
            dialog: (0, $e72nm.default),
            analyticsId: 'Team'
        };
    },
    // Other actions
    bulkChange: ({ selectedIssues: selectedIssues })=>{
        const disabled = $76e7f4b07fb5ff70$export$e8b24162d7fa01b5(selectedIssues) || $76e7f4b07fb5ff70$export$53f3d8e656ab0334(selectedIssues);
        const disabledTooltip = $76e7f4b07fb5ff70$export$e8b24162d7fa01b5(selectedIssues) ? (0, $axaal.default).issueLimitExceededTooltip : (0, $axaal.default).bulkChangeInJiraTooltip;
        return {
            type: (0, $lClE6.BULK_CHANGE),
            label: (0, $axaal.default).bulkChange,
            disabled: disabled,
            disabledTooltip: disabledTooltip,
            analyticsId: 'Bulk-change-in-Jira'
        };
    },
    removeFromPlanTitle: ()=>({
            type: (0, $lClE6.REMOVE_FROM_PLAN),
            label: (0, $axaal.default).removeFromPlanTitle,
            dialog: (0, $ej82X.default),
            analyticsId: 'Remove-from-plan'
        })
};

});
parcelRegister("ej82X", function(module, exports) {

$parcel$export(module.exports, "default", () => $835a3f1d930ec5d4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5RNvf = parcelRequire("5RNvf");

var $9q8KC = parcelRequire("9q8KC");
var $835a3f1d930ec5d4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $5RNvf.mapDispatchToProps))((0, $9q8KC.default));

});
parcelRegister("5RNvf", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToProps", () => $ad4b256003b33da4$export$9e6a17cf56877796);

var $1Szmp = parcelRequire("1Szmp");
const $ad4b256003b33da4$export$9e6a17cf56877796 = {
    removeFromPlan: (0, $1Szmp.removeSelectedIssues)
};

});

parcelRegister("9q8KC", function(module, exports) {

$parcel$export(module.exports, "default", () => $693ffbbb51bd27aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $NeuAT = parcelRequire("NeuAT");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $lFLge = parcelRequire("lFLge");

var $kJlBc = parcelRequire("kJlBc");

var $kKnzs = parcelRequire("kKnzs");
const $693ffbbb51bd27aa$var$RemoveIssuesDialog = ({ toggleModalDialog: toggleModalDialog, bulkActionSuccess: bulkActionSuccess, removeFromPlan: removeFromPlan })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClickRemovedIssue = ()=>{
        const planId = (0, $NeuAT.getPlanId)();
        const scenarioId = (0, $NeuAT.getScenarioId)();
        if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) push((0, $lFLge.buildRemoveIssuePath)(planId, scenarioId));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        shouldScrollInViewport: true,
        onClose: toggleModalDialog,
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, formatMessage((0, $kKnzs.default).removeFromPlanTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $kKnzs.default).removeIssueFromPlanMessage,
        values: {
            removedIssuesPageLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                onClick: onClickRemovedIssue,
                appearance: "link",
                spacing: "none"
            }, formatMessage((0, $kKnzs.default).removedIssueSettingsLinkMessage))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: toggleModalDialog
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            removeFromPlan();
            bulkActionSuccess(analyticsEvent);
        }
    }, formatMessage((0, $kKnzs.default).removeFromPlanActionButton))));
};
var $693ffbbb51bd27aa$export$2e2bcd8739ae039 = $693ffbbb51bd27aa$var$RemoveIssuesDialog;

});
parcelRegister("kKnzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b76d3d822ae2fce7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b76d3d822ae2fce7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeFromPlanTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-from-plan-title",
        "defaultMessage": "Remove from plan"
    },
    removeFromPlanActionButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-from-plan-action-button",
        "defaultMessage": "Remove"
    },
    removeIssueFromPlanMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.remove-issue-from-plan-message",
        "defaultMessage": "Issues saved in Jira will be removed from the plan, but can be re-included on {removedIssuesPageLink}. Unsaved issues will be permanently deleted."
    },
    removedIssueSettingsLinkMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.remove-issues.removed-issue-settings-link-message",
        "defaultMessage": "Removed issues"
    }
});

});



parcelRegister("dKihG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b2ae400f77092dc$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8FTRf = parcelRequire("8FTRf");

var $9x62j = parcelRequire("9x62j");

var $iIPG8 = parcelRequire("iIPG8");
var $2b2ae400f77092dc$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9x62j.default), (0, $8FTRf.default))((0, $iIPG8.default));

});
parcelRegister("8FTRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $07bbc4640888088f$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07bbc4640888088f$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("9x62j", function(module, exports) {

$parcel$export(module.exports, "default", () => $addaf861739267d8$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");

var $kwMvv = parcelRequire("kwMvv");

var $iK4oF = parcelRequire("iK4oF");
var $addaf861739267d8$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    assignees: (0, $6VhAf.getAssigneeList),
    assigneesById: (0, $6VhAf.getAssigneesById)
});

});

parcelRegister("iIPG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $763ed34564cdc075$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $2OeF9 = parcelRequire("2OeF9");
// eslint-disable-next-line jira/react/no-class-components
class $763ed34564cdc075$var$SetAssigneeDialog extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
        const { currentValue: currentValue, avatarIcon: avatarIcon } = this.getCurrentValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $2OeF9.default).setHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.SET_ASSIGNEE),
            currentValue: currentValue,
            avatarIcon: avatarIcon,
            onCancel: toggleModalDialog,
            onSubmit: (formData, analyticsEvent)=>{
                bulkUpdateAttribute(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { selectedIssues: selectedIssues, assigneesById: assigneesById, intl: { formatMessage: formatMessage } } = this.props;
            const firstValue = selectedIssues[0].assignee;
            const isSameValue = !selectedIssues.some((issue)=>!$5OdRK.default(issue.assignee, firstValue));
            if (isSameValue && !firstValue) return {
                currentValue: formatMessage((0, $ib5d3.default).none)
            };
            if (isSameValue && firstValue) {
                const person = assigneesById[firstValue];
                return {
                    currentValue: person.jiraUser.title,
                    avatarIcon: person.jiraUser.avatarUrl
                };
            }
            return {
                currentValue: formatMessage((0, $2OeF9.default).variousValues)
            };
        };
    }
}
var $763ed34564cdc075$export$2e2bcd8739ae039 = (0, $2qhQi.default)($763ed34564cdc075$var$SetAssigneeDialog);

});
parcelRegister("2OeF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d293ee227a966d70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d293ee227a966d70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee.set-header",
        "defaultMessage": "Update assignee"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-assignee.various-values",
        "defaultMessage": "Various assignees"
    }
});

});



parcelRegister("8rpuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e96e05828302474$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7gMUm = parcelRequire("7gMUm");

var $iU0Pk = parcelRequire("iU0Pk");

var $jOnyp = parcelRequire("jOnyp");
var $9e96e05828302474$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iU0Pk.default), (0, $7gMUm.default))((0, $jOnyp.default));

});
parcelRegister("7gMUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9512fcd26efaf0a4$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
const $9512fcd26efaf0a4$var$mapDispatchToProps = (dispatch)=>({
        bulkIssuesCRPUpdate: (cprId)=>{
            dispatch((0, $1Szmp.bulkIssuesCRPUpdate)(cprId));
        },
        bulkUnsetVersion: ()=>{
            dispatch((0, $1Szmp.bulkIssuesUpdate)({
                fixVersions: []
            }));
        }
    });
var $9512fcd26efaf0a4$export$2e2bcd8739ae039 = $9512fcd26efaf0a4$var$mapDispatchToProps;

});

parcelRegister("iU0Pk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc2d4c237502781$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $kwMvv = parcelRequire("kwMvv");

var $iK4oF = parcelRequire("iK4oF");
var $3dc2d4c237502781$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    crossProjectVersionsById: (0, $2Ruxt.getCrossProjectVersionsById),
    cpVersionsForSelectedIssues: (0, $kwMvv.getCPRsForSelectedIssues)
});

});

parcelRegister("jOnyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8aafeb7dcc40bc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $8XdMw = parcelRequire("8XdMw");
class $a8aafeb7dcc40bc7$export$be01101e4e6c427c extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkIssuesCRPUpdate: bulkIssuesCRPUpdate, bulkUnsetVersion: bulkUnsetVersion, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $8XdMw.default).setReleaseHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.SET_CP_RELEASE),
            options: this.getOptions(),
            currentValue: this.getCurrentValue(),
            onCancel: toggleModalDialog,
            onSubmit: ({ crossProjectVersion: crossProjectVersion }, analyticsEvent)=>{
                if (crossProjectVersion) bulkIssuesCRPUpdate(crossProjectVersion);
                else bulkUnsetVersion();
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { selectedIssues: selectedIssues, intl: { formatMessage: formatMessage } } = this.props;
            const isNoneValue = selectedIssues.every((issue)=>!issue.fixVersions || !issue.fixVersions.length);
            if (isNoneValue) return formatMessage((0, $ib5d3.default).none);
            return formatMessage((0, $8XdMw.default).variousValues);
        };
        this.getOptions = ()=>{
            const { cpVersionsForSelectedIssues: cpVersionsForSelectedIssues, crossProjectVersionsById: crossProjectVersionsById } = this.props;
            return cpVersionsForSelectedIssues.map((cprId)=>{
                const { id: id, name: name } = crossProjectVersionsById[cprId];
                return {
                    label: name,
                    value: id
                };
            });
        };
    }
}
var $a8aafeb7dcc40bc7$export$2e2bcd8739ae039 = (0, $2qhQi.default)($a8aafeb7dcc40bc7$export$be01101e4e6c427c);

});
parcelRegister("8XdMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e910b24eb55bc269$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e910b24eb55bc269$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setReleaseHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-cross-project-versions.set-release-header",
        "defaultMessage": "Update release"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-cross-project-versions.various-values",
        "defaultMessage": "Various releases"
    }
});

});



parcelRegister("iYPFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e3c012a002b614f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bcgFL = parcelRequire("bcgFL");

var $lve2e = parcelRequire("lve2e");

var $adf66 = parcelRequire("adf66");
var $4e3c012a002b614f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $lve2e.default), (0, $bcgFL.default))((0, $adf66.default));

});
parcelRegister("bcgFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eda3bff335c6217$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8eda3bff335c6217$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate),
    updateMultipleIssues: $1Szmp.updateMultipleIssues
};

});

parcelRegister("lve2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc0dca6ad3209cc$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");
var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $cbc0dca6ad3209cc$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    childrenByParent: (0, $aK3ri.getChildrenByParent),
    customFieldsById: (0, $kKj1m.getCustomFieldsById),
    dateConfiguration: (0, $75KhQ.getDateConfiguration),
    issueTypesById: (0, $lihml.getIssueTypesById),
    projectsById: (0, $ehEr2.getProjectsById),
    selectedIssues: (0, $kwMvv.getSelectedIssues)
});

});

parcelRegister("adf66", function(module, exports) {

$parcel$export(module.exports, "default", () => $31430e1fa06491a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $186Kt = parcelRequire("186Kt");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $4l6af = parcelRequire("4l6af");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $l2Sj2 = parcelRequire("l2Sj2");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $hiIej = parcelRequire("hiIej");
parcelRequire("6OvfP");
var $eOsHk = parcelRequire("eOsHk");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $6j8A8 = parcelRequire("6j8A8");

var $fI5oA = parcelRequire("fI5oA");

var $5jhaX = parcelRequire("5jhaX");

var $fDmg1 = parcelRequire("fDmg1");

var $71oi7 = parcelRequire("71oi7");
function $31430e1fa06491a7$export$2e2bcd8739ae039({ bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, childrenByParent: childrenByParent, customFieldsById: customFieldsById, dateConfiguration: dateConfiguration, issueTypesById: issueTypesById, projectsById: projectsById, selectedIssues: selectedIssues, toggleModalDialog: toggleModalDialog, updateMultipleIssues: updateMultipleIssues }) {
    const [startDateMethod, setStartDateMethod] = (0, $eUqFw.useState)((0, $fDmg1.KEEP_EXISTING));
    const [endDateMethod, setEndDateMethod] = (0, $eUqFw.useState)((0, $fDmg1.KEEP_EXISTING));
    const [fixedStartDate, setFixedStartDate] = (0, $eUqFw.useState)(undefined);
    const [fixedEndDate, setFixedEndDate] = (0, $eUqFw.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getPatchForSelectedIssues = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        [
            (0, $fDmg1.START_DATE),
            (0, $fDmg1.END_DATE)
        ].reduce((result, type)=>{
            const attribute = type === (0, $fDmg1.START_DATE) ? 'baselineStart' : 'baselineEnd';
            const updateDateMethod = type === (0, $fDmg1.START_DATE) ? startDateMethod : endDateMethod;
            switch(updateDateMethod){
                case 0, $fDmg1.CLEAR_DATE:
                    return Object.assign(result, {
                        [attribute]: null
                    });
                case 0, $fDmg1.SET_CUSTOM_DATE:
                    return Object.assign(result, {
                        [attribute]: type === (0, $fDmg1.START_DATE) ? fixedStartDate : fixedEndDate
                    });
                default:
                    return result;
            }
        }, {});
    const onSubmit = (_, analyticsEvent)=>{
        let modifiedIssues = selectedIssues;
        /**
     * This part handles cases such as CLEAR_DATE and SET_CUSTOM_DATE.
     */ const payload = getPatchForSelectedIssues();
        if (Object.keys(payload).length > 0) {
            bulkUpdateAttribute(payload);
            modifiedIssues = selectedIssues.map((issue)=>$01zCq.default(issue, payload));
        }
        /**
     * This part handles SET_BY_CHILD_DATES case.
     */ const rollUpDatesForSelectedIssues = (0, $71oi7.getRollUpDatesForSelectedIssues)(modifiedIssues, childrenByParent);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        const shouldPickTheDate = (_, key)=>key === 'baselineStart' && startDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES) || key === 'baselineEnd' && endDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES);
        updateMultipleIssues($cQGVO.default($186Kt.default(shouldPickTheDate), rollUpDatesForSelectedIssues));
        toggleModalDialog();
        bulkActionSuccess(analyticsEvent);
    };
    const getCurrentValue = (type)=>{
        const attribute = type === (0, $fDmg1.START_DATE) ? 'baselineStart' : 'baselineEnd';
        const firstValue = selectedIssues[0][attribute];
        const isSameValue = selectedIssues.every((issue)=>$5OdRK.default(issue[attribute], firstValue));
        if (isSameValue && !firstValue) return formatMessage((0, $ib5d3.default).none);
        if (isSameValue && firstValue) return (0, $l2Sj2.formatDateUTC)(firstValue, (0, $eTbtL.DefaultDateFormat));
        return formatMessage((0, $fI5oA.default).variousValues);
    };
    const getDateFieldTitle = (type)=>{
        const dateField = type === (0, $fDmg1.START_DATE) ? dateConfiguration.baselineStartField : dateConfiguration.baselineEndField;
        // if the date is a custom field, we get its title
        if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM) {
            const customField = customFieldsById[dateField.key];
            if (customField) return customField.title;
            return '';
        }
        // if the date is a built-in field, we get its translated message
        switch(dateField.key){
            case 0, $eOsHk.DUE_DATE:
                return formatMessage((0, $ib5d3.default).dueDate);
            case 0, $eOsHk.TARGET_START_FIELD:
                return formatMessage((0, $ib5d3.default).targetStart);
            case 0, $eOsHk.TARGET_END_FIELD:
                return formatMessage((0, $ib5d3.default).targetEnd);
            default:
                return '';
        }
    };
    const updateDateOptions = (0, $fDmg1.UPDATE_DATE_OPTIONS).map((option)=>({
            isDisabled: false,
            label: formatMessage((0, $fI5oA.default)[option]),
            name: option,
            value: option
        }));
    const formatDatePickerValue = (date)=>{
        if (date) return (0, $l2Sj2.formatDateUTC)(date, (0, $eTbtL.IsoDateFormat));
        return undefined;
    };
    const lastEndDate = (0, $71oi7.getDateForValidation)(selectedIssues, true);
    const isInvalidDateStartBeforeEnd = endDateMethod !== (0, $fDmg1.SET_CUSTOM_DATE) && (0, $7CnHa.isDefined)(fixedStartDate) && (0, $7CnHa.isDefined)(lastEndDate) && fixedStartDate > lastEndDate || endDateMethod === (0, $fDmg1.SET_CUSTOM_DATE) && (0, $7CnHa.isDefined)(fixedStartDate) && (0, $7CnHa.isDefined)(fixedEndDate) && fixedStartDate > fixedEndDate;
    const earliestStartDate = (0, $71oi7.getDateForValidation)(selectedIssues, false);
    const isInvalidDateEndAfterStart = startDateMethod !== (0, $fDmg1.SET_CUSTOM_DATE) && (0, $7CnHa.isDefined)(earliestStartDate) && (0, $7CnHa.isDefined)(fixedEndDate) && fixedEndDate < earliestStartDate || startDateMethod === (0, $fDmg1.SET_CUSTOM_DATE) && (0, $7CnHa.isDefined)(fixedStartDate) && (0, $7CnHa.isDefined)(fixedEndDate) && fixedEndDate < fixedStartDate;
    const renderCustomDateFieldErrorMessage = (dateType)=>{
        if (dateType === (0, $fDmg1.START_DATE) && isInvalidDateStartBeforeEnd) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $ib5d3.default).invalidDateStartBeforeEnd));
        if (dateType === (0, $fDmg1.END_DATE) && isInvalidDateEndAfterStart) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $ib5d3.default).invalidDateEndAfterStart));
        return null;
    };
    const renderDateSection = (dateType)=>{
        const dateFieldTitles = {
            baselineStartField: getDateFieldTitle((0, $fDmg1.START_DATE)),
            baselineEndField: getDateFieldTitle((0, $fDmg1.END_DATE))
        };
        const currentDatesValues = {
            baselineStartField: getCurrentValue((0, $fDmg1.START_DATE)),
            baselineEndField: getCurrentValue((0, $fDmg1.END_DATE))
        };
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: dateType === (0, $fDmg1.START_DATE) ? $5jhaX.startDate : $5jhaX.endDate,
            key: dateType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $5jhaX.dateTitle,
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.date-title-${dateType}`
        }, dateFieldTitles[dateType]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.values
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.currentValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.valueTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.title
        }, formatMessage((0, $ib5d3.default).current)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.arrow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: "",
            primaryColor: `var(--ds-background-neutral-bold, ${(0, $g4Vkx.default).N500})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.current-value-${dateType}`
        }, currentDatesValues[dateType])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.newValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.valueTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.title
        }, formatMessage((0, $ib5d3.default).new))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5jhaX.newValueForm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: `${dateType}Method`
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
                ...fieldProps,
                defaultValue: (0, $fDmg1.KEEP_EXISTING),
                onChange: (evt)=>{
                    if (dateType === (0, $fDmg1.START_DATE)) setStartDateMethod(evt.target.value);
                    else setEndDateMethod(evt.target.value);
                },
                options: updateDateOptions,
                value: dateType === (0, $fDmg1.START_DATE) ? startDateMethod : endDateMethod
            })), (dateType === (0, $fDmg1.START_DATE) && startDateMethod === (0, $fDmg1.SET_CUSTOM_DATE) || dateType === (0, $fDmg1.END_DATE) && endDateMethod === (0, $fDmg1.SET_CUSTOM_DATE)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: `fixed${dateType}`
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4l6af.default), {
                ...fieldProps,
                isInvalid: dateType === (0, $fDmg1.START_DATE) ? isInvalidDateStartBeforeEnd : isInvalidDateEndAfterStart,
                isTransparentBackground: false,
                onChange: (date)=>{
                    if (dateType === (0, $fDmg1.START_DATE)) setFixedStartDate(date ? (0, $17L5s.startOfUtcDay)(date) : undefined);
                    else setFixedEndDate(date ? (0, $17L5s.endOfUtcDay)(date) : undefined);
                },
                placeholder: formatMessage((0, $fI5oA.default).datePlaceholder, {
                    date: formatTimestamp(Date.now())
                }),
                showClearIndicator: true,
                value: formatDatePickerValue(dateType === (0, $fDmg1.START_DATE) ? fixedStartDate : fixedEndDate)
            })), renderCustomDateFieldErrorMessage(dateType)))))));
    };
    // when the user selects the "Set by child issue dates" option for the new start or end date, some magic will happen behind the scene, resulting
    // in potential changes to the dates of the parent issues, therefore we display an information message to prevent users to enter into PANIC mode.
    const renderInfoMessage = ()=>{
        if (startDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES) || endDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES)) {
            let modifiedIssues = selectedIssues;
            const payload = getPatchForSelectedIssues();
            if (Object.keys(payload).length > 0) modifiedIssues = selectedIssues.map((issue)=>$01zCq.default(issue, payload));
            const rollUpDatesForSelectedIssues = (0, $71oi7.getRollUpDatesForSelectedIssues)(modifiedIssues, childrenByParent);
            const issuesWithoutDates = selectedIssues.filter(({ id: id })=>(0, $7CnHa.isDefined)(rollUpDatesForSelectedIssues[id]) && (startDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES) && !(0, $7CnHa.isDefined)(rollUpDatesForSelectedIssues[id].baselineStart) || endDateMethod === (0, $fDmg1.SET_BY_CHILD_DATES) && !(0, $7CnHa.isDefined)(rollUpDatesForSelectedIssues[id].baselineEnd)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6j8A8.default), {
                issuesWithoutDates: issuesWithoutDates,
                issueTypesById: issueTypesById,
                projectsById: projectsById,
                isDefaultFlyoutOpen: false
            });
        }
        return null;
    };
    const isFormInValid = ()=>{
        if (startDateMethod === (0, $fDmg1.KEEP_EXISTING) && endDateMethod === (0, $fDmg1.KEEP_EXISTING)) return true;
        if (startDateMethod === (0, $fDmg1.SET_CUSTOM_DATE) && (!(0, $7CnHa.isDefined)(fixedStartDate) || isInvalidDateStartBeforeEnd)) return true;
        if (endDateMethod === (0, $fDmg1.SET_CUSTOM_DATE) && (!(0, $7CnHa.isDefined)(fixedEndDate) || isInvalidDateEndAfterStart)) return true;
        return false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: false,
        onClose: toggleModalDialog,
        shouldScrollInViewport: true,
        width: "large",
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $fI5oA.default).header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5jhaX.content
    }, [
        (0, $fDmg1.START_DATE),
        (0, $fDmg1.END_DATE)
    ].map((type)=>renderDateSection(type))), renderInfoMessage()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: toggleModalDialog
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        isDisabled: isFormInValid(),
        onClick: onSubmit
    }, formatMessage((0, $ib5d3.default).apply))));
}

});
parcelRegister("hiIej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2025a66c6553d911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $hnuwz = parcelRequire("hnuwz");
const $2025a66c6553d911$var$noOptions = [];
function $2025a66c6553d911$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $2025a66c6553d911$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $5Q9wj.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $eUqFw.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");
const $306a59ce4e6b6146$var$packageName = undefined;
const $306a59ce4e6b6146$var$packageVersion = undefined;
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $PdmhA.N30)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $PdmhA.B50)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});


parcelRegister("6j8A8", function(module, exports) {

$parcel$export(module.exports, "default", () => $663b483af9f4b0f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $je5kZ = parcelRequire("je5kZ");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bKxX9 = parcelRequire("bKxX9");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $eNhh9 = parcelRequire("eNhh9");
var $lRvnl = parcelRequire("lRvnl");

var $hl4M2 = parcelRequire("hl4M2");

var $ib5d3 = parcelRequire("ib5d3");

var $2TIcS = parcelRequire("2TIcS");

var $by9wc = parcelRequire("by9wc");
// eslint-disable-next-line jira/react/no-class-components
class $663b483af9f4b0f5$var$InfoMessage extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // using for story
            isDefaultFlyoutOpen: false
        };
    }
    render() {
        const { issuesWithoutDates: issuesWithoutDates } = this.props;
        return issuesWithoutDates.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            appearance: "information",
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2TIcS.default).infoMessageBeforeLink), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $2TIcS.default).infoMessageAfterLink,
            values: {
                issuesWithoutDates: this.renderInlineDialog()
            }
        })) : null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isFlyoutOpen: this.props.isDefaultFlyoutOpen
        };
        this.toggleFlyout = ()=>{
            this.setState((state)=>({
                    isFlyoutOpen: !state.isFlyoutOpen
                }));
        };
        this.closeFlyout = ()=>{
            this.setState(()=>({
                    isFlyoutOpen: false
                }));
        };
        this.issueOptionRenderer = (issue, i)=>{
            const { projectsById: projectsById, issueTypesById: issueTypesById } = this.props;
            const projectKey = issue.project && projectsById[issue.project] && projectsById[issue.project].key || '';
            const issueTypeIconUrl = issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $by9wc["issue-option-wrapper"],
                key: `${i}-option`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $by9wc["issue-type-icon"],
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    backgroundSize: 'contain',
                    backgroundImage: `url(${issueTypeIconUrl})`
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $by9wc.link
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
                issueKey: issue.issueKey,
                projectKey: projectKey
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $by9wc["issue-label"],
                title: issue.summary
            }, issue.summary)));
        };
        this.renderFlyout = (issues)=>{
            const { intl: intl } = this.props;
            if ((0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.remove-barrel-exports')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $663b483af9f4b0f5$var$flyoutStyles,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.div"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
                block: "space.100",
                inline: "space.200",
                xcss: $663b483af9f4b0f5$var$closeFlyoutStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "subtle-link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                    label: "",
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.editor-close-icon",
                    primaryColor: `var(--ds-text-subtle, ${(0, $g4Vkx.default).N200})`
                }),
                onClick: ()=>this.closeFlyout(),
                spacing: "none",
                "aria-label": intl.formatMessage((0, $ib5d3.default).close)
            })), issues.map(this.issueOptionRenderer));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $by9wc.flyout,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.flyout"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $by9wc["close-icon"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                label: "",
                // @ts-expect-error - TS2769 - No overload matches this call.
                // This component type has no onClick prop
                onClick: ()=>this.closeFlyout(),
                primaryColor: `var(--ds-text-subtle, ${(0, $g4Vkx.default).N200})`,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.editor-close-icon"
            })), issues.map(this.issueOptionRenderer));
        };
        this.renderInlineDialog = ()=>{
            const { intl: intl, issuesWithoutDates: issuesWithoutDates } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $by9wc["inline-dialog-container"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                content: this.renderFlyout(issuesWithoutDates),
                isOpen: this.state.isFlyoutOpen,
                placement: "bottom",
                noHorizontalScroll: true,
                classNames: "inline-dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>this.toggleFlyout(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.button"
            }, intl.formatMessage((0, $2TIcS.default).linkLabel, {
                issueCount: issuesWithoutDates.length
            })))));
        };
    }
}
var $663b483af9f4b0f5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($663b483af9f4b0f5$var$InfoMessage);
const $663b483af9f4b0f5$var$flyoutStyles = (0, $1ZAYh.xcss)({
    maxWidth: '480px',
    position: 'relative',
    paddingTop: 'space.100',
    paddingRight: 'space.150',
    paddingBottom: 'space.050',
    paddingLeft: '0'
});
const $663b483af9f4b0f5$var$closeFlyoutStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '0',
    right: '0'
});

});
parcelRegister("2TIcS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62c22f43aee6aff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f62c22f43aee6aff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    infoMessageBeforeLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message-before-link",
        "defaultMessage": "To best represent child issues without start or end dates, "
    },
    linkLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.link-label",
        "defaultMessage": "{issueCount, plural, one {# parent issue} other {# parent issues}}"
    },
    infoMessageAfterLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.info-message.info-message-after-link",
        "defaultMessage": "{issuesWithoutDates} will have their start or end dates removed."
    }
});

});

parcelRegister("by9wc", function(module, exports) {

$parcel$export(module.exports, "close-icon", () => $868a40d0fbe758f1$export$2e29e128697799d1, (v) => $868a40d0fbe758f1$export$2e29e128697799d1 = v);
$parcel$export(module.exports, "flyout", () => $868a40d0fbe758f1$export$ec4922be16378791, (v) => $868a40d0fbe758f1$export$ec4922be16378791 = v);
$parcel$export(module.exports, "inline-dialog-container", () => $868a40d0fbe758f1$export$ac9bfbba4987a017, (v) => $868a40d0fbe758f1$export$ac9bfbba4987a017 = v);
$parcel$export(module.exports, "issue-label", () => $868a40d0fbe758f1$export$8dbc59d0fe020d7e, (v) => $868a40d0fbe758f1$export$8dbc59d0fe020d7e = v);
$parcel$export(module.exports, "issue-option-wrapper", () => $868a40d0fbe758f1$export$2916d4d56de3dd7, (v) => $868a40d0fbe758f1$export$2916d4d56de3dd7 = v);
$parcel$export(module.exports, "issue-type-icon", () => $868a40d0fbe758f1$export$175e354db6e532ed, (v) => $868a40d0fbe758f1$export$175e354db6e532ed = v);
$parcel$export(module.exports, "link", () => $868a40d0fbe758f1$export$9c30223ca0a664fb, (v) => $868a40d0fbe758f1$export$9c30223ca0a664fb = v);
var $868a40d0fbe758f1$export$2e29e128697799d1;
var $868a40d0fbe758f1$export$ec4922be16378791;
var $868a40d0fbe758f1$export$ac9bfbba4987a017;
var $868a40d0fbe758f1$export$8dbc59d0fe020d7e;
var $868a40d0fbe758f1$export$2916d4d56de3dd7;
var $868a40d0fbe758f1$export$175e354db6e532ed;
var $868a40d0fbe758f1$export$9c30223ca0a664fb;
$868a40d0fbe758f1$export$2e29e128697799d1 = `_3aDJ6G_close-icon`;
$868a40d0fbe758f1$export$ec4922be16378791 = `_3aDJ6G_flyout`;
$868a40d0fbe758f1$export$ac9bfbba4987a017 = `_3aDJ6G_inline-dialog-container`;
$868a40d0fbe758f1$export$8dbc59d0fe020d7e = `_3aDJ6G_issue-label`;
$868a40d0fbe758f1$export$2916d4d56de3dd7 = `_3aDJ6G_issue-option-wrapper`;
$868a40d0fbe758f1$export$175e354db6e532ed = `_3aDJ6G_issue-type-icon`;
$868a40d0fbe758f1$export$9c30223ca0a664fb = `_3aDJ6G_link`;

});


parcelRegister("fI5oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d8a3d961c08f99$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34d8a3d961c08f99$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.header",
        "defaultMessage": "Update dates"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.various-values",
        "defaultMessage": "Various dates"
    },
    datePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-date.date-placeholder",
        "defaultMessage": "e.g. {date}"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ KEEP_EXISTING: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.keep-existing",
        "defaultMessage": "Keep existing"
    },
    CLEAR_DATE: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.clear-date",
        "defaultMessage": "Clear date"
    },
    SET_BY_CHILD_DATES: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.set-by-child-dates",
        "defaultMessage": "Set by child issue dates"
    },
    SET_CUSTOM_DATE: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-date-dialog.set-custom-date",
        "defaultMessage": "Set custom date"
    }
});

});

parcelRegister("5jhaX", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $3ddc0cd7cfaaa64e$export$f2120bbfa5450bd2, (v) => $3ddc0cd7cfaaa64e$export$f2120bbfa5450bd2 = v);
$parcel$export(module.exports, "content", () => $3ddc0cd7cfaaa64e$export$a7db06668cad9adb, (v) => $3ddc0cd7cfaaa64e$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "currentValue", () => $3ddc0cd7cfaaa64e$export$6cd4326f683953cc, (v) => $3ddc0cd7cfaaa64e$export$6cd4326f683953cc = v);
$parcel$export(module.exports, "dateTitle", () => $3ddc0cd7cfaaa64e$export$758b62fe1adf6ec5, (v) => $3ddc0cd7cfaaa64e$export$758b62fe1adf6ec5 = v);
$parcel$export(module.exports, "endDate", () => $3ddc0cd7cfaaa64e$export$910e497d4a89534b, (v) => $3ddc0cd7cfaaa64e$export$910e497d4a89534b = v);
$parcel$export(module.exports, "newValue", () => $3ddc0cd7cfaaa64e$export$3531a5b004bf3835, (v) => $3ddc0cd7cfaaa64e$export$3531a5b004bf3835 = v);
$parcel$export(module.exports, "newValueForm", () => $3ddc0cd7cfaaa64e$export$c87aa84947c653c7, (v) => $3ddc0cd7cfaaa64e$export$c87aa84947c653c7 = v);
$parcel$export(module.exports, "startDate", () => $3ddc0cd7cfaaa64e$export$9ffe627750d78daf, (v) => $3ddc0cd7cfaaa64e$export$9ffe627750d78daf = v);
$parcel$export(module.exports, "title", () => $3ddc0cd7cfaaa64e$export$fb184b623420d9be, (v) => $3ddc0cd7cfaaa64e$export$fb184b623420d9be = v);
$parcel$export(module.exports, "valueTitle", () => $3ddc0cd7cfaaa64e$export$9a3ba09e6b9fd40c, (v) => $3ddc0cd7cfaaa64e$export$9a3ba09e6b9fd40c = v);
$parcel$export(module.exports, "values", () => $3ddc0cd7cfaaa64e$export$68c286be0e7e55b7, (v) => $3ddc0cd7cfaaa64e$export$68c286be0e7e55b7 = v);
var $3ddc0cd7cfaaa64e$export$f2120bbfa5450bd2;
var $3ddc0cd7cfaaa64e$export$a7db06668cad9adb;
var $3ddc0cd7cfaaa64e$export$6cd4326f683953cc;
var $3ddc0cd7cfaaa64e$export$758b62fe1adf6ec5;
var $3ddc0cd7cfaaa64e$export$910e497d4a89534b;
var $3ddc0cd7cfaaa64e$export$3531a5b004bf3835;
var $3ddc0cd7cfaaa64e$export$c87aa84947c653c7;
var $3ddc0cd7cfaaa64e$export$9ffe627750d78daf;
var $3ddc0cd7cfaaa64e$export$fb184b623420d9be;
var $3ddc0cd7cfaaa64e$export$9a3ba09e6b9fd40c;
var $3ddc0cd7cfaaa64e$export$68c286be0e7e55b7;
$3ddc0cd7cfaaa64e$export$f2120bbfa5450bd2 = `seqU5a_arrow`;
$3ddc0cd7cfaaa64e$export$a7db06668cad9adb = `seqU5a_content`;
$3ddc0cd7cfaaa64e$export$6cd4326f683953cc = `seqU5a_currentValue`;
$3ddc0cd7cfaaa64e$export$758b62fe1adf6ec5 = `seqU5a_dateTitle`;
$3ddc0cd7cfaaa64e$export$910e497d4a89534b = `seqU5a_endDate`;
$3ddc0cd7cfaaa64e$export$3531a5b004bf3835 = `seqU5a_newValue`;
$3ddc0cd7cfaaa64e$export$c87aa84947c653c7 = `seqU5a_newValueForm`;
$3ddc0cd7cfaaa64e$export$9ffe627750d78daf = `seqU5a_startDate`;
$3ddc0cd7cfaaa64e$export$fb184b623420d9be = `seqU5a_title`;
$3ddc0cd7cfaaa64e$export$9a3ba09e6b9fd40c = `seqU5a_valueTitle`;
$3ddc0cd7cfaaa64e$export$68c286be0e7e55b7 = `seqU5a_values`;

});

parcelRegister("fDmg1", function(module, exports) {

$parcel$export(module.exports, "START_DATE", () => $cc699ed8f10ebeb5$export$99a467bcc22b8df9);
$parcel$export(module.exports, "END_DATE", () => $cc699ed8f10ebeb5$export$1113b91e67d28ba7);
$parcel$export(module.exports, "KEEP_EXISTING", () => $cc699ed8f10ebeb5$export$25010883706272c4);
$parcel$export(module.exports, "CLEAR_DATE", () => $cc699ed8f10ebeb5$export$a8b9780b032af666);
$parcel$export(module.exports, "SET_BY_CHILD_DATES", () => $cc699ed8f10ebeb5$export$cd232fea22992ba9);
$parcel$export(module.exports, "SET_CUSTOM_DATE", () => $cc699ed8f10ebeb5$export$20b490592af2cd4d);
$parcel$export(module.exports, "UPDATE_DATE_OPTIONS", () => $cc699ed8f10ebeb5$export$1b5bd757c52df144);
const $cc699ed8f10ebeb5$export$99a467bcc22b8df9 = 'baselineStartField';
const $cc699ed8f10ebeb5$export$1113b91e67d28ba7 = 'baselineEndField';
const $cc699ed8f10ebeb5$export$25010883706272c4 = 'KEEP_EXISTING';
const $cc699ed8f10ebeb5$export$a8b9780b032af666 = 'CLEAR_DATE';
const $cc699ed8f10ebeb5$export$cd232fea22992ba9 = 'SET_BY_CHILD_DATES';
const $cc699ed8f10ebeb5$export$20b490592af2cd4d = 'SET_CUSTOM_DATE';
const $cc699ed8f10ebeb5$export$1b5bd757c52df144 = [
    $cc699ed8f10ebeb5$export$25010883706272c4,
    $cc699ed8f10ebeb5$export$a8b9780b032af666,
    $cc699ed8f10ebeb5$export$cd232fea22992ba9,
    $cc699ed8f10ebeb5$export$20b490592af2cd4d
];

});

parcelRegister("71oi7", function(module, exports) {

$parcel$export(module.exports, "getRollUpDatesForSelectedIssues", () => $4eecc5febf434353$export$d9d5735e1ab2729d);
$parcel$export(module.exports, "getDateForValidation", () => $4eecc5febf434353$export$bfe614e9974574bf);

var $2wtN3 = parcelRequire("2wtN3");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");

var $1ybV0 = parcelRequire("1ybV0");

var $dlGXX = parcelRequire("dlGXX");

var $7CnHa = parcelRequire("7CnHa");
const $4eecc5febf434353$export$d9d5735e1ab2729d = (selectedIssues, childrenByParent)=>{
    const selectedIssuesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), selectedIssues);
    const childrenOfSelectedIssues = selectedIssues.flatMap(({ id: id })=>childrenByParent[id] || []);
    if ((0, $1ybV0.ff)('portfolio-3-no-param-reassign-fix_topgz')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        childrenOfSelectedIssues.forEach(({ id: id, parent: parent, baselineStart: issueBaselineStart, baselineEnd: issueBaselineEnd })=>{
            /**
				 * If the one of the children of the parent is selected for the bulk update and we
				 * have configured one of the dates to be updated then we need to consider the updated
				 * dates of the children while calculating rolled up dates for the parent.
				 * Example: If parent and child both are selected and child doesn't have a start date.
				 * Now we configure "Set by child dates" for the start date and "Clear date" for
				 * end date. So if the end date of the child is cleared, it will not participate in
				 * rolling up date as it will not have both the dates after we bulk update. Hence to
				 * align with the end result, we need to consider updated dates for the children.
				 */ const child = selectedIssuesById[id];
            const dates = {
                baselineStart: (0, $7CnHa.isDefined)(child) ? child.baselineStart : issueBaselineStart,
                baselineEnd: (0, $7CnHa.isDefined)(child) ? child.baselineEnd : issueBaselineEnd
            };
            if (!(0, $7CnHa.isDefined)(dates.baselineStart) && !(0, $7CnHa.isDefined)(dates.baselineEnd)) return result;
            if (parent) {
                if (!(0, $7CnHa.isDefined)(result[parent])) {
                    result[parent] = {
                        baselineStart: $2wtN3.default(null, dates.baselineStart),
                        baselineEnd: $2wtN3.default(null, dates.baselineEnd)
                    };
                    return result;
                }
                [
                    'baselineStart',
                    'baselineEnd'
                ].forEach((dateType)=>{
                    /**
						 * Once we get a child without a date, we don't need to calculate roll-up date
						 * as the rolled up value for the parent will be null then after. Hence we are
						 * calculating roll-up date only when previous roll-up value is not null.
						 */ if ((0, $7CnHa.isDefined)($kjklK.default([
                        parent,
                        dateType
                    ], result))) {
                        if (!(0, $7CnHa.isDefined)(dates[dateType])) result[parent][dateType] = null;
                        else {
                            const fn = dateType === 'baselineStart' ? Math.min : Math.max;
                            result[parent][dateType] = fn(result[parent][dateType], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            dates[dateType]);
                        }
                    }
                });
            }
            return result;
        });
        return result;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return childrenOfSelectedIssues.reduce((rollUpDatesForSelectedIssues, { id: id, parent: parent, baselineStart: issueBaselineStart, baselineEnd: issueBaselineEnd })=>{
        /**
			 * If the one of the children of the parent is selected for the bulk update and we
			 * have configured one of the dates to be updated then we need to consider the updated
			 * dates of the children while calculating rolled up dates for the parent.
			 * Example: If parent and child both are selected and child doesn't have a start date.
			 * Now we configure "Set by child dates" for the start date and "Clear date" for
			 * end date. So if the end date of the child is cleared, it will not participate in
			 * rolling up date as it will not have both the dates after we bulk update. Hence to
			 * align with the end result, we need to consider updated dates for the children.
			 */ const child = selectedIssuesById[id];
        const dates = {
            baselineStart: (0, $7CnHa.isDefined)(child) ? child.baselineStart : issueBaselineStart,
            baselineEnd: (0, $7CnHa.isDefined)(child) ? child.baselineEnd : issueBaselineEnd
        };
        if (!(0, $7CnHa.isDefined)(dates.baselineStart) && !(0, $7CnHa.isDefined)(dates.baselineEnd)) return rollUpDatesForSelectedIssues;
        if (parent) {
            if (!(0, $7CnHa.isDefined)(rollUpDatesForSelectedIssues[parent])) {
                // eslint-disable-next-line no-param-reassign
                rollUpDatesForSelectedIssues[parent] = {
                    baselineStart: $2wtN3.default(null, dates.baselineStart),
                    baselineEnd: $2wtN3.default(null, dates.baselineEnd)
                };
                return rollUpDatesForSelectedIssues;
            }
            [
                'baselineStart',
                'baselineEnd'
            ].forEach((dateType)=>{
                /**
					 * Once we get a child without a date, we don't need to calculate roll-up date
					 * as the rolled up value for the parent will be null then after. Hence we are
					 * calculating roll-up date only when previous roll-up value is not null.
					 */ if ((0, $7CnHa.isDefined)($kjklK.default([
                    parent,
                    dateType
                ], rollUpDatesForSelectedIssues))) {
                    if (!(0, $7CnHa.isDefined)(dates[dateType])) // eslint-disable-next-line no-param-reassign
                    rollUpDatesForSelectedIssues[parent][dateType] = null;
                    else {
                        const fn = dateType === 'baselineStart' ? Math.min : Math.max;
                        // eslint-disable-next-line no-param-reassign
                        rollUpDatesForSelectedIssues[parent][dateType] = fn(rollUpDatesForSelectedIssues[parent][dateType], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        dates[dateType]);
                    }
                }
            });
        }
        return rollUpDatesForSelectedIssues;
    }, {});
};
const $4eecc5febf434353$export$bfe614e9974574bf = (selectedIssues, isTargetStart)=>{
    let dateForValidation = null;
    if (isTargetStart) selectedIssues.forEach(({ baselineEnd: baselineEnd })=>{
        if (!(0, $7CnHa.isDefined)(dateForValidation) && (0, $7CnHa.isDefined)(baselineEnd)) dateForValidation = baselineEnd;
        else if ((0, $7CnHa.isDefined)(dateForValidation) && (0, $7CnHa.isDefined)(baselineEnd) && (0, $dlGXX.default)(dateForValidation, baselineEnd)) dateForValidation = baselineEnd;
    });
    else selectedIssues.forEach(({ baselineStart: baselineStart })=>{
        if (!(0, $7CnHa.isDefined)(dateForValidation) && (0, $7CnHa.isDefined)(baselineStart)) dateForValidation = baselineStart;
        else if ((0, $7CnHa.isDefined)(dateForValidation) && (0, $7CnHa.isDefined)(baselineStart) && (0, $dlGXX.default)(baselineStart, dateForValidation)) dateForValidation = baselineStart;
    });
    return dateForValidation;
};

});



parcelRegister("3pWsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $af78123cace2cb16$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6ZxNn = parcelRequire("6ZxNn");

var $cQl4L = parcelRequire("cQl4L");

var $6rUBa = parcelRequire("6rUBa");
var $af78123cace2cb16$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $cQl4L.default), (0, $6ZxNn.default))((0, $6rUBa.default));

});
parcelRegister("6ZxNn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0dbd4581e6cfe1$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f0dbd4581e6cfe1$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("cQl4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $383ff93f2fbc4959$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
var $383ff93f2fbc4959$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    plan: (0, $75KhQ.getPlan),
    workingHours: (0, $dhHiZ.getJiraHoursPerDay)
});

});

parcelRegister("6rUBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ad966007db6e6e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $aAyrO = parcelRequire("aAyrO");
var $6ETZE = parcelRequire("6ETZE");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $gwbfD = parcelRequire("gwbfD");

var $5fUv6 = parcelRequire("5fUv6");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $cKooL = parcelRequire("cKooL");

var $9B7Go = parcelRequire("9B7Go");
const $5ad966007db6e6e7$var$useCurrentValue = ({ selectedIssues: selectedIssues, planningUnit: planningUnit, workingHours: workingHours })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const firstValue = (0, $5fUv6.getEstimateValue)(planningUnit, selectedIssues[0], workingHours);
    const isSameValue = selectedIssues.every((issue)=>(0, $5fUv6.getEstimateValue)(planningUnit, issue, workingHours) === firstValue);
    return isSameValue ? firstValue?.toString(10) ?? formatMessage((0, $ib5d3.default).none) : formatMessage((0, $cKooL.default).variousValues);
};
const $5ad966007db6e6e7$var$withTooltip = (component, tooltip)=>tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip
    }, component) : component;
function $5ad966007db6e6e7$var$SetEstimateDialog({ bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, plan: { planningUnit: planningUnit }, selectedIssues: selectedIssues, toggleModalDialog: toggleModalDialog, workingHours: workingHours }) {
    const [estimate, setEstimate] = (0, $eUqFw.useState)('');
    const [showEstimateError, setShowEstimateError] = (0, $eUqFw.useState)(false);
    const [clearEstimates, setClearEstimates] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const currentValue = $5ad966007db6e6e7$var$useCurrentValue({
        planningUnit: planningUnit,
        selectedIssues: selectedIssues,
        workingHours: workingHours
    });
    const currentContent = $5ad966007db6e6e7$var$withTooltip(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go["value-placeholder"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go["current-value-title"]
    }, currentValue)), currentValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        onClose: toggleModalDialog,
        shouldScrollInViewport: true,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate",
        width: (0, $lClE6.MODAL_DIALOG_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $cKooL.default).setHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        className: $9B7Go["form-group"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go["current-value"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go["value-label"]
    }, formatMessage((0, $ib5d3.default).current)), currentContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go["new-value"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        isRequired: true,
        label: formatMessage((0, $cKooL.default).newEstimate, {
            planningUnit: formatMessage((0, $cKooL.default)[planningUnit])
        }),
        name: "estimate"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            autoFocus: true,
            isDisabled: clearEstimates,
            min: 0,
            onChange: (e)=>{
                const newValue = e.target.value;
                setShowEstimateError(Number(newValue) < 0);
                setEstimate(newValue);
            },
            type: "number",
            value: estimate
        }), showEstimateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $cKooL.default).outOfRange)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9B7Go.checkbox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        label: formatMessage((0, $cKooL.default).clearEstimates),
        onChange: (event)=>{
            setClearEstimates(event.target.checked);
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: toggleModalDialog
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        isDisabled: clearEstimates ? false : estimate === '' || Number(estimate) < 0,
        onClick: (_, analyticsEvent)=>{
            bulkUpdateAttribute({
                estimate: estimate,
                clearEstimates: clearEstimates
            });
            toggleModalDialog();
            bulkActionSuccess(analyticsEvent);
        }
    }, formatMessage((0, $ib5d3.default).apply))));
}
var $5ad966007db6e6e7$export$2e2bcd8739ae039 = $5ad966007db6e6e7$var$SetEstimateDialog;

});
parcelRegister("cKooL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa2687155dd22f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $5rYNM = parcelRequire("5rYNM");
var $0fa2687155dd22f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.set-header",
        "defaultMessage": "Update estimate"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.various-values",
        "defaultMessage": "Various estimates"
    },
    newEstimate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.new-estimate",
        "defaultMessage": "New estimate ({planningUnit})"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5rYNM.PlanningUnits).storyPoints]: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.story-points",
        "defaultMessage": "story points"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5rYNM.PlanningUnits).days]: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.days",
        "defaultMessage": "days"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5rYNM.PlanningUnits).hours]: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.set-estimate-dialog.hours",
        "defaultMessage": "hours"
    },
    outOfRange: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.out-of-range",
        "defaultMessage": "The estimate must be a positive number."
    },
    clearEstimates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-estimate.clear-estimates",
        "defaultMessage": "Clear estimates"
    }
});

});

parcelRegister("9B7Go", function(module, exports) {

$parcel$export(module.exports, "checkbox", () => $6fcd87691aed1eee$export$b07e517d22efa1ca, (v) => $6fcd87691aed1eee$export$b07e517d22efa1ca = v);
$parcel$export(module.exports, "current-value", () => $6fcd87691aed1eee$export$bd70860eb87e972b, (v) => $6fcd87691aed1eee$export$bd70860eb87e972b = v);
$parcel$export(module.exports, "current-value-title", () => $6fcd87691aed1eee$export$2c19fd1221dd0b06, (v) => $6fcd87691aed1eee$export$2c19fd1221dd0b06 = v);
$parcel$export(module.exports, "form-group", () => $6fcd87691aed1eee$export$55a1f87a143fb302, (v) => $6fcd87691aed1eee$export$55a1f87a143fb302 = v);
$parcel$export(module.exports, "icon", () => $6fcd87691aed1eee$export$1ca1ec8b29a4ce27, (v) => $6fcd87691aed1eee$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "new-value", () => $6fcd87691aed1eee$export$18786265e3bc6811, (v) => $6fcd87691aed1eee$export$18786265e3bc6811 = v);
$parcel$export(module.exports, "value-label", () => $6fcd87691aed1eee$export$f2febdad47edd01a, (v) => $6fcd87691aed1eee$export$f2febdad47edd01a = v);
$parcel$export(module.exports, "value-placeholder", () => $6fcd87691aed1eee$export$16d768213d218756, (v) => $6fcd87691aed1eee$export$16d768213d218756 = v);
var $6fcd87691aed1eee$export$b07e517d22efa1ca;
var $6fcd87691aed1eee$export$bd70860eb87e972b;
var $6fcd87691aed1eee$export$2c19fd1221dd0b06;
var $6fcd87691aed1eee$export$55a1f87a143fb302;
var $6fcd87691aed1eee$export$1ca1ec8b29a4ce27;
var $6fcd87691aed1eee$export$18786265e3bc6811;
var $6fcd87691aed1eee$export$f2febdad47edd01a;
var $6fcd87691aed1eee$export$16d768213d218756;
$6fcd87691aed1eee$export$b07e517d22efa1ca = `YXOtZW_checkbox`;
$6fcd87691aed1eee$export$bd70860eb87e972b = `YXOtZW_current-value`;
$6fcd87691aed1eee$export$2c19fd1221dd0b06 = `YXOtZW_current-value-title`;
$6fcd87691aed1eee$export$55a1f87a143fb302 = `YXOtZW_form-group`;
$6fcd87691aed1eee$export$1ca1ec8b29a4ce27 = `YXOtZW_icon`;
$6fcd87691aed1eee$export$18786265e3bc6811 = `YXOtZW_new-value`;
$6fcd87691aed1eee$export$f2febdad47edd01a = `YXOtZW_value-label`;
$6fcd87691aed1eee$export$16d768213d218756 = `YXOtZW_value-placeholder`;

});



parcelRegister("8a8aF", function(module, exports) {

$parcel$export(module.exports, "default", () => $169222dd8a20e504$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $38ueY = parcelRequire("38ueY");

var $9dXLx = parcelRequire("9dXLx");

var $4Wq0Z = parcelRequire("4Wq0Z");
var $169222dd8a20e504$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9dXLx.default), (0, $38ueY.default))((0, $4Wq0Z.default));

});
parcelRegister("38ueY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36aed1b35a831ce$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a36aed1b35a831ce$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("9dXLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a5f03fa1be006b$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $52a5f03fa1be006b$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    plan: (0, $75KhQ.getPlan),
    selectedIssues: (0, $kwMvv.getSelectedIssues)
});

});

parcelRegister("4Wq0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $5897241413b58fed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $9jNAz = parcelRequire("9jNAz");

var $cuuJa = parcelRequire("cuuJa");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");

var $e53gU = parcelRequire("e53gU");

var $ePXAm = parcelRequire("ePXAm");

var $5nu7F = parcelRequire("5nu7F");

var $e0AGA = parcelRequire("e0AGA");

var $dcFiu = parcelRequire("dcFiu");
const $5897241413b58fed$var$SetLabelDialog = ({ plan: plan, selectedIssues: selectedIssues, bulkUpdateAttribute: bulkUpdateAttribute, toggleModalDialog: toggleModalDialog })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [fieldAction, setFieldAction] = (0, $eUqFw.useState)((0, $dcFiu.FieldAction).ADD);
    const [editedLabels, setEditedLabels] = (0, $eUqFw.useState)([]);
    const getCurrentValue = ()=>{
        const firstValue = selectedIssues[0].labels;
        const isSameValue = !selectedIssues.some((issue)=>!$5OdRK.default(issue.labels?.sort(), firstValue?.sort()));
        if (isSameValue && !firstValue?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $5nu7F.default).noValues));
        if (isSameValue && firstValue) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $e0AGA["current-container"]
        }, firstValue.map((label, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
                key: i,
                text: label
            }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $5nu7F.default).variousValues));
    };
    const currentContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["value-placeholder"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["current-value-title"]
    }, getCurrentValue()));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onLabelChange = (option)=>{
        setEditedLabels(option);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = (_, analyticsEvent)=>{
        // editedLabels are in the form { label: string, value: string }
        // We transform them into an array
        const labelsArray = editedLabels.map((editedLabel)=>editedLabel.value);
        bulkUpdateAttribute({
            labels: {
                value: fieldAction !== (0, $dcFiu.FieldAction).CLEAR ? labelsArray : [],
                fieldAction: fieldAction
            }
        });
        // Analytics
        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: eventAction,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).BULK_ACTIONS_ACTION_SUCCEEDED, {
            selectedOption: 'Labels',
            fieldAction: fieldAction
        });
        toggleModalDialog();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: toggleModalDialog,
        width: (0, $lClE6.MODAL_DIALOG_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $5nu7F.default).setHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["form-group"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["value-label"]
    }, formatMessage((0, $ib5d3.default).current)), currentContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "arrow-right-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["new-value"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $e0AGA["value-label"]
    }, formatMessage((0, $ib5d3.default).new)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e53gU.default), {
        fieldAction: fieldAction,
        setFieldAction: setFieldAction
    }), fieldAction !== (0, $dcFiu.FieldAction).CLEAR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePXAm.default), {
        plan: plan,
        editedLabels: editedLabels,
        onLabelChange: onLabelChange
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: toggleModalDialog
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        onClick: onSubmit,
        isDisabled: editedLabels.length <= 0 && fieldAction !== (0, $dcFiu.FieldAction).CLEAR
    }, formatMessage((0, $ib5d3.default).apply))));
};
var $5897241413b58fed$export$2e2bcd8739ae039 = $5897241413b58fed$var$SetLabelDialog;

});
parcelRegister("e53gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f80b42ebd680f7cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGKRb = parcelRequire("gGKRb");

var $b2sK9 = parcelRequire("b2sK9");

var $fupe1 = parcelRequire("fupe1");
const $f80b42ebd680f7cb$var$FieldActionSelect = ({ fieldAction: fieldAction, setFieldAction: setFieldAction })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (selectedOption)=>{
        setFieldAction(selectedOption.value);
    };
    const fieldActionOptions = [
        {
            label: formatMessage((0, $b2sK9.default).add),
            value: 'ADD'
        },
        {
            label: formatMessage((0, $b2sK9.default).remove),
            value: 'REMOVE'
        },
        {
            label: formatMessage((0, $b2sK9.default).replace),
            value: 'SET'
        },
        {
            label: formatMessage((0, $b2sK9.default).clear),
            value: 'CLEAR'
        }
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fupe1["field-action-container"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGKRb.default), {
        id: "field-action-select",
        options: fieldActionOptions,
        onChange: handleChange,
        value: fieldActionOptions.filter((option)=>option.value === fieldAction)[0],
        isTransparentBackground: false
    })));
};
var $f80b42ebd680f7cb$export$2e2bcd8739ae039 = $f80b42ebd680f7cb$var$FieldActionSelect;

});
parcelRegister("b2sK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ccc9fb01ec6e86b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ccc9fb01ec6e86b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    add: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.add",
        "defaultMessage": "Add labels"
    },
    replace: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.replace",
        "defaultMessage": "Replace all labels"
    },
    clear: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.clear",
        "defaultMessage": "Clear all labels"
    },
    remove: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.field-action-select.remove",
        "defaultMessage": "Remove labels"
    }
});

});

parcelRegister("fupe1", function(module, exports) {

$parcel$export(module.exports, "field-action-container", () => $b46d39928895d44d$export$6a6f2caaea6b52f9, (v) => $b46d39928895d44d$export$6a6f2caaea6b52f9 = v);
var $b46d39928895d44d$export$6a6f2caaea6b52f9;
$b46d39928895d44d$export$6a6f2caaea6b52f9 = `gE_UFq_field-action-container`;

});


parcelRegister("ePXAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b875cc5211b4fcfa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuuJa = parcelRequire("cuuJa");

var $gGKRb = parcelRequire("gGKRb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lkxON = parcelRequire("lkxON");
const $b875cc5211b4fcfa$var$MAX_FIELD_LENGTH = 255;
const $b875cc5211b4fcfa$export$f18317131e3a9f2c = (planId, scenarioId)=>fetch('/rest/jpo/1.0/scenarios/labels', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            limit: 50,
            planId: planId,
            scenarioId: scenarioId,
            query: null
        })
    });
const $b875cc5211b4fcfa$var$useLabels = (planId, scenarioId)=>{
    const [labels, setLabels] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        const getLabels = async ()=>{
            if (planId == null || scenarioId == null) throw Error('No planId or scenarioId from useLabels');
            try {
                const raw = await $b875cc5211b4fcfa$export$f18317131e3a9f2c(planId, scenarioId);
                if (raw.ok) {
                    const response = await raw.json();
                    const formattedResponse = response?.items?.map((item)=>({
                            value: item,
                            label: item
                        })) || [];
                    setLabels(formattedResponse);
                } else throw Error('Failed to retrieve labels');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                throw Error('Failed to retrieve labels');
            }
        };
        getLabels();
    }, [
        planId,
        scenarioId
    ]);
    return labels;
};
const $b875cc5211b4fcfa$var$LabelSelect = ({ plan: plan, editedLabels: editedLabels, onLabelChange: onLabelChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const planLabels = $b875cc5211b4fcfa$var$useLabels(plan.id, plan.currentScenarioId);
    const [currentTypedInput, setCurrentTypedInput] = (0, $eUqFw.useState)('');
    const [currentValue, setCurrentValue] = (0, $eUqFw.useState)(editedLabels);
    const [options, setOptions] = (0, $eUqFw.useState)(planLabels);
    (0, $eUqFw.useEffect)(()=>{
        setOptions(planLabels.sort((a, b)=>a.label.localeCompare(b.label)));
    }, [
        planLabels
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (newOption)=>{
        setCurrentValue(newOption);
        // Callback
        onLabelChange(newOption);
    };
    const handleCreate = (inputValue)=>{
        const newOption = {
            label: inputValue,
            value: inputValue
        };
        setOptions([
            ...options,
            newOption
        ].sort((a, b)=>a.label.localeCompare(b.label)));
        setCurrentValue([
            ...currentValue,
            newOption
        ]);
        // Callback
        onLabelChange([
            ...currentValue,
            newOption
        ]);
        // Analytics
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL.split(' ');
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_LABEL);
    };
    const noOptionsMessage = (obj)=>{
        if (obj.inputValue.includes(' ')) return formatMessage((0, $lkxON.default).invalidInputWithSpace);
        if (obj.inputValue.trim().length > 255) return formatMessage((0, $lkxON.default).invalidInputWithMaxLength);
        return null;
    };
    const handleInputChange = (input)=>{
        setCurrentTypedInput(input);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGKRb.default), {
        id: "label-select",
        placeholder: formatMessage((0, $lkxON.default).labelPlaceholder),
        isMulti: true,
        isSearchable: true,
        isClearable: true,
        isCreatable: true,
        closeMenuOnSelect: false,
        noOptionsMessage: noOptionsMessage,
        isValidNewOption: (newValue)=>newValue !== undefined && newValue.length > 0 && newValue.length <= $b875cc5211b4fcfa$var$MAX_FIELD_LENGTH && !newValue.includes(' '),
        value: currentValue,
        onChange: handleChange,
        onCreateOption: (x)=>handleCreate(x),
        onInputChange: handleInputChange,
        options: options,
        formatCreateLabel: (newValue)=>`${newValue} (${formatMessage((0, $lkxON.default).newLabel)})`,
        isTransparentBackground: false,
        styles: {
            input: (styles)=>({
                    ...styles,
                    width: currentTypedInput ? '100px' : '1px'
                })
        }
    });
};
var $b875cc5211b4fcfa$export$2e2bcd8739ae039 = $b875cc5211b4fcfa$var$LabelSelect;

});
parcelRegister("lkxON", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d373294183e501$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $33d373294183e501$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.label-placeholder",
        "defaultMessage": "Choose a label"
    },
    newLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.new-label",
        "defaultMessage": "New label"
    },
    invalidInputWithSpace: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.invalid-input-with-space",
        "defaultMessage": "Invalid input, labels can't contain spaces"
    },
    invalidInputWithMaxLength: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.label-select.invalid-input-with-max-length",
        "defaultMessage": "Invalid input, labels can't have more than 255 characters"
    }
});

});


parcelRegister("5nu7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $31494fffebc0f55d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $31494fffebc0f55d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.set-header",
        "defaultMessage": "Update labels"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.various-values",
        "defaultMessage": "Various labels"
    },
    noValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-label.no-values",
        "defaultMessage": "No labels"
    }
});

});

parcelRegister("e0AGA", function(module, exports) {

$parcel$export(module.exports, "current-container", () => $a32d85d0d50bb122$export$88030eb8e5e39322, (v) => $a32d85d0d50bb122$export$88030eb8e5e39322 = v);
$parcel$export(module.exports, "current-value-title", () => $a32d85d0d50bb122$export$2c19fd1221dd0b06, (v) => $a32d85d0d50bb122$export$2c19fd1221dd0b06 = v);
$parcel$export(module.exports, "form-group", () => $a32d85d0d50bb122$export$55a1f87a143fb302, (v) => $a32d85d0d50bb122$export$55a1f87a143fb302 = v);
$parcel$export(module.exports, "icon", () => $a32d85d0d50bb122$export$1ca1ec8b29a4ce27, (v) => $a32d85d0d50bb122$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "new-value", () => $a32d85d0d50bb122$export$18786265e3bc6811, (v) => $a32d85d0d50bb122$export$18786265e3bc6811 = v);
$parcel$export(module.exports, "value-label", () => $a32d85d0d50bb122$export$f2febdad47edd01a, (v) => $a32d85d0d50bb122$export$f2febdad47edd01a = v);
$parcel$export(module.exports, "value-placeholder", () => $a32d85d0d50bb122$export$16d768213d218756, (v) => $a32d85d0d50bb122$export$16d768213d218756 = v);
var $a32d85d0d50bb122$export$88030eb8e5e39322;
var $a32d85d0d50bb122$export$2c19fd1221dd0b06;
var $a32d85d0d50bb122$export$55a1f87a143fb302;
var $a32d85d0d50bb122$export$1ca1ec8b29a4ce27;
var $a32d85d0d50bb122$export$18786265e3bc6811;
var $a32d85d0d50bb122$export$f2febdad47edd01a;
var $a32d85d0d50bb122$export$16d768213d218756;
$a32d85d0d50bb122$export$88030eb8e5e39322 = `_8sj1zG_current-container`;
$a32d85d0d50bb122$export$2c19fd1221dd0b06 = `_8sj1zG_current-value-title`;
$a32d85d0d50bb122$export$55a1f87a143fb302 = `_8sj1zG_form-group`;
$a32d85d0d50bb122$export$1ca1ec8b29a4ce27 = `_8sj1zG_icon`;
$a32d85d0d50bb122$export$18786265e3bc6811 = `_8sj1zG_new-value`;
$a32d85d0d50bb122$export$f2febdad47edd01a = `_8sj1zG_value-label`;
$a32d85d0d50bb122$export$16d768213d218756 = `_8sj1zG_value-placeholder`;

});

parcelRegister("dcFiu", function(module, exports) {

$parcel$export(module.exports, "FieldAction", () => $0fc59f8c86dd8ddc$export$4664dfdcfd25e124);
const $0fc59f8c86dd8ddc$export$4664dfdcfd25e124 = {
    SET: 'SET',
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    CLEAR: 'CLEAR'
};

});



parcelRegister("2sBeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e80ccbf31808f2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kJz2N = parcelRequire("kJz2N");

var $fOSVy = parcelRequire("fOSVy");

var $kJf6i = parcelRequire("kJf6i");
var $76e80ccbf31808f2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fOSVy.default), (0, $kJz2N.default))((0, $kJf6i.default));

});
parcelRegister("kJz2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11aa4031243b9c9$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11aa4031243b9c9$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("fOSVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $941af62966ba3602$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");

var $8nNqE = parcelRequire("8nNqE");
const $941af62966ba3602$var$getIssueIdToProject = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getSelectedIssues),
    (0, $ehEr2.getProjectsById)
], (0, $8nNqE.getIssueIdToProjectPure));
const $941af62966ba3602$var$getIsSomeSelectedIssuesFromTMP = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getSelectedIssues),
    $941af62966ba3602$var$getIssueIdToProject
], (0, $8nNqE.getIsSomeSelectedIssuesFromTMPPure));
const $941af62966ba3602$var$getIsSelectedIssuesFromMultipleProjects = (0, $iK4oF.createSelector)([
    (0, $kwMvv.getSelectedIssues)
], (0, $8nNqE.getIsSelectedIssuesFromMultipleProjectsPure));
var $941af62966ba3602$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issues: (0, $cwP4d.getIssues),
    issueTypesById: (0, $lihml.getIssueTypesById),
    projectsById: (0, $ehEr2.getProjectsById),
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    isSomeSelectedIssuesFromTMP: $941af62966ba3602$var$getIsSomeSelectedIssuesFromTMP,
    isSelectedIssuesFromMultipleProjects: $941af62966ba3602$var$getIsSelectedIssuesFromMultipleProjects
});

});
parcelRegister("8nNqE", function(module, exports) {

$parcel$export(module.exports, "getIssueIdToProjectPure", () => $a23cfc403c5a2230$export$a5cafa90ff4074f6);
$parcel$export(module.exports, "getIsSomeSelectedIssuesFromTMPPure", () => $a23cfc403c5a2230$export$bcc20fb54d62215a);
$parcel$export(module.exports, "getIsSelectedIssuesFromMultipleProjectsPure", () => $a23cfc403c5a2230$export$2f25656bdb74fbc5);
const $a23cfc403c5a2230$export$a5cafa90ff4074f6 = (issues, projectById)=>issues.reduce((acc, { id: id, project: projectId })=>{
        const project = projectById[projectId];
        if (project !== undefined) acc[id] = project;
        return acc;
    }, {});
const $a23cfc403c5a2230$export$bcc20fb54d62215a = (selectedIssues, issueIdToProject)=>selectedIssues.some(({ id: id })=>issueIdToProject[id]?.isSimplified === true);
const $a23cfc403c5a2230$export$2f25656bdb74fbc5 = (selectedIssues)=>new Set(selectedIssues.map(({ project: project })=>project)).size > 1;

});


parcelRegister("kJf6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $499ccf3633f6e333$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $g8SOd = parcelRequire("g8SOd");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $l926r = parcelRequire("l926r");

var $ckMan = parcelRequire("ckMan");
// eslint-disable-next-line jira/react/no-class-components
class $499ccf3633f6e333$var$SetParentDialog extends (0, $eUqFw.Component) {
    render() {
        const { bulkActionSuccess: bulkActionSuccess, bulkUpdateAttribute: bulkUpdateAttribute, intl: intl, issueTypesById: issueTypesById, toggleModalDialog: toggleModalDialog, selectedIssues: selectedIssues, UpdateAttributeForm: UpdateAttributeForm, isSomeSelectedIssuesFromTMP: isSomeSelectedIssuesFromTMP, projectsById: projectsById, issues: issues, isSelectedIssuesFromMultipleProjects: isSelectedIssuesFromMultipleProjects } = this.props;
        const { formatMessage: formatMessage } = intl;
        const { currentValue: currentValue, currentIssueTypeIcon: currentIssueTypeIcon } = this.getCurrentValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $l926r.default).header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.MOVE_ISSUES),
            options: (0, $ckMan.getParentSelectOptions)(intl, issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects),
            currentValue: currentValue,
            currentIssueTypeIcon: currentIssueTypeIcon,
            warningMessage: isSomeSelectedIssuesFromTMP && isSelectedIssuesFromMultipleProjects ? formatMessage((0, $l926r.default).crossProjectReparentingWarning) : undefined,
            onCancel: toggleModalDialog,
            onSubmit: (formData, analyticsEvent)=>{
                bulkUpdateAttribute(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, issues: issues, issueTypesById: issueTypesById, projectsById: projectsById } = this.props;
            const firstValue = selectedIssues[0].parent || '';
            const isSameValue = !selectedIssues.some((issue)=>(issue.parent || '') !== firstValue);
            if (isSameValue && !firstValue) return {
                currentValue: formatMessage((0, $ib5d3.default).none)
            };
            const parentIssue = issues.find((issue)=>issue.id === firstValue);
            if (isSameValue && parentIssue) {
                const issue = (0, $g8SOd.getIssueOption)(parentIssue, issueTypesById, projectsById);
                return {
                    currentValue: issue.label,
                    currentIssueTypeIcon: issue.icon
                };
            }
            return {
                currentValue: formatMessage((0, $l926r.default).variousParents)
            };
        };
    }
}
var $499ccf3633f6e333$export$2e2bcd8739ae039 = (0, $2qhQi.default)($499ccf3633f6e333$var$SetParentDialog);

});
parcelRegister("l926r", function(module, exports) {

$parcel$export(module.exports, "default", () => $855b815797fed4a3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $855b815797fed4a3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.header",
        "defaultMessage": "Move"
    },
    variousParents: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.various-parents",
        "defaultMessage": "Various parents"
    },
    crossProjectReparentingWarning: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-parent.cross-project-reparenting-warning",
        "defaultMessage": "Issues from team-managed projects can't be moved to another project."
    }
});

});

parcelRegister("ckMan", function(module, exports) {

$parcel$export(module.exports, "getParentSelectOptions", () => $8aa8711b9ce84787$export$cc0b71cd5db9ab68);

var $1ybV0 = parcelRequire("1ybV0");

var $g8SOd = parcelRequire("g8SOd");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");
const $8aa8711b9ce84787$export$7d9c45e8a7d2f39c = (issueTypesById, selectedIssues)=>{
    const { type: type } = selectedIssues[0];
    const selectedType = issueTypesById[type];
    return selectedType && selectedType.subTask;
};
const $8aa8711b9ce84787$export$ab64a2584557c8a1 = (selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects)=>{
    if (selectedIssues.length === 0) return [];
    const { level: selectedLevel, project: selectedProject } = selectedIssues[0];
    // Ensure only one hierarchy level is selected
    for(let i = 0; i < selectedIssues.length; i++){
        if (selectedIssues[i].level !== selectedLevel) return [];
    }
    // It's not possible to reparent issues from different TMPs, or issues from mix of TMP and CMP.
    // Only issues from same TMP, or issues from various CMPs is possible.
    if (isSomeSelectedIssuesFromTMP && isSelectedIssuesFromMultipleProjects) return [];
    if (isSomeSelectedIssuesFromTMP) // there can only be a single TMP at this point
    return issues.filter((issue)=>issue.level === selectedLevel + 1 && issue.project === selectedProject);
    // there can only be CMPs at this point
    return issues.filter((issue)=>issue.level === selectedLevel + 1 && projectsById[issue.project]?.isSimplified !== true);
};
const $8aa8711b9ce84787$export$f9f1c88bdc4182a = (issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects)=>{
    const { level: selectedLevel, project: selectedProject } = selectedIssues[0];
    // It's not possible to reparent issues from different TMPs, or issues from mix of TMP and CMP.
    // Only issues from same TMP, or issues from various CMPs is possible.
    if (isSomeSelectedIssuesFromTMP && isSelectedIssuesFromMultipleProjects) return [];
    if (isSomeSelectedIssuesFromTMP) {
        // there can only be a single TMP at this point
        if ($8aa8711b9ce84787$export$7d9c45e8a7d2f39c(issueTypesById, selectedIssues)) return issues.filter((issue)=>issue.level !== selectedLevel && issue.project === selectedProject);
        return issues.filter((issue)=>issue.level === selectedLevel + 1 && issue.project === selectedProject);
    }
    // there can only be CMPs at this point
    if ($8aa8711b9ce84787$export$7d9c45e8a7d2f39c(issueTypesById, selectedIssues)) return issues.filter((issue)=>issue.level !== selectedLevel && projectsById[issue.project]?.isSimplified !== true);
    return issues.filter((issue)=>issue.level === selectedLevel + 1 && projectsById[issue.project]?.isSimplified !== true);
};
const $8aa8711b9ce84787$export$cc0b71cd5db9ab68 = (intl, issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects)=>{
    const { formatMessage: formatMessage } = intl;
    const possibleParentOptions = (0, $1ybV0.ff)('fix-bulk-action-parenting-behaviour_ai3go') ? $8aa8711b9ce84787$export$ab64a2584557c8a1(selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects).map((issue)=>(0, $g8SOd.getIssueOption)(issue, issueTypesById, projectsById)) : $8aa8711b9ce84787$export$f9f1c88bdc4182a(issueTypesById, selectedIssues, issues, projectsById, isSomeSelectedIssuesFromTMP, isSelectedIssuesFromMultipleProjects).map((issue)=>(0, $g8SOd.getIssueOption)(issue, issueTypesById, projectsById));
    if (!$8aa8711b9ce84787$export$7d9c45e8a7d2f39c(issueTypesById, selectedIssues)) possibleParentOptions.unshift({
        label: formatMessage((0, $ib5d3.default).none),
        value: (0, $5rYNM.NONE)
    });
    return possibleParentOptions;
};

});



parcelRegister("lPjIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $211014ab42acd21f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7AwtC = parcelRequire("7AwtC");

var $cFnv7 = parcelRequire("cFnv7");
var $211014ab42acd21f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $7AwtC.default))((0, $cFnv7.default));

});
parcelRegister("7AwtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $46fbeae137bd3260$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46fbeae137bd3260$export$2e2bcd8739ae039 = {
    bulkUpdateRank: (0, $1Szmp.bulkRankIssue)
};

});

parcelRegister("cFnv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $92ac5bc7c0e04450$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $lClE6 = parcelRequire("lClE6");

var $curTf = parcelRequire("curTf");

var $lCjlj = parcelRequire("lCjlj");
// eslint-disable-next-line jira/react/no-class-components
class $92ac5bc7c0e04450$var$SetRankDialog extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            SetRankForm: $lCjlj.default
        };
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { intl: intl, toggleModalDialog: toggleModalDialog, SetRankForm: SetRankForm } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, intl.formatMessage((0, $curTf.default).setHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SetRankForm, {
            onCancel: toggleModalDialog,
            onSubmit: this.submitForm
        })));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.submitForm = (formData, analyticsEvent)=>{
            const { bulkUpdateRank: bulkUpdateRank, toggleModalDialog: toggleModalDialog, bulkActionSuccess: bulkActionSuccess } = this.props;
            bulkUpdateRank(formData);
            toggleModalDialog();
            bulkActionSuccess(analyticsEvent);
        };
    }
}
var $92ac5bc7c0e04450$export$2e2bcd8739ae039 = (0, $2qhQi.default)($92ac5bc7c0e04450$var$SetRankDialog);

});
parcelRegister("curTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e03c19600685dc7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8e03c19600685dc7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-header",
        "defaultMessage": "Update rank"
    }
});

});

parcelRegister("lCjlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e44c609fe9dc536$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3SH8Q = parcelRequire("3SH8Q");

var $lITCL = parcelRequire("lITCL");
var $2e44c609fe9dc536$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3SH8Q.default), {})((0, $lITCL.default));

});
parcelRegister("3SH8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b242f844990801fb$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");

var $k59XD = parcelRequire("k59XD");

var $1TrR5 = parcelRequire("1TrR5");
const $b242f844990801fb$var$mapStateToPropsOld = (state)=>({
        allSortedIssues: (0, $kwMvv.getAllSortedIssues)(state),
        getAncestors: (issueId)=>(0, $k59XD.getAncestors)(state, {
                issueId: issueId
            }),
        issueTypesById: (0, $lihml.getIssueTypesById)(state),
        projectsById: (0, $ehEr2.getProjectsById)(state),
        selectedIssues: (0, $kwMvv.getSelectedIssues)(state)
    });
const $b242f844990801fb$var$mapStateToPropsFactory = ()=>{
    const getAncestorsFactory = (0, $5iWql.default)((state)=>(issueId)=>(0, $k59XD.getAncestors)(state, {
                issueId: issueId
            }));
    return (state)=>({
            allSortedIssues: (0, $kwMvv.getAllSortedIssues)(state),
            getAncestors: getAncestorsFactory(state),
            issueTypesById: (0, $lihml.getIssueTypesById)(state),
            projectsById: (0, $ehEr2.getProjectsById)(state),
            selectedIssues: (0, $kwMvv.getSelectedIssues)(state)
        });
};
// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
const $b242f844990801fb$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($b242f844990801fb$var$mapStateToPropsFactory, $b242f844990801fb$var$mapStateToPropsOld);
var $b242f844990801fb$export$2e2bcd8739ae039 = $b242f844990801fb$var$mapStateToProps;

});
parcelRegister("k59XD", function(module, exports) {

$parcel$export(module.exports, "getTimelineState", () => $118d7099a28f58d6$export$2b24ae6422c2e50e);
$parcel$export(module.exports, "getAncestors", () => $118d7099a28f58d6$export$c6fd3ab3f44300d0);
$parcel$export(module.exports, "getDescendents", () => $118d7099a28f58d6$export$ec0cf3dcee1d735c);

var $kwMvv = parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");
var $cwP4d = parcelRequire("cwP4d");

var $iK4oF = parcelRequire("iK4oF");
const $118d7099a28f58d6$export$2b24ae6422c2e50e = (state)=>state.ui.Main.Tabs.Roadmap.TimelinePreview;
const $118d7099a28f58d6$export$88c9ddb45cea7241 = (string)=>(_, props)=>props[string];
const $118d7099a28f58d6$export$2e28083b1261790a = (issueMap, issueId)=>[
        issueMap[issueId]
    ].concat($kwMvv.getAncestors(issueMap[issueId], issueMap, Infinity));
const $118d7099a28f58d6$export$3506fa4ebbe17d84 = (issueMap, descendantsMap, issueId, isStrict)=>{
    const descendants = $aK3ri.getDescendants(issueMap[issueId], issueMap, descendantsMap, 0);
    return isStrict ? descendants : [
        issueMap[issueId]
    ].concat(descendants);
};
const $118d7099a28f58d6$export$c6fd3ab3f44300d0 = (0, $iK4oF.createSelector)([
    $cwP4d.getIssueMapById,
    $118d7099a28f58d6$export$88c9ddb45cea7241('issueId')
], $118d7099a28f58d6$export$2e28083b1261790a);
const $118d7099a28f58d6$export$ec0cf3dcee1d735c = (0, $iK4oF.createSelector)([
    $cwP4d.getIssueMapById,
    $aK3ri.getChildrenIdsByParent,
    $118d7099a28f58d6$export$88c9ddb45cea7241('issueId'),
    $118d7099a28f58d6$export$88c9ddb45cea7241('isStrict')
], $118d7099a28f58d6$export$3506fa4ebbe17d84);

});


parcelRegister("lITCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2141d3225d58a24f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $akSC8 = parcelRequire("akSC8");
var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $4LhB6 = parcelRequire("4LhB6");
var $7jPhn = parcelRequire("7jPhn");

var $g8SOd = parcelRequire("g8SOd");

var $jSmUl = parcelRequire("jSmUl");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $fqIs3 = parcelRequire("fqIs3");

var $i2O9S = parcelRequire("i2O9S");

var $lGDHF = parcelRequire("lGDHF");
function $2141d3225d58a24f$export$2e2bcd8739ae039({ allSortedIssues: allSortedIssues, getAncestors: getAncestors, issueTypesById: issueTypesById, onCancel: onCancel, onSubmit: onSubmit, projectsById: projectsById, selectedIssues: selectedIssues = [] }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [operationTypeFieldValue, setOperationTypeFieldValue] = (0, $eUqFw.useState)((0, $eOsHk.RANK_TOP));
    const [anchorFieldValue, setAnchorFieldValue] = (0, $eUqFw.useState)();
    const handleSubmit = (_, analyticsEvent)=>{
        const formData = {
            operationType: operationTypeFieldValue
        };
        if (anchorFieldValue) formData.anchor = anchorFieldValue;
        onSubmit(formData, analyticsEvent);
    };
    const getCurrentValue = ()=>{
        if (selectedIssues.length === 1) {
            const index = allSortedIssues.findIndex(({ id: id })=>id === selectedIssues[0].id);
            return formatMessage((0, $fqIs3.default).currentValue, {
                currentValue: index + 1
            });
        }
        return formatMessage((0, $fqIs3.default).variousValues);
    };
    const getUniqueSelectedIssuesIds = ()=>new Set(selectedIssues.map(({ id: id })=>id));
    const getPossibleIssues = ()=>{
        const selectedIssuesIds = getUniqueSelectedIssuesIds();
        return allSortedIssues.filter(({ id: id })=>!selectedIssuesIds.has(id));
    };
    const getSelectIssueOptions = ()=>getPossibleIssues().map((issue)=>(0, $g8SOd.getIssueOption)(issue, issueTypesById, projectsById));
    const renderOptionRank = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const rankMapOptions = allSortedIssues.reduce((acc, { id: id }, i)=>{
            acc[id] = i + 1;
            return acc;
        }, {});
        if (anchorFieldValue && rankMapOptions[anchorFieldValue]) return formatMessage((0, $fqIs3.default).optionRankLabel, {
            currentIndex: rankMapOptions[anchorFieldValue]
        });
        return null;
    };
    const renderInfoMessage = ()=>{
        const { issuesWithLowerPosition: issuesWithLowerPosition, issuesWithHigherPosition: issuesWithHigherPosition } = (0, $lGDHF.findSelectedIssuesWithLowerPosition)({
            allSortedIssues: allSortedIssues,
            anchorFieldValue: anchorFieldValue,
            getAncestors: getAncestors,
            issues: getPossibleIssues(),
            operationTypeFieldValue: operationTypeFieldValue,
            selectedIdsSet: getUniqueSelectedIssuesIds(),
            selectedIssues: selectedIssues
        });
        return issuesWithLowerPosition.length || issuesWithHigherPosition.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSmUl.default), {
            issueTypesById: issueTypesById,
            issuesWithHigherPosition: issuesWithHigherPosition,
            issuesWithLowerPosition: issuesWithLowerPosition,
            projectsById: projectsById,
            isDefaultFlyoutOpen: false
        }) : null;
    };
    const rankPositions = [
        {
            label: formatMessage((0, $fqIs3.default).rankTop),
            value: (0, $eOsHk.RANK_TOP)
        },
        {
            label: formatMessage((0, $fqIs3.default).rankLast),
            value: (0, $eOsHk.RANK_LAST)
        },
        {
            label: formatMessage((0, $fqIs3.default).rankBefore),
            value: (0, $eOsHk.RANK_BEFORE)
        },
        {
            label: formatMessage((0, $fqIs3.default).rankAfter),
            value: (0, $eOsHk.RANK_AFTER)
        }
    ];
    const issueOptions = getSelectIssueOptions();
    // the new rank of selected issue(s) cannot be applied if the user selected "Above issue" or "Below issue" and no issue has been selected
    const isFormInvalid = ()=>{
        if (operationTypeFieldValue === (0, $eOsHk.RANK_TOP) || operationTypeFieldValue === (0, $eOsHk.RANK_LAST)) return false;
        if ((operationTypeFieldValue === (0, $eOsHk.RANK_BEFORE) || operationTypeFieldValue === (0, $eOsHk.RANK_AFTER)) && !(0, $7CnHa.isDefined)(anchorFieldValue)) return true;
        return false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        className: $i2O9S["form-group"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S["current-value"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S["value-label"]
    }, formatMessage((0, $ib5d3.default).current)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S["value-placeholder"]
    }, getCurrentValue())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S["operation-type"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        isRequired: true,
        label: formatMessage((0, $ib5d3.default).new),
        name: "operationTypeFieldValue"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            defaultValue: rankPositions[0],
            onChange: (option)=>{
                option && setOperationTypeFieldValue(option.value);
            },
            options: rankPositions,
            value: rankPositions.find((v)=>v.value === operationTypeFieldValue),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.ak-select"
        }))), (operationTypeFieldValue === (0, $eOsHk.RANK_BEFORE) || operationTypeFieldValue === (0, $eOsHk.RANK_AFTER)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i2O9S.anchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        isRequired: true,
        name: "anchorFieldValue"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            defaultValue: undefined,
            formatOptionLabel: (0, $akSC8.selectIssueOption),
            onChange: (option)=>{
                option && setAnchorFieldValue(option.value);
            },
            options: issueOptions,
            placeholder: formatMessage((0, $fqIs3.default).chooseValuePlaceholder),
            value: issueOptions.find((v)=>v.value === anchorFieldValue)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, renderOptionRank()))), renderInfoMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        className: $i2O9S["form-footer"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        isDisabled: isFormInvalid(),
        onClick: handleSubmit
    }, formatMessage((0, $ib5d3.default).apply)))));
}

});
parcelRegister("jSmUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf06407cf2b48798$export$2e2bcd8739ae039);

var $kN08y = parcelRequire("kN08y");
var $bf06407cf2b48798$export$2e2bcd8739ae039 = (0, $kN08y.default);

});
parcelRegister("kN08y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8058dfb203209ae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $je5kZ = parcelRequire("je5kZ");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bKxX9 = parcelRequire("bKxX9");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $eNhh9 = parcelRequire("eNhh9");
var $lRvnl = parcelRequire("lRvnl");

var $hl4M2 = parcelRequire("hl4M2");

var $ib5d3 = parcelRequire("ib5d3");

var $ftMB0 = parcelRequire("ftMB0");

var $6TfVG = parcelRequire("6TfVG");
// eslint-disable-next-line jira/react/no-class-components
class $d8058dfb203209ae$var$InfoMessage extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // using for story
            isDefaultFlyoutOpen: false
        };
    }
    render() {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
            className: $6TfVG["section-message"]
        }, this.sectionMessageRenderer());
    }
    constructor(...args){
        super(...args);
        this.state = {
            lowerIssuesFlyout: this.props.isDefaultFlyoutOpen,
            higherIssuesFlyout: false
        };
        this.toggleFlyout = (flyoutType)=>{
            if (flyoutType === 'lowerIssuesFlyout' && !this.state.lowerIssuesFlyout) this.setState(()=>({
                    lowerIssuesFlyout: true,
                    higherIssuesFlyout: false
                }));
            else if (flyoutType === 'higherIssuesFlyout' && !this.state.higherIssuesFlyout) this.setState(()=>({
                    higherIssuesFlyout: true,
                    lowerIssuesFlyout: false
                }));
            else this.closeFlyout();
        };
        this.closeFlyout = ()=>{
            this.setState(()=>({
                    lowerIssuesFlyout: false,
                    higherIssuesFlyout: false
                }));
        };
        this.issueOptionRenderer = (issue, i)=>{
            const { projectsById: projectsById, issueTypesById: issueTypesById } = this.props;
            const projectKey = issue.project && projectsById[issue.project] && projectsById[issue.project].key || '';
            const issueTypeIconUrl = issueTypesById[issue.type] && issueTypesById[issue.type].iconUrl;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6TfVG["issue-option-wrapper"],
                key: `${i}-option`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $6TfVG["issue-type-icon"],
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    backgroundSize: 'contain',
                    backgroundImage: `url(${issueTypeIconUrl})`
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6TfVG.link
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
                issueKey: issue.issueKey,
                projectKey: projectKey
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6TfVG["issue-label"],
                title: issue.summary
            }, issue.summary)));
        };
        this.renderFlyout = (issues)=>{
            const { intl: intl } = this.props;
            if ((0, $bKxX9.ff)('com.atlassian.rm.jpo.jpo3cloud.remove-barrel-exports')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $d8058dfb203209ae$var$flyoutStyles,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.div"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
                block: "space.100",
                inline: "space.200",
                xcss: $d8058dfb203209ae$var$closeFlyoutStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "subtle-link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                    label: "",
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.editor-close-icon",
                    primaryColor: `var(--ds-text-subtle, ${(0, $g4Vkx.default).N200})`
                }),
                onClick: ()=>this.closeFlyout(),
                spacing: "none",
                "aria-label": intl.formatMessage((0, $ib5d3.default).close)
            })), issues.map(this.issueOptionRenderer));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $6TfVG.flyout,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.div"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $6TfVG["close-icon"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
                label: "",
                // @ts-expect-error - TS2769 - No overload matches this call.
                // This component type has no onClick prop
                onClick: ()=>this.closeFlyout(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.editor-close-icon",
                primaryColor: `var(--ds-text-subtle, ${(0, $g4Vkx.default).N200})`
            })), issues.map(this.issueOptionRenderer));
        };
        this.renderInlineDialog = (issues, flyoutType)=>{
            const { intl: intl } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6TfVG["inline-dialog-container"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                content: this.renderFlyout(issues),
                isOpen: this.state[flyoutType],
                placement: "bottom",
                noHorizontalScroll: true,
                classNames: "inline-dialog",
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.inline-dialog"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.button",
                appearance: "link",
                spacing: "none",
                onClick: ()=>this.toggleFlyout(flyoutType)
            }, intl.formatMessage((0, $ftMB0.default).linkLabel, {
                issueCount: issues.length
            })))));
        };
        this.sectionMessageRenderer = ()=>{
            const { issuesWithLowerPosition: issuesWithLowerPosition, issuesWithHigherPosition: issuesWithHigherPosition } = this.props;
            if (!issuesWithLowerPosition.length && !issuesWithHigherPosition.length) return null;
            if (issuesWithLowerPosition.length && issuesWithHigherPosition.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "information"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ftMB0.default).flagMessageTitlePart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $ftMB0.default).flagMessageLowerPositionPart,
                values: {
                    issuesWithLowerPosition: this.renderInlineDialog(issuesWithLowerPosition, 'lowerIssuesFlyout')
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $ftMB0.default).flagMessageHigherPositionPart,
                values: {
                    issuesWithHigherPosition: this.renderInlineDialog(issuesWithHigherPosition, 'higherIssuesFlyout')
                }
            }))));
            if (issuesWithLowerPosition.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "information"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ftMB0.default).flagMessageTitlePart), ', ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $ftMB0.default).flagMessageLowerPositionPart,
                values: {
                    issuesWithLowerPosition: this.renderInlineDialog(issuesWithLowerPosition, 'lowerIssuesFlyout')
                }
            }));
            if (issuesWithHigherPosition.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "information"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ftMB0.default).flagMessageTitlePart), ', ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $ftMB0.default).flagMessageHigherPositionPart,
                values: {
                    issuesWithHigherPosition: this.renderInlineDialog(issuesWithHigherPosition, 'higherIssuesFlyout')
                }
            }));
        };
    }
}
var $d8058dfb203209ae$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d8058dfb203209ae$var$InfoMessage);
const $d8058dfb203209ae$var$flyoutStyles = (0, $1ZAYh.xcss)({
    maxWidth: '480px',
    position: 'relative',
    paddingTop: 'space.100',
    paddingRight: 'space.150',
    paddingBottom: 'space.050',
    paddingLeft: '0'
});
const $d8058dfb203209ae$var$closeFlyoutStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '0',
    right: '0'
});

});
parcelRegister("ftMB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $99088237465b77f5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $99088237465b77f5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagMessageTitlePart: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-title-part",
        "defaultMessage": "When viewed in a hierarchy"
    },
    flagMessageLowerPositionPart: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-lower-position-part",
        "defaultMessage": "{issuesWithLowerPosition} will appear to be ranked lower than their actual rank."
    },
    flagMessageHigherPositionPart: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.flag-message-higher-position-part",
        "defaultMessage": "{issuesWithHigherPosition} will appear to be ranked higher than their actual rank."
    },
    linkLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.info-message.link-label",
        "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
    }
});

});

parcelRegister("6TfVG", function(module, exports) {

$parcel$export(module.exports, "close-icon", () => $50443c629020c6b4$export$2e29e128697799d1, (v) => $50443c629020c6b4$export$2e29e128697799d1 = v);
$parcel$export(module.exports, "flyout", () => $50443c629020c6b4$export$ec4922be16378791, (v) => $50443c629020c6b4$export$ec4922be16378791 = v);
$parcel$export(module.exports, "inline-dialog-container", () => $50443c629020c6b4$export$ac9bfbba4987a017, (v) => $50443c629020c6b4$export$ac9bfbba4987a017 = v);
$parcel$export(module.exports, "issue-label", () => $50443c629020c6b4$export$8dbc59d0fe020d7e, (v) => $50443c629020c6b4$export$8dbc59d0fe020d7e = v);
$parcel$export(module.exports, "issue-option-wrapper", () => $50443c629020c6b4$export$2916d4d56de3dd7, (v) => $50443c629020c6b4$export$2916d4d56de3dd7 = v);
$parcel$export(module.exports, "issue-type-icon", () => $50443c629020c6b4$export$175e354db6e532ed, (v) => $50443c629020c6b4$export$175e354db6e532ed = v);
$parcel$export(module.exports, "link", () => $50443c629020c6b4$export$9c30223ca0a664fb, (v) => $50443c629020c6b4$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "section-message", () => $50443c629020c6b4$export$b103f4e356fcb334, (v) => $50443c629020c6b4$export$b103f4e356fcb334 = v);
var $50443c629020c6b4$export$2e29e128697799d1;
var $50443c629020c6b4$export$ec4922be16378791;
var $50443c629020c6b4$export$ac9bfbba4987a017;
var $50443c629020c6b4$export$8dbc59d0fe020d7e;
var $50443c629020c6b4$export$2916d4d56de3dd7;
var $50443c629020c6b4$export$175e354db6e532ed;
var $50443c629020c6b4$export$9c30223ca0a664fb;
var $50443c629020c6b4$export$b103f4e356fcb334;
$50443c629020c6b4$export$2e29e128697799d1 = `HoAo0W_close-icon`;
$50443c629020c6b4$export$ec4922be16378791 = `HoAo0W_flyout`;
$50443c629020c6b4$export$ac9bfbba4987a017 = `HoAo0W_inline-dialog-container`;
$50443c629020c6b4$export$8dbc59d0fe020d7e = `HoAo0W_issue-label`;
$50443c629020c6b4$export$2916d4d56de3dd7 = `HoAo0W_issue-option-wrapper`;
$50443c629020c6b4$export$175e354db6e532ed = `HoAo0W_issue-type-icon`;
$50443c629020c6b4$export$9c30223ca0a664fb = `HoAo0W_link`;
$50443c629020c6b4$export$b103f4e356fcb334 = `HoAo0W_section-message`;

});



parcelRegister("fqIs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c41af5cd757478$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line formatjs/blocklist-elements
$26c41af5cd757478$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    currentValuePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.current-value-placeholder",
        "defaultMessage": "Various ranks"
    },
    chooseValuePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.choose-value-placeholder",
        "defaultMessage": "Choose an issue"
    },
    rankTop: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-top",
        "defaultMessage": "Top of plan"
    },
    rankLast: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-last",
        "defaultMessage": "Bottom of plan"
    },
    rankBefore: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-before",
        "defaultMessage": "Above issue"
    },
    rankAfter: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.rank-after",
        "defaultMessage": "Below issue"
    },
    currentValue: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.current-value",
        "defaultMessage": "{currentValue, selectordinal, one {#st} two {#nd} few {#rd} other{#th}}"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.various-values",
        "defaultMessage": "Various ranks"
    },
    optionRankLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-rank.set-rank-form.option-rank-label",
        "defaultMessage": "Rank {currentIndex, selectordinal, one {#st} two {#nd} few {#rd} other{#th}} in plan"
    }
});

});

parcelRegister("i2O9S", function(module, exports) {

$parcel$export(module.exports, "anchor", () => $d22f524fe750cd15$export$2e2992790a6f69a8, (v) => $d22f524fe750cd15$export$2e2992790a6f69a8 = v);
$parcel$export(module.exports, "current-value", () => $d22f524fe750cd15$export$bd70860eb87e972b, (v) => $d22f524fe750cd15$export$bd70860eb87e972b = v);
$parcel$export(module.exports, "form-footer", () => $d22f524fe750cd15$export$536347ba10a26096, (v) => $d22f524fe750cd15$export$536347ba10a26096 = v);
$parcel$export(module.exports, "form-group", () => $d22f524fe750cd15$export$55a1f87a143fb302, (v) => $d22f524fe750cd15$export$55a1f87a143fb302 = v);
$parcel$export(module.exports, "icon", () => $d22f524fe750cd15$export$1ca1ec8b29a4ce27, (v) => $d22f524fe750cd15$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "operation-type", () => $d22f524fe750cd15$export$a5810537250b846d, (v) => $d22f524fe750cd15$export$a5810537250b846d = v);
$parcel$export(module.exports, "value-label", () => $d22f524fe750cd15$export$f2febdad47edd01a, (v) => $d22f524fe750cd15$export$f2febdad47edd01a = v);
$parcel$export(module.exports, "value-placeholder", () => $d22f524fe750cd15$export$16d768213d218756, (v) => $d22f524fe750cd15$export$16d768213d218756 = v);
var $d22f524fe750cd15$export$2e2992790a6f69a8;
var $d22f524fe750cd15$export$bd70860eb87e972b;
var $d22f524fe750cd15$export$536347ba10a26096;
var $d22f524fe750cd15$export$55a1f87a143fb302;
var $d22f524fe750cd15$export$1ca1ec8b29a4ce27;
var $d22f524fe750cd15$export$a5810537250b846d;
var $d22f524fe750cd15$export$f2febdad47edd01a;
var $d22f524fe750cd15$export$16d768213d218756;
$d22f524fe750cd15$export$2e2992790a6f69a8 = `_1B3yza_anchor`;
$d22f524fe750cd15$export$bd70860eb87e972b = `_1B3yza_current-value`;
$d22f524fe750cd15$export$536347ba10a26096 = `_1B3yza_form-footer`;
$d22f524fe750cd15$export$55a1f87a143fb302 = `_1B3yza_form-group`;
$d22f524fe750cd15$export$1ca1ec8b29a4ce27 = `_1B3yza_icon`;
$d22f524fe750cd15$export$a5810537250b846d = `_1B3yza_operation-type`;
$d22f524fe750cd15$export$f2febdad47edd01a = `_1B3yza_value-label`;
$d22f524fe750cd15$export$16d768213d218756 = `_1B3yza_value-placeholder`;

});

parcelRegister("lGDHF", function(module, exports) {

$parcel$export(module.exports, "findSelectedIssuesWithLowerPosition", () => $4b656f5259914afa$export$7b9e63090edd886b);

var $8L1yQ = parcelRequire("8L1yQ");
var $aAR0h = parcelRequire("aAR0h");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");
const $4b656f5259914afa$export$ad9e6c0d0da0679b = (anchor, issues, selectedIdsSet)=>{
    const allSortedIssuesWithNewRank = issues.map((issue)=>{
        if (selectedIdsSet.has(issue.id)) return {
            ...issue,
            lexoRank: anchor.lexoRank
        };
        return issue;
    });
    return (0, $7CnHa.indexBy)((issue)=>issue.id, allSortedIssuesWithNewRank);
};
const $4b656f5259914afa$export$7b9e63090edd886b = ({ allSortedIssues: allSortedIssues, anchorFieldValue: anchorFieldValue, getAncestors: getAncestors, issues: issues, operationTypeFieldValue: operationTypeFieldValue, selectedIdsSet: selectedIdsSet, selectedIssues: selectedIssues })=>{
    switch(operationTypeFieldValue){
        case 0, $eOsHk.RANK_TOP:
            {
                // if some of issue ancestor is not selected it means that issue will have lower position than new rank
                const issuesWithLowerPosition = selectedIssues.filter(({ id: id })=>{
                    const ancestors = getAncestors(id);
                    return $8L1yQ.default((x, y)=>x.id === y.id, ancestors, selectedIssues).length;
                });
                return {
                    issuesWithLowerPosition: issuesWithLowerPosition,
                    issuesWithHigherPosition: []
                };
            }
        case 0, $eOsHk.RANK_LAST:
            {
                const anchor = $aAR0h.default(({ id: id })=>!selectedIdsSet.has(id), allSortedIssues);
                if (!anchor) return {
                    issuesWithLowerPosition: [],
                    issuesWithHigherPosition: []
                };
                const issuesMapByIdWithNewRank = $4b656f5259914afa$export$ad9e6c0d0da0679b(anchor, issues, selectedIdsSet);
                const issuesWithHigherPosition = selectedIssues.filter(({ id: id })=>{
                    // applying new lexorank for ancestors, filter out selected ancestors and compare
                    // if some issue has lower lexoRank than some unselected ancestor
                    // that means we have at least one issue placed after selected issue
                    const ancestors = getAncestors(id)// eslint-disable-next-line @typescript-eslint/no-shadow
                    .map(({ id: id })=>issuesMapByIdWithNewRank[id]).filter((el)=>!!el);
                    return ancestors.length ? ancestors.some(({ lexoRank: ancestorLexoRank, id: ancestorId })=>issues.some(// eslint-disable-next-line @typescript-eslint/no-shadow
                        ({ lexoRank: lexoRank, id: id })=>lexoRank >= ancestorLexoRank && ancestorId !== id)) : [];
                });
                return {
                    issuesWithLowerPosition: [],
                    issuesWithHigherPosition: issuesWithHigherPosition
                };
            }
        default:
            {
                const anchor = anchorFieldValue && allSortedIssues.find(({ id: id })=>id === anchorFieldValue);
                if (!anchor) return {
                    issuesWithLowerPosition: [],
                    issuesWithHigherPosition: []
                };
                const issuesMapByIdWithNewRank = $4b656f5259914afa$export$ad9e6c0d0da0679b(anchor, issues, selectedIdsSet);
                const issuesWithLowerPosition = [];
                const issuesWithHigherPosition = [];
                for (const issue of selectedIssues){
                    const { id: id, lexoRank: selectedLexoRank } = selectedIdsSet.has(issue.id) ? {
                        ...issue,
                        lexoRank: anchor.lexoRank
                    } : issue;
                    const ancestors = getAncestors(id).map((el)=>issuesMapByIdWithNewRank[el.id]).filter((el)=>!!el);
                    if (!ancestors.length) return {
                        issuesWithLowerPosition: issuesWithLowerPosition,
                        issuesWithHigherPosition: issuesWithHigherPosition
                    };
                    if (// check if issue will has lower position than new rank
                    ancestors.some(({ lexoRank: lexoRank })=>operationTypeFieldValue === (0, $eOsHk.RANK_AFTER) ? selectedLexoRank < lexoRank : selectedLexoRank <= lexoRank)) issuesWithLowerPosition.push(issue);
                    else if (// check if issue will has higher position than new rank
                    ancestors.some(({ lexoRank: ancestorLexoRank, id: ancestorId })=>issues.some(// eslint-disable-next-line @typescript-eslint/no-shadow
                        ({ lexoRank: lexoRank, id: id })=>lexoRank >= ancestorLexoRank && ancestorId !== id))) issuesWithHigherPosition.push(issue);
                }
                return {
                    issuesWithLowerPosition: issuesWithLowerPosition,
                    issuesWithHigherPosition: issuesWithHigherPosition
                };
            }
    }
};

});





parcelRegister("4ugWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde739e538355714$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eksN4 = parcelRequire("eksN4");

var $kdYj9 = parcelRequire("kdYj9");

var $axBUt = parcelRequire("axBUt");
var $cde739e538355714$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $kdYj9.default), (0, $eksN4.default))((0, $axBUt.default));

});
parcelRegister("eksN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $010c11af7202d7cc$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$010c11af7202d7cc$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("kdYj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $650f398e6481e70c$export$2e2bcd8739ae039);
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
var $650f398e6481e70c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    issues: (0, $cwP4d.getIssues),
    sprints: (0, $c1XMU.getSprints),
    sprintsByTeam: (0, $c1XMU.getSprintsForTeam),
    teamsById: (0, $MQRDu.getTeamsById),
    teams: (0, $MQRDu.getTeams),
    sprintsByIssueSources: (0, $c1XMU.getSprintsForIssueSources),
    additionalTeamsById: (0, $MQRDu.getAdditionalTeamsById)
});

});

parcelRegister("axBUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6066d23c3b6aef2c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $a4NMN = parcelRequire("a4NMN");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $bRhkt = parcelRequire("bRhkt");
// eslint-disable-next-line jira/react/no-class-components
class $6066d23c3b6aef2c$var$SetSprintDialog extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
        const groupedOptions = this.getGroupedOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $bRhkt.default).setHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.SET_SPRINT),
            currentValue: this.getCurrentValue(),
            options: groupedOptions,
            onCancel: toggleModalDialog,
            onSubmit: (formData, analyticsEvent)=>{
                bulkUpdateAttribute(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, sprints: sprints } = this.props;
            const firstValue = selectedIssues[0].sprint;
            const isSameValue = !selectedIssues.some((issue)=>!$5OdRK.default(issue.sprint, firstValue));
            if (isSameValue && !firstValue) return formatMessage((0, $ib5d3.default).none);
            const sprint = sprints.find((el)=>el.id === firstValue);
            if (isSameValue && firstValue && sprint) return sprint.title;
            return formatMessage((0, $bRhkt.default).variousValues);
        };
        this.getGroupedOptions = ()=>{
            const { additionalTeamsById: additionalTeamsById, intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, sprintsByTeam: sprintsByTeam, sprintsByIssueSources: sprintsByIssueSources, teams: teams, teamsById: teamsById } = this.props;
            const { sprint: sprintOfIssue, team: teamOfIssue } = selectedIssues[0];
            const otherSprintsLabel = formatMessage((0, $bRhkt.default).otherSprints);
            const futureSprintsGroupByTeam = (0, $a4NMN.getFutureSprintGroups)(teamOfIssue, sprintOfIssue, sprintsByIssueSources, sprintsByTeam, additionalTeamsById, teams, teamsById, otherSprintsLabel);
            const groupedOptions = [
                {
                    options: [
                        {
                            label: formatMessage((0, $ib5d3.default).none),
                            value: 'NONE'
                        }
                    ]
                }
            ];
            futureSprintsGroupByTeam.forEach((sprints, label)=>{
                groupedOptions.push({
                    label: label,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: sprints.map((s)=>({
                            value: s.id,
                            label: s.title
                        }))
                });
            });
            return groupedOptions;
        };
    }
}
var $6066d23c3b6aef2c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($6066d23c3b6aef2c$var$SetSprintDialog);

});
parcelRegister("bRhkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91f0f81c3e6f0af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b91f0f81c3e6f0af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.set-header",
        "defaultMessage": "Update sprint"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.various-values",
        "defaultMessage": "Various sprints"
    },
    otherSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-sprint.other-sprints",
        "defaultMessage": "Other sprints"
    }
});

});



parcelRegister("e72nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15a1229656e03fd6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bIoQ4 = parcelRequire("bIoQ4");

var $d2OAX = parcelRequire("d2OAX");

var $7ulfN = parcelRequire("7ulfN");
var $15a1229656e03fd6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $d2OAX.default), (0, $bIoQ4.default))((0, $7ulfN.default));

});
parcelRegister("bIoQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7efc6f56a402201$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7efc6f56a402201$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("d2OAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e533716afb03a4ff$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
var $e533716afb03a4ff$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    teams: (0, $MQRDu.getTeams),
    teamsById: (0, $MQRDu.getAllTeamsById)
});

});

parcelRegister("7ulfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b90dd52d1bbb945$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $lClE6 = parcelRequire("lClE6");

var $ib5d3 = parcelRequire("ib5d3");

var $3cEiU = parcelRequire("3cEiU");
// eslint-disable-next-line jira/react/no-class-components
class $1b90dd52d1bbb945$var$SetTeamsDialog extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, teams: teams, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $3cEiU.default).setTeamHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.SET_TEAM),
            options: teams.map((el)=>({
                    value: el.id,
                    label: el.title
                })),
            currentValue: this.getCurrentValue(),
            onCancel: toggleModalDialog,
            onSubmit: (formData, analyticsEvent)=>{
                bulkUpdateAttribute(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, teamsById: teamsById } = this.props;
            const firstValue = selectedIssues[0].team;
            const isSameValue = !selectedIssues.some((issue)=>!$5OdRK.default(issue.team, firstValue));
            if (isSameValue && !firstValue) return formatMessage((0, $ib5d3.default).none);
            if (isSameValue && firstValue) return teamsById[firstValue].title;
            return formatMessage((0, $3cEiU.default).variousValues);
        };
    }
}
var $1b90dd52d1bbb945$export$2e2bcd8739ae039 = (0, $2qhQi.default)($1b90dd52d1bbb945$var$SetTeamsDialog);

});
parcelRegister("3cEiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e7f73284d0d168c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3e7f73284d0d168c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setTeamHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams.set-team-header",
        "defaultMessage": "Update team"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-teams.various-values",
        "defaultMessage": "Various teams"
    }
});

});



parcelRegister("kI81z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4baafba68667f3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $dsbmG = parcelRequire("dsbmG");

var $bqmMu = parcelRequire("bqmMu");

var $khgAR = parcelRequire("khgAR");
var $7d4baafba68667f3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bqmMu.default), (0, $dsbmG.default))((0, $khgAR.default));

});
parcelRegister("dsbmG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d427ac52309fbb$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$90d427ac52309fbb$export$2e2bcd8739ae039 = {
    bulkUpdateAttribute: (0, $1Szmp.bulkIssuesUpdate)
};

});

parcelRegister("bqmMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5258b23b46a426$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $kwMvv = parcelRequire("kwMvv");

var $wcCGG = parcelRequire("wcCGG");

var $iK4oF = parcelRequire("iK4oF");
var $de5258b23b46a426$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelectedIssues),
    versions: (0, $wcCGG.getVersions),
    versionsById: (0, $wcCGG.getVersionsById),
    crossProjectVersionsById: (0, $2Ruxt.getCrossProjectVersionsById),
    sortVersionsByHighestRank: (0, $wcCGG.getSortByHighestRank),
    sortVersionsByLowestRank: (0, $wcCGG.getSortByLowestRank)
});

});

parcelRegister("khgAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8677813d925c3337$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $cQGVO = parcelRequire("cQGVO");

var $2qhQi = parcelRequire("2qhQi");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $lClE6 = parcelRequire("lClE6");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $7aiur = parcelRequire("7aiur");

var $8iKjZ = parcelRequire("8iKjZ");
// eslint-disable-next-line jira/react/no-class-components
class $8677813d925c3337$var$SetVersionsDialog extends (0, $eUqFw.Component) {
    getUnreleasedOptionsGroup(versions) {
        const { intl: { formatMessage: formatMessage }, crossProjectVersionsById: crossProjectVersionsById, sortVersionsByLowestRank: sortVersionsByLowestRank } = this.props;
        const unreleasedVersions = $fpul1.default((version)=>version.releaseStatusId !== (0, $5rYNM.RELEASE_STATUSES).RELEASED, versions);
        return {
            label: formatMessage((0, $8iKjZ.default).unreleased),
            options: $cQGVO.default((version)=>(0, $7aiur.createVersionOption)(version, crossProjectVersionsById), sortVersionsByLowestRank(unreleasedVersions))
        };
    }
    getReleasedOptionsGroup(versions) {
        const { intl: { formatMessage: formatMessage }, crossProjectVersionsById: crossProjectVersionsById, sortVersionsByHighestRank: sortVersionsByHighestRank } = this.props;
        const ReleasedVersions = $fpul1.default((version)=>version.releaseStatusId === (0, $5rYNM.RELEASE_STATUSES).RELEASED, versions);
        return {
            label: formatMessage((0, $8iKjZ.default).released),
            options: $cQGVO.default((version)=>(0, $7aiur.createVersionOption)(version, crossProjectVersionsById), sortVersionsByHighestRank(ReleasedVersions))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, toggleModalDialog: toggleModalDialog, bulkUpdateAttribute: bulkUpdateAttribute, UpdateAttributeForm: UpdateAttributeForm, bulkActionSuccess: bulkActionSuccess } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            shouldScrollInViewport: true,
            onClose: toggleModalDialog,
            width: (0, $lClE6.MODAL_DIALOG_WIDTH),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $8iKjZ.default).setReleaseHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateAttributeForm, {
            updatedAttributeType: (0, $lClE6.SET_RELEASE),
            options: this.getOptions(),
            currentValue: this.getCurrentValue(),
            onCancel: toggleModalDialog,
            onSubmit: (formData, analyticsEvent)=>{
                bulkUpdateAttribute(formData);
                toggleModalDialog();
                bulkActionSuccess(analyticsEvent);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.getCurrentValue = ()=>{
            const { intl: { formatMessage: formatMessage }, selectedIssues: selectedIssues, versionsById: versionsById } = this.props;
            const firstValue = selectedIssues[0].fixVersions || [];
            const isSameValue = !selectedIssues.some((issue)=>!$5OdRK.default(issue.fixVersions || [], firstValue));
            if (isSameValue && !firstValue.length) return formatMessage((0, $ib5d3.default).none);
            if (isSameValue && firstValue.length) return firstValue.map((versionId)=>versionsById[versionId].name).join(', ');
            return formatMessage((0, $8iKjZ.default).variousValues);
        };
        this.getOptions = ()=>{
            const { versions: versions, selectedIssues: selectedIssues } = this.props;
            const projectOfIssues = selectedIssues[0].project;
            const versionsInProject = versions.filter((version)=>version.projects.includes(projectOfIssues));
            return [
                this.getReleasedOptionsGroup(versionsInProject),
                this.getUnreleasedOptionsGroup(versionsInProject)
            ];
        };
    }
}
var $8677813d925c3337$export$2e2bcd8739ae039 = (0, $2qhQi.default)($8677813d925c3337$var$SetVersionsDialog);

});
parcelRegister("8iKjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $171ce16e77158a06$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $171ce16e77158a06$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setReleaseHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.set-release-header",
        "defaultMessage": "Update release"
    },
    variousValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.various-values",
        "defaultMessage": "Various releases"
    },
    released: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.bulk-actions.dialog.set-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});

});






parcelRegister("gJFoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e939c4fab4b6bde5$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $88u4K = parcelRequire("88u4K");

var $lbIcD = parcelRequire("lbIcD");
var $e939c4fab4b6bde5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $88u4K.default))((0, $lbIcD.default));

});
parcelRegister("88u4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb310157e8bc12ee$export$2e2bcd8739ae039);

var $1XIAV = parcelRequire("1XIAV");
const $cb310157e8bc12ee$var$mapDispatchToProps = (dispatch)=>({
        toggleExpansionIssuesInHierarchy: (isExpanded)=>{
            dispatch((0, $1XIAV.toggleExpansionInHierarchy)({
                isExpanded: isExpanded
            }));
        }
    });
var $cb310157e8bc12ee$export$2e2bcd8739ae039 = $cb310157e8bc12ee$var$mapDispatchToProps;

});
parcelRegister("1XIAV", function(module, exports) {

$parcel$export(module.exports, "toggleExpansionInHierarchy", () => $ab6a2b27099f25ed$export$40b195b9736bc1c1);
$parcel$export(module.exports, "expandIssueWithAncestors", () => $ab6a2b27099f25ed$export$bc4b62590296b977);
$parcel$export(module.exports, "default", () => $ab6a2b27099f25ed$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kXdPE = parcelRequire("kXdPE");

var $1Szmp = parcelRequire("1Szmp");
var $c7fhc = parcelRequire("c7fhc");

var $6UAvZ = parcelRequire("6UAvZ");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $aK3ri = parcelRequire("aK3ri");

var $40hi6 = parcelRequire("40hi6");
var $dJx9o = parcelRequire("dJx9o");

var $kyGCj = parcelRequire("kyGCj");

var $l1dWb = parcelRequire("l1dWb");

var $5rYNM = parcelRequire("5rYNM");
const $ab6a2b27099f25ed$export$b561bc689aa98a92 = 'command.scope.TOGGLE_EXPANSION_IN_HIERARCHY';
const $ab6a2b27099f25ed$export$9b3d94732c38bcaf = 'command.scope.EXPAND_ISSUE_WITH_ANCESTORS';
const $ab6a2b27099f25ed$export$40b195b9736bc1c1 = (payload)=>({
        type: $ab6a2b27099f25ed$export$b561bc689aa98a92,
        payload: payload
    });
function* $ab6a2b27099f25ed$export$52581e97dce9708a({ payload: { isExpanded: isExpanded } }) {
    const filteredIssuesWithHierarchy = yield (0, $9e8i2.select)((0, $kwMvv.getFilteredIssuesWithHierarchy));
    const visualisationGrouping = (yield (0, $9e8i2.select)((0, $kyGCj.getVisualisationGrouping))) || (0, $5rYNM.GROUPING).NONE;
    const hierarchyFilter = yield (0, $9e8i2.select)((0, $6UAvZ.getHierarchyFilter));
    const descendantsByParent = yield (0, $9e8i2.select)((0, $aK3ri.getDescendantsByParent));
    yield* (0, $kXdPE.default)(function*() {
        const collapseIssues = {};
        const headerIds = [
            'IssuesWithoutParentHeader'
        ];
        for(let i = hierarchyFilter.value.end; i <= hierarchyFilter.value.start; i++)headerIds.push(`IssuesWithoutParent-${i}`);
        if (visualisationGrouping === (0, $5rYNM.GROUPING).NONE) {
            for (const issue of filteredIssuesWithHierarchy)// If the issue doesn't have children, then no need to store the expand/collapse state
            if ((descendantsByParent[issue.id] || []).length > 0) collapseIssues[issue.id] = isExpanded;
            for (const header of headerIds)collapseIssues[header] = isExpanded;
        } else {
            const issuesByGroup = yield (0, $9e8i2.select)((0, $40hi6.getIssuesByGroup));
            const parentGroups = new Set();
            const filteredIssueIds = new Set(filteredIssuesWithHierarchy.map((x)=>x.id));
            for (const group of Object.values(issuesByGroup)){
                const { issues: issues = new Set(), parentGroup: parentGroup, ...groupCombination } = group;
                for (const issue of issues)if (// Prevent expansion/collapse of parent issues which do not actually appear in scope but are in issuesByGroup because of ancestor/descendant completion
                filteredIssueIds.has(issue.id) && // If the issue doesn't have children, then no need to store the expand/collapse state
                (descendantsByParent[issue.id] || []).length > 0) collapseIssues[`${issue.id}:${(0, $dJx9o.getGroupKey)(groupCombination) || (0, $5rYNM.UNDEFINED_KEY)}`] = isExpanded;
                for (const header of headerIds)collapseIssues[`${header}:${(0, $dJx9o.getGroupKey)(groupCombination) || (0, $5rYNM.UNDEFINED_KEY)}`] = isExpanded;
                yield (0, $9e8i2.put)((0, $l1dWb.toggleExpandGroup)({
                    grouping: visualisationGrouping,
                    groupName: (0, $dJx9o.getGroupKey)(groupCombination),
                    expand: isExpanded
                }));
                if (group.parentGroup) parentGroups.add(group.parentGroup);
            }
            for (const parentGroup of parentGroups)yield (0, $9e8i2.put)((0, $l1dWb.toggleExpandGroup)({
                grouping: visualisationGrouping,
                groupName: parentGroup,
                expand: isExpanded
            }));
        }
        yield (0, $9e8i2.put)((0, $c7fhc.setIsExpanded)(collapseIssues));
    });
    const hierarchyRange = hierarchyFilter.value.start - hierarchyFilter.value.end;
    if (isExpanded) yield (0, $9e8i2.put)((0, $1Szmp.expandAllAnalytics)({
        hierarchyLevels: hierarchyRange
    }));
    else yield (0, $9e8i2.put)((0, $1Szmp.collapseAllAnalytics)({
        hierarchyLevels: hierarchyRange
    }));
}
function* $ab6a2b27099f25ed$export$1d9abc122ce2894a() {
    yield (0, $bG7pV.takeEvery)($ab6a2b27099f25ed$export$b561bc689aa98a92, $ab6a2b27099f25ed$export$52581e97dce9708a);
}
const $ab6a2b27099f25ed$export$bc4b62590296b977 = ()=>({
        type: $ab6a2b27099f25ed$export$9b3d94732c38bcaf
    });
const $ab6a2b27099f25ed$export$2679bca2f6357853 = (issueLevel, hierarchyStart)=>{
    const headerIds = issueLevel < hierarchyStart ? [
        'IssuesWithoutParentHeader'
    ] : [];
    for(let i = issueLevel; i < hierarchyStart; i++)headerIds.push(`IssuesWithoutParent-${i}`);
    return headerIds;
};
function* $ab6a2b27099f25ed$export$2ac8e3b8f7b93709() {
    const activeSearch = yield (0, $9e8i2.select)((0, $40hi6.getActiveSearchIssue));
    if (!activeSearch) return;
    const { id: issueId, group: activeGroupName } = activeSearch;
    const { ancestors: ancestors = [] } = (yield (0, $9e8i2.select)((0, $kwMvv.getParentAndDescendant)))[issueId] || {};
    const issueMapById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
    const issue = issueMapById[issueId];
    // A short tale about why we're double-checking for ancestors even if the getParentAndDescendant selector
    // returned no ancestors for the issue...
    // When filters are applied in the plan, a parent issue may match the filters but not its children.
    // If the "Show Full Hierarchy" option is enabled in the Filters menu, the children will be greyed out BUT
    // displayed in the plan, therefore they can be matched by the search query
    // From the getParentAndDescendant selector perspective, these children are filtered out of the plan,
    // therefore the selector does not look for ancestors or descendants for these issues.
    // However, in the context of issue search, we need those ancestors in order to expand the hierarchy
    // of the greyed out children issues matched by the search query when the user navigates through the results
    if (ancestors.length === 0) {
        let issueParentId = issue?.parent;
        // traversing the parent layers back up to the top
        while(issueParentId && issueMapById[issueParentId]){
            ancestors.push(issueMapById[issueParentId]);
            issueParentId = issueMapById[issueParentId].parent;
        }
    }
    const maxHierarchy = Math.max(...[
        ...ancestors,
        issue
    ].map(({ level: level })=>level));
    const { value: hierarchyValue } = yield (0, $9e8i2.select)((0, $6UAvZ.getHierarchyFilter));
    const headerKeys = yield (0, $9e8i2.call)($ab6a2b27099f25ed$export$2679bca2f6357853, maxHierarchy, hierarchyValue.start);
    let expandPayload;
    const visualisationGrouping = (yield (0, $9e8i2.select)((0, $kyGCj.getVisualisationGrouping))) || (0, $5rYNM.GROUPING).NONE;
    if (visualisationGrouping === (0, $5rYNM.GROUPING).NONE) {
        expandPayload = ancestors.reduce((acc, { id: id })=>Object.assign(acc, {
                [id]: true
            }), {});
        for (const header of headerKeys)expandPayload[header] = true;
    } else {
        const groupCombinationByIssue = yield (0, $9e8i2.select)((0, $40hi6.getGroupCombinationByIssueId));
        const parentGroups = new Set();
        for (const { groupCombination: groupCombination, parentGroup: parentGroup } of groupCombinationByIssue[issueId]){
            const groupName = (0, $dJx9o.getGroupKey)(groupCombination);
            if (groupName === activeGroupName) {
                if (parentGroup) parentGroups.add(parentGroup);
                expandPayload = (ancestors || []).reduce((acc, { id: id })=>Object.assign(acc, {
                        [`${id}:${groupName || (0, $5rYNM.UNDEFINED_KEY)}`]: true
                    }), {});
                for (const header of headerKeys)expandPayload[`${header}:${groupName || (0, $5rYNM.UNDEFINED_KEY)}`] = true;
                for (const group of parentGroups)yield (0, $9e8i2.put)((0, $l1dWb.toggleExpandGroup)({
                    grouping: visualisationGrouping,
                    groupName: group,
                    expand: true
                }));
                yield (0, $9e8i2.put)((0, $l1dWb.toggleExpandGroup)({
                    grouping: visualisationGrouping,
                    groupName: groupName,
                    expand: true
                }));
            }
        }
    }
    if (expandPayload) yield (0, $9e8i2.put)((0, $c7fhc.setIsExpanded)(expandPayload));
}
function* $ab6a2b27099f25ed$export$3fe79bd01779fcb5() {
    yield (0, $bG7pV.takeLatest)($ab6a2b27099f25ed$export$9b3d94732c38bcaf, $ab6a2b27099f25ed$export$2ac8e3b8f7b93709);
}
function* $ab6a2b27099f25ed$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($ab6a2b27099f25ed$export$1d9abc122ce2894a);
    yield (0, $9e8i2.fork)($ab6a2b27099f25ed$export$3fe79bd01779fcb5);
}

});


parcelRegister("lbIcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d7ccd8b85915a8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $8uD7Y = parcelRequire("8uD7Y");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $2BQwE = parcelRequire("2BQwE");

var $duQ8C = parcelRequire("duQ8C");

var $4ABQE = parcelRequire("4ABQE");
function $19d7ccd8b85915a8$var$CollapseMenu({ toggleExpansionIssuesInHierarchy: toggleExpansionIssuesInHierarchy }) {
    const renderMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            onClick: (event)=>{
                (0, $duQ8C.default)((0, $2BQwE.KEYS).EXPAND_ALL_ISSUES, event.timeStamp);
                toggleExpansionIssuesInHierarchy(true);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4ABQE.default).expandHierarchy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            onClick: (event)=>{
                (0, $duQ8C.default)((0, $2BQwE.KEYS).COLLAPSE_ALL_ISSUES, event.timeStamp);
                toggleExpansionIssuesInHierarchy(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4ABQE.default).collapseHierarchy)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                ref: triggerRef,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.trigger-btn",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                appearance: "subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4ABQE.default).buttonTitle))
    }, renderMenu());
}
var $19d7ccd8b85915a8$export$2e2bcd8739ae039 = $19d7ccd8b85915a8$var$CollapseMenu;

});
parcelRegister("4ABQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $167cc24f0ca9ed20$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $167cc24f0ca9ed20$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    buttonTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.button-title",
        "defaultMessage": "Issue"
    },
    collapseHierarchy: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.collapse-hierarchy",
        "defaultMessage": "Collapse all"
    },
    expandHierarchy: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.collapse-menu.expand-hierarchy",
        "defaultMessage": "Expand all"
    }
});

});



parcelRegister("8J8wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $553d4115617691cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $553d4115617691cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    scope: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.scope",
        "defaultMessage": "Scope"
    },
    selectedIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.selected-issues",
        "defaultMessage": "{totalSelected, plural, one {# issue} other {# issues}} selected"
    },
    selectAllIssuesCheckboxAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.header.select-all-issues-checkbox-aria-label",
        "defaultMessage": "Select all issues"
    }
});

});

parcelRegister("cDjM2", function(module, exports) {

$parcel$export(module.exports, "bulkActions", () => $9328773e2ec84b43$export$ee73713cf34db5fd, (v) => $9328773e2ec84b43$export$ee73713cf34db5fd = v);
$parcel$export(module.exports, "issueHeader", () => $9328773e2ec84b43$export$297a7c3b2af7cbfc, (v) => $9328773e2ec84b43$export$297a7c3b2af7cbfc = v);
$parcel$export(module.exports, "left", () => $9328773e2ec84b43$export$eabcd2c8791e7bf4, (v) => $9328773e2ec84b43$export$eabcd2c8791e7bf4 = v);
$parcel$export(module.exports, "rankHeader", () => $9328773e2ec84b43$export$9078b33db607c704, (v) => $9328773e2ec84b43$export$9078b33db607c704 = v);
$parcel$export(module.exports, "scope-row", () => $9328773e2ec84b43$export$d93aae1553572380, (v) => $9328773e2ec84b43$export$d93aae1553572380 = v);
$parcel$export(module.exports, "selected", () => $9328773e2ec84b43$export$d90250155de6d7e7, (v) => $9328773e2ec84b43$export$d90250155de6d7e7 = v);
$parcel$export(module.exports, "spaBottomHeader", () => $9328773e2ec84b43$export$56f44c8502500e02, (v) => $9328773e2ec84b43$export$56f44c8502500e02 = v);
$parcel$export(module.exports, "spaHeader", () => $9328773e2ec84b43$export$2cdbf177bee1ac99, (v) => $9328773e2ec84b43$export$2cdbf177bee1ac99 = v);
var $9328773e2ec84b43$export$ee73713cf34db5fd;
var $9328773e2ec84b43$export$297a7c3b2af7cbfc;
var $9328773e2ec84b43$export$eabcd2c8791e7bf4;
var $9328773e2ec84b43$export$9078b33db607c704;
var $9328773e2ec84b43$export$d93aae1553572380;
var $9328773e2ec84b43$export$d90250155de6d7e7;
var $9328773e2ec84b43$export$56f44c8502500e02;
var $9328773e2ec84b43$export$2cdbf177bee1ac99;
$9328773e2ec84b43$export$ee73713cf34db5fd = `Ls6rIG_bulkActions`;
$9328773e2ec84b43$export$297a7c3b2af7cbfc = `Ls6rIG_issueHeader`;
$9328773e2ec84b43$export$eabcd2c8791e7bf4 = `Ls6rIG_left`;
$9328773e2ec84b43$export$9078b33db607c704 = `Ls6rIG_rankHeader`;
$9328773e2ec84b43$export$d93aae1553572380 = `Ls6rIG_scope-row`;
$9328773e2ec84b43$export$d90250155de6d7e7 = `Ls6rIG_selected`;
$9328773e2ec84b43$export$56f44c8502500e02 = `Ls6rIG_spaBottomHeader`;
$9328773e2ec84b43$export$2cdbf177bee1ac99 = `Ls6rIG_spaHeader`;

});



parcelRegister("7DHvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dde7d5445c4c056$export$2e2bcd8739ae039);
parcelRequire("2ZiOh");
var $eJkeb = parcelRequire("eJkeb");

var $lNNXV = parcelRequire("lNNXV");

var $gk7Mi = parcelRequire("gk7Mi");

var $8Nqhy = parcelRequire("8Nqhy");

var $lL8pM = parcelRequire("lL8pM");
const $0dde7d5445c4c056$var$Issues = (0, $lNNXV.connect)((0, $8Nqhy.default), (0, $gk7Mi.default))((0, $lL8pM.default));
// @ts-expect-error - connect does not have a component interface for `why-did-you-render`
$0dde7d5445c4c056$var$Issues.whyDidYouRender = true;
$0dde7d5445c4c056$var$Issues.displayName = 'Issues';
var // Type Props is polluted with intl and connect
$0dde7d5445c4c056$export$2e2bcd8739ae039 = (0, $eJkeb.default)(// @ts-expect-error - TS2345 - Argument of type 'ComponentClass<Omit<{ clearFilters: () => void; onToggle: (payload: Partial<Record<string, boolean>>) => { type: "state.domain.view-settings.issue-expansions.SET_IS_EXPANDED"; payload: Partial<...>; }; onMove: (payload: MoveIssuePayload) => { ...; }; onInvalidRanking: (payload: FlagActionPayload) => FlagAction; togg...' is not assignable to parameter of type 'AbstractComponent<Diff<Props, InjectedProps> & InjectedProps, any>'.
$0dde7d5445c4c056$var$Issues, 'portfolio-3.simple-plans.roadmap.issues-column');

});
parcelRegister("gk7Mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $711e7bf622b1e2b4$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var $c7fhc = parcelRequire("c7fhc");

var $9ozqH = parcelRequire("9ozqH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$711e7bf622b1e2b4$export$2e2bcd8739ae039 = (dispatch)=>({
        onToggle: (payload)=>dispatch((0, $c7fhc.setIsExpanded)(payload)),
        onMove: (payload)=>dispatch((0, $1Szmp.moveIssue)(payload)),
        onInvalidRanking: (payload)=>dispatch((0, $9ozqH.addFlag)(payload))
    });

});

parcelRegister("8Nqhy", function(module, exports) {

$parcel$export(module.exports, "getEnhancedIssues", () => $c6788499b915abe3$export$39b2928f3df68999);
$parcel$export(module.exports, "getTagTableItems", () => $c6788499b915abe3$export$86385f4dbe276904);
$parcel$export(module.exports, "default", () => $c6788499b915abe3$export$2e2bcd8739ae039);

var $f7Op5 = parcelRequire("f7Op5");

var $dYnI4 = parcelRequire("dYnI4");

var $akhOi = parcelRequire("akhOi");

var $kKj1m = parcelRequire("kKj1m");

var $fZW8G = parcelRequire("fZW8G");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $a0bo1 = parcelRequire("a0bo1");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $YHQpz = parcelRequire("YHQpz");

var $8RAUa = parcelRequire("8RAUa");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $ayXoc = parcelRequire("ayXoc");
const $c6788499b915abe3$export$74a7083d7abc94c3 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getVisualisationViewSettings),
    (0, $kKj1m.getCustomFieldsById)
], (viewSetting, customFieldsById)=>{
    const grouping = viewSetting.grouping;
    const customFieldId = (0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping);
    if (customFieldId.length > 0) {
        const fieldType = customFieldsById[Number(customFieldId)]?.type?.key;
        return (0, $ayXoc.isMultiSelectCustomField)(fieldType);
    }
    return false;
});
const $c6788499b915abe3$export$8448badc5d8eb2d6 = (tableItems, issueTypes, projects, hierarchyLevelsByLevel)=>{
    const id = $f7Op5.default('id');
    const issueTypesById = (0, $7CnHa.indexBy)(id, issueTypes);
    const projectsById = (0, $7CnHa.indexBy)(id, projects);
    // NOTE `enhance` is written in ill-typed and mutable style for the sake of performance
    // this code turned out to be a hot spot and we want to reduce GC and computational load
    const enhance = (issue)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        for (const key of Object.keys(issue))// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[key] = issue[key];
        result.type = issueTypesById[issue.type] || (0, $8RAUa.DEFAULT_SCRATCH_ISSUE_TYPE); // May not exist if issue sources have changed.
        result.project = projectsById[issue.project];
        // unsafe cast, but scope of `result` is small which helps to ensure it's proper structure
        // by inspecting the code above
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return result;
    };
    return tableItems.map((item)=>{
        switch(item.tag){
            case 0, $a0bo1.TABLE_ISSUE:
                {
                    const { tag: tag, value: issue, group: group, parentGroup: parentGroup, groupCombination: groupCombination } = item;
                    const enhancedIssue = {
                        tag: tag,
                        value: enhance(issue),
                        group: group,
                        parentGroup: parentGroup,
                        groupCombination: groupCombination
                    };
                    return enhancedIssue;
                }
            case 0, $a0bo1.TABLE_GROUP_HEADER:
                {
                    const { tag: tag, // eslint-disable-next-line @typescript-eslint/no-shadow
                    value: { id: id, isExpanded: isExpanded, level: level, rootIssuesCount: rootIssuesCount }, group: group, parentGroup: parentGroup } = item;
                    const enhancedHeader = {
                        tag: tag,
                        value: {
                            id: id,
                            isExpanded: isExpanded,
                            level: hierarchyLevelsByLevel[level],
                            rootIssuesCount: rootIssuesCount
                        },
                        group: group,
                        parentGroup: parentGroup
                    };
                    return enhancedHeader;
                }
            default:
                return item;
        }
    });
};
const $c6788499b915abe3$export$1e3085667260a419 = (0, $dYnI4.monitor).timeFunction($c6788499b915abe3$export$8448badc5d8eb2d6, 'roadmap_scope_issues_query_getEnhancedIssuesPure');
const $c6788499b915abe3$export$39b2928f3df68999 = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getTableItems),
    (0, $lihml.getIssueTypes),
    (0, $ehEr2.getProjects),
    (0, $fZW8G.getHierarchyLevelsByLevel)
], $c6788499b915abe3$export$1e3085667260a419);
const $c6788499b915abe3$export$ee51405ad885730a = (issues)=>issues.filter((item)=>item.tag === (0, $a0bo1.TABLE_GROUP));
const $c6788499b915abe3$export$86385f4dbe276904 = (0, $iK4oF.createSelector)([
    $c6788499b915abe3$export$39b2928f3df68999
], $c6788499b915abe3$export$ee51405ad885730a);
const $c6788499b915abe3$var$getGroupBySetting = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getVisualisationViewSettings)
], (viewSetting)=>viewSetting.grouping);
var $c6788499b915abe3$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    $c6788499b915abe3$export$39b2928f3df68999,
    (0, $a0bo1.getScrollToIndex),
    (0, $a0bo1.getDisableDnD),
    (0, $akhOi.getMode),
    (0, $cwP4d.getIssues),
    (0, $40hi6.getScope),
    (0, $kwMvv.getIsIssuesLoading),
    (0, $YHQpz.getWarnings),
    (0, $9H2AP.getWarningViewSettings),
    (0, $kyGCj.getVisualisationSorting),
    $c6788499b915abe3$export$74a7083d7abc94c3,
    $c6788499b915abe3$var$getGroupBySetting
], (issues, scrollToIndex, disableDnD, mode, issuesInPlan, scope, isLoading, warnings, warningSetting, sorting, isGroupingByMultiSelectCustomField, // eslint-disable-next-line @typescript-eslint/no-shadow
getGroupBySetting)=>({
        isLoading: isLoading,
        scrollToIndex: scrollToIndex,
        disableDnD: disableDnD,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        issues: issues,
        noIssuesInPlan: issuesInPlan.length === 0,
        rankDigits: scope.startLevelIssues.rootIssuesCount.toString().length,
        startLevel: scope.startLevelIssues.level,
        warnings: warnings,
        showWarning: warningSetting.showWarning,
        sorting: sorting,
        isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField,
        grouping: getGroupBySetting
    }));

});

parcelRegister("lL8pM", function(module, exports) {

$parcel$export(module.exports, "default", () => $da43d31fe3089c1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gJXdx = parcelRequire("gJXdx");

var $illlw = parcelRequire("illlw");

var $18sGt = parcelRequire("18sGt");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9hVJ7 = parcelRequire("9hVJ7");

var $dYnI4 = parcelRequire("dYnI4");
parcelRequire("1nPPv");

var $a0bo1 = parcelRequire("a0bo1");

var $3dOx1 = parcelRequire("3dOx1");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hPeQq = parcelRequire("hPeQq");

var $ib5d3 = parcelRequire("ib5d3");

var $7LAU3 = parcelRequire("7LAU3");

var $99lB7 = parcelRequire("99lB7");

var $auj1s = parcelRequire("auj1s");

var $9sEgY = parcelRequire("9sEgY");

var $eEsJ2 = parcelRequire("eEsJ2");

var $cAXRn = parcelRequire("cAXRn");


var $aytOt = parcelRequire("aytOt");

var $k4LoK = parcelRequire("k4LoK");
const $da43d31fe3089c1d$export$9bfc48465d72b9d6 = {
    anchor: null,
    group: null,
    id: null,
    parentId: null,
    relation: null,
    type: (0, $6b22482c0db9401b$export$6182a67c5764bd0f),
    errorType: null
};
const $da43d31fe3089c1d$var$IssuesHOC = (props)=>{
    const oldWidth = (0, $eUqFw.useRef)(props.width);
    const listContainerElRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (props.isDragging && oldWidth.current !== props.width && listContainerElRef.current) {
            (0, $hPeQq.manuallyUpdateReactVirtualizedListWidth)(listContainerElRef.current, props.width);
            oldWidth.current = props.width;
        }
    }, [
        props.isDragging,
        props.width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da43d31fe3089c1d$export$1cb51167b20548a0, {
        ...props,
        ref: listContainerElRef
    });
};
const $da43d31fe3089c1d$export$1cb51167b20548a0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onExperienceSuccess: // eslint-disable-next-line @typescript-eslint/no-empty-function
onExperienceSuccess = ()=>{}, isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField = false, SelectableIssueComponent: SelectableIssueComponent = (0, $9sEgY.default), SortableIssueComponent: SortableIssueComponent = (0, $7LAU3.SortableIssue), SortableIssuesWithoutParentComponent: SortableIssuesWithoutParentComponent = (0, $7LAU3.SortableIssuesWithoutParent), StickyHeaderComponent: StickyHeaderComponent = (0, $3dOx1.default), sorting: sorting, issues: issues, startLevel: startLevel, isLoading: isLoading, scrollToIndex: scrollToIndex, noIssuesInPlan: noIssuesInPlan, isReadOnly: isReadOnly, rankDigits: rankDigits, grouping: grouping, warnings: warnings, showWarning: showWarning, scrollElement: scrollElement, width: width, disableDnD: disableDnD, onToggle: onToggle, onMove: onMove, onInvalidRanking: onInvalidRanking }, ref)=>{
    const [drop, setDrop] = (0, $eUqFw.useState)($da43d31fe3089c1d$export$9bfc48465d72b9d6);
    const intl = (0, $5JgJ2.default)();
    const hasMounted = (0, $eUqFw.useRef)(false);
    const stickyHeaderIndex = (0, $eUqFw.useRef)(undefined);
    const onListContainerMouseDown = (e)=>{
        // Prevent text selection when we use shift key to select multiple issues
        if (e.ctrlKey || e.shiftKey) e.preventDefault();
    };
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    // Simulates componentDidUpdate
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (hasMounted.current) (0, $k4LoK.componentDidUpdateHelper)(drop, (0, $k4LoK.getDraggedNode), isLoading);
        else hasMounted.current = true;
    });
    const onSortStart = (0, $eUqFw.useCallback)(()=>{
        (0, $k4LoK.disableUserSelection)(true);
        const node = (0, $k4LoK.getDraggedNode)();
        if (node) node.classList.add($eEsJ2.isDragging);
        if (!(0, $aytOt.isSortByRank)(sorting.field)) {
            onInvalidRanking({
                key: (0, $42b69a8aa6898c13$export$5d75f74c1d4d448d)
            });
            setDrop({
                ...$da43d31fe3089c1d$export$9bfc48465d72b9d6,
                type: (0, $6b22482c0db9401b$export$2c56a3da224d2361)
            });
        }
    }, [
        onInvalidRanking,
        sorting.field
    ]);
    const onSortOver = (0, $eUqFw.useCallback)((delta)=>{
        if ((0, $aytOt.isSortByRank)(sorting.field)) setDrop((0, $aytOt.getNewDropState)({
            items: issues,
            index: delta.index,
            newIndex: delta.newIndex,
            startLevel: startLevel
        }));
    // skip onSortOver logic if issues are sorted by non-rank field
    }, [
        issues,
        sorting.field,
        startLevel
    ]);
    const onSortEnd = (0, $eUqFw.useCallback)((delta)=>{
        setDrop((currentDrop)=>(0, $k4LoK.onSortEndHelper)(currentDrop, onMove, sorting, onInvalidRanking, issues, delta));
        window.getSelection()?.empty();
    }, [
        issues,
        onInvalidRanking,
        onMove,
        sorting
    ]);
    const calculateHeightOffset = (0, $eUqFw.useCallback)(()=>{
        const nextStickyHeaderIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gJXdx)))((0, (/*@__PURE__*/$parcel$interopDefault($18sGt)))(issues, 0, scrollToIndex || issues.length), (item)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(item, 'tag') === (0, $a0bo1.TABLE_GROUP));
        if ((0, $7CnHa.isDefined)(stickyHeaderIndex.current) && nextStickyHeaderIndex <= stickyHeaderIndex.current) {
            const issue = issues[nextStickyHeaderIndex];
            const nextStickyHeaderHeight = (0, $aytOt.isTableGroupItem)(issue) && issue.height ? issue.height : 0;
            return Number(nextStickyHeaderHeight) * 40;
        }
        return 0;
    }, [
        issues,
        scrollToIndex
    ]);
    const rowRenderer = (0, $eUqFw.useCallback)(({ key: key, index: index, style: style, isScrolling: isScrolling })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cAXRn.default), {
            key: key,
            index: index,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            isScrolling: isScrolling,
            drop: drop,
            startLevel: startLevel,
            isReadOnly: isReadOnly,
            rankDigits: rankDigits,
            issues: issues,
            grouping: grouping,
            warnings: warnings,
            showWarning: showWarning,
            onToggle: onToggle,
            SelectableIssueComponent: SelectableIssueComponent,
            SortableIssueComponent: SortableIssueComponent,
            SortableIssuesWithoutParentComponent: SortableIssuesWithoutParentComponent,
            isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField
        }), [
        SelectableIssueComponent,
        SortableIssueComponent,
        SortableIssuesWithoutParentComponent,
        drop,
        grouping,
        isGroupingByMultiSelectCustomField,
        isReadOnly,
        issues,
        onToggle,
        rankDigits,
        showWarning,
        startLevel,
        warnings
    ]);
    const { parentId: parentId } = drop;
    if (!isLoading) (0, $dYnI4.monitor).startProfile((0, $5rYNM.PROFILE_KEYS).RENDER.SCOPE_TABLE);
    const getScrollContainer = (0, $eUqFw.useCallback)(()=>{
        if (!scrollElement) throw Error('scrollElement must be defined');
        return scrollElement;
    }, [
        scrollElement
    ]);
    return isLoading ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            width: '100%',
            height: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hVJ7.default), {
        ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage),
        numOfIssues: 11,
        sidePadding: 16,
        showIssueSelectCheckbox: true,
        showIssueWithoutParent: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        onMouseDown: onListContainerMouseDown,
        ref: ref
    }, (()=>{
        if (issues.length === 0) {
            if (noIssuesInPlan) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99lB7.default), {
                isReadOnly: isReadOnly
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $auj1s.default), null);
        }
        if (scrollElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$eEsJ2["drop-container"]} ${(0, $k4LoK.getDropClassName)(issues, drop)}`,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues",
            "data-name": "ScopeList"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LAU3.SortableList), {
            distance: 3,
            getContainer: getScrollContainer,
            isReadOnly: isReadOnly,
            lockToContainerEdges: true,
            lockOffset: "250%",
            onSortEnd: onSortEnd,
            onSortOver: onSortOver,
            onSortStart: onSortStart,
            rowRenderer: rowRenderer,
            rows: issues,
            scrollElement: scrollElement,
            scrollToIndex: scrollToIndex,
            heightOffset: calculateHeightOffset(),
            shouldCancelStart: (0, $k4LoK.shouldCancelStart)(disableDnD),
            width: width,
            dropParentId: parentId,
            StickyHeader: StickyHeaderComponent
        }));
        return null;
    })());
}), (_, nextProps)=>nextProps.isDragging ?? false);
var $da43d31fe3089c1d$export$2e2bcd8739ae039 = $da43d31fe3089c1d$var$IssuesHOC;

});
parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});

parcelRegister("18sGt", function(module, exports) {

var $jADKY = parcelRequire("jADKY");

var $3P7i5 = parcelRequire("3P7i5");

var $hNahz = parcelRequire("hNahz");
/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $0d3cc9d6bbe64333$var$slice(array, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    if (end && typeof end != 'number' && $3P7i5(array, start, end)) {
        start = 0;
        end = length;
    } else {
        start = start == null ? 0 : $hNahz(start);
        end = end === undefined ? length : $hNahz(end);
    }
    return $jADKY(array, start, end);
}
module.exports = $0d3cc9d6bbe64333$var$slice;

});

parcelRegister("9hVJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $033618e83c3928f5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $812KE = parcelRequire("812KE");

var $gIPv8 = parcelRequire("gIPv8");

var $1ybV0 = parcelRequire("1ybV0");

var $84CBi = parcelRequire("84CBi");

var $1FoRq = parcelRequire("1FoRq");

var $7QAbJ = parcelRequire("7QAbJ");

var $exjqP = parcelRequire("exjqP");
class $033618e83c3928f5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            numOfIssues: 10,
            rowHeight: (0, $7QAbJ.RECT_ROW_HEIGHT),
            showIssueWithoutParent: false,
            showIssueSelectCheckbox: false,
            sidePadding: 8,
            spaceInBetween: 8,
            topPadding: 8,
            animate: true
        };
    }
    render() {
        const { ariaLabel: ariaLabel, numOfIssues: numOfIssues, showIssueSelectCheckbox: showIssueSelectCheckbox, showIssueWithoutParent: showIssueWithoutParent, animate: animate } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
            name: "issue-hierarchy-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1FoRq.AutoSizer), null, ({ width: width, height: height })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $exjqP.skeleton,
                style: {
                    width: width,
                    height: height
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIPv8.default), {
                ariaLabel: ariaLabel,
                width: width,
                height: height,
                ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? {
                    animate: animate
                } : {},
                ...(0, $7QAbJ.DEFAULT_CONTENT_LOADER_PROPS)
            }, showIssueSelectCheckbox && this.getCheckboxes(), $812KE.default(0, numOfIssues).map((index)=>this.getIssues(index, width)), showIssueWithoutParent && this.getIssueWithoutParentBlock(width)))));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.checkboxSize = 16;
        this.getCheckboxes = ()=>{
            const { numOfIssues: numOfIssues, sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding } = this.props;
            const extraSpaceToCenter = Math.floor((rowHeight - this.checkboxSize) / 2);
            return $812KE.default(0, numOfIssues).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                    x: sidePadding,
                    y: index * (rowHeight + spaceInBetween) + topPadding + extraSpaceToCenter,
                    ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                    width: this.checkboxSize,
                    height: this.checkboxSize
                })));
        };
        this.getIssues = (index, width)=>{
            const { sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding, showIssueSelectCheckbox: showIssueSelectCheckbox } = this.props;
            const spaceBetweenIssueAndCheckbox = 44;
            const indentToShowHierarchy = 20;
            let xCordinate = showIssueSelectCheckbox ? sidePadding + (this.checkboxSize + spaceBetweenIssueAndCheckbox) : sidePadding;
            xCordinate = index % 2 === 0 ? xCordinate : xCordinate + indentToShowHierarchy;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: xCordinate,
                y: index * (rowHeight + spaceInBetween) + topPadding,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 2,
                height: rowHeight
            }));
        };
        this.getIssueWithoutParentBlock = (width)=>{
            const { numOfIssues: numOfIssues, sidePadding: sidePadding, spaceInBetween: spaceInBetween, rowHeight: rowHeight, topPadding: topPadding } = this.props;
            const indentToShowPerHierarchyIssueCount = 30;
            return $812KE.default(numOfIssues, numOfIssues + 3).map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                    x: index === numOfIssues ? sidePadding : sidePadding + indentToShowPerHierarchyIssueCount,
                    y: index * (rowHeight + spaceInBetween) + topPadding,
                    ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                    width: index === numOfIssues ? width / 2 : width / 3,
                    height: rowHeight
                })));
        };
    }
}

});

parcelRegister("7LAU3", function(module, exports) {

$parcel$export(module.exports, "SortableIssue", () => $6fe4c25531a8daa1$export$8ef11bbc905f2757);
$parcel$export(module.exports, "SortableIssuesWithoutParent", () => $6fe4c25531a8daa1$export$92cbe693198d9334);
$parcel$export(module.exports, "SortableIssuesWithoutParentHeader", () => $6fe4c25531a8daa1$export$458e32d4cd2843c8);
$parcel$export(module.exports, "SortableList", () => $6fe4c25531a8daa1$export$5f5bfdab9f770a66);

var $eUqFw = parcelRequire("eUqFw");

var $hXJR4 = parcelRequire("hXJR4");

var $9Ar1p = parcelRequire("9Ar1p");

var $hoaeP = parcelRequire("hoaeP");

var $H9kkp = parcelRequire("H9kkp");

var $cuuJa = parcelRequire("cuuJa");

var $i86jm = parcelRequire("i86jm");

var $djawK = parcelRequire("djawK");

var $hfAst = parcelRequire("hfAst");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $2aD9T = parcelRequire("2aD9T");
const $6fe4c25531a8daa1$export$8ef11bbc905f2757 = (0, $hXJR4.SortableElement)((0, $i86jm.default));
const $6fe4c25531a8daa1$export$92cbe693198d9334 = (0, $hXJR4.SortableElement)((0, $djawK.default));
const $6fe4c25531a8daa1$export$458e32d4cd2843c8 = (0, $hXJR4.SortableElement)((0, $hfAst.default));
class $6fe4c25531a8daa1$export$37050a05021a033e extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        const { scrollToIndex: scrollToIndex, rows: rows } = this.props;
        const listRef = this.listRef.current;
        if (listRef && scrollToIndex && scrollToIndex !== prevProps.scrollToIndex) {
            const scrollTop = listRef.getOffsetForRow({
                index: scrollToIndex
            });
            this.onChildScroll({
                scrollTop: scrollTop - this.calculateOffset()
            });
        }
        if (listRef && prevProps.rows !== rows) {
            const length = Math.min(prevProps.rows.length, rows.length);
            for(let i = 0; i < length; i++)if (prevProps.rows[i].height !== rows[i].height) {
                listRef.recomputeRowHeights();
                break;
            }
        }
    }
    render() {
        const { dropParentId: dropParentId, isReadOnly: isReadOnly, rows: rows, rowRenderer: rowRenderer, width: width = 0, scrollElement: scrollElement, StickyHeader: StickyHeader, handleScroll: handleScroll } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoaeP.WindowScroller), {
            scrollElement: scrollElement,
            onScroll: handleScroll
        }, ({ height: height = 0, isScrolling: isScrolling, onChildScroll: onChildScroll, scrollTop: scrollTop })=>{
            this.onChildScroll = onChildScroll;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    position: 'relative'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StickyHeader, {
                sectionId: "scope",
                containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-scope`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aD9T.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ar1p.List), {
                ref: this.listRef,
                autoHeight: true,
                dropParentId: dropParentId,
                height: height,
                isReadOnly: isReadOnly,
                isScrolling: isScrolling,
                onScroll: onChildScroll,
                rowCount: rows.length,
                rowHeight: ({ index: index })=>{
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    const height = rows[index].height || 1;
                    return height * (0, $5rYNM.SCOPE_ROW_HEIGHT);
                },
                rowRenderer: rowRenderer,
                rows: rows,
                scrollTop: scrollTop,
                tabIndex: null,
                width: width,
                onRowsRendered: this.rowsRendered,
                overscanRowCount: 20
            })));
        });
    }
    constructor(...args){
        super(...args);
        this.listRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.state = {
            startIndex: undefined
        };
        this.calculateOffset = ()=>{
            const { scrollToIndex: scrollToIndex, heightOffset: heightOffset } = this.props;
            const { startIndex: startIndex } = this.state;
            // we need to correct scrollIndex only when scroll to index is lower than first visible row
            if (startIndex && (0, $7CnHa.isDefined)(scrollToIndex) && scrollToIndex < startIndex) return heightOffset;
            return 0;
        };
        this.rowsRendered = ({ startIndex: startIndex })=>{
            this.setState(()=>({
                    startIndex: startIndex
                }));
        };
    }
}
const $6fe4c25531a8daa1$export$cf7eea6ec41c48e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { rows: rows } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $H9kkp.default), {
        // @ts-expect-error Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'InteractionMetricType'.
        analyticsEvent: (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).TIMELINE_VERTICAL_SCROLLED,
        attributes: {
            rowCount: rows.length
        },
        includeFirstScroll: true
    }, (handleScroll)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fe4c25531a8daa1$export$37050a05021a033e, {
            ...props,
            handleScroll: handleScroll,
            ref: ref
        }));
});
const $6fe4c25531a8daa1$export$5f5bfdab9f770a66 = (0, $hXJR4.SortableContainer)(// @ts-expect-error - TS2345 - Type 'ReactElement<any, string | JSXElementConstructor<any>> | null' is not assignable to type 'Element'.
$6fe4c25531a8daa1$export$cf7eea6ec41c48e5, {
    withRef: true
});

});
parcelRegister("hXJR4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayMove = module.exports.sortableHandle = module.exports.sortableElement = module.exports.sortableContainer = module.exports.SortableHandle = module.exports.SortableElement = module.exports.SortableContainer = undefined;

var $2ZYPu = parcelRequire("2ZYPu");
Object.defineProperty(module.exports, 'arrayMove', {
    enumerable: true,
    get: function get() {
        return $2ZYPu.arrayMove;
    }
});

var $hKejE = parcelRequire("hKejE");
var $d13b84319c699ab6$var$_SortableContainer3 = $d13b84319c699ab6$var$_interopRequireDefault($hKejE);

var $dx5vA = parcelRequire("dx5vA");
var $d13b84319c699ab6$var$_SortableElement3 = $d13b84319c699ab6$var$_interopRequireDefault($dx5vA);

var $hw5hp = parcelRequire("hw5hp");
var $d13b84319c699ab6$var$_SortableHandle3 = $d13b84319c699ab6$var$_interopRequireDefault($hw5hp);
function $d13b84319c699ab6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.SortableContainer = $d13b84319c699ab6$var$_SortableContainer3.default;
module.exports.SortableElement = $d13b84319c699ab6$var$_SortableElement3.default;
module.exports.SortableHandle = $d13b84319c699ab6$var$_SortableHandle3.default;
module.exports.sortableContainer = $d13b84319c699ab6$var$_SortableContainer3.default;
module.exports.sortableElement = $d13b84319c699ab6$var$_SortableElement3.default;
module.exports.sortableHandle = $d13b84319c699ab6$var$_SortableHandle3.default;

});
parcelRegister("2ZYPu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.vendorPrefix = module.exports.events = undefined;
module.exports.arrayMove = $22f076b829959aeb$var$arrayMove;
module.exports.omit = $22f076b829959aeb$var$omit;
module.exports.closest = $22f076b829959aeb$var$closest;
module.exports.limit = $22f076b829959aeb$var$limit;
module.exports.getElementMargin = $22f076b829959aeb$var$getElementMargin;
module.exports.provideDisplayName = $22f076b829959aeb$var$provideDisplayName;
module.exports.getPosition = $22f076b829959aeb$var$getPosition;
module.exports.isTouchEvent = $22f076b829959aeb$var$isTouchEvent;
module.exports.getEdgeOffset = $22f076b829959aeb$var$getEdgeOffset;
module.exports.getLockPixelOffset = $22f076b829959aeb$var$getLockPixelOffset;

var $h8TzT = parcelRequire("h8TzT");
var $22f076b829959aeb$var$_invariant2 = $22f076b829959aeb$var$_interopRequireDefault($h8TzT);
function $22f076b829959aeb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22f076b829959aeb$var$arrayMove(arr, previousIndex, newIndex) {
    var array = arr.slice(0);
    if (newIndex >= array.length) {
        var k = newIndex - array.length;
        while(k-- + 1)array.push(undefined);
    }
    array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
    return array;
}
function $22f076b829959aeb$var$omit(obj) {
    for(var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keysToOmit[_key - 1] = arguments[_key];
    return Object.keys(obj).reduce(function(acc, key) {
        if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
        return acc;
    }, {});
}
var $22f076b829959aeb$var$events = module.exports.events = {
    start: [
        'touchstart',
        'mousedown'
    ],
    move: [
        'touchmove',
        'mousemove'
    ],
    end: [
        'touchend',
        'touchcancel',
        'mouseup'
    ]
};
var $22f076b829959aeb$var$vendorPrefix = module.exports.vendorPrefix = function() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
    // fix for:
    //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //    window.getComputedStyle() returns null inside an iframe with display: none
    // in this case return an array with a fake mozilla style in it.
    var styles = window.getComputedStyle(document.documentElement, '') || [
        '-moz-hidden-iframe'
    ];
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && [
        '',
        'o'
    ])[1];
    switch(pre){
        case 'ms':
            return 'ms';
        default:
            return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
    }
}();
function $22f076b829959aeb$var$closest(el, fn) {
    while(el){
        if (fn(el)) return el;
        el = el.parentNode;
    }
}
function $22f076b829959aeb$var$limit(min, max, value) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
}
function $22f076b829959aeb$var$getCSSPixelValue(stringValue) {
    if (stringValue.substr(-2) === 'px') return parseFloat(stringValue);
    return 0;
}
function $22f076b829959aeb$var$getElementMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        top: $22f076b829959aeb$var$getCSSPixelValue(style.marginTop),
        right: $22f076b829959aeb$var$getCSSPixelValue(style.marginRight),
        bottom: $22f076b829959aeb$var$getCSSPixelValue(style.marginBottom),
        left: $22f076b829959aeb$var$getCSSPixelValue(style.marginLeft)
    };
}
function $22f076b829959aeb$var$provideDisplayName(prefix, Component) {
    var componentName = Component.displayName || Component.name;
    return componentName ? prefix + '(' + componentName + ')' : prefix;
}
function $22f076b829959aeb$var$getPosition(event) {
    if (event.touches && event.touches.length) return {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
    };
    else if (event.changedTouches && event.changedTouches.length) return {
        x: event.changedTouches[0].pageX,
        y: event.changedTouches[0].pageY
    };
    else return {
        x: event.pageX,
        y: event.pageY
    };
}
function $22f076b829959aeb$var$isTouchEvent(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $22f076b829959aeb$var$getEdgeOffset(node, parent) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        left: 0
    };
    // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
    if (node) {
        var nodeOffset = {
            top: offset.top + node.offsetTop,
            left: offset.left + node.offsetLeft
        };
        if (node.parentNode !== parent) return $22f076b829959aeb$var$getEdgeOffset(node.parentNode, parent, nodeOffset);
        else return nodeOffset;
    }
}
function $22f076b829959aeb$var$getLockPixelOffset(_ref) {
    var lockOffset = _ref.lockOffset, width = _ref.width, height = _ref.height;
    var offsetX = lockOffset;
    var offsetY = lockOffset;
    var unit = 'px';
    if (typeof lockOffset === 'string') {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
        (0, $22f076b829959aeb$var$_invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', lockOffset);
        offsetX = offsetY = parseFloat(lockOffset);
        unit = match[1];
    }
    (0, $22f076b829959aeb$var$_invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
    if (unit === '%') {
        offsetX = offsetX * width / 100;
        offsetY = offsetY * height / 100;
    }
    return {
        x: offsetX,
        y: offsetY
    };
}

});

parcelRegister("hKejE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ceb1d6684ef45df1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ceb1d6684ef45df1$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $ceb1d6684ef45df1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $ceb1d6684ef45df1$var$sortableContainer;

var $eUqFw = parcelRequire("eUqFw");
var $ceb1d6684ef45df1$var$_react2 = $ceb1d6684ef45df1$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $ceb1d6684ef45df1$var$_propTypes2 = $ceb1d6684ef45df1$var$_interopRequireDefault($1Qivz);

var $lEfVV = parcelRequire("lEfVV");

var $h8TzT = parcelRequire("h8TzT");
var $ceb1d6684ef45df1$var$_invariant2 = $ceb1d6684ef45df1$var$_interopRequireDefault($h8TzT);

var $9hTkn = parcelRequire("9hTkn");
var $ceb1d6684ef45df1$var$_Manager2 = $ceb1d6684ef45df1$var$_interopRequireDefault($9hTkn);

var $2ZYPu = parcelRequire("2ZYPu");
function $ceb1d6684ef45df1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ceb1d6684ef45df1$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $ceb1d6684ef45df1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ceb1d6684ef45df1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ceb1d6684ef45df1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Export Higher Order Sortable Container Component
function $ceb1d6684ef45df1$var$sortableContainer(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_Component) {
        $ceb1d6684ef45df1$var$_inherits(_class, _Component);
        function _class(props) {
            $ceb1d6684ef45df1$var$_classCallCheck(this, _class);
            var _this = $ceb1d6684ef45df1$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
            _this.handleStart = function(event) {
                var _this$props = _this.props, distance = _this$props.distance, shouldCancelStart = _this$props.shouldCancelStart;
                if (event.button === 2 || shouldCancelStart(event)) return false;
                _this._touched = true;
                _this._pos = (0, $2ZYPu.getPosition)(event);
                var node = (0, $2ZYPu.closest)(event.target, function(el) {
                    return el.sortableInfo != null;
                });
                if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
                    var useDragHandle = _this.props.useDragHandle;
                    var _node$sortableInfo = node.sortableInfo, index = _node$sortableInfo.index, collection = _node$sortableInfo.collection;
                    if (useDragHandle && !(0, $2ZYPu.closest)(event.target, function(el) {
                        return el.sortableHandle != null;
                    })) return;
                    _this.manager.active = {
                        index: index,
                        collection: collection
                    };
                    /*
          * Fixes a bug in Firefox where the :active state of anchor tags
          * prevent subsequent 'mousemove' events from being fired
          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
          */ if (!(0, $2ZYPu.isTouchEvent)(event) && event.target.tagName.toLowerCase() === 'a') event.preventDefault();
                    if (!distance) {
                        if (_this.props.pressDelay === 0) _this.handlePress(event);
                        else _this.pressTimer = setTimeout(function() {
                            return _this.handlePress(event);
                        }, _this.props.pressDelay);
                    }
                }
            };
            _this.nodeIsChild = function(node) {
                return node.sortableInfo.manager === _this.manager;
            };
            _this.handleMove = function(event) {
                var _this$props2 = _this.props, distance = _this$props2.distance, pressThreshold = _this$props2.pressThreshold;
                if (!_this.state.sorting && _this._touched) {
                    var position = (0, $2ZYPu.getPosition)(event);
                    var delta = _this._delta = {
                        x: _this._pos.x - position.x,
                        y: _this._pos.y - position.y
                    };
                    var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
                    if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
                        clearTimeout(_this.cancelTimer);
                        _this.cancelTimer = setTimeout(_this.cancel, 0);
                    } else if (distance && combinedDelta >= distance && _this.manager.isActive()) _this.handlePress(event);
                }
            };
            _this.handleEnd = function() {
                _this._touched = false;
                _this.cancel();
            };
            _this.cancel = function() {
                var distance = _this.props.distance;
                var sorting = _this.state.sorting;
                if (!sorting) {
                    if (!distance) clearTimeout(_this.pressTimer);
                    _this.manager.active = null;
                }
            };
            _this.handlePress = function(event) {
                var active = _this.manager.getActive();
                if (active) {
                    var _this$props3 = _this.props, axis = _this$props3.axis, getHelperDimensions = _this$props3.getHelperDimensions, helperClass = _this$props3.helperClass, hideSortableGhost = _this$props3.hideSortableGhost, onSortStart = _this$props3.onSortStart, useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
                    var node = active.node, collection = active.collection;
                    var index = node.sortableInfo.index;
                    var margin = (0, $2ZYPu.getElementMargin)(node);
                    var containerBoundingRect = _this.container.getBoundingClientRect();
                    var dimensions = getHelperDimensions({
                        index: index,
                        node: node,
                        collection: collection
                    });
                    _this.node = node;
                    _this.margin = margin;
                    _this.width = dimensions.width;
                    _this.height = dimensions.height;
                    _this.marginOffset = {
                        x: _this.margin.left + _this.margin.right,
                        y: Math.max(_this.margin.top, _this.margin.bottom)
                    };
                    _this.boundingClientRect = node.getBoundingClientRect();
                    _this.containerBoundingRect = containerBoundingRect;
                    _this.index = index;
                    _this.newIndex = index;
                    _this.axis = {
                        x: axis.indexOf('x') >= 0,
                        y: axis.indexOf('y') >= 0
                    };
                    _this.offsetEdge = (0, $2ZYPu.getEdgeOffset)(node, _this.container);
                    _this.initialOffset = (0, $2ZYPu.getPosition)(event);
                    _this.initialScroll = {
                        top: _this.container.scrollTop,
                        left: _this.container.scrollLeft
                    };
                    _this.initialWindowScroll = {
                        top: window.pageYOffset,
                        left: window.pageXOffset
                    };
                    var fields = node.querySelectorAll('input, textarea, select');
                    var clonedNode = node.cloneNode(true);
                    var clonedFields = [].concat($ceb1d6684ef45df1$var$_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array
                    clonedFields.forEach(function(field, index) {
                        if (field.type !== 'file' && fields[index]) field.value = fields[index].value;
                    });
                    _this.helper = _this.document.body.appendChild(clonedNode);
                    _this.helper.style.position = 'fixed';
                    _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
                    _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
                    _this.helper.style.width = _this.width + 'px';
                    _this.helper.style.height = _this.height + 'px';
                    _this.helper.style.boxSizing = 'border-box';
                    _this.helper.style.pointerEvents = 'none';
                    if (hideSortableGhost) {
                        _this.sortableGhost = node;
                        node.style.visibility = 'hidden';
                        node.style.opacity = 0;
                    }
                    _this.minTranslate = {};
                    _this.maxTranslate = {};
                    if (_this.axis.x) {
                        _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                        _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                    }
                    if (_this.axis.y) {
                        _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                        _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                    }
                    if (helperClass) {
                        var _this$helper$classLis;
                        (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, $ceb1d6684ef45df1$var$_toConsumableArray(helperClass.split(' ')));
                    }
                    _this.listenerNode = event.touches ? node : _this.contentWindow;
                    $2ZYPu.events.move.forEach(function(eventName) {
                        return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                    });
                    $2ZYPu.events.end.forEach(function(eventName) {
                        return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                    });
                    _this.setState({
                        sorting: true,
                        sortingIndex: index
                    });
                    if (onSortStart) onSortStart({
                        node: node,
                        index: index,
                        collection: collection
                    }, event);
                }
            };
            _this.handleSortMove = function(event) {
                var onSortMove = _this.props.onSortMove;
                event.preventDefault(); // Prevent scrolling on mobile
                _this.updatePosition(event);
                _this.animateNodes();
                _this.autoscroll();
                if (onSortMove) onSortMove(event);
            };
            _this.handleSortEnd = function(event) {
                var _this$props4 = _this.props, hideSortableGhost = _this$props4.hideSortableGhost, onSortEnd = _this$props4.onSortEnd;
                var collection = _this.manager.active.collection;
                // Remove the event listeners if the node is still in the DOM
                if (_this.listenerNode) {
                    $2ZYPu.events.move.forEach(function(eventName) {
                        return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
                    });
                    $2ZYPu.events.end.forEach(function(eventName) {
                        return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
                    });
                }
                // Remove the helper from the DOM
                _this.helper.parentNode.removeChild(_this.helper);
                if (hideSortableGhost && _this.sortableGhost) {
                    _this.sortableGhost.style.visibility = '';
                    _this.sortableGhost.style.opacity = '';
                }
                var nodes = _this.manager.refs[collection];
                for(var i = 0, len = nodes.length; i < len; i++){
                    var node = nodes[i];
                    var el = node.node;
                    // Clear the cached offsetTop / offsetLeft value
                    node.edgeOffset = null;
                    // Remove the transforms / transitions
                    el.style[$2ZYPu.vendorPrefix + 'Transform'] = '';
                    el.style[$2ZYPu.vendorPrefix + 'TransitionDuration'] = '';
                }
                // Stop autoscroll
                clearInterval(_this.autoscrollInterval);
                _this.autoscrollInterval = null;
                // Update state
                _this.manager.active = null;
                _this.setState({
                    sorting: false,
                    sortingIndex: null
                });
                if (typeof onSortEnd === 'function') onSortEnd({
                    oldIndex: _this.index,
                    newIndex: _this.newIndex,
                    collection: collection
                }, event);
                _this._touched = false;
            };
            _this.autoscroll = function() {
                var translate = _this.translate;
                var direction = {
                    x: 0,
                    y: 0
                };
                var speed = {
                    x: 1,
                    y: 1
                };
                var acceleration = {
                    x: 10,
                    y: 10
                };
                if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
                    direction.y = 1; // Scroll Down
                    speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
                } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
                    direction.x = 1; // Scroll Right
                    speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
                } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
                    direction.y = -1; // Scroll Up
                    speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
                } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
                    direction.x = -1; // Scroll Left
                    speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
                }
                if (_this.autoscrollInterval) {
                    clearInterval(_this.autoscrollInterval);
                    _this.autoscrollInterval = null;
                    _this.isAutoScrolling = false;
                }
                if (direction.x !== 0 || direction.y !== 0) _this.autoscrollInterval = setInterval(function() {
                    _this.isAutoScrolling = true;
                    var offset = {
                        left: 1 * speed.x * direction.x,
                        top: 1 * speed.y * direction.y
                    };
                    _this.scrollContainer.scrollTop += offset.top;
                    _this.scrollContainer.scrollLeft += offset.left;
                    _this.translate.x += offset.left;
                    _this.translate.y += offset.top;
                    _this.animateNodes();
                }, 5);
            };
            _this.manager = new $ceb1d6684ef45df1$var$_Manager2.default();
            _this.events = {
                start: _this.handleStart,
                move: _this.handleMove,
                end: _this.handleEnd
            };
            (0, $ceb1d6684ef45df1$var$_invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
            _this.state = {};
            return _this;
        }
        $ceb1d6684ef45df1$var$_createClass(_class, [
            {
                key: 'getChildContext',
                value: function getChildContext() {
                    return {
                        manager: this.manager
                    };
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var _this2 = this;
                    var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
                    /*
         *  Set our own default rather than using defaultProps because Jest
         *  snapshots will serialize window, causing a RangeError
         *  https://github.com/clauderic/react-sortable-hoc/issues/249
         */ var container = this.getContainer();
                    Promise.resolve(container).then(function(containerNode) {
                        _this2.container = containerNode;
                        _this2.document = _this2.container.ownerDocument || document;
                        var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
                        _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
                        _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : _this2.container;
                        var _loop = function _loop(key) {
                            if (_this2.events.hasOwnProperty(key)) $2ZYPu.events[key].forEach(function(eventName) {
                                return _this2.container.addEventListener(eventName, _this2.events[key], false);
                            });
                        };
                        for(var key in _this2.events)_loop(key);
                    });
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    var _this3 = this;
                    if (this.container) {
                        var _loop2 = function _loop2(key) {
                            if (_this3.events.hasOwnProperty(key)) $2ZYPu.events[key].forEach(function(eventName) {
                                return _this3.container.removeEventListener(eventName, _this3.events[key]);
                            });
                        };
                        for(var key in this.events)_loop2(key);
                    }
                }
            },
            {
                key: 'getLockPixelOffsets',
                value: function getLockPixelOffsets() {
                    var width = this.width, height = this.height;
                    var lockOffset = this.props.lockOffset;
                    var offsets = Array.isArray(lockOffset) ? lockOffset : [
                        lockOffset,
                        lockOffset
                    ];
                    (0, $ceb1d6684ef45df1$var$_invariant2.default)(offsets.length === 2, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", lockOffset);
                    var _offsets = $ceb1d6684ef45df1$var$_slicedToArray(offsets, 2), minLockOffset = _offsets[0], maxLockOffset = _offsets[1];
                    return [
                        (0, $2ZYPu.getLockPixelOffset)({
                            lockOffset: minLockOffset,
                            width: width,
                            height: height
                        }),
                        (0, $2ZYPu.getLockPixelOffset)({
                            lockOffset: maxLockOffset,
                            width: width,
                            height: height
                        })
                    ];
                }
            },
            {
                key: 'updatePosition',
                value: function updatePosition(event) {
                    var _props = this.props, lockAxis = _props.lockAxis, lockToContainerEdges = _props.lockToContainerEdges;
                    var offset = (0, $2ZYPu.getPosition)(event);
                    var translate = {
                        x: offset.x - this.initialOffset.x,
                        y: offset.y - this.initialOffset.y
                    };
                    // Adjust for window scroll
                    translate.y -= window.pageYOffset - this.initialWindowScroll.top;
                    translate.x -= window.pageXOffset - this.initialWindowScroll.left;
                    this.translate = translate;
                    if (lockToContainerEdges) {
                        var _getLockPixelOffsets = this.getLockPixelOffsets(), _getLockPixelOffsets2 = $ceb1d6684ef45df1$var$_slicedToArray(_getLockPixelOffsets, 2), minLockOffset = _getLockPixelOffsets2[0], maxLockOffset = _getLockPixelOffsets2[1];
                        var minOffset = {
                            x: this.width / 2 - minLockOffset.x,
                            y: this.height / 2 - minLockOffset.y
                        };
                        var maxOffset = {
                            x: this.width / 2 - maxLockOffset.x,
                            y: this.height / 2 - maxLockOffset.y
                        };
                        translate.x = (0, $2ZYPu.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
                        translate.y = (0, $2ZYPu.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
                    }
                    if (lockAxis === 'x') translate.y = 0;
                    else if (lockAxis === 'y') translate.x = 0;
                    this.helper.style[$2ZYPu.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
                }
            },
            {
                key: 'animateNodes',
                value: function animateNodes() {
                    var _props2 = this.props, transitionDuration = _props2.transitionDuration, hideSortableGhost = _props2.hideSortableGhost, onSortOver = _props2.onSortOver;
                    var nodes = this.manager.getOrderedRefs();
                    var containerScrollDelta = {
                        left: this.container.scrollLeft - this.initialScroll.left,
                        top: this.container.scrollTop - this.initialScroll.top
                    };
                    var sortingOffset = {
                        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
                        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
                    };
                    var windowScrollDelta = {
                        top: window.pageYOffset - this.initialWindowScroll.top,
                        left: window.pageXOffset - this.initialWindowScroll.left
                    };
                    var prevIndex = this.newIndex;
                    this.newIndex = null;
                    for(var i = 0, len = nodes.length; i < len; i++){
                        var node = nodes[i].node;
                        var index = node.sortableInfo.index;
                        var width = node.offsetWidth;
                        var height = node.offsetHeight;
                        var offset = {
                            width: this.width > width ? width / 2 : this.width / 2,
                            height: this.height > height ? height / 2 : this.height / 2
                        };
                        var translate = {
                            x: 0,
                            y: 0
                        };
                        var edgeOffset = nodes[i].edgeOffset;
                        // If we haven't cached the node's offsetTop / offsetLeft value
                        if (!edgeOffset) nodes[i].edgeOffset = edgeOffset = (0, $2ZYPu.getEdgeOffset)(node, this.container);
                        // Get a reference to the next and previous node
                        var nextNode = i < nodes.length - 1 && nodes[i + 1];
                        var prevNode = i > 0 && nodes[i - 1];
                        // Also cache the next node's edge offset if needed.
                        // We need this for calculating the animation in a grid setup
                        if (nextNode && !nextNode.edgeOffset) nextNode.edgeOffset = (0, $2ZYPu.getEdgeOffset)(nextNode.node, this.container);
                        // If the node is the one we're currently animating, skip it
                        if (index === this.index) {
                            if (hideSortableGhost) {
                                /*
              * With windowing libraries such as `react-virtualized`, the sortableGhost
              * node may change while scrolling down and then back up (or vice-versa),
              * so we need to update the reference to the new node just to be safe.
              */ this.sortableGhost = node;
                                node.style.visibility = 'hidden';
                                node.style.opacity = 0;
                            }
                            continue;
                        }
                        if (transitionDuration) node.style[$2ZYPu.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
                        if (this.axis.x) {
                            if (this.axis.y) {
                                // Calculations for a grid setup
                                if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                                    // If the current node is to the left on the same row, or above the node that's being dragged
                                    // then move it to the right
                                    translate.x = this.width + this.marginOffset.x;
                                    if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                                        // If it moves passed the right bounds, then animate it to the first position of the next row.
                                        // We just use the offset of the next node to calculate where to move, because that node's original position
                                        // is exactly where we want to go
                                        translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                                        translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                                    }
                                    if (this.newIndex === null) this.newIndex = index;
                                } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                                    // If the current node is to the right on the same row, or below the node that's being dragged
                                    // then move it to the left
                                    translate.x = -(this.width + this.marginOffset.x);
                                    if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                                        // If it moves passed the left bounds, then animate it to the last position of the previous row.
                                        // We just use the offset of the previous node to calculate where to move, because that node's original position
                                        // is exactly where we want to go
                                        translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                                        translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                                    }
                                    this.newIndex = index;
                                }
                            } else {
                                if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                                    translate.x = -(this.width + this.marginOffset.x);
                                    this.newIndex = index;
                                } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                                    translate.x = this.width + this.marginOffset.x;
                                    if (this.newIndex == null) this.newIndex = index;
                                }
                            }
                        } else if (this.axis.y) {
                            if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
                                translate.y = -(this.height + this.marginOffset.y);
                                this.newIndex = index;
                            } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
                                translate.y = this.height + this.marginOffset.y;
                                if (this.newIndex == null) this.newIndex = index;
                            }
                        }
                        node.style[$2ZYPu.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
                    }
                    if (this.newIndex == null) this.newIndex = this.index;
                    if (onSortOver && this.newIndex !== prevIndex) onSortOver({
                        newIndex: this.newIndex,
                        oldIndex: prevIndex,
                        index: this.index,
                        collection: this.manager.active.collection
                    });
                }
            },
            {
                key: 'getWrappedInstance',
                value: function getWrappedInstance() {
                    (0, $ceb1d6684ef45df1$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
                    return this.refs.wrappedInstance;
                }
            },
            {
                key: 'getContainer',
                value: function getContainer() {
                    var getContainer = this.props.getContainer;
                    if (typeof getContainer !== 'function') return (0, $lEfVV.findDOMNode)(this);
                    return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var ref = config.withRef ? 'wrappedInstance' : null;
                    return $ceb1d6684ef45df1$var$_react2.default.createElement(WrappedComponent, $ceb1d6684ef45df1$var$_extends({
                        ref: ref
                    }, (0, $2ZYPu.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
                }
            }
        ]);
        return _class;
    }($eUqFw.Component), _class.displayName = (0, $2ZYPu.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
        axis: 'y',
        transitionDuration: 300,
        pressDelay: 0,
        pressThreshold: 5,
        distance: 0,
        useWindowAsScrollContainer: false,
        hideSortableGhost: true,
        shouldCancelStart: function shouldCancelStart(e) {
            // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
            var disabledElements = [
                'input',
                'textarea',
                'select',
                'option',
                'button'
            ];
            if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) return true; // Return true to cancel sorting
        },
        lockToContainerEdges: false,
        lockOffset: '50%',
        getHelperDimensions: function getHelperDimensions(_ref) {
            var node = _ref.node;
            return {
                width: node.offsetWidth,
                height: node.offsetHeight
            };
        }
    }, _class.propTypes = {
        axis: $ceb1d6684ef45df1$var$_propTypes2.default.oneOf([
            'x',
            'y',
            'xy'
        ]),
        distance: $ceb1d6684ef45df1$var$_propTypes2.default.number,
        lockAxis: $ceb1d6684ef45df1$var$_propTypes2.default.string,
        helperClass: $ceb1d6684ef45df1$var$_propTypes2.default.string,
        transitionDuration: $ceb1d6684ef45df1$var$_propTypes2.default.number,
        contentWindow: $ceb1d6684ef45df1$var$_propTypes2.default.any,
        onSortStart: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        onSortMove: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        onSortOver: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        onSortEnd: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        shouldCancelStart: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        pressDelay: $ceb1d6684ef45df1$var$_propTypes2.default.number,
        useDragHandle: $ceb1d6684ef45df1$var$_propTypes2.default.bool,
        useWindowAsScrollContainer: $ceb1d6684ef45df1$var$_propTypes2.default.bool,
        hideSortableGhost: $ceb1d6684ef45df1$var$_propTypes2.default.bool,
        lockToContainerEdges: $ceb1d6684ef45df1$var$_propTypes2.default.bool,
        lockOffset: $ceb1d6684ef45df1$var$_propTypes2.default.oneOfType([
            $ceb1d6684ef45df1$var$_propTypes2.default.number,
            $ceb1d6684ef45df1$var$_propTypes2.default.string,
            $ceb1d6684ef45df1$var$_propTypes2.default.arrayOf($ceb1d6684ef45df1$var$_propTypes2.default.oneOfType([
                $ceb1d6684ef45df1$var$_propTypes2.default.number,
                $ceb1d6684ef45df1$var$_propTypes2.default.string
            ]))
        ]),
        getContainer: $ceb1d6684ef45df1$var$_propTypes2.default.func,
        getHelperDimensions: $ceb1d6684ef45df1$var$_propTypes2.default.func
    }, _class.childContextTypes = {
        manager: $ceb1d6684ef45df1$var$_propTypes2.default.object.isRequired
    }, _temp;
}

});
parcelRegister("9hTkn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6c309e811a65e73e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $6c309e811a65e73e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $6c309e811a65e73e$var$Manager = function() {
    function Manager() {
        $6c309e811a65e73e$var$_classCallCheck(this, Manager);
        this.refs = {};
    }
    $6c309e811a65e73e$var$_createClass(Manager, [
        {
            key: "add",
            value: function add(collection, ref) {
                if (!this.refs[collection]) this.refs[collection] = [];
                this.refs[collection].push(ref);
            }
        },
        {
            key: "remove",
            value: function remove(collection, ref) {
                var index = this.getIndex(collection, ref);
                if (index !== -1) this.refs[collection].splice(index, 1);
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                return this.active;
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this;
                return this.refs[this.active.collection].find(// eslint-disable-next-line eqeqeq
                function(_ref) {
                    var node = _ref.node;
                    return node.sortableInfo.index == _this.active.index;
                });
            }
        },
        {
            key: "getIndex",
            value: function getIndex(collection, ref) {
                return this.refs[collection].indexOf(ref);
            }
        },
        {
            key: "getOrderedRefs",
            value: function getOrderedRefs() {
                var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
                return this.refs[collection].sort($6c309e811a65e73e$var$sortByIndex);
            }
        }
    ]);
    return Manager;
}();
module.exports.default = $6c309e811a65e73e$var$Manager;
function $6c309e811a65e73e$var$sortByIndex(_ref2, _ref3) {
    var index1 = _ref2.node.sortableInfo.index;
    var index2 = _ref3.node.sortableInfo.index;
    return index1 - index2;
}

});


parcelRegister("dx5vA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9da2a149b8497a9a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9da2a149b8497a9a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $9da2a149b8497a9a$var$sortableElement;

var $eUqFw = parcelRequire("eUqFw");
var $9da2a149b8497a9a$var$_react2 = $9da2a149b8497a9a$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $9da2a149b8497a9a$var$_propTypes2 = $9da2a149b8497a9a$var$_interopRequireDefault($1Qivz);

var $lEfVV = parcelRequire("lEfVV");

var $h8TzT = parcelRequire("h8TzT");
var $9da2a149b8497a9a$var$_invariant2 = $9da2a149b8497a9a$var$_interopRequireDefault($h8TzT);

var $2ZYPu = parcelRequire("2ZYPu");
function $9da2a149b8497a9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9da2a149b8497a9a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9da2a149b8497a9a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9da2a149b8497a9a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Export Higher Order Sortable Element Component
function $9da2a149b8497a9a$var$sortableElement(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_Component) {
        $9da2a149b8497a9a$var$_inherits(_class, _Component);
        function _class() {
            $9da2a149b8497a9a$var$_classCallCheck(this, _class);
            return $9da2a149b8497a9a$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }
        $9da2a149b8497a9a$var$_createClass(_class, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var _props = this.props, collection = _props.collection, disabled = _props.disabled, index = _props.index;
                    if (!disabled) this.setDraggable(collection, index);
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if (this.props.index !== nextProps.index && this.node) this.node.sortableInfo.index = nextProps.index;
                    if (this.props.disabled !== nextProps.disabled) {
                        var collection = nextProps.collection, disabled = nextProps.disabled, index = nextProps.index;
                        if (disabled) this.removeDraggable(collection);
                        else this.setDraggable(collection, index);
                    } else if (this.props.collection !== nextProps.collection) {
                        this.removeDraggable(this.props.collection);
                        this.setDraggable(nextProps.collection, nextProps.index);
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    var _props2 = this.props, collection = _props2.collection, disabled = _props2.disabled;
                    if (!disabled) this.removeDraggable(collection);
                }
            },
            {
                key: 'setDraggable',
                value: function setDraggable(collection, index) {
                    var node = this.node = (0, $lEfVV.findDOMNode)(this);
                    node.sortableInfo = {
                        index: index,
                        collection: collection,
                        manager: this.context.manager
                    };
                    this.ref = {
                        node: node
                    };
                    this.context.manager.add(collection, this.ref);
                }
            },
            {
                key: 'removeDraggable',
                value: function removeDraggable(collection) {
                    this.context.manager.remove(collection, this.ref);
                }
            },
            {
                key: 'getWrappedInstance',
                value: function getWrappedInstance() {
                    (0, $9da2a149b8497a9a$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
                    return this.refs.wrappedInstance;
                }
            },
            {
                key: 'render',
                value: function render() {
                    var ref = config.withRef ? 'wrappedInstance' : null;
                    return $9da2a149b8497a9a$var$_react2.default.createElement(WrappedComponent, $9da2a149b8497a9a$var$_extends({
                        ref: ref
                    }, (0, $2ZYPu.omit)(this.props, 'collection', 'disabled', 'index')));
                }
            }
        ]);
        return _class;
    }($eUqFw.Component), _class.displayName = (0, $2ZYPu.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
        manager: $9da2a149b8497a9a$var$_propTypes2.default.object.isRequired
    }, _class.propTypes = {
        index: $9da2a149b8497a9a$var$_propTypes2.default.number.isRequired,
        collection: $9da2a149b8497a9a$var$_propTypes2.default.oneOfType([
            $9da2a149b8497a9a$var$_propTypes2.default.number,
            $9da2a149b8497a9a$var$_propTypes2.default.string
        ]),
        disabled: $9da2a149b8497a9a$var$_propTypes2.default.bool
    }, _class.defaultProps = {
        collection: 0
    }, _temp;
}

});

parcelRegister("hw5hp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cc09854d2b0ee939$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cc09854d2b0ee939$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $cc09854d2b0ee939$var$sortableHandle;

var $eUqFw = parcelRequire("eUqFw");
var $cc09854d2b0ee939$var$_react2 = $cc09854d2b0ee939$var$_interopRequireDefault($eUqFw);

var $lEfVV = parcelRequire("lEfVV");

var $h8TzT = parcelRequire("h8TzT");
var $cc09854d2b0ee939$var$_invariant2 = $cc09854d2b0ee939$var$_interopRequireDefault($h8TzT);

var $2ZYPu = parcelRequire("2ZYPu");
function $cc09854d2b0ee939$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc09854d2b0ee939$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cc09854d2b0ee939$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cc09854d2b0ee939$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Export Higher Order Sortable Element Component
function $cc09854d2b0ee939$var$sortableHandle(WrappedComponent) {
    var _class, _temp;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        withRef: false
    };
    return _temp = _class = function(_Component) {
        $cc09854d2b0ee939$var$_inherits(_class, _Component);
        function _class() {
            $cc09854d2b0ee939$var$_classCallCheck(this, _class);
            return $cc09854d2b0ee939$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }
        $cc09854d2b0ee939$var$_createClass(_class, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var node = (0, $lEfVV.findDOMNode)(this);
                    node.sortableHandle = true;
                }
            },
            {
                key: 'getWrappedInstance',
                value: function getWrappedInstance() {
                    (0, $cc09854d2b0ee939$var$_invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
                    return this.refs.wrappedInstance;
                }
            },
            {
                key: 'render',
                value: function render() {
                    var ref = config.withRef ? 'wrappedInstance' : null;
                    return $cc09854d2b0ee939$var$_react2.default.createElement(WrappedComponent, $cc09854d2b0ee939$var$_extends({
                        ref: ref
                    }, this.props));
                }
            }
        ]);
        return _class;
    }($eUqFw.Component), _class.displayName = (0, $2ZYPu.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
}

});


parcelRegister("H9kkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d81a4dfc8e6d0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $6Grzy = parcelRequire("6Grzy");
const $e6d81a4dfc8e6d0f$var$ScrollLongTaskAnalytics = /*#__PURE__*/ (0, $eUqFw.memo)(({ attributes: attributes, analyticsEvent: analyticsEvent, children: children, includeFirstScroll: includeFirstScroll = false, delay: delay = (0, $f7ce3ce1c4dc2e59$export$3e6e59880a7a1435) })=>{
    const isInitialTimeout = (0, $eUqFw.useRef)(!includeFirstScroll);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleScroll = ()=>{
        if (isInitialTimeout.current) {
            isInitialTimeout.current = false;
            return;
        }
        // @ts-expect-error Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'InteractionMetricType'.
        (0, $6Grzy.longTask).trackWithTimeout(analyticsEvent, createAnalyticsEvent, delay, attributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(handleScroll));
});
var $e6d81a4dfc8e6d0f$export$2e2bcd8739ae039 = $e6d81a4dfc8e6d0f$var$ScrollLongTaskAnalytics;

});
// the timeout delay to stop the scroll event tracking
const $f7ce3ce1c4dc2e59$export$3e6e59880a7a1435 = 300;

parcelRegister("6Grzy", function(module, exports) {

$parcel$export(module.exports, "longTask", () => $abafebe2863ac134$export$be097c2d334688c0);
$parcel$export(module.exports, "context", () => $abafebe2863ac134$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $abafebe2863ac134$export$2e2bcd8739ae039);

var $dYnI4 = parcelRequire("dYnI4");

var $f3YKO = parcelRequire("f3YKO");

var $jMP2a = parcelRequire("jMP2a");

var $cuuJa = parcelRequire("cuuJa");
const $abafebe2863ac134$export$be097c2d334688c0 = (0, $f3YKO.default)((0, $dYnI4.SPA_APP_NAME));
const $abafebe2863ac134$export$a078c61943f9dbbe = {
    PLAN: 'plan',
    PROGRAM: 'program',
    TEAMS: 'teams'
};
function $abafebe2863ac134$var$getGasV3TrackEventTriggerFn(eventName, actionSubjectId) {
    return function triggerTrackAnalyticsEvent(analyticsEvent, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metaData = {}) {
        if (actionSubjectId) {
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, eventName, actionSubjectId, metaData);
            return;
        }
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, eventName, metaData);
    };
}
const $abafebe2863ac134$var$triggerCalculationDurationAnalytics = $abafebe2863ac134$var$getGasV3TrackEventTriggerFn((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CALCULATE_PLAN);
const $abafebe2863ac134$var$triggerCreateCrossProjectReleaseAnalytics = $abafebe2863ac134$var$getGasV3TrackEventTriggerFn((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CREATE_CROSS_PROJECT_RELEASE);
const $abafebe2863ac134$var$triggerUpdateJiraEventAnalytics = $abafebe2863ac134$var$getGasV3TrackEventTriggerFn((0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_JIRA);
function $abafebe2863ac134$var$triggerViewRoadmapEventAnalytics(analyticsEvent, group, colourByOption, colours, sortByField, teamsTotalCount, teamsScrumCount, teamsKanbanCount, teamsSharedCount, externalTeamsTotalCount, sourcesTotalCount, sourcesBoardCount, sourcesProjectCount, sourcesFilterCount, rollupSettings, showSprints, showWarnings, planPermission, instancePermission, planningUnit, sprintActiveCount, sprintFutureCount, sprintFutureSetDates, sprintFutureInferredDates, hasSprintsWithInconsistentDates, hasAtlasPermissions, isAtlasConnectInstalled, timelineType, customTimelineType, fieldColumns, issuesCount, dependenciesCount, dependenciesViewSetting, issuesWithFixedStartDateCount, issuesWithFixedEndDateCount, issuesWithSprintStartDateCount, issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount, viewsInPlanCount, viewsWithDependencyBadgesCount, viewsWithDependencyLinesCount, viewsWithDependencyCountCount, planCreatedDate, teamsShownInPlan, projectsShownInPlan, boardsShownInPlan, filtersShownInPlan, sourcesProjectCountJswCmpCount, sourcesProjectCountJswTmpCount, sourcesProjectCountJwmCmpCount, sourcesProjectCountJwmTmpCount, sourcesProjectCountJsmCmpCount, sourcesProjectCountCmpCount, sourcesProjectCountTmpCount, isMultiScenariosEnabled, scenariosCount, hierarchyLevels, selectedFilters, isSamplePlan, maxOverlappingSprints, autoSchedulerEnabled, fiscalMonth, viewMode, zmtCount) {
    const { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers } = rollupSettings;
    const payload = {
        group: group,
        colourByOption: colourByOption,
        colours: colours,
        sortByField: sortByField,
        teamsTotalCount: teamsTotalCount,
        teamsScrumCount: teamsScrumCount,
        teamsKanbanCount: teamsKanbanCount,
        teamsSharedCount: teamsSharedCount,
        externalTeamsTotalCount: externalTeamsTotalCount,
        sourcesTotalCount: sourcesTotalCount,
        sourcesBoardCount: sourcesBoardCount,
        sourcesProjectCount: sourcesProjectCount,
        sourcesFilterCount: sourcesFilterCount,
        showingRolledUpDate: showingRolledUpDate,
        showRolledUpOthers: showRolledUpOthers,
        showSprints: showSprints,
        showWarnings: showWarnings,
        planPermission: planPermission,
        instancePermission: instancePermission,
        planningUnit: planningUnit,
        sprintActiveCount: sprintActiveCount,
        sprintFutureCount: sprintFutureCount,
        sprintFutureSetDates: sprintFutureSetDates,
        sprintFutureInferredDates: sprintFutureInferredDates,
        hasSprintsWithInconsistentDates: hasSprintsWithInconsistentDates,
        hasAtlasPermissions: hasAtlasPermissions,
        isAtlasConnectInstalled: isAtlasConnectInstalled,
        customTimelineType: customTimelineType,
        timelineType: timelineType,
        fieldColumns: fieldColumns,
        issuesCount: issuesCount,
        dependenciesCount: dependenciesCount,
        dependenciesViewSetting: dependenciesViewSetting,
        issuesWithFixedStartDateCount: issuesWithFixedStartDateCount,
        issuesWithFixedEndDateCount: issuesWithFixedEndDateCount,
        issuesWithSprintStartDateCount: issuesWithSprintStartDateCount,
        issuesWithSprintEndDateCount: issuesWithSprintEndDateCount,
        issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount,
        issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount,
        viewsInPlanCount: viewsInPlanCount,
        viewsWithDependencyBadgesCount: viewsWithDependencyBadgesCount,
        viewsWithDependencyLinesCount: viewsWithDependencyLinesCount,
        viewsWithDependencyCountCount: viewsWithDependencyCountCount,
        planCreatedDate: planCreatedDate,
        teamsShownInPlan: teamsShownInPlan,
        projectsShownInPlan: projectsShownInPlan,
        boardsShownInPlan: boardsShownInPlan,
        filtersShownInPlan: filtersShownInPlan,
        sourcesProjectCountJswCmpCount: sourcesProjectCountJswCmpCount,
        sourcesProjectCountJswTmpCount: sourcesProjectCountJswTmpCount,
        sourcesProjectCountJwmCmpCount: sourcesProjectCountJwmCmpCount,
        sourcesProjectCountJwmTmpCount: sourcesProjectCountJwmTmpCount,
        sourcesProjectCountJsmCmpCount: sourcesProjectCountJsmCmpCount,
        sourcesProjectCountCmpCount: sourcesProjectCountCmpCount,
        sourcesProjectCountTmpCount: sourcesProjectCountTmpCount,
        isMultiScenariosEnabled: isMultiScenariosEnabled,
        scenariosCount: scenariosCount,
        hierarchyLevels: hierarchyLevels,
        selectedFilters: selectedFilters,
        isSamplePlan: isSamplePlan,
        maxOverlappingSprints: maxOverlappingSprints,
        autoSchedulerEnabled: autoSchedulerEnabled,
        fiscalMonth: fiscalMonth,
        viewMode: viewMode,
        zmtCount: // delete this key when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
        zmtCount
    };
    (0, $jMP2a.fireScreenAnalytics)(analyticsEvent, payload);
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$abafebe2863ac134$export$2e2bcd8739ae039 = {
    triggerUpdateJiraEventAnalytics: $abafebe2863ac134$var$triggerUpdateJiraEventAnalytics,
    triggerViewRoadmapEventAnalytics: $abafebe2863ac134$var$triggerViewRoadmapEventAnalytics,
    triggerCalculationDurationAnalytics: $abafebe2863ac134$var$triggerCalculationDurationAnalytics,
    triggerCreateCrossProjectReleaseAnalytics: $abafebe2863ac134$var$triggerCreateCrossProjectReleaseAnalytics
};

});


parcelRegister("i86jm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb0abf1cc409cf6$export$2e2bcd8739ae039);

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $3Ah6R = parcelRequire("3Ah6R");

var $k7vr6 = parcelRequire("k7vr6");

var $lP5Go = parcelRequire("lP5Go");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdb0abf1cc409cf6$var$arePropsEqual = (a, b)=>(0, $iK4oF.equals)(a, b, 256);
const $bdb0abf1cc409cf6$export$c175600e334513b4 = (0, $lNNXV.connect)((0, $k7vr6.default), (0, $3Ah6R.default), null, {
    areOwnPropsEqual: $bdb0abf1cc409cf6$var$arePropsEqual,
    areStatePropsEqual: $bdb0abf1cc409cf6$var$arePropsEqual
})((0, $lP5Go.default));
var $bdb0abf1cc409cf6$export$2e2bcd8739ae039 = $bdb0abf1cc409cf6$export$c175600e334513b4;

});
parcelRegister("3Ah6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942ad61fdf91707$export$2e2bcd8739ae039);

var $fk2gn = parcelRequire("fk2gn");

var $77LR7 = parcelRequire("77LR7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2942ad61fdf91707$export$2e2bcd8739ae039 = (dispatch)=>({
        startInlineCreate: (payload)=>{
            dispatch((0, $fk2gn.startInlineCreate)(payload));
        },
        setIssueBeingEdited: (issueId)=>{
            dispatch((0, $77LR7.setIssueBeingEdited)(issueId));
        }
    });

});

parcelRegister("k7vr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8a4524251c3d98$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $6UAvZ = parcelRequire("6UAvZ");

var $fZW8G = parcelRequire("fZW8G");

var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");

var $40hi6 = parcelRequire("40hi6");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
const $fb8a4524251c3d98$export$c488400972c3259 = (hierarchyLevels, hierarchyFilter, typeToLevel)=>(issueType)=>{
        const { value: value } = hierarchyFilter;
        const start = Math.min(value.start, typeToLevel(issueType) - 1);
        const end = value.end;
        return hierarchyLevels.filter(({ level: level })=>level <= start && level >= end);
    };
const $fb8a4524251c3d98$var$getFilteredHierarchyForType = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getHierarchyLevels),
    (0, $6UAvZ.getHierarchyFilter),
    (0, $fZW8G.getTypeToLevel)
], $fb8a4524251c3d98$export$c488400972c3259);
var $fb8a4524251c3d98$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    activeSearchResultIndex: (0, $40hi6.getActiveSearchResultIndex),
    hasSelectedIssues: (state)=>(0, $kwMvv.getSelected)(state).size > 0,
    hierarchyLevelsForType: $fb8a4524251c3d98$var$getFilteredHierarchyForType,
    isExportMode: $akhOi.isExportMode,
    isOptimizedMode: $akhOi.isOptimizedMode,
    issueSearchResults: (0, $40hi6.searchForIssues),
    projects: (0, $ehEr2.getProjects),
    searchQuery: (0, $40hi6.getSearchQuery),
    showWarning: (state)=>(0, $9H2AP.getWarningViewSettings)(state).showWarning,
    typeToLevel: (0, $fZW8G.getTypeToLevel),
    viewMode: (0, $9H2AP.getViewMode)
});

});

parcelRegister("lP5Go", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2dbbe62a0b3ecc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $7d70y = parcelRequire("7d70y");
var $jPCDz = parcelRequire("jPCDz");
var $1zKBj = parcelRequire("1zKBj");

var $2jDha = parcelRequire("2jDha");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");

var $1ybV0 = parcelRequire("1ybV0");

var $2KzVh = parcelRequire("2KzVh");

var $aAyrO = parcelRequire("aAyrO");
var $6ETZE = parcelRequire("6ETZE");
var $fmBR7 = parcelRequire("fmBR7");
var $eNhh9 = parcelRequire("eNhh9");
var $7Mdad = parcelRequire("7Mdad");
var $gwbfD = parcelRequire("gwbfD");
var $lcvrv = parcelRequire("lcvrv");

var $cuuJa = parcelRequire("cuuJa");

var $dC8ep = parcelRequire("dC8ep");
parcelRequire("40hi6");
var $dJx9o = parcelRequire("dJx9o");
var $40hi6 = parcelRequire("40hi6");
parcelRequire("9sEgY");
var $5Cso7 = parcelRequire("5Cso7");

var $aM5yF = parcelRequire("aM5yF");

var $57dZR = parcelRequire("57dZR");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $4UWBa = parcelRequire("4UWBa");

var $5rYNM = parcelRequire("5rYNM");

var $2BQwE = parcelRequire("2BQwE");

var $8tcM1 = parcelRequire("8tcM1");

var $jMP2a = parcelRequire("jMP2a");

var $duQ8C = parcelRequire("duQ8C");

var $1fxIl = parcelRequire("1fxIl");
parcelRequire("hj9QC");
var $90o73 = parcelRequire("90o73");

var $dgMiH = parcelRequire("dgMiH");

var $3jxOP = parcelRequire("3jxOP");
parcelRequire("ihCOl");
var $cY48v = parcelRequire("cY48v");
parcelRequire("h6qU3");
var $gC3zx = parcelRequire("gC3zx");

var $4sQzf = parcelRequire("4sQzf");
const $6d2dbbe62a0b3ecc$var$DIGIT_WIDTH = 8;
const $6d2dbbe62a0b3ecc$var$WARNING_WIDTH = 16;
const $6d2dbbe62a0b3ecc$export$843b17c2f6c72837 = ({ isDragging: isDragging, isOptimized: isOptimized, rootIndex: rootIndex, isSelected: isSelected, isDropParent: isDropParent, isListMode: isListMode = false })=>{
    const isEven = rootIndex === undefined ? false : rootIndex % 2 === 0;
    const isTransposed = (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') && (isListMode || (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2'));
    let classes = '';
    if (isDragging && !isTransposed) classes = $4sQzf.isDragging;
    else if (isOptimized) classes = isEven ? $4sQzf.evenOptimized : $4sQzf.oddOptimized;
    else if (!isTransposed) // These ones are set in roadmap/table/utils/background-provider/index.tsx
    classes = isEven ? $4sQzf.even : $4sQzf.odd;
    if (isSelected) classes = $4sQzf.isSelected;
    if (isDropParent) classes += ` ${$4sQzf["drop-parent"]}`;
    return classes;
};
const $6d2dbbe62a0b3ecc$export$c175600e334513b4 = ({ issue: issue, issue: { id: issueId = '', summary: summary, depth: depth, isExpandable: isExpandable, isExpanded: isExpanded, issueKey: issueKey, project: // @ts-expect-error - TS2322 - Type '{}' is not assignable to type 'number & Readonly<{ id: number; key: string; name: string; avatarUrl: string; versions: string[]; components?: Component[] | undefined; issueTypeIds: number[]; isDefault?: boolean | undefined; ... 4 more ...; projectTypeKey: "business" | ... 1 more ... | "service_desk"; }>'.
project = {}, rootIndex: rootIndex, type: issueType, group: // @ts-expect-error - TS2322 - '' is compatible with Grouping
group = '', originals: originals }, isDropParent: isDropParent, isReadOnly: isReadOnly, isDragging: isDragging, isOptimizedMode: isOptimizedMode, isScrolling: isScrolling, groupCombination: groupCombination = {}, onToggle: onToggle, isSelected: isSelected = false, hasChildSelected: hasChildSelected, rankDigits: rankDigits, hideRank: hideRank, warnings: warnings, showWarning: showWarning, hasIndentation: hasIndentation, issueSearchResults: issueSearchResults, activeSearchResultIndex: activeSearchResultIndex, searchQuery: searchQuery, showTooltip: showTooltip = true, setIssueBeingEdited: setIssueBeingEdited, isExportMode: isExportMode, hierarchyLevelsForType: hierarchyLevelsForType, projects: projects, typeToLevel: typeToLevel, startInlineCreate: startInlineCreate, toggleSelected: toggleSelected, hasSelectedIssues: hasSelectedIssues, isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField, viewMode: viewMode, outerRef: outerRef })=>{
    const [showMeatballButton, setShowMeatballButton] = (0, $eUqFw.useState)(false);
    const [dropMenuIsOpen, setDropMenuIsOpen] = (0, $eUqFw.useState)(false);
    const [isMouseOverIssue, setIsMouseOverIssue] = (0, $eUqFw.useState)(false);
    const [optimizeFlyoutTopPosition, setOptimizeFlyoutTopPosition] = (0, $eUqFw.useState)(0);
    const innerRef = (0, $eUqFw.useRef)(null);
    const ref = (0, $2KzVh.default)(innerRef, outerRef);
    const handleToggle = (event)=>{
        if (!issueId) throw new Error('Issue must have id!');
        const idSuffix = Object.keys(groupCombination).length ? `:${(0, $dJx9o.getGroupKey)(groupCombination)}` : '';
        if (isExpanded) (0, $duQ8C.default)((0, $2BQwE.KEYS).COLLAPSE_ISSUE, event.timeStamp);
        else (0, $duQ8C.default)((0, $2BQwE.KEYS).EXPAND_ISSUE, event.timeStamp);
        onToggle({
            [`${issueId}${idSuffix}`]: !isExpanded
        });
    };
    const summaryWithMatchHighlighting = (issueLinkChunks)=>{
        const { searchMatches: searchMatches } = issueSearchResults;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gC3zx.HighlightSummary), {
            group: group,
            numberOfIssueLinkChunks: issueLinkChunks.length,
            searchMatches: searchMatches,
            summary: summary,
            searchQuery: searchQuery,
            id: issueId,
            activeSearchResultIndex: activeSearchResultIndex
        });
    };
    const isSummaryDirty = ()=>originals && $jPCDz.default('summary', originals);
    const isDescriptionDirty = ()=>originals && $jPCDz.default('description', originals);
    const shouldShowSummaryChangeIndicator = ()=>!isOptimizedMode && (isSummaryDirty() || isDescriptionDirty());
    const isRankDirty = ()=>!issueKey || originals && originals.lexoRank;
    const shouldShowRankChangeIndicator = ()=>!isOptimizedMode && isRankDirty();
    const triggerOpenIssueDescriptionDialogAnalytics = (analyticsEvent)=>{
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ISSUE_SUMMARY_BUTTON.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: action,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ISSUE_SUMMARY_BUTTON, 'arjScopeIssueSummaryBtn', {
            isReadOnly: isReadOnly,
            isScenarioIssue: issue.id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX)),
            issueTypeId: issue.type.id
        });
    };
    const getIssueSummary = (issueLinkChunks)=>{
        if (isExportMode) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4sQzf.summaryReadView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $4sQzf.ellipsis
        }, issue.summary ?? ' ')));
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) {
            const wrappedNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $4sQzf.summaryBtn,
                onClick: (_e, analyticsEvent)=>{
                    /**
						 * This function does three things:
						 * 1. it displays a spinner on the issue description field in the issue modal dialog
						 * 2. it fetches the issue description from the backend based on the issue id
						 * 3. it hides the spinner upon receiving the response from the backend
						 */ setIssueBeingEdited(issue.id);
                    triggerOpenIssueDescriptionDialogAnalytics(analyticsEvent);
                },
                appearance: "subtle"
            }, summaryWithMatchHighlighting(issueLinkChunks));
            if (showTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: issue.summary || ''
            }, wrappedNode);
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $4sQzf.summaryReadView
            }, wrappedNode);
        }
        const wrappedNode = isDragging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            padding: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            weight: "medium"
        }, summaryWithMatchHighlighting(issueLinkChunks))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1fxIl.DraggableButton), {
            onClick: (_e, analyticsEvent)=>{
                /**
					 * This function does three things:
					 * 1. it displays a spinner on the issue description field in the issue modal dialog
					 * 2. it fetches the issue description from the backend based on the issue id
					 * 3. it hides the spinner upon receiving the response from the backend
					 */ setIssueBeingEdited(issue.id);
                triggerOpenIssueDescriptionDialogAnalytics(analyticsEvent);
            },
            appearance: "subtle"
        }, summaryWithMatchHighlighting(issueLinkChunks));
        if (showTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: issue.summary || ''
        }, wrappedNode);
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4sQzf.summaryReadView
        }, wrappedNode);
    };
    const shouldShowDropMenu = ()=>!isReadOnly && !isScrolling && !isDragging && (showMeatballButton || dropMenuIsOpen);
    // When clicking a drop menu item, the menu disappears and no mouseleave event is triggered
    const hoverOut = (fn)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (...args)=>{
            setShowMeatballButton(false);
            fn(...args);
        };
    const handleDropMenuToggle = ({ isOpen: isOpen })=>setDropMenuIsOpen(isOpen);
    const triggerInlineCreateIssueAnalytics = (analyticsEvent, issueTypeId)=>{
        const analyticsKey = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CREATED_ISSUE_INLINE;
        const [actionSubject, eventAction] = analyticsKey.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: eventAction,
            actionSubject: actionSubject
        }), analyticsKey, {
            issueType: issueTypeId
        });
    };
    const handleMeatBallButtonBlurEvent = ()=>{
        setShowMeatballButton(false);
    };
    const dropMenu = ()=>{
        const issueDropMenuOptions = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgMiH.default), {
                key: "create-issue-dropdown-menu-item",
                issue: issue,
                hierarchyLevelsForType: hierarchyLevelsForType,
                projects: projects,
                typeToLevel: typeToLevel,
                startInlineCreate: hoverOut(startInlineCreate),
                triggerClassName: $4sQzf.addIcon,
                groupCombination: groupCombination,
                triggerInlineCreateIssueAnalytics: triggerInlineCreateIssueAnalytics,
                isDisabled: isGroupingByMultiSelectCustomField
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cY48v.default), {
                key: "select-issue-dropdown-menu-item",
                onRequestSelect: hoverOut(toggleSelected)
            })
        ];
        if (hasSelectedIssues) issueDropMenuOptions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3jxOP.default), {
            key: "rank-issue-dropdown-menu-item",
            issueId: issue.id,
            isSelected: isSelected
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90o73.default), {
            onOpenChange: handleDropMenuToggle,
            ariaLabel: issue?.summary,
            handleBlurEvent: handleMeatBallButtonBlurEvent
        }, issueDropMenuOptions);
    };
    const isOptimized = (()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let isOptimized = false;
        if (isOptimizedMode && (0, $7CnHa.isDefined)(issue.optimized)) {
            for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                isOptimized = true;
                break;
            }
        }
        return isOptimized;
    })();
    const onHoverChanged = (hovered)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let rect = {};
        if (isOptimized) {
            if (innerRef.current) rect = innerRef.current.getBoundingClientRect();
        }
        setShowMeatballButton(hovered);
        setIsMouseOverIssue(hovered);
        setOptimizeFlyoutTopPosition(rect.top);
    };
    const triggerCheckboxChangeAnalytics = (analyticsEvent)=>{
        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: eventAction,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
            selectOption: (0, $5Cso7.TargetTypes).single
        });
    };
    const handleCheckboxChange = (e, analyticsEvent)=>{
        const on = !isSelected;
        const extending = e.nativeEvent instanceof MouseEvent && e.nativeEvent.shiftKey;
        toggleSelected(on, {
            extending: extending,
            targetType: (0, $5Cso7.TargetTypes).single
        });
        if (on) triggerCheckboxChangeAnalytics(analyticsEvent);
    };
    const { searchMatches: searchMatches, hasNestedMatches: hasNestedMatches } = issueSearchResults;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const issueWarnings = warnings.byIssue[issueId] || [];
    const hasWarnings = !!issueWarnings.length && showWarning;
    const rankWidth = $6d2dbbe62a0b3ecc$var$DIGIT_WIDTH * rankDigits;
    const issueLink = issueKey && project.key ? `${project.key}-${issueKey}` : project.key || '';
    const issueLinkChunks = searchQuery.trim() ? (0, $40hi6.splitString)(searchQuery, issueLink) : [];
    const backgroundClassName = $6d2dbbe62a0b3ecc$export$843b17c2f6c72837({
        isDragging: isDragging,
        isOptimized: isOptimized,
        rootIndex: rootIndex,
        isSelected: isSelected,
        isDropParent: isDropParent,
        isListMode: viewMode === (0, $lcvrv.VIEW_MODES).LIST
    });
    const withNestedMatches = hasNestedMatches[group] && hasNestedMatches[group][issueId];
    const rankContent = ()=>{
        if (hasWarnings) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tcM1.default), {
            warnings: issueWarnings
        });
        if ($7d70y.default(issueId, warnings.transitiveIssueIds) && showWarning) {
            const transitiveWarnings = [
                (0, $dC8ep.misconfiguredChildrenWarning)()
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tcM1.default), {
                warnings: transitiveWarnings
            });
        }
        if (!hideRank && depth === 0) return rootIndex + 1;
        return null;
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getIssueTypeIcon = (issueId, issueType)=>{
        const issueTypeIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            // We need to use img instead of a div with backgroundImage to img due to export PNG rendering issue in Safari (JPO-18968)
            alt: issueType && issueType.name,
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.issue-icon-${issueId}`,
            src: issueType && issueType.iconUrl,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? $4sQzf["issue-icon"] : $4sQzf["issue-icon-old"]
        });
        if (isExportMode) return issueTypeIcon;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4sQzf.issueIconTooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: issueType ? issueType.name : ''
        }, issueTypeIcon)));
    };
    const cursorStyle = {
        cursor: isOptimized || isReadOnly ? 'default' : 'pointer'
    };
    const shouldShowFlyout = isOptimized && isMouseOverIssue;
    const shouldLockScroll = shouldShowFlyout || dropMenuIsOpen;
    const onFocusChanged = (event)=>{
        if (event.target === event.currentTarget) setShowMeatballButton(true);
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Tab' && event.shiftKey && event.target === event.currentTarget) setShowMeatballButton(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
        onHoverChanged: onHoverChanged
    }, // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: cursorStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$4sQzf.container} ${backgroundClassName}`,
        "data-issue": issueId,
        "data-name": `scope-issue-${issueId}`,
        "data-group": group,
        ref: ref,
        onFocus: onFocusChanged,
        onKeyDown: onKeyDown,
        ...(0, $1ybV0.ff)('remove-role-row-from-div-issues-scope_r3o7p') ? {} : {
            role: 'row'
        },
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Mdad.default), {
        enabled: shouldLockScroll
    }), shouldShowFlyout && /*#__PURE__*/ (0, $lEfVV.createPortal)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf.flyoutPositioner,
        style: {
            top: optimizeFlyoutTopPosition
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aM5yF.default), {
            issue: issue
        }),
        isOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf.container
    }))), (0, $1ni3W.getBody)()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf["ranked-gutter"]
    }, shouldShowRankChangeIndicator() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), {
        appearance: "bar"
    })), !isReadOnly && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf["select-checkbox"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        isChecked: isSelected || hasChildSelected,
        isIndeterminate: hasChildSelected && !isSelected,
        onChange: handleCheckboxChange,
        testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue-${issueId}`,
        "aria-labelledby": `issue-link-${issueId}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4sQzf.rank,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: rankWidth,
            minWidth: $6d2dbbe62a0b3ecc$var$WARNING_WIDTH
        },
        "data-name": "rank"
    }, rankContent()), hasIndentation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf["group-indentation"]
    }), $1zKBj.default((n)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: n,
            className: $4sQzf.icon,
            style: cursorStyle,
            "data-name": "spacer"
        }), depth || 0), isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$4sQzf.icon} ${$4sQzf.toggle} ${withNestedMatches ? $4sQzf["parent-match"] : ''}`,
        onClick: handleToggle,
        "aria-expanded": isExpanded,
        "aria-controls": `issue-link-${issueId}`,
        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.button-${issueId}`,
        "aria-labelledby": `issue-link-${issueId}`
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "",
        size: "medium"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: "",
        size: "medium"
    })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf.icon,
        style: cursorStyle
    }), getIssueTypeIcon(issueId, issueType), !!project.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gC3zx.HighlightIssueLink), {
        issueKey: issueKey,
        projectKey: project.key,
        issueLinkChunks: issueLinkChunks,
        searchQuery: searchQuery,
        activeMatch: searchMatches[activeSearchResultIndex],
        issueId: issueId,
        group: group
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4sQzf.summary
    }, getIssueSummary(issueLinkChunks), shouldShowSummaryChangeIndicator() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), null)), shouldShowDropMenu() && dropMenu()));
};
$6d2dbbe62a0b3ecc$export$c175600e334513b4.displayName = 'Issue';
$6d2dbbe62a0b3ecc$export$c175600e334513b4.whyDidYouRender = true;
var // @ts-expect-error - TS2345: Type 'WithAnalyticsEventsProps' is missing the following properties from type 'Props': issue, issuesInFilter, rankDigits, onToggle, and 14 more.
$6d2dbbe62a0b3ecc$export$2e2bcd8739ae039 = (0, $2jDha.default)()(/*#__PURE__*/ (0, $eUqFw.memo)($6d2dbbe62a0b3ecc$export$c175600e334513b4));

});
parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("9sEgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f79f29f71c83cc6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TargetTypes", () => (parcelRequire("5Cso7")).TargetTypes);

var $lNNXV = parcelRequire("lNNXV");

var $7zTbC = parcelRequire("7zTbC");

var $eGeY8 = parcelRequire("eGeY8");

var $2RhIg = parcelRequire("2RhIg");

var $5Cso7 = parcelRequire("5Cso7");
var $2f79f29f71c83cc6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $eGeY8.default), (0, $7zTbC.default))((0, $2RhIg.default));

});
parcelRegister("7zTbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae053c48310ef7a$export$2e2bcd8739ae039);

var $5Cso7 = parcelRequire("5Cso7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8ae053c48310ef7a$export$2e2bcd8739ae039 = {
    toggleSelectedIssues: $5Cso7.toggleSelectedIssues
};

});

parcelRegister("eGeY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4922dfdfb65a2a23$export$2e2bcd8739ae039);
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");
var $kwMvv = parcelRequire("kwMvv");

var $a0bo1 = parcelRequire("a0bo1");

var $iK4oF = parcelRequire("iK4oF");

var $8Nqhy = parcelRequire("8Nqhy");
const $4922dfdfb65a2a23$var$lastSelected = (state)=>state.ui.Main.Tabs.Roadmap.Scope.Issues.lastSelected;
const $4922dfdfb65a2a23$var$getIssueIdFromProps = (_, props)=>props.issueId;
const $4922dfdfb65a2a23$var$getIssues = (0, $iK4oF.createSelector)([
    (0, $8Nqhy.getEnhancedIssues)
], (enhancedIssues)=>enhancedIssues.filter((item)=>item.tag === (0, $a0bo1.TABLE_ISSUE)));
const $4922dfdfb65a2a23$var$isSelected = (state, props)=>!!(0, $kwMvv.getSelected)(state).has(props.issueId);
const $4922dfdfb65a2a23$export$9b7fd1d370baca28 = (descendantIds, selected, issueId)=>!!(descendantIds[issueId] && descendantIds[issueId].some((id)=>selected.has(id)));
const $4922dfdfb65a2a23$export$b8b0369ffb6a709c = (state, props)=>(0, $kwMvv.getDescendantIdsByParent)(state)[props.issueId] || [];
const $4922dfdfb65a2a23$var$hasChildSelected = (0, $iK4oF.createSelector)([
    (0, $aK3ri.getChildrenIdsByParent),
    (0, $kwMvv.getSelected),
    $4922dfdfb65a2a23$var$getIssueIdFromProps
], $4922dfdfb65a2a23$export$9b7fd1d370baca28);
const $4922dfdfb65a2a23$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    isSelected: $4922dfdfb65a2a23$var$isSelected,
    hasChildSelected: $4922dfdfb65a2a23$var$hasChildSelected,
    lastSelected: $4922dfdfb65a2a23$var$lastSelected,
    descendantIds: $4922dfdfb65a2a23$export$b8b0369ffb6a709c,
    issues: $4922dfdfb65a2a23$var$getIssues
});
var $4922dfdfb65a2a23$export$2e2bcd8739ae039 = $4922dfdfb65a2a23$var$querySelector;

});

parcelRegister("2RhIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb750852e9d7f99e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Cso7 = parcelRequire("5Cso7");

var $11vKO = parcelRequire("11vKO");
const $bb750852e9d7f99e$export$d411c0d423bc94e0 = ({ issues: issues, lastSelected: lastSelected, descendantIds: descendantIds, toggleSelectedIssues: toggleSelectedIssues, issueId: issueId, group: group, isSelected: isSelected, hasChildSelected: hasChildSelected, children: children })=>{
    const toggleSingle = (0, $eUqFw.useCallback)((on, { targetType: targetType })=>toggleSelectedIssues({
            ids: [
                issueId
            ],
            isSelected: on,
            group: group,
            targetType: targetType
        }), [
        group,
        issueId,
        toggleSelectedIssues
    ]);
    const toggleExtending = (0, $eUqFw.useCallback)((on, { targetType: targetType })=>{
        const issuesInBetween = (0, $11vKO.getIssuesInRange)({
            issues: issues,
            lastSelected: lastSelected,
            issueId: issueId,
            group: group
        });
        const ids = issuesInBetween.map((issue)=>(0, $11vKO.getId)(issue) || '');
        return toggleSelectedIssues({
            ids: ids,
            isSelected: on,
            group: group,
            targetType: targetType
        });
    }, [
        group,
        issueId,
        issues,
        lastSelected,
        toggleSelectedIssues
    ]);
    const toggleDescendants = (0, $eUqFw.useCallback)((on, { targetType: targetType })=>{
        toggleSelectedIssues({
            ids: descendantIds,
            currentIssueId: issueId,
            isSelected: on,
            group: group,
            targetType: targetType
        });
    }, [
        descendantIds,
        group,
        issueId,
        toggleSelectedIssues
    ]);
    const toggleSingleAndDescendants = (0, $eUqFw.useCallback)((on, { targetType: targetType })=>toggleSelectedIssues({
            ids: [
                issueId
            ].concat(descendantIds),
            isSelected: on,
            group: group,
            targetType: targetType
        }), [
        descendantIds,
        group,
        issueId,
        toggleSelectedIssues
    ]);
    const toggle = (0, $eUqFw.useCallback)((on, toggleParams)=>{
        const { extending: extending, targetType: targetType } = toggleParams;
        if (extending && lastSelected.id) return toggleExtending(on, toggleParams);
        switch(targetType){
            case (0, $5Cso7.TargetTypes).single:
                return toggleSingle(on, toggleParams);
            case (0, $5Cso7.TargetTypes).singleAndDescendants:
                return toggleSingleAndDescendants(true, toggleParams);
            case (0, $5Cso7.TargetTypes).descendants:
                return toggleDescendants(true, toggleParams);
            default:
                throw new TypeError('unexpected targetType');
        }
    }, [
        lastSelected?.id,
        toggleDescendants,
        toggleExtending,
        toggleSingle,
        toggleSingleAndDescendants
    ]);
    return children({
        isSelected: isSelected,
        hasChildSelected: hasChildSelected,
        toggleSelected: toggle
    });
};
var $bb750852e9d7f99e$export$2e2bcd8739ae039 = $bb750852e9d7f99e$export$d411c0d423bc94e0;

});
parcelRegister("11vKO", function(module, exports) {

$parcel$export(module.exports, "getId", () => $36ed27b251413226$export$218c8c3169c024d2);
$parcel$export(module.exports, "getIssuesInRange", () => $36ed27b251413226$export$ee4b94b8b7f020aa);

var $a0bo1 = parcelRequire("a0bo1");
function $36ed27b251413226$export$218c8c3169c024d2(item) {
    if (item.tag !== (0, $a0bo1.TABLE_ISSUE)) return null;
    return item.value.id;
}
const $36ed27b251413226$var$getGroup = (item)=>item.group;
function $36ed27b251413226$export$ee4b94b8b7f020aa({ issues: issues, lastSelected: lastSelected, issueId: issueId, group: group }) {
    const lastSelectedIndex = issues.findIndex((issue)=>!$36ed27b251413226$var$getGroup(issue) ? $36ed27b251413226$export$218c8c3169c024d2(issue) === lastSelected.id : lastSelected.group === $36ed27b251413226$var$getGroup(issue) && $36ed27b251413226$export$218c8c3169c024d2(issue) === lastSelected.id);
    const thisSelectedIndex = issues.findIndex((issue)=>!$36ed27b251413226$var$getGroup(issue) ? $36ed27b251413226$export$218c8c3169c024d2(issue) === issueId : group === $36ed27b251413226$var$getGroup(issue) && $36ed27b251413226$export$218c8c3169c024d2(issue) === issueId);
    const isSelectingForwards = thisSelectedIndex > lastSelectedIndex;
    const start = isSelectingForwards ? lastSelectedIndex : thisSelectedIndex;
    const end = isSelectingForwards ? thisSelectedIndex : lastSelectedIndex;
    const inBetween = issues.slice(start, end + 1);
    if (!isSelectingForwards) inBetween.reverse();
    return inBetween;
}

});



parcelRegister("aM5yF", function(module, exports) {

$parcel$export(module.exports, "default", () => $365d46c57743381d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bFZ87 = parcelRequire("bFZ87");

var $iKqrM = parcelRequire("iKqrM");
var $365d46c57743381d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bFZ87.default), {})((0, $iKqrM.default));

});
parcelRegister("bFZ87", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedd37631847b8d9$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");

var $iK4oF = parcelRequire("iK4oF");
const $bedd37631847b8d9$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    customFields: (0, $kKj1m.getCustomFields),
    dateConfiguration: (0, $75KhQ.getDateConfiguration),
    teams: (0, $MQRDu.getTeams),
    sprints: (0, $c1XMU.getAllSprints),
    versions: (0, $wcCGG.getVersions)
});
var $bedd37631847b8d9$export$2e2bcd8739ae039 = $bedd37631847b8d9$export$c31df4bd766f9c35;

});

parcelRegister("iKqrM", function(module, exports) {

$parcel$export(module.exports, "FLYOUT_CONTENT_WIDTH", () => $372b48bd96ce9a3c$export$a3c5c8ce6ae3cded);
$parcel$export(module.exports, "default", () => $372b48bd96ce9a3c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $ffiyv = parcelRequire("ffiyv");

var $eOsHk = parcelRequire("eOsHk");
parcelRequire("2Bjja");
var $b1b5T = parcelRequire("b1b5T");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $5pYU0 = parcelRequire("5pYU0");

var $mv2Kz = parcelRequire("mv2Kz");

var $2UKma = parcelRequire("2UKma");
const $372b48bd96ce9a3c$export$a3c5c8ce6ae3cded = 400;
const { SPRINT: $372b48bd96ce9a3c$var$SPRINT, ROLL_UP: $372b48bd96ce9a3c$var$ROLL_UP } = (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION);
const $372b48bd96ce9a3c$var$None = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $mv2Kz.none,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.row-flyout-none"
    }, intl.formatMessage({
        ...(0, $5pYU0.default).none
    }));
};
const $372b48bd96ce9a3c$var$valueOrNone = (value)=>(0, $7CnHa.isDefined)(value) ? value : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($372b48bd96ce9a3c$var$None, null);
// @ts-expect-error - TS7006 - Parameter 'inferred' implicitly has an 'any' type.
const $372b48bd96ce9a3c$var$currentValueCell = (inferred, key, currentValue)=>{
    if (inferred && key && inferred[key] === $372b48bd96ce9a3c$var$ROLL_UP) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.valueWithIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.rollUpIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1b5T.default), {
        primaryColor: `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N200})`,
        size: "medium",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.inferredText
    }, $372b48bd96ce9a3c$var$valueOrNone(currentValue))));
    if (inferred && key && inferred[key] === $372b48bd96ce9a3c$var$SPRINT) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.valueWithIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.sprintIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        maxWidth: 15
    }, "S")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.inferredText
    }, $372b48bd96ce9a3c$var$valueOrNone(currentValue))));
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $mv2Kz.valueWithIcon
    }, $372b48bd96ce9a3c$var$valueOrNone(currentValue));
};
const $372b48bd96ce9a3c$var$BarFlyout = ({ issue: issue, teams: teams, sprints: sprints, versions: versions, dateFormat: dateFormat = (0, $5rYNM.DefaultDateFormat), dateConfiguration: dateConfiguration, customFields: customFields })=>{
    const intl = (0, $5JgJ2.default)();
    const optimizedFields = (0, $2UKma.getOptimizedFields)(issue, teams, sprints, versions, dateFormat, dateConfiguration, customFields, intl);
    const optimizedFieldsCount = optimizedFields.length;
    const style = {
        width: $372b48bd96ce9a3c$export$a3c5c8ce6ae3cded
    };
    const getFieldRow = ({ label: label, currentValue: currentValue, optimizedValue: optimizedValue, delta: delta, inferred: inferred, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            key: label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            className: $mv2Kz.label
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, $372b48bd96ce9a3c$var$currentValueCell(inferred, key, currentValue)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N200})`,
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, $372b48bd96ce9a3c$var$valueOrNone(optimizedValue), delta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $mv2Kz.delta
        }, "(", delta, ")"))));
    const rows = optimizedFields.map(getFieldRow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $mv2Kz.barFlyout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.bar-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage({
        ...(0, $5pYU0.default).header
    }, {
        optimizedFieldsCount: optimizedFieldsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: $mv2Kz.label
    }, intl.formatMessage({
        ...(0, $5pYU0.default).before
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        className: $mv2Kz.label
    }, intl.formatMessage({
        ...(0, $5pYU0.default).after
    }))), rows)));
};
var $372b48bd96ce9a3c$export$2e2bcd8739ae039 = $372b48bd96ce9a3c$var$BarFlyout;

});
parcelRegister("5pYU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5086ad80f5d9289$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5086ad80f5d9289$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.header",
        "defaultMessage": "{optimizedFieldsCount, plural, one {# value} other {# values}} will be updated:"
    },
    targetDates: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.target-dates",
        "defaultMessage": "{dateFieldTitle}"
    },
    team: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.team",
        "defaultMessage": "Team"
    },
    releases: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.releases",
        "defaultMessage": "{releaseCount, plural, one {Release} other {Releases}}"
    },
    unknownTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-team",
        "defaultMessage": "Unknown team {id}"
    },
    unknownSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-sprint",
        "defaultMessage": "Unknown sprint {id}"
    },
    unknownVersion: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.unknown-version",
        "defaultMessage": "Unknown version {id}"
    },
    before: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.before",
        "defaultMessage": "Before"
    },
    after: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.after",
        "defaultMessage": "After"
    },
    none: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.flyout.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("mv2Kz", function(module, exports) {

$parcel$export(module.exports, "barFlyout", () => $043a22c0cd2e759e$export$1fa710d2293f25bc, (v) => $043a22c0cd2e759e$export$1fa710d2293f25bc = v);
$parcel$export(module.exports, "delta", () => $043a22c0cd2e759e$export$eabbe41f409ce55b, (v) => $043a22c0cd2e759e$export$eabbe41f409ce55b = v);
$parcel$export(module.exports, "inferredText", () => $043a22c0cd2e759e$export$e9b0ff3b5f703425, (v) => $043a22c0cd2e759e$export$e9b0ff3b5f703425 = v);
$parcel$export(module.exports, "label", () => $043a22c0cd2e759e$export$1237798dc640739a, (v) => $043a22c0cd2e759e$export$1237798dc640739a = v);
$parcel$export(module.exports, "none", () => $043a22c0cd2e759e$export$f883a24d5edde77c, (v) => $043a22c0cd2e759e$export$f883a24d5edde77c = v);
$parcel$export(module.exports, "rollUpIcon", () => $043a22c0cd2e759e$export$894901fa58357dbf, (v) => $043a22c0cd2e759e$export$894901fa58357dbf = v);
$parcel$export(module.exports, "sprintIcon", () => $043a22c0cd2e759e$export$f465bc73cc7bf2e2, (v) => $043a22c0cd2e759e$export$f465bc73cc7bf2e2 = v);
$parcel$export(module.exports, "valueWithIcon", () => $043a22c0cd2e759e$export$357cff3c53bd3721, (v) => $043a22c0cd2e759e$export$357cff3c53bd3721 = v);
var $043a22c0cd2e759e$export$1fa710d2293f25bc;
var $043a22c0cd2e759e$export$eabbe41f409ce55b;
var $043a22c0cd2e759e$export$e9b0ff3b5f703425;
var $043a22c0cd2e759e$export$1237798dc640739a;
var $043a22c0cd2e759e$export$f883a24d5edde77c;
var $043a22c0cd2e759e$export$894901fa58357dbf;
var $043a22c0cd2e759e$export$f465bc73cc7bf2e2;
var $043a22c0cd2e759e$export$357cff3c53bd3721;
$043a22c0cd2e759e$export$1fa710d2293f25bc = `xGwiYW_barFlyout`;
$043a22c0cd2e759e$export$eabbe41f409ce55b = `xGwiYW_delta`;
$043a22c0cd2e759e$export$e9b0ff3b5f703425 = `xGwiYW_inferredText`;
$043a22c0cd2e759e$export$1237798dc640739a = `xGwiYW_label`;
$043a22c0cd2e759e$export$f883a24d5edde77c = `xGwiYW_none`;
$043a22c0cd2e759e$export$894901fa58357dbf = `xGwiYW_rollUpIcon`;
$043a22c0cd2e759e$export$f465bc73cc7bf2e2 = `xGwiYW_sprintIcon`;
$043a22c0cd2e759e$export$357cff3c53bd3721 = `xGwiYW_valueWithIcon`;

});

parcelRegister("2UKma", function(module, exports) {

$parcel$export(module.exports, "getOptimizedFields", () => $1c0b78c46807d7ef$export$b15f3a64b1de090d);

var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");

var $17L5s = parcelRequire("17L5s");
var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("75KhQ");
var $eOsHk = parcelRequire("eOsHk");

var $57dZR = parcelRequire("57dZR");

var $5ieZD = parcelRequire("5ieZD");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $5pYU0 = parcelRequire("5pYU0");
const $1c0b78c46807d7ef$var$updateJiraWhatChangedMessages = {
    ...(0, $5ieZD.default),
    dueDate: (0, $ib5d3.default).dueDate
};
const $1c0b78c46807d7ef$var$getTitleOfConfiguredDateField = (field, customFields)=>{
    const customFieldsById = (0, $7CnHa.indexBy)($f7Op5.default('id'), customFields);
    if (field.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM) // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'. | TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    return customFieldsById[field.key] ? customFieldsById[field.key].title : '';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $1c0b78c46807d7ef$var$updateJiraWhatChangedMessages[field.key].defaultMessage;
};
const $1c0b78c46807d7ef$var$dateFieldGenerator = (current, optimized, { dateConfiguration: { baselineStartField: baselineStartField, baselineEndField: baselineEndField }, customFields: customFields, key: key, dateFormat: dateFormat, intl: intl }, inferred)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formatDateOrUndefined = (date)=>(0, $7CnHa.isDefined)(date) ? (0, $l2Sj2.formatDateUTC)(date, dateFormat) : undefined;
    let message = '';
    if (key === 'baselineStart') message = $1c0b78c46807d7ef$var$getTitleOfConfiguredDateField(baselineStartField, customFields);
    else if (key === 'baselineEnd') message = $1c0b78c46807d7ef$var$getTitleOfConfiguredDateField(baselineEndField, customFields);
    let delta;
    if ((0, $7CnHa.isDefined)(current) && (0, $7CnHa.isDefined)(optimized)) {
        if ((0, $17L5s.startOfUtcDay)(current) !== (0, $17L5s.startOfUtcDay)(optimized)) delta = (0, $17L5s.distanceInWordsWithPolarity)(current, optimized);
    }
    return {
        label: intl.formatMessage((0, $5pYU0.default).targetDates, {
            dateFieldTitle: message
        }),
        currentValue: formatDateOrUndefined(current),
        optimizedValue: formatDateOrUndefined(optimized),
        delta: delta,
        inferred: inferred,
        key: key
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1c0b78c46807d7ef$var$teamFieldGenerator = (current, optimized, { teams: teams, intl: intl })=>{
    const getTeamTitleFromId = (id)=>{
        if (id) {
            const team = teams.find((t)=>t.id === id);
            if (team) return team.title;
            return intl.formatMessage((0, $5pYU0.default).unknownTeam, {
                id: id
            });
        }
    };
    const currentTeamTitle = getTeamTitleFromId(current);
    const optimizedTeamTitle = getTeamTitleFromId(optimized);
    return {
        label: intl.formatMessage((0, $5pYU0.default).team),
        currentValue: currentTeamTitle,
        optimizedValue: optimizedTeamTitle
    };
};
const $1c0b78c46807d7ef$var$sprintFieldGenerator = (current, optimized, { sprints: sprints, intl: intl })=>{
    const getSprintTitleFromId = (id)=>{
        if (id) {
            const sprint = sprints.find((s)=>s.id === id);
            if (sprint) return sprint.title;
            return intl.formatMessage((0, $5pYU0.default).unknownSprint, {
                id: id
            });
        }
    };
    const currentSprintTitle = getSprintTitleFromId(current);
    const optimizedSprintTitle = getSprintTitleFromId(optimized);
    return {
        label: intl.formatMessage((0, $ib5d3.default).sprint),
        currentValue: currentSprintTitle,
        optimizedValue: optimizedSprintTitle
    };
};
const $1c0b78c46807d7ef$var$versionsFieldGenerator = (currentMaybe, optimizedMaybe, { versions: versions, intl: intl })=>{
    const current = currentMaybe || [];
    const optimized = optimizedMaybe || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unknownVersionMessage = (id)=>intl.formatMessage((0, $5pYU0.default).unknownVersion, {
            id: id
        });
    const getTitlesOfVersionsWithIds = $cQGVO.default((id)=>{
        const version = versions.find($h3f0m.default('id', id));
        return version ? version.name : unknownVersionMessage(id);
    });
    const maxNumReleases = Math.max(current.length, optimized.length);
    const currentVersions = getTitlesOfVersionsWithIds(current);
    const optimizedVersions = getTitlesOfVersionsWithIds(optimized);
    const currentVersionsCsv = currentVersions.join(', ');
    const optimizedVersionsCsv = optimizedVersions.join(', ');
    return {
        label: intl.formatMessage((0, $5pYU0.default).releases, {
            releaseCount: maxNumReleases
        }),
        currentValue: currentVersionsCsv || undefined,
        optimizedValue: optimizedVersionsCsv || undefined
    };
};
const $1c0b78c46807d7ef$var$fieldGenerators = {
    baselineStart: $1c0b78c46807d7ef$var$dateFieldGenerator,
    baselineEnd: $1c0b78c46807d7ef$var$dateFieldGenerator,
    team: $1c0b78c46807d7ef$var$teamFieldGenerator,
    sprint: $1c0b78c46807d7ef$var$sprintFieldGenerator,
    fixVersions: $1c0b78c46807d7ef$var$versionsFieldGenerator
};
const $1c0b78c46807d7ef$var$getOptimizedFieldEntry = (key, current, optimized, context, inferred)=>{
    const generator = $1c0b78c46807d7ef$var$fieldGenerators[key];
    if (generator) return generator(current, optimized, {
        ...context,
        key: key
    }, inferred);
    // eslint-disable-next-line no-console
    console.warn(`No generator for optimized field: ${key}`);
};
const $1c0b78c46807d7ef$export$b15f3a64b1de090d = (issue, teams, sprints, versions, dateFormat, dateConfiguration, customFields, intl)=>{
    if (issue.optimized) {
        const changedKeys = [];
        for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, optimizedKey), optimizedValue)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        changedKeys.push(optimizedKey);
        const context = {
            teams: teams,
            sprints: sprints,
            versions: versions,
            dateFormat: dateFormat,
            dateConfiguration: dateConfiguration,
            customFields: customFields,
            intl: intl
        };
        const optimizedFields = $cQGVO.default((key)=>$1c0b78c46807d7ef$var$getOptimizedFieldEntry(key, issue[key], (issue.optimized || {})[key], context, issue.inferred), changedKeys);
        const definedOptimizedFields = (0, $7CnHa.filterDefined)(optimizedFields);
        return definedOptimizedFields;
    }
    return [];
};

});
parcelRegister("5ieZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $065639644c58075a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $065639644c58075a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Lozenge labels...
    createdLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.created-label",
        "defaultMessage": "CREATED"
    },
    deletedLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.deleted-label",
        "defaultMessage": "DELETED"
    },
    updatedLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.updated-label",
        "defaultMessage": "UPDATED"
    },
    excludedLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.excluded-label",
        "defaultMessage": "REMOVED"
    },
    addedLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-label",
        "defaultMessage": "ADDED"
    },
    // What changed labels...
    changeCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.change-count",
        "defaultMessage": "{count, plural, one {{count} field} other {{count} fields}}"
    },
    description: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.description",
        "defaultMessage": "Description"
    },
    end: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.end",
        "defaultMessage": "Release date"
    },
    fixVersions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.fix-versions",
        "defaultMessage": "Release"
    },
    lexoRank: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.lexo-rank",
        "defaultMessage": "Rank"
    },
    parent: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.parent",
        "defaultMessage": "Parent"
    },
    priority: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.priority",
        "defaultMessage": "Priority"
    },
    project: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.project",
        "defaultMessage": "Project"
    },
    sprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.sprint",
        "defaultMessage": "Sprint"
    },
    start: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.start",
        "defaultMessage": "Start date"
    },
    storyPoints: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.story-points",
        "defaultMessage": "Story points"
    },
    summary: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.summary",
        "defaultMessage": "Summary"
    },
    targetEnd: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.target-end",
        "defaultMessage": "Target end"
    },
    targetStart: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.target-start",
        "defaultMessage": "Target start"
    },
    timeEstimateDays: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.time-estimate-days",
        "defaultMessage": "Estimate (d)"
    },
    timeEstimateHours: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.time-estimate-hours",
        "defaultMessage": "Estimate (h)"
    },
    team: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.team",
        "defaultMessage": "Team"
    },
    velocity: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.velocity",
        "defaultMessage": "Velocity"
    },
    plannedCapacity: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.planned-capacity",
        "defaultMessage": "Sprint velocity"
    },
    iterationVelocity: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.iteration-velocity",
        "defaultMessage": "Iteration velocity"
    },
    iterationLength: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.iteration-length",
        "defaultMessage": "Iteration length"
    },
    issueSource: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-source",
        "defaultMessage": "Issue source"
    },
    removedMember: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-member",
        "defaultMessage": "Removed member"
    },
    addedMember: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-member",
        "defaultMessage": "Added member"
    },
    weeklyHours: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.weekly-hours",
        "defaultMessage": "Weekly hours"
    },
    schedulingMode: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.scheduling-mode",
        "defaultMessage": "Scheduling mode"
    },
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.title",
        "defaultMessage": "Title"
    },
    exceptions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.exceptions",
        "defaultMessage": "Exceptions"
    },
    issueLinkCreated: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-link-created",
        "defaultMessage": "Dependency created"
    },
    issueLinkRemoved: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.issue-link-removed",
        "defaultMessage": "Dependency removed"
    },
    components: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.components",
        "defaultMessage": "Components"
    },
    addedComponents: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-components",
        "defaultMessage": "Components added"
    },
    removedComponents: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-components",
        "defaultMessage": "Components removed"
    },
    addedLabels: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.added-labels",
        "defaultMessage": "Labels added"
    },
    removedLabels: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.removed-labels",
        "defaultMessage": "Labels removed"
    },
    labels: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.labels",
        "defaultMessage": "Labels"
    },
    customFieldAdded: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.custom-field-added",
        "defaultMessage": "{field} added"
    },
    customFieldRemoved: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.custom-field-removed",
        "defaultMessage": "{field} removed"
    },
    goals: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed.goals",
        "defaultMessage": "Goals"
    }
});

});




parcelRegister("8tcM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $73f4ab9321bff75a$export$2e2bcd8739ae039);

var $dsD3C = parcelRequire("dsD3C");
var $73f4ab9321bff75a$export$2e2bcd8739ae039 = (0, $dsD3C.default);

});
parcelRegister("dsD3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd93f0715b875d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $fmBR7 = parcelRequire("fmBR7");
const $7bd93f0715b875d7$var$WarningDetails = (props)=>{
    const { warnings: warnings, opacity: opacity, isOpen: defaultIsOpen } = props;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(!!defaultIsOpen);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onHoverChanged = (0, $eUqFw.useCallback)((isHovered)=>{
        setIsOpen(isHovered);
    }, []);
    const renderTrigger = (0, $eUqFw.useCallback)(({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: onHoverChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                opacity: opacity
            },
            ref: ref,
            "data-testid": "portfolio-3-portfolio.common.warning-details.warning-icon",
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`,
            size: "small"
        }))), [
        onHoverChanged,
        opacity
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const internationaliseNestedMessages = (values)=>{
        const amount = values.amount ? formatMessage(values.amount.key, values.amount) : null;
        return {
            ...values,
            amount: amount
        };
    };
    const renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, warnings && warnings.map((warning, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                key: index,
                xcss: $7bd93f0715b875d7$var$entryStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $7bd93f0715b875d7$var$headingStyles
            }, warnings.length > 1 && `${index + 1}. `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...warning.header,
                values: internationaliseNestedMessages(warning.messageValues)
            })), warning.message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...warning.message,
                values: internationaliseNestedMessages(warning.messageValues)
            }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        trigger: renderTrigger,
        content: renderContent,
        placement: "bottom-start",
        shouldUseCaptureOnOutsideClick: true
    });
};
var $7bd93f0715b875d7$export$2e2bcd8739ae039 = $7bd93f0715b875d7$var$WarningDetails;
const $7bd93f0715b875d7$var$entryStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    minWidth: '300px',
    maxWidth: '448px'
});
const $7bd93f0715b875d7$var$headingStyles = (0, $1ZAYh.xcss)({
    fontWeight: 'bold',
    marginBottom: 'space.100'
});

});


parcelRegister("1fxIl", function(module, exports) {

$parcel$export(module.exports, "DraggableButton", () => $48ee08ade709bffe$export$127ce26e08facc24);
$parcel$export(module.exports, "DraggableIconButton", () => $48ee08ade709bffe$export$d70443e33513c77);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
const $48ee08ade709bffe$export$127ce26e08facc24 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48ee08ade709bffe$var$CompactWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        ref: ref,
        ...props
    }, children))));
const $48ee08ade709bffe$export$d70443e33513c77 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($48ee08ade709bffe$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        ref: ref,
        ...props
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48ee08ade709bffe$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _p12f1osq _16nw1r31 _r2ecglyw _71fd1o36",
            __cmplp.className
        ])
    });
});
const $48ee08ade709bffe$var$CompactWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $48ee08ade709bffe$var$Wrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_iq9ttpi8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hj9QC", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("90o73")).default);

var $90o73 = parcelRequire("90o73");

});
parcelRegister("90o73", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb028fd8a7fecaec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG1wZ = parcelRequire("jG1wZ");

var $1ybV0 = parcelRequire("1ybV0");

var $3XRVl = parcelRequire("3XRVl");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $1fxIl = parcelRequire("1fxIl");

var $7SPCD = parcelRequire("7SPCD");
function $cb028fd8a7fecaec$var$Divider() {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $7SPCD.divider
    });
}
function $cb028fd8a7fecaec$var$withDivider(children) {
    if (!Array.isArray(children)) return children;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
    const result = children.reduce((result, elem, idx)=>{
        const child = /*#__PURE__*/ (0, $eUqFw.cloneElement)(elem, {
            ...elem.props,
            key: idx
        });
        const divider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb028fd8a7fecaec$var$Divider, {
            key: `divider-${idx}`
        });
        if (idx === 0) return [
            child
        ];
        return result.concat([
            divider,
            child
        ]);
    }, []);
    return result;
}
function $cb028fd8a7fecaec$export$2e2bcd8739ae039({ ariaLabel: ariaLabel = '', handleBlurEvent: handleBlurEvent, onOpenChange: onOpenChange, children: children }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $7SPCD.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1fxIl.DraggableIconButton), {
                ...props,
                ref: triggerRef,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))),
                label: ariaLabel,
                onBlur: handleBlurEvent
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                ref: triggerRef,
                appearance: "subtle",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null),
                spacing: "none",
                onBlur: handleBlurEvent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $7SPCD.moreIconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                label: ariaLabel
            }))),
        onOpenChange: onOpenChange,
        placement: "bottom-end",
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.more-meatball"
    }, $cb028fd8a7fecaec$var$withDivider(children))));
}

});
parcelRegister("7SPCD", function(module, exports) {

$parcel$export(module.exports, "divider", () => $5bd59ea71882c671$export$e8c9778bf415dd08, (v) => $5bd59ea71882c671$export$e8c9778bf415dd08 = v);
$parcel$export(module.exports, "moreIconWrapper", () => $5bd59ea71882c671$export$c62a2b850ddc74e1, (v) => $5bd59ea71882c671$export$c62a2b850ddc74e1 = v);
$parcel$export(module.exports, "root", () => $5bd59ea71882c671$export$e8e78c978b129247, (v) => $5bd59ea71882c671$export$e8e78c978b129247 = v);
var $5bd59ea71882c671$export$e8c9778bf415dd08;
var $5bd59ea71882c671$export$c62a2b850ddc74e1;
var $5bd59ea71882c671$export$e8e78c978b129247;
$5bd59ea71882c671$export$e8c9778bf415dd08 = `wrZGAG_divider`;
$5bd59ea71882c671$export$c62a2b850ddc74e1 = `wrZGAG_moreIconWrapper`;
$5bd59ea71882c671$export$e8e78c978b129247 = `wrZGAG_root`;

});



parcelRegister("dgMiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc46ba18d0c706f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $55Qad = parcelRequire("55Qad");

var $1aC4W = parcelRequire("1aC4W");

var $bssPO = parcelRequire("bssPO");
var $3cc46ba18d0c706f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1aC4W.default), (0, $55Qad.default))((0, $bssPO.default));

});
parcelRegister("55Qad", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ccf5958e25e2129$export$2e2bcd8739ae039);
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");
const $2ccf5958e25e2129$var$mapDispatchToProps = (dispatch)=>({
        setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
            dispatch((0, $dr4qD.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
        },
        setGlobalCreateIssue: ()=>{
            dispatch((0, $dr4qD.setGlobalCreateIssue)(false));
        }
    });
var $2ccf5958e25e2129$export$2e2bcd8739ae039 = $2ccf5958e25e2129$var$mapDispatchToProps;

});

parcelRegister("1aC4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b49485e5da05e4$export$2e2bcd8739ae039);

var $fZW8G = parcelRequire("fZW8G");

var $cwMfk = parcelRequire("cwMfk");

var $iK4oF = parcelRequire("iK4oF");
var $47b49485e5da05e4$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $cwMfk.getInlineCreateState),
    (0, $fZW8G.getHierarchy)
], ({ issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy }, hierarchy)=>({
        issueTypeId: issueTypeId,
        IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
        hierarchy: hierarchy
    }));

});

parcelRegister("bssPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f38232883eddaea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f2C9X = parcelRequire("f2C9X");

var $8uD7Y = parcelRequire("8uD7Y");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
parcelRequire("40hi6");
var $dJx9o = parcelRequire("dJx9o");

var $57dZR = parcelRequire("57dZR");

var $7CnHa = parcelRequire("7CnHa");

var $3HhDf = parcelRequire("3HhDf");

var $VRWVo = parcelRequire("VRWVo");
function $8f38232883eddaea$var$CreateIssue(props) {
    const { groupCombination: groupCombination, hierarchy: hierarchy, hierarchyLevelsForType: hierarchyLevelsForType, isDisabled: isDisabled = false, issue: { group: group, id: id, level: level, parent: parent, project: project, type: type }, projects: projects, setGlobalCreateIssue: setGlobalCreateIssue, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, startInlineCreate: startInlineCreate, triggerInlineCreateIssueAnalytics: triggerInlineCreateIssueAnalytics, typeToLevel: typeToLevel } = props;
    const currentLevel = hierarchy.find((hierarchyLevel)=>level === hierarchyLevel.level);
    if (!(0, $7CnHa.isDefined)(currentLevel)) return null;
    const hierarchyLevelTitle = (hierarchyLevel)=>hierarchyLevel.title.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getInlineCreateProject = (level)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const projectsForLevel = projects.filter((project)=>// eslint-disable-next-line @typescript-eslint/no-shadow
            project.issueTypeIds.some((id)=>typeToLevel(id) === level));
        // eslint-disable-next-line @typescript-eslint/no-shadow
        return projectsForLevel.some(({ id: id })=>id === project.id) ? project : projectsForLevel[0];
    };
    const hierarchyLevels = hierarchyLevelsForType(type.id);
    const childLevel = $f2C9X.default(hierarchyLevels);
    let childInlineCreateProject;
    if ((0, $7CnHa.isDefined)(childLevel)) childInlineCreateProject = getInlineCreateProject(childLevel.level);
    const groupKey = groupCombination && Object.keys(groupCombination).length ? (0, $dJx9o.getGroupKey)(groupCombination) : group;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        id: level,
        onClick: (_, analyticsEvent)=>{
            const inlineCreateProject = getInlineCreateProject(currentLevel.level);
            if (!(0, $7CnHa.isDefined)(inlineCreateProject)) return;
            const issueTypeId = type.id;
            if ((0, $7CnHa.isDefined)(issueTypeId)) {
                setIssueTypeIdForHierarchy(currentLevel.level, issueTypeId);
                setGlobalCreateIssue();
                // triggering analytics
                triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId);
                return startInlineCreate({
                    parentId: parent,
                    hierarchyLevel: currentLevel.level,
                    issueTypeId: issueTypeId,
                    projectId: inlineCreateProject.id,
                    siblingId: id,
                    group: groupKey,
                    groupCombination: groupCombination,
                    source: 'INLINE'
                });
            }
        },
        key: level,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $VRWVo.issueTypeLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $3HhDf.default).createIssue,
        values: {
            issueType: hierarchyLevelTitle(currentLevel)
        }
    }))), (0, $7CnHa.isDefined)(childInlineCreateProject) && (0, $7CnHa.isDefined)(childLevel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        id: childLevel.level,
        isDisabled: isDisabled,
        onClick: (_, analyticsEvent)=>{
            const issueTypeId = (0, $57dZR.getInlineCreateIssueTypeId)(childLevel.level, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            childInlineCreateProject, props);
            setIssueTypeIdForHierarchy(childLevel.level, issueTypeId);
            setGlobalCreateIssue();
            // triggering analytics
            triggerInlineCreateIssueAnalytics(analyticsEvent, issueTypeId);
            return startInlineCreate({
                parentId: id,
                hierarchyLevel: childLevel.level,
                issueTypeId: issueTypeId,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                projectId: childInlineCreateProject.id,
                siblingId: null,
                group: groupKey,
                groupCombination: groupCombination,
                source: 'INLINE'
            });
        },
        key: childLevel.level
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $VRWVo.issueTypeLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $3HhDf.default).createIssue,
        values: {
            issueType: hierarchyLevelTitle(childLevel)
        }
    }))));
}
var $8f38232883eddaea$export$2e2bcd8739ae039 = $8f38232883eddaea$var$CreateIssue;

});
parcelRegister("3HhDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a837333ca405b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4a837333ca405b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createIssue: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.create-issue.create-issue",
        "defaultMessage": "Create {issueType}"
    }
});

});

parcelRegister("VRWVo", function(module, exports) {

$parcel$export(module.exports, "issueTypeLabel", () => $0adf2c36786267bd$export$60d430d701944532, (v) => $0adf2c36786267bd$export$60d430d701944532 = v);
var $0adf2c36786267bd$export$60d430d701944532;
$0adf2c36786267bd$export$60d430d701944532 = `_0kirEG_issueTypeLabel`;

});



parcelRegister("3jxOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f163c17e319f0781$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1MuzN = parcelRequire("1MuzN");

var $7zA71 = parcelRequire("7zA71");
var $f163c17e319f0781$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $1MuzN.default))((0, $7zA71.default));

});
parcelRegister("1MuzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41df4dfaf6de86e$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c41df4dfaf6de86e$export$2e2bcd8739ae039 = (dispatch)=>({
        bulkUpdateRank: (payload)=>{
            dispatch((0, $1Szmp.bulkRankIssue)(payload));
        }
    });

});

parcelRegister("7zA71", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c37e999bbe136ba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
var $gwbfD = parcelRequire("gwbfD");

var $eOsHk = parcelRequire("eOsHk");

var $5dBB6 = parcelRequire("5dBB6");
function $3c37e999bbe136ba$var$RankIssueMenuGroup({ intl: intl, bulkUpdateRank: bulkUpdateRank, issueId: issueId, isSelected: isSelected }) {
    const rankAboveEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-above-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5dBB6.default).rankAllSelectedIssuesAbove));
    const rankBelowEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-below-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5dBB6.default).rankAllSelectedIssuesBelow));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: ()=>{
            bulkUpdateRank({
                operationType: (0, $eOsHk.RANK_BEFORE),
                anchor: issueId
            });
        },
        isDisabled: isSelected
    }, isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $5dBB6.default).noRankItself)
    }, rankAboveEl) : rankAboveEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: ()=>{
            bulkUpdateRank({
                operationType: (0, $eOsHk.RANK_AFTER),
                anchor: issueId
            });
        },
        isDisabled: isSelected
    }, isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $5dBB6.default).noRankItself)
    }, rankBelowEl) : rankBelowEl));
}
var $3c37e999bbe136ba$export$2e2bcd8739ae039 = (0, $2qhQi.default)($3c37e999bbe136ba$var$RankIssueMenuGroup);

});
parcelRegister("5dBB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $028cef1c9da09a06$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $028cef1c9da09a06$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    rankAllSelectedIssuesBelow: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-all-selected-issues-below",
        "defaultMessage": "Rank selected issues below"
    },
    rankAllSelectedIssuesAbove: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.rank-all-selected-issues-above",
        "defaultMessage": "Rank selected issues above"
    },
    noRankItself: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.rank-issue.no-rank-itself",
        "defaultMessage": "Only unselected issues can be a reference for ranking."
    }
});

});



parcelRegister("ihCOl", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("cY48v")).default);

var $cY48v = parcelRequire("cY48v");

});
parcelRegister("cY48v", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb8ad38eae844dd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("9sEgY");
var $5Cso7 = parcelRequire("5Cso7");

var $jMP2a = parcelRequire("jMP2a");

var $bfrdD = parcelRequire("bfrdD");
function $fdb8ad38eae844dd$export$2e2bcd8739ae039({ onRequestSelect: onRequestSelect }) {
    const handleRequestSelect = (targetType)=>{
        onRequestSelect(true, {
            targetType: targetType
        });
    };
    const triggerAnalytics = (analyticsEvent, targetType)=>{
        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: eventAction,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_SELECT_ISSUES, {
            selectOption: targetType
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: (_, analyticsEvent)=>{
            handleRequestSelect((0, $5Cso7.TargetTypes).singleAndDescendants);
            if (analyticsEvent) triggerAnalytics(analyticsEvent, (0, $5Cso7.TargetTypes).singleAndDescendants);
        },
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-issue-and-descendants"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bfrdD.default).selectSingleAndDescendants)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: (_, analyticsEvent)=>{
            handleRequestSelect((0, $5Cso7.TargetTypes).descendants);
            if (analyticsEvent) triggerAnalytics(analyticsEvent, (0, $5Cso7.TargetTypes).descendants);
        },
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-only-descendant-issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bfrdD.default).selectDescendants)));
}

});
parcelRegister("bfrdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e7f8dc1a47d53c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2e7f8dc1a47d53c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectSingleAndDescendants: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-single-and-descendants",
        "defaultMessage": "Select this and all descendant issues"
    },
    selectDescendants: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.drop-menu.select-issue.select-descendants",
        "defaultMessage": "Select only descendant issues"
    }
});

});



parcelRegister("h6qU3", function(module, exports) {

$parcel$export(module.exports, "HighlightSummary", () => (parcelRequire("gC3zx")).HighlightSummary);
$parcel$export(module.exports, "HighlightIssueLink", () => (parcelRequire("gC3zx")).HighlightIssueLink);

var $gC3zx = parcelRequire("gC3zx");

});
parcelRegister("gC3zx", function(module, exports) {

$parcel$export(module.exports, "HighlightSummary", () => $18be2b72a38af8df$export$596cc1018cfcd53a);
$parcel$export(module.exports, "HighlightIssueLink", () => $18be2b72a38af8df$export$2e8997f2a171b7ea);

var $eUqFw = parcelRequire("eUqFw");

var $hl4M2 = parcelRequire("hl4M2");

var $40hi6 = parcelRequire("40hi6");
parcelRequire("e0Kr7");
var $hzcvF = parcelRequire("hzcvF");

var $7CnHa = parcelRequire("7CnHa");

var $hBTcN = parcelRequire("hBTcN");
function $18be2b72a38af8df$export$596cc1018cfcd53a({ numberOfIssueLinkChunks: numberOfIssueLinkChunks, summary: summary, searchQuery: searchQuery, id: id, activeSearchResultIndex: activeSearchResultIndex, searchMatches: searchMatches, group: group }) {
    const activeElRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    const [ellipsisInfo, setEllipsisInfo] = (0, $eUqFw.useState)({
        chunks: (0, $40hi6.splitString)(searchQuery, summary),
        offsetLeft: 0
    });
    const [prevQuery, setPrevQuery] = (0, $eUqFw.useState)('');
    const activeMatch = searchMatches[activeSearchResultIndex] || {};
    const isIssueWithActiveElement = activeMatch.id === id;
    const getInternalIndex = (index)=>index > 0 ? index - numberOfIssueLinkChunks : index;
    const prevActiveSearchResultIndex = (0, $hzcvF.usePrevious)(activeSearchResultIndex);
    const prevIsIssueWithActiveElement = (0, $hzcvF.usePrevious)(isIssueWithActiveElement);
    const prevActiveMatchId = (0, $hzcvF.usePrevious)(activeMatch.id);
    // the previous summary is used to track changes made to the issue summary using the inline edit field
    const prevSummary = (0, $hzcvF.usePrevious)(summary);
    const isActiveElVisible = (ref)=>{
        if (ref && ref.current && ref.current.parentElement instanceof HTMLElement) return(// reducing the ref.current[offsetLeft + offsetWidth] by 1 to cope with "..." added in front of matching chunks which are initially hidden
        ref.current.offsetLeft + ref.current.offsetWidth - 1 <= ref.current.parentElement.offsetLeft + ref.current.parentElement.offsetWidth);
    };
    (0, $eUqFw.useEffect)(()=>{
        // resets string to initial chunks
        const isNavigationBackAtTheSameEl = (0, $7CnHa.isDefined)(prevActiveSearchResultIndex) && prevActiveSearchResultIndex > activeSearchResultIndex && prevActiveMatchId === activeMatch.id;
        if (searchQuery && searchQuery !== prevQuery || !isIssueWithActiveElement && !!prevIsIssueWithActiveElement || isNavigationBackAtTheSameEl || prevSummary !== summary) {
            setPrevQuery(searchQuery);
            setEllipsisInfo({
                chunks: (0, $40hi6.splitString)(searchQuery, summary),
                offsetLeft: 0
            });
        }
    }, [
        activeElRef,
        activeMatch.id,
        activeSearchResultIndex,
        isIssueWithActiveElement,
        prevActiveMatchId,
        prevActiveSearchResultIndex,
        prevIsIssueWithActiveElement,
        prevQuery,
        prevSummary,
        searchQuery,
        summary
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // useEffect does main stuff with cutting string and adding ellipsis
        const getWordStart = (restArray)=>{
            const lastEl = restArray[restArray.length - 1];
            const index = lastEl.lastIndexOf(' ');
            if (index > 0) return lastEl.substring(index + 1);
        };
        const matchIndex = activeMatch.internalIndex - numberOfIssueLinkChunks;
        if (isActiveElVisible(activeElRef) === false && matchIndex > 0) {
            const chunksArray = (0, $40hi6.splitString)(searchQuery, summary);
            let chunks = chunksArray.splice(matchIndex);
            const wordStart = getWordStart(chunksArray) || '';
            if (wordStart) chunks = [
                '...',
                wordStart
            ].concat(chunks);
            else chunks = [
                '...'
            ].concat(chunks);
            setEllipsisInfo({
                chunks: chunks,
                // when we have wordStart we make array longer by 1 element so we need to reduce offsetLeft by 2
                offsetLeft: !wordStart ? matchIndex - 1 : matchIndex - 2
            });
        }
    }, [
        activeElRef,
        activeMatch.internalIndex,
        numberOfIssueLinkChunks,
        searchQuery,
        summary
    ]);
    if (!searchQuery.trim() || !searchMatches.length) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $hBTcN.ellipsis
    }, summary);
    const highlightedParts = ellipsisInfo.chunks.map((chunk, i)=>{
        if ((0, $40hi6.equalsIgnoreCase)(chunk, searchQuery)) {
            const matchIndex = getInternalIndex(activeMatch.internalIndex);
            if (!activeMatch.linkMatch && activeMatch.group === group && isIssueWithActiveElement && i === matchIndex - ellipsisInfo.offsetLeft) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                ref: activeElRef,
                className: `${$hBTcN.textMatch} ${$hBTcN.isActive}`,
                key: "active"
            }, chunk));
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $hBTcN.textMatch,
                key: `${chunk}-${i}`
            }, chunk));
        }
        return chunk;
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $hBTcN.ellipsis
    }, highlightedParts);
}
function $18be2b72a38af8df$export$2e8997f2a171b7ea({ issueKey: issueKey, projectKey: projectKey, // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'SearchMatch': internalIndex, id, linkMatch
activeMatch: { internalIndex: internalIndex, id: id, group: activeGroup } = {}, searchQuery: searchQuery, issueLinkChunks: issueLinkChunks, issueId: issueId, group: group }) {
    const getLinkText = ()=>{
        if (issueLinkChunks.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issueLinkChunks.map((chunk, i)=>{
            if ((0, $40hi6.equalsIgnoreCase)(chunk, searchQuery)) return activeGroup === group && issueId === id && i === internalIndex ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: `${$hBTcN.textMatch} ${$hBTcN.isActive}`,
                key: "active"
            }, chunk) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $hBTcN.textMatch,
                key: `${chunk}-${i}`
            }, chunk);
            return chunk;
        }));
        return '';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        issueKey: issueKey,
        projectKey: projectKey,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $hBTcN.link,
        issueId: issueId
    }, getLinkText());
}

});
parcelRegister("hBTcN", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $cd20b6ff2eb2c820$export$a5b94313d6908893, (v) => $cd20b6ff2eb2c820$export$a5b94313d6908893 = v);
$parcel$export(module.exports, "isActive", () => $cd20b6ff2eb2c820$export$39e04e72f972b885, (v) => $cd20b6ff2eb2c820$export$39e04e72f972b885 = v);
$parcel$export(module.exports, "link", () => $cd20b6ff2eb2c820$export$9c30223ca0a664fb, (v) => $cd20b6ff2eb2c820$export$9c30223ca0a664fb = v);
$parcel$export(module.exports, "textMatch", () => $cd20b6ff2eb2c820$export$e1215fdc5282ac0e, (v) => $cd20b6ff2eb2c820$export$e1215fdc5282ac0e = v);
var $cd20b6ff2eb2c820$export$a5b94313d6908893;
var $cd20b6ff2eb2c820$export$39e04e72f972b885;
var $cd20b6ff2eb2c820$export$9c30223ca0a664fb;
var $cd20b6ff2eb2c820$export$e1215fdc5282ac0e;
$cd20b6ff2eb2c820$export$a5b94313d6908893 = `_5eHewW_ellipsis`;
$cd20b6ff2eb2c820$export$39e04e72f972b885 = `_5eHewW_isActive`;
$cd20b6ff2eb2c820$export$9c30223ca0a664fb = `_5eHewW_link`;
$cd20b6ff2eb2c820$export$e1215fdc5282ac0e = `_5eHewW_textMatch`;

});



parcelRegister("4sQzf", function(module, exports) {

$parcel$export(module.exports, "addIcon", () => $34028dbfe4fa36f7$export$3488242433cbedb, (v) => $34028dbfe4fa36f7$export$3488242433cbedb = v);
$parcel$export(module.exports, "container", () => $34028dbfe4fa36f7$export$34e0f9847d4c02dd, (v) => $34028dbfe4fa36f7$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "drop-parent", () => $34028dbfe4fa36f7$export$863710ae9975cbf6, (v) => $34028dbfe4fa36f7$export$863710ae9975cbf6 = v);
$parcel$export(module.exports, "ellipsis", () => $34028dbfe4fa36f7$export$a5b94313d6908893, (v) => $34028dbfe4fa36f7$export$a5b94313d6908893 = v);
$parcel$export(module.exports, "even", () => $34028dbfe4fa36f7$export$df5fefc55a4eba3c, (v) => $34028dbfe4fa36f7$export$df5fefc55a4eba3c = v);
$parcel$export(module.exports, "evenOptimized", () => $34028dbfe4fa36f7$export$df20a5f04e27573e, (v) => $34028dbfe4fa36f7$export$df20a5f04e27573e = v);
$parcel$export(module.exports, "flyoutPositioner", () => $34028dbfe4fa36f7$export$c6ee8e29facfa055, (v) => $34028dbfe4fa36f7$export$c6ee8e29facfa055 = v);
$parcel$export(module.exports, "group-indentation", () => $34028dbfe4fa36f7$export$843e51c921ce4d8d, (v) => $34028dbfe4fa36f7$export$843e51c921ce4d8d = v);
$parcel$export(module.exports, "icon", () => $34028dbfe4fa36f7$export$1ca1ec8b29a4ce27, (v) => $34028dbfe4fa36f7$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "isDragging", () => $34028dbfe4fa36f7$export$9e9bc3c487fccc00, (v) => $34028dbfe4fa36f7$export$9e9bc3c487fccc00 = v);
$parcel$export(module.exports, "isSelected", () => $34028dbfe4fa36f7$export$e4d153b3e021fb47, (v) => $34028dbfe4fa36f7$export$e4d153b3e021fb47 = v);
$parcel$export(module.exports, "issue-icon", () => $34028dbfe4fa36f7$export$39bed5d6a23c78de, (v) => $34028dbfe4fa36f7$export$39bed5d6a23c78de = v);
$parcel$export(module.exports, "issue-icon-old", () => $34028dbfe4fa36f7$export$655a12e775c013c3, (v) => $34028dbfe4fa36f7$export$655a12e775c013c3 = v);
$parcel$export(module.exports, "issueIconTooltipWrapper", () => $34028dbfe4fa36f7$export$96298c959d38f53e, (v) => $34028dbfe4fa36f7$export$96298c959d38f53e = v);
$parcel$export(module.exports, "odd", () => $34028dbfe4fa36f7$export$74b48c691cc42eb1, (v) => $34028dbfe4fa36f7$export$74b48c691cc42eb1 = v);
$parcel$export(module.exports, "oddOptimized", () => $34028dbfe4fa36f7$export$f1f85ff3be680a56, (v) => $34028dbfe4fa36f7$export$f1f85ff3be680a56 = v);
$parcel$export(module.exports, "parent-match", () => $34028dbfe4fa36f7$export$97878a1315ed5db7, (v) => $34028dbfe4fa36f7$export$97878a1315ed5db7 = v);
$parcel$export(module.exports, "rank", () => $34028dbfe4fa36f7$export$fbc8bcd33b574fbc, (v) => $34028dbfe4fa36f7$export$fbc8bcd33b574fbc = v);
$parcel$export(module.exports, "ranked-gutter", () => $34028dbfe4fa36f7$export$d93565a96911fbba, (v) => $34028dbfe4fa36f7$export$d93565a96911fbba = v);
$parcel$export(module.exports, "select-checkbox", () => $34028dbfe4fa36f7$export$866f1d976e6380d8, (v) => $34028dbfe4fa36f7$export$866f1d976e6380d8 = v);
$parcel$export(module.exports, "summary", () => $34028dbfe4fa36f7$export$9a2dbef7a17e2e58, (v) => $34028dbfe4fa36f7$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "summaryBtn", () => $34028dbfe4fa36f7$export$d323a95d9c47e84b, (v) => $34028dbfe4fa36f7$export$d323a95d9c47e84b = v);
$parcel$export(module.exports, "summaryReadView", () => $34028dbfe4fa36f7$export$10ac4ca9f19e16f5, (v) => $34028dbfe4fa36f7$export$10ac4ca9f19e16f5 = v);
$parcel$export(module.exports, "toggle", () => $34028dbfe4fa36f7$export$e03c1c3201ee8bb7, (v) => $34028dbfe4fa36f7$export$e03c1c3201ee8bb7 = v);
var $34028dbfe4fa36f7$export$3488242433cbedb;
var $34028dbfe4fa36f7$export$34e0f9847d4c02dd;
var $34028dbfe4fa36f7$export$863710ae9975cbf6;
var $34028dbfe4fa36f7$export$a5b94313d6908893;
var $34028dbfe4fa36f7$export$df5fefc55a4eba3c;
var $34028dbfe4fa36f7$export$df20a5f04e27573e;
var $34028dbfe4fa36f7$export$c6ee8e29facfa055;
var $34028dbfe4fa36f7$export$843e51c921ce4d8d;
var $34028dbfe4fa36f7$export$1ca1ec8b29a4ce27;
var $34028dbfe4fa36f7$export$9e9bc3c487fccc00;
var $34028dbfe4fa36f7$export$e4d153b3e021fb47;
var $34028dbfe4fa36f7$export$39bed5d6a23c78de;
var $34028dbfe4fa36f7$export$655a12e775c013c3;
var $34028dbfe4fa36f7$export$96298c959d38f53e;
var $34028dbfe4fa36f7$export$214f72c33ec0736b;
var $34028dbfe4fa36f7$export$9c30223ca0a664fb;
var $34028dbfe4fa36f7$export$74b48c691cc42eb1;
var $34028dbfe4fa36f7$export$f1f85ff3be680a56;
var $34028dbfe4fa36f7$export$97878a1315ed5db7;
var $34028dbfe4fa36f7$export$fbc8bcd33b574fbc;
var $34028dbfe4fa36f7$export$d93565a96911fbba;
var $34028dbfe4fa36f7$export$866f1d976e6380d8;
var $34028dbfe4fa36f7$export$9a2dbef7a17e2e58;
var $34028dbfe4fa36f7$export$d323a95d9c47e84b;
var $34028dbfe4fa36f7$export$10ac4ca9f19e16f5;
var $34028dbfe4fa36f7$export$e03c1c3201ee8bb7;
var $34028dbfe4fa36f7$export$cce7aaa89215f32b;
var $34028dbfe4fa36f7$export$8db6fdef835e2b1b;
$34028dbfe4fa36f7$export$3488242433cbedb = `ra40ka_addIcon`;
$34028dbfe4fa36f7$export$34e0f9847d4c02dd = `ra40ka_container`;
$34028dbfe4fa36f7$export$863710ae9975cbf6 = `ra40ka_drop-parent`;
$34028dbfe4fa36f7$export$a5b94313d6908893 = `ra40ka_ellipsis`;
$34028dbfe4fa36f7$export$df5fefc55a4eba3c = `ra40ka_even`;
$34028dbfe4fa36f7$export$df20a5f04e27573e = `ra40ka_evenOptimized`;
$34028dbfe4fa36f7$export$c6ee8e29facfa055 = `ra40ka_flyoutPositioner`;
$34028dbfe4fa36f7$export$843e51c921ce4d8d = `ra40ka_group-indentation`;
$34028dbfe4fa36f7$export$1ca1ec8b29a4ce27 = `ra40ka_icon`;
$34028dbfe4fa36f7$export$9e9bc3c487fccc00 = `ra40ka_isDragging`;
$34028dbfe4fa36f7$export$e4d153b3e021fb47 = `ra40ka_isSelected`;
$34028dbfe4fa36f7$export$39bed5d6a23c78de = `ra40ka_issue-icon`;
$34028dbfe4fa36f7$export$655a12e775c013c3 = `ra40ka_issue-icon-old`;
$34028dbfe4fa36f7$export$96298c959d38f53e = `ra40ka_issueIconTooltipWrapper`;
$34028dbfe4fa36f7$export$214f72c33ec0736b = `ra40ka_light-summary`;
$34028dbfe4fa36f7$export$9c30223ca0a664fb = `ra40ka_link`;
$34028dbfe4fa36f7$export$74b48c691cc42eb1 = `ra40ka_odd`;
$34028dbfe4fa36f7$export$f1f85ff3be680a56 = `ra40ka_oddOptimized`;
$34028dbfe4fa36f7$export$97878a1315ed5db7 = `ra40ka_parent-match`;
$34028dbfe4fa36f7$export$fbc8bcd33b574fbc = `ra40ka_rank`;
$34028dbfe4fa36f7$export$d93565a96911fbba = `ra40ka_ranked-gutter`;
$34028dbfe4fa36f7$export$866f1d976e6380d8 = `ra40ka_select-checkbox`;
$34028dbfe4fa36f7$export$9a2dbef7a17e2e58 = `ra40ka_summary`;
$34028dbfe4fa36f7$export$d323a95d9c47e84b = `ra40ka_summaryBtn`;
$34028dbfe4fa36f7$export$10ac4ca9f19e16f5 = `ra40ka_summaryReadView`;
$34028dbfe4fa36f7$export$e03c1c3201ee8bb7 = `ra40ka_toggle`;
$34028dbfe4fa36f7$export$cce7aaa89215f32b = `ra40ka_warnings`;
$34028dbfe4fa36f7$export$8db6fdef835e2b1b = `ra40ka_warningsOptimized`;

});



parcelRegister("djawK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c904521215784f$export$2e2bcd8739ae039);

var $kUd55 = parcelRequire("kUd55");
var $b4c904521215784f$export$2e2bcd8739ae039 = (0, $kUd55.default);

});
parcelRegister("kUd55", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c3dd401bf63f7f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $2BQwE = parcelRequire("2BQwE");

var $1QVWH = parcelRequire("1QVWH");

var $duQ8C = parcelRequire("duQ8C");

var $g58E2 = parcelRequire("g58E2");

var $dzZKF = parcelRequire("dzZKF");

var $jnSfn = parcelRequire("jnSfn");
function $d3c3dd401bf63f7f$var$IssuesWithoutParent({ id: id, isExpanded: isExpanded = false, level: { title: title }, onToggle: onToggle, rankDigits: rankDigits, rootIssuesCount: rootIssuesCount, outerRef: outerRef }) {
    const handleOnToggle = (event)=>{
        if (isExpanded !== null) {
            if (isExpanded) (0, $duQ8C.default)((0, $2BQwE.KEYS).COLLAPSE_ISSUE_WITHOUT_PARENT, event.timeStamp);
            else (0, $duQ8C.default)((0, $2BQwE.KEYS).EXPAND_ISSUE_WITHOUT_PARENT, event.timeStamp);
            (0, $1QVWH.addUFOCustomData)({
                scalingFactors: {
                    rootIssuesCount: rootIssuesCount
                }
            });
        }
        onToggle({
            [id]: !isExpanded
        });
    };
    const getContentIcon = ()=>{
        if (rootIssuesCount > 0) return isExpanded === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ""
        });
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $jnSfn.icon
        });
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: outerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? $jnSfn.container : $jnSfn.containerOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jnSfn.rank,
        style: {
            width: 10 * rankDigits,
            minWidth: 10 * rankDigits
        }
    }), getContentIcon(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jnSfn.summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $dzZKF.default).level,
        values: {
            levelTitle: title,
            issuesCount: rootIssuesCount
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g58E2.default), {
        onClick: handleOnToggle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $jnSfn.toggleButton,
        "data-name": "toggleIssueWithoutParent",
        ariaExpanded: isExpanded
    }, content);
}
var $d3c3dd401bf63f7f$export$2e2bcd8739ae039 = $d3c3dd401bf63f7f$var$IssuesWithoutParent;

});
parcelRegister("g58E2", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a3de282e733ede$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aAyrO = parcelRequire("aAyrO");

var $43zOv = parcelRequire("43zOv");
function $52a3de282e733ede$export$2e2bcd8739ae039({ className: className, style: style, ariaExpanded: ariaExpanded, ...restProps }) {
    const styleObject = style ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${className ?? ''} ${$43zOv.cellButton}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textAlign: 'left',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: 'calc(100% - 4px)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...styleObject
        },
        "aria-expanded": ariaExpanded,
        ...restProps
    });
}

});
parcelRegister("43zOv", function(module, exports) {

$parcel$export(module.exports, "cellButton", () => $2f4339155a6af5b2$export$dd94d7ecfe010714, (v) => $2f4339155a6af5b2$export$dd94d7ecfe010714 = v);
var $2f4339155a6af5b2$export$dd94d7ecfe010714;
$2f4339155a6af5b2$export$dd94d7ecfe010714 = `Wh34OW_cellButton`;

});


parcelRegister("dzZKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b0a57461047168$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f7b0a57461047168$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    level: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issues-without-parent.level",
        "defaultMessage": "{levelTitle} \u2013 {issuesCount, plural, one {# issue} other {# issues}}"
    }
});

});

parcelRegister("jnSfn", function(module, exports) {

$parcel$export(module.exports, "container", () => $e1ca3e9adceea838$export$34e0f9847d4c02dd, (v) => $e1ca3e9adceea838$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "containerOld", () => $e1ca3e9adceea838$export$4e6d0512d9a636b9, (v) => $e1ca3e9adceea838$export$4e6d0512d9a636b9 = v);
$parcel$export(module.exports, "icon", () => $e1ca3e9adceea838$export$1ca1ec8b29a4ce27, (v) => $e1ca3e9adceea838$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "rank", () => $e1ca3e9adceea838$export$fbc8bcd33b574fbc, (v) => $e1ca3e9adceea838$export$fbc8bcd33b574fbc = v);
$parcel$export(module.exports, "summary", () => $e1ca3e9adceea838$export$9a2dbef7a17e2e58, (v) => $e1ca3e9adceea838$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "toggleButton", () => $e1ca3e9adceea838$export$c3f9788a1ddcf2d9, (v) => $e1ca3e9adceea838$export$c3f9788a1ddcf2d9 = v);
var $e1ca3e9adceea838$export$34e0f9847d4c02dd;
var $e1ca3e9adceea838$export$4e6d0512d9a636b9;
var $e1ca3e9adceea838$export$1ca1ec8b29a4ce27;
var $e1ca3e9adceea838$export$fbc8bcd33b574fbc;
var $e1ca3e9adceea838$export$9a2dbef7a17e2e58;
var $e1ca3e9adceea838$export$c3f9788a1ddcf2d9;
$e1ca3e9adceea838$export$34e0f9847d4c02dd = `iawNsq_container`;
$e1ca3e9adceea838$export$4e6d0512d9a636b9 = `iawNsq_containerOld`;
$e1ca3e9adceea838$export$1ca1ec8b29a4ce27 = `iawNsq_icon`;
$e1ca3e9adceea838$export$fbc8bcd33b574fbc = `iawNsq_rank`;
$e1ca3e9adceea838$export$9a2dbef7a17e2e58 = `iawNsq_summary`;
$e1ca3e9adceea838$export$c3f9788a1ddcf2d9 = `iawNsq_toggleButton`;

});



parcelRegister("hfAst", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc59b6b1d557961$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $8uD7Y = parcelRequire("8uD7Y");

var $g58E2 = parcelRequire("g58E2");

var $5mG1E = parcelRequire("5mG1E");

var $fSFd7 = parcelRequire("fSFd7");
// Remove with the cleanup of com.atlassian.rm.jpo.ease-of-use.remove-no-parent-header
function $9cc59b6b1d557961$var$IssuesWithoutParentHeader({ id: id, isExpanded: isExpanded = false, issuesCount: issuesCount, onToggle: onToggle }) {
    const handleToggle = ()=>{
        onToggle({
            [id]: !isExpanded
        });
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        "data-role": "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fSFd7.issuesWithoutParentText
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $5mG1E.default).issuesWithoutParent,
        values: {
            issuesCount: issuesCount
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g58E2.default), {
        onClick: handleToggle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $fSFd7.toggleButton,
        "data-name": "toggleIssuesWithoutParentHeader",
        ariaExpanded: isExpanded
    }, content);
}
var $9cc59b6b1d557961$export$2e2bcd8739ae039 = $9cc59b6b1d557961$var$IssuesWithoutParentHeader;

});
parcelRegister("5mG1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $78f1713a4a27b9d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $78f1713a4a27b9d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuesWithoutParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issues-without-parent-header.issues-without-parent",
        "defaultMessage": "{issuesCount, plural, one {# issue} other {# issues}} without parent"
    }
});

});

parcelRegister("fSFd7", function(module, exports) {

$parcel$export(module.exports, "issuesWithoutParentText", () => $b8fbddb6bb876098$export$2ebe39de57ad3ebf, (v) => $b8fbddb6bb876098$export$2ebe39de57ad3ebf = v);
$parcel$export(module.exports, "toggleButton", () => $b8fbddb6bb876098$export$c3f9788a1ddcf2d9, (v) => $b8fbddb6bb876098$export$c3f9788a1ddcf2d9 = v);
var $b8fbddb6bb876098$export$b18e054cadb4b0e3;
var $b8fbddb6bb876098$export$2ebe39de57ad3ebf;
var $b8fbddb6bb876098$export$c3f9788a1ddcf2d9;
$b8fbddb6bb876098$export$b18e054cadb4b0e3 = `rIGP-q_issuesWithoutParentHeader`;
$b8fbddb6bb876098$export$2ebe39de57ad3ebf = `rIGP-q_issuesWithoutParentText`;
$b8fbddb6bb876098$export$c3f9788a1ddcf2d9 = `rIGP-q_toggleButton`;

});


parcelRegister("2aD9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a160eacd6ca86ee$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fGYfY = parcelRequire("fGYfY");

var $2I1Mo = parcelRequire("2I1Mo");
var $1a160eacd6ca86ee$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fGYfY.default), {})((0, $2I1Mo.default));

});
parcelRegister("fGYfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7192f3da4393655$export$2e2bcd8739ae039);

var $evo53 = parcelRequire("evo53");

var $a0bo1 = parcelRequire("a0bo1");

var $iK4oF = parcelRequire("iK4oF");
var $e7192f3da4393655$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    scope: (0, $a0bo1.getTableItems),
    stickyHeader: (0, $evo53.getCurrentStickyHeaderGeometry)
});

});

parcelRegister("2I1Mo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60567ebb3c8b5cb7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7CnHa = parcelRequire("7CnHa");

var $1QCBK = parcelRequire("1QCBK");
function $60567ebb3c8b5cb7$export$2e2bcd8739ae039({ scope: scope, stickyHeader: stickyHeader }) {
    if (!(0, $7CnHa.isDefined)(stickyHeader)) return null;
    const item = scope[stickyHeader.index];
    if (!(0, $7CnHa.isDefined)(item)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QCBK.default), {
        item: item,
        isStickyGroupHeader: true
    });
}

});
parcelRegister("1QCBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dda4afd17a129368$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lgxoa = parcelRequire("lgxoa");

var $6mhtw = parcelRequire("6mhtw");

var $3FSfu = parcelRequire("3FSfu");
var $dda4afd17a129368$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6mhtw.default), (0, $lgxoa.default))((0, $3FSfu.default));

});
parcelRegister("lgxoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $70c27c40c962c639$export$2e2bcd8739ae039);
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$70c27c40c962c639$export$2e2bcd8739ae039 = (dispatch)=>({
        toggleExpandGroup: (payload)=>dispatch((0, $l1dWb.toggleExpandGroup)(payload))
    });

});

parcelRegister("6mhtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $66d3559a1a3437bf$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $lvJU2 = parcelRequire("lvJU2");

var $2Ruxt = parcelRequire("2Ruxt");

var $kKj1m = parcelRequire("kKj1m");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $66d3559a1a3437bf$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    additionalTeamsById: (0, $MQRDu.getAdditionalTeamsById),
    allTeams: (0, $MQRDu.getAllTeams),
    componentGroupsById: (0, $9H2AP.getComponentGroupsById),
    componentsById: (0, $lvJU2.getComponentsById),
    crossProjectVersionsById: (0, $2Ruxt.getCrossProjectVersionsById),
    customFieldsById: (0, $kKj1m.getCustomFieldsById),
    enrichedVersionsById: (0, $wcCGG.getEnrichedVersionsById),
    isExportMode: $akhOi.isExportMode,
    projectsById: (0, $ehEr2.getProjectsById),
    sprints: (0, $c1XMU.getSprints),
    useTwpTeams: (state)=>!!(0, $75KhQ.getPlan)(state).useTwpTeams,
    viewMode: (0, $9H2AP.getViewMode)
});

});

parcelRegister("3FSfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ec7a622bbf94a53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eirae = parcelRequire("eirae");
var $kDrtX = parcelRequire("kDrtX");
var $kjklK = parcelRequire("kjklK");

var $hXJR4 = parcelRequire("hXJR4");

var $iJlfe = parcelRequire("iJlfe");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $e5T2d = parcelRequire("e5T2d");

var $4nce6 = parcelRequire("4nce6");

var $14lY4 = parcelRequire("14lY4");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1EzTb = parcelRequire("1EzTb");
var $l79aB = parcelRequire("l79aB");

var $lGIBI = parcelRequire("lGIBI");

var $qmwZb = parcelRequire("qmwZb");
var $ffiyv = parcelRequire("ffiyv");
var $gwbfD = parcelRequire("gwbfD");
var $lcvrv = parcelRequire("lcvrv");

var $dlZBr = parcelRequire("dlZBr");

var $cc2RB = parcelRequire("cc2RB");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $40hi6 = parcelRequire("40hi6");

var $a0bo1 = parcelRequire("a0bo1");
parcelRequire("2Bjja");
var $4JE8j = parcelRequire("4JE8j");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $ib5d3 = parcelRequire("ib5d3");

var $8QizU = parcelRequire("8QizU");

var $ePu25 = parcelRequire("ePu25");

var $5vmgy = parcelRequire("5vmgy");
const $5ec7a622bbf94a53$var$groupIcons = {
    [(0, $5rYNM.GROUPING).ASSIGNEE]: undefined,
    [(0, $5rYNM.GROUPING).REPORTER]: undefined,
    [(0, $5rYNM.GROUPING).COMPONENT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        key: "component",
        label: "Folder icon"
    }),
    [(0, $5rYNM.GROUPING).LABEL]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        key: "label",
        label: "Folder icon"
    }),
    [(0, $5rYNM.GROUPING).NONE]: undefined,
    [(0, $5rYNM.GROUPING).PROJECT]: undefined,
    [(0, $5rYNM.GROUPING).RELEASE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
        key: "release",
        label: "Ship icon"
    }),
    [(0, $5rYNM.GROUPING).SPRINT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4JE8j.default), {
        key: "sprint",
        label: "Sprint icon"
    }),
    [(0, $5rYNM.GROUPING).TEAM]: undefined,
    // Goals handled separately as it requires state
    [(0, $5rYNM.GROUPING).GOALS]: undefined,
    // Ideas handled separately as it requires state
    [(0, $5rYNM.GROUPING).IDEAS]: undefined
};
// delete this object when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
const $5ec7a622bbf94a53$var$groupIconsOld = {
    [(0, $5rYNM.GROUPING).COMPONENT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        key: "component",
        label: "Folder icon"
    }),
    [(0, $5rYNM.GROUPING).LABEL]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        key: "label",
        label: "Folder icon"
    }),
    [(0, $5rYNM.GROUPING).TEAM]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        key: "team",
        label: "People icon"
    }),
    [(0, $5rYNM.GROUPING).SPRINT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4JE8j.default), {
        key: "sprint",
        label: "Sprint icon"
    }),
    [(0, $5rYNM.GROUPING).RELEASE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
        key: "release",
        label: "Ship icon"
    }),
    [(0, $5rYNM.GROUPING).ASSIGNEE]: undefined,
    [(0, $5rYNM.GROUPING).REPORTER]: undefined,
    [(0, $5rYNM.GROUPING).NONE]: undefined,
    [(0, $5rYNM.GROUPING).PROJECT]: undefined,
    [(0, $5rYNM.GROUPING).GOALS]: undefined,
    [(0, $5rYNM.GROUPING).IDEAS]: undefined
};
const $5ec7a622bbf94a53$var$UNASSIGNED_GOALS_GROUP = 'goals-UNDEFINED';
const $5ec7a622bbf94a53$var$UNASSIGNED_IDEAS_GROUP = 'ideas-UNDEFINED';
const $5ec7a622bbf94a53$export$97eeb400c5f33310 = ({ grouping: grouping, isExportMode: isExportMode, url: url = '', hasChildGroups: hasChildGroups = false, groupName: groupName, customFieldsById: customFieldsById, useTwpTeams: useTwpTeams = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (hasChildGroups) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        label: formatMessage((0, $ePu25.default).folderIconLabel)
    });
    // delete "isMigrateArjTeamsToPlatformTeamsEnabled() && useTwpTeams" from the condition when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    if ((0, $430Oj.default)() && useTwpTeams && grouping === (0, $5rYNM.GROUPING).TEAM) {
        // team avatars are not supported in export mode so we render an AK icon instead
        if (url && !isExportMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "small",
            src: url
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5vmgy.defaultTeamAvatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            label: formatMessage((0, $ePu25.default).peopleIconLabel),
            size: "small"
        })));
    }
    if ((0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) {
        const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        if ((0, $7CnHa.isDefined)(customFieldsById) && (0, $7CnHa.isDefined)(customFieldsById[fieldId]) && customFieldsById[fieldId].type.key === (0, $5rYNM.CustomFieldTypes).UserPicker) {
            if (isExportMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qmwZb.default), {
                size: 24,
                name: groupName
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: url
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
            key: grouping,
            label: formatMessage((0, $ePu25.default).folderIconLabel)
        });
    }
    // delete this condition and keep the truthy case when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    if ((0, $430Oj.default)() && useTwpTeams) {
        if (typeof $5ec7a622bbf94a53$var$groupIcons[grouping] !== 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $5ec7a622bbf94a53$var$groupIcons[grouping]);
    } else if (typeof $5ec7a622bbf94a53$var$groupIconsOld[grouping] !== 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $5ec7a622bbf94a53$var$groupIconsOld[grouping]);
    if (isExportMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qmwZb.default), {
        size: 24,
        name: groupName
    });
    // Always display Avatar if group by "Assignee" or group by "Project" and url is not null,undefined,empty string
    if (grouping === (0, $5rYNM.GROUPING).ASSIGNEE || !!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: url
    });
    return null;
};
const $5ec7a622bbf94a53$var$getTeamName = (id, allTeams)=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const team = allTeams.find((team)=>team.id === id);
    return team ? team.title : null;
};
const $5ec7a622bbf94a53$var$getGroupName = ({ item: item, allTeams: allTeams, sprints: sprints, formatMessage: formatMessage })=>{
    if (item.tag !== (0, $a0bo1.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
    let { value: groupName } = item;
    const { grouping: grouping, group: group, childGroups: childGroups } = item;
    if (group === (0, $40hi6.UNDEFINED_GROUP)) groupName = formatMessage((0, $ib5d3.default).unassigned);
    else if (!groupName) switch(grouping){
        case (0, $5rYNM.GROUPING).COMPONENT:
            groupName = formatMessage((0, $ib5d3.default).allOtherIssues);
            break;
        case (0, $5rYNM.GROUPING).LABEL:
            groupName = formatMessage((0, $ib5d3.default).allOtherIssues);
            break;
        case (0, $5rYNM.GROUPING).GOALS:
            groupName = formatMessage((0, $ib5d3.default).allOtherIssues);
            break;
        case (0, $5rYNM.GROUPING).IDEAS:
            groupName = formatMessage((0, $ib5d3.default).allOtherIssues);
            break;
        case (0, $5rYNM.GROUPING).TEAM:
            groupName = $kDrtX.default(item.groupCombination.team) ? formatMessage((0, $ePu25.default).unknownTeam) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $5ec7a622bbf94a53$var$getTeamName(item.groupCombination.team, allTeams);
            break;
        case (0, $5rYNM.GROUPING).RELEASE:
            if (item.groupCombination.release === (0, $5rYNM.COMPLETED_RELEASES_GROUP)) groupName = formatMessage((0, $ePu25.default).completedReleasesGroup, {
                count: childGroups ? childGroups.length : ''
            });
            break;
        case (0, $5rYNM.GROUPING).PROJECT:
            groupName = formatMessage((0, $ib5d3.default).unassigned);
            break;
        case (0, $ayXoc.isRoadmapGroupedByCustomField)(grouping) && grouping:
            groupName = formatMessage((0, $ib5d3.default).allOtherIssues);
            break;
        default:
            groupName = formatMessage((0, $ib5d3.default).unassigned);
            break;
    }
    if (grouping === (0, $5rYNM.GROUPING).SPRINT) {
        if (item.groupCombination.sprint === (0, $5rYNM.COMPLETED_SPRINTS_GROUP)) groupName = formatMessage((0, $ePu25.default).completedSprintsGroup, {
            count: childGroups ? Object.keys($eirae.default(// eslint-disable-next-line @typescript-eslint/no-shadow
            (group)=>group.groupCombination && group.groupCombination.sprint || '', childGroups)).length : ''
        });
        else {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const sprint = sprints.find((sprint)=>{
                const sprintId = $kjklK.default([
                    'groupCombination',
                    'sprint'
                ], item);
                return sprint.id === sprintId;
            });
            groupName = sprint && sprint.title ? sprint.title : formatMessage((0, $ib5d3.default).unassigned);
        }
    }
    return groupName;
};
const $5ec7a622bbf94a53$var$getSecondaryGroupName = (item, enrichedVersionsById, allTeams)=>{
    if (item.tag !== (0, $a0bo1.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
    let secondaryGroupName;
    const { grouping: grouping } = item;
    if (grouping === (0, $5rYNM.GROUPING).RELEASE) {
        const versionId = $kjklK.default([
            'groupCombination',
            'release'
        ], item);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const release = versionId && enrichedVersionsById[versionId];
        secondaryGroupName = release && (release.projects.filter(Boolean).map((project)=>typeof project !== 'number' ? project.name : null).join(', ') || null);
    }
    if (grouping === (0, $5rYNM.GROUPING).SPRINT && item.groupCombination.sprint !== (0, $5rYNM.COMPLETED_SPRINTS_GROUP)) secondaryGroupName = $5ec7a622bbf94a53$var$getTeamName(item.groupCombination.team, allTeams);
    return secondaryGroupName;
};
const $5ec7a622bbf94a53$var$getLozengeTextForGroupByRelease = (item, enrichedVersionsById, crossProjectVersionsById)=>{
    const versionId = $kjklK.default([
        'groupCombination',
        'release'
    ], item);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const release = versionId && enrichedVersionsById[versionId];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return release && $kjklK.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
        release.crossProjectVersion,
        'name'
    ], crossProjectVersionsById);
};
const $5ec7a622bbf94a53$export$1929c04eb57bfb36 = ({ id: id })=>{
    const [associatedIssues] = (0, $l79aB.useAssociatedIssues)();
    if (!associatedIssues || !associatedIssues[id]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EzTb.AssociatedIssuesView), {
        associatedIssues: [
            associatedIssues[id]
        ]
    });
};
function $5ec7a622bbf94a53$var$GroupHeaderComponent({ item: item, toggleExpandGroup: toggleExpandGroup, allTeams: allTeams, additionalTeamsById: additionalTeamsById, isExportMode: isExportMode, componentGroupsById: componentGroupsById, componentsById: componentsById, projectsById: projectsById, enrichedVersionsById: enrichedVersionsById, crossProjectVersionsById: crossProjectVersionsById, groupName: groupName, customFieldsById: customFieldsById, lazyGoalsByARI: lazyGoalsByARI, associatedIssues: associatedIssues, useTwpTeams: useTwpTeams = false, viewMode: viewMode }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (item.tag !== (0, $a0bo1.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
    const secondaryGroupName = $5ec7a622bbf94a53$var$getSecondaryGroupName(item, enrichedVersionsById, allTeams);
    const lozengeText = $5ec7a622bbf94a53$var$getLozengeTextForGroupByRelease(item, enrichedVersionsById, crossProjectVersionsById);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let componentNames = [];
    const { grouping: grouping, parentGroup: parentGroup, childGroups: childGroups } = item;
    if (grouping === (0, $5rYNM.GROUPING).COMPONENT) {
        const componentGroup = componentGroupsById[item.groupCombination.components || ''];
        const { components: components = [] } = componentGroup;
        componentNames = components.map((componentId)=>componentsById[componentId]).filter((component)=>(0, $7CnHa.isDefined)(component)).map(({ name: name, projectId: projectId })=>`${name} (${projectsById[projectId].key})`);
    }
    const isExternalTeam = (0, $7CnHa.isDefined)(item.groupCombination.team) && (0, $7CnHa.isDefined)(additionalTeamsById[item.groupCombination.team]);
    const toggle = ()=>toggleExpandGroup({
            grouping: item.grouping,
            groupName: item.group,
            expand: !item.isExpanded
        });
    const onKeyDownHandler = (e)=>{
        if (e.keyCode === 13 || e.keyCode === 32) toggle();
    };
    const renderTooltipForExternalTeam = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $5vmgy['tooltip-wrapper']
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
                className: $5vmgy['tooltip-title']
            }, formatMessage((0, $cc2RB.default).externalTeamTooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $cc2RB.default).externalTeamTooltipContent)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: isExportMode ? $5vmgy.exportPNGLozenge : $5vmgy['external-lozenge-wrapper']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $cc2RB.default).externalLozenge))));
    const isShareableTeamFromGroupItem = ()=>{
        if ((0, $7CnHa.isDefined)(item.groupCombination.team)) {
            const teamId = item.groupCombination.team;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const team = allTeams.find((team)=>team.id === teamId);
            return team ? team.shareable : false;
        }
        return false;
    };
    const renderTooltipForPlanOnlyTeam = ()=>{
        const isShareableTeam = isShareableTeamFromGroupItem();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { grouping: grouping, value: value } = item;
        if (grouping !== (0, $5rYNM.GROUPING).TEAM || value === '') return null;
        if (isExternalTeam || isShareableTeam) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $5vmgy['tooltip-wrapper']
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
                className: $5vmgy['tooltip-title']
            }, formatMessage((0, $cc2RB.default).planOnlyTeamTooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $cc2RB.default).planOnlyTeamTooltipContent)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: isExportMode ? $5vmgy.exportPNGLozenge : $5vmgy['external-lozenge-wrapper']
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $cc2RB.default).planOnlyLozenge))));
    };
    const hasParentGroup = !!parentGroup;
    const hasChildGroups = !!childGroups;
    const renderGroupName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, groupName || ''), (0, $7CnHa.isDefined)(secondaryGroupName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", null, " (", secondaryGroupName, ")"));
    const renderGroupNameContent = ()=>{
        const { group: group } = item;
        if (grouping === (0, $5rYNM.GROUPING).GOALS && group !== $5ec7a622bbf94a53$var$UNASSIGNED_GOALS_GROUP) {
            const { isLoading: isLoading, goal: goal } = lazyGoalsByARI[groupName] || {};
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dlZBr.CellSkeleton), {
                width: (0, $5rYNM.DEFAULT_FIELD_WIDTH).MEDIUM
            });
            if (goal) {
                const { name: name, state: state } = goal;
                if (name && state) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QizU.Goal), {
                    name: name,
                    state: state,
                    isExportMode: isExportMode
                });
            }
            return null;
        }
        if (grouping === (0, $5rYNM.GROUPING).IDEAS && group !== $5ec7a622bbf94a53$var$UNASSIGNED_IDEAS_GROUP) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ec7a622bbf94a53$export$1929c04eb57bfb36, {
            id: groupName
        });
        return renderGroupName();
    };
    const getTooltipContent = ()=>{
        if (grouping === (0, $5rYNM.GROUPING).GOALS) return lazyGoalsByARI[groupName]?.goal?.name || groupName;
        if (grouping === (0, $5rYNM.GROUPING).IDEAS && associatedIssues) return associatedIssues[groupName]?.summary || groupName;
        return groupName;
    };
    const isTransposed = (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') && (viewMode === (0, $lcvrv.VIEW_MODES).LIST || (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2'));
    const className = isTransposed ? 'group-details-transposed' : 'group-details';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $5vmgy[className],
        role: "button",
        tabIndex: 0,
        onClick: toggle,
        onKeyDown: onKeyDownHandler,
        "data-role": "header",
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.group-header",
        "aria-expanded": item.isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: `${$5vmgy['group-chevron']} ${hasParentGroup ? $5vmgy.hasParentGroup : ''}`
    }, item.isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "",
        size: "large"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: "",
        size: "large"
    })), grouping !== (0, $5rYNM.GROUPING).GOALS && grouping !== (0, $5rYNM.GROUPING).IDEAS && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $5vmgy.groupingAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ec7a622bbf94a53$export$97eeb400c5f33310, {
        customFieldsById: customFieldsById,
        grouping: item.grouping,
        url: item.url,
        isExportMode: isExportMode,
        hasChildGroups: hasChildGroups,
        groupName: groupName || '',
        useTwpTeams: useTwpTeams
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5vmgy['group-title']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        position: "mouse",
        content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5vmgy.tooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h6", null, getTooltipContent() || ''), componentNames.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, componentNames.join(', ')), (0, $7CnHa.isDefined)(secondaryGroupName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "(", secondaryGroupName, ")"))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `group-name ${$5vmgy.groupName}`,
        id: `group-name-${item.group.replace(/\s/g, '')}`
    }, renderGroupNameContent()))), isExternalTeam ? renderTooltipForExternalTeam() : null, renderTooltipForPlanOnlyTeam(), lozengeText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: isExportMode ? $5vmgy.exportPNGLozenge : $5vmgy['external-lozenge-wrapper']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, lozengeText)));
}
const $5ec7a622bbf94a53$var$SortableGroupHeaderComponent = (0, $hXJR4.SortableElement)($5ec7a622bbf94a53$var$GroupHeaderComponent);
const $5ec7a622bbf94a53$var$Group = ({ item: item, allTeams: allTeams, sprints: sprints, isStickyGroupHeader: isStickyGroupHeader = false, style: style, key: key = '', index: index, ...props })=>{
    const { group: group } = item;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (item.tag !== (0, $a0bo1.TABLE_GROUP)) throw new Error(`renderGroup must be called only for TABLE_GROUP item, but ${item.tag} was provided.`);
    const [{ lazyGoalsByARI: lazyGoalsByARI }] = (0, $lGIBI.useLazyGoals)();
    const [associatedIssues] = (0, $l79aB.useAssociatedIssues)();
    const groupName = $5ec7a622bbf94a53$var$getGroupName({
        item: item,
        allTeams: allTeams,
        sprints: sprints,
        formatMessage: formatMessage
    }) ?? '';
    const elementKey = `${item.tag}-${group || ''}-${groupName || key || ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: elementKey,
        ...style && {
            style: style
        },
        className: $5vmgy.groupRow
    }, isStickyGroupHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ec7a622bbf94a53$var$GroupHeaderComponent, {
        item: item,
        groupName: groupName,
        allTeams: allTeams,
        lazyGoalsByARI: lazyGoalsByARI,
        associatedIssues: associatedIssues,
        ...props
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ec7a622bbf94a53$var$SortableGroupHeaderComponent, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        index: index,
        item: item,
        groupName: groupName,
        allTeams: allTeams,
        lazyGoalsByARI: lazyGoalsByARI,
        associatedIssues: associatedIssues,
        ...props
    })));
};
var $5ec7a622bbf94a53$export$2e2bcd8739ae039 = $5ec7a622bbf94a53$var$Group;

});
parcelRegister("1EzTb", function(module, exports) {

$parcel$export(module.exports, "AssociatedIssuesView", () => $d1a8348af9623e11$export$93fe1358fa69465a);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $d1a8348af9623e11$var$Issue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d1a8348af9623e11$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d1a8348af9623e11$var$avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: props.data.iconUrl,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $d1a8348af9623e11$var$summary
    }, props.data.summary));
const $d1a8348af9623e11$export$93fe1358fa69465a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, props.associatedIssues.map((associatedIssue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1a8348af9623e11$var$Issue, {
            key: associatedIssue.key,
            data: associatedIssue
        })));
const $d1a8348af9623e11$var$container = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInlineEnd: 'space.100',
    height: '100%'
});
const $d1a8348af9623e11$var$avatar = (0, $1ZAYh.xcss)({
    paddingInlineEnd: 'space.050',
    flexShrink: 0
});
const $d1a8348af9623e11$var$summary = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexBasis: 'content',
    flexShrink: 1
});

});

parcelRegister("qmwZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c009174062b5b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLy9V = parcelRequire("lLy9V");
function $22c009174062b5b6$export$2e2bcd8739ae039({ name: name, size: size = 24 }) {
    if (!name) return null;
    const names = name.split(' ');
    if (names.length === 0) return null;
    const displayText = `${names[0][0]}${names.length > 1 ? names[names.length - 1][0] : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lLy9V.wrapper,
        style: {
            width: size,
            height: size
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lLy9V.initials,
        style: {
            fontSize: size * 0.525
        }
    }, displayText)));
}

});
parcelRegister("lLy9V", function(module, exports) {

$parcel$export(module.exports, "initials", () => $fd887c0cdfdf6023$export$82a129a7016c8ea8, (v) => $fd887c0cdfdf6023$export$82a129a7016c8ea8 = v);
$parcel$export(module.exports, "wrapper", () => $fd887c0cdfdf6023$export$cc74dcc53cfce4eb, (v) => $fd887c0cdfdf6023$export$cc74dcc53cfce4eb = v);
var $fd887c0cdfdf6023$export$82a129a7016c8ea8;
var $fd887c0cdfdf6023$export$cc74dcc53cfce4eb;
$fd887c0cdfdf6023$export$82a129a7016c8ea8 = `wnXJHq_initials`;
$fd887c0cdfdf6023$export$cc74dcc53cfce4eb = `wnXJHq_wrapper`;

});


parcelRegister("ePu25", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c4a0c1c72459e7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49c4a0c1c72459e7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalTeamLozenge: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-lozenge",
        "defaultMessage": "EXTERNAL"
    },
    externalTeamTooltipTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-tooltip-title",
        "defaultMessage": "Team currently not in this plan"
    },
    externalTeamTooltipContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.external-team-tooltip-content",
        "defaultMessage": "While this team isn't in this plan, it's appearing because it's assigned to issues in the plan."
    },
    unknownTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.unknown-team",
        "defaultMessage": "Unknown team (not included in plan)"
    },
    completedSprintsGroup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.completed-sprints-group",
        "defaultMessage": "{count} completed {count, plural, one {sprint} other {sprints}}"
    },
    completedReleasesGroup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.completed-releases-group",
        "defaultMessage": "{count} completed {count, plural, one {release} other {releases}}"
    },
    folderIconLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.folder-icon-label",
        "defaultMessage": "Folder icon"
    },
    peopleIconLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.people-icon-label",
        "defaultMessage": "People icon"
    },
    avatarLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.group.avatar-label",
        "defaultMessage": "Team avatar"
    }
});

});

parcelRegister("5vmgy", function(module, exports) {

$parcel$export(module.exports, "defaultTeamAvatar", () => $40211e8d13b20538$export$aa80651379a69724, (v) => $40211e8d13b20538$export$aa80651379a69724 = v);
$parcel$export(module.exports, "exportPNGLozenge", () => $40211e8d13b20538$export$1ec0dee322814bb4, (v) => $40211e8d13b20538$export$1ec0dee322814bb4 = v);
$parcel$export(module.exports, "external-lozenge-wrapper", () => $40211e8d13b20538$export$33826dff95c4e59c, (v) => $40211e8d13b20538$export$33826dff95c4e59c = v);
$parcel$export(module.exports, "group-chevron", () => $40211e8d13b20538$export$477d29495b2764b8, (v) => $40211e8d13b20538$export$477d29495b2764b8 = v);
$parcel$export(module.exports, "group-details", () => $40211e8d13b20538$export$b38e392ce84ba127, (v) => $40211e8d13b20538$export$b38e392ce84ba127 = v);
$parcel$export(module.exports, "group-details-transposed", () => $40211e8d13b20538$export$c62c7b536b587bce, (v) => $40211e8d13b20538$export$c62c7b536b587bce = v);
$parcel$export(module.exports, "group-title", () => $40211e8d13b20538$export$afaad7582e91f5f, (v) => $40211e8d13b20538$export$afaad7582e91f5f = v);
$parcel$export(module.exports, "groupName", () => $40211e8d13b20538$export$f1f4ce1df2235f79, (v) => $40211e8d13b20538$export$f1f4ce1df2235f79 = v);
$parcel$export(module.exports, "groupRow", () => $40211e8d13b20538$export$26ba1761329d3a7b, (v) => $40211e8d13b20538$export$26ba1761329d3a7b = v);
$parcel$export(module.exports, "groupingAvatar", () => $40211e8d13b20538$export$7c7a81be5cf6d06a, (v) => $40211e8d13b20538$export$7c7a81be5cf6d06a = v);
$parcel$export(module.exports, "hasParentGroup", () => $40211e8d13b20538$export$45a1bf0ec5c659ef, (v) => $40211e8d13b20538$export$45a1bf0ec5c659ef = v);
$parcel$export(module.exports, "tooltip", () => $40211e8d13b20538$export$4e6f96734dfe12f4, (v) => $40211e8d13b20538$export$4e6f96734dfe12f4 = v);
$parcel$export(module.exports, "tooltip-title", () => $40211e8d13b20538$export$dc125fc2d6481f0d, (v) => $40211e8d13b20538$export$dc125fc2d6481f0d = v);
$parcel$export(module.exports, "tooltip-wrapper", () => $40211e8d13b20538$export$78aadbba80938a00, (v) => $40211e8d13b20538$export$78aadbba80938a00 = v);
var $40211e8d13b20538$export$aa80651379a69724;
var $40211e8d13b20538$export$1ec0dee322814bb4;
var $40211e8d13b20538$export$33826dff95c4e59c;
var $40211e8d13b20538$export$477d29495b2764b8;
var $40211e8d13b20538$export$b38e392ce84ba127;
var $40211e8d13b20538$export$c62c7b536b587bce;
var $40211e8d13b20538$export$afaad7582e91f5f;
var $40211e8d13b20538$export$f1f4ce1df2235f79;
var $40211e8d13b20538$export$26ba1761329d3a7b;
var $40211e8d13b20538$export$7c7a81be5cf6d06a;
var $40211e8d13b20538$export$45a1bf0ec5c659ef;
var $40211e8d13b20538$export$4e6f96734dfe12f4;
var $40211e8d13b20538$export$dc125fc2d6481f0d;
var $40211e8d13b20538$export$78aadbba80938a00;
$40211e8d13b20538$export$aa80651379a69724 = `dMdMgW_defaultTeamAvatar`;
$40211e8d13b20538$export$1ec0dee322814bb4 = `dMdMgW_exportPNGLozenge`;
$40211e8d13b20538$export$33826dff95c4e59c = `dMdMgW_external-lozenge-wrapper`;
$40211e8d13b20538$export$477d29495b2764b8 = `dMdMgW_group-chevron`;
$40211e8d13b20538$export$b38e392ce84ba127 = `dMdMgW_group-details`;
$40211e8d13b20538$export$c62c7b536b587bce = `dMdMgW_group-details-transposed`;
$40211e8d13b20538$export$afaad7582e91f5f = `dMdMgW_group-title`;
$40211e8d13b20538$export$f1f4ce1df2235f79 = `dMdMgW_groupName`;
$40211e8d13b20538$export$26ba1761329d3a7b = `dMdMgW_groupRow`;
$40211e8d13b20538$export$7c7a81be5cf6d06a = `dMdMgW_groupingAvatar`;
$40211e8d13b20538$export$45a1bf0ec5c659ef = `dMdMgW_hasParentGroup`;
$40211e8d13b20538$export$4e6f96734dfe12f4 = `dMdMgW_tooltip`;
$40211e8d13b20538$export$dc125fc2d6481f0d = `dMdMgW_tooltip-title`;
$40211e8d13b20538$export$78aadbba80938a00 = `dMdMgW_tooltip-wrapper`;

});






parcelRegister("99lB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed115e02b3d879da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");

var $3upRO = parcelRequire("3upRO");

var $VEQZy = parcelRequire("VEQZy");

var $71Rxx = parcelRequire("71Rxx");
function $ed115e02b3d879da$export$2e2bcd8739ae039(_props) {
    const redirectToSpaPlanPage = (0, $3upRO.useRedirectToSpaPlanPage)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        redirectToSpaPlanPage('/settings/issue-sources');
    }, [
        redirectToSpaPlanPage
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $71Rxx.emptyView
    }, _props.isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $VEQZy.default).emptyViewMessageReadOnly) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $VEQZy.default).emptyViewMessage,
        values: {
            button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                    target: "_blank",
                    appearance: "link",
                    onClick: onClick,
                    spacing: "none"
                }, chunks)
        }
    })));
}

});
parcelRegister("VEQZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a4b2d2fb72f6db$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c7a4b2d2fb72f6db$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyViewMessageReadOnly: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-empty-state.empty-view-message-read-only",
        "defaultMessage": "There aren't any issues in this plan yet."
    },
    emptyViewMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-empty-state.empty-view-message",
        "defaultMessage": "There aren't any issues in your plan yet. Add <button>issue sources</button> to form the scope of your plan."
    }
});

});

parcelRegister("71Rxx", function(module, exports) {

$parcel$export(module.exports, "emptyView", () => $51e2284e55c8b3bf$export$a1ea9495c5c524bc, (v) => $51e2284e55c8b3bf$export$a1ea9495c5c524bc = v);
var $51e2284e55c8b3bf$export$a1ea9495c5c524bc;
$51e2284e55c8b3bf$export$a1ea9495c5c524bc = `SM_IKW_emptyView`;

});


parcelRegister("auj1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b88f2603715d00f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6h5r3 = parcelRequire("6h5r3");

var $ft52v = parcelRequire("ft52v");
const $5b88f2603715d00f$export$1dbca41e84744512 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $ft52v.emptyView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $6h5r3.default).noMatchingIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $ft52v.line2
    }, formatMessage((0, $6h5r3.default).adjustFilter))));
};
var $5b88f2603715d00f$export$2e2bcd8739ae039 = $5b88f2603715d00f$export$1dbca41e84744512;

});
parcelRegister("6h5r3", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c446edd6a0e872$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $60c446edd6a0e872$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatchingIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-in-filter-empty-view.no-matching-issues",
        "defaultMessage": "No matching issues found."
    },
    adjustFilter: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.no-issues-in-filter-empty-view.adjust-filter",
        "defaultMessage": "Adjust your filters and try again."
    }
});

});

parcelRegister("ft52v", function(module, exports) {

$parcel$export(module.exports, "emptyView", () => $b42d7927ea8d21e9$export$a1ea9495c5c524bc, (v) => $b42d7927ea8d21e9$export$a1ea9495c5c524bc = v);
$parcel$export(module.exports, "line2", () => $b42d7927ea8d21e9$export$4afbf2decdd805ec, (v) => $b42d7927ea8d21e9$export$4afbf2decdd805ec = v);
var $b42d7927ea8d21e9$export$a1ea9495c5c524bc;
var $b42d7927ea8d21e9$export$4afbf2decdd805ec;
$b42d7927ea8d21e9$export$a1ea9495c5c524bc = `jn3g7W_emptyView`;
$b42d7927ea8d21e9$export$4afbf2decdd805ec = `jn3g7W_line2`;

});


parcelRegister("eEsJ2", function(module, exports) {

$parcel$export(module.exports, "blankRow", () => $aaab155de4c5dca9$export$34126cd4b89016d9, (v) => $aaab155de4c5dca9$export$34126cd4b89016d9 = v);
$parcel$export(module.exports, "drop-child-even", () => $aaab155de4c5dca9$export$33961997e0dff007, (v) => $aaab155de4c5dca9$export$33961997e0dff007 = v);
$parcel$export(module.exports, "drop-child-odd", () => $aaab155de4c5dca9$export$2977ee011e0be97e, (v) => $aaab155de4c5dca9$export$2977ee011e0be97e = v);
$parcel$export(module.exports, "drop-container", () => $aaab155de4c5dca9$export$6f8a0a68c6ddd84d, (v) => $aaab155de4c5dca9$export$6f8a0a68c6ddd84d = v);
$parcel$export(module.exports, "drop-invalid-child-even", () => $aaab155de4c5dca9$export$74e6643589062a13, (v) => $aaab155de4c5dca9$export$74e6643589062a13 = v);
$parcel$export(module.exports, "drop-invalid-child-odd", () => $aaab155de4c5dca9$export$6fe78eff732df301, (v) => $aaab155de4c5dca9$export$6fe78eff732df301 = v);
$parcel$export(module.exports, "drop-invalid-sibling", () => $aaab155de4c5dca9$export$7749340e380680e0, (v) => $aaab155de4c5dca9$export$7749340e380680e0 = v);
$parcel$export(module.exports, "drop-sibling", () => $aaab155de4c5dca9$export$5a26b02d9ff5edbe, (v) => $aaab155de4c5dca9$export$5a26b02d9ff5edbe = v);
$parcel$export(module.exports, "isDragging", () => $aaab155de4c5dca9$export$9e9bc3c487fccc00, (v) => $aaab155de4c5dca9$export$9e9bc3c487fccc00 = v);
$parcel$export(module.exports, "isInvalid", () => $aaab155de4c5dca9$export$eac50920cf2fd59a, (v) => $aaab155de4c5dca9$export$eac50920cf2fd59a = v);
$parcel$export(module.exports, "row-with-indentation", () => $aaab155de4c5dca9$export$3fe691ddfc79d8d5, (v) => $aaab155de4c5dca9$export$3fe691ddfc79d8d5 = v);
$parcel$export(module.exports, "unselected", () => $aaab155de4c5dca9$export$dcf867063481ae2c, (v) => $aaab155de4c5dca9$export$dcf867063481ae2c = v);
var $aaab155de4c5dca9$export$34126cd4b89016d9;
var $aaab155de4c5dca9$export$33961997e0dff007;
var $aaab155de4c5dca9$export$2977ee011e0be97e;
var $aaab155de4c5dca9$export$6f8a0a68c6ddd84d;
var $aaab155de4c5dca9$export$74e6643589062a13;
var $aaab155de4c5dca9$export$6fe78eff732df301;
var $aaab155de4c5dca9$export$7749340e380680e0;
var $aaab155de4c5dca9$export$5a26b02d9ff5edbe;
var $aaab155de4c5dca9$export$8b6211bf7f067794;
var $aaab155de4c5dca9$export$9e9bc3c487fccc00;
var $aaab155de4c5dca9$export$eac50920cf2fd59a;
var $aaab155de4c5dca9$export$3fe691ddfc79d8d5;
var $aaab155de4c5dca9$export$dcf867063481ae2c;
$aaab155de4c5dca9$export$34126cd4b89016d9 = `BVYcca_blankRow`;
$aaab155de4c5dca9$export$33961997e0dff007 = `BVYcca_drop-child-even`;
$aaab155de4c5dca9$export$2977ee011e0be97e = `BVYcca_drop-child-odd`;
$aaab155de4c5dca9$export$6f8a0a68c6ddd84d = `BVYcca_drop-container`;
$aaab155de4c5dca9$export$74e6643589062a13 = `BVYcca_drop-invalid-child-even`;
$aaab155de4c5dca9$export$6fe78eff732df301 = `BVYcca_drop-invalid-child-odd`;
$aaab155de4c5dca9$export$7749340e380680e0 = `BVYcca_drop-invalid-sibling`;
$aaab155de4c5dca9$export$5a26b02d9ff5edbe = `BVYcca_drop-sibling`;
$aaab155de4c5dca9$export$8b6211bf7f067794 = `BVYcca_group-team-avatar`;
$aaab155de4c5dca9$export$9e9bc3c487fccc00 = `BVYcca_isDragging`;
$aaab155de4c5dca9$export$eac50920cf2fd59a = `BVYcca_isInvalid`;
$aaab155de4c5dca9$export$3fe691ddfc79d8d5 = `BVYcca_row-with-indentation`;
$aaab155de4c5dca9$export$dcf867063481ae2c = `BVYcca_unselected`;

});

parcelRegister("cAXRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bbbfbd42a53f36c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");

var $h7T2Y = parcelRequire("h7T2Y");

var $a0bo1 = parcelRequire("a0bo1");

var $57dZR = parcelRequire("57dZR");

var $1ni3W = parcelRequire("1ni3W");

var $5rYNM = parcelRequire("5rYNM");

var $1QCBK = parcelRequire("1QCBK");

var $kzIWY = parcelRequire("kzIWY");

var $7LAU3 = parcelRequire("7LAU3");

var $eEsJ2 = parcelRequire("eEsJ2");

var $dkvHI = parcelRequire("dkvHI");
const $4bbbfbd42a53f36c$var$TableRow = ({ SelectableIssueComponent: SelectableIssueComponent, SortableIssueComponent: SortableIssueComponent, SortableIssuesWithoutParentComponent: SortableIssuesWithoutParentComponent, issues: issues, onToggle: onToggle, isReadOnly: isReadOnly, rankDigits: rankDigits, startLevel: startLevel, warnings: warnings, showWarning: showWarning, isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField, grouping: grouping, key: key, index: index, style: style, isScrolling: isScrolling, drop: drop })=>{
    const item = issues[index];
    const { tag: tag } = item;
    if (item.tag === (0, $a0bo1.TABLE_ISSUE)) {
        const { value: issue, parentGroup: parentGroup, groupCombination: groupCombination } = item;
        const issueId = issue.id || '';
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const issueWarnings = warnings.byIssue[issueId] || [];
        // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
        const hasWarnings = issueWarnings.length > 0 && showWarning;
        const hasIndentation = !!parentGroup;
        const { parentId: parentId } = drop;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.table-row.table-issue",
            key: `${item.tag}-${item.group || ''}-${issue.id || key}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, (0, $1ybV0.ff)('arj-remove-row-warning-highlighting_jqjs5') || (0, $57dZR.getRowHighlighter)(issue.group, issueId, hasWarnings), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectableIssueComponent, {
            issueId: issue.id,
            group: issue.group
        }, ({ isSelected: isSelected, hasChildSelected: hasChildSelected, toggleSelected: toggleSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortableIssueComponent, {
                isDropParent: parentId === issue.id,
                disabled: isReadOnly,
                index: index,
                onToggle: onToggle,
                hideRank: (issue.level || (0, $8YqJS.SUB_TASK_LEVEL)) < startLevel,
                issue: issue,
                isReadOnly: isReadOnly,
                isScrolling: isScrolling,
                rankDigits: rankDigits,
                isSelected: isSelected,
                hasChildSelected: hasChildSelected,
                toggleSelected: toggleSelected,
                warnings: warnings,
                hasIndentation: hasIndentation,
                groupCombination: groupCombination,
                isGroupingByMultiSelectCustomField: isGroupingByMultiSelectCustomField
            })));
    }
    if (item.tag === (0, $a0bo1.TABLE_INLINE_CREATE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.table-row.table-inline-create",
        key: `${item.tag}-${item.group || ''}-${item.value.id || key}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzIWY.default), {
        rootIndex: item.value.rootIndex,
        isReadOnly: isReadOnly,
        fixVersions: item.value.fixVersions?.map((x)=>Number(x)),
        components: item.value.components?.map((x)=>Number(x)),
        getContainer: (0, $1ni3W.getBody)
    }));
    // Remove with the cleanup of com.atlassian.rm.jpo.ease-of-use.remove-no-parent-header
    if (item.tag === (0, $a0bo1.TABLE_HEADER)) {
        const hasIndentation = !!item.parentGroup;
        const styleName = hasIndentation ? $eEsJ2["row-with-indentation"] : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.table-row.table-header",
            key: `${item.tag}-${item.group || ''}-${item.value.id || key}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LAU3.SortableIssuesWithoutParentHeader), {
            index: index,
            disabled: isReadOnly,
            issuesCount: item.value.issueCount,
            isExpanded: item.value.isExpanded,
            id: item.value.id,
            onToggle: onToggle
        }));
    }
    if (item.tag === (0, $a0bo1.TABLE_GROUP_HEADER)) {
        const { id: id, isExpanded: isExpanded, level: level, rootIssuesCount: rootIssuesCount } = item.value;
        const hasIndentation = !!item.parentGroup;
        const styleName = hasIndentation ? $eEsJ2["row-with-indentation"] : '';
        return (0, $h7T2Y.EpicLevelSpotlightTarget)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.table-row.table-group-header",
            key: `${item.tag}-${item.group || ''}-${id || key}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortableIssuesWithoutParentComponent, {
            disabled: isReadOnly,
            index: index,
            id: id || `${level.title}`,
            isExpanded: isExpanded,
            level: level,
            onToggle: onToggle,
            rankDigits: rankDigits,
            rootIssuesCount: rootIssuesCount
        })), grouping === (0, $5rYNM.GROUPING).NONE, level?.level);
    }
    if (item.tag === (0, $a0bo1.TABLE_BLANK_ROW)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: key,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.table-row.table-blank-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkvHI.default), {
        index: index,
        disabled: isReadOnly
    }));
    if (item.tag === (0, $a0bo1.TABLE_GROUP)) // @ts-expect-error - TS2322 - Type 'TableGroupItem' is not assignable to type 'TableItem'.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QCBK.default), {
        item: item,
        style: style,
        key: key,
        index: index
    });
    throw new Error(`Unexpected TABLE item variant: ${tag}`);
};
var $4bbbfbd42a53f36c$export$2e2bcd8739ae039 = $4bbbfbd42a53f36c$var$TableRow;

});
parcelRegister("kzIWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f6f0ddd20fbe451$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $45LMl = parcelRequire("45LMl");

var $4Z6gA = parcelRequire("4Z6gA");

var $2LU2j = parcelRequire("2LU2j");
var $5f6f0ddd20fbe451$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4Z6gA.default), (0, $45LMl.default))((0, $2LU2j.default));

});
parcelRegister("45LMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc82737a60d90b2$export$2e2bcd8739ae039);
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");
var $fk2gn = parcelRequire("fk2gn");

var $boQGP = parcelRequire("boQGP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3dc82737a60d90b2$export$2e2bcd8739ae039 = (dispatch)=>({
        createIssueWithTitle: (title)=>{
            if (title) dispatch((0, $fk2gn.inlineCreateIssue)(title));
            else dispatch((0, $dr4qD.clearInlineCreate)());
        },
        cancelInlineCreate: ()=>dispatch((0, $dr4qD.clearInlineCreate)()),
        setIssueTypeId: (issueTypeId)=>dispatch((0, $dr4qD.setIssueTypeId)(issueTypeId)),
        setProjectId: (projectId)=>dispatch((0, $dr4qD.setProjectId)(projectId)),
        setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
            dispatch((0, $dr4qD.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
        },
        setDefaultProjectId: (projectId)=>dispatch((0, $boQGP.setDefaultProject)({
                projectId: projectId
            }))
    });

});

parcelRegister("4Z6gA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519ce59d3f24aab$export$2e2bcd8739ae039);

var $i0RGP = parcelRequire("i0RGP");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");

var $fZW8G = parcelRequire("fZW8G");

var $cwMfk = parcelRequire("cwMfk");
var $lxd1S = parcelRequire("lxd1S");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");

var $ehEr2 = parcelRequire("ehEr2");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $b519ce59d3f24aab$export$73a2bcc86faf65db = (hierarchyLevels, state)=>{
    const level = state.hierarchyLevel;
    const enrichedLevel = $i0RGP.default($h3f0m.default('level', level), hierarchyLevels);
    return enrichedLevel ? enrichedLevel.issueTypes : [];
};
const $b519ce59d3f24aab$export$f81ff8353d1b194c = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getEnrichedHierarchyLevels),
    (0, $cwMfk.getInlineCreateState)
], $b519ce59d3f24aab$export$73a2bcc86faf65db);
const $b519ce59d3f24aab$export$d63a65fd452a44f = (0, $iK4oF.createSelector)([
    (0, $cwMfk.getInlineCreateState),
    (0, $kwMvv.getIssueFilterMatcher)
], (state, matchFilter)=>(summary)=>{
        const issue = {
            ...state.values,
            summary: summary
        };
        // @ts-expect-error - TS2345 - Argument of type '{ summary: string; status?: string | undefined; parent?: string | undefined; description?: string | undefined; project: number; labels?: string[] | null | undefined; components?: number[] | null | undefined; ... 24 more ...; inferred?: InferredFields | undefined; }' is not assignable to parameter of type 'Readonly<{ assignee: string; assignments: Assignment[]; annotations?: Annotation[] | undefined; baselineStart?: number | null | undefined; baselineEnd?: number | null | undefined; ... 30 more ...; inferred?: InferredFields | undefined; }>'.
        return matchFilter(issue, {
            exclude: [
                (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)
            ]
        });
    });
const $b519ce59d3f24aab$export$c18ad112f2d834c1 = (issueTypes, projects, state, orderedIssueTypes, matchFilter, // eslint-disable-next-line @typescript-eslint/no-shadow
isSavingIssue)=>{
    const id = $f7Op5.default('id');
    const issueTypesById = (0, $7CnHa.indexBy)(id, issueTypes);
    const projectsById = (0, $7CnHa.indexBy)(id, projects);
    return {
        id: (0, $lxd1S.INLINE_CREATE_ID),
        issueTypeId: state.issueTypeId,
        projectId: state.projectId,
        hierarchyLevel: state.hierarchyLevel,
        issueTypes: issueTypesById,
        orderedIssueTypes: orderedIssueTypes,
        projects: projectsById,
        isGlobalCreate: state.isGlobalCreateIssue,
        matchFilter: matchFilter,
        isSavingIssue: isSavingIssue,
        isOpenLocked: Object.values(state.openLockedMap).some((value)=>!!value)
    };
};
var $b519ce59d3f24aab$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $lihml.getIssueTypes),
    (0, $ehEr2.getProjects),
    (0, $cwMfk.getInlineCreateState),
    $b519ce59d3f24aab$export$f81ff8353d1b194c,
    $b519ce59d3f24aab$export$d63a65fd452a44f,
    (0, $kwMvv.isSavingIssue)
], $b519ce59d3f24aab$export$c18ad112f2d834c1);

});

parcelRegister("2LU2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec02e0fa234ccb9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $f2C9X = parcelRequire("f2C9X");
var $dspDs = parcelRequire("dspDs");

var $86Ndv = parcelRequire("86Ndv");

var $5YsMl = parcelRequire("5YsMl");

var $4Bees = parcelRequire("4Bees");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $g4Vkx = parcelRequire("g4Vkx");
var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
var $eNhh9 = parcelRequire("eNhh9");
var $6GmrT = parcelRequire("6GmrT");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2BQwE = parcelRequire("2BQwE");

var $duQ8C = parcelRequire("duQ8C");

var $4sQzf = parcelRequire("4sQzf");

var $19abn = parcelRequire("19abn");

var $89u7J = parcelRequire("89u7J");
const $0ec02e0fa234ccb9$var$isInlineCreateRow = (target, id, projectMenu, issueMenu)=>{
    let node = target;
    // Drop menu content opens in a portal, so we need to check the menu refs to
    // know if the target belongs to the scope of this component
    if (node instanceof Node && projectMenu && projectMenu.contains(node)) return true;
    if (node instanceof Node && issueMenu && issueMenu.contains(node)) return true;
    while(node instanceof Node){
        if (node instanceof HTMLElement && node.dataset.issue === id) return true;
        node = node.parentNode;
    }
    return false;
};
class $0ec02e0fa234ccb9$export$bff74f82b631e3d3 extends (0, $eUqFw.Component) {
    static{
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            getContainer: (0, $1ni3W.getBody),
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            setDefaultProjectId: ()=>{},
            isGlobalCreate: false
        };
    }
    componentDidMount() {
        this.props.getContainer().addEventListener('click', this.clickOutsideListener, {
            capture: true
        });
        this.props.getContainer().addEventListener('keydown', this.escapeKeyListener);
        const { isSavingIssue: isSavingIssue } = this.props;
        /* JPO-20440 We trigger focus manually here. setTimeout is added to make sure the focus stays in issue summary.
     * If no setTimeout, the focus somehow moved to the last active element.
     */ this.timeoutId = setTimeout(()=>{
            // Checks if initial project is defined and not currently saving new issue
            if (this.initialProjectIsDefined && !isSavingIssue && this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
        }, 0);
    }
    componentWillUnmount() {
        this.props.getContainer().removeEventListener('click', this.clickOutsideListener, {
            capture: true
        });
        this.props.getContainer().removeEventListener('keydown', this.escapeKeyListener);
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
    /**
   * Filter projects dropdown if group by Release or Component is enabled
   */ getFilteredProjects(projectsForCurrentIssueTypeLevel) {
        const { projectId: projectId, fixVersions: fixVersions, components: components } = this.props;
        let filteredProjects = projectsForCurrentIssueTypeLevel;
        if (fixVersions && fixVersions.length) {
            // Filter by projects by fix versions if group by "release" is enabled
            const projectsForCurrentReleaseGroup = filteredProjects.filter((project)=>project.id === projectId || project.versions && $dspDs.default(project.versions, fixVersions.map((fixVersion)=>fixVersion.toString())).length > 0);
            filteredProjects = projectsForCurrentReleaseGroup.length > 0 ? projectsForCurrentReleaseGroup : filteredProjects;
        } else if (components && components.length) {
            // Filter by projects by components if group by "component" is enabled
            const projectsForCurrentComponentGroup = filteredProjects.filter((project)=>project.id === projectId || project.components && project.components.find((component)=>components.includes(component.id)));
            filteredProjects = projectsForCurrentComponentGroup.length > 0 ? projectsForCurrentComponentGroup : filteredProjects;
        }
        return filteredProjects;
    }
    render() {
        const { id: id, intl: { formatMessage: formatMessage }, issueTypeId: issueTypeId, hierarchyLevel: hierarchyLevel, projectId: projectId, issueTypes: issueTypes, orderedIssueTypes: orderedIssueTypes, projects: projects, cancelInlineCreate: cancelInlineCreate, setIssueTypeId: setIssueTypeId, rootIndex: rootIndex, isReadOnly: isReadOnly = false, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, isSavingIssue: isSavingIssue, fixVersions: fixVersions, components: components } = this.props;
        const { isProjectMenuOpen: isProjectMenuOpen, key: key } = this.state;
        const issueType = issueTypes[issueTypeId];
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const currentLevelIssueTypes = orderedIssueTypes.map(({ id: id })=>id);
        const projectsForCurrentIssueTypeLevel = (0, $7CnHa.values)(projects).filter((project)=>$dspDs.default(project.issueTypeIds, currentLevelIssueTypes).length > 0);
        const filteredProjects = this.getFilteredProjects(projectsForCurrentIssueTypeLevel);
        // if the plan is grouped by component or release AND:
        // - if there are several relevant projects in the group, the user has to select a project in the projects dropdown, which then updates the current project in the state.
        // - if there is only one relevant project in the group, the projects dropdown only renders one project and is disabled, so the user cannot select a project.
        // Therefore we need to set the project ourselves in the state otherwise creating an issue will fail since the project is undefined.
        if ((components && components.length || fixVersions && fixVersions.length) && filteredProjects.length === 1) this.setSelectedProjectId(filteredProjects[0].id, currentLevelIssueTypes);
        const project = projects[projectId] || filteredProjects.length === 1 && filteredProjects[0];
        this.initialProjectIsDefined = !!project;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-name": "issue-inline-create",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$4sQzf.container} ${(rootIndex + 1) % 2 === 0 ? $4sQzf.even : $4sQzf.odd}`,
            "data-issue": id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $89u7J.dropdown,
            "data-name": "issueTypes"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ref: triggerRef,
                    ...props,
                    isDisabled: isReadOnly || orderedIssueTypes.length < 2 || !this.initialProjectIsDefined,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: ""
                    }),
                    "aria-label": issueType ? issueType.name : formatMessage((0, $19abn.default).selectIssueType)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $89u7J.icon,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        backgroundSize: 'contain',
                        backgroundImage: issueType && `url(${issueType.iconUrl})`,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginRight: "var(--ds-space-300, 24px)"
                    },
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.issue.issue-type-icon.${issueType && issueType.id}`
                })),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.issue-types-select"
        }, this.initialProjectIsDefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            ref: (ele)=>{
                this.issueMenu = ele;
            }
        }, orderedIssueTypes.filter((item)=>project.issueTypeIds.includes(item.id)).map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
                id: item.id,
                onClick: ()=>{
                    setIssueTypeIdForHierarchy(hierarchyLevel, item.id);
                    setIssueTypeId(item.id);
                },
                key: item.id
            }, item.name))) : null)), (0, $7CnHa.values)(projects).length > 1 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $89u7J.dropdown,
            "data-name": "projects"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
            defaultOpen: !this.initialProjectIsDefined,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ref: triggerRef,
                    ...props,
                    isDisabled: isReadOnly || filteredProjects.length === 1,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: ""
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
                        [$89u7J.projectIcon]: this.initialProjectIsDefined
                    }),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...this.initialProjectIsDefined ? {
                            backgroundImage: `url(${project.avatarUrl})`
                        } : {},
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginRight: "var(--ds-space-300, 24px)"
                    }
                }, this.initialProjectIsDefined ? project.key : formatMessage((0, $19abn.default).selectProject))),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-project",
            isOpen: isProjectMenuOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            ref: (ele)=>{
                this.projectMenu = ele;
            }
        }, filteredProjects.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
                id: item.id,
                onClick: ()=>{
                    this.setSelectedProjectId(item.id, currentLevelIssueTypes);
                    this.focusOnSummaryField();
                },
                key: item.id,
                isSelected: item.id === project.id
            }, item.name))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $89u7J.inlineEdit,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.inline-edit-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GmrT.default), {
            defaultValue: "",
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>// if the issue summary is valid but it does not match the applied filters,
                // we display an info message to the user
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                    isOpen: errorMessage || fieldProps && !fieldProps.isInvalid && !this.doesIssueSummaryMatchFilters(fieldProps.value),
                    placement: "right",
                    content: errorMessage || formatMessage((0, $19abn.default).notMatchFilterMessage),
                    noHorizontalScroll: true,
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.inline-dialog"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: isSavingIssue ? $89u7J.container : ''
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ...fieldProps,
                    elemAfterInput: fieldProps && (fieldProps.isInvalid || !this.doesIssueSummaryMatchFilters(fieldProps.value)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                        label: "",
                        primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
                    }),
                    isReadOnly: !this.initialProjectIsDefined || isSavingIssue,
                    maxLength: 256,
                    placeholder: formatMessage(isSavingIssue ? (0, $19abn.default).savingIssuePlaceholder : (0, $19abn.default).titlePlaceholder),
                    "aria-label": formatMessage((0, $19abn.default).ariaLabel),
                    ref: (inputEl)=>{
                        if (inputEl) this.issueSummaryInputRef = inputEl;
                    }
                }), isSavingIssue && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $89u7J.spinner
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.saving-spinner"
                })))),
            hideActionButtons: isSavingIssue,
            keepEditViewOpenOnBlur: true,
            key: key,
            onCancel: cancelInlineCreate,
            onConfirm: this.saveIssue,
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            startWithEditViewOpen: true,
            validate: this.validateIssueSummary
        })));
    }
    constructor(...args){
        super(...args);
        this.initialProjectIsDefined = false;
        this.state = {
            key: Math.random(),
            isProjectMenuOpen: false
        };
        this.clickOutsideListener = (e)=>{
            if (!$0ec02e0fa234ccb9$var$isInlineCreateRow(e.target, this.props.id, this.projectMenu, this.issueMenu) && !this.props.isOpenLocked) this.props.cancelInlineCreate();
        };
        this.escapeKeyListener = (e)=>{
            /* istanbul ignore else */ if (e.key === 'Escape') this.props.cancelInlineCreate();
        };
        this.focusOnSummaryField = ()=>{
            this.setState({
                isProjectMenuOpen: false
            }, ()=>{
                // this is necessary to set the focus back on the issue summary input field after a project has been selected
                if (this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
            });
        };
        this.setSelectedProjectId = (id, currentLevelIssueTypes)=>{
            const { setProjectId: setProjectId, projects: projects, issueTypeId: issueTypeId, setIssueTypeId: setIssueTypeId, setDefaultProjectId: setDefaultProjectId, isGlobalCreate: isGlobalCreate } = this.props;
            const project = projects[id];
            if (!project) throw new Error(`Project with id ${id} is not found in plan`);
            setProjectId(id);
            if (isGlobalCreate === true) setDefaultProjectId(id);
            if (!project.issueTypeIds.includes(issueTypeId)) {
                const newIssueType = $f2C9X.default($dspDs.default(project.issueTypeIds, currentLevelIssueTypes));
                if (!(0, $7CnHa.isDefined)(newIssueType)) throw new Error(`Available project with id ${project.id} must contain an issue type of current level (one of ${currentLevelIssueTypes.join(', ')})`);
                setIssueTypeId(newIssueType);
            }
        };
        this.saveIssue = (title)=>{
            const titleValue = title && title.trim();
            (0, $duQ8C.default)((0, $2BQwE.KEYS).CREATE_ISSUE);
            if ((0, $7CnHa.isDefined)(titleValue) && titleValue.length > 0) this.props.createIssueWithTitle(title);
            this.setState({
                key: Math.random()
            }, ()=>{
                // JPO-19344 Trigger focus manually
                if (this.issueSummaryInputRef) this.issueSummaryInputRef.focus();
            });
        };
        this.doesIssueSummaryMatchFilters = (summary)=>summary.length === 0 || this.props.matchFilter(summary);
        this.validateIssueSummary = (summary)=>{
            // if the issue summary is not valid, we return a warning message which disables the "confirm" button of <InlineEdit />
            const { intl: { formatMessage: formatMessage } } = this.props;
            if (summary.trim().length === 0) return formatMessage((0, $19abn.default).blankInputErrorMessage);
            if (summary.length > 255) return formatMessage((0, $19abn.default).tooLongInputErrorMessage);
            // if the issue summary is valid, we return undefined which enables the "confirm" button of <InlineEdit />
            return undefined;
        };
    }
}
var $0ec02e0fa234ccb9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0ec02e0fa234ccb9$export$bff74f82b631e3d3);

});
parcelRegister("19abn", function(module, exports) {

$parcel$export(module.exports, "default", () => $81ed3e206f5b1e13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $81ed3e206f5b1e13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titlePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.title-placeholder",
        "defaultMessage": "Issue summary ..."
    },
    ariaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.aria-label",
        "defaultMessage": "Issue summary"
    },
    savingIssuePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.saving-issue-placeholder",
        "defaultMessage": "Creating issue ..."
    },
    selectProject: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-project",
        "defaultMessage": "Choose project"
    },
    selectIssueType: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.select-issue-type",
        "defaultMessage": "Choose issue type"
    },
    blankInputErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.blank-input-error-message",
        "defaultMessage": "You must specify a summary of the issue."
    },
    notMatchFilterMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.not-match-filter-message",
        "defaultMessage": "This issue will be created, but won't be visible due to the applied filters."
    },
    tooLongInputErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.scope.issues.inline-create.too-long-input-error-message",
        "defaultMessage": "Summary must be less than 256 characters."
    }
});

});

parcelRegister("89u7J", function(module, exports) {

$parcel$export(module.exports, "container", () => $5ef687f52cb01ded$export$34e0f9847d4c02dd, (v) => $5ef687f52cb01ded$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "dropdown", () => $5ef687f52cb01ded$export$81207e5cc4186890, (v) => $5ef687f52cb01ded$export$81207e5cc4186890 = v);
$parcel$export(module.exports, "icon", () => $5ef687f52cb01ded$export$1ca1ec8b29a4ce27, (v) => $5ef687f52cb01ded$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "inlineEdit", () => $5ef687f52cb01ded$export$ba770051015ef5e7, (v) => $5ef687f52cb01ded$export$ba770051015ef5e7 = v);
$parcel$export(module.exports, "projectIcon", () => $5ef687f52cb01ded$export$e595ab851fd6d370, (v) => $5ef687f52cb01ded$export$e595ab851fd6d370 = v);
$parcel$export(module.exports, "spinner", () => $5ef687f52cb01ded$export$641374ffb95bc399, (v) => $5ef687f52cb01ded$export$641374ffb95bc399 = v);
var $5ef687f52cb01ded$export$cdf6733243a3cd26;
var $5ef687f52cb01ded$export$34e0f9847d4c02dd;
var $5ef687f52cb01ded$export$81207e5cc4186890;
var $5ef687f52cb01ded$export$1ca1ec8b29a4ce27;
var $5ef687f52cb01ded$export$ba770051015ef5e7;
var $5ef687f52cb01ded$export$e595ab851fd6d370;
var $5ef687f52cb01ded$export$641374ffb95bc399;
var $5ef687f52cb01ded$export$a6dea3b909d8edf2;
var $5ef687f52cb01ded$export$82d15ec6f07228ea;
var $5ef687f52cb01ded$export$8cc0b96c9ae1fca1;
$5ef687f52cb01ded$export$cdf6733243a3cd26 = `CzkEIW_assertiveIcon`;
$5ef687f52cb01ded$export$34e0f9847d4c02dd = `CzkEIW_container`;
$5ef687f52cb01ded$export$81207e5cc4186890 = `CzkEIW_dropdown`;
$5ef687f52cb01ded$export$1ca1ec8b29a4ce27 = `CzkEIW_icon`;
$5ef687f52cb01ded$export$ba770051015ef5e7 = `CzkEIW_inlineEdit`;
$5ef687f52cb01ded$export$e595ab851fd6d370 = `CzkEIW_projectIcon`;
$5ef687f52cb01ded$export$641374ffb95bc399 = `CzkEIW_spinner`;
$5ef687f52cb01ded$export$a6dea3b909d8edf2 = `CzkEIW_validationIcon`;
$5ef687f52cb01ded$export$82d15ec6f07228ea = `CzkEIW_validationText`;
$5ef687f52cb01ded$export$8cc0b96c9ae1fca1 = `CzkEIW_validationTextMessage`;

});



parcelRegister("dkvHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb394f5e185c193$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hXJR4 = parcelRequire("hXJR4");

var $eEsJ2 = parcelRequire("eEsJ2");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
const $ccb394f5e185c193$var$BlankRow = (0, $hXJR4.SortableElement)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $eEsJ2.blankRow,
        "data-role": "header"
    }));
var $ccb394f5e185c193$export$2e2bcd8739ae039 = $ccb394f5e185c193$var$BlankRow;

});


const $6b22482c0db9401b$export$2c56a3da224d2361 = 'view.main.tabs.roadmap.scope.issues.DROP_INVALID_SIBLING';
const $6b22482c0db9401b$export$818ea92c669038b0 = 'view.main.tabs.roadmap.scope.issues.DROP_INVALID_CHILD';
const $6b22482c0db9401b$export$d4ead6ccaed25c5f = 'view.main.tabs.roadmap.scope.issues.DROP_SIBLING';
const $6b22482c0db9401b$export$56b564d4a01df705 = 'view.main.tabs.roadmap.scope.issues.DROP_CHILD';
const $6b22482c0db9401b$export$6182a67c5764bd0f = 'view.main.tabs.roadmap.scope.issues.DROP_NONE';
const $6b22482c0db9401b$export$8c3e240870cf415c = 'REPARENT_TMP_TO_EXTERNAL_ERROR';
const $6b22482c0db9401b$export$5f5b0f14f53c9487 = 'REPARENT_CMP_TO_TMP_ERROR';

parcelRegister("aytOt", function(module, exports) {

$parcel$export(module.exports, "isTableGroupItem", () => $0b26d0a94a716ee8$export$e38ba878103876f0);
$parcel$export(module.exports, "isSortByRank", () => $0b26d0a94a716ee8$export$3016207d237b956b);
$parcel$export(module.exports, "getNewDropState", () => $0b26d0a94a716ee8$export$b4d00e619e08b746);

var $1ybV0 = parcelRequire("1ybV0");

var $8YqJS = parcelRequire("8YqJS");
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");

var $a0bo1 = parcelRequire("a0bo1");

function $0b26d0a94a716ee8$export$e38ba878103876f0(issue) {
    return 'height' in issue;
}
const $0b26d0a94a716ee8$export$217282697bf60d2 = (index, newIndex)=>{
    if (newIndex > index) // The item currently at newIndex will become the itemBefore after drop
    // because the gap left behind the dragged item will offset the index - 1.
    // The item currently after newIndex will remain the itemAfter after drop.
    return {
        indexBefore: newIndex,
        indexAfter: newIndex + 1
    };
    if (newIndex < index) return {
        indexBefore: newIndex - 1,
        indexAfter: newIndex
    };
    // newIndex === index
    return {
        indexBefore: newIndex - 1,
        indexAfter: newIndex + 1
    };
};
const $0b26d0a94a716ee8$var$getRelativePosition = ({ issue: issue, itemBefore: itemBefore, itemAfter: itemAfter })=>{
    // prefer to rank issue before sibling issue than to rank issue after (parent) issue
    if (itemAfter?.tag === (0, $a0bo1.TABLE_ISSUE) && issue.value.level === itemAfter.value.level) return {
        anchor: itemAfter.value.id,
        relation: 'BEFORE'
    };
    if (itemBefore?.tag === (0, $a0bo1.TABLE_ISSUE)) return {
        anchor: itemBefore.value.id,
        relation: 'AFTER'
    };
    return {
        anchor: undefined,
        relation: 'LAST'
    };
};
const $0b26d0a94a716ee8$var$findPreviousSibling = (items, startIndex, id, level)=>{
    for(let i = startIndex; i >= 0; i--){
        const item = items[i];
        if (item?.tag === (0, $a0bo1.TABLE_ISSUE)) {
            const itemIsNotSelf = item.value.id !== id;
            const itemIsSameLevel = item.value.level === level;
            if (itemIsNotSelf && itemIsSameLevel) return item;
            if (item.value.level > level) return undefined;
        } else return undefined;
    }
    return undefined;
};
const $0b26d0a94a716ee8$var$getReparentDropState = ({ issue: issue, parentProject: parentProject, parentId: parentId })=>{
    const { value: { project: project, level: level } } = issue;
    if (parentId !== undefined) {
        if ((0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr')) {
            if (level !== (0, $8YqJS.EPIC_LEVEL)) {
                if (project.isSimplified && project.id !== parentProject.id) return {
                    parentId: null,
                    type: (0, $6b22482c0db9401b$export$818ea92c669038b0),
                    errorType: (0, $6b22482c0db9401b$export$8c3e240870cf415c)
                };
                if (!project.isSimplified && parentProject.isSimplified) return {
                    parentId: null,
                    type: (0, $6b22482c0db9401b$export$818ea92c669038b0),
                    errorType: (0, $6b22482c0db9401b$export$5f5b0f14f53c9487)
                };
            }
        } else {
            if (project.isSimplified && project.id !== parentProject.id) return {
                parentId: null,
                type: (0, $6b22482c0db9401b$export$818ea92c669038b0),
                errorType: (0, $6b22482c0db9401b$export$8c3e240870cf415c)
            };
            if (!project.isSimplified && parentProject.isSimplified) return {
                parentId: null,
                type: (0, $6b22482c0db9401b$export$818ea92c669038b0),
                errorType: (0, $6b22482c0db9401b$export$5f5b0f14f53c9487)
            };
        }
    }
    return {
        parentId: parentId,
        type: (0, $6b22482c0db9401b$export$56b564d4a01df705),
        errorType: null
    };
};
const $0b26d0a94a716ee8$export$3016207d237b956b = (sortByField)=>sortByField === (0, $chgK5.ISSUE_FIELDS).RANK;
const $0b26d0a94a716ee8$export$b4d00e619e08b746 = ({ items: items, index: index, newIndex: newIndex, startLevel: startLevel })=>{
    const draggedItem = items[index];
    if (draggedItem?.tag !== (0, $a0bo1.TABLE_ISSUE)) throw new Error(`Dragged item at index ${index} was expected to be ${(0, $a0bo1.TABLE_ISSUE)}, but was ${draggedItem.tag}.`);
    // dragged item must be table issue
    const { value: { id: id, level: level, parent: parent }, group: group } = draggedItem;
    const defaultDropState = {
        id: id,
        group: group,
        parentId: parent,
        anchor: undefined,
        relation: null,
        type: (0, $6b22482c0db9401b$export$6182a67c5764bd0f),
        errorType: null
    };
    // It's not always obvious what the user's intent was, so it's difficult to accurately classify the invalid reason.
    // Where possible, we differentiate DROP_INVALID_SIBLING from DROP_INVALID_CHILD.
    const invalidDropState = {
        ...defaultDropState,
        type: (0, $6b22482c0db9401b$export$2c56a3da224d2361)
    };
    if (index === newIndex) return defaultDropState;
    const { indexBefore: indexBefore, indexAfter: indexAfter } = $0b26d0a94a716ee8$export$217282697bf60d2(index, newIndex);
    const itemBefore = items[indexBefore];
    const itemAfter = items[indexAfter];
    const isDropInSameGroup = group === itemBefore?.group;
    if (!isDropInSameGroup) return invalidDropState;
    const isDropAtStart = newIndex === 0;
    const isDropAfterGroup = itemBefore?.tag === (0, $a0bo1.TABLE_GROUP);
    if (isDropAtStart || isDropAfterGroup) {
        if (level === startLevel) return {
            ...defaultDropState,
            ...$0b26d0a94a716ee8$var$getRelativePosition({
                issue: draggedItem,
                itemAfter: itemAfter
            }),
            parentId: null,
            type: (0, $6b22482c0db9401b$export$d4ead6ccaed25c5f)
        };
        return invalidDropState;
    }
    const isDropAfterGroupHeader = itemBefore?.tag === (0, $a0bo1.TABLE_GROUP_HEADER);
    if (isDropAfterGroupHeader) {
        const { value: { level: { level: groupHeaderLevel } } } = itemBefore;
        const willOrphanSubtask = level === (0, $8YqJS.SUB_TASK_LEVEL);
        if (level === groupHeaderLevel && !willOrphanSubtask) return {
            ...defaultDropState,
            ...$0b26d0a94a716ee8$var$getRelativePosition({
                issue: draggedItem,
                itemAfter: itemAfter
            }),
            parentId: null,
            type: (0, $6b22482c0db9401b$export$d4ead6ccaed25c5f)
        };
        return invalidDropState;
    }
    const isDropAfterIssue = itemBefore?.tag === (0, $a0bo1.TABLE_ISSUE);
    if (isDropAfterIssue) {
        const { value: { id: issueBeforeId, level: issueBeforeLevel, project: issueBeforeProject } } = itemBefore;
        // including same parent
        const isReparent = level === issueBeforeLevel - 1;
        if (isReparent) {
            const reparentState = $0b26d0a94a716ee8$var$getReparentDropState({
                issue: draggedItem,
                parentProject: issueBeforeProject,
                parentId: issueBeforeId
            });
            return reparentState.errorType === null ? {
                ...defaultDropState,
                ...reparentState,
                ...$0b26d0a94a716ee8$var$getRelativePosition({
                    issue: draggedItem,
                    itemBefore: itemBefore,
                    itemAfter: itemAfter
                })
            } : {
                ...defaultDropState,
                ...reparentState
            };
        }
        // isRerank
        const isInsertBetweenParentAndChild = itemAfter?.tag === (0, $a0bo1.TABLE_ISSUE) && level > itemAfter.value.level;
        if (!isInsertBetweenParentAndChild) {
            const sibling = $0b26d0a94a716ee8$var$findPreviousSibling(items, indexBefore, id, level);
            if (sibling !== undefined) {
                const { value: { project: siblingProject, parent: siblingParent } } = sibling;
                const willOrphanSubtask = level === (0, $8YqJS.SUB_TASK_LEVEL) && siblingParent === undefined;
                if (willOrphanSubtask) return invalidDropState;
                const isAlsoReparent = parent !== siblingParent;
                if (isAlsoReparent) {
                    const reparentState = $0b26d0a94a716ee8$var$getReparentDropState({
                        issue: draggedItem,
                        parentProject: siblingProject,
                        parentId: siblingParent
                    });
                    return reparentState.errorType === null ? {
                        ...defaultDropState,
                        ...reparentState,
                        ...$0b26d0a94a716ee8$var$getRelativePosition({
                            issue: draggedItem,
                            itemBefore: itemBefore,
                            itemAfter: itemAfter
                        })
                    } : {
                        ...defaultDropState,
                        ...reparentState
                    };
                }
                return {
                    ...defaultDropState,
                    ...$0b26d0a94a716ee8$var$getRelativePosition({
                        issue: draggedItem,
                        itemBefore: itemBefore,
                        itemAfter: itemAfter
                    }),
                    type: (0, $6b22482c0db9401b$export$d4ead6ccaed25c5f)
                };
            }
        }
    }
    // drop after any other type of item, such as blank row or inline create, are considered invalid
    return invalidDropState;
};

});

parcelRegister("k4LoK", function(module, exports) {

$parcel$export(module.exports, "shouldCancelStart", () => $efcffc0e5221a0b7$export$c26c0568f8013000);
$parcel$export(module.exports, "componentDidUpdateHelper", () => $efcffc0e5221a0b7$export$36024edf40e4ea0);
$parcel$export(module.exports, "disableUserSelection", () => $efcffc0e5221a0b7$export$76b6147b732706db);
$parcel$export(module.exports, "onSortEndHelper", () => $efcffc0e5221a0b7$export$8ad138bfa1118987);
$parcel$export(module.exports, "getDropClassName", () => $efcffc0e5221a0b7$export$39fe38c3caf3e416);
$parcel$export(module.exports, "getDraggedNode", () => $efcffc0e5221a0b7$export$ddc30553f485140a);

var $eUqFw = parcelRequire("eUqFw");

var $dYnI4 = parcelRequire("dYnI4");
parcelRequire("1nPPv");

var $a0bo1 = parcelRequire("a0bo1");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $eEsJ2 = parcelRequire("eEsJ2");


var $aytOt = parcelRequire("aytOt");
const $efcffc0e5221a0b7$export$9632930937171b5e = [
    'input',
    'textarea',
    'select',
    'option',
    'button'
];
const $efcffc0e5221a0b7$export$c26c0568f8013000 = (disableDnD)=>(e)=>{
        if ((0, $7CnHa.isDefined)(disableDnD) && disableDnD) return true;
        if (!(e.target instanceof HTMLElement) || $efcffc0e5221a0b7$export$9632930937171b5e.indexOf(e.target.tagName.toLowerCase()) !== -1) return true;
        let node = e.target;
        while(node){
            if (node.dataset && node.dataset.role === 'header') return true;
            // @ts-expect-error - TS2322 - Type 'ParentNode | null' is not assignable to type 'HTMLElement'.
            node = node.parentNode;
        }
        return false;
    };
const $efcffc0e5221a0b7$export$36024edf40e4ea0 = (state, getDraggedNode, isLoading)=>{
    const { type: dropType } = state;
    const node = getDraggedNode();
    if (!isLoading) (0, $dYnI4.monitor).finishProfile((0, $5rYNM.PROFILE_KEYS).RENDER.SCOPE_TABLE);
    if (!node) return;
    switch(dropType){
        case 0, $6b22482c0db9401b$export$6182a67c5764bd0f:
        case 0, $6b22482c0db9401b$export$56b564d4a01df705:
        case 0, $6b22482c0db9401b$export$d4ead6ccaed25c5f:
            node.classList.remove($eEsJ2.isInvalid);
            return;
        case 0, $6b22482c0db9401b$export$818ea92c669038b0:
        case 0, $6b22482c0db9401b$export$2c56a3da224d2361:
            node.classList.add($eEsJ2.isInvalid);
            return;
        default:
            throw new Error(`Unexpected drop type: ${dropType}`);
    }
};
const $efcffc0e5221a0b7$export$76b6147b732706db = (disableSelection)=>{
    const body = (0, $1ni3W.getBody)();
    body.classList.toggle($eEsJ2.unselected, disableSelection);
};
const $efcffc0e5221a0b7$var$truncateSummary = (originalSummary, maxLength = 50)=>{
    if (originalSummary.length > maxLength) return `${originalSummary.slice(0, maxLength - 3)}...`;
    return originalSummary;
};
const $efcffc0e5221a0b7$var$getIssueKey = (projectKey, issueNum, summary)=>{
    const isScenarioIssue = issueNum === undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, isScenarioIssue ? $efcffc0e5221a0b7$var$truncateSummary(summary) : `${projectKey}-${issueNum}`);
};
const $efcffc0e5221a0b7$export$8ad138bfa1118987 = (state, onMove, sorting, onInvalidRanking, issues, delta)=>{
    $efcffc0e5221a0b7$export$76b6147b732706db(false);
    const { newIndex: newIndex, oldIndex: oldIndex } = delta;
    const { group: group, id: id, relation: relation, anchor: anchor, parentId: parentId, type: type, errorType: errorType } = state;
    const dragAndDrop = true;
    if (newIndex !== oldIndex && id && relation && (0, $aytOt.isSortByRank)(sorting.field)) onMove({
        anchor: anchor,
        dragAndDrop: dragAndDrop,
        group: group,
        id: id,
        parentId: parentId,
        relation: relation
    });
    if (type === (0, $6b22482c0db9401b$export$818ea92c669038b0) && (errorType === (0, $6b22482c0db9401b$export$8c3e240870cf415c) || errorType === (0, $6b22482c0db9401b$export$5f5b0f14f53c9487))) {
        const indexBefore = newIndex - (newIndex > oldIndex ? 0 : 1);
        const draggedIssue = issues[oldIndex];
        const parentIssue = issues[indexBefore];
        onInvalidRanking({
            key: errorType === (0, $6b22482c0db9401b$export$8c3e240870cf415c) ? (0, $42b69a8aa6898c13$export$8a72c64e90d56fab) : (0, $42b69a8aa6898c13$export$ac1a967dceae5708),
            context: draggedIssue.tag === (0, $a0bo1.TABLE_ISSUE) && parentIssue.tag === (0, $a0bo1.TABLE_ISSUE) ? {
                issueKey: $efcffc0e5221a0b7$var$getIssueKey(draggedIssue.value.project.key, draggedIssue.value.issueKey, draggedIssue.value.summary),
                projectName: draggedIssue.value.project.name,
                destinationProjectName: parentIssue.value.project.name
            } : undefined
        });
    }
    return {
        anchor: null,
        group: null,
        id: null,
        parentId: null,
        relation: null,
        type: (0, $6b22482c0db9401b$export$6182a67c5764bd0f),
        errorType: null
    };
};
const $efcffc0e5221a0b7$export$39fe38c3caf3e416 = (issues, drop)=>{
    const { type: type, parentId: parentId } = drop;
    let dropRootIndex = 0;
    if ((0, $7CnHa.isDefined)(parentId)) {
        const dropParent = issues.find((issue)=>issue.tag === (0, $a0bo1.TABLE_ISSUE) && issue.value.id === parentId);
        if (dropParent && dropParent.tag === (0, $a0bo1.TABLE_ISSUE)) dropRootIndex = dropParent.value.rootIndex || 0;
    }
    switch(type){
        case 0, $6b22482c0db9401b$export$6182a67c5764bd0f:
            return;
        case 0, $6b22482c0db9401b$export$2c56a3da224d2361:
            return $eEsJ2["drop-invalid-sibling"];
        case 0, $6b22482c0db9401b$export$818ea92c669038b0:
            return dropRootIndex % 2 === 0 ? $eEsJ2["drop-invalid-child-odd"] : $eEsJ2["drop-invalid-child-even"];
        case 0, $6b22482c0db9401b$export$d4ead6ccaed25c5f:
            return $eEsJ2["drop-sibling"];
        case 0, $6b22482c0db9401b$export$56b564d4a01df705:
            return dropRootIndex % 2 === 0 ? $eEsJ2["drop-child-odd"] : $eEsJ2["drop-child-even"];
        default:
            throw new Error(`Unexpected drop type: ${type}`);
    }
};
const $efcffc0e5221a0b7$export$ddc30553f485140a = ()=>{
    const body = (0, $1ni3W.getBody)();
    // Unable to use @ts-expect-error it conflicts with typecheck with project references according to which ts-expect error is not needed and existing typecheck requires it, hence ignoring it till TS project references are enabled
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - error TS2488: Type 'HTMLCollection' must have a '[Symbol.iterator]()' method that returns an iterator.
    for (const node of body.children){
        // Unable to use @ts-expect-error it conflicts with typecheck with project references according to which ts-expect error is not needed and existing typecheck requires it, hence ignoring it till TS project references are enabled
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2339 - Property 'dataset' does not exist on type 'Element'.
        if (node.dataset.issue) return node;
    }
};

});



parcelRegister("aAoN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c027c07a93983090$export$2e2bcd8739ae039);

var $cUGog = parcelRequire("cUGog");
var $c027c07a93983090$export$2e2bcd8739ae039 = (0, $cUGog.default);

});
parcelRegister("cUGog", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2707db494503a0d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hPeQq = parcelRequire("hPeQq");

var $feYIf = parcelRequire("feYIf");
// eslint-disable-next-line jira/react/no-class-components
class $e2707db494503a0d$var$StickyHeaderCell extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps) {
        if (this.props.width !== nextProps.width && this.props.containerId) (0, $hPeQq.manuallyUpdateStickyHeaderWidth)(this.props.containerId, nextProps.width);
        return !nextProps.isDragging;
    }
    render() {
        const { containerId: containerId, isCollapsedField: isCollapsedField } = this.props;
        if (isCollapsedField === true) return null;
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            id: containerId,
            className: $feYIf.portalContainer
        });
    }
}
var $e2707db494503a0d$export$2e2bcd8739ae039 = $e2707db494503a0d$var$StickyHeaderCell;

});


parcelRegister("9JwZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe5a8b8e498652aa$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $il6o4 = parcelRequire("il6o4");

var $gTFwF = parcelRequire("gTFwF");
var $fe5a8b8e498652aa$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $il6o4.default), {})((0, $gTFwF.default));

});
parcelRegister("il6o4", function(module, exports) {

$parcel$export(module.exports, "default", () => $138ddda0105ea48c$export$2e2bcd8739ae039);

var $evo53 = parcelRequire("evo53");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $fnooh = parcelRequire("fnooh");

var $iK4oF = parcelRequire("iK4oF");
var $138ddda0105ea48c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    columns: (0, $fnooh.getColumns),
    viewNamespace: (0, $dBKyg.getNamespaceFromActiveView),
    stickyHeaderGeometry: (0, $evo53.getCurrentStickyHeaderGeometry),
    viewMode: (0, $9H2AP.getViewMode)
});

});

parcelRegister("gTFwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $831fd6549a243cd1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lMaVG = parcelRequire("lMaVG");
var $lcvrv = parcelRequire("lcvrv");

var $5rYNM = parcelRequire("5rYNM");

var $aAoN3 = parcelRequire("aAoN3");

var $feYIf = parcelRequire("feYIf");
// eslint-disable-next-line jira/react/no-class-components
class $831fd6549a243cd1$var$FieldsHeader extends (0, $eUqFw.Component) {
    shouldComponentUpdate(nextProps) {
        return !nextProps.isDragging;
    }
    render() {
        const { columns: columns, width: width, stickyHeaderGeometry: stickyHeaderGeometry, viewNamespace: viewNamespace, viewMode: viewMode, minWidth: minWidth } = this.props;
        const visibleColumns = columns.filter((column)=>column.isVisible);
        if (visibleColumns.length === 0) return null;
        const columnsData = visibleColumns.map((column, index, arr)=>({
                initialWidth: column.defaultWidth,
                minWidth: column.minWidth ?? 24,
                // Last column is flexible to absorb the remaining delta
                isFixed: !(viewMode === (0, $lcvrv.VIEW_MODES).LIST && index === arr.length - 1),
                id: column.id,
                isLoading: column.isLoading,
                collapsible: column.isCollapsible
            }));
        const isViewModeList = viewMode === (0, $lcvrv.VIEW_MODES).LIST;
        const linkToParent = isViewModeList ? undefined : (0, $5rYNM.SECTION_KEYS).MAIN;
        const id = isViewModeList ? (0, $5rYNM.SECTION_KEYS).LIST_FIELD : (0, $5rYNM.SECTION_KEYS).FIELD;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $feYIf.columnHeaderSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default), {
            id: id,
            namespace: viewNamespace,
            // @ts-expect-error - TS2322 - Type '{ id: "fields-section"; namespace: string; sectionRenderer: ({ section, index, isDragging }: SectionRendererArgs) => Element; sectionsData: { initialWidth: number | undefined; minWidth: number; isFixed: boolean; id: string; isLoading: boolean; }[]; width: number; height: number | undefined; minHeight: number; linkTo...' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
            sectionRenderer: this.sectionRenderer,
            sectionsData: columnsData,
            width: width,
            minWidth: minWidth,
            height: stickyHeaderGeometry && stickyHeaderGeometry.height,
            minHeight: (0, $5rYNM.SCOPE_ROW_HEIGHT),
            /**
					 * CAVEAT of 'linkToParent' with 'isFitParent'
					 *
					 * There are three "Fields" sections (sticky-header, header, and columns),
					 * only ONE section should be linked to the parent IF the sections have `isFitParent=false`.
					 *
					 * `isFitParent=false` where the section does not bound by parent's size, the parent's width get updated after the section resized,
					 * this will resulted with multiple cascading updates on the parent section IF multiple sections linked to the same parent.
					 *
					 * */ linkToParent: linkToParent,
            isFitParent: !isViewModeList
        })));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.sectionRenderer = ({ section: section, index: index, isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Item, {
                id: section.id,
                key: `section-${section.id}`,
                index: index,
                width: section.width,
                minWidth: section.minWidth,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClick: ()=>{},
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                setHovered: ()=>{},
                collapsible: section.collapsible
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAoN3.default), {
                isCollapsedField: section.collapsible && section.width === section.minWidth,
                containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-field-${section.id}`,
                isDragging: isDragging,
                width: section.width
            }));
    }
}
var $831fd6549a243cd1$export$2e2bcd8739ae039 = $831fd6549a243cd1$var$FieldsHeader;

});


parcelRegister("1jLma", function(module, exports) {

$parcel$export(module.exports, "default", () => $62be7f54f1fa2375$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kSWBc = parcelRequire("kSWBc");

var $5Gaz6 = parcelRequire("5Gaz6");

var $1UzSd = parcelRequire("1UzSd");
var $62be7f54f1fa2375$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5Gaz6.default), (0, $kSWBc.default))((0, $1UzSd.default));

});
parcelRegister("kSWBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de16db606f2e7eb$export$2e2bcd8739ae039);

var $hHEgb = parcelRequire("hHEgb");
const $4de16db606f2e7eb$var$mapDispatchToProps = (dispatch)=>({
        onTimeScaleCustomDatesChange: (payload)=>{
            dispatch((0, $hHEgb.timeScaleCustomDatesChange)(payload));
        },
        onModeChange: (payload)=>{
            dispatch({
                type: (0, $hHEgb.CHANGE_MODE),
                payload: payload
            });
        }
    });
var $4de16db606f2e7eb$export$2e2bcd8739ae039 = $4de16db606f2e7eb$var$mapDispatchToProps;

});
parcelRegister("hHEgb", function(module, exports) {

$parcel$export(module.exports, "CHANGE_OPTION", () => $9c5c9fc324173723$export$c2b22857fe21a293);
$parcel$export(module.exports, "CHANGE_MODE", () => $9c5c9fc324173723$export$db173bb1aa409c7a);
$parcel$export(module.exports, "CHANGE_CUSTOM_DATES", () => $9c5c9fc324173723$export$7cb96b5c6c3151af);
$parcel$export(module.exports, "timeScaleCustomDatesChange", () => $9c5c9fc324173723$export$92d52f3066b84deb);
const $9c5c9fc324173723$export$c2b22857fe21a293 = 'state.domain.view-settings.time-scale.CHANGE_OPTION';
const $9c5c9fc324173723$export$db173bb1aa409c7a = 'state.domain.view-settings.time-scale.CHANGE_MODE';
const $9c5c9fc324173723$export$7cb96b5c6c3151af = 'state.domain.view-settings.time-scale.CHANGE_CUSTOM_DATES';
const $9c5c9fc324173723$export$844b1a4452aa5be2 = (payload)=>({
        type: $9c5c9fc324173723$export$db173bb1aa409c7a,
        payload: payload
    });
const $9c5c9fc324173723$export$92d52f3066b84deb = (payload)=>({
        type: $9c5c9fc324173723$export$7cb96b5c6c3151af,
        payload: payload
    });

});


parcelRegister("5Gaz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4951e3eb8be859c$export$2e2bcd8739ae039);

var $aMoMC = parcelRequire("aMoMC");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
const $d4951e3eb8be859c$var$getInitialCustomDateRangePure = ({ start: start, end: end })=>({
        fromDate: start,
        toDate: end
    });
const $d4951e3eb8be859c$var$getInitialCustomDateRange = (0, $iK4oF.createSelector)([
    (0, $aMoMC.getTimelineRange)
], $d4951e3eb8be859c$var$getInitialCustomDateRangePure);
const $d4951e3eb8be859c$export$a53beca3bcfc33c1 = (state)=>({
        customDateRange: (0, $9H2AP.getTimeScaleViewSettings)(state).customDateRange,
        initialCustomDateRange: $d4951e3eb8be859c$var$getInitialCustomDateRange(state),
        mode: (0, $9H2AP.getTimeScaleViewSettings)(state).mode
    });
var $d4951e3eb8be859c$export$2e2bcd8739ae039 = $d4951e3eb8be859c$export$a53beca3bcfc33c1;

});

parcelRegister("1UzSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $279d89bb14bb1358$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Ai5n = parcelRequire("1Ai5n");parcelRequire("9IIas");
var $kmfT1 = parcelRequire("kmfT1");

var $dw8TK = parcelRequire("dw8TK");

var $5rYNM = parcelRequire("5rYNM");

var $gY9iQ = parcelRequire("gY9iQ");

const $279d89bb14bb1358$var$LazyTimelineModeSwitcher = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6Unth")).then(({ TimelineModeSwitcher: TimelineModeSwitcher })=>TimelineModeSwitcher), {
    moduleId: "./src/packages/aais/timeline-toolbar/src/index.tsx"
});
function $279d89bb14bb1358$export$2e2bcd8739ae039({ mode: mode = (0, $5rYNM.TIMELINE_MODES).MONTHS, onModeChange: onModeChange, customDateRange: customDateRange = {}, initialCustomDateRange: initialCustomDateRange = {}, onTimeScaleCustomDatesChange: onTimeScaleCustomDatesChange }) {
    const intl = (0, $5JgJ2.default)();
    const [isCustomRangeDialogOpen, setCustomRangeDialogOpen] = (0, $eUqFw.useState)(false);
    const onItemClicked = (0, $eUqFw.useCallback)((value)=>{
        if (value === (0, $5rYNM.TIMELINE_MODES).CUSTOM) {
            setCustomRangeDialogOpen((prev)=>!prev);
            return;
        }
        onModeChange(value);
    }, [
        onModeChange
    ]);
    const onCustomDatesApplied = (range)=>{
        setCustomRangeDialogOpen(false);
        onTimeScaleCustomDatesChange(range);
        onModeChange((0, $5rYNM.TIMELINE_MODES).CUSTOM, range);
    };
    const getCustomRangeText = (0, $eUqFw.useCallback)(()=>{
        const { fromDate: fromDate, toDate: toDate, typeOfCustomDateRange: typeOfCustomDateRange } = customDateRange;
        if (typeOfCustomDateRange === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).RELATIVE) {
            const { start: start, end: end } = (0, $17L5s.getRelativeDates)(customDateRange, new Date());
            return (0, $kmfT1.getStringFromDates)(start, end, intl);
        }
        return (0, $kmfT1.getStringFromDates)(fromDate, toDate, intl);
    }, [
        customDateRange,
        intl
    ]);
    const changeToWeeks = (0, $eUqFw.useCallback)(()=>{
        onItemClicked((0, $5rYNM.TIMELINE_MODES).WEEKS);
    }, [
        onItemClicked
    ]);
    const changeToMonths = (0, $eUqFw.useCallback)(()=>{
        onItemClicked((0, $5rYNM.TIMELINE_MODES).MONTHS);
    }, [
        onItemClicked
    ]);
    const changeToQuarters = (0, $eUqFw.useCallback)(()=>{
        onItemClicked((0, $5rYNM.TIMELINE_MODES).QUARTERS);
    }, [
        onItemClicked
    ]);
    const changeToYears = (0, $eUqFw.useCallback)(()=>{
        onItemClicked((0, $5rYNM.TIMELINE_MODES).YEARS);
    }, [
        onItemClicked
    ]);
    const changeToCustomRange = (0, $eUqFw.useCallback)(()=>{
        onItemClicked((0, $5rYNM.TIMELINE_MODES).CUSTOM);
    }, [
        onItemClicked
    ]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const changeMode = (mode)=>{
        switch(mode){
            case (0, $5rYNM.TIMELINE_MODES).WEEKS:
                onItemClicked((0, $5rYNM.TIMELINE_MODES).WEEKS);
                break;
            case (0, $5rYNM.TIMELINE_MODES).MONTHS:
                onItemClicked((0, $5rYNM.TIMELINE_MODES).MONTHS);
                break;
            case (0, $5rYNM.TIMELINE_MODES).QUARTERS:
                onItemClicked((0, $5rYNM.TIMELINE_MODES).QUARTERS);
                break;
            case (0, $5rYNM.TIMELINE_MODES).YEARS:
                onItemClicked((0, $5rYNM.TIMELINE_MODES).YEARS);
                break;
            case (0, $5rYNM.TIMELINE_MODES).CUSTOM:
                onItemClicked((0, $5rYNM.TIMELINE_MODES).CUSTOM);
                break;
            default:
                break;
        }
    };
    const modes = (0, $eUqFw.useMemo)(()=>[
            {
                type: (0, $5rYNM.TIMELINE_MODES).WEEKS,
                title: (0, $gY9iQ.default).timescaleWeeks,
                keyBoardShortcut: 'W'
            },
            {
                type: (0, $5rYNM.TIMELINE_MODES).MONTHS,
                title: (0, $gY9iQ.default).timescaleMonths,
                keyBoardShortcut: 'M'
            },
            {
                type: (0, $5rYNM.TIMELINE_MODES).QUARTERS,
                title: (0, $gY9iQ.default).timescaleQuarters,
                keyBoardShortcut: 'Q'
            },
            {
                type: (0, $5rYNM.TIMELINE_MODES).YEARS,
                title: (0, $gY9iQ.default).timescaleYears,
                keyBoardShortcut: 'Y'
            },
            {
                type: (0, $5rYNM.TIMELINE_MODES).CUSTOM,
                title: (0, $gY9iQ.default).timescaleCustom,
                buttonTitle: getCustomRangeText(),
                keyBoardShortcut: 'X',
                group: 'Custom'
            }
        ], [
        getCustomRangeText
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            width: "84px",
            height: "32px"
        }),
        name: "lazy-timeline-mode-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($279d89bb14bb1358$var$LazyTimelineModeSwitcher, {
        modes: modes,
        onModeChange: changeMode,
        currentMode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyW",
        onKeyDown: changeToWeeks
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyM",
        onKeyDown: changeToMonths
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyQ",
        onKeyDown: changeToQuarters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyY",
        onKeyDown: changeToYears
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyX",
        onKeyDown: changeToCustomRange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isCustomRangeDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        width: "716px",
        autoFocus: false,
        onClose: ()=>setCustomRangeDialogOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, intl.formatMessage((0, $gY9iQ.default).modalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Ai5n.CustomDateRangeModalContent), {
        dateRange: $b3iuB.default(customDateRange) ? initialCustomDateRange : customDateRange,
        onConfirm: onCustomDatesApplied,
        onCancel: ()=>setCustomRangeDialogOpen(false)
    })))));
}

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $PdmhA).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1kwx _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Ai5n", function(module, exports) {

$parcel$export(module.exports, "CustomDateRangeModalContent", () => $7aa1679b5346ad66$export$93b481e4f8de5dc1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");
var $eTbtL = parcelRequire("eTbtL");parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");
var $7oRrE = parcelRequire("7oRrE");

var $jirW3 = parcelRequire("jirW3");

var $co3rr = parcelRequire("co3rr");

var $9IIas = parcelRequire("9IIas");
var $kmfT1 = parcelRequire("kmfT1");
const $7aa1679b5346ad66$export$93b481e4f8de5dc1 = ({ dateRange: dateRange, showTodayIndicator: showTodayIndicator, onConfirm: onConfirm, onCancel: onCancel, onSelectedTabChange: onSelectedTabChange })=>{
    const { fromDate: fromDate, fromNowUnit: fromNowUnit = (0, $eTbtL.DateUnits).MONTHS, fromNowUnitCount: fromNowUnitCount = 2, toDate: toDate, toNowUnitCount: toNowUnitCount = 1, toNowUnit: toNowUnit = (0, $eTbtL.DateUnits).MONTHS, typeOfCustomDateRange: typeOfCustomDateRange = (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED } = dateRange;
    const [activeTabId, setActiveTabId] = (0, $eUqFw.useState)(typeOfCustomDateRange);
    const [fromNowUnitState, setFromNowUnit] = (0, $eUqFw.useState)(fromNowUnit);
    const [toNowUnitState, setToNowUnit] = (0, $eUqFw.useState)(toNowUnit);
    const [fromNowUnitCountState, setFromNowUnitCount] = (0, $eUqFw.useState)(fromNowUnitCount);
    const [toNowUnitCountState, setToNowUnitCount] = (0, $eUqFw.useState)(toNowUnitCount);
    const [fromDateState, setFromDate] = (0, $eUqFw.useState)(fromDate || Date.now());
    const [toDateState, setToDate] = (0, $eUqFw.useState)(toDate || Date.now()); // eslint-disable-next-line @typescript-eslint/no-shadow
    const isValidDateRange = (fromDate, toDate)=>fromDate != null && toDate != null && new Date(fromDate) <= new Date(toDate);
    const [isValid, setIsValidDateRange] = (0, $eUqFw.useState)(isValidDateRange(fromDateState, toDateState));
    const [isInvalidFormat, setInvalidFormat] = (0, $eUqFw.useState)(false);
    const onTabSelect = (selectedTab)=>{
        setActiveTabId(selectedTab.id);
        if (onSelectedTabChange) onSelectedTabChange();
    };
    const onApplyClicked = (0, $eUqFw.useCallback)(()=>{
        if (activeTabId === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED) {
            onConfirm({
                fromDate: fromDateState,
                toDate: toDateState,
                typeOfCustomDateRange: activeTabId
            });
            return;
        }
        const customDateRange = {
            toNowUnit: toNowUnitState,
            fromNowUnit: fromNowUnitState,
            typeOfCustomDateRange: activeTabId
        };
        if (toNowUnitCount != null) customDateRange.toNowUnitCount = Math.max(0, Math.round(toNowUnitCountState));
        if (fromNowUnitCount != null) customDateRange.fromNowUnitCount = Math.max(0, Math.round(fromNowUnitCountState));
        onConfirm(customDateRange);
    }, [
        activeTabId,
        fromDateState,
        fromNowUnitCount,
        fromNowUnitCountState,
        fromNowUnitState,
        onConfirm,
        toDateState,
        toNowUnitCount,
        toNowUnitCountState,
        toNowUnitState
    ]);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const onFixedDateRangeChange = (0, $eUqFw.useCallback)((fromDate, toDate)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const isValid = isValidDateRange(fromDate, toDate);
        setIsValidDateRange(isValid);
        setFromDate(fromDate);
        setToDate(toDate);
    }, []);
    const onRelativeValuesChange = (0, $eUqFw.useCallback)((value, key)=>{
        if (typeof value === 'number') switch(key){
            case 'fromNowUnitCount':
                setFromNowUnitCount(value);
                break;
            case 'toNowUnitCount':
                setToNowUnitCount(value);
                break;
            default:
        }
        else if (typeof value === 'string') switch(key){
            case 'fromNowUnit':
                setFromNowUnit(value);
                break;
            case 'toNowUnit':
                setToNowUnit(value);
                break;
            default:
        }
    }, []);
    const tabs = (0, $eUqFw.useMemo)(()=>[
            {
                id: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $co3rr.default).fixedTabLabel),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.time-scale.custom-modal-content.tabs.fixed',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jirW3.default), {
                    onChange: onFixedDateRangeChange,
                    fromDate: fromDateState,
                    toDate: toDateState,
                    isValidDateRange: isValid,
                    setInvalidFormat: setInvalidFormat
                })
            },
            {
                id: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).RELATIVE,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $co3rr.default).relativeTabLabel),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.time-scale.custom-modal-content.tabs.relative',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9IIas.default), {
                    toNowUnitCount: toNowUnitCountState,
                    fromNowUnitCount: fromNowUnitCountState,
                    toNowUnit: toNowUnitState,
                    fromNowUnit: fromNowUnitState,
                    onRelativeValuesChange: onRelativeValuesChange,
                    showTodayIndicator: showTodayIndicator
                })
            }
        ], [
        fromDateState,
        fromNowUnitCountState,
        fromNowUnitState,
        isValid,
        onFixedDateRangeChange,
        onRelativeValuesChange,
        showTodayIndicator,
        toDateState,
        toNowUnitCountState,
        toNowUnitState
    ]);
    const selectedTab = tabs.find((tab)=>tab.id === activeTabId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7oRrE.default), {
        tabs: tabs,
        onSelect: onTabSelect,
        selected: selectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7aa1679b5346ad66$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "portfolio-3-custom-date-range.ui.modal-content.cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $co3rr.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        isDisabled: !isValid && activeTabId === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED || isInvalidFormat,
        onClick: onApplyClicked,
        testId: "portfolio-3-custom-date-range.ui.modal-content.submit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $co3rr.default).apply))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7aa1679b5346ad66$var$ButtonGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _18s8r2fv _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7oRrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c070883f9ac19ecc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");
var $emR29 = parcelRequire("emR29");

var $51PzL = parcelRequire("51PzL");
function $c070883f9ac19ecc$export$2e2bcd8739ae039(props) {
    const selectedTabIndex = props.tabs.findIndex((tab)=>tab && tab.id === props.selected?.id);
    const curatedSelectedTabIndex = selectedTabIndex === -1 ? 0 : selectedTabIndex;
    const defaultSelectedTabIndex = props.tabs.findIndex((tab)=>tab && tab.id === props.defaultSelected?.id);
    const curatedDefaultSelectedTabIndex = defaultSelectedTabIndex === -1 ? 0 : defaultSelectedTabIndex;
    const handleChange = (index, analyticsEvent)=>{
        const tab = props.tabs[index];
        props.onSelect && props.onSelect(tab, index, analyticsEvent);
    };
    const tabs = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $51PzL["tabs-container"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
            ...props,
            selected: props.selected ? curatedSelectedTabIndex : undefined,
            defaultSelected: props.defaultSelected ? curatedDefaultSelectedTabIndex : undefined,
            onChange: handleChange,
            id: "portfolio-common-tabs",
            shouldUnmountTabPanelOnChange: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, props.tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
                testId: tab?.testId,
                key: index
            }, tab?.label))), props.tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $emR29.default), {
                key: index
            }, tab?.content))));
    return props.direction === 'column' ? tabs() : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $51PzL["tabs-row-wrapper"]
    }, tabs());
}
$c070883f9ac19ecc$export$2e2bcd8739ae039.defaultProps = {
    direction: 'column'
};

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: undefined,
    packageVersion: undefined
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

var $PdmhA = parcelRequire("PdmhA");
const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    activeLabelColor: `var(--ds-text, ${(0, $PdmhA.B500)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $PdmhA.N30)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            $b552637a2f5925a8$var$tabListStyles
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("emR29", function(module, exports) {

$parcel$export(module.exports, "default", () => $854be789e89981e2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $kgCsd = parcelRequire("kgCsd");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $854be789e89981e2$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $854be789e89981e2$export$2e2bcd8739ae039 = $854be789e89981e2$var$TabPanel;

});

parcelRegister("51PzL", function(module, exports) {

$parcel$export(module.exports, "tabs-container", () => $3a950da33a11cde6$export$47009996fffeb3bc, (v) => $3a950da33a11cde6$export$47009996fffeb3bc = v);
$parcel$export(module.exports, "tabs-row-wrapper", () => $3a950da33a11cde6$export$14ca765001cc894e, (v) => $3a950da33a11cde6$export$14ca765001cc894e = v);
var $3a950da33a11cde6$export$47009996fffeb3bc;
var $3a950da33a11cde6$export$14ca765001cc894e;
$3a950da33a11cde6$export$47009996fffeb3bc = `pakj-q_tabs-container`;
$3a950da33a11cde6$export$14ca765001cc894e = `pakj-q_tabs-row-wrapper`;

});


parcelRegister("jirW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $650fe4800bb6c1c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");

var $7jPhn = parcelRequire("7jPhn");

var $dBelL = parcelRequire("dBelL");

var $alFId = parcelRequire("alFId");

var $2YHVS = parcelRequire("2YHVS");
const $650fe4800bb6c1c8$var$FixedDateRange = ({ fromDate: fromDate, toDate: toDate, isValidDateRange: isValidDateRange, onChange: onChange, setInvalidFormat: setInvalidFormat })=>{
    const [startDate, setStartDate] = (0, $eUqFw.useState)(new Date(fromDate));
    const [endDate, setEndDate] = (0, $eUqFw.useState)(new Date(toDate));
    const [startInvalid, setStartInvalid] = (0, $eUqFw.useState)(false);
    const [endInvalid, setEndInvalid] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setInvalidFormat(startInvalid || endInvalid);
    }, [
        startInvalid,
        endInvalid,
        setInvalidFormat
    ]);
    const onStartCalendarSelect = ({ iso: iso })=>{
        if (iso !== undefined) {
            const newStartDate = new Date(iso);
            setStartDate(newStartDate);
            onChange(newStartDate.getTime(), endDate.getTime());
            setStartInvalid(false);
        }
    };
    const onEndCalendarSelect = ({ iso: iso })=>{
        if (iso !== undefined) {
            const newEndDate = new Date(iso);
            setEndDate(newEndDate);
            onChange(startDate.getTime(), newEndDate.getTime());
            setEndInvalid(false);
        }
    };
    const onStartInputChange = (date)=>{
        setStartDate(date);
        onChange(date.getTime(), endDate.getTime());
    };
    const onEndInputChange = (date)=>{
        setEndDate(date);
        onChange(startDate.getTime(), date.getTime());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($650fe4800bb6c1c8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($650fe4800bb6c1c8$var$ColumnContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $alFId.default), {
        id: "date-range-input-start-date",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2YHVS.default).from),
        date: startDate,
        onChange: onStartInputChange,
        setInvalidFormat: setStartInvalid
    }), !isValidDateRange && !startInvalid && !endInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($650fe4800bb6c1c8$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2YHVS.default).startDateAfterEndDateErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dBelL.default), {
        date: startDate,
        onSelect: onStartCalendarSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($650fe4800bb6c1c8$var$ColumnContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $alFId.default), {
        id: "date-range-input-end-date",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2YHVS.default).to),
        date: endDate,
        onChange: onEndInputChange,
        setInvalidFormat: setEndInvalid
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dBelL.default), {
        date: endDate,
        onSelect: onEndCalendarSelect
    })));
};
var $650fe4800bb6c1c8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $650fe4800bb6c1c8$var$FixedDateRange;
const $650fe4800bb6c1c8$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _zulppxbi _1amj1bp4 _guasidpf _p1lu1bp4 _wfzokb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $650fe4800bb6c1c8$var$ColumnContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $650fe4800bb6c1c8$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4h8dc _19pk10v4 _otyr1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dBelL", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae89bce393172df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gSA5V = parcelRequire("gSA5V");

var $g4Vkx = parcelRequire("g4Vkx");
var $l2Sj2 = parcelRequire("l2Sj2");
var $17L5s = parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");

var $4xHig = parcelRequire("4xHig");
const $eae89bce393172df$var$CalendarInput = ({ date: date, onSelect: onSelect })=>{
    const [month, setMonth] = (0, $eUqFw.useState)(date.getMonth());
    const [year, setYear] = (0, $eUqFw.useState)(date.getFullYear());
    const locale = (0, $4xHig.useLocale)();
    const weekStartDay = (0, $17L5s.getWeekStartDay)(locale);
    (0, $eUqFw.useEffect)(()=>{
        setMonth(date.getMonth());
        setYear(date.getFullYear());
    }, [
        date
    ]);
    const onChange = (event, _)=>{
        if (event.type === 'prev') {
            if (month === 0) {
                setMonth(11);
                setYear(year - 1);
            } else setMonth(month - 1);
        } else if (event.type === 'next') {
            if (month === 11) {
                setMonth(0);
                setYear(year + 1);
            } else setMonth(month + 1);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eae89bce393172df$var$CalendarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSA5V.default), {
        selected: [
            (0, $l2Sj2.formatDateUTC)(date.getTime(), (0, $eTbtL.IsoDateFormat))
        ],
        month: month + 1,
        year: year,
        onSelect: onSelect,
        onChange: onChange,
        day: 0,
        weekStartDay: weekStartDay,
        locale: locale
    }));
};
var $eae89bce393172df$export$2e2bcd8739ae039 = $eae89bce393172df$var$CalendarInput;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eae89bce393172df$var$CalendarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1oynm9n": (0, $9t7rW.default)((0, $g4Vkx.default).N50A),
            "--_kxj3ud": (0, $9t7rW.default)((0, $g4Vkx.default).N40A)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _16qss898 _2rko1l7b",
            __cmplp.className
        ])
    });
});

});

parcelRegister("alFId", function(module, exports) {

$parcel$export(module.exports, "default", () => $764d933057c82bc5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");

var $kMHOY = parcelRequire("kMHOY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");

var $4LhB6 = parcelRequire("4LhB6");
var $l2Sj2 = parcelRequire("l2Sj2");
var $lIePH = parcelRequire("lIePH");


var $j8hTC = parcelRequire("j8hTC");
// DD/MM/YYYY
const $764d933057c82bc5$var$DATE_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
const $764d933057c82bc5$var$isValidFormat = (dateString)=>$764d933057c82bc5$var$DATE_REGEX.test(dateString);
const $764d933057c82bc5$var$DateInput = ({ id: id, label: label, date: date, onChange: onChange, setInvalidFormat: setInvalidFormat })=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const formatDate = (date)=>(0, $l2Sj2.formatDateUTC)(date.getTime(), (0, $1bc6dfb88f72fc12$export$43fa8699f5b8d098));
    const [value, setValue] = (0, $eUqFw.useState)(formatDate(date));
    const setDateValue = (e)=>{
        const newDateString = e.target.value;
        setValue(newDateString);
        if ($764d933057c82bc5$var$isValidFormat(newDateString)) {
            // At this point newDateString is 'DD/MM/YYYY'
            const parts = newDateString.split('/');
            const newDate = new Date(Date.UTC(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10)));
            setInvalidFormat(false);
            onChange(newDate);
        } else setInvalidFormat(true);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (date) {
            setValue(formatDate(date));
            setInvalidFormat(false);
        }
    }, [
        date,
        setInvalidFormat
    ]);
    const getInvalidFormatMessage = ()=>{
        if (!$764d933057c82bc5$var$isValidFormat(value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $j8hTC.default).wrongFormatErrorMessageLocalised));
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        id: id,
        label: label,
        name: "command",
        defaultValue: ""
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIePH.default), {
            id: id,
            testId: "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.date-input.date-input",
            onChange: setDateValue,
            value: value,
            placeholder: (0, $1bc6dfb88f72fc12$export$43fa8699f5b8d098),
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $764d933057c82bc5$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                label: "Calendar Icon"
            })),
            "aria-describedby": "date-input-field-validation-error-message"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($764d933057c82bc5$var$ErrorMessageWrapper, {
        id: "date-input-field-validation-error-message"
    }, getInvalidFormatMessage()));
};
var $764d933057c82bc5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $764d933057c82bc5$var$DateInput;
const $764d933057c82bc5$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4h8dc _19pk1b66 _4t3igktf",
            __cmplp.className
        ])
    });
});
const $764d933057c82bc5$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});

});
const $1bc6dfb88f72fc12$export$43fa8699f5b8d098 = 'DD/MM/YYYY';

parcelRegister("j8hTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a6fbcf6f2d3a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a3a6fbcf6f2d3a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    wrongFormatErrorMessageLocalised: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.date-input.wrong-format-error-message-localised",
        "defaultMessage": "Date format should be DD/MM/YYYY"
    }
});

});


parcelRegister("2YHVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $541520994a730732$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $541520994a730732$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    from: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.from",
        "defaultMessage": "Start date"
    },
    to: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.to",
        "defaultMessage": "End date"
    },
    startDateAfterEndDateErrorMessage: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-date-range.start-date-after-end-date-error-message",
        "defaultMessage": "Start date must be before end date"
    }
});

});


parcelRegister("co3rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7ace9fe219fe1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad7ace9fe219fe1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fixedTabLabel: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.fixed-tab-label",
        "defaultMessage": "Fixed"
    },
    relativeTabLabel: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-tab-label",
        "defaultMessage": "Relative"
    },
    apply: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.apply",
        "defaultMessage": "Apply"
    },
    cancel: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("9IIas", function(module, exports) {

$parcel$export(module.exports, "default", () => $379131d74a8b04e2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getStringFromDates", () => (parcelRequire("kmfT1")).getStringFromDates);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
var $4LhB6 = parcelRequire("4LhB6");

var $ftyq6 = parcelRequire("ftyq6");

var $kmfT1 = parcelRequire("kmfT1");
const $379131d74a8b04e2$var$ToOrFrom = {
    TO: 'to',
    FROM: 'from'
};
const $379131d74a8b04e2$var$getSelectOptions = (count, intl)=>[
        {
            value: (0, $eTbtL.DateUnits).WEEKS,
            label: intl.formatMessage((0, $ftyq6.default).weeks, {
                count: count
            })
        },
        {
            value: (0, $eTbtL.DateUnits).MONTHS,
            label: intl.formatMessage((0, $ftyq6.default).months, {
                count: count
            })
        }
    ];
const $379131d74a8b04e2$var$RelativeDateRange = ({ fromNowUnit: fromNowUnit = (0, $eTbtL.DateUnits).WEEKS, fromNowUnitCount: fromNowUnitCount = 0, intl: intl, onRelativeValuesChange: onRelativeValuesChange, showTodayIndicator: showTodayIndicator = true, toNowUnit: toNowUnit = (0, $eTbtL.DateUnits).WEEKS, toNowUnitCount: toNowUnitCount = 0 })=>{
    /**
     We make the max value relative to the chosen unit (10 years)
     We also ensure that the user cannot type a negative
     This function acts as validation so we don't need `max`
     or `isInvalid` on our field components any more
     */ const validateCount = (0, $eUqFw.useCallback)((toOrFrom, value)=>{
        const maxValuesMap = {
            [(0, $eTbtL.DateUnits).DAYS]: 3650,
            [(0, $eTbtL.DateUnits).WEEKS]: 520,
            [(0, $eTbtL.DateUnits).MONTHS]: 120
        };
        const index = toOrFrom === $379131d74a8b04e2$var$ToOrFrom.TO ? toNowUnit : fromNowUnit;
        const max = maxValuesMap[index];
        return Math.min(max, Math.abs(Number(value)));
    }, [
        toNowUnit,
        fromNowUnit
    ]);
    const onChangeCount = (0, $eUqFw.useCallback)(({ target: { name: name, value: value } })=>{
        const toOrFrom = name === 'toNowUnitCount' ? $379131d74a8b04e2$var$ToOrFrom.TO : $379131d74a8b04e2$var$ToOrFrom.FROM;
        const val = validateCount(toOrFrom, value);
        onRelativeValuesChange(Number(val), name);
    }, [
        onRelativeValuesChange,
        validateCount
    ]);
    const onBlurCount = (0, $eUqFw.useCallback)((e)=>{
        const { name: name, value: valueStr } = e.currentTarget;
        const val = Math.round(parseFloat(valueStr));
        onRelativeValuesChange(val, name);
    }, [
        onRelativeValuesChange
    ]);
    const onChangeUnit = (0, $eUqFw.useCallback)((value, name)=>{
        if (value && !Array.isArray(value)) onRelativeValuesChange(value.value, name);
    }, [
        onRelativeValuesChange
    ]);
    const getSelectValue = (0, $eUqFw.useCallback)((currentValue, count)=>$379131d74a8b04e2$var$getSelectOptions(count, intl).find(({ value: value })=>value === currentValue), [
        intl
    ]);
    const relativeRange = (0, $eUqFw.useCallback)(()=>{
        const { start: start, end: end } = (0, $17L5s.getRelativeDates)({
            toNowUnitCount: toNowUnitCount,
            fromNowUnitCount: fromNowUnitCount,
            toNowUnit: toNowUnit,
            fromNowUnit: fromNowUnit
        }, new Date());
        return (0, $kmfT1.getStringFromDates)(start, end, intl);
    }, [
        fromNowUnit,
        fromNowUnitCount,
        intl,
        toNowUnit,
        toNowUnitCount
    ]); // Revalidate the unit counts when units (weeks/months) change
    (0, $eUqFw.useEffect)(()=>{
        const toVal = validateCount($379131d74a8b04e2$var$ToOrFrom.TO, toNowUnitCount);
        if (toVal !== toNowUnitCount) onRelativeValuesChange(toVal, 'toNowUnitCount');
        const fromVal = validateCount($379131d74a8b04e2$var$ToOrFrom.FROM, fromNowUnitCount);
        if (fromVal !== fromNowUnitCount) onRelativeValuesChange(fromVal, 'fromNowUnitCount');
    }, [
        toNowUnit,
        fromNowUnit,
        toNowUnitCount,
        fromNowUnitCount,
        onRelativeValuesChange,
        validateCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$RelativeDateRangeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$ColumnsContainer, {
        showTodayIndicator: showTodayIndicator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.to-now"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: intl.formatMessage((0, $ftyq6.default).toNowHeader),
        name: "toNowUnitCount"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            min: 0,
            name: "toNowUnitCount",
            onBlur: onBlurCount,
            onChange: onChangeCount,
            type: "number",
            value: toNowUnitCount.toString(),
            width: 60
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            isTransparentBackground: false,
            isClearable: false,
            options: $379131d74a8b04e2$var$getSelectOptions(toNowUnitCount, intl),
            value: getSelectValue(toNowUnit, toNowUnitCount),
            onChange: (option)=>onChangeUnit(option, 'toNowUnit'),
            classNamePrefix: "relative-time-range-to-now-select"
        })))))), showTodayIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$NowBarColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: intl.formatMessage((0, $ftyq6.default).todayLabel),
        name: "todayLabel"
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$NowBar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$NowLine, {
            topOffset: 40
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.from-now"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: intl.formatMessage((0, $ftyq6.default).fromNowHeader),
        name: "fromNowUnitCount"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            min: 0,
            name: "fromNowUnitCount",
            onBlur: onBlurCount,
            onChange: onChangeCount,
            type: "number",
            value: fromNowUnitCount.toString(),
            width: 60
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            classNamePrefix: "relative-time-range-from-now-select",
            isClearable: false,
            isTransparentBackground: false,
            onChange: (option)=>onChangeUnit(option, 'fromNowUnit'),
            options: $379131d74a8b04e2$var$getSelectOptions(fromNowUnitCount, intl),
            value: getSelectValue(fromNowUnit, fromNowUnitCount)
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.selected-time-range"
    }, intl.formatMessage((0, $ftyq6.default).timeRangeText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($379131d74a8b04e2$var$TimeRange, null, relativeRange())));
};
var $379131d74a8b04e2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($379131d74a8b04e2$var$RelativeDateRange);
const $379131d74a8b04e2$var$MARKER_LINE_WIDTH = 2;
const $379131d74a8b04e2$var$POINTER_WIDTH = 8; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$RelativeDateRangeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbkbql",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$Column = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulpu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$TimeRange = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p8n31",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$NowBar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iymf6 _1ltv1ssb _19pkukr8 _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $379131d74a8b04e2$var$NowLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topOffset: topOffset, noMarker: noMarker, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2iu6vl": (0, $9t7rW.default)(__cmplp.topOffset, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5idpf _1pbyegat _lcxvglyw _1bsbyh40 _1kl74oj4 _1kt9b3bt _1cs81if8 _kfgtidpf _1mp4idpf _1aukidpf _fntn1lpd _1n1j12me _1c9r12me _1pq8m65w",
            __cmplp.topOffset ? "_154i1rwy" : "_154iidpf",
            __cmplp.noMarker ? "_cfu1glyw" : "_cfu11ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$SelectWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul968cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$ColumnsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showTodayIndicator: showTodayIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _n3tdpxbi _1uo31ch8",
            __cmplp.showTodayIndicator ? "_zulpxy5q" : "_zulpoahv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $379131d74a8b04e2$var$NowBarColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1yt4otz2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ftyq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25dc2aa159617ed0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $25dc2aa159617ed0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    weeks: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.weeks",
        "defaultMessage": "{count, plural, one {Week} other {Weeks}}"
    },
    months: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.months",
        "defaultMessage": "{count, plural, one {Month} other {Months}}"
    },
    toNowHeader: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.to-now-header",
        "defaultMessage": "Show the past"
    },
    fromNowHeader: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.from-now-header",
        "defaultMessage": "Show the next"
    },
    timeRangeText: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.time-range-text",
        "defaultMessage": "Selected time range is "
    },
    todayLabel: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.today-label",
        "defaultMessage": "Today"
    },
    timescaleCustom: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-custom",
        "defaultMessage": "Custom"
    },
    timescaleFrom: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-from",
        "defaultMessage": "From {fromDate}"
    },
    timescaleTo: {
        "id": "portfolio-3-custom-date-range.ui.modal-content.relative-time-range.timescale-to",
        "defaultMessage": "To {toDate}"
    }
});

});

parcelRegister("kmfT1", function(module, exports) {

$parcel$export(module.exports, "getStringFromDates", () => $4b9c8641c974179e$export$ee3a0e6ec0a19206);

var $l2Sj2 = parcelRequire("l2Sj2");
var $eTbtL = parcelRequire("eTbtL");

var $ftyq6 = parcelRequire("ftyq6");
const $4b9c8641c974179e$export$60248f42f43df209 = (date, intl)=>{
    if (typeof date === 'number') return (0, $l2Sj2.formatTimestampWithIntl)(intl, date, (0, $eTbtL.shortDateFormat));
    return date;
};
const $4b9c8641c974179e$export$ee3a0e6ec0a19206 = (fromDateTimestamp, toDateTimestamp, intl)=>{
    if (fromDateTimestamp && toDateTimestamp) return `${$4b9c8641c974179e$export$60248f42f43df209(fromDateTimestamp, intl)} \u{2013} ${$4b9c8641c974179e$export$60248f42f43df209(toDateTimestamp, intl)}`;
    if (fromDateTimestamp) return intl.formatMessage((0, $ftyq6.default).timescaleFrom, {
        fromDate: $4b9c8641c974179e$export$60248f42f43df209(fromDateTimestamp, intl)
    });
    if (toDateTimestamp) return intl.formatMessage((0, $ftyq6.default).timescaleTo, {
        toDate: $4b9c8641c974179e$export$60248f42f43df209(toDateTimestamp, intl)
    });
    return intl.formatMessage((0, $ftyq6.default).timescaleCustom);
};

});



parcelRegister("gY9iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $88a4c8ba33624044$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $88a4c8ba33624044$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timescaleCustom: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-custom",
        "defaultMessage": "Custom"
    },
    timescaleCustomRange: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-custom-range",
        "defaultMessage": "Custom range"
    },
    timescaleFrom: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-from",
        "defaultMessage": "From {fromDate}"
    },
    timescaleTo: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-to",
        "defaultMessage": "To {toDate}"
    },
    timescaleWeeks: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-weeks",
        "defaultMessage": "Weeks"
    },
    timescaleMonths: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-months",
        "defaultMessage": "Months"
    },
    timescaleQuarters: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-quarters",
        "defaultMessage": "Quarters"
    },
    timescaleYears: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.timescale-years",
        "defaultMessage": "Years"
    },
    modalHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.time-scale.modal-header",
        "defaultMessage": "Select custom date range"
    }
});

});

parcelRegister("6Unth", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('7Ww1i')
        ]);
        const value = parcelRequire('1Zf6X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("7Ww1i")
    ]).then(()=>parcelRequire('1Zf6X'));
}

});



parcelRegister("k1Cxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf6e894cb0e0879$export$2e2bcd8739ae039);
parcelRequire("2ZiOh");
var $eJkeb = parcelRequire("eJkeb");

var $lNNXV = parcelRequire("lNNXV");

var $3Q7Pm = parcelRequire("3Q7Pm");

var $e5G3v = parcelRequire("e5G3v");

var $7mf6D = parcelRequire("7mf6D");
var $ebf6e894cb0e0879$export$2e2bcd8739ae039 = (0, $eJkeb.default)((0, $lNNXV.connect)((0, $3Q7Pm.default), {})((0, $e5G3v.default)), 'portfolio-3.simple-plans.roadmap.timeline-column');

});
parcelRegister("3Q7Pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe5bf669f4dae70$export$2e2bcd8739ae039);

var $aMoMC = parcelRequire("aMoMC");
const $7fe5bf669f4dae70$var$mapStateToProps = (state, props)=>({
        width: (0, $aMoMC.getTimelineContainerWidth)(state, props.width)
    });
var $7fe5bf669f4dae70$export$2e2bcd8739ae039 = $7fe5bf669f4dae70$var$mapStateToProps;

});

parcelRegister("e5G3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $524374dff3c0a5bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");
parcelRequire("enlJQ");
var $jjPWu = parcelRequire("jjPWu");

var $a4vO3 = parcelRequire("a4vO3");

var $hPeQq = parcelRequire("hPeQq");

var $1r0yV = parcelRequire("1r0yV");

var $aYhWi = parcelRequire("aYhWi");

var $7Ssod = parcelRequire("7Ssod");

var $9FyNo = parcelRequire("9FyNo");

var $fFww5 = parcelRequire("fFww5");
const $524374dff3c0a5bc$var$ChooseAxis = ()=>{
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    return zoomLevel === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1r0yV.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Ssod.default), null);
};
class $524374dff3c0a5bc$export$e6a97ba2cae5bb94 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            Axis: $524374dff3c0a5bc$var$ChooseAxis,
            NowLine: $9FyNo.default,
            Schedule: $fFww5.default,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onExperienceSuccess: ()=>{}
        };
    }
    componentDidMount() {
        this.props.onExperienceSuccess();
    }
    shouldComponentUpdate(nextProps) {
        if (nextProps.isDragging && this.props.width !== nextProps.width && this.containerRef.current) (0, $hPeQq.manuallyUpdateReactVirtualizedListWidth)(this.containerRef.current, nextProps.width);
        // update the first time isDragging is true
        if (nextProps.isDragging && !this.props.isDragging) return true;
        return !nextProps.isDragging;
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { Axis: Axis, NowLine: NowLine, Schedule: Schedule, scrollElement: scrollElement, width: width, isDragging: isDragging, leftSidebarWidth: leftSidebarWidth } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.containerRef,
            className: $aYhWi.timeline,
            "aria-hidden": true
        }, (0, $jjPWu.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Axis, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Schedule, {
            scrollElement: scrollElement,
            width: width,
            isDragging: isDragging,
            NowLine: NowLine,
            leftSidebarWidth: leftSidebarWidth
        })));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/sort-comp
        this.containerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
}
var $524374dff3c0a5bc$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    NowLine: (0, $a4vO3.slots).NowLine
})($524374dff3c0a5bc$export$e6a97ba2cae5bb94);

});
parcelRegister("1r0yV", function(module, exports) {

$parcel$export(module.exports, "default", () => $15dcaa9b51f82372$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kWFbl = parcelRequire("kWFbl");

var $9GU6o = parcelRequire("9GU6o");
var $15dcaa9b51f82372$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $kWFbl.default), {})((0, $9GU6o.default));

});
parcelRegister("kWFbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84b62aa897a0574$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
var $e84b62aa897a0574$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    timelineRange: (0, $aMoMC.getTimelineRange),
    fiscalMonth: (0, $dhHiZ.getFiscalMonth)
});

});

parcelRegister("9GU6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e895ffd38210996$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $17L5s = parcelRequire("17L5s");

var $aMoMC = parcelRequire("aMoMC");

var $5rYNM = parcelRequire("5rYNM");

var $3EaMD = parcelRequire("3EaMD");
// eslint-disable-next-line jira/react/no-class-components
class $7e895ffd38210996$var$TimelineAxis extends (0, $eUqFw.Component) {
    render() {
        const { timelineRange: { start: timelineRangeStart, end: timelineRangeEnd }, fiscalMonth: fiscalMonth } = this.props;
        const daysInRange = (timelineRangeEnd - timelineRangeStart) / (0, $17L5s.ONE_DAY);
        const dayUnits = (0, $aMoMC.getDayUnits)(timelineRangeStart, daysInRange);
        let timeline = [];
        // this aligns with the infinite axis "weeks" behaviour
        if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).SMALL) timeline = this.getWeeksTimeline(dayUnits);
        else if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).MEDIUM) timeline = this.getMonthsTimeline(dayUnits);
        else if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).LARGE) {
            const quarterUnits = (0, $aMoMC.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            timeline = this.getQuartersTimeline(quarterUnits);
        // this aligns with the infinite axis "years" behaviour
        } else {
            const yearUnits = (0, $aMoMC.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
            timeline = this.getYearsTimeline(yearUnits);
        }
        if (timeline.length) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3EaMD.main
        }, timeline);
        return null;
    }
    constructor(...args){
        super(...args);
        this.getWeeksTimeline = (dayUnits)=>dayUnits.map(({ widthPercentage: widthPercentage }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $3EaMD.withRightBorder,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        boxSizing: 'border-box',
                        width: `${widthPercentage}%`
                    }
                }));
        this.getMonthsTimeline = (dayUnits)=>dayUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
                const nextDate = new Date(startTime + (0, $17L5s.ONE_DAY));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: // right border is rendered on last day of month
                    nextDate.getUTCDate() === 1 ? $3EaMD.withRightBorder : '',
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        boxSizing: 'border-box',
                        width: `${widthPercentage}%`
                    }
                });
            });
        this.getQuartersTimeline = (quarterUnits)=>quarterUnits.map(({ widthPercentage: widthPercentage }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    // right border is rendered on each quarter
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $3EaMD.withRightBorder,
                    style: {
                        width: `${widthPercentage}%`
                    }
                }));
        this.getYearsTimeline = (yearUnits)=>yearUnits.map(({ widthPercentage: widthPercentage }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    key: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.axis.${index}`,
                    // right border is rendered on each year
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $3EaMD.withRightBorder,
                    style: {
                        width: `${widthPercentage}%`
                    }
                }));
    }
}
var $7e895ffd38210996$export$2e2bcd8739ae039 = $7e895ffd38210996$var$TimelineAxis;

});
parcelRegister("3EaMD", function(module, exports) {

$parcel$export(module.exports, "main", () => $2a7d78e4e869f1ab$export$f22da7240b7add18, (v) => $2a7d78e4e869f1ab$export$f22da7240b7add18 = v);
$parcel$export(module.exports, "withRightBorder", () => $2a7d78e4e869f1ab$export$2396557442884da8, (v) => $2a7d78e4e869f1ab$export$2396557442884da8 = v);
var $2a7d78e4e869f1ab$export$f22da7240b7add18;
var $2a7d78e4e869f1ab$export$2396557442884da8;
$2a7d78e4e869f1ab$export$f22da7240b7add18 = `cVvj2G_main`;
$2a7d78e4e869f1ab$export$2396557442884da8 = `cVvj2G_withRightBorder`;

});



parcelRegister("aYhWi", function(module, exports) {

$parcel$export(module.exports, "timeline", () => $7fcd6c56c3c1d192$export$cddc5598d4bb8461, (v) => $7fcd6c56c3c1d192$export$cddc5598d4bb8461 = v);
var $7fcd6c56c3c1d192$export$cddc5598d4bb8461;
$7fcd6c56c3c1d192$export$cddc5598d4bb8461 = `S5aJwG_timeline`;

});

parcelRegister("7Ssod", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0daea42169cd45a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $caL2q = parcelRequire("caL2q");

var $f3cBg = parcelRequire("f3cBg");
var $b0daea42169cd45a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $caL2q.default), {})((0, $f3cBg.default));

});
parcelRegister("caL2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb7618373247793$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");
const $7cb7618373247793$var$mapStateToProps = (state)=>({
        fiscalMonth: (0, $dhHiZ.getFiscalMonth)(state)
    });
var $7cb7618373247793$export$2e2bcd8739ae039 = $7cb7618373247793$var$mapStateToProps;

});

parcelRegister("f3cBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c771b72ee15bed5a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");

var $1okLb = parcelRequire("1okLb");

var $dasxK = parcelRequire("dasxK");

var $f96x3 = parcelRequire("f96x3");

var $kXCE0 = parcelRequire("kXCE0");
function $c771b72ee15bed5a$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
    const [{ getPercentageOffset: getPercentageOffset }] = (0, $jODJR.useHorizontalPercentageOffset)();
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [{ today: today, from: from, to: to }] = (0, $jODJR.useRenderingWindow)();
    if (!zoomLevel) return null;
    let units = [];
    const timeUnits = (0, $kXCE0.getUnits)({
        from: from,
        to: to
    }, zoomLevel, fiscalMonth);
    const todayColumnIndex = (0, $1okLb.getTodayColumnIndex)(timeUnits);
    units = timeUnits.map((unit, index)=>{
        const date = new Date(today + unit.from);
        const offset = getPercentageOffset(unit.from);
        const width = getPercentageOffset(unit.to) - offset;
        const isTodayColumn = index === todayColumnIndex;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f96x3.default), {
            key: date.getTime(),
            left: `${offset}%`,
            width: `${width}%`,
            isHighlighted: isTodayColumn
        });
    });
    if (units.length) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dasxK.infiniteAxisTimeline
    }, units);
    return null;
}

});
parcelRegister("1okLb", function(module, exports) {

$parcel$export(module.exports, "getTodayColumnIndex", () => $33ab3f61a3134c46$export$ce237023318dfe05);
const $33ab3f61a3134c46$export$ce237023318dfe05 = (ranges)=>ranges.findIndex(({ from: from, to: to })=>from <= 0 && to > 0);

});

parcelRegister("dasxK", function(module, exports) {

$parcel$export(module.exports, "infiniteAxisTimeline", () => $996259a188ca65f7$export$ccad1b38568d5a6b, (v) => $996259a188ca65f7$export$ccad1b38568d5a6b = v);
var $996259a188ca65f7$export$ccad1b38568d5a6b;
$996259a188ca65f7$export$ccad1b38568d5a6b = `W3EHoW_infiniteAxisTimeline`;

});

parcelRegister("f96x3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8f8a9461d83af31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $hWxrQ = parcelRequire("hWxrQ");
const $a8f8a9461d83af31$var$InfiniteAxisUnit = ({ left: left, width: width, isHighlighted: isHighlighted })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($hWxrQ.unit, {
            [$hWxrQ.highlighted]: isHighlighted
        }),
        style: {
            left: left,
            width: width
        }
    });
var $a8f8a9461d83af31$export$2e2bcd8739ae039 = $a8f8a9461d83af31$var$InfiniteAxisUnit;

});
parcelRegister("hWxrQ", function(module, exports) {

$parcel$export(module.exports, "highlighted", () => $d101cc862f28673a$export$ba6acb6e4dfd83c2, (v) => $d101cc862f28673a$export$ba6acb6e4dfd83c2 = v);
$parcel$export(module.exports, "unit", () => $d101cc862f28673a$export$523c0b569236b342, (v) => $d101cc862f28673a$export$523c0b569236b342 = v);
var $d101cc862f28673a$export$ba6acb6e4dfd83c2;
var $d101cc862f28673a$export$523c0b569236b342;
$d101cc862f28673a$export$ba6acb6e4dfd83c2 = `Z6eima_highlighted`;
$d101cc862f28673a$export$523c0b569236b342 = `Z6eima_unit`;

});


parcelRegister("kXCE0", function(module, exports) {

$parcel$export(module.exports, "getDayUnits", () => $8b4d1c80744bb80a$export$bc6ab2cf11089d43);
$parcel$export(module.exports, "getUnits", () => $8b4d1c80744bb80a$export$94a11c5658544737);

var $17L5s = parcelRequire("17L5s");
/** Makes timeline units.
 * @param from the offset (in ms) of the start of the rendering window considering today as origin.
 * @param to the offset (in ms) of the end of the rendering window considering today as origin.
 * @param initialize a function to get the initial start date of first unit base on the current estimated start date of the rendering window.
 * @param next a function to get the next unit's start date from the current unit start date.
 */ const $8b4d1c80744bb80a$var$makeUnits = ({ from: from, to: to }, type, initialize, next)=>{
    const today = (0, $17L5s.startOfUtcDay)(Date.now());
    const fromTs = today + from;
    const toTs = today + to;
    let dateCursor = new Date(fromTs);
    dateCursor.setUTCHours(0, 0, 0, 0);
    dateCursor = initialize(dateCursor);
    const units = [];
    while(dateCursor.getTime() < toTs){
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const from = dateCursor.getTime() - today;
        dateCursor = next(dateCursor);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const to = dateCursor.getTime() - today;
        units.push({
            from: from,
            to: to,
            type: type
        });
    }
    return units;
};
const $8b4d1c80744bb80a$export$bc6ab2cf11089d43 = ({ from: from, to: to })=>{
    const initialize = (date)=>new Date(date.getTime() - (date.getUTCDay() - 1) * (0, $17L5s.ONE_DAY)); // Reset to Monday of the week
    const next = (date)=>new Date(date.getTime() + (0, $17L5s.ONE_DAY));
    return $8b4d1c80744bb80a$var$makeUnits({
        from: from,
        to: to
    }, 'week', initialize, next);
};
/** Gets timeline units to render weeks within the rendering window. */ const $8b4d1c80744bb80a$var$getWeekUnits = ({ from: from, to: to })=>{
    const initialize = (date)=>new Date(date.getTime() - (date.getUTCDay() - 1) * (0, $17L5s.ONE_DAY)); // Reset to Monday of the week
    const next = (date)=>new Date(date.getTime() + (0, $17L5s.ONE_WEEK));
    return $8b4d1c80744bb80a$var$makeUnits({
        from: from,
        to: to
    }, 'week', initialize, next);
};
/** Gets timeline units to render months within the rendering window. */ const $8b4d1c80744bb80a$var$getMonthUnits = ({ from: from, to: to })=>{
    const initialize = (date)=>{
        date.setUTCDate(1); // Reset to 1st of the month
        return date;
    };
    const next = (date)=>{
        date.setUTCMonth(date.getUTCMonth() + 1, 1);
        return date;
    };
    return $8b4d1c80744bb80a$var$makeUnits({
        from: from,
        to: to
    }, 'month', initialize, next);
};
/** Gets timeline units to render quarters within the rendering window. */ const $8b4d1c80744bb80a$var$getQuarterUnits = ({ from: from, to: to }, fiscalMonth)=>{
    const offset = fiscalMonth - 1;
    const initialize = (date)=>{
        const dateMonth = date.getUTCMonth();
        // setting the date to the first day of the quarter it belongs to
        // e.g. if date is "Wed Jun 09 2021", it gets converted to "Thu Apr 01 2021"
        date.setUTCMonth(dateMonth - dateMonth % 3 + offset, 1);
        if (fiscalMonth > 1) {
            // if our FY starts after january, we'll always need to see a portion of the previous calendar year
            const dateYear = date.getUTCFullYear();
            date.setUTCFullYear(dateYear - 1);
        }
        return date;
    };
    const next = (date)=>{
        date.setUTCMonth(date.getUTCMonth() + 3, 1);
        return date;
    };
    return $8b4d1c80744bb80a$var$makeUnits({
        from: from,
        to: to
    }, 'quarter', initialize, next);
};
/** Gets timeline units to render years within the rendering window. */ const $8b4d1c80744bb80a$var$getYearUnits = ({ from: from, to: to }, fiscalMonth)=>{
    const initialize = (date)=>{
        // setting the date to the first day of the year
        date.setUTCMonth(fiscalMonth - 1, 1);
        if (fiscalMonth > 1) {
            const dateYear = date.getUTCFullYear();
            date.setUTCFullYear(dateYear - 1);
        }
        return date;
    };
    const next = (date)=>{
        date.setUTCFullYear(date.getUTCFullYear() + 1);
        return date;
    };
    return $8b4d1c80744bb80a$var$makeUnits({
        from: from,
        to: to
    }, 'year', initialize, next);
};
const $8b4d1c80744bb80a$export$94a11c5658544737 = ({ from: from, to: to }, zoomLevel, fiscalMonth = 1)=>{
    switch(zoomLevel){
        case 'weeks':
            return $8b4d1c80744bb80a$var$getWeekUnits({
                from: from,
                to: to
            });
        case 'months':
            return $8b4d1c80744bb80a$var$getMonthUnits({
                from: from,
                to: to
            });
        case 'quarters':
            return $8b4d1c80744bb80a$var$getQuarterUnits({
                from: from,
                to: to
            }, fiscalMonth);
        case 'years':
            return $8b4d1c80744bb80a$var$getYearUnits({
                from: from,
                to: to
            }, fiscalMonth);
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return zoomLevel;
    }
};

});



parcelRegister("9FyNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b80af83cccdd0f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $95gPO = parcelRequire("95gPO");

var $kwJG0 = parcelRequire("kwJG0");
var $86b80af83cccdd0f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $95gPO.default), {})((0, $kwJG0.default));

});
parcelRegister("95gPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d5c67dfba88073$export$2e2bcd8739ae039);

var $1ybV0 = parcelRequire("1ybV0");

var $17L5s = parcelRequire("17L5s");
var $9FEvp = parcelRequire("9FEvp");
var $dulT0 = parcelRequire("dulT0");
var $3jYzf = parcelRequire("3jYzf");

var $akhOi = parcelRequire("akhOi");

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
const $e3d5c67dfba88073$export$195ac24e17449cb1 = (timelineRange)=>{
    const { start: start, end: end } = timelineRange;
    const startDate = new Date(start);
    const endDate = new Date(end);
    const todayDate = (0, $aMoMC.getTodayDate)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let staticAxisPosition = {};
    // "today" might not necessarily be in the selected custom date range and should not be rendered if that's the case
    if (todayDate.getTime() < startDate.getTime() || todayDate.getTime() > endDate.getTime()) return staticAxisPosition;
    const totalDays = (end - start) / (0, $17L5s.ONE_DAY);
    let startTime = start;
    const widthUnit = 100 / totalDays;
    let width = 0;
    for(let day = 0; day < Math.round(totalDays); day++){
        if ((0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') && (0, $dulT0.default)((0, $3jYzf.default)(startTime), (0, $3jYzf.default)((0, $9FEvp.default)(todayDate, (0, $17L5s.dateDiffFromUTC)())))) {
            staticAxisPosition = {
                offset: width,
                widthPercentage: widthUnit
            };
            break;
        } else if (!(0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') && (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(startTime), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime()))) {
            staticAxisPosition = {
                offset: width,
                widthPercentage: widthUnit
            };
            break;
        }
        startTime += (0, $17L5s.ONE_DAY);
        width += widthUnit;
    }
    return staticAxisPosition;
};
var // eslint-disable-next-line @typescript-eslint/no-shadow
$e3d5c67dfba88073$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $aMoMC.getTimelineRange),
    (0, $akhOi.isExportMode)
], (timelineRange, isExportMode)=>({
        isExportMode: isExportMode,
        staticAxisPosition: $e3d5c67dfba88073$export$195ac24e17449cb1(timelineRange)
    }));

});

parcelRegister("kwJG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed1491a731bcc36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $1ybV0 = parcelRequire("1ybV0");

var $17L5s = parcelRequire("17L5s");

var $jODJR = parcelRequire("jODJR");

var $jODJR = parcelRequire("jODJR");
parcelRequire("areZp");
var $4j1D2 = parcelRequire("4j1D2");
var $areZp = parcelRequire("areZp");

var $4MCXQ = parcelRequire("4MCXQ");
function $4ed1491a731bcc36$export$2e2bcd8739ae039({ isExportMode: isExportMode = false, noMarker: noMarker = false, showInCustomRangeDialog: showInCustomRangeDialog = false, staticAxisPosition: staticAxisPosition = {}, topOffset: topOffset = 0 }) {
    const [{ getPercentageOffset: getPercentageOffset }] = (0, $jODJR.useHorizontalPercentageOffset)();
    const [container] = (0, $jODJR.useContainer)();
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    if (isExportMode) // Don't render now line in export mode as it only renders on the group headings and not on the issue rows
    return null;
    // Consider remove this function when cleaning up com.atlassian.rm.jpo.transposition.m2
    const withZIndexOverride = (children)=>{
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $areZp.ZIndex), {
            layer: (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS
        }, (zIndex)=>children(zIndex ?? 'initial'));
    };
    // this is the now line rendered when the timeline mode is "weeks", "months", "quarters", or "years"
    if ((0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') && zoomLevel) {
        const offsetInMs = (0, $17L5s.dateDiffFromUTC)() * (0, $17L5s.ONE_DAY);
        const todayOffset = getPercentageOffset(offsetInMs);
        const width = getPercentageOffset(offsetInMs + (0, $17L5s.ONE_DAY)) - todayOffset;
        return withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
                // note: the "marker" style renders a triangle on top of the NowLine
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${$4MCXQ.nowLine} ${!noMarker ? $4MCXQ.marker : ''}`,
                style: {
                    left: `calc(${todayOffset}% + ${container.width * (width / 100) / 2}px)`,
                    top: topOffset,
                    zIndex: zIndex
                }
            }));
    }
    // this is the now line rendered when the timeline mode is "weeks", "months", "quarters", or "years"
    if (!(0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') && zoomLevel) {
        const todayOffset = getPercentageOffset(0);
        const width = getPercentageOffset((0, $17L5s.ONE_DAY)) - todayOffset;
        return withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
                // note: the "marker" style renders a triangle on top of the NowLine
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${$4MCXQ.nowLine} ${!noMarker ? $4MCXQ.marker : ''}`,
                style: {
                    left: `calc(${todayOffset}% + ${container.width * (width / 100) / 2}px)`,
                    top: topOffset,
                    zIndex: zIndex
                }
            }));
    }
    // this is the now line rendered when the timeline mode is a custom fixed / relative date range
    if (!$b3iuB.default(staticAxisPosition)) {
        const { offset: offset = 0, widthPercentage: widthPercentage = 0 } = staticAxisPosition;
        return withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $4MCXQ.nowLineStaticAxisWrapper,
                style: {
                    left: `calc(${offset}% + ${"var(--ds-space-025, 2px)"})`,
                    width: `${widthPercentage}%`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $4MCXQ.nowLineStaticAxisSubWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // note: the "marker" style renders a triangle on top of the NowLine
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${$4MCXQ.nowLine} ${!noMarker ? $4MCXQ.marker : ''}`,
                style: {
                    top: topOffset,
                    zIndex: zIndex
                }
            }))));
    }
    // this is the now line rendered in the custom relative date range modal dialog
    if (showInCustomRangeDialog) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.now",
        // note: the "marker" style renders a triangle on top of the NowLine
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$4MCXQ.nowLine} ${!noMarker ? $4MCXQ.marker : ''}`,
        style: {
            top: topOffset
        }
    });
    return null;
}

});
parcelRegister("areZp", function(module, exports) {

$parcel$export(module.exports, "ZIndex", () => $9815afac0deead9c$export$ccb31788083e2069);
$parcel$export(module.exports, "Z_INDEX_LAYER", () => (parcelRequire("4j1D2")).Z_INDEX_LAYER);
$parcel$export(module.exports, "Z_INDEX_LEVEL", () => (parcelRequire("4j1D2")).Z_INDEX_LEVEL);

var $lNNXV = parcelRequire("lNNXV");

var $aeYxd = parcelRequire("aeYxd");

var $jjsrE = parcelRequire("jjsrE");

var $4j1D2 = parcelRequire("4j1D2");
const $9815afac0deead9c$export$ccb31788083e2069 = (0, $lNNXV.connect)((0, $aeYxd.mapStateToProps), {})((0, $jjsrE.ZIndex));

});
parcelRegister("aeYxd", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $8cfa5742d4d332c5$export$c31df4bd766f9c35);

var $lcvrv = parcelRequire("lcvrv");

var $cB5vz = parcelRequire("cB5vz");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");

var $4j1D2 = parcelRequire("4j1D2");
const $8cfa5742d4d332c5$export$b3b4bb28e7752964 = (0, $iK4oF.createSelector)([
    (0, $cB5vz.getRowConfigs)
], (rows)=>rows.length);
const $8cfa5742d4d332c5$export$a3141f11a33b8412 = (0, $iK4oF.createSelector)([
    (0, $cB5vz.getColumnConfigs)
], (columns)=>columns.length);
const $8cfa5742d4d332c5$var$STATIC_LEVEL_SIZE = 4;
const $8cfa5742d4d332c5$var$BUFFER_SIZE = 1;
const $8cfa5742d4d332c5$export$a381c346af83af6b = (numOfColumns, numOfRows, rowSticky, viewMode, props)=>{
    const lift = (level)=>(input)=>{
            const levelSize = numOfColumns + $8cfa5742d4d332c5$var$BUFFER_SIZE * 2;
            const levelsBelow = level * levelSize;
            const offset = input + $8cfa5742d4d332c5$var$BUFFER_SIZE;
            return offset + levelsBelow + $8cfa5742d4d332c5$var$STATIC_LEVEL_SIZE;
        };
    if ('layer' in props) switch(props.layer){
        case (0, $4j1D2.Z_INDEX_LAYER).DEPENDENCY_LINES:
            return 1;
        case (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS:
            return 2;
        case (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS_ARROWS:
        case (0, $4j1D2.Z_INDEX_LAYER).HORIZONTAL_SCROLL_BAR:
        case (0, $4j1D2.Z_INDEX_LAYER).DEPENDENCY_LINE_DRAG_PREVIEW:
            return 3;
        case (0, $4j1D2.Z_INDEX_LAYER).AXIS_STICKY_TIME_UNIT:
            return lift((0, $4j1D2.Z_INDEX_LEVEL).TOP)(0); // Above the header cells
        case (0, $4j1D2.Z_INDEX_LAYER).STICKY_HEADER_SCROLL_SHADOW:
            return lift((0, $4j1D2.Z_INDEX_LEVEL).SUBHEADER)(-1); // Just under the subheader cells
        case (0, $4j1D2.Z_INDEX_LAYER).EMPTY_LIST_OVERLAY:
            return lift((0, $4j1D2.Z_INDEX_LEVEL).SUBHEADER)(-1);
        case (0, $4j1D2.Z_INDEX_LAYER).STICKY_GROUP_SCROLL_SHADOW:
            return lift((0, $4j1D2.Z_INDEX_LEVEL).STICKY)(-1); // Just under the sticky cells
        default:
            return 0;
    }
    const { column: column, row: row, level: level } = props;
    const isTimelineColumn = viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE && column === numOfColumns - 1;
    const reversedColumnIndex = numOfColumns - 1 - column;
    if (row === 0) return lift((0, $4j1D2.Z_INDEX_LEVEL).HEADER)(reversedColumnIndex);
    if (row === 1) return lift((0, $4j1D2.Z_INDEX_LEVEL).SUBHEADER)(reversedColumnIndex);
    if (rowSticky[row]) return lift((0, $4j1D2.Z_INDEX_LEVEL).STICKY)(reversedColumnIndex);
    if (isTimelineColumn) return undefined;
    return lift(level ?? (0, $4j1D2.Z_INDEX_LEVEL).DEFAULT)(reversedColumnIndex);
};
const $8cfa5742d4d332c5$export$9b544f58430fc883 = (0, $iK4oF.createSelector)([
    $8cfa5742d4d332c5$export$a3141f11a33b8412,
    $8cfa5742d4d332c5$export$b3b4bb28e7752964,
    (0, $cB5vz.getRowStickiness),
    (0, $9H2AP.getViewMode),
    (state, props)=>props
], $8cfa5742d4d332c5$export$a381c346af83af6b);
const $8cfa5742d4d332c5$export$c31df4bd766f9c35 = (0, $iK4oF.createSelector)([
    $8cfa5742d4d332c5$export$9b544f58430fc883
], (zIndex)=>({
        zIndex: zIndex
    }));

});
parcelRegister("cB5vz", function(module, exports) {

$parcel$export(module.exports, "getGridRows", () => $12c342dd60f35ba4$export$b531a3ef4fb1113d);
$parcel$export(module.exports, "getGridColumns", () => $12c342dd60f35ba4$export$ab08dbb7cfffe453);
$parcel$export(module.exports, "getRowStickiness", () => $12c342dd60f35ba4$export$e41e433b8c65f966);
$parcel$export(module.exports, "getRowConfigs", () => $12c342dd60f35ba4$export$4918fac776f5200a);
$parcel$export(module.exports, "getColumnConfigs", () => $12c342dd60f35ba4$export$14116e8b59cd31f0);
$parcel$export(module.exports, "getScrollIntoViewIndex", () => $12c342dd60f35ba4$export$fcc1492b8a57487d);

var $lcvrv = parcelRequire("lcvrv");

var $kKj1m = parcelRequire("kKj1m");

var $dhHiZ = parcelRequire("dhHiZ");

var $a0bo1 = parcelRequire("a0bo1");

var $9H2AP = parcelRequire("9H2AP");

var $lf4fN = parcelRequire("lf4fN");

var $iK4oF = parcelRequire("iK4oF");

const $12c342dd60f35ba4$export$8e70bc0367277c1f = (tableItems)=>tableItems.map(({ tag: tag })=>tag);
const $12c342dd60f35ba4$export$24e035b0c9cee763 = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getTableItems)
], $12c342dd60f35ba4$export$8e70bc0367277c1f);
const $12c342dd60f35ba4$export$a79f133f7fa6b821 = (tags)=>[
        {
            tag: (0, $457029be46121cb6$export$526a1e214ba17198)
        },
        {
            tag: (0, $457029be46121cb6$export$a64a0028232151aa)
        },
        ...tags.map((itemTag, index)=>({
                tag: (0, $457029be46121cb6$export$867af8e076780d5d),
                payload: {
                    itemIndex: index,
                    itemTag: itemTag
                }
            }))
    ];
const $12c342dd60f35ba4$export$b531a3ef4fb1113d = (0, $iK4oF.createSelector)([
    $12c342dd60f35ba4$export$24e035b0c9cee763
], $12c342dd60f35ba4$export$a79f133f7fa6b821);
const $12c342dd60f35ba4$export$ae4998afe12f8a46 = (viewMode, { columns: columnStates }, customFields, atlasConnectInstalled)=>{
    // Custom field columns could be added and then removed from a plan, so we filter the available columns
    const columns = columnStates.filter((column)=>{
        if (column.id === 'goal' && !atlasConnectInstalled) return false;
        return ((0, $lf4fN.isColumnId)(column.id) || customFields.some((field)=>`${field.id}` === column.id)) && column.isVisible;
    }).map((column)=>({
            tag: (0, $457029be46121cb6$export$d6f887e0c1be1b74),
            payload: column
        }));
    return [
        {
            tag: (0, $457029be46121cb6$export$1c5a554c78c0cd12)
        },
        ...columns,
        ...viewMode === (0, $lcvrv.VIEW_MODES).LIST ? [
            {
                tag: (0, $457029be46121cb6$export$5a619ff7a6fbfc2c)
            }
        ] : [],
        ...viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE && columns.length === 0 ? [
            {
                tag: (0, $457029be46121cb6$export$ccb33e29d92c9a58)
            }
        ] : [],
        ...viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? [
            {
                tag: (0, $457029be46121cb6$export$4f4c16e273d7a49d)
            }
        ] : []
    ];
};
const $12c342dd60f35ba4$export$ab08dbb7cfffe453 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getViewMode),
    (0, $9H2AP.getFieldColumnsViewSettingsByViewMode),
    (0, $kKj1m.getSupportedCustomFields),
    (0, $dhHiZ.isAtlasConnectInstalled)
], $12c342dd60f35ba4$export$ae4998afe12f8a46);
const $12c342dd60f35ba4$export$31fead638f9b51b8 = (gridRows)=>gridRows.map((row)=>row.tag === (0, $457029be46121cb6$export$526a1e214ba17198) || row.tag === (0, $457029be46121cb6$export$a64a0028232151aa) || row.payload.itemTag === (0, $a0bo1.TABLE_GROUP));
const $12c342dd60f35ba4$export$e41e433b8c65f966 = (0, $iK4oF.createSelector)([
    $12c342dd60f35ba4$export$b531a3ef4fb1113d
], $12c342dd60f35ba4$export$31fead638f9b51b8);
const $12c342dd60f35ba4$export$12c4e1e8b68e3b99 = (rowsStickiness)=>rowsStickiness.map((sticky, index)=>({
            height: index === 0 ? 50 /** only HEADER got 50px height */  : 40,
            top: index === 0 ? 0 : 50 + (index - 1) * 40,
            thead: [
                0,
                1
            ].includes(index),
            sticky: sticky
        }));
const $12c342dd60f35ba4$export$4918fac776f5200a = (0, $iK4oF.createSelector)([
    $12c342dd60f35ba4$export$e41e433b8c65f966
], $12c342dd60f35ba4$export$12c4e1e8b68e3b99);
const $12c342dd60f35ba4$export$eb6481bf168b8c0b = (viewMode, gridColumns)=>gridColumns.map((column)=>{
        if (column.tag === (0, $457029be46121cb6$export$1c5a554c78c0cd12)) return {
            id: 'scope',
            sticky: true
        };
        if (column.tag === (0, $457029be46121cb6$export$4f4c16e273d7a49d)) return {
            id: 'timeline',
            sticky: false
        };
        if (column.tag === (0, $457029be46121cb6$export$ccb33e29d92c9a58)) return {
            id: 'empty',
            sticky: true
        };
        if (column.tag === (0, $457029be46121cb6$export$5a619ff7a6fbfc2c) && viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE) return {
            id: 'addFields',
            sticky: true
        };
        if (column.tag === (0, $457029be46121cb6$export$5a619ff7a6fbfc2c)) return {
            id: 'addFields',
            sticky: false
        };
        return {
            id: column.payload.id,
            sticky: viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE
        };
    });
const $12c342dd60f35ba4$export$14116e8b59cd31f0 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getViewMode),
    $12c342dd60f35ba4$export$ab08dbb7cfffe453
], $12c342dd60f35ba4$export$eb6481bf168b8c0b);
const $12c342dd60f35ba4$export$8c52e0409988a46a = (index)=>index === undefined ? undefined : index + 2; /* header and sub-header */ 
const $12c342dd60f35ba4$export$fcc1492b8a57487d = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getScrollToIndex)
], $12c342dd60f35ba4$export$8c52e0409988a46a);

});
const $457029be46121cb6$export$526a1e214ba17198 = 'HEADER';
const $457029be46121cb6$export$a64a0028232151aa = 'SUBHEADER';
const $457029be46121cb6$export$867af8e076780d5d = 'TABLE_ITEM';
const $457029be46121cb6$export$1c5a554c78c0cd12 = 'SCOPE';
const $457029be46121cb6$export$5a619ff7a6fbfc2c = 'ADD_FIELDS';
const $457029be46121cb6$export$ccb33e29d92c9a58 = 'EMPTY';
const $457029be46121cb6$export$d6f887e0c1be1b74 = 'FIELD';
const $457029be46121cb6$export$4f4c16e273d7a49d = 'TIMELINE';


parcelRegister("4j1D2", function(module, exports) {

$parcel$export(module.exports, "Z_INDEX_LEVEL", () => $bd8d6e251272fb3b$export$7a4b3b772ed42462);
$parcel$export(module.exports, "Z_INDEX_LAYER", () => $bd8d6e251272fb3b$export$e01d1c0ad4a0aead);
const $bd8d6e251272fb3b$export$7a4b3b772ed42462 = {
    TOP: 5,
    HEADER: 4,
    SUBHEADER: 3,
    STICKY: 2,
    FOCUSED: 1,
    DEFAULT: 0
};
const $bd8d6e251272fb3b$export$e01d1c0ad4a0aead = {
    AXIS_STICKY_TIME_UNIT: 'AXIS_STICKY_TIME_UNIT',
    DEPENDENCY_LINES: 'DEPENDENCY_LINES',
    ISSUE_BARS: 'ISSUE_BARS',
    ISSUE_BARS_ARROWS: 'ISSUE_BARS_ARROWS',
    DEPENDENCY_LINE_DRAG_PREVIEW: 'DEPENDENCY_LINE_DRAG_PREVIEW',
    STICKY_HEADER_SCROLL_SHADOW: 'STICKY_HEADER_SCROLL_SHADOW',
    EMPTY_LIST_OVERLAY: 'EMPTY_LIST_OVERLAY',
    STICKY_GROUP_SCROLL_SHADOW: 'STICKY_GROUP_SCROLL_SHADOW',
    HORIZONTAL_SCROLL_BAR: 'HORIZONTAL_SCROLL_BAR'
};

});


parcelRegister("jjsrE", function(module, exports) {

$parcel$export(module.exports, "ZIndex", () => $98ec1a19ed7255f8$export$ccb31788083e2069);
const $98ec1a19ed7255f8$export$ccb31788083e2069 = ({ children: children, zIndex: zIndex })=>children(zIndex);

});


parcelRegister("4MCXQ", function(module, exports) {

$parcel$export(module.exports, "marker", () => $37b9de9e13f3eb13$export$ffc4d0086f1a4c9, (v) => $37b9de9e13f3eb13$export$ffc4d0086f1a4c9 = v);
$parcel$export(module.exports, "nowLine", () => $37b9de9e13f3eb13$export$f96e531e4f621bc9, (v) => $37b9de9e13f3eb13$export$f96e531e4f621bc9 = v);
$parcel$export(module.exports, "nowLineStaticAxisSubWrapper", () => $37b9de9e13f3eb13$export$78ae15454ce25516, (v) => $37b9de9e13f3eb13$export$78ae15454ce25516 = v);
$parcel$export(module.exports, "nowLineStaticAxisWrapper", () => $37b9de9e13f3eb13$export$a799fcb3eca512fe, (v) => $37b9de9e13f3eb13$export$a799fcb3eca512fe = v);
var $37b9de9e13f3eb13$export$ffc4d0086f1a4c9;
var $37b9de9e13f3eb13$export$f96e531e4f621bc9;
var $37b9de9e13f3eb13$export$78ae15454ce25516;
var $37b9de9e13f3eb13$export$a799fcb3eca512fe;
$37b9de9e13f3eb13$export$ffc4d0086f1a4c9 = `Rrwtxa_marker`;
$37b9de9e13f3eb13$export$f96e531e4f621bc9 = `Rrwtxa_nowLine`;
$37b9de9e13f3eb13$export$78ae15454ce25516 = `Rrwtxa_nowLineStaticAxisSubWrapper`;
$37b9de9e13f3eb13$export$a799fcb3eca512fe = `Rrwtxa_nowLineStaticAxisWrapper`;

});



parcelRegister("fFww5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5eae7e995e94e60$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9FT4L = parcelRequire("9FT4L");

var $3YQIt = parcelRequire("3YQIt");

var $hFfrS = parcelRequire("hFfrS");
var $c5eae7e995e94e60$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3YQIt.default), (0, $9FT4L.default))((0, $hFfrS.default));

});
parcelRegister("9FT4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9da53a749999ac$export$2e2bcd8739ae039);

var $dYCPN = parcelRequire("dYCPN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f9da53a749999ac$export$2e2bcd8739ae039 = {
    enableOnlyIssueId: $dYCPN.enableOnlyIssueId
};

});
parcelRegister("dYCPN", function(module, exports) {

$parcel$export(module.exports, "ENABLE_ONLY_ISSUE_ID", () => $d494753d1d2125e1$export$f0e4fb5c8932c441);
$parcel$export(module.exports, "enableOnlyIssueId", () => $d494753d1d2125e1$export$e4830edec3ecb2da);
const $d494753d1d2125e1$export$f0e4fb5c8932c441 = 'state.ui.main.tabs.roadmap.timeline.schedule.ENABLE_ONLY_ISSUE_ID';
const $d494753d1d2125e1$export$e4830edec3ecb2da = (payload)=>({
        type: $d494753d1d2125e1$export$f0e4fb5c8932c441,
        payload: payload
    });

});


parcelRegister("3YQIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $873bd152561249ce$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $a0bo1 = parcelRequire("a0bo1");

var $aMoMC = parcelRequire("aMoMC");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $YHQpz = parcelRequire("YHQpz");

var $iK4oF = parcelRequire("iK4oF");
var $873bd152561249ce$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    dependencySettingsDisplay: (0, $9H2AP.getDependencySettingsDisplay),
    isLoading: (0, $kwMvv.getIsIssuesLoading),
    onlyEnabledIssueId: (0, $aMoMC.getOnlyEnabledIssueId),
    scope: (0, $a0bo1.getTableItems),
    showCapacity: (0, $kyGCj.getShowSprints),
    showWarning: (state)=>(0, $9H2AP.getWarningViewSettings)(state).showWarning,
    timelineRange: (0, $aMoMC.getTimelineRange),
    warnings: (0, $YHQpz.getWarnings),
    zoomLevel: (0, $aMoMC.getZoomLevel)
});

});

parcelRegister("hFfrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $238389d010c740d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $g4Vkx = parcelRequire("g4Vkx");
var $dSEBM = parcelRequire("dSEBM");

var $9Ar1p = parcelRequire("9Ar1p");
var $hoaeP = parcelRequire("hoaeP");

var $aHcVx = parcelRequire("aHcVx");
var $3oQRH = parcelRequire("3oQRH");
parcelRequire("cwMfk");
var $lxd1S = parcelRequire("lxd1S");

var $a0bo1 = parcelRequire("a0bo1");

var $3dOx1 = parcelRequire("3dOx1");

var $9FyNo = parcelRequire("9FyNo");

var $01R8T = parcelRequire("01R8T");

var $4hwn4 = parcelRequire("4hwn4");
parcelRequire("cEecN");
var $2p1Yc = parcelRequire("2p1Yc");

var $57dZR = parcelRequire("57dZR");

var $a4vO3 = parcelRequire("a4vO3");

var $fnOfj = parcelRequire("fnOfj");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $8WuJm = parcelRequire("8WuJm");

var $2yCq2 = parcelRequire("2yCq2");
parcelRequire("8WLEK");
var $3bPMB = parcelRequire("3bPMB");
var $d7aPF = parcelRequire("d7aPF");
var $8mSKC = parcelRequire("8mSKC");
parcelRequire("a76j8");
var $1X7JB = parcelRequire("1X7JB");
var $dBwUe = parcelRequire("dBwUe");
parcelRequire("3Q01T");
var $108fh = parcelRequire("108fh");
parcelRequire("9kZCZ");
var $h0tKx = parcelRequire("h0tKx");
var $9kZCZ = parcelRequire("9kZCZ");

var $dPptc = parcelRequire("dPptc");

var $jHygP = parcelRequire("jHygP");

var $8YyRg = parcelRequire("8YyRg");
const $238389d010c740d6$export$1e2ac07b8385fc57 = (0, $g4Vkx.default).N20_TRANSPARENT;
const $238389d010c740d6$export$db50be146eaa4062 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jHygP.containerSpacer
    });
// eslint-disable-next-line jira/react/no-class-components
class $238389d010c740d6$var$ScheduleComponent extends (0, $eUqFw.Component) {
    static{
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            Row: $9kZCZ.default,
            TimelineReleaseMarker: $4hwn4.default,
            ReleaseBar: $01R8T.default,
            StickyHeader: $3dOx1.default,
            DependencyLinesLayer: $3bPMB.default,
            DependencyLinesProvider: $8mSKC.default,
            NowLine: $9FyNo.default,
            DepLineDragPreviewProvider: $dBwUe.default,
            DependencyLinesLineDetail: $d7aPF.default,
            HorizontalScrollView: $3oQRH.default,
            Arrows: $2yCq2.default
        };
    }
    static{
        this.displayName = 'Schedule';
    }
    static{
        // eslint-disable-next-line react/sort-comp
        this.whyDidYouRender = true;
    }
    componentDidMount() {
        this.forceHandleScroll();
    }
    componentDidUpdate(prevProps) {
        if (this.props.scrollElement !== prevProps.scrollElement || // When zoomLevel changes, the DOM nodes may be shuffled
        this.props.zoomLevel !== prevProps.zoomLevel) this.forceHandleScroll();
        const listRef = this.listRef.current;
        if (listRef && prevProps.scope !== this.props.scope) {
            const length = Math.min(prevProps.scope.length, this.props.scope.length);
            for(let i = 0; i < length; i++)if (prevProps.scope[i].height !== this.props.scope[i].height) {
                listRef.recomputeRowHeights();
                break;
            }
        }
        // hide the dependency lines if we're dragging sections
        if (this.props.dependencySettingsDisplay === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES) {
            if (!prevProps.isDragging && this.props.isDragging) this.setState({
                linesDisabled: true
            });
            if (prevProps.isDragging && !this.props.isDragging) this.setState({
                linesDisabled: false
            });
        }
    }
    forceHandleScroll() {
        // JPOS-2155 Timeline is not rendered until next scrolling event
        // After collapse/expand timeline item position is wrong because starting index for second part of table starts from 0
        // this workaround is for recalculating items position after colapse/expand timeline.
        const ref = this.ref.current;
        if (ref) {
            ref.__handleWindowScrollEvent();
            ref.__resetIsScrolling();
        /* eslint-enable */ }
    }
    render() {
        const { intl: intl, isLoading: isLoading } = this.props;
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSEBM.default), {
            ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage)
        }) : this.getContent();
    }
    constructor(...args){
        super(...args);
        this.state = {
            startIndex: 0,
            stopIndex: Infinity,
            overscanStartIndex: 0,
            overscanStopIndex: Infinity,
            linesDisabled: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.listRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.disableOtherRows = (issueId)=>{
            this.props.enableOnlyIssueId(issueId);
            if (this.props.dependencySettingsDisplay === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES) this.setState({
                linesDisabled: true
            });
        };
        this.reEnableOtherRows = ()=>{
            this.props.enableOnlyIssueId();
            if (this.props.dependencySettingsDisplay === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES) this.setState({
                linesDisabled: false
            });
        };
        this.getWarningsForAnIssue = (issueId)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            this.props.warnings.byIssue[issueId] || [];
        this.createRowForIssue = (issue, index, topOffset)=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { Row: Row, onlyEnabledIssueId: onlyEnabledIssueId, width: width } = this.props;
            const isEven = issue.rootIndex % 2 === 0;
            const backgroundColor = isEven ? undefined : $238389d010c740d6$export$1e2ac07b8385fc57;
            const isReadOnly = onlyEnabledIssueId && issue.id !== onlyEnabledIssueId || issue.id === (0, $lxd1S.INLINE_CREATE_ID);
            const rowItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Row, {
                backgroundColor: backgroundColor,
                disableOtherRows: this.disableOtherRows,
                isReadOnly: isReadOnly,
                issue: issue,
                issueWarnings: this.getWarningsForAnIssue(issue.id || ''),
                key: issue.id,
                reEnableOtherRows: this.reEnableOtherRows,
                topOffset: topOffset,
                width: width
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2p1Yc.default), {
                scopeIndex: index,
                issueId: issue.id
            }, rowItem);
        };
        this.rowRenderer = ({ key: key, index: index, style: style })=>{
            const { scope: scope, showWarning: showWarning, width: width } = this.props;
            const item = scope[index];
            const { group: group } = item;
            const { tag: tag } = item;
            switch(tag){
                case 0, $a0bo1.TABLE_ISSUE:
                    {
                        const issue = item.value;
                        // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
                        const issueWarnings = this.getWarningsForAnIssue(issue.id || '');
                        // remove when cleaning ff arj-remove-row-warning-highlighting_jqjs5
                        const hasWarnings = showWarning && issueWarnings.length > 0;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            key: `${item.tag}-${group || ''}-${issue.id}`,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: $jHygP.row,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                ...style
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), {
                            // remove 'highlighter' prop when cleaning ff arj-remove-row-warning-highlighting_jqjs5
                            highlighter: (0, $57dZR.getRowHighlighter)(issue.group, issue.id, hasWarnings)
                        }, this.createRowForIssue(issue, index, item.topOffset)));
                    }
                case 0, $a0bo1.TABLE_INLINE_CREATE:
                    {
                        const issue = item.value;
                        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            key: `${item.tag}-${group || ''}-${issue.id}`,
                            style: style
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), null, this.createRowForIssue(issue, index, item.topOffset))));
                    }
                case 0, $a0bo1.TABLE_HEADER:
                    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), null)));
                case 0, $a0bo1.TABLE_GROUP_HEADER:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: style,
                        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.table-header-group.${item.value.id}`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($238389d010c740d6$export$db50be146eaa4062, null)));
                case 0, $a0bo1.TABLE_BLANK_ROW:
                    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        key: key,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        style: {
                            height: 40
                        }
                    }))));
                case 0, $a0bo1.TABLE_GROUP:
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8YyRg.default), {
                        width: width,
                        item: item,
                        style: style,
                        key: key
                    });
                default:
                    throw new Error(`Unexpected TABLE item variant: ${tag}`);
            }
        };
        this.rowHeight = (index)=>(this.props.scope[index]?.height ?? 1) * (0, $5rYNM.SCOPE_ROW_HEIGHT);
        this.getContent = ()=>{
            const { scope: scope, scrollElement: scrollElement, onlyEnabledIssueId: onlyEnabledIssueId, timelineRange: timelineRange, showCapacity: showCapacity, width: width, TimelineReleaseMarker: // eslint-disable-next-line @typescript-eslint/no-shadow
            TimelineReleaseMarker, ReleaseBar: // eslint-disable-next-line @typescript-eslint/no-shadow
            ReleaseBar, NowLine: // eslint-disable-next-line @typescript-eslint/no-shadow
            NowLine, StickyHeader: // eslint-disable-next-line @typescript-eslint/no-shadow
            StickyHeader, DependencyLinesLayer: // eslint-disable-next-line @typescript-eslint/no-shadow
            DependencyLinesLayer, DependencyLinesProvider: // eslint-disable-next-line @typescript-eslint/no-shadow
            DependencyLinesProvider, leftSidebarWidth: leftSidebarWidth, DepLineDragPreviewProvider: // eslint-disable-next-line @typescript-eslint/no-shadow
            DepLineDragPreviewProvider, DependencyLinesLineDetail: // eslint-disable-next-line @typescript-eslint/no-shadow
            DependencyLinesLineDetail, HorizontalScrollView: // eslint-disable-next-line @typescript-eslint/no-shadow
            HorizontalScrollView, Arrows: // eslint-disable-next-line @typescript-eslint/no-shadow
            Arrows } = this.props;
            const { startIndex: startIndex, stopIndex: stopIndex, overscanStartIndex: overscanStartIndex, overscanStopIndex: overscanStopIndex, linesDisabled: linesDisabled } = this.state;
            // NOTE rows={scope} is passed to List to trigger re-render when items content was changed
            // but length remained the same
            // & timelineRange is passed to List to trigger re-render of sprint lines when the timeline
            // is changed
            let ret = scrollElement ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $jHygP.schedule
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $jHygP["release-grid"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseBar, {
                width: width,
                renderMarker: ({ date: date, mode: mode, versionIdsMapByDate: versionIdsMapByDate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimelineReleaseMarker, {
                        key: date,
                        endDate: date,
                        mode: mode,
                        versionIdsMapByDate: versionIdsMapByDate
                    })
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoaeP.WindowScroller), {
                scrollElement: scrollElement,
                ref: this.ref
            }, ({ height: height = 0, isScrolling: isScrolling, onChildScroll: onChildScroll, scrollTop: scrollTop })=>// eslint-disable-next-line jira/react/no-empty-divs
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StickyHeader, {
                    containerId: `${(0, $5rYNM.STICKY_HEADER_CONTAINER_PREFIX)}-timeline`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dPptc.default), {
                    width: width
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Ar1p.List), {
                    ref: this.listRef,
                    autoHeight: true,
                    height: height,
                    isScrolling: isScrolling,
                    onScroll: onChildScroll,
                    onlyEnabledIssueId: onlyEnabledIssueId,
                    rowCount: scope.length,
                    rowHeight: ({ index: index })=>{
                        // eslint-disable-next-line @typescript-eslint/no-shadow
                        const height = scope[index].height || 1;
                        return height * (0, $5rYNM.SCOPE_ROW_HEIGHT);
                    },
                    rowRenderer: this.rowRenderer,
                    onRowsRendered: ({ startIndex: // eslint-disable-next-line @typescript-eslint/no-shadow
                    startIndex, stopIndex: // eslint-disable-next-line @typescript-eslint/no-shadow
                    stopIndex, overscanStartIndex: // eslint-disable-next-line @typescript-eslint/no-shadow
                    overscanStartIndex, overscanStopIndex: // eslint-disable-next-line @typescript-eslint/no-shadow
                    overscanStopIndex })=>{
                        this.setState({
                            startIndex: startIndex,
                            stopIndex: stopIndex,
                            overscanStartIndex: overscanStartIndex,
                            overscanStopIndex: overscanStopIndex
                        });
                    },
                    rows: scope,
                    scrollTop: scrollTop,
                    tabIndex: null,
                    width: width,
                    state: this.state,
                    timelineRange: timelineRange,
                    showCapacity: showCapacity,
                    overscanRowCount: 20
                }), !linesDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyLinesLayer, {
                    scope: scope,
                    startIndex: startIndex,
                    stopIndex: stopIndex,
                    timelineRange: timelineRange,
                    width: width
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1X7JB.default), {
                    scope: scope,
                    scrollTop: scrollTop,
                    timelineRange: timelineRange,
                    width: width
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $108fh.default), {
                    scrollElement: scrollElement,
                    leftSidebarWidth: leftSidebarWidth
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                    attributes: {
                        rowCount: scope.length
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aHcVx.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NowLine, {
                    noMarker: true
                })))) : null;
            ret = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HorizontalScrollView, null, ret), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Arrows, {
                containerWidth: width,
                scope: scope,
                rowHeight: this.rowHeight,
                verticalRenderingWindow: {
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex
                }
            }));
            ret = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyLinesProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DepLineDragPreviewProvider, {
                width: width
            }, ret), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyLinesLineDetail, {
                scope: scope
            }));
            return ret;
        };
    }
}
const $238389d010c740d6$export$a74e4df6c6355a42 = (0, $fnOfj.injectIntlWithDefaultProps)($238389d010c740d6$var$ScheduleComponent);
var $238389d010c740d6$export$2e2bcd8739ae039 = (0, $2qhQi.default)((0, $a4vO3.withSlots)({
    NowLine: (0, $a4vO3.slots).NowLine
})($238389d010c740d6$var$ScheduleComponent));

});
parcelRegister("dSEBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11441bf0efe95d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gIPv8 = parcelRequire("gIPv8");

var $1ybV0 = parcelRequire("1ybV0");

var $84CBi = parcelRequire("84CBi");

var $1FoRq = parcelRequire("1FoRq");

var $7QAbJ = parcelRequire("7QAbJ");

var $exjqP = parcelRequire("exjqP");
class $f11441bf0efe95d2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            rowHeight: (0, $7QAbJ.RECT_ROW_HEIGHT),
            sidePadding: 8,
            topPadding: 8,
            animate: true
        };
    }
    render() {
        const { ariaLabel: ariaLabel, rowHeight: rowHeight, sidePadding: sidePadding, topPadding: topPadding, animate: animate } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
            name: "timeline-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1FoRq.AutoSizer), null, ({ width: width, height: height })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $exjqP.skeleton,
                style: {
                    width: width,
                    height: height
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIPv8.default), {
                ariaLabel: ariaLabel,
                width: width,
                height: height,
                ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? {
                    animate: animate
                } : {},
                ...(0, $7QAbJ.DEFAULT_CONTENT_LOADER_PROPS)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding,
                y: topPadding,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 2,
                height: rowHeight
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding + 100,
                y: topPadding + 90,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 2,
                height: rowHeight
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding + 200,
                y: topPadding + 132,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 5,
                height: rowHeight
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding + 250,
                y: topPadding + 258,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 3,
                height: rowHeight
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding + 300,
                y: topPadding + 342,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 2,
                height: rowHeight
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: sidePadding + 350,
                y: topPadding + 468,
                ...(0, $7QAbJ.RECT_BORDER_RADIUS),
                width: width / 2,
                height: rowHeight
            })))));
    }
}

});

parcelRegister("aHcVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1dafbc273c1f0b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $17L5s = parcelRequire("17L5s");

var $f3YKO = parcelRequire("f3YKO");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8tMGO = parcelRequire("8tMGO");

var $jODJR = parcelRequire("jODJR");
const $7c1dafbc273c1f0b$var$longTask = (0, $f3YKO.default)((0, $8tMGO.SPA_APP_NAME));
function $7c1dafbc273c1f0b$export$2e2bcd8739ae039() {
    const [{ viewport: viewport, lastScrollTrigger: lastScrollTrigger, today: today }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const lastReportedOffset = (0, $eUqFw.useRef)(null);
    const reportAnalytics = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/no-shadow
        (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((trigger, newOffset, today)=>{
            const [actionSubject, action] = (0, $8tMGO.ANALYTICS_SCROLL_TIMELINE).split(' ');
            const diffMs = newOffset - (lastReportedOffset.current ?? 0);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), {
                trigger: trigger,
                distance: Math.ceil(msToPx(diffMs)),
                stopDate: Math.round((today + newOffset) / (0, $17L5s.ONE_DAY)) * (0, $17L5s.ONE_DAY)
            });
            lastReportedOffset.current = newOffset;
        }, 1000), [
        createAnalyticsEvent,
        msToPx
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (lastReportedOffset.current == null) lastReportedOffset.current = viewport.offset;
        if (lastScrollTrigger && lastReportedOffset.current !== viewport.offset) {
            reportAnalytics(lastScrollTrigger, viewport.offset, today);
            $7c1dafbc273c1f0b$var$longTask.trackWithTimeout((0, $8tMGO.ANALYITICS_TIMELINE_HORIZONTAL_SCROLLED), createAnalyticsEvent);
        }
    }, [
        lastScrollTrigger,
        viewport,
        today,
        reportAnalytics,
        createAnalyticsEvent
    ]);
    return null;
}

});

parcelRegister("01R8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $560d2871f64ac3b9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5ZnRM = parcelRequire("5ZnRM");

var $iUlYg = parcelRequire("iUlYg");

var $kX6V1 = parcelRequire("kX6V1");
var $560d2871f64ac3b9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iUlYg.default), (0, $5ZnRM.default))((0, $kX6V1.default));

});
parcelRegister("5ZnRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $12f0663d23b9e557$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updateFlyout", () => (parcelRequire("jZUKH")).updateFlyout);

var $jZUKH = parcelRequire("jZUKH");
const $12f0663d23b9e557$var$mapDispatchToProps = (dispatch)=>({
        openFlyout: (versionIds, type)=>{
            dispatch((0, $jZUKH.openFlyout)(versionIds, type));
        },
        closeFlyout: ()=>{
            dispatch((0, $jZUKH.closeFlyout)());
        }
    });
var $12f0663d23b9e557$export$2e2bcd8739ae039 = $12f0663d23b9e557$var$mapDispatchToProps;

});
parcelRegister("jZUKH", function(module, exports) {

$parcel$export(module.exports, "SET_MODE", () => $612eb2724c7c9d58$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "OPEN_FLYOUT", () => $612eb2724c7c9d58$export$aece46899d04da75);
$parcel$export(module.exports, "UPDATE_FLYOUT", () => $612eb2724c7c9d58$export$a2b5fcbeee378108);
$parcel$export(module.exports, "CLOSE_FLYOUT", () => $612eb2724c7c9d58$export$818850ad86c540b1);
$parcel$export(module.exports, "TOGGLE_RELEASE_HIGHLIGHT", () => $612eb2724c7c9d58$export$b573db5d1292985d);
$parcel$export(module.exports, "RESET_RELEASE_HIGHLIGHTS", () => $612eb2724c7c9d58$export$a019f587f6127c6e);
$parcel$export(module.exports, "openFlyout", () => $612eb2724c7c9d58$export$a297e31c5d8808a1);
$parcel$export(module.exports, "updateFlyout", () => $612eb2724c7c9d58$export$fcd7b1e2a5376d43);
$parcel$export(module.exports, "closeFlyout", () => $612eb2724c7c9d58$export$7670f8956d89067d);
const $612eb2724c7c9d58$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.roadmap.timeline.release-bar.SET_MODE';
const $612eb2724c7c9d58$export$aece46899d04da75 = 'state.ui.main.tabs.roadmap.timeline.release-bar.OPEN_FLYOUT';
const $612eb2724c7c9d58$export$a2b5fcbeee378108 = 'state.ui.main.tabs.roadmap.timeline.release-bar.UPDATE_FLYOUT';
const $612eb2724c7c9d58$export$818850ad86c540b1 = 'state.ui.main.tabs.roadmap.timeline.release-bar.CLOSE_FLYOUT';
const $612eb2724c7c9d58$export$b573db5d1292985d = 'state.ui.main.tabs.roadmap.timeline.release-bar.TOGGLE_RELEASE_HIGHLIGHT';
const $612eb2724c7c9d58$export$a019f587f6127c6e = 'state.ui.main.tabs.roadmap.timeline.release-bar.RESET_RELEASE_HIGHLIGHTS';
const $612eb2724c7c9d58$export$d4f039427a1beff1 = (payload)=>({
        type: $612eb2724c7c9d58$export$27a86d4a6fd7f204,
        payload: payload
    });
const $612eb2724c7c9d58$export$a297e31c5d8808a1 = (versionIds, type)=>({
        type: $612eb2724c7c9d58$export$aece46899d04da75,
        payload: {
            mode: type,
            versionIds: versionIds
        }
    });
const $612eb2724c7c9d58$export$fcd7b1e2a5376d43 = (versionIds, type, prevVersionIds)=>({
        type: $612eb2724c7c9d58$export$a2b5fcbeee378108,
        payload: {
            mode: type,
            versionIds: versionIds,
            prevVersionIds: prevVersionIds
        }
    });
const $612eb2724c7c9d58$export$7670f8956d89067d = ()=>({
        type: $612eb2724c7c9d58$export$818850ad86c540b1
    });
const $612eb2724c7c9d58$export$97c25c5d2300edd8 = (versionId)=>({
        type: $612eb2724c7c9d58$export$b573db5d1292985d,
        versionId: versionId
    });
const $612eb2724c7c9d58$export$f63ec690ad2eb4fe = (versionIds)=>({
        type: $612eb2724c7c9d58$export$a019f587f6127c6e,
        versionIds: versionIds
    });

});


parcelRegister("iUlYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa99878ddbc400c$export$2e2bcd8739ae039);

var $7d70y = parcelRequire("7d70y");
var $lqxEm = parcelRequire("lqxEm");
var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $akhOi = parcelRequire("akhOi");

var $2Ruxt = parcelRequire("2Ruxt");

var $38iYP = parcelRequire("38iYP");

var $68BNT = parcelRequire("68BNT");

var $3nT5G = parcelRequire("3nT5G");

var $1ftu4 = parcelRequire("1ftu4");

var $wcCGG = parcelRequire("wcCGG");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $lasT9 = parcelRequire("lasT9");
const $efa99878ddbc400c$export$64851af5160151f6 = (enrichedVersions, versionFilter, projectFilter)=>{
    const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = versionFilter;
    const { value: projectValue } = projectFilter;
    const filterValue = (0, $7CnHa.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
        ...value,
        ...versionsFromCrossProjectReleaseFilterValue
    ] : value;
    return enrichedVersions.filter(({ id: id, projects: projects })=>(filterValue.length === 0 || $7d70y.default(id, filterValue)) && (projectValue.length === 0 || projects.some((project)=>{
            // Defend against rare occurances of corrupt data
            // Cannot destructure property 'id' of 'undefined' as it is undefined
            if ((0, $lasT9.isProject)(project) && project.id === null) return false;
            return (0, $lasT9.isProject)(project) && projectValue.includes(project.id);
        })));
};
const $efa99878ddbc400c$export$10cb46f34fc9b7a8 = (enrichedCrossProjectVersions, versionFilter, crossProjectVersionFilter, filteredProjects)=>{
    const { value: value, versionsFromCrossProjectReleaseFilterValue: versionsFromCrossProjectReleaseFilterValue } = versionFilter;
    const versionFilterValue = (0, $7CnHa.isDefined)(versionsFromCrossProjectReleaseFilterValue) ? [
        ...value,
        ...versionsFromCrossProjectReleaseFilterValue
    ] : value;
    const filteredByProjectVersionsSet = new Set($lqxEm.default($cQGVO.default($f7Op5.default('versions'), filteredProjects)));
    const filterByProject = (versions)=>versions.some(({ id: id })=>filteredByProjectVersionsSet.has(id));
    return enrichedCrossProjectVersions.filter(({ id: id, versions: versions })=>{
        if (crossProjectVersionFilter.value.length > 0 || versionFilterValue.length > 0) return $7d70y.default(id, crossProjectVersionFilter.value) && filterByProject(versions);
        return filterByProject(versions);
    });
};
const $efa99878ddbc400c$var$getCrossProjectVersions = (0, $iK4oF.createSelector)([
    (0, $2Ruxt.getEnrichedCrossProjectVersions),
    (0, $3nT5G.getReleaseFilter),
    (0, $38iYP.getCrossProjectReleaseFilter),
    (0, $68BNT.getFilteredProjects)
], $efa99878ddbc400c$export$10cb46f34fc9b7a8);
const $efa99878ddbc400c$var$getVersions = (0, $iK4oF.createSelector)([
    (0, $wcCGG.getEnrichedVersions),
    (0, $3nT5G.getReleaseFilter),
    (0, $68BNT.getProjectFilter)
], $efa99878ddbc400c$export$64851af5160151f6);
var $efa99878ddbc400c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $akhOi.getMode),
    versions: $efa99878ddbc400c$var$getVersions,
    crossProjectVersions: $efa99878ddbc400c$var$getCrossProjectVersions,
    releaseBarState: (0, $1ftu4.getReleaseBarState),
    solutionVersionsById: (0, $wcCGG.getSolutionVersionsById)
});

});
parcelRegister("1ftu4", function(module, exports) {

$parcel$export(module.exports, "getReleaseBarState", () => $b36814383df36c9e$export$18bbac4a693d9a63);
const $b36814383df36c9e$export$18bbac4a693d9a63 = (state)=>state.ui.Main.Tabs.Roadmap.Timeline.ReleaseBar;

});

parcelRegister("lasT9", function(module, exports) {

$parcel$export(module.exports, "isProject", () => $a42881e60ddc76e3$export$7ca3f0de95b9253e);
$parcel$export(module.exports, "isVersionCrossProject", () => $a42881e60ddc76e3$export$e0ae1be48cdf8e5d);
$parcel$export(module.exports, "calculateLeftPositionPercentage", () => $a42881e60ddc76e3$export$1201dff46564a4e5);
$parcel$export(module.exports, "calculateSlippage", () => $a42881e60ddc76e3$export$125238b07db25e1f);
$parcel$export(module.exports, "calculateNewTimelineRange", () => $a42881e60ddc76e3$export$c18c64cb490ad928);
$parcel$export(module.exports, "calculateEndVersionsDate", () => $a42881e60ddc76e3$export$8bdabc349efccfa0);
$parcel$export(module.exports, "getMarkerTypeIcon", () => $a42881e60ddc76e3$export$e028bd08ccb2e98c);
$parcel$export(module.exports, "getVersionFlyoutType", () => $a42881e60ddc76e3$export$5b2d0df9616efd9e);
$parcel$export(module.exports, "ICON_TYPES", () => (parcelRequire("84GMP")).ICON_TYPES);

var $aH8gO = parcelRequire("aH8gO");
var $607C7 = parcelRequire("607C7");
var $5OdRK = parcelRequire("5OdRK");

var $gU63c = parcelRequire("gU63c");


var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $84GMP = parcelRequire("84GMP");
const $a42881e60ddc76e3$var$releaseStatusToIconType = {
    [(0, $5rYNM.RELEASE_STATUSES).UNRELEASED]: (0, $84GMP.ICON_TYPES).UNRELEASED,
    [(0, $5rYNM.RELEASE_STATUSES).RELEASED]: (0, $84GMP.ICON_TYPES).RELEASED,
    [(0, $5rYNM.RELEASE_STATUSES).OFFTRACK]: (0, $84GMP.ICON_TYPES).OFFTRACK,
    [(0, $5rYNM.RELEASE_STATUSES).ONTRACK]: (0, $84GMP.ICON_TYPES).ONTRACK
};
function $a42881e60ddc76e3$export$7ca3f0de95b9253e(proj) {
    return typeof proj !== 'number';
}
function $a42881e60ddc76e3$export$e0ae1be48cdf8e5d(version) {
    return 'versions' in version;
}
const $a42881e60ddc76e3$export$dfea42d7af3bd8f6 = (mode, versionEndDate, solutionEndDate)=>{
    /** In this case, release has a fixed end date. We can't use calculated end date
	 * when user has set a fixed end date to it.
	 */ if ((0, $7CnHa.isDefined)(versionEndDate)) return versionEndDate;
    /** When user has set release to have dynamic release date then we can use
	 * calculated end date in OPTIMIZED mode.
	 */ if (mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) return solutionEndDate || versionEndDate;
    /** While without optimization we don't know the date. Hence we have to return
	 * version's end date, which is null.
	 */ return versionEndDate;
};
const $a42881e60ddc76e3$export$fade81963e3410a4 = (mode, versions, solutionVersionsById)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const versionEndDates = versions.reduce((result, { id: id, end: versionEnd })=>{
        const solutionVersion = solutionVersionsById[id];
        let solutionEnd = null;
        if ((0, $7CnHa.isDefined)(solutionVersion)) solutionEnd = solutionVersion.end;
        const versionEndDate = $a42881e60ddc76e3$export$dfea42d7af3bd8f6(mode, versionEnd, solutionEnd);
        if ((0, $7CnHa.isDefined)(versionEndDate)) result.push(versionEndDate);
        return result;
    }, []);
    if (versionEndDates.length === 0) return null;
    return versionEndDates.reduce((result, end)=>Math.max(result, end));
};
const $a42881e60ddc76e3$export$1201dff46564a4e5 = (endDate, { start: timelineStart, end: timelineEnd })=>(endDate - timelineStart) / (timelineEnd - timelineStart) * 100;
const $a42881e60ddc76e3$export$125238b07db25e1f = (solutionEndDate, versionEndDate)=>{
    if ((0, $7CnHa.isDefined)(solutionEndDate)) return solutionEndDate - versionEndDate;
    return 0;
};
const $a42881e60ddc76e3$export$c18c64cb490ad928 = (nextDate, { start: start, end: end })=>{
    const medianTimeLineDate = (end + start) / 2;
    const releasesDatesDiff = Math.abs(nextDate - medianTimeLineDate);
    if (nextDate < start) return {
        fromDate: start - releasesDatesDiff,
        toDate: end - releasesDatesDiff
    };
    return {
        fromDate: start + releasesDatesDiff,
        toDate: end + releasesDatesDiff
    };
};
const $a42881e60ddc76e3$export$8bdabc349efccfa0 = (version, solutionVersionsById, mode)=>{
    const solutionVersion = solutionVersionsById && solutionVersionsById[version.id];
    let solutionEnd = null;
    if ((0, $7CnHa.isDefined)(solutionVersion)) solutionEnd = solutionVersion.end;
    let versionEndDate;
    if (!$a42881e60ddc76e3$export$e0ae1be48cdf8e5d(version)) versionEndDate = $a42881e60ddc76e3$export$dfea42d7af3bd8f6(mode, version.end, solutionEnd);
    else versionEndDate = $a42881e60ddc76e3$export$fade81963e3410a4(mode, version.versions, solutionVersionsById);
    return versionEndDate;
};
const $a42881e60ddc76e3$export$944dcaca26f5a09a = ({ crossProjectVersions: crossProjectVersions, versions: versions })=>{
    const crossProjectVersionStatuses = crossProjectVersions.map((crossProjectVersion)=>(0, $gU63c.getReleaseStatus)(crossProjectVersion));
    const versionStatuses = versions.map(({ releaseStatusId: releaseStatusId })=>releaseStatusId);
    const joinedVersions = [
        ...crossProjectVersionStatuses,
        ...versionStatuses
    ];
    if ($aH8gO.default($5OdRK.default((0, $5rYNM.RELEASE_STATUSES).RELEASED))(joinedVersions)) return (0, $5rYNM.RELEASE_STATUSES).RELEASED;
    if ($607C7.default($5OdRK.default((0, $5rYNM.RELEASE_STATUSES).OFFTRACK))(joinedVersions)) return (0, $5rYNM.RELEASE_STATUSES).OFFTRACK;
    return (0, $5rYNM.RELEASE_STATUSES).ONTRACK;
};
const $a42881e60ddc76e3$export$e028bd08ccb2e98c = (mappedVersions, mode, flyoutType, solutionVersionsById)=>{
    let releaseStatusId;
    const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
    switch(flyoutType){
        case 0, $5rYNM.RELEASE:
            releaseStatusId = versions[0] && versions[0].releaseStatusId;
            break;
        case 0, $5rYNM.CROSS_PROJECT_RELEASE:
            releaseStatusId = (0, $gU63c.getReleaseStatus)(crossProjectVersions[0]);
            break;
        default:
            releaseStatusId = $a42881e60ddc76e3$export$944dcaca26f5a09a(mappedVersions);
            break;
    }
    let iconType = $a42881e60ddc76e3$var$releaseStatusToIconType[releaseStatusId];
    let slippage = null;
    if (flyoutType === (0, $5rYNM.RELEASE) && mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) {
        const { id: id, end: versionEnd } = versions[0];
        const solutionVersion = solutionVersionsById[id];
        const solutionEnd = (0, $7CnHa.isDefined)(solutionVersion) ? solutionVersion.end : null;
        slippage = versionEnd ? $a42881e60ddc76e3$export$125238b07db25e1f(solutionEnd, versionEnd) : 0;
        if (releaseStatusId !== (0, $5rYNM.RELEASE_STATUSES).RELEASED) {
            if (slippage > 0) iconType = (0, $84GMP.ICON_TYPES).OFFTRACK;
            else iconType = (0, $84GMP.ICON_TYPES).ONTRACK;
        }
    }
    return iconType;
};
const $a42881e60ddc76e3$export$5b2d0df9616efd9e = (versions)=>{
    if (versions.length > 1) return 0, $50277156232634a9$export$8342016558eba865;
    if (versions[0] && $a42881e60ddc76e3$export$e0ae1be48cdf8e5d(versions[0]) && versions[0].versions) return 0, $5rYNM.CROSS_PROJECT_RELEASE;
    return 0, $5rYNM.RELEASE;
};

});
parcelRegister("aH8gO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9455d68987041a$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5NMGM = parcelRequire("5NMGM");

var $fF6Az = parcelRequire("fF6Az");
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $7c9455d68987041a$var$all = /*#__PURE__*/ (0, $ggdJA.default)(/*#__PURE__*/ (0, $5NMGM.default)([
    'all'
], (0, $fF6Az.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $7c9455d68987041a$export$2e2bcd8739ae039 = $7c9455d68987041a$var$all;

});
parcelRegister("fF6Az", function(module, exports) {

$parcel$export(module.exports, "default", () => $b66fcbc873881fae$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5zr36 = parcelRequire("5zr36");

var $8uquE = parcelRequire("8uquE");
var $b66fcbc873881fae$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype['@@transducer/init'] = (0, $8uquE.default).init;
    XAll.prototype['@@transducer/result'] = function(result) {
        if (this.all) result = this.xf['@@transducer/step'](result, true);
        return this.xf['@@transducer/result'](result);
    };
    XAll.prototype['@@transducer/step'] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $5zr36.default)(this.xf['@@transducer/step'](result, false));
        }
        return result;
    };
    return XAll;
}();
var $b66fcbc873881fae$var$_xall = /*#__PURE__*/ (0, $ggdJA.default)(function _xall(f, xf) {
    return new $b66fcbc873881fae$var$XAll(f, xf);
});
var $b66fcbc873881fae$export$2e2bcd8739ae039 = $b66fcbc873881fae$var$_xall;

});


parcelRegister("gU63c", function(module, exports) {

$parcel$export(module.exports, "getReleaseStatus", () => $9922b2695ccecee7$export$4f01710575377834);

var $aH8gO = parcelRequire("aH8gO");
var $607C7 = parcelRequire("607C7");
var $h3f0m = parcelRequire("h3f0m");

var $5rYNM = parcelRequire("5rYNM");
const $9922b2695ccecee7$export$4f01710575377834 = ({ versions: versions })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ($aH8gO.default($h3f0m.default('releaseStatusId', (0, $5rYNM.RELEASE_STATUSES).RELEASED))(versions)) return (0, $5rYNM.RELEASE_STATUSES).RELEASED;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if ($607C7.default($h3f0m.default('releaseStatusId', (0, $5rYNM.RELEASE_STATUSES).OFFTRACK))(versions)) return (0, $5rYNM.RELEASE_STATUSES).OFFTRACK;
    return (0, $5rYNM.RELEASE_STATUSES).ONTRACK;
};

});

parcelRegister("84GMP", function(module, exports) {

$parcel$export(module.exports, "ICON_TYPES", () => $37e35e9e3de15588$export$67e1fb76bc6def93);
$parcel$export(module.exports, "OVERVIEW_RELEASES", () => $50277156232634a9$export$8342016558eba865);

const $37e35e9e3de15588$var$UNRELEASED = 'UNRELEASED';
const $37e35e9e3de15588$var$RELEASED = 'RELEASED';
const $37e35e9e3de15588$var$ONTRACK = 'ONTRACK';
const $37e35e9e3de15588$var$OFFTRACK = 'OFFTRACK';
const $37e35e9e3de15588$export$67e1fb76bc6def93 = {
    UNRELEASED: $37e35e9e3de15588$var$UNRELEASED,
    RELEASED: $37e35e9e3de15588$var$RELEASED,
    ONTRACK: $37e35e9e3de15588$var$ONTRACK,
    OFFTRACK: $37e35e9e3de15588$var$OFFTRACK
};

});
const $50277156232634a9$export$8342016558eba865 = 'OVERVIEW_RELEASES';




parcelRegister("kX6V1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfcf6cb43d7e680f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $eirae = parcelRequire("eirae");
var $cQGVO = parcelRequire("cQGVO");
var $cQwal = parcelRequire("cQwal");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");

var $1ybV0 = parcelRequire("1ybV0");

var $jODJR = parcelRequire("jODJR");

var $hQMol = parcelRequire("hQMol");

var $lasT9 = parcelRequire("lasT9");

var $kslPA = parcelRequire("kslPA");

var $4GUOr = parcelRequire("4GUOr");
function $cfcf6cb43d7e680f$export$2e2bcd8739ae039({ openFlyout: openFlyout, closeFlyout: closeFlyout, releaseBarState: releaseBarState, crossProjectVersions: crossProjectVersions, mode: mode, solutionVersionsById: solutionVersionsById, versions: versions, renderMarker: renderMarker, width: width }) {
    const [zoomLevel, { scrollToView: scrollToView }] = (0, $jODJR.useZoomLevel)();
    const { isFlyoutOpen: isFlyoutOpen, versionIds: versionIds } = releaseBarState;
    const toggleFlyout = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (versionIds, type)=>{
        if (isFlyoutOpen) closeFlyout();
        else if (type !== undefined) openFlyout(versionIds, type);
    }, [
        openFlyout,
        closeFlyout,
        isFlyoutOpen
    ]);
    const handleScrollToViewRelease = (0, $eUqFw.useCallback)(({ timestamp: timestamp })=>{
        if (zoomLevel === undefined) return;
        scrollToView({
            timestamp: timestamp
        }, 'releaseNavButton');
    }, [
        zoomLevel,
        scrollToView
    ]);
    const finalRenderMarker = renderMarker ?? // eslint-disable-next-line @typescript-eslint/no-shadow
    (({ mode: mode, date: date, versionIdsMapByDate: versionIdsMapByDate }, index = 0)=>{
        const showFlyout = isFlyoutOpen && versionIdsMapByDate[date].some((id)=>versionIds.includes(id));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kslPA.default), {
            key: date,
            mode: mode,
            endDate: date,
            scrollToViewRelease: handleScrollToViewRelease,
            totalDays: Object.keys(versionIdsMapByDate).length,
            currentDayIndex: index + 1,
            versionIdsMapByDate: versionIdsMapByDate,
            showFlyout: showFlyout,
            toggleFlyout: toggleFlyout,
            width: width
        });
    });
    // Returns an object that maps release dates to ids of releases that fall on that day.
    // Loop through all versions/CPRs, returning the end date if it is defined and falls within
    // the current timeline range. We want unique end dates so we group by the end date value.
    // Undefined end dates or those outside the date range are omitted from the list
    // For each end date, we loop through each version and return only the id of that version.
    const getVersionIdsMapByDate = (timelineRange)=>$3IGDG.default($eirae.default((version)=>{
            const end = (0, $lasT9.calculateEndVersionsDate)(version, solutionVersionsById, mode);
            if (end && end >= timelineRange.start && end <= timelineRange.end) return end.toString(); // Cast to string as object keys cannot be numbers
            // We want to use reduceBy, but our current Ramda version does not support this.
            // groupBy must return a string type and cannot return undefined
            return 'undefined';
        }), $cQwal.default([
            'undefined'
        ]), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $cQGVO.default($cQGVO.default($f7Op5.default('id'))))([
            ...versions,
            ...crossProjectVersions
        ]);
    const wrap = renderMarker ? (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.div",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))([
                $4GUOr.main,
                (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2') && $4GUOr.transposed
            ])
        }, children);
    return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hQMol.default), null, (timelineRange)=>{
        const withinRange = getVersionIdsMapByDate(timelineRange);
        const all = zoomLevel === undefined ? withinRange : getVersionIdsMapByDate({
            start: -Infinity,
            end: Infinity
        });
        const nodes = Object.keys(all).sort((a, b)=>Number(a) - Number(b)).reduce((acc, date, index)=>{
            // We only want to render the releases within the rendering window
            if (!(date in withinRange)) return acc;
            const markerEl = finalRenderMarker({
                mode: mode,
                date: date,
                versionIdsMapByDate: all
            }, index);
            acc.push(markerEl);
            return acc;
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, nodes);
    }));
}

});
parcelRegister("hQMol", function(module, exports) {

$parcel$export(module.exports, "default", () => $3968da7c9015b959$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2VlTY = parcelRequire("2VlTY");

var $2L7cT = parcelRequire("2L7cT");
var $3968da7c9015b959$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2VlTY.default), {})((0, $2L7cT.default));

});
parcelRegister("2VlTY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0919b906470cf721$export$2e2bcd8739ae039);

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
var $0919b906470cf721$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    timelineRange: (0, $aMoMC.getTimelineRange)
});

});

parcelRegister("2L7cT", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c86c29a83bc40c$export$2e2bcd8739ae039);

var $jODJR = parcelRequire("jODJR");
function $68c86c29a83bc40c$export$2e2bcd8739ae039({ children: children, timelineRange: containerTimelineRange }) {
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [{ timelineRange: renderingWindowTimelineRange }] = (0, $jODJR.useRenderingWindow)();
    if (!zoomLevel) return children(containerTimelineRange);
    return children(renderingWindowTimelineRange);
}

});


parcelRegister("kslPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $715cff98a1a64886$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cYDwp = parcelRequire("cYDwp");

var $7sh64 = parcelRequire("7sh64");

var $kBQ6s = parcelRequire("kBQ6s");
var $715cff98a1a64886$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $7sh64.default), (0, $cYDwp.default))((0, $kBQ6s.default));

});
parcelRegister("cYDwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $76dfe40f984392fe$export$2e2bcd8739ae039);
parcelRequire("dWez3");
var $hHEgb = parcelRequire("hHEgb");
parcelRequire("5ZnRM");
var $jZUKH = parcelRequire("jZUKH");
const $76dfe40f984392fe$var$mapDispatchToProps = (dispatch)=>({
        updateFlyout: (versionIds, type, prevVersionIds, dateRange)=>{
            dispatch((0, $jZUKH.updateFlyout)(versionIds, type, prevVersionIds));
            if (dateRange) {
                dispatch((0, $hHEgb.timeScaleCustomDatesChange)(dateRange));
                dispatch({
                    type: (0, $hHEgb.CHANGE_OPTION),
                    payload: 'custom'
                });
            }
        }
    });
var $76dfe40f984392fe$export$2e2bcd8739ae039 = $76dfe40f984392fe$var$mapDispatchToProps;

});
parcelRegister("dWez3", function(module, exports) {

$parcel$export(module.exports, "CHANGE_OPTION", () => (parcelRequire("hHEgb")).CHANGE_OPTION);
$parcel$export(module.exports, "CHANGE_CUSTOM_DATES", () => (parcelRequire("hHEgb")).CHANGE_CUSTOM_DATES);
$parcel$export(module.exports, "timeScaleCustomDatesChange", () => (parcelRequire("hHEgb")).timeScaleCustomDatesChange);

var $hHEgb = parcelRequire("hHEgb");

});


parcelRegister("7sh64", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c7b3dd61f61d918$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $1ftu4 = parcelRequire("1ftu4");

var $aMoMC = parcelRequire("aMoMC");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $8c7b3dd61f61d918$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    solutionVersionsById: (0, $wcCGG.getSolutionVersionsById),
    timelineRange: (0, $aMoMC.getTimelineRange),
    releaseBarState: (0, $1ftu4.getReleaseBarState),
    crossProjectVersionsById: (0, $2Ruxt.getEnrichedCrossProjectVersionsById),
    versionsById: (0, $wcCGG.getEnrichedVersionsById),
    highlightedVersionIds: (state)=>(0, $9H2AP.getHighlightedVersionsViewSettings)(state).versions
});

});

parcelRegister("kBQ6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed95afb3d4db6539$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f2C9X = parcelRequire("f2C9X");

var $1ybV0 = parcelRequire("1ybV0");

var $jpQDZ = parcelRequire("jpQDZ");
var $eNhh9 = parcelRequire("eNhh9");

parcelRequire("84GMP");

var $lasT9 = parcelRequire("lasT9");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $kIzeJ = parcelRequire("kIzeJ");
parcelRequire("areZp");
var $4j1D2 = parcelRequire("4j1D2");
var $areZp = parcelRequire("areZp");

var $fHnVl = parcelRequire("fHnVl");

var $eVlrT = parcelRequire("eVlrT");

var $fqPTT = parcelRequire("fqPTT");
const $ed95afb3d4db6539$var$DIALOG_MIN_WIDTH = 480;
class $ed95afb3d4db6539$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ReleaseFlyout: $fHnVl.ProjectRelease,
            CrossProjectReleaseFlyout: $fHnVl.CrossProjectRelease,
            OverviewReleasesFlyout: $fHnVl.OverviewReleases,
            ZIndex: $areZp.ZIndex
        };
    }
    render() {
        const { mode: mode, endDate: endDate, versionIdsMapByDate: versionIdsMapByDate, timelineRange: timelineRange, width: timelineWidth, showFlyout: showFlyout, toggleFlyout: toggleFlyout, solutionVersionsById: solutionVersionsById, highlightedVersionIds: highlightedVersionIds, ZIndex: // eslint-disable-next-line @typescript-eslint/no-shadow
        ZIndex } = this.props;
        if (!(0, $7CnHa.isDefined)(endDate)) return null;
        const mappedVersions = this.mapVersionsById(versionIdsMapByDate[endDate]);
        const releaseId = $f2C9X.default(versionIdsMapByDate[endDate]);
        const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
        const versionFlyoutType = (0, $lasT9.getVersionFlyoutType)([
            ...versions,
            ...crossProjectVersions
        ]);
        const leftPositionPercentage = (0, $lasT9.calculateLeftPositionPercentage)(Number(endDate), timelineRange);
        const isHighlighted = !!versionIdsMapByDate[endDate].find((versionId)=>highlightedVersionIds.some((version)=>version === versionId));
        // Consider remove this function when cleaning up com.atlassian.rm.jpo.transposition.m2
        const withZIndexOverride = (children)=>{
            if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
            return ZIndex ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ZIndex, {
                layer: (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS
            }, (zIndex)=>children(zIndex ?? 'initial')) : null;
        };
        return withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: (node)=>{
                    if (node) this.ref = node;
                },
                // the <ReleaseMarkerIcon /> triggering the fixed dialog already has a focusable button
                // so we set the container tabIndex to -1 to disable it and avoid double-focus
                tabIndex: -1,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $fqPTT.main,
                style: {
                    left: `calc(${leftPositionPercentage}% - ${"var(--ds-space-150, 12px)"})`,
                    zIndex: zIndex
                },
                /**
     * When handling keyboard events for the "Enter" and "Space" keys, it's generally better to use the onKeyDown event rather than onKeyUp.
     * The onKeyDown event is fired as soon as the user presses a key, while the onKeyUp event is fired after the user releases a key.
     * If we were to use onKeyUp, there might be a noticeable delay between when the user presses the key and when the action is performed, especially if the user holds down the key.
     */ onKeyDown: this.onKeyDown,
                role: "button",
                "data-name": releaseId && `release-marker-${releaseId}`,
                "data-testid": releaseId && `release-marker-${releaseId}`,
                onMouseEnter: (0, $fHnVl.preload)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jpQDZ.default), {
                isOpen: showFlyout,
                minLeft: 0,
                renderDialog: (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                        content: this.renderFlyout(),
                        isOpen: true,
                        placement: (0, $kIzeJ.getFlyoutPosition)(timelineWidth, leftPositionPercentage, this.state.flyoutWidth),
                        onClose: this.handleFlyoutRequestClose,
                        noPaddings: true,
                        noHorizontalScroll: true,
                        closeOnScroll: true,
                        minWidth: $ed95afb3d4db6539$var$DIALOG_MIN_WIDTH,
                        testId: `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.inline-dialog.${releaseId}`
                    }, element),
                renderTrigger: (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVlrT.default), {
                        endDate: endDate,
                        innerRef: ref,
                        isHighlighted: isHighlighted,
                        onClick: ()=>{
                            this.getFlyoutWidth();
                            toggleFlyout(versionIdsMapByDate[endDate], versionFlyoutType);
                        },
                        release: this.props.versionsById[versionIdsMapByDate[endDate][0]],
                        totalCount: versionIdsMapByDate[endDate].length,
                        showTooltip: true,
                        type: (0, $lasT9.getMarkerTypeIcon)(mappedVersions, mode, versionFlyoutType, solutionVersionsById)
                    })
            })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            flyoutWidth: $ed95afb3d4db6539$var$DIALOG_MIN_WIDTH
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.flyoutRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.isKeyboardEventEnter = (event)=>{
            const { key: key } = event;
            return !event.nativeEvent.isComposing && key.trim().toLowerCase() === 'enter';
        };
        this.isKeyboardEventSpace = (event)=>{
            const { key: key = '' } = event;
            return !event.nativeEvent.isComposing && (key === ' ' || key.trim().toLowerCase() === 'space');
        };
        this.onKeyDown = (event)=>{
            const { toggleFlyout: toggleFlyout, versionIdsMapByDate: versionIdsMapByDate, endDate: endDate, type: type } = this.props;
            if (this.isKeyboardEventEnter(event) || this.isKeyboardEventSpace(event)) toggleFlyout(versionIdsMapByDate[endDate], type);
        };
        this.handleBack = (prevVersionIds)=>{
            const { updateFlyout: updateFlyout } = this.props;
            this.getFlyoutWidth();
            updateFlyout(prevVersionIds, (0, $50277156232634a9$export$8342016558eba865), []);
        };
        this.navigateTo = (date, direction)=>{
            const { versionIdsMapByDate: versionIdsMapByDate, updateFlyout: updateFlyout, timelineRange: timelineRange, scrollToViewRelease: scrollToViewRelease } = this.props;
            const dates = Object.keys(versionIdsMapByDate).sort((a, b)=>Number(a) - Number(b));
            const nextDate = direction === 'next' ? dates[dates.indexOf(date) + 1] : dates[dates.indexOf(date) - 1];
            const { versions: versions, crossProjectVersions: crossProjectVersions } = this.mapVersionsById(versionIdsMapByDate[nextDate]);
            const nextTimelineRange = Number(nextDate) < timelineRange.start || Number(nextDate) > timelineRange.end ? (0, $lasT9.calculateNewTimelineRange)(Number(nextDate), timelineRange) : undefined;
            this.getFlyoutWidth();
            scrollToViewRelease?.call(null, {
                timestamp: parseInt(nextDate, 10)
            });
            setTimeout(()=>updateFlyout(versionIdsMapByDate[nextDate], (0, $lasT9.getVersionFlyoutType)([
                    ...versions,
                    ...crossProjectVersions
                ]), [], nextTimelineRange), 1);
        };
        this.getReleaseFlyout = (version)=>{
            if (!version) return null;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { solutionVersionsById: solutionVersionsById, CrossProjectReleaseFlyout: CrossProjectReleaseFlyout, ReleaseFlyout: ReleaseFlyout, mode: mode } = this.props;
            const versionType = (0, $lasT9.isVersionCrossProject)(version) && version.versions ? (0, $5rYNM.CROSS_PROJECT_RELEASE) : (0, $5rYNM.RELEASE);
            if (versionType === (0, $5rYNM.RELEASE) && version.end) {
                const { id: id, end: end } = version;
                const solutionVersion = solutionVersionsById[id];
                const solutionEnd = (0, $7CnHa.isDefined)(solutionVersion) ? solutionVersion.end : null;
                const slippage = versionType === (0, $5rYNM.RELEASE) && mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771) ? (0, $lasT9.calculateSlippage)(solutionEnd, end) : null;
                return ReleaseFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseFlyout, {
                    version: version,
                    solutionVersion: solutionVersion,
                    slippage: slippage,
                    onBackHandler: this.handleBack
                }) : null;
            }
            return CrossProjectReleaseFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CrossProjectReleaseFlyout, {
                crossProjectVersion: version,
                onBackHandler: this.handleBack
            }) : null;
        };
        this.handleFlyoutRequestClose = ()=>{
            const { toggleFlyout: toggleFlyout, versionIdsMapByDate: versionIdsMapByDate, endDate: endDate, type: type } = this.props;
            toggleFlyout(versionIdsMapByDate[endDate], type);
        };
        this.renderFlyout = ()=>{
            const { endDate: endDate, currentDayIndex: currentDayIndex, totalDays: totalDays, releaseBarState: { mode: flyoutType, versionIds: versionIds }, OverviewReleasesFlyout: // eslint-disable-next-line @typescript-eslint/no-shadow
            OverviewReleasesFlyout } = this.props;
            const { versions: versions, crossProjectVersions: crossProjectVersions } = this.mapVersionsById(versionIds);
            const allVersions = [
                ...versions,
                ...crossProjectVersions
            ];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: this.flyoutRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fHnVl.Navigation), {
                onPrev: ()=>{
                    this.navigateTo(endDate, 'prev');
                },
                onNext: ()=>{
                    this.navigateTo(endDate, 'next');
                },
                currentDayIndex: currentDayIndex,
                totalDays: totalDays,
                markerRef: this.ref
            }), flyoutType === (0, $50277156232634a9$export$8342016558eba865) && OverviewReleasesFlyout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OverviewReleasesFlyout, {
                versions: allVersions,
                date: Number(endDate),
                onPreviewRelease: (id, versionType)=>{
                    this.props.updateFlyout([
                        id
                    ], versionType, versionIds);
                }
            }) : this.getReleaseFlyout(allVersions[0]));
        };
        this.mapVersionsById = (ids)=>{
            const { crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById, solutionVersionsById: solutionVersionsById, mode: mode } = this.props;
            const crossProjectVersions = [];
            const versions = [];
            ids.forEach((id)=>{
                const version = versionsById[id];
                if (version) {
                    const end = version.end || (0, $lasT9.calculateEndVersionsDate)(version, solutionVersionsById, mode);
                    versions.push({
                        ...version,
                        end: end
                    });
                } else crossProjectVersions.push(crossProjectVersionsById[id]);
            });
            return {
                versions: versions,
                crossProjectVersions: crossProjectVersions
            };
        };
        this.getFlyoutWidth = ()=>{
            // use max-width for calculating flyout position when flyout width is not defined
            const { width: flyoutWidth = $ed95afb3d4db6539$var$DIALOG_MIN_WIDTH } = this.flyoutRef.current ? this.flyoutRef.current.getBoundingClientRect() : {};
            this.setState(()=>({
                    flyoutWidth: flyoutWidth
                }));
        };
    }
}

});
parcelRegister("jpQDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $57d7f0b93aed3215$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
function $57d7f0b93aed3215$export$2e2bcd8739ae039({ isOpen: isOpen, renderDialog: renderDialog, renderTrigger: renderTrigger, minLeft: minLeft }) {
    const ref = (0, $eUqFw.useRef)(null);
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const fakeTriggerStyle = {
        position: 'absolute',
        ...rect,
        pointerEvents: 'none'
    };
    const containerElement = document.body;
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && ref.current != null) {
            const { top: top, left: left, width: width, height: height } = ref.current.getBoundingClientRect();
            const maxLeft = window.innerWidth;
            const finalLeft = Math.min(Math.max(left, minLeft), maxLeft);
            const maxWidth = window.innerWidth - finalLeft;
            const finalWidth = Math.min(width, maxWidth);
            setRect({
                top: top,
                height: height,
                left: finalLeft,
                width: finalWidth
            });
        }
    }, [
        isOpen,
        minLeft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderTrigger(ref), isOpen && containerElement != null && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lEfVV.createPortal)(renderDialog(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: fakeTriggerStyle
    })), containerElement));
}

});

parcelRegister("kIzeJ", function(module, exports) {

$parcel$export(module.exports, "getFlyoutPosition", () => $59b80dc6fc398b63$export$42128c7073828e83);
const $59b80dc6fc398b63$export$42128c7073828e83 = (timelineWidth, leftPositionPercentage, flyoutWidth)=>{
    if (timelineWidth && timelineWidth - timelineWidth * leftPositionPercentage / 100 <= flyoutWidth) return 'bottom-end';
    return 'bottom-start';
};

});

parcelRegister("fHnVl", function(module, exports) {

$parcel$export(module.exports, "CrossProjectRelease", () => $416316d6161fd78b$export$4d045b8f9015a10);
$parcel$export(module.exports, "Navigation", () => $416316d6161fd78b$export$b8a61e5c71402559);
$parcel$export(module.exports, "OverviewReleases", () => $416316d6161fd78b$export$781433a82c4e6ed2);
$parcel$export(module.exports, "ProjectRelease", () => $416316d6161fd78b$export$172e15254bd94e8c);
$parcel$export(module.exports, "preload", () => $416316d6161fd78b$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $416316d6161fd78b$var$async = ()=>(parcelRequire("1nDtx"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncCrossProjectRelease = (0, $7rh0R.lazy)(()=>$416316d6161fd78b$var$async().then(({ CrossProjectRelease: CrossProjectRelease })=>CrossProjectRelease), {});
const $416316d6161fd78b$export$4d045b8f9015a10 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cross-project-release",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncCrossProjectRelease, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncNavigation = (0, $7rh0R.lazy)(()=>$416316d6161fd78b$var$async().then(({ Navigation: Navigation })=>Navigation), {});
const $416316d6161fd78b$export$b8a61e5c71402559 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncNavigation, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncOverviewReleases = (0, $7rh0R.lazy)(()=>$416316d6161fd78b$var$async().then(({ OverviewReleases: OverviewReleases })=>OverviewReleases), {});
const $416316d6161fd78b$export$781433a82c4e6ed2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "overview-releases",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncOverviewReleases, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncProjectRelease = (0, $7rh0R.lazy)(()=>// @ts-expect-error - TS2322 - Type 'Promise<(ComponentClass<Omit<{ projectsInPlan: number; prevVersionIds: string[]; highlightedVersionIds: string[]; issuesByVersion: IssuesByVersionMap; } & { toggleReleaseHighlight: (versionId: string) => { ...; }; }, "prevVersionIds" | ... 3 more ... | "issuesByVersion">> & { ...; }) | ComponentClass<...> | Function...' is not assignable to type 'ComponentType<Props> | JavaScriptModule<ComponentType<Props>> | Promise<ComponentType<Props> | JavaScriptModule<...>>'.
    $416316d6161fd78b$var$async().then(({ ProjectRelease: ProjectRelease })=>ProjectRelease), {});
const $416316d6161fd78b$export$172e15254bd94e8c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-release",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncProjectRelease, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncQuickFilterByRelease = (0, $7rh0R.lazy)(()=>$416316d6161fd78b$var$async().then(({ QuickFilterByRelease: QuickFilterByRelease })=>QuickFilterByRelease), {});
const $416316d6161fd78b$export$a7703d8b0600b572 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "quick-filter-by-release",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncQuickFilterByRelease, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $416316d6161fd78b$var$AsyncReleaseDates = (0, $7rh0R.lazy)(()=>$416316d6161fd78b$var$async().then(({ ReleaseDates: ReleaseDates })=>ReleaseDates), {});
const $416316d6161fd78b$export$6fbb35d9a76cc6f0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "release-dates",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($416316d6161fd78b$var$AsyncReleaseDates, props));
const $416316d6161fd78b$export$513ccb98c53b8039 = ()=>{
    $416316d6161fd78b$var$AsyncCrossProjectRelease.preload();
    $416316d6161fd78b$var$AsyncNavigation.preload();
    $416316d6161fd78b$var$AsyncOverviewReleases.preload();
    $416316d6161fd78b$var$AsyncProjectRelease.preload();
    $416316d6161fd78b$var$AsyncQuickFilterByRelease.preload();
    $416316d6161fd78b$var$AsyncReleaseDates.preload();
};

});
parcelRegister("1nDtx", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("eptbW")),
            load('gwaa1')
        ]);
        const value = parcelRequire('4pS4c');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("eptbW")),
        load("gwaa1")
    ]).then(()=>parcelRequire('4pS4c'));
}

});


parcelRegister("eVlrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a5134b2a43fe12$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ICON_TYPES", () => (parcelRequire("0eEBc")).ICON_TYPES);

var $eUqFw = parcelRequire("eUqFw");

var $14lY4 = parcelRequire("14lY4");

var $2qhQi = parcelRequire("2qhQi");

var $l2Sj2 = parcelRequire("l2Sj2");
var $eTbtL = parcelRequire("eTbtL");
var $gwbfD = parcelRequire("gwbfD");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $fii5o = parcelRequire("fii5o");

var $7Tdnd = parcelRequire("7Tdnd");

var $4ZRQI = parcelRequire("4ZRQI");

var $eUNyx = parcelRequire("eUNyx");

var $79F7f = parcelRequire("79F7f");

var $0eEBc = parcelRequire("0eEBc");
const $b1a5134b2a43fe12$var$typeToClassName = {
    [(0, $0eEBc.ICON_TYPES).UNRELEASED]: $79F7f.unreleasedSpa,
    [(0, $0eEBc.ICON_TYPES).RELEASED]: $79F7f.releasedSpa,
    [(0, $0eEBc.ICON_TYPES).ONTRACK]: $79F7f.onTrackSpa,
    [(0, $0eEBc.ICON_TYPES).OFFTRACK]: $79F7f.offTrackSpa
};
// eslint-disable-next-line jira/react/no-class-components
class $b1a5134b2a43fe12$var$ReleaseMarkerIcon extends (0, $eUqFw.Component) {
    render() {
        const { innerRef: innerRef, intl: intl, isHighlighted: isHighlighted, onClick: onClick, release: release, showTooltip: showTooltip = false, totalCount: totalCount, type: type } = this.props;
        const styleName = $b1a5134b2a43fe12$var$typeToClassName[type];
        const releaseName = totalCount === 1 && (0, $7CnHa.isDefined)(release) ? release.name : null;
        const icon = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            className: $79F7f.button,
            onClick: ()=>onClick()
        }, this.getIcon());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.icon",
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: innerRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $79F7f.marker
        }, totalCount > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $79F7f.number
        }, Math.min(totalCount, 99)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $79F7f.icon
        }, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $79F7f.releaseTooltip
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
                label: intl.formatMessage((0, $ib5d3.default).release),
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $79F7f.releaseTooltipName
            }, totalCount > 1 ? intl.formatMessage((0, $fii5o.default).releases, {
                numberOfReleases: totalCount
            }) : releaseName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $79F7f.releaseTooltipDate
            }, `(${(0, $l2Sj2.formatTimestampWithIntl)(intl, Number(this.props.endDate), (0, $eTbtL.shortDateFormat))})`)),
            truncate: true
        }, icon) : icon), isHighlighted === true && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$79F7f["timeline-highlight"]} ${styleName}`
        }));
    }
    constructor(...args){
        super(...args);
        this.getIcon = ()=>{
            const { totalCount: totalCount, type: type } = this.props;
            switch(type){
                case (0, $0eEBc.ICON_TYPES).UNRELEASED:
                case (0, $0eEBc.ICON_TYPES).ONTRACK:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZRQI.OnTrackIcon), null);
                case (0, $0eEBc.ICON_TYPES).RELEASED:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUNyx.ReleasedIcon), {
                        totalCount: totalCount
                    });
                case (0, $0eEBc.ICON_TYPES).OFFTRACK:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Tdnd.OffTrackIcon), {
                        totalCount: totalCount
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZRQI.OnTrackIcon), null);
            }
        };
    }
}
var $b1a5134b2a43fe12$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b1a5134b2a43fe12$var$ReleaseMarkerIcon);

});
parcelRegister("fii5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a317ff68bcfa571f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a317ff68bcfa571f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    releases: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.release-bar.marker.icon.releases",
        "defaultMessage": "{numberOfReleases, plural, one {{numberOfReleases} release} other {{numberOfReleases} releases}}"
    }
});

});

parcelRegister("7Tdnd", function(module, exports) {

$parcel$export(module.exports, "OffTrackIcon", () => $a46f47ebd6ccc866$export$9e19a5a781ddb256);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $a46f47ebd6ccc866$export$9e19a5a781ddb256 = ({ totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-danger, ${(0, $PdmhA.R400)})`,
        cx: 12,
        cy: 12,
        r: 7
    }), totalCount === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    })));

});

parcelRegister("4ZRQI", function(module, exports) {

$parcel$export(module.exports, "OnTrackIcon", () => $26264fe2f6cbc7a5$export$bc19b352e3a970e3);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $26264fe2f6cbc7a5$export$bc19b352e3a970e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-information, ${(0, $PdmhA.B400)})`,
        cx: 12,
        cy: 12,
        r: 7
    })));

});

parcelRegister("eUNyx", function(module, exports) {

$parcel$export(module.exports, "ReleasedIcon", () => $49fce31315a26b7d$export$b7ea68e2486fd486);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $49fce31315a26b7d$export$b7ea68e2486fd486 = ({ totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-success, ${(0, $PdmhA.G400)})`,
        cx: 12,
        cy: 12,
        r: 7
    }), totalCount === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.28 11.91a.698.698 0 0 0-1.06 0 .9.9 0 0 0 0 1.18l1.5 1.666a.698.698 0 0 0 1.06 0l3-3.333a.9.9 0 0 0 0-1.179.698.698 0 0 0-1.06 0l-2.47 2.744-.97-1.077z",
        fill: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
    })));

});

parcelRegister("79F7f", function(module, exports) {

$parcel$export(module.exports, "button", () => $53594469bbfc1c40$export$2ba01fb71ed41cb6, (v) => $53594469bbfc1c40$export$2ba01fb71ed41cb6 = v);
$parcel$export(module.exports, "icon", () => $53594469bbfc1c40$export$1ca1ec8b29a4ce27, (v) => $53594469bbfc1c40$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "marker", () => $53594469bbfc1c40$export$ffc4d0086f1a4c9, (v) => $53594469bbfc1c40$export$ffc4d0086f1a4c9 = v);
$parcel$export(module.exports, "number", () => $53594469bbfc1c40$export$98e628dec113755e, (v) => $53594469bbfc1c40$export$98e628dec113755e = v);
$parcel$export(module.exports, "offTrackSpa", () => $53594469bbfc1c40$export$52dc3309278578d6, (v) => $53594469bbfc1c40$export$52dc3309278578d6 = v);
$parcel$export(module.exports, "onTrackSpa", () => $53594469bbfc1c40$export$a464d72f81a24b05, (v) => $53594469bbfc1c40$export$a464d72f81a24b05 = v);
$parcel$export(module.exports, "releaseTooltip", () => $53594469bbfc1c40$export$829d3d179a7c0145, (v) => $53594469bbfc1c40$export$829d3d179a7c0145 = v);
$parcel$export(module.exports, "releaseTooltipDate", () => $53594469bbfc1c40$export$ac3c726209525cbe, (v) => $53594469bbfc1c40$export$ac3c726209525cbe = v);
$parcel$export(module.exports, "releaseTooltipName", () => $53594469bbfc1c40$export$113aec36574c607c, (v) => $53594469bbfc1c40$export$113aec36574c607c = v);
$parcel$export(module.exports, "releasedSpa", () => $53594469bbfc1c40$export$3ade0ee46fc07220, (v) => $53594469bbfc1c40$export$3ade0ee46fc07220 = v);
$parcel$export(module.exports, "timeline-highlight", () => $53594469bbfc1c40$export$29dd82e5678ebfaa, (v) => $53594469bbfc1c40$export$29dd82e5678ebfaa = v);
$parcel$export(module.exports, "unreleasedSpa", () => $53594469bbfc1c40$export$9ea42929461af5b, (v) => $53594469bbfc1c40$export$9ea42929461af5b = v);
var $53594469bbfc1c40$export$2ba01fb71ed41cb6;
var $53594469bbfc1c40$export$1ca1ec8b29a4ce27;
var $53594469bbfc1c40$export$ffc4d0086f1a4c9;
var $53594469bbfc1c40$export$98e628dec113755e;
var $53594469bbfc1c40$export$cd48b0013ee54170;
var $53594469bbfc1c40$export$52dc3309278578d6;
var $53594469bbfc1c40$export$8e8c195be1d237dd;
var $53594469bbfc1c40$export$a464d72f81a24b05;
var $53594469bbfc1c40$export$829d3d179a7c0145;
var $53594469bbfc1c40$export$ac3c726209525cbe;
var $53594469bbfc1c40$export$113aec36574c607c;
var $53594469bbfc1c40$export$20319b0a6bbbd02c;
var $53594469bbfc1c40$export$3ade0ee46fc07220;
var $53594469bbfc1c40$export$29dd82e5678ebfaa;
var $53594469bbfc1c40$export$975896b31953f2ae;
var $53594469bbfc1c40$export$9ea42929461af5b;
$53594469bbfc1c40$export$2ba01fb71ed41cb6 = `N8JWya_button`;
$53594469bbfc1c40$export$1ca1ec8b29a4ce27 = `N8JWya_icon`;
$53594469bbfc1c40$export$ffc4d0086f1a4c9 = `N8JWya_marker`;
$53594469bbfc1c40$export$98e628dec113755e = `N8JWya_number`;
$53594469bbfc1c40$export$cd48b0013ee54170 = `N8JWya_offTrack`;
$53594469bbfc1c40$export$52dc3309278578d6 = `N8JWya_offTrackSpa`;
$53594469bbfc1c40$export$8e8c195be1d237dd = `N8JWya_onTrack`;
$53594469bbfc1c40$export$a464d72f81a24b05 = `N8JWya_onTrackSpa`;
$53594469bbfc1c40$export$829d3d179a7c0145 = `N8JWya_releaseTooltip`;
$53594469bbfc1c40$export$ac3c726209525cbe = `N8JWya_releaseTooltipDate`;
$53594469bbfc1c40$export$113aec36574c607c = `N8JWya_releaseTooltipName`;
$53594469bbfc1c40$export$20319b0a6bbbd02c = `N8JWya_released`;
$53594469bbfc1c40$export$3ade0ee46fc07220 = `N8JWya_releasedSpa`;
$53594469bbfc1c40$export$29dd82e5678ebfaa = `N8JWya_timeline-highlight`;
$53594469bbfc1c40$export$975896b31953f2ae = `N8JWya_unreleased`;
$53594469bbfc1c40$export$9ea42929461af5b = `N8JWya_unreleasedSpa`;

});

parcelRegister("0eEBc", function(module, exports) {

$parcel$export(module.exports, "ICON_TYPES", () => $f8d009f424dc8696$export$67e1fb76bc6def93);
const $f8d009f424dc8696$var$UNRELEASED = 'UNRELEASED';
const $f8d009f424dc8696$var$RELEASED = 'RELEASED';
const $f8d009f424dc8696$var$ONTRACK = 'ONTRACK';
const $f8d009f424dc8696$var$OFFTRACK = 'OFFTRACK';
const $f8d009f424dc8696$export$67e1fb76bc6def93 = {
    UNRELEASED: $f8d009f424dc8696$var$UNRELEASED,
    RELEASED: $f8d009f424dc8696$var$RELEASED,
    ONTRACK: $f8d009f424dc8696$var$ONTRACK,
    OFFTRACK: $f8d009f424dc8696$var$OFFTRACK
};

});


parcelRegister("fqPTT", function(module, exports) {

$parcel$export(module.exports, "main", () => $b3c18b1253b250b7$export$f22da7240b7add18, (v) => $b3c18b1253b250b7$export$f22da7240b7add18 = v);
var $b3c18b1253b250b7$export$f22da7240b7add18;
$b3c18b1253b250b7$export$f22da7240b7add18 = `h7JH4W_main`;

});



parcelRegister("4GUOr", function(module, exports) {

$parcel$export(module.exports, "main", () => $36a727774ae31460$export$f22da7240b7add18, (v) => $36a727774ae31460$export$f22da7240b7add18 = v);
$parcel$export(module.exports, "transposed", () => $36a727774ae31460$export$6220fe35ddf63109, (v) => $36a727774ae31460$export$6220fe35ddf63109 = v);
var $36a727774ae31460$export$f22da7240b7add18;
var $36a727774ae31460$export$6220fe35ddf63109;
$36a727774ae31460$export$f22da7240b7add18 = `jzvgOW_main`;
$36a727774ae31460$export$6220fe35ddf63109 = `jzvgOW_transposed`;

});



parcelRegister("4hwn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bcc39b16ab0322$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $da8ZQ = parcelRequire("da8ZQ");

var $g1BzZ = parcelRequire("g1BzZ");
var $12bcc39b16ab0322$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $da8ZQ.default), {})((0, $g1BzZ.default));

});
parcelRegister("da8ZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41369d6352f8f237$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $aMoMC = parcelRequire("aMoMC");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $41369d6352f8f237$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    solutionVersionsById: (0, $wcCGG.getSolutionVersionsById),
    timelineRange: (0, $aMoMC.getTimelineRange),
    crossProjectVersionsById: (0, $2Ruxt.getEnrichedCrossProjectVersionsById),
    versionsById: (0, $wcCGG.getEnrichedVersionsById),
    highlightedVersionIds: (state)=>(0, $9H2AP.getHighlightedVersionsViewSettings)(state).versions
});

});

parcelRegister("g1BzZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d80dd36562ad06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $1ybV0 = parcelRequire("1ybV0");

var $lasT9 = parcelRequire("lasT9");
var $84GMP = parcelRequire("84GMP");
parcelRequire("areZp");
var $4j1D2 = parcelRequire("4j1D2");
var $areZp = parcelRequire("areZp");

var $b50FU = parcelRequire("b50FU");
const $41d80dd36562ad06$var$typeToClassNameSpa = {
    [(0, $84GMP.ICON_TYPES).UNRELEASED]: $b50FU.unreleasedSpa,
    [(0, $84GMP.ICON_TYPES).RELEASED]: $b50FU.releasedSpa,
    [(0, $84GMP.ICON_TYPES).ONTRACK]: $b50FU.onTrackSpa,
    [(0, $84GMP.ICON_TYPES).OFFTRACK]: $b50FU.offTrackSpa
};
class $41d80dd36562ad06$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { endDate: endDate, mode: mode, solutionVersionsById: solutionVersionsById, timelineRange: timelineRange, versionIdsMapByDate: versionIdsMapByDate, highlightedVersionIds: highlightedVersionIds } = this.props;
        const isHighlighted = versionIdsMapByDate[endDate] && versionIdsMapByDate[endDate].find((versionId)=>highlightedVersionIds.some((vid)=>vid === versionId));
        if (!isHighlighted) return null;
        const leftPositionPercentage = (0, $lasT9.calculateLeftPositionPercentage)(Number(endDate), timelineRange);
        const mappedVersions = this.mapVersionsById(versionIdsMapByDate[endDate]);
        const { versions: versions, crossProjectVersions: crossProjectVersions } = mappedVersions;
        const versionFlyoutType = (0, $lasT9.getVersionFlyoutType)([
            ...versions,
            ...crossProjectVersions
        ]);
        const type = (0, $lasT9.getMarkerTypeIcon)(mappedVersions, mode, versionFlyoutType, solutionVersionsById);
        // Consider remove this function when cleaning up com.atlassian.rm.jpo.transposition.m2
        const withZIndexOverride = (children)=>{
            if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $areZp.ZIndex), {
                layer: (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS
            }, (zIndex)=>children(zIndex ?? 'initial'));
        };
        return withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($b50FU.marker, (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2') && $b50FU.transposed, $41d80dd36562ad06$var$typeToClassNameSpa[type]),
                style: {
                    left: `calc(${leftPositionPercentage}% - 1px)`,
                    zIndex: zIndex
                }
            }));
    }
    constructor(...args){
        super(...args);
        this.mapVersionsById = (ids)=>{
            const { crossProjectVersionsById: crossProjectVersionsById, versionsById: versionsById } = this.props;
            const crossProjectVersions = [];
            const versions = [];
            ids.forEach((id)=>{
                const version = versionsById[id];
                if (version) versions.push(version);
                else crossProjectVersions.push(crossProjectVersionsById[id]);
            });
            return {
                versions: versions,
                crossProjectVersions: crossProjectVersions
            };
        };
    }
}

});
parcelRegister("b50FU", function(module, exports) {

$parcel$export(module.exports, "marker", () => $8110af5e665de23d$export$ffc4d0086f1a4c9, (v) => $8110af5e665de23d$export$ffc4d0086f1a4c9 = v);
$parcel$export(module.exports, "offTrackSpa", () => $8110af5e665de23d$export$52dc3309278578d6, (v) => $8110af5e665de23d$export$52dc3309278578d6 = v);
$parcel$export(module.exports, "onTrackSpa", () => $8110af5e665de23d$export$a464d72f81a24b05, (v) => $8110af5e665de23d$export$a464d72f81a24b05 = v);
$parcel$export(module.exports, "releasedSpa", () => $8110af5e665de23d$export$3ade0ee46fc07220, (v) => $8110af5e665de23d$export$3ade0ee46fc07220 = v);
$parcel$export(module.exports, "transposed", () => $8110af5e665de23d$export$6220fe35ddf63109, (v) => $8110af5e665de23d$export$6220fe35ddf63109 = v);
$parcel$export(module.exports, "unreleasedSpa", () => $8110af5e665de23d$export$9ea42929461af5b, (v) => $8110af5e665de23d$export$9ea42929461af5b = v);
var $8110af5e665de23d$export$ffc4d0086f1a4c9;
var $8110af5e665de23d$export$52dc3309278578d6;
var $8110af5e665de23d$export$a464d72f81a24b05;
var $8110af5e665de23d$export$3ade0ee46fc07220;
var $8110af5e665de23d$export$6220fe35ddf63109;
var $8110af5e665de23d$export$9ea42929461af5b;
$8110af5e665de23d$export$ffc4d0086f1a4c9 = `VTbVHG_marker`;
$8110af5e665de23d$export$52dc3309278578d6 = `VTbVHG_offTrackSpa`;
$8110af5e665de23d$export$a464d72f81a24b05 = `VTbVHG_onTrackSpa`;
$8110af5e665de23d$export$3ade0ee46fc07220 = `VTbVHG_releasedSpa`;
$8110af5e665de23d$export$6220fe35ddf63109 = `VTbVHG_transposed`;
$8110af5e665de23d$export$9ea42929461af5b = `VTbVHG_unreleasedSpa`;

});



parcelRegister("cEecN", function(module, exports) {

$parcel$export(module.exports, "DndItemProvider", () => (parcelRequire("2p1Yc")).default);
$parcel$export(module.exports, "useDndItem", () => (parcelRequire("3qL2F")).useDndItem);
// Remove this with com.atlassian.rm.jpo.transposition.m2 cleanup
parcelRequire("3qL2F");
var $2p1Yc = parcelRequire("2p1Yc");
var $3qL2F = parcelRequire("3qL2F");

});
parcelRegister("3qL2F", function(module, exports) {

$parcel$export(module.exports, "useDndItem", () => $29185f45c5841830$export$79384f8998c974df);
$parcel$export(module.exports, "default", () => (parcelRequire("2p1Yc")).default);

var $eUqFw = parcelRequire("eUqFw");

var $5AZCG = parcelRequire("5AZCG");

var $2p1Yc = parcelRequire("2p1Yc");
function $29185f45c5841830$export$79384f8998c974df() {
    return (0, $eUqFw.useContext)((0, $5AZCG.context));
}

});
parcelRegister("5AZCG", function(module, exports) {

$parcel$export(module.exports, "context", () => $cd4762515070bafe$export$a078c61943f9dbbe);

var $eUqFw = parcelRequire("eUqFw");
const $cd4762515070bafe$export$a078c61943f9dbbe = /*#__PURE__*/ (0, $eUqFw.createContext)({
    id: {
        scopeIndex: -1,
        issueId: ''
    }
});

});

parcelRegister("2p1Yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fc2dc8ad72f102$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5AZCG = parcelRequire("5AZCG");
function $a4fc2dc8ad72f102$export$2e2bcd8739ae039({ scopeIndex: scopeIndex, issueId: issueId, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AZCG.context).Provider, {
        value: {
            id: {
                scopeIndex: scopeIndex,
                issueId: issueId
            }
        }
    }, children);
}

});



parcelRegister("fnOfj", function(module, exports) {

$parcel$export(module.exports, "injectIntlWithDefaultProps", () => $b6fc8b1bec450094$export$c4e12df8dd8762cd);

var $2qhQi = parcelRequire("2qhQi");
function $b6fc8b1bec450094$export$c4e12df8dd8762cd(WrappedComponent) {
    return (0, $2qhQi.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    WrappedComponent);
}

});

parcelRegister("2yCq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $12f2f286b408e89f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9kCPD = parcelRequire("9kCPD");

var $ego8E = parcelRequire("ego8E");

var $7T29J = parcelRequire("7T29J");
var $12f2f286b408e89f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ego8E.default), (0, $9kCPD.default))((0, $7T29J.default));

});
parcelRegister("9kCPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ea97432d9be3ea$export$2e2bcd8739ae039);

var $eTbtL = parcelRequire("eTbtL");
parcelRequire("dWez3");
var $hHEgb = parcelRequire("hHEgb");
const $30ea97432d9be3ea$var$mapDispatchToProps = (dispatch)=>({
        onTimeScaleOptionChange: (payload)=>dispatch({
                type: (0, $hHEgb.CHANGE_OPTION),
                payload: payload
            }),
        onTimeScaleCustomDatesChange: (payload)=>dispatch({
                type: (0, $hHEgb.CHANGE_CUSTOM_DATES),
                payload: {
                    ...payload,
                    typeOfCustomDateRange: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED
                }
            })
    });
var $30ea97432d9be3ea$export$2e2bcd8739ae039 = $30ea97432d9be3ea$var$mapDispatchToProps;

});

parcelRegister("ego8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $62351bcfc98c3207$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
var $62351bcfc98c3207$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $akhOi.getMode),
    timelineRange: (0, $aMoMC.getTimelineRange)
});

});

parcelRegister("7T29J", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb5cdf054c32ab7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("akhOi");

var $a0bo1 = parcelRequire("a0bo1");

var $57dZR = parcelRequire("57dZR");

var $33N5G = parcelRequire("33N5G");
parcelRequire("dAQ0b");
var $dQRw5 = parcelRequire("dQRw5");
parcelRequire("6oTYo");
var $40aEf = parcelRequire("40aEf");

var $lfpk1 = parcelRequire("lfpk1");
/** The vertical scrollbar width. */ const $7eb5cdf054c32ab7$var$SCROLLBAR_WIDTH = 18;
/** The width of the arrow icons. */ const $7eb5cdf054c32ab7$var$ARROW_WIDTH = 24;
/** The padding to allow space for the active dependency marker. */ const $7eb5cdf054c32ab7$var$DEPENDENCY_MARKER_PADDING = 24;
const $7eb5cdf054c32ab7$var$margin = {
    left: 0,
    right: $7eb5cdf054c32ab7$var$SCROLLBAR_WIDTH
};
const $7eb5cdf054c32ab7$var$getRowOffset = (index, rowHeight)=>{
    let result = (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2') ? 90 : 0;
    for(let i = 0; i < index; i++)result += rowHeight(i);
    return result;
};
function $7eb5cdf054c32ab7$export$2e2bcd8739ae039({ rowHeight: rowHeight, containerWidth: containerWidthFromProps, scope: scope, timelineRange: timelineRange, onTimeScaleCustomDatesChange: onTimeScaleCustomDatesChange, onTimeScaleOptionChange: onTimeScaleOptionChange, verticalRenderingWindow: verticalRenderingWindow, mode: mode, virtualizedRows: virtualizedRows }) {
    const containerWidth = (0, $lfpk1.useContainerWidth)(containerWidthFromProps);
    const viewportWidth = (0, $lfpk1.useViewportWidth)(containerWidth);
    const viewportTimelineRange = (0, $lfpk1.useViewportTimelineRange)(timelineRange);
    const isOptimized = mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771);
    const onArrowClick = (0, $lfpk1.useArrowClickHandler)({
        changeTimeScaleCustomDates: onTimeScaleCustomDatesChange,
        changeTimeScaleOption: onTimeScaleOptionChange,
        viewportWidth: viewportWidth,
        containerWidth: containerWidth,
        viewport: viewportTimelineRange
    });
    const msPerPx = (viewportTimelineRange.end - viewportTimelineRange.start) / viewportWidth;
    const start = viewportTimelineRange.start;
    const end = viewportTimelineRange.end - $7eb5cdf054c32ab7$var$SCROLLBAR_WIDTH * msPerPx;
    const innerRange = {
        start: start,
        end: end
    };
    const isArrowOnTheBar = (direction, baselineStart, baselineEnd)=>{
        switch(direction){
            case 'left':
                return baselineEnd != null && baselineEnd > innerRange.start + $7eb5cdf054c32ab7$var$ARROW_WIDTH * msPerPx;
            case 'right':
                return baselineStart != null && baselineStart < innerRange.end - $7eb5cdf054c32ab7$var$ARROW_WIDTH * msPerPx;
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return direction;
        }
    };
    const renderArrow = ({ offsetY: offsetY, color: color, baselineStart: baselineStart, baselineEnd: baselineEnd, issueKey: issueKey })=>// False-positive :/
        // eslint-disable-next-line react/no-unstable-nested-components
        (direction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $40aEf.default), {
                direction: direction,
                baselineStart: baselineStart,
                baselineEnd: baselineEnd,
                timelineRange: innerRange
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQRw5.default), {
                color: color,
                issueKey: issueKey,
                transparent: isArrowOnTheBar(direction, baselineStart, baselineEnd),
                direction: direction,
                width: $7eb5cdf054c32ab7$var$ARROW_WIDTH,
                offsetY: offsetY,
                onClick: ()=>onArrowClick(direction, {
                        start: baselineStart,
                        end: baselineEnd
                    }, $7eb5cdf054c32ab7$var$margin[direction] + $7eb5cdf054c32ab7$var$DEPENDENCY_MARKER_PADDING),
                margin: $7eb5cdf054c32ab7$var$margin
            }));
    const renderRow = (index, { offsetY: offsetY })=>{
        const issue = scope[index];
        if (issue == null) return null;
        switch(issue.tag){
            case 0, $a0bo1.TABLE_ISSUE:
                {
                    const { baselineStart: baselineStart, baselineEnd: baselineEnd, issueKey: issueKey, optimized: optimized } = issue.value;
                    let hasOptimizedChanges = false;
                    if (isOptimized && optimized) {
                        for (const [optimizedKey, optimizedValue] of Object.entries(optimized))if ((0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue.value, optimizedKey), optimizedValue)) {
                            hasOptimizedChanges = true;
                            break;
                        }
                    }
                    const minDate = baselineStart ?? baselineEnd;
                    const maxDate = baselineEnd ?? baselineStart;
                    const hasLeftArrow = minDate != null && minDate < innerRange.start;
                    const hasRightArrow = maxDate != null && maxDate > innerRange.end;
                    const arrow = renderArrow({
                        offsetY: offsetY,
                        color: hasOptimizedChanges ? (0, $33N5G.OPTIMIZED_COLOR) : undefined,
                        baselineStart: baselineStart,
                        baselineEnd: baselineEnd,
                        issueKey: issueKey
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                        key: index
                    }, hasLeftArrow && arrow('left'), hasRightArrow && arrow('right'));
                }
            default:
                return null;
        }
    };
    if (!Number.isFinite(verticalRenderingWindow.overscanStopIndex)) return null;
    const rows = [];
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) virtualizedRows?.forEach((rowIndex)=>{
        rows.push(renderRow(rowIndex, {
            offsetY: $7eb5cdf054c32ab7$var$getRowOffset(rowIndex, rowHeight)
        }));
    });
    else for(let i = verticalRenderingWindow.overscanStartIndex; i <= verticalRenderingWindow.overscanStopIndex; i++)rows.push(renderRow(i, {
        offsetY: $7eb5cdf054c32ab7$var$getRowOffset(i, rowHeight)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, rows);
}

});
parcelRegister("dAQ0b", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("dQRw5")).default);

var $dQRw5 = parcelRequire("dQRw5");

});
parcelRegister("dQRw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9a156433744fdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fyp42 = parcelRequire("fyp42");

var $k4jc8 = parcelRequire("k4jc8");

var $5CV7v = parcelRequire("5CV7v");

var $jUDBw = parcelRequire("jUDBw");
/** Returns a click handler that is permanently unchanged. */ function $7b9a156433744fdb$var$useLazyClickHandler(onClick) {
    const cachedClickHandlerRef = (0, $eUqFw.useRef)(onClick);
    (0, $eUqFw.useEffect)(()=>{
        cachedClickHandlerRef.current = onClick;
    }, [
        onClick
    ]);
    return (0, $eUqFw.useCallback)(()=>cachedClickHandlerRef.current(), []);
}
function $7b9a156433744fdb$export$2e2bcd8739ae039({ direction: direction, transparent: transparent, color: color, issueKey: issueKey = 0, width: width, offsetY: offsetY, margin: margin, onClick: onClick }) {
    const iconColor = transparent === true ? 'transparent' : color;
    const handleClick = $7b9a156433744fdb$var$useLazyClickHandler(onClick);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $jUDBw.root,
        style: {
            width: width,
            top: offsetY,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop: "var(--ds-space-100, 8px)",
            left: direction === 'left' ? margin.left : undefined,
            right: direction === 'right' ? margin.right : undefined
        },
        "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.arrows.${direction}.${issueKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b9a156433744fdb$var$Inner, {
        direction: direction,
        iconColor: iconColor,
        onClick: handleClick
    }));
}
/**
 * Returns the inner child for the arrow.
 * Rerendering costs heap, so we need to split and use the memo()
 */ const $7b9a156433744fdb$var$Inner = /*#__PURE__*/ (0, $eUqFw.memo)(({ direction: direction, iconColor: iconColor, onClick: onClick })=>{
    const ArrowIcon = direction === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fyp42))) : (0, (/*@__PURE__*/$parcel$interopDefault($k4jc8)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ArrowIcon, {
        label: "",
        primaryColor: iconColor
    }));
});

});
parcelRegister("jUDBw", function(module, exports) {

$parcel$export(module.exports, "root", () => $e7f1f7d97370a1de$export$e8e78c978b129247, (v) => $e7f1f7d97370a1de$export$e8e78c978b129247 = v);
var $e7f1f7d97370a1de$export$e8e78c978b129247;
$e7f1f7d97370a1de$export$e8e78c978b129247 = `zWKwda_root`;

});



parcelRegister("6oTYo", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("40aEf")).default);

var $40aEf = parcelRequire("40aEf");

});
parcelRegister("40aEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed1287492ddea84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $bo7IP = parcelRequire("bo7IP");
var $l2Sj2 = parcelRequire("l2Sj2");
var $gwbfD = parcelRequire("gwbfD");
var $eTbtL = parcelRequire("eTbtL");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $4xHig = parcelRequire("4xHig");

var $dWabo = parcelRequire("dWabo");
function $8ed1287492ddea84$var$useTooltip({ direction: direction, baselineStart: baselineStart, baselineEnd: baselineEnd, timelineRange: timelineRange }) {
    const locale = (0, $4xHig.useLocale)();
    const intl = (0, $5JgJ2.default)();
    const formatDate = (value)=>(0, $l2Sj2.formatTimestampWithIntl)(intl, value, (0, $eTbtL.weekdayFormat));
    const localeOptions = {
        locale: (0, $8K9kM.getLocale)(locale)
    };
    switch(direction){
        case 'left':
            if ((0, $7CnHa.isDefined)(baselineStart) && baselineStart < timelineRange.start && (0, $7CnHa.isDefined)(baselineEnd) && baselineEnd < timelineRange.start) return intl.formatMessage((0, $ib5d3.default).datesOutsideRange);
            if ((0, $7CnHa.isDefined)(baselineStart) && baselineStart < timelineRange.start) return intl.formatMessage((0, $dWabo.default).startDateAgo, {
                date: formatDate(baselineStart),
                dateDistance: (0, $bo7IP.default)(baselineStart, localeOptions)
            });
            if ((0, $7CnHa.isDefined)(baselineEnd) && baselineEnd < timelineRange.start) return intl.formatMessage((0, $dWabo.default).endDateAgo, {
                date: formatDate(baselineEnd),
                dateDistance: (0, $bo7IP.default)(baselineEnd, localeOptions)
            });
            return '';
        case 'right':
            if ((0, $7CnHa.isDefined)(baselineStart) && baselineStart > timelineRange.end && (0, $7CnHa.isDefined)(baselineEnd) && baselineEnd > timelineRange.end) return intl.formatMessage((0, $ib5d3.default).datesOutsideRange);
            if ((0, $7CnHa.isDefined)(baselineStart) && baselineStart > timelineRange.end) return intl.formatMessage((0, $dWabo.default).startDateFromNow, {
                date: formatDate(baselineStart),
                dateDistance: (0, $bo7IP.default)(baselineStart, localeOptions)
            });
            if ((0, $7CnHa.isDefined)(baselineEnd) && baselineEnd > timelineRange.end) return intl.formatMessage((0, $dWabo.default).endDateFromNow, {
                date: formatDate(baselineEnd),
                dateDistance: (0, $bo7IP.default)(baselineEnd, localeOptions)
            });
            return '';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return direction;
    }
}
function $8ed1287492ddea84$export$2e2bcd8739ae039(props) {
    const { direction: direction, children: children } = props;
    const tooltip = $8ed1287492ddea84$var$useTooltip(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip,
        position: direction
    }, children);
}

});
parcelRegister("dWabo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6948416a88a6eb6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d6948416a88a6eb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateAgo: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.start-date-ago",
        "defaultMessage": "Start: {date} ({dateDistance} ago)"
    },
    endDateAgo: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.end-date-ago",
        "defaultMessage": "End: {date} ({dateDistance} ago)"
    },
    startDateFromNow: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.start-date-from-now",
        "defaultMessage": "Start: {date} ({dateDistance} from now)"
    },
    endDateFromNow: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.arrows.tooltip.end-date-from-now",
        "defaultMessage": "End: {date} ({dateDistance} from now)"
    }
});

});



parcelRegister("lfpk1", function(module, exports) {

$parcel$export(module.exports, "useViewportTimelineRange", () => $9bd9091ebe702ed9$export$bdcb02269305b088);
$parcel$export(module.exports, "useViewportWidth", () => $9bd9091ebe702ed9$export$3ce37a513c68c53);
$parcel$export(module.exports, "useContainerWidth", () => $9bd9091ebe702ed9$export$7ed924c3d8496d63);
$parcel$export(module.exports, "useArrowClickHandler", () => $9bd9091ebe702ed9$export$37ceb294125f662e);

var $17L5s = parcelRequire("17L5s");

var $jODJR = parcelRequire("jODJR");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
/** Returns the new value of viewport start time that the left arrow is trying to get to when being clicked.  */ const $9bd9091ebe702ed9$var$getDestinationForLeftArrow = ({ issue: issue, viewport: viewport, viewportWidth: viewportWidth, containerWidth: containerWidth, paddingSize: paddingSize, shouldTimelineRangeExpand: shouldTimelineRangeExpand = false })=>{
    const { start: issueStart, end: issueEnd } = issue;
    const { start: viewportStart, end: viewportEnd } = viewport;
    const msPerPx = (()=>{
        if (shouldTimelineRangeExpand) {
            if ((0, $7CnHa.isDefined)(issueStart)) return (viewportEnd - issueStart) / (viewportWidth - paddingSize);
            if ((0, $7CnHa.isDefined)(issueEnd)) {
                const issueBarWidth = containerWidth * 0.3;
                return (viewportEnd - issueEnd) / (viewportWidth - paddingSize - issueBarWidth);
            }
            return viewport.start;
        }
        return (viewportEnd - viewportStart) / viewportWidth;
    })();
    const paddingSizeInMs = paddingSize * msPerPx;
    if ((0, $7CnHa.isDefined)(issueStart)) return issueStart - paddingSizeInMs;
    if ((0, $7CnHa.isDefined)(issueEnd)) {
        const issueBarWidth = containerWidth * 0.3;
        const issueBarWidthInMs = issueBarWidth * msPerPx;
        return issueEnd - issueBarWidthInMs - paddingSizeInMs;
    }
    return viewport.start;
};
/** Returns the new value of viewport end time that the right arrow is trying to get to when being clicked.  */ const $9bd9091ebe702ed9$var$getDestinationForRightArrow = ({ issue: issue, viewport: viewport, viewportWidth: viewportWidth, containerWidth: containerWidth, paddingSize: paddingSize, shouldTimelineRangeExpand: shouldTimelineRangeExpand = false })=>// Flip the timeline in a mirror and click on the left arrow instead.
    0 - $9bd9091ebe702ed9$var$getDestinationForLeftArrow({
        issue: {
            start: issue.end == null ? issue.end : -issue.end,
            end: issue.start == null ? issue.start : -issue.start
        },
        viewport: {
            start: -viewport.end,
            end: -viewport.start
        },
        viewportWidth: viewportWidth,
        containerWidth: containerWidth,
        paddingSize: paddingSize,
        shouldTimelineRangeExpand: shouldTimelineRangeExpand
    });
/**
 * Returns the destination getter depends on quick direction the arrow is.
 * checkout `getDestinationForLeftArrow` and `getDestinationForRightArrow` for more information.
 */ const $9bd9091ebe702ed9$var$getDestination = (direction)=>{
    switch(direction){
        case 'left':
            return $9bd9091ebe702ed9$var$getDestinationForLeftArrow;
        case 'right':
            return $9bd9091ebe702ed9$var$getDestinationForRightArrow;
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return direction;
    }
};
function $9bd9091ebe702ed9$export$bdcb02269305b088(fallback) {
    const [{ zoomLevel: zoomLevel, viewport: viewport, today: today }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ pxToMs: pxToMs }] = (0, $jODJR.useTimelineRuler)();
    return zoomLevel ? {
        start: today + viewport.offset,
        end: today + viewport.offset + pxToMs(viewport.width)
    } : fallback;
}
function $9bd9091ebe702ed9$export$3ce37a513c68c53(fallback) {
    const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    if (zoomLevel === undefined) return fallback;
    return viewport.width;
}
function $9bd9091ebe702ed9$export$7ed924c3d8496d63(fallback) {
    const [{ zoomLevel: zoomLevel, container: container }] = (0, $jODJR.useHorizontalScrolling)();
    if (zoomLevel === undefined) return fallback;
    return container.width;
}
function $9bd9091ebe702ed9$export$37ceb294125f662e({ changeTimeScaleCustomDates: changeTimeScaleCustomDates, changeTimeScaleOption: changeTimeScaleOption, viewportWidth: viewportWidth, containerWidth: containerWidth, viewport: viewport }) {
    const [{ zoomLevel: zoomLevel }, { setViewportOffset: setViewportOffset }] = (0, $jODJR.useHorizontalScrolling)();
    const isHorizontalScrollable = zoomLevel !== undefined;
    return (direction, issue, paddingSize)=>{
        // Get the timestamp that the arrow are trying to get to.
        const destination = $9bd9091ebe702ed9$var$getDestination(direction)({
            issue: issue,
            viewport: viewport,
            viewportWidth: viewportWidth,
            containerWidth: containerWidth,
            paddingSize: paddingSize,
            shouldTimelineRangeExpand: !isHorizontalScrollable
        });
        if (!isHorizontalScrollable) {
            changeTimeScaleOption((0, $5rYNM.TIMELINE_MODES).CUSTOM);
            switch(direction){
                case 'left':
                    changeTimeScaleCustomDates({
                        fromDate: (0, $17L5s.startOfUtcDay)(destination),
                        toDate: viewport.end
                    });
                    break;
                case 'right':
                    changeTimeScaleCustomDates({
                        fromDate: viewport.start,
                        toDate: (0, $17L5s.endOfUtcDay)(destination) + 1
                    });
                    break;
                default:
                    // prettier-ignore
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return direction;
            }
        } else switch(direction){
            case 'left':
                return setViewportOffset((offset)=>offset + destination - viewport.start, 'arrow');
            case 'right':
                return setViewportOffset((offset)=>offset + destination - viewport.end, 'arrow');
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return direction;
        }
    };
}

});



parcelRegister("8WLEK", function(module, exports) {

$parcel$export(module.exports, "DependencyLinesProvider", () => (parcelRequire("8mSKC")).default);
$parcel$export(module.exports, "DependencyLinesLayer", () => (parcelRequire("3bPMB")).default);
$parcel$export(module.exports, "DependencyLinesLineDetail", () => (parcelRequire("d7aPF")).default);

var $8mSKC = parcelRequire("8mSKC");

var $3bPMB = parcelRequire("3bPMB");

var $d7aPF = parcelRequire("d7aPF");

});
parcelRegister("8mSKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29905cf63f720a7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8ALiN = parcelRequire("8ALiN");
parcelRequire("hNxi8");
var $1eaRW = parcelRequire("1eaRW");
var $d29905cf63f720a7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $8ALiN.default), {})((0, $1eaRW.DependencyLineContainer));

});
parcelRegister("8ALiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d421a244b5a0721$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $dYnI4 = parcelRequire("dYnI4");

var $kUlCF = parcelRequire("kUlCF");

var $akhOi = parcelRequire("akhOi");

var $dEoWh = parcelRequire("dEoWh");

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $a0bo1 = parcelRequire("a0bo1");

var $aMoMC = parcelRequire("aMoMC");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $6vrw7 = parcelRequire("6vrw7");

var $gVkBP = parcelRequire("gVkBP");
function $3d421a244b5a0721$export$25634793c5cb4ee3(timelineRange, timeScale, from, to) {
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { baselineStart: fromStart, baselineEnd: fromEnd } = from.tag === (0, $a0bo1.TABLE_ISSUE) ? from.value : {};
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { baselineStart: toStart, baselineEnd: toEnd } = to.tag === (0, $a0bo1.TABLE_ISSUE) ? to.value : {};
    // return false if either of the issues has both it's dates undefined
    // (lines can still be drawn between issues with partial dates)
    const fromHasDate = (0, $7CnHa.isDefined)(fromStart) || (0, $7CnHa.isDefined)(fromEnd);
    const toHasDate = (0, $7CnHa.isDefined)(toStart) || (0, $7CnHa.isDefined)(toEnd);
    if (!fromHasDate || !toHasDate) return false;
    const { mode: selectedZoomLevel } = timeScale;
    const isScrollableTimeline = (0, $kUlCF.getZoomLevel)(selectedZoomLevel) !== undefined;
    if (isScrollableTimeline) return true;
    const fromPositions = (0, $gVkBP.getPositionsForBar)({
        ...from.tag === (0, $a0bo1.TABLE_ISSUE) && {
            baselineStart: fromStart,
            baselineEnd: fromEnd
        }
    }, timelineRange);
    const toPositions = (0, $gVkBP.getPositionsForBar)({
        ...to.tag === (0, $a0bo1.TABLE_ISSUE) && {
            baselineStart: toStart,
            baselineEnd: toEnd
        }
    }, timelineRange);
    return toPositions.leftPositionPercentage < 100 && toPositions.leftPositionPercentage > 0 && 100 - fromPositions.rightPositionPercentage < 100 && 100 - fromPositions.rightPositionPercentage > 0;
}
/**
 * This method is triggered whenever we find an inconsistency with
 * our issue types. Sometimes we have issueLinks for issues with a
 * non-existing issue type, probably coming from a migration.
 * This caused an unexpected error impeding the plan to load.
 */ const $3d421a244b5a0721$var$logDependencyLinesInconsistencyError = ()=>{
    const errorMessage = 'Incorrect issue type found when rendering dependency lines';
    (0, $guiFP.default)({
        meta: {
            packageName: (0, $5rYNM.PACKAGE_NAME),
            id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).ROADMAP,
            teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
        },
        attributes: {
            message: errorMessage
        },
        error: new Error(errorMessage)
    });
};
const $3d421a244b5a0721$var$getDependencyLinesPureFunc = (tableItems, uniqueLinks, timelineRange, timeScale, issueTypesById, issueLinkTypes, projectsById, dependencySettings)=>{
    if (dependencySettings.display !== (0, $5rYNM.DEPENDENCY_SETTINGS).LINES) return [];
    const getIssueId = (tableItem)=>{
        if (tableItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return undefined;
        return tableItem.value.id;
    };
    const tableItemsIndexMap = {};
    tableItems.forEach((tableItem, index)=>{
        const issueId = getIssueId(tableItem);
        if (!issueId) return tableItemsIndexMap;
        if (tableItemsIndexMap[issueId]) tableItemsIndexMap[issueId].push(index);
        else tableItemsIndexMap[issueId] = [
            index
        ];
        return tableItemsIndexMap;
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return uniqueLinks.reduce((lines, currentLink)=>{
        const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type, itemKey: itemKey } = currentLink;
        // There may be multiple occurrences of a source or target issue in the scope - e.g when grouped by sprint
        const issueItemFromIndexes = Object.prototype.hasOwnProperty.call(tableItemsIndexMap, sourceItemKey) ? tableItemsIndexMap[sourceItemKey] : [];
        const issueItemToIndexes = Object.prototype.hasOwnProperty.call(tableItemsIndexMap, targetItemKey) ? tableItemsIndexMap[targetItemKey] : [];
        // create pairs of the link occurrences
        const linkOccurrences = issueItemFromIndexes.flatMap((a)=>issueItemToIndexes.map((b)=>({
                    from: a,
                    to: b
                })));
        linkOccurrences.forEach(({ from: from, to: to })=>{
            const issueItemFrom = tableItems[from];
            if (!issueItemFrom || issueItemFrom.tag !== (0, $a0bo1.TABLE_ISSUE)) return;
            const issueItemTo = tableItems[to];
            if (!issueItemTo || issueItemTo.tag !== (0, $a0bo1.TABLE_ISSUE)) return;
            // the to and from points of a line should be withing the horizontal bounds of the timeline
            // for line rendering to be meaningful to a user
            const lineWithinHorizontalBounds = $3d421a244b5a0721$export$25634793c5cb4ee3(timelineRange, timeScale, issueItemFrom, issueItemTo);
            // we do not render lines between issues in groupBy views if they are in different groups
            const areInSameGroup = issueItemFrom.group === issueItemTo.group;
            const drawable = areInSameGroup && lineWithinHorizontalBounds;
            const rawSourceIssue = issueItemFrom.value;
            const rawTargetIssue = issueItemTo.value;
            const sourceIssueType = issueTypesById[rawSourceIssue.type];
            const targetIssueType = issueTypesById[rawTargetIssue.type];
            // invalid issue type
            if (!sourceIssueType || !targetIssueType) {
                $3d421a244b5a0721$var$logDependencyLinesInconsistencyError();
                return;
            }
            lines.push({
                itemKey: itemKey,
                fromIssue: {
                    indexOnScope: from,
                    id: (0, $6vrw7.toIssueId)(sourceItemKey),
                    issueKey: rawSourceIssue.issueKey,
                    projectKey: projectsById[rawSourceIssue.project].key,
                    title: rawSourceIssue.summary,
                    typeName: sourceIssueType.name,
                    iconUrl: sourceIssueType.iconUrl,
                    startDate: rawSourceIssue.baselineStart || 0,
                    dueDate: rawSourceIssue.baselineEnd || 0,
                    isHidden: false
                },
                toIssue: {
                    indexOnScope: to,
                    id: (0, $6vrw7.toIssueId)(targetItemKey),
                    issueKey: rawTargetIssue.issueKey,
                    projectKey: projectsById[rawTargetIssue.project].key,
                    title: rawTargetIssue.summary,
                    typeName: targetIssueType.name,
                    iconUrl: targetIssueType.iconUrl,
                    startDate: rawTargetIssue.baselineStart || 0,
                    dueDate: rawTargetIssue.baselineEnd || 0,
                    isHidden: false
                },
                issueLinkType: {
                    ...issueLinkTypes[type]
                },
                drawable: drawable
            });
        });
        return lines;
    }, []);
};
const $3d421a244b5a0721$export$b5efd9fe27e8d42 = (0, $dYnI4.monitor).timeFunction($3d421a244b5a0721$var$getDependencyLinesPureFunc, 'roadmap_timeline_schedule_dependencyLines_provider_query_getDependencyLinesPure');
const $3d421a244b5a0721$var$getDependencyLines = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getTableItems),
    (0, $dEoWh.getUniqueLinks),
    (0, $aMoMC.getTimelineRange),
    (0, $9H2AP.getTimeScaleViewSettings),
    (0, $lihml.getIssueTypesById),
    (0, $dEoWh.getDependencyIssueLinkTypesById),
    (0, $ehEr2.getProjectsById),
    (0, $9H2AP.getDependencySettings),
    (0, $akhOi.isOptimizedMode)
], $3d421a244b5a0721$export$b5efd9fe27e8d42);
const $3d421a244b5a0721$var$mapStateToProps = (state, props)=>({
        dependencyLines: $3d421a244b5a0721$var$getDependencyLines(state, props),
        dependencySettings: (0, $9H2AP.getDependencySettings)(state)
    });
var $3d421a244b5a0721$export$2e2bcd8739ae039 = $3d421a244b5a0721$var$mapStateToProps;

});
parcelRegister("gVkBP", function(module, exports) {

$parcel$export(module.exports, "HORIZONTAL_HIT_TARGET_THRESHOLD", () => $85b638df7a67e5d2$export$dd128398eba49a1c);
$parcel$export(module.exports, "getPositionsForBar", () => $85b638df7a67e5d2$export$32e9788ba7124f57);
$parcel$export(module.exports, "colorsToGradient", () => $85b638df7a67e5d2$export$a421baa06a50c2d7);
$parcel$export(module.exports, "getStripesStyle", () => $85b638df7a67e5d2$export$9550c86d8d33e2af);
$parcel$export(module.exports, "useDropTarget", () => $85b638df7a67e5d2$export$5967d4bb72ce3c0);

var $eUqFw = parcelRequire("eUqFw");

var $17L5s = parcelRequire("17L5s");

var $51PXu = parcelRequire("51PXu");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lhEfD = parcelRequire("lhEfD");
const $85b638df7a67e5d2$var$GRADIENT_LENGTH_PERCENTAGE = 30;
const $85b638df7a67e5d2$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE = 12;
const $85b638df7a67e5d2$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE = 100 - $85b638df7a67e5d2$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE;
const $85b638df7a67e5d2$export$dd128398eba49a1c = (0, $5rYNM.SCOPE_ROW_HEIGHT) / 4;
const $85b638df7a67e5d2$export$32e9788ba7124f57 = ({ baselineStart: baselineStart, baselineEnd: baselineEnd }, timelineRange, forcedGradients)=>{
    const timelineSize = timelineRange.end - timelineRange.start;
    const timestampToTimelineLeftPercentage = (time)=>((0, $17L5s.startOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
    const timestampToTimelineRightPercentage = (time)=>((0, $17L5s.endOfUtcDay)(time) - timelineRange.start) / timelineSize * 100;
    // Relative to the *left* edge of *timeline* as a percentage of *timeline* width.
    let leftPositionPercentage = 0;
    // Relative to the *right* edge of *timeline* as a percentage of *timeline* width.
    let rightPositionPercentage = 0;
    // Relative to the *left* edge of *bar* as a percentage of *bar* width.
    let leftAnchorPercentage = 0;
    // Relative to the *left* (sic!) edge of *bar* as a percentage of *bar* width.
    let rightAnchorPercentage = 100;
    if ((0, $7CnHa.isDefined)(baselineStart) && (0, $7CnHa.isDefined)(baselineEnd)) {
        leftPositionPercentage = timestampToTimelineLeftPercentage(baselineStart);
        rightPositionPercentage = 100 - timestampToTimelineRightPercentage(baselineEnd);
    } else if ((0, $7CnHa.isDefined)(baselineStart)) {
        leftPositionPercentage = timestampToTimelineLeftPercentage(baselineStart);
        rightPositionPercentage = 100 - (leftPositionPercentage + $85b638df7a67e5d2$var$GRADIENT_LENGTH_PERCENTAGE);
        rightAnchorPercentage = 0;
    } else if ((0, $7CnHa.isDefined)(baselineEnd)) {
        rightPositionPercentage = 100 - timestampToTimelineRightPercentage(baselineEnd);
        leftPositionPercentage = 100 - (rightPositionPercentage + $85b638df7a67e5d2$var$GRADIENT_LENGTH_PERCENTAGE);
        leftAnchorPercentage = 100;
    }
    if (forcedGradients) {
        const earliestStartPercentage = timestampToTimelineLeftPercentage(forcedGradients.earliestStart);
        const latestEndPercentage = timestampToTimelineRightPercentage(forcedGradients.latestEnd);
        if (forcedGradients.left) leftPositionPercentage = Math.min(timestampToTimelineRightPercentage(forcedGradients.earliestEnd) - $85b638df7a67e5d2$var$GRADIENT_LENGTH_PERCENTAGE, earliestStartPercentage);
        if (forcedGradients.right) rightPositionPercentage = 100 - Math.max(timestampToTimelineLeftPercentage(forcedGradients.latestStart) + $85b638df7a67e5d2$var$GRADIENT_LENGTH_PERCENTAGE, latestEndPercentage);
        const totalPercentage = 100 - (leftPositionPercentage + rightPositionPercentage);
        if (forcedGradients.left) leftAnchorPercentage = Math.max($85b638df7a67e5d2$var$MINIMUM_LEFT_FORCED_GRADIENT_PERCENTAGE, 100 * (earliestStartPercentage - leftPositionPercentage) / totalPercentage);
        if (forcedGradients.right) rightAnchorPercentage = Math.min($85b638df7a67e5d2$var$MAXIMUM_RIGHT_FORCED_GRADIENT_PERCENTAGE, 100 * (latestEndPercentage - leftPositionPercentage) / totalPercentage);
    }
    return {
        leftPositionPercentage: leftPositionPercentage,
        rightPositionPercentage: rightPositionPercentage,
        leftAnchorPercentage: leftAnchorPercentage,
        rightAnchorPercentage: rightAnchorPercentage
    };
};
// Convert ratio to percentage and limit fraction part length.
const $85b638df7a67e5d2$var$ratioToCSS = (x)=>Math.round(x * 1e6) / 1e4;
// Colors are passed to Bar in hex form.
// To create nice fade effect we need to fade to the same color, but with opacity 0.
// Which should be represented in rgba() form.
// This function does conversion like #102030 -> rgba(16, 32, 48, 0)
const $85b638df7a67e5d2$var$colorToFadeColor = (x)=>{
    const opacity = 0.1;
    const r = parseInt(x.slice(1, 3), 16);
    const g = parseInt(x.slice(3, 5), 16);
    const b = parseInt(x.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const $85b638df7a67e5d2$export$a421baa06a50c2d7 = ({ colors: colors, leftAnchorPercentage: leftAnchorPercentage, rightAnchorPercentage: rightAnchorPercentage, fadeSolidPercentage: fadeSolidPercentage })=>{
    const antiGapFactor = 1.005;
    const layers = [];
    let progress = 0;
    for (const { colour: colour, ratio: ratio } of colors){
        const top = $85b638df7a67e5d2$var$ratioToCSS(progress);
        const height = $85b638df7a67e5d2$var$ratioToCSS(ratio / (1 - progress));
        if (leftAnchorPercentage > 0) {
            const image = `linear-gradient(to left, ${colour}${fadeSolidPercentage ? `, ${colour} ${fadeSolidPercentage}%` : ''}, ${$85b638df7a67e5d2$var$colorToFadeColor(colour)})`;
            const position = `0% ${top}% / ${leftAnchorPercentage * antiGapFactor}% ${height}% no-repeat`;
            layers.push(`${image} ${position}`);
        }
        const solidPercentage = rightAnchorPercentage - leftAnchorPercentage;
        if (solidPercentage > 0) {
            const image = `linear-gradient(${colour}, ${colour})`;
            const position = `${solidPercentage < 100 ? $85b638df7a67e5d2$var$ratioToCSS(leftAnchorPercentage / (100 - solidPercentage)) : 100}% ${top}% / ${solidPercentage * antiGapFactor}% ${height}% no-repeat`;
            layers.push(`${image} ${position}`);
        }
        if (rightAnchorPercentage < 100) {
            const image = `linear-gradient(to right, ${colour}${fadeSolidPercentage ? `, ${colour} ${fadeSolidPercentage}%` : ''}, ${$85b638df7a67e5d2$var$colorToFadeColor(colour)})`;
            const position = `100% ${top}% / ${(100 - rightAnchorPercentage) * antiGapFactor}% ${height}% no-repeat`;
            layers.push(`${image} ${position}`);
        }
        progress += ratio;
    }
    return layers.join(', ');
};
const $85b638df7a67e5d2$export$9550c86d8d33e2af = (stripes, colors)=>{
    const stripesLayer = `repeating-linear-gradient(
        120deg,
        transparent,
        transparent 15px,
        ${"var(--ds-background-inverse-subtle-pressed, rgba(255, 255, 255, 0.3))"} 15px,
        ${"var(--ds-background-inverse-subtle-pressed, rgba(255, 255, 255, 0.3))"} 30px,
        transparent 30px
    )`;
    const { left: left, right: right } = stripes;
    if (!(left || right)) return {};
    if (left && right) return {
        background: stripesLayer
    };
    // Gradients of cover layers is reversed relative to stripes position
    // as it supposed to cover them where we don't want to see stripes.
    const coverLayers = $85b638df7a67e5d2$export$a421baa06a50c2d7({
        colors: colors,
        leftAnchorPercentage: left ? 100 : 0,
        rightAnchorPercentage: right ? 0 : 100,
        fadeSolidPercentage: 25
    });
    return {
        background: `${coverLayers}, ${stripesLayer}`
    };
};
const $85b638df7a67e5d2$export$5967d4bb72ce3c0 = (ref)=>{
    const { row: row } = (0, $lhEfD.useRow)();
    const [isDraggedOver, setIsDraggedOver] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) return;
        return (0, $51PXu.dropTargetForDependencyCreate)({
            element: ref.current,
            onDragEnter: ()=>setIsDraggedOver(true),
            onDragLeave: ()=>setIsDraggedOver(false),
            onDrop: ()=>setIsDraggedOver(false),
            getData: ()=>({
                    row: row
                })
        });
    }, [
        ref,
        row
    ]);
    return isDraggedOver;
};

});
parcelRegister("51PXu", function(module, exports) {

$parcel$export(module.exports, "dropTargetForDependencyCreate", () => $7677694030c638f1$export$b493dfb9f5b687ab);
$parcel$export(module.exports, "draggableForDependencyCreate", () => $7677694030c638f1$export$af6b708c718872b7);
$parcel$export(module.exports, "monitorForDependencyCreate", () => $7677694030c638f1$export$35c0c4389177f68f);
$parcel$export(module.exports, "useDependencyCreateDragSourceData", () => $7677694030c638f1$export$6cac64d8cbde5780);

var $eUqFw = parcelRequire("eUqFw");

var $eo9PV = parcelRequire("eo9PV");
const $7677694030c638f1$var$instance = Symbol('dependency-line-drag-create');
const $7677694030c638f1$export$b493dfb9f5b687ab = (opts)=>(0, $eo9PV.dropTargetForElements)({
        ...opts,
        canDrop: (...args)=>args[0].source.data.instance === $7677694030c638f1$var$instance && (opts.canDrop ? opts.canDrop(...args) : true),
        getData: (...args)=>({
                ...opts.getData?.(...args),
                instance: $7677694030c638f1$var$instance
            })
    });
const $7677694030c638f1$export$af6b708c718872b7 = (opts)=>(0, $eo9PV.draggable)({
        ...opts,
        getInitialData: (...args)=>({
                ...opts.getInitialData?.(...args),
                instance: $7677694030c638f1$var$instance
            })
    });
const $7677694030c638f1$export$35c0c4389177f68f = (opts)=>(0, $eo9PV.monitorForElements)({
        ...opts,
        canMonitor: (...args)=>args[0].source.data.instance === $7677694030c638f1$var$instance && (opts.canMonitor ? opts.canMonitor(...args) : true)
    });
const $7677694030c638f1$export$6cac64d8cbde5780 = ()=>{
    const [source, setSource] = (0, $eUqFw.useState)();
    const ref = (0, $eUqFw.useRef)(source);
    ref.current = source;
    (0, $eUqFw.useEffect)(()=>{
        $7677694030c638f1$export$35c0c4389177f68f({
            // eslint-disable-next-line @typescript-eslint/no-shadow
            onDrag: ({ source: source })=>{
                if (source !== ref.current) setSource(source);
            },
            onDrop: ()=>setSource(undefined)
        });
    }, []);
    return source?.data;
};

});

parcelRegister("lhEfD", function(module, exports) {

$parcel$export(module.exports, "RowProvider", () => $5ad4f7931a8f907c$export$329ef9142f16ee64);
$parcel$export(module.exports, "useRow", () => $5ad4f7931a8f907c$export$223b5cb3e865c05e);

var $eUqFw = parcelRequire("eUqFw");
const $5ad4f7931a8f907c$var$context = /*#__PURE__*/ (0, $eUqFw.createContext)({
    row: -1,
    height: 0
});
const $5ad4f7931a8f907c$export$329ef9142f16ee64 = ({ row: row, height: height, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5ad4f7931a8f907c$var$context.Provider, {
        value: {
            row: row,
            height: height
        }
    }, children);
const $5ad4f7931a8f907c$export$223b5cb3e865c05e = ()=>(0, $eUqFw.useContext)($5ad4f7931a8f907c$var$context);

});



parcelRegister("hNxi8", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("1eaRW")).DependencyLineContainer);
// eslint-disable-next-line jira/export/no-external-exports

var $1eaRW = parcelRequire("1eaRW");

});
parcelRegister("1eaRW", function(module, exports) {

$parcel$export(module.exports, "DependencyLineContainer", () => $c6daa2e51b014dba$export$cf2792569d5a5a20);
$parcel$export(module.exports, "useDependencyLines", () => $c6daa2e51b014dba$export$17dd40a5d02411f0);
$parcel$export(module.exports, "useActiveLine", () => $c6daa2e51b014dba$export$d49c1f035142bd61);
$parcel$export(module.exports, "useDependencySettings", () => $c6daa2e51b014dba$export$1ec9eab8919ada08);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6uT6r = parcelRequire("6uT6r");
const $c6daa2e51b014dba$var$actions = {
    setActiveLine: (activeLine)=>({ setState: setState })=>{
            setState({
                activeLine: activeLine
            });
        }
};
const $c6daa2e51b014dba$var$Store = (0, $a61MH.createStore)({
    initialState: {
        dependencyLines: [],
        dependencySettings: {
            display: (0, $6uT6r.DEPENDENCY_SETTINGS).DEFAULT
        },
        activeLine: null
    },
    actions: $c6daa2e51b014dba$var$actions,
    name: 'arj-dependency-lines'
});
const $c6daa2e51b014dba$var$hydrateContainer = ()=>({ setState: setState }, { dependencyLines: dependencyLines, dependencySettings: dependencySettings })=>{
        setState({
            dependencyLines: dependencyLines,
            dependencySettings: dependencySettings
        });
    };
const $c6daa2e51b014dba$export$cf2792569d5a5a20 = (0, $heB5U.createContainer)($c6daa2e51b014dba$var$Store, {
    onInit: $c6daa2e51b014dba$var$hydrateContainer,
    onUpdate: $c6daa2e51b014dba$var$hydrateContainer
});
const $c6daa2e51b014dba$export$17dd40a5d02411f0 = (0, $ggKAj.createHook)($c6daa2e51b014dba$var$Store, {
    selector: (state)=>state.dependencyLines
});
const $c6daa2e51b014dba$export$d49c1f035142bd61 = (0, $ggKAj.createHook)($c6daa2e51b014dba$var$Store, {
    selector: (state)=>state.activeLine
});
const $c6daa2e51b014dba$export$1ec9eab8919ada08 = (0, $ggKAj.createHook)($c6daa2e51b014dba$var$Store, {
    selector: (state)=>state.dependencySettings
});

});
parcelRegister("6uT6r", function(module, exports) {

$parcel$export(module.exports, "DEPENDENCY_SETTINGS", () => $9cb70a7549e245a0$export$37e30ab04b9b1705);
const $9cb70a7549e245a0$export$e6952b12ade67489 = 'default';
const $9cb70a7549e245a0$export$e0de529f548a9140 = 'lines';
const $9cb70a7549e245a0$export$d61684373eacdf61 = 'count';
const $9cb70a7549e245a0$export$37e30ab04b9b1705 = {
    DEFAULT: $9cb70a7549e245a0$export$e6952b12ade67489,
    LINES: $9cb70a7549e245a0$export$e0de529f548a9140,
    COUNT: $9cb70a7549e245a0$export$d61684373eacdf61
};

});




parcelRegister("3bPMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1560e9bde2d7165a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4G8mH = parcelRequire("4G8mH");

var $WaAIs = parcelRequire("WaAIs");
var $1560e9bde2d7165a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4G8mH.default), {})((0, $WaAIs.default));

});
parcelRegister("4G8mH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47c0b2cd5348a111$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $kFf60 = parcelRequire("kFf60");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $47c0b2cd5348a111$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    isOptimizedMode: $akhOi.isOptimizedMode,
    issueStatusById: (0, $kFf60.getIssueStatusById),
    syncStartEnabled: (0, $75KhQ.getSyncStartEnabled)
});

});

parcelRegister("WaAIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $73321505fda07e06$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kUWRc = parcelRequire("kUWRc");

var $opsFH = parcelRequire("opsFH");

var $iqF2x = parcelRequire("iqF2x");
var $1eaRW = parcelRequire("1eaRW");

var $lseqm = parcelRequire("lseqm");

var $a0bo1 = parcelRequire("a0bo1");

var $5rYNM = parcelRequire("5rYNM");

var $6vrw7 = parcelRequire("6vrw7");

var $gVkBP = parcelRequire("gVkBP");
function $73321505fda07e06$export$2e2bcd8739ae039({ isOptimizedMode: isOptimizedMode, issueStatusById: issueStatusById, scope: scope, startIndex: startIndex, stopIndex: stopIndex, syncStartEnabled: syncStartEnabled, timelineRange: timelineRange, width: width }) {
    const [dependencySettings] = (0, $1eaRW.useDependencySettings)();
    const getDrawableLine = (0, $eUqFw.useCallback)((dependencyLine)=>{
        const { fromIssue: fromIssue, toIssue: toIssue, drawable: drawable } = dependencyLine;
        if (!drawable) return;
        const { indexOnScope: fromItemScopeIndex, id: sourceItemKey } = fromIssue;
        const fromItem = scope[fromItemScopeIndex];
        if (!fromItem || fromItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return;
        const { indexOnScope: toItemScopeIndex, id: targetItemKey } = toIssue;
        const toItem = scope[toItemScopeIndex];
        if (!toItem || toItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return;
        // we want to render a dependency line if the to or from row is in the visible scope,
        // or if the line will vertically traverse the entirety of the visible scope
        const fromItemInLimitedScope = fromItemScopeIndex >= startIndex && fromItemScopeIndex < stopIndex;
        const toItemInLimitedScope = toItemScopeIndex >= startIndex && toItemScopeIndex < stopIndex;
        const dependencyLineTraversesVisibleArea = fromItemScopeIndex < startIndex && toItemScopeIndex > stopIndex || fromItemScopeIndex > stopIndex && toItemScopeIndex < startIndex;
        if (fromItemInLimitedScope || toItemInLimitedScope || dependencyLineTraversesVisibleArea) {
            const { baselineStart: fromBaselineStart, baselineEnd: fromBaselineEnd } = isOptimizedMode && !(0, (/*@__PURE__*/$parcel$interopDefault($kUWRc)))(fromItem.value.optimized) ? fromItem.value.optimized : fromItem.value;
            const fromPositions = (0, $gVkBP.getPositionsForBar)({
                baselineStart: fromBaselineStart,
                baselineEnd: fromBaselineEnd
            }, timelineRange);
            const { baselineStart: baselineStart, baselineEnd: baselineEnd } = isOptimizedMode && !(0, (/*@__PURE__*/$parcel$interopDefault($kUWRc)))(toItem.value.optimized) ? toItem.value.optimized : toItem.value;
            const toPositions = (0, $gVkBP.getPositionsForBar)({
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }, timelineRange);
            const isOverlapping = (0, $lseqm.getIssueLinkIfOverlapping)(fromItem.value, toItem.value, issueStatusById, syncStartEnabled);
            return {
                to: {
                    id: (0, $6vrw7.toIssueId)(targetItemKey),
                    indexOnScope: toItemScopeIndex,
                    y: scope[toItemScopeIndex].topOffset - (0, $5rYNM.SCOPE_ROW_HEIGHT) / 2,
                    x: toPositions.leftPositionPercentage * width / 100,
                    color: (0, $opsFH.GREY)
                },
                from: {
                    id: (0, $6vrw7.toIssueId)(sourceItemKey),
                    indexOnScope: fromItemScopeIndex,
                    y: scope[fromItemScopeIndex].topOffset - (0, $5rYNM.SCOPE_ROW_HEIGHT) / 2,
                    x: (100 - fromPositions.rightPositionPercentage) * width / 100,
                    color: (0, $opsFH.GREY)
                },
                itemHeight: (0, $5rYNM.SCOPE_ROW_HEIGHT),
                isOverlapping: isOverlapping
            };
        }
    }, [
        isOptimizedMode,
        issueStatusById,
        scope,
        startIndex,
        stopIndex,
        syncStartEnabled,
        timelineRange,
        width
    ]);
    return dependencySettings.display === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqF2x.DependencyLinesOverlay), {
        getDrawableLine: getDrawableLine
    }) : null;
}

});
parcelRegister("kUWRc", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $f3a6b1604e26e672$var$func = $jFIrw('isEmpty', (parcelRequire("8blac")), (parcelRequire("jKGa6")));

$f3a6b1604e26e672$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $f3a6b1604e26e672$var$func;

});

parcelRegister("iqF2x", function(module, exports) {

$parcel$export(module.exports, "DependencyLinesOverlay", () => $aaff45059d7aa4e4$export$3caea3cf449c8260);
$parcel$export(module.exports, "DependencyLineDetail", () => $aaff45059d7aa4e4$export$ad186fc2ddf9077);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $bs7an = parcelRequire("bs7an");

var $d6gDv = parcelRequire("d6gDv");

var $1eaRW = parcelRequire("1eaRW");
function $aaff45059d7aa4e4$export$3caea3cf449c8260({ getDrawableLine: getDrawableLine }) {
    const [dependencyLines] = (0, $1eaRW.useDependencyLines)();
    const [activeLine, { setActiveLine: setActiveLine }] = (0, $1eaRW.useActiveLine)();
    /* There are some cases where there could be more than one dependency between the same 2 issues */ const drawableLines = getDrawableLine && (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(dependencyLines.map(getDrawableLine).filter(Boolean), (d)=>d && [
            d.from.id,
            d.to.id,
            d.from.y,
            d.to.y
        ].join());
    const onDependencyClick = (event, params)=>{
        const clickedLine = {
            fromId: params.fromId,
            fromIndexOnScope: params.fromIndexOnScope,
            toId: params.toId,
            toIndexOnScope: params.toIndexOnScope,
            x: event.clientX,
            y: event.clientY
        };
        setActiveLine(clickedLine);
    };
    /* The clicked line */ const selectedDependency = activeLine ? {
        fromId: activeLine.fromId,
        toId: activeLine.toId,
        fromIndex: activeLine.fromIndexOnScope,
        toIndex: activeLine.toIndexOnScope
    } : undefined;
    return drawableLines?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bs7an.default), {
        dependencies: drawableLines,
        onDependencyClick: onDependencyClick,
        selectedDependency: selectedDependency
    }) : null;
}
function $aaff45059d7aa4e4$export$ad186fc2ddf9077({ onUnlink: onUnlink, canDelete: canDelete, isOverlapping: isOverlapping }) {
    const [linksDetails] = (0, $1eaRW.useDependencyLines)();
    const [activeLine, { setActiveLine: setActiveLine }] = (0, $1eaRW.useActiveLine)();
    if (!activeLine || linksDetails.length === 0) return null;
    const { x: x, y: y, fromId: fromId, fromIndexOnScope: fromIndexOnScope, toId: toId, toIndexOnScope: toIndexOnScope } = activeLine;
    /* We get only the links relevant to the current active line */ const currentLineLinks = linksDetails.filter((item)=>item.fromIssue.id === fromId && item.toIssue.id === toId && item.fromIssue.indexOnScope === fromIndexOnScope && item.toIssue.indexOnScope === toIndexOnScope);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6gDv.default), {
        position: {
            left: x,
            top: y
        },
        links: currentLineLinks,
        canDelete: canDelete,
        onUnlink: onUnlink,
        isOverlapping: isOverlapping,
        onClose: ()=>setActiveLine(null)
    });
}

});
parcelRegister("bs7an", function(module, exports) {

$parcel$export(module.exports, "default", () => $98318066b465b791$export$2e2bcd8739ae039);
/* eslint-disable jira/restricted/styled-components-migration */ 
var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $jG2Eu = parcelRequire("jG2Eu");


var $2CrYe = parcelRequire("2CrYe");
const $98318066b465b791$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
    return(// eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($98318066b465b791$var$SvgContainer, {
        className: (0, $dfce2d8dd72914ca$export$1e54f8b472a07d8d)
    }, dependencies.map((dependency)=>{
        if (dependency !== selectedDependencyLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
            key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
            ...dependency,
            onClick: onDependencyClick,
            isSelected: false
        });
        return null;
    }), selectedDependencyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CrYe.default), {
        ...selectedDependencyLine,
        onClick: onDependencyClick,
        isSelected: true
    })));
};
$98318066b465b791$var$SvgOverlay.defaultProps = {
    selectedDependency: undefined,
    onDependencyClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    dependencies: []
};
var $98318066b465b791$export$2e2bcd8739ae039 = $98318066b465b791$var$SvgOverlay;
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98318066b465b791$var$SvgContainer = /*#__PURE__*/ (0, $kwce8.default).svg.withConfig({
    componentId: "sc-7b34v9-0"
})({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    overflow: 'visible',
    pointerEvents: 'none'
});

});
/**
 * Style marshal classes
 */ const $dfce2d8dd72914ca$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $dfce2d8dd72914ca$export$cd944e09ecad5145 = 'dependency-line';

parcelRegister("2CrYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c7f5a778bca93d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hTLlD = parcelRequire("hTLlD");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lPQPn = parcelRequire("lPQPn");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");


var $aM1JA = parcelRequire("aM1JA");

var $fR5Z4 = parcelRequire("fR5Z4");
/* Even though this component represents a single line, multiple elements are used to achieve all of the requirements.
 * 1. An additional element with a larger surface area is used to capture interactions to improve the UX.
 * 2. Gradients cannot be applied to SVG elements using CSS. For this we use a linearGradient element.
 */ const $03c7f5a778bca93d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    const onPathClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $duQ8C.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'line'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
            isOverlapping: isOverlapping
        });
        onClick(event, {
            fromId: from.id,
            toId: to.id,
            isOverlapping: isOverlapping,
            fromIndexOnScope: from.indexOnScope,
            toIndexOnScope: to.indexOnScope
        });
    }, [
        createAnalyticsEvent,
        isOverlapping,
        from,
        to,
        onClick
    ]);
    const onPathMouseEnter = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onPathMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const path = (0, $fR5Z4.getPath)(from, to, itemHeight);
    const gradientId = `linear-gradient-${from.id}-${to.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (isHovered || isSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: gradientId,
        x1: from.x,
        x2: to.x,
        y1: from.y,
        y2: to.y,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0%",
        stopColor: (0, $lPQPn.getValueFromColor)(from.color)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "100%",
        stopColor: (0, $lPQPn.getValueFromColor)(to.color)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: path,
        fill: "transparent",
        strokeWidth: "2",
        stroke: $03c7f5a778bca93d$export$a73db48ef11a2bc3({
            isOverlapping: isOverlapping,
            isSelected: isSelected,
            isHovered: isHovered,
            gradientId: gradientId
        }),
        pointerEvents: "none",
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "mouse",
        mousePosition: "top",
        content: formatMessage((0, $aM1JA.default).viewDetail),
        tag: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03c7f5a778bca93d$var$InteractivePath // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $dfce2d8dd72914ca$export$cd944e09ecad5145),
        d: path,
        stroke: "transparent",
        strokeWidth: "9",
        fill: "none",
        cursor: "pointer",
        onClick: onPathClick,
        onMouseEnter: onPathMouseEnter,
        onMouseLeave: onPathMouseLeave,
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
    })));
};
$03c7f5a778bca93d$var$DependencyLine.whyDidYouRender = true; // Custom memo to handle common case where 'from' and 'to' objects change reference but not value
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$03c7f5a778bca93d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($03c7f5a778bca93d$var$DependencyLine, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $03c7f5a778bca93d$var$InteractivePath = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxv1yxs",
            __cmplp.className
        ])
    });
});
const $03c7f5a778bca93d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
    const isHighlighted = isSelected || isHovered;
    if (isOverlapping) {
        if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $PdmhA).R500})`;
        return `var(--ds-background-danger-bold, ${(0, $PdmhA).R300})`;
    }
    if (isHighlighted) return `url(#${gradientId})`;
    return `var(--ds-border-bold, ${(0, $PdmhA).N50})`;
};

});
parcelRegister("aM1JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $106a95137f755680$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $106a95137f755680$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewDetail: {
        "id": "aais-dependency-lines-overlay.common.line.view-detail",
        "defaultMessage": "View dependency detail"
    }
});

});

parcelRegister("fR5Z4", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8);

var $5iWql = parcelRequire("5iWql");
const $73e9f2077e2ffc0d$var$calculateMidPoint = (from, to)=>({
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
    });
const $73e9f2077e2ffc0d$var$getY = (p1, p2, x)=>{
    const m = (p2.y - p1.y) / (p2.x - p1.x);
    return m * (x - p1.x) + p1.y;
};
// Generates half of the complex segment
const $73e9f2077e2ffc0d$var$generateSegment = (start, end, offset)=>{
    const c1 = {
        x: start.x + offset.x,
        y: start.y
    };
    const c2 = {
        x: start.x + offset.x,
        y: start.y + offset.y
    };
    const s1 = {
        x: start.x,
        y: $73e9f2077e2ffc0d$var$getY(c2, end, start.x)
    };
    return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
};
const $73e9f2077e2ffc0d$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
    const fromOffset = {
        x: halfItemHeight,
        y: from.y <= to.y ? halfItemHeight : -halfItemHeight
    };
    const toOffset = {
        x: -fromOffset.x,
        y: -fromOffset.y
    };
    return [
        fromOffset,
        toOffset
    ];
};
// Generates a path made up of two segments for when the dependency start is after the end
const $73e9f2077e2ffc0d$var$generateComplexPath = (from, to, halfItemHeight)=>{
    const middle = $73e9f2077e2ffc0d$var$calculateMidPoint(from, to);
    const [fromOffset, toOffset] = $73e9f2077e2ffc0d$var$getSegmentOffsets(from, to, halfItemHeight);
    return `${$73e9f2077e2ffc0d$var$generateSegment(from, middle, fromOffset)} ${$73e9f2077e2ffc0d$var$generateSegment(to, middle, toOffset)}`;
};
//  Generates a single path for when the dependency start is before the end (happy case)
const $73e9f2077e2ffc0d$var$generateSinglePath = (from, to, itemHeight)=>{
    const diffX = Math.abs(from.x - to.x);
    const progression = itemHeight + diffX * 0.1;
    return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
};
const $73e9f2077e2ffc0d$export$2aa3fd96c49a84a8 = (0, $5iWql.default)((from, to, itemHeight)=>from.x > to.x ? $73e9f2077e2ffc0d$var$generateComplexPath(from, to, itemHeight / 2) : $73e9f2077e2ffc0d$var$generateSinglePath(from, to, itemHeight));

});



parcelRegister("d6gDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $76d0c1353b0cc79f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $g8JvH = parcelRequire("g8JvH");

var $1Qi0v = parcelRequire("1Qi0v");

var $eEXs3 = parcelRequire("eEXs3");
class $76d0c1353b0cc79f$export$55aef0c69232da84 extends (0, $eUqFw.Component) {
    componentDidUpdate() {
        const { links: links, onClose: onClose } = this.props;
        // close modal if all dependencies were removed
        if (links.length === 0) onClose();
    }
    render() {
        const { position: position, ...contentProps } = this.props;
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            isOpen: true,
            strategy: "absolute",
            onClose: contentProps.onClose,
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEXs3.default), contentProps),
            trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76d0c1353b0cc79f$var$Anchor, {
                    top: position.top,
                    left: position.left,
                    ref: ref
                })
        });
        // Considering removing the chart modal component when cleaning com.atlassian.rm.jpo.transposition.m2
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Qi0v.default), {
            position: position,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEXs3.default), {
                ...contentProps,
                onClose: contentProps.onClose
            }),
            onClose: contentProps.onClose
        });
    }
}
var $76d0c1353b0cc79f$export$2e2bcd8739ae039 = (0, $g8JvH.AnalyticsEventToProps)('tooltip', {
    onUnlink: 'unlinked'
})($76d0c1353b0cc79f$export$55aef0c69232da84);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76d0c1353b0cc79f$var$Anchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $9t7rW.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $9t7rW.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1Qi0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $8edf064973af22e0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eNhh9 = parcelRequire("eNhh9");
/**
 * Modals in the Chart are portalled out into a fixed position, as not to be clipped.
 */ const $8edf064973af22e0$var$ChartModal = ({ position: position, content: content, testId: testId, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8edf064973af22e0$var$InlineDialogWrapper, {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        isOpen: true,
        content: // We would like to re-enable pointer events on the content of the inline dialog to allow interaction with its content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            xcss: (0, $1ZAYh.xcss)({
                pointerEvents: 'initial'
            })
        }, content),
        onClose: onClose,
        closeOnScroll: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8edf064973af22e0$var$ModalAnchor, position)));
$8edf064973af22e0$var$ChartModal.defaultProps = {
    testId: undefined
};
var $8edf064973af22e0$export$2e2bcd8739ae039 = $8edf064973af22e0$var$ChartModal;
// Child selector is for the nested inline dialog
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8edf064973af22e0$var$InlineDialogWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _lcxvglyw _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1ceh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8edf064973af22e0$var$ModalAnchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $9t7rW.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $9t7rW.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eEXs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $540a16b58b9c98b9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $5iWql = parcelRequire("5iWql");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");
parcelRequire("17L5s");
var $j4tJJ = parcelRequire("j4tJJ");

var $4xHig = parcelRequire("4xHig");

var $gzIfN = parcelRequire("gzIfN");

var $aLN8U = parcelRequire("aLN8U");

var $9kGEk = parcelRequire("9kGEk");

var $hTB7X = parcelRequire("hTB7X");
const $540a16b58b9c98b9$var$createUnlinkHandler = (0, $5iWql.default)((itemKey, type, fromId, toId, onUnlink, callback)=>()=>{
        onUnlink({
            itemKey: itemKey,
            type: type,
            sourceItemKey: fromId,
            targetItemKey: toId
        });
        if (callback) callback();
    });
const $540a16b58b9c98b9$var$OverlapWarning = ({ fromIssue: fromIssue, toIssue: toIssue })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    if (!(fromIssue && fromIssue.dueDate && fromIssue.dueDate > 0 && toIssue && toIssue.startDate && toIssue.startDate > 0)) return null;
    const leadTime = toIssue.startDate - fromIssue.dueDate;
    let overlapPeriod = null; // if "end date" of issue A is May 4, 2021 and "start date" of issue B is May 5, 2021, then leadTime = 1
    if (leadTime === 1) // we display a leadTimeMessage "less than a day"
    // note: we don't use distanceInWords as it would return 'less than a minute'
    overlapPeriod = formatMessage((0, $9kGEk.default).lessThanOneDayLeadTime);
    else overlapPeriod = (0, $j4tJJ.default)(fromIssue.dueDate, toIssue.startDate, {
        locale: (0, $8K9kM.getLocale)(locale)
    });
    return overlapPeriod ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($540a16b58b9c98b9$var$Warning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($540a16b58b9c98b9$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, `${formatMessage((0, $9kGEk.default).overlapDatesMessage)} (${overlapPeriod})`)) : null;
};
const $540a16b58b9c98b9$var$ModalContent = (props)=>{
    const { links: links, onUnlink: onUnlink, onClose: onClose, canDelete: canDelete, isOverlapping: isOverlapping } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (links.length === 0) return null;
     // Each element in the array is a link with the same source and target
    const { fromIssue: fromIssue } = links[0];
    const { toIssue: toIssue } = links[0];
    const isDependenciesDatesOverlapping = isOverlapping(fromIssue.indexOnScope, toIssue.indexOnScope);
    const defaultOutwardDependencyDescription = formatMessage((0, $9kGEk.default).blocks);
    const shouldCloseOnUnlink = links.length <= 1;
    const dependenciesBlock = links.map((link, index)=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { fromIssue: fromIssue, toIssue: toIssue, issueLinkType: issueLinkType, itemKey: itemKey } = link;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `${issueLinkType.id}_${fromIssue.id}_${toIssue.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzIfN.default), fromIssue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTB7X.default), {
            label: issueLinkType.outward ?? defaultOutwardDependencyDescription,
            isOverlapping: isDependenciesDatesOverlapping,
            onUnlink: canDelete ? $540a16b58b9c98b9$var$createUnlinkHandler(itemKey, issueLinkType.id, fromIssue.id, toIssue.id, onUnlink, shouldCloseOnUnlink ? onClose : undefined) : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzIfN.default), toIssue), isDependenciesDatesOverlapping && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($540a16b58b9c98b9$var$OverlapWarning, {
            fromIssue: fromIssue,
            toIssue: toIssue
        }), index < links.length - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLN8U.default), null) : null);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($540a16b58b9c98b9$var$Container, {
        "data-testid": "portfolio-3-dependency-line-detail.common.ui.content.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($540a16b58b9c98b9$var$Content, null, dependenciesBlock));
};
$540a16b58b9c98b9$var$ModalContent.defaultProps = {
    onUnlink: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    canDelete: false
};
var $540a16b58b9c98b9$export$2e2bcd8739ae039 = $540a16b58b9c98b9$var$ModalContent;
const $540a16b58b9c98b9$var$TOOLTIP_Z_INDEX = 13; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $540a16b58b9c98b9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _bfhkhp5a _1bsbp3fh _16qsanr3 _2rko1l7b _c71l1mjv _1reo1wug _18m91wug _1pbyilow",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $540a16b58b9c98b9$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $540a16b58b9c98b9$var$Warning = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pkutpp _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $540a16b58b9c98b9$var$WarningIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gzIfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5839c8f8d49587e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2qhQi = parcelRequire("2qhQi");

var $hl4M2 = parcelRequire("hl4M2");

var $dpDY7 = parcelRequire("dpDY7");

var $3YcPe = parcelRequire("3YcPe");
const $5839c8f8d49587e6$var$DependencyCard = (props)=>{
    const { title: title, issueKey: issueKey, projectKey: projectKey, iconUrl: iconUrl, typeName: typeName, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$ContentLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$TypeIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpDY7.default), {
        src: iconUrl || '',
        alt: formatMessage((0, $3YcPe.default).iconAltText, {
            typeName: typeName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        issueKey: issueKey,
        projectKey: projectKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5839c8f8d49587e6$var$Title, {
        title: title
    }, title)))));
};
$5839c8f8d49587e6$var$DependencyCard.displayName = 'DependencyCard';
var $5839c8f8d49587e6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($5839c8f8d49587e6$var$DependencyCard);
const $5839c8f8d49587e6$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1yt41pyq _bfhk1s4m",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$ContentLeft = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$TitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$TypeIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz41tcg _syaz1fxt _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5839c8f8d49587e6$var$IssueLinkContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y9ia1q9c _1txj12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dpDY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d8c4f8d2bbcdf5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $83d8c4f8d2bbcdf5$var$Icon = ({ src: src, alt: alt, size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83d8c4f8d2bbcdf5$var$IconImage, {
        src: src,
        alt: alt,
        width: size,
        height: size
    });
$83d8c4f8d2bbcdf5$var$Icon.defaultProps = {
    alt: '',
    size: '16px'
};
var $83d8c4f8d2bbcdf5$export$2e2bcd8739ae039 = $83d8c4f8d2bbcdf5$var$Icon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83d8c4f8d2bbcdf5$var$IconImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3YcPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e505ea860d8d01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a8e505ea860d8d01$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconAltText: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.card.icon-alt-text",
        "defaultMessage": "{typeName} issue type"
    }
});

});


parcelRegister("aLN8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4180a218cd1c061d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4180a218cd1c061d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4pxbi",
            __cmplp.className
        ])
    });
});
const $4180a218cd1c061d$var$Line = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _vchhusvi _4t3it94y _1bsb1osq _19itukkb",
            __cmplp.className
        ])
    });
});
var $4180a218cd1c061d$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4180a218cd1c061d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4180a218cd1c061d$var$Line, null));

});

parcelRegister("9kGEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee459ded0ec51028$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ee459ded0ec51028$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blocks: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.blocks",
        "defaultMessage": "blocks"
    },
    overlapDatesMessage: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.overlap-dates-message",
        "defaultMessage": "Dates overlap"
    },
    lessThanOneDayLeadTime: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.less-than-one-day-lead-time",
        "defaultMessage": "less than 1 day"
    }
});

});

parcelRegister("hTB7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $41a0ffa63ec8dfa5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hUwRB = parcelRequire("hUwRB");

var $PdmhA = parcelRequire("PdmhA");

var $2Eq2L = parcelRequire("2Eq2L");
const $41a0ffa63ec8dfa5$var$Separator = ({ label: label, isOverlapping: isOverlapping, onUnlink: onUnlink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$SeparatorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$Line, {
        isOverlapping: isOverlapping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$IconWrapper, {
        isOverlapping: isOverlapping
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
        size: "small",
        label: label,
        primaryColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$Line, {
        isOverlapping: isOverlapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$TextContainer, null, label), onUnlink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41a0ffa63ec8dfa5$var$UnlinkButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Eq2L.default), {
        onClick: onUnlink
    })));
var $41a0ffa63ec8dfa5$export$2e2bcd8739ae039 = $41a0ffa63ec8dfa5$var$Separator;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $41a0ffa63ec8dfa5$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $41a0ffa63ec8dfa5$var$SeparatorContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $41a0ffa63ec8dfa5$var$TextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o _1wybdlk8 _vwz4dlk8",
            __cmplp.className
        ])
    });
});
const $41a0ffa63ec8dfa5$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _16qs14w9 _2rko1ssb",
            __cmplp.isOverlapping ? "_bfhkk8x7" : "_bfhk1849",
            __cmplp.className
        ])
    });
});
const $41a0ffa63ec8dfa5$var$Line = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i19bv _19it1hdd",
            __cmplp.isOverlapping ? "_1h6dk8x7" : "_1h6d1849",
            __cmplp.className
        ])
    });
});
const $41a0ffa63ec8dfa5$var$UnlinkButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Eq2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f55bbcd512912ae3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c8Guq = parcelRequire("c8Guq");

var $7u4fN = parcelRequire("7u4fN");

var $fcRCL = parcelRequire("fcRCL");

var $8cU5f = parcelRequire("8cU5f");

var $2qhQi = parcelRequire("2qhQi");


var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $b5nVC = parcelRequire("b5nVC");
// eslint-disable-next-line jira/react/no-class-components
class $f55bbcd512912ae3$var$UnlinkButton extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $b5nVC.default).unlink)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fcRCL))), {
                label: formatMessage((0, $b5nVC.default).unlink),
                size: "medium"
            }),
            spacing: "compact",
            appearance: "subtle",
            onClick: this.onClick
        }));
    }
    constructor(...args){
        super(...args);
        this.onClick = (event, analyticsEvent)=>{
            event.stopPropagation();
            this.props.onClick();
            const [actionSubject, action] = (0, $bbed278ac8d555b9$export$de7a70543cfab9e).split(' ');
            const analyticsPayload = {
                source: 'dependencyLineDetail'
            };
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), analyticsPayload);
        };
    }
}
var $f55bbcd512912ae3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2qhQi.default), (0, $g8JvH.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
}))($f55bbcd512912ae3$var$UnlinkButton);

});
parcelRegister("fcRCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12192af1a89a6ac$var$_react = $b12192af1a89a6ac$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b12192af1a89a6ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b12192af1a89a6ac$var$UnlinkIcon = (props)=>/*#__PURE__*/ $b12192af1a89a6ac$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.721 14.43a.972.972 0 00-1.37-.004l-2.088 2.059a1.928 1.928 0 01-1.37.568c-.588 0-1.135-.26-1.525-.738-.634-.777-.505-1.933.203-2.643l1.321-1.322.002.001.688-.686a.974.974 0 000-1.377l-.002-.003a.972.972 0 00-1.375 0l-2.068 2.07a3.892 3.892 0 000 5.497l.009.01A3.87 3.87 0 008.892 19a3.87 3.87 0 002.746-1.139l2.083-2.085a.951.951 0 000-1.345zm-3.442-4.86a.972.972 0 001.37.004l2.088-2.058c.366-.367.853-.57 1.37-.57.588 0 1.135.26 1.525.739.634.777.505 1.933-.203 2.643l-1.321 1.322-.002-.001-.688.686a.974.974 0 000 1.377l.002.003c.38.38.995.38 1.375 0l2.068-2.07a3.892 3.892 0 000-5.497l-.009-.01A3.87 3.87 0 0015.108 5a3.87 3.87 0 00-2.746 1.139l-2.083 2.085a.951.951 0 000 1.345zM8.924 4.618l.401.968a1 1 0 11-1.848.765l-.4-.968a1 1 0 111.848-.765M5.383 7.076l.968.401a1.001 1.001 0 01-.766 1.848l-.968-.4a1.001 1.001 0 01.766-1.848m9.932 10.413a1.003 1.003 0 00-.542 1.307l.402.968A1 1 0 1017.023 19l-.401-.967a1 1 0 00-1.307-.542zm2.176-2.174a1 1 0 00.54 1.306l.969.401a1.001 1.001 0 00.766-1.848l-.969-.4a1 1 0 00-1.306.542z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b12192af1a89a6ac$var$UnlinkIcon.displayName = 'UnlinkIcon';
var $b12192af1a89a6ac$var$_default = $b12192af1a89a6ac$var$UnlinkIcon;
module.exports.default = $b12192af1a89a6ac$var$_default;

});

const $bbed278ac8d555b9$export$de7a70543cfab9e = 'issueDependencyLink deleted';

parcelRegister("b5nVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $87602780aed76494$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $87602780aed76494$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unlink: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink",
        "defaultMessage": "Remove dependency"
    }
});

});








parcelRegister("d7aPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc98adbe052ff829$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2sQng = parcelRequire("2sQng");

var $gtWQw = parcelRequire("gtWQw");

var $1p3ps = parcelRequire("1p3ps");
var $fc98adbe052ff829$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gtWQw.default), (0, $2sQng.default))((0, $1p3ps.default));

});
parcelRegister("2sQng", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e27e1a4f8883f3$export$2e2bcd8739ae039);

var $cTDpS = parcelRequire("cTDpS");
const $04e27e1a4f8883f3$var$mapDispatchToProps = (dispatch)=>({
        removeDependency: (payload)=>{
            dispatch((0, $cTDpS.deleteIssueLink)(payload));
        }
    });
var $04e27e1a4f8883f3$export$2e2bcd8739ae039 = $04e27e1a4f8883f3$var$mapDispatchToProps;

});

parcelRegister("gtWQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f614a87cb6bce29$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $kFf60 = parcelRequire("kFf60");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $6f614a87cb6bce29$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    isEditMode: $akhOi.isEditMode,
    issueStatusById: (0, $kFf60.getIssueStatusById),
    syncStartEnabled: (0, $75KhQ.getSyncStartEnabled)
});

});

parcelRegister("1p3ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $2187826932d5a0ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iqF2x = parcelRequire("iqF2x");
var $1eaRW = parcelRequire("1eaRW");

var $lseqm = parcelRequire("lseqm");

var $a0bo1 = parcelRequire("a0bo1");

var $5rYNM = parcelRequire("5rYNM");
function $2187826932d5a0ea$export$2e2bcd8739ae039({ isEditMode: isEditMode, issueStatusById: issueStatusById, removeDependency: removeDependency, scope: scope, syncStartEnabled: syncStartEnabled }) {
    const [dependencySettings] = (0, $1eaRW.useDependencySettings)();
    const areIssuesOverlapping = (0, $eUqFw.useCallback)((fromItemScopeIndex, toItemScopeIndex)=>{
        const fromItem = scope[fromItemScopeIndex];
        if (!fromItem || fromItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return false;
        const toItem = scope[toItemScopeIndex];
        if (!toItem || toItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return false;
        return (0, $lseqm.getIssueLinkIfOverlapping)(fromItem.value, toItem.value, issueStatusById, syncStartEnabled);
    }, [
        issueStatusById,
        scope,
        syncStartEnabled
    ]);
    return dependencySettings.display === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqF2x.DependencyLineDetail), {
        onUnlink: removeDependency,
        canDelete: isEditMode,
        isOverlapping: areIssuesOverlapping
    }) : null;
}

});



parcelRegister("a76j8", function(module, exports) {

$parcel$export(module.exports, "DepLineDragPreviewProvider", () => (parcelRequire("dBwUe")).default);
$parcel$export(module.exports, "useDepLinesDrag", () => (parcelRequire("dBwUe")).useDepLinesDrag);
$parcel$export(module.exports, "DepLineDragPreviewLayer", () => (parcelRequire("1X7JB")).default);
// Remove this with com.atlassian.rm.jpo.transposition.m2 cleanup

var $dBwUe = parcelRequire("dBwUe");

var $1X7JB = parcelRequire("1X7JB");

});
parcelRegister("dBwUe", function(module, exports) {

$parcel$export(module.exports, "useDepLinesDrag", () => $6c4fa9582cd1d859$export$f709ac5ddcd09471);
$parcel$export(module.exports, "default", () => $6c4fa9582cd1d859$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dEoWh = parcelRequire("dEoWh");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $40Pdb = parcelRequire("40Pdb");

var $3w484 = parcelRequire("3w484");

var $2LEfM = parcelRequire("2LEfM");
const $6c4fa9582cd1d859$export$f709ac5ddcd09471 = ()=>(0, $eUqFw.useContext)((0, $3w484.context));
const $6c4fa9582cd1d859$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    outgoingLinks: (0, $dEoWh.getOutgoingLinks),
    dependencySettings: (0, $dhHiZ.getDependencySettingsInfo)
});
var $6c4fa9582cd1d859$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($6c4fa9582cd1d859$var$mapStateToProps, (0, $40Pdb.default))((0, $2LEfM.default));

});
parcelRegister("40Pdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $39741bc2aa9761a8$export$2e2bcd8739ae039);

var $cTDpS = parcelRequire("cTDpS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39741bc2aa9761a8$export$2e2bcd8739ae039 = {
    addIssueLink: $cTDpS.addIssueLink
};

});

parcelRegister("3w484", function(module, exports) {

$parcel$export(module.exports, "context", () => $e1bc176fec7b1c18$export$a078c61943f9dbbe);
$parcel$export(module.exports, "useHoverableIssueRect", () => $e1bc176fec7b1c18$export$6408dacfbde0dd53);
$parcel$export(module.exports, "useDropHandling", () => $e1bc176fec7b1c18$export$5048b513d451ea75);

var $eUqFw = parcelRequire("eUqFw");

var $N35KL = parcelRequire("N35KL");

var $k8Qyf = parcelRequire("k8Qyf");

var $5rYNM = parcelRequire("5rYNM");

var $5cvAz = parcelRequire("5cvAz");
const $e1bc176fec7b1c18$var$DEPENDENCY_CREATION_ERROR_FLAG_ID = 'dragPreviewDependencyCreationErrorFlag';
const $e1bc176fec7b1c18$export$a078c61943f9dbbe = /*#__PURE__*/ (0, $eUqFw.createContext)({
    width: 0,
    dragSource: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setDragSource: ()=>{},
    dragHovered: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updateIssueRect: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeIssueRect: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    handleDragMove: ()=>{},
    handleDrop: ()=>false
});
const $e1bc176fec7b1c18$export$6408dacfbde0dd53 = ()=>{
    const [hovered, setHovered] = (0, $eUqFw.useState)(null);
    const issueRectsRef = (0, $eUqFw.useRef)([]);
    const removeIssueRect = (0, $eUqFw.useCallback)((rowId)=>{
        issueRectsRef.current = issueRectsRef.current.filter((issueRect)=>!(0, (/*@__PURE__*/$parcel$interopDefault($N35KL)))(issueRect.rowId, rowId));
    }, []);
    const updateIssueRect = (0, $eUqFw.useCallback)((rowId, rect)=>{
        issueRectsRef.current = issueRectsRef.current.filter((issueRect)=>!(0, (/*@__PURE__*/$parcel$interopDefault($N35KL)))(issueRect.rowId, rowId)).concat([
            {
                rowId: rowId,
                rect: rect
            }
        ]);
    }, []);
    const handleDragMove = (0, $eUqFw.useCallback)((offsetX, offsetY)=>{
        const issueRects = issueRectsRef.current;
        for(let i = 0; i < issueRects.length; i++){
            const { rowId: rowId, rect: rect } = issueRects[i];
            const { top: top, left: left, width: width, height: height } = rect;
            if (offsetX >= left && offsetX <= left + width && offsetY >= top && offsetY <= top + height) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($N35KL)))(hovered, rowId)) setHovered(rowId);
                return;
            }
        }
        if (offsetX >= 0 && offsetY >= 0) setHovered(null);
    }, [
        hovered
    ]);
    const handleDragEnd = (0, $eUqFw.useCallback)(()=>setHovered(null), []);
    return {
        hovered: hovered,
        removeIssueRect: removeIssueRect,
        updateIssueRect: updateIssueRect,
        handleDragMove: handleDragMove,
        handleDragEnd: handleDragEnd
    };
};
const $e1bc176fec7b1c18$export$5048b513d451ea75 = (hovered, dragSource, addIssueLink, outgoingLinks, dependencySettings)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const dragSourceRef = (0, $eUqFw.useRef)(dragSource);
    const hoveredRef = (0, $eUqFw.useRef)(hovered?.issueId);
    dragSourceRef.current = dragSource;
    hoveredRef.current = hovered?.issueId;
    return (0, $eUqFw.useCallback)(({ issueLinkType: issueLinkType })=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const hovered = hoveredRef.current;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const dragSource = dragSourceRef.current;
        if (hovered == null || dragSource == null) return false;
        const [source, target] = dragSource.direction === (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD ? [
            dragSource.rowId.issueId,
            hovered
        ] : [
            hovered,
            dragSource.rowId.issueId
        ];
        // We don't create a dependency with itself
        if (source === target) return false;
        const outgoingLinksForItem = outgoingLinks[source] || [];
        const existingLinkArray = outgoingLinksForItem.filter((link)=>link.targetItemKey === target && link.type === issueLinkType);
        if (existingLinkArray.length > 0) return false;
        const dependencyIssueLinkTypes = dependencySettings.dependencyIssueLinkTypes ?? [];
        const hasIssueLinkTypeConfigured = dependencyIssueLinkTypes.find((linkType)=>linkType.issueLinkTypeId === issueLinkType);
        if (!hasIssueLinkTypeConfigured) {
            showFlag({
                id: $e1bc176fec7b1c18$var$DEPENDENCY_CREATION_ERROR_FLAG_ID,
                title: (0, $5cvAz.default).noLinkTypeFlagTitle,
                type: 'error',
                description: (0, $5cvAz.default).noLinkTypeFlagDescription,
                isAutoDismiss: true,
                actions: [
                    {
                        content: (0, $5cvAz.default).noLinkTypeFlagLink,
                        href: 'https://support.atlassian.com/jira-software-cloud/docs/configure-dependencies-in-jira-for-advanced-roadmaps/',
                        target: '_blank'
                    }
                ]
            });
            return false;
        }
        addIssueLink({
            sourceItemKey: source,
            targetItemKey: target,
            type: issueLinkType
        });
        return true;
    }, [
        addIssueLink,
        outgoingLinks,
        showFlag,
        dependencySettings?.dependencyIssueLinkTypes
    ]);
};

});
parcelRegister("N35KL", function(module, exports) {

module.exports = (parcelRequire("1OuJn"));

});

parcelRegister("5cvAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $173266aac7420d16$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $173266aac7420d16$var$messages = (0, $90IgZ.defineMessages)({
    noLinkTypeFlagTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-title",
        "defaultMessage": "We couldn't create a dependency"
    },
    noLinkTypeFlagDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-description",
        "defaultMessage": "Check your issue link Jira Setting or contact your Jira Administrator for help."
    },
    noLinkTypeFlagLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.dependency-lines.drag-preview.provider.no-link-type-flag-link",
        "defaultMessage": "Configure dependencies for your plan"
    }
});
var $173266aac7420d16$export$2e2bcd8739ae039 = $173266aac7420d16$var$messages;

});


parcelRegister("2LEfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c9b8fe27ba2122$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3w484 = parcelRequire("3w484");
function $c8c9b8fe27ba2122$var$DragPreviewDepLineProvider({ addIssueLink: addIssueLink, width: width, children: children, outgoingLinks: outgoingLinks, dependencySettings: dependencySettings }) {
    const { hovered: hovered, removeIssueRect: removeIssueRect, updateIssueRect: updateIssueRect, handleDragMove: handleDragMove, handleDragEnd: handleDragEnd } = (0, $3w484.useHoverableIssueRect)();
    const [dragSource, setDragSource] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        if (dragSource == null) handleDragEnd();
    }, [
        dragSource,
        handleDragEnd
    ]);
    const handleDrop = (0, $3w484.useDropHandling)(hovered, dragSource, addIssueLink, outgoingLinks, dependencySettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3w484.context).Provider, {
        value: {
            width: width,
            dragSource: dragSource,
            setDragSource: setDragSource,
            dragHovered: hovered,
            updateIssueRect: updateIssueRect,
            removeIssueRect: removeIssueRect,
            handleDragMove: handleDragMove,
            handleDrop: handleDrop
        }
    }, children);
}
var $c8c9b8fe27ba2122$export$2e2bcd8739ae039 = $c8c9b8fe27ba2122$var$DragPreviewDepLineProvider;

});


parcelRegister("1X7JB", function(module, exports) {

$parcel$export(module.exports, "default", () => $47e1828d725447f9$export$2e2bcd8739ae039);

var $dPgdI = parcelRequire("dPgdI");
var $47e1828d725447f9$export$2e2bcd8739ae039 = (0, $dPgdI.default);

});
parcelRegister("dPgdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc27d0e0b1008b49$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $g4Vkx = parcelRequire("g4Vkx");

var $jODJR = parcelRequire("jODJR");

var $a0bo1 = parcelRequire("a0bo1");

var $gVkBP = parcelRequire("gVkBP");

var $5rYNM = parcelRequire("5rYNM");

var $dBwUe = parcelRequire("dBwUe");

var $1QrtB = parcelRequire("1QrtB");
/** Function computes the delta between drag scroll start and current timeline location.
 * @returns {Array} Returns the drag scrolling delta in px and functions to register and deregister a callback function and reset the calculations
 */ const $dc27d0e0b1008b49$var$useScrollingDelta = ()=>{
    const offsetInPxRef = (0, $eUqFw.useRef)(0);
    const startOffsetInPxRef = (0, $eUqFw.useRef)(0);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const callbackRef = (0, $eUqFw.useRef)(()=>{});
    const deltaRef = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = (0, $jODJR.subscribeHorizontalScrolling)(({ viewport: viewport, container: container })=>{
            const offsetInPx = viewport.offset * container.width / container.duration || 0;
            offsetInPxRef.current = offsetInPx;
            deltaRef.current = offsetInPxRef.current - startOffsetInPxRef.current;
            callbackRef.current();
        });
        return unsubscribe;
    }, [
        deltaRef
    ]);
    /** Function used to start and end calculations for deltaRef */ const dragReset = (0, $eUqFw.useCallback)(()=>{
        startOffsetInPxRef.current = offsetInPxRef.current;
        deltaRef.current = 0;
    }, []);
    /** Register callback to be used when delta changes */ const register = (0, $eUqFw.useCallback)((callback)=>{
        callbackRef.current = callback;
    }, []);
    /** Deregister callback */ const deregister = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        callbackRef.current = ()=>{};
    }, []);
    return [
        deltaRef,
        {
            dragReset: dragReset,
            register: register,
            deregister: deregister
        }
    ];
};
/**
 * Gets the table item if it's issue item, return undefined otherwise.
 * @param scope the plan scope
 * @param rowId the identity of the row
 */ const $dc27d0e0b1008b49$var$getTableItem = (scope, rowId)=>{
    if (rowId === undefined) return;
    const issueTableItem = scope[rowId.scopeIndex];
    if (issueTableItem === undefined || issueTableItem.tag !== (0, $a0bo1.TABLE_ISSUE)) return;
    return issueTableItem;
};
/**
 * Returns the vertical offset of the (middle) issue bar.
 */ const $dc27d0e0b1008b49$var$getAnchorY = (scope, rowId)=>{
    const issueTableItem = $dc27d0e0b1008b49$var$getTableItem(scope, rowId);
    if (issueTableItem?.topOffset) // we remove 20 pixels from the top offset so that the anchor for the dependency line is located at the vertical center of the issue bar
    // if we wouldn't remove 20 pixels, the dependency line would be drawn from the bottom left/right of an issue bar to the bottom left/right of the issue bar it blocks
    return issueTableItem.topOffset - (0, $5rYNM.SCOPE_ROW_HEIGHT) / 2;
    return undefined;
};
/**
 * Returns the horizontal offset of the issue bar end (could be the left or the right end).
 */ const $dc27d0e0b1008b49$var$getAnchorX = (scope, timelineRange, direction, viewportWidth, rowId)=>{
    const issueTableItem = $dc27d0e0b1008b49$var$getTableItem(scope, rowId);
    if (issueTableItem === undefined) return undefined;
    const fromPositions = (0, $gVkBP.getPositionsForBar)({
        baselineStart: issueTableItem.value.baselineStart,
        baselineEnd: issueTableItem.value.baselineEnd
    }, timelineRange);
    return direction === 'inward' ? fromPositions.leftPositionPercentage * viewportWidth / 100 : (100 - fromPositions.rightPositionPercentage) * viewportWidth / 100;
};
const $dc27d0e0b1008b49$var$useMouseOffset = ()=>{
    const [value, setValue] = (0, $eUqFw.useState)({
        clientX: undefined,
        clientY: undefined
    });
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handler = (e)=>{
            e.preventDefault();
            setValue(e.detail);
        };
        window.addEventListener('customized.dragmove', handler, false);
        return ()=>window.removeEventListener('customized.dragmove', handler, false);
    }, []);
    return value;
};
function $dc27d0e0b1008b49$export$2e2bcd8739ae039({ timelineRange: timelineRange, width: width, scope: scope, scrollTop: scrollTop }) {
    const { dragSource: dragSource, handleDragMove: handleDragMove } = (0, $dBwUe.useDepLinesDrag)();
    const { rowId: rowId, direction: sourceDirection } = dragSource || {
        rowId: undefined,
        direction: undefined
    };
    const rootElRef = (0, $eUqFw.useRef)(null);
    const [deltaRef, { dragReset: dragReset, register: registerDragScrolling, deregister: deregisterDragScrolling }] = $dc27d0e0b1008b49$var$useScrollingDelta();
    const [, setFlag] = (0, $eUqFw.useState)(0);
    const [clientRect, setClientRect] = (0, $eUqFw.useState)();
    const scrollTopRef = (0, $eUqFw.useRef)(scrollTop);
    const originalScrollTopRef = (0, $eUqFw.useRef)(scrollTop);
    const anchorX = $dc27d0e0b1008b49$var$getAnchorX(scope, timelineRange, sourceDirection, width, rowId);
    const anchorY = $dc27d0e0b1008b49$var$getAnchorY(scope, rowId);
    const { clientX: mouseX, clientY: mouseY } = $dc27d0e0b1008b49$var$useMouseOffset();
    // Cache the scrollTop into a ref
    (0, $eUqFw.useEffect)(()=>{
        scrollTopRef.current = scrollTop;
    }, [
        scrollTop
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const rootEl = rootElRef.current;
        if (rootEl == null) return;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { top: top, left: left, width: width, height: height } = rootEl.getBoundingClientRect();
        setClientRect({
            top: top,
            left: left,
            width: width,
            height: height
        });
        // Set the original scrollTop to add to the offset when there is scrolling while dragging
        originalScrollTopRef.current = scrollTopRef.current;
    }, [
        anchorX,
        anchorY
    ]);
    const scrollTopDelta = scrollTop - originalScrollTopRef.current;
    let relativeMouseX = mouseX !== undefined && clientRect !== undefined ? mouseX - clientRect.left : undefined;
    if (relativeMouseX !== undefined) relativeMouseX -= (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET);
    let targetX = relativeMouseX !== undefined ? relativeMouseX : undefined;
    if (targetX !== undefined) targetX = targetX + (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET) + deltaRef.current;
    const targetY = mouseY !== undefined && clientRect !== undefined ? mouseY - (clientRect.top - scrollTopDelta) : undefined;
    (0, $eUqFw.useEffect)(()=>{
        if (targetX === undefined || targetY === undefined || rowId == null) return;
        handleDragMove(targetX, targetY);
    }, [
        targetX,
        targetY,
        handleDragMove,
        rowId
    ]);
    const shouldDraw = anchorX !== undefined && anchorY !== undefined && targetX !== undefined && targetY !== undefined && rowId !== undefined;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldDraw) {
            const handler = ()=>{
                setFlag((flag)=>flag + 1);
            };
            dragReset();
            registerDragScrolling(handler);
            return ()=>deregisterDragScrolling();
        }
        dragReset();
    }, [
        deregisterDragScrolling,
        dragReset,
        registerDragScrolling,
        shouldDraw
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            zIndex: 3,
            pointerEvents: shouldDraw ? 'initial' : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            marginLeft: -(0, $5rYNM.HORIZONTAL_SCROLL_OFFSET)
        },
        ref: rootElRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            top: (targetY ?? 0) - 8,
            left: (targetX ?? 0) - 8,
            opacity: shouldDraw ? 1 : 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$1QrtB.marker} ${$1QrtB["marker-drag-preview"]}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: 2e6,
        height: clientRect?.height ?? 0,
        opacity: shouldDraw ? 1 : 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
        // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'string | number | undefined'.
        x1: anchorX != null ? anchorX + (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET) : anchorX,
        y1: anchorY,
        x2: targetX,
        y2: targetY,
        stroke: `var(--ds-border-bold, ${(0, $g4Vkx.default).N100})`,
        strokeWidth: "2px",
        strokeLinecap: "round"
    })));
}

});
parcelRegister("1QrtB", function(module, exports) {

$parcel$export(module.exports, "marker", () => $157ff60d2517ea30$export$ffc4d0086f1a4c9, (v) => $157ff60d2517ea30$export$ffc4d0086f1a4c9 = v);
$parcel$export(module.exports, "marker-drag-preview", () => $157ff60d2517ea30$export$5bb14e8107614c68, (v) => $157ff60d2517ea30$export$5bb14e8107614c68 = v);
var $157ff60d2517ea30$export$ffc4d0086f1a4c9;
var $157ff60d2517ea30$export$5bb14e8107614c68;
$157ff60d2517ea30$export$ffc4d0086f1a4c9 = `qt-VNG_marker`;
$157ff60d2517ea30$export$5bb14e8107614c68 = `qt-VNG_marker-drag-preview`;

});




parcelRegister("3Q01T", function(module, exports) {

$parcel$export(module.exports, "useDndScrolling", () => (parcelRequire("5XDHx")).useDndScrolling);
$parcel$export(module.exports, "DndScrollingObserver", () => (parcelRequire("108fh")).default);

var $5XDHx = parcelRequire("5XDHx");

var $108fh = parcelRequire("108fh");

});
parcelRegister("5XDHx", function(module, exports) {

$parcel$export(module.exports, "useDndScrolling", () => $5008dac704518e45$export$f24f5a2d62841521);

var $jG2Eu = parcelRequire("jG2Eu");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");
const $5008dac704518e45$var$actions = {
    register: (flag)=>({ setState: setState })=>{
            setState({
                flag: flag
            });
        },
    deregister: (flag)=>({ getState: getState, setState: setState })=>{
            const { flag: currFlag } = getState();
            setState({
                flag: currFlag === flag ? null : currFlag
            });
        }
};
const $5008dac704518e45$var$Store = (0, $a61MH.createStore)({
    initialState: {
        flag: null,
        register: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        deregister: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $5008dac704518e45$var$actions,
    name: 'arj-dnd-scrolling'
});
const $5008dac704518e45$export$55bcce90b5832550 = (0, $ggKAj.createHook)($5008dac704518e45$var$Store, {
    selector: (state)=>!!state.flag
});
const $5008dac704518e45$var$getUseDndScrolling = (0, $bj4JM.createSelector)((state)=>state.flag, (state)=>!!state.flag, (flag, dragging)=>({
        flag: flag,
        dragging: dragging
    }));
const $5008dac704518e45$export$f24f5a2d62841521 = (0, $ggKAj.createHook)($5008dac704518e45$var$Store, {
    selector: $5008dac704518e45$var$getUseDndScrolling
});

});

parcelRegister("108fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6901d3f769c8ce8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");

var $5XDHx = parcelRequire("5XDHx");
const $6901d3f769c8ce8b$var$SCROLL_SCALE = 10;
const $6901d3f769c8ce8b$var$getWeightedScrollAmount = (scrollAmount)=>scrollAmount ** $6901d3f769c8ce8b$var$SCROLL_SCALE;
const $6901d3f769c8ce8b$var$SCROLL_MAX = 150;
const $6901d3f769c8ce8b$var$getThrottledScrollAmount = (scrollAmount)=>Math.min($6901d3f769c8ce8b$var$SCROLL_MAX, scrollAmount);
const $6901d3f769c8ce8b$var$SCROLL_THRESHOLD = 50;
const $6901d3f769c8ce8b$var$getScrollPosDelta = (height, cursorOffset)=>{
    const threshold = Math.min(height / 2, $6901d3f769c8ce8b$var$SCROLL_THRESHOLD);
    if (cursorOffset >= 0 && cursorOffset <= threshold) {
        // inversely relative to distance to list top
        const distanceFromTopToCursor = cursorOffset;
        const scrollAmount = $6901d3f769c8ce8b$var$getWeightedScrollAmount(1 / (distanceFromTopToCursor / threshold));
        return -$6901d3f769c8ce8b$var$getThrottledScrollAmount(scrollAmount);
    }
    if (cursorOffset <= height && cursorOffset >= height - threshold) {
        // inversely relative to distance to list bottom
        const distanceToBottomFromCursor = height - cursorOffset;
        const scrollAmount = $6901d3f769c8ce8b$var$getWeightedScrollAmount(1 / (distanceToBottomFromCursor / threshold));
        return $6901d3f769c8ce8b$var$getThrottledScrollAmount(scrollAmount);
    }
    return 0;
};
function $6901d3f769c8ce8b$export$2e2bcd8739ae039({ scrollElement: scrollElement, leftSidebarWidth: leftSidebarWidth }) {
    const [{ dragging: dragging }] = (0, $5XDHx.useDndScrolling)();
    const [{ viewport: viewport, container: container, zoomLevel: zoomLevel }, { scrollTo: scrollTo, setSmooth: setSmooth }] = (0, $jODJR.useHorizontalScrolling)();
    // Need to change viewport offset into px
    const scrollLeftRef = (0, $eUqFw.useRef)(0);
    const offsetPx = viewport.offset * container.width / container.duration;
    (0, $eUqFw.useEffect)(()=>{
        scrollLeftRef.current = offsetPx;
    }, [
        offsetPx
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!dragging) return;
        const minTop = 0;
        const maxTop = scrollElement.scrollHeight - scrollElement.clientHeight;
        let scrollTop = scrollElement.scrollTop;
        let scrollLeft = scrollLeftRef.current;
        let verticalDelta = 0;
        let horizontalDelta = 0;
        let stopped = false;
        let timeoutId;
        const scroll = ()=>{
            if (verticalDelta !== 0) {
                scrollTop += verticalDelta;
                scrollTop = Math.max(Math.min(scrollTop, maxTop), minTop);
                scrollElement.scrollTo(0, scrollTop);
            }
            // is zoomLevel is undefined, we don't want horizontal scrolling enabled
            if (horizontalDelta !== 0 && zoomLevel) {
                scrollLeft += horizontalDelta;
                setSmooth(true);
                scrollTo(scrollLeft, 'dragndrop');
            }
            if (!stopped) timeoutId = setTimeout(scroll, 333);
        };
        scroll();
        const { top: top, height: height, width: width } = scrollElement.getBoundingClientRect();
        const handleMouseMove = (e)=>{
            // Vertical
            const cursorOffset = e.clientY - top;
            verticalDelta = $6901d3f769c8ce8b$var$getScrollPosDelta(height, cursorOffset);
            // Horizontal
            const left = width - viewport.width + leftSidebarWidth;
            const horizontalCursorOffset = e.clientX - left;
            horizontalDelta = $6901d3f769c8ce8b$var$getScrollPosDelta(viewport.width, horizontalCursorOffset);
        };
        stopped = false;
        document.addEventListener('mousemove', handleMouseMove);
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            stopped = true;
            clearTimeout(timeoutId);
            setSmooth(false);
        };
    }, [
        viewport.width,
        dragging,
        scrollElement,
        scrollTo,
        setSmooth,
        zoomLevel,
        leftSidebarWidth
    ]);
    return null;
}

});


parcelRegister("9kZCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd5940bcc4876a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Container", () => (parcelRequire("h0tKx")).default);
$parcel$export(module.exports, "Overflowed", () => (parcelRequire("39ob0")).default);

var $lNNXV = parcelRequire("lNNXV");

var $5YMhS = parcelRequire("5YMhS");

var $3zh1k = parcelRequire("3zh1k");

var $h0tKx = parcelRequire("h0tKx");

var $39ob0 = parcelRequire("39ob0");
var $cecd5940bcc4876a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5YMhS.default), {})((0, $3zh1k.default));

});
parcelRegister("5YMhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c6f911df3d03e4$export$2e2bcd8739ae039);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $lPQPn = parcelRequire("lPQPn");

var $8YqJS = parcelRequire("8YqJS");

var $akhOi = parcelRequire("akhOi");

var $dEoWh = parcelRequire("dEoWh");

var $kFf60 = parcelRequire("kFf60");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");
var $cwP4d = parcelRequire("cwP4d");

var $2iYEz = parcelRequire("2iYEz");

var $aMoMC = parcelRequire("aMoMC");

var $k59XD = parcelRequire("k59XD");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $1TrR5 = parcelRequire("1TrR5");
const $58c6f911df3d03e4$export$d5c85a9b712b84e5 = (colours)=>{
    const ratio = 1 / colours.size;
    return [
        ...colours
    ].map((colour)=>({
            colour: colour,
            ratio: ratio
        }));
};
const $58c6f911df3d03e4$var$mapStateToPropsOld = (state, props)=>{
    const timelineRange = (0, $aMoMC.getTimelineRange)(state);
    const timelinePreview = (0, $k59XD.getTimelineState)(state);
    const mode = (0, $akhOi.getMode)(state);
    const colourByValue = (0, $kyGCj.getColorByValue)(state);
    const issueStatuses = (0, $kFf60.getIssueStatusById)(state);
    const colourMap = (0, $kyGCj.getColourMaps)(state);
    const issueId = props.issue.id;
    const externalIncomingLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || [];
    const externalOutgoingLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || [];
    const internalIncomingLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || [];
    const internalIncomingLinksOriginal = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || [];
    const internalOutgoingLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || [];
    const internalOutgoingLinksOriginal = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || [];
    const defaultIterationLength = (0, $2iYEz.getDefaultIterationLength)(state);
    const showWarning = (0, $9H2AP.getWarningViewSettings)(state).showWarning;
    let preview;
    let isBeingInteractedWith;
    let epicColor;
    if (timelinePreview) {
        preview = timelinePreview.previews[issueId];
        isBeingInteractedWith = timelinePreview.activeIssueId === issueId;
    }
    let barColors;
    if (colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE) {
        const { issue: { type: issueType } } = props;
        const colourByIssueTypeColourMap = (0, $kyGCj.getColourByIssueTypeColourMap)(state);
        const colour = colourByIssueTypeColourMap[issueType.toString()];
        if ((0, $7CnHa.isDefined)(colour)) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(new Set([
            colour
        ]));
    } else if (colourByValue === (0, $33N5G.colourByOptions).LABEL) {
        const { issue: { labels: labels } } = props;
        const colourByLabelColourMap = (0, $kyGCj.getColourByLabelColourMap)(state);
        const colours = new Set((labels || []).map((label)=>colourByLabelColourMap[label]).filter((x)=>!!x));
        if (colours.size > 0) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(colours);
    } else if (colourByValue === (0, $33N5G.colourByOptions).COMPONENT) {
        const components = props.issue?.components ?? [];
        const colourByComponentColourMap = (0, $kyGCj.getColourByComponentColourMap)(state);
        const colours = new Set((components || []).map((component)=>colourByComponentColourMap[component.toString()]).filter((x)=>!!x));
        if (colours.size > 0) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(colours);
    } else if (colourByValue === (0, $33N5G.colourByOptions).PRIORITY) {
        const { issue: { priority: priority } } = props;
        if ((0, $7CnHa.isDefined)(priority)) {
            const colourByPriorityColourMap = (0, $kyGCj.getColourByPriorityColourMap)(state);
            const colour = colourByPriorityColourMap[priority];
            if ((0, $7CnHa.isDefined)(colour)) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(new Set([
                colour
            ]));
        }
    } else if (colourByValue === (0, $33N5G.colourByOptions).EPIC) {
        const issueMapById = (0, $cwP4d.getIssueMapById)(state);
        const issue = issueMapById[issueId];
        if (issue?.level === (0, $8YqJS.EPIC_LEVEL)) epicColor = (0, $lPQPn.asColor)(issue.color);
        else if (issue?.level < (0, $8YqJS.EPIC_LEVEL)) {
            let issueParentId = issue?.parent;
            // traversing the parent layers back up to the epic level
            while(!epicColor && issueParentId && issueMapById[issueParentId]){
                const parent = issueMapById[issueParentId];
                const parentLevel = parent.level;
                if (parentLevel > (0, $8YqJS.EPIC_LEVEL)) break;
                if (parentLevel === (0, $8YqJS.EPIC_LEVEL)) {
                    epicColor = (0, $lPQPn.asColor)(parent?.color);
                    break;
                }
                issueParentId = parent?.parent;
            }
        }
        if ((0, $7CnHa.isDefined)(epicColor) && (0, $33N5G.epicColorToARJColor)[epicColor]) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(new Set([
            (0, $33N5G.epicColorToARJColor)[epicColor]
        ]));
    } else if ((0, $kyGCj.isColorByCustomFieldOption)(colourByValue)) {
        const { issue: { customFields: customFields = {} } } = props;
        const colourBySelectColourMap = (0, $kyGCj.getColourBySelectColourMap)(state);
        const value = customFields[colourByValue];
        // single-select custom field would have only one value so make it an array
        // multi-select custom field would have an array of values so it's good to go
        const values = Array.isArray(value) ? value : [
            value
        ];
        const colours = new Set(// eslint-disable-next-line @typescript-eslint/no-shadow
        (values || []).map((value)=>colourBySelectColourMap[value]).filter((x)=>!!x));
        if (colours.size > 0) barColors = $58c6f911df3d03e4$export$d5c85a9b712b84e5(colours);
    }
    const issueChildren = (0, $aK3ri.getChildrenByParent)(state)[props.issue.id] ?? [];
    return {
        barColors: barColors,
        issueChildren: issueChildren,
        colourByValue: colourByValue,
        colourMap: colourMap,
        defaultIterationLength: defaultIterationLength,
        epicColor: epicColor,
        externalIncomingLinks: externalIncomingLinks,
        externalOutgoingLinks: externalOutgoingLinks,
        internalIncomingLinks: internalIncomingLinks,
        internalIncomingLinksOriginal: internalIncomingLinksOriginal,
        internalOutgoingLinks: internalOutgoingLinks,
        internalOutgoingLinksOriginal: internalOutgoingLinksOriginal,
        isBeingInteractedWith: isBeingInteractedWith,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef) || props.isReadOnly,
        issueStatuses: issueStatuses,
        preview: preview,
        showOptimizations: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        timelineRange: timelineRange,
        showWarning: showWarning
    };
};
const $58c6f911df3d03e4$var$externalIncomingLinksList = [];
const $58c6f911df3d03e4$var$externalOutgoingLinksList = [];
const $58c6f911df3d03e4$var$internalIncomingLinksList = [];
const $58c6f911df3d03e4$var$internalIncomingLinksOriginalList = [];
const $58c6f911df3d03e4$var$internalOutgoingLinksList = [];
const $58c6f911df3d03e4$var$internalOutgoingLinksOriginalList = [];
const $58c6f911df3d03e4$var$issueChildrenList = [];
const $58c6f911df3d03e4$var$mapStateToPropsFactory = ()=>{
    const getColoursWithRatioFactory = (0, $5iWql.default)($58c6f911df3d03e4$export$d5c85a9b712b84e5, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
    return (state, props)=>{
        const timelineRange = (0, $aMoMC.getTimelineRange)(state);
        const timelinePreview = (0, $k59XD.getTimelineState)(state);
        const mode = (0, $akhOi.getMode)(state);
        const colourByValue = (0, $kyGCj.getColorByValue)(state);
        const issueStatuses = (0, $kFf60.getIssueStatusById)(state);
        const colourMap = (0, $kyGCj.getColourMaps)(state);
        const issueId = props.issue.id;
        const externalIncomingLinks = (0, $dEoWh.getExternalIncomingLinks)(state)[issueId] || $58c6f911df3d03e4$var$externalIncomingLinksList;
        const externalOutgoingLinks = (0, $dEoWh.getExternalOutgoingLinks)(state)[issueId] || $58c6f911df3d03e4$var$externalOutgoingLinksList;
        const internalIncomingLinks = (0, $dEoWh.getInternalIncomingLinks)(state)[issueId] || $58c6f911df3d03e4$var$internalIncomingLinksList;
        const internalIncomingLinksOriginal = (0, $dEoWh.getInternalIncomingLinkOriginals)(state)[issueId] || $58c6f911df3d03e4$var$internalIncomingLinksOriginalList;
        const internalOutgoingLinks = (0, $dEoWh.getInternalOutgoingLinks)(state)[issueId] || $58c6f911df3d03e4$var$internalOutgoingLinksList;
        const internalOutgoingLinksOriginal = (0, $dEoWh.getInternalOutgoingLinkOriginals)(state)[issueId] || $58c6f911df3d03e4$var$internalOutgoingLinksOriginalList;
        const defaultIterationLength = (0, $2iYEz.getDefaultIterationLength)(state);
        const showWarning = (0, $9H2AP.getWarningViewSettings)(state).showWarning;
        let preview;
        let isBeingInteractedWith;
        let epicColor;
        if (timelinePreview) {
            preview = timelinePreview.previews[issueId];
            isBeingInteractedWith = timelinePreview.activeIssueId === issueId;
        }
        let barColors;
        if (colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE) {
            const { issue: { type: issueType } } = props;
            const colourByIssueTypeColourMap = (0, $kyGCj.getColourByIssueTypeColourMap)(state);
            const colour = colourByIssueTypeColourMap[issueType.toString()];
            if ((0, $7CnHa.isDefined)(colour)) barColors = getColoursWithRatioFactory(new Set([
                colour
            ]));
        } else if (colourByValue === (0, $33N5G.colourByOptions).LABEL) {
            const { issue: { labels: labels } } = props;
            const colourByLabelColourMap = (0, $kyGCj.getColourByLabelColourMap)(state);
            const colours = new Set((labels || []).map((label)=>colourByLabelColourMap[label]).filter((x)=>!!x));
            if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
        } else if (colourByValue === (0, $33N5G.colourByOptions).COMPONENT) {
            const components = props.issue?.components ?? [];
            const colourByComponentColourMap = (0, $kyGCj.getColourByComponentColourMap)(state);
            const colours = new Set((components || []).map((component)=>colourByComponentColourMap[component.toString()]).filter((x)=>!!x));
            if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
        } else if (colourByValue === (0, $33N5G.colourByOptions).PRIORITY) {
            const { issue: { priority: priority } } = props;
            if ((0, $7CnHa.isDefined)(priority)) {
                const colourByPriorityColourMap = (0, $kyGCj.getColourByPriorityColourMap)(state);
                const colour = colourByPriorityColourMap[priority];
                if ((0, $7CnHa.isDefined)(colour)) barColors = getColoursWithRatioFactory(new Set([
                    colour
                ]));
            }
        } else if (colourByValue === (0, $33N5G.colourByOptions).EPIC) {
            const issueMapById = (0, $cwP4d.getIssueMapById)(state);
            const issue = issueMapById[issueId];
            if (issue?.level === (0, $8YqJS.EPIC_LEVEL)) epicColor = (0, $lPQPn.asColor)(issue.color);
            else if (issue?.level < (0, $8YqJS.EPIC_LEVEL)) {
                let issueParentId = issue?.parent;
                // traversing the parent layers back up to the epic level
                while(!epicColor && issueParentId && issueMapById[issueParentId]){
                    const parent = issueMapById[issueParentId];
                    const parentLevel = parent.level;
                    if (parentLevel > (0, $8YqJS.EPIC_LEVEL)) break;
                    if (parentLevel === (0, $8YqJS.EPIC_LEVEL)) {
                        epicColor = (0, $lPQPn.asColor)(parent?.color);
                        break;
                    }
                    issueParentId = parent?.parent;
                }
            }
            if ((0, $7CnHa.isDefined)(epicColor) && (0, $33N5G.epicColorToARJColor)[epicColor]) barColors = getColoursWithRatioFactory(new Set([
                (0, $33N5G.epicColorToARJColor)[epicColor]
            ]));
        } else if ((0, $kyGCj.isColorByCustomFieldOption)(colourByValue)) {
            const { issue: { customFields: customFields = {} } } = props;
            const colourBySelectColourMap = (0, $kyGCj.getColourBySelectColourMap)(state);
            const value = customFields[colourByValue];
            // single-select custom field would have only one value so make it an array
            // multi-select custom field would have an array of values so it's good to go
            const values = Array.isArray(value) ? value : [
                value
            ];
            const colours = new Set(// eslint-disable-next-line @typescript-eslint/no-shadow
            (values || []).map((value)=>colourBySelectColourMap[value]).filter((x)=>!!x));
            if (colours.size > 0) barColors = getColoursWithRatioFactory(colours);
        }
        const issueChildren = (0, $aK3ri.getChildrenByParent)(state)[props.issue.id] ?? $58c6f911df3d03e4$var$issueChildrenList;
        return {
            barColors: barColors,
            issueChildren: issueChildren,
            colourByValue: colourByValue,
            colourMap: colourMap,
            defaultIterationLength: defaultIterationLength,
            epicColor: epicColor,
            externalIncomingLinks: externalIncomingLinks,
            externalOutgoingLinks: externalOutgoingLinks,
            internalIncomingLinks: internalIncomingLinks,
            internalIncomingLinksOriginal: internalIncomingLinksOriginal,
            internalOutgoingLinks: internalOutgoingLinks,
            internalOutgoingLinksOriginal: internalOutgoingLinksOriginal,
            isBeingInteractedWith: isBeingInteractedWith,
            isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef) || props.isReadOnly,
            issueStatuses: issueStatuses,
            preview: preview,
            showOptimizations: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
            timelineRange: timelineRange,
            showWarning: showWarning
        };
    };
};
// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
const $58c6f911df3d03e4$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($58c6f911df3d03e4$var$mapStateToPropsFactory, $58c6f911df3d03e4$var$mapStateToPropsOld);
var $58c6f911df3d03e4$export$2e2bcd8739ae039 = $58c6f911df3d03e4$var$mapStateToProps;

});

parcelRegister("3zh1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3a04265accca29b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2wtN3 = parcelRequire("2wtN3");
var $b3iuB = parcelRequire("b3iuB");

var $g4Vkx = parcelRequire("g4Vkx");

var $57dZR = parcelRequire("57dZR");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $kJgLh = parcelRequire("kJgLh");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $l1fIX = parcelRequire("l1fIX");

var $h0tKx = parcelRequire("h0tKx");

var $aM5yF = parcelRequire("aM5yF");

var $a6kRt = parcelRequire("a6kRt");

var $aFEKE = parcelRequire("aFEKE");

var $BMvsQ = parcelRequire("BMvsQ");

var $3FC5p = parcelRequire("3FC5p");
const $e3a04265accca29b$export$5e7466f07ec9ce6a = (issue, issueStatuses, colourMap)=>{
    const issueCategoryId = (0, $7CnHa.isDefined)(issue) && (0, $7CnHa.isDefined)(issue.status) && (0, $7CnHa.isDefined)(issueStatuses) && !$b3iuB.default(issueStatuses) && (0, $7CnHa.isDefined)(issueStatuses[issue.status]) && issueStatuses[issue.status].categoryId;
    const issueStatusColour = (0, $7CnHa.isDefined)(colourMap) && !$b3iuB.default(colourMap) && (0, $7CnHa.isDefined)(colourMap.status) && !$b3iuB.default(colourMap.status) && issueCategoryId && colourMap.status[issueCategoryId.toString()];
    // Not using tokens because bar gradients use mathematical calulcations which rely on hex
    return issueStatusColour || (0, $g4Vkx.default).N500;
};
const $e3a04265accca29b$var$getColour = (issue, colourByValue, issueStatuses, colourMap, epicColor)=>{
    switch(colourByValue){
        case (0, $33N5G.colourByOptions).PROJECT:
            if (issue.project) return colourMap.project[issue.project.toString()];
            break;
        case (0, $33N5G.colourByOptions).STATUS:
            return $e3a04265accca29b$export$5e7466f07ec9ce6a(issue, issueStatuses, colourMap);
        case (0, $33N5G.colourByOptions).TEAM:
            if (issue.team) return colourMap.team[issue.team];
            break;
        case (0, $33N5G.colourByOptions).EPIC:
            if (epicColor) return epicColor;
            break;
        default:
            return 0, $33N5G.DEFAULT_COLOR;
    }
};
class $e3a04265accca29b$export$2e2bcd8739ae039 extends (0, $kJgLh.default) {
    static{
        this.defaultProps = {
            isReadOnly: false,
            showOptimizations: false,
            isBeingInteractedWith: false,
            issueWarnings: [],
            disableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            reEnableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            BothDatesRow: $l1fIX.default,
            PartialDatesRow: $aFEKE.default,
            NoDatesRow: $a6kRt.default
        };
    }
    render() {
        const { issue: issue, issueChildren: issueChildren, timelineRange: timelineRange, backgroundColor: backgroundColor, preview: preview, showOptimizations: showOptimizations, disableOtherRows: disableOtherRows, reEnableOtherRows: reEnableOtherRows, isBeingInteractedWith: isBeingInteractedWith, isReadOnly: isReadOnly, issueWarnings: issueWarnings, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, width: width, colourByValue: colourByValue, issueStatuses: issueStatuses, colourMap: colourMap, barColors: barColors, showWarning: showWarning, topOffset: topOffset, epicColor: epicColor, hasDependencyLineDragPreview: hasDependencyLineDragPreview } = this.props;
        const hasWarnings = issueWarnings.length > 0 && showWarning;
        let hasOptimizedChanges = false;
        if (showOptimizations && issue.optimized) {
            for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                hasOptimizedChanges = true;
                break;
            }
        }
        let barColor = (0, $33N5G.DEFAULT_COLOR);
        let adjustedBarColors;
        const showStripesInBar = {
            left: false,
            right: false
        };
        if (!showOptimizations) {
            barColor = $e3a04265accca29b$var$getColour(issue, colourByValue, issueStatuses, colourMap, epicColor) ?? (0, $33N5G.DEFAULT_COLOR);
            adjustedBarColors = barColors;
        }
        if (hasWarnings && colourByValue === (0, $33N5G.colourByOptions).NONE) {
            // Disabled because bar gradients use mathematical calulcations which rely on hex
            barColor = (0, $g4Vkx.default).Y300;
            adjustedBarColors = null;
            if (showOptimizations && hasOptimizedChanges) {
                showStripesInBar.left = true;
                showStripesInBar.right = true;
            }
            if (issue.inferred) {
                showStripesInBar.left = issue.inferred.baselineStart === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
                showStripesInBar.right = issue.inferred.baselineEnd === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
            }
        } else if (hasOptimizedChanges) {
            barColor = (0, $33N5G.OPTIMIZED_COLOR);
            adjustedBarColors = null;
            showStripesInBar.left = true;
            showStripesInBar.right = true;
        } else if (issue.inferred) {
            showStripesInBar.left = issue.inferred.baselineStart === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
            showStripesInBar.right = issue.inferred.baselineEnd === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
        }
        const hasOptimizedDates = showOptimizations && ((0, $7CnHa.isDefined)(issue.optimized && issue.optimized.baselineStart) || (0, $7CnHa.isDefined)(issue.optimized && issue.optimized.baselineEnd));
        const { baselineStart: baselineStart, baselineEnd: baselineEnd } = hasOptimizedDates && issue.optimized ? issue.optimized : issue;
        // When baselineStart and baselineEnd (aka targetStart and targetEnd) dates are not defined
        // but if there is a sprint assigned, we calculate the target start and target end dates
        // and draw the bar based on them
        const showActiveSprintOnTooltip = Boolean(issue.inferred && (issue.inferred.baselineStart === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT || issue.inferred.baselineEnd === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT));
        let renderFlyout;
        if (hasOptimizedChanges) renderFlyout = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aM5yF.default), {
                issue: issue
            });
        const opacity = preview ? (0, $5rYNM.PREVIEW_OPACITY) : 1;
        const innerViewProps = {
            issue: issue,
            issueChildren: issueChildren,
            baselineStart: baselineStart,
            baselineEnd: baselineEnd,
            timelineRange: timelineRange,
            barColor: barColor,
            barColors: adjustedBarColors,
            showStripesInBar: showStripesInBar,
            preview: preview,
            renderFlyout: renderFlyout,
            disableOtherRows: disableOtherRows,
            reEnableOtherRows: reEnableOtherRows,
            isBeingInteractedWith: isBeingInteractedWith,
            isReadOnly: isReadOnly,
            externalIncomingLinks: externalIncomingLinks,
            externalOutgoingLinks: externalOutgoingLinks,
            internalIncomingLinks: internalIncomingLinks,
            internalIncomingLinksOriginal: internalIncomingLinksOriginal,
            internalOutgoingLinks: internalOutgoingLinks,
            internalOutgoingLinksOriginal: internalOutgoingLinksOriginal,
            width: width,
            opacity: opacity,
            showActiveSprintOnTooltip: showActiveSprintOnTooltip,
            topOffset: topOffset,
            hasDependencyLineDragPreview: hasDependencyLineDragPreview
        };
        const innerView = this.areDatesInferredFromRollUp() ? this.getRollUpInnerView(innerViewProps) : this.getInnerView(innerViewProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $BMvsQ.row,
            "data-issue": issue.id,
            "data-group": issue.group,
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.${issue.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), {
            bgColor: backgroundColor
        }, innerView));
    }
    constructor(...args){
        super(...args);
        this.areDatesInferredFromRollUp = ()=>{
            const { issue: { inferred: { baselineStart: baselineStart, baselineEnd: baselineEnd } = {} } } = this.props;
            return baselineStart === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP || baselineEnd === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP;
        };
        this.getInnerView = (innerViewProps)=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { BothDatesRow: BothDatesRow, PartialDatesRow: PartialDatesRow, NoDatesRow: NoDatesRow } = this.props;
            const { baselineStart: baselineStart, baselineEnd: baselineEnd, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = innerViewProps;
            if ((0, $7CnHa.isDefined)(baselineStart) && (0, $7CnHa.isDefined)(baselineEnd) && baselineStart <= baselineEnd) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BothDatesRow, {
                ...innerViewProps,
                showActiveSprintOnTooltip: showActiveSprintOnTooltip
            });
            if ((0, $7CnHa.isDefined)(baselineStart) || (0, $7CnHa.isDefined)(baselineEnd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PartialDatesRow, innerViewProps);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoDatesRow, innerViewProps);
        };
        this.getRollUpInnerView = (innerViewProps)=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { issue: issue, BothDatesRow: BothDatesRow } = this.props;
            const { baselineStart: baselineStart, baselineEnd: baselineEnd, issueChildren: issueChildren, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = innerViewProps;
            const forcedGradients = (0, $3FC5p.getForcedGradients)({
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            }, issueChildren);
            const start = $2wtN3.default(forcedGradients.earliestStart, baselineStart);
            const end = $2wtN3.default(forcedGradients.latestEnd, baselineEnd);
            if (start <= end) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BothDatesRow, {
                ...innerViewProps,
                baselineStart: start,
                baselineEnd: end,
                forcedGradients: forcedGradients,
                showActiveSprintOnTooltip: showActiveSprintOnTooltip,
                datesInferredFrom: issue.inferred
            });
            return null;
        };
    }
}

});
parcelRegister("l1fIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27096309d1177f3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bXnfO = parcelRequire("bXnfO");

var $ejBrH = parcelRequire("ejBrH");

var $fyUw5 = parcelRequire("fyUw5");
var $c27096309d1177f3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ejBrH.default), (0, $bXnfO.default))((0, $fyUw5.default));

});
parcelRegister("bXnfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a35aca80d05d9d$export$2e2bcd8739ae039);

var $8NDwu = parcelRequire("8NDwu");

var $dbuYA = parcelRequire("dbuYA");
const $07a35aca80d05d9d$var$mapDispatchToProps = (dispatch, ownProps)=>({
        commitTimelinePreview: ()=>{
            dispatch((0, $8NDwu.commitTimelinePreview)());
        },
        moveTimelineIssue: (delta, targetStart, targetEnd)=>{
            dispatch((0, $dbuYA.suspend)());
            dispatch((0, $8NDwu.hoverTimelineIssue)(ownProps.issue.id, targetStart, targetEnd));
            dispatch((0, $8NDwu.moveTimelineIssue)(delta, targetStart, targetEnd));
            dispatch((0, $dbuYA.resume)());
        },
        resizeTimelineIssue: (baselineStart, baselineEnd)=>{
            dispatch((0, $dbuYA.suspend)());
            dispatch((0, $8NDwu.hoverTimelineIssue)(ownProps.issue.id, baselineStart, baselineEnd));
            dispatch((0, $8NDwu.resizeTimelineIssue)(baselineStart, baselineEnd));
            dispatch((0, $dbuYA.resume)());
        }
    });
var $07a35aca80d05d9d$export$2e2bcd8739ae039 = $07a35aca80d05d9d$var$mapDispatchToProps;

});
parcelRegister("8NDwu", function(module, exports) {

$parcel$export(module.exports, "hoverTimelineIssue", () => $5585ae22294aafa3$export$bd084625a2308db4);
$parcel$export(module.exports, "moveTimelineIssue", () => $5585ae22294aafa3$export$75d7727d186ac0aa);
$parcel$export(module.exports, "resizeTimelineIssue", () => $5585ae22294aafa3$export$e6337a28fb489262);
$parcel$export(module.exports, "commitTimelinePreview", () => $5585ae22294aafa3$export$4e0f49671c452c61);
$parcel$export(module.exports, "cancelTimelinePreview", () => $5585ae22294aafa3$export$c13f756c23f6a090);
$parcel$export(module.exports, "default", () => $5585ae22294aafa3$export$2e2bcd8739ae039);
parcelRequire("inLJ0");
var $71txE = parcelRequire("71txE");

var $fpul1 = parcelRequire("fpul1");
var $dfCnd = parcelRequire("dfCnd");
var $cQGVO = parcelRequire("cQGVO");
var $kjklK = parcelRequire("kjklK");
var $79tFY = parcelRequire("79tFY");
var $7WzTP = parcelRequire("7WzTP");
var $f7Op5 = parcelRequire("f7Op5");
var $kKqcq = parcelRequire("kKqcq");
var $9RbxZ = parcelRequire("9RbxZ");
var $eCpJ2 = parcelRequire("eCpJ2");
var $UCNmJ = parcelRequire("UCNmJ");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kXdPE = parcelRequire("kXdPE");

var $cbq3D = parcelRequire("cbq3D");

var $1Szmp = parcelRequire("1Szmp");

var $kwMvv = parcelRequire("kwMvv");

var $cwP4d = parcelRequire("cwP4d");

var $k59XD = parcelRequire("k59XD");

var $9H2AP = parcelRequire("9H2AP");

var $blSD2 = parcelRequire("blSD2");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

const $5585ae22294aafa3$export$bd084625a2308db4 = (issueId, defaultStart, defaultEnd)=>({
        type: (0, $8e08f6a976502b9d$export$cac9106b1c7f24fc),
        payload: {
            issueId: issueId,
            defaultStart: defaultStart,
            defaultEnd: defaultEnd
        }
    });
const $5585ae22294aafa3$export$75d7727d186ac0aa = (delta, targetStart, targetEnd)=>({
        type: (0, $8e08f6a976502b9d$export$eb5a7568e1c3d408),
        payload: {
            delta: delta,
            targetStart: targetStart,
            targetEnd: targetEnd
        }
    });
const $5585ae22294aafa3$export$e6337a28fb489262 = (baselineStart, baselineEnd)=>({
        type: (0, $8e08f6a976502b9d$export$f5393940db5375),
        payload: {
            baselineStart: baselineStart,
            baselineEnd: baselineEnd
        }
    });
const $5585ae22294aafa3$export$4e0f49671c452c61 = ()=>({
        type: (0, $8e08f6a976502b9d$export$328d95132417a337)
    });
const $5585ae22294aafa3$export$c13f756c23f6a090 = ()=>({
        type: (0, $8e08f6a976502b9d$export$c926e344ad34027e)
    });
const { ROLL_UP: $5585ae22294aafa3$var$ROLL_UP, SPRINT: $5585ae22294aafa3$var$SPRINT } = (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION);
const $5585ae22294aafa3$export$6d7b0751be84e7bc = (type)=>$79tFY.default([
        'inferred',
        type
    ], $5585ae22294aafa3$var$ROLL_UP);
const $5585ae22294aafa3$export$b1f4a493aaefef29 = (type)=>$79tFY.default([
        'inferred',
        type
    ], $5585ae22294aafa3$var$SPRINT);
function* $5585ae22294aafa3$export$3f9bf2fcabbab63e({ payload: { issueId: issueId, defaultStart: defaultStart, defaultEnd: defaultEnd } }) {
    try {
        const issueMapById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
        const activeIssue = issueMapById[issueId];
        // Invalid state, do nothing
        if (!activeIssue) return;
        const timeline = yield (0, $9e8i2.select)((0, $k59XD.getTimelineState));
        // If there is a preview (used when moving we need to use the preview's dates)
        const baselineStart = timeline && (0, $7CnHa.isDefined)(activeIssue.baselineStart) ? $kjklK.default([
            'previews',
            activeIssue.id,
            'baselineStart'
        ], timeline) : defaultStart;
        const baselineEnd = timeline && (0, $7CnHa.isDefined)(activeIssue.baselineEnd) ? $kjklK.default([
            'previews',
            activeIssue.id,
            'baselineEnd'
        ], timeline) : defaultEnd;
        // Strict descendants
        const strictDescendents = yield (0, $9e8i2.select)((0, $k59XD.getDescendents), {
            issueId: issueId,
            isStrict: true
        });
        const definedDescendentsWithoutSprintInferred = $fpul1.default((i)=>((0, $7CnHa.isDefined)(i.baselineStart) || (0, $7CnHa.isDefined)(i.baselineEnd)) && !$5585ae22294aafa3$export$b1f4a493aaefef29('baselineStart')(i), strictDescendents);
        const indexedDescendentIssues = (0, $7CnHa.indexBy)($f7Op5.default('id'), definedDescendentsWithoutSprintInferred);
        const strictDescendentsPreviews = $cQGVO.default((issue)=>({
                inferred: issue.inferred,
                baselineStart: issue.baselineStart,
                baselineEnd: issue.baselineEnd,
                shouldSync: true
            }), indexedDescendentIssues);
        const showRolledUpDates = yield (0, $9e8i2.select)((0, $9H2AP.getShowRolledUpDates));
        // when "Roll-up > Dates" view setting is disabled, just preview active issue
        if (!showRolledUpDates) {
            yield (0, $9e8i2.put)((0, $blSD2.setPreviewIssues)({
                activeIssueId: issueId,
                issueAndAncestors: {
                    [issueId]: {
                        baselineStart: baselineStart,
                        baselineEnd: baselineEnd,
                        shouldSync: true,
                        inferred: activeIssue.inferred
                    }
                },
                strictDescendents: strictDescendentsPreviews
            }));
            return;
        }
        // when "Roll-up > Dates" view setting is enabled
        const issueAncestors = (0, $kwMvv.getAncestors)(activeIssue, issueMapById, Infinity);
        const activeAndAncestors = [
            activeIssue
        ].concat(issueAncestors);
        const issuesSortedByLevelFromLowerToHigher = $9RbxZ.default($f7Op5.default('level'), activeAndAncestors);
        const highestLevelParent = $dfCnd.default(issuesSortedByLevelFromLowerToHigher);
        const siblingsDescendants = yield (0, $9e8i2.select)((0, $k59XD.getDescendents), {
            issueId: highestLevelParent && highestLevelParent.id,
            isStrict: true
        });
        // Delete inferred dates so we can recalculate state using getIssuesWithRolledUpDates
        const realDatesOnly = activeAndAncestors.concat(siblingsDescendants).map((issue)=>{
            const result = {
                ...issue
            };
            const isStartInferred = $kjklK.default([
                'inferred',
                'baselineStart'
            ], issue) === -1;
            const isEndInferred = $kjklK.default([
                'inferred',
                'baselineEnd'
            ], issue) === -1;
            if (isStartInferred) result.baselineStart = undefined;
            if (isEndInferred) result.baselineEnd = undefined;
            if (issue.id !== issueId) return result;
            return {
                ...result,
                baselineStart: baselineStart,
                baselineEnd: baselineEnd
            };
        });
        // Recalculate previews re-using same function as render getIssuesWithRolledUpDates
        const rolledUpIssues = (0, $cwP4d.getIssuesWithRolledUpDates)(realDatesOnly)// Previews that don't have at least one date will error through out the app
        .filter((issue)=>(0, $7CnHa.isDefined)(issue.baselineStart) || (0, $7CnHa.isDefined)(issue.baselineEnd));
        const rolledUpIssuesMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), rolledUpIssues);
        const newPreviews = $cQGVO.default(// eslint-disable-next-line @typescript-eslint/no-shadow
        ({ baselineStart: baselineStart, baselineEnd: baselineEnd, id: id, inferred: inferred })=>({
                inferred: inferred,
                baselineStart: baselineStart,
                baselineEnd: baselineEnd,
                shouldSync: id === issueId
            }), rolledUpIssuesMap);
        yield (0, $9e8i2.put)((0, $blSD2.setPreviewIssues)({
            activeIssueId: issueId,
            issueAndAncestors: newPreviews,
            strictDescendents: strictDescendentsPreviews
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $5585ae22294aafa3$export$37f14865afe5c37f({ payload: { delta: delta, targetStart: targetStart, targetEnd: targetEnd } }) {
    try {
        yield (0, $9e8i2.put)((0, $blSD2.moveIssueAndDescendents)({
            delta: delta,
            targetStart: targetStart,
            targetEnd: targetEnd
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $5585ae22294aafa3$export$ddbfe1d172b0734c({ payload: { baselineStart: baselineStart, baselineEnd: baselineEnd } }) {
    try {
        const timeline = yield (0, $9e8i2.select)((0, $k59XD.getTimelineState));
        if (!timeline) return;
        const { activeIssueId: activeIssueId, previews: previews, strictDescendentIds: strictDescendentIds } = timeline;
        if (!activeIssueId || !previews) return;
        const strictDescendentPreviews = $7WzTP.default(strictDescendentIds, previews);
        if ((0, $7CnHa.isDefined)(baselineStart)) {
            // Clamp to earliest as convenience, but mark as invalid user action.
            const listOfBaselineStarts = $cQGVO.default($kKqcq.default(Infinity, 'baselineStart'), $UCNmJ.default(strictDescendentPreviews));
            yield (0, $9e8i2.put)((0, $blSD2.setIssuesStart)({
                issueIds: [
                    activeIssueId
                ],
                baselineStart: Math.min(...listOfBaselineStarts, baselineStart)
            }));
        }
        if ((0, $7CnHa.isDefined)(baselineEnd)) {
            // Clamp to latest as convenience, but mark as invalid user action.
            const listOfBaselineEnds = $cQGVO.default($kKqcq.default(-Infinity, 'baselineEnd'), $UCNmJ.default(strictDescendentPreviews));
            yield (0, $9e8i2.put)((0, $blSD2.setIssuesEnd)({
                issueIds: [
                    activeIssueId
                ],
                baselineEnd: Math.max(...listOfBaselineEnds, baselineEnd)
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $5585ae22294aafa3$var$syncIssueBaselines(payload) {
    yield (0, $9e8i2.put)((0, $1Szmp.updateIssueRaw)(payload));
}
function* $5585ae22294aafa3$export$8af26ab715337da7() {
    try {
        const state = yield (0, $9e8i2.select)((0, $k59XD.getTimelineState));
        if (!state) return;
        const listOfPreviews = $eCpJ2.default(state.previews);
        yield* (0, $kXdPE.default)(function*() {
            for (const [id, preview] of listOfPreviews){
                const { baselineStart: baselineStart, baselineEnd: baselineEnd, shouldSync: shouldSync, inferred: inferred } = preview;
                if (shouldSync) {
                    const isInferredStart = inferred && !!inferred.baselineStart;
                    const isInferredEnd = inferred && !!inferred.baselineEnd;
                    yield* $5585ae22294aafa3$var$syncIssueBaselines({
                        id: id,
                        baselineStart: isInferredStart ? undefined : baselineStart,
                        baselineEnd: isInferredEnd ? undefined : baselineEnd
                    });
                }
            }
            // ensure that emitted actions are processed by reducers
            yield (0, $9e8i2.call)((0, $71txE.delay), 0);
            yield (0, $9e8i2.put)((0, $blSD2.clearPreview)());
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $5585ae22294aafa3$export$adf2e216f69c6b27() {
    try {
        yield (0, $9e8i2.put)((0, $blSD2.clearPreview)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $5585ae22294aafa3$export$d6dd54078da4bb63() {
    yield (0, $bG7pV.takeEvery)((0, $8e08f6a976502b9d$export$cac9106b1c7f24fc), $5585ae22294aafa3$export$3f9bf2fcabbab63e);
}
function* $5585ae22294aafa3$export$c695a14ab796349b() {
    yield (0, $bG7pV.takeEvery)((0, $8e08f6a976502b9d$export$eb5a7568e1c3d408), $5585ae22294aafa3$export$37f14865afe5c37f);
}
function* $5585ae22294aafa3$export$da137b069b1cdf64() {
    yield (0, $bG7pV.takeEvery)((0, $8e08f6a976502b9d$export$f5393940db5375), $5585ae22294aafa3$export$ddbfe1d172b0734c);
}
function* $5585ae22294aafa3$export$c9b1825986d71014() {
    yield (0, $bG7pV.takeEvery)((0, $8e08f6a976502b9d$export$328d95132417a337), $5585ae22294aafa3$export$8af26ab715337da7);
}
function* $5585ae22294aafa3$export$bd06ebe2b531e4ef() {
    yield (0, $bG7pV.takeEvery)((0, $8e08f6a976502b9d$export$c926e344ad34027e), $5585ae22294aafa3$export$adf2e216f69c6b27);
}
function* $5585ae22294aafa3$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($5585ae22294aafa3$export$c695a14ab796349b);
    yield (0, $9e8i2.fork)($5585ae22294aafa3$export$d6dd54078da4bb63);
    yield (0, $9e8i2.fork)($5585ae22294aafa3$export$da137b069b1cdf64);
    yield (0, $9e8i2.fork)($5585ae22294aafa3$export$c9b1825986d71014);
    yield (0, $9e8i2.fork)($5585ae22294aafa3$export$bd06ebe2b531e4ef);
}

});
parcelRegister("kKqcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ac6d290cbd29e3$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");

var $dOoQ4 = parcelRequire("dOoQ4");
/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $f1ac6d290cbd29e3$var$propOr = /*#__PURE__*/ (0, $4g10W.default)(function propOr(val, p, obj) {
    return (0, $dOoQ4.default)(val, [
        p
    ], obj);
});
var $f1ac6d290cbd29e3$export$2e2bcd8739ae039 = $f1ac6d290cbd29e3$var$propOr;

});

parcelRegister("blSD2", function(module, exports) {

$parcel$export(module.exports, "SET_PREVIEW_ISSUES", () => $6663a8782dcbb7c7$export$80637663a1a05fe9);
$parcel$export(module.exports, "MOVE_ISSUE_AND_DESCENDENTS", () => $6663a8782dcbb7c7$export$8075320e8cff4d3a);
$parcel$export(module.exports, "SET_ISSUES_START", () => $6663a8782dcbb7c7$export$6fa9cc43099b89d3);
$parcel$export(module.exports, "SET_ISSUES_END", () => $6663a8782dcbb7c7$export$c2d0f2930212a9b6);
$parcel$export(module.exports, "CLEAR_PREVIEW", () => $6663a8782dcbb7c7$export$be1c5abe616607a6);
$parcel$export(module.exports, "setPreviewIssues", () => $6663a8782dcbb7c7$export$9f97114098874fdb);
$parcel$export(module.exports, "moveIssueAndDescendents", () => $6663a8782dcbb7c7$export$e4e09806b1513aec);
$parcel$export(module.exports, "setIssuesStart", () => $6663a8782dcbb7c7$export$cd118d4d32fb971);
$parcel$export(module.exports, "setIssuesEnd", () => $6663a8782dcbb7c7$export$993d450aa040cdf3);
$parcel$export(module.exports, "clearPreview", () => $6663a8782dcbb7c7$export$6b29cdc60786cec3);
const $6663a8782dcbb7c7$export$80637663a1a05fe9 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_PREVIEW_ISSUES';
const $6663a8782dcbb7c7$export$8075320e8cff4d3a = 'state.ui.main.tabs.roadmap.timeline-preview.MOVE_ISSUE_AND_DESCENDENTS';
const $6663a8782dcbb7c7$export$6fa9cc43099b89d3 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_ISSUES_START';
const $6663a8782dcbb7c7$export$c2d0f2930212a9b6 = 'state.ui.main.tabs.roadmap.timeline-preview.SET_ISSUES_END';
const $6663a8782dcbb7c7$export$be1c5abe616607a6 = 'state.ui.main.tabs.roadmap.timeline-preview.CLEAR_PREVIEW';
const $6663a8782dcbb7c7$export$9f97114098874fdb = (payload)=>({
        type: $6663a8782dcbb7c7$export$80637663a1a05fe9,
        payload: payload
    });
const $6663a8782dcbb7c7$export$e4e09806b1513aec = (payload)=>({
        type: $6663a8782dcbb7c7$export$8075320e8cff4d3a,
        payload: payload
    });
const $6663a8782dcbb7c7$export$cd118d4d32fb971 = (payload)=>({
        type: $6663a8782dcbb7c7$export$6fa9cc43099b89d3,
        payload: payload
    });
const $6663a8782dcbb7c7$export$993d450aa040cdf3 = (payload)=>({
        type: $6663a8782dcbb7c7$export$c2d0f2930212a9b6,
        payload: payload
    });
const $6663a8782dcbb7c7$export$6b29cdc60786cec3 = ()=>({
        type: $6663a8782dcbb7c7$export$be1c5abe616607a6
    });

});

const $8e08f6a976502b9d$export$cac9106b1c7f24fc = 'command.timeline-preview.HOVER_TIMELINE_ISSUE';
const $8e08f6a976502b9d$export$eb5a7568e1c3d408 = 'command.timeline-preview.MOVE_TIMELINE_ISSUE';
const $8e08f6a976502b9d$export$f5393940db5375 = 'command.timeline-preview.RESIZE_TIMELINE_ISSUE';
const $8e08f6a976502b9d$export$328d95132417a337 = 'command.timeline-preview.COMMIT_TIMELINE_PREVIEW';
const $8e08f6a976502b9d$export$c926e344ad34027e = 'command.timeline-preview.CANCEL_TIMELINE_PREVIEW';



parcelRegister("ejBrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22672170fc6d47b$export$2e2bcd8739ae039);

var $c1XMU = parcelRequire("c1XMU");

var $k59XD = parcelRequire("k59XD");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $3FC5p = parcelRequire("3FC5p");
const $d22672170fc6d47b$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    sprints: (0, $c1XMU.getSprints),
    // Have to do a similar calculation for previews
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'props' implicitly has an 'any' type.
    previewForcedGradients: (state, props)=>{
        const { preview: preview, issueChildren: issueChildren } = props;
        if (!preview) return;
        const { previews: previews } = (0, $k59XD.getTimelineState)(state) || {};
        const childrenPreviews = previews && issueChildren?.map((issue)=>previews[issue.id]).filter((0, $7CnHa.isDefined));
        return (0, $3FC5p.getForcedGradients)(preview, childrenPreviews);
    }
});
var $d22672170fc6d47b$export$2e2bcd8739ae039 = $d22672170fc6d47b$var$mapStateToProps;

});
parcelRegister("3FC5p", function(module, exports) {

$parcel$export(module.exports, "getForcedGradients", () => $56c85b2c11f7f675$export$b5c256602dd8c06c);

var $2wtN3 = parcelRequire("2wtN3");
var $eoUrK = parcelRequire("eoUrK");
var $ldYmX = parcelRequire("ldYmX");

var $7CnHa = parcelRequire("7CnHa");
const $56c85b2c11f7f675$export$b5c256602dd8c06c = ({ baselineStart: baselineStart, baselineEnd: baselineEnd }, children)=>$ldYmX.default(// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
    (acc, { baselineStart: baselineStart, baselineEnd: baselineEnd })=>$eoUrK.default({
            earliestStart: (earliestStart)=>Math.min(earliestStart, $2wtN3.default(Infinity, baselineStart), $2wtN3.default(Infinity, baselineEnd)),
            earliestEnd: (earliestEnd)=>(0, $7CnHa.isDefined)(baselineStart) ? earliestEnd : Math.min(earliestEnd, $2wtN3.default(Infinity, baselineEnd)),
            latestStart: (latestStart)=>(0, $7CnHa.isDefined)(baselineEnd) ? latestStart : Math.max(latestStart, $2wtN3.default(-Infinity, baselineStart)),
            latestEnd: (latestEnd)=>Math.max(latestEnd, $2wtN3.default(-Infinity, baselineStart), $2wtN3.default(-Infinity, baselineEnd))
        }, acc), {
        earliestStart: $2wtN3.default(Infinity, baselineStart),
        earliestEnd: $2wtN3.default(Infinity, baselineStart),
        latestStart: $2wtN3.default(-Infinity, baselineEnd),
        latestEnd: $2wtN3.default(-Infinity, baselineEnd),
        left: !(0, $7CnHa.isDefined)(baselineStart),
        right: !(0, $7CnHa.isDefined)(baselineEnd)
    }, children || []);

});


parcelRegister("fyUw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a36036db8ce0fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $17L5s = parcelRequire("17L5s");
var $fmBR7 = parcelRequire("fmBR7");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $l9dNG = parcelRequire("l9dNG");

var $gVkBP = parcelRequire("gVkBP");

var $imoOy = parcelRequire("imoOy");

var $kG4Lf = parcelRequire("kG4Lf");

var $euTYF = parcelRequire("euTYF");

var $ixveE = parcelRequire("ixveE");

var $39ob0 = parcelRequire("39ob0");

var $fHPCH = parcelRequire("fHPCH");
const { ROLL_UP: $48a36036db8ce0fd$var$ROLL_UP } = (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION);
const $48a36036db8ce0fd$var$snapWithRound = (val, snap)=>Math.round(val / snap) * snap;
class $48a36036db8ce0fd$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            DependencyMarker: $euTYF.default,
            Bar: $l9dNG.default,
            isReadOnly: false,
            showStripesInBar: {
                left: false,
                right: false
            },
            isBeingInteractedWith: false,
            commitTimelinePreview: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            moveTimelineIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            resizeTimelineIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            disableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            reEnableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            renderFlyout: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { issue: issue, baselineStart: baselineStart, baselineEnd: baselineEnd, forcedGradients: forcedGradients, previewForcedGradients: previewForcedGradients, timelineRange: timelineRange, barColor: barColor, barColors: barColors, showStripesInBar: showStripesInBar, preview: preview, hasDependencyLineDragPreview: hasDependencyLineDragPreview, renderFlyout: renderFlyout, isReadOnly: isReadOnly, isBeingInteractedWith: isBeingInteractedWith, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, width: width, DependencyMarker: // eslint-disable-next-line @typescript-eslint/no-shadow
        DependencyMarker, Bar: // eslint-disable-next-line @typescript-eslint/no-shadow
        Bar, opacity: opacity, sprints: sprints, showActiveSprintOnTooltip: showActiveSprintOnTooltip, datesInferredFrom: datesInferredFrom, topOffset: topOffset } = this.props;
        const { hovered: hovered } = this.state;
        if (!(0, $7CnHa.isDefined)(baselineStart) || !(0, $7CnHa.isDefined)(baselineEnd)) throw Error('Issue must have both target dates specified to use this component');
        const barPositions = (0, $gVkBP.getPositionsForBar)({
            baselineStart: baselineStart,
            baselineEnd: baselineEnd
        }, timelineRange, forcedGradients);
        const isInferredStart = datesInferredFrom && datesInferredFrom.baselineStart === $48a36036db8ce0fd$var$ROLL_UP;
        const isInferredEnd = datesInferredFrom && datesInferredFrom.baselineEnd === $48a36036db8ce0fd$var$ROLL_UP;
        const isFadingStart = barPositions.leftAnchorPercentage !== 0;
        const isFadingEnd = barPositions.rightAnchorPercentage !== 100;
        // We don't want to drag any side is fading (same as non-rolledup)
        const canDragMove = !isFadingStart && !isFadingEnd;
        const effectiveBaselineStart = barPositions.leftAnchorPercentage === 0 ? baselineStart : null;
        const startDate = preview && (0, $7CnHa.isDefined)(preview.baselineStart) ? preview.baselineStart : effectiveBaselineStart;
        const effectiveBaselineEnd = barPositions.rightAnchorPercentage === 100 ? baselineEnd : null;
        const endDate = preview && (0, $7CnHa.isDefined)(preview.baselineEnd) ? preview.baselineEnd : effectiveBaselineEnd;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const barAdditionalStyles = {};
        if (!isReadOnly && canDragMove) barAdditionalStyles.cursor = 'move';
        let barDragHandler;
        let leftHandleDragHandler;
        let rightHandleDragHandler;
        if (!isReadOnly) {
            const baseDragHandler = {
                onDragStart: ()=>{
                    this.props.disableOtherRows(issue.id);
                },
                onDragEnd: ()=>{
                    this.props.commitTimelinePreview();
                    this.props.reEnableOtherRows();
                }
            };
            // Drag start
            leftHandleDragHandler = {
                ...baseDragHandler,
                onDrag: (_, to, start)=>{
                    if (!baselineStart || !baselineEnd) throw Error('baseline dates must be set'); // Flow check
                    const timelineWidth = timelineRange.end - timelineRange.start;
                    const deltaRatio = (to.x - start.x) / width;
                    const delta = $48a36036db8ce0fd$var$snapWithRound(deltaRatio * timelineWidth, (0, $17L5s.ONE_DAY));
                    const newBaselineStart = (0, $17L5s.startOfUtcDay)(Math.min(baselineStart + delta, baselineEnd || 0));
                    this.props.resizeTimelineIssue(newBaselineStart, isFadingEnd || isInferredEnd === true ? undefined : baselineEnd);
                }
            };
            // Drag end
            rightHandleDragHandler = {
                ...baseDragHandler,
                onDrag: (_, to, start)=>{
                    if (!baselineStart || !baselineEnd) throw Error('baseline dates must be set'); // Flow check
                    const timelineWidth = timelineRange.end - timelineRange.start;
                    const deltaRatio = (to.x - start.x) / width;
                    const delta = $48a36036db8ce0fd$var$snapWithRound(deltaRatio * timelineWidth, (0, $17L5s.ONE_DAY));
                    const newBaselineEnd = (0, $17L5s.endOfUtcDay)(Math.max(baselineEnd + delta, baselineStart || 0));
                    this.props.resizeTimelineIssue(isFadingStart || isInferredStart === true ? undefined : baselineStart, newBaselineEnd);
                }
            };
            if (canDragMove) barDragHandler = {
                ...baseDragHandler,
                onDrag: (from, to, start)=>{
                    const timelineWidth = timelineRange.end - timelineRange.start;
                    const deltaRatio = (to.x - start.x) / width;
                    const delta = $48a36036db8ce0fd$var$snapWithRound(deltaRatio * timelineWidth, (0, $17L5s.ONE_DAY));
                    if (isInferredStart === isInferredEnd) this.props.moveTimelineIssue(delta, baselineStart, baselineEnd);
                    else if (isInferredStart === true) // @ts-expect-error - TS7005 - Variable 'rightHandleDragHandler' implicitly has an 'any' type.
                    rightHandleDragHandler.onDrag(from, to, start);
                    else if (isInferredEnd === true) // @ts-expect-error - TS7005 - Variable 'leftHandleDragHandler' implicitly has an 'any' type.
                    leftHandleDragHandler.onDrag(from, to, start);
                }
            };
        }
        const bar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Bar, {
            ...barPositions,
            color: barColor,
            colors: barColors,
            showStripes: showStripesInBar,
            opacity: opacity,
            additionalStyles: barAdditionalStyles,
            showHandles: !isReadOnly && hovered && !isBeingInteractedWith,
            barDragHandler: barDragHandler,
            leftHandleDragHandler: leftHandleDragHandler,
            rightHandleDragHandler: rightHandleDragHandler,
            renderFlyout: renderFlyout,
            id: issue.id,
            topOffset: topOffset
        });
        let previewBar;
        let previewPositions;
        if (preview) {
            previewPositions = (0, $gVkBP.getPositionsForBar)(preview, timelineRange, previewForcedGradients);
            previewBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Bar, {
                ...previewPositions,
                showStripes: showStripesInBar,
                color: barColor,
                colors: barColors,
                opacity: 0.8,
                id: issue.id,
                topOffset: topOffset
            });
        }
        const datePosition = previewPositions || barPositions;
        let startDateField;
        let endDateField;
        let numDays;
        let dates;
        const incomingDependencies = !hasDependencyLineDragPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyMarker, {
            externalIncomingLinks: externalIncomingLinks,
            internalIncomingLinks: internalIncomingLinks,
            originalIssueLinks: internalIncomingLinksOriginal,
            startOrEnd: "start",
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD,
            datePosition: datePosition,
            width: width,
            issue: issue,
            isHovered: hovered,
            barColor: barColor,
            barColors: barColors
        });
        const outgoingDependencies = !hasDependencyLineDragPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyMarker, {
            externalOutgoingLinks: externalOutgoingLinks,
            internalOutgoingLinks: internalOutgoingLinks,
            originalIssueLinks: internalOutgoingLinksOriginal,
            startOrEnd: "end",
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD,
            datePosition: datePosition,
            width: width,
            issue: issue,
            isHovered: hovered,
            barColor: barColor,
            barColors: barColors
        });
        if ((hovered || isBeingInteractedWith) && !hasDependencyLineDragPreview) {
            const completedSprints = issue.completedSprints || [];
            const activeSprint = sprints.find((sprint)=>sprint.id === issue.sprint);
            startDateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                startOrEnd: "start",
                date: startDate,
                isRolledUpValue: isInferredStart
            });
            endDateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                startOrEnd: "end",
                date: endDate,
                isRolledUpValue: isInferredEnd
            });
            numDays = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixveE.default), {
                startDate: startDate,
                endDate: endDate,
                activeSprint: activeSprint,
                completedSprintCount: completedSprints.length,
                showActiveSprintOnTooltip: showActiveSprintOnTooltip
            });
            dates = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kG4Lf.default), {
                datePosition: datePosition,
                width: width
            }, startDateField, numDays, endDateField);
        }
        return(// eslint-disable-next-line @typescript-eslint/no-shadow
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: (hovered)=>this.setState({
                    hovered: hovered
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $fHPCH.spaBothDatesRow
        }, bar, previewBar, incomingDependencies, outgoingDependencies, dates, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39ob0.default), null))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            hovered: false
        };
    }
}

});
parcelRegister("l9dNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $351064c9820aa6e7$export$2e2bcd8739ae039);

var $5A34a = parcelRequire("5A34a");
var $351064c9820aa6e7$export$2e2bcd8739ae039 = (0, $5A34a.default);

});
parcelRegister("5A34a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b05592fe1506179$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $N35KL = parcelRequire("N35KL");

var $2wtN3 = parcelRequire("2wtN3");

var $1ybV0 = parcelRequire("1ybV0");

var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("cEecN");
var $3qL2F = parcelRequire("3qL2F");
parcelRequire("a76j8");
var $dBwUe = parcelRequire("dBwUe");

var $iKqrM = parcelRequire("iKqrM");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("areZp");
var $4j1D2 = parcelRequire("4j1D2");
var $areZp = parcelRequire("areZp");

var $6f81T = parcelRequire("6f81T");

var $5dDxB = parcelRequire("5dDxB");

var $gVkBP = parcelRequire("gVkBP");
function $3b05592fe1506179$export$2e2bcd8739ae039({ additionalStyles: additionalStyles, alwaysShowFlyout: alwaysShowFlyout = false, barDragHandler: barDragHandler, children: children, color: color = (0, $33N5G.DEFAULT_COLOR), colors: colors, id: id, leftAnchorPercentage: leftAnchorPercentage, leftHandleDragHandler: leftHandleDragHandler, leftPositionPercentage: leftPositionPercentage, opacity: opacity = 1, renderFlyout: renderFlyout, rightAnchorPercentage: rightAnchorPercentage, rightHandleDragHandler: rightHandleDragHandler, rightPositionPercentage: rightPositionPercentage, showHandles: showHandles = false, showStripes: showStripes, topOffset: topOffset }) {
    const ref = (0, $eUqFw.useRef)(null);
    const { dragHovered: dragHovered, dragSource: dragSource, removeIssueRect: removeIssueRect, updateIssueRect: updateIssueRect, width: viewportWidth } = (0, $dBwUe.useDepLinesDrag)();
    const { id: dndItemId } = (0, $3qL2F.useDndItem)();
    const isBeingDragHovered = (0, (/*@__PURE__*/$parcel$interopDefault($N35KL)))(dndItemId, dragHovered);
    const isSourceOfDragPreview = (0, (/*@__PURE__*/$parcel$interopDefault($N35KL)))(dndItemId, dragSource?.rowId);
    (0, $eUqFw.useEffect)(()=>{
        // we render a bar AND a previewBar for each row, and
        // we don't want to modify the issueRects when it's a previewBar
        if (opacity === (0, $5rYNM.PREVIEW_OPACITY)) return;
        const widthPercentage = 100 - rightPositionPercentage - leftPositionPercentage;
        const rect = {
            top: topOffset - (0, $5rYNM.SCOPE_ROW_HEIGHT),
            left: leftPositionPercentage / 100 * viewportWidth - (0, $gVkBP.HORIZONTAL_HIT_TARGET_THRESHOLD) + (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET),
            width: widthPercentage / 100 * viewportWidth + 2 * (0, $gVkBP.HORIZONTAL_HIT_TARGET_THRESHOLD),
            height: (0, $5rYNM.SCOPE_ROW_HEIGHT)
        };
        updateIssueRect(dndItemId, rect);
        return ()=>removeIssueRect(dndItemId);
    }, [
        dndItemId,
        leftPositionPercentage,
        opacity,
        removeIssueRect,
        rightPositionPercentage,
        topOffset,
        updateIssueRect,
        viewportWidth
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isDraggedOver = (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2') && (0, $gVkBP.useDropTarget)(ref);
    const normalizedColors = $2wtN3.default([
        {
            colour: color,
            ratio: 1
        }
    ], colors);
    const stripes = showStripes && (showStripes.left || showStripes.right) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $5dDxB.stripes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $gVkBP.getStripesStyle)(showStripes, normalizedColors),
        "data-testid": `issue-bar-stripes-${id}`
    });
    const handleStyle = {
        display: showHandles ? 'block' : 'none'
    };
    const leftHandle = leftAnchorPercentage === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6f81T.default), {
        dragHandler: leftHandleDragHandler || {},
        flag: "LEFT-HANDLE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5dDxB.leftHandle,
        style: handleStyle
    }));
    const rightHandle = rightAnchorPercentage === 100 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6f81T.default), {
        dragHandler: rightHandleDragHandler || {},
        flag: "RIGHT-HANDLE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5dDxB.rightHandle,
        style: handleStyle
    }));
    // Using && ensures we don't render the flyout unnecessarily
    const flyoutContent = alwaysShowFlyout && renderFlyout();
    // Consider remove this function when cleaning up com.atlassian.rm.jpo.transposition.m2
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const withZIndexOverride = (children)=>{
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $areZp.ZIndex), {
            layer: (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS
        }, (zIndex)=>children(zIndex ?? 'initial'));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $5dDxB.flyoutPositioner,
        // We hard-code the width of the flyout because measuring it dynamically is tricky.
        // It would require rendering the flyout, then storing the dimensions of the flyout in state,
        // then re-rendering again with the correct positioning.
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: `calc(${leftPositionPercentage}% + ${((0, $iKqrM.FLYOUT_CONTENT_WIDTH) + 50) / 2}px)`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        content: flyoutContent,
        isOpen: alwaysShowFlyout && flyoutContent !== undefined,
        placement: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5dDxB.flyoutContent
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6f81T.default), {
        dragHandler: barDragHandler || {},
        flag: "BAR"
    }, withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $5dDxB.spaBar,
            "data-name": `issue-bar-${id}`,
            "data-testid": `issue-bar-${id}`,
            ref: ref,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                background: (0, $gVkBP.colorsToGradient)({
                    colors: normalizedColors,
                    leftAnchorPercentage: leftAnchorPercentage,
                    rightAnchorPercentage: rightAnchorPercentage
                }),
                // Remove this with com.atlassian.rm.jpo.transposition.m2
                border: isBeingDragHovered === true || isSourceOfDragPreview === true ? `solid 1.5px ${"var(--ds-background-neutral-bold, #000000)"}` : '',
                boxShadow: isDraggedOver ? `0 0 0 1.5px ${"var(--ds-background-neutral-bold, #000000)"}` : undefined,
                left: `${leftPositionPercentage}%`,
                opacity: opacity,
                right: `${rightPositionPercentage}%`,
                zIndex: zIndex,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...additionalStyles
            }
        }, stripes, leftHandle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $5dDxB.content
        }, children), rightHandle))));
}

});
parcelRegister("6f81T", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d1939f32c5a4ef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $18uE0 = parcelRequire("18uE0");

var $jODJR = parcelRequire("jODJR");
parcelRequire("3Q01T");
var $5XDHx = parcelRequire("5XDHx");
/** Function computes the delta between drag scroll start and current timeline location.

 * @returns {Array} Returns the drag scrolling delta in px and functions to register and deregister a callback function and reset the calculations
 */ const $95d1939f32c5a4ef$var$useScrollingDelta = ()=>{
    const offsetInPxRef = (0, $eUqFw.useRef)(0);
    const startOffsetInPxRef = (0, $eUqFw.useRef)(0);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const callbackRef = (0, $eUqFw.useRef)(()=>{});
    const deltaRef = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = (0, $jODJR.subscribeHorizontalScrolling)(({ viewport: viewport, container: container })=>{
            const offsetInPx = viewport.offset * container.width / container.duration || 0;
            offsetInPxRef.current = offsetInPx;
            deltaRef.current = offsetInPxRef.current - startOffsetInPxRef.current;
            callbackRef.current();
        });
        return unsubscribe;
    }, [
        deltaRef
    ]);
    /** Function used to start and end calculations for deltaRef */ const dragReset = (0, $eUqFw.useCallback)(()=>{
        startOffsetInPxRef.current = offsetInPxRef.current;
        deltaRef.current = 0;
    }, []);
    /** Register callback to be used when delta changes */ const register = (0, $eUqFw.useCallback)((callback)=>{
        callbackRef.current = callback;
    }, []);
    /** Deregister callback */ const deregister = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        callbackRef.current = ()=>{};
    }, []);
    return [
        deltaRef,
        {
            dragReset: dragReset,
            register: register,
            deregister: deregister
        }
    ];
};
function $95d1939f32c5a4ef$export$2e2bcd8739ae039({ dragHandler: dragHandler, flag: flag, children: children }) {
    const [, { register: registerDndScrolling, deregister: deregisterDndScrolling }] = (0, $5XDHx.useDndScrolling)();
    const dragPayloadRef = (0, $eUqFw.useRef)(null);
    const dragHandlerRef = (0, $eUqFw.useRef)(dragHandler);
    (0, $eUqFw.useEffect)(()=>{
        dragHandlerRef.current = dragHandler;
    }, [
        dragHandler
    ]);
    const [deltaRef, { dragReset: dragReset, register: registerDragScrolling, deregister: deregisterDragScrolling }] = $95d1939f32c5a4ef$var$useScrollingDelta();
    const drag = (0, $eUqFw.useCallback)(()=>{
        const { onDrag: onDrag } = dragHandlerRef.current;
        const dragPayload = dragPayloadRef.current;
        if (onDrag == null || dragPayload == null) return;
        onDrag(dragPayload.from, {
            ...dragPayload.to,
            x: dragPayload.to.x + deltaRef.current
        }, dragPayload.start);
    }, [
        deltaRef
    ]);
    const handleDragStart = (0, $eUqFw.useCallback)((start)=>{
        const { onDragStart: onDragStart } = dragHandlerRef.current;
        if (onDragStart == null) return;
        dragReset();
        registerDragScrolling(drag);
        registerDndScrolling(flag);
        onDragStart(start);
    }, [
        dragReset,
        registerDragScrolling,
        drag,
        registerDndScrolling,
        flag
    ]);
    const handleDrag = (0, $eUqFw.useCallback)((from, to, start)=>{
        const { onDrag: onDrag } = dragHandlerRef.current;
        if (onDrag == null) return;
        dragPayloadRef.current = {
            from: from,
            to: to,
            start: start
        };
        drag();
    }, [
        drag
    ]);
    const handleDragEnd = (0, $eUqFw.useCallback)((start, end)=>{
        const { onDragEnd: onDragEnd } = dragHandlerRef.current;
        if (onDragEnd == null) return;
        dragPayloadRef.current = null;
        deregisterDragScrolling();
        deregisterDndScrolling(flag);
        onDragEnd(start, end);
    }, [
        deregisterDndScrolling,
        deregisterDragScrolling,
        flag
    ]);
    const { onClick: handleClick, onMouseDown: handleMouseDown } = dragHandler;
    const newHandler = (0, $eUqFw.useMemo)(()=>({
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onDragStart: handleDragStart,
            onDrag: handleDrag,
            onDragEnd: handleDragEnd
        }), [
        handleClick,
        handleDrag,
        handleDragEnd,
        handleDragStart,
        handleMouseDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18uE0.default), {
        dragHandler: newHandler
    }, children);
}

});

parcelRegister("5dDxB", function(module, exports) {

$parcel$export(module.exports, "content", () => $3cccd6ae9eca0361$export$a7db06668cad9adb, (v) => $3cccd6ae9eca0361$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "flyoutContent", () => $3cccd6ae9eca0361$export$a31680278bdf02a2, (v) => $3cccd6ae9eca0361$export$a31680278bdf02a2 = v);
$parcel$export(module.exports, "flyoutPositioner", () => $3cccd6ae9eca0361$export$c6ee8e29facfa055, (v) => $3cccd6ae9eca0361$export$c6ee8e29facfa055 = v);
$parcel$export(module.exports, "leftHandle", () => $3cccd6ae9eca0361$export$498fa52a5bc0ec18, (v) => $3cccd6ae9eca0361$export$498fa52a5bc0ec18 = v);
$parcel$export(module.exports, "rightHandle", () => $3cccd6ae9eca0361$export$7246006e672c1d3e, (v) => $3cccd6ae9eca0361$export$7246006e672c1d3e = v);
$parcel$export(module.exports, "spaBar", () => $3cccd6ae9eca0361$export$4323fff098116d3, (v) => $3cccd6ae9eca0361$export$4323fff098116d3 = v);
$parcel$export(module.exports, "stripes", () => $3cccd6ae9eca0361$export$4921342e9e13259b, (v) => $3cccd6ae9eca0361$export$4921342e9e13259b = v);
var $3cccd6ae9eca0361$export$a7db06668cad9adb;
var $3cccd6ae9eca0361$export$a31680278bdf02a2;
var $3cccd6ae9eca0361$export$c6ee8e29facfa055;
var $3cccd6ae9eca0361$export$498fa52a5bc0ec18;
var $3cccd6ae9eca0361$export$7246006e672c1d3e;
var $3cccd6ae9eca0361$export$4323fff098116d3;
var $3cccd6ae9eca0361$export$4921342e9e13259b;
$3cccd6ae9eca0361$export$a7db06668cad9adb = `X8NtBq_content`;
$3cccd6ae9eca0361$export$a31680278bdf02a2 = `X8NtBq_flyoutContent`;
$3cccd6ae9eca0361$export$c6ee8e29facfa055 = `X8NtBq_flyoutPositioner`;
$3cccd6ae9eca0361$export$498fa52a5bc0ec18 = `X8NtBq_leftHandle`;
$3cccd6ae9eca0361$export$7246006e672c1d3e = `X8NtBq_rightHandle`;
$3cccd6ae9eca0361$export$4323fff098116d3 = `X8NtBq_spaBar`;
$3cccd6ae9eca0361$export$4921342e9e13259b = `X8NtBq_stripes`;

});



parcelRegister("imoOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6552da0e53aff79e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $l2Sj2 = parcelRequire("l2Sj2");
var $eTbtL = parcelRequire("eTbtL");

var $7CnHa = parcelRequire("7CnHa");

var $esZBo = parcelRequire("esZBo");

var $bzaDK = parcelRequire("bzaDK");
// eslint-disable-next-line jira/react/no-class-components
class $6552da0e53aff79e$var$DateFieldView extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {};
    }
    render() {
        const { startOrEnd: startOrEnd, date: date, isRolledUpValue: isRolledUpValue, intl: intl } = this.props;
        let formattedDate;
        if (!(0, $7CnHa.isDefined)(date)) {
            if (startOrEnd === 'start') formattedDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $esZBo.default).noStartDate);
            else formattedDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $esZBo.default).noEndDate);
        } else formattedDate = (0, $l2Sj2.formatTimestampWithIntl)(intl, date, (0, $eTbtL.weekdayFormat));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $bzaDK.dateField,
            "data-testId": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.date-field"
        }, isRolledUpValue === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $esZBo.default).rolledUpLabel), formattedDate);
    }
}
var $6552da0e53aff79e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($6552da0e53aff79e$var$DateFieldView);

});
parcelRegister("esZBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $afbc0ec833ee6322$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $afbc0ec833ee6322$var$messages = (0, $90IgZ.defineMessages)({
    noStartDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.no-start-date",
        "defaultMessage": "No start date"
    },
    noEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.no-end-date",
        "defaultMessage": "No end date"
    },
    rolledUpLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.date-field.rolled-up-label",
        "defaultMessage": "Rolled up: "
    }
});
var $afbc0ec833ee6322$export$2e2bcd8739ae039 = $afbc0ec833ee6322$var$messages;

});

parcelRegister("bzaDK", function(module, exports) {

$parcel$export(module.exports, "dateField", () => $86bb37816a5451a8$export$9bbb5c84017f041b, (v) => $86bb37816a5451a8$export$9bbb5c84017f041b = v);
var $86bb37816a5451a8$export$9bbb5c84017f041b;
$86bb37816a5451a8$export$9bbb5c84017f041b = `Kx8ltq_dateField`;

});


parcelRegister("kG4Lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a7268edcd6305b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $2KzVh = parcelRequire("2KzVh");

var $jODJR = parcelRequire("jODJR");

var $6QqTq = parcelRequire("6QqTq");

var $i209G = parcelRequire("i209G");
function $27a7268edcd6305b$var$DateTooltip({ children: children, datePosition: datePosition, width: width }) {
    const [containerWidth, setContainerWidth] = (0, $eUqFw.useState)(0);
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ pxToMs: pxToMs }] = (0, $jODJR.useTimelineRuler)();
    const visible = (0, $i209G.useTooltipVisibility)();
    const elementRef = (0, $eUqFw.useRef)(null);
    const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = datePosition;
    const [{ getPercentageOffset: getPercentageOffset }] = (0, $jODJR.useHorizontalPercentageOffset)();
    const viewportLeftPercentageOffset = getPercentageOffset(viewport.offset);
    const viewportRightPercentageOffset = getPercentageOffset(viewport.offset + pxToMs(viewport.width));
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const isScrollableTimeline = zoomLevel !== undefined;
    const style = (0, $i209G.getTooltipStyle)(leftPositionPercentage, rightPositionPercentage, width, containerWidth, viewportLeftPercentageOffset, viewportRightPercentageOffset, isScrollableTimeline);
    (0, $eUqFw.useEffect)(()=>{
        const el = elementRef.current;
        if (!el) return;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const children = el.children;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        let width = 0;
        Array.from(children).forEach((child)=>{
            if (child instanceof HTMLElement) width += child.offsetWidth;
        });
        setContainerWidth(width);
    }, []);
    if (!visible) return null;
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom",
        isOpen: true,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6QqTq.dateTooltipContent
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: style.left,
                ...triggerProps,
                ref: (0, $2KzVh.default)(triggerProps.ref, elementRef),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $6QqTq.dateTooltipTrigger,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style
            }, children)
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: elementRef,
        className: $6QqTq.dateTooltip,
        style: style
    }, children));
}
var $27a7268edcd6305b$export$2e2bcd8739ae039 = $27a7268edcd6305b$var$DateTooltip;

});
parcelRegister("6QqTq", function(module, exports) {

$parcel$export(module.exports, "dateTooltip", () => $4fbc75cab6396741$export$a944350923249b5b, (v) => $4fbc75cab6396741$export$a944350923249b5b = v);
$parcel$export(module.exports, "dateTooltipContent", () => $4fbc75cab6396741$export$1d63f0c789a74b03, (v) => $4fbc75cab6396741$export$1d63f0c789a74b03 = v);
$parcel$export(module.exports, "dateTooltipTrigger", () => $4fbc75cab6396741$export$6e652c6edd54ebb7, (v) => $4fbc75cab6396741$export$6e652c6edd54ebb7 = v);
var $4fbc75cab6396741$export$a944350923249b5b;
var $4fbc75cab6396741$export$1d63f0c789a74b03;
var $4fbc75cab6396741$export$6e652c6edd54ebb7;
$4fbc75cab6396741$export$a944350923249b5b = `NRG5Ra_dateTooltip`;
$4fbc75cab6396741$export$1d63f0c789a74b03 = `NRG5Ra_dateTooltipContent`;
$4fbc75cab6396741$export$6e652c6edd54ebb7 = `NRG5Ra_dateTooltipTrigger`;

});

parcelRegister("i209G", function(module, exports) {

$parcel$export(module.exports, "getTooltipStyle", () => $939d9439d3ee65b7$export$931b35c41e37e48f);
$parcel$export(module.exports, "useTooltipVisibility", () => $939d9439d3ee65b7$export$d047e971555191a);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jODJR = parcelRequire("jODJR");
const $939d9439d3ee65b7$export$931b35c41e37e48f = (leftPercentage, rightPercentage, width, tooltipWidth, minimumPercentageOffset, maximumPercentageOffset, isScrollableTimeline)=>{
    const leftPositionPercentage = !isScrollableTimeline ? Math.max(leftPercentage, 0) : Math.max(leftPercentage, minimumPercentageOffset);
    const rightPositionPercentage = !isScrollableTimeline ? Math.max(rightPercentage, 0) : Math.max(rightPercentage, 100 - maximumPercentageOffset);
    const barWidthPercentage = 100 - (leftPositionPercentage + rightPositionPercentage);
    // The percentage of the tooltip that is inside a container
    const containerWidthPercentage = Math.max(tooltipWidth / width * 100, barWidthPercentage);
    // Calculate the center position of the bar
    const middlePositionPercentage = leftPositionPercentage + barWidthPercentage / 2;
    // Calculate where to position the tooltip
    const containerLeftPositionPercentage = !isScrollableTimeline ? Math.max(0, middlePositionPercentage - containerWidthPercentage / 2) : Math.max(minimumPercentageOffset, middlePositionPercentage - containerWidthPercentage / 2);
    let left;
    let right;
    if (!isScrollableTimeline && containerLeftPositionPercentage + containerWidthPercentage > 100) right = 0;
    else if (isScrollableTimeline && containerLeftPositionPercentage + containerWidthPercentage > maximumPercentageOffset) // If the bar is outside the viewport to the right we render it on the right side of the screen
    left = `calc(${maximumPercentageOffset - containerWidthPercentage}%)`;
    else left = `calc(${containerLeftPositionPercentage}%)`;
    return {
        left: left,
        right: right,
        minWidth: `calc(${containerWidthPercentage}%)`
    };
};
const $939d9439d3ee65b7$export$d047e971555191a = ()=>{
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [visible, setVisible] = (0, $eUqFw.useState)(true);
    const lastOffsetRef = (0, $eUqFw.useRef)(viewport.offset);
    const show = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
        setVisible(true);
    }, 100)).current;
    (0, $eUqFw.useEffect)(()=>{
        if (viewport.offset !== lastOffsetRef.current) {
            setVisible(false);
            show();
            lastOffsetRef.current = viewport.offset;
        }
    }, [
        viewport.offset,
        show
    ]);
    return visible;
};

});


parcelRegister("euTYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2921b26d2b3f96a0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fvxCL = parcelRequire("fvxCL");

var $119Hk = parcelRequire("119Hk");
var $2921b26d2b3f96a0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fvxCL.default), {})((0, $119Hk.default));

});
parcelRegister("fvxCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a887eee12fc9a75e$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $7zlu6 = parcelRequire("7zlu6");

var $fbHoQ = parcelRequire("fbHoQ");

var $dEoWh = parcelRequire("dEoWh");

var $kFf60 = parcelRequire("kFf60");

var $75KhQ = parcelRequire("75KhQ");

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$a887eee12fc9a75e$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    externalIssues: (0, $7zlu6.getExternalIssues),
    issueStatusById: (0, $kFf60.getIssueStatusById),
    isEditMode: $akhOi.isEditMode,
    isExportMode: $akhOi.isExportMode,
    isOptimizedMode: $akhOi.isOptimizedMode,
    issuesWithOptimizedById: (0, $40hi6.getAllIssuesWithOriginalAndOptimizedById),
    filterValue: (state)=>(0, $fbHoQ.getFilters)(state)[0, $12ee831723ccf9c2$export$a849f806e27a57e8].value,
    syncStartEnabled: (0, $75KhQ.getSyncStartEnabled),
    issueLinkTypes: (0, $dEoWh.getDependencyIssueLinkTypes),
    issueCountByLinkType: (0, $dEoWh.getIssueCountByLinkType)
});

});

parcelRegister("119Hk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd9bf3cd874e229$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $3fJGp = parcelRequire("3fJGp");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");

var $1eaRW = parcelRequire("1eaRW");

var $5rYNM = parcelRequire("5rYNM");

var $8ANC9 = parcelRequire("8ANC9");

var $2RLdT = parcelRequire("2RLdT");

var $kPfX1 = parcelRequire("kPfX1");

var $8bq9d = parcelRequire("8bq9d");
const $dfd9bf3cd874e229$var$BADGE_WIDTH = 16;
const $dfd9bf3cd874e229$var$MINIMUM_BAR_FREE_SPACE = 2; // Dedicate 2px for space between badge and end of bar
const $dfd9bf3cd874e229$var$BADGE_MAX = 99;
const $dfd9bf3cd874e229$var$getBadgeColouring = (barColor, barColors, badgeAppearance)=>{
    // default icon bg is grey
    let badgeColor = barColor || `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N100})`;
    // only apply bar color if we have a single bar color value... we're not handling rainbows for labels & components
    if (barColors && barColors.length === 1) badgeColor = barColors[0].colour;
    else if (barColors && barColors.length > 1) badgeColor = 'transparent';
    let textColor = `var(--ds-text-inverse, ${(0, $g4Vkx.default).N0})`;
    // always red bg if off track
    if (badgeAppearance === 'offtrack') {
        badgeColor = `var(--ds-background-danger, ${(0, $g4Vkx.default).R50})`;
        textColor = `var(--ds-text-danger, ${(0, $g4Vkx.default).R500})`;
    }
    return {
        badgeColor: badgeColor,
        textColor: textColor
    };
};
const $dfd9bf3cd874e229$export$fa91929c07a03360 = (externalIssues, issue, issuesWithOptimizedById, issueStatusById, isOptimizedMode, startOrEnd, syncStartEnabled, internalIssueLinks, externalIssueLinks)=>{
    let badgeAppearance = 'none';
    if (internalIssueLinks.length + externalIssueLinks.length) badgeAppearance = (0, $8ANC9.isDependencyOverlapping)(startOrEnd, issue, internalIssueLinks, issuesWithOptimizedById, issueStatusById, isOptimizedMode, syncStartEnabled) || (0, $8ANC9.isExternalDependencyOverlapping)(startOrEnd, issue, issueStatusById, externalIssueLinks, externalIssues, issuesWithOptimizedById, isOptimizedMode, syncStartEnabled) ? 'offtrack' : 'default';
    return badgeAppearance;
};
const $dfd9bf3cd874e229$var$getLinkCount = (startOrEnd, internalIncomingLinks, externalIncomingLinks, internalOutgoingLinks, externalOutgoingLinks)=>{
    let linkCount = 0;
    if (startOrEnd === 'start') {
        linkCount += internalIncomingLinks ? internalIncomingLinks.length : 0;
        linkCount += externalIncomingLinks ? externalIncomingLinks.length : 0;
    } else {
        linkCount += internalOutgoingLinks ? internalOutgoingLinks.length : 0;
        linkCount += externalOutgoingLinks ? externalOutgoingLinks.length : 0;
    }
    return linkCount;
};
const $dfd9bf3cd874e229$var$getBarWideEnough = (hasHiddenIncomingDependency, hasHiddenOutgoingDependency, barWidth)=>{
    // Ensuring that the bar has minimum width to fit the necessary badges
    let barWideEnoughForVisibleBadge = true;
    if (hasHiddenIncomingDependency && hasHiddenOutgoingDependency && barWidth < ($dfd9bf3cd874e229$var$BADGE_WIDTH + $dfd9bf3cd874e229$var$MINIMUM_BAR_FREE_SPACE) * 2) barWideEnoughForVisibleBadge = false;
    else if ((hasHiddenIncomingDependency || hasHiddenOutgoingDependency) && barWidth < $dfd9bf3cd874e229$var$BADGE_WIDTH + $dfd9bf3cd874e229$var$MINIMUM_BAR_FREE_SPACE) barWideEnoughForVisibleBadge = false;
    return barWideEnoughForVisibleBadge;
};
function $dfd9bf3cd874e229$export$2e2bcd8739ae039({ startOrEnd: startOrEnd, datePosition: datePosition, width: width, issue: issue, externalIssues: externalIssues, externalOutgoingLinks: externalOutgoingLinks, externalIncomingLinks: externalIncomingLinks, internalOutgoingLinks: internalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, direction: direction, issuesWithOptimizedById: issuesWithOptimizedById, issueStatusById: issueStatusById, isHovered: isHovered, isEditMode: isEditMode, isExportMode: isExportMode, isOptimizedMode: isOptimizedMode, syncStartEnabled: syncStartEnabled, issueCountByLinkType: issueCountByLinkType, issueLinkTypes: issueLinkTypes, barColors: barColors, barColor: barColor }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [dependencyLines] = (0, $1eaRW.useDependencyLines)();
    const [{ display: display }] = (0, $1eaRW.useDependencySettings)();
    const externalIssueLinks = externalOutgoingLinks || externalIncomingLinks || [];
    const internalIssueLinks = internalOutgoingLinks || internalIncomingLinks || [];
    const addIconShowing = internalIssueLinks.length + externalIssueLinks.length === 0;
    const canAddDependency = isEditMode;
    const defaultIssueLinkType = (0, $8bq9d.getDefaultIssueLinkTypeId)(issueLinkTypes);
    // If we don't have any dependency links, the add badge will show
    // If we are in READONLY mode, it should not show (so we can't add dependencies)
    // Therefore return null
    if (addIconShowing && !canAddDependency) return null;
    const badgeAppearance = $dfd9bf3cd874e229$export$fa91929c07a03360(externalIssues, issue, issuesWithOptimizedById, issueStatusById, isOptimizedMode, startOrEnd, syncStartEnabled, internalIssueLinks, externalIssueLinks);
    const linkCount = $dfd9bf3cd874e229$var$getLinkCount(startOrEnd, internalIncomingLinks, externalIncomingLinks, internalOutgoingLinks, externalOutgoingLinks);
    const isLinked = linkCount > 0;
    // the number of drawable outgoing lines is less than the number of outgoing links
    const hasHiddenOutgoingDependency = dependencyLines !== null && dependencyLines.filter(({ fromIssue: fromIssue, drawable: drawable })=>fromIssue.id === issue.id && drawable).length < linkCount;
    // the number of drawable incoming lines is less than the number of incoming links
    const hasHiddenIncomingDependency = dependencyLines !== null && dependencyLines.filter(({ toIssue: toIssue, drawable: drawable })=>toIssue.id === issue.id && drawable).length < linkCount;
    const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = datePosition;
    const rightPositionPercentageFromLeftPerspective = rightPositionPercentage * -1 + 100;
    const barWidth = Math.abs(rightPositionPercentageFromLeftPerspective - leftPositionPercentage) * width / 100;
    const barWideEnoughForVisibleBadge = $dfd9bf3cd874e229$var$getBarWideEnough(hasHiddenIncomingDependency, hasHiddenOutgoingDependency, barWidth);
    const hasHiddenDependency = startOrEnd === 'start' && hasHiddenIncomingDependency || startOrEnd === 'end' && hasHiddenOutgoingDependency;
    /** The visibility status of the marker when it's inactive (not hovered), it's visible when
   * - It has any external link (link to the issue which is not on the plan) or
   * - It has any hidden dependency (i.e. in LINES mode, line is not drawable) or
   * - The dependency setting is not LINES.
   */ const visibleWhenInactive = isLinked && barWideEnoughForVisibleBadge && (externalIssueLinks.length > 0 || hasHiddenDependency || display !== (0, $5rYNM.LINES));
    const { badgeColor: badgeColor, textColor: textColor } = $dfd9bf3cd874e229$var$getBadgeColouring(barColor, barColors, badgeAppearance);
    const badgeContent = (()=>{
        if (!isLinked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: "",
            size: "small"
        });
        if (display === (0, $5rYNM.COUNT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $kPfX1["badge-count"],
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.badge-count"
        }, linkCount > $dfd9bf3cd874e229$var$BADGE_MAX ? `${$dfd9bf3cd874e229$var$BADGE_MAX}+` : linkCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
            label: (0, $8bq9d.getDependencyLabel)(startOrEnd, formatMessage),
            size: "small"
        });
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RLdT.default), {
        containerWidth: width,
        direction: direction,
        issue: issue,
        issueBarPosition: datePosition,
        appearance: badgeAppearance,
        position: startOrEnd,
        visibleWhenInactive: visibleWhenInactive,
        active: isHovered,
        badgeColor: badgeColor,
        textColor: textColor,
        issueCountByLinkType: issueCountByLinkType,
        iconType: !isLinked ? 'add-icon' : 'link-icon',
        issueLinkType: defaultIssueLinkType,
        isEditMode: isEditMode,
        isExportMode: isExportMode
    }, badgeContent);
}

});
parcelRegister("8ANC9", function(module, exports) {

$parcel$export(module.exports, "isDependencyOverlapping", () => $7846a1a5c76ef603$export$7a673214530cb93d);
$parcel$export(module.exports, "isExternalDependencyOverlapping", () => $7846a1a5c76ef603$export$f005db951de8e262);

var $lseqm = parcelRequire("lseqm");

var $g8SOd = parcelRequire("g8SOd");
const $7846a1a5c76ef603$export$7a673214530cb93d = (position, issue, internalIssueLinks, issuesWithOptimizedById, issueStatusById, isOptimizedMode, syncStartEnabled)=>{
    if (position === 'start') return internalIssueLinks.some(({ sourceItemKey: sourceItemKey })=>{
        const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[sourceItemKey], isOptimizedMode);
        const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
        return (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
    });
    return internalIssueLinks.some(({ targetItemKey: targetItemKey })=>{
        const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
        const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[targetItemKey], isOptimizedMode);
        return (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
    });
};
const $7846a1a5c76ef603$export$f005db951de8e262 = (position, issue, issueStatusById, externalIssueLinks, externalIssues, issuesWithOptimizedById, isOptimizedMode, syncStartEnabled)=>{
    if (position === 'start') return externalIssueLinks.some(({ sourceItemKey: sourceItemKey })=>{
        const targetIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
        const sourceIssue = externalIssues[sourceItemKey];
        return (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
    });
    return externalIssueLinks.some(({ targetItemKey: targetItemKey })=>{
        const sourceIssue = (0, $g8SOd.mergeOptimizedValueToIssue)(issuesWithOptimizedById[issue.id], isOptimizedMode);
        const targetIssue = externalIssues[targetItemKey];
        return (0, $lseqm.getIssueLinkIfOverlapping)(sourceIssue, targetIssue, issueStatusById, syncStartEnabled);
    });
};

});

parcelRegister("2RLdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $090df6862d253d4a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $1ybV0 = parcelRequire("1ybV0");

var $g4Vkx = parcelRequire("g4Vkx");

var $5MFfw = parcelRequire("5MFfw");
parcelRequire("a76j8");
var $dBwUe = parcelRequire("dBwUe");
parcelRequire("areZp");
var $4j1D2 = parcelRequire("4j1D2");
var $areZp = parcelRequire("areZp");
parcelRequire("2Fg1S");
var $kIxte = parcelRequire("kIxte");

var $2dhRr = parcelRequire("2dhRr");

var $jnflc = parcelRequire("jnflc");
function $090df6862d253d4a$export$2e2bcd8739ae039({ containerWidth: containerWidth, active: active, visibleWhenInactive: visibleWhenInactive, issue: issue, issueBarPosition: issueBarPosition, direction: direction, appearance: appearance, position: position, badgeColor: badgeColor, textColor: textColor, children: children, iconType: iconType, issueLinkType: issueLinkType, issueCountByLinkType: issueCountByLinkType, isEditMode: isEditMode, isExportMode: isExportMode }) {
    const hitboxRef = (0, $eUqFw.useRef)(null);
    const domRef = (0, $eUqFw.useRef)(null);
    const { open: openFlyout } = (0, $5MFfw.useDependenciesFlyout)();
    // Remove dragging logic when cleaning up com.atlassian.rm.jpo.transposition.m2
    const { dragSource: dragSource } = (0, $dBwUe.useDepLinesDrag)();
    const handleDrop = (0, $jnflc.useDropHandling)({
        issueCountByLinkType: issueCountByLinkType,
        issueLinkType: issueLinkType
    });
    const { handleMouseDown: handleMouseDown } = (0, $jnflc.useDragHandling)({
        direction: direction,
        onDrop: handleDrop,
        isEditMode: isEditMode
    });
    const isActive = (0, $jnflc.useIsActive)({
        issue: issue,
        direction: direction,
        force: active
    });
    const handleClick = ()=>{
        const triggerEl = domRef.current;
        if (triggerEl == null) return;
        openFlyout({
            direction: direction,
            issue: issue
        }, triggerEl);
    };
    // On hover, our badge background color for multicolour bars needs to be distinguishable from our text
    const backgroundColor = badgeColor === 'transparent' && active ? `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N100})` : badgeColor;
    const pointerEvents = isActive ? 'inherit' : 'none';
    const opacity = isActive || visibleWhenInactive ? 1 : 0;
    const cursor = 'pointer';
    // Consider remove this function when cleaning up com.atlassian.rm.jpo.transposition.m2
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const withZIndexOverride = (children)=>{
        if (!(0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return children(undefined);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $areZp.ZIndex), {
            layer: (0, $4j1D2.Z_INDEX_LAYER).ISSUE_BARS
        }, (zIndex)=>children(zIndex ?? 'initial'));
    };
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const dragPreview = (0, $jnflc.useDragPreview)(hitboxRef.current, containerWidth, position, issueBarPosition, issueLinkType);
        if (dragPreview) return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kIxte.default), {
        containerWidth: containerWidth ?? 0,
        startOrEnd: position,
        issueBarPosition: issueBarPosition,
        active: isActive
    }, ({ translateX: translateX, left: left })=>withZIndexOverride((zIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: hitboxRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
                    [$2dhRr['hitbox-left']]: position === 'start',
                    [$2dhRr['hitbox-right']]: position === 'end'
                }),
                style: {
                    opacity: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    opacity,
                    transform: translateX !== null ? `translateX(${translateX}px)` : undefined,
                    transition: translateX !== null ? '0.2s' : undefined,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    transitionProperty: 'opacity, transform',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    position: 'absolute',
                    left: left,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    marginTop: "var(--ds-space-025, 2px)",
                    zIndex: zIndex ?? (isExportMode ? 4 /* Need to increase the z-index of the dependency badge so it's visible in the PNG export. */  : 3)
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: domRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($2dhRr.marker, $2dhRr[`marker-${appearance}`], {
                    [$2dhRr['marker-dragging']]: !!dragSource
                }),
                style: {
                    pointerEvents: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    pointerEvents,
                    backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    backgroundColor,
                    cursor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    cursor,
                    color: textColor
                },
                onMouseDown: handleMouseDown,
                onClick: handleClick,
                role: "button",
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onKeyDown: ()=>{},
                tabIndex: 0,
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.marker-badge.${issue.id}-${position}-${iconType}`
            }, children))));
}

});
parcelRegister("2Fg1S", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("kIxte")).default);

var $kIxte = parcelRequire("kIxte");

});
parcelRegister("kIxte", function(module, exports) {

$parcel$export(module.exports, "default", () => $2816792c65153349$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3jIsm = parcelRequire("3jIsm");
function $2816792c65153349$export$2e2bcd8739ae039({ containerWidth: containerWidth, startOrEnd: startOrEnd, issueBarPosition: issueBarPosition, active: active, children: children }) {
    const offsets = (0, $3jIsm.useOffsets)({
        containerWidth: containerWidth ?? 0,
        width: 16 /** TODO: FIX THIS */ ,
        startOrEnd: startOrEnd,
        issueBar: issueBarPosition
    });
    if (offsets == null) return null;
    const { offsetActive: offsetActive, offsetInactive: offsetInactive } = offsets;
    const translateX = active ? offsetActive - offsetInactive : 0;
    const left = offsetInactive;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        left: left,
        translateX: translateX
    }));
}

});
parcelRegister("3jIsm", function(module, exports) {

$parcel$export(module.exports, "useOffsets", () => $6690241c25cfe640$export$139bcd1caa46c880);

var $jODJR = parcelRequire("jODJR");
var $bj4JM = parcelRequire("bj4JM");
/** The vertical scrollbar width. */ const $6690241c25cfe640$var$SCROLLBAR_WIDTH = 18;
/** The space between the badge and the edge of the issue bar. */ const $6690241c25cfe640$var$SPACING = 4;
/** The width of the arrow icons. */ const $6690241c25cfe640$var$ARROW_WIDTH = 24;
/** Returns the viewport width for horizontal/non-horizontal mode. */ const $6690241c25cfe640$var$useViewportWidth = (0, $jODJR.createHorizontalScrollingHook)((0, $bj4JM.createSelector)((_, fallback)=>fallback, (state)=>state.zoomLevel, (state)=>state.viewport.width, (fallback, zoomLevel, viewportWidth)=>zoomLevel === undefined ? fallback : viewportWidth));
/** Returns the viewport offset for horizontal/non-horizontal mode. */ const $6690241c25cfe640$var$useViewportOffset = (0, $jODJR.createHorizontalScrollingHook)((0, $bj4JM.createSelector)((state)=>state.zoomLevel, (state)=>state.viewport.offset, (zoomLevel, viewportOffset)=>zoomLevel === undefined ? 0 : viewportOffset));
function $6690241c25cfe640$var$flip(position) {
    return {
        left: position.right,
        right: position.left
    };
}
/** Returns the position of the issue bar to the viewport. */ function $6690241c25cfe640$var$useIssueBarPosition({ viewportWidth: viewportWidth, issueBarPercentagePosition: { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } }) {
    const [{ zoomLevel: zoomLevel, viewport: viewport, container: container }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    if (zoomLevel === undefined) {
        const left = leftPositionPercentage / 100 * viewportWidth;
        const right = rightPositionPercentage / 100 * viewportWidth;
        return {
            left: left,
            right: right
        };
    }
    const viewportOffsetInPx = msToPx(viewport.offset);
    const distanceToContainerStart = leftPositionPercentage / 100 * container.width;
    const distanceToContainerEnd = rightPositionPercentage / 100 * container.width;
    const width = container.width - (distanceToContainerEnd + distanceToContainerStart);
    const left = distanceToContainerStart - viewportOffsetInPx;
    const right = viewportWidth - (left + width);
    return {
        left: left,
        right: right
    };
}
/**
 * Returns the position of the left badge when it's ative (hovered)
 *
 * It's easier to calculate the possible value of the position when it's ative base on the space it needs
 * and the available space (calculated by the issue bar position and the paddings)
 *
 * The original position (when it's not hoverred) can be detected by whether the ative badge
 * is inside the bar or not.
 */ function $6690241c25cfe640$var$getLeftBadgeActivePosition({ viewportWidth: viewportWidth, badgeWidth: badgeWidth, issueBar: issueBar, constraints: constraints }) {
    if (issueBar.left === undefined || issueBar.right === undefined) throw new Error('illegal state of issue bar position');
    const hasRightArrow = issueBar.right < 0;
    const maxBarMarginLeft = viewportWidth - ((hasRightArrow ? $6690241c25cfe640$var$ARROW_WIDTH : 0) + constraints.right);
    // - The issue bar is OFF the screen - to the right.
    if (issueBar.left >= viewportWidth) return null;
    // - The issue bar is VISIBLE on the viewport.
    // - There is ENOUGH space to display the active badge to the left of the bar.
    if (issueBar.left >= badgeWidth + $6690241c25cfe640$var$SPACING + constraints.left) return {
        left: Math.min(issueBar.left, maxBarMarginLeft) + // The badge width
        -badgeWidth + // The space with the issue bar
        -$6690241c25cfe640$var$SPACING,
        right: NaN
    };
    const issueBarInnerSpace = viewportWidth + -(Math.max(issueBar.left, constraints.left) + Math.max(issueBar.right, constraints.right));
    // - The issue bar is VISIBLE on the viewport.
    // - There is NOT ENOUGH space to display the active badge to the left of the bar.
    // - The visibile part of the bar is width enough.
    if (issueBar.left >= constraints.left && issueBarInnerSpace >= badgeWidth + $6690241c25cfe640$var$SPACING) return {
        left: issueBar.left + $6690241c25cfe640$var$SPACING,
        right: NaN
    };
    // - The issue bar is VISIBLE on the viewport.
    // - There is NOT ENOUGH space to display the badge to the left of the bar.
    // - The visibile part of the bar is width enough.
    // - The left arrow appears because the left end of the bar is OFF the screen.
    if (issueBarInnerSpace >= $6690241c25cfe640$var$ARROW_WIDTH + badgeWidth + $6690241c25cfe640$var$SPACING) return {
        left: $6690241c25cfe640$var$ARROW_WIDTH + $6690241c25cfe640$var$SPACING + constraints.left,
        right: NaN
    };
    return null;
}
const $6690241c25cfe640$var$getRightBadgeActivePosition = (params)=>{
    const result = $6690241c25cfe640$var$getLeftBadgeActivePosition({
        ...params,
        issueBar: $6690241c25cfe640$var$flip(params.issueBar),
        constraints: $6690241c25cfe640$var$flip(params.constraints)
    });
    if (result === null) return null;
    return $6690241c25cfe640$var$flip(result);
};
const $6690241c25cfe640$var$getLeftBadgeInactivePosition = ({ issueBar: issueBar, badgeActive: badgeActive })=>{
    // The badge is inside the bar.
    if (badgeActive.left > issueBar.left) return badgeActive;
    return {
        left: issueBar.left + $6690241c25cfe640$var$SPACING,
        right: NaN
    };
};
const $6690241c25cfe640$var$getRightBadgeInactivePosition = (params)=>$6690241c25cfe640$var$flip($6690241c25cfe640$var$getLeftBadgeInactivePosition({
        ...params,
        issueBar: $6690241c25cfe640$var$flip(params.issueBar),
        badgeActive: $6690241c25cfe640$var$flip(params.badgeActive)
    }));
/**
 * Returns the "left" offset from the position whether it's the left or right badge.
 */ function $6690241c25cfe640$var$getOffset(viewportWidth, badgeWidth, { left: left, right: right }) {
    // When it's the badge on the right, the `right` value was set from the flip()
    if (Number.isNaN(left) && !Number.isNaN(right)) return viewportWidth - (badgeWidth + right);
    return left;
}
const $6690241c25cfe640$export$139bcd1caa46c880 = ({ containerWidth: containerWidth, width: badgeWidth, startOrEnd: startOrEnd, issueBar: issueBarPercentagePosition })=>{
    const [viewportWidth] = $6690241c25cfe640$var$useViewportWidth(containerWidth);
    const [viewportOffset] = $6690241c25cfe640$var$useViewportOffset();
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    const issueBarPosition = $6690241c25cfe640$var$useIssueBarPosition({
        viewportWidth: viewportWidth,
        issueBarPercentagePosition: issueBarPercentagePosition
    });
    const getBadgePosition = startOrEnd === 'start' ? $6690241c25cfe640$var$getLeftBadgeActivePosition : $6690241c25cfe640$var$getRightBadgeActivePosition;
    const badgeActivePosition = getBadgePosition({
        viewportWidth: viewportWidth,
        badgeWidth: badgeWidth,
        issueBar: issueBarPosition,
        constraints: {
            left: 0,
            right: $6690241c25cfe640$var$SCROLLBAR_WIDTH
        }
    });
    if (badgeActivePosition === null) return null;
    const getBadgeInactivePosition = startOrEnd === 'start' ? $6690241c25cfe640$var$getLeftBadgeInactivePosition : $6690241c25cfe640$var$getRightBadgeInactivePosition;
    const badgeInactivePosition = getBadgeInactivePosition({
        issueBar: issueBarPosition,
        badgeActive: badgeActivePosition
    });
    const offsetInactive = msToPx(viewportOffset) + $6690241c25cfe640$var$getOffset(viewportWidth, badgeWidth, badgeInactivePosition);
    const offsetActive = msToPx(viewportOffset) + $6690241c25cfe640$var$getOffset(viewportWidth, badgeWidth, badgeActivePosition);
    return {
        offsetInactive: offsetInactive,
        offsetActive: offsetActive
    };
};

});



parcelRegister("2dhRr", function(module, exports) {

$parcel$export(module.exports, "hitbox-left", () => $19caa67e4cb10a1d$export$ca87f3b373972501, (v) => $19caa67e4cb10a1d$export$ca87f3b373972501 = v);
$parcel$export(module.exports, "hitbox-right", () => $19caa67e4cb10a1d$export$6223214bdaa46a4, (v) => $19caa67e4cb10a1d$export$6223214bdaa46a4 = v);
$parcel$export(module.exports, "marker", () => $19caa67e4cb10a1d$export$ffc4d0086f1a4c9, (v) => $19caa67e4cb10a1d$export$ffc4d0086f1a4c9 = v);
$parcel$export(module.exports, "marker-default", () => $19caa67e4cb10a1d$export$330307b44ea6a975, (v) => $19caa67e4cb10a1d$export$330307b44ea6a975 = v);
$parcel$export(module.exports, "marker-dragging", () => $19caa67e4cb10a1d$export$bc7092cbbc04e7ce, (v) => $19caa67e4cb10a1d$export$bc7092cbbc04e7ce = v);
$parcel$export(module.exports, "marker-none", () => $19caa67e4cb10a1d$export$fedc624f91f41bcd, (v) => $19caa67e4cb10a1d$export$fedc624f91f41bcd = v);
$parcel$export(module.exports, "marker-offtrack", () => $19caa67e4cb10a1d$export$ffecd4407c0aa5d4, (v) => $19caa67e4cb10a1d$export$ffecd4407c0aa5d4 = v);
var $19caa67e4cb10a1d$export$ca87f3b373972501;
var $19caa67e4cb10a1d$export$6223214bdaa46a4;
var $19caa67e4cb10a1d$export$ffc4d0086f1a4c9;
var $19caa67e4cb10a1d$export$330307b44ea6a975;
var $19caa67e4cb10a1d$export$bc7092cbbc04e7ce;
var $19caa67e4cb10a1d$export$fedc624f91f41bcd;
var $19caa67e4cb10a1d$export$ffecd4407c0aa5d4;
$19caa67e4cb10a1d$export$ca87f3b373972501 = `LcPLja_hitbox-left`;
$19caa67e4cb10a1d$export$6223214bdaa46a4 = `LcPLja_hitbox-right`;
$19caa67e4cb10a1d$export$ffc4d0086f1a4c9 = `LcPLja_marker`;
$19caa67e4cb10a1d$export$330307b44ea6a975 = `LcPLja_marker-default`;
$19caa67e4cb10a1d$export$bc7092cbbc04e7ce = `LcPLja_marker-dragging`;
$19caa67e4cb10a1d$export$fedc624f91f41bcd = `LcPLja_marker-none`;
$19caa67e4cb10a1d$export$ffecd4407c0aa5d4 = `LcPLja_marker-offtrack`;

});

parcelRegister("jnflc", function(module, exports) {

$parcel$export(module.exports, "useDragHandling", () => $e3bbecb37b7be657$export$4ce792279e065294);
$parcel$export(module.exports, "useDropHandling", () => $e3bbecb37b7be657$export$5048b513d451ea75);
$parcel$export(module.exports, "useDragPreview", () => $e3bbecb37b7be657$export$d29bab26291a5c45);
$parcel$export(module.exports, "useIsActive", () => $e3bbecb37b7be657$export$3a05005085a96193);

var $eUqFw = parcelRequire("eUqFw");

var $51PXu = parcelRequire("51PXu");

var $cuuJa = parcelRequire("cuuJa");

var $5MFfw = parcelRequire("5MFfw");
parcelRequire("cEecN");
var $3qL2F = parcelRequire("3qL2F");
parcelRequire("a76j8");
var $dBwUe = parcelRequire("dBwUe");
parcelRequire("3Q01T");
var $5XDHx = parcelRequire("5XDHx");

var $7CnHa = parcelRequire("7CnHa");

var $lhEfD = parcelRequire("lhEfD");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
parcelRequire("2dhRr");
const $e3bbecb37b7be657$var$DND_FLAG = 'DEPENDENCY_MARKER';
const $e3bbecb37b7be657$var$MIN_DRAG_DISTANCE = 2;
const $e3bbecb37b7be657$export$4ce792279e065294 = ({ direction: direction, isEditMode: isEditMode, onDrop: onDrop })=>{
    const [, { register: registerDndScrolling, deregister: deregisterDndScrolling }] = (0, $5XDHx.useDndScrolling)();
    const { setDragSource: setDragSource } = (0, $dBwUe.useDepLinesDrag)();
    const { id: dndItemId } = (0, $3qL2F.useDndItem)();
    const handleMouseDown = (0, $eUqFw.useCallback)((e)=>{
        if (!isEditMode) return;
        let dragStarted = false;
        const mousedownOffset = {
            x: e.clientX,
            y: e.clientY
        };
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const handleMouseMove = (e)=>{
            // Only start dragging when cursor has moved at least 2 pixels
            if (!dragStarted && (0, $7CnHa.isDefined)(e.clientX) && (0, $7CnHa.isDefined)(e.clientY) && (Math.abs(e.clientX - mousedownOffset.x) > $e3bbecb37b7be657$var$MIN_DRAG_DISTANCE || Math.abs(e.clientY - mousedownOffset.y) > $e3bbecb37b7be657$var$MIN_DRAG_DISTANCE)) {
                setDragSource({
                    rowId: dndItemId,
                    direction: direction
                });
                registerDndScrolling($e3bbecb37b7be657$var$DND_FLAG);
                dragStarted = true;
            }
            /* This is to communicate with dependency-lines/drag-preview/layer component
				 * However this is not the pattern we want, we gonna replace this in JPO-16799
				 */ const event = new CustomEvent('customized.dragmove', {
                detail: {
                    clientX: e.clientX,
                    clientY: e.clientY
                }
            });
            window.dispatchEvent(event);
        };
        const handleMouseUp = ()=>{
            onDrop();
            if (dragStarted) {
                setDragSource(undefined);
                deregisterDndScrolling($e3bbecb37b7be657$var$DND_FLAG);
                dragStarted = false;
            }
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('keydown', handleEscapeKey);
        };
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const handleEscapeKey = (e)=>{
            if (e.key === 'Escape') handleMouseUp();
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('keydown', handleEscapeKey);
    }, [
        isEditMode,
        setDragSource,
        dndItemId,
        direction,
        registerDndScrolling,
        onDrop,
        deregisterDndScrolling
    ]);
    return {
        handleMouseDown: handleMouseDown
    };
};
const $e3bbecb37b7be657$export$5048b513d451ea75 = ({ issueCountByLinkType: issueCountByLinkType, issueLinkType: issueLinkType })=>{
    const { handleDrop: handleDrop } = (0, $dBwUe.useDepLinesDrag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(()=>{
        const issueLinkAdded = handleDrop({
            issueLinkType: issueLinkType
        });
        if (issueLinkAdded) {
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADDED_ISSUE_DEPENDENCY_LINK.split(' ');
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            }), {
                source: 'dnd',
                type: issueLinkType,
                typeCount: issueCountByLinkType[issueLinkType] || 0
            });
        }
    }, [
        createAnalyticsEvent,
        handleDrop,
        issueCountByLinkType,
        issueLinkType
    ]);
};
const $e3bbecb37b7be657$export$d29bab26291a5c45 = (element, containerWidth, position, issueBarPosition, issueLinkType)=>{
    const { row: row } = (0, $lhEfD.useRow)();
    const [hasDragPreview, setHasDragPreview] = (0, $eUqFw.useState)(false);
    const hasDragPreviewRef = (0, $eUqFw.useRef)(false);
    hasDragPreviewRef.current = hasDragPreview;
    (0, $eUqFw.useEffect)(()=>(0, $51PXu.monitorForDependencyCreate)({
            onDrag: ()=>{
                if (!hasDragPreviewRef.current) setHasDragPreview(true);
            },
            onDrop: ()=>setHasDragPreview(false)
        }), []);
    (0, $eUqFw.useEffect)(()=>{
        if (!element) return;
        return (0, $51PXu.draggableForDependencyCreate)({
            element: element,
            getInitialData: ()=>({
                    row: row,
                    position: position,
                    issueLinkType: issueLinkType,
                    horizontalScrollingContainerX: containerWidth * (position === 'start' ? issueBarPosition.leftPositionPercentage / 100 : 1 - issueBarPosition.rightPositionPercentage / 100)
                })
        });
    }, [
        element,
        containerWidth,
        row,
        position,
        issueLinkType,
        issueBarPosition.leftPositionPercentage,
        issueBarPosition.rightPositionPercentage
    ]);
    return hasDragPreview;
};
const $e3bbecb37b7be657$export$3a05005085a96193 = ({ issue: issue, direction: direction, force: force })=>{
    const { payload: payload } = (0, $5MFfw.useDependenciesFlyout)();
    // The badge should be active when it's forced be active (from parent)
    // or the current flyout is the one triggered from this marker.
    if (force) return true;
    return payload?.issue.id === issue.id && payload?.direction === direction;
};

});


parcelRegister("kPfX1", function(module, exports) {

$parcel$export(module.exports, "badge-count", () => $f294f1951322bf61$export$6c2b63e0110f9881, (v) => $f294f1951322bf61$export$6c2b63e0110f9881 = v);
var $f294f1951322bf61$export$6c2b63e0110f9881;
var $f294f1951322bf61$export$b74ff737e0e298b5;
var $f294f1951322bf61$export$e5ef4f853dad983a;
var $f294f1951322bf61$export$b3571188c770cc5a;
var $f294f1951322bf61$export$81e49c35a901b51c;
$f294f1951322bf61$export$6c2b63e0110f9881 = `_3OyI6W_badge-count`;
$f294f1951322bf61$export$b74ff737e0e298b5 = `_3OyI6W_dependencies`;
$f294f1951322bf61$export$e5ef4f853dad983a = `_3OyI6W_hovered`;
$f294f1951322bf61$export$b3571188c770cc5a = `_3OyI6W_start`;
$f294f1951322bf61$export$81e49c35a901b51c = `_3OyI6W_unhovered`;

});

parcelRegister("8bq9d", function(module, exports) {

$parcel$export(module.exports, "getDefaultIssueLinkTypeId", () => $5d8633ede7192ca3$export$e7c0c9614deed0c);
$parcel$export(module.exports, "getDependencyLabel", () => $5d8633ede7192ca3$export$9d7e3ea957ff570a);

var $g2gaE = parcelRequire("g2gaE");
const $5d8633ede7192ca3$var$DEFAULT_ISSUE_LINK_TYPE = 10000;
const $5d8633ede7192ca3$export$e7c0c9614deed0c = (issueLinkTypes)=>issueLinkTypes.length > 0 ? issueLinkTypes[0].id : $5d8633ede7192ca3$var$DEFAULT_ISSUE_LINK_TYPE;
const $5d8633ede7192ca3$export$9d7e3ea957ff570a = (startOrEnd, formatMessage)=>startOrEnd === 'start' ? formatMessage((0, $g2gaE.default).startDependency) : formatMessage((0, $g2gaE.default).endDependency);

});
parcelRegister("g2gaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $871c48339adb5bcd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $871c48339adb5bcd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.start-dependency",
        "defaultMessage": "Start dependency"
    },
    endDependency: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.dependency-marker.end-dependency",
        "defaultMessage": "End dependency"
    }
});

});




parcelRegister("ixveE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7378dbc4a44f5e2d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $17L5s = parcelRequire("17L5s");

var $7CnHa = parcelRequire("7CnHa");

var $hw0OF = parcelRequire("hw0OF");

var $fX5ok = parcelRequire("fX5ok");
function $7378dbc4a44f5e2d$export$2e2bcd8739ae039(props) {
    const { startDate: startDate, endDate: endDate, activeSprint: activeSprint, completedSprintCount: completedSprintCount = 0, showActiveSprintOnTooltip: showActiveSprintOnTooltip } = props;
    if (!((0, $7CnHa.isDefined)(startDate) && (0, $7CnHa.isDefined)(endDate))) return null;
    // Adding one to include end date in calculation
    // e.g. Mar 2 - Mar 1 = 1
    // But we want to include both Mar 1 and Mar 2 in our calculations,
    // Therefore + 1 day
    const numDays = Math.floor((endDate - startDate) / (0, $17L5s.ONE_DAY)) + 1;
    const text = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fX5ok.withSprint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $hw0OF.default).issueLength,
        values: {
            numDays: numDays
        }
    }), showActiveSprintOnTooltip === true && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fX5ok.sprintDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fX5ok.separator
    }), activeSprint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $hw0OF.default).sprint,
        values: {
            activeSprint: activeSprint.title
        }
    }), completedSprintCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $hw0OF.default).completeSprints,
        values: {
            count: completedSprintCount
        }
    })));
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $fX5ok.issueLength
    }, text);
}

});
parcelRegister("hw0OF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc59d90180774c27$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $cc59d90180774c27$var$messages = (0, $90IgZ.defineMessages)({
    issueLength: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.issue-length",
        "defaultMessage": "{numDays, plural, one {# day} other {# days}}"
    },
    sprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.sprint",
        "defaultMessage": "Sprint: {activeSprint}"
    },
    completeSprints: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.issue-length.complete-sprints",
        "defaultMessage": ", +{count} Completed"
    }
});
var $cc59d90180774c27$export$2e2bcd8739ae039 = $cc59d90180774c27$var$messages;

});

parcelRegister("fX5ok", function(module, exports) {

$parcel$export(module.exports, "issueLength", () => $b9d08c50e6e309eb$export$cdb67a89cc823080, (v) => $b9d08c50e6e309eb$export$cdb67a89cc823080 = v);
$parcel$export(module.exports, "separator", () => $b9d08c50e6e309eb$export$3e523c77c1f23f8c, (v) => $b9d08c50e6e309eb$export$3e523c77c1f23f8c = v);
$parcel$export(module.exports, "sprintDetails", () => $b9d08c50e6e309eb$export$5a0c66c0f22bdbdc, (v) => $b9d08c50e6e309eb$export$5a0c66c0f22bdbdc = v);
$parcel$export(module.exports, "withSprint", () => $b9d08c50e6e309eb$export$e77aea3576038e88, (v) => $b9d08c50e6e309eb$export$e77aea3576038e88 = v);
var $b9d08c50e6e309eb$export$cdb67a89cc823080;
var $b9d08c50e6e309eb$export$3e523c77c1f23f8c;
var $b9d08c50e6e309eb$export$5a0c66c0f22bdbdc;
var $b9d08c50e6e309eb$export$e77aea3576038e88;
$b9d08c50e6e309eb$export$cdb67a89cc823080 = `O2em4q_issueLength`;
$b9d08c50e6e309eb$export$3e523c77c1f23f8c = `O2em4q_separator`;
$b9d08c50e6e309eb$export$5a0c66c0f22bdbdc = `O2em4q_sprintDetails`;
$b9d08c50e6e309eb$export$e77aea3576038e88 = `O2em4q_withSprint`;

});


parcelRegister("39ob0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9cb6e7d89e139d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5rYNM = parcelRequire("5rYNM");
function $3f9cb6e7d89e139d$export$2e2bcd8739ae039({ style: style, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testId": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.overflowed.overflowed",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: -(0, $5rYNM.HORIZONTAL_SCROLL_OFFSET),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            right: -(0, $5rYNM.HORIZONTAL_SCROLL_OFFSET)
        }
    }, children);
}
/** Restores the position and the sizing of the overflowed. */ $3f9cb6e7d89e139d$export$2e2bcd8739ae039.Restore = function RestoredOverflowed({ style: style, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            left: (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            right: (0, $5rYNM.HORIZONTAL_SCROLL_OFFSET)
        }
    }, children);
};

});

parcelRegister("fHPCH", function(module, exports) {

$parcel$export(module.exports, "spaBothDatesRow", () => $b6f2ea78e814889e$export$64d4ada7a07015f5, (v) => $b6f2ea78e814889e$export$64d4ada7a07015f5 = v);
var $b6f2ea78e814889e$export$64d4ada7a07015f5;
$b6f2ea78e814889e$export$64d4ada7a07015f5 = `Avp6xa_spaBothDatesRow`;

});



parcelRegister("h0tKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9910df93a615ea04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7CnHa = parcelRequire("7CnHa");

var $39ob0 = parcelRequire("39ob0");
/**
 * A wrapper for row which provides an optional bgColor and highlighter.
 * bgColor is the actual row bg color
 */ // remove 'highlighter' prop when cleaning ff arj-remove-row-warning-highlighting_jqjs5
function $9910df93a615ea04$var$RowContainer({ bgColor: bgColor, highlighter: highlighter, children: children, style: style = {}, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '100%'
        },
        "data-testid": testId
    }, (0, $1ybV0.ff)('arj-remove-row-warning-highlighting_jqjs5') || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39ob0.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $7CnHa.isDefined)(bgColor) && {
                backgroundColor: bgColor
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        }
    }, highlighter), children);
}
$9910df93a615ea04$var$RowContainer.whyDidYouRender = true;
$9910df93a615ea04$var$RowContainer.displayName = 'RowContainer';
var $9910df93a615ea04$export$2e2bcd8739ae039 = $9910df93a615ea04$var$RowContainer;

});

parcelRegister("a6kRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b5e79d555b5f5c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ftJNU = parcelRequire("ftJNU");

var $3tvih = parcelRequire("3tvih");

var $jc1Dh = parcelRequire("jc1Dh");
var $96b5e79d555b5f5c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3tvih.default), (0, $ftJNU.default))((0, $jc1Dh.default));

});
parcelRegister("ftJNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $867c12c4024f8a45$export$2e2bcd8739ae039);

var $8NDwu = parcelRequire("8NDwu");
const $867c12c4024f8a45$var$mapDispatchToProps = (dispatch, ownProps)=>({
        commitTimelinePreview: ()=>{
            dispatch((0, $8NDwu.commitTimelinePreview)());
        },
        cancelTimelinePreview: ()=>{
            dispatch((0, $8NDwu.cancelTimelinePreview)());
        },
        hoverTimelineIssue: (defaultStart, defaultEnd)=>{
            dispatch((0, $8NDwu.hoverTimelineIssue)(ownProps.issue.id, defaultStart, defaultEnd));
        }
    });
var $867c12c4024f8a45$export$2e2bcd8739ae039 = $867c12c4024f8a45$var$mapDispatchToProps;

});

parcelRegister("3tvih", function(module, exports) {

$parcel$export(module.exports, "default", () => $503bd8a02ef6d827$export$2e2bcd8739ae039);

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
var $503bd8a02ef6d827$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    timelineUnits: (0, $aMoMC.getTimelineUnits),
    zoomLevel: (0, $aMoMC.getZoomLevel)
});

});

parcelRegister("jc1Dh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2f4b6d6404dbdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $17L5s = parcelRequire("17L5s");

var $jODJR = parcelRequire("jODJR");

var $5rYNM = parcelRequire("5rYNM");

var $aD0C2 = parcelRequire("aD0C2");

var $fgEHA = parcelRequire("fgEHA");
const $2e2f4b6d6404dbdb$var$usePreviewSizeInMs = ()=>{
    const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ pxToMs: pxToMs, msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    // returns the cursor offset from today in ms
    // e.g. if we're in months and this func returns -400 we know we need to be -400ms from today
    const getCursorOffsetFromToday = (relativeMouseX)=>{
        const viewportOffsetInPx = msToPx(Math.abs(viewport.offset));
        let cursorOffset;
        // relativeMouseX is no longer relative, need to calculate it
        if (relativeMouseX > viewport.width) // if mouse is to the right of initial viewport
        cursorOffset = relativeMouseX - viewportOffsetInPx;
        else // if mouse is to the left of initial viewport
        cursorOffset = relativeMouseX + viewportOffsetInPx;
        const offset = viewport.offset + pxToMs(cursorOffset);
        return offset;
    };
    const getMousedOverDate = (relativeMouseX)=>{
        const today = Date.now();
        const cursorOffsetInMs = getCursorOffsetFromToday(relativeMouseX);
        const ms = today + cursorOffsetInMs;
        const date = new Date(ms);
        return date;
    };
    const getPreviewSize = (relativeMouseX)=>{
        // months has ~5px of padding between left edge of the bar and mouse cursor
        // quarters and years has ~1px
        const relativeAccountForPadding = zoomLevel === (0, $5rYNM.ZOOM_LEVELS).MONTHS ? relativeMouseX - 5 : relativeMouseX - 1;
        const mousedOverDate = getMousedOverDate(relativeAccountForPadding);
        return (0, $aD0C2.getDaysInTimelineView)(mousedOverDate, zoomLevel) * (0, $17L5s.ONE_DAY) - 1;
    };
    return getPreviewSize;
};
function $2e2f4b6d6404dbdb$export$2e2bcd8739ae039(props) {
    const getPreviewSize = $2e2f4b6d6404dbdb$var$usePreviewSizeInMs();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fgEHA.default), {
        ...props,
        getPreviewSizeInMs: getPreviewSize
    });
}

});
parcelRegister("aD0C2", function(module, exports) {

$parcel$export(module.exports, "getDaysInTimelineView", () => $435e4709c6fc1bf9$export$8b361b34637253ef);

var $6WQhi = parcelRequire("6WQhi");
var $gRrfF = parcelRequire("gRrfF");
var $lUve5 = parcelRequire("lUve5");
var $17L5s = parcelRequire("17L5s");
var $jqhqi = parcelRequire("jqhqi");

var $5rYNM = parcelRequire("5rYNM");
const $435e4709c6fc1bf9$export$a67f6b7c5b24aabc = (date)=>{
    const startDate = (0, $jqhqi.default)(date);
    const endDate = (0, $6WQhi.default)(date);
    // Doing round to account for daylight savings as tart date could be in +1000 but end date could be in +1100
    return Math.round((endDate.getTime() + 1 - startDate.getTime()) / (0, $17L5s.ONE_DAY));
};
const $435e4709c6fc1bf9$export$8b361b34637253ef = (date, zoomLevel)=>{
    const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    switch(zoomLevel){
        case (0, $5rYNM.ZOOM_LEVELS).WEEKS:
            return 7;
        case (0, $5rYNM.ZOOM_LEVELS).MONTHS:
            return (0, $gRrfF.default)(normalizedDate);
        case (0, $5rYNM.ZOOM_LEVELS).QUARTERS:
            return $435e4709c6fc1bf9$export$a67f6b7c5b24aabc(normalizedDate);
        case (0, $5rYNM.ZOOM_LEVELS).YEARS:
            return (0, $lUve5.default)(normalizedDate);
        default:
            return 30;
    }
};

});

parcelRegister("fgEHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0273843786cfa18$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $joqqM = parcelRequire("joqqM");

var $g4Vkx = parcelRequire("g4Vkx");
var $18uE0 = parcelRequire("18uE0");
var $17L5s = parcelRequire("17L5s");
var $fmBR7 = parcelRequire("fmBR7");

var $l9dNG = parcelRequire("l9dNG");

var $gVkBP = parcelRequire("gVkBP");

var $imoOy = parcelRequire("imoOy");

var $kG4Lf = parcelRequire("kG4Lf");

var $ixveE = parcelRequire("ixveE");

var $39ob0 = parcelRequire("39ob0");

var $gnR6K = parcelRequire("gnR6K");
const $f0273843786cfa18$var$snapWithFloor = (val, snap)=>Math.floor(val / snap) * snap;
// Where the hover preview should be in relation to the cursor
// 0   = The preview will be to the right of the cursor
// 0.5 = The preview will be centered around the cursor
// 1   = The preview will be to the left of the cursor
const $f0273843786cfa18$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO = 0;
const $f0273843786cfa18$export$17fb3b47afd39747 = (unit, timelineSize, timelineRange)=>unit * timelineSize + timelineRange.start;
const $f0273843786cfa18$export$d8a0b4b7b3e0ece6 = (relativeMouseX, viewWidth, timelineSize, timelineUnits)=>{
    const fromXPercentage = relativeMouseX / viewWidth * 100;
    let accumulatedUnitPercentage = 0;
    let previewUnit = timelineUnits[0];
    for(let i = 0; i < timelineUnits.length; i++){
        accumulatedUnitPercentage += timelineUnits[i].widthPercentage;
        if (accumulatedUnitPercentage > fromXPercentage || i === timelineUnits.length - 1) {
            previewUnit = timelineUnits[i];
            break;
        }
    }
    const widthPercentage = previewUnit ? previewUnit.widthPercentage : 100;
    const previewSize = $f0273843786cfa18$var$snapWithFloor(widthPercentage / 100 * timelineSize, (0, $17L5s.ONE_DAY));
    return previewSize;
};
const $f0273843786cfa18$export$48715bb6a00f5260 = (fromX, toX, timelineRange, timelineUnits, rect, calculateBaselineEnd)=>{
    const relativeStartX = fromX - rect.left;
    const relativeToX = toX - rect.left;
    const timelineSize = timelineRange.end - timelineRange.start;
    const previewSize = $f0273843786cfa18$export$d8a0b4b7b3e0ece6(relativeStartX, rect.width, timelineSize, timelineUnits);
    const startUnit = relativeStartX / rect.width;
    const baselineStart = $f0273843786cfa18$var$snapWithFloor($f0273843786cfa18$export$17fb3b47afd39747(startUnit, timelineSize, timelineRange) - previewSize * $f0273843786cfa18$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO, (0, $17L5s.ONE_DAY));
    const endUnit = relativeToX / rect.width;
    const unroundedBaselineEnd = $f0273843786cfa18$export$17fb3b47afd39747(endUnit, timelineSize, timelineRange);
    const baselineEnd = calculateBaselineEnd(unroundedBaselineEnd, previewSize, baselineStart);
    return {
        baselineStart: (0, $17L5s.startOfUtcDay)(baselineStart),
        baselineEnd: (0, $17L5s.endOfUtcDay)(baselineEnd)
    };
};
const $f0273843786cfa18$export$3a1ccf511224c1d9 = (fromX, timelineRange, rect, getPreview)=>{
    const relativeStartX = fromX - rect.left;
    const timelineSize = timelineRange.end - timelineRange.start;
    const previewSize = getPreview(relativeStartX);
    const startUnit = relativeStartX / rect.width;
    const baselineStart = $f0273843786cfa18$var$snapWithFloor($f0273843786cfa18$export$17fb3b47afd39747(startUnit, timelineSize, timelineRange) - previewSize * $f0273843786cfa18$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO, (0, $17L5s.ONE_DAY));
    const baselineEnd = baselineStart + previewSize;
    return {
        baselineStart: (0, $17L5s.startOfUtcDay)(baselineStart),
        baselineEnd: (0, $17L5s.startOfUtcDay)(baselineEnd)
    };
};
const $f0273843786cfa18$export$fa41d78174d0c825 = (unroundedBaselineEnd, _, baselineStart)=>{
    let baselineEnd = $f0273843786cfa18$var$snapWithFloor(unroundedBaselineEnd, (0, $17L5s.ONE_DAY));
    baselineEnd = Math.max(baselineStart, baselineEnd);
    return baselineEnd;
};
const $f0273843786cfa18$export$1e6156e0ceeece5a = (unroundedBaselineEnd, previewSize)=>{
    const baselineEnd = $f0273843786cfa18$var$snapWithFloor(unroundedBaselineEnd + previewSize * (1 - $f0273843786cfa18$var$HOVER_PREVIEW_CURSOR_OFFSET_RATIO), (0, $17L5s.ONE_DAY));
    return baselineEnd;
};
class $f0273843786cfa18$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isReadOnly: false,
            Bar: $l9dNG.default
        };
    }
    render() {
        const { barColor: barColor, barColors: barColors, timelineRange: timelineRange, preview: preview, issue: issue, Bar: // eslint-disable-next-line @typescript-eslint/no-shadow
        Bar, topOffset: topOffset } = this.props;
        let bar;
        let startDate;
        let endDate;
        let dates;
        let numDays;
        if (preview) {
            const { leftPositionPercentage: leftPositionPercentage, rightPositionPercentage: rightPositionPercentage } = (0, $gVkBP.getPositionsForBar)(preview, timelineRange);
            bar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Bar, {
                leftPositionPercentage: leftPositionPercentage,
                rightPositionPercentage: rightPositionPercentage,
                leftAnchorPercentage: 0,
                rightAnchorPercentage: 100,
                color: barColor,
                colors: barColors,
                opacity: 0.5,
                id: issue.id,
                additionalStyles: {
                    zIndex: 0
                },
                topOffset: topOffset
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gnR6K.spaBarContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($joqqM))), {
                label: "",
                size: "small",
                primaryColor: "var(--ds-surface-raised, rgba(255, 255, 255, 0.8))",
                secondaryColor: barColor || `var(--ds-text-subtle, ${(0, $g4Vkx.default).N500})`
            })));
            if (this.state.hovered || this.state.dragging) {
                startDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                    startOrEnd: "start",
                    date: preview.baselineStart
                });
                endDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                    startOrEnd: "end",
                    date: preview.baselineEnd
                });
                numDays = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixveE.default), {
                    startDate: preview.baselineStart,
                    endDate: preview.baselineEnd
                });
            }
            if (this.ref instanceof Element) {
                const rect = this.ref.getBoundingClientRect();
                dates = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kG4Lf.default), {
                    datePosition: {
                        leftPositionPercentage: leftPositionPercentage,
                        rightPositionPercentage: rightPositionPercentage
                    },
                    width: rect.width
                }, startDate, numDays, endDate);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: this.onHoverChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18uE0.default), {
            dragHandler: {
                onMouseDown: this.onMouseDown,
                onDrag: this.onDrag,
                onDragEnd: this.onDragEnd,
                onClick: this.onClick
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.row.no-dates.row-${issue.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($gnR6K.spaNoDatesRow, {
                [$gnR6K.readOnly]: this.props.isReadOnly
            }),
            onMouseMove: this.onMouseMove,
            ref: (ref)=>{
                if (ref) this.ref = ref;
            }
        }, bar, dates, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39ob0.default), null))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            dragging: false,
            hovered: false
        };
        this.onMouseMove = (e)=>{
            if (this.props.isReadOnly) return;
            if (this.state.dragging) // This method handles hovering only. Drag and drop is handled in onDrag.
            return;
            if (!(this.ref instanceof Element)) return;
            const { timelineRange: timelineRange, timelineUnits: timelineUnits, zoomLevel: zoomLevel, getPreviewSizeInMs: getPreviewSizeInMs } = this.props;
            if (zoomLevel === undefined || !getPreviewSizeInMs) {
                const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $f0273843786cfa18$export$48715bb6a00f5260(e.pageX, e.pageX, timelineRange, timelineUnits, this.ref.getBoundingClientRect(), $f0273843786cfa18$export$1e6156e0ceeece5a);
                this.updatePreview(baselineStart, baselineEnd);
            } else {
                const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $f0273843786cfa18$export$3a1ccf511224c1d9(e.pageX, timelineRange, this.ref.getBoundingClientRect(), getPreviewSizeInMs);
                this.updatePreview(baselineStart, baselineEnd);
            }
        };
        this.onMouseDown = ()=>{
            if (this.props.isReadOnly) return;
            // We act on onMouseDown instead of onDragStart to prevent the date from jumping
            // while we're still moving within the drag threshold
            this.setState({
                dragging: true
            });
            this.props.disableOtherRows(this.props.issue.id);
        };
        this.onDrag = (_, to, start)=>{
            if (this.props.isReadOnly) return;
            if (!(this.ref instanceof Element)) return;
            //  drag right to left, the first date is the end date
            //  drag left to right, the first date is the start date
            const startX = to.x - start.x < 0 ? to.x : start.x;
            const toX = to.x - start.x < 0 ? start.x : to.x;
            const { timelineRange: timelineRange } = this.props;
            const { baselineStart: baselineStart, baselineEnd: baselineEnd } = $f0273843786cfa18$export$48715bb6a00f5260(startX, toX, timelineRange, this.props.timelineUnits, this.ref.getBoundingClientRect(), $f0273843786cfa18$export$fa41d78174d0c825);
            this.updatePreview(baselineStart, baselineEnd);
        };
        this.onDragEnd = ()=>{
            if (this.props.isReadOnly) return;
            this.props.commitTimelinePreview();
            this.props.reEnableOtherRows();
        };
        this.onClick = ()=>{
            if (this.props.isReadOnly) return;
            this.props.commitTimelinePreview();
            this.props.reEnableOtherRows();
        };
        this.updatePreview = (baselineStart, baselineEnd)=>{
            this.props.hoverTimelineIssue(baselineStart, baselineEnd);
        };
        this.onHoverChanged = (hover)=>{
            if (this.props.isReadOnly) return;
            this.setState({
                hovered: hover
            });
            if (!hover) this.props.cancelTimelinePreview();
        };
    }
}

});
parcelRegister("joqqM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1e4c2d5db89ba60$var$_react = $e1e4c2d5db89ba60$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e1e4c2d5db89ba60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e1e4c2d5db89ba60$var$AddCircleIcon = (props)=>/*#__PURE__*/ $e1e4c2d5db89ba60$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M11.046 7.958v3.088H7.958a.954.954 0 100 1.908h3.088v3.088a.954.954 0 101.908 0v-3.088h3.088a.954.954 0 100-1.908h-3.088V7.958a.954.954 0 10-1.908 0z" fill="inherit"/></g></svg>`
    }, props));
$e1e4c2d5db89ba60$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $e1e4c2d5db89ba60$var$_default = $e1e4c2d5db89ba60$var$AddCircleIcon;
module.exports.default = $e1e4c2d5db89ba60$var$_default;

});

parcelRegister("gnR6K", function(module, exports) {

$parcel$export(module.exports, "readOnly", () => $bed7fd73e8411f76$export$b2cbc93d4da94977, (v) => $bed7fd73e8411f76$export$b2cbc93d4da94977 = v);
$parcel$export(module.exports, "spaBarContent", () => $bed7fd73e8411f76$export$94c4bac2cffc23c6, (v) => $bed7fd73e8411f76$export$94c4bac2cffc23c6 = v);
$parcel$export(module.exports, "spaNoDatesRow", () => $bed7fd73e8411f76$export$3d1c6a55f6d665b0, (v) => $bed7fd73e8411f76$export$3d1c6a55f6d665b0 = v);
var $bed7fd73e8411f76$export$b2cbc93d4da94977;
var $bed7fd73e8411f76$export$94c4bac2cffc23c6;
var $bed7fd73e8411f76$export$3d1c6a55f6d665b0;
$bed7fd73e8411f76$export$b2cbc93d4da94977 = `fUXzxa_readOnly`;
$bed7fd73e8411f76$export$94c4bac2cffc23c6 = `fUXzxa_spaBarContent`;
$bed7fd73e8411f76$export$3d1c6a55f6d665b0 = `fUXzxa_spaNoDatesRow`;

});




parcelRegister("aFEKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $81852904fb1aca3a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $Zbspp = parcelRequire("Zbspp");

var $iVqkx = parcelRequire("iVqkx");
var $81852904fb1aca3a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $Zbspp.default))((0, $iVqkx.default));

});
parcelRegister("Zbspp", function(module, exports) {

$parcel$export(module.exports, "default", () => $358d083caf355982$export$2e2bcd8739ae039);

var $8NDwu = parcelRequire("8NDwu");

var $dbuYA = parcelRequire("dbuYA");
const $358d083caf355982$var$mapDispatchToProps = (dispatch, ownProps)=>({
        commitTimelinePreview: ()=>{
            dispatch((0, $8NDwu.commitTimelinePreview)());
        },
        cancelTimelinePreview: ()=>{
            dispatch((0, $8NDwu.cancelTimelinePreview)());
        },
        resizeTimelineIssue: (baselineStart, baselineEnd)=>{
            dispatch((0, $dbuYA.suspend)());
            dispatch((0, $8NDwu.hoverTimelineIssue)(ownProps.issue.id, baselineStart, baselineEnd));
            dispatch((0, $8NDwu.resizeTimelineIssue)(baselineStart, baselineEnd));
            dispatch((0, $dbuYA.resume)());
        }
    });
var $358d083caf355982$export$2e2bcd8739ae039 = $358d083caf355982$var$mapDispatchToProps;

});

parcelRegister("iVqkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b78a9c769bed82a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fmBR7 = parcelRequire("fmBR7");
var $17L5s = parcelRequire("17L5s");

var $5rYNM = parcelRequire("5rYNM");

var $l9dNG = parcelRequire("l9dNG");

var $gVkBP = parcelRequire("gVkBP");

var $imoOy = parcelRequire("imoOy");

var $kG4Lf = parcelRequire("kG4Lf");

var $euTYF = parcelRequire("euTYF");

var $ixveE = parcelRequire("ixveE");

var $39ob0 = parcelRequire("39ob0");

var $ehQap = parcelRequire("ehQap");
const $3b78a9c769bed82a$var$snapWithRound = (val, snap)=>Math.round(val / snap) * snap;
class $3b78a9c769bed82a$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            DependencyMarker: $euTYF.default,
            Bar: $l9dNG.default,
            isReadOnly: false,
            showStripesInBar: {
                left: false,
                right: false
            },
            isBeingInteractedWith: false,
            cancelTimelinePreview: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            commitTimelinePreview: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            resizeTimelineIssue: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            disableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            reEnableOtherRows: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            renderFlyout: ()=>null
        };
    }
    render() {
        const { issue: issue, baselineStart: baselineStart, baselineEnd: baselineEnd, timelineRange: timelineRange, barColor: barColor, barColors: barColors, showStripesInBar: showStripesInBar, preview: preview, hasDependencyLineDragPreview: hasDependencyLineDragPreview, renderFlyout: renderFlyout, isBeingInteractedWith: isBeingInteractedWith, isReadOnly: isReadOnly, externalIncomingLinks: externalIncomingLinks, externalOutgoingLinks: externalOutgoingLinks, internalIncomingLinks: internalIncomingLinks, internalIncomingLinksOriginal: internalIncomingLinksOriginal, internalOutgoingLinks: internalOutgoingLinks, internalOutgoingLinksOriginal: internalOutgoingLinksOriginal, opacity: opacity, width: width, DependencyMarker: // eslint-disable-next-line @typescript-eslint/no-shadow
        DependencyMarker, Bar: // eslint-disable-next-line @typescript-eslint/no-shadow
        Bar, topOffset: topOffset } = this.props;
        const { hovered: hovered } = this.state;
        const createBar = (dates, props)=>{
            const position = (0, $gVkBP.getPositionsForBar)(dates, timelineRange);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Bar, {
                ...position,
                color: barColor,
                colors: barColors,
                showStripes: showStripesInBar,
                id: issue.id,
                ...props,
                opacity: opacity,
                topOffset: topOffset
            });
        };
        let leftHandleDragHandler;
        let rightHandleDragHandler;
        if (!isReadOnly) {
            const baseDragHandler = {
                onDragStart: ()=>{
                    this.props.disableOtherRows(issue.id);
                },
                onDragEnd: ()=>{
                    this.props.commitTimelinePreview();
                    this.props.reEnableOtherRows();
                }
            };
            if (baselineStart !== undefined) leftHandleDragHandler = {
                ...baseDragHandler,
                onDrag: (_, to, start)=>{
                    const timelineWidth = timelineRange.end - timelineRange.start;
                    const deltaRatio = (to.x - start.x) / width;
                    const delta = $3b78a9c769bed82a$var$snapWithRound(deltaRatio * timelineWidth, (0, $17L5s.ONE_DAY));
                    const newBaselineStart = baselineStart + delta;
                    this.props.resizeTimelineIssue(newBaselineStart, undefined);
                }
            };
            if (baselineEnd !== undefined) rightHandleDragHandler = {
                ...baseDragHandler,
                onDrag: (_, to, start)=>{
                    const timelineWidth = timelineRange.end - timelineRange.start;
                    const deltaRatio = (to.x - start.x) / width;
                    const delta = $3b78a9c769bed82a$var$snapWithRound(deltaRatio * timelineWidth, (0, $17L5s.ONE_DAY));
                    const newBaselineEnd = baselineEnd + delta;
                    this.props.resizeTimelineIssue(undefined, newBaselineEnd);
                }
            };
        }
        const barOpacity = preview ? 0.5 : 1;
        const bar = createBar({
            baselineStart: baselineStart,
            baselineEnd: baselineEnd
        }, {
            opacity: barOpacity,
            leftHandleDragHandler: leftHandleDragHandler,
            rightHandleDragHandler: rightHandleDragHandler,
            showHandles: !isReadOnly && hovered && !isBeingInteractedWith,
            renderFlyout: renderFlyout
        });
        let previewBar;
        if (preview) previewBar = createBar(preview, {
            opacity: 0.8
        });
        const datePosition = (0, $gVkBP.getPositionsForBar)({
            baselineStart: baselineStart,
            baselineEnd: baselineEnd
        }, timelineRange);
        const incomingDependencies = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyMarker, {
            externalIncomingLinks: externalIncomingLinks,
            internalIncomingLinks: internalIncomingLinks,
            originalIssueLinks: internalIncomingLinksOriginal,
            startOrEnd: "start",
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD,
            datePosition: datePosition,
            width: width,
            issue: issue,
            isHovered: hovered,
            barColor: barColor,
            barColors: barColors
        });
        const outgoingDependencies = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencyMarker, {
            externalOutgoingLinks: externalOutgoingLinks,
            internalOutgoingLinks: internalOutgoingLinks,
            internalOriginalIssueLinks: internalOutgoingLinksOriginal,
            startOrEnd: "end",
            direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD,
            datePosition: datePosition,
            width: width,
            issue: issue,
            isHovered: hovered,
            barColor: barColor,
            barColors: barColors
        });
        let startDate;
        let endDate;
        let dates;
        let numDays;
        if (hovered && !hasDependencyLineDragPreview) {
            startDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                startOrEnd: "start",
                date: baselineStart
            });
            endDate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $imoOy.default), {
                startOrEnd: "end",
                date: baselineEnd
            });
            numDays = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixveE.default), {
                startDate: baselineStart,
                endDate: baselineEnd
            });
            dates = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kG4Lf.default), {
                datePosition: datePosition,
                width: width
            }, startDate, numDays, endDate);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
            onHoverChanged: (hover)=>this.setState({
                    hovered: hover
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $ehQap.spaPartialDatesRow
        }, bar, previewBar, dates, incomingDependencies, outgoingDependencies, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39ob0.default), null)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            hovered: false
        };
    }
}

});
parcelRegister("ehQap", function(module, exports) {

$parcel$export(module.exports, "spaPartialDatesRow", () => $a66b1e73b4c7c894$export$18bc6d25fe9a31b3, (v) => $a66b1e73b4c7c894$export$18bc6d25fe9a31b3 = v);
var $a66b1e73b4c7c894$export$18bc6d25fe9a31b3;
$a66b1e73b4c7c894$export$18bc6d25fe9a31b3 = `NZ8FpW_spaPartialDatesRow`;

});



parcelRegister("BMvsQ", function(module, exports) {

$parcel$export(module.exports, "row", () => $07191531a559d8ff$export$120ff0929b202a6d, (v) => $07191531a559d8ff$export$120ff0929b202a6d = v);
var $07191531a559d8ff$export$120ff0929b202a6d;
$07191531a559d8ff$export$120ff0929b202a6d = `n2DYDa_row`;

});



parcelRegister("dPptc", function(module, exports) {

$parcel$export(module.exports, "default", () => $408968f7e9d62d24$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8dZUO = parcelRequire("8dZUO");

var $XTfkF = parcelRequire("XTfkF");
var $408968f7e9d62d24$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $8dZUO.default), {})((0, $XTfkF.default));

});
parcelRegister("8dZUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9a8cab9a05c667$export$2e2bcd8739ae039);

var $evo53 = parcelRequire("evo53");

var $a0bo1 = parcelRequire("a0bo1");

var $aMoMC = parcelRequire("aMoMC");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $3a9a8cab9a05c667$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    scope: (0, $a0bo1.getTableItems),
    showCapacity: (0, $kyGCj.getShowSprints),
    stickyHeader: (0, $evo53.getCurrentStickyHeaderGeometry),
    timelineRange: (0, $aMoMC.getTimelineRange),
    zoomLevel: (0, $aMoMC.getZoomLevel)
});

});

parcelRegister("XTfkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $697c502f0933c5b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("enlJQ");
var $jjPWu = parcelRequire("jjPWu");

var $8YyRg = parcelRequire("8YyRg");

var $jY4GB = parcelRequire("jY4GB");
function $697c502f0933c5b7$export$2e2bcd8739ae039({ scope: scope, zoomLevel: zoomLevel, width: width, stickyHeader: stickyHeader }) {
    if (!stickyHeader) return null;
    const item = scope[stickyHeader.index];
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8YyRg.default), {
        item: item,
        width: width,
        style: {
            height: '100%'
        }
    });
    return zoomLevel ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jY4GB.stickyHeaderSprintsContainer
    }, (0, $jjPWu.default)(content)) : content;
}

});
parcelRegister("8YyRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $118373a72f77d724$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3WER0 = parcelRequire("3WER0");

var $5byEL = parcelRequire("5byEL");
var $118373a72f77d724$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3WER0.default), {})((0, $5byEL.default));

});
parcelRegister("3WER0", function(module, exports) {

$parcel$export(module.exports, "default", () => $549635474626e29c$export$2e2bcd8739ae039);

var $aMoMC = parcelRequire("aMoMC");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $549635474626e29c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    showCapacity: (0, $kyGCj.getShowSprints),
    timelineRange: (0, $aMoMC.getTimelineRange),
    zoomLevel: (0, $aMoMC.getZoomLevel)
});

});

parcelRegister("5byEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a650a0a550c92d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $a0bo1 = parcelRequire("a0bo1");

var $9FyNo = parcelRequire("9FyNo");

var $01R8T = parcelRequire("01R8T");

var $4hwn4 = parcelRequire("4hwn4");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $dLUZc = parcelRequire("dLUZc");
parcelRequire("9kZCZ");
var $39ob0 = parcelRequire("39ob0");

var $hn2Tm = parcelRequire("hn2Tm");

var $i6sAa = parcelRequire("i6sAa");
function $78a650a0a550c92d$export$2e2bcd8739ae039({ item: item, showCapacity: showCapacity, timelineRange: timelineRange, zoomLevel: zoomLevel, width: width, style: style, key: key = '' }) {
    if (!(0, $7CnHa.isDefined)(item)) return null;
    if (item.tag !== (0, $a0bo1.TABLE_GROUP)) throw new Error(`renderGroup could only render ${(0, $a0bo1.TABLE_GROUP)} items, but got ${item.tag}`);
    const { group: group, grouping: grouping } = item;
    const [Overflowed, Restored] = !zoomLevel ? [
        (0, $eUqFw.Fragment),
        (0, $eUqFw.Fragment)
    ] : [
        (0, $39ob0.default),
        (0, $39ob0.default).Restore
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: `${item.tag}-${group || key || ''}`,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Overflowed, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i6sAa.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Restored, null, showCapacity && grouping === (0, $5rYNM.GROUPING).TEAM && (0, $7CnHa.isDefined)(item.groupCombination.team) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hn2Tm.default), {
        team: item.groupCombination.team,
        timelineRange: timelineRange
    }), showCapacity && grouping === (0, $5rYNM.GROUPING).SPRINT && (0, $7CnHa.isDefined)(item.groupCombination.team) && (0, $7CnHa.isDefined)(item.groupCombination.sprint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dLUZc.default), {
        team: item.groupCombination.team,
        sprint: item.groupCombination.sprint,
        timelineRange: timelineRange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9FyNo.default), {
        noMarker: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01R8T.default), {
        width: width,
        renderMarker: ({ date: date, mode: mode, versionIdsMapByDate: versionIdsMapByDate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hwn4.default), {
                key: date,
                endDate: date,
                mode: mode,
                versionIdsMapByDate: versionIdsMapByDate
            })
    }))))));
}

});
parcelRegister("dLUZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee4b434d0b941a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g4Vkx = parcelRequire("g4Vkx");

var $jODJR = parcelRequire("jODJR");

var $lNNXV = parcelRequire("lNNXV");
parcelRequire("9kZCZ");
var $h0tKx = parcelRequire("h0tKx");

var $glR4Q = parcelRequire("glR4Q");

var $h2mCe = parcelRequire("h2mCe");
const $6ee4b434d0b941a5$var$Capacities = (0, $lNNXV.connect)((0, $glR4Q.default), {})((0, $h2mCe.default));
const $6ee4b434d0b941a5$export$ba50afc461737701 = ({ timelineRange: timelineRangeFromProps, ...rest })=>{
    const [{ getPercentageOffsetFromToday: getPercentageOffsetFromToday }] = (0, $jODJR.useHorizontalPercentageOffset)();
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [{ timelineRange: timelineRange }] = (0, $jODJR.useRenderingWindow)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), {
        bgColor: `var(--ds-surface, ${(0, $g4Vkx.default).N0})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee4b434d0b941a5$var$Capacities, {
        ...rest,
        timelineRange: zoomLevel ? timelineRange : timelineRangeFromProps,
        zoomLevel: zoomLevel,
        getPercentageOffsetFromToday: getPercentageOffsetFromToday
    }));
};
var $6ee4b434d0b941a5$export$2e2bcd8739ae039 = $6ee4b434d0b941a5$export$ba50afc461737701;

});
parcelRegister("glR4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90442443a32184d$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $aMoMC = parcelRequire("aMoMC");
const $a90442443a32184d$var$getPlannedCapacity = (state, { sprint: sprint, team: team })=>(0, $c1XMU.getCapacityForTeamAndIteration)(state, {
        teamId: team,
        iterationId: sprint
    });
const $a90442443a32184d$var$getOriginalPlannedCapacity = (state, { sprint: sprint, team: team })=>(0, $c1XMU.getOriginalCapacityForTeamAndIteration)(state, {
        teamId: team,
        iterationId: sprint
    });
const $a90442443a32184d$var$mapStateToProps = (state, ownProps)=>({
        teamObject: (0, $MQRDu.getTeamsById)(state)[ownProps.team],
        plan: (0, $75KhQ.getPlan)(state),
        sprintsCapacityOnTimeline: (0, $c1XMU.getSprintsCapacityOnTimeline)(state),
        workingHours: (0, $dhHiZ.getJiraHoursPerDay)(state),
        isUpdated: !!$a90442443a32184d$var$getOriginalPlannedCapacity(state, ownProps),
        plannedCapacity: $a90442443a32184d$var$getPlannedCapacity(state, ownProps),
        zoomLevel: (0, $aMoMC.getZoomLevel)(state)
    });
var $a90442443a32184d$export$2e2bcd8739ae039 = $a90442443a32184d$var$mapStateToProps;

});

parcelRegister("h2mCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $548de9f144e9d2b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");

var $5JgJ2 = parcelRequire("5JgJ2");

var $17L5s = parcelRequire("17L5s");

var $5fUv6 = parcelRequire("5fUv6");

var $cuxq0 = parcelRequire("cuxq0");

var $2bJlS = parcelRequire("2bJlS");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $gtLxh = parcelRequire("gtLxh");

var $ap79s = parcelRequire("ap79s");

var $9pZlP = parcelRequire("9pZlP");
const $548de9f144e9d2b1$var$roundEstimate = (x)=>Math.round(10 * x) / 10;
const $548de9f144e9d2b1$var$Capacities = function({ plan: plan, teamObject: teamObject, plannedCapacity: plannedCapacity, workingHours: workingHours, isUpdated: isUpdated, zoomLevel: zoomLevel, getPercentageOffsetFromToday: getPercentageOffsetFromToday, sprintsCapacityOnTimeline: sprintsCapacityOnTimeline, sprint: selectedSprint, team: team }) {
    const [open, setOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const toggleFlyout = (0, $eUqFw.useCallback)(()=>setOpen((open)=>!open), []);
    if (!(0, $7CnHa.isDefined)(teamObject)) return null;
    const { issueSource: issueSource } = teamObject;
    if (issueSource === undefined || issueSource === null) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9pZlP.message
    }, formatMessage((0, $ap79s.default).noIssueSources));
    const capacity = $kjklK.default([
        team,
        selectedSprint
    ], sprintsCapacityOnTimeline);
    if (!capacity) return null;
    const { planningUnit: planningUnit } = plan;
    const timeline = capacity.map((sprint, index)=>{
        const { usedCapacity: usedCapacity = 0 } = sprint;
        const availableCapacity = plannedCapacity ? plannedCapacity.capacity || 0 : sprint.availableCapacity || 0;
        let display;
        switch(planningUnit){
            case (0, $5rYNM.PLANNING_UNITS).DAYS:
                display = formatMessage((0, $ap79s.default).daysUnit, {
                    count: $548de9f144e9d2b1$var$roundEstimate((0, $5fUv6.convertSecondsToDays)(usedCapacity, workingHours))
                });
                break;
            case (0, $5rYNM.PLANNING_UNITS).HOURS:
                display = formatMessage((0, $ap79s.default).hoursUnit, {
                    count: $548de9f144e9d2b1$var$roundEstimate((0, $5fUv6.convertSecondsToHours)(usedCapacity))
                });
                break;
            case (0, $5rYNM.PLANNING_UNITS).STORY_POINTS:
                display = `${$548de9f144e9d2b1$var$roundEstimate(usedCapacity)} / ${availableCapacity}`;
                break;
            default:
                throw new Error(`Unexpected planningUnit: ${planningUnit}`);
        }
        const content = sprint.id === 'GAP' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cuxq0.default), {
            isOpen: open,
            onToggle: toggleFlyout,
            sprint: sprint,
            teamObject: teamObject,
            plannedCapacity: plannedCapacity,
            plan: plan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bJlS.default), {
            content: display
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9pZlP.sprintBox} ${usedCapacity > availableCapacity ? $9pZlP.overbooked : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9pZlP.bar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${usedCapacity > availableCapacity ? $9pZlP.overbooked : $9pZlP.okay}`,
            style: {
                height: `${Math.min(100, 100 * usedCapacity / availableCapacity)}%`
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9pZlP.sprintName
        }, display))));
        const style = zoomLevel && getPercentageOffsetFromToday ? {
            width: `${getPercentageOffsetFromToday((0, $17L5s.endOfUtcDay)(sprint.rawEndDate || sprint.endDate)) - getPercentageOffsetFromToday((0, $17L5s.startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
            left: `${getPercentageOffsetFromToday((0, $17L5s.startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
            position: 'absolute',
            transition: 'width 0.1s ease-in-out 0s',
            animation: '0.2s ease-in-out'
        } : {
            width: `${sprint.widthPercentage}%`,
            position: 'absolute',
            left: `${sprint.offset}%`,
            transition: 'width 0.1s ease-in-out 0s',
            animation: '0.2s ease-in-out'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gtLxh.default), {
            key: index,
            sprintId: sprint.id,
            content: content,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            isUpdated: isUpdated
        });
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9pZlP.sprintLabels,
        key: 0
    }, timeline));
};
var $548de9f144e9d2b1$export$2e2bcd8739ae039 = $548de9f144e9d2b1$var$Capacities;

});
parcelRegister("cuxq0", function(module, exports) {

$parcel$export(module.exports, "default", () => $aceeb54ae74c6de0$export$2e2bcd8739ae039);

var $4nVGi = parcelRequire("4nVGi");
var $aceeb54ae74c6de0$export$2e2bcd8739ae039 = (0, $4nVGi.default);

});
parcelRegister("4nVGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c9ba885d5a212e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $jpQDZ = parcelRequire("jpQDZ");
var $eNhh9 = parcelRequire("eNhh9");

var $jODJR = parcelRequire("jODJR");

var $5rYNM = parcelRequire("5rYNM");

var $ltDM8 = parcelRequire("ltDM8");

var $ddVQP = parcelRequire("ddVQP");
const $96c9ba885d5a212e$var$DIALOG_MIN_WIDTH = 530;
function $96c9ba885d5a212e$var$SprintFlyout({ isOpen: isOpen, onToggle: onToggle, sprint: sprint, plannedCapacity: plannedCapacity, plan: plan, KanbanFlyout: KanbanFlyout, ScrumFlyout: ScrumFlyout, children: children, teamObject: teamObject, isShowTimerangeInconsistent: isShowTimerangeInconsistent = false }) {
    // for scrum sprint, we don't display flyout for past sprints
    const isScrum = sprint.schedulingMode !== (0, $5rYNM.SCHEDULE_MODE).kanban;
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const flyoutProps = {
        sprint: sprint,
        plannedCapacity: plannedCapacity,
        teamObject: teamObject,
        plan: plan,
        onCloseIconClick: onToggle
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jpQDZ.default), {
        minLeft: viewport.position.left,
        isOpen: isOpen,
        renderDialog: (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                overflow: "visible",
                isOpen: true,
                onClose: onToggle,
                placement: "bottom-start",
                shouldFlip: true,
                closeOnScroll: true,
                minWidth: $96c9ba885d5a212e$var$DIALOG_MIN_WIDTH,
                content: isScrum ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ScrumFlyout, {
                    ...flyoutProps,
                    isShowTimerangeInconsistent: isShowTimerangeInconsistent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(KanbanFlyout, flyoutProps)
            }, element),
        renderTrigger: (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $ddVQP.toggle,
                tabIndex: 0,
                onClick: onToggle,
                onKeyDown: (e)=>e.key === 'Escape' && onToggle(),
                onMouseEnter: (0, $ltDM8.preloadFlyouts),
                role: "button",
                "data-testid": `portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprint-flyout.sprint-flyout-trigger.${teamObject && teamObject.id || ''}-${isScrum ? sprint.id || '' : sprint.startDate}`
            }, children)
    });
}
$96c9ba885d5a212e$var$SprintFlyout.defaultProps = {
    KanbanFlyout: (0, $ltDM8.AsyncKanbanFlyout),
    ScrumFlyout: (0, $ltDM8.AsyncScrumFlyout),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $96c9ba885d5a212e$export$2e2bcd8739ae039 = $96c9ba885d5a212e$var$SprintFlyout;

});
parcelRegister("ltDM8", function(module, exports) {

$parcel$export(module.exports, "AsyncScrumFlyout", () => $de7a08dfc47deaad$export$6ec4eeb54fe4bbee);
$parcel$export(module.exports, "AsyncKanbanFlyout", () => $de7a08dfc47deaad$export$f552c0d4ef25b739);
$parcel$export(module.exports, "preloadFlyouts", () => $de7a08dfc47deaad$export$c07fd8539d12f6a7);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ae4LH = parcelRequire("ae4LH");

var $gGtKh = parcelRequire("gGtKh");

const $de7a08dfc47deaad$var$lazyFlyout = ()=>(parcelRequire("3pM2R"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $de7a08dfc47deaad$var$LazyScrumFlyout = (0, $7rh0R.lazy)(()=>$de7a08dfc47deaad$var$lazyFlyout().then(({ ScrumFlyout: ScrumFlyout })=>ScrumFlyout), {
    ssr: false
});
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $de7a08dfc47deaad$var$LazyKanbanFlyout = (0, $7rh0R.lazy)(()=>$de7a08dfc47deaad$var$lazyFlyout().then(({ KanbanFlyout: KanbanFlyout })=>KanbanFlyout), {
    ssr: false
});
const $de7a08dfc47deaad$export$6ec4eeb54fe4bbee = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "scrum-flyout",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de7a08dfc47deaad$var$LazyScrumFlyout, props));
const $de7a08dfc47deaad$export$f552c0d4ef25b739 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "kanban-flyout",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de7a08dfc47deaad$var$LazyKanbanFlyout, props));
const $de7a08dfc47deaad$export$c07fd8539d12f6a7 = ()=>{
    $de7a08dfc47deaad$var$LazyScrumFlyout.preload();
    $de7a08dfc47deaad$var$LazyKanbanFlyout.preload();
};

});
parcelRegister("3pM2R", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lMuWd")),
            load('iDzsu')
        ]);
        const value = parcelRequire('iXe3A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("lMuWd")),
        load("iDzsu")
    ]).then(()=>parcelRequire('iXe3A'));
}

});


parcelRegister("ddVQP", function(module, exports) {

$parcel$export(module.exports, "toggle", () => $9a095d43ac27f652$export$e03c1c3201ee8bb7, (v) => $9a095d43ac27f652$export$e03c1c3201ee8bb7 = v);
var $9a095d43ac27f652$export$e03c1c3201ee8bb7;
$9a095d43ac27f652$export$e03c1c3201ee8bb7 = `VhGm0W_toggle`;

});



parcelRegister("2bJlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3a8b475552f200c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bY7iW = parcelRequire("bY7iW");

var $3JRZX = parcelRequire("3JRZX");
var $f3a8b475552f200c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bY7iW.default), {})((0, $3JRZX.default));

});
parcelRegister("bY7iW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ad4ccbc640687f8$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");
const $6ad4ccbc640687f8$var$mapStateToProps = (state)=>({
        timelineSettings: (0, $9H2AP.getTimeScaleViewSettings)(state)
    });
var $6ad4ccbc640687f8$export$2e2bcd8739ae039 = $6ad4ccbc640687f8$var$mapStateToProps;

});

parcelRegister("3JRZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4b86e8c63885bb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7tuto = parcelRequire("7tuto");
// JPO-20817 Specify our own tooltip CSS to add space between the cursor and the tooltip. This is so the tooltip doesn't block the sprint bar.
const $fc4b86e8c63885bb$var$CustomTooltipComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3tFP.default), {
        ...rest,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $7tuto.sprintTooltip
    }, children));
});
const $fc4b86e8c63885bb$var$TimelineSprintTooltip = ({ content: content, children: children, timelineSettings: timelineSettings })=>{
    // Only use mouse position on weeks mode as the bug most likely happens here
    if ((0, $7CnHa.isDefined)(timelineSettings) && timelineSettings.mode === (0, $5rYNM.ZOOM_LEVELS).WEEKS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "mouse",
        // Customize the tooltip style as per https://atlassian.design/components/tooltip/examples#customization
        component: $fc4b86e8c63885bb$var$CustomTooltipComponent,
        content: content,
        hideTooltipOnMouseDown: true
    }, children);
    // Otherwise, we use bottom position as it has better user experience
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "bottom",
        content: content,
        hideTooltipOnMouseDown: true
    }, children);
};
var $fc4b86e8c63885bb$export$2e2bcd8739ae039 = $fc4b86e8c63885bb$var$TimelineSprintTooltip;

});
parcelRegister("7tuto", function(module, exports) {

$parcel$export(module.exports, "sprintTooltip", () => $5712e123609a173e$export$e68357c14d268b6, (v) => $5712e123609a173e$export$e68357c14d268b6 = v);
var $5712e123609a173e$export$e68357c14d268b6;
$5712e123609a173e$export$e68357c14d268b6 = `BCIj2a_sprintTooltip`;

});



parcelRegister("gtLxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1226d461062b5c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4UWBa = parcelRequire("4UWBa");

var $g8DrJ = parcelRequire("g8DrJ");
function $f1226d461062b5c2$var$Capacity(props) {
    const { sprintId: sprintId, style: style, content: content, isUpdated: isUpdated } = props;
    return content && sprintId !== 'GAP' && sprintId !== 'PAST' ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: style
    }, isUpdated && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $g8DrJ.changeIndicator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), {
        appearance: "triangle"
    })), content) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: style
    });
}
var $f1226d461062b5c2$export$2e2bcd8739ae039 = $f1226d461062b5c2$var$Capacity;

});
parcelRegister("g8DrJ", function(module, exports) {

$parcel$export(module.exports, "changeIndicator", () => $bbfbfde9875d80e1$export$deafeb91a574091c, (v) => $bbfbfde9875d80e1$export$deafeb91a574091c = v);
var $bbfbfde9875d80e1$export$deafeb91a574091c;
$bbfbfde9875d80e1$export$deafeb91a574091c = `WZML7W_changeIndicator`;

});


parcelRegister("ap79s", function(module, exports) {

$parcel$export(module.exports, "default", () => $87588a332d179676$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $87588a332d179676$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssueSources: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.no-issue-sources",
        "defaultMessage": "Associate this team with an issue source to view sprints"
    },
    daysUnit: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.days-unit",
        "defaultMessage": "{count, plural, other {# d}}"
    },
    hoursUnit: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.capacities.hours-unit",
        "defaultMessage": "{count, plural, other {# h}}"
    }
});

});

parcelRegister("9pZlP", function(module, exports) {

$parcel$export(module.exports, "bar", () => $6db609e2dcc5e8be$export$d927737047eb3867, (v) => $6db609e2dcc5e8be$export$d927737047eb3867 = v);
$parcel$export(module.exports, "message", () => $6db609e2dcc5e8be$export$a8ecead220dd38a6, (v) => $6db609e2dcc5e8be$export$a8ecead220dd38a6 = v);
$parcel$export(module.exports, "okay", () => $6db609e2dcc5e8be$export$4ff774198978dac4, (v) => $6db609e2dcc5e8be$export$4ff774198978dac4 = v);
$parcel$export(module.exports, "overbooked", () => $6db609e2dcc5e8be$export$312c3ba826526246, (v) => $6db609e2dcc5e8be$export$312c3ba826526246 = v);
$parcel$export(module.exports, "sprintBox", () => $6db609e2dcc5e8be$export$f182c2c4b027a866, (v) => $6db609e2dcc5e8be$export$f182c2c4b027a866 = v);
$parcel$export(module.exports, "sprintLabels", () => $6db609e2dcc5e8be$export$23d7aa3ce101edc3, (v) => $6db609e2dcc5e8be$export$23d7aa3ce101edc3 = v);
$parcel$export(module.exports, "sprintName", () => $6db609e2dcc5e8be$export$2780111908128a1b, (v) => $6db609e2dcc5e8be$export$2780111908128a1b = v);
var $6db609e2dcc5e8be$export$c891bbacdf93fd6e;
var $6db609e2dcc5e8be$export$d927737047eb3867;
var $6db609e2dcc5e8be$export$70b46a68a5b6a9e0;
var $6db609e2dcc5e8be$export$38e6368cd28c04af;
var $6db609e2dcc5e8be$export$a8ecead220dd38a6;
var $6db609e2dcc5e8be$export$4ff774198978dac4;
var $6db609e2dcc5e8be$export$312c3ba826526246;
var $6db609e2dcc5e8be$export$196f532ad83e375c;
var $6db609e2dcc5e8be$export$f182c2c4b027a866;
var $6db609e2dcc5e8be$export$23d7aa3ce101edc3;
var $6db609e2dcc5e8be$export$2780111908128a1b;
$6db609e2dcc5e8be$export$c891bbacdf93fd6e = `_6YIzVa_activeSprint`;
$6db609e2dcc5e8be$export$d927737047eb3867 = `_6YIzVa_bar`;
$6db609e2dcc5e8be$export$70b46a68a5b6a9e0 = `_6YIzVa_closedSprint`;
$6db609e2dcc5e8be$export$38e6368cd28c04af = `_6YIzVa_inconsistent`;
$6db609e2dcc5e8be$export$a8ecead220dd38a6 = `_6YIzVa_message`;
$6db609e2dcc5e8be$export$4ff774198978dac4 = `_6YIzVa_okay`;
$6db609e2dcc5e8be$export$312c3ba826526246 = `_6YIzVa_overbooked`;
$6db609e2dcc5e8be$export$196f532ad83e375c = `_6YIzVa_pastSprint`;
$6db609e2dcc5e8be$export$f182c2c4b027a866 = `_6YIzVa_sprintBox`;
$6db609e2dcc5e8be$export$23d7aa3ce101edc3 = `_6YIzVa_sprintLabels`;
$6db609e2dcc5e8be$export$2780111908128a1b = `_6YIzVa_sprintName`;

});



parcelRegister("hn2Tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb46c86fdde2628$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g4Vkx = parcelRequire("g4Vkx");

var $jODJR = parcelRequire("jODJR");

var $lNNXV = parcelRequire("lNNXV");
parcelRequire("9kZCZ");
var $h0tKx = parcelRequire("h0tKx");

var $5Llbn = parcelRequire("5Llbn");

var $jfGWW = parcelRequire("jfGWW");
// @ts-expect-error - TS7006 - Parameter 'ownProps' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb46c86fdde2628$var$mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5eb46c86fdde2628$var$mapDispatchToProps = {};
const $5eb46c86fdde2628$var$Sprints = (0, $lNNXV.connect)((0, $5Llbn.default), $5eb46c86fdde2628$var$mapDispatchToProps, $5eb46c86fdde2628$var$mergeProps)((0, $jfGWW.default));
const $5eb46c86fdde2628$export$577a66ab76a07096 = ({ timelineRange: containerTimelineRange, ...rest })=>{
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [{ timelineRange: viewportTimelineRange }] = (0, $jODJR.useRenderingWindow)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), {
        bgColor: `var(--ds-surface, ${(0, $g4Vkx.default).N0})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            boxShadow: `0 -2px ${`var(--ds-shadow-raised, ${(0, $g4Vkx.default).N40})`}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5eb46c86fdde2628$var$Sprints, {
        ...rest,
        timelineRange: zoomLevel ? viewportTimelineRange : containerTimelineRange,
        zoomLevel: zoomLevel
    }));
};
var $5eb46c86fdde2628$export$2e2bcd8739ae039 = $5eb46c86fdde2628$export$577a66ab76a07096;

});
parcelRegister("5Llbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7718c6ce7f64a490$export$2e2bcd8739ae039);

var $7hbkF = parcelRequire("7hbkF");

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $MQRDu = parcelRequire("MQRDu");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $7718c6ce7f64a490$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    filteredIds: (state)=>(0, $7hbkF.getSprintFilter)(state).value,
    getStreamsUnits: (0, $c1XMU.getSprintStreamsUnitsGetter),
    plan: (0, $75KhQ.getPlan),
    showWarning: (state)=>(0, $9H2AP.getWarningViewSettings)(state).showWarning,
    sprintIdsWithDatesIsInconsistent: (0, $c1XMU.getSprintIdsWithDatesIsInconsistent),
    streams: (state, props)=>(0, $c1XMU.getSprintStreamsUnitsForTeams)(state)[props.team],
    teamObject: (state, props)=>(0, $MQRDu.getTeamsById)(state)[props.team]
});

});

parcelRegister("jfGWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4410369efad434f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dulT0 = parcelRequire("dulT0");
var $17L5s = parcelRequire("17L5s");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("9kZCZ");
var $h0tKx = parcelRequire("h0tKx");

var $ecMHe = parcelRequire("ecMHe");
parcelRequire("2Awyc");
var $iaKOO = parcelRequire("iaKOO");

var $g863P = parcelRequire("g863P");

var $5tzXw = parcelRequire("5tzXw");
const $4410369efad434f6$var$Sprints = ({ plan: plan, sprintIdsWithDatesIsInconsistent: sprintIdsWithDatesIsInconsistent = [], filteredIds: filteredIds, showWarning: showWarning, teamObject: teamObject, streams: streams, timelineRange: timelineRange, getStreamsUnits: getStreamsUnits, zoomLevel: zoomLevel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!(0, $7CnHa.isDefined)(teamObject)) return null;
    const { issueSource: issueSource, schedulingMode: schedulingMode, id: id } = teamObject;
    if (!(0, $7CnHa.isDefined)(issueSource)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaKOO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $5tzXw.message
    }, formatMessage((0, $5rYNM.SCHEDULE_MODE).scrum === schedulingMode ? (0, $ecMHe.default).noIssueSourcesScrumTeam : (0, $ecMHe.default).noIssueSourcesKanbanTeam)));
    const isSprintFiltered = (sprint)=>!!filteredIds.length && !filteredIds.includes(sprint.id);
    // a sprint A is contiguous with a next sprint B if:
    // - sprint A is not the last sprint of the stream; AND
    // - sprint B is not a gap; AND
    // - sprint B is not filtered out; AND
    // - sprint A ends on the same day that sprint B starts
    const isSprintContiguousWithNextSprint = (sprint, index, stream)=>index < stream.length - 1 && stream[index + 1].id !== 'GAP' && !isSprintFiltered(stream[index + 1]) && (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(sprint.rawEndDate || sprint.endDate), (0, $17L5s.startOfUtcDay)(stream[index + 1].rawStartDate || stream[index + 1].startDate));
    const renderStream = (stream, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-name": `team-${teamObject && teamObject.id || ''}-sprint-stream-${index}`,
            key: index,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $5tzXw.sprintLabels
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        stream.map((sprint, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g863P.default), {
                isContiguousWithNextSprint: isSprintContiguousWithNextSprint(sprint, index, stream),
                isFiltered: isSprintFiltered(sprint),
                isInconsistent: sprintIdsWithDatesIsInconsistent.indexOf(sprint.id) > -1,
                key: `${sprint.startDate}-${sprint.endDate}`,
                plan: plan,
                showWarning: showWarning,
                sprint: sprint,
                teamObject: teamObject,
                zoomLevel: zoomLevel
            })));
    const sprintTableRow = (getStreamsUnits ? getStreamsUnits(timelineRange, teamObject) : streams).map(renderStream);
    return zoomLevel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0tKx.default), {
        testId: `team-${id}-sprint-header-row`
    }, sprintTableRow) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, sprintTableRow);
};
var $4410369efad434f6$export$2e2bcd8739ae039 = $4410369efad434f6$var$Sprints;

});
parcelRegister("ecMHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e295b99e20a86bc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6e295b99e20a86bc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssueSourcesScrumTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-scrum-team",
        "defaultMessage": "Associate this team with an issue source to view its sprints"
    },
    noIssueSourcesKanbanTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.no-issue-sources-kanban-team",
        "defaultMessage": "Associate this team with an issue source to view its iterations"
    }
});

});

parcelRegister("2Awyc", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("iaKOO")).default);

var $iaKOO = parcelRequire("iaKOO");

});
parcelRegister("iaKOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cce6a3e448ee5a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");
parcelRequire("3dOx1");
var $cxEeq = parcelRequire("cxEeq");
function $6cce6a3e448ee5a2$var$useFixedContainer() {
    const elRef = (0, $eUqFw.useRef)(null);
    const { sticky: sticky } = (0, $eUqFw.useContext)((0, $cxEeq.context));
    const [{ zoomLevel: zoomLevel, viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ msToPx: msToPx }] = (0, $jODJR.useTimelineRuler)();
    (0, $eUqFw.useEffect)(()=>{
        const el = elRef.current;
        if (el == null) return;
        el.style.left = `${msToPx(viewport.offset)}px`;
    }, [
        sticky,
        zoomLevel,
        msToPx,
        viewport.offset
    ]);
    return elRef;
}
function $6cce6a3e448ee5a2$export$2e2bcd8739ae039({ children: children }) {
    const containerRef = $6cce6a3e448ee5a2$var$useFixedContainer();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        style: {
            position: 'absolute'
        },
        ref: containerRef
    }, children));
}

});


parcelRegister("g863P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ee9257a4c36b7f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");

var $lNNXV = parcelRequire("lNNXV");

var $1ir3Z = parcelRequire("1ir3Z");

var $2gQm7 = parcelRequire("2gQm7");

var $dj7jt = parcelRequire("dj7jt");
const $f3ee9257a4c36b7f$var$Sprint = (0, $lNNXV.connect)((0, $1ir3Z.default), {})((0, $dj7jt.default));
const $f3ee9257a4c36b7f$var$SprintWithHorizontalScrolling = ({ sprint: sprint, ...rest })=>{
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const [extraProps] = (0, $jODJR.useHorizontalPercentageOffset)();
    const memoedSprint = (0, $2gQm7.useMemoedSprint)(sprint, zoomLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3ee9257a4c36b7f$var$Sprint, {
        ...rest,
        ...extraProps,
        zoomLevel: zoomLevel,
        sprint: memoedSprint
    });
};
var $f3ee9257a4c36b7f$export$2e2bcd8739ae039 = $f3ee9257a4c36b7f$var$SprintWithHorizontalScrolling;

});
parcelRegister("1ir3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a06abf4ed9ece3$export$2e2bcd8739ae039);

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $08a06abf4ed9ece3$var$getPlannedCapacity = (state, { sprint: sprint, teamObject: teamObject })=>{
    if (!teamObject) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $c1XMU.getCapacityForTeamAndIteration)(state, {
        teamId: teamObject.id,
        iterationId: teamObject.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum ? sprint.id : `${sprint.startDate}`
    });
};
const $08a06abf4ed9ece3$var$getOriginalPlannedCapacity = (state, { sprint: sprint, teamObject: teamObject })=>{
    if (!teamObject) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $c1XMU.getOriginalCapacityForTeamAndIteration)(state, {
        teamId: teamObject.id,
        iterationId: teamObject.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum ? sprint.id : `${sprint.startDate}`
    });
};
const $08a06abf4ed9ece3$export$346d4c5769125fa2 = (scenarioPlannedCapacity, originalPlannedCapacity, timelineRange, workingHours)=>({
        isUpdated: !!originalPlannedCapacity,
        plannedCapacity: scenarioPlannedCapacity,
        timelineRange: timelineRange,
        workingHours: workingHours
    });
var $08a06abf4ed9ece3$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    $08a06abf4ed9ece3$var$getPlannedCapacity,
    $08a06abf4ed9ece3$var$getOriginalPlannedCapacity,
    (0, $aMoMC.getTimelineRange),
    (0, $dhHiZ.getJiraHoursPerDay)
], $08a06abf4ed9ece3$export$346d4c5769125fa2);

});

parcelRegister("2gQm7", function(module, exports) {

$parcel$export(module.exports, "useMemoedSprint", () => $ee38e4fd8ee35df7$export$a8dedf5af7d6dbf3);

var $eUqFw = parcelRequire("eUqFw");

var $1OuJn = parcelRequire("1OuJn");

var $jL9rh = parcelRequire("jL9rh");
const $ee38e4fd8ee35df7$var$omitWidth = (0, (/*@__PURE__*/$parcel$interopDefault($jL9rh)))([
    'widthPercentage'
]);
function $ee38e4fd8ee35df7$export$a8dedf5af7d6dbf3(sprint, zoomLevel) {
    const sprintRef = (0, $eUqFw.useRef)(sprint);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1OuJn)))($ee38e4fd8ee35df7$var$omitWidth(sprintRef.current), $ee38e4fd8ee35df7$var$omitWidth(sprint)) || !zoomLevel) sprintRef.current = sprint;
    return sprintRef.current;
}

});
parcelRegister("jL9rh", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $e629ba84c4a07001$var$func = $jFIrw('omit', (parcelRequire("kFGm5")));

$e629ba84c4a07001$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $e629ba84c4a07001$var$func;

});


parcelRegister("dj7jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $228c64ffd82d7739$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $5YsMl = parcelRequire("5YsMl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $17L5s = parcelRequire("17L5s");
var $fmBR7 = parcelRequire("fmBR7");
parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");

var $cuxq0 = parcelRequire("cuxq0");
parcelRequire("5mvr3");
var $a4NMN = parcelRequire("a4NMN");

var $i1IpU = parcelRequire("i1IpU");

var $4UWBa = parcelRequire("4UWBa");

var $5rYNM = parcelRequire("5rYNM");

var $7dxZy = parcelRequire("7dxZy");

var $bUpYS = parcelRequire("bUpYS");
const $228c64ffd82d7739$var$Sprint = ({ getPercentageOffsetFromToday: getPercentageOffsetFromToday, isContiguousWithNextSprint: isContiguousWithNextSprint = false, isFiltered: isFiltered, isInconsistent: isInconsistent, isUpdated: isUpdated, plan: plan, plannedCapacity: plannedCapacity, showWarning: showWarning, sprint: sprint, teamObject: teamObject, timelineRange: timelineRange, workingHours: workingHours, zoomLevel: zoomLevel })=>{
    const isHorizontalScrolling = zoomLevel;
    const intl = (0, $5JgJ2.default)();
    const [state, setState] = (0, $eUqFw.useState)({
        open: false,
        isBarHovered: false
    });
    if (isFiltered === true) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bUpYS.filtered,
        style: {
            width: `${sprint.widthPercentage}%`
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const toggleFlyout = ()=>setState((state)=>({
                ...state,
                open: !state.open
            }));
    const isKanban = sprint.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban;
    const getLabel = (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i1IpU.default), {
            key: `sprint_unit_index_${sprint.startDate}`,
            gap: sprint.id === 'GAP',
            label: label,
            noMarker: false,
            widthPercentage: 100
        });
    const getDashedSprintName = ()=>sprint.label.display.replace(/\s/g, '-');
    const getFlyoutLabelAndContent = ()=>{
        const { planningUnit: planningUnit } = plan;
        const { usedCapacity: usedCapacity = 0, schedulingMode: schedulingMode } = sprint;
        const availableCapacity = plannedCapacity ? plannedCapacity.capacity || 0 : sprint.availableCapacity || 0;
        const isPast = sprint.id === 'PAST';
        const isScrum = schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum;
        let displayUsedCapacity = usedCapacity;
        let displayAvailableCapacity = availableCapacity;
        if (usedCapacity > 0 && availableCapacity === 0) {
            displayUsedCapacity = 1;
            displayAvailableCapacity = 1;
        } else if (usedCapacity === 0 && availableCapacity === 0) {
            displayUsedCapacity = 0;
            displayAvailableCapacity = 1;
        }
        const convertedUsedCapacity = (0, $a4NMN.convertCapacityByPlanningUnit)({
            capacity: usedCapacity || 0,
            planningUnit: planningUnit,
            workingHours: workingHours
        });
        const convertedAvailableCapacity = (0, $a4NMN.convertCapacityByPlanningUnit)({
            capacity: availableCapacity || 0,
            planningUnit: planningUnit,
            workingHours: workingHours
        });
        const displayTitle = (()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            let displayTitle = sprint.label.display;
            if (isKanban) switch(planningUnit){
                case (0, $5rYNM.PLANNING_UNITS).DAYS:
                case (0, $5rYNM.PLANNING_UNITS).HOURS:
                    displayTitle = `${convertedUsedCapacity || 0}/${convertedAvailableCapacity || 0}`;
                    break;
                default:
            }
            else if (isPast) displayTitle = intl.formatMessage((0, $7dxZy.default).pastSprint);
            else if (sprint.id === 'FUTURE') displayTitle = intl.formatMessage((0, $7dxZy.default).futureProjectedSprint);
            else displayTitle = sprint.label.display;
            return displayTitle;
        })();
        const display = (()=>{
            let capacity;
            switch(planningUnit){
                case (0, $5rYNM.PLANNING_UNITS).DAYS:
                case (0, $5rYNM.PLANNING_UNITS).HOURS:
                    capacity = intl.formatMessage((0, $7dxZy.default).activeUnitSprint, {
                        unit: intl.formatMessage(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        (0, $7dxZy.default)[planningUnit.toLowerCase()], {
                            used: convertedUsedCapacity,
                            available: convertedAvailableCapacity
                        })
                    });
                    break;
                default:
                    capacity = intl.formatMessage((0, $7dxZy.default).activePointsSprint, {
                        used: usedCapacity,
                        available: availableCapacity
                    });
            }
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bUpYS.sprintTooltip
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, !isKanban && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, displayTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)), (0, $a4NMN.formatDateRange)(intl, sprint.rawStartDate || sprint.startDate || 0, sprint.rawEndDate || sprint.endDate || 0)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
                style: {
                    // TODO Delete this comment after verifying space token -> previous value `6`
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    marginTop: "var(--ds-space-075, 6px)"
                }
            }, capacity)));
        })();
        const labelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($bUpYS.sprintBox, {
            [$bUpYS.overbooked]: usedCapacity > availableCapacity,
            [$bUpYS.inconsistent]: isInconsistent && showWarning,
            [$bUpYS.pastSprint]: isScrum && isPast,
            [$bUpYS.closedSprint]: sprint.state === (0, $5rYNM.SPRINT_STATES).CLOSED,
            [$bUpYS.activeSprint]: !(usedCapacity > availableCapacity) && sprint.state === (0, $5rYNM.SPRINT_STATES).ACTIVE,
            [$bUpYS.isContiguousWithNextSprint]: !state.isBarHovered && isContiguousWithNextSprint
        });
        const content = (()=>{
            if (sprint.id === 'GAP') return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmBR7.default), {
                onHoverChanged: (hover)=>setState({
                        ...state,
                        isBarHovered: hover
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bUpYS.sprintBoxWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: labelClasses
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bUpYS.bar
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": `sprint-capacity-bar-${getDashedSprintName()}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: usedCapacity > availableCapacity ? $bUpYS.overbooked : $bUpYS.okay,
                style: {
                    height: `${Math.min(100, 100 * displayUsedCapacity / displayAvailableCapacity)}%`
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bUpYS.sprintName
            }, displayTitle), isInconsistent && showWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                label: "",
                primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
            }) : null)));
        })();
        return {
            content: content,
            display: display
        };
    };
    const label = getFlyoutLabelAndContent();
    // for scrum sprint, we don't display flyout for past sprints
    const ifShowScrumFlyout = sprint.schedulingMode !== (0, $5rYNM.SCHEDULE_MODE).kanban && sprint.id !== 'GAP' && sprint.id !== 'PAST';
    // for kanban iteration, we will show the flyout for all iterations
    const ifShowKanbanFlyout = isKanban && sprint.id !== 'GAP';
    const calcWidthPercentage = (start, end, timeline)=>{
        const unitLength = Math.min(timeline.end, end) - Math.max(timeline.start, start);
        const rangeLength = timeline.end - timeline.start;
        return 100 * unitLength / rangeLength;
    };
    const style = isHorizontalScrolling && getPercentageOffsetFromToday ? {
        width: `${getPercentageOffsetFromToday((0, $17L5s.endOfUtcDay)(sprint.rawEndDate || sprint.endDate) - (!state.isBarHovered && isContiguousWithNextSprint ? (0, $17L5s.ONE_DAY) : 0)) - getPercentageOffsetFromToday((0, $17L5s.startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
        left: `${getPercentageOffsetFromToday((0, $17L5s.startOfUtcDay)(sprint.rawStartDate || sprint.startDate))}%`,
        position: 'absolute',
        transition: 'width 0.1s ease-in-out 0s',
        animation: '0.2s ease-in-out',
        ...state.isBarHovered && {
            zIndex: '1'
        }
    } : {
        width: `${calcWidthPercentage((0, $17L5s.startOfUtcDay)(sprint.rawStartDate || sprint.startDate), (0, $17L5s.endOfUtcDay)(sprint.rawEndDate || sprint.endDate) - (!state.isBarHovered && isContiguousWithNextSprint ? (0, $17L5s.ONE_DAY) : 0), timelineRange)}%`,
        position: 'absolute',
        left: `${sprint.offset}%`,
        transition: 'width 0.1s ease-in-out 0s',
        animation: '0.2s ease-in-out',
        ...state.isBarHovered && {
            zIndex: '1'
        }
    };
    const sprintLabel = getLabel(label);
    if (ifShowScrumFlyout || ifShowKanbanFlyout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-name": `sprint-header-${getDashedSprintName()}`,
        "data-testid": `sprint-header-${sprint.state}-${sprint.schedulingMode || ''}-${sprint.startDate}`
    }, isUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bUpYS.changeIndicator,
        style: {
            // TODO Delete this comment after verifying space token -> previous value `'2px'`
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: "var(--ds-space-025, 2px)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4UWBa.default), {
        appearance: "triangle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cuxq0.default), {
        isOpen: state.open,
        onToggle: toggleFlyout,
        sprint: sprint,
        plannedCapacity: plannedCapacity,
        teamObject: teamObject,
        plan: plan,
        isShowTimerangeInconsistent: isInconsistent && showWarning
    }, sprintLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-name": `sprint-header-${getDashedSprintName()}`,
        "data-testid": `sprint-header-${sprint.state}-${sprint.schedulingMode || ''}-${sprint.startDate}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, sprintLabel);
};
var $228c64ffd82d7739$export$2e2bcd8739ae039 = $228c64ffd82d7739$var$Sprint;

});
parcelRegister("5mvr3", function(module, exports) {

$parcel$export(module.exports, "getSprintType", () => $fa47c59374a94daa$export$ab9da287d8e75063);
$parcel$export(module.exports, "generateSprintUrl", () => $fa47c59374a94daa$export$b410861f57e759e0);
$parcel$export(module.exports, "generateSprintReportURL", () => $fa47c59374a94daa$export$2422af7cea3b8e6b);
$parcel$export(module.exports, "formatDateRange", () => (parcelRequire("a4NMN")).formatDateRange);
$parcel$export(module.exports, "formatSprintUTCTime", () => (parcelRequire("a4NMN")).formatSprintUTCTime);
$parcel$export(module.exports, "getLozengeContent", () => (parcelRequire("a4NMN")).getLozengeContent);
$parcel$export(module.exports, "getLozengeAppearance", () => (parcelRequire("a4NMN")).getLozengeAppearance);
/**
 * Common utils needed for sprint flyouts
 */ 
var $64VaH = parcelRequire("64VaH");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("cdMJv");
parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");
const $fa47c59374a94daa$export$ab9da287d8e75063 = (sprint)=>{
    switch(sprint.state){
        case (0, $5rYNM.SPRINT_STATES).ACTIVE:
        case (0, $5rYNM.SPRINT_STATES).CLOSED:
            return sprint.state;
        case (0, $5rYNM.SPRINT_STATES).FUTURE:
            return sprint.id === 'FUTURE' ? 'PROJECTED' : 'FUTURE';
        default:
            return sprint.state;
    }
};
const $fa47c59374a94daa$export$b410861f57e759e0 = ({ boardId: boardId, state: state, id: id, reportType: reportType })=>{
    let url = (0, $64VaH.proxyContextSafeUrl)(`/secure/RapidBoard.jspa?rapidView=${boardId}`);
    if (reportType === 'DISABLED') return undefined;
    if (state === (0, $5rYNM.SPRINT_STATES).CLOSED) {
        if (reportType === 'USE_REPORTS') url += `&view=reporting&report=burnup&sprint=${id}`;
        else url += `&view=reporting&chart=sprintRetrospective&sprint=${id}`;
    } else if (state === (0, $5rYNM.SPRINT_STATES).FUTURE) url += '&view=planning';
    return url;
};
const $fa47c59374a94daa$export$2422af7cea3b8e6b = ({ boardId: boardId, reportType: reportType })=>{
    // Disable 'Velocity Insights' link if sprint doesn't contain boardId
    if (!(0, $7CnHa.isDefined)(boardId) || reportType === 'DISABLED') return undefined;
    if (reportType === 'USE_REPORTS') return (0, $64VaH.proxyContextSafeUrl)(`/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&report=velocity`);
    return (0, $64VaH.proxyContextSafeUrl)(`/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=velocityChart`);
};

});
parcelRegister("cdMJv", function(module, exports) {

$parcel$export(module.exports, "closeFlyout", () => $8e5c8048769f1d15$export$7670f8956d89067d, (v) => $8e5c8048769f1d15$export$7670f8956d89067d = v);
$parcel$export(module.exports, "editorIconFix", () => $8e5c8048769f1d15$export$30db2273d2787c4, (v) => $8e5c8048769f1d15$export$30db2273d2787c4 = v);
$parcel$export(module.exports, "flyout", () => $8e5c8048769f1d15$export$ec4922be16378791, (v) => $8e5c8048769f1d15$export$ec4922be16378791 = v);
$parcel$export(module.exports, "goalWrapper", () => $8e5c8048769f1d15$export$df51840520fb471b, (v) => $8e5c8048769f1d15$export$df51840520fb471b = v);
$parcel$export(module.exports, "issuesWithoutSprint", () => $8e5c8048769f1d15$export$fa26aea257b4f7a2, (v) => $8e5c8048769f1d15$export$fa26aea257b4f7a2 = v);
$parcel$export(module.exports, "issuesWithoutSprintInfoTooltip", () => $8e5c8048769f1d15$export$ced42e5ce527f616, (v) => $8e5c8048769f1d15$export$ced42e5ce527f616 = v);
$parcel$export(module.exports, "issuesWithoutSprintLabel", () => $8e5c8048769f1d15$export$7c1df3b882af0d90, (v) => $8e5c8048769f1d15$export$7c1df3b882af0d90 = v);
$parcel$export(module.exports, "percentage", () => $8e5c8048769f1d15$export$a3560dfa62c7efe0, (v) => $8e5c8048769f1d15$export$a3560dfa62c7efe0 = v);
$parcel$export(module.exports, "plannedCapacityContainer", () => $8e5c8048769f1d15$export$2f9970f6397f2f65, (v) => $8e5c8048769f1d15$export$2f9970f6397f2f65 = v);
$parcel$export(module.exports, "plannedCapacityContainerReadOnly", () => $8e5c8048769f1d15$export$2ac860d058d12c0b, (v) => $8e5c8048769f1d15$export$2ac860d058d12c0b = v);
$parcel$export(module.exports, "plannedCapacityInlineEdit", () => $8e5c8048769f1d15$export$a274ec97a023a33d, (v) => $8e5c8048769f1d15$export$a274ec97a023a33d = v);
$parcel$export(module.exports, "plannedCapacityInlineEditReadView", () => $8e5c8048769f1d15$export$c6cc704aee597cc5, (v) => $8e5c8048769f1d15$export$c6cc704aee597cc5 = v);
$parcel$export(module.exports, "plannedCapacityInputWrapper", () => $8e5c8048769f1d15$export$2c6c490d4acf3a0a, (v) => $8e5c8048769f1d15$export$2c6c490d4acf3a0a = v);
$parcel$export(module.exports, "plannedCapacityLabel", () => $8e5c8048769f1d15$export$20bc53a7f951a356, (v) => $8e5c8048769f1d15$export$20bc53a7f951a356 = v);
$parcel$export(module.exports, "segment", () => $8e5c8048769f1d15$export$6519c25590136c5e, (v) => $8e5c8048769f1d15$export$6519c25590136c5e = v);
$parcel$export(module.exports, "segmentIcon", () => $8e5c8048769f1d15$export$5b924c7501773066, (v) => $8e5c8048769f1d15$export$5b924c7501773066 = v);
$parcel$export(module.exports, "sprintCapacityContainer", () => $8e5c8048769f1d15$export$d2cbbaba9ff86d32, (v) => $8e5c8048769f1d15$export$d2cbbaba9ff86d32 = v);
$parcel$export(module.exports, "sprintDates", () => $8e5c8048769f1d15$export$a1bb37a29f19da2d, (v) => $8e5c8048769f1d15$export$a1bb37a29f19da2d = v);
$parcel$export(module.exports, "sprintDatesDetail", () => $8e5c8048769f1d15$export$b8abf023c329a462, (v) => $8e5c8048769f1d15$export$b8abf023c329a462 = v);
$parcel$export(module.exports, "sprintDatesWrapper", () => $8e5c8048769f1d15$export$12629c87a3271d75, (v) => $8e5c8048769f1d15$export$12629c87a3271d75 = v);
$parcel$export(module.exports, "sprintEndDate", () => $8e5c8048769f1d15$export$57fc5a5bd99912ca, (v) => $8e5c8048769f1d15$export$57fc5a5bd99912ca = v);
$parcel$export(module.exports, "sprintFlyoutHeader", () => $8e5c8048769f1d15$export$4e0e3d7cb9aa0208, (v) => $8e5c8048769f1d15$export$4e0e3d7cb9aa0208 = v);
$parcel$export(module.exports, "sprintFlyoutHeaderWarningMessage", () => $8e5c8048769f1d15$export$59b6caf6520c0ce9, (v) => $8e5c8048769f1d15$export$59b6caf6520c0ce9 = v);
$parcel$export(module.exports, "sprintFlyoutHeaderWrapper", () => $8e5c8048769f1d15$export$7f1c79ab4d868188, (v) => $8e5c8048769f1d15$export$7f1c79ab4d868188 = v);
$parcel$export(module.exports, "sprintFlyoutHeaderWrapperFutureSprint", () => $8e5c8048769f1d15$export$4c44bd6d75a10dc6, (v) => $8e5c8048769f1d15$export$4c44bd6d75a10dc6 = v);
$parcel$export(module.exports, "sprintGoal", () => $8e5c8048769f1d15$export$70da4612f72666ac, (v) => $8e5c8048769f1d15$export$70da4612f72666ac = v);
$parcel$export(module.exports, "sprintStartDate", () => $8e5c8048769f1d15$export$ab7197a784e7bd90, (v) => $8e5c8048769f1d15$export$ab7197a784e7bd90 = v);
$parcel$export(module.exports, "sprintStatus", () => $8e5c8048769f1d15$export$1187a643a89c5844, (v) => $8e5c8048769f1d15$export$1187a643a89c5844 = v);
$parcel$export(module.exports, "sprintTitleWrapper", () => $8e5c8048769f1d15$export$952a6f3a543a5c5e, (v) => $8e5c8048769f1d15$export$952a6f3a543a5c5e = v);
$parcel$export(module.exports, "statusBreakdown", () => $8e5c8048769f1d15$export$db60df6b327bf6bf, (v) => $8e5c8048769f1d15$export$db60df6b327bf6bf = v);
$parcel$export(module.exports, "subtitle", () => $8e5c8048769f1d15$export$c96745152eb2740f, (v) => $8e5c8048769f1d15$export$c96745152eb2740f = v);
$parcel$export(module.exports, "title", () => $8e5c8048769f1d15$export$fb184b623420d9be, (v) => $8e5c8048769f1d15$export$fb184b623420d9be = v);
$parcel$export(module.exports, "unestimatedIssues", () => $8e5c8048769f1d15$export$7309a5103f0a7d82, (v) => $8e5c8048769f1d15$export$7309a5103f0a7d82 = v);
$parcel$export(module.exports, "usedCapacity", () => $8e5c8048769f1d15$export$99d218bf8c04a4a7, (v) => $8e5c8048769f1d15$export$99d218bf8c04a4a7 = v);
$parcel$export(module.exports, "velocityRow", () => $8e5c8048769f1d15$export$e748fe8ce8f38c69, (v) => $8e5c8048769f1d15$export$e748fe8ce8f38c69 = v);
$parcel$export(module.exports, "warningMessageWrapper", () => $8e5c8048769f1d15$export$1798603e7cbf9ca6, (v) => $8e5c8048769f1d15$export$1798603e7cbf9ca6 = v);
var $8e5c8048769f1d15$export$7670f8956d89067d;
var $8e5c8048769f1d15$export$30db2273d2787c4;
var $8e5c8048769f1d15$export$ec4922be16378791;
var $8e5c8048769f1d15$export$df51840520fb471b;
var $8e5c8048769f1d15$export$fa26aea257b4f7a2;
var $8e5c8048769f1d15$export$ced42e5ce527f616;
var $8e5c8048769f1d15$export$7c1df3b882af0d90;
var $8e5c8048769f1d15$export$a3560dfa62c7efe0;
var $8e5c8048769f1d15$export$2f9970f6397f2f65;
var $8e5c8048769f1d15$export$2ac860d058d12c0b;
var $8e5c8048769f1d15$export$a274ec97a023a33d;
var $8e5c8048769f1d15$export$c6cc704aee597cc5;
var $8e5c8048769f1d15$export$2c6c490d4acf3a0a;
var $8e5c8048769f1d15$export$20bc53a7f951a356;
var $8e5c8048769f1d15$export$6519c25590136c5e;
var $8e5c8048769f1d15$export$5b924c7501773066;
var $8e5c8048769f1d15$export$d2cbbaba9ff86d32;
var $8e5c8048769f1d15$export$a1bb37a29f19da2d;
var $8e5c8048769f1d15$export$b8abf023c329a462;
var $8e5c8048769f1d15$export$12629c87a3271d75;
var $8e5c8048769f1d15$export$57fc5a5bd99912ca;
var $8e5c8048769f1d15$export$4e0e3d7cb9aa0208;
var $8e5c8048769f1d15$export$59b6caf6520c0ce9;
var $8e5c8048769f1d15$export$7f1c79ab4d868188;
var $8e5c8048769f1d15$export$4c44bd6d75a10dc6;
var $8e5c8048769f1d15$export$70da4612f72666ac;
var $8e5c8048769f1d15$export$ab7197a784e7bd90;
var $8e5c8048769f1d15$export$1187a643a89c5844;
var $8e5c8048769f1d15$export$952a6f3a543a5c5e;
var $8e5c8048769f1d15$export$db60df6b327bf6bf;
var $8e5c8048769f1d15$export$c96745152eb2740f;
var $8e5c8048769f1d15$export$fb184b623420d9be;
var $8e5c8048769f1d15$export$7309a5103f0a7d82;
var $8e5c8048769f1d15$export$99d218bf8c04a4a7;
var $8e5c8048769f1d15$export$e748fe8ce8f38c69;
var $8e5c8048769f1d15$export$1798603e7cbf9ca6;
$8e5c8048769f1d15$export$7670f8956d89067d = `mBUB8q_closeFlyout`;
$8e5c8048769f1d15$export$30db2273d2787c4 = `mBUB8q_editorIconFix`;
$8e5c8048769f1d15$export$ec4922be16378791 = `mBUB8q_flyout`;
$8e5c8048769f1d15$export$df51840520fb471b = `mBUB8q_goalWrapper`;
$8e5c8048769f1d15$export$fa26aea257b4f7a2 = `mBUB8q_issuesWithoutSprint`;
$8e5c8048769f1d15$export$ced42e5ce527f616 = `mBUB8q_issuesWithoutSprintInfoTooltip`;
$8e5c8048769f1d15$export$7c1df3b882af0d90 = `mBUB8q_issuesWithoutSprintLabel`;
$8e5c8048769f1d15$export$a3560dfa62c7efe0 = `mBUB8q_percentage`;
$8e5c8048769f1d15$export$2f9970f6397f2f65 = `mBUB8q_plannedCapacityContainer`;
$8e5c8048769f1d15$export$2ac860d058d12c0b = `mBUB8q_plannedCapacityContainerReadOnly`;
$8e5c8048769f1d15$export$a274ec97a023a33d = `mBUB8q_plannedCapacityInlineEdit`;
$8e5c8048769f1d15$export$c6cc704aee597cc5 = `mBUB8q_plannedCapacityInlineEditReadView`;
$8e5c8048769f1d15$export$2c6c490d4acf3a0a = `mBUB8q_plannedCapacityInputWrapper`;
$8e5c8048769f1d15$export$20bc53a7f951a356 = `mBUB8q_plannedCapacityLabel`;
$8e5c8048769f1d15$export$6519c25590136c5e = `mBUB8q_segment`;
$8e5c8048769f1d15$export$5b924c7501773066 = `mBUB8q_segmentIcon`;
$8e5c8048769f1d15$export$d2cbbaba9ff86d32 = `mBUB8q_sprintCapacityContainer`;
$8e5c8048769f1d15$export$a1bb37a29f19da2d = `mBUB8q_sprintDates`;
$8e5c8048769f1d15$export$b8abf023c329a462 = `mBUB8q_sprintDatesDetail`;
$8e5c8048769f1d15$export$12629c87a3271d75 = `mBUB8q_sprintDatesWrapper`;
$8e5c8048769f1d15$export$57fc5a5bd99912ca = `mBUB8q_sprintEndDate`;
$8e5c8048769f1d15$export$4e0e3d7cb9aa0208 = `mBUB8q_sprintFlyoutHeader`;
$8e5c8048769f1d15$export$59b6caf6520c0ce9 = `mBUB8q_sprintFlyoutHeaderWarningMessage`;
$8e5c8048769f1d15$export$7f1c79ab4d868188 = `mBUB8q_sprintFlyoutHeaderWrapper`;
$8e5c8048769f1d15$export$4c44bd6d75a10dc6 = `mBUB8q_sprintFlyoutHeaderWrapperFutureSprint`;
$8e5c8048769f1d15$export$70da4612f72666ac = `mBUB8q_sprintGoal`;
$8e5c8048769f1d15$export$ab7197a784e7bd90 = `mBUB8q_sprintStartDate`;
$8e5c8048769f1d15$export$1187a643a89c5844 = `mBUB8q_sprintStatus`;
$8e5c8048769f1d15$export$952a6f3a543a5c5e = `mBUB8q_sprintTitleWrapper`;
$8e5c8048769f1d15$export$db60df6b327bf6bf = `mBUB8q_statusBreakdown`;
$8e5c8048769f1d15$export$c96745152eb2740f = `mBUB8q_subtitle`;
$8e5c8048769f1d15$export$fb184b623420d9be = `mBUB8q_title`;
$8e5c8048769f1d15$export$7309a5103f0a7d82 = `mBUB8q_unestimatedIssues`;
$8e5c8048769f1d15$export$99d218bf8c04a4a7 = `mBUB8q_usedCapacity`;
$8e5c8048769f1d15$export$e748fe8ce8f38c69 = `mBUB8q_velocityRow`;
$8e5c8048769f1d15$export$1798603e7cbf9ca6 = `mBUB8q_warningMessageWrapper`;

});


parcelRegister("i1IpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da6949b74a07bf3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2bJlS = parcelRequire("2bJlS");

var $eJuGU = parcelRequire("eJuGU");
function $7da6949b74a07bf3$export$2e2bcd8739ae039(props) {
    const { widthPercentage: widthPercentage, label: label, noMarker: noMarker, gap: gap } = props;
    let { content: content, display: display } = label;
    if (gap === true) // gap is filled with space b/c inline-block div w/o content breaks layout in Safari
    // and using float:left instead of inline-block breaks no-wrap effect of the parent
    display = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "\xa0");
    content = content || // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $eJuGU.innerContent
    }, noMarker === true ? null : display);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.unit",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $eJuGU.unit,
        style: {
            width: `${widthPercentage}%`
        }
    }, gap === true ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bJlS.default), {
        content: display
    }, content));
}

});
parcelRegister("eJuGU", function(module, exports) {

$parcel$export(module.exports, "innerContent", () => $ab9d13407166d715$export$dc0b7d7489259dc8, (v) => $ab9d13407166d715$export$dc0b7d7489259dc8 = v);
$parcel$export(module.exports, "unit", () => $ab9d13407166d715$export$523c0b569236b342, (v) => $ab9d13407166d715$export$523c0b569236b342 = v);
var $ab9d13407166d715$export$dc0b7d7489259dc8;
var $ab9d13407166d715$export$523c0b569236b342;
$ab9d13407166d715$export$dc0b7d7489259dc8 = `FP9-Ka_innerContent`;
$ab9d13407166d715$export$523c0b569236b342 = `FP9-Ka_unit`;

});


parcelRegister("7dxZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed270bb61dede7b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ed270bb61dede7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activePointsSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.active-points-sprint",
        "defaultMessage": "{used}/{available} points allocated"
    },
    activeUnitSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.active-unit-sprint",
        "defaultMessage": "{unit} allocated"
    },
    days: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.days",
        "defaultMessage": "{available, plural, one {{used}/{available} day} other {{used}/{available} days}}"
    },
    daysTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.days-title",
        "defaultMessage": "{displayTitle} days of estimated work"
    },
    futureProjectedSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.future-projected-sprint",
        "defaultMessage": "Projected sprint"
    },
    hours: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.hours",
        "defaultMessage": "{available, plural, one {{used}/{available} hour} other {{used}/{available} hours}}"
    },
    hoursTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.hours-title",
        "defaultMessage": "{displayTitle} hours of estimated work"
    },
    pastSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.schedule.sprints.sprint.past-sprint",
        "defaultMessage": "Past sprint"
    }
});

});

parcelRegister("bUpYS", function(module, exports) {

$parcel$export(module.exports, "activeSprint", () => $8ab913e9693c2ca2$export$c891bbacdf93fd6e, (v) => $8ab913e9693c2ca2$export$c891bbacdf93fd6e = v);
$parcel$export(module.exports, "bar", () => $8ab913e9693c2ca2$export$d927737047eb3867, (v) => $8ab913e9693c2ca2$export$d927737047eb3867 = v);
$parcel$export(module.exports, "changeIndicator", () => $8ab913e9693c2ca2$export$deafeb91a574091c, (v) => $8ab913e9693c2ca2$export$deafeb91a574091c = v);
$parcel$export(module.exports, "closedSprint", () => $8ab913e9693c2ca2$export$70b46a68a5b6a9e0, (v) => $8ab913e9693c2ca2$export$70b46a68a5b6a9e0 = v);
$parcel$export(module.exports, "filtered", () => $8ab913e9693c2ca2$export$8082fa36f85e6b63, (v) => $8ab913e9693c2ca2$export$8082fa36f85e6b63 = v);
$parcel$export(module.exports, "inconsistent", () => $8ab913e9693c2ca2$export$38e6368cd28c04af, (v) => $8ab913e9693c2ca2$export$38e6368cd28c04af = v);
$parcel$export(module.exports, "isContiguousWithNextSprint", () => $8ab913e9693c2ca2$export$b5b9fc739036f130, (v) => $8ab913e9693c2ca2$export$b5b9fc739036f130 = v);
$parcel$export(module.exports, "okay", () => $8ab913e9693c2ca2$export$4ff774198978dac4, (v) => $8ab913e9693c2ca2$export$4ff774198978dac4 = v);
$parcel$export(module.exports, "overbooked", () => $8ab913e9693c2ca2$export$312c3ba826526246, (v) => $8ab913e9693c2ca2$export$312c3ba826526246 = v);
$parcel$export(module.exports, "pastSprint", () => $8ab913e9693c2ca2$export$196f532ad83e375c, (v) => $8ab913e9693c2ca2$export$196f532ad83e375c = v);
$parcel$export(module.exports, "sprintBox", () => $8ab913e9693c2ca2$export$f182c2c4b027a866, (v) => $8ab913e9693c2ca2$export$f182c2c4b027a866 = v);
$parcel$export(module.exports, "sprintBoxWrapper", () => $8ab913e9693c2ca2$export$ad1793f393406837, (v) => $8ab913e9693c2ca2$export$ad1793f393406837 = v);
$parcel$export(module.exports, "sprintName", () => $8ab913e9693c2ca2$export$2780111908128a1b, (v) => $8ab913e9693c2ca2$export$2780111908128a1b = v);
$parcel$export(module.exports, "sprintTooltip", () => $8ab913e9693c2ca2$export$e68357c14d268b6, (v) => $8ab913e9693c2ca2$export$e68357c14d268b6 = v);
var $8ab913e9693c2ca2$export$c891bbacdf93fd6e;
var $8ab913e9693c2ca2$export$d927737047eb3867;
var $8ab913e9693c2ca2$export$deafeb91a574091c;
var $8ab913e9693c2ca2$export$70b46a68a5b6a9e0;
var $8ab913e9693c2ca2$export$8082fa36f85e6b63;
var $8ab913e9693c2ca2$export$38e6368cd28c04af;
var $8ab913e9693c2ca2$export$b5b9fc739036f130;
var $8ab913e9693c2ca2$export$4ff774198978dac4;
var $8ab913e9693c2ca2$export$312c3ba826526246;
var $8ab913e9693c2ca2$export$196f532ad83e375c;
var $8ab913e9693c2ca2$export$4ecafa351f5a3ad3;
var $8ab913e9693c2ca2$export$f182c2c4b027a866;
var $8ab913e9693c2ca2$export$ad1793f393406837;
var $8ab913e9693c2ca2$export$2780111908128a1b;
var $8ab913e9693c2ca2$export$e68357c14d268b6;
$8ab913e9693c2ca2$export$c891bbacdf93fd6e = `wHWzja_activeSprint`;
$8ab913e9693c2ca2$export$d927737047eb3867 = `wHWzja_bar`;
$8ab913e9693c2ca2$export$deafeb91a574091c = `wHWzja_changeIndicator`;
$8ab913e9693c2ca2$export$70b46a68a5b6a9e0 = `wHWzja_closedSprint`;
$8ab913e9693c2ca2$export$8082fa36f85e6b63 = `wHWzja_filtered`;
$8ab913e9693c2ca2$export$38e6368cd28c04af = `wHWzja_inconsistent`;
$8ab913e9693c2ca2$export$b5b9fc739036f130 = `wHWzja_isContiguousWithNextSprint`;
$8ab913e9693c2ca2$export$4ff774198978dac4 = `wHWzja_okay`;
$8ab913e9693c2ca2$export$312c3ba826526246 = `wHWzja_overbooked`;
$8ab913e9693c2ca2$export$196f532ad83e375c = `wHWzja_pastSprint`;
$8ab913e9693c2ca2$export$4ecafa351f5a3ad3 = `wHWzja_sprint`;
$8ab913e9693c2ca2$export$f182c2c4b027a866 = `wHWzja_sprintBox`;
$8ab913e9693c2ca2$export$ad1793f393406837 = `wHWzja_sprintBoxWrapper`;
$8ab913e9693c2ca2$export$2780111908128a1b = `wHWzja_sprintName`;
$8ab913e9693c2ca2$export$e68357c14d268b6 = `wHWzja_sprintTooltip`;

});



parcelRegister("5tzXw", function(module, exports) {

$parcel$export(module.exports, "message", () => $3fcb8de3fed11d76$export$a8ecead220dd38a6, (v) => $3fcb8de3fed11d76$export$a8ecead220dd38a6 = v);
$parcel$export(module.exports, "sprintLabels", () => $3fcb8de3fed11d76$export$23d7aa3ce101edc3, (v) => $3fcb8de3fed11d76$export$23d7aa3ce101edc3 = v);
var $3fcb8de3fed11d76$export$a8ecead220dd38a6;
var $3fcb8de3fed11d76$export$23d7aa3ce101edc3;
$3fcb8de3fed11d76$export$a8ecead220dd38a6 = `gT7APG_message`;
$3fcb8de3fed11d76$export$23d7aa3ce101edc3 = `gT7APG_sprintLabels`;

});



parcelRegister("i6sAa", function(module, exports) {

$parcel$export(module.exports, "content", () => $d2def5600cacbdf8$export$a7db06668cad9adb, (v) => $d2def5600cacbdf8$export$a7db06668cad9adb = v);
var $d2def5600cacbdf8$export$a7db06668cad9adb;
$d2def5600cacbdf8$export$a7db06668cad9adb = `_2HwH4a_content`;

});



parcelRegister("jY4GB", function(module, exports) {

$parcel$export(module.exports, "stickyHeaderSprintsContainer", () => $e8974178217e358c$export$e1a3f854cebffc7a, (v) => $e8974178217e358c$export$e1a3f854cebffc7a = v);
var $e8974178217e358c$export$e1a3f854cebffc7a;
$e8974178217e358c$export$e1a3f854cebffc7a = `aqLfOa_stickyHeaderSprintsContainer`;

});



parcelRegister("jHygP", function(module, exports) {

$parcel$export(module.exports, "containerSpacer", () => $e57c9dd7fe041662$export$daf3a68f1ee51ba1, (v) => $e57c9dd7fe041662$export$daf3a68f1ee51ba1 = v);
$parcel$export(module.exports, "release-grid", () => $e57c9dd7fe041662$export$b1b8b6e17cd840dd, (v) => $e57c9dd7fe041662$export$b1b8b6e17cd840dd = v);
$parcel$export(module.exports, "row", () => $e57c9dd7fe041662$export$120ff0929b202a6d, (v) => $e57c9dd7fe041662$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "schedule", () => $e57c9dd7fe041662$export$60974f670aa8d75e, (v) => $e57c9dd7fe041662$export$60974f670aa8d75e = v);
var $e57c9dd7fe041662$export$daf3a68f1ee51ba1;
var $e57c9dd7fe041662$export$b1b8b6e17cd840dd;
var $e57c9dd7fe041662$export$120ff0929b202a6d;
var $e57c9dd7fe041662$export$60974f670aa8d75e;
var $e57c9dd7fe041662$export$e1a3f854cebffc7a;
$e57c9dd7fe041662$export$daf3a68f1ee51ba1 = `ejs4Ea_containerSpacer`;
$e57c9dd7fe041662$export$b1b8b6e17cd840dd = `ejs4Ea_release-grid`;
$e57c9dd7fe041662$export$120ff0929b202a6d = `ejs4Ea_row`;
$e57c9dd7fe041662$export$60974f670aa8d75e = `ejs4Ea_schedule`;
$e57c9dd7fe041662$export$e1a3f854cebffc7a = `ejs4Ea_stickyHeaderSprintsContainer`;

});




parcelRegister("7mf6D", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $lMaVG = parcelRequire("lMaVG");

var $5rYNM = parcelRequire("5rYNM");
const $f1e5f273b1291a80$var$TimelineWidthSubscriber = ({ activeView: activeView, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMaVG.default).Subscriber, null, ({ sectionsData: sectionsData })=>{
        const activeTimelineSection = sectionsData?.[`view-${activeView?.id}-${(0, $5rYNM.SECTION_KEYS).MAIN}`];
        const timelineMinWidth = activeTimelineSection?.minWidths?.['timeline-column'];
        const timelineWidth = activeTimelineSection?.widths?.['timeline-column'];
        const isCollapsed = timelineMinWidth != null && timelineWidth != null && timelineWidth <= timelineMinWidth;
        if (isCollapsed) return null;
        return children ? children({
            isCollapsed: isCollapsed,
            timelineWidth: timelineWidth,
            timelineMinWidth: timelineMinWidth
        }) : null;
    });
var $f1e5f273b1291a80$export$2e2bcd8739ae039 = $f1e5f273b1291a80$var$TimelineWidthSubscriber;

});


parcelRegister("9g9PT", function(module, exports) {

$parcel$export(module.exports, "default", () => $78c4eefa60409950$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $a6bdb = parcelRequire("a6bdb");

var $4Sb9U = parcelRequire("4Sb9U");
var $78c4eefa60409950$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $a6bdb.default), {})((0, $4Sb9U.default));

});
parcelRegister("a6bdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd51a7d796a1fce6$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");

var $aMoMC = parcelRequire("aMoMC");
const $cd51a7d796a1fce6$var$mapStateToProps = (state, props)=>({
        width: (0, $aMoMC.getTimelineContainerWidth)(state, props.width),
        fiscalMonth: (0, $dhHiZ.getFiscalMonth)(state)
    });
var $cd51a7d796a1fce6$export$2e2bcd8739ae039 = $cd51a7d796a1fce6$var$mapStateToProps;

});

parcelRegister("4Sb9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9391cfcbafb8a05$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3oQRH = parcelRequire("3oQRH");

var $9FyNo = parcelRequire("9FyNo");

var $01R8T = parcelRequire("01R8T");
parcelRequire("iVBuW");
var $fkPX6 = parcelRequire("fkPX6");

var $a4vO3 = parcelRequire("a4vO3");

var $aYhWi = parcelRequire("aYhWi");
const $a9391cfcbafb8a05$export$e6a97ba2cae5bb94 = ({ width: width, fiscalMonth: fiscalMonth, NowLine: NowLine = (0, $9FyNo.default), TimeUnitsBar: TimeUnitsBar = (0, $fkPX6.default) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oQRH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $aYhWi.timeline,
        style: {
            width: width
        },
        "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.header.axis"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TimeUnitsBar, {
        fiscalMonth: fiscalMonth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01R8T.default), {
        width: width
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NowLine, {
        topOffset: 56
    })));
var $a9391cfcbafb8a05$export$2e2bcd8739ae039 = (0, $a4vO3.withSlots)({
    NowLine: (0, $a4vO3.slots).NowLine
})($a9391cfcbafb8a05$export$e6a97ba2cae5bb94);

});
parcelRegister("iVBuW", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fkPX6")).default);

var $fkPX6 = parcelRequire("fkPX6");

});
parcelRegister("fkPX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfe0673ec641ec3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jODJR = parcelRequire("jODJR");
parcelRequire("jLeQW");
var $hlvGr = parcelRequire("hlvGr");

var $eKCKV = parcelRequire("eKCKV");
function $edfe0673ec641ec3$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    if (zoomLevel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlvGr.default), {
        fiscalMonth: fiscalMonth
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKCKV.default), null);
}

});
parcelRegister("jLeQW", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("hlvGr")).default);

var $hlvGr = parcelRequire("hlvGr");

});
parcelRegister("hlvGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $917432dfd1f298c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6wqPF = parcelRequire("6wqPF");
var $8JuQt = parcelRequire("8JuQt");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $17L5s = parcelRequire("17L5s");
var $dulT0 = parcelRequire("dulT0");
var $eTbtL = parcelRequire("eTbtL");
var $l2Sj2 = parcelRequire("l2Sj2");

var $jODJR = parcelRequire("jODJR");

var $aMoMC = parcelRequire("aMoMC");

var $hIQHg = parcelRequire("hIQHg");

var $kXCE0 = parcelRequire("kXCE0");

var $5rYNM = parcelRequire("5rYNM");

var $2uGxA = parcelRequire("2uGxA");

var $lqDoH = parcelRequire("lqDoH");

var $8navu = parcelRequire("8navu");
function $917432dfd1f298c3$export$2e2bcd8739ae039({ fiscalMonth: fiscalMonth }) {
    const [{ getPercentageOffset: getPercentageOffset }] = (0, $jODJR.useHorizontalPercentageOffset)();
    const [{ viewport: viewport }] = (0, $jODJR.useHorizontalScrolling)();
    const [{ today: today, from: from, to: to }] = (0, $jODJR.useRenderingWindow)();
    const [zoomLevel] = (0, $jODJR.useZoomLevel)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let topBar;
    let bottomBar;
    /**
   * In the top bar of the timeline header, units are rendered with an absolute positioning:
   * e.g. | JAN 2022       | FEB 2022       | MAR 2022
   * The first unit (JAN 2022) is rendered in a portal that sticks to the left edge of the timeline header.
   * As the user scrolls right, the second unit gets closer to the first unit until it starts to overlap it.
   * To prevent this overlap, we unmount the "portal" of the first unit and render it like all other units, then we
   * decrease the left percentage of the first unit so that it slides to the left and makes room for the second unit.
   * The overlap is unique to each mode "weeks", "months", "quarters" and "years".
   */ const calculateTopBarFirstUnitOffset = (overlap)=>`${getPercentageOffset(viewport.offset - overlap)}%`;
    // Top bar:    | MMM YYYY                |
    // Bottom bar: | D D D D D D D D D ... D |
    if (zoomLevel === (0, $5rYNM.ZOOM_LEVELS).WEEKS) {
        // top bar header
        const monthUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).MONTHS);
        topBar = monthUnits.map((unit, index)=>{
            const isCurrentYear = new Date().getUTCFullYear() === new Date(today + unit.from).getUTCFullYear();
            const monthLabel = formatTimestamp(today + unit.from, {
                month: 'short',
                timeZone: 'UTC'
            });
            const yearLabel = formatTimestamp(today + unit.from, {
                year: '2-digit',
                timeZone: 'UTC'
            });
            const label = `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`;
            let offset = `${getPercentageOffset(unit.from)}%`;
            if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                const overlap = (0, $17L5s.ONE_DAY) * 2.25 - (unit.to - viewport.offset);
                if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                else return (0, $8navu.getTimeUnitsBarTopUnitPortal)({
                    index: index,
                    label: label
                });
            }
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: label,
                offset: offset,
                width: 0,
                zoomLevel: zoomLevel
            });
        });
        // bottom bar header
        const dayUnits = (0, $kXCE0.getDayUnits)({
            from: from,
            to: to
        });
        bottomBar = dayUnits.map((unit, index)=>{
            const offset = getPercentageOffset(unit.from);
            const width = getPercentageOffset(unit.to) - offset;
            const date = new Date(today + unit.from);
            const isToday = (0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') ? (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(date.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime() + (0, $17L5s.dateDiffFromUTC)() * (0, $17L5s.ONE_DAY))) : (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(date.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime()));
            // Monday DD/MM/YYYY
            const tooltipContent = `${formatTimestamp(date.getTime(), (0, $eTbtL.weekdayFormatLong))}`;
            return (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                isToday: isToday,
                isWeekendDay: (0, $8navu.isWeekendDay)(date),
                label: formatTimestamp(date.getTime(), {
                    day: 'numeric',
                    timeZone: 'UTC'
                }),
                offset: offset,
                // right border on Sunday
                showRightBorder: date.getUTCDay() === 0,
                showLeftBorder: date.getUTCDay() === 1,
                width: width,
                zoomLevel: zoomLevel,
                tooltipContent: tooltipContent
            });
        });
    } else if (zoomLevel === (0, $5rYNM.ZOOM_LEVELS).MONTHS) {
        // top bar header
        const monthUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).MONTHS);
        topBar = monthUnits.map((unit, index)=>{
            const isCurrentYear = new Date().getUTCFullYear() === new Date(today + unit.from).getUTCFullYear();
            const monthLabel = formatTimestamp(today + unit.from, {
                month: 'short',
                timeZone: 'UTC'
            });
            const yearLabel = formatTimestamp(today + unit.from, {
                year: '2-digit',
                timeZone: 'UTC'
            });
            const label = `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`;
            let offset = `${getPercentageOffset(unit.from)}%`;
            if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                const overlap = (0, $17L5s.ONE_WEEK) * 1.4 - (unit.to - viewport.offset);
                if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                else return (0, $8navu.getTimeUnitsBarTopUnitPortal)({
                    index: index,
                    label: label
                });
            }
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: label,
                offset: offset,
                width: 0,
                zoomLevel: zoomLevel
            });
        });
        // bottom bar header
        const weekUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).WEEKS);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        bottomBar = weekUnits.map(({ from: from, to: to }, index)=>{
            const offset = getPercentageOffset(from);
            const width = getPercentageOffset(to) - offset;
            const date = new Date(today + from);
            const isToday = (0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') ? (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(date.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime() + (0, $17L5s.dateDiffFromUTC)() * (0, $17L5s.ONE_DAY))) : (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(date.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime()));
            // Week X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = formatMessage((0, $2uGxA.default).week, {
                weekNumber: (0, $8JuQt.default)(date.getTime()),
                firstDay: formatTimestamp(date.getTime(), (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp((0, $6wqPF.default)(date, 6).getTime(), (0, $eTbtL.shortDateFormat))
            });
            return (0, $8navu.getTimeUnitsBarBottomUnit)({
                alignTextToLeft: true,
                index: index,
                isToday: isToday,
                label: date.getUTCDate(),
                offset: offset,
                showLeftPadding: false,
                showRightBorder: false,
                width: width,
                zoomLevel: zoomLevel,
                tooltipContent: tooltipContent
            });
        });
    } else if (zoomLevel === (0, $5rYNM.ZOOM_LEVELS).QUARTERS) {
        // top bar header
        const topYearUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).YEARS, fiscalMonth);
        topBar = topYearUnits.map((unit, index)=>{
            const date = new Date(today + unit.from);
            const label = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearPrefix, {
                financialYear: (0, $hIQHg.formatFY)((0, $hIQHg.calculateFinancialYear)(date.getTime(), fiscalMonth))
            }) : date.getUTCFullYear();
            let offset = `${getPercentageOffset(unit.from)}%`;
            if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                const overlap = (0, $17L5s.ONE_WEEK) * 4 - (unit.to - viewport.offset);
                if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                else return (0, $8navu.getTimeUnitsBarTopUnitPortal)({
                    index: index,
                    label: label
                });
            }
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: label,
                offset: offset,
                width: 0,
                zoomLevel: zoomLevel
            });
        });
        // bottom bar header
        const bottomQuarterUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).QUARTERS, fiscalMonth);
        bottomBar = bottomQuarterUnits.map((unit, index)=>{
            const offset = getPercentageOffset(unit.from);
            const width = getPercentageOffset(unit.to) - offset;
            const startDate = new Date(today + unit.from);
            const startTime = startDate.getTime();
            const endTime = new Date(today + unit.to - (0, $17L5s.ONE_DAY)).getTime();
            const thisMonth = startDate.getUTCMonth();
            const quarterNumber = (0, $aMoMC.getQuarterLabel)(thisMonth, fiscalMonth);
            const quarterStartMonthShortString = formatTimestamp(today + unit.from, {
                month: 'short',
                timeZone: 'UTC'
            });
            const quarterEndMonthShortString = formatTimestamp(today + unit.to - (0, $17L5s.ONE_DAY), {
                month: 'short',
                timeZone: 'UTC'
            });
            // Quarter X DD/MM/YYYY to DD/MM/YYYY, Financial Year YYYY
            // Quarter X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: formatTimestamp(startTime, (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp(endTime, (0, $eTbtL.shortDateFormat)),
                financialYear: (0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth)
            }) : formatMessage((0, $2uGxA.default).calendarYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: formatTimestamp(startTime, (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp(endTime, (0, $eTbtL.shortDateFormat))
            });
            return (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                label: formatMessage((0, $2uGxA.default).quarterDescriptorLong, {
                    quarterNumber: quarterNumber,
                    quarterStartMonthShortString: quarterStartMonthShortString,
                    quarterEndMonthShortString: quarterEndMonthShortString
                }),
                offset: offset,
                showRightBorder: false,
                showLeftBorder: true,
                width: width,
                zoomLevel: (0, $5rYNM.ZOOM_LEVELS).QUARTERS,
                tooltipContent: tooltipContent
            });
        });
    } else if (zoomLevel === (0, $5rYNM.ZOOM_LEVELS).YEARS) {
        // top bar header
        const yearUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).YEARS, fiscalMonth);
        topBar = yearUnits.map((unit, index)=>{
            const date = new Date(today + unit.from);
            const label = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearPrefix, {
                financialYear: (0, $hIQHg.formatFY)((0, $hIQHg.calculateFinancialYear)(date.getTime(), fiscalMonth))
            }) : date.getUTCFullYear();
            let offset = `${getPercentageOffset(unit.from)}%`;
            if (viewport.offset >= unit.from && viewport.offset <= unit.to) {
                const overlap = (0, $17L5s.ONE_WEEK) * 10 - (unit.to - viewport.offset);
                if (overlap > 0) offset = calculateTopBarFirstUnitOffset(overlap);
                else return (0, $8navu.getTimeUnitsBarTopUnitPortal)({
                    index: index,
                    label: label
                });
            }
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: label,
                offset: offset,
                width: 0,
                zoomLevel: zoomLevel
            });
        });
        // bottom bar header
        const quarterUnits = (0, $kXCE0.getUnits)({
            from: from,
            to: to
        }, (0, $5rYNM.ZOOM_LEVELS).QUARTERS, fiscalMonth);
        bottomBar = quarterUnits.map((unit, index)=>{
            const offset = getPercentageOffset(unit.from);
            const width = getPercentageOffset(unit.to) - offset;
            const date = new Date(today + unit.from);
            const startTime = date.getTime();
            const endTime = new Date(today + unit.to - (0, $17L5s.ONE_DAY)).getTime();
            const quarterNumber = (0, $aMoMC.getQuarterLabel)(date.getUTCMonth(), fiscalMonth);
            // Quarter X DD/MM/YYYY to DD/MM/YYYY, Financial Year YYYY
            // Quarter X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: formatTimestamp(startTime, (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp(endTime, (0, $eTbtL.shortDateFormat)),
                financialYear: (0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth)
            }) : formatMessage((0, $2uGxA.default).calendarYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: formatTimestamp(startTime, (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp(endTime, (0, $eTbtL.shortDateFormat))
            });
            return (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                label: formatMessage((0, $2uGxA.default).quarterDescriptorShort, {
                    quarterNumber: quarterNumber
                }),
                offset: offset,
                // right border on each quarter
                showRightBorder: false,
                showLeftBorder: quarterNumber === '1',
                width: width,
                zoomLevel: zoomLevel,
                tooltipContent: tooltipContent
            });
        });
    }
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lqDoH.timeUnitsBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${(0, $8navu.testId)}.top`,
        className: $lqDoH.timeUnitsBarTop
    }, topBar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${(0, $8navu.testId)}.bottom`,
        className: $lqDoH.timeUnitsBarBottom
    }, bottomBar)));
}

});
parcelRegister("hIQHg", function(module, exports) {

$parcel$export(module.exports, "calculateFinancialYear", () => $271eb6bfd040abe2$export$ecfb8a99ff85ea57);
$parcel$export(module.exports, "formatFY", () => $271eb6bfd040abe2$export$663a8e9ea7479005);
/**
 * Calculates the financial year that a date falls within. All calculations are done using UTC TZ.
 * @param time timestamp from epoch
 * @param fyStartMonth the month that FY starts (1-12)
 * @returns the financial year that the month falls within
 */ const $271eb6bfd040abe2$export$ecfb8a99ff85ea57 = (time, fyStartMonth = 1)=>{
    const date = new Date(time);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1; // zero-based
    if (fyStartMonth > 1 && month >= fyStartMonth) return year + 1;
    return year;
};
const $271eb6bfd040abe2$export$663a8e9ea7479005 = (year)=>`${year}`.slice(-2);

});

parcelRegister("2uGxA", function(module, exports) {

$parcel$export(module.exports, "quarters", () => $6a2fca1c2e02bb01$export$e0e5e1b96f56de29);
$parcel$export(module.exports, "default", () => $6a2fca1c2e02bb01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $6a2fca1c2e02bb01$var$messages = (0, $90IgZ.defineMessages)({
    january: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.january",
        "defaultMessage": "Jan"
    },
    february: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.february",
        "defaultMessage": "Feb"
    },
    march: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.march",
        "defaultMessage": "Mar"
    },
    april: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.april",
        "defaultMessage": "Apr"
    },
    may: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.may",
        "defaultMessage": "May"
    },
    june: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.june",
        "defaultMessage": "Jun"
    },
    july: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.july",
        "defaultMessage": "Jul"
    },
    august: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.august",
        "defaultMessage": "Aug"
    },
    september: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.september",
        "defaultMessage": "Sep"
    },
    october: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.october",
        "defaultMessage": "Oct"
    },
    november: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.november",
        "defaultMessage": "Nov"
    },
    december: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.december",
        "defaultMessage": "Dec"
    },
    week: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.week",
        "defaultMessage": "Week {weekNumber} {firstDay} to {lastDay}"
    },
    financialYearQuarter: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.financial-year-quarter",
        "defaultMessage": "Quarter {quarterNumber} {firstDay} to {lastDay}, Financial Year {financialYear}"
    },
    calendarYearQuarter: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.calendar-year-quarter",
        "defaultMessage": "Quarter {quarterNumber} {firstDay} to {lastDay}"
    },
    financialYearPrefix: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.financial-year-prefix",
        "defaultMessage": "FY{financialYear}"
    },
    quarterDescriptorShort: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.quarter-descriptor-short",
        "defaultMessage": "Q{quarterNumber}"
    },
    quarterDescriptorLong: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar.quarter-descriptor-long",
        "defaultMessage": "Q{quarterNumber} {quarterStartMonthShortString} - {quarterEndMonthShortString}"
    }
});
const $6a2fca1c2e02bb01$export$62f5e462247f69c8 = [
    {
        startMonth: $6a2fca1c2e02bb01$var$messages.january,
        endMonth: $6a2fca1c2e02bb01$var$messages.march
    },
    {
        startMonth: $6a2fca1c2e02bb01$var$messages.april,
        endMonth: $6a2fca1c2e02bb01$var$messages.june
    },
    {
        startMonth: $6a2fca1c2e02bb01$var$messages.july,
        endMonth: $6a2fca1c2e02bb01$var$messages.september
    },
    {
        startMonth: $6a2fca1c2e02bb01$var$messages.october,
        endMonth: $6a2fca1c2e02bb01$var$messages.december
    }
];
const $6a2fca1c2e02bb01$export$e0e5e1b96f56de29 = [
    $6a2fca1c2e02bb01$var$messages.january,
    $6a2fca1c2e02bb01$var$messages.april,
    $6a2fca1c2e02bb01$var$messages.july,
    $6a2fca1c2e02bb01$var$messages.october
];
var $6a2fca1c2e02bb01$export$2e2bcd8739ae039 = $6a2fca1c2e02bb01$var$messages;

});

parcelRegister("lqDoH", function(module, exports) {

$parcel$export(module.exports, "dateLozenge", () => $f99a962bf737defe$export$7bf2e051a0a913e, (v) => $f99a962bf737defe$export$7bf2e051a0a913e = v);
$parcel$export(module.exports, "infiniteAxis", () => $f99a962bf737defe$export$802b59a58cf5b17f, (v) => $f99a962bf737defe$export$802b59a58cf5b17f = v);
$parcel$export(module.exports, "newOverride", () => $f99a962bf737defe$export$c4e875003ce9ab52, (v) => $f99a962bf737defe$export$c4e875003ce9ab52 = v);
$parcel$export(module.exports, "staticAxis", () => $f99a962bf737defe$export$f485c5d219611ae4, (v) => $f99a962bf737defe$export$f485c5d219611ae4 = v);
$parcel$export(module.exports, "timeUnitsBar", () => $f99a962bf737defe$export$b1ce12b9a87363e9, (v) => $f99a962bf737defe$export$b1ce12b9a87363e9 = v);
$parcel$export(module.exports, "timeUnitsBarBottom", () => $f99a962bf737defe$export$ce30c66e03cd2823, (v) => $f99a962bf737defe$export$ce30c66e03cd2823 = v);
$parcel$export(module.exports, "timeUnitsBarBottomUnit", () => $f99a962bf737defe$export$4740305de9c60fe0, (v) => $f99a962bf737defe$export$4740305de9c60fe0 = v);
$parcel$export(module.exports, "timeUnitsBarBottomUnitContent", () => $f99a962bf737defe$export$b60b4c343bef999, (v) => $f99a962bf737defe$export$b60b4c343bef999 = v);
$parcel$export(module.exports, "timeUnitsBarContent", () => $f99a962bf737defe$export$d74887457c89c52, (v) => $f99a962bf737defe$export$d74887457c89c52 = v);
$parcel$export(module.exports, "timeUnitsBarTop", () => $f99a962bf737defe$export$1c5daac66ea01541, (v) => $f99a962bf737defe$export$1c5daac66ea01541 = v);
$parcel$export(module.exports, "timeUnitsBarTopUnit", () => $f99a962bf737defe$export$c442a59fddbcaac9, (v) => $f99a962bf737defe$export$c442a59fddbcaac9 = v);
$parcel$export(module.exports, "timeUnitsBarTopUnitContent", () => $f99a962bf737defe$export$c99d17876c31b812, (v) => $f99a962bf737defe$export$c99d17876c31b812 = v);
$parcel$export(module.exports, "withLeftBorder", () => $f99a962bf737defe$export$406c9f761699d0ee, (v) => $f99a962bf737defe$export$406c9f761699d0ee = v);
$parcel$export(module.exports, "yearWrapper", () => $f99a962bf737defe$export$f5a2c8e73b53d4db, (v) => $f99a962bf737defe$export$f5a2c8e73b53d4db = v);
var $f99a962bf737defe$export$7bf2e051a0a913e;
var $f99a962bf737defe$export$802b59a58cf5b17f;
var $f99a962bf737defe$export$c4e875003ce9ab52;
var $f99a962bf737defe$export$f485c5d219611ae4;
var $f99a962bf737defe$export$b1ce12b9a87363e9;
var $f99a962bf737defe$export$ce30c66e03cd2823;
var $f99a962bf737defe$export$4740305de9c60fe0;
var $f99a962bf737defe$export$b60b4c343bef999;
var $f99a962bf737defe$export$d74887457c89c52;
var $f99a962bf737defe$export$1c5daac66ea01541;
var $f99a962bf737defe$export$c442a59fddbcaac9;
var $f99a962bf737defe$export$c99d17876c31b812;
var $f99a962bf737defe$export$406c9f761699d0ee;
var $f99a962bf737defe$export$f5a2c8e73b53d4db;
$f99a962bf737defe$export$7bf2e051a0a913e = `esbLaW_dateLozenge`;
$f99a962bf737defe$export$802b59a58cf5b17f = `esbLaW_infiniteAxis`;
$f99a962bf737defe$export$c4e875003ce9ab52 = `esbLaW_newOverride`;
$f99a962bf737defe$export$f485c5d219611ae4 = `esbLaW_staticAxis`;
$f99a962bf737defe$export$b1ce12b9a87363e9 = `esbLaW_timeUnitsBar`;
$f99a962bf737defe$export$ce30c66e03cd2823 = `esbLaW_timeUnitsBarBottom`;
$f99a962bf737defe$export$4740305de9c60fe0 = `esbLaW_timeUnitsBarBottomUnit`;
$f99a962bf737defe$export$b60b4c343bef999 = `esbLaW_timeUnitsBarBottomUnitContent`;
$f99a962bf737defe$export$d74887457c89c52 = `esbLaW_timeUnitsBarContent`;
$f99a962bf737defe$export$1c5daac66ea01541 = `esbLaW_timeUnitsBarTop`;
$f99a962bf737defe$export$c442a59fddbcaac9 = `esbLaW_timeUnitsBarTopUnit`;
$f99a962bf737defe$export$c99d17876c31b812 = `esbLaW_timeUnitsBarTopUnitContent`;
$f99a962bf737defe$export$406c9f761699d0ee = `esbLaW_withLeftBorder`;
$f99a962bf737defe$export$f5a2c8e73b53d4db = `esbLaW_yearWrapper`;

});

parcelRegister("8navu", function(module, exports) {

$parcel$export(module.exports, "testId", () => $4d559c6cd045e7a3$export$d428cfd0d6a2b2ec);
$parcel$export(module.exports, "getTimeUnitsBarTopUnit", () => $4d559c6cd045e7a3$export$faca2e900e659899);
$parcel$export(module.exports, "getTimeUnitsBarTopUnitPortal", () => $4d559c6cd045e7a3$export$50ab3995cbf498f9);
$parcel$export(module.exports, "getTimeUnitsBarBottomUnit", () => $4d559c6cd045e7a3$export$fd3a8da674cde14d);
$parcel$export(module.exports, "isWeekendDay", () => $4d559c6cd045e7a3$export$41da6887b3b8f593);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $OwBos = parcelRequire("OwBos");
var $6WQhi = parcelRequire("6WQhi");
var $ffiyv = parcelRequire("ffiyv");
var $jqhqi = parcelRequire("jqhqi");
var $sDHpG = parcelRequire("sDHpG");

var $1ni3W = parcelRequire("1ni3W");

var $5rYNM = parcelRequire("5rYNM");

var $2uGxA = parcelRequire("2uGxA");

var $lqDoH = parcelRequire("lqDoH");
const $4d559c6cd045e7a3$export$d428cfd0d6a2b2ec = 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.timeline.time-units-bar';
const $4d559c6cd045e7a3$export$faca2e900e659899 = ({ index: index, label: label, offset: offset, width: width, zoomLevel: zoomLevel })=>{
    if (zoomLevel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${$4d559c6cd045e7a3$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
        key: `timeUnitsBarTopUnit${index}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarTopUnit} ${$lqDoH.infiniteAxis} ${$lqDoH.newOverride}`,
        style: {
            left: offset
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarTopUnitContent} ${$lqDoH.infiniteAxis} ${$lqDoH.withLeftBorder}`
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${$4d559c6cd045e7a3$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
        key: `timeUnitsBarTopUnit${index}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarTopUnit} ${$lqDoH.newOverride}`,
        style: {
            left: offset,
            width: `${width}%`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarTopUnitContent} ${$lqDoH.staticAxis} ${index > 0 ? $lqDoH.withLeftBorder : ''}`
    }, label));
};
const $4d559c6cd045e7a3$export$50ab3995cbf498f9 = ({ index: index, label: label })=>{
    // portals are only used when the timeline is in "weeks", "months", "quarters" or "years"
    // to render a time unit which sticks to the top left edge of the timeline header
    // we only render it if its specific container is present in the DOM since
    // we don't want to use document.body as a fallback as it would look odd
    const container = document.getElementById((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2') ? 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.overlay.axis-first-time-unit.sticky-date' : `portfolio-3-common.sections.item.${(0, $5rYNM.SECTION_ITEM_KEYS).TIMELINE}`);
    if (container) return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${$4d559c6cd045e7a3$export$d428cfd0d6a2b2ec}.top-unit-${index}`,
        key: `timeUnitsBarTopUnit${index}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarTopUnit} ${$lqDoH.infiniteAxis} ${$lqDoH.newOverride}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$lqDoH.timeUnitsBarTopUnitContent} ${$lqDoH.staticAxis}`
    }, label)), // note: getBody() is added as a fallback just to make Flow happy
    container || (0, $1ni3W.getBody)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: `timeUnitsBarTopUnit${index}`
    });
};
const $4d559c6cd045e7a3$export$d337baad096e3dd2 = (isToday, isWeekendDay, label)=>{
    // blue lozenge for today day
    if (isToday) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "inprogress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lqDoH.dateLozenge
    }, label));
    // grey lozenge for weekend day
    if (isWeekendDay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lqDoH.dateLozenge
    }, label));
    // no lozenge otherwise
    return label;
};
const $4d559c6cd045e7a3$export$fd3a8da674cde14d = ({ alignTextToLeft: alignTextToLeft = false, index: index, isToday: isToday = false, isWeekendDay: isWeekendDay = false, label: label, offset: offset, showLeftPadding: showLeftPadding = false, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder = false, width: width, zoomLevel: zoomLevel, tooltipContent: tooltipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        key: `timeUnitsBarBottomUnit${index}`,
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${$4d559c6cd045e7a3$export$d428cfd0d6a2b2ec}.bottom-unit-${index}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $lqDoH.timeUnitsBarBottomUnit,
        style: {
            left: `${offset}%`,
            width: `${width}%`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$lqDoH.timeUnitsBarBottomUnitContent} ${$lqDoH.newOverride} ${zoomLevel ? '' : $lqDoH.staticAxis} ${showRightBorder} ${showLeftBorder && $lqDoH.withLeftBorder} ${$lqDoH.newOverride}`,
        style: {
            textAlign: alignTextToLeft ? 'left' : 'center',
            paddingLeft: showLeftPadding ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
        }
    }, $4d559c6cd045e7a3$export$d337baad096e3dd2(isToday, isWeekendDay, label))));
const $4d559c6cd045e7a3$export$dd1ec7b2c7c7352b = (timeUnit)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$lqDoH.timeUnitsBarContent} ${$lqDoH.infiniteAxis} ${$lqDoH.withLeftBorder}`
    }, timeUnit);
const $4d559c6cd045e7a3$export$a7f0d2a9ddb86918 = (startTime, timelineRangeStart, timelineRangeEnd)=>{
    let quarterStart = (0, $sDHpG.default)(startTime);
    const timelineEndDate = new Date(timelineRangeEnd);
    const timelineStartDate = new Date(timelineRangeStart);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lqDoH.yearWrapper
    }, (0, $2uGxA.quarters).map((quarter, index)=>{
        quarterStart = (0, $jqhqi.default)(quarterStart);
        const quarterEnd = (0, $6WQhi.default)(quarterStart);
        quarterStart = (0, $OwBos.default)(quarterStart, 1);
        if (quarterStart > timelineStartDate && quarterEnd < timelineEndDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), quarter));
        return null;
    })));
};
const $4d559c6cd045e7a3$export$41da6887b3b8f593 = (date)=>date.getUTCDay() % 6 === 0;

});



parcelRegister("eKCKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $70569bc53ca0a75e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jCboV = parcelRequire("jCboV");

var $8Re5R = parcelRequire("8Re5R");
var $70569bc53ca0a75e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jCboV.default), {})((0, $8Re5R.default));

});
parcelRegister("jCboV", function(module, exports) {

$parcel$export(module.exports, "default", () => $892f5e6be7bb5a19$export$2e2bcd8739ae039);

var $dhHiZ = parcelRequire("dhHiZ");

var $aMoMC = parcelRequire("aMoMC");

var $iK4oF = parcelRequire("iK4oF");
var $892f5e6be7bb5a19$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    timelineRange: (0, $aMoMC.getTimelineRange),
    fiscalMonth: (0, $dhHiZ.getFiscalMonth)
});

});

parcelRegister("8Re5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $be9ee4980a39d35a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6wqPF = parcelRequire("6wqPF");
var $8JuQt = parcelRequire("8JuQt");

var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $17L5s = parcelRequire("17L5s");
var $dulT0 = parcelRequire("dulT0");
var $eTbtL = parcelRequire("eTbtL");
var $3jYzf = parcelRequire("3jYzf");
var $l2Sj2 = parcelRequire("l2Sj2");

var $aMoMC = parcelRequire("aMoMC");

var $jqeWm = parcelRequire("jqeWm");

var $hIQHg = parcelRequire("hIQHg");

var $5rYNM = parcelRequire("5rYNM");

var $2uGxA = parcelRequire("2uGxA");

var $lqDoH = parcelRequire("lqDoH");

var $8navu = parcelRequire("8navu");
function $be9ee4980a39d35a$export$2e2bcd8739ae039({ timelineRange: timelineRange, fiscalMonth: fiscalMonth }) {
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { start: timelineRangeStart, end: timelineRangeEnd } = timelineRange;
    const daysInRange = (timelineRangeEnd - timelineRangeStart) / (0, $17L5s.ONE_DAY);
    const dayUnits = (0, $aMoMC.getDayUnits)(timelineRangeStart, daysInRange);
    let topBar;
    let bottomBar;
    // the header bar of custom date ranges up to 14 days is similar to the infinite axis "weeks" header bar
    // Top bar:    | MMM YYYY                |
    // Bottom bar: | D D D D D D D D D ... D |
    if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).SMALL) {
        // top bar header
        const monthUnits = (0, $aMoMC.getMonthUnits)(timelineRangeStart, timelineRangeEnd);
        topBar = monthUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const isCurrentYear = new Date().getUTCFullYear() === new Date(startTime).getUTCFullYear();
            const monthLabel = formatTimestamp(startTime, {
                month: 'short',
                timeZone: 'UTC'
            });
            const yearLabel = formatTimestamp(startTime, {
                year: '2-digit',
                timeZone: 'UTC'
            });
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`,
                offset: 0,
                width: widthPercentage
            });
        });
        // bottom bar header
        let width = 0;
        bottomBar = dayUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            const isToday = (0, $1ybV0.ff)('respect-user-locale-when-showing-today-line_5q7ex') ? (0, $dulT0.default)((0, $3jYzf.default)(startDate), (0, $3jYzf.default)((0, $aMoMC.getTodayDate)().getTime() - (0, $17L5s.dateDiffFromUTC)() * (0, $17L5s.ONE_DAY))) : (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(startDate.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime()));
            // Monday DD/MM/YYYY
            const tooltipContent = `${formatTimestamp(startDate.getTime(), (0, $eTbtL.weekdayFormatLong))}`;
            const unit = (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                isToday: isToday,
                isWeekendDay: (0, $8navu.isWeekendDay)(startDate),
                label: formatTimestamp(startTime, {
                    day: 'numeric',
                    timeZone: 'UTC'
                }),
                offset: width,
                showRightBorder: false,
                showLeftBorder: index > 0 && startDate.getUTCDay() === 1,
                width: widthPercentage,
                tooltipContent: tooltipContent
            });
            width += widthPercentage;
            return unit;
        });
    } else if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).MEDIUM) {
        const monthUnits = (0, $aMoMC.getMonthUnits)(timelineRangeStart, timelineRangeEnd);
        topBar = monthUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const isCurrentYear = new Date().getUTCFullYear() === new Date(startTime).getUTCFullYear();
            const monthLabel = formatTimestamp(startTime, {
                month: 'short',
                timeZone: 'UTC'
            });
            const yearLabel = formatTimestamp(startTime, {
                year: '2-digit',
                timeZone: 'UTC'
            });
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: `${monthLabel}${isCurrentYear ? '' : ` \u{2019}${yearLabel}`}`,
                offset: 0,
                width: widthPercentage
            });
        });
        let dateCursor;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const bottomUnits = dayUnits.reduce((acc, { startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            if (index > 0 && startDate.getUTCDay() !== 1) acc[dateCursor].widthPercentage += widthPercentage;
            else {
                dateCursor = startTime;
                acc[dateCursor] = {
                    startTime: startTime,
                    widthPercentage: widthPercentage
                };
            }
            return acc;
        }, {});
        let width = 0;
        bottomBar = $UCNmJ.default(bottomUnits).map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            const isMonday = startDate.getUTCDay() === 1;
            // Week X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = formatMessage((0, $2uGxA.default).week, {
                weekNumber: (0, $8JuQt.default)(startDate.getTime()),
                firstDay: formatTimestamp(startDate.getTime(), (0, $eTbtL.shortDateFormat)),
                lastDay: formatTimestamp((0, $6wqPF.default)(startDate, 6).getTime(), (0, $eTbtL.shortDateFormat))
            });
            const unit = (0, $8navu.getTimeUnitsBarBottomUnit)({
                alignTextToLeft: true,
                index: index,
                isToday: isMonday && (0, $dulT0.default)((0, $17L5s.startOfUtcDay)(startDate.getTime()), (0, $17L5s.startOfUtcDay)((0, $aMoMC.getTodayDate)().getTime())),
                label: isMonday ? startDate.getUTCDate() : '',
                offset: width,
                showLeftPadding: false,
                showRightBorder: false,
                width: widthPercentage,
                tooltipContent: tooltipContent
            });
            width += widthPercentage;
            return unit;
        });
    } else if (dayUnits.length <= (0, $5rYNM.CUSTOM_DATE_RANGES).LARGE) {
        const yearUnits = (0, $aMoMC.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
        topBar = yearUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            return (0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearPrefix, {
                    financialYear: (0, $hIQHg.formatFY)((0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth))
                }) : startDate.getUTCFullYear(),
                offset: 0,
                width: widthPercentage
            });
        });
        const quarterUnits = (0, $aMoMC.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
        let width = 0;
        bottomBar = quarterUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            const quarterNumber = (0, $jqeWm.calculateQuarter)(startDate.getUTCMonth() + 1, fiscalMonth);
            let quarterStartMonth = fiscalMonth + (quarterNumber - 1) * 3;
            let quarterEndYear = startDate.getUTCFullYear();
            if (quarterStartMonth > 12) quarterStartMonth %= 12;
            if (quarterStartMonth > 10) quarterEndYear++;
            const quarterEndMonth = quarterStartMonth <= 10 ? quarterStartMonth + 2 : (quarterStartMonth + 2) % 12;
            const quarterStartTime = new Date(`${startDate.getUTCFullYear()}-${`0${quarterStartMonth}`.slice(-2)}-01T00:00:00Z`);
            const quarterEndTime = new Date(`${quarterEndYear}-${`0${quarterEndMonth}`.slice(-2)}-01T00:00:00Z`);
            const quarterStartMonthShortString = formatTimestamp(quarterStartTime.getTime(), {
                month: 'short',
                timeZone: 'UTC'
            });
            const quarterEndMonthShortString = formatTimestamp(quarterEndTime.getTime(), {
                month: 'short',
                timeZone: 'UTC'
            });
            const firstDay = formatTimestamp(startDate.getTime(), (0, $eTbtL.shortDateFormat));
            const nextQuarterStartMonth = quarterStartMonth <= 9 ? quarterStartMonth + 3 : (quarterStartMonth + 3) % 12;
            const lastDay = formatTimestamp(new Date(`${quarterEndYear}-${`0${nextQuarterStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - (0, $17L5s.ONE_DAY), (0, $eTbtL.shortDateFormat));
            // Quarter X DD/MM/YYYY to DD/MM/YYYY, Financial Year YYYY
            // Quarter X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: firstDay,
                lastDay: lastDay,
                financialYear: (0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth)
            }) : formatMessage((0, $2uGxA.default).calendarYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: firstDay,
                lastDay: lastDay
            });
            const unit = (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                label: formatMessage((0, $2uGxA.default).quarterDescriptorLong, {
                    quarterNumber: quarterNumber,
                    quarterStartMonthShortString: quarterStartMonthShortString,
                    quarterEndMonthShortString: quarterEndMonthShortString
                }),
                offset: width,
                showRightBorder: false,
                showLeftBorder: index !== 0,
                width: widthPercentage,
                tooltipContent: tooltipContent
            });
            width += widthPercentage;
            return unit;
        });
    } else {
        const yearUnits = (0, $aMoMC.getYearUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
        topBar = yearUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>(0, $8navu.getTimeUnitsBarTopUnit)({
                index: index,
                label: fiscalMonth !== 1 ? (0, $hIQHg.formatFY)((0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth)) : new Date(startTime).getUTCFullYear(),
                offset: 0,
                width: widthPercentage
            }));
        const quarterUnits = (0, $aMoMC.getQuarterUnits)(timelineRangeStart, timelineRangeEnd, fiscalMonth);
        let width = 0;
        bottomBar = quarterUnits.map(({ startTime: startTime, widthPercentage: widthPercentage }, index)=>{
            const startDate = new Date(startTime);
            const firstDay = formatTimestamp(startDate.getTime(), (0, $eTbtL.shortDateFormat));
            const quarterNumber = (0, $jqeWm.calculateQuarter)(startDate.getUTCMonth() + 1, fiscalMonth);
            let quarterStartMonth = fiscalMonth + (quarterNumber - 1) * 3;
            let quarterEndYear = startDate.getUTCFullYear();
            if (quarterStartMonth > 12) quarterStartMonth %= 12;
            if (quarterStartMonth > 10) quarterEndYear++;
            const nextQuarterStartMonth = quarterStartMonth <= 9 ? quarterStartMonth + 3 : (quarterStartMonth + 3) % 12;
            const lastDay = formatTimestamp(new Date(`${quarterEndYear}-${`0${nextQuarterStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - (0, $17L5s.ONE_DAY), (0, $eTbtL.shortDateFormat));
            // Quarter X DD/MM/YYYY to DD/MM/YYYY, Financial Year YYYY
            // Quarter X DD/MM/YYYY to DD/MM/YYYY
            const tooltipContent = fiscalMonth !== 1 ? formatMessage((0, $2uGxA.default).financialYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: firstDay,
                lastDay: lastDay,
                financialYear: (0, $hIQHg.calculateFinancialYear)(startTime, fiscalMonth)
            }) : formatMessage((0, $2uGxA.default).calendarYearQuarter, {
                quarterNumber: quarterNumber,
                firstDay: firstDay,
                lastDay: lastDay
            });
            const unit = (0, $8navu.getTimeUnitsBarBottomUnit)({
                index: index,
                label: formatMessage((0, $2uGxA.default).quarterDescriptorShort, {
                    quarterNumber: quarterNumber
                }),
                offset: width,
                // right border on each quarter
                showRightBorder: false,
                showLeftBorder: index > 0 && quarterNumber === 1,
                width: widthPercentage,
                tooltipContent: tooltipContent
            });
            width += widthPercentage;
            return unit;
        });
    }
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lqDoH.timeUnitsBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${(0, $8navu.testId)}.top`,
        className: $lqDoH.timeUnitsBarTop
    }, topBar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": `${(0, $8navu.testId)}.bottom`,
        className: $lqDoH.timeUnitsBarBottom
    }, bottomBar)));
}

});






parcelRegister("ddt7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $63348fbf04a9ee55$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1SqWq = parcelRequire("1SqWq");

var $gwbfD = parcelRequire("gwbfD");

var $jODJR = parcelRequire("jODJR");

var $j4LwV = parcelRequire("j4LwV");

var $dw8TK = parcelRequire("dw8TK");

var $avEc1 = parcelRequire("avEc1");
function $63348fbf04a9ee55$export$2e2bcd8739ae039() {
    const [, { backToToday: backToToday }] = (0, $jODJR.useToday)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4LwV.default), {
            letter: "T",
            message: (0, $avEc1.default).todayTooltip
        }),
        position: "top-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyT",
        onKeyDown: backToToday
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SqWq.default), {
        onClick: backToToday,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.today-button.today-button"
    }));
}

});
parcelRegister("1SqWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $34cf626268fb34aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hcwQN = parcelRequire("hcwQN");
const $34cf626268fb34aa$var$TodayButton = ({ onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $hcwQN.default).today));
};
var $34cf626268fb34aa$export$2e2bcd8739ae039 = $34cf626268fb34aa$var$TodayButton;

});
parcelRegister("hcwQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a676279f6b60d04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$0a676279f6b60d04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "aais-timeline-toolbar.today-button.today",
        "defaultMessage": "Today"
    }
});

});


parcelRegister("avEc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $199f9ebdf7cd6ce5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $199f9ebdf7cd6ce5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    todayTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.today-button.today-tooltip",
        "defaultMessage": "Go to today"
    }
});

});


parcelRegister("eaNnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e40b7aa64b63a5$export$2e2bcd8739ae039);

var $gJYYK = parcelRequire("gJYYK");

var $lNNXV = parcelRequire("lNNXV");

var $dfXHf = parcelRequire("dfXHf");
var $39e40b7aa64b63a5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $dfXHf.default))((0, $gJYYK.LocalStorageCommandSubscriber));

});
parcelRegister("gJYYK", function(module, exports) {

$parcel$export(module.exports, "LocalStorageCommandSubscriber", () => $42c3fe06d1f8b069$export$f91a581fe8f664e2);

var $eUqFw = parcelRequire("eUqFw");

var $4r7Yr = parcelRequire("4r7Yr");
const $42c3fe06d1f8b069$export$f91a581fe8f664e2 = (props)=>{
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const commands = (0, $4r7Yr.storage).get((0, $28b554f5e98fe58e$export$41284951b2635542)) || null;
        if (Array.isArray(commands) && commands.length) {
            commands.forEach(({ type: commandType, values: values })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const command = props[commandType];
                if (typeof command === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                command(...values);
            });
            (0, $4r7Yr.storage).clearAll();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

});
const $28b554f5e98fe58e$export$41284951b2635542 = 'commands';

parcelRegister("4r7Yr", function(module, exports) {

$parcel$export(module.exports, "storage", () => $14dbed4a466fad5d$export$ddcffe0146c8f882);

var $89bO2 = parcelRequire("89bO2");

const $14dbed4a466fad5d$export$ddcffe0146c8f882 = (0, $89bO2.createSessionStorageProvider)('use-local-storage-command');

});


parcelRegister("dfXHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab49662b9909d00$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("khGZ4");
var $9RBvc = parcelRequire("9RBvc");
parcelRequire("kyGCj");
var $l1dWb = parcelRequire("l1dWb");


var $2iNiW = parcelRequire("2iNiW");
const $2ab49662b9909d00$var$mapDispatchToProps = (dispatch)=>({
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        groupBy: (group)=>group && dispatch((0, $l1dWb.changeGroup)({
                grouping: group
            })),
        resetHierarchyFilter: ()=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: {
                    start: undefined,
                    end: undefined
                }
            }));
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
                value: {
                    start: undefined,
                    end: undefined
                }
            }));
        },
        changeHierarchyFilter: (start, end)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: {
                    start: start,
                    end: end
                }
            }));
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
                value: {
                    start: start - 1,
                    end: end - 1
                }
            }));
        },
        changeStatusFilter: (value)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9b51ec1115932c53),
                value: value
            })),
        changeTeamFilter: (itemKey)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$8abe69ceb26771cd),
                value: [
                    itemKey
                ]
            })),
        changePriorityFilter: (priorityId)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
                value: [
                    priorityId
                ]
            })),
        changeDependenciesFilter: (value)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                value: value
            })),
        changeAssigneeFilter: (assigneeId)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$43596ee088b165a),
                value: [
                    assigneeId
                ]
            })),
        changeWarningFilter: (isEnabled)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$d6f1616882408daa),
                value: isEnabled
            })),
        changeIssueWarningFilter: (warningTypes)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$59af687b450af7eb),
                value: warningTypes
            })),
        changeEnabledWarningType: (warningTypes)=>dispatch((0, $9RBvc.resetEnabledWarningType)(new Set(warningTypes))),
        changeDateRangeFilter: (dateRange)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$82db1960569473ff),
                value: dateRange
            })),
        clearFilter: ()=>dispatch((0, $296Gg.clearAll)()),
        toggleViewMode: (mode)=>dispatch((0, $2iNiW.changeViewMode)(mode))
    });
var $2ab49662b9909d00$export$2e2bcd8739ae039 = $2ab49662b9909d00$var$mapDispatchToProps;

});
parcelRegister("khGZ4", function(module, exports) {

$parcel$export(module.exports, "clearAllComponentGroups", () => (parcelRequire("b7OiP")).clearAll);
$parcel$export(module.exports, "addComponentGroup", () => (parcelRequire("b7OiP")).add);
$parcel$export(module.exports, "updateComponentGroup", () => (parcelRequire("b7OiP")).update);
$parcel$export(module.exports, "removeComponentGroup", () => (parcelRequire("b7OiP")).remove);
$parcel$export(module.exports, "toggleShowWarning", () => (parcelRequire("9RBvc")).toggleShowWarning);
$parcel$export(module.exports, "resetEnabledWarningType", () => (parcelRequire("9RBvc")).resetEnabledWarningType);
$parcel$export(module.exports, "addLabelGroup", () => (parcelRequire("etElm")).add);
$parcel$export(module.exports, "updateLabelGroup", () => (parcelRequire("etElm")).update);
$parcel$export(module.exports, "removeLabelGroup", () => (parcelRequire("etElm")).remove);
$parcel$export(module.exports, "clearAllLabelGroups", () => (parcelRequire("etElm")).clearAll);
$parcel$export(module.exports, "addCustomFieldValuesGroup", () => (parcelRequire("1MbUl")).add);
$parcel$export(module.exports, "updateCustomFieldValuesGroup", () => (parcelRequire("1MbUl")).update);
$parcel$export(module.exports, "removeCustomFieldValuesGroup", () => (parcelRequire("1MbUl")).remove);
$parcel$export(module.exports, "clearAllCustomFieldValuesGroups", () => (parcelRequire("1MbUl")).clearAll);

var $b7OiP = parcelRequire("b7OiP");

var $e0l3L = parcelRequire("e0l3L");

var $9RBvc = parcelRequire("9RBvc");

var $etElm = parcelRequire("etElm");

var $1MbUl = parcelRequire("1MbUl");

});
parcelRegister("b7OiP", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $71b0595735314bed$export$4a991c87e640ef77);
$parcel$export(module.exports, "CLEAR_ALL", () => $71b0595735314bed$export$a4b3b534f9c4179f);
$parcel$export(module.exports, "ADD", () => $71b0595735314bed$export$bb6389024b71c2ae);
$parcel$export(module.exports, "UPDATE", () => $71b0595735314bed$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $71b0595735314bed$export$29d55e1f664a246b);
$parcel$export(module.exports, "clearAll", () => $71b0595735314bed$export$1042faa6df30c26);
$parcel$export(module.exports, "add", () => $71b0595735314bed$export$e16d8520af44a096);
$parcel$export(module.exports, "update", () => $71b0595735314bed$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $71b0595735314bed$export$cd7f480d6b8286c3);
const $71b0595735314bed$export$4a991c87e640ef77 = 'state.domain.view-settings.component-groups.RESET';
const $71b0595735314bed$export$a4b3b534f9c4179f = 'state.domain.view-settings.component-groups.CLEAR_ALL';
const $71b0595735314bed$export$bb6389024b71c2ae = 'state.domain.view-settings.component-groups.ADD';
const $71b0595735314bed$export$e271b26eefe41db8 = 'state.domain.view-settings.component-groups.UPDATE';
const $71b0595735314bed$export$29d55e1f664a246b = 'state.domain.view-settings.component-groups.REMOVE';
const $71b0595735314bed$export$aad8462122ac592b = (payload)=>({
        type: $71b0595735314bed$export$4a991c87e640ef77,
        payload: payload
    });
const $71b0595735314bed$export$1042faa6df30c26 = ()=>({
        type: $71b0595735314bed$export$a4b3b534f9c4179f
    });
const $71b0595735314bed$export$e16d8520af44a096 = (payload)=>({
        type: $71b0595735314bed$export$bb6389024b71c2ae,
        payload: payload
    });
const $71b0595735314bed$export$722fbec263ad908a = (payload)=>({
        type: $71b0595735314bed$export$e271b26eefe41db8,
        payload: payload
    });
const $71b0595735314bed$export$cd7f480d6b8286c3 = (payload)=>({
        type: $71b0595735314bed$export$29d55e1f664a246b,
        payload: payload
    });

});

parcelRegister("etElm", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $c395a9040acb268d$export$4a991c87e640ef77);
$parcel$export(module.exports, "CLEAR_ALL", () => $c395a9040acb268d$export$a4b3b534f9c4179f);
$parcel$export(module.exports, "ADD", () => $c395a9040acb268d$export$bb6389024b71c2ae);
$parcel$export(module.exports, "UPDATE", () => $c395a9040acb268d$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $c395a9040acb268d$export$29d55e1f664a246b);
$parcel$export(module.exports, "clearAll", () => $c395a9040acb268d$export$1042faa6df30c26);
$parcel$export(module.exports, "add", () => $c395a9040acb268d$export$e16d8520af44a096);
$parcel$export(module.exports, "update", () => $c395a9040acb268d$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $c395a9040acb268d$export$cd7f480d6b8286c3);
const $c395a9040acb268d$export$4a991c87e640ef77 = 'state.domain.view-settings.label-groups.RESET';
const $c395a9040acb268d$export$a4b3b534f9c4179f = 'state.domain.view-settings.label-groups.CLEAR_ALL';
const $c395a9040acb268d$export$bb6389024b71c2ae = 'state.domain.view-settings.label-groups.ADD';
const $c395a9040acb268d$export$e271b26eefe41db8 = 'state.domain.view-settings.label-groups.UPDATE';
const $c395a9040acb268d$export$29d55e1f664a246b = 'state.domain.view-settings.label-groups.REMOVE';
const $c395a9040acb268d$export$aad8462122ac592b = (payload)=>({
        type: $c395a9040acb268d$export$4a991c87e640ef77,
        payload: payload
    });
const $c395a9040acb268d$export$1042faa6df30c26 = ()=>({
        type: $c395a9040acb268d$export$a4b3b534f9c4179f
    });
const $c395a9040acb268d$export$e16d8520af44a096 = (payload)=>({
        type: $c395a9040acb268d$export$bb6389024b71c2ae,
        payload: payload
    });
const $c395a9040acb268d$export$722fbec263ad908a = (payload)=>({
        type: $c395a9040acb268d$export$e271b26eefe41db8,
        payload: payload
    });
const $c395a9040acb268d$export$cd7f480d6b8286c3 = (payload)=>({
        type: $c395a9040acb268d$export$29d55e1f664a246b,
        payload: payload
    });

});

parcelRegister("1MbUl", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $b87bb6e5d406197e$export$4a991c87e640ef77);
$parcel$export(module.exports, "CLEAR_ALL", () => $b87bb6e5d406197e$export$a4b3b534f9c4179f);
$parcel$export(module.exports, "ADD", () => $b87bb6e5d406197e$export$bb6389024b71c2ae);
$parcel$export(module.exports, "UPDATE", () => $b87bb6e5d406197e$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $b87bb6e5d406197e$export$29d55e1f664a246b);
$parcel$export(module.exports, "clearAll", () => $b87bb6e5d406197e$export$1042faa6df30c26);
$parcel$export(module.exports, "add", () => $b87bb6e5d406197e$export$e16d8520af44a096);
$parcel$export(module.exports, "update", () => $b87bb6e5d406197e$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $b87bb6e5d406197e$export$cd7f480d6b8286c3);
const $b87bb6e5d406197e$export$4a991c87e640ef77 = 'state.domain.view-settings.custom-field-values-groups.RESET';
const $b87bb6e5d406197e$export$a4b3b534f9c4179f = 'state.domain.view-settings.custom-field-values-groups.CLEAR_ALL';
const $b87bb6e5d406197e$export$bb6389024b71c2ae = 'state.domain.view-settings.custom-field-values-groups.ADD';
const $b87bb6e5d406197e$export$e271b26eefe41db8 = 'state.domain.view-settings.custom-field-values-groups.UPDATE';
const $b87bb6e5d406197e$export$29d55e1f664a246b = 'state.domain.view-settings.custom-field-values-groups.REMOVE';
const $b87bb6e5d406197e$export$aad8462122ac592b = (payload)=>({
        type: $b87bb6e5d406197e$export$4a991c87e640ef77,
        payload: payload
    });
const $b87bb6e5d406197e$export$1042faa6df30c26 = (payload)=>({
        type: $b87bb6e5d406197e$export$a4b3b534f9c4179f,
        payload: payload
    });
const $b87bb6e5d406197e$export$e16d8520af44a096 = (payload)=>({
        type: $b87bb6e5d406197e$export$bb6389024b71c2ae,
        payload: payload
    });
const $b87bb6e5d406197e$export$722fbec263ad908a = (payload)=>({
        type: $b87bb6e5d406197e$export$e271b26eefe41db8,
        payload: payload
    });
const $b87bb6e5d406197e$export$cd7f480d6b8286c3 = (payload)=>({
        type: $b87bb6e5d406197e$export$29d55e1f664a246b,
        payload: payload
    });

});


parcelRegister("2iNiW", function(module, exports) {

$parcel$export(module.exports, "CHANGE_VIEW_MODE", () => $0f92e021c28f9de3$export$56b6d17900a97f5);
$parcel$export(module.exports, "changeViewMode", () => $0f92e021c28f9de3$export$36fa93dbf109f538);
const $0f92e021c28f9de3$export$56b6d17900a97f5 = 'state.domain.views.SET_VIEW_MODE';
const $0f92e021c28f9de3$export$36fa93dbf109f538 = (mode)=>({
        type: $0f92e021c28f9de3$export$56b6d17900a97f5,
        payload: {
            mode: mode
        }
    });

});





parcelRegister("4MsBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4c2bddb76a7469$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jIb7y = parcelRequire("jIb7y");

var $13uf3 = parcelRequire("13uf3");
var $6c4c2bddb76a7469$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jIb7y.default), {})((0, $13uf3.default));

});
parcelRegister("jIb7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6141e5308d24192$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $c6141e5308d24192$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    viewMode: (0, $9H2AP.getViewMode),
    isLoading: (0, $kwMvv.getIsIssuesLoading)
});

});

parcelRegister("13uf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb79faa152382189$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $lcvrv = parcelRequire("lcvrv");

var $abgpq = parcelRequire("abgpq");

var $2q9P7 = parcelRequire("2q9P7");

var $6qzs4 = parcelRequire("6qzs4");
// When cleaning up FF com.atlassian.rm.jpo.transposition we can remove this component entirely
const $bb79faa152382189$var$RoadmapWrapper = ({ viewMode: viewMode, isLoading: isLoading, ...props })=>{
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) {
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6qzs4.TableSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2q9P7.default), null);
        if (viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb79faa152382189$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6qzs4.TableSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props));
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6qzs4.TableSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2q9P7.default), null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props);
};
/* A hack to render the skeleton over the roadmap component, otherwise Roadmap component rows are not rendered correctly */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb79faa152382189$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbyzo7u",
            __cmplp.className
        ])
    });
});
var $bb79faa152382189$export$2e2bcd8739ae039 = $bb79faa152382189$var$RoadmapWrapper;

});
parcelRegister("2q9P7", function(module, exports) {

$parcel$export(module.exports, "default", () => $72787893e2087d3b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $6qzs4 = parcelRequire("6qzs4");

const $72787893e2087d3b$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("kxW6Q")).then((module)=>module.PlanTable), {
    moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/roadmap/table/index.tsx"
});
const $72787893e2087d3b$var$AsyncComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "plan-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6qzs4.TableSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72787893e2087d3b$var$LazyComponent, null));
var $72787893e2087d3b$export$2e2bcd8739ae039 = $72787893e2087d3b$var$AsyncComponent;

});
parcelRegister("6qzs4", function(module, exports) {

$parcel$export(module.exports, "TableSkeleton", () => $e2f62a1ea3608d10$export$7afc19c20799c3c1);

var $eUqFw = parcelRequire("eUqFw");

var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9hVJ7 = parcelRequire("9hVJ7");
var $1WecH = parcelRequire("1WecH");
var $dSEBM = parcelRequire("dSEBM");

var $ib5d3 = parcelRequire("ib5d3");

var $bi4E4 = parcelRequire("bi4E4");
var $3bHoQ = parcelRequire("3bHoQ");
var $9j3PG = parcelRequire("9j3PG");
var $lghGU = parcelRequire("lghGU");

var $c6XhM = parcelRequire("c6XhM");
const $e2f62a1ea3608d10$var$HeaderRow = ({ index: index, columns: columns })=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
        index: index,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--plan-grid-row-background': `var(--ds-background-neutral, ${(0, $PdmhA).N20A})`
        }
    }, // eslint-disable-next-line @typescript-eslint/no-shadow
    columns.map((column, index)=>{
        switch(column.tag){
            case 'SCOPE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: [
                        $e2f62a1ea3608d10$var$cellStyles,
                        $e2f62a1ea3608d10$var$headerCellStyles
                    ]
                }, intl.formatMessage((0, $c6XhM.default).issue));
            case 'FIELDS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: [
                        $e2f62a1ea3608d10$var$cellStyles,
                        $e2f62a1ea3608d10$var$headerCellStyles
                    ]
                }, intl.formatMessage((0, $c6XhM.default).fields));
            case 'TIMELINE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: [
                        $e2f62a1ea3608d10$var$cellStyles,
                        $e2f62a1ea3608d10$var$headerCellStyles
                    ]
                });
            default:
                return null;
        }
    }));
};
const $e2f62a1ea3608d10$var$SubheaderRow = ({ index: index, columns: columns })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
        index: index
    }, // eslint-disable-next-line @typescript-eslint/no-shadow
    columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
            key: index,
            column: index,
            xcss: [
                $e2f62a1ea3608d10$var$cellStyles,
                $e2f62a1ea3608d10$var$headerCellStyles
            ]
        })));
const $e2f62a1ea3608d10$var$BodyRow = ({ index: index, columns: columns, animate: animate })=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
        index: index
    }, // eslint-disable-next-line @typescript-eslint/no-shadow
    columns.map((column, index)=>{
        switch(column.tag){
            case 'SCOPE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: $e2f62a1ea3608d10$var$cellStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    style: {
                        width: '100%',
                        height: '600px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hVJ7.default), {
                    ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage),
                    numOfIssues: 11,
                    sidePadding: 16,
                    showIssueSelectCheckbox: true,
                    showIssueWithoutParent: true,
                    animate: animate
                })));
            case 'FIELDS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: $e2f62a1ea3608d10$var$cellStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    style: {
                        width: '100%',
                        height: '600px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WecH.default), {
                    ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage),
                    numOfRows: 13,
                    spaceInBetween: 12,
                    animate: animate
                })));
            case 'TIMELINE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                    key: index,
                    column: index,
                    xcss: $e2f62a1ea3608d10$var$cellStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    style: {
                        width: '100%',
                        height: '600px'
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSEBM.default), {
                    ariaLabel: intl.formatMessage((0, $ib5d3.default).loadingIssuesMessage),
                    animate: animate
                })));
            default:
                return null;
        }
    }));
};
const $e2f62a1ea3608d10$export$7afc19c20799c3c1 = ({ animate: animate = true })=>{
    const columnConfigs = [
        {
            id: 'scope',
            sticky: false
        },
        {
            id: 'fields',
            sticky: false
        },
        {
            id: 'timeline',
            sticky: false
        }
    ];
    const columnWidths = [
        200,
        ...Array(1).fill(300),
        undefined
    ];
    const rowConfigs = [
        /* Header */ {
            sticky: false,
            height: 50,
            thead: true,
            top: 0
        },
        /* SubHeader */ {
            sticky: false,
            height: 40,
            thead: true,
            top: 50
        },
        {
            sticky: false,
            height: 550,
            thead: false,
            top: 90
        }
    ];
    const rows = [
        {
            tag: 'HEADER',
            content: 'header'
        },
        {
            tag: 'SUBHEADER',
            content: 'subheader'
        },
        {
            tag: 'BODY',
            content: 'body'
        }
    ];
    const columns = [
        {
            tag: 'SCOPE',
            name: 'scope'
        },
        {
            tag: 'FIELDS',
            name: 'fields'
        },
        {
            tag: 'TIMELINE',
            name: 'timeline'
        }
    ];
    const stickyOffset = {
        vertical: 0,
        horizontal: 0
    };
    const uniq = (a)=>Array.from(new Set(a));
    const rangeExtractor = ({ above: above, within: within, below: below })=>uniq([
            0,
            1,
            ...above,
            ...within,
            ...below
        ]);
    const renderRow = (_row, _columns, index)=>{
        const row = rows[index];
        if (row.tag === 'HEADER') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f62a1ea3608d10$var$HeaderRow, {
            key: index,
            index: index,
            columns: columns
        });
        if (row.tag === 'SUBHEADER') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f62a1ea3608d10$var$SubheaderRow, {
            key: index,
            index: index,
            columns: columns
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2f62a1ea3608d10$var$BodyRow, {
            key: index,
            index: index,
            columns: columns,
            animate: animate
        });
    };
    const renderEmpty = (height)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
            index: -1,
            height: height
        }, columns.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
                key: index,
                column: index,
                xcss: $e2f62a1ea3608d10$var$cellStyles
            })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bHoQ.Container), {
        xcss: $e2f62a1ea3608d10$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9j3PG.Grid), {
        columnConfigs: columnConfigs,
        columnWidths: columnWidths,
        rowConfigs: rowConfigs,
        row: renderRow,
        empty: renderEmpty,
        overscan: 20,
        stickyOffset: stickyOffset,
        rangeExtractor: rangeExtractor,
        onColumnWidthsChange: ()=>null
    }, (table)=>table));
};
const $e2f62a1ea3608d10$var$containerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    inset: 'space.0',
    // @ts-expect-error - TS2322: Type number is not assignable to type
    zIndex: 0,
    backgroundColor: 'elevation.surface'
});
const $e2f62a1ea3608d10$var$cellStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`}`,
    backgroundColor: 'elevation.surface',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.250',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
    fontWeight: '500',
    // @ts-expect-error - TS2322: Type number is not assignable to type
    zIndex: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':nth-of-type(1)': {
        paddingLeft: 'space.250'
    },
    '::after': {
        content: '""',
        position: 'absolute',
        inset: 'space.0',
        background: 'var(--plan-grid-row-background)',
        // @ts-expect-error - TS2322: Type number is not assignable to type
        zIndex: -1
    }
});
const $e2f62a1ea3608d10$var$headerCellStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $PdmhA).N30})`}`
});

});
parcelRegister("bi4E4", function(module, exports) {

$parcel$export(module.exports, "Cell", () => $d3181f30485ca5d8$export$f6f0c3fe4ec306ea);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $75yqq = parcelRequire("75yqq");

var $2UUbW = parcelRequire("2UUbW");

var $lhEfD = parcelRequire("lhEfD");
const $d3181f30485ca5d8$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ column: column, colSpan: colSpan, style: style, top: top, xcss: xcssStyles, ...restProps }, ref)=>{
    const { row: row, height: height } = (0, $lhEfD.useRow)();
    const [left] = (0, $2UUbW.useColumnStickyOffset)({
        column: column,
        preview: true
    });
    const isSticky = top !== undefined || left !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75yqq.CellProvider), {
        row: row,
        column: column,
        colSpan: colSpan ?? 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "td",
        ref: ref,
        colSpan: colSpan,
        xcss: [
            $d3181f30485ca5d8$var$cellStyles,
            isSticky && $d3181f30485ca5d8$var$stickyStyles,
            ...Array.isArray(xcssStyles) ? xcssStyles : [
                xcssStyles
            ]
        ],
        style: {
            top: top,
            left: left,
            height: height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        ...restProps
    }));
});
const $d3181f30485ca5d8$var$cellStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0',
    padding: 'space.0',
    position: 'relative'
});
const $d3181f30485ca5d8$var$stickyStyles = (0, $1ZAYh.xcss)({
    position: 'sticky'
});

});
parcelRegister("75yqq", function(module, exports) {

$parcel$export(module.exports, "CellProvider", () => $bdc5b1ca893176e1$export$e2f5665ccc36e4b4);
$parcel$export(module.exports, "useCell", () => $bdc5b1ca893176e1$export$42b866d2c5dc25d7);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $bdc5b1ca893176e1$var$store = (0, $a61MH.createStore)({
    initialState: {
        row: -1,
        column: -1,
        colSpan: 1
    },
    actions: {}
});
const $bdc5b1ca893176e1$export$e2f5665ccc36e4b4 = (0, $heB5U.createContainer)($bdc5b1ca893176e1$var$store, {
    onInit: ()=>({ setState: setState }, state)=>setState(state),
    onUpdate: ()=>({ setState: setState }, state)=>setState(state)
});
const $bdc5b1ca893176e1$export$42b866d2c5dc25d7 = (0, $ggKAj.createHook)($bdc5b1ca893176e1$var$store, {
    selector: ({ row: row, column: column, colSpan: colSpan })=>({
            row: row,
            column: column,
            colSpan: colSpan
        })
});

});

parcelRegister("2UUbW", function(module, exports) {

$parcel$export(module.exports, "useRowConfig", () => $364caad791dc671b$export$3916b4f063cc8548);
$parcel$export(module.exports, "useCollapsed", () => $364caad791dc671b$export$e175e0f853cf14a9);
$parcel$export(module.exports, "useColumnWidth", () => $364caad791dc671b$export$31b9262eef3f0be6);
$parcel$export(module.exports, "useColumnWidths", () => $364caad791dc671b$export$d598237875812773);
$parcel$export(module.exports, "useColumnStickyOffset", () => $364caad791dc671b$export$cd19232ee8dc72ec);
$parcel$export(module.exports, "useIsResizing", () => $364caad791dc671b$export$ea2cea7ba1ba54df);
$parcel$export(module.exports, "useColumns", () => $364caad791dc671b$export$c97dded465ef56fb);
$parcel$export(module.exports, "useGridActions", () => $364caad791dc671b$export$7964534a86470fa1);
$parcel$export(module.exports, "GridProvider", () => $364caad791dc671b$export$c4bf645ed2cecfdd);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $bAuUP = parcelRequire("bAuUP");
const $364caad791dc671b$var$store = (0, $a61MH.createStore)({
    initialState: {
        columns: [],
        widths: [],
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onWidthsChange: ()=>{},
        stickyOffset: {
            vertical: 0,
            horizontal: 0
        },
        rows: []
    },
    actions: $bAuUP.actions
});
const $364caad791dc671b$export$f6b86a04e5d66d90 = (0, $ggKAj.createHook)($364caad791dc671b$var$store);
const $364caad791dc671b$export$55e807591ce8819 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, col)=>state.columns[col]
});
const $364caad791dc671b$export$3916b4f063cc8548 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, col)=>state.rows[col]
});
const $364caad791dc671b$export$e175e0f853cf14a9 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (0, $bj4JM.createSelector)([
        (state, { column: column, colSpan: colSpan, preview: preview })=>((preview ? state.preview : undefined) ?? state.widths).slice(column, column + colSpan).reduce((acc, width = Infinity)=>Number.isFinite(acc) && Number.isFinite(width) ? acc + width : Infinity, 0),
        (_, { threshold: threshold })=>threshold
    ], (width, threshold)=>width <= threshold)
});
const $364caad791dc671b$export$31b9262eef3f0be6 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, { column: column, preview: preview })=>((preview ? state.preview : undefined) ?? state.widths).at(column)
});
const $364caad791dc671b$export$d598237875812773 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, { preview: preview })=>(preview ? state.preview : undefined) ?? state.widths
});
const $364caad791dc671b$export$cd19232ee8dc72ec = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, { column: column, preview: preview })=>state.columns[column].sticky ? ((preview ? state.preview : undefined) ?? state.widths).slice(0, column).reduce((offset = 0, width)=>offset + width, state.stickyOffset.horizontal) : undefined
});
const $364caad791dc671b$export$3346c37762cb30d3 = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state, { row: row, virtualized: virtualized })=>{
        const sticky = virtualized.filter((index)=>state.rows[index].sticky);
        if (!sticky.includes(row)) return undefined;
        return sticky.slice(0, sticky.indexOf(row)).map((index)=>state.rows[index]).reduce((acc, { height: height })=>acc + height, state.stickyOffset.vertical);
    }
});
const $364caad791dc671b$export$ea2cea7ba1ba54df = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state)=>state.preview !== undefined
});
const $364caad791dc671b$export$c97dded465ef56fb = (0, $ggKAj.createHook)($364caad791dc671b$var$store, {
    selector: (state)=>({
            columns: state.columns,
            widths: state.widths
        })
});
const $364caad791dc671b$export$7964534a86470fa1 = (0, $ggKAj.createActionsHook)($364caad791dc671b$var$store);
const $364caad791dc671b$export$c4bf645ed2cecfdd = (0, $heB5U.createContainer)($364caad791dc671b$var$store, {
    onInit: ()=>({ setState: setState }, state)=>setState(state),
    onUpdate: ()=>({ setState: setState }, state)=>setState(state)
});

});
parcelRegister("bAuUP", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3031d739eae61c81$export$e324594224ef24da);
const $3031d739eae61c81$export$e324594224ef24da = {
    resize: (col, delta, commit = false)=>({ setState: setState, getState: getState })=>{
            const { widths: widths, onWidthsChange: onWidthsChange, resizer: resizer } = getState();
            if (!resizer) return;
            const preview = resizer({
                column: col,
                delta: delta
            })(widths);
            if (commit) onWidthsChange(preview);
            setState({
                preview: commit ? undefined : preview
            });
        },
    setWidths: (next)=>({ setState: setState })=>setState({
                widths: next
            })
};

});



parcelRegister("3bHoQ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $da425f307b9e6b0e$export$42a852a2b6b56249);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2KzVh = parcelRequire("2KzVh");

var $7uxUn = parcelRequire("7uxUn");

var $2GybD = parcelRequire("2GybD");

/**
 * The grid "container" is responsible for reacting to changes in the viewport's scroll offset or dimensions.
 * Most of the logic exists to proxy when scrolling is active or inactive, since the scrollend event is not
 * yet available by our supported browsers.
 *
 */ const $da425f307b9e6b0e$var$Inner = ({ xcss: xcssStyles, children: children, containerRef: containerRef, outerRef: outerRef = null, ...props })=>{
    const ref = (0, $2KzVh.default)(containerRef, outerRef);
    const frameId = (0, $eUqFw.useRef)();
    const initialY = (0, $eUqFw.useRef)(0);
    const scrollStart = (0, $eUqFw.useRef)(-1);
    const { scrollTo: scrollTo, setRect: setRect, updateIsScrollingY: updateIsScrollingY } = (0, $2GybD.useContainerActions)();
    const onScrollEnd = (0, $eUqFw.useCallback)(()=>{
        scrollStart.current = -1;
        initialY.current = 0;
        updateIsScrollingY(false);
        if (frameId.current) {
            cancelAnimationFrame(frameId.current);
            frameId.current = undefined;
        }
    }, [
        updateIsScrollingY
    ]);
    /* From an initiating scroll event, recursively schedule animation frames until the
	 * user stops scrolling (indicated by no scroll events over a small time period).
	 *
	 * To minimise the number of updates and reduce flickering, we spend an additional
	 * frame to first determine which axis is being scrolled, and whether the offset has
	 * changed, before updating the store.
	 */ const scrollTick = (0, $eUqFw.useCallback)(()=>{
        if (!containerRef.current) return;
        const now = performance.now();
        const scrollTime = now - scrollStart.current;
        const { scrollLeft: scrollLeft, scrollTop: scrollTop } = containerRef.current;
        if (scrollTime >= (0, $c6ef39e5cb49e1b7$export$a9b912713512229e)) onScrollEnd();
        else {
            if (initialY.current !== scrollTop) updateIsScrollingY(true);
            scrollTo({
                x: scrollLeft,
                y: scrollTop,
                passive: true
            });
            frameId.current = requestAnimationFrame(scrollTick);
        }
    }, [
        containerRef,
        scrollTo,
        onScrollEnd,
        updateIsScrollingY
    ]);
    const handleScroll = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        scrollStart.current = performance.now();
        if (!frameId.current) {
            initialY.current = currentTarget.scrollTop;
            frameId.current = requestAnimationFrame(scrollTick);
        }
    }, [
        scrollTick
    ]);
    const handleResize = (0, $eUqFw.useCallback)(()=>{
        if (!containerRef.current) return;
        const { top: top, left: left } = containerRef.current.getBoundingClientRect();
        setRect({
            top: top,
            left: left,
            width: containerRef.current.clientWidth,
            height: containerRef.current.clientHeight
        });
    }, [
        containerRef,
        setRect
    ]);
    (0, $7uxUn.useResizeObserver)({
        ref: containerRef,
        onResize: handleResize
    });
    (0, $eUqFw.useEffect)(()=>()=>{
            frameId.current && cancelAnimationFrame(frameId.current);
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: ref,
        onScroll: handleScroll,
        xcss: [
            $da425f307b9e6b0e$var$containerStyles,
            ...Array.isArray(xcssStyles) ? xcssStyles : [
                xcssStyles
            ]
        ],
        ...props
    }, children);
};
const $da425f307b9e6b0e$export$42a852a2b6b56249 = (props)=>{
    const containerRef = (0, $eUqFw.useRef)(null);
    const scrollTo = (0, $eUqFw.useCallback)(({ x: x, y: y, smooth: smooth })=>{
        const containerEl = containerRef.current;
        if (!containerEl) return;
        if (smooth) containerEl.style.scrollBehavior = 'smooth';
        if (x !== undefined) containerEl.scrollLeft = x;
        if (y !== undefined) containerEl.scrollTop = y;
        if (smooth) containerEl.style.scrollBehavior = 'auto';
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GybD.ContainerProvider), {
        scrollTo: scrollTo
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da425f307b9e6b0e$var$Inner, {
        ...props,
        containerRef: containerRef
    }));
};
const $da425f307b9e6b0e$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
    overflow: 'auto',
    minWidth: '0',
    minHeight: '0'
});

});
parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("2GybD", function(module, exports) {

$parcel$export(module.exports, "useViewport", () => $e9f7a5f6f48315be$export$297ec8eb77d6211d);
$parcel$export(module.exports, "useScrollX", () => $e9f7a5f6f48315be$export$4f7901b64c931616);
$parcel$export(module.exports, "useScrollY", () => $e9f7a5f6f48315be$export$7a772f5370e86a14);
$parcel$export(module.exports, "useIsScrollingY", () => $e9f7a5f6f48315be$export$b4e5a0824bff5bca);
$parcel$export(module.exports, "useContainerActions", () => $e9f7a5f6f48315be$export$d5ad9ced4a1f0793);
$parcel$export(module.exports, "ContainerProvider", () => $e9f7a5f6f48315be$export$a5651d4e87ed3b2d);

var $bB8Mr = parcelRequire("bB8Mr");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lK0JM = parcelRequire("lK0JM");
const $e9f7a5f6f48315be$var$store = (0, $a61MH.createStore)({
    initialState: {
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        scrollX: 0,
        scrollY: 0,
        scrollTo: (0, (/*@__PURE__*/$parcel$interopDefault($bB8Mr))),
        isScrollingY: false,
        scrollEventHandlers: []
    },
    actions: $lK0JM.actions
});
const $e9f7a5f6f48315be$export$297ec8eb77d6211d = (0, $ggKAj.createHook)($e9f7a5f6f48315be$var$store, {
    selector: ({ top: top, left: left, width: width, height: height })=>({
            top: top,
            left: left,
            width: width,
            height: height
        })
});
const $e9f7a5f6f48315be$export$4f7901b64c931616 = (0, $ggKAj.createHook)($e9f7a5f6f48315be$var$store, {
    selector: ({ scrollX: scrollX })=>scrollX
});
const $e9f7a5f6f48315be$export$7a772f5370e86a14 = (0, $ggKAj.createHook)($e9f7a5f6f48315be$var$store, {
    selector: ({ scrollY: scrollY })=>scrollY
});
const $e9f7a5f6f48315be$export$b4e5a0824bff5bca = (0, $ggKAj.createHook)($e9f7a5f6f48315be$var$store, {
    selector: ({ isScrollingY: isScrollingY })=>isScrollingY
});
const $e9f7a5f6f48315be$export$d5ad9ced4a1f0793 = (0, $ggKAj.createActionsHook)($e9f7a5f6f48315be$var$store);
const $e9f7a5f6f48315be$export$a5651d4e87ed3b2d = (0, $heB5U.createContainer)($e9f7a5f6f48315be$var$store, {
    onInit: ()=>({ setState: setState }, state)=>setState(state),
    onUpdate: ()=>({ setState: setState }, state)=>setState(state)
});

});
parcelRegister("bB8Mr", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $8719f60363b3338a$var$func = $jFIrw('noop', (parcelRequire("jG2Eu")), (parcelRequire("jKGa6")));

$8719f60363b3338a$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $8719f60363b3338a$var$func;

});

parcelRegister("lK0JM", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e925ea7146101d8c$export$e324594224ef24da);

var $2eIIH = parcelRequire("2eIIH");
const $e925ea7146101d8c$export$e324594224ef24da = {
    setRect: (rect)=>({ setState: setState })=>setState(rect),
    scrollTo: ({ x: x, y: y, smooth: smooth, passive: passive = false })=>({ setState: setState, getState: getState })=>{
            const { scrollTo: scrollTo, scrollEventHandlers: scrollEventHandlers } = getState();
            if (!passive) scrollTo({
                x: x,
                y: y,
                smooth: smooth
            });
            const newState = {
                ...x !== undefined && {
                    scrollX: x
                },
                ...y !== undefined && {
                    scrollY: y
                }
            };
            setState(newState);
            scrollEventHandlers.forEach((callback)=>callback((0, (/*@__PURE__*/$parcel$interopDefault($2eIIH)))([
                    'scrollX',
                    'scrollY'
                ], {
                    ...getState(),
                    ...newState
                })));
        },
    addScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
            setState({
                scrollEventHandlers: getState().scrollEventHandlers.concat(callback)
            });
        },
    removeScrollHandler: (callback)=>({ getState: getState, setState: setState })=>{
            setState({
                scrollEventHandlers: getState().scrollEventHandlers.filter((eventHandler)=>eventHandler !== callback)
            });
        },
    updateIsScrollingY: (isScrollingY)=>({ setState: setState })=>setState({
                isScrollingY: isScrollingY
            })
};

});


const $c6ef39e5cb49e1b7$export$a9b912713512229e = 150;


parcelRegister("9j3PG", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $05862e9bf55f99ec$export$ef2184bd89960b14);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2GybD = parcelRequire("2GybD");

var $2UUbW = parcelRequire("2UUbW");

var $jxcYD = parcelRequire("jxcYD");

var $5U6wW = parcelRequire("5U6wW");

var $ksGzZ = parcelRequire("ksGzZ");

var $5j6n9 = parcelRequire("5j6n9");
const $05862e9bf55f99ec$var$Blanket = ()=>{
    const [isScrollingY] = (0, $2GybD.useIsScrollingY)();
    if (!isScrollingY) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $05862e9bf55f99ec$var$blanketStyles
    });
};
const $05862e9bf55f99ec$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $eUqFw.memo)(({ rowConfigs: rowConfigs, columnConfigs: columnConfigs, row: renderRow, empty: empty, children: children, stickyOffset: stickyOffset, rangeExtractor: rangeExtractor, columnWidths: columnWidths, overscan: overscan = 0, resizer: resizer, onColumnWidthsChange: onColumnWidthsChange, ariaLabel: ariaLabel, role: role, testId: testId, dataName: dataName })=>{
    const table = (top, bottom)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "table",
            xcss: $05862e9bf55f99ec$var$tableStyles,
            "aria-label": ariaLabel,
            role: role,
            testId: testId,
            "data-name": dataName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxcYD.Colgroup), {
            count: columnConfigs.length
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ksGzZ.Virtualized), {
            rowConfigs: rowConfigs
        }, ({ head: head, body: body, liteRowIndexes: liteRowIndexes, visibleCols: visibleCols })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05862e9bf55f99ec$var$Blanket, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "thead"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5U6wW.Head), {
                head: head,
                renderRow: renderRow,
                columnConfigs: columnConfigs
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "tbody"
            }, empty(top /* Virtualization */ ), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5U6wW.Body), {
                body: body,
                renderRow: renderRow,
                columnConfigs: columnConfigs,
                liteRowIndexes: liteRowIndexes,
                visibleCols: visibleCols
            }), empty(bottom))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            role: "presentation",
            xcss: $05862e9bf55f99ec$var$fillWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "table",
            xcss: [
                $05862e9bf55f99ec$var$tableStyles,
                $05862e9bf55f99ec$var$fillParentStyles
            ],
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxcYD.Colgroup), {
            count: columnConfigs.length
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "tbody"
        }, empty()))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5j6n9.Virtualizer), {
        rowConfigs: rowConfigs,
        overscan: overscan,
        rangeExtractor: rangeExtractor
    }, ({ top: top, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2UUbW.GridProvider), {
            columns: columnConfigs,
            widths: columnWidths,
            onWidthsChange: onColumnWidthsChange,
            rows: rowConfigs,
            stickyOffset: stickyOffset,
            resizer: resizer
        }, children?.(table(top, bottom))));
});
const $05862e9bf55f99ec$var$tableStyles = (0, $1ZAYh.xcss)({
    tableLayout: 'fixed',
    margin: 'space.0',
    borderCollapse: 'separate',
    borderSpacing: 0,
    minWidth: '100%'
});
const $05862e9bf55f99ec$var$fillParentStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $05862e9bf55f99ec$var$fillWrapperStyles = (0, $1ZAYh.xcss)({
    flex: 1,
    position: 'relative'
});
const $05862e9bf55f99ec$var$blanketStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.0',
    left: 'space.0',
    width: '100%',
    height: '100%',
    zIndex: 'blanket'
});

});
parcelRegister("jxcYD", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $a49739d7c23a067a$export$89efc2d0ceeaa030);

var $eUqFw = parcelRequire("eUqFw");

var $2UUbW = parcelRequire("2UUbW");
const $a49739d7c23a067a$export$89efc2d0ceeaa030 = /*#__PURE__*/ (0, $eUqFw.memo)(({ count: count })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("colgroup", null, Array(count).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a49739d7c23a067a$var$Col, {
            key: index,
            index: index
        }))));
/** Renders the <col /> which configure the DOM column widths. */ const $a49739d7c23a067a$var$Col = ({ index: index })=>{
    const [width] = (0, $2UUbW.useColumnWidth)({
        column: index,
        preview: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width,
            minWidth: width === undefined ? '100%' : undefined /* Will remove in column resizing */ 
        }
    });
};

});

parcelRegister("5U6wW", function(module, exports) {

$parcel$export(module.exports, "Head", () => $07704220594786a3$export$e93312b7773dfcac);
$parcel$export(module.exports, "Body", () => $07704220594786a3$export$4b2c32e08f77ff18);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $07704220594786a3$export$e93312b7773dfcac = /*#__PURE__*/ (0, $eUqFw.memo)(({ head: head, renderRow: renderRow, columnConfigs: columnConfigs })=>head.map(([row, rowIndex])=>renderRow(row, columnConfigs, rowIndex, undefined)), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $07704220594786a3$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $eUqFw.memo)(({ body: body, renderRow: renderRow, columnConfigs: columnConfigs, liteRowIndexes: liteRowIndexes, visibleCols: visibleCols })=>body.map(([row, rowIndex])=>renderRow(row, columnConfigs, rowIndex, liteRowIndexes.includes(rowIndex) ? {
            visibleCols: visibleCols
        } : undefined)));

});

parcelRegister("ksGzZ", function(module, exports) {

$parcel$export(module.exports, "Virtualized", () => $2ba6f8381487a832$export$2a39ec02a11a5d1d);

var $eUqFw = parcelRequire("eUqFw");

var $4lcmb = parcelRequire("4lcmb");

var $7S9oo = parcelRequire("7S9oo");

var $2GybD = parcelRequire("2GybD");

var $5mdds = parcelRequire("5mdds");
const $2ba6f8381487a832$var$EMPTY_LIST = [];
const $2ba6f8381487a832$var$EMPTY_COLS = {};
const $2ba6f8381487a832$export$2a39ec02a11a5d1d = ({ rowConfigs: rowConfigs, children: children })=>{
    const virtualized = (0, $5mdds.useVirtualized)();
    const [isScrollingY] = (0, $2GybD.useIsScrollingY)();
    const columnsVisible = (0, $7S9oo.useVisibleColumns)();
    const virtualizedRef = (0, $eUqFw.useRef)(undefined);
    const visibleColsRef = (0, $eUqFw.useRef)($2ba6f8381487a832$var$EMPTY_COLS);
    const [head, body] = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4lcmb)))(([rowConfig])=>rowConfig.thead)(rowConfigs.map((rowConfig, index)=>[
                rowConfig,
                index
            ]).filter(([, index])=>virtualized.includes(index))), [
        virtualized,
        rowConfigs
    ]);
    const prevVirtualized = (0, $eUqFw.useMemo)(()=>isScrollingY ? virtualizedRef.current : undefined, [
        isScrollingY
    ]);
    virtualizedRef.current = new Set(virtualized);
    visibleColsRef.current = columnsVisible;
    /**
	 * Generate row indexes for lite-row rendering
	 * Optimization - Render lite row only for the addition rows while scrolling
	 */ const liteRowIndexes = (0, $eUqFw.useMemo)(()=>prevVirtualized !== undefined ? virtualized.filter((index)=>!prevVirtualized.has(index)) : $2ba6f8381487a832$var$EMPTY_LIST, [
        virtualized,
        prevVirtualized
    ]);
    /**
	 * Clear visibleCols when user is not scrolling, keep track of scrolling with prevVirtualized
	 * Visible columns calculation is needed by lite rows only.
	 */ const visibleCols = (0, $eUqFw.useMemo)(()=>prevVirtualized !== undefined ? visibleColsRef.current : $2ba6f8381487a832$var$EMPTY_COLS, [
        prevVirtualized
    ]);
    return children({
        head: head,
        body: body,
        liteRowIndexes: liteRowIndexes,
        visibleCols: visibleCols
    });
};

});
parcelRegister("4lcmb", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $3292b565067e7f05$var$func = $jFIrw('partition', (parcelRequire("bwbFz")));

$3292b565067e7f05$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $3292b565067e7f05$var$func;

});

parcelRegister("7S9oo", function(module, exports) {

$parcel$export(module.exports, "useVisibleColumns", () => $233c801c2f443349$export$d9f6d58f0e1787fa);

var $eUqFw = parcelRequire("eUqFw");

var $2GybD = parcelRequire("2GybD");

var $2UUbW = parcelRequire("2UUbW");
const $233c801c2f443349$export$d9f6d58f0e1787fa = ()=>{
    const [{ columns: columns, widths: widths }] = (0, $2UUbW.useColumns)();
    const [scrollX] = (0, $2GybD.useScrollX)();
    const [{ width: width }] = (0, $2GybD.useViewport)();
    const visibleCols = (0, $eUqFw.useMemo)(()=>{
        const columnsVisibleArr = {};
        let left = 0;
        columns.forEach((col, index)=>{
            const currentWidth = widths[index];
            if (col.sticky || left >= scrollX && left + currentWidth <= scrollX + width) columnsVisibleArr[index.toString()] = true;
            else columnsVisibleArr[index.toString()] = false;
            left += currentWidth;
        });
        return columnsVisibleArr;
    }, [
        scrollX,
        width,
        columns,
        widths
    ]);
    return visibleCols;
};

});

parcelRegister("5mdds", function(module, exports) {

$parcel$export(module.exports, "VirtualizedProvider", () => $71e5807a18549178$export$2bf83f0278652f6);
$parcel$export(module.exports, "useVirtualized", () => $71e5807a18549178$export$f3792f52cefad05d);

var $eUqFw = parcelRequire("eUqFw");
const $71e5807a18549178$var$context = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $71e5807a18549178$export$2bf83f0278652f6 = $71e5807a18549178$var$context.Provider;
const $71e5807a18549178$export$f3792f52cefad05d = ()=>(0, $eUqFw.useContext)($71e5807a18549178$var$context);

});


parcelRegister("5j6n9", function(module, exports) {

$parcel$export(module.exports, "Virtualizer", () => $d17664f75a0c0c9e$export$89be5a243e59c4b2);

var $eUqFw = parcelRequire("eUqFw");

var $2GybD = parcelRequire("2GybD");

var $5mdds = parcelRequire("5mdds");

var $5Xsyg = parcelRequire("5Xsyg");
const $d17664f75a0c0c9e$export$89be5a243e59c4b2 = ({ rowConfigs: rowConfigs, rangeExtractor: rangeExtractor = ({ above: above, within: within, below: below })=>[
        ...above,
        ...within,
        ...below
    ], overscan: overscan, children: children })=>{
    const [scrollY] = (0, $2GybD.useScrollY)();
    const [{ height: height }] = (0, $2GybD.useViewport)();
    const scrollHeight = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-shadow
    ()=>rowConfigs.reduce((acc, { height: height })=>acc + height, 0), [
        rowConfigs
    ]);
    const [above, within, below] = (0, $5Xsyg.getRanges)(height, scrollY, (index)=>rowConfigs[index]?.height, overscan);
    const unextracted = [
        ...above,
        ...within,
        ...below
    ];
    const virtualized = (0, $5Xsyg.getExtractedRanges)(above, within, below, rangeExtractor);
    /** The indexes of the additional sticky rows */ const additionalSticky = virtualized.slice(0, Math.max(virtualized.indexOf(unextracted[0]?.index ?? 0), 0));
    const placeholder = {
        top: (unextracted.at(0)?.top ?? 0) - additionalSticky.reduce((acc, index)=>acc + (rowConfigs[index]?.height ?? 0), 0),
        bottom: Math.max(height, scrollHeight) - ((unextracted.at(-1)?.top ?? 0) + (unextracted.at(-1)?.height ?? 0))
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5mdds.VirtualizedProvider), {
        value: virtualized
    }, children(placeholder));
};

});
parcelRegister("5Xsyg", function(module, exports) {

$parcel$export(module.exports, "getRanges", () => $90f60144e07a628c$export$876a6466078c921c);
$parcel$export(module.exports, "getExtractedRanges", () => $90f60144e07a628c$export$1ea34a44b7a952c5);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");
const $90f60144e07a628c$export$876a6466078c921c = (containerHeight, scrollTop, getRowHeight, overscan = 20)=>{
    const above = [];
    const within = [];
    const below = [];
    let lastRow;
    const aboveViewport = (offset)=>offset < scrollTop;
    const belowViewport = (offset)=>offset > scrollTop + containerHeight;
    const inViewport = (offset)=>offset >= scrollTop && offset <= scrollTop + containerHeight;
    for(let cursor = 0; cursor < Infinity; cursor++){
        const height = getRowHeight(cursor);
        if (height === undefined) break;
        const top = lastRow ? lastRow.top + lastRow.height : 0;
        const row = {
            index: cursor,
            top: top,
            height: height
        };
        if (aboveViewport(row.top + row.height)) {
            above.push(row);
            while(above.length > overscan)above.shift();
        } else if (inViewport(row.top + row.height) || inViewport(row.top)) within.push(row);
        else if (belowViewport(row.top)) {
            if (below.length < overscan) below.push(row);
        }
        if (below.length >= overscan) break;
        lastRow = row;
    }
    return [
        above,
        within,
        below
    ];
};
const $90f60144e07a628c$export$1ea34a44b7a952c5 = (0, $5iWql.default)((above, within, below, rangeExtractor)=>{
    const getIndexes = (rows)=>rows.map(({ index: index })=>index);
    return rangeExtractor({
        above: getIndexes(above),
        within: getIndexes(within),
        below: getIndexes(below)
    });
}, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));

});



parcelRegister("lghGU", function(module, exports) {

$parcel$export(module.exports, "Row", () => $fefa8f62cf9464b5$export$b59bdbef9ce70de2);
/* eslint-disable jira/react/no-style-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $2UUbW = parcelRequire("2UUbW");

var $lhEfD = parcelRequire("lhEfD");
const $fefa8f62cf9464b5$export$b59bdbef9ce70de2 = ({ index: index, height: height, style: style, ...restProps })=>{
    const [rowConfig] = (0, $2UUbW.useRowConfig)(index);
    const finalHeight = height ?? rowConfig?.height ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhEfD.RowProvider), {
        row: index,
        height: finalHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "tr",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            height: finalHeight,
            ...style
        },
        ...restProps
    }));
};

});

parcelRegister("c6XhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a4f2dca2aea5a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c5a4f2dca2aea5a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issue: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.skeleton.issue",
        "defaultMessage": "Issue"
    },
    fields: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.table.skeleton.fields",
        "defaultMessage": "Fields"
    }
});

});


parcelRegister("kxW6Q", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("gWoXB")),
            load('6WzDy')
        ]);
        const value = parcelRequire('6jUfN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("gWoXB")),
        load("6WzDy")
    ]).then(()=>parcelRequire('6jUfN'));
}

});




parcelRegister("bKdiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8914f0cd3d327073$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Toolbar", () => (parcelRequire("eh10R")).default);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $eh10R = parcelRequire("eh10R");

var $9l42x = parcelRequire("9l42x");
const $8914f0cd3d327073$export$3a977cd83f945733 = (state)=>(0, $75KhQ.getPlan)(state).title;
const $8914f0cd3d327073$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $akhOi.getMode),
    isReadOnly: $akhOi.isReadOnly,
    isArchived: $akhOi.isArchived,
    plan: (0, $75KhQ.getPlan)
});
var $8914f0cd3d327073$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($8914f0cd3d327073$var$mapStateToProps, {})((0, $9l42x.PageHeader));

});
parcelRegister("eh10R", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf12d875952bb48$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $4UOY1 = parcelRequire("4UOY1");
const $7bf12d875952bb48$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $akhOi.getMode)
});
var $7bf12d875952bb48$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($7bf12d875952bb48$var$mapStateToProps, {})((0, $4UOY1.Toolbar));

});
parcelRegister("4UOY1", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $e7e3f097b78d03e9$export$4c260019440d418f);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $7Jv2m = parcelRequire("7Jv2m");

var $h7T2Y = parcelRequire("h7T2Y");
parcelRequire("akhOi");

var $5q8gK = parcelRequire("5q8gK");

var $kbEgN = parcelRequire("kbEgN");

var $1qPld = parcelRequire("1qPld");

var $30kLD = parcelRequire("30kLD");

var $Bp98t = parcelRequire("Bp98t");

var $jGytv = parcelRequire("jGytv");

var $gZhAv = parcelRequire("gZhAv");
const $e7e3f097b78d03e9$export$4c260019440d418f = ({ mode: mode, headerMode: headerMode = 'visible' })=>{
    const isShowReviewChangesinCompactToolbarEnabled = (0, $1ybV0.ff)('arj.show-review-changes-in-compact-header', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e3f097b78d03e9$var$RowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e3f097b78d03e9$var$LeftAlignment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jGytv.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
        name: (0, $7Jv2m.Spotlights).ShowAndTell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e3f097b78d03e9$var$LeftAlignment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qPld.default), null), mode !== (0, $99f9ac26081f8045$export$e91bb82ec00eb771) && mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Bp98t.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7e3f097b78d03e9$var$RightAlignment, null, mode !== (0, $99f9ac26081f8045$export$e91bb82ec00eb771) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30kLD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
        name: (0, $7Jv2m.Spotlights).ListMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZhAv.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
        name: (0, $7Jv2m.Spotlights).FindYourLook
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5q8gK.default), null)), isShowReviewChangesinCompactToolbarEnabled && headerMode === 'toolbar' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbEgN.default), null)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7e3f097b78d03e9$var$RowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $e7e3f097b78d03e9$var$RightAlignment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $e7e3f097b78d03e9$var$LeftAlignment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _zulpu2gc _1bah1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5q8gK", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c3ba8671f27813$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $lNNXV = parcelRequire("lNNXV");

var $j5KBC = parcelRequire("j5KBC");

var $apK5J = parcelRequire("apK5J");

var $cXU6N = parcelRequire("cXU6N");
const $94c3ba8671f27813$var$withAnalyticsContext = (Component)=>({ analyticsAttributes: analyticsAttributes, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "viewSettings",
            sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
            attributes: analyticsAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, rest));
// It has to be done like this else the class methods are not under the context
const $94c3ba8671f27813$var$ViewWithAnalyticsContext = $94c3ba8671f27813$var$withAnalyticsContext((0, $cXU6N.default));
var $94c3ba8671f27813$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $apK5J.default), (0, $j5KBC.default))($94c3ba8671f27813$var$ViewWithAnalyticsContext);

});
parcelRegister("j5KBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $06078b7515259cfe$export$2e2bcd8739ae039);
parcelRequire("1afYi");
var $9ffcO = parcelRequire("9ffcO");
parcelRequire("khGZ4");
var $b7OiP = parcelRequire("b7OiP");
var $1MbUl = parcelRequire("1MbUl");
var $etElm = parcelRequire("etElm");
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$06078b7515259cfe$export$2e2bcd8739ae039 = (dispatch)=>({
        clearAllComponentColours: ()=>{
            dispatch((0, $9ffcO.clearAllComponentColours)());
        },
        clearAllComponentGroups: ()=>{
            dispatch((0, $b7OiP.clearAll)());
        },
        clearAllCustomFieldValuesGroups: (grouping)=>{
            dispatch((0, $1MbUl.clearAll)({
                grouping: grouping
            }));
        },
        clearAllIssueTypeColours: ()=>{
            dispatch((0, $9ffcO.clearAllIssueTypeColours)());
        },
        clearAllLabelColours: ()=>{
            dispatch((0, $9ffcO.clearAllLabelColours)());
        },
        clearAllLabelGroups: ()=>{
            dispatch((0, $etElm.clearAll)());
        },
        clearAllPriorityColours: ()=>{
            dispatch((0, $9ffcO.clearAllPriorityColours)());
        },
        clearAllSelectColours: ()=>{
            dispatch((0, $9ffcO.clearAllSelectColours)());
        },
        toggleShowSprints: (showSprints)=>{
            dispatch((0, $l1dWb.toggleShowSprints)({
                showSprints: showSprints
            }));
        }
    });

});
parcelRegister("1afYi", function(module, exports) {

$parcel$export(module.exports, "updateProjectColorMap", () => $e9e06b53e1811873$export$783ec83b5bf86e1e);
$parcel$export(module.exports, "updateTeamColorMap", () => $e9e06b53e1811873$export$c5d50d9d2efc88a8);
$parcel$export(module.exports, "addComponentColour", () => (parcelRequire("9ffcO")).addComponentColour);
$parcel$export(module.exports, "addLabelColour", () => (parcelRequire("9ffcO")).addLabelColour);
$parcel$export(module.exports, "addSelectColour", () => (parcelRequire("9ffcO")).addSelectColour);
$parcel$export(module.exports, "updateComponentColour", () => (parcelRequire("9ffcO")).updateComponentColour);
$parcel$export(module.exports, "updateLabelColour", () => (parcelRequire("9ffcO")).updateLabelColour);
$parcel$export(module.exports, "updateSelectColour", () => (parcelRequire("9ffcO")).updateSelectColour);
$parcel$export(module.exports, "removeComponentColour", () => (parcelRequire("9ffcO")).removeComponentColour);
$parcel$export(module.exports, "removeLabelColour", () => (parcelRequire("9ffcO")).removeLabelColour);
$parcel$export(module.exports, "removeSelectColour", () => (parcelRequire("9ffcO")).removeSelectColour);
$parcel$export(module.exports, "clearAllComponentColours", () => (parcelRequire("9ffcO")).clearAllComponentColours);
$parcel$export(module.exports, "clearAllIssueTypeColours", () => (parcelRequire("9ffcO")).clearAllIssueTypeColours);
$parcel$export(module.exports, "clearAllLabelColours", () => (parcelRequire("9ffcO")).clearAllLabelColours);
$parcel$export(module.exports, "clearAllPriorityColours", () => (parcelRequire("9ffcO")).clearAllPriorityColours);
$parcel$export(module.exports, "clearAllSelectColours", () => (parcelRequire("9ffcO")).clearAllSelectColours);

var $9FeHi = parcelRequire("9FeHi");
var $l3byl = parcelRequire("l3byl");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $ehEr2 = parcelRequire("ehEr2");

var $MQRDu = parcelRequire("MQRDu");

var $33N5G = parcelRequire("33N5G");

var $9ffcO = parcelRequire("9ffcO");
/**
 * Rebuilds the colorBy map to accommodate new entities that that got added to the plan.
 * The method tries to keep the previous colors as is and assign new colors to the newly added entities.
 * @param colorMapOfViewPreference
 * @param entityIds
 * @param colorByOption
 */ function $e9e06b53e1811873$var$rebuildColorMap(colorMapOfViewPreference, entityIds, colorByOption) {
    const colorMap = colorMapOfViewPreference[colorByOption];
    // Since the preferences might contain entities which do not exist in the plan anymore
    // we need to filter these out and make use of these colours
    const colourOfEntitiesInThisPlan = $l3byl.default(Object.keys(colorMap).filter((p)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entityIds.includes(Number(p))), colorMap);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let newColorMap = {};
    for (const id of entityIds)// if the entity exists in the preference
    if (colorMap[id]) newColorMap = {
        ...newColorMap,
        [id]: colorMap[id]
    };
    else {
        const freeColors = $9FeHi.default((0, $33N5G.colourPalette), [
            ...Object.values(newColorMap),
            ...colourOfEntitiesInThisPlan
        ]);
        newColorMap[id] = freeColors[0] || (0, $33N5G.colourPalette)[entityIds.length % (0, $33N5G.colourPalette).length];
    }
    return newColorMap;
}
function* $e9e06b53e1811873$export$783ec83b5bf86e1e(colorMapOfViewPreference) {
    const projectIds = (yield (0, $9e8i2.select)((0, $ehEr2.getProjects))).map((p)=>p.id);
    return $e9e06b53e1811873$var$rebuildColorMap(colorMapOfViewPreference, projectIds, 'project');
}
function* $e9e06b53e1811873$export$c5d50d9d2efc88a8(colorMapOfViewPreference) {
    const teamIds = (yield (0, $9e8i2.select)((0, $MQRDu.getAllTeams))).map((p)=>p.id);
    return $e9e06b53e1811873$var$rebuildColorMap(colorMapOfViewPreference, teamIds, 'team');
}

});


parcelRegister("apK5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b67eecfc1a92ab1d$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");

var $9RUk7 = parcelRequire("9RUk7");
const $b67eecfc1a92ab1d$var$getAnalyticsAttributes = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getPlan),
    (0, $ehEr2.getIsSimplifiedProjectAvailable),
    (0, $9H2AP.getColorByViewSettings),
    (0, $kyGCj.getVisualisationGrouping),
    (0, $kyGCj.getVisualisationSorting),
    (0, $kyGCj.getShowSprints),
    (0, $9H2AP.getDependencySettings),
    (0, $9H2AP.getRollupViewSettings),
    (0, $kKj1m.getCustomFields)
], (plan, planContainsNextGenIssues, colorBy, grouping, sorting, showSprints, dependencySettings, rollUpSettings, customFields)=>({
        viewSettingsDetails: {
            colorBy: colorBy.colourByValue,
            sortBy: sorting.field,
            groupBy: (0, $9RUk7.getGroupForAnalyticEvent)(grouping, customFields),
            showCapacityOnTimeline: showSprints,
            dependencyStyle: dependencySettings.display,
            rollUpDates: rollUpSettings.showingRolledUpDate,
            rollUpOthers: rollUpSettings.showRolledUpOthers
        },
        planId: plan.id,
        planContainsNextGenIssues: planContainsNextGenIssues
    }));
var $b67eecfc1a92ab1d$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    analyticsAttributes: $b67eecfc1a92ab1d$var$getAnalyticsAttributes,
    colourByConfiguration: (0, $9H2AP.getColorByViewSettings),
    grouping: (0, $kyGCj.getVisualisationGrouping),
    groupingByMultiValueCustomField: (0, $kyGCj.isGroupByMultiValueCustomField),
    showSprints: (0, $kyGCj.getShowSprints)
});

});

parcelRegister("cXU6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c764ddf094d1134a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $fUQgT = parcelRequire("fUQgT");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $6ETZE = parcelRequire("6ETZE");
var $eNhh9 = parcelRequire("eNhh9");

var $cuuJa = parcelRequire("cuuJa");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");

var $dEh7f = parcelRequire("dEh7f");

var $ir8Bb = parcelRequire("ir8Bb");

var $frPga = parcelRequire("frPga");

var $bHxpc = parcelRequire("bHxpc");

var $eoc9T = parcelRequire("eoc9T");

var $kVa9T = parcelRequire("kVa9T");

var $9V71l = parcelRequire("9V71l");

var $4a353 = parcelRequire("4a353");

var $kINxd = parcelRequire("kINxd");

var $cpL1H = parcelRequire("cpL1H");

var $lDofH = parcelRequire("lDofH");

var $69mNn = parcelRequire("69mNn");

var $bRrol = parcelRequire("bRrol");

var $6YgBT = parcelRequire("6YgBT");

var $2SySz = parcelRequire("2SySz");

var $03EuP = parcelRequire("03EuP");
class $c764ddf094d1134a$export$4d0b6d35abb3362d extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ColourBy: $dEh7f.default,
            ColourByIssueType: $frPga.default,
            ColourByLabel: $bHxpc.default,
            ColourByComponent: $ir8Bb.default,
            ColourByPriority: $eoc9T.default,
            ColourBySelect: $kVa9T.default,
            DependencySettings: $4a353.default,
            GroupBy: $kINxd.default,
            GroupByComponents: $cpL1H.default,
            SortBy: $2SySz.default,
            EstimateRollup: $6YgBT.default,
            groupingByMultiValueCustomField: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, this.renderContent()),
            isOpen: this.state.isOpen,
            onClose: ()=>{
                if (this.state.isDialogLocked) return;
                this.setState({
                    isOpen: false
                }, ()=>{
                    this.buttonRef.current?.focus();
                });
            },
            placement: "bottom-end"
        }, this.renderTriggerButton());
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: !!this.props.isDefaultOpen,
            isDialogLocked: false
        };
        this.buttonRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.toggleDialogLocked = (isDialogLocked)=>{
            this.setState({
                isDialogLocked: isDialogLocked
            });
        };
        this.toggleMenu = (_, analyticsEvent)=>{
            this.setState(({ isOpen: isOpen })=>{
                if (!isOpen) {
                    const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).INLINE_DIALOG_VIEWED.split(' ');
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                        actionSubject: actionSubject,
                        action: action
                    }));
                }
                return {
                    isOpen: !isOpen
                };
            });
        };
        this.renderTriggerButton = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { isOpen: isOpen } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
                    label: ""
                }),
                isSelected: isOpen,
                onClick: this.toggleMenu,
                ref: this.buttonRef,
                "aria-expanded": this.state.isOpen,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.button"
            }, formatMessage((0, $bRrol.default).triggerButtonLabel));
        };
        this.renderColourByIssueTypeLegend = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { ColourByIssueType: ColourByIssueType } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, ColourByIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourByIssueType, {
                onMenuToggle: this.toggleDialogLocked
            }))));
        };
        this.renderColourByLabelLegend = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { ColourByLabel: ColourByLabel } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, ColourByLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourByLabel, {
                onMenuToggle: this.toggleDialogLocked
            }))));
        };
        this.renderColourByComponentLegend = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { ColourByComponent: ColourByComponent } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, ColourByComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourByComponent, {
                onMenuToggle: this.toggleDialogLocked
            }))));
        };
        this.renderColourByPriorityLegend = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { ColourByPriority: ColourByPriority } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, ColourByPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourByPriority, {
                onMenuToggle: this.toggleDialogLocked
            }))));
        };
        this.renderColourBySelectLegend = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { ColourBySelect: ColourBySelect } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, ColourBySelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourBySelect, {
                onMenuToggle: this.toggleDialogLocked
            }))));
        };
        this.renderColourByClearButton = ()=>{
            const { clearAllComponentColours: clearAllComponentColours, clearAllIssueTypeColours: clearAllIssueTypeColours, clearAllLabelColours: clearAllLabelColours, clearAllPriorityColours: clearAllPriorityColours, clearAllSelectColours: clearAllSelectColours, colourByConfiguration: { colourByValue: colourByValue } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                onClick: (e)=>{
                    // This is required to keep ViewSettings InlineDialog open.
                    e.preventDefault();
                    if (colourByValue === (0, $33N5G.colourByOptions).COMPONENT) clearAllComponentColours();
                    else if (colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE) clearAllIssueTypeColours();
                    else if (colourByValue === (0, $33N5G.colourByOptions).LABEL) clearAllLabelColours();
                    else if (colourByValue === (0, $33N5G.colourByOptions).PRIORITY) clearAllPriorityColours();
                    else if ((0, $kyGCj.isColorByCustomFieldOption)(colourByValue)) clearAllSelectColours();
                },
                spacing: "compact",
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-colors"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bRrol.default).clearAllColours));
        };
        this.shouldShowClearButton = ()=>{
            const { colourByConfiguration: { colourByValue: colourByValue, colourIssueTypes: colourIssueTypes, colourLabels: colourLabels, colourPriorities: colourPriorities, colourSelects: colourSelects, colourComponents: colourComponents } } = this.props;
            if (colourByValue === (0, $33N5G.colourByOptions).COMPONENT) {
                const isAddingNewComponentColour = colourComponents.some(({ colour: colour })=>!colour);
                return colourComponents.length > (isAddingNewComponentColour ? 1 : 0);
            }
            if (colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE) {
                if ((0, $7CnHa.isDefined)(colourIssueTypes)) {
                    const isAddingNewIssueTypeColour = colourIssueTypes.some(({ colour: colour })=>!colour);
                    return colourIssueTypes.length > (isAddingNewIssueTypeColour ? 1 : 0);
                }
                return false;
            }
            if (colourByValue === (0, $33N5G.colourByOptions).LABEL) {
                const isAddingNewLabelColour = colourLabels.some(({ colour: colour })=>!colour);
                return colourLabels.length > (isAddingNewLabelColour ? 1 : 0);
            }
            if (colourByValue === (0, $33N5G.colourByOptions).PRIORITY) {
                if ((0, $7CnHa.isDefined)(colourPriorities)) {
                    const isAddingNewPriorityColour = colourPriorities.some(({ colour: colour })=>!colour);
                    return colourPriorities.length > (isAddingNewPriorityColour ? 1 : 0);
                }
                return false;
            }
            if ((0, $kyGCj.isColorByCustomFieldOption)(colourByValue)) {
                const isAddingNewSelectColour = (colourSelects[colourByValue] || []).some(({ colour: colour })=>!colour);
                return (colourSelects[colourByValue] || []).length > (isAddingNewSelectColour ? 1 : 0);
            }
            return false;
        };
        this.shouldShowClearAllGroupsButton = ()=>{
            const { grouping: grouping, groupingByMultiValueCustomField: groupingByMultiValueCustomField } = this.props;
            return grouping === (0, $5rYNM.GROUPING).COMPONENT || grouping === (0, $5rYNM.GROUPING).LABEL || groupingByMultiValueCustomField;
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onClearAllGroups = (e = {
            preventDefault: ()=>{}
        })=>{
            // This is required to keep ViewSettings InlineDialog open.
            e.preventDefault && e.preventDefault();
            const { clearAllCustomFieldValuesGroups: clearAllCustomFieldValuesGroups, clearAllComponentGroups: clearAllComponentGroups, clearAllLabelGroups: clearAllLabelGroups, grouping: grouping } = this.props;
            if (grouping === (0, $5rYNM.GROUPING).COMPONENT) return clearAllComponentGroups();
            if (grouping === (0, $5rYNM.GROUPING).LABEL) return clearAllLabelGroups();
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return clearAllCustomFieldValuesGroups(grouping);
        };
        this.renderClearAllGroupsButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                spacing: "compact",
                onClick: this.onClearAllGroups,
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-groups"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bRrol.default).clearAllGroups));
        this.handleKeyDownCapture = (e)=>{
            if (e.key === 'Escape' && !this.state.isDialogLocked) this.setState({
                isOpen: false
            }, ()=>{
                this.buttonRef.current?.focus();
            });
        };
        this.renderContent = ()=>{
            const { ColourBy: // eslint-disable-next-line @typescript-eslint/no-shadow
            ColourBy, DependencySettings: // eslint-disable-next-line @typescript-eslint/no-shadow
            DependencySettings, GroupBy: // eslint-disable-next-line @typescript-eslint/no-shadow
            GroupBy, GroupByComponents: // eslint-disable-next-line @typescript-eslint/no-shadow
            GroupByComponents, SortBy: // eslint-disable-next-line @typescript-eslint/no-shadow
            SortBy, EstimateRollup: // eslint-disable-next-line @typescript-eslint/no-shadow
            EstimateRollup, colourByConfiguration: { colourByValue: colourByValue }, grouping: grouping, showSprints: showSprints, toggleShowSprints: toggleShowSprints, intl: intl, groupingByMultiValueCustomField: groupingByMultiValueCustomField } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $03EuP.settingsList,
                onKeyDownCapture: this.handleKeyDownCapture
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $9V71l.default).colourByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $03EuP.viewSettingSelect,
                ...!this.shouldShowClearButton() && {
                    colSpan: 2
                }
            }, ColourBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColourBy, {
                onMenuToggle: this.toggleDialogLocked
            })), this.shouldShowClearButton() && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $03EuP.clearAllButton
            }, this.renderColourByClearButton())), colourByValue === (0, $33N5G.colourByOptions).COMPONENT && this.renderColourByComponentLegend(), colourByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE ? this.renderColourByIssueTypeLegend() : null, colourByValue === (0, $33N5G.colourByOptions).LABEL && this.renderColourByLabelLegend(), colourByValue === (0, $33N5G.colourByOptions).PRIORITY ? this.renderColourByPriorityLegend() : null, (0, $kyGCj.isColorByCustomFieldOption)(colourByValue) && this.renderColourBySelectLegend(), SortBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortBy, {
                onMenuToggle: this.toggleDialogLocked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).groupBy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $03EuP.viewSettingSelect,
                ...!this.shouldShowClearAllGroupsButton() && {
                    colSpan: 2
                }
            }, GroupBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupBy, {
                onMenuToggle: this.toggleDialogLocked
            })), this.shouldShowClearAllGroupsButton() && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $03EuP.clearAllButton
            }, this.renderClearAllGroupsButton())), grouping === (0, $5rYNM.GROUPING).COMPONENT && GroupByComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupByComponents, {
                onMenuToggle: this.toggleDialogLocked
            }), grouping === (0, $5rYNM.GROUPING).LABEL && (0, $69mNn.default) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69mNn.default), {
                onMenuToggle: this.toggleDialogLocked
            }), groupingByMultiValueCustomField && (0, $lDofH.default) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lDofH.default), {
                onMenuToggle: this.toggleDialogLocked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $03EuP.showCapacityCheckbox
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                defaultChecked: showSprints,
                isDisabled: grouping !== (0, $5rYNM.GROUPING).SPRINT && grouping !== (0, $5rYNM.GROUPING).TEAM,
                label: intl.formatMessage({
                    ...(0, $bRrol.default).showSprintsOnTimeline
                }),
                onChange: (_, analyticsEvent)=>{
                    const nextValue = !showSprints;
                    const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SHOW_CAPACITY_ON_TIMELINE_CHANGED.split(' ');
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                        actionSubject: actionSubject,
                        action: action
                    }), actionSubjectId, {
                        newPlanSettingValue: nextValue
                    });
                    toggleShowSprints(nextValue);
                },
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-capacity-checkbox",
                value: "show-sprints"
            })), grouping !== (0, $5rYNM.GROUPING).SPRINT && grouping !== (0, $5rYNM.GROUPING).TEAM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $03EuP.checkboxInfo,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-capacity-checkbox-info"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bRrol.default).onlyAvailableForTeamOrSprint)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $03EuP.topAlignedTd
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bRrol.default).dependencySettingsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2,
                className: $03EuP.topAlignedTd
            }, DependencySettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependencySettings, {
                onMenuToggle: this.toggleDialogLocked
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $03EuP.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                className: $03EuP.topAlignedTd
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $03EuP.rollupSetting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bRrol.default).rollupLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2,
                className: $03EuP.topAlignedTd
            }, EstimateRollup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EstimateRollup, null)))))));
        };
    }
}
var $c764ddf094d1134a$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c764ddf094d1134a$export$4d0b6d35abb3362d);

});
parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b964a2018cb4a0d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 11-5.999.001A3 3 0 0111 8zM9 8a1 1 0 10-1.999-.001A1 1 0 009 8zm10 8a3 3 0 11-5.999.001A3 3 0 0119 16zm-2 0a1 1 0 10-1.999-.001A1 1 0 0017 16z"/></g></svg>`
    }, props));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = $b964a2018cb4a0d7$var$PreferencesIcon;
module.exports.default = $b964a2018cb4a0d7$var$_default;

});

parcelRegister("dEh7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $8acaef84f588569c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $66lrU = parcelRequire("66lrU");

var $f1Zsc = parcelRequire("f1Zsc");

var $dWZUj = parcelRequire("dWZUj");
var $8acaef84f588569c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $f1Zsc.default), (0, $66lrU.default))((0, $dWZUj.default));

});
parcelRegister("66lrU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c14511038fb5a9e$export$2e2bcd8739ae039);

var $9ffcO = parcelRequire("9ffcO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0c14511038fb5a9e$export$2e2bcd8739ae039 = (dispatch)=>({
        setColourByValue: (payload)=>{
            dispatch((0, $9ffcO.setColourByValue)(payload));
        },
        setColourMap: (payload)=>{
            dispatch((0, $9ffcO.setColourMap)(payload));
        },
        setPriorityColourMap: (payload)=>{
            dispatch((0, $9ffcO.setPriorityColourMap)(payload));
        }
    });

});

parcelRegister("f1Zsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f9383bac1f53f59$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $jp3RH = parcelRequire("jp3RH");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $2f9383bac1f53f59$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    colourByValue: (0, $kyGCj.getColorByValue),
    colourMaps: (0, $kyGCj.getColourMaps),
    colourPriorities: (0, $kyGCj.getColourPriorities),
    filterableCustomFields: (0, $kKj1m.getFilterableCustomFields),
    issuePrioritiesIdList: (0, $jp3RH.getIssuePrioritiesIdList),
    viewMode: (0, $9H2AP.getViewMode)
});

});

parcelRegister("dWZUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $158f89d76aa53413$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $fIpiC = parcelRequire("fIpiC");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lcvrv = parcelRequire("lcvrv");

var $cuuJa = parcelRequire("cuuJa");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $2BQwE = parcelRequire("2BQwE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $31WUh = parcelRequire("31WUh");

var $9V71l = parcelRequire("9V71l");

var $5LXYp = parcelRequire("5LXYp");
function $158f89d76aa53413$var$ColourBy({ colourByValue: colourByValue, colourMaps: colourMaps, colourPriorities: colourPriorities, filterableCustomFields: filterableCustomFields, isDefaultMenuOpen: isDefaultMenuOpen = false, issuePrioritiesIdList: issuePrioritiesIdList, onMenuToggle: onMenuToggle, setColourByValue: setColourByValue, setColourMap: setColourMap, setPriorityColourMap: setPriorityColourMap, viewMode: viewMode = (0, $lcvrv.VIEW_MODES).TIMELINE }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const createDefaultMap = (id)=>{
        if (id === (0, $33N5G.colourByOptions).STATUS) return 0, $33N5G.statusColourMap;
        // Maps for project and team are created on page load
        return {};
    };
    /**
   * This function creates a preset of colours when the user colour the plan by priority
   * It takes the priorities provided by the issuePrioritiesIdList, then the colours included in
   * the priorityColourMap (3, at the time of writing these lines), and allocates priorities to these colours
   */ const createPriorityColourMap = ()=>{
        if ((0, $7CnHa.isDefined)(issuePrioritiesIdList) && issuePrioritiesIdList.length >= (0, $33N5G.priorityColourMap).length) {
            const [floorChunkSize, ceilChunkSize] = $fIpiC.default([
                Math.floor,
                Math.ceil
            ])(issuePrioritiesIdList.length / (0, $33N5G.priorityColourMap).length);
            // we use different chunk sizes based on the amount of priorities e.g.
            // if there are 3 (3 % 3 = 0) priorities: [1, 1, 1]
            // if there are 4 (4 % 3 = 1) priorities: [1, 2, 1]
            // if there are 5 (5 % 3 = 2) priorities: [2, 1, 2]
            // if there are 6 (6 % 3 = 0) priorities: [2, 2, 2]
            // and so on...
            const chunks = issuePrioritiesIdList.length % (0, $33N5G.priorityColourMap).length === 1 ? [
                floorChunkSize,
                ceilChunkSize,
                floorChunkSize
            ] : [
                ceilChunkSize,
                floorChunkSize,
                ceilChunkSize
            ];
            setPriorityColourMap({
                chunks: chunks,
                issuePrioritiesIdList: issuePrioritiesIdList
            });
        }
    };
    const changeColourBy = ({ value: value })=>{
        (0, $duQ8C.default)((0, $2BQwE.KEYS).CHANGE_COLOR_BY_SETTING);
        setColourByValue({
            id: value
        });
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COLOR_BY_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject,
            action: action
        }), actionSubjectId, {
            newPlanSettingValue: value
        });
        if (!(0, $kyGCj.isColorByCustomFieldOption)(value)) {
            if (value === (0, $33N5G.colourByOptions).PRIORITY && $b3iuB.default(colourPriorities)) // when Color by > Priority is selected and there are no options picked for any colours, we provide
            // a preset of colours and options picked for these colours to the user
            createPriorityColourMap();
            else if (colourMaps[value] && Object.keys(colourMaps[value]).length === 0) {
                const map = createDefaultMap(value);
                setColourMap({
                    id: value,
                    map: map
                });
            }
        }
    };
    const getColourByOptionsFromStandardFields = ()=>Object.keys((0, $5LXYp.colorByLabelsMap)).map((key)=>({
                id: key.toString(),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                content: formatMessage((0, $5LXYp.colorByLabelsMap)[key]),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                label: formatMessage((0, $5LXYp.colorByLabelsMap)[key]),
                value: key.toString()
            }));
    const getColourByOptionsFromCustomFields = ()=>filterableCustomFields.map(({ id: id, title: title })=>({
                id: id.toString(),
                content: title,
                label: title,
                value: id.toString()
            }));
    const standardFieldsOptions = getColourByOptionsFromStandardFields();
    const customFieldsOptions = getColourByOptionsFromCustomFields();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31WUh.default), {
        classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by",
        customFieldsOptions: customFieldsOptions,
        handleOnChange: changeColourBy,
        isDefaultMenuOpen: isDefaultMenuOpen,
        isDisabled: viewMode === (0, $lcvrv.VIEW_MODES).LIST,
        onMenuToggle: onMenuToggle,
        selectedFieldId: colourByValue,
        standardFieldsOptions: standardFieldsOptions,
        ...(0, $1ybV0.ff)('jsw.roadmaps.timeline-viewsettings-dropdown-button-arialabel-1120_7ctf1') && {
            label: formatMessage((0, $9V71l.default).colourByLabel)
        }
    });
}
var $158f89d76aa53413$export$2e2bcd8739ae039 = $158f89d76aa53413$var$ColourBy;

});
parcelRegister("31WUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $94cffe16b89ef531$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aUqTb = parcelRequire("aUqTb");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $g4Vkx = parcelRequire("g4Vkx");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $ib5d3 = parcelRequire("ib5d3");

var $czjvE = parcelRequire("czjvE");

var $cGE0j = parcelRequire("cGE0j");
function $94cffe16b89ef531$var$ViewSettingSelect({ classNamePrefix: classNamePrefix, customFieldsOptions: customFieldsOptions, handleOnChange: handleOnChange, isDefaultMenuOpen: isDefaultMenuOpen = false, isDisabled: // always false in PROD, potentially true in StoryBook
isDisabled = false, onMenuToggle: onMenuToggle, selectedFieldId: selectedFieldId, standardFieldsOptions: standardFieldsOptions, label: label }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isMenuOpen, setIsMenuOpen] = (0, $eUqFw.useState)(isDefaultMenuOpen);
    const groupedOptions = [
        {
            label: '',
            options: standardFieldsOptions
        }
    ];
    if (customFieldsOptions.length > 0) {
        const sortedCustomFieldsOptions = customFieldsOptions.sort((a, b)=>a.label.localeCompare(b.label));
        groupedOptions.push({
            label: formatMessage((0, $ib5d3.default).customFields),
            options: sortedCustomFieldsOptions
        });
    }
    const selectedValue = [
        ...standardFieldsOptions,
        ...customFieldsOptions
    ].find(({ id: id })=>id === selectedFieldId);
    const formatOptionLabel = ({ content: content, isDisabled: isDisabled, tooltipContent: tooltipContent }, { context: context })=>{
        if (context === 'menu') {
            if (isDisabled) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $cGE0j.option
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage(tooltipContent),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                label: formatMessage(tooltipContent),
                primaryColor: `var(--ds-blanket, ${(0, $g4Vkx.default).N500})`,
                size: "small"
            })))));
            return content;
        }
        return content;
    };
    const tooltipContent = ()=>{
        if (isDisabled) return formatMessage((0, $czjvE.default).optionDisabledInListView);
        if (!isMenuOpen) return selectedValue?.label;
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        blurInputOnSelect: true,
        classNamePrefix: classNamePrefix,
        closeMenuOnSelect: true,
        formatOptionLabel: formatOptionLabel,
        isDisabled: isDisabled,
        menuIsOpen: isMenuOpen,
        menuPortalTarget: window.STORYBOOK_ENV ? undefined : (0, $1ni3W.getBody)(),
        onChange: handleOnChange,
        onMenuClose: ()=>{
            setIsMenuOpen(false);
            onMenuToggle(false);
        },
        onMenuOpen: ()=>{
            setIsMenuOpen(true);
            onMenuToggle(true);
        },
        options: groupedOptions,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 999
                })
        },
        value: selectedValue,
        ...(0, $1ybV0.ff)('jsw.roadmaps.timeline-viewsettings-dropdown-button-arialabel-1120_7ctf1') && {
            'aria-label': formatMessage((0, $czjvE.default).selectAriaLabel, {
                label: label,
                selectedValue: selectedValue?.label
            })
        }
    }));
}
var $94cffe16b89ef531$export$2e2bcd8739ae039 = $94cffe16b89ef531$var$ViewSettingSelect;

});
parcelRegister("czjvE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874fa5d8a23ba30$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a874fa5d8a23ba30$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    optionDisabledInListView: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.view-setting-select.option-disabled-in-list-view",
        "defaultMessage": "This option is unavailable in list view"
    },
    selectAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.view-setting-select.select-aria-label",
        "defaultMessage": "{label} {selectedValue}"
    }
});

});

parcelRegister("cGE0j", function(module, exports) {

$parcel$export(module.exports, "option", () => $93c8704327165263$export$a75d1723e6bda2ec, (v) => $93c8704327165263$export$a75d1723e6bda2ec = v);
var $93c8704327165263$export$a75d1723e6bda2ec;
$93c8704327165263$export$a75d1723e6bda2ec = `LpNIna_option`;

});


parcelRegister("9V71l", function(module, exports) {

$parcel$export(module.exports, "default", () => $415918d25f77295e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $415918d25f77295e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colourByLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by.colour-by-label",
        "defaultMessage": "Color by"
    }
});

});

parcelRegister("5LXYp", function(module, exports) {

$parcel$export(module.exports, "colorByLabelsMap", () => $aa860195367094fc$export$1fba1ddb0e3b4298);

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");
const $aa860195367094fc$export$1fba1ddb0e3b4298 = {
    [(0, $33N5G.colourByOptions).NONE]: (0, $ib5d3.default).none,
    [(0, $33N5G.colourByOptions).COMPONENT]: (0, $ib5d3.default).component,
    [(0, $33N5G.colourByOptions).EPIC]: (0, $ib5d3.default).epic,
    [(0, $33N5G.colourByOptions).ISSUE_TYPE]: (0, $ib5d3.default).issueType,
    [(0, $33N5G.colourByOptions).LABEL]: (0, $ib5d3.default).label,
    [(0, $33N5G.colourByOptions).PRIORITY]: (0, $ib5d3.default).priority,
    [(0, $33N5G.colourByOptions).PROJECT]: (0, $ib5d3.default).project,
    [(0, $33N5G.colourByOptions).STATUS]: (0, $ib5d3.default).status,
    [(0, $33N5G.colourByOptions).TEAM]: (0, $ib5d3.default).team
};

});



parcelRegister("ir8Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d147be5047eda56$export$2e2bcd8739ae039);
parcelRequire("1afYi");
var $9ffcO = parcelRequire("9ffcO");

var $lvJU2 = parcelRequire("lvJU2");

var $ehEr2 = parcelRequire("ehEr2");

var $9H2AP = parcelRequire("9H2AP");

var $lNNXV = parcelRequire("lNNXV");

var $jW8mU = parcelRequire("jW8mU");
const $9d147be5047eda56$var$mapStateToProps = (state)=>({
        colourByConfiguration: (0, $9H2AP.getColorByViewSettings)(state),
        components: (0, $lvJU2.getComponents)(state),
        projectsById: (0, $ehEr2.getProjectsById)(state)
    });
const $9d147be5047eda56$var$mapDispatchToProps = (dispatch)=>({
        addComponentColour: ()=>{
            dispatch((0, $9ffcO.addComponentColour)());
        },
        updateComponentColour: (payload)=>{
            dispatch((0, $9ffcO.updateComponentColour)(payload));
        },
        removeComponentColour: (payload)=>{
            dispatch((0, $9ffcO.removeComponentColour)(payload));
        }
    });
var $9d147be5047eda56$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($9d147be5047eda56$var$mapStateToProps, $9d147be5047eda56$var$mapDispatchToProps)((0, $jW8mU.default));

});
parcelRegister("jW8mU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23f25a13f3cbf41$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");

var $6ROLN = parcelRequire("6ROLN");

var $bkIGg = parcelRequire("bkIGg");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $d46zl = parcelRequire("d46zl");

var $4rXgj = parcelRequire("4rXgj");
const $e23f25a13f3cbf41$var$optionsToComponents = (options)=>options.map((x)=>x.value);
class $e23f25a13f3cbf41$export$1c8038c4bb24c6bf extends (0, $eUqFw.Component) {
    render() {
        const { colourByConfiguration: { colourComponents: colourComponents }, intl: intl } = this.props;
        const isAddingNewComponentColour = colourComponents.some(({ colour: colour })=>!colour);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4rXgj.list
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4rXgj.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $4rXgj.allOtherIssuesButton,
            isDisabled: true,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: intl.formatMessage((0, $33N5G.colourPickerPaletteLabels)[0, $33N5G.DEFAULT_COLOR]),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $4rXgj.swatch,
                style: {
                    backgroundColor: (0, $33N5G.DEFAULT_COLOR)
                }
            }))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4rXgj.allOtherIssues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).allOtherIssues))), colourComponents.map(this.renderRow), isAddingNewComponentColour ? null : this.renderAddComponent()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            // "keySuffix" was added to force re-render when all components are removed from any Select to remove its whole row.
            // Reason: to avoid regression when clearing some Select the last Select with the same colour is removed.
            // Also this implementation lets keep focus on Select while editing it from keyboard -
            // https://stash.atlassian.com/plugins/servlet/jira-integration/issues/JPOS-4624
            keySuffix: 0
        };
        // components select must not show components already picked for any colour
        this.availableComponents = ()=>{
            const { components: components, colourByConfiguration: { colourComponents: colourComponents } } = this.props;
            const usedComponents = new Set((0, $7CnHa.chain)((x)=>x.components, colourComponents));
            return components.map((component)=>component.id.toString()).filter((component)=>!usedComponents.has(component));
        };
        this.componentIdsToOptions = (componentIds)=>{
            const { components: components, projectsById: projectsById } = this.props;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return componentIds.reduce((options, componentId)=>{
                const component = components.find(// eslint-disable-next-line @typescript-eslint/no-shadow
                (component)=>component.id.toString() === componentId);
                if (component) {
                    const option = {
                        value: component.id.toString(),
                        label: component.projectId ? `${component.name} (${projectsById[component.projectId].key})` : component.name
                    };
                    options.push(option);
                }
                return options;
            }, []);
        };
        this.onComponentsChange = (index, options)=>{
            const { updateComponentColour: updateComponentColour, removeComponentColour: removeComponentColour } = this.props;
            if ($kDrtX.default(options) || $b3iuB.default(options)) {
                removeComponentColour({
                    index: index
                });
                this.setState((prevState)=>({
                        keySuffix: prevState.keySuffix + 1
                    }));
            } else updateComponentColour({
                index: index,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                components: $e23f25a13f3cbf41$var$optionsToComponents(options)
            });
        };
        this.onColourChange = (index)=>(colour)=>{
                const { updateComponentColour: updateComponentColour, removeComponentColour: removeComponentColour } = this.props;
                if (colour) updateComponentColour({
                    index: index,
                    colour: colour
                });
                else removeComponentColour({
                    index: index
                });
            };
        this.renderRow = (colourComponent, index)=>{
            const { colour: colour, components: components } = colourComponent;
            const availableComponents = this.availableComponents();
            const { intl: intl, onMenuToggle: onMenuToggle } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $4rXgj.row,
                key: `${index}-${colour || ''}-${this.state.keySuffix}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
                colour: colour,
                onColourChange: this.onColourChange(index),
                position: "left",
                ariaLabel: colour ? intl.formatMessage((0, $d46zl.default).editLabelColorAriaLabel) : intl.formatMessage((0, $d46zl.default).chooseLabelColorAriaLabel)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $4rXgj.componentSelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
                htmlFor: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByComponent.select-component"
            }, intl.formatMessage(colour ? (0, $d46zl.default).selectComponentLabel : (0, $d46zl.default).selectColour)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-component_select-component-${index}`,
                defaultValue: this.componentIdsToOptions(components),
                isDisabled: !colour,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                onChange: (options)=>this.onComponentsChange(index, options),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: this.componentIdsToOptions(availableComponents),
                placeholder: intl.formatMessage(colour ? (0, $d46zl.default).findComponent : (0, $d46zl.default).chooseColour),
                styles: {
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                },
                inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByComponent.select-component"
            }))));
        };
        this.renderAddComponent = ()=>{
            const { addComponentColour: addComponentColour } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: `${$4rXgj.addLabelButton} ${$4rXgj.row}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                    label: ""
                }),
                onClick: (e)=>{
                    e.preventDefault();
                    addComponentColour();
                },
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.add-color-link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $4rXgj.addLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $d46zl.default).addComponent)))));
        };
    }
}
var $e23f25a13f3cbf41$export$2e2bcd8739ae039 = (0, $2qhQi.default)($e23f25a13f3cbf41$export$1c8038c4bb24c6bf);

});
parcelRegister("2xinl", function(module, exports) {

$parcel$export(module.exports, "default", () => $649ff4605b81f36b$export$2e2bcd8739ae039);

var $82ngp = parcelRequire("82ngp");
var $649ff4605b81f36b$export$2e2bcd8739ae039 = (0, $82ngp.default);

});
parcelRegister("82ngp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dddbb50a3d90cf5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $01F0p = parcelRequire("01F0p");

var $5JgJ2 = parcelRequire("5JgJ2");

var $33N5G = parcelRequire("33N5G");
const $5dddbb50a3d90cf5$var$ColourPicker = ({ colour: colour, position: position = 'left', isDisabled: isDisabled = false, selectedColourSwatchSize: selectedColourSwatchSize = 'small', onColourChange: onColourChange, ariaLabel: ariaLabel })=>{
    const [color, setColor] = (0, $eUqFw.useState)(colour);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const colorPalette = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/no-shadow
        (0, $33N5G.colourPickerPalette).map((colour)=>({
                label: formatMessage((0, $33N5G.colourPickerPaletteLabels)[colour]),
                value: colour
            })), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01F0p.default), {
        palette: colorPalette,
        selectedColor: color,
        showDefaultSwatchColor: !!color,
        selectedColourSwatchSize: selectedColourSwatchSize,
        isDisabledSelectedSwatch: isDisabled,
        popperProps: {
            strategy: 'fixed',
            placement: position,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            10
                        ]
                    }
                }
            ]
        },
        cols: colorPalette.length / 2,
        onChange: (newColor)=>{
            setColor(newColor);
            onColourChange(newColor);
        },
        label: ariaLabel
    });
};
var $5dddbb50a3d90cf5$export$2e2bcd8739ae039 = $5dddbb50a3d90cf5$var$ColourPicker;

});
parcelRegister("01F0p", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $e0f2aa3037ee4cdc$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $e0f2aa3037ee4cdc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ColorPaletteMenu", () => (parcelRequire("cu9kj")).default);

var $jx7pE = parcelRequire("jx7pE");

var $dUxck = parcelRequire("dUxck");

var $cu9kj = parcelRequire("cu9kj");
const { Compact: $e0f2aa3037ee4cdc$export$6479582a9c9e50ce, Standard: $e0f2aa3037ee4cdc$export$d5a1f56087d42b19 } = (0, $dUxck.Mode);
var $e0f2aa3037ee4cdc$export$2e2bcd8739ae039 = (0, $jx7pE.default);

});
parcelRegister("jx7pE", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb72bcd9e150791$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $l44HT = parcelRequire("l44HT");

var $85AtA = parcelRequire("85AtA");

var $k8uYo = parcelRequire("k8uYo");


var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $jiLMl = parcelRequire("jiLMl");
function $beb72bcd9e150791$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $beb72bcd9e150791$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $beb72bcd9e150791$var$packageName = undefined;
const $beb72bcd9e150791$var$packageVersion = undefined;
class $beb72bcd9e150791$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $beb72bcd9e150791$var$defaultPopperProps, label: label = 'Color picker', selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
        const { options: options, value: value } = (0, $c0Y4D.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l44HT.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: $beb72bcd9e150791$var$colorCardWrapperStyles,
                    ref: ref
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $85AtA.default), {
                    ...value,
                    label: fullLabel,
                    expanded: isOpen,
                    swatchSize: selectedColourSwatchSize,
                    isDisabled: isDisabledSelectedSwatch
                })),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            "aria-label": fullLabel,
            value: value,
            components: $k8uYo,
            onChange: this.onChangeSelect,
            // never show search input
            searchThreshold: Number.MAX_VALUE,
            // palette props
            cols: cols,
            checkMarkColor: checkMarkColor,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown
        });
    }
    constructor(...args){
        super(...args);
        this.createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
        this.state = {
            isTabbing: false
        };
        this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $beb72bcd9e150791$var$packageName,
                    packageVersion: $beb72bcd9e150791$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        };
        this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        };
        this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $5094de7401eea7ba$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $5094de7401eea7ba$export$b34c7ae3fd8138d2) || key === (0, $5094de7401eea7ba$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === 'Escape') e.stopPropagation();
        };
        this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $jiLMl.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $beb72bcd9e150791$export$2fcf66ed38ff3cf5 = (0, $2qhQi.default)($beb72bcd9e150791$var$ColorPickerWithoutAnalyticsBase);
var $beb72bcd9e150791$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: $beb72bcd9e150791$var$packageName,
    packageVersion: $beb72bcd9e150791$var$packageVersion
})((0, $2jDha.default)()($beb72bcd9e150791$export$2fcf66ed38ff3cf5));
const $beb72bcd9e150791$var$colorCardWrapperStyles = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};

});
parcelRegister("85AtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3225ae62471df5f8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
function $3225ae62471df5f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3225ae62471df5f8$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled })=>{
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        css: [
            $3225ae62471df5f8$var$sharedColorContainerStyles,
            swatchSize === 'small' ? $3225ae62471df5f8$var$smallColorContainerSize : $3225ae62471df5f8$var$defaultColorContainerSize,
            $3225ae62471df5f8$var$colorCardButtonStyles,
            expanded && $3225ae62471df5f8$var$colorCardButtonFocusedStyles
        ],
        disabled: isDisabled,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "aria-label": label,
        "aria-expanded": expanded,
        "aria-haspopup": true,
        type: "button"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3225ae62471df5f8$var$colorCardWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3225ae62471df5f8$var$colorCardContentStyles,
            swatchSize === 'small' ? $3225ae62471df5f8$var$smallColorCardContentSize : $3225ae62471df5f8$var$defaultColorCardContentSize
        ],
        style: {
            background: value || 'transparent'
        }
    }))));
};
var $3225ae62471df5f8$export$2e2bcd8739ae039 = $3225ae62471df5f8$var$ColorCard;
const $3225ae62471df5f8$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: '6px',
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $3225ae62471df5f8$var$smallColorContainerSize = {
    name: "1435ao5",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
};
const $3225ae62471df5f8$var$defaultColorContainerSize = {
    name: "1uafl10",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
};
const $3225ae62471df5f8$var$colorCardButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:focus):hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
        outline: 'none'
    }
});
const $3225ae62471df5f8$var$colorCardButtonFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
    outline: 'none'
});
const $3225ae62471df5f8$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $3225ae62471df5f8$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});
const $3225ae62471df5f8$var$smallColorCardContentSize = {
    name: "1rrhp72",
    styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
};
const $3225ae62471df5f8$var$defaultColorCardContentSize = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};

});

parcelRegister("k8uYo", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $1392b51a14debfe3$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $1392b51a14debfe3$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $1392b51a14debfe3$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $1392b51a14debfe3$export$84712d0562a614b8);
/** @jsx jsx */ 
var $158Fh = parcelRequire("158Fh");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");
function $1392b51a14debfe3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1392b51a14debfe3$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1392b51a14debfe3$var$colorPaletteContainerStyles,
        role: "radiogroup",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $c0Y4D.getWidth)(cols) : undefined
        },
        ref: innerRef
    }, children);
};
const $1392b51a14debfe3$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1392b51a14debfe3$var$colorCardWrapperStyles,
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $158Fh.default), {
        label: label,
        value: value,
        checkMarkColor: checkMarkColor,
        isOption: true,
        focused: isFocused,
        selected: isSelected,
        onKeyDown: (value)=>onOptionKeyDown(value),
        isTabbing: isTabbing
    }));
};
const $1392b51a14debfe3$export$ec98719d3db7f2e4 = ()=>null;
const $1392b51a14debfe3$export$84712d0562a614b8 = ()=>null;
const $1392b51a14debfe3$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $1392b51a14debfe3$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};

});
parcelRegister("158Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35978981991cf34$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $8cU5f = parcelRequire("8cU5f");


var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $jaTu3 = parcelRequire("jaTu3");
function $a35978981991cf34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a35978981991cf34$var$ColorCard = (props)=>{
    const { value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $PdmhA.N0), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
    const ref = (0, $eUqFw.useRef)(null);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const { key: key } = event;
        if ((isTabbing === undefined || isTabbing) && onKeyDown && (key === (0, $5094de7401eea7ba$export$8152f929a25a0ff4) || key === (0, $5094de7401eea7ba$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onKeyDown(value);
        }
    }, [
        isTabbing,
        onKeyDown,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const refCurrent = ref.current;
        const handleKeyDown = (e)=>{
            if (e.key === 'Tab') {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        refCurrent?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            refCurrent?.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, (0, $XHGTv.getBooleanFF)('platform.jca11y-2997-remove-duplicate-screen-reader-announcements_fz13s') ? (tooltipProps)=>{
        delete tooltipProps['aria-describedby'];
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...tooltipProps,
            css: [
                $a35978981991cf34$var$sharedColorContainerStyles,
                (isTabbing === undefined || isTabbing) && $a35978981991cf34$var$colorCardOptionTabbingStyles,
                focused && !isTabbing && $a35978981991cf34$var$colorCardOptionFocusedStyles
            ],
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onKeyDown: handleKeyDown,
            role: "radio",
            "aria-checked": selected,
            "aria-label": label,
            tabIndex: 0,
            ref: (0, $jaTu3.mergeRefs)([
                ref,
                tooltipProps.ref
            ])
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardContentStyles,
            style: {
                background: value || 'transparent'
            }
        }, selected && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardContentCheckMarkStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
            primaryColor: checkMarkColor,
            label: ""
        })))));
    } : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $a35978981991cf34$var$sharedColorContainerStyles,
            (isTabbing === undefined || isTabbing) && $a35978981991cf34$var$colorCardOptionTabbingStyles,
            focused && !isTabbing && $a35978981991cf34$var$colorCardOptionFocusedStyles
        ],
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyDown: handleKeyDown,
        role: "radio",
        "aria-checked": selected,
        "aria-label": label,
        tabIndex: 0,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardContentStyles,
        style: {
            background: value || 'transparent'
        }
    }, selected && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardContentCheckMarkStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: checkMarkColor,
        label: ""
    }))))));
};
var $a35978981991cf34$export$2e2bcd8739ae039 = $a35978981991cf34$var$ColorCard;
const $a35978981991cf34$var$colorCardOptionTabbingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
    }
});
const $a35978981991cf34$var$colorCardOptionFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
});
const $a35978981991cf34$var$colorCardContentCheckMarkStyles = {
    name: "gyevkv",
    styles: "margin:1px"
};
const $a35978981991cf34$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: "var(--ds-border-radius-200, 6px)",
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $a35978981991cf34$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $a35978981991cf34$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});

const $5094de7401eea7ba$export$64c9b8c6e6a2c6ac = 32;
const $5094de7401eea7ba$export$e51a3576c045c8d5 = ' ';
const $5094de7401eea7ba$export$8152f929a25a0ff4 = 'Enter';
const $5094de7401eea7ba$export$b34c7ae3fd8138d2 = 'ArrowDown';
const $5094de7401eea7ba$export$1734a06b2397c2a8 = 'ArrowUp';
const $5094de7401eea7ba$export$10f6869ed0a7d75b = 'Tab';

parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});



parcelRegister("c0Y4D", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $b46f108815c58f3f$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $b46f108815c58f3f$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $lcnyw = parcelRequire("lcnyw");


var $5iWql = parcelRequire("5iWql");

var $dUxck = parcelRequire("dUxck");
const $b46f108815c58f3f$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $5094de7401eea7ba$export$64c9b8c6e6a2c6ac) + (0, $lcnyw.gridSize)() / 2);
    return mode === (0, $dUxck.Mode).Standard ? width + (0, $lcnyw.gridSize)() : width;
};
const $b46f108815c58f3f$export$d2312e68e1f5ad00 = (0, $5iWql.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("dUxck", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $53c487a191c92002$export$9484bbecc3c49a2e);
var $53c487a191c92002$export$9484bbecc3c49a2e;
(function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
})($53c487a191c92002$export$9484bbecc3c49a2e || ($53c487a191c92002$export$9484bbecc3c49a2e = {}));

});



parcelRegister("jiLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $403c80e207605265$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $403c80e207605265$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    }
});

});


parcelRegister("cu9kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f56609052bab10ee$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $dUxck = parcelRequire("dUxck");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $158Fh = parcelRequire("158Fh");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
function $f56609052bab10ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f56609052bab10ee$export$4bbfe93c6a14e8e6 = ({ createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $dUxck.Mode).Standard })=>{
    const createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: undefined,
                packageVersion: undefined
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const handleChange = (value)=>{
        onChange(value, changeAnalyticsCaller());
    };
    const { options: options, value: selectedValue } = (0, $c0Y4D.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-label": fullLabel,
        role: "radiogroup",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $f56609052bab10ee$var$colorPaletteMenuStyles,
            mode === (0, $dUxck.Mode).Standard && $f56609052bab10ee$var$colorPaletteMenuStandardStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $c0Y4D.getWidth)(cols, mode)}px`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f56609052bab10ee$var$colorPaletteContainerStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            mode === (0, $dUxck.Mode).Compact && $f56609052bab10ee$var$colorPaletteContainerCompactStyles
        ]
    }, options.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f56609052bab10ee$var$colorCardWrapperStyles,
            key: value
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $158Fh.default), {
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            selected: value === selectedValue.value,
            onClick: handleChange,
            onKeyDown: handleChange
        })))));
};
var $f56609052bab10ee$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: undefined,
    packageVersion: undefined
})((0, $2jDha.default)()($f56609052bab10ee$export$4bbfe93c6a14e8e6));
const $f56609052bab10ee$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $f56609052bab10ee$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};
const $f56609052bab10ee$var$colorPaletteContainerCompactStyles = {
    name: "h6te2n",
    styles: "padding:var(--ds-space-0, 0)"
};
const $f56609052bab10ee$var$colorPaletteMenuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'relative',
    margin: "var(--ds-space-0, 0)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`
});
const $f56609052bab10ee$var$colorPaletteMenuStandardStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40)}, 0 0 8px ${(0, $PdmhA.N40)}`})`
});

});




parcelRegister("d46zl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58677ae8d577fb1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c58677ae8d577fb1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    findComponent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.find-component",
        "defaultMessage": "Choose component"
    },
    selectComponentLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.select-component-label",
        "defaultMessage": "Select component"
    },
    chooseColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.choose-colour",
        "defaultMessage": "Choose color"
    },
    selectColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.select-colour",
        "defaultMessage": "Select color"
    },
    addComponent: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.add-component",
        "defaultMessage": "Add color"
    },
    chooseLabelColorAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.choose-label-color-aria-label",
        "defaultMessage": "Choose a label color"
    },
    editLabelColorAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-component.edit-label-color-aria-label",
        "defaultMessage": "edit label color"
    }
});

});

parcelRegister("4rXgj", function(module, exports) {

$parcel$export(module.exports, "addLabel", () => $33d7a74427e1f3f4$export$7382a268046a9fb1, (v) => $33d7a74427e1f3f4$export$7382a268046a9fb1 = v);
$parcel$export(module.exports, "addLabelButton", () => $33d7a74427e1f3f4$export$2e19006997105e3f, (v) => $33d7a74427e1f3f4$export$2e19006997105e3f = v);
$parcel$export(module.exports, "allOtherIssues", () => $33d7a74427e1f3f4$export$5cfe825620032318, (v) => $33d7a74427e1f3f4$export$5cfe825620032318 = v);
$parcel$export(module.exports, "allOtherIssuesButton", () => $33d7a74427e1f3f4$export$dc5d9523e11716f6, (v) => $33d7a74427e1f3f4$export$dc5d9523e11716f6 = v);
$parcel$export(module.exports, "componentSelect", () => $33d7a74427e1f3f4$export$30ae6ac4023c3a21, (v) => $33d7a74427e1f3f4$export$30ae6ac4023c3a21 = v);
$parcel$export(module.exports, "list", () => $33d7a74427e1f3f4$export$8837f4fc672e936d, (v) => $33d7a74427e1f3f4$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "row", () => $33d7a74427e1f3f4$export$120ff0929b202a6d, (v) => $33d7a74427e1f3f4$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "swatch", () => $33d7a74427e1f3f4$export$c672d9950c40fe0a, (v) => $33d7a74427e1f3f4$export$c672d9950c40fe0a = v);
var $33d7a74427e1f3f4$export$7382a268046a9fb1;
var $33d7a74427e1f3f4$export$2e19006997105e3f;
var $33d7a74427e1f3f4$export$5cfe825620032318;
var $33d7a74427e1f3f4$export$dc5d9523e11716f6;
var $33d7a74427e1f3f4$export$30ae6ac4023c3a21;
var $33d7a74427e1f3f4$export$8837f4fc672e936d;
var $33d7a74427e1f3f4$export$120ff0929b202a6d;
var $33d7a74427e1f3f4$export$c672d9950c40fe0a;
$33d7a74427e1f3f4$export$7382a268046a9fb1 = `fVtzqW_addLabel`;
$33d7a74427e1f3f4$export$2e19006997105e3f = `fVtzqW_addLabelButton`;
$33d7a74427e1f3f4$export$5cfe825620032318 = `fVtzqW_allOtherIssues`;
$33d7a74427e1f3f4$export$dc5d9523e11716f6 = `fVtzqW_allOtherIssuesButton`;
$33d7a74427e1f3f4$export$30ae6ac4023c3a21 = `fVtzqW_componentSelect`;
$33d7a74427e1f3f4$export$8837f4fc672e936d = `fVtzqW_list`;
$33d7a74427e1f3f4$export$120ff0929b202a6d = `fVtzqW_row`;
$33d7a74427e1f3f4$export$c672d9950c40fe0a = `fVtzqW_swatch`;

});



parcelRegister("frPga", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1f033dcfb69b334$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hddOw = parcelRequire("hddOw");

var $4Jkob = parcelRequire("4Jkob");

var $k4KqQ = parcelRequire("k4KqQ");
var $d1f033dcfb69b334$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4Jkob.default), (0, $hddOw.default))((0, $k4KqQ.default));

});
parcelRegister("hddOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1cd287849338e6a$export$2e2bcd8739ae039);

var $9ffcO = parcelRequire("9ffcO");
const $b1cd287849338e6a$var$mapDispatchToProps = (dispatch)=>({
        addIssueTypeColour: ()=>{
            dispatch((0, $9ffcO.addIssueTypeColour)());
        },
        removeIssueTypeColour: (payload)=>{
            dispatch((0, $9ffcO.removeIssueTypeColour)(payload));
        },
        updateIssueTypeColour: (payload)=>{
            dispatch((0, $9ffcO.updateIssueTypeColour)(payload));
        }
    });
var $b1cd287849338e6a$export$2e2bcd8739ae039 = $b1cd287849338e6a$var$mapDispatchToProps;

});

parcelRegister("4Jkob", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac564763ccaea13$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $kyGCj = parcelRequire("kyGCj");
const $fac564763ccaea13$var$mapStateToProps = (state)=>({
        colourIssueTypes: (0, $kyGCj.getColourIssueTypes)(state),
        issueTypeIds: (0, $lihml.getIssueTypeIds)(state),
        issueTypeIdsOfCompanyManagedProjects: (0, $lihml.getIssueTypeIdsOfCompanyManagedProjects)(state),
        issueTypesById: (0, $lihml.getIssueTypesById)(state),
        issueTypesByName: (0, $lihml.getIssueTypesByName)(state),
        projectsById: (0, $ehEr2.getProjectsById)(state),
        teamManagedProjectByIssueTypeId: (0, $lihml.getTeamManagedProjectByIssueTypeId)(state),
        teamManagedProjectsSortedByName: (0, $ehEr2.getTeamManagedProjectsSortedByName)(state),
        issueTypeIconByName: (0, $lihml.getIssueTypeIconByName)(state)
    });
var $fac564763ccaea13$export$2e2bcd8739ae039 = $fac564763ccaea13$var$mapStateToProps;

});

parcelRegister("k4KqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd93374a181a6f8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $ldoFd = parcelRequire("ldoFd");

var $MdoH4 = parcelRequire("MdoH4");

var $iJlfe = parcelRequire("iJlfe");

var $6ROLN = parcelRequire("6ROLN");

var $bkIGg = parcelRequire("bkIGg");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $3jEV8 = parcelRequire("3jEV8");

var $9nv6P = parcelRequire("9nv6P");

var $iPWWY = parcelRequire("iPWWY");
function $cd93374a181a6f8f$export$d154e1e62b02b1c7(props) {
    const { colourIssueTypes: colourIssueTypes, issueTypesById: issueTypesById, issueTypeIdsOfCompanyManagedProjects: issueTypeIdsOfCompanyManagedProjects, teamManagedProjectsSortedByName: teamManagedProjectsSortedByName, onMenuToggle: onMenuToggle, removeIssueTypeColour: removeIssueTypeColour, updateIssueTypeColour: updateIssueTypeColour, issueTypesByName: issueTypesByName, addIssueTypeColour: addIssueTypeColour, issueTypeIds: issueTypeIds, projectsById: projectsById, teamManagedProjectByIssueTypeId: teamManagedProjectByIssueTypeId, issueTypeIconByName: issueTypeIconByName } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const sortOptionsByLabel = (options)=>options.map((issueTypeId)=>({
                label: issueTypesById[issueTypeId].name,
                value: issueTypeId
            })).sort((a, b)=>a.label.localeCompare(b.label));
    // this function returns the label and value of all selected issue types based on their issue type id
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getIssueTypesValues = (issueTypeIds)=>issueTypeIds.reduce((acc, issueTypeId)=>{
            if (issueTypesById[issueTypeId]?.name) acc.push({
                label: issueTypesById[issueTypeId].name,
                value: issueTypeId
            });
            return acc;
        }, []);
    // this function returns the issue types options grouped by project in the dropdown menu
    // top section includes shortcut to select all (TMP) issue types matching name
    // issue types from company-managed projects are grouped into one group
    // issue types from teams-managed projects are grouped per team-managed project
    const getIssueTypesOptions = (availableIssueTypeIds)=>{
        if (teamManagedProjectsSortedByName.length) {
            const allIssueTypeNameOptions = {
                label: undefined,
                options: (0, $iPWWY.getIssueTypeNamesWithMoreThanOneOccurrence)(Array.from(availableIssueTypeIds), issueTypesById).sort((name, otherName)=>name.localeCompare(otherName)).map((name)=>({
                        label: formatMessage((0, $3jEV8.default).allIssueTypesOption, {
                            issueTypeName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, name)
                        }),
                        value: name
                    }))
            };
            const issueTypesOptions = teamManagedProjectsSortedByName.reduce((acc, project)=>{
                const availableProjectIssueTypeIds = project.issueTypeIds.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
                // showing a project "group" only if some of its issue types are not yet selected for any colour
                if (availableProjectIssueTypeIds.length) acc.push({
                    // the group label is not formatted here but rather in the formatIssueTypeGroupLabel() function,
                    // so here we are just passing the project id as "label"
                    label: project.id,
                    options: sortOptionsByLabel(availableProjectIssueTypeIds)
                });
                return acc;
            }, []);
            // if there are company-managed projects, that group should be displayed first
            if (issueTypeIdsOfCompanyManagedProjects.length) {
                const availableProjectIssueTypeIds = issueTypeIdsOfCompanyManagedProjects.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
                issueTypesOptions.unshift({
                    label: formatMessage((0, $3jEV8.default).companyManagedProjectsLabel),
                    options: sortOptionsByLabel(availableProjectIssueTypeIds)
                });
            }
            // all issue type name fixed to top, before CMP and TMP
            issueTypesOptions.unshift(allIssueTypeNameOptions);
            return issueTypesOptions;
        }
        const availableProjectIssueTypeIds = issueTypeIdsOfCompanyManagedProjects.filter((issueTypeId)=>availableIssueTypeIds.has(issueTypeId));
        return sortOptionsByLabel(availableProjectIssueTypeIds);
    };
    const onIssueTypesChange = (index, options)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(options) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options)) removeIssueTypeColour({
            index: index
        });
        else {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const issueTypeIds = [];
            // ambiguous type
            if (Array.isArray(options)) {
                options.forEach(({ value: value })=>{
                    if (typeof value === 'number') // issue type id
                    issueTypeIds.push(value);
                    else if (typeof value === 'string') // issue type name
                    (issueTypesByName[value] ?? []).forEach(({ id: id })=>issueTypeIds.push(id));
                });
                updateIssueTypeColour({
                    index: index,
                    issueTypes: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(issueTypeIds)
                });
            }
        }
    };
    const onColourChange = (index)=>(colour)=>{
            if ((0, $7CnHa.isDefined)(colour)) updateIssueTypeColour({
                index: index,
                colour: colour
            });
            else removeIssueTypeColour({
                index: index
            });
        };
    // this function formats group labels in the menu
    const formatIssueTypeGroupLabel = (option)=>{
        // option is either
        // { label: project.id, options: [{ label: option.label, value: option.id }] } for team-managed projects
        // { label: groupLabel, options: [{ label: option.label, value: option.id }] } for company-managed projects
        // for team-managed projects
        if (projectsById[option.label]) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.projectHeading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            appearance: "square",
            size: "xsmall",
            src: projectsById[option.label]?.avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.projectName
        }, projectsById[option.label].name)));
        // for company-managed projects
        return option.label;
    };
    // this function formats option labels in the menu
    const formatIssueTypeOptionLabel = (option, { context: context })=>{
        // FF not necessary here because the typeof option.value can only be number when FF disabled
        const iconUrl = typeof option.value === 'string' ? `url(${issueTypeIconByName[option.value]})` : `url(${issueTypesById[option.value]?.iconUrl})`;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.issueTypeOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundImage: iconUrl
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $9nv6P.issueTypeOptionIcon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, context === 'value' && teamManagedProjectByIssueTypeId[option.value]?.key ? `${option.label} (${teamManagedProjectByIssueTypeId[option.value].key})` : option.label)));
    };
    const availableIssueTypeIds = (0, $eUqFw.useMemo)(()=>{
        // this function ensures that the dropdown list of issue types does not include
        // issue types that were already selected for any colour
        const usedIssueTypeIds = new Set((0, $7CnHa.chain)((x)=>x.issueTypes, colourIssueTypes));
        return new Set(issueTypeIds.filter((issueTypeId)=>!usedIssueTypeIds.has(issueTypeId)));
    }, [
        colourIssueTypes,
        issueTypeIds
    ]);
    const renderRow = (colourIssueType, index)=>{
        const { colour: colour, issueTypes: issueTypes = [] } = colourIssueType;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `${index}-${colour || ''}`,
            className: $9nv6P.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
            colour: colour,
            onColourChange: onColourChange(index),
            position: "left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.issueTypeSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
            htmlFor: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.selectIssueType"
        }, formatMessage((0, $7CnHa.isDefined)(colour) ? (0, $3jEV8.default).selectIssueType : (0, $3jEV8.default).selectColour)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-issue-type_select-issue-type-${index}`,
            closeMenuOnSelect: false,
            defaultValue: getIssueTypesValues(issueTypes),
            formatGroupLabel: formatIssueTypeGroupLabel,
            formatOptionLabel: formatIssueTypeOptionLabel,
            isDisabled: !colour,
            isMulti: true,
            menuPlacement: "auto",
            menuPortalTarget: (0, $1ni3W.getBody)(),
            onChange: (options)=>onIssueTypesChange(index, options),
            onMenuClose: ()=>onMenuToggle(false),
            onMenuOpen: ()=>onMenuToggle(true),
            options: getIssueTypesOptions(availableIssueTypeIds),
            placeholder: formatMessage((0, $7CnHa.isDefined)(colour) ? (0, $3jEV8.default).chooseIssueType : (0, $3jEV8.default).chooseColour),
            styles: {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                menuPortal: (styles)=>({
                        ...styles,
                        zIndex: 1000
                    })
            },
            inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.selectIssueType"
        }))));
    };
    const renderAddColourLink = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.addColourLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                label: formatMessage((0, $3jEV8.default).addColour)
            }),
            onClick: ()=>addIssueTypeColour(),
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.add-color-link"
        }, formatMessage((0, $3jEV8.default).addColour)));
    const isAddingNewIssueTypeColour = colourIssueTypes.some(({ colour: colour })=>!colour);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9nv6P.list
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9nv6P.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $9nv6P.allOtherIssuesButton,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $33N5G.colourPickerPaletteLabels)[0, $33N5G.DEFAULT_COLOR]),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9nv6P.swatch,
            style: {
                backgroundColor: (0, $33N5G.DEFAULT_COLOR)
            }
        })),
        isDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9nv6P.allOtherIssues
    }, formatMessage((0, $ib5d3.default).allOtherIssues))), colourIssueTypes.map(renderRow), !isAddingNewIssueTypeColour && renderAddColourLink()));
}
var $cd93374a181a6f8f$export$2e2bcd8739ae039 = $cd93374a181a6f8f$export$d154e1e62b02b1c7;

});
parcelRegister("3jEV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4857a1a12f754547$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4857a1a12f754547$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.add-colour",
        "defaultMessage": "Add color"
    },
    chooseColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.choose-colour",
        "defaultMessage": "Choose color"
    },
    selectColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.select-colour",
        "defaultMessage": "Select color"
    },
    chooseIssueType: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.choose-issue-type",
        "defaultMessage": "Choose issue type"
    },
    selectIssueType: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.select-issue-type",
        "defaultMessage": "Select issue type"
    },
    companyManagedProjectsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.company-managed-projects-label",
        "defaultMessage": "Company-managed projects"
    },
    allIssueTypesOption: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-issue-type.all-issue-types-option",
        "defaultMessage": "All {issueTypeName} issue types"
    }
});

});

parcelRegister("9nv6P", function(module, exports) {

$parcel$export(module.exports, "addColourLink", () => $6d3e64a9ed59a230$export$f627f0c01f3c5e2e, (v) => $6d3e64a9ed59a230$export$f627f0c01f3c5e2e = v);
$parcel$export(module.exports, "allOtherIssues", () => $6d3e64a9ed59a230$export$5cfe825620032318, (v) => $6d3e64a9ed59a230$export$5cfe825620032318 = v);
$parcel$export(module.exports, "allOtherIssuesButton", () => $6d3e64a9ed59a230$export$dc5d9523e11716f6, (v) => $6d3e64a9ed59a230$export$dc5d9523e11716f6 = v);
$parcel$export(module.exports, "issueTypeOption", () => $6d3e64a9ed59a230$export$9e44a4a997031111, (v) => $6d3e64a9ed59a230$export$9e44a4a997031111 = v);
$parcel$export(module.exports, "issueTypeOptionIcon", () => $6d3e64a9ed59a230$export$a7a1cf00f122df53, (v) => $6d3e64a9ed59a230$export$a7a1cf00f122df53 = v);
$parcel$export(module.exports, "issueTypeSelect", () => $6d3e64a9ed59a230$export$d3fef5ce4a91e9ce, (v) => $6d3e64a9ed59a230$export$d3fef5ce4a91e9ce = v);
$parcel$export(module.exports, "list", () => $6d3e64a9ed59a230$export$8837f4fc672e936d, (v) => $6d3e64a9ed59a230$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "projectHeading", () => $6d3e64a9ed59a230$export$55437923f4020fe1, (v) => $6d3e64a9ed59a230$export$55437923f4020fe1 = v);
$parcel$export(module.exports, "projectName", () => $6d3e64a9ed59a230$export$551361c7c5b2aef8, (v) => $6d3e64a9ed59a230$export$551361c7c5b2aef8 = v);
$parcel$export(module.exports, "row", () => $6d3e64a9ed59a230$export$120ff0929b202a6d, (v) => $6d3e64a9ed59a230$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "swatch", () => $6d3e64a9ed59a230$export$c672d9950c40fe0a, (v) => $6d3e64a9ed59a230$export$c672d9950c40fe0a = v);
var $6d3e64a9ed59a230$export$f627f0c01f3c5e2e;
var $6d3e64a9ed59a230$export$5cfe825620032318;
var $6d3e64a9ed59a230$export$dc5d9523e11716f6;
var $6d3e64a9ed59a230$export$9e44a4a997031111;
var $6d3e64a9ed59a230$export$a7a1cf00f122df53;
var $6d3e64a9ed59a230$export$d3fef5ce4a91e9ce;
var $6d3e64a9ed59a230$export$8837f4fc672e936d;
var $6d3e64a9ed59a230$export$55437923f4020fe1;
var $6d3e64a9ed59a230$export$551361c7c5b2aef8;
var $6d3e64a9ed59a230$export$120ff0929b202a6d;
var $6d3e64a9ed59a230$export$c672d9950c40fe0a;
$6d3e64a9ed59a230$export$f627f0c01f3c5e2e = `Xirf0q_addColourLink`;
$6d3e64a9ed59a230$export$5cfe825620032318 = `Xirf0q_allOtherIssues`;
$6d3e64a9ed59a230$export$dc5d9523e11716f6 = `Xirf0q_allOtherIssuesButton`;
$6d3e64a9ed59a230$export$9e44a4a997031111 = `Xirf0q_issueTypeOption`;
$6d3e64a9ed59a230$export$a7a1cf00f122df53 = `Xirf0q_issueTypeOptionIcon`;
$6d3e64a9ed59a230$export$d3fef5ce4a91e9ce = `Xirf0q_issueTypeSelect`;
$6d3e64a9ed59a230$export$8837f4fc672e936d = `Xirf0q_list`;
$6d3e64a9ed59a230$export$55437923f4020fe1 = `Xirf0q_projectHeading`;
$6d3e64a9ed59a230$export$551361c7c5b2aef8 = `Xirf0q_projectName`;
$6d3e64a9ed59a230$export$120ff0929b202a6d = `Xirf0q_row`;
$6d3e64a9ed59a230$export$c672d9950c40fe0a = `Xirf0q_swatch`;

});

parcelRegister("iPWWY", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeNamesWithMoreThanOneOccurrence", () => $ddabf4628358ba1f$export$b955839f34ef1f6);
const $ddabf4628358ba1f$export$b955839f34ef1f6 = (issueTypeIds, issueTypesById)=>{
    const issueTypeNameCounter = {};
    const namesWithMoreThanOneOccurrence = [];
    issueTypeIds.forEach((issueTypeId)=>{
        const issueType = issueTypesById[issueTypeId];
        if (issueType !== undefined) {
            const count = issueTypeNameCounter[issueType.name];
            if (count === undefined) issueTypeNameCounter[issueType.name] = 1;
            else if (count === 1) {
                issueTypeNameCounter[issueType.name] = 2;
                namesWithMoreThanOneOccurrence.push(issueType.name);
            }
        // not necessary to count beyond 2
        }
    });
    return namesWithMoreThanOneOccurrence;
};

});



parcelRegister("bHxpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a879d4df563dd4e$export$2e2bcd8739ae039);
parcelRequire("1afYi");
var $9ffcO = parcelRequire("9ffcO");

var $94enn = parcelRequire("94enn");

var $9H2AP = parcelRequire("9H2AP");

var $lNNXV = parcelRequire("lNNXV");

var $fJFj8 = parcelRequire("fJFj8");
const $5a879d4df563dd4e$var$mapStateToProps = (state)=>({
        colourByConfiguration: (0, $9H2AP.getColorByViewSettings)(state),
        issueLabels: (0, $94enn.getIssueLabels)(state)
    });
const $5a879d4df563dd4e$var$mapDispatchToProps = (dispatch)=>({
        addLabelColour: ()=>{
            dispatch((0, $9ffcO.addLabelColour)());
        },
        updateLabelColour: (payload)=>{
            dispatch((0, $9ffcO.updateLabelColour)(payload));
        },
        removeLabelColour: (payload)=>{
            dispatch((0, $9ffcO.removeLabelColour)(payload));
        }
    });
var $5a879d4df563dd4e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($5a879d4df563dd4e$var$mapStateToProps, $5a879d4df563dd4e$var$mapDispatchToProps)((0, $fJFj8.default));

});
parcelRegister("fJFj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c823dc4fc3cb7573$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");

var $6ROLN = parcelRequire("6ROLN");

var $bkIGg = parcelRequire("bkIGg");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $7oVwo = parcelRequire("7oVwo");

var $1ONBG = parcelRequire("1ONBG");
const $c823dc4fc3cb7573$var$labelsToOptions = (labels)=>labels.map((label)=>({
            value: label,
            label: label
        }));
const $c823dc4fc3cb7573$var$optionsToLabels = (options)=>options.map((x)=>x.value);
class $c823dc4fc3cb7573$export$7029547aac054d9e extends (0, $eUqFw.Component) {
    render() {
        const { colourByConfiguration: { colourLabels: colourLabels }, intl: intl } = this.props;
        const isAddingNewLabelColour = colourLabels.some(({ colour: colour })=>!colour);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $1ONBG.list
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $1ONBG.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $1ONBG.allOtherIssuesButton,
            isDisabled: true,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: intl.formatMessage((0, $33N5G.colourPickerPaletteLabels)[0, $33N5G.DEFAULT_COLOR]),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $1ONBG.swatch,
                style: {
                    backgroundColor: (0, $33N5G.DEFAULT_COLOR)
                }
            }))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $1ONBG.allOtherIssues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).allOtherIssues))), colourLabels.map(this.renderRow), isAddingNewLabelColour ? null : this.renderAddLabel()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            // "keySuffix" was added to force re-render when all labels are removed from any Select to remove its whole row.
            // Reason: to avoid regression when clearing some Select the last Select with the same colour is removed.
            // Also this implementation lets keep focus on Select while editing it from keyboard -
            // https://stash.atlassian.com/plugins/servlet/jira-integration/issues/JPOS-4624
            keySuffix: 0
        };
        // label select must not show labels already picked for any colour
        this.availableLabels = ()=>{
            const { issueLabels: issueLabels, colourByConfiguration: { colourLabels: colourLabels } } = this.props;
            const usedLabels = new Set((0, $7CnHa.chain)((x)=>x.labels, colourLabels));
            return issueLabels.filter((label)=>!usedLabels.has(label));
        };
        this.onLabelsChange = (index, options)=>{
            const { updateLabelColour: updateLabelColour, removeLabelColour: removeLabelColour } = this.props;
            if ($kDrtX.default(options) || $b3iuB.default(options)) {
                removeLabelColour({
                    index: index
                });
                this.setState((prevState)=>({
                        keySuffix: prevState.keySuffix + 1
                    }));
            } else updateLabelColour({
                index: index,
                labels: $c823dc4fc3cb7573$var$optionsToLabels(options)
            });
        };
        this.onColourChange = (index)=>(colour)=>{
                const { updateLabelColour: updateLabelColour, removeLabelColour: removeLabelColour } = this.props;
                if (colour) updateLabelColour({
                    index: index,
                    colour: colour
                });
                else removeLabelColour({
                    index: index
                });
            };
        this.renderRow = (colourLabel, index)=>{
            const { colour: colour, labels: labels } = colourLabel;
            const issueLabels = this.availableLabels();
            const { intl: intl, onMenuToggle: onMenuToggle } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $1ONBG.row,
                key: `${index}-${colour || ''}-${this.state.keySuffix}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
                colour: colour,
                onColourChange: this.onColourChange(index),
                position: "left"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $1ONBG.labelSelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
                htmlFor: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByLabel_select"
            }, intl.formatMessage(colour ? (0, $7oVwo.default).selectVisibleLabel : (0, $7oVwo.default).selectColour)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-label_select-label-${index}`,
                defaultValue: $c823dc4fc3cb7573$var$labelsToOptions(labels),
                isDisabled: !colour,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                onChange: (options)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    this.onLabelsChange(index, options),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: $c823dc4fc3cb7573$var$labelsToOptions(issueLabels),
                placeholder: intl.formatMessage(colour ? (0, $7oVwo.default).chooseLabel : (0, $7oVwo.default).chooseColour),
                styles: {
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                },
                inputId: "portfolio-3.simple-plans_main_tabs_roadmap.view-settings.colourByLabel_select"
            }))));
        };
        this.renderAddLabel = ()=>{
            const { addLabelColour: addLabelColour } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: `${$1ONBG.addLabelButton} ${$1ONBG.row}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                    label: ""
                }),
                onClick: (e)=>{
                    e.preventDefault();
                    addLabelColour();
                },
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.add-color-link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $1ONBG.addLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7oVwo.default).addLabel)))));
        };
    }
}
var $c823dc4fc3cb7573$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c823dc4fc3cb7573$export$7029547aac054d9e);

});
parcelRegister("7oVwo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da35d46b440dbb4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2da35d46b440dbb4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    chooseLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.choose-label",
        "defaultMessage": "Choose label"
    },
    selectVisibleLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.select-visible-label",
        "defaultMessage": "Select label"
    },
    chooseColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.choose-colour",
        "defaultMessage": "Choose color"
    },
    selectColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.select-colour",
        "defaultMessage": "Select color"
    },
    addLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-label.add-label",
        "defaultMessage": "Add color"
    }
});

});

parcelRegister("1ONBG", function(module, exports) {

$parcel$export(module.exports, "addLabel", () => $1530f0ceabb32f86$export$7382a268046a9fb1, (v) => $1530f0ceabb32f86$export$7382a268046a9fb1 = v);
$parcel$export(module.exports, "addLabelButton", () => $1530f0ceabb32f86$export$2e19006997105e3f, (v) => $1530f0ceabb32f86$export$2e19006997105e3f = v);
$parcel$export(module.exports, "allOtherIssues", () => $1530f0ceabb32f86$export$5cfe825620032318, (v) => $1530f0ceabb32f86$export$5cfe825620032318 = v);
$parcel$export(module.exports, "allOtherIssuesButton", () => $1530f0ceabb32f86$export$dc5d9523e11716f6, (v) => $1530f0ceabb32f86$export$dc5d9523e11716f6 = v);
$parcel$export(module.exports, "labelSelect", () => $1530f0ceabb32f86$export$519b192a392926cb, (v) => $1530f0ceabb32f86$export$519b192a392926cb = v);
$parcel$export(module.exports, "list", () => $1530f0ceabb32f86$export$8837f4fc672e936d, (v) => $1530f0ceabb32f86$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "row", () => $1530f0ceabb32f86$export$120ff0929b202a6d, (v) => $1530f0ceabb32f86$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "swatch", () => $1530f0ceabb32f86$export$c672d9950c40fe0a, (v) => $1530f0ceabb32f86$export$c672d9950c40fe0a = v);
var $1530f0ceabb32f86$export$7382a268046a9fb1;
var $1530f0ceabb32f86$export$2e19006997105e3f;
var $1530f0ceabb32f86$export$5cfe825620032318;
var $1530f0ceabb32f86$export$dc5d9523e11716f6;
var $1530f0ceabb32f86$export$519b192a392926cb;
var $1530f0ceabb32f86$export$8837f4fc672e936d;
var $1530f0ceabb32f86$export$120ff0929b202a6d;
var $1530f0ceabb32f86$export$c672d9950c40fe0a;
$1530f0ceabb32f86$export$7382a268046a9fb1 = `dYaZ6G_addLabel`;
$1530f0ceabb32f86$export$2e19006997105e3f = `dYaZ6G_addLabelButton`;
$1530f0ceabb32f86$export$5cfe825620032318 = `dYaZ6G_allOtherIssues`;
$1530f0ceabb32f86$export$dc5d9523e11716f6 = `dYaZ6G_allOtherIssuesButton`;
$1530f0ceabb32f86$export$519b192a392926cb = `dYaZ6G_labelSelect`;
$1530f0ceabb32f86$export$8837f4fc672e936d = `dYaZ6G_list`;
$1530f0ceabb32f86$export$120ff0929b202a6d = `dYaZ6G_row`;
$1530f0ceabb32f86$export$c672d9950c40fe0a = `dYaZ6G_swatch`;

});



parcelRegister("eoc9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $4246c25e1bfe2ed8$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ktZLb = parcelRequire("ktZLb");

var $hAuWz = parcelRequire("hAuWz");

var $g68pT = parcelRequire("g68pT");
var $4246c25e1bfe2ed8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hAuWz.default), (0, $ktZLb.default))((0, $g68pT.default));

});
parcelRegister("ktZLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39336a86a40253b$export$2e2bcd8739ae039);

var $9ffcO = parcelRequire("9ffcO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c39336a86a40253b$export$2e2bcd8739ae039 = (dispatch)=>({
        addPriorityColour: ()=>{
            dispatch((0, $9ffcO.addPriorityColour)());
        },
        removePriorityColour: (payload)=>{
            dispatch((0, $9ffcO.removePriorityColour)(payload));
        },
        updatePriorityColour: (payload)=>{
            dispatch((0, $9ffcO.updatePriorityColour)(payload));
        }
    });

});

parcelRegister("hAuWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbaf40a12a0a3670$export$2e2bcd8739ae039);

var $jp3RH = parcelRequire("jp3RH");

var $kyGCj = parcelRequire("kyGCj");
const $cbaf40a12a0a3670$var$mapStateToProps = (state)=>({
        colourPriorities: (0, $kyGCj.getColourPriorities)(state),
        issuePrioritiesIdList: (0, $jp3RH.getIssuePrioritiesIdList)(state) ?? undefined,
        prioritiesById: (0, $jp3RH.getIssuePriorities)(state)
    });
var $cbaf40a12a0a3670$export$2e2bcd8739ae039 = $cbaf40a12a0a3670$var$mapStateToProps;

});

parcelRegister("g68pT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf924781820cc7c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");

var $bkIGg = parcelRequire("bkIGg");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $4Wp9X = parcelRequire("4Wp9X");

var $9vGzH = parcelRequire("9vGzH");

var $dJ9Qj = parcelRequire("dJ9Qj");
class $9bf924781820cc7c$export$189655d48e326ed1 extends (0, $eUqFw.Component) {
    render() {
        const { colourPriorities: colourPriorities, intl: { formatMessage: formatMessage } } = this.props;
        const isAddingNewPriorityColour = colourPriorities.some(({ colour: colour })=>!colour);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9vGzH.list
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9vGzH.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $9vGzH.allOtherIssuesButton,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $33N5G.colourPickerPaletteLabels)[0, $33N5G.DEFAULT_COLOR]),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9vGzH.swatch,
                style: {
                    backgroundColor: (0, $33N5G.DEFAULT_COLOR)
                }
            })),
            isDisabled: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9vGzH.allOtherIssues
        }, formatMessage((0, $ib5d3.default).allOtherIssues))), colourPriorities.map(this.renderRow), !isAddingNewPriorityColour && this.renderAddColourLink()));
    }
    constructor(...args){
        super(...args);
        this.onPrioritiesChange = (index, options)=>{
            const { updatePriorityColour: updatePriorityColour, removePriorityColour: removePriorityColour } = this.props;
            if ($kDrtX.default(options) || $b3iuB.default(options)) removePriorityColour({
                index: index
            });
            else updatePriorityColour({
                index: index,
                priorities: (0, $dJ9Qj.getOptionsToPriorityIds)(options)
            });
        };
        this.renderPriorityOption = (option)=>{
            const priorityIcon = this.props.prioritiesById[option.value]?.iconUrl;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9vGzH.priorityOption
            }, priorityIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                style: {
                    backgroundImage: `url(${priorityIcon})`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $9vGzH.priorityOptionIcon
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, option.label)));
        };
        this.renderRow = (colourPriority, index)=>{
            const { intl: intl, onMenuToggle: onMenuToggle, prioritiesById: prioritiesById, colourPriorities: colourPriorities, issuePrioritiesIdList: issuePrioritiesIdList, updatePriorityColour: updatePriorityColour, removePriorityColour: removePriorityColour } = this.props;
            const { colour: colour, priorities: priorities = [] } = colourPriority;
            const availablePriorities = (0, $dJ9Qj.getAvailablePriorities)(colourPriorities, issuePrioritiesIdList);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: `${index}-${colour || ''}`,
                "data-testid": `select-priority-wrapper-${index}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $9vGzH.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
                colour: colour,
                onColourChange: (0, $dJ9Qj.onColourChange)(index, removePriorityColour, updatePriorityColour),
                position: "left"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9vGzH.prioritySelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-priority_select-priority-${index}`,
                closeMenuOnSelect: false,
                defaultValue: (0, $dJ9Qj.getPriorityIdsToOptions)(priorities, prioritiesById),
                formatOptionLabel: this.renderPriorityOption,
                isDisabled: !colour,
                isMulti: true,
                menuPlacement: "auto",
                inputId: "priority-select",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                onChange: (options)=>this.onPrioritiesChange(index, options),
                onMenuClose: ()=>onMenuToggle(false),
                onMenuOpen: ()=>onMenuToggle(true),
                options: (0, $dJ9Qj.getPriorityIdsToOptions)(availablePriorities, prioritiesById),
                placeholder: intl.formatMessage((0, $7CnHa.isDefined)(colour) ? (0, $4Wp9X.default).choosePriority : (0, $4Wp9X.default).chooseColour),
                styles: {
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                }
            })));
        };
        this.renderAddColourLink = ()=>{
            const { addPriorityColour: addPriorityColour, intl: { formatMessage: formatMessage } } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9vGzH.addColourLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                    label: formatMessage((0, $4Wp9X.default).addColour)
                }),
                onClick: ()=>addPriorityColour(),
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.add-color-link"
            }, formatMessage((0, $4Wp9X.default).addColour))));
        };
    }
}
var $9bf924781820cc7c$export$2e2bcd8739ae039 = (0, $2qhQi.default)($9bf924781820cc7c$export$189655d48e326ed1);

});
parcelRegister("4Wp9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7602fe1757d4f08$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c7602fe1757d4f08$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.add-colour",
        "defaultMessage": "Add color"
    },
    chooseColour: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.choose-colour",
        "defaultMessage": "Choose color"
    },
    choosePriority: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-priority.choose-priority",
        "defaultMessage": "Choose priority"
    }
});

});

parcelRegister("9vGzH", function(module, exports) {

$parcel$export(module.exports, "addColourLink", () => $6ec808c2d25b6178$export$f627f0c01f3c5e2e, (v) => $6ec808c2d25b6178$export$f627f0c01f3c5e2e = v);
$parcel$export(module.exports, "allOtherIssues", () => $6ec808c2d25b6178$export$5cfe825620032318, (v) => $6ec808c2d25b6178$export$5cfe825620032318 = v);
$parcel$export(module.exports, "allOtherIssuesButton", () => $6ec808c2d25b6178$export$dc5d9523e11716f6, (v) => $6ec808c2d25b6178$export$dc5d9523e11716f6 = v);
$parcel$export(module.exports, "list", () => $6ec808c2d25b6178$export$8837f4fc672e936d, (v) => $6ec808c2d25b6178$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "priorityOption", () => $6ec808c2d25b6178$export$155152b53237140d, (v) => $6ec808c2d25b6178$export$155152b53237140d = v);
$parcel$export(module.exports, "priorityOptionIcon", () => $6ec808c2d25b6178$export$e51be9b6e86c3e6e, (v) => $6ec808c2d25b6178$export$e51be9b6e86c3e6e = v);
$parcel$export(module.exports, "prioritySelect", () => $6ec808c2d25b6178$export$ee83c1b866c8c1f4, (v) => $6ec808c2d25b6178$export$ee83c1b866c8c1f4 = v);
$parcel$export(module.exports, "row", () => $6ec808c2d25b6178$export$120ff0929b202a6d, (v) => $6ec808c2d25b6178$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "swatch", () => $6ec808c2d25b6178$export$c672d9950c40fe0a, (v) => $6ec808c2d25b6178$export$c672d9950c40fe0a = v);
var $6ec808c2d25b6178$export$f627f0c01f3c5e2e;
var $6ec808c2d25b6178$export$5cfe825620032318;
var $6ec808c2d25b6178$export$dc5d9523e11716f6;
var $6ec808c2d25b6178$export$8837f4fc672e936d;
var $6ec808c2d25b6178$export$155152b53237140d;
var $6ec808c2d25b6178$export$e51be9b6e86c3e6e;
var $6ec808c2d25b6178$export$ee83c1b866c8c1f4;
var $6ec808c2d25b6178$export$120ff0929b202a6d;
var $6ec808c2d25b6178$export$c672d9950c40fe0a;
$6ec808c2d25b6178$export$f627f0c01f3c5e2e = `tsWTQG_addColourLink`;
$6ec808c2d25b6178$export$5cfe825620032318 = `tsWTQG_allOtherIssues`;
$6ec808c2d25b6178$export$dc5d9523e11716f6 = `tsWTQG_allOtherIssuesButton`;
$6ec808c2d25b6178$export$8837f4fc672e936d = `tsWTQG_list`;
$6ec808c2d25b6178$export$155152b53237140d = `tsWTQG_priorityOption`;
$6ec808c2d25b6178$export$e51be9b6e86c3e6e = `tsWTQG_priorityOptionIcon`;
$6ec808c2d25b6178$export$ee83c1b866c8c1f4 = `tsWTQG_prioritySelect`;
$6ec808c2d25b6178$export$120ff0929b202a6d = `tsWTQG_row`;
$6ec808c2d25b6178$export$c672d9950c40fe0a = `tsWTQG_swatch`;

});

parcelRegister("dJ9Qj", function(module, exports) {

$parcel$export(module.exports, "getPriorityIdsToOptions", () => $63fedb499e475d03$export$95876874e89972af);
$parcel$export(module.exports, "getOptionsToPriorityIds", () => $63fedb499e475d03$export$8e3d2d44e81969a9);
$parcel$export(module.exports, "getAvailablePriorities", () => $63fedb499e475d03$export$c6cdd4b9fa03ef76);
$parcel$export(module.exports, "onColourChange", () => $63fedb499e475d03$export$3c5f96994762a26);

var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");

var $7CnHa = parcelRequire("7CnHa");
const $63fedb499e475d03$export$95876874e89972af = (priorityIds, prioritiesById)=>priorityIds.reduce((acc, priorityId)=>{
        // this check prevents a plan crash if a priority previously picked for any colour is removed from the plan
        if (prioritiesById[priorityId]) acc.push({
            label: prioritiesById[priorityId].name,
            value: priorityId
        });
        return acc;
    }, []);
const $63fedb499e475d03$export$8e3d2d44e81969a9 = (options)=>$cQGVO.default($f7Op5.default('value'), options);
const $63fedb499e475d03$export$c6cdd4b9fa03ef76 = (colourPriorities, issuePrioritiesIdList = [])=>{
    const usedPriorities = new Set((0, $7CnHa.chain)((x)=>x.priorities, colourPriorities));
    return issuePrioritiesIdList.filter((priorityId)=>!usedPriorities.has(priorityId));
};
const $63fedb499e475d03$export$3c5f96994762a26 = (index, removePriorityColour, updatePriorityColour)=>(colour)=>{
        if ((0, $7CnHa.isDefined)(colour)) updatePriorityColour({
            index: index,
            colour: colour
        });
        else removePriorityColour({
            index: index
        });
    };

});



parcelRegister("kVa9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9302e6cf1fb2af$export$2e2bcd8739ae039);
parcelRequire("1afYi");
var $9ffcO = parcelRequire("9ffcO");

var $kKj1m = parcelRequire("kKj1m");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");

var $lNNXV = parcelRequire("lNNXV");

var $1vRmZ = parcelRequire("1vRmZ");
const $cc9302e6cf1fb2af$var$mapStateToProps = (state)=>({
        colourByConfiguration: (0, $9H2AP.getColorByViewSettings)(state),
        selectOptionsFromIssues: (0, $kyGCj.getSelectOptionsFromIssues)(state),
        selectOptions: (0, $kKj1m.getSelectOptions)(state)
    });
const $cc9302e6cf1fb2af$var$mapDispatchToProps = (dispatch)=>({
        addSelectColour: ()=>{
            dispatch((0, $9ffcO.addSelectColour)());
        },
        updateSelectColour: (payload)=>{
            dispatch((0, $9ffcO.updateSelectColour)(payload));
        },
        removeSelectColour: (payload)=>{
            dispatch((0, $9ffcO.removeSelectColour)(payload));
        }
    });
var $cc9302e6cf1fb2af$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($cc9302e6cf1fb2af$var$mapStateToProps, $cc9302e6cf1fb2af$var$mapDispatchToProps)((0, $1vRmZ.default));

});
parcelRegister("1vRmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $193e19de7089a6c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $kDrtX = parcelRequire("kDrtX");

var $bkIGg = parcelRequire("bkIGg");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $8j60h = parcelRequire("8j60h");

var $6qUQC = parcelRequire("6qUQC");
const $193e19de7089a6c9$export$742fca7ce59eb416 = (values, options)=>values.map((value)=>{
        const label = options.find((option)=>option.id.toString() === value);
        return {
            value: value,
            label: label ? label.value : value
        };
    });
const $193e19de7089a6c9$var$optionsToLabels = (options)=>options.map((x)=>x.value);
// eslint-disable-next-line jira/react/no-class-components
class $193e19de7089a6c9$var$ColourBySelect extends (0, $eUqFw.Component) {
    render() {
        const values = this.getValues();
        const isAddingNewLabelColour = values.some(({ colour: colour })=>!colour);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $6qUQC.list
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $6qUQC.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $6qUQC.allOtherIssuesButton,
            isDisabled: true,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6qUQC.swatch,
                style: {
                    backgroundColor: (0, $33N5G.DEFAULT_COLOR)
                }
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $6qUQC.allOtherIssues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).allOtherIssues))), values.map(this.renderRow), isAddingNewLabelColour ? null : this.renderAddLabel()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            // "keySuffix" was added to force re-render when all labels are removed from any Select to remove its whole row.
            // Reason: to avoid regression when clearing some Select the last Select with the same colour is removed.
            // Also this implementation lets keep focus on Select while editing it from keyboard -
            // https://stash.atlassian.com/plugins/servlet/jira-integration/issues/JPOS-4624
            keySuffix: 0
        };
        // label select must not show labels already picked for any colour
        this.getAvailableOptions = ()=>{
            const { selectOptionsFromIssues: selectOptionsFromIssues } = this.props;
            const usedOptions = new Set((0, $7CnHa.chain)((x)=>x.options, this.getValues()));
            return selectOptionsFromIssues.filter((option)=>!usedOptions.has(option)).map((option)=>option.toString());
        };
        this.onLabelsChange = (index, options)=>{
            const { updateSelectColour: updateSelectColour, removeSelectColour: removeSelectColour } = this.props;
            if ($kDrtX.default(options) || $b3iuB.default(options)) {
                removeSelectColour({
                    index: index
                });
                this.setState((prevState)=>({
                        keySuffix: prevState.keySuffix + 1
                    }));
            } else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            updateSelectColour({
                index: index,
                options: $193e19de7089a6c9$var$optionsToLabels(options)
            });
        };
        this.onColourChange = (index)=>(colour)=>{
                const { updateSelectColour: updateSelectColour, removeSelectColour: removeSelectColour } = this.props;
                if (colour) updateSelectColour({
                    index: index,
                    colour: colour
                });
                else removeSelectColour({
                    index: index
                });
            };
        this.renderRow = (colourSelect, index)=>{
            const { intl: intl, onMenuToggle: onMenuToggle, selectOptions: selectOptions } = this.props;
            const { colour: colour, options: options } = colourSelect;
            const availableOptions = this.getAvailableOptions();
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6qUQC.row,
                key: `${index}-${colour || ''}-${this.state.keySuffix}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
                colour: colour,
                onColourChange: this.onColourChange(index),
                position: "left"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6qUQC.labelSelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                classNamePrefix: `portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_colour-by-select_select-select-${index}`,
                defaultValue: $193e19de7089a6c9$export$742fca7ce59eb416(options, selectOptions),
                isDisabled: !colour,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                // eslint-disable-next-line @typescript-eslint/no-shadow
                onChange: (options)=>this.onLabelsChange(index, options),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: $193e19de7089a6c9$export$742fca7ce59eb416(availableOptions, selectOptions),
                placeholder: intl.formatMessage(colour ? (0, $8j60h.default).findLabel : (0, $8j60h.default).selectLabel),
                styles: {
                    // eslint-disable-next-line @typescript-eslint/no-shadow
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                }
            }))));
        };
        this.renderAddLabel = ()=>{
            const { addSelectColour: addSelectColour } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: `${$6qUQC.addLabelButton} ${$6qUQC.row}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                    label: ""
                }),
                onClick: (e)=>{
                    e.preventDefault();
                    addSelectColour();
                },
                testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.add-color-link"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $6qUQC.addLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8j60h.default).addLabel)))));
        };
        this.getValues = ()=>{
            const { colourByConfiguration: { colourSelects: colourSelects, colourByValue: colourByValue } } = this.props;
            return colourSelects[colourByValue] || [];
        };
    }
}
var $193e19de7089a6c9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($193e19de7089a6c9$var$ColourBySelect);

});
parcelRegister("8j60h", function(module, exports) {

$parcel$export(module.exports, "default", () => $96230b2dde08672a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $96230b2dde08672a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    findLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.find-label",
        "defaultMessage": "Choose option"
    },
    selectLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.select-label",
        "defaultMessage": "Choose color"
    },
    addLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.colour-by-select.add-label",
        "defaultMessage": "Add color"
    }
});

});

parcelRegister("6qUQC", function(module, exports) {

$parcel$export(module.exports, "addLabel", () => $4af14493de1d72f7$export$7382a268046a9fb1, (v) => $4af14493de1d72f7$export$7382a268046a9fb1 = v);
$parcel$export(module.exports, "addLabelButton", () => $4af14493de1d72f7$export$2e19006997105e3f, (v) => $4af14493de1d72f7$export$2e19006997105e3f = v);
$parcel$export(module.exports, "allOtherIssues", () => $4af14493de1d72f7$export$5cfe825620032318, (v) => $4af14493de1d72f7$export$5cfe825620032318 = v);
$parcel$export(module.exports, "allOtherIssuesButton", () => $4af14493de1d72f7$export$dc5d9523e11716f6, (v) => $4af14493de1d72f7$export$dc5d9523e11716f6 = v);
$parcel$export(module.exports, "labelSelect", () => $4af14493de1d72f7$export$519b192a392926cb, (v) => $4af14493de1d72f7$export$519b192a392926cb = v);
$parcel$export(module.exports, "list", () => $4af14493de1d72f7$export$8837f4fc672e936d, (v) => $4af14493de1d72f7$export$8837f4fc672e936d = v);
$parcel$export(module.exports, "row", () => $4af14493de1d72f7$export$120ff0929b202a6d, (v) => $4af14493de1d72f7$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "swatch", () => $4af14493de1d72f7$export$c672d9950c40fe0a, (v) => $4af14493de1d72f7$export$c672d9950c40fe0a = v);
var $4af14493de1d72f7$export$7382a268046a9fb1;
var $4af14493de1d72f7$export$2e19006997105e3f;
var $4af14493de1d72f7$export$5cfe825620032318;
var $4af14493de1d72f7$export$dc5d9523e11716f6;
var $4af14493de1d72f7$export$519b192a392926cb;
var $4af14493de1d72f7$export$8837f4fc672e936d;
var $4af14493de1d72f7$export$120ff0929b202a6d;
var $4af14493de1d72f7$export$c672d9950c40fe0a;
$4af14493de1d72f7$export$7382a268046a9fb1 = `Z0-zja_addLabel`;
$4af14493de1d72f7$export$2e19006997105e3f = `Z0-zja_addLabelButton`;
$4af14493de1d72f7$export$5cfe825620032318 = `Z0-zja_allOtherIssues`;
$4af14493de1d72f7$export$dc5d9523e11716f6 = `Z0-zja_allOtherIssuesButton`;
$4af14493de1d72f7$export$519b192a392926cb = `Z0-zja_labelSelect`;
$4af14493de1d72f7$export$8837f4fc672e936d = `Z0-zja_list`;
$4af14493de1d72f7$export$120ff0929b202a6d = `Z0-zja_row`;
$4af14493de1d72f7$export$c672d9950c40fe0a = `Z0-zja_swatch`;

});



parcelRegister("4a353", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab257e916994b6ab$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2HZhj = parcelRequire("2HZhj");

var $6BqnB = parcelRequire("6BqnB");

var $5mf3j = parcelRequire("5mf3j");
var $ab257e916994b6ab$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6BqnB.default), (0, $2HZhj.default))((0, $5mf3j.default));

});
parcelRegister("2HZhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca714ae3f4c2adce$export$2e2bcd8739ae039);

var $8fleG = parcelRequire("8fleG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca714ae3f4c2adce$export$2e2bcd8739ae039 = (dispatch)=>({
        changeDisplay: (payload)=>{
            dispatch((0, $8fleG.changeDisplay)(payload));
        }
    });

});

parcelRegister("6BqnB", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cdc53e63cfffd7$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $06cdc53e63cfffd7$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    dependencySettings: (0, $9H2AP.getDependencySettings),
    viewMode: (0, $9H2AP.getViewMode)
});

});

parcelRegister("5mf3j", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e8cfe2ce35fdf2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $6ETZE = parcelRequire("6ETZE");
var $jQxSL = parcelRequire("jQxSL");
var $gwbfD = parcelRequire("gwbfD");
var $lcvrv = parcelRequire("lcvrv");

var $cuuJa = parcelRequire("cuuJa");

var $1ni3W = parcelRequire("1ni3W");

var $5rYNM = parcelRequire("5rYNM");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8e2Vk = parcelRequire("8e2Vk");

var $i6GjB = parcelRequire("i6GjB");
const { LINES: $e0e8cfe2ce35fdf2$var$LINES, DEFAULT: $e0e8cfe2ce35fdf2$var$DEFAULT, COUNT: $e0e8cfe2ce35fdf2$var$COUNT } = (0, $5rYNM.DEPENDENCY_SETTINGS);
const $e0e8cfe2ce35fdf2$export$e161bc0b9865a0b7 = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8e2Vk.default).default),
        value: $e0e8cfe2ce35fdf2$var$DEFAULT
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8e2Vk.default).lines),
        value: $e0e8cfe2ce35fdf2$var$LINES
    }
];
// Extend the default Option to have accessible tags (https://github.com/JedWatson/react-select/pull/4322#issuecomment-749134033)
const $e0e8cfe2ce35fdf2$var$Option = (props)=>{
    const innerProps = {
        ...props.innerProps,
        role: 'option',
        'aria-disabled': props.isDisabled
    };
    const Elem = (0, $jQxSL.c).Option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Elem, {
        ...props,
        innerProps: innerProps
    });
};
function $e0e8cfe2ce35fdf2$export$2e2bcd8739ae039({ changeDisplay: changeDisplay, dependencySettings: dependencySettings, onMenuToggle: onMenuToggle, viewMode: viewMode }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { display: display } = dependencySettings;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOptionClick = (0, $eUqFw.useCallback)((setting)=>{
        changeDisplay({
            display: setting
        });
    }, [
        changeDisplay
    ]);
    const onCheckSelected = (0, $eUqFw.useCallback)((event)=>{
        const nextValue = event.target.checked ? $e0e8cfe2ce35fdf2$var$COUNT : $e0e8cfe2ce35fdf2$var$DEFAULT;
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DEPENDENCY_TYPE_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject,
            action: action
        }), actionSubjectId, {
            newPlanSettingValue: nextValue
        });
        handleOptionClick(nextValue);
    }, [
        createAnalyticsEvent,
        handleOptionClick
    ]);
    const triggerId = display === $e0e8cfe2ce35fdf2$var$LINES ? $e0e8cfe2ce35fdf2$var$LINES : $e0e8cfe2ce35fdf2$var$DEFAULT;
    const selectedValue = (0, $eUqFw.useMemo)(()=>$e0e8cfe2ce35fdf2$export$e161bc0b9865a0b7.find(({ value: value })=>value === triggerId), [
        triggerId
    ]);
    const onSelectChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ value: value })=>{
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DEPENDENCY_TYPE_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject,
            action: action
        }), actionSubjectId, {
            newPlanSettingValue: value === $e0e8cfe2ce35fdf2$var$DEFAULT ? 'badges' : value
        });
        changeDisplay({
            display: value
        });
    }, [
        changeDisplay,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: viewMode === (0, $lcvrv.VIEW_MODES).LIST ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8e2Vk.default).disabledTooltip) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        blurInputOnSelect: true,
        closeMenuOnSelect: true,
        isMulti: false,
        isDisabled: viewMode === (0, $lcvrv.VIEW_MODES).LIST,
        isSearchable: false,
        // Extend the default <Option /> component to render a better accessbile <div /> wrapper and makes easier write testing
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        components: {
            Option: $e0e8cfe2ce35fdf2$var$Option
        },
        menuPortalTarget: (0, $1ni3W.getBody)(),
        onChange: onSelectChange,
        onMenuClose: ()=>onMenuToggle(false),
        onMenuOpen: ()=>onMenuToggle(true),
        options: $e0e8cfe2ce35fdf2$export$e161bc0b9865a0b7,
        styles: {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            menuPortal: (styles)=>({
                    ...styles,
                    zIndex: 1000
                })
        },
        value: selectedValue,
        ...(0, $1ybV0.ff)('jsw.roadmaps.timeline-viewsettings-dropdown-button-arialabel-1120_7ctf1') && {
            'aria-label': formatMessage((0, $8e2Vk.default).dependencySettingAriaLabel, {
                selectedOption: selectedValue?.value === $e0e8cfe2ce35fdf2$var$DEFAULT ? 'Badges' : selectedValue?.value
            })
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i6GjB.checkboxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        isDisabled: display === $e0e8cfe2ce35fdf2$var$LINES,
        isChecked: display === $e0e8cfe2ce35fdf2$var$COUNT,
        onChange: onCheckSelected,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8e2Vk.default).count)
    })));
}

});
parcelRegister("8e2Vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $423a099bd7b721a3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $423a099bd7b721a3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    default: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.default",
        "defaultMessage": "Badges"
    },
    lines: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.lines",
        "defaultMessage": "Lines"
    },
    count: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.count",
        "defaultMessage": "Show number of dependencies"
    },
    disabledTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.disabled-tooltip",
        "defaultMessage": "This option is unavailable in list view"
    },
    dependencySettingAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings.dependency-setting-aria-label",
        "defaultMessage": "Dependency style {selectedOption}"
    }
});

});

parcelRegister("i6GjB", function(module, exports) {

$parcel$export(module.exports, "checkboxWrapper", () => $d2e99c715f940c95$export$8b18e1c47ccc2c63, (v) => $d2e99c715f940c95$export$8b18e1c47ccc2c63 = v);
var $d2e99c715f940c95$export$8b18e1c47ccc2c63;
$d2e99c715f940c95$export$8b18e1c47ccc2c63 = `Dx8POa_checkboxWrapper`;

});



parcelRegister("kINxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f157df920d14d0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $c60Wp = parcelRequire("c60Wp");

var $iV3rK = parcelRequire("iV3rK");

var $jAftF = parcelRequire("jAftF");
var $80f157df920d14d0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iV3rK.mapStateToProps), (0, $c60Wp.default))((0, $jAftF.default));

});
parcelRegister("c60Wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5000db6f473a7cb$export$2e2bcd8739ae039);
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");
const $c5000db6f473a7cb$var$mapDispatchToProps = (dispatch)=>({
        changeGroup: (group)=>{
            dispatch((0, $l1dWb.changeGroup)({
                grouping: group
            }));
        }
    });
var $c5000db6f473a7cb$export$2e2bcd8739ae039 = $c5000db6f473a7cb$var$mapDispatchToProps;

});

parcelRegister("iV3rK", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $b59a866678984fd5$export$c31df4bd766f9c35);

var $kKj1m = parcelRequire("kKj1m");

var $dhHiZ = parcelRequire("dhHiZ");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
const $b59a866678984fd5$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    customFields: (0, $kKj1m.getCustomFields),
    grouping: (0, $kyGCj.getVisualisationGrouping),
    isAtlasConnectInstalled: $dhHiZ.isAtlasConnectInstalled
});

});

parcelRegister("jAftF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5811984eb80a3355$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuuJa = parcelRequire("cuuJa");

var $5rYNM = parcelRequire("5rYNM");

var $9RUk7 = parcelRequire("9RUk7");

var $2BQwE = parcelRequire("2BQwE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $31WUh = parcelRequire("31WUh");

var $i4lB7 = parcelRequire("i4lB7");
function $5811984eb80a3355$export$2e2bcd8739ae039({ changeGroup: changeGroup, customFields: customFields, grouping: grouping, isDefaultMenuOpen: isDefaultMenuOpen = false, onMenuToggle: onMenuToggle, isAtlasConnectInstalled: isAtlasConnectInstalled }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const changeGroupBy = ({ type: type, value: value })=>{
        (0, $duQ8C.default)((0, $2BQwE.KEYS).CHANGE_GROUP_BY_SETTING);
        changeGroup(value);
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).GROUP_BY_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject,
            action: action
        }), actionSubjectId, {
            newPlanSettingValue: type
        });
    };
    const standardFieldsOptions = Object.keys((0, $9RUk7.standardFieldsGroupings)(isAtlasConnectInstalled)).map((key)=>({
            content: formatMessage((0, $9RUk7.getGroupByStandardFieldLabel)(key)),
            id: key,
            label: formatMessage((0, $9RUk7.getGroupByStandardFieldLabel)(key)),
            type: key,
            value: key
        }));
    const customFieldsOptions = Object.entries((0, $9RUk7.getGroupingCustomFields)(customFields)).map(([key, { title: title, type: type }])=>({
            content: title,
            id: key,
            label: title,
            type: type,
            value: key
        })) ?? [];
    if (!isAtlasConnectInstalled && grouping === (0, $5rYNM.GROUPING).GOALS) changeGroupBy({
        type: 'standard',
        value: (0, $5rYNM.GROUPING).NONE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31WUh.default), {
        classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_group-by",
        customFieldsOptions: customFieldsOptions,
        handleOnChange: changeGroupBy,
        isDefaultMenuOpen: isDefaultMenuOpen,
        onMenuToggle: onMenuToggle,
        standardFieldsOptions: standardFieldsOptions,
        selectedFieldId: grouping,
        ...(0, $1ybV0.ff)('jsw.roadmaps.timeline-viewsettings-dropdown-button-arialabel-1120_7ctf1') && {
            label: formatMessage((0, $i4lB7.default).groupByLabel)
        }
    });
}

});
parcelRegister("i4lB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $081fa6bdd1ee28c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $081fa6bdd1ee28c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupByLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.group-by-label",
        "defaultMessage": "Group by"
    }
});

});



parcelRegister("cpL1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4583a06dc21c7f2f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kpjGq = parcelRequire("kpjGq");

var $jMSc9 = parcelRequire("jMSc9");

var $75YRF = parcelRequire("75YRF");
var $4583a06dc21c7f2f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jMSc9.default), (0, $kpjGq.default))((0, $75YRF.default));

});
parcelRegister("kpjGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c65880f5f5e3159$export$2e2bcd8739ae039);
parcelRequire("khGZ4");
var $b7OiP = parcelRequire("b7OiP");
const $6c65880f5f5e3159$var$mapDispatchToProps = (dispatch)=>({
        addGroup: (group)=>{
            dispatch((0, $b7OiP.add)(group));
        },
        updateGroup: (groupId, patch)=>{
            dispatch((0, $b7OiP.update)({
                id: groupId,
                patch: patch
            }));
        },
        removeGroup: (groupId)=>{
            dispatch((0, $b7OiP.remove)(groupId));
        }
    });
var $6c65880f5f5e3159$export$2e2bcd8739ae039 = $6c65880f5f5e3159$var$mapDispatchToProps;

});

parcelRegister("jMSc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1cc32de1c4b163b$export$2e2bcd8739ae039);

var $lvJU2 = parcelRequire("lvJU2");

var $ehEr2 = parcelRequire("ehEr2");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
var $b1cc32de1c4b163b$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    componentGroups: (0, $9H2AP.getComponentGroupsViewSettings),
    componentsById: (0, $lvJU2.getComponentsById),
    projectsById: (0, $ehEr2.getProjectsById)
});

});

parcelRegister("75YRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $386cc87fa3822acc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hkOxK = parcelRequire("hkOxK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $bkIGg = parcelRequire("bkIGg");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
parcelRequire("9H2AP");

var $it3if = parcelRequire("it3if");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $esjUr = parcelRequire("esjUr");

var $6byWG = parcelRequire("6byWG");
const $386cc87fa3822acc$var$trimName = (name)=>{
    const maxLength = 254;
    return name.length > maxLength ? name.substring(0, maxLength) : name;
};
// eslint-disable-next-line jira/react/no-class-components
class $386cc87fa3822acc$var$GroupByComponents extends (0, $eUqFw.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props);
        this.isNewGroupNameValid = (newName)=>{
            const allGroupNames = new Set(this.props.componentGroups.map(({ name: name })=>name));
            return !allGroupNames.has(newName);
        };
        this.isAllOtherIssuesGroup = (id)=>id === (0, $bb09f71c7817719d$export$526fec6b76d5bc5);
        this.onCreateGroup = ()=>this.setState({
                isCreating: true
            });
        this.onCancelCreateGroup = ()=>this.setState({
                isCreating: false
            });
        this.onConfirmingCreateGroup = (newName)=>{
            this.onCancelCreateGroup();
            if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
            this.props.addGroup({
                id: $386cc87fa3822acc$var$trimName(newName).toLowerCase(),
                name: $386cc87fa3822acc$var$trimName(newName),
                isExpanded: true,
                components: []
            });
        };
        this.onConfirmingUpdateGroup = (id, newName)=>{
            if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
            this.props.updateGroup(id, {
                id: $386cc87fa3822acc$var$trimName(newName).toLowerCase(),
                name: $386cc87fa3822acc$var$trimName(newName)
            });
        };
        this.onUpdatingComponentsInGroup = (id, selectValue)=>{
            if ((0, $7CnHa.isDefined)(selectValue)) this.props.updateGroup(id, {
                components: selectValue.map(({ value: value })=>value)
            });
        };
        this.toggleExpanded = (id, isExpanded)=>this.props.updateGroup(id, {
                isExpanded: isExpanded
            });
        this.renderComponentSelect = (groupId, components)=>{
            const { componentsById: componentsById, intl: { formatMessage: formatMessage }, onMenuToggle: onMenuToggle, projectsById: projectsById } = this.props;
            const allComponents = Object.keys(componentsById).map((k)=>componentsById[parseFloat(k)]);
            const options = $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('name')))(allComponents).map(({ id: id, name: name, projectId: projectId })=>({
                    value: id,
                    label: `${name} (${projectsById[projectId].key})`
                }));
            const valueOptions = options.filter(({ value: value })=>components.includes(value));
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $6byWG.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $6byWG.componentSelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                autoFocus: true,
                classNamePrefix: "group-by-custom-options-select",
                defaultValue: valueOptions,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                onChange: (value)=>this.onUpdatingComponentsInGroup(groupId, value),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: options,
                placeholder: formatMessage((0, $esjUr.default).componentPlaceholder),
                // eslint-disable-next-line @typescript-eslint/no-shadow
                styles: {
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                }
            })))));
        };
        this.renderGroup = (group)=>{
            const { id: id, isExpanded: isExpanded, components: components } = group;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $6byWG.row,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
                groupName: group.name,
                groupId: id,
                isExpanded: isExpanded,
                onConfirm: (newName)=>{
                    this.onConfirmingUpdateGroup(id, newName);
                },
                onCancel: this.onCancelCreateGroup,
                onDelete: this.props.removeGroup,
                onToggleExpanded: this.toggleExpanded
            }))), !this.isAllOtherIssuesGroup(id) && isExpanded && this.renderComponentSelect(id, components));
        };
        this.state = {
            isCreating: false
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.props.componentGroups.map(this.renderGroup), this.state.isCreating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $6byWG.row,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.creating-group-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
            shouldCreateGroup: true,
            onConfirm: this.onConfirmingCreateGroup,
            onCancel: this.onCancelCreateGroup
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $6byWG.componentGroup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$6byWG.icon} ${$6byWG.blue}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "link",
            onClick: this.onCreateGroup,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.create-components-group"
        }, formatMessage((0, $esjUr.default).createGroup))))));
    }
}
var $386cc87fa3822acc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($386cc87fa3822acc$var$GroupByComponents);

});
parcelRegister("it3if", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffb9ca9839070ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dwj4T = parcelRequire("dwj4T");

var $e5T2d = parcelRequire("e5T2d");

var $ajCg0 = parcelRequire("ajCg0");

var $fEMj1 = parcelRequire("fEMj1");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $5CV7v = parcelRequire("5CV7v");
var $eNhh9 = parcelRequire("eNhh9");
var $6GmrT = parcelRequire("6GmrT");
var $gwbfD = parcelRequire("gwbfD");
parcelRequire("9H2AP");

var $fnOfj = parcelRequire("fnOfj");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $7zyYg = parcelRequire("7zyYg");

var $3WQ2C = parcelRequire("3WQ2C");
const $4ffb9ca9839070ac$var$COMPONENT_GROUP_TEMPORARY_ID = 'jpo_group_temp_id';
// eslint-disable-next-line jira/react/no-class-components
class $4ffb9ca9839070ac$var$Group extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            groupId: $4ffb9ca9839070ac$var$COMPONENT_GROUP_TEMPORARY_ID,
            groupName: '',
            isExpanded: false,
            shouldCreateGroup: false,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDelete: ()=>{},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onToggleExpanded: ()=>{}
        };
    }
    render() {
        const { intl: intl, groupId: groupId, groupName: groupName, isExpanded: isExpanded, shouldCreateGroup: shouldCreateGroup, onConfirm: onConfirm, onCancel: onCancel } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3WQ2C.group
        }, !(this.isAllOtherIssuesGroup(groupId) || shouldCreateGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $3WQ2C.expandCollapseChevron,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.expand-group-wrapper"
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
            onClick: this.onChevronDownClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
            label: ""
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
            onClick: this.onChevronRightClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3WQ2C.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
            label: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3WQ2C.groupTitleSection
        }, this.isAllOtherIssuesGroup(groupId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).allOtherIssues) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3WQ2C.groupTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GmrT.default), {
            defaultValue: groupName,
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                    content: errorMessage,
                    isOpen: fieldProps.isInvalid,
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ...fieldProps,
                    autoFocus: shouldCreateGroup,
                    elemAfterInput: fieldProps && fieldProps.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                        label: "",
                        primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
                    }),
                    maxLength: 256,
                    placeholder: intl.formatMessage((0, $7zyYg.default).groupPlaceholder),
                    testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.group-name-input"
                })),
            onCancel: onCancel,
            onConfirm: onConfirm,
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                    content: groupName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $3WQ2C.groupTitleReadViewContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, groupName))),
            startWithEditViewOpen: shouldCreateGroup,
            validate: this.validateGroupTitle
        })), !shouldCreateGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $3WQ2C.trashButton,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.delete-group-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "subtle",
            onClick: this.onTrashButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
            label: "",
            size: "small",
            primaryColor: (0, $33N5G.DEFAULT_COLOR)
        })))))));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onTrashButtonClick = (e)=>{
            e.preventDefault();
            const { groupId: groupId, onDelete: onDelete } = this.props;
            onDelete(groupId);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChevronDownClick = (e)=>{
            e.preventDefault();
            const { groupId: groupId, onToggleExpanded: onToggleExpanded } = this.props;
            onToggleExpanded(groupId, false);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChevronRightClick = (e)=>{
            e.preventDefault();
            const { groupId: groupId, onToggleExpanded: onToggleExpanded } = this.props;
            onToggleExpanded(groupId, true);
        };
        this.isAllOtherIssuesGroup = (groupId)=>groupId === (0, $bb09f71c7817719d$export$526fec6b76d5bc5);
        this.validateGroupTitle = (title)=>{
            if (title.length < 256) return;
            return this.props.intl.formatMessage((0, $7zyYg.default).tooLongInputErrorMessage);
        };
    }
}
var $4ffb9ca9839070ac$export$2e2bcd8739ae039 = (0, $fnOfj.injectIntlWithDefaultProps)($4ffb9ca9839070ac$var$Group);

});
parcelRegister("7zyYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb6338791984b1c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cfb6338791984b1c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.group-placeholder",
        "defaultMessage": "Untitled group"
    },
    tooLongInputErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.common.group.too-long-input-error-message",
        "defaultMessage": "Group title cannot be longer than 255 characters"
    }
});

});

parcelRegister("3WQ2C", function(module, exports) {

$parcel$export(module.exports, "expandCollapseChevron", () => $2dff282b407a6070$export$a39acbc38d158393, (v) => $2dff282b407a6070$export$a39acbc38d158393 = v);
$parcel$export(module.exports, "group", () => $2dff282b407a6070$export$e5e25fbcc1f7affe, (v) => $2dff282b407a6070$export$e5e25fbcc1f7affe = v);
$parcel$export(module.exports, "groupTitle", () => $2dff282b407a6070$export$91bc5dc3bf221ff4, (v) => $2dff282b407a6070$export$91bc5dc3bf221ff4 = v);
$parcel$export(module.exports, "groupTitleReadViewContainer", () => $2dff282b407a6070$export$a74a63e6c2387008, (v) => $2dff282b407a6070$export$a74a63e6c2387008 = v);
$parcel$export(module.exports, "groupTitleSection", () => $2dff282b407a6070$export$ef200e02c037d06, (v) => $2dff282b407a6070$export$ef200e02c037d06 = v);
$parcel$export(module.exports, "icon", () => $2dff282b407a6070$export$1ca1ec8b29a4ce27, (v) => $2dff282b407a6070$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "trashButton", () => $2dff282b407a6070$export$bdb39bfcac72c125, (v) => $2dff282b407a6070$export$bdb39bfcac72c125 = v);
var $2dff282b407a6070$export$a39acbc38d158393;
var $2dff282b407a6070$export$e5e25fbcc1f7affe;
var $2dff282b407a6070$export$91bc5dc3bf221ff4;
var $2dff282b407a6070$export$a74a63e6c2387008;
var $2dff282b407a6070$export$ef200e02c037d06;
var $2dff282b407a6070$export$1ca1ec8b29a4ce27;
var $2dff282b407a6070$export$bdb39bfcac72c125;
$2dff282b407a6070$export$a39acbc38d158393 = `taeYma_expandCollapseChevron`;
$2dff282b407a6070$export$e5e25fbcc1f7affe = `taeYma_group`;
$2dff282b407a6070$export$91bc5dc3bf221ff4 = `taeYma_groupTitle`;
$2dff282b407a6070$export$a74a63e6c2387008 = `taeYma_groupTitleReadViewContainer`;
$2dff282b407a6070$export$ef200e02c037d06 = `taeYma_groupTitleSection`;
$2dff282b407a6070$export$1ca1ec8b29a4ce27 = `taeYma_icon`;
$2dff282b407a6070$export$bdb39bfcac72c125 = `taeYma_trashButton`;

});


parcelRegister("esjUr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea5a3ec4823e858$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fea5a3ec4823e858$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createGroup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.create-group",
        "defaultMessage": "Create group"
    },
    componentPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.components.component-placeholder",
        "defaultMessage": "Choose a component"
    }
});

});

parcelRegister("6byWG", function(module, exports) {

$parcel$export(module.exports, "blue", () => $480ee09f5e93e7d9$export$2aa0182783e7e9de, (v) => $480ee09f5e93e7d9$export$2aa0182783e7e9de = v);
$parcel$export(module.exports, "componentGroup", () => $480ee09f5e93e7d9$export$26fe3bb68f295d9, (v) => $480ee09f5e93e7d9$export$26fe3bb68f295d9 = v);
$parcel$export(module.exports, "componentSelect", () => $480ee09f5e93e7d9$export$30ae6ac4023c3a21, (v) => $480ee09f5e93e7d9$export$30ae6ac4023c3a21 = v);
$parcel$export(module.exports, "icon", () => $480ee09f5e93e7d9$export$1ca1ec8b29a4ce27, (v) => $480ee09f5e93e7d9$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "row", () => $480ee09f5e93e7d9$export$120ff0929b202a6d, (v) => $480ee09f5e93e7d9$export$120ff0929b202a6d = v);
var $480ee09f5e93e7d9$export$2aa0182783e7e9de;
var $480ee09f5e93e7d9$export$26fe3bb68f295d9;
var $480ee09f5e93e7d9$export$30ae6ac4023c3a21;
var $480ee09f5e93e7d9$export$a39acbc38d158393;
var $480ee09f5e93e7d9$export$91bc5dc3bf221ff4;
var $480ee09f5e93e7d9$export$ef200e02c037d06;
var $480ee09f5e93e7d9$export$1ca1ec8b29a4ce27;
var $480ee09f5e93e7d9$export$120ff0929b202a6d;
var $480ee09f5e93e7d9$export$bdb39bfcac72c125;
$480ee09f5e93e7d9$export$2aa0182783e7e9de = `epJkjG_blue`;
$480ee09f5e93e7d9$export$26fe3bb68f295d9 = `epJkjG_componentGroup`;
$480ee09f5e93e7d9$export$30ae6ac4023c3a21 = `epJkjG_componentSelect`;
$480ee09f5e93e7d9$export$a39acbc38d158393 = `epJkjG_expandCollapseChevron`;
$480ee09f5e93e7d9$export$91bc5dc3bf221ff4 = `epJkjG_groupTitle`;
$480ee09f5e93e7d9$export$ef200e02c037d06 = `epJkjG_groupTitleSection`;
$480ee09f5e93e7d9$export$1ca1ec8b29a4ce27 = `epJkjG_icon`;
$480ee09f5e93e7d9$export$120ff0929b202a6d = `epJkjG_row`;
$480ee09f5e93e7d9$export$bdb39bfcac72c125 = `epJkjG_trashButton`;

});



parcelRegister("lDofH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3685edca58404e67$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1XlKJ = parcelRequire("1XlKJ");

var $k48O6 = parcelRequire("k48O6");

var $2RQd6 = parcelRequire("2RQd6");
var $3685edca58404e67$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $k48O6.default), (0, $1XlKJ.default))((0, $2RQd6.default));

});
parcelRegister("1XlKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f751889bad189c95$export$2e2bcd8739ae039);
parcelRequire("khGZ4");
var $1MbUl = parcelRequire("1MbUl");
const $f751889bad189c95$var$mapDispatchToProps = (dispatch)=>({
        addGroup: (grouping, group)=>{
            dispatch((0, $1MbUl.add)({
                grouping: grouping,
                group: group
            }));
        },
        updateGroup: (grouping, groupId, patch)=>{
            dispatch((0, $1MbUl.update)({
                grouping: grouping,
                id: groupId,
                patch: // @ts-expect-error-Type-2322 'undefined' is not assignable to type 'string'.
                patch
            }));
        },
        removeGroup: (grouping, groupId)=>{
            dispatch((0, $1MbUl.remove)({
                grouping: grouping,
                id: groupId
            }));
        }
    });
var $f751889bad189c95$export$2e2bcd8739ae039 = $f751889bad189c95$var$mapDispatchToProps;

});

parcelRegister("k48O6", function(module, exports) {

$parcel$export(module.exports, "default", () => $81cd8ff246404a1b$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $6kzO6 = parcelRequire("6kzO6");

var $kyGCj = parcelRequire("kyGCj");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");
const $81cd8ff246404a1b$var$getGroupingCustomFieldType = (0, $iK4oF.createSelector)([
    (0, $kKj1m.getCustomFieldsById),
    (0, $kyGCj.getVisualisationGrouping)
], (customFieldsById, grouping)=>{
    if (!(0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) return '';
    const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
    if ((0, $7CnHa.isDefined)(customFieldsById)) return customFieldsById[fieldId]?.type.key;
    return '';
});
const $81cd8ff246404a1b$var$getCustomFieldOptions = (0, $iK4oF.createSelector)([
    (0, $kyGCj.getVisualisationGrouping),
    (0, $kKj1m.getSelectOptions)
], (grouping, selectOptions)=>{
    if (!(0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) return [];
    const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
    return selectOptions.filter((option)=>option.fieldId === fieldId);
});
const $81cd8ff246404a1b$var$getCustomLabelFieldOptions = (0, $iK4oF.createSelector)([
    $81cd8ff246404a1b$var$getGroupingCustomFieldType,
    (0, $6kzO6.getCustomLabelsByField),
    (0, $kyGCj.getVisualisationGrouping)
], (groupingCustomFieldType, customLabelsByField, grouping)=>{
    if (!(0, $ayXoc.isRoadmapGroupedByCustomField)(grouping)) return [];
    if (groupingCustomFieldType === (0, $5rYNM.CustomFieldTypes).Labels) {
        const fieldId = parseInt((0, $ayXoc.getCustomFieldIdFromCustomFieldGrouping)(grouping), 10);
        return customLabelsByField[fieldId] || [];
    }
    return [];
});
var $81cd8ff246404a1b$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    customFieldValuesGroups: (0, $kyGCj.getCustomFieldValuesGroups),
    customLabelFieldOptions: $81cd8ff246404a1b$var$getCustomLabelFieldOptions,
    grouping: (0, $kyGCj.getVisualisationGrouping),
    groupingCustomFieldType: $81cd8ff246404a1b$var$getGroupingCustomFieldType,
    selectOptions: $81cd8ff246404a1b$var$getCustomFieldOptions
});

});
parcelRegister("6kzO6", function(module, exports) {

$parcel$export(module.exports, "getCustomLabelsByField", () => $cca203fe0221ca18$export$cd4f35dafaa09986);
const $cca203fe0221ca18$export$cd4f35dafaa09986 = (state)=>state.domain.customLabelsByField;

});


parcelRegister("2RQd6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef02fe905338e42$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hkOxK = parcelRequire("hkOxK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $bkIGg = parcelRequire("bkIGg");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
parcelRequire("9H2AP");

var $it3if = parcelRequire("it3if");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $UGMVO = parcelRequire("UGMVO");

var $3gaNY = parcelRequire("3gaNY");
function $9ef02fe905338e42$export$2e2bcd8739ae039({ addGroup: addGroup, customFieldValuesGroups: customFieldValuesGroups, customLabelFieldOptions: customLabelFieldOptions, grouping: grouping, groupingCustomFieldType: groupingCustomFieldType, onMenuToggle: onMenuToggle, selectOptions: selectOptions, removeGroup: removeGroup, updateGroup: updateGroup }) {
    const [isCreating, setIsCreating] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const trimName = (name)=>{
        const maxLength = 254;
        return name.length > maxLength ? name.substring(0, maxLength) : name;
    };
    const isNewGroupNameValid = (newName)=>{
        const allGroupNames = new Set(customFieldValuesGroups.map(({ name: name })=>name));
        return !allGroupNames.has(newName);
    };
    const onCreateGroup = ()=>{
        setIsCreating(true);
    };
    const onCancelCreateGroup = ()=>{
        setIsCreating(false);
    };
    const onConfirmingCreateGroup = (newName)=>{
        onCancelCreateGroup();
        if (newName.length === 0 || !isNewGroupNameValid(newName)) return;
        addGroup(grouping, {
            id: trimName(newName).toLowerCase(),
            name: trimName(newName),
            isExpanded: true,
            [grouping]: []
        });
    };
    const onConfirmingUpdateGroup = (id, newName)=>{
        if (newName.length === 0 || !isNewGroupNameValid(newName)) return;
        updateGroup(grouping, id, {
            id: trimName(newName).toLowerCase(),
            name: trimName(newName)
        });
    };
    const onUpdatingValuesInGroup = (id, selectValue)=>{
        if ((0, $7CnHa.isDefined)(selectValue)) updateGroup(grouping, id, {
            [grouping]: selectValue.map(({ value: value })=>value)
        });
    };
    const toggleExpanded = (id, isExpanded)=>{
        updateGroup(grouping, id, {
            isExpanded: isExpanded
        });
    };
    const renderComponentSelect = (groupId, values)=>{
        let options = [];
        let valueOptions = [];
        if (groupingCustomFieldType === (0, $5rYNM.CustomFieldTypes).Labels) {
            options = customLabelFieldOptions.map((label)=>({
                    value: label,
                    label: label
                }));
            valueOptions = options.filter(({ value: value })=>values.includes(value));
        } else {
            options = $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('value')))(selectOptions).map(({ id: id, value: value })=>({
                    value: id,
                    label: value
                }));
            valueOptions = options.filter(({ value: value })=>values.includes(value));
        }
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            className: $3gaNY.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3gaNY.customFieldValueSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            autoFocus: true,
            classNamePrefix: "group-by-custom-options-select",
            defaultValue: valueOptions,
            isMulti: true,
            menuPortalTarget: (0, $1ni3W.getBody)(),
            onChange: (value)=>onUpdatingValuesInGroup(groupId, value),
            onMenuClose: ()=>{
                onMenuToggle(false);
            },
            onMenuOpen: ()=>{
                onMenuToggle(true);
            },
            options: options,
            placeholder: formatMessage((0, $UGMVO.default).componentPlaceholder),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            styles: {
                menuPortal: (styles)=>({
                        ...styles,
                        zIndex: 1000
                    })
            }
        })))));
    };
    const renderGroup = (group)=>{
        const { id: id, isExpanded: isExpanded, [grouping]: values } = group;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $3gaNY.row,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
            groupId: id,
            groupName: group.name,
            isExpanded: isExpanded,
            onCancel: onCancelCreateGroup,
            onConfirm: (newName)=>{
                onConfirmingUpdateGroup(id, newName);
            },
            onDelete: (groupId)=>removeGroup(grouping, groupId),
            onToggleExpanded: toggleExpanded
        }))), id !== (0, $bb09f71c7817719d$export$526fec6b76d5bc5) && isExpanded && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderComponentSelect(id, values));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, customFieldValuesGroups.map(renderGroup), isCreating && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
        className: $3gaNY.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
        onCancel: onCancelCreateGroup,
        onConfirm: onConfirmingCreateGroup,
        shouldCreateGroup: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $3gaNY.customFieldValuesGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $3gaNY.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
        label: "",
        primaryColor: `var(--ds-text-brand, ${(0, $g4Vkx.default).B400})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        onClick: onCreateGroup,
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.create-custom-field-values-group"
    }, formatMessage((0, $UGMVO.default).createGroup))))));
}

});
parcelRegister("UGMVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0267741904848dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0267741904848dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createGroup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.create-group",
        "defaultMessage": "Create group"
    },
    componentPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.custom-fields.component-placeholder",
        "defaultMessage": "Choose a value"
    }
});

});

parcelRegister("3gaNY", function(module, exports) {

$parcel$export(module.exports, "customFieldValueSelect", () => $25fb3f609e978fe1$export$ce6e55e8280c094f, (v) => $25fb3f609e978fe1$export$ce6e55e8280c094f = v);
$parcel$export(module.exports, "customFieldValuesGroup", () => $25fb3f609e978fe1$export$492b91577b69d574, (v) => $25fb3f609e978fe1$export$492b91577b69d574 = v);
$parcel$export(module.exports, "icon", () => $25fb3f609e978fe1$export$1ca1ec8b29a4ce27, (v) => $25fb3f609e978fe1$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "row", () => $25fb3f609e978fe1$export$120ff0929b202a6d, (v) => $25fb3f609e978fe1$export$120ff0929b202a6d = v);
var $25fb3f609e978fe1$export$ce6e55e8280c094f;
var $25fb3f609e978fe1$export$492b91577b69d574;
var $25fb3f609e978fe1$export$91bc5dc3bf221ff4;
var $25fb3f609e978fe1$export$1ca1ec8b29a4ce27;
var $25fb3f609e978fe1$export$120ff0929b202a6d;
$25fb3f609e978fe1$export$ce6e55e8280c094f = `_6yml3W_customFieldValueSelect`;
$25fb3f609e978fe1$export$492b91577b69d574 = `_6yml3W_customFieldValuesGroup`;
$25fb3f609e978fe1$export$91bc5dc3bf221ff4 = `_6yml3W_groupTitle`;
$25fb3f609e978fe1$export$1ca1ec8b29a4ce27 = `_6yml3W_icon`;
$25fb3f609e978fe1$export$120ff0929b202a6d = `_6yml3W_row`;

});



parcelRegister("69mNn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed94801346b96f9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $h4h4j = parcelRequire("h4h4j");

var $aTJ9Q = parcelRequire("aTJ9Q");

var $gjguD = parcelRequire("gjguD");
var $aed94801346b96f9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $aTJ9Q.default), (0, $h4h4j.default))((0, $gjguD.default));

});
parcelRegister("h4h4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $76747b7ef6d8a13e$export$2e2bcd8739ae039);
parcelRequire("khGZ4");
var $etElm = parcelRequire("etElm");
const $76747b7ef6d8a13e$var$mapDispatchToProps = (dispatch)=>({
        addGroup: (name)=>{
            dispatch((0, $etElm.add)({
                id: name.toLowerCase(),
                name: name,
                isExpanded: true,
                labels: []
            }));
        },
        updateGroup: (groupId, patch)=>{
            dispatch((0, $etElm.update)({
                id: groupId,
                patch: patch
            }));
        },
        removeGroup: (groupId)=>{
            dispatch((0, $etElm.remove)(groupId));
        }
    });
var $76747b7ef6d8a13e$export$2e2bcd8739ae039 = $76747b7ef6d8a13e$var$mapDispatchToProps;

});

parcelRegister("aTJ9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e4296a25bfacdd1$export$2e2bcd8739ae039);

var $94enn = parcelRequire("94enn");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
const $7e4296a25bfacdd1$export$a9e58a8ee6cd2485 = (issueLabels)=>issueLabels.map((label)=>({
            value: label,
            label: label
        }));
const $7e4296a25bfacdd1$var$getSelectOptions = (0, $iK4oF.createSelector)([
    (0, $94enn.getIssueLabels)
], $7e4296a25bfacdd1$export$a9e58a8ee6cd2485);
var $7e4296a25bfacdd1$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    labelGroups: (0, $9H2AP.getLabelsGroupViewSettings),
    selectOptions: $7e4296a25bfacdd1$var$getSelectOptions,
    groupAttribute: ()=>'labels'
});

});

parcelRegister("gjguD", function(module, exports) {

$parcel$export(module.exports, "default", () => $faaea51db5468983$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bkIGg = parcelRequire("bkIGg");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");
var $aAyrO = parcelRequire("aAyrO");
parcelRequire("9H2AP");

var $it3if = parcelRequire("it3if");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $caPOr = parcelRequire("caPOr");

var $jMOYe = parcelRequire("jMOYe");
const $faaea51db5468983$var$trimName = (name)=>{
    const maxLength = 254;
    return name.length > maxLength ? name.substring(0, maxLength) : name;
};
// eslint-disable-next-line jira/react/no-class-components
class $faaea51db5468983$var$GroupByLabels extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.isNewGroupNameValid = (newName)=>{
            const allGroupNames = new Set(this.props.labelGroups.map(({ name: name })=>name));
            return !allGroupNames.has(newName);
        };
        this.isAllOtherIssuesGroup = (id)=>id === (0, $bb09f71c7817719d$export$526fec6b76d5bc5);
        this.onCreateGroup = ()=>this.setState({
                isCreating: true
            });
        this.onCancelCreateGroup = ()=>this.setState({
                isCreating: false
            });
        this.onConfirmingCreateGroup = (newName)=>{
            this.onCancelCreateGroup();
            if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
            this.props.addGroup($faaea51db5468983$var$trimName(newName));
        };
        this.onConfirmingUpdateGroup = (id, newName)=>{
            if (newName.length === 0 || !this.isNewGroupNameValid(newName)) return;
            this.props.updateGroup(id, {
                id: $faaea51db5468983$var$trimName(newName).toLowerCase(),
                name: $faaea51db5468983$var$trimName(newName)
            });
        };
        this.onUpdatingValuesInGroup = (id, selectValue)=>{
            if ((0, $7CnHa.isDefined)(selectValue)) this.props.updateGroup(id, {
                [this.props.groupAttribute]: selectValue.map(({ value: value })=>value)
            });
        };
        this.toggleExpanded = (id, isExpanded)=>this.props.updateGroup(id, {
                isExpanded: isExpanded
            });
        this.renderSelect = (groupId, groupValues)=>{
            const { intl: { formatMessage: formatMessage }, onMenuToggle: onMenuToggle, selectOptions: selectOptions } = this.props;
            const valueOptions = selectOptions.filter(({ value: value })=>groupValues.includes(value));
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                className: $jMOYe.row
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $jMOYe.labelSelect
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                autoFocus: true,
                classNamePrefix: "group-by-custom-options-select",
                defaultValue: valueOptions,
                isMulti: true,
                menuPlacement: "auto",
                menuPortalTarget: (0, $1ni3W.getBody)(),
                onChange: (value)=>this.onUpdatingValuesInGroup(groupId, value),
                onMenuClose: ()=>{
                    onMenuToggle(false);
                },
                onMenuOpen: ()=>{
                    onMenuToggle(true);
                },
                options: selectOptions,
                placeholder: formatMessage((0, $caPOr.default).labelPlaceholder),
                // eslint-disable-next-line @typescript-eslint/no-shadow
                styles: {
                    menuPortal: (styles)=>({
                            ...styles,
                            zIndex: 1000
                        })
                }
            })))));
        };
        this.renderGroup = (group)=>{
            const { groupAttribute: groupAttribute, removeGroup: removeGroup } = this.props;
            const { id: id, isExpanded: isExpanded, [groupAttribute]: groupValues } = group;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $jMOYe.row,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
                colSpan: 2
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
                groupName: group.name,
                groupId: id,
                isExpanded: isExpanded,
                onConfirm: (newName)=>{
                    this.onConfirmingUpdateGroup(id, newName);
                },
                onCancel: this.onCancelCreateGroup,
                onDelete: removeGroup,
                onToggleExpanded: this.toggleExpanded
            }))), !this.isAllOtherIssuesGroup(id) && isExpanded && this.renderSelect(id, groupValues));
        };
        this.state = {
            isCreating: false
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, labelGroups: labelGroups } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, labelGroups.map(this.renderGroup), this.state.isCreating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $jMOYe.row,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.label-group-creating"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $it3if.default), {
            shouldCreateGroup: true,
            onConfirm: this.onConfirmingCreateGroup,
            onCancel: this.onCancelCreateGroup
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $jMOYe.labelGroup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: `${$jMOYe.icon} ${$jMOYe.blue}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
            label: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "link",
            onClick: this.onCreateGroup,
            testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.create-labels-group"
        }, formatMessage((0, $caPOr.default).createGroup))))));
    }
}
var $faaea51db5468983$export$2e2bcd8739ae039 = (0, $2qhQi.default)($faaea51db5468983$var$GroupByLabels);

});
parcelRegister("caPOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac1b53f5873584f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cac1b53f5873584f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createGroup: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.create-group",
        "defaultMessage": "Create group"
    },
    labelPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.group-by.labels.label-placeholder",
        "defaultMessage": "Choose a label"
    }
});

});

parcelRegister("jMOYe", function(module, exports) {

$parcel$export(module.exports, "blue", () => $e67a09ad930c9657$export$2aa0182783e7e9de, (v) => $e67a09ad930c9657$export$2aa0182783e7e9de = v);
$parcel$export(module.exports, "icon", () => $e67a09ad930c9657$export$1ca1ec8b29a4ce27, (v) => $e67a09ad930c9657$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "labelGroup", () => $e67a09ad930c9657$export$cd3543f471a6c0aa, (v) => $e67a09ad930c9657$export$cd3543f471a6c0aa = v);
$parcel$export(module.exports, "labelSelect", () => $e67a09ad930c9657$export$519b192a392926cb, (v) => $e67a09ad930c9657$export$519b192a392926cb = v);
$parcel$export(module.exports, "row", () => $e67a09ad930c9657$export$120ff0929b202a6d, (v) => $e67a09ad930c9657$export$120ff0929b202a6d = v);
var $e67a09ad930c9657$export$2aa0182783e7e9de;
var $e67a09ad930c9657$export$a39acbc38d158393;
var $e67a09ad930c9657$export$91bc5dc3bf221ff4;
var $e67a09ad930c9657$export$ef200e02c037d06;
var $e67a09ad930c9657$export$1ca1ec8b29a4ce27;
var $e67a09ad930c9657$export$cd3543f471a6c0aa;
var $e67a09ad930c9657$export$519b192a392926cb;
var $e67a09ad930c9657$export$120ff0929b202a6d;
var $e67a09ad930c9657$export$bdb39bfcac72c125;
$e67a09ad930c9657$export$2aa0182783e7e9de = `x5vVhW_blue`;
$e67a09ad930c9657$export$a39acbc38d158393 = `x5vVhW_expandCollapseChevron`;
$e67a09ad930c9657$export$91bc5dc3bf221ff4 = `x5vVhW_groupTitle`;
$e67a09ad930c9657$export$ef200e02c037d06 = `x5vVhW_groupTitleSection`;
$e67a09ad930c9657$export$1ca1ec8b29a4ce27 = `x5vVhW_icon`;
$e67a09ad930c9657$export$cd3543f471a6c0aa = `x5vVhW_labelGroup`;
$e67a09ad930c9657$export$519b192a392926cb = `x5vVhW_labelSelect`;
$e67a09ad930c9657$export$120ff0929b202a6d = `x5vVhW_row`;
$e67a09ad930c9657$export$bdb39bfcac72c125 = `x5vVhW_trashButton`;

});



parcelRegister("bRrol", function(module, exports) {

$parcel$export(module.exports, "default", () => $2daa295263382175$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2daa295263382175$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    triggerButtonLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.trigger-button-label",
        "defaultMessage": "View settings"
    },
    clearAllColours: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-colours",
        "defaultMessage": "Clear all colors"
    },
    clearAllGroups: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.clear-all-groups",
        "defaultMessage": "Clear all groups"
    },
    showSprintsOnTimeline: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.show-sprints-on-timeline",
        "defaultMessage": "Show capacity on timeline"
    },
    onlyAvailableForTeamOrSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.only-available-for-team-or-sprint",
        "defaultMessage": "Only available when grouping by team or sprint"
    },
    rollupLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-label",
        "defaultMessage": "Roll-up"
    },
    dependencySettingsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.dependency-settings-label",
        "defaultMessage": "Dependency style"
    }
});

});

parcelRegister("6YgBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3aa4684ad42af6$export$2e2bcd8739ae039);

var $051m9 = parcelRequire("051m9");

var $9H2AP = parcelRequire("9H2AP");

var $e0l3L = parcelRequire("e0l3L");

var $lNNXV = parcelRequire("lNNXV");

var $f3mWh = parcelRequire("f3mWh");
const $3a3aa4684ad42af6$var$mapStateToProps = (state)=>({
        rollupSettings: (0, $9H2AP.getRollupViewSettings)(state)
    });
const $3a3aa4684ad42af6$var$mapDispatchToProps = (dispatch)=>({
        setShowingRolledUpDates: (shouldShow)=>{
            dispatch((0, $e0l3L.setShowRolledUpDates)({
                shouldShow: shouldShow
            }));
            dispatch((0, $051m9.calculateStatusOfAllReleases)());
        },
        setShowRolledUpOthers: (shouldShow)=>{
            dispatch((0, $e0l3L.setShowRolledUpOthers)({
                shouldShow: shouldShow
            }));
        }
    });
var $3a3aa4684ad42af6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($3a3aa4684ad42af6$var$mapStateToProps, $3a3aa4684ad42af6$var$mapDispatchToProps)((0, $f3mWh.default));

});
parcelRegister("f3mWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d4933b21e042c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cPAcJ = parcelRequire("cPAcJ");

var $cnPHV = parcelRequire("cnPHV");

var $lkPEe = parcelRequire("lkPEe");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6ETZE = parcelRequire("6ETZE");

var $cuuJa = parcelRequire("cuuJa");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");

var $hfMzg = parcelRequire("hfMzg");

var $1gCED = parcelRequire("1gCED");
const $43d4933b21e042c2$var$EstimateRollupOld = ({ rollupSettings: { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers }, setShowingRolledUpDates: setShowingRolledUpDates, setShowRolledUpOthers: setShowRolledUpOthers })=>{
    const intl = (0, $5JgJ2.default)();
    const othersMessage = (0, $hfMzg.default).showRolledUpOthers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.checkboxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        isChecked: showingRolledUpDate,
        label: intl.formatMessage((0, $ib5d3.default).dates),
        onChange: (_, analyticsEvent)=>{
            const nextValue = !showingRolledUpDate;
            const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_DATES_CHANGED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: nextValue
            });
            setShowingRolledUpDates(nextValue);
        },
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.description
    }, intl.formatMessage({
        ...(0, $hfMzg.default).showingRolledUpDatesDescription
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.checkboxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        isChecked: showRolledUpOthers,
        label: intl.formatMessage({
            ...othersMessage
        }),
        onChange: (_, analyticsEvent)=>{
            const nextValue = !showRolledUpOthers;
            const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_OTHERS_CHANGED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: nextValue
            });
            setShowRolledUpOthers(nextValue);
        },
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.description
    }, intl.formatMessage({
        ...(0, $hfMzg.default).showRolledUpOthersDescription
    }))));
};
const $43d4933b21e042c2$var$EstimateRollup = ({ rollupSettings: { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers }, setShowingRolledUpDates: setShowingRolledUpDates, setShowRolledUpOthers: setShowRolledUpOthers })=>{
    const intl = (0, $5JgJ2.default)();
    const othersMessage = (0, $hfMzg.default).showRolledUpOthers;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        block: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPAcJ.default), {
        legend: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, intl.formatMessage((0, $hfMzg.default).rollupGroupLabel))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.checkboxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        name: "roll-up",
        "aria-describedby": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates",
        isChecked: showingRolledUpDate,
        label: intl.formatMessage((0, $ib5d3.default).dates),
        onChange: (_, analyticsEvent)=>{
            const nextValue = !showingRolledUpDate;
            const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_DATES_CHANGED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: nextValue
            });
            setShowingRolledUpDates(nextValue);
        },
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-dates",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $1gCED.description
    }, intl.formatMessage({
        ...(0, $hfMzg.default).showingRolledUpDatesDescription
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.option
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1gCED.checkboxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        name: "roll-up",
        "aria-describedby": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others",
        isChecked: showRolledUpOthers,
        label: intl.formatMessage({
            ...othersMessage
        }),
        onChange: (_, analyticsEvent)=>{
            const nextValue = !showRolledUpOthers;
            const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ROLL_UP_OTHERS_CHANGED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                actionSubject: actionSubject,
                action: action
            }), actionSubjectId, {
                newPlanSettingValue: nextValue
            });
            setShowRolledUpOthers(nextValue);
        },
        testId: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-others",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $1gCED.description
    }, intl.formatMessage({
        ...(0, $hfMzg.default).showRolledUpOthersDescription
    })))));
};
var $43d4933b21e042c2$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('jsw.roadmaps.missing-grouping-for-checkboxes_y', $43d4933b21e042c2$var$EstimateRollup, $43d4933b21e042c2$var$EstimateRollupOld);

});
parcelRegister("cPAcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc8c9e6420cb9ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $6ROLN = parcelRequire("6ROLN");
function $bdc8c9e6420cb9ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bdc8c9e6420cb9ce$var$fieldSetStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ const $bdc8c9e6420cb9ce$var$Fieldset = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("fieldset", {
        css: $bdc8c9e6420cb9ce$var$fieldSetStyles
    }, legend && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Legend), null, legend), children);
};
var $bdc8c9e6420cb9ce$export$2e2bcd8739ae039 = $bdc8c9e6420cb9ce$var$Fieldset;

});

parcelRegister("hfMzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $967fb501d846d2c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $967fb501d846d2c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showingRolledUpDatesDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.showing-rolled-up-dates-description",
        "defaultMessage": "Show a roll-up of dates in the fields and timeline sections."
    },
    showRolledUpOthers: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-others",
        "defaultMessage": "Others"
    },
    showRolledUpOthersDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-others-description",
        "defaultMessage": "Show a roll-up of sprints, releases, teams, and estimates in the fields section."
    },
    rollupGroupLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.rollup-group-label",
        "defaultMessage": "roll-up"
    },
    // Old labels. Remove once rollup dates is launched and feature toggle is removed:
    showRolledUpLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-label",
        "defaultMessage": "Show rolled-up values in fields"
    },
    showRolledUpLabelDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.rollup-settings.show-rolled-up-label-description",
        "defaultMessage": "For parent issues, show a preview of the rolled-up values of the child issues in the corresponding fields."
    }
});

});

parcelRegister("1gCED", function(module, exports) {

$parcel$export(module.exports, "checkboxWrapper", () => $0ec545030c313f0b$export$8b18e1c47ccc2c63, (v) => $0ec545030c313f0b$export$8b18e1c47ccc2c63 = v);
$parcel$export(module.exports, "description", () => $0ec545030c313f0b$export$6d59db4903f20f7d, (v) => $0ec545030c313f0b$export$6d59db4903f20f7d = v);
$parcel$export(module.exports, "option", () => $0ec545030c313f0b$export$a75d1723e6bda2ec, (v) => $0ec545030c313f0b$export$a75d1723e6bda2ec = v);
var $0ec545030c313f0b$export$8b18e1c47ccc2c63;
var $0ec545030c313f0b$export$6d59db4903f20f7d;
var $0ec545030c313f0b$export$a75d1723e6bda2ec;
$0ec545030c313f0b$export$8b18e1c47ccc2c63 = `xVA1UG_checkboxWrapper`;
$0ec545030c313f0b$export$6d59db4903f20f7d = `xVA1UG_description`;
$0ec545030c313f0b$export$a75d1723e6bda2ec = `xVA1UG_option`;

});



parcelRegister("2SySz", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e12efd3ff8a80b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2xOcb = parcelRequire("2xOcb");

var $idxxx = parcelRequire("idxxx");

var $tswv1 = parcelRequire("tswv1");
var $44e12efd3ff8a80b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $idxxx.default), (0, $2xOcb.default))((0, $tswv1.default));

});
parcelRegister("2xOcb", function(module, exports) {

$parcel$export(module.exports, "default", () => $05286ab9bb1ed45d$export$2e2bcd8739ae039);
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");
const $05286ab9bb1ed45d$var$mapDispatchToProps = (dispatch)=>({
        changeSort: (sortBy)=>{
            dispatch((0, $l1dWb.changeSort)({
                sorting: sortBy
            }));
        }
    });
var $05286ab9bb1ed45d$export$2e2bcd8739ae039 = $05286ab9bb1ed45d$var$mapDispatchToProps;

});

parcelRegister("idxxx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfc484fcdaea871$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $jp3RH = parcelRequire("jp3RH");

var $75KhQ = parcelRequire("75KhQ");

var $kyGCj = parcelRequire("kyGCj");

var $iK4oF = parcelRequire("iK4oF");
var $7bfc484fcdaea871$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    customFields: (0, $kKj1m.getCustomFields),
    sorting: (0, $kyGCj.getVisualisationSorting),
    dateConfiguration: (0, $75KhQ.getDateConfiguration),
    planningUnit: (0, $75KhQ.getPlanningUnit),
    issuePrioritiesIdList: (0, $jp3RH.getIssuePrioritiesIdList)
});

});

parcelRegister("tswv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6612eae477dfa4f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hiIej = parcelRequire("hiIej");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");

var $7s3LJ = parcelRequire("7s3LJ");

var $5rYNM = parcelRequire("5rYNM");

var $2BQwE = parcelRequire("2BQwE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $31WUh = parcelRequire("31WUh");

var $bWzWB = parcelRequire("bWzWB");

var $joFQ2 = parcelRequire("joFQ2");

var $62d8R = parcelRequire("62d8R");
function $6612eae477dfa4f3$var$SortBy({ changeSort: changeSort, customFields: customFields, dateConfiguration: dateConfiguration, issuePrioritiesIdList: issuePrioritiesIdList, isDefaultMenuOpen: isDefaultMenuOpen = false, onMenuToggle: onMenuToggle, planningUnit: planningUnit, sorting: sorting }) {
    const intl = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOnChange = ({ defaultDirection: defaultDirection, value: value })=>{
        (0, $duQ8C.default)((0, $2BQwE.KEYS).SORT_BY_FIELD);
        const sortConfiguration = (0, $62d8R.getSortConfiguration)(String(value), customFields, defaultDirection);
        changeSort(sortConfiguration);
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SORT_BY_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: actionSubject,
            action: action
        }), actionSubjectId, {
            newPlanSettingValue: sortConfiguration.isCustomField ? `customfield_${sortConfiguration.type}` : (0, $7s3LJ.getFieldKey)(sortConfiguration.field, planningUnit)
        });
    };
    const onDirectionSelect = (direction)=>{
        changeSort({
            ...sorting,
            direction: direction
        });
    };
    const optionLabels = (0, $62d8R.getOptionValueLabels)(intl, customFields, planningUnit);
    const standardFieldsOptions = (0, $62d8R.getStandardFieldsOptions)(dateConfiguration, optionLabels, issuePrioritiesIdList);
    const customFieldsOptions = (0, $62d8R.getCustomFieldsOptions)(customFields, dateConfiguration);
    const sortDirectionsOptions = [
        {
            name: 'sortDirection',
            value: (0, $5rYNM.SORT_DIRECTION).ASCENDING,
            label: intl.formatMessage((0, $bWzWB.default).ascending),
            testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.ascending'
        },
        {
            name: 'sortDirection',
            value: (0, $5rYNM.SORT_DIRECTION).DESCENDING,
            label: intl.formatMessage((0, $bWzWB.default).descending),
            testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.view-settings.sort-by.descending'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
        className: sorting.field !== (0, $chgK5.ISSUE_FIELDS).RANK ? '' : $joFQ2.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, intl.formatMessage((0, $bWzWB.default).sortByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31WUh.default), {
        classNamePrefix: "portfolio-3-portfolio_app-simple-plans_main_tabs_roadmap_view-settings_sort-by",
        customFieldsOptions: customFieldsOptions,
        handleOnChange: handleOnChange,
        isDefaultMenuOpen: isDefaultMenuOpen,
        onMenuToggle: onMenuToggle,
        standardFieldsOptions: standardFieldsOptions,
        selectedFieldId: sorting.field,
        ...(0, $1ybV0.ff)('jsw.roadmaps.timeline-viewsettings-dropdown-button-arialabel-1120_7ctf1') && {
            label: intl.formatMessage((0, $bWzWB.default).sortByLabel)
        }
    }))), sorting.field !== (0, $chgK5.ISSUE_FIELDS).RANK && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
        className: $joFQ2.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
        colSpan: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $joFQ2.radioOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange: (e)=>onDirectionSelect(e.target.value),
        options: sortDirectionsOptions,
        value: sorting.direction
    })))));
}
var $6612eae477dfa4f3$export$2e2bcd8739ae039 = $6612eae477dfa4f3$var$SortBy;

});


parcelRegister("03EuP", function(module, exports) {

$parcel$export(module.exports, "checkboxInfo", () => $00afb1a6167f80a3$export$403f69544f111ddc, (v) => $00afb1a6167f80a3$export$403f69544f111ddc = v);
$parcel$export(module.exports, "clearAllButton", () => $00afb1a6167f80a3$export$82c3bde2d8663425, (v) => $00afb1a6167f80a3$export$82c3bde2d8663425 = v);
$parcel$export(module.exports, "rollupSetting", () => $00afb1a6167f80a3$export$f1cbbb54ba02ac4f, (v) => $00afb1a6167f80a3$export$f1cbbb54ba02ac4f = v);
$parcel$export(module.exports, "row", () => $00afb1a6167f80a3$export$120ff0929b202a6d, (v) => $00afb1a6167f80a3$export$120ff0929b202a6d = v);
$parcel$export(module.exports, "settingsList", () => $00afb1a6167f80a3$export$e7df410635e138ff, (v) => $00afb1a6167f80a3$export$e7df410635e138ff = v);
$parcel$export(module.exports, "showCapacityCheckbox", () => $00afb1a6167f80a3$export$1ed190a3824c90ae, (v) => $00afb1a6167f80a3$export$1ed190a3824c90ae = v);
$parcel$export(module.exports, "topAlignedTd", () => $00afb1a6167f80a3$export$ff94d69d5395970d, (v) => $00afb1a6167f80a3$export$ff94d69d5395970d = v);
$parcel$export(module.exports, "viewSettingSelect", () => $00afb1a6167f80a3$export$24a4da606ee32d0c, (v) => $00afb1a6167f80a3$export$24a4da606ee32d0c = v);
var $00afb1a6167f80a3$export$403f69544f111ddc;
var $00afb1a6167f80a3$export$82c3bde2d8663425;
var $00afb1a6167f80a3$export$f1cbbb54ba02ac4f;
var $00afb1a6167f80a3$export$120ff0929b202a6d;
var $00afb1a6167f80a3$export$e7df410635e138ff;
var $00afb1a6167f80a3$export$1ed190a3824c90ae;
var $00afb1a6167f80a3$export$ff94d69d5395970d;
var $00afb1a6167f80a3$export$24a4da606ee32d0c;
$00afb1a6167f80a3$export$403f69544f111ddc = `hzFZ5q_checkboxInfo`;
$00afb1a6167f80a3$export$82c3bde2d8663425 = `hzFZ5q_clearAllButton`;
$00afb1a6167f80a3$export$f1cbbb54ba02ac4f = `hzFZ5q_rollupSetting`;
$00afb1a6167f80a3$export$120ff0929b202a6d = `hzFZ5q_row`;
$00afb1a6167f80a3$export$e7df410635e138ff = `hzFZ5q_settingsList`;
$00afb1a6167f80a3$export$1ed190a3824c90ae = `hzFZ5q_showCapacityCheckbox`;
$00afb1a6167f80a3$export$ff94d69d5395970d = `hzFZ5q_topAlignedTd`;
$00afb1a6167f80a3$export$24a4da606ee32d0c = `hzFZ5q_viewSettingSelect`;

});



parcelRegister("kbEgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb36a0479463d740$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ctR9z = parcelRequire("ctR9z");

var $lNNXV = parcelRequire("lNNXV");

var $gkTS0 = parcelRequire("gkTS0");

var $jncXd = parcelRequire("jncXd");

var $4t4jv = parcelRequire("4t4jv");

var $hTzNX = parcelRequire("hTzNX");
const $eb36a0479463d740$var$withGicModalOpen = (WrappedComponent)=>(props)=>{
        const [{ isModalOpen: isModalOpen }] = (0, $ctR9z.useTriggerIssueCreateModal)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            isGicModalOpen: isModalOpen
        });
    };
const $eb36a0479463d740$var$HooksInjector = (props)=>{
    const { clear: clear } = (0, $gkTS0.useAdvancedRoadmapsSummaryDataResource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTzNX.default), {
        ...props,
        clearSummaryPageCache: clear
    });
};
var $eb36a0479463d740$export$2e2bcd8739ae039 = $eb36a0479463d740$var$withGicModalOpen((0, $lNNXV.connect)((0, $4t4jv.default), (0, $jncXd.default))($eb36a0479463d740$var$HooksInjector));

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') && {
                    callbackPayload: undefined
                },
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lEpcX = parcelRequire("lEpcX");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});



parcelRegister("jncXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $541571e8ba72e5f3$export$2e2bcd8739ae039);

var $6fxQQ = parcelRequire("6fxQQ");
var $9LVH6 = parcelRequire("9LVH6");
var $cONEK = parcelRequire("cONEK");

var $7SlBO = parcelRequire("7SlBO");

var $2BQwE = parcelRequire("2BQwE");

var $duQ8C = parcelRequire("duQ8C");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$541571e8ba72e5f3$export$2e2bcd8739ae039 = (dispatch)=>({
        openDialog: (e)=>{
            (0, $duQ8C.default)((0, $2BQwE.KEYS).OPEN_REVIEW_CHANGES, e.timeStamp);
            dispatch((0, $6fxQQ.getChangesMetadata)());
            dispatch((0, $6fxQQ.getNotificationPreference)());
            dispatch((0, $7SlBO.openUpdateJiraDialog)());
        },
        closeDialog: ()=>{
            dispatch((0, $7SlBO.closeUpdateJiraDialog)());
        },
        updateJira: (analyticsEvent, notifyWatchers)=>{
            dispatch((0, $6fxQQ.commitChanges)({
                actions: {
                    success: [
                        (0, $6fxQQ.saveNotificationPreference)({
                            shouldNotifyWatchers: notifyWatchers
                        }),
                        (0, $7SlBO.deselectAllChanges)(),
                        (0, $6fxQQ.updateLastCommittedTimestamp)()
                    ]
                },
                notifyWatchers: notifyWatchers
            }, {
                analyticsEvent: analyticsEvent
            }));
        },
        revertChanges: ()=>{
            dispatch((0, $6fxQQ.revertChanges)({
                actions: {
                    success: [
                        (0, $7SlBO.deselectAllChanges)()
                    ]
                }
            }));
        },
        closeCommitWarningFlag: ()=>{
            dispatch((0, $7SlBO.closeCommitWarningFlag)());
        },
        interruptCommitting: ()=>{
            dispatch((0, $9LVH6.interrupt)());
        },
        interruptReverting: ()=>{
            dispatch((0, $cONEK.interrupt)());
        },
        updateNotificationPreference: (shouldNotifyWatchers)=>{
            dispatch((0, $7SlBO.updateNotificationPreference)({
                shouldNotifyWatchers: shouldNotifyWatchers
            }));
        }
    });

});
parcelRegister("6fxQQ", function(module, exports) {

$parcel$export(module.exports, "COMMIT_CHANGES", () => $0c702537d957a9a2$export$a031474266a52bb4);
$parcel$export(module.exports, "getChangesMetadata", () => $0c702537d957a9a2$export$35be11ad3df1110);
$parcel$export(module.exports, "commitChanges", () => $0c702537d957a9a2$export$53720dfce17bb85a);
$parcel$export(module.exports, "revertChanges", () => $0c702537d957a9a2$export$d269e5e1393c5f8a);
$parcel$export(module.exports, "getNotificationPreference", () => $0c702537d957a9a2$export$3c3771868e06ade1);
$parcel$export(module.exports, "saveNotificationPreference", () => $0c702537d957a9a2$export$7b2133f0c970c6e2);
$parcel$export(module.exports, "updateLastCommittedTimestamp", () => $0c702537d957a9a2$export$f734abf5c5cd3d95);
$parcel$export(module.exports, "default", () => $0c702537d957a9a2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "expandChange", () => (parcelRequire("7SlBO")).expandChange);
$parcel$export(module.exports, "collapseChange", () => (parcelRequire("7SlBO")).collapseChange);
$parcel$export(module.exports, "selectChange", () => (parcelRequire("7SlBO")).selectChange);
$parcel$export(module.exports, "deselectChange", () => (parcelRequire("7SlBO")).deselectChange);
$parcel$export(module.exports, "selectAllChanges", () => (parcelRequire("7SlBO")).selectAllChanges);
$parcel$export(module.exports, "deselectAllChanges", () => (parcelRequire("7SlBO")).deselectAllChanges);
$parcel$export(module.exports, "replaceSelectedChanges", () => (parcelRequire("7SlBO")).replaceSelectedChanges);
$parcel$export(module.exports, "sortChanges", () => (parcelRequire("7SlBO")).sortChanges);
$parcel$export(module.exports, "changeFilter", () => (parcelRequire("7SlBO")).changeFilter);
$parcel$export(module.exports, "clearFilter", () => (parcelRequire("7SlBO")).clearFilter);
$parcel$export(module.exports, "USER_FILTER_ID", () => (parcelRequire("j3zeB")).USER_FILTER_ID);
$parcel$export(module.exports, "interruptCommitting", () => (parcelRequire("9LVH6")).interrupt);
$parcel$export(module.exports, "interruptReverting", () => (parcelRequire("cONEK")).interrupt);

var $9FeHi = parcelRequire("9FeHi");
var $8K6YM = parcelRequire("8K6YM");
var $li3lI = parcelRequire("li3lI");
var $jPCDz = parcelRequire("jPCDz");
var $l0L3x = parcelRequire("l0L3x");
var $cQGVO = parcelRequire("cQGVO");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $gUUjF = parcelRequire("gUUjF");

var $dYnI4 = parcelRequire("dYnI4");

var $kP3Wn = parcelRequire("kP3Wn");

var $63O1Q = parcelRequire("63O1Q");

var $1jM5j = parcelRequire("1jM5j");

var $kXdPE = parcelRequire("kXdPE");

var $i3p5Q = parcelRequire("i3p5Q");

var $emgvC = parcelRequire("emgvC");

var $h7pZO = parcelRequire("h7pZO");

var $kKZNQ = parcelRequire("kKZNQ");

var $cbq3D = parcelRequire("cbq3D");

var $1Szmp = parcelRequire("1Szmp");

var $cTDpS = parcelRequire("cTDpS");

var $2L2I7 = parcelRequire("2L2I7");

var $1C7Mn = parcelRequire("1C7Mn");

var $051m9 = parcelRequire("051m9");
parcelRequire("bJc6r");
var $dsqWN = parcelRequire("dsqWN");

var $6VhAf = parcelRequire("6VhAf");

var $2Ruxt = parcelRequire("2Ruxt");

var $dEoWh = parcelRequire("dEoWh");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $9ydqM = parcelRequire("9ydqM");

var $c1XMU = parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");

var $MQRDu = parcelRequire("MQRDu");

var $eDYLe = parcelRequire("eDYLe");

var $wcCGG = parcelRequire("wcCGG");

var $fr1nu = parcelRequire("fr1nu");

var $DywVp = parcelRequire("DywVp");

var $kt7Vd = parcelRequire("kt7Vd");

var $gExeY = parcelRequire("gExeY");

var $lwKA5 = parcelRequire("lwKA5");

var $4dybm = parcelRequire("4dybm");

var $d4YZJ = parcelRequire("d4YZJ");

var $1pBkD = parcelRequire("1pBkD");

var $1LA8L = parcelRequire("1LA8L");

var $3oWAB = parcelRequire("3oWAB");

var $fDCVo = parcelRequire("fDCVo");

var $9LVH6 = parcelRequire("9LVH6");

var $cONEK = parcelRequire("cONEK");

var $12x9g = parcelRequire("12x9g");

var $c7fhc = parcelRequire("c7fhc");
parcelRequire("6owOg");
var $5Cso7 = parcelRequire("5Cso7");

var $7SlBO = parcelRequire("7SlBO");

var $j3zeB = parcelRequire("j3zeB");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hkDg7 = parcelRequire("hkDg7");

var $hoHCC = parcelRequire("hoHCC");

var $koaLU = parcelRequire("koaLU");
const $0c702537d957a9a2$export$308972e7a1f0c32f = 'command.update-jira.GET_CHANGES_METADATA';
const $0c702537d957a9a2$export$7636b4e7de1cbb0c = 'command.update-jira.GET_NOTIFICATION_PREFERENCE';
const $0c702537d957a9a2$export$5de96f956f57013f = 'command.update-jira.SAVE_NOTIFICATION_PREFERENCE';
const $0c702537d957a9a2$export$a031474266a52bb4 = 'command.update-jira.COMMIT_CHANGES';
const $0c702537d957a9a2$export$c73a59414b3152da = 'command.update-jira.REVERT_CHANGES';
const $0c702537d957a9a2$export$a9f3c3bb2f676e06 = 'command.update-jira.INTERRUPT';
const $0c702537d957a9a2$export$e4edc10ab54a304a = 'command.update-jira.UPDATE_LAST_COMMITTED_TIMESTAMP';
const $0c702537d957a9a2$export$35be11ad3df1110 = ()=>({
        type: $0c702537d957a9a2$export$308972e7a1f0c32f
    });
const $0c702537d957a9a2$export$53720dfce17bb85a = (payload, meta)=>({
        type: $0c702537d957a9a2$export$a031474266a52bb4,
        payload: payload,
        meta: meta
    });
const $0c702537d957a9a2$export$d269e5e1393c5f8a = (payload)=>({
        type: $0c702537d957a9a2$export$c73a59414b3152da,
        payload: payload
    });
const $0c702537d957a9a2$export$3c3771868e06ade1 = ()=>({
        type: $0c702537d957a9a2$export$7636b4e7de1cbb0c
    });
const $0c702537d957a9a2$export$7b2133f0c970c6e2 = (payload)=>({
        type: $0c702537d957a9a2$export$5de96f956f57013f,
        payload: payload
    });
const $0c702537d957a9a2$export$7b7d62677a00f822 = ()=>({
        type: $0c702537d957a9a2$export$a9f3c3bb2f676e06
    });
const $0c702537d957a9a2$export$f734abf5c5cd3d95 = ()=>({
        type: $0c702537d957a9a2$export$e4edc10ab54a304a
    });
const $0c702537d957a9a2$export$b85cd17f8fbba1f1 = (state, metaData)=>{
    const requiredUserKeys = metaData.map((value)=>value.lastChangeUser);
    const availableUserKeys = (0, $6VhAf.getAssigneeList)(state).map((assignee)=>assignee.personId);
    return $9FeHi.default(requiredUserKeys, availableUserKeys);
};
function* $0c702537d957a9a2$export$5c1594403ad65fa3() {
    const sprints = yield (0, $9e8i2.select)((0, $c1XMU.getSprints));
    const originalIssues = yield (0, $9e8i2.select)((0, $kwMvv.getOriginalIssues));
    const issuesById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
    yield (0, $9e8i2.put)((0, $3oWAB.reset)({
        category: (0, $5rYNM.ENTITY).ISSUE
    }));
    const warnings = [];
    for (const issueId of Object.keys(originalIssues)){
        const issue = issuesById[issueId];
        const originalIssue = originalIssues[issueId];
        if (issue) {
            if (issue.id == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.accessing-property-of-undefined', 'doGetChangeWarnings originalIssues[issueId] is undefined');
            if (issue.id?.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX)) || $jPCDz.default('sprint', originalIssue) && issue.sprint !== originalIssue.sprint) {
                const sprint = issue.sprint && (0, $a4NMN.getSprintById)(sprints, issue.sprint);
                if (sprint && sprint.state === 'ACTIVE') warnings.push({
                    category: (0, $5rYNM.ENTITY).ISSUE,
                    itemId: issueId,
                    warnings: (0, $koaLU.getChangeWarning)((0, $koaLU.ADDED_TO_ACTIVE_SPRINT))
                });
                const removedSprint = (0, $a4NMN.getSprintById)(sprints, originalIssue.sprint);
                if (removedSprint && removedSprint.state === 'ACTIVE') warnings.push({
                    category: (0, $5rYNM.ENTITY).ISSUE,
                    itemId: issueId,
                    warnings: (0, $koaLU.getChangeWarning)((0, $koaLU.REMOVED_FROM_ACTIVE_SPRINT))
                });
            }
        }
    }
    if (warnings.length) yield (0, $9e8i2.put)((0, $3oWAB.addBulk)(warnings));
}
const $0c702537d957a9a2$export$b874b322b7832120 = (issueLinksMetadata, issueLinksValuesForIssues, issueLinkOriginalsForIssues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueLinksValues = {};
    for (const issueId of Object.keys(issueLinksValuesForIssues))for (const issueLinkId of Object.keys(issueLinksValuesForIssues[issueId]))issueLinksValues[issueLinkId] = issueLinksValuesForIssues[issueId][issueLinkId];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueLinksOriginals = {};
    for (const issueId of Object.keys(issueLinkOriginalsForIssues))for (const issueLinkId of Object.keys(issueLinkOriginalsForIssues[issueId]))issueLinksOriginals[issueLinkId] = issueLinkOriginalsForIssues[issueId][issueLinkId];
    return Object.keys(issueLinksMetadata).filter((issueLinkId)=>{
        if (!(0, $7CnHa.isDefined)(issueLinksOriginals[issueLinkId]) && !(0, $7CnHa.isDefined)(issueLinksValues[issueLinkId])) return false;
        return true;
    }).map((issueLinkId)=>{
        const issueLinkMetadata = issueLinksMetadata[issueLinkId];
        switch(issueLinkMetadata.scenarioType){
            case 'DELETED':
                {
                    const issueLink = issueLinksOriginals[issueLinkId];
                    return {
                        itemKey: issueLinkId,
                        originals: {},
                        scenarioType: 'DELETED',
                        sourceItemKey: issueLink.sourceItemKey,
                        targetItemKey: issueLink.targetItemKey,
                        values: {
                            type: issueLink.type
                        }
                    };
                }
            default:
                {
                    const issueLink = issueLinksValues[issueLinkId];
                    return {
                        itemKey: issueLinkId,
                        originals: {},
                        scenarioType: 'ADDED',
                        sourceItemKey: issueLink.sourceItemKey,
                        targetItemKey: issueLink.targetItemKey,
                        values: {
                            type: issueLink.type
                        }
                    };
                }
        }
    });
};
const $0c702537d957a9a2$export$1ef8ba280e7555c0 = (issueChangesMetadata, issuesById, scenarioRemovedIssuesById, originalIssues, issueLinks)=>{
    const allIssuesById = {
        ...issuesById,
        ...scenarioRemovedIssuesById
    };
    /**
	 * Add issues that have only dependency changes. Such issues are not recorded in
	 * `originalIssues`
	 */ for (const issueId of Object.keys(issueLinks))if (!(0, $7CnHa.isDefined)(originalIssues[issueId])) // eslint-disable-next-line no-param-reassign
    originalIssues[issueId] = {};
    const definedIssuesIds = Object.keys(originalIssues).filter((id)=>allIssuesById[id]);
    return definedIssuesIds.map((id)=>(0, $kwMvv.toApiIssue)(allIssuesById[id], originalIssues[id], issueChangesMetadata[id]?.scenarioType));
};
function* $0c702537d957a9a2$export$d9d7693e2245e256() {
    try {
        const state = yield (0, $9e8i2.select)($l0L3x.default);
        const { domain: { plan: { id: id, currentScenarioId: currentScenarioId }, sequence: sequence } } = state;
        const body = (0, $hkDg7.getChangesMetadataBody)({
            id: id,
            currentScenarioId: currentScenarioId
        }, sequence);
        yield (0, $9e8i2.put)($fDCVo.sent());
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hkDg7.urls).getScenarioChangesMetadata, {
            profile: (0, $hkDg7.urls).getScenarioChangesMetadata,
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const json = yield (0, $9e8i2.call)(response.json.bind(response));
            const issueLinkValues = yield (0, $9e8i2.select)((0, $dEoWh.getIssueLinks));
            const issueLinkOriginals = yield (0, $9e8i2.select)((0, $dEoWh.getIssueLinkOriginals));
            const issueLinks = yield (0, $9e8i2.call)($0c702537d957a9a2$export$b874b322b7832120, {
                ...json.metaData.issueLinks
            }, issueLinkValues, issueLinkOriginals);
            const issuesMapById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
            const scenarioRemovedIssuesById = yield (0, $9e8i2.select)((0, $cwP4d.getScenarioRemovedIssueMapById));
            const originalIssues = yield (0, $9e8i2.select)((0, $kwMvv.getOriginalIssues));
            const issueLinkChangesData = yield (0, $9e8i2.call)((0, $dEoWh.getIssueLinkChangesDataPure), issueLinks);
            // Get all the API issues with that are related to changes
            const issues = yield (0, $9e8i2.call)($0c702537d957a9a2$export$1ef8ba280e7555c0, json.metaData.issues, issuesMapById, scenarioRemovedIssuesById, originalIssues, issueLinkChangesData);
            yield (0, $9e8i2.put)($fDCVo.success({
                ...json,
                issues: issues,
                issueLinks: issueLinks
            }));
            // check if all the users who did modifications have their meta data available
            // if not, let's fetch them because we need the meta data to display their display name and avatar
            const allChangesMetaData = yield (0, $9e8i2.select)((0, $eDYLe.getAllChangesMetaData));
            const keys = $0c702537d957a9a2$export$b85cd17f8fbba1f1(state, allChangesMetaData);
            yield (0, $9e8i2.put)((0, $kKZNQ.populateUserPickerOptions)());
            // fetch all the assignee of issues and original issues, as we need to display them
            yield (0, $9e8i2.put)((0, $63O1Q.fetchAssigneeListForKeys)({
                keys: keys,
                fetchAllAssignees: true
            }));
            yield (0, $9e8i2.call)($0c702537d957a9a2$export$5c1594403ad65fa3);
            yield (0, $9e8i2.put)($fDCVo.afterSuccess());
        } else yield (0, $9e8i2.put)($fDCVo.error({
            code: response.status,
            message: yield (0, $9e8i2.call)(response.json.bind(response))
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)($fDCVo.error({
            code: 0,
            message: {
                error: e.message
            }
        }));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $0c702537d957a9a2$export$f88a659cb8822a85() {
    let shouldNotifyWatchers;
    try {
        shouldNotifyWatchers = yield (0, $9e8i2.call)((0, $hoHCC.getNotifyWatchersPreference));
    } catch (err) {
    // Call can fail with a 404 if user has not previously set userPreference key
    }
    yield (0, $9e8i2.put)($7SlBO.updateNotificationPreference({
        shouldNotifyWatchers: shouldNotifyWatchers
    }));
}
function* $0c702537d957a9a2$export$25a1a7245485adb4({ payload: { shouldNotifyWatchers: shouldNotifyWatchers } }) {
    try {
        yield (0, $9e8i2.call)((0, $hoHCC.setNotifyWatchersPreference), shouldNotifyWatchers);
    } catch (err) {
        return undefined;
    }
}
function* $0c702537d957a9a2$export$df46215683194476(bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers) {
    const bulkResponse = yield (0, $9e8i2.call)((0, $i3p5Q.executeBulkCommitRequest), bulkCommitEntitiesBatch, notifyWatchers);
    // handle the commit responses one by one
    let success = true;
    let tryBatchAgainFromIndex = null;
    for (const entityResponse of bulkResponse?.orderedCommitResults ?? []){
        const id = entityResponse.itemKey;
        // since issue links are not a selectable entity in the commit UI (they come under issues),
        // we don't increment the count here
        if (entityResponse.entityType !== (0, $emgvC.BulkCommitEntityType).ISSUE_LINK) yield (0, $9e8i2.put)($9LVH6.incrementNumberOfCommittedChanges());
        if (!entityResponse.success) success = false;
        switch(entityResponse.entityType){
            case (0, $emgvC.BulkCommitEntityType).X_PROJECT_VERSION:
                yield (0, $9e8i2.call)($h7pZO.handleCrossProjectVersionCommitResponse, entityResponse);
                break;
            case (0, $emgvC.BulkCommitEntityType).VERSION:
                yield (0, $9e8i2.call)($051m9.handleVersionCommitResponse, entityResponse);
                break;
            case (0, $emgvC.BulkCommitEntityType).TEAM:
                yield (0, $9e8i2.call)((0, $1C7Mn.handleTeamBulkCommitResponse), entityResponse);
                break;
            case (0, $emgvC.BulkCommitEntityType).RESOURCE:
                yield (0, $9e8i2.call)((0, $1C7Mn.handleResourceBulkCommitResponse), entityResponse);
                break;
            case (0, $emgvC.BulkCommitEntityType).PLANNED_CAPACITY:
                {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const plannedCapacityChange = plannedCapacityChangesByItemKey.get(id);
                    yield (0, $9e8i2.call)((0, $2L2I7.handlePlannedCapacityBulkCommitResponse), entityResponse, plannedCapacityChange);
                    break;
                }
            case (0, $emgvC.BulkCommitEntityType).ISSUE:
                {
                    const isJiraScreenDisplayed = yield (0, $9e8i2.call)((0, $1Szmp.handleIssueCommitResponse), entityResponse, notifyWatchers);
                    // if required fields for issue create were needed or the issue status transition screen required, it means the batch was interrupted,
                    // and we need to attempt to commit the rest of the batch
                    if (isJiraScreenDisplayed) {
                        success = true;
                        if (bulkCommitEntitiesBatch.length > bulkResponse.orderedCommitResults.length) tryBatchAgainFromIndex = bulkResponse.orderedCommitResults.length;
                    }
                    const processedId = entityResponse.generatedId ?? id;
                    processedIssueChanges.push(processedId);
                    if (processedId !== id) {
                        issueIdToProcessedId.set(id, processedId);
                        yield (0, $9e8i2.put)($fr1nu.updateIssueReferences({
                            oldId: id,
                            newId: processedId
                        }));
                    }
                    break;
                }
            case (0, $emgvC.BulkCommitEntityType).ISSUE_LINK:
                {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    let associatedIssueId = issueLinkToIssueMap.get(entityResponse.itemKey);
                    if (issueIdToProcessedId.has(associatedIssueId)) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    associatedIssueId = issueIdToProcessedId.get(associatedIssueId);
                    yield (0, $9e8i2.call)($cTDpS.handleIssueLinkCommitResponse, entityResponse, associatedIssueId);
                    break;
                }
            default:
        }
        if (!success || tryBatchAgainFromIndex !== null) break;
    }
    return {
        issueIdToProcessedId: issueIdToProcessedId,
        processedIssueChanges: processedIssueChanges,
        success: success,
        tryBatchAgainFromIndex: tryBatchAgainFromIndex
    };
}
function* $0c702537d957a9a2$export$73b4b802f205083a(selectedChanges, selectedIssues, notifyWatchers) {
    const allPlannedCapacityChanges = yield (0, $9e8i2.select)((0, $c1XMU.getPlannedCapacityChanges));
    const plannedCapacityChangesByItemKey = allPlannedCapacityChanges.reduce((map, change)=>{
        if ((0, $7CnHa.isDefined)(change.values.itemKey)) map.set(change.values.itemKey, change);
        return map;
    }, new Map());
    const { bulkCommitEntities: bulkCommitEntities, issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount, issueLinkToIssueMap: issueLinkToIssueMap } = yield (0, $9e8i2.call)((0, $i3p5Q.createBulkCommitRequestEntityList), selectedChanges, selectedIssues, allPlannedCapacityChanges);
    let issueIdToProcessedId = new Map();
    let processedIssueChanges = [];
    const issueChangesMetaData = yield (0, $9e8i2.select)((0, $kwMvv.getIssueChangesMetaData));
    const batchSize = (0, $dsqWN.default)();
    for(let i = 0; i < bulkCommitEntities.length; i += batchSize){
        let tryBatchAgainFromIndex = null;
        let success = true;
        let bulkCommitEntitiesBatch = bulkCommitEntities.slice(i, i + batchSize);
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsSavingInterrupted))) break;
        ({ issueIdToProcessedId: issueIdToProcessedId, processedIssueChanges: processedIssueChanges, success: success, tryBatchAgainFromIndex: tryBatchAgainFromIndex } = yield (0, $9e8i2.call)($0c702537d957a9a2$export$df46215683194476, bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers));
        // if the batch commit was interrupted part of the way due to required fields,
        // we should attempt to commit the rest of the batch
        while(tryBatchAgainFromIndex !== null){
            bulkCommitEntitiesBatch = bulkCommitEntitiesBatch.slice(tryBatchAgainFromIndex);
            ({ issueIdToProcessedId: issueIdToProcessedId, processedIssueChanges: processedIssueChanges, success: success, tryBatchAgainFromIndex: tryBatchAgainFromIndex } = yield (0, $9e8i2.call)($0c702537d957a9a2$export$df46215683194476, bulkCommitEntitiesBatch, plannedCapacityChangesByItemKey, issueIdToProcessedId, processedIssueChanges, issueLinkToIssueMap, notifyWatchers));
        }
        if (!success) break;
    }
    // issues that only contain issue link changes are not committed (it is a issue link entity instead)
    // but as the issues still appear in the commit UI, we need to increment the change count to match.
    for(let i = 0; i < issueLinkOnlyIssueChangesCount; i++)yield (0, $9e8i2.put)($9LVH6.incrementNumberOfCommittedChanges());
    // issue post-commit work that is only meant to be run once
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        isSelected: false,
        toggleAll: true,
        ids: []
    }));
    yield (0, $9e8i2.put)((0, $c7fhc.updateExpandedIssueLinks)(Object.fromEntries(issueIdToProcessedId)));
    yield (0, $9e8i2.call)((0, $1Szmp.getHiddenIssues), processedIssueChanges.filter((id)=>!issueChangesMetaData[id] || issueChangesMetaData[id].scenarioType !== 'DELETED'));
    yield (0, $9e8i2.put)((0, $lwKA5.reset)({}));
}
function* $0c702537d957a9a2$export$1da733c3857c6e08({ payload: { actions: actions, notifyWatchers: notifyWatchers } }) {
    (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_SAVE);
    const data = yield (0, $9e8i2.select)((0, $eDYLe.getFilteredReviewChanges));
    if (!data.length) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: 'Get changes before committing them'
        }));
        return;
    }
    const selectedChanges = yield (0, $9e8i2.select)((0, $eDYLe.getSelectedChanges));
    const selectedChangesCount = yield (0, $9e8i2.select)((0, $eDYLe.getSelectedChangesCount));
    // we get the issues sorted by hierarchy as parents need to be created before their children,
    // since the child issue will contain a parent link referencing the parent
    const selectedIssues = yield (0, $9e8i2.select)((0, $eDYLe.getSortedByHierarchySelectedIssues));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const committedChangesSets = $cQGVO.default((items)=>new Set(items), selectedChanges);
    yield (0, $9e8i2.put)($9LVH6.start(selectedChangesCount));
    try {
        (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_PERSIST);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$73b4b802f205083a, selectedChanges, selectedIssues, notifyWatchers);
        (0, $dYnI4.monitor).finishTask((0, $5rYNM.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_PERSIST, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-shadow
            scalingFactors: $cQGVO.default((changes)=>changes.size, committedChangesSets)
        });
        // NOTE getBacklog is duplicated in both branches (instead of one in `finally` block)
        // because we want to execute it (and wait for result) before success/error action
        yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
        if (actions.success) for (const action of actions.success)yield (0, $9e8i2.put)(action);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
        /* istanbul ignore else */ if (actions.error) yield (0, $9e8i2.put)(actions.error);
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)($9LVH6.stop());
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$d9d7693e2245e256);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const data = yield (0, $9e8i2.select)((0, $eDYLe.getReviewChanges));
        const filteredData = yield (0, $9e8i2.select)((0, $eDYLe.getFilteredReviewChanges));
        const isOutOfSync = yield (0, $9e8i2.select)((0, $eDYLe.getIsOutOfSync));
        if (!filteredData.length && !isOutOfSync) yield (0, $9e8i2.put)($7SlBO.clearFilter((0, $j3zeB.USER_FILTER_ID)));
        if (!data.length && !isOutOfSync) yield (0, $9e8i2.put)($7SlBO.closeUpdateJiraDialog());
        data.forEach((uncommittedChange)=>committedChangesSets[uncommittedChange.category]?.delete(uncommittedChange.id));
        (0, $dYnI4.monitor).finishTask((0, $5rYNM.PERFORMANCE_KEYS).COMMIT_CHANGES_TIME_TO_SAVE, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-shadow
            scalingFactors: $cQGVO.default((changes)=>changes.size, committedChangesSets)
        });
    }
}
function* $0c702537d957a9a2$export$c90b346a1ef1c74e(selectedChanges) {
    const issueChangesMetaData = yield (0, $9e8i2.select)((0, $kwMvv.getIssueChangesMetaData));
    const issueLinkChanges = yield (0, $9e8i2.select)((0, $dEoWh.getIssueLinkChangesData));
    // Tracking reverted issue link changes is required because every issue link change
    // is present in issue link changes associated with both source and target issue,
    // but must be reverted only once.
    const revertedIssueLinkChanges = new Set();
    // It is necessary to revert issue links before actual issue changes to ensure
    // that created issues are reverted after reverting their links.
    // At the moment there is no good way to represent such compound changes
    // using Review changes dialog progress bar.
    // For this reason issue links are reverted without tracking any progress,
    // though user is still capable to interrupt this process as isSavingInterrupted
    // is checked inside the loop.
    /* eslint-disable no-labels, no-continue */ loop: for (const id of selectedChanges)for (const { itemKey: itemKey } of issueLinkChanges[id] || []){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break loop;
        if (revertedIssueLinkChanges.has(itemKey)) continue;
        const response = yield (0, $9e8i2.call)($cTDpS.revertChange, itemKey, id);
        if (!response.ok) {
            yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
            break;
        }
        revertedIssueLinkChanges.add(itemKey);
    }
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        // If issue link change is the only change associated with this issue
        // then issue itself must not be reverted.
        if (issueChangesMetaData[id]) {
            const response = yield (0, $9e8i2.call)((0, $1Szmp.revertChange), id);
            yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
            if (!response.ok) {
                yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
                break;
            }
        } else yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
    }
    const patches = yield (0, $9e8i2.select)((0, $kwMvv.getOriginalIssues));
    yield (0, $9e8i2.put)((0, $5Cso7.toggleSelectedIssues)({
        isSelected: false,
        toggleAll: true,
        ids: []
    }));
    yield (0, $9e8i2.put)((0, $kt7Vd.bulkUpdate)(patches));
    yield (0, $9e8i2.put)((0, $kt7Vd.removeWithoutIssueKey)());
    yield (0, $9e8i2.put)((0, $lwKA5.reset)({}));
}
function* $0c702537d957a9a2$export$c311273348377937(selectedChanges) {
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        const response = yield (0, $9e8i2.call)($h7pZO.revertChange, id);
        yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
        if (!response.ok) {
            yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
            break;
        }
        yield* (0, $kXdPE.default)(function*() {
            const originals = yield (0, $9e8i2.select)((0, $2Ruxt.getOriginalCrossProjectVersions));
            if (id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $9e8i2.call)($h7pZO.removeCrossProjectVersionFromStore, id);
            else {
                const removedCrossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getRemovedCrossProjectVersionsById));
                const removedCrossProjectVersion = removedCrossProjectVersionsById[id];
                /** We have to add a removed cross-project version back to main cross-project versions list
				 *  before reseting the values from originals, because the version id will not be found
				 *  until we add it to the list. Doing so will make sure that while reseting values,
				 *  it will find version in the list.
				 */ if ((0, $7CnHa.isDefined)(removedCrossProjectVersion)) yield (0, $9e8i2.call)($h7pZO.addRemovedCrossProjectVersionToMainCrossProjectVersionsList, removedCrossProjectVersion);
                yield (0, $9e8i2.put)($DywVp.bulkUpdate({
                    [id]: originals[id]
                }));
                yield (0, $9e8i2.put)($gExeY.reset($8K6YM.default(id, originals)));
            }
        });
    }
}
function* $0c702537d957a9a2$export$337fbf4febbb6d6e(selectedChanges) {
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        const response = yield (0, $9e8i2.call)($051m9.revertChange, id);
        yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
        if (!response.ok) {
            yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
            break;
        }
        const originals = yield (0, $9e8i2.select)((0, $wcCGG.getOriginalVersions));
        const originalVersion = originals[id];
        if (id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $9e8i2.call)($051m9.removeVersionFromStore, id);
        else {
            /** We have to add a removed version back to versions list before reseting the values from originals,
			 *  because the version id will not be found until we add it to the list. Doing so
			 *  will make sure that while reseting values, it will find version in the list.
			 */ const removedVersionsById = yield (0, $9e8i2.select)((0, $wcCGG.getRemovedVersionsById));
            const removedVersion = removedVersionsById[id];
            if ((0, $7CnHa.isDefined)(removedVersion)) yield (0, $9e8i2.call)($051m9.addRemovedVersionToMainVersionsList, removedVersion);
            const versionsById = yield (0, $9e8i2.select)((0, $wcCGG.getVersionsById));
            const version = versionsById[id];
            // Update cross-project version
            if (Object.keys(originalVersion).includes('crossProjectVersion')) {
                if ((0, $7CnHa.isDefined)(version.crossProjectVersion)) // Remove a release from crossProjectVersion
                yield (0, $9e8i2.call)($h7pZO.removeVersionFromCrossProjectVersion, id, version.crossProjectVersion);
                if ((0, $7CnHa.isDefined)(originalVersion.crossProjectVersion)) yield (0, $9e8i2.call)($h7pZO.addVersionInCrossProjectVersion, id, originalVersion.crossProjectVersion);
            }
            yield (0, $9e8i2.put)((0, $12x9g.bulkUpdate)({
                [id]: originals[id]
            }));
        }
        yield (0, $9e8i2.put)((0, $1LA8L.reset)($8K6YM.default(id, originals)));
    }
}
function* $0c702537d957a9a2$export$ca9a89fd41789c0d(selectedChanges) {
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        const response = yield (0, $9e8i2.call)((0, $1C7Mn.revertResourceChange), id);
        yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
        if (!response.ok) {
            yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
            break;
        }
        const originals = yield (0, $9e8i2.select)((0, $9ydqM.getOriginalResources));
        yield (0, $9e8i2.put)((0, $d4YZJ.reset)($8K6YM.default(id, originals)));
    }
}
function* $0c702537d957a9a2$export$76a9f8d4d2d6478c(selectedChanges) {
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        const response = yield (0, $9e8i2.call)((0, $1C7Mn.revertTeamChange), id);
        yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
        if (!response.ok) {
            yield (0, $9e8i2.put).resolve($0c702537d957a9a2$export$7b7d62677a00f822());
            break;
        }
        const originals = yield (0, $9e8i2.select)((0, $MQRDu.getOriginalTeams));
        yield (0, $9e8i2.put)((0, $1pBkD.reset)($8K6YM.default(id, originals)));
    }
}
function* $0c702537d957a9a2$export$90c04c22c0e8a50f(selectedChanges) {
    const allPlannedCapacityChanges = yield (0, $9e8i2.select)((0, $c1XMU.getPlannedCapacityChanges));
    for (const id of selectedChanges){
        if (yield (0, $9e8i2.select)((0, $eDYLe.getIsRevertingInterrupted))) break;
        const plannedCapacityChanges = allPlannedCapacityChanges.filter((capacityChange)=>capacityChange.iterationId === id);
        for (const plannedCapacityChange of plannedCapacityChanges){
            const { teamId: teamId, iterationId: iterationId } = plannedCapacityChange.values;
            const response = yield (0, $9e8i2.call)((0, $2L2I7.revertPlannedCapacityChange), plannedCapacityChange);
            if (!response.ok) {
                yield (0, $9e8i2.put)($0c702537d957a9a2$export$7b7d62677a00f822());
                break;
            }
            const originals = yield (0, $9e8i2.select)((0, $c1XMU.getOriginalPlannedCapacities));
            yield (0, $9e8i2.put)((0, $4dybm.reset)($li3lI.default([
                teamId,
                iterationId
            ], originals)));
        }
        yield (0, $9e8i2.put)($cONEK.incrementNumberOfRevertedChanges());
    }
}
function* $0c702537d957a9a2$export$ecf66aaaea5ca30a({ payload: { actions: actions } }) {
    const data = yield (0, $9e8i2.select)((0, $eDYLe.getFilteredReviewChanges));
    if (!data.length) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: 'Get changes before reverting them'
        }));
        return;
    }
    const selectedChanges = yield (0, $9e8i2.select)((0, $eDYLe.getSelectedChanges));
    const selectedChangesCount = yield (0, $9e8i2.select)((0, $eDYLe.getSelectedChangesCount));
    yield (0, $9e8i2.put)($cONEK.start(selectedChangesCount));
    try {
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$c90b346a1ef1c74e, selectedChanges[(0, $5rYNM.ENTITY).ISSUE]);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$337fbf4febbb6d6e, selectedChanges[(0, $5rYNM.ENTITY).RELEASE]);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$c311273348377937, selectedChanges[(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$ca9a89fd41789c0d, selectedChanges[(0, $5rYNM.ENTITY).RESOURCE]);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$76a9f8d4d2d6478c, selectedChanges[(0, $5rYNM.ENTITY).TEAM]);
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$90c04c22c0e8a50f, selectedChanges[(0, $5rYNM.ENTITY).SPRINT]);
        // NOTE getBacklog is duplicated in both branches (instead of one in `finally` block)
        // because we want to execute it (and wait for result) before success/error action
        yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
        /* istanbul ignore else */ if (actions.success) for (const action of actions.success)yield (0, $9e8i2.put)(action);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
        /* istanbul ignore else */ if (actions.error) yield (0, $9e8i2.put)(actions.error);
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)($cONEK.stop());
        yield (0, $9e8i2.call)($0c702537d957a9a2$export$d9d7693e2245e256);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const data = yield (0, $9e8i2.select)((0, $eDYLe.getReviewChanges));
        const filteredData = yield (0, $9e8i2.select)((0, $eDYLe.getFilteredReviewChanges));
        const isOutOfSync = yield (0, $9e8i2.select)((0, $eDYLe.getIsOutOfSync));
        if (!filteredData.length && !isOutOfSync) yield (0, $9e8i2.put)($7SlBO.clearFilter((0, $j3zeB.USER_FILTER_ID)));
        if (!data.length && !isOutOfSync) yield (0, $9e8i2.put)($7SlBO.closeUpdateJiraDialog());
    }
}
function* $0c702537d957a9a2$export$b869f89bdc5d5ec1() {
    if (yield (0, $9e8i2.select)((0, $eDYLe.getIsSaving))) yield (0, $9e8i2.put)($9LVH6.interrupt());
    else if (yield (0, $9e8i2.select)((0, $eDYLe.getIsReverting))) yield (0, $9e8i2.put)($cONEK.interrupt());
}
function* $0c702537d957a9a2$export$555af14e14350990() {
    const state = yield (0, $9e8i2.select)($l0L3x.default);
    const { domain: { plan: { id: planId } } } = state;
    if (!planId) return;
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hkDg7.urls).updateLastCommittedTimestamp(planId), {
        method: (0, $kP3Wn.POST)
    });
    if (!response.ok) throw new Error('There was an error when trying to update the plan');
}
function* $0c702537d957a9a2$export$96494dda9a3d57b4() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$308972e7a1f0c32f, $0c702537d957a9a2$export$d9d7693e2245e256);
}
function* $0c702537d957a9a2$export$6f18501cc25be345() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$a031474266a52bb4, $0c702537d957a9a2$export$1da733c3857c6e08);
}
function* $0c702537d957a9a2$export$73f92641dfd20b98() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$c73a59414b3152da, $0c702537d957a9a2$export$ecf66aaaea5ca30a);
}
function* $0c702537d957a9a2$export$e0e74359047007f8() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$e4edc10ab54a304a, $0c702537d957a9a2$export$555af14e14350990);
}
function* $0c702537d957a9a2$export$aa6c1e215cb7ce11() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$7636b4e7de1cbb0c, $0c702537d957a9a2$export$f88a659cb8822a85);
}
function* $0c702537d957a9a2$export$12a5127652e2889e() {
    yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$5de96f956f57013f, $0c702537d957a9a2$export$25a1a7245485adb4);
}
function* $0c702537d957a9a2$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$96494dda9a3d57b4);
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$6f18501cc25be345);
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$73f92641dfd20b98);
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$e0e74359047007f8);
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$aa6c1e215cb7ce11);
    yield (0, $9e8i2.fork)($0c702537d957a9a2$export$12a5127652e2889e);
    yield (0, $9e8i2.fork)(function*() {
        yield (0, $bG7pV.takeLatest)($0c702537d957a9a2$export$a9f3c3bb2f676e06, $0c702537d957a9a2$export$b869f89bdc5d5ec1);
    });
}

});
parcelRegister("li3lI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7fde08097bd1130$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");

var $5CL3x = parcelRequire("5CL3x");

var $dPJMs = parcelRequire("dPJMs");

var $aeXAa = parcelRequire("aeXAa");

var $8K6YM = parcelRequire("8K6YM");

var $6aakY = parcelRequire("6aakY");

var $elb6l = parcelRequire("elb6l");
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $f7fde08097bd1130$var$dissocPath = /*#__PURE__*/ (0, $ggdJA.default)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $5CL3x.default)(path[0]) && (0, $dPJMs.default)(obj) ? (0, $6aakY.default)(path[0], 1, obj) : (0, $8K6YM.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, $5CL3x.default)(head) && (0, $dPJMs.default)(obj)) return (0, $elb6l.default)(head, dissocPath(tail, obj[head]), obj);
            else return (0, $aeXAa.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $f7fde08097bd1130$export$2e2bcd8739ae039 = $f7fde08097bd1130$var$dissocPath;

});

parcelRegister("i3p5Q", function(module, exports) {

$parcel$export(module.exports, "executeBulkCommitRequest", () => $4dd596e9915d2570$export$1a42b6fc7ec66ade);
$parcel$export(module.exports, "createBulkCommitRequestEntityList", () => $4dd596e9915d2570$export$902136b0124933d2);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $kP3Wn = parcelRequire("kP3Wn");

var $3EOJS = parcelRequire("3EOJS");

var $emgvC = parcelRequire("emgvC");

var $j5GRN = parcelRequire("j5GRN");

var $iTjRl = parcelRequire("iTjRl");

var $dEoWh = parcelRequire("dEoWh");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $xlOmi = parcelRequire("xlOmi");

var $9LVH6 = parcelRequire("9LVH6");

var $7WQG5 = parcelRequire("7WQG5");

var $eBGH3 = parcelRequire("eBGH3");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $13pyJ = parcelRequire("13pyJ");
const $4dd596e9915d2570$export$a9f3c3bb2f676e06 = 'command.update-jira.INTERRUPT';
const $4dd596e9915d2570$export$7b7d62677a00f822 = ()=>({
        type: $4dd596e9915d2570$export$a9f3c3bb2f676e06
    });
function* $4dd596e9915d2570$export$1a42b6fc7ec66ade(bulkCommitIssues, notifyWatchers) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $3EOJS.bulkCommitBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, bulkCommitIssues, notifyWatchers);
    const response = yield* $iTjRl.json({
        url: (0, $3EOJS.bulkCommitUrl),
        profile: (0, $3EOJS.bulkCommitUrl),
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (!response.ok) {
        yield (0, $9e8i2.put).resolve($4dd596e9915d2570$export$7b7d62677a00f822());
        return undefined;
    }
    const responseBody = response.data;
    yield (0, $9e8i2.put)((0, $xlOmi.update)(responseBody.sequenceChanges));
    return responseBody;
}
function* $4dd596e9915d2570$export$e328200534490fb3(selectedChanges) {
    yield (0, $9e8i2.put)((0, $7WQG5.reset)([]));
    const issueChangesMetaData = yield (0, $9e8i2.select)((0, $kwMvv.getIssueChangesMetaData));
    const issueAndIssueLinkCommitEntities = [];
    let issueLinkOnlyIssueChangesCount = 0; // used to increment count
    const issueIdsBeingCommitted = new Set();
    const issuesById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
    for (const id of selectedChanges){
        const parentIdOfThisIssue = issuesById[id]?.parent;
        // Don't commit issue when parent issue has not been created in Jira (Still a scenario), as cannot create parent link
        if ((0, $13pyJ.isScenarioIssue)(parentIdOfThisIssue) && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !issueIdsBeingCommitted.has(parentIdOfThisIssue)) {
            const uncommittedWarnings = yield (0, $9e8i2.call)((0, $j5GRN.inspectForCommitWarnings), undefined, {
                error: 'UNCOMMITTED_PARENT',
                errorMessages: []
            });
            yield (0, $9e8i2.put)((0, $eBGH3.add)({
                category: (0, $5rYNM.ENTITY).ISSUE,
                itemId: id,
                warnings: uncommittedWarnings
            }));
            // We need to increment on fail since warning messages minus one from the committed count.
            yield (0, $9e8i2.put)((0, $9LVH6.incrementNumberOfCommittedChanges)());
            yield (0, $9e8i2.put).resolve($4dd596e9915d2570$export$7b7d62677a00f822());
            break;
        }
        if (issueChangesMetaData[id]) {
            issueAndIssueLinkCommitEntities.push({
                entityType: (0, $emgvC.BulkCommitEntityType).ISSUE,
                itemKey: id
            });
            issueIdsBeingCommitted.add(id);
        } else // If issue link change is the only change associated with this issue
        // then issue itself must not be committed, but we still keep track of it to increment the correct number of changes
        issueLinkOnlyIssueChangesCount += 1;
    }
    // It is necessary to commit issue links after actual issue changes to ensure
    // that created issues are committed before creating their links.
    const issueLinkChanges = yield (0, $9e8i2.select)((0, $dEoWh.getIssueLinkChangesData));
    const issueLinkChangesSet = new Set();
    const issueLinkToIssueMap = new Map(); // used for adding failures to issue if issueLink fails.
    for (const issueId of selectedChanges){
        for (const { itemKey: itemKey } of issueLinkChanges[issueId] ?? [])if (!issueLinkChangesSet.has(itemKey)) {
            issueAndIssueLinkCommitEntities.push({
                entityType: (0, $emgvC.BulkCommitEntityType).ISSUE_LINK,
                itemKey: itemKey
            });
            issueLinkChangesSet.add(itemKey);
            issueLinkToIssueMap.set(itemKey, issueId);
        }
    }
    return {
        issueAndIssueLinkCommitEntities: issueAndIssueLinkCommitEntities,
        issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount,
        issueLinkToIssueMap: issueLinkToIssueMap
    };
}
function* $4dd596e9915d2570$export$902136b0124933d2(selectedChanges, selectedIssues, allPlannedCapacityChanges) {
    const bulkCommitEntities = [];
    selectedChanges[(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]?.forEach((id)=>{
        bulkCommitEntities.push({
            entityType: (0, $emgvC.BulkCommitEntityType).X_PROJECT_VERSION,
            itemKey: id
        });
    });
    selectedChanges[(0, $5rYNM.ENTITY).RELEASE]?.forEach((id)=>{
        bulkCommitEntities.push({
            entityType: (0, $emgvC.BulkCommitEntityType).VERSION,
            itemKey: id
        });
    });
    selectedChanges[(0, $5rYNM.ENTITY).TEAM]?.forEach((id)=>{
        bulkCommitEntities.push({
            entityType: (0, $emgvC.BulkCommitEntityType).TEAM,
            itemKey: id
        });
    });
    selectedChanges[(0, $5rYNM.ENTITY).RESOURCE]?.forEach((id)=>{
        bulkCommitEntities.push({
            entityType: (0, $emgvC.BulkCommitEntityType).RESOURCE,
            itemKey: id
        });
    });
    // planned capacity changes chosen by iteration, but the itemKey represents the individual team specific capacity change
    selectedChanges[(0, $5rYNM.ENTITY).SPRINT]?.forEach((id)=>{
        allPlannedCapacityChanges.filter((capacityChange)=>capacityChange.iterationId === id && (0, $7CnHa.isDefined)(capacityChange.values.itemKey)).forEach((capacityChange)=>bulkCommitEntities.push({
                entityType: (0, $emgvC.BulkCommitEntityType).PLANNED_CAPACITY,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                itemKey: capacityChange.values.itemKey
            }));
    });
    const { issueAndIssueLinkCommitEntities: issueAndIssueLinkCommitEntities, issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount, issueLinkToIssueMap: issueLinkToIssueMap } = yield (0, $9e8i2.call)($4dd596e9915d2570$export$e328200534490fb3, selectedIssues);
    bulkCommitEntities.push(...issueAndIssueLinkCommitEntities);
    return {
        bulkCommitEntities: bulkCommitEntities,
        issueLinkOnlyIssueChangesCount: issueLinkOnlyIssueChangesCount,
        issueLinkToIssueMap: issueLinkToIssueMap
    };
}

});
parcelRegister("3EOJS", function(module, exports) {

$parcel$export(module.exports, "bulkCommitUrl", () => $ddd33458972523fc$export$7c4e50214fe2513b);
$parcel$export(module.exports, "bulkCommitBody", () => $ddd33458972523fc$export$10adece601c6a143);

var $GanEp = parcelRequire("GanEp");

var $hkDg7 = parcelRequire("hkDg7");
const $ddd33458972523fc$export$7c4e50214fe2513b = '/rest/jpo/1.0/bulk-commit';
const $ddd33458972523fc$export$10adece601c6a143 = ({ id: planId, currentScenarioId: scenarioId }, sequence, orderedCommitEntities, // Defaults to true, we want to notify watchers
notifyWatchers = true)=>{
    if (!planId || !scenarioId) throw new Error('Need both plan and scenario to commit or get changes');
    const payload = {
        planId: planId,
        scenarioId: scenarioId,
        sequence: $GanEp.default((0, $hkDg7.sequenceKeys).map((key)=>[
                key,
                {
                    current: sequence[key]?.current ?? 0
                }
            ])),
        orderedCommitEntities: orderedCommitEntities,
        notifyWatchers: notifyWatchers
    };
    return payload;
};

});

parcelRegister("emgvC", function(module, exports) {

$parcel$export(module.exports, "BulkCommitEntityType", () => $337f97e1a4c2eb55$export$491435a7bc7b10e7);
const $337f97e1a4c2eb55$export$491435a7bc7b10e7 = {
    X_PROJECT_VERSION: 'X_PROJECT_VERSION',
    VERSION: 'VERSION',
    TEAM: 'TEAM',
    RESOURCE: 'RESOURCE',
    PLANNED_CAPACITY: 'PLANNED_CAPACITY',
    ISSUE: 'ISSUE',
    ISSUE_LINK: 'ISSUE_LINK'
};

});


parcelRegister("h7pZO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ADD_RELEASE", () => $0d630a3119fa0c4c$export$2bdfac268df97e49);
$parcel$export(module.exports, "UPDATE_RELEASE", () => $0d630a3119fa0c4c$export$3f90e3abee6e8d70);
$parcel$export(module.exports, "DELETE_RELEASE", () => $0d630a3119fa0c4c$export$440c54a43c85f449);
$parcel$export(module.exports, "ALIGN_DATES_OF_RELEASES", () => $0d630a3119fa0c4c$export$4192fcdf48d80cf0);
$parcel$export(module.exports, "VIEW_RELEASE_IN_ROADMAP", () => $0d630a3119fa0c4c$export$a54e64fcc2f0026f);
$parcel$export(module.exports, "addRelease", () => $0d630a3119fa0c4c$export$d7ff8290d1a14fa1);
$parcel$export(module.exports, "updateRelease", () => $0d630a3119fa0c4c$export$a5f005f0031c650d);
$parcel$export(module.exports, "deleteRelease", () => $0d630a3119fa0c4c$export$41b4061737a08cd);
$parcel$export(module.exports, "alignDatesOfReleases", () => $0d630a3119fa0c4c$export$bb284c7cbd912e33);
$parcel$export(module.exports, "viewReleaseInRoadmap", () => $0d630a3119fa0c4c$export$4ddde390df08566c);
$parcel$export(module.exports, "addRemovedCrossProjectVersionToMainCrossProjectVersionsList", () => $0d630a3119fa0c4c$export$a9e2c51d05f71323);
$parcel$export(module.exports, "handleCrossProjectVersionWarnings", () => $0d630a3119fa0c4c$export$788bc0a886dbb81f);
$parcel$export(module.exports, "handleCrossProjectVersionCommitResponse", () => $0d630a3119fa0c4c$export$3ca5d248d9658375);
$parcel$export(module.exports, "revertChange", () => $0d630a3119fa0c4c$export$be623675b8f208ee);
$parcel$export(module.exports, "addVersionInCrossProjectVersion", () => $0d630a3119fa0c4c$export$8e127e72248d08);
$parcel$export(module.exports, "removeVersionFromCrossProjectVersion", () => $0d630a3119fa0c4c$export$ac89d6cd5251dbf4);
$parcel$export(module.exports, "addCrossProjectVersionInStore", () => $0d630a3119fa0c4c$export$3b6da5955bae8c75);
$parcel$export(module.exports, "removeCrossProjectVersionFromStore", () => $0d630a3119fa0c4c$export$4bbfd299114d60db);
$parcel$export(module.exports, "doUpdateVersion", () => $0d630a3119fa0c4c$export$740de856a6989843);
$parcel$export(module.exports, "updateStateAfterAddingVersion", () => $0d630a3119fa0c4c$export$476de812fbbb6302);
$parcel$export(module.exports, "doAddVersion", () => $0d630a3119fa0c4c$export$89ca6b91461e4dc);
$parcel$export(module.exports, "updateStateAfterDeletingCrossProjectVersion", () => $0d630a3119fa0c4c$export$ed51d7a10005fa33);
$parcel$export(module.exports, "doDeleteVersion", () => $0d630a3119fa0c4c$export$c7f0d1a6ee665364);
$parcel$export(module.exports, "doAlignDatesOfReleases", () => $0d630a3119fa0c4c$export$4653b8ba9e3d5d06);
$parcel$export(module.exports, "doViewReleaseInRoadmap", () => $0d630a3119fa0c4c$export$6305f6649b21cb82);
$parcel$export(module.exports, "watchAddVersion", () => $0d630a3119fa0c4c$export$7636f00a67e1b930);
$parcel$export(module.exports, "watchUpdateVersion", () => $0d630a3119fa0c4c$export$919e3b6069d2417d);
$parcel$export(module.exports, "watchDeleteVersion", () => $0d630a3119fa0c4c$export$877c3b6cd35254fd);
$parcel$export(module.exports, "watchAlignDatesOfReleases", () => $0d630a3119fa0c4c$export$37dcd128d22a75be);
$parcel$export(module.exports, "watchViewReleaseInRoadmap", () => $0d630a3119fa0c4c$export$20993805280f607e);
$parcel$export(module.exports, "default", () => $0d630a3119fa0c4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "openProjectReleasesFlyout", () => (parcelRequire("3S4UF")).openFlyout);
$parcel$export(module.exports, "closeProjectReleasesFlyout", () => (parcelRequire("3S4UF")).closeFlyout);
$parcel$export(module.exports, "setModeForCreateUpdateDialog", () => (parcelRequire("ktOon")).setMode);
$parcel$export(module.exports, "openCreateUpdateDialog", () => (parcelRequire("ktOon")).openDialog);
$parcel$export(module.exports, "closeCreateUpdateDialog", () => (parcelRequire("ktOon")).closeDialog);
$parcel$export(module.exports, "openAlignDatesDialog", () => (parcelRequire("iFT7K")).openDialog);
$parcel$export(module.exports, "closeAlignDatesDialog", () => (parcelRequire("iFT7K")).closeDialog);
$parcel$export(module.exports, "openDeleteDialog", () => (parcelRequire("liE2e")).openDialog);
$parcel$export(module.exports, "closeDeleteDialog", () => (parcelRequire("liE2e")).closeDialog);
$parcel$export(module.exports, "CREATE_RELEASE", () => $1e4d809ca7085b17$export$afecb711a599950a);
$parcel$export(module.exports, "EDIT_RELEASE", () => $1e4d809ca7085b17$export$b9385259cf8397cd);

var $8K6YM = parcelRequire("8K6YM");
var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $kXdPE = parcelRequire("kXdPE");

var $jyOCP = parcelRequire("jyOCP");

var $j5GRN = parcelRequire("j5GRN");

var $cbq3D = parcelRequire("cbq3D");

var $296Gg = parcelRequire("296Gg");

var $iTjRl = parcelRequire("iTjRl");

var $2Ruxt = parcelRequire("2Ruxt");
parcelRequire("38iYP");
parcelRequire("3nT5G");

var $75KhQ = parcelRequire("75KhQ");

var $DywVp = parcelRequire("DywVp");

var $gExeY = parcelRequire("gExeY");

var $bEaE7 = parcelRequire("bEaE7");

var $xlOmi = parcelRequire("xlOmi");

var $eBGH3 = parcelRequire("eBGH3");

var $iFT7K = parcelRequire("iFT7K");

var $liE2e = parcelRequire("liE2e");

var $ktOon = parcelRequire("ktOon");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $bipJF = parcelRequire("bipJF");

var $3S4UF = parcelRequire("3S4UF");

// TODO This is a horrendous hack to temporarily workaround mutual dependency between command/versions and command/cross-project-versions via injection at common parent. Proper solution pending.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $0d630a3119fa0c4c$var$versionsCommands = {};
const $0d630a3119fa0c4c$export$2bdfac268df97e49 = 'command.cross-project-versions.ADD_RELEASE';
const $0d630a3119fa0c4c$export$3f90e3abee6e8d70 = 'command.cross-project-versions.UPDATE_RELEASE';
const $0d630a3119fa0c4c$export$440c54a43c85f449 = 'command.cross-project-versions.DELETE_RELEASE';
const $0d630a3119fa0c4c$export$4192fcdf48d80cf0 = 'command.cross-project-versions.ALIGN_DATES_OF_RELEASES';
const $0d630a3119fa0c4c$export$a54e64fcc2f0026f = 'command.cross-project-versions.VIEW_RELEASE_IN_ROADMAP';
const $0d630a3119fa0c4c$export$d7ff8290d1a14fa1 = (version, analyticsEvent)=>({
        type: $0d630a3119fa0c4c$export$2bdfac268df97e49,
        payload: version,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $0d630a3119fa0c4c$export$a5f005f0031c650d = (payload)=>({
        type: $0d630a3119fa0c4c$export$3f90e3abee6e8d70,
        payload: payload
    });
const $0d630a3119fa0c4c$export$41b4061737a08cd = (payload)=>({
        type: $0d630a3119fa0c4c$export$440c54a43c85f449,
        payload: payload
    });
const $0d630a3119fa0c4c$export$bb284c7cbd912e33 = (payload)=>({
        type: $0d630a3119fa0c4c$export$4192fcdf48d80cf0,
        payload: payload
    });
const $0d630a3119fa0c4c$export$4ddde390df08566c = (filterValue)=>({
        type: $0d630a3119fa0c4c$export$a54e64fcc2f0026f,
        payload: filterValue
    });
function* $0d630a3119fa0c4c$export$a9e2c51d05f71323(removedVersion) {
    const { id: id } = removedVersion;
    // Remove cross-project version from removed cross-project versions' list
    yield (0, $9e8i2.put)($bEaE7.remove(id));
    // Add cross-project version to state.domain.cross-project-versions.
    yield (0, $9e8i2.put)($DywVp.add(removedVersion));
}
function* $0d630a3119fa0c4c$export$788bc0a886dbb81f(entityResponse) {
    if (entityResponse.success) {
        const internalEntity = entityResponse.entity?.entity;
        const warnings = yield (0, $9e8i2.call)((0, $j5GRN.inspectForCommitWarnings), internalEntity, entityResponse.error);
        if (warnings.length) yield (0, $9e8i2.put)((0, $eBGH3.add)({
            category: (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE,
            itemId: entityResponse.generatedId ?? entityResponse.itemKey,
            warnings: warnings
        }));
    } else yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE,
        itemId: entityResponse.generatedId ?? entityResponse.itemKey,
        warnings: [
            (0, $j5GRN.defaultWarning)
        ]
    }));
}
function* $0d630a3119fa0c4c$export$3ca5d248d9658375(entityResponse) {
    yield (0, $9e8i2.call)($0d630a3119fa0c4c$export$788bc0a886dbb81f, entityResponse);
    // generatedId is present for an add operation from a scenario object
    const id = entityResponse.itemKey;
    const newId = entityResponse.generatedId ?? id;
    const removedCrossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getRemovedCrossProjectVersionsById));
    const removedCrossProjectVersion = removedCrossProjectVersionsById[id];
    if (newId !== id) {
        yield (0, $9e8i2.put)($DywVp.bulkUpdate({
            [id]: {
                id: newId
            }
        }));
        yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.updateReferences, {
            crossProjectVersion: [
                [
                    id,
                    newId
                ]
            ]
        });
    }
    if ((0, $7CnHa.isDefined)(removedCrossProjectVersion)) {
        yield (0, $9e8i2.put)($bEaE7.remove(id));
        yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.updateReferences, {
            crossProjectVersion: [
                [
                    id,
                    null
                ]
            ]
        });
    }
    const originals = yield (0, $9e8i2.select)((0, $2Ruxt.getOriginalCrossProjectVersions));
    yield (0, $9e8i2.put)($gExeY.reset($8K6YM.default(id, originals)));
}
function* $0d630a3119fa0c4c$export$be623675b8f208ee(id) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, id);
    const response = yield* $iTjRl.json({
        url: (0, $bipJF.urls).revertChanges,
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
    }
    return response;
}
function* $0d630a3119fa0c4c$export$8e127e72248d08(versionId, crossProjectVersionId) {
    const removedCrossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getRemovedCrossProjectVersionsById));
    const removedCrossProjectVersion = removedCrossProjectVersionsById[crossProjectVersionId];
    /** We allow versions, that are part of deleted cross-project version (but not yet committed),
	 *  to be assigned to other cross-project version. So when that change is reverted we have to
	 *  add a version in deleted cross-project version back.
	 */ if ((0, $7CnHa.isDefined)(removedCrossProjectVersion)) // Add a release in crossProjectVersion that is deleted, but not yet committed
    yield (0, $9e8i2.put)($bEaE7.addVersionInCrossProjectVersion({
        crossProjectVersionId: crossProjectVersionId,
        versionId: versionId
    }));
    else // Add a new release in crossProjectVersion that it belongs to.
    yield (0, $9e8i2.put)($DywVp.addVersionInCrossProjectVersion({
        crossProjectVersionId: crossProjectVersionId,
        versionId: versionId
    }));
}
function* $0d630a3119fa0c4c$export$ac89d6cd5251dbf4(versionId, crossProjectVersionId) {
    const removedCrossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getRemovedCrossProjectVersionsById));
    const removedCrossProjectVersion = removedCrossProjectVersionsById[crossProjectVersionId];
    /** We allow versions, that are part of deleted cross-project version (but not yet committed),
	 *  to be assigned to other cross-project version. So when that change is reverted we have to
	 *  add a version in deleted cross-project version back.
	 */ if ((0, $7CnHa.isDefined)(removedCrossProjectVersion)) // Remove a release from crossProjectVersion that is deleted, but not yet committed
    yield (0, $9e8i2.put)($bEaE7.removeVersionFromCrossProjectVersion({
        crossProjectVersionId: crossProjectVersionId,
        versionId: versionId
    }));
    else // Remove a release from crossProjectVersion
    yield (0, $9e8i2.put)($DywVp.removeVersionFromCrossProjectVersion({
        crossProjectVersionId: crossProjectVersionId,
        versionId: versionId
    }));
}
function* $0d630a3119fa0c4c$export$3b6da5955bae8c75({ id: id, name: name, versions: versions }) {
    // Add a new release to state.domain.versions.
    yield (0, $9e8i2.put)($DywVp.add({
        id: id,
        name: name,
        versions: []
    }));
    // Update crossProjectVersion in each version.
    for (const versionId of versions){
        const patch = {
            versionId: versionId,
            patch: {
                crossProjectVersion: id
            }
        };
        yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.updateVersion, patch);
    }
}
function* $0d630a3119fa0c4c$export$4bbfd299114d60db(versionId) {
    // Remove a cross-project release from state.domain.cross-project-versions
    yield (0, $9e8i2.put)($DywVp.remove(versionId));
    // Revert crossProjectVersion in each version.
    yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.revertReferences, {
        crossProjectVersion: [
            versionId
        ]
    });
    // Remove cross-project version from original cross-project versions as we don't commit such changes
    const originals = yield (0, $9e8i2.select)((0, $2Ruxt.getOriginalCrossProjectVersions));
    yield (0, $9e8i2.put)($gExeY.reset($8K6YM.default(versionId, originals)));
}
function* $0d630a3119fa0c4c$export$740de856a6989843({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $ktOon.initiateRequest)());
    try {
        const url = (0, $bipJF.urls).update;
        const body = (0, $bipJF.updateVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { versionId: versionId, patch: patch } = payload;
            const crossProjectVersionsById = yield (0, $9e8i2.select)((0, $2Ruxt.getCrossProjectVersionsById));
            const { name: originalName } = crossProjectVersionsById[versionId];
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield* (0, $kXdPE.default)(function*() {
                // Update a release in client-side model
                yield (0, $9e8i2.put)($DywVp.bulkUpdate({
                    [versionId]: patch
                }));
                /** Update the original cross-project versions model so that it shows updated release in
				 *  the update-jira dialog.
				 */ yield (0, $9e8i2.put)($gExeY.update({
                    id: versionId,
                    values: {
                        name: originalName
                    }
                }));
                // Update the sequence
                yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
                // Close the update release dialog
                yield (0, $9e8i2.put)((0, $ktOon.closeDialog)());
            });
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $ktOon.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $ktOon.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $0d630a3119fa0c4c$export$476de812fbbb6302({ name: name, versions: versions }, newVersionId, sequence) {
    yield* (0, $kXdPE.default)(function*() {
        // Add a new release to client-side model
        yield (0, $9e8i2.call)($0d630a3119fa0c4c$export$3b6da5955bae8c75, {
            id: newVersionId,
            name: name,
            versions: versions
        });
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        /** Update the original cross-project versions model so that it shows newly added release in
		 *  the update-jira dialog.
		 */ yield (0, $9e8i2.put)($gExeY.update({
            id: newVersionId,
            values: {}
        }));
        // Close the create release dialog
        yield (0, $9e8i2.put)((0, $ktOon.closeDialog)());
    });
}
function* $0d630a3119fa0c4c$export$89ca6b91461e4dc({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $ktOon.initiateRequest)());
    try {
        const url = (0, $bipJF.urls).add;
        const body = (0, $bipJF.addVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { itemKey: itemKey, change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($0d630a3119fa0c4c$export$476de812fbbb6302, payload, itemKey, sequence);
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $ktOon.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $ktOon.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $0d630a3119fa0c4c$export$ed51d7a10005fa33(crossProjectVersion, sequence) {
    yield* (0, $kXdPE.default)(function*() {
        if (crossProjectVersion.id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) // Remove cross-project version from store
        yield (0, $9e8i2.call)($0d630a3119fa0c4c$export$4bbfd299114d60db, crossProjectVersion.id);
        else {
            // Remove a cross-project release from state.domain.cross-project-versions
            yield (0, $9e8i2.put)($DywVp.remove(crossProjectVersion.id));
            // Add a cross-project release in state.domain.removed-cross-project-versions
            yield (0, $9e8i2.put)($bEaE7.add(crossProjectVersion));
            /** Update the original cross-project versions model so that it shows deleted release in
			 *  the update-jira dialog.
			 */ yield (0, $9e8i2.put)($gExeY.update({
                id: crossProjectVersion.id,
                values: {}
            }));
        }
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        // Close the delete release dialog
        yield (0, $9e8i2.put)((0, $liE2e.closeDialog)());
    });
}
function* $0d630a3119fa0c4c$export$c7f0d1a6ee665364({ payload: payload }) {
    const { crossProjectVersion: crossProjectVersion, doesRemoveVersions: doesRemoveVersions } = payload;
    yield (0, $9e8i2.put)((0, $liE2e.initiateRequest)());
    try {
        const url = (0, $bipJF.urls).delete;
        const body = (0, $bipJF.deleteVersionBody)((yield (0, $9e8i2.select)((0, $75KhQ.getPlan))), payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($0d630a3119fa0c4c$export$ed51d7a10005fa33, crossProjectVersion, sequence);
            if (doesRemoveVersions) {
                const { versions: versions } = crossProjectVersion;
                for (const versionId of versions)if (versionId.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX))) yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.updateStateAfterDeletingVersion, versionId, sequence);
                else yield (0, $9e8i2.call)($0d630a3119fa0c4c$var$versionsCommands.updateStateAfterRemovingVersion, versionId, sequence);
            }
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
        yield (0, $9e8i2.put)((0, $liE2e.resetRequest)());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $liE2e.resetRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $0d630a3119fa0c4c$export$4653b8ba9e3d5d06({ payload: payload }) {
    const { versions: versions, patch: patch } = payload;
    yield (0, $9e8i2.put)((0, $iFT7K.initiateRequest)());
    for (const versionId of versions){
        const patchConfig = {
            versionId: versionId,
            patch: patch
        };
        yield (0, $9e8i2.put)($0d630a3119fa0c4c$var$versionsCommands.updateRelease(patchConfig));
    }
    yield (0, $9e8i2.put)((0, $iFT7K.resetRequest)());
    yield (0, $9e8i2.put)((0, $iFT7K.closeDialog)());
}
function* $0d630a3119fa0c4c$export$6305f6649b21cb82({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$53e2f8996e102881)));
    yield (0, $9e8i2.put)((0, $296Gg.change)({
        id: (0, $12ee831723ccf9c2$export$585fb3e81bcfccad),
        value: payload
    }));
}
function* $0d630a3119fa0c4c$export$7636f00a67e1b930() {
    yield (0, $bG7pV.takeEvery)($0d630a3119fa0c4c$export$2bdfac268df97e49, $0d630a3119fa0c4c$export$89ca6b91461e4dc);
}
function* $0d630a3119fa0c4c$export$919e3b6069d2417d() {
    yield (0, $bG7pV.takeEvery)($0d630a3119fa0c4c$export$3f90e3abee6e8d70, $0d630a3119fa0c4c$export$740de856a6989843);
}
function* $0d630a3119fa0c4c$export$877c3b6cd35254fd() {
    yield (0, $bG7pV.takeEvery)($0d630a3119fa0c4c$export$440c54a43c85f449, $0d630a3119fa0c4c$export$c7f0d1a6ee665364);
}
function* $0d630a3119fa0c4c$export$37dcd128d22a75be() {
    yield (0, $bG7pV.takeEvery)($0d630a3119fa0c4c$export$4192fcdf48d80cf0, $0d630a3119fa0c4c$export$4653b8ba9e3d5d06);
}
function* $0d630a3119fa0c4c$export$20993805280f607e() {
    yield (0, $bG7pV.takeEvery)($0d630a3119fa0c4c$export$a54e64fcc2f0026f, $0d630a3119fa0c4c$export$6305f6649b21cb82);
}
function $0d630a3119fa0c4c$export$2e2bcd8739ae039(versionCommandsModule) {
    $0d630a3119fa0c4c$var$versionsCommands = versionCommandsModule;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function*() {
        yield (0, $9e8i2.fork)($0d630a3119fa0c4c$export$7636f00a67e1b930);
        yield (0, $9e8i2.fork)($0d630a3119fa0c4c$export$919e3b6069d2417d);
        yield (0, $9e8i2.fork)($0d630a3119fa0c4c$export$877c3b6cd35254fd);
        yield (0, $9e8i2.fork)($0d630a3119fa0c4c$export$37dcd128d22a75be);
        yield (0, $9e8i2.fork)($0d630a3119fa0c4c$export$20993805280f607e);
    };
}

});
parcelRegister("bEaE7", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $179dd9a43733a95c$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $179dd9a43733a95c$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $179dd9a43733a95c$export$29d55e1f664a246b);
$parcel$export(module.exports, "ADD_VERSION_IN_CROSS_PROJECT_VERSION", () => $179dd9a43733a95c$export$5bb382b7a9364fa0);
$parcel$export(module.exports, "REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION", () => $179dd9a43733a95c$export$cfd29272fccd14f8);
$parcel$export(module.exports, "reset", () => $179dd9a43733a95c$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $179dd9a43733a95c$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $179dd9a43733a95c$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "addVersionInCrossProjectVersion", () => $179dd9a43733a95c$export$8e127e72248d08);
$parcel$export(module.exports, "removeVersionFromCrossProjectVersion", () => $179dd9a43733a95c$export$ac89d6cd5251dbf4);
const $179dd9a43733a95c$export$4a991c87e640ef77 = 'state.domain.removed-cross-project-versions.RESET';
const $179dd9a43733a95c$export$bb6389024b71c2ae = 'state.domain.removed-cross-project-versions.ADD';
const $179dd9a43733a95c$export$29d55e1f664a246b = 'state.domain.removed-cross-project-versions.REMOVE';
const $179dd9a43733a95c$export$5bb382b7a9364fa0 = 'state.domain.removed-cross-project-versions.ADD_VERSION_IN_CROSS_PROJECT_VERSION';
const $179dd9a43733a95c$export$cfd29272fccd14f8 = 'state.domain.removed-cross-project-versions.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION';
const $179dd9a43733a95c$export$aad8462122ac592b = (payload)=>({
        type: $179dd9a43733a95c$export$4a991c87e640ef77,
        payload: payload
    });
const $179dd9a43733a95c$export$e16d8520af44a096 = (payload)=>({
        type: $179dd9a43733a95c$export$bb6389024b71c2ae,
        payload: payload
    });
const $179dd9a43733a95c$export$cd7f480d6b8286c3 = (versionId)=>({
        type: $179dd9a43733a95c$export$29d55e1f664a246b,
        versionId: versionId
    });
const $179dd9a43733a95c$export$8e127e72248d08 = (payload)=>({
        type: $179dd9a43733a95c$export$5bb382b7a9364fa0,
        payload: payload
    });
const $179dd9a43733a95c$export$ac89d6cd5251dbf4 = (payload)=>({
        type: $179dd9a43733a95c$export$cfd29272fccd14f8,
        payload: payload
    });

});

parcelRegister("iFT7K", function(module, exports) {

$parcel$export(module.exports, "OPEN_DIALOG", () => $94a2d95516df2d42$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $94a2d95516df2d42$export$194b247a9d6170da);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $94a2d95516df2d42$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $94a2d95516df2d42$export$31889003e5372a7f);
$parcel$export(module.exports, "openDialog", () => $94a2d95516df2d42$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $94a2d95516df2d42$export$34bf1befb2fab61a);
$parcel$export(module.exports, "initiateRequest", () => $94a2d95516df2d42$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $94a2d95516df2d42$export$b38f09eddeeb56fb);
const $94a2d95516df2d42$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.SET_MODE';
const $94a2d95516df2d42$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.OPEN_DIALOG';
const $94a2d95516df2d42$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.CLOSE_DIALOG';
const $94a2d95516df2d42$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.INITIATE_REQUEST';
const $94a2d95516df2d42$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.align-dates-dialog.RESET_REQUEST';
const $94a2d95516df2d42$export$45f11db5513b93db = (versionId)=>({
        type: $94a2d95516df2d42$export$fb283a8049ce78e7,
        versionId: versionId
    });
const $94a2d95516df2d42$export$34bf1befb2fab61a = ()=>({
        type: $94a2d95516df2d42$export$194b247a9d6170da
    });
const $94a2d95516df2d42$export$82f68a404cfea29 = ()=>({
        type: $94a2d95516df2d42$export$4580e708995fb75f
    });
const $94a2d95516df2d42$export$b38f09eddeeb56fb = ()=>({
        type: $94a2d95516df2d42$export$31889003e5372a7f
    });

});

parcelRegister("liE2e", function(module, exports) {

$parcel$export(module.exports, "OPEN_DIALOG", () => $0853ffaf210c1797$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $0853ffaf210c1797$export$194b247a9d6170da);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $0853ffaf210c1797$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $0853ffaf210c1797$export$31889003e5372a7f);
$parcel$export(module.exports, "openDialog", () => $0853ffaf210c1797$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $0853ffaf210c1797$export$34bf1befb2fab61a);
$parcel$export(module.exports, "initiateRequest", () => $0853ffaf210c1797$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $0853ffaf210c1797$export$b38f09eddeeb56fb);
const $0853ffaf210c1797$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.OPEN_DIALOG';
const $0853ffaf210c1797$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.CLOSE_DIALOG';
const $0853ffaf210c1797$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.INITIATE_REQUEST';
const $0853ffaf210c1797$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.delete-release-dialog.RESET_REQUEST';
const $0853ffaf210c1797$export$45f11db5513b93db = (versionId)=>({
        type: $0853ffaf210c1797$export$fb283a8049ce78e7,
        versionId: versionId
    });
const $0853ffaf210c1797$export$34bf1befb2fab61a = ()=>({
        type: $0853ffaf210c1797$export$194b247a9d6170da
    });
const $0853ffaf210c1797$export$82f68a404cfea29 = ()=>({
        type: $0853ffaf210c1797$export$4580e708995fb75f
    });
const $0853ffaf210c1797$export$b38f09eddeeb56fb = ()=>({
        type: $0853ffaf210c1797$export$31889003e5372a7f
    });

});

parcelRegister("ktOon", function(module, exports) {

$parcel$export(module.exports, "SET_MODE", () => $87a10044e18fd4aa$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "OPEN_DIALOG", () => $87a10044e18fd4aa$export$fb283a8049ce78e7);
$parcel$export(module.exports, "CLOSE_DIALOG", () => $87a10044e18fd4aa$export$194b247a9d6170da);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $87a10044e18fd4aa$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $87a10044e18fd4aa$export$31889003e5372a7f);
$parcel$export(module.exports, "setMode", () => $87a10044e18fd4aa$export$d4f039427a1beff1);
$parcel$export(module.exports, "openDialog", () => $87a10044e18fd4aa$export$45f11db5513b93db);
$parcel$export(module.exports, "closeDialog", () => $87a10044e18fd4aa$export$34bf1befb2fab61a);
$parcel$export(module.exports, "initiateRequest", () => $87a10044e18fd4aa$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $87a10044e18fd4aa$export$b38f09eddeeb56fb);
const $87a10044e18fd4aa$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.SET_MODE';
const $87a10044e18fd4aa$export$fb283a8049ce78e7 = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.OPEN_DIALOG';
const $87a10044e18fd4aa$export$194b247a9d6170da = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.CLOSE_DIALOG';
const $87a10044e18fd4aa$export$4580e708995fb75f = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.INITIATE_REQUEST';
const $87a10044e18fd4aa$export$31889003e5372a7f = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.RESET_REQUEST';
const $87a10044e18fd4aa$export$d4f039427a1beff1 = (payload)=>({
        type: $87a10044e18fd4aa$export$27a86d4a6fd7f204,
        payload: payload
    });
const $87a10044e18fd4aa$export$45f11db5513b93db = (versionId = null)=>({
        type: $87a10044e18fd4aa$export$fb283a8049ce78e7,
        payload: {
            versionId: versionId
        }
    });
const $87a10044e18fd4aa$export$34bf1befb2fab61a = ()=>({
        type: $87a10044e18fd4aa$export$194b247a9d6170da
    });
const $87a10044e18fd4aa$export$82f68a404cfea29 = ()=>({
        type: $87a10044e18fd4aa$export$4580e708995fb75f
    });
const $87a10044e18fd4aa$export$b38f09eddeeb56fb = ()=>({
        type: $87a10044e18fd4aa$export$31889003e5372a7f
    });

});

parcelRegister("bipJF", function(module, exports) {

$parcel$export(module.exports, "urls", () => $3d95d816d6f6fa04$export$bcae9ba627f604b6);
$parcel$export(module.exports, "addVersionBody", () => $3d95d816d6f6fa04$export$a19bf42e0b3d7082);
$parcel$export(module.exports, "updateVersionBody", () => $3d95d816d6f6fa04$export$80a1d0573753ab10);
$parcel$export(module.exports, "deleteVersionBody", () => $3d95d816d6f6fa04$export$4c6bb7db8f86d168);
const $3d95d816d6f6fa04$export$bcae9ba627f604b6 = {
    add: '/rest/jpo/1.0/xprojectversions/add',
    update: '/rest/jpo/1.0/xprojectversions/update',
    delete: '/rest/jpo/1.0/xprojectversions/delete',
    revertChanges: '/rest/jpo/1.0/xprojectversions/revert'
};
const $3d95d816d6f6fa04$export$a19bf42e0b3d7082 = (plan, { name: name, versions: versions })=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    return {
        planId: planId,
        scenarioId: scenarioId,
        description: {
            name: {
                value: name
            }
        },
        versions: versions
    };
};
const $3d95d816d6f6fa04$export$80a1d0573753ab10 = (plan, { versionId: versionId, patch: patch })=>{
    const { id: planId, currentScenarioId: scenarioId } = plan;
    return {
        planId: planId,
        scenarioId: scenarioId,
        itemKeys: [
            versionId
        ],
        description: {
            name: {
                value: patch.name
            }
        }
    };
};
const $3d95d816d6f6fa04$export$4c6bb7db8f86d168 = ({ id: planId, currentScenarioId: scenarioId }, { crossProjectVersion: crossProjectVersion, doesRemoveVersions: doesRemoveVersions })=>{
    const { id: versionId, versions: projectVersions } = crossProjectVersion;
    if (doesRemoveVersions) return {
        itemKeys: [
            versionId
        ],
        planId: planId,
        scenarioId: scenarioId,
        versionItemKeys: projectVersions
    };
    return {
        itemKeys: [
            versionId
        ],
        planId: planId,
        scenarioId: scenarioId
    };
};

});

parcelRegister("3S4UF", function(module, exports) {

$parcel$export(module.exports, "OPEN_FLYOUT", () => $2e60a83fad2a2d59$export$aece46899d04da75);
$parcel$export(module.exports, "CLOSE_FLYOUT", () => $2e60a83fad2a2d59$export$818850ad86c540b1);
$parcel$export(module.exports, "openFlyout", () => $2e60a83fad2a2d59$export$a297e31c5d8808a1);
$parcel$export(module.exports, "closeFlyout", () => $2e60a83fad2a2d59$export$7670f8956d89067d);
const $2e60a83fad2a2d59$export$aece46899d04da75 = 'state.ui.main.tabs.releases.cross-project-releases.releases-table.project-releases.OPEN_FLYOUT';
const $2e60a83fad2a2d59$export$818850ad86c540b1 = 'state.ui.main.tabs.releases.cross-project-releases.releases-table.project-releases.CLOSE_FLYOUT';
const $2e60a83fad2a2d59$export$a297e31c5d8808a1 = (crossProjectVersionId)=>({
        type: $2e60a83fad2a2d59$export$aece46899d04da75,
        payload: {
            crossProjectVersionId: crossProjectVersionId
        }
    });
const $2e60a83fad2a2d59$export$7670f8956d89067d = ()=>({
        type: $2e60a83fad2a2d59$export$818850ad86c540b1
    });

});

const $1e4d809ca7085b17$export$afecb711a599950a = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.CREATE_RELEASE';
const $1e4d809ca7085b17$export$b9385259cf8397cd = 'state.ui.main.tabs.releases.cross-project-releases.release-dialog.EDIT_RELEASE';


parcelRegister("2L2I7", function(module, exports) {

$parcel$export(module.exports, "update", () => $1c132dae0de14edf$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $1c132dae0de14edf$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "handlePlannedCapacityBulkCommitResponse", () => $1c132dae0de14edf$export$8b600fda5e69f9a2);
$parcel$export(module.exports, "revertPlannedCapacityChange", () => $1c132dae0de14edf$export$980a5ed5057b9945);
$parcel$export(module.exports, "default", () => $1c132dae0de14edf$export$2e2bcd8739ae039);

var $li3lI = parcelRequire("li3lI");
var $7WzTP = parcelRequire("7WzTP");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $1ybV0 = parcelRequire("1ybV0");

var $kP3Wn = parcelRequire("kP3Wn");

var $kXdPE = parcelRequire("kXdPE");

var $jyOCP = parcelRequire("jyOCP");

var $cbq3D = parcelRequire("cbq3D");

var $iTjRl = parcelRequire("iTjRl");

var $75KhQ = parcelRequire("75KhQ");

var $c1XMU = parcelRequire("c1XMU");

var $eDYLe = parcelRequire("eDYLe");

var $4dybm = parcelRequire("4dybm");

var $gwmQW = parcelRequire("gwmQW");

var $xlOmi = parcelRequire("xlOmi");

var $eBGH3 = parcelRequire("eBGH3");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $fzFrt = parcelRequire("fzFrt");

var $h5Yb6 = parcelRequire("h5Yb6");
const $1c132dae0de14edf$export$e271b26eefe41db8 = 'command.planned-capacities.UPDATE';
const $1c132dae0de14edf$export$4a991c87e640ef77 = 'command.planned-capacities.RESET';
const $1c132dae0de14edf$export$29d55e1f664a246b = 'command.planned-capacities.REMOVE';
const $1c132dae0de14edf$export$aad8462122ac592b = (payload)=>({
        type: $1c132dae0de14edf$export$4a991c87e640ef77,
        payload: payload
    });
const $1c132dae0de14edf$export$722fbec263ad908a = (payload)=>({
        type: $1c132dae0de14edf$export$e271b26eefe41db8,
        payload: payload
    });
const $1c132dae0de14edf$export$cd7f480d6b8286c3 = (payload)=>({
        type: $1c132dae0de14edf$export$29d55e1f664a246b,
        payload: payload
    });
function* $1c132dae0de14edf$export$4884fd84d9484e78(// eslint-disable-next-line @typescript-eslint/no-explicit-any
block, promise) {
    if (!promise || !promise?.resolve || !promise?.reject) return yield (0, $9e8i2.call)(block);
    try {
        const result = yield (0, $9e8i2.call)(block);
        promise.resolve(result); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        promise.reject(err);
    }
}
function* $1c132dae0de14edf$export$8b600fda5e69f9a2(entityResponse, plannedCapacityChange) {
    // We need to query the actual value here so we know if we added/updated a capacity
    // or if we removed it
    const capacitySelectorProps = $7WzTP.default([
        'teamId',
        'iterationId'
    ], plannedCapacityChange.values);
    const currentPlannedCapacity = yield (0, $9e8i2.select)((0, $c1XMU.getCapacityForTeamAndIteration), capacitySelectorProps);
    const wasRemoved = !currentPlannedCapacity;
    const id = entityResponse.itemKey;
    const newId = entityResponse.generatedId;
    // Check if the capacity has a new ID that must replace the old one
    // (happens when a capacity change in the scenario is committed for the first time)
    const hasNewId = (0, $7CnHa.isDefined)(newId) && id !== newId;
    if (!wasRemoved && hasNewId) // Update state with the new item key
    yield (0, $9e8i2.put)((0, $gwmQW.update)({
        ...plannedCapacityChange.values,
        itemKey: newId
    }));
    const { teamId: teamId, iterationId: iterationId } = plannedCapacityChange.values;
    const originals = yield (0, $9e8i2.select)((0, $c1XMU.getOriginalPlannedCapacities));
    yield (0, $9e8i2.put)((0, $4dybm.reset)($li3lI.default([
        teamId,
        iterationId
    ], originals)));
}
function* $1c132dae0de14edf$export$980a5ed5057b9945(plannedCapacityChange) {
    const { id: planId, currentScenarioId: currentScenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const sequence = yield (0, $9e8i2.select)((0, $eDYLe.getSequence));
    if (!(0, $7CnHa.isDefined)(plannedCapacityChange.values.itemKey)) return;
    if (!(0, $7CnHa.isDefined)(planId)) return;
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, plannedCapacityChange.values.itemKey);
    // We need to query out the original here, instead of getting it from plannedCapacityChange,
    // because we need to know if the original capacity value is NULL (i.e. default). Whereas
    // `plannedCapacityChange.originals.capacity` will be resolved to an actual number, so
    // there's no way to know if we're reverting back to that number or to NULL.
    const capacitySelectorProps = $7WzTP.default([
        'teamId',
        'iterationId'
    ], plannedCapacityChange.values);
    const original = yield (0, $9e8i2.select)((0, $c1XMU.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
    const { iterationId: iterationId } = plannedCapacityChange.values;
    const response = yield (0, $9e8i2.call)((0, $iTjRl.jsonOrError), {
        url: (0, $fzFrt.urls).revertPlannedCapacity,
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        if (original.capacity === null) {
            const removePayload = $7WzTP.default([
                'teamId',
                'iterationId'
            ], plannedCapacityChange.values);
            yield (0, $9e8i2.put)((0, $gwmQW.remove)(removePayload));
        } else yield (0, $9e8i2.put)((0, $gwmQW.update)(original));
    } else yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).PLANNED_CAPACITY,
        itemId: iterationId,
        warnings: [
            (0, $h5Yb6.warning)
        ]
    }));
    return response;
}
const $1c132dae0de14edf$export$6b79266acc025ac2 = (action)=>{
    const payload = {
        teamKey: {
            value: action.payload.teamId
        },
        iterationId: {
            value: parseInt(action.payload.iterationId, 10)
        },
        schedulingMode: {
            value: action.payload.schedulingMode
        },
        planningUnit: {
            value: action.payload.planningUnit
        },
        capacity: {
            value: action.payload.capacity
        }
    };
    return payload;
};
function* $1c132dae0de14edf$export$5e3deeaaf3eca751(action) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    if (!(0, $7CnHa.isDefined)(planId)) return;
    const capacitySelectorProps = $7WzTP.default([
        'teamId',
        'iterationId'
    ], action.payload);
    const original = yield (0, $9e8i2.select)((0, $c1XMU.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
    const currentPlannedCapacity = yield (0, $9e8i2.select)((0, $c1XMU.getCapacityForTeamAndIteration), capacitySelectorProps);
    const isAddingNewCapacity = !original && !currentPlannedCapacity;
    let originalUpdatePayload;
    if (!original) {
        if (currentPlannedCapacity) originalUpdatePayload = currentPlannedCapacity;
        else originalUpdatePayload = {
            ...action.payload,
            capacity: null
        };
        yield (0, $9e8i2.put)((0, $4dybm.update)(originalUpdatePayload));
    } else originalUpdatePayload = original;
    const endpoint = isAddingNewCapacity ? (0, $fzFrt.urls).addPlannedCapacity : (0, $fzFrt.urls).updatePlannedCapacity;
    const { itemKey: itemKey } = isAddingNewCapacity ? {} : currentPlannedCapacity || original || {};
    // Pre response update (better User experience) so they dont see the request lag
    yield (0, $9e8i2.put)((0, $gwmQW.update)({
        ...action.payload,
        itemKey: itemKey
    }));
    const response = yield (0, $9e8i2.call)((0, $iTjRl.jsonOrError), {
        url: endpoint,
        method: (0, $kP3Wn.POST),
        body: {
            planId: planId,
            scenarioId: scenarioId,
            itemKey: itemKey,
            description: $1c132dae0de14edf$export$6b79266acc025ac2(action)
        }
    });
    if (response.ok) {
        const { itemKey: // eslint-disable-next-line @typescript-eslint/no-shadow
        itemKey, change: { sequence: sequence } } = response.data;
        yield* (0, $kXdPE.default)(function*() {
            // Update the sequence
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            // If we've created a new planned capacity, set the itemKey in redux
            if (isAddingNewCapacity) {
                yield (0, $9e8i2.put)((0, $4dybm.update)({
                    ...originalUpdatePayload,
                    itemKey: itemKey
                }));
                yield (0, $9e8i2.put)((0, $gwmQW.update)({
                    ...action.payload,
                    itemKey: itemKey
                }));
            }
        });
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && response.data) return response.data;
    } else {
        const { error: error } = response.data;
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: error
        }));
    }
}
function* $1c132dae0de14edf$export$d28ae27ab8b30e55(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($1c132dae0de14edf$export$4884fd84d9484e78, function*() {
        return yield (0, $9e8i2.call)($1c132dae0de14edf$export$5e3deeaaf3eca751, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $1c132dae0de14edf$export$2cdaaf942b1444db(action) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const capacitySelectorProps = $7WzTP.default([
        'teamId',
        'iterationId'
    ], action.payload);
    const currentPlannedCapacity = yield (0, $9e8i2.select)((0, $c1XMU.getCapacityForTeamAndIteration), capacitySelectorProps);
    const original = yield (0, $9e8i2.select)((0, $c1XMU.getOriginalCapacityForTeamAndIteration), capacitySelectorProps);
    if (!(0, $7CnHa.isDefined)(planId)) return;
    if (!currentPlannedCapacity) return;
    if (!original) {
        const clone = yield (0, $9e8i2.select)((0, $c1XMU.getCapacityForTeamAndIteration), capacitySelectorProps);
        if (clone) yield (0, $9e8i2.put)((0, $4dybm.update)(clone));
    }
    yield (0, $9e8i2.put)((0, $gwmQW.remove)(capacitySelectorProps));
    if (original && original.capacity === null) // original planned capacity is actually the default value
    yield (0, $9e8i2.put)((0, $4dybm.remove)(capacitySelectorProps));
    const response = yield (0, $9e8i2.call)((0, $iTjRl.jsonOrError), {
        url: (0, $fzFrt.urls).deletePlannedCapacity,
        method: (0, $kP3Wn.POST),
        body: {
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: [
                currentPlannedCapacity.itemKey
            ]
        }
    });
    if (response.ok) {
        const { change: { sequence: sequence } } = response.data;
        // Update the sequence
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && response.data) return response.data;
    } else {
        const { error: error } = response.data;
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: error
        }));
    }
}
function* $1c132dae0de14edf$export$7ff84668db579d28(action) {
    const { payload: { promise: promise, ...payload }, type: type } = action;
    yield (0, $9e8i2.call)($1c132dae0de14edf$export$4884fd84d9484e78, function*() {
        return yield (0, $9e8i2.call)($1c132dae0de14edf$export$2cdaaf942b1444db, {
            type: type,
            payload: payload
        });
    }, promise);
}
function* $1c132dae0de14edf$export$95a8c56f6b8521b1() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($1c132dae0de14edf$export$e271b26eefe41db8, $1c132dae0de14edf$export$d28ae27ab8b30e55);
    else yield (0, $bG7pV.takeEvery)($1c132dae0de14edf$export$e271b26eefe41db8, $1c132dae0de14edf$export$5e3deeaaf3eca751);
}
function* $1c132dae0de14edf$export$ebb3588e2061e641() {
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) yield (0, $bG7pV.takeEvery)($1c132dae0de14edf$export$29d55e1f664a246b, $1c132dae0de14edf$export$7ff84668db579d28);
    else yield (0, $bG7pV.takeEvery)($1c132dae0de14edf$export$29d55e1f664a246b, $1c132dae0de14edf$export$2cdaaf942b1444db);
}
function* $1c132dae0de14edf$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($1c132dae0de14edf$export$95a8c56f6b8521b1);
    yield (0, $9e8i2.fork)($1c132dae0de14edf$export$ebb3588e2061e641);
}

});
parcelRegister("4dybm", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $91e044e19c2f98f2$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $91e044e19c2f98f2$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $91e044e19c2f98f2$export$29d55e1f664a246b);
$parcel$export(module.exports, "UPDATE_TEAM_ID", () => $91e044e19c2f98f2$export$3375e6b8e0671d88);
$parcel$export(module.exports, "reset", () => $91e044e19c2f98f2$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $91e044e19c2f98f2$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $91e044e19c2f98f2$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updateTeamId", () => $91e044e19c2f98f2$export$3d88424f2784ccca);
const $91e044e19c2f98f2$export$4a991c87e640ef77 = 'state.domain.original-planned-capacities.RESET';
const $91e044e19c2f98f2$export$e271b26eefe41db8 = 'state.domain.original-planned-capacities.UPDATE';
const $91e044e19c2f98f2$export$29d55e1f664a246b = 'state.domain.original-planned-capacities.REMOVE';
const $91e044e19c2f98f2$export$3375e6b8e0671d88 = 'state.domain.original-planned-capacities.UPDATE_TEAM_ID';
const $91e044e19c2f98f2$export$aad8462122ac592b = (payload)=>({
        type: $91e044e19c2f98f2$export$4a991c87e640ef77,
        payload: payload
    });
const $91e044e19c2f98f2$export$722fbec263ad908a = (payload)=>({
        type: $91e044e19c2f98f2$export$e271b26eefe41db8,
        payload: payload
    });
const $91e044e19c2f98f2$export$cd7f480d6b8286c3 = (payload)=>({
        type: $91e044e19c2f98f2$export$29d55e1f664a246b,
        payload: payload
    });
const $91e044e19c2f98f2$export$3d88424f2784ccca = (payload)=>({
        type: $91e044e19c2f98f2$export$3375e6b8e0671d88,
        payload: payload
    });

});

parcelRegister("gwmQW", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $97e2bbce80ee77cf$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $97e2bbce80ee77cf$export$e271b26eefe41db8);
$parcel$export(module.exports, "REMOVE", () => $97e2bbce80ee77cf$export$29d55e1f664a246b);
$parcel$export(module.exports, "UPDATE_TEAM_ID", () => $97e2bbce80ee77cf$export$3375e6b8e0671d88);
$parcel$export(module.exports, "reset", () => $97e2bbce80ee77cf$export$aad8462122ac592b);
$parcel$export(module.exports, "update", () => $97e2bbce80ee77cf$export$722fbec263ad908a);
$parcel$export(module.exports, "remove", () => $97e2bbce80ee77cf$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updateTeamId", () => $97e2bbce80ee77cf$export$3d88424f2784ccca);
const $97e2bbce80ee77cf$export$4a991c87e640ef77 = 'state.domain.planned-capacities.RESET';
const $97e2bbce80ee77cf$export$e271b26eefe41db8 = 'state.domain.planned-capacities.UPDATE';
const $97e2bbce80ee77cf$export$29d55e1f664a246b = 'state.domain.planned-capacities.REMOVE';
const $97e2bbce80ee77cf$export$3375e6b8e0671d88 = 'state.domain.planned-capacities.UPDATE_TEAM_ID';
const $97e2bbce80ee77cf$export$aad8462122ac592b = (payload)=>({
        type: $97e2bbce80ee77cf$export$4a991c87e640ef77,
        payload: payload
    });
const $97e2bbce80ee77cf$export$722fbec263ad908a = (payload)=>({
        type: $97e2bbce80ee77cf$export$e271b26eefe41db8,
        payload: payload
    });
const $97e2bbce80ee77cf$export$cd7f480d6b8286c3 = (payload)=>({
        type: $97e2bbce80ee77cf$export$29d55e1f664a246b,
        payload: payload
    });
const $97e2bbce80ee77cf$export$3d88424f2784ccca = (payload)=>({
        type: $97e2bbce80ee77cf$export$3375e6b8e0671d88,
        payload: payload
    });

});

parcelRegister("fzFrt", function(module, exports) {

$parcel$export(module.exports, "urls", () => $d0f55bf04b62f2f4$export$bcae9ba627f604b6);
const $d0f55bf04b62f2f4$export$bcae9ba627f604b6 = {
    addPlannedCapacity: '/rest/jpo/1.0/plannedcapacity/add',
    updatePlannedCapacity: '/rest/jpo/1.0/plannedcapacity/update',
    deletePlannedCapacity: '/rest/jpo/1.0/plannedcapacity/delete',
    revertPlannedCapacity: '/rest/jpo/1.0/plannedcapacity/revert'
};

});

parcelRegister("h5Yb6", function(module, exports) {

$parcel$export(module.exports, "warning", () => $764a63f0d5cd506b$export$491112666e282270);

var $90IgZ = parcelRequire("90IgZ");
const $764a63f0d5cd506b$var$messages = (0, $90IgZ.defineMessages)({
    defaultWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.planned-capacities.default-warning-header",
        "defaultMessage": "Could not be committed for unknown reasons."
    },
    defaultWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.planned-capacities.default-warning-content",
        "defaultMessage": "Sprint capacity could not be committed for unknown reasons. Please contact your administrator."
    }
});
const $764a63f0d5cd506b$export$491112666e282270 = {
    header: $764a63f0d5cd506b$var$messages.defaultWarningHeader,
    message: $764a63f0d5cd506b$var$messages.defaultWarningContent,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    messageValues: {}
};
var $764a63f0d5cd506b$export$2e2bcd8739ae039 = $764a63f0d5cd506b$var$messages;

});


parcelRegister("1C7Mn", function(module, exports) {

$parcel$export(module.exports, "CREATE_TEAM", () => $b102556097e1ab1c$export$e51fd07f4cff4dd9);
$parcel$export(module.exports, "ADD_SHARED_TEAM", () => $b102556097e1ab1c$export$9fca7f5cffefe520);
$parcel$export(module.exports, "SHARE_TEAM", () => $b102556097e1ab1c$export$12f7bd68200c8cf6);
$parcel$export(module.exports, "createTeam", () => $b102556097e1ab1c$export$dadd67f86cf9b534);
$parcel$export(module.exports, "editTeam", () => $b102556097e1ab1c$export$3120cad1fc5da91e);
$parcel$export(module.exports, "addSharedTeam", () => $b102556097e1ab1c$export$7ce4510b5cb3f18a);
$parcel$export(module.exports, "addAtlassianTeam", () => $b102556097e1ab1c$export$7ee5b11e737d7de2);
$parcel$export(module.exports, "deleteTeam", () => $b102556097e1ab1c$export$400f94bac8630c0e);
$parcel$export(module.exports, "shareTeam", () => $b102556097e1ab1c$export$473ac9847ab8d834);
$parcel$export(module.exports, "addMembersAndShareTeam", () => $b102556097e1ab1c$export$7718371a65b500a9);
$parcel$export(module.exports, "handleTeamBulkCommitResponse", () => $b102556097e1ab1c$export$2a51e8f87b180e63);
$parcel$export(module.exports, "handleResourceBulkCommitResponse", () => $b102556097e1ab1c$export$ec920820200d647a);
$parcel$export(module.exports, "revertTeamChange", () => $b102556097e1ab1c$export$4576c7b725f993c0);
$parcel$export(module.exports, "revertResourceChange", () => $b102556097e1ab1c$export$adfa94f7c5619c0a);
$parcel$export(module.exports, "default", () => $b102556097e1ab1c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CREATE_MODE", () => (parcelRequire("eeTL3")).CREATE_MODE);

var $itLT6 = parcelRequire("itLT6");
var $7d70y = parcelRequire("7d70y");
var $8K6YM = parcelRequire("8K6YM");
var $5OdRK = parcelRequire("5OdRK");
var $l0L3x = parcelRequire("l0L3x");
var $b3iuB = parcelRequire("b3iuB");
var $7WzTP = parcelRequire("7WzTP");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $63O1Q = parcelRequire("63O1Q");

var $1jM5j = parcelRequire("1jM5j");

var $kXdPE = parcelRequire("kXdPE");

var $jyOCP = parcelRequire("jyOCP");

var $cbq3D = parcelRequire("cbq3D");

var $296Gg = parcelRequire("296Gg");

var $iTjRl = parcelRequire("iTjRl");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $3Fte6 = parcelRequire("3Fte6");

var $75KhQ = parcelRequire("75KhQ");

var $9ydqM = parcelRequire("9ydqM");

var $MQRDu = parcelRequire("MQRDu");

var $4dybm = parcelRequire("4dybm");

var $d4YZJ = parcelRequire("d4YZJ");

var $1pBkD = parcelRequire("1pBkD");

var $uh7SP = parcelRequire("uh7SP");

var $gwmQW = parcelRequire("gwmQW");

var $xlOmi = parcelRequire("xlOmi");

var $6Oj3G = parcelRequire("6Oj3G");

var $eBGH3 = parcelRequire("eBGH3");

var $8RAUa = parcelRequire("8RAUa");

var $9ffcO = parcelRequire("9ffcO");


var $28oyV = parcelRequire("28oyV");

var $eeTL3 = parcelRequire("eeTL3");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $bUR5P = parcelRequire("bUR5P");

var $fvMkH = parcelRequire("fvMkH");
const $b102556097e1ab1c$export$e51fd07f4cff4dd9 = 'command.teams.CREATE_TEAM';
const $b102556097e1ab1c$export$9fca7f5cffefe520 = 'command.teams.ADD_SHARED_TEAM';
const $b102556097e1ab1c$export$3a18867c511c1a09 = 'command.teams.ADD_ATLASSIAN_TEAM';
const $b102556097e1ab1c$export$16af3175a6f522a7 = 'command.teams.UPDATE_TEAM';
const $b102556097e1ab1c$export$9835fe396f18bdff = 'command.teams.DELETE_TEAM';
const $b102556097e1ab1c$export$c8251868ca64bcab = 'command.teams.ADD_TEAM_MEMBER';
const $b102556097e1ab1c$export$9afb46849dcfc3d8 = 'command.teams.DELETE_TEAM_MEMBER';
const $b102556097e1ab1c$export$4c45575b665b09d6 = 'command.teams.FETCH_ADDITIONAL_TEAMS';
const $b102556097e1ab1c$export$12f7bd68200c8cf6 = 'command.teams.SHARE_TEAM';
const $b102556097e1ab1c$export$8fa1d931bc8a441c = 'command.teams.ADD_MEMBERS_AND_SHARE_TEAM';
const $b102556097e1ab1c$export$dadd67f86cf9b534 = (payload)=>({
        type: $b102556097e1ab1c$export$e51fd07f4cff4dd9,
        payload: payload
    });
const $b102556097e1ab1c$export$3120cad1fc5da91e = (payload)=>({
        type: $b102556097e1ab1c$export$16af3175a6f522a7,
        payload: payload
    });
const $b102556097e1ab1c$export$7ce4510b5cb3f18a = (sharedTeamId)=>({
        type: $b102556097e1ab1c$export$9fca7f5cffefe520,
        sharedTeamId: sharedTeamId
    });
const $b102556097e1ab1c$export$7ee5b11e737d7de2 = (payload)=>({
        type: $b102556097e1ab1c$export$3a18867c511c1a09,
        payload: payload
    });
const $b102556097e1ab1c$export$400f94bac8630c0e = (payload)=>({
        type: $b102556097e1ab1c$export$9835fe396f18bdff,
        payload: payload
    });
const $b102556097e1ab1c$export$473ac9847ab8d834 = (teamId)=>({
        type: $b102556097e1ab1c$export$12f7bd68200c8cf6,
        teamId: teamId
    });
const $b102556097e1ab1c$export$7718371a65b500a9 = (payload)=>({
        type: $b102556097e1ab1c$export$8fa1d931bc8a441c,
        payload: payload
    });
function* $b102556097e1ab1c$export$3d88424f2784ccca(oldId, newId) {
    yield* (0, $kXdPE.default)(function*() {
        if (newId) {
            yield (0, $9e8i2.put)((0, $6Oj3G.update)({
                teamId: oldId,
                patch: {
                    id: newId
                }
            }));
            yield (0, $9e8i2.put)((0, $9ffcO.updateTeamId)({
                oldId: oldId,
                newId: newId
            }));
            yield (0, $9e8i2.put)((0, $gwmQW.updateTeamId)({
                oldId: oldId,
                newId: newId
            }));
            yield (0, $9e8i2.put)((0, $4dybm.updateTeamId)({
                oldId: oldId,
                newId: newId
            }));
        }
        const { value: value } = yield (0, $9e8i2.select)((0, $3Fte6.getTeamsFilterPure));
        if ((0, $7CnHa.isDefined)(value) && $7d70y.default(oldId, value)) {
            const newValue = value.filter((team)=>team !== oldId);
            if (newId) newValue.push(newId);
            yield (0, $9e8i2.put)((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$8abe69ceb26771cd),
                value: newValue
            }));
        }
    });
}
const $b102556097e1ab1c$export$1d57c8a8fd4b49d1 = (payload)=>({
        type: $b102556097e1ab1c$export$c8251868ca64bcab,
        payload: payload
    });
const $b102556097e1ab1c$export$84f34219307d9860 = (payload)=>({
        type: $b102556097e1ab1c$export$9afb46849dcfc3d8,
        payload: payload
    });
function* $b102556097e1ab1c$export$2a51e8f87b180e63(entityResponse) {
    const teamId = entityResponse.itemKey;
    const generatedId = entityResponse.generatedId;
    const error = entityResponse.error;
    const team = yield (0, $9e8i2.select)((0, $MQRDu.getTeamById), teamId);
    if (team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED) {
        yield (0, $9e8i2.put)((0, $6Oj3G.remove)({
            id: teamId,
            action: 'COMMIT'
        }));
        yield (0, $9e8i2.put)((0, $9ffcO.removeTeamId)({
            id: teamId
        }));
    } else {
        yield (0, $9e8i2.put)((0, $6Oj3G.update)({
            teamId: teamId,
            patch: {
                scenarioType: (0, $5rYNM.SCENARIO_TYPE).NONE
            }
        }));
        yield (0, $9e8i2.call)($b102556097e1ab1c$export$3d88424f2784ccca, teamId, generatedId);
    }
    const warnings = (0, $fvMkH.inspectForCommitWarnings)(error);
    if (warnings.length) yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).TEAM,
        itemId: teamId,
        warnings: warnings
    }));
    const originals = yield (0, $9e8i2.select)((0, $MQRDu.getOriginalTeams));
    yield (0, $9e8i2.put)((0, $1pBkD.reset)($8K6YM.default(teamId, originals)));
}
function* $b102556097e1ab1c$export$ec920820200d647a(entityResponse) {
    const resourceId = entityResponse.itemKey;
    const newResourceId = entityResponse.generatedId;
    const teams = yield (0, $9e8i2.select)((0, $MQRDu.getTeams));
    const team = (0, $MQRDu.findTeamAssociatedWithResource)(teams, resourceId);
    if (team && newResourceId) yield (0, $9e8i2.put)((0, $6Oj3G.updateResource)({
        teamId: team.id,
        resourceId: resourceId,
        itemKey: newResourceId
    }));
    const warnings = yield (0, $9e8i2.call)((0, $fvMkH.inspectForResourceCommitWarnings), entityResponse.error, newResourceId ?? resourceId);
    if (warnings.length) yield (0, $9e8i2.put)((0, $eBGH3.add)({
        category: (0, $5rYNM.ENTITY).RESOURCE,
        itemId: newResourceId ?? resourceId,
        warnings: warnings
    }));
    const originals = yield (0, $9e8i2.select)((0, $9ydqM.getOriginalResources));
    yield (0, $9e8i2.put)((0, $d4YZJ.reset)($8K6YM.default(resourceId, originals)));
}
function* $b102556097e1ab1c$export$4576c7b725f993c0(teamId) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, teamId);
    const response = yield* $iTjRl.json({
        url: (0, $bUR5P.urls).revertTeamChanges,
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence }, scenarioType: scenarioType } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        const team = yield (0, $9e8i2.select)((0, $MQRDu.getTeamById), teamId);
        if (team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
            yield (0, $9e8i2.put)((0, $6Oj3G.remove)({
                id: teamId,
                action: 'REVERT'
            }));
            yield (0, $9e8i2.put)((0, $9ffcO.removeTeamId)({
                id: teamId
            }));
        } else {
            const originalTeams = yield (0, $9e8i2.select)((0, $MQRDu.getOriginalTeams));
            const originalValues = originalTeams[teamId];
            yield (0, $9e8i2.put)((0, $6Oj3G.update)({
                teamId: teamId,
                patch: {
                    ...team.originals,
                    scenarioType: scenarioType,
                    originals: {},
                    ...originalValues
                }
            }));
        }
    }
    return response;
}
function* $b102556097e1ab1c$export$adfa94f7c5619c0a(resourceId) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId }, sequence: sequence } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = (0, $jyOCP.revertBody)({
        id: planId,
        currentScenarioId: currentScenarioId
    }, sequence, resourceId);
    const response = yield* $iTjRl.json({
        url: (0, $bUR5P.urls).revertResourceChanges,
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { // eslint-disable-next-line @typescript-eslint/no-shadow
        change: { sequence: sequence } } = response.data;
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        const teams = yield (0, $9e8i2.select)((0, $MQRDu.getTeams));
        const team = (0, $MQRDu.findTeamAssociatedWithResource)(teams, resourceId);
        if (team) {
            const resource = (0, $MQRDu.findResourceFromTeam)(team, resourceId);
            if (resource && resource.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) yield (0, $9e8i2.put)((0, $6Oj3G.update)({
                teamId: team.id,
                patch: {
                    resources: team.resources.filter(// eslint-disable-next-line @typescript-eslint/no-shadow
                    (resource)=>resource.itemKey !== resourceId)
                }
            }));
            else yield (0, $9e8i2.put)((0, $6Oj3G.updateResource)({
                itemKey: resourceId,
                resourceId: resourceId,
                teamId: team.id
            }));
        }
    }
    return response;
}
function* $b102556097e1ab1c$export$29c583b936b0d944({ payload: teamMemberPayload }) {
    const { weeklyHours: weeklyHours, personItemKey: personItemKey, teamItemKey: teamItemKey } = teamMemberPayload;
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = {
        planId: planId,
        scenarioId: currentScenarioId,
        description: {
            weeklyHours: (0, $7CnHa.isDefined)(weeklyHours) ? {
                value: weeklyHours
            } : {}
        },
        personItemKey: personItemKey,
        teamItemKey: teamItemKey
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).addTeamMember, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { change: { sequence: sequence }, person: person, resourceItemKey: resourceItemKey } = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        yield (0, $9e8i2.put)((0, $uh7SP.add)(person));
        yield (0, $9e8i2.put)((0, $63O1Q.fetchTeamsAssignees)());
        const resource = {
            itemKey: resourceItemKey,
            scenarioType: (0, $5rYNM.SCENARIO_TYPE).ADDED,
            originals: person.originals,
            personItemKey: person.itemKey,
            values: {
                weeklyHours: (0, $7CnHa.isDefined)(weeklyHours) ? weeklyHours : null
            }
        };
        yield (0, $9e8i2.put)((0, $6Oj3G.addMember)({
            teamId: teamItemKey,
            resource: resource
        }));
        yield (0, $9e8i2.put)((0, $d4YZJ.update)({
            itemKey: resourceItemKey
        }));
    } else {
        const message = yield (0, $9e8i2.call)(response.text.bind(response));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: message
        }));
    }
}
function* $b102556097e1ab1c$export$f8cc5277460b8c48({ payload: { removedResources: removedResources, teamId: teamId } }) {
    const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = {
        planId: planId,
        scenarioId: currentScenarioId,
        itemKeys: removedResources.map((el)=>el.itemKey)
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).deleteTeamMember, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        for (const resource of removedResources){
            if (resource.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).ADDED) yield (0, $9e8i2.put)((0, $d4YZJ.update)({
                itemKey: resource.itemKey
            }));
            yield (0, $9e8i2.put)((0, $6Oj3G.removeMember)({
                teamId: teamId,
                resource: resource
            }));
        }
        const originalResources = yield (0, $9e8i2.select)((0, $9ydqM.getOriginalResources));
        const resets = (0, $7CnHa.filterMap)(({ scenarioType: scenarioType })=>scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED, (resource)=>resource.itemKey, removedResources);
        if (resets.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resetOriginals = Object.keys(originalResources).reduce((acc, key)=>{
                if (!resets.includes(key)) acc[key] = originalResources[key];
                return acc;
            }, {});
            yield (0, $9e8i2.put)((0, $d4YZJ.reset)(resetOriginals));
        }
        const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
    } else {
        const message = yield (0, $9e8i2.call)(response.text.bind(response));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: message
        }));
    }
}
function* $b102556097e1ab1c$export$ea9bd73fd9ebed1({ members: members, team: team }) {
    const { resources: resources } = team;
    const addedResources = members.filter((el)=>!resources.some((res)=>res.scenarioType !== (0, $5rYNM.SCENARIO_TYPE).DELETED && res.personItemKey === el.value.toString()));
    const removedResources = resources.filter((el)=>el.scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED || !members.some((member)=>member.value.toString() === el.personItemKey));
    for (const teamMember of addedResources)yield (0, $9e8i2.call)($b102556097e1ab1c$export$29c583b936b0d944, $b102556097e1ab1c$export$1d57c8a8fd4b49d1({
        personItemKey: teamMember.value.toString(),
        teamItemKey: team.id
    }));
    if (removedResources.length) yield (0, $9e8i2.call)($b102556097e1ab1c$export$f8cc5277460b8c48, $b102556097e1ab1c$export$84f34219307d9860({
        removedResources: removedResources,
        teamId: team.id
    }));
}
function* $b102556097e1ab1c$export$a27e6496b19f1ec5(team) {
    const newTeam = (0, $8RAUa.prepareTeam)(team);
    yield (0, $9e8i2.put)((0, $6Oj3G.add)(newTeam));
    yield (0, $9e8i2.put)((0, $1pBkD.update)({
        id: newTeam.id
    }));
    yield (0, $9e8i2.put)((0, $6Oj3G.update)({
        teamId: newTeam.id,
        patch: {
            scenarioType: (0, $5rYNM.SCENARIO_TYPE).ADDED
        }
    }));
    yield (0, $9e8i2.put)((0, $9ffcO.setColourForNewTeam)({
        id: team.itemKey
    }));
}
function* $b102556097e1ab1c$export$6b49b838ae174911({ payload: teamPayload }) {
    yield (0, $9e8i2.put)((0, $eeTL3.initiateRequest)());
    const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        description: (0, $bUR5P.getTeamDescriptionPayload)(teamPayload)
    };
    const { members: members = [] } = teamPayload;
    try {
        const url = (0, $bUR5P.urls).addNewTeam;
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body,
            profile: url
        });
        if (response.ok) {
            const { change: { sequence: sequence }, team: team } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            yield (0, $9e8i2.call)($b102556097e1ab1c$export$a27e6496b19f1ec5, team);
            for (const teamMember of members)yield (0, $9e8i2.call)($b102556097e1ab1c$export$29c583b936b0d944, $b102556097e1ab1c$export$1d57c8a8fd4b49d1({
                personItemKey: teamMember.value.toString(),
                teamItemKey: team.itemKey
            }));
            yield (0, $9e8i2.put)((0, $eeTL3.closeTeamsDialog)());
        } else {
            const message = yield (0, $9e8i2.call)(response.text.bind(response));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: message
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)((0, $eeTL3.resetRequest)());
    }
}
function* $b102556097e1ab1c$export$cd63b032aaad44e4({ sharedTeamId: sharedTeamId }) {
    yield (0, $9e8i2.put)((0, $eeTL3.initiateRequest)());
    const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        teamId: sharedTeamId
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).addSharedTeam, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { change: { sequence: sequence }, team: team, people: people } = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        yield (0, $9e8i2.call)($b102556097e1ab1c$export$a27e6496b19f1ec5, team);
        for (const person of people)yield (0, $9e8i2.put)((0, $uh7SP.add)(person));
        yield (0, $9e8i2.put)((0, $eeTL3.closeTeamsDialog)());
    } else {
        const message = yield (0, $9e8i2.call)(response.text.bind(response));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: message
        }));
    }
    yield (0, $9e8i2.put)((0, $eeTL3.resetRequest)());
}
function* $b102556097e1ab1c$export$94ab737c3e9c6723({ payload: atlassianTeamPayload }) {
    yield (0, $9e8i2.put)((0, $eeTL3.initiateRequest)());
    yield (0, $9e8i2.put)((0, $28oyV.resetAddedTwpTeam)());
    const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        teamId: atlassianTeamPayload.id,
        members: atlassianTeamPayload.members
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).addAtlassianTeam, {
        method: (0, $kP3Wn.POST),
        body: body
    });
    if (response.ok) {
        const { change: { sequence: sequence }, team: team, people: people } = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
        // if the Atlassian team is newly created, it may take some time for the data to become available, so
        // use the team name we supplied
        const teamToAdd = atlassianTeamPayload.title ? $itLT6.default([
            'values',
            'title'
        ], atlassianTeamPayload.title, team) : team;
        // Initialise team settings to make sure review changes are correct on the subsequent update
        teamToAdd.values.issueSource = null;
        teamToAdd.values.iterationLength = null;
        teamToAdd.values.schedulingMode = (0, $5rYNM.SCHEDULE_MODE).scrum;
        teamToAdd.values.velocity = null;
        teamToAdd.values.weeklyHours = null;
        yield (0, $9e8i2.call)($b102556097e1ab1c$export$a27e6496b19f1ec5, teamToAdd);
        for (const person of people)yield (0, $9e8i2.put)((0, $uh7SP.add)(person));
        yield (0, $9e8i2.put)((0, $28oyV.storeAddedTwpTeam)({
            teamTitle: teamToAdd.values.title,
            teamId: teamToAdd.itemKey
        }));
    } else {
        const message = yield (0, $9e8i2.call)(response.text.bind(response));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: message
        }));
    }
    yield (0, $9e8i2.put)((0, $eeTL3.resetRequest)());
}
function* $b102556097e1ab1c$export$8c5eeb39ea12a165({ payload: { enhancedTeam: enhancedTeam, formFields: formFields, teamId: teamId } }) {
    yield (0, $9e8i2.put)((0, $eeTL3.initiateRequest)());
    const { domain: { plan: { id: planId, currentScenarioId: scenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const { members: members = [], ...rest } = formFields;
    const { members: enhancedMembers = [], ...enhancedRest } = enhancedTeam;
    const patch = (0, $7CnHa.pickBy)((el, key)=>!$5OdRK.default(el, enhancedRest[key]), rest);
    const isEqualMembers = members.length === enhancedMembers.length && members.every((member)=>enhancedMembers.some((enhancedMember)=>member.value.toString() === enhancedMember.value.toString()));
    if ($b3iuB.default(patch) && isEqualMembers) {
        yield (0, $9e8i2.put)((0, $eeTL3.resetRequest)());
        yield (0, $9e8i2.put)((0, $eeTL3.closeTeamsDialog)());
        return;
    }
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        itemKeys: [
            teamId
        ],
        description: (0, $bUR5P.getTeamDescriptionPayload)(patch)
    };
    try {
        const url = (0, $bUR5P.urls).updateTeam;
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body,
            profile: url
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            const team = yield (0, $9e8i2.select)((0, $MQRDu.getTeamById), teamId);
            const originals = $7WzTP.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            Object.keys(patch).filter((key)=>patch[key] !== team[key]), team);
            if (!isEqualMembers) yield (0, $9e8i2.call)($b102556097e1ab1c$export$ea9bd73fd9ebed1, {
                members: members,
                team: team
            });
            const scenarioType = team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? (0, $5rYNM.SCENARIO_TYPE).ADDED : (0, $5rYNM.SCENARIO_TYPE).UPDATED;
            yield (0, $9e8i2.put)((0, $1pBkD.update)({
                ...originals,
                id: teamId
            }));
            yield (0, $9e8i2.put)((0, $6Oj3G.update)({
                teamId: teamId,
                patch: {
                    scenarioType: scenarioType,
                    ...scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED ? {
                        originals: originals
                    } : {},
                    ...patch
                }
            }));
            yield (0, $9e8i2.put)((0, $eeTL3.closeTeamsDialog)());
        } else {
            const message = yield (0, $9e8i2.call)(response.text.bind(response));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: message
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)((0, $eeTL3.resetRequest)());
    }
}
function* $b102556097e1ab1c$export$555554d803cdd4c6({ payload: payload }) {
    try {
        const { currentScenarioId: scenarioId, id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const body = {
            itemKeys: [
                payload.id
            ],
            planId: planId,
            scenarioId: scenarioId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).deleteTeam, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { change: { sequence: sequence } } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
            const team = yield (0, $9e8i2.select)((0, $MQRDu.getTeamById), payload.id);
            if (team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) {
                yield (0, $9e8i2.put)((0, $6Oj3G.remove)({
                    id: payload.id,
                    action: 'DELETE'
                }));
                yield (0, $9e8i2.put)((0, $9ffcO.removeTeamId)({
                    id: payload.id
                }));
                const originals = yield (0, $9e8i2.select)((0, $MQRDu.getOriginalTeams));
                yield (0, $9e8i2.put)((0, $1pBkD.reset)($8K6YM.default(payload.id, originals)));
            } else {
                yield (0, $9e8i2.put)((0, $1pBkD.update)({
                    ...payload
                }));
                yield (0, $9e8i2.put)((0, $6Oj3G.update)({
                    teamId: payload.id,
                    patch: {
                        scenarioType: (0, $5rYNM.SCENARIO_TYPE).DELETED
                    }
                }));
            }
            yield (0, $9e8i2.call)($b102556097e1ab1c$export$3d88424f2784ccca, payload.id);
            yield (0, $9e8i2.call)((0, $1jM5j.getBacklog)); // revert value of issues' team cell
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $b102556097e1ab1c$export$e8872698abd4b9a({ teamId: teamId }) {
    try {
        const { id: planId, useTwpTeams: useTwpTeams } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        if ((0, $430Oj.default)() && useTwpTeams) {
            const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).setSharedNew, {
                method: (0, $kP3Wn.POST),
                body: {
                    planId: planId,
                    teamId: teamId
                }
            });
            if (response.ok) {
                const { externalId: externalId } = yield (0, $9e8i2.call)(response.json.bind(response));
                yield (0, $9e8i2.put)((0, $6Oj3G.setShared)(teamId, externalId));
            } else {
                const message = yield (0, $9e8i2.call)(response.text.bind(response));
                yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                    message: message
                }));
            }
        } else {
            const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).setShared(teamId), {
                method: (0, $kP3Wn.POST)
            });
            if (response.ok) yield (0, $9e8i2.put)((0, $6Oj3G.setSharedOld)(teamId));
            else {
                const message = yield (0, $9e8i2.call)(response.text.bind(response));
                yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                    message: message
                }));
            }
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $b102556097e1ab1c$export$b02ba2781d0ccd18({ payload: { teamId: teamId, personIds: personIds } }) {
    try {
        const { id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $bUR5P.urls).addTeamMemberWithoutScenarioChange, {
            method: (0, $kP3Wn.POST),
            body: {
                planId: planId,
                teamId: teamId,
                persons: personIds.map((aId)=>({
                        personId: aId
                    }))
            }
        });
        if (response.ok) {
            const { resources: resources } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.all)(resources.map(function*({ person: person, resourceItemKey: resourceItemKey }) {
                yield (0, $9e8i2.put)((0, $uh7SP.add)(person));
                const resource = {
                    itemKey: resourceItemKey,
                    scenarioType: (0, $5rYNM.SCENARIO_TYPE).ADDED,
                    originals: person.originals,
                    personItemKey: person.itemKey,
                    values: {
                        weeklyHours: null
                    }
                };
                yield (0, $9e8i2.put)((0, $6Oj3G.addMember)({
                    teamId: teamId,
                    resource: resource
                }));
            }));
            // if the new added persons doesn't existed in the team assignee, need to fetch them
            yield (0, $9e8i2.put)((0, $63O1Q.fetchTeamsAssignees)());
            yield (0, $9e8i2.put)($b102556097e1ab1c$export$473ac9847ab8d834(teamId));
        } else {
            const message = yield (0, $9e8i2.call)(response.text.bind(response));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                message: message
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $b102556097e1ab1c$export$4b409c03c7ab2245() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$e51fd07f4cff4dd9, $b102556097e1ab1c$export$6b49b838ae174911);
}
function* $b102556097e1ab1c$export$eac49cd6e7d8cb65() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$9fca7f5cffefe520, $b102556097e1ab1c$export$cd63b032aaad44e4);
}
function* $b102556097e1ab1c$export$2d80cf2dc32820d2() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$3a18867c511c1a09, $b102556097e1ab1c$export$94ab737c3e9c6723);
}
function* $b102556097e1ab1c$export$e4e4d710dba71d61() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$16af3175a6f522a7, $b102556097e1ab1c$export$8c5eeb39ea12a165);
}
function* $b102556097e1ab1c$export$f555f148b310eebf() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$9835fe396f18bdff, $b102556097e1ab1c$export$555554d803cdd4c6);
}
function* $b102556097e1ab1c$export$8ec20e797f5e6408() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$c8251868ca64bcab, $b102556097e1ab1c$export$29c583b936b0d944);
}
function* $b102556097e1ab1c$export$510a706ed03de615() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$9afb46849dcfc3d8, $b102556097e1ab1c$export$f8cc5277460b8c48);
}
function* $b102556097e1ab1c$export$925e67f5cb8cc50c() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$12f7bd68200c8cf6, $b102556097e1ab1c$export$e8872698abd4b9a);
}
function* $b102556097e1ab1c$export$581612e0e6e99ed1() {
    yield (0, $bG7pV.takeEvery)($b102556097e1ab1c$export$8fa1d931bc8a441c, $b102556097e1ab1c$export$b02ba2781d0ccd18);
}
function* $b102556097e1ab1c$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$4b409c03c7ab2245);
    // delete this fork when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$eac49cd6e7d8cb65);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$2d80cf2dc32820d2);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$e4e4d710dba71d61);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$f555f148b310eebf);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$8ec20e797f5e6408);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$510a706ed03de615);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$925e67f5cb8cc50c);
    yield (0, $9e8i2.fork)($b102556097e1ab1c$export$581612e0e6e99ed1);
}

});
parcelRegister("d4YZJ", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $488485a4f83897d5$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $488485a4f83897d5$export$e271b26eefe41db8);
$parcel$export(module.exports, "update", () => $488485a4f83897d5$export$722fbec263ad908a);
$parcel$export(module.exports, "reset", () => $488485a4f83897d5$export$aad8462122ac592b);
const $488485a4f83897d5$export$4a991c87e640ef77 = 'state.domain.original-resources.RESET';
const $488485a4f83897d5$export$e271b26eefe41db8 = 'state.domain.original-resources.UPDATE';
const $488485a4f83897d5$export$722fbec263ad908a = (payload)=>({
        type: $488485a4f83897d5$export$e271b26eefe41db8,
        payload: payload
    });
const $488485a4f83897d5$export$aad8462122ac592b = (payload)=>({
        type: $488485a4f83897d5$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("1pBkD", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $189e5760f6994c83$export$4a991c87e640ef77);
$parcel$export(module.exports, "UPDATE", () => $189e5760f6994c83$export$e271b26eefe41db8);
$parcel$export(module.exports, "update", () => $189e5760f6994c83$export$722fbec263ad908a);
$parcel$export(module.exports, "reset", () => $189e5760f6994c83$export$aad8462122ac592b);
const $189e5760f6994c83$export$4a991c87e640ef77 = 'state.domain.original-teams.RESET';
const $189e5760f6994c83$export$e271b26eefe41db8 = 'state.domain.original-teams.UPDATE';
const $189e5760f6994c83$export$722fbec263ad908a = (payload)=>({
        type: $189e5760f6994c83$export$e271b26eefe41db8,
        payload: payload
    });
const $189e5760f6994c83$export$aad8462122ac592b = (payload)=>({
        type: $189e5760f6994c83$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("uh7SP", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $bd950d79bc8a1b3c$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $bd950d79bc8a1b3c$export$bb6389024b71c2ae);
$parcel$export(module.exports, "reset", () => $bd950d79bc8a1b3c$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $bd950d79bc8a1b3c$export$e16d8520af44a096);
const $bd950d79bc8a1b3c$export$4a991c87e640ef77 = 'state.domain.persons.RESET';
const $bd950d79bc8a1b3c$export$bb6389024b71c2ae = 'state.domain.persons.ADD';
const $bd950d79bc8a1b3c$export$aad8462122ac592b = (payload)=>({
        type: $bd950d79bc8a1b3c$export$4a991c87e640ef77,
        payload: payload
    });
const $bd950d79bc8a1b3c$export$e16d8520af44a096 = (payload)=>({
        type: $bd950d79bc8a1b3c$export$bb6389024b71c2ae,
        payload: payload
    });

});

parcelRegister("6Oj3G", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $d935892b3a3b7ca7$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $d935892b3a3b7ca7$export$4a991c87e640ef77);
$parcel$export(module.exports, "REMOVE", () => $d935892b3a3b7ca7$export$29d55e1f664a246b);
$parcel$export(module.exports, "UPDATE", () => $d935892b3a3b7ca7$export$e271b26eefe41db8);
$parcel$export(module.exports, "UPDATE_RESOURCE", () => $d935892b3a3b7ca7$export$14d087c009633b99);
$parcel$export(module.exports, "ADD_MEMBER", () => $d935892b3a3b7ca7$export$fd02c2a24df725bc);
$parcel$export(module.exports, "REMOVE_MEMBER", () => $d935892b3a3b7ca7$export$70ddd0b194796257);
$parcel$export(module.exports, "SET_SHARED", () => $d935892b3a3b7ca7$export$bf0c919e7ee37f3f);
$parcel$export(module.exports, "add", () => $d935892b3a3b7ca7$export$e16d8520af44a096);
$parcel$export(module.exports, "reset", () => $d935892b3a3b7ca7$export$aad8462122ac592b);
$parcel$export(module.exports, "remove", () => $d935892b3a3b7ca7$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "update", () => $d935892b3a3b7ca7$export$722fbec263ad908a);
$parcel$export(module.exports, "updateResource", () => $d935892b3a3b7ca7$export$1301c313b2890e2d);
$parcel$export(module.exports, "addMember", () => $d935892b3a3b7ca7$export$d199869810608d4e);
$parcel$export(module.exports, "removeMember", () => $d935892b3a3b7ca7$export$57b1164dbe7b642f);
$parcel$export(module.exports, "setSharedOld", () => $d935892b3a3b7ca7$export$f8736e4dd682e749);
$parcel$export(module.exports, "setShared", () => $d935892b3a3b7ca7$export$72030e9b32b3f1bb);
const $d935892b3a3b7ca7$export$bb6389024b71c2ae = 'state.domain.teams.ADD';
const $d935892b3a3b7ca7$export$4a991c87e640ef77 = 'state.domain.teams.RESET';
const $d935892b3a3b7ca7$export$29d55e1f664a246b = 'state.domain.teams.REMOVE';
const $d935892b3a3b7ca7$export$e271b26eefe41db8 = 'state.domain.teams.UPDATE';
const $d935892b3a3b7ca7$export$14d087c009633b99 = 'state.domain.teams.UPDATE_RESOURCE';
const $d935892b3a3b7ca7$export$fd02c2a24df725bc = 'state.domain.teams.ADD_MEMBER';
const $d935892b3a3b7ca7$export$70ddd0b194796257 = 'state.domain.teams.REMOVE_MEMBER';
const $d935892b3a3b7ca7$export$bf0c919e7ee37f3f = 'state.domain.teams.SET_SHARED';
const $d935892b3a3b7ca7$export$e16d8520af44a096 = (payload)=>({
        type: $d935892b3a3b7ca7$export$bb6389024b71c2ae,
        payload: payload
    });
const $d935892b3a3b7ca7$export$aad8462122ac592b = (payload)=>({
        type: $d935892b3a3b7ca7$export$4a991c87e640ef77,
        payload: payload
    });
const $d935892b3a3b7ca7$export$cd7f480d6b8286c3 = (payload)=>({
        type: $d935892b3a3b7ca7$export$29d55e1f664a246b,
        payload: payload
    });
const $d935892b3a3b7ca7$export$722fbec263ad908a = (payload)=>({
        type: $d935892b3a3b7ca7$export$e271b26eefe41db8,
        payload: payload
    });
const $d935892b3a3b7ca7$export$1301c313b2890e2d = (payload)=>({
        type: $d935892b3a3b7ca7$export$14d087c009633b99,
        payload: payload
    });
const $d935892b3a3b7ca7$export$d199869810608d4e = (payload)=>({
        type: $d935892b3a3b7ca7$export$fd02c2a24df725bc,
        payload: payload
    });
const $d935892b3a3b7ca7$export$57b1164dbe7b642f = (payload)=>({
        type: $d935892b3a3b7ca7$export$70ddd0b194796257,
        payload: payload
    });
const $d935892b3a3b7ca7$export$f8736e4dd682e749 = (teamId)=>({
        type: $d935892b3a3b7ca7$export$bf0c919e7ee37f3f,
        teamId: teamId
    });
const $d935892b3a3b7ca7$export$72030e9b32b3f1bb = (teamId, externalId)=>({
        type: $d935892b3a3b7ca7$export$bf0c919e7ee37f3f,
        teamId: teamId,
        externalId: externalId
    });

});

parcelRegister("28oyV", function(module, exports) {

$parcel$export(module.exports, "STORE_ADDED_TWP_TEAM", () => $d00891b5039159fc$export$1b569f318992fe0f);
$parcel$export(module.exports, "RESET_ADDED_TWP_TEAM", () => $d00891b5039159fc$export$c574386b3f59ba7d);
$parcel$export(module.exports, "LOAD_CREATE_TWP_FORM", () => $d00891b5039159fc$export$27399c91b45e0c1f);
$parcel$export(module.exports, "RESET_CREATE_TWP_FORM", () => $d00891b5039159fc$export$74df48b967e3300b);
$parcel$export(module.exports, "storeAddedTwpTeam", () => $d00891b5039159fc$export$53e229d16867e049);
$parcel$export(module.exports, "resetAddedTwpTeam", () => $d00891b5039159fc$export$bfeaad00c5b059a4);
$parcel$export(module.exports, "loadCreateTwpForm", () => $d00891b5039159fc$export$5daa826ee6e9d368);
$parcel$export(module.exports, "resetCreateTwpForm", () => $d00891b5039159fc$export$51dd78b7d08a90e);
const $d00891b5039159fc$export$1b569f318992fe0f = 'state.ui.main.tabs.teams.create-team.STORE_ADDED_TWP_TEAM';
const $d00891b5039159fc$export$c574386b3f59ba7d = 'state.ui.main.tabs.teams.create-team.RESET_ADDED_TWP_TEAM';
const $d00891b5039159fc$export$27399c91b45e0c1f = 'state.ui.main.tabs.teams.create-team.LOAD_CREATE_TWP_FORM';
const $d00891b5039159fc$export$74df48b967e3300b = 'state.ui.main.tabs.teams.create-team.RESET_CREATE_TWP_FORM';
const $d00891b5039159fc$export$53e229d16867e049 = (payload)=>({
        type: $d00891b5039159fc$export$1b569f318992fe0f,
        payload: payload
    });
const $d00891b5039159fc$export$bfeaad00c5b059a4 = ()=>({
        type: $d00891b5039159fc$export$c574386b3f59ba7d
    });
const $d00891b5039159fc$export$5daa826ee6e9d368 = ()=>({
        type: $d00891b5039159fc$export$27399c91b45e0c1f
    });
const $d00891b5039159fc$export$51dd78b7d08a90e = ()=>({
        type: $d00891b5039159fc$export$74df48b967e3300b
    });

});

parcelRegister("eeTL3", function(module, exports) {

$parcel$export(module.exports, "OPEN_TEAMS_DIALOG", () => $e584c8d2f455389f$export$df5fbe9561f83371);
$parcel$export(module.exports, "CLOSE_TEAMS_DIALOG", () => $e584c8d2f455389f$export$12dd9a899aa0aa58);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $e584c8d2f455389f$export$4580e708995fb75f);
$parcel$export(module.exports, "RESET_REQUEST", () => $e584c8d2f455389f$export$31889003e5372a7f);
$parcel$export(module.exports, "SET_MODE", () => $e584c8d2f455389f$export$27a86d4a6fd7f204);
$parcel$export(module.exports, "CREATE_MODE", () => $e584c8d2f455389f$export$a356edc8fe7e437f);
$parcel$export(module.exports, "EDIT_MODE", () => $e584c8d2f455389f$export$7925fddf359eacb);
$parcel$export(module.exports, "SHOW_SHARED_TEAM_SUCCESS_FLAG", () => $e584c8d2f455389f$export$772bc10fe934e1e0);
$parcel$export(module.exports, "setMode", () => $e584c8d2f455389f$export$d4f039427a1beff1);
$parcel$export(module.exports, "openTeamsDialog", () => $e584c8d2f455389f$export$136a9c6639c07b52);
$parcel$export(module.exports, "closeTeamsDialog", () => $e584c8d2f455389f$export$f0505160fc7e9491);
$parcel$export(module.exports, "showSharedTeamSuccessFlag", () => $e584c8d2f455389f$export$a1428575f9757458);
$parcel$export(module.exports, "initiateRequest", () => $e584c8d2f455389f$export$82f68a404cfea29);
$parcel$export(module.exports, "resetRequest", () => $e584c8d2f455389f$export$b38f09eddeeb56fb);
const $e584c8d2f455389f$export$df5fbe9561f83371 = 'state.ui.main.tabs.teams.list.OPEN_TEAMS_DIALOG';
const $e584c8d2f455389f$export$12dd9a899aa0aa58 = 'state.ui.main.tabs.teams.list.CLOSE_TEAMS_DIALOG';
const $e584c8d2f455389f$export$4580e708995fb75f = 'state.ui.main.tabs.teams.list.INITIATE_REQUEST';
const $e584c8d2f455389f$export$31889003e5372a7f = 'state.ui.main.tabs.teams.list.RESET_REQUEST';
const $e584c8d2f455389f$export$27a86d4a6fd7f204 = 'state.ui.main.tabs.teams.list.SET_MODE';
const $e584c8d2f455389f$export$a356edc8fe7e437f = 'state.ui.main.tabs.teams.list.CREATE_MODE';
const $e584c8d2f455389f$export$7925fddf359eacb = 'state.ui.main.tabs.teams.list.EDIT_MODE';
const $e584c8d2f455389f$export$772bc10fe934e1e0 = 'state.ui.main.tabs.teams.list.SHOW_SHARED_TEAM_SUCCESS_FLAG';
const $e584c8d2f455389f$export$d4f039427a1beff1 = (payload)=>({
        type: $e584c8d2f455389f$export$27a86d4a6fd7f204,
        payload: payload
    });
const $e584c8d2f455389f$export$136a9c6639c07b52 = (editedTeam)=>({
        type: $e584c8d2f455389f$export$df5fbe9561f83371,
        payload: {
            editedTeam: editedTeam
        }
    });
const $e584c8d2f455389f$export$f0505160fc7e9491 = ()=>({
        type: $e584c8d2f455389f$export$12dd9a899aa0aa58
    });
const $e584c8d2f455389f$export$a1428575f9757458 = (// eslint-disable-next-line @typescript-eslint/no-shadow
showSharedTeamSuccessFlag)=>({
        type: $e584c8d2f455389f$export$772bc10fe934e1e0,
        payload: {
            showSharedTeamSuccessFlag: showSharedTeamSuccessFlag
        }
    });
const $e584c8d2f455389f$export$82f68a404cfea29 = ()=>({
        type: $e584c8d2f455389f$export$4580e708995fb75f
    });
const $e584c8d2f455389f$export$b38f09eddeeb56fb = ()=>({
        type: $e584c8d2f455389f$export$31889003e5372a7f
    });

});

parcelRegister("bUR5P", function(module, exports) {

$parcel$export(module.exports, "urls", () => $4ce3ab36575d60f5$export$bcae9ba627f604b6);
$parcel$export(module.exports, "getTeamDescriptionPayload", () => $4ce3ab36575d60f5$export$a31038b7085fc230);

var $kDrtX = parcelRequire("kDrtX");
const $4ce3ab36575d60f5$export$bcae9ba627f604b6 = {
    addNewTeam: '/rest/jpo/1.0/team/addNew',
    // delete this url when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    addSharedTeam: '/rest/jpo/1.0/team/addShared',
    addAtlassianTeam: ' /rest/jpo/1.0/team/addExternal',
    updateTeam: '/rest/jpo/1.0/team/update',
    revertTeamChanges: '/rest/jpo/1.0/team/revert',
    deleteTeam: '/rest/jpo/1.0/team/delete',
    revertResourceChanges: '/rest/jpo/1.0/resource/revertMember',
    addTeamMember: '/rest/jpo/1.0/resource/addMember',
    deleteTeamMember: '/rest/jpo/1.0/resource/deleteMember',
    setShared: (id)=>`/rest/teams/1.0/teams/${id}/setShared`,
    setSharedNew: '/rest/jpo/1.0/team/setShared',
    // This is the endpoint which will add team member directly to the team without scenario change
    addTeamMemberWithoutScenarioChange: '/rest/jpo/1.0/team/addResources',
    getTWPTeam: (id)=>`/gateway/api/v3/teams/${id}`,
    getTWPTeamV4: (id, siteId)=>`/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`,
    getDefaultTeamMember: '/rest/teams/1.0/teams/defaultTeamMember'
};
const $4ce3ab36575d60f5$export$a31038b7085fc230 = (teamData)=>{
    const description = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const key of Object.keys(teamData)){
        const value = teamData[key];
        description[key] = $kDrtX.default(value) ? {} : {
            value: value
        };
    }
    return description;
};

});

parcelRegister("fvMkH", function(module, exports) {

$parcel$export(module.exports, "inspectForCommitWarnings", () => $0dc43aec12ad1bf1$export$1eed481c758d15b7);
$parcel$export(module.exports, "inspectForResourceCommitWarnings", () => $0dc43aec12ad1bf1$export$360bb984af0cb967);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $f6g5r = parcelRequire("f6g5r");

var $9ydqM = parcelRequire("9ydqM");

var $ajQOs = parcelRequire("ajQOs");
const $0dc43aec12ad1bf1$export$deb6050352aafd0b = {
    header: (0, $ajQOs.default).defaultWarningHeader,
    message: (0, $ajQOs.default).defaultWarningContent,
    messageValues: {}
};
function $0dc43aec12ad1bf1$export$40c68b739c0cfa3f({ error: error }) {
    switch(error){
        case 'ENVIRONMENT_ENTITY_NOT_FOUND':
            return {
                header: (0, $ajQOs.default).teamNotFoundHeader,
                message: (0, $ajQOs.default).teamNotFoundContent,
                messageValues: {}
            };
        default:
            return $0dc43aec12ad1bf1$export$deb6050352aafd0b;
    }
}
function $0dc43aec12ad1bf1$export$4d5511f367ca5f2({ error: error }, personTitle) {
    switch(error){
        case 'ENVIRONMENT_ENTITY_NOT_FOUND':
            return {
                header: (0, $ajQOs.default).memberNotFoundHeader,
                message: (0, $ajQOs.default).memberNotFoundContent,
                messageValues: {
                    personTitle: personTitle
                }
            };
        case 'ENVIRONMENT_RELATED_ENTITY_NOT_FOUND':
            return {
                header: (0, $ajQOs.default).memberOrTeamNotFoundHeader,
                message: (0, $ajQOs.default).memberOrTeamNotFoundContent,
                messageValues: {
                    personTitle: personTitle
                }
            };
        default:
            return $0dc43aec12ad1bf1$export$deb6050352aafd0b;
    }
}
function $0dc43aec12ad1bf1$export$1eed481c758d15b7(error) {
    if (error) return [
        $0dc43aec12ad1bf1$export$40c68b739c0cfa3f(error)
    ];
    return [];
}
function* $0dc43aec12ad1bf1$export$360bb984af0cb967(error, resourceId) {
    if (error) {
        const resources = yield (0, $9e8i2.select)((0, $9ydqM.getAllResources));
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const resource = resources.find((resource)=>resource.itemKey === resourceId);
        if (resource) {
            const persons = yield (0, $9e8i2.select)((0, $f6g5r.getPersons));
            const person = (0, $f6g5r.getPersonByItemKey)(persons, resource.personItemKey);
            const personTitle = person && person.values.title || '';
            return [
                $0dc43aec12ad1bf1$export$4d5511f367ca5f2(error, personTitle)
            ];
        }
        return [
            $0dc43aec12ad1bf1$export$4d5511f367ca5f2(error, '')
        ];
    }
    return [];
}

});
parcelRegister("ajQOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b6a0c62a92f9d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8b6a0c62a92f9d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    teamNotFoundHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.team-not-found-header",
        "defaultMessage": "This team no longer exists in the plan"
    },
    teamNotFoundContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.team-not-found-content",
        "defaultMessage": "Refresh your plan to reflect this change"
    },
    memberNotFoundHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-not-found-header",
        "defaultMessage": "Member {personTitle} could not be found"
    },
    memberNotFoundContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-not-found-content",
        "defaultMessage": "Refresh to update your plan"
    },
    memberOrTeamNotFoundHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-or-team-not-found-header",
        "defaultMessage": "Member {personTitle} or team could not be found"
    },
    memberOrTeamNotFoundContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.member-or-team-not-found-content",
        "defaultMessage": "Refresh to update your plan"
    },
    defaultWarningHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.default-warning-header",
        "defaultMessage": "Could not be committed for unknown reasons."
    },
    defaultWarningContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.teams.default-warning-content",
        "defaultMessage": "Team could not be committed for unknown reasons. Please contact your administrator."
    }
});

});



parcelRegister("3oWAB", function(module, exports) {

$parcel$export(module.exports, "ADD_BULK", () => $10db5c1885a162c3$export$4f864ebd809b742);
$parcel$export(module.exports, "RESET", () => $10db5c1885a162c3$export$4a991c87e640ef77);
$parcel$export(module.exports, "addBulk", () => $10db5c1885a162c3$export$18971c0c4ca9e2fe);
$parcel$export(module.exports, "reset", () => $10db5c1885a162c3$export$aad8462122ac592b);
const $10db5c1885a162c3$export$4f864ebd809b742 = 'state.domain.update-jira.changes-warnings.ADD_BULK';
const $10db5c1885a162c3$export$4a991c87e640ef77 = 'state.domain.update-jira.changes-warnings.RESET';
const $10db5c1885a162c3$export$18971c0c4ca9e2fe = (payload)=>({
        type: $10db5c1885a162c3$export$4f864ebd809b742,
        payload: payload
    });
const $10db5c1885a162c3$export$aad8462122ac592b = (payload)=>({
        type: $10db5c1885a162c3$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("fDCVo", function(module, exports) {

$parcel$export(module.exports, "SENT", () => $56ca9f3216353d34$export$f083ed52efef4a01);
$parcel$export(module.exports, "SUCCESS", () => $56ca9f3216353d34$export$638cc6e36b2a737a);
$parcel$export(module.exports, "AFTER_SUCCESS", () => $56ca9f3216353d34$export$c1338e083bd3d6c5);
$parcel$export(module.exports, "ERROR", () => $56ca9f3216353d34$export$103bedf43ba882db);
$parcel$export(module.exports, "sent", () => $56ca9f3216353d34$export$50bb50b39823aeba);
$parcel$export(module.exports, "success", () => $56ca9f3216353d34$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "afterSuccess", () => $56ca9f3216353d34$export$43fb54a6937a3c03);
$parcel$export(module.exports, "error", () => $56ca9f3216353d34$export$a3bc9b8ed74fc);
const $56ca9f3216353d34$export$f083ed52efef4a01 = 'state.domain.update-jira.changes.SENT';
const $56ca9f3216353d34$export$638cc6e36b2a737a = 'state.domain.update-jira.changes.SUCCESS';
const $56ca9f3216353d34$export$c1338e083bd3d6c5 = 'state.domain.update-jira.changes.AFTER_SUCCESS';
const $56ca9f3216353d34$export$103bedf43ba882db = 'state.domain.update-jira.changes.ERROR';
const $56ca9f3216353d34$export$50bb50b39823aeba = ()=>({
        type: $56ca9f3216353d34$export$f083ed52efef4a01
    });
const $56ca9f3216353d34$export$fe7c49d056ea1d88 = (payload)=>({
        type: $56ca9f3216353d34$export$638cc6e36b2a737a,
        payload: payload
    });
const $56ca9f3216353d34$export$43fb54a6937a3c03 = ()=>({
        type: $56ca9f3216353d34$export$c1338e083bd3d6c5
    });
const $56ca9f3216353d34$export$a3bc9b8ed74fc = (payload)=>({
        type: $56ca9f3216353d34$export$103bedf43ba882db,
        payload: payload
    });

});

parcelRegister("cONEK", function(module, exports) {

$parcel$export(module.exports, "START", () => $8deb85356705fd9c$export$21c466265830bc3a);
$parcel$export(module.exports, "INCREMENT_NUMBER_OF_REVERTED_CHANGES", () => $8deb85356705fd9c$export$3eb3aeac2dc57cff);
$parcel$export(module.exports, "INTERRUPT", () => $8deb85356705fd9c$export$a9f3c3bb2f676e06);
$parcel$export(module.exports, "STOP", () => $8deb85356705fd9c$export$82b9a23e44460c20);
$parcel$export(module.exports, "start", () => $8deb85356705fd9c$export$b3571188c770cc5a);
$parcel$export(module.exports, "incrementNumberOfRevertedChanges", () => $8deb85356705fd9c$export$7ef033a43cf24941);
$parcel$export(module.exports, "interrupt", () => $8deb85356705fd9c$export$7b7d62677a00f822);
$parcel$export(module.exports, "stop", () => $8deb85356705fd9c$export$fa6813432f753b0d);
const $8deb85356705fd9c$export$21c466265830bc3a = 'state.domain.update-jira.revert.START';
const $8deb85356705fd9c$export$3eb3aeac2dc57cff = 'state.domain.update-jira.revert.INCREMENT_NUMBER_OF_REVERTED_CHANGES';
const $8deb85356705fd9c$export$a9f3c3bb2f676e06 = 'state.domain.update-jira.revert.INTERRUPT';
const $8deb85356705fd9c$export$82b9a23e44460c20 = 'state.domain.update-jira.revert.STOP';
const $8deb85356705fd9c$export$b3571188c770cc5a = (totalChanges)=>({
        type: $8deb85356705fd9c$export$21c466265830bc3a,
        payload: totalChanges
    });
const $8deb85356705fd9c$export$7ef033a43cf24941 = ()=>({
        type: $8deb85356705fd9c$export$3eb3aeac2dc57cff
    });
const $8deb85356705fd9c$export$7b7d62677a00f822 = ()=>({
        type: $8deb85356705fd9c$export$a9f3c3bb2f676e06
    });
const $8deb85356705fd9c$export$fa6813432f753b0d = ()=>({
        type: $8deb85356705fd9c$export$82b9a23e44460c20
    });

});

parcelRegister("7SlBO", function(module, exports) {

$parcel$export(module.exports, "OPEN_UPDATE_JIRA_DIALOG", () => $765746eaa8215d97$export$200e9ae2a09a2e08);
$parcel$export(module.exports, "CLOSE_UPDATE_JIRA_DIALOG", () => $765746eaa8215d97$export$e69c7d485722335e);
$parcel$export(module.exports, "EXPAND_UPDATE_JIRA_DIALOG_CHANGE", () => $765746eaa8215d97$export$21158182fc61c195);
$parcel$export(module.exports, "COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE", () => $765746eaa8215d97$export$22e3a9f5b7095d0e);
$parcel$export(module.exports, "CLOSE_COMMIT_WARNING_FLAG", () => $765746eaa8215d97$export$68f98813700bf28a);
$parcel$export(module.exports, "SELECT_CHANGE", () => $765746eaa8215d97$export$3988ad83d406c69a);
$parcel$export(module.exports, "DESELECT_CHANGE", () => $765746eaa8215d97$export$5279058cec1d0a47);
$parcel$export(module.exports, "SELECT_ALL_CHANGES", () => $765746eaa8215d97$export$4d81e085299caab3);
$parcel$export(module.exports, "DESELECT_ALL_CHANGES", () => $765746eaa8215d97$export$e83712732e630a07);
$parcel$export(module.exports, "REPLACE_SELECTED_CHANGES", () => $765746eaa8215d97$export$6eb56e01d786a268);
$parcel$export(module.exports, "SORT_CHANGES", () => $765746eaa8215d97$export$4df47d0242175a06);
$parcel$export(module.exports, "CHANGE_FILTER", () => $765746eaa8215d97$export$d02a1637d15b4bed);
$parcel$export(module.exports, "CLEAR_FILTER", () => $765746eaa8215d97$export$80f6e3f69ac5bef4);
$parcel$export(module.exports, "UPDATE_NOTIFICATION_PREFERENCE", () => $765746eaa8215d97$export$ba367bd16fc3c33c);
$parcel$export(module.exports, "CHANGE_QUICK_SELECT", () => $765746eaa8215d97$export$afe070bce8c7789a);
$parcel$export(module.exports, "expandChange", () => $765746eaa8215d97$export$5d5b64526974bb5b);
$parcel$export(module.exports, "collapseChange", () => $765746eaa8215d97$export$2c8a6ea62723bd5c);
$parcel$export(module.exports, "selectChange", () => $765746eaa8215d97$export$4711beb50aac99ca);
$parcel$export(module.exports, "selectAllChanges", () => $765746eaa8215d97$export$528e92eb1d1ed679);
$parcel$export(module.exports, "deselectChange", () => $765746eaa8215d97$export$cfdf286e64c890ef);
$parcel$export(module.exports, "deselectAllChanges", () => $765746eaa8215d97$export$f329ca2428faec41);
$parcel$export(module.exports, "replaceSelectedChanges", () => $765746eaa8215d97$export$af5446a491c79a66);
$parcel$export(module.exports, "openUpdateJiraDialog", () => $765746eaa8215d97$export$9556be913e22e834);
$parcel$export(module.exports, "closeUpdateJiraDialog", () => $765746eaa8215d97$export$63ccf6460d2b3a2d);
$parcel$export(module.exports, "closeCommitWarningFlag", () => $765746eaa8215d97$export$d9feb970119457c2);
$parcel$export(module.exports, "sortChanges", () => $765746eaa8215d97$export$6d088339d2e39cdd);
$parcel$export(module.exports, "changeFilter", () => $765746eaa8215d97$export$347972a19297a2b7);
$parcel$export(module.exports, "clearFilter", () => $765746eaa8215d97$export$77cedf2a856f1597);
$parcel$export(module.exports, "updateNotificationPreference", () => $765746eaa8215d97$export$bb54798cc2dbcdbb);
$parcel$export(module.exports, "changeQuickSelect", () => $765746eaa8215d97$export$c18a1ba68b68c2bd);
const $765746eaa8215d97$export$200e9ae2a09a2e08 = 'state.ui.top.title-bar.update-jira.OPEN_UPDATE_JIRA_DIALOG';
const $765746eaa8215d97$export$e69c7d485722335e = 'state.ui.top.title-bar.update-jira.CLOSE_UPDATE_JIRA_DIALOG';
const $765746eaa8215d97$export$21158182fc61c195 = 'state.ui.top.title-bar.update-jira.EXPAND_UPDATE_JIRA_DIALOG_CHANGE';
const $765746eaa8215d97$export$22e3a9f5b7095d0e = 'state.ui.top.title-bar.update-jira.COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE';
const $765746eaa8215d97$export$68f98813700bf28a = 'state.ui.top.title-bar.update-jira.CLOSE_COMMIT_WARNING_FLAG';
const $765746eaa8215d97$export$3988ad83d406c69a = 'state.ui.top.title-bar.update-jira.SELECT_CHANGE';
const $765746eaa8215d97$export$5279058cec1d0a47 = 'state.ui.top.title-bar.update-jira.DESELECT_CHANGE';
const $765746eaa8215d97$export$4d81e085299caab3 = 'state.ui.top.title-bar.update-jira.SELECT_ALL_CHANGES';
const $765746eaa8215d97$export$e83712732e630a07 = 'state.ui.top.title-bar.update-jira.DESELECT_ALL_CHANGES';
const $765746eaa8215d97$export$6eb56e01d786a268 = 'state.ui.top.title-bar.update-jira.REPLACE_SELECTED_CHANGES';
const $765746eaa8215d97$export$4df47d0242175a06 = 'state.ui.top.title-bar.update-jira.SORT_CHANGES';
const $765746eaa8215d97$export$d02a1637d15b4bed = 'state.ui.top.title-bar.update-jira.CHANGE_FILTER';
const $765746eaa8215d97$export$80f6e3f69ac5bef4 = 'state.ui.top.title-bar.update-jira.CLEAR_FILTER';
const $765746eaa8215d97$export$ba367bd16fc3c33c = 'state.ui.top.title-bar.update-jira.UPDATE_NOTIFICATION_PREFERENCE';
const $765746eaa8215d97$export$afe070bce8c7789a = 'state.ui.top.title-bar.update-jira.SET_QUICK_SELECT';
const $765746eaa8215d97$export$5d5b64526974bb5b = (changeId, category)=>({
        type: $765746eaa8215d97$export$21158182fc61c195,
        payload: {
            id: changeId,
            category: category
        }
    });
const $765746eaa8215d97$export$2c8a6ea62723bd5c = (changeId, category)=>({
        type: $765746eaa8215d97$export$22e3a9f5b7095d0e,
        payload: {
            id: changeId,
            category: category
        }
    });
const $765746eaa8215d97$export$4711beb50aac99ca = (changeId, category)=>({
        type: $765746eaa8215d97$export$3988ad83d406c69a,
        payload: {
            id: changeId,
            category: category
        }
    });
const $765746eaa8215d97$export$528e92eb1d1ed679 = (changes)=>({
        type: $765746eaa8215d97$export$4d81e085299caab3,
        payload: changes
    });
const $765746eaa8215d97$export$cfdf286e64c890ef = (changeId, category)=>({
        type: $765746eaa8215d97$export$5279058cec1d0a47,
        payload: {
            id: changeId,
            category: category
        }
    });
const $765746eaa8215d97$export$f329ca2428faec41 = ()=>({
        type: $765746eaa8215d97$export$e83712732e630a07
    });
const $765746eaa8215d97$export$af5446a491c79a66 = (changes)=>({
        type: $765746eaa8215d97$export$6eb56e01d786a268,
        payload: changes
    });
const $765746eaa8215d97$export$9556be913e22e834 = ()=>({
        type: $765746eaa8215d97$export$200e9ae2a09a2e08
    });
const $765746eaa8215d97$export$63ccf6460d2b3a2d = ()=>({
        type: $765746eaa8215d97$export$e69c7d485722335e
    });
const $765746eaa8215d97$export$d9feb970119457c2 = ()=>({
        type: $765746eaa8215d97$export$68f98813700bf28a
    });
const $765746eaa8215d97$export$6d088339d2e39cdd = (sortBy, sortDirection)=>({
        type: $765746eaa8215d97$export$4df47d0242175a06,
        payload: {
            sortBy: sortBy,
            sortDirection: sortDirection
        }
    });
const $765746eaa8215d97$export$347972a19297a2b7 = (payload)=>({
        type: $765746eaa8215d97$export$d02a1637d15b4bed,
        payload: payload
    });
const $765746eaa8215d97$export$77cedf2a856f1597 = (payload)=>({
        type: $765746eaa8215d97$export$80f6e3f69ac5bef4,
        payload: payload
    });
const $765746eaa8215d97$export$bb54798cc2dbcdbb = (payload)=>({
        type: $765746eaa8215d97$export$ba367bd16fc3c33c,
        payload: payload
    });
const $765746eaa8215d97$export$c18a1ba68b68c2bd = (payload)=>({
        type: $765746eaa8215d97$export$afe070bce8c7789a,
        payload: payload
    });

});

parcelRegister("hoHCC", function(module, exports) {

$parcel$export(module.exports, "setNotifyWatchersPreference", () => $aa29e707b258378f$export$d606e07e0273c036);
$parcel$export(module.exports, "getNotifyWatchersPreference", () => $aa29e707b258378f$export$3a214b30d45c783);

var $cnRoI = parcelRequire("cnRoI");
parcelRequire("1Uotp");
var $eOsHk = parcelRequire("eOsHk");

var $5rYNM = parcelRequire("5rYNM");

var $cm5m0 = parcelRequire("cm5m0");
const $aa29e707b258378f$export$d1b8c46158563cca = (issue)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const associateTargetDates = (_, key)=>{
        if (key === 'baselineStart') return 0, $eOsHk.TARGET_START_FIELD;
        if (key === 'baselineEnd') return 0, $eOsHk.TARGET_END_FIELD;
        return key;
    };
    return {
        ...issue,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        values: (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(issue.values, associateTargetDates),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        originals: (0, (/*@__PURE__*/$parcel$interopDefault($cnRoI)))(issue.originals, associateTargetDates)
    };
};
const $aa29e707b258378f$export$d606e07e0273c036 = (preference)=>(0, $cm5m0.userPreferenceAPI).set((0, $5rYNM.NOTIFY_WATCHERS_KEY), preference);
const $aa29e707b258378f$export$3a214b30d45c783 = async ()=>{
    const preference = await (0, $cm5m0.userPreferenceAPI).get((0, $5rYNM.NOTIFY_WATCHERS_KEY));
    // This value should be a boolean. If it isn't, we'll set a default in our reducer.
    return typeof preference === 'boolean' ? preference : undefined;
};

});

parcelRegister("koaLU", function(module, exports) {

$parcel$export(module.exports, "REMOVED_FROM_ACTIVE_SPRINT", () => $d6303d31d3a986b0$export$ca127c6dfeba9a68);
$parcel$export(module.exports, "ADDED_TO_ACTIVE_SPRINT", () => $d6303d31d3a986b0$export$9f2d02783b5aa8ad);
$parcel$export(module.exports, "getChangeWarning", () => $d6303d31d3a986b0$export$998fb70d79c8dba2);

var $hSiHc = parcelRequire("hSiHc");
const $d6303d31d3a986b0$export$ca127c6dfeba9a68 = 'state.updateJira.changesWarnings.REMOVED_FROM_ACTIVE_SPRINT';
const $d6303d31d3a986b0$export$9f2d02783b5aa8ad = 'state.updateJira.changesWarnings.ADDED_TO_ACTIVE_SPRINT';
const $d6303d31d3a986b0$export$998fb70d79c8dba2 = (error)=>{
    switch(error){
        case $d6303d31d3a986b0$export$ca127c6dfeba9a68:
            return [
                {
                    header: (0, $hSiHc.default).removedFromActiveSprintHeader,
                    message: (0, $hSiHc.default).removedFromActiveSprintMessage,
                    messageValues: {}
                }
            ];
        case $d6303d31d3a986b0$export$9f2d02783b5aa8ad:
            return [
                {
                    header: (0, $hSiHc.default).addedToActiveSprintHeader,
                    message: (0, $hSiHc.default).addedToActiveSprintMessage,
                    messageValues: {}
                }
            ];
        default:
            return [];
    }
};

});
parcelRegister("hSiHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca829805f81d17ba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca829805f81d17ba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removedFromActiveSprintHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.removed-from-active-sprint-header",
        "defaultMessage": "This issue has been removed from an active sprint"
    },
    removedFromActiveSprintMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.removed-from-active-sprint-message",
        "defaultMessage": "Saving this change will remove the issue from the scope of a sprint that's in progress."
    },
    addedToActiveSprintHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.added-to-active-sprint-header",
        "defaultMessage": "This issue will be added to an active sprint"
    },
    addedToActiveSprintMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.command.update-jira.added-to-active-sprint-message",
        "defaultMessage": "Saving this change will add the issue to a sprint that's already in progress."
    }
});

});




parcelRegister("4t4jv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37cbc8a2f493794$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $fZW8G = parcelRequire("fZW8G");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");

var $avgb5 = parcelRequire("avgb5");
const $b37cbc8a2f493794$var$getHiddenIssuesDialogVisibilityState = (state)=>state.ui.Top.TitleBar.HiddenIssues.isDialogOpen;
const $b37cbc8a2f493794$export$518824cf31321346 = (0, $iK4oF.createSelector)([
    // NOTE this changes count is different from just getReviewChanges.length,
    // refer selector comment for details
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getReviewChangesCount),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $avgb5.getDialogVisibilityState),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsLoading),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsSaving),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsSavingInterrupted),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsReverting),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsRevertingInterrupted),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getIsOutOfSync),
    // @ts-expect-error - TS2769 - No overload matches this call.
    $b37cbc8a2f493794$var$getHiddenIssuesDialogVisibilityState,
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $akhOi.getMode),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getCommitWarnings),
    // @ts-expect-error - TS2769 - No overload matches this call.
    (0, $eDYLe.getChangesWarnings),
    (0, $eDYLe.getCommittedChangesCount),
    (0, $eDYLe.getIsCommitWarningFlagClosed),
    (0, $eDYLe.getSelectedChangesCount),
    (0, $eDYLe.getIsLoaded),
    (0, $dhHiZ.isNonPublishingEditor),
    (0, $eDYLe.getNotificationPreference),
    (0, $kwMvv.getIsIssuesLoading)
], (changesCount, isDialogOpen, isLoading, isSaving, isSavingInterrupted, isReverting, isRevertingInterrupted, isOutOfSync, hiddenIssuesDialogIsOpen, mode, commitWarnings, changesWarnings, committedChangesCount, isCommitWarningFlagClosed, selectedChangesCount, isLoaded, // eslint-disable-next-line @typescript-eslint/no-shadow
isNonPublishingEditor, shouldNotifyWatchers, isIssuesLoading)=>({
        changesCount: changesCount,
        isDialogOpen: isDialogOpen,
        isLoading: isLoading,
        isSaving: isSaving,
        isSavingInterrupted: isSavingInterrupted,
        isReadOnly: mode !== (0, $99f9ac26081f8045$export$250171a898bf7ef),
        isOptimizing: mode === (0, $99f9ac26081f8045$export$7536581a3f6533cb),
        isOptimized: mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771),
        isReverting: isReverting,
        isRevertingInterrupted: isRevertingInterrupted,
        isOutOfSync: isOutOfSync,
        hiddenIssuesDialogIsOpen: hiddenIssuesDialogIsOpen,
        commitWarningMeta: (0, $avgb5.getCommitWarningMeta)(commitWarnings, changesWarnings, isSaving, committedChangesCount, isCommitWarningFlagClosed, isLoaded),
        selectedChangesCount: selectedChangesCount,
        isNonPublishingEditor: isNonPublishingEditor,
        shouldNotifyWatchers: shouldNotifyWatchers,
        isIssuesLoading: isIssuesLoading
    }));
const $b37cbc8a2f493794$var$changesSelector = (0, $iK4oF.createSelector)([
    (0, $eDYLe.getFilteredReviewChanges),
    (0, $eDYLe.getSortDirection),
    (0, $eDYLe.getExpandedChanges)
], (filteredReviewChanges, sortDirection, expandedChanges)=>(0, $avgb5.expandChanges)((0, $avgb5.sortChanges)(filteredReviewChanges, sortDirection), expandedChanges));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b37cbc8a2f493794$export$2e2bcd8739ae039 = (state)=>({
        ...$b37cbc8a2f493794$export$518824cf31321346(state),
        changes: $b37cbc8a2f493794$var$changesSelector(state),
        currentScenarioColor: (0, $75KhQ.getCurrentScenarioColor)(state),
        dateConfiguration: (0, $75KhQ.getDateConfiguration)(state),
        typeToLevel: (0, $fZW8G.getTypeToLevel)(state)
    });

});
parcelRegister("avgb5", function(module, exports) {

$parcel$export(module.exports, "getDialogVisibilityState", () => $0413b21da50209e1$export$2ca6bc717c6809d7);
$parcel$export(module.exports, "getCommitWarningMeta", () => $0413b21da50209e1$export$86715c8d56b29ac1);
$parcel$export(module.exports, "sortChanges", () => $0413b21da50209e1$export$6d088339d2e39cdd);
$parcel$export(module.exports, "expandChanges", () => $0413b21da50209e1$export$6c63a5e0a507d94c);

var $aH8gO = parcelRequire("aH8gO");
var $b3iuB = parcelRequire("b3iuB");
var $63hMP = parcelRequire("63hMP");
var $ldYmX = parcelRequire("ldYmX");
var $l7xwn = parcelRequire("l7xwn");
var $UCNmJ = parcelRequire("UCNmJ");

var $kwMvv = parcelRequire("kwMvv");

var $kogU9 = parcelRequire("kogU9");

var $aKueD = parcelRequire("aKueD");

var $5rYNM = parcelRequire("5rYNM");
const $0413b21da50209e1$export$2ca6bc717c6809d7 = (state)=>state.ui.Top.TitleBar.UpdateJira.isDialogOpen;
const $0413b21da50209e1$export$86715c8d56b29ac1 = (commitWarnings, changesWarnings, isSaving, committedChangesCount, isCommitWarningFlagClosed, isLoaded)=>{
    const failedCommitCount = $ldYmX.default((numWarnings, warnings)=>numWarnings + (warnings ? Object.keys(warnings).length : 0), 0, $UCNmJ.default(commitWarnings));
    return {
        commitWarningsExists: !$aH8gO.default($b3iuB.default)($UCNmJ.default(commitWarnings)) || !$aH8gO.default($b3iuB.default)($UCNmJ.default(changesWarnings)),
        shouldShowCommitWarningFlag: isLoaded && $63hMP.default(isSaving) && $63hMP.default(isCommitWarningFlagClosed),
        successfulCommitCount: committedChangesCount - failedCommitCount,
        failedCommitCount: failedCommitCount
    };
};
const $0413b21da50209e1$export$51575a0b7be323d2 = (changeA, changeB)=>{
    if (changeA.lastModified && changeB.lastModified) return changeA.lastModified.date < changeB.lastModified.date ? -1 : 1;
    return 0;
};
const $0413b21da50209e1$export$f28150f7dedb9772 = (changeA, changeB)=>{
    if (changeA.lastModified && changeB.lastModified) return changeA.lastModified.date > changeB.lastModified.date ? -1 : 1;
    return 0;
};
const $0413b21da50209e1$export$6d088339d2e39cdd = (changes, sortDirection)=>{
    if (sortDirection === 'ASC') return $l7xwn.default($0413b21da50209e1$export$f28150f7dedb9772, changes);
    return $l7xwn.default($0413b21da50209e1$export$51575a0b7be323d2, changes);
};
const $0413b21da50209e1$export$abd126f47bcb7dde = (change)=>{
    const { category: category, lastModified: lastModified, warnings: warnings, ...rest } = change;
    let changedAttributes;
    switch(change.category){
        case (0, $5rYNM.ENTITY).ISSUE:
            {
                const { type: type, details: details } = change;
                changedAttributes = [
                    ...(0, $kwMvv.getChangedAttributes)(details, type)
                ];
                break;
            }
        case (0, $5rYNM.ENTITY).RELEASE:
            {
                const { type: type, details: { values: values, originals: originals } } = change;
                changedAttributes = [
                    ...(0, $aKueD.getChangedAttributes)(values, originals, type)
                ];
                break;
            }
        case (0, $5rYNM.ENTITY).TEAM:
        case (0, $5rYNM.ENTITY).RESOURCE:
            return (0, $kogU9.expandChangesForTeam)(change);
        case (0, $5rYNM.ENTITY).SPRINT:
            changedAttributes = Object.keys(change.details.originals);
            break;
        default:
            return [];
    }
    return changedAttributes.map((attributeName)=>// NOTE due to Flow limitations in handling sum types we need to do unsafe cast here
        // therefore please pay extra attention to keep this code correct
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...rest,
            type: (0, $5rYNM.SCENARIO_TYPE).NONE,
            category: category,
            attributeName: attributeName,
            warnings: []
        }));
};
const $0413b21da50209e1$export$6c63a5e0a507d94c = (collapsedChanges, expandedChanges)=>{
    const changes = [];
    collapsedChanges.forEach((change)=>{
        const { id: id, category: category, changeCount: changeCount } = change;
        changes.push(change);
        const isExpanded = expandedChanges[category].includes(id);
        if (isExpanded && (change.type === (0, $5rYNM.SCENARIO_TYPE).ADDED || changeCount > 1)) changes.push(...$0413b21da50209e1$export$abd126f47bcb7dde(change));
    });
    return changes;
};

});


parcelRegister("hTzNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $338c847ad1d08b81$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $2ziLQ = parcelRequire("2ziLQ");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $8uD7Y = parcelRequire("8uD7Y");

var $g4Vkx = parcelRequire("g4Vkx");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $eYlCJ = parcelRequire("eYlCJ");
var $ltfxy = parcelRequire("ltfxy");
var $gwbfD = parcelRequire("gwbfD");

var $j4LwV = parcelRequire("j4LwV");

var $dw8TK = parcelRequire("dw8TK");

var $cuuJa = parcelRequire("cuuJa");

var $9didO = parcelRequire("9didO");

var $8S614 = parcelRequire("8S614");

var $fnOfj = parcelRequire("fnOfj");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $lFLge = parcelRequire("lFLge");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $iSeKM = parcelRequire("iSeKM");

var $kQxX0 = parcelRequire("kQxX0");

var $iwkze = parcelRequire("iwkze");

var $8mzXE = parcelRequire("8mzXE");

var $65T54 = parcelRequire("65T54");


var $iIRNc = parcelRequire("iIRNc");

var $75P1g = parcelRequire("75P1g");

var $1x2im = parcelRequire("1x2im");

var $k0Ls4 = parcelRequire("k0Ls4");

var $hvKbm = parcelRequire("hvKbm");

var $4TlS7 = parcelRequire("4TlS7");

var $k1mf2 = parcelRequire("k1mf2");

var $iLYmT = parcelRequire("iLYmT");

var $5OXJf = parcelRequire("5OXJf");

var $fCQQJ = parcelRequire("fCQQJ");

var $jgxY2 = parcelRequire("jgxY2");
const $338c847ad1d08b81$var$DIALOG_NON_TABLE_HEIGHT = 200;
const $338c847ad1d08b81$var$DIALOG_MIN_HEIGHT = 500;
const $338c847ad1d08b81$export$1bd567d0d45faa0b = (props, handleStopAction, openDiscardConfirmation)=>{
    const { intl: intl, isLoading: isLoading, isSaving: isSaving, isSavingInterrupted: isSavingInterrupted, isReadOnly: isReadOnly, isReverting: isReverting, isRevertingInterrupted: isRevertingInterrupted, isOutOfSync: isOutOfSync, closeDialog: closeDialog, updateJira: updateJira, selectedChangesCount: selectedChangesCount, isNonPublishingEditor: isNonPublishingEditor, isGicModalOpen: isGicModalOpen = false, clearSummaryPageCache: clearSummaryPageCache, changesCount: changesCount } = props;
    const discardAction = {
        text: intl.formatMessage((0, $k0Ls4.default).updateJiraDialogRevertButtonText),
        onClick: openDiscardConfirmation,
        appearance: 'subtle',
        isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isReverting,
        isLoading: false,
        isVisible: !(isSaving || isReadOnly || isReverting),
        testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-selected-changes'
    };
    if (!(isSaving || isReverting)) {
        if ((0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w')) return [
            discardAction,
            {
                text: intl?.formatMessage((0, $k0Ls4.default).updateJiraDialogUpdateButtonText),
                type: 'save',
                onClick: (e, analyticsEvent)=>{
                    updateJira(analyticsEvent, props.shouldNotifyWatchers);
                    clearSummaryPageCache();
                    const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED.split(' ');
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED, {
                        changesCount: changesCount,
                        isPlansUpdateReviewChangesEnabled: true
                    });
                },
                appearance: 'primary',
                isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isNonPublishingEditor || isGicModalOpen,
                isVisible: !isReadOnly,
                autoFocus: true,
                tooltip: isGicModalOpen ? intl?.formatMessage((0, $k0Ls4.default).disabledTooltipForUpdateJiraWhenGicIsOpen) : intl?.formatMessage((0, $k0Ls4.default).disabledTooltipForUpdateJira),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.save-selected-changes'
            }
        ];
        return [
            {
                text: intl.formatMessage((0, $ib5d3.default).cancel),
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onClick: (_, analyticsEvent)=>{
                    closeDialog();
                    if ((0, $7CnHa.isDefined)(analyticsEvent)) {
                        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED.split(' ');
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                            action: action,
                            actionSubject: actionSubject
                        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED, {});
                    }
                },
                appearance: 'subtle',
                testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.cancel'
            },
            {
                text: intl?.formatMessage((0, $k0Ls4.default).updateJiraDialogUpdateButtonTextOld),
                type: 'save',
                onClick: (e, analyticsEvent)=>{
                    updateJira(analyticsEvent, props.shouldNotifyWatchers);
                    clearSummaryPageCache();
                    const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED.split(' ');
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_SELECTED_CHANGES_IN_JIRA_CLICKED, {});
                },
                appearance: 'primary',
                isDisabled: isOutOfSync || isLoading || selectedChangesCount === 0 || isNonPublishingEditor || isGicModalOpen,
                isVisible: !isReadOnly,
                autoFocus: true,
                tooltip: isGicModalOpen ? intl?.formatMessage((0, $k0Ls4.default).disabledTooltipForUpdateJiraWhenGicIsOpen) : intl?.formatMessage((0, $k0Ls4.default).disabledTooltipForUpdateJira),
                testId: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.save-selected-changes'
            },
            discardAction
        ];
    }
    return [
        {
            text: !(isSavingInterrupted || isRevertingInterrupted) ? intl.formatMessage((0, $k0Ls4.default).updateJiraDialogStopButtonText) : intl.formatMessage((0, $k0Ls4.default).updateJiraDialogStoppingButtonText),
            onClick: ()=>{
                handleStopAction();
            },
            isLoading: isSavingInterrupted || isRevertingInterrupted,
            isDisabled: isSavingInterrupted || isRevertingInterrupted
        },
        discardAction
    ];
};
const $338c847ad1d08b81$var$DEFAULT_STATE = {
    isDiscardConfirmationOpen: false,
    openedDialogWithChanges: false
};
const $338c847ad1d08b81$var$DEFAULT_STATE_OLD = {
    isDiscardConfirmationOpen: false
};
// eslint-disable-next-line jira/react/no-class-components
class $338c847ad1d08b81$var$UpdateJira extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ChangesTable: $8mzXE.default,
            Footer: $hvKbm.default,
            QuickSelectors: $k1mf2.default,
            RequiredFieldsDialog: $iLYmT.default,
            ChangeStatusDialog: $kQxX0.default,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            UserFilter: (0, $9didO.default)((0, $1x2im.default))
        };
    }
    render() {
        const { intl: intl, changes: changes, changesCount: changesCount, isDialogOpen: isDialogOpen, isLoading: isLoading, isSaving: isSaving, isReadOnly: isReadOnly, isOptimizing: isOptimizing, isOptimized: isOptimized, isReverting: isReverting, isOutOfSync: isOutOfSync, openDialog: openDialog, onChangeListModified: onChangeListModified, hiddenIssuesDialogIsOpen: hiddenIssuesDialogIsOpen, closeCommitWarningFlag: closeCommitWarningFlag, commitWarningMeta: { commitWarningsExists: commitWarningsExists, shouldShowCommitWarningFlag: shouldShowCommitWarningFlag, successfulCommitCount: successfulCommitCount, failedCommitCount: failedCommitCount }, selectedChangesCount: selectedChangesCount, ChangesTable: // eslint-disable-next-line @typescript-eslint/no-shadow
        ChangesTable, Footer: // eslint-disable-next-line @typescript-eslint/no-shadow
        Footer, QuickSelectors: // eslint-disable-next-line @typescript-eslint/no-shadow
        QuickSelectors, RequiredFieldsDialog: // eslint-disable-next-line @typescript-eslint/no-shadow
        RequiredFieldsDialog, ChangeStatusDialog: // eslint-disable-next-line @typescript-eslint/no-shadow
        ChangeStatusDialog, UserFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
        UserFilter, currentScenarioColor: currentScenarioColor, dateConfiguration: dateConfiguration, typeToLevel: typeToLevel, shouldNotifyWatchers: shouldNotifyWatchers, isIssuesLoading: isIssuesLoading } = this.props;
        if ((0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') && isIssuesLoading) return null;
        let width = 'x-large';
        let height;
        let dialogContent;
        switch(true){
            case isOutOfSync:
                /* eslint-disable jsx-a11y/no-static-element-interactions */ dialogContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $fCQQJ["out-of-sync"]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                    label: "",
                    dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($8S614)))
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $fCQQJ["out-of-sync-message"],
                    onClick: this.refresh
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage((0, $k0Ls4.default).outOfSyncMessageConcurrentEditing)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, intl.formatMessage((0, $k0Ls4.default).refreshCta, {
                    span: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                            role: "button",
                            tabIndex: 0
                        }, chunks)
                }))));
                break;
            case isLoading:
                dialogContent = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $fCQQJ.spinner
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
                    size: "large"
                }));
                break;
            default:
                // NOTE The problem is putting virtualized content (Table) into a growable Modal
                //
                // Contradictions posed by the problem:
                //
                // 1. Virtualized Table requires explicit height to be set on it, because it's the
                // essence of virtualization: render only content which is visible in the given area
                // and don't push parent / don't create scroll in parent by excessive content.
                //
                // 2. In case of small rows count we want our Modal to shrink and otherwise to grow
                // until it fills a viewport (sans padding).
                //
                // To cut this Gordian knot without overcomplications we manage Modal height not by
                // pushing it with Table's element (which is tricky because of [1]), but just doing
                // a rough estimation of desired size based on typical dialog styling and number of
                // changes to display. Growth is constrained by max-height in .body style. Table
                // then uses AutoSizer to fit into actual available space for it.
                width = '90vw';
                height = Math.max($338c847ad1d08b81$var$DIALOG_NON_TABLE_HEIGHT + (0, $d5f16ccf32841b20$export$88e6c5bab2ff80e8) * changes.length, $338c847ad1d08b81$var$DIALOG_MIN_HEIGHT);
                dialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? (0, $k0Ls4.default).updateJiraDialogContent : (0, $k0Ls4.default).updateJiraDialogContentOld), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $fCQQJ.filters
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    style: {
                        flexGrow: 1
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QuickSelectors, {
                    changes: changes
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UserFilter, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangesTable, {
                    changes: changes,
                    commitWarningsExists: commitWarningsExists,
                    isUpdating: isSaving || isReverting,
                    isReadOnly: isReadOnly
                }));
        }
        const headerText = intl.formatMessage((0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? (0, $k0Ls4.default).updateJiraDialogHeader : (0, $k0Ls4.default).updateJiraDialogHeaderOld, {
            changesCount: changesCount
        });
        const changeCountBadgeOutline = currentScenarioColor === `var(--ds-border-brand, ${(0, $g4Vkx.default).B400})` ? {
            boxShadow: `0 0 0 2px ${`var(--ds-surface, ${(0, $g4Vkx.default).N0})`}`
        } : null;
        const renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
                name: "update-jira"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4LwV.default), {
                    letter: "R",
                    message: (0, $k0Ls4.default).updateJiraButtonGeneralTooltip
                }),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                onClick: openDialog,
                isDisabled: changesCount === 0 || isOptimizing,
                appearance: "primary",
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button",
                ref: this.buttonRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $fCQQJ["button-label"]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $k0Ls4.default).updateJiraButtonTextOld), changesCount > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $fCQQJ.changeCountBadge,
                style: {
                    ...changeCountBadgeOutline
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    backgroundColor: currentScenarioColor,
                    color: currentScenarioColor ? (0, $33N5G.colourPaletteTextColoursMap)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Ignored via go/DSP-18766
                    currentScenarioColor] || `var(--ds-text-inverse, ${(0, $g4Vkx.default).N0})` : `var(--ds-text-inverse, ${(0, $g4Vkx.default).N0})`
                },
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.change-count"
            }, changesCount))))));
        const shouldIncludeTimeframePlanningAnalyticsAttributes = changesCount > 0 && isDialogOpen && !isLoading && !isSaving && !isReverting;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $fCQQJ.updateJiraButton
        }, ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') || (0, $1ybV0.ff)('platform-calendar-adoption-in-plans')) && (0, $7CnHa.isDefined)(onChangeListModified) && isDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwkze.default), {
            onChangeListModified: onChangeListModified,
            changesCount: changesCount,
            isSaving: (0, $1ybV0.ff)('platform-calendar-adoption-in-plans') ? isSaving : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "reviewChanges",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            attributes: shouldIncludeTimeframePlanningAnalyticsAttributes ? {
                roadmapChangeDetails: (0, $jgxY2.getAttributesForIssuesWithTimeframeChanges)(changes, dateConfiguration, typeToLevel),
                changesCount: changesCount
            } : {}
        }, (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OXJf.default), {
            currentScenarioColor: currentScenarioColor,
            changesCount: changesCount,
            isOptimizing: isOptimizing,
            isOptimized: isOptimized,
            isReadOnly: isReadOnly,
            openDialog: this.handleOpenDialog,
            ref: this.buttonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !(changesCount === 0 || isOptimizing || isOptimized || isReadOnly) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
            shortcutKey: "KeyR",
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onKeyDown: openDialog
        }), changesCount === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: intl.formatMessage((0, $k0Ls4.default).updateJiraButtonTooltip),
            position: "bottom"
        }, renderButton()) : renderButton()), isDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null) : null, (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.state.openedDialogWithChanges ? this.renderDialog(headerText, dialogContent, width, height) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75P1g.default), {
            handleCloseDialog: this.handleCloseDialog
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            shouldReturnFocus: true,
            shouldCloseOnEscapePress: (0, $eI5EY.fg)('plans-review-dialog-disable-esc-close') ? // should only close on esc if it is NOT saving or reverting
            !(isSaving || isReverting) : true,
            onClose: this.handleCloseDialogOld,
            shouldCloseOnOverlayClick: false,
            width: width,
            height: height
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $fCQQJ.header
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", {
            className: $fCQQJ.title
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, headerText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $fCQQJ.body
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $fCQQJ.dialogContent,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-content"
        }, dialogContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RequiredFieldsDialog, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeStatusDialog, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $fCQQJ.footerParent,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, {
            leftActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TlS7.NotificationToggle), {
                active: shouldNotifyWatchers,
                onChange: this.toggleNotification
            }),
            actions: $338c847ad1d08b81$export$1bd567d0d45faa0b(this.props, this.handleStopAction, this.openDiscardConfirmation),
            selectedChangesCount: selectedChangesCount
        }))))), hiddenIssuesDialogIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iSeKM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $65T54.default), {
            successfulCommitCount: successfulCommitCount,
            failedCommitCount: failedCommitCount,
            show: shouldShowCommitWarningFlag,
            onClose: ()=>{
                closeCommitWarningFlag();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "discardChanges",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIRNc.default), {
            isOpen: this.state.isDiscardConfirmationOpen,
            onConfirm: this.handleDiscardConfirmation,
            onCancel: this.closeDiscardConfirmation
        })))));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.buttonRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.state = (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? $338c847ad1d08b81$var$DEFAULT_STATE : $338c847ad1d08b81$var$DEFAULT_STATE_OLD;
        this.toggleNotification = (next)=>{
            this.props.updateNotificationPreference(next);
        };
        this.openDiscardConfirmation = (_, analyticsEvent)=>{
            const { changesCount: changesCount } = this.props;
            this.setState({
                isDiscardConfirmationOpen: true
            });
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED.split(' ');
            if ((0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w')) (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED, {
                changesCount: changesCount,
                isPlansUpdateReviewChangesEnabled: true
            });
            else (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).DISCARD_SELECTED_CHANGES_CLICKED);
        };
        this.closeDiscardConfirmation = ()=>{
            this.setState({
                isDiscardConfirmationOpen: false
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleDiscardConfirmation = (_, analyticsEvent)=>{
            this.setState({
                isDiscardConfirmationOpen: false
            });
            this.props.revertChanges();
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVERT_SCENARIO, {
                changesCount: this.props.selectedChangesCount,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    isPlansUpdateReviewChangesEnabled: true
                } : {}
            });
        };
        this.refresh = (e)=>{
            if (e.target.getAttribute('role') === 'button') (0, $lFLge.reload)();
        };
        this.handleStopAction = ()=>{
            const { isSaving: isSaving, interruptCommitting: interruptCommitting, interruptReverting: interruptReverting } = this.props;
            if (isSaving) interruptCommitting();
            else interruptReverting();
        };
        this.handleCloseDialog = (_, analyticsEvent)=>{
            const { closeDialog: closeDialog, changesCount: changesCount } = this.props;
            if ((0, $7CnHa.isDefined)(analyticsEvent)) {
                const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED.split(' ');
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_CANCEL_CLICKED, {
                    changesCount: changesCount,
                    isPlansUpdateReviewChangesEnabled: true
                });
            }
            closeDialog();
            this.buttonRef.current?.focus();
        };
        this.handleCloseDialogOld = ()=>{
            const { closeDialog: closeDialog } = this.props;
            closeDialog();
            this.buttonRef.current?.focus();
        };
        this.renderDialog = (headerText, dialogContent, width, height)=>{
            const { intl: intl, selectedChangesCount: selectedChangesCount, RequiredFieldsDialog: RequiredFieldsDialogComponent, ChangeStatusDialog: ChangeStatusDialogComponent, Footer: FooterComponent, changesCount: changesCount, shouldNotifyWatchers: shouldNotifyWatchers, isSaving: isSaving, isReverting: isReverting } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
                attributes: {
                    changesCount: changesCount,
                    isPlansUpdateReviewChangesEnabled: true
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
                autoFocus: true,
                shouldReturnFocus: true,
                shouldCloseOnEscapePress: (0, $eI5EY.fg)('plans-review-dialog-disable-esc-close') ? // should only close on esc if it is NOT saving or reverting
                !(isSaving || isReverting) : true,
                onClose: this.handleCloseDialog,
                shouldCloseOnOverlayClick: false,
                width: width,
                height: height
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $338c847ad1d08b81$var$headerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                as: "h2",
                size: "medium"
            }, headerText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                appearance: "subtle",
                label: intl.formatMessage((0, $k0Ls4.default).closeDialog),
                spacing: "compact",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7))),
                onClick: this.handleCloseDialog,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.selected-field-remove-button"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $fCQQJ.body
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $fCQQJ.dialogContent,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-content"
            }, dialogContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RequiredFieldsDialogComponent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeStatusDialogComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $fCQQJ.footerParent,
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-dialog-footer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FooterComponent, {
                leftActions: changesCount !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TlS7.NotificationToggle), {
                    active: shouldNotifyWatchers,
                    onChange: this.toggleNotification
                }) : null,
                actions: $338c847ad1d08b81$export$1bd567d0d45faa0b(this.props, this.handleStopAction, this.openDiscardConfirmation),
                selectedChangesCount: selectedChangesCount
            })))));
        };
        this.handleOpenDialog = (e)=>{
            const { openDialog: openDialog, changesCount: changesCount } = this.props;
            this.setState({
                openedDialogWithChanges: changesCount !== 0
            });
            openDialog(e);
        };
    }
}
const $338c847ad1d08b81$var$headerStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.250',
    paddingRight: 'space.250',
    paddingLeft: 'space.250',
    paddingBottom: 'space.100',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
var $338c847ad1d08b81$export$2e2bcd8739ae039 = (0, $fnOfj.injectIntlWithDefaultProps)($338c847ad1d08b81$var$UpdateJira);

});
parcelRegister("02Sz7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $008a83972912ce1e$var$_react = $008a83972912ce1e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $008a83972912ce1e$var$_UNSAFE_baseNew = $008a83972912ce1e$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $008a83972912ce1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Close".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $008a83972912ce1e$var$CloseIcon = (props)=>/*#__PURE__*/ $008a83972912ce1e$var$_react.default.createElement($008a83972912ce1e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$008a83972912ce1e$var$CloseIcon.displayName = 'CloseIcon';
var $008a83972912ce1e$var$_default = module.exports.default = $008a83972912ce1e$var$CloseIcon;

});
parcelRegister("gCIXy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("bxHQy")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("bxHQy")).Icon);

var $bxHQy = parcelRequire("bxHQy");

});
parcelRegister("bxHQy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $68e08bf1bc6fdccc$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $68e08bf1bc6fdccc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");
function $68e08bf1bc6fdccc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68e08bf1bc6fdccc$var$commonSVGStyles = {
    name: "10ihzwq",
    styles: "overflow:hidden;pointer-events:none;stop{stop-color:currentColor;}"
};
const $68e08bf1bc6fdccc$var$svgStyles = {
    name: "x6fk93",
    styles: "color:currentColor;vertical-align:bottom"
};
const $68e08bf1bc6fdccc$var$iconStyles = {
    name: "mrp99y",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0;line-height:1;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0)"
};
const $68e08bf1bc6fdccc$var$utilityIconStyles = {
    name: "1j4yvsm",
    styles: "line-height:var(--ds-space-150, 12px)"
};
const $68e08bf1bc6fdccc$var$scaleStyles = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
/**
 * For windows high contrast mode
 */ const $68e08bf1bc6fdccc$var$baseHcmStyles = {
    name: "9vywkz",
    styles: "@media screen and (forced-colors: active){color:CanvasText;filter:grayscale(1);}"
};
const $68e08bf1bc6fdccc$var$sizeMap = {
    scale: {
        name: "1a1gyup",
        styles: "width:inherit;height:inherit"
    },
    utility: {
        name: "1w03az9",
        styles: "width:var(--ds-space-150, 12px);height:var(--ds-space-150, 12px)"
    },
    none: {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    },
    spacious: {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    }
};
const $68e08bf1bc6fdccc$var$baseSizeMap = {
    global: 16,
    utility: 12
};
const $68e08bf1bc6fdccc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eUqFw.memo)(function Icon(props) {
    const { color: color = "var(--ds-icon, #44546F)", spacing: providedSpacing = 'none', testId: testId, label: label, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, type: // Used to set icon dimensions/behaviour in codegen
    type = 'global', dangerouslySetGlyph: // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $XHGTv.getBooleanFF)('platform.design-system-team.enable-new-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $byn9U.jsx)(FallbackIcon, {
        primaryColor: color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    const spacing = type === 'utility' ? 'none' : providedSpacing;
    const baseSize = $68e08bf1bc6fdccc$var$baseSizeMap[type];
    const size = type === 'utility' ? 'utility' : shouldScale ? 'scale' : spacing;
    const viewBoxPadding = spacing === 'spacious' ? 4 : 0;
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    let iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = `
<filter id="ds-newIconOpacityFilter">
  <feFlood flood-color="var(--ds-icon-disabled)" />
  <feComposite in2="SourceGraphic" operator="in" />
</filter>
<g filter="url(#ds-newIconOpacityFilter)">
  ${dangerouslySetInnerHTML.__html}
</g>`;
        iconColor = "var(--ds-icon, #44546F)";
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $68e08bf1bc6fdccc$var$iconStyles,
            $68e08bf1bc6fdccc$var$baseHcmStyles,
            shouldScale && $68e08bf1bc6fdccc$var$scaleStyles,
            type === 'utility' && $68e08bf1bc6fdccc$var$utilityIconStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        css: [
            $68e08bf1bc6fdccc$var$commonSVGStyles,
            $68e08bf1bc6fdccc$var$svgStyles,
            $68e08bf1bc6fdccc$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $68e08bf1bc6fdccc$export$2e2bcd8739ae039 = $68e08bf1bc6fdccc$export$f04a61298a47a40f;

});



parcelRegister("9didO", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f01623ca809c4c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $31f01623ca809c4c$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class FilterItem extends (0, $eUqFw.Component) {
        componentDidUpdate(_, prevState) {
            const { parentScrollContainer: parentScrollContainer } = this.props;
            if (!parentScrollContainer) return;
            // Listen to "scroll" event only when dropdown menu is open
            if (this.state.isOpen && !prevState.isOpen) parentScrollContainer.addEventListener('scroll', this.onParentScroll);
            else if (!this.state.isOpen && prevState.isOpen) parentScrollContainer.removeEventListener('scroll', this.onParentScroll);
        }
        componentWillUnmount() {
            if (this.props.parentScrollContainer) this.props.parentScrollContainer.removeEventListener('scroll', this.onParentScroll);
        }
        render() {
            const { parentScrollContainer: parentScrollContainer, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...this.state,
                ...restProps,
                onOpenChange: this.onOpenChange,
                onQueryChange: this.onQueryChange
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                searchQuery: '',
                isOpen: !!this.props.isInitiallyOpen
            };
            this.onParentScroll = ()=>{
                if (this.state.isOpen) this.setState({
                    isOpen: false
                });
            };
            this.onOpenChange = ({ isOpen: isOpen })=>{
                this.setState({
                    isOpen: isOpen
                });
            };
            this.onQueryChange = (searchQuery)=>{
                this.setState({
                    searchQuery: searchQuery
                });
            };
        }
    };
}

});

parcelRegister("8S614", function(module, exports) {
module.exports = "<svg width=\"200\" height=\"184\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"0%\" y1=\"50.007%\" x2=\"99.999%\" y2=\"50.007%\" id=\"a\"><stop stop-color=\"#6C798F\" offset=\"0%\"></stop><stop stop-color=\"#6C798F\" stop-opacity=\".1\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"-6635.484%\" y1=\"-2%\" y2=\"-2%\" id=\"b\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"0%\" y1=\"14049%\" x2=\"10440%\" y2=\"14049%\" id=\"c\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient></defs><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M106 167.73v-39.56A40.57 40.57 0 1 0 65.45 87.6H25.88c-.004-32.416 19.521-61.643 49.47-74.049 29.948-12.406 64.42-5.548 87.341 17.375 22.92 22.923 29.774 57.397 17.364 87.344-12.41 29.947-41.639 49.468-74.055 49.46z\" fill=\"url(#a)\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 169.27v-39.56c22.406 0 40.57-18.164 40.57-40.57s-18.164-40.57-40.57-40.57-40.57 18.164-40.57 40.57H21.71C21.71 44.88 57.59 9 101.85 9s80.14 35.88 80.14 80.14-35.88 80.14-80.14 80.14v-.01z\" fill=\"#0065FF\"></path><path d=\"M182 89.14c.088-42.717-33.345-77.995-76.005-80.199-42.66-2.204-79.55 29.44-83.865 71.939L8.75 79.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3c2.525-21.65 21.705-37.435 43.436-35.748 21.731 1.686 38.246 20.242 37.4 42.022-.846 21.78-18.75 39-40.546 38.996h1.55v39.53c43.618-.876 78.538-36.453 78.6-80.08z\" fill=\"#0065FF\"></path><path d=\"M104.4 161.27h-1.55 1.55z\" fill=\"url(#b)\" transform=\"translate(-1 8)\"></path><path fill=\"url(#c)\" d=\"M0 121.71h102.85v39.57H0z\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 129.71v39.57h1.55v-39.57h-1.55z\" fill=\"#0065FF\"></path><path d=\"M102.85 121.71v39.57h1.55v-39.57h-1.55z\" fill=\"url(#c)\" transform=\"translate(-1 8)\"></path></g></svg>";

});

parcelRegister("iSeKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce2ddafb6029b38$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4Puli = parcelRequire("4Puli");

var $kHagp = parcelRequire("kHagp");

var $6zHIC = parcelRequire("6zHIC");
var $3ce2ddafb6029b38$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $kHagp.default), (0, $4Puli.default))((0, $6zHIC.default));

});
parcelRegister("4Puli", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be005481ded7b64$export$2e2bcd8739ae039);

const $6be005481ded7b64$var$mapDispatchToProps = (dispatch)=>({
        closeDialog: ()=>{
            dispatch({
                type: (0, $98b7323ecc71747d$export$b1f17581bba10917)
            });
        }
    });
var $6be005481ded7b64$export$2e2bcd8739ae039 = $6be005481ded7b64$var$mapDispatchToProps;

});

parcelRegister("kHagp", function(module, exports) {

$parcel$export(module.exports, "default", () => $29267d882e5b584f$export$2e2bcd8739ae039);

var $ehEr2 = parcelRequire("ehEr2");

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
const $29267d882e5b584f$var$getDialogVisibilityState = (state)=>state.ui.Top.TitleBar.HiddenIssues.isDialogOpen;
const $29267d882e5b584f$var$mapStateToProps = (0, $iK4oF.createSelector)([
    $29267d882e5b584f$var$getDialogVisibilityState,
    (0, $ehEr2.getProjects),
    (0, $eDYLe.getHiddenIssues)
], (isDialogOpen, projects, hiddenIssues)=>({
        isDialogOpen: isDialogOpen,
        projects: projects,
        hiddenIssues: hiddenIssues
    }));
var $29267d882e5b584f$export$2e2bcd8739ae039 = $29267d882e5b584f$var$mapStateToProps;

});

parcelRegister("6zHIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c99b50177c1e33$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2bv8J = parcelRequire("2bv8J");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cCFSU = parcelRequire("cCFSU");
var $kQ0RL = parcelRequire("kQ0RL");

var $64VaH = parcelRequire("64VaH");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $7U4Fc = parcelRequire("7U4Fc");
function $27c99b50177c1e33$var$HiddenIssuesDialog({ closeDialog: closeDialog, hiddenIssues: hiddenIssues, isDialogOpen: isDialogOpen, projects: projects }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsById = (0, $7CnHa.indexBy)((project)=>project.id, projects);
    const issueKeys = hiddenIssues.map((issue)=>{
        const project = projectsById[issue.projectId];
        return `${project.key}-${issue.issueKey}`;
    });
    let title;
    let description;
    if (hiddenIssues.length === 1) {
        const hiddenIssuesUrl = (0, $64VaH.proxyContextSafeUrl)(`/browse/${issueKeys[0]}`);
        title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27c99b50177c1e33$var$BaseButtonContainer, {
            role: "button",
            tabIndex: 0,
            onClick: ()=>(0, $lFLge.openInNewTab)(hiddenIssuesUrl),
            onKeyDown: ()=>(0, $lFLge.openInNewTab)(hiddenIssuesUrl)
        }, formatMessage((0, $7U4Fc.default).issueNotVisibleHeader, {
            issueKey: issueKeys[0],
            span: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, chunk)
        }));
        description = formatMessage((0, $7U4Fc.default).issueNotVisible);
    } else {
        const hiddenIssuesUrl = (0, $64VaH.proxyContextSafeUrl)(`/issues/?jql=key in (${issueKeys.join(', ')}) order by key`);
        title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27c99b50177c1e33$var$BaseButtonContainer, {
            role: "button",
            tabIndex: 0,
            onClick: ()=>(0, $lFLge.openInNewTab)(hiddenIssuesUrl),
            onKeyDown: ()=>(0, $lFLge.openInNewTab)(hiddenIssuesUrl)
        }, formatMessage((0, $7U4Fc.default).issuesNotVisibleHeader, {
            numIssues: hiddenIssues.length,
            span: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, chunk)
        }));
        description = formatMessage((0, $7U4Fc.default).issuesNotVisible);
    }
    return isDialogOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
        onDismissed: closeDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: "",
            primaryColor: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`
        }),
        id: "hidden-issues-info-flag",
        title: title,
        description: description
    })) : null;
}
var $27c99b50177c1e33$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $27c99b50177c1e33$var$HiddenIssuesDialog;
const $27c99b50177c1e33$var$BaseButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tjqh6uv _1myktlke _hhgo18uv _110q8stv _1newnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7U4Fc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19af3fbfd1ef2a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b19af3fbfd1ef2a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueNotVisibleHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issue-not-visible-header",
        "defaultMessage": "<span>{issueKey}</span> is no longer visible in your plan"
    },
    issueNotVisible: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issue-not-visible",
        "defaultMessage": "This issue is missing some details that are specified in the issue sources of your plan. To make this issue visible, add these missing details to the issue."
    },
    issuesNotVisibleHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issues-not-visible-header",
        "defaultMessage": "<span>{numIssues} issues</span> are no longer visible in your plan"
    },
    issuesNotVisible: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.hidden-issues.issues-not-visible",
        "defaultMessage": "These issues are missing some details that are specified in the issue sources of your plan. To make these issues visible, add these missing details to the issues."
    }
});

});



parcelRegister("kQxX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38fc3cebd688b87$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $34pY9 = parcelRequire("34pY9");

var $5MuGM = parcelRequire("5MuGM");

var $ieCmq = parcelRequire("ieCmq");
var $a38fc3cebd688b87$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5MuGM.default), (0, $34pY9.default))((0, $ieCmq.default));

});
parcelRegister("34pY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ee7580c169d5431$export$2e2bcd8739ae039);

var $2oZqS = parcelRequire("2oZqS");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$5ee7580c169d5431$export$2e2bcd8739ae039 = (dispatch)=>({
        success: ()=>{
            dispatch((0, $2oZqS.success)());
        },
        fail: ()=>{
            dispatch((0, $2oZqS.fail)());
        },
        cancel: ()=>{
            dispatch((0, $2oZqS.cancel)());
        }
    });

});

parcelRegister("5MuGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07fc9ec1441571f$export$2e2bcd8739ae039);

var $iK4oF = parcelRequire("iK4oF");
const $a07fc9ec1441571f$var$getChangeStatusDialog = (state)=>state.domain.updateJira.changeStatus;
const $a07fc9ec1441571f$var$mapStateToProps = (0, $iK4oF.createSelector)([
    $a07fc9ec1441571f$var$getChangeStatusDialog
], (changeStatus)=>({
        ...changeStatus
    }));
var $a07fc9ec1441571f$export$2e2bcd8739ae039 = $a07fc9ec1441571f$var$mapStateToProps;

});

parcelRegister("ieCmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $70f249bc0ee43c1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $1a3la = parcelRequire("1a3la");

var $2aue1 = parcelRequire("2aue1");

var $huI7r = parcelRequire("huI7r");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");
const $70f249bc0ee43c1a$var$getAriIssueId = (issueId = '', cloudId = '')=>(0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
const $70f249bc0ee43c1a$var$FocusUnlock = ()=>// a focus-lock that covers the whole body
    // effectively replaces another active lock (from modal)
    // and allows other solutions (focus-trap/ AUI) to work without interruptions
    // used to "support" AUI focus lock implementation
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        // set FocusLock to ignore all elements
        whiteList: (0, $eUqFw.useCallback)(()=>false, []),
        returnFocus: true,
        // disable autofocus in order to minimize interference
        autoFocus: false
    });
const $70f249bc0ee43c1a$var$ChangeStatusDialog = ({ isWaiting: isWaiting, issueKeyInJira: issueKeyInJira, transitionId: transitionId, issueId: issueId, success: success, fail: fail, cancel: cancel })=>{
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const cloudId = (0, $dWLk9.useCloudId)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isWaiting) return;
        const handleDialogSuccess = ()=>success();
        const handleDialogCancel = ()=>cancel();
        const handleDialogError = ()=>fail();
        const issueKey = (0, $6vrw7.toIssueKey)(issueKeyInJira || '');
        const transitionIdString = transitionId || '';
        const ariIssueId = $70f249bc0ee43c1a$var$getAriIssueId(issueId, cloudId);
        openIssueTransitionModal?.({
            payload: {
                issueId: ariIssueId,
                issueKey: issueKey,
                transitionId: transitionIdString
            },
            triggerPointKey: 'issue-transition-advanced-roadmaps-jira-transition',
            onDialogSuccess: handleDialogSuccess,
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError
        });
    }, [
        isWaiting,
        issueKeyInJira,
        transitionId,
        success,
        cancel,
        fail,
        openIssueTransitionModal,
        issueId,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aue1.default), null, (stackIndex)=>stackIndex ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70f249bc0ee43c1a$var$FocusUnlock, null) : null);
};
var $70f249bc0ee43c1a$export$2e2bcd8739ae039 = $70f249bc0ee43c1a$var$ChangeStatusDialog;

});
parcelRegister("2aue1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cee3ee5f6377c07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $9cee3ee5f6377c07$var$isAuiDialogEvent = (ev)=>{
    if (!(ev instanceof CustomEvent)) return false;
    const hasAuiDialogElement = ev.detail?.layerElement?.classList?.contains('aui-dialog2');
    return hasAuiDialogElement;
};
class $9cee3ee5f6377c07$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        document.addEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
        document.addEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
        document.addEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
        document.addEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
    }
    componentWillUnmount() {
        document.removeEventListener('legacyJiraDialogBeforeShow', this.incrementStackIndex);
        document.removeEventListener('legacyJiraDialogBeforeHide', this.decrementStackIndex);
        document.removeEventListener('on-before-aui-layer-show', this.incrementStackIndexWhenAuiDialog);
        document.removeEventListener('on-before-aui-layer-hide', this.decrementStackIndexWhenAuiDialog);
    }
    render() {
        /**
		 * Currently not all event listeners are being triggered, so the stackIndex
		 * smaller then 1 is being blocked.
		 * https://hello.atlassian.net/wiki/spaces/JSDee/pages/1781258277/Bento+Modal+View+-+FocusLock+Problem
		 */ return this.props.children(this.state.stackIndex);
    }
    constructor(...args){
        super(...args);
        this.state = {
            stackIndex: 0
        };
        this.incrementStackIndex = ()=>{
            this.setState((oldState)=>({
                    stackIndex: oldState.stackIndex + 1
                }));
        };
        this.decrementStackIndex = ()=>{
            this.setState((oldState)=>({
                    stackIndex: oldState.stackIndex - 1
                }));
        };
        this.incrementStackIndexWhenAuiDialog = (ev)=>{
            if (!$9cee3ee5f6377c07$var$isAuiDialogEvent(ev)) return;
            this.incrementStackIndex();
        };
        this.decrementStackIndexWhenAuiDialog = (ev)=>{
            if (!$9cee3ee5f6377c07$var$isAuiDialogEvent(ev)) return;
            this.decrementStackIndex();
        };
    }
}

});



parcelRegister("iwkze", function(module, exports) {

$parcel$export(module.exports, "default", () => $a37038020f811165$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
const $a37038020f811165$var$ChangesCountMonitorNew = ({ changesCount: changesCount, onChangeListModified: onChangeListModified, isSaving: isSaving })=>{
    const lastCount = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isSaving) {
            // No need to trigger it when the component first mounts.
            if (lastCount.current !== undefined && lastCount.current !== changesCount) // trigger callback when changes are saved or discarded.
            onChangeListModified();
            lastCount.current = changesCount;
        }
    }, [
        changesCount,
        onChangeListModified,
        isSaving
    ]);
    return null;
};
const $a37038020f811165$var$ChangesCountMonitorOld = ({ changesCount: changesCount, onChangeListModified: onChangeListModified })=>{
    const lastCount = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        // No need to trigger it when the component first mounts.
        if (lastCount.current !== undefined) // trigger callback when changes are saved or discarded.
        onChangeListModified();
        lastCount.current = changesCount;
    }, [
        changesCount,
        onChangeListModified
    ]);
    return null;
};
const $a37038020f811165$var$ChangesCountMonitor = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('platform-calendar-adoption-in-plans'), $a37038020f811165$var$ChangesCountMonitorNew, $a37038020f811165$var$ChangesCountMonitorOld);
var $a37038020f811165$export$2e2bcd8739ae039 = $a37038020f811165$var$ChangesCountMonitor;

});

parcelRegister("8mzXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $257310571f883afe$export$2e2bcd8739ae039);

var $6BdUl = parcelRequire("6BdUl");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $lNNXV = parcelRequire("lNNXV");

var $fABaF = parcelRequire("fABaF");

var $16PRZ = parcelRequire("16PRZ");

var $aDx1G = parcelRequire("aDx1G");

var $6fjvW = parcelRequire("6fjvW");
const $257310571f883afe$var$View = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('jsw.roadmaps.jca11y-505-review-table-switch-to-treegrid-component_s0cfc'), (0, $6fjvW.default), (0, $aDx1G.default));
var $257310571f883afe$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6BdUl)))((0, $6fjvW.withScrollTracking), (0, $lNNXV.connect)((0, $16PRZ.default), (0, $fABaF.default)))($257310571f883afe$var$View);

});
parcelRegister("6BdUl", function(module, exports) {

module.exports = (parcelRequire("bAiwi"));

});
parcelRegister("bAiwi", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $86f16c296470f0ea$var$func = $jFIrw('flowRight', (parcelRequire("dNhRY")));

$86f16c296470f0ea$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $86f16c296470f0ea$var$func;

});
parcelRegister("dNhRY", function(module, exports) {

var $fpEqY = parcelRequire("fpEqY");
/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */ var $a0adb679f56a9638$var$flowRight = $fpEqY(true);
module.exports = $a0adb679f56a9638$var$flowRight;

});



parcelRegister("fABaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf79331b8022ae39$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf79331b8022ae39$export$2e2bcd8739ae039 = (dispatch)=>({
        sortChanges: (sortBy, sortDirection)=>{
            dispatch((0, $7SlBO.sortChanges)(sortBy, sortDirection));
        }
    });

});

parcelRegister("16PRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37b19cd87ad9b73$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
var $b37b19cd87ad9b73$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    sortBy: (0, $eDYLe.getSortBy),
    sortDirection: (0, $eDYLe.getSortDirection),
    useTwpTeams: (state)=>!!(0, $75KhQ.getPlan)(state).useTwpTeams
});

});

parcelRegister("aDx1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $daafec0d0855728a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $kjklK = parcelRequire("kjklK");

var $l53D0 = parcelRequire("l53D0");

var $gTPnA = parcelRequire("gTPnA");

var $8Kx08 = parcelRequire("8Kx08");

var $cSu9v = parcelRequire("cSu9v");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $1FoRq = parcelRequire("1FoRq");
var $gevkk = parcelRequire("gevkk");

var $H9kkp = parcelRequire("H9kkp");

var $cuuJa = parcelRequire("cuuJa");

var $jgxY2 = parcelRequire("jgxY2");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $8tcM1 = parcelRequire("8tcM1");


var $9fc7m = parcelRequire("9fc7m");

var $i4Ev2 = parcelRequire("i4Ev2");

var $dyxrg = parcelRequire("dyxrg");

var $7Iztn = parcelRequire("7Iztn");

var $bIGyx = parcelRequire("bIGyx");

var $kKHqc = parcelRequire("kKHqc");

var $k0duZ = parcelRequire("k0duZ");

var $hPUoO = parcelRequire("hPUoO");

var $7MVun = parcelRequire("7MVun");

var $azMYX = parcelRequire("azMYX");

var $csJwr = parcelRequire("csJwr");

var $cJYh4 = parcelRequire("cJYh4");

var $3VL1h = parcelRequire("3VL1h");
// eslint-disable-next-line jira/react/no-class-components
class $daafec0d0855728a$var$ChangesTable extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            commitWarningsExists: false,
            ValueChangeComponent: (0, $csJwr.default),
            WhatChangedComponent: (0, $3VL1h.default),
            SelectChangeHeader: $7Iztn.default,
            SelectChangeCell: $dyxrg.default,
            IssueTitleCell: $k0duZ.default
        };
    }
    render() {
        const { changes: changes, commitWarningsExists: commitWarningsExists, intl: intl, isReadOnly: isReadOnly, handleScroll: handleScroll, sortDirection: sortDirection, sortBy: sortBy } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $bIGyx.container,
            "data-name": "update-jira-dialog-content",
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table",
            "aria-label": intl.formatMessage((0, $i4Ev2.default).tableAriaLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1FoRq.AutoSizer), null, ({ width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Table), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.centralise-react-virtualized-overflow-styles') ? 'changesTable' : $bIGyx.table,
                gridClassName: $bIGyx.grid,
                width: width,
                height: height,
                headerHeight: 20,
                headerClassName: $bIGyx.columnHeader,
                rowHeight: (0, $d5f16ccf32841b20$export$88e6c5bab2ff80e8),
                rowCount: changes.length,
                rowGetter: ({ index: index })=>changes[index],
                rowClassName: $bIGyx.tableRow,
                sort: this.sort,
                sortDirection: sortDirection,
                sortBy: sortBy,
                onScroll: handleScroll
            }, commitWarningsExists && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                dataKey: "warnings",
                width: 25,
                cellRenderer: this.commitWarningCellRenderer,
                disableSort: true
            }), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                label: this.selectColumnHeaderRenderer(),
                dataKey: "isSelected",
                width: 30,
                cellRenderer: this.selectCellRenderer,
                disableSort: true,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    headerRenderer: this.tableHeaderRenderer
                } : {}
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                label: intl.formatMessage((0, $i4Ev2.default).titleColumnHeader),
                dataKey: "details",
                width: 100,
                cellRenderer: this.titleCellRenderer,
                flexGrow: 1,
                disableSort: true,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    headerRenderer: this.tableHeaderRenderer
                } : {}
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                width: 150,
                label: intl.formatMessage((0, $i4Ev2.default).categoryColumnHeader),
                dataKey: "category",
                cellRenderer: this.categoryCellRenderer,
                disableSort: true,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    headerRenderer: this.tableHeaderRenderer
                } : {}
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                width: 250,
                label: intl.formatMessage((0, $i4Ev2.default).whatChangedColumnHeader),
                dataKey: "type",
                cellRenderer: this.whatChangedCellRenderer,
                disableSort: true,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    headerRenderer: this.tableHeaderRenderer
                } : {}
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                width: 150,
                dataKey: (0, $cJYh4.VALUE_TYPE).CURRENT,
                cellRenderer: this.valueCellRenderer,
                headerRenderer: this.oldValueColumnHeaderRenderer,
                disableSort: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                width: 150,
                label: intl.formatMessage((0, $ib5d3.default).new),
                dataKey: (0, $cJYh4.VALUE_TYPE).NEW,
                cellRenderer: this.valueCellRenderer,
                disableSort: true,
                ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                    headerRenderer: this.tableHeaderRenderer
                } : {}
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gevkk.Column), {
                width: 150,
                label: intl.formatMessage((0, $i4Ev2.default).lastModifiedColumnHeader),
                dataKey: "lastModified",
                headerRenderer: this.lastModifiedColumnHeaderRenderer,
                cellRenderer: this.lastModifiedCellRenderer
            }))));
    }
    constructor(...args){
        super(...args);
        this.selectColumnHeaderRenderer = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { SelectChangeHeader: SelectChangeHeader, changes: changes, isUpdating: isUpdating } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectChangeHeader, {
                changes: changes,
                isUpdating: isUpdating
            });
        };
        this.selectCellRenderer = ({ rowData: rowData })=>{
            const { id: id, category: category, type: type } = rowData;
            if (type === (0, $5rYNM.SCENARIO_TYPE).NONE) return null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let items = [
                {
                    id: id,
                    category: category
                }
            ];
            if ((category === (0, $5rYNM.ENTITY).TEAM || category === (0, $5rYNM.ENTITY).RESOURCE) && rowData.details.changes.length > 0) {
                items = [];
                const uniqIds = new Set();
                const addItem = (item)=>{
                    const uniqId = `${item.category}:${item.id}`;
                    if (!uniqIds.has(uniqId)) {
                        uniqIds.add(uniqId);
                        items.push(item);
                    }
                };
                const changes = rowData.details.changes;
                for (const change of changes)if (change.category === (0, $5rYNM.ENTITY).RESOURCE) addItem({
                    id: change.resourceId,
                    category: change.category
                });
                else addItem({
                    id: id,
                    category: category
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { isUpdating: isUpdating, SelectChangeCell: SelectChangeCell } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectChangeCell, {
                id: (0, $jgxY2.getIdForChangeCategory)(id, category),
                items: items,
                isUpdating: isUpdating
            });
        };
        this.titleCellRenderer = ({ rowData: rowData })=>{
            const change = rowData;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { IssueTitleCell: IssueTitleCell, useTwpTeams: useTwpTeams = false } = this.props;
            if (change.type !== (0, $5rYNM.SCENARIO_TYPE).NONE) switch(change.category){
                case (0, $5rYNM.ENTITY).ISSUE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueTitleCell, {
                        details: change.details
                    });
                case (0, $5rYNM.ENTITY).RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPUoO.default), {
                        details: change.details
                    });
                case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKHqc.default), {
                        crossProjectVersion: change.details.values
                    });
                case (0, $5rYNM.ENTITY).TEAM:
                case (0, $5rYNM.ENTITY).RESOURCE:
                    {
                        const teamDetail = change.details;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azMYX.default), {
                            name: teamDetail.title.name,
                            avatarUrl: teamDetail.title.avatarUrl,
                            useTwpTeams: useTwpTeams,
                            id: change.id,
                            category: change.category
                        });
                    }
                case (0, $5rYNM.ENTITY).SPRINT:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7MVun.default), {
                        sprint: change.details.values,
                        id: change.id,
                        category: change.category
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
        };
        this.categoryCellRenderer = ({ cellData: cellData, rowData: rowData })=>{
            const { intl: intl } = this.props;
            const { type: type } = rowData;
            if (type !== (0, $5rYNM.SCENARIO_TYPE).NONE) switch(cellData){
                case (0, $5rYNM.ENTITY).ISSUE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $i4Ev2.default).issueCategory));
                case (0, $5rYNM.ENTITY).TEAM:
                case (0, $5rYNM.ENTITY).RESOURCE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $i4Ev2.default).teamCategory));
                case (0, $5rYNM.ENTITY).RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $i4Ev2.default).releaseCategory));
                case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $ib5d3.default).crossProjectRelease));
                case (0, $5rYNM.ENTITY).SPRINT:
                    {
                        const schedulingMode = $kjklK.default([
                            'details',
                            'values',
                            'schedulingMode'
                        ], rowData);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage(schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban ? (0, $i4Ev2.default).iterationCategory : (0, $i4Ev2.default).sprintCategory));
                    }
                default:
                    return null;
            }
            return null;
        };
        this.whatChangedCellRenderer = ({ cellData: cellData, rowData: rowData })=>{
            const { WhatChangedComponent: WhatChangedComponent } = this.props;
            const scenarioType = cellData;
            const { attributeName: attributeName, changeCount: changeCount, id: id, category: category } = rowData;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WhatChangedComponent, {
                attributeName: attributeName,
                changeType: scenarioType,
                changeCount: changeCount,
                id: id,
                category: category,
                changeDetails: rowData
            });
        };
        this.commitWarningCellRenderer = ({ cellData: cellData })=>{
            if ($b3iuB.default(cellData)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tcM1.default), {
                warnings: cellData
            });
        };
        this.valueCellRenderer = ({ dataKey: dataKey, rowData: rowData })=>{
            const { ValueChangeComponent: ValueChangeComponent } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueChangeComponent, {
                change: rowData,
                valueType: dataKey
            });
        };
        this.lastModifiedCellRenderer = ({ cellData: { date: date, title: title, personId: personId, avatarUrl: avatarUrl, dateFormat: dateFormat } = {} })=>{
            if (!personId) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9fc7m.default), {
                date: date,
                title: title,
                personId: personId,
                avatarUrl: avatarUrl,
                dateFormat: dateFormat
            });
        };
        this.lastModifiedColumnHeaderRenderer = ()=>{
            const { intl: intl, sortDirection: sortDirection } = this.props;
            return (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $daafec0d0855728a$var$lastModifiedHeaderStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, intl.formatMessage((0, $i4Ev2.default).lastModifiedColumnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $daafec0d0855728a$var$lastModifiedHeaderArrowStyles
            }, sortDirection === 'ASC' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Kx08))), {
                label: "Sort ascending"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l53D0))), {
                label: "Sort descending"
            }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bIGyx.modifiedColumnHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "data-sortdir": sortDirection
            }, intl.formatMessage((0, $i4Ev2.default).lastModifiedColumnHeader)));
        };
        this.oldValueColumnHeaderRenderer = ()=>{
            const { intl: intl } = this.props;
            return (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $daafec0d0855728a$var$columnHeaderStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, intl.formatMessage((0, $i4Ev2.default).oldValueColumnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span",
                xcss: $daafec0d0855728a$var$columnHeaderArrowStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTPnA))), {
                label: ""
            }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $bIGyx.oldColumnHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $i4Ev2.default).oldValueColumnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $bIGyx.oldColumnHeaderArrow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                label: "",
                size: "small"
            })));
        };
        this.tableHeaderRenderer = ({ label: label })=>label;
        this.sort = ()=>{
            const { sortChanges: sortChanges, sortDirection: sortDirection, sortBy: sortBy } = this.props;
            sortChanges(sortBy, sortDirection === 'ASC' ? 'DESC' : 'ASC');
        };
    }
}
var $daafec0d0855728a$export$2e2bcd8739ae039 = (0, $2qhQi.default)($daafec0d0855728a$var$ChangesTable);
const $daafec0d0855728a$var$lastModifiedHeaderStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    outline: 'none',
    gap: 'space.050'
});
const $daafec0d0855728a$var$lastModifiedHeaderArrowStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignSelf: 'center'
});
const $daafec0d0855728a$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $daafec0d0855728a$var$columnHeaderArrowStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.075'
});
const $daafec0d0855728a$export$391633ede08dabb1 = (WrappedComponent)=>// eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $H9kkp.default), {
            // @ts-expect-error Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'InteractionMetricType'.
            analyticsEvent: (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_SCROLLED
        }, (handleScroll)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                handleScroll: handleScroll
            }));

});
parcelRegister("l53D0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f58ce116508c34ca$var$_react = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $f58ce116508c34ca$var$_UNSAFE_baseNew = $f58ce116508c34ca$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $f58ce116508c34ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f58ce116508c34ca$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f58ce116508c34ca$var$_react.default.createElement($f58ce116508c34ca$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 14.25V1M3 9.25l5 5 5-5"/>`
    }, props));
$f58ce116508c34ca$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f58ce116508c34ca$var$_default = module.exports.default = $f58ce116508c34ca$var$ArrowDownIcon;

});

parcelRegister("gTPnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 8H1m8.25-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});

parcelRegister("8Kx08", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65ec37f1dfc82391$var$_react = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $65ec37f1dfc82391$var$_UNSAFE_baseNew = $65ec37f1dfc82391$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $65ec37f1dfc82391$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: Multi-purpose
 * Location: ADS
 * Usage guidance: Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65ec37f1dfc82391$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $65ec37f1dfc82391$var$_react.default.createElement($65ec37f1dfc82391$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75V15M3 6.75l5-5 5 5"/>`
    }, props));
$65ec37f1dfc82391$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $65ec37f1dfc82391$var$_default = module.exports.default = $65ec37f1dfc82391$var$ArrowUpIcon;

});

parcelRegister("gevkk", function(module, exports) {

$parcel$export(module.exports, "Column", () => $25323278c5202e02$export$816b5d811295e6bc);
$parcel$export(module.exports, "Table", () => $25323278c5202e02$export$54ec01a60f47d33d);
/**
 * Big library ,
 * A proxy to deep import parts we use only
 */ 
var $lbpa0 = parcelRequire("lbpa0");

var $hoaeP = parcelRequire("hoaeP");

var $9Ar1p = parcelRequire("9Ar1p");

var $1FoRq = parcelRequire("1FoRq");
// @ts-expect-error - TS2352 - Conversion of type 'typeof Column' to type 'ComponentType<ColumnProps>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $25323278c5202e02$export$816b5d811295e6bc = (0, $lbpa0.Column);
// @ts-expect-error - TS2352 - Conversion of type 'typeof Table' to type 'ComponentType<TableProps>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $25323278c5202e02$export$54ec01a60f47d33d = (0, $lbpa0.Table);

});
parcelRegister("lbpa0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Table = module.exports.SortIndicator = module.exports.SortDirection = module.exports.Column = module.exports.defaultRowRenderer = module.exports.defaultHeaderRenderer = module.exports.defaultHeaderRowRenderer = module.exports.defaultCellRenderer = module.exports.defaultCellDataGetter = module.exports.createMultiSort = undefined;

var $hdb2x = parcelRequire("hdb2x");
var $f6be245f83cc692a$var$_createMultiSort2 = $f6be245f83cc692a$var$_interopRequireDefault($hdb2x);

var $h6vU1 = parcelRequire("h6vU1");
var $f6be245f83cc692a$var$_defaultCellDataGetter2 = $f6be245f83cc692a$var$_interopRequireDefault($h6vU1);

var $gxQHn = parcelRequire("gxQHn");
var $f6be245f83cc692a$var$_defaultCellRenderer2 = $f6be245f83cc692a$var$_interopRequireDefault($gxQHn);

var $jkyQ4 = parcelRequire("jkyQ4");
var $f6be245f83cc692a$var$_defaultHeaderRowRenderer2 = $f6be245f83cc692a$var$_interopRequireDefault($jkyQ4);

var $6l3WB = parcelRequire("6l3WB");
var $f6be245f83cc692a$var$_defaultHeaderRenderer2 = $f6be245f83cc692a$var$_interopRequireDefault($6l3WB);

var $fNj79 = parcelRequire("fNj79");
var $f6be245f83cc692a$var$_defaultRowRenderer2 = $f6be245f83cc692a$var$_interopRequireDefault($fNj79);

var $451Zf = parcelRequire("451Zf");
var $f6be245f83cc692a$var$_Column2 = $f6be245f83cc692a$var$_interopRequireDefault($451Zf);

var $eA46i = parcelRequire("eA46i");
var $f6be245f83cc692a$var$_SortDirection2 = $f6be245f83cc692a$var$_interopRequireDefault($eA46i);

var $9qrbQ = parcelRequire("9qrbQ");
var $f6be245f83cc692a$var$_SortIndicator2 = $f6be245f83cc692a$var$_interopRequireDefault($9qrbQ);

var $4Ywfp = parcelRequire("4Ywfp");
var $f6be245f83cc692a$var$_Table2 = $f6be245f83cc692a$var$_interopRequireDefault($4Ywfp);
function $f6be245f83cc692a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $f6be245f83cc692a$var$_Table2.default;
module.exports.createMultiSort = $f6be245f83cc692a$var$_createMultiSort2.default;
module.exports.defaultCellDataGetter = $f6be245f83cc692a$var$_defaultCellDataGetter2.default;
module.exports.defaultCellRenderer = $f6be245f83cc692a$var$_defaultCellRenderer2.default;
module.exports.defaultHeaderRowRenderer = $f6be245f83cc692a$var$_defaultHeaderRowRenderer2.default;
module.exports.defaultHeaderRenderer = $f6be245f83cc692a$var$_defaultHeaderRenderer2.default;
module.exports.defaultRowRenderer = $f6be245f83cc692a$var$_defaultRowRenderer2.default;
module.exports.Column = $f6be245f83cc692a$var$_Column2.default;
module.exports.SortDirection = $f6be245f83cc692a$var$_SortDirection2.default;
module.exports.SortIndicator = $f6be245f83cc692a$var$_SortIndicator2.default;
module.exports.Table = $f6be245f83cc692a$var$_Table2.default;

});
parcelRegister("hdb2x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $azEBZ = parcelRequire("azEBZ");
var $c87c36e03655fa16$var$_keys2 = $c87c36e03655fa16$var$_interopRequireDefault($azEBZ);
module.exports.default = $c87c36e03655fa16$var$createMultiSort;
function $c87c36e03655fa16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c87c36e03655fa16$var$createMultiSort(sortCallback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, defaultSortBy = _ref.defaultSortBy, _ref$defaultSortDirec = _ref.defaultSortDirection, defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;
    if (!sortCallback) throw Error('Required parameter "sortCallback" not specified');
    var sortBy = defaultSortBy || [];
    var sortDirection = {};
    sortBy.forEach(function(dataKey) {
        sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
    });
    function sort(_ref2) {
        var defaultSortDirection = _ref2.defaultSortDirection, event = _ref2.event, dataKey = _ref2.sortBy;
        if (event.shiftKey) {
            // Shift + click appends a column to existing criteria
            if (sortDirection.hasOwnProperty(dataKey)) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else {
                sortDirection[dataKey] = defaultSortDirection;
                sortBy.push(dataKey);
            }
        } else if (event.ctrlKey || event.metaKey) {
            // Control + click removes column from sort (if pressent)
            var index = sortBy.indexOf(dataKey);
            if (index >= 0) {
                sortBy.splice(index, 1);
                delete sortDirection[dataKey];
            }
        } else {
            // Clear sortBy array of all non-selected keys
            sortBy.length = 0;
            sortBy.push(dataKey);
            // Clear sortDirection object of all non-selected keys
            var sortDirectionKeys = (0, $c87c36e03655fa16$var$_keys2.default)(sortDirection);
            sortDirectionKeys.forEach(function(key) {
                if (key !== dataKey) delete sortDirection[key];
            });
            // If key is already selected, reverse sort direction.
            // Else, set sort direction to default direction.
            if (sortDirection.hasOwnProperty(dataKey)) sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
            else sortDirection[dataKey] = defaultSortDirection;
        }
        // Notify application code
        sortCallback({
            sortBy: sortBy,
            sortDirection: sortDirection
        });
    }
    return {
        sort: sort,
        sortBy: sortBy,
        sortDirection: sortDirection
    };
}

});

parcelRegister("h6vU1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c73bbe675c0c66da$var$defaultCellDataGetter;
parcelRequire("c9TMT");
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */ function $c73bbe675c0c66da$var$defaultCellDataGetter(_ref) {
    var dataKey = _ref.dataKey, rowData = _ref.rowData;
    if (typeof rowData.get === 'function') return rowData.get(dataKey);
    else return rowData[dataKey];
}

});
parcelRegister("c9TMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.bpfrpt_proptype_HeaderRendererParams = module.exports.bpfrpt_proptype_HeaderRowRendererParams = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellDataGetterParams = undefined;

var $1Qivz = parcelRequire("1Qivz");
var $8da199901aa52610$var$_propTypes2 = $8da199901aa52610$var$_interopRequireDefault($1Qivz);
function $8da199901aa52610$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8da199901aa52610$var$bpfrpt_proptype_CellDataGetterParams = null;
var $8da199901aa52610$var$bpfrpt_proptype_CellRendererParams = null;
var $8da199901aa52610$var$bpfrpt_proptype_HeaderRowRendererParams = null;
var $8da199901aa52610$var$bpfrpt_proptype_HeaderRendererParams = null;
var $8da199901aa52610$var$bpfrpt_proptype_RowRendererParams = null;
module.exports.bpfrpt_proptype_CellDataGetterParams = $8da199901aa52610$var$bpfrpt_proptype_CellDataGetterParams;
module.exports.bpfrpt_proptype_CellRendererParams = $8da199901aa52610$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_HeaderRowRendererParams = $8da199901aa52610$var$bpfrpt_proptype_HeaderRowRendererParams;
module.exports.bpfrpt_proptype_HeaderRendererParams = $8da199901aa52610$var$bpfrpt_proptype_HeaderRendererParams;
module.exports.bpfrpt_proptype_RowRendererParams = $8da199901aa52610$var$bpfrpt_proptype_RowRendererParams;

});


parcelRegister("gxQHn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0b89b489716cb70$var$defaultCellRenderer;
parcelRequire("c9TMT");
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */ function $c0b89b489716cb70$var$defaultCellRenderer(_ref) {
    var cellData = _ref.cellData;
    if (cellData == null) return '';
    else return String(cellData);
}

});

parcelRegister("jkyQ4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e12ae8d774ee0649$var$defaultHeaderRowRenderer;

var $eUqFw = parcelRequire("eUqFw");
var $e12ae8d774ee0649$var$React = $e12ae8d774ee0649$var$_interopRequireWildcard($eUqFw);
parcelRequire("c9TMT");

var $1Qivz = parcelRequire("1Qivz");
var $e12ae8d774ee0649$var$_propTypes2 = $e12ae8d774ee0649$var$_interopRequireDefault($1Qivz);
function $e12ae8d774ee0649$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e12ae8d774ee0649$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e12ae8d774ee0649$var$defaultHeaderRowRenderer(_ref) {
    var className = _ref.className, columns = _ref.columns, style = _ref.style;
    return $e12ae8d774ee0649$var$React.createElement('div', {
        className: className,
        role: 'row',
        style: style
    }, columns);
}
$e12ae8d774ee0649$var$defaultHeaderRowRenderer.propTypes = null;

});

parcelRegister("6l3WB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49d7c37c64fe211c$var$defaultHeaderRenderer;

var $eUqFw = parcelRequire("eUqFw");
var $49d7c37c64fe211c$var$React = $49d7c37c64fe211c$var$_interopRequireWildcard($eUqFw);

var $9qrbQ = parcelRequire("9qrbQ");
var $49d7c37c64fe211c$var$_SortIndicator2 = $49d7c37c64fe211c$var$_interopRequireDefault($9qrbQ);
parcelRequire("c9TMT");

var $1Qivz = parcelRequire("1Qivz");
var $49d7c37c64fe211c$var$_propTypes2 = $49d7c37c64fe211c$var$_interopRequireDefault($1Qivz);
function $49d7c37c64fe211c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49d7c37c64fe211c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
/**
 * Default table header renderer.
 */ function $49d7c37c64fe211c$var$defaultHeaderRenderer(_ref) {
    var dataKey = _ref.dataKey, label = _ref.label, sortBy = _ref.sortBy, sortDirection = _ref.sortDirection;
    var showSortIndicator = sortBy === dataKey;
    var children = [
        $49d7c37c64fe211c$var$React.createElement('span', {
            className: 'ReactVirtualized__Table__headerTruncatedText',
            key: 'label',
            title: typeof label === 'string' ? label : null
        }, label)
    ];
    if (showSortIndicator) children.push($49d7c37c64fe211c$var$React.createElement($49d7c37c64fe211c$var$_SortIndicator2.default, {
        key: 'SortIndicator',
        sortDirection: sortDirection
    }));
    return children;
}
$49d7c37c64fe211c$var$defaultHeaderRenderer.propTypes = null;

});
parcelRegister("9qrbQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6dcba2271da8e808$var$SortIndicator;

var $96Bek = parcelRequire("96Bek");
var $6dcba2271da8e808$var$_clsx2 = $6dcba2271da8e808$var$_interopRequireDefault($96Bek);

var $1Qivz = parcelRequire("1Qivz");
var $6dcba2271da8e808$var$_propTypes2 = $6dcba2271da8e808$var$_interopRequireDefault($1Qivz);

var $eUqFw = parcelRequire("eUqFw");
var $6dcba2271da8e808$var$React = $6dcba2271da8e808$var$_interopRequireWildcard($eUqFw);

var $eA46i = parcelRequire("eA46i");
var $6dcba2271da8e808$var$_SortDirection2 = $6dcba2271da8e808$var$_interopRequireDefault($eA46i);
function $6dcba2271da8e808$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $6dcba2271da8e808$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */ function $6dcba2271da8e808$var$SortIndicator(_ref) {
    var sortDirection = _ref.sortDirection;
    var classNames = (0, $6dcba2271da8e808$var$_clsx2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
        'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === $6dcba2271da8e808$var$_SortDirection2.default.ASC,
        'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === $6dcba2271da8e808$var$_SortDirection2.default.DESC
    });
    return $6dcba2271da8e808$var$React.createElement('svg', {
        className: classNames,
        width: 18,
        height: 18,
        viewBox: '0 0 24 24'
    }, sortDirection === $6dcba2271da8e808$var$_SortDirection2.default.ASC ? $6dcba2271da8e808$var$React.createElement('path', {
        d: 'M7 14l5-5 5 5z'
    }) : $6dcba2271da8e808$var$React.createElement('path', {
        d: 'M7 10l5 5 5-5z'
    }), $6dcba2271da8e808$var$React.createElement('path', {
        d: 'M0 0h24v24H0z',
        fill: 'none'
    }));
}
$6dcba2271da8e808$var$SortIndicator.propTypes = {};

});
parcelRegister("eA46i", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a9d79bca62f1d5c9$var$SortDirection = {
    /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */ ASC: 'ASC',
    /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */ DESC: 'DESC'
};
module.exports.default = $a9d79bca62f1d5c9$var$SortDirection;

});



parcelRegister("fNj79", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $b7fa42511ad2cdb4$var$_extends3 = $b7fa42511ad2cdb4$var$_interopRequireDefault($2gFMx);
module.exports.default = $b7fa42511ad2cdb4$var$defaultRowRenderer;

var $eUqFw = parcelRequire("eUqFw");
var $b7fa42511ad2cdb4$var$React = $b7fa42511ad2cdb4$var$_interopRequireWildcard($eUqFw);
parcelRequire("c9TMT");

var $1Qivz = parcelRequire("1Qivz");
var $b7fa42511ad2cdb4$var$_propTypes2 = $b7fa42511ad2cdb4$var$_interopRequireDefault($1Qivz);
function $b7fa42511ad2cdb4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b7fa42511ad2cdb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Default row renderer for Table.
 */ function $b7fa42511ad2cdb4$var$defaultRowRenderer(_ref) {
    var className = _ref.className, columns = _ref.columns, index = _ref.index, key = _ref.key, onRowClick = _ref.onRowClick, onRowDoubleClick = _ref.onRowDoubleClick, onRowMouseOut = _ref.onRowMouseOut, onRowMouseOver = _ref.onRowMouseOver, onRowRightClick = _ref.onRowRightClick, rowData = _ref.rowData, style = _ref.style;
    var a11yProps = {
        'aria-rowindex': index + 1
    };
    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps['aria-label'] = 'row';
        a11yProps.tabIndex = 0;
        if (onRowClick) a11yProps.onClick = function(event) {
            return onRowClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowDoubleClick) a11yProps.onDoubleClick = function(event) {
            return onRowDoubleClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOut) a11yProps.onMouseOut = function(event) {
            return onRowMouseOut({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowMouseOver) a11yProps.onMouseOver = function(event) {
            return onRowMouseOver({
                event: event,
                index: index,
                rowData: rowData
            });
        };
        if (onRowRightClick) a11yProps.onContextMenu = function(event) {
            return onRowRightClick({
                event: event,
                index: index,
                rowData: rowData
            });
        };
    }
    return $b7fa42511ad2cdb4$var$React.createElement('div', (0, $b7fa42511ad2cdb4$var$_extends3.default)({}, a11yProps, {
        className: className,
        key: key,
        role: 'row',
        style: style
    }), columns);
}
$b7fa42511ad2cdb4$var$defaultRowRenderer.propTypes = null;

});

parcelRegister("451Zf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cLNRv = parcelRequire("cLNRv");
var $2f892b9f06017750$var$_getPrototypeOf2 = $2f892b9f06017750$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $2f892b9f06017750$var$_classCallCheck3 = $2f892b9f06017750$var$_interopRequireDefault($jO9Ex);

var $aMQVq = parcelRequire("aMQVq");
var $2f892b9f06017750$var$_possibleConstructorReturn3 = $2f892b9f06017750$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $2f892b9f06017750$var$_inherits3 = $2f892b9f06017750$var$_interopRequireDefault($5taqD);

var $1Qivz = parcelRequire("1Qivz");
var $2f892b9f06017750$var$_propTypes2 = $2f892b9f06017750$var$_interopRequireDefault($1Qivz);

var $eUqFw = parcelRequire("eUqFw");
var $2f892b9f06017750$var$React = $2f892b9f06017750$var$_interopRequireWildcard($eUqFw);

var $6l3WB = parcelRequire("6l3WB");
var $2f892b9f06017750$var$_defaultHeaderRenderer2 = $2f892b9f06017750$var$_interopRequireDefault($6l3WB);

var $gxQHn = parcelRequire("gxQHn");
var $2f892b9f06017750$var$_defaultCellRenderer2 = $2f892b9f06017750$var$_interopRequireDefault($gxQHn);

var $h6vU1 = parcelRequire("h6vU1");
var $2f892b9f06017750$var$_defaultCellDataGetter2 = $2f892b9f06017750$var$_interopRequireDefault($h6vU1);

var $eA46i = parcelRequire("eA46i");
var $2f892b9f06017750$var$_SortDirection2 = $2f892b9f06017750$var$_interopRequireDefault($eA46i);
function $2f892b9f06017750$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $2f892b9f06017750$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Describes the header and cell contents of a table column.
 */ var $2f892b9f06017750$var$Column = function(_React$Component) {
    (0, $2f892b9f06017750$var$_inherits3.default)(Column, _React$Component);
    function Column() {
        (0, $2f892b9f06017750$var$_classCallCheck3.default)(this, Column);
        return (0, $2f892b9f06017750$var$_possibleConstructorReturn3.default)(this, (Column.__proto__ || (0, $2f892b9f06017750$var$_getPrototypeOf2.default)(Column)).apply(this, arguments));
    }
    return Column;
}($2f892b9f06017750$var$React.Component);
$2f892b9f06017750$var$Column.defaultProps = {
    cellDataGetter: $2f892b9f06017750$var$_defaultCellDataGetter2.default,
    cellRenderer: $2f892b9f06017750$var$_defaultCellRenderer2.default,
    defaultSortDirection: $2f892b9f06017750$var$_SortDirection2.default.ASC,
    flexGrow: 0,
    flexShrink: 1,
    headerRenderer: $2f892b9f06017750$var$_defaultHeaderRenderer2.default,
    style: {}
};
module.exports.default = $2f892b9f06017750$var$Column;
$2f892b9f06017750$var$Column.propTypes = {};

});

parcelRegister("4Ywfp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gFMx = parcelRequire("2gFMx");
var $39f5c7b9121ddc0a$var$_extends3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($2gFMx);

var $cLNRv = parcelRequire("cLNRv");
var $39f5c7b9121ddc0a$var$_getPrototypeOf2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($cLNRv);

var $jO9Ex = parcelRequire("jO9Ex");
var $39f5c7b9121ddc0a$var$_classCallCheck3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($jO9Ex);

var $i2meQ = parcelRequire("i2meQ");
var $39f5c7b9121ddc0a$var$_createClass3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($i2meQ);

var $aMQVq = parcelRequire("aMQVq");
var $39f5c7b9121ddc0a$var$_possibleConstructorReturn3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($aMQVq);

var $5taqD = parcelRequire("5taqD");
var $39f5c7b9121ddc0a$var$_inherits3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($5taqD);

var $96Bek = parcelRequire("96Bek");
var $39f5c7b9121ddc0a$var$_clsx2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($96Bek);

var $451Zf = parcelRequire("451Zf");
var $39f5c7b9121ddc0a$var$_Column2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($451Zf);

var $1Qivz = parcelRequire("1Qivz");
var $39f5c7b9121ddc0a$var$_propTypes2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($1Qivz);

var $eUqFw = parcelRequire("eUqFw");
var $39f5c7b9121ddc0a$var$React = $39f5c7b9121ddc0a$var$_interopRequireWildcard($eUqFw);

var $lEfVV = parcelRequire("lEfVV");

var $ef5CW = parcelRequire("ef5CW");
var $39f5c7b9121ddc0a$var$_Grid3 = $39f5c7b9121ddc0a$var$_interopRequireDefault($ef5CW);

var $fNj79 = parcelRequire("fNj79");
var $39f5c7b9121ddc0a$var$_defaultRowRenderer2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($fNj79);

var $jkyQ4 = parcelRequire("jkyQ4");
var $39f5c7b9121ddc0a$var$_defaultHeaderRowRenderer2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($jkyQ4);

var $eA46i = parcelRequire("eA46i");
var $39f5c7b9121ddc0a$var$_SortDirection2 = $39f5c7b9121ddc0a$var$_interopRequireDefault($eA46i);
function $39f5c7b9121ddc0a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $39f5c7b9121ddc0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */ var $39f5c7b9121ddc0a$var$Table = function(_React$PureComponent) {
    (0, $39f5c7b9121ddc0a$var$_inherits3.default)(Table, _React$PureComponent);
    function Table(props) {
        (0, $39f5c7b9121ddc0a$var$_classCallCheck3.default)(this, Table);
        var _this = (0, $39f5c7b9121ddc0a$var$_possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, $39f5c7b9121ddc0a$var$_getPrototypeOf2.default)(Table)).call(this, props));
        _this.state = {
            scrollbarWidth: 0
        };
        _this._createColumn = _this._createColumn.bind(_this);
        _this._createRow = _this._createRow.bind(_this);
        _this._onScroll = _this._onScroll.bind(_this);
        _this._onSectionRendered = _this._onSectionRendered.bind(_this);
        _this._setRef = _this._setRef.bind(_this);
        return _this;
    }
    (0, $39f5c7b9121ddc0a$var$_createClass3.default)(Table, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref) {
                var alignment = _ref.alignment, index = _ref.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index
                    }), scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref2) {
                var columnIndex = _ref2.columnIndex, rowIndex = _ref2.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$columnIndex = _ref3.columnIndex, columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex, _ref3$rowIndex = _ref3.rowIndex, rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'getScrollbarWidth',
            value: function getScrollbarWidth() {
                if (this.Grid) {
                    var _Grid = (0, $lEfVV.findDOMNode)(this.Grid);
                    var clientWidth = _Grid.clientWidth || 0;
                    var offsetWidth = _Grid.offsetWidth || 0;
                    return offsetWidth - clientWidth;
                }
                return 0;
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._setScrollbarWidth();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this._setScrollbarWidth();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, children = _props.children, className = _props.className, disableHeader = _props.disableHeader, gridClassName = _props.gridClassName, gridStyle = _props.gridStyle, headerHeight = _props.headerHeight, headerRowRenderer = _props.headerRowRenderer, height = _props.height, id = _props.id, noRowsRenderer = _props.noRowsRenderer, rowClassName = _props.rowClassName, rowStyle = _props.rowStyle, scrollToIndex = _props.scrollToIndex, style = _props.style, width = _props.width;
                var scrollbarWidth = this.state.scrollbarWidth;
                var availableRowsHeight = disableHeader ? height : height - headerHeight;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: -1
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: -1
                }) : rowStyle;
                // Precompute and cache column styles before rendering rows and columns to speed things up
                this._cachedColumnStyles = [];
                $39f5c7b9121ddc0a$var$React.Children.toArray(children).forEach(function(column, index) {
                    var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
                    _this2._cachedColumnStyles[index] = (0, $39f5c7b9121ddc0a$var$_extends3.default)({
                        overflow: 'hidden'
                    }, flexStyles);
                });
                // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
                // This is done because Grid is a pure component and won't update unless its properties or state has changed.
                // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
                return $39f5c7b9121ddc0a$var$React.createElement('div', {
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-colcount': $39f5c7b9121ddc0a$var$React.Children.toArray(children).length,
                    'aria-rowcount': this.props.rowCount,
                    className: (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table', className),
                    id: id,
                    role: 'grid',
                    style: style
                }, !disableHeader && headerRowRenderer({
                    className: (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table__headerRow', rowClass),
                    columns: this._getHeaderColumns(),
                    style: (0, $39f5c7b9121ddc0a$var$_extends3.default)({
                        height: headerHeight,
                        overflow: 'hidden',
                        paddingRight: scrollbarWidth,
                        width: width
                    }, rowStyleObject)
                }), $39f5c7b9121ddc0a$var$React.createElement($39f5c7b9121ddc0a$var$_Grid3.default, (0, $39f5c7b9121ddc0a$var$_extends3.default)({}, this.props, {
                    'aria-readonly': null,
                    autoContainerWidth: true,
                    className: (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table__Grid', gridClassName),
                    cellRenderer: this._createRow,
                    columnWidth: width,
                    columnCount: 1,
                    height: availableRowsHeight,
                    id: undefined,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    role: 'rowgroup',
                    scrollbarWidth: scrollbarWidth,
                    scrollToRow: scrollToIndex,
                    style: (0, $39f5c7b9121ddc0a$var$_extends3.default)({}, gridStyle, {
                        overflowX: 'hidden'
                    })
                })));
            }
        },
        {
            key: '_createColumn',
            value: function _createColumn(_ref4) {
                var column = _ref4.column, columnIndex = _ref4.columnIndex, isScrolling = _ref4.isScrolling, parent = _ref4.parent, rowData = _ref4.rowData, rowIndex = _ref4.rowIndex;
                var onColumnClick = this.props.onColumnClick;
                var _column$props = column.props, cellDataGetter = _column$props.cellDataGetter, cellRenderer = _column$props.cellRenderer, className = _column$props.className, columnData = _column$props.columnData, dataKey = _column$props.dataKey, id = _column$props.id;
                var cellData = cellDataGetter({
                    columnData: columnData,
                    dataKey: dataKey,
                    rowData: rowData
                });
                var renderedCell = cellRenderer({
                    cellData: cellData,
                    columnData: columnData,
                    columnIndex: columnIndex,
                    dataKey: dataKey,
                    isScrolling: isScrolling,
                    parent: parent,
                    rowData: rowData,
                    rowIndex: rowIndex
                });
                var onClick = function onClick(event) {
                    onColumnClick && onColumnClick({
                        columnData: columnData,
                        dataKey: dataKey,
                        event: event
                    });
                };
                var style = this._cachedColumnStyles[columnIndex];
                var title = typeof renderedCell === 'string' ? renderedCell : null;
                // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return $39f5c7b9121ddc0a$var$React.createElement('div', {
                    'aria-colindex': columnIndex + 1,
                    'aria-describedby': id,
                    className: (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table__rowColumn', className),
                    key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
                    onClick: onClick,
                    role: 'gridcell',
                    style: style,
                    title: title
                }, renderedCell);
            }
        },
        {
            key: '_createHeader',
            value: function _createHeader(_ref5) {
                var column = _ref5.column, index = _ref5.index;
                var _props2 = this.props, headerClassName = _props2.headerClassName, headerStyle = _props2.headerStyle, onHeaderClick = _props2.onHeaderClick, sort = _props2.sort, sortBy = _props2.sortBy, sortDirection = _props2.sortDirection;
                var _column$props2 = column.props, columnData = _column$props2.columnData, dataKey = _column$props2.dataKey, defaultSortDirection = _column$props2.defaultSortDirection, disableSort = _column$props2.disableSort, headerRenderer = _column$props2.headerRenderer, id = _column$props2.id, label = _column$props2.label;
                var sortEnabled = !disableSort && sort;
                var classNames = (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
                    ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
                });
                var style = this._getFlexStyleForColumn(column, (0, $39f5c7b9121ddc0a$var$_extends3.default)({}, headerStyle, column.props.headerStyle));
                var renderedHeader = headerRenderer({
                    columnData: columnData,
                    dataKey: dataKey,
                    disableSort: disableSort,
                    label: label,
                    sortBy: sortBy,
                    sortDirection: sortDirection
                });
                var headerOnClick = void 0, headerOnKeyDown = void 0, headerTabIndex = void 0, headerAriaSort = void 0, headerAriaLabel = void 0;
                if (sortEnabled || onHeaderClick) {
                    // If this is a sortable header, clicking it should update the table data's sorting.
                    var isFirstTimeSort = sortBy !== dataKey;
                    // If this is the firstTime sort of this column, use the column default sort order.
                    // Otherwise, invert the direction of the sort.
                    var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === $39f5c7b9121ddc0a$var$_SortDirection2.default.DESC ? $39f5c7b9121ddc0a$var$_SortDirection2.default.ASC : $39f5c7b9121ddc0a$var$_SortDirection2.default.DESC;
                    var onClick = function onClick(event) {
                        sortEnabled && sort({
                            defaultSortDirection: defaultSortDirection,
                            event: event,
                            sortBy: dataKey,
                            sortDirection: newSortDirection
                        });
                        onHeaderClick && onHeaderClick({
                            columnData: columnData,
                            dataKey: dataKey,
                            event: event
                        });
                    };
                    var onKeyDown = function onKeyDown(event) {
                        if (event.key === 'Enter' || event.key === ' ') onClick(event);
                    };
                    headerAriaLabel = column.props['aria-label'] || label || dataKey;
                    headerAriaSort = 'none';
                    headerTabIndex = 0;
                    headerOnClick = onClick;
                    headerOnKeyDown = onKeyDown;
                }
                if (sortBy === dataKey) headerAriaSort = sortDirection === $39f5c7b9121ddc0a$var$_SortDirection2.default.ASC ? 'ascending' : 'descending';
                // Avoid using object-spread syntax with multiple objects here,
                // Since it results in an extra method call to 'babel-runtime/helpers/extends'
                // See PR https://github.com/bvaughn/react-virtualized/pull/942
                return $39f5c7b9121ddc0a$var$React.createElement('div', {
                    'aria-label': headerAriaLabel,
                    'aria-sort': headerAriaSort,
                    className: classNames,
                    id: id,
                    key: 'Header-Col' + index,
                    onClick: headerOnClick,
                    onKeyDown: headerOnKeyDown,
                    role: 'columnheader',
                    style: style,
                    tabIndex: headerTabIndex
                }, renderedHeader);
            }
        },
        {
            key: '_createRow',
            value: function _createRow(_ref6) {
                var _this3 = this;
                var index = _ref6.rowIndex, isScrolling = _ref6.isScrolling, key = _ref6.key, parent = _ref6.parent, style = _ref6.style;
                var _props3 = this.props, children = _props3.children, onRowClick = _props3.onRowClick, onRowDoubleClick = _props3.onRowDoubleClick, onRowRightClick = _props3.onRowRightClick, onRowMouseOver = _props3.onRowMouseOver, onRowMouseOut = _props3.onRowMouseOut, rowClassName = _props3.rowClassName, rowGetter = _props3.rowGetter, rowRenderer = _props3.rowRenderer, rowStyle = _props3.rowStyle;
                var scrollbarWidth = this.state.scrollbarWidth;
                var rowClass = typeof rowClassName === 'function' ? rowClassName({
                    index: index
                }) : rowClassName;
                var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
                    index: index
                }) : rowStyle;
                var rowData = rowGetter({
                    index: index
                });
                var columns = $39f5c7b9121ddc0a$var$React.Children.toArray(children).map(function(column, columnIndex) {
                    return _this3._createColumn({
                        column: column,
                        columnIndex: columnIndex,
                        isScrolling: isScrolling,
                        parent: parent,
                        rowData: rowData,
                        rowIndex: index,
                        scrollbarWidth: scrollbarWidth
                    });
                });
                var className = (0, $39f5c7b9121ddc0a$var$_clsx2.default)('ReactVirtualized__Table__row', rowClass);
                var flattenedStyle = (0, $39f5c7b9121ddc0a$var$_extends3.default)({}, style, {
                    height: this._getRowHeight(index),
                    overflow: 'hidden',
                    paddingRight: scrollbarWidth
                }, rowStyleObject);
                return rowRenderer({
                    className: className,
                    columns: columns,
                    index: index,
                    isScrolling: isScrolling,
                    key: key,
                    onRowClick: onRowClick,
                    onRowDoubleClick: onRowDoubleClick,
                    onRowRightClick: onRowRightClick,
                    onRowMouseOver: onRowMouseOver,
                    onRowMouseOut: onRowMouseOut,
                    rowData: rowData,
                    style: flattenedStyle
                });
            }
        },
        {
            key: '_getFlexStyleForColumn',
            value: function _getFlexStyleForColumn(column) {
                var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
                var style = (0, $39f5c7b9121ddc0a$var$_extends3.default)({}, customStyle, {
                    flex: flexValue,
                    msFlex: flexValue,
                    WebkitFlex: flexValue
                });
                if (column.props.maxWidth) style.maxWidth = column.props.maxWidth;
                if (column.props.minWidth) style.minWidth = column.props.minWidth;
                return style;
            }
        },
        {
            key: '_getHeaderColumns',
            value: function _getHeaderColumns() {
                var _this4 = this;
                var _props4 = this.props, children = _props4.children, disableHeader = _props4.disableHeader;
                var items = disableHeader ? [] : $39f5c7b9121ddc0a$var$React.Children.toArray(children);
                return items.map(function(column, index) {
                    return _this4._createHeader({
                        column: column,
                        index: index
                    });
                });
            }
        },
        {
            key: '_getRowHeight',
            value: function _getRowHeight(rowIndex) {
                var rowHeight = this.props.rowHeight;
                return typeof rowHeight === 'function' ? rowHeight({
                    index: rowIndex
                }) : rowHeight;
            }
        },
        {
            key: '_onScroll',
            value: function _onScroll(_ref7) {
                var clientHeight = _ref7.clientHeight, scrollHeight = _ref7.scrollHeight, scrollTop = _ref7.scrollTop;
                var onScroll = this.props.onScroll;
                onScroll({
                    clientHeight: clientHeight,
                    scrollHeight: scrollHeight,
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: '_onSectionRendered',
            value: function _onSectionRendered(_ref8) {
                var rowOverscanStartIndex = _ref8.rowOverscanStartIndex, rowOverscanStopIndex = _ref8.rowOverscanStopIndex, rowStartIndex = _ref8.rowStartIndex, rowStopIndex = _ref8.rowStopIndex;
                var onRowsRendered = this.props.onRowsRendered;
                onRowsRendered({
                    overscanStartIndex: rowOverscanStartIndex,
                    overscanStopIndex: rowOverscanStopIndex,
                    startIndex: rowStartIndex,
                    stopIndex: rowStopIndex
                });
            }
        },
        {
            key: '_setRef',
            value: function _setRef(ref) {
                this.Grid = ref;
            }
        },
        {
            key: '_setScrollbarWidth',
            value: function _setScrollbarWidth() {
                var scrollbarWidth = this.getScrollbarWidth();
                this.setState({
                    scrollbarWidth: scrollbarWidth
                });
            }
        }
    ]);
    return Table;
}($39f5c7b9121ddc0a$var$React.PureComponent);
$39f5c7b9121ddc0a$var$Table.defaultProps = {
    disableHeader: false,
    estimatedRowSize: 30,
    headerHeight: 0,
    headerStyle: {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {
        return null;
    },
    onScroll: function onScroll() {
        return null;
    },
    overscanIndicesGetter: $ef5CW.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    rowRenderer: $39f5c7b9121ddc0a$var$_defaultRowRenderer2.default,
    headerRowRenderer: $39f5c7b9121ddc0a$var$_defaultHeaderRowRenderer2.default,
    rowStyle: {},
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
module.exports.default = $39f5c7b9121ddc0a$var$Table;
$39f5c7b9121ddc0a$var$Table.propTypes = {};

});



parcelRegister("jgxY2", function(module, exports) {

$parcel$export(module.exports, "getExpandedChanges", () => $71707116cb859ef7$export$bacc19472f5797fe);
$parcel$export(module.exports, "getAttributesForIssuesWithTimeframeChanges", () => $71707116cb859ef7$export$23ee0086b01df145);
$parcel$export(module.exports, "getIdForChangeCategory", () => $71707116cb859ef7$export$26928ed5ec19a0d);

var $kjklK = parcelRequire("kjklK");

var $l2Sj2 = parcelRequire("l2Sj2");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $71707116cb859ef7$export$bacc19472f5797fe = (changes)=>{
    const result = [];
    const uniqIds = new Set();
    const addItem = (item)=>{
        const uniqId = `${item.category}:${item.id}`;
        if (!uniqIds.has(uniqId)) {
            uniqIds.add(uniqId);
            result.push(item);
        }
    };
    for (const change of changes)if (change.type !== (0, $5rYNM.SCENARIO_TYPE).NONE) {
        if (change.category === (0, $5rYNM.ENTITY).TEAM) addItem({
            id: change.id,
            category: change.category
        });
        if (change.category === (0, $5rYNM.ENTITY).TEAM || change.category === (0, $5rYNM.ENTITY).RESOURCE) change.details.changes.filter((additionalChange)=>additionalChange.category === (0, $5rYNM.ENTITY).RESOURCE).forEach((additionalChange)=>{
            addItem({
                id: additionalChange.resourceId || '0',
                category: (0, $5rYNM.ENTITY).RESOURCE
            });
        });
        else addItem({
            id: change.id,
            category: change.category
        });
    }
    return result;
};
const $71707116cb859ef7$var$formatDate = (timestamp)=>{
    if (!(0, $7CnHa.isDefined)(timestamp)) return timestamp;
    return (0, $l2Sj2.formatDateUTC)(timestamp, 'YYYY-MM-DD HH:mm:ss');
};
// the key will not exist in the originals object if there's no change
const $71707116cb859ef7$var$hasDateChange = (dateField, originals)=>{
    if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    originals[dateField.key] !== undefined) return true;
    if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM) {
        if ($kjklK.default([
            `customField-${dateField.key}`,
            'value'
        ], originals) !== undefined) return true;
    }
    return false;
};
const $71707116cb859ef7$var$getConfiguredDateValues = (dateField, originals, values)=>{
    if (dateField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM) return {
        current: $71707116cb859ef7$var$formatDate($kjklK.default([
            `customField-${dateField.key}`,
            'value'
        ], originals) || null),
        new: $71707116cb859ef7$var$formatDate($kjklK.default([
            `customField-${dateField.key}`,
            'value'
        ], values) || null)
    };
    return {
        current: $71707116cb859ef7$var$formatDate($kjklK.default([
            dateField.key
        ], originals) || null),
        new: $71707116cb859ef7$var$formatDate($kjklK.default([
            dateField.key
        ], values) || null)
    };
};
const $71707116cb859ef7$export$23ee0086b01df145 = (changes, dateConfiguration, typeToLevel)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    const isIssueWithTimeframeChanges = (change)=>{
        const originals = $kjklK.default([
            'details',
            'originals'
        ], change);
        if (change.category !== (0, $5rYNM.ENTITY).ISSUE || change.type === 'NONE' || originals === undefined) return false;
        if ($71707116cb859ef7$var$hasDateChange(baselineStartField, originals) || $71707116cb859ef7$var$hasDateChange(baselineEndField, originals)) return true;
        return false;
    };
    const changeAnalyticsAttributes = (change)=>{
        let start = {
            current: null,
            new: null
        };
        let end = {
            current: null,
            new: null
        };
        const originals = $kjklK.default([
            'details',
            'originals'
        ], change);
        const values = $kjklK.default([
            'details',
            'values'
        ], change);
        if (originals !== undefined && values !== undefined) {
            start = $71707116cb859ef7$var$getConfiguredDateValues(baselineStartField, originals, values);
            end = $71707116cb859ef7$var$getConfiguredDateValues(baselineEndField, originals, values);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const type = $kjklK.default([
            'details',
            'values',
            'type'
        ], change);
        const hierarchyLevel = typeToLevel(type);
        return {
            issueId: change.id,
            lastModifiedDate: $71707116cb859ef7$var$formatDate(change.lastModified?.date),
            lastModifiedUser: change.lastModified?.personId,
            start: {
                type: baselineStartField.type,
                ...start,
                changed: start.current !== start.new
            },
            end: {
                type: baselineEndField.type,
                ...end,
                changed: end.current !== end.new
            },
            hierarchyLevel: hierarchyLevel
        };
    };
    return (0, $7CnHa.filterMap)(isIssueWithTimeframeChanges, changeAnalyticsAttributes, changes);
};
const $71707116cb859ef7$export$26928ed5ec19a0d = (id, category)=>{
    switch(category){
        case (0, $5rYNM.ENTITY).ISSUE:
            return `issue_change_${id}`;
        case (0, $5rYNM.ENTITY).RELEASE:
            return `release_change_${id}`;
        case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
            return `cross_project_release_change_${id}`;
        case (0, $5rYNM.ENTITY).TEAM:
            return `team_change_${id}`;
        case (0, $5rYNM.ENTITY).RESOURCE:
            return `resource_change_${id}`;
        case (0, $5rYNM.ENTITY).PLANNED_CAPACITY:
            return `planned_capacity_change_${id}`;
        case (0, $5rYNM.ENTITY).SPRINT:
            return `sprint_change_${id}`;
        default:
            return id;
    }
};

});

const $d5f16ccf32841b20$export$88e6c5bab2ff80e8 = 30;

parcelRegister("9fc7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1096b5b038dcfe94$export$2e2bcd8739ae039);

var $cuIOn = parcelRequire("cuIOn");
var $1096b5b038dcfe94$export$2e2bcd8739ae039 = (0, $cuIOn.default);

});
parcelRegister("cuIOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff28aa5cf04a7e38$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");

var $1IqwQ = parcelRequire("1IqwQ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $d2wNG = parcelRequire("d2wNG");
var $l2Sj2 = parcelRequire("l2Sj2");
var $eTbtL = parcelRequire("eTbtL");

var $gVFFY = parcelRequire("gVFFY");
function $ff28aa5cf04a7e38$var$LastModified(props) {
    const intl = (0, $5JgJ2.default)();
    const { personId: personId, title: title, date: date, avatarUrl: avatarUrl } = props;
    const daysDifference = (0, $d2wNG.default)(new Date(), date);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const formatRelative = (intl, date)=>{
        const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
        return intl.formatRelativeTime(time, unit);
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getDate = (intl, value)=>(0, $l2Sj2.formatTimestampWithIntl)(intl, value, (0, $eTbtL.shortDateFormat));
    const dateDisplayString = daysDifference > 7 ? getDate(intl, date) : formatRelative(intl, date);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gVFFY.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $gVFFY.label,
        title: dateDisplayString
    }, dateDisplayString), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gVFFY.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: title || personId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: avatarUrl,
        name: title || personId
    })))));
}
var $ff28aa5cf04a7e38$export$2e2bcd8739ae039 = $ff28aa5cf04a7e38$var$LastModified;

});
parcelRegister("gVFFY", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $c5324c315ead6b7a$export$345c5736c8054f22, (v) => $c5324c315ead6b7a$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "container", () => $c5324c315ead6b7a$export$34e0f9847d4c02dd, (v) => $c5324c315ead6b7a$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "label", () => $c5324c315ead6b7a$export$1237798dc640739a, (v) => $c5324c315ead6b7a$export$1237798dc640739a = v);
var $c5324c315ead6b7a$export$345c5736c8054f22;
var $c5324c315ead6b7a$export$34e0f9847d4c02dd;
var $c5324c315ead6b7a$export$1237798dc640739a;
$c5324c315ead6b7a$export$345c5736c8054f22 = `RCUxaq_avatar`;
$c5324c315ead6b7a$export$34e0f9847d4c02dd = `RCUxaq_container`;
$c5324c315ead6b7a$export$1237798dc640739a = `RCUxaq_label`;

});



parcelRegister("i4Ev2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12b9cbb7bbcdc34$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a12b9cbb7bbcdc34$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title-column-header",
        "defaultMessage": "Title"
    },
    categoryColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.category-column-header",
        "defaultMessage": "Category"
    },
    whatChangedColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.what-changed-column-header",
        "defaultMessage": "What changed"
    },
    oldValueColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.old-value-column-header",
        "defaultMessage": "Current (Jira)"
    },
    lastModifiedColumnHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.last-modified-column-header",
        "defaultMessage": "Last modified"
    },
    issueCategory: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.issue-category",
        "defaultMessage": "Issue"
    },
    teamCategory: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.team-category",
        "defaultMessage": "Team"
    },
    releaseCategory: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.release-category",
        "defaultMessage": "Release"
    },
    sprintCategory: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.sprint-category",
        "defaultMessage": "Sprint"
    },
    iterationCategory: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.iteration-category",
        "defaultMessage": "Iteration"
    },
    exceptions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.exceptions",
        "defaultMessage": "Exceptions"
    },
    tableAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.table-aria-label",
        "defaultMessage": "Update Jira changes table"
    },
    lastModifiedColumnAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.last-modified-column-aria-label",
        "defaultMessage": "Last modified"
    }
});

});

parcelRegister("dyxrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $52954b14a6b3b8f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $6ETZE = parcelRequire("6ETZE");

var $lNNXV = parcelRequire("lNNXV");

var $ZGkxZ = parcelRequire("ZGkxZ");

var $5geoM = parcelRequire("5geoM");

var $cG9iu = parcelRequire("cG9iu");
class $52954b14a6b3b8f6$export$d4456a5c5e486524 extends (0, $eUqFw.Component) {
    render() {
        const { id: id, isUpdating: isUpdating } = this.props;
        const isSelected = this.isSelected();
        return (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            "aria-labelledby": id,
            isChecked: isSelected,
            isDisabled: isUpdating,
            onChange: this.handleChange,
            testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.select-change.cell.checkbox-${id}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $1ybV0.ff)('jsw.roadmaps.jca11y-505-review-table-switch-to-treegrid-component_s0cfc') ? $cG9iu.changeSelectRowNewGrid : $cG9iu.changeSelectRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            "aria-labelledby": id,
            isChecked: isSelected,
            isDisabled: isUpdating,
            onChange: this.handleChange,
            testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.select-change.cell.checkbox-${id}`
        }));
    }
    constructor(...args){
        super(...args);
        this.isSelected = ()=>{
            const { items: items, selectedChanges: selectedChanges } = this.props;
            return items.length > 0 && items.every((item)=>this.isItemSelected(item, selectedChanges));
        };
        this.isItemSelected = ({ id: id, category: category }, selectedChanges)=>selectedChanges[category] && selectedChanges[category].includes(id);
        this.handleChange = ()=>{
            const { items: items, select: select, deselect: deselect } = this.props;
            const isSelected = this.isSelected();
            if (isSelected) items.forEach((item)=>deselect(item.id, item.category));
            else items.forEach((item)=>select(item.id, item.category));
        };
    }
}
var $52954b14a6b3b8f6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5geoM.default), (0, $ZGkxZ.default))($52954b14a6b3b8f6$export$d4456a5c5e486524);

});
parcelRegister("ZGkxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9d690723837cda$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");

var $7SlBO = parcelRequire("7SlBO");

var $j3zeB = parcelRequire("j3zeB");
const $ac9d690723837cda$var$mapDispatchToProps = (dispatch)=>({
        select: (changeId, category)=>{
            dispatch((0, $7SlBO.selectChange)(changeId, category));
            dispatch((0, $7SlBO.changeQuickSelect)((0, $j3zeB.QuickSelectOption).NONE));
        },
        deselect: (changeId, category)=>{
            dispatch((0, $7SlBO.deselectChange)(changeId, category));
            dispatch((0, $7SlBO.changeQuickSelect)((0, $j3zeB.QuickSelectOption).NONE));
        }
    });
var $ac9d690723837cda$export$2e2bcd8739ae039 = $ac9d690723837cda$var$mapDispatchToProps;

});

parcelRegister("5geoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06db60175740161$export$2e2bcd8739ae039);

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
var $a06db60175740161$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedChanges: (0, $eDYLe.getSelectedChanges)
});

});

parcelRegister("cG9iu", function(module, exports) {

$parcel$export(module.exports, "changeSelectRow", () => $93b09e87952733a3$export$6d3e6753f5884225, (v) => $93b09e87952733a3$export$6d3e6753f5884225 = v);
$parcel$export(module.exports, "changeSelectRowNewGrid", () => $93b09e87952733a3$export$7cae2f6dd3217e83, (v) => $93b09e87952733a3$export$7cae2f6dd3217e83 = v);
var $93b09e87952733a3$export$6d3e6753f5884225;
var $93b09e87952733a3$export$7cae2f6dd3217e83;
$93b09e87952733a3$export$6d3e6753f5884225 = `wo8OGa_changeSelectRow`;
$93b09e87952733a3$export$7cae2f6dd3217e83 = `wo8OGa_changeSelectRowNewGrid`;

});


parcelRegister("7Iztn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b826aa6396148e25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f7Op5 = parcelRequire("f7Op5");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");

var $jgxY2 = parcelRequire("jgxY2");

var $7CnHa = parcelRequire("7CnHa");

var $lNNXV = parcelRequire("lNNXV");

var $eAz3y = parcelRequire("eAz3y");

var $4oyDX = parcelRequire("4oyDX");

var $hnfhC = parcelRequire("hnfhC");

var $7X2pH = parcelRequire("7X2pH");
const $b826aa6396148e25$export$be74dcf36d511131 = 'checked';
const $b826aa6396148e25$export$4bfe604431277125 = 'unchecked';
const $b826aa6396148e25$export$c5a6fe907430212e = 'indeterminate';
const $b826aa6396148e25$export$a3f38dab6b48dc8d = (changes, selectedChanges)=>{
    const selectedChangesCount = (0, $7CnHa.valuesLength)(selectedChanges);
    const changesCount = changes.length;
    if (changesCount > 0 && changesCount === selectedChangesCount) return $b826aa6396148e25$export$be74dcf36d511131;
    if (selectedChangesCount > 0) return $b826aa6396148e25$export$c5a6fe907430212e;
    return $b826aa6396148e25$export$4bfe604431277125;
};
class $b826aa6396148e25$export$881caa45becfe0fd extends (0, $eUqFw.Component) {
    render() {
        const { changes: changes, isUpdating: isUpdating, selectedChanges: selectedChanges, intl: intl } = this.props;
        const expandedChanges = (0, $jgxY2.getExpandedChanges)(changes);
        const status = $b826aa6396148e25$export$a3f38dab6b48dc8d(expandedChanges, selectedChanges);
        return (0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            isChecked: status === $b826aa6396148e25$export$be74dcf36d511131 || status === $b826aa6396148e25$export$c5a6fe907430212e,
            isIndeterminate: status === $b826aa6396148e25$export$c5a6fe907430212e,
            isDisabled: isUpdating,
            onChange: this.handleChange,
            "aria-label": intl.formatMessage((0, $4oyDX.default).selectHeaderAriaLabel)
        }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7X2pH.changeSelectHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            isChecked: status === $b826aa6396148e25$export$be74dcf36d511131 || status === $b826aa6396148e25$export$c5a6fe907430212e,
            isIndeterminate: status === $b826aa6396148e25$export$c5a6fe907430212e,
            isDisabled: isUpdating,
            onChange: this.handleChange,
            "aria-label": intl.formatMessage((0, $4oyDX.default).selectHeaderAriaLabel)
        }));
    }
    constructor(...args){
        super(...args);
        this.handleChange = ()=>{
            const { changes: changes, selectAll: selectAll, deselectAll: deselectAll, selectedChanges: selectedChanges } = this.props;
            const expandedChanges = (0, $jgxY2.getExpandedChanges)(changes);
            const status = $b826aa6396148e25$export$a3f38dab6b48dc8d(expandedChanges, selectedChanges);
            if (status === $b826aa6396148e25$export$be74dcf36d511131 || status === $b826aa6396148e25$export$c5a6fe907430212e) deselectAll();
            else {
                const changesByCategory = (0, $7CnHa.groupBy)($f7Op5.default('category'), expandedChanges);
                selectAll((0, $7CnHa.mapValues)($f7Op5.default('id'), changesByCategory));
            }
        };
    }
}
var $b826aa6396148e25$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hnfhC.default), (0, $eAz3y.default))((0, $2qhQi.default)($b826aa6396148e25$export$881caa45becfe0fd));

});
parcelRegister("eAz3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aecf4ba91f7178$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");
const $b5aecf4ba91f7178$var$mapDispatchToProps = (dispatch)=>({
        selectAll: (changes)=>{
            dispatch((0, $7SlBO.selectAllChanges)(changes));
        },
        deselectAll: ()=>{
            dispatch((0, $7SlBO.deselectAllChanges)());
        }
    });
var $b5aecf4ba91f7178$export$2e2bcd8739ae039 = $b5aecf4ba91f7178$var$mapDispatchToProps;

});

parcelRegister("4oyDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $002cf7456a7eae71$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $002cf7456a7eae71$var$messages = (0, $90IgZ.defineMessages)({
    selectHeaderAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.select-change.header.select-header-aria-label",
        "defaultMessage": "Select all issues"
    }
});
var $002cf7456a7eae71$export$2e2bcd8739ae039 = $002cf7456a7eae71$var$messages;

});

parcelRegister("hnfhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f61f90e8d7f1e7$export$2e2bcd8739ae039);

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
var $c0f61f90e8d7f1e7$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedChanges: (0, $eDYLe.getSelectedChanges)
});

});

parcelRegister("7X2pH", function(module, exports) {

$parcel$export(module.exports, "changeSelectHeader", () => $5c9fea5928423e5a$export$b6f67c6e1bd953a, (v) => $5c9fea5928423e5a$export$b6f67c6e1bd953a = v);
var $5c9fea5928423e5a$export$b6f67c6e1bd953a;
$5c9fea5928423e5a$export$b6f67c6e1bd953a = `Kkig_q_changeSelectHeader`;

});


parcelRegister("bIGyx", function(module, exports) {

$parcel$export(module.exports, "columnHeader", () => $8884d087ce93d7bc$export$d13f5cc425f7d974, (v) => $8884d087ce93d7bc$export$d13f5cc425f7d974 = v);
$parcel$export(module.exports, "commonColumnHeader", () => $8884d087ce93d7bc$export$b0e1aafbbb4a8b15, (v) => $8884d087ce93d7bc$export$b0e1aafbbb4a8b15 = v);
$parcel$export(module.exports, "container", () => $8884d087ce93d7bc$export$34e0f9847d4c02dd, (v) => $8884d087ce93d7bc$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "grid", () => $8884d087ce93d7bc$export$85fc379452d91af0, (v) => $8884d087ce93d7bc$export$85fc379452d91af0 = v);
$parcel$export(module.exports, "modifiedColumnHeader", () => $8884d087ce93d7bc$export$4754f93c9af7081d, (v) => $8884d087ce93d7bc$export$4754f93c9af7081d = v);
$parcel$export(module.exports, "modifiedGridColumnHeader", () => $8884d087ce93d7bc$export$8956cb9ad7faa898, (v) => $8884d087ce93d7bc$export$8956cb9ad7faa898 = v);
$parcel$export(module.exports, "oldColumnHeader", () => $8884d087ce93d7bc$export$6eedf6f5a4447774, (v) => $8884d087ce93d7bc$export$6eedf6f5a4447774 = v);
$parcel$export(module.exports, "oldColumnHeaderArrow", () => $8884d087ce93d7bc$export$4bbd2d49469545b1, (v) => $8884d087ce93d7bc$export$4bbd2d49469545b1 = v);
$parcel$export(module.exports, "table", () => $8884d087ce93d7bc$export$9852986a3ec5f6a0, (v) => $8884d087ce93d7bc$export$9852986a3ec5f6a0 = v);
$parcel$export(module.exports, "tableRow", () => $8884d087ce93d7bc$export$ce666bf02318c957, (v) => $8884d087ce93d7bc$export$ce666bf02318c957 = v);
var $8884d087ce93d7bc$export$8995574774093d93;
var $8884d087ce93d7bc$export$d13f5cc425f7d974;
var $8884d087ce93d7bc$export$b0e1aafbbb4a8b15;
var $8884d087ce93d7bc$export$34e0f9847d4c02dd;
var $8884d087ce93d7bc$export$85fc379452d91af0;
var $8884d087ce93d7bc$export$711e2b273dbb00ac;
var $8884d087ce93d7bc$export$91fbaa0417f2b694;
var $8884d087ce93d7bc$export$4754f93c9af7081d;
var $8884d087ce93d7bc$export$8956cb9ad7faa898;
var $8884d087ce93d7bc$export$6eedf6f5a4447774;
var $8884d087ce93d7bc$export$4bbd2d49469545b1;
var $8884d087ce93d7bc$export$9852986a3ec5f6a0;
var $8884d087ce93d7bc$export$ce666bf02318c957;
$8884d087ce93d7bc$export$8995574774093d93 = `ldgrhG_ReactVirtualized__Table__headerRow`;
$8884d087ce93d7bc$export$d13f5cc425f7d974 = `ldgrhG_columnHeader`;
$8884d087ce93d7bc$export$b0e1aafbbb4a8b15 = `ldgrhG_commonColumnHeader`;
$8884d087ce93d7bc$export$34e0f9847d4c02dd = `ldgrhG_container`;
$8884d087ce93d7bc$export$85fc379452d91af0 = `ldgrhG_grid`;
$8884d087ce93d7bc$export$711e2b273dbb00ac = `ldgrhG_gridContainer`;
$8884d087ce93d7bc$export$91fbaa0417f2b694 = `ldgrhG_hideScrollBar`;
$8884d087ce93d7bc$export$4754f93c9af7081d = `ldgrhG_modifiedColumnHeader`;
$8884d087ce93d7bc$export$8956cb9ad7faa898 = `ldgrhG_modifiedGridColumnHeader`;
$8884d087ce93d7bc$export$6eedf6f5a4447774 = `ldgrhG_oldColumnHeader`;
$8884d087ce93d7bc$export$4bbd2d49469545b1 = `ldgrhG_oldColumnHeaderArrow`;
$8884d087ce93d7bc$export$9852986a3ec5f6a0 = `ldgrhG_table`;
$8884d087ce93d7bc$export$ce666bf02318c957 = `ldgrhG_tableRow`;

});

parcelRegister("kKHqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4837cd85f2d5fc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jgxY2 = parcelRequire("jgxY2");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $fFrtl = parcelRequire("fFrtl");
function $f4837cd85f2d5fc3$export$2e2bcd8739ae039(props) {
    const { name: releaseName, id: id } = props.crossProjectVersion;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: releaseName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $fFrtl.crossProjectReleaseTitle,
        id: (0, $jgxY2.getIdForChangeCategory)(id, (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE),
        "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.cross-project-release.cross-project-release-title-container-${id}`
    }, releaseName));
}

});
parcelRegister("fFrtl", function(module, exports) {

$parcel$export(module.exports, "crossProjectReleaseTitle", () => $b67ffec6ed2d8df0$export$693a2a1482e505bb, (v) => $b67ffec6ed2d8df0$export$693a2a1482e505bb = v);
var $b67ffec6ed2d8df0$export$693a2a1482e505bb;
$b67ffec6ed2d8df0$export$693a2a1482e505bb = `oAtGSG_crossProjectReleaseTitle`;

});


parcelRegister("k0duZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a771169c16f52fa$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5Q8LG = parcelRequire("5Q8LG");

var $ay5Gc = parcelRequire("ay5Gc");
var $9a771169c16f52fa$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5Q8LG.default), {})((0, $ay5Gc.default));

});
parcelRegister("5Q8LG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b290aec822013c17$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $b290aec822013c17$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    projects: (0, $ehEr2.getProjects),
    issueTypes: (0, $lihml.getIssueTypes)
});

});

parcelRegister("ay5Gc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad4394bd9ba72d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f7Op5 = parcelRequire("f7Op5");

var $hl4M2 = parcelRequire("hl4M2");

var $jgxY2 = parcelRequire("jgxY2");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $8E8ed = parcelRequire("8E8ed");
function $8ad4394bd9ba72d2$export$2e2bcd8739ae039({ projects: projects, issueTypes: issueTypes, details: details }) {
    const projectsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), projects);
    const issueTypesByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueTypes);
    const { issueKey: issueKey, values: { summary: summary, project: projectId, type: issueTypeId }, id: id } = details;
    const projectKey = projectId ? projectsByIdMap[projectId]?.key || '' : '';
    const issueType = issueTypesByIdMap[issueTypeId];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $8E8ed.issueTitle,
        id: (0, $jgxY2.getIdForChangeCategory)(id, (0, $5rYNM.ENTITY).ISSUE),
        "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.issue.issue-title-container-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $8E8ed.issueIcon,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundSize: 'contain',
            backgroundImage: issueType && `url(${issueType.iconUrl})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        projectKey: projectKey,
        issueKey: issueKey,
        className: $8E8ed.issueLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: summary,
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8E8ed.issueSummary
    }, summary)));
}

});
parcelRegister("8E8ed", function(module, exports) {

$parcel$export(module.exports, "issueIcon", () => $64b8711f34dfdf09$export$415983cbc1f2b3fe, (v) => $64b8711f34dfdf09$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $64b8711f34dfdf09$export$b71709449311b2f9, (v) => $64b8711f34dfdf09$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueSummary", () => $64b8711f34dfdf09$export$7c7bc027bbbea103, (v) => $64b8711f34dfdf09$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $64b8711f34dfdf09$export$12781bd67c11efd8, (v) => $64b8711f34dfdf09$export$12781bd67c11efd8 = v);
var $64b8711f34dfdf09$export$415983cbc1f2b3fe;
var $64b8711f34dfdf09$export$b71709449311b2f9;
var $64b8711f34dfdf09$export$7c7bc027bbbea103;
var $64b8711f34dfdf09$export$12781bd67c11efd8;
$64b8711f34dfdf09$export$415983cbc1f2b3fe = `Od-IXa_issueIcon`;
$64b8711f34dfdf09$export$b71709449311b2f9 = `Od-IXa_issueLink`;
$64b8711f34dfdf09$export$7c7bc027bbbea103 = `Od-IXa_issueSummary`;
$64b8711f34dfdf09$export$12781bd67c11efd8 = `Od-IXa_issueTitle`;

});



parcelRegister("hPUoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6de71d7dafb8f52$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $2KZEd = parcelRequire("2KZEd");

var $cwcS3 = parcelRequire("cwcS3");
var $f6de71d7dafb8f52$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2KZEd.default), {})((0, $cwcS3.default));

});
parcelRegister("2KZEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe38e98af8977630$export$2e2bcd8739ae039);

var $iK4oF = parcelRequire("iK4oF");
var $fe38e98af8977630$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (_, ownProps)=>ownProps
], (ownProps)=>({
        ...ownProps
    }));

});

parcelRegister("cwcS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e03f9c8b0c6529$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jgxY2 = parcelRequire("jgxY2");

var $64VaH = parcelRequire("64VaH");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $70rc0 = parcelRequire("70rc0");
const $06e03f9c8b0c6529$export$1f2d195ca7827fba = (version)=>{
    const { id: id, projects: projects } = version;
    const project = projects[0];
    return (0, $64VaH.proxyContextSafeUrl)(`/browse/${project.key}/fixforversion/${id}`);
};
function $06e03f9c8b0c6529$export$2e2bcd8739ae039(props) {
    const { details: version } = props;
    const { id: id, projects: projects, values: { name: releaseName } } = version;
    const { avatarUrl: projectAvatar, name: projectName } = projects[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $70rc0.releaseTitle,
        id: (0, $jgxY2.getIdForChangeCategory)(id, (0, $5rYNM.ENTITY).RELEASE),
        "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.release.release-title-container-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$70rc0.projectIcon}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            backgroundSize: 'contain',
            backgroundImage: `url(${projectAvatar})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: `${releaseName} (${projectName})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $70rc0.titleText
    }, id.startsWith((0, $5rYNM.SCENARIO_ISSUE_ID_PREFIX)) ? `${releaseName} (${projectName})` : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $06e03f9c8b0c6529$export$1f2d195ca7827fba(version),
        target: "_blank",
        rel: "noopener noreferrer"
    }, releaseName, " (", projectName, ")"))));
}

});
parcelRegister("70rc0", function(module, exports) {

$parcel$export(module.exports, "projectIcon", () => $0150fe7537a4eae6$export$e595ab851fd6d370, (v) => $0150fe7537a4eae6$export$e595ab851fd6d370 = v);
$parcel$export(module.exports, "releaseTitle", () => $0150fe7537a4eae6$export$2189f9364c53a5b7, (v) => $0150fe7537a4eae6$export$2189f9364c53a5b7 = v);
$parcel$export(module.exports, "titleText", () => $0150fe7537a4eae6$export$318bb85fd83e5f1a, (v) => $0150fe7537a4eae6$export$318bb85fd83e5f1a = v);
var $0150fe7537a4eae6$export$e595ab851fd6d370;
var $0150fe7537a4eae6$export$2189f9364c53a5b7;
var $0150fe7537a4eae6$export$318bb85fd83e5f1a;
$0150fe7537a4eae6$export$e595ab851fd6d370 = `_8mBR-W_projectIcon`;
$0150fe7537a4eae6$export$2189f9364c53a5b7 = `_8mBR-W_releaseTitle`;
$0150fe7537a4eae6$export$318bb85fd83e5f1a = `_8mBR-W_titleText`;

});



parcelRegister("7MVun", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd257487363b68c6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1DG1q = parcelRequire("1DG1q");

var $5pEwh = parcelRequire("5pEwh");
var $cd257487363b68c6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1DG1q.default), {})((0, $5pEwh.default));

});
parcelRegister("1DG1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a00f6544ad32065$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
var $0a00f6544ad32065$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $75KhQ.getIssueSourcesById),
    (_, ownProps)=>ownProps
], (issueSourcesById, ownProps)=>{
    const { sprint: sprint } = ownProps;
    const issueSourceId = sprint.issueSources && sprint.issueSources[0];
    const issueSource = issueSourcesById[issueSourceId];
    const boardId = issueSource && issueSource.type === (0, $5rYNM.ISSUE_SOURCE_TYPES).BOARD ? issueSource.value : undefined;
    return {
        boardId: boardId
    };
});

});

parcelRegister("5pEwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $79bfb9f84b6c0323$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2Sj2 = parcelRequire("l2Sj2");

var $jgxY2 = parcelRequire("jgxY2");

var $64VaH = parcelRequire("64VaH");
parcelRequire("2Bjja");
var $4JE8j = parcelRequire("4JE8j");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $ibwST = parcelRequire("ibwST");
// eslint-disable-next-line jira/react/no-class-components
class $79bfb9f84b6c0323$var$SprintTitle extends (0, $eUqFw.Component) {
    generateSprintUrl() {
        const { boardId: boardId, sprint: sprint } = this.props;
        if (sprint && (0, $7CnHa.isDefined)(boardId) && boardId !== '') {
            let url = (0, $64VaH.proxyContextSafeUrl)(`/secure/RapidBoard.jspa?rapidView=${boardId}`);
            if (sprint.state === (0, $5rYNM.SPRINT_STATES).CLOSED) url += `&view=reporting&chart=sprintRetrospective&sprint=${sprint.id}`;
            else if (sprint.state === (0, $5rYNM.SPRINT_STATES).FUTURE) url += '&view=planning';
            return url;
        }
    }
    render() {
        const { sprint: sprint, boardId: boardId, id: id, category: category } = this.props;
        let sprintName;
        if (sprint.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban) sprintName = `${(0, $l2Sj2.formatDateUTC)(sprint.startDate, 'DD MMM')} - ` + `${(0, $l2Sj2.formatDateUTC)(sprint.endDate, 'DD MMM')}`;
        else sprintName = sprint.title;
        const sprintUrl = sprint.schedulingMode === (0, $5rYNM.SCHEDULE_MODE).scrum && (0, $7CnHa.isDefined)(boardId) && boardId !== '' && this.generateSprintUrl();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $ibwST.sprintTitle,
            id: (0, $jgxY2.getIdForChangeCategory)(id, category),
            "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.sprint.sprint-title-container-${id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $ibwST.projectIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4JE8j.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: `${sprintName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $ibwST.titleText
        }, (0, $7CnHa.isDefined)(sprintUrl) && sprintUrl !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: this.generateSprintUrl(),
            target: "_blank",
            rel: "noopener noreferrer"
        }, sprintName) : `${sprintName}`)));
    }
}
var $79bfb9f84b6c0323$export$2e2bcd8739ae039 = $79bfb9f84b6c0323$var$SprintTitle;

});
parcelRegister("ibwST", function(module, exports) {

$parcel$export(module.exports, "projectIcon", () => $d3d2c33d837c42b7$export$e595ab851fd6d370, (v) => $d3d2c33d837c42b7$export$e595ab851fd6d370 = v);
$parcel$export(module.exports, "sprintTitle", () => $d3d2c33d837c42b7$export$d36673c13d5182d, (v) => $d3d2c33d837c42b7$export$d36673c13d5182d = v);
$parcel$export(module.exports, "titleText", () => $d3d2c33d837c42b7$export$318bb85fd83e5f1a, (v) => $d3d2c33d837c42b7$export$318bb85fd83e5f1a = v);
var $d3d2c33d837c42b7$export$e595ab851fd6d370;
var $d3d2c33d837c42b7$export$d36673c13d5182d;
var $d3d2c33d837c42b7$export$318bb85fd83e5f1a;
$d3d2c33d837c42b7$export$e595ab851fd6d370 = `_5tEYsq_projectIcon`;
$d3d2c33d837c42b7$export$d36673c13d5182d = `_5tEYsq_sprintTitle`;
$d3d2c33d837c42b7$export$318bb85fd83e5f1a = `_5tEYsq_titleText`;

});



parcelRegister("azMYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e259526c0a6b015$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4nce6 = parcelRequire("4nce6");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $jgxY2 = parcelRequire("jgxY2");

var $7Iub8 = parcelRequire("7Iub8");

var $9qjTn = parcelRequire("9qjTn");
function $7e259526c0a6b015$export$2e2bcd8739ae039(props) {
    const { id: id, category: category, avatarUrl: teamAvatarUrl, name: teamName, useTwpTeams: useTwpTeams = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $9qjTn.teamTitle,
        id: (0, $jgxY2.getIdForChangeCategory)(id, category),
        "data-testid": `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.title.team.team-title-container-${id}`
    }, (0, $430Oj.default)() && useTwpTeams && !teamAvatarUrl ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9qjTn.defaultTeamAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: "",
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$9qjTn.teamIcon}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: teamAvatarUrl ? {
            backgroundSize: 'contain',
            backgroundImage: `url(${teamAvatarUrl})`
        } : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9qjTn.titleText
    }, teamName)));
}

});
parcelRegister("9qjTn", function(module, exports) {

$parcel$export(module.exports, "defaultTeamAvatar", () => $6dc5f8f5a30dc847$export$aa80651379a69724, (v) => $6dc5f8f5a30dc847$export$aa80651379a69724 = v);
$parcel$export(module.exports, "teamIcon", () => $6dc5f8f5a30dc847$export$6d74194612a54b7, (v) => $6dc5f8f5a30dc847$export$6d74194612a54b7 = v);
$parcel$export(module.exports, "teamTitle", () => $6dc5f8f5a30dc847$export$f1ea300f5bc512fd, (v) => $6dc5f8f5a30dc847$export$f1ea300f5bc512fd = v);
$parcel$export(module.exports, "titleText", () => $6dc5f8f5a30dc847$export$318bb85fd83e5f1a, (v) => $6dc5f8f5a30dc847$export$318bb85fd83e5f1a = v);
var $6dc5f8f5a30dc847$export$aa80651379a69724;
var $6dc5f8f5a30dc847$export$6d74194612a54b7;
var $6dc5f8f5a30dc847$export$f1ea300f5bc512fd;
var $6dc5f8f5a30dc847$export$318bb85fd83e5f1a;
$6dc5f8f5a30dc847$export$aa80651379a69724 = `_5-wTfW_defaultTeamAvatar`;
$6dc5f8f5a30dc847$export$6d74194612a54b7 = `_5-wTfW_teamIcon`;
$6dc5f8f5a30dc847$export$f1ea300f5bc512fd = `_5-wTfW_teamTitle`;
$6dc5f8f5a30dc847$export$318bb85fd83e5f1a = `_5-wTfW_titleText`;

});


parcelRegister("csJwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b715669325288b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cCpSA = parcelRequire("cCpSA");

var $fg4I9 = parcelRequire("fg4I9");
var $83b715669325288b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $cCpSA.default), {})((0, $fg4I9.default));

});
parcelRegister("cCpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $aafbb5941261b653$export$2e2bcd8739ae039);

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
const $aafbb5941261b653$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    expandedChanges: (0, $eDYLe.getExpandedChanges)
});
var $aafbb5941261b653$export$2e2bcd8739ae039 = $aafbb5941261b653$var$querySelector;

});

parcelRegister("fg4I9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca13283c695f324b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("1Uotp");
var $eOsHk = parcelRequire("eOsHk");

var $kogU9 = parcelRequire("kogU9");

var $fnOfj = parcelRequire("fnOfj");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $6QOt6 = parcelRequire("6QOt6");

var $lPXB7 = parcelRequire("lPXB7");

var $5kOUx = parcelRequire("5kOUx");

var $6oGhI = parcelRequire("6oGhI");

var $3lULI = parcelRequire("3lULI");

var $agWUp = parcelRequire("agWUp");

var $c3mTP = parcelRequire("c3mTP");

var $6UbOj = parcelRequire("6UbOj");

var $2y4yv = parcelRequire("2y4yv");

var $1CNGE = parcelRequire("1CNGE");

var $kKtTa = parcelRequire("kKtTa");

var $ajFlM = parcelRequire("ajFlM");

var $5xy8f = parcelRequire("5xy8f");

var $bNIIH = parcelRequire("bNIIH");

var $5RGza = parcelRequire("5RGza");

var $lerWa = parcelRequire("lerWa");

var $8Fyr8 = parcelRequire("8Fyr8");

var $8rIYV = parcelRequire("8rIYV");

var $eGrDA = parcelRequire("eGrDA");

var $cJYh4 = parcelRequire("cJYh4");
// eslint-disable-next-line jira/react/no-class-components
class $ca13283c695f324b$var$ValueChangeCell extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            AssigneeComponent: (0, $5kOUx.default),
            CrossProjectReleaseComponent: (0, $3lULI.default),
            EstimateComponent: (0, $c3mTP.default),
            IssueLinkComponent: (0, $2y4yv.default),
            ProjectComponent: (0, $5xy8f.default),
            PriorityComponent: (0, $ajFlM.default),
            ReleaseComponent: (0, $bNIIH.default),
            SprintComponent: (0, $5RGza.default),
            TeamComponent: (0, $eGrDA.default),
            CustomFieldComponent: (0, $agWUp.default),
            PlannedCapacityComponent: (0, $lerWa.default),
            StatusComponent: (0, $8Fyr8.default)
        };
    }
    render() {
        const { intl: intl, change: change, expandedChanges: expandedChanges } = this.props;
        const { attributeName: attributeName, id: id, category: category, type: type, changeCount: changeCount } = change;
        if (type === (0, $5rYNM.SCENARIO_TYPE).DELETED) return null;
        const values = this.getValues();
        const isExpanded = (0, $7CnHa.isDefined)(expandedChanges) && expandedChanges[category].includes(id);
        const hasMultipleChanges = (type === (0, $5rYNM.SCENARIO_TYPE).ADDED || type === (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING) && changeCount > 0 || type === (0, $5rYNM.SCENARIO_TYPE).MULTIPLE;
        if (hasMultipleChanges && isExpanded) return null;
        if (hasMultipleChanges) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $8rIYV["multiple-label"]
        }, intl.formatMessage((0, $kKtTa.default).multipleChanges)));
        if ((0, $7CnHa.isDefined)(attributeName)) {
            const value = values[attributeName];
            if (attributeName.startsWith('issueLink-')) {
                if (!value) return '-';
                const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, // eslint-disable-next-line @typescript-eslint/no-shadow
                values: { type: type } } = value;
                const { IssueLinkComponent: IssueLinkComponent } = this.props;
                if (sourceItemKey === id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueLinkComponent, {
                    issue: targetItemKey,
                    linkType: type,
                    direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).OUTWARD
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueLinkComponent, {
                    issue: sourceItemKey,
                    linkType: type,
                    direction: (0, $5rYNM.ISSUE_LINK_DIRECTION).INWARD
                });
            }
            if (attributeName.startsWith('customField')) {
                if (!value) return '-';
                const { CustomFieldComponent: CustomFieldComponent } = this.props;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const { id: id, value: customFieldValue } = value;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFieldComponent, {
                    id: id,
                    value: customFieldValue,
                    attributeName: attributeName
                });
            }
            if (attributeName.startsWith('teamVelocity')) {
                const { PlannedCapacityComponent: PlannedCapacityComponent } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PlannedCapacityComponent, {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    plannedCapacity: values[attributeName]
                });
            }
            switch(attributeName){
                case 'assignee':
                    {
                        const { AssigneeComponent: AssigneeComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AssigneeComponent, {
                            assignee: value
                        });
                    }
                case 0, $eOsHk.TARGET_START_FIELD:
                case 0, $eOsHk.TARGET_END_FIELD:
                case 'dueDate':
                    {
                        const date = value;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, date ? (0, $l2Sj2.formatDateWithIntl)(intl, date) : '-');
                    }
                case 'iterationLength':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value !== undefined ? `${value}  ${intl.formatMessage((0, $kKtTa.default).weeks)}` : '-');
                case 'crossProjectVersion':
                    {
                        const crossProjectVersionId = value;
                        const { CrossProjectReleaseComponent: CrossProjectReleaseComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, (0, $7CnHa.isDefined)(crossProjectVersionId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CrossProjectReleaseComponent, {
                            crossProjectVersionId: crossProjectVersionId
                        }) : '-');
                    }
                case 'end':
                    {
                        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6QOt6.default), {
                            end: value,
                            emptyMessage: "-"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                paddingRight: "var(--ds-space-050, 4px)"
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                            content: content,
                            id: value
                        }, content));
                    }
                case 'fixVersions':
                    {
                        const { ReleaseComponent: ReleaseComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseComponent, {
                            fixVersions: value
                        });
                    }
                case 'lexoRank':
                case 'description':
                    // Never show a value for rank or description changes
                    return null;
                case 'parent':
                    {
                        const { IssueLinkComponent: IssueLinkComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueLinkComponent, {
                            issue: value
                        });
                    }
                case 'priority':
                    {
                        // eslint-disable-next-line @typescript-eslint/no-shadow
                        const { PriorityComponent: PriorityComponent, change: change } = this.props;
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const details = change.details;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PriorityComponent, {
                            priority: value,
                            project: details.values.project
                        });
                    }
                case 'project':
                    {
                        const { ProjectComponent: ProjectComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectComponent, {
                            project: value
                        });
                    }
                case 'start':
                    {
                        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPXB7.default), {
                            start: value,
                            delta: values.delta,
                            emptyMessage: "-"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                paddingRight: "var(--ds-space-050, 4px)"
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                            content: content,
                            id: value
                        }, content));
                    }
                case 'sprint':
                    {
                        const { SprintComponent: SprintComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SprintComponent, {
                            sprint: value
                        });
                    }
                case 'status':
                    {
                        const { StatusComponent: StatusComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StatusComponent, {
                            statusId: value
                        });
                    }
                case 'statusTransition':
                    return null;
                case 'team':
                    {
                        const { TeamComponent: TeamComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TeamComponent, {
                            team: value
                        });
                    }
                case 'timeEstimate':
                    {
                        const { EstimateComponent: EstimateComponent } = this.props;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EstimateComponent, {
                            timeEstimate: value
                        });
                    }
                case 'exceptions':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "-");
                case 'components':
                case 'addedComponents':
                case 'removedComponents':
                    {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const details = this.props.change.details;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6oGhI.default), {
                            project: details.values.project,
                            components: value,
                            isAdded: attributeName !== 'removedComponents'
                        });
                    }
                case 'labels':
                case 'addedLabels':
                case 'removedLabels':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CNGE.default), {
                        labels: value || [],
                        isAdded: attributeName !== 'removedLabels'
                    });
                case 'color':
                    return null;
                case 'goals':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UbOj.default), {
                        goals: value
                    });
                default:
                    {
                        const text = (0, $7CnHa.isDefined)(value) ? value : '-';
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                            content: text
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text));
                    }
            }
        }
        return null;
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.getValues = ()=>{
            const { change: change, valueType: valueType } = this.props;
            switch(change.category){
                case (0, $5rYNM.ENTITY).ISSUE:
                case (0, $5rYNM.ENTITY).RELEASE:
                case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
                case (0, $5rYNM.ENTITY).SPRINT:
                    if (valueType === (0, $cJYh4.VALUE_TYPE).CURRENT) return change.details.originals;
                    return change.details.values;
                case (0, $5rYNM.ENTITY).TEAM:
                case (0, $5rYNM.ENTITY).RESOURCE:
                    {
                        const detailChange = (0, $kogU9.getDetailChange)(change);
                        if (!detailChange) return {};
                        if (valueType === (0, $cJYh4.VALUE_TYPE).CURRENT) return {
                            [detailChange.attributeName]: detailChange.originalValue
                        };
                        return {
                            [detailChange.attributeName]: detailChange.currentValue
                        };
                    }
                default:
                    return {};
            }
        };
    }
}
var $ca13283c695f324b$export$2e2bcd8739ae039 = (0, $fnOfj.injectIntlWithDefaultProps)($ca13283c695f324b$var$ValueChangeCell);

});
parcelRegister("6QOt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $064b354db25fa915$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("wcCGG");
var $lNU8O = parcelRequire("lNU8O");
var $aKueD = parcelRequire("aKueD");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");
function $064b354db25fa915$var$ReleaseDate(props) {
    const { intl: intl, end: end, emptyMessage: emptyMessage } = props;
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    if (end === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, emptyMessage);
    const { method: method } = (0, $aKueD.getEndDateMethod)(end);
    if (method === (0, $lNU8O.DATE_METHODS).FIXED_DATE && (0, $7CnHa.isDefined)(end)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatTimestamp(end));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $ib5d3.default).afterAllIssuesAreCompleted));
}
var $064b354db25fa915$export$2e2bcd8739ae039 = (0, $2qhQi.default)($064b354db25fa915$var$ReleaseDate);

});

parcelRegister("lPXB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b9022ab24fd403$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("wcCGG");
var $lNU8O = parcelRequire("lNU8O");
var $aKueD = parcelRequire("aKueD");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");
function $90b9022ab24fd403$var$StartDate(props) {
    const { intl: intl, start: start, delta: delta, emptyMessage: emptyMessage } = props;
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    if (start === undefined && delta === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, emptyMessage);
    const { method: method, quantity: quantity = 0, unit: unit = 0, direction: direction = (0, $5rYNM.DIRECTIONS).AFTER } = (0, $aKueD.getStartDateMethod)(start, delta);
    let message;
    if (method === (0, $lNU8O.DATE_METHODS).FIXED_DATE && (0, $7CnHa.isDefined)(start)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatTimestamp(start));
    if (method === (0, $lNU8O.DATE_METHODS).RELATIVE_TO_PREVIOUS_RELEASE) {
        if (quantity === 0) {
            message = intl.formatMessage((0, $ib5d3.default).whenPreviousReleaseEnds);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, message);
        }
        message = intl.formatMessage((0, $ib5d3.default).relativeToPreviousRelease, {
            factor: `${quantity} ${unit} ${intl.formatMessage((0, $ib5d3.default)[direction])}`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, message);
    }
    message = intl.formatMessage((0, $ib5d3.default).asEarlyAsPossible);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, message);
}
var $90b9022ab24fd403$export$2e2bcd8739ae039 = (0, $2qhQi.default)($90b9022ab24fd403$var$StartDate);

});

parcelRegister("5kOUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $df563902bcf9a6e5$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $iaQe4 = parcelRequire("iaQe4");

var $lWK7t = parcelRequire("lWK7t");
var $df563902bcf9a6e5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iaQe4.default), {})((0, $lWK7t.default));

});
parcelRegister("iaQe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d76e5d4a9bc445fe$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");
const $d76e5d4a9bc445fe$export$78fb49a702cc1f2 = (state)=>({
        assigneeList: (0, $6VhAf.getAssigneeList)(state)
    });
var $d76e5d4a9bc445fe$export$2e2bcd8739ae039 = $d76e5d4a9bc445fe$export$78fb49a702cc1f2;

});

parcelRegister("lWK7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $094815fa97f555a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $9e7LZ = parcelRequire("9e7LZ");

var $7Iub8 = parcelRequire("7Iub8");

var $gCZyp = parcelRequire("gCZyp");
function $094815fa97f555a2$export$2e2bcd8739ae039(props) {
    const { assignee: assignee, assigneeList: assigneeList } = props;
    if (!assignee) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const person = assigneeList.find((person)=>person.personId === assignee);
    if (person) {
        const { jiraUser: { title: title, avatarUrl: avatarUrl } } = person;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: title,
            id: assignee
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $gCZyp.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: avatarUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $gCZyp.title
        }, title));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});
parcelRegister("9e7LZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b3e0c3fd0b5eec9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $ib5d3 = parcelRequire("ib5d3");
function $0b3e0c3fd0b5eec9$var$NotInPlanMessage(_) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).notInPlan);
}
var $0b3e0c3fd0b5eec9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0b3e0c3fd0b5eec9$var$NotInPlanMessage);

});

parcelRegister("gCZyp", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $c1aff14831df3fec$export$345c5736c8054f22, (v) => $c1aff14831df3fec$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "title", () => $c1aff14831df3fec$export$fb184b623420d9be, (v) => $c1aff14831df3fec$export$fb184b623420d9be = v);
var $c1aff14831df3fec$export$345c5736c8054f22;
var $c1aff14831df3fec$export$fb184b623420d9be;
$c1aff14831df3fec$export$345c5736c8054f22 = `J-Y8fq_avatar`;
$c1aff14831df3fec$export$fb184b623420d9be = `J-Y8fq_title`;

});



parcelRegister("6oGhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0f74ebcb600fee$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kEunj = parcelRequire("kEunj");

var $6j0Lf = parcelRequire("6j0Lf");
var $9b0f74ebcb600fee$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $kEunj.default), {})((0, $6j0Lf.default));

});
parcelRegister("kEunj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8f0af9bbe1cf46b$export$2e2bcd8739ae039);

var $lvJU2 = parcelRequire("lvJU2");
const $a8f0af9bbe1cf46b$var$querySelector = (state)=>({
        componentDetails: (0, $lvJU2.getComponentsByProjectId)(state)
    });
var $a8f0af9bbe1cf46b$export$2e2bcd8739ae039 = $a8f0af9bbe1cf46b$var$querySelector;

});

parcelRegister("6j0Lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $85369388bb12489f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8U3E7 = parcelRequire("8U3E7");
class $85369388bb12489f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const title = this.getComponents().map((component)=>component.name).join(', ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8U3E7.default), {
            tooltip: title,
            tags: this.getComponents().map((component)=>component.name),
            isRemoved: !this.props.isAdded
        });
    }
    constructor(...args){
        super(...args);
        this.getComponents = ()=>{
            const { componentDetails: componentDetails, components: components, project: project } = this.props;
            if (!components || !project) return [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return componentDetails[project.toString()].filter((component)=>components.includes(component.id));
        };
    }
}

});
parcelRegister("8U3E7", function(module, exports) {

$parcel$export(module.exports, "default", () => $65167cd9f0e1bc8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");
var $gwbfD = parcelRequire("gwbfD");

var $aSSFe = parcelRequire("aSSFe");
function $65167cd9f0e1bc8b$export$2e2bcd8739ae039(props) {
    const { tooltip: tooltip, tags: tags, isRemoved: isRemoved, width: width } = props;
    let componentClass = $aSSFe.component;
    if (isRemoved) componentClass = `${componentClass} ${$aSSFe.componentRemoved}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $aSSFe.componentsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $aSSFe.tagContainer,
        style: {
            maxWidth: width
        }
    }, tags.map((tag, i)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: componentClass,
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
            text: tag
        })))))));
}

});
parcelRegister("aSSFe", function(module, exports) {

$parcel$export(module.exports, "component", () => $7ec959a411561dfb$export$d8556a2a8f973135, (v) => $7ec959a411561dfb$export$d8556a2a8f973135 = v);
$parcel$export(module.exports, "componentRemoved", () => $7ec959a411561dfb$export$95ba871b46255fbb, (v) => $7ec959a411561dfb$export$95ba871b46255fbb = v);
$parcel$export(module.exports, "componentsContainer", () => $7ec959a411561dfb$export$77d38a6d62c7a7c9, (v) => $7ec959a411561dfb$export$77d38a6d62c7a7c9 = v);
$parcel$export(module.exports, "tagContainer", () => $7ec959a411561dfb$export$89a4c13858b336ea, (v) => $7ec959a411561dfb$export$89a4c13858b336ea = v);
var $7ec959a411561dfb$export$d8556a2a8f973135;
var $7ec959a411561dfb$export$95ba871b46255fbb;
var $7ec959a411561dfb$export$77d38a6d62c7a7c9;
var $7ec959a411561dfb$export$89a4c13858b336ea;
$7ec959a411561dfb$export$d8556a2a8f973135 = `_9m15JG_component`;
$7ec959a411561dfb$export$95ba871b46255fbb = `_9m15JG_componentRemoved`;
$7ec959a411561dfb$export$77d38a6d62c7a7c9 = `_9m15JG_componentsContainer`;
$7ec959a411561dfb$export$89a4c13858b336ea = `_9m15JG_tagContainer`;

});




parcelRegister("3lULI", function(module, exports) {

$parcel$export(module.exports, "default", () => $044e9ff4437d259c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $Z7yVv = parcelRequire("Z7yVv");

var $5RNBz = parcelRequire("5RNBz");
var $044e9ff4437d259c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $Z7yVv.default), {})((0, $5RNBz.default));

});
parcelRegister("Z7yVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8ff909c921bb98$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $iK4oF = parcelRequire("iK4oF");
var $cc8ff909c921bb98$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    crossProjectVersions: (0, $2Ruxt.getCrossProjectVersions),
    removedCrossProjectVersions: (0, $2Ruxt.getRemovedCrossProjectVersions)
});

});

parcelRegister("5RNBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $111a34ac40cfdde4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f7Op5 = parcelRequire("f7Op5");

var $9e7LZ = parcelRequire("9e7LZ");

var $7CnHa = parcelRequire("7CnHa");

var $7Iub8 = parcelRequire("7Iub8");
function $111a34ac40cfdde4$export$2e2bcd8739ae039(props) {
    const { crossProjectVersionId: crossProjectVersionId, crossProjectVersions: crossProjectVersions, removedCrossProjectVersions: removedCrossProjectVersions } = props;
    const crossProjectVersionsByIdMap = (0, $7CnHa.indexBy)($f7Op5.default('id'), [
        ...crossProjectVersions,
        ...removedCrossProjectVersions
    ]);
    const crossProjectVersion = crossProjectVersionsByIdMap[crossProjectVersionId];
    return (0, $7CnHa.isDefined)(crossProjectVersion) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: crossProjectVersion.name,
        id: crossProjectVersionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, crossProjectVersion.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});


parcelRegister("agWUp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c77e05db52c290$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $iWBrA = parcelRequire("iWBrA");

var $gdcdG = parcelRequire("gdcdG");
var $c7c77e05db52c290$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $iWBrA.default), {})((0, $gdcdG.default));

});
parcelRegister("iWBrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $935a49fb73d6240c$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
const $935a49fb73d6240c$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    customFields: (0, $kKj1m.getSupportedCustomFields)
});
var $935a49fb73d6240c$export$2e2bcd8739ae039 = $935a49fb73d6240c$var$mapStateToProps;

});

parcelRegister("gdcdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $de7b297b3299ff0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $h3Ils = parcelRequire("h3Ils");

var $bMDrw = parcelRequire("bMDrw");

var $439Ur = parcelRequire("439Ur");

var $1Catp = parcelRequire("1Catp");

var $fJJif = parcelRequire("fJJif");
function $de7b297b3299ff0e$export$2e2bcd8739ae039(props) {
    const { customFields: customFields, id: id, value: value, attributeName: attributeName } = props;
    if (!(0, $7CnHa.isDefined)(value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "-");
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const field = customFields.find((field)=>field.id.toString() === id.toString());
    const emptyElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
    if (!field) return emptyElement;
    if (typeof value === 'string' || typeof value === 'number') {
        const valueString = value === 'string' ? value : String(value);
        switch(field.type.key){
            case (0, $5rYNM.CustomFieldTypes).TextField:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Catp.default), {
                    value: valueString
                });
            case (0, $5rYNM.CustomFieldTypes).NumberField:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Catp.default), {
                    value: valueString
                });
            case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            case (0, $5rYNM.CustomFieldTypes).RadioButtons:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $439Ur.default), {
                    value: valueString
                });
            case (0, $5rYNM.CustomFieldTypes).DatePicker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3Ils.default), {
                    value: value
                });
            case (0, $5rYNM.CustomFieldTypes).UserPicker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJJif.default), {
                    value: valueString
                });
            default:
                return emptyElement;
        }
    } else // value is an array
    switch(field.type.key){
        case (0, $5rYNM.CustomFieldTypes).Labels:
        case (0, $5rYNM.CustomFieldTypes).MultiSelect:
        case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMDrw.default), {
                value: value,
                attributeName: attributeName
            });
        default:
            return emptyElement;
    }
}

});
parcelRegister("h3Ils", function(module, exports) {

$parcel$export(module.exports, "default", () => $99b31f8750ed0739$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2Sj2 = parcelRequire("l2Sj2");

var $7Iub8 = parcelRequire("7Iub8");
function $99b31f8750ed0739$export$2e2bcd8739ae039(props) {
    const { value: value } = props;
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getFormattedDate = (value)=>formatTimestamp(value);
    const date = typeof value === 'number' ? getFormattedDate(value) : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: date
    }, date);
}

});

parcelRegister("bMDrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $579eed46655e4ea3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $k5x0C = parcelRequire("k5x0C");

var $lS3K6 = parcelRequire("lS3K6");
var $579eed46655e4ea3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $k5x0C.default), {})((0, $lS3K6.default));

});
parcelRegister("k5x0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d714c05082a46e3$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
const $7d714c05082a46e3$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    selectOptions: (0, $kKj1m.getSelectOptions)
});
var $7d714c05082a46e3$export$2e2bcd8739ae039 = $7d714c05082a46e3$var$querySelector;

});

parcelRegister("lS3K6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf37ead2476fdfb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8U3E7 = parcelRequire("8U3E7");
class $4bf37ead2476fdfb$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { value: value = [], attributeName: attributeName } = this.props;
        const options = value.map(this.getValue).map((option)=>option.value);
        const title = options.join(', ');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8U3E7.default), {
            tooltip: title,
            tags: options,
            isRemoved: attributeName.startsWith('customFieldValueRemoved'),
            width: "150px"
        });
    }
    constructor(...args){
        super(...args);
        this.getValue = (id)=>{
            const { selectOptions: selectOptions } = this.props;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const option = selectOptions.find((option)=>option.id.toString() === id.toString());
            if (!option) return {
                value: id
            };
            return option;
        };
    }
}

});


parcelRegister("439Ur", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cacf9695990d4b0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8vncE = parcelRequire("8vncE");

var $eRu3Y = parcelRequire("eRu3Y");
var $6cacf9695990d4b0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $8vncE.default), {})((0, $eRu3Y.default));

});
parcelRegister("8vncE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf74b2e31dd7d75a$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $iK4oF = parcelRequire("iK4oF");
const $bf74b2e31dd7d75a$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    singleSelectionOptions: (0, $kKj1m.getSelectOptions)
});
var $bf74b2e31dd7d75a$export$2e2bcd8739ae039 = $bf74b2e31dd7d75a$var$mapStateToProps;

});

parcelRegister("eRu3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d808e0e260be076$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Iub8 = parcelRequire("7Iub8");
function $3d808e0e260be076$export$2e2bcd8739ae039(props) {
    const { value: value, singleSelectionOptions: singleSelectionOptions } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const option = singleSelectionOptions.find((option)=>option.id.toString() === value);
    if (!option) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: option.value
    }, option.value);
}

});


parcelRegister("1Catp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b8ff3db325c0be$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Iub8 = parcelRequire("7Iub8");
function $d9b8ff3db325c0be$export$2e2bcd8739ae039(props) {
    const { value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: value
    }, value);
}

});

parcelRegister("fJJif", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d803b01b751585$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fNWoU = parcelRequire("fNWoU");

var $4qiSn = parcelRequire("4qiSn");
var $86d803b01b751585$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fNWoU.default), {})((0, $4qiSn.default));

});
parcelRegister("fNWoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f602d6519445cf$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");
const $56f602d6519445cf$var$querySelector = (state)=>({
        userList: (0, $kKj1m.getUserPickerOptions)(state).userList
    });
var $56f602d6519445cf$export$2e2bcd8739ae039 = $56f602d6519445cf$var$querySelector;

});

parcelRegister("4qiSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65b2be9ac3232e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $9e7LZ = parcelRequire("9e7LZ");

var $7CnHa = parcelRequire("7CnHa");

var $7Iub8 = parcelRequire("7Iub8");

var $kFLkI = parcelRequire("kFLkI");
function $e65b2be9ac3232e3$export$2e2bcd8739ae039(props) {
    const { value: value, userList: userList } = props;
    if (!(0, $7CnHa.isDefined)(value)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    const user = userList.find((person)=>person.value === value);
    if (user) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: user.label,
        id: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $kFLkI.avatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "xsmall",
        src: user.icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $kFLkI.title
    }, user.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});
parcelRegister("kFLkI", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $f0cc5a5bb6ad1619$export$345c5736c8054f22, (v) => $f0cc5a5bb6ad1619$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "title", () => $f0cc5a5bb6ad1619$export$fb184b623420d9be, (v) => $f0cc5a5bb6ad1619$export$fb184b623420d9be = v);
var $f0cc5a5bb6ad1619$export$345c5736c8054f22;
var $f0cc5a5bb6ad1619$export$fb184b623420d9be;
$f0cc5a5bb6ad1619$export$345c5736c8054f22 = `Fod5uq_avatar`;
$f0cc5a5bb6ad1619$export$fb184b623420d9be = `Fod5uq_title`;

});





parcelRegister("c3mTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fcb03d8ba3a4eb$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $c1dBh = parcelRequire("c1dBh");

var $7TxvN = parcelRequire("7TxvN");
var $10fcb03d8ba3a4eb$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $c1dBh.default), {})((0, $7TxvN.default));

});
parcelRegister("c1dBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ded9828855dc02$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");
const $03ded9828855dc02$var$querySelector = (state)=>({
        plan: (0, $75KhQ.getPlan)(state),
        workingHours: (0, $dhHiZ.getJiraHoursPerDay)(state)
    });
var $03ded9828855dc02$export$2e2bcd8739ae039 = $03ded9828855dc02$var$querySelector;

});

parcelRegister("7TxvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed76aa8687e350c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5fUv6 = parcelRequire("5fUv6");

var $7CnHa = parcelRequire("7CnHa");
const $ed76aa8687e350c5$var$planningUnits = {
    storyPoints: 'StoryPoints',
    days: 'Days',
    hours: 'Hours'
};
class $ed76aa8687e350c5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getEstimateValue(planningUnit, timeEstimate) {
        switch(planningUnit){
            case $ed76aa8687e350c5$var$planningUnits.days:
                return (0, $5fUv6.convertSecondsToDays)(timeEstimate, this.props.workingHours);
            case $ed76aa8687e350c5$var$planningUnits.hours:
                return (0, $5fUv6.convertSecondsToHours)(timeEstimate);
            case $ed76aa8687e350c5$var$planningUnits.storyPoints:
                // We can't accurately convert a timeEstimate for a points plan (it should be filtered out anyway)
                return 0;
            default:
                throw new Error(`Unexpected planningUnit: ${planningUnit}`);
        }
    }
    getEstimateText() {
        const { plan: { planningUnit: planningUnit }, timeEstimate: timeEstimate } = this.props;
        const estimateValue = this.getEstimateValue(planningUnit, timeEstimate);
        return this.round(estimateValue).toString();
    }
    render() {
        const { timeEstimate: timeEstimate } = this.props;
        if (!(0, $7CnHa.isDefined)(timeEstimate)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, this.getEstimateText());
    }
    constructor(...args){
        super(...args);
        this.round = (number)=>Math.round(number * 1000) / 1000;
    }
}

});


parcelRegister("6UbOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d8ebc3772dc904$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $lGIBI = parcelRequire("lGIBI");

var $7Iub8 = parcelRequire("7Iub8");
function $63d8ebc3772dc904$export$2e2bcd8739ae039({ goals: goals }) {
    const [{ lazyGoalsByARI: lazyGoalsByARI }] = (0, $lGIBI.useLazyGoals)();
    const allGoals = goals.reduce((acc, goalARI)=>{
        const lazyGoal = lazyGoalsByARI[goalARI]?.goal;
        if (lazyGoal) acc.push(lazyGoal);
        return acc;
    }, []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(allGoals)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "-");
    const sortedGoalNames = allGoals.map((goal)=>goal.name).sort().join(', ');
    const sortedGoalKeys = allGoals.map((goal)=>goal.key).sort().join(', ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: sortedGoalNames
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, sortedGoalKeys));
}

});

parcelRegister("2y4yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b2f8b9e992b4b9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bKc6g = parcelRequire("bKc6g");

var $7H445 = parcelRequire("7H445");
var $40b2f8b9e992b4b9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bKc6g.default), {})((0, $7H445.default));

});
parcelRegister("bKc6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d281077d94772c$export$2e2bcd8739ae039);

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
var $e3d281077d94772c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issues: (0, $cwP4d.getIssues),
    issuesInChangeData: (0, $kwMvv.getIssueChangesData),
    issueLinkTypes: (state)=>(0, $dhHiZ.getIssueLinkTypesInfo)(state).issueLinkTypes,
    issueTypes: (0, $lihml.getIssueTypes),
    projects: (0, $ehEr2.getProjects)
});

});

parcelRegister("7H445", function(module, exports) {

$parcel$export(module.exports, "default", () => $77ed7ff5a1c22450$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hl4M2 = parcelRequire("hl4M2");

var $9e7LZ = parcelRequire("9e7LZ");

var $7CnHa = parcelRequire("7CnHa");

var $7Iub8 = parcelRequire("7Iub8");

var $7C0Jk = parcelRequire("7C0Jk");

var $iwuv0 = parcelRequire("iwuv0");
function $77ed7ff5a1c22450$export$2e2bcd8739ae039(props) {
    const { issue: issueId, issues: issues, issuesInChangeData: issuesInChangeData, issueLinkTypes: issueLinkTypes, issueTypes: issueTypes, linkType: linkType, direction: direction, projects: projects } = props;
    const NotInPlanComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
    if (!issueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    const targetIssueFromChangeData = issuesInChangeData.find((currentIssue)=>currentIssue.id === issueId);
    const targetIssueFromBacklog = issues.find((currentIssue)=>currentIssue.id === issueId);
    if (!((0, $7CnHa.isDefined)(targetIssueFromChangeData) || (0, $7CnHa.isDefined)(targetIssueFromBacklog))) return NotInPlanComponent;
    let summary;
    let project;
    let type;
    let issueKey;
    if ((0, $7CnHa.isDefined)(targetIssueFromChangeData)) ({ values: { summary: summary, project: project, type: type }, issueKey: issueKey } = targetIssueFromChangeData);
    else if ((0, $7CnHa.isDefined)(targetIssueFromBacklog)) ({ summary: summary, project: project, type: type, issueKey: issueKey } = targetIssueFromBacklog);
    const targetProject = projects.find((currentProject)=>currentProject.id === project);
    const issueType = issueTypes.find((currentIssueType)=>currentIssueType.id === type);
    const link = linkType && issueLinkTypes.find(({ id: id })=>id === linkType);
    const issueLinkType = link && direction && (0, $7C0Jk.titleCase)(link[direction]);
    if (targetProject && issueType) {
        const { key: projectKey } = targetProject;
        const title = `${issueLinkType ? `${issueLinkType} ` : ''}${projectKey}${issueKey ? `-${issueKey}` : ''} ${summary || ''}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: title,
            id: issueId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $iwuv0.issueTitle
        }, issueLinkType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $iwuv0.issueLinkType
        }, issueLinkType) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $iwuv0.issueIcon,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundSize: 'contain',
                backgroundImage: issueType && `url(${issueType.iconUrl})`
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
            projectKey: projectKey,
            issueKey: issueKey,
            className: $iwuv0.issueLink
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $iwuv0.issueSummary
        }, summary)));
    }
    return NotInPlanComponent;
}

});
parcelRegister("iwuv0", function(module, exports) {

$parcel$export(module.exports, "issueIcon", () => $d7c2df9ddfa0ca97$export$415983cbc1f2b3fe, (v) => $d7c2df9ddfa0ca97$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $d7c2df9ddfa0ca97$export$b71709449311b2f9, (v) => $d7c2df9ddfa0ca97$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueLinkType", () => $d7c2df9ddfa0ca97$export$294038f9fee3cea7, (v) => $d7c2df9ddfa0ca97$export$294038f9fee3cea7 = v);
$parcel$export(module.exports, "issueSummary", () => $d7c2df9ddfa0ca97$export$7c7bc027bbbea103, (v) => $d7c2df9ddfa0ca97$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $d7c2df9ddfa0ca97$export$12781bd67c11efd8, (v) => $d7c2df9ddfa0ca97$export$12781bd67c11efd8 = v);
var $d7c2df9ddfa0ca97$export$415983cbc1f2b3fe;
var $d7c2df9ddfa0ca97$export$b71709449311b2f9;
var $d7c2df9ddfa0ca97$export$294038f9fee3cea7;
var $d7c2df9ddfa0ca97$export$7c7bc027bbbea103;
var $d7c2df9ddfa0ca97$export$12781bd67c11efd8;
$d7c2df9ddfa0ca97$export$415983cbc1f2b3fe = `-1QI8a_issueIcon`;
$d7c2df9ddfa0ca97$export$b71709449311b2f9 = `-1QI8a_issueLink`;
$d7c2df9ddfa0ca97$export$294038f9fee3cea7 = `-1QI8a_issueLinkType`;
$d7c2df9ddfa0ca97$export$7c7bc027bbbea103 = `-1QI8a_issueSummary`;
$d7c2df9ddfa0ca97$export$12781bd67c11efd8 = `-1QI8a_issueTitle`;

});



parcelRegister("1CNGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c76b3da4e6aeb4d3$export$2e2bcd8739ae039);

var $jaOBq = parcelRequire("jaOBq");
var $c76b3da4e6aeb4d3$export$2e2bcd8739ae039 = (0, $jaOBq.default);

});
parcelRegister("jaOBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61263881348840cc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8U3E7 = parcelRequire("8U3E7");
function $61263881348840cc$export$2e2bcd8739ae039(props) {
    const { labels: labels, isAdded: isAdded } = props;
    const title = labels.join(', ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8U3E7.default), {
        tooltip: title,
        tags: labels,
        isRemoved: !isAdded,
        width: "150px"
    });
}

});


parcelRegister("kKtTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce4e296c8477898a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce4e296c8477898a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    multipleChanges: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.multiple-changes",
        "defaultMessage": "Multiple"
    },
    weeks: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.weeks",
        "defaultMessage": "Weeks"
    }
});

});

parcelRegister("ajFlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d54715e76b6a35$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6FB01 = parcelRequire("6FB01");

var $jXGKg = parcelRequire("jXGKg");
var $39d54715e76b6a35$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6FB01.default), {})((0, $jXGKg.default));

});
parcelRegister("6FB01", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e45fd253c81eac7$export$2e2bcd8739ae039);

var $jp3RH = parcelRequire("jp3RH");

var $ehEr2 = parcelRequire("ehEr2");
const $1e45fd253c81eac7$var$querySelector = (state, ownProps)=>({
        prioritiesByIdMap: (0, $jp3RH.getIssuePriorities)(state),
        priorityIdsForProject: ownProps.project && (0, $ehEr2.getIssuePriorityIdsByProjectId)(state)[ownProps.project] || []
    });
var $1e45fd253c81eac7$export$2e2bcd8739ae039 = $1e45fd253c81eac7$var$querySelector;

});

parcelRegister("jXGKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb00ed7d15729ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $9e7LZ = parcelRequire("9e7LZ");

var $64VaH = parcelRequire("64VaH");

var $7Iub8 = parcelRequire("7Iub8");

var $6xq1C = parcelRequire("6xq1C");
function $0eb00ed7d15729ec$export$2e2bcd8739ae039(props) {
    const { prioritiesByIdMap: prioritiesByIdMap, priority: priority, priorityIdsForProject: priorityIdsForProject } = props;
    if (!priority) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    const targetPriority = prioritiesByIdMap[priority];
    if (targetPriority && priorityIdsForProject.includes(priority)) {
        const { iconUrl: iconUrl, name: name } = targetPriority;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: name,
            id: priority
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $6xq1C.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: (0, $64VaH.proxyContextSafeUrl)(iconUrl)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $6xq1C.title
        }, name));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});
parcelRegister("6xq1C", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $013a7bec119050f2$export$345c5736c8054f22, (v) => $013a7bec119050f2$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "title", () => $013a7bec119050f2$export$fb184b623420d9be, (v) => $013a7bec119050f2$export$fb184b623420d9be = v);
var $013a7bec119050f2$export$345c5736c8054f22;
var $013a7bec119050f2$export$fb184b623420d9be;
$013a7bec119050f2$export$345c5736c8054f22 = `jhcJ8q_avatar`;
$013a7bec119050f2$export$fb184b623420d9be = `jhcJ8q_title`;

});



parcelRegister("5xy8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a02e2c2bc21ea0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $eRKft = parcelRequire("eRKft");

var $ipsHC = parcelRequire("ipsHC");
var $73a02e2c2bc21ea0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $eRKft.default), {})((0, $ipsHC.default));

});
parcelRegister("eRKft", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a39c4f65b5cb1f$export$2e2bcd8739ae039);

var $ehEr2 = parcelRequire("ehEr2");
const $b8a39c4f65b5cb1f$var$querySelector = (state)=>({
        projects: (0, $ehEr2.getProjects)(state)
    });
var $b8a39c4f65b5cb1f$export$2e2bcd8739ae039 = $b8a39c4f65b5cb1f$var$querySelector;

});

parcelRegister("ipsHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26291a4a971cde9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $9e7LZ = parcelRequire("9e7LZ");

var $7Iub8 = parcelRequire("7Iub8");

var $lDqoc = parcelRequire("lDqoc");
function $d26291a4a971cde9$export$2e2bcd8739ae039(props) {
    const { project: project, projects: projects } = props;
    const targetProject = projects.find((currentProject)=>currentProject.id === project);
    if (targetProject) {
        const { avatarUrl: avatarUrl, name: name } = targetProject;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            id: project,
            content: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $lDqoc.avatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: avatarUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $lDqoc.name
        }, name));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});
parcelRegister("lDqoc", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $fc01b5d9d5f6ff77$export$345c5736c8054f22, (v) => $fc01b5d9d5f6ff77$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "name", () => $fc01b5d9d5f6ff77$export$a8ff84c12d48cfa6, (v) => $fc01b5d9d5f6ff77$export$a8ff84c12d48cfa6 = v);
var $fc01b5d9d5f6ff77$export$345c5736c8054f22;
var $fc01b5d9d5f6ff77$export$a8ff84c12d48cfa6;
$fc01b5d9d5f6ff77$export$345c5736c8054f22 = `I5-f4G_avatar`;
$fc01b5d9d5f6ff77$export$a8ff84c12d48cfa6 = `I5-f4G_name`;

});



parcelRegister("bNIIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa0a8e2788c145d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5i6B8 = parcelRequire("5i6B8");

var $83eQB = parcelRequire("83eQB");
var $faa0a8e2788c145d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5i6B8.default), {})((0, $83eQB.default));

});
parcelRegister("5i6B8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b05fd0a32fc9652$export$2e2bcd8739ae039);

var $wcCGG = parcelRequire("wcCGG");
const $5b05fd0a32fc9652$var$querySelector = (state)=>({
        versions: [
            ...(0, $wcCGG.getVersions)(state),
            ...(0, $wcCGG.getRemovedVersions)(state)
        ]
    });
var $5b05fd0a32fc9652$export$2e2bcd8739ae039 = $5b05fd0a32fc9652$var$querySelector;

});

parcelRegister("83eQB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa274e05b742641$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $7Iub8 = parcelRequire("7Iub8");

var $ib5d3 = parcelRequire("ib5d3");
function $dfa274e05b742641$var$Release({ intl: intl, fixVersions: fixVersions = [], versions: versions }) {
    const versionNames = fixVersions && fixVersions.map((fixVersion)=>{
        const targetVersion = versions.find((currentVersion)=>currentVersion.id === fixVersion);
        if (targetVersion) return targetVersion.name;
        return intl.formatMessage((0, $ib5d3.default).notInPlan);
    });
    return versionNames ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: versionNames.join(', ')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, versionNames.join(', '))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "-");
}
var $dfa274e05b742641$export$2e2bcd8739ae039 = (0, $2qhQi.default)($dfa274e05b742641$var$Release);

});


parcelRegister("5RGza", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a237d7d5013752$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hxEr0 = parcelRequire("hxEr0");

var $4VS5s = parcelRequire("4VS5s");
var $25a237d7d5013752$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hxEr0.default), {})((0, $4VS5s.default));

});
parcelRegister("hxEr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f857912581b82cbb$export$2e2bcd8739ae039);

var $c1XMU = parcelRequire("c1XMU");
const $f857912581b82cbb$var$querySelector = (state)=>({
        sprints: (0, $c1XMU.getSprints)(state),
        externalSprintsById: (0, $c1XMU.getExternalSprintsById)(state)
    });
var $f857912581b82cbb$export$2e2bcd8739ae039 = $f857912581b82cbb$var$querySelector;

});

parcelRegister("4VS5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $89c7ec133790a278$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $9e7LZ = parcelRequire("9e7LZ");

var $7Iub8 = parcelRequire("7Iub8");

var $kq4Hl = parcelRequire("kq4Hl");
function $89c7ec133790a278$var$Sprint(props) {
    const { intl: intl, sprint: sprint, sprints: sprints, externalSprintsById: externalSprintsById } = props;
    if (!sprint) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    const targetSprint = sprints.find((currentSprint)=>currentSprint.id === sprint);
    if (targetSprint) {
        const { title: title } = targetSprint;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: title,
            id: sprint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, title));
    }
    const externalSprint = externalSprintsById[sprint];
    if (externalSprint) {
        const { title: title } = externalSprint;
        const externalSprintText = intl.formatMessage((0, $kq4Hl.default).externalSprint);
        const text = `${title} (${externalSprintText})`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: text,
            id: sprint
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}
var $89c7ec133790a278$export$2e2bcd8739ae039 = (0, $2qhQi.default)($89c7ec133790a278$var$Sprint);

});
parcelRegister("kq4Hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0c269ffe480bf8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e0c269ffe480bf8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.sprint.external-sprint",
        "defaultMessage": "External sprint"
    }
});

});



parcelRegister("lerWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f88c98539faf7ac$export$2e2bcd8739ae039);

var $fVnpA = parcelRequire("fVnpA");
var $2f88c98539faf7ac$export$2e2bcd8739ae039 = (0, $fVnpA.default);

});
parcelRegister("fVnpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2607276d46ae9534$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");

var $7CnHa = parcelRequire("7CnHa");

var $2FGe4 = parcelRequire("2FGe4");
const $2607276d46ae9534$var$hoursPerDay = 8;
// eslint-disable-next-line jira/react/no-class-components
class $2607276d46ae9534$var$PlannedCapacity extends (0, $eUqFw.Component) {
    getConvertedValue() {
        const { capacity: capacity, planningUnit: planningUnit } = this.props.plannedCapacity;
        return (0, $a4NMN.convertCapacityByPlanningUnit)({
            capacity: capacity || 0,
            planningUnit: planningUnit,
            workingHours: $2607276d46ae9534$var$hoursPerDay
        });
    }
    render() {
        const { intl: intl, plannedCapacity: plannedCapacity } = this.props;
        if (!(0, $7CnHa.isDefined)(plannedCapacity)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, this.getConvertedValue(), ' ', intl.formatMessage((0, $2FGe4.default).plannedCapacityUnits, {
            planningUnit: plannedCapacity.planningUnit
        }));
    }
}
var $2607276d46ae9534$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2607276d46ae9534$var$PlannedCapacity);

});
parcelRegister("2FGe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee167fe8405577c0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ee167fe8405577c0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    plannedCapacityUnits: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.value-change.sprint-velocity.planned-capacity-units",
        "defaultMessage": "{planningUnit, select, Hours {hours} StoryPoints {points} Days {days} other {points}}"
    }
});

});



parcelRegister("8Fyr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16a647f8d7f833e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fom3r = parcelRequire("fom3r");

var $kMzRV = parcelRequire("kMzRV");
var $a16a647f8d7f833e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fom3r.default), {})((0, $kMzRV.default));

});
parcelRegister("fom3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $286bafaa127e77bb$export$2e2bcd8739ae039);

var $kFf60 = parcelRequire("kFf60");
const $286bafaa127e77bb$var$querySelector = (state)=>({
        issueStatusesById: (0, $kFf60.getIssueStatusById)(state)
    });
var $286bafaa127e77bb$export$2e2bcd8739ae039 = $286bafaa127e77bb$var$querySelector;

});

parcelRegister("kMzRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd677252016937e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d16Lt = parcelRequire("d16Lt");
class $dd677252016937e2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { statusId: statusId, issueStatusesById: issueStatusesById } = this.props;
        const status = statusId && issueStatusesById && issueStatusesById[statusId];
        if (!status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
        const { id: id, name: name, categoryId: categoryId } = status;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": `status-changed-${id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
            value: {
                id: id,
                name: name,
                statusCategory: {
                    id: categoryId
                }
            }
        }));
    }
}

});


parcelRegister("8rIYV", function(module, exports) {

$parcel$export(module.exports, "multiple-label", () => $6263bccabf22460e$export$463ec856c7c8a0fb, (v) => $6263bccabf22460e$export$463ec856c7c8a0fb = v);
var $6263bccabf22460e$export$463ec856c7c8a0fb;
$6263bccabf22460e$export$463ec856c7c8a0fb = `Kph_na_multiple-label`;

});

parcelRegister("eGrDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cfca97b9f7b9446$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6NnEy = parcelRequire("6NnEy");

var $iioh4 = parcelRequire("iioh4");
var $3cfca97b9f7b9446$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6NnEy.default), {})((0, $iioh4.default));

});
parcelRegister("6NnEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6adc143bf901cfc4$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
var $6adc143bf901cfc4$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    teams: (0, $MQRDu.getTeams),
    useTwpTeams: (state)=>!!(0, $75KhQ.getPlan)(state).useTwpTeams
});

});

parcelRegister("iioh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b43b24c0717955c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $4nce6 = parcelRequire("4nce6");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $9e7LZ = parcelRequire("9e7LZ");

var $7Iub8 = parcelRequire("7Iub8");

var $7ifkp = parcelRequire("7ifkp");
function $5b43b24c0717955c$export$2e2bcd8739ae039(props) {
    const { team: team, teams: teams, useTwpTeams: useTwpTeams = false } = props;
    if (!team) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "-");
    const targetTeam = teams.find((currentTeam)=>currentTeam.id === team);
    if (targetTeam) {
        const { avatarUrl: avatarUrl, title: title } = targetTeam;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7ifkp["title-group"]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7ifkp.avatar
        }, (0, $430Oj.default)() && useTwpTeams && !avatarUrl ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7ifkp.defaultTeamAvatar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            label: "",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            size: "xsmall",
            src: avatarUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
            content: title,
            id: team
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $7ifkp.title
        }, title))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9e7LZ.default), null));
}

});
parcelRegister("7ifkp", function(module, exports) {

$parcel$export(module.exports, "avatar", () => $54f61ab167a3be97$export$345c5736c8054f22, (v) => $54f61ab167a3be97$export$345c5736c8054f22 = v);
$parcel$export(module.exports, "defaultTeamAvatar", () => $54f61ab167a3be97$export$aa80651379a69724, (v) => $54f61ab167a3be97$export$aa80651379a69724 = v);
$parcel$export(module.exports, "title", () => $54f61ab167a3be97$export$fb184b623420d9be, (v) => $54f61ab167a3be97$export$fb184b623420d9be = v);
$parcel$export(module.exports, "title-group", () => $54f61ab167a3be97$export$6bdb7531c44b5e4e, (v) => $54f61ab167a3be97$export$6bdb7531c44b5e4e = v);
var $54f61ab167a3be97$export$345c5736c8054f22;
var $54f61ab167a3be97$export$aa80651379a69724;
var $54f61ab167a3be97$export$fb184b623420d9be;
var $54f61ab167a3be97$export$6bdb7531c44b5e4e;
$54f61ab167a3be97$export$345c5736c8054f22 = `ihzk7q_avatar`;
$54f61ab167a3be97$export$aa80651379a69724 = `ihzk7q_defaultTeamAvatar`;
$54f61ab167a3be97$export$fb184b623420d9be = `ihzk7q_title`;
$54f61ab167a3be97$export$6bdb7531c44b5e4e = `ihzk7q_title-group`;

});



parcelRegister("cJYh4", function(module, exports) {

$parcel$export(module.exports, "VALUE_TYPE", () => $1aed5923d5d11523$export$1345b4a1d6c7126b);
const $1aed5923d5d11523$export$1345b4a1d6c7126b = {
    CURRENT: 'current',
    NEW: 'new'
};

});



parcelRegister("3VL1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $142257debb8c90a0$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cdOgP = parcelRequire("cdOgP");

var $6Urm9 = parcelRequire("6Urm9");

var $6eX4o = parcelRequire("6eX4o");
var $142257debb8c90a0$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6Urm9.default), (0, $cdOgP.default))((0, $6eX4o.default));

});
parcelRegister("cdOgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d78d14443f7a2c8d$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d78d14443f7a2c8d$export$2e2bcd8739ae039 = (dispatch)=>({
        expandChange: (id, category)=>{
            dispatch((0, $7SlBO.expandChange)(id, category));
        },
        collapseChange: (id, category)=>{
            dispatch((0, $7SlBO.collapseChange)(id, category));
        }
    });

});

parcelRegister("6Urm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e5bcec48fcebce$export$2e2bcd8739ae039);

var $kKj1m = parcelRequire("kKj1m");

var $75KhQ = parcelRequire("75KhQ");

var $MQRDu = parcelRequire("MQRDu");

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
const $60e5bcec48fcebce$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    plan: (0, $75KhQ.getPlan),
    expandedChanges: (0, $eDYLe.getExpandedChanges),
    customFields: (0, $kKj1m.getSupportedCustomFields),
    teamsById: (0, $MQRDu.getTeamsById)
});
var $60e5bcec48fcebce$export$2e2bcd8739ae039 = $60e5bcec48fcebce$var$querySelector;

});

parcelRegister("6eX4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da2483a6f8088d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kjklK = parcelRequire("kjklK");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $ffiyv = parcelRequire("ffiyv");
var $gwbfD = parcelRequire("gwbfD");

var $4rACk = parcelRequire("4rACk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $ib5d3 = parcelRequire("ib5d3");

var $5ieZD = parcelRequire("5ieZD");

var $27Az2 = parcelRequire("27Az2");
const $4da2483a6f8088d9$var$SpanWithTitle = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value));
const $4da2483a6f8088d9$var$SpanWithTitleAndParenthetical = ({ value: value, parenthetical: parenthetical })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: `${value} (${parenthetical})`,
        position: "mouse",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $27Az2["attribute-with-parenthetical"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, value, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $27Az2.parenthetical
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "("), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $27Az2.ellipsed
    }, parenthetical), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, ")"))));
// eslint-disable-next-line jira/react/no-class-components
class $4da2483a6f8088d9$var$WhatChangedCell extends (0, $eUqFw.Component) {
    renderChevron() {
        const isExpanded = this.isExpanded();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: `${$27Az2.icon} ${$27Az2.toggle}`
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "",
            size: "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "",
            size: "medium"
        })));
    }
    onKeyDownHandler(e) {
        if (e.key === 'Enter') {
            const { expandChange: expandChange, collapseChange: collapseChange, id: id, category: category } = this.props;
            this.isExpanded() ? collapseChange(id, category) : expandChange(id, category);
        }
    }
    render() {
        const { attributeName: attributeName, intl: intl, changeType: changeType, changeCount: changeCount, expandChange: expandChange, collapseChange: collapseChange, id: id, category: category, changeDetails: changeDetails, teamsById: teamsById } = this.props;
        const messages = {
            ...(0, $5ieZD.default),
            assignee: (0, $ib5d3.default).assignee,
            crossProjectVersion: (0, $ib5d3.default).crossProjectRelease,
            dueDate: (0, $ib5d3.default).dueDate,
            name: (0, $ib5d3.default).name,
            status: (0, $ib5d3.default).status
        };
        const isExpanded = this.isExpanded();
        switch(changeType){
            case (0, $5rYNM.SCENARIO_TYPE).ADDED:
            case (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING:
                {
                    const label = changeType === (0, $5rYNM.SCENARIO_TYPE).ADDED ? messages.createdLabel : messages.addedLabel;
                    if (changeCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                        "aria-expanded": isExpanded,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${$27Az2.multiple} ${$27Az2.toggle}`,
                        onClick: ()=>isExpanded ? collapseChange(id, category) : expandChange(id, category),
                        onKeyDown: this.onKeyDownHandler
                    }, this.renderChevron(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $27Az2.label
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        appearance: "new"
                    }, intl.formatMessage(label)), ' +', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                        ...messages.changeCount,
                        values: {
                            count: changeCount
                        }
                    })));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        appearance: "new"
                    }, intl.formatMessage(label));
                }
            case (0, $5rYNM.SCENARIO_TYPE).MULTIPLE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                    "aria-expanded": isExpanded,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$27Az2.multiple} ${$27Az2.toggle}`,
                    onClick: ()=>isExpanded ? collapseChange(id, category) : expandChange(id, category),
                    onKeyDown: this.onKeyDownHandler
                }, this.renderChevron(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $27Az2.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...messages.changeCount,
                    values: {
                        count: changeCount
                    }
                })));
            case (0, $5rYNM.SCENARIO_TYPE).DELETED:
                if (category === (0, $5rYNM.ENTITY).RELEASE || category === (0, $5rYNM.ENTITY).ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    appearance: "removed"
                }, intl.formatMessage(messages.excludedLabel));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    appearance: "removed"
                }, intl.formatMessage(messages.deletedLabel));
            case 'EXCLUDED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    appearance: "removed"
                }, intl.formatMessage(messages.excludedLabel));
            default:
                {
                    if (attributeName === 'timeEstimate') {
                        const { plan: { planningUnit: planningUnit } } = this.props;
                        if (planningUnit === (0, $5rYNM.PLANNING_UNITS).DAYS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: intl.formatMessage(messages.timeEstimateDays)
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: intl.formatMessage(messages.timeEstimateHours)
                        });
                    }
                    if (category === (0, $5rYNM.ENTITY).RESOURCE && attributeName !== 'addedMember' && attributeName !== 'removedMember') {
                        const resourceChange = changeDetails && changeDetails.details && (0, $4rACk.isTeamAndResourceDetails)(changeDetails) && changeDetails.details.changes.find((change)=>change.resourceId === id);
                        const additionalInfo = resourceChange && resourceChange.personTitle ? `(${resourceChange.personTitle})` : '';
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const change = messages[attributeName || ''] ? // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
                        `${intl.formatMessage(messages[attributeName])} ${additionalInfo}` : '';
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: change
                        });
                    }
                    if (category === (0, $5rYNM.ENTITY).SPRINT && (0, $7CnHa.isDefined)(attributeName) && attributeName.startsWith('teamVelocity-')) {
                        const schedulingMode = $kjklK.default([
                            'details',
                            'values',
                            'schedulingMode'
                        ], changeDetails);
                        const teamId = $kjklK.default([
                            'details',
                            'values',
                            attributeName || '',
                            'teamId'
                        ], changeDetails) || '';
                        const team = teamsById[teamId] || {};
                        const attrTitle = intl.formatMessage(schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban ? messages.iterationVelocity : messages.plannedCapacity);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitleAndParenthetical, {
                            value: attrTitle,
                            parenthetical: team.title
                        });
                    }
                    if (attributeName && attributeName.startsWith('issueLink-')) {
                        const scenarioType = $kjklK.default([
                            'details',
                            'values',
                            attributeName || '',
                            'scenarioType'
                        ], changeDetails) || $kjklK.default([
                            'details',
                            'originals',
                            attributeName || '',
                            'scenarioType'
                        ], changeDetails);
                        let message;
                        switch(scenarioType){
                            case (0, $5rYNM.SCENARIO_TYPE).ADDED:
                                message = intl.formatMessage(messages.issueLinkCreated);
                                break;
                            case (0, $5rYNM.SCENARIO_TYPE).DELETED:
                                message = intl.formatMessage(messages.issueLinkRemoved);
                                break;
                            default:
                                throw new Error(`Unexpected issue link scenarioType: ${scenarioType || ''}`);
                        }
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                            title: message
                        }, message);
                    }
                    if (attributeName && attributeName.startsWith('customField')) {
                        const { customFields: customFields } = this.props;
                        const customFieldId = attributeName.split('-')[1];
                        const field = customFields && // eslint-disable-next-line @typescript-eslint/no-shadow
                        customFields.find((field)=>field.id.toString() === customFieldId);
                        const fieldTitle = field ? field.title : '';
                        if (attributeName.startsWith('customFieldValueAdded')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: intl.formatMessage(messages.customFieldAdded, {
                                field: fieldTitle
                            })
                        });
                        if (attributeName.startsWith('customFieldValueRemoved')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: intl.formatMessage(messages.customFieldRemoved, {
                                field: fieldTitle
                            })
                        });
                        return field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                            value: field.title
                        }) : '';
                    }
                    let change = '';
                    if (attributeName === 'fixVersions') change = intl.formatMessage((0, $ib5d3.default).releases);
                    else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    change = messages[attributeName || ''] ? // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
                    intl.formatMessage(messages[attributeName]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4da2483a6f8088d9$var$SpanWithTitle, {
                        value: change
                    });
                }
        }
    }
    constructor(...args){
        super(...args);
        this.isExpanded = ()=>{
            const { expandedChanges: expandedChanges, id: id, category: category } = this.props;
            return expandedChanges[category].includes(id);
        };
    }
}
var $4da2483a6f8088d9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($4da2483a6f8088d9$var$WhatChangedCell);

});
parcelRegister("4rACk", function(module, exports) {

$parcel$export(module.exports, "isTeamAndResourceDetails", () => $7e4545e60375bff8$export$ac245c21e3e1be07);
function $7e4545e60375bff8$export$ac245c21e3e1be07(change) {
    return true;
}

});

parcelRegister("27Az2", function(module, exports) {

$parcel$export(module.exports, "attribute-with-parenthetical", () => $18b899175d0efdc8$export$c67771312808b708, (v) => $18b899175d0efdc8$export$c67771312808b708 = v);
$parcel$export(module.exports, "ellipsed", () => $18b899175d0efdc8$export$6ce21b76224237ee, (v) => $18b899175d0efdc8$export$6ce21b76224237ee = v);
$parcel$export(module.exports, "icon", () => $18b899175d0efdc8$export$1ca1ec8b29a4ce27, (v) => $18b899175d0efdc8$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "label", () => $18b899175d0efdc8$export$1237798dc640739a, (v) => $18b899175d0efdc8$export$1237798dc640739a = v);
$parcel$export(module.exports, "multiple", () => $18b899175d0efdc8$export$939ddaa3205df08e, (v) => $18b899175d0efdc8$export$939ddaa3205df08e = v);
$parcel$export(module.exports, "parenthetical", () => $18b899175d0efdc8$export$1d02494d67adba65, (v) => $18b899175d0efdc8$export$1d02494d67adba65 = v);
$parcel$export(module.exports, "toggle", () => $18b899175d0efdc8$export$e03c1c3201ee8bb7, (v) => $18b899175d0efdc8$export$e03c1c3201ee8bb7 = v);
var $18b899175d0efdc8$export$c67771312808b708;
var $18b899175d0efdc8$export$6ce21b76224237ee;
var $18b899175d0efdc8$export$1ca1ec8b29a4ce27;
var $18b899175d0efdc8$export$1237798dc640739a;
var $18b899175d0efdc8$export$939ddaa3205df08e;
var $18b899175d0efdc8$export$1d02494d67adba65;
var $18b899175d0efdc8$export$e03c1c3201ee8bb7;
$18b899175d0efdc8$export$c67771312808b708 = `WoPb7q_attribute-with-parenthetical`;
$18b899175d0efdc8$export$6ce21b76224237ee = `WoPb7q_ellipsed`;
$18b899175d0efdc8$export$1ca1ec8b29a4ce27 = `WoPb7q_icon`;
$18b899175d0efdc8$export$1237798dc640739a = `WoPb7q_label`;
$18b899175d0efdc8$export$939ddaa3205df08e = `WoPb7q_multiple`;
$18b899175d0efdc8$export$1d02494d67adba65 = `WoPb7q_parenthetical`;
$18b899175d0efdc8$export$e03c1c3201ee8bb7 = `WoPb7q_toggle`;

});




parcelRegister("6fjvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0f87d2316dc378$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withScrollTracking", () => $9a0f87d2316dc378$export$391633ede08dabb1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $H9kkp = parcelRequire("H9kkp");

var $cuuJa = parcelRequire("cuuJa");

var $ib5d3 = parcelRequire("ib5d3");

var $3bHoQ = parcelRequire("3bHoQ");
var $9j3PG = parcelRequire("9j3PG");
var $lghGU = parcelRequire("lghGU");

var $2bQI4 = parcelRequire("2bQI4");

var $hReHg = parcelRequire("hReHg");

var $i4Ev2 = parcelRequire("i4Ev2");
const $9a0f87d2316dc378$var$stickyOffset = {
    vertical: 0,
    horizontal: 0
};
function $9a0f87d2316dc378$export$2e2bcd8739ae039({ changes: changes, isUpdating: isUpdating, commitWarningsExists: commitWarningsExists, isReadOnly: isReadOnly }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [gridRows, setGridRows] = (0, $eUqFw.useState)([]);
    const [rowConfig, setRowConfig] = (0, $eUqFw.useState)([]);
    const [columnConfig, setColumnConfig] = (0, $eUqFw.useState)([]);
    const colConfigs = (0, $eUqFw.useCallback)(()=>{
        const configs = [
            {
                id: 'details',
                sticky: false,
                name: formatMessage((0, $i4Ev2.default).titleColumnHeader),
                width: 120
            },
            {
                id: 'category',
                sticky: false,
                name: formatMessage((0, $i4Ev2.default).categoryColumnHeader),
                width: 40
            },
            {
                id: 'type',
                sticky: false,
                name: formatMessage((0, $i4Ev2.default).whatChangedColumnHeader),
                width: 45
            },
            {
                id: 'current',
                sticky: false,
                name: '',
                width: 32
            },
            {
                id: 'new',
                sticky: false,
                name: formatMessage((0, $ib5d3.default).new),
                width: 32
            },
            {
                id: 'lastModified',
                sticky: false,
                name: formatMessage((0, $i4Ev2.default).lastModifiedColumnHeader),
                width: 28
            }
        ];
        if (!isReadOnly) configs.unshift({
            id: 'isSelected',
            sticky: false,
            name: '',
            width: 7
        });
        if (commitWarningsExists) configs.unshift({
            id: 'warnings',
            sticky: false,
            name: '',
            width: 7
        });
        return configs;
    }, [
        isReadOnly,
        commitWarningsExists,
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const rowsList = [
            {
                tag: 'HEADER',
                content: 'header'
            }
        ];
        const rowConfigs = [
            {
                sticky: true,
                height: 25,
                thead: true,
                top: 0
            }
        ];
        changes.forEach((x, i)=>{
            rowsList.push({
                tag: 'BODY',
                content: `content${i + 1}`
            });
            rowConfigs.push({
                sticky: false,
                height: 30,
                thead: false,
                top: 25 + i * 30
            });
        });
        setGridRows(rowsList);
        setRowConfig(rowConfigs);
        setColumnConfig(colConfigs());
    }, [
        changes,
        colConfigs
    ]);
    const renderRow = (_row, _columns, index)=>{
        const row = gridRows[index];
        if (row.tag === 'HEADER') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hReHg.default), {
            index: index,
            columns: _columns,
            columnConfig: columnConfig,
            changes: changes,
            commitWarningsExists: commitWarningsExists,
            isReadOnly: isReadOnly,
            isUpdating: isUpdating
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bQI4.default), {
            rowIndex: index,
            columnConfig: columnConfig,
            change: changes[index - 1],
            isUpdating: isUpdating
        });
    };
    const columnWidths = (0, $eUqFw.useMemo)(()=>{
        const widths = [];
        columnConfig.forEach((col)=>{
            widths.push(col.width);
        });
        return widths;
    }, [
        columnConfig
    ]);
    const emptyRow = (height)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
            index: -1,
            height: height
        });
    const uniq = (a)=>Array.from(new Set(a));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const makeRangeExtractor = (_rowConfig)=>({ above: above, within: within, below: below })=>{
            for(let cursor = (within[0] ?? 0) - 1; cursor >= 0; cursor--)if (_rowConfig[cursor].sticky) {
                const additional = above.includes(cursor) ? [] : [
                    cursor
                ];
                return uniq([
                    0,
                    ...additional,
                    ...above,
                    ...within,
                    ...below
                ]);
            }
            return uniq([
                0,
                ...above,
                ...within,
                ...below
            ]);
        };
    const rangeExtractor = (0, $eUqFw.useMemo)(()=>makeRangeExtractor(rowConfig), [
        makeRangeExtractor,
        rowConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3bHoQ.Container), {
        xcss: [
            $9a0f87d2316dc378$var$gridContainerStyles
        ],
        "data-scroll": "lockable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9j3PG.Grid), {
        columnWidths: columnWidths,
        columnConfigs: columnConfig,
        rowConfigs: rowConfig,
        row: renderRow,
        empty: emptyRow,
        overscan: 10,
        onColumnWidthsChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        stickyOffset: $9a0f87d2316dc378$var$stickyOffset,
        ariaLabel: formatMessage((0, $i4Ev2.default).tableAriaLabel),
        role: "grid",
        rangeExtractor: rangeExtractor,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table",
        dataName: "update-jira-dialog-content"
    }, (table)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, table)));
}
const $9a0f87d2316dc378$export$391633ede08dabb1 = (WrappedComponent)=>// eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $H9kkp.default), {
            // @ts-expect-error Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'InteractionMetricType'.
            analyticsEvent: (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_SCROLLED
        }, (handleScroll)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                handleScroll: handleScroll
            }));
const $9a0f87d2316dc378$var$gridContainerStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto',
    marginTop: "var(--ds-space-200, 16px)",
    marginBottom: "var(--ds-space-200, 16px)",
    marginLeft: "var(--ds-space-0, 0px)",
    marginRight: "var(--ds-space-0, 0px)"
});

});
parcelRegister("2bQI4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a33b12abd9155ba$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hc5Gp = parcelRequire("hc5Gp");

var $90ka0 = parcelRequire("90ka0");
var $7a33b12abd9155ba$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hc5Gp.default), {})((0, $90ka0.default));

});
parcelRegister("hc5Gp", function(module, exports) {

$parcel$export(module.exports, "default", () => $723344a2733f63cc$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $723344a2733f63cc$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    useTwpTeams: (state)=>!!(0, $75KhQ.getPlan)(state).useTwpTeams
});

});

parcelRegister("90ka0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c18087d9698c92cc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $8blac = parcelRequire("8blac");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5rYNM = parcelRequire("5rYNM");

var $ib5d3 = parcelRequire("ib5d3");

var $8tcM1 = parcelRequire("8tcM1");

var $bi4E4 = parcelRequire("bi4E4");
var $lghGU = parcelRequire("lghGU");

var $jgxY2 = parcelRequire("jgxY2");

var $9fc7m = parcelRequire("9fc7m");

var $i4Ev2 = parcelRequire("i4Ev2");

var $dyxrg = parcelRequire("dyxrg");

var $kKHqc = parcelRequire("kKHqc");

var $k0duZ = parcelRequire("k0duZ");

var $hPUoO = parcelRequire("hPUoO");

var $7MVun = parcelRequire("7MVun");

var $azMYX = parcelRequire("azMYX");

var $csJwr = parcelRequire("csJwr");

var $cJYh4 = parcelRequire("cJYh4");

var $3VL1h = parcelRequire("3VL1h");
function $c18087d9698c92cc$export$2e2bcd8739ae039({ change: change, useTwpTeams: useTwpTeams, rowIndex: rowIndex, isUpdating: isUpdating, columnConfig: columnConfig, SelectChangeCell: SelectChangeCell = (0, $dyxrg.default), IssueTitleCell: IssueTitleCell = (0, $k0duZ.default), ValueChangeComponent: ValueChangeComponent = (0, $csJwr.default), WhatChangedComponent: WhatChangedComponent = (0, $3VL1h.default) }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!change) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    const commitWarningCellRenderer = ()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(change.warnings)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tcM1.default), {
            warnings: change.warnings
        });
    };
    const selectCellRenderer = ()=>{
        const { id: id, category: category, type: type } = change;
        if (type === (0, $5rYNM.SCENARIO_TYPE).NONE) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let items = [
            {
                id: id,
                category: category
            }
        ];
        if ((category === (0, $5rYNM.ENTITY).TEAM || category === (0, $5rYNM.ENTITY).RESOURCE) && change.details.changes.length > 0) {
            items = [];
            const uniqIds = new Set();
            const addItem = (item)=>{
                const uniqId = `${item.category}:${item.id}`;
                if (!uniqIds.has(uniqId)) {
                    uniqIds.add(uniqId);
                    items.push(item);
                }
            };
            const detailChanges = change.details.changes;
            for (const detailChange of detailChanges)if (detailChange.category === (0, $5rYNM.ENTITY).RESOURCE) addItem({
                id: detailChange.resourceId,
                category: detailChange.category
            });
            else addItem({
                id: id,
                category: category
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectChangeCell, {
            id: (0, $jgxY2.getIdForChangeCategory)(id, category),
            items: items,
            isUpdating: isUpdating
        });
    };
    const titleCellRenderer = ()=>{
        if (change?.type && change?.type !== (0, $5rYNM.SCENARIO_TYPE).NONE) switch(change.category){
            case (0, $5rYNM.ENTITY).ISSUE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueTitleCell, {
                    details: change.details
                });
            case (0, $5rYNM.ENTITY).RELEASE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPUoO.default), {
                    details: change.details
                });
            case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKHqc.default), {
                    crossProjectVersion: change.details.values
                });
            case (0, $5rYNM.ENTITY).TEAM:
            case (0, $5rYNM.ENTITY).RESOURCE:
                {
                    const teamDetail = change.details;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azMYX.default), {
                        name: teamDetail.title.name,
                        avatarUrl: teamDetail.title.avatarUrl,
                        useTwpTeams: useTwpTeams,
                        id: change.id,
                        category: change.category
                    });
                }
            case (0, $5rYNM.ENTITY).SPRINT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7MVun.default), {
                    sprint: change.details.values,
                    id: change.id,
                    category: change.category
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
    };
    const categoryCellRenderer = ()=>{
        const { type: type } = change;
        if (type !== (0, $5rYNM.SCENARIO_TYPE).NONE) switch(change.category){
            case (0, $5rYNM.ENTITY).ISSUE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $i4Ev2.default).issueCategory));
            case (0, $5rYNM.ENTITY).TEAM:
            case (0, $5rYNM.ENTITY).RESOURCE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $i4Ev2.default).teamCategory));
            case (0, $5rYNM.ENTITY).RELEASE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $i4Ev2.default).releaseCategory));
            case (0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $ib5d3.default).crossProjectRelease));
            case (0, $5rYNM.ENTITY).SPRINT:
                {
                    const schedulingMode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(change, [
                        'details',
                        'values',
                        'schedulingMode'
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage(schedulingMode === (0, $5rYNM.SCHEDULE_MODE).kanban ? (0, $i4Ev2.default).iterationCategory : (0, $i4Ev2.default).sprintCategory));
                }
            default:
                return null;
        }
        return null;
    };
    const whatChangedCellRenderer = ()=>{
        const scenarioType = change.type;
        const { attributeName: attributeName, changeCount: changeCount, id: id, category: category } = change;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WhatChangedComponent, {
            attributeName: attributeName,
            changeType: scenarioType,
            changeCount: changeCount,
            id: id,
            category: category,
            changeDetails: change
        });
    };
    const valueCellRenderer = (dataKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueChangeComponent, {
            change: change,
            valueType: dataKey
        });
    const lastModifiedCellRenderer = ()=>{
        const { date: date, title: title, personId: personId, avatarUrl: avatarUrl, dateFormat: dateFormat } = change.lastModified || {};
        if (!change.lastModified || !personId || !date) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9fc7m.default), {
            date: date,
            title: title,
            personId: personId,
            avatarUrl: avatarUrl,
            dateFormat: dateFormat || ''
        });
    };
    const bodyCellRenderer = (column)=>{
        switch(column.id){
            case 'warnings':
                return commitWarningCellRenderer();
            case 'isSelected':
                return selectCellRenderer();
            case 'details':
                return titleCellRenderer();
            case 'category':
                return categoryCellRenderer();
            case 'type':
                return whatChangedCellRenderer();
            case (0, $cJYh4.VALUE_TYPE).CURRENT:
                return valueCellRenderer((0, $cJYh4.VALUE_TYPE).CURRENT);
            case (0, $cJYh4.VALUE_TYPE).NEW:
                return valueCellRenderer((0, $cJYh4.VALUE_TYPE).NEW);
            case 'lastModified':
                return lastModifiedCellRenderer();
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
        index: rowIndex
    }, columnConfig.map((column, index)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
            style: {
                zIndex: 1
            },
            xcss: $c18087d9698c92cc$var$cellStyles,
            column: index,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $c18087d9698c92cc$var$cellContainer
        }, bodyCellRenderer(column)))));
}
const $c18087d9698c92cc$var$cellStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    verticalAlign: 'top'
});
const $c18087d9698c92cc$var$cellContainer = (0, $1ZAYh.xcss)({
    position: 'absolute',
    inset: 'space.0',
    alignContent: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    backgroundColor: 'elevation.surface',
    overflow: 'hidden',
    transition: 'background-color 0.1s ease',
    ':focus-within': {
        overflow: 'initial'
    }
});

});


parcelRegister("hReHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e2583d7d23aab52$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $j47tc = parcelRequire("j47tc");

var $hvBUl = parcelRequire("hvBUl");

var $dkHb1 = parcelRequire("dkHb1");
var $9e2583d7d23aab52$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hvBUl.default), (0, $j47tc.default))((0, $dkHb1.default));

});
parcelRegister("j47tc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bc5ad92604b81f$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e1bc5ad92604b81f$export$2e2bcd8739ae039 = (dispatch)=>({
        sortChanges: (sortBy, sortDirection)=>{
            dispatch((0, $7SlBO.sortChanges)(sortBy, sortDirection));
        }
    });

});

parcelRegister("hvBUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $deae999b8ad83ec8$export$2e2bcd8739ae039);

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
var $deae999b8ad83ec8$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    sortBy: (0, $eDYLe.getSortBy),
    sortDirection: (0, $eDYLe.getSortDirection)
});

});

parcelRegister("dkHb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b778fa1c4c5f2517$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $cSu9v = parcelRequire("cSu9v");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bi4E4 = parcelRequire("bi4E4");
var $lghGU = parcelRequire("lghGU");

var $i4Ev2 = parcelRequire("i4Ev2");

var $7Iztn = parcelRequire("7Iztn");

var $bIGyx = parcelRequire("bIGyx");

var $cJYh4 = parcelRequire("cJYh4");
function $b778fa1c4c5f2517$export$2e2bcd8739ae039({ changes: changes, sortBy: sortBy, columnConfig: columnConfig, sortDirection: sortDirection, isUpdating: isUpdating, index: index, columns: columns, sortChanges: sortChanges, SelectChangeHeader: SelectChangeHeader = (0, $7Iztn.default) }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const selectColumnHeaderRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectChangeHeader, {
            changes: changes,
            isUpdating: isUpdating
        });
    const oldValueColumnHeaderRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($bIGyx.oldColumnHeader, $bIGyx.columnHeader)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $i4Ev2.default).oldValueColumnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $bIGyx.oldColumnHeaderArrow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
            label: "",
            size: "small"
        })));
    const sort = ()=>{
        sortChanges(sortBy, sortDirection === 'ASC' ? 'DESC' : 'ASC');
    };
    const lastModifiedColumnHeaderRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            "aria-label": formatMessage((0, $i4Ev2.default).lastModifiedColumnAriaLabel),
            className: $bIGyx.modifiedGridColumnHeader,
            onClick: sort
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-sortdir": sortDirection
        }, formatMessage((0, $i4Ev2.default).lastModifiedColumnHeader)));
    const columnHeaderRenderer = (title)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($bIGyx.commonColumnHeader, $bIGyx.columnHeader)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, title));
    const headerCellRenderer = (column)=>{
        switch(column.id){
            case 'isSelected':
                return selectColumnHeaderRenderer();
            case (0, $cJYh4.VALUE_TYPE).CURRENT:
                return oldValueColumnHeaderRenderer();
            case 'lastModified':
                return lastModifiedColumnHeaderRenderer();
            default:
                {
                    const col = columnConfig.find((x)=>x.id === column.id);
                    return columnHeaderRenderer(col?.name || '');
                }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghGU.Row), {
        index: index
    }, columns.map((column, i)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bi4E4.Cell), {
            style: {
                zIndex: 2
            },
            xcss: $b778fa1c4c5f2517$var$cellStyles,
            key: i,
            column: i,
            top: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b778fa1c4c5f2517$var$cellContainer
        }, headerCellRenderer(column)))));
}
const $b778fa1c4c5f2517$var$cellStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    verticalAlign: 'top'
});
const $b778fa1c4c5f2517$var$cellContainer = (0, $1ZAYh.xcss)({
    position: 'absolute',
    inset: 'space.0',
    alignContent: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    borderBottom: `2px solid ${"var(--ds-background-accent-gray-subtler, var(--adg3-color-N50))"}`,
    backgroundColor: 'elevation.surface',
    overflow: 'hidden',
    transition: 'background-color 0.1s ease',
    ':focus-within': {
        overflow: 'initial'
    }
});

});




parcelRegister("65T54", function(module, exports) {

$parcel$export(module.exports, "default", () => $463cc0686ae1f9a0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $5YsMl = parcelRequire("5YsMl");

var $8uD7Y = parcelRequire("8uD7Y");

var $eBkd9 = parcelRequire("eBkd9");
var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");
var $kQ0RL = parcelRequire("kQ0RL");

var $8Wu1K = parcelRequire("8Wu1K");
function $463cc0686ae1f9a0$var$CommitWarningNotification(props) {
    const { show: show, failedCommitCount: failedCommitCount, successfulCommitCount: successfulCommitCount, onClose: onClose } = props;
    if (!show) return null;
    let title;
    let description;
    let icon;
    const onlySuccessful = successfulCommitCount && !failedCommitCount;
    if (onlySuccessful) {
        title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8Wu1K.default).successHeaderText);
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8Wu1K.default).successContentText,
            values: {
                successfulCommitCount: successfulCommitCount
            }
        });
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            label: "",
            primaryColor: `var(--ds-icon-success, ${(0, $g4Vkx.default).G300})`
        });
    } else {
        title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8Wu1K.default).warningHeaderText,
            values: {
                successfulCommitCount: successfulCommitCount
            }
        });
        if (!successfulCommitCount) description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8Wu1K.default).warningContentText,
            values: {
                failedCommitCount: failedCommitCount
            }
        });
        else description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8Wu1K.default).warningWithSuccessContentSuccessText,
            values: {
                successfulCommitCount: successfulCommitCount
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $8Wu1K.default).warningWithSuccessContentWarningText,
            values: {
                failedCommitCount: failedCommitCount
            }
        })));
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
        onDismissed: onClose
    }, onlySuccessful ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBkd9.default), {
        id: "portfolio-3-app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification",
        title: title,
        description: description,
        icon: icon,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.auto-dismiss-flag"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        id: "commit-warning-modification-flag",
        title: title,
        description: description,
        icon: icon
    }));
}
var $463cc0686ae1f9a0$export$2e2bcd8739ae039 = $463cc0686ae1f9a0$var$CommitWarningNotification;

});
parcelRegister("8Wu1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $9777bc59caf69c24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9777bc59caf69c24$var$messages = (0, $90IgZ.defineMessages)({
    warningHeaderText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-header-text",
        "defaultMessage": "{successfulCommitCount, plural, =0 {Changes couldn't be saved} other {Some changes couldn't be saved}}"
    },
    warningWithSuccessContentSuccessText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-with-success-content-success-text",
        "defaultMessage": "{successfulCommitCount, plural, one {# change was} other {# changes were}} successfully saved to your plan."
    },
    warningWithSuccessContentWarningText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-with-success-content-warning-text",
        "defaultMessage": "However, {failedCommitCount, plural, one {# change} other {# changes}} could not be committed."
    },
    warningContentText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.warning-content-text",
        "defaultMessage": "{failedCommitCount, plural, =0 {Your plan is out of sync due to concurrent editing.} one {# change couldn't be saved.} other {# changes couldn't be saved.}}"
    },
    successHeaderText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.success-header-text",
        "defaultMessage": "Success"
    },
    successContentText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.commit-warning-notification.success-content-text",
        "defaultMessage": "{successfulCommitCount, plural, one {# change was} other {# changes were}} successfully saved in Jira."
    }
});
var $9777bc59caf69c24$export$2e2bcd8739ae039 = $9777bc59caf69c24$var$messages;

});


parcelRegister("iIRNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b3356d005f9219b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $ib5d3 = parcelRequire("ib5d3");

var $F9ZPY = parcelRequire("F9ZPY");
function $0b3356d005f9219b$export$2e2bcd8739ae039({ isOpen: isOpen, onConfirm: onConfirm, onCancel: onCancel }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $F9ZPY.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $F9ZPY.default).message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.cancel"
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onConfirm,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.confirm"
    }, formatMessage((0, $F9ZPY.default).confirm))));
}

});
parcelRegister("F9ZPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b1bb5ae9ca9b1a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a8b1bb5ae9ca9b1a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    confirm: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.confirm",
        "defaultMessage": "Discard changes"
    },
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.title",
        "defaultMessage": "Confirm discard"
    },
    message: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.discard-confirmation.message",
        "defaultMessage": "Are you sure you want to discard the selected changes?"
    }
});

});


parcelRegister("75P1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9cf95e81f3863ce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $220ac = parcelRequire("220ac");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $klID0 = parcelRequire("klID0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2RVAX = parcelRequire("2RVAX");

var $d6f6c = parcelRequire("d6f6c");

var $6rtjE = parcelRequire("6rtjE");

var $b7rr2 = parcelRequire("b7rr2");
const $c9cf95e81f3863ce$var$EmptyDialog = ({ handleCloseDialog: handleCloseDialog })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            changesCount: 0,
            isPlansUpdateReviewChangesEnabled: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldReturnFocus: true,
        shouldCloseOnEscapePress: true,
        onClose: handleCloseDialog,
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c9cf95e81f3863ce$var$relativeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c9cf95e81f3863ce$var$closeIconAbsoluteStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        label: formatMessage((0, $b7rr2.default).closeIconLabel),
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7))),
        onClick: handleCloseDialog,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.selected-field-remove-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        header: formatMessage((0, $b7rr2.default).noChangesDialogHeader),
        description: formatMessage((0, $b7rr2.default).noChangesDialogDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6rtjE.default), {
            onClick: handleCloseDialog,
            articleId: "5jV03VyuxP6cfYQwcKWxWO"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            color: "color.link"
        }, formatMessage((0, $b7rr2.default).noChangesDialogActionButtonText))),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $c9cf95e81f3863ce$var$emptyImageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $c9cf95e81f3863ce$var$emptyImageStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $klID0.default), {
                alt: ""
            })))
    })));
};
const $c9cf95e81f3863ce$var$relativeStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $c9cf95e81f3863ce$var$closeIconAbsoluteStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: 'space.250',
    right: 'space.250'
});
const $c9cf95e81f3863ce$var$emptyImageContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 'space.400'
});
const $c9cf95e81f3863ce$var$emptyImageStyles = (0, $1ZAYh.xcss)({
    width: '160px'
});
var $c9cf95e81f3863ce$export$2e2bcd8739ae039 = $c9cf95e81f3863ce$var$EmptyDialog;

});
parcelRegister("klID0", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a7c0712a4e59af$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $iBcib = parcelRequire("iBcib");
const $62a7c0712a4e59af$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iBcib)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iBcib)),
    autoDark: false
});
var $62a7c0712a4e59af$export$2e2bcd8739ae039 = $62a7c0712a4e59af$var$Illustration;
// for advanced use only
const $62a7c0712a4e59af$export$a179c88182cb9d56 = [
    0,
    0,
    160,
    160
];

});
parcelRegister("iBcib", function(module, exports) {
module.exports = new URL("celebrate.45e473a6.svg", import.meta.url).toString();

});


parcelRegister("6rtjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $298a716b3c6b8aa4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $3QLcd = parcelRequire("3QLcd");
const $298a716b3c6b8aa4$var$HelpPanelButton = ({ onClick: onClick, articleId: articleId, articleType: articleType = 'HELP_ARTICLE', children: children })=>{
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, articleType);
    }, [
        onClick,
        onOpenInProductHelpArticle,
        articleType,
        articleId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: $298a716b3c6b8aa4$var$pressableStyles,
        onClick: handleClick,
        backgroundColor: "color.background.neutral.subtle"
    }, children);
};
const $298a716b3c6b8aa4$var$pressableStyles = (0, $1ZAYh.xcss)({
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline'
    }
});
var $298a716b3c6b8aa4$export$2e2bcd8739ae039 = $298a716b3c6b8aa4$var$HelpPanelButton;

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;

});


parcelRegister("b7rr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b1e3fec9deae44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $92b1e3fec9deae44$var$messages = (0, $90IgZ.defineMessages)({
    noChangesDialogHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-header",
        "defaultMessage": "Your plan is up to date!"
    },
    noChangesDialogDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-description",
        "defaultMessage": "Any changes you make to the issues in your plan, including creating new ones, will appear here for your approval. These changes aren't applied until you decide your plan is ready to go."
    },
    noChangesDialogActionButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.no-changes-dialog-action-button-text",
        "defaultMessage": "Read how to save changes in your plan."
    },
    closeIconLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.empty-dialog.close-icon-label",
        "defaultMessage": "Close dialog"
    }
});
var $92b1e3fec9deae44$export$2e2bcd8739ae039 = $92b1e3fec9deae44$var$messages;

});


parcelRegister("1x2im", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ec1c6a594f3517$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cFPLx = parcelRequire("cFPLx");

var $bbSob = parcelRequire("bbSob");

var $njKqH = parcelRequire("njKqH");
var $43ec1c6a594f3517$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bbSob.default), (0, $cFPLx.default))((0, $njKqH.default));

});
parcelRegister("cFPLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $78390fe3f1525ea4$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");
var $j3zeB = parcelRequire("j3zeB");
const $78390fe3f1525ea4$var$mapDispatchToProps = (dispatch)=>({
        onRequestChange: ({ value: value, visibleIssueIds: visibleIssueIds })=>dispatch((0, $7SlBO.changeFilter)({
                id: (0, $j3zeB.USER_FILTER_ID),
                value: value,
                visibleIssueIds: visibleIssueIds
            })),
        onRequestClear: ()=>dispatch((0, $7SlBO.clearFilter)((0, $j3zeB.USER_FILTER_ID)))
    });
var $78390fe3f1525ea4$export$2e2bcd8739ae039 = $78390fe3f1525ea4$var$mapDispatchToProps;

});

parcelRegister("bbSob", function(module, exports) {

$parcel$export(module.exports, "default", () => $164943972f504d07$export$2e2bcd8739ae039);

var $6VhAf = parcelRequire("6VhAf");

var $a6d5W = parcelRequire("a6d5W");

var $eDYLe = parcelRequire("eDYLe");

var $1bVXL = parcelRequire("1bVXL");

var $iK4oF = parcelRequire("iK4oF");
const $164943972f504d07$export$f320820d53e740a0 = (reviewChanges, assigneesById)=>{
    const result = [];
    for (const { lastModified: lastModified } of reviewChanges)if (!result.some((el)=>el && lastModified && el.personId === lastModified.personId)) {
        const { personId: personId } = lastModified || {};
        if (personId && assigneesById[personId]) result.push(assigneesById[personId]);
    }
    return result;
};
const $164943972f504d07$export$27701b0bf8892f62 = (0, $iK4oF.createSelector)([
    (0, $eDYLe.getReviewChanges),
    (0, $6VhAf.getAssigneesById)
], $164943972f504d07$export$f320820d53e740a0);
const $164943972f504d07$var$mapStateToProps = (0, $iK4oF.createSelector)([
    $164943972f504d07$export$27701b0bf8892f62,
    (0, $1bVXL.getUserFilter),
    (0, $eDYLe.getReviewChanges),
    (0, $a6d5W.getCurrentUser)
], (users, { value: value }, reviewChanges, currentUser)=>({
        users: users,
        value: value,
        reviewChanges: reviewChanges,
        currentUser: currentUser
    }));
var $164943972f504d07$export$2e2bcd8739ae039 = $164943972f504d07$var$mapStateToProps;

});
parcelRegister("a6d5W", function(module, exports) {

$parcel$export(module.exports, "getPlanEditorPermissions", () => $a3ee2f03babdff5c$export$d8c3b0a7b4abef66);
$parcel$export(module.exports, "getPlanViewerPermissions", () => $a3ee2f03babdff5c$export$c543d2c04370d703);
$parcel$export(module.exports, "getCurrentUser", () => $a3ee2f03babdff5c$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "isFetchPlanPermissionsInProgress", () => $a3ee2f03babdff5c$export$22dfe31f63ec61de);
$parcel$export(module.exports, "getTeamPermissions", () => $a3ee2f03babdff5c$export$488aee7772181f51);
const $a3ee2f03babdff5c$export$1ab970995a1d0ad = (state)=>state.domain.permissions.planPermissions;
const $a3ee2f03babdff5c$export$d8c3b0a7b4abef66 = (state)=>state.domain.permissions.planPermissions.filter((permission)=>permission.permissions.includes('EDIT'));
const $a3ee2f03babdff5c$export$c543d2c04370d703 = (state)=>state.domain.permissions.planPermissions.filter((permission)=>permission.permissions.includes('VIEW'));
const $a3ee2f03babdff5c$export$e5432d4c8eb97ea7 = (state)=>({
        displayName: state.domain.system.systemInfo.userName,
        key: state.domain.system.systemInfo.accountId,
        email: state.domain.system.systemInfo.userEmailAddress,
        avatarUrl: state.domain.system.systemInfo.avatarUrl
    });
const $a3ee2f03babdff5c$export$22dfe31f63ec61de = (state)=>state.domain.permissions.isFetchPlanPermissionsInProgress;
const $a3ee2f03babdff5c$export$488aee7772181f51 = (state)=>state.domain.permissions.teamPermissions;

});


parcelRegister("njKqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b55f882a4ed539b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $b3iuB = parcelRequire("b3iuB");
var $63hMP = parcelRequire("63hMP");
var $3IGDG = parcelRequire("3IGDG");

var $6Pq2D = parcelRequire("6Pq2D");

var $2qhQi = parcelRequire("2qhQi");

var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $cuuJa = parcelRequire("cuuJa");

var $ewMwZ = parcelRequire("ewMwZ");
parcelRequire("h2lUi");
var $ekxsu = parcelRequire("ekxsu");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $3nLf8 = parcelRequire("3nLf8");

var $6L2LZ = parcelRequire("6L2LZ");

var $eG0CY = parcelRequire("eG0CY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $k9m7i = parcelRequire("k9m7i");

var $9qInP = parcelRequire("9qInP");
function $9b55f882a4ed539b$var$UserFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, users: users, reviewChanges: reviewChanges, currentUser: currentUser }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSelected = (user)=>$1l9vO.default(user.personId, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCheckboxChange = (e)=>{
        const { value: personId, checked: checked } = e.currentTarget;
        const nextValue = (()=>{
            const withoutUser = $fpul1.default($3IGDG.default($5OdRK.default(personId), $63hMP.default))(value);
            if (!checked) return withoutUser;
            return [
                ...withoutUser,
                personId
            ];
        })();
        const visibleIssueIds = reviewChanges.filter((change)=>{
            if (change.lastModified?.personId !== undefined) return nextValue.includes(change.lastModified?.personId);
            return false;
        }).map((change)=>change.id);
        onRequestChange({
            value: nextValue,
            visibleIssueIds: visibleIssueIds
        });
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_USER_FILTER_CHANGED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), {
            isCurrentUser: currentUser.key === personId,
            checked: checked
        });
    };
    const usersToDisplay = (0, $ewMwZ.sort)((0, $ewMwZ.filter)(searchQuery, users));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
        isVisible: !!value.length,
        onClearClick: onRequestClear
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
        placeholder: intl.formatMessage((0, $k9m7i.default).searchPlaceholder),
        searchQuery: searchQuery,
        onQueryChange: onQueryChange
    }), usersToDisplay.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ekxsu.AssigneeCheckbox), {
            checked: isSelected(user),
            onChange: handleCheckboxChange,
            person: user
        }))), $b3iuB.default(usersToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
}
function $9b55f882a4ed539b$var$UserFilterDialog(props) {
    const { isOpen: isOpen, onOpenChange: onOpenChange } = props;
    const dialogRef = (0, $eUqFw.useRef)(null);
    (0, $6L2LZ.useHandleDialogClose)(dialogRef, onOpenChange, isOpen);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: dialogRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        isOpen: isOpen,
        onClose: onOpenChange,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55f882a4ed539b$var$UserFilter, props)),
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9qInP.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        triggerButtonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ekxsu.TriggerButtonText), {
            value: props.value,
            persons: props.users
        })
    })));
}
var $9b55f882a4ed539b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($9b55f882a4ed539b$var$UserFilterDialog);

});
parcelRegister("h2lUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e67a7e3ae835eb05$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AssigneeCheckbox", () => (parcelRequire("ekxsu")).AssigneeCheckbox);
$parcel$export(module.exports, "TriggerButtonText", () => (parcelRequire("ekxsu")).TriggerButtonText);

var $lNNXV = parcelRequire("lNNXV");

var $eA5jV = parcelRequire("eA5jV");

var $ez7AN = parcelRequire("ez7AN");

var $ekxsu = parcelRequire("ekxsu");
var $e67a7e3ae835eb05$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ez7AN.default), (0, $eA5jV.default))((0, $ekxsu.default));

});
parcelRegister("eA5jV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff85387618349623$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $ff85387618349623$var$mapDispatchToProps = (dispatch)=>({
        onRequestChange: (payload)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$43596ee088b165a),
                value: payload
            })),
        onRequestClear: ()=>dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$43596ee088b165a)))
    });
var $ff85387618349623$export$2e2bcd8739ae039 = $ff85387618349623$var$mapDispatchToProps;

});

parcelRegister("ez7AN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc2cd1cf55823341$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");

var $aYCQt = parcelRequire("aYCQt");


var $iK4oF = parcelRequire("iK4oF");
const $cc2cd1cf55823341$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $aYCQt.getAssigneeForFilter),
    (0, $fbHoQ.getFilters)
], (assignees, { [(0, $12ee831723ccf9c2$export$43596ee088b165a)]: { id: id, value: value } })=>({
        id: id,
        value: value,
        assignees: assignees
    }));
var $cc2cd1cf55823341$export$2e2bcd8739ae039 = $cc2cd1cf55823341$var$mapStateToProps;

});

parcelRegister("ekxsu", function(module, exports) {

$parcel$export(module.exports, "AssigneeCheckbox", () => $d1b266486c73c85b$export$7235937fc5668072);
$parcel$export(module.exports, "TriggerButtonText", () => $d1b266486c73c85b$export$8bd0edd7ca02ab5f);
$parcel$export(module.exports, "default", () => $d1b266486c73c85b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $b3iuB = parcelRequire("b3iuB");
var $63hMP = parcelRequire("63hMP");
var $3IGDG = parcelRequire("3IGDG");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $ewMwZ = parcelRequire("ewMwZ");
parcelRequire("aYCQt");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $eG0CY = parcelRequire("eG0CY");

var $gkXIa = parcelRequire("gkXIa");

var $6g33d = parcelRequire("6g33d");

var $99D1w = parcelRequire("99D1w");
function $d1b266486c73c85b$export$7235937fc5668072({ person: person, checked: checked, onChange: onChange }) {
    const { title: title, email: email, avatarUrl: avatarUrl } = person.jiraUser;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        value: person.personId,
        isChecked: checked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkXIa.UserSelectItem), {
            email: email,
            label: title,
            icon: avatarUrl
        })
    });
}
function $d1b266486c73c85b$var$AssigneeFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, assignees: assignees }) {
    const isSelected = (assignee)=>$1l9vO.default(assignee.personId, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleAssigneeCheckboxChange = (e)=>{
        const { value: personId, checked: checked } = e.currentTarget;
        const nextValue = (()=>{
            const withoutTheAssignee = $fpul1.default($3IGDG.default($5OdRK.default(personId), $63hMP.default))(value);
            if (!checked) return withoutTheAssignee;
            return withoutTheAssignee.concat([
                personId
            ]);
        })();
        onRequestChange(nextValue);
    };
    const assigneesToDisplay = (0, $ewMwZ.sort)((0, $ewMwZ.filter)(searchQuery, assignees));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
        isVisible: !!value.length,
        onClearClick: onRequestClear
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
        placeholder: intl.formatMessage((0, $99D1w.default).searchAssigneePlaceholder),
        searchQuery: searchQuery,
        onQueryChange: onQueryChange,
        ariaLabel: intl.formatMessage((0, $99D1w.default).searchAssigneeLabel)
    }), assigneesToDisplay.map((assignee, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1b266486c73c85b$export$7235937fc5668072, {
            checked: isSelected(assignee),
            onChange: handleAssigneeCheckboxChange,
            person: assignee
        }))), $b3iuB.default(assigneesToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
}
const $d1b266486c73c85b$var$getNames = (assignees, selected)=>{
    const selectedAssignees = assignees.filter((person)=>selected.has(person.personId));
    const names = selectedAssignees.map((person)=>person.jiraUser.title);
    return names.join(', ');
};
function $d1b266486c73c85b$export$8bd0edd7ca02ab5f({ value: value, persons: persons }) {
    const selected = new Set(value);
    if (selected.size === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $99D1w.default).emptyPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
        text: $d1b266486c73c85b$var$getNames(persons, selected)
    });
}
function $d1b266486c73c85b$var$AssigneeFilterDialog(props) {
    const { isOpen: isOpen, onOpenChange: onOpenChange, value: value, intl: intl, assignees: assignees } = props;
    const ariaText = ()=>{
        const selected = new Set(value);
        // ex: Asignees, All selected
        return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$43596ee088b165a])}, ${selected.size > 0 ? $d1b266486c73c85b$var$getNames(assignees, selected) : intl.formatMessage((0, $99D1w.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        isOpen: isOpen,
        onClose: onOpenChange,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1b266486c73c85b$var$AssigneeFilter, props)),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.trigger-btn",
        triggerButtonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1b266486c73c85b$export$8bd0edd7ca02ab5f, {
            value: props.value,
            persons: props.assignees
        }),
        ariaLabel: ariaText()
    }));
}
var $d1b266486c73c85b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d1b266486c73c85b$var$AssigneeFilterDialog);

});
parcelRegister("04tZU", function(module, exports) {

$parcel$export(module.exports, "FILTER_MAX_WIDTH", () => $d06f92bac43a5630$export$13b4adfaabd254c6);
$parcel$export(module.exports, "FILTER_WIDTH", () => $d06f92bac43a5630$export$f8cf4f7345271a9b);
$parcel$export(module.exports, "TriggerButton", () => (parcelRequire("6uwgw")).default);
$parcel$export(module.exports, "ClearFilterButton", () => (parcelRequire("s8Q9q")).default);
$parcel$export(module.exports, "FilterText", () => (parcelRequire("hfVzN")).default);
$parcel$export(module.exports, "TitleWithAvatar", () => (parcelRequire("b1aFA")).default);
$parcel$export(module.exports, "NoMatchFound", () => (parcelRequire("3nLf8")).default);
$parcel$export(module.exports, "SearchField", () => (parcelRequire("eG0CY")).default);
// To reduce code duplication and to improve styling consistency, export common components that are reusable across different filters.

var $6uwgw = parcelRequire("6uwgw");

var $s8Q9q = parcelRequire("s8Q9q");

var $hfVzN = parcelRequire("hfVzN");

var $b1aFA = parcelRequire("b1aFA");

var $3nLf8 = parcelRequire("3nLf8");

var $gtaRB = parcelRequire("gtaRB");

var $eG0CY = parcelRequire("eG0CY");
const $d06f92bac43a5630$export$13b4adfaabd254c6 = 450;
const $d06f92bac43a5630$export$f8cf4f7345271a9b = 300;

});
parcelRegister("6uwgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fcb9793a1382b9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $aAyrO = parcelRequire("aAyrO");

var $hrsRa = parcelRequire("hrsRa");
function $59fcb9793a1382b9$export$4129321aecd13375(props) {
    const { isOpen: isOpen, testId: testId, triggerButtonText: triggerButtonText, ariaLabel: ariaLabel, onOpenChange: onOpenChange } = props;
    const onOpenChangeHandle = ()=>{
        onOpenChange({
            isOpen: !isOpen
        });
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $hrsRa.filterButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        isSelected: isOpen,
        onClick: onOpenChangeHandle,
        testId: testId,
        ariaLabel: ariaLabel
    }, triggerButtonText)));
}
var $59fcb9793a1382b9$export$2e2bcd8739ae039 = $59fcb9793a1382b9$export$4129321aecd13375;

});
parcelRegister("hrsRa", function(module, exports) {

$parcel$export(module.exports, "filterButtonWrapper", () => $cb2b5795011359af$export$706db85642e6c245, (v) => $cb2b5795011359af$export$706db85642e6c245 = v);
var $cb2b5795011359af$export$706db85642e6c245;
$cb2b5795011359af$export$706db85642e6c245 = `bnOPCW_filterButtonWrapper`;

});


parcelRegister("s8Q9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e972b17569bb456$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");

var $ib5d3 = parcelRequire("ib5d3");
function $6e972b17569bb456$export$2e2bcd8739ae039({ onClearClick: onClearClick, isVisible: isVisible }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        style: {
            display: isVisible ? 'inline-flex' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        onClick: onClearClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).clearFilterText)));
}

});

parcelRegister("hfVzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d86adc917c2a596$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Iub8 = parcelRequire("7Iub8");

var $hTFR0 = parcelRequire("hTFR0");
function $9d86adc917c2a596$export$2e2bcd8739ae039({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $hTFR0.filterText
    }, text));
}

});
parcelRegister("hTFR0", function(module, exports) {

$parcel$export(module.exports, "filterText", () => $d0780a0828ff44c5$export$dac863774b2ab841, (v) => $d0780a0828ff44c5$export$dac863774b2ab841 = v);
var $d0780a0828ff44c5$export$dac863774b2ab841;
$d0780a0828ff44c5$export$dac863774b2ab841 = `_053xKW_filterText`;

});


parcelRegister("b1aFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c889720afac25c47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $7Iub8 = parcelRequire("7Iub8");

var $1OhTG = parcelRequire("1OhTG");
function $c889720afac25c47$export$2e2bcd8739ae039({ avatarUrl: avatarUrl, name: name, projectKey: projectKey, id: id, appearance: appearance = 'circle', size: size = 'small' }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $1OhTG.projectTitleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
        id: id,
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${size === 'small' ? $1OhTG["small-spacing"] : $1OhTG["xsmall-spacing"]} ${$1OhTG.projectTitle}`
    }, name, " ", projectKey && `(${projectKey})`))));
}

});
parcelRegister("1OhTG", function(module, exports) {

$parcel$export(module.exports, "projectTitle", () => $151857f714880250$export$d98ff0eab640b056, (v) => $151857f714880250$export$d98ff0eab640b056 = v);
$parcel$export(module.exports, "projectTitleContainer", () => $151857f714880250$export$2474dce96b358573, (v) => $151857f714880250$export$2474dce96b358573 = v);
$parcel$export(module.exports, "small-spacing", () => $151857f714880250$export$f501eb5ad30f4376, (v) => $151857f714880250$export$f501eb5ad30f4376 = v);
$parcel$export(module.exports, "xsmall-spacing", () => $151857f714880250$export$72ca87e592414a1a, (v) => $151857f714880250$export$72ca87e592414a1a = v);
var $151857f714880250$export$d98ff0eab640b056;
var $151857f714880250$export$2474dce96b358573;
var $151857f714880250$export$f501eb5ad30f4376;
var $151857f714880250$export$72ca87e592414a1a;
$151857f714880250$export$d98ff0eab640b056 = `j-gf7G_projectTitle`;
$151857f714880250$export$2474dce96b358573 = `j-gf7G_projectTitleContainer`;
$151857f714880250$export$f501eb5ad30f4376 = `j-gf7G_small-spacing`;
$151857f714880250$export$72ca87e592414a1a = `j-gf7G_xsmall-spacing`;

});


parcelRegister("3nLf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ecdf5ad9fdd281$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ib5d3 = parcelRequire("ib5d3");

var $17gIb = parcelRequire("17gIb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$02ecdf5ad9fdd281$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $17gIb.noMatchFoundText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).noMatchFoundText));

});
parcelRegister("17gIb", function(module, exports) {

$parcel$export(module.exports, "checkboxLabel", () => $0d0368765b5512b1$export$68673652bda1864d, (v) => $0d0368765b5512b1$export$68673652bda1864d = v);
$parcel$export(module.exports, "defaultTeamAvatar", () => $0d0368765b5512b1$export$aa80651379a69724, (v) => $0d0368765b5512b1$export$aa80651379a69724 = v);
$parcel$export(module.exports, "noMatchFoundText", () => $0d0368765b5512b1$export$432ba9be018e81c2, (v) => $0d0368765b5512b1$export$432ba9be018e81c2 = v);
$parcel$export(module.exports, "teamAvatarItem", () => $0d0368765b5512b1$export$a15af679b64a13e5, (v) => $0d0368765b5512b1$export$a15af679b64a13e5 = v);
var $0d0368765b5512b1$export$68673652bda1864d;
var $0d0368765b5512b1$export$aa80651379a69724;
var $0d0368765b5512b1$export$432ba9be018e81c2;
var $0d0368765b5512b1$export$a15af679b64a13e5;
$0d0368765b5512b1$export$68673652bda1864d = `oVM_OG_checkboxLabel`;
$0d0368765b5512b1$export$aa80651379a69724 = `oVM_OG_defaultTeamAvatar`;
$0d0368765b5512b1$export$432ba9be018e81c2 = `oVM_OG_noMatchFoundText`;
$0d0368765b5512b1$export$a15af679b64a13e5 = `oVM_OG_teamAvatarItem`;

});


parcelRegister("gtaRB", function(module, exports) {

var $5rYNM = parcelRequire("5rYNM");
const { CHECKED: $6425d694e7555ac6$export$be74dcf36d511131, UNCHECKED: $6425d694e7555ac6$export$4bfe604431277125, INDETERMINATE: $6425d694e7555ac6$export$c5a6fe907430212e } = (0, $5rYNM.CHECKBOX_STATES);
const $6425d694e7555ac6$export$de039e868213edc8 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
categoryStatuses, // eslint-disable-next-line @typescript-eslint/no-explicit-any
selectedStatuses)=>{
    if (selectedStatuses.size > 0 && categoryStatuses.every((el)=>selectedStatuses.has(el))) return $6425d694e7555ac6$export$be74dcf36d511131;
    if (categoryStatuses.some((el)=>selectedStatuses.has(el))) return $6425d694e7555ac6$export$c5a6fe907430212e;
    return $6425d694e7555ac6$export$4bfe604431277125;
};

});


parcelRegister("99D1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $09eacc14cd55e9c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $09eacc14cd55e9c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchAssigneePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.search-assignee-placeholder",
        "defaultMessage": "Show issues from assignees"
    },
    searchAssigneeLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.assignee-filter.search-assignee-label",
        "defaultMessage": "Choose from assignees"
    }
});

});



parcelRegister("6L2LZ", function(module, exports) {

$parcel$export(module.exports, "useHandleDialogClose", () => $683a7b66455a6fe3$export$b53868bd1fa52e47);

var $eUqFw = parcelRequire("eUqFw");
const $683a7b66455a6fe3$export$b53868bd1fa52e47 = (dialogRef, onOpenChange, isOpen)=>{
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Close the dialog when clicking outside.
		 *
		 * @param {MouseEvent|TouchEvent} event - The DOM event from a mouse or touch action.
		 */ const handleClickOutside = (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                event.preventDefault();
                onOpenChange({
                    isOpen: false
                });
            }
        };
        /**
		 * Close the dialog when pressing the 'Escape' key.
		 *
		 * @param {KeyboardEvent} event - The DOM event from a keyboard action.
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onOpenChange({
                    isOpen: false
                });
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
            document.addEventListener('keydown', handleKeyDown);
        }
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isOpen,
        onOpenChange,
        dialogRef
    ]);
};

});

parcelRegister("k9m7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $50978b2ea3128ce0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50978b2ea3128ce0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.search-placeholder",
        "defaultMessage": "Choose users..."
    }
});

});

parcelRegister("9qInP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3021660226bb35fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");

var $4p93N = parcelRequire("4p93N");

var $gU53j = parcelRequire("gU53j");
const $3021660226bb35fc$var$TriggerButton = ({ isOpen: isOpen, onOpenChange: onOpenChange, triggerButtonText: triggerButtonText })=>{
    const intl = (0, $5JgJ2.default)();
    const handleOpenChange = ()=>{
        onOpenChange({
            isOpen: !isOpen
        });
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gU53j.filterButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        isSelected: isOpen,
        onClick: handleOpenChange,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gU53j.buttonTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gU53j.buttonLabel
    }, intl.formatMessage((0, $4p93N.default).filterByLabel), ":"), triggerButtonText))));
};
var $3021660226bb35fc$export$2e2bcd8739ae039 = $3021660226bb35fc$var$TriggerButton;

});
parcelRegister("4p93N", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b06d649753a82b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $43b06d649753a82b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterByLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.filters.user-filter.trigger-button.filter-by-label",
        "defaultMessage": "Last modified by"
    }
});

});

parcelRegister("gU53j", function(module, exports) {

$parcel$export(module.exports, "buttonLabel", () => $c4e5cba20a5e067f$export$47614749115bca3d, (v) => $c4e5cba20a5e067f$export$47614749115bca3d = v);
$parcel$export(module.exports, "buttonTextContainer", () => $c4e5cba20a5e067f$export$4ee7107eea12c1bc, (v) => $c4e5cba20a5e067f$export$4ee7107eea12c1bc = v);
$parcel$export(module.exports, "filterButtonWrapper", () => $c4e5cba20a5e067f$export$706db85642e6c245, (v) => $c4e5cba20a5e067f$export$706db85642e6c245 = v);
var $c4e5cba20a5e067f$export$47614749115bca3d;
var $c4e5cba20a5e067f$export$4ee7107eea12c1bc;
var $c4e5cba20a5e067f$export$706db85642e6c245;
$c4e5cba20a5e067f$export$47614749115bca3d = `_5f2lVa_buttonLabel`;
$c4e5cba20a5e067f$export$4ee7107eea12c1bc = `_5f2lVa_buttonTextContainer`;
$c4e5cba20a5e067f$export$706db85642e6c245 = `_5f2lVa_filterButtonWrapper`;

});




parcelRegister("k0Ls4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7264e0ebaef0174e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $7264e0ebaef0174e$var$messages = (0, $90IgZ.defineMessages)({
    updateJiraButtonTextOld: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-text-old",
        "defaultMessage": "Review changes"
    },
    updateJiraButtonGeneralTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-general-tooltip",
        "defaultMessage": "Review changes"
    },
    updateJiraButtonTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-button-tooltip",
        "defaultMessage": "No changes have been made in this plan"
    },
    updateJiraDialogHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-header",
        "defaultMessage": "Unsaved changes"
    },
    updateJiraDialogHeaderOld: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-header-old",
        "defaultMessage": "Review changes"
    },
    updateJiraDialogContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-content",
        "defaultMessage": "Save issues created or changed in your plan so they update in your projects."
    },
    updateJiraDialogContentOld: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-content-old",
        "defaultMessage": "These changes are only saved in your plan. To see these changes in Jira, you'll need to save these in Jira first."
    },
    updateJiraDialogContentNoChanges: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-content-no-changes",
        "defaultMessage": "There are no unsaved changes"
    },
    updateJiraDialogRevertButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-revert-button-text",
        "defaultMessage": "Discard selected changes"
    },
    updateJiraDialogUpdateButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-update-button-text",
        "defaultMessage": "Save changes"
    },
    updateJiraDialogUpdateButtonTextOld: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-update-button-text-old",
        "defaultMessage": "Save selected changes in Jira"
    },
    updateJiraDialogStopButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stop-button-text",
        "defaultMessage": "Quit"
    },
    updateJiraDialogStoppingButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.update-jira-dialog-stopping-button-text",
        "defaultMessage": "Quitting"
    },
    outOfSyncMessageConcurrentEditing: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.out-of-sync-message-concurrent-editing",
        "defaultMessage": "Your plan is out of sync due to concurrent editing."
    },
    refreshCta: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.refresh-cta",
        "defaultMessage": "<span>Refresh</span> to get the latest version. Your changes will not be lost."
    },
    disabledTooltipForUpdateJira: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira",
        "defaultMessage": "You don't have permission to save changes in Jira."
    },
    disabledTooltipForUpdateJiraWhenGicIsOpen: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.disabled-tooltip-for-update-jira-when-gic-is-open",
        "defaultMessage": "You can't save selected changes in Jira because you already have an issue in creation."
    },
    closeDialog: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.close-dialog",
        "defaultMessage": "Close dialog"
    }
});
var $7264e0ebaef0174e$export$2e2bcd8739ae039 = $7264e0ebaef0174e$var$messages;

});

parcelRegister("hvKbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $824a3af671622cfc$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cO3ik = parcelRequire("cO3ik");

var $9Ogb7 = parcelRequire("9Ogb7");
var $824a3af671622cfc$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $cO3ik.default), {})((0, $9Ogb7.default));

});
parcelRegister("cO3ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79bf36b82d42b75$export$2e2bcd8739ae039);

var $eDYLe = parcelRequire("eDYLe");

var $iK4oF = parcelRequire("iK4oF");
var $a79bf36b82d42b75$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedChanges: (0, $eDYLe.getSelectedChanges),
    isSaving: (0, $eDYLe.getIsSaving),
    commitProgressStats: (0, $eDYLe.getCommitProgressStats),
    isReverting: (0, $eDYLe.getIsReverting),
    revertProgressStats: (0, $eDYLe.getRevertProgressStats)
});

});

parcelRegister("9Ogb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $135d10719d4764a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $eYlCJ = parcelRequire("eYlCJ");
var $gwbfD = parcelRequire("gwbfD");

var $dloAy = parcelRequire("dloAy");

var $2BQwE = parcelRequire("2BQwE");

var $jMP2a = parcelRequire("jMP2a");

var $1QVWH = parcelRequire("1QVWH");

var $duQ8C = parcelRequire("duQ8C");

var $kHn6t = parcelRequire("kHn6t");

var $i5tKu = parcelRequire("i5tKu");
function $135d10719d4764a9$var$UpdateJiraDialogFooter(props) {
    const { actions: actions, leftActions: leftActions = null, rightActions: rightActions, selectedChanges: selectedChanges, selectedChangesCount: selectedChangesCount, isSaving: isSaving, commitProgressStats: { numberOfCommittedChanges: numberOfCommittedChanges, totalChanges: totalCommitChanges }, isReverting: isReverting, revertProgressStats: { numberOfRevertedChanges: numberOfRevertedChanges, totalChanges: totalRevertChanges } } = props;
    const onTooltipShowHandler = (analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'warningIcon');
    const scalingFactors = Object.fromEntries(Object.entries(selectedChanges).map(([entity, ids])=>[
            entity,
            ids.length
        ]));
    const getFooterRight = ()=>{
        if (rightActions) return rightActions;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, actions.filter(({ isVisible: isVisible = true })=>isVisible).map(({ appearance: appearance, autoFocus: autoFocus = false, isDisabled: isDisabled, isLoading: isLoading, onClick: onClick, testId: testId = '', text: text, tooltip: tooltip, type: type })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $i5tKu.buttonWrapper,
                key: text
            }, isDisabled && selectedChangesCount > 0 && tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: tooltip,
                position: "top",
                onShow: onTooltipShowHandler
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y500})`,
                label: tooltip
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: appearance,
                isDisabled: isDisabled,
                onClick: (e, analyticsEvent)=>{
                    onClick(e, analyticsEvent);
                    if (type === 'save' && scalingFactors) {
                        (0, $duQ8C.default)((0, $2BQwE.KEYS).SAVE_REVIEW_CHANGES, e.timeStamp);
                        (0, $1QVWH.addUFOCustomData)(scalingFactors); // Uses a hook so it cannot be done in the onClick handler as its in a class component.
                    }
                },
                iconAfter: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
                    invertColor: !isDisabled
                }) : undefined,
                autoFocus: autoFocus,
                testId: testId
            }, text))));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i5tKu.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i5tKu.footerLeft
    }, leftActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i5tKu.progressContainer
    }, isSaving && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i5tKu.commitProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dloAy.default), {
        label: {
            ...(0, $kHn6t.default).committingChangesLabelNoElipsis
        },
        countOfThingsDone: numberOfCommittedChanges,
        countOfThingsToDo: totalCommitChanges
    })), isReverting && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $i5tKu.commitProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dloAy.default), {
        label: {
            ...(0, $kHn6t.default).revertingChangesLabelNoElipsis
        },
        countOfThingsDone: numberOfRevertedChanges,
        countOfThingsToDo: totalRevertChanges
    })), getFooterRight())));
}
var $135d10719d4764a9$export$2e2bcd8739ae039 = $135d10719d4764a9$var$UpdateJiraDialogFooter;

});
parcelRegister("dloAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $41f010f60042661b$export$2e2bcd8739ae039);

var $c7MEC = parcelRequire("c7MEC");
var $41f010f60042661b$export$2e2bcd8739ae039 = (0, $c7MEC.default);

});
parcelRegister("c7MEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9e1451b34cace9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $3o1TE = parcelRequire("3o1TE");
var $eYlCJ = parcelRequire("eYlCJ");

var $9TIY9 = parcelRequire("9TIY9");

var $dYQ1u = parcelRequire("dYQ1u");
function $6a9e1451b34cace9$export$2e2bcd8739ae039(props) {
    const { label: label, countOfThingsDone: countOfThingsDone, countOfThingsToDo: countOfThingsToDo } = props;
    const percentage = countOfThingsToDo === 0 ? 0 : Math.floor(100 * countOfThingsDone / countOfThingsToDo);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dYQ1u.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3o1TE.default), {
        label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $dYQ1u.labelWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $dYQ1u.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), {
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label))),
        percentage: percentage,
        progressMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9TIY9.default).progress,
            values: {
                countOfThingsDone: countOfThingsDone,
                countOfThingsToDo: countOfThingsToDo,
                percentage: percentage
            }
        })
    })));
}

});
parcelRegister("3o1TE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c43afd9f2f8d1d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4VYEa = parcelRequire("4VYEa");

var $4oLca = parcelRequire("4oLca");
function $4c43afd9f2f8d1d2$export$2e2bcd8739ae039(props) {
    const { label: label, percentage: percentage, progressMessage: progressMessage } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4oLca.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4oLca.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, progressMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4VYEa.default), {
        percentage: percentage
    })));
}

});
parcelRegister("4VYEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3a35955bb45668$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cRhhK = parcelRequire("cRhhK");
function $be3a35955bb45668$export$2e2bcd8739ae039(props) {
    const { percentage: percentage } = props;
    if (percentage < 0 || percentage > 100) throw new Error(`Percentage must be within [0, 100] range, got ${percentage}`);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cRhhK.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cRhhK.bar,
        style: {
            width: `${percentage}%`
        }
    })));
}

});
parcelRegister("cRhhK", function(module, exports) {

$parcel$export(module.exports, "bar", () => $95c7d7c8ac18c4cb$export$d927737047eb3867, (v) => $95c7d7c8ac18c4cb$export$d927737047eb3867 = v);
$parcel$export(module.exports, "container", () => $95c7d7c8ac18c4cb$export$34e0f9847d4c02dd, (v) => $95c7d7c8ac18c4cb$export$34e0f9847d4c02dd = v);
var $95c7d7c8ac18c4cb$export$d927737047eb3867;
var $95c7d7c8ac18c4cb$export$34e0f9847d4c02dd;
$95c7d7c8ac18c4cb$export$d927737047eb3867 = `WF5SHW_bar`;
$95c7d7c8ac18c4cb$export$34e0f9847d4c02dd = `WF5SHW_container`;

});


parcelRegister("4oLca", function(module, exports) {

$parcel$export(module.exports, "container", () => $333e035057a16180$export$34e0f9847d4c02dd, (v) => $333e035057a16180$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "header", () => $333e035057a16180$export$38e42c68cf43b5d4, (v) => $333e035057a16180$export$38e42c68cf43b5d4 = v);
var $333e035057a16180$export$34e0f9847d4c02dd;
var $333e035057a16180$export$38e42c68cf43b5d4;
$333e035057a16180$export$34e0f9847d4c02dd = `EEOLLq_container`;
$333e035057a16180$export$38e42c68cf43b5d4 = `EEOLLq_header`;

});


parcelRegister("9TIY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9dd0b5cd05bf41a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a9dd0b5cd05bf41a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    progress: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.components.progress.progress",
        "defaultMessage": "{countOfThingsDone} of {countOfThingsToDo} changes \u2014 {percentage}%"
    },
    label: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.components.progress.label",
        "defaultMessage": "Saving in Jira..."
    }
});

});

parcelRegister("dYQ1u", function(module, exports) {

$parcel$export(module.exports, "container", () => $a2d93ba0089e4e7b$export$34e0f9847d4c02dd, (v) => $a2d93ba0089e4e7b$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "labelWrapper", () => $a2d93ba0089e4e7b$export$61bb151bc9360b59, (v) => $a2d93ba0089e4e7b$export$61bb151bc9360b59 = v);
$parcel$export(module.exports, "spinnerWrapper", () => $a2d93ba0089e4e7b$export$d043ff22bb17d686, (v) => $a2d93ba0089e4e7b$export$d043ff22bb17d686 = v);
var $a2d93ba0089e4e7b$export$34e0f9847d4c02dd;
var $a2d93ba0089e4e7b$export$61bb151bc9360b59;
var $a2d93ba0089e4e7b$export$d043ff22bb17d686;
$a2d93ba0089e4e7b$export$34e0f9847d4c02dd = `p0eKqa_container`;
$a2d93ba0089e4e7b$export$61bb151bc9360b59 = `p0eKqa_labelWrapper`;
$a2d93ba0089e4e7b$export$d043ff22bb17d686 = `p0eKqa_spinnerWrapper`;

});



parcelRegister("kHn6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c83fc53b3a9e1a36$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c83fc53b3a9e1a36$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    committingChangesLabelNoElipsis: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.modal-footer.committing-changes-label-no-elipsis",
        "defaultMessage": "Saving in Jira"
    },
    revertingChangesLabelNoElipsis: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.modal-footer.reverting-changes-label-no-elipsis",
        "defaultMessage": "Discarding changes"
    }
});

});

parcelRegister("i5tKu", function(module, exports) {

$parcel$export(module.exports, "buttonWrapper", () => $d2afc51fff6b0fff$export$a3b9b213fa74e4fd, (v) => $d2afc51fff6b0fff$export$a3b9b213fa74e4fd = v);
$parcel$export(module.exports, "commitProgress", () => $d2afc51fff6b0fff$export$b4e6005b1986f726, (v) => $d2afc51fff6b0fff$export$b4e6005b1986f726 = v);
$parcel$export(module.exports, "footer", () => $d2afc51fff6b0fff$export$adb608be33961c98, (v) => $d2afc51fff6b0fff$export$adb608be33961c98 = v);
$parcel$export(module.exports, "footerLeft", () => $d2afc51fff6b0fff$export$4ba0eff4a9437fb, (v) => $d2afc51fff6b0fff$export$4ba0eff4a9437fb = v);
$parcel$export(module.exports, "progressContainer", () => $d2afc51fff6b0fff$export$2612087cf48ded35, (v) => $d2afc51fff6b0fff$export$2612087cf48ded35 = v);
var $d2afc51fff6b0fff$export$a3b9b213fa74e4fd;
var $d2afc51fff6b0fff$export$b4e6005b1986f726;
var $d2afc51fff6b0fff$export$adb608be33961c98;
var $d2afc51fff6b0fff$export$4ba0eff4a9437fb;
var $d2afc51fff6b0fff$export$2612087cf48ded35;
$d2afc51fff6b0fff$export$a3b9b213fa74e4fd = `UZNJmq_buttonWrapper`;
$d2afc51fff6b0fff$export$b4e6005b1986f726 = `UZNJmq_commitProgress`;
$d2afc51fff6b0fff$export$adb608be33961c98 = `UZNJmq_footer`;
$d2afc51fff6b0fff$export$4ba0eff4a9437fb = `UZNJmq_footerLeft`;
$d2afc51fff6b0fff$export$2612087cf48ded35 = `UZNJmq_progressContainer`;

});



parcelRegister("4TlS7", function(module, exports) {

$parcel$export(module.exports, "NotificationToggle", () => $e06683c24687a9ee$export$9f77dec5f8cc764a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jgrQL = parcelRequire("jgrQL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6ETZE = parcelRequire("6ETZE");
var $g4Vkx = parcelRequire("g4Vkx");
var $gwbfD = parcelRequire("gwbfD");

var $i9e6f = parcelRequire("i9e6f");
const $e06683c24687a9ee$export$9f77dec5f8cc764a = ({ active: active, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleCheckboxChange = (0, $eUqFw.useCallback)((e)=>onChange(e.target.checked), [
        onChange
    ]);
    const label = formatMessage((0, $i9e6f.default).notifyWatchers);
    const tooltip = formatMessage((0, $i9e6f.default).notifyWatchersDesc);
    const tooltipAriaLabel = formatMessage((0, $i9e6f.default).notifyWatchersTooltipAriaLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e06683c24687a9ee$var$NotifyWatchersContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.checkbox",
        isChecked: active,
        onChange: handleCheckboxChange,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "button",
            tabIndex: 0,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
            label: tooltipAriaLabel,
            primaryColor: `var(--ds-icon-information, ${(0, $g4Vkx.default).B400})`
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e06683c24687a9ee$var$NotifyWatchersContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm0-8.5a1 1 0 00-1 1V15a1 1 0 002 0v-2.5a1 1 0 00-1-1zm0-1.125a1.375 1.375 0 100-2.75 1.375 1.375 0 000 2.75z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = $e0651d627acb5549$var$EditorInfoIcon;
module.exports.default = $e0651d627acb5549$var$_default;

});

parcelRegister("i9e6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d1a7cc68718b486$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $2d1a7cc68718b486$var$messages = (0, $90IgZ.defineMessages)({
    notifyWatchers: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers",
        "defaultMessage": "Send update notifications"
    },
    notifyWatchersDesc: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers-desc",
        "defaultMessage": "Users associated with these issues will be notified of the change as per their notification settings."
    },
    notifyWatchersTooltipAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.notification-toggle.notify-watchers-tooltip-aria-label",
        "defaultMessage": "More info"
    }
});
var $2d1a7cc68718b486$export$2e2bcd8739ae039 = $2d1a7cc68718b486$var$messages;

});


parcelRegister("k1mf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9891f10f9a09ae1e$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $aqlzI = parcelRequire("aqlzI");

var $a5nXS = parcelRequire("a5nXS");

var $1mRon = parcelRequire("1mRon");
var $9891f10f9a09ae1e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $a5nXS.default), (0, $aqlzI.default))((0, $1mRon.default));

});
parcelRegister("aqlzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $edaaf80de91e4edc$export$2e2bcd8739ae039);
parcelRequire("6fxQQ");
var $7SlBO = parcelRequire("7SlBO");

var $7SlBO = parcelRequire("7SlBO");
const $edaaf80de91e4edc$var$mapDispatchToProps = (dispatch)=>({
        replaceSelection: (changes)=>{
            dispatch((0, $7SlBO.replaceSelectedChanges)(changes));
        },
        changeQuickSelect: (option)=>{
            dispatch((0, $7SlBO.changeQuickSelect)(option));
        }
    });
var $edaaf80de91e4edc$export$2e2bcd8739ae039 = $edaaf80de91e4edc$var$mapDispatchToProps;

});

parcelRegister("a5nXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $518d713b206a55f6$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $1bVXL = parcelRequire("1bVXL");

var $kJwcd = parcelRequire("kJwcd");

var $iK4oF = parcelRequire("iK4oF");
const $518d713b206a55f6$var$getUserFilterValuesPure = (userFilter)=>userFilter.value;
const $518d713b206a55f6$var$getUserFilterValues = (0, $iK4oF.createSelector)([
    (0, $1bVXL.getUserFilter)
], $518d713b206a55f6$var$getUserFilterValuesPure);
var $518d713b206a55f6$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    selectedIssues: (0, $kwMvv.getSelected),
    userFilter: $518d713b206a55f6$var$getUserFilterValues,
    option: (0, $kJwcd.getQuickSelectOption)
});

});
parcelRegister("kJwcd", function(module, exports) {

$parcel$export(module.exports, "getQuickSelectOption", () => $dddaebfac9f97f2e$export$4c274803eed73060);
const $dddaebfac9f97f2e$export$4c274803eed73060 = (state)=>state.ui.Top.TitleBar.UpdateJira.quickSelectOption;

});


parcelRegister("1mRon", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c45e19f5f81e86$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cWiVr = parcelRequire("cWiVr");

var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $eTbtL = parcelRequire("eTbtL");
var $gwbfD = parcelRequire("gwbfD");
var $l2Sj2 = parcelRequire("l2Sj2");

var $cuuJa = parcelRequire("cuuJa");

var $j3zeB = parcelRequire("j3zeB");

var $7CnHa = parcelRequire("7CnHa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hMVOo = parcelRequire("hMVOo");

var $fg483 = parcelRequire("fg483");
const $23c45e19f5f81e86$var$QuickSelectors = ({ selectedIssues: selectedIssues, changes: changes, replaceSelection: replaceSelection, userFilter: userFilter, option: option, changeQuickSelect: changeQuickSelect })=>{
    const currentUserData = (0, $cWiVr.useCurrentUser)().data.user;
    const isCurrentUserFilteredOut = userFilter.length > 0 && (0, $7CnHa.isDefined)(currentUserData.accountId) && !userFilter.includes(currentUserData.accountId);
    const hasTimelineSelection = selectedIssues.size > 0;
    const defaultSelection = (()=>{
        if (hasTimelineSelection) return (0, $j3zeB.QuickSelectOption).TIMELINE;
        if (!isCurrentUserFilteredOut) return (0, $j3zeB.QuickSelectOption).MINE;
        // User filter persists, so if the current user is filtered out, select 'none' as default value
        return (0, $j3zeB.QuickSelectOption).NONE;
    })();
    const isInitialRender = (0, $eUqFw.useRef)(true);
    const lastChanges = (0, $eUqFw.useRef)(changes.length);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const applySelection = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (changes)=>{
        replaceSelection(changes);
    }, [
        replaceSelection
    ]);
    const getSelectionsFromOption = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (option)=>{
        let newSelections;
        switch(option){
            case (0, $j3zeB.QuickSelectOption).MINE:
                newSelections = (0, $fg483.getMyChanges)(changes, currentUserData.accountId);
                break;
            case (0, $j3zeB.QuickSelectOption).TODAY:
                newSelections = (0, $fg483.getTodaysChanges)(changes);
                break;
            case (0, $j3zeB.QuickSelectOption).TIMELINE:
                newSelections = (0, $fg483.getTimelineChanges)(changes, selectedIssues);
                break;
            default:
                newSelections = (0, $fg483.getAllChanges)(changes);
                break;
        }
        return newSelections;
    }, [
        changes,
        currentUserData.accountId,
        selectedIssues
    ]);
    const selectIssuesOnOptionChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (option)=>{
        applySelection(getSelectionsFromOption(option));
    }, [
        applySelection,
        getSelectionsFromOption
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isInitialRender.current) {
            isInitialRender.current = false;
            changeQuickSelect(defaultSelection);
            selectIssuesOnOptionChange(defaultSelection);
        }
    }, [
        changeQuickSelect,
        defaultSelection,
        selectIssuesOnOptionChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialRender.current && lastChanges.current !== changes.length) {
            if (option !== (0, $j3zeB.QuickSelectOption).NONE) selectIssuesOnOptionChange(option);
            lastChanges.current = changes.length;
        }
    }, [
        changes,
        selectIssuesOnOptionChange,
        option
    ]);
    const options = [
        {
            value: (0, $j3zeB.QuickSelectOption).MINE,
            label: formatMessage((0, $hMVOo.default).myChangesLabel),
            tooltip: formatMessage((0, $hMVOo.default).myChangesTooltip),
            isDisabled: isCurrentUserFilteredOut
        },
        {
            value: (0, $j3zeB.QuickSelectOption).TODAY,
            label: formatMessage((0, $hMVOo.default).todaysChangesLabel),
            tooltip: formatMessage((0, $hMVOo.default).todaysChangesTooltip, {
                date: formatTimestamp(Date.now(), (0, $eTbtL.shortDateFormat))
            })
        },
        {
            value: (0, $j3zeB.QuickSelectOption).TIMELINE,
            label: formatMessage((0, $hMVOo.default).inheritTimelineSelectionLabel),
            tooltip: formatMessage((0, $hMVOo.default).inheritTimelineSelectionTooltip)
        }
    ];
    const handleSelect = (clickedOption)=>{
        const selectOrDeselectOption = option === clickedOption ? (0, $j3zeB.QuickSelectOption).NONE : clickedOption;
        changeQuickSelect(selectOrDeselectOption);
        selectIssuesOnOptionChange(selectOrDeselectOption);
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REVIEW_CHANGES_MODAL_QUICK_SELECT_CLICKED.split(' ');
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), {
            option: selectOrDeselectOption
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, options.map(({ value: value, label: label, tooltip: tooltip, isDisabled: isDisabled }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: tooltip,
            key: `${value}-quick-select`,
            position: "top",
            delay: 1000
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            isSelected: option === value,
            isDisabled: isDisabled,
            onClick: ()=>{
                handleSelect(value);
            },
            testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.button-${value}`,
            autoFocus: index === 0
        }, label))));
};
var $23c45e19f5f81e86$export$2e2bcd8739ae039 = $23c45e19f5f81e86$var$QuickSelectors;

});
parcelRegister("hMVOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $813f5037f10f01bc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $813f5037f10f01bc$var$messages = (0, $90IgZ.defineMessages)({
    myChangesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.my-changes-label",
        "defaultMessage": "Issues changed by me"
    },
    myChangesTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.my-changes-tooltip",
        "defaultMessage": "This option selects all the changes related to issues you\u2019ve edited, including changes made by others. "
    },
    todaysChangesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.todays-changes-label",
        "defaultMessage": "Issues changed today"
    },
    todaysChangesTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.todays-changes-tooltip",
        "defaultMessage": "This option selects all changes made to issues on {date}."
    },
    inheritTimelineSelectionLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.inherit-timeline-selection-label",
        "defaultMessage": "Selected on the timeline"
    },
    inheritTimelineSelectionTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.quick-selectors.inherit-timeline-selection-tooltip",
        "defaultMessage": "This option only selects changes that apply to issues currently selected on your timeline."
    }
});
var $813f5037f10f01bc$export$2e2bcd8739ae039 = $813f5037f10f01bc$var$messages;

});

parcelRegister("fg483", function(module, exports) {

$parcel$export(module.exports, "getMyChanges", () => $fc722d14c565e7fc$export$e155176f8d445f89);
$parcel$export(module.exports, "getTodaysChanges", () => $fc722d14c565e7fc$export$6f496663abc2170a);
$parcel$export(module.exports, "getTimelineChanges", () => $fc722d14c565e7fc$export$baa60d2323310e21);
$parcel$export(module.exports, "getAllChanges", () => $fc722d14c565e7fc$export$56552f518dc96f0f);

var $f7Op5 = parcelRequire("f7Op5");

var $dulT0 = parcelRequire("dulT0");

var $7CnHa = parcelRequire("7CnHa");

var $jgxY2 = parcelRequire("jgxY2");
const $fc722d14c565e7fc$var$getChangeIdsByCategory = (changes)=>{
    const changesByCategory = (0, $7CnHa.groupBy)($f7Op5.default('category'), (0, $jgxY2.getExpandedChanges)(changes));
    return (0, $7CnHa.mapValues)($f7Op5.default('id'), changesByCategory);
};
const $fc722d14c565e7fc$export$e155176f8d445f89 = (changes, myUserId)=>{
    let filteredChanges = [];
    if (myUserId) filteredChanges = changes.filter((change)=>change.lastModified && myUserId === change.lastModified.personId);
    return $fc722d14c565e7fc$var$getChangeIdsByCategory(filteredChanges);
};
const $fc722d14c565e7fc$export$6f496663abc2170a = (changes)=>{
    const filteredChanges = changes.filter((change)=>change.lastModified && (0, $dulT0.default)(new Date(), new Date(change.lastModified?.date)));
    return $fc722d14c565e7fc$var$getChangeIdsByCategory(filteredChanges);
};
const $fc722d14c565e7fc$export$baa60d2323310e21 = (changes, selection)=>{
    const filteredChanges = changes.filter((change)=>selection.has(change.id));
    return $fc722d14c565e7fc$var$getChangeIdsByCategory(filteredChanges);
};
const $fc722d14c565e7fc$export$56552f518dc96f0f = (changes)=>$fc722d14c565e7fc$var$getChangeIdsByCategory(changes);

});



parcelRegister("iLYmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f59f7413c637d95$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $j874V = parcelRequire("j874V");

var $apcWJ = parcelRequire("apcWJ");

var $J02j4 = parcelRequire("J02j4");
const $9f59f7413c637d95$var$connector = (0, $lNNXV.connect)((0, $apcWJ.default), (0, $j874V.default));
var // @ts-expect-error - TS2345 - Argument of type '(props: ActiveProps) => JSX.Element' is not assignable to parameter of type 'Component<{ handleSubmit: (id: string) => null | undefined; handleCancel: () => null | undefined; handleCancelAll: () => null | undefined; handleFailure: () => null | undefined; }>'.
$9f59f7413c637d95$export$2e2bcd8739ae039 = $9f59f7413c637d95$var$connector((0, $J02j4.default));

});
parcelRegister("j874V", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7402834506bc0b$export$2e2bcd8739ae039);

var $264LW = parcelRequire("264LW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8d7402834506bc0b$export$2e2bcd8739ae039 = (dispatch)=>({
        handleSubmit: (id)=>dispatch((0, $264LW.submit)({
                generatedItemId: id
            })),
        handleCancel: ()=>dispatch((0, $264LW.cancel)()),
        handleCancelAll: ()=>dispatch((0, $264LW.cancel)()),
        handleFailure: ()=>dispatch((0, $264LW.fail)())
    });

});

parcelRegister("apcWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca45719f9887e71$export$2e2bcd8739ae039);

var $i0RGP = parcelRequire("i0RGP");
var $f7Op5 = parcelRequire("f7Op5");

var $kKj1m = parcelRequire("kKj1m");

var $fZW8G = parcelRequire("fZW8G");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $eDYLe = parcelRequire("eDYLe");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
// Start date is a custom field
const $8ca45719f9887e71$var$getStartDateCustomField = (0, $iK4oF.createSelector)([
    (0, $kKj1m.getCustomFields)
], (customFields)=>customFields.find(({ defaultStartDateCustomField: defaultStartDateCustomField })=>defaultStartDateCustomField));
const $8ca45719f9887e71$var$getRequiredFields = (state)=>state.domain.updateJira.requiredFields;
/**
 * This function looks for the issue project key in the projects props and mixes it up with the issue key.
 *
 * @param issue Issue.
 * @param projectsById Projects grouped by id.
 *
 * @returns Returns the issue project key and the issue key concatenated with a "-"; or null if the issue project id was not found in projectsById.
 */ const $8ca45719f9887e71$var$getIssueKey = (issueKey, project, projectsById)=>{
    if (project && projectsById[project]) return `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
    return null;
};
var $8ca45719f9887e71$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    $8ca45719f9887e71$var$getRequiredFields,
    (0, $eDYLe.getFilteredReviewChanges),
    (0, $lihml.getIssueTypes),
    (0, $dhHiZ.getSystemInfo),
    (0, $dhHiZ.getAgileInfo),
    (0, $cwP4d.getIssueMapById),
    (0, $ehEr2.getProjectsById),
    $8ca45719f9887e71$var$getStartDateCustomField,
    (0, $fZW8G.getTypeToLevel),
    (0, $75KhQ.getPlan),
    (0, $MQRDu.getTeamsById)
], (requiredFields, reviewChanges, issueTypes, systemInfo, agileInfo, issuesMappedById, projectsById, startDateCustomField, getIssueTypeToHierarchyLevel, planInfo, teamsById)=>{
    const { isWaiting: isWaiting } = requiredFields;
    if (!isWaiting) return {
        isOpen: false
    };
    const { issueId: issueId, error: error } = requiredFields;
    const jiraConfig = {
        hoursPerDay: systemInfo.jiraHoursPerDay,
        daysPerWeek: systemInfo.jiraDaysPerWeek
    };
    const issueTypesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), issueTypes);
    const issueChange = $i0RGP.default((change)=>change.id === issueId, reviewChanges);
    const issue = issueChange?.details;
    const fullIssue = issuesMappedById[issueId];
    if (!issue || !fullIssue) throw new Error('Cannot retrieve issue details for required fields dialog');
    const parentIssue = (()=>{
        const pIssue = fullIssue.parent != null ? issuesMappedById[fullIssue.parent] : undefined;
        if (pIssue?.type == null || pIssue?.issueKey == null || pIssue?.project == null) return;
        const parentIssueKey = $8ca45719f9887e71$var$getIssueKey(pIssue.issueKey, pIssue.project, projectsById);
        if (!parentIssueKey) return;
        return {
            key: parentIssueKey,
            hierarchyLevel: getIssueTypeToHierarchyLevel(pIssue.type)
        };
    })();
    return {
        isOpen: true,
        issue: issue,
        error: error,
        issueTypesById: issueTypesById,
        agileConfig: agileInfo,
        jiraConfig: jiraConfig,
        parentIssue: parentIssue,
        startDateCustomField: startDateCustomField,
        planInfo: planInfo,
        projectsById: projectsById,
        teamsById: teamsById
    };
});

});

parcelRegister("J02j4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71028c232eb4d3c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kUWRc = parcelRequire("kUWRc");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ctR9z = parcelRequire("ctR9z");


var $9FjHM = parcelRequire("9FjHM");

var $54kAD = parcelRequire("54kAD");

var $9zkwU = parcelRequire("9zkwU");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d71028c232eb4d3c$var$getDocumentRoot = ()=>document.body;
const $d71028c232eb4d3c$var$tryMoveElementToContainer = (container, el)=>{
    if (container) {
        el.remove();
        container.appendChild(el);
    }
};
const $d71028c232eb4d3c$var$DEFAULT_OPEN_GIC_MODAL_VALUES = {
    id: 'jpo-dialogs-jira-create-issue',
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$998dfc72404b9e14),
    disableCreationSuccessFlag: true,
    disableProjectDropdown: true,
    disableIssueTypeDropdown: true,
    displayOnlyRequiredFields: false,
    displayCreateAnotherIssueToggle: false
};
const $d71028c232eb4d3c$var$useGlobalIssueCreateModal = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showDialog = (0, $eUqFw.useCallback)(({ payload: payload, handleSubmit: handleSubmit, handleCancel: handleCancel, isSubTask: isSubTask, errorMessages: errorMessages })=>{
        openIssueCreateModal({
            ...$d71028c232eb4d3c$var$DEFAULT_OPEN_GIC_MODAL_VALUES,
            payload: payload,
            title: formatMessage((0, $9FjHM.default).requiredFieldsDialogTitle),
            isSubTaskCreationOpen: isSubTask,
            onIssueCreate: (data)=>handleSubmit(data.issueId.toString()),
            onClose: ()=>handleCancel(),
            submitErrorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($kUWRc)))(errorMessages) ? undefined : errorMessages?.join('\n')
        });
    }, [
        formatMessage,
        openIssueCreateModal
    ]);
    return {
        showDialog: showDialog
    };
};
const $d71028c232eb4d3c$var$RequiredFieldsDialog = (props)=>{
    const { showDialog: showDialog } = $d71028c232eb4d3c$var$useGlobalIssueCreateModal();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d71028c232eb4d3c$var$RequiredFieldsDialogClass, {
        ...props,
        showDialog: showDialog,
        formatMessage: formatMessage
    });
};
// eslint-disable-next-line jira/react/no-class-components
class $d71028c232eb4d3c$var$RequiredFieldsDialogClass extends (0, $eUqFw.Component) {
    createLegacyDialogInRefContainer(activeProps) {
        const { formatMessage: formatMessage, issue: issue, issueTypesById: issueTypesById, agileConfig: agileConfig, jiraConfig: jiraConfig, projectsById: projectsById } = activeProps;
        const jQueryDeferred = (0, $54kAD.default).create({
            formatMessage: formatMessage,
            issue: issue,
            issueTypesById: issueTypesById,
            agileConfig: agileConfig,
            jiraConfig: jiraConfig,
            isIssueSimplified: projectsById[issue.values.project].isSimplified,
            onRenderCallback: (dialog)=>{
                $d71028c232eb4d3c$var$tryMoveElementToContainer(this.containerRef, dialog);
            }
        });
        return jQueryDeferred;
    }
    /**
   * There are a few things happening here:
   * - This AUI / jQuery UI dialog is rendered on top of an AtlasKit React dialog;
   * - The AtlasKit dialog is wrapped in a focus lock component, which will block events
   *    to any element that isn't a direct child;
   * - The AUI / jQuery dialog will by default render at the bottom of the page outside of
   *   React's dom, which means it will by blocked out by the focus lock component;
   * - We can't just make the AUI dialog component a direct child of the AtlasKit component,
   *   because then it will be blocked by the AUI blanket which blocks inputs outside of the
   *   AUI dialog, and is rendered at the bottom of the page.
   *
   * The workaround is then to:
   * - Render an empty container as a child of the atlas kit dialog and get a ref to it. If
   *   we render the AUI dialog inside this container, it will be accepted by the AtlasKit
   *   focus lock;
   * - Portal the ref container to the bottom of the page, so that it can get around the
   *   AUI dialog blanket;
   * - Since we can't control where the AUI dialog renders by default (it's an internal
   *   detail in the jira-quick-edit-plugin), wait for it to render, and then manually
   *   move it into our portalled ref container.
   */ // eslint-disable-next-line react/sort-comp
    render() {
        const root = $d71028c232eb4d3c$var$getDocumentRoot();
        const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: (ref)=>{
                this.containerRef = ref;
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(container, root);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.isOpen !== this.props.isOpen;
    }
    async componentDidUpdate() {
        if (this.containerRef) this.containerRef.innerHTML = '';
        if (!this.props.isOpen) return;
        const activeProps = this.props;
        const { handleSubmit: handleSubmit, handleCancel: handleCancel, handleCancelAll: handleCancelAll, handleFailure: handleFailure, issue: issue, agileConfig: agileConfig, issueTypesById: issueTypesById, error: error, parentIssue: parentIssue, startDateCustomField: startDateCustomField, planInfo: planInfo, projectsById: projectsById, teamsById: teamsById } = activeProps;
        const isIssueSimplified = projectsById[issue.values.project].isSimplified;
        const isModernDialogEnabled = window.IssueCreate && window.IssueCreate.Visibility.isEnabled;
        if (isModernDialogEnabled && this.props.showDialog) {
            const { payload: payload, isSubTask: isSubTask } = await (0, $9zkwU.getOpenIssueCreateModalPayload)({
                issue: issue,
                agileConfig: agileConfig,
                issueTypesById: issueTypesById,
                planInfo: planInfo,
                startDateCustomField: startDateCustomField,
                parentIssue: parentIssue,
                isIssueSimplified: isIssueSimplified,
                teamsById: teamsById
            });
            this.props.showDialog({
                payload: payload,
                handleSubmit: handleSubmit,
                handleCancel: handleCancel,
                isSubTask: isSubTask,
                errorMessages: error?.errorMessages
            });
        } else this.createLegacyDialogInRefContainer(activeProps).done(({ id: id })=>handleSubmit(id)).fail(({ reason: reason })=>{
            if (reason === 'cancel') handleCancel();
            else if (reason === 'cancel-all') handleCancelAll();
            else handleFailure();
        });
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line react/sort-comp
        this.containerRef = null;
    }
}
var $d71028c232eb4d3c$export$2e2bcd8739ae039 = $d71028c232eb4d3c$var$RequiredFieldsDialog;

});
parcelRegister("9FjHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f6ff38b0b3ec897$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0f6ff38b0b3ec897$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredFieldsDialogTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.required-fields-dialog.required-fields-dialog-title",
        "defaultMessage": "Set required fields"
    }
});

});

parcelRegister("54kAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb36ca588a52324e$export$2e2bcd8739ae039);

var $g3QAp = parcelRequire("g3QAp");
var $eb36ca588a52324e$export$2e2bcd8739ae039 = (0, $g3QAp.default);

});
parcelRegister("g3QAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ac16517212e25b$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");
var $2wtN3 = parcelRequire("2wtN3");
var $fpul1 = parcelRequire("fpul1");
var $5oPVJ = parcelRequire("5oPVJ");

var $l2Sj2 = parcelRequire("l2Sj2");

var $5rYNM = parcelRequire("5rYNM");

var $6h3T7 = parcelRequire("6h3T7");

var $1GoEI = parcelRequire("1GoEI");

var $gYC20 = parcelRequire("gYC20");
const $37ac16517212e25b$var$createCreateIssueModel = ({ projectId: projectId, issueTypeId: issueTypeId, parentIssueId: parentIssueId })=>{
    const $ = (0, $1GoEI.getJquery)();
    const RequiredFieldsCreateIssueModel = (0, $1GoEI.getJira)().Forms.CreateIssueModel.extend({
        getActiveFieldIds () {
            const deferred = new $.Deferred();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const activeFieldsIds = [];
            this.getRequiredFields().done((requiredFields)=>{
                requiredFields.forEach((requiredField)=>{
                    if (!activeFieldsIds.includes(requiredField.id)) activeFieldsIds.push(requiredField.id);
                });
                deferred.resolve(activeFieldsIds);
            });
            return deferred;
        },
        getUseConfigurableForm () {
            return $.when(true);
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setUseConfigurableForm () {}
    });
    return new RequiredFieldsCreateIssueModel({
        projectId: projectId,
        issueType: issueTypeId,
        parentIssueId: parentIssueId
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $37ac16517212e25b$var$disableSelect = ($el)=>{
    const $ = (0, $1GoEI.getJquery)();
    if ($el.length > 0) {
        $el.addClass('aui-disabled');
        $('input', $el).prop('disabled', true);
        // The select also has a span which contains the dropdown symbol. This also needs to separately be disabled.
        $('span', $el).css('pointer-events', 'none');
        if ($('.aui-disabled-blanket').length === 0) $el.append('<div class="aui-disabled-blanket" style="height: 30px;"></div>');
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $37ac16517212e25b$var$isCommittedFixVersion = (versionId)=>$5oPVJ.default(Number, +versionId);
const $37ac16517212e25b$var$formatEstimates = ({ seconds: seconds, hoursPerDay: hoursPerDay, daysPerWeek: daysPerWeek })=>{
    if (!seconds) return undefined;
    const durations = {
        h: 3600,
        m: 60,
        s: 1
    };
    const format = [
        {
            unit: 'w',
            seconds: durations.h * hoursPerDay * daysPerWeek
        },
        {
            unit: 'd',
            seconds: durations.h * hoursPerDay
        },
        {
            unit: 'h',
            seconds: durations.h
        },
        {
            unit: 'm',
            seconds: durations.m
        },
        {
            unit: 's',
            seconds: durations.s
        }
    ];
    let remainingSeconds = seconds;
    let retVal = '';
    format.forEach((entry)=>{
        const x = Math.floor(remainingSeconds / entry.seconds);
        if (x > 0) {
            retVal += `${x}${entry.unit} `;
            remainingSeconds -= x * entry.seconds;
        }
    });
    return retVal.trim();
};
const $37ac16517212e25b$var$timestampToFormattedDate = (timestampValue)=>(0, $l2Sj2.formatDateUTC)(timestampValue, (0, $5rYNM.DefaultDateFormat));
const $37ac16517212e25b$var$formatCustomField = (customField)=>{
    if (customField.typeKey === (0, $5rYNM.CustomFieldTypes).DatePicker) // Date picker values are always number
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $37ac16517212e25b$var$timestampToFormattedDate(customField.value);
    return customField.value;
};
const $37ac16517212e25b$var$isCustomFieldKey = (key)=>key.startsWith('customField');
const $37ac16517212e25b$export$ca7888bf604d23e8 = ({ issue: issue, agileConfig: agileConfig, isIssueSimplified: isIssueSimplified })=>{
    const { epicLabelField: epicLabelField, storyPointsField: storyPointsField, storyPointEstimateField: storyPointEstimateField } = agileConfig;
    const nonScenarioFixVersions = $fpul1.default($37ac16517212e25b$var$isCommittedFixVersion, $2wtN3.default([], issue.values.fixVersions));
    // prefill data to show in the jira issue dialog
    let prefilledFields = {
        summary: issue.values.summary,
        description: issue.values.description || '',
        fixVersions: nonScenarioFixVersions,
        issuetype: issue.values.type
    };
    if (issue.values.dueDate) // prefill expects lower case duedate
    prefilledFields = $aeXAa.default('duedate', $37ac16517212e25b$var$timestampToFormattedDate(issue.values.dueDate), prefilledFields);
    // scan through our issue data to send any fields that have values, so the jira issue dialog will be pre-populated as much as possible
    /* eslint-disable @typescript-eslint/consistent-type-assertions */ Object.entries(issue.values)/* eslint-enable @typescript-eslint/consistent-type-assertions */ .forEach(([key, value])=>{
        if (key && value) {
            if ($37ac16517212e25b$var$isCustomFieldKey(key)) {
                const customField = issue.values[key];
                prefilledFields[`customfield_${customField.id}`] = $37ac16517212e25b$var$formatCustomField(customField);
            } else if (!prefilledFields[key]) // not sure why this is expected to be never =(
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            prefilledFields[key] = issue.values[key];
        }
    });
    if (epicLabelField) // not sure why this is expected to be never =(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    prefilledFields[epicLabelField] = issue.values.summary;
    if (issue.values.storyPoints) {
        if (isIssueSimplified && storyPointsField) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        prefilledFields[storyPointsField] = issue.values.storyPoints;
        else if (!isIssueSimplified && storyPointEstimateField) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        prefilledFields[storyPointEstimateField] = issue.values.storyPoints;
    }
    return prefilledFields;
};
const $37ac16517212e25b$var$create = (params)=>{
    const { issue: issue, issueTypesById: issueTypesById, jiraConfig: jiraConfig } = params;
    const $ = (0, $1GoEI.getJquery)();
    const _ = (0, $1GoEI.getUnderscore)();
    const deferred = new $.Deferred();
    const isSubTask = issueTypesById[issue.values.type] && issueTypesById[issue.values.type].subTask === true;
    const isSubTaskCreationPossible = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const isCommittedParentId = $5oPVJ.default(Number, +issue.values.parent);
        return !isSubTask || isCommittedParentId;
    };
    if (!isSubTaskCreationPossible) {
        deferred.reject({
            type: 'client-sub-task-creation-impossible'
        });
        return deferred;
    }
    const prefilledFields = $37ac16517212e25b$export$ca7888bf604d23e8(params);
    const formattedEstimates = $37ac16517212e25b$var$formatEstimates({
        seconds: issue.values.timeEstimate,
        hoursPerDay: jiraConfig.hoursPerDay,
        daysPerWeek: jiraConfig.daysPerWeek
    });
    const parentId = isSubTask ? issue.values.parent : undefined;
    const createIssueModel = $37ac16517212e25b$var$createCreateIssueModel({
        projectId: issue.values.project,
        issueTypeId: issue.values.type,
        parentIssueId: parentId
    });
    const title = params.formatMessage((0, $gYC20.default).requiredFieldsDialogTitle);
    (0, $6h3T7.default).showDialog({
        deferred: deferred,
        model: createIssueModel,
        prefilledFields: prefilledFields,
        title: title,
        hideConfigureFields: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onRenderCallback: ($dialog)=>{
            if (formattedEstimates) {
                $('#timetracking_originalestimate', $dialog).val(formattedEstimates);
                $('#timetracking_remainingestimate', $dialog).val(formattedEstimates);
                $('#timetracking', $dialog).val(formattedEstimates);
            }
            const el = $dialog.get(0);
            params.onRenderCallback(el);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onContentRefreshedCallback: (quickFormElement)=>{
            _.defer(()=>{
                $37ac16517212e25b$var$disableSelect($('#project-single-select', quickFormElement));
                $37ac16517212e25b$var$disableSelect($('#issuetype-single-select', quickFormElement));
            });
        }
    });
    return deferred;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$37ac16517212e25b$export$2e2bcd8739ae039 = {
    create: $37ac16517212e25b$var$create
};

});
parcelRegister("6h3T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9f751355f8b71f$export$2e2bcd8739ae039);

var $1GoEI = parcelRequire("1GoEI");
const $0d9f751355f8b71f$var$createCreateIssueForm = ({ model: model, title: title, prefilledFields: prefilledFields = {} })=>{
    const $ = (0, $1GoEI.getJquery)();
    const JIRA = (0, $1GoEI.getJira)();
    const CustomFormContainer = JIRA.Forms.Container.extend({
        lazyInit () {
            const options = this.options();
            options.prefilledValues.fieldsToRetain = Object.keys(options.prefilledValues);
            this.prefilledValues = $.param(options.prefilledValues, true);
            this.options = ()=>options;
            this._super();
        },
        render () {
            const deferred = $.Deferred();
            this.lazyInit();
            this.model.getUseConfigurableForm().done((isConfigurable)=>{
                if (isConfigurable) // @ts-expect-error - TS7006 - Parameter 'el' implicitly has an 'any' type. | TS7006 - Parameter 'scripts' implicitly has an 'any' type.
                this.configurableForm.render(this.prefilledValues).done((_, scripts)=>{
                    deferred.resolveWith(this, [
                        this.$element
                    ]);
                    this.$element.append(scripts);
                });
                else this.unconfigurableForm.render.render(this.prefilledValues)// @ts-expect-error - TS7006 - Parameter 'el' implicitly has an 'any' type. | TS7006 - Parameter 'scripts' implicitly has an 'any' type.
                .done((_, scripts)=>{
                    deferred.resolveWith(this, [
                        this.$element,
                        scripts
                    ]);
                    this.$element.append(scripts);
                });
            }).fail(()=>{
                deferred.resolveWith(this, [
                    this.$element
                ]);
            });
            return deferred.promise();
        }
    });
    return new CustomFormContainer(()=>{
        const globalEventNamespaces = [
            'QuickCreateEpic'
        ];
        const configurableForm = new JIRA.Forms.ConfigurableCreateIssueForm({
            model: model,
            title: title,
            globalEventNamespaces: globalEventNamespaces
        });
        const unconfigurableForm = new JIRA.Forms.UnconfigurableCreateIssueForm({
            model: model,
            title: title,
            globalEventNamespaces: globalEventNamespaces
        });
        return {
            globalEventNamespaces: globalEventNamespaces,
            model: model,
            configurableForm: configurableForm,
            unconfigurableForm: unconfigurableForm,
            errorHandler: new JIRA.Forms.CreateIssueError(),
            prefilledValues: prefilledFields
        };
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0d9f751355f8b71f$var$bind = (element, eventKey, func)=>{
    if (element) (0, $1GoEI.getAjs)().$(element).bind(eventKey, func);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0d9f751355f8b71f$var$unbind = (element, eventKey, func)=>{
    const AJS = (0, $1GoEI.getAjs)();
    if (element && eventKey) {
        if (func) AJS.$(element).unbind(eventKey, func);
        else AJS.$(element).unbind(eventKey);
    }
};
const $0d9f751355f8b71f$var$showDialog = ({ model: model, prefilledFields: prefilledFields, title: title, hideConfigureFields: hideConfigureFields, hideCancelAllLink: hideCancelAllLink, deferred: deferred, onRenderCallback: onRenderCallback, onContentRefreshedCallback: onContentRefreshedCallback })=>{
    const JIRA = (0, $1GoEI.getJira)();
    const $ = (0, $1GoEI.getJquery)();
    const form = $0d9f751355f8b71f$var$createCreateIssueForm({
        model: model,
        title: title,
        prefilledFields: prefilledFields
    });
    const dialog = form.asDialog({
        id: 'jpo-dialogs-jira-create-issue'
    });
    const cancelAllLink = !hideCancelAllLink ? $('<a href="javascript:void(0);" class="jpo-cancel-all">Cancel All</a>') : undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onIssueCreated = (_, data)=>{
        const issueData = data.createdIssueDetails;
        const result = {
            id: issueData.id,
            key: issueData.key,
            title: issueData.fields.summary,
            issuetypeId: issueData.fields.issuetype.id
        };
        deferred.resolve(result);
    };
    const onContentRefreshed = ()=>{
        const quickForm = dialog.getQuickForm();
        const quickFormElement = quickForm.$element;
        onContentRefreshedCallback && onContentRefreshedCallback(quickFormElement);
    };
    const onValidationError = ()=>{
        const quickForm = dialog.getQuickForm();
        const quickFormElement = quickForm.$element;
        onContentRefreshedCallback && onContentRefreshedCallback(quickFormElement);
    };
    const onRender = ()=>{
        const quickForm = dialog.getQuickForm();
        const quickFormElement = quickForm.$element;
        $('label.qf-create-another', quickFormElement).remove();
        if (hideConfigureFields) $('.qf-form-operations', quickFormElement).remove();
        if (cancelAllLink !== undefined) {
            $('.form-footer .buttons', quickFormElement).append(cancelAllLink);
            cancelAllLink.on('click', ()=>{
                const undim = true;
                dialog.hide(undim, {
                    reason: 'cancel-all'
                });
                dialog.destroy();
            });
        }
        onRenderCallback && onRenderCallback(dialog.$popup);
        $0d9f751355f8b71f$var$bind(form.configurableForm, 'issueCreated', onIssueCreated);
        $0d9f751355f8b71f$var$bind(form.unconfigurableForm, 'issueCreated', onIssueCreated);
        $0d9f751355f8b71f$var$bind(form.configurableForm, 'validationError', onValidationError);
        $0d9f751355f8b71f$var$bind(form.unconfigurableForm, 'validationError', onValidationError);
        $0d9f751355f8b71f$var$unbind(form, 'configurableFormRendered', onRender);
        $0d9f751355f8b71f$var$unbind(form, 'unconfigurableFormRendered', onRender);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDialogHide = (event, dialogObj, reason)=>{
        if (event && event.isDefaultPrevented()) return;
        let reasonValue = reason;
        if (reasonValue === 'esc') reasonValue = 'cancel';
        $0d9f751355f8b71f$var$unbind(form.configurableForm, 'issueCreated', onIssueCreated);
        $0d9f751355f8b71f$var$unbind(form.unconfigurableForm, 'issueCreated', onIssueCreated);
        $0d9f751355f8b71f$var$unbind(form.configurableForm, 'validationError', onValidationError);
        $0d9f751355f8b71f$var$unbind(form.unconfigurableForm, 'validationError', onValidationError);
        $0d9f751355f8b71f$var$unbind(form, 'configurableFormRendered', onRender);
        $0d9f751355f8b71f$var$unbind(form, 'unconfigurableFormRendered', onRender);
        $0d9f751355f8b71f$var$unbind(form, 'contentRefreshed', onContentRefreshed);
        $0d9f751355f8b71f$var$unbind(dialogObj, 'Dialog.hide', onDialogHide);
        $0d9f751355f8b71f$var$unbind(document, 'QuickCreateIssueInEpic.validationError', onValidationError);
        if (JIRA.EpicPicker) $0d9f751355f8b71f$var$unbind(document, JIRA.EpicPicker.READY_EVENT);
        if (cancelAllLink) cancelAllLink.off('click');
        if (reasonValue === 'cancel' || reasonValue === 'cancel-all') deferred.reject({
            reason: reasonValue
        });
        else deferred.reject({
            type: 'cancel-operation-unknown'
        });
    };
    $0d9f751355f8b71f$var$bind(form, 'configurableFormRendered', onRender);
    $0d9f751355f8b71f$var$bind(form, 'unconfigurableFormRendered', onRender);
    $0d9f751355f8b71f$var$bind(form, 'contentRefreshed', onContentRefreshed);
    $0d9f751355f8b71f$var$bind(dialog, 'Dialog.hide', onDialogHide);
    dialog.show();
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9f751355f8b71f$export$2e2bcd8739ae039 = {
    showDialog: $0d9f751355f8b71f$var$showDialog
};

});
parcelRegister("1GoEI", function(module, exports) {

$parcel$export(module.exports, "getJquery", () => $d6b5f934fdadce70$export$6c7e070cd85c6c57);
$parcel$export(module.exports, "getUnderscore", () => $d6b5f934fdadce70$export$2243344b1bb4828d);
$parcel$export(module.exports, "getJira", () => $d6b5f934fdadce70$export$57a8ce65afe89b19);
$parcel$export(module.exports, "getAjs", () => $d6b5f934fdadce70$export$5f49845c47c8d9ba);

var $7CnHa = parcelRequire("7CnHa");
/* This a workaround for the following problem:
https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/development/summary-legacy/src/test-util/mock-dev-detail-dependencies.js
mocks `window.require` and expects the second parameter to be mandatory and to be a function.
At the same time `window.require` which is called by Portfolio at runtime have the second parameter
optional but when it's provided it's expected to be a string which is then split.
*/ // eslint-disable-next-line @typescript-eslint/no-empty-function
const $d6b5f934fdadce70$var$callback = ()=>{};
$d6b5f934fdadce70$var$callback.split = ()=>[];
// @ts-expect-error TS2769 - No overload matches this call.
const $d6b5f934fdadce70$var$getJqueryValue = ()=>window && window.require && window.require('jquery', $d6b5f934fdadce70$var$callback);
// @ts-expect-error - TS2769 - No overload matches this call.
const $d6b5f934fdadce70$var$getUnderscoreValue = ()=>window && window.require && window.require('underscore', $d6b5f934fdadce70$var$callback);
const $d6b5f934fdadce70$var$getJiraValue = ()=>window && window.JIRA;
const $d6b5f934fdadce70$var$getAjsValue = ()=>window && window.AJS;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d6b5f934fdadce70$var$getGlobal = (getValue)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let value;
    return ()=>{
        if (!(0, $7CnHa.isDefined)(value)) value = getValue();
        return value;
    };
};
const $d6b5f934fdadce70$export$6c7e070cd85c6c57 = $d6b5f934fdadce70$var$getGlobal($d6b5f934fdadce70$var$getJqueryValue);
const $d6b5f934fdadce70$export$2243344b1bb4828d = $d6b5f934fdadce70$var$getGlobal($d6b5f934fdadce70$var$getUnderscoreValue);
const $d6b5f934fdadce70$export$57a8ce65afe89b19 = $d6b5f934fdadce70$var$getGlobal($d6b5f934fdadce70$var$getJiraValue);
const $d6b5f934fdadce70$export$5f49845c47c8d9ba = $d6b5f934fdadce70$var$getGlobal($d6b5f934fdadce70$var$getAjsValue);

});


parcelRegister("gYC20", function(module, exports) {

$parcel$export(module.exports, "default", () => $934bbf73be81015a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $934bbf73be81015a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredFieldsDialogTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.required-fields-dialog.uncontrolled-legacy-dialog.required-fields-dialog-title",
        "defaultMessage": "Set required fields"
    }
});

});



parcelRegister("9zkwU", function(module, exports) {

$parcel$export(module.exports, "getOpenIssueCreateModalPayload", () => $69aaf5c71b3f5ff1$export$72c3f78108cf2fcc);

var $a0i0f = parcelRequire("a0i0f");

var $guiFP = parcelRequire("guiFP");

var $8YqJS = parcelRequire("8YqJS");
var $l2Sj2 = parcelRequire("l2Sj2");

var $gUMnJ = parcelRequire("gUMnJ");

var $5rVFi = parcelRequire("5rVFi");

var $5rYNM = parcelRequire("5rYNM");
const $69aaf5c71b3f5ff1$var$timestampToFormattedDate = (timestampValue)=>timestampValue != null && (0, $l2Sj2.formatDateUTC)(timestampValue, 'YYYY-MM-DD');
const $69aaf5c71b3f5ff1$var$isCustomFieldKey = (key)=>key.startsWith('customField');
const $69aaf5c71b3f5ff1$export$cefe233909b19f98 = (payload)=>(0, $5rVFi.default)((0, $gUMnJ.urls).getDescription, {
        method: 'POST',
        body: {
            ...payload,
            renderRaw: true
        }
    }).then((response)=>response.json());
// Maps custom field to the type similar to src/packages/issue-create/new-issue-create-trigger/src/constants.tsx
const $69aaf5c71b3f5ff1$var$CUSTOM_FIELD_MAP = {
    [(0, $5rYNM.CustomFieldTypes).DatePicker]: 'datePickerFields',
    [(0, $5rYNM.CustomFieldTypes).TextField]: 'singleLineTextFields',
    [(0, $5rYNM.CustomFieldTypes).UserPicker]: 'singleSelectUserPickerFields',
    [(0, $5rYNM.CustomFieldTypes).NumberField]: 'numberFields',
    [(0, $5rYNM.CustomFieldTypes).MultiSelect]: 'multipleSelectFields',
    [(0, $5rYNM.CustomFieldTypes).Labels]: 'labelsFields',
    /**
	 * Unsupported in ARJ with new issues
	 */ // Gic doesn't seem to have an option to show this but we will pass it through anyway incase they support it one day
    [(0, $5rYNM.CustomFieldTypes).MultiCheckboxes]: 'multipleSelectFields',
    // New issues cannot have single select fields (drop down wont populate)
    [(0, $5rYNM.CustomFieldTypes).SingleSelect]: 'singleSelectFields',
    // New issues cannot have radio select fields (drop down wont populate)
    [(0, $5rYNM.CustomFieldTypes).RadioButtons]: 'singleSelectFields',
    // New issues cannot have url (read-only) field
    [(0, $5rYNM.CustomFieldTypes).Url]: 'urlFields'
};
const $69aaf5c71b3f5ff1$var$transformCustomFieldKey = (ckey)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ckey?.replace(/customFieldValueAdded-|customFieldValueRemoved-|customField-/gi, 'customfield_');
const $69aaf5c71b3f5ff1$export$72c3f78108cf2fcc = async ({ issue: issue, agileConfig: agileConfig, issueTypesById: issueTypesById, planInfo: planInfo, teamsById: teamsById, startDateCustomField: startDateCustomField, parentIssue: parentIssue, isIssueSimplified: isIssueSimplified }, // DI for testing easier than jest mock
fetchDescription = $69aaf5c71b3f5ff1$export$cefe233909b19f98)=>{
    const { epicLinkField: epicLinkField, storyPointsField: storyPointsField, sprintsField: sprintsField, storyPointEstimateField: storyPointEstimateField, targetStartField: targetStartField, targetEndField: targetEndField, teamField: teamField } = agileConfig;
    const { values: values } = issue;
    const { type: type, project: project } = values;
    // Do nothing if its NaN
    if (type == null) throw Error('Error opening GIC, no issue type');
    const isSubTask = !!issueTypesById[type]?.subTask;
    const payload = Object.entries(values).reduce((result, [key, val])=>{
        /**
			 * Custom Field
			 */ // Not possible, type hinting
        if (!result.defaultValues || !result.customFieldsToPreserveOnFormRecreation) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return result;
        // Dont handle empty values
        if (val == null) return result;
        if ($69aaf5c71b3f5ff1$var$isCustomFieldKey(key)) {
            // We dont prefill removed multi-select values
            if (key.includes('customFieldValueRemoved')) return result;
            const { id: customFieldId, typeKey: typeKey = '', value: customFieldValue } = val; // eslint-disable-line @typescript-eslint/consistent-type-assertions
            // Don't handle empty values
            if (customFieldValue == null) return result;
            const fieldType = $69aaf5c71b3f5ff1$var$CUSTOM_FIELD_MAP[typeKey];
            // No mapper found unsupported
            // There could actually be things we dont support, which we will need to silence the error
            if (!fieldType) {
                (0, $guiFP.default)({
                    meta: {
                        id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).GIC,
                        packageName: (0, $5rYNM.PACKAGE_NAME),
                        teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
                    },
                    error: new Error(`Unsupported custom field ${typeKey}`),
                    sendToPrivacyUnsafeSplunk: false
                });
                return result;
            }
            const newVal = (()=>{
                switch(fieldType){
                    case 'singleLineTextFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            text: customFieldValue
                        };
                    case 'datePickerFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            date: {
                                formattedDate: $69aaf5c71b3f5ff1$var$timestampToFormattedDate(// Date picker values are always number
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                customFieldValue)
                            }
                        };
                    case 'singleSelectUserPickerFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            user: {
                                accountId: customFieldValue
                            }
                        };
                    case 'numberFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            value: customFieldValue
                        };
                    case 'singleSelectFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            option: {
                                optionId: customFieldValue
                            }
                        };
                    case 'multipleSelectFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            options: Array.isArray(customFieldValue) ? customFieldValue.map((val)=>({
                                    optionId: val
                                })) : [
                                {
                                    optionId: customFieldValue
                                }
                            ]
                        };
                    case 'urlFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            url: customFieldValue
                        };
                    case 'labelsFields':
                        return {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(key),
                            labels: Array.isArray(customFieldValue) ? customFieldValue.map((val)=>({
                                    name: val
                                })) : [
                                {
                                    name: customFieldValue
                                }
                            ]
                        };
                    default:
                        return result;
                }
            })();
            if (!newVal) return result;
            // Add the values
            result.customFieldsToPreserveOnFormRecreation.push(`customfield_${customFieldId}`);
            // eslint-disable-next-line no-param-reassign
            result.defaultValues[fieldType] = (result.defaultValues[fieldType] || []).concat(newVal);
            return result;
        }
        /**
			 * Non Custom Field, basically all bespoke handling
			 */ switch(key){
            case 'summary':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.singleLineTextFields = (result.defaultValues.singleLineTextFields || []).concat({
                    fieldId: key,
                    text: val
                });
                break;
            case 'storyPoints':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.numberFields = (result.defaultValues.numberFields || []).concat({
                    fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    isIssueSimplified ? storyPointEstimateField : storyPointsField),
                    value: val
                });
                break;
            case 'dueDate':
                if (typeof val === 'number' || typeof val === 'string') // eslint-disable-next-line no-param-reassign
                result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                    // Lower case
                    fieldId: 'duedate',
                    date: {
                        formattedDate: $69aaf5c71b3f5ff1$var$timestampToFormattedDate(val)
                    }
                });
                break;
            case 'startDate':
                if (typeof val === 'number' || typeof val === 'string') // eslint-disable-next-line no-param-reassign
                result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                    // Lower case
                    fieldId: startDateCustomField ? `customField-${startDateCustomField.id}` : 'startdate',
                    date: {
                        formattedDate: $69aaf5c71b3f5ff1$var$timestampToFormattedDate(val)
                    }
                });
                break;
            case 'targetStart':
            case 'targetEnd':
                {
                    if (!(typeof val === 'number' || typeof val === 'string')) break;
                    const fieldIdKey = key === 'targetStart' ? targetStartField : targetEndField;
                    // eslint-disable-next-line no-param-reassign
                    result.defaultValues.datePickerFields = (result.defaultValues.datePickerFields || []).concat({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(fieldIdKey),
                        date: {
                            formattedDate: $69aaf5c71b3f5ff1$var$timestampToFormattedDate(val)
                        }
                    });
                    break;
                }
            case 'sprint':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.sprintsField = {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(sprintsField),
                    sprints: Array.isArray(val) ? val.map((sprint)=>({
                            sprintId: sprint
                        })) : [
                        {
                            sprintId: val
                        }
                    ]
                };
                break;
            case 'assignee':
            case 'reporter':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.singleSelectUserPickerFields = (result.defaultValues.singleSelectUserPickerFields || []).concat({
                    fieldId: key,
                    user: {
                        accountId: val
                    }
                });
                break;
            case 'parent':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.parentField = {
                    issueId: val
                };
                if (isSubTask && val != null) // We only want to send parentId when the issue is a subtask
                // If we send parentId when the issue is an epic, the modal
                // will not allow creation of the epic issue due to rules
                // imposed by the GIC team
                // eslint-disable-next-line no-param-reassign
                result.parentId = {
                    parentId: String(val)
                };
                break;
            case 'labels':
                {
                    const labelValue = {
                        fieldId: key,
                        labels: Array.isArray(val) ? val.map((label)=>({
                                name: label
                            })) : [
                            {
                                name: val
                            }
                        ]
                    };
                    // eslint-disable-next-line no-param-reassign
                    result.defaultValues.labelsFields = Array.isArray(result.defaultValues.labelsFields) ? result.defaultValues.labelsFields.concat(labelValue) : [
                        labelValue
                    ];
                    break;
                }
            case 'fixVersions':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.multipleVersionPickerFields = {
                    fieldId: key,
                    versions: Array.isArray(val) ? val.map((sprint)=>({
                            versionId: sprint
                        })) : [
                        {
                            versionId: val
                        }
                    ]
                };
                break;
            case 'components':
                // eslint-disable-next-line no-param-reassign
                result.defaultValues.components = Array.isArray(val) ? val.map((val)=>({
                        componentId: val
                    })) : [
                    {
                        componentId: val
                    }
                ];
                break;
            case 'team':
                // Set team value for plan already migrated to TWP
                if (planInfo.useTwpTeams) {
                    const team = values.team ? teamsById[values.team] : null;
                    // For plan only team, teamId is set to empty as it doesn't exist on GIC team field
                    const teamId = team && team.externalId ? team.externalId : '';
                    const teamVal = {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(teamField),
                        team: {
                            teamId: teamId
                        }
                    };
                    // eslint-disable-next-line no-param-reassign
                    result.defaultValues.atlassianTeamFields = teamVal;
                } else {
                    // Set team value for plan not yet migrated to TWP
                    const teamVal = {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(teamField),
                        option: {
                            optionId: values.team
                        }
                    };
                    // eslint-disable-next-line no-param-reassign
                    result.defaultValues.singleSelectFields = (result.defaultValues.singleSelectFields || []).concat(teamVal);
                }
                break;
            // Things unhandled or handled else where
            case 'type':
            case 'project':
            case 'lexoRank':
            case 'issueLink':
            case 'description':
            case 'color':
            default:
                break;
        }
        return result;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {
        defaultValues: {},
        customFieldsToPreserveOnFormRecreation: []
    });
    /**
	 * Handle the rest of the meta data
	 */ payload.issueType = {
        issueTypeId: String(type)
    };
    if (project) payload.project = {
        projectId: String(project)
    };
    if (values.description) {
        const { value: value } = await fetchDescription({
            planId: planInfo.id,
            scenarioId: planInfo.currentScenarioId,
            itemKey: issue.id
        });
        const descriptionVal = {
            fieldId: 'description',
            richText: {
                wikiText: value
            }
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(payload, 'defaultValues.richTextFields', Array.isArray(payload.defaultValues?.richTextFields) ? payload.defaultValues?.richTextFields.concat(descriptionVal) : [
            descriptionVal
        ]);
    }
    if (parentIssue?.hierarchyLevel === (0, $8YqJS.EPIC_LEVEL)) (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(payload, 'defaultValues.epicLinkField', {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fieldId: $69aaf5c71b3f5ff1$var$transformCustomFieldKey(epicLinkField),
        epicLink: {
            issueKey: parentIssue.key
        }
    });
    return {
        payload: payload,
        isSubTask: isSubTask
    };
};

});



parcelRegister("5OXJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f57d8b00c51b21d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dw8TK = parcelRequire("dw8TK");

var $knKv2 = parcelRequire("knKv2");

var $jOYEo = parcelRequire("jOYEo");
const $1f57d8b00c51b21d$var$ReviewChangesButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ currentScenarioColor: currentScenarioColor, changesCount: changesCount, isOptimizing: isOptimizing, isOptimized: isOptimized, isReadOnly: isReadOnly, openDialog: openDialog }, ref)=>{
    const [hasCountChanged, setHasCountChanged] = (0, $eUqFw.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(false);
    const toggleSetHasCountChanged = (0, $eUqFw.useCallback)(()=>setHasCountChanged(true), []);
    const activateSpotlight = (0, $eUqFw.useCallback)(()=>setIsSpotlightActive(true), []);
    const closeSpotlight = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const handleOpenDialog = (0, $eUqFw.useCallback)((e)=>{
        if (isSpotlightActive && hasCountChanged) setIsSpotlightActive(false);
        openDialog(e);
    }, [
        isSpotlightActive,
        openDialog,
        setIsSpotlightActive,
        hasCountChanged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOYEo.default), {
        changesCount: changesCount,
        onCountChanged: toggleSetHasCountChanged
    }), !(isOptimizing || isOptimized || isReadOnly) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyR",
        onKeyDown: handleOpenDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knKv2.default), {
        ref: ref,
        hasCountChanged: hasCountChanged,
        isSpotlightActive: isSpotlightActive,
        openDialog: handleOpenDialog,
        closeSpotlight: closeSpotlight,
        activateSpotlight: activateSpotlight,
        currentScenarioColor: currentScenarioColor,
        changesCount: changesCount,
        isOptimizing: isOptimizing
    }));
});
var $1f57d8b00c51b21d$export$2e2bcd8739ae039 = $1f57d8b00c51b21d$var$ReviewChangesButtonWrapper;

});
parcelRegister("knKv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7f8c0dda30690a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $6zOB7 = parcelRequire("6zOB7");

var $8Wt6T = parcelRequire("8Wt6T");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $gwbfD = parcelRequire("gwbfD");

var $j4LwV = parcelRequire("j4LwV");

var $33N5G = parcelRequire("33N5G");

var $6gjgQ = parcelRequire("6gjgQ");

var $iuPJs = parcelRequire("iuPJs");
const $ee7f8c0dda30690a$var$ReviewChangesButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ hasCountChanged: hasCountChanged, changesCount: changesCount, isSpotlightActive: isSpotlightActive, isOptimizing: isOptimizing, currentScenarioColor: currentScenarioColor, openDialog: openDialog, closeSpotlight: closeSpotlight, activateSpotlight: activateSpotlight }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: popperRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j4LwV.default), {
                letter: "R"
            }),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ee7f8c0dda30690a$var$buttonContainerStyles,
            ref: popperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Wt6T.Pulse), {
            radius: 4,
            pulse: hasCountChanged && isSpotlightActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            onClick: openDialog,
            isDisabled: isOptimizing,
            appearance: "primary",
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-button",
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ee7f8c0dda30690a$var$buttonLabelStyles
        }, formatMessage((0, $6gjgQ.default).updateJiraButtonText), changesCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $ee7f8c0dda30690a$var$changeCountBadgeStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            style: {
                backgroundColor: currentScenarioColor,
                color: currentScenarioColor ? (0, $33N5G.colourPaletteTextColoursMap)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Ignored via go/DSP-18766
                currentScenarioColor] || `var(--ds-text-inverse, ${(0, $g4Vkx.default).N0})` : `var(--ds-text-inverse, ${(0, $g4Vkx.default).N0})`
            },
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.change-count"
        }, changesCount)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), {
        placement: "bottom-end"
    }, ({ ref: popperRef, style: style })=>hasCountChanged ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: popperRef,
            style: style,
            xcss: $ee7f8c0dda30690a$var$spotlightContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iuPJs.default), {
            closeSpotlight: closeSpotlight,
            activateSpotlight: activateSpotlight,
            isSpotlightActive: isSpotlightActive
        })) : null));
});
const $ee7f8c0dda30690a$var$buttonLabelStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $ee7f8c0dda30690a$var$changeCountBadgeStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginTop: '0',
    marginRight: 'space.025',
    marginLeft: 'space.075',
    marginBottom: '0',
    outline: 0,
    borderRadius: '2em'
});
const $ee7f8c0dda30690a$var$buttonContainerStyles = (0, $1ZAYh.xcss)({
    width: 'min-content'
});
const $ee7f8c0dda30690a$var$spotlightContainerStyles = (0, $1ZAYh.xcss)({
    zIndex: 'spotlight'
});
var $ee7f8c0dda30690a$export$2e2bcd8739ae039 = $ee7f8c0dda30690a$var$ReviewChangesButton;

});
parcelRegister("6gjgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae09b593cd8dcfb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9ae09b593cd8dcfb$var$messages = (0, $90IgZ.defineMessages)({
    updateJiraButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.update-jira-button-text",
        "defaultMessage": "Unsaved changes"
    }
});
var $9ae09b593cd8dcfb$export$2e2bcd8739ae039 = $9ae09b593cd8dcfb$var$messages;

});

parcelRegister("iuPJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $99715522baa86db6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $cWiVr = parcelRequire("cWiVr");

var $fQBRm = parcelRequire("fQBRm");
const $99715522baa86db6$export$709a19d72c2ee36f = 'jira.user.plans.review-changes.onboarding';
const $99715522baa86db6$var$getUserPropertyEndpoint = (accountId)=>`/rest/api/3/user/properties/${$99715522baa86db6$export$709a19d72c2ee36f}?accountId=${accountId}`;
const $99715522baa86db6$var$ReviewChangesSpotlightManager = ({ closeSpotlight: closeSpotlight, activateSpotlight: activateSpotlight, isSpotlightActive: isSpotlightActive })=>{
    const { data: { user: { accountId: accountId } } } = (0, $cWiVr.useCurrentUser)();
    const getUserProperty = (0, $eUqFw.useCallback)(()=>(0, $lRmyA.performGetRequest)($99715522baa86db6$var$getUserPropertyEndpoint(accountId ?? '')), [
        accountId
    ]);
    const updateUserProperty = (0, $eUqFw.useCallback)((timestamp)=>(0, $lRmyA.performPutRequest)($99715522baa86db6$var$getUserPropertyEndpoint(accountId ?? ''), {
            body: JSON.stringify({
                timestamp: timestamp
            })
        }), [
        accountId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        getUserProperty().then((userProperty)=>{
            if (!userProperty?.value?.timestamp) activateSpotlight();
        }).catch((error)=>{
            if (error?.statusCode === 404) activateSpotlight();
        });
    }, [
        activateSpotlight,
        getUserProperty
    ]);
    return isSpotlightActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQBRm.default), {
        closeSpotlight: closeSpotlight,
        updateUserProperty: updateUserProperty
    }) : null;
};
var $99715522baa86db6$export$2e2bcd8739ae039 = $99715522baa86db6$var$ReviewChangesSpotlightManager;

});
parcelRegister("fQBRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca0ca4af17c375a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $g9Oms = parcelRequire("g9Oms");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cuuJa = parcelRequire("cuuJa");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $eQX6h = parcelRequire("eQX6h");
const $eca0ca4af17c375a$var$ReviewChangesSpotlight = ({ closeSpotlight: closeSpotlight, updateUserProperty: updateUserProperty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        updateUserProperty(Date.now());
    }, [
        updateUserProperty
    ]);
    const handleCloseDialog = (_, analyticsEvent)=>{
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLOSE_UNSAVED_CHANGES_SPOTLIGHT.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: action,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLOSE_UNSAVED_CHANGES_SPOTLIGHT);
        closeSpotlight();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "reviewChangesSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            appearance: "subtle",
            label: formatMessage((0, $eQX6h.default).closeSpotlight),
            spacing: "compact",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($02Sz7))), {
                    ...iconProps,
                    color: "var(--ds-icon-inverse, #FFFFFF)"
                }),
            onClick: handleCloseDialog,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.selected-field-remove-button"
        }),
        heading: formatMessage((0, $eQX6h.default).updateJiraSpotlightTitle)
    }, formatMessage((0, $eQX6h.default).updateJiraSpotlightBody)));
};
var $eca0ca4af17c375a$export$2e2bcd8739ae039 = $eca0ca4af17c375a$var$ReviewChangesSpotlight;

});
parcelRegister("eQX6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9e1c8a849ce427$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ed9e1c8a849ce427$var$messages = (0, $90IgZ.defineMessages)({
    updateJiraSpotlightTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.update-jira-spotlight-title",
        "defaultMessage": "Your plan has unsaved changes"
    },
    updateJiraSpotlightBody: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.update-jira-spotlight-body",
        "defaultMessage": "Save issues created or changed in your plan so they update in your projects."
    },
    closeSpotlight: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.review-changes-button-wrapper.review-changes-button.review-changes-spotlight-manager.review-changes-spotlight.close-spotlight",
        "defaultMessage": "Close unsaved changes spotlight"
    }
});
var $ed9e1c8a849ce427$export$2e2bcd8739ae039 = $ed9e1c8a849ce427$var$messages;

});




parcelRegister("jOYEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad7924111916075$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $aad7924111916075$var$SpotlightChangesCountMonitor = /*#__PURE__*/ (0, $eUqFw.memo)(({ changesCount: changesCount, onCountChanged: onCountChanged })=>{
    const prevChangesCount = (0, $eUqFw.useRef)(changesCount);
    (0, $eUqFw.useEffect)(()=>{
        if (changesCount !== 0 && changesCount !== prevChangesCount.current) onCountChanged(changesCount);
        prevChangesCount.current = changesCount;
    }, [
        changesCount,
        onCountChanged
    ]);
    return null;
});
var $aad7924111916075$export$2e2bcd8739ae039 = $aad7924111916075$var$SpotlightChangesCountMonitor;

});


parcelRegister("fCQQJ", function(module, exports) {

$parcel$export(module.exports, "body", () => $b603666d20b387fe$export$32180ef41b15b513, (v) => $b603666d20b387fe$export$32180ef41b15b513 = v);
$parcel$export(module.exports, "button-label", () => $b603666d20b387fe$export$fe7e0a090115fdda, (v) => $b603666d20b387fe$export$fe7e0a090115fdda = v);
$parcel$export(module.exports, "changeCountBadge", () => $b603666d20b387fe$export$187bfbaba8563c7b, (v) => $b603666d20b387fe$export$187bfbaba8563c7b = v);
$parcel$export(module.exports, "dialogContent", () => $b603666d20b387fe$export$1a09c8e9a482a512, (v) => $b603666d20b387fe$export$1a09c8e9a482a512 = v);
$parcel$export(module.exports, "filters", () => $b603666d20b387fe$export$82462a21aead86ed, (v) => $b603666d20b387fe$export$82462a21aead86ed = v);
$parcel$export(module.exports, "footerParent", () => $b603666d20b387fe$export$dc0b18c34163d3d8, (v) => $b603666d20b387fe$export$dc0b18c34163d3d8 = v);
$parcel$export(module.exports, "header", () => $b603666d20b387fe$export$38e42c68cf43b5d4, (v) => $b603666d20b387fe$export$38e42c68cf43b5d4 = v);
$parcel$export(module.exports, "out-of-sync", () => $b603666d20b387fe$export$3ee20dc3519c4984, (v) => $b603666d20b387fe$export$3ee20dc3519c4984 = v);
$parcel$export(module.exports, "out-of-sync-message", () => $b603666d20b387fe$export$b66d7f757063937e, (v) => $b603666d20b387fe$export$b66d7f757063937e = v);
$parcel$export(module.exports, "spinner", () => $b603666d20b387fe$export$641374ffb95bc399, (v) => $b603666d20b387fe$export$641374ffb95bc399 = v);
$parcel$export(module.exports, "title", () => $b603666d20b387fe$export$fb184b623420d9be, (v) => $b603666d20b387fe$export$fb184b623420d9be = v);
$parcel$export(module.exports, "updateJiraButton", () => $b603666d20b387fe$export$cca14117b277a7bc, (v) => $b603666d20b387fe$export$cca14117b277a7bc = v);
var $b603666d20b387fe$export$32180ef41b15b513;
var $b603666d20b387fe$export$fe7e0a090115fdda;
var $b603666d20b387fe$export$187bfbaba8563c7b;
var $b603666d20b387fe$export$1a09c8e9a482a512;
var $b603666d20b387fe$export$82462a21aead86ed;
var $b603666d20b387fe$export$dc0b18c34163d3d8;
var $b603666d20b387fe$export$38e42c68cf43b5d4;
var $b603666d20b387fe$export$3ee20dc3519c4984;
var $b603666d20b387fe$export$b66d7f757063937e;
var $b603666d20b387fe$export$641374ffb95bc399;
var $b603666d20b387fe$export$fb184b623420d9be;
var $b603666d20b387fe$export$cca14117b277a7bc;
$b603666d20b387fe$export$32180ef41b15b513 = `pHrIna_body`;
$b603666d20b387fe$export$fe7e0a090115fdda = `pHrIna_button-label`;
$b603666d20b387fe$export$187bfbaba8563c7b = `pHrIna_changeCountBadge`;
$b603666d20b387fe$export$1a09c8e9a482a512 = `pHrIna_dialogContent`;
$b603666d20b387fe$export$82462a21aead86ed = `pHrIna_filters`;
$b603666d20b387fe$export$dc0b18c34163d3d8 = `pHrIna_footerParent`;
$b603666d20b387fe$export$38e42c68cf43b5d4 = `pHrIna_header`;
$b603666d20b387fe$export$3ee20dc3519c4984 = `pHrIna_out-of-sync`;
$b603666d20b387fe$export$b66d7f757063937e = `pHrIna_out-of-sync-message`;
$b603666d20b387fe$export$641374ffb95bc399 = `pHrIna_spinner`;
$b603666d20b387fe$export$fb184b623420d9be = `pHrIna_title`;
$b603666d20b387fe$export$cca14117b277a7bc = `pHrIna_updateJiraButton`;

});



parcelRegister("1qPld", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3f0bee2dc24929$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

var $lNNXV = parcelRequire("lNNXV");

var $5JKRf = parcelRequire("5JKRf");

var $8NYxR = parcelRequire("8NYxR");
const $9f3f0bee2dc24929$var$mapDispatchToProps = (dispatch)=>({
        clearAllFilters: ()=>{
            dispatch((0, $296Gg.clearAll)());
        }
    });
var $9f3f0bee2dc24929$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5JKRf.default), $9f3f0bee2dc24929$var$mapDispatchToProps)((0, $8NYxR.default));

});
parcelRegister("5JKRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc47fb0e09139e78$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");

var $fiZs1 = parcelRequire("fiZs1");

var $dhHiZ = parcelRequire("dhHiZ");

var $iK4oF = parcelRequire("iK4oF");
var $fc47fb0e09139e78$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    customFieldsWithFilteringAllowed: (0, $fiZs1.getCustomFieldsWithFilteringAllowed),
    filtersAppliedCount: (0, $fbHoQ.getFilterCount),
    isAtlasConnectInstalled: $dhHiZ.isAtlasConnectInstalled
});

});

parcelRegister("8NYxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $75cd062b273eba12$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $6Pq2D = parcelRequire("6Pq2D");

var $9nkwJ = parcelRequire("9nkwJ");

var $4ki2H = parcelRequire("4ki2H");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $2KzVh = parcelRequire("2KzVh");

var $aAyrO = parcelRequire("aAyrO");
parcelRequire("aYCQt");
parcelRequire("2c08V");
parcelRequire("imCER");
parcelRequire("bRpYp");
parcelRequire("2vV9U");
parcelRequire("gqs5m");
parcelRequire("5Rz3d");
parcelRequire("68BNT");
parcelRequire("3nT5G");
parcelRequire("f436g");
parcelRequire("7hbkF");
parcelRequire("5mAJ1");
parcelRequire("77IHm");
parcelRequire("3Fte6");


var $h2lUi = parcelRequire("h2lUi");

var $fm06g = parcelRequire("fm06g");

var $jsydY = parcelRequire("jsydY");

var $7IziM = parcelRequire("7IziM");

var $k8GBh = parcelRequire("k8GBh");

var $9didO = parcelRequire("9didO");

var $kCWNj = parcelRequire("kCWNj");

var $eLSVD = parcelRequire("eLSVD");

var $8WXPA = parcelRequire("8WXPA");

var $9UH7i = parcelRequire("9UH7i");

var $4Hv8J = parcelRequire("4Hv8J");

var $2XBb4 = parcelRequire("2XBb4");

var $6g33d = parcelRequire("6g33d");

var $5gTDp = parcelRequire("5gTDp");

var $fRTqhI = parcelRequire("fRTqhI");

var $hlsFw = parcelRequire("hlsFw");

var $aViBI = parcelRequire("aViBI");

var $abpxl = parcelRequire("abpxl");

var $2vNVG = parcelRequire("2vNVG");

var $88LTk = parcelRequire("88LTk");

var $foduK = parcelRequire("foduK");

var $lrSA8 = parcelRequire("lrSA8");
class $75cd062b273eba12$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            AssigneeFilter: (0, $9didO.default)((0, $h2lUi.default)),
            ComponentFilter: (0, $9didO.default)((0, $fm06g.default)),
            CustomFieldFilter: (0, $9didO.default)((0, $jsydY.default)),
            DependenciesFilter: (0, $9didO.default)((0, $k8GBh.default)),
            HierarchyFilter: $eLSVD.default,
            IssueTypesKeyFilter: (0, $9didO.default)((0, $9UH7i.default)),
            IssuePrioritiesFilter: (0, $9didO.default)((0, $8WXPA.default)),
            LabelFilter: (0, $9didO.default)((0, $2XBb4.default)),
            ProjectFilter: (0, $9didO.default)((0, $fRTqhI.default)),
            ReleaseFilter: (0, $9didO.default)((0, $hlsFw.default)),
            SprintFilter: (0, $9didO.default)((0, $abpxl.default)),
            StatusKeyFilter: (0, $9didO.default)((0, $2vNVG.default)),
            SummaryFilter: $foduK.default,
            TeamFilter: (0, $9didO.default)((0, $lrSA8.default)),
            ReporterFilter: (0, $9didO.default)((0, $aViBI.default)),
            GoalFilter: (0, $9didO.default)((0, $kCWNj.default)),
            DateRangeFilter: $7IziM.default,
            IssueWarningFilter: (0, $9didO.default)((0, $4Hv8J.default)),
            Options: $5gTDp.default
        };
    }
    render() {
        return this.renderFilters();
    }
    constructor(...args){
        super(...args);
        this.state = {
            inlineDialogContentEl: null,
            isMenuOpen: false,
            isOpen: !!this.props.isDefaultOpenMenu
        };
        this.buttonRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.onFiltersRender = (el)=>{
            if (this.state.inlineDialogContentEl) return;
            this.setState(()=>({
                    inlineDialogContentEl: el
                }));
        };
        this.onClose = ()=>{
            this.setState({
                isOpen: false
            }, ()=>{
                !this.state.isOpen && this.buttonRef.current?.focus();
            });
        };
        this.toggleOpen = ()=>{
            const { isOpen: isOpen, inlineDialogContentEl: inlineDialogContentEl } = this.state;
            this.setState({
                isOpen: !isOpen,
                inlineDialogContentEl: isOpen ? inlineDialogContentEl : null
            }, ()=>{
                !this.state.isOpen && this.buttonRef.current?.focus();
            });
        };
        this.renderTriggerButton = (triggerProps)=>{
            const { filtersAppliedCount: filtersAppliedCount } = this.props;
            const { ref: ref, ...restTriggerProps } = triggerProps || {
                ref: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                iconAfter: filtersAppliedCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                    appearance: "primary"
                }, filtersAppliedCount) : undefined,
                ...restTriggerProps,
                ref: (0, $2KzVh.mergeRefs)(this.buttonRef, ref),
                "aria-expanded": this.state.isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
                    label: ""
                }),
                isSelected: this.state.isOpen,
                onClick: this.toggleOpen,
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default).header));
        };
        this.renderStandardFieldsFilters = (setInitialFocusRef)=>{
            const { AssigneeFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            AssigneeFilter, ReporterFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            ReporterFilter, ComponentFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            ComponentFilter, DependenciesFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            DependenciesFilter, IssueTypesKeyFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            IssueTypesKeyFilter, IssuePrioritiesFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            IssuePrioritiesFilter, LabelFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            LabelFilter, ProjectFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            ProjectFilter, ReleaseFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            ReleaseFilter, SprintFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            SprintFilter, StatusKeyFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            StatusKeyFilter, SummaryFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            SummaryFilter, HierarchyFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            HierarchyFilter, TeamFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            TeamFilter, GoalFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            GoalFilter, DateRangeFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            DateRangeFilter, IssueWarningFilter: // eslint-disable-next-line @typescript-eslint/no-shadow
            IssueWarningFilter, isAtlasConnectInstalled: isAtlasConnectInstalled } = this.props;
            const { inlineDialogContentEl: inlineDialogContentEl } = this.state;
            const filters = [
                {
                    filter: HierarchyFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HierarchyFilter, null),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SummaryFilter, {
                        inputRef: setInitialFocusRef
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$e32eeae4866f112c])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReleaseFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$53e2f8996e102881])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TeamFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$8abe69ceb26771cd])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AssigneeFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$43596ee088b165a])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SprintFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssuePrioritiesFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d])
                },
                {
                    filter: IssueTypesKeyFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueTypesKeyFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$a8ec3260a009d752])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$6022538efc28a609])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LabelFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$7e257b719377371e])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DependenciesFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$a849f806e27a57e8])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ReporterFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$20140793a0aa2b3c])
                },
                {
                    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StatusKeyFilter, {
                        parentScrollContainer: inlineDialogContentEl
                    }),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$9b51ec1115932c53])
                }
            ];
            if (isAtlasConnectInstalled) // during clean up move it before issue priorities filter and after project filter
            filters.splice(7, 0, {
                filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GoalFilter, {
                    parentScrollContainer: inlineDialogContentEl
                }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$861e775e082be75a])
            });
            if ((0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k')) filters.push({
                filter: IssueWarningFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueWarningFilter, {
                    parentScrollContainer: inlineDialogContentEl
                }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$59af687b450af7eb])
            });
            filters.push({
                filter: DateRangeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DateRangeFilter, {
                    parentScrollContainer: inlineDialogContentEl
                }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default)[0, $12ee831723ccf9c2$export$82db1960569473ff])
            });
            return filters.map(({ filter: filter, label: label }, index)=>filter && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    key: index,
                    className: $88LTk.filterRow
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($88LTk.filterRowLabel, {
                        [$88LTk.hierarchyFilterLabel]: index === 0
                    })
                }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $88LTk.filterRowFilter
                }, filter)));
        };
        this.renderFilters = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { clearAllFilters: clearAllFilters, filtersAppliedCount: filtersAppliedCount, Options: Options } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
                content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $88LTk.filtersDialog
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $88LTk.filtersHeader
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                        appearance: "link",
                        interactionName: "arj-timeline-clear-all-filters",
                        isDisabled: !filtersAppliedCount,
                        onClick: clearAllFilters,
                        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.clear-all-filters"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6g33d.default).clearAllFiltersLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $88LTk.filtersList,
                        ref: this.onFiltersRender
                    }, this.renderStandardFieldsFilters(setInitialFocusRef), this.renderCustomFieldsFilters()), Options && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $88LTk.filterOptions
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Options, null)))),
                isOpen: this.state.isOpen,
                onClose: this.onClose,
                trigger: this.renderTriggerButton,
                shouldRenderToParent: true,
                role: "dialog",
                placement: "bottom-start"
            });
        };
        this.renderCustomFieldsFilters = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { CustomFieldFilter: CustomFieldFilter, customFieldsWithFilteringAllowed: customFieldsWithFilteringAllowed } = this.props;
            const { inlineDialogContentEl: inlineDialogContentEl } = this.state;
            return customFieldsWithFilteringAllowed.map((field)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    key: field.id,
                    className: $88LTk.filterRow
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $88LTk.filterRowLabel
                }, field.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $88LTk.filterRowFilter
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFieldFilter, {
                    field: field,
                    parentScrollContainer: inlineDialogContentEl
                }))));
        };
    }
}

});
parcelRegister("fm06g", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85353e7495dda13$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fiRcx = parcelRequire("fiRcx");

var $j2byJ = parcelRequire("j2byJ");

var $ehDEW = parcelRequire("ehDEW");
var $f85353e7495dda13$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $j2byJ.default), (0, $fiRcx.default))((0, $ehDEW.default));

});
parcelRegister("fiRcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d7ed46a26f0212$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("2c08V");
const $95d7ed46a26f0212$var$mapDispatchToProps = (dispatch)=>({
        changeFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$6022538efc28a609),
                value: payload
            }));
        },
        clearFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$6022538efc28a609)));
        }
    });
var $95d7ed46a26f0212$export$2e2bcd8739ae039 = $95d7ed46a26f0212$var$mapDispatchToProps;

});

parcelRegister("j2byJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d5c089bb75ea6e$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("2c08V");

var $ehEr2 = parcelRequire("ehEr2");
const $95d5c089bb75ea6e$var$mapStateToProps = (state)=>{
    const projects = (0, $ehEr2.getProjects)(state);
    const { [(0, $12ee831723ccf9c2$export$6022538efc28a609)]: { id: id, value: value } } = (0, $fbHoQ.getFilters)(state);
    return {
        id: id,
        value: value,
        projects: projects
    };
};
var $95d5c089bb75ea6e$export$2e2bcd8739ae039 = $95d5c089bb75ea6e$var$mapStateToProps;

});

parcelRegister("ehDEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $159d3ab41c30aefe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("2c08V");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $b1aFA = parcelRequire("b1aFA");
var $6uwgw = parcelRequire("6uwgw");

var $7CnHa = parcelRequire("7CnHa");

var $7Iub8 = parcelRequire("7Iub8");

var $eG0CY = parcelRequire("eG0CY");

var $17gIb = parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $e37IL = parcelRequire("e37IL");
// eslint-disable-next-line jira/react/no-class-components
class $159d3ab41c30aefe$var$ComponentFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearFilter: clearFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: clearFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $e37IL.default).searchComponentsPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $e37IL.default).searchComponentsLabel)
            }), this.renderProjectGroups()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.trigger-btn",
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { value: value, projects: projects } = this.props;
            return (0, $7CnHa.chain)(({ components: components })=>components || [], projects).filter(({ id: id })=>value.includes(id)).map(({ name: name })=>name).join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            const filterText = this.constructFilterText();
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e37IL.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Components, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$6022538efc28a609])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $e37IL.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isComponentSelected = (component)=>this.props.value.includes(component);
        this.onComponentClick = (clickedComponent)=>{
            const { value: value, changeFilter: changeFilter } = this.props;
            if (this.isComponentSelected(clickedComponent)) changeFilter(value.filter((component)=>component !== clickedComponent));
            else changeFilter([
                ...value,
                clickedComponent
            ]);
        };
        this.renderComponents = (components)=>components.map(({ id: id, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: `${id}`,
                    key: id,
                    isChecked: this.isComponentSelected(id),
                    onChange: ()=>this.onComponentClick(id),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        content: name,
                        id: id
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $17gIb.checkboxLabel
                    }, name))
                })));
        this.renderProjectGroups = ()=>{
            const filteredProjects = this.getFilteredProjects();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, filteredProjects.map(({ id: id, name: name, key: key, components: components, avatarUrl: avatarUrl })=>{
                const projectTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1aFA.default), {
                    avatarUrl: avatarUrl,
                    id: id,
                    projectKey: key,
                    name: name
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                    heading: projectTitle,
                    key: id
                }, this.renderComponents(components));
            }), filteredProjects.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
        };
        this.getFilteredProjects = ()=>{
            const { projects: projects } = this.props;
            const searchQuery = this.props.searchQuery.toLowerCase();
            const filteredProjects = [];
            for (const project of projects){
                const { components: components = [] } = project;
                const filteredComponents = components.filter(({ name: name })=>name.toLowerCase().includes(searchQuery));
                if (filteredComponents.length > 0) filteredProjects.push({
                    ...project,
                    components: filteredComponents
                });
            }
            return filteredProjects;
        };
    }
}
var $159d3ab41c30aefe$export$2e2bcd8739ae039 = (0, $2qhQi.default)($159d3ab41c30aefe$var$ComponentFilter);

});
parcelRegister("e37IL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a618ab6f35b6cfc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a618ab6f35b6cfc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchComponentsPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.search-components-placeholder",
        "defaultMessage": "Show issues from components"
    },
    searchComponentsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.component-filter.search-components-label",
        "defaultMessage": "Choose from components"
    }
});

});



parcelRegister("jsydY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2cd9be0d069d57$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $5rYNM = parcelRequire("5rYNM");

var $lYw6f = parcelRequire("lYw6f");

var $lbRDf = parcelRequire("lbRDf");

var $6Lgs5 = parcelRequire("6Lgs5");
function $5a2cd9be0d069d57$export$2e2bcd8739ae039({ field: field, parentScrollContainer: parentScrollContainer, ...filterItemHocProps }) {
    const fieldKey = field.type && field.type.key;
    switch(fieldKey){
        case (0, $5rYNM.CustomFieldTypes).Labels:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lYw6f.default), {
                customField: field,
                parentScrollContainer: parentScrollContainer,
                ...filterItemHocProps
            });
        case (0, $5rYNM.CustomFieldTypes).AssetObject:
        case (0, $5rYNM.CustomFieldTypes).MultiSelect:
            if (!(0, $cofZt.default)()) {
                if (fieldKey === (0, $5rYNM.CustomFieldTypes).AssetObject) return null;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbRDf.default), {
                customField: field,
                parentScrollContainer: parentScrollContainer,
                ...filterItemHocProps
            });
        case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
        case (0, $5rYNM.CustomFieldTypes).RadioButtons:
        case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Lgs5.default), {
                customField: field,
                parentScrollContainer: parentScrollContainer,
                ...filterItemHocProps
            });
        default:
            return null;
    }
}

});
parcelRegister("lYw6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbbfd81144803652$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6dGgK = parcelRequire("6dGgK");

var $ikC6Y = parcelRequire("ikC6Y");

var $5rpH4 = parcelRequire("5rpH4");
var $cbbfd81144803652$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $ikC6Y.default), (0, $6dGgK.default))((0, $5rpH4.default));

});
parcelRegister("6dGgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $59212eaed9a3a522$export$2e2bcd8739ae039);

var $cbq3D = parcelRequire("cbq3D");

var $8B14N = parcelRequire("8B14N");
const $59212eaed9a3a522$var$mapDispatchToProps = (dispatch, props)=>({
        onChange (value) {
            dispatch((0, $8B14N.update)({
                customField: props.customField,
                value: value
            }));
        },
        onRequestClear () {
            dispatch((0, $8B14N.clear)({
                customField: props.customField
            }));
        },
        genericError (payload) {
            dispatch((0, $cbq3D.genericError)(payload));
        }
    });
var $59212eaed9a3a522$export$2e2bcd8739ae039 = $59212eaed9a3a522$var$mapDispatchToProps;

});

parcelRegister("ikC6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $36df363bd9f6c96c$export$2e2bcd8739ae039);

var $kjklK = parcelRequire("kjklK");

var $fiZs1 = parcelRequire("fiZs1");

var $iK4oF = parcelRequire("iK4oF");
const $36df363bd9f6c96c$export$d9fe1e02b9e05ed7 = (state)=>state.domain.customLabelsByField;
const $36df363bd9f6c96c$var$getLabelsForField = (state, { customField: customField })=>$36df363bd9f6c96c$export$d9fe1e02b9e05ed7(state)[customField.id];
const $36df363bd9f6c96c$var$getValue = (state, { customField: customField })=>{
    const customFieldFilter = (0, $fiZs1.getCustomFieldFilter)(state);
    return $kjklK.default([
        'value',
        customField.id
    ], customFieldFilter) ?? [];
};
var $36df363bd9f6c96c$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    options: $36df363bd9f6c96c$var$getLabelsForField,
    value: $36df363bd9f6c96c$var$getValue
});

});

parcelRegister("5rpH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca16e74fbefd509$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $l7xwn = parcelRequire("l7xwn");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $fiZs1 = parcelRequire("fiZs1");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $jnxbR = parcelRequire("jnxbR");

var $7Iub8 = parcelRequire("7Iub8");

var $eG0CY = parcelRequire("eG0CY");

var $64sbN = parcelRequire("64sbN");
const $3ca16e74fbefd509$var$Label = ({ value: value = [], onOpenChange: onOpenChange, isOpen: isOpen, customField: customField, searchQuery: searchQuery, onQueryChange: onQueryChange, onRequestClear: onRequestClear, options: options = [], onChange: onChange })=>{
    const intl = (0, $5JgJ2.default)();
    const constructFilterText = ()=>{
        const noValueOption = $7d70y.default((0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID), value) ? [
            intl.formatMessage((0, $jnxbR.default).noValue)
        ] : [];
        const optionsText = options.filter((label)=>$7d70y.default(label, value));
        return noValueOption.concat(optionsText).join(', ');
    };
    const renderFilterText = ()=>{
        const filterText = constructFilterText();
        return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
            text: filterText
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jnxbR.default).emptyPlaceholder);
    };
    const isOptionSelected = (optionId)=>$7d70y.default(optionId, value);
    const handleOptionClick = (label)=>{
        const filtered = value.filter((opt)=>opt !== label);
        if (isOptionSelected(label)) onChange(filtered);
        else onChange([
            ...filtered,
            label
        ]);
    };
    const renderOptions = ()=>{
        const filteredOptions = $l7xwn.default((a, b)=>a.localeCompare(b), options.filter((option)=>option.toLowerCase().includes(searchQuery.toLowerCase())));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, filteredOptions.length > 0 && !searchQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
            key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            id: `${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`,
            key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
            isChecked: isOptionSelected(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
            onChange: ()=>handleOptionClick(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
            label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $64sbN.optionLabel
            }, intl.formatMessage((0, $jnxbR.default).noValue))
        })) : null, filteredOptions.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: label
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: label,
                key: label,
                isChecked: isOptionSelected(label),
                onChange: ()=>handleOptionClick(label),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                    id: label,
                    content: label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $64sbN.optionLabel
                }, label))
            }))), filteredOptions.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        onClose: onOpenChange,
        isOpen: isOpen,
        position: "bottom left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
            isVisible: !!value.length,
            onClearClick: onRequestClear
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
            placeholder: intl.formatMessage((0, $jnxbR.default).searchPlaceholder, {
                fieldName: customField.title
            }),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange
        }), renderOptions())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        triggerButtonText: renderFilterText(),
        testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.label.trigger-btn.${customField.id}`,
        ariaLabel: customField.title
    }));
};
var $3ca16e74fbefd509$export$2e2bcd8739ae039 = $3ca16e74fbefd509$var$Label;

});
parcelRegister("jnxbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40dbb7ca88b9c9c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c40dbb7ca88b9c9c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.search-placeholder",
        "defaultMessage": "Choose an option"
    },
    noMatchFoundText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.no-match-found-text",
        "defaultMessage": "No matches"
    },
    noValue: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.no-value",
        "defaultMessage": "No value"
    }
});

});

parcelRegister("64sbN", function(module, exports) {

$parcel$export(module.exports, "noMatchFoundText", () => $46b8fb96ea17eb7b$export$432ba9be018e81c2, (v) => $46b8fb96ea17eb7b$export$432ba9be018e81c2 = v);
$parcel$export(module.exports, "optionLabel", () => $46b8fb96ea17eb7b$export$245ad05b0468ea5e, (v) => $46b8fb96ea17eb7b$export$245ad05b0468ea5e = v);
var $46b8fb96ea17eb7b$export$432ba9be018e81c2;
var $46b8fb96ea17eb7b$export$245ad05b0468ea5e;
$46b8fb96ea17eb7b$export$432ba9be018e81c2 = `IIii6q_noMatchFoundText`;
$46b8fb96ea17eb7b$export$245ad05b0468ea5e = `IIii6q_optionLabel`;

});



parcelRegister("lbRDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec28a7fd63aaf913$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kz0GY = parcelRequire("kz0GY");

var $h6yit = parcelRequire("h6yit");

var $2t1eh = parcelRequire("2t1eh");
var $ec28a7fd63aaf913$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $h6yit.default), (0, $kz0GY.default))((0, $2t1eh.default));

});
parcelRegister("kz0GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd16f96175b86a2$export$2e2bcd8739ae039);

var $8B14N = parcelRequire("8B14N");
const $dbd16f96175b86a2$var$mapDispatchToProps = (dispatch, props)=>({
        onChange (value) {
            dispatch((0, $8B14N.update)({
                customField: props.customField,
                value: value
            }));
        },
        onRequestClear: ()=>{
            dispatch((0, $8B14N.clear)({
                customField: props.customField
            }));
        }
    });
var $dbd16f96175b86a2$export$2e2bcd8739ae039 = $dbd16f96175b86a2$var$mapDispatchToProps;

});

parcelRegister("h6yit", function(module, exports) {

$parcel$export(module.exports, "default", () => $af4504f52e691cc0$export$2e2bcd8739ae039);

var $kjklK = parcelRequire("kjklK");

var $kKj1m = parcelRequire("kKj1m");

var $fiZs1 = parcelRequire("fiZs1");

var $iK4oF = parcelRequire("iK4oF");
const $af4504f52e691cc0$export$8ba04a2269d8d395 = (state, { customField: customField })=>{
    // "selectOptions" is an array including e.g.
    // [{id: 10200, value: "Brisbane", fieldId: 10400},
    // {id: 10201, value: "Melbourne", fieldId: 10400},
    // {id: 10202, value: "Sydney", fieldId: 10400},
    // {id: 10300, value: "Kangaroo", fieldId: 10500},
    // {id: 10301, value: "Koala", fieldId: 10500},
    // {id: 10302, value: "Echidna", fieldId: 10500},
    // {id: 10303, value: "Cockatoo", fieldId: 10500}]
    const selectOptions = (0, $kKj1m.getSelectOptions)(state);
    // the "selectOptions" are then filtered to keep only the options of the custom field
    // e.g. if fieldId = 10400 the returned array is
    // [{id: 10200, value: "Brisbane", fieldId: 10400},
    // {id: 10201, value: "Melbourne", fieldId: 10400},
    // {id: 10202, value: "Sydney", fieldId: 10400}]
    return selectOptions.filter((opt)=>opt.fieldId === customField.id);
};
const $af4504f52e691cc0$export$ba9a994fdfb4baba = (state, { customField: customField })=>{
    // "customFieldFilter" is an object including
    // an "id" which is the custom field filter id
    // a "value" object including all the custom fields id's, which in turn include the selected custom fields filters id's
    //  e.g.
    // {
    //   id: "state.domain.view-settings.filters.CUSTOM_FIELD_FILTER_ID",
    //   value: { 10400: ["10201", "10200"], 10500: ["10302"] }
    // }
    // in this instance, "Melbourne" and "Brisbane" are selected for fieldId "10400", "Echidna" is selected for fieldId "10500"
    const customFieldFilter = (0, $fiZs1.getCustomFieldFilter)(state);
    // this looks for the value object in the customFieldFilter object, then looks for the array of selected filter values corresponding to the custom field id
    // in this instance, it will return
    // ["10201", "10200"] for custom field id "10400"
    // ["10302"] for custom field id "10500"
    return $kjklK.default([
        'value',
        String(customField.id)
    ], customFieldFilter) || [];
};
var // both functions are then used to create a dropdown list selector including all the possible options as well as the ones that are selected
$af4504f52e691cc0$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    options: $af4504f52e691cc0$export$8ba04a2269d8d395,
    value: $af4504f52e691cc0$export$ba9a994fdfb4baba
});

});

parcelRegister("2t1eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $183f8126dd7c413f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $9FeHi = parcelRequire("9FeHi");
var $1l9vO = parcelRequire("1l9vO");
var $dspDs = parcelRequire("dspDs");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $8aqkF = parcelRequire("8aqkF");
var $egiDP = parcelRequire("egiDP");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $fiZs1 = parcelRequire("fiZs1");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $eG0CY = parcelRequire("eG0CY");
var $6uwgw = parcelRequire("6uwgw");

var $jnxbR = parcelRequire("jnxbR");

var $7Iub8 = parcelRequire("7Iub8");

var $6g33d = parcelRequire("6g33d");

var $64sbN = parcelRequire("64sbN");
// eslint-disable-next-line jira/react/no-class-components
class $183f8126dd7c413f$var$MultiSelect extends (0, $eUqFw.Component) {
    render() {
        const { customField: customField, intl: intl, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, onRequestClear: onRequestClear, searchQuery: searchQuery, value: value } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: onRequestClear
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $jnxbR.default).searchPlaceholder, {
                    fieldName: customField.title
                }),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange
            }), this.renderOptions())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: this.renderFilterText(),
            testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.multi-select.trigger-btn.${customField.id}`,
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { intl: intl, options: options, value: value } = this.props;
            const noValueOption = {
                id: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
                value: intl.formatMessage((0, $jnxbR.default).noValue)
            };
            const uniqueLabels = [
                noValueOption
            ].concat(options).reduce((acc, option)=>{
                if (value.includes(`${option.id}`)) return acc.add(option.value);
                return acc;
            }, new Set());
            return [
                ...uniqueLabels
            ].join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            return value.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: this.constructFilterText()
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jnxbR.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl, customField: customField } = this.props;
            const filterText = this.constructFilterText();
            return `${customField.title}, ${value.length > 0 ? filterText : intl.formatMessage((0, $jnxbR.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isOptionSelectedNew = (optionValue)=>{
            const { value: value, options: options } = this.props;
            if (optionValue === (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)) return $1l9vO.default(optionValue, value);
            const matchingOptionIds = options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
            // eg if id=1, value='red', id=2, value='red', id=3, value='blue' and value=[2,3] is saved in the filter
            return $dspDs.default(matchingOptionIds, value).length > 0;
        };
        this.isOptionSelected = (optionId)=>$7d70y.default(optionId, this.props.value);
        this.handleOptionClickNew = (optionValue)=>{
            const { onChange: onChange, value: value, options: options } = this.props;
            const matchingOptionIds = optionValue === (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID) ? [
                (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)
            ] : options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
            // if option is already selected, remove it
            const isSelected = value.some((opt)=>matchingOptionIds.includes(opt));
            if (isSelected) // by sending the set without these options
            onChange($9FeHi.default(value, matchingOptionIds));
            else // otherwise include all the matching ids
            onChange($8aqkF.default(matchingOptionIds, value));
        };
        this.handleOptionClick = (optionId)=>{
            const { onChange: onChange, value: value } = this.props;
            const filtered = value.filter((opt)=>opt !== optionId);
            if (this.isOptionSelected(optionId)) onChange(filtered);
            else onChange([
                ...filtered,
                optionId
            ]);
        };
        this.renderOptions = ()=>{
            const { intl: intl, options: options } = this.props;
            const filteredOptions = $9RbxZ.default($f7Op5.default('value'), options.filter((option)=>option.value.toLowerCase().includes(this.props.searchQuery.toLowerCase())));
            /**
     * it's possible to have multiple options defined with the same name (value) when there are
     * multiple contexts defined for the field.
     * We don't want to show all these as the are indistinguishable duplicates to the user.
     * Instead, just select based on the value and later re-map this to all the matching ids to
     * perform the issue filtering using the ids.
     */ const dedupedOptions = $egiDP.default($f7Op5.default('value'), filteredOptions);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, options.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: `${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`,
                key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
                isChecked: this.isOptionSelected(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
                onChange: ()=>this.handleOptionClick(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
                label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $64sbN.optionLabel
                }, intl.formatMessage((0, $jnxbR.default).noValue))
            })) : null, dedupedOptions.map(({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: value
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: `${value}`,
                    key: value,
                    isChecked: this.isOptionSelectedNew(`${value}`),
                    onChange: ()=>this.handleOptionClickNew(`${value}`),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        id: value,
                        content: value
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $64sbN.optionLabel
                    }, value))
                }))), !filteredOptions.length && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $64sbN.noMatchFoundText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jnxbR.default).noMatchFoundText)));
        };
    }
}
var $183f8126dd7c413f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($183f8126dd7c413f$var$MultiSelect);

});


parcelRegister("6Lgs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c5ddfc11a120b1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4jrAq = parcelRequire("4jrAq");

var $dtbkP = parcelRequire("dtbkP");

var $i46vP = parcelRequire("i46vP");
var $67c5ddfc11a120b1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $dtbkP.mapStateToProps), (0, $4jrAq.default))((0, $i46vP.default));

});
parcelRegister("4jrAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71699e8d387b64f$export$2e2bcd8739ae039);

var $8B14N = parcelRequire("8B14N");
const $d71699e8d387b64f$var$mapDispatchToProps = (dispatch, props)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange (value) {
            dispatch((0, $8B14N.update)({
                customField: props.customField,
                value: value
            }));
        },
        onRequestClear () {
            dispatch((0, $8B14N.clear)({
                customField: props.customField
            }));
        }
    });
var $d71699e8d387b64f$export$2e2bcd8739ae039 = $d71699e8d387b64f$var$mapDispatchToProps;

});

parcelRegister("dtbkP", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $0f64fd2c39e82fe3$export$c31df4bd766f9c35);

var $kjklK = parcelRequire("kjklK");

var $kKj1m = parcelRequire("kKj1m");

var $fiZs1 = parcelRequire("fiZs1");

var $iK4oF = parcelRequire("iK4oF");
const $0f64fd2c39e82fe3$var$getOptions = (state, { customField: customField })=>(0, $kKj1m.getSelectOptions)(state).filter((opt)=>opt.fieldId === customField.id);
const $0f64fd2c39e82fe3$var$getValue = (state, { customField: customField })=>{
    const customFieldFilter = (0, $fiZs1.getCustomFieldFilter)(state);
    return $kjklK.default([
        'value',
        String(customField.id)
    ], customFieldFilter) || [];
};
const $0f64fd2c39e82fe3$export$c31df4bd766f9c35 = (0, $iK4oF.createStructuredSelector)({
    options: $0f64fd2c39e82fe3$var$getOptions,
    value: $0f64fd2c39e82fe3$var$getValue
});

});

parcelRegister("i46vP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99f581dca72ff8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $9FeHi = parcelRequire("9FeHi");
var $1l9vO = parcelRequire("1l9vO");
var $dspDs = parcelRequire("dspDs");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $8aqkF = parcelRequire("8aqkF");
var $1uCJR = parcelRequire("1uCJR");
var $egiDP = parcelRequire("egiDP");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $fiZs1 = parcelRequire("fiZs1");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $eG0CY = parcelRequire("eG0CY");
var $6uwgw = parcelRequire("6uwgw");

var $jnxbR = parcelRequire("jnxbR");

var $7Iub8 = parcelRequire("7Iub8");

var $6g33d = parcelRequire("6g33d");

var $64sbN = parcelRequire("64sbN");
// eslint-disable-next-line jira/react/no-class-components
class $d99f581dca72ff8b$var$SingleSelect extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, value: value, onOpenChange: onOpenChange, isOpen: isOpen, customField: customField, searchQuery: searchQuery, onQueryChange: onQueryChange, onRequestClear: onRequestClear } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            position: "bottom left",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: onRequestClear
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $jnxbR.default).searchPlaceholder, {
                    fieldName: customField.title
                }),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange
            }), this.renderOptions())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: this.renderFilterText(),
            testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.custom-field-filter.single-select.trigger-btn.${customField.id}`,
            ariaLabel: this.ariaText()
        })));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { intl: intl, options: options, value: value } = this.props;
            const noValueOption = {
                id: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
                value: intl.formatMessage((0, $jnxbR.default).noValue)
            };
            return $1uCJR.default([
                noValueOption
            ].concat(options).filter(({ id: id })=>$1l9vO.default(`${id}`, value)).map($f7Op5.default('value'))).join(', ');
        };
        this.renderFilterText = ()=>{
            const value = this.props.value;
            const filterText = this.constructFilterText();
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jnxbR.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl, customField: customField } = this.props;
            const filterText = this.constructFilterText();
            return `${customField.title}, ${value.length > 0 ? filterText : intl.formatMessage((0, $jnxbR.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isOptionSelectedNew = (optionValue)=>{
            const { value: value, options: options } = this.props;
            if (optionValue === (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)) return $1l9vO.default(optionValue, value);
            const matchingOptionIds = options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
            // eg if id=1, value='red', id=2, value='red', id=3, value='blue' and value=[2,3] is saved in the filter
            return $dspDs.default(matchingOptionIds, value).length > 0;
        };
        this.isOptionSelected = (optionId)=>{
            const value = this.props.value;
            return $7d70y.default(optionId, value);
        };
        this.handleOptionClickNew = (optionValue)=>{
            const { onChange: onChange, value: value, options: options } = this.props;
            const matchingOptionIds = optionValue === (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID) ? [
                (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)
            ] : options.filter((option)=>option.value === optionValue).map((option)=>option.id.toString());
            // if option is already selected, remove it
            const isSelected = value.some((opt)=>matchingOptionIds.includes(opt));
            if (isSelected) // by sending the set without these options
            onChange($9FeHi.default(value, matchingOptionIds));
            else // otherwise include all the matching ids
            onChange($8aqkF.default(matchingOptionIds, value));
        };
        this.handleOptionClick = (optionId)=>{
            const { value: value, onChange: onChange } = this.props;
            const filtered = value.filter((opt)=>opt !== optionId);
            if (this.isOptionSelected(optionId)) onChange(filtered);
            else onChange([
                ...filtered,
                optionId
            ]);
        };
        this.renderOptions = ()=>{
            const { intl: intl, options: options } = this.props;
            const filteredOptions = $9RbxZ.default($f7Op5.default('value'), options.filter((option)=>option.value.toLowerCase().includes(this.props.searchQuery.toLowerCase())));
            /**
     * it's possible to have multiple options defined with the same name (value) when there are
     * multiple contexts defined for the field.
     * We don't want to show all these as the are indistinguishable duplicates to the user.
     * Instead, just select based on the value and later re-map this to all the matching ids to
     * perform the issue filtering using the ids.
     */ const dedupedOptions = $egiDP.default($f7Op5.default('value'), filteredOptions);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, options.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: `${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`,
                key: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
                isChecked: this.isOptionSelected(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
                onChange: ()=>this.handleOptionClick(`${(0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)}`),
                label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $64sbN.optionLabel
                }, intl.formatMessage((0, $jnxbR.default).noValue))
            })) : null, dedupedOptions.map(({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: value
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: `${value}`,
                    key: value,
                    isChecked: this.isOptionSelectedNew(`${value}`),
                    onChange: ()=>this.handleOptionClickNew(`${value}`),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        id: value,
                        content: value
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $64sbN.optionLabel
                    }, value))
                }))), filteredOptions.length === 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $64sbN.noMatchFoundText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $jnxbR.default).noMatchFoundText)));
        };
    }
}
var $d99f581dca72ff8b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d99f581dca72ff8b$var$SingleSelect);

});



parcelRegister("7IziM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4e4dad0c3fc9253$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $k4Btk = parcelRequire("k4Btk");

var $4pKjd = parcelRequire("4pKjd");

var $3dZYX = parcelRequire("3dZYX");
var $b4e4dad0c3fc9253$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $4pKjd.default), (0, $k4Btk.default))((0, $3dZYX.DateRangeFilter));

});
parcelRegister("k4Btk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae97948322cdeb7$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $7ae97948322cdeb7$var$mapDispatchToProps = (dispatch)=>({
        onDateRangeChange: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$82db1960569473ff),
                value: payload
            }));
        }
    });
var $7ae97948322cdeb7$export$2e2bcd8739ae039 = $7ae97948322cdeb7$var$mapDispatchToProps;

});

parcelRegister("4pKjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c865380e3b61ba$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");


var $iK4oF = parcelRequire("iK4oF");
const $62c865380e3b61ba$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], ({ [(0, $12ee831723ccf9c2$export$82db1960569473ff)]: { id: id, value: { startDate: startDate, endDate: endDate } } })=>({
        id: id,
        startDate: startDate,
        endDate: endDate
    }));
var $62c865380e3b61ba$export$2e2bcd8739ae039 = $62c865380e3b61ba$var$mapStateToProps;

});

parcelRegister("3dZYX", function(module, exports) {

$parcel$export(module.exports, "DateRangeFilter", () => $3ea9a90c9543ce58$export$26dc5fbaa253de80);

var $eUqFw = parcelRequire("eUqFw");

var $jXg8H = parcelRequire("jXg8H");

var $6ROLN = parcelRequire("6ROLN");

var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $85rpc = parcelRequire("85rpc");

var $bPCkU = parcelRequire("bPCkU");
const $3ea9a90c9543ce58$export$26dc5fbaa253de80 = ({ startDate: startTimestamp, endDate: endTimestamp, onDateRangeChange: onDateRangeChange })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const startDate = (0, $bPCkU.convertToDateString)(startTimestamp);
    const endDate = (0, $bPCkU.convertToDateString)(endTimestamp);
    const onStartInputChange = (newStartDate)=>{
        onDateRangeChange((0, $bPCkU.createAndHandleDateRangeChange)(newStartDate, endDate));
    };
    const onEndInputChange = (newEndDate)=>{
        onDateRangeChange((0, $bPCkU.createAndHandleDateRangeChange)(startDate, newEndDate));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $3ea9a90c9543ce58$var$filterContainerStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "date-range-filter-from"
    }, formatMessage((0, $85rpc.default).startDateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
        locale: locale,
        value: startDate,
        onChange: onStartInputChange,
        placeholder: formatMessage((0, $85rpc.default).noDatePlaceholder),
        maxDate: endDate,
        selectProps: {
            inputId: 'date-range-filter-from'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "date-range-filter-to"
    }, formatMessage((0, $85rpc.default).endDateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
        locale: locale,
        value: endDate,
        minDate: startDate,
        placeholder: formatMessage((0, $85rpc.default).noDatePlaceholder),
        onChange: onEndInputChange,
        selectProps: {
            inputId: 'date-range-filter-to'
        }
    })));
};
const $3ea9a90c9543ce58$var$filterContainerStyles = (0, $1ZAYh.xcss)({
    width: '278px'
});

});
parcelRegister("85rpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $023dbd09b0c10b14$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $023dbd09b0c10b14$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.start-date-label",
        "defaultMessage": "Start date"
    },
    endDateLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.end-date-label",
        "defaultMessage": "End date"
    },
    noDatePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.date-range-filter.no-date-placeholder",
        "defaultMessage": "None"
    }
});

});

parcelRegister("bPCkU", function(module, exports) {

$parcel$export(module.exports, "convertToDateString", () => $14f50a586cf4512d$export$329b86aa495c7d2b);
$parcel$export(module.exports, "createAndHandleDateRangeChange", () => $14f50a586cf4512d$export$19d9ed0dfec2c07a);

var $l2Sj2 = parcelRequire("l2Sj2");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
const $14f50a586cf4512d$export$329b86aa495c7d2b = (timestamp)=>timestamp !== undefined ? (0, $l2Sj2.formatDateUTC)(timestamp, (0, $eTbtL.IsoDateFormat)) : '';
const $14f50a586cf4512d$export$677e82bae63eb855 = (date)=>date !== undefined && date !== '' ? (0, $17L5s.startOfUtcDay)(date) : undefined;
const $14f50a586cf4512d$export$19d9ed0dfec2c07a = (newStartDate, newEndDate)=>{
    const startDateTmp = $14f50a586cf4512d$export$677e82bae63eb855(newStartDate);
    const endDateTmp = $14f50a586cf4512d$export$677e82bae63eb855(newEndDate);
    return {
        ...startDateTmp !== undefined && {
            startDate: startDateTmp
        },
        ...endDateTmp !== undefined && {
            endDate: endDateTmp
        }
    };
};

});



parcelRegister("k8GBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43990e1e893697d7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $iAoY8 = parcelRequire("iAoY8");

var $5KuQ1 = parcelRequire("5KuQ1");

var $87nTO = parcelRequire("87nTO");
var $43990e1e893697d7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5KuQ1.default), (0, $iAoY8.default))((0, $87nTO.default));

});
parcelRegister("iAoY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d175b107372d4a69$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $d175b107372d4a69$var$mapDispatchToProps = (dispatch)=>({
        changeDependenciesFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                value: payload
            }));
        }
    });
var $d175b107372d4a69$export$2e2bcd8739ae039 = $d175b107372d4a69$var$mapDispatchToProps;

});

parcelRegister("5KuQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce76fbb28c00dc3e$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("bRpYp");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");
const $ce76fbb28c00dc3e$var$mapStateToProps = (state)=>{
    const { [(0, $12ee831723ccf9c2$export$a849f806e27a57e8)]: { id: id, value: value } } = (0, $fbHoQ.getFilters)(state);
    return {
        id: id,
        issues: (0, $cwP4d.getIssues)(state),
        issueMapById: (0, $cwP4d.getIssueMapById)(state),
        issueTypes: (0, $lihml.getIssueTypes)(state),
        projectsById: (0, $ehEr2.getProjectsById)(state),
        value: value
    };
};
var $ce76fbb28c00dc3e$export$2e2bcd8739ae039 = $ce76fbb28c00dc3e$var$mapStateToProps;

});

parcelRegister("87nTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed3607416946069$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $86Ndv = parcelRequire("86Ndv");

var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
var $hnuwz = parcelRequire("hnuwz");
var $akSC8 = parcelRequire("akSC8");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("bRpYp");
parcelRequire("gGKRb");
var $2LimL = parcelRequire("2LimL");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $04tZU = parcelRequire("04tZU");

var $6g33d = parcelRequire("6g33d");

var $eV55H = parcelRequire("eV55H");

var $ib4xT = parcelRequire("ib4xT");
const $eed3607416946069$export$d742e2fb7de0884c = (0, $g8JvH.AnalyticsEventToProps)('radioButton', {
    onChange: 'changed'
})((0, $hnuwz.default));
const $eed3607416946069$var$AsyncSelectWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('asyncSelect', {
    onChange: 'changed'
})((0, $2LimL.AsyncSelect));
function $eed3607416946069$var$isDepdendencyFilterValueHasTransitive(val) {
    return val.type === 'specificIssue';
}
class $eed3607416946069$export$51af50c438784b95 extends (0, $eUqFw.Component) {
    render() {
        const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
        const { intl: intl, issueMapById: issueMapById, value: value, isOpen: isOpen } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            overflow: "visible",
            onClose: this.onOpenChange,
            isOpen: isOpen,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter",
            content: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), {
                style: {
                    overflow: 'visible'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                heading: intl.formatMessage((0, $eV55H.default).showIssues)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eed3607416946069$export$d742e2fb7de0884c, {
                isChecked: value.type === 'off',
                label: intl.formatMessage((0, $eV55H.default).allIssues),
                name: "showIssues",
                onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                        type: 'off'
                    }, analyticsEvent),
                value: "off"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eed3607416946069$export$d742e2fb7de0884c, {
                isChecked: value.type === 'on',
                label: intl.formatMessage((0, $eV55H.default).hasDependencies),
                name: "showIssues",
                onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                        type: 'on'
                    }, analyticsEvent),
                value: "on"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eed3607416946069$export$d742e2fb7de0884c, {
                isChecked: value.type === 'offtrack',
                label: intl.formatMessage((0, $eV55H.default).offtrackDependencies),
                name: "showIssues",
                onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                        type: 'offtrack'
                    }, analyticsEvent),
                value: "offtrack"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eed3607416946069$export$d742e2fb7de0884c, {
                isChecked: value.type === 'specificIssue',
                label: intl.formatMessage((0, $eV55H.default).specificIssue),
                name: "showIssues",
                onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                        type: 'specificIssue'
                    }, analyticsEvent),
                value: "specificIssue"
            }))), value.type === 'specificIssue' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eed3607416946069$var$AsyncSelectWithAnalytics, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $ib4xT.issueSelector,
                defaultOptions: true,
                defaultValue: value.issueId && issueMapById[value.issueId],
                formatOptionLabel: this.renderDependencyIssue,
                getOptionValue: this.getDependencyIssueValue,
                getOptionLabel: this.getDependencyIssueValue,
                isClearable: true,
                isTransparentBackground: false,
                loadOptions: this.loadOptions,
                menuPlacement: "auto",
                onChange: this.onIssueChange,
                placeholder: intl.formatMessage((0, $eV55H.default).issueSelectorPlaceholder),
                autoFocus: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $ib4xT.includeTransitive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                isChecked: value.includeTransitive,
                label: intl.formatMessage((0, $eV55H.default).includeTransitive),
                onChange: (_, analyticsEvent)=>onDependencyFilterChange({
                        type: 'specificIssue',
                        issueId: value.issueId,
                        includeTransitive: !value.includeTransitive
                    }, analyticsEvent)
            }))) : null)
        }, this.renderTriggerButton());
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onIssueChange = (issue, _, analyticsEvent)=>{
            const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
            const { value: value } = props;
            onDependencyFilterChange({
                type: 'specificIssue',
                issueId: issue && issue.id,
                includeTransitive: $eed3607416946069$var$isDepdendencyFilterValueHasTransitive(value) && value.includeTransitive || false
            }, analyticsEvent);
        };
        this.onOpenChange = ({ isOpen: isOpen, ignoreMenuOpen: ignoreMenuOpen }, analyticsEvent)=>{
            const { props: props, onDependencyFilterChange: onDependencyFilterChange } = this;
            const { value: value, onOpenChange: onOpenChange } = props;
            if (!ignoreMenuOpen && props.isMenuOpen) return;
            if (!isOpen && value.type === 'specificIssue' && !value.issueId) onDependencyFilterChange({
                type: 'off'
            }, analyticsEvent);
            onOpenChange({
                isOpen: isOpen
            });
        };
        this.onDependencyFilterChange = (payload, analyticsEvent)=>{
            this.props.changeDependenciesFilter(payload);
            // triggering analytics when a user adds changes the "Dependencies" filter
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_DEPENDENCIES_FILTER.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), {
                type: payload.type
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.toggleOpen = (_, analyticsEvent)=>{
            const { isOpen: isOpen } = this.props;
            this.onOpenChange({
                isOpen: !isOpen,
                ignoreMenuOpen: true
            }, analyticsEvent);
        };
        this.getIssueKey = ({ issueKey: issueKey, project: projectId })=>{
            const { projectsById: projectsById } = this.props;
            const project = projectsById[projectId || NaN];
            const key = issueKey ? `${project.key}-${issueKey}` : project.key;
            return key;
        };
        this.getDependencyIssueValue = (issue)=>`${this.getIssueKey(issue)} ${issue.summary}`;
        this.loadOptions = (query)=>{
            const q = query.toLowerCase();
            const issues = this.props.issues.filter((issue)=>this.getDependencyIssueValue(issue).toLowerCase().includes(q)).slice(0, 50);
            return Promise.resolve(issues);
        };
        this.renderDependencyIssue = (issue)=>{
            const { issueTypes: issueTypes } = this.props;
            const issueType = issueTypes.find(({ id: id })=>id === issue.type);
            return (0, $akSC8.selectIssueOption)({
                icon: issueType && issueType.iconUrl,
                label: this.getDependencyIssueValue(issue)
            });
        };
        this.renderTriggerButton = ()=>{
            const { intl: intl, issueMapById: issueMapById, value: value, isOpen: isOpen } = this.props;
            let triggerButtonText = '';
            if (value.type === 'specificIssue') {
                const { issueId: issueId } = value;
                if (issueId && issueMapById[issueId]) triggerButtonText = intl.formatMessage((0, $eV55H.default).specificIssueTrigger, {
                    issueKey: this.getIssueKey(issueMapById[issueId])
                });
                else triggerButtonText = intl.formatMessage((0, $eV55H.default).offTrigger);
            } else triggerButtonText = intl.formatMessage((0, $eV55H.default)[`${value.type}Trigger`]);
            const ariaText = ()=>// Dependencies, All issues selected
                `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$a849f806e27a57e8])}, ${triggerButtonText} ${intl.formatMessage((0, $6g33d.default).selected)}`;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $ib4xT.filterButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                isSelected: isOpen,
                onClick: this.toggleOpen,
                ariaLabel: ariaText(),
                testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.trigger-btn"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($ib4xT.filterButton, {
                    [$ib4xT.filterButtonApplied]: value.type !== 'off'
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $ib4xT.buttonText
            }, triggerButtonText)))));
        };
    }
}
var $eed3607416946069$export$2e2bcd8739ae039 = (0, $2qhQi.default)($eed3607416946069$export$51af50c438784b95);

});
parcelRegister("eV55H", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb0a55722fb0cf73$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eb0a55722fb0cf73$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.show-issues",
        "defaultMessage": "Show issues"
    },
    allIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.all-issues",
        "defaultMessage": "All issues"
    },
    hasDependencies: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.has-dependencies",
        "defaultMessage": "Has dependencies"
    },
    specificIssue: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.specific-issue",
        "defaultMessage": "Specific issue"
    },
    offtrackDependencies: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.offtrack-dependencies",
        "defaultMessage": "Overlapping dates"
    },
    issueSelectorPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.issue-selector-placeholder",
        "defaultMessage": "Choose issue..."
    },
    offTrigger: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.off-trigger",
        "defaultMessage": "All issues"
    },
    onTrigger: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.on-trigger",
        "defaultMessage": "Issues with dependencies"
    },
    specificIssueTrigger: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.specific-issue-trigger",
        "defaultMessage": "Dependencies of {issueKey}"
    },
    offtrackTrigger: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.offtrack-trigger",
        "defaultMessage": "Issues with overlapping dates"
    },
    includeTransitive: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.dependencies-filter.include-transitive",
        "defaultMessage": "Include dependency chain"
    }
});

});

parcelRegister("ib4xT", function(module, exports) {

$parcel$export(module.exports, "buttonText", () => $d3bcc7bce2a7b37b$export$c058c12a17cc5c02, (v) => $d3bcc7bce2a7b37b$export$c058c12a17cc5c02 = v);
$parcel$export(module.exports, "filterButton", () => $d3bcc7bce2a7b37b$export$64796c58ca8c33ef, (v) => $d3bcc7bce2a7b37b$export$64796c58ca8c33ef = v);
$parcel$export(module.exports, "filterButtonApplied", () => $d3bcc7bce2a7b37b$export$d3cfd886ed244cea, (v) => $d3bcc7bce2a7b37b$export$d3cfd886ed244cea = v);
$parcel$export(module.exports, "filterButtonWrapper", () => $d3bcc7bce2a7b37b$export$706db85642e6c245, (v) => $d3bcc7bce2a7b37b$export$706db85642e6c245 = v);
$parcel$export(module.exports, "includeTransitive", () => $d3bcc7bce2a7b37b$export$8348ef9c4a261b73, (v) => $d3bcc7bce2a7b37b$export$8348ef9c4a261b73 = v);
$parcel$export(module.exports, "issueSelector", () => $d3bcc7bce2a7b37b$export$a849e6f9952698a4, (v) => $d3bcc7bce2a7b37b$export$a849e6f9952698a4 = v);
var $d3bcc7bce2a7b37b$export$c058c12a17cc5c02;
var $d3bcc7bce2a7b37b$export$64796c58ca8c33ef;
var $d3bcc7bce2a7b37b$export$d3cfd886ed244cea;
var $d3bcc7bce2a7b37b$export$706db85642e6c245;
var $d3bcc7bce2a7b37b$export$8348ef9c4a261b73;
var $d3bcc7bce2a7b37b$export$a849e6f9952698a4;
$d3bcc7bce2a7b37b$export$c058c12a17cc5c02 = `o5zuRq_buttonText`;
$d3bcc7bce2a7b37b$export$64796c58ca8c33ef = `o5zuRq_filterButton`;
$d3bcc7bce2a7b37b$export$d3cfd886ed244cea = `o5zuRq_filterButtonApplied`;
$d3bcc7bce2a7b37b$export$706db85642e6c245 = `o5zuRq_filterButtonWrapper`;
$d3bcc7bce2a7b37b$export$8348ef9c4a261b73 = `o5zuRq_includeTransitive`;
$d3bcc7bce2a7b37b$export$a849e6f9952698a4 = `o5zuRq_issueSelector`;

});



parcelRegister("kCWNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1c8714d50beb3d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hJoSh = parcelRequire("hJoSh");

var $1nk1U = parcelRequire("1nk1U");

var $8uvQ6 = parcelRequire("8uvQ6");
var $8f1c8714d50beb3d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1nk1U.default), (0, $hJoSh.default))((0, $8uvQ6.default));

});
parcelRegister("hJoSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5348f6b892e390d4$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $5348f6b892e390d4$var$mapDispatchToProps = (dispatch)=>({
        changeGoalsFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$861e775e082be75a),
                value: payload
            }));
        },
        clearGoalsFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$861e775e082be75a)));
        }
    });
var $5348f6b892e390d4$export$2e2bcd8739ae039 = $5348f6b892e390d4$var$mapDispatchToProps;

});

parcelRegister("1nk1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ca821957c7d06d$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");

var $e4IaE = parcelRequire("e4IaE");


var $iK4oF = parcelRequire("iK4oF");
const $85ca821957c7d06d$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $e4IaE.getIssueGoalARIs),
    (0, $fbHoQ.getFilters)
], (issueGoalARIs, { [(0, $12ee831723ccf9c2$export$861e775e082be75a)]: { id: id, value: value } })=>({
        issueGoalARIs: issueGoalARIs,
        id: id,
        value: value
    }));
var $85ca821957c7d06d$export$2e2bcd8739ae039 = $85ca821957c7d06d$var$mapStateToProps;

});

parcelRegister("8uvQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed01d62b1bc8a953$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $lGIBI = parcelRequire("lGIBI");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $eG0CY = parcelRequire("eG0CY");

var $4dREb = parcelRequire("4dREb");
var $As52d = parcelRequire("As52d");

var $6g33d = parcelRequire("6g33d");

var $1ayJI = parcelRequire("1ayJI");
const $ed01d62b1bc8a953$var$GoalFilter = ({ clearGoalsFilter: clearGoalsFilter, value: value, searchQuery: searchQuery, onOpenChange: onOpenChange, isOpen: isOpen, onQueryChange: onQueryChange, changeGoalsFilter: changeGoalsFilter, issueGoalARIs: issueGoalARIs })=>{
    const [definedGoalsByARI] = (0, $lGIBI.useDefinedGoals)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isGoalsSelected = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(definedGoalsByARI) && value.length > 0;
    const onGoalClick = (id)=>{
        if (isGoalSelected(id)) changeGoalsFilter(value.filter((goalId)=>goalId !== id));
        else changeGoalsFilter([
            ...value,
            id
        ]);
    };
    const constructFilterText = ()=>{
        const goalNames = value.flatMap((goalARI)=>{
            const definedGoal = definedGoalsByARI[goalARI];
            return definedGoal.name;
        });
        const sortedGoalNames = goalNames.sort();
        return sortedGoalNames.join(', ');
    };
    const renderFilterText = ()=>{
        if (isGoalsSelected) {
            const filterText = constructFilterText();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1ayJI.default).emptyPlaceholder);
    };
    const ariaText = ()=>{
        const filterText = isGoalsSelected ? constructFilterText() : formatMessage((0, $1ayJI.default).emptyPlaceholder);
        return `${formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$861e775e082be75a])}, ${filterText} ${formatMessage((0, $6g33d.default).selected)}`;
    };
    const isGoalSelected = (goalARI)=>value.includes(goalARI);
    const filterGoalsWithSearchQuery = (goalARI)=>{
        const definedGoal = definedGoalsByARI[goalARI];
        // goalARI could refer to a goal that has been unlinked
        return definedGoal ? definedGoal.name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
    };
    const filteredGoalARIs = issueGoalARIs.filter(filterGoalsWithSearchQuery);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        onClose: onOpenChange,
        isOpen: isOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
            isVisible: isGoalsSelected,
            onClearClick: clearGoalsFilter
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
            placeholder: formatMessage((0, $1ayJI.default).searchGoalsPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange
        }), filteredGoalARIs.map((goalARI)=>{
            const { name: name, state: state } = definedGoalsByARI[goalARI];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: goalARI
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: `${goalARI}`,
                isChecked: isGoalSelected(goalARI),
                onChange: ()=>onGoalClick(goalARI),
                label: state !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $ed01d62b1bc8a953$var$filterItemContentStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4dREb.GoalIcon), {
                    state: state.value
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    xcss: $ed01d62b1bc8a953$var$goalNameWrapperStyles
                }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $As52d.GoalTracker), {
                    label: state.label,
                    value: state.value,
                    score: state.score
                })) : name
            }));
        }), filteredGoalARIs.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null)),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        triggerButtonText: renderFilterText(),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.trigger-btn",
        ariaLabel: ariaText()
    }));
};
const $ed01d62b1bc8a953$var$filterItemContentStyles = (0, $1ZAYh.xcss)({
    lineHeight: '24px',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '390px'
});
const $ed01d62b1bc8a953$var$goalNameWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
var $ed01d62b1bc8a953$export$2e2bcd8739ae039 = $ed01d62b1bc8a953$var$GoalFilter;

});
parcelRegister("1ayJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $762f501b31e1168c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $762f501b31e1168c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchGoalsPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.goal-filter.search-goals-placeholder",
        "defaultMessage": "Show issues from goals"
    }
});

});



parcelRegister("eLSVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f93196c087125cb$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ejD3H = parcelRequire("ejD3H");

var $cB3tT = parcelRequire("cB3tT");

var $4UcUs = parcelRequire("4UcUs");
var $0f93196c087125cb$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $cB3tT.default), (0, $ejD3H.default))((0, $4UcUs.default));

});
parcelRegister("ejD3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb98dc2a270d4338$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");

const $cb98dc2a270d4338$var$mapDispatchToProps = (dispatch)=>({
        onHierarchyChange: (payload)=>{
            dispatch((0, $dr4qD.clearInlineCreate)());
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: payload
            }));
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
                value: {
                    start: payload.start - 1,
                    end: payload.end - 1
                }
            }));
        }
    });
var $cb98dc2a270d4338$export$2e2bcd8739ae039 = $cb98dc2a270d4338$var$mapDispatchToProps;

});

parcelRegister("cB3tT", function(module, exports) {

$parcel$export(module.exports, "default", () => $445e8462f0d1e86d$export$2e2bcd8739ae039);

var $6UAvZ = parcelRequire("6UAvZ");

var $fZW8G = parcelRequire("fZW8G");

var $iK4oF = parcelRequire("iK4oF");
var $445e8462f0d1e86d$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getHierarchyLevels),
    (0, $6UAvZ.getHierarchyFilter)
], (hierarchy, { id: id, value: { start: start, end: end } })=>({
        id: id,
        hierarchy: hierarchy,
        start: start,
        end: end
    }));

});

parcelRegister("4UcUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a4079e2839b8f1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eyMXO = parcelRequire("eyMXO");
var $i0RGP = parcelRequire("i0RGP");
var $fSMKM = parcelRequire("fSMKM");
var $h3f0m = parcelRequire("h3f0m");

var $5JgJ2 = parcelRequire("5JgJ2");

var $f4Q2n = parcelRequire("f4Q2n");
var $dNJqt = parcelRequire("dNJqt");

var $7iAcc = parcelRequire("7iAcc");

var $dVENQ = parcelRequire("dVENQ");
const $3a4079e2839b8f1d$var$comparator = $eyMXO.default($fSMKM.default);
function $3a4079e2839b8f1d$var$HierarchyFilter({ end: end, hierarchy: hierarchy, id: id, onHierarchyChange: onHierarchyChange, start: start }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnChange = (selection)=>{
        if (selection.start && selection.end) onHierarchyChange({
            start: selection.start.value,
            end: selection.end.value
        });
    };
    const hierarchyLevelRangeItems = hierarchy.map(({ level: level, title: title })=>({
            content: title,
            id: level,
            value: level
        }));
    let rangeSelectorProps = {
        groups: [
            {
                id: id,
                items: hierarchyLevelRangeItems
            }
        ],
        comparator: $3a4079e2839b8f1d$var$comparator,
        onChange: handleOnChange
    };
    const startItem = $i0RGP.default($h3f0m.default('value', start), hierarchyLevelRangeItems);
    const endItem = $i0RGP.default($h3f0m.default('value', end), hierarchyLevelRangeItems);
    if (startItem) rangeSelectorProps = {
        ...rangeSelectorProps,
        start: {
            ...startItem,
            label: formatMessage((0, $7iAcc.default).topHierarchyLevelLabel),
            name: 'topHierarchyLevel',
            showTooltip: true
        }
    };
    if (endItem) rangeSelectorProps = {
        ...rangeSelectorProps,
        end: {
            ...endItem,
            label: formatMessage((0, $7iAcc.default).bottomHierarchyLevelLabel),
            name: 'bottomHierarchyLevel',
            showTooltip: true
        }
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dVENQ.hierarchyFilter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNJqt.default), rangeSelectorProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4Q2n.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.from",
        ariaLabel: formatMessage((0, $7iAcc.default).hierarchyFrom)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dVENQ.separator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f4Q2n.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.to",
        ariaLabel: formatMessage((0, $7iAcc.default).hierarchyTo)
    }))));
}
var $3a4079e2839b8f1d$export$2e2bcd8739ae039 = $3a4079e2839b8f1d$var$HierarchyFilter;

});
parcelRegister("eyMXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99a38d48dc7269f$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $a99a38d48dc7269f$var$comparator = /*#__PURE__*/ (0, $eSWTK.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $a99a38d48dc7269f$export$2e2bcd8739ae039 = $a99a38d48dc7269f$var$comparator;

});

parcelRegister("fSMKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b901b79d85994423$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $b901b79d85994423$var$gt = /*#__PURE__*/ (0, $ggdJA.default)(function gt(a, b) {
    return a > b;
});
var $b901b79d85994423$export$2e2bcd8739ae039 = $b901b79d85994423$var$gt;

});

parcelRegister("f4Q2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d00a4df4fc7ea5b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cQGVO = parcelRequire("cQGVO");

var $86Ndv = parcelRequire("86Ndv");
parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
class $d00a4df4fc7ea5b5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            defaultValue: null,
            isLoading: false,
            groups: [],
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onChange: ()=>{},
            placement: 'bottom-start',
            testId: ''
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */ if (this.props.defaultValue !== nextProps.defaultValue) this.setState(()=>({
                selectedItem: nextProps.defaultValue
            }));
    }
    render() {
        const { groups: groups = [], isLoading: isLoading, placement: placement, placeholder: placeholder, testId: testId } = this.props;
        const { selectedItem: selectedItem } = this.state;
        let buttonContent = placeholder !== null && placeholder !== undefined ? placeholder : 'Select from a list';
        if (selectedItem) buttonContent = selectedItem.content;
        const triggerContent = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ref: triggerRef,
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                "aria-label": this.props.ariaLabel
            }, buttonContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
            isLoading: isLoading,
            placement: placement,
            testId: testId,
            trigger: triggerContent
        }, $cQGVO.default(this.createGroupElement, groups));
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedItem: this.props.defaultValue
        };
        this.handleClick = (item, group, e)=>{
            this.setState({
                selectedItem: item
            });
            /* istanbul ignore else */ if (this.props.onChange) this.props.onChange(item, group, e);
        };
        this.createItemElement = (item, group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
                key: item.id,
                onClick: (e)=>this.handleClick(item, group, e),
                title: item.tooltipDescription,
                ...item
            }, item.content);
        this.createGroupElement = (group)=>{
            const itemElements = $cQGVO.default((item)=>this.createItemElement(item, group), group.items);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
                key: group.id,
                title: group.heading
            }, itemElements);
        };
    }
}

});

parcelRegister("dNJqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $91ad631c0a355816$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $eyMXO = parcelRequire("eyMXO");
var $1vSyG = parcelRequire("1vSyG");

var $4LhB6 = parcelRequire("4LhB6");

var $gwbfD = parcelRequire("gwbfD");
class $91ad631c0a355816$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            comparator: $eyMXO.default($1vSyG.default),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onChange: ()=>{}
        };
    }
    getStartSelectProps() {
        const { groups: groups, start: start, end: end, comparator: comparator, onChange: onRangeChange } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newGroups = groups.map(({ items: items, ...group })=>({
                ...group,
                items: items.map((item)=>({
                        ...item,
                        isDisabled: end ? comparator(item.value, end.value) > 0 : false
                    }))
            }));
        return {
            groups: newGroups,
            defaultValue: start,
            onChange: (item)=>onRangeChange({
                    start: item,
                    end: end
                })
        };
    }
    getEndSelectProps() {
        const { groups: groups, start: start, end: end, comparator: comparator, onChange: onRangeChange } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newGroups = groups.map(({ items: items, ...group })=>({
                ...group,
                items: items.map((item)=>({
                        ...item,
                        isDisabled: start ? comparator(start.value, item.value) > 0 : false
                    }))
            }));
        return {
            groups: newGroups,
            defaultValue: end,
            onChange: (item)=>onRangeChange({
                    start: start,
                    end: item
                })
        };
    }
    render() {
        const { children: children, end: end, start: start } = this.props;
        const [startSelect, separator, endSelect] = children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.getSelectComponent(start, /*#__PURE__*/ (0, $eUqFw.cloneElement)(startSelect, this.getStartSelectProps())), separator, this.getSelectComponent(end, /*#__PURE__*/ (0, $eUqFw.cloneElement)(endSelect, this.getEndSelectProps())));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.getSelectComponent = (level, itemSelectEl)=>{
            if (level && level.label && level.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                label: level.label,
                name: level.name
            }, ()=>{
                if (level.showTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                    content: level.content
                }, itemSelectEl);
                return itemSelectEl;
            });
            return itemSelectEl;
        };
    }
}

});
parcelRegister("1vSyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a301e0712cdb58$export$2e2bcd8739ae039);

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $11a301e0712cdb58$var$lt = /*#__PURE__*/ (0, $ggdJA.default)(function lt(a, b) {
    return a < b;
});
var $11a301e0712cdb58$export$2e2bcd8739ae039 = $11a301e0712cdb58$var$lt;

});


parcelRegister("7iAcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2a1c893da1fb56$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6b2a1c893da1fb56$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    topHierarchyLevelLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.top-hierarchy-level-label",
        "defaultMessage": "From"
    },
    bottomHierarchyLevelLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.bottom-hierarchy-level-label",
        "defaultMessage": "To"
    },
    hierarchyFrom: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-from",
        "defaultMessage": "Hierarchy from:"
    },
    hierarchyTo: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.hierarchy-filter.hierarchy-to",
        "defaultMessage": "Hierarchy to:"
    }
});

});

parcelRegister("dVENQ", function(module, exports) {

$parcel$export(module.exports, "hierarchyFilter", () => $a2403fde8fbb53fe$export$a1a07870f153942d, (v) => $a2403fde8fbb53fe$export$a1a07870f153942d = v);
$parcel$export(module.exports, "separator", () => $a2403fde8fbb53fe$export$3e523c77c1f23f8c, (v) => $a2403fde8fbb53fe$export$3e523c77c1f23f8c = v);
var $a2403fde8fbb53fe$export$a1a07870f153942d;
var $a2403fde8fbb53fe$export$3e523c77c1f23f8c;
$a2403fde8fbb53fe$export$a1a07870f153942d = `SBxuMW_hierarchyFilter`;
$a2403fde8fbb53fe$export$3e523c77c1f23f8c = `SBxuMW_separator`;

});



parcelRegister("8WXPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9408d750eaa7ba$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7FsIT = parcelRequire("7FsIT");

var $34mLq = parcelRequire("34mLq");

var $8cMbw = parcelRequire("8cMbw");
var $4e9408d750eaa7ba$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $34mLq.default), (0, $7FsIT.default))((0, $8cMbw.default));

});
parcelRegister("7FsIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b3848e91bf7fc56$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $8b3848e91bf7fc56$var$mapDispatchToProps = (dispatch)=>({
        changeIssuePrioritiesFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
                value: payload
            }));
        },
        clearIssuePrioritiesFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d)));
        }
    });
var $8b3848e91bf7fc56$export$2e2bcd8739ae039 = $8b3848e91bf7fc56$var$mapDispatchToProps;

});

parcelRegister("34mLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e837e2328fc2d8$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("2vV9U");

var $jp3RH = parcelRequire("jp3RH");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
var $d6e837e2328fc2d8$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $jp3RH.getIssuePriorities),
    (0, $fbHoQ.getFilters),
    (0, $jp3RH.getIssuePrioritiesIdList),
    (0, $jp3RH.getIssuePriorities)
], (issuePriorities, { [(0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d)]: { id: id, value: value } }, issuePrioritiesIdList, prioritiesById)=>({
        id: id,
        value: value,
        issuePriorities: (0, $7CnHa.isDefined)(issuePrioritiesIdList) ? issuePrioritiesIdList.map((id)=>prioritiesById[id]) : Object.values(issuePriorities)
    }));

});

parcelRegister("8cMbw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3869ffd397685a14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("2vV9U");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $b1aFA = parcelRequire("b1aFA");
var $6uwgw = parcelRequire("6uwgw");

var $eG0CY = parcelRequire("eG0CY");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $bic1B = parcelRequire("bic1B");
const $3869ffd397685a14$var$CheckboxWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('checkbox', {
    onChange: 'changed'
})((0, $6ETZE.default));
// eslint-disable-next-line jira/react/no-class-components
class $3869ffd397685a14$var$IssuePrioritiesFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, isOpen: isOpen, value: value, searchQuery: searchQuery, onOpenChange: onOpenChange, onQueryChange: onQueryChange, clearIssuePrioritiesFilter: clearIssuePrioritiesFilter } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: clearIssuePrioritiesFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $bic1B.default).searchPriorityPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $bic1B.default).searchPriorityLabel)
            }), this.getIssuePriorities()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText(),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.trigger-btn"
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { issuePriorities: issuePriorities, value: value } = this.props;
            return issuePriorities.filter(({ id: id })=>$7d70y.default(id, value)).map(({ name: name })=>name).join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: this.constructFilterText()
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bic1B.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Priorities, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $bic1B.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isIssuePrioritySelected = (issuePriorityId)=>$7d70y.default(issuePriorityId, this.props.value);
        this.filterIssueTypesWithSearchQuery = (issuePriority)=>issuePriority.name.toLowerCase().includes(this.props.searchQuery.toLowerCase());
        this.getIssuePrioritiesOrder = (issuePriorityIds)=>{
            const { issuePriorities: issuePriorities } = this.props;
            return issuePriorities.filter(({ id: id })=>issuePriorityIds.includes(id)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((_, index)=>index);
        };
        this.onIssuePriorityClick = (issuePriorityId, analyticsEvent)=>{
            const { value: value, changeIssuePrioritiesFilter: changeIssuePrioritiesFilter } = this.props;
            let issuePriorityIds;
            if (this.isIssuePrioritySelected(issuePriorityId)) {
                issuePriorityIds = $fpul1.default((issuePriority)=>issuePriority !== issuePriorityId, value);
                changeIssuePrioritiesFilter(issuePriorityIds);
            } else {
                issuePriorityIds = [
                    ...value,
                    issuePriorityId
                ];
                changeIssuePrioritiesFilter(issuePriorityIds);
            }
            // Send an analytics event when the user updates the Issue Priorities filter
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATED_ISSUE_PRIORITIES_FILTER.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), {
                issuePrioritiesOrder: this.getIssuePrioritiesOrder(issuePriorityIds)
            });
        };
        this.getIssuePrioritiesOptions = (issuePriorities)=>issuePriorities.map(({ name: name, id: id, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3869ffd397685a14$var$CheckboxWithAnalytics, {
                    id: `${id}`,
                    key: id,
                    isChecked: this.isIssuePrioritySelected(id),
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange: (_, analyticsEvent)=>this.onIssuePriorityClick(id, analyticsEvent),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1aFA.default), {
                        avatarUrl: iconUrl,
                        id: id,
                        name: name,
                        appearance: "square",
                        size: "xsmall"
                    })
                })));
        this.getIssuePriorities = ()=>{
            const { issuePriorities: issuePriorities } = this.props;
            const filteredIssuePriorities = issuePriorities.filter(this.filterIssueTypesWithSearchQuery);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.getIssuePrioritiesOptions(filteredIssuePriorities), filteredIssuePriorities.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
        };
    }
}
var $3869ffd397685a14$export$2e2bcd8739ae039 = (0, $2qhQi.default)($3869ffd397685a14$var$IssuePrioritiesFilter);

});
parcelRegister("bic1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $857b86dce054d2d2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $857b86dce054d2d2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchPriorityPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.search-priority-placeholder",
        "defaultMessage": "Show issues from issue priority"
    },
    searchPriorityLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-priorities-filter.search-priority-label",
        "defaultMessage": "Choose from priorities"
    }
});

});



parcelRegister("9UH7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68c3c3b949860c9$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6h6CP = parcelRequire("6h6CP");

var $emwCK = parcelRequire("emwCK");

var $kTJqa = parcelRequire("kTJqa");
var $e68c3c3b949860c9$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $emwCK.default), (0, $6h6CP.default))((0, $kTJqa.default));

});
parcelRegister("6h6CP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bce136886b2555b$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $9bce136886b2555b$var$mapDispatchToProps = (dispatch)=>({
        changeIssueTypeKeyFilter: (value)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$a8ec3260a009d752),
                value: value
            }));
        },
        clearIssueTypeKeyFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$a8ec3260a009d752)));
        }
    });
var $9bce136886b2555b$export$2e2bcd8739ae039 = $9bce136886b2555b$var$mapDispatchToProps;

});

parcelRegister("emwCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b2326497ee46d2$export$2e2bcd8739ae039);

var $fcWBJ = parcelRequire("fcWBJ");

var $MdoH4 = parcelRequire("MdoH4");

var $gqs5m = parcelRequire("gqs5m");

var $fZW8G = parcelRequire("fZW8G");

var $lihml = parcelRequire("lihml");

var $iK4oF = parcelRequire("iK4oF");
const $a7b2326497ee46d2$export$cdd41b88f440e95a = (hierarchyTitles, issueTypeIconByKey, issueTypeById)=>{
    const issueTypeByLevel = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(Object.values(issueTypeById), ({ level: level })=>level);
    return Object.entries(issueTypeByLevel).sort(([firstLevel], [secondLevel])=>Number(secondLevel) - Number(firstLevel)).reduce((acc, [level, issueTypes])=>{
        const aggregatedIssueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(issueTypes.map(({ name: name })=>name)).sort().map((name)=>({
                name: name,
                iconUrl: issueTypeIconByKey[`${level} ${name}`] ?? '#'
            }));
        const aggregatedIssueTypeHierarchy = {
            level: Number(level),
            title: hierarchyTitles[Number(level)] ?? '',
            issueTypes: aggregatedIssueTypes
        };
        acc.push(aggregatedIssueTypeHierarchy);
        return acc;
    }, []);
};
const $a7b2326497ee46d2$var$getAggregatedIssueTypeHierarchies = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getHierarchyTitles),
    (0, $lihml.getIssueTypeIconByKey),
    (0, $fZW8G.getIssueTypeWithLevelById)
], $a7b2326497ee46d2$export$cdd41b88f440e95a);
const $a7b2326497ee46d2$var$mapStateToProps = (state)=>({
        value: (0, $gqs5m.getIssueTypeKeyFilterValue)(state),
        aggregatedIssueTypeHierarchy: $a7b2326497ee46d2$var$getAggregatedIssueTypeHierarchies(state)
    });
var $a7b2326497ee46d2$export$2e2bcd8739ae039 = $a7b2326497ee46d2$var$mapStateToProps;

});

parcelRegister("kTJqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a237ce750f30d70$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $03i9R = parcelRequire("03i9R");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $3nLf8 = parcelRequire("3nLf8");
var $b1aFA = parcelRequire("b1aFA");

var $eG0CY = parcelRequire("eG0CY");
parcelRequire("17gIb");

var $2qtl9 = parcelRequire("2qtl9");
parcelRequire("60RtM");
var $jlaua = parcelRequire("jlaua");
const $5a237ce750f30d70$var$IssueTypeKeyFilter = ({ value: value, aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy, searchQuery: searchQuery, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, changeIssueTypeKeyFilter: changeIssueTypeKeyFilter, clearIssueTypeKeyFilter: clearIssueTypeKeyFilter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getValueMatcher = (level, name)=>(currentValue)=>currentValue.level === level && currentValue.name === name;
    const onIssueTypeKeyClick = (level, name, isChecked)=>{
        if (isChecked) changeIssueTypeKeyFilter((0, (/*@__PURE__*/$parcel$interopDefault($03i9R)))(value, getValueMatcher(level, name)));
        else changeIssueTypeKeyFilter([
            ...value,
            {
                level: level,
                name: name
            }
        ]);
    };
    const renderIssueTypeKeyOptions = (level, aggregatedIssueTypes)=>aggregatedIssueTypes.map(({ name: name, iconUrl: iconUrl })=>{
            const isChecked = value.some(getValueMatcher(level, name));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                isChecked: isChecked,
                onChange: ()=>onIssueTypeKeyClick(level, name, isChecked),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1aFA.default), {
                    avatarUrl: iconUrl,
                    name: name,
                    appearance: "square",
                    size: "xsmall"
                })
            }));
        });
    const renderIssueTypeKeyGroups = ()=>{
        const groupItems = aggregatedIssueTypeHierarchy.map(({ level: level, title: title, issueTypes: issueTypes })=>{
            const filtered = issueTypes.filter(({ name: name })=>name.toLowerCase().includes(searchQuery.toLowerCase()));
            if (filtered.length === 0) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                heading: title,
                key: level
            }, renderIssueTypeKeyOptions(level, filtered));
        }).filter((groupItem)=>groupItem !== null);
        return groupItems.length > 0 ? groupItems : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        onClose: onOpenChange,
        isOpen: isOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
            isVisible: value.length > 0,
            onClearClick: clearIssueTypeKeyFilter
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
            placeholder: formatMessage((0, $2qtl9.default).searchIssueTypePlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange,
            ariaLabel: formatMessage((0, $2qtl9.default).searchIssueTypeLabel)
        }), renderIssueTypeKeyGroups()),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jlaua.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        value: value,
        aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy
    }));
};
var $5a237ce750f30d70$export$2e2bcd8739ae039 = $5a237ce750f30d70$var$IssueTypeKeyFilter;

});
parcelRegister("03i9R", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");

var $bRX4x = parcelRequire("bRX4x");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $009e5dc1ea78ed8e$var$reject(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $bRX4x($7qARj(predicate, 3)));
}
module.exports = $009e5dc1ea78ed8e$var$reject;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});


parcelRegister("2qtl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $977e5a7374353dad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $977e5a7374353dad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchIssueTypePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.search-issue-type-placeholder",
        "defaultMessage": "Show issues from issue types"
    },
    searchIssueTypeLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.search-issue-type-label",
        "defaultMessage": "Choose from issue types"
    }
});

});

parcelRegister("60RtM", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("jlaua")).default);

var $jlaua = parcelRequire("jlaua");

});
parcelRegister("jlaua", function(module, exports) {

$parcel$export(module.exports, "default", () => $a466b82ee7afbdbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("gqs5m");
parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $6uwgw = parcelRequire("6uwgw");

var $6g33d = parcelRequire("6g33d");

var $72vQW = parcelRequire("72vQW");
const $a466b82ee7afbdbc$var$IssueTypesFilterTrigger = ({ value: value, aggregatedIssueTypeHierarchy: aggregatedIssueTypeHierarchy, isOpen: isOpen, onOpenChange: onOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const validValues = value.filter(({ level: level, name: name })=>aggregatedIssueTypeHierarchy.find(({ level: hierarchyLevel })=>level === hierarchyLevel)?.issueTypes.some(({ name: aggregatedName })=>name === aggregatedName) ?? false);
    const filteredIssueTypeNames = validValues.map(({ name: name })=>name).join(', ');
    const triggerLabel = validValues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
        text: filteredIssueTypeNames
    }) : formatMessage((0, $72vQW.default).placeholder);
    const ariaLabel = `${formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$a8ec3260a009d752])}, ${validValues.length > 0 ? filteredIssueTypeNames : formatMessage((0, $72vQW.default).placeholder)} ${formatMessage((0, $6g33d.default).selected)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        triggerButtonText: triggerLabel,
        ariaLabel: ariaLabel,
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.trigger"
    });
};
var $a466b82ee7afbdbc$export$2e2bcd8739ae039 = $a466b82ee7afbdbc$var$IssueTypesFilterTrigger;

});
parcelRegister("72vQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3cacdb31c0fb37$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8a3cacdb31c0fb37$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-types-key-filter.trigger.placeholder",
        "defaultMessage": "All"
    }
});

});





parcelRegister("4Hv8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c3617dc743e5daf$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jmABs = parcelRequire("jmABs");

var $e1NOv = parcelRequire("e1NOv");

var $fG8m7 = parcelRequire("fG8m7");
var $0c3617dc743e5daf$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $e1NOv.default), (0, $jmABs.default))((0, $fG8m7.IssueWarningFilter));

});
parcelRegister("jmABs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c56d605410bb011$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $9c56d605410bb011$var$mapDispatchToProps = (dispatch)=>({
        onWarningFilterChange: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$59af687b450af7eb),
                value: payload
            }));
        },
        onClearWarningFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$59af687b450af7eb)));
        }
    });
var $9c56d605410bb011$export$2e2bcd8739ae039 = $9c56d605410bb011$var$mapDispatchToProps;

});

parcelRegister("e1NOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f648f74b030626e9$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");


var $iK4oF = parcelRequire("iK4oF");
const $f648f74b030626e9$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], ({ [(0, $12ee831723ccf9c2$export$59af687b450af7eb)]: { id: id, value: value } })=>({
        id: id,
        value: value
    }));
var $f648f74b030626e9$export$2e2bcd8739ae039 = $f648f74b030626e9$var$mapStateToProps;

});

parcelRegister("fG8m7", function(module, exports) {

$parcel$export(module.exports, "IssueWarningFilter", () => $d0a59a4089852c40$export$3813e023bf5ce236);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $hFkwG = parcelRequire("hFkwG");

parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $6uwgw = parcelRequire("6uwgw");

var $6g33d = parcelRequire("6g33d");

var $c5eeg = parcelRequire("c5eeg");
const $d0a59a4089852c40$var$WarningMenuItem = ({ warningType: warningType, messages: // eslint-disable-next-line @typescript-eslint/no-shadow
messages, value: value, onWarningFilterChange: onWarningFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChange = (0, $eUqFw.useCallback)(()=>onWarningFilterChange(value.includes(warningType) ? value.filter((x)=>x !== warningType) : [
            ...value,
            warningType
        ]), [
        onWarningFilterChange,
        warningType,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
        key: warningType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        id: warningType,
        key: warningType,
        isChecked: value.includes(warningType),
        onChange: onChange,
        label: formatMessage(messages.header)
    }));
};
const $d0a59a4089852c40$export$3813e023bf5ce236 = ({ value: value, onWarningFilterChange: onWarningFilterChange, onClearWarningFilter: onClearWarningFilter, onOpenChange: onOpenChange, isOpen: isOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterText = (0, $eUqFw.useMemo)(()=>value.length > 0 ? value.map((id)=>(0, $hFkwG.WarningTypes)[id])// eslint-disable-next-line @typescript-eslint/no-shadow
        .filter((messages)=>messages !== undefined)// eslint-disable-next-line @typescript-eslint/no-shadow
        .map((messages)=>formatMessage(messages.header)).join(', ') : '', [
        value,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        onClose: onOpenChange,
        isOpen: isOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
            isVisible: !!value.length,
            onClearClick: onClearWarningFilter
        }), // eslint-disable-next-line @typescript-eslint/no-shadow
        Object.entries((0, $hFkwG.WarningTypes)).map(([warningType, messages])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0a59a4089852c40$var$WarningMenuItem, {
                key: warningType,
                warningType: warningType,
                messages: messages,
                value: value,
                onWarningFilterChange: onWarningFilterChange
            }))),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter.trigger-btn",
        triggerButtonText: value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
            text: filterText
        }) : formatMessage((0, $c5eeg.default).emptyPlaceholder),
        ariaLabel: `${formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$59af687b450af7eb])}, ${value.length > 0 ? filterText : formatMessage((0, $c5eeg.default).emptyPlaceholder)} ${formatMessage((0, $6g33d.default).selected)}`
    }));
};

});
parcelRegister("c5eeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3196957342c0d4a6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3196957342c0d4a6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.issue-warning-filter.empty-placeholder",
        "defaultMessage": "All issues"
    }
});

});



parcelRegister("2XBb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cbb08b83148c0c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hRKeT = parcelRequire("hRKeT");

var $b1kk3 = parcelRequire("b1kk3");

var $9qogX = parcelRequire("9qogX");
var $e3cbb08b83148c0c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $b1kk3.default), (0, $hRKeT.default))((0, $9qogX.default));

});
parcelRegister("hRKeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aa3c6ffc73d5efd$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("5Rz3d");
const $0aa3c6ffc73d5efd$var$mapDispatchToProps = (dispatch)=>({
        changeFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$7e257b719377371e),
                value: payload
            }));
        },
        clearFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$7e257b719377371e)));
        }
    });
var $0aa3c6ffc73d5efd$export$2e2bcd8739ae039 = $0aa3c6ffc73d5efd$var$mapDispatchToProps;

});

parcelRegister("b1kk3", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ae4b09bd356881$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("5Rz3d");

var $94enn = parcelRequire("94enn");
const $12ae4b09bd356881$var$mapStateToProps = (state)=>{
    const labels = (0, $94enn.getIssueLabels)(state);
    const { [(0, $12ee831723ccf9c2$export$7e257b719377371e)]: { id: id, value: value } } = (0, $fbHoQ.getFilters)(state);
    return {
        id: id,
        value: value,
        labels: labels
    };
};
var $12ae4b09bd356881$export$2e2bcd8739ae039 = $12ae4b09bd356881$var$mapStateToProps;

});

parcelRegister("9qogX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26953129f5bd7e2a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");

var $5Rz3d = parcelRequire("5Rz3d");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $7Iub8 = parcelRequire("7Iub8");

var $eG0CY = parcelRequire("eG0CY");

var $17gIb = parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $dsU7U = parcelRequire("dsU7U");
// eslint-disable-next-line jira/react/no-class-components
class $26953129f5bd7e2a$var$LabelFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, labels: labels, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearFilter: clearFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
        const searchResultLabels = labels.filter(this.filterLabelsWithSearchQuery);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: clearFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $dsU7U.default).searchLabelsPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $dsU7U.default).searchLabelsAriaLabel)
            }), !!searchResultLabels.length && this.renderNoLabel(), this.renderLabels(searchResultLabels)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.trigger-btn",
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { labels: labels, value: value, intl: intl } = this.props;
            const filteredValues = labels.filter((label)=>$7d70y.default(label, value));
            return $7d70y.default((0, $5Rz3d.NO_LABEL_ID), value) ? [
                intl.formatMessage({
                    ...(0, $dsU7U.default).noLabelsFilterText
                }),
                ...filteredValues
            ].join(', ') : filteredValues.join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            const filterText = this.constructFilterText();
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dsU7U.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Labels, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$7e257b719377371e])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $dsU7U.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isLabelSelected = (label)=>$7d70y.default(label, this.props.value);
        this.filterLabelsWithSearchQuery = (label)=>label.toLowerCase().includes(this.props.searchQuery.toLowerCase());
        this.onLabelClick = (clickedLabel)=>{
            const { value: value, changeFilter: changeFilter } = this.props;
            if (this.isLabelSelected(clickedLabel)) changeFilter($fpul1.default((label)=>label !== clickedLabel, value));
            else changeFilter([
                ...value,
                clickedLabel
            ]);
        };
        this.renderNoLabel = ()=>{
            const { intl: intl } = this.props;
            const name = intl.formatMessage({
                ...(0, $dsU7U.default).noLabelsFilterText
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: (0, $5Rz3d.NO_LABEL_ID),
                key: (0, $5Rz3d.NO_LABEL_ID),
                isChecked: this.isLabelSelected((0, $5Rz3d.NO_LABEL_ID)),
                onChange: ()=>this.onLabelClick((0, $5Rz3d.NO_LABEL_ID)),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                    content: name,
                    id: (0, $5Rz3d.NO_LABEL_ID)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $17gIb.checkboxLabel
                }, name))
            }));
        };
        this.renderLabels = (searchResultLabels)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, searchResultLabels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: `${index}`,
                    key: index,
                    isChecked: this.isLabelSelected(label),
                    onChange: ()=>this.onLabelClick(label),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        content: label,
                        id: index
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $17gIb.checkboxLabel
                    }, label))
                }))), searchResultLabels.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
    }
}
var $26953129f5bd7e2a$export$2e2bcd8739ae039 = (0, $2qhQi.default)($26953129f5bd7e2a$var$LabelFilter);

});
parcelRegister("dsU7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5326c2109d35afa2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5326c2109d35afa2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchLabelsPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.search-labels-placeholder",
        "defaultMessage": "Show issues from labels"
    },
    noLabelsFilterText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.no-labels-filter-text",
        "defaultMessage": "No label"
    },
    searchLabelsAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.label-filter.search-labels-aria-label",
        "defaultMessage": "Choose from labels"
    }
});

});



parcelRegister("5gTDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9188cab55e3480fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jg4SU = parcelRequire("jg4SU");
const $9188cab55e3480fc$var$FilterOptions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jg4SU.default), null));
var $9188cab55e3480fc$export$2e2bcd8739ae039 = $9188cab55e3480fc$var$FilterOptions;

});
parcelRegister("jg4SU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b63861761962b2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4s8vc = parcelRequire("4s8vc");

var $hskeN = parcelRequire("hskeN");

var $aEznq = parcelRequire("aEznq");
var $e2b63861761962b2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hskeN.default), (0, $4s8vc.default))((0, $aEznq.default));

});
parcelRegister("4s8vc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e56b34aa328fa242$export$2e2bcd8739ae039);
parcelRequire("9RC35");
var $3rc1Q = parcelRequire("3rc1Q");
const $e56b34aa328fa242$var$mapDispatchToProps = (dispatch)=>({
        toggleShowFullHierarchy: ()=>{
            dispatch((0, $3rc1Q.toggleShowFullHierarchy)());
        }
    });
var $e56b34aa328fa242$export$2e2bcd8739ae039 = $e56b34aa328fa242$var$mapDispatchToProps;

});
parcelRegister("9RC35", function(module, exports) {

$parcel$export(module.exports, "toggleShowFullHierarchy", () => (parcelRequire("3rc1Q")).toggleShowFullHierarchy);

var $3rc1Q = parcelRequire("3rc1Q");

});
parcelRegister("3rc1Q", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_SHOW_FULL_HIERARCHY", () => $a8e9118fe6e89400$export$2dd3c7fec17f3ab0);
$parcel$export(module.exports, "RESET_FILTER_OPTIONS", () => $a8e9118fe6e89400$export$a9d7c14600b4285c);
$parcel$export(module.exports, "toggleShowFullHierarchy", () => $a8e9118fe6e89400$export$8e1f41da5d253fc9);
const $a8e9118fe6e89400$export$2dd3c7fec17f3ab0 = 'state.domain.view-settings.filter-options.TOGGLE_SHOW_FULL_HIERARCHY';
const $a8e9118fe6e89400$export$6d843f8910970c90 = 'state.domain.view-settings.filter-options.TOGGLE_AUTO_EXPAND_TO_SHOW_ISSUES_MATCHING_FILTER';
const $a8e9118fe6e89400$export$a9d7c14600b4285c = 'state.domain.view-settings.filter-options.RESET_FILTER_OPTIONS';
const $a8e9118fe6e89400$export$8e1f41da5d253fc9 = ()=>({
        type: $a8e9118fe6e89400$export$2dd3c7fec17f3ab0
    });
const $a8e9118fe6e89400$export$df9c7baa802c70f8 = (payload)=>({
        type: $a8e9118fe6e89400$export$a9d7c14600b4285c,
        payload: payload
    });

});



parcelRegister("hskeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $003131bf6c1fc6d8$export$2e2bcd8739ae039);

var $6WF4e = parcelRequire("6WF4e");

var $iK4oF = parcelRequire("iK4oF");
const $003131bf6c1fc6d8$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $6WF4e.getShowFullHierarchy)
], (showFullHierarchy)=>({
        showFullHierarchy: showFullHierarchy
    }));
var $003131bf6c1fc6d8$export$2e2bcd8739ae039 = $003131bf6c1fc6d8$var$mapStateToProps;

});

parcelRegister("aEznq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f06d8c0684483cb2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");

var $89V3C = parcelRequire("89V3C");
// eslint-disable-next-line jira/react/no-class-components
class $f06d8c0684483cb2$var$ShowFullHierarchyOption extends (0, $eUqFw.Component) {
    render() {
        const { showFullHierarchy: showFullHierarchy, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
            onChange: this.toggleShowFullHierarchy,
            label: intl.formatMessage((0, $89V3C.default).showFullHierarchy),
            isChecked: showFullHierarchy
        });
    }
    constructor(...args){
        super(...args);
        this.toggleShowFullHierarchy = ()=>{
            this.props.toggleShowFullHierarchy();
        };
    }
}
var $f06d8c0684483cb2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($f06d8c0684483cb2$var$ShowFullHierarchyOption);

});
parcelRegister("89V3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $5505ce3040ee4e21$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5505ce3040ee4e21$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showFullHierarchy: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.options.show-full-hierarchy.show-full-hierarchy",
        "defaultMessage": "Show full hierarchy"
    }
});

});




parcelRegister("fRTqhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $080fe0104ce74f8a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $dnNfk = parcelRequire("dnNfk");

var $1hOQc = parcelRequire("1hOQc");

var $fhXn2 = parcelRequire("fhXn2");
var $080fe0104ce74f8a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1hOQc.default), (0, $dnNfk.default))((0, $fhXn2.default));

});
parcelRegister("dnNfk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf2795648f5e35a$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $ddf2795648f5e35a$var$mapDispatchToProps = (dispatch)=>({
        changeProjectFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8),
                value: payload
            }));
        },
        clearProjectFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8)));
        }
    });
var $ddf2795648f5e35a$export$2e2bcd8739ae039 = $ddf2795648f5e35a$var$mapDispatchToProps;

});

parcelRegister("1hOQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f1cc4916f6b56c3$export$2e2bcd8739ae039);

var $hkOxK = parcelRequire("hkOxK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("68BNT");

var $ehEr2 = parcelRequire("ehEr2");

var $iK4oF = parcelRequire("iK4oF");
var $5f1cc4916f6b56c3$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjects),
    (0, $fbHoQ.getFilters)
], (projects, { [(0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8)]: { id: id, value: value } })=>({
        id: id,
        value: value,
        projects: $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('name')))(projects)
    }));

});

parcelRegister("fhXn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08984bc475016f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hkOxK = parcelRequire("hkOxK");
var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");
var $jDSc6 = parcelRequire("jDSc6");
var $1l9vO = parcelRequire("1l9vO");
var $f7Op5 = parcelRequire("f7Op5");
var $701od = parcelRequire("701od");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("68BNT");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $b1aFA = parcelRequire("b1aFA");
var $6uwgw = parcelRequire("6uwgw");

var $eG0CY = parcelRequire("eG0CY");

var $6g33d = parcelRequire("6g33d");

var $dRO4l = parcelRequire("dRO4l");
// eslint-disable-next-line jira/react/no-class-components
class $b08984bc475016f7$var$ProjectFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearProjectFilter: clearProjectFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: clearProjectFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $dRO4l.default).searchProjectPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $dRO4l.default).searchProjectLabel)
            }), this.renderProjectGroups()),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.trigger-btn",
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { projects: projects, value: value } = this.props;
            return projects.filter(({ id: id })=>$7d70y.default(id, value)).map(({ name: name })=>name).join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            const filterText = this.constructFilterText();
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dRO4l.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Projects, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $dRO4l.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isProjectSelected = (projectId)=>$7d70y.default(projectId, this.props.value);
        this.filterProjectsWithSearchQuery = (project)=>{
            const queryMatchProp = $hkOxK.default($1l9vO.default($701od.default(this.props.searchQuery)), $701od.default, // @ts-expect-error - TS2769 - No overload matches this call.
            $jDSc6.default($f7Op5.default)(project));
            return queryMatchProp('name') || queryMatchProp('key');
        };
        this.onProjectClick = (projectId)=>{
            const { value: value, changeProjectFilter: changeProjectFilter } = this.props;
            if (this.isProjectSelected(projectId)) changeProjectFilter($fpul1.default((project)=>project !== projectId, value));
            else changeProjectFilter([
                ...value,
                projectId
            ]);
        };
        this.renderProjectGroups = ()=>{
            // @ts-expect-error - TS2769 - No overload matches this call.
            const searchResultProjects = this.props.projects.filter(this.filterProjectsWithSearchQuery);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, searchResultProjects.map(({ id: id, key: key, name: name, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: `${id}`,
                    key: id,
                    isChecked: this.isProjectSelected(id),
                    onChange: ()=>this.onProjectClick(id),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1aFA.default), {
                        avatarUrl: avatarUrl,
                        id: id,
                        projectKey: key,
                        name: name
                    })
                }))), searchResultProjects.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
        };
    }
}
var $b08984bc475016f7$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b08984bc475016f7$var$ProjectFilter);

});
parcelRegister("dRO4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1c1d2abf5f927f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb1c1d2abf5f927f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchProjectPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.search-project-placeholder",
        "defaultMessage": "Show issues from projects"
    },
    searchProjectLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.project-filter.search-project-label",
        "defaultMessage": "Choose from projects"
    }
});

});



parcelRegister("hlsFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bedcc7cf31d764ec$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fg7sT = parcelRequire("fg7sT");

var $2GmXp = parcelRequire("2GmXp");

var $jQgdv = parcelRequire("jQgdv");
var $bedcc7cf31d764ec$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $2GmXp.default), (0, $fg7sT.default))((0, $jQgdv.default));

});
parcelRegister("fg7sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6884969b2e0f204e$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("38iYP");
parcelRequire("3nT5G");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6884969b2e0f204e$export$2e2bcd8739ae039 = (dispatch)=>({
        changeReleaseFilter: (id, payload)=>{
            dispatch((0, $296Gg.change)({
                id: id,
                value: payload
            }));
        },
        clearReleaseFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$585fb3e81bcfccad)));
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$53e2f8996e102881)));
        }
    });

});

parcelRegister("2GmXp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4b5a610bc602cb$export$2e2bcd8739ae039);

var $2Ruxt = parcelRequire("2Ruxt");

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("38iYP");
parcelRequire("3nT5G");

var $ehEr2 = parcelRequire("ehEr2");

var $wcCGG = parcelRequire("wcCGG");

var $hFzsN = parcelRequire("hFzsN");

var $iK4oF = parcelRequire("iK4oF");
const $6c4b5a610bc602cb$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $ehEr2.getProjects),
    (0, $2Ruxt.getCrossProjectVersions),
    (0, $2Ruxt.getCrossProjectVersionsById),
    (0, $wcCGG.getVersionsById),
    (0, $fbHoQ.getFilters)
], (projects, crossProjectVersions, crossProjectVersionsById, versionsById, { [(0, $12ee831723ccf9c2$export$53e2f8996e102881)]: { id: id, value: value }, [(0, $12ee831723ccf9c2$export$585fb3e81bcfccad)]: { value: crossProjectReleaseFilterValue = [] } })=>({
        id: id,
        value: value,
        crossProjectReleaseFilterValue: crossProjectReleaseFilterValue,
        crossProjectVersions: (0, $hFzsN.sortAsLowerCaseByNameProp)(crossProjectVersions),
        projects: (0, $hFzsN.sortAsLowerCaseByNameProp)(projects),
        versionsById: versionsById,
        crossProjectVersionsById: crossProjectVersionsById
    }));
var $6c4b5a610bc602cb$export$2e2bcd8739ae039 = $6c4b5a610bc602cb$var$mapStateToProps;

});
parcelRegister("hFzsN", function(module, exports) {

$parcel$export(module.exports, "sortAsLowerCaseByNameProp", () => $209678e1807198ec$export$93166931f01f58c9);
// This module contains resable functions composed from Ramda

var $hkOxK = parcelRequire("hkOxK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");
const $209678e1807198ec$export$93166931f01f58c9 = $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('name')));

});


parcelRegister("jQgdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $494ba201de313ed1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");
var $b3iuB = parcelRequire("b3iuB");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
var $ffiyv = parcelRequire("ffiyv");
parcelRequire("38iYP");

var $3nT5G = parcelRequire("3nT5G");

var $3Yj7v = parcelRequire("3Yj7v");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $b1aFA = parcelRequire("b1aFA");
var $6uwgw = parcelRequire("6uwgw");

var $7CnHa = parcelRequire("7CnHa");

var $hFzsN = parcelRequire("hFzsN");

var $7Iub8 = parcelRequire("7Iub8");

var $ib5d3 = parcelRequire("ib5d3");

var $eG0CY = parcelRequire("eG0CY");

var $17gIb = parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $cULlX = parcelRequire("cULlX");

var $cA4g3 = parcelRequire("cA4g3");
// eslint-disable-next-line jira/react/no-class-components
class $494ba201de313ed1$var$ReleaseFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, searchQuery: searchQuery } = this.props;
        const searchResultsLength = this.getFilteredProjects().length + this.getFilteredCrossProjectVersions().length;
        const label = searchResultsLength > 0 ? intl.formatMessage((0, $cULlX.default).searchResultsCount, {
            totalCount: searchResultsLength
        }) : intl.formatMessage((0, $ib5d3.default).noMatchFoundText);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: this.shouldClearRenderButtonRender(),
                onClearClick: this.onClearClick
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $cULlX.default).searchReleasesPlaceholder),
                searchQuery: searchQuery,
                ariaLabel: intl.formatMessage((0, $cULlX.default).searchReleasesLabel),
                onQueryChange: this.onSearchQueryChange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Yj7v.DelayedAnnouncer), {
                ref: this.announcerRef,
                label: label
            }), !$b3iuB.default(this.props.versionsById) && this.renderNoReleases(), this.renderCrossProjectReleasesGroup(), this.renderProjectGroups(), searchResultsLength === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            triggerButtonText: this.renderFilterText(),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.trigger-btn",
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.announcerRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.onVersionClick = (id, isSelected)=>{
            const { value: value, changeReleaseFilter: changeReleaseFilter } = this.props;
            if (isSelected) changeReleaseFilter((0, $12ee831723ccf9c2$export$53e2f8996e102881), [
                ...value,
                id
            ]);
            else changeReleaseFilter((0, $12ee831723ccf9c2$export$53e2f8996e102881), $fpul1.default((version)=>version !== id, value));
        };
        this.onCrossProjectVersionClick = (id, isSelected)=>{
            const { crossProjectReleaseFilterValue: crossProjectReleaseFilterValue, changeReleaseFilter: changeReleaseFilter } = this.props;
            if (isSelected) changeReleaseFilter((0, $12ee831723ccf9c2$export$585fb3e81bcfccad), [
                ...crossProjectReleaseFilterValue,
                id
            ]);
            else changeReleaseFilter((0, $12ee831723ccf9c2$export$585fb3e81bcfccad), $fpul1.default((version)=>version !== id, crossProjectReleaseFilterValue));
        };
        this.onClearClick = ()=>this.props.clearReleaseFilter();
        this.getVersion = (versionId)=>{
            const { versionsById: versionsById } = this.props;
            return versionsById[versionId];
        };
        this.filterProjectsWithSearchQuery = (project)=>project.versions.map(this.getVersion).some(this.filterVersionsWithSearchQuery);
        this.filterVersionsWithSearchQuery = (version)=>{
            const { name: name, crossProjectVersion: crossProjectVersion } = version;
            const { crossProjectVersionsById: crossProjectVersionsById, searchQuery: searchQuery } = this.props;
            if ((0, $7CnHa.isDefined)(crossProjectVersion) && (0, $7CnHa.isDefined)(crossProjectVersionsById[crossProjectVersion])) return name.toLowerCase().includes(searchQuery.toLowerCase()) || crossProjectVersionsById[crossProjectVersion].name.toLowerCase().includes(searchQuery.toLowerCase());
            return name.toLowerCase().includes(searchQuery.toLowerCase());
        };
        this.constructFilterText = ()=>{
            const { versionsById: versionsById, value: value, crossProjectVersions: crossProjectVersions, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue, intl: intl } = this.props;
            const versionNames = (0, $hFzsN.sortAsLowerCaseByNameProp)((0, $7CnHa.values)(versionsById)).filter(({ id: id })=>$7d70y.default(id, value)).map(({ name: name })=>name);
            const crossProjectVersionNames = (0, $hFzsN.sortAsLowerCaseByNameProp)(crossProjectVersions).filter(({ id: id })=>$7d70y.default(id, crossProjectReleaseFilterValue)).map(({ name: name })=>name);
            if ($7d70y.default((0, $3nT5G.NO_RELEASE_ID), value)) return [
                intl.formatMessage({
                    ...(0, $cULlX.default).noReleasesFilterText
                }),
                ...versionNames,
                ...crossProjectVersionNames
            ].join(', ');
            return [
                ...versionNames,
                ...crossProjectVersionNames
            ].join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
            const filterText = this.constructFilterText();
            return value.length > 0 || crossProjectReleaseFilterValue.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cULlX.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Releases, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$53e2f8996e102881])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $cULlX.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.getFilteredCrossProjectVersions = ()=>{
            const { crossProjectVersions: crossProjectVersions, searchQuery: searchQuery } = this.props;
            return crossProjectVersions.filter(({ name: name })=>name.toLowerCase().includes(searchQuery.toLowerCase()));
        };
        this.renderCrossProjectReleasesGroup = ()=>{
            const { intl: intl, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
            const isSelected = (versionId)=>$7d70y.default(versionId, crossProjectReleaseFilterValue);
            const filteredCrossProjectVersions = this.getFilteredCrossProjectVersions();
            if (filteredCrossProjectVersions.length === 0) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                heading: intl.formatMessage((0, $ib5d3.default).crossProjectReleases)
            }, filteredCrossProjectVersions.length > 0 && filteredCrossProjectVersions.map((version)=>{
                const { id: id, name: name } = version;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: id,
                    key: id,
                    name: name,
                    isChecked: isSelected(id),
                    onChange: ()=>this.onCrossProjectVersionClick(id, !isSelected(id)),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        id: id,
                        content: name
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $17gIb.checkboxLabel
                    }, name))
                }));
            }));
        };
        this.getFilteredProjects = ()=>{
            const { projects: projects } = this.props;
            return projects.filter((project)=>project.isReleasesEnabled && this.filterProjectsWithSearchQuery(project));
        };
        this.renderProjectGroups = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.getFilteredProjects().map(({ id: id, name: name, key: key, versions: versions, avatarUrl: avatarUrl })=>{
                const projectTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1aFA.default), {
                    avatarUrl: avatarUrl,
                    id: id,
                    projectKey: key,
                    name: name
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                    heading: projectTitle,
                    key: id
                }, this.renderVersionOptions(versions));
            }));
        this.renderVersionOptions = (versions)=>{
            const { value: value, crossProjectVersionsById: crossProjectVersionsById } = this.props;
            const isSelected = (versionId)=>$7d70y.default(versionId, value);
            const sortedVersionObjects = (0, $hFzsN.sortAsLowerCaseByNameProp)(versions.map(this.getVersion));
            return sortedVersionObjects.filter(this.filterVersionsWithSearchQuery).map((version)=>{
                const { id: id, name: name, crossProjectVersion: crossProjectVersion } = version;
                const doesHaveCrossProjectVersionThatIsNotDeleted = (0, $7CnHa.isDefined)(crossProjectVersion) && (0, $7CnHa.isDefined)(crossProjectVersionsById[crossProjectVersion]);
                const crossProjectVersionName = doesHaveCrossProjectVersionThatIsNotDeleted ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                crossProjectVersionsById[crossProjectVersion].name : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: id,
                    key: id,
                    name: name,
                    isChecked: isSelected(id),
                    onChange: ()=>this.onVersionClick(id, !isSelected(id)),
                    label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $cA4g3.crossProjectReleaseOption
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $cA4g3.crossProjectReleaseName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        content: name,
                        id: id
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, name))), (0, $7CnHa.isDefined)(crossProjectVersion) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $cA4g3.crossProjectReleaseLozenge
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                        maxWidth: 100
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        content: crossProjectVersionName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, crossProjectVersionName)))))
                }));
            });
        };
        this.renderNoReleases = ()=>{
            const { value: value, intl: intl } = this.props;
            const id = (0, $3nT5G.NO_RELEASE_ID);
            const name = intl.formatMessage({
                ...(0, $cULlX.default).noReleasesFilterText
            });
            const isSelected = (versionId)=>$7d70y.default(versionId, value);
            const selected = isSelected(id);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: id,
                key: id,
                name: name,
                isChecked: selected,
                onChange: ()=>this.onVersionClick(id, !isSelected(id)),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                    content: name,
                    id: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $17gIb.checkboxLabel
                }, name))
            }));
        };
        this.shouldClearRenderButtonRender = ()=>{
            const { value: value, crossProjectReleaseFilterValue: crossProjectReleaseFilterValue } = this.props;
            if (!(value.length || crossProjectReleaseFilterValue.length)) return false;
            return true;
        };
        this.onSearchQueryChange = (query)=>{
            this.props.onQueryChange(query);
            this.announcerRef.current?.announce();
        };
    }
}
var $494ba201de313ed1$export$2e2bcd8739ae039 = (0, $2qhQi.default)($494ba201de313ed1$var$ReleaseFilter);

});
parcelRegister("3Yj7v", function(module, exports) {

$parcel$export(module.exports, "DelayedAnnouncer", () => $dbf16b441776778c$export$92b86912c718fcf2);

var $eUqFw = parcelRequire("eUqFw");

var $lkPEe = parcelRequire("lkPEe");
const $dbf16b441776778c$export$92b86912c718fcf2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ label: label, waitBeforeAnnouncement: waitBeforeAnnouncement = 300 }, ref)=>{
    const [isAnnounced, setIsAnnounced] = (0, $eUqFw.useState)(false);
    const announcementTrigger = (0, $eUqFw.useCallback)(()=>{
        setIsAnnounced(false);
        const timer = setTimeout(()=>{
            setIsAnnounced(true);
        }, waitBeforeAnnouncement);
        return ()=>clearTimeout(timer);
    }, [
        waitBeforeAnnouncement
    ]);
    (0, $eUqFw.useImperativeHandle)(ref, ()=>({
            announce: announcementTrigger
        }));
    (0, $eUqFw.useEffect)(announcementTrigger, [
        waitBeforeAnnouncement,
        announcementTrigger,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
        key: String(isAnnounced)
    }, label)));
});

});

parcelRegister("cULlX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e424837d1cefb53$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3e424837d1cefb53$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchReleasesPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-releases-placeholder",
        "defaultMessage": "Show issues from releases"
    },
    noReleasesFilterText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.no-releases-filter-text",
        "defaultMessage": "No release"
    },
    searchReleasesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-releases-label",
        "defaultMessage": "Choose from releases"
    },
    searchResultsCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.release-filter.search-results-count",
        "defaultMessage": "{totalCount, plural, one {# suggestion} other {# suggestions}} available"
    }
});

});

parcelRegister("cA4g3", function(module, exports) {

$parcel$export(module.exports, "crossProjectReleaseLozenge", () => $928c2661ef07da6d$export$be8ecdd1dde7847a, (v) => $928c2661ef07da6d$export$be8ecdd1dde7847a = v);
$parcel$export(module.exports, "crossProjectReleaseName", () => $928c2661ef07da6d$export$ad543e317dba39b7, (v) => $928c2661ef07da6d$export$ad543e317dba39b7 = v);
$parcel$export(module.exports, "crossProjectReleaseOption", () => $928c2661ef07da6d$export$dd5faf32de3b1cad, (v) => $928c2661ef07da6d$export$dd5faf32de3b1cad = v);
var $928c2661ef07da6d$export$be8ecdd1dde7847a;
var $928c2661ef07da6d$export$ad543e317dba39b7;
var $928c2661ef07da6d$export$dd5faf32de3b1cad;
$928c2661ef07da6d$export$be8ecdd1dde7847a = `mo_vea_crossProjectReleaseLozenge`;
$928c2661ef07da6d$export$ad543e317dba39b7 = `mo_vea_crossProjectReleaseName`;
$928c2661ef07da6d$export$dd5faf32de3b1cad = `mo_vea_crossProjectReleaseOption`;

});



parcelRegister("aViBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ba8b5a31f896e2$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1uNmm = parcelRequire("1uNmm");

var $3Sw8s = parcelRequire("3Sw8s");

var $aYTHx = parcelRequire("aYTHx");
var $46ba8b5a31f896e2$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3Sw8s.default), (0, $1uNmm.default))((0, $aYTHx.default));

});
parcelRegister("1uNmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6985d04d521be9e$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $e6985d04d521be9e$var$mapDispatchToProps = (dispatch)=>({
        onRequestChange: (payload)=>dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$20140793a0aa2b3c),
                value: payload
            })),
        onRequestClear: ()=>dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$20140793a0aa2b3c)))
    });
var $e6985d04d521be9e$export$2e2bcd8739ae039 = $e6985d04d521be9e$var$mapDispatchToProps;

});

parcelRegister("3Sw8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f05745b9a1edf6$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");

var $f436g = parcelRequire("f436g");


var $iK4oF = parcelRequire("iK4oF");
const $37f05745b9a1edf6$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $f436g.getReporterForFilter),
    (0, $fbHoQ.getFilters)
], (reporters, { [(0, $12ee831723ccf9c2$export$20140793a0aa2b3c)]: { id: id, value: value } })=>({
        id: id,
        value: value,
        reporters: reporters
    }));
var $37f05745b9a1edf6$export$2e2bcd8739ae039 = $37f05745b9a1edf6$var$mapStateToProps;

});

parcelRegister("aYTHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $563dcfd6e88d7a07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5OdRK = parcelRequire("5OdRK");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $b3iuB = parcelRequire("b3iuB");
var $63hMP = parcelRequire("63hMP");
var $3IGDG = parcelRequire("3IGDG");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("f436g");

var $fwzA0 = parcelRequire("fwzA0");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $eG0CY = parcelRequire("eG0CY");

var $gkXIa = parcelRequire("gkXIa");

var $6g33d = parcelRequire("6g33d");

var $2rruw = parcelRequire("2rruw");
function $563dcfd6e88d7a07$export$2ed0b1dd6bae3b05({ person: person, checked: checked, onChange: onChange }) {
    const { title: title, email: email, avatarUrl: avatarUrl } = person.jiraUser;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        value: person.personId,
        isChecked: checked,
        onChange: onChange,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gkXIa.UserSelectItem), {
            email: email,
            label: title,
            icon: avatarUrl
        })
    });
}
function $563dcfd6e88d7a07$var$ReporterFilter({ intl: intl, searchQuery: searchQuery, onQueryChange: onQueryChange, value: value, onRequestChange: onRequestChange, onRequestClear: onRequestClear, reporters: reporters }) {
    const isSelected = (reporter)=>$1l9vO.default(reporter.personId, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleReporterCheckboxChange = (e)=>{
        const { value: personId, checked: checked } = e.currentTarget;
        const nextValue = (()=>{
            const withoutTheReporter = $fpul1.default($3IGDG.default($5OdRK.default(personId), $63hMP.default))(value);
            if (!checked) return withoutTheReporter;
            return withoutTheReporter.concat([
                personId
            ]);
        })();
        onRequestChange(nextValue);
    };
    const reportersToDisplay = (0, $fwzA0.sortPerson)((0, $fwzA0.filter)(searchQuery, reporters));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
        isVisible: !!value.length,
        onClearClick: onRequestClear
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
        placeholder: intl.formatMessage((0, $2rruw.default).searchReporterPlaceholder),
        searchQuery: searchQuery,
        onQueryChange: onQueryChange,
        ariaLabel: intl.formatMessage((0, $2rruw.default).searchReporterLabel)
    }), reportersToDisplay.map((reporter, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($563dcfd6e88d7a07$export$2ed0b1dd6bae3b05, {
            checked: isSelected(reporter),
            onChange: handleReporterCheckboxChange,
            person: reporter
        }))), $b3iuB.default(reportersToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
}
const $563dcfd6e88d7a07$var$getNames = (reporters, selected)=>{
    const selectedReporters = reporters.filter((person)=>selected.has(person.personId));
    const names = selectedReporters.map((person)=>person.jiraUser.title);
    return names.join(', ');
};
function $563dcfd6e88d7a07$export$8bd0edd7ca02ab5f({ value: value, persons: persons }) {
    const selected = new Set(value);
    if (selected.size === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2rruw.default).emptyPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
        text: $563dcfd6e88d7a07$var$getNames(persons, selected)
    });
}
function $563dcfd6e88d7a07$var$ReporterFilterDialog(props) {
    const { isOpen: isOpen, onOpenChange: onOpenChange, value: value, intl: intl, reporters: reporters } = props;
    const ariaText = ()=>{
        const selected = new Set(value);
        // ex: reporters, All selected
        return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$20140793a0aa2b3c])}, ${selected.size > 0 ? $563dcfd6e88d7a07$var$getNames(reporters, selected) : intl.formatMessage((0, $2rruw.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        isOpen: isOpen,
        onClose: onOpenChange,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($563dcfd6e88d7a07$var$ReporterFilter, props)),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.trigger-btn",
        triggerButtonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($563dcfd6e88d7a07$export$8bd0edd7ca02ab5f, {
            value: props.value,
            persons: props.reporters
        }),
        ariaLabel: ariaText()
    }));
}
var $563dcfd6e88d7a07$export$2e2bcd8739ae039 = (0, $2qhQi.default)($563dcfd6e88d7a07$var$ReporterFilterDialog);

});
parcelRegister("fwzA0", function(module, exports) {

$parcel$export(module.exports, "sortPerson", () => $5bc91ec3a5ef1832$export$92171731eacb7568);
$parcel$export(module.exports, "filter", () => $5bc91ec3a5ef1832$export$3dea766d36a8935f);

var $eUK1h = parcelRequire("eUK1h");
var $fpul1 = parcelRequire("fpul1");
var $1l9vO = parcelRequire("1l9vO");
var $haaWO = parcelRequire("haaWO");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");
const $5bc91ec3a5ef1832$var$sortByPersonTitle = $9RbxZ.default((el)=>$701od.default(el.jiraUser.title));
const $5bc91ec3a5ef1832$export$92171731eacb7568 = $3IGDG.default($5bc91ec3a5ef1832$var$sortByPersonTitle);
const $5bc91ec3a5ef1832$var$getFullText = $3IGDG.default($f7Op5.default('jiraUser'), (user)=>[
        user?.email ?? '',
        user.title
    ], $haaWO.default(' '), $701od.default);
const $5bc91ec3a5ef1832$var$matchQuery = $eUK1h.default((query, person)=>$1l9vO.default($701od.default(query))($5bc91ec3a5ef1832$var$getFullText(person)));
const $5bc91ec3a5ef1832$export$3dea766d36a8935f = $eUK1h.default((query, people)=>$fpul1.default($5bc91ec3a5ef1832$var$matchQuery(query))(people));

});

parcelRegister("2rruw", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d05dda971f8552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $29d05dda971f8552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchReporterPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.search-reporter-placeholder",
        "defaultMessage": "Show issues from reporters"
    },
    searchReporterLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.reporter-filter.search-reporter-label",
        "defaultMessage": "Choose from reporters"
    }
});

});



parcelRegister("abpxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0980fe91a8cf0a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kfFgO = parcelRequire("kfFgO");

var $5MUTW = parcelRequire("5MUTW");

var $jyE6Z = parcelRequire("jyE6Z");
var $ef0980fe91a8cf0a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5MUTW.default), (0, $kfFgO.default))((0, $jyE6Z.default));

});
parcelRegister("kfFgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $934b0a281791f941$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("7hbkF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$934b0a281791f941$export$2e2bcd8739ae039 = (dispatch)=>({
        changeFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb),
                value: payload
            }));
        },
        clearFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb)));
        }
    });

});

parcelRegister("5MUTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $949a969d72544e7c$export$2e2bcd8739ae039);

var $c1XMU = parcelRequire("c1XMU");
const $949a969d72544e7c$var$mapStateToProps = (state)=>({
        allSprints: (0, $c1XMU.getAllSprints)(state),
        externalSprints: (0, $c1XMU.getExternalSprints)(state),
        filterSprints: (0, $c1XMU.getUniqueFilterSprints)(state),
        sprintsAndTeamsByIssueSources: (0, $c1XMU.getSprintsAndTeamsByIssueSources)(state),
        sprintsByIdMap: (0, $c1XMU.getSprintByIdMap)(state),
        sprintStatesCategories: (0, $c1XMU.getSprintStatesCategories)(state)
    });
var $949a969d72544e7c$export$2e2bcd8739ae039 = $949a969d72544e7c$var$mapStateToProps;

});

parcelRegister("jyE6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4358662ad39a7312$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
var $ffiyv = parcelRequire("ffiyv");

var $7hbkF = parcelRequire("7hbkF");

var $a4NMN = parcelRequire("a4NMN");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $5rYNM = parcelRequire("5rYNM");

var $7Iub8 = parcelRequire("7Iub8");

var $ib5d3 = parcelRequire("ib5d3");

var $eG0CY = parcelRequire("eG0CY");

var $6g33d = parcelRequire("6g33d");

var $1CSjE = parcelRequire("1CSjE");

var $3799Z = parcelRequire("3799Z");
const { CHECKED: $4358662ad39a7312$export$be74dcf36d511131, UNCHECKED: $4358662ad39a7312$export$4bfe604431277125, INDETERMINATE: $4358662ad39a7312$export$c5a6fe907430212e } = (0, $5rYNM.CHECKBOX_STATES);
// eslint-disable-next-line jira/react/no-class-components
class $4358662ad39a7312$var$SprintFilter extends (0, $eUqFw.Component) {
    render() {
        const { allSprints: allSprints, clearFilter: clearFilter, filterSprints: filterSprints, intl: intl, isOpen: isOpen, onOpenChange: onOpenChange, onQueryChange: onQueryChange, searchQuery: searchQuery } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            onClose: onOpenChange,
            isOpen: isOpen,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: filterSprints.size > 0,
                onClearClick: clearFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $1CSjE.default).searchSprintPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $1CSjE.default).searchSprintLabel)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: `${(0, $7hbkF.NO_SPRINT_ID)}-checkbox`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: (0, $7hbkF.NO_SPRINT_ID),
                key: (0, $7hbkF.NO_SPRINT_ID),
                isChecked: this.isSelected((0, $7hbkF.NO_SPRINT_ID)),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).noSprintLabel),
                onChange: ()=>this.onItemClick((0, $7hbkF.NO_SPRINT_ID))
            })), searchQuery && allSprints.some(this.filterSprintsWithSearchQuery) || allSprints.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, this.renderSprintStateCategories(), this.renderSprintsWithTeams(), this.renderSprintsWithoutTeams(), this.renderExternalSprints()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null)),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.trigger-btn",
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { filterSprints: filterSprints, intl: intl, sprintsByIdMap: sprintsByIdMap } = this.props;
            const filteredSprintsTitles = [];
            // the "No sprint" filter is displayed first in the filter button text
            if (filterSprints.has((0, $7hbkF.NO_SPRINT_ID))) filteredSprintsTitles.push(intl.formatMessage((0, $ib5d3.default).noSprintLabel));
            [
                ...filterSprints
            ].forEach((sprintId)=>{
                if (sprintsByIdMap[sprintId] && sprintsByIdMap[sprintId].title) filteredSprintsTitles.push(sprintsByIdMap[sprintId].title);
            });
            return filteredSprintsTitles.join(', ');
        };
        this.renderFilterText = ()=>{
            if (this.props.filterSprints.size > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: this.constructFilterText()
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1CSjE.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { filterSprints: filterSprints, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Sprints, All
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb])}, ${filterSprints.size > 0 ? filterText : intl.formatMessage((0, $1CSjE.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.filterSprintsWithSearchQuery = (sprint)=>sprint.title.toLowerCase().includes(this.props.searchQuery.toLowerCase());
        this.renderLozenge = (sprintState)=>{
            const { intl: intl } = this.props;
            const lozengeContent = (0, $a4NMN.getSprintStateLozengeContent)(intl);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: (0, $a4NMN.getLozengeAppearance)(sprintState)
            }, lozengeContent(sprintState));
        };
        this.onItemGroupClick = (sprintIds, checkboxState)=>{
            const newFilterSprint = new Set(this.props.filterSprints);
            if (checkboxState === $4358662ad39a7312$export$4bfe604431277125) for (const id of sprintIds)newFilterSprint.add(id);
            else for (const id of sprintIds)newFilterSprint.delete(id);
            this.props.changeFilter(Array.from(newFilterSprint));
        };
        this.isSelected = (id)=>this.props.filterSprints.has(id);
        this.onItemClick = (id)=>{
            const { filterSprints: filterSprints, changeFilter: changeFilter } = this.props;
            const newFilterSprint = new Set(filterSprints);
            if (this.isSelected(id)) newFilterSprint.delete(id);
            else newFilterSprint.add(id);
            changeFilter(Array.from(newFilterSprint));
        };
        // this function renders a "group" of sprints i.e. either:
        // - the group(s) of sprints associated with a team
        // - the (unique) group of sprints not associated with a team
        // each group rendered includes a heading and a list of sprints
        this.renderSprintsGroup = (heading, sprints, renderSprintStateLozenge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                heading: heading,
                key: heading
            }, sprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: sprint.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    isChecked: this.props.filterSprints.has(sprint.id),
                    label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $3799Z["sprint-title-container"]
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        content: sprint.title
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $3799Z["sprint-title"]
                    }, sprint.title)), renderSprintStateLozenge(sprint.state)),
                    onChange: ()=>this.onItemClick(sprint.id)
                }))));
        // this function renders the main categories of sprints, right below the "No sprint" filter
        // i.e. "All [COMPLETED / ACTIVE / FUTURE / EXTERNAL] sprints"
        this.renderSprintStateCategories = ()=>{
            const { sprintStatesCategories: sprintStatesCategories } = this.props;
            if (!sprintStatesCategories.length) return null;
            const { intl: intl } = this.props;
            const checkboxContent = (0, $a4NMN.getSprintStateLabel)(intl);
            return sprintStatesCategories.map(({ checkboxState: checkboxState, sprintIds: sprintIds, sprintState: sprintState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: `${sprintState}-stateCheckbox`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    isChecked: checkboxState !== $4358662ad39a7312$export$4bfe604431277125,
                    isDisabled: !sprintIds.length,
                    isIndeterminate: checkboxState === $4358662ad39a7312$export$c5a6fe907430212e,
                    label: checkboxContent(sprintState),
                    onChange: ()=>this.onItemGroupClick(sprintIds, checkboxState)
                })));
        };
        // this function renders all sprints associated with a Team, for each Team
        this.renderSprintsWithTeams = ()=>{
            const { searchQuery: searchQuery, sprintsAndTeamsByIssueSources: { sprintsWithTeams: sprintsWithTeams } } = this.props;
            if (sprintsWithTeams.length) return sprintsWithTeams.map((sprintsInGroup)=>{
                // filtering sprints based on search query
                const sprints = searchQuery ? sprintsInGroup.sprints.filter(this.filterSprintsWithSearchQuery) : sprintsInGroup.sprints;
                if (!sprints.length) return null;
                return this.renderSprintsGroup(sprintsInGroup.teams.join(', '), sprints, (sprintState)=>this.renderLozenge(sprintState));
            });
            return null;
        };
        // this function renders all sprints which are not associated with a Team, in one unique group
        this.renderSprintsWithoutTeams = ()=>{
            const { intl: { formatMessage: formatMessage }, searchQuery: searchQuery, sprintsAndTeamsByIssueSources: { sprintsWithoutTeams: sprintsWithoutTeams } } = this.props;
            if (sprintsWithoutTeams.length) {
                // filtering sprints based on search query
                const sprints = searchQuery ? sprintsWithoutTeams.filter(this.filterSprintsWithSearchQuery) : sprintsWithoutTeams;
                if (!sprints.length) return null;
                return this.renderSprintsGroup(formatMessage((0, $ib5d3.default).noAssociatedTeams), sprints, (sprintState)=>this.renderLozenge(sprintState));
            }
            return null;
        };
        // this function renders all external sprints in one unique group
        this.renderExternalSprints = ()=>{
            const { externalSprints: externalSprints, intl: { formatMessage: formatMessage }, searchQuery: searchQuery } = this.props;
            // filtering external sprints based on search query
            const filteredExternalSprints = searchQuery ? externalSprints.filter(this.filterSprintsWithSearchQuery) : externalSprints;
            if (!filteredExternalSprints.length) return null;
            return this.renderSprintsGroup(formatMessage((0, $ib5d3.default).otherSprints), filteredExternalSprints, (sprintState)=>this.renderLozenge((0, $5rYNM.EXTERNAL_SPRINT) || sprintState));
        };
    }
}
var $4358662ad39a7312$export$2e2bcd8739ae039 = (0, $2qhQi.default)($4358662ad39a7312$var$SprintFilter);

});
parcelRegister("1CSjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f62ee3b73d55fa53$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f62ee3b73d55fa53$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchSprintPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.search-sprint-placeholder",
        "defaultMessage": "Show issues from sprints"
    },
    categoriesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.categories-label",
        "defaultMessage": "All {state} sprints"
    },
    searchSprintLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.sprint-filter.search-sprint-label",
        "defaultMessage": "Choose from sprints"
    }
});

});

parcelRegister("3799Z", function(module, exports) {

$parcel$export(module.exports, "sprint-title", () => $2449218cef2a13f9$export$bfd119284cd59066, (v) => $2449218cef2a13f9$export$bfd119284cd59066 = v);
$parcel$export(module.exports, "sprint-title-container", () => $2449218cef2a13f9$export$9ae592458084b2f1, (v) => $2449218cef2a13f9$export$9ae592458084b2f1 = v);
var $2449218cef2a13f9$export$bfd119284cd59066;
var $2449218cef2a13f9$export$9ae592458084b2f1;
$2449218cef2a13f9$export$bfd119284cd59066 = `gJJ7dW_sprint-title`;
$2449218cef2a13f9$export$9ae592458084b2f1 = `gJJ7dW_sprint-title-container`;

});



parcelRegister("2vNVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $386dd66f11518e42$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $e6bjR = parcelRequire("e6bjR");

var $jDy7U = parcelRequire("jDy7U");

var $gWgaq = parcelRequire("gWgaq");
var $386dd66f11518e42$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jDy7U.default), (0, $e6bjR.default))((0, $gWgaq.default));

});
parcelRegister("e6bjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1be677f2ca6b7518$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("5mAJ1");
const $1be677f2ca6b7518$var$mapDispatchToProps = (dispatch)=>({
        changeFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9b51ec1115932c53),
                value: payload
            }));
        },
        clearFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$9b51ec1115932c53)));
        }
    });
var $1be677f2ca6b7518$export$2e2bcd8739ae039 = $1be677f2ca6b7518$var$mapDispatchToProps;

});

parcelRegister("jDy7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $311ace25815f09ef$export$2e2bcd8739ae039);

var $5mAJ1 = parcelRequire("5mAJ1");

var $44SvN = parcelRequire("44SvN");
const $311ace25815f09ef$var$mapStateToProps = (state)=>({
        statusOptionsByCategory: (0, $5mAJ1.getStatusKeyFilterOptionsByCategory)(state),
        categoryNameById: (0, $44SvN.getCategoryNameById)(state),
        value: (0, $5mAJ1.getStatusKeyFilterValue)(state),
        allCategoryCheckedState: (0, $5mAJ1.getAllStatusKeyOfCategoryChecked)(state)
    });
var $311ace25815f09ef$export$2e2bcd8739ae039 = $311ace25815f09ef$var$mapStateToProps;

});

parcelRegister("gWgaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e3c71f8f4e59a92$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $biByU = parcelRequire("biByU");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $d16Lt = parcelRequire("d16Lt");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("5mAJ1");
var $7YjYY = parcelRequire("7YjYY");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $5rYNM = parcelRequire("5rYNM");

var $eG0CY = parcelRequire("eG0CY");
parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $iOtQK = parcelRequire("iOtQK");

var $lU2Qi = parcelRequire("lU2Qi");
const $9e3c71f8f4e59a92$var$isUnsaved = (statusName)=>statusName === (0, $7YjYY.UNSAVED_STATUS).name;
const $9e3c71f8f4e59a92$var$StatusKeyFilter = (props)=>{
    const { value: selectedStatusKeys, statusOptionsByCategory: statusOptionsByCategory, categoryNameById: categoryNameById, allCategoryCheckedState: allCategoryCheckedState, searchQuery: searchQuery, isOpen: isOpen, changeFilter: changeFilter, clearFilter: clearFilter, onQueryChange: onQueryChange, onOpenChange: onOpenChange } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isStatusKeySelected = (statusKey)=>selectedStatusKeys.some((selectedStatusKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(selectedStatusKey, statusKey));
    const onStatusKeyClick = (clickedStatusKey)=>{
        const newValue = isStatusKeySelected(clickedStatusKey) ? selectedStatusKeys.filter((selectedStatusKey)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(selectedStatusKey, clickedStatusKey)) : [
            ...selectedStatusKeys,
            clickedStatusKey
        ];
        changeFilter(newValue);
    };
    const onCategoryClick = (clickedCategory)=>{
        const allStatusNamesFromCategory = statusOptionsByCategory.get(clickedCategory) ?? [];
        const isCategorySelected = allStatusNamesFromCategory.length > 0 && allStatusNamesFromCategory.every((statusName)=>isStatusKeySelected({
                category: clickedCategory,
                name: statusName
            }));
        if (isCategorySelected) {
            const newValue = selectedStatusKeys.filter(({ category: category })=>category !== `${clickedCategory}`);
            changeFilter(newValue);
        } else changeFilter((0, (/*@__PURE__*/$parcel$interopDefault($biByU)))([
            ...selectedStatusKeys,
            ...allStatusNamesFromCategory.map((statusName)=>({
                    category: `${clickedCategory}`,
                    name: statusName
                }))
        ], (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))));
    };
    const onClearFilter = ()=>{
        clearFilter();
    };
    const filterStatusesWithSearchQuery = (statusName)=>statusName.toLowerCase().includes(searchQuery.toLowerCase());
    const filteredStatusOptionsByCategory = Array.from(statusOptionsByCategory.entries()).reduce((acc, [category, statusNames])=>{
        const filteredStatusNames = statusNames.filter(filterStatusesWithSearchQuery);
        if (filteredStatusNames.length > 0) acc.set(category, filteredStatusNames);
        return acc;
    }, new Map());
    const renderStatus = (name, category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
            value: {
                id: 'N/A',
                name: name,
                statusCategory: {
                    id: category
                }
            }
        });
    const renderTriggerButton = ()=>{
        const text = selectedStatusKeys.length > 0 ? selectedStatusKeys.map(({ name: name })=>$9e3c71f8f4e59a92$var$isUnsaved(name) ? formatMessage((0, $iOtQK.default).unsavedIssues) : name).join(', ') : formatMessage((0, $iOtQK.default).emptyPlaceholder);
        const ariaText = `${formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$9b51ec1115932c53])}, ${text} ${formatMessage((0, $6g33d.default).selected)}`;
        const renderFilterText = ()=>{
            if (selectedStatusKeys.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: text
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iOtQK.default).emptyPlaceholder);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.trigger-btn",
            triggerButtonText: (0, $1ybV0.ff)('seq-test-plan-improvement-plan-part-1_o31ak') ? renderFilterText() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: text
            }),
            ariaLabel: ariaText
        });
    };
    const renderDropList = ()=>{
        if (filteredStatusOptionsByCategory.size === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Array.from(filteredStatusOptionsByCategory.keys()).map((category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                key: `${category}-categoryCheckboxes`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.${category}`,
                isChecked: allCategoryCheckedState[category] === (0, $5rYNM.CHECKBOX_STATES).CHECKED || allCategoryCheckedState[category] === (0, $5rYNM.CHECKBOX_STATES).INDETERMINATE,
                isIndeterminate: allCategoryCheckedState[category] === (0, $5rYNM.CHECKBOX_STATES).INDETERMINATE,
                label: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $lU2Qi.categoriesLabel
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $iOtQK.default).categoriesLabel,
                    values: {
                        status: renderStatus(categoryNameById.get(category) ?? '', Number(category))
                    }
                })),
                onChange: ()=>onCategoryClick(category)
            }))), Array.from(filteredStatusOptionsByCategory.entries()).map(([category, statusNames])=>{
            if (statusNames.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuGroup), {
                heading: categoryNameById.get(category) ?? '',
                key: `${category}-statusCheckboxes`
            }, statusNames.map((statusName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: statusName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    testId: `portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.${statusName}`,
                    isChecked: isStatusKeySelected({
                        category: category,
                        name: statusName
                    }),
                    onChange: ()=>onStatusKeyClick({
                            category: category,
                            name: statusName
                        }),
                    label: $9e3c71f8f4e59a92$var$isUnsaved(statusName) ? formatMessage({
                        ...(0, $iOtQK.default).unsavedIssues
                    }) : renderStatus(statusName, Number(category))
                }))));
            return null;
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        noPaddings: true,
        maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
        minWidth: (0, $04tZU.FILTER_WIDTH),
        onClose: onOpenChange,
        isOpen: isOpen,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
            isVisible: selectedStatusKeys.length > 0,
            onClearClick: onClearFilter
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
            placeholder: formatMessage((0, $iOtQK.default).searchStatusPlaceholder),
            searchQuery: searchQuery,
            onQueryChange: onQueryChange,
            ariaLabel: formatMessage((0, $iOtQK.default).searchStatusLabel)
        }), renderDropList()),
        testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter"
    }, renderTriggerButton());
};
$9e3c71f8f4e59a92$var$StatusKeyFilter.defaultProps = {
    isOpen: false
};
var $9e3c71f8f4e59a92$export$2e2bcd8739ae039 = $9e3c71f8f4e59a92$var$StatusKeyFilter;

});
parcelRegister("iOtQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $89aa4c08d5353c51$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $89aa4c08d5353c51$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchStatusPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.search-status-placeholder",
        "defaultMessage": "Show issues from statuses"
    },
    categoriesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.categories-label",
        "defaultMessage": "All {status} statuses"
    },
    unsavedIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.unsaved-issues",
        "defaultMessage": "Unsaved issues"
    },
    searchStatusLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.status-key-filter.search-status-label",
        "defaultMessage": "Choose from statuses"
    }
});

});

parcelRegister("lU2Qi", function(module, exports) {

$parcel$export(module.exports, "categoriesLabel", () => $ff21086ac5e661cf$export$70d32fb684f1516d, (v) => $ff21086ac5e661cf$export$70d32fb684f1516d = v);
var $ff21086ac5e661cf$export$70d32fb684f1516d;
$ff21086ac5e661cf$export$70d32fb684f1516d = `POzVCG_categoriesLabel`;

});



parcelRegister("88LTk", function(module, exports) {

$parcel$export(module.exports, "filterOptions", () => $5ed4384fa18859bd$export$60d56ed3961c839c, (v) => $5ed4384fa18859bd$export$60d56ed3961c839c = v);
$parcel$export(module.exports, "filterRow", () => $5ed4384fa18859bd$export$58c9fd6b8a6e3f69, (v) => $5ed4384fa18859bd$export$58c9fd6b8a6e3f69 = v);
$parcel$export(module.exports, "filterRowFilter", () => $5ed4384fa18859bd$export$174af62556826970, (v) => $5ed4384fa18859bd$export$174af62556826970 = v);
$parcel$export(module.exports, "filterRowLabel", () => $5ed4384fa18859bd$export$fdca09c2d96ecd0d, (v) => $5ed4384fa18859bd$export$fdca09c2d96ecd0d = v);
$parcel$export(module.exports, "filtersDialog", () => $5ed4384fa18859bd$export$95dc403e64e1a72e, (v) => $5ed4384fa18859bd$export$95dc403e64e1a72e = v);
$parcel$export(module.exports, "filtersHeader", () => $5ed4384fa18859bd$export$32665f30e610c72b, (v) => $5ed4384fa18859bd$export$32665f30e610c72b = v);
$parcel$export(module.exports, "filtersList", () => $5ed4384fa18859bd$export$c569aa76df9ea47e, (v) => $5ed4384fa18859bd$export$c569aa76df9ea47e = v);
$parcel$export(module.exports, "hierarchyFilterLabel", () => $5ed4384fa18859bd$export$c5e7ce4aedd187d9, (v) => $5ed4384fa18859bd$export$c5e7ce4aedd187d9 = v);
var $5ed4384fa18859bd$export$60d56ed3961c839c;
var $5ed4384fa18859bd$export$58c9fd6b8a6e3f69;
var $5ed4384fa18859bd$export$174af62556826970;
var $5ed4384fa18859bd$export$fdca09c2d96ecd0d;
var $5ed4384fa18859bd$export$95dc403e64e1a72e;
var $5ed4384fa18859bd$export$32665f30e610c72b;
var $5ed4384fa18859bd$export$c569aa76df9ea47e;
var $5ed4384fa18859bd$export$c5e7ce4aedd187d9;
$5ed4384fa18859bd$export$60d56ed3961c839c = `_6cBvHG_filterOptions`;
$5ed4384fa18859bd$export$58c9fd6b8a6e3f69 = `_6cBvHG_filterRow`;
$5ed4384fa18859bd$export$174af62556826970 = `_6cBvHG_filterRowFilter`;
$5ed4384fa18859bd$export$fdca09c2d96ecd0d = `_6cBvHG_filterRowLabel`;
$5ed4384fa18859bd$export$95dc403e64e1a72e = `_6cBvHG_filtersDialog`;
$5ed4384fa18859bd$export$32665f30e610c72b = `_6cBvHG_filtersHeader`;
$5ed4384fa18859bd$export$c569aa76df9ea47e = `_6cBvHG_filtersList`;
$5ed4384fa18859bd$export$c5e7ce4aedd187d9 = `_6cBvHG_hierarchyFilterLabel`;

});

parcelRegister("foduK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2efc5aa166ed851$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5Ippu = parcelRequire("5Ippu");

var $5L21l = parcelRequire("5L21l");

var $dyvSR = parcelRequire("dyvSR");
var $a2efc5aa166ed851$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5L21l.default), (0, $5Ippu.default))((0, $dyvSR.default));

});
parcelRegister("5Ippu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb6e6ac47308e7$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $8ccb6e6ac47308e7$var$mapDispatchToProps = (dispatch)=>({
        changeSummaryFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$e32eeae4866f112c),
                value: payload
            }));
        },
        clearSummaryFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$e32eeae4866f112c)));
        }
    });
var $8ccb6e6ac47308e7$export$2e2bcd8739ae039 = $8ccb6e6ac47308e7$var$mapDispatchToProps;

});

parcelRegister("5L21l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69325b655868566$export$2e2bcd8739ae039);

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("77IHm");

var $iK4oF = parcelRequire("iK4oF");
var $b69325b655868566$export$2e2bcd8739ae039 = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], ({ [(0, $12ee831723ccf9c2$export$e32eeae4866f112c)]: { id: id, value: value } })=>({
        id: id,
        value: value
    }));

});

parcelRegister("dyvSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b914f5289fe46e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hjlb6 = parcelRequire("hjlb6");

var $5k4ch = parcelRequire("5k4ch");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $g4Vkx = parcelRequire("g4Vkx");
var $5CV7v = parcelRequire("5CV7v");
parcelRequire("77IHm");

var $6g33d = parcelRequire("6g33d");

var $kqUoo = parcelRequire("kqUoo");

var $9h4Bm = parcelRequire("9h4Bm");
// eslint-disable-next-line jira/react/no-class-components
class $67b914f5289fe46e$var$SummaryFilter extends (0, $eUqFw.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) return {
            value: props.value,
            query: props.value || ''
        };
        return null;
    }
    render() {
        const { intl: intl, inputRef: inputRef } = this.props;
        const { query: query } = this.state;
        const hasInput = query.length > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($9h4Bm.searchFieldContainer, {
                [$9h4Bm.hasInput]: hasInput
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            autoFocus: true,
            ref: inputRef,
            elemAfterInput: hasInput && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $9h4Bm.clearSearchField
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
                onClick: this.onClearQuery,
                tabIndex: -1,
                ariaLabel: intl.formatMessage((0, $kqUoo.default).clearButtonLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
                label: "",
                primaryColor: `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N70})`,
                size: "small"
            }))),
            onChange: this.onFieldChange,
            placeholder: intl.formatMessage((0, $kqUoo.default).placeholder),
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter",
            value: query,
            "aria-label": intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$e32eeae4866f112c])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            query: this.props.value || '',
            value: this.props.value
        };
        this.applyQuery = (query)=>{
            const { changeSummaryFilter: changeSummaryFilter } = this.props;
            changeSummaryFilter(query);
        };
        this.applyQueryDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.applyQuery, 250);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onFieldChange = (e)=>{
            const query = e.target.value;
            this.setState({
                query: query
            });
            this.applyQueryDebounced(query);
        };
        this.onClearQuery = ()=>{
            this.setState({
                query: ''
            });
            this.applyQueryDebounced('');
        };
    }
}
var $67b914f5289fe46e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($67b914f5289fe46e$var$SummaryFilter);

});
parcelRegister("kqUoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $59588b62104b6dff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $59588b62104b6dff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter.placeholder",
        "defaultMessage": "Type issue keys, summaries"
    },
    clearButtonLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.summary-filter.clear-button-label",
        "defaultMessage": "clear"
    }
});

});

parcelRegister("9h4Bm", function(module, exports) {

$parcel$export(module.exports, "clearSearchField", () => $6c094562b4b76e4c$export$b80a961de74058b, (v) => $6c094562b4b76e4c$export$b80a961de74058b = v);
$parcel$export(module.exports, "hasInput", () => $6c094562b4b76e4c$export$303c88434854a784, (v) => $6c094562b4b76e4c$export$303c88434854a784 = v);
$parcel$export(module.exports, "searchFieldContainer", () => $6c094562b4b76e4c$export$d5ce248efb7645dd, (v) => $6c094562b4b76e4c$export$d5ce248efb7645dd = v);
var $6c094562b4b76e4c$export$b80a961de74058b;
var $6c094562b4b76e4c$export$303c88434854a784;
var $6c094562b4b76e4c$export$d5ce248efb7645dd;
$6c094562b4b76e4c$export$b80a961de74058b = `_3aa0cW_clearSearchField`;
$6c094562b4b76e4c$export$303c88434854a784 = `_3aa0cW_hasInput`;
$6c094562b4b76e4c$export$d5ce248efb7645dd = `_3aa0cW_searchFieldContainer`;

});



parcelRegister("lrSA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5f449f9f65a4a4d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ikwcV = parcelRequire("ikwcV");

var $bspaT = parcelRequire("bspaT");

var $hOK0p = parcelRequire("hOK0p");
var $b5f449f9f65a4a4d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bspaT.default), (0, $ikwcV.default))((0, $hOK0p.default));

});
parcelRegister("ikwcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $de347c8418ba9f82$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");

const $de347c8418ba9f82$var$mapDispatchToProps = (dispatch)=>({
        changeTeamFilter: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$8abe69ceb26771cd),
                value: payload
            }));
        },
        clearTeamFilter: ()=>{
            dispatch((0, $296Gg.clear)((0, $12ee831723ccf9c2$export$8abe69ceb26771cd)));
        }
    });
var $de347c8418ba9f82$export$2e2bcd8739ae039 = $de347c8418ba9f82$var$mapDispatchToProps;

});

parcelRegister("bspaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2e85e27405ef31$export$2e2bcd8739ae039);

var $hkOxK = parcelRequire("hkOxK");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("3Fte6");

var $75KhQ = parcelRequire("75KhQ");

var $MQRDu = parcelRequire("MQRDu");

var $iK4oF = parcelRequire("iK4oF");
const $5f2e85e27405ef31$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $MQRDu.getExistingTeams),
    (0, $fbHoQ.getFilters),
    (0, $75KhQ.getPlan)
], (teams, { [(0, $12ee831723ccf9c2$export$8abe69ceb26771cd)]: { id: id, value: value } }, plan)=>({
        id: id,
        value: value,
        teams: $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('title')))(teams),
        useTwpTeams: plan.useTwpTeams
    }));
var $5f2e85e27405ef31$export$2e2bcd8739ae039 = $5f2e85e27405ef31$var$mapStateToProps;

});

parcelRegister("hOK0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cdd8b9097836eeb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");

var $iJlfe = parcelRequire("iJlfe");

var $4nce6 = parcelRequire("4nce6");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $6ETZE = parcelRequire("6ETZE");
var $4zIro = parcelRequire("4zIro");
var $eNhh9 = parcelRequire("eNhh9");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $3Fte6 = parcelRequire("3Fte6");
parcelRequire("04tZU");
var $s8Q9q = parcelRequire("s8Q9q");
var $04tZU = parcelRequire("04tZU");
var $hfVzN = parcelRequire("hfVzN");
var $3nLf8 = parcelRequire("3nLf8");
var $6uwgw = parcelRequire("6uwgw");

var $7Iub8 = parcelRequire("7Iub8");

var $eG0CY = parcelRequire("eG0CY");

var $17gIb = parcelRequire("17gIb");

var $6g33d = parcelRequire("6g33d");

var $clyqT = parcelRequire("clyqT");
// eslint-disable-next-line jira/react/no-class-components
class $2cdd8b9097836eeb$var$TeamFilter extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, onOpenChange: onOpenChange, isOpen: isOpen, value: value, clearTeamFilter: clearTeamFilter, searchQuery: searchQuery, onQueryChange: onQueryChange } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
            noPaddings: true,
            maxWidth: (0, $04tZU.FILTER_MAX_WIDTH),
            minWidth: (0, $04tZU.FILTER_WIDTH),
            onClose: onOpenChange,
            isOpen: isOpen,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $s8Q9q.default), {
                isVisible: !!value.length,
                onClearClick: clearTeamFilter
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG0CY.default), {
                placeholder: intl.formatMessage((0, $clyqT.default).searchTeamPlaceholder),
                searchQuery: searchQuery,
                onQueryChange: onQueryChange,
                ariaLabel: intl.formatMessage((0, $clyqT.default).searchTeamLabel)
            }), this.props.teams.length > 0 && this.renderNoTeams(), this.renderProjectGroups())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uwgw.default), {
            isOpen: isOpen,
            onOpenChange: onOpenChange,
            testId: "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.trigger-btn",
            triggerButtonText: this.renderFilterText(),
            ariaLabel: this.ariaText()
        }));
    }
    constructor(...args){
        super(...args);
        this.constructFilterText = ()=>{
            const { teams: teams, value: value, intl: intl } = this.props;
            const noTeamText = value.length > 1 ? `${intl.formatMessage((0, $clyqT.default).noTeamFilterText)}, ` : intl.formatMessage((0, $clyqT.default).noTeamFilterText);
            return ($7d70y.default((0, $3Fte6.NO_TEAM_ID), value) ? noTeamText : '') + teams.filter(({ id: id })=>$7d70y.default(id, value)).map(({ title: title })=>title).join(', ');
        };
        this.renderFilterText = ()=>{
            const { value: value } = this.props;
            const filterText = this.constructFilterText();
            return value.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfVzN.default), {
                text: filterText
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $clyqT.default).emptyPlaceholder);
        };
        this.ariaText = ()=>{
            const { value: value, intl: intl } = this.props;
            const filterText = this.constructFilterText();
            // Teams, All selected
            return `${intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$8abe69ceb26771cd])}, ${value.length > 0 ? filterText : intl.formatMessage((0, $clyqT.default).emptyPlaceholder)} ${intl.formatMessage((0, $6g33d.default).selected)}`;
        };
        this.isTeamSelected = (teamTitle)=>$7d70y.default(teamTitle, this.props.value);
        this.filterTeamsWithSearchQuery = (team)=>team.title.toLowerCase().includes(this.props.searchQuery.toLowerCase());
        this.onTeamClick = (id)=>{
            const { value: value, changeTeamFilter: changeTeamFilter } = this.props;
            if (this.isTeamSelected(id)) changeTeamFilter($fpul1.default((team)=>team !== id, value));
            else changeTeamFilter([
                ...value,
                id
            ]);
        };
        this.renderProjectGroups = ()=>{
            const { teams: teams, useTwpTeams: useTwpTeams = false } = this.props;
            const searchResultTeams = teams.filter(this.filterTeamsWithSearchQuery);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, searchResultTeams.map(({ avatarUrl: avatarUrl = '', id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), {
                    key: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                    id: id,
                    key: id,
                    isChecked: this.isTeamSelected(id),
                    onChange: ()=>this.onTeamClick(id),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                        id: id,
                        content: title
                    }, (0, $430Oj.default)() && useTwpTeams ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $17gIb.teamAvatarItem
                    }, !avatarUrl ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $17gIb.defaultTeamAvatar
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                        label: "",
                        size: "small"
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                        size: "small",
                        src: avatarUrl
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $17gIb.checkboxLabel
                    }, title)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                        className: $17gIb.checkboxLabel
                    }, title))
                }))), searchResultTeams.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nLf8.default), null));
        };
        this.renderNoTeams = ()=>{
            const { intl: intl } = this.props;
            const title = intl.formatMessage({
                ...(0, $clyqT.default).noTeamFilterText
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zIro.DialogMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
                id: (0, $3Fte6.NO_TEAM_ID),
                key: (0, $3Fte6.NO_TEAM_ID),
                isChecked: this.isTeamSelected((0, $3Fte6.NO_TEAM_ID)),
                onChange: ()=>this.onTeamClick((0, $3Fte6.NO_TEAM_ID)),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                    id: (0, $3Fte6.NO_TEAM_ID),
                    content: title
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $17gIb.checkboxLabel
                }, title))
            }));
        };
    }
}
var $2cdd8b9097836eeb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2cdd8b9097836eeb$var$TeamFilter);

});
parcelRegister("clyqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88421ca22061ccf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b88421ca22061ccf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.empty-placeholder",
        "defaultMessage": "All"
    },
    searchTeamPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.search-team-placeholder",
        "defaultMessage": "Show issues from teams"
    },
    noTeamFilterText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.no-team-filter-text",
        "defaultMessage": "No team"
    },
    searchTeamLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.filter-bar.team-filter.search-team-label",
        "defaultMessage": "Choose from teams"
    }
});

});





parcelRegister("30kLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f695cbb9c82e8ce3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $4xEUn = parcelRequire("4xEUn");

var $5hxiZ = parcelRequire("5hxiZ");

var $1tsip = parcelRequire("1tsip");
var $f695cbb9c82e8ce3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5hxiZ.default), (0, $4xEUn.default))((0, $1tsip.default));

});
parcelRegister("4xEUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b3e7a447f38709$export$2e2bcd8739ae039);

var $296Gg = parcelRequire("296Gg");
parcelRequire("khGZ4");
var $9RBvc = parcelRequire("9RBvc");


var $9RBvc = parcelRequire("9RBvc");

var $iX8wj = parcelRequire("iX8wj");
const $19b3e7a447f38709$var$mapDispatchToProps = (dispatch)=>({
        setSearchQuery: (value)=>{
            dispatch((0, $iX8wj.setSearchQuery)(value));
            dispatch((0, $iX8wj.toggleIssueSearch)(true));
        },
        toggleShowWarning: ()=>{
            dispatch((0, $9RBvc.toggleShowWarning)());
        },
        toggleWarningByType: (type)=>{
            dispatch((0, $9RBvc.toggleWarningByType)(type));
        },
        toggleWarningsFilter: (value)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$d6f1616882408daa),
                value: value
            }));
        }
    });
var $19b3e7a447f38709$export$2e2bcd8739ae039 = $19b3e7a447f38709$var$mapDispatchToProps;

});
parcelRegister("iX8wj", function(module, exports) {

$parcel$export(module.exports, "RESET_SEARCH_RESULTS", () => $4d6e3b438e62328b$export$ca438e92d01957dc);
$parcel$export(module.exports, "SEARCH_ICON_CLICK", () => $4d6e3b438e62328b$export$7cbc0bf0e3faadbe);
$parcel$export(module.exports, "SET_ACTIVE_SEARCH_RESULT_INDEX", () => $4d6e3b438e62328b$export$dee502a60050bab0);
$parcel$export(module.exports, "SET_SEARCH_QUERY", () => $4d6e3b438e62328b$export$6c3b572d2d64ae9);
$parcel$export(module.exports, "STARTED_SEARCH_RESULT_NAVIGATION", () => $4d6e3b438e62328b$export$d2f4281b9c017343);
$parcel$export(module.exports, "TOGGLE_ISSUE_SEARCH", () => $4d6e3b438e62328b$export$98cb10bd2faa93c7);
$parcel$export(module.exports, "setSearchQuery", () => $4d6e3b438e62328b$export$2cd1e14773f5e71b);
$parcel$export(module.exports, "setActiveSearchResultIndex", () => $4d6e3b438e62328b$export$a7062054d7b425ce);
$parcel$export(module.exports, "searchIconClick", () => $4d6e3b438e62328b$export$2aabb555469c35c);
$parcel$export(module.exports, "startedSearchResultNavigation", () => $4d6e3b438e62328b$export$6e39a71f2e10c895);
$parcel$export(module.exports, "toggleIssueSearch", () => $4d6e3b438e62328b$export$58338d7218e4ff1d);
const $4d6e3b438e62328b$export$ca438e92d01957dc = 'state.ui.main.tabs.roadmap.scope.header.search.RESET_SEARCH_RESULTS';
const $4d6e3b438e62328b$export$7cbc0bf0e3faadbe = 'state.ui.main.tabs.roadmap.scope.header.search.SEARCH_ICON_CLICK';
const $4d6e3b438e62328b$export$dee502a60050bab0 = 'state.ui.main.tabs.roadmap.scope.header.search.SET_ACTIVE_SEARCH_RESULT_INDEX';
const $4d6e3b438e62328b$export$6c3b572d2d64ae9 = 'state.ui.main.tabs.roadmap.scope.header.search.SET_SEARCH_QUERY';
const $4d6e3b438e62328b$export$d2f4281b9c017343 = 'state.ui.main.tabs.roadmap.scope.header.search.STARTED_SEARCH_RESULT_NAVIGATION';
const $4d6e3b438e62328b$export$98cb10bd2faa93c7 = 'state.ui.main.tabs.roadmap.scope.header.search.TOGGLE_ISSUE_SEARCH';
const $4d6e3b438e62328b$export$2cd1e14773f5e71b = (payload)=>({
        type: $4d6e3b438e62328b$export$6c3b572d2d64ae9,
        payload: payload
    });
const $4d6e3b438e62328b$export$a7062054d7b425ce = (payload)=>({
        type: $4d6e3b438e62328b$export$dee502a60050bab0,
        payload: payload
    });
const $4d6e3b438e62328b$export$dc60b1e0f93b4b42 = ()=>({
        type: $4d6e3b438e62328b$export$ca438e92d01957dc
    });
const $4d6e3b438e62328b$export$2aabb555469c35c = ()=>({
        type: $4d6e3b438e62328b$export$7cbc0bf0e3faadbe
    });
const $4d6e3b438e62328b$export$6e39a71f2e10c895 = ()=>({
        type: $4d6e3b438e62328b$export$d2f4281b9c017343
    });
const $4d6e3b438e62328b$export$58338d7218e4ff1d = (payload)=>({
        type: $4d6e3b438e62328b$export$98cb10bd2faa93c7,
        payload: payload
    });

});


parcelRegister("5hxiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9614634f7a247ee5$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $kahmZ = parcelRequire("kahmZ");

var $lihml = parcelRequire("lihml");

var $ehEr2 = parcelRequire("ehEr2");

var $cwP4d = parcelRequire("cwP4d");

var $9H2AP = parcelRequire("9H2AP");

var $YHQpz = parcelRequire("YHQpz");

var $iK4oF = parcelRequire("iK4oF");
var $9614634f7a247ee5$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    disabledWarnings: (0, $YHQpz.getDisabledWarnings),
    issueTypesById: (0, $lihml.getIssueTypesById),
    issuesById: (0, $cwP4d.getIssueMapById),
    mode: (0, $akhOi.getMode),
    projectsById: (0, $ehEr2.getProjectsById),
    showWarning: (state)=>(0, $9H2AP.getWarningViewSettings)(state).showWarning,
    warningCount: (0, $YHQpz.getWarningsCount),
    warningFilterValue: (state)=>(0, $kahmZ.getWarningFilter)(state).value,
    warnings: (0, $YHQpz.getAggregatedWarnings)
});

});

parcelRegister("1tsip", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3158066b13a520$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $5YsMl = parcelRequire("5YsMl");

var $3MV1G = parcelRequire("3MV1G");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $g4Vkx = parcelRequire("g4Vkx");
var $bbaTG = parcelRequire("bbaTG");
var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("akhOi");

var $lOjjB = parcelRequire("lOjjB");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $24zkT = parcelRequire("24zkT");

var $4m0f4 = parcelRequire("4m0f4");

var $nLQ6A = parcelRequire("nLQ6A");
// eslint-disable-next-line jira/react/no-class-components
class $8c3158066b13a520$var$WarningCenter extends (0, $eUqFw.Component) {
    render() {
        const { warningCount: warningCount, warnings: warnings, showWarning: showWarning, toggleWarningByType: toggleWarningByType, disabledWarnings: disabledWarnings, warningFilterValue: warningFilterValue, toggleWarningsFilter: toggleWarningsFilter, issuesById: issuesById, setSearchQuery: setSearchQuery, issueTypesById: issueTypesById, projectsById: projectsById, toggleShowWarning: toggleShowWarning } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24zkT.default), {
                    focusRef: setInitialFocusRef,
                    disabledWarnings: disabledWarnings,
                    issueTypesById: issueTypesById,
                    issuesById: issuesById,
                    onTypeIdChange: this.handleTypeIdChange,
                    projectsById: projectsById,
                    setSearchQuery: setSearchQuery,
                    showWarning: showWarning,
                    toggleShowWarning: toggleShowWarning,
                    toggleWarningByType: toggleWarningByType,
                    toggleWarningsFilter: toggleWarningsFilter,
                    typeId: this.state.typeId,
                    warningCount: warningCount,
                    warningFilterValue: warningFilterValue,
                    warnings: warnings
                }),
            isOpen: this.state.isOpen,
            trigger: this.renderTriggerButton,
            shouldRenderToParent: true,
            role: "dialog",
            onClose: this.onClose,
            placement: "bottom-end"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            typeId: null
        };
        this.buttonRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.toggleWarningCenter = ()=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                }, ()=>{
                    !this.state.isOpen && this.buttonRef.current?.focus();
                });
                return;
            }
            this.setState({
                isOpen: true
            });
            const { createAnalyticsEvent: createAnalyticsEvent = null } = this.props;
            if (!createAnalyticsEvent) return;
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).OPENED_WARNING_CENTER.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                count: this.props.warningCount
            });
        };
        this.onClose = ()=>{
            this.setState({
                isOpen: false
            }, ()=>{
                !this.state.isOpen && this.buttonRef.current?.focus();
            });
        };
        this.handleTypeIdChange = (typeId)=>{
            this.setState({
                typeId: typeId
            });
            if (typeof typeId !== 'string') return;
            const { createAnalyticsEvent: createAnalyticsEvent = null } = this.props;
            if (!createAnalyticsEvent) return;
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).FILTERED_WARNING_TYPE.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            const warningType = (0, $lOjjB.WARNING_TYPE_NUMBER_MAP)[typeId] || null;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                count: this.props.warningCount,
                warningType: warningType
            });
        };
        this.renderTriggerButton = (triggerProps)=>{
            const { intl: intl, mode: mode, showWarning: showWarning } = this.props;
            const { ref: ref, ...restTriggerProps } = triggerProps || {
                ref: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.warning-centre-button",
                ref: ref
            }, mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && mode !== (0, $99f9ac26081f8045$export$b07c15b79440feb8) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $nLQ6A.warningsButtonIconOnly
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4m0f4.default).warningsButtonLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                appearance: "default",
                ...restTriggerProps,
                ref: this.buttonRef,
                onClick: this.toggleWarningCenter,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                    label: intl.formatMessage((0, $4m0f4.default).warningsButtonLabel),
                    primaryColor: showWarning ? `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})` : `var(--ds-icon-subtle, ${(0, $g4Vkx.default).N200})`,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.custom-theme-button"
                }),
                ...showWarning && {
                    theme: (current, themeProps)=>({
                            ...current(themeProps),
                            buttonStyles: {
                                ...current(themeProps).buttonStyles,
                                background: `var(--ds-background-warning, ${(0, $g4Vkx.default).Y75})`,
                                '&:hover': {
                                    background: `var(--ds-background-warning-hovered, ${(0, $g4Vkx.default).Y100})`
                                }
                            }
                        })
                }
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && mode !== (0, $99f9ac26081f8045$export$b07c15b79440feb8) ? $nLQ6A.warningsButtonIconLabel : ''
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                appearance: "default",
                ...restTriggerProps,
                ref: this.buttonRef,
                onClick: this.toggleWarningCenter,
                ...showWarning && {
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
                        label: "",
                        primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
                    }),
                    theme: (current, themeProps)=>({
                            ...current(themeProps),
                            buttonStyles: {
                                ...current(themeProps).buttonStyles,
                                background: `var(--ds-background-warning, ${(0, $g4Vkx.default).Y75})`,
                                '&:hover': {
                                    background: `var(--ds-background-warning-hovered, ${(0, $g4Vkx.default).Y100})`
                                }
                            }
                        })
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4m0f4.default).warningsButtonLabel))));
        };
    }
}
const $8c3158066b13a520$var$WarningCenterWithIntl = (0, $2qhQi.default)((0, $2jDha.default)()($8c3158066b13a520$var$WarningCenter));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c3158066b13a520$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "warningsCenter",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c3158066b13a520$var$WarningCenterWithIntl, props));

});
parcelRegister("24zkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cff3c978f1b741a0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gpZWO = parcelRequire("gpZWO");

var $cSu9v = parcelRequire("cSu9v");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $e270j = parcelRequire("e270j");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");

var $cuuJa = parcelRequire("cuuJa");

var $hFkwG = parcelRequire("hFkwG");

var $lOjjB = parcelRequire("lOjjB");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $awiwy = parcelRequire("awiwy");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $k9uGU = parcelRequire("k9uGU");

var $iMHm5 = parcelRequire("iMHm5");

var $gz44y = parcelRequire("gz44y");
const $cff3c978f1b741a0$var$Content = ({ warnings: warnings, warningCount: warningCount, toggleWarningByType: toggleWarningByType, disabledWarnings: disabledWarnings, toggleWarningsFilter: toggleWarningsFilter, warningFilterValue: warningFilterValue, issuesById: issuesById, setSearchQuery: setSearchQuery, issueTypesById: issueTypesById, projectsById: projectsById, typeId: typeId, onTypeIdChange: onTypeIdChange, showWarning: showWarning, toggleShowWarning: toggleShowWarning, focusRef: focusRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onToggleWarningsFilter = ()=>{
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).TOGGLED_WARNING_FILTER.split(' ');
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const newWarningFilterValue = !warningFilterValue;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            count: warningCount,
            selectedOption: newWarningFilterValue ? 1 : 0
        });
        toggleWarningsFilter(newWarningFilterValue);
    };
    const getOnIssueItemClick = (issue)=>()=>{
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).LOCATED_WARNING_ISSUE_ITEM.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            const warningType = typeof typeId === 'string' ? (0, $lOjjB.WARNING_TYPE_NUMBER_MAP)[typeId] || null : null;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                warningType: warningType
            });
            setSearchQuery(issue.summary);
        };
    const getOnToggleWarningByType = (key, nextState)=>()=>{
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).TOGGLED_WARNING_TYPE.split(' ');
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            const warningType = (0, $lOjjB.WARNING_TYPE_NUMBER_MAP)[key] || null;
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                selectedOption: nextState ? 1 : 0,
                warningType: warningType
            });
            toggleWarningByType(key);
        };
    const getWarningDialogContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $cff3c978f1b741a0$var$warningsDialogHeaderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningsDialogHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100"
        }, Object.entries((0, $hFkwG.WarningTypes)).map(([key, value])=>{
            const { header: header } = value;
            const isEnabled = !(disabledWarnings || []).includes(key);
            const issueCount = warnings[key] && warnings[key].length || 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                key: key,
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $cff3c978f1b741a0$var$warningToggleAndTextStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
                isChecked: isEnabled,
                onChange: getOnToggleWarningByType(key, !isEnabled),
                testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warning-type--${key}`,
                label: formatMessage(header)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, issueCount === 0 ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                isDisabled: true,
                className: $gz44y.disabledWarningButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).zeroCountWarningText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                onClick: ()=>onTypeIdChange(key),
                appearance: "link",
                isDisabled: issueCount === 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $gz44y.affectedIssuesCount,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                    label: ""
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $iMHm5.default).warningCountText,
                values: {
                    count: issueCount
                }
            }))), !isEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                isDisabled: true,
                className: $gz44y.disabledWarningButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).disabledIssueStatusText))));
        })));
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    const getWarningDialogContentFFOff = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
            className: $gz44y.warningTable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("thead", {
            className: $gz44y.tableBorderReset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
            className: $gz44y.tableHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningsDialogProblemHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
            className: `${$gz44y.tableHeader} ${$gz44y.statusHeader}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningPopupStatusHeaderText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("th", {
            className: `${$gz44y.tableHeader} ${$gz44y.warningEnabledHeader}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningPopupEnabledStateHeaderText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            className: $gz44y.tableBorderReset
        }, Object.entries((0, $hFkwG.WarningTypesOld)).map(([key, value])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { header: header, description: description } = value;
            const isEnabled = !(disabledWarnings || []).includes(key);
            const issueCount = warnings[key] && warnings[key].length || 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gz44y.warningDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, isEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gz44y.statusButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                onClick: ()=>onTypeIdChange(key),
                appearance: "link",
                isDisabled: issueCount === 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $iMHm5.default).warningAffectCountText,
                values: {
                    count: issueCount
                }
            }))), !isEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gz44y.statusButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
                appearance: "link",
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).disabledIssueStatusText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
                isChecked: isEnabled,
                onChange: getOnToggleWarningByType(key, !isEnabled),
                testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warning-type--${key}`,
                label: formatMessage(header)
            })));
        })));
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getTypeDefinedWarningDialogContent = (typeId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-type-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $cff3c978f1b741a0$var$issueListHeaderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hFkwG.WarningTypes)[typeId].header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $cff3c978f1b741a0$var$warningDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hFkwG.WarningTypes)[typeId].description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $cff3c978f1b741a0$var$issueListContainerStyles
        }, (warnings[typeId] || []).map((issueId)=>{
            const issue = issuesById[issueId];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9uGU.default), {
                key: issueId,
                onClick: getOnIssueItemClick(issue),
                issue: issue,
                projectKey: projectsById[issue.project.toString()].key,
                issueType: issueTypesById[issue.type.toString()]
            });
        })));
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const getTypeDefinedWarningDialogContentFFOff = (typeId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-type-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gz44y.issueListHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hFkwG.WarningTypesOld)[typeId].header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gz44y.warningDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hFkwG.WarningTypesOld)[typeId].description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gz44y.issueListContainer
        }, (warnings[typeId] || []).map((issueId)=>{
            const issue = issuesById[issueId];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9uGU.default), {
                key: issueId,
                onClick: getOnIssueItemClick(issue),
                issue: issue,
                projectKey: projectsById[issue.project.toString()].key,
                issueType: issueTypesById[issue.type.toString()]
            });
        })));
    let content = (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? getWarningDialogContent() : getWarningDialogContentFFOff();
    if ((0, $7CnHa.isDefined)(typeId) && typeId !== '') content = (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre') ? getTypeDefinedWarningDialogContent(typeId) : getTypeDefinedWarningDialogContentFFOff(typeId);
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-centre-modal",
        xcss: $cff3c978f1b741a0$var$modalContentHeightStyles
    }, (!(0, $7CnHa.isDefined)(typeId) || typeId === '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$topDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$warningCenterHeaderStyles,
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningCenterHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$warningCenterIntroStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? (0, $iMHm5.default).warningsDialogDescriptionAndDocumentationLink : (0, $iMHm5.default).warningsDialogDescription,
        values: {
            link: (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                articleId: (0, $5rYNM.IPH_IDS).WARNING_CENTER,
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                    href: (0, $awiwy.default).URLs.warningsDialog,
                    tagRef: focusRef
                }, formatMessage((0, $iMHm5.default).iphLink)),
                appearance: "link",
                spacing: "none"
            }, formatMessage((0, $iMHm5.default).iphLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                href: (0, $awiwy.default).URLs.warningsDialog,
                tagRef: focusRef
            }, formatMessage((0, $iMHm5.default).warningsDialogLink))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$toggleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: showWarning,
        onChange: toggleShowWarning,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warnings-visibility",
        label: formatMessage((0, $iMHm5.default).showWarningsOnYourTimeline)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).showWarningsOnYourTimeline)), !(0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$toggleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: warningFilterValue,
        onChange: onToggleWarningsFilter,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warnings-filter",
        label: formatMessage((0, $iMHm5.default).issuesWithWarningFilter)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).issuesWithWarningFilter))), (0, $7CnHa.isDefined)(typeId) && typeId !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            label: ""
        }),
        onClick: ()=>onTypeIdChange(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).goBackToOverview))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cff3c978f1b741a0$var$contentBoxStyles
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-centre-modal",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $gz44y.modalContentHeight
    }, (!(0, $7CnHa.isDefined)(typeId) || typeId === '') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.topDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.warningCenterHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningCenterHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.warningCenterIntro
    }, (0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $iMHm5.default).warningsDialogDescriptionAndDocumentationLink,
        values: {
            link: (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                articleId: (0, $5rYNM.IPH_IDS).WARNING_CENTER,
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                    href: (0, $awiwy.default).URLs.warningsDialog,
                    tagRef: focusRef
                }, formatMessage((0, $iMHm5.default).iphLink)),
                appearance: "link",
                spacing: "none"
            }, formatMessage((0, $iMHm5.default).iphLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                href: (0, $awiwy.default).URLs.warningsDialog,
                tagRef: focusRef
            }, formatMessage((0, $iMHm5.default).warningsDialogLink))
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).warningsDialogPreamble)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.toggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: showWarning,
        onChange: toggleShowWarning,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warnings-visibility",
        label: formatMessage((0, $iMHm5.default).showWarnings)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).showWarnings)), !(0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.toggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: warningFilterValue,
        onChange: onToggleWarningsFilter,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.toggle-warnings-filter",
        label: formatMessage((0, $iMHm5.default).filterIssuesWithWarning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).filterIssuesWithWarning))), (0, $7CnHa.isDefined)(typeId) && typeId !== '' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.backButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            label: ""
        }),
        onClick: ()=>onTypeIdChange(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $iMHm5.default).goBackToOverview))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gz44y.content
    }, content));
};
var $cff3c978f1b741a0$export$2e2bcd8739ae039 = $cff3c978f1b741a0$var$Content;
// Styles
const $cff3c978f1b741a0$var$warningToggleAndTextStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $cff3c978f1b741a0$var$warningsDialogHeaderStyles = (0, $1ZAYh.xcss)({
    fontWeight: '600',
    paddingLeft: 'space.075',
    paddingBottom: 'space.150'
});
const $cff3c978f1b741a0$var$issueListHeaderStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.250'
});
const $cff3c978f1b741a0$var$warningDescriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $cff3c978f1b741a0$var$issueListContainerStyles = (0, $1ZAYh.xcss)({
    maxHeight: '400px',
    overflowY: 'auto'
});
const $cff3c978f1b741a0$var$modalContentHeightStyles = (0, $1ZAYh.xcss)({
    maxHeight: 'calc(100vh - 188px)'
});
const $cff3c978f1b741a0$var$topDescriptionStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.neutral'
});
const $cff3c978f1b741a0$var$warningCenterHeaderStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.150',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text',
    marginLeft: 'space.075'
});
const $cff3c978f1b741a0$var$warningCenterIntroStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100',
    marginLeft: 'space.075'
});
const $cff3c978f1b741a0$var$toggleWrapperStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    display: 'flex'
});
const $cff3c978f1b741a0$var$backButtonStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150'
});
const $cff3c978f1b741a0$var$contentBoxStyles = (0, $1ZAYh.xcss)({
    padding: 'space.200',
    width: '595px'
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $je5kZ = parcelRequire("je5kZ");

var $k9Z3M = parcelRequire("k9Z3M");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$export$3eb7d6130acfda37 = (size)=>size === 'large' ? 'large' : 'small';
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const uuid = (0, $jFtVs.useUIDSeed)()('toggle');
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: `${uuid}-label`,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? `${uuid}-label` : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-check-icon`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-cross-icon`
    })));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // icons - check and cross
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockStart: `${$f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // This is the first of the two on/off symbols. The first of type is a
        // hidden text `span` for labeling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:nth-last-of-type(2)': {
            insetInlineStart: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:last-of-type': {
            insetInlineEnd: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && {
            '> span': {
                position: 'absolute',
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

var $PdmhA = parcelRequire("PdmhA");
const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $PdmhA.G400)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $PdmhA.G500)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N200)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.N400)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("awiwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $19933e48824d6f83$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjY2n = parcelRequire("hjY2n");
function $19933e48824d6f83$var$DocLink({ type: Tag = 'a', href: href, className: className, ariaLabel: ariaLabel, children: children, tagRef: tagRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, {
        href: href,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: tagRef,
        "aria-label": ariaLabel
    }, children);
}
$19933e48824d6f83$var$DocLink.URLs = (0, $hjY2n.default);
var $19933e48824d6f83$export$2e2bcd8739ae039 = $19933e48824d6f83$var$DocLink;

});

parcelRegister("k9uGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd9056da1f01dbf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hl4M2 = parcelRequire("hl4M2");

var $92qrt = parcelRequire("92qrt");
function $5dd9056da1f01dbf$export$2e2bcd8739ae039(props) {
    const { issue: issue, issueType: issueType, projectKey: projectKey, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $92qrt.issueTitle,
        onClick: onClick,
        tabIndex: 0,
        role: "button",
        onKeyPress: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $92qrt.issueIcon,
        style: {
            backgroundImage: issueType && `url(${issueType.iconUrl})`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $92qrt.issueSummary,
        title: issue.summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hl4M2.default), {
        issueKey: issue.issueKey,
        projectKey: projectKey,
        className: $92qrt.issueLink
    }), issue.summary));
}

});
parcelRegister("92qrt", function(module, exports) {

$parcel$export(module.exports, "issueIcon", () => $6948cfd159820f02$export$415983cbc1f2b3fe, (v) => $6948cfd159820f02$export$415983cbc1f2b3fe = v);
$parcel$export(module.exports, "issueLink", () => $6948cfd159820f02$export$b71709449311b2f9, (v) => $6948cfd159820f02$export$b71709449311b2f9 = v);
$parcel$export(module.exports, "issueSummary", () => $6948cfd159820f02$export$7c7bc027bbbea103, (v) => $6948cfd159820f02$export$7c7bc027bbbea103 = v);
$parcel$export(module.exports, "issueTitle", () => $6948cfd159820f02$export$12781bd67c11efd8, (v) => $6948cfd159820f02$export$12781bd67c11efd8 = v);
var $6948cfd159820f02$export$415983cbc1f2b3fe;
var $6948cfd159820f02$export$b71709449311b2f9;
var $6948cfd159820f02$export$7c7bc027bbbea103;
var $6948cfd159820f02$export$12781bd67c11efd8;
$6948cfd159820f02$export$415983cbc1f2b3fe = `LFMl9q_issueIcon`;
$6948cfd159820f02$export$b71709449311b2f9 = `LFMl9q_issueLink`;
$6948cfd159820f02$export$7c7bc027bbbea103 = `LFMl9q_issueSummary`;
$6948cfd159820f02$export$12781bd67c11efd8 = `LFMl9q_issueTitle`;

});


parcelRegister("iMHm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32142604b500ef1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a32142604b500ef1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    warningCenterHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-center-header",
        "defaultMessage": "Warning center"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    warningsDialogProblemHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-problem-header",
        "defaultMessage": "Warning"
    },
    warningsDialogHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-header",
        "defaultMessage": "Show on timeline"
    },
    warningPopupStatusHeaderText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-popup-status-header-text",
        "defaultMessage": "Status"
    },
    warningPopupEnabledStateHeaderText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-popup-enabled-state-header-text",
        "defaultMessage": "Enabled"
    },
    disabledIssueStatusText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.disabled-issue-status-text",
        "defaultMessage": "disabled"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    warningAffectCountText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-affect-count-text",
        "defaultMessage": "affects {count, plural, one {# issue} other {# issues}}"
    },
    warningCountText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warning-count-text",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}}"
    },
    zeroCountWarningText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.zero-count-warning-text",
        "defaultMessage": "-"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    warningsDialogPreamble: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-preamble",
        "defaultMessage": "Configure which type of warnings you want to see in your plan."
    },
    warningsDialogDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-description",
        "defaultMessage": "Configure which warnings you want to see in your plan. {link}"
    },
    warningsDialogDescriptionAndDocumentationLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-description-and-documentation-link",
        "defaultMessage": "Configure which warnings you want to see in your plan. Use the filter menu to only show issues with warnings. {link}"
    },
    warningsDialogLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.warnings-dialog-link",
        "defaultMessage": "Learn more about these warnings."
    },
    iphLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.iph-link",
        "defaultMessage": "How do I resolve these warnings?"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    showWarnings: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.show-warnings",
        "defaultMessage": "Show warnings"
    },
    showWarningsOnYourTimeline: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.show-warnings-on-your-timeline",
        "defaultMessage": "Show warnings on your timeline"
    },
    // Remove when FF com.atlassian.rm.jpo.jpo3cloud.revamp-warning-centre is removed
    filterIssuesWithWarning: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.filter-issues-with-warning",
        "defaultMessage": "Filter issues with warnings"
    },
    issuesWithWarningFilter: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.issues-with-warning-filter",
        "defaultMessage": "Only show issues with warnings"
    },
    goBackToOverview: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.content.go-back-to-overview",
        "defaultMessage": "Go back to overview"
    }
});

});

parcelRegister("gz44y", function(module, exports) {

$parcel$export(module.exports, "affectedIssuesCount", () => $c0f312f09fa3a095$export$7beaea76dcc76433, (v) => $c0f312f09fa3a095$export$7beaea76dcc76433 = v);
$parcel$export(module.exports, "backButton", () => $c0f312f09fa3a095$export$8d6d009d1f06226e, (v) => $c0f312f09fa3a095$export$8d6d009d1f06226e = v);
$parcel$export(module.exports, "content", () => $c0f312f09fa3a095$export$a7db06668cad9adb, (v) => $c0f312f09fa3a095$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "disabledWarningButton", () => $c0f312f09fa3a095$export$3b51cc1f96246e43, (v) => $c0f312f09fa3a095$export$3b51cc1f96246e43 = v);
$parcel$export(module.exports, "issueListContainer", () => $c0f312f09fa3a095$export$d62bc6b8cd0c219a, (v) => $c0f312f09fa3a095$export$d62bc6b8cd0c219a = v);
$parcel$export(module.exports, "issueListHeader", () => $c0f312f09fa3a095$export$500b5b95b0c24a28, (v) => $c0f312f09fa3a095$export$500b5b95b0c24a28 = v);
$parcel$export(module.exports, "modalContentHeight", () => $c0f312f09fa3a095$export$356f9b4e07db7fe5, (v) => $c0f312f09fa3a095$export$356f9b4e07db7fe5 = v);
$parcel$export(module.exports, "statusButton", () => $c0f312f09fa3a095$export$cf9c8034c12dfca5, (v) => $c0f312f09fa3a095$export$cf9c8034c12dfca5 = v);
$parcel$export(module.exports, "statusHeader", () => $c0f312f09fa3a095$export$e48aeb53e75edda7, (v) => $c0f312f09fa3a095$export$e48aeb53e75edda7 = v);
$parcel$export(module.exports, "tableBorderReset", () => $c0f312f09fa3a095$export$6e1a5bc09a65063d, (v) => $c0f312f09fa3a095$export$6e1a5bc09a65063d = v);
$parcel$export(module.exports, "tableHeader", () => $c0f312f09fa3a095$export$48884d2a5190dc73, (v) => $c0f312f09fa3a095$export$48884d2a5190dc73 = v);
$parcel$export(module.exports, "toggleWrapper", () => $c0f312f09fa3a095$export$f6974ddaf51e13c2, (v) => $c0f312f09fa3a095$export$f6974ddaf51e13c2 = v);
$parcel$export(module.exports, "topDescription", () => $c0f312f09fa3a095$export$8b2bc455bfb5f6da, (v) => $c0f312f09fa3a095$export$8b2bc455bfb5f6da = v);
$parcel$export(module.exports, "warningCenterHeader", () => $c0f312f09fa3a095$export$b6a3ec7a3b5e5077, (v) => $c0f312f09fa3a095$export$b6a3ec7a3b5e5077 = v);
$parcel$export(module.exports, "warningCenterIntro", () => $c0f312f09fa3a095$export$7b98675199e17ba7, (v) => $c0f312f09fa3a095$export$7b98675199e17ba7 = v);
$parcel$export(module.exports, "warningDescription", () => $c0f312f09fa3a095$export$7bbb303f6bfc8f38, (v) => $c0f312f09fa3a095$export$7bbb303f6bfc8f38 = v);
$parcel$export(module.exports, "warningEnabledHeader", () => $c0f312f09fa3a095$export$e7cb9302674b493e, (v) => $c0f312f09fa3a095$export$e7cb9302674b493e = v);
$parcel$export(module.exports, "warningTable", () => $c0f312f09fa3a095$export$f05ad4c576480d75, (v) => $c0f312f09fa3a095$export$f05ad4c576480d75 = v);
var $c0f312f09fa3a095$export$7beaea76dcc76433;
var $c0f312f09fa3a095$export$8d6d009d1f06226e;
var $c0f312f09fa3a095$export$a7db06668cad9adb;
var $c0f312f09fa3a095$export$3b51cc1f96246e43;
var $c0f312f09fa3a095$export$d62bc6b8cd0c219a;
var $c0f312f09fa3a095$export$500b5b95b0c24a28;
var $c0f312f09fa3a095$export$356f9b4e07db7fe5;
var $c0f312f09fa3a095$export$cf9c8034c12dfca5;
var $c0f312f09fa3a095$export$e48aeb53e75edda7;
var $c0f312f09fa3a095$export$6e1a5bc09a65063d;
var $c0f312f09fa3a095$export$48884d2a5190dc73;
var $c0f312f09fa3a095$export$f6974ddaf51e13c2;
var $c0f312f09fa3a095$export$8b2bc455bfb5f6da;
var $c0f312f09fa3a095$export$b6a3ec7a3b5e5077;
var $c0f312f09fa3a095$export$7b98675199e17ba7;
var $c0f312f09fa3a095$export$7bbb303f6bfc8f38;
var $c0f312f09fa3a095$export$e7cb9302674b493e;
var $c0f312f09fa3a095$export$f05ad4c576480d75;
$c0f312f09fa3a095$export$7beaea76dcc76433 = `_6nmt9a_affectedIssuesCount`;
$c0f312f09fa3a095$export$8d6d009d1f06226e = `_6nmt9a_backButton`;
$c0f312f09fa3a095$export$a7db06668cad9adb = `_6nmt9a_content`;
$c0f312f09fa3a095$export$3b51cc1f96246e43 = `_6nmt9a_disabledWarningButton`;
$c0f312f09fa3a095$export$d62bc6b8cd0c219a = `_6nmt9a_issueListContainer`;
$c0f312f09fa3a095$export$500b5b95b0c24a28 = `_6nmt9a_issueListHeader`;
$c0f312f09fa3a095$export$356f9b4e07db7fe5 = `_6nmt9a_modalContentHeight`;
$c0f312f09fa3a095$export$cf9c8034c12dfca5 = `_6nmt9a_statusButton`;
$c0f312f09fa3a095$export$e48aeb53e75edda7 = `_6nmt9a_statusHeader`;
$c0f312f09fa3a095$export$6e1a5bc09a65063d = `_6nmt9a_tableBorderReset`;
$c0f312f09fa3a095$export$48884d2a5190dc73 = `_6nmt9a_tableHeader`;
$c0f312f09fa3a095$export$f6974ddaf51e13c2 = `_6nmt9a_toggleWrapper`;
$c0f312f09fa3a095$export$8b2bc455bfb5f6da = `_6nmt9a_topDescription`;
$c0f312f09fa3a095$export$b6a3ec7a3b5e5077 = `_6nmt9a_warningCenterHeader`;
$c0f312f09fa3a095$export$7b98675199e17ba7 = `_6nmt9a_warningCenterIntro`;
$c0f312f09fa3a095$export$7bbb303f6bfc8f38 = `_6nmt9a_warningDescription`;
$c0f312f09fa3a095$export$e7cb9302674b493e = `_6nmt9a_warningEnabledHeader`;
$c0f312f09fa3a095$export$f05ad4c576480d75 = `_6nmt9a_warningTable`;

});


parcelRegister("4m0f4", function(module, exports) {

$parcel$export(module.exports, "default", () => $827a313f0664dac5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $827a313f0664dac5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    warningsButtonLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.warnings-button-label",
        "defaultMessage": "Warnings"
    }
});

});

parcelRegister("nLQ6A", function(module, exports) {

$parcel$export(module.exports, "warningsButtonIconLabel", () => $04774201b93ab7ce$export$fb2e2236de94c4bc, (v) => $04774201b93ab7ce$export$fb2e2236de94c4bc = v);
$parcel$export(module.exports, "warningsButtonIconOnly", () => $04774201b93ab7ce$export$be7fa4316fd602e4, (v) => $04774201b93ab7ce$export$be7fa4316fd602e4 = v);
var $04774201b93ab7ce$export$fb2e2236de94c4bc;
var $04774201b93ab7ce$export$be7fa4316fd602e4;
$04774201b93ab7ce$export$fb2e2236de94c4bc = `Tcej8q_warningsButtonIconLabel`;
$04774201b93ab7ce$export$be7fa4316fd602e4 = `Tcej8q_warningsButtonIconOnly`;

});



parcelRegister("Bp98t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201f273af13e375$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $8clM6 = parcelRequire("8clM6");

var $3SEZf = parcelRequire("3SEZf");

var $fCk8j = parcelRequire("fCk8j");
var $d201f273af13e375$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3SEZf.default), (0, $8clM6.default))((0, $fCk8j.default));

});
parcelRegister("8clM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fde7eaa3314663$export$2e2bcd8739ae039);

var $5GdAe = parcelRequire("5GdAe");

var $6zT5O = parcelRequire("6zT5O");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$09fde7eaa3314663$export$2e2bcd8739ae039 = {
    discardChanges: $5GdAe.discardChanges,
    saveView: $5GdAe.saveView,
    saveViewAs: $5GdAe.saveViewAs,
    removeError: $6zT5O.removeError,
    deleteView: $5GdAe.deleteView,
    setSaveViewAsDialogStatus: $6zT5O.setSaveViewAsDialogStatus,
    switchView: $5GdAe.switchView
};

});
parcelRegister("5GdAe", function(module, exports) {

$parcel$export(module.exports, "switchView", () => $d984085e1bfcb8c2$export$adaf8a367aa41030);
$parcel$export(module.exports, "modifyView", () => $d984085e1bfcb8c2$export$d47a9f66421ac6ac);
$parcel$export(module.exports, "discardChanges", () => $d984085e1bfcb8c2$export$a1371969d487fc2a);
$parcel$export(module.exports, "saveView", () => $d984085e1bfcb8c2$export$5c85e4ea5ae8a7f2);
$parcel$export(module.exports, "saveViewAs", () => $d984085e1bfcb8c2$export$771c355a80466f9b);
$parcel$export(module.exports, "deleteView", () => $d984085e1bfcb8c2$export$443d89549b135c95);
$parcel$export(module.exports, "markAsDefaultView", () => $d984085e1bfcb8c2$export$65c8c09b8f8e5243);
$parcel$export(module.exports, "fetchHistoricalIssueForView", () => $d984085e1bfcb8c2$export$74f46688edc62a6d);
$parcel$export(module.exports, "applyModificationsForInactiveViews", () => $d984085e1bfcb8c2$export$423d927bdcf0d280);
$parcel$export(module.exports, "populateReportViewSettings", () => $d984085e1bfcb8c2$export$60fcc8898bd8f5d0);
$parcel$export(module.exports, "initializeViews", () => $d984085e1bfcb8c2$export$6fa92c81825ed985);
$parcel$export(module.exports, "default", () => $d984085e1bfcb8c2$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");
var $01zCq = parcelRequire("01zCq");
var $dRoir = parcelRequire("dRoir");
var $f7Op5 = parcelRequire("f7Op5");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kXdPE = parcelRequire("kXdPE");

var $cbq3D = parcelRequire("cbq3D");

var $iTjRl = parcelRequire("iTjRl");

var $1Szmp = parcelRequire("1Szmp");

var $75KhQ = parcelRequire("75KhQ");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $gtAIo = parcelRequire("gtAIo");

var $l4n5f = parcelRequire("l4n5f");


var $dJ7Td = parcelRequire("dJ7Td");

var $6zT5O = parcelRequire("6zT5O");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $3uVcR = parcelRequire("3uVcR");
var $ewehA = parcelRequire("ewehA");
const $d984085e1bfcb8c2$var$SWITCH_VIEW = 'command.views.SWITCH_VIEW';
const $d984085e1bfcb8c2$var$MODIFY_VIEW = 'command.views.MODIFY_VIEW';
const $d984085e1bfcb8c2$var$SAVE_VIEW = 'command.views.SAVE_VIEW';
const $d984085e1bfcb8c2$var$SAVE_VIEW_AS = 'command.views.SAVE_VIEW_AS';
const $d984085e1bfcb8c2$var$DISCARD_CHANGES = 'command.views.DISCARD_CHANGES';
const $d984085e1bfcb8c2$var$DELETE_VIEW = 'command.views.DELETE_VIEW';
const $d984085e1bfcb8c2$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW = 'command.views.FETCH_HISTORICAL_ISSUE_FOR_VIEW';
const $d984085e1bfcb8c2$var$MARK_AS_DEFAULT_VIEW = 'command.views.MARK_AS_DEFAULT_VIEW';
const $d984085e1bfcb8c2$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS = 'command.views.APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS';
const $d984085e1bfcb8c2$export$adaf8a367aa41030 = (id)=>({
        type: $d984085e1bfcb8c2$var$SWITCH_VIEW,
        payload: {
            id: id
        }
    });
const $d984085e1bfcb8c2$export$d47a9f66421ac6ac = (payload)=>({
        type: $d984085e1bfcb8c2$var$MODIFY_VIEW,
        payload: payload
    });
const $d984085e1bfcb8c2$export$a1371969d487fc2a = (id)=>({
        type: $d984085e1bfcb8c2$var$DISCARD_CHANGES,
        payload: {
            id: id
        }
    });
const $d984085e1bfcb8c2$export$5c85e4ea5ae8a7f2 = (payload)=>({
        type: $d984085e1bfcb8c2$var$SAVE_VIEW,
        payload: payload
    });
const $d984085e1bfcb8c2$export$771c355a80466f9b = (payload)=>({
        type: $d984085e1bfcb8c2$var$SAVE_VIEW_AS,
        payload: payload
    });
const $d984085e1bfcb8c2$export$443d89549b135c95 = (id, shouldCallAPI = true)=>({
        type: $d984085e1bfcb8c2$var$DELETE_VIEW,
        payload: {
            id: id,
            shouldCallAPI: shouldCallAPI
        }
    });
const $d984085e1bfcb8c2$export$65c8c09b8f8e5243 = (id)=>({
        type: $d984085e1bfcb8c2$var$MARK_AS_DEFAULT_VIEW,
        payload: {
            id: id
        }
    });
const $d984085e1bfcb8c2$export$74f46688edc62a6d = ()=>({
        type: $d984085e1bfcb8c2$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW
    });
const $d984085e1bfcb8c2$export$423d927bdcf0d280 = (savedViewsInfo)=>({
        type: $d984085e1bfcb8c2$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS,
        payload: savedViewsInfo
    });
function* $d984085e1bfcb8c2$export$aea62a1ac812f7bb(viewSettings) {
    const viewSettingsData = ()=>viewSettings;
    yield (0, $9e8i2.put)((0, $gtAIo.reset)(viewSettingsData()));
}
function* $d984085e1bfcb8c2$export$60fcc8898bd8f5d0(viewSettings) {
    yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$aea62a1ac812f7bb, (yield (0, $9e8i2.call)($3uVcR.getReportViewSettings, viewSettings)));
}
function* $d984085e1bfcb8c2$export$57a10d00b7d9e806(view) {
    const changedPrefs = yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$aea62a1ac812f7bb, view.preferences);
    if (changedPrefs) {
        const mergePrefs = $dRoir.default(changedPrefs);
        const preferences = mergePrefs(view.preferences);
        return $dRoir.default({
            preferences: preferences
        })(view);
    }
}
function* $d984085e1bfcb8c2$export$60f6a189695639d0(action) {
    const { id: viewId } = action.payload;
    yield* (0, $kXdPE.default)(function*() {
        const views = yield (0, $9e8i2.select)((0, $dBKyg.getViews));
        const selected = views.find(({ id: id })=>id === viewId);
        if (!selected) return;
        const updated = yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$57a10d00b7d9e806, selected);
        if (updated) yield (0, $9e8i2.put)($l4n5f.updateView(updated));
        yield (0, $9e8i2.put)($l4n5f.setActiveView(selected));
        yield (0, $9e8i2.call)($3uVcR.replaceURLForViewId, viewId);
    });
    yield (0, $9e8i2.call)($3uVcR.pushActiveViewId, viewId);
    yield (0, $9e8i2.put)($d984085e1bfcb8c2$export$74f46688edc62a6d());
}
function* $d984085e1bfcb8c2$export$6fa92c81825ed985(payload) {
    if (!payload || !payload.savedViews) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return yield (0, $9e8i2.call)((0, $iTjRl.withErrorTolerated), function*() {
        const isSample = yield (0, $9e8i2.select)((0, $75KhQ.getIsSamplePlan));
        const isCrossTeamPlanning = $3uVcR.isCrossTeamPlanningTemplateExperimentEnabled() ? yield (0, $9e8i2.select)((0, $75KhQ.getIsCrossTeamPlanning)) : undefined;
        const { vid: vid } = (0, $lFLge.parseQueryParams)(window.location.search);
        const views = yield (0, $9e8i2.call)($3uVcR.initializeViews, payload, {
            forSamplePlan: isSample,
            forCrossTeamPlanning: isCrossTeamPlanning
        });
        const active = views.find($f7Op5.default('active'));
        yield* (0, $kXdPE.default)(function*() {
            yield (0, $9e8i2.put)($l4n5f.reset(views));
            const updated = yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$57a10d00b7d9e806, active);
            if (updated) yield (0, $9e8i2.put)($l4n5f.updateView(updated));
        });
        const viewForVid = views.find((view)=>view.id === Number(vid));
        if (isSample) yield (0, $9e8i2.call)($3uVcR.replaceURLForSamplePlan);
        if (viewForVid && active.id !== viewForVid.id) yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$60f6a189695639d0, $d984085e1bfcb8c2$export$adaf8a367aa41030(viewForVid.id));
        else {
            yield (0, $9e8i2.call)($3uVcR.replaceURLForViewId, active.id);
            // doSwitchView also fetches historical issues so we want to fetch it only when we are not switching views.
            yield (0, $9e8i2.put)($d984085e1bfcb8c2$export$74f46688edc62a6d());
        }
    });
}
function* $d984085e1bfcb8c2$export$fdd4f54ef4770039() {
    yield (0, $bG7pV.takeLatest)($d984085e1bfcb8c2$var$SWITCH_VIEW, $d984085e1bfcb8c2$export$60f6a189695639d0);
}
function* $d984085e1bfcb8c2$export$d5f781a73c19a677(action) {
    yield (0, $9e8i2.put)($l4n5f.modifyView(action.payload));
    const views = yield (0, $9e8i2.select)((0, $dBKyg.getViews));
    const modifiedView = views.find(({ id: id })=>id === action.payload.id);
    if (!modifiedView) throw new Error('modified view not found');
    yield (0, $9e8i2.call)($3uVcR.pushModifiedView, modifiedView);
}
function* $d984085e1bfcb8c2$export$b05193c1480d5bf3() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$MODIFY_VIEW, $d984085e1bfcb8c2$export$d5f781a73c19a677);
}
function* $d984085e1bfcb8c2$export$937c45f7777ca9e7(action) {
    const viewId = action.payload.id;
    const view = (yield (0, $9e8i2.select)((0, $dBKyg.getViews))).find((one)=>one.id === viewId);
    if (!view) throw new Error('view to discard not found');
    if (view.original) {
        const updated = yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$57a10d00b7d9e806, $aeXAa.default('active', true)(view.original));
        if (updated) yield (0, $9e8i2.put)($l4n5f.updateView(updated));
    }
    yield (0, $9e8i2.put)($l4n5f.discardChanges(view.id));
    yield (0, $9e8i2.call)($3uVcR.deleteModifiedView, view.id);
}
function* $d984085e1bfcb8c2$export$891357a43e298c1() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$DISCARD_CHANGES, $d984085e1bfcb8c2$export$937c45f7777ca9e7);
}
function* $d984085e1bfcb8c2$export$819415907a77688(action) {
    yield (0, $9e8i2.put)((0, $dJ7Td.setRenameSaving)(true));
    // when saving from the settings page, we send the source view in the payload
    // when saving from roadmap, we just get the active view
    const active = action.payload.view || (yield (0, $9e8i2.select)((0, $dBKyg.getPrunedActiveView)));
    if (!active.modified && !action.payload.renameOnly) throw new Error('cannot save unmodifed view');
    try {
        const version = action.payload.overwrite && active.original ? active.original.version : active.version;
        const { version: nextVersion } = yield (0, $9e8i2.call)($3uVcR.updateView, $01zCq.default(active, {
            version: version
        }), action.payload.renameOnly);
        yield (0, $9e8i2.put)($l4n5f.saveView(active.id, nextVersion, active.name));
        if (!action.payload.renameOnly) // only delete the view mods if it's a full save, not just a rename
        yield (0, $9e8i2.call)($3uVcR.deleteModifiedView, active.id);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (err instanceof $ewehA.UpdateErrorConflicted) {
            /*
                Fetch the latest version of the view to be used
                when user decide to discard / overwrite the changes
            */ const view = yield (0, $9e8i2.call)($3uVcR.fetchSavedView, active.id);
            yield (0, $9e8i2.put)($l4n5f.updateView({
                id: active.id,
                original: view
            }));
            yield (0, $9e8i2.put)($6zT5O.addError(new $ewehA.UpdateErrorConflicted({
                ...err,
                modifiedBy: view.updatedBy
            })));
        } else if (err instanceof $ewehA.UpdateErrorNotExists) yield (0, $9e8i2.put)($6zT5O.addError(err));
        else if (err instanceof $ewehA.SaveAsErrorDuplicateView) yield (0, $9e8i2.put)($6zT5O.addError(err));
        else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: err,
            stackTrace: err.stack
        }));
    }
    yield (0, $9e8i2.put)((0, $dJ7Td.setRenameSaving)(false));
}
function* $d984085e1bfcb8c2$export$6822aa1f0a093909() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$SAVE_VIEW, $d984085e1bfcb8c2$export$819415907a77688);
}
function* $d984085e1bfcb8c2$export$8417e6604a78ce1(action) {
    const { name: name, asDefault: isDefault, duplicateSection: duplicateSection, sourceViewId: sourceViewId } = action.payload;
    // The choice to perform certain actions depends on whether we're
    // trying to 'save as' from the settings page or the roadmap page.
    // We only receive the sourceViewId arg from the settings page.
    const fromSettingsPage = !!sourceViewId;
    const currentView = (0, $7CnHa.isDefined)(sourceViewId) ? yield (0, $9e8i2.select)((0, $dBKyg.getViewById), sourceViewId) : yield (0, $9e8i2.select)((0, $dBKyg.getPrunedActiveView));
    const views = yield (0, $9e8i2.select)((0, $dBKyg.getViews));
    const currentJiraUser = yield (0, $9e8i2.call)($3uVcR.getCurrentUserInViewFormat);
    // Need to find unique negative number for temporary id
    const tempId = function _r(id) {
        if (views.some((one)=>one.id === id)) return _r(id - 1);
        return id;
    }(-1);
    const newView = {
        id: tempId,
        name: name,
        preferences: currentView.preferences,
        persisted: currentView.persisted,
        version: 0,
        isDefault: isDefault,
        active: false,
        modified: false,
        original: null,
        createdBy: currentJiraUser,
        updatedAt: new Date(),
        updatedBy: currentJiraUser
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield (0, $9e8i2.call)((0, $iTjRl.withErrorTolerated), function*() {
        yield (0, $9e8i2.put)($6zT5O.setSaveViewAsDialogStatus('SAVING'));
        const { id: actualId, errorCode: errorCode } = yield (0, $9e8i2.call)($3uVcR.createView, newView);
        if (errorCode === 'DUPLICATE_VIEW') {
            const error = new $ewehA.SaveAsErrorDuplicateView({
                viewId: tempId,
                viewName: currentView.name,
                newName: newView.name
            });
            yield (0, $9e8i2.put)($6zT5O.addError(error));
            yield (0, $9e8i2.put)($6zT5O.setSaveViewAsDialogStatus('OPEN'));
            return;
        }
        yield (0, $9e8i2.put)($6zT5O.setSaveViewAsDialogStatus('CLOSED'));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        yield* (0, $kXdPE.default)(function*() {
            yield (0, $9e8i2.put)($l4n5f.addView(newView));
            if (!fromSettingsPage || fromSettingsPage && currentView.active) yield (0, $9e8i2.put)($l4n5f.setActiveView({
                id: tempId
            }));
            if (currentView.id === (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28)) // removing the view if it is an "Untitled" one
            yield (0, $9e8i2.put)($l4n5f.removeView(currentView.id));
            else {
                // removing the view if we're saving as from the settings page
                // (we can only achieve save as from settings if the view we
                // were renaming was deleted from under us)
                if (fromSettingsPage) yield (0, $9e8i2.put)($l4n5f.removeView(currentView.id));
                // otherwise discarding changes of the view
                yield (0, $9e8i2.put)($l4n5f.discardChanges(currentView.id));
            }
        });
        yield (0, $9e8i2.call)($3uVcR.deleteModifiedView, currentView.id);
        yield (0, $9e8i2.put)($l4n5f.changeId(tempId, actualId));
        if (duplicateSection) $3uVcR.duplicateSectionState({
            sourceViewId: currentView.id,
            targetViewId: actualId,
            duplicateSection: duplicateSection
        });
        // we want to switch to the new view if we're on the roadmap page
        // or if we're on the settings page and the currentView (now removed)
        // was the active view
        if (!fromSettingsPage || fromSettingsPage && currentView.active) yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$60f6a189695639d0, $d984085e1bfcb8c2$export$adaf8a367aa41030(actualId));
    });
}
function* $d984085e1bfcb8c2$export$c554e9fd017b5411() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$SAVE_VIEW_AS, $d984085e1bfcb8c2$export$8417e6604a78ce1);
}
function* $d984085e1bfcb8c2$export$42488dc94da29116(action) {
    const { id: viewId } = action.payload;
    const views = yield (0, $9e8i2.select)((0, $dBKyg.getViews));
    const viewToRemove = views.find(({ id: id })=>id === viewId);
    const defaultView = yield (0, $9e8i2.select)((0, $dBKyg.getDefaultView));
    const { shouldCallAPI: shouldCallAPI } = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield (0, $9e8i2.call)((0, $iTjRl.withErrorTolerated), function*() {
        if (shouldCallAPI && viewToRemove.id !== (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28)) {
            const deleteResponse = yield (0, $9e8i2.call)($3uVcR.deleteView, viewToRemove.id);
            if ((0, $7CnHa.isDefined)(deleteResponse) && deleteResponse.errorCode === 'DEFAULT_VIEW') {
                yield (0, $9e8i2.put)($l4n5f.markAsDefaultView(viewToRemove.id));
                yield (0, $9e8i2.put)($6zT5O.addError(new $ewehA.DeleteErrorDefaultView({
                    viewId: viewToRemove.id,
                    viewName: viewToRemove.name
                })));
                return;
            }
        }
        yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$937c45f7777ca9e7, $d984085e1bfcb8c2$export$a1371969d487fc2a(viewToRemove.id));
        yield (0, $9e8i2.put)($l4n5f.removeView(viewToRemove.id));
        if (viewToRemove.active) yield (0, $9e8i2.call)($d984085e1bfcb8c2$export$60f6a189695639d0, $d984085e1bfcb8c2$export$adaf8a367aa41030(defaultView.id));
    });
}
function* $d984085e1bfcb8c2$export$d96b7cdfdceeb949() {
    // we have to fetch historical issues only if the breakdown column is visible
    // TODO: [list view] double check if the fetch here needs to be based on view mode
    const fields = yield (0, $9e8i2.select)((0, $9H2AP.getFieldColumnsViewSettingsByViewMode));
    const hasBreakdown = fields.columns.find((column)=>column.id === 'breakdown');
    const hasBreakdownByEstimate = fields.columns.find((column)=>column.id === 'progressByEstimation');
    if (hasBreakdown && hasBreakdown.isVisible === true || hasBreakdownByEstimate && hasBreakdownByEstimate.isVisible === true) yield (0, $9e8i2.put)((0, $1Szmp.fetchHistoricalDoneIssues)());
}
function* $d984085e1bfcb8c2$export$d926b2deb1f6679f(action) {
    const { activeViewId: activeViewId, modifiedSavedViews: modifiedSavedViews } = action.payload;
    const modifiedInactiveViews = [];
    for (const view of modifiedSavedViews)// Apply modifications for only inactive views
    if (view.id !== activeViewId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    modifiedInactiveViews.push((yield (0, $9e8i2.call)($3uVcR.prepareModifiedView, view)));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yield* (0, $kXdPE.default)(function*() {
        for (const view of modifiedInactiveViews)yield (0, $9e8i2.put)($l4n5f.modifyView(view));
    });
}
function* $d984085e1bfcb8c2$export$e944914df7c62610() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$DELETE_VIEW, $d984085e1bfcb8c2$export$42488dc94da29116);
}
function* $d984085e1bfcb8c2$export$ce5df739bd41a75e() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$FETCH_HISTORICAL_ISSUE_FOR_VIEW, $d984085e1bfcb8c2$export$d96b7cdfdceeb949);
}
function* $d984085e1bfcb8c2$export$ac7387aac4bb66ae(action) {
    const { id: viewId } = action.payload;
    // marking this view as default in the reducer
    yield (0, $9e8i2.put)($l4n5f.markAsDefaultView(viewId));
    // marking this view as default in the backend
    yield (0, $9e8i2.call)($3uVcR.markAsDefaultView, {
        id: viewId,
        isDefault: true
    });
}
function* $d984085e1bfcb8c2$export$e5281f3ef11f93a2() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$MARK_AS_DEFAULT_VIEW, $d984085e1bfcb8c2$export$ac7387aac4bb66ae);
}
function* $d984085e1bfcb8c2$export$b9e892138c4d10a6() {
    yield (0, $bG7pV.takeEvery)($d984085e1bfcb8c2$var$APPLY_MODIFICATIONS_FOR_INACTIVE_VIEWS, $d984085e1bfcb8c2$export$d926b2deb1f6679f);
}
function* $d984085e1bfcb8c2$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$fdd4f54ef4770039);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$b05193c1480d5bf3);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$891357a43e298c1);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$6822aa1f0a093909);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$c554e9fd017b5411);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$e944914df7c62610);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$e5281f3ef11f93a2);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$ce5df739bd41a75e);
    yield (0, $9e8i2.fork)($d984085e1bfcb8c2$export$b9e892138c4d10a6);
}

});
parcelRegister("dRoir", function(module, exports) {

$parcel$export(module.exports, "default", () => $a173125a9455fcba$export$2e2bcd8739ae039);

var $cOiwb = parcelRequire("cOiwb");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $a173125a9455fcba$var$mergeLeft = /*#__PURE__*/ (0, $ggdJA.default)(function mergeLeft(l, r) {
    return (0, $cOiwb.default)({}, r, l);
});
var $a173125a9455fcba$export$2e2bcd8739ae039 = $a173125a9455fcba$var$mergeLeft;

});

parcelRegister("gtAIo", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $85f0775501638f44$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $85f0775501638f44$export$aad8462122ac592b);
const $85f0775501638f44$export$4a991c87e640ef77 = 'state.domain.view-settings.RESET';
const $85f0775501638f44$export$aad8462122ac592b = (payload)=>({
        type: $85f0775501638f44$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("l4n5f", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $5f28ae5a0cb96329$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD_VIEW", () => $5f28ae5a0cb96329$export$d5c7f0043e8499b4);
$parcel$export(module.exports, "SET_ACTIVE_VIEW", () => $5f28ae5a0cb96329$export$1dcbb1560f898e17);
$parcel$export(module.exports, "UPDATE_VIEW", () => $5f28ae5a0cb96329$export$f72ed78ff6e8d2c1);
$parcel$export(module.exports, "MODIFY_VIEW", () => $5f28ae5a0cb96329$export$9924007b7b68c0);
$parcel$export(module.exports, "DISCARD_CHANGES", () => $5f28ae5a0cb96329$export$633852209b65bdf8);
$parcel$export(module.exports, "SAVE_VIEW", () => $5f28ae5a0cb96329$export$54365030094e4c08);
$parcel$export(module.exports, "CHANGE_ID", () => $5f28ae5a0cb96329$export$30d96d366ce76f35);
$parcel$export(module.exports, "REMOVE_VIEW", () => $5f28ae5a0cb96329$export$b17ac863c94eaf9d);
$parcel$export(module.exports, "MARK_AS_DEFAULT_VIEW", () => $5f28ae5a0cb96329$export$898cd9d1c5ed8268);
$parcel$export(module.exports, "reset", () => $5f28ae5a0cb96329$export$aad8462122ac592b);
$parcel$export(module.exports, "addView", () => $5f28ae5a0cb96329$export$35410e842afb9251);
$parcel$export(module.exports, "setActiveView", () => $5f28ae5a0cb96329$export$72db5c5227066d6d);
$parcel$export(module.exports, "updateView", () => $5f28ae5a0cb96329$export$827a6c17a85f6d1a);
$parcel$export(module.exports, "modifyView", () => $5f28ae5a0cb96329$export$d47a9f66421ac6ac);
$parcel$export(module.exports, "discardChanges", () => $5f28ae5a0cb96329$export$a1371969d487fc2a);
$parcel$export(module.exports, "saveView", () => $5f28ae5a0cb96329$export$5c85e4ea5ae8a7f2);
$parcel$export(module.exports, "changeId", () => $5f28ae5a0cb96329$export$8573c371c091443a);
$parcel$export(module.exports, "removeView", () => $5f28ae5a0cb96329$export$db777a0280058600);
$parcel$export(module.exports, "markAsDefaultView", () => $5f28ae5a0cb96329$export$65c8c09b8f8e5243);
const $5f28ae5a0cb96329$export$4a991c87e640ef77 = 'state.domain.views.RESET';
const $5f28ae5a0cb96329$export$d5c7f0043e8499b4 = 'state.domain.views.ADD_VIEW';
const $5f28ae5a0cb96329$export$1dcbb1560f898e17 = 'state.domain.views.SET_ACTIVE_VIEW';
const $5f28ae5a0cb96329$export$f72ed78ff6e8d2c1 = 'state.domain.views.UPDATE_VIEW';
const $5f28ae5a0cb96329$export$9924007b7b68c0 = 'state.domain.views.MODIFY_VIEW';
const $5f28ae5a0cb96329$export$633852209b65bdf8 = 'state.domain.views.DISCARD_CHANGES';
const $5f28ae5a0cb96329$export$54365030094e4c08 = 'state.domain.views.SAVE_VIEW';
const $5f28ae5a0cb96329$export$30d96d366ce76f35 = 'state.domain.views.CHANGE_ID';
const $5f28ae5a0cb96329$export$b17ac863c94eaf9d = 'state.domain.views.REMOVE_VIEW';
const $5f28ae5a0cb96329$export$898cd9d1c5ed8268 = 'state.domain.views.MARK_AS_DEFAULT_VIEW';
const $5f28ae5a0cb96329$export$aad8462122ac592b = (payload)=>({
        type: $5f28ae5a0cb96329$export$4a991c87e640ef77,
        payload: payload
    });
const $5f28ae5a0cb96329$export$35410e842afb9251 = (payload)=>({
        type: $5f28ae5a0cb96329$export$d5c7f0043e8499b4,
        payload: payload
    });
const $5f28ae5a0cb96329$export$72db5c5227066d6d = (payload)=>({
        type: $5f28ae5a0cb96329$export$1dcbb1560f898e17,
        payload: payload
    });
const $5f28ae5a0cb96329$export$827a6c17a85f6d1a = (payload)=>({
        type: $5f28ae5a0cb96329$export$f72ed78ff6e8d2c1,
        payload: payload
    });
const $5f28ae5a0cb96329$export$d47a9f66421ac6ac = (payload)=>({
        type: $5f28ae5a0cb96329$export$9924007b7b68c0,
        payload: payload
    });
const $5f28ae5a0cb96329$export$a1371969d487fc2a = (id)=>({
        type: $5f28ae5a0cb96329$export$633852209b65bdf8,
        payload: {
            id: id
        }
    });
const $5f28ae5a0cb96329$export$5c85e4ea5ae8a7f2 = (id, nextVersion, name)=>({
        type: $5f28ae5a0cb96329$export$54365030094e4c08,
        payload: {
            id: id,
            version: nextVersion,
            name: name
        }
    });
const $5f28ae5a0cb96329$export$8573c371c091443a = (previous, next)=>({
        type: $5f28ae5a0cb96329$export$30d96d366ce76f35,
        payload: {
            previous: previous,
            next: next
        }
    });
const $5f28ae5a0cb96329$export$db777a0280058600 = (id)=>({
        type: $5f28ae5a0cb96329$export$b17ac863c94eaf9d,
        payload: {
            id: id
        }
    });
const $5f28ae5a0cb96329$export$65c8c09b8f8e5243 = (id)=>({
        type: $5f28ae5a0cb96329$export$898cd9d1c5ed8268,
        payload: {
            id: id
        }
    });

});

const $a5f9f46ec677da8d$export$bbf45675c6d09c28 = 0;
const $a5f9f46ec677da8d$export$468529e988abe072 = '@@CURRENT_USER'; // Used for createdBy & updatedBy

parcelRegister("dJ7Td", function(module, exports) {

$parcel$export(module.exports, "SET_RENAME_SAVING", () => $d6ff332268c41c09$export$457cfa1eeaf7e7d0);
$parcel$export(module.exports, "setRenameSaving", () => $d6ff332268c41c09$export$e0b94c76da8c605e);

var $6zT5O = parcelRequire("6zT5O");
const $d6ff332268c41c09$export$457cfa1eeaf7e7d0 = 'state.ui.settings.views.row.SET_RENAME_SAVING';
const $d6ff332268c41c09$export$e0b94c76da8c605e = (saving)=>({
        type: $d6ff332268c41c09$export$457cfa1eeaf7e7d0,
        payload: saving
    });

});
parcelRegister("6zT5O", function(module, exports) {

$parcel$export(module.exports, "ADD_ERROR", () => $3a63eb68d45c84e9$export$3a6b9485726c3ea0);
$parcel$export(module.exports, "REMOVE_ERROR", () => $3a63eb68d45c84e9$export$bb5b23b9a43f9778);
$parcel$export(module.exports, "SET_SAVE_VIEW_AS_DIALOG_STATUS", () => $3a63eb68d45c84e9$export$bd13754248ee35);
$parcel$export(module.exports, "addError", () => $3a63eb68d45c84e9$export$239c33984d9b1367);
$parcel$export(module.exports, "removeError", () => $3a63eb68d45c84e9$export$220bda22c3bcb06f);
$parcel$export(module.exports, "setSaveViewAsDialogStatus", () => $3a63eb68d45c84e9$export$e2e02ce9f0f78490);
const $3a63eb68d45c84e9$export$3a6b9485726c3ea0 = 'state.ui.top.view-bar.ADD_ERROR';
const $3a63eb68d45c84e9$export$bb5b23b9a43f9778 = 'state.ui.top.view-bar.REMOVE_ERROR';
const $3a63eb68d45c84e9$export$bd13754248ee35 = 'state.ui.top.view-bar.SET_SAVE_VIEW_AS_DIALOG_STATUS';
const $3a63eb68d45c84e9$export$239c33984d9b1367 = (error)=>({
        type: $3a63eb68d45c84e9$export$3a6b9485726c3ea0,
        payload: error
    });
const $3a63eb68d45c84e9$export$220bda22c3bcb06f = (error)=>({
        type: $3a63eb68d45c84e9$export$bb5b23b9a43f9778,
        payload: error
    });
const $3a63eb68d45c84e9$export$e2e02ce9f0f78490 = (status)=>({
        type: $3a63eb68d45c84e9$export$bd13754248ee35,
        payload: status
    });

});


parcelRegister("3uVcR", function(module, exports) {

$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $b118d87b96a4c644$export$5d06510124eb14f8);
$parcel$export(module.exports, "getCurrentUserInViewFormat", () => $b118d87b96a4c644$export$1e094021f1ba1c3b);
$parcel$export(module.exports, "prepareModifiedView", () => $b118d87b96a4c644$export$982d2d18ebd0a982);
$parcel$export(module.exports, "pushActiveViewId", () => $b118d87b96a4c644$export$937c89ad2c912ae5);
$parcel$export(module.exports, "pushModifiedView", () => $b118d87b96a4c644$export$a55835a0997c18e6);
$parcel$export(module.exports, "deleteModifiedView", () => $b118d87b96a4c644$export$3f3078e2fb5b2249);
$parcel$export(module.exports, "createView", () => $b118d87b96a4c644$export$d7febe7b891e79f0);
$parcel$export(module.exports, "updateView", () => $b118d87b96a4c644$export$827a6c17a85f6d1a);
$parcel$export(module.exports, "fetchSavedView", () => $b118d87b96a4c644$export$bc294d0493f3206);
$parcel$export(module.exports, "initializeViews", () => $b118d87b96a4c644$export$6fa92c81825ed985);
$parcel$export(module.exports, "getReportViewSettings", () => $b118d87b96a4c644$export$1050f30725ffa53);
$parcel$export(module.exports, "deleteView", () => $b118d87b96a4c644$export$443d89549b135c95);
$parcel$export(module.exports, "markAsDefaultView", () => $b118d87b96a4c644$export$65c8c09b8f8e5243);
$parcel$export(module.exports, "replaceURLForViewId", () => $b118d87b96a4c644$export$c816faf8404f4eb6);
$parcel$export(module.exports, "replaceURLForSamplePlan", () => $b118d87b96a4c644$export$ecf701fdb2f69c12);
$parcel$export(module.exports, "duplicateSectionState", () => $b118d87b96a4c644$export$8b6fc6f02567edff);
$parcel$export(module.exports, "UpdateErrorConflicted", () => (parcelRequire("ewehA")).UpdateErrorConflicted);
$parcel$export(module.exports, "UpdateErrorNotExists", () => (parcelRequire("ewehA")).UpdateErrorNotExists);
$parcel$export(module.exports, "SaveAsErrorDuplicateView", () => (parcelRequire("ewehA")).SaveAsErrorDuplicateView);
$parcel$export(module.exports, "DeleteErrorDefaultView", () => (parcelRequire("ewehA")).DeleteErrorDefaultView);

var $c8Guq = parcelRequire("c8Guq");

var $aeXAa = parcelRequire("aeXAa");
var $5oPVJ = parcelRequire("5oPVJ");
var $kDrtX = parcelRequire("kDrtX");
var $01zCq = parcelRequire("01zCq");
var $bIjSf = parcelRequire("bIjSf");
var $kLHvr = parcelRequire("kLHvr");
var $3by2Y = parcelRequire("3by2Y");
var $3IGDG = parcelRequire("3IGDG");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $ezuVy = parcelRequire("ezuVy");

var $1afYi = parcelRequire("1afYi");

var $hFkwG = parcelRequire("hFkwG");

var $akhOi = parcelRequire("akhOi");

var $a6d5W = parcelRequire("a6d5W");

var $75KhQ = parcelRequire("75KhQ");

var $dBKyg = parcelRequire("dBKyg");
var $8DPqY = parcelRequire("8DPqY");


var $ewehA = parcelRequire("ewehA");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $kInjb = parcelRequire("kInjb");

var $lFLge = parcelRequire("lFLge");


var $6iKTy = parcelRequire("6iKTy");

var $4EcJI = parcelRequire("4EcJI");

var $cC2NN = parcelRequire("cC2NN");
const $b118d87b96a4c644$export$5d06510124eb14f8 = ()=>(0, $79xbN.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');
const $b118d87b96a4c644$export$49517d4b7c5fe443 = (timestamp)=>{
    // if the timestamp is defined and is a number
    if ((0, $7CnHa.isDefined)(timestamp) && $5oPVJ.default(Number, timestamp)) // instantiating a new Date object set to timestamp * 1000 to convert it to milliseconds
    return new Date(timestamp * 1e3);
    return null;
};
function* $b118d87b96a4c644$export$1e7ef12a24e81388(view) {
    const colourMaps = view.preferences && view.preferences.colourByV2 && view.preferences.colourByV2.colourMaps;
    if ($kDrtX.default(colourMaps)) return view;
    const projectColourMap = yield (0, $9e8i2.call)((0, $1afYi.updateProjectColorMap), // the updateProjectColorMap function always expects an object including the "project" key,
    // therefore this check is necessary in order to prevent views not loading in the plan (see JPO-16893)
    colourMaps.project && $5oPVJ.default(Object, colourMaps.project) ? colourMaps : {
        project: {}
    });
    const teamColourMap = yield (0, $9e8i2.call)((0, $1afYi.updateTeamColorMap), // the updateTeamColorMap function always expects an object including the "team" key,
    // therefore this check is necessary in order to prevent views not loading in the plan (see JPO-16893)
    colourMaps.team && $5oPVJ.default(Object, colourMaps.team) ? colourMaps : {
        team: {}
    });
    return $bIjSf.default(view, {
        preferences: {
            colourByV2: {
                colourMaps: {
                    project: projectColourMap,
                    team: teamColourMap
                }
            }
        }
    });
}
function* $b118d87b96a4c644$export$1e094021f1ba1c3b() {
    const { displayName: title, key: jiraUserId, name: jiraUsername = '', email: email = '', avatarUrl: avatarUrl = '' } = yield (0, $9e8i2.select)((0, $a6d5W.getCurrentUser));
    return {
        title: title,
        jiraUserId: jiraUserId,
        jiraUsername: jiraUsername,
        email: email,
        avatarUrl: avatarUrl
    };
}
function* $b118d87b96a4c644$export$203ed8b65c3b2a28() {
    const { id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    if (!planId) throw new Error('plan not found');
    return planId;
}
function* $b118d87b96a4c644$var$remoteFetch(key, errMessage = 'Failed to fetch remoteFetch') {
    // JPO-20477 Checks if the plan ID exists in the state to prevent plan not found error
    // when user loads a new plan before the previous plan finished loading
    const plan = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    if (!(0, $7CnHa.isDefined)(plan.id)) return undefined;
    const url = (0, $6iKTy.urls).userProperties(plan.id, key);
    const { value: result } = yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'GET',
        profile: (0, $6iKTy.urls).userProperties(0, ':prop'),
        json: true
    }, errMessage);
    return result;
}
function* $b118d87b96a4c644$export$f36830f6a371f043(key, // eslint-disable-next-line @typescript-eslint/no-explicit-any
value, errMessage = 'Failed to fetch remotePush') {
    const isKeyExisting = !!(yield (0, $9e8i2.call)($b118d87b96a4c644$var$remoteFetch, key));
    // JPO-20477 Checks if the plan ID exists in the state to prevent plan not found error
    // when user loads a new plan before the previous plan finished loading
    const plan = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    if (!(0, $7CnHa.isDefined)(plan.id)) return undefined;
    const url = (0, $6iKTy.urls).userProperties(plan.id, key);
    return yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: isKeyExisting ? 'PUT' : 'POST',
        body: {
            value: value
        }
    }, errMessage);
}
function* $b118d87b96a4c644$export$167cc9098fae982c(key, errMessage = 'Failed to fetch remoteDelete') {
    const url = (0, $6iKTy.urls).userProperties((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'remoteDelete')), key);
    return yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'DELETE'
    }, errMessage);
}
/**
 * TODO: https://hello.atlassian.net/browse/JPO-25656
 * Review if we want to keep this util that removes the fallback for inaccessible list field columns cases
 */ const $b118d87b96a4c644$var$extendFieldColumnsForListView = (preferences)=>{
    const { fieldColumnsV0: fieldColumnsV0, listFieldColumnsV0: listFieldColumnsV0 } = preferences;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    let updatedPrefs = {
        ...preferences
    };
    // If list field columns are not accessible, we should copy over the data from field columns as a fallback
    if (!listFieldColumnsV0) updatedPrefs = $aeXAa.default('listFieldColumnsV0', fieldColumnsV0, updatedPrefs);
    return updatedPrefs;
};
const $b118d87b96a4c644$export$94de9d76bcd60e54 = (preferences)=>{
    const { filtersV0: filtersV0, warningSettingsV1: warningSettingsV1 } = preferences;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const updatedPrefs = {
        ...preferences
    };
    if (filtersV0 && warningSettingsV1) {
        const warningFilter = filtersV0[0, $12ee831723ccf9c2$export$d6f1616882408daa];
        const issueWarningFilter = filtersV0[0, $12ee831723ccf9c2$export$59af687b450af7eb];
        if (issueWarningFilter) updatedPrefs.filtersV0 = {
            ...filtersV0,
            [(0, $12ee831723ccf9c2$export$d6f1616882408daa)]: undefined
        };
        else if (warningFilter) {
            const disabledWarnings = new Set(warningSettingsV1?.disabledWarnings ?? []);
            const selectedWarningTypes = (0, $hFkwG.WarningTypeIds).filter((warningTypeId)=>!disabledWarnings.has(warningTypeId));
            updatedPrefs.filtersV0 = {
                ...filtersV0,
                [(0, $12ee831723ccf9c2$export$d6f1616882408daa)]: undefined,
                [(0, $12ee831723ccf9c2$export$59af687b450af7eb)]: warningFilter.value && selectedWarningTypes.length > 0 ? {
                    id: (0, $12ee831723ccf9c2$export$59af687b450af7eb),
                    value: selectedWarningTypes
                } : undefined
            };
        }
    }
    return updatedPrefs;
};
const $b118d87b96a4c644$var$customMigrations = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
    $b118d87b96a4c644$var$extendFieldColumnsForListView,
    $b118d87b96a4c644$export$94de9d76bcd60e54
]);
function* $b118d87b96a4c644$export$982d2d18ebd0a982(payload) {
    const { id: id, version: version, preferences: preferences } = payload;
    const migratedPrefs = yield (0, $9e8i2.call)((0, $4EcJI.migratePrefs), (0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? $b118d87b96a4c644$var$customMigrations(preferences) : $b118d87b96a4c644$var$extendFieldColumnsForListView(preferences));
    const migratedView = $aeXAa.default('preferences', migratedPrefs, payload);
    const { preferences: preferencesWithUpdatedColorMaps } = yield (0, $9e8i2.call)($b118d87b96a4c644$export$1e7ef12a24e81388, migratedView);
    return {
        id: id,
        version: version,
        preferences: preferencesWithUpdatedColorMaps
    };
}
function* $b118d87b96a4c644$export$937c89ad2c912ae5(id) {
    // pushing the active view id to the db
    yield (0, $9e8i2.call)($b118d87b96a4c644$export$f36830f6a371f043, 'activeView', {
        value: {
            id: id
        }
    }, 'Failed to fetch pushActiveViewId');
}
function* $b118d87b96a4c644$export$a55835a0997c18e6(view) {
    const { id: id, version: version, preferences: preferences, persisted: persisted } = view;
    yield (0, $9e8i2.call)($b118d87b96a4c644$export$f36830f6a371f043, `modifiedView-${id}`, {
        version: version,
        preferences: $kLHvr.default(persisted.preferences, preferences)
    }, 'Failed to fetch pushModifiedView');
}
function* $b118d87b96a4c644$export$3f3078e2fb5b2249(id) {
    yield (0, $9e8i2.call)($b118d87b96a4c644$export$167cc9098fae982c, `modifiedView-${id}`, 'Failed to fetch deleteModifiedView');
}
const $b118d87b96a4c644$export$40bfa3442cecdd7b = (payload)=>{
    const { id: id, version: version, name: name, preferences: persistedPrefs, isDefault: isDefault, createdBy: createdBy, lastModifiedBy: lastModifiedBy, lastModifiedTimestamp: lastModifiedTimestamp } = payload;
    let updatedPersistedPrefs = persistedPrefs;
    const preferences = (()=>{
        if (persistedPrefs) {
            updatedPersistedPrefs = (0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k') ? $b118d87b96a4c644$var$customMigrations(persistedPrefs) : $b118d87b96a4c644$var$extendFieldColumnsForListView(persistedPrefs);
            return (0, $4EcJI.migratePrefs)(updatedPersistedPrefs);
        }
        throw new Error(`preferences not available on the view with id ${id}`);
    })();
    return {
        id: id,
        version: version,
        name: name,
        preferences: preferences,
        persisted: {
            preferences: updatedPersistedPrefs || preferences
        },
        isDefault: isDefault,
        active: false,
        modified: false,
        original: null,
        createdBy: createdBy,
        updatedBy: lastModifiedBy,
        // If the predefined view has never been updated, the "lastModifiedTimestamp" will be "undefined".
        // Once the predefined view is updated, the "lastModifiedTimestamp" will always been defined and should be a number (integer).
        // NB: user-defined views always have a lastModifiedTimestamp.
        updatedAt: $b118d87b96a4c644$export$49517d4b7c5fe443(lastModifiedTimestamp)
    };
};
function* $b118d87b96a4c644$export$d7febe7b891e79f0({ name: name, isDefault: isDefault, preferences: preferences, persisted: persisted, isPredefined: isPredefined = false }) {
    const url = (0, $6iKTy.urls).create((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'createView')));
    const persistedPrefs = persisted && persisted.preferences;
    const body = (0, $6iKTy.createViewBody)({
        name: name,
        isDefault: isDefault,
        preferences: $kLHvr.default(persistedPrefs || {}, preferences),
        isPredefined: isPredefined
    });
    const { id: id, version: version, errorCode: errorCode } = yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'POST',
        body: body,
        json: true
    }, 'Failed to fetch createView');
    return {
        id: id,
        version: version,
        errorCode: errorCode
    };
}
function* $b118d87b96a4c644$export$827a6c17a85f6d1a({ id: id, name: name, version: version, isDefault: isDefault, preferences: preferences, original: original, persisted: persisted, isPredefined: isPredefined }, renameOnly) {
    const url = (0, $6iKTy.urls).view((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'updateView')), id);
    // In case of rename, we want to make sure our errors reflect the current view name,
    // not the rename value we're passing in
    const currentView = yield (0, $9e8i2.select)((0, $dBKyg.getViewById), id);
    const { name: currentName = name } = currentView || {};
    let updatedPreferences = preferences;
    let body;
    if (!renameOnly) {
        if (!isPredefined) {
            if (!original) throw new Error('original must be defined');
            updatedPreferences = $3IGDG.default($kLHvr.default(original.persisted.preferences), $kLHvr.default(persisted.preferences))(preferences);
        }
        body = (0, $6iKTy.updateViewBody)({
            name: name,
            version: version,
            isDefault: isDefault,
            preferences: updatedPreferences,
            isPredefined: isPredefined
        });
    } else body = (0, $6iKTy.renameViewBody)({
        name: name
    });
    const payload = yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'PUT',
        body: body,
        json: true
    }, 'Failed to fetch updateView');
    if (payload.updateErrorCode === 'VIEW_NOT_FOUND') throw new (0, $ewehA.UpdateErrorNotExists)({
        viewId: id,
        viewName: currentName
    });
    if (payload.updateErrorCode === 'STALE_VERSION') throw new (0, $ewehA.UpdateErrorConflicted)({
        viewId: id,
        viewName: currentName,
        modifiedBy: payload.previouslyModifiedBy,
        modifiedAt: new Date(payload.previouslyModifiedTimestamp * 1e3)
    });
    if (payload.updateErrorCode === 'DUPLICATE_VIEW') throw new (0, $ewehA.SaveAsErrorDuplicateView)({
        viewId: id,
        viewName: currentName,
        newName: name
    });
    return {
        id: payload.id,
        version: payload.newVersion
    };
}
function* $b118d87b96a4c644$export$5fc739fff44ff01(predefined) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const payload = yield (0, $9e8i2.call)($b118d87b96a4c644$export$d7febe7b891e79f0, {
        ...predefined,
        isPredefined: true
    });
    return {
        ...predefined,
        ...payload
    };
}
function $b118d87b96a4c644$export$b24bec42687f32a(predefined, id, version) {
    return {
        ...predefined,
        id: id,
        version: version
    };
}
function* $b118d87b96a4c644$export$d1f9bed5329ee15(view) {
    try {
        // @ts-expect-error - TS2769 - No overload matches this call.
        yield (0, $9e8i2.call)($b118d87b96a4c644$export$827a6c17a85f6d1a, $01zCq.default(view, {
            isPredefined: true
        }));
        return view;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // if we didn't successfully update remotely, we don't want to add our view
        // to the list of saved views.
        if (err instanceof (0, $ewehA.UpdateErrorNotExists) || err instanceof (0, $ewehA.UpdateErrorConflicted)) return null;
        throw err;
    }
}
function* $b118d87b96a4c644$export$925b68815ba4f5c2(payload, // When cleaning up second_premium_template_experiment, make forCrossTeamPlanning required
options) {
    // Predefined views are saved for the first time from the front end.
    // If a new plan is created, the WRM payload should be empty of predefined views
    // If an existing plan is loaded, the WRM may contain predefined views without preferences
    // which we can identify by the absence of the createdTimestamp
    // If a plan is subsequently loaded, the WRM payload should now contain any predefined views complete with preferences
    const predefinedPreferences = yield (0, $9e8i2.select)((0, $8DPqY.default));
    const [payloadUnsavedPredefinedViews, payloadUserCreatedViews] = $3by2Y.default((view)=>!(0, $7CnHa.isDefined)(view.createdTimestamp) && !(0, $7CnHa.isDefined)(view.preferences) && (0, $7CnHa.isDefined)(predefinedPreferences[view.name]), payload);
    const payloadDefault = payload.filter((view)=>view.isDefault);
    let savedPredefinedViews;
    if (payloadUnsavedPredefinedViews.length > 0) // we will have unsavedPredefinedViews on plans that existed before we moved
    // the saving of predefined views from the BE to the FE.
    // We want to update these with the corresponding predefined view preferences
    savedPredefinedViews = yield (0, $9e8i2.all)(payloadUnsavedPredefinedViews.map((payloadUnsavedPredefinedView)=>{
        const viewName = payloadUnsavedPredefinedView.name;
        // update this view with prefs
        return (0, $9e8i2.call)($b118d87b96a4c644$export$d1f9bed5329ee15, {
            ...payloadUnsavedPredefinedView,
            preferences: predefinedPreferences[viewName]
        });
    }));
    else if (payloadUserCreatedViews.length > 0) // plans existing prior to the above mentioned change may not
    // have any unsaved predefined views, but have some user created views
    // (predefined views may have already been saved, or been deleted)
    // in this case, we don't want to create or update any predefined views
    savedPredefinedViews = [];
    else {
        const isReadOnlyMode = yield (0, $9e8i2.select)((0, $akhOi.isReadOnly));
        const presetNames = (0, $kInjb.getPresetViewNames)();
        const defaultDefaultViewName = options?.forSamplePlan || options?.forCrossTeamPlanning ? presetNames.SPRINT_CAPACITY_MANAGEMENT : presetNames.BASIC;
        // when no unsavedPredefinedViews or userCreatedViews exist, we can assume
        // we're on a newly created plan, and need to generate all of the predefined views
        savedPredefinedViews = yield (0, $9e8i2.all)(Object.keys(predefinedPreferences).map((name, i)=>{
            const newPredefinedView = {
                name: name,
                preferences: predefinedPreferences[name],
                // if we didn't have a default view in the payload, Basic should be the plan default
                isDefault: payloadDefault.length > 0 ? false : name === defaultDefaultViewName
            };
            // When in readOnly mode, we don't try to create views in the server since this will result in
            // 401 error because the user only has read-only permission.
            if (isReadOnlyMode) // The current index (i + 1) is used as view ID and version is always 0 which is ok since
            // a read-only user won't be able to change these views.
            // i + 1 because view ID 0 is considered as untitled view (see UNTITLED_VIEW_ID)
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9e8i2.call)($b118d87b96a4c644$export$b24bec42687f32a, newPredefinedView, i + 1, 0);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $9e8i2.call)($b118d87b96a4c644$export$5fc739fff44ff01, newPredefinedView);
        }));
    }
    const allSavedViews = [
        ...payloadUserCreatedViews,
        ...savedPredefinedViews.filter((predefinedView)=>(0, $7CnHa.isDefined)(predefinedView))
    ].map((view)=>$b118d87b96a4c644$export$40bfa3442cecdd7b(view));
    // The preference may not include the local project colour maps, so need to add these missed preferences in there
    return yield (0, $9e8i2.all)(allSavedViews.map((view)=>(0, $9e8i2.call)($b118d87b96a4c644$export$1e7ef12a24e81388, view)));
}
function* $b118d87b96a4c644$export$ba8fdcb3b5fbb4fe() {
    const url = (0, $6iKTy.urls).create((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'fetchSavedViews')));
    const payload = yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'GET',
        json: true
    }, 'Failed to fetch fetchSavedViews');
    return yield (0, $9e8i2.call)($b118d87b96a4c644$export$925b68815ba4f5c2, payload);
}
function* $b118d87b96a4c644$export$bc294d0493f3206(id) {
    // TODO: Ask backend for GET {item} REST API
    return (yield (0, $9e8i2.call)($b118d87b96a4c644$export$ba8fdcb3b5fbb4fe)).find((one)=>one.id === id);
}
function* $b118d87b96a4c644$export$8d94958ea8a83ea6(modifiedUntitled) {
    if (!modifiedUntitled) return undefined;
    const currentJiraUser = yield (0, $9e8i2.call)($b118d87b96a4c644$export$1e094021f1ba1c3b);
    const result = {
        id: (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28),
        name: 'Untitled',
        version: 0,
        preferences: modifiedUntitled.preferences,
        isDefault: false,
        active: false,
        modified: true,
        original: null,
        persisted: {
            preferences: {}
        },
        createdBy: currentJiraUser,
        updatedBy: currentJiraUser,
        updatedAt: new Date()
    };
    return result;
}
function* $b118d87b96a4c644$export$6fa92c81825ed985(payload, // When cleaning up second_premium_template_experiment, make forCrossTeamPlanning required
options) {
    const { savedViews: savedViews, modifiedSavedViews: modifiedSavedViews, activeViewId: remoteActiveViewId } = payload;
    const remoteSaved = yield (0, $9e8i2.call)($b118d87b96a4c644$export$925b68815ba4f5c2, savedViews, options);
    const untitleViewModifications = modifiedSavedViews.find(({ id: id })=>id === (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28));
    let remoteUntitled;
    if ((0, $7CnHa.isDefined)(untitleViewModifications)) {
        const modifiedUntitled = yield (0, $9e8i2.call)($b118d87b96a4c644$export$982d2d18ebd0a982, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        untitleViewModifications);
        remoteUntitled = yield (0, $9e8i2.call)($b118d87b96a4c644$export$8d94958ea8a83ea6, modifiedUntitled);
    }
    const remoteAll = remoteSaved.concat(remoteUntitled || []);
    const remoteActiveView = remoteActiveViewId && remoteAll.find((one)=>one.id === remoteActiveViewId);
    const [activeViewId, result] = (()=>{
        if (remoteActiveView) return [
            remoteActiveView.id,
            remoteAll
        ];
        if (remoteUntitled) return [
            (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28),
            remoteAll
        ];
        try {
            return [
                remoteSaved.find((one)=>one.isDefault).id,
                remoteAll
            ];
        } catch  {
            throw new Error('default view not found');
        }
    })();
    if (activeViewId !== remoteActiveViewId) yield (0, $9e8i2.call)($b118d87b96a4c644$export$937c89ad2c912ae5, activeViewId);
    // Process the view modification just for an active view
    const activeViewModifications = modifiedSavedViews.find(({ id: id })=>id === activeViewId);
    let modifiedActiveView;
    if ((0, $7CnHa.isDefined)(activeViewModifications)) modifiedActiveView = yield (0, $9e8i2.call)($b118d87b96a4c644$export$982d2d18ebd0a982, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    activeViewModifications);
    return result.map((original)=>{
        const active = original.id === activeViewId;
        if (active && modifiedActiveView) {
            const { version: version, preferences: preferences } = modifiedActiveView;
            return $kLHvr.default(original, {
                version: version,
                preferences: preferences,
                modified: true,
                persisted: {
                    preferences: preferences
                },
                original: original,
                active: active
            });
        }
        return $01zCq.default(original, {
            active: active
        });
    });
}
function* $b118d87b96a4c644$export$1050f30725ffa53(blob) {
    const migratableReportBlob = (0, $cC2NN.getReportMigratableBlob)(blob);
    const reportViewSetting = yield (0, $9e8i2.call)((0, $4EcJI.migratePrefs), migratableReportBlob);
    return reportViewSetting;
}
function* $b118d87b96a4c644$export$443d89549b135c95(id) {
    const url = (0, $6iKTy.urls).view((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'deleteView')), id);
    return yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'DELETE',
        json: true
    }, 'Failed to fetch deleteView');
}
function* $b118d87b96a4c644$export$65c8c09b8f8e5243({ id: id, isDefault: isDefault }) {
    const url = (0, $6iKTy.urls).view((yield (0, $9e8i2.call)($b118d87b96a4c644$export$203ed8b65c3b2a28, 'markAsDefaultView')), id);
    const body = (0, $6iKTy.markAsDefaultViewBody)({
        isDefault: isDefault
    });
    // this marks the view as default in the backend
    yield (0, $9e8i2.call)((0, $5rVFi.aggressiveFetch), url, {
        method: 'PUT',
        body: body,
        json: true
    }, 'Failed to fetch markAsDefaultView');
}
function $b118d87b96a4c644$export$df4b64c21468538d(search, activeViewId) {
    return (0, $lFLge.updateQueryString)(search, {
        vid: activeViewId
    });
}
const $b118d87b96a4c644$export$c816faf8404f4eb6 = (id)=>{
    const search = $b118d87b96a4c644$export$df4b64c21468538d(window.location.search, id);
    const url = `${window.location.origin}${window.location.pathname}${search}${window.location.hash}`;
    window.history.replaceState({}, window.title, url);
};
const $b118d87b96a4c644$export$ecf701fdb2f69c12 = ()=>{
    const search = (0, $lFLge.updateQueryString)(window.location.search, {
        isSample: undefined
    });
    const url = `${window.location.origin}${window.location.pathname}${search}${window.location.hash}`;
    window.history.replaceState({}, window.title, url);
};
function $b118d87b96a4c644$export$8b6fc6f02567edff({ sourceViewId: sourceViewId, targetViewId: targetViewId, duplicateSection: duplicateSection }) {
    duplicateSection((0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(sourceViewId), (0, $5rYNM.SECTION_KEYS).FIELD), (0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(targetViewId), (0, $5rYNM.SECTION_KEYS).FIELD));
    duplicateSection((0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(sourceViewId), (0, $5rYNM.SECTION_KEYS).MAIN), (0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(targetViewId), (0, $5rYNM.SECTION_KEYS).MAIN));
    duplicateSection((0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(sourceViewId), (0, $5rYNM.SECTION_KEYS).LIST_FIELD), (0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(targetViewId), (0, $5rYNM.SECTION_KEYS).LIST_FIELD));
    duplicateSection((0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(sourceViewId), (0, $5rYNM.SECTION_KEYS).LIST_MAIN), (0, $ezuVy.getSectionNamespace)((0, $dBKyg.getNamespaceForView)(targetViewId), (0, $5rYNM.SECTION_KEYS).LIST_MAIN));
}

});
parcelRegister("kLHvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e9f1d4fda4af11$export$2e2bcd8739ae039);

var $cOiwb = parcelRequire("cOiwb");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $f1e9f1d4fda4af11$var$mergeRight = /*#__PURE__*/ (0, $ggdJA.default)(function mergeRight(l, r) {
    return (0, $cOiwb.default)({}, l, r);
});
var $f1e9f1d4fda4af11$export$2e2bcd8739ae039 = $f1e9f1d4fda4af11$var$mergeRight;

});

parcelRegister("ewehA", function(module, exports) {

$parcel$export(module.exports, "UpdateErrorNotExists", () => $967f51dd7eec2a59$export$dfc2d89b8d2626c8);
$parcel$export(module.exports, "UpdateErrorConflicted", () => $967f51dd7eec2a59$export$5e0c174d920f99b6);
$parcel$export(module.exports, "SaveAsErrorDuplicateView", () => $967f51dd7eec2a59$export$4eb53133637b9bc4);
$parcel$export(module.exports, "DeleteErrorDefaultView", () => $967f51dd7eec2a59$export$66fda58b1a5e03e9);
/* eslint-disable max-classes-per-file */ class $967f51dd7eec2a59$export$dfc2d89b8d2626c8 {
    constructor({ viewId: viewId, viewName: viewName }){
        this.viewId = viewId;
        this.viewName = viewName;
    }
}
class $967f51dd7eec2a59$export$5e0c174d920f99b6 {
    constructor({ viewId: viewId, viewName: viewName, modifiedBy: modifiedBy, modifiedAt: modifiedAt }){
        this.viewId = viewId;
        this.viewName = viewName;
        this.modifiedBy = modifiedBy;
        this.modifiedAt = modifiedAt;
    }
}
class $967f51dd7eec2a59$export$4eb53133637b9bc4 {
    constructor({ viewId: viewId, viewName: viewName, newName: newName }){
        this.viewId = viewId;
        this.viewName = viewName;
        this.newName = newName;
    }
}
class $967f51dd7eec2a59$export$66fda58b1a5e03e9 {
    constructor({ viewId: viewId, viewName: viewName }){
        this.viewId = viewId;
        this.viewName = viewName;
    }
}

});

parcelRegister("6iKTy", function(module, exports) {

$parcel$export(module.exports, "urls", () => $de2cf0360d9fe118$export$bcae9ba627f604b6);
$parcel$export(module.exports, "createViewBody", () => $de2cf0360d9fe118$export$bbc51f09cfcea3dc);
$parcel$export(module.exports, "updateViewBody", () => $de2cf0360d9fe118$export$4a0b5be06a9ebee9);
$parcel$export(module.exports, "markAsDefaultViewBody", () => $de2cf0360d9fe118$export$12a4fa70d07eeb16);
$parcel$export(module.exports, "renameViewBody", () => $de2cf0360d9fe118$export$7ab2dbfec76aec8);

var $7CnHa = parcelRequire("7CnHa");
const $de2cf0360d9fe118$export$bcae9ba627f604b6 = {
    userProperties: (planId, propName)=>`/rest/jpo/1.0/plans/${planId}/userProperties${(0, $7CnHa.isDefined)(propName) ? `/viewSwitching-${propName}` : ''}`,
    create: (planId)=>`/rest/jpo/1.0/plans/${planId}/savedviews`,
    view: (planId, viewId)=>`/rest/jpo/1.0/plans/${planId}/savedviews/${viewId}`
};
const $de2cf0360d9fe118$export$bbc51f09cfcea3dc = ({ name: name, isDefault: isDefault, preferences: preferences, isPredefined: isPredefined = false })=>({
        viewName: name,
        viewPreferences: preferences,
        isDefault: isDefault,
        isPredefined: isPredefined
    });
const $de2cf0360d9fe118$export$4a0b5be06a9ebee9 = ({ name: name, version: version, isDefault: isDefault, preferences: preferences, isPredefined: isPredefined = false })=>({
        viewName: name,
        viewVersion: version,
        viewPreferences: preferences,
        markAsDefault: isDefault,
        isPredefined: isPredefined
    });
const $de2cf0360d9fe118$export$12a4fa70d07eeb16 = ({ isDefault: isDefault })=>({
        markAsDefault: isDefault
    });
const $de2cf0360d9fe118$export$7ab2dbfec76aec8 = ({ name: name })=>({
        viewName: name
    });

});

parcelRegister("4EcJI", function(module, exports) {

$parcel$export(module.exports, "migratePrefs", () => $7ee2827947488188$export$3cd3a68476baaf89);

var $dRoir = parcelRequire("dRoir");

var $3eiEY = parcelRequire("3eiEY");
function $7ee2827947488188$export$3cd3a68476baaf89(blob) {
    return (0, $3eiEY.default)(blob);
}
function $7ee2827947488188$export$2e2bcd8739ae039(view) {
    const preferences = $7ee2827947488188$export$3cd3a68476baaf89(view.preferences);
    return $dRoir.default({
        preferences: preferences,
        original: view.original && $7ee2827947488188$export$2e2bcd8739ae039(view.original)
    })(view);
}

});
parcelRegister("3eiEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $427e8f63f0afc6f8$export$2e2bcd8739ae039);

var $3IGDG = parcelRequire("3IGDG");

var $gtAIo = parcelRequire("gtAIo");

var $isMLY = parcelRequire("isMLY");

var $gw4qQ = parcelRequire("gw4qQ");

var $gXtPn = parcelRequire("gXtPn");

var $9ltDt = parcelRequire("9ltDt");

var $dn4xl = parcelRequire("dn4xl");

var $iT09U = parcelRequire("iT09U");

var $c3C4s = parcelRequire("c3C4s");

var $dSkfn = parcelRequire("dSkfn");

var $j8FO7 = parcelRequire("j8FO7");

var $dg7Hh = parcelRequire("dg7Hh");

var $cBUDZ = parcelRequire("cBUDZ");

var $9OspV = parcelRequire("9OspV");

var $jJO9g = parcelRequire("jJO9g");

var $1sB9c = parcelRequire("1sB9c");

var $1nK7w = parcelRequire("1nK7w");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427e8f63f0afc6f8$var$normalize = (blob)=>(0, $dg7Hh.default)(undefined, (0, $gtAIo.reset)(blob));
const $427e8f63f0afc6f8$var$migrate = [
    (0, $iT09U.default),
    (0, $isMLY.default),
    (0, $9OspV.default),
    (0, $dSkfn.default),
    (0, $9ltDt.default),
    (0, $9ltDt.migrateListFieldColumns),
    (0, $jJO9g.default),
    (0, $dn4xl.default),
    (0, $cBUDZ.default),
    (0, $c3C4s.default),
    (0, $gw4qQ.default),
    (0, $j8FO7.default),
    (0, $1nK7w.default),
    (0, $gXtPn.default),
    (0, $1sB9c.default)
] // eslint-disable-next-line @typescript-eslint/no-explicit-any
.reduce((acc, fn)=>$3IGDG.default(acc, fn));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $427e8f63f0afc6f8$var$fromV0 = $3IGDG.default($427e8f63f0afc6f8$var$migrate, $427e8f63f0afc6f8$var$normalize);
var $427e8f63f0afc6f8$export$2e2bcd8739ae039 = $427e8f63f0afc6f8$var$fromV0;

});
parcelRegister("isMLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $049d6b77031b9228$export$2e2bcd8739ae039);

var $bIjSf = parcelRequire("bIjSf");

var $hUgnE = parcelRequire("hUgnE");

var $33N5G = parcelRequire("33N5G");
var $049d6b77031b9228$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return $bIjSf.default(prevState, {
            colourMaps: {
                status: (0, $33N5G.statusColourMap)
            }
        });
    },
    V1: function fromV0ToV1(prevState) {
        return {
            ...prevState,
            colourIssueTypes: [],
            colourPriorities: []
        };
    },
    V2: function fromV1ToV2(prevState) {
        return {
            ...prevState,
            colourIssueTypeKeys: []
        };
    }
}, {
    prefix: 'colourBy',
    from: 'V0'
}));

});
parcelRegister("hUgnE", function(module, exports) {

$parcel$export(module.exports, "createMigrate", () => $a16b1915f4a89536$export$c1e9a1c26f76dca5);
$parcel$export(module.exports, "incremental", () => $a16b1915f4a89536$export$4f53b643294ba29);

var $fc0j7 = parcelRequire("fc0j7");
var $aeXAa = parcelRequire("aeXAa");
var $iOTcG = parcelRequire("iOTcG");
var $i0RGP = parcelRequire("i0RGP");
var $jPCDz = parcelRequire("jPCDz");
var $l0L3x = parcelRequire("l0L3x");
var $cQGVO = parcelRequire("cQGVO");
var $cQwal = parcelRequire("cQwal");
var $3IGDG = parcelRequire("3IGDG");
var $f7Op5 = parcelRequire("f7Op5");
var $2uEDR = parcelRequire("2uEDR");
const $a16b1915f4a89536$export$bf95ba95946b416f = ({ from: from, to: to, migrate: migrate })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (viewSettings)=>{
        const prevState = viewSettings[from];
        const nextState = migrate(prevState);
        return $3IGDG.default($cQwal.default([
            from
        ]), $aeXAa.default(to, nextState))(viewSettings);
    };
const $a16b1915f4a89536$export$c1e9a1c26f76dca5 = (...steps)=>(viewSettings, options)=>{
        // need to pick only the steps from the current version in viewSettings to the required version
        const currentVersion = $3IGDG.default($2uEDR.default, $cQGVO.default($f7Op5.default('to')), steps[0] ? $fc0j7.default(steps[0].from) : $l0L3x.default, $i0RGP.default((key)=>$jPCDz.default(key)(viewSettings)))(steps);
        // we will rely on initialState since the attribute is not found in the view settings blob
        if (!currentVersion) return viewSettings;
        const { steps: requiredSteps } = steps.reduce((// eslint-disable-next-line @typescript-eslint/no-shadow
        { steps: steps, started: started, ended: ended }, { from: from, to: to, migrate: migrate })=>{
            if (!started && currentVersion && from !== currentVersion) return {
                steps: steps,
                started: started,
                ended: ended
            };
            if (ended) return {
                steps: steps,
                started: started,
                ended: ended
            };
            const needSkipPrevSteps = from === currentVersion;
            const prevSteps = needSkipPrevSteps ? [] : steps;
            return {
                steps: [
                    ...prevSteps,
                    {
                        from: from,
                        to: to,
                        migrate: migrate
                    }
                ],
                started: true,
                ended: ended || to === (options && options.to)
            };
        }, {
            steps: [],
            started: false,
            ended: false
        });
        const migrate = requiredSteps.length > 0 ? $iOTcG.default($3IGDG.default, ...requiredSteps.map($a16b1915f4a89536$export$bf95ba95946b416f)) : $l0L3x.default; // in case there is no migration to apply
        return migrate(viewSettings);
    };
const $a16b1915f4a89536$export$4f53b643294ba29 = (migrations, options)=>{
    const { prefix: prefix } = options;
    const getVersionNo = (Vx)=>Number((Vx.match(/^V([0-9]+)$/i) || [])[1]);
    const makeKey = (ver)=>`${prefix}V${ver}`;
    const versionNos = Object.keys(migrations).map(getVersionNo).sort();
    if (versionNos.find(Number.isNaN) !== undefined) throw new Error(`wrong version name in the migrations of ${prefix}`);
    const fromVerNo = getVersionNo(options.from);
    if (Number.isNaN(fromVerNo)) throw new Error('options.from must be correct version name');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [steps] = versionNos.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([acc, prevVer], ver)=>{
        const from = makeKey(prevVer);
        const to = makeKey(ver);
        return [
            [
                ...acc,
                {
                    from: from,
                    to: to,
                    migrate: migrations[`V${ver}`]
                }
            ],
            ver
        ];
    }, [
        [],
        fromVerNo
    ]);
    return steps;
};

});
parcelRegister("fc0j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0f8370dd5dd4595$export$2e2bcd8739ae039);

var $kJFRt = parcelRequire("kJFRt");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $b0f8370dd5dd4595$var$append = /*#__PURE__*/ (0, $ggdJA.default)(function append(el, list) {
    return (0, $kJFRt.default)(list, [
        el
    ]);
});
var $b0f8370dd5dd4595$export$2e2bcd8739ae039 = $b0f8370dd5dd4595$var$append;

});

parcelRegister("iOTcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $db37b7cd8a5e004c$export$2e2bcd8739ae039);

var $eUK1h = parcelRequire("eUK1h");
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $db37b7cd8a5e004c$var$call = /*#__PURE__*/ (0, $eUK1h.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $db37b7cd8a5e004c$export$2e2bcd8739ae039 = $db37b7cd8a5e004c$var$call;

});



parcelRegister("gw4qQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bfc785e75d80f83$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $2bfc785e75d80f83$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'componentGroups',
    from: 'V0'
}));

});

parcelRegister("gXtPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $121c0a34e64d8634$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $121c0a34e64d8634$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'dateConstraints',
    from: 'V0'
}));

});

parcelRegister("9ltDt", function(module, exports) {

$parcel$export(module.exports, "migrateListFieldColumns", () => $505c7fc14b0faa9b$export$209345f4e458d066);
$parcel$export(module.exports, "default", () => $505c7fc14b0faa9b$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
const $505c7fc14b0faa9b$export$209345f4e458d066 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'listFieldColumns',
    from: 'V0'
}));
var $505c7fc14b0faa9b$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'fieldColumns',
    from: 'V0'
}));

});

parcelRegister("dn4xl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37ddc34f1464da$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $5e37ddc34f1464da$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    },
    V1: function fromV0ToV1(prevState) {
        return {
            includeAncestors: true,
            includeDescendants: prevState.showFullHierarchy
        };
    }
}, {
    prefix: 'filterOptions',
    from: 'V0'
}));

});

parcelRegister("iT09U", function(module, exports) {

$parcel$export(module.exports, "default", () => $139f587a6a49c146$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $139f587a6a49c146$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'filters',
    from: 'V0'
}));

});

parcelRegister("c3C4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f29f737ceb020e$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $e7f29f737ceb020e$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'highlightedVersions',
    from: 'V0'
}));

});

parcelRegister("dSkfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $78af3c89f6afba0c$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $78af3c89f6afba0c$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'issueExpansions',
    from: 'V0'
}));

});

parcelRegister("j8FO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $de7184b666c2c695$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $de7184b666c2c695$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'labelGroups',
    from: 'V0'
}));

});

parcelRegister("dg7Hh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2286f11915c6a092$export$2e2bcd8739ae039);

var $lEZXx = parcelRequire("lEZXx");
var $cQwal = parcelRequire("cQwal");
var $7WzTP = parcelRequire("7WzTP");

var $lcvrv = parcelRequire("lcvrv");

var $l1eW8 = parcelRequire("l1eW8");

var $gtAIo = parcelRequire("gtAIo");

var $bit90 = parcelRequire("bit90");

var $dT2LZ = parcelRequire("dT2LZ");

var $fKorV = parcelRequire("fKorV");

var $6TQUU = parcelRequire("6TQUU");

var $bwvEa = parcelRequire("bwvEa");

var $iUBEf = parcelRequire("iUBEf");

var $aGViN = parcelRequire("aGViN");

var $dD7T9 = parcelRequire("dD7T9");

var $ekLOD = parcelRequire("ekLOD");

var $c8TSU = parcelRequire("c8TSU");

var $hL0u5 = parcelRequire("hL0u5");

var $6RLYO = parcelRequire("6RLYO");

var $gEJLO = parcelRequire("gEJLO");

var $1w9iY = parcelRequire("1w9iY");

var $bLErO = parcelRequire("bLErO");

var $ft2cW = parcelRequire("ft2cW");

var $dfELb = parcelRequire("dfELb");
const $2286f11915c6a092$var$reducersByKey = {
    filtersV0: (0, $ekLOD.default),
    colourByV2: (0, $dT2LZ.default),
    timeScaleV1: (0, $1w9iY.default),
    issueExpansionsV0: (0, $hL0u5.default),
    fieldColumnsV0: (0, $aGViN.default),
    filterOptionsV1: (0, $dD7T9.default),
    rollupSettingsV0: (0, $gEJLO.default),
    highlightedVersionsV0: (0, $c8TSU.default),
    componentGroupsV0: (0, $fKorV.default),
    labelGroupsV0: (0, $6RLYO.default),
    customFieldValuesGroupsV0: (0, $6TQUU.default),
    warningSettingsV1: (0, $dfELb.default),
    dateConstraintsV0: (0, $bwvEa.default),
    visualisationsV0: (0, $ft2cW.default),
    dependencySettingsV0: (0, $iUBEf.default),
    listFieldColumnsV0: (0, $aGViN.default),
    viewModeV0: (0, $bLErO.default),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    calendarFiltersV0: (0, $ekLOD.default),
    activeFilterViewV0: (0, $bit90.default)
};
const $2286f11915c6a092$var$FIELD_COLUMNS_KEY = 'fieldColumnsV0';
const $2286f11915c6a092$var$LIST_FIELD_COLUMNS_KEY = 'listFieldColumnsV0';
const $2286f11915c6a092$var$FILTERS_KEY = 'filtersV0';
const $2286f11915c6a092$var$CALENDAR_FILTERS_KEY = 'calendarFiltersV0';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2286f11915c6a092$var$combined = (0, $l1eW8.combineReducers)($2286f11915c6a092$var$reducersByKey);
const $2286f11915c6a092$var$initialState = $2286f11915c6a092$var$combined(undefined, {
    type: ''
});
function $2286f11915c6a092$export$2e2bcd8739ae039(state = $2286f11915c6a092$var$initialState, action) {
    const resetState = $2286f11915c6a092$var$initialState;
    switch(action.type){
        case 0, $gtAIo.RESET:
            {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const pickExact = $7WzTP.default(// activeFilterViewV0 is in the view-settings state for the convenience of
                // accessing it from the default reducer below.
                // However, it's set based on the route and must not be reset by saved views.
                Object.keys(resetState).filter((key)=>key !== 'activeFilterViewV0'));
                return $lEZXx.default(pickExact(action.payload))(resetState);
            }
        default:
            {
                const fieldColumnsKey = state.viewModeV0?.mode === (0, $lcvrv.VIEW_MODES).LIST ? $2286f11915c6a092$var$LIST_FIELD_COLUMNS_KEY : $2286f11915c6a092$var$FIELD_COLUMNS_KEY;
                const filtersKey = state.activeFilterViewV0 === 'calendar' ? $2286f11915c6a092$var$CALENDAR_FILTERS_KEY : $2286f11915c6a092$var$FILTERS_KEY;
                return {
                    ...state,
                    ...$cQwal.default([
                        $2286f11915c6a092$var$FIELD_COLUMNS_KEY,
                        $2286f11915c6a092$var$LIST_FIELD_COLUMNS_KEY,
                        $2286f11915c6a092$var$FILTERS_KEY,
                        $2286f11915c6a092$var$CALENDAR_FILTERS_KEY
                    ], $2286f11915c6a092$var$combined(state, action)),
                    [fieldColumnsKey]: (0, $aGViN.default)(state[fieldColumnsKey], action),
                    [filtersKey]: (0, $ekLOD.default)(state[filtersKey], action)
                };
            }
    }
}

});
parcelRegister("l1eW8", function(module, exports) {

$parcel$export(module.exports, "combineReducers", () => $c7fcd4f23fa869c2$export$66e4520cdb265d18);
$parcel$export(module.exports, "errorReporterMiddleware", () => $c7fcd4f23fa869c2$export$6aaec9220272ce3d);

var $huRi7 = parcelRequire("huRi7");

var $fuSfG = parcelRequire("fuSfG");

var $bwMm3 = parcelRequire("bwMm3");
var $huQCH = parcelRequire("huQCH");
var $ldYmX = parcelRequire("ldYmX");

var $guiFP = parcelRequire("guiFP");

var $l7qZG = parcelRequire("l7qZG");

var $5rYNM = parcelRequire("5rYNM");
/**
   This is an extended version of Redux'es combineReducers. It implements
   support for Composite Pattern. Essentially, it accepts second optional
   argument being a function which can respond to any action with a list of
   actions to be processed by combined reducers. You can think about it as
   batched actions with a few nice properties:

   1. It's straightforward and consistent with `combineReducers` approach to
   structuring state. Initial action is processed on the level which is the
   closest common ancestor to changed branches. No state update directly happens
   on that level, real updates are still in leaves.

   2. It's efficient. It calls reducers straight away without ceremony with
   additional message passing. It returns the same reference if those reducers
   haven't changed branches.

   3. It's versatile. Though you are restricted with what you want to perform
   inside composite (the same restrictions as for reducers for the same good
   reasons), you have access to both state and action payload and can do any
   preparations required to pass data down the tree.

   4. It's easy to test. It's just a pure function with well-defined input
   scope.

   5. It's discoverable. You have one well-defined entry point for you action
   disregard of how it was created, and reducers to follow up for actual state
   update are right there, in the subtree of module where composite was defined.
   In complex cases you can descend tree layer by layer to the desired level of
   specificity. Also your logic is kept in reducers as opposed to moving it out to
   action creators as is done in other solutions.

   6. It's friendly. Whenever you make a typo in a delegated reducer name, you
   get suggestion how to correct it ;-)

   Contrived example:

    export default combineReducers<*, *>({ issues, versions }, (state, action) => {
        switch (action.type) {
            case NUKE_VERSION:
                const versionId = action.payload;
                const issueIds = state.issues
                    .filter(({ version }) => version === versionId)
                    .map(({ id }) => id);
                return {
                    issues: [{ type: DELETE_ISSUES, payload: issueIds }],
                    versions: [{ type: DELETE_VERSIONS, payload: [versionId] }],
                };
            default:
                return {};
        }
    });

*/ // currying helper functions makes their use with Ramda more readable
// compare R.minBy(distance(typo)) vs R.minBy((suggestion) => distance(typo, suggestion))
// R.curryN used instead of R.curry because levenshtein.get can take 3 arguments
const $c7fcd4f23fa869c2$var$distance = $bwMm3.default(2, (0, (/*@__PURE__*/$parcel$interopDefault($fuSfG))).get);
// just an aid for developer to spot exact typo without switching contexts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c7fcd4f23fa869c2$var$speller = (suggestions)=>(typo)=>$ldYmX.default($huQCH.default($c7fcd4f23fa869c2$var$distance(typo)), '', suggestions);
function $c7fcd4f23fa869c2$export$66e4520cdb265d18(reducers, composite) {
    const combinedReducers = (0, $huRi7.combineReducers)(reducers);
    if (!composite) return combinedReducers;
    const getSuggestion = $c7fcd4f23fa869c2$var$speller(Object.keys(reducers));
    return (previousState, action)=>{
        const state = combinedReducers(previousState, action);
        if (!composite) return state;
        const compositeActions = composite(state, action);
        const compositeActionsKeys = Object.keys(compositeActions);
        const nextState = {
            ...state
        };
        let hasChanged = false;
        for (const key of compositeActionsKeys){
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const reducer = reducers[key];
            if (!reducer) throw new Error(`Composite returned missing reducer "${key}", did you mean "${getSuggestion(key)}"?`);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const stateForKey = state[key];
            const nextStateForKey = $ldYmX.default(reducer, stateForKey, compositeActions[key]);
            hasChanged = hasChanged || nextStateForKey !== stateForKey;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            nextState[key] = nextStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
const $c7fcd4f23fa869c2$export$6aaec9220272ce3d = ()=>(next)=>(action)=>{
            try {
                return next(action);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).REDUX,
                        packageName: (0, $5rYNM.PACKAGE_NAME),
                        teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
                    },
                    error: err,
                    attributes: {
                        action: action.type
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return next((0, $l7qZG.showError)(err.message, err.stack, window?.location.hash, window?.location.pathname));
            }
        };

});
parcelRegister("fuSfG", function(module, exports) {
(function() {
    'use strict';
    var collator;
    try {
        collator = typeof Intl !== "undefined" && typeof Intl.Collator !== "undefined" ? Intl.Collator("generic", {
            sensitivity: "base"
        }) : null;
    } catch (err) {
        console.log("Collator could not be initialized and wouldn't be used");
    }
    // arrays to re-use
    var prevRow = [], str2Char = [];
    /**
   * Based on the algorithm at http://en.wikipedia.org/wiki/Levenshtein_distance.
   */ var Levenshtein = {
        /**
     * Calculate levenshtein distance of the two strings.
     *
     * @param str1 String the first string.
     * @param str2 String the second string.
     * @param [options] Additional options.
     * @param [options.useCollator] Use `Intl.Collator` for locale-sensitive string comparison.
     * @return Integer the levenshtein distance (0 and above).
     */ get: function(str1, str2, options) {
            var useCollator = options && collator && options.useCollator;
            var str1Len = str1.length, str2Len = str2.length;
            // base cases
            if (str1Len === 0) return str2Len;
            if (str2Len === 0) return str1Len;
            // two rows
            var curCol, nextCol, i, j, tmp;
            // initialise previous row
            for(i = 0; i < str2Len; ++i){
                prevRow[i] = i;
                str2Char[i] = str2.charCodeAt(i);
            }
            prevRow[str2Len] = str2Len;
            var strCmp;
            if (useCollator) // calculate current row distance from previous row using collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = 0 === collator.compare(str1.charAt(i), String.fromCharCode(str2Char[j]));
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            else // calculate current row distance from previous row without collator
            for(i = 0; i < str1Len; ++i){
                nextCol = i + 1;
                for(j = 0; j < str2Len; ++j){
                    curCol = nextCol;
                    // substution
                    strCmp = str1.charCodeAt(i) === str2Char[j];
                    nextCol = prevRow[j] + (strCmp ? 0 : 1);
                    // insertion
                    tmp = curCol + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // deletion
                    tmp = prevRow[j + 1] + 1;
                    if (nextCol > tmp) nextCol = tmp;
                    // copy current col value into previous (in preparation for next iteration)
                    prevRow[j] = curCol;
                }
                // copy last col value into previous (in preparation for next iteration)
                prevRow[j] = nextCol;
            }
            return nextCol;
        }
    };
    // amd
    if (typeof define !== "undefined" && define !== null && define.amd) define(function() {
        return Levenshtein;
    });
    else if (module !== null && true && module.exports === exports) module.exports = Levenshtein;
    else if (typeof self !== "undefined" && typeof self.postMessage === 'function' && typeof self.importScripts === 'function') self.Levenshtein = Levenshtein;
    else if (typeof window !== "undefined" && window !== null) window.Levenshtein = Levenshtein;
})();

});

parcelRegister("huQCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbce0ee539f4ddde$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $cbce0ee539f4ddde$var$minBy = /*#__PURE__*/ (0, $4g10W.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $cbce0ee539f4ddde$export$2e2bcd8739ae039 = $cbce0ee539f4ddde$var$minBy;

});


parcelRegister("bit90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba5ed0522991667$export$2e2bcd8739ae039);

var $k8WUU = parcelRequire("k8WUU");
const $7ba5ed0522991667$var$reducer = (state = 'timeline', action)=>{
    switch(action.type){
        case 0, $k8WUU.CHANGE_ACTIVE_FILTER_VIEW:
            return action.payload;
        default:
            return state;
    }
};
var $7ba5ed0522991667$export$2e2bcd8739ae039 = $7ba5ed0522991667$var$reducer;

});
parcelRegister("k8WUU", function(module, exports) {

$parcel$export(module.exports, "CHANGE_ACTIVE_FILTER_VIEW", () => $b1287598fae2ec3f$export$34894007d3f39391);
$parcel$export(module.exports, "changeActiveFilterView", () => $b1287598fae2ec3f$export$b74a806f82bb5aa7);
const $b1287598fae2ec3f$export$34894007d3f39391 = 'state.domain.views.SET_ACTIVE_FILTER_VIEW';
const $b1287598fae2ec3f$export$b74a806f82bb5aa7 = (payload)=>({
        type: $b1287598fae2ec3f$export$34894007d3f39391,
        payload: payload
    });

});


parcelRegister("dT2LZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7f6328c259eb4b$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $8K6YM = parcelRequire("8K6YM");
var $eoUrK = parcelRequire("eoUrK");
var $6aakY = parcelRequire("6aakY");

var $33N5G = parcelRequire("33N5G");

var $9ffcO = parcelRequire("9ffcO");
const $2a7f6328c259eb4b$export$d4c72bab9d6cc13a = {
    colourByValue: (0, $33N5G.colourByOptions).NONE,
    colourComponents: [],
    colourIssueTypes: [],
    colourIssueTypeKeys: [],
    colourLabels: [],
    colourMaps: {
        none: {},
        project: {},
        status: (0, $33N5G.statusColourMap),
        team: {}
    },
    colourPriorities: [],
    colourSelects: {},
    lastUsed: 0
};
const $2a7f6328c259eb4b$export$1650419e431d3ba3 = (state = $2a7f6328c259eb4b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9ffcO.RESET:
            return {
                ...action.payload
            };
        case 0, $9ffcO.SET_COLOUR_BY_VALUE:
            {
                const { id: id } = action.payload;
                return {
                    ...state,
                    colourByValue: id
                };
            }
        case 0, $9ffcO.SET_COLOUR_MAP:
            {
                const { id: id, map: map } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return {
                    ...state,
                    colourMaps: {
                        ...state.colourMaps,
                        [id]: map
                    }
                };
            }
        case 0, $9ffcO.UPDATE_TEAM_ID:
            {
                const { oldId: oldId, newId: newId } = action.payload;
                const map = state.colourMaps.team;
                const colour = map[oldId];
                return {
                    ...state,
                    colourMaps: {
                        ...state.colourMaps,
                        team: {
                            ...$8K6YM.default(oldId, map),
                            [newId]: colour
                        }
                    }
                };
            }
        case 0, $9ffcO.SET_COLOUR_FOR_NEW_TEAM:
            {
                const { id: id } = action.payload;
                const { lastUsed: lastUsed, colourMaps: colourMaps } = state;
                const nextColourIndex = (lastUsed + 1) % (0, $33N5G.colourPalette).length;
                const colour = (0, $33N5G.colourPalette)[nextColourIndex];
                return {
                    ...state,
                    colourMaps: {
                        ...state.colourMaps,
                        team: {
                            ...colourMaps.team,
                            [id]: colour
                        }
                    },
                    lastUsed: nextColourIndex
                };
            }
        case 0, $9ffcO.REMOVE_TEAM_ID:
            {
                const { id: id } = action.payload;
                return {
                    ...state,
                    colourMaps: {
                        ...state.colourMaps,
                        team: $8K6YM.default(id, state.colourMaps.team)
                    }
                };
            }
        case 0, $9ffcO.ADD_ISSUE_TYPE_COLOUR:
            return {
                ...state,
                colourIssueTypes: [
                    ...state.colourIssueTypes,
                    {
                        issueTypes: []
                    }
                ]
            };
        case 0, $9ffcO.UPDATE_ISSUE_TYPE_COLOUR:
            {
                const { index: index, ...patch } = action.payload;
                return $eoUrK.default({
                    colourIssueTypes: $gUZib.default(index, (item)=>({
                            ...item,
                            ...patch
                        }))
                }, state);
            }
        case 0, $9ffcO.REMOVE_ISSUE_TYPE_COLOUR:
            {
                const { index: index } = action.payload;
                return $eoUrK.default({
                    colourIssueTypes: $6aakY.default(index, 1)
                }, state);
            }
        case 0, $9ffcO.ADD_LABEL_COLOUR:
            return {
                ...state,
                colourLabels: [
                    ...state.colourLabels,
                    {
                        labels: []
                    }
                ]
            };
        case 0, $9ffcO.UPDATE_LABEL_COLOUR:
            {
                const { index: index, ...patch } = action.payload;
                return $eoUrK.default({
                    colourLabels: $gUZib.default(index, (item)=>({
                            ...item,
                            ...patch
                        }))
                }, state);
            }
        case 0, $9ffcO.REMOVE_LABEL_COLOUR:
            {
                const { index: index } = action.payload;
                return $eoUrK.default({
                    colourLabels: $6aakY.default(index, 1)
                }, state);
            }
        case 0, $9ffcO.ADD_COMPONENT_COLOUR:
            return {
                ...state,
                colourComponents: [
                    ...state.colourComponents,
                    {
                        components: []
                    }
                ]
            };
        case 0, $9ffcO.UPDATE_COMPONENT_COLOUR:
            {
                const { index: index, ...patch } = action.payload;
                return $eoUrK.default({
                    colourComponents: $gUZib.default(index, (item)=>({
                            ...item,
                            ...patch
                        }))
                }, state);
            }
        case 0, $9ffcO.REMOVE_COMPONENT_COLOUR:
            {
                const { index: index } = action.payload;
                return $eoUrK.default({
                    colourComponents: $6aakY.default(index, 1)
                }, state);
            }
        case 0, $9ffcO.ADD_PRIORITY_COLOUR:
            return {
                ...state,
                colourPriorities: [
                    ...state.colourPriorities,
                    {
                        priorities: []
                    }
                ]
            };
        case 0, $9ffcO.SET_PRIORITY_COLOUR_MAP:
            {
                const { chunks: chunks, issuePrioritiesIdList: issuePrioritiesIdList } = action.payload;
                const priorities = [];
                let start = 0;
                (0, $33N5G.priorityColourMap).forEach((colour, index)=>{
                    priorities.push({
                        colour: colour,
                        priorities: issuePrioritiesIdList.slice(start, start + chunks[index])
                    });
                    start += chunks[index];
                });
                return {
                    ...state,
                    colourPriorities: priorities
                };
            }
        case 0, $9ffcO.UPDATE_PRIORITY_COLOUR:
            {
                const { index: index, ...patch } = action.payload;
                return $eoUrK.default({
                    colourPriorities: $gUZib.default(index, (item)=>({
                            ...item,
                            ...patch
                        }))
                }, state);
            }
        case 0, $9ffcO.REMOVE_PRIORITY_COLOUR:
            {
                const { index: index } = action.payload;
                return $eoUrK.default({
                    colourPriorities: $6aakY.default(index, 1)
                }, state);
            }
        case 0, $9ffcO.ADD_SELECT_COLOUR:
            return {
                ...state,
                colourSelects: {
                    ...state.colourSelects,
                    [state.colourByValue]: [
                        ...state.colourSelects[state.colourByValue] || [],
                        {
                            options: []
                        }
                    ]
                }
            };
        case 0, $9ffcO.UPDATE_SELECT_COLOUR:
            {
                const { index: index, ...patch } = action.payload;
                return $eoUrK.default({
                    colourSelects: {
                        [state.colourByValue]: $gUZib.default(index, (item)=>({
                                ...item,
                                ...patch
                            }))
                    }
                }, state);
            }
        case 0, $9ffcO.REMOVE_SELECT_COLOUR:
            {
                const { index: index } = action.payload;
                return $eoUrK.default({
                    colourSelects: {
                        [state.colourByValue]: $6aakY.default(index, 1)
                    }
                }, state);
            }
        case 0, $9ffcO.CLEAR_ALL_COMPONENT_COLOURS:
            return {
                ...state,
                colourComponents: []
            };
        case 0, $9ffcO.CLEAR_ALL_ISSUE_TYPE_COLOURS:
            return {
                ...state,
                colourIssueTypes: []
            };
        case 0, $9ffcO.CLEAR_ALL_LABEL_COLOURS:
            return {
                ...state,
                colourLabels: []
            };
        case 0, $9ffcO.CLEAR_ALL_PRIORITY_COLOURS:
            return {
                ...state,
                colourPriorities: []
            };
        case 0, $9ffcO.CLEAR_ALL_SELECT_COLOURS:
            return {
                ...state,
                colourSelects: {
                    ...state.colourSelects,
                    [state.colourByValue]: []
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $2a7f6328c259eb4b$export$2e2bcd8739ae039 = $2a7f6328c259eb4b$export$1650419e431d3ba3;

});

parcelRegister("fKorV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c2e0c8797ca64ca$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $01zCq = parcelRequire("01zCq");

var $7CnHa = parcelRequire("7CnHa");

var $b7OiP = parcelRequire("b7OiP");

const $3c2e0c8797ca64ca$var$initialState = [
    {
        id: (0, $bb09f71c7817719d$export$526fec6b76d5bc5),
        name: '',
        isExpanded: false,
        components: []
    }
];
const $3c2e0c8797ca64ca$var$reducer = (state = $3c2e0c8797ca64ca$var$initialState, action)=>{
    switch(action.type){
        case 0, $b7OiP.RESET:
            {
                const initialGroup = action.payload.find(({ id: id })=>id === (0, $bb09f71c7817719d$export$526fec6b76d5bc5));
                if ((0, $7CnHa.isDefined)(initialGroup)) return [
                    ...action.payload
                ];
                return [
                    ...$3c2e0c8797ca64ca$var$initialState,
                    ...action.payload
                ];
            }
        case 0, $b7OiP.CLEAR_ALL:
            return $3c2e0c8797ca64ca$var$initialState;
        case 0, $b7OiP.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $b7OiP.UPDATE:
            {
                const { payload: payload } = action;
                const index = state.findIndex(({ id: id })=>id === payload.id);
                return $gUZib.default(index, (component)=>$01zCq.default(component, payload.patch), state);
            }
        case 0, $b7OiP.REMOVE:
            {
                const { payload: payload } = action;
                return state.filter(({ id: id })=>id !== payload);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $3c2e0c8797ca64ca$export$2e2bcd8739ae039 = $3c2e0c8797ca64ca$var$reducer;

});

parcelRegister("6TQUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $804b17a265ac8d69$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $01zCq = parcelRequire("01zCq");

var $1MbUl = parcelRequire("1MbUl");

const $804b17a265ac8d69$var$initialState = {};
const $804b17a265ac8d69$var$getAllOtherIssuesGroup = (grouping)=>({
        id: (0, $2d8d6e97f58f6828$export$526fec6b76d5bc5),
        name: '',
        isExpanded: false,
        [grouping]: []
    });
const $804b17a265ac8d69$var$reducer = (state = $804b17a265ac8d69$var$initialState, action)=>{
    switch(action.type){
        case 0, $1MbUl.RESET:
            return {
                ...state,
                [action.payload.grouping]: action.payload.groups
            };
        case 0, $1MbUl.CLEAR_ALL:
            return {
                ...state,
                [action.payload.grouping]: [
                    $804b17a265ac8d69$var$getAllOtherIssuesGroup(action.payload.grouping)
                ]
            };
        case 0, $1MbUl.ADD:
            {
                const groups = state[action.payload.grouping] || [
                    $804b17a265ac8d69$var$getAllOtherIssuesGroup(action.payload.grouping)
                ];
                return {
                    ...state,
                    [action.payload.grouping]: [
                        ...groups,
                        action.payload.group
                    ]
                };
            }
        case 0, $1MbUl.UPDATE:
            {
                const { payload: payload } = action;
                const groups = state[payload.grouping] || [];
                const index = groups.findIndex(({ id: id })=>id === action.payload.id);
                return {
                    ...state,
                    [payload.grouping]: $gUZib.default(index, (group)=>$01zCq.default(group, payload.patch), groups)
                };
            }
        case 0, $1MbUl.REMOVE:
            {
                const { payload: payload } = action;
                const groups = state[payload.grouping] || [];
                return {
                    ...state,
                    [payload.grouping]: groups.filter(({ id: id })=>id !== payload.id)
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $804b17a265ac8d69$export$2e2bcd8739ae039 = $804b17a265ac8d69$var$reducer;

});

parcelRegister("bwvEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9123f3c0eadc683$export$2e2bcd8739ae039);

var $kbECr = parcelRequire("kbECr");
const $e9123f3c0eadc683$var$initialState = {
    showDateConstraints: false
};
const $e9123f3c0eadc683$var$reducer = (state = $e9123f3c0eadc683$var$initialState, action)=>{
    switch(action.type){
        case 0, $kbECr.RESET_SHOW_DATE_CONSTRAINTS:
            return {
                ...state,
                showDateConstraints: action.payload.showDateConstraints
            };
        case 0, $kbECr.TOGGLE_SHOW_DATE_CONSTRAINTS:
            return {
                ...state,
                showDateConstraints: !state.showDateConstraints
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $e9123f3c0eadc683$export$2e2bcd8739ae039 = $e9123f3c0eadc683$var$reducer;

});
parcelRegister("kbECr", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_SHOW_DATE_CONSTRAINTS", () => $a1a20c331cb0c80a$export$918e26cf26b9a386);
$parcel$export(module.exports, "RESET_SHOW_DATE_CONSTRAINTS", () => $a1a20c331cb0c80a$export$a412b36a73383e70);
const $a1a20c331cb0c80a$export$918e26cf26b9a386 = 'state.domain.view-settings.date-constraints-setting.TOGGLE_SHOW_DATE_CONSTRAINTS';
const $a1a20c331cb0c80a$export$a412b36a73383e70 = 'state.domain.view-settings.date-constraints-setting.RESET_SHOW_DATE_CONSTRAINTS';
const $a1a20c331cb0c80a$export$50afbc86dffb6fd9 = ()=>({
        type: $a1a20c331cb0c80a$export$918e26cf26b9a386
    });
const $a1a20c331cb0c80a$export$56eae6b516154c2e = (payload)=>({
        type: $a1a20c331cb0c80a$export$a412b36a73383e70,
        payload: payload
    });

});


parcelRegister("iUBEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $921f67da3e55d366$export$2e2bcd8739ae039);

var $8fleG = parcelRequire("8fleG");
const $921f67da3e55d366$var$initialState = {
    display: 'default'
};
const $921f67da3e55d366$var$reducer = (state = $921f67da3e55d366$var$initialState, action)=>{
    switch(action.type){
        case 0, $8fleG.CHANGE_DISPLAY:
            return {
                ...state,
                display: action.payload.display
            };
        default:
            return {
                ...state,
                display: state.display || 'default'
            };
    }
};
var $921f67da3e55d366$export$2e2bcd8739ae039 = $921f67da3e55d366$var$reducer;

});

parcelRegister("dD7T9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6edfdefbb67f27a2$export$2e2bcd8739ae039);

var $3rc1Q = parcelRequire("3rc1Q");
const $6edfdefbb67f27a2$export$d4c72bab9d6cc13a = {
    includeAncestors: true,
    includeDescendants: true
};
const $6edfdefbb67f27a2$var$reducer = (state = $6edfdefbb67f27a2$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $3rc1Q.RESET_FILTER_OPTIONS:
            return {
                ...action.payload
            };
        case 0, $3rc1Q.TOGGLE_SHOW_FULL_HIERARCHY:
            return {
                ...state,
                includeDescendants: !state.includeDescendants
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $6edfdefbb67f27a2$export$2e2bcd8739ae039 = $6edfdefbb67f27a2$var$reducer;

});

parcelRegister("ekLOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd42d9f4e9dfb0c5$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $eaaIH = parcelRequire("eaaIH");

var $9weAS = parcelRequire("9weAS");

const $fd42d9f4e9dfb0c5$var$initialState = {
    [(0, $12ee831723ccf9c2$export$585fb3e81bcfccad)]: {
        id: (0, $12ee831723ccf9c2$export$585fb3e81bcfccad),
        value: []
    },
    [(0, $12ee831723ccf9c2$export$82db1960569473ff)]: {
        id: (0, $12ee831723ccf9c2$export$82db1960569473ff),
        value: {}
    }
};
const $fd42d9f4e9dfb0c5$var$reducer = (state, action)=>{
    switch(action.type){
        case 0, $eaaIH.RESET:
            return {
                ...action.payload
            };
        case 0, $eaaIH.CHANGE:
            {
                const { id: id, value: value } = action.payload;
                return {
                    ...state,
                    [id]: $01zCq.default(state[id] ?? {}, {
                        value: value
                    })
                };
            }
        case 0, $eaaIH.CLEAR:
            {
                const id = action.payload;
                return {
                    ...state,
                    [id]: $01zCq.default(state[id] ?? {}, {
                        value: $fd42d9f4e9dfb0c5$var$initialState[id]?.value
                    })
                };
            }
        case 0, $eaaIH.CLEAR_ALL:
            return {
                ...$fd42d9f4e9dfb0c5$var$initialState,
                [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: state[0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc],
                [(0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5)]: state[0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5]
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fd42d9f4e9dfb0c5$var$finalReducer = (state = $fd42d9f4e9dfb0c5$var$initialState, action)=>({
        ...$fd42d9f4e9dfb0c5$var$reducer(state, action),
        [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: (0, $9weAS.default)(state[0, $12ee831723ccf9c2$export$3b798637a628dacc], action)
    });
var $fd42d9f4e9dfb0c5$export$2e2bcd8739ae039 = $fd42d9f4e9dfb0c5$var$finalReducer;

});
parcelRegister("9weAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e82f582ba37866$export$2e2bcd8739ae039);
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $8B14N = parcelRequire("8B14N");
parcelRequire("eiSK3");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $38e82f582ba37866$var$filterValueFor(customField, desirable) {
    switch(customField.type.key){
        case (0, $5rYNM.CustomFieldTypes).Labels:
        case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
        case (0, $5rYNM.CustomFieldTypes).AssetObject:
        case (0, $5rYNM.CustomFieldTypes).MultiSelect:
        case (0, $5rYNM.CustomFieldTypes).RadioButtons:
        case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            if (!(0, $cofZt.default)()) {
                if (customField.type.key === (0, $5rYNM.CustomFieldTypes).AssetObject) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return [];
            }
            // Make it array
            if (!(0, $7CnHa.isDefined)(desirable)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
            if (!Array.isArray(desirable)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
            return desirable;
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
    }
}
function $38e82f582ba37866$var$updateFilterValue(state, fieldId, updateFn) {
    return {
        ...state,
        value: {
            ...state.value,
            [fieldId]: updateFn(state.value[fieldId])
        }
    };
}
function $38e82f582ba37866$export$2e2bcd8739ae039(state = {
    id: (0, $12ee831723ccf9c2$export$3b798637a628dacc),
    value: {}
}, action) {
    const { value: value } = state;
    switch(action.type){
        case 0, $8B14N.RESET:
            {
                const { customFields: customFields } = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const nextValue = customFields.reduce((acc, customField)=>{
                    const id = String(customField.id);
                    if (!customField.filteringAllowed) return acc;
                    return Object.assign(acc, {
                        [id]: $38e82f582ba37866$var$filterValueFor(customField, value[id])
                    });
                }, {});
                return {
                    ...state,
                    value: nextValue
                };
            }
        case 0, $8B14N.UPDATE:
            {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const { value: value, customField: customField } = action.payload;
                const id = String(customField.id);
                return $38e82f582ba37866$var$updateFilterValue(state, id, ()=>$38e82f582ba37866$var$filterValueFor(customField, value));
            }
        case 0, $8B14N.CLEAR:
            {
                const { customField: customField } = action.payload;
                const id = String(customField.id);
                return $38e82f582ba37866$var$updateFilterValue(state, id, ()=>$38e82f582ba37866$var$filterValueFor(customField, null));
            }
        case 0, $8B14N.CLEAR_ALL:
            {
                const { customFields: customFields } = action.payload;
                return customFields.reduce((acc, customField)=>{
                    const id = String(customField.id);
                    return $38e82f582ba37866$var$updateFilterValue(acc, id, ()=>$38e82f582ba37866$var$filterValueFor(customField, null));
                }, state);
            }
        default:
            return state;
    }
}

});
parcelRegister("eiSK3", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELD_FILTER_ID", () => $12ee831723ccf9c2$export$3b798637a628dacc);
// eslint-disable-next-line jira/export/no-external-exports


});



parcelRegister("c8TSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $543f171114556b11$export$2e2bcd8739ae039);

var $7s5zv = parcelRequire("7s5zv");
const $543f171114556b11$export$d4c72bab9d6cc13a = {
    versions: []
};
const $543f171114556b11$export$1650419e431d3ba3 = (state = $543f171114556b11$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $7s5zv.TOGGLE:
            {
                const { versionId: versionId } = action;
                const highlightedVersionIds = new Set(state.versions);
                if (highlightedVersionIds.has(versionId)) highlightedVersionIds.delete(versionId);
                else highlightedVersionIds.add(versionId);
                return {
                    versions: [
                        ...highlightedVersionIds
                    ]
                };
            }
        case 0, $7s5zv.RESET:
            return {
                versions: action.versionIds
            };
        default:
            return state;
    }
};
var $543f171114556b11$export$2e2bcd8739ae039 = $543f171114556b11$export$1650419e431d3ba3;

});
parcelRegister("7s5zv", function(module, exports) {

$parcel$export(module.exports, "TOGGLE", () => $f1248c6b6f5a353b$export$60842f1a88feb6ed);
$parcel$export(module.exports, "RESET", () => $f1248c6b6f5a353b$export$4a991c87e640ef77);
$parcel$export(module.exports, "toggle", () => $f1248c6b6f5a353b$export$e03c1c3201ee8bb7);
const $f1248c6b6f5a353b$export$60842f1a88feb6ed = 'state.domain.view-settings.highlighted-versions.TOGGLE';
const $f1248c6b6f5a353b$export$4a991c87e640ef77 = 'state.domain.view-settings.highlighted-versions.RESET';
const $f1248c6b6f5a353b$export$e03c1c3201ee8bb7 = (versionId)=>({
        type: $f1248c6b6f5a353b$export$60842f1a88feb6ed,
        versionId: versionId
    });
const $f1248c6b6f5a353b$export$aad8462122ac592b = (versionIds)=>({
        type: $f1248c6b6f5a353b$export$4a991c87e640ef77,
        versionIds: versionIds
    });

});


parcelRegister("hL0u5", function(module, exports) {

$parcel$export(module.exports, "default", () => $36cbca4c6a536db6$export$2e2bcd8739ae039);

var $c7fhc = parcelRequire("c7fhc");
const $36cbca4c6a536db6$export$d4c72bab9d6cc13a = {
    isExpanded: {
        IssuesWithoutParentHeader: true
    }
};
const $36cbca4c6a536db6$var$reducer = (state = $36cbca4c6a536db6$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $c7fhc.RESET:
            return action.payload;
        case 0, $c7fhc.SET_IS_EXPANDED:
            {
                const { payload: payload } = action;
                const all = {
                    ...state.isExpanded,
                    ...payload
                };
                // remove keys with false value from the object since the default value is false.
                // this optimization keeps the view preference payload small
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const prunedIsExpanded = Object.entries(all).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                (acc, [key, value])=>{
                    if (value === true) acc[key] = value;
                    return acc;
                }, {});
                return {
                    ...state,
                    isExpanded: prunedIsExpanded
                };
            }
        case 0, $c7fhc.UPDATE_EXPANDED_ISSUE_LINKS:
            {
                const { payload: payload } = action;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const isExpanded = Object.keys(state.isExpanded).reduce((acc, currentKey)=>{
                    let newKey = currentKey;
                    const keyComponents = currentKey.split(':');
                    if (payload[keyComponents[0]]) {
                        keyComponents[0] = payload[keyComponents[0]];
                        newKey = keyComponents.join(':');
                    }
                    acc[newKey] = state.isExpanded[currentKey];
                    return acc;
                }, {});
                return {
                    ...state,
                    isExpanded: isExpanded
                };
            }
        default:
            return state;
    }
};
var $36cbca4c6a536db6$export$2e2bcd8739ae039 = $36cbca4c6a536db6$var$reducer;

});

parcelRegister("6RLYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $178b19c3fbd42e4c$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $01zCq = parcelRequire("01zCq");

var $7CnHa = parcelRequire("7CnHa");

var $etElm = parcelRequire("etElm");

const $178b19c3fbd42e4c$var$initialState = [
    {
        id: (0, $368897e366669426$export$526fec6b76d5bc5),
        name: '',
        isExpanded: false,
        labels: []
    }
];
const $178b19c3fbd42e4c$export$a41c0e365ee7d8b4 = $178b19c3fbd42e4c$var$initialState;
const $178b19c3fbd42e4c$var$reducer = (state = $178b19c3fbd42e4c$var$initialState, action)=>{
    switch(action.type){
        case 0, $etElm.RESET:
            {
                const initialGroup = action.payload.find(({ id: id })=>id === (0, $368897e366669426$export$526fec6b76d5bc5));
                if ((0, $7CnHa.isDefined)(initialGroup)) return [
                    ...action.payload
                ];
                return [
                    ...$178b19c3fbd42e4c$var$initialState,
                    ...action.payload
                ];
            }
        case 0, $etElm.CLEAR_ALL:
            return $178b19c3fbd42e4c$var$initialState;
        case 0, $etElm.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $etElm.UPDATE:
            {
                const { payload: payload } = action;
                const index = state.findIndex(({ id: id })=>id === payload.id);
                return $gUZib.default(index, (label)=>$01zCq.default(label, payload.patch), state);
            }
        case 0, $etElm.REMOVE:
            {
                const { payload: payload } = action;
                return state.filter(({ id: id })=>id !== payload);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $178b19c3fbd42e4c$export$2e2bcd8739ae039 = $178b19c3fbd42e4c$var$reducer;

});
const $368897e366669426$export$526fec6b76d5bc5 = 'all_other_issues';


parcelRegister("gEJLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $843fcfb99e06163e$export$2e2bcd8739ae039);

var $e0l3L = parcelRequire("e0l3L");
const $843fcfb99e06163e$export$d4c72bab9d6cc13a = {
    showingRolledUpDate: true,
    showRolledUpOthers: true
};
const $843fcfb99e06163e$export$1650419e431d3ba3 = (state = $843fcfb99e06163e$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $e0l3L.SET_SHOW_ROLLED_UP_DATE:
            return {
                ...state,
                showingRolledUpDate: action.payload.shouldShow
            };
        case 0, $e0l3L.SET_SHOW_ROLLED_UP_OTHERS:
            return {
                ...state,
                showRolledUpOthers: action.payload.shouldShow
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $843fcfb99e06163e$export$2e2bcd8739ae039 = $843fcfb99e06163e$export$1650419e431d3ba3;

});

parcelRegister("1w9iY", function(module, exports) {

$parcel$export(module.exports, "default", () => $11e4d5714f05e5d9$export$2e2bcd8739ae039);

var $5rYNM = parcelRequire("5rYNM");

var $hHEgb = parcelRequire("hHEgb");
const $11e4d5714f05e5d9$export$d4c72bab9d6cc13a = {
    mode: (0, $5rYNM.TIMELINE_MODES).MONTHS
};
const $11e4d5714f05e5d9$var$reducer = (state = $11e4d5714f05e5d9$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $hHEgb.CHANGE_OPTION:
            return {
                ...state,
                selection: action.payload
            };
        case 0, $hHEgb.CHANGE_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case 0, $hHEgb.CHANGE_CUSTOM_DATES:
            return {
                ...state,
                customDateRange: {
                    ...state.customDateRange,
                    ...action.payload
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $11e4d5714f05e5d9$export$2e2bcd8739ae039 = $11e4d5714f05e5d9$var$reducer;

});

parcelRegister("bLErO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a296a5fa4636b0e$export$2e2bcd8739ae039);

var $lcvrv = parcelRequire("lcvrv");

var $2iNiW = parcelRequire("2iNiW");
const $4a296a5fa4636b0e$var$initialState = {
    // Update default value when 'ploverview_landing_on_list_mode_by_default' experiment ends
    mode: (0, $lcvrv.VIEW_MODES).TIMELINE
};
const $4a296a5fa4636b0e$var$reducer = (state = $4a296a5fa4636b0e$var$initialState, action)=>{
    switch(action.type){
        case 0, $2iNiW.CHANGE_VIEW_MODE:
            return {
                ...state,
                mode: action.payload.mode
            };
        default:
            return {
                ...state,
                mode: state.mode || (0, $lcvrv.VIEW_MODES).TIMELINE
            };
    }
};
var $4a296a5fa4636b0e$export$2e2bcd8739ae039 = $4a296a5fa4636b0e$var$reducer;

});

parcelRegister("ft2cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5add2aa9da7cb7b$export$2e2bcd8739ae039);

var $5rYNM = parcelRequire("5rYNM");

var $l1dWb = parcelRequire("l1dWb");

var $dvRTl = parcelRequire("dvRTl");
const $d5add2aa9da7cb7b$export$d4c72bab9d6cc13a = {
    sorting: (0, $dvRTl.defaultSorting),
    grouping: (0, $5rYNM.GROUPING).NONE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedItems: Object.keys((0, $5rYNM.GROUPING)).reduce((result, group)=>Object.assign(result, {
            [group]: {}
        }), {}),
    showSprints: false
};
const $d5add2aa9da7cb7b$var$reducer = (state = $d5add2aa9da7cb7b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $l1dWb.RESET:
            return {
                ...action.payload
            };
        case 0, $l1dWb.CHANGE_GROUP:
            return {
                ...state,
                grouping: action.payload.grouping
            };
        case 0, $l1dWb.CHANGE_SORT:
            return {
                ...state,
                sorting: action.payload.sorting
            };
        case 0, $l1dWb.TOGGLE_EXPAND_GROUP:
            {
                const { grouping: grouping, groupName: groupName, expand: expand } = action.payload;
                const { expandedItems: expandedItems } = state;
                return {
                    ...state,
                    expandedItems: {
                        ...expandedItems,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        [grouping]: {
                            ...expandedItems[grouping],
                            [groupName]: expand
                        }
                    }
                };
            }
        case 0, $l1dWb.TOGGLE_SHOW_SPRINTS:
            {
                const { showSprints: showSprints } = action.payload;
                return {
                    ...state,
                    showSprints: showSprints
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $d5add2aa9da7cb7b$export$2e2bcd8739ae039 = $d5add2aa9da7cb7b$var$reducer;

});

parcelRegister("dfELb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7c1302c585a2f8$export$2e2bcd8739ae039);

var $lOjjB = parcelRequire("lOjjB");

var $9RBvc = parcelRequire("9RBvc");
const $0d7c1302c585a2f8$var$initialState = {
    showWarning: false,
    disabledWarnings: []
};
const $0d7c1302c585a2f8$var$reducer = (stateArg = $0d7c1302c585a2f8$var$initialState, action)=>{
    switch(action.type){
        case 0, $9RBvc.RESET_SHOW_WARNING:
            return {
                ...stateArg,
                showWarning: action.payload.showWarning
            };
        case 0, $9RBvc.TOGGLE_SHOW_WARNING:
            return {
                ...stateArg,
                showWarning: !stateArg.showWarning
            };
        case 0, $9RBvc.TOGGLE_WARNING_TYPE:
            if ((stateArg.disabledWarnings || []).includes(action.payload)) {
                const warningsWithPayloadItemRemoved = stateArg.disabledWarnings.filter(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (item)=>item !== action.payload);
                return {
                    ...stateArg,
                    disabledWarnings: warningsWithPayloadItemRemoved
                };
            }
            return {
                ...stateArg,
                disabledWarnings: [
                    ...stateArg.disabledWarnings,
                    action.payload
                ]
            };
        case 0, $9RBvc.RESET_ENABLED_WARNING_TYPE:
            return {
                ...stateArg,
                disabledWarnings: (0, $lOjjB.WARNING_CENTER_AVAILABLE_TYPES).filter((warningType)=>!action.payload.has(warningType))
            };
        default:
            {
                const _exhaustiveCheck = action;
                return stateArg;
            }
    }
};
var $0d7c1302c585a2f8$export$2e2bcd8739ae039 = $0d7c1302c585a2f8$var$reducer;

});


parcelRegister("cBUDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $664eb84b327ccb6c$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $664eb84b327ccb6c$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'rollupSetting',
    from: 'V0'
}));

});

parcelRegister("9OspV", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0ec34d8528977a$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");

var $5rYNM = parcelRequire("5rYNM");
/**
 * maps the V0 selection value to the rough equivalent of the V1 mode value
 */ const $df0ec34d8528977a$var$mapSelection = (selection)=>{
    switch(selection){
        case '1yr':
            return (0, $5rYNM.TIMELINE_MODES).QUARTERS;
        case '3mth':
            return (0, $5rYNM.TIMELINE_MODES).MONTHS;
        case 'custom':
            return selection;
        default:
            return (0, $5rYNM.TIMELINE_MODES).MONTHS;
    }
};
var $df0ec34d8528977a$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    },
    V1: function fromV0ToV1(prevState) {
        const mode = $df0ec34d8528977a$var$mapSelection(prevState.selection);
        return {
            ...prevState,
            mode: mode
        };
    }
}, {
    prefix: 'timeScale',
    from: 'V0'
}));

});

parcelRegister("jJO9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b001a06f306c4cb$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $2b001a06f306c4cb$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return prevState;
    }
}, {
    prefix: 'viewMode',
    from: 'V0'
}));

});

parcelRegister("1sB9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $7060fa0056d1a6db$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $7060fa0056d1a6db$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV0(prevState) {
        return {
            ...prevState
        };
    }
}, {
    prefix: 'visualisations',
    from: 'V0'
}));

});

parcelRegister("1nK7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b240690614bbf3a$export$2e2bcd8739ae039);

var $hUgnE = parcelRequire("hUgnE");
var $9b240690614bbf3a$export$2e2bcd8739ae039 = (0, $hUgnE.createMigrate)(...(0, $hUgnE.incremental)({
    V0: function fromV0ToV1(prevState) {
        return {
            ...prevState,
            disabledWarnings: []
        };
    }
}, {
    prefix: 'warningSettings',
    from: 'V0'
}));

});



parcelRegister("cC2NN", function(module, exports) {

$parcel$export(module.exports, "getReportMigratableBlob", () => $9b1f43c182eabbdd$export$3994f83f8fd76e58);
function $9b1f43c182eabbdd$export$3994f83f8fd76e58(reportViewSettings) {
    if (!reportViewSettings.filtersConfig) // the report view settings has been migrated
    // @ts-expect-error - TS2740 - Type 'ReportViewSettings' is missing the following properties from type 'PreMigrationBlob': releaseBar, colorBy, groupByLabels, groupBy, and 7 more.
    return reportViewSettings;
    return {
        dateConstraintsSetting: undefined,
        releaseBar: reportViewSettings.releaseBarState,
        colorBy: reportViewSettings.colorByConfig,
        groupByLabels: {
            groups: reportViewSettings.groupByLabelGroups
        },
        fieldColumns: reportViewSettings.fieldColumnsConfig,
        groupBy: {
            groups: reportViewSettings.groupByComponentGroups
        },
        filterOptions: reportViewSettings.filterOptionsConfig,
        timeScale: reportViewSettings.timelineConfig,
        warningSetting: reportViewSettings.warningSetting,
        visualisations: reportViewSettings.groupByConfig,
        filters: reportViewSettings.filtersConfig,
        scopeIssues: {
            isExpanded: reportViewSettings.issueExpansionConfig,
            selected: [],
            lastSelected: [],
            isLoading: false,
            isLoadingHistory: false,
            isSavingIssue: false
        },
        rollupSettings: {
            showingRolledUpDate: reportViewSettings.rollupSettings.showingRolledUpDate || false,
            showRolledUpOthers: reportViewSettings.rollupSettings.showRolledUpOthers || false
        },
        estimateRollup: {
            showRolledUpEstimate: reportViewSettings.rollupSettings.showRolledUpEstimate || false
        }
    };
}

});




parcelRegister("3SEZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e54a2acc806ded$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $dBKyg = parcelRequire("dBKyg");

var $iK4oF = parcelRequire("iK4oF");
var $73e54a2acc806ded$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    views: (0, $dBKyg.getViews),
    activeView: (0, $dBKyg.getActiveView),
    errors: (0, $dBKyg.getErrors),
    saveViewAsDialogStatus: (0, $dBKyg.getSaveViewAsDialogStatus),
    readOnly: (0, $akhOi.isReadOnly)
});

});

parcelRegister("fCk8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7f7b2c9b236234$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $ltfxy = parcelRequire("ltfxy");


var $ewehA = parcelRequire("ewehA");

var $2BQwE = parcelRequire("2BQwE");

var $duQ8C = parcelRequire("duQ8C");

var $i9MGx = parcelRequire("i9MGx");

var $laYef = parcelRequire("laYef");

var $jNofI = parcelRequire("jNofI");

var $1NLvh = parcelRequire("1NLvh");

var $9TZSw = parcelRequire("9TZSw");

var $3PNta = parcelRequire("3PNta");

var $GyNCW = parcelRequire("GyNCW");
function $3b7f7b2c9b236234$var$getDeleteDefaultViewError(errors) {
    const err = errors.find((one)=>one instanceof (0, $ewehA.DeleteErrorDefaultView));
    if (!err) return null;
    if (!(err instanceof (0, $ewehA.DeleteErrorDefaultView))) return null;
    return err;
}
function $3b7f7b2c9b236234$var$getConflictError(errors) {
    const err = errors.find((one)=>one instanceof (0, $ewehA.UpdateErrorConflicted));
    if (!err) return null;
    if (!(err instanceof (0, $ewehA.UpdateErrorConflicted))) return null;
    return err;
}
function $3b7f7b2c9b236234$var$getNonExistingError(errors) {
    const err = errors.find((one)=>one instanceof (0, $ewehA.UpdateErrorNotExists));
    if (!err) return null;
    if (!(err instanceof (0, $ewehA.UpdateErrorNotExists))) return null;
    return err;
}
function $3b7f7b2c9b236234$var$getDuplicateViewError(errors) {
    const err = errors.find((one)=>one instanceof (0, $ewehA.SaveAsErrorDuplicateView));
    if (!err) return null;
    if (!(err instanceof (0, $ewehA.SaveAsErrorDuplicateView))) return null;
    return err;
}
function $3b7f7b2c9b236234$export$2e2bcd8739ae039({ views: views, activeView: activeView, errors: errors, saveView: saveView, saveViewAs: saveViewAs, discardChanges: discardChanges, deleteView: deleteView, removeError: removeError, duplicateSection: duplicateSection, saveViewAsDialogStatus: saveViewAsDialogStatus, setSaveViewAsDialogStatus: setSaveViewAsDialogStatus, readOnly: readOnly, switchView: switchView }) {
    const [saving, setSaving] = (0, $eUqFw.useState)(false);
    const [deleting, setDeleting] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (saveViewAsDialogStatus !== 'CLOSED') {
            const firstChild = buttonRef.current?.firstElementChild;
            if (firstChild instanceof HTMLElement && firstChild.focus) firstChild.focus();
        }
    }, [
        saveViewAsDialogStatus
    ]);
    const handleActiveViewChange = (e, id)=>{
        if (id !== activeView.id) {
            (0, $duQ8C.default)((0, $2BQwE.KEYS).SWITCH_VIEW, e.timeStamp);
            switchView(id);
        }
    };
    const openSaveAsDialog = ()=>{
        setSaveViewAsDialogStatus('OPEN');
    };
    const duplicateViewError = $3b7f7b2c9b236234$var$getDuplicateViewError(errors);
    const closeSaveAsDialog = ()=>{
        setSaveViewAsDialogStatus('CLOSED');
        if (duplicateViewError) removeError(duplicateViewError);
    };
    const buttonRef = (0, $eUqFw.useRef)(null);
    const handleRequestSaveAs = ({ name: name, asDefault: asDefault })=>{
        saveViewAs({
            name: name,
            asDefault: asDefault,
            duplicateSection: duplicateSection
        });
    };
    const openSavingDialog = ()=>setSaving(true);
    const closeSavingDialog = ()=>setSaving(false);
    const confirmSaving = ()=>{
        if (activeView.id === (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28)) return openSaveAsDialog();
        saveView({
            overwrite: false
        });
        closeSavingDialog();
    };
    const confirmDiscarding = ()=>{
        discardChanges(activeView.id);
    };
    const openDeletingDialog = ()=>setDeleting(true);
    const closeDeletingDialog = ()=>setDeleting(false);
    const confirmDeleting = ()=>{
        deleteView(activeView.id);
        closeDeletingDialog();
    };
    const conflictError = $3b7f7b2c9b236234$var$getConflictError(errors);
    const closeConflictDialog = ()=>{
        if (conflictError) removeError(conflictError);
    };
    const handleConflictRequestSaveAs = ()=>{
        closeConflictDialog();
        openSaveAsDialog();
    };
    const handleConflictRequestDiscardChanges = ()=>{
        closeConflictDialog();
        discardChanges(activeView.id);
    };
    const handleConflictRequestOverwrite = ()=>{
        closeConflictDialog();
        saveView({
            overwrite: true
        });
    };
    const nonExistingError = $3b7f7b2c9b236234$var$getNonExistingError(errors);
    const closeNonExistingDialog = ()=>{
        if (nonExistingError) removeError(nonExistingError);
    };
    const handleNonExistingRequestSaveAs = ()=>{
        closeNonExistingDialog();
        openSaveAsDialog();
    };
    const handleNonExistingRequestDiscardChanges = ()=>{
        closeNonExistingDialog();
        deleteView(activeView.id, false);
    };
    const handleTitleChange = ()=>{
        if (duplicateViewError) removeError(duplicateViewError);
    };
    const deleteDefaultViewError = $3b7f7b2c9b236234$var$getDeleteDefaultViewError(errors);
    const closeDeleteErrorNotification = ()=>{
        if (deleteDefaultViewError) removeError(deleteDefaultViewError);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "view-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3PNta.default), {
        views: views,
        isReadOnly: readOnly,
        onRequestDiscardChanges: confirmDiscarding,
        onRequestViewChange: handleActiveViewChange,
        onRequestSave: openSavingDialog,
        onRequestSaveAs: openSaveAsDialog,
        onRequestDelete: openDeletingDialog,
        buttonRef: buttonRef
    }), !$b3iuB.default(views) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $GyNCW.default), {
        onConfirm: confirmSaving,
        onClose: closeSavingDialog,
        viewName: activeView.name
    }), saveViewAsDialogStatus !== 'CLOSED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9TZSw.default), {
        hasDuplicateViewError: !!duplicateViewError,
        isSaving: saveViewAsDialogStatus === 'SAVING',
        onChange: handleTitleChange,
        onSubmit: handleRequestSaveAs,
        onClose: closeSaveAsDialog
    }), deleting && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jNofI.default), {
        viewName: activeView.name,
        onConfirm: confirmDeleting,
        onClose: closeDeletingDialog
    }), conflictError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9MGx.default), {
        conflictError: conflictError,
        onRequestOverwrite: handleConflictRequestOverwrite,
        onRequestSaveAs: handleConflictRequestSaveAs,
        onRequestDiscardChanges: handleConflictRequestDiscardChanges,
        onClose: closeConflictDialog
    }), nonExistingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1NLvh.default), {
        viewName: nonExistingError.viewName,
        onRequestSaveAs: handleNonExistingRequestSaveAs,
        onRequestDiscardChanges: handleNonExistingRequestDiscardChanges,
        onClose: closeNonExistingDialog
    }), deleteDefaultViewError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $laYef.default), {
        viewName: deleteDefaultViewError.viewName,
        dismissFlag: closeDeleteErrorNotification
    }))));
}

});
parcelRegister("i9MGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6095fa2c25cc502a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eTbtL = parcelRequire("eTbtL");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $hnuwz = parcelRequire("hnuwz");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $l2Sj2 = parcelRequire("l2Sj2");

var $ib5d3 = parcelRequire("ib5d3");

var $lz8oz = parcelRequire("lz8oz");

var $bRCWW = parcelRequire("bRCWW");

var $k6tXG = parcelRequire("k6tXG");
function $6095fa2c25cc502a$export$2e2bcd8739ae039({ conflictError: { viewName: viewName, modifiedBy: modifiedBy, modifiedAt: modifiedAt }, onClose: onClose, onRequestOverwrite: onRequestOverwrite, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const options = [
        {
            message: (0, $bRCWW.default).overwrite,
            action: onRequestOverwrite,
            isFocused: true
        },
        {
            message: (0, $bRCWW.default).saveAs,
            action: onRequestSaveAs,
            isFocused: false
        },
        {
            message: (0, $bRCWW.default).discardChanges,
            action: onRequestDiscardChanges,
            isFocused: false
        }
    ];
    const [selectedIndex, setSelectedIndex] = (0, $eUqFw.useState)(-1);
    const handleRadioButtonChange = (idx)=>()=>setSelectedIndex(idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $bRCWW.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $bRCWW.default).message, {
        name: viewName,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.updatedInfoGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.headersColor
    }, formatMessage((0, $bRCWW.default).modifiedByHeader)), (0, $lz8oz.ViewUser)(modifiedBy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.modifiedAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.headersColor
    }, formatMessage((0, $bRCWW.default).modifiedAtHeader)), formatTimestamp(modifiedAt.getTime() - modifiedAt.getTimezoneOffset() * 60000, (0, $eTbtL.longDateTimeFormat)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.actionGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$k6tXG.actionGroupHeader} ${$k6tXG.headersColor}`
    }, formatMessage((0, $bRCWW.default).actionGroupHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k6tXG.actionGroupRadios
    }, options.map(({ message: message }, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            isChecked: idx === selectedIndex,
            key: idx,
            label: formatMessage(message),
            onChange: handleRadioButtonChange(idx)
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        isDisabled: selectedIndex === -1,
        onClick: options[selectedIndex] && options[selectedIndex].action
    }, formatMessage((0, $ib5d3.default).confirm))));
}

});
parcelRegister("lz8oz", function(module, exports) {

$parcel$export(module.exports, "ViewUser", () => $47fcfa2c3ab294d4$export$f1f3b3137c27ba7d);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $gwbfD = parcelRequire("gwbfD");

var $baEk9 = parcelRequire("baEk9");
const $47fcfa2c3ab294d4$export$f1f3b3137c27ba7d = (user)=>user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: user.email
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $baEk9.avatarWithTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: user.avatarUrl,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $baEk9.userTitle
    }, user.title))) : '';

});
parcelRegister("baEk9", function(module, exports) {

$parcel$export(module.exports, "avatarWithTitle", () => $821fe8616ff80c2c$export$ab485147d010f3a4, (v) => $821fe8616ff80c2c$export$ab485147d010f3a4 = v);
$parcel$export(module.exports, "userTitle", () => $821fe8616ff80c2c$export$6c3180b0bb3c4aaa, (v) => $821fe8616ff80c2c$export$6c3180b0bb3c4aaa = v);
var $821fe8616ff80c2c$export$ab485147d010f3a4;
var $821fe8616ff80c2c$export$c15bf4ef59dc517d;
var $821fe8616ff80c2c$export$6c3180b0bb3c4aaa;
$821fe8616ff80c2c$export$ab485147d010f3a4 = `t08fYq_avatarWithTitle`;
$821fe8616ff80c2c$export$c15bf4ef59dc517d = `t08fYq_mutedColor`;
$821fe8616ff80c2c$export$6c3180b0bb3c4aaa = `t08fYq_userTitle`;

});


parcelRegister("bRCWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c80eb66ed83028$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a1c80eb66ed83028$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.heading",
        "defaultMessage": "Are you sure you want to save?"
    },
    message: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.message",
        "defaultMessage": "<strong>{name}</strong> was updated during your session by the following."
    },
    actionGroupHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.action-group-header",
        "defaultMessage": "Would you like to"
    },
    overwrite: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.overwrite",
        "defaultMessage": "Overwrite their changes"
    },
    saveAs: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.save-as",
        "defaultMessage": "Save as a new view"
    },
    discardChanges: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.discard-changes",
        "defaultMessage": "Discard your changes"
    },
    modifiedByHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.modified-by-header",
        "defaultMessage": "Who"
    },
    modifiedAtHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.conflict-dialog.modified-at-header",
        "defaultMessage": "When"
    }
});

});

parcelRegister("k6tXG", function(module, exports) {

$parcel$export(module.exports, "actionGroup", () => $ea2b9becf55f706d$export$90bccb1402e26e40, (v) => $ea2b9becf55f706d$export$90bccb1402e26e40 = v);
$parcel$export(module.exports, "actionGroupHeader", () => $ea2b9becf55f706d$export$9c67da48344f8b9a, (v) => $ea2b9becf55f706d$export$9c67da48344f8b9a = v);
$parcel$export(module.exports, "actionGroupRadios", () => $ea2b9becf55f706d$export$90a6f280bce1c5d1, (v) => $ea2b9becf55f706d$export$90a6f280bce1c5d1 = v);
$parcel$export(module.exports, "headersColor", () => $ea2b9becf55f706d$export$7335ea925f0de853, (v) => $ea2b9becf55f706d$export$7335ea925f0de853 = v);
$parcel$export(module.exports, "modifiedAt", () => $ea2b9becf55f706d$export$8e2c99dc0786c8ea, (v) => $ea2b9becf55f706d$export$8e2c99dc0786c8ea = v);
$parcel$export(module.exports, "updatedInfoGroup", () => $ea2b9becf55f706d$export$60e028c712f447af, (v) => $ea2b9becf55f706d$export$60e028c712f447af = v);
var $ea2b9becf55f706d$export$90bccb1402e26e40;
var $ea2b9becf55f706d$export$9c67da48344f8b9a;
var $ea2b9becf55f706d$export$90a6f280bce1c5d1;
var $ea2b9becf55f706d$export$7335ea925f0de853;
var $ea2b9becf55f706d$export$8e2c99dc0786c8ea;
var $ea2b9becf55f706d$export$60e028c712f447af;
$ea2b9becf55f706d$export$90bccb1402e26e40 = `THfINa_actionGroup`;
$ea2b9becf55f706d$export$9c67da48344f8b9a = `THfINa_actionGroupHeader`;
$ea2b9becf55f706d$export$90a6f280bce1c5d1 = `THfINa_actionGroupRadios`;
$ea2b9becf55f706d$export$7335ea925f0de853 = `THfINa_headersColor`;
$ea2b9becf55f706d$export$8e2c99dc0786c8ea = `THfINa_modifiedAt`;
$ea2b9becf55f706d$export$60e028c712f447af = `THfINa_updatedInfoGroup`;

});


parcelRegister("laYef", function(module, exports) {

$parcel$export(module.exports, "default", () => $6064aa107477086e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5YsMl = parcelRequire("5YsMl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g4Vkx = parcelRequire("g4Vkx");
var $cCFSU = parcelRequire("cCFSU");
var $kQ0RL = parcelRequire("kQ0RL");

var $cVN7k = parcelRequire("cVN7k");
function $6064aa107477086e$var$DeleteErrorNotification({ dismissFlag: dismissFlag, viewName: viewName }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const title = formatMessage((0, $cVN7k.default).title);
    const description = formatMessage((0, $cVN7k.default).description, {
        viewName: viewName,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    });
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "Delete error warning",
        primaryColor: `var(--ds-icon-warning, ${(0, $g4Vkx.default).Y300})`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
        onDismissed: dismissFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        id: "delete-error-notification-flag",
        title: title,
        description: description,
        icon: icon
    }));
}
var $6064aa107477086e$export$2e2bcd8739ae039 = $6064aa107477086e$var$DeleteErrorNotification;

});
parcelRegister("cVN7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b2152788a8fab5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00b2152788a8fab5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.delete-error-notification.title",
        "defaultMessage": "Unable to delete view"
    },
    description: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.delete-error-notification.description",
        "defaultMessage": "<strong>{viewName}</strong> could not be deleted as it has been set as the default view for this plan"
    }
});

});


parcelRegister("jNofI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd3799457c8dfc6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $ib5d3 = parcelRequire("ib5d3");

var $6NoFB = parcelRequire("6NoFB");
function $0bd3799457c8dfc6$export$2e2bcd8739ae039({ viewName: viewName, onConfirm: onConfirm, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, formatMessage((0, $6NoFB.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $6NoFB.default).message, {
        name: viewName,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.delete-view-config-dialog-cancel-button"
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onConfirm,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.delete-view-config-dialog-delete-button"
    }, formatMessage((0, $ib5d3.default).delete))));
}

});
parcelRegister("6NoFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7f11f6300424f3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad7f11f6300424f3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.heading",
        "defaultMessage": "Delete saved view"
    },
    message: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.deleting-dialog.message",
        "defaultMessage": "Deleting <strong>{name}</strong> will remove it from this plan, and everyone currently using this view will no longer see it."
    }
});

});


parcelRegister("1NLvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2ae7761bce207f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $hnuwz = parcelRequire("hnuwz");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $ib5d3 = parcelRequire("ib5d3");

var $jExxQ = parcelRequire("jExxQ");

var $h62jZ = parcelRequire("h62jZ");
function $bc2ae7761bce207f$export$2e2bcd8739ae039({ onClose: onClose, onRequestDiscardChanges: onRequestDiscardChanges, onRequestSaveAs: onRequestSaveAs, viewName: viewName }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const options = [
        {
            message: (0, $jExxQ.default).saveAs,
            action: onRequestSaveAs
        },
        {
            message: (0, $jExxQ.default).discardChanges,
            action: onRequestDiscardChanges
        }
    ];
    const [selectedIndex, setSelectedIndex] = (0, $eUqFw.useState)(-1);
    const handleRadioButtonChange = (idx)=>()=>setSelectedIndex(idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $jExxQ.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $jExxQ.default).message, {
        name: viewName,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $h62jZ.actionGroup,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.not-existing-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $h62jZ.actionGroupHeader
    }, formatMessage((0, $jExxQ.default).actionGroupHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $h62jZ.actionGroupRadios
    }, options.map(({ message: message }, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            isChecked: idx === selectedIndex,
            key: idx,
            label: formatMessage(message),
            onChange: handleRadioButtonChange(idx)
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        isDisabled: selectedIndex === -1,
        onClick: options[selectedIndex] && options[selectedIndex].action,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.view-non-existing-dialog-confirm-button"
    }, formatMessage((0, $ib5d3.default).confirm))));
}

});
parcelRegister("jExxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb6edf70ce286c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdb6edf70ce286c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.heading",
        "defaultMessage": "Save deleted view"
    },
    actionGroupHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.action-group-header",
        "defaultMessage": "Do you want to:"
    },
    message: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.message",
        "defaultMessage": "<strong>{name}</strong> was deleted by someone else during your session."
    },
    saveAs: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.save-as",
        "defaultMessage": "Save as a new view"
    },
    discardChanges: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.non-existing-dialog.discard-changes",
        "defaultMessage": "Discard your changes"
    }
});

});

parcelRegister("h62jZ", function(module, exports) {

$parcel$export(module.exports, "actionGroup", () => $c724cc33741b078a$export$90bccb1402e26e40, (v) => $c724cc33741b078a$export$90bccb1402e26e40 = v);
$parcel$export(module.exports, "actionGroupHeader", () => $c724cc33741b078a$export$9c67da48344f8b9a, (v) => $c724cc33741b078a$export$9c67da48344f8b9a = v);
$parcel$export(module.exports, "actionGroupRadios", () => $c724cc33741b078a$export$90a6f280bce1c5d1, (v) => $c724cc33741b078a$export$90a6f280bce1c5d1 = v);
var $c724cc33741b078a$export$90bccb1402e26e40;
var $c724cc33741b078a$export$9c67da48344f8b9a;
var $c724cc33741b078a$export$90a6f280bce1c5d1;
$c724cc33741b078a$export$90bccb1402e26e40 = `_8w1NhG_actionGroup`;
$c724cc33741b078a$export$9c67da48344f8b9a = `_8w1NhG_actionGroupHeader`;
$c724cc33741b078a$export$90a6f280bce1c5d1 = `_8w1NhG_actionGroupRadios`;

});


parcelRegister("9TZSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3278dbe6888e811a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $aAyrO = parcelRequire("aAyrO");
var $6ETZE = parcelRequire("6ETZE");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $ib5d3 = parcelRequire("ib5d3");

var $3OlOm = parcelRequire("3OlOm");

var $jFVhu = parcelRequire("jFVhu");
const $3278dbe6888e811a$var$MAX_VIEW_NAME_LENGTH = 200;
function $3278dbe6888e811a$export$2e2bcd8739ae039({ hasDuplicateViewError: hasDuplicateViewError, isSaving: isSaving, onChange: onChange, onClose: onClose, onSubmit: onSubmit }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [name, setName] = (0, $eUqFw.useState)('');
    const [asDefault, markAsDefault] = (0, $eUqFw.useState)(false);
    const handleTitleChange = (e)=>{
        onChange();
        if (e.currentTarget instanceof HTMLInputElement) setName(e.currentTarget.value.substr(0, $3278dbe6888e811a$var$MAX_VIEW_NAME_LENGTH + 1));
    };
    const handleMarkAsDefaultChange = (e)=>{
        if (e.currentTarget instanceof HTMLInputElement) markAsDefault(e.currentTarget.checked);
    };
    const isMaximumNameLengthExceeded = name.length > $3278dbe6888e811a$var$MAX_VIEW_NAME_LENGTH;
    const errorMessage = (()=>{
        if (hasDuplicateViewError) return formatMessage((0, $3OlOm.default).duplicateView);
        if (isMaximumNameLengthExceeded) return formatMessage((0, $3OlOm.default).maximumNameLengthExceeded, {
            number: $3278dbe6888e811a$var$MAX_VIEW_NAME_LENGTH
        });
    })();
    const hasError = hasDuplicateViewError || isMaximumNameLengthExceeded;
    const submit = ()=>onSubmit({
            name: name.trim(),
            asDefault: asDefault
        });
    const canSubmit = name.trim() !== '' && !hasError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $3OlOm.default).headingCreate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $3OlOm.default).messageCreate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jFVhu.formItemWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        isRequired: true,
        label: formatMessage((0, $3OlOm.default).title),
        name: "viewName"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            autoFocus: true,
            isInvalid: hasError,
            onChange: handleTitleChange,
            placeholder: formatMessage((0, $3OlOm.default).titlePlaceholder),
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.input",
            value: name
        }), !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $3OlOm.default).titleHint)), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.error-message"
        }, errorMessage || '')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $jFVhu.formItemWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ETZE.default), {
        isChecked: asDefault,
        onChange: handleMarkAsDefaultChange,
        label: formatMessage((0, $3OlOm.default).makeDefaultCheckboxLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: `${$jFVhu.fieldHint} ${$jFVhu.checkboxHint}`
    }, formatMessage((0, $3OlOm.default).makeDefaultCheckboxHint)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.cancel-button"
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        isDisabled: !canSubmit,
        isLoading: isSaving,
        onClick: submit,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.save-button"
    }, formatMessage((0, $3OlOm.default).save))));
}

});
parcelRegister("3OlOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d3ee62d06f99164$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d3ee62d06f99164$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    headingCreate: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.heading-create",
        "defaultMessage": "Create a new view"
    },
    messageCreate: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.message-create",
        "defaultMessage": "Make a new view of your plan, and change the view settings to tell a different story. This new view will inherit the filters and settings of the currently selected view."
    },
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title",
        "defaultMessage": "Title"
    },
    titlePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title-placeholder",
        "defaultMessage": "Capacity planning"
    },
    titleHint: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.title-hint",
        "defaultMessage": "Choose a name that others will recognize"
    },
    makeDefaultCheckboxLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.make-default-checkbox-label",
        "defaultMessage": "Make default for everyone"
    },
    makeDefaultCheckboxHint: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.make-default-checkbox-hint",
        "defaultMessage": "Use as initial view for everyone"
    },
    save: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.save",
        "defaultMessage": "Save"
    },
    duplicateView: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.duplicate-view",
        "defaultMessage": "This name is already being used. Enter another name."
    },
    maximumNameLengthExceeded: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.save-as-dialog.maximum-name-length-exceeded",
        "defaultMessage": "This name exceeds {number, plural, one {# character} other {# characters}}"
    }
});

});

parcelRegister("jFVhu", function(module, exports) {

$parcel$export(module.exports, "checkboxHint", () => $e52e477c823eefaf$export$1ca662024e10e76a, (v) => $e52e477c823eefaf$export$1ca662024e10e76a = v);
$parcel$export(module.exports, "fieldHint", () => $e52e477c823eefaf$export$6963c9681059ce1e, (v) => $e52e477c823eefaf$export$6963c9681059ce1e = v);
$parcel$export(module.exports, "formItemWrapper", () => $e52e477c823eefaf$export$d5ee42b7cad50777, (v) => $e52e477c823eefaf$export$d5ee42b7cad50777 = v);
var $e52e477c823eefaf$export$1ca662024e10e76a;
var $e52e477c823eefaf$export$6963c9681059ce1e;
var $e52e477c823eefaf$export$48db87e3f4768880;
var $e52e477c823eefaf$export$d5ee42b7cad50777;
$e52e477c823eefaf$export$1ca662024e10e76a = `OuAaVW_checkboxHint`;
$e52e477c823eefaf$export$6963c9681059ce1e = `OuAaVW_fieldHint`;
$e52e477c823eefaf$export$48db87e3f4768880 = `OuAaVW_fieldLabel`;
$e52e477c823eefaf$export$d5ee42b7cad50777 = `OuAaVW_formItemWrapper`;

});


parcelRegister("3PNta", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fea16d40683aef3$export$2e2bcd8739ae039);

var $3G4g4 = parcelRequire("3G4g4");
var $0fea16d40683aef3$export$2e2bcd8739ae039 = (0, $3G4g4.default);

});
parcelRegister("3G4g4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb76f668da5912e5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");
var $3by2Y = parcelRequire("3by2Y");
var $f7Op5 = parcelRequire("f7Op5");
var $eWC3M = parcelRequire("eWC3M");

var $86Ndv = parcelRequire("86Ndv");

var $23NQ5 = parcelRequire("23NQ5");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
var $1WecH = parcelRequire("1WecH");
var $ffiyv = parcelRequire("ffiyv");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $gwbfD = parcelRequire("gwbfD");


var $NeuAT = parcelRequire("NeuAT");
parcelRequire("2Bjja");
var $ffzME = parcelRequire("ffzME");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hjY2n = parcelRequire("hjY2n");

var $kInjb = parcelRequire("kInjb");

var $6DE5z = parcelRequire("6DE5z");

var $lFLge = parcelRequire("lFLge");

var $kJlBc = parcelRequire("kJlBc");

var $1v9w8 = parcelRequire("1v9w8");

var $lkUkY = parcelRequire("lkUkY");
/**
 * Map the old default view names to new name with "view" suffix
 */ const $bb76f668da5912e5$var$updateViewName = (view)=>{
    if ((0, $1ybV0.ff)('com.atlassian.jpo.rm.update-preset-names')) return (0, $kInjb.getMigratedPresetViewName)(view);
    const viewName = view.name;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const viewKeys = Object.keys((0, $6DE5z.PRESET_VIEWS_NAMES_V1));
    const key = viewKeys.find(// eslint-disable-next-line @typescript-eslint/no-shadow
    (key)=>(0, $6DE5z.PRESET_VIEWS_NAMES_V1)[key] === viewName);
    if (key && (0, $6DE5z.PRESET_VIEWS_NAMES_V2)[key]) return (0, $6DE5z.PRESET_VIEWS_NAMES_V2)[key];
    return viewName;
};
function $bb76f668da5912e5$var$MenuItemLabel({ view: view }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lkUkY.viewName
    }, view.id !== (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28) ? $bb76f668da5912e5$var$updateViewName(view) : formatMessage((0, $1v9w8.default).untitled)));
}
const $bb76f668da5912e5$var$TriggerEl = ({ views: views, activeViewName: activeViewName = '', elemAfter: elemAfter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ($b3iuB.default(views)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $1v9w8.default).savedViews));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: activeViewName,
        position: "top",
        delay: 500
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $lkUkY.view
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lkUkY.viewName
    }, activeViewName), " ", elemAfter)));
};
function $bb76f668da5912e5$var$ModifiedView({ activeViewName: activeViewName, onRequestSave: onRequestSave, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges, onRequestDelete: onRequestDelete, isReadOnly: isReadOnly, isDraft: isDraft }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!activeViewName) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        component: "div",
        isSelected: true,
        description: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $lkUkY.modifiedViewActions
        }, isReadOnly ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            appearance: "link",
            onClick: isDraft ? onRequestSaveAs : onRequestSave,
            testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.save-current-view"
        }, formatMessage((0, $1v9w8.default).saveChanges)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $lkUkY.actionSeparator
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            appearance: "link",
            onClick: isDraft ? onRequestDelete : onRequestDiscardChanges
        }, formatMessage(isDraft ? (0, $1v9w8.default).delete : (0, $1v9w8.default).reset))),
        elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $lkUkY.lozengeContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, isDraft ? formatMessage((0, $1v9w8.default).draft) : formatMessage((0, $1v9w8.default).edited)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $lkUkY.modifiedViewName
    }, activeViewName));
}
function $bb76f668da5912e5$var$SavedViewSwitcher({ onRequestSave: onRequestSave, onRequestSaveAs: onRequestSaveAs, onRequestDiscardChanges: onRequestDiscardChanges, onRequestViewChange: onRequestViewChange, onRequestDelete: onRequestDelete, views: views, isReadOnly: isReadOnly, defaultOpen: defaultOpen = false, buttonRef: buttonRef }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const openInProductHelp = (0, $3QLcd.useHelpPanelLink)();
    const activeView = views.find($f7Op5.default('active'));
    const activeViewName = (0, $7CnHa.isDefined)(activeView) && activeView.id !== (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28) ? $bb76f668da5912e5$var$updateViewName(activeView) : formatMessage((0, $1v9w8.default).untitled);
    if (!$b3iuB.default(views) && !activeView) throw new Error('active view not found');
    const renderViewItemsList = ()=>{
        // displaying a skeleton list when waiting for the views to be ready
        if ($b3iuB.default(views)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.skeleton",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $lkUkY.viewsListSkeleton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WecH.default), {
            numOfRows: 5,
            rowHeight: 32,
            spaceInBetween: 8
        }));
        // reordering the views to put the active view first
        const reorderedViews = $eWC3M.default($3by2Y.default($f7Op5.default('active'), views));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $lkUkY.viewsList
        }, reorderedViews.map((view, index)=>{
            // this is used to set a different background-color on the view item (only when on the backlog view)
            const isActiveViewSelected = !view.modified && index === 0;
            const isActiveViewModified = view.modified && index === 0;
            if (isActiveViewModified) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
                isSelected: isActiveViewSelected,
                key: view.id,
                onClick: (e)=>{
                    onRequestViewChange(e, view.id);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb76f668da5912e5$var$MenuItemLabel, {
                view: view
            }));
        })));
    };
    const onClickManageViews = ()=>{
        const planId = (0, $NeuAT.getPlanId)();
        const scenarioId = (0, $NeuAT.getScenarioId)();
        if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) push((0, $lFLge.buildManageViewsPath)(planId, scenarioId));
    };
    const onClickLearnMore = ()=>openInProductHelp?.((0, $5rYNM.IPH_IDS).SAVED_VIEWS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.button",
        ref: buttonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.dropdown-menu",
        defaultOpen: defaultOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ref: triggerRef,
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffzME.default), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $lkUkY.viewTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb76f668da5912e5$var$TriggerEl, {
                views: views,
                activeViewName: activeViewName,
                elemAfter: activeView?.modified ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $lkUkY.activeLozengeContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, activeView.id === (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28) ? formatMessage((0, $1v9w8.default).draft) : formatMessage((0, $1v9w8.default).edited))) : null
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: formatMessage((0, $1v9w8.default).savedViews)
    }, activeView?.modified && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bb76f668da5912e5$var$ModifiedView, {
        onRequestSave: onRequestSave,
        onRequestSaveAs: onRequestSaveAs,
        activeViewName: activeViewName,
        onRequestDiscardChanges: onRequestDiscardChanges,
        onRequestDelete: onRequestDelete,
        isReadOnly: isReadOnly,
        isDraft: activeView.id === (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28)
    }), renderViewItemsList()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: onClickLearnMore
    }, formatMessage((0, $1v9w8.default).iphLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            label: ""
        }),
        href: (0, $hjY2n.default).viewSwitching,
        target: "_blank"
    }, formatMessage((0, $1v9w8.default).learnMore))), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: onClickManageViews
    }, formatMessage((0, $1v9w8.default).manageViews)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        onClick: onRequestSaveAs
    }, formatMessage((0, $1v9w8.default).createANewView)))));
}
var $bb76f668da5912e5$export$2e2bcd8739ae039 = $bb76f668da5912e5$var$SavedViewSwitcher;

});
parcelRegister("eWC3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae14015ec7c4f4af$export$2e2bcd8739ae039);

var $1kIfb = parcelRequire("1kIfb");

var $hC4q3 = parcelRequire("hC4q3");
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $ae14015ec7c4f4af$var$unnest = /*#__PURE__*/ (0, $hC4q3.default)((0, $1kIfb.default));
var $ae14015ec7c4f4af$export$2e2bcd8739ae039 = $ae14015ec7c4f4af$var$unnest;

});

parcelRegister("1v9w8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5337ccb385422155$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5337ccb385422155$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createANewView: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.create-a-new-view",
        "defaultMessage": "Create a new view"
    },
    draft: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.draft",
        "defaultMessage": "draft"
    },
    edited: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.edited",
        "defaultMessage": "edited"
    },
    manageViews: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.manage-views",
        "defaultMessage": "Manage saved views"
    },
    reset: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.reset",
        "defaultMessage": "Reset"
    },
    delete: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.delete",
        "defaultMessage": "Delete"
    },
    saveChanges: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.save-changes",
        "defaultMessage": "Save"
    },
    savedViews: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.saved-views",
        "defaultMessage": "Saved views"
    },
    untitled: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.untitled",
        "defaultMessage": "Untitled"
    },
    learnMore: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.learn-more",
        "defaultMessage": "Learn more about saved views"
    },
    iphLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saved-view-switcher.iph-link",
        "defaultMessage": "Read more about saved views"
    }
});

});

parcelRegister("lkUkY", function(module, exports) {

$parcel$export(module.exports, "actionSeparator", () => $f8872aa4b18a633e$export$7927c1cdebe68d43, (v) => $f8872aa4b18a633e$export$7927c1cdebe68d43 = v);
$parcel$export(module.exports, "activeLozengeContainer", () => $f8872aa4b18a633e$export$d9bc97eff0df9d6c, (v) => $f8872aa4b18a633e$export$d9bc97eff0df9d6c = v);
$parcel$export(module.exports, "lozengeContainer", () => $f8872aa4b18a633e$export$eb4875e6806aa5a, (v) => $f8872aa4b18a633e$export$eb4875e6806aa5a = v);
$parcel$export(module.exports, "modifiedViewActions", () => $f8872aa4b18a633e$export$6a9188a55c849b46, (v) => $f8872aa4b18a633e$export$6a9188a55c849b46 = v);
$parcel$export(module.exports, "modifiedViewName", () => $f8872aa4b18a633e$export$4975e08bd497572f, (v) => $f8872aa4b18a633e$export$4975e08bd497572f = v);
$parcel$export(module.exports, "view", () => $f8872aa4b18a633e$export$c4ddc81c7b2c8d7a, (v) => $f8872aa4b18a633e$export$c4ddc81c7b2c8d7a = v);
$parcel$export(module.exports, "viewName", () => $f8872aa4b18a633e$export$560239d3315fb15a, (v) => $f8872aa4b18a633e$export$560239d3315fb15a = v);
$parcel$export(module.exports, "viewTrigger", () => $f8872aa4b18a633e$export$164f82e58a010d8e, (v) => $f8872aa4b18a633e$export$164f82e58a010d8e = v);
$parcel$export(module.exports, "viewsList", () => $f8872aa4b18a633e$export$59a28b0ab50de038, (v) => $f8872aa4b18a633e$export$59a28b0ab50de038 = v);
$parcel$export(module.exports, "viewsListSkeleton", () => $f8872aa4b18a633e$export$d9a879e41895b0d8, (v) => $f8872aa4b18a633e$export$d9a879e41895b0d8 = v);
var $f8872aa4b18a633e$export$7927c1cdebe68d43;
var $f8872aa4b18a633e$export$d9bc97eff0df9d6c;
var $f8872aa4b18a633e$export$eb4875e6806aa5a;
var $f8872aa4b18a633e$export$6a9188a55c849b46;
var $f8872aa4b18a633e$export$4975e08bd497572f;
var $f8872aa4b18a633e$export$c4ddc81c7b2c8d7a;
var $f8872aa4b18a633e$export$560239d3315fb15a;
var $f8872aa4b18a633e$export$164f82e58a010d8e;
var $f8872aa4b18a633e$export$59a28b0ab50de038;
var $f8872aa4b18a633e$export$d9a879e41895b0d8;
$f8872aa4b18a633e$export$7927c1cdebe68d43 = `FM3apa_actionSeparator`;
$f8872aa4b18a633e$export$d9bc97eff0df9d6c = `FM3apa_activeLozengeContainer`;
$f8872aa4b18a633e$export$eb4875e6806aa5a = `FM3apa_lozengeContainer`;
$f8872aa4b18a633e$export$6a9188a55c849b46 = `FM3apa_modifiedViewActions`;
$f8872aa4b18a633e$export$4975e08bd497572f = `FM3apa_modifiedViewName`;
$f8872aa4b18a633e$export$c4ddc81c7b2c8d7a = `FM3apa_view`;
$f8872aa4b18a633e$export$560239d3315fb15a = `FM3apa_viewName`;
$f8872aa4b18a633e$export$164f82e58a010d8e = `FM3apa_viewTrigger`;
$f8872aa4b18a633e$export$59a28b0ab50de038 = `FM3apa_viewsList`;
$f8872aa4b18a633e$export$d9a879e41895b0d8 = `FM3apa_viewsListSkeleton`;

});



parcelRegister("GyNCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $49bd826b3e5c9aa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $ib5d3 = parcelRequire("ib5d3");

var $j8oYu = parcelRequire("j8oYu");
function $49bd826b3e5c9aa7$var$SavingDialog({ viewName: viewName, onConfirm: onConfirm, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        shouldScrollInViewport: true,
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $j8oYu.default).heading, {
        viewName: viewName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $j8oYu.default).message, {
        viewName: viewName,
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onConfirm,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.view-save-changes-save-button"
    }, formatMessage((0, $ib5d3.default).save))));
}
var $49bd826b3e5c9aa7$export$2e2bcd8739ae039 = $49bd826b3e5c9aa7$var$SavingDialog;

});
parcelRegister("j8oYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d71eeeeb0eb4d1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $63d71eeeeb0eb4d1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.heading",
        "defaultMessage": "Save changes to {viewName}"
    },
    message: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.saving-dialog.message",
        "defaultMessage": "Everyone who uses <strong>{viewName}</strong> to view this plan will see your changes. Are you sure you want to continue?"
    }
});

});




parcelRegister("jGytv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1017506c471075$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cq70r = parcelRequire("cq70r");

var $eeXmI = parcelRequire("eeXmI");

var $k1zvS = parcelRequire("k1zvS");
var $6c1017506c471075$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $eeXmI.default), (0, $cq70r.default))((0, $k1zvS.default));

});
parcelRegister("cq70r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a4db50112bb5b93$export$2e2bcd8739ae039);

var $1XIAV = parcelRequire("1XIAV");

var $iX8wj = parcelRequire("iX8wj");
const $7a4db50112bb5b93$var$mapDispatchToProps = (dispatch)=>({
        expandHierarchy: ()=>{
            dispatch((0, $1XIAV.expandIssueWithAncestors)());
        },
        searchIconClick: ()=>{
            dispatch((0, $iX8wj.searchIconClick)());
        },
        setActiveSearchResultIndex: (payload)=>{
            dispatch((0, $iX8wj.setActiveSearchResultIndex)(payload));
        },
        setSearchQuery: (query)=>{
            dispatch((0, $iX8wj.setSearchQuery)(query));
        },
        startedSearchResultNavigation: ()=>{
            dispatch((0, $iX8wj.startedSearchResultNavigation)());
        },
        toggleIssueSearch: (isOpen)=>{
            dispatch((0, $iX8wj.toggleIssueSearch)(isOpen));
        }
    });
var $7a4db50112bb5b93$export$2e2bcd8739ae039 = $7a4db50112bb5b93$var$mapDispatchToProps;

});

parcelRegister("eeXmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5b714c59b76d16$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var $7f5b714c59b76d16$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    searchQuery: (0, $40hi6.getSearchQuery),
    issueSearchResults: (0, $40hi6.searchForIssues),
    activeSearchResultIndex: (0, $40hi6.getActiveSearchResultIndex),
    isConfluenceMacro: $akhOi.isConfluenceMacro,
    isEmbed: $akhOi.isEmbed
});

});

parcelRegister("k1zvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7481446ac3cf3b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

var $hjlb6 = parcelRequire("hjlb6");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $5k4ch = parcelRequire("5k4ch");

var $dsroq = parcelRequire("dsroq");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $g4Vkx = parcelRequire("g4Vkx");
var $5CV7v = parcelRequire("5CV7v");

var $432rh = parcelRequire("432rh");

var $3n8aE = parcelRequire("3n8aE");

var $8Ui86 = parcelRequire("8Ui86");

var $2WrTq = parcelRequire("2WrTq");

var $geQIa = parcelRequire("geQIa");

var $dMwRK = parcelRequire("dMwRK");
const $d7481446ac3cf3b4$var$SearchSummary = ({ searchQuery: searchQuery, totalResults: totalResults, onDismiss: onDismiss, activeSearchResultIndex: activeSearchResultIndex, navigateResults: navigateResults })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasSearchQuery = searchQuery.trim() !== '';
    const displayedActiveIndex = activeSearchResultIndex + 1;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dMwRK.searchSummaryContainer
    }, hasSearchQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $dMwRK.summaryCount
    }, Math.min(displayedActiveIndex, totalResults), "/", totalResults), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($dMwRK.iconWrapper, {
            [$dMwRK.disabled]: totalResults === 0 || displayedActiveIndex === 1
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
        onClick: ()=>navigateResults('up'),
        ariaLabel: formatMessage((0, $geQIa.default).viewPreviousSearchDataArialabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
        label: "",
        primaryColor: `var(--ds-text-subtlest, ${(0, $g4Vkx.default).N90})`
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($dMwRK.iconWrapper, {
            [$dMwRK.disabled]: totalResults === 0 || displayedActiveIndex === totalResults
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
        onClick: ()=>navigateResults('down'),
        ariaLabel: formatMessage((0, $geQIa.default).viewNextSearchDataArialabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "",
        primaryColor: `var(--ds-text-subtlest, ${(0, $g4Vkx.default).N90})`
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $dMwRK.iconWrapper,
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.input-close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
        onClick: onDismiss,
        ariaLabel: formatMessage((0, $geQIa.default).clearSearchDataArialabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        label: "",
        size: "small",
        primaryColor: `var(--ds-text-subtle, ${(0, $g4Vkx.default).N70})`
    })))));
};
const $d7481446ac3cf3b4$var$Search = ({ searchQuery: searchQuery, setSearchQuery: setSearchQuery, issueSearchResults: { total: total }, searchIconClick: searchIconClick, startedSearchResultNavigation: startedSearchResultNavigation, setActiveSearchResultIndex: setActiveSearchResultIndex, activeSearchResultIndex: activeSearchResultIndex, expandHierarchy: expandHierarchy, IssueSearchWarningFlagComponent: IssueSearchWarningFlagComponent = (0, $2WrTq.default), toggleIssueSearch: toggleIssueSearch, isConfluenceMacro: isConfluenceMacro, isEmbed: isEmbed })=>{
    const [searchString, setSearchString] = (0, $eUqFw.useState)(searchQuery);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const closeSearchIfEmpty = ()=>{
        if (searchQuery.trim() === '') toggleIssueSearch(false);
    };
    const [isTouched, setIsTouched] = (0, $eUqFw.useState)(false);
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const isSearchBoxEmpty = searchString.trim() === '';
    const closeSearchbar = ()=>{
        setSearchString('');
        toggleIssueSearch(false);
        searchInputRef.current && searchInputRef.current.blur();
    };
    const focusSearchInput = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(searchInputRef.current)) // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.js
        setTimeout(()=>searchInputRef.current && searchInputRef.current.focus(), 0);
    };
    const navigateResults = (direction)=>{
        // the analytics are triggered only when the user starts to browse through the matches
        if (!isTouched) {
            setIsTouched(true);
            startedSearchResultNavigation();
        }
        const nextIndex = direction === 'up' ? Math.max(0, activeSearchResultIndex - 1) : Math.min(activeSearchResultIndex + 1, total - 1);
        setActiveSearchResultIndex(nextIndex);
        expandHierarchy();
    };
    const handleKeyPress = (e)=>{
        const { key: key, shiftKey: shiftKey } = e;
        if (key === 'Escape') closeSearchbar();
        else if (key === 'ArrowUp' || key === 'Enter' && shiftKey) navigateResults('up');
        else if (key === 'ArrowDown' || key === 'Enter') navigateResults('down');
    };
    const searchQueryChange = (0, $eUqFw.useCallback)((query)=>{
        setSearchQuery(query);
        setActiveSearchResultIndex(0);
        expandHierarchy();
    }, [
        expandHierarchy,
        setActiveSearchResultIndex,
        setSearchQuery
    ]);
    const debouncedSearchQueryChange = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(searchQueryChange, 300), [
        searchQueryChange
    ]);
    (0, $eUqFw.useEffect)(()=>{
        debouncedSearchQueryChange(searchString);
    }, [
        debouncedSearchQueryChange,
        searchString
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setSearchString(searchQuery);
    }, [
        searchQuery
    ]);
    const searchBox = (0, $eUqFw.useRef)(null);
    (0, $3n8aE.useOnClickOutside)(searchBox, ()=>closeSearchIfEmpty());
    const elemAfterInput = isSearchBoxEmpty ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dMwRK.searchIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        label: " ",
        size: "small",
        primaryColor: `var(--ds-text-subtlest, ${(0, $g4Vkx.default).N90})`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7481446ac3cf3b4$var$SearchSummary, {
        searchQuery: searchString,
        onDismiss: ()=>closeSearchbar(),
        totalResults: total,
        activeSearchResultIndex: activeSearchResultIndex,
        navigateResults: navigateResults
    });
    const renderCustomSearchField = ({ textFieldProps: textFieldProps })=>{
        const textField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...textFieldProps,
            elemAfterInput: elemAfterInput,
            isCompact: true,
            onKeyDown: (e)=>{
                handleKeyPress(e);
            }
        });
        return textField;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.page-header.search",
        ref: searchBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $432rh.default), {
        onFocusSearch: ()=>{
            toggleIssueSearch(true);
            searchIconClick();
            focusSearchInput();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueSearchWarningFlagComponent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        maxLength: 255,
        onChange: (e)=>{
            toggleIssueSearch(true);
            setSearchString(e);
            searchIconClick();
        },
        value: searchString,
        ariaLabelText: formatMessage((0, $geQIa.default).searchFieldAriaLabel),
        placeholder: formatMessage((0, $geQIa.default).searchPlaceholder),
        inputRef: searchInputRef,
        renderCustomSearchField: renderCustomSearchField,
        isAutocompleteDisabled: isConfluenceMacro || isEmbed
    }));
};
var $d7481446ac3cf3b4$export$2e2bcd8739ae039 = $d7481446ac3cf3b4$var$Search;

});
parcelRegister("432rh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb249aea98dfdf7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cmc0m = parcelRequire("cmc0m");

var $j4LwV = parcelRequire("j4LwV");
const $3eb249aea98dfdf7$var$HijackBrowserSearch = ({ onFocusSearch: onFocusSearch })=>{
    const onGlobalSearch = (0, $eUqFw.useCallback)(({ event: event })=>{
        event.preventDefault();
        onFocusSearch();
    }, [
        onFocusSearch
    ]);
    (0, $cmc0m.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $3eb249aea98dfdf7$export$2e2bcd8739ae039 = $3eb249aea98dfdf7$var$HijackBrowserSearch;

});
parcelRegister("cmc0m", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $cda4b48a66b8cbd6$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $cda4b48a66b8cbd6$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $cda4b48a66b8cbd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $cda4b48a66b8cbd6$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $cda4b48a66b8cbd6$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $eUqFw.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $cda4b48a66b8cbd6$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $cda4b48a66b8cbd6$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $jMP2a.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onGlobalSearch = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $cda4b48a66b8cbd6$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $cda4b48a66b8cbd6$export$2e2bcd8739ae039 = $cda4b48a66b8cbd6$var$GlobalSearchTracker;

});


parcelRegister("3n8aE", function(module, exports) {

$parcel$export(module.exports, "useOnClickOutside", () => $344e70d1e6095313$export$9afc64c180e82dc4);

var $eUqFw = parcelRequire("eUqFw");
function $344e70d1e6095313$export$9afc64c180e82dc4(ref, handler) {
    (0, $eUqFw.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || event.target instanceof Node && ref.current.contains(event.target)) return;
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        return ()=>{
            document.removeEventListener('mousedown', listener);
        };
    }, [
        ref,
        handler
    ]);
}

});

parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $babBw = parcelRequire("babBw");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder,
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemAfterInput: searchIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        size: "small",
        label: "",
        primaryColor: primaryColor
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            size: "small",
            label: clearIconLabel,
            primaryColor: primaryColor
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});

});


parcelRegister("2WrTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edb65d7184c57c3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3nvW2 = parcelRequire("3nvW2");

var $bTfFy = parcelRequire("bTfFy");

var $9YT1F = parcelRequire("9YT1F");
var $7edb65d7184c57c3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $bTfFy.default), (0, $3nvW2.default))((0, $9YT1F.default));

});
parcelRegister("3nvW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7405e041b50281$export$2e2bcd8739ae039);

var $9ozqH = parcelRequire("9ozqH");
const $cc7405e041b50281$var$mapDispatchToProps = {
    onAddFlag: (0, $9ozqH.addFlag),
    onRemoveFlag: (0, $9ozqH.removeFlag)
};
var $cc7405e041b50281$export$2e2bcd8739ae039 = $cc7405e041b50281$var$mapDispatchToProps;

});

parcelRegister("bTfFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $48541bcd19ca3482$export$2e2bcd8739ae039);

var $40hi6 = parcelRequire("40hi6");

var $iK4oF = parcelRequire("iK4oF");
var $48541bcd19ca3482$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    issueSearchResults: (0, $40hi6.searchForIssues)
});

});

parcelRegister("9YT1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c9d9b380304e35$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("1nPPv");
const $c9c9d9b380304e35$var$IssueSearchWarningFlag = ({ issueSearchResults: { resultsHiddenByFilter: resultsHiddenByFilter }, onAddFlag: onAddFlag, onRemoveFlag: onRemoveFlag })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (resultsHiddenByFilter.length > 0) onAddFlag({
            key: (0, $42b69a8aa6898c13$export$225669431bad5551)
        });
        else if (resultsHiddenByFilter.length === 0) onRemoveFlag({
            key: (0, $42b69a8aa6898c13$export$225669431bad5551)
        });
    }, [
        resultsHiddenByFilter,
        onAddFlag,
        onRemoveFlag
    ]);
    return null;
};
var $c9c9d9b380304e35$export$2e2bcd8739ae039 = $c9c9d9b380304e35$var$IssueSearchWarningFlag;

});


parcelRegister("geQIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a21eefd17aa0f52$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a21eefd17aa0f52$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-placeholder",
        "defaultMessage": "Search"
    },
    searchFieldAriaLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.search-field-aria-label",
        "defaultMessage": "Find Issue"
    },
    viewPreviousSearchDataArialabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.view-previous-search-data-arialabel",
        "defaultMessage": "View previous search data"
    },
    viewNextSearchDataArialabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.view-next-search-data-arialabel",
        "defaultMessage": "View next search data"
    },
    clearSearchDataArialabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.search.clear-search-data-arialabel",
        "defaultMessage": "Clear search data"
    }
});

});

parcelRegister("dMwRK", function(module, exports) {

$parcel$export(module.exports, "disabled", () => $a089408989889999$export$683472f6198a076e, (v) => $a089408989889999$export$683472f6198a076e = v);
$parcel$export(module.exports, "iconWrapper", () => $a089408989889999$export$38e6d710c8ae6ec3, (v) => $a089408989889999$export$38e6d710c8ae6ec3 = v);
$parcel$export(module.exports, "searchIconWrapper", () => $a089408989889999$export$908581d7efaaac0d, (v) => $a089408989889999$export$908581d7efaaac0d = v);
$parcel$export(module.exports, "searchSummaryContainer", () => $a089408989889999$export$6e9fe1cbf67e5c6, (v) => $a089408989889999$export$6e9fe1cbf67e5c6 = v);
$parcel$export(module.exports, "summaryCount", () => $a089408989889999$export$9d29bafa0761180, (v) => $a089408989889999$export$9d29bafa0761180 = v);
var $a089408989889999$export$683472f6198a076e;
var $a089408989889999$export$38e6d710c8ae6ec3;
var $a089408989889999$export$908581d7efaaac0d;
var $a089408989889999$export$6e9fe1cbf67e5c6;
var $a089408989889999$export$9d29bafa0761180;
$a089408989889999$export$683472f6198a076e = `QjmutW_disabled`;
$a089408989889999$export$38e6d710c8ae6ec3 = `QjmutW_iconWrapper`;
$a089408989889999$export$908581d7efaaac0d = `QjmutW_searchIconWrapper`;
$a089408989889999$export$6e9fe1cbf67e5c6 = `QjmutW_searchSummaryContainer`;
$a089408989889999$export$9d29bafa0761180 = `QjmutW_summaryCount`;

});



parcelRegister("gZhAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a943522350e71cfd$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $y3NqW = parcelRequire("y3NqW");

var $03fdL = parcelRequire("03fdL");

var $hWsn0 = parcelRequire("hWsn0");
var $a943522350e71cfd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $03fdL.default), (0, $y3NqW.default))((0, $hWsn0.ViewModeSwitcher));

});
parcelRegister("y3NqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $87229f6936bcce42$export$2e2bcd8739ae039);

var $2iNiW = parcelRequire("2iNiW");
const $87229f6936bcce42$var$mapDispatchToProps = {
    changeViewMode: $2iNiW.changeViewMode
};
var $87229f6936bcce42$export$2e2bcd8739ae039 = $87229f6936bcce42$var$mapDispatchToProps;

});

parcelRegister("03fdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e4e643504c65d44$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");
const $5e4e643504c65d44$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $9H2AP.getViewMode)
});
var $5e4e643504c65d44$export$2e2bcd8739ae039 = $5e4e643504c65d44$var$mapStateToProps;

});

parcelRegister("hWsn0", function(module, exports) {

$parcel$export(module.exports, "ViewModeSwitcher", () => $0590cf6e9c5d2b52$export$d5ac5813985c55c6);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lcvrv = parcelRequire("lcvrv");

var $dw8TK = parcelRequire("dw8TK");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $idWR0 = parcelRequire("idWR0");

var $fa2D3 = parcelRequire("fa2D3");

var $dTgOe = parcelRequire("dTgOe");
const $0590cf6e9c5d2b52$export$d5ac5813985c55c6 = ({ mode: mode, changeViewMode: changeViewMode })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tracePress = (0, $fa2D3.default)('arj-toggle-view-mode');
    const testIdPrefix = 'portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.toggle-button.';
    const options = [
        {
            id: (0, $lcvrv.VIEW_MODES).TIMELINE,
            label: formatMessage((0, $ib5d3.default).timeline),
            testId: `${testIdPrefix}${(0, $lcvrv.VIEW_MODES).TIMELINE}`
        },
        {
            id: (0, $lcvrv.VIEW_MODES).LIST,
            label: formatMessage((0, $dTgOe.default).listOptionLabel),
            testId: `${testIdPrefix}${(0, $lcvrv.VIEW_MODES).LIST}`
        }
    ];
    const onChange = (0, $eUqFw.useCallback)((viewMode, event)=>{
        tracePress(event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewMode', {
            viewMode: viewMode
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        changeViewMode(viewMode);
    }, [
        tracePress,
        changeViewMode,
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        tracePress(event.timeStamp);
        const viewMode = mode === (0, $lcvrv.VIEW_MODES).TIMELINE ? (0, $lcvrv.VIEW_MODES).LIST : (0, $lcvrv.VIEW_MODES).TIMELINE;
        changeViewMode(viewMode);
    }, [
        tracePress,
        changeViewMode,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dw8TK.UseShortcuts), {
        shortcutKey: "KeyL",
        onKeyDown: onKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idWR0.default), {
        label: formatMessage((0, $dTgOe.default).toggleButtonsLabel),
        options: options,
        selectedOption: mode,
        onChange: onChange
    }));
};

});
parcelRegister("idWR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $73632070bf5ddd84$export$2e2bcd8739ae039);

var $xXn1D = parcelRequire("xXn1D");
var $73632070bf5ddd84$export$2e2bcd8739ae039 = (0, $xXn1D.default);

});
parcelRegister("xXn1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce949e0e35a7fdf$export$2e2bcd8739ae039);

var $gDOUU = parcelRequire("gDOUU");
var $9ce949e0e35a7fdf$export$2e2bcd8739ae039 = (0, $gDOUU.default);

});
parcelRegister("gDOUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $824aba1f17e001b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");

var $3zbnM = parcelRequire("3zbnM");

var $3jcOX = parcelRequire("3jcOX");
let $824aba1f17e001b2$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$824aba1f17e001b2$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $3jcOX.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $3jcOX.assertPrecondition)(()=>({
            precondition: (0, $3jcOX.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $3jcOX.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $3jcOX.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eUqFw.useState)(()=>`toggle-buttons-${$824aba1f17e001b2$var$uniqueId++}`);
    const fieldsetRef = (0, $eUqFw.useRef)(null);
    const selectedOptionRef = (0, $eUqFw.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($824aba1f17e001b2$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zbnM.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $824aba1f17e001b2$var$selectedOptionIndicator = {
    backgroundColor: `${`var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N0})`} !important`,
    borderRadius: `${(0, $c9TLT.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $824aba1f17e001b2$var$Fieldset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhk1s4m _2rko1l7b _1yt41b66 _1wyb1crf _vwz41clk _1p1dangw _k48pni7l _syazaj1x _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _1rus1tag _rfx31wa3 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_15e91tag _1ph31wa3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3zbnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ba5ec87b79062c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
var $d0ba5ec87b79062c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ba5ec87b79062c$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ba5ec87b79062c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11127mnp _1q091wmp _pytkt94y _5hv9t94y _2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _khufstnw _15pj1ule _136ejjoz _1vzltlke _1ioh1l7b _1hhy73ad _1emz73ad _1efl8q0r _7el91vt6 _15pqglyw _vrjh14ae _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3jcOX", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $62ff6afe47e09810$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $62ff6afe47e09810$export$5565eefbe4b468a0);
const $62ff6afe47e09810$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $62ff6afe47e09810$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});




parcelRegister("dTgOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $baeaefc5125ca8ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $baeaefc5125ca8ac$var$messages = (0, $90IgZ.defineMessages)({
    toggleButtonsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.toggle-buttons-label",
        "defaultMessage": "Select view mode"
    },
    listOptionLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.view-mode-switcher.list-option-label",
        "defaultMessage": "List"
    }
});
var $baeaefc5125ca8ac$export$2e2bcd8739ae039 = $baeaefc5125ca8ac$var$messages;

});





parcelRegister("9l42x", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $11efd9bae01a7416$export$53f1cd6809577fc5);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bm5l8 = parcelRequire("bm5l8");
var $asKFY = parcelRequire("asKFY");

var $3a8wJ = parcelRequire("3a8wJ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");
parcelRequire("akhOi");

var $6gsf3 = parcelRequire("6gsf3");

var $3vYcn = parcelRequire("3vYcn");
const $11efd9bae01a7416$export$53f1cd6809577fc5 = ({ mode: mode, title: title, actions: actions, titleDecorators: titleDecorators, plan: plan, showPlanTitle: showPlanTitle = false, isReadOnly: isReadOnly = false, isArchived: isArchived = false, withBreadcrumbs: withBreadcrumbs = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6gsf3.default), null);
    const { id: id, scenarios: scenarios, currentScenarioId: currentScenarioId, title: planTitle, multiScenarioEnabled: multiScenarioEnabled } = plan;
    const scenarioTitle = scenarios && scenarios.find((s)=>s.id === currentScenarioId)?.title || '';
    const getTitle = ()=>{
        if (showPlanTitle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, planTitle, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, " / ", title));
        return title;
    };
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $asKFY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        text: formatMessage((0, $3vYcn.default).breadcrumbTitle),
        href: "/jira/plans/"
    }), planTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        truncationWidth: 300,
        text: `${planTitle}`,
        href: `/jira/plans/${id}/`
    }), multiScenarioEnabled && scenarioTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm5l8.default), {
        truncationWidth: 300,
        text: `${scenarioTitle}`,
        href: `/jira/plans/${id}/scenarios/${currentScenarioId}/timeline`
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        disableTitleStyles: true,
        truncateTitle: true,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11efd9bae01a7416$var$FiltersContainer, null, actions),
        breadcrumbs: withBreadcrumbs ? breadcrumbs : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11efd9bae01a7416$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11efd9bae01a7416$var$Heading, null, getTitle()), isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        isBold: true
    }, formatMessage((0, $3vYcn.default).readOnly)), isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        isBold: true
    }, formatMessage((0, $3vYcn.default).archived)), titleDecorators)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11efd9bae01a7416$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _vwz4xy5q _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _1bto1l2s _o5721q9c _1wyb1tcg _k48p1wq8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11efd9bae01a7416$var$TitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11efd9bae01a7416$var$FiltersContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _o5724jg8 _zulp1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6gsf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1520381ca7a7ca49$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $6wp9u = parcelRequire("6wp9u");

var $6Npxa = parcelRequire("6Npxa");

var $5wON8 = parcelRequire("5wON8");
var $1520381ca7a7ca49$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $6Npxa.default), (0, $6wp9u.default))((0, $5wON8.default));

});
parcelRegister("6wp9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ac4cf0a635b5f7$export$2e2bcd8739ae039);

var $9lwEQ = parcelRequire("9lwEQ");
const $00ac4cf0a635b5f7$var$mapDispatchToProps = (dispatch)=>({
        onApply: ()=>{
            dispatch((0, $9lwEQ.applyChange)());
        },
        onCancel: ()=>{
            dispatch((0, $9lwEQ.cancelOptimize)());
        }
    });
var $00ac4cf0a635b5f7$export$2e2bcd8739ae039 = $00ac4cf0a635b5f7$var$mapDispatchToProps;

});
parcelRegister("9lwEQ", function(module, exports) {

$parcel$export(module.exports, "BEFORE_APPLY_CHANGE", () => $b4137d07cdab87a8$export$76a37d622d00e9f7);
$parcel$export(module.exports, "AFTER_APPLY_CHANGE", () => $b4137d07cdab87a8$export$10e12d040017c5fd);
$parcel$export(module.exports, "BEFORE_OPTIMIZE_CALCULATION", () => $b4137d07cdab87a8$export$68b581ada2ac0283);
$parcel$export(module.exports, "AFTER_OPTIMIZE_CALCULATION", () => $b4137d07cdab87a8$export$152246657c0e60d3);
$parcel$export(module.exports, "startOptimize", () => $b4137d07cdab87a8$export$95aeb3ead71202f6);
$parcel$export(module.exports, "cancelOptimize", () => $b4137d07cdab87a8$export$22316cffb5125c18);
$parcel$export(module.exports, "applyChange", () => $b4137d07cdab87a8$export$6fbe08f3dbfbccb2);
$parcel$export(module.exports, "default", () => $b4137d07cdab87a8$export$2e2bcd8739ae039);
parcelRequire("inLJ0");
var $71txE = parcelRequire("71txE");

var $aeXAa = parcelRequire("aeXAa");
var $cQGVO = parcelRequire("cQGVO");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $1jM5j = parcelRequire("1jM5j");

var $cbq3D = parcelRequire("cbq3D");

var $hLlYV = parcelRequire("hLlYV");

var $6fxQQ = parcelRequire("6fxQQ");

var $akhOi = parcelRequire("akhOi");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $kCccV = parcelRequire("kCccV");

var $gNoQI = parcelRequire("gNoQI");


var $xlOmi = parcelRequire("xlOmi");

var $k94CF = parcelRequire("k94CF");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $g8LRx = parcelRequire("g8LRx");
const $b4137d07cdab87a8$export$982c77cfe4f10899 = 'command.optimize.START_OPTIMIZE';
const $b4137d07cdab87a8$export$b552825ff76c8dca = 'command.optimize.CANCEL_OPTIMIZE';
const $b4137d07cdab87a8$export$b6d845d94d76e436 = 'command.optimize.APPLY_CHANGE';
const $b4137d07cdab87a8$export$76a37d622d00e9f7 = 'command.optimize.BEFORE_APPLY_CHANGE';
const $b4137d07cdab87a8$export$10e12d040017c5fd = 'command.optimize.AFTER_APPLY_CHANGE';
const $b4137d07cdab87a8$export$68b581ada2ac0283 = 'command.optimize.BEFORE_OPTIMIZE_CALCULATION';
const $b4137d07cdab87a8$export$152246657c0e60d3 = 'command.optimize.AFTER_OPTIMIZE_CALCULATION';
const $b4137d07cdab87a8$export$95aeb3ead71202f6 = (analyticsEvent)=>({
        type: $b4137d07cdab87a8$export$982c77cfe4f10899,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b4137d07cdab87a8$export$22316cffb5125c18 = ()=>({
        type: $b4137d07cdab87a8$export$b552825ff76c8dca
    });
const $b4137d07cdab87a8$export$6fbe08f3dbfbccb2 = ()=>({
        type: $b4137d07cdab87a8$export$b6d845d94d76e436
    });
const $b4137d07cdab87a8$export$52e6dbf58c39b42b = ()=>({
        type: $b4137d07cdab87a8$export$76a37d622d00e9f7
    });
const $b4137d07cdab87a8$export$cc3f63d32a5b42ff = ()=>({
        type: $b4137d07cdab87a8$export$10e12d040017c5fd
    });
const $b4137d07cdab87a8$export$f370c41c3524f7bd = ()=>({
        type: $b4137d07cdab87a8$export$68b581ada2ac0283
    });
const $b4137d07cdab87a8$export$1c02c78aae1d79d1 = (analyticsEvent)=>({
        type: $b4137d07cdab87a8$export$152246657c0e60d3,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $b4137d07cdab87a8$var$APPLY_CHANGES_POLL_DELAY = 1000;
const $b4137d07cdab87a8$var$AUTO_SCHEDULE_FIRST_POLL_DELAY = 300;
const $b4137d07cdab87a8$var$AUTO_SCHEDULE_NEXT_POLL_DELAY = 1000;
function* $b4137d07cdab87a8$export$59e7395bfe4ec720(error) {
    yield (0, $9e8i2.put)((0, $cbq3D.genericError)(error));
    yield (0, $9e8i2.put)($b4137d07cdab87a8$export$22316cffb5125c18());
}
function* $b4137d07cdab87a8$export$17eb80881f8092da() {
    const url = (0, $g8LRx.urls).pollOptimize;
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const body = {
        planId: planId,
        scenarioId: scenarioId
    };
    const calculationId = (yield (0, $9e8i2.select)((0, $kCccV.getSolution))).id;
    try {
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { done: done, running: running } = yield (0, $9e8i2.call)(response.json.bind(response));
            if (done && done.id === calculationId && !running) yield (0, $9e8i2.put)((0, $k94CF.setLatest)(true));
            else yield (0, $9e8i2.put)((0, $k94CF.setLatest)(false));
        } else yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, {
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        const errorPayload = {
            message: e.message,
            stackTrace: e.stack
        };
        yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, errorPayload);
    }
}
function* $b4137d07cdab87a8$export$3f6a30e15340a142(id, body, meta) {
    const url = (0, $g8LRx.urls).pollOptimize;
    yield (0, $9e8i2.call)((0, $71txE.delay), $b4137d07cdab87a8$var$AUTO_SCHEDULE_FIRST_POLL_DELAY);
    while(true){
        if ((yield (0, $9e8i2.select)((0, $akhOi.getMode))) !== (0, $99f9ac26081f8045$export$7536581a3f6533cb)) break;
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if ((yield (0, $9e8i2.select)((0, $akhOi.getMode))) !== (0, $99f9ac26081f8045$export$7536581a3f6533cb)) break;
        if (response.ok) {
            const { done: done, running: running } = yield (0, $9e8i2.call)(response.json.bind(response));
            // done.id >= id  --> there may be multiple calculations running at the same time for this plan, so we may get 'id' which is greater
            if (done && done.id >= id) {
                yield (0, $9e8i2.put)($b4137d07cdab87a8$export$1c02c78aae1d79d1(meta.analyticsEvent));
                yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
                yield (0, $9e8i2.put)((0, $k94CF.setValidity)(true));
                yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$e91bb82ec00eb771)));
                break;
            } else if (!(running && running.id >= id)) {
                yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, {
                    message: 'Unexpected response'
                });
                break;
            }
        } else {
            yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, {
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            });
            break;
        }
        yield (0, $9e8i2.call)((0, $71txE.delay), $b4137d07cdab87a8$var$AUTO_SCHEDULE_NEXT_POLL_DELAY);
    }
}
function* $b4137d07cdab87a8$export$120948c802b124a1(meta) {
    yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$7536581a3f6533cb)));
    const url = (0, $g8LRx.urls).startOptimize;
    const { id: planId, currentScenarioId: scenarioId, autoScheduleConfiguration: basicCalculationConfiguration } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const selectedIssueIdsToSchedule = $cQGVO.default((issue)=>issue.id, (yield (0, $9e8i2.select)((0, $kwMvv.getSelectedIssues))));
    const calculationConfiguration = selectedIssueIdsToSchedule.length > 0 ? $aeXAa.default('selectedIssueIds', selectedIssueIdsToSchedule, basicCalculationConfiguration) : basicCalculationConfiguration;
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        calculationConfiguration: calculationConfiguration
    };
    try {
        yield (0, $9e8i2.put)($b4137d07cdab87a8$export$f370c41c3524f7bd());
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { id: id } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($b4137d07cdab87a8$export$3f6a30e15340a142, id, body, meta);
        } else if (response.status === 404) yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, {
            message: '',
            description: (0, $ib5d3.default).planNotFound
        });
        else yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, {
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        const errorPayload = {
            message: e.message,
            stackTrace: e.stack
        };
        yield (0, $9e8i2.call)($b4137d07cdab87a8$export$59e7395bfe4ec720, errorPayload);
    }
}
function* $b4137d07cdab87a8$export$d6be908d04ca3821(error) {
    yield (0, $9e8i2.put)((0, $cbq3D.genericError)(error));
    yield (0, $9e8i2.put)((0, $k94CF.setProgress)(null));
}
function* $b4137d07cdab87a8$export$37a8543ad18a3592(id) {
    const url = (0, $g8LRx.urls).pollApplying(id);
    while(true){
        yield (0, $9e8i2.call)((0, $71txE.delay), $b4137d07cdab87a8$var$APPLY_CHANGES_POLL_DELAY);
        if ((yield (0, $9e8i2.select)((0, $akhOi.getMode))) !== (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) {
            yield (0, $9e8i2.put)((0, $k94CF.setProgress)(null)); // Cancel.
            break;
        }
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.GET)
        });
        if (response.ok) {
            const { done: done, progressPercent: progress } = yield (0, $9e8i2.call)(response.json.bind(response));
            if (done) {
                yield (0, $9e8i2.call)((0, $1jM5j.getBacklog));
                const result = yield (0, $9e8i2.call)((0, $hLlYV.getPlanInfo));
                if (!result) return;
                const { sequence: sequence } = result;
                yield (0, $9e8i2.put)((0, $xlOmi.update)(sequence));
                yield (0, $9e8i2.put)((0, $6fxQQ.getChangesMetadata)());
                yield (0, $9e8i2.put).resolve($b4137d07cdab87a8$export$cc3f63d32a5b42ff());
                yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$250171a898bf7ef)));
                break;
            } else if ((0, $7CnHa.isDefined)(progress)) yield (0, $9e8i2.put)((0, $k94CF.setProgress)(progress));
            else {
                yield (0, $9e8i2.call)($b4137d07cdab87a8$export$d6be908d04ca3821, {
                    message: 'Unexpected response'
                });
                break;
            }
        } else {
            yield (0, $9e8i2.call)($b4137d07cdab87a8$export$d6be908d04ca3821, {
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: url,
                    type: (0, $kP3Wn.GET),
                    status: response.status
                }
            });
            break;
        }
    }
}
function* $b4137d07cdab87a8$export$73eb4bd5eeb73fa8() {
    // Abort if we have no calculation id (nothing to commit) or we're already in progress.
    const calculationId = (yield (0, $9e8i2.select)((0, $kCccV.getSolution))).id;
    const progress = yield (0, $9e8i2.select)((0, $kCccV.getApplyingProgress));
    if (!(0, $7CnHa.isDefined)(calculationId) || (0, $7CnHa.isDefined)(progress)) return;
    yield (0, $9e8i2.call)($b4137d07cdab87a8$export$17eb80881f8092da);
    const isSolutionLatest = yield (0, $9e8i2.select)((0, $kCccV.getIsSolutionLatest));
    // Start progress!
    yield (0, $9e8i2.put)((0, $k94CF.setProgress)(0));
    if (!isSolutionLatest) {
        // Instead of introducing another UI state property to show 'Out of sync' notification,
        // we use 'Active applying' and 'Not latest solution' state properties to trigger a modal
        // window notification. This is why we start and then stop progress before the return
        // statement.
        yield (0, $9e8i2.put)((0, $k94CF.setProgress)(null));
        return;
    }
    const url = (0, $g8LRx.urls).applyChange;
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        calculationId: calculationId
    };
    try {
        yield (0, $9e8i2.put)($b4137d07cdab87a8$export$52e6dbf58c39b42b());
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const { taskId: id } = yield (0, $9e8i2.call)(response.json.bind(response));
            yield (0, $9e8i2.call)($b4137d07cdab87a8$export$37a8543ad18a3592, id);
        } else yield (0, $9e8i2.call)($b4137d07cdab87a8$export$d6be908d04ca3821, {
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        const errorPayload = {
            message: e.message,
            stackTrace: e.stack
        };
        yield (0, $9e8i2.call)($b4137d07cdab87a8$export$d6be908d04ca3821, errorPayload);
    }
}
function* $b4137d07cdab87a8$export$aaad525afb68b6c0({ meta: meta }) {
    yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$7536581a3f6533cb)));
    const isSolutionValid = yield (0, $9e8i2.select)((0, $kCccV.getIsSolutionValid));
    // checkSolutionLatest is heavy as it performs a REST call -> so we're skipping it if it's not needed
    if (isSolutionValid) yield (0, $9e8i2.call)($b4137d07cdab87a8$export$17eb80881f8092da);
    const isSolutionLatest = yield (0, $9e8i2.select)((0, $kCccV.getIsSolutionLatest));
    if (isSolutionValid && isSolutionLatest) yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$e91bb82ec00eb771)));
    else yield (0, $9e8i2.call)($b4137d07cdab87a8$export$120948c802b124a1, meta);
}
function* $b4137d07cdab87a8$export$71f9684b6236e5f8() {
    yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$250171a898bf7ef)));
}
function* $b4137d07cdab87a8$export$b48ee7217010719d() {
    yield (0, $bG7pV.takeLatest)($b4137d07cdab87a8$export$982c77cfe4f10899, $b4137d07cdab87a8$export$aaad525afb68b6c0);
}
function* $b4137d07cdab87a8$export$eca955165f78089b() {
    yield (0, $bG7pV.takeLatest)($b4137d07cdab87a8$export$b552825ff76c8dca, $b4137d07cdab87a8$export$71f9684b6236e5f8);
}
function* $b4137d07cdab87a8$export$1f1bbef5df68d102() {
    yield (0, $bG7pV.takeEvery)($b4137d07cdab87a8$export$b6d845d94d76e436, $b4137d07cdab87a8$export$73eb4bd5eeb73fa8);
}
function* $b4137d07cdab87a8$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($b4137d07cdab87a8$export$b48ee7217010719d);
    yield (0, $9e8i2.fork)($b4137d07cdab87a8$export$eca955165f78089b);
    yield (0, $9e8i2.fork)($b4137d07cdab87a8$export$1f1bbef5df68d102);
}

});
parcelRegister("g8LRx", function(module, exports) {

$parcel$export(module.exports, "urls", () => $60a6e3af7a0a96ea$export$bcae9ba627f604b6);
const $60a6e3af7a0a96ea$export$bcae9ba627f604b6 = {
    startOptimize: '/rest/jpo/1.0/scheduling',
    pollOptimize: '/rest/jpo/1.0/scheduling/poll',
    applyChange: '/rest/jpo/1.0/scheduling/commit',
    pollApplying: (id)=>`/rest/jpo/1.0/scheduling/commit/${id}`
};

});



parcelRegister("6Npxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7005d0328610adb2$export$2e2bcd8739ae039);

var $40hi6 = parcelRequire("40hi6");

var $kCccV = parcelRequire("kCccV");

var $iK4oF = parcelRequire("iK4oF");
var $7005d0328610adb2$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    allIssues: (0, $40hi6.getAllIssuesWithOriginalAndOptimized),
    filteredIssues: (0, $40hi6.getIssuesWithOriginalsAndOptimized),
    isLatest: (0, $kCccV.getIsSolutionLatest),
    progress: (0, $kCccV.getApplyingProgress)
});

});

parcelRegister("5wON8", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0c18fdd5488baf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $bbaTG = parcelRequire("bbaTG");
var $eYlCJ = parcelRequire("eYlCJ");

var $cuuJa = parcelRequire("cuuJa");

var $57dZR = parcelRequire("57dZR");

var $7CnHa = parcelRequire("7CnHa");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");

var $3hp2h = parcelRequire("3hp2h");

var $c72nZ = parcelRequire("c72nZ");

var $eFWEr = parcelRequire("eFWEr");
// eslint-disable-next-line jira/react/no-class-components
class $fe0c18fdd5488baf$var$ApplyOptimisation extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        if ((0, $7CnHa.isDefined)(props.progress) && !props.isLatest && !state.isDialogOpen) return {
            isDialogOpen: true
        };
        return null;
    }
    render() {
        if (this.state.isDialogOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hp2h.default), {
            closeDialog: this.closeDialog
        });
        const { allIssues: allIssues, filteredIssues: filteredIssues, intl: intl, onApply: onApply, progress: progress } = this.props;
        const optimizedFilteredIssuesCount = filteredIssues.filter(this.isOptimized).length || 0;
        const optimizedAllIssuesCount = allIssues.filter(this.isOptimized).length || 0;
        const issueCountMessage = optimizedFilteredIssuesCount === optimizedAllIssuesCount ? intl.formatMessage((0, $c72nZ.default).previewingAllIssues, {
            issueCount: optimizedFilteredIssuesCount,
            strong: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunk)
        }) : intl.formatMessage((0, $c72nZ.default).previewingFilteredIssues, {
            filteredIssueCount: optimizedFilteredIssuesCount,
            allIssueCount: optimizedAllIssuesCount,
            strong: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunk)
        });
        const applyingButtonTheme = (current, themeProps)=>({
                ...current(themeProps),
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    background: `var(--ds-background-information, ${(0, $PdmhA).N10A})`,
                    color: `var(--ds-text-information, ${(0, $PdmhA).N60})`
                }
            });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $eFWEr.spaPreviewResultsOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $eFWEr.spaPreviewHeaderSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $eFWEr.previewTitle
        }, issueCountMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $eFWEr.actionButtons
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            onClick: this.handleCancelClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: $eFWEr.cancelButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).cancel))), (0, $7CnHa.isDefined)(progress) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            isDisabled: true,
            onClick: onApply,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), null),
            theme: applyingButtonTheme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $c72nZ.default).applying,
            values: {
                progress: progress
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "primary",
            onClick: onApply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $c72nZ.default).apply))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $eFWEr.spaPreviewDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $c72nZ.default).previewingIssuesDescription))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isDialogOpen: false
        };
        this.closeDialog = ()=>{
            this.setState({
                isDialogOpen: false
            });
        };
        this.isOptimized = (issue)=>{
            let isOptimized = false;
            if ((0, $7CnHa.isDefined)(issue.optimized)) {
                for (const [optimizedKey, optimizedValue] of Object.entries(issue.optimized))if ((0, $57dZR.hasValueChanged)((0, $57dZR.getCurrentValue)(issue, optimizedKey), optimizedValue)) {
                    isOptimized = true;
                    break;
                }
            }
            return isOptimized;
        };
        this.handleCancelClick = (_, analyticsEvent)=>{
            this.props.onCancel();
            // triggering analytics
            const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_CANCEL_OPTIMIZATION.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: eventAction,
                actionSubject: actionSubject
            }));
        };
    }
}
var $fe0c18fdd5488baf$export$2e2bcd8739ae039 = (0, $2qhQi.default)($fe0c18fdd5488baf$var$ApplyOptimisation);

});
parcelRegister("3hp2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $993f23a3c5e9951e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $jGAXm = parcelRequire("jGAXm");

var $ib5d3 = parcelRequire("ib5d3");

var $lFLge = parcelRequire("lFLge");

var $caHiB = parcelRequire("caHiB");

var $2EfR8 = parcelRequire("2EfR8");
function $993f23a3c5e9951e$export$2e2bcd8739ae039({ closeDialog: closeDialog }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const refreshButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        onClick: (0, $lFLge.reload),
        appearance: "link",
        spacing: "none"
    }, formatMessage((0, $caHiB.default).modalRefreshBtn));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        onClose: closeDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $caHiB.default).modalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2EfR8["modal-body"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($jGAXm)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $caHiB.default).notLatestMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $caHiB.default).refreshMessage,
        values: {
            refreshButton: refreshButton
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: closeDialog
    }, formatMessage((0, $ib5d3.default).cancel))));
}

});
parcelRegister("jGAXm", function(module, exports) {
module.exports = "<svg width=\"200\" height=\"184\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"0%\" y1=\"50.007%\" x2=\"99.999%\" y2=\"50.007%\" id=\"a\"><stop stop-color=\"#6C798F\" offset=\"0%\"></stop><stop stop-color=\"#6C798F\" stop-opacity=\".1\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"-6635.484%\" y1=\"-2%\" y2=\"-2%\" id=\"b\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient><linearGradient x1=\"0%\" y1=\"14049%\" x2=\"10440%\" y2=\"14049%\" id=\"c\"><stop stop-color=\"#99C1FF\" stop-opacity=\"0\" offset=\"0%\"></stop><stop stop-color=\"#93BEFF\" stop-opacity=\".04\" offset=\"1%\"></stop><stop stop-color=\"#78ADFF\" stop-opacity=\".22\" offset=\"5%\"></stop><stop stop-color=\"#5E9EFF\" stop-opacity=\".38\" offset=\"9%\"></stop><stop stop-color=\"#4790FF\" stop-opacity=\".53\" offset=\"14%\"></stop><stop stop-color=\"#3484FF\" stop-opacity=\".66\" offset=\"20%\"></stop><stop stop-color=\"#247AFF\" stop-opacity=\".77\" offset=\"25%\"></stop><stop stop-color=\"#1672FF\" stop-opacity=\".85\" offset=\"32%\"></stop><stop stop-color=\"#0C6CFF\" stop-opacity=\".92\" offset=\"40%\"></stop><stop stop-color=\"#0568FF\" stop-opacity=\".97\" offset=\"49%\"></stop><stop stop-color=\"#0166FF\" stop-opacity=\".99\" offset=\"63%\"></stop><stop stop-color=\"#0065FF\" offset=\"100%\"></stop></linearGradient></defs><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M106 167.73v-39.56A40.57 40.57 0 1 0 65.45 87.6H25.88c-.004-32.416 19.521-61.643 49.47-74.049 29.948-12.406 64.42-5.548 87.341 17.375 22.92 22.923 29.774 57.397 17.364 87.344-12.41 29.947-41.639 49.468-74.055 49.46z\" fill=\"url(#a)\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 169.27v-39.56c22.406 0 40.57-18.164 40.57-40.57s-18.164-40.57-40.57-40.57-40.57 18.164-40.57 40.57H21.71C21.71 44.88 57.59 9 101.85 9s80.14 35.88 80.14 80.14-35.88 80.14-80.14 80.14v-.01z\" fill=\"#0065FF\"></path><path d=\"M182 89.14c.088-42.717-33.345-77.995-76.005-80.199-42.66-2.204-79.55 29.44-83.865 71.939L8.75 79.67a3.06 3.06 0 0 0-2.62 5l30.56 36.63c1.08 1.3 3 1.47 3.4.39l36.63-30.57c3-1.75 1.93-5.15-.78-5.4l-14.38-1.3c2.525-21.65 21.705-37.435 43.436-35.748 21.731 1.686 38.246 20.242 37.4 42.022-.846 21.78-18.75 39-40.546 38.996h1.55v39.53c43.618-.876 78.538-36.453 78.6-80.08z\" fill=\"#0065FF\"></path><path d=\"M104.4 161.27h-1.55 1.55z\" fill=\"url(#b)\" transform=\"translate(-1 8)\"></path><path fill=\"url(#c)\" d=\"M0 121.71h102.85v39.57H0z\" transform=\"translate(-1 8)\"></path><path d=\"M101.85 129.71v39.57h1.55v-39.57h-1.55z\" fill=\"#0065FF\"></path><path d=\"M102.85 121.71v39.57h1.55v-39.57h-1.55z\" fill=\"url(#c)\" transform=\"translate(-1 8)\"></path></g></svg>";

});

parcelRegister("caHiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $920a249c273f7734$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $920a249c273f7734$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.modal-header",
        "defaultMessage": "Applying changes"
    },
    modalRefreshBtn: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.modal-refresh-btn",
        "defaultMessage": "Refresh"
    },
    notLatestMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.not-latest-message",
        "defaultMessage": "Changes are out of sync due to concurrent auto-scheduling."
    },
    refreshMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.dialog.refresh-message",
        "defaultMessage": "{refreshButton} to see the latest changes."
    }
});

});

parcelRegister("2EfR8", function(module, exports) {

$parcel$export(module.exports, "modal-body", () => $1edb9de31d6aa5a9$export$2f7d9971875d27cc, (v) => $1edb9de31d6aa5a9$export$2f7d9971875d27cc = v);
var $1edb9de31d6aa5a9$export$2f7d9971875d27cc;
$1edb9de31d6aa5a9$export$2f7d9971875d27cc = `hacwPa_modal-body`;

});


parcelRegister("c72nZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e40d050a9004eb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1e40d050a9004eb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    apply: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.apply",
        "defaultMessage": "Accept changes"
    },
    applying: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.applying",
        "defaultMessage": "Applying changes ({progress}%)"
    },
    previewingAllIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-all-issues",
        "defaultMessage": "Previewing a total of <strong>{issueCount}</strong> auto-scheduled issues"
    },
    previewingFilteredIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-filtered-issues",
        "defaultMessage": "Previewing <strong>{filteredIssueCount}</strong> of <strong>{allIssueCount}</strong> auto-scheduled issues"
    },
    previewingIssuesDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.apply-optimisation.previewing-issues-description",
        "defaultMessage": "By accepting, your plan will be updated with these changes. You'll still need to review and save all changes in your plan to Jira."
    }
});

});

parcelRegister("eFWEr", function(module, exports) {

$parcel$export(module.exports, "actionButtons", () => $aaf263f181fa2940$export$b6fb1741c7f64881, (v) => $aaf263f181fa2940$export$b6fb1741c7f64881 = v);
$parcel$export(module.exports, "cancelButton", () => $aaf263f181fa2940$export$4ededb8e5b56a6fb, (v) => $aaf263f181fa2940$export$4ededb8e5b56a6fb = v);
$parcel$export(module.exports, "previewTitle", () => $aaf263f181fa2940$export$435aa072d3c70d67, (v) => $aaf263f181fa2940$export$435aa072d3c70d67 = v);
$parcel$export(module.exports, "spaPreviewDescription", () => $aaf263f181fa2940$export$8bec8fcb49760d0a, (v) => $aaf263f181fa2940$export$8bec8fcb49760d0a = v);
$parcel$export(module.exports, "spaPreviewHeaderSection", () => $aaf263f181fa2940$export$949d9c874bca1a72, (v) => $aaf263f181fa2940$export$949d9c874bca1a72 = v);
$parcel$export(module.exports, "spaPreviewResultsOverlay", () => $aaf263f181fa2940$export$51725f5aed7fd5b7, (v) => $aaf263f181fa2940$export$51725f5aed7fd5b7 = v);
var $aaf263f181fa2940$export$b6fb1741c7f64881;
var $aaf263f181fa2940$export$4ededb8e5b56a6fb;
var $aaf263f181fa2940$export$435aa072d3c70d67;
var $aaf263f181fa2940$export$8bec8fcb49760d0a;
var $aaf263f181fa2940$export$949d9c874bca1a72;
var $aaf263f181fa2940$export$51725f5aed7fd5b7;
$aaf263f181fa2940$export$b6fb1741c7f64881 = `x0kt5W_actionButtons`;
$aaf263f181fa2940$export$4ededb8e5b56a6fb = `x0kt5W_cancelButton`;
$aaf263f181fa2940$export$435aa072d3c70d67 = `x0kt5W_previewTitle`;
$aaf263f181fa2940$export$8bec8fcb49760d0a = `x0kt5W_spaPreviewDescription`;
$aaf263f181fa2940$export$949d9c874bca1a72 = `x0kt5W_spaPreviewHeaderSection`;
$aaf263f181fa2940$export$51725f5aed7fd5b7 = `x0kt5W_spaPreviewResultsOverlay`;

});



parcelRegister("3vYcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $77864e1d5014be55$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $77864e1d5014be55$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pageTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.page-title",
        "defaultMessage": "Timeline"
    },
    breadcrumbTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.breadcrumb-title",
        "defaultMessage": "Plans"
    },
    readOnly: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.read-only",
        "defaultMessage": "Read-Only"
    },
    archived: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.archived",
        "defaultMessage": "Archived"
    }
});

});



parcelRegister("5F8Fv", function(module, exports) {

$parcel$export(module.exports, "ReportAppBase", () => $219887a2505301bd$export$cf6ecc6613a7b841);
$parcel$export(module.exports, "PlanAppBase", () => $219887a2505301bd$export$9ffe420d3b5fa4bd);
$parcel$export(module.exports, "SettingsAppBase", () => $219887a2505301bd$export$de97c218c12a59a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $iAoTX = parcelRequire("iAoTX");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5BRby = parcelRequire("5BRby");

var $ae4LH = parcelRequire("ae4LH");

var $9EHc8 = parcelRequire("9EHc8");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("bJc6r");
var $8bnQD = parcelRequire("8bnQD");

var $lPYkK = parcelRequire("lPYkK");

var $k5P3O = parcelRequire("k5P3O");

var $iVsy4 = parcelRequire("iVsy4");

var $3Ff32 = parcelRequire("3Ff32");

var $lOpTz = parcelRequire("lOpTz");

var $gPr41 = parcelRequire("gPr41");

var $3HCkE = parcelRequire("3HCkE");
var $kJlBc = parcelRequire("kJlBc");

var $drCAA = parcelRequire("drCAA");

var $eIp1n = parcelRequire("eIp1n");

var $fO5rB = parcelRequire("fO5rB");

var $iPDOm = parcelRequire("iPDOm");

var $6M8Uw = parcelRequire("6M8Uw");

var $iJHZm = parcelRequire("iJHZm");

var $ab6rA = parcelRequire("ab6rA");
var $4xHig = parcelRequire("4xHig");
parcelRequire("4PQoa");
var $kY36r = parcelRequire("kY36r");

var $7FLAp = parcelRequire("7FLAp");

var $cOkqp = parcelRequire("cOkqp");
const $219887a2505301bd$export$cf6ecc6613a7b841 = ({ withReduxStore: withReduxStore, paddingLeft: paddingLeft = true, paddingRight: paddingRight = true, children: children, store: store = (0, $lPYkK.default) })=>{
    const locale = (0, $4xHig.useLocale)();
    const editions = (0, $ab6rA.useAppEditions)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanReportPageInitialChecksResource));
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage,
        planId: data.planId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "spa-app.advanced-roadmaps-plan.report",
        packageName: "jiraSpaAppsAdvancedRoadmaps",
        teamName: "advanced-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experience: "viewPortfolio3",
        analyticsSource: "portfolio3",
        application: (0, $eIp1n.JIRA_PORTFOLIO),
        edition: editions.software,
        additionalAttributes: {
            synthetic: (0, $8bnQD.default)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        store: withReduxStore ? store : undefined,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7FLAp.AnalyticsInitializer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVsy4.default), null, document.body && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ff32.default), null), document.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
        loading: null,
        persistor: (0, $lPYkK.persistor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPr41.default), {
        locale: locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($219887a2505301bd$var$Container, {
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "arj"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lOpTz.default), null))))));
};
const $219887a2505301bd$export$9ffe420d3b5fa4bd = ({ appKey: appKey = 'spa-app.advanced-roadmaps-plan.default', withReduxStore: withReduxStore, paddingLeft: paddingLeft = true, paddingRight: paddingRight = true, children: children, store: store = (0, $lPYkK.default), planView: planView })=>{
    const locale = (0, $4xHig.useLocale)();
    const editions = (0, $ab6rA.useAppEditions)();
    const { data: data, loading: loading, error: error } = (0, $cOkqp.usePlanCheck)();
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const containerStyles = (0, $eUqFw.useMemo)(()=>{
        const styles = [
            $219887a2505301bd$var$containerStylesNoPadding
        ];
        if (paddingLeft) styles.push($219887a2505301bd$var$containerWithPaddingLeft);
        if (paddingRight) styles.push($219887a2505301bd$var$containerWithPaddingRight);
        return styles;
    }, [
        paddingLeft,
        paddingRight
    ]);
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) {
        const planId = Number.isNaN(match.params.planId) ? undefined : Number(match.params.planId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
            errorMessage: data.errorMessage,
            planId: planId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: appKey,
        packageName: "jiraSpaAppsAdvancedRoadmaps",
        teamName: "advanced-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experience: "viewPortfolio3",
        analyticsSource: "portfolio3",
        application: (0, $eIp1n.JIRA_PORTFOLIO),
        edition: editions.software,
        additionalAttributes: {
            synthetic: (0, $8bnQD.default)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        store: withReduxStore ? store : undefined,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7FLAp.AnalyticsInitializer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVsy4.default), null, document.body && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ff32.default), null), document.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
        loading: null,
        persistor: (0, $lPYkK.persistor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPr41.default), {
        locale: locale,
        planView: planView
    }), (0, $1ybV0.ff)('jet-plans-nav-refresh_f9025') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: containerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($219887a2505301bd$var$Container, {
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "arj"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lOpTz.default), null), (0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k5P3O.default), null))))));
};
const $219887a2505301bd$export$de97c218c12a59a0 = ({ children: children, appKey: appKey = 'spa-app.advanced-roadmaps-plan.settings', store: store = (0, $lPYkK.default) })=>{
    const locale = (0, $4xHig.useLocale)();
    const editions = (0, $ab6rA.useAppEditions)();
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) {
        const planId = Number.isNaN(match.params.planId) ? undefined : Number(match.params.planId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
            errorMessage: data.errorMessage,
            planId: planId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: appKey,
        packageName: "jiraSpaAppsAdvancedRoadmaps",
        teamName: "advanced-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experience: "viewPortfolio3PlanSettings",
        analyticsSource: "portfolio3",
        application: (0, $eIp1n.JIRA_PORTFOLIO),
        edition: editions.software,
        additionalAttributes: {
            synthetic: (0, $8bnQD.default)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        store: store,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7FLAp.AnalyticsInitializer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVsy4.default), null, document.body && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ff32.default), null), document.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
        loading: null,
        persistor: (0, $lPYkK.persistor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gPr41.default), {
        locale: locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($219887a2505301bd$var$Container, {
        paddingLeft: true,
        paddingRight: true,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "arj"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lOpTz.default), null))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $219887a2505301bd$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { paddingLeft: paddingLeft, paddingRight: paddingRight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _4t3i1osq",
            __cmplp.paddingLeft && "_19bv1jfw",
            __cmplp.paddingRight && "_u5f31ejb",
            __cmplp.className
        ])
    });
});
const $219887a2505301bd$var$containerStylesNoPadding = (0, $1ZAYh.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
});
const $219887a2505301bd$var$containerWithPaddingLeft = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.300'
});
const $219887a2505301bd$var$containerWithPaddingRight = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300'
});

});
parcelRegister("lPYkK", function(module, exports) {

$parcel$export(module.exports, "persistor", () => $05ca07dc85954487$export$7b682ac9934ca3e4);
$parcel$export(module.exports, "default", () => $05ca07dc85954487$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");
parcelRequire("97CJW");
var $5BTOa = parcelRequire("5BTOa");

var $inLJ0 = parcelRequire("inLJ0");

var $guiFP = parcelRequire("guiFP");

var $fcaZ5 = parcelRequire("fcaZ5");
parcelRequire("bJc6r");
var $8bnQD = parcelRequire("8bnQD");

var $6xtFS = parcelRequire("6xtFS");

var $2FY8j = parcelRequire("2FY8j");

var $131Tg = parcelRequire("131Tg");

var $8pnAg = parcelRequire("8pnAg");


var $l7qZG = parcelRequire("l7qZG");

var $ewayV = parcelRequire("ewayV");

var $l1eW8 = parcelRequire("l1eW8");

var $5rYNM = parcelRequire("5rYNM");

var $dbuYA = parcelRequire("dbuYA");

var $9f99L = parcelRequire("9f99L");

var $2ZJWb = parcelRequire("2ZJWb");
const $05ca07dc85954487$var$composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
}) : (0, $huRi7.compose);
/* eslint-enable */ const $05ca07dc85954487$var$middlewares = [];
const $05ca07dc85954487$var$sagaMiddleware = (0, $inLJ0.default)({
    onError: (error)=>{
        const id = (0, $ewayV.isEnvironmentError)(error) ? (0, $5rYNM.ERROR_REPORTING_PACKAGE).ENVIRONMENT : (0, $5rYNM.ERROR_REPORTING_PACKAGE).REDUX_SAGA;
        (0, $guiFP.default)({
            meta: {
                id: id,
                packageName: (0, $5rYNM.PACKAGE_NAME),
                teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                synthetic: (0, $8bnQD.default)()
            }
        });
        $05ca07dc85954487$var$store.dispatch((0, $l7qZG.showError)(error.message, error.stack, window?.location.hash, window?.location.pathname));
    }
});
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$05ca07dc85954487$var$middlewares.push((0, $l1eW8.errorReporterMiddleware));
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$05ca07dc85954487$var$middlewares.push($05ca07dc85954487$var$sagaMiddleware);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$05ca07dc85954487$var$middlewares.push((0, $9f99L.default));
const $05ca07dc85954487$var$store = (0, $huRi7.createStore)((0, $2ZJWb.default), $05ca07dc85954487$var$composeEnhancers((0, $huRi7.applyMiddleware)(...$05ca07dc85954487$var$middlewares), (0, $dbuYA.default)()));
const $05ca07dc85954487$export$7b682ac9934ca3e4 = (0, $5BTOa.default)($05ca07dc85954487$var$store);
var $05ca07dc85954487$export$2e2bcd8739ae039 = $05ca07dc85954487$var$store;
// Initialise "processes" which run in "parallel" with Redux loop.
$05ca07dc85954487$var$sagaMiddleware.run((0, $fcaZ5.default));
(0, $2FY8j.default)($05ca07dc85954487$var$store);
if ((0, $8pnAg.getInitialMode)() !== (0, $99f9ac26081f8045$export$f79b1fae3e63e441)) // In export PNG mode, we don't want to persist the selected timeline range in the export PNG dialog
(0, $6xtFS.default)($05ca07dc85954487$var$store);
(0, $131Tg.default)($05ca07dc85954487$var$store);

});
parcelRegister("fcaZ5", function(module, exports) {

$parcel$export(module.exports, "initialLoad", () => $bea068ecc8536ec0$export$b70fe0c8c3456154);
$parcel$export(module.exports, "default", () => $bea068ecc8536ec0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resetReduxStore", () => (parcelRequire("9Nhwa")).resetReduxStore);
$parcel$export(module.exports, "restoreReduxStore", () => (parcelRequire("9Nhwa")).restoreReduxStore);
$parcel$export(module.exports, "changeActiveFilterView", () => (parcelRequire("k8WUU")).changeActiveFilterView);

var $aeXAa = parcelRequire("aeXAa");
var $itLT6 = parcelRequire("itLT6");
var $kGWdh = parcelRequire("kGWdh");
var $kjklK = parcelRequire("kjklK");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $1ybV0 = parcelRequire("1ybV0");

var $dYnI4 = parcelRequire("dYnI4");

var $kXdPE = parcelRequire("kXdPE");

var $lUiqk = parcelRequire("lUiqk");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $akhOi = parcelRequire("akhOi");

var $fr1nu = parcelRequire("fr1nu");

var $gNoQI = parcelRequire("gNoQI");

var $8pnAg = parcelRequire("8pnAg");


var $9ozqH = parcelRequire("9ozqH");


var $l46YP = parcelRequire("l46YP");

var $dr8sv = parcelRequire("dr8sv");
parcelRequire("6OvfP");
var $eOsHk = parcelRequire("eOsHk");

var $1oWqc = parcelRequire("1oWqc");

var $iywPH = parcelRequire("iywPH");

var $aF7eA = parcelRequire("aF7eA");

var $fKrBu = parcelRequire("fKrBu");

var $8RAUa = parcelRequire("8RAUa");

var $k8WUU = parcelRequire("k8WUU");

var $8B14N = parcelRequire("8B14N");

var $ayiPs = parcelRequire("ayiPs");

var $l7qZG = parcelRequire("l7qZG");

var $6owOg = parcelRequire("6owOg");

var $NeuAT = parcelRequire("NeuAT");

var $64VaH = parcelRequire("64VaH");

var $4a0ar = parcelRequire("4a0ar");

var $eOsHk = parcelRequire("eOsHk");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");


var $jwhcr = parcelRequire("jwhcr");

var $kP3Wn = parcelRequire("kP3Wn");

var $63O1Q = parcelRequire("63O1Q");

var $1jM5j = parcelRequire("1jM5j");

var $jpccz = parcelRequire("jpccz");

var $h7pZO = parcelRequire("h7pZO");

var $kKZNQ = parcelRequire("kKZNQ");

var $d4sjQ = parcelRequire("d4sjQ");

var $cbq3D = parcelRequire("cbq3D");

var $6itAY = parcelRequire("6itAY");

var $99FB5 = parcelRequire("99FB5");

var $296Gg = parcelRequire("296Gg");

var $kXDg8 = parcelRequire("kXDg8");

var $fk2gn = parcelRequire("fk2gn");

var $1Szmp = parcelRequire("1Szmp");

var $cTDpS = parcelRequire("cTDpS");

var $4zflJ = parcelRequire("4zflJ");

var $agcf7 = parcelRequire("agcf7");

var $6hfzF = parcelRequire("6hfzF");

var $9lwEQ = parcelRequire("9lwEQ");

var $6MKBs = parcelRequire("6MKBs");

var $lxYdq = parcelRequire("lxYdq");

var $hLlYV = parcelRequire("hLlYV");

var $2L2I7 = parcelRequire("2L2I7");

var $8qtqq = parcelRequire("8qtqq");

var $jmPgj = parcelRequire("jmPgj");

var $eelZZ = parcelRequire("eelZZ");

var $1XIAV = parcelRequire("1XIAV");

var $hI5cD = parcelRequire("hI5cD");

var $heBex = parcelRequire("heBex");

var $1C7Mn = parcelRequire("1C7Mn");

var $1eyFr = parcelRequire("1eyFr");

var $8NDwu = parcelRequire("8NDwu");

var $lUiqk = parcelRequire("lUiqk");

var $6fxQQ = parcelRequire("6fxQQ");

var $051m9 = parcelRequire("051m9");

var $5GdAe = parcelRequire("5GdAe");

var $dC8ep = parcelRequire("dC8ep");

var $9Nhwa = parcelRequire("9Nhwa");
const $bea068ecc8536ec0$export$b70fe0c8c3456154 = (payload)=>({
        type: (0, $74b2f27518e05c28$export$bf72183eb20c4d57),
        payload: payload
    });
const $bea068ecc8536ec0$export$b6770a6d5ff091de = ()=>({
        type: (0, $74b2f27518e05c28$export$a60cf13a28cbf30f)
    });
const $bea068ecc8536ec0$var$INVERTED_TARGET_START_END_API_MAP = $kGWdh.default((0, $eOsHk.TARGET_START_END_API_MAP));
const $bea068ecc8536ec0$export$43f2c3001ad105a9 = (field)=>{
    const newId = $kjklK.default([
        field.id
    ], $bea068ecc8536ec0$var$INVERTED_TARGET_START_END_API_MAP);
    return newId ? {
        ...field,
        id: newId,
        key: newId
    } : field;
};
// eslint-disable-next-line jira/ff/no-module-level-eval
const $bea068ecc8536ec0$var$isOpenApiClientEnabled = (0, $1ybV0.ff)('use-openapi-generated-server-stub-and-the-client_p7a4d');
const $bea068ecc8536ec0$var$getWarnings = (dateField, dateFieldStatus, // eslint-disable-next-line @typescript-eslint/no-shadow
customFields)=>{
    if (dateFieldStatus === (0, $eOsHk.DateFieldStatus).UNAVAILABLE) {
        const apiDateField = customFields.find((field)=>String(field.id) === dateField.key);
        return {
            code: (0, $eOsHk.DATEFIELD_WARNINGS).UNAVAILABLE,
            apiDateField: apiDateField
        };
    }
    if (dateFieldStatus === (0, $eOsHk.DateFieldStatus).NOT_EXIST) return {
        code: (0, $eOsHk.DATEFIELD_WARNINGS).NOT_EXIST
    };
    return undefined;
};
const $bea068ecc8536ec0$export$183a142021de15c4 = (planInfo)=>{
    // eslint-disable-next-line no-param-reassign
    planInfo.plan.baselineStartField = $bea068ecc8536ec0$export$43f2c3001ad105a9(planInfo.plan.baselineStartField);
    // eslint-disable-next-line no-param-reassign
    planInfo.plan.baselineEndField = $bea068ecc8536ec0$export$43f2c3001ad105a9(planInfo.plan.baselineEndField);
};
function $bea068ecc8536ec0$export$ab3a3f2027ecddbb(planInfo) {
    if (planInfo.dateFieldStatuses == null) return undefined;
    if (planInfo.dateFieldStatuses != null && (planInfo.dateFieldStatuses.startFieldStatus !== (0, $eOsHk.DateFieldStatus).OK || planInfo.dateFieldStatuses.endFieldStatus !== (0, $eOsHk.DateFieldStatus).OK)) {
        const dateWarnings = {};
        const startWarning = $bea068ecc8536ec0$var$getWarnings(planInfo.plan.baselineStartField, planInfo.dateFieldStatuses.startFieldStatus, planInfo.customFields);
        const endWarning = $bea068ecc8536ec0$var$getWarnings(planInfo.plan.baselineEndField, planInfo.dateFieldStatuses.endFieldStatus, planInfo.customFields);
        if (startWarning) dateWarnings.baselineStartField = $itLT6.default([
            'warning'
        ], startWarning, (0, $4a0ar.extractStartDateField)(planInfo));
        if (endWarning) dateWarnings.baselineEndField = $itLT6.default([
            'warning'
        ], endWarning, (0, $eOsHk.DUE_DATE_FIELD));
        if (startWarning || endWarning) return dateWarnings;
    }
    return undefined;
}
function* $bea068ecc8536ec0$var$doBacklog(backlogResponse, sprints) {
    let backlog = null;
    if (backlogResponse.ok) yield* (0, $kXdPE.default)(function*() {
        (0, $dYnI4.monitor).setMark('jira.fe-spa.advanced-roadmaps.product.parse-json:start');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backlog = yield (0, $9e8i2.call)(backlogResponse.json.bind(backlogResponse));
        (0, $dYnI4.monitor).setMark('jira.fe-spa.advanced-roadmaps.product.parse-json:end');
        yield (0, $9e8i2.call)((0, $heBex.populateExternalSprints), backlog?.sprints ?? [], sprints);
        yield (0, $9e8i2.put)((0, $fr1nu.resetBacklog)(backlog));
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const teams = backlog.teams?.map((0, $8RAUa.prepareTeam)) ?? [];
        yield (0, $9e8i2.put)((0, $aF7eA.setAdditionalTeams)(teams));
        yield (0, $9e8i2.put)((0, $fr1nu.afterResetBacklog)());
        yield (0, $9e8i2.put)($051m9.calculateStatusOfAllReleases());
        // Backlog data should only be falsy when we have already thrown an error
        yield (0, $9e8i2.call)((0, $63O1Q.populateAssigneesFromProfiles), backlog?.assigneeProfiles ?? {});
        yield (0, $9e8i2.call)((0, $jmPgj.populateReportersFromProfiles), backlog?.reporterProfiles ?? {});
    });
    else {
        yield (0, $9e8i2.call)((0, $63O1Q.populateAssignees));
        const body = yield (0, $9e8i2.call)((0, $jpccz.backlogBody), {
            id: (0, $NeuAT.getPlanId)() || 1,
            currentScenarioId: (0, $NeuAT.getScenarioId)() || 1
        });
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(backlogResponse, (yield (0, $9e8i2.call)(backlogResponse.text.bind(backlogResponse)))),
            requestInfo: {
                url: (0, $jpccz.urls).backlog,
                type: (0, $kP3Wn.POST),
                status: backlogResponse.status,
                body: body
            }
        }));
    }
    return backlog;
}
function* $bea068ecc8536ec0$var$doBacklogOpenApi(backlogResponse, sprints) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (backlogResponse.json) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return yield* $bea068ecc8536ec0$var$doBacklog(backlogResponse, sprints);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
    backlogResponse;
    const backlog = yield backlogResponse.value();
    if (backlog) yield* (0, $kXdPE.default)(function*() {
        yield (0, $9e8i2.call)((0, $heBex.populateExternalSprints), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backlog?.sprints ? backlog?.sprints : [], sprints);
        yield (0, $9e8i2.put)((0, $fr1nu.resetBacklog)(backlog));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-shadow
        const teams = backlog.teams ? backlog.teams.map((0, $8RAUa.prepareTeam)) : [];
        yield (0, $9e8i2.put)((0, $aF7eA.setAdditionalTeams)(teams));
        yield (0, $9e8i2.put)((0, $fr1nu.afterResetBacklog)());
        yield (0, $9e8i2.put)($051m9.calculateStatusOfAllReleases());
        yield (0, $9e8i2.call)((0, $63O1Q.populateAssigneesFromProfiles), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backlog?.assigneeProfiles ? backlog?.assigneeProfiles : {});
        yield (0, $9e8i2.call)((0, $jmPgj.populateReportersFromProfiles), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backlog?.reporterProfiles ? backlog?.reporterProfiles : {});
    });
    else {
        yield (0, $9e8i2.call)((0, $63O1Q.populateAssignees));
        const body = yield (0, $9e8i2.call)((0, $jpccz.backlogBody), {
            id: (0, $NeuAT.getPlanId)() || 1,
            currentScenarioId: (0, $NeuAT.getScenarioId)() || 1
        });
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(backlogResponse.raw, (yield (0, $9e8i2.call)(backlogResponse.raw.text.bind(backlogResponse)))),
            requestInfo: {
                url: backlogResponse.raw.url,
                type: (0, $kP3Wn.POST),
                status: backlogResponse.raw.status,
                body: body
            }
        }));
    }
}
/* eslint-disable no-empty */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $bea068ecc8536ec0$var$fetchJson(url) {
    try {
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: 'GET'
        });
        if (response.ok) return yield (0, $9e8i2.call)(response.json.bind(response));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {}
    throw new Error(`Failed to fetch page data for plan: ${url}`);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $bea068ecc8536ec0$var$getBasicRequiredPlanInfo() {
    const reportHash = yield (0, $9e8i2.call)((0, $NeuAT.getReportHash));
    if ((0, $7CnHa.isDefined)(reportHash)) {
        let response;
        const earlyPreloadBasicPlanInfoPromise = window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;
        delete window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;
        if (earlyPreloadBasicPlanInfoPromise) // @ts-expect-error TS2322 - Type 'Promise<any>' is not assignable to type 'Effect'.
        response = yield earlyPreloadBasicPlanInfoPromise;
        if (!(0, $7CnHa.isDefined)(response)) response = yield (0, $9e8i2.call)($bea068ecc8536ec0$var$fetchJson, `/rest/jpo/1.0/reportinfo/generic/${reportHash}`);
        yield (0, $9e8i2.put)((0, $dr8sv.update)({
            id: response.planId,
            currentScenarioId: response.scenarioId
        }));
        return {
            planId: response.planId,
            scenarioId: response.scenarioId,
            reportInfo: response.data
        };
    }
    return {
        planId: yield (0, $9e8i2.call)((0, $NeuAT.getPlanId)),
        scenarioId: yield (0, $9e8i2.call)((0, $NeuAT.getScenarioId)),
        reportInfo: undefined
    };
}
function* $bea068ecc8536ec0$export$ad018cca17f6d021(savedViewsInfo, appMode) {
    // in REPORT mode, there is only one view so there is no need to initialize views
    // however, we still want to get the historical issues if there is a progress column in the view
    if (appMode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7)) yield (0, $9e8i2.put)((0, $5GdAe.fetchHistoricalIssueForView)());
    else if (savedViewsInfo) yield (0, $9e8i2.call)((0, $5GdAe.initializeViews), savedViewsInfo);
}
function* $bea068ecc8536ec0$var$doInitialLoadSetPlanSystemInfo(pageData, payload) {
    const { planDefaultsInfo: planDefaultsInfo, planInfo: planInfo, hierarchyInfo: hierarchyInfo, issueStatusCategoryInfo: issueStatusCategoryInfo, systemInfo: systemInfo, agileInfo: agileInfo, issueLinkTypesInfo: issueLinkTypesInfo, dependencySettingsInfo: dependencySettingsInfo, loadingLimitsInfo: loadingLimitsInfo, isAtlasConnectInstalled: isAtlasConnectInstalled, hasAtlasPermissions: hasAtlasPermissions } = pageData;
    yield (0, $9e8i2.put).resolve((0, $iywPH.setSystemInfo)({
        agileInfo: agileInfo,
        issueLinkTypesInfo: issueLinkTypesInfo,
        dependencySettingsInfo: dependencySettingsInfo,
        systemInfo: {
            ...systemInfo,
            ...payload
        },
        loadingLimitsInfo: loadingLimitsInfo,
        isAtlasConnectInstalled: isAtlasConnectInstalled,
        hasAtlasPermissions: hasAtlasPermissions
    }));
    yield (0, $9e8i2.put)((0, $l46YP.setPlanDefaults)(planDefaultsInfo));
    yield (0, $9e8i2.put).resolve((0, $fr1nu.setPlanInfo)({
        planInfo: planInfo,
        hierarchyInfo: hierarchyInfo,
        issueStatusCategoryInfo: issueStatusCategoryInfo
    }));
}
function* $bea068ecc8536ec0$var$doInitialLoadDependencyReportConfluenceMacro(pageData, payload, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backlogTask) {
    yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadSetPlanSystemInfo, pageData, payload);
    if ($bea068ecc8536ec0$var$isOpenApiClientEnabled) yield* $bea068ecc8536ec0$var$doBacklogOpenApi((yield (0, $9e8i2.join)(backlogTask)), pageData.planInfo.sprints);
    else yield* $bea068ecc8536ec0$var$doBacklog((yield (0, $9e8i2.join)(backlogTask)), pageData.planInfo.sprints);
    yield (0, $9e8i2.put)((0, $6owOg.setIsLoading)(false));
    yield (0, $9e8i2.put)($bea068ecc8536ec0$export$b6770a6d5ff091de());
}
function* $bea068ecc8536ec0$var$doInitialLoadTimeline(pageData, payload, appMode, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backlogTask) {
    const { planInfo: planInfo, userProperties: userProperties, savedViewsInfoFull: savedViewsInfoFull, customFieldsOptions: customFieldsOptions } = pageData;
    yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadSetPlanSystemInfo, pageData, payload);
    yield (0, $9e8i2.put)((0, $fKrBu.updateUserIsOnboarded)(Boolean(userProperties.onboadingShown)));
    if (!userProperties.onboadingShown) {
        // We only show the tour if the user is in EDIT mode
        if (appMode === (0, $99f9ac26081f8045$export$250171a898bf7ef)) yield (0, $9e8i2.put).resolve((0, $6hfzF.setIntroOpen)(true));
        // delete this condition including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
        if ((0, $430Oj.default)() && planInfo.useTwpTeams) yield (0, $9e8i2.put).resolve((0, $lUiqk.setTwpBenefitsModalShown)(true));
    // we display the TWP benefits modal only to existing customers if the migration is complete
    // and if customers haven't seen it already
    // delete this condition including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    } else if ((0, $430Oj.default)() && planInfo.useTwpTeams && !userProperties.twpBenefitsModalShown) yield (0, $9e8i2.put).resolve((0, $lUiqk.setTwpBenefitsModalOpen)(true));
    if ($bea068ecc8536ec0$var$isOpenApiClientEnabled) yield* $bea068ecc8536ec0$var$doBacklogOpenApi((yield (0, $9e8i2.join)(backlogTask)), planInfo.sprints);
    else yield* $bea068ecc8536ec0$var$doBacklog((yield (0, $9e8i2.join)(backlogTask)), planInfo.sprints);
    yield (0, $9e8i2.call)((0, $kKZNQ.doPopulateUserPickerOptions));
    yield (0, $9e8i2.put)((0, $8B14N.reset)({
        customFields: planInfo.customFields
    }));
    yield (0, $9e8i2.call)($bea068ecc8536ec0$export$ad018cca17f6d021, savedViewsInfoFull, appMode);
    yield (0, $9e8i2.put)((0, $dC8ep.calculateWarnings)());
    yield (0, $9e8i2.put)($051m9.calculateStatusOfAllReleases());
    yield (0, $9e8i2.put)((0, $6owOg.setIsLoading)(false));
    const dateWarnings = $bea068ecc8536ec0$export$ab3a3f2027ecddbb(planInfo);
    if (dateWarnings) yield (0, $9e8i2.put)((0, $dr8sv.update)(dateWarnings));
    yield (0, $9e8i2.put)($bea068ecc8536ec0$export$b6770a6d5ff091de());
    yield (0, $9e8i2.put)((0, $5GdAe.applyModificationsForInactiveViews)(savedViewsInfoFull));
    if (customFieldsOptions) {
        const selectOptions = customFieldsOptions.map(({ customFieldId: fieldId, options: options })=>options.map((option)=>$aeXAa.default('fieldId', fieldId, option))).reduce((a, b)=>a.concat(b), []);
        yield (0, $9e8i2.put)((0, $1oWqc.reset)(selectOptions));
    }
    if (payload.planView) yield (0, $9e8i2.put)((0, $k8WUU.changeActiveFilterView)(payload.planView));
}
function* $bea068ecc8536ec0$var$populateReportConfig(// eslint-disable-next-line @typescript-eslint/no-explicit-any
parameters, pageData, payload, appMode, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backlogTask) {
    switch(parameters.view){
        case 0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE:
            yield (0, $9e8i2.call)((0, $d4sjQ.populateDependencyReportFilterSettings), parameters.viewConfig.filtersV0);
            yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadDependencyReportConfluenceMacro, pageData, payload, backlogTask);
            break;
        default:
            yield (0, $9e8i2.call)((0, $5GdAe.populateReportViewSettings), parameters.viewConfig);
            yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
    }
}
function* $bea068ecc8536ec0$export$d25a2f5a3aab9b8({ payload: payload }) {
    yield (0, $9e8i2.put)((0, $6owOg.setIsLoading)(true));
    yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $8pnAg.getInitialMode)()));
    const basicPlanInfo = yield (0, $9e8i2.call)($bea068ecc8536ec0$var$getBasicRequiredPlanInfo);
    // Setting planId and scenarioId for TTI performance event.
    (0, $dYnI4.monitor).initializeContextualAnalyticsData({
        planId: basicPlanInfo.planId,
        scenarioId: basicPlanInfo.scenarioId
    });
    const appMode = yield (0, $9e8i2.select)((0, $akhOi.getMode));
    // Calling the backlog endpoint to get issue data.
    const backlogTask = yield (0, $9e8i2.fork)((0, $1jM5j.fetchBacklog), true, basicPlanInfo.planId, basicPlanInfo.scenarioId, appMode);
    // Calling /rest/jpo/1.0/info/metadata endpoint to get page data.
    const pageData = yield (0, $9e8i2.call)((0, $6MKBs.getPageDataFromInfoMetadata), basicPlanInfo);
    if (pageData === (0, $42b69a8aa6898c13$export$1c67cc6ab03450a2)) {
        yield (0, $9e8i2.put)((0, $l7qZG.setIsProjectLimitExceeded)());
        // For Report/Confluence macro we do not want to redirect as the app is not mounted in SPA
        if (appMode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7)) return;
        yield (0, $9e8i2.call)((0, $lFLge.redirect), (0, $64VaH.proxyContextSafeUrl)(`/jira/plans/${basicPlanInfo.planId}/setup`));
        return;
    }
    const { planInfo: planInfo, reportInfo: reportInfo } = pageData;
    $bea068ecc8536ec0$export$183a142021de15c4(planInfo);
    // Reports are by default read-only. Hence we want set READONLY mode only if the default mode is not REPORT
    if (appMode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7)) {
        if (!reportInfo) throw new Error('Failed to fetch report data');
        yield (0, $9e8i2.put).resolve((0, $ayiPs.setConfluenceMacroType)(reportInfo.parameters.view));
        yield (0, $9e8i2.call)($bea068ecc8536ec0$var$populateReportConfig, reportInfo.parameters, pageData, payload, appMode, backlogTask);
    } else if (planInfo.readOnly && appMode !== (0, $99f9ac26081f8045$export$f79b1fae3e63e441)) {
        yield (0, $9e8i2.put)((0, $gNoQI.setMode)((0, $99f9ac26081f8045$export$b07c15b79440feb8)));
        yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
    } else yield (0, $9e8i2.call)($bea068ecc8536ec0$var$doInitialLoadTimeline, pageData, payload, appMode, backlogTask);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $bea068ecc8536ec0$var$initialLoadWith401Handled(action) {
    try {
        yield (0, $9e8i2.call)($bea068ecc8536ec0$export$d25a2f5a3aab9b8, action);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (err instanceof Error && err.message.includes('no-jira-software-access-for-user')) {
            yield (0, $9e8i2.put)((0, $9ozqH.pushFlag)({
                key: (0, $42b69a8aa6898c13$export$a23067a331938f15)
            }));
            return;
        }
        throw err;
    }
}
function* $bea068ecc8536ec0$export$e8f373ba4bb4eba9() {
    yield (0, $bG7pV.takeLatest)((0, $74b2f27518e05c28$export$bf72183eb20c4d57), $bea068ecc8536ec0$var$initialLoadWith401Handled);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bea068ecc8536ec0$var$rootSaga = function*() {
    yield (0, $9e8i2.fork)((0, $kXDg8.default));
    yield (0, $9e8i2.fork)((0, $63O1Q.default));
    yield (0, $9e8i2.fork)((0, $dC8ep.default));
    yield (0, $9e8i2.fork)((0, $h7pZO.default)($051m9));
    yield (0, $9e8i2.fork)((0, $kKZNQ.default));
    yield (0, $9e8i2.fork)((0, $99FB5.default));
    yield (0, $9e8i2.fork)((0, $fk2gn.default));
    yield (0, $9e8i2.fork)((0, $1Szmp.default));
    yield (0, $9e8i2.fork)((0, $cTDpS.default));
    yield (0, $9e8i2.fork)((0, $agcf7.default));
    yield (0, $9e8i2.fork)((0, $9lwEQ.default));
    yield (0, $9e8i2.fork)((0, $lxYdq.default));
    yield (0, $9e8i2.fork)((0, $hLlYV.default));
    yield (0, $9e8i2.fork)((0, $8qtqq.default));
    yield (0, $9e8i2.fork)((0, $eelZZ.default));
    yield (0, $9e8i2.fork)((0, $1XIAV.default));
    yield (0, $9e8i2.fork)((0, $6itAY.default));
    yield (0, $9e8i2.fork)((0, $hI5cD.default));
    yield (0, $9e8i2.fork)((0, $5GdAe.default));
    yield (0, $9e8i2.fork)((0, $1C7Mn.default));
    yield (0, $9e8i2.fork)((0, $1eyFr.default));
    yield (0, $9e8i2.fork)((0, $8NDwu.default));
    yield (0, $9e8i2.fork)((0, $6fxQQ.default));
    yield (0, $9e8i2.fork)((0, $051m9.default)($h7pZO));
    yield (0, $9e8i2.fork)($bea068ecc8536ec0$export$e8f373ba4bb4eba9);
    yield (0, $9e8i2.fork)((0, $296Gg.default));
    yield (0, $9e8i2.fork)((0, $6hfzF.default));
    yield (0, $9e8i2.fork)((0, $heBex.default));
    yield (0, $9e8i2.fork)((0, $jwhcr.default));
    yield (0, $9e8i2.fork)((0, $2L2I7.default));
    yield (0, $9e8i2.fork)((0, $4zflJ.default));
    // delete this condition including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    if ((0, $430Oj.default)()) yield (0, $9e8i2.fork)((0, $lUiqk.default));
};
function* $bea068ecc8536ec0$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)((0, $cbq3D.default));
    while(true)try {
        yield (0, $9e8i2.call)($bea068ecc8536ec0$var$rootSaga);
        break;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}

});
parcelRegister("kGWdh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f104e2d14d8a6733$export$2e2bcd8739ae039);

var $eSWTK = parcelRequire("eSWTK");

var $erwaN = parcelRequire("erwaN");
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $f104e2d14d8a6733$var$invertObj = /*#__PURE__*/ (0, $eSWTK.default)(function invertObj(obj) {
    var props = (0, $erwaN.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $f104e2d14d8a6733$export$2e2bcd8739ae039 = $f104e2d14d8a6733$var$invertObj;

});

parcelRegister("lUiqk", function(module, exports) {

$parcel$export(module.exports, "setTwpBenefitsModalOpen", () => $00a58fb577030a6a$export$aa6de96b4da13b86);
$parcel$export(module.exports, "setTwpBenefitsModalShown", () => $00a58fb577030a6a$export$737382d4fc71bd3b);
$parcel$export(module.exports, "default", () => $00a58fb577030a6a$export$2e2bcd8739ae039);
// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");


var $5rVFi = parcelRequire("5rVFi");

var $7b9QQ = parcelRequire("7b9QQ");

const $00a58fb577030a6a$export$aa6de96b4da13b86 = (payload)=>({
        type: (0, $b5e6defa10b961e2$export$7270779d12b502c5),
        payload: payload
    });
const $00a58fb577030a6a$export$737382d4fc71bd3b = (payload)=>({
        type: (0, $a9ff6029a2d94121$export$3b2f16474ca3df8e),
        payload: payload
    });
function* $00a58fb577030a6a$export$fb7d918510127bf7({ payload: payload }) {
    try {
        const url = (0, $7b9QQ.urls).set;
        const body = (0, $7b9QQ.setUserPropertyBody)('twpBenefitsModalShown', payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $00a58fb577030a6a$export$19825b06a7e13a13() {
    yield (0, $bG7pV.takeEvery)((0, $a9ff6029a2d94121$export$3b2f16474ca3df8e), $00a58fb577030a6a$export$fb7d918510127bf7);
}
function* $00a58fb577030a6a$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($00a58fb577030a6a$export$19825b06a7e13a13);
}

});
// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
const $b5e6defa10b961e2$export$7270779d12b502c5 = 'state.ui.twp-benefits-modal.SET_TWP_BENEFITS_MODAL_OPEN';

parcelRegister("7b9QQ", function(module, exports) {

$parcel$export(module.exports, "urls", () => $813bdbbcd87db436$export$bcae9ba627f604b6);
$parcel$export(module.exports, "setUserPropertyBody", () => $813bdbbcd87db436$export$4901ba1ed7ae3875);
// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
const $813bdbbcd87db436$export$bcae9ba627f604b6 = {
    set: '/rest/jpo/1.0/pluginUserProperties/set'
};
const $813bdbbcd87db436$export$4901ba1ed7ae3875 = (key, value)=>({
        key: key,
        value: value
    });

});

const $a9ff6029a2d94121$export$3b2f16474ca3df8e = 'command.twp-benefits-modal.SET_TWP_BENEFITS_MODAL_SHOWN';


parcelRegister("8pnAg", function(module, exports) {

$parcel$export(module.exports, "getInitialMode", () => $d485ee00177e8c85$export$31f8cb84db5999fd);
$parcel$export(module.exports, "default", () => $d485ee00177e8c85$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");

var $fr1nu = parcelRequire("fr1nu");

var $lFLge = parcelRequire("lFLge");

var $9kmw7 = parcelRequire("9kmw7");

var $gNoQI = parcelRequire("gNoQI");

const $d485ee00177e8c85$export$31f8cb84db5999fd = ()=>{
    if ((0, $lFLge.isReportView)()) return 0, $99f9ac26081f8045$export$e3d31417f21c1ce7;
    if ((0, $lFLge.isExportView)()) return 0, $99f9ac26081f8045$export$f79b1fae3e63e441;
    return 0, $99f9ac26081f8045$export$250171a898bf7ef;
};
const $d485ee00177e8c85$var$getInitialState = ()=>({
        mode: $d485ee00177e8c85$export$31f8cb84db5999fd(),
        analyticsEvent: (0, $9kmw7.createTestEvent)(),
        hasReportedInitialLoadAnalytics: false,
        isPlanInfoReady: false,
        isExportPreview: (0, $lFLge.isExportPreview)()
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d485ee00177e8c85$export$2e2bcd8739ae039 = (state = $d485ee00177e8c85$var$getInitialState(), action)=>{
    switch(action.type){
        case 0, $gNoQI.REPORT_INITIAL_LOAD_ANALYTICS:
            return {
                ...state,
                hasReportedInitialLoadAnalytics: true
            };
        case 0, $gNoQI.SET_MODE:
            {
                const mode = action.payload;
                if (state.mode === (0, $99f9ac26081f8045$export$b07c15b79440feb8)) return state;
                return $aeXAa.default('mode', mode, state);
            }
        case 0, $gNoQI.SET_ANALYTICS_EVENT:
            {
                const analyticsEvent = action.payload;
                return $aeXAa.default('analyticsEvent', analyticsEvent, state);
            }
        case 0, $fr1nu.SET_PLAN_INFO:
            return $aeXAa.default('isPlanInfoReady', true, state);
        case 0, $gNoQI.SET_IS_EXPORT_PREVIEW:
            return $aeXAa.default('isExportPreview', action.payload, state);
        case 0, $gNoQI.SET_BROWSER_HISTORY:
            {
                const browserHistory = action.payload;
                return $aeXAa.default('browserHistory', browserHistory, state);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("9kmw7", function(module, exports) {

$parcel$export(module.exports, "createTestEvent", () => $afb81dcb7058a451$export$85f5d5efce614e62);

var $cPQ3Q = parcelRequire("cPQ3Q");
const $afb81dcb7058a451$export$85f5d5efce614e62 = (payload = {
    payload: {
        action: 'thisIsADumyAction',
        actionSubject: 'thisIsADumyActionSubject'
    }
})=>new (0, $cPQ3Q.default)(payload);

});


parcelRegister("l46YP", function(module, exports) {

$parcel$export(module.exports, "SET_PLAN_DEFAULTS", () => $9ae40c23d9a12ee7$export$2f67879ed146c53a);
$parcel$export(module.exports, "setPlanDefaults", () => $9ae40c23d9a12ee7$export$6bd5a8361ba5d3f);
const $9ae40c23d9a12ee7$export$2f67879ed146c53a = 'state.domain.planDefaults.SET_PLAN_DEFAULTS';
const $9ae40c23d9a12ee7$export$6bd5a8361ba5d3f = (payload)=>({
        type: $9ae40c23d9a12ee7$export$2f67879ed146c53a,
        payload: payload
    });

});

parcelRegister("iywPH", function(module, exports) {

$parcel$export(module.exports, "SET_SYSTEM_INFO", () => $07b018b3c9b6b39a$export$988c147bb85b1b82);
$parcel$export(module.exports, "setSystemInfo", () => $07b018b3c9b6b39a$export$a6d44ded8a2c25c6);
const $07b018b3c9b6b39a$export$988c147bb85b1b82 = 'state.domain.system.SET_SYSTEM_INFO';
const $07b018b3c9b6b39a$export$a6d44ded8a2c25c6 = (payload)=>({
        type: $07b018b3c9b6b39a$export$988c147bb85b1b82,
        payload: payload
    });

});

parcelRegister("fKrBu", function(module, exports) {

$parcel$export(module.exports, "UPDATE", () => $9ce6fd7d327067b8$export$e271b26eefe41db8);
$parcel$export(module.exports, "updateUserIsOnboarded", () => $9ce6fd7d327067b8$export$20517a0faa9bbb17);
const $9ce6fd7d327067b8$export$e271b26eefe41db8 = 'state.ui.eap.UPDATE';
const $9ce6fd7d327067b8$export$20517a0faa9bbb17 = (payload)=>({
        type: $9ce6fd7d327067b8$export$e271b26eefe41db8,
        payload: payload
    });

});

parcelRegister("ayiPs", function(module, exports) {

$parcel$export(module.exports, "SET_CONFLUENCE_MACRO_TYPE", () => $083bc3a094db33d7$export$47da29bdd98ccf6e);
$parcel$export(module.exports, "setConfluenceMacroType", () => $083bc3a094db33d7$export$ba97b0acf6b6d58f);
const $083bc3a094db33d7$export$47da29bdd98ccf6e = 'state.ui.confluence-macro.SET_CONFLUENCE_MACRO_TYPE';
const $083bc3a094db33d7$export$ba97b0acf6b6d58f = (payload)=>({
        type: $083bc3a094db33d7$export$47da29bdd98ccf6e,
        payload: payload
    });

});

parcelRegister("4a0ar", function(module, exports) {

$parcel$export(module.exports, "extractStartDateField", () => $e8225d5cdde07ae3$export$5840ec613b05dae0);

var $eOsHk = parcelRequire("eOsHk");
const $e8225d5cdde07ae3$export$5840ec613b05dae0 = (planInfo)=>{
    const startDateCustomField = planInfo.customFields.find((field)=>field.defaultStartDateCustomField);
    if (!startDateCustomField) throw new Error('missing Start Date Custom field in server response');
    return {
        id: `customfield_${startDateCustomField.id}`,
        key: `${startDateCustomField.id}`,
        type: (0, $eOsHk.DATEFIELD_TYPES).CUSTOM
    };
};

});

parcelRegister("d4sjQ", function(module, exports) {

$parcel$export(module.exports, "populateDependencyReportFilterSettings", () => $ebb1fe43a2581663$export$9f242b44e4270ddf);
$parcel$export(module.exports, "setIssueFilter", () => (parcelRequire("2DO1r")).setIssueFilter);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $2DO1r = parcelRequire("2DO1r");
function* $ebb1fe43a2581663$export$9f242b44e4270ddf(// eslint-disable-next-line @typescript-eslint/no-explicit-any
filterSettings) {
    yield (0, $9e8i2.put)((0, $2DO1r.initiateFilters)(filterSettings));
}

});

parcelRegister("6itAY", function(module, exports) {

$parcel$export(module.exports, "CLICK_EXPORT_TO_CSV_ANALYTICS", () => $363d09bab7a6409d$export$aeee1a25bc7adb7d);
$parcel$export(module.exports, "PLAN_EXPORTED_ANALYTICS", () => $363d09bab7a6409d$export$d0842f9ff391ee31);
$parcel$export(module.exports, "planExportedAnalytics", () => $363d09bab7a6409d$export$b46290bf6060fea2);
$parcel$export(module.exports, "EXPORT_EVENT_TYPE", () => $363d09bab7a6409d$export$deb2e5b0ecff69f9);
$parcel$export(module.exports, "getExportCsvScopeItems", () => $363d09bab7a6409d$export$982142380268f802);
$parcel$export(module.exports, "default", () => $363d09bab7a6409d$export$2e2bcd8739ae039);

var $fG8Rc = parcelRequire("fG8Rc");

var $f7Op5 = parcelRequire("f7Op5");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $l2Sj2 = parcelRequire("l2Sj2");

var $1Szmp = parcelRequire("1Szmp");

var $6VhAf = parcelRequire("6VhAf");

var $YxFn4 = parcelRequire("YxFn4");

var $lvJU2 = parcelRequire("lvJU2");

var $kKj1m = parcelRequire("kKj1m");

var $5fUv6 = parcelRequire("5fUv6");

var $bpu1R = parcelRequire("bpu1R");

var $jp3RH = parcelRequire("jp3RH");

var $kFf60 = parcelRequire("kFf60");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $aK3ri = parcelRequire("aK3ri");

var $KA559 = parcelRequire("KA559");

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $aMoMC = parcelRequire("aMoMC");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $70w9h = parcelRequire("70w9h");

var $3IuGJ = parcelRequire("3IuGJ");
const $363d09bab7a6409d$export$a8eb40e0b086759e = 'command.export-roadmap.CLICK_EXPORT_TO_CSV';
const $363d09bab7a6409d$export$aeee1a25bc7adb7d = 'command.export-roadmap.CLICK_EXPORT_TO_CSV_ANALYTICS';
const $363d09bab7a6409d$export$d0842f9ff391ee31 = 'command.export-roadmap.PLAN_EXPORTED_ANALYTICS';
const $363d09bab7a6409d$export$b46290bf6060fea2 = (payload)=>({
        type: $363d09bab7a6409d$export$d0842f9ff391ee31,
        payload: payload
    });
const $363d09bab7a6409d$export$deb2e5b0ecff69f9 = {
    PNG: '.png',
    CSV: '.csv',
    LINK: 'Link',
    EMBED: 'Embed',
    CONFLUENCE: 'Confluence',
    DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
};
const $363d09bab7a6409d$export$982142380268f802 = (csvIntlMessages, additionalData)=>({
        type: $363d09bab7a6409d$export$a8eb40e0b086759e,
        csvIntlMessages: csvIntlMessages,
        additionalData: additionalData
    });
function* $363d09bab7a6409d$export$b4d6459e13978f3c({ csvIntlMessages: csvIntlMessages, additionalData: { goalsByARI: goalsByARI } = {
    goalsByARI: {}
} }) {
    const assigneesById = yield (0, $9e8i2.select)((0, $6VhAf.getAssigneesById));
    const reportersById = yield (0, $9e8i2.select)((0, $KA559.getReportersById));
    const componentsById = yield (0, $9e8i2.select)((0, $lvJU2.getComponentsById));
    const allCustomFields = yield (0, $9e8i2.select)((0, $kKj1m.getCustomFields));
    const dateConfiguration = yield (0, $9e8i2.select)((0, $75KhQ.getDateConfiguration));
    const estimateFromHistoryIssues = yield (0, $9e8i2.select)((0, $YxFn4.getEstimateFromHistoryIssues));
    const externalSprintsById = yield (0, $9e8i2.select)((0, $c1XMU.getExternalSprintsById));
    const externalTeamsById = yield (0, $9e8i2.select)((0, $MQRDu.getAdditionalTeamsById));
    const issueIdToDescendantsIdMap = yield (0, $9e8i2.select)((0, $kwMvv.getDescendantIdsByParent));
    const issueMapById = yield (0, $9e8i2.select)((0, $cwP4d.getIssueMapById));
    const issuePrioritiesById = yield (0, $9e8i2.select)((0, $jp3RH.getIssuePriorities));
    const issueStatusesById = yield (0, $9e8i2.select)((0, $kFf60.getIssueStatusById));
    const issues = yield (0, $9e8i2.select)((0, $cwP4d.getIssues));
    const issueTypesById = yield (0, $9e8i2.select)((0, $lihml.getIssueTypesById));
    const plan = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const projectsById = yield (0, $9e8i2.select)((0, $ehEr2.getProjectsById));
    const rollUpMap = yield (0, $9e8i2.select)((0, $aK3ri.getRollupMap));
    const scopeItemsForExport = yield (0, $9e8i2.select)((0, $bpu1R.getScopeItemsForExport));
    const showRolledUpDates = yield (0, $9e8i2.select)((0, $9H2AP.getShowRolledUpDates));
    const showRolledUpOthers = yield (0, $9e8i2.select)((0, $9H2AP.getShowRolledUpOthers));
    const selectOptionsById = yield (0, $9e8i2.select)((0, $kKj1m.getSelectOptionsById));
    const sprintsById = yield (0, $9e8i2.select)((0, $c1XMU.getSprintByIdMap));
    const systemInfo = yield (0, $9e8i2.select)((0, $dhHiZ.getSystemInfo));
    const teamsById = yield (0, $9e8i2.select)((0, $MQRDu.getTeamsById));
    const userPickerOptions = yield (0, $9e8i2.select)((0, $kKj1m.getUserPickerOptions));
    const isAtlasConnectInstalled = yield (0, $9e8i2.select)((0, $dhHiZ.isAtlasConnectInstalled));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let userPickerOptionsById = {};
    if (userPickerOptions?.userList) userPickerOptionsById = (0, $7CnHa.indexBy)($f7Op5.default('value'), userPickerOptions.userList);
    const versions = yield (0, $9e8i2.select)((0, $wcCGG.getVersions));
    yield (0, $9e8i2.call)((0, $1Szmp.getHistoricalDoneIssues));
    const historyIssues = yield (0, $9e8i2.select)((0, $kwMvv.getHistoryIssues));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const scopeItems = scopeItemsForExport.map((issue)=>{
        const { assignee: assignee, reporter: reporter, components: components, dueDate: dueDate, fixVersions: fixVersions, id: id, labels: labels, parent: parent, priority: priority, project: project, status: status, summary: summary, targetEnd: targetEnd, targetStart: targetStart, team: team, type: type, customFields: customFields, goals: goals } = issue;
        // standard fields data
        const dataRecordStandardFields = {
            assignee: assignee ? (0, $3IuGJ.getIssueAssigneeName)(assignee, assigneesById) : '',
            reporter: reporter ? (0, $3IuGJ.getIssueReporterName)(reporter, reportersById) : '',
            components: components && components.length ? (0, $3IuGJ.joinIssueComponents)(components, componentsById) : '',
            dueDate: dueDate ? (0, $l2Sj2.formatDateUTC)(dueDate, (0, $5rYNM.DefaultDateFormat)) : '',
            estimate: (0, $5fUv6.getEstimateValue)(plan.planningUnit, issue, systemInfo.jiraHoursPerDay) || '',
            key: (0, $3IuGJ.getIssueKey)(issue, projectsById) || '',
            labels: labels ? (0, $3IuGJ.joinIssueLabels)(labels) : '',
            parent: parent ? (0, $3IuGJ.getIssueParentSummary)(parent, issueMapById) : '',
            priority: priority ? (0, $3IuGJ.getIssuePriorityName)(priority, issuePrioritiesById) : '',
            project: project ? (0, $3IuGJ.getIssueProjectName)(project, projectsById) : '',
            release: fixVersions ? (0, $3IuGJ.getIssueReleaseName)(fixVersions, versions) : '',
            sprint: (0, $3IuGJ.getIssueSprintName)(issue, sprintsById, externalSprintsById, csvIntlMessages) || '',
            status: status ? (0, $3IuGJ.getIssueStatusName)(status, issueStatusesById) : '',
            summary: summary || '',
            targetEnd: targetEnd ? (0, $l2Sj2.formatDateUTC)(targetEnd, (0, $5rYNM.DefaultDateFormat)) : '',
            targetStart: targetStart ? (0, $l2Sj2.formatDateUTC)(targetStart, (0, $5rYNM.DefaultDateFormat)) : '',
            team: team ? (0, $3IuGJ.getIssueTeamName)(team, teamsById, externalTeamsById, csvIntlMessages) : '',
            type: type ? (0, $3IuGJ.getIssueTypeName)(type, issueTypesById) : ''
        };
        // rolled-up / inferred data for date fields
        let dataRecordRolledUpOrInferredDateFields = {};
        // if the setting "Configuration > Use sprint dates when issues don't have start and end dates" is enabled OR
        // if view settings > Roll-up > Dates is enabled
        if (plan.issueInferredDateSelection || showRolledUpDates) dataRecordRolledUpOrInferredDateFields = (0, $3IuGJ.getIssueInferredDates)(issue, dateConfiguration);
        // rolled-up data for other standard fields
        let dataRecordRollupOtherFields = {};
        if (showRolledUpOthers) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { sprint: sprint, estimate: estimate, release: release, team: team } = rollUpMap[id];
            dataRecordRollupOtherFields = {
                sprintRollUp: sprint ? (0, $3IuGJ.getIssueRollUpSprintName)(sprint, sprintsById, externalSprintsById, csvIntlMessages.labels.completed) : '',
                estimateRollUp: (0, $5fUv6.getEstimateRollupValue)(estimate, plan.planningUnit, systemInfo.jiraHoursPerDay) || '',
                releaseRollUp: release ? (0, $3IuGJ.getIssueReleaseName)(release, versions) : '',
                teamRollUp: team ? (0, $3IuGJ.getIssueRollupTeamNames)(team, teamsById, externalTeamsById, csvIntlMessages) : ''
            };
        }
        // issue progress estimate breakdown
        const dataRecordProgressEstimateFields = (0, $3IuGJ.getIssueEstimateProgressBreakdown)(issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, plan.planningUnit, systemInfo.jiraHoursPerDay, estimateFromHistoryIssues);
        // issue progress count breakdown
        const dataRecordProgressCountFields = (0, $3IuGJ.getIssueCountProgressBreakdown)(issue, issues, issueStatusesById, issueMapById, historyIssues);
        // custom fields - ordered the same way as they appear in the Custom fields management page
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataRecordCustomFields = allCustomFields && allCustomFields.length && customFields ? allCustomFields.reduce((accumulator, customField)=>{
            accumulator[customField.id] = (0, $3IuGJ.getIssueCustomFieldValue)(customFields, customField, selectOptionsById, userPickerOptionsById) || '';
            return accumulator;
        }, {}) : {};
        return {
            ...dataRecordStandardFields,
            ...dataRecordProgressEstimateFields,
            ...dataRecordProgressCountFields,
            ...dataRecordCustomFields,
            ...dataRecordRolledUpOrInferredDateFields,
            ...dataRecordRollupOtherFields,
            ...isAtlasConnectInstalled ? (0, $70w9h.getGoalValues)(goals, goalsByARI) : {}
        };
    });
    // triggering analytics event
    yield (0, $9e8i2.put)({
        type: $363d09bab7a6409d$export$aeee1a25bc7adb7d,
        payload: {
            issueExportCount: scopeItems && scopeItems.length ? scopeItems.length : 0
        }
    });
    // transforming data into CSV format
    const csvData = new Blob([
        (0, $3IuGJ.prepareCSVData)(allCustomFields, plan.planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, scopeItems, isAtlasConnectInstalled)
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    // triggering the download of the CSV file
    const exportName = csvIntlMessages.exportName;
    (0, $fG8Rc.saveAs)(csvData, (0, $3IuGJ.getExportCsvFileName)(exportName, (0, $aMoMC.getTodayDate)()));
    // triggering plan exported analytics event
    yield (0, $9e8i2.put)($363d09bab7a6409d$export$b46290bf6060fea2({
        exportFormat: $363d09bab7a6409d$export$deb2e5b0ecff69f9.CSV
    }));
}
function* $363d09bab7a6409d$export$c582f49da0d1e51() {
    yield (0, $bG7pV.takeEvery)($363d09bab7a6409d$export$a8eb40e0b086759e, $363d09bab7a6409d$export$b4d6459e13978f3c);
}
function* $363d09bab7a6409d$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($363d09bab7a6409d$export$c582f49da0d1e51);
}

});
parcelRegister("fG8Rc", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $b6a1a615ff478201$var$saveAs = $b6a1a615ff478201$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (0, module.exports) module.exports.saveAs = $b6a1a615ff478201$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $b6a1a615ff478201$var$saveAs;
});

});

parcelRegister("bpu1R", function(module, exports) {

$parcel$export(module.exports, "getScopeItemsForExport", () => $2ba2e8fe72955d56$export$4dcfa5cdaa5f20c1);

var $fbHoQ = parcelRequire("fbHoQ");

var $40hi6 = parcelRequire("40hi6");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");
const $2ba2e8fe72955d56$export$f9b9f1184e09598e = (issuesWithOriginalsAndOptimized, isExpanded, filters)=>{
    const { [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: { value: { start: start, end: end } } } = filters;
    const issuesById = (0, $7CnHa.indexBy)(({ id: id })=>id, issuesWithOriginalsAndOptimized);
    const issuesByParent = (0, $7CnHa.groupBy)(({ parent: parent })=>parent || '', issuesWithOriginalsAndOptimized.filter(({ parent: parent })=>parent));
    const scopeItems = (0, $40hi6.buildScope)(issuesWithOriginalsAndOptimized, issuesByParent, issuesById, isExpanded, start, end, '', undefined, issuesWithOriginalsAndOptimized, true);
    const issuesWithoutParent = scopeItems.issuesWithoutParent.flatMap((item)=>item.issues);
    const items = [
        ...scopeItems.startLevelIssues.issues,
        ...issuesWithoutParent
    ];
    return items;
};
const $2ba2e8fe72955d56$export$4dcfa5cdaa5f20c1 = (0, $iK4oF.createSelector)([
    (0, $40hi6.getIssuesWithOriginalsAndOptimized),
    (0, $40hi6.getIsExpanded),
    (0, $fbHoQ.getFilters)
], $2ba2e8fe72955d56$export$f9b9f1184e09598e);

});

parcelRegister("70w9h", function(module, exports) {

$parcel$export(module.exports, "getGoalValues", () => $9eea1c4839b68b26$export$abab68205e6c1d55);

const $9eea1c4839b68b26$export$abab68205e6c1d55 = (issueGoalARIs = [], goalsByARI)=>issueGoalARIs.reduce((goalValues, issueGoalARI)=>{
        const goal = goalsByARI[issueGoalARI];
        if (goal !== undefined) {
            // goal names
            goalValues[0, $d3ec7873a55d3e9b$export$c029c3f1c363635d].push(goal.name);
            // goal statuses
            const goalStatus = goal?.state?.label;
            if (goalStatus !== undefined) goalValues[0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9].push(goalStatus);
        }
        return goalValues;
    }, {
        [(0, $d3ec7873a55d3e9b$export$c029c3f1c363635d)]: [],
        [(0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9)]: []
    });

});
const $d3ec7873a55d3e9b$export$c029c3f1c363635d = 'goalName';
const $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9 = 'goalStatus';


parcelRegister("3IuGJ", function(module, exports) {

$parcel$export(module.exports, "getIssueTypeName", () => $2e8a3de252d2450f$export$7fbe5338a34739de);
$parcel$export(module.exports, "getIssueProjectName", () => $2e8a3de252d2450f$export$6c241f86e023d701);
$parcel$export(module.exports, "getIssueReleaseName", () => $2e8a3de252d2450f$export$84c842134cc1fd5b);
$parcel$export(module.exports, "getIssueTeamName", () => $2e8a3de252d2450f$export$97d1f1aabb59f95);
$parcel$export(module.exports, "getIssueAssigneeName", () => $2e8a3de252d2450f$export$3a850b8a681ae00c);
$parcel$export(module.exports, "getIssueReporterName", () => $2e8a3de252d2450f$export$b558665a8c393051);
$parcel$export(module.exports, "getIssueSprintName", () => $2e8a3de252d2450f$export$87ef4e1f3d511d73);
$parcel$export(module.exports, "getIssueRollupTeamNames", () => $2e8a3de252d2450f$export$f0f50e989285e516);
$parcel$export(module.exports, "getIssueRollUpSprintName", () => $2e8a3de252d2450f$export$ef7f668cfde40b02);
$parcel$export(module.exports, "getIssueInferredDates", () => $2e8a3de252d2450f$export$461993bb60cf4f52);
$parcel$export(module.exports, "getIssueParentSummary", () => $2e8a3de252d2450f$export$e0f55aa59712c593);
$parcel$export(module.exports, "getIssuePriorityName", () => $2e8a3de252d2450f$export$4978b3d56d2e8888);
$parcel$export(module.exports, "joinIssueLabels", () => $2e8a3de252d2450f$export$3fb12692aa6c9f2a);
$parcel$export(module.exports, "joinIssueComponents", () => $2e8a3de252d2450f$export$b4ac423912d147e4);
$parcel$export(module.exports, "getIssueKey", () => $2e8a3de252d2450f$export$4a030f6192bebe03);
$parcel$export(module.exports, "getIssueCustomFieldValue", () => $2e8a3de252d2450f$export$97d480ec651a5128);
$parcel$export(module.exports, "getIssueStatusName", () => $2e8a3de252d2450f$export$9ae9a4e7a54bf810);
$parcel$export(module.exports, "getIssueEstimateProgressBreakdown", () => $2e8a3de252d2450f$export$8ad3db919cdd9608);
$parcel$export(module.exports, "getIssueCountProgressBreakdown", () => $2e8a3de252d2450f$export$ff7aae3d2c7f6af0);
$parcel$export(module.exports, "getExportCsvFileName", () => $2e8a3de252d2450f$export$e88b298904081119);
$parcel$export(module.exports, "getExportPngFileName", () => $2e8a3de252d2450f$export$311cf81586e3cd12);
$parcel$export(module.exports, "prepareCSVData", () => $2e8a3de252d2450f$export$63353f144eea0dc4);

var $hkOxK = parcelRequire("hkOxK");
var $aP1ZI = parcelRequire("aP1ZI");
var $haaWO = parcelRequire("haaWO");
var $cQGVO = parcelRequire("cQGVO");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $l7xwn = parcelRequire("l7xwn");
var $UCNmJ = parcelRequire("UCNmJ");

var $1ybV0 = parcelRequire("1ybV0");

var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");
parcelRequire("kwMvv");
var $aK3ri = parcelRequire("aK3ri");

var $iN8yE = parcelRequire("iN8yE");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $fJsYU = parcelRequire("fJsYU");

var $8Vy9J = parcelRequire("8Vy9J");

const $2e8a3de252d2450f$var$DateTypes = {
    Start: 'START',
    End: 'END',
    Other: 'OTHER'
};
const $2e8a3de252d2450f$var$issueField = {
    [$2e8a3de252d2450f$var$DateTypes.Start]: 'baselineStart',
    [$2e8a3de252d2450f$var$DateTypes.End]: 'baselineEnd',
    [$2e8a3de252d2450f$var$DateTypes.Other]: undefined
};
const $2e8a3de252d2450f$export$7fbe5338a34739de = (issueTypeId, issueTypesById)=>{
    const issueType = issueTypesById[String(issueTypeId)];
    if (issueType) return issueType.name;
    return null;
};
const $2e8a3de252d2450f$export$6c241f86e023d701 = (issueProjectId, projectsById)=>{
    const issueProject = projectsById[issueProjectId];
    if (issueProject) return issueProject.name;
    return null;
};
const $2e8a3de252d2450f$export$84c842134cc1fd5b = (issueFixVersions, versions)=>{
    const issueRelease = issueFixVersions.map((fixVersion)=>{
        const issueReleaseData = versions.find(({ id: id })=>id === fixVersion);
        if (issueReleaseData) return issueReleaseData.name;
        return null;
    }).filter(Boolean);
    if (issueRelease && issueRelease.length) return issueRelease.join(', ');
    return null;
};
const $2e8a3de252d2450f$export$97d1f1aabb59f95 = (issueTeamId, teamsById, externalTeamsById, csvIntlMessages)=>{
    // if the issue is in an internal team
    if (teamsById[issueTeamId]) return teamsById[issueTeamId].title;
    // if the issue is in an external team
    if (externalTeamsById[issueTeamId]) return `${externalTeamsById[issueTeamId].title} ${csvIntlMessages.labels.external}`;
    return null;
};
const $2e8a3de252d2450f$export$3a850b8a681ae00c = (issueAssigneeId, assigneesById)=>{
    if (issueAssigneeId === 'unassigned') return null;
    const assignee = assigneesById[issueAssigneeId];
    if (assignee) return assignee.jiraUser && assignee.jiraUser.title;
    return null;
};
const $2e8a3de252d2450f$export$b558665a8c393051 = (issueReporterId, reportersById)=>{
    const reporter = reportersById[issueReporterId];
    if (reporter) return reporter.jiraUser && reporter.jiraUser.title;
    return null;
};
const $2e8a3de252d2450f$export$87ef4e1f3d511d73 = (issue, sprintsById, externalSprintsById, csvIntlMessages)=>{
    // this array will include al
    let issueSprintNames = [];
    // if the issue is in a current/future sprint
    if ((0, $7CnHa.isDefined)(issue.sprint)) {
        // if the issue is in a current/future INTERNAL sprint
        if (sprintsById[issue.sprint]) issueSprintNames.push(sprintsById[issue.sprint].title);
        else if (externalSprintsById[issue.sprint]) issueSprintNames.push(`${externalSprintsById[issue.sprint].title} ${csvIntlMessages.labels.external}`);
    }
    // if the issue is in completed sprints
    if (issue.completedSprints && issue.completedSprints.length) // for each completed sprint, we merge the current/future sprint names with the completed sprint names
    issueSprintNames = [
        ...issueSprintNames,
        ...issue.completedSprints.map((completedSprint)=>{
            // if the issue is in a completed INTERNAL sprint
            if (sprintsById[completedSprint]) return `${sprintsById[completedSprint].title} ${csvIntlMessages.labels.completed}`;
            // if the issue is in a completed EXTERNAL sprint
            if (externalSprintsById[completedSprint]) return `${externalSprintsById[completedSprint].title} ${csvIntlMessages.labels.external} ${csvIntlMessages.labels.completed}`;
            return null;
        }).filter(Boolean)
    ];
    // if there are sprint names, we join them with " + " the same way it is done in the timeline of issues
    if (issueSprintNames && issueSprintNames.length) return issueSprintNames.join(' + ');
    return null;
};
const $2e8a3de252d2450f$export$f0f50e989285e516 = (teamIds, teamsById, externalTeamsById, csvIntlMessages)=>(0, $1ybV0.ff)('export-roadmaps-utils_p0zmt') ? teamIds.map((id)=>$2e8a3de252d2450f$export$97d1f1aabb59f95(id, teamsById, externalTeamsById, csvIntlMessages) || '').join(', ') : $hkOxK.default($haaWO.default(', '), $cQGVO.default((id)=>$2e8a3de252d2450f$export$97d1f1aabb59f95(id, teamsById, externalTeamsById, csvIntlMessages) || ''))(teamIds);
const $2e8a3de252d2450f$export$ef7f668cfde40b02 = (sprintRollUpForIssue, sprintsById, externalSprintsById, completedSprintsMsg)=>{
    const mapSprintNames = (ids)=>(ids || []).map((sprintId)=>{
            const externalSprint = externalSprintsById[sprintId];
            const sprint = sprintsById[sprintId] || {};
            return externalSprint ? externalSprint.title : sprint.title || completedSprintsMsg;
        });
    return (0, $1ybV0.ff)('export-roadmaps-utils_p0zmt') ? mapSprintNames(sprintRollUpForIssue).sort((a, b)=>a.localeCompare(b)).join(', ') : $hkOxK.default($haaWO.default(', '), $l7xwn.default((a, b)=>a.localeCompare(b)), mapSprintNames)(sprintRollUpForIssue);
};
const $2e8a3de252d2450f$export$fd2749ffa89ee868 = (issue, dateType)=>{
    const issueFieldDateType = $2e8a3de252d2450f$var$issueField[dateType];
    const date = typeof issueFieldDateType !== 'undefined' ? issue[issueFieldDateType] : undefined;
    return (0, $7CnHa.isDefined)(date) ? (0, $l2Sj2.formatDateUTC)(date, (0, $5rYNM.DefaultDateFormat)) : '';
};
const $2e8a3de252d2450f$export$584f5c625cd2e6d8 = (issue, type)=>{
    if (type !== $2e8a3de252d2450f$var$DateTypes.Other) {
        const attribute = $2e8a3de252d2450f$var$issueField[type];
        if ((0, $1ybV0.ff)('export-roadmaps-utils_p0zmt')) {
            const inferredFrom = issue?.inferred?.[attribute] ?? (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE;
            return inferredFrom;
        }
        const inferredFrom = $kjklK.default([
            'inferred',
            attribute
        ], issue);
        return inferredFrom || (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE;
    }
    return (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).NONE;
};
const $2e8a3de252d2450f$export$461993bb60cf4f52 = (issue, dateConfiguration)=>/**
 * Example 1:
 * "Use sprint dates when issues don't have start and end dates" is enabled
 * "View settings > Roll-up > Dates" is enabled
 * The plan's Start date is "Target start" and the plan's End date is "Due date"
 * The issue is a story with:
 * - no target start, but has one sub-task whose target start is 02/Apr/20
 * - a due date set to 14/Apr/20
 * Then the object returned is {targetStartRollUp: "02/Apr/20", dueDate: "14/Apr/20"}
 *
 * Example 2:
 * "Use sprint dates when issues don't have start and end dates" is enabled
 * "View settings > Roll-up > Dates" is enabled
 * The plan's Start date is "Custom date" (a custom field) and the plan's End date is "Target end"
 * The issue is a story:
 * - with no custom date and no target end date set
 * - assigned to a sprint which starts on 23/Mar/20 and ends on 06/Apr/20
 * Then the object returned is {10202: "23/Mar/20", targetEnd: "06/Apr/20"}
 *
 */ ({
        [`${dateConfiguration.baselineStartField.key}${$2e8a3de252d2450f$export$584f5c625cd2e6d8(issue, $2e8a3de252d2450f$var$DateTypes.Start) === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP ? 'RollUp' : ''}`]: $2e8a3de252d2450f$export$fd2749ffa89ee868(issue, $2e8a3de252d2450f$var$DateTypes.Start),
        [`${dateConfiguration.baselineEndField.key}${$2e8a3de252d2450f$export$584f5c625cd2e6d8(issue, $2e8a3de252d2450f$var$DateTypes.End) === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).ROLL_UP ? 'RollUp' : ''}`]: $2e8a3de252d2450f$export$fd2749ffa89ee868(issue, $2e8a3de252d2450f$var$DateTypes.End)
    });
const $2e8a3de252d2450f$export$e0f55aa59712c593 = (issueParentId, issueMapById)=>{
    const issueParent = issueMapById[issueParentId];
    if (issueParent) return issueParent.summary;
    return null;
};
const $2e8a3de252d2450f$export$4978b3d56d2e8888 = (issuePriorityId, issuePriorities)=>{
    const issuePriority = issuePriorities[issuePriorityId];
    if (issuePriority) return issuePriority.name;
    return null;
};
const $2e8a3de252d2450f$export$3fb12692aa6c9f2a = (issueLabels)=>issueLabels.join(', ');
const $2e8a3de252d2450f$export$b4ac423912d147e4 = (issueComponents, componentsById)=>{
    // the issue can have one to many components stored in an array as follows:
    // 1 components: { issue: { components: [10300] } }
    // 2+ components: { issue: { components: [10301, 10302] } }
    // for each componentId, we look for its name in the componentsById props
    const issueComponentsNames = issueComponents.map((componentId)=>componentsById[componentId] ? componentsById[componentId].name : null).filter(Boolean);
    // then we join the components names of the issue with ", " so it renders like "Component 2, Component 1" in the CSV
    if (issueComponentsNames && issueComponentsNames.length) return issueComponentsNames.join(', ');
    return null;
};
const $2e8a3de252d2450f$export$4a030f6192bebe03 = (issue, projectsById)=>{
    const { issueKey: issueKey = '', project: project } = issue;
    if (project && projectsById[project]) return `${projectsById[project].key}${issueKey ? `-${issueKey}` : ''}`;
    return null;
};
const $2e8a3de252d2450f$export$97d480ec651a5128 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
issueCustomFields, customField, selectOptionsById, userPickerOptionsById)=>{
    const { id: customFieldId, type: customFieldType } = customField;
    // issueCustomFields is an object including all custom fields of the issue with their respective values e.g.
    // { 10302: "10101", 10500: ["10301", "10302"], 10700: 454545 }
    // in this case the issue has:
    // one SingleSelect custom field (id 10302) with one selected option (id 10101)
    // one MultiSelect custom field (id 10500) with two selected options (ids 10301, 10302)
    // one TextField custom field (id 10700) with value 4545454
    if (!issueCustomFields || !customFieldId || !customFieldType || !customFieldType.key) return null;
    switch(customFieldType.key){
        // in the issueCustomFields object, the "DatePicker" custom field is stored as a key / value pair such as
        // { 10702: 1581379200000 }
        // the key is the custom field id, the value is a timestamp of the selected date
        case (0, $5rYNM.CustomFieldTypes).DatePicker:
            // returning the custom field value in a formatted date
            return issueCustomFields[customFieldId] ? (0, $l2Sj2.formatDateUTC)(issueCustomFields[customFieldId], (0, $5rYNM.DefaultDateFormat)) : null;
        // in the issueCustomFields object, the "Labels" custom field is stored as a key / value pair such as
        // 10704: ["Test", "UX", "needs-ix"]
        // the key is the custom field id, the value is an array of strings
        case (0, $5rYNM.CustomFieldTypes).Labels:
            // returning all strings joined by ", "
            return issueCustomFields[customFieldId] ? issueCustomFields[customFieldId].join(', ') : null;
        // in the issueCustomFields object, the "SingleSelect" and "RadioButtons" custom fields are stored as a key / value pair such as
        // { 10302: "10101" }
        // the key is the custom field id, the value is the id of the selected option of the custom field
        case (0, $5rYNM.CustomFieldTypes).RadioButtons:
        case (0, $5rYNM.CustomFieldTypes).SingleSelect:
            // in this case we use the id of the selected option of the custom field to find its "value" in the selectOptionsById object
            return issueCustomFields[customFieldId] && selectOptionsById[issueCustomFields[customFieldId]] ? selectOptionsById[issueCustomFields[customFieldId]].value : null;
        // in the issueCustomFields object, the "MultiSelect" and "MultiCheckboxes" custom fields is stored as a key / value pair such as
        // { 10500: ["10301", "10302"] }
        // the key is the custom field id, the value is an array including the id(s) of the selected option(s) of the custom field
        case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
        case (0, $5rYNM.CustomFieldTypes).AssetObject:
        case (0, $5rYNM.CustomFieldTypes).MultiSelect:
            if (!(0, $cofZt.default)()) {
                if (customFieldType.key === (0, $5rYNM.CustomFieldTypes).AssetObject) return issueCustomFields[customFieldId];
            }
            // if the custom field id is included in the custom fields object of the issue
            return issueCustomFields[customFieldId] ? issueCustomFields[customFieldId]// then we loop through the array of id(s) of the selected option(s) of the custom field and retrieve
            // the respective "value" in the selectOptionsById object
            .map((customFieldSelectedOptionId)=>selectOptionsById[customFieldSelectedOptionId] ? selectOptionsById[customFieldSelectedOptionId].value : null).filter(Boolean).join(', ') : null;
        // in the issueCustomFields object, the "UserPicker" custom field is stored as a key / value pair such as
        // { 10711: "5dba90b3de06db0da26c29c4" }
        // the key is the custom field id, the value is the id of a user
        case (0, $5rYNM.CustomFieldTypes).UserPicker:
            {
                if (issueCustomFields[customFieldId] === 'unassigned') return null;
                const user = userPickerOptionsById[issueCustomFields[customFieldId]];
                if (user) return user.label;
                return null;
            }
        // for the other custom fields types ("NumberField", "TextField", "Url"), we simply return the value of the custom field
        // in this example the value "454545" will be returned for the "TextField" custom field
        default:
            return issueCustomFields[customFieldId];
    }
};
const $2e8a3de252d2450f$export$9ae9a4e7a54bf810 = (issueStatusId, issueStatusesById)=>{
    const issueStatus = issueStatusesById[issueStatusId];
    if (issueStatus) return issueStatus.name;
    return null;
};
const $2e8a3de252d2450f$export$8ad3db919cdd9608 = (issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues)=>{
    // setting the issue progress to 0 by default
    let progressRemaining = 0;
    let progressCompleted = 0;
    let progressPercentage = 0;
    // getBreakDownByEstimate returns an object that looks like e.g.
    // {
    //     "byCategoryId": {
    //       "2": 0,
    //       "3": 3,
    //       "4": 9
    //     },
    //     "total": 12,
    //     "unestimated": 0,
    //     "issueCount": 3
    //   }
    // in this example, there are:
    // TODO (byCategoryId["2"]) = 0
    // DONE (byCategoryId["3"]) = 3
    // IN PROGRESS (byCategoryId["4"]) = 9
    // TOTAL (total) = 12
    const issueBreakdownByEstimate = (0, $iN8yE.getBreakdownByEstimate)(issue, issueIdToDescendantsIdMap, issueStatusesById, issueMapById, planningUnit, workingHours, estimateFromHistoryIssues);
    if (issueBreakdownByEstimate) {
        const { byCategoryId: byCategoryId, total: total } = issueBreakdownByEstimate;
        // if "byCategoryId" and "total" are defined in the "issueBreakdownByEstimate" object and if the total is higher than 0
        if ((0, $7CnHa.isDefined)(byCategoryId) && (0, $7CnHa.isDefined)(total) && total > 0) {
            // from the example above progressRemaining = 0 + 9 = 9
            progressRemaining = byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).TODO] + byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS];
            // from the example above progressCompleted = 3
            progressCompleted = byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE];
            // from the example above progressPercentage = roundToTwoDigit( (3 / 12) * 100 ) = 25
            progressPercentage = (0, $fJsYU.roundToTwoDigit)(progressCompleted / total * 100);
        }
    }
    return {
        progressPercentage: progressPercentage,
        progressCompleted: progressCompleted,
        progressRemaining: progressRemaining
    };
};
const $2e8a3de252d2450f$export$ff7aae3d2c7f6af0 = (issue, issues, issueStatusesById, issueMapById, historyIssues)=>{
    // setting the issue progress to 0 by default
    let progressIssueCount = 0;
    let toDoIssueCount = 0;
    let inProgressIssueCount = 0;
    let doneIssueCount = 0;
    let totalIssueCount = 0;
    // getBreakdown returns an object that looks like e.g.
    // {
    //     "byCategoryId": {
    //       "2": 1,
    //       "3": 2,
    //       "4": 4
    //     },
    //     "total": 7,
    //   }
    // in this example, there are:
    // TODO (byCategoryId["2"]) = 1
    // DONE (byCategoryId["3"]) = 2
    // IN PROGRESS (byCategoryId["4"]) = 4
    // TOTAL (total) = 7
    const issueCountBreakdown = (0, $iN8yE.getBreakdown)(issue, (0, $7CnHa.mapGroupsToIds)((0, $aK3ri.getChildrenByParentPure)(issues)), issueStatusesById, issueMapById, historyIssues);
    if (issueCountBreakdown) {
        const { byCategoryId: byCategoryId, total: total } = issueCountBreakdown;
        // if "byCategoryId" and "total" are defined in the "issueCountBreakdown" object and if the total is higher than 0
        if ((0, $7CnHa.isDefined)(byCategoryId) && (0, $7CnHa.isDefined)(total) && total > 0) {
            toDoIssueCount = byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).TODO];
            inProgressIssueCount = byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).INPROGRESS];
            doneIssueCount = byCategoryId[(0, $5rYNM.ISSUE_STATUS_CATEGORIES).DONE];
            totalIssueCount = total;
            // from the example above progressIssueCount = (2 / 7) * 100 = 28,57
            progressIssueCount = (0, $fJsYU.roundToTwoDigit)(doneIssueCount / totalIssueCount * 100);
        }
    }
    return {
        progressIssueCount: progressIssueCount,
        toDoIssueCount: toDoIssueCount,
        inProgressIssueCount: inProgressIssueCount,
        doneIssueCount: doneIssueCount,
        totalIssueCount: totalIssueCount
    };
};
const $2e8a3de252d2450f$export$319cb38742ef325d = (planningUnit, csvColumnHeadings, showRolledUpOthers = false)=>{
    if (planningUnit === (0, $5rYNM.PlanningUnits).days) return showRolledUpOthers ? csvColumnHeadings.estimateDaysRollUp : csvColumnHeadings.estimateDays;
    if (planningUnit === (0, $5rYNM.PlanningUnits).hours) return showRolledUpOthers ? csvColumnHeadings.estimateHoursRollUp : csvColumnHeadings.estimateHours;
    return showRolledUpOthers ? csvColumnHeadings.estimateStoryPointsRollUp : csvColumnHeadings.estimateStoryPoints;
};
const $2e8a3de252d2450f$export$6a7d553643acdfa3 = (planningUnit, csvColumnHeadings)=>{
    if (planningUnit === (0, $5rYNM.PlanningUnits).days) return csvColumnHeadings.progressCompletedDays;
    if (planningUnit === (0, $5rYNM.PlanningUnits).hours) return csvColumnHeadings.progressCompletedHours;
    return csvColumnHeadings.progressCompletedStoryPoints;
};
const $2e8a3de252d2450f$export$d260d342fb74a279 = (planningUnit, csvColumnHeadings)=>{
    if (planningUnit === (0, $5rYNM.PlanningUnits).days) return csvColumnHeadings.progressRemainingDays;
    if (planningUnit === (0, $5rYNM.PlanningUnits).hours) return csvColumnHeadings.progressRemainingHours;
    return csvColumnHeadings.progressRemainingStoryPoints;
};
/**
 * get Standard fields column headings - the order of columns / fields is defined in JPOS-4053
 * @param planningUnit Planning unit.
 * @param csvIntlMessages Object of internationalized messages.
 * @param showRolledUpOthers Boolean to show roll-up others.
 * @param showRolledUpDates Boolean to show roll-up dates.
 * @param dateConfiguration Object including the "baselineStartField" and "baselineEndField" of the plan.
 * @param isAtlasConnectInstalled When Atlas has not been configured, then Atlas fields will be hidden,
 * @returns standard list of columns headings
 */ const $2e8a3de252d2450f$var$getStandardFieldsColumnHeadings = (planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled)=>{
    const { columnHeadings: columnHeadings } = csvIntlMessages;
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    return [
        {
            label: columnHeadings.type,
            value: 'type',
            show: true
        },
        {
            label: columnHeadings.summary,
            value: 'summary',
            show: true
        },
        {
            label: columnHeadings.project,
            value: 'project',
            show: true
        },
        {
            label: columnHeadings.releaseRollUp,
            value: 'releaseRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.release,
            value: 'release',
            show: true
        },
        {
            label: columnHeadings.teamRollUp,
            value: 'teamRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.team,
            value: 'team',
            show: true
        },
        {
            label: columnHeadings.assignee,
            value: 'assignee',
            show: true
        },
        {
            label: columnHeadings.reporter,
            value: 'reporter',
            show: true
        },
        {
            label: columnHeadings.sprintRollUp,
            value: 'sprintRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.sprint,
            value: 'sprint',
            show: true
        },
        {
            label: columnHeadings.targetStartDateRollUp,
            value: 'targetStartRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'targetStart' || baselineEndField.key === 'targetStart')
        },
        {
            label: columnHeadings.targetStartDate,
            value: 'targetStart',
            show: true
        },
        {
            label: columnHeadings.targetEndDateRollUp,
            value: 'targetEndRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'targetEnd' || baselineEndField.key === 'targetEnd')
        },
        {
            label: columnHeadings.targetEndDate,
            value: 'targetEnd',
            show: true
        },
        {
            label: columnHeadings.dueDateRollUp,
            value: 'dueDateRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'dueDate' || baselineEndField.key === 'dueDate')
        },
        {
            label: columnHeadings.dueDate,
            value: 'dueDate',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$319cb38742ef325d(planningUnit, columnHeadings, showRolledUpOthers),
            value: 'estimateRollUp',
            show: showRolledUpOthers
        },
        {
            label: $2e8a3de252d2450f$export$319cb38742ef325d(planningUnit, columnHeadings),
            value: 'estimate',
            show: true
        },
        {
            label: columnHeadings.parent,
            value: 'parent',
            show: true
        },
        {
            label: columnHeadings.priority,
            value: 'priority',
            show: true
        },
        {
            label: columnHeadings.labels,
            value: 'labels',
            show: true
        },
        {
            label: columnHeadings.components,
            value: 'components',
            show: true
        },
        {
            label: columnHeadings.key,
            value: 'key',
            show: true
        },
        {
            label: columnHeadings.status,
            value: 'status',
            show: true
        },
        {
            label: columnHeadings[0, $d3ec7873a55d3e9b$export$c029c3f1c363635d],
            value: (0, $d3ec7873a55d3e9b$export$c029c3f1c363635d),
            show: isAtlasConnectInstalled
        },
        {
            label: columnHeadings[0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9],
            value: (0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9),
            show: isAtlasConnectInstalled
        }
    ].filter((item)=>item.show);
};
/**
 * Get column headings for the progress breakdown
 * @param planningUnit Planning unit.
 * @param csvIntlMessages Object of internationalized messages.
 * @returns
 */ const $2e8a3de252d2450f$var$getProgressBreakdownColumnHeadings = (planningUnit, csvIntlMessages)=>{
    const { columnHeadings: columnHeadings } = csvIntlMessages;
    return [
        {
            label: columnHeadings.progressPercentage,
            value: 'progressPercentage',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$6a7d553643acdfa3(planningUnit, columnHeadings),
            value: 'progressCompleted',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$d260d342fb74a279(planningUnit, columnHeadings),
            value: 'progressRemaining',
            show: true
        }
    ];
};
/**
 * Get column headings for the issue count breakdown
 * @param csvIntlMessages Object of internationalized messages.
 * @returns
 */ const $2e8a3de252d2450f$var$getIssueCountBreakdownColumnHeadings = (csvIntlMessages)=>{
    const { columnHeadings: columnHeadings } = csvIntlMessages;
    return [
        {
            label: columnHeadings.progressIssueCount,
            value: 'progressIssueCount',
            show: true
        },
        {
            label: columnHeadings.toDoIssueCount,
            value: 'toDoIssueCount',
            show: true
        },
        {
            label: columnHeadings.inProgressIssueCount,
            value: 'inProgressIssueCount',
            show: true
        },
        {
            label: columnHeadings.doneIssueCount,
            value: 'doneIssueCount',
            show: true
        },
        {
            label: columnHeadings.totalIssueCount,
            value: 'totalIssueCount',
            show: true
        }
    ];
};
const $2e8a3de252d2450f$export$cf9c1d126da629c3 = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled)=>{
    const { columnHeadings: columnHeadings } = csvIntlMessages;
    // standard fields column headings - the order of columns / fields is defined in JPOS-4053
    const standardFieldsColumnHeadings = $2e8a3de252d2450f$var$getStandardFieldsColumnHeadings(planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled);
    // column headings for the progress breakdown
    const progressBreakdownColumnHeadings = $2e8a3de252d2450f$var$getProgressBreakdownColumnHeadings(planningUnit, csvIntlMessages);
    // column headings for the issue count breakdown
    const issueCountBreakdownColumnHeadings = $2e8a3de252d2450f$var$getIssueCountBreakdownColumnHeadings(csvIntlMessages);
    // column headings for the custom fields
    // for custom fields the "label" is the title of the custom field (e.g. "Eligible Cities") and the value is the custom field id (e.g. 10501)
    // By using the custom field id rather than the title as the value, the user can have several custom fields sharing the same title (which JIRA allows)
    const customFieldColumnHeadings = customFields.map((customField)=>({
            label: customField.title,
            value: String(customField.id),
            show: true
        }));
    // if custom field is defined as one of the configurable date fields, the roll up column needs to be displayed before
    Object.values(dateConfiguration).forEach(({ key: key })=>{
        const index = customFieldColumnHeadings.findIndex(({ value: value })=>key === value);
        if (index === -1) return;
        const customField = customFields.find(({ id: id })=>key === String(id)) || {
            title: undefined,
            id: undefined
        };
        customFieldColumnHeadings.splice(index, 0, {
            label: `${customField.title} ${columnHeadings.rollUp}`,
            value: `${customField.id}RollUp`,
            show: true
        });
    });
    // returning all column headings
    return [
        ...standardFieldsColumnHeadings,
        ...progressBreakdownColumnHeadings,
        ...issueCountBreakdownColumnHeadings,
        ...customFieldColumnHeadings
    ];
};
const $2e8a3de252d2450f$var$getCSVColumnHeadingsOld = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = dateConfiguration;
    const { columnHeadings: columnHeadings } = csvIntlMessages;
    // standard fields column headings - the order of columns / fields is defined in JPOS-4053
    const standardFieldsColumnHeadings = [
        {
            label: columnHeadings.type,
            value: 'type',
            show: true
        },
        {
            label: columnHeadings.summary,
            value: 'summary',
            show: true
        },
        {
            label: columnHeadings.project,
            value: 'project',
            show: true
        },
        {
            label: columnHeadings.releaseRollUp,
            value: 'releaseRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.release,
            value: 'release',
            show: true
        },
        {
            label: columnHeadings.teamRollUp,
            value: 'teamRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.team,
            value: 'team',
            show: true
        },
        {
            label: columnHeadings.assignee,
            value: 'assignee',
            show: true
        },
        {
            label: columnHeadings.reporter,
            value: 'reporter',
            show: true
        },
        {
            label: columnHeadings.sprintRollUp,
            value: 'sprintRollUp',
            show: showRolledUpOthers
        },
        {
            label: columnHeadings.sprint,
            value: 'sprint',
            show: true
        },
        {
            label: columnHeadings.targetStartDateRollUp,
            value: 'targetStartRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'targetStart' || baselineEndField.key === 'targetStart')
        },
        {
            label: columnHeadings.targetStartDate,
            value: 'targetStart',
            show: true
        },
        {
            label: columnHeadings.targetEndDateRollUp,
            value: 'targetEndRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'targetEnd' || baselineEndField.key === 'targetEnd')
        },
        {
            label: columnHeadings.targetEndDate,
            value: 'targetEnd',
            show: true
        },
        {
            label: columnHeadings.dueDateRollUp,
            value: 'dueDateRollUp',
            show: showRolledUpDates && (baselineStartField.key === 'dueDate' || baselineEndField.key === 'dueDate')
        },
        {
            label: columnHeadings.dueDate,
            value: 'dueDate',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$319cb38742ef325d(planningUnit, columnHeadings, showRolledUpOthers),
            value: 'estimateRollUp',
            show: showRolledUpOthers
        },
        {
            label: $2e8a3de252d2450f$export$319cb38742ef325d(planningUnit, columnHeadings),
            value: 'estimate',
            show: true
        },
        {
            label: columnHeadings.parent,
            value: 'parent',
            show: true
        },
        {
            label: columnHeadings.priority,
            value: 'priority',
            show: true
        },
        {
            label: columnHeadings.labels,
            value: 'labels',
            show: true
        },
        {
            label: columnHeadings.components,
            value: 'components',
            show: true
        },
        {
            label: columnHeadings.key,
            value: 'key',
            show: true
        },
        {
            label: columnHeadings.status,
            value: 'status',
            show: true
        },
        {
            label: columnHeadings[0, $d3ec7873a55d3e9b$export$c029c3f1c363635d],
            value: (0, $d3ec7873a55d3e9b$export$c029c3f1c363635d),
            show: isAtlasConnectInstalled
        },
        {
            label: columnHeadings[0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9],
            value: (0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9),
            show: isAtlasConnectInstalled
        }
    ].filter($f7Op5.default('show'));
    // column headings for the progress breakdown
    const progressBreakdownColumnHeadings = [
        {
            label: columnHeadings.progressPercentage,
            value: 'progressPercentage',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$6a7d553643acdfa3(planningUnit, columnHeadings),
            value: 'progressCompleted',
            show: true
        },
        {
            label: $2e8a3de252d2450f$export$d260d342fb74a279(planningUnit, columnHeadings),
            value: 'progressRemaining',
            show: true
        }
    ];
    // column headings for the issue count breakdown
    const issueCountBreakdownColumnHeadings = [
        {
            label: columnHeadings.progressIssueCount,
            value: 'progressIssueCount',
            show: true
        },
        {
            label: columnHeadings.toDoIssueCount,
            value: 'toDoIssueCount',
            show: true
        },
        {
            label: columnHeadings.inProgressIssueCount,
            value: 'inProgressIssueCount',
            show: true
        },
        {
            label: columnHeadings.doneIssueCount,
            value: 'doneIssueCount',
            show: true
        },
        {
            label: columnHeadings.totalIssueCount,
            value: 'totalIssueCount',
            show: true
        }
    ];
    // column headings for the custom fields
    // for custom fields the "label" is the title of the custom field (e.g. "Eligible Cities") and the value is the custom field id (e.g. 10501)
    // By using the custom field id rather than the title as the value, the user can have several custom fields sharing the same title (which JIRA allows)
    let customFieldColumnHeadings = customFields.map((customField)=>({
            label: customField.title,
            value: String(customField.id),
            show: true
        }));
    // if custom field is defined as one of the configurable date fields, the roll up column needs to be displayed before
    $UCNmJ.default(dateConfiguration).forEach(({ key: key })=>{
        const index = customFieldColumnHeadings.findIndex(({ value: value })=>key === value);
        if (index === -1) return;
        const customField = customFields.find(({ id: id })=>key === String(id)) || {
            title: undefined,
            id: undefined
        };
        customFieldColumnHeadings = $aP1ZI.default(index, {
            label: `${customField.title} ${columnHeadings.rollUp}`,
            value: `${customField.id}RollUp`,
            show: true
        }, customFieldColumnHeadings);
    });
    // returning all column headings
    return [
        ...standardFieldsColumnHeadings,
        ...progressBreakdownColumnHeadings,
        ...issueCountBreakdownColumnHeadings,
        ...customFieldColumnHeadings
    ];
};
const $2e8a3de252d2450f$export$892b30033766af0d = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled)=>(0, $1ybV0.ff)('export-roadmaps-utils_p0zmt') ? $2e8a3de252d2450f$export$cf9c1d126da629c3(customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled) : $2e8a3de252d2450f$var$getCSVColumnHeadingsOld(customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled);
/**
 *
 * @param planTitle
 * @param date
 * @param ext
 *
 * @returns Returns a string including the file name.
 */ const $2e8a3de252d2450f$var$getExportFileName = (exportName = '', date, ext = '')=>{
    const fileName = [
        exportName.trim(),
        (0, $l2Sj2.formatDateUTC)(date.getTime(), (0, $5rYNM.EXPORT_FILE_DATE_FORMAT))
    ].filter(Boolean).join('_');
    const safeFileName = fileName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    return `${safeFileName}.${ext}`;
};
const $2e8a3de252d2450f$export$e88b298904081119 = (exportName = '', date)=>$2e8a3de252d2450f$var$getExportFileName(exportName, date, 'csv');
const $2e8a3de252d2450f$export$311cf81586e3cd12 = (exportName = '', date)=>$2e8a3de252d2450f$var$getExportFileName(exportName, date, 'png');
const $2e8a3de252d2450f$export$63353f144eea0dc4 = (customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, // eslint-disable-next-line @typescript-eslint/no-explicit-any
scopeItemsArray, isAtlasConnectInstalled)=>{
    // header
    const headingsArray = $2e8a3de252d2450f$export$892b30033766af0d(customFields, planningUnit, csvIntlMessages, showRolledUpOthers, showRolledUpDates, dateConfiguration, isAtlasConnectInstalled);
    return (0, $8Vy9J.buildCSV)(headingsArray, scopeItemsArray);
};

});
parcelRegister("aP1ZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1036d4c48043e2$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $7e1036d4c48043e2$var$insert = /*#__PURE__*/ (0, $4g10W.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $7e1036d4c48043e2$export$2e2bcd8739ae039 = $7e1036d4c48043e2$var$insert;

});

parcelRegister("8Vy9J", function(module, exports) {

$parcel$export(module.exports, "buildCSV", () => $f1da4715dcf3aa62$export$8bfbf32dccc29440);
const $f1da4715dcf3aa62$var$NEW_LINE = '\r\n';
const $f1da4715dcf3aa62$export$8bfbf32dccc29440 = (headers, scopeItems)=>{
    const visibleHeaders = headers.filter(({ show: show })=>show);
    const lines = [];
    // header
    lines.push(`${visibleHeaders.map(({ label: label })=>label).join(',')}`);
    // body
    const headerKeys = visibleHeaders.map(({ value: value })=>value);
    scopeItems.forEach((scopeItem)=>{
        const line = headerKeys.map((headerKey)=>{
            const scopeItemValue = scopeItem[headerKey];
            if (scopeItemValue === undefined || scopeItemValue === null) return '';
            if (Array.isArray(scopeItemValue)) return `"${scopeItemValue.join(',').replaceAll('"', '""')}"`;
            return `"${`${scopeItemValue}`.replaceAll('"', '""')}"`;
        }).join(',');
        lines.push(line);
    });
    return lines.join($f1da4715dcf3aa62$var$NEW_LINE);
};

});



parcelRegister("kXDg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba680790c4febe71$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $akhOi = parcelRequire("akhOi");

var $1nPPv = parcelRequire("1nPPv");

var $9ozqH = parcelRequire("9ozqH");


var $1uZFJ = parcelRequire("1uZFJ");

var $eNU9X = parcelRequire("eNU9X");
const $ba680790c4febe71$var$EDIT_MODE_ONLY_FLAGS = [
    {
        key: (0, $42b69a8aa6898c13$export$42d68c08a5ace658)
    },
    {
        key: (0, $42b69a8aa6898c13$export$a1a68e80ebef1446)
    }
];
const $ba680790c4febe71$var$RANKING_WARNING_FLAGS = [
    {
        key: (0, $42b69a8aa6898c13$export$5d75f74c1d4d448d)
    },
    {
        key: (0, $42b69a8aa6898c13$export$8a72c64e90d56fab)
    },
    {
        key: (0, $42b69a8aa6898c13$export$ac1a967dceae5708)
    }
];
function* $ba680790c4febe71$export$5b63f32dd550acba({ payload: payload }) {
    const isReadOnly = yield (0, $9e8i2.select)((0, $akhOi.isReadOnly));
    const allFlags = yield (0, $9e8i2.select)((0, $1nPPv.getFlags));
    const { key: key } = payload;
    let shouldPushFlag = false;
    if (!isReadOnly) shouldPushFlag = true;
    else if (!$ba680790c4febe71$var$EDIT_MODE_ONLY_FLAGS.some(({ key: editModeOnlyKey })=>editModeOnlyKey === key)) shouldPushFlag = true;
    if ($ba680790c4febe71$var$RANKING_WARNING_FLAGS.some(({ key: rankingWarningKey })=>rankingWarningKey === key) && !allFlags.includes(key)) shouldPushFlag = true;
    if (shouldPushFlag) yield (0, $9e8i2.put)((0, $9ozqH.pushFlag)(payload));
}
function* $ba680790c4febe71$export$cfaf9da3a08e8d3e({ payload: payload }) {
    const flagName = (0, $eNU9X.transformDismissedFlagName)(payload.key);
    if (flagName) yield (0, $9e8i2.put)((0, $1uZFJ.updateHiddenFlagDate)({
        key: flagName
    }));
}
function* $ba680790c4febe71$export$2e2bcd8739ae039() {
    yield (0, $bG7pV.takeEvery)((0, $9ozqH.ADD_FLAG), $ba680790c4febe71$export$5b63f32dd550acba);
    yield (0, $bG7pV.takeEvery)((0, $9ozqH.DISMISS_FLAG), $ba680790c4febe71$export$cfaf9da3a08e8d3e);
}

});
parcelRegister("1uZFJ", function(module, exports) {

$parcel$export(module.exports, "UPDATE_HIDDEN_FLAG_DATE", () => $3b9e32c05fa8e749$export$9383ffe2e65d2eb7);
$parcel$export(module.exports, "CLEAR_HIDDEN_FLAG_DATE", () => $3b9e32c05fa8e749$export$32941719fac87cfb);
$parcel$export(module.exports, "updateHiddenFlagDate", () => $3b9e32c05fa8e749$export$4088c054a6cf051d);
$parcel$export(module.exports, "clearHiddenFlagDate", () => $3b9e32c05fa8e749$export$8eb5fdb4567a7333);
const $3b9e32c05fa8e749$export$9383ffe2e65d2eb7 = 'state.domain.hiddenFlags.UPDATE_HIDDEN_FLAG_DATE';
const $3b9e32c05fa8e749$export$32941719fac87cfb = 'state.domain.hiddenFlags.CLEAR_HIDDEN_FLAG_DATE';
const $3b9e32c05fa8e749$export$4088c054a6cf051d = (payload)=>({
        type: $3b9e32c05fa8e749$export$9383ffe2e65d2eb7,
        payload: payload
    });
const $3b9e32c05fa8e749$export$8eb5fdb4567a7333 = (payload)=>({
        type: $3b9e32c05fa8e749$export$32941719fac87cfb,
        payload: payload
    });

});

parcelRegister("eNU9X", function(module, exports) {

$parcel$export(module.exports, "transformDismissedFlagName", () => $5a8b48174af312ef$export$96e4348af167b4b);
parcelRequire("1nPPv");
const $5a8b48174af312ef$export$96e4348af167b4b = (flagKey)=>{
    switch(flagKey){
        case 'issue-limit-warning':
            return 0, $42b69a8aa6898c13$export$42d68c08a5ace658;
        case 'reparent-tmp-to-external-warning':
            return 0, $42b69a8aa6898c13$export$8a72c64e90d56fab;
        case 'reparent-cmp-to-tmp-warning':
            return 0, $42b69a8aa6898c13$export$ac1a967dceae5708;
        default:
            return '';
    }
};

});


parcelRegister("agcf7", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesForIds", () => $7c35b1c440bbae3b$export$fb83572fb8b10534);
$parcel$export(module.exports, "default", () => $7c35b1c440bbae3b$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $2utnB = parcelRequire("2utnB");

var $5rVFi = parcelRequire("5rVFi");

var $9dq4u = parcelRequire("9dq4u");
const $7c35b1c440bbae3b$var$GET_ISSUE_TYPES_FOR_IDS = 'command.issue-type.GET_ISSUE_TYPES_FOR_IDS';
const $7c35b1c440bbae3b$export$fb83572fb8b10534 = (payload)=>({
        type: $7c35b1c440bbae3b$var$GET_ISSUE_TYPES_FOR_IDS,
        payload: payload
    });
function* $7c35b1c440bbae3b$export$747c2876415a1f3e({ payload: payload }) {
    const url = (0, $9dq4u.urls).issueTypesForIds;
    const body = {
        ids: payload
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const issueTypes = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)($2utnB.add(issueTypes));
    } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
        ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
        requestInfo: {
            url: url,
            type: 'POST',
            status: response.status,
            body: body
        }
    }));
}
function* $7c35b1c440bbae3b$export$5e4065bac8fb3930() {
    yield (0, $bG7pV.takeEvery)($7c35b1c440bbae3b$var$GET_ISSUE_TYPES_FOR_IDS, $7c35b1c440bbae3b$export$747c2876415a1f3e);
}
function* $7c35b1c440bbae3b$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($7c35b1c440bbae3b$export$5e4065bac8fb3930);
}

});
parcelRegister("2utnB", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $f44dc18dc808074f$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $f44dc18dc808074f$export$bb6389024b71c2ae);
$parcel$export(module.exports, "reset", () => $f44dc18dc808074f$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $f44dc18dc808074f$export$e16d8520af44a096);
const $f44dc18dc808074f$export$4a991c87e640ef77 = 'state.domain.issue-types.RESET';
const $f44dc18dc808074f$export$bb6389024b71c2ae = 'state.domain.issue-types.ADD';
const $f44dc18dc808074f$export$aad8462122ac592b = (payload)=>({
        type: $f44dc18dc808074f$export$4a991c87e640ef77,
        payload: payload
    });
const $f44dc18dc808074f$export$e16d8520af44a096 = (payload)=>({
        type: $f44dc18dc808074f$export$bb6389024b71c2ae,
        payload: payload
    });

});

parcelRegister("9dq4u", function(module, exports) {

$parcel$export(module.exports, "urls", () => $53dddd5b0ef18e3b$export$bcae9ba627f604b6);
const $53dddd5b0ef18e3b$export$bcae9ba627f604b6 = {
    issueTypesForIds: '/rest/jpo/1.0/issuetypes'
};

});


parcelRegister("6hfzF", function(module, exports) {

$parcel$export(module.exports, "setIntroOpen", () => $cec239af0c36e4b9$export$e235b69f47ba4464);
$parcel$export(module.exports, "default", () => $cec239af0c36e4b9$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $fAVjN = parcelRequire("fAVjN");

var $5rVFi = parcelRequire("5rVFi");

var $iVBJa = parcelRequire("iVBJa");
const $cec239af0c36e4b9$export$e235b69f47ba4464 = (payload)=>({
        type: (0, $fAVjN.SET_INTRO_OPEN),
        payload: payload
    });
function* $cec239af0c36e4b9$export$29f7d6751d659711({ payload: payload }) {
    try {
        const url = (0, $iVBJa.urls).set;
        const body = (0, $iVBJa.setUserPropertyBody)('onboadingShown', payload);
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $cec239af0c36e4b9$export$1a6b50881f96a8ec() {
    yield (0, $bG7pV.takeEvery)((0, $fAVjN.SET_ONBOARDING_SHOWN), $cec239af0c36e4b9$export$29f7d6751d659711);
}
function* $cec239af0c36e4b9$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($cec239af0c36e4b9$export$1a6b50881f96a8ec);
}

});
parcelRegister("fAVjN", function(module, exports) {

$parcel$export(module.exports, "SET_INTRO_OPEN", () => $ca1e529dfd26e077$export$c92e1b6fc8685e50);
$parcel$export(module.exports, "SET_ONBOARDING_SHOWN", () => $ca1e529dfd26e077$export$e0391b0512509585);
$parcel$export(module.exports, "SET_ACTIVE_CARD", () => $ca1e529dfd26e077$export$b335940c72c522b7);
$parcel$export(module.exports, "setOnBoardingShown", () => $ca1e529dfd26e077$export$15c7f29739be525d);
$parcel$export(module.exports, "setActiveCard", () => $ca1e529dfd26e077$export$c408a3a8a6e2d351);
const $ca1e529dfd26e077$export$c92e1b6fc8685e50 = 'state.ui.onboarding.SET_INTRO_OPEN';
const $ca1e529dfd26e077$export$e0391b0512509585 = 'state.ui.onboarding.SET_ONBOARDING_SHOWN';
const $ca1e529dfd26e077$export$b335940c72c522b7 = 'state.ui.onboarding.SET_ACTIVE_CARD';
const $ca1e529dfd26e077$export$15c7f29739be525d = (payload)=>({
        type: $ca1e529dfd26e077$export$e0391b0512509585,
        payload: payload
    });
const $ca1e529dfd26e077$export$c408a3a8a6e2d351 = (payload)=>({
        type: $ca1e529dfd26e077$export$b335940c72c522b7,
        payload: payload
    });

});

parcelRegister("iVBJa", function(module, exports) {

$parcel$export(module.exports, "urls", () => $97788d9768d70134$export$bcae9ba627f604b6);
$parcel$export(module.exports, "setUserPropertyBody", () => $97788d9768d70134$export$4901ba1ed7ae3875);
const $97788d9768d70134$export$bcae9ba627f604b6 = {
    set: '/rest/jpo/1.0/pluginUserProperties/set'
};
const $97788d9768d70134$export$4901ba1ed7ae3875 = (key, value)=>({
        key: key,
        value: value
    });

});


parcelRegister("6MKBs", function(module, exports) {

$parcel$export(module.exports, "getPageDataFromInfoMetadata", () => $6e1e7ff3c9ccce13$export$ce6ea50e8812f057);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $dYnI4 = parcelRequire("dYnI4");

var $j3szT = parcelRequire("j3szT");

var $iTjRl = parcelRequire("iTjRl");


var $7CnHa = parcelRequire("7CnHa");
function* $6e1e7ff3c9ccce13$export$ce6ea50e8812f057(basicPlanInfo) {
    if (!(0, $7CnHa.isDefined)(basicPlanInfo)) throw new Error('Basic plan info missing for non-wrm page data loading');
    const { planId: planId, scenarioId: scenarioId, reportInfo: reportInfo } = basicPlanInfo;
    let response;
    const url = '/rest/jpo/1.0/info/metadata';
    const earlyPreloadInfoMetadataPromise = window.__ARJ_INFO_METADATA_PROMISE__;
    delete window.__ARJ_INFO_METADATA_PROMISE__;
    if (earlyPreloadInfoMetadataPromise) {
        const responseObj = yield earlyPreloadInfoMetadataPromise;
        const ok = responseObj.ok;
        const data = yield responseObj.json();
        response = {
            ok: ok,
            data: data
        };
        /**
		 * Recording the performance information of the API before returning
		 * the response.
		 */ const start = Math.floor((0, $j3szT.extractStartTime)('jira.fe-spa.advanced-roadmaps.early-preload.info-metadata:start'));
        const end = Math.ceil((0, $j3szT.extractStartTime)('jira.fe-spa.advanced-roadmaps.early-preload.info-metadata:end'));
        (0, $dYnI4.monitor).recordCustomProfile(url, {
            start: start,
            end: end
        });
    }
    if (!(0, $7CnHa.isDefined)(response)) response = yield (0, $9e8i2.call)((0, $iTjRl.json), {
        url: url,
        method: 'POST',
        body: {
            planId: planId,
            scenarioId: scenarioId,
            includeCustomFieldsOptions: true
        },
        profile: url
    });
    if ((0, $7CnHa.isDefined)(response) && response.ok) {
        if ('errorMessage' in response.data) {
            if (response.data.errorMessage === (0, $42b69a8aa6898c13$export$1c67cc6ab03450a2)) return 0, $42b69a8aa6898c13$export$1c67cc6ab03450a2;
        } else return {
            planDefaultsInfo: response.data.planDefaults,
            planInfo: response.data.simplePlan,
            hierarchyInfo: response.data.hierarchy,
            issueStatusCategoryInfo: response.data.issueStatus,
            systemInfo: response.data.system,
            agileInfo: response.data.agile,
            issueLinkTypesInfo: response.data.issueLinks,
            dependencySettingsInfo: response.data.dependencySettings,
            userProperties: response.data.pluginUser,
            loadingLimitsInfo: response.data.loadingLimits,
            savedViewsInfoFull: response.data.savedViewsInfoFull,
            customFieldsOptions: response.data.customFieldsOptions,
            isAtlasConnectInstalled: response.data.isAtlasConnectInstalled,
            hasAtlasPermissions: response.data.hasAtlasPermissions,
            reportInfo: reportInfo
        };
    }
    throw new Error('Failed to fetch page data for plan');
}

});

parcelRegister("lxYdq", function(module, exports) {

$parcel$export(module.exports, "establishPermission", () => $c97800f53dc7f406$export$e2b6dc333326621);
$parcel$export(module.exports, "revokePermission", () => $c97800f53dc7f406$export$2d04b98d90274ff1);
$parcel$export(module.exports, "revokeAllPermissions", () => $c97800f53dc7f406$export$cbbad8f9b6cf6c33);
$parcel$export(module.exports, "fetchPermissions", () => $c97800f53dc7f406$export$4f24ecba11982e9d);
$parcel$export(module.exports, "fetchTeamPermissions", () => $c97800f53dc7f406$export$eb658a558727ba9f);
$parcel$export(module.exports, "default", () => $c97800f53dc7f406$export$2e2bcd8739ae039);

var $3by2Y = parcelRequire("3by2Y");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $guiFP = parcelRequire("guiFP");

var $kP3Wn = parcelRequire("kP3Wn");

var $63O1Q = parcelRequire("63O1Q");

var $cbq3D = parcelRequire("cbq3D");
parcelRequire("bJc6r");
var $1eATi = parcelRequire("1eATi");

var $akhOi = parcelRequire("akhOi");

var $a6d5W = parcelRequire("a6d5W");

var $75KhQ = parcelRequire("75KhQ");

var $iFUSZ = parcelRequire("iFUSZ");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $hn5xe = parcelRequire("hn5xe");
const $c97800f53dc7f406$export$b9a6161393332468 = 'command.permissions.FETCH_PERMISSIONS';
const $c97800f53dc7f406$export$2158053a23d9487 = 'command.permissions.ESTABLISH_PERMISSION';
const $c97800f53dc7f406$export$de33a2a8581dd543 = 'command.permissions.REVOKE_PERMISSION';
const $c97800f53dc7f406$export$fe39957c0d22d76b = 'command.permissions.REVOKE_ALL_PERMISSIONS';
const $c97800f53dc7f406$export$42789425ce10f663 = 'command.permissions.FETCH_TEAM_PERMISSIONS';
const $c97800f53dc7f406$export$e2b6dc333326621 = (payload)=>({
        type: $c97800f53dc7f406$export$2158053a23d9487,
        payload: payload
    });
const $c97800f53dc7f406$export$2d04b98d90274ff1 = (payload)=>({
        type: $c97800f53dc7f406$export$de33a2a8581dd543,
        payload: payload
    });
const $c97800f53dc7f406$export$cbbad8f9b6cf6c33 = (payload)=>({
        type: $c97800f53dc7f406$export$fe39957c0d22d76b,
        payload: payload
    });
const $c97800f53dc7f406$export$4f24ecba11982e9d = ()=>({
        type: $c97800f53dc7f406$export$b9a6161393332468
    });
const $c97800f53dc7f406$export$eb658a558727ba9f = (orgId, siteId)=>({
        type: $c97800f53dc7f406$export$42789425ce10f663,
        orgId: orgId,
        siteId: siteId
    });
const $c97800f53dc7f406$export$778f86d0002199a6 = (payload)=>`Failed to add "${payload.holder.type}" permission for "${payload.holder.key}"`;
const $c97800f53dc7f406$export$4a5061a17a8f71cf = (payload)=>`Failed to delete "${payload.holder.type}" permission for "${payload.holder.key}"`;
function* $c97800f53dc7f406$export$20993e109b0754be({ payload: payload }) {
    try {
        yield (0, $9e8i2.put)((0, $iFUSZ.removePermission)(payload));
        const { id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const body = {
            permission: {
                permission: payload.permission,
                holder: payload.holder
            },
            planId: planId
        };
        if (!payload.holder) (0, $guiFP.default)({
            meta: {
                packageName: (0, $5rYNM.PACKAGE_NAME),
                id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).APP,
                teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: `Removing permission - Permission holder is undefined in ${JSON.stringify(payload)}`
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hn5xe.urls).revoke, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            const error = (0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response))));
            yield (0, $9e8i2.put)((0, $iFUSZ.addPermission)(payload));
            yield (0, $9e8i2.put)((0, $cbq3D.httpRequestError)(response, error, {
                method: (0, $kP3Wn.POST)
            }));
            return;
        }
        const { removed: removed } = yield (0, $9e8i2.call)(response.json.bind(response));
        if (!removed.length) {
            yield (0, $9e8i2.put)((0, $iFUSZ.addPermission)(payload));
            throw (()=>({
                    message: $c97800f53dc7f406$export$4a5061a17a8f71cf(payload)
                }))();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $c97800f53dc7f406$export$97f2c8a7346cddbe({ payload: payload }) {
    try {
        yield (0, $9e8i2.put)((0, $iFUSZ.addPermission)(payload));
        const { id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
        const body = {
            permission: {
                permission: payload.permission,
                holder: payload.holder
            },
            planId: planId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hn5xe.urls).establish, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            const error = (0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response))));
            yield (0, $9e8i2.put)((0, $iFUSZ.removePermission)(payload));
            yield (0, $9e8i2.put)((0, $cbq3D.httpRequestError)(response, error, {
                method: (0, $kP3Wn.POST)
            }));
            return;
        }
        const { added: added } = yield (0, $9e8i2.call)(response.json.bind(response));
        if (!added.length) {
            yield (0, $9e8i2.put)((0, $iFUSZ.removePermission)(payload));
            throw (()=>({
                    message: $c97800f53dc7f406$export$778f86d0002199a6(payload)
                }))();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $c97800f53dc7f406$export$cdd82d420769a463({ payload: payload }) {
    try {
        if (payload.permission === 'EDIT') {
            // `EDIT` permissions for the currentUser must be revoked last to trigger
            // proper behaviour on the backend as we don't allow users to exclude themselves
            // unless switching back to unrestricted mode.
            const currentUser = yield (0, $9e8i2.select)((0, $a6d5W.getCurrentUser));
            const [[currentUserPermissions], permissions] = $3by2Y.default(({ holder: { key: key } })=>key === currentUser.key, (yield (0, $9e8i2.select)((0, $a6d5W.getPlanEditorPermissions))));
            yield (0, $9e8i2.all)(permissions.map((permission)=>(0, $9e8i2.call)($c97800f53dc7f406$export$20993e109b0754be, {
                    type: $c97800f53dc7f406$export$de33a2a8581dd543,
                    payload: {
                        ...permission,
                        permission: payload.permission
                    }
                })));
            if (currentUserPermissions) yield (0, $9e8i2.call)($c97800f53dc7f406$export$20993e109b0754be, {
                type: $c97800f53dc7f406$export$de33a2a8581dd543,
                payload: {
                    ...currentUserPermissions,
                    permission: payload.permission
                }
            });
        } else {
            const permissions = yield (0, $9e8i2.select)((0, $a6d5W.getPlanViewerPermissions));
            yield (0, $9e8i2.all)(permissions.map((permission)=>(0, $9e8i2.call)($c97800f53dc7f406$export$20993e109b0754be, {
                    type: $c97800f53dc7f406$export$de33a2a8581dd543,
                    payload: {
                        ...permission,
                        permission: payload.permission
                    }
                })));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $c97800f53dc7f406$export$8452b742476a15ac() {
    try {
        // check if the view is under read only
        const isReadOnlyMode = yield (0, $9e8i2.select)((0, $akhOi.isReadOnly));
        // The permission endpoint for the view currently is called during page load
        // This should not be called if the user is read-only
        // This has been confirmed with Ruslan, the reason why we load permissions on every page
        // which is merged as part of work on https://bulldog.internal.atlassian.com/browse/JPOS-2326 and
        // that call on every page load was a shortcut to make implementation simpler that was never fixed afterwards.
        // Also, from my investigation and testing, the readonly user doesn't even use permissions state.
        if (!isReadOnlyMode) {
            yield (0, $9e8i2.put)((0, $iFUSZ.toggleFetchInProggress)(true));
            const { id: planId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
            if ((0, $7CnHa.isDefined)(planId)) {
                const permissionsResponse = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hn5xe.urls).get(planId), {
                    method: (0, $kP3Wn.GET),
                    profile: (0, $hn5xe.urls).get(':id')
                });
                if (permissionsResponse && permissionsResponse.ok) {
                    const { permissions: permissions } = yield (0, $9e8i2.call)(permissionsResponse.json.bind(permissionsResponse));
                    const userKeys = permissions.filter((p)=>p.holder.type === 'ACCOUNT_ID').map((p)=>p.holder.key);
                    if (userKeys.length) {
                        const users = yield (0, $9e8i2.call)((0, $63O1Q.getUsers), {
                            keys: userKeys
                        });
                        const enhancedPermissions = permissions.map((permission)=>{
                            const user = users.find(// eslint-disable-next-line @typescript-eslint/no-shadow
                            (user)=>user.accountId === permission.accountId);
                            if (user) return {
                                ...permission,
                                email: user.email,
                                avatarUrl: user.avatarUrl
                            };
                            return permission;
                        });
                        yield (0, $9e8i2.put)((0, $iFUSZ.setPermissions)(enhancedPermissions));
                    } else yield (0, $9e8i2.put)((0, $iFUSZ.setPermissions)(permissions));
                    yield (0, $9e8i2.put)((0, $iFUSZ.toggleFetchInProggress)(false));
                } else if (permissionsResponse) {
                    const error = (0, $kP3Wn.parseError)(permissionsResponse, (yield (0, $9e8i2.call)(permissionsResponse.text.bind(permissionsResponse))));
                    yield (0, $9e8i2.put)((0, $cbq3D.httpRequestError)(permissionsResponse, error, {
                        method: (0, $kP3Wn.GET)
                    }));
                }
            }
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $c97800f53dc7f406$export$8c75928f3cfbbaa2({ orgId: orgId, siteId: siteId }) {
    try {
        const teamPermissions = yield (0, $9e8i2.select)((0, $a6d5W.getTeamPermissions));
        if (!(0, $7CnHa.isDefined)(teamPermissions) || !(0, $7CnHa.isDefined)(teamPermissions.canViewTeams) || !(0, $7CnHa.isDefined)(teamPermissions.canCreateTeams)) {
            let response;
            if ((0, $1eATi.default)()) response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hn5xe.urls).getTeamsPermissionV4(orgId, siteId ?? 'None'), {
                method: (0, $kP3Wn.GET)
            });
            else response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hn5xe.urls).getTeamsPermission(orgId), {
                method: (0, $kP3Wn.GET)
            });
            if (response.ok) {
                const { permissions: permissions } = yield (0, $9e8i2.call)(response.json.bind(response));
                yield (0, $9e8i2.put)((0, $iFUSZ.setTeamPermissions)({
                    canViewTeams: Array.isArray(permissions) && permissions.length > 0 && permissions.includes('CAN_VIEW_TEAMS'),
                    canCreateTeams: Array.isArray(permissions) && permissions.length > 0 && permissions.includes('CAN_CREATE_TEAMS')
                }));
            } else {
                const message = yield (0, $9e8i2.call)(response.text.bind(response));
                throw new Error(`Failed to retrieve team permissions: ${message}`);
            }
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // Set defaut team permissions to false
        yield (0, $9e8i2.put)((0, $iFUSZ.setTeamPermissions)({
            canViewTeams: false,
            canCreateTeams: false
        }));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $c97800f53dc7f406$export$ff2e827105f76051() {
    yield (0, $bG7pV.takeEvery)($c97800f53dc7f406$export$b9a6161393332468, $c97800f53dc7f406$export$8452b742476a15ac);
}
function* $c97800f53dc7f406$export$4a978780d71ec34c() {
    yield (0, $bG7pV.takeEvery)($c97800f53dc7f406$export$de33a2a8581dd543, $c97800f53dc7f406$export$20993e109b0754be);
}
function* $c97800f53dc7f406$export$7d210b1b6e021c6f() {
    yield (0, $bG7pV.takeEvery)($c97800f53dc7f406$export$fe39957c0d22d76b, $c97800f53dc7f406$export$cdd82d420769a463);
}
function* $c97800f53dc7f406$export$695e0c43372db94b() {
    yield (0, $bG7pV.takeEvery)($c97800f53dc7f406$export$2158053a23d9487, $c97800f53dc7f406$export$97f2c8a7346cddbe);
}
function* $c97800f53dc7f406$export$77730714e7314625() {
    yield (0, $bG7pV.takeEvery)($c97800f53dc7f406$export$42789425ce10f663, $c97800f53dc7f406$export$8c75928f3cfbbaa2);
}
function* $c97800f53dc7f406$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($c97800f53dc7f406$export$ff2e827105f76051);
    yield (0, $9e8i2.fork)($c97800f53dc7f406$export$695e0c43372db94b);
    yield (0, $9e8i2.fork)($c97800f53dc7f406$export$4a978780d71ec34c);
    yield (0, $9e8i2.fork)($c97800f53dc7f406$export$7d210b1b6e021c6f);
    yield (0, $9e8i2.fork)($c97800f53dc7f406$export$77730714e7314625);
}

});
parcelRegister("iFUSZ", function(module, exports) {

$parcel$export(module.exports, "SET_PERMISSIONS", () => $981482644f7c0945$export$2942bd9e290bbd66);
$parcel$export(module.exports, "TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS", () => $981482644f7c0945$export$f5e5b4f9add4f24f);
$parcel$export(module.exports, "ADD_PERMISSION", () => $981482644f7c0945$export$daea955f3c0bef8f);
$parcel$export(module.exports, "REMOVE_PERMISSION", () => $981482644f7c0945$export$10984e8384291f74);
$parcel$export(module.exports, "SET_CURRENT_USER", () => $981482644f7c0945$export$c6dfa1844d1d3b74);
$parcel$export(module.exports, "SET_TEAM_PERMISSIONS", () => $981482644f7c0945$export$1155c6bdb5740e0e);
$parcel$export(module.exports, "setPermissions", () => $981482644f7c0945$export$e4bd73c83a5e34e4);
$parcel$export(module.exports, "toggleFetchInProggress", () => $981482644f7c0945$export$3a1e7e56a0d004d4);
$parcel$export(module.exports, "addPermission", () => $981482644f7c0945$export$7a841ea48c61adb7);
$parcel$export(module.exports, "removePermission", () => $981482644f7c0945$export$15a6812353e636e4);
$parcel$export(module.exports, "setTeamPermissions", () => $981482644f7c0945$export$5cffc2df64325dce);
const $981482644f7c0945$export$2942bd9e290bbd66 = 'state.domain.permissions.SET_PERMISSIONS';
const $981482644f7c0945$export$f5e5b4f9add4f24f = 'state.domain.permissions.TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS';
const $981482644f7c0945$export$daea955f3c0bef8f = 'state.domain.permissions.ADD_PERMISSION';
const $981482644f7c0945$export$10984e8384291f74 = 'state.domain.permissions.REMOVE_PERMISSION';
const $981482644f7c0945$export$c6dfa1844d1d3b74 = 'state.domain.permissions.SET_CURRENT_USER';
const $981482644f7c0945$export$1155c6bdb5740e0e = 'state.domain.teams.SET_TEAM_PERMISSIONS';
const $981482644f7c0945$export$e4bd73c83a5e34e4 = (payload)=>({
        type: $981482644f7c0945$export$2942bd9e290bbd66,
        payload: payload
    });
const $981482644f7c0945$export$3a1e7e56a0d004d4 = (payload)=>({
        type: $981482644f7c0945$export$f5e5b4f9add4f24f,
        payload: payload
    });
const $981482644f7c0945$export$7a841ea48c61adb7 = (payload)=>({
        type: $981482644f7c0945$export$daea955f3c0bef8f,
        payload: payload
    });
const $981482644f7c0945$export$15a6812353e636e4 = (payload)=>({
        type: $981482644f7c0945$export$10984e8384291f74,
        payload: payload
    });
const $981482644f7c0945$export$64e99e757b084e7c = (payload)=>({
        type: $981482644f7c0945$export$c6dfa1844d1d3b74,
        payload: payload
    });
const $981482644f7c0945$export$5cffc2df64325dce = (payload)=>({
        type: $981482644f7c0945$export$1155c6bdb5740e0e,
        payload: payload
    });

});

parcelRegister("hn5xe", function(module, exports) {

$parcel$export(module.exports, "urls", () => $f702bdea771ecc4d$export$bcae9ba627f604b6);
const $f702bdea771ecc4d$export$bcae9ba627f604b6 = {
    get: (id)=>`/rest/jpo/1.0/permissions/${id}`,
    establish: '/rest/jpo/1.0/permissions/establish',
    revoke: '/rest/jpo/1.0/permissions/revoke',
    getTeamsPermission: (orgId)=>`/gateway/api/v3/teams/permission/self/organization/${orgId}`,
    getTeamsPermissionV4: (orgId, siteId)=>`/gateway/api/v4/teams/permission/self/organization/${orgId}?siteId=${siteId}`
};

});


parcelRegister("8qtqq", function(module, exports) {

$parcel$export(module.exports, "getProjectsForIds", () => $bb5c4b948b068560$export$eb70922768388871);
$parcel$export(module.exports, "default", () => $bb5c4b948b068560$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $hLlYV = parcelRequire("hLlYV");

var $75KhQ = parcelRequire("75KhQ");

var $Nfcm7 = parcelRequire("Nfcm7");

var $boQGP = parcelRequire("boQGP");

var $8RAUa = parcelRequire("8RAUa");

var $5rVFi = parcelRequire("5rVFi");

var $hRsTi = parcelRequire("hRsTi");
const $bb5c4b948b068560$var$GET_PROJECTS_FOR_IDS = 'command.project.GET_PROJECTS_FOR_IDS';
const $bb5c4b948b068560$export$eb70922768388871 = (payload)=>({
        type: $bb5c4b948b068560$var$GET_PROJECTS_FOR_IDS,
        payload: payload
    });
function* $bb5c4b948b068560$export$2332176d4ac35fa4(action) {
    if ((0, $eI5EY.fg)('use_get_project_info_for_ids_in_arj')) yield (0, $9e8i2.call)($bb5c4b948b068560$export$50d69cf9752fdea9, action);
    else yield (0, $9e8i2.call)($bb5c4b948b068560$export$cac6bed28a5bf8cb, action);
}
function* $bb5c4b948b068560$export$cac6bed28a5bf8cb({ payload: payload }) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const url = (0, $hRsTi.urls).projectsForIds;
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        ids: payload
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const projects = yield (0, $9e8i2.call)(response.json.bind(response));
        const result = yield (0, $9e8i2.call)((0, $hLlYV.getPlanInfo));
        if (!result) return;
        const { issuePriorityInformation: issuePriorityInformation } = result;
        if ((0, $1ybV0.ff)('com.atlassian.jpo.issue-priority-error-logs')) projects.forEach((project)=>{
            if (issuePriorityInformation.projectToPrioritySchemeAssociations[project.id] == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.get-project-for-ids.error', 'Project id not found in issue priority information, in getProjectForIds', {
                path: window.location.pathname.replace(/\d+/g, '{id}'),
                projectsLength: projects.length,
                issuePriorityProjectLength: Object.keys(issuePriorityInformation.projectToPrioritySchemeAssociations).length
            });
        });
        yield (0, $9e8i2.put)($boQGP.add($8RAUa.prepareProjects(projects, issuePriorityInformation)));
    } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
        ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
        requestInfo: {
            url: url,
            type: 'POST',
            status: response.status,
            body: body
        }
    }));
}
function* $bb5c4b948b068560$export$50d69cf9752fdea9({ payload: payload }) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const body = {
        planId: planId,
        scenarioId: scenarioId,
        ids: payload
    };
    const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $hRsTi.urls).projectInfoForIds, {
        method: 'POST',
        body: body
    });
    if (response.ok) {
        const projectInfoByIdResponse = yield (0, $9e8i2.call)(response.json.bind(response));
        const { projects: projects, issuePriorityInformation: issuePriorityInformation } = projectInfoByIdResponse;
        if ((0, $1ybV0.ff)('com.atlassian.jpo.issue-priority-error-logs')) projects.forEach((project)=>{
            if (issuePriorityInformation.projectToPrioritySchemeAssociations[project.id] == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.get-project-for-ids.error', 'Project id not found in issue priority information, in getProjectInfoForIds', {
                path: window.location.pathname.replace(/\d+/g, '{id}'),
                projectsLength: projects.length,
                issuePriorityProjectLength: Object.keys(issuePriorityInformation.projectToPrioritySchemeAssociations).length
            });
        });
        // store projects in the state
        yield (0, $9e8i2.put)($boQGP.add($8RAUa.prepareProjects(projects, issuePriorityInformation)));
        // also store issue priority information if there was any missing
        yield (0, $9e8i2.put)($Nfcm7.add(issuePriorityInformation.issuePriorities));
    } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
        ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
        requestInfo: {
            url: (0, $hRsTi.urls).projectInfoForIds,
            type: 'POST',
            status: response.status,
            body: body
        }
    }));
}
function* $bb5c4b948b068560$export$14e7ff07dd2407a3() {
    yield (0, $bG7pV.takeEvery)($bb5c4b948b068560$var$GET_PROJECTS_FOR_IDS, $bb5c4b948b068560$export$2332176d4ac35fa4);
}
function* $bb5c4b948b068560$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($bb5c4b948b068560$export$14e7ff07dd2407a3);
}

});
parcelRegister("Nfcm7", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $866ebc6df4b5c00d$export$4a991c87e640ef77);
$parcel$export(module.exports, "ADD", () => $866ebc6df4b5c00d$export$bb6389024b71c2ae);
$parcel$export(module.exports, "reset", () => $866ebc6df4b5c00d$export$aad8462122ac592b);
$parcel$export(module.exports, "add", () => $866ebc6df4b5c00d$export$e16d8520af44a096);
const $866ebc6df4b5c00d$export$4a991c87e640ef77 = 'state.domain.issue-priorities.RESET';
const $866ebc6df4b5c00d$export$bb6389024b71c2ae = 'state.domain.issue-priorities.ADD';
const $866ebc6df4b5c00d$export$aad8462122ac592b = (payload)=>({
        type: $866ebc6df4b5c00d$export$4a991c87e640ef77,
        payload: payload
    });
const $866ebc6df4b5c00d$export$e16d8520af44a096 = (payload)=>({
        type: $866ebc6df4b5c00d$export$bb6389024b71c2ae,
        payload: payload
    });

});

parcelRegister("hRsTi", function(module, exports) {

$parcel$export(module.exports, "urls", () => $9ed71c2acd3d9f0b$export$bcae9ba627f604b6);
const $9ed71c2acd3d9f0b$export$bcae9ba627f604b6 = {
    projectsForIds: '/rest/jpo/1.0/projects/list',
    projectInfoForIds: '/rest/jpo/1.0/projects/info'
};

});


parcelRegister("jmPgj", function(module, exports) {

$parcel$export(module.exports, "populateReportersFromProfiles", () => $e7ca33440e52098b$export$f795a896e279d1d9);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");

var $cbq3D = parcelRequire("cbq3D");

var $jNZI1 = parcelRequire("jNZI1");
function* $e7ca33440e52098b$export$f795a896e279d1d9(reporterProfiles) {
    try {
        const { domain: { issues: issues } } = yield (0, $9e8i2.select)($l0L3x.default);
        // Map of account id to person
        // This construct a map of reporter profiles mapping
        // to make it as ID : Person
        const allPersonsMap = {};
        for (const reporter of Object.values(reporterProfiles))allPersonsMap[reporter.accountId] = {
            personId: reporter.accountId,
            jiraUser: reporter
        };
        // loop through each issue and find its reporter person
        // then construct another map to store
        // issue ID : Person
        const issueReporterMap = {};
        issues.forEach((issue)=>{
            if (issue.reporter) {
                const reporterPerson = allPersonsMap[issue.reporter];
                if (reporterPerson) issueReporterMap[issue.id] = reporterPerson;
            }
        });
        yield (0, $9e8i2.put)((0, $jNZI1.updateIssueReporterMap)(issueReporterMap));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}

});
parcelRegister("jNZI1", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ISSUE_REPORTER_MAP", () => $bdd539cf2f7c6ef2$export$23b774f011fb0045);
$parcel$export(module.exports, "updateIssueReporterMap", () => $bdd539cf2f7c6ef2$export$8fe130820bc3f47e);
const $bdd539cf2f7c6ef2$export$23b774f011fb0045 = 'state.domain.reporters.UPDATE_ISSUE_REPORTER_MAP';
const $bdd539cf2f7c6ef2$export$8fe130820bc3f47e = (payload)=>({
        type: $bdd539cf2f7c6ef2$export$23b774f011fb0045,
        payload: payload
    });

});


parcelRegister("eelZZ", function(module, exports) {

$parcel$export(module.exports, "enableScenarios", () => $1cd2a2fd3db086f9$export$2069dd79b5cbd8b2);
$parcel$export(module.exports, "createScenario", () => $1cd2a2fd3db086f9$export$eb4b17f0922257e2);
$parcel$export(module.exports, "deleteScenario", () => $1cd2a2fd3db086f9$export$2aa284e9acf25212);
$parcel$export(module.exports, "disableScenarios", () => $1cd2a2fd3db086f9$export$8efa580e75af7168);
$parcel$export(module.exports, "updateScenario", () => $1cd2a2fd3db086f9$export$7d797dece46a4b0a);
$parcel$export(module.exports, "default", () => $1cd2a2fd3db086f9$export$2e2bcd8739ae039);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $75KhQ = parcelRequire("75KhQ");

var $dr8sv = parcelRequire("dr8sv");

var $j9mlP = parcelRequire("j9mlP");

var $5rVFi = parcelRequire("5rVFi");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $aFh1G = parcelRequire("aFh1G");
const $1cd2a2fd3db086f9$export$d5260d2dd06aa25 = 'command.scenarios.ENABLE_SCENARIOS';
const $1cd2a2fd3db086f9$export$726212a28c977994 = 'command.scenarios.CREATE_SCENARIO';
const $1cd2a2fd3db086f9$export$d0eccde1378805f6 = 'command.scenarios.DELETE_SCENARIO';
const $1cd2a2fd3db086f9$export$1c2ff7f28b1aacb1 = 'command.scenarios.DISABLE_SCENARIOS';
const $1cd2a2fd3db086f9$export$60e8b04bc54d4cc2 = 'command.scenarios.UPDATE_PLAN_SCENARIO';
const $1cd2a2fd3db086f9$export$2069dd79b5cbd8b2 = (payload)=>({
        type: $1cd2a2fd3db086f9$export$d5260d2dd06aa25,
        payload: payload
    });
const $1cd2a2fd3db086f9$export$eb4b17f0922257e2 = (payload)=>({
        type: $1cd2a2fd3db086f9$export$726212a28c977994,
        payload: payload
    });
const $1cd2a2fd3db086f9$export$2aa284e9acf25212 = (payload)=>({
        type: $1cd2a2fd3db086f9$export$d0eccde1378805f6,
        payload: payload
    });
const $1cd2a2fd3db086f9$export$8efa580e75af7168 = (scenarioToKeepId)=>({
        type: $1cd2a2fd3db086f9$export$1c2ff7f28b1aacb1,
        scenarioToKeepId: scenarioToKeepId
    });
const $1cd2a2fd3db086f9$export$7d797dece46a4b0a = (payload)=>({
        type: $1cd2a2fd3db086f9$export$60e8b04bc54d4cc2,
        payload: payload
    });
function* $1cd2a2fd3db086f9$export$21845d2e88ce6583({ payload: payload }) {
    try {
        const { domain: { plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
        if (!planId) throw new Error('Plan id is not available');
        if (!currentScenarioId) throw new Error('Scenario id is not available');
        yield (0, $9e8i2.put)((0, $j9mlP.initiateRequest)());
        const body = {
            planId: planId,
            ...payload
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $aFh1G.urls).enable, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        yield (0, $9e8i2.put)((0, $j9mlP.toggleDialogVisibility)(false));
        yield (0, $9e8i2.put)((0, $j9mlP.completeRequest)());
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $aFh1G.urls).scenarios,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            return;
        }
        yield (0, $9e8i2.put)((0, $dr8sv.enablePlanScenarios)([
            {
                id: currentScenarioId,
                planId: planId,
                title: payload.title,
                color: payload.color
            }
        ]));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $j9mlP.completeRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1cd2a2fd3db086f9$export$a613f554292bedd({ payload: { redirect: redirect, ...rest } }) {
    try {
        const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId } } } = yield (0, $9e8i2.select)($l0L3x.default);
        if (!planId) throw new Error('Plan ID is missing');
        yield (0, $9e8i2.put)((0, $j9mlP.initiateRequest)());
        const body = {
            planId: planId,
            ...rest
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $aFh1G.urls).scenarios, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        yield (0, $9e8i2.put)((0, $j9mlP.toggleDialogVisibility)(false));
        yield (0, $9e8i2.put)((0, $j9mlP.completeRequest)());
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $aFh1G.urls).scenarios,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            return;
        }
        const { id: id } = yield (0, $9e8i2.call)(response.json.bind(response));
        yield (0, $9e8i2.put)((0, $dr8sv.addPlanScenario)({
            id: id,
            planId: planId,
            title: rest.title,
            color: rest.color
        }));
        if (redirect && (0, $7CnHa.isDefined)(browserHistory)) yield (0, $9e8i2.call)((0, $lFLge.redirectToNewScenario), browserHistory, id);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $j9mlP.completeRequest)());
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1cd2a2fd3db086f9$export$99fac75bb20ed97f({ payload: { scenarioId: scenarioId, title: title } }) {
    let deletedScenario;
    try {
        const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
        if (!planId) throw new Error('Plan ID is missing');
        deletedScenario = {
            id: scenarioId,
            title: title,
            planId: planId
        };
        yield (0, $9e8i2.put)((0, $dr8sv.removePlanScenario)(deletedScenario));
        const body = {
            planId: planId,
            scenarioId: scenarioId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $aFh1G.urls).delete, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $aFh1G.urls).scenarios,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            yield (0, $9e8i2.put)((0, $dr8sv.addPlanScenario)(deletedScenario));
            return;
        }
        if (currentScenarioId === scenarioId && (0, $7CnHa.isDefined)(browserHistory)) {
            const scenarios = yield (0, $9e8i2.select)((0, $75KhQ.getPlanScenarios));
            yield (0, $9e8i2.call)((0, $lFLge.redirectToNewScenario), browserHistory, scenarios[0].id);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (deletedScenario) yield (0, $9e8i2.put)((0, $dr8sv.addPlanScenario)(deletedScenario));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1cd2a2fd3db086f9$export$e7dcec382a8c3081({ scenarioToKeepId: scenarioToKeepId }) {
    const { domain: { app: { browserHistory: browserHistory }, plan: { id: planId, currentScenarioId: currentScenarioId, scenarios: scenarios } } } = yield (0, $9e8i2.select)($l0L3x.default);
    try {
        if (!planId) throw new Error('Plan ID is missing');
        yield (0, $9e8i2.put)((0, $dr8sv.disablePlanScenarios)(scenarioToKeepId));
        const body = {
            planId: planId,
            scenarioToKeepId: scenarioToKeepId
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $aFh1G.urls).disable, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $dr8sv.enablePlanScenarios)(scenarios || []));
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $aFh1G.urls).scenarios,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            return;
        }
        if (currentScenarioId !== scenarioToKeepId && (0, $7CnHa.isDefined)(browserHistory)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const scenarios = yield (0, $9e8i2.select)((0, $75KhQ.getPlanScenarios));
            yield (0, $9e8i2.call)((0, $lFLge.redirectToNewScenario), browserHistory, scenarios[0].id);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $dr8sv.enablePlanScenarios)(scenarios || []));
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1cd2a2fd3db086f9$export$e1834d7eb47a78d7({ payload: payload }) {
    try {
        const { domain: { plan: { id: planId } } } = yield (0, $9e8i2.select)($l0L3x.default);
        if (!planId) throw new Error('Plan ID is missing');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const patch = Object.keys(payload).reduce((acc, el)=>{
            if (el === 'id') return Object.assign(acc, {
                scenarioId: payload[el]
            });
            return Object.assign(acc, {
                [el]: {
                    value: payload[el]
                }
            });
        }, {});
        const body = {
            planId: planId,
            ...patch
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), (0, $aFh1G.urls).update, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (!response.ok) {
            yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
                ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
                requestInfo: {
                    url: (0, $aFh1G.urls).update,
                    type: (0, $kP3Wn.POST),
                    status: response.status,
                    body: body
                }
            }));
            return;
        }
        yield (0, $9e8i2.put)((0, $dr8sv.updatePlanScenario)(payload));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    }
}
function* $1cd2a2fd3db086f9$export$a95809cfa8d2bf7e() {
    yield (0, $bG7pV.takeEvery)($1cd2a2fd3db086f9$export$d5260d2dd06aa25, $1cd2a2fd3db086f9$export$21845d2e88ce6583);
}
function* $1cd2a2fd3db086f9$export$68468727d6129272() {
    yield (0, $bG7pV.takeEvery)($1cd2a2fd3db086f9$export$726212a28c977994, $1cd2a2fd3db086f9$export$a613f554292bedd);
}
function* $1cd2a2fd3db086f9$export$17e1ec902a44bd43() {
    yield (0, $bG7pV.takeEvery)($1cd2a2fd3db086f9$export$d0eccde1378805f6, $1cd2a2fd3db086f9$export$99fac75bb20ed97f);
}
function* $1cd2a2fd3db086f9$export$786e98554684a8d3() {
    yield (0, $bG7pV.takeEvery)($1cd2a2fd3db086f9$export$1c2ff7f28b1aacb1, $1cd2a2fd3db086f9$export$e7dcec382a8c3081);
}
function* $1cd2a2fd3db086f9$export$138e003c42190081() {
    yield (0, $bG7pV.takeEvery)($1cd2a2fd3db086f9$export$60e8b04bc54d4cc2, $1cd2a2fd3db086f9$export$e1834d7eb47a78d7);
}
function* $1cd2a2fd3db086f9$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($1cd2a2fd3db086f9$export$a95809cfa8d2bf7e);
    yield (0, $9e8i2.fork)($1cd2a2fd3db086f9$export$68468727d6129272);
    yield (0, $9e8i2.fork)($1cd2a2fd3db086f9$export$17e1ec902a44bd43);
    yield (0, $9e8i2.fork)($1cd2a2fd3db086f9$export$786e98554684a8d3);
    yield (0, $9e8i2.fork)($1cd2a2fd3db086f9$export$138e003c42190081);
}

});
parcelRegister("j9mlP", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_SCENARIOS_DIALOG_VISIBILITY", () => $57788b0ce3a1c201$export$6439a3c47494e26c);
$parcel$export(module.exports, "INITIATE_REQUEST", () => $57788b0ce3a1c201$export$4580e708995fb75f);
$parcel$export(module.exports, "COMPLETE_REQUEST", () => $57788b0ce3a1c201$export$dbf282afa56573f1);
$parcel$export(module.exports, "toggleDialogVisibility", () => $57788b0ce3a1c201$export$3e2a6f206c6cc8da);
$parcel$export(module.exports, "initiateRequest", () => $57788b0ce3a1c201$export$82f68a404cfea29);
$parcel$export(module.exports, "completeRequest", () => $57788b0ce3a1c201$export$64739a9c2bbf975d);
const $57788b0ce3a1c201$export$6439a3c47494e26c = 'state.ui.settings.scenarios.TOGGLE_SCENARIOS_DIALOG_VISIBILITY';
const $57788b0ce3a1c201$export$4580e708995fb75f = 'state.ui.settings.scenarios.INITIATE_REQUEST';
const $57788b0ce3a1c201$export$dbf282afa56573f1 = 'state.ui.settings.scenarios.COMPLETE_REQUEST';
const $57788b0ce3a1c201$export$3e2a6f206c6cc8da = (visibility)=>({
        type: $57788b0ce3a1c201$export$6439a3c47494e26c,
        payload: visibility
    });
const $57788b0ce3a1c201$export$82f68a404cfea29 = ()=>({
        type: $57788b0ce3a1c201$export$4580e708995fb75f
    });
const $57788b0ce3a1c201$export$64739a9c2bbf975d = ()=>({
        type: $57788b0ce3a1c201$export$dbf282afa56573f1
    });

});

parcelRegister("aFh1G", function(module, exports) {

$parcel$export(module.exports, "urls", () => $6c9d702d1565caee$export$bcae9ba627f604b6);
const $6c9d702d1565caee$export$bcae9ba627f604b6 = {
    enable: '/rest/jpo/1.0/plans/enableMultiScenario',
    disable: '/rest/jpo/1.0/plans/disableMultiScenario',
    scenarios: '/rest/jpo/1.0/scenarios',
    delete: '/rest/jpo/1.0/scenarios/delete',
    update: '/rest/jpo/1.0/scenarios/update'
};

});


parcelRegister("hI5cD", function(module, exports) {

$parcel$export(module.exports, "createShareReportUrl", () => $0df21467ac764f5a$export$4018fa062b22188);
$parcel$export(module.exports, "default", () => $0df21467ac764f5a$export$2e2bcd8739ae039);

var $l0L3x = parcelRequire("l0L3x");
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $kP3Wn = parcelRequire("kP3Wn");

var $cbq3D = parcelRequire("cbq3D");

var $43peS = parcelRequire("43peS");

var $2UIWs = parcelRequire("2UIWs");

var $9H2AP = parcelRequire("9H2AP");

var $dYuck = parcelRequire("dYuck");

var $5rVFi = parcelRequire("5rVFi");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");

var $dk5mo = parcelRequire("dk5mo");
const $0df21467ac764f5a$export$8409ec1a90ca0eda = 'command.share-report.CREATE_SHARE_REPORT_URL';
const $0df21467ac764f5a$export$4018fa062b22188 = ()=>({
        type: $0df21467ac764f5a$export$8409ec1a90ca0eda
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $0df21467ac764f5a$var$getViewConfig(shareAs) {
    switch(shareAs){
        case (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE:
            return {
                filtersV0: yield (0, $9e8i2.select)((0, $43peS.getDependencyFilters))
            };
        default:
            return yield (0, $9e8i2.select)((0, $9H2AP.getViewSettings));
    }
}
function $0df21467ac764f5a$var$getViewType(shareAs) {
    switch(shareAs){
        case (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE:
            return 0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE;
        default:
            return 0, $5rYNM.TIMELINE_SHARE_TYPE;
    }
}
function* $0df21467ac764f5a$export$9a491b3da4e6dfec() {
    const { domain: { plan: { id: id, currentScenarioId: currentScenarioId } } } = yield (0, $9e8i2.select)($l0L3x.default);
    const shareAs = yield (0, $9e8i2.select)((0, $2UIWs.getShareAsState));
    const viewConfig = yield (0, $9e8i2.call)($0df21467ac764f5a$var$getViewConfig, shareAs);
    if (!id) throw new Error('No plan to share');
    try {
        yield (0, $9e8i2.put)((0, $dYuck.setLoadingShareReport)(true));
        const url = (0, $dk5mo.urls).share;
        const body = {
            entityId: id,
            entityType: 'PLAN',
            parameters: {
                viewConfig: // Add your configurations here!
                viewConfig,
                scenarioId: currentScenarioId,
                version: 3,
                view: $0df21467ac764f5a$var$getViewType(shareAs)
            }
        };
        const response = yield (0, $9e8i2.call)((0, $5rVFi.default), url, {
            method: (0, $kP3Wn.POST),
            body: body
        });
        if (response.ok) {
            const json = yield (0, $9e8i2.call)(response.json.bind(response));
            const location = yield (0, $9e8i2.call)((0, $lFLge.getLocation));
            const domain = location.origin;
            const hash = json.hash;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            let url = `${domain}/jira/plans/reports/${hash}`;
            if (shareAs === (0, $5rYNM.SHARE_AS).EMBED) url = `${domain}/secure/PlanEmbeddedReport.jspa?r=${hash}`;
            if (shareAs === (0, $5rYNM.SHARE_AS).CONFLUENCE || shareAs === (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) url = `${domain}/secure/PortfolioRoadmapConfluence.jspa?r=${hash}`;
            yield (0, $9e8i2.put)((0, $dYuck.updateShareReportUrl)(url));
        } else yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            ...(0, $kP3Wn.parseError)(response, (yield (0, $9e8i2.call)(response.text.bind(response)))),
            requestInfo: {
                url: url,
                type: (0, $kP3Wn.POST),
                status: response.status,
                body: body
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        yield (0, $9e8i2.put)((0, $cbq3D.genericError)({
            message: e.message,
            stackTrace: e.stack
        }));
    } finally{
        yield (0, $9e8i2.put)((0, $dYuck.setLoadingShareReport)(false));
    }
}
function* $0df21467ac764f5a$export$6926c353b9065c36() {
    yield (0, $bG7pV.takeEvery)($0df21467ac764f5a$export$8409ec1a90ca0eda, $0df21467ac764f5a$export$9a491b3da4e6dfec);
}
function* $0df21467ac764f5a$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($0df21467ac764f5a$export$6926c353b9065c36);
}

});
parcelRegister("43peS", function(module, exports) {

$parcel$export(module.exports, "NO_SPRINT_ID", () => $a0d555a67f949bb3$export$43e4bd26116c3832);
$parcel$export(module.exports, "getDependencyFilters", () => $a0d555a67f949bb3$export$9f024de859700a05);
$parcel$export(module.exports, "getGroupBy", () => $a0d555a67f949bb3$export$53a21aeef48e14a8);
$parcel$export(module.exports, "getDerivedRollupBy", () => $a0d555a67f949bb3$export$b34fa994a0b1a04f);
$parcel$export(module.exports, "getDerivedRollupHierarchyLevel", () => $a0d555a67f949bb3$export$ee8383ff306b4af6);
$parcel$export(module.exports, "getIssueInFocus", () => $a0d555a67f949bb3$export$252546b1d2d4555b);
$parcel$export(module.exports, "getIssueFilter", () => $a0d555a67f949bb3$export$d04c3e551cb51203);
$parcel$export(module.exports, "getProjectFilter", () => $a0d555a67f949bb3$export$4939fc722e810d76);
$parcel$export(module.exports, "getIssueLinkTypeFilter", () => $a0d555a67f949bb3$export$b41266013927b954);
$parcel$export(module.exports, "getStagePosAndScale", () => $a0d555a67f949bb3$export$39638c949f8528e7);
$parcel$export(module.exports, "matchesSprintFilter", () => $a0d555a67f949bb3$export$27808ca17f8ac6d9);
$parcel$export(module.exports, "getRolledUpIssuesLinks", () => $a0d555a67f949bb3$export$875d2ee98e4be59a);
$parcel$export(module.exports, "getShowReset", () => $a0d555a67f949bb3$export$9501b94120bcbbda);
$parcel$export(module.exports, "getUniqueFilterSprints", () => $a0d555a67f949bb3$export$5e2f833fb9b859c6);
$parcel$export(module.exports, "getSprintStatesCategories", () => $a0d555a67f949bb3$export$14fe519a54423fb3);
$parcel$export(module.exports, "getExternalSprintsForDependencyReport", () => $a0d555a67f949bb3$export$6993027b8d88ec7a);
$parcel$export(module.exports, "getShowAddDependency", () => $a0d555a67f949bb3$export$a74c8bcabfc4ae12);
$parcel$export(module.exports, "getAddDependencyFromIssueId", () => $a0d555a67f949bb3$export$9afef5a663d87a37);
$parcel$export(module.exports, "getDependencyReportStatus", () => $a0d555a67f949bb3$export$f96c47160d780e3d);

var $8YqJS = parcelRequire("8YqJS");

var $dEoWh = parcelRequire("dEoWh");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
var $kwMvv = parcelRequire("kwMvv");

var $cwP4d = parcelRequire("cwP4d");

var $c1XMU = parcelRequire("c1XMU");
var $a4NMN = parcelRequire("a4NMN");
parcelRequire("gbae2");
var $e730d = parcelRequire("e730d");
var $gbae2 = parcelRequire("gbae2");

var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $a0d555a67f949bb3$export$43e4bd26116c3832 = (0, $5rYNM.UNDEFINED_KEY);
const $a0d555a67f949bb3$export$9f024de859700a05 = (state)=>state.ui.Main.Tabs.Dependencies.Filters;
const $a0d555a67f949bb3$export$53a21aeef48e14a8 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.groupBy;
const $a0d555a67f949bb3$export$b34fa994a0b1a04f = (state)=>$a0d555a67f949bb3$export$53a21aeef48e14a8(state) === (0, $e730d.GroupBy).EPIC_LEVEL ? (0, $gbae2.ROLLUP_BY_OPTION).HIERARCHY : state.ui.Main.Tabs.Dependencies.Filters.rollupBy;
const $a0d555a67f949bb3$export$ee8383ff306b4af6 = (state)=>$a0d555a67f949bb3$export$53a21aeef48e14a8(state) === (0, $e730d.GroupBy).EPIC_LEVEL ? (0, $8YqJS.STORY_LEVEL) : state.ui.Main.Tabs.Dependencies.Filters.rollupHierarchyLevel;
const $a0d555a67f949bb3$export$252546b1d2d4555b = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueInFocus;
const $a0d555a67f949bb3$export$d04c3e551cb51203 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueFilter;
const $a0d555a67f949bb3$export$4939fc722e810d76 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.projectFilter;
const $a0d555a67f949bb3$export$d63c00efb8ec5b93 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.sprintFilter;
const $a0d555a67f949bb3$export$b41266013927b954 = (state)=>state.ui.Main.Tabs.Dependencies.Filters.issueLinkTypeFilter;
const $a0d555a67f949bb3$export$39638c949f8528e7 = (state)=>state.ui.Main.Tabs.Dependencies.StagePosAndScale;
const $a0d555a67f949bb3$var$getIssueFilterSafePure = (issuesById, issueFilter)=>{
    if (issueFilter !== null && issuesById[issueFilter]) return issueFilter;
    return null;
};
const $a0d555a67f949bb3$export$cc776683b8ca2a1a = (0, $iK4oF.createSelector)([
    (0, $cwP4d.getIssueMapById),
    $a0d555a67f949bb3$export$d04c3e551cb51203
], $a0d555a67f949bb3$var$getIssueFilterSafePure);
const $a0d555a67f949bb3$export$14dac874d99ad1a4 = (issueId, incomingLinks, outgoingLinks)=>{
    const specificIssueLinks = new Set();
    // Collect all the issues which are linked to the specific one via dependencies,
    // both immediate and transitive.
    // Handling cycles: skip met issues, but don't interrupt queue traversal.
    const queue = [
        issueId
    ];
    while(queue.length > 0){
        const id = queue.pop();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        for (const link of incomingLinks[id] || []){
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const id = link.sourceItemKey;
            if (!specificIssueLinks.has(id)) {
                specificIssueLinks.add(id);
                queue.push(id);
            }
        }
    }
    const outgoingQueue = [
        issueId
    ];
    while(outgoingQueue.length > 0){
        const outgoingQueueId = outgoingQueue.pop();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        for (const outgoingLink of outgoingLinks[outgoingQueueId] || []){
            const outgoingId = outgoingLink.targetItemKey;
            if (!specificIssueLinks.has(outgoingId)) {
                specificIssueLinks.add(outgoingId);
                outgoingQueue.push(outgoingId);
            }
        }
    }
    return specificIssueLinks;
};
const $a0d555a67f949bb3$export$27808ca17f8ac6d9 = (issue, sprintFilter)=>{
    const issueSprints = [
        ...issue.completedSprints || [],
        issue.sprint
    ].filter((0, $7CnHa.isDefined));
    return sprintFilter.has($a0d555a67f949bb3$export$43e4bd26116c3832) && issueSprints.length === 0 || issueSprints.some((sprint)=>sprintFilter.has(sprint));
};
const $a0d555a67f949bb3$export$c9b72860ad1772c6 = (internalOutgoingLinks, internalIncomingLinks, parentsAndDescendant, rollupBy, rollupHierarchyLevel, issueMap, issueInFocus, issueFilter, issues, projectFilter, issueLinkTypeFilter, sprintFilter)=>{
    const results = {};
    let hasDependency = false;
    let issuesToHighlight = new Set();
    let activeIssue = issueInFocus;
    if ((0, $7CnHa.isDefined)(issueFilter)) {
        const issueMatchesFilter = issues.find((issue)=>issue.id === issueFilter);
        if (issueMatchesFilter) activeIssue = issueMatchesFilter.id;
    }
    if ((0, $7CnHa.isDefined)(activeIssue)) {
        const chain = $a0d555a67f949bb3$export$14dac874d99ad1a4(activeIssue, internalIncomingLinks, internalOutgoingLinks);
        issuesToHighlight = new Set([
            ...chain,
            activeIssue
        ]);
    }
    // using a set to avoid duplicate issues in the "Issues without parent / team" group
    const otherIssues = new Set();
    Object.keys(internalOutgoingLinks).forEach((key)=>{
        const links = internalOutgoingLinks[key];
        if (links.length > 0) hasDependency = true;
        links.forEach((link)=>{
            const sourceIssue = issueMap[link.sourceItemKey];
            const targetIssue = issueMap[link.targetItemKey];
            if (sourceIssue && targetIssue) {
                // Project filter
                if (Array.isArray(projectFilter) && projectFilter.length > 0 && !(projectFilter.includes(sourceIssue.project.toString()) || projectFilter.includes(targetIssue.project.toString()))) return;
                // Issue Link Type filter
                if (Array.isArray(issueLinkTypeFilter) && issueLinkTypeFilter.length > 0 && !issueLinkTypeFilter.includes(link.type.toString())) return;
                // Sprint filter
                if (Array.isArray(sprintFilter) && sprintFilter.length > 0) {
                    const filterSprints = new Set(sprintFilter);
                    if (!($a0d555a67f949bb3$export$27808ca17f8ac6d9(sourceIssue, filterSprints) || $a0d555a67f949bb3$export$27808ca17f8ac6d9(targetIssue, filterSprints))) return;
                }
            }
            let sourceItemKey = null;
            let targetItemKey = null;
            let isSourceRolledUp = false;
            let isTargetRolledUp = false;
            if (rollupBy !== 'team') {
                sourceItemKey = link.sourceItemKey;
                targetItemKey = link.targetItemKey;
                if (sourceIssue.level < rollupHierarchyLevel && parentsAndDescendant[link.sourceItemKey]) {
                    const ancestors = parentsAndDescendant[link.sourceItemKey].ancestors;
                    const ancestorMatchesLevel = ancestors.find((ancestor)=>ancestor.level === rollupHierarchyLevel);
                    isSourceRolledUp = true;
                    if (ancestorMatchesLevel) sourceItemKey = ancestorMatchesLevel.id;
                    else {
                        otherIssues.add(sourceItemKey);
                        sourceItemKey = 'other';
                    }
                }
                if (targetIssue.level < rollupHierarchyLevel && parentsAndDescendant[link.targetItemKey]) {
                    const ancestors = parentsAndDescendant[link.targetItemKey].ancestors;
                    const ancestorMatchesLevel = ancestors.find((ancestor)=>ancestor.level === rollupHierarchyLevel);
                    isTargetRolledUp = true;
                    if (ancestorMatchesLevel) targetItemKey = ancestorMatchesLevel.id;
                    else {
                        otherIssues.add(targetItemKey);
                        targetItemKey = 'other';
                    }
                }
            }
            if (rollupBy === 'team') {
                if (!(0, $7CnHa.isDefined)(sourceIssue.team)) {
                    otherIssues.add(sourceIssue.id);
                    sourceItemKey = 'other';
                } else sourceItemKey = sourceIssue.team;
                if (!(0, $7CnHa.isDefined)(targetIssue.team)) {
                    otherIssues.add(targetIssue.id);
                    targetItemKey = 'other';
                } else targetItemKey = targetIssue.team;
                isSourceRolledUp = true;
                isTargetRolledUp = true;
            }
            if ((0, $7CnHa.isDefined)(issueFilter) && (!issuesToHighlight.has(sourceItemKey) || !issuesToHighlight.has(targetItemKey))) return;
            if ((0, $7CnHa.isDefined)(sourceItemKey) && !results[sourceItemKey]) results[sourceItemKey] = {};
            if ((0, $7CnHa.isDefined)(sourceItemKey) && (0, $7CnHa.isDefined)(targetItemKey) && !results[sourceItemKey][targetItemKey]) results[sourceItemKey][targetItemKey] = {
                type: rollupBy === 'team' ? 'team' : 'issue',
                links: [],
                highlight: false,
                rollup: false
            };
            if ((0, $7CnHa.isDefined)(sourceItemKey) && (0, $7CnHa.isDefined)(targetItemKey) && results[sourceItemKey] && results[sourceItemKey][targetItemKey]) {
                results[sourceItemKey][targetItemKey].links.push(link);
                if (isTargetRolledUp && isSourceRolledUp) results[sourceItemKey][targetItemKey].rollup = true;
                if (issuesToHighlight.has(sourceItemKey) && issuesToHighlight.has(targetItemKey)) results[sourceItemKey][targetItemKey].highlight = true;
            }
        });
    });
    return {
        links: results,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        otherIssues: [
            ...otherIssues
        ],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        activeIssue: activeIssue,
        hasDependency: hasDependency
    };
};
const $a0d555a67f949bb3$export$875d2ee98e4be59a = (0, $iK4oF.createSelector)([
    (0, $dEoWh.getInternalOutgoingLinks),
    (0, $dEoWh.getInternalIncomingLinks),
    (0, $kwMvv.getWholeHierarchyParentAndDescendant),
    $a0d555a67f949bb3$export$b34fa994a0b1a04f,
    $a0d555a67f949bb3$export$ee8383ff306b4af6,
    (0, $cwP4d.getIssueMapById),
    $a0d555a67f949bb3$export$252546b1d2d4555b,
    $a0d555a67f949bb3$export$cc776683b8ca2a1a,
    (0, $cwP4d.getIssues),
    $a0d555a67f949bb3$export$4939fc722e810d76,
    $a0d555a67f949bb3$export$b41266013927b954,
    $a0d555a67f949bb3$export$d63c00efb8ec5b93
], $a0d555a67f949bb3$export$c9b72860ad1772c6);
const $a0d555a67f949bb3$var$getShowResetPure = (groupBy, rollupBy, issueFilter, projectFilter, issueLinkTypeFilter, sprintFilter)=>(0, $7CnHa.isDefined)(rollupBy) && rollupBy !== (0, $gbae2.ROLLUP_BY_OPTION).NONE || (0, $7CnHa.isDefined)(groupBy) && groupBy !== (0, $e730d.GroupBy).NONE || (0, $7CnHa.isDefined)(issueFilter) && issueFilter !== '' || Array.isArray(projectFilter) && projectFilter.length > 0 || Array.isArray(issueLinkTypeFilter) && issueLinkTypeFilter.length > 0 || Array.isArray(sprintFilter) && sprintFilter.length > 0;
const $a0d555a67f949bb3$export$9501b94120bcbbda = (0, $iK4oF.createSelector)([
    $a0d555a67f949bb3$export$53a21aeef48e14a8,
    $a0d555a67f949bb3$export$b34fa994a0b1a04f,
    $a0d555a67f949bb3$export$d04c3e551cb51203,
    $a0d555a67f949bb3$export$4939fc722e810d76,
    $a0d555a67f949bb3$export$b41266013927b954,
    $a0d555a67f949bb3$export$d63c00efb8ec5b93
], $a0d555a67f949bb3$var$getShowResetPure);
const $a0d555a67f949bb3$export$5e2f833fb9b859c6 = (0, $iK4oF.createSelector)([
    $a0d555a67f949bb3$export$d63c00efb8ec5b93
], (sprintIds)=>new Set((0, $7CnHa.isDefined)(sprintIds) ? sprintIds : []));
const $a0d555a67f949bb3$export$14fe519a54423fb3 = (0, $iK4oF.createSelector)([
    (0, $c1XMU.getSprintsIdsByState),
    (0, $c1XMU.getExternalSprintsIds),
    $a0d555a67f949bb3$export$5e2f833fb9b859c6
], (0, $a4NMN.getSprintStatesCategoriesPure));
const $a0d555a67f949bb3$var$getExternalSprintsForDependencyReportPure = (externalSprints)=>externalSprints.map((sprint)=>{
        // eslint-disable-next-line no-param-reassign
        sprint.state = (0, $5rYNM.EXTERNAL_SPRINT);
        return sprint;
    });
const $a0d555a67f949bb3$export$6993027b8d88ec7a = (0, $iK4oF.createSelector)([
    (0, $c1XMU.getExternalSprints)
], $a0d555a67f949bb3$var$getExternalSprintsForDependencyReportPure);
const $a0d555a67f949bb3$export$a74c8bcabfc4ae12 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency.show;
const $a0d555a67f949bb3$export$9afef5a663d87a37 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency.fromIssueId;
const $a0d555a67f949bb3$export$9ef1ee05899da938 = (state)=>state.ui.Main.Tabs.Dependencies.AddDependency;
const $a0d555a67f949bb3$export$f96c47160d780e3d = (state)=>state.ui.Main.Tabs.Dependencies.ReportState.status;

});
parcelRegister("gbae2", function(module, exports) {

$parcel$export(module.exports, "ROLLUP_BY_OPTION", () => $a519c3b4d992e099$export$d9fa0ec49073b3ae);
$parcel$export(module.exports, "UNASSIGNED", () => $a519c3b4d992e099$export$3f4d79509888a8a1);
$parcel$export(module.exports, "NO_PARENT_GROUP_SUFFIX", () => $a519c3b4d992e099$export$377cc8309f78ea89);
$parcel$export(module.exports, "OTHER_GROUP_ID", () => $a519c3b4d992e099$export$1c43c7cada5ed38c);
$parcel$export(module.exports, "GROUP_BY_SPRINT_FIELD", () => $a519c3b4d992e099$export$3087c867fbc13a45);
$parcel$export(module.exports, "GroupBy", () => (parcelRequire("e730d")).GroupBy);

var $e730d = parcelRequire("e730d");
const $a519c3b4d992e099$export$c53d0f541b41b88e = 'none';
const $a519c3b4d992e099$export$fe791c4fa892e400 = 'project';
const $a519c3b4d992e099$export$bc8b984358922f81 = 'team';
const $a519c3b4d992e099$export$346285e0085a3842 = 'epic_level';
const $a519c3b4d992e099$export$b2223f32ad2e34cb = 'hierarchy';
const $a519c3b4d992e099$export$a316570a0dbfd2b0 = 'sprint';
const $a519c3b4d992e099$export$d9fa0ec49073b3ae = {
    NONE: $a519c3b4d992e099$export$c53d0f541b41b88e,
    HIERARCHY: $a519c3b4d992e099$export$b2223f32ad2e34cb,
    TEAM: $a519c3b4d992e099$export$bc8b984358922f81
};
const $a519c3b4d992e099$export$3f4d79509888a8a1 = 'unassigned';
const $a519c3b4d992e099$export$377cc8309f78ea89 = 'no_parent_group';
const $a519c3b4d992e099$export$1c43c7cada5ed38c = 'other';
const $a519c3b4d992e099$export$3087c867fbc13a45 = 'groupBySprintField';

});
parcelRegister("e730d", function(module, exports) {

$parcel$export(module.exports, "GroupBy", () => $d6bfb6add16b1d67$export$9abad2bb8d934a7f);
const $d6bfb6add16b1d67$export$9abad2bb8d934a7f = {
    NONE: 'none',
    PROJECT: 'project',
    TEAM: 'team',
    SPRINT: 'sprint',
    EPIC_LEVEL: 'epic_level'
};

});



parcelRegister("2UIWs", function(module, exports) {

$parcel$export(module.exports, "getShareAsState", () => $530d8cda338b7420$export$fe89daf00abed1f6);
const $530d8cda338b7420$export$fe89daf00abed1f6 = (state)=>state.ui.Top.TitleBar.ShareReport.shareAs;

});

parcelRegister("dYuck", function(module, exports) {

$parcel$export(module.exports, "OPEN_SHARE_REPORT_DIALOG", () => $915bc495a70c6bd7$export$836085c4d81f251d);
$parcel$export(module.exports, "CLOSE_SHARE_REPORT_DIALOG", () => $915bc495a70c6bd7$export$f50cb06862f792a8);
$parcel$export(module.exports, "LOADING_SHARE_REPORT_URL", () => $915bc495a70c6bd7$export$876c0239d6fbc58e);
$parcel$export(module.exports, "UPDATE_SHARE_REPORT_URL", () => $915bc495a70c6bd7$export$d3f43cf16dd0c690);
$parcel$export(module.exports, "UPDATE_SHARE_AS", () => $915bc495a70c6bd7$export$f38e20411ca33587);
$parcel$export(module.exports, "setLoadingShareReport", () => $915bc495a70c6bd7$export$2294ae698e2f6b56);
$parcel$export(module.exports, "updateShareReportUrl", () => $915bc495a70c6bd7$export$a1efe1f9253d8d3);
const $915bc495a70c6bd7$export$836085c4d81f251d = 'state.ui.top.title-bar.share-report.OPEN_SHARE_REPORT_DIALOG';
const $915bc495a70c6bd7$export$f50cb06862f792a8 = 'state.ui.top.title-bar.share-report.CLOSE_SHARE_REPORT_DIALOG';
const $915bc495a70c6bd7$export$876c0239d6fbc58e = 'state.ui.top.title-bar.share-report.LOADING_SHARE_REPORT_URL';
const $915bc495a70c6bd7$export$d3f43cf16dd0c690 = 'state.ui.top.title-bar.share-report.UPDATE_SHARE_REPORT_URL';
const $915bc495a70c6bd7$export$f38e20411ca33587 = 'state.ui.top.title-bar.share-report.UPDATE_SHARE_AS';
const $915bc495a70c6bd7$export$2294ae698e2f6b56 = (isLoading)=>({
        type: $915bc495a70c6bd7$export$876c0239d6fbc58e,
        payload: {
            isLoading: isLoading
        }
    });
const $915bc495a70c6bd7$export$a1efe1f9253d8d3 = (url)=>({
        type: $915bc495a70c6bd7$export$d3f43cf16dd0c690,
        payload: {
            url: url
        }
    });
const $915bc495a70c6bd7$export$f7081aac54367c97 = (shareAs)=>({
        type: $915bc495a70c6bd7$export$f38e20411ca33587,
        payload: {
            shareAs: shareAs
        }
    });

});

parcelRegister("dk5mo", function(module, exports) {

$parcel$export(module.exports, "urls", () => $d788dcf0cf5c49ea$export$bcae9ba627f604b6);
const $d788dcf0cf5c49ea$export$bcae9ba627f604b6 = {
    share: '/rest/jpo/1.0/genericreport/share'
};

});


parcelRegister("heBex", function(module, exports) {

$parcel$export(module.exports, "getSprintsForIds", () => $eb2df3a7724f6497$export$82e35078e5524b74);
$parcel$export(module.exports, "populateExternalSprints", () => $eb2df3a7724f6497$export$93c7e9eb4104792d);
$parcel$export(module.exports, "default", () => $eb2df3a7724f6497$export$2e2bcd8739ae039);
parcelRequire("6Zcms");
var $9e8i2 = parcelRequire("9e8i2");
var $bG7pV = parcelRequire("bG7pV");

var $iTjRl = parcelRequire("iTjRl");

var $75KhQ = parcelRequire("75KhQ");

var $dsxgv = parcelRequire("dsxgv");

var $kg3sZ = parcelRequire("kg3sZ");

var $9W5WC = parcelRequire("9W5WC");
const $eb2df3a7724f6497$export$d5302947a411ffb1 = 'command.sprint.GET_SPRINTS_FOR_IDS';
const $eb2df3a7724f6497$export$82e35078e5524b74 = (payload)=>({
        type: $eb2df3a7724f6497$export$d5302947a411ffb1,
        payload: payload
    });
function* $eb2df3a7724f6497$export$a67699f3a6f6bdde(allExternalSprints) {
    const disabledSprints = [];
    const externalSprints = [];
    allExternalSprints.forEach((sprint)=>{
        if (sprint.isDisabled === true) disabledSprints.push(sprint);
        else externalSprints.push(sprint);
    });
    yield (0, $9e8i2.put)($kg3sZ.add(externalSprints));
    yield (0, $9e8i2.put)($dsxgv.add(disabledSprints));
}
function* $eb2df3a7724f6497$export$6d66b37be32f516a({ payload: payload }) {
    const { id: planId, currentScenarioId: scenarioId } = yield (0, $9e8i2.select)((0, $75KhQ.getPlan));
    const response = yield* (0, $iTjRl.jsonOrError)({
        url: (0, $9W5WC.urls).sprintsForIds,
        method: 'POST',
        body: {
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: payload
        }
    });
    if (response.ok) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const externalSprints = response.data;
        yield (0, $9e8i2.call)($eb2df3a7724f6497$export$a67699f3a6f6bdde, externalSprints);
    }
}
function* $eb2df3a7724f6497$export$93c7e9eb4104792d(allSprints, planSprints) {
    const planSprintIds = new Set(planSprints.map((it)=>it.id));
    const externalSprints = allSprints.filter((it)=>!planSprintIds.has(it.id));
    yield (0, $9e8i2.call)($eb2df3a7724f6497$export$a67699f3a6f6bdde, externalSprints);
}
function* $eb2df3a7724f6497$export$e2949ba7d39c1662() {
    yield (0, $bG7pV.takeEvery)($eb2df3a7724f6497$export$d5302947a411ffb1, $eb2df3a7724f6497$export$6d66b37be32f516a);
}
function* $eb2df3a7724f6497$export$2e2bcd8739ae039() {
    yield (0, $9e8i2.fork)($eb2df3a7724f6497$export$e2949ba7d39c1662);
}

});
parcelRegister("dsxgv", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $2c7b7542149517cb$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $2c7b7542149517cb$export$4a991c87e640ef77);
$parcel$export(module.exports, "add", () => $2c7b7542149517cb$export$e16d8520af44a096);
$parcel$export(module.exports, "reset", () => $2c7b7542149517cb$export$aad8462122ac592b);
const $2c7b7542149517cb$export$bb6389024b71c2ae = 'state.domain.disabled-sprints.ADD';
const $2c7b7542149517cb$export$4a991c87e640ef77 = 'state.domain.disabled-sprints.RESET';
const $2c7b7542149517cb$export$e16d8520af44a096 = (payload)=>({
        type: $2c7b7542149517cb$export$bb6389024b71c2ae,
        payload: payload
    });
const $2c7b7542149517cb$export$aad8462122ac592b = (payload)=>({
        type: $2c7b7542149517cb$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("kg3sZ", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $d767a9c4fd668c47$export$bb6389024b71c2ae);
$parcel$export(module.exports, "RESET", () => $d767a9c4fd668c47$export$4a991c87e640ef77);
$parcel$export(module.exports, "add", () => $d767a9c4fd668c47$export$e16d8520af44a096);
const $d767a9c4fd668c47$export$bb6389024b71c2ae = 'state.domain.external-sprints.ADD';
const $d767a9c4fd668c47$export$4a991c87e640ef77 = 'state.domain.external-sprints.RESET';
const $d767a9c4fd668c47$export$e16d8520af44a096 = (payload)=>({
        type: $d767a9c4fd668c47$export$bb6389024b71c2ae,
        payload: payload
    });
const $d767a9c4fd668c47$export$aad8462122ac592b = (payload)=>({
        type: $d767a9c4fd668c47$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("9W5WC", function(module, exports) {

$parcel$export(module.exports, "urls", () => $91e3919cdac1779f$export$bcae9ba627f604b6);
const $91e3919cdac1779f$export$bcae9ba627f604b6 = {
    sprintsForIds: '/rest/jpo/1.0/sprint/get'
};

});


parcelRegister("9Nhwa", function(module, exports) {

$parcel$export(module.exports, "RESET_REDUX_STORE", () => $5ea5eb0d0a531397$export$fbb68db26834815d);
$parcel$export(module.exports, "RESTORE_REDUX_STORE", () => $5ea5eb0d0a531397$export$2e5623391f1ce3b5);
$parcel$export(module.exports, "resetReduxStore", () => $5ea5eb0d0a531397$export$6c0dcd2cdf8ea8de);
$parcel$export(module.exports, "restoreReduxStore", () => $5ea5eb0d0a531397$export$61e7b1f8f9c1a24b);
const $5ea5eb0d0a531397$export$fbb68db26834815d = 'state.RESET_REDUX_STORE';
const $5ea5eb0d0a531397$export$2e5623391f1ce3b5 = 'state.RESTORE_REDUX_STORE';
const $5ea5eb0d0a531397$export$6c0dcd2cdf8ea8de = ()=>({
        type: $5ea5eb0d0a531397$export$fbb68db26834815d
    });
const $5ea5eb0d0a531397$export$61e7b1f8f9c1a24b = (initialState)=>({
        type: $5ea5eb0d0a531397$export$2e5623391f1ce3b5,
        payload: initialState
    });

});


parcelRegister("6xtFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $88a31f473462c9ce$export$2e2bcd8739ae039);

var $5OdRK = parcelRequire("5OdRK");

var $5GdAe = parcelRequire("5GdAe");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $ebzbc = parcelRequire("ebzbc");
function $88a31f473462c9ce$export$2e2bcd8739ae039(store) {
    const observer = ()=>{
        const state = store.getState();
        const activeView = (0, $dBKyg.getActiveView)(state);
        if (!activeView) return;
        const preferences = (0, $9H2AP.getViewSettings)(state);
        if ($5OdRK.default(preferences, activeView.preferences)) return;
        store.dispatch((0, $5GdAe.modifyView)({
            id: activeView.id,
            preferences: preferences
        }));
    };
    return store.subscribe((0, $ebzbc.relaxedScheduler)(observer));
}

});
parcelRegister("ebzbc", function(module, exports) {

$parcel$export(module.exports, "makeRelationsMap", () => $1feb4ca2c6b51750$export$28b13bfc110f7aa);
$parcel$export(module.exports, "relaxedScheduler", () => $1feb4ca2c6b51750$export$d999bead76c31bfe);
const $1feb4ca2c6b51750$export$28b13bfc110f7aa = ()=>({
        issueType: new Set(),
        project: new Set(),
        sprint: new Set(),
        version: new Set()
    });
const $1feb4ca2c6b51750$export$d999bead76c31bfe = (callback)=>{
    let executionTime = 25;
    const requestCallback = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback || ((f)=>setTimeout(f, 2 * executionTime));
    let isScheduled = false;
    let scheduleNextCall = false;
    let wrapper;
    const schedule = ()=>{
        isScheduled = true;
        requestCallback(wrapper);
    };
    wrapper = ()=>{
        isScheduled = false;
        const startMark = performance.now();
        callback();
        executionTime = performance.now() - startMark;
        if (scheduleNextCall) {
            scheduleNextCall = false;
            schedule();
        }
    };
    return ()=>{
        if (scheduleNextCall) return;
        if (isScheduled) {
            scheduleNextCall = true;
            return;
        }
        schedule();
    };
};

});


parcelRegister("2FY8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7278a860673276$export$2e2bcd8739ae039);

var $agcf7 = parcelRequire("agcf7");

var $8qtqq = parcelRequire("8qtqq");

var $heBex = parcelRequire("heBex");

var $051m9 = parcelRequire("051m9");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");

var $c1XMU = parcelRequire("c1XMU");

var $wcCGG = parcelRequire("wcCGG");

var $ebzbc = parcelRequire("ebzbc");
/*

This observer scans state for references to missing entities and tries to load these entities.

It is not complete yet! If you hit a situation when you get missing relations, please update
the observer code to handle your case.

Also, we might want to migrate here fetching issue team and assignee as well.

Relations to be checked in state.domain:

+------------------------------+------------------------------+
| From                         | To                           |
|------------------------------|------------------------------|
| issues, originalIssues       | [x] project                  |
|                              | [ ] assignee                 |
|                              | [x] fixVersions              |
|                              | [ ] parent                   |
|                              | [x] type                     |
|                              | [x] externalSprint           |
|                              | [x] external completedSprints|
|                              | ...                          |
|------------------------------|------------------------------|
| versions, originalVersions,  | ...                          |
| crossProjectVersions,        |                              |
| originalCrossProjectVersions |                              |
| removedVersions              |                              |
|------------------------------|------------------------------|
| filters                      | ...                          |
|------------------------------|------------------------------|
| issueLinks                   | ...                          |
|------------------------------|------------------------------|
| projects                     | ...                          |
|------------------------------|------------------------------|
| updateJira                   | ...                          |
|------------------------------|------------------------------|
| teams, originalTeams,        | ...                          |
| teamsAdditional              |                              |
+------------------------------+------------------------------+

*/ const $be7278a860673276$var$requestActionCreators = {
    issueType: (0, $agcf7.getIssueTypesForIds),
    project: (0, $8qtqq.getProjectsForIds),
    sprint: (0, $heBex.getSprintsForIds),
    version: (0, $051m9.getReleasesForIds)
};
const $be7278a860673276$export$646c2b2ed0073599 = (check, // `any` is justified here as function is generic over any entity structure
// `{ [key: string]: any}` would be more appropriate but it triggers Flow to infer object structure
// which of course is incompatible across various entity types
// eslint-disable-next-line @typescript-eslint/no-explicit-any
entities, typeToAttributes)=>{
    for (const entity of entities)// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const type of Object.keys(typeToAttributes)){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
        const attributes = [].concat(typeToAttributes[type]);
        for (const attribute of attributes){
            const id = entity[attribute];
            if (Array.isArray(id)) // eslint-disable-next-line @typescript-eslint/no-shadow
            id.forEach((id)=>check(type, id));
            else check(type, id);
        }
    }
};
const $be7278a860673276$var$createObserver = (store)=>{
    // Map of entity type to set of ids which we already requested from server.
    // Right now we don't distinguish successful retrieval from failure,
    // we just don't want to ask about the same entity twice in both cases.
    const resolvedRelations = (0, $ebzbc.makeRelationsMap)();
    const observer = ()=>{
        const state = store.getState();
        // Lookup tables to quickly check if entity is present in the app state.
        const lookup = {
            issueType: (0, $lihml.getIssueTypesById)(state),
            project: (0, $ehEr2.getProjectsById)(state),
            sprint: (0, $c1XMU.getAllSprintsIncludingDisabledByIdMap)(state),
            version: (0, $wcCGG.getVersionsById)(state)
        };
        // Map of entity type to set of ids to request server for.
        const unresolvedRelations = (0, $ebzbc.makeRelationsMap)();
        // Add id to unresolvedRelations to request for it at the end of the function,
        // and add it to resolvedRelations straight away to mark it as resolved for the next function call.
        const track = (type, id)=>{
            // not sure why these are expecting `never` =(
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            unresolvedRelations[type].add(id);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            resolvedRelations[type].add(id);
        };
        // Check if relation is missing and unresolved and mark it for loading if so.
        const check = (type, id)=>{
            const lookupValue = lookup[type][id];
            // not sure why this is expecting `never` =(
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (id && !(lookupValue || resolvedRelations[type].has(id))) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            track(type, id);
        };
        // Now let's scan for references to missing entities.
        // state.domain.issues
        $be7278a860673276$export$646c2b2ed0073599(check, (0, $cwP4d.getAllIssues)(state), {
            project: 'project',
            issueType: 'type',
            sprint: [
                'sprint',
                'completedSprints'
            ],
            version: 'fixVersions'
        });
        // state.domain.originalIssues
        // Portfolio doesn't support changing project and type of issue,
        // thus we are not checking them in originalIssues.
        // state.domain.versions
        // ...
        // Now let's execute commands to ask server for missing entities.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const type of Object.keys(unresolvedRelations)){
            const ids = unresolvedRelations[type];
            if (ids.size > 0) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            store.dispatch($be7278a860673276$var$requestActionCreators[type]([
                ...ids
            ]));
        }
    };
    return store.subscribe((0, $ebzbc.relaxedScheduler)(observer));
};
var $be7278a860673276$export$2e2bcd8739ae039 = $be7278a860673276$var$createObserver;

});

parcelRegister("131Tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d13537d567c193$export$2e2bcd8739ae039);

var $k94CF = parcelRequire("k94CF");

var $ebzbc = parcelRequire("ebzbc");
/*

This observer checks for any changes to the state that would invalidate the solution cache.

*/ const $e3d13537d567c193$var$createObserver = (store)=>{
    let currentState;
    const observer = ()=>{
        const previousState = currentState;
        currentState = store.getState();
        if (!previousState) store.dispatch((0, $k94CF.setValidity)(false));
        else if (currentState.domain.solution.isValid) {
            if (previousState.domain.sequence !== currentState.domain.sequence || previousState.domain.plan !== currentState.domain.plan || previousState.ui.Main.Tabs.Roadmap.Scope.Issues.selected !== currentState.ui.Main.Tabs.Roadmap.Scope.Issues.selected) store.dispatch((0, $k94CF.setValidity)(false));
        }
    };
    return store.subscribe((0, $ebzbc.relaxedScheduler)(observer));
};
var $e3d13537d567c193$export$2e2bcd8739ae039 = $e3d13537d567c193$var$createObserver;

});

parcelRegister("9f99L", function(module, exports) {

$parcel$export(module.exports, "default", () => $451e27197a5a52cd$export$2e2bcd8739ae039);

var $9FeHi = parcelRequire("9FeHi");
var $5OdRK = parcelRequire("5OdRK");
var $i0RGP = parcelRequire("i0RGP");
var $eirae = parcelRequire("eirae");
var $kjklK = parcelRequire("kjklK");
var $f7Op5 = parcelRequire("f7Op5");
var $h3f0m = parcelRequire("h3f0m");
var $l3byl = parcelRequire("l3byl");

var $1ybV0 = parcelRequire("1ybV0");

var $l2Sj2 = parcelRequire("l2Sj2");
var $juY6T = parcelRequire("juY6T");

var $6Grzy = parcelRequire("6Grzy");

var $cuuJa = parcelRequire("cuuJa");

var $h7pZO = parcelRequire("h7pZO");

var $6itAY = parcelRequire("6itAY");
parcelRequire("1Szmp");

var $9lwEQ = parcelRequire("9lwEQ");

var $hLlYV = parcelRequire("hLlYV");

var $9zeAN = parcelRequire("9zeAN");

var $1C7Mn = parcelRequire("1C7Mn");

var $6fxQQ = parcelRequire("6fxQQ");
parcelRequire("bJc6r");
var $8bnQD = parcelRequire("8bnQD");

var $akhOi = parcelRequire("akhOi");

var $2Ruxt = parcelRequire("2Ruxt");

var $kKj1m = parcelRequire("kKj1m");
parcelRequire("eA35d");
var $9H2AP = parcelRequire("9H2AP");

var $fbHoQ = parcelRequire("fbHoQ");
parcelRequire("bRpYp");
parcelRequire("77IHm");
parcelRequire("kahmZ");

var $dEoWh = parcelRequire("dEoWh");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");
parcelRequire("75KhQ");
var $eOsHk = parcelRequire("eOsHk");
var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $cwP4d = parcelRequire("cwP4d");

var $7s3LJ = parcelRequire("7s3LJ");

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $kogU9 = parcelRequire("kogU9");

var $aMoMC = parcelRequire("aMoMC");

var $beuE2 = parcelRequire("beuE2");

var $eDYLe = parcelRequire("eDYLe");

var $wcCGG = parcelRequire("wcCGG");

var $9H2AP = parcelRequire("9H2AP");

var $dBKyg = parcelRequire("dBKyg");

var $kyGCj = parcelRequire("kyGCj");

var $fr1nu = parcelRequire("fr1nu");

var $1umd3 = parcelRequire("1umd3");

var $fDCVo = parcelRequire("fDCVo");

var $lNYdY = parcelRequire("lNYdY");

var $eaaIH = parcelRequire("eaaIH");

var $8B14N = parcelRequire("8B14N");


var $c7fhc = parcelRequire("c7fhc");

var $hHEgb = parcelRequire("hHEgb");

var $l1dWb = parcelRequire("l1dWb");

var $l4n5f = parcelRequire("l4n5f");

var $iX8wj = parcelRequire("iX8wj");

var $9G8kJ = parcelRequire("9G8kJ");

var $8Nqhy = parcelRequire("8Nqhy");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $9RUk7 = parcelRequire("9RUk7");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $83lyg = parcelRequire("83lyg");
const $451e27197a5a52cd$var$changesOfType = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
changes, selectedChanges, scenarioType)=>{
    const changesById = (0, $7CnHa.indexBy)($f7Op5.default('id'), changes);
    return selectedChanges.filter((id)=>changesById[id].metaData.scenarioType === scenarioType).length;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $451e27197a5a52cd$var$typeOfCustomField = (field)=>{
    const fieldKey = field && $kjklK.default([
        'type',
        'key'
    ], field);
    const fieldType = fieldKey && fieldKey.split(':')[1] || '';
    return `customfield_${fieldType}`;
};
const $451e27197a5a52cd$var$filterSourceMap = {
    '#plan/backlog': (0, $12ee831723ccf9c2$export$f4ac8734c859ca93),
    '#plan/releases': (0, $12ee831723ccf9c2$export$eb2de919d11696d)
};
const $451e27197a5a52cd$var$isPredefined = (view)=>!(0, $7CnHa.isDefined)(view.createdBy) && !(0, $7CnHa.isDefined)(view.updatedBy);
const $451e27197a5a52cd$var$handleAnalyticsError = (analyticsArgs)=>(action)=>{
        try {
            return analyticsArgs(action);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $83lyg.logAnalyticsError)(error, `analytics failed in ${action.type}`);
        }
    };
class $451e27197a5a52cd$var$AnalyticsMiddleware {
    constructor(){
        this.apply = (store)=>(next)=>$451e27197a5a52cd$var$handleAnalyticsError((action)=>{
                    switch(action.type){
                        case 0, $fr1nu.AFTER_RESET_BACKLOG:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const dependencyCount = (0, $7CnHa.valuesKeysLength)(state.domain.issueLinks.values);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_BACKLOG.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_BACKLOG, {
                                        dependencyCount: dependencyCount
                                    });
                                }
                                break;
                            }
                        case 0, $9lwEQ.BEFORE_APPLY_CHANGE:
                            this.applyChangeTimer = new (0, $juY6T.default)();
                            this.applyChangeTimer.start();
                            break;
                        // Triggered when a suggested schedule has finished being accepted into a plan
                        case 0, $9lwEQ.AFTER_APPLY_CHANGE:
                            if ((0, $7CnHa.isDefined)(this.applyChangeTimer) && this.applyChangeTimer.isStarted() && !this.applyChangeTimer.isStopped()) {
                                this.applyChangeTimer.stop();
                                const state = store.getState();
                                const { id: planId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_ACCEPT_OPTIMIZATION.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        // The time (in milli-seconds) that it took to accept the suggested schedule
                                        totalTimeInMillis: this.applyChangeTimer.duration()
                                    });
                                }
                            }
                            break;
                        case 0, $9lwEQ.BEFORE_OPTIMIZE_CALCULATION:
                            this.optimizeCalculationTimer = new (0, $juY6T.default)();
                            this.optimizeCalculationTimer.start();
                            break;
                        case 0, $9lwEQ.AFTER_OPTIMIZE_CALCULATION:
                            {
                                const afterOptimizeCalculationAction = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                action;
                                if ((0, $7CnHa.isDefined)(this.optimizeCalculationTimer) && this.optimizeCalculationTimer.isStarted() && !this.optimizeCalculationTimer.isStopped()) {
                                    this.optimizeCalculationTimer.stop();
                                    const state = store.getState();
                                    const { id: planId } = (0, $75KhQ.getPlan)(state);
                                    if ((0, $7CnHa.isDefined)(planId)) {
                                        const selectedIssues = (0, $kwMvv.getSelectedIssues)(state);
                                        (0, $6Grzy.default).triggerCalculationDurationAnalytics(afterOptimizeCalculationAction.meta.analyticsEvent, {
                                            totalTimeInMillis: this.optimizeCalculationTimer.duration(),
                                            isSelectiveScheduling: selectedIssues.length > 0
                                        });
                                    }
                                }
                                break;
                            }
                        case 0, $6fxQQ.COMMIT_CHANGES:
                            {
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const commitChangesAction = action;
                                const state = store.getState();
                                if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view')) {
                                    const countForGoals = (0, $eDYLe.getCountForGoals)(state);
                                    if (countForGoals.numAddedGoals || countForGoals.numRemovedGoals) {
                                        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
                                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goals updated', {
                                            source: 'Plans',
                                            ...countForGoals
                                        });
                                    }
                                }
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const teamsData = state.domain.teams;
                                const versionChanges = (0, $wcCGG.getVersionChanges)(state);
                                const crossProjectVersionChanges = (0, $2Ruxt.getCrossProjectVersionChanges)(state);
                                const selectedChanges = (0, $eDYLe.getSelectedChanges)(state);
                                const selectedVersionChanges = selectedChanges[(0, $5rYNM.ENTITY).RELEASE];
                                const selectedCrossProjectVersionChanges = selectedChanges[(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE];
                                const changedAttributeCounts = (0, $kwMvv.getIssueAttributeChangeCounts)(state);
                                const createdIssueCount = (0, $kwMvv.getCreatedIssueCount)(state);
                                const countForStatusCategory = (0, $eDYLe.getCountForStatusCategory)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $6Grzy.default).triggerUpdateJiraEventAnalytics(commitChangesAction.meta.analyticsEvent, {
                                    teamCreateCount: teamsData.filter((team)=>team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED).length,
                                    teamUpdateCount: teamsData.filter((team)=>team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).UPDATED).length,
                                    versionCreateCount: $451e27197a5a52cd$var$changesOfType(versionChanges, selectedVersionChanges, (0, $5rYNM.SCENARIO_TYPE).ADDED),
                                    versionUpdateCount: $451e27197a5a52cd$var$changesOfType(versionChanges, selectedVersionChanges, (0, $5rYNM.SCENARIO_TYPE).UPDATED),
                                    versionRemoveCount: $451e27197a5a52cd$var$changesOfType(versionChanges, selectedVersionChanges, (0, $5rYNM.SCENARIO_TYPE).DELETED),
                                    versionCPRCreateCount: $451e27197a5a52cd$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $5rYNM.SCENARIO_TYPE).ADDED),
                                    versionCPRUpdateCount: $451e27197a5a52cd$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $5rYNM.SCENARIO_TYPE).UPDATED),
                                    versionCPRRemoveCount: $451e27197a5a52cd$var$changesOfType(crossProjectVersionChanges, selectedCrossProjectVersionChanges, (0, $5rYNM.SCENARIO_TYPE).DELETED),
                                    issueCreateCount: createdIssueCount,
                                    assigneeChangeCount: changedAttributeCounts.assignee || 0,
                                    baselineStartChangeCount: changedAttributeCounts.baselineStart || 0,
                                    baselineEndChangeCount: changedAttributeCounts.baselineEnd || 0,
                                    customFieldChangeCount: changedAttributeCounts.customField || 0,
                                    dueDateChangeCount: changedAttributeCounts.dueDate || 0,
                                    fixVersionsChangeCount: changedAttributeCounts.fixVersions || 0,
                                    labelsChangeCount: changedAttributeCounts.labels || 0,
                                    lexoRankChangeCount: changedAttributeCounts.lexoRank || 0,
                                    parentChangeCount: changedAttributeCounts.parent || 0,
                                    priorityChangeCount: changedAttributeCounts.priority || 0,
                                    sprintChangeCount: changedAttributeCounts.sprint || 0,
                                    storyPointsChangeCount: changedAttributeCounts.storyPoints || 0,
                                    summaryChangeCount: changedAttributeCounts.summary || 0,
                                    descriptionChangeCount: changedAttributeCounts.description || 0,
                                    teamChangeCount: changedAttributeCounts.team || 0,
                                    componentsChangeCount: changedAttributeCounts.components || 0,
                                    countForStatusCategory: countForStatusCategory,
                                    ...(0, $1ybV0.ff)('plans-update-review-changes-to-unsaved-changes_sbz4w') ? {
                                        isPlansUpdateReviewChangesEnabled: true
                                    } : {}
                                });
                                break;
                            }
                        case 0, $83cf706a87a62789$export$242fccfb90c57247:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_ISSUE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                    const addAction = action;
                                    let attributes;
                                    if ((0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr')) attributes = (0, $83lyg.getIssueAnalyticAttributesNew)(addAction.payload.issue, (0, $lihml.getIssueTypesById)(state), (0, $ehEr2.getProjectsById)(state), {});
                                    else attributes = (0, $83lyg.getIssueAnalyticAttributes)(addAction.payload.issue, (0, $lihml.getIssueTypesById)(state), {});
                                    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_ISSUE, attributes);
                                }
                                break;
                            }
                        case 0, $83cf706a87a62789$export$b6c322dbc4f2f8ac:
                            {
                                const state = store.getState();
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const selectedIssues = (0, $kwMvv.getSelectedIssues)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_ISSUES.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const bulkUpdateAction = action;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    // We can't rely on the MOVE_ISSUE action to determine issues because it is also
                                    // called when ranking issues. However, we know that a move event has occurred when
                                    // an issue is updated with a new parent.
                                    if (bulkUpdateAction.payload && bulkUpdateAction.payload.parent) {
                                        // eslint-disable-next-line @typescript-eslint/no-shadow
                                        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUES.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                    }
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        issueCount: selectedIssues.length,
                                        attributes: Object.keys(bulkUpdateAction.payload).filter((key)=>key !== 'id')
                                    });
                                }
                                break;
                            }
                        case 0, $83cf706a87a62789$export$d46fd8e9a2a59b28:
                            {
                                const state = store.getState();
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_ISSUE.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const updateAction = action;
                                const issue = (0, $cwP4d.getIssueMapById)(state)[updateAction.payload.id];
                                const updatedFields = Object.keys(updateAction.payload).filter((key)=>key !== 'id');
                                let attributes;
                                if ((0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr')) attributes = (0, $83lyg.getIssueAnalyticAttributesNew)(issue, (0, $lihml.getIssueTypesById)(state), (0, $ehEr2.getProjectsById)(state), {
                                    updatedFields: updatedFields
                                });
                                else attributes = (0, $83lyg.getIssueAnalyticAttributes)(issue, (0, $lihml.getIssueTypesById)(state), {
                                    updatedFields: updatedFields
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
                                break;
                            }
                        case 0, $83cf706a87a62789$export$9bbbeac0bf5bf14:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const rankAction = action;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const issueId = rankAction.payload.itemKeys[0];
                                    const issue = (0, $cwP4d.getIssueMapById)(state)[issueId];
                                    let attributes;
                                    if ((0, $1ybV0.ff)('support-cross-project-parenting-for-initiativesepics-in-tmp._piqmr')) attributes = (0, $83lyg.getIssueAnalyticAttributesNew)(issue, (0, $lihml.getIssueTypesById)(state), (0, $ehEr2.getProjectsById)(state), {
                                        method: 'dragged'
                                    });
                                    else attributes = (0, $83lyg.getIssueAnalyticAttributes)(issue, (0, $lihml.getIssueTypesById)(state), {
                                        method: 'dragged'
                                    });
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).RANK_ISSUE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).RANK_ISSUE, attributes);
                                }
                                break;
                            }
                        case 0, $9zeAN.VIEW_ROADMAP:
                            {
                                const state = store.getState();
                                // Don't fire the view roadmapTabScreen event in export mode.
                                if ((0, $akhOi.isExportMode)(state)) break;
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const viewRoadmapAction = action;
                                const autoSchedulerEnabled = (0, $75KhQ.getAutoSchedulerEnabled)(state);
                                const { id: planId, currentScenarioId: scenarioId, zeroMemberTeamsCount: zmtCount, isSamplePlan: isSamplePlan } = (0, $75KhQ.getPlan)(state);
                                const planningUnit = (0, $75KhQ.getPlanningUnit)(state);
                                const customFields = (0, $kKj1m.getCustomFields)(state);
                                const group = (0, $9RUk7.getGroupForAnalyticEvent)((0, $9H2AP.getVisualisationViewSettings)(state).grouping, customFields);
                                const sorting = (0, $9H2AP.getVisualisationViewSettings)(state).sorting;
                                const sortingField = (0, $7s3LJ.getFieldKey)(sorting.field, planningUnit);
                                const sortByField = sorting.isCustomField ? `customfield_${sorting.type}` : sortingField;
                                const showSprints = (0, $9H2AP.getVisualisationViewSettings)(state).showSprints;
                                const showWarnings = (0, $9H2AP.getWarningViewSettings)(state).showWarning;
                                const rollupSettings = (0, $9H2AP.getRollupViewSettings)(state);
                                let colourBy = (0, $kyGCj.getColorByValue)(state);
                                if ((0, $kyGCj.isColorByCustomFieldOption)(colourBy)) {
                                    const customFieldsById = (0, $kKj1m.getCustomFieldsById)(state);
                                    colourBy = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                    customFieldsById[colourBy]?.type?.title || colourBy;
                                }
                                const colours = (0, $83lyg.getColoursUsedInPlan)((0, $9H2AP.getColorByViewSettings)(state));
                                const existingTeams = state.domain.teams.filter((team)=>team.scenarioType !== 'DELETED');
                                const teamsScrumCount = existingTeams.filter((team)=>team.schedulingMode === 'Scrum').length;
                                const teamsKanbanCount = existingTeams.filter((team)=>team.schedulingMode === 'Kanban').length;
                                const teamsSharedCount = existingTeams.filter((team)=>team.shareable).length;
                                const projectsShownInPlan = (0, $75KhQ.getIssueSources)(state).filter((source)=>source.type === 'Project').map((project)=>Number(project.value));
                                const boardsShownInPlan = (0, $75KhQ.getIssueSources)(state).filter((source)=>source.type === 'Board').map((board)=>Number(board.value));
                                const filtersShownInPlan = (0, $75KhQ.getIssueSources)(state).filter((source)=>source.type === 'Filter').map((filter)=>Number(filter.value));
                                const sourcesTotalCount = (0, $75KhQ.getIssueSources)(state).length;
                                const sourcesBoardCount = boardsShownInPlan.length;
                                const sourcesProjectCount = projectsShownInPlan.length;
                                const sourcesFilterCount = filtersShownInPlan.length;
                                const planPermission = (0, $akhOi.getPlanUserRole)(state);
                                const instancePermission = (0, $dhHiZ.getInstanceUserRole)(state);
                                const { active: sprintActiveCount, future: sprintFutureCount, sprintFutureSetDates: sprintFutureSetDatesCount, sprintFutureInferredDates: sprintFutureInferredDatesCount } = (0, $83lyg.countFutureSprintDates)(state.domain.sprints);
                                const { issuesWithFixedStartDateCount: issuesWithFixedStartDateCount, issuesWithFixedEndDateCount: issuesWithFixedEndDateCount, issuesWithSprintStartDateCount: issuesWithSprintStartDateCount, issuesWithSprintEndDateCount: issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount } = (0, $83lyg.countIssueInferredDates)(state.domain.plan, state.domain.issues, state.domain.versions);
                                const fieldColumns = (0, $9H2AP.getFieldColumnsViewSettingsByViewMode)(state).columns.filter((field)=>field.isVisible).map((field)=>field.id);
                                const issuesCount = (0, $cwP4d.getAllIssues)(state).length;
                                const dependenciesCount = (0, $dEoWh.getUniqueLinks)(state).length;
                                const dependencySettings = (0, $9H2AP.getDependencySettings)(state);
                                const dependencySettingsDisplay = dependencySettings ? dependencySettings.display : '';
                                const planCreatedTimestamp = (0, $75KhQ.getCreatedTimestamp)(state) || 0;
                                const planCreatedDate = (0, $l2Sj2.formatDateUTC)(planCreatedTimestamp * 1000, 'YYYY-MM-DD HH:mm:ss');
                                const allTeams = (0, $MQRDu.getAllTeams)(state);
                                const teamsShownInPlan = allTeams.map(({ id: id })=>Number(id));
                                const externalTeams = (0, $MQRDu.getAdditionalTeams)(state);
                                const multiScenarioEnabled = !!(0, $75KhQ.isMultiScenarioEnabled)(state);
                                const scenarios = (0, $75KhQ.getPlanScenarios)(state);
                                const scenariosCount = scenarios?.length || 1;
                                const { selectedFilters: selectedFilters, hierarchyLevels: hierarchyLevels } = (0, $fbHoQ.getFiltersAndHierarchyLevelsForAnalytics)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const customDateRange = (0, $9H2AP.getTimeScaleViewSettings)(state).customDateRange || {};
                                    const zoomLevel = (0, $aMoMC.getZoomLevel)(state);
                                    const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $83lyg.getTimelineAttributes)(customDateRange, zoomLevel);
                                    const views = (0, $dBKyg.getViews)(state);
                                    const viewsInPlanCount = views.length;
                                    const viewsWithDependencyBadgesCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'default').length;
                                    const viewsWithDependencyLinesCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'lines').length;
                                    const viewsWithDependencyCountCount = views.filter((view)=>view.preferences.dependencySettingsV0.display === 'count').length;
                                    const projects = (0, $ehEr2.getProjects)(state);
                                    const projectsByType = $eirae.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                    $l3byl.default([
                                        'projectTypeKey',
                                        'isSimplified'
                                    ]), projects);
                                    // jira software project types count
                                    const sourcesProjectCountJswCmpCount = projectsByType[`${(0, $5rYNM.PROJECT_TYPE_KEY).SOFTWARE},false`]?.length ?? 0;
                                    const sourcesProjectCountJswTmpCount = projectsByType[`${(0, $5rYNM.PROJECT_TYPE_KEY).SOFTWARE},true`]?.length ?? 0;
                                    // jira work management project types count
                                    const sourcesProjectCountJwmCmpCount = projectsByType[`${(0, $5rYNM.PROJECT_TYPE_KEY).WORK_MANAGEMENT},false`]?.length ?? 0;
                                    const sourcesProjectCountJwmTmpCount = projectsByType[`${(0, $5rYNM.PROJECT_TYPE_KEY).WORK_MANAGEMENT},true`]?.length ?? 0;
                                    // jira service management project type count (cmp only)
                                    const sourcesProjectCountJsmCmpCount = projectsByType[`${(0, $5rYNM.PROJECT_TYPE_KEY).SERVICE_MANAGEMENT},false`]?.length ?? 0;
                                    // all project types count
                                    const sourcesProjectCountCmpCount = sourcesProjectCountJswCmpCount + sourcesProjectCountJwmCmpCount + sourcesProjectCountJsmCmpCount;
                                    const sourcesProjectCountTmpCount = sourcesProjectCountJswTmpCount + sourcesProjectCountJwmTmpCount;
                                    const fiscalMonth = (0, $dhHiZ.getFiscalMonth)(state);
                                    const hasSprintsWithInconsistentDates = (0, $c1XMU.getSprintIdsWithDatesIsInconsistent)(state).length > 0;
                                    const hasAtlasPermissions = (0, $dhHiZ.getHasAtlasPermissions)(state);
                                    const isAtlasConnectInstalled = (0, $dhHiZ.isAtlasConnectInstalled)(state);
                                    const tagTableItems = (0, $8Nqhy.getTagTableItems)(state);
                                    const rowHeights = tagTableItems.map((tableItem)=>tableItem.height || 1);
                                    const maxOverlappingSprints = Math.max(...rowHeights, 0);
                                    const viewMode = (0, $9H2AP.getViewMode)(state);
                                    (0, $6Grzy.default).triggerViewRoadmapEventAnalytics(viewRoadmapAction.meta.analyticsEvent, group, colourBy, colours, sortByField, existingTeams.length, teamsScrumCount, teamsKanbanCount, teamsSharedCount, externalTeams.length, sourcesTotalCount, sourcesBoardCount, sourcesProjectCount, sourcesFilterCount, rollupSettings, showSprints, showWarnings, planPermission, instancePermission, planningUnit, sprintActiveCount, sprintFutureCount, sprintFutureSetDatesCount, sprintFutureInferredDatesCount, hasSprintsWithInconsistentDates, hasAtlasPermissions, isAtlasConnectInstalled, timelineType, customTimelineType, fieldColumns, issuesCount, dependenciesCount, dependencySettingsDisplay, issuesWithFixedStartDateCount, issuesWithFixedEndDateCount, issuesWithSprintStartDateCount, issuesWithSprintEndDateCount, issuesWithReleaseStartDateCount, issuesWithReleaseEndDateCount, viewsInPlanCount, viewsWithDependencyBadgesCount, viewsWithDependencyLinesCount, viewsWithDependencyCountCount, planCreatedDate, teamsShownInPlan, projectsShownInPlan, boardsShownInPlan, filtersShownInPlan, sourcesProjectCountJswCmpCount, sourcesProjectCountJswTmpCount, sourcesProjectCountJwmCmpCount, sourcesProjectCountJwmTmpCount, sourcesProjectCountJsmCmpCount, sourcesProjectCountCmpCount, sourcesProjectCountTmpCount, multiScenarioEnabled, scenariosCount, hierarchyLevels, selectedFilters, isSamplePlan, maxOverlappingSprints, autoSchedulerEnabled, fiscalMonth, viewMode, // delete this key when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
                                    zmtCount);
                                }
                                break;
                            }
                        // Triggered when the expand all button is pressed
                        case 0, $83cf706a87a62789$export$20130dbd048fc414:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const expandAllAnalyticsAction = action;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPANDED_ALL_ISSUES.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    // hierarchyLevels is the number of issue hierarchy levels that were expanded
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        hierarchyLevels: expandAllAnalyticsAction.payload.hierarchyLevels
                                    });
                                }
                                break;
                            }
                        // Triggered when the collapse all button is pressed
                        case 0, $83cf706a87a62789$export$39babeb2e7944629:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const collapseAllAnalyticsAction = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                action;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSED_ALL_ISSUES.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    // hierarchyLevels is the number of issue hierarchy levels that were expanded
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        hierarchyLevels: collapseAllAnalyticsAction.payload.hierarchyLevels
                                    });
                                }
                                break;
                            }
                        case 0, $8B14N.UPDATE:
                            if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.add-custom-field-filter-analytics')) {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const filterChangeAction = action;
                                const customFieldId = filterChangeAction.payload.customField.id;
                                const nextFilterValue = filterChangeAction.payload.value;
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                let source = '';
                                if (typeof window !== 'undefined') {
                                    const { hash: hash } = window.location;
                                    source = $451e27197a5a52cd$var$filterSourceMap[hash];
                                }
                                const filterValue = $kjklK.default([
                                    (0, $12ee831723ccf9c2$export$3b798637a628dacc),
                                    `${customFieldId}`
                                ], (0, $fbHoQ.getRawFilters)(state));
                                const addition = $9FeHi.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                nextFilterValue || [], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                filterValue || []);
                                const addedOrRemoved = addition.length > 0 ? 1 : 0;
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const itemCount = nextFilterValue.length;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    scenarioId: scenarioId,
                                    filterID: (0, $12ee831723ccf9c2$export$3b798637a628dacc),
                                    plan: (0, $6Grzy.context).PLAN,
                                    source: source,
                                    addedOrRemoved: addedOrRemoved,
                                    itemCount: itemCount,
                                    customFieldType: filterChangeAction.payload.customField.type.key
                                });
                            }
                            break;
                        case 0, $8B14N.CLEAR:
                            if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.add-custom-field-filter-analytics')) {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    let source = '';
                                    if (typeof window !== 'undefined') {
                                        const { hash: hash } = window.location;
                                        source = $451e27197a5a52cd$var$filterSourceMap[hash];
                                    }
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        filterID: (0, $12ee831723ccf9c2$export$3b798637a628dacc),
                                        plan: (0, $6Grzy.context).PLAN,
                                        source: source,
                                        addedOrRemoved: 0,
                                        itemCount: 0
                                    });
                                }
                            }
                            break;
                        case 0, $eaaIH.CHANGE:
                            {
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                if (action.bypassAnalytics) break;
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const filterChangeAction = action;
                                const filterID = filterChangeAction.payload.id;
                                const currentRawFilters = (0, $fbHoQ.getRawFilters)(state);
                                const currentRawFilter = currentRawFilters[filterID];
                                const filterValue = currentRawFilter && currentRawFilter.value;
                                const nextFilterValue = filterChangeAction.payload.value;
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if (!this.ignoredFilterIds.includes(filterID)) {
                                    let addedOrRemoved = 0;
                                    let itemCount = 0;
                                    let source = '';
                                    if (typeof window !== 'undefined') {
                                        const { hash: hash } = window.location;
                                        source = $451e27197a5a52cd$var$filterSourceMap[hash];
                                    }
                                    if (filterID === (0, $12ee831723ccf9c2$export$e32eeae4866f112c)) {
                                        if (nextFilterValue === '') {
                                            addedOrRemoved = 0;
                                            itemCount = 0;
                                        } else {
                                            addedOrRemoved = 1;
                                            itemCount = 1;
                                        }
                                    } else if (filterID === (0, $12ee831723ccf9c2$export$d6f1616882408daa)) addedOrRemoved = nextFilterValue ? 1 : 0;
                                    else if (filterID === (0, $12ee831723ccf9c2$export$a849f806e27a57e8) && typeof nextFilterValue === 'object' && 'type' in nextFilterValue) addedOrRemoved = filterValue && nextFilterValue.type === 'off' ? 0 : 1;
                                    else {
                                        const addition = $9FeHi.default(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                        nextFilterValue || [], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                        filterValue || []);
                                        addedOrRemoved = addition.length > 0 ? 1 : 0;
                                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                        itemCount = nextFilterValue.length;
                                    }
                                    if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        filterID: filterID,
                                        plan: (0, $6Grzy.context).PLAN,
                                        source: source,
                                        addedOrRemoved: addedOrRemoved,
                                        itemCount: itemCount
                                    });
                                }
                                break;
                            }
                        case 0, $eaaIH.CLEAR_ALL:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLEAR_FILTERS.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    let source = '';
                                    if (typeof window !== 'undefined') {
                                        const { hash: hash } = window.location;
                                        source = $451e27197a5a52cd$var$filterSourceMap[hash];
                                    }
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        plan: (0, $6Grzy.context).PLAN,
                                        source: source
                                    });
                                }
                                break;
                            }
                        case 0, $eaaIH.CLEAR:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const filterChangeAction = action;
                                const filterID = filterChangeAction.payload;
                                if (!this.ignoredFilterIds.includes(filterID) && (0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).UPDATE_FILTER.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    let source = '';
                                    if (typeof window !== 'undefined') {
                                        const { hash: hash } = window.location;
                                        source = $451e27197a5a52cd$var$filterSourceMap[hash];
                                    }
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        filterID: filterID,
                                        plan: (0, $6Grzy.context).PLAN,
                                        source: source,
                                        addedOrRemoved: 0,
                                        itemCount: 0
                                    });
                                }
                                break;
                            }
                        case 0, $h7pZO.ADD_RELEASE:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const addCrossProjectReleaseCommand = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                action;
                                const crossProjectRelease = addCrossProjectReleaseCommand.payload;
                                const projectReleaseCount = crossProjectRelease.versions.length;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $6Grzy.default).triggerCreateCrossProjectReleaseAnalytics(addCrossProjectReleaseCommand.meta.analyticsEvent, {
                                    projectReleaseCount: projectReleaseCount
                                });
                                break;
                            }
                        case 0, $1C7Mn.ADD_SHARED_TEAM:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SHARED_TEAM_ADDED.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                }
                                break;
                            }
                        case 0, $1C7Mn.CREATE_TEAM:
                            {
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).PRIVATE_TEAM_CREATED.split(' ');
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(store.getState());
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                break;
                            }
                        case 0, $1C7Mn.SHARE_TEAM:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).TEAM_IS_SHARED.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                }
                                break;
                            }
                        case 0, $hLlYV.UPDATE_PLAN:
                            {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const updatePlanAction = action;
                                const configuredDates = updatePlanAction.payload.baselineStartField || updatePlanAction.payload.baselineEndField;
                                if (configuredDates) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CONFIGURABLE_DATE_CHANGED.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                    const updatedPlan = {
                                        ...(0, $75KhQ.getPlan)(state),
                                        ...updatePlanAction.payload
                                    };
                                    const isPlanUsingAnyCustomDates = (plan)=>plan.baselineStartField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM || plan.baselineEndField.type === (0, $eOsHk.DATEFIELD_TYPES).CUSTOM;
                                    const isPrevPlanUsingCustomDates = isPlanUsingAnyCustomDates((0, $75KhQ.getPlan)(state));
                                    const isNextPlanUsingCustomDates = isPlanUsingAnyCustomDates(updatedPlan);
                                    if (!isPrevPlanUsingCustomDates && isNextPlanUsingCustomDates) {
                                        // eslint-disable-next-line @typescript-eslint/no-shadow
                                        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CUSTOM_CONFIGURABLE_DATE_USED.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                    } else if (isPrevPlanUsingCustomDates && !isNextPlanUsingCustomDates) {
                                        // eslint-disable-next-line @typescript-eslint/no-shadow
                                        const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).NO_CUSTOM_CONFIGURABLE_DATES_USED.split(' ');
                                        analyticsEvent.update({
                                            action: eventAction,
                                            actionSubject: actionSubject
                                        });
                                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                    }
                                }
                                break;
                            }
                        case 0, $1umd3.UPDATE_PARENT:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const updateParentAction = action;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUE.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    const method = updateParentAction.payload.isDragAndDrop ? {
                                        method: 'dragged'
                                    } : {};
                                    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).REPARENT_ISSUE, method);
                                }
                                break;
                            }
                        case 0, $l4n5f.SET_ACTIVE_VIEW:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const { payload: { id: id } } = action;
                                const activeView = (0, $dBKyg.getViews)(state).find((view)=>view.id === id);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SET_ACTIVE_VIEW.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(activeView)) {
                                    const isPredefinedView = $451e27197a5a52cd$var$isPredefined(activeView);
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        presetName: (0, $83lyg.getPresetName)(activeView),
                                        isDefault: activeView.isDefault ? 1 : 0,
                                        isPredefined: isPredefinedView ? 1 : 0,
                                        isCustom: isPredefinedView ? 0 : 1,
                                        isEdited: activeView.modified ? 1 : 0
                                    });
                                }
                                break;
                            }
                        case 0, $l4n5f.SAVE_VIEW:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const { payload: { id: id } } = action;
                                const view = $i0RGP.default($h3f0m.default('id', id))((0, $dBKyg.getViews)(state));
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SAVE_VIEW.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(view)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    scenarioId: scenarioId,
                                    isDefault: view.isDefault ? 1 : 0,
                                    isCustom: view.isUnchangedPredefinedView ? 0 : 1
                                });
                                break;
                            }
                        case 0, $l4n5f.ADD_VIEW:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ADD_VIEW.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(payload)) {
                                    const isPredefinedView = $451e27197a5a52cd$var$isPredefined(payload);
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        isDefault: payload.isDefault ? 1 : 0,
                                        isCustom: isPredefinedView ? 0 : 1
                                    });
                                }
                                break;
                            }
                        case 0, $l4n5f.RESET:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const activeView = payload.find((view)=>view.active === true);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).RESET_VIEWS.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(activeView)) {
                                    const isPredefinedView = $451e27197a5a52cd$var$isPredefined(activeView);
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        presetName: (0, $83lyg.getPresetName)(activeView),
                                        isDefault: activeView.isDefault ? 1 : 0,
                                        isPredefined: isPredefinedView ? 1 : 0,
                                        isCustom: isPredefinedView ? 0 : 1,
                                        isEdited: activeView.modified ? 1 : 0
                                    });
                                }
                                break;
                            }
                        case 0, $lNYdY.HIDE_COLUMN:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const viewMode = (0, $9H2AP.getViewMode)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { id: id } = action;
                                const isCustomField = !!parseInt(id, 10);
                                let fieldName = id;
                                if (isCustomField) {
                                    const field = $i0RGP.default($h3f0m.default('id', parseInt(id, 10)))(state.domain.customFields);
                                    fieldName = $451e27197a5a52cd$var$typeOfCustomField(field);
                                }
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).HIDE_COLUMN.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    scenarioId: scenarioId,
                                    fieldName: fieldName,
                                    viewMode: viewMode
                                });
                                break;
                            }
                        case 0, $lNYdY.SHOW_COLUMN:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const viewMode = (0, $9H2AP.getViewMode)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { id: id } = action;
                                const isCustomField = !!parseInt(id, 10);
                                let fieldName = id;
                                if (isCustomField) {
                                    const field = $i0RGP.default($h3f0m.default('id', parseInt(id, 10)))(state.domain.customFields);
                                    fieldName = $451e27197a5a52cd$var$typeOfCustomField(field);
                                }
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SHOW_COLUMN.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    scenarioId: scenarioId,
                                    fieldName: fieldName,
                                    viewMode: viewMode
                                });
                                break;
                            }
                        // An analytics event is fired when the default view is changed from the view management page
                        case 0, $l4n5f.MARK_AS_DEFAULT_VIEW:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const { payload: { id: id } } = action;
                                const viewMarkedAsDefault = $i0RGP.default($h3f0m.default('id', id))((0, $dBKyg.getViews)(state));
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).MARK_AS_DEFAULT_VIEW.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(viewMarkedAsDefault)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    scenarioId: scenarioId,
                                    // the following values are defined in JPOS-4198
                                    isDefault: 1,
                                    isPredefined: viewMarkedAsDefault.isUnchangedPredefinedView ? 1 : 0,
                                    isCustom: viewMarkedAsDefault.isUnchangedPredefinedView ? 0 : 1,
                                    isEdited: viewMarkedAsDefault.modified ? 1 : 0
                                });
                                break;
                            }
                        case 0, $hHEgb.CHANGE_OPTION:
                            {
                                const state = store.getState();
                                const { id: planId } = (0, $75KhQ.getPlan)(state);
                                const customDateRange = (0, $9H2AP.getTimeScaleViewSettings)(state).customDateRange || {};
                                const zoomLevel = (0, $aMoMC.getZoomLevel)(state);
                                const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $83lyg.getTimelineAttributes)(customDateRange, zoomLevel);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if ((0, $7CnHa.isDefined)(planId)) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    plan: (0, $6Grzy.context).PLAN,
                                    timelineType: timelineType,
                                    customTimelineType: customTimelineType
                                });
                                break;
                            }
                        case 0, $hHEgb.CHANGE_MODE:
                            {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const { id: planId } = (0, $75KhQ.getPlan)(state);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                if (payload !== (0, $5rYNM.TIMELINE_MODES).CUSTOM) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    plan: (0, $6Grzy.context).PLAN,
                                    timelineType: payload
                                });
                                break;
                            }
                        case 0, $hHEgb.CHANGE_CUSTOM_DATES:
                            {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const { id: planId } = (0, $75KhQ.getPlan)(state);
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SELECT_TIMELINE_RANGE.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                const { timelineType: timelineType, customTimelineType: customTimelineType } = (0, $83lyg.getTimelineAttributes)(payload);
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                    planId: planId,
                                    plan: (0, $6Grzy.context).PLAN,
                                    timelineType: timelineType,
                                    customTimelineType: customTimelineType
                                });
                                break;
                            }
                        case 0, $iX8wj.SEARCH_ICON_CLICK:
                            {
                                const state = store.getState();
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ISSUE_SEARCH_ICON_CLICK.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                break;
                            }
                        case 0, $iX8wj.STARTED_SEARCH_RESULT_NAVIGATION:
                            {
                                const state = store.getState();
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).ISSUE_SEARCH_STARTED_SEARCH_RESULT_NAVIGATION.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
                                break;
                            }
                        case 0, $6itAY.CLICK_EXPORT_TO_CSV_ANALYTICS:
                            {
                                const state = store.getState();
                                const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                const { selectedFilters: selectedFilters, hierarchyLevels: hierarchyLevels } = (0, $fbHoQ.getFiltersAndHierarchyLevelsForAnalytics)(state);
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const clickExportToCsvAction = action;
                                const issueExportCount = clickExportToCsvAction.payload.issueExportCount;
                                if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId) && (0, $7CnHa.isDefined)(issueExportCount)) {
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_EXPORT_TO_CSV.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    // Flow can't make up its mind wrt filters - this will be fixed when we remove the feature flag of View Switching
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        plan: (0, $6Grzy.context).PLAN,
                                        issueExportCount: issueExportCount,
                                        hierarchyLevels: hierarchyLevels,
                                        planMode: (0, $akhOi.getPlanModeForAnalytics)(state),
                                        selectedFilters: selectedFilters
                                    });
                                }
                                break;
                            }
                        case 0, $6itAY.PLAN_EXPORTED_ANALYTICS:
                            {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const planExportedAction = action;
                                const attributes = planExportedAction.payload;
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).PLAN_EXPORTED.split(' ');
                                analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                });
                                const allAttributes = {
                                    planMode: (0, $akhOi.getPlanModeForAnalytics)(state),
                                    ...attributes
                                };
                                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).PLAN_EXPORTED, allAttributes);
                                break;
                            }
                        case 0, $fDCVo.AFTER_SUCCESS:
                            {
                                const state = store.getState();
                                const feStateChangeCount = (0, $eDYLe.getReviewChangesCount)(state);
                                const backendChangeCount = (0, $eDYLe.getReviewChanges)(state).length;
                                const isDialogOpen = state.ui.Top.TitleBar.UpdateJira.isDialogOpen;
                                if (isDialogOpen) {
                                    const { id: planId, currentScenarioId: scenarioId } = (0, $75KhQ.getPlan)(state);
                                    const changeCounts = {
                                        fromFrontendState: {
                                            total: feStateChangeCount,
                                            issuesIncludingLinks: (0, $kwMvv.getIssueChangeCount)(state),
                                            issueLinks: (0, $kwMvv.getIssueChangesWithChangedLinksCount)(state),
                                            versions: (0, $wcCGG.getVersionChangeCount)(state),
                                            crossProjectVersions: (0, $2Ruxt.getCrossProjectVersionChangeCount)(state),
                                            teamsAndResources: (0, $kogU9.getTeamOrResourceChangeCount)(state)
                                        },
                                        fromBackend: {
                                            total: backendChangeCount,
                                            issuesIncludingLinks: (0, $kwMvv.getIssueChanges)(state).length,
                                            issueLinks: (0, $kwMvv.getIssueChangesWithChangedLinks)(state).length,
                                            versions: (0, $wcCGG.getVersionChanges)(state).length,
                                            crossProjectVersions: (0, $2Ruxt.getCrossProjectVersionChanges)(state).length,
                                            teamsAndResources: (0, $kogU9.getTeamAndResourceChanges)(state).length
                                        }
                                    };
                                    const hasMismatch = !$5OdRK.default(changeCounts.fromFrontendState, changeCounts.fromBackend);
                                    const synthetic = (0, $8bnQD.default)();
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [actionSubject, eventAction] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_LOADED_CHANGES.split(' ');
                                    analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    });
                                    if ((0, $7CnHa.isDefined)(planId) && (0, $7CnHa.isDefined)(scenarioId)) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COMMIT_MODAL_LOADED_CHANGES, {
                                        planId: planId,
                                        scenarioId: scenarioId,
                                        changeCounts: changeCounts,
                                        hasMismatch: hasMismatch,
                                        synthetic: synthetic
                                    });
                                }
                                break;
                            }
                        case 0, $9G8kJ.TOGGLE_TOOLBAR:
                            {
                                const state = store.getState();
                                const grouping = (0, $kyGCj.getVisualisationGrouping)(state);
                                const mode = (0, $akhOi.getMode)(state);
                                const showToolBar = (0, $beuE2.getToolBarVisibilityState)(state);
                                const filteredIssues = (0, $kwMvv.getFilteredIssues)(state).length;
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                // eslint-disable-next-line @typescript-eslint/no-shadow
                                const [actionSubject, action] = (showToolBar ? (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_TOOL_BAR : (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_TOOL_BAR).split(' ');
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                                    action: action,
                                    actionSubject: actionSubject
                                }), {
                                    browserInnerWidth: window.innerWidth,
                                    browserInnerHeight: window.innerHeight,
                                    browserOuterWidth: window.outerWidth,
                                    browserOuterHeight: window.outerHeight,
                                    browserZoomPercentage: window.outerWidth / window.innerWidth * 100,
                                    filteredIssues: filteredIssues,
                                    grouping: grouping,
                                    isFullScreen: window.screen.availWidth === window.screen.width && window.screen.availHeight === window.screen.height,
                                    mode: mode,
                                    screenWidth: window.screen.width,
                                    screenHeight: window.screen.height
                                });
                                break;
                            }
                        case 0, $c7fhc.SET_IS_EXPANDED:
                            {
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const keys = Object.keys(payload);
                                /**
						 * We are checking the length === 1 because we are using the same action
						 * to expand and collpase ALL. The expand/collapse ALL ananlytics is captured
						 * by EXPAND[COLLPASE]_ALL_ANALYTICS_ACTION above.
						 *
						 * Here we are just taking care of single item expand and collapse.
						 */ if (keys.length === 1) {
                                    const state = store.getState();
                                    const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                    const [item] = keys[0].split(':');
                                    const expand = payload[keys[0]];
                                    const [actionSubject, eventAction] = (expand ? (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_SCOPE_ITEM : (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_SCOPE_ITEM).split(' ');
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                                        action: eventAction,
                                        actionSubject: actionSubject
                                    }), {
                                        item: item
                                    });
                                }
                                break;
                            }
                        case 0, $l1dWb.TOGGLE_EXPAND_GROUP:
                            {
                                const state = store.getState();
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                                const { payload: payload } = action;
                                const { grouping: grouping, expand: expand } = payload;
                                const analyticsEvent = (0, $akhOi.getAnalyticsEvent)(state);
                                const [actionSubject, eventAction] = (expand ? (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPAND_SCOPE_GROUP : (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).COLLAPSE_SCOPE_GROUP).split(' ');
                                (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                                    action: eventAction,
                                    actionSubject: actionSubject
                                }), {
                                    grouping: grouping
                                });
                                break;
                            }
                        default:
                            break;
                    }
                    return next(action);
                });
        this.ignoredFilterIds = [
            (0, $12ee831723ccf9c2$export$a8ec3260a009d752),
            (0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d),
            (0, $12ee831723ccf9c2$export$3b798637a628dacc)
        ];
    }
}
const $451e27197a5a52cd$var$middleware = new $451e27197a5a52cd$var$AnalyticsMiddleware();
var $451e27197a5a52cd$export$2e2bcd8739ae039 = $451e27197a5a52cd$var$middleware.apply;

});
parcelRegister("juY6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $90dd937df9111fa8$export$2e2bcd8739ae039);

var $iTOTo = parcelRequire("iTOTo");
class $90dd937df9111fa8$export$2e2bcd8739ae039 {
    constructor(){
        this.timer = {
            startTime: undefined,
            endTime: undefined
        };
    }
    start() {
        if (this.isStopped()) throw new Error('Timer has already been stopped');
        if (this.isStarted()) throw new Error('Timer has already been started');
        this.timer.startTime = (0, $iTOTo.default).now();
    }
    stop() {
        if (!this.isStarted()) throw new Error("Timer hasn't been started");
        if (this.isStopped()) throw new Error('Timer has already been stopped');
        this.timer.endTime = (0, $iTOTo.default).now();
    }
    duration() {
        // Checking properties directly here so that Flow can refine on the final calculation.
        if (this.timer.startTime === undefined) throw new Error("Timer hasn't been started");
        if (this.timer.endTime === undefined) throw new Error("Timer hasn't been stopped");
        return this.timer.endTime - this.timer.startTime;
    }
    isStarted() {
        return this.timer.startTime !== undefined;
    }
    isStopped() {
        return this.timer.endTime !== undefined;
    }
}

});
parcelRegister("iTOTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8dadf45b9dc50e2$export$2e2bcd8739ae039);

var $2IatN = parcelRequire("2IatN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8dadf45b9dc50e2$export$2e2bcd8739ae039 = {
    /**
	 * Computes the duration of the current page load. This uses the Navigation Timing API, and starts recording
	 * when the browser starts making the request, not from when JavaScript actually starts executing. The event
	 * is completed when the window fires the `load` event (e.g. DCL has fired, and all images and frames are also
	 * complete).
	 *
	 * @returns The total load time in milliseconds, or undefined if the page is still loading (i.e. the load event
	 * has not yet fired).
	 */ lastFullPageLoad () {
        const timing = (0, $2IatN.default).timing;
        const isCurrentPageLoadComplete = timing.loadEventEnd > 0;
        return isCurrentPageLoadComplete ? timing.loadEventEnd - timing.navigationStart : undefined;
    },
    /**
	 * @returns The elapsed time in milliseconds between when the page started loading (timing.navigationStart), and
	 * the current point in time.
	 */ now () {
        return (0, $2IatN.default).now();
    }
};

});
parcelRegister("2IatN", function(module, exports) {

$parcel$export(module.exports, "default", () => $49bf6b80fe5c480c$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-properties
const $49bf6b80fe5c480c$var$performance = window.performance;
var $49bf6b80fe5c480c$export$2e2bcd8739ae039 = $49bf6b80fe5c480c$var$performance;

});



parcelRegister("eA35d", function(module, exports) {

$parcel$export(module.exports, "getFieldColumnsViewSettingsByViewMode", () => (parcelRequire("9H2AP")).getFieldColumnsViewSettingsByViewMode);

var $9H2AP = parcelRequire("9H2AP");

});

parcelRegister("beuE2", function(module, exports) {

$parcel$export(module.exports, "getToolBarVisibilityState", () => $8e954668adccd60e$export$d758e0d1efb191df);
const $8e954668adccd60e$export$d758e0d1efb191df = (state)=>state.ui.Top.TitleBar.ToolBar.showToolBar;

});

parcelRegister("9G8kJ", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_TOOLBAR", () => $6260dc04ab0d50ed$export$ccc9db851a286742);
$parcel$export(module.exports, "toggleToolBar", () => $6260dc04ab0d50ed$export$5ffe462ecc322803);
const $6260dc04ab0d50ed$export$ccc9db851a286742 = 'state.ui.top.title-bar.tool-bar.TOGGLE_TOOLBAR';
const $6260dc04ab0d50ed$export$5ffe462ecc322803 = ()=>({
        type: $6260dc04ab0d50ed$export$ccc9db851a286742
    });

});

parcelRegister("83lyg", function(module, exports) {

$parcel$export(module.exports, "countFutureSprintDates", () => $735337fac5660aef$export$9bd2edfcf92cf271);
$parcel$export(module.exports, "countIssueInferredDates", () => $735337fac5660aef$export$2e9dafbfe356d9ad);
$parcel$export(module.exports, "getColoursUsedInPlan", () => $735337fac5660aef$export$6076dd623bc4deb);
$parcel$export(module.exports, "getIssueAnalyticAttributes", () => $735337fac5660aef$export$b6a1c462ad352e48);
$parcel$export(module.exports, "getIssueAnalyticAttributesNew", () => $735337fac5660aef$export$e634d793fd575323);
$parcel$export(module.exports, "getTimelineAttributes", () => $735337fac5660aef$export$936ca6b7e73b7cfb);
$parcel$export(module.exports, "logAnalyticsError", () => $735337fac5660aef$export$736397007665a3b6);
$parcel$export(module.exports, "getPresetName", () => $735337fac5660aef$export$70447d77c8eef9d);

var $hkOxK = parcelRequire("hkOxK");
var $1dZWS = parcelRequire("1dZWS");
var $b3iuB = parcelRequire("b3iuB");
var $01zCq = parcelRequire("01zCq");
var $UCNmJ = parcelRequire("UCNmJ");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("75KhQ");
var $eOsHk = parcelRequire("eOsHk");

var $eOsHk = parcelRequire("eOsHk");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $kInjb = parcelRequire("kInjb");

var $6DE5z = parcelRequire("6DE5z");
const $735337fac5660aef$export$9bd2edfcf92cf271 = $hkOxK.default((result)=>{
    const { sprintFutureSetDates: sprintFutureSetDates = 0, sprintFutureInferredDates: sprintFutureInferredDates = 0 } = result;
    return $01zCq.default({
        closed: 0,
        active: 0,
        future: sprintFutureSetDates + sprintFutureInferredDates,
        sprintFutureSetDates: sprintFutureSetDates,
        sprintFutureInferredDates: sprintFutureInferredDates
    })(result);
}, $1dZWS.default((sprint)=>{
    if (sprint.state === (0, $5rYNM.SPRINT_STATES).FUTURE) return sprint.planned ? 'sprintFutureSetDates' : 'sprintFutureInferredDates';
    return String(sprint.state).toLowerCase();
}));
// Assumption: issueReleases will always contain 1 element
const $735337fac5660aef$var$inferringReleaseStart = (allReleases, issueReleases)=>{
    if (issueReleases.length === 0) return false;
    const releaseToCheck = allReleases.find((release)=>release.id === issueReleases[0]);
    return releaseToCheck?.start != null;
};
const $735337fac5660aef$var$inferringReleaseEnd = (allReleases, issueReleases)=>{
    if (issueReleases.length === 0) return false;
    const releaseToCheck = allReleases.find((release)=>release.id === issueReleases[0]);
    return releaseToCheck?.end != null;
};
const $735337fac5660aef$export$2e9dafbfe356d9ad = (plan, issues, releases)=>{
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField, issueInferredDateSelection: issueInferredDateSelection } = plan;
    let startInferred = 0;
    let endInferred = 0;
    let issuesWithFixedStartDateCount = 0;
    let issuesWithFixedEndDateCount = 0;
    let issuesWithSprintStartDateCount = 0;
    let issuesWithSprintEndDateCount = 0;
    let issuesWithReleaseStartDateCount = 0;
    let issuesWithReleaseEndDateCount = 0;
    issues.forEach((issue)=>{
        let startDate;
        let endDate;
        if (baselineStartField.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        startDate = issue[baselineStartField.key];
        else {
            // issue start date is a custom field
            const customFields = issue.customFields;
            // baselineStartField.key will be the id of the custom field
            startDate = customFields ? customFields[baselineStartField.key] : null;
        }
        if (baselineEndField.type === (0, $eOsHk.DATEFIELD_TYPES).BUILT_IN) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        endDate = issue[baselineEndField.key];
        else {
            // issue end date is a custom field
            const customFields = issue.customFields;
            // baselineEndField.key will be the id of the custom field
            endDate = customFields ? customFields[baselineEndField.key] : null;
        }
        // if both start and end are null, then we can assume we *may* be inferring from sprint or release
        // or we could not find the custom fields which they are using to indicate start or end date
        if (startDate == null && endDate == null) {
            // check if inferring from sprints and issue is assigned to a sprint
            if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT && issue.sprint != null) {
                startInferred += 1;
                endInferred += 1;
            } else if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE) // check if inferring from release
            {
                if (issue.fixVersions && issue.fixVersions.length !== 0) {
                    // issue is associated with a release
                    if ($735337fac5660aef$var$inferringReleaseStart(releases, issue.fixVersions)) startInferred += 1;
                    // Have to be explicit for flow
                    if (issue.fixVersions != null && $735337fac5660aef$var$inferringReleaseEnd(releases, issue.fixVersions)) endInferred += 1;
                }
            }
        }
        // issue has a start date
        if (startDate != null) issuesWithFixedStartDateCount += 1;
        // issue has an end date
        if (endDate != null) issuesWithFixedEndDateCount += 1;
    });
    // assign inferredStart and inferredEnd to appropriate attribute
    if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT) {
        issuesWithSprintStartDateCount = startInferred;
        issuesWithSprintEndDateCount = endInferred;
    } else if (issueInferredDateSelection === (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).RELEASE) {
        issuesWithReleaseStartDateCount = startInferred;
        issuesWithReleaseEndDateCount = endInferred;
    }
    return {
        issuesWithFixedStartDateCount: issuesWithFixedStartDateCount,
        issuesWithFixedEndDateCount: issuesWithFixedEndDateCount,
        issuesWithSprintStartDateCount: issuesWithSprintStartDateCount,
        issuesWithSprintEndDateCount: issuesWithSprintEndDateCount,
        issuesWithReleaseStartDateCount: issuesWithReleaseStartDateCount,
        issuesWithReleaseEndDateCount: issuesWithReleaseEndDateCount
    };
};
const $735337fac5660aef$export$76c52757c67889ee = (colourByViewSettings, colourByOption)=>{
    const colours = $UCNmJ.default(colourByViewSettings.colourMaps[colourByOption]).map((colour)=>{
        const colourMessage = (0, $33N5G.colourPickerPaletteLabels)[colour];
        if (colourMessage === undefined || colourMessage.defaultMessage === undefined) return colour;
        return colourMessage.defaultMessage;
    });
    if ($b3iuB.default(colours)) // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'ColoursUsed': averageOptionsPerColour, colours, count
    return {};
    return {
        averageOptionsPerColour: 1,
        colours: colours,
        count: colours.length
    };
};
const $735337fac5660aef$var$getAverageOptionsPerColour = (colours)=>colours.reduce((acc, { colour: colour, ...rest })=>acc + Object.values(rest)[0].length, 0) / colours.length;
const $735337fac5660aef$var$getColourNames = (colours)=>colours.reduce((acc, { colour: colour })=>{
        if ((0, $7CnHa.isDefined)(colour)) acc.push((0, $33N5G.colourPickerPaletteLabels)[colour]?.defaultMessage || colour);
        return acc;
    }, []);
const $735337fac5660aef$export$dd20b0398a9cbc92 = (colourByViewSettings, colourViewSettings)=>{
    const colours = colourByViewSettings[colourViewSettings];
    if (!(0, $7CnHa.isDefined)(colours) || $b3iuB.default(colours)) // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'ColoursUsed': averageOptionsPerColour, colours, count
    return {};
    return {
        averageOptionsPerColour: $735337fac5660aef$var$getAverageOptionsPerColour(colours),
        colours: $735337fac5660aef$var$getColourNames(colours),
        count: colours.length
    };
};
const $735337fac5660aef$export$6076dd623bc4deb = (colourByViewSettings)=>({
        [(0, $33N5G.colourByOptions).COMPONENT]: $735337fac5660aef$export$dd20b0398a9cbc92(colourByViewSettings, 'colourComponents'),
        [(0, $33N5G.colourByOptions).ISSUE_TYPE]: $735337fac5660aef$export$dd20b0398a9cbc92(colourByViewSettings, 'colourIssueTypes'),
        [(0, $33N5G.colourByOptions).LABEL]: $735337fac5660aef$export$dd20b0398a9cbc92(colourByViewSettings, 'colourLabels'),
        [(0, $33N5G.colourByOptions).PRIORITY]: $735337fac5660aef$export$dd20b0398a9cbc92(colourByViewSettings, 'colourPriorities'),
        [(0, $33N5G.colourByOptions).PROJECT]: $735337fac5660aef$export$76c52757c67889ee(colourByViewSettings, (0, $33N5G.colourByOptions).PROJECT),
        [(0, $33N5G.colourByOptions).STATUS]: $735337fac5660aef$export$76c52757c67889ee(colourByViewSettings, (0, $33N5G.colourByOptions).STATUS),
        [(0, $33N5G.colourByOptions).TEAM]: $735337fac5660aef$export$76c52757c67889ee(colourByViewSettings, (0, $33N5G.colourByOptions).TEAM)
    });
const $735337fac5660aef$export$b6a1c462ad352e48 = (issue, issueTypesById, additionalAttributes = {})=>{
    const issueAttributes = {
        ...(0, $7CnHa.isDefined)(issue.id) && {
            issueId: issue.id
        },
        issueTypeId: issue.type,
        issueType: issueTypesById[issue.type]?.name,
        hierarchyLevel: issue.level
    };
    return Object.assign(additionalAttributes, issueAttributes);
};
const $735337fac5660aef$export$e634d793fd575323 = (issue, issueTypesById, projectsById, additionalAttributes = {})=>{
    const issueAttributes = {
        ...(0, $7CnHa.isDefined)(issue.id) && {
            issueId: issue.id
        },
        issueTypeId: issue.type,
        issueType: issueTypesById[issue.type]?.name,
        hierarchyLevel: issue.level,
        isSimplified: projectsById[issue.project]?.isSimplified
    };
    return Object.assign(additionalAttributes, issueAttributes);
};
const $735337fac5660aef$export$936ca6b7e73b7cfb = (customDateRange, zoomLevel)=>{
    let timelineType; // "weeks", "months", "quarters", "years", or "custom"
    let customTimelineType = ''; // "fixed" or "relative"
    switch(zoomLevel){
        case (0, $5rYNM.ZOOM_LEVELS).WEEKS:
        case (0, $5rYNM.ZOOM_LEVELS).MONTHS:
        case (0, $5rYNM.ZOOM_LEVELS).QUARTERS:
        case (0, $5rYNM.ZOOM_LEVELS).YEARS:
            timelineType = zoomLevel;
            break;
        // if zoomLevel is undefined, the plan has a "custom" date range
        default:
            timelineType = (0, $5rYNM.TIMELINE_MODES).CUSTOM;
            if (!$b3iuB.default(customDateRange)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            customTimelineType = customDateRange.typeOfCustomDateRange;
            break;
    }
    return {
        customTimelineType: customTimelineType,
        timelineType: timelineType
    };
};
const $735337fac5660aef$export$736397007665a3b6 = (error, message)=>{
    (0, $guiFP.default)({
        meta: {
            packageName: (0, $5rYNM.PACKAGE_NAME),
            id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).ROADMAP,
            teamName: (0, $5rYNM.ERROR_REPORTING_TEAM)
        },
        attributes: {
            message: message
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $735337fac5660aef$export$70447d77c8eef9d = (view)=>{
    if ((0, $1ybV0.ff)('com.atlassian.jpo.rm.update-preset-names')) {
        const presets = (0, $kInjb.getPresetViewNames)();
        const viewName = (0, $kInjb.getMigratedPresetViewName)(view);
        const presetNames = [
            ...Object.values(presets),
            'Untitled'
        ];
        if (presetNames.indexOf(viewName) >= 0) return viewName;
        return 'Custom';
    }
    const { name: name } = view;
    const presetNames = [
        ...Object.values((0, $6DE5z.PRESET_VIEWS_NAMES_V1)),
        'Untitled'
    ];
    if (presetNames.indexOf(name) >= 0) return name;
    return 'Custom';
};

});


parcelRegister("2ZJWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48a39b5340530f7$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $9Nhwa = parcelRequire("9Nhwa");

var $bXDzc = parcelRequire("bXDzc");

var $7vjBd = parcelRequire("7vjBd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c48a39b5340530f7$var$appReducer = (0, $l1eW8.combineReducers)({
    domain: $bXDzc.default,
    ui: $7vjBd.default
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c48a39b5340530f7$var$rootReducer = (state, action)=>{
    if (action.type === (0, $9Nhwa.RESTORE_REDUX_STORE)) /**
		 * When switching between different pages within the same plan,
		 * the state needs to be rehydrated from the cache to prevent
		 * unnecessary API calls to initial load the same plan again.
		 */ return $c48a39b5340530f7$var$appReducer(action.payload, action);
    if (action.type === (0, $9Nhwa.RESET_REDUX_STORE)) /**
		 * In order to reset the redux store to the initial state, we are passing "undefined"
		 * value as state for the root reducer. This value will then be passed to all the child
		 * reducers. As this value is "undefined", all the child reducers will return their default
		 * state. Assumption is all the child reducers are using default initial state.
		 */ return $c48a39b5340530f7$var$appReducer(undefined, action);
    return $c48a39b5340530f7$var$appReducer(state, action);
};
var $c48a39b5340530f7$export$2e2bcd8739ae039 = $c48a39b5340530f7$var$rootReducer;

});
parcelRegister("bXDzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc2a1a2b766508ed$export$2e2bcd8739ae039);

var $3by2Y = parcelRequire("3by2Y");
var $kjklK = parcelRequire("kjklK");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $dYnI4 = parcelRequire("dYnI4");

var $akhOi = parcelRequire("akhOi");

var $lwKA5 = parcelRequire("lwKA5");


var $l1eW8 = parcelRequire("l1eW8");

var $fr1nu = parcelRequire("fr1nu");

var $8pnAg = parcelRequire("8pnAg");

var $h0gC4 = parcelRequire("h0gC4");

var $DywVp = parcelRequire("DywVp");

var $baFys = parcelRequire("baFys");

var $2LFLH = parcelRequire("2LFLH");

var $991dc = parcelRequire("991dc");

var $bfLCp = parcelRequire("bfLCp");

var $gVN0z = parcelRequire("gVN0z");

var $dsxgv = parcelRequire("dsxgv");

var $9nIz3 = parcelRequire("9nIz3");

var $alW3F = parcelRequire("alW3F");

var $5t2Pe = parcelRequire("5t2Pe");

var $9ozqH = parcelRequire("9ozqH");

var $JysvY = parcelRequire("JysvY");


var $kz0vM = parcelRequire("kz0vM");

var $iTAsW = parcelRequire("iTAsW");

var $g686T = parcelRequire("g686T");

var $cQxJy = parcelRequire("cQxJy");

var $lICLK = parcelRequire("lICLK");

var $dA5gW = parcelRequire("dA5gW");

var $lhX0J = parcelRequire("lhX0J");

var $iqsN6 = parcelRequire("iqsN6");

var $872dx = parcelRequire("872dx");

var $5eaGD = parcelRequire("5eaGD");

var $amamE = parcelRequire("amamE");

var $Nfcm7 = parcelRequire("Nfcm7");

var $gtbR1 = parcelRequire("gtbR1");

var $a0OS1 = parcelRequire("a0OS1");

var $6tiLT = parcelRequire("6tiLT");

var $6Sie5 = parcelRequire("6Sie5");

var $jJCIe = parcelRequire("jJCIe");

var $2utnB = parcelRequire("2utnB");

var $ew2cF = parcelRequire("ew2cF");

var $kt7Vd = parcelRequire("kt7Vd");

var $az483 = parcelRequire("az483");

var $kIUsy = parcelRequire("kIUsy");

var $fUzZw = parcelRequire("fUzZw");

var $gExeY = parcelRequire("gExeY");

var $2MGzR = parcelRequire("2MGzR");

var $lCL3I = parcelRequire("lCL3I");

var $4dybm = parcelRequire("4dybm");

var $j8W5F = parcelRequire("j8W5F");

var $d4YZJ = parcelRequire("d4YZJ");

var $cVpED = parcelRequire("cVpED");

var $1pBkD = parcelRequire("1pBkD");

var $gFJ9p = parcelRequire("gFJ9p");

var $1LA8L = parcelRequire("1LA8L");

var $9pelO = parcelRequire("9pelO");

var $gCwkO = parcelRequire("gCwkO");

var $uh7SP = parcelRequire("uh7SP");

var $6qsGU = parcelRequire("6qsGU");

var $dhLbt = parcelRequire("dhLbt");

var $dr8sv = parcelRequire("dr8sv");

var $1npMo = parcelRequire("1npMo");

var $gwmQW = parcelRequire("gwmQW");

var $kIlJL = parcelRequire("kIlJL");

var $boQGP = parcelRequire("boQGP");

var $j3r1q = parcelRequire("j3r1q");

var $bEaE7 = parcelRequire("bEaE7");

var $L8rDX = parcelRequire("L8rDX");

var $cYoMq = parcelRequire("cYoMq");

var $5YqZc = parcelRequire("5YqZc");

var $iWPoR = parcelRequire("iWPoR");

var $9ZuLc = parcelRequire("9ZuLc");

var $kZlLv = parcelRequire("kZlLv");

var $3n1fO = parcelRequire("3n1fO");

var $xlOmi = parcelRequire("xlOmi");

var $bnuD7 = parcelRequire("bnuD7");

var $k94CF = parcelRequire("k94CF");

var $3AY4C = parcelRequire("3AY4C");

var $lOdND = parcelRequire("lOdND");

var $ahKLe = parcelRequire("ahKLe");

var $5DgX0 = parcelRequire("5DgX0");

var $8FmvP = parcelRequire("8FmvP");

var $6Oj3G = parcelRequire("6Oj3G");

var $7VeEM = parcelRequire("7VeEM");

var $lHE4S = parcelRequire("lHE4S");

var $fye2y = parcelRequire("fye2y");

var $jpD1u = parcelRequire("jpD1u");

var $8RAUa = parcelRequire("8RAUa");

var $a7lvN = parcelRequire("a7lvN");

var $xlkYE = parcelRequire("xlkYE");

var $12x9g = parcelRequire("12x9g");

var $56IuN = parcelRequire("56IuN");

var $eaaIH = parcelRequire("eaaIH");

var $dg7Hh = parcelRequire("dg7Hh");

var $1e5GW = parcelRequire("1e5GW");

var $e5wZF = parcelRequire("e5wZF");
// Get issue limit flag actions to be applied
const $fc2a1a2b766508ed$var$getIssueLimitFlagActions = (appMode, numIssues, limits, more, // eslint-disable-next-line @typescript-eslint/no-shadow
hiddenFlags)=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const flags = [];
    if (!(0, $akhOi.isReadOnlyPure)(appMode)) {
        if ((numIssues > limits.absoluteIssueLimit || more) && !(0, $8RAUa.isFlagHidden)((0, $42b69a8aa6898c13$export$42d68c08a5ace658), hiddenFlags)) flags.push((0, $9ozqH.pushFlag)({
            key: (0, $42b69a8aa6898c13$export$42d68c08a5ace658)
        }));
        else if (numIssues <= limits.absoluteIssueLimit) flags.push((0, $9ozqH.removeFlag)({
            key: (0, $42b69a8aa6898c13$export$42d68c08a5ace658)
        }));
    }
    return flags;
};
// Get view settings actions depending on issue list being set
const $fc2a1a2b766508ed$var$getViewSettingsActions = (// eslint-disable-next-line @typescript-eslint/no-shadow
issues, filters)=>{
    const dependenciesFilterValue = filters[0, $12ee831723ccf9c2$export$a849f806e27a57e8]?.value;
    // Remove filter if we are filtering for a specific issue that is not in the list
    const removeFilter = dependenciesFilterValue && dependenciesFilterValue.type === 'specificIssue' && !issues.some(({ id: id })=>id === dependenciesFilterValue.issueId);
    return removeFilter ? [
        $eaaIH.change({
            id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
            value: {
                type: 'off'
            }
        })
    ] : [];
};
// Transform backlog issues into data that will be put into state
const $fc2a1a2b766508ed$var$getIssueData = (state, // eslint-disable-next-line @typescript-eslint/no-shadow
issues, // eslint-disable-next-line @typescript-eslint/no-shadow
scenarioRemovedIssues)=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { originalIssues: originalIssues, hierarchy: hierarchy, issueTypes: issueTypes, projects: projects } = state;
    const { baselineStartField: baselineStartField, baselineEndField: baselineEndField } = state.plan;
    const dateConfiguration = {
        baselineStartField: baselineStartField,
        baselineEndField: baselineEndField
    };
    const releasesDisabledProject = projects.reduce((acc, { isReleasesEnabled: isReleasesEnabled, id: id })=>{
        if (!isReleasesEnabled) acc.push(id);
        return acc;
    }, []);
    const stateIssues = (0, $8RAUa.prepareIssues)(issues, {
        levels: hierarchy.levels,
        issueTypes: issueTypes,
        dateConfiguration: dateConfiguration,
        releasesDisabledProject: releasesDisabledProject
    });
    const stateScenarioRemovedIssues = (0, $8RAUa.prepareIssues)(scenarioRemovedIssues, {
        levels: hierarchy.levels,
        issueTypes: issueTypes,
        dateConfiguration: dateConfiguration,
        releasesDisabledProject: releasesDisabledProject
    });
    const stateOriginalIssues = (0, $8RAUa.prepareOriginalIssues)(issues, dateConfiguration, scenarioRemovedIssues);
    const stateIssueGoals = (0, $8RAUa.prepareIssueGoals)(stateIssues, stateOriginalIssues);
    const stateIssueLabels = (0, $8RAUa.prepareIssueLabels)(stateIssues, originalIssues);
    const stateIssueLinks = (0, $8RAUa.prepareIssueLinks)(issues, state.system.dependencySettingsInfo);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const customLabelsByField = (0, $8RAUa.prepareCustomLabels)(stateIssues, originalIssues, state.customFields);
    return {
        issues: stateIssues,
        scenarioRemovedIssues: stateScenarioRemovedIssues,
        originalIssues: stateOriginalIssues,
        issueLabels: stateIssueLabels,
        issueLinks: stateIssueLinks,
        customLabelsByField: customLabelsByField,
        goalARIs: stateIssueGoals
    };
};
const $fc2a1a2b766508ed$var$resetBacklog = (state, payload, extractIssueFn)=>{
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { app: app, hiddenFlags: hiddenFlags, issueTypes: issueTypes, projects: projects } = state;
    const calculationResult = payload.calculationResult;
    const issuesToProcess = extractIssueFn(payload);
    const stateIssueData = $fc2a1a2b766508ed$var$getIssueData(state, issuesToProcess, payload.scenarioRemovedIssues);
    const flagActions = $fc2a1a2b766508ed$var$getIssueLimitFlagActions(app.mode, stateIssueData.issues.length, state.system.loadingLimitsInfo, payload.more, hiddenFlags);
    const viewSettingsActions = $fc2a1a2b766508ed$var$getViewSettingsActions(stateIssueData.issues, state.viewSettings.filtersV0);
    return {
        viewSettings: viewSettingsActions,
        flags: flagActions,
        issueTypes: [
            (0, $2utnB.reset)(issueTypes)
        ],
        projects: [
            (0, $boQGP.reset)(projects)
        ],
        issues: [
            (0, $kt7Vd.reset)(stateIssueData.issues)
        ],
        issueLabels: [
            (0, $lhX0J.reset)(stateIssueData.issueLabels)
        ],
        customLabelsByField: [
            (0, $bfLCp.resetAll)(stateIssueData.customLabelsByField)
        ],
        issueLinks: [
            (0, $872dx.reset)(stateIssueData.issueLinks)
        ],
        lexorank: [
            $kIUsy.resetAdjustments([])
        ],
        scenarioRemovedIssues: [
            (0, $9ZuLc.reset)(stateIssueData.scenarioRemovedIssues)
        ],
        solution: calculationResult && !calculationResult.error ? [
            (0, $k94CF.reset)((0, $8RAUa.prepareSolution)(calculationResult))
        ] : [],
        originalIssues: [
            (0, $lwKA5.reset)(stateIssueData.originalIssues)
        ],
        goalARIs: [
            (0, $lICLK.reset)(stateIssueData.goalARIs)
        ]
    };
};
const $fc2a1a2b766508ed$var$composite = (state, action)=>{
    switch(action.type){
        case 0, $fr1nu.SET_PLAN_INFO:
            {
                const { planInfo: planInfo, planInfo: { crossProjectVersions: // eslint-disable-next-line @typescript-eslint/no-shadow
                crossProjectVersions, customFields: // eslint-disable-next-line @typescript-eslint/no-shadow
                customFields, issueStatuses: // eslint-disable-next-line @typescript-eslint/no-shadow
                issueStatuses, issuePriorityInformation: issuePriorityInformation, issueTypes: // eslint-disable-next-line @typescript-eslint/no-shadow
                issueTypes, projects: // eslint-disable-next-line @typescript-eslint/no-shadow
                projects, sequence: // eslint-disable-next-line @typescript-eslint/no-shadow
                sequence, sprints: // eslint-disable-next-line @typescript-eslint/no-shadow
                sprints, teams: // eslint-disable-next-line @typescript-eslint/no-shadow
                teams, plannedCapacities: // eslint-disable-next-line @typescript-eslint/no-shadow
                plannedCapacities, persons: // eslint-disable-next-line @typescript-eslint/no-shadow
                persons, releaseStatuses: // eslint-disable-next-line @typescript-eslint/no-shadow
                releaseStatuses }, hierarchyInfo: hierarchyInfo, // eslint-disable-next-line @typescript-eslint/no-shadow
                issueStatusCategoryInfo: { issueStatusCategories: issueStatusCategories } } = action.payload;
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $dYnI4.monitor).startTask((0, $fr1nu.SET_PLAN_INFO), {
                    scalingFactors: {
                        sprints: sprints.length
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const versions = (0, $8RAUa.prepareVersions)(projects, crossProjectVersions, {
                    isPreparingRemovedVersions: false
                });
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const removedVersions = (0, $8RAUa.prepareVersions)(projects, crossProjectVersions, {
                    isPreparingRemovedVersions: true
                });
                const allReleaseStatuses = (0, $8RAUa.prepareReleaseStatuses)(releaseStatuses);
                const existingCrossProjectVersions = (0, $8RAUa.prepareCrossProjectVersions)(crossProjectVersions, versions, {
                    isPreparingDeletedCrossProjectVersions: false
                });
                const deletedCrossProjectVersions = (0, $8RAUa.prepareCrossProjectVersions)(crossProjectVersions, versions, {
                    isPreparingDeletedCrossProjectVersions: true
                });
                const preparedPlannedCapacities = (0, $8RAUa.prepareWRMPlannedCapacities)(plannedCapacities);
                const preparedOriginalPlannedCapacities = (0, $8RAUa.prepareWRMOriginalPlannedCapacities)(plannedCapacities);
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const [preparedSprints, disabledSprints] = $3by2Y.default((x)=>x.isDisabled !== true)((0, $8RAUa.prepareSprints)(sprints, planInfo));
                /**
			 * The backend now provides the Jira hierarchy level for each hierarchy used in Plans:
			 * [{ title: 'Sub-Task', issueTypes: [10004, 10002], level: -1 }, { title: 'Story', issueTypes: [10003], level: 0 }, ...]
			 *
			 * Therefore we will use the hierarchy levels provided by the backend when the feature flag is enabled, as opposed to
			 * calculating them based on the hierarchy levels array.
			 */ const preparedHierarchyInfo = {
                    levels: !(0, $1ybV0.ff)('use-jira-hierarchy-levels-in-plans_knftc') ? hierarchyInfo.levels.map((hierarchyLevel, index)=>({
                            ...hierarchyLevel,
                            level: index
                        })) : hierarchyInfo.levels
                };
                if ((0, $1ybV0.ff)('com.atlassian.jpo.issue-priority-error-logs')) projects.forEach((project)=>{
                    if (issuePriorityInformation.projectToPrioritySchemeAssociations[project.id] == null) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.set-plan-info.error', 'Project id not found in issue priority information, in Set Plan Info', {
                        path: window.location.pathname.replace(/\d+/g, '{id}'),
                        projectsLength: projects.length,
                        issuePriorityProjectLength: Object.keys(issuePriorityInformation.projectToPrioritySchemeAssociations).length
                    });
                });
                const result = {
                    crossProjectVersions: [
                        (0, $DywVp.reset)(existingCrossProjectVersions)
                    ],
                    customFields: [
                        (0, $2LFLH.reset)(customFields)
                    ],
                    hierarchy: [
                        (0, $iTAsW.reset)(preparedHierarchyInfo)
                    ],
                    issueTypes: [
                        (0, $2utnB.reset)(issueTypes)
                    ],
                    plan: [
                        (0, $dr8sv.reset)((0, $8RAUa.preparePlan)(planInfo))
                    ],
                    projects: [
                        (0, $boQGP.reset)((0, $8RAUa.prepareProjects)(projects, issuePriorityInformation))
                    ],
                    sequence: sequence ? [
                        (0, $xlOmi.reset)(sequence)
                    ] : [],
                    versions: [
                        (0, $12x9g.reset)(versions)
                    ],
                    sprints: [
                        (0, $lOdND.reset)(preparedSprints)
                    ],
                    disabledSprints: [
                        (0, $dsxgv.reset)(disabledSprints)
                    ],
                    plannedCapacities: [
                        (0, $gwmQW.reset)(preparedPlannedCapacities)
                    ],
                    teams: [
                        (0, $6Oj3G.reset)((0, $8RAUa.prepareTeams)(teams))
                    ],
                    issueStatusCategories: issueStatusCategories ? [
                        (0, $a0OS1.reset)(issueStatusCategories)
                    ] : [],
                    issuePriorities: [
                        (0, $Nfcm7.reset)(issuePriorityInformation.issuePriorities)
                    ],
                    issueStatuses: [
                        (0, $6Sie5.reset)(issueStatuses)
                    ],
                    releaseStatuses: [
                        (0, $a7lvN.reset)(allReleaseStatuses)
                    ],
                    removedCrossProjectVersions: [
                        (0, $bEaE7.reset)(deletedCrossProjectVersions)
                    ],
                    removedVersions: [
                        (0, $cYoMq.reset)(removedVersions)
                    ],
                    originalVersions: [
                        (0, $1LA8L.reset)((0, $8RAUa.prepareOriginalVersions)(projects, crossProjectVersions))
                    ],
                    originalCrossProjectVersions: [
                        (0, $gExeY.reset)((0, $8RAUa.prepareOriginalCrossProjectVersions)(crossProjectVersions))
                    ],
                    originalPlannedCapacities: [
                        (0, $4dybm.reset)(preparedOriginalPlannedCapacities)
                    ],
                    originalTeams: [
                        (0, $1pBkD.reset)((0, $8RAUa.prepareOriginalTeams)(teams))
                    ],
                    originalResources: [
                        (0, $d4YZJ.reset)((0, $8RAUa.prepareOriginalResources)(teams))
                    ],
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                    persons: [
                        (0, $uh7SP.reset)(persons)
                    ]
                };
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $dYnI4.monitor).finishTask((0, $fr1nu.SET_PLAN_INFO));
                return result;
            }
        case 0, $fr1nu.RESET_BACKLOG:
            return $fc2a1a2b766508ed$var$resetBacklog(state, action.payload, (backlog)=>backlog.issues);
        case 0, $fr1nu.UPDATE_ISSUE_REFERENCES:
            {
                const { oldId: oldId, newId: newId } = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const actions = {};
                // Updates dependency filter
                const dependenciesFilterValue = $kjklK.default([
                    (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                    'value'
                ], state.viewSettings.filtersV0);
                if (dependenciesFilterValue && dependenciesFilterValue.type === 'specificIssue' && dependenciesFilterValue.issueId === oldId) actions.viewSettings = [
                    $eaaIH.change({
                        id: (0, $12ee831723ccf9c2$export$a849f806e27a57e8),
                        value: {
                            ...dependenciesFilterValue,
                            issueId: newId
                        }
                    })
                ];
                // Update the issue id
                let bulkIssuesUpdates = {
                    [oldId]: {
                        id: newId
                    }
                };
                bulkIssuesUpdates = state.issues.filter(({ parent: parent })=>parent === oldId).reduce((payload, { id: id })=>{
                    // eslint-disable-next-line no-param-reassign
                    payload[id] = {
                        parent: newId
                    };
                    return payload;
                }, bulkIssuesUpdates);
                actions.issues = [
                    (0, $kt7Vd.bulkUpdate)(bulkIssuesUpdates)
                ];
                return actions;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return {};
            }
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$fc2a1a2b766508ed$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    app: $8pnAg.default,
    assignees: $h0gC4.default,
    crossProjectVersions: $baFys.default,
    customFields: $991dc.default,
    externalIssues: $alW3F.default,
    flags: $JysvY.default,
    goalARIs: $dA5gW.default,
    hiddenFlags: $kz0vM.default,
    hierarchy: $g686T.default,
    issues: $az483.default,
    issueLabels: $iqsN6.default,
    issueLinks: $5eaGD.default,
    issueModal: $amamE.default,
    issuePriorities: $gtbR1.default,
    issueStatusCategories: $6tiLT.default,
    issueStatuses: $jJCIe.default,
    issueTypes: $ew2cF.default,
    lexorank: $fUzZw.default,
    originalCrossProjectVersions: $2MGzR.default,
    originalIssues: $lCL3I.default,
    originalPlannedCapacities: $j8W5F.default,
    originalTeams: $gFJ9p.default,
    originalResources: $cVpED.default,
    originalVersions: $9pelO.default,
    permissions: $gCwkO.default,
    persons: $6qsGU.default,
    plan: $1npMo.default,
    planDefaults: $dhLbt.default,
    projects: $j3r1q.default,
    releaseStatuses: $xlkYE.default,
    reporters: $iWPoR.default,
    removedCrossProjectVersions: $L8rDX.default,
    removedVersions: $5YqZc.default,
    scenarioRemovedIssues: $kZlLv.default,
    sequence: $bnuD7.default,
    solution: $3AY4C.default,
    sprints: $ahKLe.default,
    plannedCapacities: $kIlJL.default,
    system: $5DgX0.default,
    teams: $7VeEM.default,
    teamsAdditional: $8FmvP.default,
    updateJira: $lHE4S.default,
    versions: $56IuN.default,
    warnings: $e5wZF.default,
    historyIssues: $cQxJy.default,
    selectOptions: $3n1fO.default,
    customLabelsByField: $gVN0z.default,
    userPickerOptions: $jpD1u.default,
    userIsOnboarded: $fye2y.default,
    externalSprints: $5t2Pe.default,
    disabledSprints: $9nIz3.default,
    viewSettings: $dg7Hh.default,
    views: $1e5GW.default
}, $fc2a1a2b766508ed$var$composite);

});
parcelRegister("h0gC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a207c12a2ba1f969$export$2e2bcd8739ae039);

var $eN1iE = parcelRequire("eN1iE");
var $kjklK = parcelRequire("kjklK");
var $UCNmJ = parcelRequire("UCNmJ");

var $g4z4L = parcelRequire("g4z4L");
const $a207c12a2ba1f969$var$initialState = {
    issueAssigneeMap: {},
    assigneeList: []
};
const $a207c12a2ba1f969$export$fff63944c1108d5c = (existingPeople, newPeople)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const indexedExistingPeople = $eN1iE.default($kjklK.default([
        'jiraUser',
        'accountId'
    ]), existingPeople);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const indexedNewPeople = $eN1iE.default($kjklK.default([
        'jiraUser',
        'accountId'
    ]), newPeople);
    const mergedUsers = {
        ...indexedExistingPeople,
        ...indexedNewPeople
    };
    return $UCNmJ.default(mergedUsers);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a207c12a2ba1f969$export$2e2bcd8739ae039 = (state = $a207c12a2ba1f969$var$initialState, action)=>{
    switch(action.type){
        case 0, $g4z4L.UPDATE_ISSUE_ASSIGNEE_MAP:
            return {
                ...state,
                issueAssigneeMap: {
                    ...state.issueAssigneeMap,
                    ...action.payload
                }
            };
        case 0, $g4z4L.UPDATE_ASSIGNEES_LIST:
            {
                const { people: people } = action.payload;
                return {
                    ...state,
                    assigneeList: $a207c12a2ba1f969$export$fff63944c1108d5c(state.assigneeList, people)
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("baFys", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d9a454b9a975f0$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $8RAUa = parcelRequire("8RAUa");

var $DywVp = parcelRequire("DywVp");
const $83d9a454b9a975f0$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$83d9a454b9a975f0$export$2e2bcd8739ae039 = (state = $83d9a454b9a975f0$var$initialState, action)=>{
    switch(action.type){
        case 0, $DywVp.RESET:
            return [
                ...action.payload
            ];
        case 0, $DywVp.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $DywVp.REMOVE:
            {
                const removedId = action.payload;
                return state.filter(({ id: id })=>id !== removedId);
            }
        case 0, $DywVp.BULK_UPDATE:
            {
                const { payload: payload } = action;
                const result = [];
                for (const item of state){
                    const patch = payload[item.id];
                    if (patch) result.push($01zCq.default(item, patch));
                    else result.push(item);
                }
                return result;
            }
        case 0, $DywVp.ADD_VERSION_IN_CROSS_PROJECT_VERSION:
            {
                const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                // Array spreading is done to make flow understand the type.
                return [
                    ...state.map((crossProjectVersion)=>{
                        const { id: id, versions: versions } = crossProjectVersion;
                        if (id === crossProjectVersionId) return {
                            ...crossProjectVersion,
                            versions: [
                                ...versions,
                                versionId
                            ]
                        };
                        return crossProjectVersion;
                    })
                ];
            }
        case 0, $DywVp.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION:
            {
                const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                // Array spreading is done to make flow understand the type.
                return [
                    ...state.map((crossProjectVersion)=>{
                        const { id: id, versions: versions } = crossProjectVersion;
                        if (id === crossProjectVersionId) return {
                            ...crossProjectVersion,
                            versions: versions.filter((vid)=>vid !== versionId)
                        };
                        return crossProjectVersion;
                    })
                ];
            }
        case 0, $DywVp.UPDATE_REFERENCES:
            return (0, $8RAUa.updateRefs)(state, action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("991dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $89e837cdd77dc62c$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $2LFLH = parcelRequire("2LFLH");
const $89e837cdd77dc62c$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$89e837cdd77dc62c$export$2e2bcd8739ae039 = (state = $89e837cdd77dc62c$var$initialState, action)=>{
    switch(action.type){
        case 0, $2LFLH.RESET:
            return [
                ...action.payload
            ];
        case 0, $2LFLH.ADD:
            return [
                ...state,
                ...action.payload
            ];
        case 0, $2LFLH.UPDATE:
            {
                const { payload: payload } = action;
                return state.map((customField)=>{
                    if (customField.id === payload.id) return $01zCq.default(customField, payload);
                    return customField;
                });
            }
        case 0, $2LFLH.REMOVE:
            return state.filter((field)=>field.id !== action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("gVN0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f78d17a01e2bfe5$export$2e2bcd8739ae039);

var $bfLCp = parcelRequire("bfLCp");
const $0f78d17a01e2bfe5$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0f78d17a01e2bfe5$export$2e2bcd8739ae039 = (state = $0f78d17a01e2bfe5$var$initialState, action)=>{
    switch(action.type){
        case 0, $bfLCp.RESET_ALL:
            return action.payload;
        case 0, $bfLCp.RESET:
            {
                const { customFieldId: customFieldId, labels: labels } = action.payload;
                return {
                    ...state,
                    [customFieldId]: labels.sort()
                };
            }
        case 0, $bfLCp.ADD:
            {
                const { customFieldId: customFieldId, labels: labels } = action.payload;
                const labelsSet = new Set((state[customFieldId] || []).concat(labels));
                return {
                    ...state,
                    [customFieldId]: Array.from(labelsSet).sort()
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("9nIz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f2b03669e7d43e5$export$2e2bcd8739ae039);

var $dsxgv = parcelRequire("dsxgv");
const $2f2b03669e7d43e5$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f2b03669e7d43e5$export$2e2bcd8739ae039 = (state = $2f2b03669e7d43e5$var$initialState, action)=>{
    switch(action.type){
        case 0, $dsxgv.RESET:
            return action.payload.map((sprint)=>({
                    ...sprint,
                    id: sprint.id.toString()
                }));
        case 0, $dsxgv.ADD:
            return [
                ...state,
                ...action.payload.map((sprint)=>({
                        ...sprint,
                        id: sprint.id.toString()
                    }))
            ];
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("alW3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f118a59db935b50d$export$2e2bcd8739ae039);

var $4hIOe = parcelRequire("4hIOe");
const $f118a59db935b50d$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f118a59db935b50d$export$2e2bcd8739ae039 = (state = $f118a59db935b50d$var$initialState, action)=>{
    switch(action.type){
        case 0, $4hIOe.ADD:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("5t2Pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $765c31e3397cc117$export$2e2bcd8739ae039);

var $kg3sZ = parcelRequire("kg3sZ");
const $765c31e3397cc117$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$765c31e3397cc117$export$2e2bcd8739ae039 = (state = $765c31e3397cc117$var$initialState, action)=>{
    switch(action.type){
        case 0, $kg3sZ.RESET:
            return action.payload.map((sprint)=>({
                    ...sprint,
                    id: sprint.id.toString()
                }));
        case 0, $kg3sZ.ADD:
            return [
                ...state,
                ...action.payload.map((sprint)=>({
                        ...sprint,
                        id: sprint.id.toString()
                    }))
            ];
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("JysvY", function(module, exports) {

$parcel$export(module.exports, "default", () => $44565d61de5dd74d$export$2e2bcd8739ae039);

var $9ozqH = parcelRequire("9ozqH");
const $44565d61de5dd74d$var$initialState = [];
const $44565d61de5dd74d$var$pushFlag = (state, key, context)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
        {
            key: key,
            context: context
        }
    ].concat(state.filter(({ key: previousFlagKey })=>previousFlagKey !== key));
const $44565d61de5dd74d$var$removeFlagOccurrenceFromState = (state, key)=>{
    const filteredState = state.filter(({ key: previousFlagKey })=>previousFlagKey !== key);
    return filteredState;
};
const $44565d61de5dd74d$var$removeLatestFlag = (state)=>{
    const topFlagRemoved = state.slice(1);
    return topFlagRemoved;
};
function $44565d61de5dd74d$export$2e2bcd8739ae039(state = $44565d61de5dd74d$var$initialState, action) {
    switch(action.type){
        case 0, $9ozqH.PUSH_FLAG:
            {
                const { payload: { key: key, context: context } } = action;
                return $44565d61de5dd74d$var$pushFlag(state, key, context);
            }
        // Only called behind FF'd code
        case 0, $9ozqH.REMOVE_FLAG:
            return $44565d61de5dd74d$var$removeFlagOccurrenceFromState(state, action.payload.key);
        case 0, $9ozqH.DISMISS_FLAG:
            return $44565d61de5dd74d$var$removeLatestFlag(state);
        default:
            return state;
    }
}

});

parcelRegister("kz0vM", function(module, exports) {

$parcel$export(module.exports, "default", () => $461acdd05c9dc6b7$export$2e2bcd8739ae039);

var $kBus3 = parcelRequire("kBus3");
var $c8Rgw = parcelRequire("c8Rgw");

var $1uZFJ = parcelRequire("1uZFJ");
const $461acdd05c9dc6b7$var$initialState = {};
// ms in one week
const $461acdd05c9dc6b7$var$oneWeek = 604800000;
// avoid hiding the flag forever
const $461acdd05c9dc6b7$var$MAX_MULTIPLIER = 3;
/**
 * Calculates the timestamp for 2 weeks * multiplier from now
 * @param {number} multiplier
 * @returns {number}
 */ const $461acdd05c9dc6b7$var$calculateWeeksTime = (multiplier)=>Date.now() + $461acdd05c9dc6b7$var$oneWeek * 2 * multiplier;
const $461acdd05c9dc6b7$var$updateHiddenFlagDate = (state, flag)=>{
    // If the flag was already hidden in the past, we increase its multiplier for the next time
    if (state[flag]) {
        const currentMultiplier = state[flag].multiplier;
        const newMultiplier = currentMultiplier < $461acdd05c9dc6b7$var$MAX_MULTIPLIER ? currentMultiplier + 1 : $461acdd05c9dc6b7$var$MAX_MULTIPLIER;
        return {
            ...state,
            [flag]: {
                multiplier: newMultiplier,
                hiddenUntilTimestamp: $461acdd05c9dc6b7$var$calculateWeeksTime(newMultiplier)
            }
        };
    }
    return {
        ...state,
        [flag]: {
            multiplier: 1,
            hiddenUntilTimestamp: $461acdd05c9dc6b7$var$calculateWeeksTime(1)
        }
    };
};
const $461acdd05c9dc6b7$var$clearHiddenFlagDate = (state, flag)=>{
    const nextState = {
        ...state
    };
    delete nextState[flag];
    return nextState;
};
function $461acdd05c9dc6b7$var$reducer(state = $461acdd05c9dc6b7$var$initialState, action) {
    switch(action.type){
        case 0, $1uZFJ.UPDATE_HIDDEN_FLAG_DATE:
            return $461acdd05c9dc6b7$var$updateHiddenFlagDate(state, action.payload.key);
        case 0, $1uZFJ.CLEAR_HIDDEN_FLAG_DATE:
            return $461acdd05c9dc6b7$var$clearHiddenFlagDate(state, action.payload.key);
        default:
            return state;
    }
}
var // eslint-disable-next-line jira/redux/redux-persist-whitelist
$461acdd05c9dc6b7$export$2e2bcd8739ae039 = (0, $c8Rgw.persistReducer)({
    key: (0, $kBus3.getPlanPrefixedKey)('hidden-flags')
}, $461acdd05c9dc6b7$var$reducer);

});

parcelRegister("iTAsW", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $986ebb87027e7739$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $986ebb87027e7739$export$aad8462122ac592b);
const $986ebb87027e7739$export$4a991c87e640ef77 = 'state.domain.hierarchy.RESET';
const $986ebb87027e7739$export$aad8462122ac592b = (payload)=>({
        type: $986ebb87027e7739$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("g686T", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b3047167190de3$export$2e2bcd8739ae039);

var $iTAsW = parcelRequire("iTAsW");
const $18b3047167190de3$var$initialState = {
    levels: []
};
const $18b3047167190de3$var$hierarchyReducer = (state = $18b3047167190de3$var$initialState, action)=>{
    switch(action.type){
        case 0, $iTAsW.RESET:
            return {
                levels: action.payload.levels
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $18b3047167190de3$export$2e2bcd8739ae039 = $18b3047167190de3$var$hierarchyReducer;

});

parcelRegister("cQxJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f280dee5a8249a$export$2e2bcd8739ae039);

var $1umd3 = parcelRequire("1umd3");
const $f1f280dee5a8249a$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f1f280dee5a8249a$export$2e2bcd8739ae039 = (state = $f1f280dee5a8249a$var$initialState, action)=>{
    switch(action.type){
        case 0, $1umd3.RESET:
            return action.payload;
        case 0, $1umd3.UPDATE_PARENT:
            {
                const { id: id, parent: parent } = action.payload;
                return state.map((historyIssue)=>{
                    if (historyIssue.id === id) return {
                        ...historyIssue,
                        parent: parent
                    };
                    return historyIssue;
                });
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lICLK", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $e7ab9340b0dc4f27$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $e7ab9340b0dc4f27$export$aad8462122ac592b);
const $e7ab9340b0dc4f27$export$4a991c87e640ef77 = 'state.domain.issue-goals.RESET';
const $e7ab9340b0dc4f27$export$aad8462122ac592b = (payload)=>({
        type: $e7ab9340b0dc4f27$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("dA5gW", function(module, exports) {

$parcel$export(module.exports, "default", () => $001323b6512cc56b$export$2e2bcd8739ae039);

var $lICLK = parcelRequire("lICLK");
const $001323b6512cc56b$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$001323b6512cc56b$export$2e2bcd8739ae039 = (state = $001323b6512cc56b$var$initialState, action)=>{
    switch(action.type){
        case 0, $lICLK.RESET:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("iqsN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $807177b2d3b4e5a6$export$2e2bcd8739ae039);

var $lhX0J = parcelRequire("lhX0J");
const $807177b2d3b4e5a6$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$807177b2d3b4e5a6$export$2e2bcd8739ae039 = (state = $807177b2d3b4e5a6$var$initialState, action)=>{
    switch(action.type){
        case 0, $lhX0J.ADD:
            return [
                ...state,
                action.payload
            ].sort();
        case 0, $lhX0J.RESET:
            return action.payload;
        case 0, $lhX0J.REMOVE:
            return state.filter((label)=>label !== action.payload).sort();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5eaGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9b4d8ea8c2907c$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");
var $8K6YM = parcelRequire("8K6YM");
var $eoUrK = parcelRequire("eoUrK");

var $7CnHa = parcelRequire("7CnHa");

var $872dx = parcelRequire("872dx");
const $ff9b4d8ea8c2907c$var$initialState = {
    values: {},
    originals: {}
};
const $ff9b4d8ea8c2907c$var$updateLink = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
f, { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey }, state)=>$eoUrK.default({
        values: {
            [sourceItemKey]: f,
            [targetItemKey]: f
        }
    }, state);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff9b4d8ea8c2907c$export$2e2bcd8739ae039 = (state = $ff9b4d8ea8c2907c$var$initialState, action)=>{
    const { values: values } = state;
    switch(action.type){
        case 0, $872dx.ADD:
            {
                const { pendingKey: pendingKey, ...link } = action.payload;
                const { itemKey: itemKey, sourceItemKey: sourceItemKey, targetItemKey: targetItemKey } = link;
                // R.evolve short-circuits on missing keys thus we ensure that key is present
                // this is harmless mutation as we return a new state object anyway
                if (!values[sourceItemKey]) values[sourceItemKey] = {};
                if (!values[targetItemKey]) values[targetItemKey] = {};
                const optimisticState = $ff9b4d8ea8c2907c$var$updateLink($aeXAa.default(itemKey, link), link, state);
                if ((0, $7CnHa.isDefined)(pendingKey)) // remove optimistic update issue links
                return $ff9b4d8ea8c2907c$var$updateLink($8K6YM.default(pendingKey), link, optimisticState);
                return optimisticState;
            }
        case 0, $872dx.RESET:
            return action.payload;
        case 0, $872dx.REMOVE:
            {
                const link = action.payload;
                return $ff9b4d8ea8c2907c$var$updateLink($8K6YM.default(link.itemKey), link, state);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("amamE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca24c543b1a16d73$export$2e2bcd8739ae039);

var $77LR7 = parcelRequire("77LR7");
const $ca24c543b1a16d73$export$d4c72bab9d6cc13a = {
    issueBeingEdited: null,
    isLoadingIssueDescription: false
};
const $ca24c543b1a16d73$var$reducer = (state = $ca24c543b1a16d73$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $77LR7.SET_ISSUE_BEING_EDITED:
            return {
                ...state,
                issueBeingEdited: action.payload
            };
        case 0, $77LR7.SET_LOADING_ISSUE_DESCRIPTION:
            return {
                ...state,
                isLoadingIssueDescription: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $ca24c543b1a16d73$export$2e2bcd8739ae039 = $ca24c543b1a16d73$var$reducer;

});

parcelRegister("gtbR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $81adf4af16ff413e$export$2e2bcd8739ae039);

var $Nfcm7 = parcelRequire("Nfcm7");
const $81adf4af16ff413e$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$81adf4af16ff413e$export$2e2bcd8739ae039 = (state = $81adf4af16ff413e$var$initialState, action)=>{
    switch(action.type){
        case 0, $Nfcm7.RESET:
            return action.payload;
        case 0, $Nfcm7.ADD:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

});

parcelRegister("a0OS1", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $2729686bb1f74199$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $2729686bb1f74199$export$aad8462122ac592b);
const $2729686bb1f74199$export$4a991c87e640ef77 = 'state.domain.issue-status-categories.RESET';
const $2729686bb1f74199$export$aad8462122ac592b = (payload)=>({
        type: $2729686bb1f74199$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("6tiLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6575e1c8566e77$export$2e2bcd8739ae039);

var $a0OS1 = parcelRequire("a0OS1");
const $eb6575e1c8566e77$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb6575e1c8566e77$export$2e2bcd8739ae039 = (state = $eb6575e1c8566e77$var$initialState, action)=>{
    switch(action.type){
        case 0, $a0OS1.RESET:
            return [
                ...action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("6Sie5", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $94ea6ddba39bc835$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $94ea6ddba39bc835$export$aad8462122ac592b);
const $94ea6ddba39bc835$export$4a991c87e640ef77 = 'state.domain.issue-statuses.RESET';
const $94ea6ddba39bc835$export$aad8462122ac592b = (payload)=>({
        type: $94ea6ddba39bc835$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("jJCIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $228c580a55012667$export$2e2bcd8739ae039);

var $6Sie5 = parcelRequire("6Sie5");
const $228c580a55012667$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$228c580a55012667$export$2e2bcd8739ae039 = (state = $228c580a55012667$var$initialState, action)=>{
    switch(action.type){
        case 0, $6Sie5.RESET:
            return [
                ...action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("ew2cF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7283345438392e39$export$2e2bcd8739ae039);

var $2utnB = parcelRequire("2utnB");
const $7283345438392e39$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7283345438392e39$export$2e2bcd8739ae039 = (state = $7283345438392e39$var$initialState, action)=>{
    switch(action.type){
        case 0, $2utnB.RESET:
            return action.payload.map(({ id: id, ...rest })=>({
                    ...rest,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    id: parseInt(id, 10)
                }));
        case 0, $2utnB.ADD:
            return [
                ...state,
                ...action.payload.map(({ id: id, ...rest })=>({
                        ...rest,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        id: parseInt(id, 10)
                    }))
            ];
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("az483", function(module, exports) {

$parcel$export(module.exports, "default", () => $d227e82371ed89ff$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $aeXAa = parcelRequire("aeXAa");
var $4G7jA = parcelRequire("4G7jA");
var $aP1ZI = parcelRequire("aP1ZI");
var $01zCq = parcelRequire("01zCq");
var $8e6Ja = parcelRequire("8e6Ja");
var $h3f0m = parcelRequire("h3f0m");
var $8aqkF = parcelRequire("8aqkF");

var $dcFiu = parcelRequire("dcFiu");

var $7CnHa = parcelRequire("7CnHa");

var $kt7Vd = parcelRequire("kt7Vd");
const $d227e82371ed89ff$var$initialState = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d227e82371ed89ff$var$mergeIssueValues = (key, stateValue, payloadValue)=>key === 'customFields' ? $01zCq.default(stateValue, payloadValue) : payloadValue;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d227e82371ed89ff$export$2e2bcd8739ae039 = (state = $d227e82371ed89ff$var$initialState, action)=>{
    switch(action.type){
        case 0, $kt7Vd.RESET:
            return [
                ...action.payload
            ];
        case 0, $kt7Vd.UPDATE:
            {
                const { payload: payload } = action;
                const index = state.findIndex(({ id: id })=>id === payload.id);
                return $gUZib.default(index, (issue)=>$8e6Ja.default($d227e82371ed89ff$var$mergeIssueValues, issue, payload), state);
            }
        case 0, $kt7Vd.BULK_LABEL_UPDATE:
            {
                const { payload: payload } = action;
                const applyPatch = (issue)=>{
                    const issueUpdate = payload[issue.id];
                    if (!(0, $7CnHa.isDefined)(issueUpdate)) return issue;
                    const patch = {
                        labels: issueUpdate.labels?.value
                    };
                    switch(issueUpdate.labels?.fieldAction){
                        case (0, $dcFiu.FieldAction).ADD:
                            patch.labels = $8aqkF.default(patch.labels, issue.labels || []);
                            break;
                        case (0, $dcFiu.FieldAction).REMOVE:
                            patch.labels = issue.labels?.filter((label)=>!patch.labels.includes(label));
                            break;
                        default:
                            break;
                    }
                    return $8e6Ja.default($d227e82371ed89ff$var$mergeIssueValues, issue, patch);
                };
                return state.map(applyPatch);
            }
        case 0, $kt7Vd.BULK_UPDATE:
            {
                const { payload: payload } = action;
                const applyPatch = (issue)=>{
                    const patch = payload[issue.id];
                    if (!(0, $7CnHa.isDefined)(patch)) return issue;
                    return $8e6Ja.default($d227e82371ed89ff$var$mergeIssueValues, issue, patch);
                };
                return state.map(applyPatch);
            }
        case 0, $kt7Vd.ADD:
            {
                const parentId = action.payload.parent;
                const position = parentId ? $4G7jA.default($h3f0m.default('id', parentId), state) : -1;
                if (position >= 0) return $aP1ZI.default(position + 1, action.payload, state);
                return [
                    ...state,
                    action.payload
                ];
            }
        case 0, $kt7Vd.RANK:
            {
                const { payload: { itemKeys: [id], anchor: anchor } } = action;
                if (anchor === undefined) return state;
                const movedIssueIndex = state.findIndex((issue)=>issue.id === id);
                const anchorIssue = state.find((issue)=>issue.id === anchor);
                if (!anchorIssue) throw new Error(`Anchor with id ${anchor} not found!`);
                return $gUZib.default(movedIssueIndex, $aeXAa.default('lexoRank', anchorIssue.lexoRank), state);
            }
        case 0, $kt7Vd.BULK_RANK:
            {
                const { payload: { itemKeys: itemKeys, anchor: anchor } } = action;
                const itemKeysSet = new Set(itemKeys);
                if (anchor === undefined) return state;
                const anchorIssue = state.find((el)=>el.id === anchor);
                if (!anchorIssue) throw new Error(`Anchor with id ${anchor} not found!`);
                const lexoRank = anchorIssue.lexoRank;
                const result = [];
                for (const issue of state)if (itemKeysSet.has(issue.id)) result.push({
                    ...issue,
                    lexoRank: lexoRank
                });
                else result.push(issue);
                return result;
            }
        case 0, $kt7Vd.REMOVE_WITHOUT_ISSUE_KEY:
            return state.filter(({ issueKey: issueKey })=>issueKey);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("fUzZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80333597e62295d$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");
var $aP1ZI = parcelRequire("aP1ZI");
var $2bK9G = parcelRequire("2bK9G");
var $01zCq = parcelRequire("01zCq");

var $kIUsy = parcelRequire("kIUsy");
const $d80333597e62295d$var$initialState = {
    issueAdjustments: [],
    versionAdjustments: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d80333597e62295d$export$2e2bcd8739ae039 = (state = $d80333597e62295d$var$initialState, action)=>{
    const actionType = action.type;
    switch(actionType){
        case 0, $kIUsy.RESET_ADJUSTMENTS:
            return $01zCq.default(state, {
                issueAdjustments: [
                    ...action.payload
                ]
            });
        case 0, $kIUsy.ADJUST_ISSUE_LEXORANK:
            {
                const { anchor: anchor, itemKeys: [id], relation: relation } = action.payload;
                if (anchor === undefined) return state;
                const adjustments = state.issueAdjustments.filter((x)=>x !== id);
                const anchorAdjustment = adjustments.indexOf(anchor);
                if (anchorAdjustment < 0) {
                    const items = relation === 'AFTER' ? [
                        anchor,
                        id
                    ] : [
                        id,
                        anchor
                    ];
                    return $aeXAa.default('issueAdjustments', [
                        ...adjustments,
                        ...items
                    ], state);
                }
                const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                return $aeXAa.default('issueAdjustments', $aP1ZI.default(adjustment, id, adjustments), state);
            }
        case 0, $kIUsy.BULK_ADJUST_ISSUE_LEXORANK:
            {
                const { anchor: anchor, itemKeys: itemKeys, relation: relation } = action.payload;
                const itemKeysSet = new Set(itemKeys);
                const adjustments = state.issueAdjustments.filter((id)=>!itemKeysSet.has(id));
                if (relation === 'LAST') return $aeXAa.default('issueAdjustments', [
                    ...adjustments,
                    ...itemKeys
                ], state);
                if (anchor === undefined) return state;
                const anchorAdjustment = adjustments.indexOf(anchor);
                if (anchorAdjustment < 0) {
                    const items = relation === 'AFTER' ? [
                        anchor,
                        ...itemKeys
                    ] : [
                        ...itemKeys,
                        anchor
                    ];
                    return $aeXAa.default('issueAdjustments', [
                        ...adjustments,
                        ...items
                    ], state);
                }
                const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                return $aeXAa.default('issueAdjustments', $2bK9G.default(adjustment, itemKeys, adjustments), state);
            }
        case 0, $kIUsy.ADJUST_VERSION_LEXORANK:
            {
                const { anchor: anchor, id: id, relation: relation } = action.payload;
                if (anchor === undefined) return state;
                const adjustments = state.versionAdjustments.filter((x)=>x !== id);
                const anchorAdjustment = adjustments.indexOf(anchor);
                if (anchorAdjustment < 0) {
                    const items = relation === 'AFTER' ? [
                        anchor,
                        id
                    ] : [
                        id,
                        anchor
                    ];
                    return $aeXAa.default('versionAdjustments', [
                        ...adjustments,
                        ...items
                    ], state);
                }
                const adjustment = anchorAdjustment + (relation === 'AFTER' ? 1 : 0);
                return $aeXAa.default('versionAdjustments', $aP1ZI.default(adjustment, id, adjustments), state);
            }
        case 0, $kIUsy.UPDATE_VERSION_LEXORANK_ADJUSTMENTS:
            {
                const { payload: payload } = action;
                const patches = Object.keys(payload);
                const versionAdjustments = state.versionAdjustments.map((versionId)=>patches.includes(versionId) ? payload[versionId] : versionId);
                return $aeXAa.default('versionAdjustments', versionAdjustments, state);
            }
        default:
            // prettier-ignore
            actionType;
            return state;
    }
};

});
parcelRegister("2bK9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1980694921287655$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $1980694921287655$var$insertAll = /*#__PURE__*/ (0, $4g10W.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $1980694921287655$export$2e2bcd8739ae039 = $1980694921287655$var$insertAll;

});


parcelRegister("2MGzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3457a0f53030096$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $8RAUa = parcelRequire("8RAUa");

var $gExeY = parcelRequire("gExeY");
const $c3457a0f53030096$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c3457a0f53030096$export$2e2bcd8739ae039 = (state = $c3457a0f53030096$var$initialState, action)=>{
    switch(action.type){
        case 0, $gExeY.RESET:
            return {
                ...action.payload
            };
        case 0, $gExeY.UPDATE:
            {
                const { id: id, values: values } = action.payload;
                return {
                    ...state,
                    [id]: $01zCq.default(values, state[id])
                };
            }
        case 0, $gExeY.UPDATE_REFERENCES:
            return (0, $8RAUa.updateRefs)(state, action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lCL3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3cb3f343bd3bc44$export$2e2bcd8739ae039);

var $8K6YM = parcelRequire("8K6YM");
var $01zCq = parcelRequire("01zCq");
var $8e6Ja = parcelRequire("8e6Ja");
var $cQwal = parcelRequire("cQwal");

var $7CnHa = parcelRequire("7CnHa");

var $lwKA5 = parcelRequire("lwKA5");
const $a3cb3f343bd3bc44$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a3cb3f343bd3bc44$export$2e2bcd8739ae039 = (state = $a3cb3f343bd3bc44$var$initialState, action)=>{
    switch(action.type){
        case 0, $lwKA5.RESET:
            return {
                ...action.payload
            };
        case 0, $lwKA5.UPDATE:
            {
                const { id: id, ...originals } = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const mergeValues = (key, payloadValue, stateValue)=>key === 'customFields' ? $01zCq.default(payloadValue, stateValue) : stateValue;
                return {
                    ...state,
                    // NOTE merging state into "originals" and not vice versa because we want to keep old value if it was already set (real original)
                    [id]: $8e6Ja.default(mergeValues, originals, state[id] || {})
                };
            }
        case 0, $lwKA5.REVERT_FIELDS:
            {
                const { id: id, fields: fields } = action.payload;
                const originalIssue = state[id];
                const newOriginalIssue = (0, $7CnHa.pickBy)((_, key)=>!fields.includes(key), originalIssue);
                if (Object.keys(newOriginalIssue).length === 0) return $8K6YM.default(id, state);
                return {
                    ...state,
                    [id]: {
                        ...newOriginalIssue
                    }
                };
            }
        case 0, $lwKA5.REMOVE:
            return $cQwal.default(action.payload, state);
        default:
            return state;
    }
};

});

parcelRegister("j8W5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $6faae009efbe398e$export$2e2bcd8739ae039);

var $itLT6 = parcelRequire("itLT6");
var $li3lI = parcelRequire("li3lI");
var $cQGVO = parcelRequire("cQGVO");

var $4dybm = parcelRequire("4dybm");
const $6faae009efbe398e$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6faae009efbe398e$export$2e2bcd8739ae039 = (state = $6faae009efbe398e$var$initialState, action)=>{
    switch(action.type){
        case 0, $4dybm.RESET:
            {
                const resetAction = action;
                return {
                    ...resetAction.payload
                };
            }
        case 0, $4dybm.UPDATE:
            {
                const updateAction = action;
                const { iterationId: iterationId, teamId: teamId } = updateAction.payload;
                return $itLT6.default([
                    teamId,
                    iterationId
                ], updateAction.payload, state);
            }
        case 0, $4dybm.REMOVE:
            {
                const { payload: { teamId: teamId, iterationId: iterationId } } = action;
                return $li3lI.default([
                    teamId,
                    iterationId
                ], state);
            }
        case 0, $4dybm.UPDATE_TEAM_ID:
            {
                const { payload: { oldId: oldId, newId: newId } } = action;
                const newState = {
                    ...state
                };
                if (newState[oldId]) {
                    newState[newId] = $cQGVO.default((capacity)=>({
                            ...capacity,
                            teamId: newId
                        }), newState[oldId]);
                    delete newState[oldId];
                }
                return newState;
            }
        default:
            return state;
    }
};

});

parcelRegister("cVpED", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68070d6a6575a11$export$2e2bcd8739ae039);

var $bIjSf = parcelRequire("bIjSf");

var $d4YZJ = parcelRequire("d4YZJ");
const $b68070d6a6575a11$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b68070d6a6575a11$export$2e2bcd8739ae039 = (state = $b68070d6a6575a11$var$initialState, action)=>{
    switch(action.type){
        case 0, $d4YZJ.RESET:
            return {
                ...action.payload
            };
        case 0, $d4YZJ.UPDATE:
            {
                const { itemKey: itemKey, ...originals } = action.payload;
                return {
                    ...state,
                    // NOTE merging state into "originals" and not vice versa because we want to keep old value if it was already set (real original)
                    [itemKey]: $bIjSf.default(originals, state[itemKey] || {})
                };
            }
        default:
            return state;
    }
};

});

parcelRegister("gFJ9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8580c433f23cb96$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $1pBkD = parcelRequire("1pBkD");
const $d8580c433f23cb96$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d8580c433f23cb96$export$2e2bcd8739ae039 = (state = $d8580c433f23cb96$var$initialState, action)=>{
    switch(action.type){
        case 0, $1pBkD.RESET:
            return {
                ...action.payload
            };
        case 0, $1pBkD.UPDATE:
            {
                const { id: id, ...originals } = action.payload;
                return {
                    ...state,
                    // NOTE merging state into "originals" and not vice versa because we want to keep old value if it was already set (real original)
                    [id]: $01zCq.default(originals, state[id])
                };
            }
        default:
            return state;
    }
};

});

parcelRegister("9pelO", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a770927d216d9f$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $8RAUa = parcelRequire("8RAUa");

var $1LA8L = parcelRequire("1LA8L");
const $18a770927d216d9f$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$18a770927d216d9f$export$2e2bcd8739ae039 = (state = $18a770927d216d9f$var$initialState, action)=>{
    switch(action.type){
        case 0, $1LA8L.RESET:
            return {
                ...action.payload
            };
        case 0, $1LA8L.UPDATE:
            {
                const { id: id, values: values } = action.payload;
                return {
                    ...state,
                    [id]: $01zCq.default(values, state[id])
                };
            }
        case 0, $1LA8L.UPDATE_REFERENCES:
            return (0, $8RAUa.updateRefs)(state, action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("gCwkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1718bab66693f1$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $iFUSZ = parcelRequire("iFUSZ");

var $luwrE = parcelRequire("luwrE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd1718bab66693f1$var$currentUser = (state = {}, action)=>{
    switch(action.type){
        case 0, $iFUSZ.SET_CURRENT_USER:
            {
                const { displayName: displayName, key: key, emailAddress: email, avatarUrls: avatarUrls } = action.payload;
                return {
                    displayName: displayName,
                    key: key,
                    email: email,
                    avatarUrl: avatarUrls['48x48']
                };
            }
        default:
            return state;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd1718bab66693f1$var$isFetchPlanPermissionsInProgress = (state = false, action)=>{
    switch(action.type){
        case 0, $iFUSZ.TOGGLE_FETCH_PLAN_PERMISSIONS_IN_PROGRESS:
            return action.payload;
        default:
            return state;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd1718bab66693f1$var$teamPermissions = (state = {}, action)=>{
    switch(action.type){
        case 0, $iFUSZ.SET_TEAM_PERMISSIONS:
            return action.payload;
        default:
            return state;
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$dd1718bab66693f1$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    planPermissions: $luwrE.default,
    currentUser: $dd1718bab66693f1$var$currentUser,
    isFetchPlanPermissionsInProgress: $dd1718bab66693f1$var$isFetchPlanPermissionsInProgress,
    teamPermissions: $dd1718bab66693f1$var$teamPermissions
});

});
parcelRegister("luwrE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5aa582d27f78b2$export$2e2bcd8739ae039);

var $iFUSZ = parcelRequire("iFUSZ");
const $ac5aa582d27f78b2$var$initialState = [];
const $ac5aa582d27f78b2$var$permissionReducer = (state, action)=>{
    switch(action.type){
        case 0, $iFUSZ.ADD_PERMISSION:
            if (state.holder.key !== action.payload.holder.key) return state;
            return {
                ...state,
                permissions: state.permissions.concat(action.payload.permission)
            };
        case 0, $iFUSZ.REMOVE_PERMISSION:
            if (state.holder.key !== action.payload.holder.key) return state;
            return {
                ...state,
                permissions: state.permissions.filter((role)=>role !== action.payload.permission)
            };
        default:
            return state;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac5aa582d27f78b2$export$2e2bcd8739ae039 = (state = $ac5aa582d27f78b2$var$initialState, action)=>{
    switch(action.type){
        case 0, $iFUSZ.SET_PERMISSIONS:
            return [
                ...action.payload
            ];
        case 0, $iFUSZ.ADD_PERMISSION:
            {
                const { holder: holder } = action.payload;
                const existingPermission = state.find((permission)=>permission.holder.key === holder.key);
                if (!existingPermission) {
                    const { permission: permission, ...rest } = action.payload;
                    return state.concat({
                        ...rest,
                        permissions: [
                            permission
                        ]
                    });
                }
                return state.map((permission)=>$ac5aa582d27f78b2$var$permissionReducer(permission, action));
            }
        case 0, $iFUSZ.REMOVE_PERMISSION:
            return state.map((permission)=>$ac5aa582d27f78b2$var$permissionReducer(permission, action)).filter((permission)=>permission.permissions.length > 0);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("6qsGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa9a3487fb8b28a5$export$2e2bcd8739ae039);

var $uh7SP = parcelRequire("uh7SP");
const $aa9a3487fb8b28a5$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa9a3487fb8b28a5$export$2e2bcd8739ae039 = (state = $aa9a3487fb8b28a5$var$initialState, action)=>{
    switch(action.type){
        case 0, $uh7SP.RESET:
            return action.payload;
        case 0, $uh7SP.ADD:
            return [
                ...state,
                action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("dhLbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $280c546d415ea01a$export$2e2bcd8739ae039);

var $l46YP = parcelRequire("l46YP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$280c546d415ea01a$export$2e2bcd8739ae039 = (state = {}, action)=>{
    if (action.type === (0, $l46YP.SET_PLAN_DEFAULTS)) return action.payload;
    return state;
};

});

parcelRegister("1npMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $594ed4751fb3d72e$export$2e2bcd8739ae039);

var $aPa3f = parcelRequire("aPa3f");

var $eOsHk = parcelRequire("eOsHk");
parcelRequire("5rYNM");

var $dr8sv = parcelRequire("dr8sv");
const $594ed4751fb3d72e$var$initialState = {
    title: (0, $aPa3f.tryExtractPlanTitleFromDocument)(),
    planningUnit: 'StoryPoints',
    issueSources: [],
    includeCompletedIssuesFor: (0, $87a0abe4cc67502d$export$6afdd25b4da87159),
    autoScheduleConfiguration: {
        ignoreSprints: false,
        ignoreReleases: false,
        ignoreTeams: false
    },
    teamManager: false,
    syncStartEnabled: false,
    issueInferredDateSelection: (0, $eOsHk.ISSUE_INFERRED_DATE_SELECTION).SPRINT,
    baselineStartField: (0, $eOsHk.TARGET_START_DATE_FIELD),
    baselineEndField: (0, $eOsHk.DUE_DATE_FIELD),
    useTwpTeams: false,
    isSamplePlan: false,
    autoSchedulerEnabled: false,
    planStatus: 'ACTIVE',
    // delete this key when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    zeroMemberTeamsCount: 0,
    planType: undefined,
    creatorAccountId: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$594ed4751fb3d72e$export$2e2bcd8739ae039 = (state = $594ed4751fb3d72e$var$initialState, action)=>{
    switch(action.type){
        case 0, $dr8sv.RESET:
            return {
                ...action.payload
            };
        case 0, $dr8sv.UPDATE:
            return {
                ...state,
                ...action.payload
            };
        case 0, $dr8sv.ENABLE_PLAN_SCENARIOS:
            return {
                ...state,
                multiScenarioEnabled: true,
                scenarios: action.payload
            };
        case 0, $dr8sv.ADD_PLAN_SCENARIO:
            return {
                ...state,
                scenarios: [
                    action.payload,
                    ...state.scenarios || []
                ]
            };
        case 0, $dr8sv.UPDATE_PLAN_SCENARIO:
            {
                if (!state.scenarios) return state;
                const { id: id, ...values } = action.payload;
                const scenarios = state.scenarios.map((scenario)=>{
                    if (scenario.id === id) return {
                        ...scenario,
                        ...values
                    };
                    return scenario;
                });
                return {
                    ...state,
                    scenarios: scenarios
                };
            }
        case 0, $dr8sv.REMOVE_PLAN_SCENARIO:
            {
                const { id: id } = action.payload;
                return {
                    ...state,
                    scenarios: state.scenarios && state.scenarios.filter((scenario)=>scenario.id !== id)
                };
            }
        case 0, $dr8sv.DISABLE_PLAN_SCENARIOS:
            {
                const { scenarioToKeepId: scenarioToKeepId } = action;
                return {
                    ...state,
                    multiScenarioEnabled: false,
                    scenarios: state.scenarios && state.scenarios.filter((scenario)=>scenario.id === scenarioToKeepId)
                };
            }
        case 0, $dr8sv.UPDATE_AUTO_SCHEDULER_ENABLED:
            return {
                ...state,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("aPa3f", function(module, exports) {

$parcel$export(module.exports, "tryExtractPlanTitleFromDocument", () => $d3e182edff78033f$export$38c9cfaa14d648d1);
const $d3e182edff78033f$var$DOCUMENT_TITLE_DIVIDER_PLANS = ' - Plans - ';
const $d3e182edff78033f$export$38c9cfaa14d648d1 = ()=>{
    if (document && document.title) {
        const index = document.title.lastIndexOf($d3e182edff78033f$var$DOCUMENT_TITLE_DIVIDER_PLANS);
        return index === -1 ? undefined : document.title.substring(0, index);
    }
    return undefined;
};

});


parcelRegister("kIlJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6550ca1d8b6499ef$export$2e2bcd8739ae039);

var $itLT6 = parcelRequire("itLT6");
var $li3lI = parcelRequire("li3lI");
var $cQGVO = parcelRequire("cQGVO");

var $gwmQW = parcelRequire("gwmQW");
const $6550ca1d8b6499ef$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6550ca1d8b6499ef$export$2e2bcd8739ae039 = (state = $6550ca1d8b6499ef$var$initialState, action)=>{
    switch(action.type){
        case 0, $gwmQW.RESET:
            {
                const resetAction = action;
                return {
                    ...resetAction.payload
                };
            }
        case 0, $gwmQW.UPDATE:
            {
                const updateAction = action;
                const { iterationId: iterationId, teamId: teamId } = updateAction.payload;
                return $itLT6.default([
                    teamId,
                    iterationId
                ], updateAction.payload, state);
            }
        case 0, $gwmQW.REMOVE:
            {
                const { payload: { teamId: teamId, iterationId: iterationId } } = action;
                return $li3lI.default([
                    teamId,
                    iterationId
                ], state);
            }
        case 0, $gwmQW.UPDATE_TEAM_ID:
            {
                const { payload: { oldId: oldId, newId: newId } } = action;
                const newState = {
                    ...state
                };
                if (newState[oldId]) {
                    newState[newId] = $cQGVO.default((capacity)=>({
                            ...capacity,
                            teamId: newId
                        }), newState[oldId]);
                    delete newState[oldId];
                }
                return newState;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("j3r1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $39f0a682a0fae9cc$export$2e2bcd8739ae039);

var $7CnHa = parcelRequire("7CnHa");

var $boQGP = parcelRequire("boQGP");
const $39f0a682a0fae9cc$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39f0a682a0fae9cc$export$2e2bcd8739ae039 = (state = $39f0a682a0fae9cc$var$initialState, action)=>{
    switch(action.type){
        case 0, $boQGP.RESET:
            // there are many projects , so there isn't any default
            if (action.payload.length > 1) return action.payload.map((project)=>({
                    ...project,
                    isDefault: false
                }));
            // if there is only one project ,this project is the default one
            return action.payload.map((project)=>({
                    ...project,
                    isDefault: true
                }));
        case 0, $boQGP.ADD:
            return [
                ...state,
                ...action.payload
            ];
        case 0, $boQGP.ADD_VERSION_IN_PROJECT:
            {
                const { projectId: projectId, versionId: versionId } = action.payload;
                const project = state.find(({ id: id })=>id === projectId);
                if ((0, $7CnHa.isDefined)(project)) {
                    const restOfTheProjects = state.filter(({ id: id })=>id !== projectId);
                    return [
                        ...restOfTheProjects,
                        {
                            ...project,
                            versions: [
                                ...project.versions,
                                versionId
                            ]
                        }
                    ];
                }
                return state;
            }
        case 0, $boQGP.SET_DEFAULT_PROJECT:
            {
                const projectId = action.payload.projectId;
                return state.map((project)=>({
                        ...project,
                        isDefault: project.id === projectId
                    }));
            }
        case 0, $boQGP.REMOVE_VERSION_FROM_PROJECT:
            {
                const { projectId: projectId, versionId: versionId } = action.payload;
                const project = state.find(({ id: id })=>id === projectId);
                if ((0, $7CnHa.isDefined)(project)) {
                    const newVersions = project.versions.filter((id)=>id !== versionId);
                    const restOfTheProjects = state.filter(({ id: id })=>id !== projectId);
                    return [
                        ...restOfTheProjects,
                        {
                            ...project,
                            versions: [
                                ...newVersions
                            ]
                        }
                    ];
                }
                return state;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("L8rDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $22bc3c1764f876e7$export$2e2bcd8739ae039);

var $hFzsN = parcelRequire("hFzsN");

var $bEaE7 = parcelRequire("bEaE7");
const $22bc3c1764f876e7$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$22bc3c1764f876e7$export$2e2bcd8739ae039 = (state = $22bc3c1764f876e7$var$initialState, action)=>{
    switch(action.type){
        case 0, $bEaE7.RESET:
            return (0, $hFzsN.sortAsLowerCaseByNameProp)([
                ...action.payload
            ]);
        case 0, $bEaE7.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $bEaE7.REMOVE:
            {
                const removedId = action.versionId;
                return state.filter(({ id: id })=>id !== removedId);
            }
        case 0, $bEaE7.ADD_VERSION_IN_CROSS_PROJECT_VERSION:
            {
                const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                // Array spreading is done to make flow understand the type.
                return [
                    ...state.map((crossProjectVersion)=>{
                        const { id: id, versions: versions } = crossProjectVersion;
                        if (id === crossProjectVersionId) return {
                            ...crossProjectVersion,
                            versions: [
                                ...versions,
                                versionId
                            ]
                        };
                        return crossProjectVersion;
                    })
                ];
            }
        case 0, $bEaE7.REMOVE_VERSION_FROM_CROSS_PROJECT_VERSION:
            {
                const { crossProjectVersionId: crossProjectVersionId, versionId: versionId } = action.payload;
                // Array spreading is done to make flow understand the type.
                return [
                    ...state.map((crossProjectVersion)=>{
                        const { id: id, versions: versions } = crossProjectVersion;
                        if (id === crossProjectVersionId) return {
                            ...crossProjectVersion,
                            versions: versions.filter((vid)=>vid !== versionId)
                        };
                        return crossProjectVersion;
                    })
                ];
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5YqZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $889083748b0ccd1f$export$2e2bcd8739ae039);

var $hFzsN = parcelRequire("hFzsN");

var $cYoMq = parcelRequire("cYoMq");
const $889083748b0ccd1f$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$889083748b0ccd1f$export$2e2bcd8739ae039 = (state = $889083748b0ccd1f$var$initialState, action)=>{
    switch(action.type){
        case 0, $cYoMq.RESET:
            return (0, $hFzsN.sortAsLowerCaseByNameProp)([
                ...action.payload
            ]);
        case 0, $cYoMq.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $cYoMq.REMOVE:
            {
                const removedId = action.versionId;
                return state.filter(({ id: id })=>id !== removedId);
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("iWPoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5985704db447f6ba$export$2e2bcd8739ae039);

var $jNZI1 = parcelRequire("jNZI1");
const $5985704db447f6ba$var$initialState = {
    issueReporterMap: {},
    reporterList: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5985704db447f6ba$export$2e2bcd8739ae039 = (state = $5985704db447f6ba$var$initialState, action)=>{
    switch(action.type){
        case 0, $jNZI1.UPDATE_ISSUE_REPORTER_MAP:
            return {
                ...state,
                issueReporterMap: {
                    ...state.issueReporterMap,
                    ...action.payload
                }
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("kZlLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9525e47fef5f0e$export$2e2bcd8739ae039);

var $9ZuLc = parcelRequire("9ZuLc");
const $fb9525e47fef5f0e$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fb9525e47fef5f0e$export$2e2bcd8739ae039 = (state = $fb9525e47fef5f0e$var$initialState, action)=>{
    switch(action.type){
        case 0, $9ZuLc.RESET:
            return [
                ...action.payload
            ];
        case 0, $9ZuLc.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $9ZuLc.BULK_ADD:
            return [
                ...state,
                ...action.payload
            ];
        case 0, $9ZuLc.REMOVE:
            return state.filter(({ id: id })=>id !== action.payload);
        case 0, $9ZuLc.BULK_REMOVE:
            return state.filter(({ id: id })=>!action.payload.includes(id));
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("3n1fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a08a48ca2973107$export$2e2bcd8739ae039);

var $1oWqc = parcelRequire("1oWqc");
const $8a08a48ca2973107$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a08a48ca2973107$export$2e2bcd8739ae039 = (state = $8a08a48ca2973107$var$initialState, action)=>{
    switch(action.type){
        case 0, $1oWqc.RESET:
            return action.payload;
        case 0, $1oWqc.ADD:
            {
                const { payload: payload } = action;
                const newItems = payload.map((item)=>item.id);
                return [
                    ...payload,
                    ...state.filter((item)=>!newItems.includes(item.id))
                ];
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bnuD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef0c5411443f4299$export$2e2bcd8739ae039);

var $xlOmi = parcelRequire("xlOmi");
const $ef0c5411443f4299$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef0c5411443f4299$export$2e2bcd8739ae039 = (state = $ef0c5411443f4299$var$initialState, action)=>{
    switch(action.type){
        case 0, $xlOmi.INCREMENT:
            {
                const newState = {
                    ...state
                };
                for (const key of action.payload){
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const { current: current } = newState[key] || {
                        current: 0
                    };
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    newState[key] = {
                        before: current,
                        current: current + 1
                    };
                }
                return newState;
            }
        case 0, $xlOmi.RESET:
            return {
                ...action.payload
            };
        case 0, $xlOmi.UPDATE:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("3AY4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbadf687f995cb2f$export$2e2bcd8739ae039);

var $k94CF = parcelRequire("k94CF");
const $cbadf687f995cb2f$var$initialState = {
    isLatest: false,
    isValid: false,
    applyingProgress: null,
    projects: {},
    teams: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cbadf687f995cb2f$export$2e2bcd8739ae039 = (state = $cbadf687f995cb2f$var$initialState, action)=>{
    switch(action.type){
        case 0, $k94CF.SET_LATEST:
            {
                const isLatest = action.payload;
                return {
                    ...state,
                    isLatest: isLatest
                };
            }
        case 0, $k94CF.SET_VALIDITY:
            {
                const isValid = action.payload;
                return {
                    ...state,
                    isValid: isValid
                };
            }
        case 0, $k94CF.SET_PROGRESS:
            {
                const applyingProgress = action.payload;
                return {
                    ...state,
                    applyingProgress: applyingProgress
                };
            }
        case 0, $k94CF.RESET:
            {
                const solution = action.payload;
                return {
                    ...state,
                    ...solution,
                    applyingProgress: null,
                    isValid: false
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lOdND", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $41ae987efd5392e7$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $41ae987efd5392e7$export$aad8462122ac592b);
const $41ae987efd5392e7$export$4a991c87e640ef77 = 'state.domain.sprints.RESET';
const $41ae987efd5392e7$export$aad8462122ac592b = (payload)=>({
        type: $41ae987efd5392e7$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("ahKLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $174e272afe3b9b42$export$2e2bcd8739ae039);

var $lOdND = parcelRequire("lOdND");
const $174e272afe3b9b42$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$174e272afe3b9b42$export$2e2bcd8739ae039 = (state = $174e272afe3b9b42$var$initialState, action)=>{
    switch(action.type){
        case 0, $lOdND.RESET:
            return [
                ...action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("5DgX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a25063a5237f2546$export$2e2bcd8739ae039);

var $ao0hp = parcelRequire("ao0hp");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $iywPH = parcelRequire("iywPH");
const $a25063a5237f2546$var$defaultInitialConfig = {
    locale: (0, $ao0hp.defaultLocale)
};
const $a25063a5237f2546$export$d4c72bab9d6cc13a = {
    systemInfo: {
        lookAndFeel: {
            dateFormat: (0, $5rYNM.DefaultDateFormat)
        },
        jiraHoursPerDay: 8,
        jiraDaysPerWeek: 5,
        jiraTitle: '',
        // viewer is the most restricted option we can take as a default (See PluginPermission type).
        // If the user does not have view permissions they won't even load the state.
        permission: 'Viewer',
        isAdmin: false,
        fiscalMonth: 1,
        accountId: '',
        userName: '',
        userEmailAddress: '',
        avatarUrl: '',
        ...$a25063a5237f2546$var$defaultInitialConfig
    },
    agileInfo: {
        version: '',
        epicLinkField: '',
        epicLabelField: '',
        sprintsField: '',
        storyPointsField: '',
        storyPointFieldName: '',
        storyPointEstimateField: '',
        storyPointEstimateFieldName: '',
        targetStartField: '',
        targetEndField: '',
        teamField: ''
    },
    issueLinkTypesInfo: {
        isIssueLinkingEnabled: true,
        issueLinkTypes: []
    },
    dependencySettingsInfo: {
        dependencyIssueLinkTypes: []
    },
    loadingLimitsInfo: {
        absoluteIssueLimit: Infinity,
        defaultAbsoluteIssueLimit: Infinity,
        defaultHierarchyIssueLimit: Infinity,
        defaultProjectLimit: Infinity,
        projectLimit: Infinity
    },
    isAtlasConnectInstalled: false,
    hasAtlasPermissions: false
};
const $a25063a5237f2546$export$534a5ce135e639a = ({ issueLinkTypesInfo: issueLinkTypesInfo, dependencySettingsInfo: dependencySettingsInfo, ...rest })=>{
    const { issueLinkTypes: issueLinkTypes } = issueLinkTypesInfo;
    const { dependencyIssueLinkTypes: dependencyIssueLinkTypes } = dependencySettingsInfo;
    const dependencyIssueLinkTypeById = (0, $7CnHa.indexBy)((dependencyIssueLinkType)=>dependencyIssueLinkType.issueLinkTypeId, dependencyIssueLinkTypes);
    const remappedIssueLinkTypes = issueLinkTypes.map((issueLinkType)=>{
        const dependencyIssueLinkType = dependencyIssueLinkTypeById[issueLinkType.id];
        if (dependencyIssueLinkType && !dependencyIssueLinkType.isOutward) return {
            ...issueLinkType,
            outward: issueLinkType.inward,
            inward: issueLinkType.outward
        };
        return issueLinkType;
    });
    return {
        ...rest,
        dependencySettingsInfo: dependencySettingsInfo,
        issueLinkTypesInfo: {
            ...issueLinkTypesInfo,
            issueLinkTypes: remappedIssueLinkTypes
        }
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a25063a5237f2546$export$2e2bcd8739ae039 = (state = $a25063a5237f2546$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $iywPH.SET_SYSTEM_INFO:
            return $a25063a5237f2546$export$534a5ce135e639a(action.payload);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("8FmvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a0584cfa1228a32$export$2e2bcd8739ae039);

var $aF7eA = parcelRequire("aF7eA");
const $2a0584cfa1228a32$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a0584cfa1228a32$export$2e2bcd8739ae039 = (state = $2a0584cfa1228a32$var$initialState, action)=>{
    switch(action.type){
        case 0, $aF7eA.SET:
            {
                const payload = action.payload;
                return [
                    ...payload
                ];
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("7VeEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $55416cd172e7e2a5$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $5rYNM = parcelRequire("5rYNM");

var $6Oj3G = parcelRequire("6Oj3G");
const $55416cd172e7e2a5$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55416cd172e7e2a5$export$2e2bcd8739ae039 = (state = $55416cd172e7e2a5$var$initialState, action)=>{
    switch(action.type){
        case 0, $6Oj3G.ADD:
            return [
                action.payload,
                ...state
            ];
        case 0, $6Oj3G.RESET:
            return [
                ...action.payload
            ];
        case 0, $6Oj3G.REMOVE:
            {
                const removePayload = action.payload;
                if (removePayload.action === 'COMMIT') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return state.filter((team)=>!(removePayload.id === team.id && (team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).DELETED || team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).EXCLUDED)));
                return state.filter((team)=>!(removePayload.id === team.id && (team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED || team.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDEDEXISTING)));
            }
        case 0, $6Oj3G.UPDATE:
            {
                const updatePayload = action.payload;
                return state.map((team)=>{
                    if (team.id === updatePayload.teamId) return {
                        ...team,
                        ...updatePayload.patch
                    };
                    return team;
                });
            }
        case 0, $6Oj3G.UPDATE_RESOURCE:
            {
                const { teamId: teamId, resourceId: resourceId, itemKey: itemKey } = action.payload;
                return state.map((team)=>{
                    if (team.id === teamId) {
                        const resources = team.resources.map((resource)=>{
                            if (resource.itemKey === resourceId) return {
                                ...resource,
                                scenarioType: undefined,
                                values: $01zCq.default(resource.values, resource.originals),
                                originals: {},
                                itemKey: itemKey
                            };
                            return resource;
                        });
                        return {
                            ...team,
                            resources: resources
                        };
                    }
                    return team;
                });
            }
        case 0, $6Oj3G.ADD_MEMBER:
            {
                const payload = action.payload;
                return state.map((team)=>{
                    if (team.id === payload.teamId) return {
                        ...team,
                        resources: [
                            ...team.resources,
                            payload.resource
                        ]
                    };
                    return team;
                });
            }
        case 0, $6Oj3G.REMOVE_MEMBER:
            {
                const payload = action.payload;
                return state.map((team)=>{
                    if (team.id === payload.teamId) {
                        if (payload.resource.scenarioType === (0, $5rYNM.SCENARIO_TYPE).ADDED) return {
                            ...team,
                            resources: team.resources.filter((resource)=>resource.itemKey !== payload.resource.itemKey)
                        };
                        return {
                            ...team,
                            resources: team.resources.map((resource)=>resource.itemKey === payload.resource.itemKey ? {
                                    ...resource,
                                    scenarioType: (0, $5rYNM.SCENARIO_TYPE).DELETED
                                } : resource)
                        };
                    }
                    return team;
                });
            }
        case 0, $6Oj3G.SET_SHARED:
            {
                const { teamId: teamId, externalId: externalId } = action;
                return state.map((team)=>{
                    if (team.id === teamId) return {
                        ...team,
                        externalId: externalId,
                        shareable: true
                    };
                    return team;
                });
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("lHE4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ecf28dd7ed73dc$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $doxJ4 = parcelRequire("doxJ4");

var $5Uqoj = parcelRequire("5Uqoj");

var $3AX2c = parcelRequire("3AX2c");

var $8ycn4 = parcelRequire("8ycn4");

var $kRMHR = parcelRequire("kRMHR");

var $gVmW5 = parcelRequire("gVmW5");

var $3xrUz = parcelRequire("3xrUz");

var $hW6ik = parcelRequire("hW6ik");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$42ecf28dd7ed73dc$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    changes: $3AX2c.default,
    changesWarnings: $5Uqoj.default,
    commit: $8ycn4.default,
    revert: $3xrUz.default,
    hiddenIssues: $kRMHR.default,
    warnings: $hW6ik.default,
    requiredFields: $gVmW5.default,
    changeStatus: $doxJ4.default
});

});
parcelRegister("doxJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $41c69e70acdd553f$export$2e2bcd8739ae039);

var $2oZqS = parcelRequire("2oZqS");
const $41c69e70acdd553f$var$initialState = {
    issueId: '',
    isWaiting: false,
    issueKeyInJira: undefined,
    transitionId: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$41c69e70acdd553f$export$2e2bcd8739ae039 = (state = $41c69e70acdd553f$var$initialState, action)=>{
    switch(action.type){
        case 0, $2oZqS.LOAD:
            return {
                ...state,
                isWaiting: true,
                ...action.payload
            };
        case 0, $2oZqS.CANCEL:
            return {
                ...state,
                isWaiting: false
            };
        case 0, $2oZqS.SUCCESS:
            return {
                ...state,
                isWaiting: false
            };
        case 0, $2oZqS.FAIL:
            return {
                ...state,
                isWaiting: false
            };
        default:
            return state;
    }
};

});

parcelRegister("5Uqoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $beac3d303c81494a$export$2e2bcd8739ae039);

var $itLT6 = parcelRequire("itLT6");

var $9LVH6 = parcelRequire("9LVH6");

var $7SlBO = parcelRequire("7SlBO");

var $5rYNM = parcelRequire("5rYNM");

var $3oWAB = parcelRequire("3oWAB");
const $beac3d303c81494a$var$initialState = {
    [(0, $5rYNM.ENTITY).ISSUE]: {},
    [(0, $5rYNM.ENTITY).RELEASE]: {},
    [(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]: {},
    [(0, $5rYNM.ENTITY).TEAM]: {},
    [(0, $5rYNM.ENTITY).RESOURCE]: {},
    [(0, $5rYNM.ENTITY).SPRINT]: {},
    [(0, $5rYNM.ENTITY).PLANNED_CAPACITY]: {},
    [(0, $5rYNM.ENTITY).NONE]: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$beac3d303c81494a$export$2e2bcd8739ae039 = (state = $beac3d303c81494a$var$initialState, action)=>{
    switch(action.type){
        case 0, $3oWAB.RESET:
            return {
                ...state,
                [action.payload.category]: {}
            };
        case 0, $3oWAB.ADD_BULK:
            return action.payload.reduce((nextState, { category: category, itemId: itemId, warnings: warnings })=>{
                const nextWarnings = (nextState[category][itemId] || []).concat(warnings);
                return $itLT6.default([
                    category,
                    itemId
                ], nextWarnings, nextState);
            }, state);
        case 0, $9LVH6.START:
        case 0, $7SlBO.OPEN_UPDATE_JIRA_DIALOG:
            return $beac3d303c81494a$var$initialState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("3AX2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8696c22d87a83e63$export$2e2bcd8739ae039);


var $fDCVo = parcelRequire("fDCVo");
const $8696c22d87a83e63$var$initialState = {
    status: $2d1ffdf76d206286$export$16250ffd632e517a
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8696c22d87a83e63$export$2e2bcd8739ae039 = (state = $8696c22d87a83e63$var$initialState, action)=>{
    switch(action.type){
        case 0, $fDCVo.SENT:
            return {
                status: $2d1ffdf76d206286$export$26d55645375ca9a
            };
        case 0, $fDCVo.SUCCESS:
            return {
                status: $2d1ffdf76d206286$export$638cc6e36b2a737a,
                data: action.payload
            };
        case 0, $fDCVo.ERROR:
            return {
                status: $2d1ffdf76d206286$export$103bedf43ba882db,
                error: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("8ycn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb621906d0aba1e3$export$2e2bcd8739ae039);

var $9LVH6 = parcelRequire("9LVH6");
const $cb621906d0aba1e3$var$initialState = {
    inProgress: false,
    isInterrupted: false,
    progressStats: {
        numberOfCommittedChanges: 0,
        totalChanges: 0
    },
    changesCommitted: 0
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cb621906d0aba1e3$export$2e2bcd8739ae039 = (state = $cb621906d0aba1e3$var$initialState, action)=>{
    switch(action.type){
        case 0, $9LVH6.START:
            return {
                ...state,
                inProgress: true,
                progressStats: {
                    numberOfCommittedChanges: 0,
                    totalChanges: action.payload
                }
            };
        case 0, $9LVH6.INCREMENT_NUMBER_OF_COMMITTED_CHANGES:
            return {
                ...state,
                progressStats: {
                    ...state.progressStats,
                    numberOfCommittedChanges: state.progressStats.numberOfCommittedChanges + 1
                }
            };
        case 0, $9LVH6.INTERRUPT:
            return {
                ...state,
                isInterrupted: true
            };
        case 0, $9LVH6.STOP:
            return {
                ...state,
                inProgress: false,
                isInterrupted: false,
                progressStats: {
                    ...$cb621906d0aba1e3$var$initialState.progressStats
                },
                changesCommitted: state.progressStats.numberOfCommittedChanges
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kRMHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6020ebc9d7dfe855$export$2e2bcd8739ae039);

var $7WQG5 = parcelRequire("7WQG5");
const $6020ebc9d7dfe855$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6020ebc9d7dfe855$export$2e2bcd8739ae039 = (state = $6020ebc9d7dfe855$var$initialState, action)=>{
    switch(action.type){
        case 0, $7WQG5.RESET:
            return [
                ...action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("gVmW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ff1d249727b3ce$export$2e2bcd8739ae039);

var $264LW = parcelRequire("264LW");
const $46ff1d249727b3ce$var$initialState = {
    isWaiting: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46ff1d249727b3ce$export$2e2bcd8739ae039 = (state = $46ff1d249727b3ce$var$initialState, action)=>{
    switch(action.type){
        case 0, $264LW.LOAD:
            {
                const { issueId: issueId, error: error } = action.payload;
                return {
                    isWaiting: true,
                    issueId: issueId,
                    error: error
                };
            }
        case 0, $264LW.CANCEL:
        case 0, $264LW.SUBMIT:
        case 0, $264LW.FAIL:
            return {
                isWaiting: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("3xrUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ee90f768cc3414$export$2e2bcd8739ae039);

var $cONEK = parcelRequire("cONEK");
const $38ee90f768cc3414$var$initialState = {
    inProgress: false,
    isInterrupted: false,
    progressStats: {
        numberOfRevertedChanges: 0,
        totalChanges: 0
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38ee90f768cc3414$export$2e2bcd8739ae039 = (state = $38ee90f768cc3414$var$initialState, action)=>{
    switch(action.type){
        case 0, $cONEK.START:
            return {
                ...state,
                inProgress: true,
                progressStats: {
                    numberOfRevertedChanges: 0,
                    totalChanges: action.payload
                }
            };
        case 0, $cONEK.INCREMENT_NUMBER_OF_REVERTED_CHANGES:
            return {
                ...state,
                progressStats: {
                    ...state.progressStats,
                    numberOfRevertedChanges: state.progressStats.numberOfRevertedChanges + 1
                }
            };
        case 0, $cONEK.INTERRUPT:
            return {
                ...state,
                isInterrupted: true
            };
        case 0, $cONEK.STOP:
            return {
                inProgress: false,
                isInterrupted: false,
                progressStats: {
                    ...$38ee90f768cc3414$var$initialState.progressStats
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("hW6ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c95fc5330c5cc$export$2e2bcd8739ae039);

var $9LVH6 = parcelRequire("9LVH6");

var $7SlBO = parcelRequire("7SlBO");

var $5rYNM = parcelRequire("5rYNM");

var $eBGH3 = parcelRequire("eBGH3");
const $420c95fc5330c5cc$var$initialState = {
    [(0, $5rYNM.ENTITY).ISSUE]: {},
    [(0, $5rYNM.ENTITY).RELEASE]: {},
    [(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]: {},
    [(0, $5rYNM.ENTITY).TEAM]: {},
    [(0, $5rYNM.ENTITY).RESOURCE]: {},
    [(0, $5rYNM.ENTITY).SPRINT]: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$420c95fc5330c5cc$export$2e2bcd8739ae039 = (state = $420c95fc5330c5cc$var$initialState, action)=>{
    switch(action.type){
        case 0, $eBGH3.ADD:
            {
                const { category: category, itemId: itemId, warnings: warnings } = action.payload;
                return {
                    ...state,
                    [category]: {
                        ...state[category],
                        [itemId]: warnings
                    }
                };
            }
        case 0, $9LVH6.START:
        case 0, $7SlBO.OPEN_UPDATE_JIRA_DIALOG:
            return $420c95fc5330c5cc$var$initialState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("fye2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ddb1feee448c0$export$2e2bcd8739ae039);

var $fKrBu = parcelRequire("fKrBu");
const $a51ddb1feee448c0$var$initialState = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a51ddb1feee448c0$export$2e2bcd8739ae039 = (state = $a51ddb1feee448c0$var$initialState, action)=>{
    switch(action.type){
        case 0, $fKrBu.UPDATE:
            return action.payload;
        default:
            return state;
    }
};

});

parcelRegister("jpD1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0861c47732a19609$export$2e2bcd8739ae039);

var $eN1iE = parcelRequire("eN1iE");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");
var $UCNmJ = parcelRequire("UCNmJ");

var $7uxoA = parcelRequire("7uxoA");
const $0861c47732a19609$var$initialState = {
    userList: []
};
const $0861c47732a19609$export$fff63944c1108d5c = (existingPeople, newPeople)=>{
    const indexedExistingPeople = $eN1iE.default($f7Op5.default('value'), existingPeople);
    const indexedNewPeople = $eN1iE.default($f7Op5.default('value'), newPeople);
    const mergedUsers = {
        ...indexedExistingPeople,
        ...indexedNewPeople
    };
    return $9RbxZ.default((el)=>$701od.default(el.label), $UCNmJ.default(mergedUsers));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0861c47732a19609$export$2e2bcd8739ae039 = (state = $0861c47732a19609$var$initialState, action)=>{
    switch(action.type){
        case 0, $7uxoA.RESET:
            return {
                ...state,
                userList: $0861c47732a19609$export$fff63944c1108d5c(state.userList, action.payload)
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("a7lvN", function(module, exports) {

$parcel$export(module.exports, "RESET", () => $008b1ddd39163400$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $008b1ddd39163400$export$aad8462122ac592b);
const $008b1ddd39163400$export$4a991c87e640ef77 = 'state.domain.version-statuses.RESET';
const $008b1ddd39163400$export$aad8462122ac592b = (payload)=>({
        type: $008b1ddd39163400$export$4a991c87e640ef77,
        payload: payload
    });

});

parcelRegister("xlkYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $960ebcad1466fc31$export$2e2bcd8739ae039);

var $a7lvN = parcelRequire("a7lvN");
const $960ebcad1466fc31$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$960ebcad1466fc31$export$2e2bcd8739ae039 = (state = $960ebcad1466fc31$var$initialState, action)=>{
    switch(action.type){
        case 0, $a7lvN.RESET:
            return [
                ...action.payload
            ];
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("56IuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $45f5646cf79fad61$export$2e2bcd8739ae039);

var $gUZib = parcelRequire("gUZib");
var $aeXAa = parcelRequire("aeXAa");
var $01zCq = parcelRequire("01zCq");

var $8RAUa = parcelRequire("8RAUa");

var $12x9g = parcelRequire("12x9g");
const $45f5646cf79fad61$var$initialState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45f5646cf79fad61$export$2e2bcd8739ae039 = (state = $45f5646cf79fad61$var$initialState, action)=>{
    switch(action.type){
        case 0, $12x9g.RESET:
            return [
                ...action.payload
            ];
        case 0, $12x9g.ADD:
            return [
                ...state,
                action.payload
            ];
        case 0, $12x9g.REMOVE:
            {
                const removedId = action.payload;
                return state.filter(({ id: id })=>id !== removedId);
            }
        case 0, $12x9g.RANK:
            {
                const { payload: { id: id, anchor: anchor } } = action;
                if (anchor === undefined) return state;
                const movedVersionIndex = state.findIndex((issue)=>issue.id === id);
                const anchorVersion = state.find((version)=>version.id === anchor);
                if (!anchorVersion) throw new Error(`Anchor with id ${anchor} not found!`);
                return $gUZib.default(movedVersionIndex, $aeXAa.default('lexoRank', anchorVersion.lexoRank), state);
            }
        case 0, $12x9g.BULK_UPDATE:
            {
                const { payload: payload } = action;
                const result = [];
                for (const item of state){
                    const patch = payload[item.id];
                    if (patch) result.push($01zCq.default(item, patch));
                    else result.push(item);
                }
                return result;
            }
        case 0, $12x9g.UPDATE_REFERENCES:
            return (0, $8RAUa.updateRefs)(state, action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1e5GW", function(module, exports) {

$parcel$export(module.exports, "default", () => $331bc38fbf3244d2$export$2e2bcd8739ae039);

var $aeXAa = parcelRequire("aeXAa");
var $fpul1 = parcelRequire("fpul1");
var $dRoir = parcelRequire("dRoir");
var $kLHvr = parcelRequire("kLHvr");
var $3IGDG = parcelRequire("3IGDG");

var $l4n5f = parcelRequire("l4n5f");


var $i4d9k = parcelRequire("i4d9k");
const $331bc38fbf3244d2$var$initialState = [];
const $331bc38fbf3244d2$var$update = (state, id, updater)=>state.map((view)=>view.id === id ? updater(view) : view);
const $331bc38fbf3244d2$var$reducer = (state = $331bc38fbf3244d2$var$initialState, action)=>{
    switch(action.type){
        case 0, $l4n5f.RESET:
            return action.payload;
        case 0, $l4n5f.SET_ACTIVE_VIEW:
            {
                const { id: viewId } = action.payload;
                return state.map((view)=>$aeXAa.default('active', view.id === viewId)(view));
            }
        case 0, $l4n5f.MARK_AS_DEFAULT_VIEW:
            {
                const { id: viewId } = action.payload;
                // setting all views as NOT default ones
                const nextState = state.map($aeXAa.default('isDefault', false));
                // setting current view as the default one
                return $331bc38fbf3244d2$var$update(nextState, viewId, $dRoir.default({
                    isDefault: true
                }));
            }
        case 0, $l4n5f.ADD_VIEW:
            {
                const newView = action.payload;
                let nextState = state;
                // There should be only 1 default view
                if (newView.isDefault) nextState = nextState.map($aeXAa.default('isDefault', false));
                return [
                    ...nextState,
                    action.payload
                ];
            }
        case 0, $l4n5f.UPDATE_VIEW:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return $331bc38fbf3244d2$var$update(state, action.payload.id, $dRoir.default(action.payload));
        case 0, $l4n5f.MODIFY_VIEW:
            {
                const { id: id, preferences: preferences } = action.payload;
                return $331bc38fbf3244d2$var$update(state, id, (view)=>{
                    const brandNewUpdate = !view.original;
                    return {
                        ...view,
                        preferences: preferences,
                        persisted: brandNewUpdate ? {
                            preferences: preferences
                        } : view.persisted,
                        original: brandNewUpdate && id !== (0, $a5f9f46ec677da8d$export$bbf45675c6d09c28) ? view : view.original,
                        modified: true
                    };
                });
            }
        case 0, $l4n5f.DISCARD_CHANGES:
            {
                const { id: id } = action.payload;
                const view = state.find((one)=>one.id === id);
                if (!view || !view.original) return state;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                return $331bc38fbf3244d2$var$update(state, view.id, (view)=>{
                    if (view.original) return $kLHvr.default(view.original, {
                        modified: false,
                        active: view.active,
                        isDefault: view.isDefault
                    });
                    return view;
                });
            }
        case 0, $l4n5f.SAVE_VIEW:
            {
                const { id: id, version: version, name: name } = action.payload;
                return $331bc38fbf3244d2$var$update(state, id, (viewFromState)=>{
                    let modified = false;
                    let original = null;
                    if (viewFromState.version === version) {
                        modified = viewFromState.modified;
                        original = viewFromState.original;
                    }
                    return $dRoir.default({
                        name: name,
                        version: version,
                        modified: modified,
                        original: original
                    }, viewFromState);
                });
            }
        case 0, $l4n5f.CHANGE_ID:
            {
                const { previous: previous, next: next } = action.payload;
                return $331bc38fbf3244d2$var$update(state, previous, $aeXAa.default('id', next));
            }
        case 0, $l4n5f.REMOVE_VIEW:
            {
                const { id: id } = action.payload;
                return $3IGDG.default($fpul1.default((one)=>one.id !== id), $i4d9k.trySetActiveView)(state);
            }
        default:
            return state;
    }
};
var $331bc38fbf3244d2$export$2e2bcd8739ae039 = $331bc38fbf3244d2$var$reducer;

});
parcelRegister("i4d9k", function(module, exports) {

$parcel$export(module.exports, "trySetActiveView", () => $ee019a85df6d0720$export$5b04e006128dde6e);

var $aeXAa = parcelRequire("aeXAa");
function $ee019a85df6d0720$export$5b04e006128dde6e(state) {
    const hasActive = state.some((one)=>one.active);
    if (hasActive) return state;
    const [nextState] = state.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([acc, set], view)=>{
        if (!set && view.isDefault) {
            const nextView = $aeXAa.default('active', true)(view);
            return [
                [
                    ...acc,
                    nextView
                ],
                true
            ];
        }
        return [
            [
                ...acc,
                view
            ],
            set
        ];
    }, [
        [],
        false
    ]);
    return nextState;
}

});


parcelRegister("e5wZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1958596e60950196$export$2e2bcd8739ae039);

var $bmXiI = parcelRequire("bmXiI");
const $1958596e60950196$export$d4c72bab9d6cc13a = {
    byIssue: {},
    transitiveIssueIds: [],
    allWarningsByIssue: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1958596e60950196$export$2e2bcd8739ae039 = (state = $1958596e60950196$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $bmXiI.SET_WARNINGS:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});


parcelRegister("7vjBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c482d4062c0e24$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $clKfg = parcelRequire("clKfg");

var $8mkxe = parcelRequire("8mkxe");

var $6MFJZ = parcelRequire("6MFJZ");

var $3Cxsl = parcelRequire("3Cxsl");

var $cNDFx = parcelRequire("cNDFx");

var $5nO6r = parcelRequire("5nO6r");

var $4Yj23 = parcelRequire("4Yj23");

var $jRxzi = parcelRequire("jRxzi");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$03c482d4062c0e24$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Top: $4Yj23.default,
    Main: $6MFJZ.default,
    Errors: $8mkxe.default,
    Settings: $5nO6r.default,
    Onboarding: $3Cxsl.default,
    SectionWidths: $cNDFx.default,
    TwpBenefitsModal: // delete this line when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    $jRxzi.default,
    ConfluenceMacro: $clKfg.default
});

});
parcelRegister("clKfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c9e8b01e4164d55$export$2e2bcd8739ae039);

var $5rYNM = parcelRequire("5rYNM");

var $ayiPs = parcelRequire("ayiPs");
const $1c9e8b01e4164d55$var$initialState = {
    confluenceMacroType: (0, $5rYNM.TIMELINE_SHARE_TYPE)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c9e8b01e4164d55$export$2e2bcd8739ae039 = (state = $1c9e8b01e4164d55$var$initialState, action)=>{
    switch(action.type){
        case 0, $ayiPs.SET_CONFLUENCE_MACRO_TYPE:
            return {
                ...state,
                confluenceMacroType: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("8mkxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d642b911a1ecc827$export$2e2bcd8739ae039);

var $01zCq = parcelRequire("01zCq");

var $l7qZG = parcelRequire("l7qZG");
const $d642b911a1ecc827$export$d4c72bab9d6cc13a = {
    errors: [],
    isErrorLogDialogOpen: false,
    isProjectLimitExceeded: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d642b911a1ecc827$export$2e2bcd8739ae039 = (state = $d642b911a1ecc827$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $l7qZG.SHOW_ERROR:
            {
                const { title: title, message: message, stackTrace: stackTrace, details: details, locationHash: locationHash, locationPath: locationPath, description: description } = action.payload;
                return $01zCq.default(state, {
                    errors: [
                        {
                            id: state.errors.length,
                            title: title,
                            message: message,
                            stackTrace: stackTrace,
                            details: details,
                            locationHash: locationHash,
                            locationPath: locationPath,
                            description: description
                        },
                        ...state.errors
                    ]
                });
            }
        case 0, $l7qZG.HIDE_ERROR:
            return $01zCq.default(state, {
                errors: state.errors.slice(1)
            });
        case 0, $l7qZG.HIDE_ALL_ERRORS:
            return $01zCq.default(state, {
                errors: []
            });
        case 0, $l7qZG.SHOW_ERROR_LOG_DIALOG:
            return $01zCq.default(state, {
                isErrorLogDialogOpen: true
            });
        case 0, $l7qZG.HIDE_ERROR_LOG_DIALOG:
            return $01zCq.default(state, {
                isErrorLogDialogOpen: false
            });
        case 0, $l7qZG.SET_IS_PROJECT_LIMIT_EXCEEDED:
            return {
                ...state,
                isProjectLimitExceeded: true
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("6MFJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3463f5154730f8f4$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $gmmE0 = parcelRequire("gmmE0");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$3463f5154730f8f4$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Tabs: $gmmE0.default
});

});
parcelRegister("gmmE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddae486390c43cbc$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $fkvVj = parcelRequire("fkvVj");

var $lmwUm = parcelRequire("lmwUm");

var $fMend = parcelRequire("fMend");

var $83uj7 = parcelRequire("83uj7");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$ddae486390c43cbc$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Roadmap: $fMend.default,
    Releases: $lmwUm.default,
    Teams: $83uj7.default,
    Dependencies: $fkvVj.default
});

});
parcelRegister("fkvVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7f715d71cb3744$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $6fZt2 = parcelRequire("6fZt2");

var $g764T = parcelRequire("g764T");

var $hhhy7 = parcelRequire("hhhy7");

var $7dlGI = parcelRequire("7dlGI");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$2a7f715d71cb3744$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    AddDependency: $6fZt2.default,
    Filters: $g764T.default,
    ReportState: $hhhy7.default,
    StagePosAndScale: $7dlGI.default
});

});
parcelRegister("6fZt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdfe9e133ddd3923$export$2e2bcd8739ae039);

var $7fPss = parcelRequire("7fPss");
const $bdfe9e133ddd3923$var$initialState = {
    show: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdfe9e133ddd3923$export$2e2bcd8739ae039 = (state = $bdfe9e133ddd3923$var$initialState, action)=>{
    switch(action.type){
        case 0, $7fPss.SHOW_ADD_DEPENDENCY:
            return {
                ...state,
                show: true
            };
        case 0, $7fPss.HIDE_ADD_DEPENDENCY:
            return {
                ...state,
                show: false,
                fromIssueId: undefined
            };
        case 0, $7fPss.SHOW_ADD_DEPENDENCY_FROM_ISSUE:
            return {
                ...state,
                show: true,
                fromIssueId: action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("7fPss", function(module, exports) {

$parcel$export(module.exports, "SHOW_ADD_DEPENDENCY", () => $a6fbcdbfc4d2bc82$export$930cb2608d44b969);
$parcel$export(module.exports, "HIDE_ADD_DEPENDENCY", () => $a6fbcdbfc4d2bc82$export$fd6dfcc200390a20);
$parcel$export(module.exports, "SHOW_ADD_DEPENDENCY_FROM_ISSUE", () => $a6fbcdbfc4d2bc82$export$d0f393b30f752ecb);
$parcel$export(module.exports, "showAddDependency", () => $a6fbcdbfc4d2bc82$export$636ddd791d583885);
$parcel$export(module.exports, "hideAddDependency", () => $a6fbcdbfc4d2bc82$export$ff8355cfea6e30e1);
$parcel$export(module.exports, "showAddDependencyFromIssue", () => $a6fbcdbfc4d2bc82$export$4c249c02fe79d5e6);
const $a6fbcdbfc4d2bc82$export$930cb2608d44b969 = 'state.ui.main.tabs.dependencies.addDependency.SHOW_ADD_DEPENDENCY';
const $a6fbcdbfc4d2bc82$export$fd6dfcc200390a20 = 'state.ui.main.tabs.dependencies.addDependency.HIDE_ADD_DEPENDENCY';
const $a6fbcdbfc4d2bc82$export$d0f393b30f752ecb = 'state.ui.main.tabs.dependencies.addDependency.SHOW_ADD_DEPENDENCY_FROM_ISSUE';
const $a6fbcdbfc4d2bc82$export$636ddd791d583885 = ()=>({
        type: $a6fbcdbfc4d2bc82$export$930cb2608d44b969
    });
const $a6fbcdbfc4d2bc82$export$ff8355cfea6e30e1 = ()=>({
        type: $a6fbcdbfc4d2bc82$export$fd6dfcc200390a20
    });
const $a6fbcdbfc4d2bc82$export$4c249c02fe79d5e6 = (id)=>({
        type: $a6fbcdbfc4d2bc82$export$d0f393b30f752ecb,
        payload: id
    });

});


parcelRegister("g764T", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c3d4f809e3a72f$export$2e2bcd8739ae039);

var $2DO1r = parcelRequire("2DO1r");
const $20c3d4f809e3a72f$var$initialState = {
    rollupBy: null,
    rollupHierarchyLevel: -1,
    groupBy: null,
    issueInFocus: null,
    issueFilter: null,
    projectFilter: null,
    sprintFilter: null,
    issueLinkTypeFilter: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$20c3d4f809e3a72f$export$2e2bcd8739ae039 = (state = $20c3d4f809e3a72f$var$initialState, action)=>{
    switch(action.type){
        case 0, $2DO1r.SET_ROLLUP_FILTER:
            return {
                ...state,
                rollupBy: action.payload.rollupBy,
                rollupHierarchyLevel: action.payload.rollupHierarchyLevel,
                issueFilter: null
            };
        case 0, $2DO1r.SET_ISSUE_IN_FOCUS:
            return {
                ...state,
                issueInFocus: action.payload
            };
        case 0, $2DO1r.SET_GROUP_BY:
            return {
                ...state,
                groupBy: action.payload
            };
        case 0, $2DO1r.SET_ISSUE_FILTER:
            return {
                ...state,
                issueFilter: action.payload
            };
        case 0, $2DO1r.SET_PROJECT_FILTER:
            return {
                ...state,
                projectFilter: action.payload
            };
        case 0, $2DO1r.SET_ISSUE_LINK_TYPE_FILTER:
            return {
                ...state,
                issueLinkTypeFilter: action.payload
            };
        case 0, $2DO1r.SET_SPRINT_FILTER:
            return {
                ...state,
                sprintFilter: action.payload
            };
        case 0, $2DO1r.RESET_FILTERS:
            return {
                ...state,
                ...$20c3d4f809e3a72f$var$initialState
            };
        case 0, $2DO1r.INITIATE_FILTERS:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("hhhy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $810b3a21d9e7cd93$export$2e2bcd8739ae039);

var $9N6Ld = parcelRequire("9N6Ld");

var $54dbx = parcelRequire("54dbx");
const $810b3a21d9e7cd93$var$initialState = {
    // Set initial state as loading to prevent flickers
    status: (0, $54dbx.ReportStatus).LOADING
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$810b3a21d9e7cd93$export$2e2bcd8739ae039 = (state = $810b3a21d9e7cd93$var$initialState, action)=>{
    switch(action.type){
        case 0, $9N6Ld.SET_REPORT_STATUS:
            return {
                ...state,
                status: action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("9N6Ld", function(module, exports) {

$parcel$export(module.exports, "SET_REPORT_STATUS", () => $73d1921ce568086c$export$61d1aa0baef12c2d);
$parcel$export(module.exports, "setReportStatus", () => $73d1921ce568086c$export$c708fed96182e84a);
const $73d1921ce568086c$export$61d1aa0baef12c2d = 'state.ui.main.tabs.dependencies.report-state.SET_REPORT_STATUS';
const $73d1921ce568086c$export$c708fed96182e84a = (status)=>({
        type: $73d1921ce568086c$export$61d1aa0baef12c2d,
        payload: status
    });

});

parcelRegister("54dbx", function(module, exports) {

$parcel$export(module.exports, "ReportStatus", () => $62ac8024a2c5e1c8$export$8133a9c5bfc78dc);
const $62ac8024a2c5e1c8$export$8133a9c5bfc78dc = {
    LOADING: 'loading',
    SUCCESS: 'success',
    WARNING: 'warning'
};

});


parcelRegister("7dlGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $07aa6c4a62c49c5e$export$2e2bcd8739ae039);

var $cy9Xg = parcelRequire("cy9Xg");
const $07aa6c4a62c49c5e$var$initialState = {
    x: 0,
    y: 0,
    scale: 1
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07aa6c4a62c49c5e$export$2e2bcd8739ae039 = (state = $07aa6c4a62c49c5e$var$initialState, action)=>{
    switch(action.type){
        case 0, $cy9Xg.SET_STAGE_POSITION_SCALE:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("cy9Xg", function(module, exports) {

$parcel$export(module.exports, "SET_STAGE_POSITION_SCALE", () => $2b05d71358caf6a5$export$3568144dfe0024c2);
$parcel$export(module.exports, "setStagePositionAndScale", () => $2b05d71358caf6a5$export$4cb0c81df7018081);
const $2b05d71358caf6a5$export$3568144dfe0024c2 = 'state.ui.main.tabs.dependencies.stage-position-scale.SET_STAGE_POSITION_SCALE';
const $2b05d71358caf6a5$export$4cb0c81df7018081 = (pos)=>({
        type: $2b05d71358caf6a5$export$3568144dfe0024c2,
        payload: pos
    });

});



parcelRegister("lmwUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4094df3747cdc353$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $GodK7 = parcelRequire("GodK7");

var $4MAQO = parcelRequire("4MAQO");

var $bNOlU = parcelRequire("bNOlU");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$4094df3747cdc353$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    CrossProjectReleases: $GodK7.default,
    ProjectReleases: $bNOlU.default,
    ReleasesFilter: $4MAQO.default
});

});
parcelRegister("GodK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e6442b493a427eb$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $96tk7 = parcelRequire("96tk7");

var $ju1l5 = parcelRequire("ju1l5");

var $jtUD7 = parcelRequire("jtUD7");

var $bjl3i = parcelRequire("bjl3i");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$0e6442b493a427eb$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    ReleaseDialog: $jtUD7.default,
    ReleasesTable: $bjl3i.default,
    AlignDatesDialog: $96tk7.default,
    DeleteReleaseDialog: $ju1l5.default
});

});
parcelRegister("96tk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a480cdc6fc74328$export$2e2bcd8739ae039);

var $iFT7K = parcelRequire("iFT7K");
const $3a480cdc6fc74328$var$initialState = {
    isDialogOpen: false,
    versionId: '',
    isProcessingRequest: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a480cdc6fc74328$export$2e2bcd8739ae039 = (state = $3a480cdc6fc74328$var$initialState, action)=>{
    switch(action.type){
        case 0, $iFT7K.OPEN_DIALOG:
            return {
                ...state,
                isDialogOpen: true,
                versionId: action.versionId
            };
        case 0, $iFT7K.CLOSE_DIALOG:
            return $3a480cdc6fc74328$var$initialState;
        case 0, $iFT7K.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $iFT7K.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("ju1l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $54549fa725624630$export$2e2bcd8739ae039);

var $liE2e = parcelRequire("liE2e");
const $54549fa725624630$var$initialState = {
    isDialogOpen: false,
    versionId: '',
    isProcessingRequest: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54549fa725624630$export$2e2bcd8739ae039 = (state = $54549fa725624630$var$initialState, action)=>{
    switch(action.type){
        case 0, $liE2e.OPEN_DIALOG:
            return {
                ...state,
                isDialogOpen: true,
                versionId: action.versionId
            };
        case 0, $liE2e.CLOSE_DIALOG:
            return $54549fa725624630$var$initialState;
        case 0, $liE2e.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $liE2e.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("jtUD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f642103291984d3$export$2e2bcd8739ae039);

var $ktOon = parcelRequire("ktOon");

const $6f642103291984d3$var$initialState = {
    mode: (0, $1e4d809ca7085b17$export$afecb711a599950a),
    isDialogOpen: false,
    isProcessingRequest: false,
    versionId: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f642103291984d3$export$2e2bcd8739ae039 = (state = $6f642103291984d3$var$initialState, action)=>{
    switch(action.type){
        case 0, $ktOon.SET_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case 0, $ktOon.OPEN_DIALOG:
            {
                const { versionId: versionId } = action.payload;
                return {
                    ...state,
                    isDialogOpen: true,
                    versionId: versionId
                };
            }
        case 0, $ktOon.CLOSE_DIALOG:
            return {
                ...state,
                isDialogOpen: false,
                versionId: null
            };
        case 0, $ktOon.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $ktOon.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bjl3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $7843a523ad3ef505$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $8NKuw = parcelRequire("8NKuw");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$7843a523ad3ef505$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    ProjectReleases: $8NKuw.default
});

});
parcelRegister("8NKuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2539d3f7fb2eff6$export$2e2bcd8739ae039);

var $3S4UF = parcelRequire("3S4UF");
const $c2539d3f7fb2eff6$export$d4c72bab9d6cc13a = {
    isFlyoutOpen: false,
    currentCrossProjectVersionId: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2539d3f7fb2eff6$export$2e2bcd8739ae039 = (state = $c2539d3f7fb2eff6$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $3S4UF.OPEN_FLYOUT:
            return {
                isFlyoutOpen: true,
                currentCrossProjectVersionId: action.payload.crossProjectVersionId
            };
        case 0, $3S4UF.CLOSE_FLYOUT:
            return {
                ...$c2539d3f7fb2eff6$export$d4c72bab9d6cc13a
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("4MAQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d275aa1a147525b$export$2e2bcd8739ae039);

var $40uL7 = parcelRequire("40uL7");
const $3d275aa1a147525b$var$initialState = {
    textFilter: '',
    statusFilter: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d275aa1a147525b$export$2e2bcd8739ae039 = (state = $3d275aa1a147525b$var$initialState, action)=>{
    switch(action.type){
        case 0, $40uL7.SET_TEXT_FILTER:
            return {
                ...state,
                textFilter: action.textFilter
            };
        case 0, $40uL7.SET_STATUS_FILTER:
            return {
                ...state,
                statusFilter: action.statusFilter
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("40uL7", function(module, exports) {

$parcel$export(module.exports, "SET_TEXT_FILTER", () => $fc3b4a1b1e0d9899$export$3ff6c5ed0a39e295);
$parcel$export(module.exports, "SET_STATUS_FILTER", () => $fc3b4a1b1e0d9899$export$fab3161b91e72a41);
$parcel$export(module.exports, "setTextFilter", () => $fc3b4a1b1e0d9899$export$18ecd839459a178a);
$parcel$export(module.exports, "setStatusFilter", () => $fc3b4a1b1e0d9899$export$53079c817c07f5a2);
const $fc3b4a1b1e0d9899$export$3ff6c5ed0a39e295 = 'state.ui.main.tabs.releases.filter.SET_TEXT_FILTER';
const $fc3b4a1b1e0d9899$export$fab3161b91e72a41 = 'state.ui.main.tabs.releases.filter.SET_STATUS_FILTER';
const $fc3b4a1b1e0d9899$export$18ecd839459a178a = (textFilter)=>({
        type: $fc3b4a1b1e0d9899$export$3ff6c5ed0a39e295,
        textFilter: textFilter
    });
const $fc3b4a1b1e0d9899$export$53079c817c07f5a2 = (statusFilter)=>({
        type: $fc3b4a1b1e0d9899$export$fab3161b91e72a41,
        statusFilter: statusFilter
    });

});


parcelRegister("bNOlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc72b919c7f2582$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $4LGSB = parcelRequire("4LGSB");

var $1q6He = parcelRequire("1q6He");

var $ea1YP = parcelRequire("ea1YP");

var $4swEl = parcelRequire("4swEl");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$3fc72b919c7f2582$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    ReleasesTable: $4swEl.default,
    ReleaseDialog: $ea1YP.default,
    DeleteReleaseDialog: $1q6He.default,
    AddToCprDialog: $4LGSB.default
});

});
parcelRegister("4LGSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd498541293d7ecc$export$2e2bcd8739ae039);

var $9aQvf = parcelRequire("9aQvf");
const $cd498541293d7ecc$var$initialState = {
    isDialogOpen: false,
    versionId: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd498541293d7ecc$export$2e2bcd8739ae039 = (state = $cd498541293d7ecc$var$initialState, action)=>{
    switch(action.type){
        case 0, $9aQvf.OPEN_DIALOG:
            return {
                ...state,
                isDialogOpen: true,
                versionId: action.versionId
            };
        case 0, $9aQvf.CLOSE_DIALOG:
            return $cd498541293d7ecc$var$initialState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1q6He", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6f04481633909e$export$2e2bcd8739ae039);

var $8NHMp = parcelRequire("8NHMp");

var $ivdvr = parcelRequire("ivdvr");
const $2b6f04481633909e$var$initialState = {
    mode: (0, $ivdvr.DELETE_RELEASE),
    isDialogOpen: false,
    versionId: '',
    isProcessingRequest: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b6f04481633909e$export$2e2bcd8739ae039 = (state = $2b6f04481633909e$var$initialState, action)=>{
    switch(action.type){
        case 0, $8NHMp.SET_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case 0, $8NHMp.OPEN_DIALOG:
            return {
                ...state,
                isDialogOpen: true,
                versionId: action.versionId
            };
        case 0, $8NHMp.CLOSE_DIALOG:
            return $2b6f04481633909e$var$initialState;
        case 0, $8NHMp.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $8NHMp.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("ea1YP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b12536e1c4d22a$export$2e2bcd8739ae039);

var $boi4O = parcelRequire("boi4O");

const $a7b12536e1c4d22a$var$initialState = {
    mode: (0, $2ca1157acc350995$export$afecb711a599950a),
    isDialogOpen: false,
    projectId: 0,
    isProcessingRequest: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a7b12536e1c4d22a$export$2e2bcd8739ae039 = (state = $a7b12536e1c4d22a$var$initialState, action)=>{
    switch(action.type){
        case 0, $boi4O.SET_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case 0, $boi4O.OPEN_DIALOG:
            {
                const { projectId: projectId, versionId: versionId } = action.payload;
                return {
                    ...state,
                    isDialogOpen: true,
                    projectId: projectId,
                    versionId: versionId
                };
            }
        case 0, $boi4O.CLOSE_DIALOG:
            return {
                ...state,
                projectId: 0,
                versionId: null,
                isDialogOpen: false
            };
        case 0, $boi4O.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $boi4O.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("4swEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f53dc0b50dc3113$export$2e2bcd8739ae039);

var $MrW4M = parcelRequire("MrW4M");
const $2f53dc0b50dc3113$export$d4c72bab9d6cc13a = {
    isRanking: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2f53dc0b50dc3113$export$2e2bcd8739ae039 = (state = $2f53dc0b50dc3113$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $MrW4M.SET_RANKING_STATE:
            return {
                isRanking: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});



parcelRegister("fMend", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1c992a871d0176$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $ixMy4 = parcelRequire("ixMy4");

var $6Gzmr = parcelRequire("6Gzmr");

var $5azO8 = parcelRequire("5azO8");

var $iYkll = parcelRequire("iYkll");

var $5Dy2m = parcelRequire("5Dy2m");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$7a1c992a871d0176$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Fields: $ixMy4.default,
    Scope: $6Gzmr.default,
    Timeline: $5Dy2m.default,
    TimelinePreview: $iYkll.default,
    StickyHeader: $5azO8.default
});

});
parcelRegister("ixMy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4461842f987da7b8$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $lyS0P = parcelRequire("lyS0P");

var $2PCiJ = parcelRequire("2PCiJ");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$4461842f987da7b8$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Assignee: $lyS0P.default,
    CustomFields: $2PCiJ.default
});

});
parcelRegister("lyS0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $019c164ffda2918a$export$2e2bcd8739ae039);

var $bv1hL = parcelRequire("bv1hL");
const $019c164ffda2918a$var$initialState = {
    isFetchAssigneeListInProgress: false,
    issueIdForFetchAssigneeListProgress: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$019c164ffda2918a$export$2e2bcd8739ae039 = (state = $019c164ffda2918a$var$initialState, action)=>{
    switch(action.type){
        case 0, $bv1hL.FETCH_ASSIGNEES_START:
            return {
                isFetchAssigneeListInProgress: true,
                issueIdForFetchAssigneeListProgress: action.payload.issueId
            };
        case 0, $bv1hL.FETCH_ASSIGNEES_STOP:
            return {
                isFetchAssigneeListInProgress: false,
                issueIdForFetchAssigneeListProgress: action.payload.issueId
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("2PCiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ac24038686ace4$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $6QljM = parcelRequire("6QljM");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$72ac24038686ace4$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    UserPicker: $6QljM.default
});

});
parcelRegister("6QljM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d75a153f2a542bc6$export$2e2bcd8739ae039);

var $gCsFH = parcelRequire("gCsFH");
const $d75a153f2a542bc6$var$initialState = {
    isFetchUserListInProgress: false,
    issueId: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d75a153f2a542bc6$export$2e2bcd8739ae039 = (state = $d75a153f2a542bc6$var$initialState, action)=>{
    switch(action.type){
        case 0, $gCsFH.FETCH_USER_START:
            return {
                isFetchUserListInProgress: true,
                issueId: action.payload.issueId
            };
        case 0, $gCsFH.FETCH_USER_STOP:
            return {
                isFetchUserListInProgress: false,
                issueId: action.payload.issueId
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("6Gzmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $13c7dddfc13f8877$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $8Rbhe = parcelRequire("8Rbhe");

var $lxd1S = parcelRequire("lxd1S");

var $8dBXz = parcelRequire("8dBXz");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$13c7dddfc13f8877$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Issues: $8dBXz.default,
    InlineCreate: $lxd1S.default,
    Header: $8Rbhe.default
});

});
parcelRegister("8Rbhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e98e7ab8b6487cbb$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $c28Fs = parcelRequire("c28Fs");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$e98e7ab8b6487cbb$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Search: $c28Fs.default
});

});
parcelRegister("c28Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3967aeea662475f$export$2e2bcd8739ae039);

var $iX8wj = parcelRequire("iX8wj");
const $a3967aeea662475f$var$initialState = {
    activeSearchResultIndex: 1,
    isSearchBoxOpen: false,
    searchQuery: ''
};
const $a3967aeea662475f$var$reducer = (state = $a3967aeea662475f$var$initialState, action)=>{
    switch(action.type){
        case 0, $iX8wj.RESET_SEARCH_RESULTS:
            return $a3967aeea662475f$var$initialState;
        case 0, $iX8wj.SET_ACTIVE_SEARCH_RESULT_INDEX:
            return {
                ...state,
                activeSearchResultIndex: action.payload
            };
        case 0, $iX8wj.SET_SEARCH_QUERY:
            return {
                ...state,
                searchQuery: action.payload
            };
        case 0, $iX8wj.TOGGLE_ISSUE_SEARCH:
            return {
                ...state,
                isSearchBoxOpen: action.payload
            };
        default:
            return state;
    }
};
var $a3967aeea662475f$export$2e2bcd8739ae039 = $a3967aeea662475f$var$reducer;

});


parcelRegister("8dBXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $139c50b56eb09f5f$export$2e2bcd8739ae039);

var $6owOg = parcelRequire("6owOg");

var $fylDL = parcelRequire("fylDL");
const $139c50b56eb09f5f$export$d4c72bab9d6cc13a = {
    selected: new Set(),
    lastSelected: {},
    isLoading: true,
    isLoadingHistory: false,
    isSavingIssue: false
};
const $139c50b56eb09f5f$var$reducer = (state = $139c50b56eb09f5f$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $6owOg.RESET:
            return {
                isLoading: state.isLoading,
                selected: new Set(),
                lastSelected: {},
                isSavingIssue: false,
                isLoadingHistory: false
            };
        case 0, $6owOg.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case 0, $6owOg.SET_IS_LOADING_HISTORY:
            return {
                ...state,
                isLoadingHistory: action.payload
            };
        case 0, $6owOg.SET_IS_SAVING:
            return {
                ...state,
                isSavingIssue: action.payload
            };
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            action;
            return (0, $fylDL.default)(state, action);
    }
};
var $139c50b56eb09f5f$export$2e2bcd8739ae039 = $139c50b56eb09f5f$var$reducer;

});
parcelRegister("fylDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f110eeecd93174cd$export$2e2bcd8739ae039);

var $7CnHa = parcelRequire("7CnHa");

var $5Cso7 = parcelRequire("5Cso7");
const $f110eeecd93174cd$var$reducer = (state, action)=>{
    switch(action.type){
        case 0, $5Cso7.TOGGLE_SELECTED_ISSUES:
            {
                const { payload: { ids: ids, isSelected: isSelected, group: group, toggleAll: toggleAll } } = action;
                if (toggleAll === true) return {
                    ...state,
                    selected: isSelected ? new Set(ids) : new Set(),
                    lastSelected: {}
                };
                const selected = new Set(state.selected);
                for (const id of ids)if (isSelected) selected.add(id);
                else selected.delete(id);
                if ((0, $7CnHa.isDefined)(action.payload.currentIssueId) && ids.length) selected.delete(action.payload.currentIssueId);
                return {
                    ...state,
                    selected: selected,
                    lastSelected: {
                        id: ids.slice(-1)[0],
                        group: group,
                        isSelected: isSelected
                    }
                };
            }
        default:
            return state;
    }
};
var $f110eeecd93174cd$export$2e2bcd8739ae039 = $f110eeecd93174cd$var$reducer;

});



parcelRegister("5azO8", function(module, exports) {

$parcel$export(module.exports, "default", () => $386e12e030befe34$export$2e2bcd8739ae039);

var $gG3rI = parcelRequire("gG3rI");
const $386e12e030befe34$var$initialState = {
    scrollTop: 0
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386e12e030befe34$export$2e2bcd8739ae039 = (state = $386e12e030befe34$var$initialState, action)=>{
    if (action.type === (0, $gG3rI.SET_STICKY_HEADER_SCROLL)) return {
        ...state,
        ...action.payload
    };
    return state;
};

});

parcelRegister("iYkll", function(module, exports) {

$parcel$export(module.exports, "default", () => $581f333b0ac4b686$export$2e2bcd8739ae039);

var $e1ur4 = parcelRequire("e1ur4");
var $7d70y = parcelRequire("7d70y");
var $GanEp = parcelRequire("GanEp");
var $gX20Q = parcelRequire("gX20Q");
var $erwaN = parcelRequire("erwaN");
var $cQGVO = parcelRequire("cQGVO");
var $kpKEz = parcelRequire("kpKEz");
var $eCpJ2 = parcelRequire("eCpJ2");

var $7CnHa = parcelRequire("7CnHa");

var $blSD2 = parcelRequire("blSD2");
function $581f333b0ac4b686$var$update(oldState, issueIds, operation) {
    const op = ([issueId, issue])=>[
            issueId,
            $7d70y.default(issueId, issueIds) ? operation(issue, issueId) : issue
        ];
    const previews = $GanEp.default($cQGVO.default(op, $eCpJ2.default(oldState.previews)));
    return {
        ...oldState,
        previews: previews
    };
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$581f333b0ac4b686$export$2e2bcd8739ae039 = (state = null, action)=>{
    if (action.type === (0, $blSD2.SET_PREVIEW_ISSUES)) {
        const { activeIssueId: activeIssueId, issueAndAncestors: issueAndAncestors, strictDescendents: strictDescendents } = action.payload;
        const previews = $GanEp.default($e1ur4.default($eCpJ2.default(issueAndAncestors), $eCpJ2.default(strictDescendents)));
        const strictAncestorIds = $kpKEz.default($gX20Q.default(activeIssueId), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        $erwaN.default(issueAndAncestors));
        return {
            activeIssueId: activeIssueId,
            strictAncestorIds: strictAncestorIds,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            strictDescendentIds: $erwaN.default(strictDescendents),
            previews: previews
        };
    }
    if (!state) return state;
    switch(action.type){
        case 0, $blSD2.MOVE_ISSUE_AND_DESCENDENTS:
            {
                const { delta: delta, targetStart: targetStart, targetEnd: targetEnd } = action.payload;
                const { strictDescendentIds: strictDescendentIds, activeIssueId: activeIssueId } = state;
                return $581f333b0ac4b686$var$update(state, [
                    ...strictDescendentIds,
                    activeIssueId
                ], (issue, issueId)=>{
                    const shift = (num)=>(0, $7CnHa.isDefined)(num) ? delta + num : undefined;
                    const rest = {
                        ...issue
                    };
                    // The one we are moving will always be set
                    if (issueId === activeIssueId) delete rest.inferred;
                    return {
                        ...rest,
                        baselineStart: shift(issueId === activeIssueId ? targetStart : issue.baselineStart),
                        baselineEnd: shift(issueId === activeIssueId ? targetEnd : issue.baselineEnd)
                    };
                });
            }
        case 0, $blSD2.SET_ISSUES_START:
            {
                const { issueIds: issueIds, baselineStart: baselineStart } = action.payload;
                return $581f333b0ac4b686$var$update(state, issueIds, ({ baselineEnd: baselineEnd, shouldSync: shouldSync, inferred: inferred })=>{
                    const newInferred = inferred;
                    if (newInferred) delete newInferred.baselineStart;
                    return {
                        inferred: newInferred,
                        baselineStart: baselineStart,
                        baselineEnd: baselineEnd,
                        shouldSync: shouldSync
                    };
                });
            }
        case 0, $blSD2.SET_ISSUES_END:
            {
                const { issueIds: issueIds, baselineEnd: baselineEnd } = action.payload;
                return $581f333b0ac4b686$var$update(state, issueIds, ({ baselineStart: baselineStart, shouldSync: shouldSync, inferred: inferred })=>{
                    const newInferred = inferred;
                    if (newInferred) delete newInferred.baselineEnd;
                    return {
                        inferred: newInferred,
                        baselineStart: baselineStart,
                        baselineEnd: baselineEnd,
                        shouldSync: shouldSync
                    };
                });
            }
        case 0, $blSD2.CLEAR_PREVIEW:
            return null;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("gX20Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c573b7b81f20dbbb$export$2e2bcd8739ae039);

var $1eyk6 = parcelRequire("1eyk6");

var $ggdJA = parcelRequire("ggdJA");
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $c573b7b81f20dbbb$var$identical = /*#__PURE__*/ (0, $ggdJA.default)((0, $1eyk6.default));
var $c573b7b81f20dbbb$export$2e2bcd8739ae039 = $c573b7b81f20dbbb$var$identical;

});


parcelRegister("5Dy2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $66bd12acf5b0db67$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $3ISyH = parcelRequire("3ISyH");

var $34Lbv = parcelRequire("34Lbv");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$66bd12acf5b0db67$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    ReleaseBar: $3ISyH.default,
    Schedule: $34Lbv.default
});

});
parcelRegister("3ISyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a784277b1e89236$export$2e2bcd8739ae039);
parcelRequire("97CJW");
var $hvHzx = parcelRequire("hvHzx");

var $kBus3 = parcelRequire("kBus3");
var $c8Rgw = parcelRequire("c8Rgw");

var $5rYNM = parcelRequire("5rYNM");

var $jZUKH = parcelRequire("jZUKH");
const $4a784277b1e89236$export$d4c72bab9d6cc13a = {
    mode: (0, $5rYNM.RELEASE),
    isFlyoutOpen: false,
    versionIds: [],
    prevVersionIds: [],
    highlightedVersionIds: new Set()
};
const $4a784277b1e89236$export$1650419e431d3ba3 = (state = $4a784277b1e89236$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $jZUKH.SET_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case 0, $jZUKH.OPEN_FLYOUT:
            {
                const { mode: mode, versionIds: versionIds } = action.payload;
                return {
                    mode: mode,
                    isFlyoutOpen: true,
                    versionIds: versionIds,
                    highlightedVersionIds: state.highlightedVersionIds
                };
            }
        case 0, $jZUKH.UPDATE_FLYOUT:
            {
                const { mode: mode, versionIds: versionIds, prevVersionIds: prevVersionIds } = action.payload;
                return {
                    ...state,
                    mode: mode,
                    versionIds: versionIds,
                    prevVersionIds: prevVersionIds
                };
            }
        case 0, $jZUKH.CLOSE_FLYOUT:
            return {
                ...state,
                isFlyoutOpen: false
            };
        case 0, $jZUKH.TOGGLE_RELEASE_HIGHLIGHT:
            {
                const { versionId: versionId } = action;
                // TODO need to avoid use Set in the redux, as there are serializability concerns（https://github.com/reduxjs/redux/issues/1499）
                // It is related to https://bulldog.internal.atlassian.com/browse/JPOS-3816
                const highlightedVersionIds = new Set(state.highlightedVersionIds);
                if (highlightedVersionIds.has(versionId)) highlightedVersionIds.delete(versionId);
                else highlightedVersionIds.add(versionId);
                return {
                    ...state,
                    highlightedVersionIds: highlightedVersionIds
                };
            }
        case 0, $jZUKH.RESET_RELEASE_HIGHLIGHTS:
            return {
                ...state,
                highlightedVersionIds: new Set(action.versionIds)
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
// Converting Set to Array when persisted, and back to Set when before putting back to redux store.
const $4a784277b1e89236$var$SetTransform = (0, $hvHzx.default)((highlightedVersionIds)=>[
        ...highlightedVersionIds
    ], (highlightedVersionIds)=>new Set(highlightedVersionIds), {
    whitelist: [
        'highlightedVersionIds'
    ]
});
var $4a784277b1e89236$export$2e2bcd8739ae039 = (0, $c8Rgw.persistReducer)({
    key: (0, $kBus3.getPlanPrefixedKey)('release-bar'),
    whitelist: [
        'highlightedVersionIds'
    ],
    transforms: [
        $4a784277b1e89236$var$SetTransform
    ]
}, $4a784277b1e89236$export$1650419e431d3ba3);

});

parcelRegister("34Lbv", function(module, exports) {

$parcel$export(module.exports, "default", () => $098930e61f4fcbca$export$2e2bcd8739ae039);

var $dYCPN = parcelRequire("dYCPN");
const $098930e61f4fcbca$var$initialState = {
    onlyEnabledIssueId: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$098930e61f4fcbca$export$2e2bcd8739ae039 = (state = $098930e61f4fcbca$var$initialState, action)=>{
    switch(action.type){
        case 0, $dYCPN.ENABLE_ONLY_ISSUE_ID:
            return {
                ...state,
                onlyEnabledIssueId: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});



parcelRegister("83uj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ef754f191f8f4e$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $i3QYL = parcelRequire("i3QYL");

var $2jlz0 = parcelRequire("2jlz0");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$d6ef754f191f8f4e$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    TeamsList: $2jlz0.default,
    CreateTeam: $i3QYL.default
});

});
parcelRegister("i3QYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bf82047e28f5ce$export$2e2bcd8739ae039);

var $28oyV = parcelRequire("28oyV");
const $82bf82047e28f5ce$var$initialState = {
    addedTWPTeamTitle: undefined,
    addedTWPTeamId: undefined,
    isCreateTwpFormLoading: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82bf82047e28f5ce$export$2e2bcd8739ae039 = (state = $82bf82047e28f5ce$var$initialState, action)=>{
    switch(action.type){
        case 0, $28oyV.STORE_ADDED_TWP_TEAM:
            return {
                ...state,
                addedTWPTeamTitle: action.payload.teamTitle,
                addedTWPTeamId: action.payload.teamId
            };
        case 0, $28oyV.RESET_ADDED_TWP_TEAM:
            return {
                ...state,
                addedTWPTeamTitle: undefined,
                addedTWPTeamId: undefined
            };
        case 0, $28oyV.LOAD_CREATE_TWP_FORM:
            return {
                ...state,
                isCreateTwpFormLoading: true
            };
        case 0, $28oyV.RESET_CREATE_TWP_FORM:
            return {
                ...state,
                isCreateTwpFormLoading: false
            };
        default:
            return state;
    }
};

});

parcelRegister("2jlz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a51dc7bfd40d420$export$2e2bcd8739ae039);

var $eeTL3 = parcelRequire("eeTL3");
const $1a51dc7bfd40d420$var$initialState = {
    isDialogOpen: false,
    isProcessingRequest: false,
    showSharedTeamSuccessFlag: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1a51dc7bfd40d420$export$2e2bcd8739ae039 = (state = $1a51dc7bfd40d420$var$initialState, action)=>{
    switch(action.type){
        case 0, $eeTL3.OPEN_TEAMS_DIALOG:
            return {
                ...state,
                ...action.payload,
                isDialogOpen: true
            };
        case 0, $eeTL3.CLOSE_TEAMS_DIALOG:
            return {
                ...state,
                isDialogOpen: false
            };
        case 0, $eeTL3.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $eeTL3.RESET_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        case 0, $eeTL3.SET_MODE:
            return {
                ...state,
                dialogMode: action.payload
            };
        case 0, $eeTL3.SHOW_SHARED_TEAM_SUCCESS_FLAG:
            return {
                ...state,
                showSharedTeamSuccessFlag: action.payload.showSharedTeamSuccessFlag
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("3Cxsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa24c52f4997e822$export$2e2bcd8739ae039);

var $fAVjN = parcelRequire("fAVjN");
const $aa24c52f4997e822$var$initialState = {
    isIntroOpen: false,
    activeCard: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aa24c52f4997e822$export$2e2bcd8739ae039 = (state = $aa24c52f4997e822$var$initialState, action)=>{
    switch(action.type){
        case 0, $fAVjN.SET_ACTIVE_CARD:
            return {
                ...state,
                activeCard: action.payload
            };
        case 0, $fAVjN.SET_INTRO_OPEN:
            return {
                ...state,
                isIntroOpen: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("cNDFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ba50d18e02113b$export$2e2bcd8739ae039);

var $5rYNM = parcelRequire("5rYNM");

const $10ba50d18e02113b$var$initialState = {
    scope: (0, $5rYNM.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH),
    fields: (0, $5rYNM.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH),
    timeline: 0,
    timelineExport: (0, $5rYNM.EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$10ba50d18e02113b$export$2e2bcd8739ae039 = (state = $10ba50d18e02113b$var$initialState, action)=>{
    switch(action.type){
        case 0, $891dfdd01b02bc5d$export$47640bb49c9df5f2:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("5nO6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5077b453963428$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $huQh4 = parcelRequire("huQh4");

var $4YmMK = parcelRequire("4YmMK");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$7f5077b453963428$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    Scenarios: $huQh4.default,
    Views: $4YmMK.default
});

});
parcelRegister("huQh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ce54378f32acf0$export$2e2bcd8739ae039);

var $j9mlP = parcelRequire("j9mlP");
const $57ce54378f32acf0$var$initialState = {
    isModalDialogOpen: false,
    isProcessingRequest: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$57ce54378f32acf0$export$2e2bcd8739ae039 = (state = $57ce54378f32acf0$var$initialState, action)=>{
    switch(action.type){
        case 0, $j9mlP.TOGGLE_SCENARIOS_DIALOG_VISIBILITY:
            return {
                ...state,
                isModalDialogOpen: action.payload
            };
        case 0, $j9mlP.INITIATE_REQUEST:
            return {
                ...state,
                isProcessingRequest: true
            };
        case 0, $j9mlP.COMPLETE_REQUEST:
            return {
                ...state,
                isProcessingRequest: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("4YmMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $76ea63bbea38d263$export$2e2bcd8739ae039);

var $dJ7Td = parcelRequire("dJ7Td");
const $76ea63bbea38d263$var$initialState = {
    renameSaving: false
};
function $76ea63bbea38d263$export$2e2bcd8739ae039(state = $76ea63bbea38d263$var$initialState, action) {
    switch(action.type){
        case 0, $dJ7Td.SET_RENAME_SAVING:
            return {
                ...state,
                renameSaving: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("4Yj23", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc450c71fcd631d4$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $hRVFu = parcelRequire("hRVFu");

var $jFqv0 = parcelRequire("jFqv0");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$cc450c71fcd631d4$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    TitleBar: $hRVFu.default,
    ViewBar: $jFqv0.default
});

});
parcelRegister("hRVFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae95b38716d28a9a$export$2e2bcd8739ae039);

var $l1eW8 = parcelRequire("l1eW8");

var $4zPK4 = parcelRequire("4zPK4");

var $kwtIq = parcelRequire("kwtIq");

var $6zLOa = parcelRequire("6zLOa");

var $1AA7E = parcelRequire("1AA7E");

var $kZdXf = parcelRequire("kZdXf");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$ae95b38716d28a9a$export$2e2bcd8739ae039 = (0, $l1eW8.combineReducers)({
    PlanSettings: $kwtIq.default,
    UpdateJira: $kZdXf.default,
    ShareReport: $6zLOa.default,
    HiddenIssues: $4zPK4.default,
    ToolBar: $1AA7E.default
});

});
parcelRegister("4zPK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb9ec56ff20b3a3$export$2e2bcd8739ae039);

const $6bb9ec56ff20b3a3$var$initialState = {
    isDialogOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6bb9ec56ff20b3a3$export$2e2bcd8739ae039 = (state = $6bb9ec56ff20b3a3$var$initialState, action)=>{
    switch(action.type){
        case 0, $98b7323ecc71747d$export$9d631ffde1befd43:
            return {
                isDialogOpen: true
            };
        case 0, $98b7323ecc71747d$export$b1f17581bba10917:
            return {
                isDialogOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kwtIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc24116e5d26591$export$2e2bcd8739ae039);

var $48HOG = parcelRequire("48HOG");
const $5dc24116e5d26591$var$initialState = {
    planTitle: 'This is a fake plan title',
    planId: 11,
    deleteDialogOpen: false,
    deleteButtonEnabled: true,
    redirectFrom: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dc24116e5d26591$export$2e2bcd8739ae039 = (state = $5dc24116e5d26591$var$initialState, action)=>{
    switch(action.type){
        case 0, $48HOG.SET_DELETE_DIALOG_VISIBILITY:
            return {
                ...state,
                deleteDialogOpen: action.payload
            };
        case 0, $48HOG.REDIRECT_TO_SETTINGS:
            return {
                ...state,
                redirectFrom: action.payload
            };
        case 0, $48HOG.ENABLE_DELETE:
            return {
                ...state,
                deleteButtonEnabled: true
            };
        case 0, $48HOG.DISABLE_DELETE:
            return {
                ...state,
                deleteButtonEnabled: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("6zLOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de7d469e9248f4c$export$2e2bcd8739ae039);

var $5rYNM = parcelRequire("5rYNM");

var $dYuck = parcelRequire("dYuck");
const $2de7d469e9248f4c$var$initialState = {
    isDialogOpen: false,
    isLoading: false,
    url: '',
    shareAs: (0, $5rYNM.SHARE_AS).LINK
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2de7d469e9248f4c$export$2e2bcd8739ae039 = (state = $2de7d469e9248f4c$var$initialState, action)=>{
    switch(action.type){
        case 0, $dYuck.OPEN_SHARE_REPORT_DIALOG:
            return {
                ...state,
                isDialogOpen: true
            };
        case 0, $dYuck.CLOSE_SHARE_REPORT_DIALOG:
            return {
                ...state,
                isDialogOpen: false
            };
        case 0, $dYuck.LOADING_SHARE_REPORT_URL:
            return {
                ...state,
                isLoading: action.payload.isLoading
            };
        case 0, $dYuck.UPDATE_SHARE_REPORT_URL:
            return {
                ...state,
                url: action.payload.url
            };
        case 0, $dYuck.UPDATE_SHARE_AS:
            return {
                ...state,
                shareAs: action.payload.shareAs
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("1AA7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a3bdb2b1235281$export$2e2bcd8739ae039);

var $9G8kJ = parcelRequire("9G8kJ");
const $14a3bdb2b1235281$var$initialState = {
    showToolBar: true
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14a3bdb2b1235281$export$2e2bcd8739ae039 = (state = $14a3bdb2b1235281$var$initialState, action)=>{
    switch(action.type){
        case 0, $9G8kJ.TOGGLE_TOOLBAR:
            return {
                ...state,
                showToolBar: !state.showToolBar
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("kZdXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e95af74a6a3dc0$export$2e2bcd8739ae039);

var $7d70y = parcelRequire("7d70y");
var $5OdRK = parcelRequire("5OdRK");
var $eoUrK = parcelRequire("eoUrK");
var $fpul1 = parcelRequire("fpul1");
var $cQGVO = parcelRequire("cQGVO");
var $01zCq = parcelRequire("01zCq");
var $kpKEz = parcelRequire("kpKEz");

var $9LVH6 = parcelRequire("9LVH6");

var $5rYNM = parcelRequire("5rYNM");

var $7SlBO = parcelRequire("7SlBO");

var $j3zeB = parcelRequire("j3zeB");
const $e5e95af74a6a3dc0$export$d4c72bab9d6cc13a = {
    isDialogOpen: false,
    expandedChanges: {
        [(0, $5rYNM.ENTITY).ISSUE]: [],
        [(0, $5rYNM.ENTITY).RELEASE]: [],
        [(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]: [],
        [(0, $5rYNM.ENTITY).TEAM]: [],
        [(0, $5rYNM.ENTITY).RESOURCE]: [],
        [(0, $5rYNM.ENTITY).SPRINT]: [],
        [(0, $5rYNM.ENTITY).PLANNED_CAPACITY]: [],
        [(0, $5rYNM.ENTITY).NONE]: []
    },
    isCommitWarningFlagClosed: true,
    selectedChanges: {
        [(0, $5rYNM.ENTITY).ISSUE]: [],
        [(0, $5rYNM.ENTITY).RELEASE]: [],
        [(0, $5rYNM.ENTITY).CROSS_PROJECT_RELEASE]: [],
        [(0, $5rYNM.ENTITY).TEAM]: [],
        [(0, $5rYNM.ENTITY).RESOURCE]: [],
        [(0, $5rYNM.ENTITY).SPRINT]: [],
        [(0, $5rYNM.ENTITY).PLANNED_CAPACITY]: [],
        [(0, $5rYNM.ENTITY).NONE]: []
    },
    filters: {
        [(0, $j3zeB.USER_FILTER_ID)]: {
            id: (0, $j3zeB.USER_FILTER_ID),
            value: []
        }
    },
    sortBy: 'lastModified',
    sortDirection: 'ASC',
    shouldNotifyWatchers: true,
    quickSelectOption: (0, $j3zeB.QuickSelectOption).MINE
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e5e95af74a6a3dc0$var$addId = (id)=>(ids)=>{
        const result = new Set(ids);
        result.add(id);
        return Array.from(result);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5e95af74a6a3dc0$export$2e2bcd8739ae039 = (state = $e5e95af74a6a3dc0$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $7SlBO.OPEN_UPDATE_JIRA_DIALOG:
            return {
                ...state,
                isDialogOpen: true,
                isCommitWarningFlagClosed: true
            };
        case 0, $7SlBO.CLOSE_UPDATE_JIRA_DIALOG:
            return {
                ...state,
                isDialogOpen: false
            };
        case 0, $7SlBO.EXPAND_UPDATE_JIRA_DIALOG_CHANGE:
            {
                const { id: id, category: category } = action.payload;
                return $eoUrK.default({
                    expandedChanges: {
                        [category]: $e5e95af74a6a3dc0$var$addId(id)
                    }
                }, state);
            }
        case 0, $7SlBO.COLLAPSE_UPDATE_JIRA_DIALOG_CHANGE:
            {
                const { id: id, category: category } = action.payload;
                return $eoUrK.default({
                    expandedChanges: {
                        [category]: $kpKEz.default($5OdRK.default(id))
                    }
                }, state);
            }
        case 0, $7SlBO.CLOSE_COMMIT_WARNING_FLAG:
        case 0, $9LVH6.START:
            return {
                ...state,
                isCommitWarningFlagClosed: true
            };
        case 0, $9LVH6.STOP:
            return {
                ...state,
                isCommitWarningFlagClosed: false
            };
        case 0, $7SlBO.SELECT_CHANGE:
            {
                const { id: id, category: category } = action.payload;
                return $eoUrK.default({
                    selectedChanges: {
                        [category]: $e5e95af74a6a3dc0$var$addId(id)
                    }
                }, state);
            }
        case 0, $7SlBO.SELECT_ALL_CHANGES:
            return {
                ...state,
                selectedChanges: $01zCq.default(state.selectedChanges, {
                    ...action.payload
                })
            };
        case 0, $7SlBO.DESELECT_CHANGE:
            {
                const { id: id, category: category } = action.payload;
                return $eoUrK.default({
                    selectedChanges: {
                        [category]: $kpKEz.default($5OdRK.default(id))
                    }
                }, state);
            }
        case 0, $7SlBO.DESELECT_ALL_CHANGES:
            return {
                ...state,
                selectedChanges: {
                    ...$e5e95af74a6a3dc0$export$d4c72bab9d6cc13a.selectedChanges
                }
            };
        case 0, $7SlBO.REPLACE_SELECTED_CHANGES:
            return {
                ...state,
                selectedChanges: {
                    ...$e5e95af74a6a3dc0$export$d4c72bab9d6cc13a.selectedChanges,
                    ...action.payload
                }
            };
        case 0, $7SlBO.SORT_CHANGES:
            {
                const { sortBy: sortBy, sortDirection: sortDirection } = action.payload;
                return {
                    ...state,
                    sortBy: sortBy,
                    sortDirection: sortDirection
                };
            }
        case 0, $7SlBO.CHANGE_FILTER:
            {
                const { id: id, value: value, visibleIssueIds: visibleIssueIds } = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const isVisible = (el)=>$7d70y.default(el, visibleIssueIds);
                const result = visibleIssueIds.length ? $cQGVO.default($fpul1.default(isVisible), state.selectedChanges) : state.selectedChanges;
                return {
                    ...state,
                    filters: $01zCq.default(state.filters, {
                        [id]: {
                            id: id,
                            value: value
                        }
                    }),
                    selectedChanges: $01zCq.default(state.selectedChanges, result)
                };
            }
        case 0, $7SlBO.CLEAR_FILTER:
            {
                const id = action.payload;
                return {
                    ...state,
                    filters: {
                        ...state.filters,
                        [id]: {
                            ...$e5e95af74a6a3dc0$export$d4c72bab9d6cc13a.filters[id]
                        }
                    }
                };
            }
        case 0, $7SlBO.UPDATE_NOTIFICATION_PREFERENCE:
            {
                const { shouldNotifyWatchers: shouldNotifyWatchers } = action.payload;
                return {
                    ...state,
                    // We want to default to true if the user has not previously set this user preferences value
                    shouldNotifyWatchers: shouldNotifyWatchers ?? true
                };
            }
        case 0, $7SlBO.CHANGE_QUICK_SELECT:
            return {
                ...state,
                quickSelectOption: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("jFqv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fbbd70b34c4b74d$export$2e2bcd8739ae039);

var $fc0j7 = parcelRequire("fc0j7");
var $5OdRK = parcelRequire("5OdRK");
var $eoUrK = parcelRequire("eoUrK");
var $fpul1 = parcelRequire("fpul1");

var $6zT5O = parcelRequire("6zT5O");
const $0fbbd70b34c4b74d$var$initialState = {
    errors: [],
    saveViewAsDialogStatus: 'CLOSED'
};
function $0fbbd70b34c4b74d$export$2e2bcd8739ae039(state = $0fbbd70b34c4b74d$var$initialState, action) {
    switch(action.type){
        case 0, $6zT5O.ADD_ERROR:
            // @ts-expect-error - TS2349 - This expression is not callable. | TS2344 - Type 'State' does not satisfy the constraint 'Evolver<any>'.
            return $eoUrK.default({
                errors: $fc0j7.default(action.payload)
            })(state);
        case 0, $6zT5O.REMOVE_ERROR:
            // @ts-expect-error - TS2349 - This expression is not callable. | TS2344 - Type 'State' does not satisfy the constraint 'Evolver<any>'.
            return $eoUrK.default({
                errors: $fpul1.default((err)=>!$5OdRK.default(err, action.payload))
            })(state);
        case 0, $6zT5O.SET_SAVE_VIEW_AS_DIALOG_STATUS:
            return {
                ...state,
                saveViewAsDialogStatus: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("jRxzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $081cac27aa963665$export$2e2bcd8739ae039);
// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled

const $081cac27aa963665$var$initialState = {
    isTwpBenefitsModalOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$081cac27aa963665$export$2e2bcd8739ae039 = (state = $081cac27aa963665$var$initialState, action)=>{
    switch(action.type){
        case 0, $b5e6defa10b961e2$export$7270779d12b502c5:
            return {
                ...state,
                isTwpBenefitsModalOpen: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});




parcelRegister("k5P3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5552a08b5dad411d$export$2e2bcd8739ae039);

var $1Szmp = parcelRequire("1Szmp");

var $cTDpS = parcelRequire("cTDpS");

var $2L2I7 = parcelRequire("2L2I7");

var $lihml = parcelRequire("lihml");

var $lNNXV = parcelRequire("lNNXV");

var $fqZyJ = parcelRequire("fqZyJ");
const $5552a08b5dad411d$var$mapDispatchToProps = (dispatch)=>({
        updateIssue: (payload)=>{
            dispatch((0, $1Szmp.updateIssueOrInlineCreate)(payload));
        },
        rankIssue: (payload)=>{
            dispatch((0, $1Szmp.rankIssue)(payload));
        },
        bulkUpdateIssues: (payload)=>{
            dispatch((0, $1Szmp.bulkIssuesUpdate)(payload));
        },
        addIssue: (payload)=>{
            dispatch((0, $1Szmp.addIssue)(payload));
        },
        addIssueLink: (payload)=>{
            dispatch((0, $cTDpS.addIssueLink)(payload));
        },
        removeIssueLink: (payload)=>{
            dispatch((0, $cTDpS.deleteIssueLink)(payload));
        },
        updatePlannedCapacity: (payload)=>{
            dispatch((0, $2L2I7.update)(payload));
        },
        removePlannedCapacity: (payload)=>{
            dispatch((0, $2L2I7.remove)(payload));
        }
    });
const $5552a08b5dad411d$var$mapStateToProps = (state)=>({
        issueTypesById: (0, $lihml.getIssueTypesById)(state)
    });
const $5552a08b5dad411d$var$BridgeEventSubscriber = (0, $lNNXV.connect)($5552a08b5dad411d$var$mapStateToProps, $5552a08b5dad411d$var$mapDispatchToProps)((0, $fqZyJ.default));
var $5552a08b5dad411d$export$2e2bcd8739ae039 = $5552a08b5dad411d$var$BridgeEventSubscriber;

});
parcelRegister("fqZyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5345593f9aff6834$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("5mE9G");
var $yohAn = parcelRequire("yohAn");
var $5mE9G = parcelRequire("5mE9G");
/** subscribe to events from the eventBus using the usePlanBridgeConsumer hook, and call the updateOrInlineCreate action on updateIssue */ const $5345593f9aff6834$var$BridgeEventSubscriberView = ({ updateIssue: updateIssue, rankIssue: rankIssue, bulkUpdateIssues: bulkUpdateIssues, addIssue: addIssue, addIssueLink: addIssueLink, removeIssueLink: removeIssueLink, updatePlannedCapacity: updatePlannedCapacity, removePlannedCapacity: removePlannedCapacity, issueTypesById: issueTypesById })=>{
    const createPayload = (event)=>({
            ...event.payload,
            promise: {
                resolve: event.resolve,
                reject: event.reject
            }
        });
    (0, $eUqFw.useEffect)(()=>{
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).UPDATE_ISSUE, async (event)=>{
            updateIssue(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).RANK_ISSUE, async (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            rankIssue(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).UPDATE_ISSUES, async (event)=>{
            bulkUpdateIssues(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).ADD_ISSUE, async (event)=>{
            const newIssue = event.payload;
            if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && newIssue.level === undefined) {
                const issueType = issueTypesById[Number(newIssue.type)];
                if (issueType) // TODO remove the + 1 when we switch issue levels to the new hierarchy levels to align with Jira https://hello.jira.atlassian.cloud/browse/JPO-27964
                newIssue.level = issueType.level + 1;
            }
            addIssue(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            createPayload({
                ...event,
                payload: {
                    issue: newIssue,
                    skipRanking: true
                }
            }));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).ADD_ISSUE_LINK, async (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            addIssueLink(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).REMOVE_ISSUE_LINK, async (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            removeIssueLink(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).UPDATE_PLANNED_CAPACITY, async (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            updatePlannedCapacity(createPayload(event));
        });
        (0, $5mE9G.default).subscribe((0, $yohAn.BridgeEventValue).REMOVE_PLANNED_CAPACITY, async (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            removePlannedCapacity(createPayload(event));
        });
        (0, $5mE9G.default).ready();
    }, [
        updateIssue,
        rankIssue,
        bulkUpdateIssues,
        addIssue,
        addIssueLink,
        removeIssueLink,
        removePlannedCapacity,
        updatePlannedCapacity,
        issueTypesById
    ]);
    return null;
};
var $5345593f9aff6834$export$2e2bcd8739ae039 = $5345593f9aff6834$var$BridgeEventSubscriberView;

});
parcelRegister("5mE9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fddba046576874ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BridgeEventValue", () => (parcelRequire("yohAn")).BridgeEventValue);

var $yohAn = parcelRequire("yohAn");
class $fddba046576874ab$var$PlanBridge {
    constructor(){
        this.isReady = false;
        this.eventBus = [];
        this.eventHandlers = {};
        this.dispatchBridgeEvent = (eventType, payload)=>{
            const promise = new Promise((resolve, reject)=>{
                this.eventBus.push({
                    type: eventType,
                    payload: payload,
                    resolve: resolve,
                    reject: reject
                });
                if (this.isReady) this.executeEvents();
            });
            return promise;
        };
        this.subscribe = (eventType, handler)=>{
            this.eventHandlers[eventType] = handler;
        };
        this.executeEvents = ()=>{
            const lastEvent = this.eventBus.pop();
            if (lastEvent && this.eventHandlers[lastEvent.type]) try {
                this.eventHandlers[lastEvent.type](lastEvent);
            } catch (e) {
                lastEvent.reject(e);
            }
            if (this.eventBus.length) this.executeEvents();
        };
        this.ready = ()=>{
            this.isReady = true;
            this.executeEvents();
        };
        this.actions = {
            addIssue: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).ADD_ISSUE, payload),
            updateIssue: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).UPDATE_ISSUE, payload),
            rankIssue: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).RANK_ISSUE, payload),
            bulkUpdateIssues: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).UPDATE_ISSUES, payload),
            addIssueLink: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).ADD_ISSUE_LINK, payload),
            removeIssueLink: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).REMOVE_ISSUE_LINK, payload),
            updatePlannedCapacity: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).UPDATE_PLANNED_CAPACITY, payload),
            removePlannedCapacity: (payload)=>this.dispatchBridgeEvent((0, $yohAn.BridgeEventValue).REMOVE_PLANNED_CAPACITY, payload)
        };
    }
}
const $fddba046576874ab$var$planBridge = new $fddba046576874ab$var$PlanBridge();
var $fddba046576874ab$export$2e2bcd8739ae039 = $fddba046576874ab$var$planBridge;

});
parcelRegister("yohAn", function(module, exports) {

$parcel$export(module.exports, "BridgeEventValue", () => $06faa6536c2f276b$export$5e85930ccc594abf);
const $06faa6536c2f276b$export$5e85930ccc594abf = {
    ADD_ISSUE: 0,
    UPDATE_ISSUE: 1,
    UPDATE_ISSUES: 2,
    ADD_ISSUE_LINK: 3,
    REMOVE_ISSUE_LINK: 4,
    RANK_ISSUE: 5,
    UPDATE_PLANNED_CAPACITY: 6,
    REMOVE_PLANNED_CAPACITY: 7
};

});




parcelRegister("iVsy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $378699d1d8615022$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $3QVxF = parcelRequire("3QVxF");

var $cbq3D = parcelRequire("cbq3D");

var $lNNXV = parcelRequire("lNNXV");
const $378699d1d8615022$var$mapDispatchToProps = {
    genericError: $cbq3D.genericError
};
class $378699d1d8615022$var$PortfolioErrorBoundary extends (0, $eUqFw.Component) {
    // eslint-disable-next-line react/sort-comp
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch({ message: message, stack: stackTrace }) {
        this.props.genericError({
            message: message,
            stackTrace: stackTrace,
            shouldReportError: false
        });
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: "portfolio-3.simple-plans.view-error"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QVxF.ErrorPage), {
            error: this.state.error
        }));
        return this.props.children;
    }
}
var $378699d1d8615022$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, $378699d1d8615022$var$mapDispatchToProps)($378699d1d8615022$var$PortfolioErrorBoundary);

});
parcelRegister("3QVxF", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $b93bf23695119d4b$export$c120a0e80fd44ca6);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $ihlUj = parcelRequire("ihlUj");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cgOgM = parcelRequire("cgOgM");

var $lOT6I = parcelRequire("lOT6I");
// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
const $b93bf23695119d4b$var$reloadPage = ()=>window.location.reload(true);
const $b93bf23695119d4b$var$contactSupport = ()=>{
    window.location.href = 'https://support.atlassian.com/contact/';
};
const $b93bf23695119d4b$export$c120a0e80fd44ca6 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let description = formatMessage((0, $lOT6I.default).description);
    if (error) description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihlUj.ErrorHash), {
        error: error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($cgOgM))),
        size: "narrow",
        header: formatMessage((0, $lOT6I.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: $b93bf23695119d4b$var$reloadPage,
            testId: "error-boundary.ui.error-page.primary-action-button"
        }, formatMessage((0, $lOT6I.default).reloadPageButton)),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            onClick: $b93bf23695119d4b$var$contactSupport,
            testId: "error-boundary.ui.error-page.tertiary-action-button"
        }, formatMessage((0, $lOT6I.default).contactSupportButton))
    });
};

});
parcelRegister("ihlUj", function(module, exports) {

$parcel$export(module.exports, "ErrorHash", () => $e823e2ae3cb86cca$export$db1607d938d7ca33);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iH6c1 = parcelRequire("iH6c1");
const $e823e2ae3cb86cca$export$db1607d938d7ca33 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "errors-handling.ui.error-hash"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e823e2ae3cb86cca$var$Wrapper, null, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e823e2ae3cb86cca$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18s8qssn _1yt4u49m _bfhk1s10 _2rko1l7b _ect485st _1wyb16xt _syaz1wmz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cgOgM", function(module, exports) {
module.exports = new URL("error-modal.9d4de729.svg", import.meta.url).toString();

});

parcelRegister("lOT6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae6b4b7d5482e45$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $4ae6b4b7d5482e45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "error-boundary.page.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    },
    header: {
        "id": "error-boundary.page.header",
        "defaultMessage": "Something's gone wrong"
    },
    reloadPageButton: {
        "id": "error-boundary.page.reload-page-button",
        "defaultMessage": "Reload page"
    },
    contactSupportButton: {
        "id": "error-boundary.page.contact-support-button",
        "defaultMessage": "Contact support"
    }
});

});



parcelRegister("3Ff32", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d27fb5c0e7b4f11$export$2e2bcd8739ae039);

var $2240V = parcelRequire("2240V");

var $l7qZG = parcelRequire("l7qZG");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $4N26L = parcelRequire("4N26L");
const $2d27fb5c0e7b4f11$var$mapStateToProps = (0, $iK4oF.createSelector)([
    (0, $2240V.getErrors),
    (0, $2240V.getErrorLogDialogState)
], (errors, isErrorLogDialogOpen)=>({
        errors: errors,
        isErrorLogDialogOpen: isErrorLogDialogOpen
    }));
const $2d27fb5c0e7b4f11$var$mapDispatchToProps = (dispatch)=>({
        hideError: ()=>{
            dispatch((0, $l7qZG.hideError)());
        },
        hideAllErrors: ()=>{
            dispatch((0, $l7qZG.hideAllErrors)());
        },
        showErrorLogDialog: ()=>{
            dispatch((0, $l7qZG.showErrorLogDialog)());
        },
        hideErrorLogDialog: ()=>{
            dispatch((0, $l7qZG.hideErrorLogDialog)());
        }
    });
const $2d27fb5c0e7b4f11$var$ErrorNotification = (0, $lNNXV.connect)($2d27fb5c0e7b4f11$var$mapStateToProps, $2d27fb5c0e7b4f11$var$mapDispatchToProps)((0, $4N26L.default));
var $2d27fb5c0e7b4f11$export$2e2bcd8739ae039 = $2d27fb5c0e7b4f11$var$ErrorNotification;

});
parcelRegister("4N26L", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb54770078dc1337$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $96IgR = parcelRequire("96IgR");

var $8uD7Y = parcelRequire("8uD7Y");

var $cCFSU = parcelRequire("cCFSU");
var $kQ0RL = parcelRequire("kQ0RL");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $Texvm = parcelRequire("Texvm");

var $fnOfj = parcelRequire("fnOfj");

var $ib5d3 = parcelRequire("ib5d3");

var $dE8br = parcelRequire("dE8br");

var $9SqTQ = parcelRequire("9SqTQ");

var $7UrPb = parcelRequire("7UrPb");
const $eb54770078dc1337$var$Description = ({ description: description })=>{
    const emailLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://support.atlassian.com/contact",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "https://support.atlassian.com/contact");
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $7UrPb["email-link"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...description || (0, $9SqTQ.default).errorMessage,
        values: {
            emailLink: emailLink
        }
    })));
};
const $eb54770078dc1337$var$getFlag = ({ id: id, title: title, description: description }, intl)=>({
        id: id,
        title: title || intl.formatMessage((0, $9SqTQ.default).errorTitle),
        appearance: 'error',
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb54770078dc1337$var$Description, {
            description: description
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "Error icon",
            primaryColor: "var(--ds-icon-danger, #FF5630)"
        })
    });
// eslint-disable-next-line jira/react/no-class-components
class $eb54770078dc1337$var$ErrorNotification extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            ViewExperienceFailureTracker: $Texvm.default
        };
    }
    render() {
        // hiding error notifications flags on StoryBook to prevent flakey Cypress tests
        if (window?.STORYBOOK_ENV) return null;
        const { intl: intl, errors: errors, isErrorLogDialogOpen: isErrorLogDialogOpen, showErrorLogDialog: showErrorLogDialog, hideErrorLogDialog: hideErrorLogDialog, ViewExperienceFailureTracker: // eslint-disable-next-line @typescript-eslint/no-shadow
        ViewExperienceFailureTracker } = this.props;
        const actionsSingleError = [
            {
                content: intl.formatMessage((0, $9SqTQ.default).viewLog),
                onClick: showErrorLogDialog
            },
            {
                content: intl.formatMessage((0, $9SqTQ.default).dismiss),
                onClick: this.dismissFlag,
                testId: 'portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag.dismiss-btn'
            }
        ];
        const actions = [
            ...actionsSingleError,
            {
                content: intl.formatMessage((0, $9SqTQ.default).dismissAll),
                onClick: this.dismissAllFlag,
                testId: 'portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag.dismiss-all-btn'
            }
        ];
        const errorOnTop = errors[errors.length - 1];
        let errorDetails;
        let ErrorInfoComponent;
        let ErrorDetailsComponent;
        if (errorOnTop) {
            const errorInfo = {
                title: 'Stack Trace',
                sections: [
                    {
                        title: `${errorOnTop.message}\n\n`,
                        info: errorOnTop.stackTrace || intl.formatMessage((0, $9SqTQ.default).stackTraceNotFoundMessage)
                    }
                ]
            };
            ErrorInfoComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE8br.default), errorInfo);
            if (errorOnTop.details) {
                errorDetails = errorOnTop.details;
                let requestInfoComponent;
                if (errorDetails.requestInfo) {
                    const requestInfo = {
                        title: 'Request Information',
                        sections: [
                            {
                                title: 'Url: ',
                                info: errorDetails.requestInfo.url
                            },
                            {
                                title: 'Type: ',
                                info: errorDetails.requestInfo.type
                            },
                            {
                                title: 'Status: ',
                                info: errorDetails.requestInfo.status
                            },
                            {
                                title: 'Data: ',
                                info: JSON.stringify(errorDetails.requestInfo.body, undefined, 2) || ''
                            }
                        ]
                    };
                    requestInfoComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE8br.default), requestInfo);
                }
                const clientInfo = {
                    title: 'Client Information',
                    sections: [
                        {
                            title: 'User Agent: ',
                            info: errorDetails.clientInfo.userAgent
                        },
                        {
                            title: 'Local Time: ',
                            info: errorDetails.clientInfo.localTime
                        }
                    ]
                };
                const systemInfo = {
                    title: 'System Information',
                    sections: [
                        {
                            title: 'Jira Title: ',
                            info: errorDetails.systemInfo.jiraTitle
                        }
                    ]
                };
                ErrorDetailsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, requestInfoComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE8br.default), clientInfo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dE8br.default), systemInfo));
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceFailureTracker, {
            location: "portfolio-3.simple-plans.state-or-global-error"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
            onDismissed: this.dismissFlag
        }, errors.map((error)=>$eb54770078dc1337$var$getFlag(error, intl)).map((flag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
                actions: errors.length === 1 ? actionsSingleError : actions,
                ...flag,
                key: flag.id,
                testId: "portfolio-3-portfolio.app-simple-plans.error-notification.error-notification-flag"
            }))), isErrorLogDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            onClose: ()=>hideErrorLogDialog(),
            width: "x-large",
            autoFocus: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
            appearance: "danger"
        }, errorOnTop.title || intl.formatMessage((0, $9SqTQ.default).errorTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $7UrPb["error-log"]
        }, ErrorDetailsComponent, ErrorInfoComponent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "danger",
            onClick: ()=>hideErrorLogDialog()
        }, intl.formatMessage((0, $ib5d3.default).cancel)))));
    }
    constructor(...args){
        super(...args);
        this.dismissFlag = ()=>{
            const { hideError: hideError, hideErrorLogDialog: hideErrorLogDialog } = this.props;
            hideErrorLogDialog();
            hideError();
        };
        this.dismissAllFlag = ()=>{
            const { hideAllErrors: hideAllErrors, hideErrorLogDialog: hideErrorLogDialog } = this.props;
            hideErrorLogDialog();
            hideAllErrors();
        };
    }
}
var $eb54770078dc1337$export$2e2bcd8739ae039 = (0, $fnOfj.injectIntlWithDefaultProps)($eb54770078dc1337$var$ErrorNotification);

});
parcelRegister("dE8br", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58613d6c42d637b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtbL6 = parcelRequire("gtbL6");
function $f58613d6c42d637b$export$2e2bcd8739ae039(props) {
    const { title: title, sections: sections } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("pre", {
        className: $gtbL6["error-details"]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h4", null, title), sections.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, section.title), section.info))));
}

});
parcelRegister("gtbL6", function(module, exports) {

$parcel$export(module.exports, "error-details", () => $031822ff3a8bc939$export$270a1f581400e0c9, (v) => $031822ff3a8bc939$export$270a1f581400e0c9 = v);
var $031822ff3a8bc939$export$270a1f581400e0c9;
$031822ff3a8bc939$export$270a1f581400e0c9 = `kevL5G_error-details`;

});


parcelRegister("9SqTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fd1ae2ce4277f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $270fd1ae2ce4277f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.error-message",
        "defaultMessage": "Wait a few seconds, then try again. If this keeps happening, let us know at {emailLink}."
    },
    errorTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.error-title",
        "defaultMessage": "Something went wrong."
    },
    stackTraceNotFoundMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.stack-trace-not-found-message",
        "defaultMessage": "There is no stacktrace available."
    },
    viewLog: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.view-log",
        "defaultMessage": "View Log"
    },
    dismiss: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.dismiss",
        "defaultMessage": "Dismiss"
    },
    dismissAll: {
        "id": "portfolio-3-portfolio.app-simple-plans.error-notification.dismiss-all",
        "defaultMessage": "Dismiss all"
    }
});

});

parcelRegister("7UrPb", function(module, exports) {

$parcel$export(module.exports, "email-link", () => $5c2358c36f44f1fd$export$1ab0abbc0e203d0, (v) => $5c2358c36f44f1fd$export$1ab0abbc0e203d0 = v);
$parcel$export(module.exports, "error-log", () => $5c2358c36f44f1fd$export$9e1a4430890c109, (v) => $5c2358c36f44f1fd$export$9e1a4430890c109 = v);
var $5c2358c36f44f1fd$export$1ab0abbc0e203d0;
var $5c2358c36f44f1fd$export$9e1a4430890c109;
$5c2358c36f44f1fd$export$1ab0abbc0e203d0 = `_8mXQ2q_email-link`;
$5c2358c36f44f1fd$export$9e1a4430890c109 = `_8mXQ2q_error-log`;

});



parcelRegister("lOpTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8647ca9548b49c31$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $lFFlu = parcelRequire("lFFlu");

var $dVfJE = parcelRequire("dVfJE");
var $8647ca9548b49c31$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $lFFlu.default), {})((0, $dVfJE.default));

});
parcelRegister("lFFlu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff7400845c9ae5a3$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");
const $ff7400845c9ae5a3$var$mapStateToProps = (state)=>({
        isLoading: (0, $kwMvv.getIsIssuesLoading)(state)
    });
var $ff7400845c9ae5a3$export$2e2bcd8739ae039 = $ff7400845c9ae5a3$var$mapStateToProps;

});

parcelRegister("dVfJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a184c7f74a8d8858$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("2ZiOh");
var $eJkeb = parcelRequire("eJkeb");
// eslint-disable-next-line jira/react/no-class-components
class $a184c7f74a8d8858$var$ExperienceTracker extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        const { isLoading: isLoading, onExperienceSuccess: onExperienceSuccess } = this.props;
        if (prevProps.isLoading && !isLoading) onExperienceSuccess?.();
    }
    render() {
        return null;
    }
}
var $a184c7f74a8d8858$export$2e2bcd8739ae039 = (0, $eJkeb.default)($a184c7f74a8d8858$var$ExperienceTracker, 'portfolio-3.simple-plans.backlog.request');

});


parcelRegister("gPr41", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a306dba703a48ce$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $ayvFR = parcelRequire("ayvFR");

var $SCIiP = parcelRequire("SCIiP");
var $4a306dba703a48ce$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(null, (0, $ayvFR.default))((0, $SCIiP.ReduxStoreLifecycle));

});
parcelRegister("ayvFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b2c1b8a3d42bd63$export$2e2bcd8739ae039);
parcelRequire("fcaZ5");
var $k8WUU = parcelRequire("k8WUU");
var $fcaZ5 = parcelRequire("fcaZ5");
var $9Nhwa = parcelRequire("9Nhwa");
const $2b2c1b8a3d42bd63$var$mapDispatchToProps = {
    initialLoad: $fcaZ5.initialLoad,
    restoreReduxStore: $9Nhwa.restoreReduxStore,
    resetReduxStore: $9Nhwa.resetReduxStore,
    changeActiveFilterView: $k8WUU.changeActiveFilterView
};
var $2b2c1b8a3d42bd63$export$2e2bcd8739ae039 = $2b2c1b8a3d42bd63$var$mapDispatchToProps;

});

parcelRegister("SCIiP", function(module, exports) {

$parcel$export(module.exports, "ReduxStoreLifecycle", () => $2c5aa08c1c8082d8$export$1fe5fa347ba3315b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $kwMvv = parcelRequire("kwMvv");

var $lPYkK = parcelRequire("lPYkK");

var $2usXM = parcelRequire("2usXM");
const $2c5aa08c1c8082d8$export$1fe5fa347ba3315b = ({ locale: locale, initialLoad: initialLoad, restoreReduxStore: restoreReduxStore, resetReduxStore: resetReduxStore, changeActiveFilterView: changeActiveFilterView, planView: planView })=>{
    const [cachedState, cacheState] = (0, $2usXM.useReduxStateCache)();
    (0, $eUqFw.useEffect)(()=>{
        if (cachedState) {
            try {
                if (!cachedState.domain.plan.id) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.plan-id-not-available', 'Plan id is not available while restoring Redux store state', {
                    loading: (0, $kwMvv.getIsIssuesLoading)(cachedState)
                });
            } catch (err) {
            // not necessary
            }
            restoreReduxStore(cachedState);
            if (planView) changeActiveFilterView(planView);
        } else initialLoad({
            locale: locale,
            planView: planView
        });
    }, [
        cachedState,
        initialLoad,
        locale,
        restoreReduxStore,
        planView,
        changeActiveFilterView
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            const state = (0, $lPYkK.default).getState();
            // Only cache when the plan is done loading
            cacheState((0, $kwMvv.getIsIssuesLoading)(state) ? undefined : state);
            try {
                if (!state.domain.plan.id) (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.plan-id-not-available', 'Plan id is not available while caching Redux store state', {
                    loading: (0, $kwMvv.getIsIssuesLoading)(state)
                });
            } catch (err) {
            // not necessary
            }
        }, [
        cacheState
    ]);
    // Reset the store on unmount to ensure we don't have data
    // of the current plan when switching into another plan.
    (0, $eUqFw.useEffect)(()=>()=>{
            resetReduxStore();
        }, [
        resetReduxStore
    ]);
    return null;
};

});
parcelRegister("2usXM", function(module, exports) {

$parcel$export(module.exports, "useReduxStateCache", () => $6c17de4d7bf697f1$export$624082a1a136a51e);

var $eUqFw = parcelRequire("eUqFw");

var $3HCkE = parcelRequire("3HCkE");

var $drCAA = parcelRequire("drCAA");
const $6c17de4d7bf697f1$export$624082a1a136a51e = ()=>{
    const { data: initialState, update: update } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsReduxStoreStateResource));
    const cacheState = (0, $eUqFw.useCallback)((state)=>{
        update(()=>state);
    }, [
        update
    ]);
    return [
        initialState ?? undefined,
        cacheState
    ];
};

});



parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("4PQoa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $49ca583d40822c1e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ErrorScreen", () => (parcelRequire("kY36r")).ErrorScreen);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $ae4LH = parcelRequire("ae4LH");
parcelRequire("lMyr4");
var $dxrfT = parcelRequire("dxrfT");
parcelRequire("7V92z");
var $gQ3lB = parcelRequire("gQ3lB");

var $3HCkE = parcelRequire("3HCkE");

var $drCAA = parcelRequire("drCAA");

var $fO5rB = parcelRequire("fO5rB");

var $3pQEp = parcelRequire("3pQEp");

var $iPDOm = parcelRequire("iPDOm");

var $6M8Uw = parcelRequire("6M8Uw");

var $ab6rA = parcelRequire("ab6rA");
var $4xHig = parcelRequire("4xHig");

var $kY36r = parcelRequire("kY36r");
const $49ca583d40822c1e$var$PlanView = ()=>{
    const locale = (0, $4xHig.useLocale)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxrfT.default), {
        locale: locale,
        edition: appEditions.software
    });
};
const $49ca583d40822c1e$var$ReportView = ()=>{
    const locale = (0, $4xHig.useLocale)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanReportPageInitialChecksResource));
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxrfT.default), {
        locale: locale,
        edition: appEditions.software
    });
};
const $49ca583d40822c1e$var$ExportView = ()=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: data, loading: loading, error: error } = (0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));
    // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
    if (error?.statusCode === 401) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPDOm.RedirectToLoginPage), null);
    if (loading || data === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ae4LH.default), null);
    if (!data.success) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kY36r.ErrorScreen), {
        errorMessage: data.errorMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQ3lB.default), {
        locale: locale
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$49ca583d40822c1e$export$2e2bcd8739ae039 = ({ viewType: viewType = 'plan' })=>{
    const renderView = ()=>{
        switch(viewType){
            case 'report':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49ca583d40822c1e$var$ReportView, null);
            case 'export':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49ca583d40822c1e$var$ExportView, null);
            case 'plan':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($49ca583d40822c1e$var$PlanView, null);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3pQEp.default), {
        id: "spa-app-bootstrap.advanced-roadmaps-plan"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), renderView()));
};

});
parcelRegister("lMyr4", function(module, exports) {

$parcel$export(module.exports, "PortfolioSimplePlans", () => (parcelRequire("dxrfT")).default);

var $dxrfT = parcelRequire("dxrfT");

});
parcelRegister("dxrfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2389db1d2e88995$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
parcelRequire("buD8w");
parcelRequire("TGJRV");

var $eUqFw = parcelRequire("eUqFw");

var $a5pCl = parcelRequire("a5pCl");
parcelRequire("fcaZ5");
var $9Nhwa = parcelRequire("9Nhwa");

var $lPYkK = parcelRequire("lPYkK");
parcelRequire("032zv");

var $7KQcR = parcelRequire("7KQcR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b2389db1d2e88995$export$2e2bcd8739ae039 = (props)=>{
    const { locale: locale, edition: edition } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (window.location.pathname.includes('PortfolioEmbeddedReportView.jspa') || window.location.pathname.includes('PlanEmbeddedReportView.jspa')) /**
			 * Initializing the BM3 performance instrumentation for legacy page. It starts the
			 * page load and also adds some performance related metadata. The metric is stopped in
			 * src/packages/portfolio-3/portfolio/src/common/analytics/performance.js#L122
			 */ (0, $a5pCl.initBrowserMetrics3)();
        /**
		 * Resetting the redux store while unmounting the application. Please refer to the
		 * detailed explanation provided at
		 * src/packages/portfolio-3/portfolio/src/app-simple-plans/command/index.js#L535
		 */ return function arjAppUnmounted() {
            (0, $lPYkK.default).dispatch((0, $9Nhwa.resetReduxStore)());
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7KQcR.default), {
        locale: locale,
        edition: edition,
        store: (0, $lPYkK.default)
    });
};

});
parcelRegister("buD8w", function(module, exports) {
const $85e0dabc2a35df68$var$style = document.createElement('style');
$85e0dabc2a35df68$var$style.textContent = ":root{--jpo-common-base-spacing:8px;--jpo-common-min-app-width:1000px;--adg3-color-R50:#ffebe6;--adg3-color-R75:#ffbdad;--adg3-color-R100:#ff8f73;--adg3-color-R200:#ff7452;--adg3-color-R300:#ff5630;--adg3-color-R400:#de350b;--adg3-color-R500:#bf2600;--adg3-color-Y50:#fffae6;--adg3-color-Y75:#fff0b3;--adg3-color-Y100:#ffe380;--adg3-color-Y200:#ffc400;--adg3-color-Y300:#ffab00;--adg3-color-Y400:#ff991f;--adg3-color-Y500:#ff8b00;--adg3-color-G50:#e3fcef;--adg3-color-G75:#abf5d1;--adg3-color-G100:#79f2c0;--adg3-color-G200:#57d9a3;--adg3-color-G300:#36b37e;--adg3-color-G400:#00875a;--adg3-color-G500:#064;--adg3-color-B50:#deebff;--adg3-color-B75:#b3d4ff;--adg3-color-B100:#4c9aff;--adg3-color-B200:#2684ff;--adg3-color-B300:#0065ff;--adg3-color-B400:#0052cc;--adg3-color-B500:#0747a6;--adg3-color-P50:#eae6ff;--adg3-color-P75:#c0b6f2;--adg3-color-P100:#998dd9;--adg3-color-P200:#8777d9;--adg3-color-P300:#6554c0;--adg3-color-P400:#5243aa;--adg3-color-P500:#403294;--adg3-color-T50:#e6fcff;--adg3-color-T75:#b3f5ff;--adg3-color-T100:#79e2f2;--adg3-color-T200:#00c7e6;--adg3-color-T300:#00b8d9;--adg3-color-T400:#00a3bf;--adg3-color-T500:#008da6;--adg3-color-N0:#fff;--adg3-color-N10:#fafbfc;--adg3-color-N20:#f4f5f7;--adg3-color-N30:#ebecf0;--adg3-color-N40:#dfe1e6;--adg3-color-N50:#c1c7d0;--adg3-color-N60:#b3bac5;--adg3-color-N70:#a5adba;--adg3-color-N80:#97a0af;--adg3-color-N90:#8993a4;--adg3-color-N100:#7a869a;--adg3-color-N200:#6b778c;--adg3-color-N300:#5e6c84;--adg3-color-N400:#505f79;--adg3-color-N500:#42526e;--adg3-color-N600:#344563;--adg3-color-N700:#253858;--adg3-color-N800:#172b4d;--adg3-color-N900:#091e42;--adg3-color-N10A:#091e4205;--adg3-color-N20A:#091e420a;--adg3-color-N30A:#091e4214;--adg3-color-N40A:#091e4221;--adg3-color-N50A:#091e4240;--adg3-color-N60A:#091e424f;--adg3-color-N70A:#091e425c;--adg3-color-N80A:#091e426b;--adg3-color-N90A:#091e427a;--adg3-color-N100A:#091e428a;--adg3-color-N200A:#091e4299;--adg3-color-N300A:#091e42a8;--adg3-color-N400A:#091e42b5;--adg3-color-N500A:#091e42c4;--adg3-color-N600A:#091e42d1;--adg3-color-N700A:#091e42e3;--adg3-color-N800A:#091e42f2;--adg3-color-DN900:#e6edfa;--adg3-color-DN800:#dce5f5;--adg3-color-DN700:#ced9eb;--adg3-color-DN600:#b8c7e0;--adg3-color-DN500:#abbbd6;--adg3-color-DN400:#9fb0cc;--adg3-color-DN300:#8c9cb8;--adg3-color-DN200:#7988a3;--adg3-color-DN100:#67758f;--adg3-color-DN90:#56637a;--adg3-color-DN80:#455166;--adg3-color-DN70:#3b475c;--adg3-color-DN60:#313d52;--adg3-color-DN50:#283447;--adg3-color-DN40:#202b3d;--adg3-color-DN30:#1b2638;--adg3-color-DN20:#121a29;--adg3-color-DN10:#0e1624;--adg3-color-DN0:#0d1424;--adg3-color-DN800A:#0d14240f;--adg3-color-DN700A:#0d142424;--adg3-color-DN600A:#0d14242e;--adg3-color-DN500A:#0d14244a;--adg3-color-DN400A:#0d14245c;--adg3-color-DN300A:#0d142466;--adg3-color-DN200A:#0d142478;--adg3-color-DN100A:#0d142487;--adg3-color-DN90A:#0d1424a1;--adg3-color-DN80A:#0d1424ba;--adg3-color-DN70A:#0d1424c7;--adg3-color-DN60A:#0d1424cf;--adg3-color-DN50A:#0d1424d9;--adg3-color-DN40A:#0d1424e3;--adg3-color-DN30A:#0d1424eb;--adg3-color-DN20A:#0d1424f2;--adg3-color-DN10A:#0d1424f7;--adg3-color-background-light:#fff;--adg3-color-background-dark:#1b2638;--adg3-color-text-light:#091e42;--adg3-color-text-dark:#b8c7e0;--adg3-color-subtleText-light:#5e6c84;--adg3-color-subtleText-dark:#8c9cb8;--adg3-color-placeholderText-light:#7a869a;--adg3-color-placeholderText-dark:#7988a3;--adg3-color-heading-light:#172b4d;--adg3-color-heading-dark:#b8c7e0;--adg3-color-subtleHeading-light:#5e6c84;--adg3-color-subtleHeading-dark:#8c9cb8;--adg3-color-codeBlock-light:#f4f5f7;--adg3-color-codeBlock-dark:#283447;--adg3-color-link-light:#0052cc;--adg3-color-link-dark:#4c9aff;--adg3-color-linkHover-light:#0065ff;--adg3-color-linkHover-dark:#2684ff;--adg3-color-linkActive-light:#0747a6;--adg3-color-linkActive-dark:#4c9aff;--adg3-color-linkOutline-light:#4c9aff;--adg3-color-linkOutline-dark:#2684ff;--adg3-color-primary-light:#0052cc;--adg3-color-primary-dark:#4c9aff;--adg3-color-blue-light:#0052cc;--adg3-color-blue-dark:#4c9aff;--adg3-color-teal-light:#00b8d9;--adg3-color-teal-dark:#00c7e6;--adg3-color-purple-light:#6554c0;--adg3-color-purple-dark:#998dd9;--adg3-color-red-light:#ff5630;--adg3-color-red-dark:#ff5630;--adg3-color-yellow-light:#ffab00;--adg3-color-yellow-dark:#ffab00;--adg3-color-green-light:#36b37e;--adg3-color-green-dark:#36b37e;--jpo-icon-size-small:16px;--jpo-icon-size-medium:24px;--jpo-icon-size-large:32px;--jpo-icon-size-xlarge:40px;--jpo-toolbar-dropdown-offset:290px;--jira-top-navigation-height:56px;--adg3-color-N20-transparent:#23375f0d;--jpo-spacing:var(--jpo-common-base-spacing);--jpo-theme-color:var(--adg3-color-B400);--jpo-text-default-color:var(--adg3-color-N800);--jpo-text-secondary-color:var(--adg3-color-N200);--jpo-text-muted-color:var(--adg3-color-N70);--jpo-text-error-color:var(--adg3-color-R400);--jpo-bg-default-color:var(--adg3-color-N0);--jpo-bg-reverse-color:var(--adg3-color-N20);--jpo-bg-warning-color:var(--adg3-color-Y50);--jpo-bg-dark-color:var(--adg3-color-N800);--jpo-border-default-color:var(--adg3-color-N50);--jpo-border-secondary-color:var(--adg3-color-N40);--jpo-z-index-date-tooltip:4;--jpo-z-index-dependency-marker-hovered:2;--jpo-z-index-dependency-marker:3;--jpo-z-index-dependency-bar:3;--jpo-z-index-dependency-arrow:3;--jpo-z-index-issue-arrow:3;--jpo-z-index-dependency-handle:10;--jpo-z-index-horizontal-scrolling-overlay:10000}";
document.querySelector('head').appendChild($85e0dabc2a35df68$var$style);

});

parcelRegister("TGJRV", function(module, exports) {
const $0a764a354ec80e0e$var$style = document.createElement('style');
$0a764a354ec80e0e$var$style.textContent = ".ReactVirtualized__Table__headerRow{text-transform:uppercase;flex-direction:row;align-items:center;font-weight:700;display:flex}.ReactVirtualized__Table__row{flex-direction:row;align-items:center;display:flex}.ReactVirtualized__Table__headerTruncatedText{white-space:nowrap;text-overflow:ellipsis;max-width:100%;display:inline-block;overflow:hidden}.ReactVirtualized__Table__headerColumn,.ReactVirtualized__Table__rowColumn{min-width:0;margin-right:10px}.ReactVirtualized__Table__rowColumn{text-overflow:ellipsis;white-space:nowrap}.ReactVirtualized__Table__headerColumn:first-of-type,.ReactVirtualized__Table__rowColumn:first-of-type{margin-left:10px}.ReactVirtualized__Table__sortableHeaderColumn{cursor:pointer}.ReactVirtualized__Table__sortableHeaderIconContainer{align-items:center;display:flex}.ReactVirtualized__Table__sortableHeaderIcon{fill:currentColor;flex:0 0 24px;width:1em;height:1em}";
document.querySelector('head').appendChild($0a764a354ec80e0e$var$style);

});

parcelRegister("032zv", function(module, exports) {
const $009246967d0272d9$var$style = document.createElement('style');
$009246967d0272d9$var$style.textContent = "#page-body>#content{margin-right:0}.arj .ReactVirtualized__Grid,.arj .ReactVirtualized__List,.arj-export-view .ReactVirtualized__Grid,.arj-report-view .ReactVirtualized__Grid,.arj-export-view .ReactVirtualized__List,.arj-report-view .ReactVirtualized__List{will-change:auto!important;overflow:visible!important}.arj .ReactVirtualized__Grid__innerScrollContainer,.arj-export-view .ReactVirtualized__Grid__innerScrollContainer,.arj-report-view .ReactVirtualized__Grid__innerScrollContainer{overflow:visible!important}.releasesTable .ReactVirtualized__Grid,.releasesTable .ReactVirtualized__List,.changesTable .ReactVirtualized__Grid,.changesTable .ReactVirtualized__List{overflow:hidden auto!important}.changesTable .ReactVirtualized__Grid__innerScrollContainer{overflow:hidden!important}.changesTable .ReactVirtualized__Table__rowColumn a:focus-visible,.changesTable .ReactVirtualized__Table__rowColumn button:focus-visible{outline-offset:var(--ds-space-negative-025,-2px);margin:var(--ds-space-0,0px)var(--ds-space-negative-025,-2px);padding:var(--ds-space-025,2px)}";
document.querySelector('head').appendChild($009246967d0272d9$var$style);

});

parcelRegister("7KQcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54aa5ac59f94e07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $iAoTX = parcelRequire("iAoTX");

var $5BRby = parcelRequire("5BRby");

var $9EHc8 = parcelRequire("9EHc8");

var $aR8n6 = parcelRequire("aR8n6");

var $6rW04 = parcelRequire("6rW04");

var $aOINP = parcelRequire("aOINP");
var $lIePH = parcelRequire("lIePH");

var $6Grzy = parcelRequire("6Grzy");

var $fcaZ5 = parcelRequire("fcaZ5");
parcelRequire("dru6o");
var $gNoQI = parcelRequire("gNoQI");

var $296Gg = parcelRequire("296Gg");
parcelRequire("bJc6r");
var $8bnQD = parcelRequire("8bnQD");

var $lPYkK = parcelRequire("lPYkK");

var $l9J5E = parcelRequire("l9J5E");

var $9FyNo = parcelRequire("9FyNo");

var $a4vO3 = parcelRequire("a4vO3");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
parcelRequire("2ZiOh");
var $eJkeb = parcelRequire("eJkeb");

var $gGKRb = parcelRequire("gGKRb");

var $lFLge = parcelRequire("lFLge");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $lNNXV = parcelRequire("lNNXV");

var $eIp1n = parcelRequire("eIp1n");

var $51ACp = parcelRequire("51ACp");

var $jK1pm = parcelRequire("jK1pm");
parcelRequire("cuFEI");
var $iMoOg = parcelRequire("iMoOg");

var $iFYrC = parcelRequire("iFYrC");

var $5GBSS = parcelRequire("5GBSS");

var $irfuL = parcelRequire("irfuL");

var $8lLGC = parcelRequire("8lLGC");

var $4vPWW = parcelRequire("4vPWW");

var $iYRB0 = parcelRequire("iYRB0");
parcelRequire("df4Jn");
var $fsbKr = parcelRequire("fsbKr");

var $bDAY5 = parcelRequire("bDAY5");
parcelRequire("aE4WL");
var $cXr7b = parcelRequire("cXr7b");

var $iVsy4 = parcelRequire("iVsy4");

var $3Ff32 = parcelRequire("3Ff32");

var $75Ete = parcelRequire("75Ete");
const $a54aa5ac59f94e07$var$mapDispatchToProps = {
    initialLoad: $fcaZ5.initialLoad,
    setInitialFilterValues: $296Gg.setInitialFilterValues
};
const $a54aa5ac59f94e07$var$Connected = (0, $eJkeb.default)((0, $lNNXV.connect)(null, $a54aa5ac59f94e07$var$mapDispatchToProps)((0, $75Ete.default)), 'portfolio-3.simple-plans.app');
const $a54aa5ac59f94e07$var$App = ({ locale: locale, edition: edition, store: store })=>{
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * We are adding this special class to 'jira-frontend' div to scope the react virtualized
		 * classes defined in src/app-simple-plans/styles.css. CSS styles for these classes can be found
		 * in many places and we are scoping them all.
		 * When we are in Jira SPA, we can not pollute the global classes and hence we are
		 * scoping them to ARJ application.
		 * We remove the special .arj class once our app is unmounted. Look into the returned function below.
		 */ const JfeRootElement = document.getElementById('jira-frontend');
        if (JfeRootElement) JfeRootElement.classList.add('arj');
        return function removeArjClass() {
            // Remove special .arj class from 'jira-frontend' div.
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const JfeRootElement = document.getElementById('jira-frontend');
            if (JfeRootElement) JfeRootElement.classList.remove('arj');
        };
    }, []);
    const { id: planId, sid: scenarioId } = (0, $lFLge.getPathParams)();
    /**
	 * BEGIN: searchSessionId
	 * When the plan is accessed through the Jira search bar, multiple search parameters are added to the
	 * query including the searchSessionId.
	 * In "src/packages/session-tracker/src/view/index.js#109", these parameters are then striped from the
	 * query params and added to the metadata on the history change. The previous session's metadata is also
	 * cleaned on the history change.
	 * During the SPA, transition the app can get rendered multiple times because of the prop changes in the
	 * SPA parent components. Because of this, the searchSessionId is available during the first render and
	 * gets cleaned after that.
	 * We use searchSessionId to track user's activity. To retain this value, we are using the "useMemo" hook
	 * with the "planId". So until the planId changes, it will not re-read the value and keeps the first value
	 * it read.
	 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    const searchSessionId = (0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-search-session-id'), [
        planId
    ]);
    // END: searchSessionId
    let contextAnalyticsDataAttributes = {
        planId: planId,
        scenarioId: scenarioId,
        context: (0, $6Grzy.context).PLAN
    };
    if ((0, $7CnHa.isDefined)(searchSessionId)) contextAnalyticsDataAttributes = {
        ...contextAnalyticsDataAttributes,
        searchSessionId: searchSessionId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "view-advanced-roadmaps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experience: "viewPortfolio3",
        analyticsSource: "portfolio3",
        application: (0, $eIp1n.JIRA_PORTFOLIO),
        edition: edition,
        additionalAttributes: {
            synthetic: (0, $8bnQD.default)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        store: store,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l9J5E.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "portfolio3",
        attributes: contextAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>store.dispatch((0, $gNoQI.setAnalyticsEvent)(analyticsEvent))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>{
        store.dispatch((0, $gNoQI.setBrowserHistory)(history));
        return null;
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVsy4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).APP,
        packageName: (0, $5rYNM.PACKAGE_NAME),
        teamName: (0, $5rYNM.ERROR_REPORTING_TEAM),
        sendToPrivacyUnsafeSplunk: true
    }, document.body && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ff32.default), null), document.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
        loading: null,
        persistor: (0, $lPYkK.persistor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a54aa5ac59f94e07$var$Connected, {
        locale: locale,
        planId: planId,
        scenarioId: scenarioId
    }))))))))));
};
var $a54aa5ac59f94e07$export$2e2bcd8739ae039 = (0, $a4vO3.provideComponents)({
    FieldSelect: $8lLGC.default,
    FieldPrioritySelect: $irfuL.default,
    FieldMultiSelectCell: $5GBSS.default,
    FieldDatePicker: $iFYrC.default,
    CellSelectWithRollup: $gGKRb.CellSelectWithRollup,
    CellTextField: (0, $lIePH.default),
    AdvancedFieldsMenu: $iMoOg.default,
    FieldUserAvatarCell: $4vPWW.default,
    FilterDependencyGraphFromRoadmap: $fsbKr.default,
    QuickFilter: $cXr7b.default,
    IssueSearchWarningClearFilter: $bDAY5.default,
    NowLine: $9FyNo.default,
    UserPicker: $iYRB0.default
})($a54aa5ac59f94e07$var$App);

});
parcelRegister("dru6o", function(module, exports) {

$parcel$export(module.exports, "setAnalyticsEvent", () => (parcelRequire("gNoQI")).setAnalyticsEvent);
$parcel$export(module.exports, "setBrowserHistory", () => (parcelRequire("gNoQI")).setBrowserHistory);

var $gNoQI = parcelRequire("gNoQI");

});

parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $kJlBc = parcelRequire("kJlBc");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $kJlBc.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("75Ete", function(module, exports) {

$parcel$export(module.exports, "default", () => $5910119acf53cad0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bhLKP = parcelRequire("bhLKP");
var $kFhA9 = parcelRequire("kFhA9");
var $7QNSj = parcelRequire("7QNSj");
var $9MQbY = parcelRequire("9MQbY");
parcelRequire("bJc6r");
var $430Oj = parcelRequire("430Oj");

var $lOpTz = parcelRequire("lOpTz");

var $5AKWJ = parcelRequire("5AKWJ");

var $2A95Z = parcelRequire("2A95Z");

var $8fpC6 = parcelRequire("8fpC6");

var $hNBHk = parcelRequire("hNBHk");

var $5rBQb = parcelRequire("5rBQb");

var $75klB = parcelRequire("75klB");
class $5910119acf53cad0$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onExperienceSuccess: ()=>{}
        };
    }
    componentDidMount() {
        this.initializeApp();
        this.props.onExperienceSuccess && this.props.onExperienceSuccess();
        // Scope this global style to the ARJ package to prevent it leaking into other packages' storybooks
        window.document.body.style.overflowY = 'hidden';
    }
    componentDidUpdate(prevProps) {
        if (this.props.planId !== prevProps.planId || this.props.scenarioId !== prevProps.scenarioId) this.initializeApp();
    }
    componentWillUnmount() {
        // Remove the inline styles
        if (window.document.body.style.overflowY === 'hidden') window.document.body.style.overflowY = '';
    }
    initializeApp() {
        const { locale: locale, initialLoad: initialLoad, setInitialFilterValues: setInitialFilterValues } = this.props;
        initialLoad({
            locale: locale
        });
        setInitialFilterValues();
    }
    render() {
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("main", {
            className: $5rBQb.app,
            "data-name": "ManualPlans"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2A95Z.default), null), (0, $430Oj.default)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75klB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhLKP.default), {
            hashType: "noslash"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kFhA9.default), {
            to: "/plan/backlog",
            from: "/",
            exact: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kFhA9.default), {
            to: "/plan/backlog",
            from: "/backlog",
            exact: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
            path: "/plan",
            component: (0, $8fpC6.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
            path: "/settings",
            component: (0, $hNBHk.default)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AKWJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lOpTz.default), null)));
    }
}

});
parcelRegister("bhLKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8376533ddffe1f80$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $gSncF = parcelRequire("gSncF");

var $bqSCJ = parcelRequire("bqSCJ");
function $8376533ddffe1f80$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8376533ddffe1f80$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8376533ddffe1f80$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $8376533ddffe1f80$var$HashRouter = function(_React$Component) {
    $8376533ddffe1f80$var$_inherits(HashRouter, _React$Component);
    function HashRouter() {
        var _temp, _this, _ret;
        $8376533ddffe1f80$var$_classCallCheck(this, HashRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8376533ddffe1f80$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, $gSncF.createHashHistory)(_this.props), _temp), $8376533ddffe1f80$var$_possibleConstructorReturn(_this, _ret);
    }
    HashRouter.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
    };
    HashRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqSCJ.default), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$8376533ddffe1f80$var$HashRouter.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hashType: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        "hashbang",
        "noslash",
        "slash"
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
var $8376533ddffe1f80$export$2e2bcd8739ae039 = $8376533ddffe1f80$var$HashRouter;

});
parcelRegister("bqSCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $852c7e8f766e6629$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aTrRe = parcelRequire("aTrRe");
var $852c7e8f766e6629$export$2e2bcd8739ae039 = (0, $aTrRe.default);

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});



parcelRegister("kFhA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b5466ff4a4adc2$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $lCIzm = parcelRequire("lCIzm");
var $f0b5466ff4a4adc2$export$2e2bcd8739ae039 = (0, $lCIzm.default);

});
parcelRegister("lCIzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbdfb81ac488d020$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $gSncF = parcelRequire("gSncF");

var $jCQQ5 = parcelRequire("jCQQ5");
var $fbdfb81ac488d020$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $fbdfb81ac488d020$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbdfb81ac488d020$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fbdfb81ac488d020$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $fbdfb81ac488d020$var$Redirect = function(_React$Component) {
    $fbdfb81ac488d020$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $fbdfb81ac488d020$var$_classCallCheck(this, Redirect);
        return $fbdfb81ac488d020$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $gSncF.createLocation)(prevProps.to);
        var nextTo = (0, $gSncF.createLocation)(this.props.to);
        if ((0, $gSncF.locationsAreEqual)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $jCQQ5.default)(to, computedMatch.params);
            else return $fbdfb81ac488d020$var$_extends({}, to, {
                pathname: (0, $jCQQ5.default)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$fbdfb81ac488d020$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    ]).isRequired
};
$fbdfb81ac488d020$var$Redirect.defaultProps = {
    push: false
};
$fbdfb81ac488d020$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    }).isRequired
};
var $fbdfb81ac488d020$export$2e2bcd8739ae039 = $fbdfb81ac488d020$var$Redirect;

});
parcelRegister("jCQQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49a8db050a6777e$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $e49a8db050a6777e$var$patternCache = {};
var $e49a8db050a6777e$var$cacheLimit = 10000;
var $e49a8db050a6777e$var$cacheCount = 0;
var $e49a8db050a6777e$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $e49a8db050a6777e$var$patternCache[cacheKey] || ($e49a8db050a6777e$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1))).compile(pattern);
    if ($e49a8db050a6777e$var$cacheCount < $e49a8db050a6777e$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $e49a8db050a6777e$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $e49a8db050a6777e$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $e49a8db050a6777e$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $e49a8db050a6777e$export$2e2bcd8739ae039 = $e49a8db050a6777e$var$generatePath;

});



parcelRegister("7QNSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7413dcddcdf29e$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $k43p8 = parcelRequire("k43p8");
var $5b7413dcddcdf29e$export$2e2bcd8739ae039 = (0, $k43p8.default);

});
parcelRegister("k43p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b6d266f4833098$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $1d3eD = parcelRequire("1d3eD");
var $e9b6d266f4833098$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e9b6d266f4833098$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9b6d266f4833098$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9b6d266f4833098$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9b6d266f4833098$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e9b6d266f4833098$var$Route = function(_React$Component) {
    $e9b6d266f4833098$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e9b6d266f4833098$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e9b6d266f4833098$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e9b6d266f4833098$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e9b6d266f4833098$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1d3eD.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.render && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e9b6d266f4833098$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$e9b6d266f4833098$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$e9b6d266f4833098$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
$e9b6d266f4833098$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $e9b6d266f4833098$export$2e2bcd8739ae039 = $e9b6d266f4833098$var$Route;

});
parcelRegister("1d3eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1983bddd0ee331$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $0e1983bddd0ee331$var$patternCache = {};
var $0e1983bddd0ee331$var$cacheLimit = 10000;
var $0e1983bddd0ee331$var$cacheCount = 0;
var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $0e1983bddd0ee331$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;

});



parcelRegister("9MQbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $72011505e90bfe2d$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e8LPn = parcelRequire("e8LPn");
var $72011505e90bfe2d$export$2e2bcd8739ae039 = (0, $e8LPn.default);

});
parcelRegister("e8LPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b6e9a2b5461b16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $1d3eD = parcelRequire("1d3eD");
function $a4b6e9a2b5461b16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b6e9a2b5461b16$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4b6e9a2b5461b16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a4b6e9a2b5461b16$var$Switch = function(_React$Component) {
    $a4b6e9a2b5461b16$var$_inherits(Switch, _React$Component);
    function Switch() {
        $a4b6e9a2b5461b16$var$_classCallCheck(this, Switch);
        return $a4b6e9a2b5461b16$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1d3eD.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$a4b6e9a2b5461b16$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
    }).isRequired
};
$a4b6e9a2b5461b16$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $a4b6e9a2b5461b16$export$2e2bcd8739ae039 = $a4b6e9a2b5461b16$var$Switch;

});


parcelRegister("2A95Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac088680da93c5ec$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1b0r2 = parcelRequire("1b0r2");

var $f9P4k = parcelRequire("f9P4k");

var $tGOhy = parcelRequire("tGOhy");
var $ac088680da93c5ec$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $f9P4k.default), (0, $1b0r2.default))((0, $tGOhy.default));

});
parcelRegister("1b0r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b99a9a6146b86a$export$2e2bcd8739ae039);

var $6hfzF = parcelRequire("6hfzF");

var $fAVjN = parcelRequire("fAVjN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$46b99a9a6146b86a$export$2e2bcd8739ae039 = (dispatch)=>({
        setOnBoardingShown: (shown)=>{
            dispatch((0, $fAVjN.setOnBoardingShown)(shown));
        },
        setActiveCard: (activeCard)=>{
            dispatch((0, $fAVjN.setActiveCard)(activeCard));
        },
        setIsIntroOpen: (isOpen)=>{
            dispatch((0, $6hfzF.setIntroOpen)(isOpen));
        }
    });

});

parcelRegister("f9P4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8018f61edfd2528f$export$2e2bcd8739ae039);

var $1MWal = parcelRequire("1MWal");

var $iK4oF = parcelRequire("iK4oF");
const $8018f61edfd2528f$var$querySelector = (0, $iK4oF.createStructuredSelector)({
    activeCard: (0, $1MWal.getActiveCard),
    introOpen: (0, $1MWal.isIntroOpen)
});
var $8018f61edfd2528f$export$2e2bcd8739ae039 = $8018f61edfd2528f$var$querySelector;

});

parcelRegister("tGOhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $801ca122704309f0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $eBkd9 = parcelRequire("eBkd9");
var $aAyrO = parcelRequire("aAyrO");
var $Sibrq = parcelRequire("Sibrq");
var $g4Vkx = parcelRequire("g4Vkx");
var $bbaTG = parcelRequire("bbaTG");
var $kQ0RL = parcelRequire("kQ0RL");
var $lfiOu = parcelRequire("lfiOu");
var $jPr84 = parcelRequire("jPr84");
var $2RVAX = parcelRequire("2RVAX");
var $hJJD2 = parcelRequire("hJJD2");
var $7zpSo = parcelRequire("7zpSo");

var $awiwy = parcelRequire("awiwy");

var $ib5d3 = parcelRequire("ib5d3");

var $joypV = parcelRequire("joypV");

var $4XRr7 = parcelRequire("4XRr7");
// eslint-disable-next-line jira/react/no-class-components
class $801ca122704309f0$var$Onboarding extends (0, $eUqFw.Component) {
    render() {
        const { activeCard: activeCard, intl: intl, introOpen: introOpen, setActiveCard: setActiveCard, setIsIntroOpen: setIsIntroOpen, setOnBoardingShown: setOnBoardingShown } = this.props;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let resultingCards = {};
        const moveNext = ()=>{
            const currentCardIndex = activeCard === '' ? -1 : Object.keys(resultingCards).indexOf(activeCard);
            const nextCard = Object.keys(resultingCards)[currentCardIndex + 1];
            setActiveCard(nextCard);
        };
        const startTour = ()=>{
            setOnBoardingShown(true);
            setIsIntroOpen(false);
            moveNext();
        };
        const skipTour = ()=>{
            setIsIntroOpen(false);
            this.setShowCompleteFlag(true);
            setOnBoardingShown(true);
        };
        const actionsNextButton = [
            {
                onClick: moveNext,
                text: intl.formatMessage((0, $joypV.default).nextButton)
            }
        ];
        const cards = {
            'update-jira': {
                actions: actionsNextButton,
                heading: intl.formatMessage((0, $joypV.default).updateJiraCardTitle),
                dialogPlacement: 'bottom left',
                target: 'update-jira',
                targetBgColor: "var(--ds-surface, white)",
                targetRadius: 3,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $joypV.default).updateJiraCardContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $4XRr7.gutter
                }, intl.formatMessage((0, $joypV.default).updateJiraCardAdditionalContent)))
            },
            'view-tab-switching': {
                actions: [
                    {
                        onClick: moveNext,
                        text: intl.formatMessage((0, $joypV.default).nextButton)
                    },
                    {
                        onClick: ()=>{
                            setActiveCard('');
                            this.setShowCompleteFlag(true);
                        },
                        text: intl.formatMessage((0, $ib5d3.default).learnMore),
                        appearance: 'subtle-link',
                        href: (0, $awiwy.default).URLs.viewSwitching,
                        target: 'blank'
                    }
                ],
                heading: intl.formatMessage((0, $joypV.default).tabSwitchingCardTitle),
                dialogPlacement: 'bottom left',
                target: 'view-tab-switching',
                targetBgColor: "var(--ds-surface, white)",
                content: intl.formatMessage((0, $joypV.default).tabSwitchingCardContent)
            },
            'filters-view-settings': {
                actions: actionsNextButton,
                heading: intl.formatMessage((0, $joypV.default).filtersViewSettingsCardTitle),
                dialogPlacement: 'bottom left',
                target: 'filters-view-settings',
                targetBgColor: "var(--ds-surface, white)",
                content: intl.formatMessage((0, $joypV.default).filtersViewSettingsCardContent)
            },
            'view-actions': {
                actions: actionsNextButton,
                heading: intl.formatMessage((0, $joypV.default).savedViewsDropdownCardTitle),
                dialogPlacement: 'bottom left',
                target: 'view-actions',
                targetBgColor: "var(--ds-surface, white)",
                content: intl.formatMessage((0, $joypV.default).savedViewsDropdownCardContent)
            },
            scope: {
                actions: actionsNextButton,
                heading: intl.formatMessage((0, $joypV.default).scopeCardTitle),
                dialogPlacement: 'right top',
                target: 'scope',
                targetBgColor: "var(--ds-surface, white)",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $joypV.default).scopeCardContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $4XRr7.gutter
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $joypV.default).scopeCardAdditionalContent,
                    values: {
                        link: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                            className: $4XRr7.hierarchyLink,
                            href: (0, $awiwy.default).URLs.gettingStarted
                        }, intl.formatMessage((0, $joypV.default).scopeCardAdditionalContentHierarchyLink))
                    }
                })))
            },
            fields: {
                actions: actionsNextButton,
                heading: intl.formatMessage((0, $joypV.default).fieldsCardTitle),
                dialogPlacement: 'left top',
                target: 'fields',
                targetBgColor: "var(--ds-surface, white)",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $joypV.default).fieldsCardContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $4XRr7.gutter
                }, intl.formatMessage((0, $joypV.default).fieldsCardAdditionalContent)))
            },
            timeline: {
                actions: [
                    {
                        onClick: ()=>{
                            setActiveCard('');
                            this.setShowCompleteFlag(true);
                        },
                        text: intl.formatMessage((0, $joypV.default).finishButton)
                    }
                ],
                heading: intl.formatMessage((0, $joypV.default).timelineCardTitle),
                dialogPlacement: 'right top',
                target: 'timeline',
                targetBgColor: "var(--ds-surface, white)",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $joypV.default).timelineCardContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $4XRr7.gutter
                }, intl.formatMessage((0, $joypV.default).timelineCardAdditionalContent)))
            }
        };
        resultingCards = cards;
        const activeCardIndex = Object.keys(resultingCards).indexOf(activeCard);
        const activeCardComponent = resultingCards[activeCard];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, introOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose: ()=>{},
            shouldCloseOnOverlayClick: false,
            shouldCloseOnEscapePress: false,
            testId: "portfolio-3-portfolio.app-simple-plans.onboarding.benefits-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4XRr7.dialogContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4XRr7.banner
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4XRr7.dialogInnerContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4XRr7.contentHeader
        }, intl.formatMessage((0, $joypV.default).plansWelcomeModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            className: $4XRr7.contentText
        }, intl.formatMessage((0, $joypV.default).plansWelcomeModalContentSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $4XRr7.buttonBar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "subtle",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $4XRr7.skipButton,
            onClick: skipTour,
            testId: "portfolio-3-portfolio.app-simple-plans.onboarding.skip-tour"
        }, intl.formatMessage((0, $joypV.default).welcomeModalSkipTour)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Sibrq.default).Provider, {
            value: (0, $jPr84.modalButtonTheme)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            appearance: "primary",
            onClick: startTour,
            testId: "portfolio-3-portfolio.app-simple-plans.onboarding.get-started"
        }, intl.formatMessage((0, $joypV.default).welcomeModalGetStarted)))))))), this.state.showCompleteFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.FlagGroup), {
            onDismissed: ()=>{
                this.setShowCompleteFlag(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBkd9.default), {
            id: "portfolio-3-app-simple-plans.onboarding-success",
            title: intl.formatMessage((0, $joypV.default).doneFlagTitle),
            description: intl.formatMessage((0, $joypV.default).plansDoneFlagContent),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
                label: "",
                primaryColor: `var(--ds-icon-success, ${(0, $g4Vkx.default).G300})`
            }),
            actions: [
                {
                    content: (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                            href: (0, $awiwy.default).URLs.gettingStarted
                        }, intl.formatMessage((0, $joypV.default).doneFlagViewDocumentationLink)),
                        appearance: "link",
                        spacing: "none"
                    }, intl.formatMessage((0, $joypV.default).doneFlagViewDocumentationLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                        href: (0, $awiwy.default).URLs.gettingStarted
                    }, intl.formatMessage((0, $joypV.default).doneFlagViewDocumentationLink))
                }
            ],
            testId: "portfolio-3-portfolio.app-simple-plans.onboarding.success-flag"
        })), activeCardComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
            heading: activeCardComponent.heading,
            actions: activeCardComponent.actions,
            dialogPlacement: activeCardComponent.dialogPlacement,
            target: activeCardComponent.target,
            targetBgColor: activeCardComponent.targetBgColor,
            targetRadius: activeCardComponent.targetRadius,
            dialogWidth: 300,
            actionsBeforeElement: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $4XRr7.steps
            }, `${activeCardIndex + 1}/${Object.keys(resultingCards).length}`),
            testId: `portfolio-3-portfolio.app-simple-plans.onboarding.spotlight-card-${activeCardIndex + 1}`
        }, activeCardComponent.content)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            showCompleteFlag: false
        };
        this.setShowCompleteFlag = (showCompleteFlag)=>{
            this.setState({
                showCompleteFlag: showCompleteFlag
            });
        };
    }
}
var $801ca122704309f0$export$2e2bcd8739ae039 = (0, $2qhQi.default)($801ca122704309f0$var$Onboarding);

});
parcelRegister("joypV", function(module, exports) {

$parcel$export(module.exports, "default", () => $43dee8bb5003a6b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $43dee8bb5003a6b3$var$messages = (0, $90IgZ.defineMessages)({
    plansWelcomeModalTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.plans-welcome-modal-title",
        "defaultMessage": "Welcome to Plans"
    },
    plansWelcomeModalContentSpork: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.plans-welcome-modal-content-spork",
        "defaultMessage": "Plans is designed to help you ship larger pieces of work faster and more reliably by building smarter plans. Get visibility into work happening across Jira, track dependencies across teams, plan with team capacity in mind, and communicate status across your organization."
    },
    welcomeModalSkipTour: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.welcome-modal-skip-tour",
        "defaultMessage": "Skip tour"
    },
    welcomeModalGetStarted: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.welcome-modal-get-started",
        "defaultMessage": "Get started"
    },
    nextButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.next-button",
        "defaultMessage": "Next"
    },
    finishButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.finish-button",
        "defaultMessage": "Got it"
    },
    updateJiraCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-title",
        "defaultMessage": "Saving changes"
    },
    updateJiraCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-content",
        "defaultMessage": "Any changes you make are automatically kept here until you're ready to save them to Jira."
    },
    updateJiraCardAdditionalContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-additional-content",
        "defaultMessage": "If changes are no longer needed, you can easily discard them."
    },
    scopeCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-title",
        "defaultMessage": "Manage your issues"
    },
    scopeCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-content",
        "defaultMessage": "Issues within this plan will appear in the scope section."
    },
    scopeCardAdditionalContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-additional-content",
        "defaultMessage": "Here you can create new issues, rank issues by dragging them up or down, and organize issues into {link}."
    },
    scopeCardAdditionalContentHierarchyLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-additional-content-hierarchy-link",
        "defaultMessage": "hierarchy levels"
    },
    fieldsCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-title",
        "defaultMessage": "Edit issues"
    },
    fieldsCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-content",
        "defaultMessage": "Make changes to your issues in the fields section."
    },
    fieldsCardAdditionalContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-additional-content",
        "defaultMessage": "Need more fields? Click on the Fields > button to show and hide fields such as team, dependencies, estimate, custom fields, and more."
    },
    timelineCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-title",
        "defaultMessage": "Visualize dates"
    },
    timelineCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-content",
        "defaultMessage": "See when issues and releases are scheduled in the timeline."
    },
    timelineCardAdditionalContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-additional-content",
        "defaultMessage": "To show an issue on the timeline simply drag and drop, or set date fields."
    },
    doneFlagTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.done-flag-title",
        "defaultMessage": "Happy planning!"
    },
    plansDoneFlagContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.plans-done-flag-content",
        "defaultMessage": "For more information on how to get started with Plans, check out our latest documentation."
    },
    doneFlagViewDocumentationLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.done-flag-view-documentation-link",
        "defaultMessage": "View documentation"
    },
    filtersViewSettingsCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.filters-view-settings-card-title",
        "defaultMessage": "Customize your roadmap"
    },
    filtersViewSettingsCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.filters-view-settings-card-content",
        "defaultMessage": "Choose which issues to show in your plan using filters, then decide how they\u2019re displayed using the View settings menu."
    },
    tabSwitchingCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.tab-switching-card-title",
        "defaultMessage": "View plan information"
    },
    tabSwitchingCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.tab-switching-card-content",
        "defaultMessage": "Navigate between the Roadmap view, teams and releases included in your plan, and the dependencies report."
    },
    savedViewsDropdownCardTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.saved-views-dropdown-card-title",
        "defaultMessage": "Create and switch views"
    },
    savedViewsDropdownCardContent: {
        "id": "portfolio-3-portfolio.app-simple-plans.onboarding.saved-views-dropdown-card-content",
        "defaultMessage": "Save your current filters and settings as a view that can later be recalled. You can also switch between the different views based on what information you wish to highlight."
    }
});
var $43dee8bb5003a6b3$export$2e2bcd8739ae039 = $43dee8bb5003a6b3$var$messages;

});

parcelRegister("4XRr7", function(module, exports) {

$parcel$export(module.exports, "banner", () => $39d61f7a254e4080$export$bb5ee47d9ea2348e, (v) => $39d61f7a254e4080$export$bb5ee47d9ea2348e = v);
$parcel$export(module.exports, "buttonBar", () => $39d61f7a254e4080$export$b004c9847a75de92, (v) => $39d61f7a254e4080$export$b004c9847a75de92 = v);
$parcel$export(module.exports, "contentHeader", () => $39d61f7a254e4080$export$d7dc7be08229f0b2, (v) => $39d61f7a254e4080$export$d7dc7be08229f0b2 = v);
$parcel$export(module.exports, "contentText", () => $39d61f7a254e4080$export$25461e9eb43d56b4, (v) => $39d61f7a254e4080$export$25461e9eb43d56b4 = v);
$parcel$export(module.exports, "dialogContent", () => $39d61f7a254e4080$export$1a09c8e9a482a512, (v) => $39d61f7a254e4080$export$1a09c8e9a482a512 = v);
$parcel$export(module.exports, "dialogInnerContent", () => $39d61f7a254e4080$export$29ce79ff6c68f3e5, (v) => $39d61f7a254e4080$export$29ce79ff6c68f3e5 = v);
$parcel$export(module.exports, "gutter", () => $39d61f7a254e4080$export$f2b922cb4a245974, (v) => $39d61f7a254e4080$export$f2b922cb4a245974 = v);
$parcel$export(module.exports, "hierarchyLink", () => $39d61f7a254e4080$export$824ed78f362d2f0f, (v) => $39d61f7a254e4080$export$824ed78f362d2f0f = v);
$parcel$export(module.exports, "skipButton", () => $39d61f7a254e4080$export$bc892abb8d6aa6fd, (v) => $39d61f7a254e4080$export$bc892abb8d6aa6fd = v);
$parcel$export(module.exports, "steps", () => $39d61f7a254e4080$export$be3f796aed065412, (v) => $39d61f7a254e4080$export$be3f796aed065412 = v);
var $39d61f7a254e4080$export$bb5ee47d9ea2348e;
var $39d61f7a254e4080$export$b004c9847a75de92;
var $39d61f7a254e4080$export$d7dc7be08229f0b2;
var $39d61f7a254e4080$export$25461e9eb43d56b4;
var $39d61f7a254e4080$export$1a09c8e9a482a512;
var $39d61f7a254e4080$export$29ce79ff6c68f3e5;
var $39d61f7a254e4080$export$f2b922cb4a245974;
var $39d61f7a254e4080$export$824ed78f362d2f0f;
var $39d61f7a254e4080$export$bc892abb8d6aa6fd;
var $39d61f7a254e4080$export$be3f796aed065412;
$39d61f7a254e4080$export$bb5ee47d9ea2348e = `c9nuQq_banner`;
$39d61f7a254e4080$export$b004c9847a75de92 = `c9nuQq_buttonBar`;
$39d61f7a254e4080$export$d7dc7be08229f0b2 = `c9nuQq_contentHeader`;
$39d61f7a254e4080$export$25461e9eb43d56b4 = `c9nuQq_contentText`;
$39d61f7a254e4080$export$1a09c8e9a482a512 = `c9nuQq_dialogContent`;
$39d61f7a254e4080$export$29ce79ff6c68f3e5 = `c9nuQq_dialogInnerContent`;
$39d61f7a254e4080$export$f2b922cb4a245974 = `c9nuQq_gutter`;
$39d61f7a254e4080$export$824ed78f362d2f0f = `c9nuQq_hierarchyLink`;
$39d61f7a254e4080$export$bc892abb8d6aa6fd = `c9nuQq_skipButton`;
$39d61f7a254e4080$export$be3f796aed065412 = `c9nuQq_steps`;

});



parcelRegister("8fpC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c3cdc9a8b7dc70$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j67d5 = parcelRequire("j67d5");

var $akTHA = parcelRequire("akTHA");
parcelRequire("5rBQb");

var $8617b = parcelRequire("8617b");
/**
 * $$ UpdateRecentPlans $$
 * This component is used to load the store of the "Plans" menu items from the backend.
 *
 * This component updates the FE store with this new information. If we don't update the FE store, we will see
 * previous list of recent plans for a moment and then it updates to new list once /navigation endpoint
 * returns the results.
 */ const $c7c3cdc9a8b7dc70$var$UpdateRecentPlans = ()=>{
    const [, { load: load }] = (0, $j67d5.usePlansItems)();
    (0, $eUqFw.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return null;
};
function $c7c3cdc9a8b7dc70$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { TitleBar: TitleBar, Main: Main } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Main, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7c3cdc9a8b7dc70$var$UpdateRecentPlans, null));
}
$c7c3cdc9a8b7dc70$export$2e2bcd8739ae039.defaultProps = {
    TitleBar: $8617b.default,
    Main: $akTHA.default
};

});
parcelRegister("j67d5", function(module, exports) {

$parcel$export(module.exports, "usePlansItems", () => $be19608a77c2b55a$export$9386de9ff002702a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $2zniw = parcelRequire("2zniw");

var $6vrw7 = parcelRequire("6vrw7");
const $be19608a77c2b55a$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchPlansItems: fetchPlansItems, baseUrl: baseUrl, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchPlansItems(baseUrl);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $be19608a77c2b55a$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($be19608a77c2b55a$var$handleFetch());
            await promise;
        }
};
const $be19608a77c2b55a$export$b0dd7d935d0978a4 = ({ storeName: storeName = 'plans-item-store', fetchPlansItems: fetchPlansItems })=>{
    const initialState = {
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        fetchPlansItems: fetchPlansItems,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: null,
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $a61MH.createStore)({
        name: storeName,
        actions: $be19608a77c2b55a$var$actions,
        initialState: initialState
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const usePlansItems = (0, $ggKAj.createHook)(Store, {
        selector: selector
    });
    return {
        usePlansItems: usePlansItems
    };
};
const { usePlansItems: $be19608a77c2b55a$export$9386de9ff002702a } = $be19608a77c2b55a$export$b0dd7d935d0978a4({
    fetchPlansItems: (0, $2zniw.fetchPlansItems)
});

});
parcelRegister("2zniw", function(module, exports) {

$parcel$export(module.exports, "fetchPlansItems", () => $60516206d57201d0$export$ae5884604a8ac77b);

var $fVqUX = parcelRequire("fVqUX");

var $6vrw7 = parcelRequire("6vrw7");

const $60516206d57201d0$var$handleError = (error)=>{
    throw error;
};
const $60516206d57201d0$var$transformResult = ({ isVisible: isVisible, staticLinks: staticLinks, recentPlans: recentPlans = [] })=>{
    const recentItems = recentPlans.map(({ planId: planId, scenarioId: scenarioId, title: title, url: url })=>({
            id: `${planId}|${scenarioId}`,
            title: title || '',
            url: url,
            type: (0, $0e036566397b8f78$export$eebccb886b064713)
        }));
    return {
        isVisible: isVisible,
        recent: recentItems,
        links: staticLinks
    };
};
const $60516206d57201d0$export$ae5884604a8ac77b = async (baseUrl = (0, $6vrw7.toBaseUrl)(''))=>{
    const url = `${baseUrl}/rest/jpo/1.0/navigation`;
    try {
        const response = await fetch(url, (0, $fVqUX.default));
        if (response.ok) {
            const result = await response.json();
            return $60516206d57201d0$var$transformResult(result);
        }
        return $60516206d57201d0$var$handleError(new Error(response.statusText));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $60516206d57201d0$var$handleError(error);
    }
};

});
const $0e036566397b8f78$export$91a9dba2d38d9a6f = 'projects';
const $0e036566397b8f78$export$ebb48b08205007c5 = 'issues';
const $0e036566397b8f78$export$6737b9227f60f39d = 'filters';
const $0e036566397b8f78$export$6e58b6b0aa48a271 = 'dashboards';
const $0e036566397b8f78$export$20f1031cc9fdf29e = 'queues';
const $0e036566397b8f78$export$f95f1a684a17f189 = 'boards';
const $0e036566397b8f78$export$3c11110d46d67e8c = 'jwmBoards';
const $0e036566397b8f78$export$5e2cc09b58170ca2 = 'addons';
const $0e036566397b8f78$export$eebccb886b064713 = 'plans';
const $0e036566397b8f78$export$1c2ea36059c73937 = 'alerts';



parcelRegister("akTHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c016afbdf682771$export$2e2bcd8739ae039);

var $jufFm = parcelRequire("jufFm");

var $lNNXV = parcelRequire("lNNXV");

var $jxUSq = parcelRequire("jxUSq");

var $cN7Of = parcelRequire("cN7Of");
var $7c016afbdf682771$export$2e2bcd8739ae039 = (0, $jufFm.default)((0, $lNNXV.connect)((0, $jxUSq.default), {})((0, $cN7Of.default)));

});
parcelRegister("jufFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2fcf89d461b00dc$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aMJyi = parcelRequire("aMJyi");
var $e2fcf89d461b00dc$export$2e2bcd8739ae039 = (0, $aMJyi.default);

});
parcelRegister("aMJyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da1b8cd67194547$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $bcF1v = parcelRequire("bcF1v");

var $k43p8 = parcelRequire("k43p8");
var $7da1b8cd67194547$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7da1b8cd67194547$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A public higher-order component to access the imperative API
 */ var $7da1b8cd67194547$var$withRouter = function withRouter(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $7da1b8cd67194547$var$_objectWithoutProperties(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k43p8.default), {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, $7da1b8cd67194547$var$_extends({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bcF1v)))(C, Component);
};
var $7da1b8cd67194547$export$2e2bcd8739ae039 = $7da1b8cd67194547$var$withRouter;

});
parcelRegister("bcF1v", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $8280a310ba805005$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8280a310ba805005$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8280a310ba805005$var$defineProperty = Object.defineProperty;
var $8280a310ba805005$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8280a310ba805005$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8280a310ba805005$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8280a310ba805005$var$getPrototypeOf = Object.getPrototypeOf;
var $8280a310ba805005$var$objectPrototype = $8280a310ba805005$var$getPrototypeOf && $8280a310ba805005$var$getPrototypeOf(Object);
function $8280a310ba805005$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($8280a310ba805005$var$objectPrototype) {
            var inheritedComponent = $8280a310ba805005$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8280a310ba805005$var$objectPrototype) $8280a310ba805005$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $8280a310ba805005$var$getOwnPropertyNames(sourceComponent);
        if ($8280a310ba805005$var$getOwnPropertySymbols) keys = keys.concat($8280a310ba805005$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$8280a310ba805005$var$REACT_STATICS[key] && !$8280a310ba805005$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $8280a310ba805005$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $8280a310ba805005$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $8280a310ba805005$var$hoistNonReactStatics;

});



parcelRegister("jxUSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e67cc3d180632e38$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $e67cc3d180632e38$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    planTitle: (state)=>(0, $75KhQ.getPlan)(state).title,
    isReportMode: (state)=>(0, $akhOi.isReportMode)(state)
});

});

parcelRegister("cN7Of", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a47fcc30a124a5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kFhA9 = parcelRequire("kFhA9");
var $7QNSj = parcelRequire("7QNSj");
var $9MQbY = parcelRequire("9MQbY");

var $heNSb = parcelRequire("heNSb");

var $2qhQi = parcelRequire("2qhQi");

var $gRGDF = parcelRequire("gRGDF");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $9xIyq = parcelRequire("9xIyq");

var $cNhXT = parcelRequire("cNhXT");

var $9eWiI = parcelRequire("9eWiI");

var $80zhc = parcelRequire("80zhc");

var $abgpq = parcelRequire("abgpq");

var $fqXwe = parcelRequire("fqXwe");
// eslint-disable-next-line jira/react/no-class-components
class $c4a47fcc30a124a5$var$Main extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            Roadmap: $abgpq.default,
            Teams: (0, $fqXwe.default),
            Releases: (0, $80zhc.default),
            Dependencies: (0, $9eWiI.default)
        };
    }
    render() {
        const { intl: intl, planTitle: planTitle, isReportMode: isReportMode, Roadmap: // eslint-disable-next-line @typescript-eslint/no-shadow
        Roadmap, location: { pathname: pathname } } = this.props;
        const productName = intl.formatMessage((0, $9xIyq.default).plans);
        const documentTitle = (0, $7CnHa.isDefined)(planTitle) ? `${planTitle} - ${productName}` : `${productName}`;
        if (isReportMode) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $cNhXT.roadmapReportingWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
            title: documentTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Roadmap, null)));
        const tabs = [
            {
                label: intl.formatMessage((0, $9xIyq.default).roadmapTabLabel),
                value: 'ROADMAP',
                link: '/backlog',
                testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap'
            },
            {
                label: intl.formatMessage((0, $9xIyq.default).teamsTabLabel),
                value: 'TEAMS',
                link: '/teams',
                testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.teams'
            },
            {
                label: intl.formatMessage((0, $9xIyq.default).releasesTabLabel),
                value: 'RELEASES',
                link: '/releases'
            },
            {
                label: intl.formatMessage((0, $9xIyq.default).dependenciesTabLabel),
                value: 'DEPENDENCIES',
                link: '/dependencies',
                testId: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies'
            }
        ];
        let selectedTab = tabs.find(({ link: link })=>`/plan${link}` === pathname);
        selectedTab = (0, $7CnHa.isDefined)(selectedTab) ? selectedTab : tabs[0];
        (0, $lFLge.redirectToPlanPage)(selectedTab.link);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
            className: $cNhXT.main,
            "aria-label": intl.formatMessage((0, $9xIyq.default).planAndTimeline)
        }, this.TabContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
            title: documentTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gRGDF.FirePlanCreationEventFromThePrevWizard), null)));
    }
    constructor(...args){
        super(...args);
        this.TabContent = ()=>{
            const { Roadmap: // eslint-disable-next-line @typescript-eslint/no-shadow
            Roadmap, // eslint-disable-next-line @typescript-eslint/no-shadow
            Teams: AsyncTeams, // eslint-disable-next-line @typescript-eslint/no-shadow
            Releases: AsyncReleases, match: { url: url } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kFhA9.default), {
                to: "/plan/backlog",
                from: "/plan",
                exact: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
                path: `${url}/backlog`,
                component: Roadmap
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
                path: `${url}/teams`,
                component: AsyncTeams
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
                path: `${url}/releases`,
                component: AsyncReleases
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
                path: `${url}/dependencies`,
                component: (0, $9eWiI.default)
            }));
        };
    }
}
var $c4a47fcc30a124a5$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c4a47fcc30a124a5$var$Main);

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("gRGDF", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $ea4eddb19742c90f$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "FirePlanCreationEventFromThePrevWizard", () => $ea4eddb19742c90f$export$febc0945121e470c);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");


var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");
var $2qZHF = parcelRequire("2qZHF");

var $3FyZ4 = parcelRequire("3FyZ4");

var $7Pxgh = parcelRequire("7Pxgh");
const $ea4eddb19742c90f$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eUqFw.useRef)((0, $3FyZ4.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $iKlrz.getEvent)(analyticsEvent)));
        }
    };
};
function $ea4eddb19742c90f$export$1b581a2ec13e37f1({ children: children }) {
    const { sendEvent: sendEvent } = $ea4eddb19742c90f$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: (0, $e779cc169fd2a347$export$2ceccf177fae277c),
        onEvent: sendEvent
    }, children);
}
function $ea4eddb19742c90f$export$febc0945121e470c() {
    const planId = (0, $eUqFw.useRef)((0, $7Pxgh.getPlanId)(window.location)).current;
    const version = (0, $eUqFw.useRef)((0, $7Pxgh.getWizardVersion)(window.location)).current;
    const nextUrl = (0, $eUqFw.useRef)((0, $7Pxgh.stripPlanWizardParams)(window.location)).current;
    // When finishing the plan creation on the legacy plan wizard, the redirected URL will have &wizardversion=2
    if (version !== 2) return null;
    const fireEvent = (analyticsEvent)=>{
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'plan created', {
            planId: planId,
            version: version
        });
        // Remove the param to prevent the user from triggering the event more than once by reloading or bookmarking
        window.history.replaceState({}, '', nextUrl);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
}

});
const $e779cc169fd2a347$export$f636b5b56f1d624a = 'Screen';
const $e779cc169fd2a347$export$9d2de6eebf7462b5 = 'Drawer';
const $e779cc169fd2a347$export$1171103ea9083ffa = 'Modal';
const $e779cc169fd2a347$export$cae2783c9279926 = 'InlineDialog';
const $e779cc169fd2a347$export$d1123261ca8831d2 = 'Dropdown';
const $e779cc169fd2a347$export$a1562d08625f5d7e = 'UI';
const $e779cc169fd2a347$export$947dac6c72b26f81 = 'TRACK';
const $e779cc169fd2a347$export$f1d537d508d2945a = 'SCREEN';
const $e779cc169fd2a347$export$12346a674644c156 = 'OPERATIONAL';
const $e779cc169fd2a347$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("7Pxgh", function(module, exports) {

$parcel$export(module.exports, "getPlanId", () => $e4ded55c5c13eb06$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "getWizardVersion", () => $e4ded55c5c13eb06$export$3d4ecc1b43c6567c);
$parcel$export(module.exports, "stripPlanWizardParams", () => $e4ded55c5c13eb06$export$6ac0dd0b33e1da11);

var $53ciZ = parcelRequire("53ciZ");
const $e4ded55c5c13eb06$export$203ed8b65c3b2a28 = (loc)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(loc.search);
    return parseInt(parsed.id, 10);
};
const $e4ded55c5c13eb06$export$3d4ecc1b43c6567c = (loc)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(loc.search);
    return parseInt(parsed.wizardversion, 10);
};
const $e4ded55c5c13eb06$export$6ac0dd0b33e1da11 = (loc)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(loc.search);
    const nextQueryPayload = {
        ...parsed
    };
    delete nextQueryPayload.wizardversion;
    const nextQuery = `?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(nextQueryPayload)}`;
    return `${loc.origin}${nextQuery}${loc.hash}`;
};

});


parcelRegister("9xIyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a89c94227c25ec43$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a89c94227c25ec43$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    roadmapTabLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.roadmap-tab-label",
        "defaultMessage": "Roadmap"
    },
    teamsTabLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.teams-tab-label",
        "defaultMessage": "Teams"
    },
    releasesTabLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.releases-tab-label",
        "defaultMessage": "Releases"
    },
    dependenciesTabLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.dependencies-tab-label",
        "defaultMessage": "Dependencies report"
    },
    planAndTimeline: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.plan-and-timeline",
        "defaultMessage": "Plan and timeline"
    },
    plans: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.plans",
        "defaultMessage": "Plans"
    },
    releasesSearchPlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.releases-search-placeholder",
        "defaultMessage": "Search releases"
    },
    searchLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.main.search-label",
        "defaultMessage": "Typing letters in this search field input updates the releases search results."
    }
});

});

parcelRegister("cNhXT", function(module, exports) {

$parcel$export(module.exports, "main", () => $9507ff211ed81f3c$export$f22da7240b7add18, (v) => $9507ff211ed81f3c$export$f22da7240b7add18 = v);
$parcel$export(module.exports, "roadmapReportingWrapper", () => $9507ff211ed81f3c$export$b14aa76d52c50af8, (v) => $9507ff211ed81f3c$export$b14aa76d52c50af8 = v);
var $9507ff211ed81f3c$export$f22da7240b7add18;
var $9507ff211ed81f3c$export$b14aa76d52c50af8;
$9507ff211ed81f3c$export$f22da7240b7add18 = `_9g2d7q_main`;
$9507ff211ed81f3c$export$b14aa76d52c50af8 = `_9g2d7q_roadmapReportingWrapper`;

});

parcelRegister("9eWiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f218cd54ef09aa36$export$2e2bcd8739ae039);
$parcel$export(module.exports, "preload", () => $f218cd54ef09aa36$export$513ccb98c53b8039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $gGtKh = parcelRequire("gGtKh");
const $f218cd54ef09aa36$var$METRIC_KEY = 'LOAD_START_ADVANCED_ROADMAPS_DEPENDENCIES_PAGE';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f218cd54ef09aa36$var$Page = (0, $7rh0R.lazy)(()=>(parcelRequire("fYaQX")), {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/dependencies/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f218cd54ef09aa36$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "advanced-roadmaps-dependencies-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $f218cd54ef09aa36$var$METRIC_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f218cd54ef09aa36$var$Page, props));
const $f218cd54ef09aa36$export$513ccb98c53b8039 = $f218cd54ef09aa36$var$Page.preload;

});
parcelRegister("fYaQX", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2Umqd")),
            load('h2MrD'),
            load('bYT2S'),
            load('5NAyp')
        ]);
        const value = parcelRequire('76PEp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2Umqd")),
        load("h2MrD"),
        load("bYT2S"),
        load("5NAyp")
    ]).then(()=>parcelRequire('76PEp'));
}

});


parcelRegister("80zhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3eb21c708f5cf7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "preload", () => $1a3eb21c708f5cf7$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $gGtKh = parcelRequire("gGtKh");
const $1a3eb21c708f5cf7$var$METRIC_KEY = 'LOAD_START_ADVANCED_ROADMAPS_RELEASES_PAGE';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1a3eb21c708f5cf7$var$Page = (0, $7rh0R.lazy)(()=>(parcelRequire("f0APo")), {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/releases/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1a3eb21c708f5cf7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "advanced-roadmaps-releases-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $1a3eb21c708f5cf7$var$METRIC_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a3eb21c708f5cf7$var$Page, props));
const $1a3eb21c708f5cf7$export$513ccb98c53b8039 = $1a3eb21c708f5cf7$var$Page.preload;

});
parcelRegister("f0APo", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2mb6O")),
            load('h2MrD'),
            load('bYT2S'),
            load('4gO6K')
        ]);
        const value = parcelRequire('b27GI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("2mb6O")),
        load("h2MrD"),
        load("bYT2S"),
        load("4gO6K")
    ]).then(()=>parcelRequire('b27GI'));
}

});


parcelRegister("fqXwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c6898312945e9a1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "preload", () => $4c6898312945e9a1$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $gGtKh = parcelRequire("gGtKh");
const $4c6898312945e9a1$var$METRIC_KEY = 'LOAD_START_ADVANCED_ROADMAPS_TEAMS_PAGE';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4c6898312945e9a1$var$Page = (0, $7rh0R.lazy)(()=>(parcelRequire("3FEjV")), {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/main/tabs/teams/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c6898312945e9a1$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "advanced-roadmaps-teams-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $4c6898312945e9a1$var$METRIC_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c6898312945e9a1$var$Page, props));
const $4c6898312945e9a1$export$513ccb98c53b8039 = $4c6898312945e9a1$var$Page.preload;

});
parcelRegister("3FEjV", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1qTqU")),
            load('2hmUs'),
            load('bCeK4'),
            load('fMPFK')
        ]);
        const value = parcelRequire('97Ifw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("1qTqU")),
        load("2hmUs"),
        load("bCeK4"),
        load("fMPFK")
    ]).then(()=>parcelRequire('97Ifw'));
}

});




parcelRegister("5rBQb", function(module, exports) {

$parcel$export(module.exports, "app", () => $3f6cd3bd65798cc0$export$729c8b7179294ba, (v) => $3f6cd3bd65798cc0$export$729c8b7179294ba = v);
var $3f6cd3bd65798cc0$export$729c8b7179294ba;
$3f6cd3bd65798cc0$export$729c8b7179294ba = `uDGY6G_app`;

});

parcelRegister("8617b", function(module, exports) {

$parcel$export(module.exports, "default", () => $2797a3e3ad605dfb$export$2e2bcd8739ae039);

var $jufFm = parcelRequire("jufFm");

var $akhOi = parcelRequire("akhOi");

var $beuE2 = parcelRequire("beuE2");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $PbCA0 = parcelRequire("PbCA0");

var $g0ygz = parcelRequire("g0ygz");
const $2797a3e3ad605dfb$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    mode: (0, $akhOi.getMode),
    readOnly: (0, $akhOi.isReadOnly),
    showToolBar: (0, $beuE2.getToolBarVisibilityState)
});
var $2797a3e3ad605dfb$export$2e2bcd8739ae039 = (0, $jufFm.default)((0, $lNNXV.connect)($2797a3e3ad605dfb$var$mapStateToProps, (0, $PbCA0.default))((0, $g0ygz.default)));

});
parcelRegister("PbCA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f07a94d1584110$export$2e2bcd8739ae039);

var $6hfzF = parcelRequire("6hfzF");

var $9G8kJ = parcelRequire("9G8kJ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$32f07a94d1584110$export$2e2bcd8739ae039 = (dispatch)=>({
        showOnboarding: ()=>{
            dispatch((0, $6hfzF.setIntroOpen)(true));
        },
        toggleToolBar: ()=>{
            dispatch((0, $9G8kJ.toggleToolBar)());
        }
    });

});

parcelRegister("g0ygz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f45d9cf95990e4b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $bLFgh = parcelRequire("bLFgh");
var $5CV7v = parcelRequire("5CV7v");
var $ffiyv = parcelRequire("ffiyv");
var $ltfxy = parcelRequire("ltfxy");
var $gwbfD = parcelRequire("gwbfD");

var $ehNfb = parcelRequire("ehNfb");
parcelRequire("akhOi");

var $5q8gK = parcelRequire("5q8gK");

var $1qPld = parcelRequire("1qPld");

var $Bp98t = parcelRequire("Bp98t");

var $hVUU2 = parcelRequire("hVUU2");

var $5rYNM = parcelRequire("5rYNM");

var $brSAH = parcelRequire("brSAH");

var $lFLge = parcelRequire("lFLge");

var $6gsf3 = parcelRequire("6gsf3");

var $8G2Ik = parcelRequire("8G2Ik");

var $2ptMN = parcelRequire("2ptMN");

var $aDD34 = parcelRequire("aDD34");

var $71Qj2 = parcelRequire("71Qj2");

var $kOCNy = parcelRequire("kOCNy");

var $gy8pW = parcelRequire("gy8pW");

var $6EPGR = parcelRequire("6EPGR");

var $kbEgN = parcelRequire("kbEgN");

var $30kLD = parcelRequire("30kLD");
// eslint-disable-next-line jira/react/no-class-components
class $6f45d9cf95990e4b$var$TitleBar extends (0, $eUqFw.Component) {
    static{
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            Optimize: $2ptMN.default,
            ApplyOptimisations: $6gsf3.default,
            PlanSettings: $aDD34.default,
            Title: $6EPGR.default,
            UpdateJira: $kbEgN.default,
            ShareReport: $kOCNy.default,
            WarningCenter: $30kLD.default,
            Scenarios: $71Qj2.default,
            FeedbackButton: (0, $ehNfb.FeedbackButtonLazyComponent),
            FilterBar: $1qPld.default,
            ViewBar: $Bp98t.default,
            ViewSettings: $5q8gK.default,
            ViewSwitcher: $hVUU2.default
        };
    }
    static{
        this.displayName = 'TitleBar';
    }
    static{
        this.whyDidYouRender = true;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.title-bar"
        }, this.getHeaderRows());
    }
    constructor(...args){
        super(...args);
        this.getReadOnlyPlanLozenge = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gy8pW.readOnlyPlanLozenge
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                isBold: true,
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.read-only-lozenge"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8G2Ik.default).readOnlyLozengeText)));
        this.getToggleToolBarButtonRow = (currentRoute)=>{
            const { intl: intl, mode: mode, showToolBar: showToolBar, toggleToolBar: toggleToolBar } = this.props;
            // hiding the collapse / expand icon when the plan is optimized the header is hidden by an overlay,
            // but the z-index of the button would make it appear over the overlay
            if (currentRoute !== (0, $lFLge.PLAN_PAGES).ROADMAP || mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                className: $gy8pW.headerRowSeparator
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)));
            const buttonMessage = intl.formatMessage(showToolBar ? (0, $8G2Ik.default).collapseToolBar : (0, $8G2Ik.default).expandToolBar);
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                className: $gy8pW.headerRowBacklogSeparator
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.toggle-toolbar-button",
                id: "toolBarButtonIcon",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $gy8pW.toolBarButtonIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: buttonMessage,
                position: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
                onClick: toggleToolBar,
                ariaLabel: buttonMessage
            }, showToolBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.up-icon",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.down-icon",
                label: ""
            }))))));
        };
        this.getHeaderRows = ()=>{
            const { ApplyOptimisations: // eslint-disable-next-line @typescript-eslint/no-shadow
            ApplyOptimisations, FeedbackButton: FeedbackButton, FilterBar: // eslint-disable-next-line @typescript-eslint/no-shadow
            FilterBar, Optimize: // eslint-disable-next-line @typescript-eslint/no-shadow
            Optimize, PlanSettings: // eslint-disable-next-line @typescript-eslint/no-shadow
            PlanSettings, Scenarios: // eslint-disable-next-line @typescript-eslint/no-shadow
            Scenarios, ShareReport: // eslint-disable-next-line @typescript-eslint/no-shadow
            ShareReport, Title: // eslint-disable-next-line @typescript-eslint/no-shadow
            Title, UpdateJira: // eslint-disable-next-line @typescript-eslint/no-shadow
            UpdateJira, ViewBar: // eslint-disable-next-line @typescript-eslint/no-shadow
            ViewBar, ViewSettings: // eslint-disable-next-line @typescript-eslint/no-shadow
            ViewSettings, ViewSwitcher: // eslint-disable-next-line @typescript-eslint/no-shadow
            ViewSwitcher, WarningCenter: // eslint-disable-next-line @typescript-eslint/no-shadow
            WarningCenter, location: { pathname: pathname }, mode: mode, readOnly: readOnly, showToolBar: showToolBar, intl: { formatMessage: formatMessage } } = this.props;
            const currentRoute = pathname.slice(1).split('/')[1];
            switch(mode){
                case 0, $99f9ac26081f8045$export$250171a898bf7ef:
                case 0, $99f9ac26081f8045$export$e91bb82ec00eb771:
                case 0, $99f9ac26081f8045$export$7536581a3f6533cb:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.headerRow
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).planSettingsViewTitle),
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.mode-edit-optimized-optimizing"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.headerRowLeft
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.title
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, {
                        isReadOnly: readOnly
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PlanSettings, null), readOnly && this.getReadOnlyPlanLozenge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Scenarios, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.viewSwitcherWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSwitcher, {
                        currentRoute: currentRoute,
                        isReadOnly: readOnly
                    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).giveFeedbackAndReviewTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FeedbackButton, null), currentRoute === (0, $lFLge.PLAN_PAGES).DEPENDENCIES_REPORT && showToolBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareReport, {
                        confluenceMacroType: (0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateJira, null))))), this.getToggleToolBarButtonRow(currentRoute), currentRoute === (0, $lFLge.PLAN_PAGES).ROADMAP && showToolBar && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.toolBar
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).filterAndChangeViewTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.left
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
                        name: "filters-view-settings"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.toolBarFiltersSettingsContainer
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSettings, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewBar, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).warningsAndAutoSceduleTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), {
                        className: $gy8pW.toolBarRight
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WarningCenter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareReport, {
                        confluenceMacroType: (0, $5rYNM.TIMELINE_SHARE_TYPE)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Optimize, null), mode === (0, $99f9ac26081f8045$export$e91bb82ec00eb771) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApplyOptimisations, null)))));
                case 0, $99f9ac26081f8045$export$b07c15b79440feb8:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.headerRow
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).planSettingsViewTitle),
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.mode-readonly"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.left
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.title
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, {
                        isReadOnly: readOnly
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PlanSettings, null), readOnly && this.getReadOnlyPlanLozenge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Scenarios, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.viewSwitcherWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSwitcher, {
                        currentRoute: currentRoute,
                        isReadOnly: readOnly
                    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).giveFeedbackAndReviewTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FeedbackButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(UpdateJira, null))))), this.getToggleToolBarButtonRow(currentRoute), currentRoute === (0, $lFLge.PLAN_PAGES).ROADMAP && showToolBar && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.toolBar
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).filterAndChangeViewTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.left
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
                        name: "filters-view-settings"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.toolBarFiltersSettingsContainer
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSettings, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewBar, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).warningsAndShareTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), {
                        className: $gy8pW.toolBarRight
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WarningCenter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareReport, {
                        confluenceMacroType: (0, $5rYNM.TIMELINE_SHARE_TYPE)
                    })))));
                case 0, $99f9ac26081f8045$export$e3d31417f21c1ce7:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.headerRow
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).planSettingsTitle),
                        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.mode-report"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.left
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.title
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Title, {
                        isReadOnly: readOnly
                    })), readOnly && this.getReadOnlyPlanLozenge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Scenarios, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).giveFeedbackTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FeedbackButton, null)))), this.getToggleToolBarButtonRow(currentRoute), showToolBar && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Row), {
                        className: $gy8pW.toolBar
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).filterAndChangeViewTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Left), {
                        className: $gy8pW.left
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $gy8pW.toolBarFiltersSettingsContainer
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewSettings, null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
                        "aria-label": formatMessage((0, $8G2Ik.default).warningsAndShareTitle)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brSAH.Right), {
                        className: $gy8pW.toolBarRight
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WarningCenter, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ShareReport, {
                        confluenceMacroType: (0, $5rYNM.TIMELINE_SHARE_TYPE)
                    })))));
                case 0, $99f9ac26081f8045$export$f79b1fae3e63e441:
                    return null;
                default:
                    throw new Error(`Unexpected mode: ${mode}`);
            }
        };
    }
}
var $6f45d9cf95990e4b$export$2e2bcd8739ae039 = (0, $2qhQi.default)($6f45d9cf95990e4b$var$TitleBar);

});
parcelRegister("ehNfb", function(module, exports) {

$parcel$export(module.exports, "FeedbackButtonLazyComponent", () => $f7b98e27221dc23e$export$e1559a22f6313482);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $l2ZYW = parcelRequire("l2ZYW");

var $0cdA8 = parcelRequire("0cdA8");

var $8uD7Y = parcelRequire("8uD7Y");

var $gGtKh = parcelRequire("gGtKh");

var $74PyA = parcelRequire("74PyA");
const $f7b98e27221dc23e$var$FallbackComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l2ZYW))), {
            label: ""
        }),
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74PyA.default).giveFeedback));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f7b98e27221dc23e$var$FeedbackButtonLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("fXFF4")).then((module)=>module.FeedbackButton), {
    moduleId: "./src/packages/portfolio-3/feedback-collector/src/ui/index.tsx"
});
const $f7b98e27221dc23e$export$e1559a22f6313482 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "advanced-roadmaps-plan.feedback-collector",
        packageName: "jira-portfolio-3-feedback-collector",
        teamName: "advanced-roadmaps",
        fallback: $f7b98e27221dc23e$var$FallbackComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feedback-button",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7b98e27221dc23e$var$FallbackComponent, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7b98e27221dc23e$var$FeedbackButtonLazy, null)));

});
parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f529dd351378d429$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.881 5.48l-8.426 6.829c-.396.32-.582.956-.413 1.417l.099.272c.168.462.726.829 1.227.82l1.131-.02 6.062-.102 3.652-.063c.51-.01.788-.385.616-.861l-2.923-8.03c-.105-.288-.324-.441-.567-.441a.731.731 0 00-.458.179zM4.98 15.953l1.754 4.818a1 1 0 101.879-.684l-1.539-4.228-2.094.094zm13.711-9.111l-2.819 1.026a1 1 0 10.684 1.879l2.82-1.026a1 1 0 10-.685-1.88zm-1.792 3.845a1.006 1.006 0 00-.644.766 1.002 1.002 0 00.811 1.159l2.955.52a1 1 0 001.122-1.301l-.017-.047a.997.997 0 00-.758-.621l-2.955-.521a.974.974 0 00-.514.045zm-.548-7.639l-1.929 2.298a1 1 0 001.532 1.286l1.928-2.298a1.001 1.001 0 00-.765-1.643.993.993 0 00-.766.357z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = $f529dd351378d429$var$FeedbackIcon;
module.exports.default = $f529dd351378d429$var$_default;

});

parcelRegister("74PyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32971213dac96c7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $f32971213dac96c7$var$messages = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "portfolio-3-feedback-collector.ui.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "portfolio-3-feedback-collector.ui.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    contactSupport: {
        "id": "portfolio-3-feedback-collector.ui.contact-support",
        "defaultMessage": "contact our support team"
    },
    enrollInResearchPrompt: {
        "id": "portfolio-3-feedback-collector.ui.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "portfolio-3-feedback-collector.ui.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    },
    giveFeedback: {
        "id": "portfolio-3-feedback-collector.ui.give-feedback",
        "defaultMessage": "Give feedback"
    },
    reportBug: {
        "id": "portfolio-3-feedback-collector.ui.report-bug",
        "defaultMessage": "If you have technical issues or find a bug in {productName}, please {contactSupportLink}."
    },
    plansReportBug: {
        "id": "portfolio-3-feedback-collector.ui.plans-report-bug",
        "defaultMessage": "If you have technical issues or find a bug in Plans, please {contactSupportLink}."
    }
});
var $f32971213dac96c7$export$2e2bcd8739ae039 = $f32971213dac96c7$var$messages;

});

parcelRegister("fXFF4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2nRO7');
        const value = parcelRequire('iuxkG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2nRO7").then(()=>parcelRequire('iuxkG'));
}

});


parcelRegister("hVUU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d15522025dbc5c1$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $1Sp1k = parcelRequire("1Sp1k");

var $lbu1V = parcelRequire("lbu1V");
var $2d15522025dbc5c1$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $1Sp1k.default), {})((0, $lbu1V.default));

});
parcelRegister("1Sp1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b90fcad82b7210$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $75KhQ = parcelRequire("75KhQ");

var $1TrR5 = parcelRequire("1TrR5");
const $d4b90fcad82b7210$var$mapStateToPropsOld = (state)=>({
        isMultiScenarioEnabled: (0, $75KhQ.isMultiScenarioEnabled)(state) ?? false,
        planScenarios: (0, $75KhQ.getPlanScenarios)(state)
    });
const $d4b90fcad82b7210$var$getPlanScenariosMemoized = ()=>(0, $df4Sl.createSelector)((0, $75KhQ.getPlanScenarios), (res)=>res);
const $d4b90fcad82b7210$var$mapStateToPropsFactory = ()=>{
    const getPlanScenariosInstance = $d4b90fcad82b7210$var$getPlanScenariosMemoized();
    return (state)=>({
            isMultiScenarioEnabled: (0, $75KhQ.isMultiScenarioEnabled)(state) ?? false,
            planScenarios: getPlanScenariosInstance(state)
        });
};
const $d4b90fcad82b7210$var$mapStateToProps = (0, $1TrR5.functionWithFFRedux)($d4b90fcad82b7210$var$mapStateToPropsFactory, $d4b90fcad82b7210$var$mapStateToPropsOld);
var $d4b90fcad82b7210$export$2e2bcd8739ae039 = $d4b90fcad82b7210$var$mapStateToProps;

});

parcelRegister("lbu1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $06affa8ac5d38d9e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $bhLKP = parcelRequire("bhLKP");
var $7QNSj = parcelRequire("7QNSj");
var $9MQbY = parcelRequire("9MQbY");

var $86Ndv = parcelRequire("86Ndv");

var $krV8e = parcelRequire("krV8e");

var $4nce6 = parcelRequire("4nce6");

var $1vuAp = parcelRequire("1vuAp");

var $14lY4 = parcelRequire("14lY4");

var $8uD7Y = parcelRequire("8uD7Y");

var $3XRVl = parcelRequire("3XRVl");
var $ltfxy = parcelRequire("ltfxy");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $cuuJa = parcelRequire("cuuJa");

var $9eWiI = parcelRequire("9eWiI");

var $80zhc = parcelRequire("80zhc");

var $fqXwe = parcelRequire("fqXwe");

var $7CnHa = parcelRequire("7CnHa");

var $lFLge = parcelRequire("lFLge");

var $jMP2a = parcelRequire("jMP2a");

var $396lB = parcelRequire("396lB");

var $hBt0n = parcelRequire("hBt0n");
const $06affa8ac5d38d9e$var$preloadAllTabs = ()=>{
    (0, $80zhc.preload)();
    (0, $fqXwe.preload)();
    (0, $9eWiI.preload)();
};
function $06affa8ac5d38d9e$var$ViewSwitcher({ currentRoute: currentRoute, isMultiScenarioEnabled: isMultiScenarioEnabled, isReadOnly: isReadOnly, planScenarios: planScenarios, defaultOpen: defaultOpen = false }) {
    const routeNames = [
        {
            path: `/${(0, $lFLge.PLAN_PATHS).ROADMAP}`,
            route: (0, $lFLge.PLAN_PAGES).ROADMAP,
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $396lB.default).timelineLabel),
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1vuAp)))
        },
        {
            path: `/${(0, $lFLge.PLAN_PATHS).TEAMS}`,
            route: (0, $lFLge.PLAN_PAGES).TEAMS,
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $396lB.default).teamsLabel),
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4nce6)))
        },
        {
            path: `/${(0, $lFLge.PLAN_PATHS).RELEASES}`,
            route: (0, $lFLge.PLAN_PAGES).RELEASES,
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $396lB.default).releasesLabel),
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($14lY4)))
        },
        {
            path: `/${(0, $lFLge.PLAN_PATHS).DEPENDENCIES_REPORT}`,
            route: (0, $lFLge.PLAN_PAGES).DEPENDENCIES_REPORT,
            Component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $396lB.default).dependenciesLabel),
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($krV8e)))
        }
    ];
    const getHandlePageChange = (route)=>{
        (0, $lFLge.redirectToPlanPage)(route);
    };
    const viewSwitcherBeforeIcon = ()=>{
        if (currentRoute === (0, $lFLge.PLAN_PAGES).TEAMS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            label: ""
        });
        if (currentRoute === (0, $lFLge.PLAN_PAGES).RELEASES) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            label: ""
        });
        if (currentRoute === (0, $lFLge.PLAN_PAGES).DEPENDENCIES_REPORT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krV8e))), {
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
            label: ""
        });
    };
    const hasScenarios = !(isMultiScenarioEnabled !== true || !(0, $7CnHa.isDefined)(planScenarios) || planScenarios.length < 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.button",
        onMouseEnter: $06affa8ac5d38d9e$var$preloadAllTabs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "view-tab-switching"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        defaultOpen: defaultOpen,
        testId: "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.dropdown-menu",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ref: triggerRef,
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                iconBefore: viewSwitcherBeforeIcon()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($hBt0n.viewTrigger, {
                    [$hBt0n.withScenarios]: hasScenarios,
                    [$hBt0n.isReadOnly]: isReadOnly
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhLKP.default), {
                hashType: "noslash"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, routeNames.map((r)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
                    key: r.path,
                    path: r.path,
                    component: r.Component
                }))))))
    }, routeNames.map((r)=>{
        const { route: route, Component: Component, Icon: Icon } = r;
        const isSelected = currentRoute === route;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: isSelected ? $hBt0n.activeMenuItem : '',
            key: `viewSwitcher${route}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
                label: ""
            }),
            isSelected: isSelected,
            onClick: (_, analyticsEvent)=>{
                if (route === (0, $lFLge.PLAN_PAGES).DEPENDENCIES_REPORT && analyticsEvent) {
                    const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).CLICKED_DEPENDENCY_TAB.split(' ');
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                        action: action,
                        actionSubject: actionSubject
                    }));
                }
                getHandlePageChange(`/${route}`);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, null))));
    }))));
}
var $06affa8ac5d38d9e$export$2e2bcd8739ae039 = $06affa8ac5d38d9e$var$ViewSwitcher;

});
parcelRegister("krV8e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee32a577ef7038dc$var$_react = $ee32a577ef7038dc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ee32a577ef7038dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ee32a577ef7038dc$var$GraphBarIcon = (props)=>/*#__PURE__*/ $ee32a577ef7038dc$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="17" y="5" width="4" height="11" rx="2"/><rect x="11" y="8" width="4" height="8" rx="2"/><rect x="5" y="11" width="4" height="5" rx="2"/><path d="M21 17H4.995C4.448 17 4 16.548 4 15.991V6a1 1 0 10-2 0v9.991A3.004 3.004 0 004.995 19H21a1 1 0 000-2z" fill-rule="nonzero"/></g></svg>`
    }, props));
$ee32a577ef7038dc$var$GraphBarIcon.displayName = 'GraphBarIcon';
var $ee32a577ef7038dc$var$_default = $ee32a577ef7038dc$var$GraphBarIcon;
module.exports.default = $ee32a577ef7038dc$var$_default;

});

parcelRegister("1vuAp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1190697f0a3052c9$var$_react = $1190697f0a3052c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1190697f0a3052c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1190697f0a3052c9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $1190697f0a3052c9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 2h10a3 3 0 010 6H6a3 3 0 110-6zm0 2a1 1 0 100 2h10a1 1 0 000-2H6zm4 5h8a3 3 0 010 6h-8a3 3 0 010-6zm0 2a1 1 0 000 2h8a1 1 0 000-2h-8zm-4 5h6a3 3 0 010 6H6a3 3 0 010-6zm0 2a1 1 0 000 2h6a1 1 0 000-2H6z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$1190697f0a3052c9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $1190697f0a3052c9$var$_default = $1190697f0a3052c9$var$RoadmapIcon;
module.exports.default = $1190697f0a3052c9$var$_default;

});

parcelRegister("396lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a4bcfc89b473589$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8a4bcfc89b473589$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timelineLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.timeline-label",
        "defaultMessage": "Timeline"
    },
    teamsLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.teams-label",
        "defaultMessage": "Teams"
    },
    releasesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.releases-label",
        "defaultMessage": "Releases"
    },
    dependenciesLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.dependencies-label",
        "defaultMessage": "Dependencies report"
    }
});

});

parcelRegister("hBt0n", function(module, exports) {

$parcel$export(module.exports, "activeMenuItem", () => $034ea6c6f9a81818$export$5b8fc07aa6ed6ed2, (v) => $034ea6c6f9a81818$export$5b8fc07aa6ed6ed2 = v);
$parcel$export(module.exports, "isReadOnly", () => $034ea6c6f9a81818$export$2498094d90b6ac72, (v) => $034ea6c6f9a81818$export$2498094d90b6ac72 = v);
$parcel$export(module.exports, "viewTrigger", () => $034ea6c6f9a81818$export$164f82e58a010d8e, (v) => $034ea6c6f9a81818$export$164f82e58a010d8e = v);
$parcel$export(module.exports, "withScenarios", () => $034ea6c6f9a81818$export$b3564392b6dc402a, (v) => $034ea6c6f9a81818$export$b3564392b6dc402a = v);
var $034ea6c6f9a81818$export$5b8fc07aa6ed6ed2;
var $034ea6c6f9a81818$export$80f239540c9c48f3;
var $034ea6c6f9a81818$export$7c8d9d59f518d0c6;
var $034ea6c6f9a81818$export$2498094d90b6ac72;
var $034ea6c6f9a81818$export$1ded4619033f627b;
var $034ea6c6f9a81818$export$c4ddc81c7b2c8d7a;
var $034ea6c6f9a81818$export$560239d3315fb15a;
var $034ea6c6f9a81818$export$fdd07bfcc294413c;
var $034ea6c6f9a81818$export$164f82e58a010d8e;
var $034ea6c6f9a81818$export$59a28b0ab50de038;
var $034ea6c6f9a81818$export$d9a879e41895b0d8;
var $034ea6c6f9a81818$export$b3564392b6dc402a;
$034ea6c6f9a81818$export$5b8fc07aa6ed6ed2 = `_83PclW_activeMenuItem`;
$034ea6c6f9a81818$export$80f239540c9c48f3 = `_83PclW_currentLabelWrapper`;
$034ea6c6f9a81818$export$7c8d9d59f518d0c6 = `_83PclW_editedLozengeWrapper`;
$034ea6c6f9a81818$export$2498094d90b6ac72 = `_83PclW_isReadOnly`;
$034ea6c6f9a81818$export$1ded4619033f627b = `_83PclW_manageViewsItem`;
$034ea6c6f9a81818$export$c4ddc81c7b2c8d7a = `_83PclW_view`;
$034ea6c6f9a81818$export$560239d3315fb15a = `_83PclW_viewName`;
$034ea6c6f9a81818$export$fdd07bfcc294413c = `_83PclW_viewSwitcherMenuHeader`;
$034ea6c6f9a81818$export$164f82e58a010d8e = `_83PclW_viewTrigger`;
$034ea6c6f9a81818$export$59a28b0ab50de038 = `_83PclW_viewsList`;
$034ea6c6f9a81818$export$d9a879e41895b0d8 = `_83PclW_viewsListSkeleton`;
$034ea6c6f9a81818$export$b3564392b6dc402a = `_83PclW_withScenarios`;

});



parcelRegister("8G2Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d0120e969cb4f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $74d0120e969cb4f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readOnlyLozengeText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.read-only-lozenge-text",
        "defaultMessage": "Read-Only"
    },
    collapseToolBar: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.collapse-tool-bar",
        "defaultMessage": "Collapse"
    },
    expandToolBar: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.expand-tool-bar",
        "defaultMessage": "Expand"
    },
    planSettingsViewTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings-view-title",
        "defaultMessage": "Plan title, plan settings and view"
    },
    planSettingsTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings-title",
        "defaultMessage": "Plan title and plan settings"
    },
    filterAndChangeViewTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.filter-and-change-view-title",
        "defaultMessage": "Filter issues and change view settings"
    },
    warningsAndAutoSceduleTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings-and-auto-scedule-title",
        "defaultMessage": "View plan warnings, Share your plan and Auto-schedule issues"
    },
    warningsAndShareTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings-and-share-title",
        "defaultMessage": "View plan warnings, Share your plan"
    },
    giveFeedbackTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.give-feedback-title",
        "defaultMessage": "Give feedback"
    },
    giveFeedbackAndReviewTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.give-feedback-and-review-title",
        "defaultMessage": "Give feedback and review changes"
    }
});

});

parcelRegister("2ptMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $de27201be88f0e0e$export$2e2bcd8739ae039);

var $9lwEQ = parcelRequire("9lwEQ");

var $akhOi = parcelRequire("akhOi");

var $kwMvv = parcelRequire("kwMvv");

var $MQRDu = parcelRequire("MQRDu");

var $lNNXV = parcelRequire("lNNXV");

var $evsDb = parcelRequire("evsDb");
const $de27201be88f0e0e$var$mapStateToProps = (state)=>{
    const mode = (0, $akhOi.getMode)(state);
    return {
        showSpinner: mode === (0, $99f9ac26081f8045$export$7536581a3f6533cb),
        selectedIssueCount: (0, $kwMvv.getSelectedIssues)(state).length,
        existingTeams: (0, $MQRDu.getExistingTeams)(state)
    };
};
const $de27201be88f0e0e$var$mapDispatchToProps = (dispatch)=>({
        onOptimize: (analyticsEvent)=>{
            dispatch((0, $9lwEQ.startOptimize)(analyticsEvent));
        }
    });
var $de27201be88f0e0e$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($de27201be88f0e0e$var$mapStateToProps, $de27201be88f0e0e$var$mapDispatchToProps)((0, $evsDb.default));

});
parcelRegister("evsDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd6f93c6d571e27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $9nkwJ = parcelRequire("9nkwJ");

var $dCwmM = parcelRequire("dCwmM");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $bbaTG = parcelRequire("bbaTG");
var $eNhh9 = parcelRequire("eNhh9");
var $eYlCJ = parcelRequire("eYlCJ");
var $gwbfD = parcelRequire("gwbfD");

var $1ni3W = parcelRequire("1ni3W");

var $7CnHa = parcelRequire("7CnHa");

var $3mEM1 = parcelRequire("3mEM1");

var $eg8Ro = parcelRequire("eg8Ro");

var $8sOqP = parcelRequire("8sOqP");
function $9fd6f93c6d571e27$var$Optimize({ existingTeams: existingTeams, onOptimize: onOptimize, selectedIssueCount: selectedIssueCount, showSpinner: showSpinner }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isConfigureDialogOpen, setIsConfigureDialogOpen] = (0, $eUqFw.useState)(false);
    const ref = (0, $eUqFw.useRef)(null);
    const onWindowClick = (0, $eUqFw.useCallback)((e)=>{
        const node = e.target;
        if (!isConfigureDialogOpen || !(0, $7CnHa.isDefined)(ref.current) || node instanceof Element && ref.current.contains(node)) return;
        setIsConfigureDialogOpen(!isConfigureDialogOpen);
    }, [
        isConfigureDialogOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $1ni3W.getBody)().addEventListener('click', onWindowClick);
        return ()=>(0, $1ni3W.getBody)().removeEventListener('click', onWindowClick);
    }, [
        onWindowClick
    ]);
    const onClick = ()=>{
        setIsConfigureDialogOpen(!isConfigureDialogOpen);
    };
    const onPreviewResults = (_, analyticsEvent)=>{
        setIsConfigureDialogOpen(!isConfigureDialogOpen);
        onOptimize(analyticsEvent);
    };
    const getTooltipMessage = ()=>{
        if (existingTeams.length === 0) return formatMessage((0, $eg8Ro.default).noTeamsAvailableTooltip);
        return formatMessage((0, $eg8Ro.default).optimizeTooltip);
    };
    const isButtonDisabled = showSpinner || existingTeams.length === 0;
    const disabledTheme = (current, themeProps)=>({
            ...current(themeProps),
            buttonStyles: {
                ...current(themeProps).buttonStyles,
                background: `var(--ds-background-disabled, ${(0, $g4Vkx.default).N20A})`,
                color: `var(--ds-text-disabled, ${(0, $g4Vkx.default).N70})`,
                cursor: 'not-allowed'
            }
        });
    const buttonIconAfter = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8sOqP.optimizeButtonAfterIcons
    }, selectedIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, selectedIssueCount), showSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.spinner",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $8sOqP.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYlCJ.default), null)));
    const buttonRef = (0, $eUqFw.useRef)(null);
    const handleKeyDownCapture = (e)=>{
        if (e.key === 'Escape') {
            setIsConfigureDialogOpen(false);
            setTimeout(()=>{
                buttonRef.current?.focus();
            });
        }
    };
    const showIconAfter = selectedIssueCount > 0 || showSpinner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        onKeyDownCapture: handleKeyDownCapture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mEM1.default), {
            onPreviewResults: onPreviewResults
        })),
        isOpen: isConfigureDialogOpen,
        onClose: ()=>{
            setTimeout(()=>{
                buttonRef.current?.focus();
            });
        },
        noPaddings: true,
        placement: "bottom-end",
        strategy: (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? 'absolute' : 'fixed'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: getTooltipMessage(),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8sOqP.optimizeButtonIconOnly
    }, isButtonDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...showIconAfter && {
            iconAfter: buttonIconAfter
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dCwmM))), {
            label: ""
        }),
        theme: disabledTheme,
        ref: buttonRef,
        "aria-expanded": isConfigureDialogOpen,
        "aria-label": formatMessage((0, $eg8Ro.default).optimize)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        ...showIconAfter && {
            iconAfter: buttonIconAfter
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dCwmM))), {
            label: ""
        }),
        appearance: "subtle",
        isSelected: isConfigureDialogOpen,
        onClick: onClick,
        ref: buttonRef,
        "aria-expanded": isConfigureDialogOpen,
        ariaLabel: `${formatMessage((0, $eg8Ro.default).optimize)} - ${getTooltipMessage()}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $8sOqP.optimizeButtonLabelOnly
    }, isButtonDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...showIconAfter && {
            iconAfter: buttonIconAfter
        },
        theme: disabledTheme,
        ref: buttonRef,
        "aria-expanded": isConfigureDialogOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eg8Ro.default).optimize)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        ...showIconAfter && {
            iconAfter: buttonIconAfter
        },
        isSelected: isConfigureDialogOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dCwmM))), {
            label: ""
        }),
        ref: buttonRef,
        "aria-expanded": isConfigureDialogOpen,
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eg8Ro.default).optimize)))))));
}
var $9fd6f93c6d571e27$export$2e2bcd8739ae039 = $9fd6f93c6d571e27$var$Optimize;

});
parcelRegister("dCwmM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ea7ee47c0e63562$var$_react = $9ea7ee47c0e63562$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9ea7ee47c0e63562$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9ea7ee47c0e63562$var$ScheduleIcon = (props)=>/*#__PURE__*/ $9ea7ee47c0e63562$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M19 10.341V7.006A2 2 0 0017.006 5H4.994A2 2 0 003 7.006v9.988A2 2 0 004.994 19h6.809a5.96 5.96 0 01-.72-2.001c-3.028 0-6.083-.002-6.083-.005C5 16.994 5 7 4.994 7 4.994 7 17 7 17 7.006V10c.701 0 1.374.12 2 .341z" fill-rule="nonzero"/><path d="M5 4v1h2V4a1 1 0 00-2 0zm10 0v1h2V4a1 1 0 00-2 0zM4 7h14v2H4zm14 8v-1.01a1 1 0 00-1-.99c-.556 0-1 .444-1 .99V15h-1.01a1 1 0 00-.99 1c0 .556.444 1 .99 1H16v1.01a1 1 0 001 .99c.556 0 1-.444 1-.99V17h1.01a1 1 0 00.99-1c0-.556-.444-1-.99-1H18zm-1 6a5 5 0 110-10 5 5 0 010 10z"/></g></svg>`
    }, props));
$9ea7ee47c0e63562$var$ScheduleIcon.displayName = 'ScheduleIcon';
var $9ea7ee47c0e63562$var$_default = $9ea7ee47c0e63562$var$ScheduleIcon;
module.exports.default = $9ea7ee47c0e63562$var$_default;

});

parcelRegister("3mEM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $316f6b011ea20c6b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $d3uws = parcelRequire("d3uws");

var $3R7TQ = parcelRequire("3R7TQ");

var $5jWgk = parcelRequire("5jWgk");
var $316f6b011ea20c6b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3R7TQ.default), (0, $d3uws.default))((0, $5jWgk.default));

});
parcelRegister("d3uws", function(module, exports) {

$parcel$export(module.exports, "default", () => $363a3022b7525304$export$2e2bcd8739ae039);

var $hLlYV = parcelRequire("hLlYV");
const $363a3022b7525304$var$mapDispatchToProps = (dispatch)=>({
        updateAutoScheduleConfiguration: (payload)=>{
            dispatch((0, $hLlYV.updatePlan)({
                autoScheduleConfiguration: payload
            }));
        }
    });
var $363a3022b7525304$export$2e2bcd8739ae039 = $363a3022b7525304$var$mapDispatchToProps;

});

parcelRegister("3R7TQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b5ee3832510b19$export$2e2bcd8739ae039);

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $e9b5ee3832510b19$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    autoScheduleConfiguration: (0, $75KhQ.getAutoScheduleConfiguration),
    selectedIssuesCount: (state)=>(0, $kwMvv.getSelectedIssues)(state).length
});

});

parcelRegister("5jWgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $606aefd56c2004ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");

var $aAyrO = parcelRequire("aAyrO");
var $hnuwz = parcelRequire("hnuwz");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $awiwy = parcelRequire("awiwy");

var $ib5d3 = parcelRequire("ib5d3");

var $49WmB = parcelRequire("49WmB");

var $czJXf = parcelRequire("czJXf");
const $606aefd56c2004ff$var$OVERWRITE_OPTIONS = [
    {
        value: (0, $5rYNM.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).overwriteAllValues)
    },
    {
        value: (0, $5rYNM.AUTO_SCHEDULE_OVERWRITE).EMPTY_VALUES_ONLY,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).overwriteEmptyValuesOnly)
    }
];
const $606aefd56c2004ff$var$OVERWRITE_ISSUE_VALUES = [
    {
        value: (0, $5rYNM.ISSUE_VALUES).SPRINT,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).sprints)
    },
    {
        value: (0, $5rYNM.ISSUE_VALUES).RELEASE,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).releases)
    },
    {
        value: (0, $5rYNM.ISSUE_VALUES).TEAM,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).teams)
    }
];
const $606aefd56c2004ff$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES = {
    [(0, $5rYNM.ISSUE_VALUES).SPRINT]: 'ignoreSprints',
    [(0, $5rYNM.ISSUE_VALUES).RELEASE]: 'ignoreReleases',
    [(0, $5rYNM.ISSUE_VALUES).TEAM]: 'ignoreTeams'
};
class $606aefd56c2004ff$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { onPreviewResults: onPreviewResults, selectedIssuesCount: selectedIssuesCount } = this.props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.topDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.descriptionParagraph
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).selectiveSchedulingDescriptionParagraphOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.descriptionParagraph
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).selectiveSchedulingDescriptionParagraphTwo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.descriptionParagraph
        }, (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            articleId: (0, $5rYNM.IPH_IDS).AUTO_SCHEDULE,
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                href: (0, $awiwy.default).URLs.schedulingWork
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).iphLink)),
            appearance: "link",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).iphLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
            href: (0, $awiwy.default).URLs.schedulingWork
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).learnMore))), selectedIssuesCount > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.selectedIssueCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $49WmB.default).selectiveSchedulingSelectedIssues,
            values: {
                count: selectedIssuesCount
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.configurationSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.overwriteTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall",
            as: "h2",
            id: "overwrite-issue-values-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).overwriteTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            id: "overwrite-issue-values-desc",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$czJXf.textSizeH200} ${$czJXf.overwriteDescription}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).overwriteDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "grid",
            "aria-labelledby": "overwrite-issue-values-title",
            "aria-describedby": "overwrite-issue-values-desc",
            "aria-busy": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "rowgroup"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "row",
            className: $czJXf.configurationTableHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.optionsHeader
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.issueValuesHeader
        }, $606aefd56c2004ff$var$OVERWRITE_ISSUE_VALUES.map(({ label: label, value: value }, colIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                id: `column-${colIndex}`,
                role: "columnheader",
                key: value,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $czJXf.textSizeH200
            }, label))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "rowgroup",
            className: $czJXf.configurationTableContent
        }, $606aefd56c2004ff$var$OVERWRITE_OPTIONS.map(({ label: label, value: optionValue }, rowIndex)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                role: "row",
                key: optionValue,
                className: $czJXf.configurationOptionRow
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                id: `row-${rowIndex}`,
                role: "rowheader",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${$czJXf.optionsContent} ${$czJXf.textSizeH200}`
            }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $czJXf.issueValueSelection
            }, $606aefd56c2004ff$var$OVERWRITE_ISSUE_VALUES.map(({ value: issueValue }, colIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    role: "gridcell",
                    key: issueValue
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
                    isChecked: this.isOptionSelected(issueValue, optionValue),
                    "aria-labelledby": `column-${colIndex} row-${rowIndex}`,
                    name: issueValue,
                    value: optionValue,
                    onChange: ()=>this.onConfigurationChange(issueValue, optionValue)
                }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $czJXf.actionFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.preview-results",
            appearance: "primary",
            onClick: onPreviewResults
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49WmB.default).previewResults)))))));
    }
    constructor(...args){
        super(...args);
        this.isOptionSelected = (issueValue, overwriteOption)=>{
            const { autoScheduleConfiguration: autoScheduleConfiguration } = this.props;
            const apiKey = $606aefd56c2004ff$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES[issueValue];
            return (0, $7CnHa.isDefined)(autoScheduleConfiguration) && (autoScheduleConfiguration[apiKey] === true && overwriteOption === (0, $5rYNM.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES || autoScheduleConfiguration[apiKey] === false && overwriteOption === (0, $5rYNM.AUTO_SCHEDULE_OVERWRITE).EMPTY_VALUES_ONLY);
        };
        this.onConfigurationChange = (issueValue, overwriteOption)=>{
            this.props.updateAutoScheduleConfiguration({
                [$606aefd56c2004ff$var$API_KEYS_FOR_OVERWRITE_ISSUE_VALUES[issueValue]]: overwriteOption === (0, $5rYNM.AUTO_SCHEDULE_OVERWRITE).ALL_VALUES
            });
        };
    }
}

});
parcelRegister("49WmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eba580aeafdea24$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9eba580aeafdea24$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectiveSchedulingDescriptionParagraphOne: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-description-paragraph-one",
        "defaultMessage": "Select which estimated issues you want to auto-schedule using the checkboxes in the Scope section of your plan."
    },
    selectiveSchedulingDescriptionParagraphTwo: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-description-paragraph-two",
        "defaultMessage": "If you select none, the auto-scheduler will create a plan for all of your estimated issues based on their ranking, the velocity of teams in your plan, and any dependencies you set."
    },
    learnMore: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.learn-more",
        "defaultMessage": "More about estimating and scheduling issues"
    },
    iphLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.iph-link",
        "defaultMessage": "See what the auto-scheduler does"
    },
    selectiveSchedulingSelectedIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.selective-scheduling-selected-issues",
        "defaultMessage": "{count, plural, one {# issue} other {# issues}} selected"
    },
    overwriteTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-title",
        "defaultMessage": "Overwriting issue values"
    },
    overwriteDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-description",
        "defaultMessage": "You can choose to overwrite fields that have existing values, or to set values only if the fields are empty."
    },
    overwriteAllValues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-all-values",
        "defaultMessage": "All values"
    },
    overwriteEmptyValuesOnly: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.overwrite-empty-values-only",
        "defaultMessage": "Empty values only"
    },
    previewResults: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.configuration-dialog.preview-results",
        "defaultMessage": "Preview results"
    }
});

});

parcelRegister("czJXf", function(module, exports) {

$parcel$export(module.exports, "actionFooter", () => $927c6692864f8546$export$c4cc592d9243d26f, (v) => $927c6692864f8546$export$c4cc592d9243d26f = v);
$parcel$export(module.exports, "configurationOptionRow", () => $927c6692864f8546$export$32cce1bfe9972049, (v) => $927c6692864f8546$export$32cce1bfe9972049 = v);
$parcel$export(module.exports, "configurationSection", () => $927c6692864f8546$export$2f6b858d2dafa41f, (v) => $927c6692864f8546$export$2f6b858d2dafa41f = v);
$parcel$export(module.exports, "configurationTableContent", () => $927c6692864f8546$export$a1e1ff5fd61ffaa6, (v) => $927c6692864f8546$export$a1e1ff5fd61ffaa6 = v);
$parcel$export(module.exports, "configurationTableHeader", () => $927c6692864f8546$export$5eb22442b30132f0, (v) => $927c6692864f8546$export$5eb22442b30132f0 = v);
$parcel$export(module.exports, "container", () => $927c6692864f8546$export$34e0f9847d4c02dd, (v) => $927c6692864f8546$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "descriptionParagraph", () => $927c6692864f8546$export$1f4ab7e80c81cd5a, (v) => $927c6692864f8546$export$1f4ab7e80c81cd5a = v);
$parcel$export(module.exports, "issueValueSelection", () => $927c6692864f8546$export$f7a502964befde9d, (v) => $927c6692864f8546$export$f7a502964befde9d = v);
$parcel$export(module.exports, "issueValuesHeader", () => $927c6692864f8546$export$58488719ec949635, (v) => $927c6692864f8546$export$58488719ec949635 = v);
$parcel$export(module.exports, "optionsContent", () => $927c6692864f8546$export$cdad7d6f330222f7, (v) => $927c6692864f8546$export$cdad7d6f330222f7 = v);
$parcel$export(module.exports, "optionsHeader", () => $927c6692864f8546$export$e13f53816edc1a22, (v) => $927c6692864f8546$export$e13f53816edc1a22 = v);
$parcel$export(module.exports, "overwriteDescription", () => $927c6692864f8546$export$1b7365b65607ab6, (v) => $927c6692864f8546$export$1b7365b65607ab6 = v);
$parcel$export(module.exports, "overwriteTitle", () => $927c6692864f8546$export$3cd49a6a901c298c, (v) => $927c6692864f8546$export$3cd49a6a901c298c = v);
$parcel$export(module.exports, "selectedIssueCount", () => $927c6692864f8546$export$4c800cfa9cf69f7, (v) => $927c6692864f8546$export$4c800cfa9cf69f7 = v);
$parcel$export(module.exports, "textSizeH200", () => $927c6692864f8546$export$5ac20e88bf8a38cb, (v) => $927c6692864f8546$export$5ac20e88bf8a38cb = v);
$parcel$export(module.exports, "topDescription", () => $927c6692864f8546$export$8b2bc455bfb5f6da, (v) => $927c6692864f8546$export$8b2bc455bfb5f6da = v);
var $927c6692864f8546$export$c4cc592d9243d26f;
var $927c6692864f8546$export$32cce1bfe9972049;
var $927c6692864f8546$export$2f6b858d2dafa41f;
var $927c6692864f8546$export$a1e1ff5fd61ffaa6;
var $927c6692864f8546$export$5eb22442b30132f0;
var $927c6692864f8546$export$34e0f9847d4c02dd;
var $927c6692864f8546$export$1f4ab7e80c81cd5a;
var $927c6692864f8546$export$f7a502964befde9d;
var $927c6692864f8546$export$58488719ec949635;
var $927c6692864f8546$export$cdad7d6f330222f7;
var $927c6692864f8546$export$e13f53816edc1a22;
var $927c6692864f8546$export$1b7365b65607ab6;
var $927c6692864f8546$export$3cd49a6a901c298c;
var $927c6692864f8546$export$4c800cfa9cf69f7;
var $927c6692864f8546$export$5ac20e88bf8a38cb;
var $927c6692864f8546$export$8b2bc455bfb5f6da;
$927c6692864f8546$export$c4cc592d9243d26f = `q0XS9W_actionFooter`;
$927c6692864f8546$export$32cce1bfe9972049 = `q0XS9W_configurationOptionRow`;
$927c6692864f8546$export$2f6b858d2dafa41f = `q0XS9W_configurationSection`;
$927c6692864f8546$export$a1e1ff5fd61ffaa6 = `q0XS9W_configurationTableContent`;
$927c6692864f8546$export$5eb22442b30132f0 = `q0XS9W_configurationTableHeader`;
$927c6692864f8546$export$34e0f9847d4c02dd = `q0XS9W_container`;
$927c6692864f8546$export$1f4ab7e80c81cd5a = `q0XS9W_descriptionParagraph`;
$927c6692864f8546$export$f7a502964befde9d = `q0XS9W_issueValueSelection`;
$927c6692864f8546$export$58488719ec949635 = `q0XS9W_issueValuesHeader`;
$927c6692864f8546$export$cdad7d6f330222f7 = `q0XS9W_optionsContent`;
$927c6692864f8546$export$e13f53816edc1a22 = `q0XS9W_optionsHeader`;
$927c6692864f8546$export$1b7365b65607ab6 = `q0XS9W_overwriteDescription`;
$927c6692864f8546$export$3cd49a6a901c298c = `q0XS9W_overwriteTitle`;
$927c6692864f8546$export$4c800cfa9cf69f7 = `q0XS9W_selectedIssueCount`;
$927c6692864f8546$export$5ac20e88bf8a38cb = `q0XS9W_textSizeH200`;
$927c6692864f8546$export$8b2bc455bfb5f6da = `q0XS9W_topDescription`;

});



parcelRegister("eg8Ro", function(module, exports) {

$parcel$export(module.exports, "default", () => $0da0b84794a3e23e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0da0b84794a3e23e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    optimize: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.optimize",
        "defaultMessage": "Auto-schedule"
    },
    optimizeTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.optimize-tooltip",
        "defaultMessage": "Schedule work based on estimates"
    },
    noTeamsAvailableTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.optimize.no-teams-available-tooltip",
        "defaultMessage": "Add a team to your plan to auto-schedule issues"
    }
});

});

parcelRegister("8sOqP", function(module, exports) {

$parcel$export(module.exports, "optimizeButtonAfterIcons", () => $62980ef08a9a1d65$export$e48a95239c5524fa, (v) => $62980ef08a9a1d65$export$e48a95239c5524fa = v);
$parcel$export(module.exports, "optimizeButtonIconOnly", () => $62980ef08a9a1d65$export$15f0da71eb6e87f0, (v) => $62980ef08a9a1d65$export$15f0da71eb6e87f0 = v);
$parcel$export(module.exports, "optimizeButtonLabelOnly", () => $62980ef08a9a1d65$export$2a6a8de8f55597e9, (v) => $62980ef08a9a1d65$export$2a6a8de8f55597e9 = v);
$parcel$export(module.exports, "spinnerContainer", () => $62980ef08a9a1d65$export$140fd7bd1291a3e4, (v) => $62980ef08a9a1d65$export$140fd7bd1291a3e4 = v);
var $62980ef08a9a1d65$export$e48a95239c5524fa;
var $62980ef08a9a1d65$export$15f0da71eb6e87f0;
var $62980ef08a9a1d65$export$2a6a8de8f55597e9;
var $62980ef08a9a1d65$export$140fd7bd1291a3e4;
$62980ef08a9a1d65$export$e48a95239c5524fa = `viPLjG_optimizeButtonAfterIcons`;
$62980ef08a9a1d65$export$15f0da71eb6e87f0 = `viPLjG_optimizeButtonIconOnly`;
$62980ef08a9a1d65$export$2a6a8de8f55597e9 = `viPLjG_optimizeButtonLabelOnly`;
$62980ef08a9a1d65$export$140fd7bd1291a3e4 = `viPLjG_spinnerContainer`;

});



parcelRegister("aDD34", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c339a08dc40f77$export$2e2bcd8739ae039);

var $jufFm = parcelRequire("jufFm");

var $lNNXV = parcelRequire("lNNXV");

var $cxyf4 = parcelRequire("cxyf4");

var $ap1ao = parcelRequire("ap1ao");

var $cJBkX = parcelRequire("cJBkX");
var $d8c339a08dc40f77$export$2e2bcd8739ae039 = (0, $jufFm.default)((0, $lNNXV.connect)((0, $ap1ao.default), (0, $cxyf4.default))((0, $cJBkX.default)));

});
parcelRegister("cxyf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $37291ffe7dd3436c$export$2e2bcd8739ae039);

var $6hfzF = parcelRequire("6hfzF");

var $hLlYV = parcelRequire("hLlYV");

var $48HOG = parcelRequire("48HOG");

var $9G8kJ = parcelRequire("9G8kJ");

var $lFLge = parcelRequire("lFLge");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$37291ffe7dd3436c$export$2e2bcd8739ae039 = (dispatch)=>({
        toggleOpenDeleteDialog: (visibility)=>dispatch((0, $48HOG.setDeleteDialogVisibility)(visibility)),
        redirectToSettings: (redirectFrom)=>{
            dispatch((0, $48HOG.redirectToSettings)(redirectFrom));
            (0, $lFLge.redirectToSettings)();
        },
        showOnboarding: ()=>{
            dispatch((0, $6hfzF.setIntroOpen)(true));
        },
        onDeletePlan: ()=>dispatch((0, $hLlYV.deletePlan)()),
        toggleToolBar: ()=>{
            dispatch((0, $9G8kJ.toggleToolBar)());
        }
    });

});

parcelRegister("ap1ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $b810f32a5200ada4$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $beuE2 = parcelRequire("beuE2");

var $iK4oF = parcelRequire("iK4oF");
const $b810f32a5200ada4$export$203ed8b65c3b2a28 = (state)=>(0, $75KhQ.getPlan)(state).id;
const $b810f32a5200ada4$export$3a977cd83f945733 = (state)=>(0, $75KhQ.getPlan)(state).title;
const $b810f32a5200ada4$export$d45aa4efc65a4c49 = (state)=>state.ui.Top.TitleBar.PlanSettings.deleteDialogOpen;
const $b810f32a5200ada4$export$6e16d0dea41c32a = (state)=>state.ui.Top.TitleBar.PlanSettings.deleteButtonEnabled;
var $b810f32a5200ada4$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    deleteButtonEnabled: $b810f32a5200ada4$export$6e16d0dea41c32a,
    deleteDialogOpen: $b810f32a5200ada4$export$d45aa4efc65a4c49,
    isReadOnly: $akhOi.isReadOnly,
    planTitle: $b810f32a5200ada4$export$3a977cd83f945733,
    planId: $b810f32a5200ada4$export$203ed8b65c3b2a28,
    showToolBar: (0, $beuE2.getToolBarVisibilityState)
});

});

parcelRegister("cJBkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd7576f0242bf2a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $jG1wZ = parcelRequire("jG1wZ");

var $5318D = parcelRequire("5318D");

var $iw0Y6 = parcelRequire("iw0Y6");

var $23NQ5 = parcelRequire("23NQ5");

var $fEMj1 = parcelRequire("fEMj1");

var $k8Qyf = parcelRequire("k8Qyf");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $3XRVl = parcelRequire("3XRVl");
var $fEubG = parcelRequire("fEubG");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $gwbfD = parcelRequire("gwbfD");

var $c6Xop = parcelRequire("c6Xop");


var $cuuJa = parcelRequire("cuuJa");

var $hNBHk = parcelRequire("hNBHk");

var $hjY2n = parcelRequire("hjY2n");

var $ib5d3 = parcelRequire("ib5d3");

var $lFLge = parcelRequire("lFLge");

var $jMP2a = parcelRequire("jMP2a");

var $5VnQt = parcelRequire("5VnQt");

var $4ayzL = parcelRequire("4ayzL");
function $cd7576f0242bf2a3$var$PlanSettings(props) {
    const { planTitle: planTitle, planId: planId, toggleOpenDeleteDialog: toggleOpenDeleteDialog, onDeletePlan: onDeletePlan, intl: intl, deleteDialogOpen: deleteDialogOpen, deleteButtonEnabled: deleteButtonEnabled, isReadOnly: isReadOnly, defaultOpen: defaultOpen, redirectToSettings: redirectToSettings, showOnboarding: showOnboarding, history: history } = props;
    const [isPlanDuplicatingModalOpen, setIsPlanDuplicatingModalOpen] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const goToSettings = ()=>{
        const redirectFrom = window.location.hash.slice(1);
        redirectToSettings(`/${redirectFrom.split('/')[1]}`);
    };
    const openPlanDuplicatingModal = ()=>{
        setIsPlanDuplicatingModalOpen(true);
    };
    const closePlanDuplicatingModal = ()=>{
        setIsPlanDuplicatingModalOpen(false);
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const onPlanDuplicatingComplete = (planId, scenarioId)=>{
        setIsPlanDuplicatingModalOpen(false);
        (0, $lFLge.redirectToPlan)(planId, scenarioId);
    };
    const onPlanDuplicatingError = ()=>{
        setIsPlanDuplicatingModalOpen(false);
        showFlag({
            id: (0, $b25041d009c1ef55$export$51b62d6ed94805c9),
            type: 'error',
            title: (0, $5VnQt.default).planDuplicatedFlagError
        });
    };
    const nonReadOnlyMenuItemsBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iw0Y6))), {
            label: intl.formatMessage((0, $5VnQt.default).configure),
            size: "small"
        }),
        onClick: goToSettings
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5VnQt.default).configure)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: intl.formatMessage((0, $5VnQt.default).duplicate),
            size: "small"
        }),
        isDisabled: isReadOnly,
        onClick: openPlanDuplicatingModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5VnQt.default).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4ayzL.planSettingsDivider
    }));
    const nonReadOnlyMenuItemsAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4ayzL.planSettingsDivider
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEMj1))), {
            label: intl.formatMessage((0, $5VnQt.default).delete),
            size: "small"
        }),
        isDisabled: isReadOnly,
        onClick: ()=>toggleOpenDeleteDialog(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5VnQt.default).delete)));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $4ayzL.planSettings,
        onMouseEnter: ()=>(0, $hNBHk.preload)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $5VnQt.default).planSettings)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
        defaultOpen: defaultOpen,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings",
        // eslint-disable-next-line @typescript-eslint/no-shadow
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                ref: triggerRef,
                appearance: "subtle",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: ""
                }),
                "aria-label": intl.formatMessage((0, $5VnQt.default).planSettings)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, nonReadOnlyMenuItemsBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5318D))), {
            label: intl.formatMessage((0, $5VnQt.default).takeTour),
            size: "small"
        }),
        onClick: ()=>{
            history && history.push('/backlog');
            // the toolbar must be expanded before starting the onboarding tour
            if (!props.showToolBar) props.toggleToolBar();
            showOnboarding();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5VnQt.default).takeTour)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            label: "",
            size: "small"
        }),
        href: (0, $hjY2n.default).home,
        onClick: (_, analyticsEvent)=>{
            const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).HEADER_HELP_LINK_CLICKED.split(' ');
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }));
        },
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5VnQt.default).helpLink)), !isReadOnly && nonReadOnlyMenuItemsAfter))), planId && isPlanDuplicatingModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6Xop.default), {
        planId: planId,
        planTitle: planTitle || '',
        onClose: closePlanDuplicatingModal,
        onComplete: onPlanDuplicatingComplete,
        onError: onPlanDuplicatingError
    }), deleteDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: true,
        onClose: ()=>toggleOpenDeleteDialog(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "danger"
    }, intl.formatMessage((0, $5VnQt.default).deletePlanHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $5VnQt.default).deletePlanDescription,
        values: {
            planTitle: planTitle,
            // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>toggleOpenDeleteDialog(false),
        isDisabled: false,
        appearance: "subtle"
    }, intl.formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>onDeletePlan(),
        isDisabled: !deleteButtonEnabled,
        appearance: "danger"
    }, intl.formatMessage((0, $5VnQt.default).delete))))));
}
var $cd7576f0242bf2a3$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cd7576f0242bf2a3$var$PlanSettings);

});
parcelRegister("c6Xop", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a61df1b0265d2c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $d1a61df1b0265d2c$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lKkyn")), {
    moduleId: "./src/packages/portfolio-3/plan-duplicating/src/index.tsx"
});
const $d1a61df1b0265d2c$var$AsyncComponent = ({ fallback: fallback, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-portfolio-3-plan-duplicating",
        fallback: "flag",
        packageName: "jira-plan-duplicating"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "plan-duplicating",
        fallback: fallback !== undefined ? fallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d1a61df1b0265d2c$var$LazyComponent, props)));
$d1a61df1b0265d2c$var$AsyncComponent.defaultProps = {
    fallback: undefined
};
var $d1a61df1b0265d2c$export$2e2bcd8739ae039 = $d1a61df1b0265d2c$var$AsyncComponent;

});
parcelRegister("lKkyn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('35Gpy')
        ]);
        const value = parcelRequire('f7lS8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("35Gpy")
    ]).then(()=>parcelRequire('f7lS8'));
}

});


const $b25041d009c1ef55$export$f27a837467ec20e5 = 'jiraPortfolio3PlanDuplicating';
const $b25041d009c1ef55$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $b25041d009c1ef55$export$51b62d6ed94805c9 = 'duplicatePlanError';
const $b25041d009c1ef55$export$62da4a2465b3b309 = 255;

parcelRegister("hNBHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $07036a500a9078da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "preload", () => $07036a500a9078da$export$513ccb98c53b8039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $gGtKh = parcelRequire("gGtKh");
const $07036a500a9078da$var$METRIC_KEY = 'LOAD_START_ADVANCED_ROADMAPS_SETTINGS_PAGE';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $07036a500a9078da$var$Page = (0, $7rh0R.lazy)(()=>(parcelRequire("d5Gg3")), {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/portfolio/src/app-simple-plans/view/settings/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07036a500a9078da$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "advanced-roadmaps-settings-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $07036a500a9078da$var$METRIC_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($07036a500a9078da$var$Page, props));
const $07036a500a9078da$export$513ccb98c53b8039 = $07036a500a9078da$var$Page.preload;

});
parcelRegister("d5Gg3", function(module, exports) {






if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("bRgvT")),
            load('h2MrD'),
            load('bYT2S'),
            load('flfQm')
        ]);
        const value = parcelRequire('47gVE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        (parcelRequire("e5kw4"))((parcelRequire("bjqNS")).resolve("bRgvT")),
        load("h2MrD"),
        load("bYT2S"),
        load("flfQm")
    ]).then(()=>parcelRequire('47gVE'));
}

});


parcelRegister("5VnQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff474597b921bad1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ff474597b921bad1$var$messages = (0, $90IgZ.defineMessages)({
    deletePlanDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete-plan-description",
        "defaultMessage": "Please confirm that you want to permanently delete the plan <strong>{planTitle}</strong>."
    },
    deletePlanHeading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete-plan-heading",
        "defaultMessage": "Delete plan"
    },
    delete: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.delete",
        "defaultMessage": "Delete"
    },
    configure: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.configure",
        "defaultMessage": "Configure"
    },
    duplicate: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.duplicate",
        "defaultMessage": "Duplicate"
    },
    takeTour: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.take-tour",
        "defaultMessage": "Take tour"
    },
    helpLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.help-link",
        "defaultMessage": "Get help"
    },
    planSettings: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.plan-settings",
        "defaultMessage": "Plan settings"
    },
    planDuplicatedFlagError: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.plan-settings.plan-duplicated-flag-error",
        "defaultMessage": "There was an error when trying to duplicate your plan"
    }
});
var $ff474597b921bad1$export$2e2bcd8739ae039 = $ff474597b921bad1$var$messages;

});

parcelRegister("4ayzL", function(module, exports) {

$parcel$export(module.exports, "planSettings", () => $3092eaa9532f92f3$export$eac178460b8cc3d5, (v) => $3092eaa9532f92f3$export$eac178460b8cc3d5 = v);
$parcel$export(module.exports, "planSettingsDivider", () => $3092eaa9532f92f3$export$24cd15837060266a, (v) => $3092eaa9532f92f3$export$24cd15837060266a = v);
var $3092eaa9532f92f3$export$eac178460b8cc3d5;
var $3092eaa9532f92f3$export$24cd15837060266a;
$3092eaa9532f92f3$export$eac178460b8cc3d5 = `GQ2yHa_planSettings`;
$3092eaa9532f92f3$export$24cd15837060266a = `GQ2yHa_planSettingsDivider`;

});



parcelRegister("71Qj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31db80de77f52cc$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cEWBC = parcelRequire("cEWBC");

var $joPE7 = parcelRequire("joPE7");

var $31CqG = parcelRequire("31CqG");
var $a31db80de77f52cc$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $joPE7.default), (0, $cEWBC.default))((0, $31CqG.default));

});
parcelRegister("cEWBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6bb01809d42eda1$export$2e2bcd8739ae039);

var $eelZZ = parcelRequire("eelZZ");
parcelRequire("6mH6C");
var $j9mlP = parcelRequire("j9mlP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6bb01809d42eda1$export$2e2bcd8739ae039 = {
    createScenario: $eelZZ.createScenario,
    toggleDialogVisibility: $j9mlP.toggleDialogVisibility
};

});
parcelRegister("6mH6C", function(module, exports) {

$parcel$export(module.exports, "toggleDialogVisibility", () => (parcelRequire("j9mlP")).toggleDialogVisibility);
// eslint-disable-next-line jira/export/no-external-exports

var $j9mlP = parcelRequire("j9mlP");

});


parcelRegister("joPE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $15a1118b5f32531e$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
const $15a1118b5f32531e$var$isScenariosDialogOpen = (state)=>state.ui.Settings.Scenarios.isModalDialogOpen;
const $15a1118b5f32531e$var$isProcessingRequest = (state)=>state.ui.Settings.Scenarios.isProcessingRequest;
var $15a1118b5f32531e$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    currentScenarioId: $75KhQ.currentScenarioId,
    isMultiScenarioEnabled: $75KhQ.isMultiScenarioEnabled,
    isProcessingRequest: $15a1118b5f32531e$var$isProcessingRequest,
    isReadOnly: $akhOi.isReadOnly,
    isScenariosDialogOpen: $15a1118b5f32531e$var$isScenariosDialogOpen,
    mode: (0, $akhOi.getMode),
    planScenarios: (0, $75KhQ.getPlanScenarios)
});

});

parcelRegister("31CqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $99bf1c6688d50989$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3by2Y = parcelRequire("3by2Y");
var $h3f0m = parcelRequire("h3f0m");
var $eWC3M = parcelRequire("eWC3M");

var $86Ndv = parcelRequire("86Ndv");

var $bZ1Zi = parcelRequire("bZ1Zi");

var $bkIGg = parcelRequire("bkIGg");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $3XRVl = parcelRequire("3XRVl");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");
var $gwbfD = parcelRequire("gwbfD");
parcelRequire("akhOi");

var $civR8 = parcelRequire("civR8");

var $7CnHa = parcelRequire("7CnHa");

var $7Iub8 = parcelRequire("7Iub8");

var $lFLge = parcelRequire("lFLge");

var $51ACp = parcelRequire("51ACp");

var $ueytZ = parcelRequire("ueytZ");

var $3j9Gh = parcelRequire("3j9Gh");
// eslint-disable-next-line jira/react/no-class-components
class $99bf1c6688d50989$var$Scenarios extends (0, $eUqFw.Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static getDerivedStateFromProps(props, state) {
        if (state.selectedScenarioId !== props.currentScenarioId) return {
            ...state,
            selectedScenarioId: props.currentScenarioId
        };
        return null;
    }
    render() {
        const { planScenarios: planScenarios, isMultiScenarioEnabled: isMultiScenarioEnabled, isProcessingRequest: isProcessingRequest, createScenario: createScenario, isScenariosDialogOpen: isScenariosDialogOpen, toggleDialogVisibility: toggleDialogVisibility, isReadOnly: isReadOnly, mode: mode } = this.props;
        const { selectedScenarioId: selectedScenarioId, isDropMenuOpen: isDropMenuOpen } = this.state;
        if (isMultiScenarioEnabled !== true || !(0, $7CnHa.isDefined)(planScenarios) || planScenarios.length < 1) return null;
        const selectedScenario = planScenarios.find((scenario)=>scenario.id === selectedScenarioId);
        const triggerTitle = selectedScenario ? selectedScenario.title : '';
        const selectedScenarioColor = selectedScenario ? selectedScenario.color : '';
        if (isReadOnly) return this.renderScenarioTitle(triggerTitle, selectedScenarioColor);
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3j9Gh.scenarioWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                    content: triggerTitle,
                    position: "bottom"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: ""
                    }),
                    isSelected: isDropMenuOpen,
                    ref: triggerRef,
                    ...props
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $3j9Gh.scenarioButton
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: $3j9Gh.scenarioSwatch,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        backgroundColor: selectedScenarioColor
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `${$3j9Gh.scenarioTitle} ${mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) ? $3j9Gh.isReportMode : ''}`
                }, triggerTitle)))),
            onOpenChange: this.onOpenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3j9Gh.scenarioSwitcherMenuHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ueytZ.default).scenarios)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $3j9Gh.scenariosList
        }, this.scenarioListRenderer()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bkIGg))), {
                label: ""
            }),
            onClick: ()=>{
                toggleDialogVisibility(true);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ueytZ.default).createScenario)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
                label: ""
            }),
            onClick: ()=>(0, $lFLge.redirectToSettingsSubPage)('scenarios')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ueytZ.default).manageScenarios))), isScenariosDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $civR8.default), {
            isProcessingRequest: isProcessingRequest,
            isMultiScenarioEnabled: isMultiScenarioEnabled,
            createScenario: (payload)=>createScenario({
                    ...payload,
                    redirect: true
                }),
            onClose: ()=>{
                toggleDialogVisibility(false);
            }
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedScenarioId: this.props.currentScenarioId,
            isDropMenuOpen: false
        };
        this.onScenarioChange = (sid)=>{
            const { currentScenarioId: currentScenarioId } = this.props;
            if (currentScenarioId === sid) return;
            this.setState(()=>({
                    selectedScenarioId: sid
                }));
            (0, $lFLge.redirectToNewScenario)(this.props.history, sid);
        };
        this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState({
                isDropMenuOpen: isOpen
            });
        };
        this.scenarioListRenderer = ()=>{
            const { selectedScenarioId: selectedScenarioId } = this.state;
            // reordering the scenarios to put the active scenario first
            const scenarios = $eWC3M.default($3by2Y.default($h3f0m.default('id', selectedScenarioId), this.props.planScenarios));
            return scenarios.map(({ color: color, id: id, title: title })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    key: id,
                    className: selectedScenarioId === id ? $3j9Gh.activeScenarioItem : ''
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XRVl.DropMenuItem), {
                    elemBefore: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                        className: $3j9Gh.scenarioItemColor,
                        style: {
                            backgroundColor: color
                        }
                    }),
                    id: id,
                    isSelected: selectedScenarioId === id,
                    onClick: ()=>{
                        this.onScenarioChange(id);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Iub8.default), {
                    content: title,
                    id: id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, title)))));
        };
        this.renderScenarioTitle = (scenarioTitle, color)=>{
            const { mode: mode } = this.props;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $3j9Gh.scenarioReadOnlyWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: scenarioTitle,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $3j9Gh.scenario
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $3j9Gh.scenarioSwatch,
                style: {
                    backgroundColor: color
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${$3j9Gh.scenarioTitle} ${mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) ? ` ${$3j9Gh.isReportMode}` : ''}`
            }, scenarioTitle)))));
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $99bf1c6688d50989$var$ScenariosWithHistory = (props)=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99bf1c6688d50989$var$Scenarios, {
            history: history,
            ...props
        }));
var $99bf1c6688d50989$export$2e2bcd8739ae039 = (0, $2qhQi.default)($99bf1c6688d50989$var$ScenariosWithHistory);
const $99bf1c6688d50989$export$fdb9142e471a5606 = (0, $2qhQi.default)($99bf1c6688d50989$var$Scenarios);

});
parcelRegister("civR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $353a05be2af36693$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gfink = parcelRequire("gfink");

var $7Zdv5 = parcelRequire("7Zdv5");
var $353a05be2af36693$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gfink.default), {})((0, $7Zdv5.default));

});
parcelRegister("gfink", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7af40a7f3ebd98$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
var $cb7af40a7f3ebd98$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    currentScenarioId: $75KhQ.currentScenarioId,
    planScenarios: (0, $75KhQ.getPlanScenarios)
});

});

parcelRegister("7Zdv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $16833b250948f38d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9FeHi = parcelRequire("9FeHi");

var $cPAcJ = parcelRequire("cPAcJ");
var $jeetE = parcelRequire("jeetE");

var $PdmhA = parcelRequire("PdmhA");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("akSC8");
var $5wCDk = parcelRequire("5wCDk");parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $lzLxZ = parcelRequire("lzLxZ");
var $lfiOu = parcelRequire("lfiOu");
var $2RVAX = parcelRequire("2RVAX");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $hiIej = parcelRequire("hiIej");parcelRequire("aAyrO");
var $7u4fN = parcelRequire("7u4fN");

var $7CnHa = parcelRequire("7CnHa");

var $2xinl = parcelRequire("2xinl");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $UPC9W = parcelRequire("UPC9W");

var $21ZWY = parcelRequire("21ZWY");
const $16833b250948f38d$var$SCENARIO_TYPES = {
    BLANK: 'blank',
    COPY: 'copy'
};
class $16833b250948f38d$export$cf131c1c2576cfd8 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.buttonRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.submitForm = (fields)=>{
            const { scenarioTitle: scenarioTitle, scenarioColour: scenarioColour } = fields;
            const payload = {
                title: scenarioTitle.trim(),
                color: scenarioColour
            };
            // if fields.scenarioType is undefined, it means that the user is enabling scenarios in the plan
            // we then need to create a scenario which is a "copy" of the current scenario, although it is not technically a copy
            if (!fields.scenarioType) payload.scenarioId = this.props.currentScenarioId;
            else if (fields.scenarioType === $16833b250948f38d$var$SCENARIO_TYPES.COPY) payload.scenarioId = fields.scenarioId.value;
            this.props.createScenario(payload);
        };
        this.setScenarioTitleFieldValidity = (isValid)=>{
            this.setState({
                isScenarioTitleFieldValid: isValid
            });
        };
        this.validateScenarioTitle = (scenarioTitle)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            if (!(0, $7CnHa.isDefined)(scenarioTitle)) {
                this.setScenarioTitleFieldValidity(false);
                return '';
            }
            if (scenarioTitle.trim() === '') {
                this.setScenarioTitleFieldValidity(false);
                return formatMessage((0, $UPC9W.default).scenarioTitleEmpty);
            }
            if (scenarioTitle.length > 255) {
                this.setScenarioTitleFieldValidity(false);
                return formatMessage((0, $UPC9W.default).titleLengthValidation);
            }
            this.setScenarioTitleFieldValidity(true);
            return '';
        };
        this.getDefaultScenarioOption = ()=>this.getScenarioOptions().find(({ value: value })=>value === this.props.currentScenarioId);
        this.getScenarioOptions = ()=>{
            const { currentScenarioId: currentScenarioId, intl: { formatMessage: formatMessage }, planScenarios: planScenarios = [] } = this.props;
            return planScenarios.map(({ id: id, title: title })=>({
                    label: `${title} ${id === currentScenarioId ? formatMessage((0, $UPC9W.default).currentScenarioLabel) : ''}`,
                    value: id
                }));
        };
        this.getDefaultColour = ()=>{
            const { planScenarios: planScenarios = [] } = this.props;
            const colors = $9FeHi.default((0, $33N5G.colourPickerPalette), planScenarios.map(({ color: color })=>color));
            return colors[0] || (0, $33N5G.colourPickerPalette)[0];
        };
        this.state = {
            isScenarioTitleFieldValid: false // defaulted to false since the field is required
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, isMultiScenarioEnabled: isMultiScenarioEnabled = false, isProcessingRequest: isProcessingRequest, onClose: onClose, planScenarios: planScenarios = [] } = this.props;
        const { isScenarioTitleFieldValid: isScenarioTitleFieldValid } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
            autoFocus: true,
            onClose: onClose,
            shouldCloseOnEscapePress: !isProcessingRequest,
            shouldCloseOnOverlayClick: !isProcessingRequest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage(isMultiScenarioEnabled ? (0, $UPC9W.default).dialogTitle : (0, $UPC9W.default).dialogTitleFirstScenario))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginBottom: "var(--ds-space-300, 24px)"
            }
        }, formatMessage((0, $UPC9W.default).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null)), !isMultiScenarioEnabled && formatMessage((0, $UPC9W.default).firstScenarioDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
            onSubmit: this.submitForm
        }, ({ formProps: formProps, getState: getState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $21ZWY.scenarioTitleAndColourFields
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $21ZWY.scenarioTitle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                "aria-required": true,
                defaultValue: isMultiScenarioEnabled ? undefined : planScenarios[0].title,
                isDisabled: isProcessingRequest,
                isRequired: true,
                label: formatMessage((0, $UPC9W.default).scenarioTitle),
                name: "scenarioTitle",
                validate: this.validateScenarioTitle
            }, ({ fieldProps: fieldProps, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ...fieldProps,
                    testId: "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.title",
                    onBlur: (value)=>fieldProps.onChange(value || ''),
                    placeholder: formatMessage((0, $UPC9W.default).scenarioTitlePlaceholder)
                }), (0, $7CnHa.isDefined)(meta.error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, meta.error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "aria-label": formatMessage((0, $UPC9W.default).scenarioColor),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $21ZWY.scenarioColour
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                defaultValue: this.getDefaultColour(),
                isDisabled: isProcessingRequest,
                name: "scenarioColour"
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xinl.default), {
                    colour: fieldProps.value,
                    onColourChange: (colour)=>{
                        (0, $7CnHa.isDefined)(colour) && fieldProps.onChange(colour);
                    },
                    position: "bottom-start",
                    selectedColourSwatchSize: "default"
                })))), isMultiScenarioEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $21ZWY.radioGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPAcJ.default), {
                legend: formatMessage((0, $UPC9W.default).scenarioCreateFrom)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                defaultValue: $16833b250948f38d$var$SCENARIO_TYPES.COPY,
                isDisabled: isProcessingRequest,
                name: "scenarioType"
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
                    onChange: fieldProps.onChange,
                    options: [
                        {
                            label: formatMessage((0, $UPC9W.default).createFromBlank),
                            value: $16833b250948f38d$var$SCENARIO_TYPES.BLANK
                        },
                        {
                            label: formatMessage((0, $UPC9W.default).createFromScenario),
                            value: $16833b250948f38d$var$SCENARIO_TYPES.COPY
                        }
                    ],
                    value: fieldProps.value
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                defaultValue: this.getDefaultScenarioOption(),
                isDisabled: getState().values.scenarioType === $16833b250948f38d$var$SCENARIO_TYPES.BLANK || isProcessingRequest,
                name: "scenarioId"
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    ...fieldProps,
                    menuPortalTarget: document.body,
                    options: this.getScenarioOptions(),
                    styles: {
                        menuPortal: (base)=>({
                                ...base,
                                zIndex: 9999
                            })
                    }
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $21ZWY.hiddenSubmitButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
                type: "submit",
                ref: this.buttonRef
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            isDisabled: isProcessingRequest,
            onClick: onClose
        }, formatMessage((0, $ib5d3.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            isDisabled: !isScenarioTitleFieldValid || isProcessingRequest,
            onClick: ()=>{
                if (this.buttonRef.current) this.buttonRef.current.click();
            }
        }, formatMessage((0, $ib5d3.default).create))));
    }
}
var $16833b250948f38d$export$2e2bcd8739ae039 = (0, $2qhQi.default)($16833b250948f38d$export$cf131c1c2576cfd8);

});
parcelRegister("UPC9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c7f8a2055fbef7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $45c7f8a2055fbef7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    currentScenarioLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.current-scenario-label",
        "defaultMessage": "(current)"
    },
    dialogTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title",
        "defaultMessage": "Create scenario"
    },
    dialogTitleFirstScenario: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title-first-scenario",
        "defaultMessage": "Create first scenario"
    },
    titleLengthValidation: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.title-length-validation",
        "defaultMessage": "The scenario title cannot exceed 255 characters."
    },
    firstScenarioDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.first-scenario-description",
        "defaultMessage": "Any changes that aren't saved yet will exist in this scenario. You can also create additional scenarios at any time."
    },
    scenarioTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title",
        "defaultMessage": "Scenario name"
    },
    scenarioTitlePlaceholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-placeholder",
        "defaultMessage": "e.g. Best case"
    },
    scenarioColor: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-color",
        "defaultMessage": "Color"
    },
    scenarioCreateFrom: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-create-from",
        "defaultMessage": "Create from"
    },
    createFromBlank: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-blank",
        "defaultMessage": "Blank scenario"
    },
    createFromScenario: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-scenario",
        "defaultMessage": "Copy of:"
    },
    scenarioTitleEmpty: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-empty",
        "defaultMessage": "Please enter a scenario title"
    },
    requiredFieldsSummary: {
        "id": "portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});

parcelRegister("21ZWY", function(module, exports) {

$parcel$export(module.exports, "hiddenSubmitButton", () => $17abbac335978364$export$925df3919f606a09, (v) => $17abbac335978364$export$925df3919f606a09 = v);
$parcel$export(module.exports, "radioGroup", () => $17abbac335978364$export$7246d22ab0922ede, (v) => $17abbac335978364$export$7246d22ab0922ede = v);
$parcel$export(module.exports, "scenarioColour", () => $17abbac335978364$export$27312fbca74027aa, (v) => $17abbac335978364$export$27312fbca74027aa = v);
$parcel$export(module.exports, "scenarioTitle", () => $17abbac335978364$export$7140c7d1fc768b45, (v) => $17abbac335978364$export$7140c7d1fc768b45 = v);
$parcel$export(module.exports, "scenarioTitleAndColourFields", () => $17abbac335978364$export$73ef3d6ff19f8c4e, (v) => $17abbac335978364$export$73ef3d6ff19f8c4e = v);
var $17abbac335978364$export$925df3919f606a09;
var $17abbac335978364$export$7246d22ab0922ede;
var $17abbac335978364$export$27312fbca74027aa;
var $17abbac335978364$export$7140c7d1fc768b45;
var $17abbac335978364$export$73ef3d6ff19f8c4e;
$17abbac335978364$export$925df3919f606a09 = `YsU-kW_hiddenSubmitButton`;
$17abbac335978364$export$7246d22ab0922ede = `YsU-kW_radioGroup`;
$17abbac335978364$export$27312fbca74027aa = `YsU-kW_scenarioColour`;
$17abbac335978364$export$7140c7d1fc768b45 = `YsU-kW_scenarioTitle`;
$17abbac335978364$export$73ef3d6ff19f8c4e = `YsU-kW_scenarioTitleAndColourFields`;

});



parcelRegister("ueytZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06117579edfed20c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06117579edfed20c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createScenario: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.create-scenario",
        "defaultMessage": "Create scenario"
    },
    manageScenarios: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.manage-scenarios",
        "defaultMessage": "Manage scenarios"
    },
    scenarios: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.scenarios.scenarios",
        "defaultMessage": "Scenarios"
    }
});

});

parcelRegister("3j9Gh", function(module, exports) {

$parcel$export(module.exports, "activeScenarioItem", () => $268aa7e33c4926f8$export$6e80c944f5ea7131, (v) => $268aa7e33c4926f8$export$6e80c944f5ea7131 = v);
$parcel$export(module.exports, "isReportMode", () => $268aa7e33c4926f8$export$e8610bde98f41d48, (v) => $268aa7e33c4926f8$export$e8610bde98f41d48 = v);
$parcel$export(module.exports, "scenario", () => $268aa7e33c4926f8$export$e2ad0c7f6240be88, (v) => $268aa7e33c4926f8$export$e2ad0c7f6240be88 = v);
$parcel$export(module.exports, "scenarioButton", () => $268aa7e33c4926f8$export$4e53d53c8142d230, (v) => $268aa7e33c4926f8$export$4e53d53c8142d230 = v);
$parcel$export(module.exports, "scenarioItemColor", () => $268aa7e33c4926f8$export$247f77ab0548faac, (v) => $268aa7e33c4926f8$export$247f77ab0548faac = v);
$parcel$export(module.exports, "scenarioReadOnlyWrapper", () => $268aa7e33c4926f8$export$3ecc174cb094193, (v) => $268aa7e33c4926f8$export$3ecc174cb094193 = v);
$parcel$export(module.exports, "scenarioSwatch", () => $268aa7e33c4926f8$export$92a23dd764ffe399, (v) => $268aa7e33c4926f8$export$92a23dd764ffe399 = v);
$parcel$export(module.exports, "scenarioSwitcherMenuHeader", () => $268aa7e33c4926f8$export$804f30839e65bc86, (v) => $268aa7e33c4926f8$export$804f30839e65bc86 = v);
$parcel$export(module.exports, "scenarioTitle", () => $268aa7e33c4926f8$export$7140c7d1fc768b45, (v) => $268aa7e33c4926f8$export$7140c7d1fc768b45 = v);
$parcel$export(module.exports, "scenarioWrapper", () => $268aa7e33c4926f8$export$43aa57aac2608ff2, (v) => $268aa7e33c4926f8$export$43aa57aac2608ff2 = v);
$parcel$export(module.exports, "scenariosList", () => $268aa7e33c4926f8$export$a0006f0efe0fb9b4, (v) => $268aa7e33c4926f8$export$a0006f0efe0fb9b4 = v);
var $268aa7e33c4926f8$export$6e80c944f5ea7131;
var $268aa7e33c4926f8$export$e8610bde98f41d48;
var $268aa7e33c4926f8$export$e2ad0c7f6240be88;
var $268aa7e33c4926f8$export$4e53d53c8142d230;
var $268aa7e33c4926f8$export$247f77ab0548faac;
var $268aa7e33c4926f8$export$3ecc174cb094193;
var $268aa7e33c4926f8$export$92a23dd764ffe399;
var $268aa7e33c4926f8$export$804f30839e65bc86;
var $268aa7e33c4926f8$export$7140c7d1fc768b45;
var $268aa7e33c4926f8$export$43aa57aac2608ff2;
var $268aa7e33c4926f8$export$a0006f0efe0fb9b4;
$268aa7e33c4926f8$export$6e80c944f5ea7131 = `oWhgpG_activeScenarioItem`;
$268aa7e33c4926f8$export$e8610bde98f41d48 = `oWhgpG_isReportMode`;
$268aa7e33c4926f8$export$e2ad0c7f6240be88 = `oWhgpG_scenario`;
$268aa7e33c4926f8$export$4e53d53c8142d230 = `oWhgpG_scenarioButton`;
$268aa7e33c4926f8$export$247f77ab0548faac = `oWhgpG_scenarioItemColor`;
$268aa7e33c4926f8$export$3ecc174cb094193 = `oWhgpG_scenarioReadOnlyWrapper`;
$268aa7e33c4926f8$export$92a23dd764ffe399 = `oWhgpG_scenarioSwatch`;
$268aa7e33c4926f8$export$804f30839e65bc86 = `oWhgpG_scenarioSwitcherMenuHeader`;
$268aa7e33c4926f8$export$7140c7d1fc768b45 = `oWhgpG_scenarioTitle`;
$268aa7e33c4926f8$export$43aa57aac2608ff2 = `oWhgpG_scenarioWrapper`;
$268aa7e33c4926f8$export$a0006f0efe0fb9b4 = `oWhgpG_scenariosList`;

});



parcelRegister("kOCNy", function(module, exports) {

$parcel$export(module.exports, "default", () => $461c90877c65040f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gg29q = parcelRequire("gg29q");

var $alYIn = parcelRequire("alYIn");

var $1OBYl = parcelRequire("1OBYl");
var $461c90877c65040f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $alYIn.default), (0, $gg29q.default))((0, $1OBYl.default));

});
parcelRegister("gg29q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c46bbf94966998$export$2e2bcd8739ae039);

var $6itAY = parcelRequire("6itAY");

var $hI5cD = parcelRequire("hI5cD");

var $dYuck = parcelRequire("dYuck");
const $b1c46bbf94966998$var$mapDispatchToProps = (dispatch)=>({
        getExportCsvScopeItems: (csvIntlMessages, additionalData)=>{
            dispatch((0, $6itAY.getExportCsvScopeItems)(csvIntlMessages, additionalData));
        },
        planExportedAnalytics: (payload)=>{
            dispatch((0, $6itAY.planExportedAnalytics)(payload));
        },
        openShareReportDialog: ()=>{
            dispatch((0, $hI5cD.createShareReportUrl)());
            dispatch({
                type: (0, $dYuck.OPEN_SHARE_REPORT_DIALOG)
            });
        },
        closeShareReportDialog: ()=>{
            dispatch({
                type: (0, $dYuck.CLOSE_SHARE_REPORT_DIALOG)
            });
        },
        updateShareReportUrl: (payload)=>{
            dispatch({
                type: (0, $dYuck.UPDATE_SHARE_AS),
                payload: payload
            });
            // Warning! We have to create the report url *after* we've toggled the internal embed state above.
            dispatch((0, $hI5cD.createShareReportUrl)());
        }
    });
var $b1c46bbf94966998$export$2e2bcd8739ae039 = $b1c46bbf94966998$var$mapDispatchToProps;

});

parcelRegister("alYIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0e3685a941a067$export$2e2bcd8739ae039);

var $akhOi = parcelRequire("akhOi");

var $43peS = parcelRequire("43peS");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $2UIWs = parcelRequire("2UIWs");

var $8Nqhy = parcelRequire("8Nqhy");

var $iK4oF = parcelRequire("iK4oF");
const $dd0e3685a941a067$export$2ca6bc717c6809d7 = (state)=>state.ui.Top.TitleBar.ShareReport.isDialogOpen;
const $dd0e3685a941a067$export$20bb0d907fbbe433 = (state)=>state.ui.Top.TitleBar.ShareReport.isLoading;
const $dd0e3685a941a067$export$988c39a43dd06466 = (state)=>state.ui.Top.TitleBar.ShareReport.url;
var $dd0e3685a941a067$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    isLoading: $dd0e3685a941a067$export$20bb0d907fbbe433,
    isOpen: $dd0e3685a941a067$export$2ca6bc717c6809d7,
    mode: (0, $akhOi.getMode),
    noIssuesInPlan: (state)=>(0, $8Nqhy.getEnhancedIssues)(state).length === 0,
    readOnly: (0, $akhOi.isReadOnly),
    isReportMode: $akhOi.isReportMode,
    planModeForAnalytics: (0, $akhOi.getPlanModeForAnalytics),
    dependencyReportStatus: (0, $43peS.getDependencyReportStatus),
    shareAs: (0, $2UIWs.getShareAsState),
    url: $dd0e3685a941a067$export$988c39a43dd06466,
    analyticsEvent: (0, $akhOi.getAnalyticsEvent),
    isIssuesLoading: (0, $kwMvv.getIsIssuesLoading),
    planTitle: (0, $75KhQ.getPlanTitle)
});

});

parcelRegister("1OBYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $597e368c252eb4d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $dFWNP = parcelRequire("dFWNP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $iaRDX = parcelRequire("iaRDX");
var $8SnT0 = parcelRequire("8SnT0");
var $2RVAX = parcelRequire("2RVAX");
var $8ZwXC = parcelRequire("8ZwXC");
var $gxMC2 = parcelRequire("gxMC2");
var $7eyVf = parcelRequire("7eyVf");
var $20Dml = parcelRequire("20Dml");
var $gwbfD = parcelRequire("gwbfD");

var $cuuJa = parcelRequire("cuuJa");
parcelRequire("akhOi");

var $54dbx = parcelRequire("54dbx");

var $5rYNM = parcelRequire("5rYNM");

var $g8JvH = parcelRequire("g8JvH");
var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $4LgLj = parcelRequire("4LgLj");

var $5sJld = parcelRequire("5sJld");

var $3o0Oi = parcelRequire("3o0Oi");

var $2opo2 = parcelRequire("2opo2");
const $597e368c252eb4d3$var$ButtonItemWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('tab', {
    onClick: 'clicked'
})((0, $iaRDX.default));
function $597e368c252eb4d3$var$ShareReport({ analyticsEvent: analyticsEvent, closeShareReportDialog: closeShareReportDialog, confluenceMacroType: confluenceMacroType, dependencyReportStatus: dependencyReportStatus, getExportCsvScopeItems: getExportCsvScopeItems, isIssuesLoading: isIssuesLoading, isLoading: isLoading, isOpen: isOpen = false, isReportMode: isReportMode, mode: mode, noIssuesInPlan: noIssuesInPlan, openShareReportDialog: openShareReportDialog, planExportedAnalytics: planExportedAnalytics, planModeForAnalytics: planModeForAnalytics, planTitle: planTitle, readOnly: readOnly, shareAs: shareAs, updateShareReportUrl: updateShareReportUrl, url: url }) {
    const intl = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const open = (_, analyticsEvent)=>{
        // Reset Redux to Link or DependencyConfluence share type depending on which tab has been selected
        resetShareAsReduxState();
        openShareReportDialog();
        if (readOnly && shareAs !== (0, $5rYNM.SHARE_AS).PNG && shareAs !== (0, $5rYNM.SHARE_AS).CSV) updateShareReportUrl({
            shareAs: (0, $5rYNM.SHARE_AS).CSV
        });
        const [actionSubject, action] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SHARE_REPORT.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: action,
            actionSubject: actionSubject
        }), (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).SHARE_REPORT);
    };
    const close = ()=>closeShareReportDialog();
    const resetShareAsReduxState = ()=>{
        if (confluenceMacroType === (0, $5rYNM.TIMELINE_SHARE_TYPE) && shareAs === (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) updateShareReportUrl({
            shareAs: (0, $5rYNM.SHARE_AS).LINK
        });
        else if (confluenceMacroType === (0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE) && shareAs !== (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE) updateShareReportUrl({
            shareAs: (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE
        });
    };
    const getShareDialogNavigationItems = ()=>{
        const navigationItems = [
            {
                action: (0, $5rYNM.SHARE_AS).LINK,
                label: intl.formatMessage((0, $3o0Oi.default).shareAsLink)
            },
            {
                action: (0, $5rYNM.SHARE_AS).EMBED,
                label: intl.formatMessage((0, $3o0Oi.default).shareAsEmbed)
            },
            {
                action: (0, $5rYNM.SHARE_AS).CONFLUENCE,
                label: intl.formatMessage((0, $3o0Oi.default).shareAsConfluence)
            },
            {
                action: (0, $5rYNM.SHARE_AS).CSV,
                label: intl.formatMessage((0, $3o0Oi.default).shareAsSpreadsheetCsv)
            },
            {
                action: (0, $5rYNM.SHARE_AS).PNG,
                label: intl.formatMessage((0, $3o0Oi.default).shareAsPng)
            }
        ];
        return navigationItems.map(({ action: action, label: label })=>{
            const isSelected = shareAs === action;
            const isDisabled = // only CSV available in report mode
            isReportMode && action !== (0, $5rYNM.SHARE_AS).CSV || // only CSV and PNG available in read only mode
            readOnly && ![
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $5rYNM.SHARE_AS).CSV,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $5rYNM.SHARE_AS).PNG
            ].includes(action);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($597e368c252eb4d3$var$ButtonItemWithAnalytics, {
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: action,
                // eslint-disable-next-line @typescript-eslint/no-shadow
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, action, {
                        planMode: planModeForAnalytics
                    });
                    updateShareReportUrl({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        shareAs: action
                    });
                },
                testId: `portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-${action.toLowerCase()}`
            }, label);
        });
    };
    const isDependencyReportReadonlyOrReportMode = ()=>confluenceMacroType === (0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE) && (mode === (0, $99f9ac26081f8045$export$b07c15b79440feb8) || mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7));
    if (isDependencyReportReadonlyOrReportMode()) return null;
    const shareAsButtonTextFormatted = intl.formatMessage((0, $3o0Oi.default).shareButtonText);
    const isDisabled = isIssuesLoading || confluenceMacroType === (0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE) && dependencyReportStatus !== (0, $54dbx.ReportStatus).SUCCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "shareReport",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-report-button"
    }, !(0, $1ybV0.ff)('jet-plans-nav-refresh_f9025') && mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && mode !== (0, $99f9ac26081f8045$export$b07c15b79440feb8) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.shareButtonIconOnly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: shareAsButtonTextFormatted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        ariaLabel: shareAsButtonTextFormatted,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            label: ""
        }),
        onClick: open,
        appearance: "subtle",
        isDisabled: isDisabled
    }))), (0, $1ybV0.ff)('jet-plans-nav-refresh_f9025') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))),
        onClick: open,
        appearance: "subtle",
        isDisabled: isDisabled,
        label: shareAsButtonTextFormatted
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7) && mode !== (0, $99f9ac26081f8045$export$b07c15b79440feb8) ? $2opo2.shareButtonLabelOnly : ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            label: ""
        }),
        onClick: open,
        appearance: "subtle",
        isDisabled: isDisabled
    }, shareAsButtonTextFormatted))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RVAX.default), {
        autoFocus: false,
        onClose: close,
        width: "x-large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.modalBody
    }, confluenceMacroType === (0, $5rYNM.TIMELINE_SHARE_TYPE) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.sideNavigation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $20Dml.default), {
        label: intl.formatMessage((0, $3o0Oi.default).shareHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxMC2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SnT0.default), null, intl.formatMessage((0, $3o0Oi.default).shareHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZwXC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eyVf.default), null, getShareDialogNavigationItems())))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LgLj.default), {
        intl: intl,
        isLoading: isLoading,
        onClose: close,
        shareAs: shareAs,
        updateShareReportUrl: updateShareReportUrl,
        url: url,
        getExportCsvScopeItems: getExportCsvScopeItems,
        noIssuesInPlan: noIssuesInPlan,
        PNGExportContentComponent: (0, $5sJld.default),
        planMode: planModeForAnalytics,
        isReportMode: isReportMode,
        analyticsEvent: analyticsEvent,
        planExportedAnalytics: planExportedAnalytics,
        confluenceMacroType: confluenceMacroType,
        planTitle: planTitle
    }))));
}
var $597e368c252eb4d3$export$2e2bcd8739ae039 = $597e368c252eb4d3$var$ShareReport;

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("4LgLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9890378027e05df2$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $2bv8J = parcelRequire("2bv8J");

var $zKKIn = parcelRequire("zKKIn");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $aAyrO = parcelRequire("aAyrO");

var $cuuJa = parcelRequire("cuuJa");

var $6itAY = parcelRequire("6itAY");

var $5rYNM = parcelRequire("5rYNM");

var $awiwy = parcelRequire("awiwy");

var $ib5d3 = parcelRequire("ib5d3");

var $jMP2a = parcelRequire("jMP2a");

var $2opo2 = parcelRequire("2opo2");

var $dCvMn = parcelRequire("dCvMn");

var $2i5F1 = parcelRequire("2i5F1");

var $5sJld = parcelRequire("5sJld");

var $bOk0G = parcelRequire("bOk0G");
const $9890378027e05df2$var$linkStyles = null; // eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any
class $9890378027e05df2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, isLoading: isLoading, isReportMode: isReportMode, onClose: onClose, shareAs: shareAs, planTitle: planTitle } = this.props;
        const { isCopied: isCopied } = this.state;
        const isConfluenceSharing = shareAs === (0, $5rYNM.SHARE_AS).CONFLUENCE || this.isConfluenceSharingType(shareAs);
        if (shareAs === (0, $5rYNM.SHARE_AS).CSV) {
            const { getExportCsvScopeItems: getExportCsvScopeItems, noIssuesInPlan: noIssuesInPlan } = this.props;
            const csvIntlMessages = (0, $bOk0G.getCsvIntlMessages)(formatMessage, planTitle);
            const onClickExport = (additionalData = {
                goalsByARI: {}
            })=>{
                if (!noIssuesInPlan) {
                    getExportCsvScopeItems(csvIntlMessages, additionalData);
                    this.setState({
                        didCsvDownload: true
                    });
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dCvMn.CSVExport), {
                isReportMode: isReportMode,
                noIssuesInPlan: noIssuesInPlan,
                onClickExport: onClickExport,
                onClose: onClose
            });
        }
        if (shareAs === (0, $5rYNM.SHARE_AS).PNG) {
            const { planMode: planMode } = this.props;
            let { PNGExportContentComponent: PNGExportContentComponent } = this.props;
            PNGExportContentComponent = PNGExportContentComponent || (0, $5sJld.default);
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $2opo2.content
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $2opo2.contentHeading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                size: "medium",
                as: "h2"
            }, formatMessage((0, $2i5F1.default).shareDialogHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $2opo2.contentBody
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PNGExportContentComponent, {
                onClose: onClose,
                planMode: planMode
            }))));
        }
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.contentHeading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "medium",
            as: "h2"
        }, formatMessage({
            ...(0, $2i5F1.default).shareDialogHeader
        }))), isConfluenceSharing ? this.confluenceSharingIntro() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage({
            ...(0, $2i5F1.default).urlLabel
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.urlForm
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $2opo2.urlTextfield,
            "data-testid": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "aria-label": formatMessage({
                ...(0, $2i5F1.default).confluenceUrlLabel
            }),
            isReadOnly: true,
            ref: (fieldRef)=>{
                this.input = fieldRef;
            },
            value: this.textFieldValue()
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.copyButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            appearance: "primary",
            onClick: this.copyToClipboard,
            isDisabled: isLoading,
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copy-button"
        }, formatMessage({
            ...(0, $2i5F1.default).copyButtonText
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $2opo2.copiedMessage,
            role: "alert",
            "aria-live": "polite",
            style: {
                visibility: isCopied ? 'visible' : 'hidden'
            }
        }, formatMessage({
            ...(0, $2i5F1.default).copiedButtonText
        }))), isConfluenceSharing ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.accessControl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.accessControlMacroIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: formatMessage((0, $2i5F1.default).accessControlNoteIcon),
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.accessControlMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2i5F1.default).accessControlMacroDescription))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.accessControl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($zKKIn))), {
            label: formatMessage({
                ...(0, $2i5F1.default).accessControlIcon
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.accessControlMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $2i5F1.default).accessControlDescriptionTimeline,
            values: {
                action: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, formatMessage((0, $2i5F1.default).accessControlView))
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $2opo2.contentFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            onClick: onClose,
            appearance: "subtle"
        }, formatMessage((0, $ib5d3.default).cancel)))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isCopied: false,
            didCsvDownload: false
        };
        this.componentDidUpdate = ()=>{
            this.selectTextInUrlField();
        };
        this.componentWillUnmount = ()=>{
            const { shareAs: shareAs, analyticsEvent: analyticsEvent } = this.props;
            if (analyticsEvent && shareAs === (0, $5rYNM.SHARE_AS).CSV) {
                const { planMode: planMode } = this.props;
                const { didCsvDownload: didCsvDownload } = this.state;
                const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_CSV_MODAL_CLOSED.split(' ');
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
                    action: action,
                    actionSubject: actionSubject
                }), actionSubjectId, {
                    didDownload: didCsvDownload,
                    planMode: planMode
                });
            }
        };
        this.selectTextInUrlField = ()=>{
            if (this.input) this.input.select();
        };
        this.copyToClipboard = ()=>{
            const { planExportedAnalytics: planExportedAnalytics, shareAs: shareAs } = this.props;
            this.selectTextInUrlField();
            document.execCommand('copy');
            if (this.input) this.input.focus();
            this.setState({
                isCopied: true
            }, ()=>{
                /** This is a temporary workaround to have 'Copied' disappear after sometime.
       * We added this because there is no AK comp that provides this feature. Once we have
       * this feature in AK we can replace this code.
       */ setTimeout(()=>{
                    if (this.input) this.input.blur();
                    this.setState({
                        isCopied: false
                    });
                }, 5000);
            });
            const exportFormats = Object.values((0, $6itAY.EXPORT_EVENT_TYPE));
            if (exportFormats.includes(shareAs)) planExportedAnalytics({
                exportFormat: shareAs
            });
        };
        this.getUrl = ()=>{
            const { url: url, shareAs: shareAs } = this.props;
            if (shareAs === (0, $5rYNM.SHARE_AS).EMBED) return `<iframe src='${url}' width='1024' height='640' style='border:1px solid #ccc;'></iframe>`;
            return url;
        };
        this.getConfluenceMacroSharingMessage = ()=>{
            const { confluenceMacroType: confluenceMacroType } = this.props;
            switch(confluenceMacroType){
                case 0, $5rYNM.DEPENDENCY_REPORT_SHARE_TYPE:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2i5F1.default).confluenceDependencyMacroSharingMessage);
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $2i5F1.default).confluenceTimelineMacroSharingMessage);
            }
        };
        this.confluenceSharingIntro = ()=>{
            const { intl: intl, onClose: onClose } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, this.getConfluenceMacroSharingMessage()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $2i5F1.default).confluenceMacroSharingInstructions,
                values: {
                    link: (0, $1ybV0.ff)('in-product-help-for-plans_qwds9') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                        articleId: (0, $5rYNM.IPH_IDS).SHARE_CONFLUENCE,
                        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                            href: (0, $awiwy.default).URLs.schedulingWork
                        }, intl.formatMessage((0, $2i5F1.default).confluenceMacroIph)),
                        appearance: "link",
                        spacing: "none",
                        onClick: onClose
                    }, intl.formatMessage((0, $2i5F1.default).confluenceMacroIph)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
                        href: (0, $awiwy.default).URLs.embedRoadmapInConfluenceMacro,
                        className: (0, $7JEyt.default)([
                            "_4bfu18uv _1hms8stv _ajmmnqa1"
                        ])
                    }, intl.formatMessage((0, $2i5F1.default).viewMacroInstructionsLinkText))
                }
            })));
        };
        this.textFieldValue = ()=>{
            const { intl: intl, isLoading: isLoading } = this.props;
            return isLoading ? intl.formatMessage({
                ...(0, $2i5F1.default).generatingUrl
            }) : this.getUrl();
        };
        this.isConfluenceSharingType = (shareAs)=>shareAs === (0, $5rYNM.SHARE_AS).CONFLUENCE || shareAs === (0, $5rYNM.SHARE_AS).DEPENDENCY_REPORT_CONFLUENCE;
    }
}

});
parcelRegister("zKKIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06b789109a6e6b89$var$_react = $06b789109a6e6b89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $06b789109a6e6b89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $06b789109a6e6b89$var$LockCircleIcon = (props)=>/*#__PURE__*/ $06b789109a6e6b89$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M12.02 8h-.04A1.98 1.98 0 0010 9.98V11h1V9.99a.99.99 0 01.99-.99h.02a.99.99 0 01.99.99V11h1V9.98A1.98 1.98 0 0012.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 00-1 1v2.001a1 1 0 00.991.999h4.018a.992.992 0 00.991-.999V13a1 1 0 00-1-1h-1z" fill="inherit"/></g></svg>`
    }, props));
$06b789109a6e6b89$var$LockCircleIcon.displayName = 'LockCircleIcon';
var $06b789109a6e6b89$var$_default = $06b789109a6e6b89$var$LockCircleIcon;
module.exports.default = $06b789109a6e6b89$var$_default;

});

parcelRegister("2opo2", function(module, exports) {

$parcel$export(module.exports, "accessControl", () => $1be183e99e58c186$export$fdd9c2c09d78ce4c, (v) => $1be183e99e58c186$export$fdd9c2c09d78ce4c = v);
$parcel$export(module.exports, "accessControlMacroIcon", () => $1be183e99e58c186$export$56923094f5f1fa12, (v) => $1be183e99e58c186$export$56923094f5f1fa12 = v);
$parcel$export(module.exports, "accessControlMessage", () => $1be183e99e58c186$export$83744063017ab4a, (v) => $1be183e99e58c186$export$83744063017ab4a = v);
$parcel$export(module.exports, "content", () => $1be183e99e58c186$export$a7db06668cad9adb, (v) => $1be183e99e58c186$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "contentBody", () => $1be183e99e58c186$export$95dc927f26875787, (v) => $1be183e99e58c186$export$95dc927f26875787 = v);
$parcel$export(module.exports, "contentBodyIntro", () => $1be183e99e58c186$export$a75a3bae055e85c8, (v) => $1be183e99e58c186$export$a75a3bae055e85c8 = v);
$parcel$export(module.exports, "contentFooter", () => $1be183e99e58c186$export$553e225968be56ef, (v) => $1be183e99e58c186$export$553e225968be56ef = v);
$parcel$export(module.exports, "contentHeading", () => $1be183e99e58c186$export$91dccde366be8185, (v) => $1be183e99e58c186$export$91dccde366be8185 = v);
$parcel$export(module.exports, "copiedMessage", () => $1be183e99e58c186$export$4c3060136220ba05, (v) => $1be183e99e58c186$export$4c3060136220ba05 = v);
$parcel$export(module.exports, "copyButton", () => $1be183e99e58c186$export$82c3bb3cf4f0e46, (v) => $1be183e99e58c186$export$82c3bb3cf4f0e46 = v);
$parcel$export(module.exports, "modalBody", () => $1be183e99e58c186$export$475ea8af95eb4516, (v) => $1be183e99e58c186$export$475ea8af95eb4516 = v);
$parcel$export(module.exports, "shareButtonIconOnly", () => $1be183e99e58c186$export$2ddc19957d825cb3, (v) => $1be183e99e58c186$export$2ddc19957d825cb3 = v);
$parcel$export(module.exports, "shareButtonLabelOnly", () => $1be183e99e58c186$export$c8eafe09676fbaa, (v) => $1be183e99e58c186$export$c8eafe09676fbaa = v);
$parcel$export(module.exports, "sideNavigation", () => $1be183e99e58c186$export$176e221cffa2e044, (v) => $1be183e99e58c186$export$176e221cffa2e044 = v);
$parcel$export(module.exports, "urlForm", () => $1be183e99e58c186$export$1fc77b9f6ff29e1c, (v) => $1be183e99e58c186$export$1fc77b9f6ff29e1c = v);
$parcel$export(module.exports, "urlTextfield", () => $1be183e99e58c186$export$f2518e279dc5ad83, (v) => $1be183e99e58c186$export$f2518e279dc5ad83 = v);
var $1be183e99e58c186$export$fdd9c2c09d78ce4c;
var $1be183e99e58c186$export$56923094f5f1fa12;
var $1be183e99e58c186$export$83744063017ab4a;
var $1be183e99e58c186$export$a7db06668cad9adb;
var $1be183e99e58c186$export$95dc927f26875787;
var $1be183e99e58c186$export$a75a3bae055e85c8;
var $1be183e99e58c186$export$553e225968be56ef;
var $1be183e99e58c186$export$91dccde366be8185;
var $1be183e99e58c186$export$4c3060136220ba05;
var $1be183e99e58c186$export$82c3bb3cf4f0e46;
var $1be183e99e58c186$export$42436f1f3fbda47f;
var $1be183e99e58c186$export$475ea8af95eb4516;
var $1be183e99e58c186$export$644913298ab745fc;
var $1be183e99e58c186$export$2ddc19957d825cb3;
var $1be183e99e58c186$export$c8eafe09676fbaa;
var $1be183e99e58c186$export$176e221cffa2e044;
var $1be183e99e58c186$export$1fc77b9f6ff29e1c;
var $1be183e99e58c186$export$f2518e279dc5ad83;
$1be183e99e58c186$export$fdd9c2c09d78ce4c = `_93vqlG_accessControl`;
$1be183e99e58c186$export$56923094f5f1fa12 = `_93vqlG_accessControlMacroIcon`;
$1be183e99e58c186$export$83744063017ab4a = `_93vqlG_accessControlMessage`;
$1be183e99e58c186$export$a7db06668cad9adb = `_93vqlG_content`;
$1be183e99e58c186$export$95dc927f26875787 = `_93vqlG_contentBody`;
$1be183e99e58c186$export$a75a3bae055e85c8 = `_93vqlG_contentBodyIntro`;
$1be183e99e58c186$export$553e225968be56ef = `_93vqlG_contentFooter`;
$1be183e99e58c186$export$91dccde366be8185 = `_93vqlG_contentHeading`;
$1be183e99e58c186$export$4c3060136220ba05 = `_93vqlG_copiedMessage`;
$1be183e99e58c186$export$82c3bb3cf4f0e46 = `_93vqlG_copyButton`;
$1be183e99e58c186$export$42436f1f3fbda47f = `_93vqlG_generateLinkButton`;
$1be183e99e58c186$export$475ea8af95eb4516 = `_93vqlG_modalBody`;
$1be183e99e58c186$export$644913298ab745fc = `_93vqlG_shareButton`;
$1be183e99e58c186$export$2ddc19957d825cb3 = `_93vqlG_shareButtonIconOnly`;
$1be183e99e58c186$export$c8eafe09676fbaa = `_93vqlG_shareButtonLabelOnly`;
$1be183e99e58c186$export$176e221cffa2e044 = `_93vqlG_sideNavigation`;
$1be183e99e58c186$export$1fc77b9f6ff29e1c = `_93vqlG_urlForm`;
$1be183e99e58c186$export$f2518e279dc5ad83 = `_93vqlG_urlTextfield`;

});

parcelRegister("dCvMn", function(module, exports) {

$parcel$export(module.exports, "CSVExport", () => $841dca71bad35aa7$export$44886573e792865b);

var $eUqFw = parcelRequire("eUqFw");

var $5oiKm = parcelRequire("5oiKm");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lGIBI = parcelRequire("lGIBI");

var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $g4Vkx = parcelRequire("g4Vkx");
var $bbaTG = parcelRequire("bbaTG");
var $lRvnl = parcelRequire("lRvnl");
var $gwbfD = parcelRequire("gwbfD");

var $ib5d3 = parcelRequire("ib5d3");

var $2opo2 = parcelRequire("2opo2");

var $2i5F1 = parcelRequire("2i5F1");
const $841dca71bad35aa7$export$44886573e792865b = ({ isReportMode: isReportMode, noIssuesInPlan: noIssuesInPlan, onClickExport: onClickExport, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [definedGoalsByARI] = (0, $lGIBI.useDefinedGoals)();
    const onClickExportWithAdditionalData = (0, $eUqFw.useCallback)(()=>{
        onClickExport({
            goalsByARI: definedGoalsByARI
        });
    }, [
        onClickExport,
        definedGoalsByARI
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h3", {
        className: $2opo2.contentHeading
    }, formatMessage((0, $2i5F1.default).shareDialogHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.contentBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.contentBodyIntro
    }, isReportMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2i5F1.default).reportModeMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2i5F1.default).exportCsvIntro)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $2i5F1.default).plansExportCsvIntro2)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $2opo2.contentFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: noIssuesInPlan && formatMessage((0, $2i5F1.default).noIssuesToExportTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5oiKm))), {
            label: ""
        }),
        onClick: onClickExportWithAdditionalData,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.csv-export.export-spreadsheet",
        theme: (current, themeProps)=>({
                ...current(themeProps),
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    ...noIssuesInPlan && {
                        background: `var(--ds-background-disabled, ${(0, $g4Vkx.default).N20A})`,
                        color: `var(--ds-text-disabled, ${(0, $g4Vkx.default).N70})`,
                        cursor: 'not-allowed'
                    }
                }
            })
    }, formatMessage((0, $2i5F1.default).exportCsvButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $ib5d3.default).cancel))))));
};

});
parcelRegister("5oiKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0103517d4ae70c89$var$_react = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0103517d4ae70c89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0103517d4ae70c89$var$ExportIcon = (props)=>/*#__PURE__*/ $0103517d4ae70c89$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 6.491V16a1 1 0 01-2 0V6.491L9.784 7.697a1.051 1.051 0 01-1.478 0 1.029 1.029 0 010-1.465l2.955-2.929a1.051 1.051 0 011.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.051 1.051 0 01-1.478 0L13 6.49zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.009 2.009 0 015 18.991V11.01A2 2 0 017 9h2z" fill="currentColor"/></svg>`
    }, props));
$0103517d4ae70c89$var$ExportIcon.displayName = 'ExportIcon';
var $0103517d4ae70c89$var$_default = $0103517d4ae70c89$var$ExportIcon;
module.exports.default = $0103517d4ae70c89$var$_default;

});

parcelRegister("2i5F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98ae0dc7dcaa48b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a98ae0dc7dcaa48b$var$messages = (0, $90IgZ.defineMessages)({
    shareDialogHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.share-dialog-header",
        "defaultMessage": "Share plan"
    },
    urlLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.url-label",
        "defaultMessage": "Use the link below to share this roadmap:"
    },
    generatingUrl: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.generating-url",
        "defaultMessage": "Generating ..."
    },
    copyButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copy-button-text",
        "defaultMessage": "Copy"
    },
    copiedButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.copied-button-text",
        "defaultMessage": "Copied!"
    },
    accessControlIcon: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-icon",
        "defaultMessage": "Access Control:"
    },
    accessControlNoteIcon: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-note-icon",
        "defaultMessage": "note"
    },
    accessControlDescriptionTimeline: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-description-timeline",
        "defaultMessage": "Anyone with access to this plan will be able to {action} this timeline. It will not be editable from the link (read-only)."
    },
    accessControlMacroDescription: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-macro-description",
        "defaultMessage": "The macro shares a view-only version of your plan. Viewers won\u2019t be able to make changes from your Confluence page."
    },
    accessControlView: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.access-control-view",
        "defaultMessage": "view"
    },
    confluenceTimelineMacroSharingMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-timeline-macro-sharing-message",
        "defaultMessage": "Share your timeline to a Confluence page."
    },
    confluenceDependencyMacroSharingMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-dependency-macro-sharing-message",
        "defaultMessage": "Share your dependencies view to a Confluence page."
    },
    confluenceMacroSharingInstructions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-macro-sharing-instructions",
        "defaultMessage": "Copy the link below, and paste it into your Confluence page. {link}."
    },
    viewMacroInstructionsLinkText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.view-macro-instructions-link-text",
        "defaultMessage": "View detailed instructions on how to share your plans to Confluence"
    },
    confluenceMacroIph: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-macro-iph",
        "defaultMessage": "Read more about sharing a plan to Confluence"
    },
    exportCsvIntro: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-intro",
        "defaultMessage": "Create a spreadsheet from your plan that can be opened with programs like Excel."
    },
    plansExportCsvIntro2: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.plans-export-csv-intro-2",
        "defaultMessage": "When you export your plan to .csv, Plans will only export issues that are currently visible in your plan. Use filters, view settings, and sorting options to include or exclude issues from your .csv file."
    },
    exportCsvButton: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-button",
        "defaultMessage": "Export to .csv"
    },
    noIssuesToExportTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.no-issues-to-export-tooltip",
        "defaultMessage": "There are no issues to export"
    },
    exportCsvColumnHeadingHierarchy: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-hierarchy",
        "defaultMessage": "Hierarchy"
    },
    exportCsvColumnHeadingTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-title",
        "defaultMessage": "Title"
    },
    exportCsvColumnHeadingProject: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-project",
        "defaultMessage": "Project"
    },
    exportCsvColumnHeadingReleases: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-releases",
        "defaultMessage": "Releases"
    },
    exportCsvColumnHeadingTeam: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-team",
        "defaultMessage": "Team"
    },
    exportCsvColumnHeadingSprint: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-sprint",
        "defaultMessage": "Sprint"
    },
    exportCsvColumnHeadingTargetStartDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-target-start-date",
        "defaultMessage": "Target start date"
    },
    exportCsvColumnHeadingTargetEndDate: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-target-end-date",
        "defaultMessage": "Target end date"
    },
    exportCsvColumnHeadingEstimateDays: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-estimate-days",
        "defaultMessage": "Estimates (d)"
    },
    exportCsvColumnHeadingEstimateHours: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-estimate-hours",
        "defaultMessage": "Estimates (h)"
    },
    exportCsvColumnHeadingStoryPoints: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-story-points",
        "defaultMessage": "Story points"
    },
    exportCsvColumnHeadingParent: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-parent",
        "defaultMessage": "Parent"
    },
    exportCsvColumnHeadingPriority: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-priority",
        "defaultMessage": "Priority"
    },
    exportCsvColumnHeadingLabels: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-labels",
        "defaultMessage": "Labels"
    },
    exportCsvColumnHeadingComponents: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-components",
        "defaultMessage": "Components"
    },
    exportCsvColumnHeadingGoalName: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-goal-name",
        "defaultMessage": "Goal"
    },
    exportCsvColumnHeadingGoalStatus: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-goal-status",
        "defaultMessage": "Goal status"
    },
    exportCsvColumnHeadingIssueKey: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-issue-key",
        "defaultMessage": "Issue key"
    },
    exportCsvColumnHeadingIssueStatus: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-issue-status",
        "defaultMessage": "Issue status"
    },
    exportCsvColumnHeadingProgressPercentage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-percentage",
        "defaultMessage": "Progress (%)"
    },
    exportCsvColumnHeadingProgressCompletedDays: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-days",
        "defaultMessage": "Progress completed (d)"
    },
    exportCsvColumnHeadingProgressCompletedHours: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-hours",
        "defaultMessage": "Progress completed (h)"
    },
    exportCsvColumnHeadingProgressCompletedStoryPoints: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-completed-story-points",
        "defaultMessage": "Progress completed (sp)"
    },
    exportCsvColumnHeadingProgressRemainingDays: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-days",
        "defaultMessage": "Progress remaining (d)"
    },
    exportCsvColumnHeadingProgressRemainingHours: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-hours",
        "defaultMessage": "Progress remaining (h)"
    },
    exportCsvColumnHeadingProgressRemainingStoryPoints: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-remaining-story-points",
        "defaultMessage": "Progress remaining (sp)"
    },
    exportCsvColumnHeadingProgressIssueCountPercentage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-progress-issue-count-percentage",
        "defaultMessage": "Progress (%) issue count (IC)"
    },
    exportCsvColumnHeadingToDoIssueCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-to-do-issue-count",
        "defaultMessage": "To do IC"
    },
    exportCsvColumnHeadingInProgressIssueCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-in-progress-issue-count",
        "defaultMessage": "In progress IC"
    },
    exportCsvColumnHeadingDoneIssueCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-done-issue-count",
        "defaultMessage": "Done IC"
    },
    exportCsvColumnHeadingTotalIssueCount: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-total-issue-count",
        "defaultMessage": "Total IC"
    },
    exportCsvColumnHeadingRollUp: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-column-heading-roll-up",
        "defaultMessage": "(roll-up)"
    },
    exportCsvExternalLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-external-label",
        "defaultMessage": "[EXT]"
    },
    exportCsvCompletedLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-completed-label",
        "defaultMessage": "[COMPLETED]"
    },
    reportModeMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.report-mode-message",
        "defaultMessage": "When viewing a plan from a shared link, you can only export data to a .csv file."
    },
    exportCsvFilename: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.export-csv-filename",
        "defaultMessage": "Plans {planTitle}"
    },
    confluenceUrlLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.confluence-url-label",
        "defaultMessage": "Confluence URL"
    }
});
var $a98ae0dc7dcaa48b$export$2e2bcd8739ae039 = $a98ae0dc7dcaa48b$var$messages;

});


parcelRegister("5sJld", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede1c24eec3c18db$export$2e2bcd8739ae039);

var $6itAY = parcelRequire("6itAY");

var $lNNXV = parcelRequire("lNNXV");

var $5k26e = parcelRequire("5k26e");

var $fBrsn = parcelRequire("fBrsn");
var $ede1c24eec3c18db$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5k26e.default), {
    planExportedAnalytics: $6itAY.planExportedAnalytics
})((0, $fBrsn.default));

});
parcelRegister("5k26e", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2995bdc342df71$export$2e2bcd8739ae039);
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $75KhQ = parcelRequire("75KhQ");

var $4GVCJ = parcelRequire("4GVCJ");

var $a0bo1 = parcelRequire("a0bo1");

var $9H2AP = parcelRequire("9H2AP");

var $iK4oF = parcelRequire("iK4oF");

var $7jIPT = parcelRequire("7jIPT");
const $7c2995bdc342df71$export$c7f8b8401976f675 = (0, $iK4oF.createSelector)([
    (0, $9H2AP.getTimeScaleViewSettings)
], (0, $7jIPT.getInitialExportDateRange));
const $7c2995bdc342df71$export$34fe7608eea15efe = (0, $iK4oF.createSelector)([
    (0, $a0bo1.getTableItems)
], (tableItems)=>tableItems.filter((ti)=>ti.tag === (0, $a0bo1.TABLE_ISSUE)).length);
const $7c2995bdc342df71$var$mapStateToProps = (state)=>({
        fieldsWidth: (0, $4GVCJ.getFieldsWidth)(state),
        scopeWidth: (0, $4GVCJ.getScopeWidth)(state),
        timelineExportWidth: (0, $4GVCJ.getTimelineExportWidth)(state),
        initialTimelineDateRange: $7c2995bdc342df71$export$c7f8b8401976f675(state),
        numIssuesInPlan: (0, $cwP4d.getAllIssues)(state).length,
        numIssues: $7c2995bdc342df71$export$34fe7608eea15efe(state),
        planTitle: (0, $75KhQ.getPlan)(state).title,
        viewMode: (0, $9H2AP.getViewMode)(state)
    });
var $7c2995bdc342df71$export$2e2bcd8739ae039 = $7c2995bdc342df71$var$mapStateToProps;

});
parcelRegister("7jIPT", function(module, exports) {

$parcel$export(module.exports, "EXPORT_PNG_TIMELINE_WIDTH_OPTIONS", () => $6693086ab0a29b22$export$463117a55a1baf95);
$parcel$export(module.exports, "getInitialExportDateRange", () => $6693086ab0a29b22$export$4fa0ed0bf0ea5915);

var $eTbtL = parcelRequire("eTbtL");parcelRequire("17L5s");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");

var $aMoMC = parcelRequire("aMoMC");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $6693086ab0a29b22$export$463117a55a1baf95 = {
    NONE: 'none',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    CUSTOM: 'custom'
};
const $6693086ab0a29b22$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');
const $6693086ab0a29b22$export$4fa0ed0bf0ea5915 = (timescaleViewSettings = {
    mode: (0, $5rYNM.TIMELINE_MODES).MONTHS
}, todayDate = (0, $aMoMC.getTodayDate)())=>{
    const { mode: mode, customDateRange: customDateRange } = timescaleViewSettings;
    // "To now range" defaults to 1 unit before today.
    // Note that "to now range" converts to fixed date range "from date".
    const toNowMultiplier = 1;
    // "From now range" defaults to 3 units after today.
    // Note that "from now range" converts to fixed date range "to date".
    const fromNowMultiplier = 3;
    // The default unit is set to 'months'
    let relativeDateRange = {
        typeOfCustomDateRange: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).RELATIVE,
        fromNowUnitCount: fromNowMultiplier,
        toNowUnitCount: toNowMultiplier,
        fromNowUnit: (0, $eTbtL.DateUnits).MONTHS,
        toNowUnit: (0, $eTbtL.DateUnits).MONTHS
    };
    switch(mode){
        case (0, $5rYNM.TIMELINE_MODES).CUSTOM:
            if ((0, $7CnHa.isDefined)(customDateRange)) {
                if (customDateRange.typeOfCustomDateRange === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED) return customDateRange;
                relativeDateRange = customDateRange;
            }
            break;
        case (0, $5rYNM.TIMELINE_MODES).WEEKS:
            relativeDateRange.fromNowUnit = (0, $eTbtL.DateUnits).WEEKS;
            relativeDateRange.toNowUnit = (0, $eTbtL.DateUnits).WEEKS;
            break;
        case (0, $5rYNM.TIMELINE_MODES).QUARTERS:
            relativeDateRange.fromNowUnit = (0, $eTbtL.DateUnits).MONTHS;
            relativeDateRange.toNowUnit = (0, $eTbtL.DateUnits).MONTHS;
            relativeDateRange.fromNowUnitCount = 3 * fromNowMultiplier;
            relativeDateRange.toNowUnitCount = 3 * toNowMultiplier;
            break;
        case (0, $5rYNM.TIMELINE_MODES).YEARS:
            relativeDateRange.fromNowUnit = (0, $eTbtL.DateUnits).MONTHS;
            relativeDateRange.toNowUnit = (0, $eTbtL.DateUnits).MONTHS;
            relativeDateRange.fromNowUnitCount = 12 * fromNowMultiplier;
            relativeDateRange.toNowUnitCount = 12 * toNowMultiplier;
            break;
        case (0, $5rYNM.TIMELINE_MODES).MONTHS:
        default:
            break;
    }
    const { start: start, end: end } = (0, $17L5s.getRelativeDates)(relativeDateRange, todayDate);
    return {
        typeOfCustomDateRange: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED,
        fromDate: start,
        toDate: end
    };
};

});


parcelRegister("fBrsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2892d350cbc1c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");

var $fG8Rc = parcelRequire("fG8Rc");

var $2bv8J = parcelRequire("2bv8J");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $bLFgh = parcelRequire("bLFgh");
var $lRvnl = parcelRequire("lRvnl");
var $eYlCJ = parcelRequire("eYlCJ");
var $gwbfD = parcelRequire("gwbfD");
var $lcvrv = parcelRequire("lcvrv");

var $dYnI4 = parcelRequire("dYnI4");

var $cuuJa = parcelRequire("cuuJa");

var $6itAY = parcelRequire("6itAY");

var $3IuGJ = parcelRequire("3IuGJ");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $awiwy = parcelRequire("awiwy");

var $ib5d3 = parcelRequire("ib5d3");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8WuJm = parcelRequire("8WuJm");

var $ribbU = parcelRequire("ribbU");

var $bgE6H = parcelRequire("bgE6H");

var $5ks3x = parcelRequire("5ks3x");

var $7jIPT = parcelRequire("7jIPT");
const $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES = 500;
const $bc2892d350cbc1c8$var$DAY_MS = 86400000;
const $bc2892d350cbc1c8$var$WARNING_ISSUE_COUNT_LIMIT = 150;
const $bc2892d350cbc1c8$var$presetWidths = {
    none: '0',
    small: '400',
    medium: '700',
    large: '900',
    custom: ''
};
const $bc2892d350cbc1c8$var$buildIframeUrls = (href, scopeWidth, fieldsWidth, fromDate, toDate)=>{
    const url = new URL(href);
    url.searchParams.set('scopeWidth', scopeWidth.toString());
    url.searchParams.set('fieldsWidth', fieldsWidth.toString());
    url.searchParams.set('startInPreviewMode', '1');
    if ((0, $7CnHa.isDefined)(fromDate)) url.searchParams.set('fromDate', fromDate.toString());
    if ((0, $7CnHa.isDefined)(toDate)) url.searchParams.set('toDate', toDate.toString());
    const { pathname: pathname, hash: hash } = url;
    const iframeURL = `${pathname.replace(/\/timeline\/?/, '')}/export/${url.search}${hash}`;
    url.searchParams.set('startInPreviewMode', '0');
    const downloadModeIframeURL = `${pathname.replace(/\/timeline\/?/, '')}/export/${url.search}${hash}`;
    return {
        iframeURL: iframeURL,
        downloadModeIframeURL: downloadModeIframeURL
    };
};
function $bc2892d350cbc1c8$var$PngExport({ fieldsWidth: fieldsWidth, scopeWidth: scopeWidth, initialTimelineDateRange: initialTimelineDateRange, numIssuesInPlan: numIssuesInPlan, numIssues: numIssues, onClose: onClose, planMode: planMode, planTitle: planTitle, SpinnerComponent: SpinnerComponent = (0, $eYlCJ.default), renderPreviewIframe: renderPreviewIframe = true, testIframeUrl: testIframeUrl = null, planExportedAnalytics: planExportedAnalytics, viewMode: viewMode }) {
    const intl = (0, $5JgJ2.default)();
    const didFinishInitialPreview = (0, $eUqFw.useRef)(false);
    const didDownload = (0, $eUqFw.useRef)(false);
    const isUnmounting = (0, $eUqFw.useRef)(false);
    const [isDownloading, setIsDownloading] = (0, $eUqFw.useState)(false);
    const [isDownloadModeReady, setIsDownloadModeReady] = (0, $eUqFw.useState)(false);
    const defaultSelection = viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE : (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE;
    const [selection, setSelection] = (0, $eUqFw.useState)(defaultSelection);
    const [customValue, setCustomValue] = (0, $eUqFw.useState)($bc2892d350cbc1c8$var$presetWidths.large);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [imgData, setImgData] = (0, $eUqFw.useState)(null);
    const [timelineDateRange, setTimelineDateRange] = (0, $eUqFw.useState)(initialTimelineDateRange);
    const iframeRef = (0, $eUqFw.useRef)(null);
    const downloadModeIframeRef = (0, $eUqFw.useRef)(null);
    const isInvalidCustomValue = selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM && customValue.trim() !== '' && (Number(customValue) > 5000 || Number(customValue) < 400);
    const timelineDays = (0, $7CnHa.isDefined)(timelineDateRange.toDate) && (0, $7CnHa.isDefined)(timelineDateRange.fromDate) ? Math.round((timelineDateRange.toDate - timelineDateRange.fromDate) / $bc2892d350cbc1c8$var$DAY_MS) : 0;
    const handleSetSelection = (type, analyticsEvent)=>{
        const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_PNG_CHANGE_TIMELINE_WIDTH.split(' ');
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.update({
            action: action,
            actionSubject: actionSubject
        }), actionSubjectId, {
            timelineWidth: type
        });
        setCustomValue($bc2892d350cbc1c8$var$presetWidths[type]);
        setSelection(type);
    };
    function changeWidth(newWidth) {
        if (iframeRef.current !== null && iframeRef.current.contentWindow) {
            if (didFinishInitialPreview.current) (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW, {
                scalingFactors: {
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues
                }
            });
        }
        const changeWidthOnIframe = (iframe)=>{
            if (iframe.current !== null && iframe.current.contentWindow) {
                setImgData(null);
                setIsDownloadModeReady(false);
                iframe.current && iframe.current.contentWindow.postMessage({
                    type: 'updateTimelineWidth',
                    payload: {
                        fieldsWidth: fieldsWidth,
                        scopeWidth: scopeWidth,
                        timelineExport: newWidth
                    }
                });
            }
        };
        changeWidthOnIframe(iframeRef);
        changeWidthOnIframe(downloadModeIframeRef);
    }
    const debouncedChangeWidth = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(changeWidth, 1000));
    const handleChangeTimelineDateRange = (newCustomDates)=>{
        const range = {
            ...timelineDateRange,
            ...newCustomDates
        };
        setTimelineDateRange(range);
        if (iframeRef.current !== null && iframeRef.current.contentWindow) (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW, {
            scalingFactors: {
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        });
        const changeDateRangeOnIframe = (iframe)=>{
            if (iframe.current !== null && iframe.current.contentWindow) {
                setImgData(null);
                setIsDownloadModeReady(false);
                iframe.current?.contentWindow.postMessage({
                    type: 'updateTimelineDateRange',
                    payload: {
                        timelineDateRange: range
                    }
                });
            }
        };
        changeDateRangeOnIframe(iframeRef);
        changeDateRangeOnIframe(downloadModeIframeRef);
    };
    function downloadImageFromIframe() {
        if (downloadModeIframeRef.current && downloadModeIframeRef.current.contentWindow) downloadModeIframeRef.current.contentWindow.postMessage({
            type: 'downloadImage'
        });
    }
    const handleDownload = (_, analyticsEvent)=>{
        (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.EXPORT, {
            scalingFactors: {
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        });
        setIsDownloading(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportPngDownload', {
            issuesInPlan: numIssuesInPlan,
            issuesInExport: numIssues,
            timelineWidth: selection,
            timelineDays: timelineDays,
            planMode: planMode
        });
        // The iframe will re-export with all the issues, then post 'downloadImage' message
        // which we listen to here and trigger the download.
        downloadImageFromIframe();
    };
    const doDownload = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    async (imgData)=>{
        if (imgData !== null) {
            const res = await fetch(imgData);
            const blob = await res.blob();
            (0, $fG8Rc.saveAs)(blob, (0, $3IuGJ.getExportPngFileName)(intl.formatMessage((0, $ribbU.default).pngExportName, {
                planTitle: planTitle
            }), new Date()));
            didDownload.current = true;
            planExportedAnalytics({
                exportFormat: (0, $6itAY.EXPORT_EVENT_TYPE).PNG,
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues,
                timelineWidth: selection,
                timelineDays: timelineDays
            });
        }
        setIsDownloading(false);
    }, [
        intl,
        planTitle,
        planExportedAnalytics,
        numIssuesInPlan,
        numIssues,
        selection,
        timelineDays
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isInvalidCustomValue) return;
        debouncedChangeWidth.current(Number(customValue));
    }, [
        customValue,
        isInvalidCustomValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const listener = (event)=>{
            switch(event.data.type){
                // profile is triggered for analytics purposes
                case 'profile':
                    {
                        const { profileAction: profileAction, profileKey: profileKey } = event.data.payload;
                        if (!profileAction || !profileKey) throw new Error('profileAction or profileKey missing in profile event');
                        const profileFunc = profileAction === 'start' ? (0, $dYnI4.monitor).startProfile.bind((0, $dYnI4.monitor)) : (0, $dYnI4.monitor).finishProfile.bind((0, $dYnI4.monitor));
                        profileFunc(profileKey);
                        break;
                    }
                // downloadModeReady is triggered when the download mode iframe has finished loading
                case 'downloadModeReady':
                    setIsDownloadModeReady(true);
                    break;
                // exportedImage is triggered when the subsequent preview image is generated
                case 'exportedImage':
                    setImgData(event.data.payload.image);
                    (0, $dYnI4.monitor).finishTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.SUBSEQUENT_PREVIEW);
                    break;
                // initialExportedImage is triggered when the initial preview image is generated
                case 'initialExportedImage':
                    setImgData(event.data.payload.image);
                    (0, $dYnI4.monitor).finishTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.INITIAL_PREVIEW);
                    didFinishInitialPreview.current = true;
                    break;
                // fullExportedImage is triggered when the download mode image is generated
                case 'fullExportedImage':
                    doDownload(event.data.payload.image);
                    (0, $dYnI4.monitor).finishTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.EXPORT);
                    break;
                default:
                    break;
            }
        };
        window.addEventListener('message', listener);
        return ()=>window.removeEventListener('message', listener);
    }, [
        doDownload
    ]);
    // Setup timer for the initial preview
    (0, $eUqFw.useEffect)(()=>{
        (0, $dYnI4.monitor).startTask((0, $5rYNM.PERFORMANCE_KEYS).EXPORT_PNG.INITIAL_PREVIEW, {
            scalingFactors: {
                issuesInPlan: numIssuesInPlan,
                issuesInExport: numIssues
            }
        });
        // This is the only profile we start from the parent.
        // The rest are started from the iframe using the 'profile' postMessage event.
        (0, $dYnI4.monitor).startProfile((0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.INITIAL_LOAD);
    }, [
        numIssues,
        numIssuesInPlan
    ]);
    // Send analytics before dismounting
    (0, $eUqFw.useEffect)(()=>()=>{
            isUnmounting.current = true;
        }, []);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (isUnmounting.current) {
                const [actionSubject, action, actionSubjectId] = (0, $cuuJa.PRODUCT_ANALYTICS_EVENT_NAMES).EXPORT_PNG_MODAL_CLOSED.split(' ');
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject
                }), actionSubjectId, {
                    issuesInPlan: numIssuesInPlan,
                    issuesInExport: numIssues,
                    isDownloading: isDownloading,
                    isGeneratingPreview: imgData === null && !isDownloadModeReady && !isDownloading && numIssues <= $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES,
                    isShowingTooManyIssuesWarning: numIssues > $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES,
                    didDownload: didDownload.current,
                    viewMode: viewMode
                });
            }
        }, [
        createAnalyticsEvent,
        imgData,
        isDownloading,
        isDownloadModeReady,
        numIssues,
        numIssuesInPlan,
        viewMode
    ]);
    let iframeURL = '';
    let downloadModeIframeURL = '';
    const URLs = $bc2892d350cbc1c8$var$buildIframeUrls(window.location.href, scopeWidth, fieldsWidth, initialTimelineDateRange.fromDate, initialTimelineDateRange.toDate);
    iframeURL = (0, $7CnHa.isDefined)(testIframeUrl) ? `${testIframeUrl}&startInPreviewMode=1` : URLs.iframeURL;
    downloadModeIframeURL = (0, $7CnHa.isDefined)(testIframeUrl) ? `${testIframeUrl}&startInPreviewMode=0` : URLs.downloadModeIframeURL;
    let invalidMsg = null;
    if (numIssues > $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES) invalidMsg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            viewDisplayed: 'tooManyIssuesWarning',
            issuesInPlan: numIssuesInPlan,
            issuesInExport: numIssues
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $ribbU.default).tooManyIssues,
        values: {
            visibleIssues: numIssues
        }
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $ribbU.default).plansMaxIssues,
        values: {
            maxIssues: $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $ribbU.default).maxIssuesSuggestion,
        values: {
            maxIssues: $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES
        }
    })));
    else if (numIssues <= 0) invalidMsg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            viewDisplayed: 'noIssuesWarning',
            issuesInPlan: numIssuesInPlan,
            issuesInExport: numIssues
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ribbU.default).noIssues));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "exportPng",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.container
    }, invalidMsg || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            viewDisplayed: 'exportControls',
            issuesInPlan: numIssuesInPlan,
            issuesInExport: numIssues
        }
    }), viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ks3x.default), {
        isDisabled: isDownloading,
        selection: selection,
        setSelection: handleSetSelection,
        customWidth: customValue,
        setCustomWidth: setCustomValue,
        customDateRange: timelineDateRange,
        setCustomDateRange: handleChangeTimelineDateRange
    }), isInvalidCustomValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.invalid-timeline-message",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bgE6H.errorMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage((0, $ribbU.default).customValueErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.previewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.previewBadge
    }, imgData === null || !isDownloadModeReady || isDownloading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpinnerComponent, {
        size: "small",
        invertColor: true
    })), intl.formatMessage(isDownloading ? (0, $ribbU.default).exportingMessage : (0, $ribbU.default).loadingMessage, {
        visibleIssues: numIssues
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, numIssues > (0, $5rYNM.NUM_ISSUES_IN_EXPORT_PREVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $ribbU.default).previewLozenge,
        values: {
            visibleIssues: numIssues,
            previewIssues: (0, $5rYNM.NUM_ISSUES_IN_EXPORT_PREVIEW)
        }
    }) : intl.formatMessage((0, $ribbU.default).previewLozengeBasic))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.previewPane
    }, imgData !== null && isDownloadModeReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        "data-test-id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-image",
        src: imgData,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bgE6H.previewImage,
        alt: intl.formatMessage((0, $ribbU.default).pngExportImageAlt, {
            planTitle: planTitle
        })
    }))))), numIssues > $bc2892d350cbc1c8$var$WARNING_ISSUE_COUNT_LIMIT && numIssues <= $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: intl.formatMessage((0, $ribbU.default).filterIssuesMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.warningMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $ribbU.default).warningMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awiwy.default), {
        href: (0, $awiwy.default).URLs.exportPng
    }, intl.formatMessage((0, $ib5d3.default).learnMore))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $bgE6H.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        appearance: "primary",
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.download",
        isDisabled: isInvalidCustomValue || imgData === null || !isDownloadModeReady || isDownloading,
        onClick: handleDownload
    }, intl.formatMessage(isDownloading ? (0, $ribbU.default).downloading : (0, $ribbU.default).downloadButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.cancel-button",
        appearance: "subtle",
        onClick: onClose
    }, intl.formatMessage((0, $ib5d3.default).cancel))))), renderPreviewIframe && numIssues <= $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES && numIssues > 0 && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        ref: iframeRef,
        title: "export png preview mode",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bgE6H.collapsedIframe,
        src: iframeURL
    }), document.body || document.createElement('div')), renderPreviewIframe && numIssues <= $bc2892d350cbc1c8$var$MAX_VISIBLE_ISSUES && numIssues > 0 && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        ref: downloadModeIframeRef,
        title: "export png download mode",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $bgE6H.collapsedIframe,
        src: downloadModeIframeURL
    }), document.body || document.createElement('div')));
}
var $bc2892d350cbc1c8$export$2e2bcd8739ae039 = $bc2892d350cbc1c8$var$PngExport;

});
parcelRegister("ribbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2602fdf0641632b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $2602fdf0641632b7$var$messages = (0, $90IgZ.defineMessages)({
    tooManyIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.too-many-issues",
        "defaultMessage": "Your plan view is currently showing {visibleIssues, plural, one {# issue} other {# issues}}."
    },
    noIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.no-issues",
        "defaultMessage": "Your plan view is not showing any issues."
    },
    plansMaxIssues: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.plans-max-issues",
        "defaultMessage": "Plans can only export {maxIssues, plural, one {# issue} other {# issues}} to a PNG at one time. Please use filters to hide issues from your plan view."
    },
    maxIssuesSuggestion: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.max-issues-suggestion",
        "defaultMessage": "If you want a snapshot of your data that contains more than {maxIssues, plural, one {# issue} other {# issues}}, we recommend exporting your issues as a .csv file."
    },
    previewLozenge: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-lozenge",
        "defaultMessage": "Previewing {previewIssues} of {visibleIssues, plural, one {# issue} other {# issues}}"
    },
    previewLozengeBasic: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.preview-lozenge-basic",
        "defaultMessage": "Preview"
    },
    downloading: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.downloading",
        "defaultMessage": "Downloading..."
    },
    downloadButtonLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.download-button-label",
        "defaultMessage": "Download"
    },
    customValueErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.custom-value-error-message",
        "defaultMessage": "Timeline width must be between 400 and 5000 pixels"
    },
    loadingMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.loading-message",
        "defaultMessage": "Generating preview..."
    },
    exportingMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.exporting-message",
        "defaultMessage": "Exporting {visibleIssues, plural, one {# issue} other {# issues}}..."
    },
    warningMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.warning-message",
        "defaultMessage": "Your export could take a few minutes."
    },
    filterIssuesMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.filter-issues-message",
        "defaultMessage": "Filter issues from your timeline and hide unnecessary columns to make it faster."
    },
    pngExportName: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.png-export-name",
        "defaultMessage": "Plans {planTitle}"
    },
    pngExportImageAlt: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.png-export-image-alt",
        "defaultMessage": "{planTitle} preview"
    }
});
var $2602fdf0641632b7$export$2e2bcd8739ae039 = $2602fdf0641632b7$var$messages;

});

parcelRegister("bgE6H", function(module, exports) {

$parcel$export(module.exports, "collapsedIframe", () => $83404cc60fc6b8b3$export$56a50ac285b8f9fc, (v) => $83404cc60fc6b8b3$export$56a50ac285b8f9fc = v);
$parcel$export(module.exports, "container", () => $83404cc60fc6b8b3$export$34e0f9847d4c02dd, (v) => $83404cc60fc6b8b3$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "errorMessage", () => $83404cc60fc6b8b3$export$493b5823483d2c4e, (v) => $83404cc60fc6b8b3$export$493b5823483d2c4e = v);
$parcel$export(module.exports, "footer", () => $83404cc60fc6b8b3$export$adb608be33961c98, (v) => $83404cc60fc6b8b3$export$adb608be33961c98 = v);
$parcel$export(module.exports, "previewBadge", () => $83404cc60fc6b8b3$export$95cbb0d5b186c892, (v) => $83404cc60fc6b8b3$export$95cbb0d5b186c892 = v);
$parcel$export(module.exports, "previewContainer", () => $83404cc60fc6b8b3$export$8aade8ce2b5d7e87, (v) => $83404cc60fc6b8b3$export$8aade8ce2b5d7e87 = v);
$parcel$export(module.exports, "previewImage", () => $83404cc60fc6b8b3$export$b5db251096956c0d, (v) => $83404cc60fc6b8b3$export$b5db251096956c0d = v);
$parcel$export(module.exports, "previewPane", () => $83404cc60fc6b8b3$export$c3bb42c40ca018ec, (v) => $83404cc60fc6b8b3$export$c3bb42c40ca018ec = v);
$parcel$export(module.exports, "spinnerContainer", () => $83404cc60fc6b8b3$export$140fd7bd1291a3e4, (v) => $83404cc60fc6b8b3$export$140fd7bd1291a3e4 = v);
$parcel$export(module.exports, "warningMessage", () => $83404cc60fc6b8b3$export$8abc02a5a17d88e4, (v) => $83404cc60fc6b8b3$export$8abc02a5a17d88e4 = v);
var $83404cc60fc6b8b3$export$56a50ac285b8f9fc;
var $83404cc60fc6b8b3$export$34e0f9847d4c02dd;
var $83404cc60fc6b8b3$export$493b5823483d2c4e;
var $83404cc60fc6b8b3$export$adb608be33961c98;
var $83404cc60fc6b8b3$export$95cbb0d5b186c892;
var $83404cc60fc6b8b3$export$8aade8ce2b5d7e87;
var $83404cc60fc6b8b3$export$b5db251096956c0d;
var $83404cc60fc6b8b3$export$c3bb42c40ca018ec;
var $83404cc60fc6b8b3$export$140fd7bd1291a3e4;
var $83404cc60fc6b8b3$export$8abc02a5a17d88e4;
$83404cc60fc6b8b3$export$56a50ac285b8f9fc = `g8i1ia_collapsedIframe`;
$83404cc60fc6b8b3$export$34e0f9847d4c02dd = `g8i1ia_container`;
$83404cc60fc6b8b3$export$493b5823483d2c4e = `g8i1ia_errorMessage`;
$83404cc60fc6b8b3$export$adb608be33961c98 = `g8i1ia_footer`;
$83404cc60fc6b8b3$export$95cbb0d5b186c892 = `g8i1ia_previewBadge`;
$83404cc60fc6b8b3$export$8aade8ce2b5d7e87 = `g8i1ia_previewContainer`;
$83404cc60fc6b8b3$export$b5db251096956c0d = `g8i1ia_previewImage`;
$83404cc60fc6b8b3$export$c3bb42c40ca018ec = `g8i1ia_previewPane`;
$83404cc60fc6b8b3$export$140fd7bd1291a3e4 = `g8i1ia_spinnerContainer`;
$83404cc60fc6b8b3$export$8abc02a5a17d88e4 = `g8i1ia_warningMessage`;

});

parcelRegister("5ks3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $f67402034b0bf4c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $8G7Ct = parcelRequire("8G7Ct");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $g4Vkx = parcelRequire("g4Vkx");
var $4LhB6 = parcelRequire("4LhB6");
var $hnuwz = parcelRequire("hnuwz");
var $lIePH = parcelRequire("lIePH");
var $gwbfD = parcelRequire("gwbfD");

var $3Yj7v = parcelRequire("3Yj7v");

var $kYJkt = parcelRequire("kYJkt");

var $9FWlf = parcelRequire("9FWlf");

var $ib5d3 = parcelRequire("ib5d3");

var $7jIPT = parcelRequire("7jIPT");

var $cxXqp = parcelRequire("cxXqp");

var $9IEJ2 = parcelRequire("9IEJ2");
const $f67402034b0bf4c2$var$ExportTimelineSettings = ({ isDisabled: isDisabled, selection: selection, setSelection: setSelection, customWidth: customWidth, setCustomWidth: setCustomWidth, customDateRange: customDateRange, setCustomDateRange: setCustomDateRange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const announcerRef = (0, $eUqFw.useRef)(null);
    const createSelectionSetter = (type)=>(_, analyticsEvent)=>setSelection(type, analyticsEvent);
    const createSelectionSetterOld = (type)=>(_, analyticsEvent)=>setSelection(type, analyticsEvent);
    const timelineSettingsContainer = (0, $1ZAYh.xcss)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        gap: 'space.100'
    });
    const timelineSettingsField = (0, $1ZAYh.xcss)({
        marginTop: 'space.negative.075',
        gap: 'space.025'
    });
    const timelineWidthContainer = (0, $1ZAYh.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100'
    });
    const customTextBoxContainer = (0, $1ZAYh.xcss)({
        alignItems: 'center',
        caretColor: 'color.icon.accent.gray.subtle',
        display: 'flex',
        marginLeft: 'space.100'
    });
    const customTextBoxContainerLabel = (0, $1ZAYh.xcss)({
        marginLeft: 'space.050',
        color: 'color.text.subtle',
        fontSize: '16px'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('jsw.roadmaps.plan-timeline-screen-missing-list-mark-up_7zqp1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: timelineSettingsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: timelineSettingsField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("fieldset", {
        className: $9IEJ2.timelineSettingsFieldset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", {
        className: $9IEJ2.timelineSettingsLegend
    }, formatMessage((0, $cxXqp.default).widthLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: timelineWidthContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-timeline",
        isDisabled: isDisabled,
        isChecked: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL,
        onChange: createSelectionSetter((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL),
        label: formatMessage((0, $cxXqp.default).smallLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-timeline",
        isDisabled: isDisabled,
        isChecked: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM,
        onChange: createSelectionSetter((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM),
        label: formatMessage((0, $cxXqp.default).mediumLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-timeline",
        isDisabled: isDisabled,
        isChecked: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE,
        onChange: createSelectionSetter((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE),
        label: formatMessage((0, $cxXqp.default).largeLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline",
        isDisabled: isDisabled,
        isChecked: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM,
        onChange: createSelectionSetter((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM),
        label: formatMessage((0, $cxXqp.default).customLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: customTextBoxContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIePH.default), {
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline-width",
        isCompact: true,
        isDisabled: selection !== (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM || isDisabled,
        type: "number",
        value: customWidth,
        min: 400,
        max: 5000,
        onChange: (e)=>{
            setCustomWidth(e.target.value);
            announcerRef.current?.announce();
        },
        width: "80",
        "aria-label": formatMessage((0, $cxXqp.default).customWidthPixelLabelText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Yj7v.DelayedAnnouncer), {
        ref: announcerRef,
        label: customWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: customTextBoxContainerLabel
    }, formatMessage((0, $cxXqp.default).customWidthPixelLabel)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: timelineSettingsField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $cxXqp.default).timelineRangeLabel),
        name: "timelineRange",
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJkt.default), {
            fieldProps: fieldProps,
            customDateRange: customDateRange,
            onCustomDatesChange: setCustomDateRange,
            isDisabled: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE || isDisabled
        })))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9IEJ2.timelineSettingsContainerOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9IEJ2.timelineSettingsField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $cxXqp.default).widthLabel),
        name: "timelineWidth",
        defaultValue: ""
    }, ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9IEJ2.timelineWidthContainerOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $cxXqp.default).hideTimelineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.no-timeline",
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9IEJ2.iconButton} ${$9IEJ2.leftButton}`,
            isSelected: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8G7Ct))), {
                label: formatMessage((0, $cxXqp.default).hideTimelineTooltip),
                secondaryColor: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE ? `var(--ds-icon-inverse, ${(0, $g4Vkx.default).N500})` : `var(--ds-icon-inverse, ${(0, $g4Vkx.default).N0})`
            }),
            onClick: createSelectionSetterOld((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $cxXqp.default).smallTimelineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-timeline",
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9IEJ2.iconButton} ${$9IEJ2.smallIcon}`,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                label: "",
                dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($9FWlf)))
            }),
            isSelected: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL,
            onClick: createSelectionSetterOld((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).SMALL)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $cxXqp.default).mediumTimelineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-timeline",
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9IEJ2.iconButton} ${$9IEJ2.mediumIcon}`,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                label: "",
                dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($9FWlf)))
            }),
            isSelected: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM,
            onClick: createSelectionSetterOld((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).MEDIUM)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: formatMessage((0, $cxXqp.default).largeTimelineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-timeline",
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9IEJ2.iconButton} ${$9IEJ2.largeIcon}`,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
                label: "",
                dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($9FWlf)))
            }),
            isSelected: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE,
            onClick: createSelectionSetterOld((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).LARGE)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline",
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${$9IEJ2.iconButton} ${$9IEJ2.rightButton}`,
            isSelected: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM,
            onClick: createSelectionSetterOld((0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM)
        }, formatMessage((0, $cxXqp.default).customLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9IEJ2.customTextBoxContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lIePH.default), {
            testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-timeline-width",
            isCompact: true,
            isDisabled: selection !== (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).CUSTOM || isDisabled,
            type: "number",
            value: customWidth,
            min: 400,
            max: 5000,
            onChange: (e)=>{
                setCustomWidth(e.target.value);
            },
            width: "80",
            "aria-label": formatMessage((0, $cxXqp.default).customWidthPixelLabelText)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $9IEJ2.customTextBoxContainerLabel
        }, formatMessage((0, $cxXqp.default).customWidthPixelLabel)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9IEJ2.timelineSettingsField
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $ib5d3.default).dateRange),
        name: "timelineRange",
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kYJkt.default), {
            fieldProps: fieldProps,
            customDateRange: customDateRange,
            onCustomDatesChange: setCustomDateRange,
            isDisabled: selection === (0, $7jIPT.EXPORT_PNG_TIMELINE_WIDTH_OPTIONS).NONE || isDisabled
        })))));
};
var $f67402034b0bf4c2$export$2e2bcd8739ae039 = $f67402034b0bf4c2$var$ExportTimelineSettings;

});
parcelRegister("8G7Ct", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65182812713c931f$var$_react = $65182812713c931f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $65182812713c931f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $65182812713c931f$var$PresenceBusyIcon = (props)=>/*#__PURE__*/ $65182812713c931f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12 18a6 6 0 100-12 6 6 0 000 12z" fill="currentColor"/><path d="M9.367 9.363a1.241 1.241 0 011.747-.008l3.527 3.527c.48.48.48 1.26-.008 1.747a1.241 1.241 0 01-1.747.008l-3.527-3.526c-.48-.48-.48-1.26.008-1.748z" fill="inherit"/></g></svg>`
    }, props));
$65182812713c931f$var$PresenceBusyIcon.displayName = 'PresenceBusyIcon';
var $65182812713c931f$var$_default = $65182812713c931f$var$PresenceBusyIcon;
module.exports.default = $65182812713c931f$var$_default;

});

parcelRegister("kYJkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a4a3307b9a6ce$export$2e2bcd8739ae039);

var $7u2P4 = parcelRequire("7u2P4");
var $975a4a3307b9a6ce$export$2e2bcd8739ae039 = (0, $7u2P4.default);

});
parcelRegister("7u2P4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea56ace8d3148a4f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aAyrO = parcelRequire("aAyrO");
var $eTbtL = parcelRequire("eTbtL");
var $17L5s = parcelRequire("17L5s");
var $eNhh9 = parcelRequire("eNhh9");

var $1Ai5n = parcelRequire("1Ai5n");parcelRequire("9IIas");
var $kmfT1 = parcelRequire("kmfT1");
function $ea56ace8d3148a4f$export$2e2bcd8739ae039({ customDateRange: customDateRange, isDisabled: isDisabled = false, onCustomDatesChange: onCustomDatesChange, fieldProps: fieldProps }) {
    const intl = (0, $5JgJ2.default)();
    const [isCustomRangeDialogOpen, setIsCustomRangeDialogOpen] = (0, $eUqFw.useState)(false);
    const [dialogPosition, setDialogPosition] = (0, $eUqFw.useState)('bottom-end');
    const ref = (0, $eUqFw.useRef)(null);
    const onCustomDatesApplied = (range)=>{
        setIsCustomRangeDialogOpen(false);
        onCustomDatesChange(range);
    };
    // A hack to make sure the dialog stays at the bottom-end of date range button
    // When the selected tab is changed, the dialog position is set to value other than 'bottom-end'
    const recalculateDialogPosition = ()=>{
        setDialogPosition('auto-end');
    };
    // Then the dialogPosition is set back to 'bottom-end' when position was changed in the recalculateDialogPosition
    (0, $eUqFw.useEffect)(()=>{
        setDialogPosition('bottom-end');
    }, [
        dialogPosition
    ]);
    const customItemDialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Ai5n.CustomDateRangeModalContent), {
        dateRange: customDateRange,
        onConfirm: onCustomDatesApplied,
        onCancel: ()=>setIsCustomRangeDialogOpen(false),
        onSelectedTabChange: recalculateDialogPosition
    });
    const onItemClicked = ()=>{
        setIsCustomRangeDialogOpen((prevIsCustomRangeDialogOpen)=>!prevIsCustomRangeDialogOpen);
    };
    const getButtonText = ()=>{
        const { fromDate: fromDate, toDate: toDate, typeOfCustomDateRange: typeOfCustomDateRange } = customDateRange;
        if (typeOfCustomDateRange === (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).RELATIVE) {
            const { start: start, end: end } = (0, $17L5s.getRelativeDates)(customDateRange, new Date());
            return (0, $kmfT1.getStringFromDates)(start, end, intl);
        }
        return (0, $kmfT1.getStringFromDates)(fromDate, toDate, intl);
    };
    const buttonWithIcon = (0, $1ZAYh.xcss)({
        marginLeft: 'space.100'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
        content: customItemDialogContent,
        isOpen: isCustomRangeDialogOpen,
        maxWidth: 716,
        overflow: "visible",
        placement: dialogPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aAyrO.default), {
        onClick: ()=>onItemClicked(),
        ...fieldProps,
        "aria-labelledby": `${fieldProps?.['aria-labelledby']} ${fieldProps?.id}-buttonText`,
        isDisabled: isDisabled,
        testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.custom-timeline-range.button",
        ...(0, $1ybV0.ff)('jsw.roadmaps.plan-timeline-screen-missing-list-mark-up_7zqp1') && {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: buttonWithIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                label: ""
            }))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: `${fieldProps?.id}-buttonText`
    }, getButtonText()))));
}

});


parcelRegister("9FWlf", function(module, exports) {
module.exports = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path style=\"fill:currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 0C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H9C10.6569 12 12 10.6569 12 9V3C12 1.34315 10.6569 0 9 0H3ZM3.17848 6.64171L3.81856 7.32919C3.92794 7.44667 3.98946 7.60609 3.98959 7.77237C3.98971 7.93865 3.92844 8.09817 3.81923 8.21585C3.71003 8.33352 3.56185 8.3997 3.40728 8.39984C3.25272 8.39998 3.10444 8.33405 2.99506 8.21657L1.38825 6.49078C1.13749 6.22145 1.13675 5.78389 1.38668 5.51457L2.99252 3.78418C3.10188 3.66633 3.25029 3.60005 3.40508 3.59991C3.55988 3.59977 3.70838 3.6658 3.81793 3.78346C3.92748 3.90111 3.98909 4.06077 3.98922 4.2273C3.98934 4.39383 3.92797 4.55359 3.8186 4.67144L3.17998 5.3596L5.62569 5.35746C5.63257 5.35714 5.63945 5.35695 5.64636 5.35689L5.95957 5.35716L6.35306 5.35682C6.36094 5.35688 6.3688 5.35712 6.37663 5.35753L8.81944 5.35967L8.18081 4.67151C8.07144 4.55366 8.01007 4.3939 8.0102 4.22737C8.01032 4.06084 8.07194 3.90118 8.18148 3.78353C8.29103 3.66587 8.43954 3.59984 8.59433 3.59998C8.74913 3.60012 8.89753 3.6664 9.0069 3.78425L10.6127 5.51464C10.8627 5.78396 10.8619 6.22152 10.6112 6.49084L9.00436 8.21664C8.89498 8.33412 8.74669 8.40005 8.59213 8.39991C8.43757 8.39977 8.28939 8.33359 8.18018 8.21592C8.07098 8.09824 8.0097 7.93872 8.00982 7.77244C8.00995 7.60616 8.07147 7.44674 8.18085 7.32926L8.82094 6.64178L5.95985 6.63927L3.17848 6.64171Z\"></path>\n</svg>\n";

});

parcelRegister("cxXqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfec92fef3a8779a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $bfec92fef3a8779a$var$messages = (0, $90IgZ.defineMessages)({
    widthLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.width-label",
        "defaultMessage": "Timeline width"
    },
    smallLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-label",
        "defaultMessage": "Small"
    },
    mediumLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-label",
        "defaultMessage": "Medium"
    },
    largeLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-label",
        "defaultMessage": "Large"
    },
    customLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-label",
        "defaultMessage": "Custom"
    },
    customWidthPixelLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-width-pixel-label",
        "defaultMessage": "px"
    },
    hideTimelineTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.hide-timeline-tooltip",
        "defaultMessage": "Hide timeline"
    },
    smallTimelineTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.small-timeline-tooltip",
        "defaultMessage": "Small timeline"
    },
    mediumTimelineTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.medium-timeline-tooltip",
        "defaultMessage": "Medium timeline"
    },
    largeTimelineTooltip: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.large-timeline-tooltip",
        "defaultMessage": "Large timeline"
    },
    customWidthPixelLabelText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.custom-width-pixel-label-text",
        "defaultMessage": "Enter 400 to 5000 pixels"
    },
    timelineRangeLabel: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.components.png-export.timeline-settings.timeline-range-label",
        "defaultMessage": "Timeline range"
    }
});
var $bfec92fef3a8779a$export$2e2bcd8739ae039 = $bfec92fef3a8779a$var$messages;

});

parcelRegister("9IEJ2", function(module, exports) {

$parcel$export(module.exports, "customTextBoxContainer", () => $7137d05c10f5446e$export$9641704250b21401, (v) => $7137d05c10f5446e$export$9641704250b21401 = v);
$parcel$export(module.exports, "customTextBoxContainerLabel", () => $7137d05c10f5446e$export$606c4ee59580a558, (v) => $7137d05c10f5446e$export$606c4ee59580a558 = v);
$parcel$export(module.exports, "iconButton", () => $7137d05c10f5446e$export$60bb6c1f29b8a8cc, (v) => $7137d05c10f5446e$export$60bb6c1f29b8a8cc = v);
$parcel$export(module.exports, "largeIcon", () => $7137d05c10f5446e$export$74d5185f69036be9, (v) => $7137d05c10f5446e$export$74d5185f69036be9 = v);
$parcel$export(module.exports, "leftButton", () => $7137d05c10f5446e$export$8d2bf4574acbbb23, (v) => $7137d05c10f5446e$export$8d2bf4574acbbb23 = v);
$parcel$export(module.exports, "mediumIcon", () => $7137d05c10f5446e$export$172b1039ee6f4aa5, (v) => $7137d05c10f5446e$export$172b1039ee6f4aa5 = v);
$parcel$export(module.exports, "rightButton", () => $7137d05c10f5446e$export$ca46c843dfcf70a9, (v) => $7137d05c10f5446e$export$ca46c843dfcf70a9 = v);
$parcel$export(module.exports, "smallIcon", () => $7137d05c10f5446e$export$a84d047839c615fd, (v) => $7137d05c10f5446e$export$a84d047839c615fd = v);
$parcel$export(module.exports, "timelineSettingsContainerOld", () => $7137d05c10f5446e$export$38460e3a7fdb3a06, (v) => $7137d05c10f5446e$export$38460e3a7fdb3a06 = v);
$parcel$export(module.exports, "timelineSettingsField", () => $7137d05c10f5446e$export$1a0ec97652b58e49, (v) => $7137d05c10f5446e$export$1a0ec97652b58e49 = v);
$parcel$export(module.exports, "timelineSettingsFieldset", () => $7137d05c10f5446e$export$801db1482b62a3ee, (v) => $7137d05c10f5446e$export$801db1482b62a3ee = v);
$parcel$export(module.exports, "timelineSettingsLegend", () => $7137d05c10f5446e$export$3c04ee4c4b5472b8, (v) => $7137d05c10f5446e$export$3c04ee4c4b5472b8 = v);
$parcel$export(module.exports, "timelineWidthContainerOld", () => $7137d05c10f5446e$export$11fc36cd349534a9, (v) => $7137d05c10f5446e$export$11fc36cd349534a9 = v);
var $7137d05c10f5446e$export$9641704250b21401;
var $7137d05c10f5446e$export$606c4ee59580a558;
var $7137d05c10f5446e$export$60bb6c1f29b8a8cc;
var $7137d05c10f5446e$export$74d5185f69036be9;
var $7137d05c10f5446e$export$8d2bf4574acbbb23;
var $7137d05c10f5446e$export$172b1039ee6f4aa5;
var $7137d05c10f5446e$export$ca46c843dfcf70a9;
var $7137d05c10f5446e$export$a84d047839c615fd;
var $7137d05c10f5446e$export$8f1254d250c66dfe;
var $7137d05c10f5446e$export$38460e3a7fdb3a06;
var $7137d05c10f5446e$export$1a0ec97652b58e49;
var $7137d05c10f5446e$export$801db1482b62a3ee;
var $7137d05c10f5446e$export$3c04ee4c4b5472b8;
var $7137d05c10f5446e$export$6758a543ba1276a1;
var $7137d05c10f5446e$export$11fc36cd349534a9;
$7137d05c10f5446e$export$9641704250b21401 = `FQwbrG_customTextBoxContainer`;
$7137d05c10f5446e$export$606c4ee59580a558 = `FQwbrG_customTextBoxContainerLabel`;
$7137d05c10f5446e$export$60bb6c1f29b8a8cc = `FQwbrG_iconButton`;
$7137d05c10f5446e$export$74d5185f69036be9 = `FQwbrG_largeIcon`;
$7137d05c10f5446e$export$8d2bf4574acbbb23 = `FQwbrG_leftButton`;
$7137d05c10f5446e$export$172b1039ee6f4aa5 = `FQwbrG_mediumIcon`;
$7137d05c10f5446e$export$ca46c843dfcf70a9 = `FQwbrG_rightButton`;
$7137d05c10f5446e$export$a84d047839c615fd = `FQwbrG_smallIcon`;
$7137d05c10f5446e$export$8f1254d250c66dfe = `FQwbrG_timelineSettingsContainer`;
$7137d05c10f5446e$export$38460e3a7fdb3a06 = `FQwbrG_timelineSettingsContainerOld`;
$7137d05c10f5446e$export$1a0ec97652b58e49 = `FQwbrG_timelineSettingsField`;
$7137d05c10f5446e$export$801db1482b62a3ee = `FQwbrG_timelineSettingsFieldset`;
$7137d05c10f5446e$export$3c04ee4c4b5472b8 = `FQwbrG_timelineSettingsLegend`;
$7137d05c10f5446e$export$6758a543ba1276a1 = `FQwbrG_timelineWidthContainer`;
$7137d05c10f5446e$export$11fc36cd349534a9 = `FQwbrG_timelineWidthContainerOld`;

});




parcelRegister("bOk0G", function(module, exports) {

$parcel$export(module.exports, "getCsvIntlMessages", () => $3a21dc65a1cd5944$export$7652b5caf942c20);


var $ib5d3 = parcelRequire("ib5d3");

var $2i5F1 = parcelRequire("2i5F1");
const $3a21dc65a1cd5944$export$7652b5caf942c20 = (formatMessage, planTitle)=>{
    const columnHeadingRollUpLabel = formatMessage((0, $2i5F1.default).exportCsvColumnHeadingRollUp);
    return {
        exportName: formatMessage((0, $2i5F1.default).exportCsvFilename, {
            planTitle: planTitle
        }),
        columnHeadings: {
            type: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingHierarchy),
            summary: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTitle),
            project: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProject),
            releaseRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingReleases)} ${columnHeadingRollUpLabel}`,
            release: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingReleases),
            teamRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTeam)} ${columnHeadingRollUpLabel}`,
            team: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTeam),
            assignee: formatMessage((0, $ib5d3.default).assignee),
            reporter: formatMessage((0, $ib5d3.default).reporter),
            sprintRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingSprint)} ${columnHeadingRollUpLabel}`,
            sprint: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingSprint),
            targetStartDateRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTargetStartDate)} ${columnHeadingRollUpLabel}`,
            targetStartDate: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTargetStartDate),
            targetEndDateRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTargetEndDate)} ${columnHeadingRollUpLabel}`,
            targetEndDate: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTargetEndDate),
            dueDateRollUp: `${formatMessage((0, $ib5d3.default).dueDate)} ${columnHeadingRollUpLabel}`,
            dueDate: formatMessage((0, $ib5d3.default).dueDate),
            estimateDaysRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingEstimateDays)} ${columnHeadingRollUpLabel}`,
            estimateDays: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingEstimateDays),
            estimateHoursRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingEstimateHours)} ${columnHeadingRollUpLabel}`,
            estimateHours: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingEstimateHours),
            estimateStoryPointsRollUp: `${formatMessage((0, $2i5F1.default).exportCsvColumnHeadingStoryPoints)} ${columnHeadingRollUpLabel}`,
            estimateStoryPoints: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingStoryPoints),
            [(0, $d3ec7873a55d3e9b$export$c029c3f1c363635d)]: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingGoalName),
            [(0, $d3ec7873a55d3e9b$export$f33fc1dddb5c20e9)]: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingGoalStatus),
            parent: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingParent),
            priority: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingPriority),
            labels: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingLabels),
            components: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingComponents),
            key: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingIssueKey),
            status: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingIssueStatus),
            progressPercentage: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressPercentage),
            progressCompletedDays: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressCompletedDays),
            progressCompletedHours: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressCompletedHours),
            progressCompletedStoryPoints: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressCompletedStoryPoints),
            progressRemainingDays: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressRemainingDays),
            progressRemainingHours: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressRemainingHours),
            progressRemainingStoryPoints: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressRemainingStoryPoints),
            progressIssueCount: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingProgressIssueCountPercentage),
            toDoIssueCount: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingToDoIssueCount),
            inProgressIssueCount: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingInProgressIssueCount),
            doneIssueCount: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingDoneIssueCount),
            totalIssueCount: formatMessage((0, $2i5F1.default).exportCsvColumnHeadingTotalIssueCount),
            rollUp: columnHeadingRollUpLabel
        },
        labels: {
            external: formatMessage((0, $2i5F1.default).exportCsvExternalLabel),
            completed: formatMessage((0, $2i5F1.default).exportCsvCompletedLabel)
        }
    };
};

});


parcelRegister("3o0Oi", function(module, exports) {

$parcel$export(module.exports, "default", () => $29528cbc3d476f9b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $29528cbc3d476f9b$var$messages = (0, $90IgZ.defineMessages)({
    shareButtonText: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-button-text",
        "defaultMessage": "Share"
    },
    shareHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-header",
        "defaultMessage": "Share plan as"
    },
    shareAsLink: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-link",
        "defaultMessage": "Link"
    },
    shareAsEmbed: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-embed",
        "defaultMessage": "Embed"
    },
    shareAsConfluence: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-confluence",
        "defaultMessage": "Confluence"
    },
    shareAsSpreadsheetCsv: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-spreadsheet-csv",
        "defaultMessage": "CSV"
    },
    shareAsPng: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.share-report.share-as-png",
        "defaultMessage": "Image (.png)"
    }
});
var $29528cbc3d476f9b$export$2e2bcd8739ae039 = $29528cbc3d476f9b$var$messages;

});



parcelRegister("gy8pW", function(module, exports) {

$parcel$export(module.exports, "headerRow", () => $c0c659d1edeb697d$export$faed4863136ce212, (v) => $c0c659d1edeb697d$export$faed4863136ce212 = v);
$parcel$export(module.exports, "headerRowBacklogSeparator", () => $c0c659d1edeb697d$export$102b19bec5f1b880, (v) => $c0c659d1edeb697d$export$102b19bec5f1b880 = v);
$parcel$export(module.exports, "headerRowLeft", () => $c0c659d1edeb697d$export$b2456e4507ac1eff, (v) => $c0c659d1edeb697d$export$b2456e4507ac1eff = v);
$parcel$export(module.exports, "headerRowSeparator", () => $c0c659d1edeb697d$export$3bb9594b148e59ee, (v) => $c0c659d1edeb697d$export$3bb9594b148e59ee = v);
$parcel$export(module.exports, "left", () => $c0c659d1edeb697d$export$eabcd2c8791e7bf4, (v) => $c0c659d1edeb697d$export$eabcd2c8791e7bf4 = v);
$parcel$export(module.exports, "readOnlyPlanLozenge", () => $c0c659d1edeb697d$export$febac0928185e9d4, (v) => $c0c659d1edeb697d$export$febac0928185e9d4 = v);
$parcel$export(module.exports, "title", () => $c0c659d1edeb697d$export$fb184b623420d9be, (v) => $c0c659d1edeb697d$export$fb184b623420d9be = v);
$parcel$export(module.exports, "toolBar", () => $c0c659d1edeb697d$export$ed2652bdb9ef1ad0, (v) => $c0c659d1edeb697d$export$ed2652bdb9ef1ad0 = v);
$parcel$export(module.exports, "toolBarButtonIcon", () => $c0c659d1edeb697d$export$f4bed195fe4c740c, (v) => $c0c659d1edeb697d$export$f4bed195fe4c740c = v);
$parcel$export(module.exports, "toolBarFiltersSettingsContainer", () => $c0c659d1edeb697d$export$b12c9d3b5f2e5f99, (v) => $c0c659d1edeb697d$export$b12c9d3b5f2e5f99 = v);
$parcel$export(module.exports, "toolBarRight", () => $c0c659d1edeb697d$export$670ac6d0995075b, (v) => $c0c659d1edeb697d$export$670ac6d0995075b = v);
$parcel$export(module.exports, "viewSwitcherWrapper", () => $c0c659d1edeb697d$export$60fb14650e2a2f3a, (v) => $c0c659d1edeb697d$export$60fb14650e2a2f3a = v);
var $c0c659d1edeb697d$export$faed4863136ce212;
var $c0c659d1edeb697d$export$102b19bec5f1b880;
var $c0c659d1edeb697d$export$b2456e4507ac1eff;
var $c0c659d1edeb697d$export$3bb9594b148e59ee;
var $c0c659d1edeb697d$export$eabcd2c8791e7bf4;
var $c0c659d1edeb697d$export$febac0928185e9d4;
var $c0c659d1edeb697d$export$fb184b623420d9be;
var $c0c659d1edeb697d$export$ed2652bdb9ef1ad0;
var $c0c659d1edeb697d$export$f4bed195fe4c740c;
var $c0c659d1edeb697d$export$b12c9d3b5f2e5f99;
var $c0c659d1edeb697d$export$670ac6d0995075b;
var $c0c659d1edeb697d$export$60fb14650e2a2f3a;
$c0c659d1edeb697d$export$faed4863136ce212 = `tbjfXa_headerRow`;
$c0c659d1edeb697d$export$102b19bec5f1b880 = `tbjfXa_headerRowBacklogSeparator`;
$c0c659d1edeb697d$export$b2456e4507ac1eff = `tbjfXa_headerRowLeft`;
$c0c659d1edeb697d$export$3bb9594b148e59ee = `tbjfXa_headerRowSeparator`;
$c0c659d1edeb697d$export$eabcd2c8791e7bf4 = `tbjfXa_left`;
$c0c659d1edeb697d$export$febac0928185e9d4 = `tbjfXa_readOnlyPlanLozenge`;
$c0c659d1edeb697d$export$fb184b623420d9be = `tbjfXa_title`;
$c0c659d1edeb697d$export$ed2652bdb9ef1ad0 = `tbjfXa_toolBar`;
$c0c659d1edeb697d$export$f4bed195fe4c740c = `tbjfXa_toolBarButtonIcon`;
$c0c659d1edeb697d$export$b12c9d3b5f2e5f99 = `tbjfXa_toolBarFiltersSettingsContainer`;
$c0c659d1edeb697d$export$670ac6d0995075b = `tbjfXa_toolBarRight`;
$c0c659d1edeb697d$export$60fb14650e2a2f3a = `tbjfXa_viewSwitcherWrapper`;

});

parcelRegister("6EPGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $048f54fc70278515$export$2e2bcd8739ae039);

var $df4Sl = parcelRequire("df4Sl");

var $hLlYV = parcelRequire("hLlYV");

var $akhOi = parcelRequire("akhOi");

var $75KhQ = parcelRequire("75KhQ");

var $dhHiZ = parcelRequire("dhHiZ");

var $lNNXV = parcelRequire("lNNXV");
var $1TrR5 = parcelRequire("1TrR5");

var $9If9R = parcelRequire("9If9R");
const $048f54fc70278515$var$mapStateToProps = (state)=>({
        isMultiScenarioEnabled: (0, $75KhQ.isMultiScenarioEnabled)(state),
        jiraTitle: (0, $dhHiZ.getSystemInfo)(state).jiraTitle,
        planScenarios: (0, $75KhQ.getPlanScenarios)(state),
        value: (0, $75KhQ.getPlan)(state).title,
        mode: (0, $akhOi.getMode)(state)
    });
const $048f54fc70278515$var$getPlanScenariosMemoized = ()=>(0, $df4Sl.createSelector)((0, $75KhQ.getPlanScenarios), (res)=>res);
const $048f54fc70278515$var$mapStateToPropsFactory = ()=>{
    const getPlanScenariosInstance = $048f54fc70278515$var$getPlanScenariosMemoized();
    return (state)=>({
            isMultiScenarioEnabled: (0, $75KhQ.isMultiScenarioEnabled)(state),
            jiraTitle: (0, $dhHiZ.getSystemInfo)(state).jiraTitle,
            planScenarios: getPlanScenariosInstance(state),
            value: (0, $75KhQ.getPlan)(state).title,
            mode: (0, $akhOi.getMode)(state)
        });
};
const $048f54fc70278515$var$mapDispatchToProps = (dispatch)=>({
        onChange: (title)=>{
            dispatch((0, $hLlYV.updatePlan)({
                title: title
            }));
        }
    });
var $048f54fc70278515$export$2e2bcd8739ae039 = (0, $lNNXV.connect)(// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
(0, $1TrR5.functionWithFFRedux)($048f54fc70278515$var$mapStateToPropsFactory, $048f54fc70278515$var$mapStateToProps), $048f54fc70278515$var$mapDispatchToProps)((0, $9If9R.default));

});
parcelRegister("9If9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8a1d277d382a7c6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $2qhQi = parcelRequire("2qhQi");
parcelRequire("lIePH");
var $cf2Y4 = parcelRequire("cf2Y4");
var $eNhh9 = parcelRequire("eNhh9");
var $6GmrT = parcelRequire("6GmrT");
var $1WecH = parcelRequire("1WecH");
var $gwbfD = parcelRequire("gwbfD");
parcelRequire("akhOi");

var $7CnHa = parcelRequire("7CnHa");

var $686hF = parcelRequire("686hF");

var $gaTpJ = parcelRequire("gaTpJ");
// eslint-disable-next-line jira/react/no-class-components
class $b8a1d277d382a7c6$var$Title extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, isMultiScenarioEnabled: isMultiScenarioEnabled, isReadOnly: isReadOnly, mode: mode, planScenarios: planScenarios, value: value } = this.props;
        if (!(0, $7CnHa.isDefined)(value)) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gaTpJ.skeletonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WecH.default), {
            numOfRows: 1,
            topPadding: 2
        })));
        const hasScenarios = !(isMultiScenarioEnabled !== true || !(0, $7CnHa.isDefined)(planScenarios) || planScenarios.length < 1);
        const placeholder = intl.formatMessage((0, $686hF.default).placeholder);
        const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))($gaTpJ.planTitleContainer, {
            [$gaTpJ.withScenarios]: hasScenarios,
            [$gaTpJ.isReadOnly]: isReadOnly && mode !== (0, $99f9ac26081f8045$export$e3d31417f21c1ce7),
            [$gaTpJ.isReportMode]: mode === (0, $99f9ac26081f8045$export$e3d31417f21c1ce7)
        });
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: classNames,
            "aria-label": intl.formatMessage((0, $686hF.default).planTitle)
        }, isReadOnly === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
            content: value
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gaTpJ.planTitleReadOnly
        }, value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6GmrT.default), {
            defaultValue: value,
            editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNhh9.default), {
                    content: errorMessage,
                    isOpen: fieldProps.isInvalid,
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                    ...fieldProps,
                    testId: "portfolio-3-portfolio.app-simple-plans.top.title-bar.title.input",
                    autoFocus: true,
                    maxLength: 256,
                    placeholder: placeholder
                })),
            onConfirm: this.onChangeTitle,
            readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                    content: value || placeholder
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                    className: $gaTpJ.planTitleReadViewContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    className: $gaTpJ.planTitle
                }, value || placeholder))),
            // eslint-disable-next-line @typescript-eslint/no-shadow
            validate: (value)=>this.validateTitle(value)
        })));
    }
    constructor(...args){
        super(...args);
        this.onChangeTitle = (planTitle)=>{
            const trimmedTitle = planTitle.trim();
            const { jiraTitle: jiraTitle, onChange: onChange, intl: intl } = this.props;
            const productName = intl.formatMessage((0, $686hF.default).plans);
            document.title = `${trimmedTitle || intl.formatMessage((0, $686hF.default).placeholder)} - ${productName} - ${jiraTitle}`;
            onChange(trimmedTitle);
        };
        this.validateTitle = (title)=>{
            const trimmedTitle = title.trim();
            if (trimmedTitle.length <= 255) return;
            return this.props.intl.formatMessage((0, $686hF.default).tooLongInputErrorMessage);
        };
    }
}
var $b8a1d277d382a7c6$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b8a1d277d382a7c6$var$Title);

});
parcelRegister("686hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b5da7af563ecc5c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5b5da7af563ecc5c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.title.placeholder",
        "defaultMessage": "Untitled plan"
    },
    planTitle: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.title.plan-title",
        "defaultMessage": "Plan title"
    },
    tooLongInputErrorMessage: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.title.too-long-input-error-message",
        "defaultMessage": "Title cannot be longer than 255 characters"
    },
    plans: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.title-bar.title.plans",
        "defaultMessage": "Plans"
    }
});

});

parcelRegister("gaTpJ", function(module, exports) {

$parcel$export(module.exports, "isReadOnly", () => $bc68909bcb5ae425$export$2498094d90b6ac72, (v) => $bc68909bcb5ae425$export$2498094d90b6ac72 = v);
$parcel$export(module.exports, "isReportMode", () => $bc68909bcb5ae425$export$e8610bde98f41d48, (v) => $bc68909bcb5ae425$export$e8610bde98f41d48 = v);
$parcel$export(module.exports, "planTitle", () => $bc68909bcb5ae425$export$8b8baa6a4c19ac50, (v) => $bc68909bcb5ae425$export$8b8baa6a4c19ac50 = v);
$parcel$export(module.exports, "planTitleContainer", () => $bc68909bcb5ae425$export$ea31bb514faed2d8, (v) => $bc68909bcb5ae425$export$ea31bb514faed2d8 = v);
$parcel$export(module.exports, "planTitleReadOnly", () => $bc68909bcb5ae425$export$4a0c43b2e1dca86c, (v) => $bc68909bcb5ae425$export$4a0c43b2e1dca86c = v);
$parcel$export(module.exports, "planTitleReadViewContainer", () => $bc68909bcb5ae425$export$35cc9baf51fc0d9a, (v) => $bc68909bcb5ae425$export$35cc9baf51fc0d9a = v);
$parcel$export(module.exports, "skeletonContainer", () => $bc68909bcb5ae425$export$e39e8873928166f5, (v) => $bc68909bcb5ae425$export$e39e8873928166f5 = v);
$parcel$export(module.exports, "withScenarios", () => $bc68909bcb5ae425$export$b3564392b6dc402a, (v) => $bc68909bcb5ae425$export$b3564392b6dc402a = v);
var $bc68909bcb5ae425$export$2498094d90b6ac72;
var $bc68909bcb5ae425$export$e8610bde98f41d48;
var $bc68909bcb5ae425$export$8b8baa6a4c19ac50;
var $bc68909bcb5ae425$export$ea31bb514faed2d8;
var $bc68909bcb5ae425$export$4a0c43b2e1dca86c;
var $bc68909bcb5ae425$export$35cc9baf51fc0d9a;
var $bc68909bcb5ae425$export$e39e8873928166f5;
var $bc68909bcb5ae425$export$b3564392b6dc402a;
$bc68909bcb5ae425$export$2498094d90b6ac72 = `qwUGVG_isReadOnly`;
$bc68909bcb5ae425$export$e8610bde98f41d48 = `qwUGVG_isReportMode`;
$bc68909bcb5ae425$export$8b8baa6a4c19ac50 = `qwUGVG_planTitle`;
$bc68909bcb5ae425$export$ea31bb514faed2d8 = `qwUGVG_planTitleContainer`;
$bc68909bcb5ae425$export$4a0c43b2e1dca86c = `qwUGVG_planTitleReadOnly`;
$bc68909bcb5ae425$export$35cc9baf51fc0d9a = `qwUGVG_planTitleReadViewContainer`;
$bc68909bcb5ae425$export$e39e8873928166f5 = `qwUGVG_skeletonContainer`;
$bc68909bcb5ae425$export$b3564392b6dc402a = `qwUGVG_withScenarios`;

});






parcelRegister("75klB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac90a5ae08e567a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $bYMIg = parcelRequire("bYMIg");

var $lhEdY = parcelRequire("lhEdY");

var $fEVnb = parcelRequire("fEVnb");
var $8ac90a5ae08e567a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $lhEdY.default), (0, $bYMIg.default))((0, $fEVnb.default));

});
parcelRegister("bYMIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa4453f518bc6b3$export$2e2bcd8739ae039);

var $lUiqk = parcelRequire("lUiqk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffa4453f518bc6b3$export$2e2bcd8739ae039 = (dispatch)=>({
        setTwpBenefitsModalOpen: (isOpen)=>{
            dispatch((0, $lUiqk.setTwpBenefitsModalOpen)(isOpen));
        },
        setTwpBenefitsModalShown: (shown)=>{
            dispatch((0, $lUiqk.setTwpBenefitsModalShown)(shown));
        }
    });

});

parcelRegister("lhEdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $42939437afd59ada$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $cH2aU = parcelRequire("cH2aU");

var $iK4oF = parcelRequire("iK4oF");
var $42939437afd59ada$export$2e2bcd8739ae039 = (0, $iK4oF.createStructuredSelector)({
    isTwpBenefitsModalOpen: $cH2aU.isTwpBenefitsModalOpen,
    useTwpTeams: $75KhQ.useTwpTeams
});

});
parcelRegister("cH2aU", function(module, exports) {

$parcel$export(module.exports, "isTwpBenefitsModalOpen", () => $e02e9ed56e5fd4ef$export$25e281f5c0e9ff3f);
// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
const $e02e9ed56e5fd4ef$export$25e281f5c0e9ff3f = (state)=>state.ui.TwpBenefitsModal.isTwpBenefitsModalOpen;

});


parcelRegister("fEVnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $158b4bc858c68957$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $9exb1 = parcelRequire("9exb1");

var $ib5d3 = parcelRequire("ib5d3");

var $lFLge = parcelRequire("lFLge");

var $eNTZc = parcelRequire("eNTZc");

var $izfQg = parcelRequire("izfQg");
// eslint-disable-next-line jira/react/no-class-components
class $158b4bc858c68957$var$TwpBenefitsModal extends (0, $eUqFw.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, isTwpBenefitsModalOpen: isTwpBenefitsModalOpen, useTwpTeams: useTwpTeams = false } = this.props;
        if (useTwpTeams && isTwpBenefitsModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9exb1.default), {
            actions: this.getOnBoardingDialogActions(),
            heading: formatMessage((0, $izfQg.default).title),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($eNTZc)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $izfQg.default).plansContentSpork, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        this.getOnBoardingDialogActions = ()=>{
            const { intl: { formatMessage: formatMessage }, setTwpBenefitsModalOpen: setTwpBenefitsModalOpen, setTwpBenefitsModalShown: setTwpBenefitsModalShown } = this.props;
            const actions = [
                {
                    onClick: ()=>{
                        setTwpBenefitsModalShown(true);
                        setTwpBenefitsModalOpen(false);
                    },
                    text: formatMessage((0, $ib5d3.default).close)
                }
            ];
            // if LaunchDarkly is unavailable, the url will be an empty string
            // therefore we don't render the "Learn more" button since it would lead to nowhere
            const learnMoreUrl = 'https://community.atlassian.com/t5/Advanced-Roadmaps-articles/How-to-prepare-teams-with-no-members-for-migration/ba-p/2045801';
            actions.unshift({
                onClick: ()=>{
                    setTwpBenefitsModalShown(true);
                    (0, $lFLge.openInNewTab)(learnMoreUrl);
                },
                text: formatMessage((0, $ib5d3.default).learnMore)
            });
            return actions;
        };
    }
}
var $158b4bc858c68957$export$2e2bcd8739ae039 = (0, $2qhQi.default)($158b4bc858c68957$var$TwpBenefitsModal);

});
parcelRegister("9exb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8001437b12aad8a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bbaTG = parcelRequire("bbaTG");
var $Sibrq = parcelRequire("Sibrq");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $cMtFc = parcelRequire("cMtFc");

var $bzFJL = parcelRequire("bzFJL");

var $jPr84 = parcelRequire("jPr84");
class $8001437b12aad8a5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, ...props } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $cMtFc.useModal)();
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bzFJL.ModalHeading), {
                id: titleId
            }, heading);
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aOw1G.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            shouldCloseOnOverlayClick: false,
            shouldCloseOnEscapePress: false,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)(Header, null), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lfiOu.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bzFJL.ModalBody), null, heading && /*#__PURE__*/ (0, $byn9U.jsx)(CustomHeader, null), children)), /*#__PURE__*/ (0, $byn9U.jsx)(Footer, null));
    }
    constructor(...args){
        super(...args);
        this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $bzFJL.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        };
        this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $Sibrq.default).Provider, {
                    value: (0, $jPr84.modalButtonTheme)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bzFJL.ModalActionContainer), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                    const variant = idx ? 'subtle-link' : 'primary';
                    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $bzFJL.ModalActionItem), {
                        key: key || (typeof text === 'string' ? text : `${idx}`)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bbaTG.default), {
                        appearance: variant,
                        autoFocus: !idx,
                        ...rest
                    }, text));
                }))) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("bzFJL", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $28745bf125f76d3d$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $28745bf125f76d3d$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $28745bf125f76d3d$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $28745bf125f76d3d$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $28745bf125f76d3d$export$c245e9f76e3299b1);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
                                                               * @jsxRuntime classic
                                                               */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
function $28745bf125f76d3d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $28745bf125f76d3d$var$modalBodyStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-200, 16px)"}`,
    textAlign: 'center'
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
const $28745bf125f76d3d$var$modalHeadingStyles = /*#__PURE__*/ (0, $byn9U.css)([
    /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $4lTFP.h600)({
        theme: {
            mode: 'light'
        }
    })),
    {
        marginBottom: "var(--ds-space-100, 8px)",
        color: 'inherit'
    }
]);
const $28745bf125f76d3d$var$modalImageStyles = {
    name: "1e6i37z",
    styles: "width:100%;height:auto;border-start-end-radius:var(--ds-border-radius, 3px);border-start-start-radius:var(--ds-border-radius, 3px);@media (min-width: 320px) and (max-width: 480px){border-radius:0;}"
};
const $28745bf125f76d3d$var$modalActionContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
    justifyContent: 'center',
    flexDirection: 'row',
    flexFlow: 'wrap'
});
const $28745bf125f76d3d$var$modalActionContainerReversedStyles = {
    name: "2b8jyz",
    styles: "flex-direction:row-reverse"
};
const $28745bf125f76d3d$var$modalActionItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $28745bf125f76d3d$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $28745bf125f76d3d$var$modalBodyStyles
    }, children);
const $28745bf125f76d3d$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $28745bf125f76d3d$var$modalHeadingStyles,
        id: id
    }, children);
};
const $28745bf125f76d3d$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $byn9U.jsx)("img", {
        css: $28745bf125f76d3d$var$modalImageStyles,
        alt: alt,
        src: src
    });
const $28745bf125f76d3d$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $28745bf125f76d3d$var$modalActionContainerStyles,
            shouldReverseButtonOrder && $28745bf125f76d3d$var$modalActionContainerReversedStyles
        ]
    }, children);
const $28745bf125f76d3d$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $28745bf125f76d3d$var$modalActionItemStyles
    }, children);

});


parcelRegister("eNTZc", function(module, exports) {
module.exports = new URL("illustration.8549dce1.png", import.meta.url).toString();

});

parcelRegister("izfQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c4117980dc5630$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e6c4117980dc5630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-portfolio.app-simple-plans.twp-benefits-modal.title",
        "defaultMessage": "Your teams have moved!"
    },
    plansContentSpork: {
        "id": "portfolio-3-portfolio.app-simple-plans.twp-benefits-modal.plans-content-spork",
        "defaultMessage": "Your Shared teams in Plans are now available across all of Jira. To view and manage them, navigate to the <strong>People</strong> tab at the top of the screen."
    }
});

});







parcelRegister("7V92z", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("gQ3lB")).default);
/* eslint-disable @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766 */ parcelRequire("TGJRV");
parcelRequire("buD8w");
parcelRequire("hg9Bv");
parcelRequire("032zv");

var $gQ3lB = parcelRequire("gQ3lB");

});
parcelRegister("hg9Bv", function(module, exports) {

});

parcelRegister("gQ3lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66c6bc6ea86cf22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $iAoTX = parcelRequire("iAoTX");

var $5BRby = parcelRequire("5BRby");

var $aR8n6 = parcelRequire("aR8n6");

var $aOINP = parcelRequire("aOINP");
var $lcvrv = parcelRequire("lcvrv");

var $6Grzy = parcelRequire("6Grzy");

var $fcaZ5 = parcelRequire("fcaZ5");

var $296Gg = parcelRequire("296Gg");

var $kwMvv = parcelRequire("kwMvv");

var $4GVCJ = parcelRequire("4GVCJ");

var $9H2AP = parcelRequire("9H2AP");

var $gNoQI = parcelRequire("gNoQI");

var $hHEgb = parcelRequire("hHEgb");

var $lPYkK = parcelRequire("lPYkK");

var $1G4B0 = parcelRequire("1G4B0");

var $iVsy4 = parcelRequire("iVsy4");

var $3Ff32 = parcelRequire("3Ff32");

var $a4vO3 = parcelRequire("a4vO3");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");

var $8WuJm = parcelRequire("8WuJm");

var $lNNXV = parcelRequire("lNNXV");

var $5qPNi = parcelRequire("5qPNi");

var $h7GVo = parcelRequire("h7GVo");

var $4AUB1 = parcelRequire("4AUB1");

var $5pvzt = parcelRequire("5pvzt");
parcelRequire("9hoTw");
var $2eaAI = parcelRequire("2eaAI");

var $jyM6W = parcelRequire("jyM6W");

var $9Zwdm = parcelRequire("9Zwdm");

var $hzoH5 = parcelRequire("hzoH5");

var $gsN6Q = parcelRequire("gsN6Q");

var $76PbK = parcelRequire("76PbK");

var $gagRj = parcelRequire("gagRj");

var $kkUno = parcelRequire("kkUno");
const $f66c6bc6ea86cf22$var$mapStateToProps = (state)=>({
        appWidth: (0, $lFLge.getNonTimelineWidth)() + ((0, $9H2AP.getViewMode)(state) === (0, $lcvrv.VIEW_MODES).TIMELINE ? (0, $4GVCJ.getTimelineExportWidth)(state) : 0),
        numIssues: (0, $kwMvv.getFilteredIssues)(state).length
    });
const $f66c6bc6ea86cf22$var$mapDispatchToProps = (dispatch)=>({
        initialLoad: (config)=>{
            dispatch((0, $fcaZ5.initialLoad)(config));
        },
        setInitialFilterValues: ()=>dispatch((0, $296Gg.setInitialFilterValues)()),
        updateColumnWidths: (scopeWidth, fieldsWidth, timelineWidth, timelineExportWidth)=>{
            dispatch((0, $1G4B0.updateColumnWidths)({
                scope: scopeWidth,
                fields: fieldsWidth,
                timeline: timelineWidth,
                timelineExport: timelineExportWidth
            }));
        },
        updateTimelineDateRange: (timelineDateRange)=>{
            dispatch({
                type: (0, $hHEgb.CHANGE_MODE),
                payload: 'custom'
            });
            dispatch({
                type: (0, $hHEgb.CHANGE_OPTION),
                payload: 'custom'
            });
            dispatch((0, $hHEgb.timeScaleCustomDatesChange)(timelineDateRange));
        },
        setIsExportPreview: (isExportPreview)=>{
            dispatch((0, $gNoQI.setIsExportPreview)(isExportPreview));
        }
    });
const $f66c6bc6ea86cf22$var$Connected = (0, $lNNXV.connect)($f66c6bc6ea86cf22$var$mapStateToProps, $f66c6bc6ea86cf22$var$mapDispatchToProps)((0, $kkUno.default));
const $f66c6bc6ea86cf22$var$App = ({ locale: locale })=>{
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * We are adding this special class to 'jira-frontend' div to scope the react virtualized
		 * classes defined in src/app-export-view/styles.css. CSS styles for these classes can be found
		 * in many places and we are scoping them all.
		 * When we are in Jira SPA, we can not pollute the global classes and hence we are
		 * scoping them to ARJ application.
		 * We remove the special .arj-export-view class once our app is unmounted. Look into the returned function below.
		 */ const JfeRootElement = document.getElementById('jira-frontend');
        if (JfeRootElement) JfeRootElement.classList.add('arj-export-view');
        return function removeArjClass() {
            // Remove special .arj class from 'jira-frontend' div.
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const JfeRootElement = document.getElementById('jira-frontend');
            if (JfeRootElement) JfeRootElement.classList.remove('arj-export-view');
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        store: (0, $lPYkK.default),
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "portfolio3ExportView",
        attributes: {
            context: (0, $6Grzy.context).PLAN
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVsy4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: (0, $5rYNM.ERROR_REPORTING_PACKAGE).APP,
        packageName: (0, $5rYNM.PACKAGE_NAME),
        teamName: (0, $5rYNM.ERROR_REPORTING_TEAM),
        sendToPrivacyUnsafeSplunk: true
    }, document.body && /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ff32.default), null), document.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAoTX.PersistGate), {
        loading: null,
        persistor: (0, $lPYkK.persistor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f66c6bc6ea86cf22$var$Connected, {
        locale: locale
    })))))));
};
var $f66c6bc6ea86cf22$export$2e2bcd8739ae039 = (0, $a4vO3.provideComponents)({
    AdvancedFieldsMenu: $5qPNi.default,
    FieldSelect: $9Zwdm.default,
    FieldPrioritySelect: $jyM6W.default,
    FieldMultiSelectCell: $2eaAI.default,
    FieldDatePicker: $5pvzt.default,
    CellSelectWithRollup: $h7GVo.default,
    FieldUserAvatarCell: $hzoH5.default,
    CellTextField: $4AUB1.default,
    IssueSearchWarningClearFilter: $76PbK.default,
    NowLine: $gagRj.default,
    UserPicker: $gsN6Q.default
})($f66c6bc6ea86cf22$var$App);

});
parcelRegister("5qPNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1790a7433d27aa44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $ib5d3 = parcelRequire("ib5d3");

var $7M75X = parcelRequire("7M75X");
function $1790a7433d27aa44$var$AdvancedFieldsMenu() {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $7M75X.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ib5d3.default).fields)));
}
var $1790a7433d27aa44$export$2e2bcd8739ae039 = $1790a7433d27aa44$var$AdvancedFieldsMenu;

});
parcelRegister("7M75X", function(module, exports) {

$parcel$export(module.exports, "title", () => $5a928508bb44b678$export$fb184b623420d9be, (v) => $5a928508bb44b678$export$fb184b623420d9be = v);
var $5a928508bb44b678$export$fb184b623420d9be;
$5a928508bb44b678$export$fb184b623420d9be = `ruCJCG_title`;

});


parcelRegister("h7GVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a0a4658ec34ca64$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gnThp = parcelRequire("gnThp");

var $al6Nl = parcelRequire("al6Nl");
var $3a0a4658ec34ca64$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gnThp.default), {})((0, $al6Nl.default));

});
parcelRegister("gnThp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b309939f81fb23b9$export$2e2bcd8739ae039);

var $9H2AP = parcelRequire("9H2AP");
const $b309939f81fb23b9$var$mapStateToProps = (state)=>({
        showRolledUpOthers: (0, $9H2AP.getShowRolledUpOthers)(state)
    });
var $b309939f81fb23b9$export$2e2bcd8739ae039 = $b309939f81fb23b9$var$mapStateToProps;

});

parcelRegister("al6Nl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c586a289fe4b199$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");

var $cc2RB = parcelRequire("cc2RB");

var $jQEOv = parcelRequire("jQEOv");

var $8V0HQ = parcelRequire("8V0HQ");

var $bII9H = parcelRequire("bII9H");
const $8c586a289fe4b199$var$CellSelectWithRollup = ({ value: value, rolledUpValues: rolledUpValues, showRolledUpOthers: showRolledUpOthers })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getValue = ()=>{
        const text = Array.isArray(value) ? value.map((v)=>v.label || '').join(', ') : value?.label || '';
        if (!text) return null;
        if (!Array.isArray(value)) {
            if (value?.isExternalTeam === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $bII9H.textWithLozenge
            }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $cc2RB.default).externalLozengeShort)));
            if (value?.isPlanOnlyTeam === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $bII9H.textWithLozenge
            }, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, formatMessage((0, $cc2RB.default).planOnlyLozenge)));
        }
        return text;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQEOv.default), {
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8V0HQ.default), {
            showRollup: showRolledUpOthers && (rolledUpValues || []).length > 0,
            isDisabled: false,
            rolledUpValues: rolledUpValues,
            withValue: !!getValue(),
            readonly: true
        }, getValue())
    });
};
var $8c586a289fe4b199$export$2e2bcd8739ae039 = $8c586a289fe4b199$var$CellSelectWithRollup;

});
parcelRegister("jQEOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $991c5011ee8d97ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hjlb6 = parcelRequire("hjlb6");

var $7CnHa = parcelRequire("7CnHa");

var $k51iV = parcelRequire("k51iV");
const $991c5011ee8d97ac$var$GenericReadonlyCell = ({ text: text, italic: italic = false, align: align = 'left', iconBefore: iconBefore })=>{
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))({
        [$k51iV.root]: true,
        [$k51iV.alignRight]: align === 'right',
        italic: italic
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: rootClassNames
    }, (0, $7CnHa.isDefined)(iconBefore) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k51iV.iconBefore
    }, iconBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $k51iV.text
    }, text)));
};
var $991c5011ee8d97ac$export$2e2bcd8739ae039 = $991c5011ee8d97ac$var$GenericReadonlyCell;

});
parcelRegister("k51iV", function(module, exports) {

$parcel$export(module.exports, "alignRight", () => $e9e549444393631b$export$faf8793e4a37a5a2, (v) => $e9e549444393631b$export$faf8793e4a37a5a2 = v);
$parcel$export(module.exports, "iconBefore", () => $e9e549444393631b$export$b8382a68a7e5d6cc, (v) => $e9e549444393631b$export$b8382a68a7e5d6cc = v);
$parcel$export(module.exports, "root", () => $e9e549444393631b$export$e8e78c978b129247, (v) => $e9e549444393631b$export$e8e78c978b129247 = v);
$parcel$export(module.exports, "text", () => $e9e549444393631b$export$6f093cfa640b7166, (v) => $e9e549444393631b$export$6f093cfa640b7166 = v);
var $e9e549444393631b$export$faf8793e4a37a5a2;
var $e9e549444393631b$export$b8382a68a7e5d6cc;
var $e9e549444393631b$export$5540da1282cbf565;
var $e9e549444393631b$export$e8e78c978b129247;
var $e9e549444393631b$export$6f093cfa640b7166;
$e9e549444393631b$export$faf8793e4a37a5a2 = `jV-Hrq_alignRight`;
$e9e549444393631b$export$b8382a68a7e5d6cc = `jV-Hrq_iconBefore`;
$e9e549444393631b$export$5540da1282cbf565 = `jV-Hrq_italic`;
$e9e549444393631b$export$e8e78c978b129247 = `jV-Hrq_root`;
$e9e549444393631b$export$6f093cfa640b7166 = `jV-Hrq_text`;

});


parcelRegister("bII9H", function(module, exports) {

$parcel$export(module.exports, "textWithLozenge", () => $88860e212a06a81c$export$276572ba60525a68, (v) => $88860e212a06a81c$export$276572ba60525a68 = v);
var $88860e212a06a81c$export$276572ba60525a68;
$88860e212a06a81c$export$276572ba60525a68 = `_2WPfcW_textWithLozenge`;

});



parcelRegister("4AUB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e34c7ae90f390d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jQEOv = parcelRequire("jQEOv");
const $a5e34c7ae90f390d$var$ReadonlyCellTextfield = ({ value: value, isAlignRight: isAlignRight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQEOv.default), {
        align: isAlignRight === true ? 'right' : 'left',
        text: value
    });
var $a5e34c7ae90f390d$export$2e2bcd8739ae039 = $a5e34c7ae90f390d$var$ReadonlyCellTextfield;

});

parcelRegister("5pvzt", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ea153a1c934211$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2Sj2 = parcelRequire("l2Sj2");

var $jQEOv = parcelRequire("jQEOv");

var $7CnHa = parcelRequire("7CnHa");
function $54ea153a1c934211$export$2e2bcd8739ae039({ value: value }) {
    const { formatDate: formatDate } = (0, $l2Sj2.useDateFormatter)();
    // If the date is a rollup date, sprint or release inferred dates,
    // it's taken care of by renderInferredDate in src/packages/portfolio-3/portfoli o/src/app-simple-plans/view/main/tabs/roadmap/fields/columns/cells/date/view.js
    const date = (0, $7CnHa.isDefined)(value) && value !== '' ? formatDate(value) : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQEOv.default), {
        text: date
    });
}

});

parcelRegister("9hoTw", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("2eaAI")).default);
// eslint-disable-next-line jira/export/no-external-exports

var $2eaAI = parcelRequire("2eaAI");

});

parcelRegister("jyM6W", function(module, exports) {

$parcel$export(module.exports, "default", () => $a81fd54dc2bcc458$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7CnHa = parcelRequire("7CnHa");

var $jQEOv = parcelRequire("jQEOv");
function $a81fd54dc2bcc458$export$2e2bcd8739ae039({ value: value }) {
    const item = Array.isArray(value) ? value[0] : value;
    const text = (0, $7CnHa.isDefined)(item) && (0, $7CnHa.isDefined)(item.label) ? item.label : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQEOv.default), {
        text: text
    });
}

});

parcelRegister("9Zwdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f0981ae208f329$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7CnHa = parcelRequire("7CnHa");

var $jQEOv = parcelRequire("jQEOv");

var $kLzMv = parcelRequire("kLzMv");
function $43f0981ae208f329$export$2e2bcd8739ae039({ value: value }) {
    const item = Array.isArray(value) ? value[0] : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQEOv.default), {
        text: (0, $7CnHa.isDefined)(item) && (0, $7CnHa.isDefined)(item.label) ? item.label : '',
        iconBefore: (0, $7CnHa.isDefined)(item) && (0, $7CnHa.isDefined)(item.icon) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            alt: "",
            className: $kLzMv.readOnlyCellIcon,
            src: item.icon
        }) : undefined
    });
}

});
parcelRegister("kLzMv", function(module, exports) {

$parcel$export(module.exports, "readOnlyCellIcon", () => $f1e3f3d97ccc6411$export$39613a9d2a517b94, (v) => $f1e3f3d97ccc6411$export$39613a9d2a517b94 = v);
var $f1e3f3d97ccc6411$export$39613a9d2a517b94;
$f1e3f3d97ccc6411$export$39613a9d2a517b94 = `EVr9xW_readOnlyCellIcon`;

});


parcelRegister("hzoH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5500b7551a8a7c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $qmwZb = parcelRequire("qmwZb");

var $7CnHa = parcelRequire("7CnHa");

var $9ZPBJ = parcelRequire("9ZPBJ");
function $cc5500b7551a8a7c$export$2e2bcd8739ae039({ title: title }) {
    if (!(0, $7CnHa.isDefined)(title)) return null;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9ZPBJ.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9ZPBJ.avatarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qmwZb.default), {
        size: 18,
        name: title
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $9ZPBJ.nameContainer
    }, title)));
}

});
parcelRegister("9ZPBJ", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $7471d7c63d3f6ea3$export$4ea799498ef4a755, (v) => $7471d7c63d3f6ea3$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "container", () => $7471d7c63d3f6ea3$export$34e0f9847d4c02dd, (v) => $7471d7c63d3f6ea3$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "nameContainer", () => $7471d7c63d3f6ea3$export$3b9d909fcd39d8ae, (v) => $7471d7c63d3f6ea3$export$3b9d909fcd39d8ae = v);
var $7471d7c63d3f6ea3$export$4ea799498ef4a755;
var $7471d7c63d3f6ea3$export$34e0f9847d4c02dd;
var $7471d7c63d3f6ea3$export$3b9d909fcd39d8ae;
$7471d7c63d3f6ea3$export$4ea799498ef4a755 = `SR2byq_avatarContainer`;
$7471d7c63d3f6ea3$export$34e0f9847d4c02dd = `SR2byq_container`;
$7471d7c63d3f6ea3$export$3b9d909fcd39d8ae = `SR2byq_nameContainer`;

});


parcelRegister("gsN6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ce026ef56877c2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $qmwZb = parcelRequire("qmwZb");

var $7CnHa = parcelRequire("7CnHa");

var $cQtqz = parcelRequire("cQtqz");
function $09ce026ef56877c2$export$2e2bcd8739ae039({ user: user }) {
    if (!(0, $7CnHa.isDefined)(user) || user.value === 'unassigned' || !user.label) return null;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cQtqz.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cQtqz.avatarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qmwZb.default), {
        size: 18,
        name: user.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cQtqz.nameContainer
    }, user.label)));
}

});
parcelRegister("cQtqz", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $95a12b15a16b440f$export$4ea799498ef4a755, (v) => $95a12b15a16b440f$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "container", () => $95a12b15a16b440f$export$34e0f9847d4c02dd, (v) => $95a12b15a16b440f$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "nameContainer", () => $95a12b15a16b440f$export$3b9d909fcd39d8ae, (v) => $95a12b15a16b440f$export$3b9d909fcd39d8ae = v);
var $95a12b15a16b440f$export$4ea799498ef4a755;
var $95a12b15a16b440f$export$34e0f9847d4c02dd;
var $95a12b15a16b440f$export$3b9d909fcd39d8ae;
$95a12b15a16b440f$export$4ea799498ef4a755 = `NYx5hW_avatarContainer`;
$95a12b15a16b440f$export$34e0f9847d4c02dd = `NYx5hW_container`;
$95a12b15a16b440f$export$3b9d909fcd39d8ae = `NYx5hW_nameContainer`;

});


parcelRegister("76PbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4bbf2fcc4ca7a1$export$2e2bcd8739ae039);
function $fc4bbf2fcc4ca7a1$export$2e2bcd8739ae039() {
    return null;
}

});

parcelRegister("gagRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $add85c6ba0df9353$export$2e2bcd8739ae039);
function $add85c6ba0df9353$export$2e2bcd8739ae039() {
    return null;
}

});

parcelRegister("kkUno", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda240255a8c80e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j34h8 = parcelRequire("j34h8");

var $eTbtL = parcelRequire("eTbtL");

var $7jIPT = parcelRequire("7jIPT");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");

var $lFLge = parcelRequire("lFLge");

var $2yi9h = parcelRequire("2yi9h");

var $h7dEr = parcelRequire("h7dEr");

var $e3jLW = parcelRequire("e3jLW");
class $bda240255a8c80e9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.hasDoneInitialLoad = false;
        this.hasSentInitialLoadWithIssuesProfile = false;
        // the full list of props is available here: https://html2canvas.hertzen.com/configuration
        // (you might need to upgrade to the latest version to use some props)
        this.html2CanvasConfig = {
            allowTaint: true,
            useCORS: true,
            taintTest: false,
            scale: 1,
            logging: false
        };
        // eslint-disable-next-line react/sort-comp
        this.state = {
            timelineDateRange: undefined
        };
        // Send a profiling event to the iframe parent
        // The parent will call `monitor.startProfile` or `monitor.finishProfile` and they'll
        // automatically be recorded against the running task (initialPreview|subsequentPreview|export)
        this.sendProfileEvent = (profileAction, profileKey)=>{
            window.parent?.postMessage({
                type: 'profile',
                payload: {
                    profileAction: profileAction,
                    profileKey: profileKey
                }
            }, '*');
        };
        this.messageHandler = async (event)=>{
            if (event.origin !== window.location.origin) return;
            const postExportedImage = async (eventType = 'exportedImage')=>{
                if (this.props.numIssues > 0) // requestAnimationFrame ensures the browser has finished painting before we do the export
                // https://stackoverflow.com/a/69529699
                requestAnimationFrame(()=>{
                    setTimeout(async ()=>{
                        const imageData = await this.exportView();
                        event.source.postMessage({
                            type: eventType,
                            payload: {
                                image: imageData
                            }
                        }, event.origin);
                    }, 1);
                });
            };
            switch(event.data.type){
                case 'getExportedImage':
                    postExportedImage();
                    break;
                case 'updateTimelineWidth':
                    {
                        const { fieldsWidth: fieldsWidth, scopeWidth: scopeWidth, timelineExport: timelineExport } = event.data.payload;
                        this.props.updateColumnWidths(scopeWidth, fieldsWidth, 0, timelineExport);
                        if ((0, $lFLge.isExportPreview)()) postExportedImage();
                        break;
                    }
                case 'updateTimelineDateRange':
                    {
                        const { timelineDateRange: timelineDateRange } = event.data.payload;
                        this.setState({
                            timelineDateRange: timelineDateRange
                        });
                        this.props.updateTimelineDateRange(timelineDateRange);
                        if ((0, $lFLge.isExportPreview)()) postExportedImage();
                        else // For some reason, handleOnloadComponent is not called when timeline date range is updated
                        // So, here we need to send message to the png-export that the download mode is ready
                        requestAnimationFrame(()=>{
                            setTimeout(()=>{
                                window.parent.postMessage({
                                    type: 'downloadModeReady'
                                }, '*');
                            }, 1);
                        });
                        break;
                    }
                case 'downloadImage':
                    if (!(0, $lFLge.isExportPreview)()) postExportedImage('fullExportedImage');
                    break;
                default:
                    break;
            }
        };
        this.handleOnloadComponent = async ()=>{
            if (this.props.numIssues > 0 && !this.hasDoneInitialLoad) {
                this.hasDoneInitialLoad = true;
                if (this.isExportTestMode) this.showPreviewBelow();
                // Only initialise timeline range on the first load of export view, ie. when timelineDateRange is undefined
                if (!(0, $7CnHa.isDefined)(this.state.timelineDateRange)) {
                    const { fromDate: fromDate, toDate: toDate } = (0, $lFLge.getExportTimelineDateRange)();
                    const initialTimelineDateRange = (0, $7CnHa.isDefined)(fromDate) && (0, $7CnHa.isDefined)(toDate) ? {
                        fromDate: fromDate,
                        toDate: toDate,
                        typeOfCustomDateRange: (0, $eTbtL.CUSTOM_TIME_RANGE_TYPES).FIXED
                    } : (0, $7jIPT.getInitialExportDateRange)();
                    this.setState({
                        timelineDateRange: initialTimelineDateRange
                    });
                    this.props.updateTimelineDateRange(initialTimelineDateRange);
                }
                // calling setTimeout here to make sure exportView is run after the updateTimelineDateRange,
                // otherwise the timeline header is not rendered correctly
                if ((0, $lFLge.isExportPreview)()) requestAnimationFrame(()=>{
                    setTimeout(async ()=>{
                        const imageData = await this.exportView();
                        window.parent.postMessage({
                            type: 'initialExportedImage',
                            payload: {
                                image: imageData
                            }
                        }, '*');
                    }, 1);
                });
            }
            if (!(0, $lFLge.isExportPreview)()) window.parent.postMessage({
                type: 'downloadModeReady'
            }, '*');
        };
        this.getExportViewNode = ()=>document.querySelector('.arj-export-view') || document.body;
        this.exportView = async ()=>{
            this.sendProfileEvent('start', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.PREPARE_FOR_EXPORT);
            (0, $e3jLW.preparePlanForExport)();
            this.sendProfileEvent('finish', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.PREPARE_FOR_EXPORT);
            this.sendProfileEvent('start', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.CANVAS_RENDER);
            let data;
            const exportView = this.getExportViewNode();
            if (exportView && exportView.scrollHeight > 10000) data = await this.convertToCanvasOnLargePlan();
            else data = await this.convertToCanvas();
            this.sendProfileEvent('finish', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.CANVAS_RENDER);
            return data;
        };
        this.convertToCanvas = async ()=>{
            const exportView = this.getExportViewNode();
            const config = {
                ...this.html2CanvasConfig,
                windowWidth: this.props.appWidth,
                windowHeight: exportView?.scrollHeight
            };
            const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($j34h8)))(exportView, config);
            return canvas.toDataURL();
        };
        this.convertToCanvasOnLargePlan = async ()=>{
            const exportView = this.getExportViewNode();
            const canvasWidth = this.props.appWidth;
            const canvas2Height = exportView ? Math.round(exportView.scrollHeight) : 0;
            const canvas1Height = canvas2Height / 2;
            const canvas1Config = {
                ...this.html2CanvasConfig,
                windowWidth: canvasWidth,
                windowHeight: canvas1Height,
                height: canvas1Height
            };
            const canvas2Config = {
                ...this.html2CanvasConfig,
                windowWidth: canvasWidth,
                windowHeight: canvas2Height,
                y: canvas1Height,
                height: canvas2Height - canvas1Height
            };
            const [canvas1, canvas2] = await Promise.all([
                (0, (/*@__PURE__*/$parcel$interopDefault($j34h8)))(exportView, canvas1Config),
                (0, (/*@__PURE__*/$parcel$interopDefault($j34h8)))(exportView, canvas2Config)
            ]);
            const canvas = document.createElement('canvas');
            canvas.setAttribute('width', canvasWidth.toString());
            canvas.setAttribute('height', canvas2Height.toString());
            const ctx = canvas.getContext('2d');
            ctx?.drawImage(canvas1, 0, 0);
            ctx?.drawImage(canvas2, 0, canvas1Height);
            return canvas.toDataURL();
        };
        // Show the exported image directly underneath the plan with an "Update" button to re-export
        this.isExportTestMode = window?.location.href.indexOf('exportTestMode=1') >= 0;
        // Replace the document body content with the export once it's done (used for storybook VR test)
        this.replaceWithExport = window?.location.href.indexOf('replaceWithExport=1') >= 0;
    }
    componentDidMount() {
        this.props.initialLoad({
            locale: this.props.locale
        });
        this.props.setInitialFilterValues();
        // Make sure you can scroll around the export view
        this.originalOverflowX = window.document.body.style.overflowX;
        this.originalOverflowY = window.document.body.style.overflowY;
        window.document.body.style.setProperty('overflow-y', 'auto', 'important');
        window.document.body.style.setProperty('overflow-x', 'auto', 'important');
        // @ts-expect-error - TS2769 - No overload matches this call.
        window.addEventListener('message', this.messageHandler);
        // In test mode we do some crude dom stuff to show the image below the plan
        if (this.isExportTestMode && !this.replaceWithExport) {
            const btn = window.document.createElement('button');
            btn.onclick = ()=>{
                const el = window.document.getElementById('export-preview');
                if (el) el.innerHTML = '';
                this.showPreviewBelow();
            };
            btn.innerHTML = 'Update';
            window.document.body.appendChild(btn);
            const div = window.document.createElement('div');
            div.id = 'export-preview';
            window.document.body.appendChild(div);
        }
    }
    componentDidUpdate() {
        if (this.props.numIssues > 0) this.sendProfileEvent('finish', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.REACT_RENDER);
    }
    // Only used in test mode
    showPreviewBelow() {
        requestAnimationFrame(()=>{
            setTimeout(()=>{
                this.exportView().then((dataUrl)=>{
                    const container = this.replaceWithExport ? window.document.querySelector('.arj-export-view') : window.document.getElementById('export-preview');
                    const img = new Image();
                    img.src = dataUrl;
                    img.setAttribute('data-testid', 'portfolio-3-portfolio.app-export-view.view.main.export-image');
                    if (container) {
                        container.innerHTML = '';
                        container.appendChild(img);
                    }
                });
            // delay the exportView after the initial load to make sure all the issues has been loaded.
            }, 3000);
        });
    }
    componentWillUnmount() {
        // Remove the inline styles
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        window.document.body.style.overflowX = this.originalOverflowX;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        window.document.body.style.overflowY = this.originalOverflowY;
        // @ts-expect-error - TS2769 - No overload matches this call.
        window.removeEventListener('message', this.messageHandler);
    }
    render() {
        if (this.props.numIssues > 0) {
            // This is our best approximation at timing the initial load (before the first render that includes issues)
            if (!this.hasSentInitialLoadWithIssuesProfile) {
                this.sendProfileEvent('finish', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.INITIAL_LOAD);
                this.hasSentInitialLoadWithIssuesProfile = true;
            }
            this.sendProfileEvent('start', (0, $5rYNM.PROFILE_KEYS).EXPORT_PNG.REACT_RENDER);
        }
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $h7dEr.app,
            "data-name": "ManualPlans"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2yi9h.default), {
            onLoadComplete: this.handleOnloadComponent,
            appWidth: this.props.appWidth
        })));
    }
}

});
parcelRegister("j34h8", function(module, exports) {
'use strict';
var $dde19d25b54a6854$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $lCz2k = parcelRequire("lCz2k");
var $dde19d25b54a6854$var$_CanvasRenderer2 = $dde19d25b54a6854$var$_interopRequireDefault($lCz2k);

var $Q1JwR = parcelRequire("Q1JwR");
var $dde19d25b54a6854$var$_Logger2 = $dde19d25b54a6854$var$_interopRequireDefault($Q1JwR);

var $idLSz = parcelRequire("idLSz");
function $dde19d25b54a6854$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dde19d25b54a6854$var$html2canvas = function html2canvas(element, conf) {
    var config = conf || {};
    var logger = new $dde19d25b54a6854$var$_Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
    logger.log("html2canvas $npm_package_version");
    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) return Promise.reject('Provided element is not within a Document');
    var defaultView = ownerDocument.defaultView;
    var defaultOptions = {
        async: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        imageTimeout: 15000,
        logging: true,
        proxy: null,
        removeContainer: true,
        foreignObjectRendering: false,
        scale: defaultView.devicePixelRatio || 1,
        target: new $dde19d25b54a6854$var$_CanvasRenderer2.default(config.canvas),
        useCORS: false,
        windowWidth: defaultView.innerWidth,
        windowHeight: defaultView.innerHeight,
        scrollX: defaultView.pageXOffset,
        scrollY: defaultView.pageYOffset
    };
    var result = (0, $idLSz.renderElement)(element, $dde19d25b54a6854$var$_extends({}, defaultOptions, config), logger);
    return result;
};
$dde19d25b54a6854$var$html2canvas.CanvasRenderer = $dde19d25b54a6854$var$_CanvasRenderer2.default;
module.exports = $dde19d25b54a6854$var$html2canvas;

});
parcelRegister("lCz2k", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fbd8531cc9f973ae$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kRg2K = parcelRequire("kRg2K");

var $dPsAk = parcelRequire("dPsAk");
function $fbd8531cc9f973ae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $fbd8531cc9f973ae$var$addColorStops = function addColorStops(gradient, canvasGradient) {
    var maxStop = Math.max.apply(null, gradient.colorStops.map(function(colorStop) {
        return colorStop.stop;
    }));
    var f = 1 / Math.max(1, maxStop);
    gradient.colorStops.forEach(function(colorStop) {
        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
    });
};
var $fbd8531cc9f973ae$var$CanvasRenderer = function() {
    function CanvasRenderer(canvas) {
        $fbd8531cc9f973ae$var$_classCallCheck(this, CanvasRenderer);
        this.canvas = canvas ? canvas : document.createElement('canvas');
    }
    $fbd8531cc9f973ae$var$_createClass(CanvasRenderer, [
        {
            key: 'render',
            value: function render(options) {
                this.ctx = this.canvas.getContext('2d');
                this.options = options;
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + 'px';
                this.canvas.style.height = options.height + 'px';
                this.ctx.scale(this.options.scale, this.options.scale);
                this.ctx.translate(-options.x, -options.y);
                this.ctx.textBaseline = 'bottom';
                options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
            }
        },
        {
            key: 'clip',
            value: function clip(clipPaths, callback) {
                var _this = this;
                if (clipPaths.length) {
                    this.ctx.save();
                    clipPaths.forEach(function(path) {
                        _this.path(path);
                        _this.ctx.clip();
                    });
                }
                callback();
                if (clipPaths.length) this.ctx.restore();
            }
        },
        {
            key: 'drawImage',
            value: function drawImage(image, source, destination) {
                this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
            }
        },
        {
            key: 'drawShape',
            value: function drawShape(path, color) {
                this.path(path);
                this.ctx.fillStyle = color.toString();
                this.ctx.fill();
            }
        },
        {
            key: 'fill',
            value: function fill(color) {
                this.ctx.fillStyle = color.toString();
                this.ctx.fill();
            }
        },
        {
            key: 'getTarget',
            value: function getTarget() {
                this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
                return Promise.resolve(this.canvas);
            }
        },
        {
            key: 'path',
            value: function path(_path) {
                var _this2 = this;
                this.ctx.beginPath();
                if (Array.isArray(_path)) _path.forEach(function(point, index) {
                    var start = point.type === $kRg2K.PATH.VECTOR ? point : point.start;
                    if (index === 0) _this2.ctx.moveTo(start.x, start.y);
                    else _this2.ctx.lineTo(start.x, start.y);
                    if (point.type === $kRg2K.PATH.BEZIER_CURVE) _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                });
                else this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
                this.ctx.closePath();
            }
        },
        {
            key: 'rectangle',
            value: function rectangle(x, y, width, height, color) {
                this.ctx.fillStyle = color.toString();
                this.ctx.fillRect(x, y, width, height);
            }
        },
        {
            key: 'renderLinearGradient',
            value: function renderLinearGradient(bounds, gradient) {
                var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);
                $fbd8531cc9f973ae$var$addColorStops(gradient, linearGradient);
                this.ctx.fillStyle = linearGradient;
                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
        },
        {
            key: 'renderRadialGradient',
            value: function renderRadialGradient(bounds, gradient) {
                var _this3 = this;
                var x = bounds.left + gradient.center.x;
                var y = bounds.top + gradient.center.y;
                var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
                if (!radialGradient) return;
                $fbd8531cc9f973ae$var$addColorStops(gradient, radialGradient);
                this.ctx.fillStyle = radialGradient;
                if (gradient.radius.x !== gradient.radius.y) {
                    // transforms for elliptical radial gradient
                    var midX = bounds.left + 0.5 * bounds.width;
                    var midY = bounds.top + 0.5 * bounds.height;
                    var f = gradient.radius.y / gradient.radius.x;
                    var invF = 1 / f;
                    this.transform(midX, midY, [
                        1,
                        0,
                        0,
                        f,
                        0,
                        0
                    ], function() {
                        return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
                    });
                } else this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
        },
        {
            key: 'renderRepeat',
            value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
                this.path(path);
                this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
                this.ctx.translate(offsetX, offsetY);
                this.ctx.fill();
                this.ctx.translate(-offsetX, -offsetY);
            }
        },
        {
            key: 'renderTextNode',
            value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
                var _this4 = this;
                this.ctx.font = [
                    font.fontStyle,
                    font.fontVariant,
                    font.fontWeight,
                    font.fontSize,
                    font.fontFamily
                ].join(' ');
                textBounds.forEach(function(text) {
                    _this4.ctx.fillStyle = color.toString();
                    if (textShadows && text.text.trim().length) textShadows.slice(0).reverse().forEach(function(textShadow) {
                        _this4.ctx.shadowColor = textShadow.color.toString();
                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
                        _this4.ctx.shadowBlur = textShadow.blur;
                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                    });
                    else _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                    if (textDecoration !== null) {
                        var textDecorationColor = textDecoration.textDecorationColor || color;
                        textDecoration.textDecorationLine.forEach(function(textDecorationLine) {
                            switch(textDecorationLine){
                                case $dPsAk.TEXT_DECORATION_LINE.UNDERLINE:
                                    // Draws a line at the baseline of the font
                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                    // need to take that into account both in position and size
                                    var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font), baseline = _options$fontMetrics$.baseline;
                                    _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
                                    break;
                                case $dPsAk.TEXT_DECORATION_LINE.OVERLINE:
                                    _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
                                    break;
                                case $dPsAk.TEXT_DECORATION_LINE.LINE_THROUGH:
                                    // TODO try and find exact position for line-through
                                    var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font), middle = _options$fontMetrics$2.middle;
                                    _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
                                    break;
                            }
                        });
                    }
                });
            }
        },
        {
            key: 'resizeImage',
            value: function resizeImage(image, size) {
                if (image.width === size.width && image.height === size.height) return image;
                var canvas = this.canvas.ownerDocument.createElement('canvas');
                canvas.width = size.width;
                canvas.height = size.height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
                return canvas;
            }
        },
        {
            key: 'setOpacity',
            value: function setOpacity(opacity) {
                this.ctx.globalAlpha = opacity;
            }
        },
        {
            key: 'transform',
            value: function transform(offsetX, offsetY, matrix, callback) {
                this.ctx.save();
                this.ctx.translate(offsetX, offsetY);
                this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                this.ctx.translate(-offsetX, -offsetY);
                callback();
                this.ctx.restore();
            }
        }
    ]);
    return CanvasRenderer;
}();
module.exports.default = $fbd8531cc9f973ae$var$CanvasRenderer;

});
parcelRegister("kRg2K", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f2f533c17308f84b$var$PATH = module.exports.PATH = {
    VECTOR: 0,
    BEZIER_CURVE: 1,
    CIRCLE: 2
};

});

parcelRegister("dPsAk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTextDecoration = module.exports.TEXT_DECORATION_LINE = module.exports.TEXT_DECORATION = module.exports.TEXT_DECORATION_STYLE = undefined;

var $gO3cU = parcelRequire("gO3cU");
var $a116362e3e3736ce$var$_Color2 = $a116362e3e3736ce$var$_interopRequireDefault($gO3cU);
function $a116362e3e3736ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a116362e3e3736ce$var$TEXT_DECORATION_STYLE = module.exports.TEXT_DECORATION_STYLE = {
    SOLID: 0,
    DOUBLE: 1,
    DOTTED: 2,
    DASHED: 3,
    WAVY: 4
};
var $a116362e3e3736ce$var$TEXT_DECORATION = module.exports.TEXT_DECORATION = {
    NONE: null
};
var $a116362e3e3736ce$var$TEXT_DECORATION_LINE = module.exports.TEXT_DECORATION_LINE = {
    UNDERLINE: 1,
    OVERLINE: 2,
    LINE_THROUGH: 3,
    BLINK: 4
};
var $a116362e3e3736ce$var$parseLine = function parseLine(line) {
    switch(line){
        case 'underline':
            return $a116362e3e3736ce$var$TEXT_DECORATION_LINE.UNDERLINE;
        case 'overline':
            return $a116362e3e3736ce$var$TEXT_DECORATION_LINE.OVERLINE;
        case 'line-through':
            return $a116362e3e3736ce$var$TEXT_DECORATION_LINE.LINE_THROUGH;
    }
    return $a116362e3e3736ce$var$TEXT_DECORATION_LINE.BLINK;
};
var $a116362e3e3736ce$var$parseTextDecorationLine = function parseTextDecorationLine(line) {
    if (line === 'none') return null;
    return line.split(' ').map($a116362e3e3736ce$var$parseLine);
};
var $a116362e3e3736ce$var$parseTextDecorationStyle = function parseTextDecorationStyle(style) {
    switch(style){
        case 'double':
            return $a116362e3e3736ce$var$TEXT_DECORATION_STYLE.DOUBLE;
        case 'dotted':
            return $a116362e3e3736ce$var$TEXT_DECORATION_STYLE.DOTTED;
        case 'dashed':
            return $a116362e3e3736ce$var$TEXT_DECORATION_STYLE.DASHED;
        case 'wavy':
            return $a116362e3e3736ce$var$TEXT_DECORATION_STYLE.WAVY;
    }
    return $a116362e3e3736ce$var$TEXT_DECORATION_STYLE.SOLID;
};
var $a116362e3e3736ce$var$parseTextDecoration = module.exports.parseTextDecoration = function parseTextDecoration(style) {
    var textDecorationLine = $a116362e3e3736ce$var$parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
    if (textDecorationLine === null) return $a116362e3e3736ce$var$TEXT_DECORATION.NONE;
    var textDecorationColor = style.textDecorationColor ? new $a116362e3e3736ce$var$_Color2.default(style.textDecorationColor) : null;
    var textDecorationStyle = $a116362e3e3736ce$var$parseTextDecorationStyle(style.textDecorationStyle);
    return {
        textDecorationLine: textDecorationLine,
        textDecorationColor: textDecorationColor,
        textDecorationStyle: textDecorationStyle
    };
};

});
parcelRegister("gO3cU", function(module, exports) {
'use strict';
// http://dev.w3.org/csswg/css-color/
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c3c3cdbe655981fa$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $c3c3cdbe655981fa$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $c3c3cdbe655981fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $c3c3cdbe655981fa$var$HEX3 = /^#([a-f0-9]{3})$/i;
var $c3c3cdbe655981fa$var$hex3 = function hex3(value) {
    var match = value.match($c3c3cdbe655981fa$var$HEX3);
    if (match) return [
        parseInt(match[1][0] + match[1][0], 16),
        parseInt(match[1][1] + match[1][1], 16),
        parseInt(match[1][2] + match[1][2], 16),
        null
    ];
    return false;
};
var $c3c3cdbe655981fa$var$HEX6 = /^#([a-f0-9]{6})$/i;
var $c3c3cdbe655981fa$var$hex6 = function hex6(value) {
    var match = value.match($c3c3cdbe655981fa$var$HEX6);
    if (match) return [
        parseInt(match[1].substring(0, 2), 16),
        parseInt(match[1].substring(2, 4), 16),
        parseInt(match[1].substring(4, 6), 16),
        null
    ];
    return false;
};
var $c3c3cdbe655981fa$var$RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $c3c3cdbe655981fa$var$rgb = function rgb(value) {
    var match = value.match($c3c3cdbe655981fa$var$RGB);
    if (match) return [
        Number(match[1]),
        Number(match[2]),
        Number(match[3]),
        null
    ];
    return false;
};
var $c3c3cdbe655981fa$var$RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
var $c3c3cdbe655981fa$var$rgba = function rgba(value) {
    var match = value.match($c3c3cdbe655981fa$var$RGBA);
    if (match && match.length > 4) return [
        Number(match[1]),
        Number(match[2]),
        Number(match[3]),
        Number(match[4])
    ];
    return false;
};
var $c3c3cdbe655981fa$var$fromArray = function fromArray(array) {
    return [
        Math.min(array[0], 255),
        Math.min(array[1], 255),
        Math.min(array[2], 255),
        array.length > 3 ? array[3] : null
    ];
};
var $c3c3cdbe655981fa$var$namedColor = function namedColor(name) {
    var color = $c3c3cdbe655981fa$var$NAMED_COLORS[name.toLowerCase()];
    return color ? color : false;
};
var $c3c3cdbe655981fa$var$Color = function() {
    function Color(value) {
        $c3c3cdbe655981fa$var$_classCallCheck(this, Color);
        var _ref = Array.isArray(value) ? $c3c3cdbe655981fa$var$fromArray(value) : $c3c3cdbe655981fa$var$hex3(value) || $c3c3cdbe655981fa$var$rgb(value) || $c3c3cdbe655981fa$var$rgba(value) || $c3c3cdbe655981fa$var$namedColor(value) || $c3c3cdbe655981fa$var$hex6(value) || [
            0,
            0,
            0,
            null
        ], _ref2 = $c3c3cdbe655981fa$var$_slicedToArray(_ref, 4), r = _ref2[0], g = _ref2[1], b = _ref2[2], a = _ref2[3];
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    $c3c3cdbe655981fa$var$_createClass(Color, [
        {
            key: 'isTransparent',
            value: function isTransparent() {
                return this.a === 0;
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
            }
        }
    ]);
    return Color;
}();
module.exports.default = $c3c3cdbe655981fa$var$Color;
var $c3c3cdbe655981fa$var$NAMED_COLORS = {
    transparent: [
        0,
        0,
        0,
        0
    ],
    aliceblue: [
        240,
        248,
        255,
        null
    ],
    antiquewhite: [
        250,
        235,
        215,
        null
    ],
    aqua: [
        0,
        255,
        255,
        null
    ],
    aquamarine: [
        127,
        255,
        212,
        null
    ],
    azure: [
        240,
        255,
        255,
        null
    ],
    beige: [
        245,
        245,
        220,
        null
    ],
    bisque: [
        255,
        228,
        196,
        null
    ],
    black: [
        0,
        0,
        0,
        null
    ],
    blanchedalmond: [
        255,
        235,
        205,
        null
    ],
    blue: [
        0,
        0,
        255,
        null
    ],
    blueviolet: [
        138,
        43,
        226,
        null
    ],
    brown: [
        165,
        42,
        42,
        null
    ],
    burlywood: [
        222,
        184,
        135,
        null
    ],
    cadetblue: [
        95,
        158,
        160,
        null
    ],
    chartreuse: [
        127,
        255,
        0,
        null
    ],
    chocolate: [
        210,
        105,
        30,
        null
    ],
    coral: [
        255,
        127,
        80,
        null
    ],
    cornflowerblue: [
        100,
        149,
        237,
        null
    ],
    cornsilk: [
        255,
        248,
        220,
        null
    ],
    crimson: [
        220,
        20,
        60,
        null
    ],
    cyan: [
        0,
        255,
        255,
        null
    ],
    darkblue: [
        0,
        0,
        139,
        null
    ],
    darkcyan: [
        0,
        139,
        139,
        null
    ],
    darkgoldenrod: [
        184,
        134,
        11,
        null
    ],
    darkgray: [
        169,
        169,
        169,
        null
    ],
    darkgreen: [
        0,
        100,
        0,
        null
    ],
    darkgrey: [
        169,
        169,
        169,
        null
    ],
    darkkhaki: [
        189,
        183,
        107,
        null
    ],
    darkmagenta: [
        139,
        0,
        139,
        null
    ],
    darkolivegreen: [
        85,
        107,
        47,
        null
    ],
    darkorange: [
        255,
        140,
        0,
        null
    ],
    darkorchid: [
        153,
        50,
        204,
        null
    ],
    darkred: [
        139,
        0,
        0,
        null
    ],
    darksalmon: [
        233,
        150,
        122,
        null
    ],
    darkseagreen: [
        143,
        188,
        143,
        null
    ],
    darkslateblue: [
        72,
        61,
        139,
        null
    ],
    darkslategray: [
        47,
        79,
        79,
        null
    ],
    darkslategrey: [
        47,
        79,
        79,
        null
    ],
    darkturquoise: [
        0,
        206,
        209,
        null
    ],
    darkviolet: [
        148,
        0,
        211,
        null
    ],
    deeppink: [
        255,
        20,
        147,
        null
    ],
    deepskyblue: [
        0,
        191,
        255,
        null
    ],
    dimgray: [
        105,
        105,
        105,
        null
    ],
    dimgrey: [
        105,
        105,
        105,
        null
    ],
    dodgerblue: [
        30,
        144,
        255,
        null
    ],
    firebrick: [
        178,
        34,
        34,
        null
    ],
    floralwhite: [
        255,
        250,
        240,
        null
    ],
    forestgreen: [
        34,
        139,
        34,
        null
    ],
    fuchsia: [
        255,
        0,
        255,
        null
    ],
    gainsboro: [
        220,
        220,
        220,
        null
    ],
    ghostwhite: [
        248,
        248,
        255,
        null
    ],
    gold: [
        255,
        215,
        0,
        null
    ],
    goldenrod: [
        218,
        165,
        32,
        null
    ],
    gray: [
        128,
        128,
        128,
        null
    ],
    green: [
        0,
        128,
        0,
        null
    ],
    greenyellow: [
        173,
        255,
        47,
        null
    ],
    grey: [
        128,
        128,
        128,
        null
    ],
    honeydew: [
        240,
        255,
        240,
        null
    ],
    hotpink: [
        255,
        105,
        180,
        null
    ],
    indianred: [
        205,
        92,
        92,
        null
    ],
    indigo: [
        75,
        0,
        130,
        null
    ],
    ivory: [
        255,
        255,
        240,
        null
    ],
    khaki: [
        240,
        230,
        140,
        null
    ],
    lavender: [
        230,
        230,
        250,
        null
    ],
    lavenderblush: [
        255,
        240,
        245,
        null
    ],
    lawngreen: [
        124,
        252,
        0,
        null
    ],
    lemonchiffon: [
        255,
        250,
        205,
        null
    ],
    lightblue: [
        173,
        216,
        230,
        null
    ],
    lightcoral: [
        240,
        128,
        128,
        null
    ],
    lightcyan: [
        224,
        255,
        255,
        null
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210,
        null
    ],
    lightgray: [
        211,
        211,
        211,
        null
    ],
    lightgreen: [
        144,
        238,
        144,
        null
    ],
    lightgrey: [
        211,
        211,
        211,
        null
    ],
    lightpink: [
        255,
        182,
        193,
        null
    ],
    lightsalmon: [
        255,
        160,
        122,
        null
    ],
    lightseagreen: [
        32,
        178,
        170,
        null
    ],
    lightskyblue: [
        135,
        206,
        250,
        null
    ],
    lightslategray: [
        119,
        136,
        153,
        null
    ],
    lightslategrey: [
        119,
        136,
        153,
        null
    ],
    lightsteelblue: [
        176,
        196,
        222,
        null
    ],
    lightyellow: [
        255,
        255,
        224,
        null
    ],
    lime: [
        0,
        255,
        0,
        null
    ],
    limegreen: [
        50,
        205,
        50,
        null
    ],
    linen: [
        250,
        240,
        230,
        null
    ],
    magenta: [
        255,
        0,
        255,
        null
    ],
    maroon: [
        128,
        0,
        0,
        null
    ],
    mediumaquamarine: [
        102,
        205,
        170,
        null
    ],
    mediumblue: [
        0,
        0,
        205,
        null
    ],
    mediumorchid: [
        186,
        85,
        211,
        null
    ],
    mediumpurple: [
        147,
        112,
        219,
        null
    ],
    mediumseagreen: [
        60,
        179,
        113,
        null
    ],
    mediumslateblue: [
        123,
        104,
        238,
        null
    ],
    mediumspringgreen: [
        0,
        250,
        154,
        null
    ],
    mediumturquoise: [
        72,
        209,
        204,
        null
    ],
    mediumvioletred: [
        199,
        21,
        133,
        null
    ],
    midnightblue: [
        25,
        25,
        112,
        null
    ],
    mintcream: [
        245,
        255,
        250,
        null
    ],
    mistyrose: [
        255,
        228,
        225,
        null
    ],
    moccasin: [
        255,
        228,
        181,
        null
    ],
    navajowhite: [
        255,
        222,
        173,
        null
    ],
    navy: [
        0,
        0,
        128,
        null
    ],
    oldlace: [
        253,
        245,
        230,
        null
    ],
    olive: [
        128,
        128,
        0,
        null
    ],
    olivedrab: [
        107,
        142,
        35,
        null
    ],
    orange: [
        255,
        165,
        0,
        null
    ],
    orangered: [
        255,
        69,
        0,
        null
    ],
    orchid: [
        218,
        112,
        214,
        null
    ],
    palegoldenrod: [
        238,
        232,
        170,
        null
    ],
    palegreen: [
        152,
        251,
        152,
        null
    ],
    paleturquoise: [
        175,
        238,
        238,
        null
    ],
    palevioletred: [
        219,
        112,
        147,
        null
    ],
    papayawhip: [
        255,
        239,
        213,
        null
    ],
    peachpuff: [
        255,
        218,
        185,
        null
    ],
    peru: [
        205,
        133,
        63,
        null
    ],
    pink: [
        255,
        192,
        203,
        null
    ],
    plum: [
        221,
        160,
        221,
        null
    ],
    powderblue: [
        176,
        224,
        230,
        null
    ],
    purple: [
        128,
        0,
        128,
        null
    ],
    rebeccapurple: [
        102,
        51,
        153,
        null
    ],
    red: [
        255,
        0,
        0,
        null
    ],
    rosybrown: [
        188,
        143,
        143,
        null
    ],
    royalblue: [
        65,
        105,
        225,
        null
    ],
    saddlebrown: [
        139,
        69,
        19,
        null
    ],
    salmon: [
        250,
        128,
        114,
        null
    ],
    sandybrown: [
        244,
        164,
        96,
        null
    ],
    seagreen: [
        46,
        139,
        87,
        null
    ],
    seashell: [
        255,
        245,
        238,
        null
    ],
    sienna: [
        160,
        82,
        45,
        null
    ],
    silver: [
        192,
        192,
        192,
        null
    ],
    skyblue: [
        135,
        206,
        235,
        null
    ],
    slateblue: [
        106,
        90,
        205,
        null
    ],
    slategray: [
        112,
        128,
        144,
        null
    ],
    slategrey: [
        112,
        128,
        144,
        null
    ],
    snow: [
        255,
        250,
        250,
        null
    ],
    springgreen: [
        0,
        255,
        127,
        null
    ],
    steelblue: [
        70,
        130,
        180,
        null
    ],
    tan: [
        210,
        180,
        140,
        null
    ],
    teal: [
        0,
        128,
        128,
        null
    ],
    thistle: [
        216,
        191,
        216,
        null
    ],
    tomato: [
        255,
        99,
        71,
        null
    ],
    turquoise: [
        64,
        224,
        208,
        null
    ],
    violet: [
        238,
        130,
        238,
        null
    ],
    wheat: [
        245,
        222,
        179,
        null
    ],
    white: [
        255,
        255,
        255,
        null
    ],
    whitesmoke: [
        245,
        245,
        245,
        null
    ],
    yellow: [
        255,
        255,
        0,
        null
    ],
    yellowgreen: [
        154,
        205,
        50,
        null
    ]
};
var $c3c3cdbe655981fa$var$TRANSPARENT = module.exports.TRANSPARENT = new $c3c3cdbe655981fa$var$Color([
    0,
    0,
    0,
    0
]);

});



parcelRegister("Q1JwR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $09c633a5fefd5165$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $09c633a5fefd5165$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $09c633a5fefd5165$var$Logger = function() {
    function Logger(enabled, id, start) {
        $09c633a5fefd5165$var$_classCallCheck(this, Logger);
        this.enabled = typeof window !== 'undefined' && enabled;
        this.start = start ? start : Date.now();
        this.id = id;
    }
    $09c633a5fefd5165$var$_createClass(Logger, [
        {
            key: 'child',
            value: function child(id) {
                return new Logger(this.enabled, id, this.start);
            }
        },
        {
            key: 'log',
            value: function log() {
                if (this.enabled && window.console && window.console.log) {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                        Date.now() - this.start + 'ms',
                        this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'
                    ].concat([].slice.call(args, 0)));
                }
            }
        },
        {
            key: 'error',
            value: function error() {
                if (this.enabled && window.console && window.console.error) {
                    for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [
                        Date.now() - this.start + 'ms',
                        this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'
                    ].concat([].slice.call(args, 0)));
                }
            }
        }
    ]);
    return Logger;
}();
module.exports.default = $09c633a5fefd5165$var$Logger;

});

parcelRegister("idLSz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.renderElement = undefined;
var $d43e94aefa0f8b15$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $Q1JwR = parcelRequire("Q1JwR");
var $d43e94aefa0f8b15$var$_Logger2 = $d43e94aefa0f8b15$var$_interopRequireDefault($Q1JwR);

var $dIgh0 = parcelRequire("dIgh0");

var $bYzJT = parcelRequire("bYzJT");
var $d43e94aefa0f8b15$var$_Renderer2 = $d43e94aefa0f8b15$var$_interopRequireDefault($bYzJT);

var $eHkeh = parcelRequire("eHkeh");
var $d43e94aefa0f8b15$var$_ForeignObjectRenderer2 = $d43e94aefa0f8b15$var$_interopRequireDefault($eHkeh);

var $2ivfO = parcelRequire("2ivfO");
var $d43e94aefa0f8b15$var$_Feature2 = $d43e94aefa0f8b15$var$_interopRequireDefault($2ivfO);

var $4rAif = parcelRequire("4rAif");

var $lbXoG = parcelRequire("lbXoG");

var $1J8yd = parcelRequire("1J8yd");

var $gO3cU = parcelRequire("gO3cU");
var $d43e94aefa0f8b15$var$_Color2 = $d43e94aefa0f8b15$var$_interopRequireDefault($gO3cU);
function $d43e94aefa0f8b15$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d43e94aefa0f8b15$var$renderElement = module.exports.renderElement = function renderElement(element, options, logger) {
    var ownerDocument = element.ownerDocument;
    var windowBounds = new $4rAif.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
    // http://www.w3.org/TR/css3-background/#special-backgrounds
    var documentBackgroundColor = ownerDocument.documentElement ? new $d43e94aefa0f8b15$var$_Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : $gO3cU.TRANSPARENT;
    var bodyBackgroundColor = ownerDocument.body ? new $d43e94aefa0f8b15$var$_Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : $gO3cU.TRANSPARENT;
    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new $d43e94aefa0f8b15$var$_Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new $d43e94aefa0f8b15$var$_Color2.default(options.backgroundColor) : null;
    return (options.foreignObjectRendering ? $d43e94aefa0f8b15$var$_Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function(supportForeignObject) {
        return supportForeignObject ? function(cloner) {
            return cloner.inlineFonts(ownerDocument).then(function() {
                return cloner.resourceLoader.ready();
            }).then(function() {
                var renderer = new $d43e94aefa0f8b15$var$_ForeignObjectRenderer2.default(cloner.documentElement);
                var defaultView = ownerDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;
                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';
                var _ref = isDocument ? (0, $4rAif.parseDocumentSize)(ownerDocument) : (0, $4rAif.parseBounds)(element, scrollX, scrollY), width = _ref.width, height = _ref.height, left = _ref.left, top = _ref.top;
                return renderer.render({
                    backgroundColor: backgroundColor,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
                    windowWidth: options.windowWidth,
                    windowHeight: options.windowHeight,
                    scrollX: options.scrollX,
                    scrollY: options.scrollY
                });
            });
        }(new $lbXoG.DocumentCloner(element, options, logger, true, renderElement)) : (0, $lbXoG.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function(_ref2) {
            var _ref3 = $d43e94aefa0f8b15$var$_slicedToArray(_ref2, 3), container = _ref3[0], clonedElement = _ref3[1], resourceLoader = _ref3[2];
            var stack = (0, $dIgh0.NodeParser)(clonedElement, resourceLoader, logger);
            var clonedDocument = clonedElement.ownerDocument;
            if (backgroundColor === stack.container.style.background.backgroundColor) stack.container.style.background.backgroundColor = $gO3cU.TRANSPARENT;
            return resourceLoader.ready().then(function(imageStore) {
                var fontMetrics = new $1J8yd.FontMetrics(clonedDocument);
                var defaultView = clonedDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;
                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';
                var _ref4 = isDocument ? (0, $4rAif.parseDocumentSize)(ownerDocument) : (0, $4rAif.parseBounds)(clonedElement, scrollX, scrollY), width = _ref4.width, height = _ref4.height, left = _ref4.left, top = _ref4.top;
                var renderOptions = {
                    backgroundColor: backgroundColor,
                    fontMetrics: fontMetrics,
                    imageStore: imageStore,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
                };
                if (Array.isArray(options.target)) return Promise.all(options.target.map(function(target) {
                    var renderer = new $d43e94aefa0f8b15$var$_Renderer2.default(target, renderOptions);
                    return renderer.render(stack);
                }));
                else {
                    var renderer = new $d43e94aefa0f8b15$var$_Renderer2.default(options.target, renderOptions);
                    var canvas = renderer.render(stack);
                    if (options.removeContainer === true) {
                        if (container.parentNode) container.parentNode.removeChild(container);
                    }
                    return canvas;
                }
            });
        });
    });
};

});
parcelRegister("dIgh0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeParser = undefined;

var $2Ueb1 = parcelRequire("2Ueb1");
var $9fbc01fb63761a30$var$_StackingContext2 = $9fbc01fb63761a30$var$_interopRequireDefault($2Ueb1);

var $6RJQM = parcelRequire("6RJQM");
var $9fbc01fb63761a30$var$_NodeContainer2 = $9fbc01fb63761a30$var$_interopRequireDefault($6RJQM);

var $l5O3X = parcelRequire("l5O3X");
var $9fbc01fb63761a30$var$_TextContainer2 = $9fbc01fb63761a30$var$_interopRequireDefault($l5O3X);

var $6UpLb = parcelRequire("6UpLb");

var $8vWh7 = parcelRequire("8vWh7");

var $dcmux = parcelRequire("dcmux");
function $9fbc01fb63761a30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9fbc01fb63761a30$var$NodeParser = module.exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
    var index = 0;
    var container = new $9fbc01fb63761a30$var$_NodeContainer2.default(node, null, resourceLoader, index++);
    var stack = new $9fbc01fb63761a30$var$_StackingContext2.default(container, null, true);
    $9fbc01fb63761a30$var$parseNodeTree(node, container, stack, resourceLoader, index);
    return stack;
};
var $9fbc01fb63761a30$var$IGNORED_NODE_NAMES = [
    'SCRIPT',
    'HEAD',
    'TITLE',
    'OBJECT',
    'BR',
    'OPTION'
];
var $9fbc01fb63761a30$var$parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
    for(var childNode = node.firstChild, nextNode; childNode; childNode = nextNode){
        nextNode = childNode.nextSibling;
        var defaultView = childNode.ownerDocument.defaultView;
        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
            if (childNode.data.trim().length > 0) parent.childNodes.push($9fbc01fb63761a30$var$_TextContainer2.default.fromTextNode(childNode, parent));
        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
            if ($9fbc01fb63761a30$var$IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
                var container = new $9fbc01fb63761a30$var$_NodeContainer2.default(childNode, parent, resourceLoader, index++);
                if (container.isVisible()) {
                    if (childNode.tagName === 'INPUT') // $FlowFixMe
                    (0, $6UpLb.inlineInputElement)(childNode, container);
                    else if (childNode.tagName === 'TEXTAREA') // $FlowFixMe
                    (0, $6UpLb.inlineTextAreaElement)(childNode, container);
                    else if (childNode.tagName === 'SELECT') // $FlowFixMe
                    (0, $6UpLb.inlineSelectElement)(childNode, container);
                    else if (container.style.listStyle && container.style.listStyle.listStyleType !== $dcmux.LIST_STYLE_TYPE.NONE) (0, $8vWh7.inlineListItemElement)(childNode, container, resourceLoader);
                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
                    var treatAsRealStackingContext = $9fbc01fb63761a30$var$createsRealStackingContext(container, childNode);
                    if (treatAsRealStackingContext || $9fbc01fb63761a30$var$createsStackingContext(container)) {
                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
                        // which actually create a new stacking context should be considered part of the parent stacking context
                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                        var childStack = new $9fbc01fb63761a30$var$_StackingContext2.default(container, parentStack, treatAsRealStackingContext);
                        parentStack.contexts.push(childStack);
                        if (SHOULD_TRAVERSE_CHILDREN) parseNodeTree(childNode, container, childStack, resourceLoader, index);
                    } else {
                        stack.children.push(container);
                        if (SHOULD_TRAVERSE_CHILDREN) parseNodeTree(childNode, container, stack, resourceLoader, index);
                    }
                }
            }
        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
            var _container = new $9fbc01fb63761a30$var$_NodeContainer2.default(childNode, parent, resourceLoader, index++);
            var _treatAsRealStackingContext = $9fbc01fb63761a30$var$createsRealStackingContext(_container, childNode);
            if (_treatAsRealStackingContext || $9fbc01fb63761a30$var$createsStackingContext(_container)) {
                // for treatAsRealStackingContext:false, any positioned descendants and descendants
                // which actually create a new stacking context should be considered part of the parent stacking context
                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                var _childStack = new $9fbc01fb63761a30$var$_StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
                _parentStack.contexts.push(_childStack);
            } else stack.children.push(_container);
        }
    }
};
var $9fbc01fb63761a30$var$createsRealStackingContext = function createsRealStackingContext(container, node) {
    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || $9fbc01fb63761a30$var$isBodyWithTransparentRoot(container, node);
};
var $9fbc01fb63761a30$var$createsStackingContext = function createsStackingContext(container) {
    return container.isPositioned() || container.isFloating();
};
var $9fbc01fb63761a30$var$isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
    return node.nodeName === 'BODY' && container.parent instanceof $9fbc01fb63761a30$var$_NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
};

});
parcelRegister("2Ueb1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $21dbceebaac6e90d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6RJQM = parcelRequire("6RJQM");
var $21dbceebaac6e90d$var$_NodeContainer2 = $21dbceebaac6e90d$var$_interopRequireDefault($6RJQM);
parcelRequire("kqVyv");
function $21dbceebaac6e90d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21dbceebaac6e90d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $21dbceebaac6e90d$var$StackingContext = function() {
    function StackingContext(container, parent, treatAsRealStackingContext) {
        $21dbceebaac6e90d$var$_classCallCheck(this, StackingContext);
        this.container = container;
        this.parent = parent;
        this.contexts = [];
        this.children = [];
        this.treatAsRealStackingContext = treatAsRealStackingContext;
    }
    $21dbceebaac6e90d$var$_createClass(StackingContext, [
        {
            key: 'getOpacity',
            value: function getOpacity() {
                return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
            }
        },
        {
            key: 'getRealParentStackingContext',
            value: function getRealParentStackingContext() {
                return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
            }
        }
    ]);
    return StackingContext;
}();
module.exports.default = $21dbceebaac6e90d$var$StackingContext;

});
parcelRegister("6RJQM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4ffb423ecf7aa0fa$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $gO3cU = parcelRequire("gO3cU");
var $4ffb423ecf7aa0fa$var$_Color2 = $4ffb423ecf7aa0fa$var$_interopRequireDefault($gO3cU);

var $j1biG = parcelRequire("j1biG");

var $6vPZX = parcelRequire("6vPZX");

var $gIYuc = parcelRequire("gIYuc");

var $78dPR = parcelRequire("78dPR");

var $cijur = parcelRequire("cijur");

var $6w3Lw = parcelRequire("6w3Lw");

var $f3WrI = parcelRequire("f3WrI");

var $h7pd1 = parcelRequire("h7pd1");

var $aWgAn = parcelRequire("aWgAn");

var $dcmux = parcelRequire("dcmux");

var $gTsRU = parcelRequire("gTsRU");

var $hOOLZ = parcelRequire("hOOLZ");

var $aazPo = parcelRequire("aazPo");

var $guqDy = parcelRequire("guqDy");

var $kqVyv = parcelRequire("kqVyv");

var $dPsAk = parcelRequire("dPsAk");

var $aFCU7 = parcelRequire("aFCU7");

var $41mZw = parcelRequire("41mZw");

var $a56z5 = parcelRequire("a56z5");

var $bmVVz = parcelRequire("bmVVz");

var $a6ZTh = parcelRequire("a6ZTh");

var $dTMxH = parcelRequire("dTMxH");

var $4rAif = parcelRequire("4rAif");

var $6UpLb = parcelRequire("6UpLb");

var $8vWh7 = parcelRequire("8vWh7");
function $4ffb423ecf7aa0fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4ffb423ecf7aa0fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $4ffb423ecf7aa0fa$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
var $4ffb423ecf7aa0fa$var$NodeContainer = function() {
    function NodeContainer(node, parent, resourceLoader, index) {
        var _this = this;
        $4ffb423ecf7aa0fa$var$_classCallCheck(this, NodeContainer);
        this.parent = parent;
        this.tagName = node.tagName;
        this.index = index;
        this.childNodes = [];
        this.listItems = [];
        if (typeof node.start === 'number') this.listStart = node.start;
        var defaultView = node.ownerDocument.defaultView;
        var scrollX = defaultView.pageXOffset;
        var scrollY = defaultView.pageYOffset;
        var style = defaultView.getComputedStyle(node, null);
        var display = (0, $cijur.parseDisplay)(style.display);
        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';
        var position = (0, $kqVyv.parsePosition)(style.position);
        this.style = {
            background: IS_INPUT ? $6UpLb.INPUT_BACKGROUND : (0, $6vPZX.parseBackground)(style, resourceLoader),
            border: IS_INPUT ? $6UpLb.INPUT_BORDERS : (0, $gIYuc.parseBorder)(style),
            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, $6UpLb.getInputBorderRadius)(node) : (0, $78dPR.parseBorderRadius)(style),
            color: IS_INPUT ? $6UpLb.INPUT_COLOR : new $4ffb423ecf7aa0fa$var$_Color2.default(style.color),
            display: display,
            float: (0, $6w3Lw.parseCSSFloat)(style.float),
            font: (0, $f3WrI.parseFont)(style),
            letterSpacing: (0, $h7pd1.parseLetterSpacing)(style.letterSpacing),
            listStyle: display === $cijur.DISPLAY.LIST_ITEM ? (0, $dcmux.parseListStyle)(style) : null,
            lineBreak: (0, $aWgAn.parseLineBreak)(style.lineBreak),
            margin: (0, $gTsRU.parseMargin)(style),
            opacity: parseFloat(style.opacity),
            overflow: $4ffb423ecf7aa0fa$var$INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, $hOOLZ.parseOverflow)(style.overflow) : $hOOLZ.OVERFLOW.HIDDEN,
            overflowWrap: (0, $aazPo.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
            padding: (0, $guqDy.parsePadding)(style),
            position: position,
            textDecoration: (0, $dPsAk.parseTextDecoration)(style),
            textShadow: (0, $aFCU7.parseTextShadow)(style.textShadow),
            textTransform: (0, $41mZw.parseTextTransform)(style.textTransform),
            transform: (0, $a56z5.parseTransform)(style),
            visibility: (0, $bmVVz.parseVisibility)(style.visibility),
            wordBreak: (0, $a6ZTh.parseWordBreak)(style.wordBreak),
            zIndex: (0, $dTMxH.parseZIndex)(position !== $kqVyv.POSITION.STATIC ? style.zIndex : 'auto')
        };
        if (this.isTransformed()) // getBoundingClientRect provides values post-transform, we want them without the transformation
        node.style.transform = 'matrix(1,0,0,1,0,0)';
        if (display === $cijur.DISPLAY.LIST_ITEM) {
            var listOwner = (0, $8vWh7.getListOwner)(this);
            if (listOwner) {
                var listIndex = listOwner.listItems.length;
                listOwner.listItems.push(this);
                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
            }
        }
        // TODO move bound retrieval for all nodes to a later stage?
        if (node.tagName === 'IMG') node.addEventListener('load', function() {
            _this.bounds = (0, $4rAif.parseBounds)(node, scrollX, scrollY);
            _this.curvedBounds = (0, $4rAif.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
        });
        this.image = $4ffb423ecf7aa0fa$var$getImage(node, resourceLoader);
        this.bounds = IS_INPUT ? (0, $6UpLb.reformatInputBounds)((0, $4rAif.parseBounds)(node, scrollX, scrollY)) : (0, $4rAif.parseBounds)(node, scrollX, scrollY);
        this.curvedBounds = (0, $4rAif.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);
    }
    $4ffb423ecf7aa0fa$var$_createClass(NodeContainer, [
        {
            key: 'getClipPaths',
            value: function getClipPaths() {
                var parentClips = this.parent ? this.parent.getClipPaths() : [];
                var isClipped = this.style.overflow !== $hOOLZ.OVERFLOW.VISIBLE;
                return isClipped ? parentClips.concat([
                    (0, $4rAif.calculatePaddingBoxPath)(this.curvedBounds)
                ]) : parentClips;
            }
        },
        {
            key: 'isInFlow',
            value: function isInFlow() {
                return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
            }
        },
        {
            key: 'isVisible',
            value: function isVisible() {
                return !(0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === $bmVVz.VISIBILITY.VISIBLE;
            }
        },
        {
            key: 'isAbsolutelyPositioned',
            value: function isAbsolutelyPositioned() {
                return this.style.position !== $kqVyv.POSITION.STATIC && this.style.position !== $kqVyv.POSITION.RELATIVE;
            }
        },
        {
            key: 'isPositioned',
            value: function isPositioned() {
                return this.style.position !== $kqVyv.POSITION.STATIC;
            }
        },
        {
            key: 'isFloating',
            value: function isFloating() {
                return this.style.float !== $6w3Lw.FLOAT.NONE;
            }
        },
        {
            key: 'isRootElement',
            value: function isRootElement() {
                return this.parent === null;
            }
        },
        {
            key: 'isTransformed',
            value: function isTransformed() {
                return this.style.transform !== null;
            }
        },
        {
            key: 'isPositionedWithZIndex',
            value: function isPositionedWithZIndex() {
                return this.isPositioned() && !this.style.zIndex.auto;
            }
        },
        {
            key: 'isInlineLevel',
            value: function isInlineLevel() {
                return (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_BLOCK) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_FLEX) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_GRID) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_LIST_ITEM) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_TABLE);
            }
        },
        {
            key: 'isInlineBlockOrInlineTable',
            value: function isInlineBlockOrInlineTable() {
                return (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_BLOCK) || (0, $j1biG.contains)(this.style.display, $cijur.DISPLAY.INLINE_TABLE);
            }
        }
    ]);
    return NodeContainer;
}();
module.exports.default = $4ffb423ecf7aa0fa$var$NodeContainer;
var $4ffb423ecf7aa0fa$var$getImage = function getImage(node, resourceLoader) {
    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
        var s = new XMLSerializer();
        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
    }
    switch(node.tagName){
        case 'IMG':
            // $FlowFixMe
            var img = node;
            return resourceLoader.loadImage(img.currentSrc || img.src);
        case 'CANVAS':
            // $FlowFixMe
            var canvas = node;
            return resourceLoader.loadCanvas(canvas);
        case 'IFRAME':
            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
            if (iframeKey) return iframeKey;
            break;
    }
    return null;
};

});
parcelRegister("j1biG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dd86e05a5b07eee5$var$contains = module.exports.contains = function contains(bit, value) {
    return (bit & value) !== 0;
};
var $dd86e05a5b07eee5$var$distance = module.exports.distance = function distance(a, b) {
    return Math.sqrt(a * a + b * b);
};
var $dd86e05a5b07eee5$var$copyCSSStyles = module.exports.copyCSSStyles = function copyCSSStyles(style, target) {
    // Edge does not provide value for cssText
    for(var i = style.length - 1; i >= 0; i--){
        var property = style.item(i);
        // Safari shows pseudoelements if content is set
        if (property !== 'content') target.style.setProperty(property, style.getPropertyValue(property));
    }
    return target;
};
var $dd86e05a5b07eee5$var$SMALL_IMAGE = module.exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

});

parcelRegister("6vPZX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBackgroundImage = module.exports.parseBackground = module.exports.calculateBackgroundRepeatPath = module.exports.calculateBackgroundPosition = module.exports.calculateBackgroungPositioningArea = module.exports.calculateBackgroungPaintingArea = module.exports.calculateGradientBackgroundSize = module.exports.calculateBackgroundSize = module.exports.BACKGROUND_ORIGIN = module.exports.BACKGROUND_CLIP = module.exports.BACKGROUND_SIZE = module.exports.BACKGROUND_REPEAT = undefined;

var $gO3cU = parcelRequire("gO3cU");
var $4bddf920ecd44744$var$_Color2 = $4bddf920ecd44744$var$_interopRequireDefault($gO3cU);

var $iAhLp = parcelRequire("iAhLp");
var $4bddf920ecd44744$var$_Length2 = $4bddf920ecd44744$var$_interopRequireDefault($iAhLp);

var $4gGI9 = parcelRequire("4gGI9");
var $4bddf920ecd44744$var$_Size2 = $4bddf920ecd44744$var$_interopRequireDefault($4gGI9);

var $cQg28 = parcelRequire("cQg28");
var $4bddf920ecd44744$var$_Vector2 = $4bddf920ecd44744$var$_interopRequireDefault($cQg28);

var $4rAif = parcelRequire("4rAif");

var $guqDy = parcelRequire("guqDy");
function $4bddf920ecd44744$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4bddf920ecd44744$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $4bddf920ecd44744$var$BACKGROUND_REPEAT = module.exports.BACKGROUND_REPEAT = {
    REPEAT: 0,
    NO_REPEAT: 1,
    REPEAT_X: 2,
    REPEAT_Y: 3
};
var $4bddf920ecd44744$var$BACKGROUND_SIZE = module.exports.BACKGROUND_SIZE = {
    AUTO: 0,
    CONTAIN: 1,
    COVER: 2,
    LENGTH: 3
};
var $4bddf920ecd44744$var$BACKGROUND_CLIP = module.exports.BACKGROUND_CLIP = {
    BORDER_BOX: 0,
    PADDING_BOX: 1,
    CONTENT_BOX: 2
};
var $4bddf920ecd44744$var$BACKGROUND_ORIGIN = module.exports.BACKGROUND_ORIGIN = $4bddf920ecd44744$var$BACKGROUND_CLIP;
var $4bddf920ecd44744$var$AUTO = 'auto';
var $4bddf920ecd44744$var$BackgroundSize = function BackgroundSize(size) {
    $4bddf920ecd44744$var$_classCallCheck(this, BackgroundSize);
    switch(size){
        case 'contain':
            this.size = $4bddf920ecd44744$var$BACKGROUND_SIZE.CONTAIN;
            break;
        case 'cover':
            this.size = $4bddf920ecd44744$var$BACKGROUND_SIZE.COVER;
            break;
        case 'auto':
            this.size = $4bddf920ecd44744$var$BACKGROUND_SIZE.AUTO;
            break;
        default:
            this.value = new $4bddf920ecd44744$var$_Length2.default(size);
    }
};
var $4bddf920ecd44744$var$calculateBackgroundSize = module.exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
    var width = 0;
    var height = 0;
    var size = backgroundImage.size;
    if (size[0].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.CONTAIN || size[0].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.COVER) {
        var targetRatio = bounds.width / bounds.height;
        var currentRatio = image.width / image.height;
        return targetRatio < currentRatio !== (size[0].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.COVER) ? new $4bddf920ecd44744$var$_Size2.default(bounds.width, bounds.width / currentRatio) : new $4bddf920ecd44744$var$_Size2.default(bounds.height * currentRatio, bounds.height);
    }
    if (size[0].value) width = size[0].value.getAbsoluteValue(bounds.width);
    if (size[0].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.AUTO && size[1].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.AUTO) height = image.height;
    else if (size[1].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.AUTO) height = width / image.width * image.height;
    else if (size[1].value) height = size[1].value.getAbsoluteValue(bounds.height);
    if (size[0].size === $4bddf920ecd44744$var$BACKGROUND_SIZE.AUTO) width = height / image.height * image.width;
    return new $4bddf920ecd44744$var$_Size2.default(width, height);
};
var $4bddf920ecd44744$var$calculateGradientBackgroundSize = module.exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
    var size = backgroundImage.size;
    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;
    return new $4bddf920ecd44744$var$_Size2.default(width, height);
};
var $4bddf920ecd44744$var$AUTO_SIZE = new $4bddf920ecd44744$var$BackgroundSize($4bddf920ecd44744$var$AUTO);
var $4bddf920ecd44744$var$calculateBackgroungPaintingArea = module.exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
    switch(clip){
        case $4bddf920ecd44744$var$BACKGROUND_CLIP.BORDER_BOX:
            return (0, $4rAif.calculateBorderBoxPath)(curves);
        case $4bddf920ecd44744$var$BACKGROUND_CLIP.PADDING_BOX:
        default:
            return (0, $4rAif.calculatePaddingBoxPath)(curves);
    }
};
var $4bddf920ecd44744$var$calculateBackgroungPositioningArea = module.exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
    var paddingBox = (0, $4rAif.calculatePaddingBox)(bounds, border);
    switch(backgroundOrigin){
        case $4bddf920ecd44744$var$BACKGROUND_ORIGIN.BORDER_BOX:
            return bounds;
        case $4bddf920ecd44744$var$BACKGROUND_ORIGIN.CONTENT_BOX:
            var paddingLeft = padding[$guqDy.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
            var paddingRight = padding[$guqDy.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
            var paddingTop = padding[$guqDy.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
            var paddingBottom = padding[$guqDy.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
            return new $4rAif.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
        case $4bddf920ecd44744$var$BACKGROUND_ORIGIN.PADDING_BOX:
        default:
            return paddingBox;
    }
};
var $4bddf920ecd44744$var$calculateBackgroundPosition = module.exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
    return new $4bddf920ecd44744$var$_Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
};
var $4bddf920ecd44744$var$calculateBackgroundRepeatPath = module.exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
    var repeat = background.repeat;
    switch(repeat){
        case $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT_X:
            return [
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))
            ];
        case $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT_Y:
            return [
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))
            ];
        case $4bddf920ecd44744$var$BACKGROUND_REPEAT.NO_REPEAT:
            return [
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))
            ];
        default:
            return [
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left), Math.round(bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)),
                new $4bddf920ecd44744$var$_Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))
            ];
    }
};
var $4bddf920ecd44744$var$parseBackground = module.exports.parseBackground = function parseBackground(style, resourceLoader) {
    return {
        backgroundColor: new $4bddf920ecd44744$var$_Color2.default(style.backgroundColor),
        backgroundImage: $4bddf920ecd44744$var$parseBackgroundImages(style, resourceLoader),
        backgroundClip: $4bddf920ecd44744$var$parseBackgroundClip(style.backgroundClip),
        backgroundOrigin: $4bddf920ecd44744$var$parseBackgroundOrigin(style.backgroundOrigin)
    };
};
var $4bddf920ecd44744$var$parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
    switch(backgroundClip){
        case 'padding-box':
            return $4bddf920ecd44744$var$BACKGROUND_CLIP.PADDING_BOX;
        case 'content-box':
            return $4bddf920ecd44744$var$BACKGROUND_CLIP.CONTENT_BOX;
    }
    return $4bddf920ecd44744$var$BACKGROUND_CLIP.BORDER_BOX;
};
var $4bddf920ecd44744$var$parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
    switch(backgroundOrigin){
        case 'padding-box':
            return $4bddf920ecd44744$var$BACKGROUND_ORIGIN.PADDING_BOX;
        case 'content-box':
            return $4bddf920ecd44744$var$BACKGROUND_ORIGIN.CONTENT_BOX;
    }
    return $4bddf920ecd44744$var$BACKGROUND_ORIGIN.BORDER_BOX;
};
var $4bddf920ecd44744$var$parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
    switch(backgroundRepeat.trim()){
        case 'no-repeat':
            return $4bddf920ecd44744$var$BACKGROUND_REPEAT.NO_REPEAT;
        case 'repeat-x':
        case 'repeat no-repeat':
            return $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT_X;
        case 'repeat-y':
        case 'no-repeat repeat':
            return $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT_Y;
        case 'repeat':
            return $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT;
    }
    return $4bddf920ecd44744$var$BACKGROUND_REPEAT.REPEAT;
};
var $4bddf920ecd44744$var$parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
    var sources = $4bddf920ecd44744$var$parseBackgroundImage(style.backgroundImage).map(function(backgroundImage) {
        if (backgroundImage.method === 'url') {
            var key = resourceLoader.loadImage(backgroundImage.args[0]);
            backgroundImage.args = key ? [
                key
            ] : [];
        }
        return backgroundImage;
    });
    var positions = style.backgroundPosition.split(',');
    var repeats = style.backgroundRepeat.split(',');
    var sizes = style.backgroundSize.split(',');
    return sources.map(function(source, index) {
        var size = (sizes[index] || $4bddf920ecd44744$var$AUTO).trim().split(' ').map($4bddf920ecd44744$var$parseBackgroundSize);
        var position = (positions[index] || $4bddf920ecd44744$var$AUTO).trim().split(' ').map($4bddf920ecd44744$var$parseBackgoundPosition);
        return {
            source: source,
            repeat: $4bddf920ecd44744$var$parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
            size: size.length < 2 ? [
                size[0],
                $4bddf920ecd44744$var$AUTO_SIZE
            ] : [
                size[0],
                size[1]
            ],
            position: position.length < 2 ? [
                position[0],
                position[0]
            ] : [
                position[0],
                position[1]
            ]
        };
    });
};
var $4bddf920ecd44744$var$parseBackgroundSize = function parseBackgroundSize(size) {
    return size === 'auto' ? $4bddf920ecd44744$var$AUTO_SIZE : new $4bddf920ecd44744$var$BackgroundSize(size);
};
var $4bddf920ecd44744$var$parseBackgoundPosition = function parseBackgoundPosition(position) {
    switch(position){
        case 'bottom':
        case 'right':
            return new $4bddf920ecd44744$var$_Length2.default('100%');
        case 'left':
        case 'top':
            return new $4bddf920ecd44744$var$_Length2.default('0%');
        case 'auto':
            return new $4bddf920ecd44744$var$_Length2.default('0');
    }
    return new $4bddf920ecd44744$var$_Length2.default(position);
};
var $4bddf920ecd44744$var$parseBackgroundImage = module.exports.parseBackgroundImage = function parseBackgroundImage(image) {
    var whitespace = /^\s$/;
    var results = [];
    var args = [];
    var method = '';
    var quote = null;
    var definition = '';
    var mode = 0;
    var numParen = 0;
    var appendResult = function appendResult() {
        var prefix = '';
        if (method) {
            if (definition.substr(0, 1) === '"') definition = definition.substr(1, definition.length - 2);
            if (definition) args.push(definition.trim());
            var prefix_i = method.indexOf('-', 1) + 1;
            if (method.substr(0, 1) === '-' && prefix_i > 0) {
                prefix = method.substr(0, prefix_i).toLowerCase();
                method = method.substr(prefix_i);
            }
            method = method.toLowerCase();
            if (method !== 'none') results.push({
                prefix: prefix,
                method: method,
                args: args
            });
        }
        args = [];
        method = definition = '';
    };
    image.split('').forEach(function(c) {
        if (mode === 0 && whitespace.test(c)) return;
        switch(c){
            case '"':
                if (!quote) quote = c;
                else if (quote === c) quote = null;
                break;
            case '(':
                if (quote) break;
                else if (mode === 0) {
                    mode = 1;
                    return;
                } else numParen++;
                break;
            case ')':
                if (quote) break;
                else if (mode === 1) {
                    if (numParen === 0) {
                        mode = 0;
                        appendResult();
                        return;
                    } else numParen--;
                }
                break;
            case ',':
                if (quote) break;
                else if (mode === 0) {
                    appendResult();
                    return;
                } else if (mode === 1) {
                    if (numParen === 0 && !method.match(/^url$/i)) {
                        args.push(definition.trim());
                        definition = '';
                        return;
                    }
                }
                break;
        }
        if (mode === 0) method += c;
        else definition += c;
    });
    appendResult();
    return results;
};

});
parcelRegister("iAhLp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateLengthFromValueWithUnit = module.exports.LENGTH_TYPE = undefined;
var $d8795e4a973c928f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $6RJQM = parcelRequire("6RJQM");
var $d8795e4a973c928f$var$_NodeContainer2 = $d8795e4a973c928f$var$_interopRequireDefault($6RJQM);
function $d8795e4a973c928f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d8795e4a973c928f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $d8795e4a973c928f$var$LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;
var $d8795e4a973c928f$var$LENGTH_TYPE = module.exports.LENGTH_TYPE = {
    PX: 0,
    PERCENTAGE: 1
};
var $d8795e4a973c928f$var$Length = function() {
    function Length(value) {
        $d8795e4a973c928f$var$_classCallCheck(this, Length);
        this.type = value.substr(value.length - 1) === '%' ? $d8795e4a973c928f$var$LENGTH_TYPE.PERCENTAGE : $d8795e4a973c928f$var$LENGTH_TYPE.PX;
        var parsedValue = parseFloat(value);
        this.value = isNaN(parsedValue) ? 0 : parsedValue;
    }
    $d8795e4a973c928f$var$_createClass(Length, [
        {
            key: 'isPercentage',
            value: function isPercentage() {
                return this.type === $d8795e4a973c928f$var$LENGTH_TYPE.PERCENTAGE;
            }
        },
        {
            key: 'getAbsoluteValue',
            value: function getAbsoluteValue(parentLength) {
                return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
            }
        }
    ], [
        {
            key: 'create',
            value: function create(v) {
                return new Length(v);
            }
        }
    ]);
    return Length;
}();
module.exports.default = $d8795e4a973c928f$var$Length;
var $d8795e4a973c928f$var$getRootFontSize = function getRootFontSize(container) {
    var parent = container.parent;
    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
};
var $d8795e4a973c928f$var$calculateLengthFromValueWithUnit = module.exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
    switch(unit){
        case 'px':
        case '%':
            return new $d8795e4a973c928f$var$Length(value + unit);
        case 'em':
        case 'rem':
            var length = new $d8795e4a973c928f$var$Length(value);
            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : $d8795e4a973c928f$var$getRootFontSize(container);
            return length;
        default:
            // TODO: handle correctly if unknown unit is used
            return new $d8795e4a973c928f$var$Length('0');
    }
};

});

parcelRegister("4gGI9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $31b9c99498bf1bee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $31b9c99498bf1bee$var$Size = function Size(width, height) {
    $31b9c99498bf1bee$var$_classCallCheck(this, Size);
    this.width = width;
    this.height = height;
};
module.exports.default = $31b9c99498bf1bee$var$Size;

});

parcelRegister("cQg28", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kRg2K = parcelRequire("kRg2K");
function $9596c746a038431a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $9596c746a038431a$var$Vector = function Vector(x, y) {
    $9596c746a038431a$var$_classCallCheck(this, Vector);
    this.type = $kRg2K.PATH.VECTOR;
    this.x = x;
    this.y = y;
};
module.exports.default = $9596c746a038431a$var$Vector;

});

parcelRegister("4rAif", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBoundCurves = module.exports.calculatePaddingBoxPath = module.exports.calculateBorderBoxPath = module.exports.parsePathForBorder = module.exports.parseDocumentSize = module.exports.calculateContentBox = module.exports.calculatePaddingBox = module.exports.parseBounds = module.exports.Bounds = undefined;
var $33c5d61f9dccd214$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cQg28 = parcelRequire("cQg28");
var $33c5d61f9dccd214$var$_Vector2 = $33c5d61f9dccd214$var$_interopRequireDefault($cQg28);

var $f0RUS = parcelRequire("f0RUS");
var $33c5d61f9dccd214$var$_BezierCurve2 = $33c5d61f9dccd214$var$_interopRequireDefault($f0RUS);
function $33c5d61f9dccd214$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33c5d61f9dccd214$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $33c5d61f9dccd214$var$TOP = 0;
var $33c5d61f9dccd214$var$RIGHT = 1;
var $33c5d61f9dccd214$var$BOTTOM = 2;
var $33c5d61f9dccd214$var$LEFT = 3;
var $33c5d61f9dccd214$var$H = 0;
var $33c5d61f9dccd214$var$V = 1;
var $33c5d61f9dccd214$var$Bounds = module.exports.Bounds = function() {
    function Bounds(x, y, w, h) {
        $33c5d61f9dccd214$var$_classCallCheck(this, Bounds);
        this.left = x;
        this.top = y;
        this.width = w;
        this.height = h;
    }
    $33c5d61f9dccd214$var$_createClass(Bounds, null, [
        {
            key: 'fromClientRect',
            value: function fromClientRect(clientRect, scrollX, scrollY) {
                return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
            }
        }
    ]);
    return Bounds;
}();
var $33c5d61f9dccd214$var$parseBounds = module.exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
    return $33c5d61f9dccd214$var$Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
};
var $33c5d61f9dccd214$var$calculatePaddingBox = module.exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
    return new $33c5d61f9dccd214$var$Bounds(bounds.left + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + borders[$33c5d61f9dccd214$var$TOP].borderWidth, bounds.width - (borders[$33c5d61f9dccd214$var$RIGHT].borderWidth + borders[$33c5d61f9dccd214$var$LEFT].borderWidth), bounds.height - (borders[$33c5d61f9dccd214$var$TOP].borderWidth + borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth));
};
var $33c5d61f9dccd214$var$calculateContentBox = module.exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
    // TODO support percentage paddings
    var paddingTop = padding[$33c5d61f9dccd214$var$TOP].value;
    var paddingRight = padding[$33c5d61f9dccd214$var$RIGHT].value;
    var paddingBottom = padding[$33c5d61f9dccd214$var$BOTTOM].value;
    var paddingLeft = padding[$33c5d61f9dccd214$var$LEFT].value;
    return new $33c5d61f9dccd214$var$Bounds(bounds.left + paddingLeft + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + paddingTop + borders[$33c5d61f9dccd214$var$TOP].borderWidth, bounds.width - (borders[$33c5d61f9dccd214$var$RIGHT].borderWidth + borders[$33c5d61f9dccd214$var$LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[$33c5d61f9dccd214$var$TOP].borderWidth + borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth + paddingTop + paddingBottom));
};
var $33c5d61f9dccd214$var$parseDocumentSize = module.exports.parseDocumentSize = function parseDocumentSize(document) {
    var body = document.body;
    var documentElement = document.documentElement;
    if (!body || !documentElement) throw new Error('');
    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
    return new $33c5d61f9dccd214$var$Bounds(0, 0, width, height);
};
var $33c5d61f9dccd214$var$parsePathForBorder = module.exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
    switch(borderSide){
        case $33c5d61f9dccd214$var$TOP:
            return $33c5d61f9dccd214$var$createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
        case $33c5d61f9dccd214$var$RIGHT:
            return $33c5d61f9dccd214$var$createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
        case $33c5d61f9dccd214$var$BOTTOM:
            return $33c5d61f9dccd214$var$createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
        case $33c5d61f9dccd214$var$LEFT:
        default:
            return $33c5d61f9dccd214$var$createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
    }
};
var $33c5d61f9dccd214$var$createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
    var path = [];
    if (outer1 instanceof $33c5d61f9dccd214$var$_BezierCurve2.default) path.push(outer1.subdivide(0.5, false));
    else path.push(outer1);
    if (outer2 instanceof $33c5d61f9dccd214$var$_BezierCurve2.default) path.push(outer2.subdivide(0.5, true));
    else path.push(outer2);
    if (inner2 instanceof $33c5d61f9dccd214$var$_BezierCurve2.default) path.push(inner2.subdivide(0.5, true).reverse());
    else path.push(inner2);
    if (inner1 instanceof $33c5d61f9dccd214$var$_BezierCurve2.default) path.push(inner1.subdivide(0.5, false).reverse());
    else path.push(inner1);
    return path;
};
var $33c5d61f9dccd214$var$calculateBorderBoxPath = module.exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
    return [
        curves.topLeftOuter,
        curves.topRightOuter,
        curves.bottomRightOuter,
        curves.bottomLeftOuter
    ];
};
var $33c5d61f9dccd214$var$calculatePaddingBoxPath = module.exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
    return [
        curves.topLeftInner,
        curves.topRightInner,
        curves.bottomRightInner,
        curves.bottomLeftInner
    ];
};
var $33c5d61f9dccd214$var$parseBoundCurves = module.exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
    var tlh = borderRadius[$33c5d61f9dccd214$var$CORNER.TOP_LEFT][$33c5d61f9dccd214$var$H].getAbsoluteValue(bounds.width);
    var tlv = borderRadius[$33c5d61f9dccd214$var$CORNER.TOP_LEFT][$33c5d61f9dccd214$var$V].getAbsoluteValue(bounds.height);
    var trh = borderRadius[$33c5d61f9dccd214$var$CORNER.TOP_RIGHT][$33c5d61f9dccd214$var$H].getAbsoluteValue(bounds.width);
    var trv = borderRadius[$33c5d61f9dccd214$var$CORNER.TOP_RIGHT][$33c5d61f9dccd214$var$V].getAbsoluteValue(bounds.height);
    var brh = borderRadius[$33c5d61f9dccd214$var$CORNER.BOTTOM_RIGHT][$33c5d61f9dccd214$var$H].getAbsoluteValue(bounds.width);
    var brv = borderRadius[$33c5d61f9dccd214$var$CORNER.BOTTOM_RIGHT][$33c5d61f9dccd214$var$V].getAbsoluteValue(bounds.height);
    var blh = borderRadius[$33c5d61f9dccd214$var$CORNER.BOTTOM_LEFT][$33c5d61f9dccd214$var$H].getAbsoluteValue(bounds.width);
    var blv = borderRadius[$33c5d61f9dccd214$var$CORNER.BOTTOM_LEFT][$33c5d61f9dccd214$var$V].getAbsoluteValue(bounds.height);
    var factors = [];
    factors.push((tlh + trh) / bounds.width);
    factors.push((blh + brh) / bounds.width);
    factors.push((tlv + blv) / bounds.height);
    factors.push((trv + brv) / bounds.height);
    var maxFactor = Math.max.apply(Math, factors);
    if (maxFactor > 1) {
        tlh /= maxFactor;
        tlv /= maxFactor;
        trh /= maxFactor;
        trv /= maxFactor;
        brh /= maxFactor;
        brv /= maxFactor;
        blh /= maxFactor;
        blv /= maxFactor;
    }
    var topWidth = bounds.width - trh;
    var rightHeight = bounds.height - brv;
    var bottomWidth = bounds.width - brh;
    var leftHeight = bounds.height - blv;
    return {
        topLeftOuter: tlh > 0 || tlv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left, bounds.top, tlh, tlv, $33c5d61f9dccd214$var$CORNER.TOP_LEFT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left, bounds.top),
        topLeftInner: tlh > 0 || tlv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + borders[$33c5d61f9dccd214$var$TOP].borderWidth, Math.max(0, tlh - borders[$33c5d61f9dccd214$var$LEFT].borderWidth), Math.max(0, tlv - borders[$33c5d61f9dccd214$var$TOP].borderWidth), $33c5d61f9dccd214$var$CORNER.TOP_LEFT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + borders[$33c5d61f9dccd214$var$TOP].borderWidth),
        topRightOuter: trh > 0 || trv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, $33c5d61f9dccd214$var$CORNER.TOP_RIGHT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + bounds.width, bounds.top),
        topRightInner: trh > 0 || trv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[$33c5d61f9dccd214$var$LEFT].borderWidth), bounds.top + borders[$33c5d61f9dccd214$var$TOP].borderWidth, topWidth > bounds.width + borders[$33c5d61f9dccd214$var$LEFT].borderWidth ? 0 : trh - borders[$33c5d61f9dccd214$var$LEFT].borderWidth, trv - borders[$33c5d61f9dccd214$var$TOP].borderWidth, $33c5d61f9dccd214$var$CORNER.TOP_RIGHT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + bounds.width - borders[$33c5d61f9dccd214$var$RIGHT].borderWidth, bounds.top + borders[$33c5d61f9dccd214$var$TOP].borderWidth),
        bottomRightOuter: brh > 0 || brv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, $33c5d61f9dccd214$var$CORNER.BOTTOM_RIGHT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
        bottomRightInner: brh > 0 || brv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[$33c5d61f9dccd214$var$LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[$33c5d61f9dccd214$var$TOP].borderWidth), Math.max(0, brh - borders[$33c5d61f9dccd214$var$RIGHT].borderWidth), brv - borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth, $33c5d61f9dccd214$var$CORNER.BOTTOM_RIGHT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + bounds.width - borders[$33c5d61f9dccd214$var$RIGHT].borderWidth, bounds.top + bounds.height - borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth),
        bottomLeftOuter: blh > 0 || blv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, $33c5d61f9dccd214$var$CORNER.BOTTOM_LEFT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left, bounds.top + bounds.height),
        bottomLeftInner: blh > 0 || blv > 0 ? $33c5d61f9dccd214$var$getCurvePoints(bounds.left + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[$33c5d61f9dccd214$var$LEFT].borderWidth), blv - borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth, $33c5d61f9dccd214$var$CORNER.BOTTOM_LEFT) : new $33c5d61f9dccd214$var$_Vector2.default(bounds.left + borders[$33c5d61f9dccd214$var$LEFT].borderWidth, bounds.top + bounds.height - borders[$33c5d61f9dccd214$var$BOTTOM].borderWidth)
    };
};
var $33c5d61f9dccd214$var$CORNER = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 2,
    BOTTOM_LEFT: 3
};
var $33c5d61f9dccd214$var$getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = r1 * kappa; // control point offset horizontal
    var oy = r2 * kappa; // control point offset vertical
    var xm = x + r1; // x-middle
    var ym = y + r2; // y-middle
    switch(position){
        case $33c5d61f9dccd214$var$CORNER.TOP_LEFT:
            return new $33c5d61f9dccd214$var$_BezierCurve2.default(new $33c5d61f9dccd214$var$_Vector2.default(x, ym), new $33c5d61f9dccd214$var$_Vector2.default(x, ym - oy), new $33c5d61f9dccd214$var$_Vector2.default(xm - ox, y), new $33c5d61f9dccd214$var$_Vector2.default(xm, y));
        case $33c5d61f9dccd214$var$CORNER.TOP_RIGHT:
            return new $33c5d61f9dccd214$var$_BezierCurve2.default(new $33c5d61f9dccd214$var$_Vector2.default(x, y), new $33c5d61f9dccd214$var$_Vector2.default(x + ox, y), new $33c5d61f9dccd214$var$_Vector2.default(xm, ym - oy), new $33c5d61f9dccd214$var$_Vector2.default(xm, ym));
        case $33c5d61f9dccd214$var$CORNER.BOTTOM_RIGHT:
            return new $33c5d61f9dccd214$var$_BezierCurve2.default(new $33c5d61f9dccd214$var$_Vector2.default(xm, y), new $33c5d61f9dccd214$var$_Vector2.default(xm, y + oy), new $33c5d61f9dccd214$var$_Vector2.default(x + ox, ym), new $33c5d61f9dccd214$var$_Vector2.default(x, ym));
        case $33c5d61f9dccd214$var$CORNER.BOTTOM_LEFT:
        default:
            return new $33c5d61f9dccd214$var$_BezierCurve2.default(new $33c5d61f9dccd214$var$_Vector2.default(xm, ym), new $33c5d61f9dccd214$var$_Vector2.default(xm - ox, ym), new $33c5d61f9dccd214$var$_Vector2.default(x, y + oy), new $33c5d61f9dccd214$var$_Vector2.default(x, y));
    }
};

});
parcelRegister("f0RUS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $aee0adc1fb4e909e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $kRg2K = parcelRequire("kRg2K");

var $cQg28 = parcelRequire("cQg28");
var $aee0adc1fb4e909e$var$_Vector2 = $aee0adc1fb4e909e$var$_interopRequireDefault($cQg28);
function $aee0adc1fb4e909e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aee0adc1fb4e909e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $aee0adc1fb4e909e$var$lerp = function lerp(a, b, t) {
    return new $aee0adc1fb4e909e$var$_Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
};
var $aee0adc1fb4e909e$var$BezierCurve = function() {
    function BezierCurve(start, startControl, endControl, end) {
        $aee0adc1fb4e909e$var$_classCallCheck(this, BezierCurve);
        this.type = $kRg2K.PATH.BEZIER_CURVE;
        this.start = start;
        this.startControl = startControl;
        this.endControl = endControl;
        this.end = end;
    }
    $aee0adc1fb4e909e$var$_createClass(BezierCurve, [
        {
            key: 'subdivide',
            value: function subdivide(t, firstHalf) {
                var ab = $aee0adc1fb4e909e$var$lerp(this.start, this.startControl, t);
                var bc = $aee0adc1fb4e909e$var$lerp(this.startControl, this.endControl, t);
                var cd = $aee0adc1fb4e909e$var$lerp(this.endControl, this.end, t);
                var abbc = $aee0adc1fb4e909e$var$lerp(ab, bc, t);
                var bccd = $aee0adc1fb4e909e$var$lerp(bc, cd, t);
                var dest = $aee0adc1fb4e909e$var$lerp(abbc, bccd, t);
                return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
            }
        },
        {
            key: 'reverse',
            value: function reverse() {
                return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
            }
        }
    ]);
    return BezierCurve;
}();
module.exports.default = $aee0adc1fb4e909e$var$BezierCurve;

});


parcelRegister("guqDy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parsePadding = module.exports.PADDING_SIDES = undefined;

var $iAhLp = parcelRequire("iAhLp");
var $c0141c3cbb5a8e17$var$_Length2 = $c0141c3cbb5a8e17$var$_interopRequireDefault($iAhLp);
function $c0141c3cbb5a8e17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c0141c3cbb5a8e17$var$PADDING_SIDES = module.exports.PADDING_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};
var $c0141c3cbb5a8e17$var$SIDES = [
    'top',
    'right',
    'bottom',
    'left'
];
var $c0141c3cbb5a8e17$var$parsePadding = module.exports.parsePadding = function parsePadding(style) {
    return $c0141c3cbb5a8e17$var$SIDES.map(function(side) {
        return new $c0141c3cbb5a8e17$var$_Length2.default(style.getPropertyValue('padding-' + side));
    });
};

});


parcelRegister("gIYuc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBorder = module.exports.BORDER_SIDES = module.exports.BORDER_STYLE = undefined;

var $gO3cU = parcelRequire("gO3cU");
var $c2cfacabb405face$var$_Color2 = $c2cfacabb405face$var$_interopRequireDefault($gO3cU);
function $c2cfacabb405face$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c2cfacabb405face$var$BORDER_STYLE = module.exports.BORDER_STYLE = {
    NONE: 0,
    SOLID: 1
};
var $c2cfacabb405face$var$BORDER_SIDES = module.exports.BORDER_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};
var $c2cfacabb405face$var$SIDES = Object.keys($c2cfacabb405face$var$BORDER_SIDES).map(function(s) {
    return s.toLowerCase();
});
var $c2cfacabb405face$var$parseBorderStyle = function parseBorderStyle(style) {
    switch(style){
        case 'none':
            return $c2cfacabb405face$var$BORDER_STYLE.NONE;
    }
    return $c2cfacabb405face$var$BORDER_STYLE.SOLID;
};
var $c2cfacabb405face$var$parseBorder = module.exports.parseBorder = function parseBorder(style) {
    return $c2cfacabb405face$var$SIDES.map(function(side) {
        var borderColor = new $c2cfacabb405face$var$_Color2.default(style.getPropertyValue('border-' + side + '-color'));
        var borderStyle = $c2cfacabb405face$var$parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
        return {
            borderColor: borderColor,
            borderStyle: borderStyle,
            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
        };
    });
};

});

parcelRegister("78dPR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBorderRadius = undefined;
var $5314032dd86501d6$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $iAhLp = parcelRequire("iAhLp");
var $5314032dd86501d6$var$_Length2 = $5314032dd86501d6$var$_interopRequireDefault($iAhLp);
function $5314032dd86501d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5314032dd86501d6$var$SIDES = [
    'top-left',
    'top-right',
    'bottom-right',
    'bottom-left'
];
var $5314032dd86501d6$var$parseBorderRadius = module.exports.parseBorderRadius = function parseBorderRadius(style) {
    return $5314032dd86501d6$var$SIDES.map(function(side) {
        var value = style.getPropertyValue('border-' + side + '-radius');
        var _value$split$map = value.split(' ').map($5314032dd86501d6$var$_Length2.default.create), _value$split$map2 = $5314032dd86501d6$var$_slicedToArray(_value$split$map, 2), horizontal = _value$split$map2[0], vertical = _value$split$map2[1];
        return typeof vertical === 'undefined' ? [
            horizontal,
            horizontal
        ] : [
            horizontal,
            vertical
        ];
    });
};

});

parcelRegister("cijur", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8f3648c73895ccb7$var$DISPLAY = module.exports.DISPLAY = {
    NONE: 1,
    BLOCK: 2,
    INLINE: 4,
    RUN_IN: 8,
    FLOW: 16,
    FLOW_ROOT: 32,
    TABLE: 64,
    FLEX: 128,
    GRID: 256,
    RUBY: 512,
    SUBGRID: 1024,
    LIST_ITEM: 2048,
    TABLE_ROW_GROUP: 4096,
    TABLE_HEADER_GROUP: 8192,
    TABLE_FOOTER_GROUP: 16384,
    TABLE_ROW: 32768,
    TABLE_CELL: 65536,
    TABLE_COLUMN_GROUP: 131072,
    TABLE_COLUMN: 262144,
    TABLE_CAPTION: 524288,
    RUBY_BASE: 1048576,
    RUBY_TEXT: 2097152,
    RUBY_BASE_CONTAINER: 4194304,
    RUBY_TEXT_CONTAINER: 8388608,
    CONTENTS: 16777216,
    INLINE_BLOCK: 33554432,
    INLINE_LIST_ITEM: 67108864,
    INLINE_TABLE: 134217728,
    INLINE_FLEX: 268435456,
    INLINE_GRID: 536870912
};
var $8f3648c73895ccb7$var$parseDisplayValue = function parseDisplayValue(display) {
    switch(display){
        case 'block':
            return $8f3648c73895ccb7$var$DISPLAY.BLOCK;
        case 'inline':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE;
        case 'run-in':
            return $8f3648c73895ccb7$var$DISPLAY.RUN_IN;
        case 'flow':
            return $8f3648c73895ccb7$var$DISPLAY.FLOW;
        case 'flow-root':
            return $8f3648c73895ccb7$var$DISPLAY.FLOW_ROOT;
        case 'table':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE;
        case 'flex':
            return $8f3648c73895ccb7$var$DISPLAY.FLEX;
        case 'grid':
            return $8f3648c73895ccb7$var$DISPLAY.GRID;
        case 'ruby':
            return $8f3648c73895ccb7$var$DISPLAY.RUBY;
        case 'subgrid':
            return $8f3648c73895ccb7$var$DISPLAY.SUBGRID;
        case 'list-item':
            return $8f3648c73895ccb7$var$DISPLAY.LIST_ITEM;
        case 'table-row-group':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_ROW_GROUP;
        case 'table-header-group':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_HEADER_GROUP;
        case 'table-footer-group':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_FOOTER_GROUP;
        case 'table-row':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_ROW;
        case 'table-cell':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_CELL;
        case 'table-column-group':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_COLUMN_GROUP;
        case 'table-column':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_COLUMN;
        case 'table-caption':
            return $8f3648c73895ccb7$var$DISPLAY.TABLE_CAPTION;
        case 'ruby-base':
            return $8f3648c73895ccb7$var$DISPLAY.RUBY_BASE;
        case 'ruby-text':
            return $8f3648c73895ccb7$var$DISPLAY.RUBY_TEXT;
        case 'ruby-base-container':
            return $8f3648c73895ccb7$var$DISPLAY.RUBY_BASE_CONTAINER;
        case 'ruby-text-container':
            return $8f3648c73895ccb7$var$DISPLAY.RUBY_TEXT_CONTAINER;
        case 'contents':
            return $8f3648c73895ccb7$var$DISPLAY.CONTENTS;
        case 'inline-block':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE_BLOCK;
        case 'inline-list-item':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE_LIST_ITEM;
        case 'inline-table':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE_TABLE;
        case 'inline-flex':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE_FLEX;
        case 'inline-grid':
            return $8f3648c73895ccb7$var$DISPLAY.INLINE_GRID;
    }
    return $8f3648c73895ccb7$var$DISPLAY.NONE;
};
var $8f3648c73895ccb7$var$setDisplayBit = function setDisplayBit(bit, display) {
    return bit | $8f3648c73895ccb7$var$parseDisplayValue(display);
};
var $8f3648c73895ccb7$var$parseDisplay = module.exports.parseDisplay = function parseDisplay(display) {
    return display.split(' ').reduce($8f3648c73895ccb7$var$setDisplayBit, 0);
};

});

parcelRegister("6w3Lw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4be8a6fc3b1eeb8a$var$FLOAT = module.exports.FLOAT = {
    NONE: 0,
    LEFT: 1,
    RIGHT: 2,
    INLINE_START: 3,
    INLINE_END: 4
};
var $4be8a6fc3b1eeb8a$var$parseCSSFloat = module.exports.parseCSSFloat = function parseCSSFloat(float) {
    switch(float){
        case 'left':
            return $4be8a6fc3b1eeb8a$var$FLOAT.LEFT;
        case 'right':
            return $4be8a6fc3b1eeb8a$var$FLOAT.RIGHT;
        case 'inline-start':
            return $4be8a6fc3b1eeb8a$var$FLOAT.INLINE_START;
        case 'inline-end':
            return $4be8a6fc3b1eeb8a$var$FLOAT.INLINE_END;
    }
    return $4be8a6fc3b1eeb8a$var$FLOAT.NONE;
};

});

parcelRegister("f3WrI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $af7478fe19d72545$var$parseFontWeight = function parseFontWeight(weight) {
    switch(weight){
        case 'normal':
            return 400;
        case 'bold':
            return 700;
    }
    var value = parseInt(weight, 10);
    return isNaN(value) ? 400 : value;
};
var $af7478fe19d72545$var$parseFont = module.exports.parseFont = function parseFont(style) {
    var fontFamily = style.fontFamily;
    var fontSize = style.fontSize;
    var fontStyle = style.fontStyle;
    var fontVariant = style.fontVariant;
    var fontWeight = $af7478fe19d72545$var$parseFontWeight(style.fontWeight);
    return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight
    };
};

});

parcelRegister("h7pd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c766a51a0bba6ee6$var$parseLetterSpacing = module.exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
    if (letterSpacing === 'normal') return 0;
    var value = parseFloat(letterSpacing);
    return isNaN(value) ? 0 : value;
};

});

parcelRegister("aWgAn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7f6c2fc290f60aa3$var$LINE_BREAK = module.exports.LINE_BREAK = {
    NORMAL: 'normal',
    STRICT: 'strict'
};
var $7f6c2fc290f60aa3$var$parseLineBreak = module.exports.parseLineBreak = function parseLineBreak(wordBreak) {
    switch(wordBreak){
        case 'strict':
            return $7f6c2fc290f60aa3$var$LINE_BREAK.STRICT;
        case 'normal':
        default:
            return $7f6c2fc290f60aa3$var$LINE_BREAK.NORMAL;
    }
};

});

parcelRegister("dcmux", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseListStyle = module.exports.parseListStyleType = module.exports.LIST_STYLE_TYPE = module.exports.LIST_STYLE_POSITION = undefined;

var $6vPZX = parcelRequire("6vPZX");
var $99bdd7aec40b1bf4$var$LIST_STYLE_POSITION = module.exports.LIST_STYLE_POSITION = {
    INSIDE: 0,
    OUTSIDE: 1
};
var $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE = module.exports.LIST_STYLE_TYPE = {
    NONE: -1,
    DISC: 0,
    CIRCLE: 1,
    SQUARE: 2,
    DECIMAL: 3,
    CJK_DECIMAL: 4,
    DECIMAL_LEADING_ZERO: 5,
    LOWER_ROMAN: 6,
    UPPER_ROMAN: 7,
    LOWER_GREEK: 8,
    LOWER_ALPHA: 9,
    UPPER_ALPHA: 10,
    ARABIC_INDIC: 11,
    ARMENIAN: 12,
    BENGALI: 13,
    CAMBODIAN: 14,
    CJK_EARTHLY_BRANCH: 15,
    CJK_HEAVENLY_STEM: 16,
    CJK_IDEOGRAPHIC: 17,
    DEVANAGARI: 18,
    ETHIOPIC_NUMERIC: 19,
    GEORGIAN: 20,
    GUJARATI: 21,
    GURMUKHI: 22,
    HEBREW: 22,
    HIRAGANA: 23,
    HIRAGANA_IROHA: 24,
    JAPANESE_FORMAL: 25,
    JAPANESE_INFORMAL: 26,
    KANNADA: 27,
    KATAKANA: 28,
    KATAKANA_IROHA: 29,
    KHMER: 30,
    KOREAN_HANGUL_FORMAL: 31,
    KOREAN_HANJA_FORMAL: 32,
    KOREAN_HANJA_INFORMAL: 33,
    LAO: 34,
    LOWER_ARMENIAN: 35,
    MALAYALAM: 36,
    MONGOLIAN: 37,
    MYANMAR: 38,
    ORIYA: 39,
    PERSIAN: 40,
    SIMP_CHINESE_FORMAL: 41,
    SIMP_CHINESE_INFORMAL: 42,
    TAMIL: 43,
    TELUGU: 44,
    THAI: 45,
    TIBETAN: 46,
    TRAD_CHINESE_FORMAL: 47,
    TRAD_CHINESE_INFORMAL: 48,
    UPPER_ARMENIAN: 49,
    DISCLOSURE_OPEN: 50,
    DISCLOSURE_CLOSED: 51
};
var $99bdd7aec40b1bf4$var$parseListStyleType = module.exports.parseListStyleType = function parseListStyleType(type) {
    switch(type){
        case 'disc':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DISC;
        case 'circle':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CIRCLE;
        case 'square':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.SQUARE;
        case 'decimal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DECIMAL;
        case 'cjk-decimal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CJK_DECIMAL;
        case 'decimal-leading-zero':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
        case 'lower-roman':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.LOWER_ROMAN;
        case 'upper-roman':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.UPPER_ROMAN;
        case 'lower-greek':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.LOWER_GREEK;
        case 'lower-alpha':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.LOWER_ALPHA;
        case 'upper-alpha':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.UPPER_ALPHA;
        case 'arabic-indic':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.ARABIC_INDIC;
        case 'armenian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.ARMENIAN;
        case 'bengali':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.BENGALI;
        case 'cambodian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CAMBODIAN;
        case 'cjk-earthly-branch':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
        case 'cjk-heavenly-stem':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
        case 'cjk-ideographic':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
        case 'devanagari':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DEVANAGARI;
        case 'ethiopic-numeric':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
        case 'georgian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.GEORGIAN;
        case 'gujarati':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.GUJARATI;
        case 'gurmukhi':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.GURMUKHI;
        case 'hebrew':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.HEBREW;
        case 'hiragana':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.HIRAGANA;
        case 'hiragana-iroha':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.HIRAGANA_IROHA;
        case 'japanese-formal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.JAPANESE_FORMAL;
        case 'japanese-informal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.JAPANESE_INFORMAL;
        case 'kannada':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KANNADA;
        case 'katakana':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KATAKANA;
        case 'katakana-iroha':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KATAKANA_IROHA;
        case 'khmer':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KHMER;
        case 'korean-hangul-formal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
        case 'korean-hanja-formal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
        case 'korean-hanja-informal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
        case 'lao':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.LAO;
        case 'lower-armenian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.LOWER_ARMENIAN;
        case 'malayalam':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.MALAYALAM;
        case 'mongolian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.MONGOLIAN;
        case 'myanmar':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.MYANMAR;
        case 'oriya':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.ORIYA;
        case 'persian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.PERSIAN;
        case 'simp-chinese-formal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
        case 'simp-chinese-informal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
        case 'tamil':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.TAMIL;
        case 'telugu':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.TELUGU;
        case 'thai':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.THAI;
        case 'tibetan':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.TIBETAN;
        case 'trad-chinese-formal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
        case 'trad-chinese-informal':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
        case 'upper-armenian':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.UPPER_ARMENIAN;
        case 'disclosure-open':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DISCLOSURE_OPEN;
        case 'disclosure-closed':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
        case 'none':
        default:
            return $99bdd7aec40b1bf4$var$LIST_STYLE_TYPE.NONE;
    }
};
var $99bdd7aec40b1bf4$var$parseListStyle = module.exports.parseListStyle = function parseListStyle(style) {
    var listStyleImage = (0, $6vPZX.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
    return {
        listStyleType: $99bdd7aec40b1bf4$var$parseListStyleType(style.getPropertyValue('list-style-type')),
        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
        listStylePosition: $99bdd7aec40b1bf4$var$parseListStylePosition(style.getPropertyValue('list-style-position'))
    };
};
var $99bdd7aec40b1bf4$var$parseListStylePosition = function parseListStylePosition(position) {
    switch(position){
        case 'inside':
            return $99bdd7aec40b1bf4$var$LIST_STYLE_POSITION.INSIDE;
        case 'outside':
        default:
            return $99bdd7aec40b1bf4$var$LIST_STYLE_POSITION.OUTSIDE;
    }
};

});

parcelRegister("gTsRU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseMargin = undefined;

var $iAhLp = parcelRequire("iAhLp");
var $c4c82d11d4f5210c$var$_Length2 = $c4c82d11d4f5210c$var$_interopRequireDefault($iAhLp);
function $c4c82d11d4f5210c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c4c82d11d4f5210c$var$SIDES = [
    'top',
    'right',
    'bottom',
    'left'
];
var $c4c82d11d4f5210c$var$parseMargin = module.exports.parseMargin = function parseMargin(style) {
    return $c4c82d11d4f5210c$var$SIDES.map(function(side) {
        return new $c4c82d11d4f5210c$var$_Length2.default(style.getPropertyValue('margin-' + side));
    });
};

});

parcelRegister("hOOLZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cf8e7daa902cc829$var$OVERFLOW = module.exports.OVERFLOW = {
    VISIBLE: 0,
    HIDDEN: 1,
    SCROLL: 2,
    AUTO: 3
};
var $cf8e7daa902cc829$var$parseOverflow = module.exports.parseOverflow = function parseOverflow(overflow) {
    switch(overflow){
        case 'hidden':
            return $cf8e7daa902cc829$var$OVERFLOW.HIDDEN;
        case 'scroll':
            return $cf8e7daa902cc829$var$OVERFLOW.SCROLL;
        case 'auto':
            return $cf8e7daa902cc829$var$OVERFLOW.AUTO;
        case 'visible':
        default:
            return $cf8e7daa902cc829$var$OVERFLOW.VISIBLE;
    }
};

});

parcelRegister("aazPo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7676a140168ddd7f$var$OVERFLOW_WRAP = module.exports.OVERFLOW_WRAP = {
    NORMAL: 0,
    BREAK_WORD: 1
};
var $7676a140168ddd7f$var$parseOverflowWrap = module.exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
    switch(overflow){
        case 'break-word':
            return $7676a140168ddd7f$var$OVERFLOW_WRAP.BREAK_WORD;
        case 'normal':
        default:
            return $7676a140168ddd7f$var$OVERFLOW_WRAP.NORMAL;
    }
};

});

parcelRegister("kqVyv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ee02e1b27d53b967$var$POSITION = module.exports.POSITION = {
    STATIC: 0,
    RELATIVE: 1,
    ABSOLUTE: 2,
    FIXED: 3,
    STICKY: 4
};
var $ee02e1b27d53b967$var$parsePosition = module.exports.parsePosition = function parsePosition(position) {
    switch(position){
        case 'relative':
            return $ee02e1b27d53b967$var$POSITION.RELATIVE;
        case 'absolute':
            return $ee02e1b27d53b967$var$POSITION.ABSOLUTE;
        case 'fixed':
            return $ee02e1b27d53b967$var$POSITION.FIXED;
        case 'sticky':
            return $ee02e1b27d53b967$var$POSITION.STICKY;
    }
    return $ee02e1b27d53b967$var$POSITION.STATIC;
};

});

parcelRegister("aFCU7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTextShadow = undefined;

var $gO3cU = parcelRequire("gO3cU");
var $7c4be94a743647b5$var$_Color2 = $7c4be94a743647b5$var$_interopRequireDefault($gO3cU);
function $7c4be94a743647b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7c4be94a743647b5$var$NUMBER = /^([+-]|\d|\.)$/i;
var $7c4be94a743647b5$var$parseTextShadow = module.exports.parseTextShadow = function parseTextShadow(textShadow) {
    if (textShadow === 'none' || typeof textShadow !== 'string') return null;
    var currentValue = '';
    var isLength = false;
    var values = [];
    var shadows = [];
    var numParens = 0;
    var color = null;
    var appendValue = function appendValue() {
        if (currentValue.length) {
            if (isLength) values.push(parseFloat(currentValue));
            else color = new $7c4be94a743647b5$var$_Color2.default(currentValue);
        }
        isLength = false;
        currentValue = '';
    };
    var appendShadow = function appendShadow() {
        if (values.length && color !== null) shadows.push({
            color: color,
            offsetX: values[0] || 0,
            offsetY: values[1] || 0,
            blur: values[2] || 0
        });
        values.splice(0, values.length);
        color = null;
    };
    for(var i = 0; i < textShadow.length; i++){
        var c = textShadow[i];
        switch(c){
            case '(':
                currentValue += c;
                numParens++;
                break;
            case ')':
                currentValue += c;
                numParens--;
                break;
            case ',':
                if (numParens === 0) {
                    appendValue();
                    appendShadow();
                } else currentValue += c;
                break;
            case ' ':
                if (numParens === 0) appendValue();
                else currentValue += c;
                break;
            default:
                if (currentValue.length === 0 && $7c4be94a743647b5$var$NUMBER.test(c)) isLength = true;
                currentValue += c;
        }
    }
    appendValue();
    appendShadow();
    if (shadows.length === 0) return null;
    return shadows;
};

});

parcelRegister("41mZw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2ed9170661888eb2$var$TEXT_TRANSFORM = module.exports.TEXT_TRANSFORM = {
    NONE: 0,
    LOWERCASE: 1,
    UPPERCASE: 2,
    CAPITALIZE: 3
};
var $2ed9170661888eb2$var$parseTextTransform = module.exports.parseTextTransform = function parseTextTransform(textTransform) {
    switch(textTransform){
        case 'uppercase':
            return $2ed9170661888eb2$var$TEXT_TRANSFORM.UPPERCASE;
        case 'lowercase':
            return $2ed9170661888eb2$var$TEXT_TRANSFORM.LOWERCASE;
        case 'capitalize':
            return $2ed9170661888eb2$var$TEXT_TRANSFORM.CAPITALIZE;
    }
    return $2ed9170661888eb2$var$TEXT_TRANSFORM.NONE;
};

});

parcelRegister("a56z5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTransform = undefined;

var $iAhLp = parcelRequire("iAhLp");
var $756f76ac568ed0c1$var$_Length2 = $756f76ac568ed0c1$var$_interopRequireDefault($iAhLp);
function $756f76ac568ed0c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $756f76ac568ed0c1$var$toFloat = function toFloat(s) {
    return parseFloat(s.trim());
};
var $756f76ac568ed0c1$var$MATRIX = /(matrix|matrix3d)\((.+)\)/;
var $756f76ac568ed0c1$var$parseTransform = module.exports.parseTransform = function parseTransform(style) {
    var transform = $756f76ac568ed0c1$var$parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform || // $FlowFixMe
    style.msTransform || // $FlowFixMe
    style.oTransform);
    if (transform === null) return null;
    return {
        transform: transform,
        transformOrigin: $756f76ac568ed0c1$var$parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin || // $FlowFixMe
        style.msTransformOrigin || // $FlowFixMe
        style.oTransformOrigin)
    };
};
// $FlowFixMe
var $756f76ac568ed0c1$var$parseTransformOrigin = function parseTransformOrigin(origin) {
    if (typeof origin !== 'string') {
        var v = new $756f76ac568ed0c1$var$_Length2.default('0');
        return [
            v,
            v
        ];
    }
    var values = origin.split(' ').map($756f76ac568ed0c1$var$_Length2.default.create);
    return [
        values[0],
        values[1]
    ];
};
// $FlowFixMe
var $756f76ac568ed0c1$var$parseTransformMatrix = function parseTransformMatrix(transform) {
    if (transform === 'none' || typeof transform !== 'string') return null;
    var match = transform.match($756f76ac568ed0c1$var$MATRIX);
    if (match) {
        if (match[1] === 'matrix') {
            var matrix = match[2].split(',').map($756f76ac568ed0c1$var$toFloat);
            return [
                matrix[0],
                matrix[1],
                matrix[2],
                matrix[3],
                matrix[4],
                matrix[5]
            ];
        } else {
            var matrix3d = match[2].split(',').map($756f76ac568ed0c1$var$toFloat);
            return [
                matrix3d[0],
                matrix3d[1],
                matrix3d[4],
                matrix3d[5],
                matrix3d[12],
                matrix3d[13]
            ];
        }
    }
    return null;
};

});

parcelRegister("bmVVz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $846eaf016ff2bcd0$var$VISIBILITY = module.exports.VISIBILITY = {
    VISIBLE: 0,
    HIDDEN: 1,
    COLLAPSE: 2
};
var $846eaf016ff2bcd0$var$parseVisibility = module.exports.parseVisibility = function parseVisibility(visibility) {
    switch(visibility){
        case 'hidden':
            return $846eaf016ff2bcd0$var$VISIBILITY.HIDDEN;
        case 'collapse':
            return $846eaf016ff2bcd0$var$VISIBILITY.COLLAPSE;
        case 'visible':
        default:
            return $846eaf016ff2bcd0$var$VISIBILITY.VISIBLE;
    }
};

});

parcelRegister("a6ZTh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $75ca7916a43dafc7$var$WORD_BREAK = module.exports.WORD_BREAK = {
    NORMAL: 'normal',
    BREAK_ALL: 'break-all',
    KEEP_ALL: 'keep-all'
};
var $75ca7916a43dafc7$var$parseWordBreak = module.exports.parseWordBreak = function parseWordBreak(wordBreak) {
    switch(wordBreak){
        case 'break-all':
            return $75ca7916a43dafc7$var$WORD_BREAK.BREAK_ALL;
        case 'keep-all':
            return $75ca7916a43dafc7$var$WORD_BREAK.KEEP_ALL;
        case 'normal':
        default:
            return $75ca7916a43dafc7$var$WORD_BREAK.NORMAL;
    }
};

});

parcelRegister("dTMxH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a1e610edbae9fc52$var$parseZIndex = module.exports.parseZIndex = function parseZIndex(zIndex) {
    var auto = zIndex === 'auto';
    return {
        auto: auto,
        order: auto ? 0 : parseInt(zIndex, 10)
    };
};

});

parcelRegister("6UpLb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reformatInputBounds = module.exports.inlineSelectElement = module.exports.inlineTextAreaElement = module.exports.inlineInputElement = module.exports.getInputBorderRadius = module.exports.INPUT_BACKGROUND = module.exports.INPUT_BORDERS = module.exports.INPUT_COLOR = undefined;

var $l5O3X = parcelRequire("l5O3X");
var $507bf477f9e3917a$var$_TextContainer2 = $507bf477f9e3917a$var$_interopRequireDefault($l5O3X);

var $6vPZX = parcelRequire("6vPZX");

var $gIYuc = parcelRequire("gIYuc");

var $bzx79 = parcelRequire("bzx79");
var $507bf477f9e3917a$var$_Circle2 = $507bf477f9e3917a$var$_interopRequireDefault($bzx79);

var $cQg28 = parcelRequire("cQg28");
var $507bf477f9e3917a$var$_Vector2 = $507bf477f9e3917a$var$_interopRequireDefault($cQg28);

var $gO3cU = parcelRequire("gO3cU");
var $507bf477f9e3917a$var$_Color2 = $507bf477f9e3917a$var$_interopRequireDefault($gO3cU);

var $iAhLp = parcelRequire("iAhLp");
var $507bf477f9e3917a$var$_Length2 = $507bf477f9e3917a$var$_interopRequireDefault($iAhLp);
parcelRequire("4rAif");
parcelRequire("bQxc3");

var $j1biG = parcelRequire("j1biG");
function $507bf477f9e3917a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $507bf477f9e3917a$var$INPUT_COLOR = module.exports.INPUT_COLOR = new $507bf477f9e3917a$var$_Color2.default([
    42,
    42,
    42
]);
var $507bf477f9e3917a$var$INPUT_BORDER_COLOR = new $507bf477f9e3917a$var$_Color2.default([
    165,
    165,
    165
]);
var $507bf477f9e3917a$var$INPUT_BACKGROUND_COLOR = new $507bf477f9e3917a$var$_Color2.default([
    222,
    222,
    222
]);
var $507bf477f9e3917a$var$INPUT_BORDER = {
    borderWidth: 1,
    borderColor: $507bf477f9e3917a$var$INPUT_BORDER_COLOR,
    borderStyle: $gIYuc.BORDER_STYLE.SOLID
};
var $507bf477f9e3917a$var$INPUT_BORDERS = module.exports.INPUT_BORDERS = [
    $507bf477f9e3917a$var$INPUT_BORDER,
    $507bf477f9e3917a$var$INPUT_BORDER,
    $507bf477f9e3917a$var$INPUT_BORDER,
    $507bf477f9e3917a$var$INPUT_BORDER
];
var $507bf477f9e3917a$var$INPUT_BACKGROUND = module.exports.INPUT_BACKGROUND = {
    backgroundColor: $507bf477f9e3917a$var$INPUT_BACKGROUND_COLOR,
    backgroundImage: [],
    backgroundClip: $6vPZX.BACKGROUND_CLIP.PADDING_BOX,
    backgroundOrigin: $6vPZX.BACKGROUND_ORIGIN.PADDING_BOX
};
var $507bf477f9e3917a$var$RADIO_BORDER_RADIUS = new $507bf477f9e3917a$var$_Length2.default('50%');
var $507bf477f9e3917a$var$RADIO_BORDER_RADIUS_TUPLE = [
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS,
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS
];
var $507bf477f9e3917a$var$INPUT_RADIO_BORDER_RADIUS = [
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$RADIO_BORDER_RADIUS_TUPLE
];
var $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS = new $507bf477f9e3917a$var$_Length2.default('3px');
var $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS_TUPLE = [
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS,
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS
];
var $507bf477f9e3917a$var$INPUT_CHECKBOX_BORDER_RADIUS = [
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS_TUPLE,
    $507bf477f9e3917a$var$CHECKBOX_BORDER_RADIUS_TUPLE
];
var $507bf477f9e3917a$var$getInputBorderRadius = module.exports.getInputBorderRadius = function getInputBorderRadius(node) {
    return node.type === 'radio' ? $507bf477f9e3917a$var$INPUT_RADIO_BORDER_RADIUS : $507bf477f9e3917a$var$INPUT_CHECKBOX_BORDER_RADIUS;
};
var $507bf477f9e3917a$var$inlineInputElement = module.exports.inlineInputElement = function inlineInputElement(node, container) {
    if (node.type === 'radio' || node.type === 'checkbox') {
        if (node.checked) {
            var size = Math.min(container.bounds.width, container.bounds.height);
            container.childNodes.push(node.type === 'checkbox' ? [
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                new $507bf477f9e3917a$var$_Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
            ] : new $507bf477f9e3917a$var$_Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
        }
    } else $507bf477f9e3917a$var$inlineFormElement($507bf477f9e3917a$var$getInputValue(node), node, container, false);
};
var $507bf477f9e3917a$var$inlineTextAreaElement = module.exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
    $507bf477f9e3917a$var$inlineFormElement(node.value, node, container, true);
};
var $507bf477f9e3917a$var$inlineSelectElement = module.exports.inlineSelectElement = function inlineSelectElement(node, container) {
    var option = node.options[node.selectedIndex || 0];
    $507bf477f9e3917a$var$inlineFormElement(option ? option.text || '' : '', node, container, false);
};
var $507bf477f9e3917a$var$reformatInputBounds = module.exports.reformatInputBounds = function reformatInputBounds(bounds) {
    if (bounds.width > bounds.height) {
        bounds.left += (bounds.width - bounds.height) / 2;
        bounds.width = bounds.height;
    } else if (bounds.width < bounds.height) {
        bounds.top += (bounds.height - bounds.width) / 2;
        bounds.height = bounds.width;
    }
    return bounds;
};
var $507bf477f9e3917a$var$inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
    var body = node.ownerDocument.body;
    if (value.length > 0 && body) {
        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
        (0, $j1biG.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
        wrapper.style.position = 'absolute';
        wrapper.style.left = container.bounds.left + 'px';
        wrapper.style.top = container.bounds.top + 'px';
        if (!allowLinebreak) wrapper.style.whiteSpace = 'nowrap';
        var text = node.ownerDocument.createTextNode(value);
        wrapper.appendChild(text);
        body.appendChild(wrapper);
        container.childNodes.push($507bf477f9e3917a$var$_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    }
};
var $507bf477f9e3917a$var$getInputValue = function getInputValue(node) {
    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;
    return value.length === 0 ? node.placeholder || '' : value;
};

});
parcelRegister("l5O3X", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f5b0e605b490e1df$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $41mZw = parcelRequire("41mZw");

var $bQxc3 = parcelRequire("bQxc3");
function $f5b0e605b490e1df$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $f5b0e605b490e1df$var$TextContainer = function() {
    function TextContainer(text, parent, bounds) {
        $f5b0e605b490e1df$var$_classCallCheck(this, TextContainer);
        this.text = text;
        this.parent = parent;
        this.bounds = bounds;
    }
    $f5b0e605b490e1df$var$_createClass(TextContainer, null, [
        {
            key: 'fromTextNode',
            value: function fromTextNode(node, parent) {
                var text = $f5b0e605b490e1df$var$transform(node.data, parent.style.textTransform);
                return new TextContainer(text, parent, (0, $bQxc3.parseTextBounds)(text, parent, node));
            }
        }
    ]);
    return TextContainer;
}();
module.exports.default = $f5b0e605b490e1df$var$TextContainer;
var $f5b0e605b490e1df$var$CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
var $f5b0e605b490e1df$var$transform = function transform(text, _transform) {
    switch(_transform){
        case $41mZw.TEXT_TRANSFORM.LOWERCASE:
            return text.toLowerCase();
        case $41mZw.TEXT_TRANSFORM.CAPITALIZE:
            return text.replace($f5b0e605b490e1df$var$CAPITALIZE, $f5b0e605b490e1df$var$capitalize);
        case $41mZw.TEXT_TRANSFORM.UPPERCASE:
            return text.toUpperCase();
        default:
            return text;
    }
};
function $f5b0e605b490e1df$var$capitalize(m, p1, p2) {
    if (m.length > 0) return p1 + p2.toUpperCase();
    return m;
}

});
parcelRegister("bQxc3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTextBounds = module.exports.TextBounds = undefined;

var $4rAif = parcelRequire("4rAif");

var $dPsAk = parcelRequire("dPsAk");

var $2ivfO = parcelRequire("2ivfO");
var $89fe4c8c93086fc1$var$_Feature2 = $89fe4c8c93086fc1$var$_interopRequireDefault($2ivfO);

var $4gxoB = parcelRequire("4gxoB");
function $89fe4c8c93086fc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89fe4c8c93086fc1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $89fe4c8c93086fc1$var$TextBounds = module.exports.TextBounds = function TextBounds(text, bounds) {
    $89fe4c8c93086fc1$var$_classCallCheck(this, TextBounds);
    this.text = text;
    this.bounds = bounds;
};
var $89fe4c8c93086fc1$var$parseTextBounds = module.exports.parseTextBounds = function parseTextBounds(value, parent, node) {
    var letterRendering = parent.style.letterSpacing !== 0;
    var textList = letterRendering ? (0, $4gxoB.toCodePoints)(value).map(function(i) {
        return (0, $4gxoB.fromCodePoint)(i);
    }) : (0, $4gxoB.breakWords)(value, parent);
    var length = textList.length;
    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
    var scrollX = defaultView ? defaultView.pageXOffset : 0;
    var scrollY = defaultView ? defaultView.pageYOffset : 0;
    var textBounds = [];
    var offset = 0;
    for(var i = 0; i < length; i++){
        var text = textList[i];
        if (parent.style.textDecoration !== $dPsAk.TEXT_DECORATION.NONE || text.trim().length > 0) {
            if ($89fe4c8c93086fc1$var$_Feature2.default.SUPPORT_RANGE_BOUNDS) textBounds.push(new $89fe4c8c93086fc1$var$TextBounds(text, $89fe4c8c93086fc1$var$getRangeBounds(node, offset, text.length, scrollX, scrollY)));
            else {
                var replacementNode = node.splitText(text.length);
                textBounds.push(new $89fe4c8c93086fc1$var$TextBounds(text, $89fe4c8c93086fc1$var$getWrapperBounds(node, scrollX, scrollY)));
                node = replacementNode;
            }
        } else if (!$89fe4c8c93086fc1$var$_Feature2.default.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
        offset += text.length;
    }
    return textBounds;
};
var $89fe4c8c93086fc1$var$getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    wrapper.appendChild(node.cloneNode(true));
    var parentNode = node.parentNode;
    if (parentNode) {
        parentNode.replaceChild(wrapper, node);
        var bounds = (0, $4rAif.parseBounds)(wrapper, scrollX, scrollY);
        if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
        return bounds;
    }
    return new $4rAif.Bounds(0, 0, 0, 0);
};
var $89fe4c8c93086fc1$var$getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
    var range = node.ownerDocument.createRange();
    range.setStart(node, offset);
    range.setEnd(node, offset + length);
    return $4rAif.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
};

});
parcelRegister("2ivfO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eHkeh = parcelRequire("eHkeh");
var $1ac5819e5677cc64$var$testRangeBounds = function testRangeBounds(document1) {
    var TEST_HEIGHT = 123;
    if (document1.createRange) {
        var range = document1.createRange();
        if (range.getBoundingClientRect) {
            var testElement = document1.createElement('boundtest');
            testElement.style.height = TEST_HEIGHT + 'px';
            testElement.style.display = 'block';
            document1.body.appendChild(testElement);
            range.selectNode(testElement);
            var rangeBounds = range.getBoundingClientRect();
            var rangeHeight = Math.round(rangeBounds.height);
            document1.body.removeChild(testElement);
            if (rangeHeight === TEST_HEIGHT) return true;
        }
    }
    return false;
};
// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
var $1ac5819e5677cc64$var$testBase64 = function testBase64(document1, src) {
    var img = new Image();
    var canvas = document1.createElement('canvas');
    var ctx = canvas.getContext('2d');
    return new Promise(function(resolve) {
        // Single pixel base64 image renders fine on iOS 10.3???
        img.src = src;
        var onload = function onload() {
            try {
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL();
            } catch (e) {
                return resolve(false);
            }
            return resolve(true);
        };
        img.onload = onload;
        img.onerror = function() {
            return resolve(false);
        };
        if (img.complete === true) setTimeout(function() {
            onload();
        }, 500);
    });
};
var $1ac5819e5677cc64$var$testCORS = function testCORS() {
    return typeof new Image().crossOrigin !== 'undefined';
};
var $1ac5819e5677cc64$var$testResponseType = function testResponseType() {
    return typeof new XMLHttpRequest().responseType === 'string';
};
var $1ac5819e5677cc64$var$testSVG = function testSVG(document1) {
    var img = new Image();
    var canvas = document1.createElement('canvas');
    var ctx = canvas.getContext('2d');
    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';
    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch (e) {
        return false;
    }
    return true;
};
var $1ac5819e5677cc64$var$isGreenPixel = function isGreenPixel(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};
var $1ac5819e5677cc64$var$testForeignObject = function testForeignObject(document1) {
    var canvas = document1.createElement('canvas');
    var size = 100;
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgb(0, 255, 0)';
    ctx.fillRect(0, 0, size, size);
    var img = new Image();
    var greenImageSrc = canvas.toDataURL();
    img.src = greenImageSrc;
    var svg = (0, $eHkeh.createForeignObjectSVG)(size, size, 0, 0, img);
    ctx.fillStyle = 'red';
    ctx.fillRect(0, 0, size, size);
    return (0, $eHkeh.loadSerializedSVG)(svg).then(function(img) {
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, size, size).data;
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        var node = document1.createElement('div');
        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
        node.style.height = size + 'px';
        // Firefox 55 does not render inline <img /> tags
        return $1ac5819e5677cc64$var$isGreenPixel(data) ? (0, $eHkeh.loadSerializedSVG)((0, $eHkeh.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
    }).then(function(img) {
        ctx.drawImage(img, 0, 0);
        // Edge does not render background-images
        return $1ac5819e5677cc64$var$isGreenPixel(ctx.getImageData(0, 0, size, size).data);
    }).catch(function(e) {
        return false;
    });
};
var $1ac5819e5677cc64$var$FEATURES = {
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RANGE_BOUNDS () {
        'use strict';
        var value = $1ac5819e5677cc64$var$testRangeBounds(document);
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_RANGE_BOUNDS', {
            value: value
        });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_SVG_DRAWING () {
        'use strict';
        var value1 = $1ac5819e5677cc64$var$testSVG(document);
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_SVG_DRAWING', {
            value: value1
        });
        return value1;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_BASE64_DRAWING () {
        'use strict';
        return function(src) {
            var _value = $1ac5819e5677cc64$var$testBase64(document, src);
            Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_BASE64_DRAWING', {
                value: function value() {
                    return _value;
                }
            });
            return _value;
        };
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_FOREIGNOBJECT_DRAWING () {
        'use strict';
        var value2 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? $1ac5819e5677cc64$var$testForeignObject(document) : Promise.resolve(false);
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
            value: value2
        });
        return value2;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_IMAGES () {
        'use strict';
        var value3 = $1ac5819e5677cc64$var$testCORS();
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_CORS_IMAGES', {
            value: value3
        });
        return value3;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RESPONSE_TYPE () {
        'use strict';
        var value4 = $1ac5819e5677cc64$var$testResponseType();
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_RESPONSE_TYPE', {
            value: value4
        });
        return value4;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_XHR () {
        'use strict';
        var value5 = 'withCredentials' in new XMLHttpRequest();
        Object.defineProperty($1ac5819e5677cc64$var$FEATURES, 'SUPPORT_CORS_XHR', {
            value: value5
        });
        return value5;
    }
};
module.exports.default = $1ac5819e5677cc64$var$FEATURES;

});
parcelRegister("eHkeh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ab34c5f6db3d9f4b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $ab34c5f6db3d9f4b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ab34c5f6db3d9f4b$var$ForeignObjectRenderer = function() {
    function ForeignObjectRenderer(element) {
        $ab34c5f6db3d9f4b$var$_classCallCheck(this, ForeignObjectRenderer);
        this.element = element;
    }
    $ab34c5f6db3d9f4b$var$_createClass(ForeignObjectRenderer, [
        {
            key: 'render',
            value: function render(options) {
                var _this = this;
                this.options = options;
                this.canvas = document.createElement('canvas');
                this.ctx = this.canvas.getContext('2d');
                this.canvas.width = Math.floor(options.width) * options.scale;
                this.canvas.height = Math.floor(options.height) * options.scale;
                this.canvas.style.width = options.width + 'px';
                this.canvas.style.height = options.height + 'px';
                options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
                var svg = $ab34c5f6db3d9f4b$var$createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);
                return $ab34c5f6db3d9f4b$var$loadSerializedSVG(svg).then(function(img) {
                    if (options.backgroundColor) {
                        _this.ctx.fillStyle = options.backgroundColor.toString();
                        _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
                    }
                    _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
                    return _this.canvas;
                });
            }
        }
    ]);
    return ForeignObjectRenderer;
}();
module.exports.default = $ab34c5f6db3d9f4b$var$ForeignObjectRenderer;
var $ab34c5f6db3d9f4b$var$createForeignObjectSVG = module.exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
    var xmlns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(xmlns, 'svg');
    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttributeNS(null, 'width', width);
    svg.setAttributeNS(null, 'height', height);
    foreignObject.setAttributeNS(null, 'width', '100%');
    foreignObject.setAttributeNS(null, 'height', '100%');
    foreignObject.setAttributeNS(null, 'x', x);
    foreignObject.setAttributeNS(null, 'y', y);
    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return svg;
};
var $ab34c5f6db3d9f4b$var$loadSerializedSVG = module.exports.loadSerializedSVG = function loadSerializedSVG(svg) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
    });
};

});


parcelRegister("4gxoB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakWords = module.exports.fromCodePoint = module.exports.toCodePoints = undefined;

var $bnwo0 = parcelRequire("bnwo0");
Object.defineProperty(module.exports, 'toCodePoints', {
    enumerable: true,
    get: function get() {
        return $bnwo0.toCodePoints;
    }
});
Object.defineProperty(module.exports, 'fromCodePoint', {
    enumerable: true,
    get: function get() {
        return $bnwo0.fromCodePoint;
    }
});

var $6RJQM = parcelRequire("6RJQM");
var $31b28fbfe43e8d14$var$_NodeContainer2 = $31b28fbfe43e8d14$var$_interopRequireDefault($6RJQM);

var $aazPo = parcelRequire("aazPo");
function $31b28fbfe43e8d14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31b28fbfe43e8d14$var$breakWords = module.exports.breakWords = function breakWords(str, parent) {
    var breaker = (0, $bnwo0.LineBreaker)(str, {
        lineBreak: parent.style.lineBreak,
        wordBreak: parent.style.overflowWrap === $aazPo.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
    });
    var words = [];
    var bk = void 0;
    while(!(bk = breaker.next()).done)words.push(bk.value.slice());
    return words;
};

});
parcelRegister("bnwo0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fHw1e = parcelRequire("fHw1e");
Object.defineProperty(module.exports, 'toCodePoints', {
    enumerable: true,
    get: function get() {
        return $fHw1e.toCodePoints;
    }
});
Object.defineProperty(module.exports, 'fromCodePoint', {
    enumerable: true,
    get: function get() {
        return $fHw1e.fromCodePoint;
    }
});

var $1jomV = parcelRequire("1jomV");
Object.defineProperty(module.exports, 'LineBreaker', {
    enumerable: true,
    get: function get() {
        return $1jomV.LineBreaker;
    }
});

});
parcelRegister("fHw1e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b6e3b57018480df8$var$toCodePoints = module.exports.toCodePoints = function toCodePoints(str) {
    var codePoints = [];
    var i = 0;
    var length = str.length;
    while(i < length){
        var value = str.charCodeAt(i++);
        if (value >= 0xd800 && value <= 0xdbff && i < length) {
            var extra = str.charCodeAt(i++);
            if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
            else {
                codePoints.push(value);
                i--;
            }
        } else codePoints.push(value);
    }
    return codePoints;
};
var $b6e3b57018480df8$var$fromCodePoint = module.exports.fromCodePoint = function fromCodePoint() {
    if (String.fromCodePoint) return String.fromCodePoint.apply(String, arguments);
    var length = arguments.length;
    if (!length) return '';
    var codeUnits = [];
    var index = -1;
    var result = '';
    while(++index < length){
        var codePoint = arguments.length <= index ? undefined : arguments[index];
        if (codePoint <= 0xffff) codeUnits.push(codePoint);
        else {
            codePoint -= 0x10000;
            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
        }
        if (index + 1 === length || codeUnits.length > 0x4000) {
            result += String.fromCharCode.apply(String, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result;
};
var $b6e3b57018480df8$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $b6e3b57018480df8$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $b6e3b57018480df8$var$i = 0; $b6e3b57018480df8$var$i < $b6e3b57018480df8$var$chars.length; $b6e3b57018480df8$var$i++)$b6e3b57018480df8$var$lookup[$b6e3b57018480df8$var$chars.charCodeAt($b6e3b57018480df8$var$i)] = $b6e3b57018480df8$var$i;
var $b6e3b57018480df8$var$decode = module.exports.decode = function decode(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i = void 0, p = 0, encoded1 = void 0, encoded2 = void 0, encoded3 = void 0, encoded4 = void 0;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $b6e3b57018480df8$var$lookup[base64.charCodeAt(i)];
        encoded2 = $b6e3b57018480df8$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $b6e3b57018480df8$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $b6e3b57018480df8$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
};
var $b6e3b57018480df8$var$polyUint16Array = module.exports.polyUint16Array = function polyUint16Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var _i = 0; _i < length; _i += 2)bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
    return bytes;
};
var $b6e3b57018480df8$var$polyUint32Array = module.exports.polyUint32Array = function polyUint32Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for(var _i2 = 0; _i2 < length; _i2 += 4)bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
    return bytes;
};

});

parcelRegister("1jomV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LineBreaker = module.exports.inlineBreakOpportunities = module.exports.lineBreakAtIndex = module.exports.codePointsToCharacterClasses = module.exports.UnicodeTrie = module.exports.BREAK_ALLOWED = module.exports.BREAK_NOT_ALLOWED = module.exports.BREAK_MANDATORY = module.exports.classes = module.exports.LETTER_NUMBER_MODIFIER = undefined;
var $0f4a77eaee471d90$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $0f4a77eaee471d90$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $2Mstu = parcelRequire("2Mstu");

var $dHs8d = parcelRequire("dHs8d");
var $0f4a77eaee471d90$var$_linebreakTrie2 = $0f4a77eaee471d90$var$_interopRequireDefault($dHs8d);

var $fHw1e = parcelRequire("fHw1e");
function $0f4a77eaee471d90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0f4a77eaee471d90$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $0f4a77eaee471d90$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0f4a77eaee471d90$var$LETTER_NUMBER_MODIFIER = module.exports.LETTER_NUMBER_MODIFIER = 50;
// Non-tailorable Line Breaking Classes
var $0f4a77eaee471d90$var$BK = 1; //  Cause a line break (after)
var $0f4a77eaee471d90$var$CR = 2; //  Cause a line break (after), except between CR and LF
var $0f4a77eaee471d90$var$LF = 3; //  Cause a line break (after)
var $0f4a77eaee471d90$var$CM = 4; //  Prohibit a line break between the character and the preceding character
var $0f4a77eaee471d90$var$NL = 5; //  Cause a line break (after)
var $0f4a77eaee471d90$var$SG = 6; //  Do not occur in well-formed text
var $0f4a77eaee471d90$var$WJ = 7; //  Prohibit line breaks before and after
var $0f4a77eaee471d90$var$ZW = 8; //  Provide a break opportunity
var $0f4a77eaee471d90$var$GL = 9; //  Prohibit line breaks before and after
var $0f4a77eaee471d90$var$SP = 10; // Enable indirect line breaks
var $0f4a77eaee471d90$var$ZWJ = 11; // Prohibit line breaks within joiner sequences
// Break Opportunities
var $0f4a77eaee471d90$var$B2 = 12; //  Provide a line break opportunity before and after the character
var $0f4a77eaee471d90$var$BA = 13; //  Generally provide a line break opportunity after the character
var $0f4a77eaee471d90$var$BB = 14; //  Generally provide a line break opportunity before the character
var $0f4a77eaee471d90$var$HY = 15; //  Provide a line break opportunity after the character, except in numeric context
var $0f4a77eaee471d90$var$CB = 16; //   Provide a line break opportunity contingent on additional information
// Characters Prohibiting Certain Breaks
var $0f4a77eaee471d90$var$CL = 17; //  Prohibit line breaks before
var $0f4a77eaee471d90$var$CP = 18; //  Prohibit line breaks before
var $0f4a77eaee471d90$var$EX = 19; //  Prohibit line breaks before
var $0f4a77eaee471d90$var$IN = 20; //  Allow only indirect line breaks between pairs
var $0f4a77eaee471d90$var$NS = 21; //  Allow only indirect line breaks before
var $0f4a77eaee471d90$var$OP = 22; //  Prohibit line breaks after
var $0f4a77eaee471d90$var$QU = 23; //  Act like they are both opening and closing
// Numeric Context
var $0f4a77eaee471d90$var$IS = 24; //  Prevent breaks after any and before numeric
var $0f4a77eaee471d90$var$NU = 25; //  Form numeric expressions for line breaking purposes
var $0f4a77eaee471d90$var$PO = 26; //  Do not break following a numeric expression
var $0f4a77eaee471d90$var$PR = 27; //  Do not break in front of a numeric expression
var $0f4a77eaee471d90$var$SY = 28; //  Prevent a break before; and allow a break after
// Other Characters
var $0f4a77eaee471d90$var$AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
var $0f4a77eaee471d90$var$AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
var $0f4a77eaee471d90$var$CJ = 31; //  Treat as NS or ID for strict or normal breaking.
var $0f4a77eaee471d90$var$EB = 32; //  Do not break from following Emoji Modifier
var $0f4a77eaee471d90$var$EM = 33; //  Do not break from preceding Emoji Base
var $0f4a77eaee471d90$var$H2 = 34; //  Form Korean syllable blocks
var $0f4a77eaee471d90$var$H3 = 35; //  Form Korean syllable blocks
var $0f4a77eaee471d90$var$HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
var $0f4a77eaee471d90$var$ID = 37; //  Break before or after; except in some numeric context
var $0f4a77eaee471d90$var$JL = 38; //  Form Korean syllable blocks
var $0f4a77eaee471d90$var$JV = 39; //  Form Korean syllable blocks
var $0f4a77eaee471d90$var$JT = 40; //  Form Korean syllable blocks
var $0f4a77eaee471d90$var$RI = 41; //  Keep pairs together. For pairs; break before and after other classes
var $0f4a77eaee471d90$var$SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
var $0f4a77eaee471d90$var$XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
var $0f4a77eaee471d90$var$classes = module.exports.classes = {
    BK: $0f4a77eaee471d90$var$BK,
    CR: $0f4a77eaee471d90$var$CR,
    LF: $0f4a77eaee471d90$var$LF,
    CM: $0f4a77eaee471d90$var$CM,
    NL: $0f4a77eaee471d90$var$NL,
    SG: $0f4a77eaee471d90$var$SG,
    WJ: $0f4a77eaee471d90$var$WJ,
    ZW: $0f4a77eaee471d90$var$ZW,
    GL: $0f4a77eaee471d90$var$GL,
    SP: $0f4a77eaee471d90$var$SP,
    ZWJ: $0f4a77eaee471d90$var$ZWJ,
    B2: $0f4a77eaee471d90$var$B2,
    BA: $0f4a77eaee471d90$var$BA,
    BB: $0f4a77eaee471d90$var$BB,
    HY: $0f4a77eaee471d90$var$HY,
    CB: $0f4a77eaee471d90$var$CB,
    CL: $0f4a77eaee471d90$var$CL,
    CP: $0f4a77eaee471d90$var$CP,
    EX: $0f4a77eaee471d90$var$EX,
    IN: $0f4a77eaee471d90$var$IN,
    NS: $0f4a77eaee471d90$var$NS,
    OP: $0f4a77eaee471d90$var$OP,
    QU: $0f4a77eaee471d90$var$QU,
    IS: $0f4a77eaee471d90$var$IS,
    NU: $0f4a77eaee471d90$var$NU,
    PO: $0f4a77eaee471d90$var$PO,
    PR: $0f4a77eaee471d90$var$PR,
    SY: $0f4a77eaee471d90$var$SY,
    AI: $0f4a77eaee471d90$var$AI,
    AL: $0f4a77eaee471d90$var$AL,
    CJ: $0f4a77eaee471d90$var$CJ,
    EB: $0f4a77eaee471d90$var$EB,
    EM: $0f4a77eaee471d90$var$EM,
    H2: $0f4a77eaee471d90$var$H2,
    H3: $0f4a77eaee471d90$var$H3,
    HL: $0f4a77eaee471d90$var$HL,
    ID: $0f4a77eaee471d90$var$ID,
    JL: $0f4a77eaee471d90$var$JL,
    JV: $0f4a77eaee471d90$var$JV,
    JT: $0f4a77eaee471d90$var$JT,
    RI: $0f4a77eaee471d90$var$RI,
    SA: $0f4a77eaee471d90$var$SA,
    XX: $0f4a77eaee471d90$var$XX
};
var $0f4a77eaee471d90$var$BREAK_MANDATORY = module.exports.BREAK_MANDATORY = '!';
var $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED = module.exports.BREAK_NOT_ALLOWED = "\xd7";
var $0f4a77eaee471d90$var$BREAK_ALLOWED = module.exports.BREAK_ALLOWED = "\xf7";
var $0f4a77eaee471d90$var$UnicodeTrie = module.exports.UnicodeTrie = (0, $2Mstu.createTrieFromBase64)($0f4a77eaee471d90$var$_linebreakTrie2.default);
var $0f4a77eaee471d90$var$ALPHABETICS = [
    $0f4a77eaee471d90$var$AL,
    $0f4a77eaee471d90$var$HL
];
var $0f4a77eaee471d90$var$HARD_LINE_BREAKS = [
    $0f4a77eaee471d90$var$BK,
    $0f4a77eaee471d90$var$CR,
    $0f4a77eaee471d90$var$LF,
    $0f4a77eaee471d90$var$NL
];
var $0f4a77eaee471d90$var$SPACE = [
    $0f4a77eaee471d90$var$SP,
    $0f4a77eaee471d90$var$ZW
];
var $0f4a77eaee471d90$var$PREFIX_POSTFIX = [
    $0f4a77eaee471d90$var$PR,
    $0f4a77eaee471d90$var$PO
];
var $0f4a77eaee471d90$var$LINE_BREAKS = $0f4a77eaee471d90$var$HARD_LINE_BREAKS.concat($0f4a77eaee471d90$var$SPACE);
var $0f4a77eaee471d90$var$KOREAN_SYLLABLE_BLOCK = [
    $0f4a77eaee471d90$var$JL,
    $0f4a77eaee471d90$var$JV,
    $0f4a77eaee471d90$var$JT,
    $0f4a77eaee471d90$var$H2,
    $0f4a77eaee471d90$var$H3
];
var $0f4a77eaee471d90$var$HYPHEN = [
    $0f4a77eaee471d90$var$HY,
    $0f4a77eaee471d90$var$BA
];
var $0f4a77eaee471d90$var$codePointsToCharacterClasses = module.exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';
    var types = [];
    var indicies = [];
    var categories = [];
    codePoints.forEach(function(codePoint, index) {
        var classType = $0f4a77eaee471d90$var$UnicodeTrie.get(codePoint);
        if (classType > $0f4a77eaee471d90$var$LETTER_NUMBER_MODIFIER) {
            categories.push(true);
            classType -= $0f4a77eaee471d90$var$LETTER_NUMBER_MODIFIER;
        } else categories.push(false);
        if ([
            'normal',
            'auto',
            'loose'
        ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
        {
            if ([
                0x2010,
                0x2013,
                0x301c,
                0x30a0
            ].indexOf(codePoint) !== -1) {
                indicies.push(index);
                return types.push($0f4a77eaee471d90$var$CB);
            }
        }
        if (classType === $0f4a77eaee471d90$var$CM || classType === $0f4a77eaee471d90$var$ZWJ) {
            // LB10 Treat any remaining combining mark or ZWJ as AL.
            if (index === 0) {
                indicies.push(index);
                return types.push($0f4a77eaee471d90$var$AL);
            }
            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
            // the base character in all of the following rules. Treat ZWJ as if it were CM.
            var prev = types[index - 1];
            if ($0f4a77eaee471d90$var$LINE_BREAKS.indexOf(prev) === -1) {
                indicies.push(indicies[index - 1]);
                return types.push(prev);
            }
            indicies.push(index);
            return types.push($0f4a77eaee471d90$var$AL);
        }
        indicies.push(index);
        if (classType === $0f4a77eaee471d90$var$CJ) return types.push(lineBreak === 'strict' ? $0f4a77eaee471d90$var$NS : $0f4a77eaee471d90$var$ID);
        if (classType === $0f4a77eaee471d90$var$SA) return types.push($0f4a77eaee471d90$var$AL);
        if (classType === $0f4a77eaee471d90$var$AI) return types.push($0f4a77eaee471d90$var$AL);
        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
        // to take into account the actual line breaking properties for these characters.
        if (classType === $0f4a77eaee471d90$var$XX) {
            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push($0f4a77eaee471d90$var$ID);
            else return types.push($0f4a77eaee471d90$var$AL);
        }
        types.push(classType);
    });
    return [
        indicies,
        types,
        categories
    ];
};
var $0f4a77eaee471d90$var$isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
    var current = classTypes[currentIndex];
    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
        var i = currentIndex;
        while(i <= classTypes.length){
            i++;
            var next = classTypes[i];
            if (next === b) return true;
            if (next !== $0f4a77eaee471d90$var$SP) break;
        }
    }
    if (current === $0f4a77eaee471d90$var$SP) {
        var _i = currentIndex;
        while(_i > 0){
            _i--;
            var prev = classTypes[_i];
            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                var n = currentIndex;
                while(n <= classTypes.length){
                    n++;
                    var _next = classTypes[n];
                    if (_next === b) return true;
                    if (_next !== $0f4a77eaee471d90$var$SP) break;
                }
            }
            if (prev !== $0f4a77eaee471d90$var$SP) break;
        }
    }
    return false;
};
var $0f4a77eaee471d90$var$previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
    var i = currentIndex;
    while(i >= 0){
        var type = classTypes[i];
        if (type === $0f4a77eaee471d90$var$SP) i--;
        else return type;
    }
    return 0;
};
var $0f4a77eaee471d90$var$_lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
    if (indicies[index] === 0) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    var currentIndex = index - 1;
    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    var beforeIndex = currentIndex - 1;
    var afterIndex = currentIndex + 1;
    var current = classTypes[currentIndex];
    // LB4 Always break after hard line breaks.
    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
    var next = classTypes[afterIndex];
    if (current === $0f4a77eaee471d90$var$CR && next === $0f4a77eaee471d90$var$LF) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    if ($0f4a77eaee471d90$var$HARD_LINE_BREAKS.indexOf(current) !== -1) return $0f4a77eaee471d90$var$BREAK_MANDATORY;
    // LB6 Do not break before hard line breaks.
    if ($0f4a77eaee471d90$var$HARD_LINE_BREAKS.indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB7 Do not break before spaces or zero width space.
    if ($0f4a77eaee471d90$var$SPACE.indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
    if ($0f4a77eaee471d90$var$previousNonSpaceClassType(currentIndex, classTypes) === $0f4a77eaee471d90$var$ZW) return $0f4a77eaee471d90$var$BREAK_ALLOWED;
    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
    if ($0f4a77eaee471d90$var$UnicodeTrie.get(codePoints[currentIndex]) === $0f4a77eaee471d90$var$ZWJ && (next === $0f4a77eaee471d90$var$ID || next === $0f4a77eaee471d90$var$EB || next === $0f4a77eaee471d90$var$EM)) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB11 Do not break before or after Word joiner and related characters.
    if (current === $0f4a77eaee471d90$var$WJ || next === $0f4a77eaee471d90$var$WJ) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB12 Do not break after NBSP and related characters.
    if (current === $0f4a77eaee471d90$var$GL) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
    if ([
        $0f4a77eaee471d90$var$SP,
        $0f4a77eaee471d90$var$BA,
        $0f4a77eaee471d90$var$HY
    ].indexOf(current) === -1 && next === $0f4a77eaee471d90$var$GL) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
    if ([
        $0f4a77eaee471d90$var$CL,
        $0f4a77eaee471d90$var$CP,
        $0f4a77eaee471d90$var$EX,
        $0f4a77eaee471d90$var$IS,
        $0f4a77eaee471d90$var$SY
    ].indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB14 Do not break after ‘[’, even after spaces.
    if ($0f4a77eaee471d90$var$previousNonSpaceClassType(currentIndex, classTypes) === $0f4a77eaee471d90$var$OP) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB15 Do not break within ‘”[’, even with intervening spaces.
    if ($0f4a77eaee471d90$var$isAdjacentWithSpaceIgnored($0f4a77eaee471d90$var$QU, $0f4a77eaee471d90$var$OP, currentIndex, classTypes)) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
    if ($0f4a77eaee471d90$var$isAdjacentWithSpaceIgnored([
        $0f4a77eaee471d90$var$CL,
        $0f4a77eaee471d90$var$CP
    ], $0f4a77eaee471d90$var$NS, currentIndex, classTypes)) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB17 Do not break within ‘——’, even with intervening spaces.
    if ($0f4a77eaee471d90$var$isAdjacentWithSpaceIgnored($0f4a77eaee471d90$var$B2, $0f4a77eaee471d90$var$B2, currentIndex, classTypes)) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB18 Break after spaces.
    if (current === $0f4a77eaee471d90$var$SP) return $0f4a77eaee471d90$var$BREAK_ALLOWED;
    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
    if (current === $0f4a77eaee471d90$var$QU || next === $0f4a77eaee471d90$var$QU) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB20 Break before and after unresolved CB.
    if (next === $0f4a77eaee471d90$var$CB || current === $0f4a77eaee471d90$var$CB) return $0f4a77eaee471d90$var$BREAK_ALLOWED;
    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
    if ([
        $0f4a77eaee471d90$var$BA,
        $0f4a77eaee471d90$var$HY,
        $0f4a77eaee471d90$var$NS
    ].indexOf(next) !== -1 || current === $0f4a77eaee471d90$var$BB) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB21a Don't break after Hebrew + Hyphen.
    if (before === $0f4a77eaee471d90$var$HL && $0f4a77eaee471d90$var$HYPHEN.indexOf(current) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB21b Don’t break between Solidus and Hebrew letters.
    if (current === $0f4a77eaee471d90$var$SY && next === $0f4a77eaee471d90$var$HL) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
    if (next === $0f4a77eaee471d90$var$IN && $0f4a77eaee471d90$var$ALPHABETICS.concat($0f4a77eaee471d90$var$IN, $0f4a77eaee471d90$var$EX, $0f4a77eaee471d90$var$NU, $0f4a77eaee471d90$var$ID, $0f4a77eaee471d90$var$EB, $0f4a77eaee471d90$var$EM).indexOf(current) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB23 Do not break between digits and letters.
    if ($0f4a77eaee471d90$var$ALPHABETICS.indexOf(next) !== -1 && current === $0f4a77eaee471d90$var$NU || $0f4a77eaee471d90$var$ALPHABETICS.indexOf(current) !== -1 && next === $0f4a77eaee471d90$var$NU) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
    if (current === $0f4a77eaee471d90$var$PR && [
        $0f4a77eaee471d90$var$ID,
        $0f4a77eaee471d90$var$EB,
        $0f4a77eaee471d90$var$EM
    ].indexOf(next) !== -1 || [
        $0f4a77eaee471d90$var$ID,
        $0f4a77eaee471d90$var$EB,
        $0f4a77eaee471d90$var$EM
    ].indexOf(current) !== -1 && next === $0f4a77eaee471d90$var$PO) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
    if ($0f4a77eaee471d90$var$ALPHABETICS.indexOf(current) !== -1 && $0f4a77eaee471d90$var$PREFIX_POSTFIX.indexOf(next) !== -1 || $0f4a77eaee471d90$var$PREFIX_POSTFIX.indexOf(current) !== -1 && $0f4a77eaee471d90$var$ALPHABETICS.indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB25 Do not break between the following pairs of classes relevant to numbers:
    if (// (PR | PO) × ( OP | HY )? NU
    [
        $0f4a77eaee471d90$var$PR,
        $0f4a77eaee471d90$var$PO
    ].indexOf(current) !== -1 && (next === $0f4a77eaee471d90$var$NU || [
        $0f4a77eaee471d90$var$OP,
        $0f4a77eaee471d90$var$HY
    ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === $0f4a77eaee471d90$var$NU) || // ( OP | HY ) × NU
    [
        $0f4a77eaee471d90$var$OP,
        $0f4a77eaee471d90$var$HY
    ].indexOf(current) !== -1 && next === $0f4a77eaee471d90$var$NU || // NU ×	(NU | SY | IS)
    current === $0f4a77eaee471d90$var$NU && [
        $0f4a77eaee471d90$var$NU,
        $0f4a77eaee471d90$var$SY,
        $0f4a77eaee471d90$var$IS
    ].indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
    if ([
        $0f4a77eaee471d90$var$NU,
        $0f4a77eaee471d90$var$SY,
        $0f4a77eaee471d90$var$IS,
        $0f4a77eaee471d90$var$CL,
        $0f4a77eaee471d90$var$CP
    ].indexOf(next) !== -1) {
        var prevIndex = currentIndex;
        while(prevIndex >= 0){
            var type = classTypes[prevIndex];
            if (type === $0f4a77eaee471d90$var$NU) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
            else if ([
                $0f4a77eaee471d90$var$SY,
                $0f4a77eaee471d90$var$IS
            ].indexOf(type) !== -1) prevIndex--;
            else break;
        }
    }
    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
    if ([
        $0f4a77eaee471d90$var$PR,
        $0f4a77eaee471d90$var$PO
    ].indexOf(next) !== -1) {
        var _prevIndex = [
            $0f4a77eaee471d90$var$CL,
            $0f4a77eaee471d90$var$CP
        ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
        while(_prevIndex >= 0){
            var _type = classTypes[_prevIndex];
            if (_type === $0f4a77eaee471d90$var$NU) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
            else if ([
                $0f4a77eaee471d90$var$SY,
                $0f4a77eaee471d90$var$IS
            ].indexOf(_type) !== -1) _prevIndex--;
            else break;
        }
    }
    // LB26 Do not break a Korean syllable.
    if ($0f4a77eaee471d90$var$JL === current && [
        $0f4a77eaee471d90$var$JL,
        $0f4a77eaee471d90$var$JV,
        $0f4a77eaee471d90$var$H2,
        $0f4a77eaee471d90$var$H3
    ].indexOf(next) !== -1 || [
        $0f4a77eaee471d90$var$JV,
        $0f4a77eaee471d90$var$H2
    ].indexOf(current) !== -1 && [
        $0f4a77eaee471d90$var$JV,
        $0f4a77eaee471d90$var$JT
    ].indexOf(next) !== -1 || [
        $0f4a77eaee471d90$var$JT,
        $0f4a77eaee471d90$var$H3
    ].indexOf(current) !== -1 && next === $0f4a77eaee471d90$var$JT) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB27 Treat a Korean Syllable Block the same as ID.
    if ($0f4a77eaee471d90$var$KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
        $0f4a77eaee471d90$var$IN,
        $0f4a77eaee471d90$var$PO
    ].indexOf(next) !== -1 || $0f4a77eaee471d90$var$KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === $0f4a77eaee471d90$var$PR) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB28 Do not break between alphabetics (“at”).
    if ($0f4a77eaee471d90$var$ALPHABETICS.indexOf(current) !== -1 && $0f4a77eaee471d90$var$ALPHABETICS.indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
    if (current === $0f4a77eaee471d90$var$IS && $0f4a77eaee471d90$var$ALPHABETICS.indexOf(next) !== -1) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
    if ($0f4a77eaee471d90$var$ALPHABETICS.concat($0f4a77eaee471d90$var$NU).indexOf(current) !== -1 && next === $0f4a77eaee471d90$var$OP || $0f4a77eaee471d90$var$ALPHABETICS.concat($0f4a77eaee471d90$var$NU).indexOf(next) !== -1 && current === $0f4a77eaee471d90$var$CP) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
    // indicators preceding the position of the break.
    if (current === $0f4a77eaee471d90$var$RI && next === $0f4a77eaee471d90$var$RI) {
        var i = indicies[currentIndex];
        var count = 1;
        while(i > 0){
            i--;
            if (classTypes[i] === $0f4a77eaee471d90$var$RI) count++;
            else break;
        }
        if (count % 2 !== 0) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    }
    // LB30b Do not break between an emoji base and an emoji modifier.
    if (current === $0f4a77eaee471d90$var$EB && next === $0f4a77eaee471d90$var$EM) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    return $0f4a77eaee471d90$var$BREAK_ALLOWED;
};
var $0f4a77eaee471d90$var$lineBreakAtIndex = module.exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
    // LB2 Never break at the start of text.
    if (index === 0) return $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    // LB3 Always break at the end of text.
    if (index >= codePoints.length) return $0f4a77eaee471d90$var$BREAK_MANDATORY;
    var _codePointsToCharacte = $0f4a77eaee471d90$var$codePointsToCharacterClasses(codePoints), _codePointsToCharacte2 = $0f4a77eaee471d90$var$_slicedToArray(_codePointsToCharacte, 2), indicies = _codePointsToCharacte2[0], classTypes = _codePointsToCharacte2[1];
    return $0f4a77eaee471d90$var$_lineBreakAtIndex(codePoints, classTypes, indicies, index);
};
var $0f4a77eaee471d90$var$cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
    if (!options) options = {
        lineBreak: 'normal',
        wordBreak: 'normal'
    };
    var _codePointsToCharacte3 = $0f4a77eaee471d90$var$codePointsToCharacterClasses(codePoints, options.lineBreak), _codePointsToCharacte4 = $0f4a77eaee471d90$var$_slicedToArray(_codePointsToCharacte3, 3), indicies = _codePointsToCharacte4[0], classTypes = _codePointsToCharacte4[1], isLetterNumber = _codePointsToCharacte4[2];
    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
        return [
            $0f4a77eaee471d90$var$NU,
            $0f4a77eaee471d90$var$AL,
            $0f4a77eaee471d90$var$SA
        ].indexOf(type) !== -1 ? $0f4a77eaee471d90$var$ID : type;
    });
    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(isLetterNumber, i) {
        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
    }) : null;
    return [
        indicies,
        classTypes,
        forbiddenBreakpoints
    ];
};
var $0f4a77eaee471d90$var$inlineBreakOpportunities = module.exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
    var codePoints = (0, $fHw1e.toCodePoints)(str);
    var output = $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
    var _cssFormattedClasses = $0f4a77eaee471d90$var$cssFormattedClasses(codePoints, options), _cssFormattedClasses2 = $0f4a77eaee471d90$var$_slicedToArray(_cssFormattedClasses, 3), indicies = _cssFormattedClasses2[0], classTypes = _cssFormattedClasses2[1], forbiddenBreakpoints = _cssFormattedClasses2[2];
    codePoints.forEach(function(codePoint, i) {
        output += (0, $fHw1e.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? $0f4a77eaee471d90$var$BREAK_MANDATORY : $0f4a77eaee471d90$var$_lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
    });
    return output;
};
var $0f4a77eaee471d90$var$Break = function() {
    function Break(codePoints, lineBreak, start, end) {
        $0f4a77eaee471d90$var$_classCallCheck(this, Break);
        this._codePoints = codePoints;
        this.required = lineBreak === $0f4a77eaee471d90$var$BREAK_MANDATORY;
        this.start = start;
        this.end = end;
    }
    $0f4a77eaee471d90$var$_createClass(Break, [
        {
            key: 'slice',
            value: function slice() {
                return $fHw1e.fromCodePoint.apply(undefined, $0f4a77eaee471d90$var$_toConsumableArray(this._codePoints.slice(this.start, this.end)));
            }
        }
    ]);
    return Break;
}();
var $0f4a77eaee471d90$var$LineBreaker = module.exports.LineBreaker = function LineBreaker(str, options) {
    var codePoints = (0, $fHw1e.toCodePoints)(str);
    var _cssFormattedClasses3 = $0f4a77eaee471d90$var$cssFormattedClasses(codePoints, options), _cssFormattedClasses4 = $0f4a77eaee471d90$var$_slicedToArray(_cssFormattedClasses3, 3), indicies = _cssFormattedClasses4[0], classTypes = _cssFormattedClasses4[1], forbiddenBreakpoints = _cssFormattedClasses4[2];
    var length = codePoints.length;
    var lastEnd = 0;
    var nextIndex = 0;
    return {
        next: function next() {
            if (nextIndex >= length) return {
                done: true
            };
            var lineBreak = $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED;
            while(nextIndex < length && (lineBreak = $0f4a77eaee471d90$var$_lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED);
            if (lineBreak !== $0f4a77eaee471d90$var$BREAK_NOT_ALLOWED || nextIndex === length) {
                var value = new $0f4a77eaee471d90$var$Break(codePoints, lineBreak, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return {
                    value: value,
                    done: false
                };
            }
            return {
                done: true
            };
        }
    };
};

});
parcelRegister("2Mstu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trie = module.exports.createTrieFromBase64 = module.exports.UTRIE2_INDEX_2_MASK = module.exports.UTRIE2_INDEX_2_BLOCK_LENGTH = module.exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = module.exports.UTRIE2_INDEX_1_OFFSET = module.exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = module.exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = module.exports.UTRIE2_INDEX_2_BMP_LENGTH = module.exports.UTRIE2_LSCP_INDEX_2_LENGTH = module.exports.UTRIE2_DATA_MASK = module.exports.UTRIE2_DATA_BLOCK_LENGTH = module.exports.UTRIE2_LSCP_INDEX_2_OFFSET = module.exports.UTRIE2_SHIFT_1_2 = module.exports.UTRIE2_INDEX_SHIFT = module.exports.UTRIE2_SHIFT_1 = module.exports.UTRIE2_SHIFT_2 = undefined;
var $206626e98be12057$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $fHw1e = parcelRequire("fHw1e");
function $206626e98be12057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/** Shift size for getting the index-2 table offset. */ var $206626e98be12057$var$UTRIE2_SHIFT_2 = module.exports.UTRIE2_SHIFT_2 = 5;
/** Shift size for getting the index-1 table offset. */ var $206626e98be12057$var$UTRIE2_SHIFT_1 = module.exports.UTRIE2_SHIFT_1 = 11;
/**
 * Shift size for shifting left the index array values.
 * Increases possible data size with 16-bit index values at the cost
 * of compactability.
 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
 */ var $206626e98be12057$var$UTRIE2_INDEX_SHIFT = module.exports.UTRIE2_INDEX_SHIFT = 2;
/**
 * Difference between the two shift sizes,
 * for getting an index-1 offset from an index-2 offset. 6=11-5
 */ var $206626e98be12057$var$UTRIE2_SHIFT_1_2 = module.exports.UTRIE2_SHIFT_1_2 = $206626e98be12057$var$UTRIE2_SHIFT_1 - $206626e98be12057$var$UTRIE2_SHIFT_2;
/**
 * The part of the index-2 table for U+D800..U+DBFF stores values for
 * lead surrogate code _units_ not code _points_.
 * Values for lead surrogate code _points_ are indexed with this portion of the table.
 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
 */ var $206626e98be12057$var$UTRIE2_LSCP_INDEX_2_OFFSET = module.exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> $206626e98be12057$var$UTRIE2_SHIFT_2;
/** Number of entries in a data block. 32=0x20 */ var $206626e98be12057$var$UTRIE2_DATA_BLOCK_LENGTH = module.exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << $206626e98be12057$var$UTRIE2_SHIFT_2;
/** Mask for getting the lower bits for the in-data-block offset. */ var $206626e98be12057$var$UTRIE2_DATA_MASK = module.exports.UTRIE2_DATA_MASK = $206626e98be12057$var$UTRIE2_DATA_BLOCK_LENGTH - 1;
var $206626e98be12057$var$UTRIE2_LSCP_INDEX_2_LENGTH = module.exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> $206626e98be12057$var$UTRIE2_SHIFT_2;
/** Count the lengths of both BMP pieces. 2080=0x820 */ var $206626e98be12057$var$UTRIE2_INDEX_2_BMP_LENGTH = module.exports.UTRIE2_INDEX_2_BMP_LENGTH = $206626e98be12057$var$UTRIE2_LSCP_INDEX_2_OFFSET + $206626e98be12057$var$UTRIE2_LSCP_INDEX_2_LENGTH;
/**
 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
 */ var $206626e98be12057$var$UTRIE2_UTF8_2B_INDEX_2_OFFSET = module.exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = $206626e98be12057$var$UTRIE2_INDEX_2_BMP_LENGTH;
var $206626e98be12057$var$UTRIE2_UTF8_2B_INDEX_2_LENGTH = module.exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
/**
 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
 * Variable length, for code points up to highStart, where the last single-value range starts.
 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
 *
 * The part of the index-2 table for supplementary code points starts
 * after this index-1 table.
 *
 * Both the index-1 table and the following part of the index-2 table
 * are omitted completely if there is only BMP data.
 */ var $206626e98be12057$var$UTRIE2_INDEX_1_OFFSET = module.exports.UTRIE2_INDEX_1_OFFSET = $206626e98be12057$var$UTRIE2_UTF8_2B_INDEX_2_OFFSET + $206626e98be12057$var$UTRIE2_UTF8_2B_INDEX_2_LENGTH;
/**
 * Number of index-1 entries for the BMP. 32=0x20
 * This part of the index-1 table is omitted from the serialized form.
 */ var $206626e98be12057$var$UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = module.exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> $206626e98be12057$var$UTRIE2_SHIFT_1;
/** Number of entries in an index-2 block. 64=0x40 */ var $206626e98be12057$var$UTRIE2_INDEX_2_BLOCK_LENGTH = module.exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << $206626e98be12057$var$UTRIE2_SHIFT_1_2;
/** Mask for getting the lower bits for the in-index-2-block offset. */ var $206626e98be12057$var$UTRIE2_INDEX_2_MASK = module.exports.UTRIE2_INDEX_2_MASK = $206626e98be12057$var$UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
var $206626e98be12057$var$createTrieFromBase64 = module.exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
    var buffer = (0, $fHw1e.decode)(base64);
    var view32 = Array.isArray(buffer) ? (0, $fHw1e.polyUint32Array)(buffer) : new Uint32Array(buffer);
    var view16 = Array.isArray(buffer) ? (0, $fHw1e.polyUint16Array)(buffer) : new Uint16Array(buffer);
    var headerLength = 24;
    var index = view16.slice(headerLength / 2, view32[4] / 2);
    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));
    return new $206626e98be12057$var$Trie(view32[0], view32[1], view32[2], view32[3], index, data);
};
var $206626e98be12057$var$Trie = module.exports.Trie = function() {
    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
        $206626e98be12057$var$_classCallCheck(this, Trie);
        this.initialValue = initialValue;
        this.errorValue = errorValue;
        this.highStart = highStart;
        this.highValueIndex = highValueIndex;
        this.index = index;
        this.data = data;
    }
    /**
     * Get the value for a code point as stored in the Trie.
     *
     * @param codePoint the code point
     * @return the value
     */ $206626e98be12057$var$_createClass(Trie, [
        {
            key: 'get',
            value: function get(codePoint) {
                var ix = void 0;
                if (codePoint >= 0) {
                    if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                        // Ordinary BMP code point, excluding leading surrogates.
                        // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                        // 16 bit data is stored in the index array itself.
                        ix = this.index[codePoint >> $206626e98be12057$var$UTRIE2_SHIFT_2];
                        ix = (ix << $206626e98be12057$var$UTRIE2_INDEX_SHIFT) + (codePoint & $206626e98be12057$var$UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint <= 0xffff) {
                        // Lead Surrogate Code Point.  A Separate index section is stored for
                        // lead surrogate code units and code points.
                        //   The main index has the code unit data.
                        //   For this function, we need the code point data.
                        // Note: this expression could be refactored for slightly improved efficiency, but
                        //       surrogate code points will be so rare in practice that it's not worth it.
                        ix = this.index[$206626e98be12057$var$UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> $206626e98be12057$var$UTRIE2_SHIFT_2)];
                        ix = (ix << $206626e98be12057$var$UTRIE2_INDEX_SHIFT) + (codePoint & $206626e98be12057$var$UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint < this.highStart) {
                        // Supplemental code point, use two-level lookup.
                        ix = $206626e98be12057$var$UTRIE2_INDEX_1_OFFSET - $206626e98be12057$var$UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> $206626e98be12057$var$UTRIE2_SHIFT_1);
                        ix = this.index[ix];
                        ix += codePoint >> $206626e98be12057$var$UTRIE2_SHIFT_2 & $206626e98be12057$var$UTRIE2_INDEX_2_MASK;
                        ix = this.index[ix];
                        ix = (ix << $206626e98be12057$var$UTRIE2_INDEX_SHIFT) + (codePoint & $206626e98be12057$var$UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
                }
                // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
                return this.errorValue;
            }
        }
    ]);
    return Trie;
}();

});

parcelRegister("dHs8d", function(module, exports) {
'use strict';
module.exports = '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';

});






parcelRegister("bzx79", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kRg2K = parcelRequire("kRg2K");
function $86cca66ca9b1d4c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $86cca66ca9b1d4c7$var$Circle = function Circle(x, y, radius) {
    $86cca66ca9b1d4c7$var$_classCallCheck(this, Circle);
    this.type = $kRg2K.PATH.CIRCLE;
    this.x = x;
    this.y = y;
    this.radius = radius;
};
module.exports.default = $86cca66ca9b1d4c7$var$Circle;

});


parcelRegister("8vWh7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCounterText = module.exports.inlineListItemElement = module.exports.getListOwner = undefined;

var $j1biG = parcelRequire("j1biG");

var $6RJQM = parcelRequire("6RJQM");
var $632e6c3302100068$var$_NodeContainer2 = $632e6c3302100068$var$_interopRequireDefault($6RJQM);

var $l5O3X = parcelRequire("l5O3X");
var $632e6c3302100068$var$_TextContainer2 = $632e6c3302100068$var$_interopRequireDefault($l5O3X);

var $dcmux = parcelRequire("dcmux");

var $4gxoB = parcelRequire("4gxoB");
function $632e6c3302100068$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Margin between the enumeration and the list item content
var $632e6c3302100068$var$MARGIN_RIGHT = 7;
var $632e6c3302100068$var$ancestorTypes = [
    'OL',
    'UL',
    'MENU'
];
var $632e6c3302100068$var$getListOwner = module.exports.getListOwner = function getListOwner(container) {
    var parent = container.parent;
    if (!parent) return null;
    do {
        var isAncestor = $632e6c3302100068$var$ancestorTypes.indexOf(parent.tagName) !== -1;
        if (isAncestor) return parent;
        parent = parent.parent;
    }while (parent);
    return container.parent;
};
var $632e6c3302100068$var$inlineListItemElement = module.exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
    var listStyle = container.style.listStyle;
    if (!listStyle) return;
    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    (0, $j1biG.copyCSSStyles)(style, wrapper);
    wrapper.style.position = 'absolute';
    wrapper.style.bottom = 'auto';
    wrapper.style.display = 'block';
    wrapper.style.letterSpacing = 'normal';
    switch(listStyle.listStylePosition){
        case $dcmux.LIST_STYLE_POSITION.OUTSIDE:
            wrapper.style.left = 'auto';
            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + $632e6c3302100068$var$MARGIN_RIGHT + 'px';
            wrapper.style.textAlign = 'right';
            break;
        case $dcmux.LIST_STYLE_POSITION.INSIDE:
            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
            wrapper.style.right = 'auto';
            wrapper.style.textAlign = 'left';
            break;
    }
    var text = void 0;
    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
    var styleImage = listStyle.listStyleImage;
    if (styleImage) {
        if (styleImage.method === 'url') {
            var image = node.ownerDocument.createElement('img');
            image.src = styleImage.args[0];
            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
            wrapper.style.width = 'auto';
            wrapper.style.height = 'auto';
            wrapper.appendChild(image);
        } else {
            var size = parseFloat(container.style.font.fontSize) * 0.5;
            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
            wrapper.style.width = size + 'px';
            wrapper.style.height = size + 'px';
            wrapper.style.backgroundImage = style.listStyleImage;
        }
    } else if (typeof container.listIndex === 'number') {
        text = node.ownerDocument.createTextNode($632e6c3302100068$var$createCounterText(container.listIndex, listStyle.listStyleType, true));
        wrapper.appendChild(text);
        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
    }
    // $FlowFixMe
    var body = node.ownerDocument.body;
    body.appendChild(wrapper);
    if (text) {
        container.childNodes.push($632e6c3302100068$var$_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    } else // $FlowFixMe
    container.childNodes.push(new $632e6c3302100068$var$_NodeContainer2.default(wrapper, container, resourceLoader, 0));
};
var $632e6c3302100068$var$ROMAN_UPPER = {
    integers: [
        1000,
        900,
        500,
        400,
        100,
        90,
        50,
        40,
        10,
        9,
        5,
        4,
        1
    ],
    values: [
        'M',
        'CM',
        'D',
        'CD',
        'C',
        'XC',
        'L',
        'XL',
        'X',
        'IX',
        'V',
        'IV',
        'I'
    ]
};
var $632e6c3302100068$var$ARMENIAN = {
    integers: [
        9000,
        8000,
        7000,
        6000,
        5000,
        4000,
        3000,
        2000,
        1000,
        900,
        800,
        700,
        600,
        500,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u0554",
        "\u0553",
        "\u0552",
        "\u0551",
        "\u0550",
        "\u054F",
        "\u054E",
        "\u054D",
        "\u054C",
        "\u054B",
        "\u054A",
        "\u0549",
        "\u0548",
        "\u0547",
        "\u0546",
        "\u0545",
        "\u0544",
        "\u0543",
        "\u0542",
        "\u0541",
        "\u0540",
        "\u053F",
        "\u053E",
        "\u053D",
        "\u053C",
        "\u053B",
        "\u053A",
        "\u0539",
        "\u0538",
        "\u0537",
        "\u0536",
        "\u0535",
        "\u0534",
        "\u0533",
        "\u0532",
        "\u0531"
    ]
};
var $632e6c3302100068$var$HEBREW = {
    integers: [
        10000,
        9000,
        8000,
        7000,
        6000,
        5000,
        4000,
        3000,
        2000,
        1000,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        19,
        18,
        17,
        16,
        15,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u05D9\u05F3",
        "\u05D8\u05F3",
        "\u05D7\u05F3",
        "\u05D6\u05F3",
        "\u05D5\u05F3",
        "\u05D4\u05F3",
        "\u05D3\u05F3",
        "\u05D2\u05F3",
        "\u05D1\u05F3",
        "\u05D0\u05F3",
        "\u05EA",
        "\u05E9",
        "\u05E8",
        "\u05E7",
        "\u05E6",
        "\u05E4",
        "\u05E2",
        "\u05E1",
        "\u05E0",
        "\u05DE",
        "\u05DC",
        "\u05DB",
        "\u05D9\u05D8",
        "\u05D9\u05D7",
        "\u05D9\u05D6",
        "\u05D8\u05D6",
        "\u05D8\u05D5",
        "\u05D9",
        "\u05D8",
        "\u05D7",
        "\u05D6",
        "\u05D5",
        "\u05D4",
        "\u05D3",
        "\u05D2",
        "\u05D1",
        "\u05D0"
    ]
};
var $632e6c3302100068$var$GEORGIAN = {
    integers: [
        10000,
        9000,
        8000,
        7000,
        6000,
        5000,
        4000,
        3000,
        2000,
        1000,
        900,
        800,
        700,
        600,
        500,
        400,
        300,
        200,
        100,
        90,
        80,
        70,
        60,
        50,
        40,
        30,
        20,
        10,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ],
    values: [
        "\u10F5",
        "\u10F0",
        "\u10EF",
        "\u10F4",
        "\u10EE",
        "\u10ED",
        "\u10EC",
        "\u10EB",
        "\u10EA",
        "\u10E9",
        "\u10E8",
        "\u10E7",
        "\u10E6",
        "\u10E5",
        "\u10E4",
        "\u10F3",
        "\u10E2",
        "\u10E1",
        "\u10E0",
        "\u10DF",
        "\u10DE",
        "\u10DD",
        "\u10F2",
        "\u10DC",
        "\u10DB",
        "\u10DA",
        "\u10D9",
        "\u10D8",
        "\u10D7",
        "\u10F1",
        "\u10D6",
        "\u10D5",
        "\u10D4",
        "\u10D3",
        "\u10D2",
        "\u10D1",
        "\u10D0"
    ]
};
var $632e6c3302100068$var$createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
    if (value < min || value > max) return $632e6c3302100068$var$createCounterText(value, fallback, suffix.length > 0);
    return symbols.integers.reduce(function(string, integer, index) {
        while(value >= integer){
            value -= integer;
            string += symbols.values[index];
        }
        return string;
    }, '') + suffix;
};
var $632e6c3302100068$var$createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
    var string = '';
    do {
        if (!isNumeric) value--;
        string = resolver(value) + string;
        value /= codePointRangeLength;
    }while (value * codePointRangeLength >= codePointRangeLength);
    return string;
};
var $632e6c3302100068$var$createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
    return (value < 0 ? '-' : '') + ($632e6c3302100068$var$createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
        return (0, $4gxoB.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
    }) + suffix);
};
var $632e6c3302100068$var$createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';
    var codePointRangeLength = symbols.length;
    return $632e6c3302100068$var$createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
        return symbols[Math.floor(codePoint % codePointRangeLength)];
    }) + suffix;
};
var $632e6c3302100068$var$CJK_ZEROS = 1;
var $632e6c3302100068$var$CJK_TEN_COEFFICIENTS = 2;
var $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS = 4;
var $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS = 8;
var $632e6c3302100068$var$createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
    if (value < -9999 || value > 9999) return $632e6c3302100068$var$createCounterText(value, $dcmux.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
    var tmp = Math.abs(value);
    var string = suffix;
    if (tmp === 0) return numbers[0] + string;
    for(var digit = 0; tmp > 0 && digit <= 4; digit++){
        var coefficient = tmp % 10;
        if (coefficient === 0 && (0, $j1biG.contains)(flags, $632e6c3302100068$var$CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
        else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, $j1biG.contains)(flags, $632e6c3302100068$var$CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, $j1biG.contains)(flags, $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, $j1biG.contains)(flags, $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
        else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
        tmp = Math.floor(tmp / 10);
    }
    return (value < 0 ? negativeSign : '') + string;
};
var $632e6c3302100068$var$CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
var $632e6c3302100068$var$CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
var $632e6c3302100068$var$JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
var $632e6c3302100068$var$KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4 ";
var $632e6c3302100068$var$createCounterText = module.exports.createCounterText = function createCounterText(value, type, appendSuffix) {
    var defaultSuffix = appendSuffix ? '. ' : '';
    var cjkSuffix = appendSuffix ? "\u3001" : '';
    var koreanSuffix = appendSuffix ? ', ' : '';
    switch(type){
        case $dcmux.LIST_STYLE_TYPE.DISC:
            return "\u2022";
        case $dcmux.LIST_STYLE_TYPE.CIRCLE:
            return "\u25E6";
        case $dcmux.LIST_STYLE_TYPE.SQUARE:
            return "\u25FE";
        case $dcmux.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
            var string = $632e6c3302100068$var$createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
            return string.length < 4 ? '0' + string : string;
        case $dcmux.LIST_STYLE_TYPE.CJK_DECIMAL:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
        case $dcmux.LIST_STYLE_TYPE.LOWER_ROMAN:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 3999, $632e6c3302100068$var$ROMAN_UPPER, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case $dcmux.LIST_STYLE_TYPE.UPPER_ROMAN:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 3999, $632e6c3302100068$var$ROMAN_UPPER, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.LOWER_GREEK:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.LOWER_ALPHA:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.UPPER_ALPHA:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.ARABIC_INDIC:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.ARMENIAN:
        case $dcmux.LIST_STYLE_TYPE.UPPER_ARMENIAN:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 9999, $632e6c3302100068$var$ARMENIAN, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.LOWER_ARMENIAN:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 9999, $632e6c3302100068$var$ARMENIAN, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case $dcmux.LIST_STYLE_TYPE.BENGALI:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.CAMBODIAN:
        case $dcmux.LIST_STYLE_TYPE.KHMER:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
        case $dcmux.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
        case $dcmux.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
        case $dcmux.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", $632e6c3302100068$var$CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS | $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", $632e6c3302100068$var$CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, $632e6c3302100068$var$CJK_ZEROS | $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS | $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", $632e6c3302100068$var$CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS | $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", $632e6c3302100068$var$CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, $632e6c3302100068$var$CJK_ZEROS | $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS | $632e6c3302100068$var$CJK_HUNDRED_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", $632e6c3302100068$var$JAPANESE_NEGATIVE, cjkSuffix, 0);
        case $dcmux.LIST_STYLE_TYPE.JAPANESE_FORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", $632e6c3302100068$var$JAPANESE_NEGATIVE, cjkSuffix, $632e6c3302100068$var$CJK_ZEROS | $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", $632e6c3302100068$var$KOREAN_NEGATIVE, koreanSuffix, $632e6c3302100068$var$CJK_ZEROS | $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", $632e6c3302100068$var$KOREAN_NEGATIVE, koreanSuffix, 0);
        case $dcmux.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
            return $632e6c3302100068$var$createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", $632e6c3302100068$var$KOREAN_NEGATIVE, koreanSuffix, $632e6c3302100068$var$CJK_ZEROS | $632e6c3302100068$var$CJK_TEN_COEFFICIENTS | $632e6c3302100068$var$CJK_TEN_HIGH_COEFFICIENTS);
        case $dcmux.LIST_STYLE_TYPE.DEVANAGARI:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.GEORGIAN:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 19999, $632e6c3302100068$var$GEORGIAN, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.GUJARATI:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.GURMUKHI:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.HEBREW:
            return $632e6c3302100068$var$createAdditiveCounter(value, 1, 10999, $632e6c3302100068$var$HEBREW, $dcmux.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.HIRAGANA:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
        case $dcmux.LIST_STYLE_TYPE.HIRAGANA_IROHA:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
        case $dcmux.LIST_STYLE_TYPE.KANNADA:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.KATAKANA:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
        case $dcmux.LIST_STYLE_TYPE.KATAKANA_IROHA:
            return $632e6c3302100068$var$createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
        case $dcmux.LIST_STYLE_TYPE.LAO:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.MONGOLIAN:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.MYANMAR:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.ORIYA:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.PERSIAN:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.TAMIL:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.TELUGU:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.THAI:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.TIBETAN:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
        case $dcmux.LIST_STYLE_TYPE.DECIMAL:
        default:
            return $632e6c3302100068$var$createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
    }
};

});




parcelRegister("bYzJT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8b81055de697c097$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $8b81055de697c097$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4rAif = parcelRequire("4rAif");
parcelRequire("1J8yd");

var $h1MNO = parcelRequire("h1MNO");

var $l5O3X = parcelRequire("l5O3X");
var $8b81055de697c097$var$_TextContainer2 = $8b81055de697c097$var$_interopRequireDefault($l5O3X);

var $6vPZX = parcelRequire("6vPZX");

var $gIYuc = parcelRequire("gIYuc");
function $8b81055de697c097$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b81055de697c097$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $8b81055de697c097$var$Renderer = function() {
    function Renderer(target, options) {
        $8b81055de697c097$var$_classCallCheck(this, Renderer);
        this.target = target;
        this.options = options;
        target.render(options);
    }
    $8b81055de697c097$var$_createClass(Renderer, [
        {
            key: 'renderNode',
            value: function renderNode(container) {
                if (container.isVisible()) {
                    this.renderNodeBackgroundAndBorders(container);
                    this.renderNodeContent(container);
                }
            }
        },
        {
            key: 'renderNodeContent',
            value: function renderNodeContent(container) {
                var _this = this;
                var callback = function callback() {
                    if (container.childNodes.length) container.childNodes.forEach(function(child) {
                        if (child instanceof $8b81055de697c097$var$_TextContainer2.default) {
                            var style = child.parent.style;
                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
                        } else _this.target.drawShape(child, container.style.color);
                    });
                    if (container.image) {
                        var _image = _this.options.imageStore.get(container.image);
                        if (_image) {
                            var contentBox = (0, $4rAif.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
                            var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
                            var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
                            if (_width > 0 && _height > 0) _this.target.clip([
                                (0, $4rAif.calculatePaddingBoxPath)(container.curvedBounds)
                            ], function() {
                                _this.target.drawImage(_image, new $4rAif.Bounds(0, 0, _width, _height), contentBox);
                            });
                        }
                    }
                };
                var paths = container.getClipPaths();
                if (paths.length) this.target.clip(paths, callback);
                else callback();
            }
        },
        {
            key: 'renderNodeBackgroundAndBorders',
            value: function renderNodeBackgroundAndBorders(container) {
                var _this2 = this;
                var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;
                var hasRenderableBorders = container.style.border.some(function(border) {
                    return border.borderStyle !== $gIYuc.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
                });
                var callback = function callback() {
                    var backgroundPaintingArea = (0, $6vPZX.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);
                    if (HAS_BACKGROUND) _this2.target.clip([
                        backgroundPaintingArea
                    ], function() {
                        if (!container.style.background.backgroundColor.isTransparent()) _this2.target.fill(container.style.background.backgroundColor);
                        _this2.renderBackgroundImage(container);
                    });
                    container.style.border.forEach(function(border, side) {
                        if (border.borderStyle !== $gIYuc.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) _this2.renderBorder(border, side, container.curvedBounds);
                    });
                };
                if (HAS_BACKGROUND || hasRenderableBorders) {
                    var paths = container.parent ? container.parent.getClipPaths() : [];
                    if (paths.length) this.target.clip(paths, callback);
                    else callback();
                }
            }
        },
        {
            key: 'renderBackgroundImage',
            value: function renderBackgroundImage(container) {
                var _this3 = this;
                container.style.background.backgroundImage.slice(0).reverse().forEach(function(backgroundImage) {
                    if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) _this3.renderBackgroundRepeat(container, backgroundImage);
                    else if (/gradient/i.test(backgroundImage.source.method)) _this3.renderBackgroundGradient(container, backgroundImage);
                });
            }
        },
        {
            key: 'renderBackgroundRepeat',
            value: function renderBackgroundRepeat(container, background) {
                var image = this.options.imageStore.get(background.source.args[0]);
                if (image) {
                    var backgroundPositioningArea = (0, $6vPZX.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
                    var backgroundImageSize = (0, $6vPZX.calculateBackgroundSize)(background, image, backgroundPositioningArea);
                    var position = (0, $6vPZX.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
                    var _path = (0, $6vPZX.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);
                    var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
                    var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
                    this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
                }
            }
        },
        {
            key: 'renderBackgroundGradient',
            value: function renderBackgroundGradient(container, background) {
                var backgroundPositioningArea = (0, $6vPZX.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
                var backgroundImageSize = (0, $6vPZX.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
                var position = (0, $6vPZX.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
                var gradientBounds = new $4rAif.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);
                var gradient = (0, $h1MNO.parseGradient)(container, background.source, gradientBounds);
                if (gradient) switch(gradient.type){
                    case $h1MNO.GRADIENT_TYPE.LINEAR_GRADIENT:
                        // $FlowFixMe
                        this.target.renderLinearGradient(gradientBounds, gradient);
                        break;
                    case $h1MNO.GRADIENT_TYPE.RADIAL_GRADIENT:
                        // $FlowFixMe
                        this.target.renderRadialGradient(gradientBounds, gradient);
                        break;
                }
            }
        },
        {
            key: 'renderBorder',
            value: function renderBorder(border, side, curvePoints) {
                this.target.drawShape((0, $4rAif.parsePathForBorder)(curvePoints, side), border.borderColor);
            }
        },
        {
            key: 'renderStack',
            value: function renderStack(stack) {
                var _this4 = this;
                if (stack.container.isVisible()) {
                    var _opacity = stack.getOpacity();
                    if (_opacity !== this._opacity) {
                        this.target.setOpacity(stack.getOpacity());
                        this._opacity = _opacity;
                    }
                    var _transform = stack.container.style.transform;
                    if (_transform !== null) this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function() {
                        return _this4.renderStackContent(stack);
                    });
                    else this.renderStackContent(stack);
                }
            }
        },
        {
            key: 'renderStackContent',
            value: function renderStackContent(stack) {
                var _splitStackingContext = $8b81055de697c097$var$splitStackingContexts(stack), _splitStackingContext2 = $8b81055de697c097$var$_slicedToArray(_splitStackingContext, 5), negativeZIndex = _splitStackingContext2[0], zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1], positiveZIndex = _splitStackingContext2[2], nonPositionedFloats = _splitStackingContext2[3], nonPositionedInlineLevel = _splitStackingContext2[4];
                var _splitDescendants = $8b81055de697c097$var$splitDescendants(stack), _splitDescendants2 = $8b81055de697c097$var$_slicedToArray(_splitDescendants, 2), inlineLevel = _splitDescendants2[0], nonInlineLevel = _splitDescendants2[1];
                // https://www.w3.org/TR/css-position-3/#painting-order
                // 1. the background and borders of the element forming the stacking context.
                this.renderNodeBackgroundAndBorders(stack.container);
                // 2. the child stacking contexts with negative stack levels (most negative first).
                negativeZIndex.sort($8b81055de697c097$var$sortByZIndex).forEach(this.renderStack, this);
                // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                this.renderNodeContent(stack.container);
                nonInlineLevel.forEach(this.renderNode, this);
                // 4. All non-positioned floating descendants, in tree order. For each one of these,
                // treat the element as if it created a new stacking context, but any positioned descendants and descendants
                // which actually create a new stacking context should be considered part of the parent stacking context,
                // not this new one.
                nonPositionedFloats.forEach(this.renderStack, this);
                // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
                nonPositionedInlineLevel.forEach(this.renderStack, this);
                inlineLevel.forEach(this.renderNode, this);
                // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
                //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
                //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
                //  but any positioned descendants and descendants which actually create a new stacking context should be
                //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
                //  treat the stacking context generated atomically.
                //
                //  All opacity descendants with opacity less than 1
                //
                //  All transform descendants with transform other than none
                zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
                // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
                // order (smallest first) then tree order.
                positiveZIndex.sort($8b81055de697c097$var$sortByZIndex).forEach(this.renderStack, this);
            }
        },
        {
            key: 'render',
            value: function render(stack) {
                var _this5 = this;
                if (this.options.backgroundColor) this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
                this.renderStack(stack);
                var target = this.target.getTarget();
                return target;
            }
        }
    ]);
    return Renderer;
}();
module.exports.default = $8b81055de697c097$var$Renderer;
var $8b81055de697c097$var$splitDescendants = function splitDescendants(stack) {
    var inlineLevel = [];
    var nonInlineLevel = [];
    var length = stack.children.length;
    for(var i = 0; i < length; i++){
        var child = stack.children[i];
        if (child.isInlineLevel()) inlineLevel.push(child);
        else nonInlineLevel.push(child);
    }
    return [
        inlineLevel,
        nonInlineLevel
    ];
};
var $8b81055de697c097$var$splitStackingContexts = function splitStackingContexts(stack) {
    var negativeZIndex = [];
    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
    var positiveZIndex = [];
    var nonPositionedFloats = [];
    var nonPositionedInlineLevel = [];
    var length = stack.contexts.length;
    for(var i = 0; i < length; i++){
        var child = stack.contexts[i];
        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
            if (child.container.style.zIndex.order < 0) negativeZIndex.push(child);
            else if (child.container.style.zIndex.order > 0) positiveZIndex.push(child);
            else zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
        } else if (child.container.isFloating()) nonPositionedFloats.push(child);
        else nonPositionedInlineLevel.push(child);
    }
    return [
        negativeZIndex,
        zeroOrAutoZIndexOrTransformedOrOpacity,
        positiveZIndex,
        nonPositionedFloats,
        nonPositionedInlineLevel
    ];
};
var $8b81055de697c097$var$sortByZIndex = function sortByZIndex(a, b) {
    if (a.container.style.zIndex.order > b.container.style.zIndex.order) return 1;
    else if (a.container.style.zIndex.order < b.container.style.zIndex.order) return -1;
    return a.container.index > b.container.index ? 1 : -1;
};

});
parcelRegister("1J8yd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FontMetrics = undefined;
var $1420a075981e4ec4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $j1biG = parcelRequire("j1biG");
function $1420a075981e4ec4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $1420a075981e4ec4$var$SAMPLE_TEXT = 'Hidden Text';
var $1420a075981e4ec4$var$FontMetrics = module.exports.FontMetrics = function() {
    function FontMetrics(document) {
        $1420a075981e4ec4$var$_classCallCheck(this, FontMetrics);
        this._data = {};
        this._document = document;
    }
    $1420a075981e4ec4$var$_createClass(FontMetrics, [
        {
            key: '_parseMetrics',
            value: function _parseMetrics(font) {
                var container = this._document.createElement('div');
                var img = this._document.createElement('img');
                var span = this._document.createElement('span');
                var body = this._document.body;
                if (!body) throw new Error('');
                container.style.visibility = 'hidden';
                container.style.fontFamily = font.fontFamily;
                container.style.fontSize = font.fontSize;
                container.style.margin = '0';
                container.style.padding = '0';
                body.appendChild(container);
                img.src = $j1biG.SMALL_IMAGE;
                img.width = 1;
                img.height = 1;
                img.style.margin = '0';
                img.style.padding = '0';
                img.style.verticalAlign = 'baseline';
                span.style.fontFamily = font.fontFamily;
                span.style.fontSize = font.fontSize;
                span.style.margin = '0';
                span.style.padding = '0';
                span.appendChild(this._document.createTextNode($1420a075981e4ec4$var$SAMPLE_TEXT));
                container.appendChild(span);
                container.appendChild(img);
                var baseline = img.offsetTop - span.offsetTop + 2;
                container.removeChild(span);
                container.appendChild(this._document.createTextNode($1420a075981e4ec4$var$SAMPLE_TEXT));
                container.style.lineHeight = 'normal';
                img.style.verticalAlign = 'super';
                var middle = img.offsetTop - container.offsetTop + 2;
                body.removeChild(container);
                return {
                    baseline: baseline,
                    middle: middle
                };
            }
        },
        {
            key: 'getMetrics',
            value: function getMetrics(font) {
                var key = font.fontFamily + ' ' + font.fontSize;
                if (this._data[key] === undefined) this._data[key] = this._parseMetrics(font);
                return this._data[key];
            }
        }
    ]);
    return FontMetrics;
}();

});

parcelRegister("h1MNO", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transformWebkitRadialGradientArgs = module.exports.parseGradient = module.exports.RadialGradient = module.exports.LinearGradient = module.exports.RADIAL_GRADIENT_SHAPE = module.exports.GRADIENT_TYPE = undefined;
var $c65862d1ea2f7734$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $6RJQM = parcelRequire("6RJQM");
var $c65862d1ea2f7734$var$_NodeContainer2 = $c65862d1ea2f7734$var$_interopRequireDefault($6RJQM);

var $9GrH1 = parcelRequire("9GrH1");

var $gO3cU = parcelRequire("gO3cU");
var $c65862d1ea2f7734$var$_Color2 = $c65862d1ea2f7734$var$_interopRequireDefault($gO3cU);

var $iAhLp = parcelRequire("iAhLp");
var $c65862d1ea2f7734$var$_Length2 = $c65862d1ea2f7734$var$_interopRequireDefault($iAhLp);

var $j1biG = parcelRequire("j1biG");
function $c65862d1ea2f7734$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c65862d1ea2f7734$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $c65862d1ea2f7734$var$SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
var $c65862d1ea2f7734$var$PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
var $c65862d1ea2f7734$var$ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
var $c65862d1ea2f7734$var$FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
var $c65862d1ea2f7734$var$RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;
var $c65862d1ea2f7734$var$GRADIENT_TYPE = module.exports.GRADIENT_TYPE = {
    LINEAR_GRADIENT: 0,
    RADIAL_GRADIENT: 1
};
var $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE = module.exports.RADIAL_GRADIENT_SHAPE = {
    CIRCLE: 0,
    ELLIPSE: 1
};
var $c65862d1ea2f7734$var$LENGTH_FOR_POSITION = {
    left: new $c65862d1ea2f7734$var$_Length2.default('0%'),
    top: new $c65862d1ea2f7734$var$_Length2.default('0%'),
    center: new $c65862d1ea2f7734$var$_Length2.default('50%'),
    right: new $c65862d1ea2f7734$var$_Length2.default('100%'),
    bottom: new $c65862d1ea2f7734$var$_Length2.default('100%')
};
var $c65862d1ea2f7734$var$LinearGradient = module.exports.LinearGradient = function LinearGradient(colorStops, direction) {
    $c65862d1ea2f7734$var$_classCallCheck(this, LinearGradient);
    this.type = $c65862d1ea2f7734$var$GRADIENT_TYPE.LINEAR_GRADIENT;
    this.colorStops = colorStops;
    this.direction = direction;
};
var $c65862d1ea2f7734$var$RadialGradient = module.exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
    $c65862d1ea2f7734$var$_classCallCheck(this, RadialGradient);
    this.type = $c65862d1ea2f7734$var$GRADIENT_TYPE.RADIAL_GRADIENT;
    this.colorStops = colorStops;
    this.shape = shape;
    this.center = center;
    this.radius = radius;
};
var $c65862d1ea2f7734$var$parseGradient = module.exports.parseGradient = function parseGradient(container, _ref, bounds) {
    var args = _ref.args, method = _ref.method, prefix = _ref.prefix;
    if (method === 'linear-gradient') return $c65862d1ea2f7734$var$parseLinearGradient(args, bounds, !!prefix);
    else if (method === 'gradient' && args[0] === 'linear') // TODO handle correct angle
    return $c65862d1ea2f7734$var$parseLinearGradient([
        'to bottom'
    ].concat($c65862d1ea2f7734$var$transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
    else if (method === 'radial-gradient') return $c65862d1ea2f7734$var$parseRadialGradient(container, prefix === '-webkit-' ? $c65862d1ea2f7734$var$transformWebkitRadialGradientArgs(args) : args, bounds);
    else if (method === 'gradient' && args[0] === 'radial') return $c65862d1ea2f7734$var$parseRadialGradient(container, $c65862d1ea2f7734$var$transformObsoleteColorStops($c65862d1ea2f7734$var$transformWebkitRadialGradientArgs(args.slice(1))), bounds);
};
var $c65862d1ea2f7734$var$parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
    var colorStops = [];
    for(var i = firstColorStopIndex; i < args.length; i++){
        var value = args[i];
        var HAS_LENGTH = $c65862d1ea2f7734$var$ENDS_WITH_LENGTH.test(value);
        var lastSpaceIndex = value.lastIndexOf(' ');
        var _color = new $c65862d1ea2f7734$var$_Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
        var _stop = HAS_LENGTH ? new $c65862d1ea2f7734$var$_Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new $c65862d1ea2f7734$var$_Length2.default('0%') : i === args.length - 1 ? new $c65862d1ea2f7734$var$_Length2.default('100%') : null;
        colorStops.push({
            color: _color,
            stop: _stop
        });
    }
    var absoluteValuedColorStops = colorStops.map(function(_ref2) {
        var color = _ref2.color, stop = _ref2.stop;
        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;
        return {
            color: color,
            // $FlowFixMe
            stop: absoluteStop
        };
    });
    var previousColorStop = absoluteValuedColorStops[0].stop;
    for(var _i = 0; _i < absoluteValuedColorStops.length; _i++)if (previousColorStop !== null) {
        var _stop2 = absoluteValuedColorStops[_i].stop;
        if (_stop2 === null) {
            var n = _i;
            while(absoluteValuedColorStops[n].stop === null)n++;
            var steps = n - _i + 1;
            var nextColorStep = absoluteValuedColorStops[n].stop;
            var stepSize = (nextColorStep - previousColorStop) / steps;
            for(; _i < n; _i++)previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
        } else previousColorStop = _stop2;
    }
    return absoluteValuedColorStops;
};
var $c65862d1ea2f7734$var$parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
    var angle = (0, $9GrH1.parseAngle)(args[0]);
    var HAS_SIDE_OR_CORNER = $c65862d1ea2f7734$var$SIDE_OR_CORNER.test(args[0]);
    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || $c65862d1ea2f7734$var$PERCENTAGE_ANGLES.test(args[0]);
    var direction = HAS_DIRECTION ? angle !== null ? $c65862d1ea2f7734$var$calculateGradientDirection(// if there is a prefix, the 0° angle points due East (instead of North per W3C)
    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? $c65862d1ea2f7734$var$parseSideOrCorner(args[0], bounds) : $c65862d1ea2f7734$var$parsePercentageAngle(args[0], bounds) : $c65862d1ea2f7734$var$calculateGradientDirection(Math.PI, bounds);
    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;
    // TODO: Fix some inaccuracy with color stops with px values
    var lineLength = Math.min((0, $j1biG.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);
    return new $c65862d1ea2f7734$var$LinearGradient($c65862d1ea2f7734$var$parseColorStops(args, firstColorStopIndex, lineLength), direction);
};
var $c65862d1ea2f7734$var$parseRadialGradient = function parseRadialGradient(container, args, bounds) {
    var m = args[0].match($c65862d1ea2f7734$var$RADIAL_SHAPE_DEFINITION);
    var shape = m && (m[1] === 'circle' || // explicit shape specification
    m[3] !== undefined && m[5] === undefined // only one radius coordinate
    ) ? $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.CIRCLE : $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.ELLIPSE;
    var radius = {};
    var center = {};
    if (m) {
        // Radius
        if (m[3] !== undefined) radius.x = (0, $iAhLp.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
        if (m[5] !== undefined) radius.y = (0, $iAhLp.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
        // Position
        if (m[7]) center.x = $c65862d1ea2f7734$var$LENGTH_FOR_POSITION[m[7].toLowerCase()];
        else if (m[8] !== undefined) center.x = (0, $iAhLp.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
        if (m[10]) center.y = $c65862d1ea2f7734$var$LENGTH_FOR_POSITION[m[10].toLowerCase()];
        else if (m[11] !== undefined) center.y = (0, $iAhLp.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
    }
    var gradientCenter = {
        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
    };
    var gradientRadius = $c65862d1ea2f7734$var$calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);
    return new $c65862d1ea2f7734$var$RadialGradient($c65862d1ea2f7734$var$parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
};
var $c65862d1ea2f7734$var$calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
    var width = bounds.width;
    var height = bounds.height;
    var HALF_WIDTH = width * 0.5;
    var HALF_HEIGHT = height * 0.5;
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
    var HALF_LINE_LENGTH = lineLength / 2;
    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
    var x1 = width - x0;
    var y1 = height - y0;
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
};
var $c65862d1ea2f7734$var$parseTopRight = function parseTopRight(bounds) {
    return Math.acos(bounds.width / 2 / ((0, $j1biG.distance)(bounds.width, bounds.height) / 2));
};
var $c65862d1ea2f7734$var$parseSideOrCorner = function parseSideOrCorner(side, bounds) {
    switch(side){
        case 'bottom':
        case 'to top':
            return $c65862d1ea2f7734$var$calculateGradientDirection(0, bounds);
        case 'left':
        case 'to right':
            return $c65862d1ea2f7734$var$calculateGradientDirection(Math.PI / 2, bounds);
        case 'right':
        case 'to left':
            return $c65862d1ea2f7734$var$calculateGradientDirection(3 * Math.PI / 2, bounds);
        case 'top right':
        case 'right top':
        case 'to bottom left':
        case 'to left bottom':
            return $c65862d1ea2f7734$var$calculateGradientDirection(Math.PI + $c65862d1ea2f7734$var$parseTopRight(bounds), bounds);
        case 'top left':
        case 'left top':
        case 'to bottom right':
        case 'to right bottom':
            return $c65862d1ea2f7734$var$calculateGradientDirection(Math.PI - $c65862d1ea2f7734$var$parseTopRight(bounds), bounds);
        case 'bottom left':
        case 'left bottom':
        case 'to top right':
        case 'to right top':
            return $c65862d1ea2f7734$var$calculateGradientDirection($c65862d1ea2f7734$var$parseTopRight(bounds), bounds);
        case 'bottom right':
        case 'right bottom':
        case 'to top left':
        case 'to left top':
            return $c65862d1ea2f7734$var$calculateGradientDirection(2 * Math.PI - $c65862d1ea2f7734$var$parseTopRight(bounds), bounds);
        case 'top':
        case 'to bottom':
        default:
            return $c65862d1ea2f7734$var$calculateGradientDirection(Math.PI, bounds);
    }
};
var $c65862d1ea2f7734$var$parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
    var _angle$split$map = angle.split(' ').map(parseFloat), _angle$split$map2 = $c65862d1ea2f7734$var$_slicedToArray(_angle$split$map, 2), left = _angle$split$map2[0], top = _angle$split$map2[1];
    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);
    return $c65862d1ea2f7734$var$calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
};
var $c65862d1ea2f7734$var$findCorner = function findCorner(bounds, x, y, closest) {
    var corners = [
        {
            x: 0,
            y: 0
        },
        {
            x: 0,
            y: bounds.height
        },
        {
            x: bounds.width,
            y: 0
        },
        {
            x: bounds.width,
            y: bounds.height
        }
    ];
    // $FlowFixMe
    return corners.reduce(function(stat, corner) {
        var d = (0, $j1biG.distance)(x - corner.x, y - corner.y);
        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
            optimumCorner: corner,
            optimumDistance: d
        };
        return stat;
    }, {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null
    }).optimumCorner;
};
var $c65862d1ea2f7734$var$calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
    var x = center.x;
    var y = center.y;
    var rx = 0;
    var ry = 0;
    switch(extent){
        case 'closest-side':
            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
            if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.CIRCLE) rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            else if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;
        case 'closest-corner':
            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
            if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.CIRCLE) rx = ry = Math.min((0, $j1biG.distance)(x, y), (0, $j1biG.distance)(x, y - bounds.height), (0, $j1biG.distance)(x - bounds.width, y), (0, $j1biG.distance)(x - bounds.width, y - bounds.height));
            else if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
                var corner = $c65862d1ea2f7734$var$findCorner(bounds, x, y, true);
                rx = (0, $j1biG.distance)(corner.x - x, (corner.y - y) / c);
                ry = c * rx;
            }
            break;
        case 'farthest-side':
            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
            if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.CIRCLE) rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            else if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;
        case 'farthest-corner':
            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
            if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.CIRCLE) rx = ry = Math.max((0, $j1biG.distance)(x, y), (0, $j1biG.distance)(x, y - bounds.height), (0, $j1biG.distance)(x - bounds.width, y), (0, $j1biG.distance)(x - bounds.width, y - bounds.height));
            else if (shape === $c65862d1ea2f7734$var$RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
                var _corner = $c65862d1ea2f7734$var$findCorner(bounds, x, y, false);
                rx = (0, $j1biG.distance)(_corner.x - x, (_corner.y - y) / _c);
                ry = _c * rx;
            }
            break;
        default:
            // pixel or percentage values
            rx = radius.x || 0;
            ry = radius.y !== undefined ? radius.y : rx;
            break;
    }
    return {
        x: rx,
        y: ry
    };
};
var $c65862d1ea2f7734$var$transformWebkitRadialGradientArgs = module.exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
    var shape = '';
    var radius = '';
    var extent = '';
    var position = '';
    var idx = 0;
    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;
    var matchStartPosition = args[idx].match(POSITION);
    if (matchStartPosition) idx++;
    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
    if (matchShapeExtent) {
        shape = matchShapeExtent[1] || '';
        extent = matchShapeExtent[2] || '';
        if (extent === 'contain') extent = 'closest-side';
        else if (extent === 'cover') extent = 'farthest-corner';
        idx++;
    }
    var matchStartRadius = args[idx].match(RADIUS);
    if (matchStartRadius) idx++;
    var matchEndPosition = args[idx].match(POSITION);
    if (matchEndPosition) idx++;
    var matchEndRadius = args[idx].match(RADIUS);
    if (matchEndRadius) idx++;
    var matchPosition = matchEndPosition || matchStartPosition;
    if (matchPosition && matchPosition[1]) {
        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
        if (matchPosition[2]) position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
    }
    var matchRadius = matchEndRadius || matchStartRadius;
    if (matchRadius) {
        radius = matchRadius[0];
        if (!matchRadius[1]) radius += 'px';
    }
    if (position && !shape && !radius && !extent) {
        radius = position;
        position = '';
    }
    if (position) position = 'at ' + position;
    return [
        [
            shape,
            extent,
            radius,
            position
        ].filter(function(s) {
            return !!s;
        }).join(' ')
    ].concat(args.slice(idx));
};
var $c65862d1ea2f7734$var$transformObsoleteColorStops = function transformObsoleteColorStops(args) {
    return args.map(function(color) {
        return color.match($c65862d1ea2f7734$var$FROM_TO_COLORSTOP);
    })// $FlowFixMe
    .map(function(v, index) {
        if (!v) return args[index];
        switch(v[1]){
            case 'from':
                return v[4] + ' 0%';
            case 'to':
                return v[4] + ' 100%';
            case 'color-stop':
                if (v[3] === '%') return v[4] + ' ' + v[2];
                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
        }
    });
};

});
parcelRegister("9GrH1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $70cd848d4476e746$var$ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
var $70cd848d4476e746$var$parseAngle = module.exports.parseAngle = function parseAngle(angle) {
    var match = angle.match($70cd848d4476e746$var$ANGLE);
    if (match) {
        var value = parseFloat(match[1]);
        switch(match[2].toLowerCase()){
            case 'deg':
                return Math.PI * value / 180;
            case 'grad':
                return Math.PI / 200 * value;
            case 'rad':
                return value;
            case 'turn':
                return Math.PI * 2 * value;
        }
    }
    return null;
};

});



parcelRegister("lbXoG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneWindow = module.exports.DocumentCloner = undefined;
var $f6d8b3161743da3b$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $f6d8b3161743da3b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4rAif = parcelRequire("4rAif");

var $fDeh2 = parcelRequire("fDeh2");

var $8tnoc = parcelRequire("8tnoc");
var $f6d8b3161743da3b$var$_ResourceLoader2 = $f6d8b3161743da3b$var$_interopRequireDefault($8tnoc);

var $j1biG = parcelRequire("j1biG");

var $6vPZX = parcelRequire("6vPZX");

var $lCz2k = parcelRequire("lCz2k");
var $f6d8b3161743da3b$var$_CanvasRenderer2 = $f6d8b3161743da3b$var$_interopRequireDefault($lCz2k);

var $2S1bh = parcelRequire("2S1bh");
function $f6d8b3161743da3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f6d8b3161743da3b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $f6d8b3161743da3b$var$IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
var $f6d8b3161743da3b$var$DocumentCloner = module.exports.DocumentCloner = function() {
    function DocumentCloner(element, options, logger, copyInline, renderer) {
        $f6d8b3161743da3b$var$_classCallCheck(this, DocumentCloner);
        this.referenceElement = element;
        this.scrolledElements = [];
        this.copyStyles = copyInline;
        this.inlineImages = copyInline;
        this.logger = logger;
        this.options = options;
        this.renderer = renderer;
        this.resourceLoader = new $f6d8b3161743da3b$var$_ResourceLoader2.default(options, logger, window);
        this.pseudoContentData = {
            counters: {},
            quoteDepth: 0
        };
        // $FlowFixMe
        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
    }
    $f6d8b3161743da3b$var$_createClass(DocumentCloner, [
        {
            key: 'inlineAllImages',
            value: function inlineAllImages(node) {
                var _this = this;
                if (this.inlineImages && node) {
                    var style = node.style;
                    Promise.all((0, $6vPZX.parseBackgroundImage)(style.backgroundImage).map(function(backgroundImage) {
                        if (backgroundImage.method === 'url') return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function(img) {
                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
                        }).catch(function(e) {});
                        return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
                    })).then(function(backgroundImages) {
                        if (backgroundImages.length > 1) // TODO Multiple backgrounds somehow broken in Chrome
                        style.backgroundColor = '';
                        style.backgroundImage = backgroundImages.join(',');
                    });
                    if (node instanceof HTMLImageElement) this.resourceLoader.inlineImage(node.src).then(function(img) {
                        if (img && node instanceof HTMLImageElement && node.parentNode) {
                            var parentNode = node.parentNode;
                            var clonedChild = (0, $j1biG.copyCSSStyles)(node.style, img.cloneNode(false));
                            parentNode.replaceChild(clonedChild, node);
                        }
                    }).catch(function(e) {});
                }
            }
        },
        {
            key: 'inlineFonts',
            value: function inlineFonts(document1) {
                var _this2 = this;
                return Promise.all(Array.from(document1.styleSheets).map(function(sheet) {
                    if (sheet.href) return fetch(sheet.href).then(function(res) {
                        return res.text();
                    }).then(function(text) {
                        return $f6d8b3161743da3b$var$createStyleSheetFontsFromText(text, sheet.href);
                    }).catch(function(e) {
                        return [];
                    });
                    return $f6d8b3161743da3b$var$getSheetFonts(sheet, document1);
                })).then(function(fonts) {
                    return fonts.reduce(function(acc, font) {
                        return acc.concat(font);
                    }, []);
                }).then(function(fonts) {
                    return Promise.all(fonts.map(function(font) {
                        return fetch(font.formats[0].src).then(function(response) {
                            return response.blob();
                        }).then(function(blob) {
                            return new Promise(function(resolve, reject) {
                                var reader = new FileReader();
                                reader.onerror = reject;
                                reader.onload = function() {
                                    // $FlowFixMe
                                    var result = reader.result;
                                    resolve(result);
                                };
                                reader.readAsDataURL(blob);
                            });
                        }).then(function(dataUri) {
                            font.fontFace.setProperty('src', 'url("' + dataUri + '")');
                            return '@font-face {' + font.fontFace.cssText + ' ';
                        });
                    }));
                }).then(function(fontCss) {
                    var style = document1.createElement('style');
                    style.textContent = fontCss.join('\n');
                    _this2.documentElement.appendChild(style);
                });
            }
        },
        {
            key: 'createElementClone',
            value: function createElementClone(node) {
                var _this3 = this;
                if (this.copyStyles && node instanceof HTMLCanvasElement) {
                    var img = node.ownerDocument.createElement('img');
                    try {
                        img.src = node.toDataURL();
                        return img;
                    } catch (e) {}
                }
                if (node instanceof HTMLIFrameElement) {
                    var tempIframe = node.cloneNode(false);
                    var iframeKey = $f6d8b3161743da3b$var$generateIframeKey();
                    tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);
                    var _parseBounds = (0, $4rAif.parseBounds)(node, 0, 0), width = _parseBounds.width, height = _parseBounds.height;
                    this.resourceLoader.cache[iframeKey] = $f6d8b3161743da3b$var$getIframeDocumentElement(node, this.options).then(function(documentElement) {
                        return _this3.renderer(documentElement, {
                            async: _this3.options.async,
                            allowTaint: _this3.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: _this3.options.imageTimeout,
                            logging: _this3.options.logging,
                            proxy: _this3.options.proxy,
                            removeContainer: _this3.options.removeContainer,
                            scale: _this3.options.scale,
                            foreignObjectRendering: _this3.options.foreignObjectRendering,
                            useCORS: _this3.options.useCORS,
                            target: new $f6d8b3161743da3b$var$_CanvasRenderer2.default(),
                            width: width,
                            height: height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        }, _this3.logger.child(iframeKey));
                    }).then(function(canvas) {
                        return new Promise(function(resolve, reject) {
                            var iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = function() {
                                return resolve(canvas);
                            };
                            iframeCanvas.onerror = reject;
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode) tempIframe.parentNode.replaceChild((0, $j1biG.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
                        });
                    });
                    return tempIframe;
                }
                if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
                    var css = [].slice.call(node.sheet.cssRules, 0).reduce(function(css, rule) {
                        try {
                            if (rule && rule.cssText) return css + rule.cssText;
                            return css;
                        } catch (err) {
                            _this3.logger.log('Unable to access cssText property', rule.name);
                            return css;
                        }
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
                return node.cloneNode(false);
            }
        },
        {
            key: 'cloneNode',
            value: function cloneNode(node) {
                var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);
                var window1 = node.ownerDocument.defaultView;
                var style = node instanceof window1.HTMLElement ? window1.getComputedStyle(node) : null;
                var styleBefore = node instanceof window1.HTMLElement ? window1.getComputedStyle(node, ':before') : null;
                var styleAfter = node instanceof window1.HTMLElement ? window1.getComputedStyle(node, ':after') : null;
                if (this.referenceElement === node && clone instanceof window1.HTMLElement) this.clonedReferenceElement = clone;
                if (clone instanceof window1.HTMLBodyElement) $f6d8b3161743da3b$var$createPseudoHideStyles(clone);
                var counters = (0, $2S1bh.parseCounterReset)(style, this.pseudoContentData);
                var contentBefore = (0, $2S1bh.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);
                for(var child = node.firstChild; child; child = child.nextSibling){
                    if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' && // $FlowFixMe
                    !child.hasAttribute($f6d8b3161743da3b$var$IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || // $FlowFixMe
                    !this.options.ignoreElements(child))) {
                        if (!this.copyStyles || child.nodeName !== 'STYLE') clone.appendChild(this.cloneNode(child));
                    }
                }
                var contentAfter = (0, $2S1bh.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
                (0, $2S1bh.popCounters)(counters, this.pseudoContentData);
                if (node instanceof window1.HTMLElement && clone instanceof window1.HTMLElement) {
                    if (styleBefore) this.inlineAllImages($f6d8b3161743da3b$var$inlinePseudoElement(node, clone, styleBefore, contentBefore, $f6d8b3161743da3b$var$PSEUDO_BEFORE));
                    if (styleAfter) this.inlineAllImages($f6d8b3161743da3b$var$inlinePseudoElement(node, clone, styleAfter, contentAfter, $f6d8b3161743da3b$var$PSEUDO_AFTER));
                    if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) (0, $j1biG.copyCSSStyles)(style, clone);
                    this.inlineAllImages(clone);
                    if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                        clone,
                        node.scrollLeft,
                        node.scrollTop
                    ]);
                    switch(node.nodeName){
                        case 'CANVAS':
                            if (!this.copyStyles) $f6d8b3161743da3b$var$cloneCanvasContents(node, clone);
                            break;
                        case 'TEXTAREA':
                        case 'SELECT':
                            clone.value = node.value;
                            break;
                    }
                }
                return clone;
            }
        }
    ]);
    return DocumentCloner;
}();
var $f6d8b3161743da3b$var$getSheetFonts = function getSheetFonts(sheet, document1) {
    // $FlowFixMe
    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function(rule) {
        return rule.type === CSSRule.FONT_FACE_RULE;
    }).map(function(rule) {
        var src = (0, $6vPZX.parseBackgroundImage)(rule.style.getPropertyValue('src'));
        var formats = [];
        for(var i = 0; i < src.length; i++)if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
            var a = document1.createElement('a');
            a.href = src[i].args[0];
            if (document1.body) document1.body.appendChild(a);
            var font = {
                src: a.href,
                format: src[i + 1].args[0]
            };
            formats.push(font);
        }
        return {
            // TODO select correct format for browser),
            formats: formats.filter(function(font) {
                return /^woff/i.test(font.format);
            }),
            fontFace: rule.style
        };
    }).filter(function(font) {
        return font.formats.length;
    });
};
var $f6d8b3161743da3b$var$createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
    var doc = document.implementation.createHTMLDocument('');
    var base = document.createElement('base');
    // $FlowFixMe
    base.href = baseHref;
    var style = document.createElement('style');
    style.textContent = text;
    if (doc.head) doc.head.appendChild(base);
    if (doc.body) doc.body.appendChild(style);
    return style.sheet ? $f6d8b3161743da3b$var$getSheetFonts(style.sheet, doc) : [];
};
var $f6d8b3161743da3b$var$restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
};
var $f6d8b3161743da3b$var$cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
    try {
        if (clonedCanvas) {
            clonedCanvas.width = canvas.width;
            clonedCanvas.height = canvas.height;
            var ctx = canvas.getContext('2d');
            var clonedCtx = clonedCanvas.getContext('2d');
            if (ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
            else clonedCtx.drawImage(canvas, 0, 0);
        }
    } catch (e) {}
};
var $f6d8b3161743da3b$var$inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') return;
    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
    (0, $j1biG.copyCSSStyles)(style, anonymousReplacedElement);
    if (contentItems) {
        var len = contentItems.length;
        for(var i = 0; i < len; i++){
            var item = contentItems[i];
            switch(item.type){
                case $2S1bh.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
                    var img = clone.ownerDocument.createElement('img');
                    img.src = (0, $6vPZX.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                    break;
                case $2S1bh.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
                    break;
            }
        }
    }
    anonymousReplacedElement.className = $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    clone.className += pseudoElt === $f6d8b3161743da3b$var$PSEUDO_BEFORE ? ' ' + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    if (pseudoElt === $f6d8b3161743da3b$var$PSEUDO_BEFORE) clone.insertBefore(anonymousReplacedElement, clone.firstChild);
    else clone.appendChild(anonymousReplacedElement);
    return anonymousReplacedElement;
};
var $f6d8b3161743da3b$var$URL_REGEXP = /^url\((.+)\)$/i;
var $f6d8b3161743da3b$var$PSEUDO_BEFORE = ':before';
var $f6d8b3161743da3b$var$PSEUDO_AFTER = ':after';
var $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
var $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
var $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
var $f6d8b3161743da3b$var$createPseudoHideStyles = function createPseudoHideStyles(body) {
    $f6d8b3161743da3b$var$createStyles(body, '.' + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + $f6d8b3161743da3b$var$PSEUDO_BEFORE + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_CLASS_AFTER + $f6d8b3161743da3b$var$PSEUDO_AFTER + $f6d8b3161743da3b$var$PSEUDO_HIDE_ELEMENT_STYLE);
};
var $f6d8b3161743da3b$var$createStyles = function createStyles(body, styles) {
    var style = body.ownerDocument.createElement('style');
    style.innerHTML = styles;
    body.appendChild(style);
};
var $f6d8b3161743da3b$var$initNode = function initNode(_ref) {
    var _ref2 = $f6d8b3161743da3b$var$_slicedToArray(_ref, 3), element = _ref2[0], x = _ref2[1], y = _ref2[2];
    element.scrollLeft = x;
    element.scrollTop = y;
};
var $f6d8b3161743da3b$var$generateIframeKey = function generateIframeKey() {
    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
};
var $f6d8b3161743da3b$var$DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;
var $f6d8b3161743da3b$var$getIframeDocumentElement = function getIframeDocumentElement(node, options) {
    try {
        return Promise.resolve(node.contentWindow.document.documentElement);
    } catch (e) {
        return options.proxy ? (0, $fDeh2.Proxy)(node.src, options).then(function(html) {
            var match = html.match($f6d8b3161743da3b$var$DATA_URI_REGEXP);
            if (!match) return Promise.reject();
            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
        }).then(function(html) {
            return $f6d8b3161743da3b$var$createIframeContainer(node.ownerDocument, (0, $4rAif.parseBounds)(node, 0, 0)).then(function(cloneIframeContainer) {
                var cloneWindow = cloneIframeContainer.contentWindow;
                var documentClone = cloneWindow.document;
                documentClone.open();
                documentClone.write(html);
                var iframeLoad = $f6d8b3161743da3b$var$iframeLoader(cloneIframeContainer).then(function() {
                    return documentClone.documentElement;
                });
                documentClone.close();
                return iframeLoad;
            });
        }) : Promise.reject();
    }
};
var $f6d8b3161743da3b$var$createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
    var cloneIframeContainer = ownerDocument.createElement('iframe');
    cloneIframeContainer.className = 'html2canvas-container';
    cloneIframeContainer.style.visibility = 'hidden';
    cloneIframeContainer.style.position = 'fixed';
    cloneIframeContainer.style.left = '-10000px';
    cloneIframeContainer.style.top = '0px';
    cloneIframeContainer.style.border = '0';
    cloneIframeContainer.width = bounds.width.toString();
    cloneIframeContainer.height = bounds.height.toString();
    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
    cloneIframeContainer.setAttribute($f6d8b3161743da3b$var$IGNORE_ATTRIBUTE, 'true');
    if (!ownerDocument.body) return Promise.reject('');
    ownerDocument.body.appendChild(cloneIframeContainer);
    return Promise.resolve(cloneIframeContainer);
};
var $f6d8b3161743da3b$var$iframeLoader = function iframeLoader(cloneIframeContainer) {
    var cloneWindow = cloneIframeContainer.contentWindow;
    var documentClone = cloneWindow.document;
    return new Promise(function(resolve, reject) {
        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function() {
            var interval = setInterval(function() {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                    clearInterval(interval);
                    resolve(cloneIframeContainer);
                }
            }, 50);
        };
    });
};
var $f6d8b3161743da3b$var$cloneWindow = module.exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
    var cloner = new $f6d8b3161743da3b$var$DocumentCloner(referenceElement, options, logger, false, renderer);
    var scrollX = ownerDocument.defaultView.pageXOffset;
    var scrollY = ownerDocument.defaultView.pageYOffset;
    return $f6d8b3161743da3b$var$createIframeContainer(ownerDocument, bounds).then(function(cloneIframeContainer) {
        var cloneWindow = cloneIframeContainer.contentWindow;
        var documentClone = cloneWindow.document;
        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = $f6d8b3161743da3b$var$iframeLoader(cloneIframeContainer).then(function() {
            cloner.scrolledElements.forEach($f6d8b3161743da3b$var$initNode);
            cloneWindow.scrollTo(bounds.left, bounds.top);
            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
                documentClone.documentElement.style.top = -bounds.top + 'px';
                documentClone.documentElement.style.left = -bounds.left + 'px';
                documentClone.documentElement.style.position = 'absolute';
            }
            var result = Promise.resolve([
                cloneIframeContainer,
                cloner.clonedReferenceElement,
                cloner.resourceLoader
            ]);
            var onclone = options.onclone;
            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function() {
                return onclone(documentClone);
            }).then(function() {
                return result;
            }) : result : Promise.reject('');
        });
        documentClone.open();
        documentClone.write($f6d8b3161743da3b$var$serializeDoctype(document.doctype) + '<html></html>');
        // Chrome scrolls the parent document for some reason after the write to the cloned window???
        $f6d8b3161743da3b$var$restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
        documentClone.close();
        return iframeLoad;
    });
};
var $f6d8b3161743da3b$var$serializeDoctype = function serializeDoctype(doctype) {
    var str = '';
    if (doctype) {
        str += '<!DOCTYPE ';
        if (doctype.name) str += doctype.name;
        if (doctype.internalSubset) str += doctype.internalSubset;
        if (doctype.publicId) str += '"' + doctype.publicId + '"';
        if (doctype.systemId) str += '"' + doctype.systemId + '"';
        str += '>';
    }
    return str;
};

});
parcelRegister("fDeh2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Proxy = undefined;

var $2ivfO = parcelRequire("2ivfO");
var $b61591fe9951b83d$var$_Feature2 = $b61591fe9951b83d$var$_interopRequireDefault($2ivfO);
function $b61591fe9951b83d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b61591fe9951b83d$var$Proxy = module.exports.Proxy = function Proxy(src, options) {
    if (!options.proxy) return Promise.reject(null);
    var proxy = options.proxy;
    return new Promise(function(resolve, reject) {
        var responseType = $b61591fe9951b83d$var$_Feature2.default.SUPPORT_CORS_XHR && $b61591fe9951b83d$var$_Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
        var xhr = $b61591fe9951b83d$var$_Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
        xhr.onload = function() {
            if (xhr instanceof XMLHttpRequest) {
                if (xhr.status === 200) {
                    if (responseType === 'text') resolve(xhr.response);
                    else {
                        var reader = new FileReader();
                        // $FlowFixMe
                        reader.addEventListener('load', function() {
                            return resolve(reader.result);
                        }, false);
                        // $FlowFixMe
                        reader.addEventListener('error', function(e) {
                            return reject(e);
                        }, false);
                        reader.readAsDataURL(xhr.response);
                    }
                } else reject('');
            } else resolve(xhr.responseText);
        };
        xhr.onerror = reject;
        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);
        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
        if (options.imageTimeout) {
            var timeout = options.imageTimeout;
            xhr.timeout = timeout;
            xhr.ontimeout = function() {
                return reject('');
            };
        }
        xhr.send();
    });
};

});

parcelRegister("8tnoc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResourceStore = undefined;
var $62b32ccd11f2270d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $2ivfO = parcelRequire("2ivfO");
var $62b32ccd11f2270d$var$_Feature2 = $62b32ccd11f2270d$var$_interopRequireDefault($2ivfO);

var $fDeh2 = parcelRequire("fDeh2");
function $62b32ccd11f2270d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $62b32ccd11f2270d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $62b32ccd11f2270d$var$ResourceLoader = function() {
    function ResourceLoader(options, logger, window) {
        $62b32ccd11f2270d$var$_classCallCheck(this, ResourceLoader);
        this.options = options;
        this._window = window;
        this.origin = this.getOrigin(window.location.href);
        this.cache = {};
        this.logger = logger;
        this._index = 0;
    }
    $62b32ccd11f2270d$var$_createClass(ResourceLoader, [
        {
            key: 'loadImage',
            value: function loadImage(src) {
                var _this = this;
                if (this.hasResourceInCache(src)) return src;
                if ($62b32ccd11f2270d$var$isBlobImage(src)) {
                    this.cache[src] = $62b32ccd11f2270d$var$_loadImage(src, this.options.imageTimeout || 0);
                    return src;
                }
                if (!$62b32ccd11f2270d$var$isSVG(src) || $62b32ccd11f2270d$var$_Feature2.default.SUPPORT_SVG_DRAWING) {
                    if (this.options.allowTaint === true || $62b32ccd11f2270d$var$isInlineImage(src) || this.isSameOrigin(src)) return this.addImage(src, src, false);
                    else if (!this.isSameOrigin(src)) {
                        if (typeof this.options.proxy === 'string') {
                            this.cache[src] = (0, $fDeh2.Proxy)(src, this.options).then(function(src) {
                                return $62b32ccd11f2270d$var$_loadImage(src, _this.options.imageTimeout || 0);
                            });
                            return src;
                        } else if (this.options.useCORS === true && $62b32ccd11f2270d$var$_Feature2.default.SUPPORT_CORS_IMAGES) return this.addImage(src, src, true);
                    }
                }
            }
        },
        {
            key: 'inlineImage',
            value: function inlineImage(src) {
                var _this2 = this;
                if ($62b32ccd11f2270d$var$isInlineImage(src)) return $62b32ccd11f2270d$var$_loadImage(src, this.options.imageTimeout || 0);
                if (this.hasResourceInCache(src)) return this.cache[src];
                if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') return this.cache[src] = (0, $fDeh2.Proxy)(src, this.options).then(function(src) {
                    return $62b32ccd11f2270d$var$_loadImage(src, _this2.options.imageTimeout || 0);
                });
                return this.xhrImage(src);
            }
        },
        {
            key: 'xhrImage',
            value: function xhrImage(src) {
                var _this3 = this;
                this.cache[src] = new Promise(function(resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            if (xhr.status !== 200) reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
                            else {
                                var reader = new FileReader();
                                reader.addEventListener('load', function() {
                                    // $FlowFixMe
                                    var result = reader.result;
                                    resolve(result);
                                }, false);
                                reader.addEventListener('error', function(e) {
                                    return reject(e);
                                }, false);
                                reader.readAsDataURL(xhr.response);
                            }
                        }
                    };
                    xhr.responseType = 'blob';
                    if (_this3.options.imageTimeout) {
                        var timeout = _this3.options.imageTimeout;
                        xhr.timeout = timeout;
                        xhr.ontimeout = function() {
                            return reject('');
                        };
                    }
                    xhr.open('GET', src, true);
                    xhr.send();
                }).then(function(src) {
                    return $62b32ccd11f2270d$var$_loadImage(src, _this3.options.imageTimeout || 0);
                });
                return this.cache[src];
            }
        },
        {
            key: 'loadCanvas',
            value: function loadCanvas(node) {
                var key = String(this._index++);
                this.cache[key] = Promise.resolve(node);
                return key;
            }
        },
        {
            key: 'hasResourceInCache',
            value: function hasResourceInCache(key) {
                return typeof this.cache[key] !== 'undefined';
            }
        },
        {
            key: 'addImage',
            value: function addImage(key, src, useCORS) {
                var _this4 = this;
                var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
                    return new Promise(function(resolve, reject) {
                        var img = new Image();
                        img.onload = function() {
                            return resolve(img);
                        };
                        //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                        if (!supportsDataImages || useCORS) img.crossOrigin = 'anonymous';
                        img.onerror = reject;
                        img.src = src;
                        if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                        setTimeout(function() {
                            resolve(img);
                        }, 500);
                        if (_this4.options.imageTimeout) {
                            var timeout = _this4.options.imageTimeout;
                            setTimeout(function() {
                                return reject('');
                            }, timeout);
                        }
                    });
                };
                this.cache[key] = $62b32ccd11f2270d$var$isInlineBase64Image(src) && !$62b32ccd11f2270d$var$isSVG(src) ? $62b32ccd11f2270d$var$_Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
                return key;
            }
        },
        {
            key: 'isSameOrigin',
            value: function isSameOrigin(url) {
                return this.getOrigin(url) === this.origin;
            }
        },
        {
            key: 'getOrigin',
            value: function getOrigin(url) {
                var link = this._link || (this._link = this._window.document.createElement('a'));
                link.href = url;
                link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
                return link.protocol + link.hostname + link.port;
            }
        },
        {
            key: 'ready',
            value: function ready() {
                var _this5 = this;
                var keys = Object.keys(this.cache);
                var values = keys.map(function(str) {
                    return _this5.cache[str].catch(function(e) {
                        return null;
                    });
                });
                return Promise.all(values).then(function(images) {
                    return new $62b32ccd11f2270d$var$ResourceStore(keys, images);
                });
            }
        }
    ]);
    return ResourceLoader;
}();
module.exports.default = $62b32ccd11f2270d$var$ResourceLoader;
var $62b32ccd11f2270d$var$ResourceStore = module.exports.ResourceStore = function() {
    function ResourceStore(keys, resources) {
        $62b32ccd11f2270d$var$_classCallCheck(this, ResourceStore);
        this._keys = keys;
        this._resources = resources;
    }
    $62b32ccd11f2270d$var$_createClass(ResourceStore, [
        {
            key: 'get',
            value: function get(key) {
                var index = this._keys.indexOf(key);
                return index === -1 ? null : this._resources[index];
            }
        }
    ]);
    return ResourceStore;
}();
var $62b32ccd11f2270d$var$INLINE_SVG = /^data:image\/svg\+xml/i;
var $62b32ccd11f2270d$var$INLINE_BASE64 = /^data:image\/.*;base64,/i;
var $62b32ccd11f2270d$var$INLINE_IMG = /^data:image\/.*/i;
var $62b32ccd11f2270d$var$isInlineImage = function isInlineImage(src) {
    return $62b32ccd11f2270d$var$INLINE_IMG.test(src);
};
var $62b32ccd11f2270d$var$isInlineBase64Image = function isInlineBase64Image(src) {
    return $62b32ccd11f2270d$var$INLINE_BASE64.test(src);
};
var $62b32ccd11f2270d$var$isBlobImage = function isBlobImage(src) {
    return src.substr(0, 4) === 'blob';
};
var $62b32ccd11f2270d$var$isSVG = function isSVG(src) {
    return src.substr(-3).toLowerCase() === 'svg' || $62b32ccd11f2270d$var$INLINE_SVG.test(src);
};
var $62b32ccd11f2270d$var$_loadImage = function _loadImage(src, timeout) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = src;
        if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
        setTimeout(function() {
            resolve(img);
        }, 500);
        if (timeout) setTimeout(function() {
            return reject('');
        }, timeout);
    });
};

});

parcelRegister("2S1bh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseContent = module.exports.resolvePseudoContent = module.exports.popCounters = module.exports.parseCounterReset = module.exports.TOKEN_TYPE = module.exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;
var $21718a6c22a76f58$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $8vWh7 = parcelRequire("8vWh7");

var $dcmux = parcelRequire("dcmux");
var $21718a6c22a76f58$var$PSEUDO_CONTENT_ITEM_TYPE = module.exports.PSEUDO_CONTENT_ITEM_TYPE = {
    TEXT: 0,
    IMAGE: 1
};
var $21718a6c22a76f58$var$TOKEN_TYPE = module.exports.TOKEN_TYPE = {
    STRING: 0,
    ATTRIBUTE: 1,
    URL: 2,
    COUNTER: 3,
    COUNTERS: 4,
    OPENQUOTE: 5,
    CLOSEQUOTE: 6
};
var $21718a6c22a76f58$var$parseCounterReset = module.exports.parseCounterReset = function parseCounterReset(style, data) {
    if (!style || !style.counterReset || style.counterReset === 'none') return [];
    var counterNames = [];
    var counterResets = style.counterReset.split(/\s*,\s*/);
    var lenCounterResets = counterResets.length;
    for(var i = 0; i < lenCounterResets; i++){
        var _counterResets$i$spli = counterResets[i].split(/\s+/), _counterResets$i$spli2 = $21718a6c22a76f58$var$_slicedToArray(_counterResets$i$spli, 2), counterName = _counterResets$i$spli2[0], initialValue = _counterResets$i$spli2[1];
        counterNames.push(counterName);
        var counter = data.counters[counterName];
        if (!counter) counter = data.counters[counterName] = [];
        counter.push(parseInt(initialValue || 0, 10));
    }
    return counterNames;
};
var $21718a6c22a76f58$var$popCounters = module.exports.popCounters = function popCounters(counterNames, data) {
    var lenCounters = counterNames.length;
    for(var i = 0; i < lenCounters; i++)data.counters[counterNames[i]].pop();
};
var $21718a6c22a76f58$var$resolvePseudoContent = module.exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') return null;
    var tokens = $21718a6c22a76f58$var$parseContent(style.content);
    var len = tokens.length;
    var contentItems = [];
    var s = '';
    // increment the counter (if there is a "counter-increment" declaration)
    var counterIncrement = style.counterIncrement;
    if (counterIncrement && counterIncrement !== 'none') {
        var _counterIncrement$spl = counterIncrement.split(/\s+/), _counterIncrement$spl2 = $21718a6c22a76f58$var$_slicedToArray(_counterIncrement$spl, 2), counterName = _counterIncrement$spl2[0], incrementValue = _counterIncrement$spl2[1];
        var counter = data.counters[counterName];
        if (counter) counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
    }
    // build the content string
    for(var i = 0; i < len; i++){
        var token = tokens[i];
        switch(token.type){
            case $21718a6c22a76f58$var$TOKEN_TYPE.STRING:
                s += token.value || '';
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.ATTRIBUTE:
                if (node instanceof HTMLElement && token.value) s += node.getAttribute(token.value) || '';
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.COUNTER:
                var _counter = data.counters[token.name || ''];
                if (_counter) s += $21718a6c22a76f58$var$formatCounterValue([
                    _counter[_counter.length - 1]
                ], '', token.format);
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.COUNTERS:
                var _counters = data.counters[token.name || ''];
                if (_counters) s += $21718a6c22a76f58$var$formatCounterValue(_counters, token.glue, token.format);
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.OPENQUOTE:
                s += $21718a6c22a76f58$var$getQuote(style, true, data.quoteDepth);
                data.quoteDepth++;
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.CLOSEQUOTE:
                data.quoteDepth--;
                s += $21718a6c22a76f58$var$getQuote(style, false, data.quoteDepth);
                break;
            case $21718a6c22a76f58$var$TOKEN_TYPE.URL:
                if (s) {
                    contentItems.push({
                        type: $21718a6c22a76f58$var$PSEUDO_CONTENT_ITEM_TYPE.TEXT,
                        value: s
                    });
                    s = '';
                }
                contentItems.push({
                    type: $21718a6c22a76f58$var$PSEUDO_CONTENT_ITEM_TYPE.IMAGE,
                    value: token.value || ''
                });
                break;
        }
    }
    if (s) contentItems.push({
        type: $21718a6c22a76f58$var$PSEUDO_CONTENT_ITEM_TYPE.TEXT,
        value: s
    });
    return contentItems;
};
var $21718a6c22a76f58$var$parseContent = module.exports.parseContent = function parseContent(content, cache) {
    if (cache && cache[content]) return cache[content];
    var tokens = [];
    var len = content.length;
    var isString = false;
    var isEscaped = false;
    var isFunction = false;
    var str = '';
    var functionName = '';
    var args = [];
    for(var i = 0; i < len; i++){
        var c = content.charAt(i);
        switch(c){
            case "'":
            case '"':
                if (isEscaped) str += c;
                else {
                    isString = !isString;
                    if (!isFunction && !isString) {
                        tokens.push({
                            type: $21718a6c22a76f58$var$TOKEN_TYPE.STRING,
                            value: str
                        });
                        str = '';
                    }
                }
                break;
            case '\\':
                if (isEscaped) {
                    str += c;
                    isEscaped = false;
                } else isEscaped = true;
                break;
            case '(':
                if (isString) str += c;
                else {
                    isFunction = true;
                    functionName = str;
                    str = '';
                    args = [];
                }
                break;
            case ')':
                if (isString) str += c;
                else if (isFunction) {
                    if (str) args.push(str);
                    switch(functionName){
                        case 'attr':
                            if (args.length > 0) tokens.push({
                                type: $21718a6c22a76f58$var$TOKEN_TYPE.ATTRIBUTE,
                                value: args[0]
                            });
                            break;
                        case 'counter':
                            if (args.length > 0) {
                                var counter = {
                                    type: $21718a6c22a76f58$var$TOKEN_TYPE.COUNTER,
                                    name: args[0]
                                };
                                if (args.length > 1) counter.format = args[1];
                                tokens.push(counter);
                            }
                            break;
                        case 'counters':
                            if (args.length > 0) {
                                var _counters2 = {
                                    type: $21718a6c22a76f58$var$TOKEN_TYPE.COUNTERS,
                                    name: args[0]
                                };
                                if (args.length > 1) _counters2.glue = args[1];
                                if (args.length > 2) _counters2.format = args[2];
                                tokens.push(_counters2);
                            }
                            break;
                        case 'url':
                            if (args.length > 0) tokens.push({
                                type: $21718a6c22a76f58$var$TOKEN_TYPE.URL,
                                value: args[0]
                            });
                            break;
                    }
                    isFunction = false;
                    str = '';
                }
                break;
            case ',':
                if (isString) str += c;
                else if (isFunction) {
                    args.push(str);
                    str = '';
                }
                break;
            case ' ':
            case '\t':
                if (isString) str += c;
                else if (str) {
                    $21718a6c22a76f58$var$addOtherToken(tokens, str);
                    str = '';
                }
                break;
            default:
                str += c;
        }
        if (c !== '\\') isEscaped = false;
    }
    if (str) $21718a6c22a76f58$var$addOtherToken(tokens, str);
    if (cache) cache[content] = tokens;
    return tokens;
};
var $21718a6c22a76f58$var$addOtherToken = function addOtherToken(tokens, identifier) {
    switch(identifier){
        case 'open-quote':
            tokens.push({
                type: $21718a6c22a76f58$var$TOKEN_TYPE.OPENQUOTE
            });
            break;
        case 'close-quote':
            tokens.push({
                type: $21718a6c22a76f58$var$TOKEN_TYPE.CLOSEQUOTE
            });
            break;
    }
};
var $21718a6c22a76f58$var$getQuote = function getQuote(style, isOpening, quoteDepth) {
    var quotes = style.quotes ? style.quotes.split(/\s+/) : [
        "'\"'",
        "'\"'"
    ];
    var idx = quoteDepth * 2;
    if (idx >= quotes.length) idx = quotes.length - 2;
    if (!isOpening) ++idx;
    return quotes[idx].replace(/^["']|["']$/g, '');
};
var $21718a6c22a76f58$var$formatCounterValue = function formatCounterValue(counter, glue, format) {
    var len = counter.length;
    var result = '';
    for(var i = 0; i < len; i++){
        if (i > 0) result += glue || '';
        result += (0, $8vWh7.createCounterText)(counter[i], (0, $dcmux.parseListStyleType)(format || 'decimal'), false);
    }
    return result;
};

});




parcelRegister("2yi9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $4643d39bab63e6b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $l9J5E = parcelRequire("l9J5E");

var $abgpq = parcelRequire("abgpq");

var $1BZPr = parcelRequire("1BZPr");

var $5UXob = parcelRequire("5UXob");

var $iKjFO = parcelRequire("iKjFO");

var $h7dEr = parcelRequire("h7dEr");

var $fQqnO = parcelRequire("fQqnO");
function $4643d39bab63e6b2$export$2e2bcd8739ae039({ onLoadComplete: onLoadComplete, appWidth: appWidth }) {
    const roadmapContainerRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l9J5E.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $h7dEr.container,
        style: {
            width: appWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UXob.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQqnO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $h7dEr.main
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $h7dEr.roadmap,
        ref: roadmapContainerRef
    }, (0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1BZPr.default), {
        containerRef: roadmapContainerRef,
        onLoadComplete: onLoadComplete,
        appWidth: appWidth
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), {
        containerRef: roadmapContainerRef,
        onLoadComplete: onLoadComplete,
        appWidth: appWidth
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKjFO.default), null)));
}

});
parcelRegister("1BZPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b561a5480d93d28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lGIBI = parcelRequire("lGIBI");

var $lcvrv = parcelRequire("lcvrv");

var $abgpq = parcelRequire("abgpq");

var $2q9P7 = parcelRequire("2q9P7");

var $lNNXV = parcelRequire("lNNXV");

var $jIb7y = parcelRequire("jIb7y");
// When cleaning up FF com.atlassian.rm.jpo.transposition we can remove this component entirely
const $7b561a5480d93d28$var$RoadmapExportWrapper = ({ viewMode: viewMode, isLoading: isLoading, onLoadComplete: onLoadComplete, ...props })=>{
    const [{ lazyGoalsByARI: lazyGoalsByARI }] = (0, $lGIBI.useLazyGoals)();
    const isGoalsLoading = Object.values(lazyGoalsByARI).some((goal)=>goal.isLoading);
    if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition')) {
        if (!isLoading && !isGoalsLoading && onLoadComplete) // NOTE: Similar to src/packages/portfolio-3/portfolio/src/app-export-view/view/main/view.tsx,
        // calling setTimeout here to make sure export preview snapshot is captured when all fields are ready,
        // otherwise the preview may not render correctly when the plan is small and in list mode (basically too few elements to render)
        // TODO: Find a better way to ensure isLoading is marked at a reliable timing
        setTimeout(()=>{
            onLoadComplete();
        }, 100);
        if ((0, $1ybV0.ff)('com.atlassian.rm.jpo.transposition.m2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2q9P7.default), null);
        return viewMode === (0, $lcvrv.VIEW_MODES).TIMELINE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2q9P7.default), null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $abgpq.default), props);
};
var $7b561a5480d93d28$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $jIb7y.default), {})($7b561a5480d93d28$var$RoadmapExportWrapper);

});

parcelRegister("5UXob", function(module, exports) {

$parcel$export(module.exports, "default", () => $67119cafbea7c168$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $hGckm = parcelRequire("hGckm");

var $hrifR = parcelRequire("hrifR");
var $67119cafbea7c168$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $hGckm.mapStateToProps), {})((0, $hrifR.default));

});
parcelRegister("hGckm", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $ed500a204faa7aa6$export$c31df4bd766f9c35);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");
const $ed500a204faa7aa6$var$getScenario = (0, $iK4oF.createSelector)([
    (0, $75KhQ.isMultiScenarioEnabled),
    (0, $75KhQ.getPlanScenarios),
    (0, $75KhQ.currentScenarioId)
], // eslint-disable-next-line @typescript-eslint/no-shadow
(isMultiScenarioEnabled, scenarios, currentScenarioId)=>isMultiScenarioEnabled === true ? (scenarios || []).find((scenario)=>scenario.id === currentScenarioId) : undefined);
const $ed500a204faa7aa6$export$c31df4bd766f9c35 = (state)=>({
        plan: (0, $75KhQ.getPlan)(state),
        scenario: $ed500a204faa7aa6$var$getScenario(state)
    });

});

parcelRegister("hrifR", function(module, exports) {

$parcel$export(module.exports, "default", () => $763d37eef6dca3fe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $2qhQi = parcelRequire("2qhQi");

var $gwbfD = parcelRequire("gwbfD");

var $7OR78 = parcelRequire("7OR78");

var $dwym5 = parcelRequire("dwym5");
function $763d37eef6dca3fe$var$Title({ plan: plan }) {
    if (!plan) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: plan.title || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.planTitle
    }, plan.title || ''));
}
function $763d37eef6dca3fe$var$Scenario({ scenario: scenario }) {
    if (!scenario) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
        content: scenario.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.scenario
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.scenarioColor,
        style: {
            backgroundColor: scenario.color
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.scenarioTitle
    }, scenario.title)));
}
function $763d37eef6dca3fe$var$Header({ plan: plan, scenario: scenario }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.titleBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($763d37eef6dca3fe$var$Title, {
        plan: plan
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($763d37eef6dca3fe$var$Scenario, {
        scenario: scenario
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $dwym5.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: "",
        dangerouslySetGlyph: (0, (/*@__PURE__*/$parcel$interopDefault($7OR78)))
    }))));
}
var $763d37eef6dca3fe$export$2e2bcd8739ae039 = (0, $2qhQi.default)($763d37eef6dca3fe$var$Header);

});
parcelRegister("7OR78", function(module, exports) {
module.exports = "<svg width=\"76\" height=\"32\" viewBox=\"0 0 76 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g id=\"logo-gradient-blue-jira\">\n<g clip-path=\"url(#clip0)\">\n<path d=\"M0 0H76V32H0V0Z\" fill=\"white\" fill-opacity=\"0.01\"></path>\n<g id=\"Jira\">\n<path d=\"M38.8963 6.13371H41.7283V20.1309C41.7283 23.8217 40.0434 26.3983 36.1359 26.3983C34.6661 26.3983 33.5189 26.1546 32.7302 25.876V23.195C33.5906 23.5432 34.6302 23.7173 35.6698 23.7173C38.0717 23.7173 38.8963 22.3245 38.8963 20.305V6.13371Z\" fill=\"#253858\"></path>\n<path d=\"M46.9266 5.05432C48.0379 5.05432 48.8266 5.71588 48.8266 6.89972C48.8266 8.04875 48.0379 8.74513 46.9266 8.74513C45.8152 8.74513 45.0266 8.08357 45.0266 6.89972C45.0266 5.7507 45.8152 5.05432 46.9266 5.05432ZM45.5285 10.9387H48.253V26.2591H45.5285V10.9387Z\" fill=\"#253858\"></path>\n<path d=\"M54.9924 26.2591H52.3395V10.9387H54.9924V13.6198C55.9244 11.8092 57.5018 10.5209 60.5848 10.695V13.2716C57.1075 12.9234 54.9924 13.9331 54.9924 17.2061V26.2591Z\" fill=\"#253858\"></path>\n<path d=\"M73.3112 23.5084C72.3075 25.5279 70.4075 26.5724 67.9697 26.5724C63.7754 26.5724 61.6603 23.1254 61.6603 18.5989C61.6603 14.2813 63.8829 10.6254 68.2924 10.6254C70.5867 10.6254 72.3792 11.6351 73.3112 13.6198V10.9387H76.0358V26.2591H73.3112V23.5084ZM68.6867 24.1351C71.1245 24.1351 73.2754 22.6379 73.2754 19.2256V18.007C73.2754 14.5947 71.3037 13.0975 68.9735 13.0975C65.9263 13.0975 64.349 15.0474 64.349 18.5989C64.3848 22.2897 65.8905 24.1351 68.6867 24.1351Z\" fill=\"#253858\"></path>\n</g>\n<g id=\"Icon\">\n<path id=\"Vector\" d=\"M24.664 3H12.2603C12.2603 5.99443 14.7697 8.43176 17.8527 8.43176H20.147V10.5557C20.147 13.5501 22.6565 15.9875 25.7395 15.9875V4.04457C25.7395 3.45265 25.2735 3 24.664 3Z\" fill=\"#2684FF\"></path>\n<path id=\"Vector_2\" d=\"M18.5339 8.98877H6.13013C6.13013 11.9832 8.63956 14.4205 11.7226 14.4205H14.0169V16.5793C14.0169 19.5737 16.5264 22.0111 19.6094 22.0111V10.0333C19.6094 9.47623 19.1433 8.98877 18.5339 8.98877Z\" fill=\"url(#paint0_linear)\"></path>\n<path id=\"Vector_3\" d=\"M12.4038 15.0125H0C0 18.0069 2.50943 20.4442 5.59245 20.4442H7.88679V22.5682C7.88679 25.5626 10.3962 27.9999 13.4792 27.9999V16.057C13.4792 15.4651 12.9774 15.0125 12.4038 15.0125Z\" fill=\"url(#paint1_linear)\"></path>\n</g>\n</g>\n</g>\n<defs>\n<linearGradient id=\"paint0_linear\" x1=\"19.3455\" y1=\"9.01882\" x2=\"14.2302\" y2=\"14.45\" gradientUnits=\"userSpaceOnUse\">\n<stop offset=\"0.176\" stop-color=\"#0052CC\"></stop>\n<stop offset=\"1\" stop-color=\"#2684FF\"></stop>\n</linearGradient>\n<linearGradient id=\"paint1_linear\" x1=\"13.5601\" y1=\"15.0525\" x2=\"7.63562\" y2=\"20.9874\" gradientUnits=\"userSpaceOnUse\">\n<stop offset=\"0.176\" stop-color=\"#0052CC\"></stop>\n<stop offset=\"1\" stop-color=\"#2684FF\"></stop>\n</linearGradient>\n<clipPath id=\"clip0\">\n<path d=\"M0 0H76V32H0V0Z\" fill=\"white\"></path>\n</clipPath>\n</defs>\n</svg>\n";

});

parcelRegister("dwym5", function(module, exports) {

$parcel$export(module.exports, "logoContainer", () => $028a7761fc304b43$export$a1fe6a2d7788354f, (v) => $028a7761fc304b43$export$a1fe6a2d7788354f = v);
$parcel$export(module.exports, "planTitle", () => $028a7761fc304b43$export$8b8baa6a4c19ac50, (v) => $028a7761fc304b43$export$8b8baa6a4c19ac50 = v);
$parcel$export(module.exports, "root", () => $028a7761fc304b43$export$e8e78c978b129247, (v) => $028a7761fc304b43$export$e8e78c978b129247 = v);
$parcel$export(module.exports, "scenario", () => $028a7761fc304b43$export$e2ad0c7f6240be88, (v) => $028a7761fc304b43$export$e2ad0c7f6240be88 = v);
$parcel$export(module.exports, "scenarioColor", () => $028a7761fc304b43$export$14fc1fd2bb66e100, (v) => $028a7761fc304b43$export$14fc1fd2bb66e100 = v);
$parcel$export(module.exports, "scenarioTitle", () => $028a7761fc304b43$export$7140c7d1fc768b45, (v) => $028a7761fc304b43$export$7140c7d1fc768b45 = v);
$parcel$export(module.exports, "titleBar", () => $028a7761fc304b43$export$870b5cbff008e1ed, (v) => $028a7761fc304b43$export$870b5cbff008e1ed = v);
var $028a7761fc304b43$export$a1fe6a2d7788354f;
var $028a7761fc304b43$export$8b8baa6a4c19ac50;
var $028a7761fc304b43$export$e8e78c978b129247;
var $028a7761fc304b43$export$e2ad0c7f6240be88;
var $028a7761fc304b43$export$14fc1fd2bb66e100;
var $028a7761fc304b43$export$7140c7d1fc768b45;
var $028a7761fc304b43$export$870b5cbff008e1ed;
$028a7761fc304b43$export$a1fe6a2d7788354f = `V7a83q_logoContainer`;
$028a7761fc304b43$export$8b8baa6a4c19ac50 = `V7a83q_planTitle`;
$028a7761fc304b43$export$e8e78c978b129247 = `V7a83q_root`;
$028a7761fc304b43$export$e2ad0c7f6240be88 = `V7a83q_scenario`;
$028a7761fc304b43$export$14fc1fd2bb66e100 = `V7a83q_scenarioColor`;
$028a7761fc304b43$export$7140c7d1fc768b45 = `V7a83q_scenarioTitle`;
$028a7761fc304b43$export$870b5cbff008e1ed = `V7a83q_titleBar`;

});



parcelRegister("iKjFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7322d915a0159b5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $4UWBa = parcelRequire("4UWBa");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $Iz1AD = parcelRequire("Iz1AD");

var $jET0V = parcelRequire("jET0V");

var $9OrRl = parcelRequire("9OrRl");

var $1coCP = parcelRequire("1coCP");

var $ls9vZ = parcelRequire("ls9vZ");

var $kyxVj = parcelRequire("kyxVj");

var $er73t = parcelRequire("er73t");

var $gWCUu = parcelRequire("gWCUu");

var $jb5Pp = parcelRequire("jb5Pp");
function $7322d915a0159b5f$var$Legend({ intl: intl, issueTypeLegendItems: issueTypeLegendItems = [], dependencySettings: dependencySettings = {
    display: (0, $5rYNM.DEPENDENCY_SETTINGS).DEFAULT
}, colorByValue: colorByValue = (0, $33N5G.colourByOptions).NONE, customFields: customFields = [], colorByLegends: colorByLegends = [], timelineWidth: timelineWidth = 0, fieldColumnsViewSettings: fieldColumnsViewSettings = {
    columns: []
}, ChangeIndicatorComponent: ChangeIndicatorComponent = (0, $4UWBa.default), ColorByLegendComponent: ColorByLegendComponent = (0, $Iz1AD.default), IssueTypesLegendComponent: IssueTypesLegendComponent = (0, $9OrRl.default), SystemIconsLegendComponent: SystemIconsLegendComponent = (0, $jb5Pp.default), StatusBreakdownLegendComponent: StatusBreakdownLegendComponent = (0, $er73t.default) }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        className: $gWCUu.legend
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h5", {
        className: $gWCUu.title
    }, " ", intl.formatMessage((0, $1coCP.default).legendHeader), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gWCUu.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueTypesLegendComponent, {
        issueTypeLegendItems: issueTypeLegendItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ls9vZ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColorByLegendComponent, {
        // @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps
        colorByValue: colorByValue,
        customFields: customFields,
        colorByLegends: colorByLegends,
        timelineWidth: timelineWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StatusBreakdownLegendComponent, {
        // @ts-expect-error - TS2322 - argument here seems unused, is set by mapStateToProps
        fieldColumnsViewSettings: fieldColumnsViewSettings
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyxVj.default), {
        ChangeIndicatorComponent: ChangeIndicatorComponent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SystemIconsLegendComponent, {
        dependencySettings: dependencySettings
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gWCUu.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jET0V.default), null))));
}
var $7322d915a0159b5f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($7322d915a0159b5f$var$Legend);

});
parcelRegister("Iz1AD", function(module, exports) {

$parcel$export(module.exports, "default", () => $45307771d27aa1f7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $brMoq = parcelRequire("brMoq");

var $1FZyO = parcelRequire("1FZyO");
var $45307771d27aa1f7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $brMoq.mapStateToProps), {})((0, $1FZyO.default));

});
parcelRegister("brMoq", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $c895b4dd7c15962a$export$c31df4bd766f9c35);

var $kKj1m = parcelRequire("kKj1m");

var $4GVCJ = parcelRequire("4GVCJ");

var $kyGCj = parcelRequire("kyGCj");

var $hoFKU = parcelRequire("hoFKU");
const $c895b4dd7c15962a$export$c31df4bd766f9c35 = (state)=>({
        colorByValue: (0, $kyGCj.getColorByValue)(state),
        customFields: (0, $kKj1m.getCustomFields)(state),
        colorByLegends: (0, $hoFKU.getColorByLegends)(state),
        timelineWidth: (0, $4GVCJ.getTimelineExportWidth)(state)
    });

});

parcelRegister("1FZyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b94df47b5e2adfaf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b3iuB = parcelRequire("b3iuB");

var $2qhQi = parcelRequire("2qhQi");

var $kyGCj = parcelRequire("kyGCj");

var $6oalL = parcelRequire("6oalL");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $izT8E = parcelRequire("izT8E");

var $9pY2o = parcelRequire("9pY2o");

var $5UWLG = parcelRequire("5UWLG");
function $b94df47b5e2adfaf$var$ColourByLegend({ intl: intl, colorByValue: colorByValue, customFields: customFields, colorByLegends: colorByLegends, timelineWidth: timelineWidth }) {
    const messages = {
        ...(0, $6oalL.default),
        issueType: (0, $ib5d3.default).issueType,
        allOtherIssues: (0, $ib5d3.default).allOtherIssues,
        label: (0, $ib5d3.default).label
    };
    if ($b3iuB.default(timelineWidth) || $b3iuB.default(colorByLegends)) return null;
    let colorByValueTitle = '';
    if ((0, $kyGCj.isColorByCustomFieldOption)(colorByValue)) {
        const customField = customFields.find((field)=>field.id === Number(colorByValue));
        if (customField) colorByValueTitle = customField.title;
    } else colorByValueTitle = intl.formatMessage(messages[colorByValue]);
    // displaying "All other issues" color option only if the plan is colored by component, issue type, label, priority or custom field
    const showAllOtherIssuesColorLabel = colorByValue === (0, $33N5G.colourByOptions).COMPONENT || colorByValue === (0, $33N5G.colourByOptions).ISSUE_TYPE || colorByValue === (0, $33N5G.colourByOptions).LABEL || colorByValue === (0, $33N5G.colourByOptions).PRIORITY || (0, $kyGCj.isColorByCustomFieldOption)(colorByValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: `${intl.formatMessage(messages.colorBy)} (${colorByValueTitle})`
    }, showAllOtherIssuesColorLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pY2o.default), {
        key: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UWLG.default), {
        color: (0, $33N5G.DEFAULT_COLOR),
        label: intl.formatMessage(messages.allOtherIssues)
    })), colorByLegends.map((colorByLegend, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pY2o.default), {
            key: index + 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UWLG.default), {
            color: colorByLegend.color,
            label: colorByLegend.label
        }))));
}
var $b94df47b5e2adfaf$export$2e2bcd8739ae039 = (0, $2qhQi.default)($b94df47b5e2adfaf$var$ColourByLegend);

});
parcelRegister("izT8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $75e92770bbee35e6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gWCUu = parcelRequire("gWCUu");
function $75e92770bbee35e6$export$2e2bcd8739ae039({ title: title, children: children, childrenMaxWidth: childrenMaxWidth = '300px' }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gWCUu.legendContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h6", {
        className: $gWCUu.legendTitle
    }, title, ": "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gWCUu.legendItems,
        style: {
            maxWidth: childrenMaxWidth
        }
    }, children)));
}

});
parcelRegister("gWCUu", function(module, exports) {

$parcel$export(module.exports, "bar", () => $c5603ed6c902d146$export$d927737047eb3867, (v) => $c5603ed6c902d146$export$d927737047eb3867 = v);
$parcel$export(module.exports, "changeIndicatorContainer", () => $c5603ed6c902d146$export$7820836831999fc2, (v) => $c5603ed6c902d146$export$7820836831999fc2 = v);
$parcel$export(module.exports, "content", () => $c5603ed6c902d146$export$a7db06668cad9adb, (v) => $c5603ed6c902d146$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "footer", () => $c5603ed6c902d146$export$adb608be33961c98, (v) => $c5603ed6c902d146$export$adb608be33961c98 = v);
$parcel$export(module.exports, "legend", () => $c5603ed6c902d146$export$9a9b59e08de24cef, (v) => $c5603ed6c902d146$export$9a9b59e08de24cef = v);
$parcel$export(module.exports, "legendContainer", () => $c5603ed6c902d146$export$3a5ac273ad263bbd, (v) => $c5603ed6c902d146$export$3a5ac273ad263bbd = v);
$parcel$export(module.exports, "legendItem", () => $c5603ed6c902d146$export$ca5d1eadfed8df75, (v) => $c5603ed6c902d146$export$ca5d1eadfed8df75 = v);
$parcel$export(module.exports, "legendItemColor", () => $c5603ed6c902d146$export$788afbc176e60ed8, (v) => $c5603ed6c902d146$export$788afbc176e60ed8 = v);
$parcel$export(module.exports, "legendItemIcon", () => $c5603ed6c902d146$export$29004005cb5a474e, (v) => $c5603ed6c902d146$export$29004005cb5a474e = v);
$parcel$export(module.exports, "legendItemText", () => $c5603ed6c902d146$export$c02d0ead553caca7, (v) => $c5603ed6c902d146$export$c02d0ead553caca7 = v);
$parcel$export(module.exports, "legendItems", () => $c5603ed6c902d146$export$41c4f1a1b74f0408, (v) => $c5603ed6c902d146$export$41c4f1a1b74f0408 = v);
$parcel$export(module.exports, "legendTitle", () => $c5603ed6c902d146$export$ee051a14ea41fb53, (v) => $c5603ed6c902d146$export$ee051a14ea41fb53 = v);
$parcel$export(module.exports, "systemIcon", () => $c5603ed6c902d146$export$7f008be803e377ce, (v) => $c5603ed6c902d146$export$7f008be803e377ce = v);
$parcel$export(module.exports, "title", () => $c5603ed6c902d146$export$fb184b623420d9be, (v) => $c5603ed6c902d146$export$fb184b623420d9be = v);
$parcel$export(module.exports, "triangle", () => $c5603ed6c902d146$export$9eed783d03e0135c, (v) => $c5603ed6c902d146$export$9eed783d03e0135c = v);
var $c5603ed6c902d146$export$d927737047eb3867;
var $c5603ed6c902d146$export$7820836831999fc2;
var $c5603ed6c902d146$export$a7db06668cad9adb;
var $c5603ed6c902d146$export$adb608be33961c98;
var $c5603ed6c902d146$export$9a9b59e08de24cef;
var $c5603ed6c902d146$export$3a5ac273ad263bbd;
var $c5603ed6c902d146$export$ca5d1eadfed8df75;
var $c5603ed6c902d146$export$788afbc176e60ed8;
var $c5603ed6c902d146$export$29004005cb5a474e;
var $c5603ed6c902d146$export$c02d0ead553caca7;
var $c5603ed6c902d146$export$41c4f1a1b74f0408;
var $c5603ed6c902d146$export$ee051a14ea41fb53;
var $c5603ed6c902d146$export$7f008be803e377ce;
var $c5603ed6c902d146$export$fb184b623420d9be;
var $c5603ed6c902d146$export$9eed783d03e0135c;
$c5603ed6c902d146$export$d927737047eb3867 = `_4_0bva_bar`;
$c5603ed6c902d146$export$7820836831999fc2 = `_4_0bva_changeIndicatorContainer`;
$c5603ed6c902d146$export$a7db06668cad9adb = `_4_0bva_content`;
$c5603ed6c902d146$export$adb608be33961c98 = `_4_0bva_footer`;
$c5603ed6c902d146$export$9a9b59e08de24cef = `_4_0bva_legend`;
$c5603ed6c902d146$export$3a5ac273ad263bbd = `_4_0bva_legendContainer`;
$c5603ed6c902d146$export$ca5d1eadfed8df75 = `_4_0bva_legendItem`;
$c5603ed6c902d146$export$788afbc176e60ed8 = `_4_0bva_legendItemColor`;
$c5603ed6c902d146$export$29004005cb5a474e = `_4_0bva_legendItemIcon`;
$c5603ed6c902d146$export$c02d0ead553caca7 = `_4_0bva_legendItemText`;
$c5603ed6c902d146$export$41c4f1a1b74f0408 = `_4_0bva_legendItems`;
$c5603ed6c902d146$export$ee051a14ea41fb53 = `_4_0bva_legendTitle`;
$c5603ed6c902d146$export$7f008be803e377ce = `_4_0bva_systemIcon`;
$c5603ed6c902d146$export$fb184b623420d9be = `_4_0bva_title`;
$c5603ed6c902d146$export$9eed783d03e0135c = `_4_0bva_triangle`;

});


parcelRegister("9pY2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa4670d457a6aca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gWCUu = parcelRequire("gWCUu");
function $4aa4670d457a6aca$export$2e2bcd8739ae039({ children: children }) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $gWCUu.legendItem
    }, children);
}

});

parcelRegister("5UWLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c131c52df06d3f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $48zJl = parcelRequire("48zJl");
function $f6c131c52df06d3f$export$2e2bcd8739ae039({ label: label, color: color }) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $48zJl.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $48zJl.color,
        style: {
            backgroundColor: color
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, label)));
}

});
parcelRegister("48zJl", function(module, exports) {

$parcel$export(module.exports, "color", () => $3033a012d748c9ed$export$35e9368ef982300f, (v) => $3033a012d748c9ed$export$35e9368ef982300f = v);
$parcel$export(module.exports, "container", () => $3033a012d748c9ed$export$34e0f9847d4c02dd, (v) => $3033a012d748c9ed$export$34e0f9847d4c02dd = v);
var $3033a012d748c9ed$export$35e9368ef982300f;
var $3033a012d748c9ed$export$34e0f9847d4c02dd;
$3033a012d748c9ed$export$35e9368ef982300f = `_31VSRq_color`;
$3033a012d748c9ed$export$34e0f9847d4c02dd = `_31VSRq_container`;

});




parcelRegister("jET0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $106dd0d145f434b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $eTbtL = parcelRequire("eTbtL");
var $l2Sj2 = parcelRequire("l2Sj2");

var $aMoMC = parcelRequire("aMoMC");

var $1coCP = parcelRequire("1coCP");
function $106dd0d145f434b2$var$ExportDate({ intl: intl }) {
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, intl.formatMessage((0, $1coCP.default).exportDisclaimerSpork, {
        date: formatTimestamp((0, $aMoMC.getTodayDate)().getTime(), (0, $eTbtL.shortDateFormat))
    }));
}
var $106dd0d145f434b2$export$2e2bcd8739ae039 = (0, $2qhQi.default)($106dd0d145f434b2$var$ExportDate);

});
parcelRegister("1coCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23952556858024c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d23952556858024c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    legendHeader: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.legend-header",
        "defaultMessage": "Legend"
    },
    systemIconsLegendHeader: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.system-icons-legend-header",
        "defaultMessage": "System icons"
    },
    scenarioChangesLegendHeader: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.scenario-changes-legend-header",
        "defaultMessage": "Scenario changes"
    },
    dateFieldIcon: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.date-field-icon",
        "defaultMessage": "Start/end date field"
    },
    sprintInferredDateIcon: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.sprint-inferred-date-icon",
        "defaultMessage": "Date inferred from sprint"
    },
    releaseInferredDateIcon: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.release-inferred-date-icon",
        "defaultMessage": "Date inferred from release"
    },
    rolledUpValueIcon: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.rolled-up-value-icon",
        "defaultMessage": "Rolled-up value"
    },
    externalIcon: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.external-icon",
        "defaultMessage": "Teams and sprints currently not in this plan"
    },
    unsavedCreatedIssues: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.unsaved-created-issues",
        "defaultMessage": "Unsaved created issues"
    },
    exportDisclaimerSpork: {
        "id": "portfolio-3-portfolio.app-export-view.main.legend.export-disclaimer-spork",
        "defaultMessage": "Exported on {date} | Powered by Jira"
    }
});

});


parcelRegister("9OrRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ccae6ac6f241bd$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $3Mt4h = parcelRequire("3Mt4h");

var $fCTc3 = parcelRequire("fCTc3");
var $c8ccae6ac6f241bd$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $3Mt4h.mapStateToProps), {})((0, $fCTc3.default));

});
parcelRegister("3Mt4h", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $357f6c9b21cde43d$export$c31df4bd766f9c35);

var $ieygu = parcelRequire("ieygu");
var $3by2Y = parcelRequire("3by2Y");
var $f7Op5 = parcelRequire("f7Op5");
var $l7xwn = parcelRequire("l7xwn");

var $fZW8G = parcelRequire("fZW8G");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");

var $iK4oF = parcelRequire("iK4oF");
const $357f6c9b21cde43d$export$1c7330205a63763a = (enrichedHierarchyLevels, issueTypeIdsOfCompanyManagedProjects, filteredIssues)=>{
    const visibleIssueTypes = new Set(filteredIssues.map((issue)=>issue.type));
    // Sort issue types by hierarchy level descending and filter to only the visible issue types
    const sortedLevels = $l7xwn.default($ieygu.default($f7Op5.default('level')), enrichedHierarchyLevels);
    const issueTypes = sortedLevels.flatMap((level)=>level.issueTypes).filter((issueType)=>visibleIssueTypes.has(issueType.id));
    // Split the sorted issue types by company managed or team managed
    const [companyManagedIssueTypes, teamManagedIssueTypes] = $3by2Y.default((issueType)=>issueTypeIdsOfCompanyManagedProjects.includes(issueType.id), issueTypes);
    // Create mapping function to group issue types by name and remove any duplicated icons
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueTypeIconsGroupByName = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mapIssueTypeNameWithIconUrl = (issueType)=>{
        if (!issueTypeIconsGroupByName[issueType.name]) issueTypeIconsGroupByName[issueType.name] = [
            issueType.iconUrl
        ];
        else if (!issueTypeIconsGroupByName[issueType.name].includes(issueType.iconUrl)) issueTypeIconsGroupByName[issueType.name].push(issueType.iconUrl);
    };
    // Run the mapping function on the company managed issue types first
    // then on the team managed ones
    companyManagedIssueTypes.forEach(mapIssueTypeNameWithIconUrl);
    teamManagedIssueTypes.forEach(mapIssueTypeNameWithIconUrl);
    // Construct issue type legend items
    const issueTypeLegendItems = [];
    for(const name in issueTypeIconsGroupByName)if (issueTypeIconsGroupByName[name]) issueTypeLegendItems.push({
        name: name,
        iconUrls: issueTypeIconsGroupByName[name]
    });
    return issueTypeLegendItems;
};
const $357f6c9b21cde43d$var$getIssueTypeLegendItems = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getEnrichedHierarchyLevels),
    (0, $lihml.getIssueTypeIdsOfCompanyManagedProjects),
    (0, $kwMvv.getFilteredIssues)
], $357f6c9b21cde43d$export$1c7330205a63763a);
const $357f6c9b21cde43d$export$c31df4bd766f9c35 = (state)=>({
        issueTypeLegendItems: $357f6c9b21cde43d$var$getIssueTypeLegendItems(state)
    });

});
parcelRegister("ieygu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4641d20aa2c10ee$export$2e2bcd8739ae039);

var $4g10W = parcelRequire("4g10W");
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $d4641d20aa2c10ee$var$descend = /*#__PURE__*/ (0, $4g10W.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $d4641d20aa2c10ee$export$2e2bcd8739ae039 = $d4641d20aa2c10ee$var$descend;

});


parcelRegister("fCTc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd1d5b2482e5b1b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $ib5d3 = parcelRequire("ib5d3");

var $izT8E = parcelRequire("izT8E");

var $9pY2o = parcelRequire("9pY2o");

var $gWCUu = parcelRequire("gWCUu");
function $cd1d5b2482e5b1b8$var$IssueTypesLegend({ intl: intl, issueTypeLegendItems: issueTypeLegendItems }) {
    if (!issueTypeLegendItems || issueTypeLegendItems.length <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: intl.formatMessage((0, $ib5d3.default).issueType)
    }, issueTypeLegendItems.map((legendItem, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pY2o.default), {
            key: index
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        legendItem.iconUrls.map((iconUrl, index)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                alt: "",
                key: index,
                className: $gWCUu.legendItemIcon,
                src: iconUrl
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gWCUu.legendItemText
        }, legendItem.name))));
}
var $cd1d5b2482e5b1b8$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cd1d5b2482e5b1b8$var$IssueTypesLegend);

});


parcelRegister("ls9vZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c0bc2d569e38605$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $eVlrT = parcelRequire("eVlrT");
var $0eEBc = parcelRequire("0eEBc");

var $ib5d3 = parcelRequire("ib5d3");

var $izT8E = parcelRequire("izT8E");

var $lvI8e = parcelRequire("lvI8e");
parcelRequire("gWCUu");
function $1c0bc2d569e38605$var$ReleaseLegend({ intl: intl }) {
    const legendItems = [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVlrT.default), {
                type: (0, $0eEBc.ICON_TYPES).ONTRACK,
                totalCount: 1,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClick: ()=>{}
            }),
            text: intl.formatMessage((0, $ib5d3.default).onTrackRelease)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVlrT.default), {
                type: (0, $0eEBc.ICON_TYPES).OFFTRACK,
                totalCount: 1,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClick: ()=>{}
            }),
            text: intl.formatMessage((0, $ib5d3.default).offTrackRelease)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eVlrT.default), {
                type: (0, $0eEBc.ICON_TYPES).RELEASED,
                totalCount: 1,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClick: ()=>{}
            }),
            text: intl.formatMessage((0, $ib5d3.default).releasedRelease)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: intl.formatMessage((0, $ib5d3.default).release)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvI8e.default), {
        items: legendItems
    }));
}
var $1c0bc2d569e38605$export$2e2bcd8739ae039 = (0, $2qhQi.default)($1c0bc2d569e38605$var$ReleaseLegend);

});
parcelRegister("lvI8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd4b062be214587$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9pY2o = parcelRequire("9pY2o");

var $gWCUu = parcelRequire("gWCUu");
function $abd4b062be214587$export$2e2bcd8739ae039({ items: items }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pY2o.default), {
            key: index
        }, item.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: $gWCUu.legendItemText
        }, item.text))));
}

});


parcelRegister("kyxVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $42196a1a8ef922fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $4UWBa = parcelRequire("4UWBa");

var $ib5d3 = parcelRequire("ib5d3");

var $izT8E = parcelRequire("izT8E");

var $lvI8e = parcelRequire("lvI8e");

var $1coCP = parcelRequire("1coCP");

var $gWCUu = parcelRequire("gWCUu");
function $42196a1a8ef922fb$var$ScenarioChangesLegend({ intl: intl, ChangeIndicatorComponent: ChangeIndicatorComponent = (0, $4UWBa.default) }) {
    const legendItems = [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: `${$gWCUu.changeIndicatorContainer} ${$gWCUu.bar}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeIndicatorComponent, {
                appearance: "bar"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: `${$gWCUu.changeIndicatorContainer} ${$gWCUu.triangle}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeIndicatorComponent, {
                appearance: "triangle"
            }))),
            text: intl.formatMessage((0, $ib5d3.default).unsavedChanges)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: intl.formatMessage((0, $1coCP.default).scenarioChangesLegendHeader),
        childrenMaxWidth: "400px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvI8e.default), {
        items: legendItems
    }));
}
var $42196a1a8ef922fb$export$2e2bcd8739ae039 = (0, $2qhQi.default)($42196a1a8ef922fb$var$ScenarioChangesLegend);

});

parcelRegister("er73t", function(module, exports) {

$parcel$export(module.exports, "default", () => $813b34ad45aa12dc$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $7IbHz = parcelRequire("7IbHz");

var $2srkk = parcelRequire("2srkk");
var $813b34ad45aa12dc$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $7IbHz.mapStateToProps), {})((0, $2srkk.default));

});
parcelRegister("7IbHz", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $fb37d407cd493db5$export$c31df4bd766f9c35);

var $9H2AP = parcelRequire("9H2AP");
const $fb37d407cd493db5$export$c31df4bd766f9c35 = (state)=>({
        fieldColumnsViewSettings: (0, $9H2AP.getFieldColumnsViewSettingsByViewMode)(state)
    });

});

parcelRegister("2srkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $372959a76ffc6f43$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $i0RGP = parcelRequire("i0RGP");
var $b3iuB = parcelRequire("b3iuB");
var $h3f0m = parcelRequire("h3f0m");

var $2qhQi = parcelRequire("2qhQi");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $ib5d3 = parcelRequire("ib5d3");

var $3c22F = parcelRequire("3c22F");

var $izT8E = parcelRequire("izT8E");

var $lvI8e = parcelRequire("lvI8e");

var $gWCUu = parcelRequire("gWCUu");
function $372959a76ffc6f43$var$StatusBreakdownLegend({ intl: intl, fieldColumnsViewSettings: fieldColumnsViewSettings }) {
    // Don't show this legend if status breakdown column is not visible
    if ($b3iuB.default(fieldColumnsViewSettings) || $b3iuB.default(fieldColumnsViewSettings.columns)) return null;
    const breakdownColumn = $i0RGP.default($h3f0m.default('id', 'breakdown'))(fieldColumnsViewSettings.columns);
    if (!(0, $7CnHa.isDefined)(breakdownColumn) || !breakdownColumn?.isVisible) return null;
    const legendItems = [
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $gWCUu.legendItemColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    backgroundColor: (0, $33N5G.statusBreakdownColourMap).TODO
                }
            }),
            text: intl.formatMessage((0, $3c22F.default).todo)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $gWCUu.legendItemColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    backgroundColor: (0, $33N5G.statusBreakdownColourMap).INPROGRESS
                }
            }),
            text: intl.formatMessage((0, $3c22F.default).inprogress)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: $gWCUu.legendItemColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    backgroundColor: (0, $33N5G.statusBreakdownColourMap).DONE
                }
            }),
            text: intl.formatMessage((0, $3c22F.default).done)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: intl.formatMessage((0, $ib5d3.default).statusBreakdown)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvI8e.default), {
        items: legendItems
    }));
}
var $372959a76ffc6f43$export$2e2bcd8739ae039 = (0, $2qhQi.default)($372959a76ffc6f43$var$StatusBreakdownLegend);

});


parcelRegister("jb5Pp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b832a63b7747bfe$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $52aSL = parcelRequire("52aSL");

var $8yGWr = parcelRequire("8yGWr");
var $9b832a63b7747bfe$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $52aSL.mapStateToProps), {})((0, $8yGWr.default));

});
parcelRegister("52aSL", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $6464da324039a4da$export$c31df4bd766f9c35);

var $9H2AP = parcelRequire("9H2AP");
const $6464da324039a4da$export$c31df4bd766f9c35 = (state)=>({
        dependencySettings: (0, $9H2AP.getDependencySettings)(state)
    });

});

parcelRegister("8yGWr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c5a2008977892f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fyp42 = parcelRequire("fyp42");

var $k4jc8 = parcelRequire("k4jc8");

var $2qhQi = parcelRequire("2qhQi");

var $ffiyv = parcelRequire("ffiyv");

var $cc2RB = parcelRequire("cc2RB");
parcelRequire("2Bjja");
var $b1b5T = parcelRequire("b1b5T");

var $jGqUJ = parcelRequire("jGqUJ");

var $ib5d3 = parcelRequire("ib5d3");

var $izT8E = parcelRequire("izT8E");

var $lvI8e = parcelRequire("lvI8e");

var $1coCP = parcelRequire("1coCP");

var $gWCUu = parcelRequire("gWCUu");
function $d4c5a2008977892f$var$SystemIconsLegend({ intl: intl, dependencySettings: { display: display } }) {
    const legendItems = [
        {
            icon: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "D")),
            text: intl.formatMessage((0, $1coCP.default).dateFieldIcon)
        },
        {
            icon: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "S")),
            text: intl.formatMessage((0, $1coCP.default).sprintInferredDateIcon)
        },
        {
            icon: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, "R")),
            text: intl.formatMessage((0, $1coCP.default).releaseInferredDateIcon)
        },
        {
            icon: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1b5T.default), {
                label: ""
            })),
            text: intl.formatMessage((0, $1coCP.default).rolledUpValueIcon)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyp42))), {
                label: ""
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4jc8))), {
                label: ""
            }))),
            text: intl.formatMessage((0, $ib5d3.default).datesOutsideRange)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jGqUJ.default), {
                withWarning: false,
                dependencyDisplay: display
            }),
            text: intl.formatMessage((0, $ib5d3.default).dependency)
        },
        {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jGqUJ.default), {
                withWarning: true,
                dependencyDisplay: display
            }),
            text: intl.formatMessage((0, $ib5d3.default).dependencyWarning)
        },
        {
            icon: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: $gWCUu.systemIcon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, intl.formatMessage((0, $cc2RB.default).externalLozengeShort))),
            text: intl.formatMessage((0, $1coCP.default).externalIcon)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izT8E.default), {
        title: intl.formatMessage((0, $1coCP.default).systemIconsLegendHeader),
        childrenMaxWidth: "450px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lvI8e.default), {
        items: legendItems
    }));
}
var $d4c5a2008977892f$export$2e2bcd8739ae039 = (0, $2qhQi.default)($d4c5a2008977892f$var$SystemIconsLegend);

});
parcelRegister("jGqUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d278eab9e11757$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3fJGp = parcelRequire("3fJGp");

var $5rYNM = parcelRequire("5rYNM");

var $0uMZ8 = parcelRequire("0uMZ8");
function $17d278eab9e11757$export$2e2bcd8739ae039({ withWarning: withWarning, dependencyDisplay: dependencyDisplay }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, dependencyDisplay === (0, $5rYNM.DEPENDENCY_SETTINGS).LINES && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$0uMZ8.dependencyLine} ${withWarning ? $0uMZ8.dependencyLineWithWarning : ''}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${$0uMZ8.harmonisedDependency} ${withWarning ? $0uMZ8.harmonisedDependencyWithWarning : ''}`
    }, dependencyDisplay !== (0, $5rYNM.DEPENDENCY_SETTINGS).COUNT ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
        label: "",
        size: "small"
    }) : '1'));
}

});
parcelRegister("0uMZ8", function(module, exports) {

$parcel$export(module.exports, "dependencyLine", () => $0017e2459c4e07d1$export$3aac61385c53c989, (v) => $0017e2459c4e07d1$export$3aac61385c53c989 = v);
$parcel$export(module.exports, "dependencyLineWithWarning", () => $0017e2459c4e07d1$export$82e2153d71e78692, (v) => $0017e2459c4e07d1$export$82e2153d71e78692 = v);
$parcel$export(module.exports, "harmonisedDependency", () => $0017e2459c4e07d1$export$16a71d39305b088f, (v) => $0017e2459c4e07d1$export$16a71d39305b088f = v);
$parcel$export(module.exports, "harmonisedDependencyWithWarning", () => $0017e2459c4e07d1$export$5d378888c00e6f1, (v) => $0017e2459c4e07d1$export$5d378888c00e6f1 = v);
var $0017e2459c4e07d1$export$3aac61385c53c989;
var $0017e2459c4e07d1$export$82e2153d71e78692;
var $0017e2459c4e07d1$export$16a71d39305b088f;
var $0017e2459c4e07d1$export$5d378888c00e6f1;
$0017e2459c4e07d1$export$3aac61385c53c989 = `nTJQua_dependencyLine`;
$0017e2459c4e07d1$export$82e2153d71e78692 = `nTJQua_dependencyLineWithWarning`;
$0017e2459c4e07d1$export$16a71d39305b088f = `nTJQua_harmonisedDependency`;
$0017e2459c4e07d1$export$5d378888c00e6f1 = `nTJQua_harmonisedDependencyWithWarning`;

});





parcelRegister("h7dEr", function(module, exports) {

$parcel$export(module.exports, "app", () => $c75dadff7d528585$export$729c8b7179294ba, (v) => $c75dadff7d528585$export$729c8b7179294ba = v);
$parcel$export(module.exports, "container", () => $c75dadff7d528585$export$34e0f9847d4c02dd, (v) => $c75dadff7d528585$export$34e0f9847d4c02dd = v);
$parcel$export(module.exports, "main", () => $c75dadff7d528585$export$f22da7240b7add18, (v) => $c75dadff7d528585$export$f22da7240b7add18 = v);
$parcel$export(module.exports, "roadmap", () => $c75dadff7d528585$export$9c71dede7933041b, (v) => $c75dadff7d528585$export$9c71dede7933041b = v);
var $c75dadff7d528585$export$729c8b7179294ba;
var $c75dadff7d528585$export$34e0f9847d4c02dd;
var $c75dadff7d528585$export$9a9b59e08de24cef;
var $c75dadff7d528585$export$f22da7240b7add18;
var $c75dadff7d528585$export$9c71dede7933041b;
$c75dadff7d528585$export$729c8b7179294ba = `LeCnga_app`;
$c75dadff7d528585$export$34e0f9847d4c02dd = `LeCnga_container`;
$c75dadff7d528585$export$9a9b59e08de24cef = `LeCnga_legend`;
$c75dadff7d528585$export$f22da7240b7add18 = `LeCnga_main`;
$c75dadff7d528585$export$9c71dede7933041b = `LeCnga_roadmap`;

});

parcelRegister("fQqnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d0451c060d509a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9k6gr = parcelRequire("9k6gr");

var $gs427 = parcelRequire("gs427");
var $f5d0451c060d509a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9k6gr.mapStateToProps), {})((0, $gs427.default));

});
parcelRegister("9k6gr", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $075dfa6af64ed2cd$export$c31df4bd766f9c35);

var $i0RGP = parcelRequire("i0RGP");
var $h3f0m = parcelRequire("h3f0m");

var $kKj1m = parcelRequire("kKj1m");

var $6WF4e = parcelRequire("6WF4e");

var $fbHoQ = parcelRequire("fbHoQ");

var $fZW8G = parcelRequire("fZW8G");

var $75KhQ = parcelRequire("75KhQ");

var $aMoMC = parcelRequire("aMoMC");

var $9H2AP = parcelRequire("9H2AP");

var $kyGCj = parcelRequire("kyGCj");


var $iK4oF = parcelRequire("iK4oF");
const $075dfa6af64ed2cd$export$e57e1ccf601b80ee = (hierarchy, { [(0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc)]: { value: { start: start, end: end } } })=>({
        from: $i0RGP.default($h3f0m.default('level', start), hierarchy)?.title || '',
        to: $i0RGP.default($h3f0m.default('level', end), hierarchy)?.title || ''
    });
const $075dfa6af64ed2cd$var$getHierarchyRangeLabels = (0, $iK4oF.createSelector)([
    (0, $fZW8G.getHierarchy),
    (0, $fbHoQ.getFilters)
], $075dfa6af64ed2cd$export$e57e1ccf601b80ee);
const $075dfa6af64ed2cd$export$c31df4bd766f9c35 = (state)=>({
        hierarchyRange: $075dfa6af64ed2cd$var$getHierarchyRangeLabels(state),
        timelineRange: (0, $aMoMC.getTimelineRange)(state),
        groupBy: (0, $kyGCj.getVisualisationGrouping)(state),
        colorBy: (0, $kyGCj.getColorByValue)(state),
        rollupSettings: (0, $9H2AP.getRollupViewSettings)(state),
        sorting: (0, $kyGCj.getVisualisationSorting)(state),
        planningUnit: (0, $75KhQ.getPlanningUnit)(state),
        customFields: (0, $kKj1m.getCustomFields)(state),
        filterCount: (0, $fbHoQ.getFilterCount)(state),
        warningSettings: (0, $9H2AP.getWarningViewSettings)(state),
        showFullHierarchy: (0, $6WF4e.getShowFullHierarchy)(state)
    });

});

parcelRegister("gs427", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ced15fcc64e2810$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $l2Sj2 = parcelRequire("l2Sj2");
parcelRequire("1Uotp");
var $chgK5 = parcelRequire("chgK5");

var $5LXYp = parcelRequire("5LXYp");

var $62d8R = parcelRequire("62d8R");

var $7CnHa = parcelRequire("7CnHa");

var $33N5G = parcelRequire("33N5G");

var $5rYNM = parcelRequire("5rYNM");

var $ayXoc = parcelRequire("ayXoc");

var $9RUk7 = parcelRequire("9RUk7");

var $ib5d3 = parcelRequire("ib5d3");

var $eQ2m5 = parcelRequire("eQ2m5");

var $b1W2O = parcelRequire("b1W2O");

var $50hWa = parcelRequire("50hWa");
const $0ced15fcc64e2810$export$43121141bf3aa833 = ({ title: title, items: items })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $50hWa.group
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $50hWa.groupTitle
    }, title, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $50hWa.groupContent
    }, items.map((item, i)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: `item-${i}`,
            className: $50hWa.groupContentItem
        }, item))));
function $0ced15fcc64e2810$export$2e2bcd8739ae039({ hierarchyRange: hierarchyRange, timelineRange: timelineRange, groupBy: groupBy, colorBy: colorBy, rollupSettings: rollupSettings, sorting: sorting, customFields: customFields, planningUnit: planningUnit, filterCount: filterCount, warningSettings: warningSettings, showFullHierarchy: showFullHierarchy, FilterViewInformationComponent: FilterViewInformationComponent = (0, $eQ2m5.default) }) {
    const intl = (0, $5JgJ2.default)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const { start: start, end: end } = timelineRange;
    const rollup = (()=>{
        const { showingRolledUpDate: showingRolledUpDate, showRolledUpOthers: showRolledUpOthers } = rollupSettings;
        if (showingRolledUpDate && showRolledUpOthers) return intl.formatMessage((0, $b1W2O.default).rollupAll);
        if (showingRolledUpDate) return intl.formatMessage((0, $ib5d3.default).dates);
        if (showRolledUpOthers) return intl.formatMessage((0, $b1W2O.default).rollupOthers);
        return null;
    })();
    const sortLabel = (()=>{
        const sortOptionLabels = {
            ...(0, $62d8R.getOptionValueLabels)(intl, customFields, planningUnit),
            [(0, $chgK5.ISSUE_FIELDS).RANK]: intl.formatMessage((0, $b1W2O.default).rank)
        };
        return sortOptionLabels[sorting.field];
    })();
    const colorByLabel = (()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if ((0, $5LXYp.colorByLabelsMap)[colorBy]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return intl.formatMessage((0, $5LXYp.colorByLabelsMap)[colorBy]);
        const customField = customFields.find((field)=>`${field.id}` === colorBy);
        if (customField) return customField.title;
        return '';
    })();
    const groupByLabel = (()=>{
        if ((0, $ayXoc.isRoadmapGroupedByCustomField)(groupBy)) return (0, $9RUk7.getGroupByCustomFieldLabel)(groupBy, customFields);
        return intl.formatMessage((0, $9RUk7.getGroupByStandardFieldLabel)(groupBy));
    })();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("section", {
        className: $50hWa.viewInformation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ced15fcc64e2810$export$43121141bf3aa833, {
        title: intl.formatMessage((0, $b1W2O.default).hierarchy),
        items: [
            // eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, hierarchyRange.from), " ", intl.formatMessage((0, $b1W2O.default).hierarchySeparator), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, hierarchyRange.to), showFullHierarchy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", intl.formatMessage((0, $b1W2O.default).showFullHierarchy), ")")))
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ced15fcc64e2810$export$43121141bf3aa833, {
        title: intl.formatMessage((0, $b1W2O.default).view),
        items: [
            ...groupBy !== (0, $5rYNM.GROUPING).NONE ? [
                // eslint-disable-next-line react/jsx-key
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $ib5d3.default).groupBy)), " (", groupByLabel, ")")
            ] : [],
            ...colorBy !== (0, $33N5G.colourByOptions).NONE ? [
                // eslint-disable-next-line react/jsx-key
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $b1W2O.default).colorBy)), " (", colorByLabel, ")")
            ] : [],
            ...(0, $7CnHa.isDefined)(rollup) ? [
                // eslint-disable-next-line react/jsx-key
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $b1W2O.default).rollup)), " (", rollup, ")")
            ] : [],
            // eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $b1W2O.default).sortBy)), " (", sortLabel, ")")
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ced15fcc64e2810$export$43121141bf3aa833, {
        title: intl.formatMessage((0, $ib5d3.default).dateRange),
        items: [
            // eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, formatTimestamp(start), " - ", formatTimestamp(end)))
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ced15fcc64e2810$export$43121141bf3aa833, {
        title: intl.formatMessage((0, $b1W2O.default).filters, {
            filtersApplied: filterCount
        }),
        items: [
            filterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FilterViewInformationComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $b1W2O.default).noFilterApplied))
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0ced15fcc64e2810$export$43121141bf3aa833, {
        title: intl.formatMessage((0, $b1W2O.default).warnings),
        items: [
            // eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage(warningSettings.showWarning ? (0, $b1W2O.default).warningsEnabled : (0, $b1W2O.default).warningsDisabled)))
        ]
    })));
}

});
parcelRegister("eQ2m5", function(module, exports) {

$parcel$export(module.exports, "default", () => $24cde377be5af2db$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $g1TA1 = parcelRequire("g1TA1");

var $8DoQA = parcelRequire("8DoQA");
var $24cde377be5af2db$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $g1TA1.mapStateToProps), {})((0, $8DoQA.default));

});
parcelRegister("g1TA1", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $5e5c7600935dba40$export$c31df4bd766f9c35);

var $hC4q3 = parcelRequire("hC4q3");
var $hkOxK = parcelRequire("hkOxK");
var $7d70y = parcelRequire("7d70y");
var $fpul1 = parcelRequire("fpul1");
var $cQGVO = parcelRequire("cQGVO");
var $f7Op5 = parcelRequire("f7Op5");
var $9RbxZ = parcelRequire("9RbxZ");
var $701od = parcelRequire("701od");

var $2Ruxt = parcelRequire("2Ruxt");

var $fbHoQ = parcelRequire("fbHoQ");

var $aYCQt = parcelRequire("aYCQt");
parcelRequire("2c08V");
parcelRequire("38iYP");

var $fiZs1 = parcelRequire("fiZs1");
parcelRequire("bRpYp");
parcelRequire("2vV9U");
parcelRequire("gqs5m");

var $5Rz3d = parcelRequire("5Rz3d");
parcelRequire("68BNT");

var $3nT5G = parcelRequire("3nT5G");

var $f436g = parcelRequire("f436g");

var $7hbkF = parcelRequire("7hbkF");

var $4s2RU = parcelRequire("4s2RU");
parcelRequire("5mAJ1");
parcelRequire("77IHm");
parcelRequire("kahmZ");

var $fZW8G = parcelRequire("fZW8G");

var $e4IaE = parcelRequire("e4IaE");

var $94enn = parcelRequire("94enn");

var $jp3RH = parcelRequire("jp3RH");

var $lihml = parcelRequire("lihml");
parcelRequire("kwMvv");
var $cwP4d = parcelRequire("cwP4d");

var $ehEr2 = parcelRequire("ehEr2");

var $c1XMU = parcelRequire("c1XMU");

var $dhHiZ = parcelRequire("dhHiZ");

var $MQRDu = parcelRequire("MQRDu");

var $wcCGG = parcelRequire("wcCGG");


var $7CnHa = parcelRequire("7CnHa");

var $hFzsN = parcelRequire("hFzsN");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const { CHECKED: $5e5c7600935dba40$export$be74dcf36d511131, UNCHECKED: $5e5c7600935dba40$export$4bfe604431277125, INDETERMINATE: $5e5c7600935dba40$export$c5a6fe907430212e } = (0, $5rYNM.CHECKBOX_STATES);
const $5e5c7600935dba40$export$bb128313e7225d60 = ({ [(0, $12ee831723ccf9c2$export$53e2f8996e102881)]: { value: value } }, versionsById)=>{
    const versionNames = $cQGVO.default((releaseId)=>({
            id: releaseId,
            name: releaseId !== (0, $3nT5G.NO_RELEASE_ID) && (0, $7CnHa.isDefined)(versionsById[releaseId]) ? versionsById[releaseId].name : ''
        }), value);
    return (0, $7CnHa.isDefined)(versionNames) ? (0, $hFzsN.sortAsLowerCaseByNameProp)(versionNames) : versionNames;
};
const $5e5c7600935dba40$export$3d34688b22f8a102 = ({ [(0, $12ee831723ccf9c2$export$585fb3e81bcfccad)]: { value: crossProjectReleaseFilterValue = [] } }, crossProjectVersionsById)=>{
    const crossProjectVersionNames = (0, $hFzsN.sortAsLowerCaseByNameProp)($cQGVO.default((releaseId)=>({
            id: releaseId,
            name: (0, $7CnHa.isDefined)(crossProjectVersionsById[releaseId]) ? crossProjectVersionsById[releaseId].name : ''
        }), crossProjectReleaseFilterValue));
    return (0, $7CnHa.isDefined)(crossProjectVersionNames) ? (0, $hFzsN.sortAsLowerCaseByNameProp)(crossProjectVersionNames) : crossProjectVersionNames;
};
const $5e5c7600935dba40$export$c162eab77772db5b = ({ [(0, $12ee831723ccf9c2$export$8abe69ceb26771cd)]: { value: value } }, teamsById)=>{
    const filteredTeams = $cQGVO.default((teamId)=>({
            id: teamId,
            name: (0, $7CnHa.isDefined)(teamsById[teamId]) ? teamsById[teamId].title : ''
        }), value);
    return (0, $7CnHa.isDefined)(filteredTeams) ? (0, $hFzsN.sortAsLowerCaseByNameProp)(filteredTeams) : filteredTeams;
};
const $5e5c7600935dba40$export$e604362162a8c4a8 = ({ [(0, $12ee831723ccf9c2$export$a8ec3260a009d752)]: { value: value } }, issueTypeWithLevelById, issueTypeIconByKey)=>value.reduce((acc, issueTypeId)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeWithLevel = issueTypeWithLevelById[issueTypeId];
        if ((0, $7CnHa.isDefined)(issueTypeWithLevel)) acc.push({
            id: issueTypeId,
            name: issueTypeWithLevel.name,
            iconUrl: issueTypeIconByKey[`${issueTypeWithLevel.level} ${issueTypeWithLevel.name}`],
            // using key to store the hierarchy level
            key: `${issueTypeWithLevel.level}`
        });
        return acc;
    }, []);
const $5e5c7600935dba40$export$c96a90bda7a2e88a = ({ [(0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d)]: { value: value } }, issuePrioritiesById)=>$cQGVO.default((issuePriorityId)=>({
            id: issuePriorityId,
            name: (0, $7CnHa.isDefined)(issuePrioritiesById[issuePriorityId]) ? issuePrioritiesById[issuePriorityId].name : ''
        }), value);
const $5e5c7600935dba40$export$5cd6a8027384cc39 = ({ [(0, $12ee831723ccf9c2$export$43596ee088b165a)]: { value: value } }, assignees)=>$cQGVO.default(({ personId: personId, jiraUser: jiraUser })=>({
            id: personId,
            name: jiraUser ? jiraUser.title : ''
        }), $fpul1.default(({ personId: personId })=>$7d70y.default(personId, value), assignees));
const $5e5c7600935dba40$export$95f213f1b171139 = ({ [(0, $12ee831723ccf9c2$export$20140793a0aa2b3c)]: { value: value } }, reporters)=>$cQGVO.default(({ personId: personId, jiraUser: jiraUser })=>({
            id: personId,
            name: jiraUser ? jiraUser.title : ''
        }), $fpul1.default(({ personId: personId })=>$7d70y.default(personId, value), reporters));
const $5e5c7600935dba40$export$ff4a14ccc49fed2f = (allSprintsByIdMap, externalSprintsById, filterSprints, sprintStatesCategories)=>{
    const results = [];
    if ((0, $7CnHa.isDefined)(filterSprints)) filterSprints.forEach((sprintId)=>{
        if (sprintId !== (0, $7hbkF.NO_SPRINT_ID)) {
            let filterSprintState = (0, $7CnHa.isDefined)(allSprintsByIdMap[sprintId]) ? allSprintsByIdMap[sprintId].state : '';
            filterSprintState = (0, $7CnHa.isDefined)(externalSprintsById[sprintId]) ? (0, $5rYNM.EXTERNAL_SPRINT) : filterSprintState;
            let sprintName = (0, $7CnHa.isDefined)(allSprintsByIdMap[sprintId]) ? allSprintsByIdMap[sprintId].title : '';
            sprintName = (0, $7CnHa.isDefined)(externalSprintsById[sprintId]) ? externalSprintsById[sprintId].title : sprintName;
            const selectedSprintStateCategory = $fpul1.default(({ checkboxState: checkboxState, sprintState: sprintState })=>checkboxState === $5e5c7600935dba40$export$be74dcf36d511131 && sprintState === filterSprintState, sprintStatesCategories);
            if (!(0, $7CnHa.isDefined)(selectedSprintStateCategory) || selectedSprintStateCategory.length === 0) results.push({
                id: sprintId,
                sprintState: filterSprintState,
                sprintName: sprintName
            });
        }
    });
    return results;
};
const $5e5c7600935dba40$export$5c4d15fb439d8f5d = (filterSprints, sprintStatesCategories)=>{
    const results = [];
    if ((0, $7CnHa.isDefined)(filterSprints) && filterSprints.has((0, $7hbkF.NO_SPRINT_ID))) results.push({
        id: (0, $7hbkF.NO_SPRINT_ID)
    });
    sprintStatesCategories.forEach((category)=>{
        if (category.checkboxState === $5e5c7600935dba40$export$be74dcf36d511131) results.push({
            id: category.sprintState,
            sprintState: category.sprintState
        });
    });
    return results;
};
const $5e5c7600935dba40$export$546565c5ebb5ee41 = ({ [(0, $12ee831723ccf9c2$export$e32eeae4866f112c)]: { value: value } })=>value || '';
const $5e5c7600935dba40$export$935820a00882eac5 = ({ [(0, $12ee831723ccf9c2$export$861e775e082be75a)]: { value: value } }, issueGoalARIs)=>{
    const results = [];
    value.forEach((goal, i)=>{
        if (goal === (0, $5Rz3d.NO_LABEL_ID)) results.push({
            id: (0, $5Rz3d.NO_LABEL_ID),
            name: ''
        });
        else if (issueGoalARIs.includes(goal)) results.push({
            id: i,
            name: goal
        });
    });
    return results;
};
const $5e5c7600935dba40$export$4e797b533dddda05 = ({ [(0, $12ee831723ccf9c2$export$7e257b719377371e)]: { value: value } }, labels)=>{
    const results = [];
    value.forEach((label, i)=>{
        if (label === (0, $5Rz3d.NO_LABEL_ID)) results.push({
            id: (0, $5Rz3d.NO_LABEL_ID),
            name: ''
        });
        else if (labels.includes(label)) results.push({
            id: i,
            name: label
        });
    });
    return results;
};
const $5e5c7600935dba40$export$6dabe1ba334ec6a9 = ({ [(0, $12ee831723ccf9c2$export$9b51ec1115932c53)]: { value: value } }, statuses)=>statuses.filter(({ id: id })=>value.indexOf(id) > -1);
const $5e5c7600935dba40$export$48773ecb6624dbb4 = ({ [(0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8)]: { value: value } }, projects)=>{
    const sortedProjects = $9RbxZ.default($hkOxK.default($701od.default, $f7Op5.default('name')))(projects);
    return $cQGVO.default(({ id: id, name: name, avatarUrl: avatarUrl, key: key })=>({
            id: id,
            name: name,
            iconUrl: avatarUrl,
            key: key
        }), $fpul1.default(({ id: id })=>$7d70y.default(id, value), sortedProjects));
};
const $5e5c7600935dba40$export$835d029fa1f1c04e = ({ [(0, $12ee831723ccf9c2$export$6022538efc28a609)]: { value: value } }, projects, projectsById)=>$hC4q3.default(({ components: components })=>components || [], projects).filter(({ id: id })=>value.includes(id)).map(({ id: id, name: name, projectId: projectId })=>({
            id: id,
            name: name,
            key: projectsById[projectId].key
        }));
const $5e5c7600935dba40$export$ced6baa7b6f46ac5 = ({ [(0, $12ee831723ccf9c2$export$d6f1616882408daa)]: { value: value } })=>value || false;
const $5e5c7600935dba40$export$615e3079a51d9190 = ({ [(0, $12ee831723ccf9c2$export$a849f806e27a57e8)]: { value: value } }, issueMapById, projectsById, issueTypesById)=>{
    if (value.type === 'specificIssue') {
        const issue = (0, $7CnHa.isDefined)(value.issueId) ? issueMapById[value.issueId] : null;
        const project = (0, $7CnHa.isDefined)(issue) ? projectsById[issue.project] : null;
        let issueKey = '';
        if (project) {
            if ((0, $7CnHa.isDefined)(issue) && (0, $7CnHa.isDefined)(issue.issueKey)) issueKey = `${project.key}-${issue.issueKey}`;
            else issueKey = project.key;
        }
        const issueType = (0, $7CnHa.isDefined)(issue) ? issueTypesById[issue.type] : null;
        return {
            type: value.type,
            issueKey: issueKey,
            issueSummary: (0, $7CnHa.isDefined)(issue) ? issue.summary : '',
            issueTypeIconUrl: (0, $7CnHa.isDefined)(issueType) ? issueType.iconUrl : '',
            includeTransitive: value.includeTransitive
        };
    }
    return {
        type: (0, $7CnHa.isDefined)(value) ? value.type : 'off'
    };
};
const $5e5c7600935dba40$var$getFilteredReleases = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $wcCGG.getVersionsById)
], $5e5c7600935dba40$export$bb128313e7225d60);
const $5e5c7600935dba40$var$getFilteredCrossProjectReleases = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $2Ruxt.getCrossProjectVersionsById)
], $5e5c7600935dba40$export$3d34688b22f8a102);
const $5e5c7600935dba40$var$getFilteredTeams = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $MQRDu.getTeamsById)
], $5e5c7600935dba40$export$c162eab77772db5b);
const $5e5c7600935dba40$var$getSummaryFilter = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], $5e5c7600935dba40$export$546565c5ebb5ee41);
const $5e5c7600935dba40$var$getFilteredIssueLabels = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $94enn.getIssueLabels)
], $5e5c7600935dba40$export$4e797b533dddda05);
const $5e5c7600935dba40$var$getFilteredStatusKey = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $4s2RU.getIssueStatusFilterOptions)
], $5e5c7600935dba40$export$6dabe1ba334ec6a9);
const $5e5c7600935dba40$var$getFilteredIssueTypeKey = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $fZW8G.getIssueTypeWithLevelById),
    (0, $lihml.getIssueTypeIconByKey)
], $5e5c7600935dba40$export$e604362162a8c4a8);
const $5e5c7600935dba40$var$getFilteredIssuePriorities = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $jp3RH.getIssuePrioritiesById)
], $5e5c7600935dba40$export$c96a90bda7a2e88a);
const $5e5c7600935dba40$var$getFilteredAssignees = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $aYCQt.getAssigneeForFilter)
], $5e5c7600935dba40$export$5cd6a8027384cc39);
const $5e5c7600935dba40$var$getFilteredGoals = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $e4IaE.getIssueGoalARIs)
], $5e5c7600935dba40$export$935820a00882eac5);
const $5e5c7600935dba40$var$getFilteredReporters = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $f436g.getReporterForFilter)
], $5e5c7600935dba40$export$95f213f1b171139);
const $5e5c7600935dba40$var$getFilteredProjects = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $ehEr2.getProjects)
], $5e5c7600935dba40$export$48773ecb6624dbb4);
const $5e5c7600935dba40$var$getFilteredComponents = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $ehEr2.getProjects),
    (0, $ehEr2.getProjectsById)
], $5e5c7600935dba40$export$835d029fa1f1c04e);
const $5e5c7600935dba40$var$getAdditionalFilteredSprints = (0, $iK4oF.createSelector)([
    (0, $c1XMU.getAllSprintsByIdMap),
    (0, $c1XMU.getExternalSprintsById),
    (0, $c1XMU.getUniqueFilterSprints),
    (0, $c1XMU.getSprintStatesCategories)
], $5e5c7600935dba40$export$ff4a14ccc49fed2f);
const $5e5c7600935dba40$var$getFilteredSprintCategories = (0, $iK4oF.createSelector)([
    (0, $c1XMU.getUniqueFilterSprints),
    (0, $c1XMU.getSprintStatesCategories)
], $5e5c7600935dba40$export$5c4d15fb439d8f5d);
const $5e5c7600935dba40$var$getFilteredDependencies = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $cwP4d.getIssueMapById),
    (0, $ehEr2.getProjectsById),
    (0, $lihml.getIssueTypesById)
], $5e5c7600935dba40$export$615e3079a51d9190);
const $5e5c7600935dba40$var$getFilterIssuesWithWarningsSetting = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], $5e5c7600935dba40$export$ced6baa7b6f46ac5);
const $5e5c7600935dba40$export$c5c31289740eb69e = ({ [(0, $12ee831723ccf9c2$export$82db1960569473ff)]: { value: value } })=>value.startDate || value.endDate ? value : undefined;
const $5e5c7600935dba40$var$getFilteredDateRange = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], $5e5c7600935dba40$export$c5c31289740eb69e);
const $5e5c7600935dba40$export$e5808a792901721d = ({ [(0, $12ee831723ccf9c2$export$59af687b450af7eb)]: { value: value } })=>value;
const $5e5c7600935dba40$var$getFilteredIssueWarnings = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters)
], $5e5c7600935dba40$export$e5808a792901721d);
const $5e5c7600935dba40$export$c31df4bd766f9c35 = (state)=>({
        releases: $5e5c7600935dba40$var$getFilteredReleases(state),
        crossProjectReleases: $5e5c7600935dba40$var$getFilteredCrossProjectReleases(state),
        teams: $5e5c7600935dba40$var$getFilteredTeams(state),
        summary: $5e5c7600935dba40$var$getSummaryFilter(state),
        issueTypeKeys: $5e5c7600935dba40$var$getFilteredIssueTypeKey(state),
        issuePriorities: $5e5c7600935dba40$var$getFilteredIssuePriorities(state),
        assignees: $5e5c7600935dba40$var$getFilteredAssignees(state),
        reporters: $5e5c7600935dba40$var$getFilteredReporters(state),
        goals: $5e5c7600935dba40$var$getFilteredGoals(state),
        additionalSprints: $5e5c7600935dba40$var$getAdditionalFilteredSprints(state),
        sprintCategories: $5e5c7600935dba40$var$getFilteredSprintCategories(state),
        warnings: $5e5c7600935dba40$var$getFilterIssuesWithWarningsSetting(state),
        labels: $5e5c7600935dba40$var$getFilteredIssueLabels(state),
        statusKeys: $5e5c7600935dba40$var$getFilteredStatusKey(state),
        projects: $5e5c7600935dba40$var$getFilteredProjects(state),
        components: $5e5c7600935dba40$var$getFilteredComponents(state),
        dependencies: $5e5c7600935dba40$var$getFilteredDependencies(state),
        customFieldFilterCount: (0, $fiZs1.getCustomFieldFilterCount)(state),
        isAtlasConnectInstalled: (0, $dhHiZ.isAtlasConnectInstalled)(state),
        dateRange: $5e5c7600935dba40$var$getFilteredDateRange(state),
        issueWarnings: $5e5c7600935dba40$var$getFilteredIssueWarnings(state)
    });

});
parcelRegister("4s2RU", function(module, exports) {

$parcel$export(module.exports, "getIssueStatusFilterOptions", () => $c6ac73374e34ce2e$export$adcf009e39085c81);

var $V8UZp = parcelRequire("V8UZp");

var $kFf60 = parcelRequire("kFf60");

var $9H2AP = parcelRequire("9H2AP");


var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $c6ac73374e34ce2e$export$6ffc1063451c988d = {
    id: (0, $5rYNM.UNDEFINED_KEY),
    categoryId: 2,
    name: 'UNSAVED'
};
const $c6ac73374e34ce2e$export$1b001418845b471c = (issue, filter, optimizedMode)=>(0, $V8UZp.applyFilter)(issue, filter.value, 'status', optimizedMode);
const $c6ac73374e34ce2e$export$ddcfe73f870060ea = (state)=>(0, $9H2AP.getFiltersViewSettings)(state)[0, $12ee831723ccf9c2$export$e3608e8ffa9df136] || {
        id: (0, $12ee831723ccf9c2$export$e3608e8ffa9df136),
        value: []
    };
const $c6ac73374e34ce2e$export$118cb57d68780367 = (0, $iK4oF.createSelector)([
    (0, $kFf60.getIssueStatuses),
    $c6ac73374e34ce2e$export$ddcfe73f870060ea
], (issueStatuses, pureFilter)=>{
    const { value: value = [] } = pureFilter;
    const existingStatuses = value.filter((status)=>issueStatuses.some((issueStatus)=>issueStatus.id === status) || status === $c6ac73374e34ce2e$export$6ffc1063451c988d.id);
    return {
        id: (0, $12ee831723ccf9c2$export$e3608e8ffa9df136),
        value: existingStatuses
    };
});
const $c6ac73374e34ce2e$export$adcf009e39085c81 = (0, $iK4oF.createSelector)([
    (0, $kFf60.getIssueStatuses)
], (issueStatuses)=>[
        ...issueStatuses,
        $c6ac73374e34ce2e$export$6ffc1063451c988d
    ]);

});


parcelRegister("8DoQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $967b87c3aa375297$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $biByU = parcelRequire("biByU");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $d16Lt = parcelRequire("d16Lt");

var $lGIBI = parcelRequire("lGIBI");

var $ffiyv = parcelRequire("ffiyv");
var $l2Sj2 = parcelRequire("l2Sj2");

var $hFkwG = parcelRequire("hFkwG");
parcelRequire("2c08V");
parcelRequire("bRpYp");
parcelRequire("kOHCR");
parcelRequire("2vV9U");
parcelRequire("gqs5m");

var $5Rz3d = parcelRequire("5Rz3d");
parcelRequire("68BNT");

var $3nT5G = parcelRequire("3nT5G");
parcelRequire("5mAJ1");
var $7YjYY = parcelRequire("7YjYY");
parcelRequire("77IHm");

var $3Fte6 = parcelRequire("3Fte6");
parcelRequire("kahmZ");


var $eV55H = parcelRequire("eV55H");

var $dsU7U = parcelRequire("dsU7U");

var $6g33d = parcelRequire("6g33d");

var $cULlX = parcelRequire("cULlX");

var $iOtQK = parcelRequire("iOtQK");

var $clyqT = parcelRequire("clyqT");

var $7CnHa = parcelRequire("7CnHa");

var $hl24D = parcelRequire("hl24D");

var $bcFKL = parcelRequire("bcFKL");

var $h5Y9I = parcelRequire("h5Y9I");

var $70X2T = parcelRequire("70X2T");

var $cs7gX = parcelRequire("cs7gX");
const $967b87c3aa375297$var$formatDateRange = (intl, formatTimestamp, dateRange)=>{
    const { startDate: startDate, endDate: endDate } = dateRange;
    if (startDate && endDate) return intl.formatMessage((0, $h5Y9I.default).dateRange, {
        startDate: formatTimestamp(startDate),
        endDate: formatTimestamp(endDate)
    });
    if (startDate) return intl.formatMessage((0, $h5Y9I.default).dateRangeFrom, {
        startDate: formatTimestamp(startDate)
    });
    if (endDate) return intl.formatMessage((0, $h5Y9I.default).dateRangeTo, {
        endDate: formatTimestamp(endDate)
    });
    return '';
};
function $967b87c3aa375297$export$2e2bcd8739ae039({ releases: releases, crossProjectReleases: crossProjectReleases, teams: teams, summary: summary, issueTypeKeys: issueTypeKeys, issuePriorities: issuePriorities, assignees: assignees, reporters: reporters, additionalSprints: additionalSprints, sprintCategories: sprintCategories, warnings: warnings, goals: goals, labels: labels, statusKeys: statusKeys, projects: projects, components: components, dependencies: dependencies, customFieldFilterCount: customFieldFilterCount, CustomFieldsFilterGroupComponent: CustomFieldsFilterGroupComponent = (0, $hl24D.default), isAtlasConnectInstalled: isAtlasConnectInstalled, dateRange: dateRange, issueWarnings: issueWarnings }) {
    const intl = (0, $5JgJ2.default)();
    const filterGroups = [];
    const [definedGoalsByARI] = (0, $lGIBI.useDefinedGoals)();
    const { formatTimestamp: formatTimestamp } = (0, $l2Sj2.useDateFormatter)();
    const exportPNGLabelLozenge = (index, name)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: `lozenge-div-${index}`,
            className: $cs7gX.exportPNGLozenge
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            key: `lozenge-${index}`
        }, name));
    if (releases.length > 0) filterGroups.push({
        id: 'releasesFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$53e2f8996e102881]),
            truncateMessageKey: (0, $h5Y9I.default).remainingReleases,
            items: [
                ...releases.map((item)=>item.id === (0, $3nT5G.NO_RELEASE_ID) ? intl.formatMessage((0, $cULlX.default).noReleasesFilterText) : item.name),
                ...crossProjectReleases.map((item)=>item.name)
            ]
        })
    });
    if (teams.length > 0) filterGroups.push({
        id: 'teamsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$8abe69ceb26771cd]),
            truncateMessageKey: (0, $h5Y9I.default).remainingTeams,
            items: teams.map((item)=>item.id === (0, $3Fte6.NO_TEAM_ID) ? intl.formatMessage((0, $clyqT.default).noTeamFilterText) : item.name)
        })
    });
    if (summary.length > 0) filterGroups.push({
        id: 'summaryFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$e32eeae4866f112c]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", summary, ")"))
    });
    if (additionalSprints.length > 0 || sprintCategories.length > 0) filterGroups.push({
        id: 'sprintsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70X2T.default), {
            additionalSprints: additionalSprints,
            sprintCategories: sprintCategories
        })
    });
    if (projects.length > 0) filterGroups.push({
        id: 'projectsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$d0da0a0b0cd817d8]),
            truncateMessageKey: (0, $h5Y9I.default).remainingProjects,
            items: projects.map((item)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    key: `project-${item.id}`,
                    className: $cs7gX.filterItemWithIcon
                }, (0, $7CnHa.isDefined)(item.iconUrl) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                    className: `${$cs7gX.icon} ${$cs7gX.circle}`,
                    alt: "",
                    src: item.iconUrl
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, item.name, " (", item.key, ")")))
        })
    });
    if (assignees.length > 0) filterGroups.push({
        id: 'assigneesFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$43596ee088b165a]),
            truncateMessageKey: (0, $h5Y9I.default).remainingAssignees,
            items: assignees.map((item)=>item.name)
        })
    });
    if (reporters.length > 0) filterGroups.push({
        id: 'reportersFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$20140793a0aa2b3c]),
            truncateMessageKey: (0, $h5Y9I.default).remainingReporters,
            items: reporters.map((item)=>item.name)
        })
    });
    // issueTypeKeys actually issue status objects here
    if (issueTypeKeys.length > 0) filterGroups.push({
        id: 'issueTypesFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$a8ec3260a009d752]),
            truncateMessageKey: (0, $h5Y9I.default).remainingIssueTypes,
            items: (0, (/*@__PURE__*/$parcel$interopDefault($biByU)))(issueTypeKeys.map(({ key: key, name: name, iconUrl: iconUrl })=>({
                    key: key,
                    name: name,
                    iconUrl: iconUrl
                })), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))).map(({ key: level, name: name, iconUrl: iconUrl })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    key: `issueType-${level}-${name}`,
                    className: $cs7gX.filterItemWithIcon
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                    className: $cs7gX.icon,
                    alt: "",
                    src: iconUrl
                }), name))
        })
    });
    if (issuePriorities.length > 0) filterGroups.push({
        id: 'issuePrioritiesFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$b6fe2739dbbe2e5d]),
            truncateMessageKey: (0, $h5Y9I.default).remainingIssuePriorities,
            items: issuePriorities.map((item)=>item.name)
        })
    });
    if (components.length > 0) filterGroups.push({
        id: 'componentsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$6022538efc28a609]),
            truncateMessageKey: (0, $h5Y9I.default).remainingComponents,
            items: components.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                    key: `components-${item.id}`
                }, item.name, " (", item.key, ")"))
        })
    });
    if (labels.length > 0) filterGroups.push({
        id: 'labelsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$7e257b719377371e]),
            truncateMessageKey: (0, $h5Y9I.default).remainingLabels,
            items: labels.map((item, index)=>item.id === (0, $5Rz3d.NO_LABEL_ID) ? intl.formatMessage((0, $dsU7U.default).noLabelsFilterText) : exportPNGLabelLozenge(index, item.name))
        })
    });
    if (isAtlasConnectInstalled && goals.length > 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(definedGoalsByARI)) filterGroups.push({
        id: 'goalsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$861e775e082be75a]),
            truncateMessageKey: (0, $h5Y9I.default).remainingGoals,
            items: goals.map((item)=>definedGoalsByARI[item.name].name)
        })
    });
    if (dependencies.type !== 'off') {
        if (dependencies.type === 'specificIssue') {
            const issue = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                className: $cs7gX.filterItemWithIcon
            }, (0, $7CnHa.isDefined)(dependencies.issueTypeIconUrl) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                className: $cs7gX.icon,
                alt: "",
                src: dependencies.issueTypeIconUrl
            }), dependencies.issueKey, " ", dependencies.issueSummary);
            const message = dependencies.includeTransitive === true ? (0, $h5Y9I.default).specificIssueTriggerWithDependencyChain : (0, $eV55H.default).specificIssueTrigger;
            filterGroups.push({
                id: 'dependenciesFilterGroup',
                node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$a849f806e27a57e8]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...message,
                    values: {
                        issueKey: issue
                    }
                }), ")"))
            });
        } else filterGroups.push({
            id: 'dependenciesFilterGroup',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$a849f806e27a57e8]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", intl.formatMessage((0, $eV55H.default)[`${dependencies.type}Trigger`]), ")"))
        });
    }
    // statusKeys actually status objects here
    if (statusKeys.length > 0) filterGroups.push({
        id: 'statusesFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$9b51ec1115932c53]),
            truncateMessageKey: (0, $h5Y9I.default).remainingStatuses,
            items: (0, (/*@__PURE__*/$parcel$interopDefault($biByU)))(statusKeys.map(({ categoryId: categoryId, name: name })=>({
                    categoryId: categoryId,
                    name: name
                })), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))).map(({ categoryId: categoryId, name: name }, index)=>name === (0, $7YjYY.UNSAVED_STATUS).name ? intl.formatMessage((0, $iOtQK.default).unsavedIssues) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d16Lt.StatusLozenge), {
                    key: index,
                    value: {
                        id: `${index}`,
                        name: name,
                        statusCategory: {
                            id: categoryId
                        }
                    }
                }))
        })
    });
    if ((0, $1ybV0.ff)('plans-warning-filter-rework_7pi1k')) {
        if (issueWarnings.length > 0) filterGroups.push({
            id: 'issueWarningsFilterGroup',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
                title: intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$59af687b450af7eb]),
                truncateMessageKey: (0, $h5Y9I.default).remainingWarnings,
                items: issueWarnings.map((warningId)=>(0, $hFkwG.WarningTypes)[warningId]).filter((warning)=>warning !== undefined).map((warning)=>intl.formatMessage(warning.header))
            })
        });
        if (dateRange) filterGroups.push({
            id: 'dateRangeFilterGroup',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$82db1960569473ff]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", $967b87c3aa375297$var$formatDateRange(intl, formatTimestamp, dateRange), ")"))
        });
    } else if (warnings) filterGroups.push({
        id: 'warningsFilterGroup',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$d6f1616882408daa]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", intl.formatMessage((0, $h5Y9I.default).issuesWithWarnings), ")"))
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cs7gX.filterGroups
    }, filterGroups.length > 0 && filterGroups.map((item, i)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: item.id,
            className: $cs7gX.filterGroupItem
        }, item.node, i < filterGroups.length - 1 || customFieldFilterCount > 0 ? ',' : '')), customFieldFilterCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomFieldsFilterGroupComponent, null)));
}

});
parcelRegister("hl24D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06cb059ca77e47a$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $gBs2M = parcelRequire("gBs2M");

var $kteJx = parcelRequire("kteJx");
var $c06cb059ca77e47a$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $gBs2M.mapStateToProps), {})((0, $kteJx.default));

});
parcelRegister("gBs2M", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $8605b77e242201ef$export$c31df4bd766f9c35);

var $7d70y = parcelRequire("7d70y");
var $1l9vO = parcelRequire("1l9vO");
parcelRequire("bJc6r");
var $cofZt = parcelRequire("cofZt");

var $kKj1m = parcelRequire("kKj1m");

var $fbHoQ = parcelRequire("fbHoQ");

var $fiZs1 = parcelRequire("fiZs1");


var $7CnHa = parcelRequire("7CnHa");

var $iK4oF = parcelRequire("iK4oF");

var $5rYNM = parcelRequire("5rYNM");
const $8605b77e242201ef$export$fcc98b316551a1ed = ({ [(0, $12ee831723ccf9c2$export$3b798637a628dacc)]: { value: value } }, filterableCustomFields, selectOptions)=>{
    const results = [];
    filterableCustomFields.forEach((customField)=>{
        const fieldKey = customField.type && customField.type.key;
        const customFieldId = String(customField.id);
        const filterValue = (0, $7CnHa.isDefined)(value[customFieldId]) ? value[customFieldId] : [];
        if (filterValue.length) {
            let customFieldViewInfo = [];
            switch(fieldKey){
                case (0, $5rYNM.CustomFieldTypes).Labels:
                    customFieldViewInfo = filterValue.filter((label)=>label !== (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID)).map((label, i)=>({
                            id: i,
                            name: label
                        }));
                    break;
                case (0, $5rYNM.CustomFieldTypes).AssetObject:
                case (0, $5rYNM.CustomFieldTypes).MultiSelect:
                case (0, $5rYNM.CustomFieldTypes).MultiCheckboxes:
                case (0, $5rYNM.CustomFieldTypes).RadioButtons:
                case (0, $5rYNM.CustomFieldTypes).SingleSelect:
                    {
                        if (!(0, $cofZt.default)()) {
                            if (fieldKey === (0, $5rYNM.CustomFieldTypes).AssetObject) break;
                        }
                        const options = selectOptions.filter((opt)=>opt.fieldId === customField.id);
                        if ((0, $7CnHa.isDefined)(options)) customFieldViewInfo = options.filter(({ id: id })=>$1l9vO.default(`${id}`, filterValue))// eslint-disable-next-line @typescript-eslint/no-shadow
                        .map(({ id: id, value: value })=>({
                                id: id,
                                name: value
                            }));
                        break;
                    }
                default:
                    break;
            }
            const noValueOption = $7d70y.default((0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID), filterValue) ? [
                {
                    id: (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID),
                    name: ''
                }
            ] : [];
            const values = noValueOption.concat(customFieldViewInfo);
            if (values.length) results.push({
                id: customFieldId,
                title: customField.title,
                values: values
            });
        }
    });
    return results;
};
const $8605b77e242201ef$var$getFilteredCustomFields = (0, $iK4oF.createSelector)([
    (0, $fbHoQ.getFilters),
    (0, $fiZs1.getCustomFieldsWithFilteringAllowed),
    (0, $kKj1m.getSelectOptions)
], $8605b77e242201ef$export$fcc98b316551a1ed);
const $8605b77e242201ef$export$c31df4bd766f9c35 = (state)=>({
        customFields: $8605b77e242201ef$var$getFilteredCustomFields(state)
    });

});

parcelRegister("kteJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4a91c051018fa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fiZs1 = parcelRequire("fiZs1");

var $jnxbR = parcelRequire("jnxbR");

var $bcFKL = parcelRequire("bcFKL");

var $cs7gX = parcelRequire("cs7gX");

var $d9HCH = parcelRequire("d9HCH");
function $2f4a91c051018fa7$export$2e2bcd8739ae039({ customFields: customFields }) {
    const intl = (0, $5JgJ2.default)();
    if (customFields.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, customFields.map((customField, i)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: customField.id,
            className: $cs7gX.filterGroupItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bcFKL.default), {
            title: customField.title,
            truncateMessageKey: (0, $d9HCH.default).remainingOptions,
            items: [
                ...customField.values.map((item)=>item.id === (0, $fiZs1.NO_CUSTOM_FIELD_VALUE_ID) ? intl.formatMessage((0, $jnxbR.default).noValue) : item.name)
            ]
        }), i < customFields.length - 1 ? ', ' : '')));
    return null;
}

});
parcelRegister("bcFKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b893be872df49115$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aKOnU = parcelRequire("aKOnU");
const $b893be872df49115$export$2ce1bcfc620343c0 = 2;
function $b893be872df49115$export$2e2bcd8739ae039({ title: title, truncateMessageKey: truncateMessageKey, items: items }) {
    const intl = (0, $5JgJ2.default)();
    let remainderItemCounts = items.length - $b893be872df49115$export$2ce1bcfc620343c0;
    // if the remainder item count is 1, might as well display the last item
    remainderItemCounts = remainderItemCounts === 1 ? 0 : remainderItemCounts;
    const truncatedItems = remainderItemCounts > 0 ? items.slice(0, items.length - remainderItemCounts) : items;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, title, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: $aKOnU.filterGroupItems
    }, truncatedItems.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: i
        }, i === 0 ? '(' : '', item, i < truncatedItems.length - 1 || remainderItemCounts > 0 ? ', ' : ')')), remainderItemCounts > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, intl.formatMessage(truncateMessageKey, {
        count: remainderItemCounts
    }), ")") : ''));
}

});
parcelRegister("aKOnU", function(module, exports) {

$parcel$export(module.exports, "filterGroupItems", () => $7d454898295a3ca9$export$160d5bf22afdc613, (v) => $7d454898295a3ca9$export$160d5bf22afdc613 = v);
var $7d454898295a3ca9$export$160d5bf22afdc613;
$7d454898295a3ca9$export$160d5bf22afdc613 = `QDcwyq_filterGroupItems`;

});


parcelRegister("cs7gX", function(module, exports) {

$parcel$export(module.exports, "circle", () => $910dbdbac95248ec$export$e1d786d2f707b414, (v) => $910dbdbac95248ec$export$e1d786d2f707b414 = v);
$parcel$export(module.exports, "exportPNGLozenge", () => $910dbdbac95248ec$export$1ec0dee322814bb4, (v) => $910dbdbac95248ec$export$1ec0dee322814bb4 = v);
$parcel$export(module.exports, "filterGroupItem", () => $910dbdbac95248ec$export$31f6ac73ff3b44e1, (v) => $910dbdbac95248ec$export$31f6ac73ff3b44e1 = v);
$parcel$export(module.exports, "filterGroups", () => $910dbdbac95248ec$export$d3d5e26c84511196, (v) => $910dbdbac95248ec$export$d3d5e26c84511196 = v);
$parcel$export(module.exports, "filterItemWithIcon", () => $910dbdbac95248ec$export$9ad58b43cb66d294, (v) => $910dbdbac95248ec$export$9ad58b43cb66d294 = v);
$parcel$export(module.exports, "icon", () => $910dbdbac95248ec$export$1ca1ec8b29a4ce27, (v) => $910dbdbac95248ec$export$1ca1ec8b29a4ce27 = v);
var $910dbdbac95248ec$export$e1d786d2f707b414;
var $910dbdbac95248ec$export$1ec0dee322814bb4;
var $910dbdbac95248ec$export$31f6ac73ff3b44e1;
var $910dbdbac95248ec$export$d3d5e26c84511196;
var $910dbdbac95248ec$export$9ad58b43cb66d294;
var $910dbdbac95248ec$export$1ca1ec8b29a4ce27;
$910dbdbac95248ec$export$e1d786d2f707b414 = `_9J4P6a_circle`;
$910dbdbac95248ec$export$1ec0dee322814bb4 = `_9J4P6a_exportPNGLozenge`;
$910dbdbac95248ec$export$31f6ac73ff3b44e1 = `_9J4P6a_filterGroupItem`;
$910dbdbac95248ec$export$d3d5e26c84511196 = `_9J4P6a_filterGroups`;
$910dbdbac95248ec$export$9ad58b43cb66d294 = `_9J4P6a_filterItemWithIcon`;
$910dbdbac95248ec$export$1ca1ec8b29a4ce27 = `_9J4P6a_icon`;

});

parcelRegister("d9HCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2264aecbdcabeca$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b2264aecbdcabeca$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remainingOptions: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.custom-fields.remaining-options",
        "defaultMessage": "+{count} {count, plural, one {more option} other {more options}}"
    }
});

});



parcelRegister("h5Y9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd4e37af00f5720$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bbd4e37af00f5720$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remainingReleases: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-releases",
        "defaultMessage": "+{count} {count, plural, one {more release} other {more releases}}"
    },
    remainingTeams: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-teams",
        "defaultMessage": "+{count} {count, plural, one {more team} other {more teams}}"
    },
    remainingAssignees: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-assignees",
        "defaultMessage": "+{count} {count, plural, one {more assignee} other {more assignees}}"
    },
    remainingReporters: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-reporters",
        "defaultMessage": "+{count} {count, plural, one {more reporter} other {more reporters}}"
    },
    remainingIssueTypes: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-issue-types",
        "defaultMessage": "+{count} {count, plural, one {more issue type} other {more issue types}}"
    },
    remainingIssuePriorities: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-issue-priorities",
        "defaultMessage": "+{count} {count, plural, one {more issue priority} other {more issue priorities}}"
    },
    remainingSprints: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-sprints",
        "defaultMessage": "+{count} {count, plural, one {more sprint} other {more sprints}}"
    },
    remainingGoals: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-goals",
        "defaultMessage": "+{count} {count, plural, one {more goal} other {more goals}}"
    },
    remainingWarnings: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-warnings",
        "defaultMessage": "+{count} {count, plural, one {more warning} other {more warnings}}"
    },
    remainingLabels: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-labels",
        "defaultMessage": "+{count} {count, plural, one {more label} other {more labels}}"
    },
    remainingStatuses: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-statuses",
        "defaultMessage": "+{count} {count, plural, one {more status} other {more statuses}}"
    },
    remainingProjects: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-projects",
        "defaultMessage": "+{count} {count, plural, one {more project} other {more projects}}"
    },
    remainingComponents: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.remaining-components",
        "defaultMessage": "+{count} {count, plural, one {more component} other {more components}}"
    },
    issuesWithWarnings: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.issues-with-warnings",
        "defaultMessage": "Issues with warnings"
    },
    showFullHierarchy: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.show-full-hierarchy",
        "defaultMessage": "Showing full hierarchy"
    },
    specificIssueTriggerWithDependencyChain: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.specific-issue-trigger-with-dependency-chain",
        "defaultMessage": "Dependencies of {issueKey} (including dependency chain)"
    },
    dateRange: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range",
        "defaultMessage": "From {startDate} to {endDate}"
    },
    dateRangeFrom: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range-from",
        "defaultMessage": "From {startDate}"
    },
    dateRangeTo: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.date-range-to",
        "defaultMessage": "To {endDate}"
    }
});

});

parcelRegister("70X2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a293c32d2e6b8f0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $ffiyv = parcelRequire("ffiyv");

var $7hbkF = parcelRequire("7hbkF");

var $a4NMN = parcelRequire("a4NMN");

var $6g33d = parcelRequire("6g33d");

var $1CSjE = parcelRequire("1CSjE");

var $ib5d3 = parcelRequire("ib5d3");

var $cs7gX = parcelRequire("cs7gX");

var $5xgtT = parcelRequire("5xgtT");
const $0a293c32d2e6b8f0$export$c900d96097da072 = 2;
const $0a293c32d2e6b8f0$var$SprintLozenge = ({ sprintState: sprintState })=>{
    const intl = (0, $5JgJ2.default)();
    if (sprintState === undefined) return null;
    const lozengeContent = (0, $a4NMN.getSprintStateLozengeContent)(intl);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: $cs7gX.exportPNGLozenge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: (0, $a4NMN.getLozengeAppearance)(sprintState)
    }, lozengeContent(sprintState))));
};
function $0a293c32d2e6b8f0$export$2e2bcd8739ae039({ sprintCategories: sprintCategories, additionalSprints: additionalSprints }) {
    const intl = (0, $5JgJ2.default)();
    // only the additional selected sprints are truncated, the sprint categories will always be displayed
    let remainderItemCounts = additionalSprints.length > 0 ? // the remainder count is the additional sprints minus the limit subtracted by the number of categories,
    // and should not exceed the total number of additional sprints
    additionalSprints.length - Math.max($0a293c32d2e6b8f0$export$c900d96097da072 - sprintCategories.length, 0) : 0;
    // if the remainder item count is 1, might as well display the last item
    remainderItemCounts = remainderItemCounts === 1 ? 0 : remainderItemCounts;
    // slice the additional sprints based on the remainder item counts
    const truncatedSprints = remainderItemCounts > 0 ? additionalSprints.slice(0, additionalSprints.length - remainderItemCounts) : additionalSprints;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, intl.formatMessage((0, $6g33d.default)[0, $12ee831723ccf9c2$export$46cb1c3e9f7a5fbb]), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "(", sprintCategories.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: item.id === (0, $7hbkF.NO_SPRINT_ID) ? 'NO_SPRINT_ID' : item.id
        }, item.id === (0, $7hbkF.NO_SPRINT_ID) ? intl.formatMessage((0, $ib5d3.default).noSprintLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $1CSjE.default).categoriesLabel,
            values: {
                state: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a293c32d2e6b8f0$var$SprintLozenge, {
                    sprintState: item.sprintState
                })
            }
        }), i < sprintCategories.length - 1 || truncatedSprints.length > 0 || remainderItemCounts > 0 ? ',  ' : '')), truncatedSprints.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: item.id
        }, item.sprintName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0a293c32d2e6b8f0$var$SprintLozenge, {
            sprintState: item.sprintState
        }), i < truncatedSprints.length - 1 || remainderItemCounts > 0 ? ',  ' : '')), remainderItemCounts > 0 ? `${intl.formatMessage((0, $5xgtT.default).remainingSprints, {
        count: remainderItemCounts
    })}` : '', ")"));
}

});
parcelRegister("5xgtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77d16a97aa1c1e9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b77d16a97aa1c1e9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    remainingSprints: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filter.sprint-filter-group.remaining-sprints",
        "defaultMessage": "+{count} {count, plural, one {more sprint} other {more sprints}}"
    }
});

});




parcelRegister("b1W2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f9735a8bdbb4ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c8f9735a8bdbb4ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hierarchy: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.hierarchy",
        "defaultMessage": "Hierarchy"
    },
    hierarchySeparator: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.hierarchy-separator",
        "defaultMessage": "to"
    },
    view: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.view",
        "defaultMessage": "View"
    },
    colorBy: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.color-by",
        "defaultMessage": "Color by"
    },
    rollup: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.rollup",
        "defaultMessage": "Roll-up"
    },
    rollupAll: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.rollup-all",
        "defaultMessage": "Yes"
    },
    rollupOthers: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.rollup-others",
        "defaultMessage": "Not dates"
    },
    sortBy: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.sort-by",
        "defaultMessage": "Sort by"
    },
    rank: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.rank",
        "defaultMessage": "Rank"
    },
    filters: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.filters",
        "defaultMessage": "{filtersApplied, plural,\n            =0 {Filters}\n            one {1 filter applied}\n            other {{filtersApplied} filters applied}\n        }"
    },
    noFilterApplied: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.no-filter-applied",
        "defaultMessage": "No filter applied"
    },
    warnings: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.warnings",
        "defaultMessage": "Warnings"
    },
    warningsEnabled: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.warnings-enabled",
        "defaultMessage": "Enabled"
    },
    warningsDisabled: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.warnings-disabled",
        "defaultMessage": "Disabled"
    },
    showFullHierarchy: {
        "id": "portfolio-3-portfolio.app-export-view.main.view-information.show-full-hierarchy",
        "defaultMessage": "Showing full hierarchy"
    }
});

});

parcelRegister("50hWa", function(module, exports) {

$parcel$export(module.exports, "group", () => $3a4addc36c968998$export$e5e25fbcc1f7affe, (v) => $3a4addc36c968998$export$e5e25fbcc1f7affe = v);
$parcel$export(module.exports, "groupContent", () => $3a4addc36c968998$export$d6a271f2cc7855f3, (v) => $3a4addc36c968998$export$d6a271f2cc7855f3 = v);
$parcel$export(module.exports, "groupContentItem", () => $3a4addc36c968998$export$5df539e660ea78b9, (v) => $3a4addc36c968998$export$5df539e660ea78b9 = v);
$parcel$export(module.exports, "groupTitle", () => $3a4addc36c968998$export$91bc5dc3bf221ff4, (v) => $3a4addc36c968998$export$91bc5dc3bf221ff4 = v);
$parcel$export(module.exports, "viewInformation", () => $3a4addc36c968998$export$885ced6884065e26, (v) => $3a4addc36c968998$export$885ced6884065e26 = v);
var $3a4addc36c968998$export$e5e25fbcc1f7affe;
var $3a4addc36c968998$export$d6a271f2cc7855f3;
var $3a4addc36c968998$export$5df539e660ea78b9;
var $3a4addc36c968998$export$91bc5dc3bf221ff4;
var $3a4addc36c968998$export$885ced6884065e26;
$3a4addc36c968998$export$e5e25fbcc1f7affe = `lmr94a_group`;
$3a4addc36c968998$export$d6a271f2cc7855f3 = `lmr94a_groupContent`;
$3a4addc36c968998$export$5df539e660ea78b9 = `lmr94a_groupContentItem`;
$3a4addc36c968998$export$91bc5dc3bf221ff4 = `lmr94a_groupTitle`;
$3a4addc36c968998$export$885ced6884065e26 = `lmr94a_viewInformation`;

});




parcelRegister("e3jLW", function(module, exports) {

$parcel$export(module.exports, "preparePlanForExport", () => $494ab2be15f30935$export$1b186cbfaf6eb3a1);
/**
 * Can not rasterize svg with value 'currentColor' and 'inherit' in fill attribute.
 * Replace these values with actual color codes.
 */ const $494ab2be15f30935$var$setSvgColorsExplicitly = ()=>{
    const svgElements = window.document.querySelectorAll('svg *[fill]');
    for(let i = 0; i < svgElements.length; i += 1){
        let fillAttr = svgElements[i].getAttribute('fill') || '';
        const styleParent = svgElements[i].closest('span');
        if (styleParent) {
            const parentStyle = getComputedStyle(styleParent);
            // Fix for the primary color of dependency badge
            // Copy the grand parent primary color to the span --icon-primary-color.
            if (parentStyle.getPropertyValue('--icon-primary-color') === 'currentColor') {
                const grandParent = styleParent.closest('*');
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const grandParentStyle = getComputedStyle(grandParent);
                styleParent.style.setProperty('--icon-primary-color', grandParentStyle.color);
            }
            if (fillAttr.indexOf('currentColor') > -1 && styleParent) fillAttr = parentStyle.getPropertyValue('--icon-primary-color') || fillAttr;
            else if (fillAttr.indexOf('inherit') > -1 && styleParent) fillAttr = parentStyle.getPropertyValue('--icon-secondary-color') || fillAttr;
            svgElements[i].setAttribute('fill', fillAttr);
        }
    }
};
/**
 * Set SVG widths and heights
 */ const $494ab2be15f30935$var$setSvgWidthAndHeight = ()=>{
    const svgs = window.document.querySelectorAll('svg');
    for(let i = 0; i < svgs.length; i += 1){
        const svg = svgs[i];
        // Remove previously set width and height from dependencies overlay
        if (svg.classList.contains('dependencies-overlay')) {
            svg.removeAttribute('width');
            svg.removeAttribute('height');
        }
        // Set absolute width and height to all SVG that doesn't have these attributes defined.
        if (!svg.getAttribute('width') || !svg.getAttribute('height')) {
            const { width: width, height: height } = svg.getBoundingClientRect();
            svg.setAttribute('width', `${Math.round(width)}`);
            svg.setAttribute('height', `${Math.round(height)}`);
        }
    }
};
const $494ab2be15f30935$export$1b186cbfaf6eb3a1 = ()=>{
    $494ab2be15f30935$var$setSvgColorsExplicitly();
    $494ab2be15f30935$var$setSvgWidthAndHeight();
};

});




parcelRegister("3pQEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5d844a0c4163b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $78d1w = parcelRequire("78d1w");
const $dc5d844a0c4163b4$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78d1w.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $dc5d844a0c4163b4$var$SpaErrorBoundary = $dc5d844a0c4163b4$var$ErrorBoundaryWithExtraEventData;
var $dc5d844a0c4163b4$export$2e2bcd8739ae039 = $dc5d844a0c4163b4$var$SpaErrorBoundary;

});


parcelRegister("7FLAp", function(module, exports) {

$parcel$export(module.exports, "AnalyticsInitializer", () => $d577fe9081dbeda0$export$104a3bea6fcce96c);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");

var $6Grzy = parcelRequire("6Grzy");
parcelRequire("dru6o");
var $gNoQI = parcelRequire("gNoQI");

var $lPYkK = parcelRequire("lPYkK");

var $8WuJm = parcelRequire("8WuJm");
var $2qZHF = parcelRequire("2qZHF");

var $kJlBc = parcelRequire("kJlBc");
const $d577fe9081dbeda0$export$104a3bea6fcce96c = ({ children: children })=>{
    const [{ match: match }] = (0, $kJlBc.useRouter)();
    const planId = match.params.planId ?? '';
    const scenarioId = match.params.scenarioId ?? '';
    /**
	 * When the plan is accessed through the Jira search bar, multiple search parameters are added to the
	 * query including the searchSessionId.
	 * In "src/packages/session-tracker/src/view/index.js#109", these parameters are then striped from the
	 * query params and added to the metadata on the history change. The previous session's metadata is also
	 * cleaned on the history change.
	 * During the SPA, transition the app can get rendered multiple times because of the prop changes in the
	 * SPA parent components. Because of this, the searchSessionId is available during the first render and
	 * gets cleaned after that.
	 * We use searchSessionId to track user's activity. To retain this value, we are using the "useMemo" hook
	 * with the "planId". So until the planId changes, it will not re-read the value and keeps the first value
	 * it read.
	 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    const searchSessionId = (0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-search-session-id'), [
        planId
    ]);
    const contextAnalyticsDataAttributes = {
        planId: planId,
        scenarioId: scenarioId,
        context: (0, $6Grzy.context).PLAN,
        ...searchSessionId && {
            searchSessionId: searchSessionId
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "portfolio3",
        attributes: contextAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (analyticsEvent)=>(0, $lPYkK.default).dispatch((0, $gNoQI.setAnalyticsEvent)(analyticsEvent))
    }), children);
};

});

parcelRegister("cOkqp", function(module, exports) {

$parcel$export(module.exports, "usePlanCheck", () => $8691f685bf742d84$export$e6f190cd203659ad);

var $3HCkE = parcelRequire("3HCkE");

var $drCAA = parcelRequire("drCAA");
const $8691f685bf742d84$export$e6f190cd203659ad = ()=>(0, $3HCkE.useResource)((0, $drCAA.advancedRoadmapsPlanPageInitialChecksResource));

});


parcelRegister("4ZvZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9881a6b25f99caf1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9XeW0 = parcelRequire("9XeW0");

var $7CnHa = parcelRequire("7CnHa");

var $82XRh = parcelRequire("82XRh");
function $9881a6b25f99caf1$export$2e2bcd8739ae039({ pageHeading: pageHeading }) {
    const { data: data } = (0, $9XeW0.usePlan)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const productName = formatMessage((0, $82XRh.default).plans);
    const documentTitle = (0, $7CnHa.isDefined)(data?.title) && (0, $7CnHa.isDefined)(pageHeading) ? `${pageHeading} - ${data?.title} - ${productName}` : `${productName}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
}

});
parcelRegister("82XRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1269fa6b1a50a0bf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $1269fa6b1a50a0bf$var$messages = (0, $90IgZ.defineMessages)({
    plans: {
        "id": "spa-apps-advanced-roadmaps-plan.common.document-title.plans",
        "defaultMessage": "Plans"
    }
});
var $1269fa6b1a50a0bf$export$2e2bcd8739ae039 = $1269fa6b1a50a0bf$var$messages;

});


parcelRegister("68S28", function(module, exports) {

$parcel$export(module.exports, "PlanOnboarding", () => $9da11e496ab739cb$export$c270e928245c1fe3);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $6zEnX = parcelRequire("6zEnX");

var $7ClpZ = parcelRequire("7ClpZ");

var $7SyBh = parcelRequire("7SyBh");

var $fWk9k = parcelRequire("fWk9k");

var $jYuPE = parcelRequire("jYuPE");

var $4Yo2u = parcelRequire("4Yo2u");

var $5Kbvu = parcelRequire("5Kbvu");

var $h9jAv = parcelRequire("h9jAv");

var $2KLen = parcelRequire("2KLen");

var $dgSCQ = parcelRequire("dgSCQ");

var $2qwvI = parcelRequire("2qwvI");

var $gUQi8 = parcelRequire("gUQi8");

var $2VH0W = parcelRequire("2VH0W");

var $dxcfv = parcelRequire("dxcfv");

var $673Wg = parcelRequire("673Wg");
const $9da11e496ab739cb$export$c270e928245c1fe3 = ({ children: children })=>{
    const [{ visible: visible }, { closeOnboarding: closeOnboarding }] = (0, $6zEnX.useOnboardingTour)();
    const [{ isTakingOnboardingTour: isTakingOnboardingTour }, { resetCttTakingTour: resetCttTakingTour }] = (0, $7SyBh.useCttOnboardingTour)();
    const isCrossTeamPlanningTemplateEnabled = (0, $673Wg.isCrossTeamPlanningTemplateExperimentEnabled)();
    const accountId = (0, $dxcfv.useAccountId)();
    // Short-circuit CTP/CTT changeboarding if there is active onboarding tour
    if (!accountId || visible) return null;
    const withCrossTeamTemplateOnboarding = (onboarding)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gUQi8.default), null, (enabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SyBh.CttOnboardingProvider), {
                isGlobal: true,
                accountId: accountId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgSCQ.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Yo2u.CttOnboarding), props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9jAv.Onboarding), {
                visible: isTakingOnboardingTour,
                onClose: ()=>{
                    closeOnboarding();
                    resetCttTakingTour();
                }
            })), !enabled && onboarding));
    const withCrossTeamPlanningOnboarding = (onboarding)=>{
        if (!isCrossTeamPlanningTemplateEnabled) return onboarding;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qwvI.default), null, (enabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ClpZ.CtpOnboardingProvider), {
                isGlobal: true,
                accountId: accountId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9jAv.Onboarding), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2KLen.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYuPE.CtpOnboarding), props))), !enabled && onboarding));
    };
    const getChangeboarding = ()=>(0, $1ybV0.ff)('sploverview-remove-old-plans-changeboarding') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWk9k.Changeboarding), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zEnX.OnboardingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5Kbvu.FlagGroupGuard), {
        forChangeboarding: !(0, $1ybV0.ff)('sploverview-remove-old-plans-changeboarding'),
        forCttOnboarding: true,
        forCtpOnboarding: isCrossTeamPlanningTemplateEnabled
    }, children), withCrossTeamTemplateOnboarding(withCrossTeamPlanningOnboarding(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2VH0W.default), null, (userIsOnboarded)=>userIsOnboarded ? getChangeboarding() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9jAv.Onboarding), null)))));
};

});
parcelRegister("6zEnX", function(module, exports) {

$parcel$export(module.exports, "useRehydrated", () => $7a221506b214ffe2$export$783184fef467e477);
$parcel$export(module.exports, "useChangeboarding", () => $7a221506b214ffe2$export$4a515e2e15159bbe);
$parcel$export(module.exports, "useOnboardingTour", () => $7a221506b214ffe2$export$c7824882d969afa7);
$parcel$export(module.exports, "OnboardingProvider", () => $7a221506b214ffe2$export$54ba648a75d332de);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $eWQXg = parcelRequire("eWQXg");

var $7q1V6 = parcelRequire("7q1V6");

var $focLT = parcelRequire("focLT");
const $7a221506b214ffe2$var$initialState = {
    _rehydrated: false
};
const $7a221506b214ffe2$var$store = (0, $a61MH.createStore)({
    initialState: $7a221506b214ffe2$var$initialState,
    actions: $eWQXg.actions,
    name: 'portfolio-3/onboarding'
});
const $7a221506b214ffe2$export$783184fef467e477 = (0, $ggKAj.createHook)($7a221506b214ffe2$var$store, {
    selector: (state)=>state._rehydrated
});
const $7a221506b214ffe2$export$4a515e2e15159bbe = (0, $ggKAj.createHook)($7a221506b214ffe2$var$store, {
    selector: (0, $7q1V6.selectChangeboarding)
});
const $7a221506b214ffe2$export$c7824882d969afa7 = (0, $ggKAj.createHook)($7a221506b214ffe2$var$store, {
    selector: (0, $7q1V6.selectOnboardingTour)
});
const $7a221506b214ffe2$export$54ba648a75d332de = (0, $heB5U.createContainer)($7a221506b214ffe2$var$store, {
    onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (getState()._rehydratePromise === undefined) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const promise = dispatch((0, $focLT.rehydrate));
                setState({
                    _rehydratePromise: promise
                });
                await promise;
            }
        }
});

});
parcelRegister("eWQXg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $658bec5618caead0$export$e324594224ef24da);

var $focLT = parcelRequire("focLT");
const $658bec5618caead0$var$changeboardingActions = {
    initChangeboarding: ()=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            if (getState().changeboarding?.stage === undefined) setState({
                changeboarding: {
                    stage: 'READY'
                }
            });
        },
    closeChangeboarding: ({ silent: silent } = {
        silent: true
    }, at = new Date())=>({ dispatch: dispatch })=>{
            dispatch((0, $focLT.update)({
                ui: !silent,
                persist: true
            })({
                changeboarding: {
                    stage: 'CLOSED',
                    closedAt: at
                }
            }));
        }
};
const $658bec5618caead0$var$onboardingActions = {
    initOnboarding: ()=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            if (getState().onboarding?.stage === undefined) setState({
                onboarding: {
                    stage: 'READY'
                }
            });
        },
    closeOnboarding: ({ silent: silent } = {
        silent: true
    })=>({ dispatch: dispatch })=>{
            dispatch((0, $focLT.update)({
                ui: !silent,
                persist: true
            })({
                onboarding: {
                    stage: 'CLOSED'
                }
            }));
        }
};
const $658bec5618caead0$export$e324594224ef24da = {
    ...$658bec5618caead0$var$changeboardingActions,
    ...$658bec5618caead0$var$onboardingActions
};

});
parcelRegister("focLT", function(module, exports) {

$parcel$export(module.exports, "rehydrate", () => $452ff9607d52d2fb$export$27af23fc693b4501);
$parcel$export(module.exports, "update", () => $452ff9607d52d2fb$export$722fbec263ad908a);

var $2eIIH = parcelRequire("2eIIH");

var $cm5m0 = parcelRequire("cm5m0");
const $452ff9607d52d2fb$var$PERSIST_KEY = 'jira.user.arj.onboarding';
const $452ff9607d52d2fb$export$27af23fc693b4501 = async ({ getState: getState, setState: setState })=>{
    if (getState()._rehydrated) return;
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parseDate = (raw)=>{
        const maybeDate = new Date(raw);
        return !Number.isNaN(maybeDate.getTime()) ? maybeDate : new Date();
    };
    // Mark as any since it's assumed to be opaque, we ensure type safety in the code below.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const raw = await (0, $cm5m0.userPreferenceAPI).get($452ff9607d52d2fb$var$PERSIST_KEY) ?? {};
    const changeboarding = (()=>{
        try {
            const stage = raw.changeboarding?.stage;
            switch(stage){
                case 'READY':
                    return {
                        stage: stage
                    };
                case 'CLOSED':
                    return {
                        stage: stage,
                        closedAt: parseDate(raw.changeboarding?.closedAt)
                    };
                default:
                    assertUnreachable(stage);
                    return undefined;
            }
        } catch (err) {
            return undefined;
        }
    })();
    const onboarding = (()=>{
        try {
            const stage = raw.onboarding?.stage;
            switch(stage){
                case 'READY':
                    return {
                        stage: stage
                    };
                case 'CLOSED':
                    return {
                        stage: stage
                    };
                default:
                    assertUnreachable(stage);
                    return undefined;
            }
        } catch (err) {
            return undefined;
        }
    })();
    setState({
        _rehydrated: true,
        changeboarding: changeboarding,
        onboarding: onboarding
    });
};
const $452ff9607d52d2fb$var$persist = (update)=>async ({ getState: getState })=>{
        const serialize = (0, (/*@__PURE__*/$parcel$interopDefault($2eIIH)))([
            'changeboarding',
            'onboarding'
        ]);
        (0, $cm5m0.userPreferenceAPI).set($452ff9607d52d2fb$var$PERSIST_KEY, serialize({
            ...getState(),
            ...update
        }));
    };
const $452ff9607d52d2fb$export$722fbec263ad908a = (options = {
    ui: true,
    persist: true
})=>(partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
            if (!_rehydrated) await _rehydratePromise;
            if (options.ui) setState(partial);
            if (options.persist) dispatch($452ff9607d52d2fb$var$persist({
                ...getState(),
                ...partial
            }));
        };

});


parcelRegister("7q1V6", function(module, exports) {

$parcel$export(module.exports, "selectChangeboarding", () => $3910e0d43d590e41$export$763e5c2849fd2595);
$parcel$export(module.exports, "selectOnboardingTour", () => $3910e0d43d590e41$export$66bbb450debbfc1b);
const $3910e0d43d590e41$export$763e5c2849fd2595 = ({ changeboarding: changeboarding })=>({
        visible: changeboarding?.stage === 'READY'
    });
const $3910e0d43d590e41$export$66bbb450debbfc1b = ({ onboarding: onboarding })=>({
        visible: onboarding?.stage === 'READY',
        closed: onboarding?.stage === 'CLOSED'
    });

});


parcelRegister("7ClpZ", function(module, exports) {

$parcel$export(module.exports, "useCtpOnboardingTour", () => $4e3f30bc7a1dbf5f$export$84018af84275ab8);
$parcel$export(module.exports, "CtpOnboardingProvider", () => $4e3f30bc7a1dbf5f$export$7f8925c26a55fcf6);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $2C3JM = parcelRequire("2C3JM");

var $jUN5K = parcelRequire("jUN5K");

var $40wfe = parcelRequire("40wfe");
const $4e3f30bc7a1dbf5f$var$initialState = {
    _rehydrated: false
};
const $4e3f30bc7a1dbf5f$var$store = (0, $a61MH.createStore)({
    initialState: $4e3f30bc7a1dbf5f$var$initialState,
    actions: $2C3JM.actions,
    name: 'portfolio-3/ctp-onboarding'
});
const $4e3f30bc7a1dbf5f$export$84018af84275ab8 = (0, $ggKAj.createHook)($4e3f30bc7a1dbf5f$var$store, {
    selector: (0, $jUN5K.selectCtpOnboardingTour)
});
const $4e3f30bc7a1dbf5f$export$7f8925c26a55fcf6 = (0, $heB5U.createContainer)($4e3f30bc7a1dbf5f$var$store, {
    onInit: ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (getState()._rehydratePromise === undefined) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const promise = dispatch((0, $40wfe.rehydrate));
                setState({
                    _rehydratePromise: promise
                });
                await promise;
            }
        }
});

});
parcelRegister("2C3JM", function(module, exports) {

$parcel$export(module.exports, "actions", () => $15aa5aaa2718c247$export$e324594224ef24da);

var $gUUjF = parcelRequire("gUUjF");

var $gpEwb = parcelRequire("gpEwb");

var $40wfe = parcelRequire("40wfe");
const $15aa5aaa2718c247$var$ctpOnboardingActions = {
    initCtpOnboarding: (planId)=>async ({ getState: getState, setState: setState })=>{
            await getState()._rehydratePromise;
            const { ctpOnboarding: ctpOnboarding } = getState();
            if (planId === null) return;
            if (!ctpOnboarding) {
                setState({
                    ctpOnboarding: {
                        stage: (0, $gpEwb.CTP_ONBOARDING_STAGE).TIMELINE,
                        planId: planId
                    }
                });
                return;
            }
            if (ctpOnboarding.planId !== planId && ctpOnboarding.stage !== (0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED) setState({
                ctpOnboarding: {
                    stage: (0, $gpEwb.CTP_ONBOARDING_STAGE).TIMELINE,
                    planId: planId
                }
            });
        },
    nextCtpStage: (skipTo)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { ctpOnboarding: ctpOnboarding } = getState();
            if (!ctpOnboarding) return;
            const { planId: planId, stage: stage } = ctpOnboarding;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const updateStage = (updateStage)=>{
                dispatch((0, $40wfe.update)({
                    ctpOnboarding: {
                        stage: updateStage,
                        planId: planId
                    }
                }));
            };
            if (skipTo) {
                Object.values((0, $gpEwb.CTP_ONBOARDING_STAGE)).includes(skipTo) && updateStage(skipTo);
                return;
            }
            switch(stage){
                case (0, $gpEwb.CTP_ONBOARDING_STAGE).TIMELINE:
                    updateStage((0, $gpEwb.CTP_ONBOARDING_STAGE).CREATE_ISSUE);
                    break;
                case (0, $gpEwb.CTP_ONBOARDING_STAGE).CREATE_ISSUE:
                    updateStage((0, $gpEwb.CTP_ONBOARDING_STAGE).TEAMS);
                    break;
                case (0, $gpEwb.CTP_ONBOARDING_STAGE).TEAMS:
                    updateStage((0, $gpEwb.CTP_ONBOARDING_STAGE).BOARDS);
                    break;
                case (0, $gpEwb.CTP_ONBOARDING_STAGE).BOARDS:
                    updateStage((0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED);
                    break;
                case (0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED:
                    break;
                default:
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.ctp-onboarding.store.nextStageError', 'Something went wrong going to the next stage, so closing onboarding', {
                        path: window.location.pathname.replace(/\d+/g, '{id}'),
                        errorMessage: "Didn't expect to get here",
                        stage: stage
                    });
                    setState({
                        ctpOnboarding: {
                            ...ctpOnboarding,
                            stage: (0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED
                        }
                    });
                    break;
            }
        }
};
const $15aa5aaa2718c247$export$e324594224ef24da = {
    ...$15aa5aaa2718c247$var$ctpOnboardingActions
};

});
parcelRegister("gpEwb", function(module, exports) {

$parcel$export(module.exports, "CTP_ONBOARDING_STAGE", () => $127d7da1668aaa5f$export$77d891eb602b849f);
const $127d7da1668aaa5f$export$77d891eb602b849f = {
    TIMELINE: 'TIMELINE',
    CREATE_ISSUE: 'CREATE_ISSUE',
    TEAMS: 'TEAMS',
    BOARDS: 'BOARDS',
    CLOSED: 'CLOSED'
};

});

parcelRegister("40wfe", function(module, exports) {

$parcel$export(module.exports, "rehydrate", () => $8bbf3280e52081ea$export$27af23fc693b4501);
$parcel$export(module.exports, "update", () => $8bbf3280e52081ea$export$722fbec263ad908a);

var $2eIIH = parcelRequire("2eIIH");

var $fVqUX = parcelRequire("fVqUX");

var $lRmyA = parcelRequire("lRmyA");

var $gpEwb = parcelRequire("gpEwb");
const $8bbf3280e52081ea$var$PERSIST_KEY = 'jira.user.arj.ctp-onboarding';
const $8bbf3280e52081ea$var$getCtpOnboardingUserProperties = async (accountId)=>{
    const fetchResponse = await fetch(`/rest/api/3/user/properties/${$8bbf3280e52081ea$var$PERSIST_KEY}?accountId=${accountId}`, (0, $fVqUX.default));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not migrated their data
    if (status === 404) return undefined;
    throw new Error(`Fetching ${$8bbf3280e52081ea$var$PERSIST_KEY} user property failed. Status code: ${fetchResponse.status}`);
};
const $8bbf3280e52081ea$export$27af23fc693b4501 = async ({ getState: getState, setState: setState }, { accountId: accountId })=>{
    if (getState()._rehydrated) return;
    // Mark as any since it's assumed to be opaque, we ensure type safety in the code below.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let raw = {};
    const response = await $8bbf3280e52081ea$var$getCtpOnboardingUserProperties(accountId);
    if (response) raw = response;
    else raw = {};
    const ctpOnboarding = (()=>{
        const stage = raw.ctpOnboarding?.stage;
        if (stage && Object.values((0, $gpEwb.CTP_ONBOARDING_STAGE)).includes(stage)) return {
            stage: stage,
            planId: raw.ctpOnboarding?.planId
        };
        return undefined;
    })();
    setState({
        _rehydrated: true,
        ctpOnboarding: ctpOnboarding
    });
};
const $8bbf3280e52081ea$export$9a6132153fba2e0 = (update)=>async ({ getState: getState }, { accountId: accountId })=>{
        const serialize = (0, (/*@__PURE__*/$parcel$interopDefault($2eIIH)))([
            'ctpOnboarding'
        ]);
        await (0, $lRmyA.performPutRequest)(`/rest/api/3/user/properties/${$8bbf3280e52081ea$var$PERSIST_KEY}?accountId=${accountId}`, {
            body: JSON.stringify(serialize({
                ...getState(),
                ...update
            }))
        });
    };
const $8bbf3280e52081ea$export$722fbec263ad908a = (partial)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { _rehydrated: _rehydrated, _rehydratePromise: _rehydratePromise } = getState();
        if (!_rehydrated) await _rehydratePromise;
        setState(partial);
        dispatch($8bbf3280e52081ea$export$9a6132153fba2e0({
            ...getState(),
            ...partial
        }));
    };

});


parcelRegister("jUN5K", function(module, exports) {

$parcel$export(module.exports, "selectCtpOnboardingTour", () => $b3dfe811d944c4a9$export$4d58ae5942d42bdc);

var $gUUjF = parcelRequire("gUUjF");

var $gpEwb = parcelRequire("gpEwb");
const $b3dfe811d944c4a9$export$4d58ae5942d42bdc = ({ ctpOnboarding: ctpOnboarding })=>{
    const getVisibility = ()=>{
        if (!ctpOnboarding) return false;
        switch(ctpOnboarding.stage){
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).TIMELINE:
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).CREATE_ISSUE:
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).TEAMS:
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).BOARDS:
                return true;
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED:
                return false;
            default:
                (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.ctp-onboarding.store.getVisibilityError', 'Something went wrong going to the next stage', {
                    path: window.location.pathname.replace(/\d+/g, '{id}'),
                    errorMessage: "Didn't expect to get here"
                });
                return false;
        }
    };
    return {
        stage: ctpOnboarding?.stage,
        planId: ctpOnboarding?.planId,
        visible: getVisibility()
    };
};

});


parcelRegister("fWk9k", function(module, exports) {

$parcel$export(module.exports, "Changeboarding", () => $1b3c67725c8abd20$export$d7cfba75deb33e5);

var $eUqFw = parcelRequire("eUqFw");

var $9exb1 = parcelRequire("9exb1");
var $dxopF = parcelRequire("dxopF");
var $hJJD2 = parcelRequire("hJJD2");
var $7zpSo = parcelRequire("7zpSo");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1GeZ8 = parcelRequire("1GeZ8");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $7w7IK = parcelRequire("7w7IK");

var $cNjuW = parcelRequire("cNjuW");

var $6zEnX = parcelRequire("6zEnX");

var $7Jv2m = parcelRequire("7Jv2m");

var $CLmMB = parcelRequire("CLmMB");

var $72mMy = parcelRequire("72mMy");
const $1b3c67725c8abd20$export$d7cfba75deb33e5 = ()=>{
    const [{ visible: visible }, { initChangeboarding: initChangeboarding, closeChangeboarding: closeChangeboarding }] = (0, $6zEnX.useChangeboarding)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [step, { next: next, start: start, finish: finish }] = (0, $72mMy.useStep)();
    (0, $eUqFw.useEffect)(()=>{
        initChangeboarding();
    }, [
        initChangeboarding
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (visible) start();
    }, [
        start,
        visible
    ]);
    const { expandLeftSidebar: expandLeftSidebarChangingEveryRender } = (0, $1GeZ8.usePageLayoutResize)();
    const [expandLeftSidebar] = (0, $eUqFw.useState)(()=>expandLeftSidebarChangingEveryRender);
    const openCommunityPost = (0, $eUqFw.useCallback)((_e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openedNewNavigationCommunityPost');
        next();
    }, [
        next
    ]);
    const startChangeboarding = (0, $eUqFw.useCallback)((_e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'startedNewNavigationChangeboarding');
        next();
    }, [
        next
    ]);
    const skipChangeboarding = (0, $eUqFw.useCallback)((_e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'skippedNewNavigationChangeboarding');
        finish();
    }, [
        finish
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (step === 'spotlight') expandLeftSidebar();
        if (step === 'flag') closeChangeboarding({
            silent: true
        });
        if (step === 'finished') closeChangeboarding();
    }, [
        step,
        closeChangeboarding,
        expandLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, visible && step === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9exb1.default), {
        heading: formatMessage((0, $CLmMB.messages).modalHeading),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7w7IK))),
        actions: [
            {
                onClick: startChangeboarding,
                text: formatMessage((0, $CLmMB.messages).modalShowMe)
            },
            {
                onClick: skipChangeboarding,
                text: formatMessage((0, $CLmMB.messages).modalExploreOnMyOwn)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "modal",
        action: "viewed",
        actionSubjectId: "newNavigationChangeboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $CLmMB.messages).modalContentParagraph1)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, visible && step === 'spotlight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actions: [
            {
                text: formatMessage((0, $CLmMB.messages).viewsSpotlightNext),
                onClick: next
            }
        ],
        heading: formatMessage((0, $CLmMB.messages).viewsSpotlightTitle),
        target: (0, $7Jv2m.Spotlights).Views,
        key: (0, $7Jv2m.Spotlights).Views,
        targetRadius: 0,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`
    }, formatMessage((0, $CLmMB.messages).viewsSpotlightMessage))), visible && step === 'flag' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "flag",
        action: "viewed",
        actionSubjectId: "finishedNewNavigationChangeboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNjuW.Flag), {
        onDismissed: next,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $CLmMB.messages).flagTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $CLmMB.messages).flagContent),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $CLmMB.messages).flagClose),
                onClick: next
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $CLmMB.messages).flagReadCommunityPost),
                href: 'https://community.atlassian.com/t5/Jira-articles/We-re-testing-a-new-interface-for-Advanced-Roadmaps/ba-p/2328773',
                target: '_blank',
                onClick: openCommunityPost
            }
        ]
    })));
};

});
parcelRegister("7w7IK", function(module, exports) {
module.exports = new URL("changeboarding.8b1240de.svg", import.meta.url).toString();

});

parcelRegister("cNjuW", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $7d47273339df601d$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eBkd9 = parcelRequire("eBkd9");
var $cCFSU = parcelRequire("cCFSU");
var $k8Qyf = parcelRequire("k8Qyf");
const $7d47273339df601d$export$48ea269755562084 = ({ id: id, isAutoDismissed: isAutoDismissed, onDismissed: onDismissed, ...props })=>{
    const [uid] = (0, $eUqFw.useState)(()=>id ?? Math.random().toString(36).substring(2));
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onDismissedWrapper = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-shadow
    (id, analyticsEvent)=>{
        dismissFlag(String(id));
        onDismissed && onDismissed(id, analyticsEvent);
    }, [
        dismissFlag,
        onDismissed
    ]);
    const [flagEl] = (0, $eUqFw.useState)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d47273339df601d$var$FlagWrapper, {
            key: uid
        }, isAutoDismissed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eBkd9.default), {
            id: uid,
            onDismissed: onDismissedWrapper,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
            id: uid,
            onDismissed: onDismissedWrapper,
            ...props
        })));
    (0, $eUqFw.useEffect)(()=>{
        setTimeout(()=>showFlag({
                id: uid,
                render: ()=>flagEl
            }), 0 /* This is to prevent glitches when show/hide flags simultaneously */ );
        return ()=>dismissFlag(uid);
    }, [
        flagEl,
        uid,
        showFlag,
        dismissFlag
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d47273339df601d$var$FlagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_88dhagmp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("CLmMB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $15f716656a02a02e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $15f716656a02a02e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    viewsSpotlightTitle: {
        "id": "portfolio-3-onboarding.changeboarding.views-spotlight-title",
        "defaultMessage": "Views you can use"
    },
    viewsSpotlightMessage: {
        "id": "portfolio-3-onboarding.changeboarding.views-spotlight-message",
        "defaultMessage": "The different aspects of your plan are now easier to find in a simple, more Jira-like menu."
    },
    viewsSpotlightNext: {
        "id": "portfolio-3-onboarding.changeboarding.views-spotlight-next",
        "defaultMessage": "Next"
    },
    modalHeading: {
        "id": "portfolio-3-onboarding.changeboarding.modal-heading",
        "defaultMessage": "It's beginning to look a lot like Jira!"
    },
    modalContentParagraph1: {
        "id": "portfolio-3-onboarding.changeboarding.modal-content-paragraph-1",
        "defaultMessage": "Advanced Roadmaps now looks more like the rest of Jira! This new navigation layout allows you to easily discover features, explore other views of your plan, and can be hidden to give you a full width view of your work."
    },
    modalShowMe: {
        "id": "portfolio-3-onboarding.changeboarding.modal-show-me",
        "defaultMessage": "Show me!"
    },
    modalExploreOnMyOwn: {
        "id": "portfolio-3-onboarding.changeboarding.modal-explore-on-my-own",
        "defaultMessage": "I'll explore on my own"
    },
    flagTitle: {
        "id": "portfolio-3-onboarding.changeboarding.flag-title",
        "defaultMessage": "These are just the highlights"
    },
    flagContent: {
        "id": "portfolio-3-onboarding.changeboarding.flag-content",
        "defaultMessage": "We've also redesigned how Scenarios look, how to save a view of your plan, and more. To see all the changes, check out our Community page!"
    },
    flagClose: {
        "id": "portfolio-3-onboarding.changeboarding.flag-close",
        "defaultMessage": "Close"
    },
    flagReadCommunityPost: {
        "id": "portfolio-3-onboarding.changeboarding.flag-read-community-post",
        "defaultMessage": "Read community post"
    }
});

});

parcelRegister("72mMy", function(module, exports) {

$parcel$export(module.exports, "useStep", () => $48b1aff577ec205f$export$7896576cb7635832);

var $eUqFw = parcelRequire("eUqFw");
const $48b1aff577ec205f$export$7896576cb7635832 = ()=>{
    const [step, setStep] = (0, $eUqFw.useState)('inactive');
    const start = (0, $eUqFw.useCallback)(()=>setStep('modal'), []);
    const finish = (0, $eUqFw.useCallback)(()=>setStep('finished'), []);
    const next = (0, $eUqFw.useCallback)(()=>setStep((current)=>{
            switch(current){
                case 'inactive':
                    return 'modal';
                case 'modal':
                    return 'spotlight';
                case 'spotlight':
                    return 'flag';
                case 'flag':
                    return 'finished';
                default:
                    return 'inactive';
            }
        }), []);
    return [
        step,
        {
            next: next,
            start: start,
            finish: finish
        }
    ];
};

});


parcelRegister("jYuPE", function(module, exports) {

$parcel$export(module.exports, "CtpOnboarding", () => $88a0f85e72f0547f$export$a3cc728690e2f060);

var $eUqFw = parcelRequire("eUqFw");

var $7zpSo = parcelRequire("7zpSo");

var $gUUjF = parcelRequire("gUUjF");

var $1GeZ8 = parcelRequire("1GeZ8");

var $6zEnX = parcelRequire("6zEnX");

var $7ClpZ = parcelRequire("7ClpZ");

var $gpEwb = parcelRequire("gpEwb");

var $1e2c1 = parcelRequire("1e2c1");

var $brBHP = parcelRequire("brBHP");

var $b8Rtj = parcelRequire("b8Rtj");

var $5I3Cd = parcelRequire("5I3Cd");
const $88a0f85e72f0547f$export$a3cc728690e2f060 = ({ planId: planId, issueSources: issueSources, projectKey: projectKey })=>{
    const [{ stage: stage }, { initCtpOnboarding: initCtpOnboarding }] = (0, $7ClpZ.useCtpOnboardingTour)();
    const [{ closed: isPlansOnboardingClosed }] = (0, $6zEnX.useOnboardingTour)();
    const { expandLeftSidebar: expandLeftSidebarChangingEveryRender } = (0, $1GeZ8.usePageLayoutResize)();
    const [expandLeftSidebar] = (0, $eUqFw.useState)(()=>expandLeftSidebarChangingEveryRender);
    (0, $eUqFw.useEffect)(()=>{
        if (planId && isPlansOnboardingClosed) initCtpOnboarding(planId);
    }, [
        initCtpOnboarding,
        planId,
        isPlansOnboardingClosed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Ensure the left sidebar is open for each CTP onboarding step
        expandLeftSidebar();
    }, [
        stage,
        expandLeftSidebar
    ]);
    if (!planId) return null;
    if (!stage) return null;
    const getSpotlightStage = ()=>{
        switch(stage){
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).TIMELINE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I3Cd.TimelineSpotlight), null);
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).CREATE_ISSUE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brBHP.CreateIssueSpotlight), null);
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).TEAMS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8Rtj.TeamsSpotlight), null);
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).BOARDS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1e2c1.BoardsSpotlight), {
                    issueSources: issueSources,
                    projectKey: projectKey
                });
            case (0, $gpEwb.CTP_ONBOARDING_STAGE).CLOSED:
                return null;
            default:
                (0, $gUUjF.default).safeErrorWithoutCustomerData('plans.ctp-onboarding.spotlightMountError', 'Spotlight did not mount getSpotlightStage', {
                    stage: stage,
                    planId: planId,
                    path: window.location.pathname.replace(/\d+/g, '{id}'),
                    errorMessage: "Didn't expect to get here"
                });
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, getSpotlightStage());
};

});
parcelRegister("1e2c1", function(module, exports) {

$parcel$export(module.exports, "BoardsSpotlight", () => $fee6dbe9b126d696$export$e6ea79202f53595d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $7ClpZ = parcelRequire("7ClpZ");

var $6A3mj = parcelRequire("6A3mj");

var $dGtmb = parcelRequire("dGtmb");

var $caENz = parcelRequire("caENz");
const $fee6dbe9b126d696$export$e6ea79202f53595d = ({ issueSources: issueSources, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCtpStage: nextCtpStage }] = (0, $7ClpZ.useCtpOnboardingTour)();
    const issueSourceLinks = (0, $eUqFw.useMemo)(()=>{
        if (!projectKey) return null;
        if (!issueSources?.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $eI5EY.fg)('arj_ctp_template_sort_board_name_in_onboarding') ? issueSources.sort((a, b)=>(a.title ?? '').localeCompare(b.title ?? '')).map(({ id: id, value: boardId, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                key: id,
                target: "_blank",
                href: (0, $caENz.getBoardUrl)(projectKey, boardId),
                className: (0, $7JEyt.default)([
                    "_1e0c1ule _syaz15cr _ca0qu2gc _p12f1osq _1bto1l2s _1reo15vq _18m915vq _o5721q9c _f8pj15cr _nt751r31 _49pcglyw _1hvw1o36 _30l315cr"
                ])
            }, `${title} ${formatMessage((0, $dGtmb.messages).board)}`)) : issueSources.map(({ id: id, value: boardId, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                key: id,
                target: "_blank",
                href: (0, $caENz.getBoardUrl)(projectKey, boardId),
                className: (0, $7JEyt.default)([
                    "_1e0c1ule _syaz15cr _ca0qu2gc _p12f1osq _1bto1l2s _1reo15vq _18m915vq _o5721q9c _f8pj15cr _nt751r31 _49pcglyw _1hvw1o36 _30l315cr"
                ])
            }, `${title} ${formatMessage((0, $dGtmb.messages).board)}`)));
    }, [
        issueSources,
        projectKey,
        formatMessage
    ]);
    // If we have no board links to display, something has gone wrong during template creation
    // Skip displaying this spotlight
    if (!issueSourceLinks) {
        nextCtpStage();
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "crossTeamPlanningBoardsSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actionsBeforeElement: "4/4",
        actions: [
            {
                text: formatMessage((0, $dGtmb.messages).ok),
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'crossTeamPlanningOnboardingFinish');
                    nextCtpStage();
                }
            }
        ],
        heading: formatMessage((0, $dGtmb.messages).heading),
        target: (0, $6A3mj.CtpSpotlights).Teams,
        key: (0, $6A3mj.CtpSpotlights).Boards,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        targetRadius: 3,
        dialogPlacement: "right top",
        dialogWidth: 350
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dGtmb.messages).bodyFirst), issueSourceLinks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
const $fee6dbe9b126d696$var$linkButtonStyles = null;

});
parcelRegister("dGtmb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7bdf59cd48619943$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $7bdf59cd48619943$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.ctp-onboarding.boards-spotlight.heading",
        "defaultMessage": "A board for each team"
    },
    bodyFirst: {
        "id": "portfolio-3-onboarding.ctp-onboarding.boards-spotlight.body-first",
        "defaultMessage": "Bookmark these two team boards for quick access."
    },
    board: {
        "id": "portfolio-3-onboarding.ctp-onboarding.boards-spotlight.board",
        "defaultMessage": "Board"
    },
    ok: {
        "id": "portfolio-3-onboarding.ctp-onboarding.boards-spotlight.ok",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("caENz", function(module, exports) {

$parcel$export(module.exports, "getBoardUrl", () => $056a78dd491b7574$export$505a9f131607d070);
const $056a78dd491b7574$export$505a9f131607d070 = (projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;

});


parcelRegister("brBHP", function(module, exports) {

$parcel$export(module.exports, "CreateIssueSpotlight", () => $bb4c881383fe5e4f$export$3a85773f11f010e3);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7ClpZ = parcelRequire("7ClpZ");

var $6A3mj = parcelRequire("6A3mj");

var $dk8H3 = parcelRequire("dk8H3");
const $bb4c881383fe5e4f$export$3a85773f11f010e3 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCtpStage: nextCtpStage }] = (0, $7ClpZ.useCtpOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "crossTeamPlanningCreateIssueSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actionsBeforeElement: "2/4",
        actions: [
            {
                text: formatMessage((0, $dk8H3.messages).next),
                onClick: ()=>nextCtpStage()
            }
        ],
        heading: formatMessage((0, $dk8H3.messages).heading),
        target: (0, $6A3mj.CtpSpotlights).CreateIssue,
        key: (0, $6A3mj.CtpSpotlights).CreateIssue,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        targetRadius: 3,
        dialogPlacement: "bottom left",
        dialogWidth: 350
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dk8H3.messages).bodyFirst), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $dk8H3.messages).bodySecond, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dk8H3.messages).bodyThird)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("dk8H3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d4c6838e14257f22$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d4c6838e14257f22$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.ctp-onboarding.create-issue-spotlight.heading",
        "defaultMessage": "Create issues in the plan"
    },
    bodyFirst: {
        "id": "portfolio-3-onboarding.ctp-onboarding.create-issue-spotlight.body-first",
        "defaultMessage": "Create issues in the plan and assign work to a team-specific board."
    },
    bodySecond: {
        "id": "portfolio-3-onboarding.ctp-onboarding.create-issue-spotlight.body-second",
        "defaultMessage": "Select <b>Review changes</b> to save edits in your plan to issues in your project."
    },
    bodyThird: {
        "id": "portfolio-3-onboarding.ctp-onboarding.create-issue-spotlight.body-third",
        "defaultMessage": "You can also add an existing issue source to your plan."
    },
    next: {
        "id": "portfolio-3-onboarding.ctp-onboarding.create-issue-spotlight.next",
        "defaultMessage": "Next"
    }
});

});


parcelRegister("b8Rtj", function(module, exports) {

$parcel$export(module.exports, "TeamsSpotlight", () => $adceec8b518565d3$export$691b612cd271a7d4);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7ClpZ = parcelRequire("7ClpZ");

var $6A3mj = parcelRequire("6A3mj");

var $e3xS5 = parcelRequire("e3xS5");
const $adceec8b518565d3$export$691b612cd271a7d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCtpStage: nextCtpStage }] = (0, $7ClpZ.useCtpOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "crossTeamPlanningTeamsSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actionsBeforeElement: "3/4",
        actions: [
            {
                text: formatMessage((0, $e3xS5.messages).next),
                onClick: ()=>nextCtpStage()
            }
        ],
        heading: formatMessage((0, $e3xS5.messages).heading),
        target: (0, $6A3mj.CtpSpotlights).Teams,
        key: (0, $6A3mj.CtpSpotlights).Teams,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        targetRadius: 3,
        dialogPlacement: "right top",
        dialogWidth: 350
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $e3xS5.messages).bodyFirst), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $e3xS5.messages).bodySecond, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("e3xS5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f8d9f8cc48122412$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f8d9f8cc48122412$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.ctp-onboarding.teams-spotlight.heading",
        "defaultMessage": "Change teams"
    },
    bodyFirst: {
        "id": "portfolio-3-onboarding.ctp-onboarding.teams-spotlight.body-first",
        "defaultMessage": "By default, this plan includes two new teams."
    },
    bodySecond: {
        "id": "portfolio-3-onboarding.ctp-onboarding.teams-spotlight.body-second",
        "defaultMessage": "Use the <b>Teams</b> tab to remove or add an existing team from your organization."
    },
    next: {
        "id": "portfolio-3-onboarding.ctp-onboarding.teams-spotlight.next",
        "defaultMessage": "Next"
    }
});

});


parcelRegister("5I3Cd", function(module, exports) {

$parcel$export(module.exports, "TimelineSpotlight", () => $5d56dd17f4547550$export$317ca0a8e8606fff);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7ClpZ = parcelRequire("7ClpZ");

var $6A3mj = parcelRequire("6A3mj");

var $kLkyp = parcelRequire("kLkyp");
const $5d56dd17f4547550$export$317ca0a8e8606fff = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCtpStage: nextCtpStage }] = (0, $7ClpZ.useCtpOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "crossTeamPlanningTimelineSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actionsBeforeElement: "1/4",
        actions: [
            {
                text: formatMessage((0, $kLkyp.messages).next),
                onClick: ()=>nextCtpStage()
            }
        ],
        heading: formatMessage((0, $kLkyp.messages).heading),
        target: (0, $6A3mj.CtpSpotlights).Timeline,
        key: (0, $6A3mj.CtpSpotlights).Timeline,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        targetRadius: 3,
        dialogPlacement: "right top",
        dialogWidth: 350
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kLkyp.messages).bodyFirst), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kLkyp.messages).bodySecond)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("kLkyp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $42b84afce08b8159$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $42b84afce08b8159$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.ctp-onboarding.timeline-spotlight.heading",
        "defaultMessage": "Welcome to your cross-team plan"
    },
    bodyFirst: {
        "id": "portfolio-3-onboarding.ctp-onboarding.timeline-spotlight.body-first",
        "defaultMessage": "Get a complete view of the work of multiple teams as a list or timeline."
    },
    bodySecond: {
        "id": "portfolio-3-onboarding.ctp-onboarding.timeline-spotlight.body-second",
        "defaultMessage": "Start by adding issues, then applying filters to track, plan or report on work."
    },
    next: {
        "id": "portfolio-3-onboarding.ctp-onboarding.timeline-spotlight.next",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("4Yo2u", function(module, exports) {

$parcel$export(module.exports, "CttOnboarding", () => $26958068fc51ff3f$export$3525310af3288e74);

var $eUqFw = parcelRequire("eUqFw");

var $7zpSo = parcelRequire("7zpSo");

var $7SyBh = parcelRequire("7SyBh");

var $jDE3A = parcelRequire("jDE3A");

var $bqwPF = parcelRequire("bqwPF");

var $5tMU0 = parcelRequire("5tMU0");

var $esGjt = parcelRequire("esGjt");

var $dgPiK = parcelRequire("dgPiK");

var $lcWnA = parcelRequire("lcWnA");

var $8OQwX = parcelRequire("8OQwX");

var $aQwPd = parcelRequire("aQwPd");
const $26958068fc51ff3f$export$3525310af3288e74 = ({ planId: planId, variant: variant, hasAnyInitiatives: hasAnyInitiatives, hasEpicWithParent: hasEpicWithParent, isRoadmapGroupedByNone: isRoadmapGroupedByNone, setInlineCreate: setInlineCreate, setClearInlineCreate: setClearInlineCreate, setRedirectToSpaPlanPage: setRedirectToSpaPlanPage, setPrimeRoadmap: setPrimeRoadmap })=>{
    const [{ stage: stage }, { initCttOnboarding: initCttOnboarding }] = (0, $7SyBh.useCttOnboardingTour)();
    const propsStepInputTitle = {
        setInlineCreate: setInlineCreate,
        setClearInlineCreate: setClearInlineCreate,
        setPrimeRoadmap: setPrimeRoadmap,
        variant: variant,
        hasAnyInitiatives: hasAnyInitiatives
    };
    const propsStepInputEpicReparent = {
        variant: variant,
        hasEpicWithParent: hasEpicWithParent
    };
    const propsForEpicReparentSpotlight = {
        variant: variant,
        isRoadmapGroupedByNone: isRoadmapGroupedByNone,
        setPrimeRoadmap: setPrimeRoadmap,
        setRedirectToSpaPlanPage: setRedirectToSpaPlanPage
    };
    const propsForNavigateIssueSources = {
        setRedirectToSpaPlanPage: setRedirectToSpaPlanPage,
        hasAnyInitiatives: hasAnyInitiatives
    };
    (0, $eUqFw.useEffect)(()=>{
        if (planId) initCttOnboarding(planId);
    }, [
        initCttOnboarding,
        planId
    ]);
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    if (!planId) return null;
    if (!stage) return null;
    const getSpotlightStage = ()=>{
        switch(stage){
            case (0, $jDE3A.CttOnboardingStage).CREATE_INITATIVE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tMU0.CreateInitativeSpotlight), {
                    variant: variant
                });
            case (0, $jDE3A.CttOnboardingStage).INPUT_TITLE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQwPd.StepInputTitle), propsStepInputTitle);
            case (0, $jDE3A.CttOnboardingStage).NAVIGATE_ISSUE_SOURCES:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgPiK.NavigateIssueSourcesSpotlight), propsForNavigateIssueSources);
            case (0, $jDE3A.CttOnboardingStage).SHOW_ISSUE_SOURCES:
            case (0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN:
                // for these two cases we mount the spotlight directly on the sidebar.
                return null;
            case (0, $jDE3A.CttOnboardingStage).EPIC_REPARENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $esGjt.EpicReparentSpotlight), propsForEpicReparentSpotlight);
            case (0, $jDE3A.CttOnboardingStage).INPUT_EPIC_REPARENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8OQwX.StepInputEpicReparent), propsStepInputEpicReparent);
            case (0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcWnA.ReviewChangesSpotlight), {
                    variant: variant
                });
            case (0, $jDE3A.CttOnboardingStage).FINISH_FLAG:
                return null;
            case (0, $jDE3A.CttOnboardingStage).CLOSED:
                return null;
            default:
                assertUnreachable(stage);
                return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, getSpotlightStage()), stage === (0, $jDE3A.CttOnboardingStage).FINISH_FLAG && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqwPF.FinishFlag), null));
};

});
parcelRegister("bqwPF", function(module, exports) {

$parcel$export(module.exports, "FinishFlag", () => $a11939859256854a$export$35e948d10c687c6d);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $cNjuW = parcelRequire("cNjuW");

var $7SyBh = parcelRequire("7SyBh");

var $hkCvR = parcelRequire("hkCvR");
const $a11939859256854a$export$35e948d10c687c6d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { closeCttOnboarding: closeCttOnboarding, setCttTakingTour: setCttTakingTour }] = (0, $7SyBh.useCttOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "topLevelPlanningFinishFlag",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNjuW.Flag), {
        isAutoDismissed: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
            label: "Success"
        }),
        onDismissed: ()=>{
            closeCttOnboarding({
                silent: false
            });
        },
        title: `\u{1F389} ${formatMessage((0, $hkCvR.messages).spotlightFinishedFlagTitle)} \u{1F389}`,
        description: formatMessage((0, $hkCvR.messages).spotlightFinishedFlagBodyPlans),
        actions: [
            {
                content: formatMessage((0, $hkCvR.messages).spotlightFinishedFlagTakeFullTour),
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningFinishFlagTakeFullTour');
                    closeCttOnboarding({
                        silent: false
                    });
                    setCttTakingTour();
                }
            },
            {
                content: formatMessage((0, $hkCvR.messages).spotlightFinishedFlagReadTheDocumentation),
                href: ' https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/',
                target: '_blank',
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningFinishFlagDocumentation');
                    closeCttOnboarding({
                        silent: false
                    });
                }
            }
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("hkCvR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $75a743c27a1db9fb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $75a743c27a1db9fb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightFinishedFlagTitle: {
        "id": "portfolio-3-onboarding.ctt-onboarding.finish-flag.spotlight-finished-flag-title",
        "defaultMessage": "You've made your first plan!"
    },
    spotlightFinishedFlagBodyPlans: {
        "id": "portfolio-3-onboarding.ctt-onboarding.finish-flag.spotlight-finished-flag-body-plans",
        "defaultMessage": "But why stop here? Learn how to take your planning to the next level!"
    },
    spotlightFinishedFlagTakeFullTour: {
        "id": "portfolio-3-onboarding.ctt-onboarding.finish-flag.spotlight-finished-flag-take-full-tour",
        "defaultMessage": "Take the full tour"
    },
    spotlightFinishedFlagReadTheDocumentation: {
        "id": "portfolio-3-onboarding.ctt-onboarding.finish-flag.spotlight-finished-flag-read-the-documentation",
        "defaultMessage": "Read the documentation"
    }
});

});


parcelRegister("5tMU0", function(module, exports) {

$parcel$export(module.exports, "CreateInitativeSpotlight", () => $5de0b5d5f43fe38b$export$6a09fe62f19d45d1);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $9AYBy = parcelRequire("9AYBy");

var $7SyBh = parcelRequire("7SyBh");

var $jDE3A = parcelRequire("jDE3A");

var $hIE3U = parcelRequire("hIE3U");

var $6ccPi = parcelRequire("6ccPi");
const $5de0b5d5f43fe38b$export$6a09fe62f19d45d1 = ({ variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCttStage: nextCttStage }] = (0, $7SyBh.useCttOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "topLevelPlanningCreateInitiativeSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actions: [
            {
                text: formatMessage((0, $6ccPi.messages).spotlightGotIt),
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningCreateInitiativeNext', {
                        isInitiativeLevelConfigured: variant !== (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE
                    });
                    nextCttStage();
                }
            }
        ],
        image: (0, (/*@__PURE__*/$parcel$interopDefault($9AYBy))),
        dialogWidth: 275,
        heading: formatMessage((0, $6ccPi.messages).spotlightCreateInitativeTitle),
        target: (0, $hIE3U.CttSpotlights).CreateIssue,
        key: (0, $hIE3U.CttSpotlights).CreateIssue,
        targetRadius: 3,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6ccPi.messages).spotlightCreateInitativeBodyP1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6ccPi.messages).spotlightCreateInitativeBodyP2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isInitiativeLevelConfigured: variant !== (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE
        }
    }));
};

});
parcelRegister("9AYBy", function(module, exports) {
module.exports = new URL("create-initiative.71932101.svg", import.meta.url).toString();

});

parcelRegister("6ccPi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $158d0034dd987893$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $158d0034dd987893$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightGotIt: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-create-initative.spotlight-got-it",
        "defaultMessage": "Got it"
    },
    spotlightCreateInitativeTitle: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-create-initative.spotlight-create-initative-title",
        "defaultMessage": "Take the initiative!"
    },
    spotlightCreateInitativeBodyP1: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-create-initative.spotlight-create-initative-body-p-1",
        "defaultMessage": "Start by defining your first Initiative, which sits on the hierarchy level above Epics. They represent big goals like \u201CBuild a rocket\u201D, \u201CLaunch a new app\u201D, or \u201CTake over the world\u201D."
    },
    spotlightCreateInitativeBodyP2: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-create-initative.spotlight-create-initative-body-p-2",
        "defaultMessage": "So what are your goals?"
    }
});

});


parcelRegister("esGjt", function(module, exports) {

$parcel$export(module.exports, "EpicReparentSpotlight", () => $32d7afd1851bb759$export$d0f440f7a11925c1);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $7SyBh = parcelRequire("7SyBh");

var $jDE3A = parcelRequire("jDE3A");

var $hIE3U = parcelRequire("hIE3U");

var $ekajr = parcelRequire("ekajr");
const $32d7afd1851bb759$export$d0f440f7a11925c1 = ({ variant: variant, setPrimeRoadmap: setPrimeRoadmap, setRedirectToSpaPlanPage: setRedirectToSpaPlanPage, isRoadmapGroupedByNone: isRoadmapGroupedByNone })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCttStage: nextCttStage, setSpotlight: setSpotlight, resetSpotlight: resetSpotlight }] = (0, $7SyBh.useCttOnboardingTour)();
    const [hasPrimedForReparenting, setHasPrimedForReparenting] = (0, $eUqFw.useState)(false);
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    (0, $eUqFw.useEffect)(()=>{
        if (!hasPrimedForReparenting) {
            setPrimeRoadmap();
            setHasPrimedForReparenting(true);
        }
    }, [
        hasPrimedForReparenting,
        setPrimeRoadmap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasPrimedForReparenting && (variant === (0, $jDE3A.CttOnboardingVariant).TMP_EPIC || variant === (0, $jDE3A.CttOnboardingVariant).NO_EPIC)) setSpotlight((0, $hIE3U.CttSpotlights).Scope);
        if (hasPrimedForReparenting && !isRoadmapGroupedByNone) // Something went wrong skip this step
        nextCttStage((0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES);
        return ()=>{
            resetSpotlight();
        };
    }, [
        hasPrimedForReparenting,
        isRoadmapGroupedByNone,
        nextCttStage,
        resetSpotlight,
        setSpotlight,
        variant
    ]);
    if (!hasPrimedForReparenting) return null;
    const fireSkippedButtonEvent = (analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningEpicReparentSkip', {
            variant: variant
        });
    };
    const fireGoBackToIssueSourcesButtonEvent = (analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningEpicReparentGoBackToIssueSources', {
            variant: variant
        });
    };
    const getSpotLight = ()=>{
        try {
            switch(variant){
                case (0, $jDE3A.CttOnboardingVariant).TMP_EPIC:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                        actions: [
                            {
                                text: formatMessage((0, $ekajr.messages).spotlightGoToIssueSources),
                                onClick: (_, analyticsEvent)=>{
                                    fireGoBackToIssueSourcesButtonEvent(analyticsEvent);
                                    resetSpotlight();
                                    nextCttStage((0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN);
                                    setRedirectToSpaPlanPage('/settings/issue-sources');
                                }
                            },
                            {
                                text: formatMessage((0, $ekajr.messages).spotlightContinueAnyway),
                                appearance: 'subtle',
                                onClick: (_, analyticsEvent)=>{
                                    fireSkippedButtonEvent(analyticsEvent);
                                    resetSpotlight();
                                    nextCttStage((0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES);
                                }
                            }
                        ],
                        target: (0, $hIE3U.CttSpotlights).Scope,
                        key: (0, $hIE3U.CttSpotlights).Scope,
                        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                        targetRadius: 3
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ekajr.messages).spotlightTmpEpicBody));
                case (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE:
                case (0, $jDE3A.CttOnboardingVariant).NO_EPIC:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                        actions: [
                            {
                                text: formatMessage((0, $ekajr.messages).spotlightGoToIssueSources),
                                onClick: (_, analyticsEvent)=>{
                                    fireGoBackToIssueSourcesButtonEvent(analyticsEvent);
                                    resetSpotlight();
                                    nextCttStage((0, $jDE3A.CttOnboardingStage).NAVIGATE_PLAN);
                                    setRedirectToSpaPlanPage('/settings/issue-sources');
                                }
                            },
                            {
                                text: formatMessage((0, $ekajr.messages).spotlightSkip),
                                appearance: 'subtle',
                                onClick: (_, analyticsEvent)=>{
                                    fireSkippedButtonEvent(analyticsEvent);
                                    resetSpotlight();
                                    nextCttStage((0, $jDE3A.CttOnboardingStage).REVIEW_CHANGES);
                                }
                            }
                        ],
                        target: (0, $hIE3U.CttSpotlights).Scope,
                        key: (0, $hIE3U.CttSpotlights).Scope,
                        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
                        targetRadius: 3
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ekajr.messages).spotlightNoEpicsBody));
                case (0, $jDE3A.CttOnboardingVariant).EPIC:
                    return isRoadmapGroupedByNone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
                        actions: [
                            {
                                text: formatMessage((0, $ekajr.messages).spotlightGotIt),
                                onClick: (_, analyticsEvent)=>{
                                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningEpicReparentGotIt', {
                                        variant: variant
                                    });
                                    nextCttStage();
                                }
                            }
                        ],
                        target: (0, $hIE3U.CttSpotlights).EpicSection,
                        key: (0, $hIE3U.CttSpotlights).EpicSection,
                        targetRadius: 3,
                        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ekajr.messages).spotlightEpicReparentBody)) : null;
                default:
                    assertUnreachable(variant);
                    return null;
            }
        } catch (e) {
            return null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "topLevelPlanningEpicReparentSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, getSpotLight(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            hasOnlyTmpEpics: variant === (0, $jDE3A.CttOnboardingVariant).TMP_EPIC,
            hasNoEpics: variant === (0, $jDE3A.CttOnboardingVariant).NO_EPIC,
            hasNoInitiativesConfigured: variant === (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE
        }
    }));
};

});
parcelRegister("ekajr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d515ffd18238ccc5$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d515ffd18238ccc5$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightEpicReparentBody: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-epic-reparent-body",
        "defaultMessage": "To complete your planning spree, drag and drop an Epic under an Initiative. This lets you roll-up values from all the child issues to the Initiative level."
    },
    spotlightNoEpicsBody: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-no-epics-body",
        "defaultMessage": "To keep going, add a project to your plan that includes at least one Epic."
    },
    spotlightTmpEpicBody: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-tmp-epic-body",
        "defaultMessage": "Right now, re-parenting issues isn't possible for team-managed projects."
    },
    spotlightGotIt: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-got-it",
        "defaultMessage": "Got it"
    },
    spotlightGoToIssueSources: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-go-to-issue-sources",
        "defaultMessage": "Go to issue sources"
    },
    spotlightSkip: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-skip",
        "defaultMessage": "Skip"
    },
    spotlightContinueAnyway: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-epic-reparent.spotlight-continue-anyway",
        "defaultMessage": "Continue anyway"
    }
});

});


parcelRegister("dgPiK", function(module, exports) {

$parcel$export(module.exports, "NavigateIssueSourcesSpotlight", () => $73c66c6f46b5f644$export$3c7ed5e41e742555);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $7SyBh = parcelRequire("7SyBh");

var $hIE3U = parcelRequire("hIE3U");

var $bkBN7 = parcelRequire("bkBN7");
const $73c66c6f46b5f644$export$3c7ed5e41e742555 = ({ setRedirectToSpaPlanPage: setRedirectToSpaPlanPage, hasAnyInitiatives: hasAnyInitiatives })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCttStage: nextCttStage }] = (0, $7SyBh.useCttOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "topLevelPlanningNavigateIssueSourcesSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actions: [
            {
                text: formatMessage((0, $bkBN7.messages).spotlightGotToIssueSources),
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningNavigateToIssueSources', {
                        isInitiativeCreated: hasAnyInitiatives
                    });
                    setRedirectToSpaPlanPage('/settings/issue-sources');
                    nextCttStage();
                }
            }
        ],
        heading: formatMessage((0, $bkBN7.messages).spotlightNavigateIssueSourcesTitle),
        target: (0, $hIE3U.CttSpotlights).Settings,
        key: (0, $hIE3U.CttSpotlights).Settings,
        targetRadius: 3,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bkBN7.messages).spotlightNavigateIssueSourcesBodyP1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $bkBN7.messages).spotlightNavigateIssueSourcesBodyP2, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isInitiativeCreated: hasAnyInitiatives
        }
    }));
};

});
parcelRegister("bkBN7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aae12fc6282be410$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $aae12fc6282be410$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightGotToIssueSources: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-navigate-issue-sources.spotlight-got-to-issue-sources",
        "defaultMessage": "Go to Issue Sources"
    },
    spotlightNavigateIssueSourcesTitle: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-navigate-issue-sources.spotlight-navigate-issue-sources-title",
        "defaultMessage": "Let's keep going!"
    },
    spotlightNavigateIssueSourcesBodyP1: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-navigate-issue-sources.spotlight-navigate-issue-sources-body-p-1",
        "defaultMessage": "Now add another project, board, or filter that has the work items you want to track with your Initiative."
    },
    spotlightNavigateIssueSourcesBodyP2: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-navigate-issue-sources.spotlight-navigate-issue-sources-body-p-2",
        "defaultMessage": "Select <b>Plan settings</b>, then <b>Issue sources</b>."
    }
});

});


parcelRegister("lcWnA", function(module, exports) {

$parcel$export(module.exports, "ReviewChangesSpotlight", () => $d0d5765f21bd3858$export$6662ecfe97cb94ad);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $7SyBh = parcelRequire("7SyBh");

var $hIE3U = parcelRequire("hIE3U");

var $Vch2Y = parcelRequire("Vch2Y");
const $d0d5765f21bd3858$export$6662ecfe97cb94ad = ({ variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { nextCttStage: nextCttStage }] = (0, $7SyBh.useCttOnboardingTour)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "topLevelPlanningReviewChangesSpotlight",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        actions: [
            {
                text: formatMessage((0, $Vch2Y.messages).spotlightGotIt),
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'topLevelPlanningReviewChangesGotIt', {
                        isReparentingSkipped: variant === 'TMP_EPIC' || variant === 'NO_EPIC' || variant === 'NO_INITIATIVE'
                    });
                    nextCttStage();
                }
            }
        ],
        heading: formatMessage((0, $Vch2Y.messages).spotlightReviewChangesTitle),
        target: (0, $hIE3U.CttSpotlights).ReviewChanges,
        key: (0, $hIE3U.CttSpotlights).ReviewChanges,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        targetRadius: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $Vch2Y.messages).spotlightReviewChangesBodyP1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $Vch2Y.messages).spotlightReviewChangesBodyP2, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            variant: variant
        }
    }));
};

});
parcelRegister("Vch2Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9dbea673065285fa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9dbea673065285fa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightGotIt: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-review-changes.spotlight-got-it",
        "defaultMessage": "Got it"
    },
    spotlightReviewChangesTitle: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-review-changes.spotlight-review-changes-title",
        "defaultMessage": "Save your changes"
    },
    spotlightReviewChangesBodyP1: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-review-changes.spotlight-review-changes-body-p-1",
        "defaultMessage": "Your plan is a sandbox environment, meaning your changes are held until you're ready to save them. "
    },
    spotlightReviewChangesBodyP2: {
        "id": "portfolio-3-onboarding.ctt-onboarding.spotlight-review-changes.spotlight-review-changes-body-p-2",
        "defaultMessage": "Use <b>Review changes</b> to save or discard your edits."
    }
});

});


parcelRegister("8OQwX", function(module, exports) {

$parcel$export(module.exports, "StepInputEpicReparent", () => $29aa83f6c4a84f8b$export$e65bd73456673304);

var $eUqFw = parcelRequire("eUqFw");

var $7SyBh = parcelRequire("7SyBh");

var $jDE3A = parcelRequire("jDE3A");
const $29aa83f6c4a84f8b$export$e65bd73456673304 = ({ variant: variant, hasEpicWithParent: hasEpicWithParent })=>{
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    const [, { nextCttStage: nextCttStage }] = (0, $7SyBh.useCttOnboardingTour)();
    (0, $eUqFw.useEffect)(()=>{
        try {
            switch(variant){
                case (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE:
                case (0, $jDE3A.CttOnboardingVariant).NO_EPIC:
                case (0, $jDE3A.CttOnboardingVariant).TMP_EPIC:
                    nextCttStage();
                    break;
                case (0, $jDE3A.CttOnboardingVariant).EPIC:
                    if (hasEpicWithParent) nextCttStage();
                    break;
                default:
                    assertUnreachable(variant);
                    break;
            }
        } catch (e) {
            nextCttStage();
        }
    }, [
        hasEpicWithParent,
        nextCttStage,
        variant
    ]);
    return null;
};

});

parcelRegister("aQwPd", function(module, exports) {

$parcel$export(module.exports, "StepInputTitle", () => $d1c04dcad235caf4$export$d8d807b6fa718a0d);

var $eUqFw = parcelRequire("eUqFw");

var $7SyBh = parcelRequire("7SyBh");

var $jDE3A = parcelRequire("jDE3A");
const $d1c04dcad235caf4$export$d8d807b6fa718a0d = ({ setInlineCreate: setInlineCreate, setClearInlineCreate: setClearInlineCreate, setPrimeRoadmap: setPrimeRoadmap, variant: variant, hasAnyInitiatives: hasAnyInitiatives })=>{
    const assertUnreachable = (_)=>{
        throw new Error("Didn't expect to get here");
    };
    const [, { nextCttStage: nextCttStage }] = (0, $7SyBh.useCttOnboardingTour)();
    const [hasStartedInlineCreate, setHasStartedInlineCreate] = (0, $eUqFw.useState)(false);
    const [hasPrimedRoadmap, setHasPrimedRoadmap] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        try {
            switch(variant){
                case (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE:
                    nextCttStage();
                    break;
                case (0, $jDE3A.CttOnboardingVariant).EPIC:
                case (0, $jDE3A.CttOnboardingVariant).NO_EPIC:
                case (0, $jDE3A.CttOnboardingVariant).TMP_EPIC:
                    if (!hasPrimedRoadmap) {
                        setPrimeRoadmap();
                        setHasPrimedRoadmap(true);
                        break;
                    }
                    if (hasAnyInitiatives) {
                        setClearInlineCreate();
                        nextCttStage();
                        break;
                    }
                    if (!hasStartedInlineCreate) // In the event that there is some unforeseen other failure, skip the user input.
                    try {
                        setInlineCreate();
                        setHasStartedInlineCreate(true);
                    } catch (e) {
                        nextCttStage((0, $jDE3A.CttOnboardingStage).NAVIGATE_ISSUE_SOURCES);
                    }
                    break;
                default:
                    assertUnreachable(variant);
                    break;
            }
        } catch (e) {
            nextCttStage();
        }
    }, [
        setClearInlineCreate,
        hasAnyInitiatives,
        hasPrimedRoadmap,
        hasStartedInlineCreate,
        nextCttStage,
        variant,
        setPrimeRoadmap,
        setInlineCreate
    ]);
    return null;
};

});


parcelRegister("5Kbvu", function(module, exports) {

$parcel$export(module.exports, "FlagGroupGuard", () => $312efa88db5ea0a4$export$282f85d0de401244);

var $eUqFw = parcelRequire("eUqFw");

var $6zEnX = parcelRequire("6zEnX");

var $7ClpZ = parcelRequire("7ClpZ");

var $7SyBh = parcelRequire("7SyBh");
const $312efa88db5ea0a4$export$282f85d0de401244 = ({ forChangeboarding: forChangeboarding, forCttOnboarding: forCttOnboarding, forCtpOnboarding: forCtpOnboarding, children: children })=>{
    const [rehydrated] = (0, $6zEnX.useRehydrated)();
    const [changeboarding] = (0, $6zEnX.useChangeboarding)();
    const [cttOnboarding] = (0, $7SyBh.useCttOnboardingTour)();
    const [ctpOnboarding] = (0, $7ClpZ.useCtpOnboardingTour)();
    if (!rehydrated) return null;
    if (forChangeboarding && changeboarding.visible) return null;
    if (forCttOnboarding && cttOnboarding.visible) return null;
    if (forCtpOnboarding && ctpOnboarding.visible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("h9jAv", function(module, exports) {

$parcel$export(module.exports, "Onboarding", () => $e35e83218a2d1253$export$70238cd3868b67c9);

var $eUqFw = parcelRequire("eUqFw");

var $jWuk1 = parcelRequire("jWuk1");

var $9exb1 = parcelRequire("9exb1");
var $dxopF = parcelRequire("dxopF");
var $7zpSo = parcelRequire("7zpSo");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1GeZ8 = parcelRequire("1GeZ8");

var $5CV7v = parcelRequire("5CV7v");

var $d6f6c = parcelRequire("d6f6c");

var $j2AVF = parcelRequire("j2AVF");

var $cDwYm = parcelRequire("cDwYm");

var $7Jv2m = parcelRequire("7Jv2m");

var $ls9eE = parcelRequire("ls9eE");

var $5rV2v = parcelRequire("5rV2v");

var $2K6Hv = parcelRequire("2K6Hv");

var $gsYdu = parcelRequire("gsYdu");

var $j1sNH = parcelRequire("j1sNH");

var $ew8RF = parcelRequire("ew8RF");

var $6nFPe = parcelRequire("6nFPe");

var $lHj3G = parcelRequire("lHj3G");

var $jJOqx = parcelRequire("jJOqx");

var $dPvFo = parcelRequire("dPvFo");

var $hfNY2 = parcelRequire("hfNY2");

var $7p7t4 = parcelRequire("7p7t4");
const $e35e83218a2d1253$var$IconButtonStyles = {
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
const $e35e83218a2d1253$export$70238cd3868b67c9 = (props)=>{
    const [{ visible: visible }, { init: init, close: close }] = (0, $7p7t4.useController)(props);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [step, { next: next, start: start, finish: finish, skip: skip }] = (0, $7p7t4.useStep)();
    const [{ spotlight: spotlight, currentStepCount: currentStepCount, totalStepCount: totalStepCount }, { reset: resetSpotlight, start: startSpotlight, next: nextSpotlight }] = (0, $7Jv2m.useCurrentSpotlight)();
    const { expandLeftSidebar: expandLeftSidebarChangingEveryRender } = (0, $1GeZ8.usePageLayoutResize)();
    const [expandLeftSidebar] = (0, $eUqFw.useState)(()=>expandLeftSidebarChangingEveryRender);
    const openInProductHelp = (0, $3QLcd.useHelpPanelLink)();
    (0, $eUqFw.useEffect)(()=>{
        init();
    }, [
        init
    ]);
    // Auto-start
    (0, $eUqFw.useEffect)(()=>{
        if (visible) start();
    }, [
        start,
        visible
    ]);
    // Start the spotlight
    (0, $eUqFw.useEffect)(()=>{
        if (step === 'spotlight') startSpotlight();
    }, [
        step,
        startSpotlight
    ]);
    // When the spotlight finishes
    (0, $eUqFw.useEffect)(()=>{
        if (spotlight === undefined) {
            next();
            if (!(0, $1ybV0.ff)('sploverview-onboarding-tour')) resetSpotlight();
        }
    }, [
        next,
        resetSpotlight,
        spotlight
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).Views) expandLeftSidebar();
        if (step === 'flag') {
            if ((0, $1ybV0.ff)('sploverview-onboarding-tour')) resetSpotlight();
            close({
                silent: true
            });
        }
        if (step === 'finished') {
            if ((0, $7p7t4.isCrossTeamPlanningTemplateExperimentEnabled)()) // We must ensure the 'CLOSED' state of the plans onboarding is set on the state
            // when the plans onboarding finishes to allow display of onboardings that follow
            close({
                silent: false
            });
            else close();
        }
    }, [
        step,
        spotlight,
        resetSpotlight,
        expandLeftSidebar,
        close
    ]);
    const spotlightActions = ({ learnMoreURL: learnMoreURL })=>{
        const nextAction = {
            onClick: nextSpotlight,
            text: formatMessage((0, $5rV2v.messages).spotlightNext)
        };
        return learnMoreURL ? [
            nextAction,
            {
                text: formatMessage((0, $5rV2v.messages).spotlightLearnMore),
                appearance: 'subtle-link',
                href: learnMoreURL,
                target: '_blank'
            }
        ] : [
            nextAction
        ];
    };
    const spotlightHeadingAfterElement = (0, $1ybV0.ff)('sploverview-onboarding-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CV7v.IconButton), {
        onClick: skip,
        ariaLabel: formatMessage((0, $5rV2v.messages).spotlightCloseLabel),
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $e35e83218a2d1253$var$IconButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        size: "small",
        label: "",
        primaryColor: `var(--ds-surface, ${(0, $PdmhA.N0)})`
    })) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('sploverview-onboarding-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, step === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9exb1.default), {
        heading: formatMessage((0, $5rV2v.messages).modalHeadingPlansSpork),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cDwYm))),
        actions: [
            {
                onClick: finish,
                appearance: 'subtle',
                text: formatMessage((0, $5rV2v.messages).modalSkip)
            },
            {
                onClick: next,
                appearance: 'primary',
                text: formatMessage((0, $5rV2v.messages).modalTakeTour)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "modal",
        action: "viewed",
        actionSubjectId: "advancedRoadmapsOnboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5rV2v.messages).modalContentParagraphPlansSpork))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, step === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9exb1.default), {
        heading: formatMessage((0, $5rV2v.messages).modalHeadingPlansSpork),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($j2AVF))),
        actions: [
            {
                onClick: finish,
                appearance: 'subtle',
                text: formatMessage((0, $5rV2v.messages).modalSkipTour)
            },
            {
                onClick: next,
                appearance: 'primary',
                text: formatMessage((0, $5rV2v.messages).modalGetStarted)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "modal",
        action: "viewed",
        actionSubjectId: "advancedRoadmapsOnboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5rV2v.messages).modalContentParagraphPlansSpork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).Scope && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lHj3G.ScopeSpotlight), {
        target: (0, $7Jv2m.Spotlights).Scope,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).Fields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2K6Hv.FieldsSpotlight), {
        target: (0, $7Jv2m.Spotlights).Fields,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).Timeline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dPvFo.TimelineSpotlight), {
        target: (0, $7Jv2m.Spotlights).Timeline,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).HeartOfPlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1sNH.HeartOfPlanSpotlight), {
        target: (0, $7Jv2m.Spotlights).HeartOfPlan,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).ListMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ew8RF.ListModeSpotlight), {
        target: (0, $7Jv2m.Spotlights).ListMode,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).Views && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hfNY2.ViewsSpotlight), {
        target: (0, $7Jv2m.Spotlights).Views,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).ShowAndTell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jJOqx.ShowAndTellSpotlight), {
        target: (0, $7Jv2m.Spotlights).ShowAndTell,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).SaveYourChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nFPe.SaveYourChangesSpotlight), {
        target: (0, $7Jv2m.Spotlights).SaveYourChanges,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    }), step === 'spotlight' && spotlight === (0, $7Jv2m.Spotlights).FindYourLook && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsYdu.FindYourLookSpotlight), {
        target: (0, $7Jv2m.Spotlights).FindYourLook,
        actionsBeforeElement: `${currentStepCount}/${totalStepCount}`,
        actions: spotlightActions,
        headingAfterElement: spotlightHeadingAfterElement
    })), step === 'flag' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ls9eE.FinishFlag), {
        onDismiss: next,
        openInProductHelp: openInProductHelp
    }));
};

});
parcelRegister("j2AVF", function(module, exports) {
module.exports = new URL("benefits-banner.3db808f6.png", import.meta.url).toString();

});

parcelRegister("cDwYm", function(module, exports) {
module.exports = new URL("onboarding.d344422b.gif", import.meta.url).toString();

});

parcelRegister("ls9eE", function(module, exports) {

$parcel$export(module.exports, "FinishFlag", () => $36d620df711ba339$export$35e948d10c687c6d);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $d6f6c = parcelRequire("d6f6c");

var $cNjuW = parcelRequire("cNjuW");

var $cMeyZ = parcelRequire("cMeyZ");
const $36d620df711ba339$export$35e948d10c687c6d = ({ onDismiss: onDismiss, openInProductHelp: openInProductHelp })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "flag",
        action: "viewed",
        actionSubjectId: "finishedAdvancedRoadmapsOnboarding"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cNjuW.Flag), {
        isAutoDismissed: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            label: "",
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G400})`
        }),
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cMeyZ.messages).flagTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cMeyZ.messages).plansFlagContent),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cMeyZ.messages).flagClose),
                onClick: onDismiss
            },
            ...(0, $1ybV0.ff)('in-product-help-for-plans_qwds9') && openInProductHelp ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cMeyZ.messages).flagViewDocumentation),
                    onClick: ()=>openInProductHelp('')
                }
            ] : [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cMeyZ.messages).flagViewDocumentation),
                    href: 'https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/'
                }
            ]
        ]
    }));

});
parcelRegister("cMeyZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6cf41230c6829078$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6cf41230c6829078$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-title",
        "defaultMessage": "Happy planning!"
    },
    plansFlagContent: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.plans-flag-content",
        "defaultMessage": "For more information on how to get started with Plans, check out our latest documentation."
    },
    flagClose: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-close",
        "defaultMessage": "Close"
    },
    flagViewDocumentation: {
        "id": "portfolio-3-onboarding.onboarding.flag-finish.flag-view-documentation",
        "defaultMessage": "View documentation"
    }
});

});


parcelRegister("5rV2v", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6d3fc3d98ad0be3e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6d3fc3d98ad0be3e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    spotlightCloseLabel: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-close-label",
        "defaultMessage": "Close"
    },
    modalHeadingPlansSpork: {
        "id": "portfolio-3-onboarding.onboarding.modal-heading-plans-spork",
        "defaultMessage": "Welcome to Plans"
    },
    modalContentParagraphPlansSpork: {
        "id": "portfolio-3-onboarding.onboarding.modal-content-paragraph-plans-spork",
        "defaultMessage": "Track dependencies from multiple teams, monitor team's capacity, and view the status of work in real time so you can see everything happening across Jira."
    },
    modalGetStarted: {
        "id": "portfolio-3-onboarding.onboarding.modal-get-started",
        "defaultMessage": "Get started"
    },
    modalTakeTour: {
        "id": "portfolio-3-onboarding.onboarding.modal-take-tour",
        "defaultMessage": "Take tour"
    },
    modalSkipTour: {
        "id": "portfolio-3-onboarding.onboarding.modal-skip-tour",
        "defaultMessage": "Skip tour"
    },
    modalSkip: {
        "id": "portfolio-3-onboarding.onboarding.modal-skip",
        "defaultMessage": "Skip"
    },
    spotlightNext: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-next",
        "defaultMessage": "Next"
    },
    spotlightLearnMore: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-learn-more",
        "defaultMessage": "Learn more"
    }
});

});

parcelRegister("2K6Hv", function(module, exports) {

$parcel$export(module.exports, "FieldsSpotlight", () => $3ae3c1d875c65326$export$638c439f0a00adf1);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1tbnV = parcelRequire("1tbnV");
const $3ae3c1d875c65326$export$638c439f0a00adf1 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: "var(--ds-surface, white)",
        dialogPlacement: "right top",
        heading: formatMessage((0, $1tbnV.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#2.-Fields'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1tbnV.messages).content));
};

});
parcelRegister("1tbnV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c53eaac5805b70b5$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c53eaac5805b70b5$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-fields.title",
        "defaultMessage": "All about the details"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-fields.content",
        "defaultMessage": "Add or remove columns to highlight important planning information like issue dates, team assignments, estimates, and more."
    }
});

});


parcelRegister("gsYdu", function(module, exports) {

$parcel$export(module.exports, "FindYourLookSpotlight", () => $f04b5fdd9d7f0d82$export$854c6a85659497df);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $20zgO = parcelRequire("20zgO");
const $f04b5fdd9d7f0d82$export$854c6a85659497df = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetRadius: 0,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        heading: formatMessage((0, $20zgO.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/change-how-advanced-roadmaps-displays-your-timeline-data/'
        }),
        headingAfterElement: headingAfterElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $20zgO.messages).content));
};

});
parcelRegister("20zgO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $00b74abbc9908078$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $00b74abbc9908078$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.title",
        "defaultMessage": "Find your look"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-find-your-look.content",
        "defaultMessage": "Add a personal touch to your plan by changing how your issues are grouped, sorted or displayed."
    }
});

});


parcelRegister("j1sNH", function(module, exports) {

$parcel$export(module.exports, "HeartOfPlanSpotlight", () => $e4988d62b5c4c652$export$859e382090c26be5);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kYlGY = parcelRequire("kYlGY");
const $e4988d62b5c4c652$export$859e382090c26be5 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: "var(--ds-surface, white)",
        dialogPlacement: "top left",
        heading: formatMessage((0, $kYlGY.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#1.-Issue-column'
        }),
        headingAfterElement: headingAfterElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kYlGY.messages).content));
};

});
parcelRegister("kYlGY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b735751b7cd47fa3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b735751b7cd47fa3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.title",
        "defaultMessage": "The heart of your plan"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-heart-of-plan.content",
        "defaultMessage": "View, create, and schedule tasks, then customize which data fields you want to see in context."
    }
});

});


parcelRegister("ew8RF", function(module, exports) {

$parcel$export(module.exports, "ListModeSpotlight", () => $cf1c6802fbc56734$export$5c026a266f250837);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $49QuG = parcelRequire("49QuG");
const $cf1c6802fbc56734$export$5c026a266f250837 = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        dialogPlacement: "bottom right",
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: ''
        }),
        headingAfterElement: headingAfterElement,
        heading: (0, $1ybV0.ff)('sploverview-onboarding-tour') ? formatMessage((0, $49QuG.messages).heading) : undefined
    }, (0, $1ybV0.ff)('sploverview-onboarding-tour') ? // Needed the div to fix the word break from flex container
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $49QuG.messages).description, {
        b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $49QuG.messages).content));
};

});
parcelRegister("49QuG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5f82f26213180165$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5f82f26213180165$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.heading",
        "defaultMessage": "More room for planning"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.content",
        "defaultMessage": "The List view removes timeline bars and capacity planning boxes from your plan. Add as many columns as you need."
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-list-mode.description",
        "defaultMessage": "Select <b>Timeline</b> to view the timeline bars and capacity information, or choose <b>List</b> to hide them and add as many fields as you want."
    }
});

});


parcelRegister("6nFPe", function(module, exports) {

$parcel$export(module.exports, "SaveYourChangesSpotlight", () => $4c9006a2b43feb82$export$6558b61777516cff);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6roRs = parcelRequire("6roRs");
const $4c9006a2b43feb82$export$6558b61777516cff = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        heading: formatMessage((0, $6roRs.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/save-changes-made-in-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6roRs.messages).content));
};

});
parcelRegister("6roRs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $674b3e9d4056cfcf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $674b3e9d4056cfcf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.title",
        "defaultMessage": "Save your changes"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-save-your-changes.content",
        "defaultMessage": "Your plan is a sandbox environment, meaning the changes you make here aren't committed until you're ready. Use this button to save your changes and get down to work."
    }
});

});


parcelRegister("lHj3G", function(module, exports) {

$parcel$export(module.exports, "ScopeSpotlight", () => $c1395fda67fea56c$export$1764b32609d94063);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $eaLFq = parcelRequire("eaLFq");
const $c1395fda67fea56c$export$1764b32609d94063 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: "var(--ds-surface, white)",
        dialogPlacement: "right top",
        heading: formatMessage((0, $eaLFq.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#1.-Issue-column'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $eaLFq.messages).content));
};

});
parcelRegister("eaLFq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ed8537a14ddadd12$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ed8537a14ddadd12$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-scope.title",
        "defaultMessage": "What's in a plan?"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-scope.content",
        "defaultMessage": "At its core, your plan consists of issues from your projects which show in the Scope column."
    }
});

});


parcelRegister("jJOqx", function(module, exports) {

$parcel$export(module.exports, "ShowAndTellSpotlight", () => $c8221f3c30f8d48f$export$1cbd09eb9384dd3b);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $bSG8t = parcelRequire("bSG8t");
const $c8221f3c30f8d48f$export$1cbd09eb9384dd3b = ({ target: target, actionsBeforeElement: actionsBeforeElement, headingAfterElement: headingAfterElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetRadius: 0,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        heading: (0, $1ybV0.ff)('sploverview-onboarding-tour') ? formatMessage((0, $bSG8t.messages).heading) : formatMessage((0, $bSG8t.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/preconfigured-views-in-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1ybV0.ff)('sploverview-onboarding-tour') ? (0, $bSG8t.messages).description : (0, $bSG8t.messages).content));
};

});
parcelRegister("bSG8t", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a1fbf6e8602322d3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a1fbf6e8602322d3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.title",
        "defaultMessage": "Show and tell"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.content",
        "defaultMessage": "Use filters to only show issues that are relevant to what you're working on. You also can create multiple views of your plan, each with a unique story, and recall them on demand."
    },
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.heading",
        "defaultMessage": "A view to remember"
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-show-and-tell.description",
        "defaultMessage": "Filter issues based on what's relevant to you, then save it to tell a unique story. Make multiple views to curate your plan for different audiences."
    }
});

});


parcelRegister("dPvFo", function(module, exports) {

$parcel$export(module.exports, "TimelineSpotlight", () => $cf1ebeff8bcff585$export$317ca0a8e8606fff);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $9XMk1 = parcelRequire("9XMk1");
const $cf1ebeff8bcff585$export$317ca0a8e8606fff = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetBgColor: "var(--ds-surface, white)",
        dialogPlacement: "left top",
        heading: formatMessage((0, $9XMk1.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-read-my-advanced-roadmaps-plan/#3.-Timeline-bars'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $9XMk1.messages).content));
};

});
parcelRegister("9XMk1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d5bb9a76172e4d56$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d5bb9a76172e4d56$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-timeline.title",
        "defaultMessage": "Your plan, visualized"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-timeline.content",
        "defaultMessage": "Issue data such as dates and dependencies are displayed here, along with releases and other planning data."
    }
});

});


parcelRegister("hfNY2", function(module, exports) {

$parcel$export(module.exports, "ViewsSpotlight", () => $30439a4dee7126ea$export$9ea3305cd20bda43);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $cx9s6 = parcelRequire("cx9s6");
const $30439a4dee7126ea$export$9ea3305cd20bda43 = ({ target: target, actionsBeforeElement: actionsBeforeElement, actions: actions, headingAfterElement: headingAfterElement })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        target: target,
        targetRadius: 0,
        targetBgColor: `var(--ds-surface, ${(0, $PdmhA).N0})`,
        heading: (0, $1ybV0.ff)('sploverview-onboarding-tour') ? formatMessage((0, $cx9s6.messages).heading) : formatMessage((0, $cx9s6.messages).title),
        actionsBeforeElement: actionsBeforeElement,
        actions: actions({
            learnMoreURL: 'https://support.atlassian.com/jira-software-cloud/docs/how-do-i-navigate-advanced-roadmaps/'
        }),
        headingAfterElement: headingAfterElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $1ybV0.ff)('sploverview-onboarding-tour') ? (0, $cx9s6.messages).description : (0, $cx9s6.messages).content));
};

});
parcelRegister("cx9s6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1d12927fe4f51b16$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1d12927fe4f51b16$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.title",
        "defaultMessage": "Views you can use"
    },
    content: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.content",
        "defaultMessage": "Issues are just one part of your plan. Use this menu to view releases and teams included in your plan, plus other layers of information."
    },
    heading: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.heading",
        "defaultMessage": "Views for different needs"
    },
    description: {
        "id": "portfolio-3-onboarding.onboarding.spotlight-views.description",
        "defaultMessage": "Each page shows you a different aspect of your plan so you can quickly find the information you need."
    }
});

});


parcelRegister("7p7t4", function(module, exports) {

$parcel$export(module.exports, "useStep", () => $f3908acd0569b27f$export$7896576cb7635832);
$parcel$export(module.exports, "useController", () => $f3908acd0569b27f$export$e8c786024a2b0a79);
$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $f3908acd0569b27f$export$5d06510124eb14f8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $79xbN = parcelRequire("79xbN");

var $6zEnX = parcelRequire("6zEnX");
const $f3908acd0569b27f$export$7896576cb7635832 = ()=>{
    const [step, setStep] = (0, $eUqFw.useState)('inactive');
    const start = (0, $eUqFw.useCallback)(()=>setStep('modal'), []);
    const finish = (0, $eUqFw.useCallback)(()=>setStep('finished'), []);
    const skipToFlag = (0, $eUqFw.useCallback)(()=>setStep('flag'), []);
    const next = (0, $eUqFw.useCallback)(()=>setStep((current)=>{
            switch(current){
                case 'modal':
                    return 'spotlight';
                case 'spotlight':
                    return 'flag';
                case 'flag':
                default:
                    return 'finished';
            }
        }), []);
    return [
        step,
        {
            next: next,
            start: start,
            finish: finish,
            skip: skipToFlag
        }
    ];
};
const $f3908acd0569b27f$var$useStoreController = ()=>{
    const [{ visible: visible }, { initOnboarding: initOnboarding, closeOnboarding: closeOnboarding }] = (0, $6zEnX.useOnboardingTour)();
    return [
        {
            visible: visible
        },
        {
            init: initOnboarding,
            close: closeOnboarding
        }
    ];
};
const $f3908acd0569b27f$var$usePropsController = (props)=>{
    if (!('visible' in props)) return undefined;
    const { visible: visible, onClose: onClose } = props;
    return [
        {
            visible: visible
        },
        {
            init: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            close: onClose
        }
    ];
};
const $f3908acd0569b27f$export$e8c786024a2b0a79 = (props)=>{
    const storeController = $f3908acd0569b27f$var$useStoreController();
    const propsController = $f3908acd0569b27f$var$usePropsController(props);
    return propsController ?? storeController;
};
const $f3908acd0569b27f$export$5d06510124eb14f8 = ()=>(0, $79xbN.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');

});


parcelRegister("2KLen", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce19958d4ee04f6$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $P0OMJ = parcelRequire("P0OMJ");

var $aaap2 = parcelRequire("aaap2");
var $6ce19958d4ee04f6$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $P0OMJ.mapStateToProps), {})((0, $aaap2.CtpOnboardingPlanDataSubscriber));

});
parcelRegister("P0OMJ", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $0c1d5ffea1774de1$export$c31df4bd766f9c35);

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");
const $0c1d5ffea1774de1$export$c31df4bd766f9c35 = (state)=>({
        planId: (0, $75KhQ.getPlan)(state).id,
        projects: (0, $ehEr2.getProjects)(state),
        issueSources: (0, $75KhQ.getIssueSources)(state)
    });

});

parcelRegister("aaap2", function(module, exports) {

$parcel$export(module.exports, "CtpOnboardingPlanDataSubscriber", () => $7c984861899f20a6$export$84a36631e8c01e82);

var $eUqFw = parcelRequire("eUqFw");
const $7c984861899f20a6$export$84a36631e8c01e82 = ({ children: children, planId: planId, issueSources: issueSources, projects: projects })=>{
    const transformedIssueSources = (0, $eUqFw.useMemo)(()=>issueSources?.map(({ id: id, value: value, title: title })=>({
                id: id,
                value: value,
                title: title
            })), [
        issueSources
    ]);
    const childrenProps = {
        planId: planId,
        projectKey: projects?.[0]?.key,
        issueSources: transformedIssueSources
    };
    return children(childrenProps);
};

});


parcelRegister("dgSCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $258cd59173d394f4$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $28LCZ = parcelRequire("28LCZ");

var $fOs8K = parcelRequire("fOs8K");

var $40hfJ = parcelRequire("40hfJ");
var $258cd59173d394f4$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $fOs8K.mapStateToProps), (0, $28LCZ.mapDispatchToProps))((0, $40hfJ.CttOnboardingPlanDataSubscriber));

});
parcelRegister("28LCZ", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToProps", () => $2efbf86dd3ea7458$export$9e6a17cf56877796);

var $296Gg = parcelRequire("296Gg");
parcelRequire("fk2gn");
var $dr4qD = parcelRequire("dr4qD");
var $fk2gn = parcelRequire("fk2gn");

var $1XIAV = parcelRequire("1XIAV");
parcelRequire("6auew");
var $l1dWb = parcelRequire("l1dWb");

var $boQGP = parcelRequire("boQGP");


var $5rYNM = parcelRequire("5rYNM");
const $2efbf86dd3ea7458$export$9e6a17cf56877796 = (dispatch)=>({
        startInlineCreate: (payload)=>{
            dispatch((0, $fk2gn.startInlineCreate)(payload));
        },
        clearInlineCreate: ()=>{
            dispatch((0, $dr4qD.clearInlineCreate)());
        },
        setIssueTypeIdForHierarchy: (hierarchyLevel, issueTypeId)=>{
            dispatch((0, $dr4qD.setIssueTypeIdForHierarchy)(hierarchyLevel, issueTypeId));
        },
        setGlobalCreateIssue: ()=>{
            dispatch((0, $dr4qD.setGlobalCreateIssue)(true));
        },
        setDefaultProject: (projectId)=>dispatch((0, $boQGP.setDefaultProject)({
                projectId: projectId
            })),
        expandScopeInHierarchy: ()=>dispatch((0, $1XIAV.toggleExpansionInHierarchy)({
                isExpanded: true
            })),
        setGroupNone: ()=>{
            dispatch((0, $l1dWb.changeGroup)({
                grouping: (0, $5rYNM.GROUPING).NONE
            }));
        },
        setHierarchyLevels: (payload)=>{
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$9ca65f4dca18a9fc),
                value: payload
            }));
            dispatch((0, $296Gg.change)({
                id: (0, $12ee831723ccf9c2$export$c4a2a48e7b94aaa5),
                value: {
                    start: payload.start - 1,
                    end: payload.end - 1
                }
            }));
        }
    });

});

parcelRegister("fOs8K", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $4b688741a6f01d41$export$c31df4bd766f9c35);

var $5iWql = parcelRequire("5iWql");

var $8YqJS = parcelRequire("8YqJS");

var $fZW8G = parcelRequire("fZW8G");

var $cwMfk = parcelRequire("cwMfk");

var $lihml = parcelRequire("lihml");

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");

var $ehEr2 = parcelRequire("ehEr2");

var $kyGCj = parcelRequire("kyGCj");

var $1TrR5 = parcelRequire("1TrR5");
const $4b688741a6f01d41$var$mapStateToPropsOld = (state)=>{
    const { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy } = (0, $cwMfk.getInlineCreateState)(state);
    return {
        planId: (0, $75KhQ.getPlan)(state).id,
        typeToLevel: (0, $fZW8G.getTypeToLevel)(state),
        projects: (0, $ehEr2.getProjects)(state),
        issueTypeId: issueTypeId,
        IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
        defaultProjectId: (0, $ehEr2.getDefaultProjectId)(state),
        enrichedHierarchyLevels: (0, $fZW8G.getEnrichedHierarchyLevels)(state),
        visualisationGrouping: (0, $kyGCj.getVisualisationGrouping)(state),
        initativeLevelIssues: (0, $kwMvv.getIssuesByLevel)(state, (0, $8YqJS.INITIATIVE_LEVEL)),
        epicLevelIssues: (0, $kwMvv.getIssuesByLevel)(state, (0, $8YqJS.EPIC_LEVEL)),
        hierarchyRange: (0, $fZW8G.getHierarchyRange)(state),
        tmpIssueTypeIds: (0, $lihml.getTeamManagedProjectByIssueTypeId)(state)
    };
};
const $4b688741a6f01d41$var$mapStateToPropsFactory = ()=>{
    const initativeLevelIssuesFactory = (0, $5iWql.default)((state)=>(0, $kwMvv.getIssuesByLevel)(state, (0, $8YqJS.INITIATIVE_LEVEL)));
    const epicLevelIssuesFactory = (0, $5iWql.default)((state)=>(0, $kwMvv.getIssuesByLevel)(state, (0, $8YqJS.EPIC_LEVEL)));
    return (state)=>{
        const { issueTypeId: issueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy } = (0, $cwMfk.getInlineCreateState)(state);
        return {
            planId: (0, $75KhQ.getPlan)(state).id,
            typeToLevel: (0, $fZW8G.getTypeToLevel)(state),
            projects: (0, $ehEr2.getProjects)(state),
            issueTypeId: issueTypeId,
            IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
            defaultProjectId: (0, $ehEr2.getDefaultProjectId)(state),
            enrichedHierarchyLevels: (0, $fZW8G.getEnrichedHierarchyLevels)(state),
            visualisationGrouping: (0, $kyGCj.getVisualisationGrouping)(state),
            initativeLevelIssues: initativeLevelIssuesFactory(state),
            epicLevelIssues: epicLevelIssuesFactory(state),
            hierarchyRange: (0, $fZW8G.getHierarchyRange)(state),
            tmpIssueTypeIds: (0, $lihml.getTeamManagedProjectByIssueTypeId)(state)
        };
    };
};
const $4b688741a6f01d41$export$c31df4bd766f9c35 = (0, $1TrR5.functionWithFFRedux)($4b688741a6f01d41$var$mapStateToPropsFactory, $4b688741a6f01d41$var$mapStateToPropsOld);

});

parcelRegister("40hfJ", function(module, exports) {

$parcel$export(module.exports, "CttOnboardingPlanDataSubscriber", () => $197fe0f11d301d57$export$b2e6aed609425fc7);

var $eUqFw = parcelRequire("eUqFw");

var $8i1R8 = parcelRequire("8i1R8");

var $i0RGP = parcelRequire("i0RGP");
var $dspDs = parcelRequire("dspDs");
var $h3f0m = parcelRequire("h3f0m");

var $8YqJS = parcelRequire("8YqJS");

var $jDE3A = parcelRequire("jDE3A");

var $57dZR = parcelRequire("57dZR");

var $3upRO = parcelRequire("3upRO");

var $7CnHa = parcelRequire("7CnHa");

var $5rYNM = parcelRequire("5rYNM");
const $197fe0f11d301d57$export$b2e6aed609425fc7 = ({ children: children, planId: planId, setIssueTypeIdForHierarchy: setIssueTypeIdForHierarchy, setGlobalCreateIssue: setGlobalCreateIssue, enrichedHierarchyLevels: enrichedHierarchyLevels, projects: projects, startInlineCreate: startInlineCreate, setDefaultProject: setDefaultProject, defaultProjectId: defaultProjectId, typeToLevel: typeToLevel, issueTypeId: currentIssueTypeId, IssueTypeIdForHierarchy: IssueTypeIdForHierarchy, setGroupNone: setGroupNone, setHierarchyLevels: setHierarchyLevels, expandScopeInHierarchy: expandScopeInHierarchy, visualisationGrouping: visualisationGrouping, hierarchyRange: hierarchyRange, initativeLevelIssues: initativeLevelIssues, epicLevelIssues: epicLevelIssues, clearInlineCreate: clearInlineCreate, tmpIssueTypeIds: tmpIssueTypeIds })=>{
    const redirectToSpaPlanPage = (0, $3upRO.useRedirectToSpaPlanPage)();
    const handleCreate = (0, $eUqFw.useCallback)((hierarchyLevel, project)=>{
        const issueTypeId = (0, $57dZR.getInlineCreateIssueTypeId)(hierarchyLevel, project, {
            issueTypeId: currentIssueTypeId,
            IssueTypeIdForHierarchy: IssueTypeIdForHierarchy,
            typeToLevel: typeToLevel
        });
        setIssueTypeIdForHierarchy(hierarchyLevel, issueTypeId);
        setGlobalCreateIssue();
        const getProjectsForCurrentIssueTypeLevel = (level)=>{
            const enrichedLevel = $i0RGP.default($h3f0m.default('level', level), enrichedHierarchyLevels);
            const orderedIssueTypes = enrichedLevel ? enrichedLevel.issueTypes : [];
            const currentLevelIssueTypes = orderedIssueTypes.map(({ id: id })=>id);
            return projects.filter(// eslint-disable-next-line @typescript-eslint/no-shadow
            (project)=>$dspDs.default(project.issueTypeIds, currentLevelIssueTypes).length > 0);
        };
        const projectsForCurrentIssueTypeLevel = getProjectsForCurrentIssueTypeLevel(hierarchyLevel);
        if (projectsForCurrentIssueTypeLevel.length === 1) setDefaultProject(project.id);
        startInlineCreate({
            parentId: null,
            siblingId: null,
            hierarchyLevel: hierarchyLevel,
            issueTypeId: issueTypeId,
            projectId: project.id,
            source: 'HEADER'
        });
    }, [
        IssueTypeIdForHierarchy,
        currentIssueTypeId,
        enrichedHierarchyLevels,
        projects,
        setDefaultProject,
        setGlobalCreateIssue,
        setIssueTypeIdForHierarchy,
        startInlineCreate,
        typeToLevel
    ]);
    const inlineCreate = (0, $eUqFw.useCallback)(()=>{
        const projectsForLevel = projects.filter((x)=>x.issueTypeIds.some((id)=>typeToLevel(id) === (0, $8YqJS.INITIATIVE_LEVEL)));
        const project = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(projectsForLevel, [
            'id',
            defaultProjectId
        ]) || projectsForLevel[0];
        if (!(0, $7CnHa.isDefined)(project)) throw new Error('No project available for this level of hierarchy. This step should have been skipped.');
        else handleCreate((0, $8YqJS.INITIATIVE_LEVEL), project);
    }, [
        defaultProjectId,
        handleCreate,
        projects,
        typeToLevel
    ]);
    const primeRoadmap = (0, $eUqFw.useCallback)(()=>{
        expandScopeInHierarchy();
        setGroupNone();
        setHierarchyLevels({
            start: hierarchyRange.max,
            end: hierarchyRange.min
        });
    }, [
        expandScopeInHierarchy,
        hierarchyRange,
        setGroupNone,
        setHierarchyLevels
    ]);
    const hasInitiativeLevelConfigured = (0, $eUqFw.useMemo)(()=>enrichedHierarchyLevels.some((hl)=>hl.level === (0, $8YqJS.INITIATIVE_LEVEL)), [
        enrichedHierarchyLevels
    ]);
    const hasEpicLevelConfiguredAndPopulated = (0, $eUqFw.useMemo)(()=>enrichedHierarchyLevels.some((hl)=>hl.level === (0, $8YqJS.EPIC_LEVEL)) && epicLevelIssues.length > 0, [
        enrichedHierarchyLevels,
        epicLevelIssues.length
    ]);
    const hasOnlyTmpEpics = (0, $eUqFw.useMemo)(()=>epicLevelIssues?.every((issue)=>issue.type in tmpIssueTypeIds), [
        epicLevelIssues,
        tmpIssueTypeIds
    ]);
    const hasAnyInitiatives = initativeLevelIssues?.length > 0;
    const hasEpicWithParent = (0, $eUqFw.useMemo)(()=>epicLevelIssues.some((issue)=>issue.parent), [
        epicLevelIssues
    ]);
    const isRoadmapGroupedByNone = visualisationGrouping === (0, $5rYNM.GROUPING).NONE;
    const cttOnboardingVariant = (0, $eUqFw.useMemo)(()=>{
        if (!hasInitiativeLevelConfigured) return (0, $jDE3A.CttOnboardingVariant).NO_INITIATIVE;
        if (!hasEpicLevelConfiguredAndPopulated) return (0, $jDE3A.CttOnboardingVariant).NO_EPIC;
        if (hasOnlyTmpEpics) return (0, $jDE3A.CttOnboardingVariant).TMP_EPIC;
        return (0, $jDE3A.CttOnboardingVariant).EPIC;
    }, [
        hasEpicLevelConfiguredAndPopulated,
        hasInitiativeLevelConfigured,
        hasOnlyTmpEpics
    ]);
    const childrenProps = {
        planId: planId,
        variant: cttOnboardingVariant,
        hasAnyInitiatives: hasAnyInitiatives,
        hasEpicWithParent: hasEpicWithParent,
        isRoadmapGroupedByNone: isRoadmapGroupedByNone,
        setInlineCreate: inlineCreate,
        setClearInlineCreate: clearInlineCreate,
        setRedirectToSpaPlanPage: redirectToSpaPlanPage,
        setPrimeRoadmap: primeRoadmap
    };
    return children(childrenProps);
};

});


parcelRegister("2qwvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $900124b1e65a9120$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $adh7T = parcelRequire("adh7T");

var $jR0Gd = parcelRequire("jR0Gd");
var $900124b1e65a9120$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $adh7T.mapStateToProps), {})((0, $jR0Gd.ShouldShowCtpOnboarding));

});
parcelRegister("adh7T", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $274d23993e04e986$export$c31df4bd766f9c35);

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");
const $274d23993e04e986$export$c31df4bd766f9c35 = (state)=>({
        creatorAccountId: (0, $75KhQ.getPlan)(state).creatorAccountId,
        planType: (0, $75KhQ.getPlan)(state).planType,
        isPlanLoading: (0, $kwMvv.getIsIssuesLoading)(state)
    });

});

parcelRegister("jR0Gd", function(module, exports) {

$parcel$export(module.exports, "ShouldShowCtpOnboarding", () => $89b8f8815cbd7e45$export$84682c9f18795e78);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");
const $89b8f8815cbd7e45$export$84682c9f18795e78 = ({ planType: planType, creatorAccountId: creatorAccountId, isPlanLoading: isPlanLoading, children: children })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const shouldShowCttOnboarding = !isPlanLoading && planType === 'CROSS_TEAM_PLANNING' && creatorAccountId === atlassianAccountId;
    if (isPlanLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(shouldShowCttOnboarding));
};

});


parcelRegister("gUQi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d05cd7315eab16b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $9bZ1z = parcelRequire("9bZ1z");

var $5G3Xt = parcelRequire("5G3Xt");
var $0d05cd7315eab16b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $9bZ1z.mapStateToProps), {})((0, $5G3Xt.ShouldShowCttOnboarding));

});
parcelRegister("9bZ1z", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $9fea5cc44492763e$export$c31df4bd766f9c35);

var $kwMvv = parcelRequire("kwMvv");

var $75KhQ = parcelRequire("75KhQ");
const $9fea5cc44492763e$export$c31df4bd766f9c35 = (state)=>({
        creatorAccountId: (0, $75KhQ.getPlan)(state).creatorAccountId,
        planType: (0, $75KhQ.getPlan)(state).planType,
        isPlanLoading: (0, $kwMvv.getIsIssuesLoading)(state)
    });

});

parcelRegister("5G3Xt", function(module, exports) {

$parcel$export(module.exports, "ShouldShowCttOnboarding", () => $4e95a48aab210c53$export$4c307aee2e9e9261);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");
const $4e95a48aab210c53$export$4c307aee2e9e9261 = ({ planType: planType, creatorAccountId: creatorAccountId, isPlanLoading: isPlanLoading, children: children })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const shouldShowCttOnboarding = !isPlanLoading && planType === 'CROSS_TEAM' && creatorAccountId === atlassianAccountId;
    if (isPlanLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(shouldShowCttOnboarding));
};

});


parcelRegister("2VH0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $48c50bdd248d3e2d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $5MEM6 = parcelRequire("5MEM6");

var $8YhOq = parcelRequire("8YhOq");
var $48c50bdd248d3e2d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((0, $5MEM6.mapStateToProps), {})((0, $8YhOq.UserIsOnboarded));

});
parcelRegister("5MEM6", function(module, exports) {

$parcel$export(module.exports, "mapStateToProps", () => $73da7e5bcae38eae$export$c31df4bd766f9c35);
const $73da7e5bcae38eae$export$c31df4bd766f9c35 = (state)=>({
        userIsOnboarded: state.domain.userIsOnboarded
    });

});

parcelRegister("8YhOq", function(module, exports) {

$parcel$export(module.exports, "UserIsOnboarded", () => $6b1187804e2ec7d5$export$da7b641f0649c8d2);
const $6b1187804e2ec7d5$export$da7b641f0649c8d2 = ({ userIsOnboarded: userIsOnboarded, children: children })=>userIsOnboarded === null ? null : children(userIsOnboarded);

});


parcelRegister("673Wg", function(module, exports) {

$parcel$export(module.exports, "isCrossTeamPlanningTemplateExperimentEnabled", () => $5de2e62dcf5dceb7$export$5d06510124eb14f8);

var $79xbN = parcelRequire("79xbN");
const $5de2e62dcf5dceb7$export$5d06510124eb14f8 = ()=>(0, $79xbN.expValEquals)('second_premium_template_experiment', 'cohort', 'variation');

});


parcelRegister("ligKL", function(module, exports) {

$parcel$export(module.exports, "HeaderBar", () => $c0140745707c54e6$export$c7c21e5b2657e253);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");

var $ehNfb = parcelRequire("ehNfb");

var $hIE3U = parcelRequire("hIE3U");

var $7Jv2m = parcelRequire("7Jv2m");

var $h7T2Y = parcelRequire("h7T2Y");

var $bKdiQ = parcelRequire("bKdiQ");
var $eh10R = parcelRequire("eh10R");

var $jXlMU = parcelRequire("jXlMU");

var $hR1p1 = parcelRequire("hR1p1");

var $2ptMN = parcelRequire("2ptMN");

var $kOCNy = parcelRequire("kOCNy");

var $kbEgN = parcelRequire("kbEgN");

var $5rYNM = parcelRequire("5rYNM");

var $5BnlQ = parcelRequire("5BnlQ");
const $c0140745707c54e6$export$c7c21e5b2657e253 = ()=>{
    const [headerMode, setHeaderMode] = (0, $eUqFw.useState)('visible');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, headerMode !== 'hidden' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0140745707c54e6$var$HeaderContent, null, headerMode !== 'toolbar' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKdiQ.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5BnlQ.default).timeline),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ehNfb.FeedbackButtonLazyComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kOCNy.default), {
            confluenceMacroType: (0, $5rYNM.TIMELINE_SHARE_TYPE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXlMU.default), null, (enabled)=>enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ptMN.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
            name: (0, $hIE3U.CttSpotlights).ReviewChanges
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h7T2Y.SpotlightTarget), {
            name: (0, $7Jv2m.Spotlights).SaveYourChanges
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbEgN.default), null))))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eh10R.default), {
        headerMode: headerMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hR1p1.default), {
        mode: headerMode,
        setMode: setHeaderMode
    }), (0, $1ybV0.ff)('sploverview-onboarding-tour') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Jv2m.OnboardingHeaderModeUpdater), {
        headerMode: headerMode,
        setHeaderMode: setHeaderMode
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0140745707c54e6$var$HeaderContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1ejb _u5f31ejb _1bchidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jXlMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b240daee0511a08$export$2e2bcd8739ae039);

var $75KhQ = parcelRequire("75KhQ");

var $iK4oF = parcelRequire("iK4oF");

var $lNNXV = parcelRequire("lNNXV");

var $apoj5 = parcelRequire("apoj5");
const $4b240daee0511a08$var$mapStateToProps = (0, $iK4oF.createStructuredSelector)({
    isAutoSchedulerEnabled: (0, $75KhQ.getAutoSchedulerEnabled)
});
var $4b240daee0511a08$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($4b240daee0511a08$var$mapStateToProps, {})((0, $apoj5.default));

});
parcelRegister("apoj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd658a4505de594$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $4cd658a4505de594$var$AutoSchedulerSwitch = (props)=>{
    const { children: children, isAutoSchedulerEnabled: isAutoSchedulerEnabled } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(isAutoSchedulerEnabled));
};
var $4cd658a4505de594$export$2e2bcd8739ae039 = $4cd658a4505de594$var$AutoSchedulerSwitch;

});


parcelRegister("hR1p1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc55afa597d63b9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $86Ndv = parcelRequire("86Ndv");

var $5xnoX = parcelRequire("5xnoX");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gwbfD = parcelRequire("gwbfD");

var $lVLLN = parcelRequire("lVLLN");
const $cc55afa597d63b9d$var$ButtonContainer = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$BaseButtonContainer, {
        "data-component-selector": "ButtonContainer",
        ...props
    }, children);
const $cc55afa597d63b9d$var$HeaderToggle = ({ mode: mode, setMode: setMode })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    switch(mode){
        case 'hidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$Bar, {
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$BarSection, {
                key: "Show toolbar",
                justifyContent: "center",
                onClick: ()=>setMode('toolbar'),
                "aria-expanded": false,
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-show",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $lVLLN.default).showRefinementOptions)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: formatMessage((0, $lVLLN.default).showRefinementOptions)
            }))))));
        case 'toolbar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$Bar, {
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$BarSection, {
                key: "Hide toolbar",
                justifyContent: "end",
                onClick: ()=>setMode('hidden'),
                "aria-expanded": true,
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-hide",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $lVLLN.default).hideRefinementOptions)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                label: formatMessage((0, $lVLLN.default).hideRefinementOptions)
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$BarSection, {
                key: "Show header",
                justifyContent: "start",
                onClick: ()=>setMode('visible'),
                "aria-expanded": false,
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-show",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $lVLLN.default).showHeader)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: formatMessage((0, $lVLLN.default).showHeader)
            }))))));
        case 'visible':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$Bar, {
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$BarSection, {
                key: "Hide header",
                justifyContent: "center",
                onClick: ()=>setMode('toolbar'),
                "aria-expanded": true,
                "data-testId": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.bar-section-hide",
                isFixPlanHeaderButtonEnabled: (0, $1ybV0.ff)('jsw.chronos.fix-plan-header-collapse-expand-button')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwbfD.default), {
                content: formatMessage((0, $lVLLN.default).hideHeader)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc55afa597d63b9d$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5xnoX))), {
                label: formatMessage((0, $lVLLN.default).hideHeader)
            }))))));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    }
};
var $cc55afa597d63b9d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cc55afa597d63b9d$var$HeaderToggle;
const $cc55afa597d63b9d$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4utpp _154iutpp _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc55afa597d63b9d$var$BarSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixPlanHeaderButtonEnabled: isFixPlanHeaderButtonEnabled, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_knsc5k": (0, $9t7rW.default)(__cmplp.justifyContent)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4cvr1h6o _11q7glyw _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _16qsglyw _80omtlke _1bahdlq5 _qy8a1id0 _6l561id0 _1v8vojai _12yjojai _1ebu5ynh _yqmw5ynh _16bj1f5i _nfpi1f5i _13hk1qap _1u0rnli6 _v4nb5ynh _cuqb1f5i _7ehiglyw",
            __cmplp.isFixPlanHeaderButtonEnabled ? "_16jlidpf _1o9zkb7n _i0dl1wug" : "_16jlkb7n _1o9zkb7n _i0dl1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc55afa597d63b9d$var$Bar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixPlanHeaderButtonEnabled: isFixPlanHeaderButtonEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _4t3i1tcg _kqswh2mm _1kt9b3bt _1mp41osq _kfgtyh40 _rfx3yh40 _1rushloo _1cs8stnw _qnecidpf _19woidpf _dsq4glyw _154pidpf _pdyk1hrg _gc16idpf _1n361pie _spuikb7n _r3ldkb7n _1wlykb7n _xk06kb7n",
            __cmplp.isFixPlanHeaderButtonEnabled ? "_1pbykb7n" : "_1pby11wp",
            __cmplp.isFixPlanHeaderButtonEnabled ? "_r2ecglyw" : "_r2ecnqa1",
            __cmplp.isFixPlanHeaderButtonEnabled ? "_1046v8b6 _1egjv8b6" : "_10461pie _1egj1pie",
            __cmplp.isFixPlanHeaderButtonEnabled ? "_1scov8b6 _1xznv8b6" : "_1sco1pie _1xzn1pie",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc55afa597d63b9d$var$BaseButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71f5i _2rko1ssb _4t3i1tcg _1bsb1tcg _16qs1b5k _19it178y _v5641fx5 _l8ku1k0e",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lVLLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $285b65cb6f06797c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $285b65cb6f06797c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    hideRefinementOptions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.hide-refinement-options",
        "defaultMessage": "Hide refinement options"
    },
    showRefinementOptions: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.show-refinement-options",
        "defaultMessage": "Show refinement options"
    },
    hideHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.hide-header",
        "defaultMessage": "Hide header"
    },
    showHeader: {
        "id": "portfolio-3-portfolio.app-simple-plans.top.page-header.header-toggle.show-header",
        "defaultMessage": "Show header"
    }
});

});


parcelRegister("5BnlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff27432311c87c64$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ff27432311c87c64$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeline: {
        "id": "spa-apps-advanced-roadmaps-plan.plan-timeline.timeline",
        "defaultMessage": "Timeline"
    }
});

});


parcelRegister("dLW5r", function(module, exports) {

$parcel$export(module.exports, "RoadmapContainer", () => $7cee0fb969fa59b4$export$22bc6298226e6809);
$parcel$export(module.exports, "HeaderContainer", () => $7cee0fb969fa59b4$export$1e86fd0e1db89578);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7cee0fb969fa59b4$export$22bc6298226e6809 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3doi319 _1kl7i319 _13li1y44 _kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _18u01jfw",
            __cmplp.className
        ])
    });
});
const $7cee0fb969fa59b4$export$1e86fd0e1db89578 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _2lx21bp4 _19bv1jfw",
            __cmplp.className
        ])
    });
});

});



//# sourceMappingURL=async-plan-timeline.76747216.js.map
